
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8TgEi", function(module, exports) {
module.exports = function navigation(app) {
    app.ports.refresh && app.ports.refresh.subscribe(function() {
        window.location.reload(true);
    });
    app.ports.redirectAndRefresh && app.ports.redirectAndRefresh.subscribe(function(url) {
        setTimeout(function() {
            window.location.replace(url);
        }, 0);
    });
};

});

parcelRegister("bvPu1", function(module, exports) {
module.exports = function(app) {
    if (window.nomalab.intercom) {
        // Load intercom snippet
        (function() {
            var w = window;
            var ic = w.Intercom;
            if (typeof ic === "function") {
                ic('reattach_activator');
                ic('update', w.intercomSettings);
            } else {
                var d = document;
                var i = function() {
                    i.c(arguments);
                };
                i.q = [];
                i.c = function(args) {
                    i.q.push(args);
                };
                w.Intercom = i;
                var l = function() {
                    var s = d.createElement('script');
                    s.type = 'text/javascript';
                    s.async = true;
                    s.src = 'https://widget.intercom.io/widget/' + window.nomalab.intercom.id;
                    var x = d.getElementsByTagName('script')[0];
                    x.parentNode.insertBefore(s, x);
                };
                if (document.readyState === 'complete') l();
                else if (w.attachEvent) w.attachEvent('onload', l);
                else w.addEventListener('load', l, false);
            }
        })();
        window.Intercom("boot", {
            api_base: "https://api-iam.intercom.io",
            app_id: window.nomalab.intercom.id,
            name: window.nomalab.user?.name || "",
            email: window.nomalab.user?.email,
            alignment: "left"
        });
    }
    if (window.nomalab.sentry) {
        var sentryTag = document.createElement('script');
        sentryTag.crossOrigin = "anonymous";
        sentryTag.src = "https://browser.sentry-cdn.com/5.27.6/bundle.tracing.min.js";
        sentryTag.integrity = "sha384-9Z8PxByVWP+gIm/rTMPn9BWwknuJR5oJcLj+Nr9mvzk8nJVkVXgQvlLGZ9SIFEJF";
        sentryTag.addEventListener('load', function() {
            Sentry.init({
                dsn: window.nomalab.sentry.url,
                release: 'dev',
                environment: window.nomalab.environment || 'prod',
                integrations: [
                    new Sentry.Integrations.BrowserTracing()
                ],
                tracesSampleRate: 0.2
            });
            if (window.nomalab.user && window.nomalab.user.email) Sentry.setUser({
                email: window.nomalab.user.email
            });
        });
        document.body.appendChild(sentryTag);
    }
    app.ports.openIntercom && app.ports.openIntercom.subscribe(function(toggle) {
        if (toggle) Intercom && Intercom('show');
        else Intercom && Intercom('hide');
    });
};

});

parcelRegister("hjsOJ", function(module, exports) {
module.exports = function(app) {
    app.ports.gotoSSO && app.ports.gotoSSO.subscribe(async function(ssoUrl) {
        window.location = ssoUrl;
    });
};

});

parcelRegister("iHeIR", function(module, exports) {
module.exports = function routing(app, portName) {
    // Manually handle the push history state
    // mostly to allow ctrl/cmd + click to open in new tab
    document.body.addEventListener('click', function(e) {
        // ignore click + meta or ctrl for new tabs
        if (e.ctrlKey || e.metaKey) return true;
        // lookup for an <a[href]>
        var element = e.target;
        while(!element.href){
            if (!element.parentNode) return true;
            element = element.parentNode;
        }
        var href = element.getAttribute('href');
        // ignore links for <a[data-prevent-history]>
        if (element.getAttribute('data-prevent-history')) return true;
        // ignore external links and anchors
        if (/^https?:\/\//.test(href) || href.slice(0, 1) === '#') return true;
        // ignore mailto links or tel
        if (href.slice(0, 7) === 'mailto:' || href.slice(0, 4) === 'tel:') return true;
        // let's do the magic
        e.preventDefault();
        try {
            app.ports.newurl.send(href);
        } catch (e) {
            console.error(e);
        }
        history.pushState(null, null, href);
        return false;
    }, true);
    window.addEventListener('popstate', function() {
        app.ports.newurl.send(window.location.pathname + window.location.search);
    });
    app.ports[portName].subscribe(function(href) {
        try {
            app.ports.newurl.send(href);
        } catch (e) {
            console.error(e);
        }
        history.pushState(null, null, href);
    });
};

});

parcelRegister("8oUNT", function(module, exports) {
function $61dca0a9cfd068cc$var$hoursToOffset(hours) {
    const sign = hours >= 0 ? "+" : "-";
    const absHours = Math.abs(hours);
    const pad = (num)=>num.toString().padStart(2, "0");
    return `${sign}${pad(absHours)}:00`;
}
Object.defineProperty(Event.prototype, "timezone", {
    get () {
        const offset = -(new Date().getTimezoneOffset() / 60);
        return this.target.value + $61dca0a9cfd068cc$var$hoursToOffset(offset);
    }
});
/*
 * <time-zone />
 * Gives a string representation of the navigator's timezone like "europe/paris".
 */ class $61dca0a9cfd068cc$var$TimeZone extends HTMLElement {
    constructor(){
        super();
        const timeZone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
        this.attachShadow({
            mode: "open"
        });
        this.shadowRoot.innerHTML = timeZone;
    }
}
customElements.define("time-zone", $61dca0a9cfd068cc$var$TimeZone);

});

parcelRegister("3mVol", function(module, exports) {

var $203nN = parcelRequire("203nN");
var $aT4Ql = parcelRequire("aT4Ql");

var $armoC = parcelRequire("armoC");
var $273ff1f51366ad7c$var$localeFns = {
    locale: $armoC.default
};
/*
 * <format-time datetime="2020-06-04T12:27:06.222Z">
 */ class $273ff1f51366ad7c$var$FormatTime extends HTMLElement {
    constructor(){
        super();
        this.useRelativeDate = false;
    }
    connectedCallback() {
        this.render();
        this.onclick = function() {
            this.useRelativeDate = !this.useRelativeDate;
            this.render();
        };
    }
    render() {
        var x = new Date(this.getAttribute('datetime'));
        this.innerHTML = this.useRelativeDate ? $aT4Ql.default(x, new Date(), $273ff1f51366ad7c$var$localeFns) : $203nN.default(x, 'PP, p', $273ff1f51366ad7c$var$localeFns);
    }
}
customElements.define('format-time', $273ff1f51366ad7c$var$FormatTime);

});
parcelRegister("203nN", function(module, exports) {

$parcel$export(module.exports, "default", () => $174e34a109ac4685$export$2e2bcd8739ae039);

var $89kHF = parcelRequire("89kHF");

var $jLc1d = parcelRequire("jLc1d");

var $6LSiz = parcelRequire("6LSiz");

var $iL0o9 = parcelRequire("iL0o9");

var $fpRsA = parcelRequire("fpRsA");

var $2ytfe = parcelRequire("2ytfe");

var $4qJLD = parcelRequire("4qJLD");

var $gHgks = parcelRequire("gHgks");

var $9CgcO = parcelRequire("9CgcO");

var $bGiaL = parcelRequire("bGiaL");

var $8idmG = parcelRequire("8idmG");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $174e34a109ac4685$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $174e34a109ac4685$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $174e34a109ac4685$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $174e34a109ac4685$var$doubleQuoteRegExp = /''/g;
var $174e34a109ac4685$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $174e34a109ac4685$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $9CgcO.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $bGiaL.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $8idmG.default);
    var firstWeekContainsDate = (0, $gHgks.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $gHgks.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $6LSiz.default)(dirtyDate);
    if (!(0, $89kHF.default)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $2ytfe.default)(originalDate);
    var utcDate = (0, $jLc1d.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($174e34a109ac4685$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $fpRsA.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($174e34a109ac4685$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $174e34a109ac4685$var$cleanEscapedString(substring);
        var formatter = (0, $iL0o9.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $4qJLD.isProtectedWeekYearToken)(substring)) (0, $4qJLD.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $4qJLD.isProtectedDayOfYearToken)(substring)) (0, $4qJLD.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($174e34a109ac4685$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $174e34a109ac4685$var$cleanEscapedString(input) {
    var matched = input.match($174e34a109ac4685$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($174e34a109ac4685$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("89kHF", function(module, exports) {

$parcel$export(module.exports, "default", () => $5eef393d91872c56$export$2e2bcd8739ae039);

var $etYxp = parcelRequire("etYxp");

var $6LSiz = parcelRequire("6LSiz");

var $9CgcO = parcelRequire("9CgcO");
function $5eef393d91872c56$export$2e2bcd8739ae039(dirtyDate) {
    (0, $9CgcO.default)(1, arguments);
    if (!(0, $etYxp.default)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $6LSiz.default)(dirtyDate);
    return !isNaN(Number(date));
}

});
parcelRegister("etYxp", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8b2bbadfee029f4$export$2e2bcd8739ae039);

var $dE0Ic = parcelRequire("dE0Ic");

var $9CgcO = parcelRequire("9CgcO");
function $a8b2bbadfee029f4$export$2e2bcd8739ae039(value) {
    (0, $9CgcO.default)(1, arguments);
    return value instanceof Date || (0, $dE0Ic.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

});
parcelRegister("dE0Ic", function(module, exports) {

$parcel$export(module.exports, "default", () => $9eef90229acab198$export$2e2bcd8739ae039);
function $9eef90229acab198$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $9eef90229acab198$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9eef90229acab198$export$2e2bcd8739ae039(o);
}

});

parcelRegister("9CgcO", function(module, exports) {

$parcel$export(module.exports, "default", () => $70043bc780e32c25$export$2e2bcd8739ae039);
function $70043bc780e32c25$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

});


parcelRegister("6LSiz", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ee14069b769b146$export$2e2bcd8739ae039);

var $dE0Ic = parcelRequire("dE0Ic");

var $9CgcO = parcelRequire("9CgcO");
function $4ee14069b769b146$export$2e2bcd8739ae039(argument) {
    (0, $9CgcO.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $dE0Ic.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});


parcelRegister("jLc1d", function(module, exports) {

$parcel$export(module.exports, "default", () => $e62bbac424410a64$export$2e2bcd8739ae039);

var $foWD3 = parcelRequire("foWD3");

var $9CgcO = parcelRequire("9CgcO");

var $gHgks = parcelRequire("gHgks");
function $e62bbac424410a64$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $9CgcO.default)(2, arguments);
    var amount = (0, $gHgks.default)(dirtyAmount);
    return (0, $foWD3.default)(dirtyDate, -amount);
}

});
parcelRegister("foWD3", function(module, exports) {

$parcel$export(module.exports, "default", () => $b366935f61c29473$export$2e2bcd8739ae039);

var $gHgks = parcelRequire("gHgks");

var $6LSiz = parcelRequire("6LSiz");

var $9CgcO = parcelRequire("9CgcO");
function $b366935f61c29473$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $9CgcO.default)(2, arguments);
    var timestamp = (0, $6LSiz.default)(dirtyDate).getTime();
    var amount = (0, $gHgks.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

});
parcelRegister("gHgks", function(module, exports) {

$parcel$export(module.exports, "default", () => $c27d5417d9ceaeb4$export$2e2bcd8739ae039);
function $c27d5417d9ceaeb4$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});



parcelRegister("iL0o9", function(module, exports) {

$parcel$export(module.exports, "default", () => $da7ceaf3f6767786$export$2e2bcd8739ae039);

var $iOv1C = parcelRequire("iOv1C");

var $4UNVG = parcelRequire("4UNVG");

var $dfIbz = parcelRequire("dfIbz");

var $gmi7p = parcelRequire("gmi7p");

var $7i20C = parcelRequire("7i20C");

var $fjP2F = parcelRequire("fjP2F");

var $gzukL = parcelRequire("gzukL");
var $da7ceaf3f6767786$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $da7ceaf3f6767786$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $gzukL.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $7i20C.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $fjP2F.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, $fjP2F.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $dfIbz.default)(date);
        // Padding
        return (0, $fjP2F.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $fjP2F.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $fjP2F.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $fjP2F.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $gzukL.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $fjP2F.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $gmi7p.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $fjP2F.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $4UNVG.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $fjP2F.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $gzukL.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $iOv1C.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $fjP2F.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $fjP2F.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $fjP2F.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $fjP2F.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $da7ceaf3f6767786$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $da7ceaf3f6767786$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $da7ceaf3f6767786$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $da7ceaf3f6767786$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $da7ceaf3f6767786$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $da7ceaf3f6767786$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $gzukL.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $gzukL.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $fjP2F.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $fjP2F.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $gzukL.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $gzukL.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $gzukL.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $da7ceaf3f6767786$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $da7ceaf3f6767786$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $da7ceaf3f6767786$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $da7ceaf3f6767786$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $da7ceaf3f6767786$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $da7ceaf3f6767786$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $da7ceaf3f6767786$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $da7ceaf3f6767786$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $da7ceaf3f6767786$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $da7ceaf3f6767786$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $fjP2F.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $fjP2F.default)(timestamp, token.length);
    }
};
function $da7ceaf3f6767786$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $fjP2F.default)(minutes, 2);
}
function $da7ceaf3f6767786$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $fjP2F.default)(Math.abs(offset) / 60, 2);
    }
    return $da7ceaf3f6767786$var$formatTimezone(offset, dirtyDelimiter);
}
function $da7ceaf3f6767786$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $fjP2F.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $fjP2F.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $da7ceaf3f6767786$export$2e2bcd8739ae039 = $da7ceaf3f6767786$var$formatters;

});
parcelRegister("iOv1C", function(module, exports) {

$parcel$export(module.exports, "default", () => $db24f677adcc8be7$export$2e2bcd8739ae039);

var $6LSiz = parcelRequire("6LSiz");

var $9CgcO = parcelRequire("9CgcO");
var $db24f677adcc8be7$var$MILLISECONDS_IN_DAY = 86400000;
function $db24f677adcc8be7$export$2e2bcd8739ae039(dirtyDate) {
    (0, $9CgcO.default)(1, arguments);
    var date = (0, $6LSiz.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $db24f677adcc8be7$var$MILLISECONDS_IN_DAY) + 1;
}

});

parcelRegister("4UNVG", function(module, exports) {

$parcel$export(module.exports, "default", () => $39431f4ed56ab011$export$2e2bcd8739ae039);

var $6LSiz = parcelRequire("6LSiz");

var $5oCKc = parcelRequire("5oCKc");

var $iiaSs = parcelRequire("iiaSs");

var $9CgcO = parcelRequire("9CgcO");
var $39431f4ed56ab011$var$MILLISECONDS_IN_WEEK = 604800000;
function $39431f4ed56ab011$export$2e2bcd8739ae039(dirtyDate) {
    (0, $9CgcO.default)(1, arguments);
    var date = (0, $6LSiz.default)(dirtyDate);
    var diff = (0, $5oCKc.default)(date).getTime() - (0, $iiaSs.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $39431f4ed56ab011$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("5oCKc", function(module, exports) {

$parcel$export(module.exports, "default", () => $3edd3f6b1880a7df$export$2e2bcd8739ae039);

var $6LSiz = parcelRequire("6LSiz");

var $9CgcO = parcelRequire("9CgcO");
function $3edd3f6b1880a7df$export$2e2bcd8739ae039(dirtyDate) {
    (0, $9CgcO.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $6LSiz.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("iiaSs", function(module, exports) {

$parcel$export(module.exports, "default", () => $d512586fed99fcf4$export$2e2bcd8739ae039);

var $dfIbz = parcelRequire("dfIbz");

var $5oCKc = parcelRequire("5oCKc");

var $9CgcO = parcelRequire("9CgcO");
function $d512586fed99fcf4$export$2e2bcd8739ae039(dirtyDate) {
    (0, $9CgcO.default)(1, arguments);
    var year = (0, $dfIbz.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $5oCKc.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("dfIbz", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a5ef3661dea9318$export$2e2bcd8739ae039);

var $6LSiz = parcelRequire("6LSiz");

var $9CgcO = parcelRequire("9CgcO");

var $5oCKc = parcelRequire("5oCKc");
function $9a5ef3661dea9318$export$2e2bcd8739ae039(dirtyDate) {
    (0, $9CgcO.default)(1, arguments);
    var date = (0, $6LSiz.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $5oCKc.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $5oCKc.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("gmi7p", function(module, exports) {

$parcel$export(module.exports, "default", () => $be8cc15968860a81$export$2e2bcd8739ae039);

var $6LSiz = parcelRequire("6LSiz");

var $jZirl = parcelRequire("jZirl");

var $3btZY = parcelRequire("3btZY");

var $9CgcO = parcelRequire("9CgcO");
var $be8cc15968860a81$var$MILLISECONDS_IN_WEEK = 604800000;
function $be8cc15968860a81$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $9CgcO.default)(1, arguments);
    var date = (0, $6LSiz.default)(dirtyDate);
    var diff = (0, $jZirl.default)(date, options).getTime() - (0, $3btZY.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $be8cc15968860a81$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("jZirl", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8d204a3c18e1e82$export$2e2bcd8739ae039);

var $6LSiz = parcelRequire("6LSiz");

var $9CgcO = parcelRequire("9CgcO");

var $gHgks = parcelRequire("gHgks");

var $bGiaL = parcelRequire("bGiaL");
function $e8d204a3c18e1e82$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $9CgcO.default)(1, arguments);
    var defaultOptions = (0, $bGiaL.getDefaultOptions)();
    var weekStartsOn = (0, $gHgks.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $6LSiz.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});
parcelRegister("bGiaL", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", () => $8811b6a27a6ec831$export$430a3269e24b912e);
var $8811b6a27a6ec831$var$defaultOptions = {};
function $8811b6a27a6ec831$export$430a3269e24b912e() {
    return $8811b6a27a6ec831$var$defaultOptions;
}
function $8811b6a27a6ec831$export$95365be1b0704abc(newOptions) {
    $8811b6a27a6ec831$var$defaultOptions = newOptions;
}

});


parcelRegister("3btZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $2519ab3ee3c9cc4e$export$2e2bcd8739ae039);

var $7i20C = parcelRequire("7i20C");

var $9CgcO = parcelRequire("9CgcO");

var $jZirl = parcelRequire("jZirl");

var $gHgks = parcelRequire("gHgks");

var $bGiaL = parcelRequire("bGiaL");
function $2519ab3ee3c9cc4e$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $9CgcO.default)(1, arguments);
    var defaultOptions = (0, $bGiaL.getDefaultOptions)();
    var firstWeekContainsDate = (0, $gHgks.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $7i20C.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $jZirl.default)(firstWeek, options);
    return date;
}

});
parcelRegister("7i20C", function(module, exports) {

$parcel$export(module.exports, "default", () => $54ebc5cb5ca70901$export$2e2bcd8739ae039);

var $6LSiz = parcelRequire("6LSiz");

var $9CgcO = parcelRequire("9CgcO");

var $jZirl = parcelRequire("jZirl");

var $gHgks = parcelRequire("gHgks");

var $bGiaL = parcelRequire("bGiaL");
function $54ebc5cb5ca70901$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $9CgcO.default)(1, arguments);
    var date = (0, $6LSiz.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $bGiaL.getDefaultOptions)();
    var firstWeekContainsDate = (0, $gHgks.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $jZirl.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $jZirl.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("fjP2F", function(module, exports) {

$parcel$export(module.exports, "default", () => $b270394483307839$export$2e2bcd8739ae039);
function $b270394483307839$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}

});

parcelRegister("gzukL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c10771e8bbd593db$export$2e2bcd8739ae039);

var $fjP2F = parcelRequire("fjP2F");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $c10771e8bbd593db$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $fjP2F.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $fjP2F.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $fjP2F.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $fjP2F.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $fjP2F.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $fjP2F.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $fjP2F.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $fjP2F.default)(fractionalSeconds, token.length);
    }
};
var $c10771e8bbd593db$export$2e2bcd8739ae039 = $c10771e8bbd593db$var$formatters;

});


parcelRegister("fpRsA", function(module, exports) {

$parcel$export(module.exports, "default", () => $b392a8e1e0084ffa$export$2e2bcd8739ae039);
var $b392a8e1e0084ffa$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $b392a8e1e0084ffa$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $b392a8e1e0084ffa$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $b392a8e1e0084ffa$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $b392a8e1e0084ffa$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $b392a8e1e0084ffa$var$timeLongFormatter(timePattern, formatLong));
};
var $b392a8e1e0084ffa$var$longFormatters = {
    p: $b392a8e1e0084ffa$var$timeLongFormatter,
    P: $b392a8e1e0084ffa$var$dateTimeLongFormatter
};
var $b392a8e1e0084ffa$export$2e2bcd8739ae039 = $b392a8e1e0084ffa$var$longFormatters;

});

parcelRegister("2ytfe", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dc5711e50dd479c$export$2e2bcd8739ae039);
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $1dc5711e50dd479c$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("4qJLD", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", () => $339d17943b949a28$export$c6cc36aa33304772);
$parcel$export(module.exports, "isProtectedWeekYearToken", () => $339d17943b949a28$export$c6b49d6dceb604a1);
$parcel$export(module.exports, "throwProtectedError", () => $339d17943b949a28$export$8073c1ae88f0e727);
var $339d17943b949a28$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $339d17943b949a28$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $339d17943b949a28$export$c6cc36aa33304772(token) {
    return $339d17943b949a28$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $339d17943b949a28$export$c6b49d6dceb604a1(token) {
    return $339d17943b949a28$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $339d17943b949a28$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

});

parcelRegister("8idmG", function(module, exports) {

$parcel$export(module.exports, "default", () => $609a5f2b3f4e92ab$export$2e2bcd8739ae039);

var $g9AAU = parcelRequire("g9AAU");
var $609a5f2b3f4e92ab$export$2e2bcd8739ae039 = (0, $g9AAU.default);

});
parcelRegister("g9AAU", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc29df7b21bca249$export$2e2bcd8739ae039);

var $cSLJ0 = parcelRequire("cSLJ0");

var $1VTxI = parcelRequire("1VTxI");

var $7Bm6O = parcelRequire("7Bm6O");

var $92VtU = parcelRequire("92VtU");

var $lTJI1 = parcelRequire("lTJI1");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $bc29df7b21bca249$var$locale = {
    code: 'en-US',
    formatDistance: (0, $cSLJ0.default),
    formatLong: (0, $1VTxI.default),
    formatRelative: (0, $7Bm6O.default),
    localize: (0, $92VtU.default),
    match: (0, $lTJI1.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $bc29df7b21bca249$export$2e2bcd8739ae039 = $bc29df7b21bca249$var$locale;

});
parcelRegister("cSLJ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $960f8c5bceff00cb$export$2e2bcd8739ae039);
var $960f8c5bceff00cb$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $960f8c5bceff00cb$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $960f8c5bceff00cb$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $960f8c5bceff00cb$export$2e2bcd8739ae039 = $960f8c5bceff00cb$var$formatDistance;

});

parcelRegister("1VTxI", function(module, exports) {

$parcel$export(module.exports, "default", () => $168632f5e78f1e82$export$2e2bcd8739ae039);

var $k7msk = parcelRequire("k7msk");
var $168632f5e78f1e82$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $168632f5e78f1e82$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $168632f5e78f1e82$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $168632f5e78f1e82$var$formatLong = {
    date: (0, $k7msk.default)({
        formats: $168632f5e78f1e82$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $k7msk.default)({
        formats: $168632f5e78f1e82$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $k7msk.default)({
        formats: $168632f5e78f1e82$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $168632f5e78f1e82$export$2e2bcd8739ae039 = $168632f5e78f1e82$var$formatLong;

});
parcelRegister("k7msk", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea55e15e15b7eb15$export$2e2bcd8739ae039);
function $ea55e15e15b7eb15$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("7Bm6O", function(module, exports) {

$parcel$export(module.exports, "default", () => $588d237949860422$export$2e2bcd8739ae039);
var $588d237949860422$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $588d237949860422$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $588d237949860422$var$formatRelativeLocale[token];
};
var $588d237949860422$export$2e2bcd8739ae039 = $588d237949860422$var$formatRelative;

});

parcelRegister("92VtU", function(module, exports) {

$parcel$export(module.exports, "default", () => $6960e39587f41811$export$2e2bcd8739ae039);

var $4zyfL = parcelRequire("4zyfL");
var $6960e39587f41811$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $6960e39587f41811$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $6960e39587f41811$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $6960e39587f41811$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $6960e39587f41811$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $6960e39587f41811$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $6960e39587f41811$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $6960e39587f41811$var$localize = {
    ordinalNumber: $6960e39587f41811$var$ordinalNumber,
    era: (0, $4zyfL.default)({
        values: $6960e39587f41811$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $4zyfL.default)({
        values: $6960e39587f41811$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $4zyfL.default)({
        values: $6960e39587f41811$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $4zyfL.default)({
        values: $6960e39587f41811$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $4zyfL.default)({
        values: $6960e39587f41811$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $6960e39587f41811$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $6960e39587f41811$export$2e2bcd8739ae039 = $6960e39587f41811$var$localize;

});
parcelRegister("4zyfL", function(module, exports) {

$parcel$export(module.exports, "default", () => $354500478779114c$export$2e2bcd8739ae039);
function $354500478779114c$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("lTJI1", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff1230e3ffb00377$export$2e2bcd8739ae039);

var $gjUIp = parcelRequire("gjUIp");

var $2ucSP = parcelRequire("2ucSP");
var $ff1230e3ffb00377$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $ff1230e3ffb00377$var$parseOrdinalNumberPattern = /\d+/i;
var $ff1230e3ffb00377$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $ff1230e3ffb00377$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $ff1230e3ffb00377$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $ff1230e3ffb00377$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $ff1230e3ffb00377$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $ff1230e3ffb00377$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $ff1230e3ffb00377$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $ff1230e3ffb00377$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $ff1230e3ffb00377$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $ff1230e3ffb00377$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $ff1230e3ffb00377$var$match = {
    ordinalNumber: (0, $2ucSP.default)({
        matchPattern: $ff1230e3ffb00377$var$matchOrdinalNumberPattern,
        parsePattern: $ff1230e3ffb00377$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gjUIp.default)({
        matchPatterns: $ff1230e3ffb00377$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ff1230e3ffb00377$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $gjUIp.default)({
        matchPatterns: $ff1230e3ffb00377$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ff1230e3ffb00377$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gjUIp.default)({
        matchPatterns: $ff1230e3ffb00377$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ff1230e3ffb00377$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $gjUIp.default)({
        matchPatterns: $ff1230e3ffb00377$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ff1230e3ffb00377$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $gjUIp.default)({
        matchPatterns: $ff1230e3ffb00377$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $ff1230e3ffb00377$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $ff1230e3ffb00377$export$2e2bcd8739ae039 = $ff1230e3ffb00377$var$match;

});
parcelRegister("gjUIp", function(module, exports) {

$parcel$export(module.exports, "default", () => $be1a6a2e41c9df24$export$2e2bcd8739ae039);
function $be1a6a2e41c9df24$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $be1a6a2e41c9df24$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $be1a6a2e41c9df24$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $be1a6a2e41c9df24$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $be1a6a2e41c9df24$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("2ucSP", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cf8607c658561b8$export$2e2bcd8739ae039);
function $1cf8607c658561b8$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});





parcelRegister("aT4Ql", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ed2cc2f4da26e13$export$2e2bcd8739ae039);

var $bGiaL = parcelRequire("bGiaL");

var $3erYA = parcelRequire("3erYA");

var $203nN = parcelRequire("203nN");

var $8idmG = parcelRequire("8idmG");

var $jLc1d = parcelRequire("jLc1d");

var $6LSiz = parcelRequire("6LSiz");

var $2ytfe = parcelRequire("2ytfe");

var $9CgcO = parcelRequire("9CgcO");

var $gHgks = parcelRequire("gHgks");
function $7ed2cc2f4da26e13$export$2e2bcd8739ae039(dirtyDate, dirtyBaseDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$weekStartsOn, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2;
    (0, $9CgcO.default)(2, arguments);
    var date = (0, $6LSiz.default)(dirtyDate);
    var baseDate = (0, $6LSiz.default)(dirtyBaseDate);
    var defaultOptions = (0, $bGiaL.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $8idmG.default);
    var weekStartsOn = (0, $gHgks.default)((_ref2 = (_ref3 = (_ref4 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.weekStartsOn) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0);
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    if (!locale.formatRelative) throw new RangeError('locale must contain formatRelative property');
    var diff = (0, $3erYA.default)(date, baseDate);
    if (isNaN(diff)) throw new RangeError('Invalid time value');
    var token;
    if (diff < -6) token = 'other';
    else if (diff < -1) token = 'lastWeek';
    else if (diff < 0) token = 'yesterday';
    else if (diff < 1) token = 'today';
    else if (diff < 2) token = 'tomorrow';
    else if (diff < 7) token = 'nextWeek';
    else token = 'other';
    var utcDate = (0, $jLc1d.default)(date, (0, $2ytfe.default)(date));
    var utcBaseDate = (0, $jLc1d.default)(baseDate, (0, $2ytfe.default)(baseDate));
    var formatStr = locale.formatRelative(token, utcDate, utcBaseDate, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
    return (0, $203nN.default)(date, formatStr, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
}

});
parcelRegister("3erYA", function(module, exports) {

$parcel$export(module.exports, "default", () => $25a8616156ae4fc2$export$2e2bcd8739ae039);

var $2ytfe = parcelRequire("2ytfe");

var $4GdvM = parcelRequire("4GdvM");

var $9CgcO = parcelRequire("9CgcO");
var $25a8616156ae4fc2$var$MILLISECONDS_IN_DAY = 86400000;
function $25a8616156ae4fc2$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $9CgcO.default)(2, arguments);
    var startOfDayLeft = (0, $4GdvM.default)(dirtyDateLeft);
    var startOfDayRight = (0, $4GdvM.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $2ytfe.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $2ytfe.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $25a8616156ae4fc2$var$MILLISECONDS_IN_DAY);
}

});
parcelRegister("4GdvM", function(module, exports) {

$parcel$export(module.exports, "default", () => $368590c4c170241e$export$2e2bcd8739ae039);

var $6LSiz = parcelRequire("6LSiz");

var $9CgcO = parcelRequire("9CgcO");
function $368590c4c170241e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $9CgcO.default)(1, arguments);
    var date = (0, $6LSiz.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});



parcelRegister("armoC", function(module, exports) {

$parcel$export(module.exports, "default", () => $799dcc686cb7b1a2$export$2e2bcd8739ae039);

var $85EFQ = parcelRequire("85EFQ");

var $9gr0l = parcelRequire("9gr0l");

var $5axV5 = parcelRequire("5axV5");

var $5oi8b = parcelRequire("5oi8b");

var $i5chs = parcelRequire("i5chs");
/**
 * @type {Locale}
 * @category Locales
 * @summary French locale.
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 */ var $799dcc686cb7b1a2$var$locale = {
    code: 'fr',
    formatDistance: (0, $85EFQ.default),
    formatLong: (0, $9gr0l.default),
    formatRelative: (0, $5axV5.default),
    localize: (0, $5oi8b.default),
    match: (0, $i5chs.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $799dcc686cb7b1a2$export$2e2bcd8739ae039 = $799dcc686cb7b1a2$var$locale;

});
parcelRegister("85EFQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e3e5759d72c18c1$export$2e2bcd8739ae039);
var $5e3e5759d72c18c1$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "moins d\u2019une seconde",
        other: 'moins de {{count}} secondes'
    },
    xSeconds: {
        one: '1 seconde',
        other: '{{count}} secondes'
    },
    halfAMinute: '30 secondes',
    lessThanXMinutes: {
        one: "moins d\u2019une minute",
        other: 'moins de {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'environ 1 heure',
        other: 'environ {{count}} heures'
    },
    xHours: {
        one: '1 heure',
        other: '{{count}} heures'
    },
    xDays: {
        one: '1 jour',
        other: '{{count}} jours'
    },
    aboutXWeeks: {
        one: 'environ 1 semaine',
        other: 'environ {{count}} semaines'
    },
    xWeeks: {
        one: '1 semaine',
        other: '{{count}} semaines'
    },
    aboutXMonths: {
        one: 'environ 1 mois',
        other: 'environ {{count}} mois'
    },
    xMonths: {
        one: '1 mois',
        other: '{{count}} mois'
    },
    aboutXYears: {
        one: 'environ 1 an',
        other: 'environ {{count}} ans'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} ans'
    },
    overXYears: {
        one: "plus d\u2019un an",
        other: 'plus de {{count}} ans'
    },
    almostXYears: {
        one: "presqu\u2019un an",
        other: 'presque {{count}} ans'
    }
};
var $5e3e5759d72c18c1$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var form = $5e3e5759d72c18c1$var$formatDistanceLocale[token];
    if (typeof form === 'string') result = form;
    else if (count === 1) result = form.one;
    else result = form.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'dans ' + result;
        else return 'il y a ' + result;
    }
    return result;
};
var $5e3e5759d72c18c1$export$2e2bcd8739ae039 = $5e3e5759d72c18c1$var$formatDistance;

});

parcelRegister("9gr0l", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bea8e3922703055$export$2e2bcd8739ae039);

var $k7msk = parcelRequire("k7msk");
var $6bea8e3922703055$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $6bea8e3922703055$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $6bea8e3922703055$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $6bea8e3922703055$var$formatLong = {
    date: (0, $k7msk.default)({
        formats: $6bea8e3922703055$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $k7msk.default)({
        formats: $6bea8e3922703055$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $k7msk.default)({
        formats: $6bea8e3922703055$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $6bea8e3922703055$export$2e2bcd8739ae039 = $6bea8e3922703055$var$formatLong;

});

parcelRegister("5axV5", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c3832af8c3b4897$export$2e2bcd8739ae039);
var $3c3832af8c3b4897$var$formatRelativeLocale = {
    lastWeek: "eeee 'dernier \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'prochain \xe0' p",
    other: 'P'
};
var $3c3832af8c3b4897$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $3c3832af8c3b4897$var$formatRelativeLocale[token];
};
var $3c3832af8c3b4897$export$2e2bcd8739ae039 = $3c3832af8c3b4897$var$formatRelative;

});

parcelRegister("5oi8b", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ecd4215b3611959$export$2e2bcd8739ae039);

var $4zyfL = parcelRequire("4zyfL");
var $3ecd4215b3611959$var$eraValues = {
    narrow: [
        'av. J.-C',
        'ap. J.-C'
    ],
    abbreviated: [
        'av. J.-C',
        'ap. J.-C'
    ],
    wide: [
        "avant J\xe9sus-Christ",
        "apr\xe8s J\xe9sus-Christ"
    ]
};
var $3ecd4215b3611959$var$quarterValues = {
    narrow: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    abbreviated: [
        '1er trim.',
        "2\xe8me trim.",
        "3\xe8me trim.",
        "4\xe8me trim."
    ],
    wide: [
        '1er trimestre',
        "2\xe8me trimestre",
        "3\xe8me trimestre",
        "4\xe8me trimestre"
    ]
};
var $3ecd4215b3611959$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'janv.',
        "f\xe9vr.",
        'mars',
        'avr.',
        'mai',
        'juin',
        'juil.',
        "ao\xfbt",
        'sept.',
        'oct.',
        'nov.',
        "d\xe9c."
    ],
    wide: [
        'janvier',
        "f\xe9vrier",
        'mars',
        'avril',
        'mai',
        'juin',
        'juillet',
        "ao\xfbt",
        'septembre',
        'octobre',
        'novembre',
        "d\xe9cembre"
    ]
};
var $3ecd4215b3611959$var$dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        'J',
        'V',
        'S'
    ],
    short: [
        'di',
        'lu',
        'ma',
        'me',
        'je',
        've',
        'sa'
    ],
    abbreviated: [
        'dim.',
        'lun.',
        'mar.',
        'mer.',
        'jeu.',
        'ven.',
        'sam.'
    ],
    wide: [
        'dimanche',
        'lundi',
        'mardi',
        'mercredi',
        'jeudi',
        'vendredi',
        'samedi'
    ]
};
var $3ecd4215b3611959$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'mat.',
        afternoon: 'ap.m.',
        evening: 'soir',
        night: 'mat.'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'matin',
        afternoon: "apr\xe8s-midi",
        evening: 'soir',
        night: 'matin'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'du matin',
        afternoon: "de l\u2019apr\xe8s-midi",
        evening: 'du soir',
        night: 'du matin'
    }
};
var $3ecd4215b3611959$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (number === 0) return '0';
    var feminineUnits = [
        'year',
        'week',
        'hour',
        'minute',
        'second'
    ];
    var suffix;
    if (number === 1) suffix = unit && feminineUnits.includes(unit) ? "\xe8re" : 'er';
    else suffix = "\xe8me";
    return number + suffix;
};
var $3ecd4215b3611959$var$localize = {
    ordinalNumber: $3ecd4215b3611959$var$ordinalNumber,
    era: (0, $4zyfL.default)({
        values: $3ecd4215b3611959$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $4zyfL.default)({
        values: $3ecd4215b3611959$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $4zyfL.default)({
        values: $3ecd4215b3611959$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $4zyfL.default)({
        values: $3ecd4215b3611959$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $4zyfL.default)({
        values: $3ecd4215b3611959$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $3ecd4215b3611959$export$2e2bcd8739ae039 = $3ecd4215b3611959$var$localize;

});

parcelRegister("i5chs", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2a2384b9f07212a$export$2e2bcd8739ae039);

var $gjUIp = parcelRequire("gjUIp");

var $2ucSP = parcelRequire("2ucSP");
var $d2a2384b9f07212a$var$matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
var $d2a2384b9f07212a$var$parseOrdinalNumberPattern = /\d+/i;
var $d2a2384b9f07212a$var$matchEraPatterns = {
    narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
    abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
};
var $d2a2384b9f07212a$var$parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
var $d2a2384b9f07212a$var$matchQuarterPatterns = {
    narrow: /^T?[1234]/i,
    abbreviated: /^[1234](er|ème|e)? trim\.?/i,
    wide: /^[1234](er|ème|e)? trimestre/i
};
var $d2a2384b9f07212a$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $d2a2384b9f07212a$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
    wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
var $d2a2384b9f07212a$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^av/i,
        /^ma/i,
        /^juin/i,
        /^juil/i,
        /^ao/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $d2a2384b9f07212a$var$matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|lu|ma|me|je|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
    wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
var $d2a2384b9f07212a$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^je/i,
        /^ve/i,
        /^sa/i
    ]
};
var $d2a2384b9f07212a$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
    any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
var $d2a2384b9f07212a$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /soir/i,
        night: /nuit/i
    }
};
var $d2a2384b9f07212a$var$match = {
    ordinalNumber: (0, $2ucSP.default)({
        matchPattern: $d2a2384b9f07212a$var$matchOrdinalNumberPattern,
        parsePattern: $d2a2384b9f07212a$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value);
        }
    }),
    era: (0, $gjUIp.default)({
        matchPatterns: $d2a2384b9f07212a$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d2a2384b9f07212a$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $gjUIp.default)({
        matchPatterns: $d2a2384b9f07212a$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d2a2384b9f07212a$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gjUIp.default)({
        matchPatterns: $d2a2384b9f07212a$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d2a2384b9f07212a$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $gjUIp.default)({
        matchPatterns: $d2a2384b9f07212a$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d2a2384b9f07212a$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $gjUIp.default)({
        matchPatterns: $d2a2384b9f07212a$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $d2a2384b9f07212a$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $d2a2384b9f07212a$export$2e2bcd8739ae039 = $d2a2384b9f07212a$var$match;

});



parcelRegister("4ARPW", function(module, exports) {

var $203nN = parcelRequire("203nN");

var $armoC = parcelRequire("armoC");
var $358449145bcc6074$var$localeFns = {
    locale: $armoC.default
};
/*
 * <format-date datetime="2020-06-04T12:27:06.222Z">
 */ class $358449145bcc6074$var$FormatDate extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.render();
        this.onclick = function() {
            this.render();
        };
    }
    render() {
        var x = new Date(this.getAttribute('datetime'));
        this.innerHTML = $203nN.default(x, 'PP', $358449145bcc6074$var$localeFns);
    }
}
customElements.define('format-date', $358449145bcc6074$var$FormatDate);

});

parcelRegister("5JGum", function(module, exports) {

var $auMgu = parcelRequire("auMgu");

var $armoC = parcelRequire("armoC");
var $42d21d1d2554d6c6$var$localeFns = {
    locale: $armoC.default
};
/*
 * <format-distance startdate="2020-06-04T12:27:06.222Z" enddate="2021-06-04T12:27:06.222Z">
 */ class $42d21d1d2554d6c6$var$DistanceTime extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.render();
    }
    render() {
        var start = new Date(this.getAttribute('startdate'));
        var end = new Date(this.getAttribute('enddate'));
        this.innerHTML = $auMgu.default(end, start, $42d21d1d2554d6c6$var$localeFns);
    }
}
customElements.define('format-distance', $42d21d1d2554d6c6$var$DistanceTime);

});
parcelRegister("auMgu", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a42252011213e79$export$2e2bcd8739ae039);

var $bGiaL = parcelRequire("bGiaL");

var $2ytfe = parcelRequire("2ytfe");

var $2amLD = parcelRequire("2amLD");

var $6LSiz = parcelRequire("6LSiz");

var $lXawA = parcelRequire("lXawA");

var $lvekV = parcelRequire("lvekV");

var $8idmG = parcelRequire("8idmG");

var $9CgcO = parcelRequire("9CgcO");
var $7a42252011213e79$var$MILLISECONDS_IN_MINUTE = 60000;
var $7a42252011213e79$var$MINUTES_IN_DAY = 1440;
var $7a42252011213e79$var$MINUTES_IN_MONTH = $7a42252011213e79$var$MINUTES_IN_DAY * 30;
var $7a42252011213e79$var$MINUTES_IN_YEAR = $7a42252011213e79$var$MINUTES_IN_DAY * 365;
function $7a42252011213e79$export$2e2bcd8739ae039(dirtyDate, dirtyBaseDate, options) {
    var _ref, _options$locale, _options$roundingMeth;
    (0, $9CgcO.default)(2, arguments);
    var defaultOptions = (0, $bGiaL.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $8idmG.default);
    if (!locale.formatDistance) throw new RangeError('locale must contain localize.formatDistance property');
    var comparison = (0, $2amLD.default)(dirtyDate, dirtyBaseDate);
    if (isNaN(comparison)) throw new RangeError('Invalid time value');
    var localizeOptions = (0, $lvekV.default)((0, $lXawA.default)(options), {
        addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
        comparison: comparison
    });
    var dateLeft;
    var dateRight;
    if (comparison > 0) {
        dateLeft = (0, $6LSiz.default)(dirtyBaseDate);
        dateRight = (0, $6LSiz.default)(dirtyDate);
    } else {
        dateLeft = (0, $6LSiz.default)(dirtyDate);
        dateRight = (0, $6LSiz.default)(dirtyBaseDate);
    }
    var roundingMethod = String((_options$roundingMeth = options === null || options === void 0 ? void 0 : options.roundingMethod) !== null && _options$roundingMeth !== void 0 ? _options$roundingMeth : 'round');
    var roundingMethodFn;
    if (roundingMethod === 'floor') roundingMethodFn = Math.floor;
    else if (roundingMethod === 'ceil') roundingMethodFn = Math.ceil;
    else if (roundingMethod === 'round') roundingMethodFn = Math.round;
    else throw new RangeError("roundingMethod must be 'floor', 'ceil' or 'round'");
    var milliseconds = dateRight.getTime() - dateLeft.getTime();
    var minutes = milliseconds / $7a42252011213e79$var$MILLISECONDS_IN_MINUTE;
    var timezoneOffset = (0, $2ytfe.default)(dateRight) - (0, $2ytfe.default)(dateLeft);
    // Use DST-normalized difference in minutes for years, months and days;
    // use regular difference in minutes for hours, minutes and seconds.
    var dstNormalizedMinutes = (milliseconds - timezoneOffset) / $7a42252011213e79$var$MILLISECONDS_IN_MINUTE;
    var defaultUnit = options === null || options === void 0 ? void 0 : options.unit;
    var unit;
    if (!defaultUnit) {
        if (minutes < 1) unit = 'second';
        else if (minutes < 60) unit = 'minute';
        else if (minutes < $7a42252011213e79$var$MINUTES_IN_DAY) unit = 'hour';
        else if (dstNormalizedMinutes < $7a42252011213e79$var$MINUTES_IN_MONTH) unit = 'day';
        else if (dstNormalizedMinutes < $7a42252011213e79$var$MINUTES_IN_YEAR) unit = 'month';
        else unit = 'year';
    } else unit = String(defaultUnit);
    // 0 up to 60 seconds
    if (unit === 'second') {
        var seconds = roundingMethodFn(milliseconds / 1000);
        return locale.formatDistance('xSeconds', seconds, localizeOptions);
    // 1 up to 60 mins
    } else if (unit === 'minute') {
        var roundedMinutes = roundingMethodFn(minutes);
        return locale.formatDistance('xMinutes', roundedMinutes, localizeOptions);
    // 1 up to 24 hours
    } else if (unit === 'hour') {
        var hours = roundingMethodFn(minutes / 60);
        return locale.formatDistance('xHours', hours, localizeOptions);
    // 1 up to 30 days
    } else if (unit === 'day') {
        var days = roundingMethodFn(dstNormalizedMinutes / $7a42252011213e79$var$MINUTES_IN_DAY);
        return locale.formatDistance('xDays', days, localizeOptions);
    // 1 up to 12 months
    } else if (unit === 'month') {
        var months = roundingMethodFn(dstNormalizedMinutes / $7a42252011213e79$var$MINUTES_IN_MONTH);
        return months === 12 && defaultUnit !== 'month' ? locale.formatDistance('xYears', 1, localizeOptions) : locale.formatDistance('xMonths', months, localizeOptions);
    // 1 year up to max Date
    } else if (unit === 'year') {
        var years = roundingMethodFn(dstNormalizedMinutes / $7a42252011213e79$var$MINUTES_IN_YEAR);
        return locale.formatDistance('xYears', years, localizeOptions);
    }
    throw new RangeError("unit must be 'second', 'minute', 'hour', 'day', 'month' or 'year'");
}

});
parcelRegister("2amLD", function(module, exports) {

$parcel$export(module.exports, "default", () => $193e2d0d73e849f3$export$2e2bcd8739ae039);

var $6LSiz = parcelRequire("6LSiz");

var $9CgcO = parcelRequire("9CgcO");
function $193e2d0d73e849f3$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $9CgcO.default)(2, arguments);
    var dateLeft = (0, $6LSiz.default)(dirtyDateLeft);
    var dateRight = (0, $6LSiz.default)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

});

parcelRegister("lXawA", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffb745a36db7587c$export$2e2bcd8739ae039);

var $lvekV = parcelRequire("lvekV");
function $ffb745a36db7587c$export$2e2bcd8739ae039(object) {
    return (0, $lvekV.default)({}, object);
}

});
parcelRegister("lvekV", function(module, exports) {

$parcel$export(module.exports, "default", () => $040a2ff43ed6f491$export$2e2bcd8739ae039);
function $040a2ff43ed6f491$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

});




parcelRegister("3Ii3I", function(module, exports) {
module.exports = function raf(app) {
    var lastTime = 0;
    var vendors = [
        'ms',
        'moz',
        'webkit',
        'o'
    ];
    var usingSetTimeout = false;
    if (!window.requestAnimationFrame) vendors.forEach(function(prefix) {
        window.requestAnimationFrame = window[prefix + 'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[prefix + 'CancelAnimationFrame'] || window[prefix + 'CancelRequestAnimationFrame'];
    });
    if (!window.requestAnimationFrame) {
        usingSetTimeout = true;
        window.requestAnimationFrame = function(callback, element) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function() {
                callback(currTime + timeToCall);
            }, timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };
    }
    if (!window.cancelAnimationFrame) {
        if (usingSetTimeout) window.cancelAnimationFrame = function(id) {
            clearTimeout(id);
        };
        else window.cancelAnimationFrame = function() {};
    }
    return app;
};

});

parcelRegister("4lCIN", function(module, exports) {
module.exports = function keyboard(app) {
    window.addEventListener('keypress', function(e) {
        if (e.target.tagName === "INPUT" || e.target.tagName === "SELECT" || e.target.tagName === "TEXTAREA") ;
        else app.ports.onKeypressNoInput.send(e.keyCode);
    });
// window.addEventListener('keydown', function (e) {
//   if (e.target.tagName === "INPUT" || e.target.tagName === "SELECT" || e.target.tagName === "TEXTAREA") {
//     // filling a form...
//   } else {
//     // do not scroll
//     if (e.keyCode == 32) e.preventDefault();
//     app.ports.onKeydownNoInput.send(e.keyCode);
//   }
// });
// window.addEventListener('keyup', function (e) {
//   if (e.target.tagName === "INPUT" || e.target.tagName === "SELECT" || e.target.tagName === "TEXTAREA") {
//     // filling a form...
//   } else {
//     app.ports.onKeyupNoInput.send(e.keyCode);
//   }
// });
};

});

parcelRegister("56a0I", function(module, exports) {
module.exports = function viewport(app) {
    window.onresize = function() {
        app.ports.viewport.send({
            width: window.innerWidth,
            height: window.innerHeight,
            isFullscreen: !!(document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement)
        });
    };
};

});

parcelRegister("j63Xd", function(module, exports) {
window.document.body.addEventListener("click", function(e) {
    var target = e.target;
    var current = document.getElementById("CatchClickAll");
    if (!current) return true;
    do {
        if (target === current) return true;
    }while (target = target.parentNode);
    current.click();
}, true);

});

parcelRegister("fFcjN", function(module, exports) {

$parcel$export(module.exports, "default", () => $3704c843920dcfc2$export$2e2bcd8739ae039);

var $ffDwH = parcelRequire("ffDwH");

var $kjMit = parcelRequire("kjMit");

var $eqZ8F = parcelRequire("eqZ8F");

var $8dcRR = parcelRequire("8dcRR");

var $gguoi = parcelRequire("gguoi");

var $6jqaU = parcelRequire("6jqaU");
const $3704c843920dcfc2$var$$ = $gguoi.$;
var $3704c843920dcfc2$var$shakaVideoContainer;
// shaka buffer config (in second)
const $3704c843920dcfc2$var$BUFFERBEHIND = 300;
const $3704c843920dcfc2$var$BUFFERINGGOAL = 300;
const $3704c843920dcfc2$var$CONSTANT_VIDEO_INTERACTIVITY = 0.00001;
const $3704c843920dcfc2$var$IS_IOS = /iPad|iPhone|iPod/.test(navigator.platform) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
function $3704c843920dcfc2$export$2e2bcd8739ae039(app) {
    function sendEventToElm(event) {
        app.ports.jsToElm?.send(Object.assign({
            action: '',
            buffer: [
                {
                    start: 0,
                    end: 0
                }
            ],
            frame: 0
        }, event));
    }
    function preventDefaultWindowOnSpace(event) {
        if (event.key == ' ' && ![
            'INPUT',
            'TEXTAREA'
        ].includes(event.target.nodeName)) event.preventDefault();
    }
    function computeCurrentFrame(video, frameRate, supportFrameAccuracy) {
        if (supportFrameAccuracy) return $8dcRR(video);
        else return Math.floor(video.currentTime * frameRate);
    }
    class Nomaplayer extends HTMLElement {
        constructor(){
            super(), this.state = {
                selectedTracks: [],
                audiotracks: [],
                manifest: '',
                player: {},
                currentSubtitle: '',
                frameRate: 0,
                startTimecode: '00:00:00:00'
            }, this.frameAccuracySupport = true, // Timecode input
            this.maskInput = {}, this.timecodeMaskElt = {}, // Timecode overlay
            this.timeMaskElt = {}, this.timeCursorElt = {}, this.timeTCElt = {}, // Proxy `this` inside listener
            this.videoProgressListener = (event)=>this.onVideoProgress(event), this.inputFocusListener = ()=>this.getVideo().pause(), this.inputBlurListener = ()=>setTimeout(()=>this.getVideo().focus(), 10), this.moveTimecodeListener = (event)=>this.moveTimecode(event), this.requestFrameTimecodeOverlayListener = ()=>this.requestFrameTimecodeOverlay(), this.portsFromElm = (event)=>this.eventFromElm(event), this.onTimeMaskClickListener = (event)=>this.onTimeMaskClick(event), this.keyUpVideo = (event)=>{
                if (!(event.target.tagName === 'INPUT' || event.target.tagName === 'SELECT' || event.target.tagName === 'TEXTAREA')) switch(event.keyCode){
                    // space
                    case 32:
                        if (this.getVideo().paused) this.play();
                        else this.pause();
                        break;
                    // Left arrow
                    case 37:
                        this.prevFrame();
                        break;
                    // Right arrow
                    case 39:
                        this.nextFrame();
                }
            };
            $6jqaU.polyfill.installAll();
            this.attachShadow({
                mode: 'open'
            });
            this.frameAccuracySupport = !(!$6jqaU.Player.isBrowserSupported() || $3704c843920dcfc2$var$IS_IOS);
            const videoCtrl = document.createElement('div');
            $3704c843920dcfc2$var$shakaVideoContainer = videoCtrl;
            const videoStyles = document.createElement('style');
            videoStyles.innerHTML = `
.shaka-hidden{display:none!important}
.shaka-video-container{pointer-events:none;position:absolute;left:1vw;right:1vw;top:1vw;bottom:1vw;display:flex}

.shaka-text-container{position:absolute;left:0;right:0;top:0;bottom:0;font-size:1vw;line-height:1.4;color:#fff}
.shaka-text-container span.shaka-text-wrapper{display:inline;background:0 0}
@media (min-width: 1000px) and (max-width: 1400px) { .shaka-text-container { font-size: 1.55vw; } }
@media (max-width: 1000px) { .shaka-text-container { font-size: 2.2vw; } }
.PlayerFullScreen .shaka-text-container { font-size: 2.2vw !important; }
.shaka-text-container * { background-color: rgba(0,0,0,0) !important; }
.shaka-text-container {
  text-shadow: 0 0 0.11vw #000, 0 0 2px #000, 0 0 2px #000;
}
.PlayerControlsShown.shaka-video-container { bottom: calc(90px + 1vw); }

.shaka-spinner-container{display:none;}
      `;
            const video = document.createElement('video');
            video.setAttribute('style', 'width: 100%;display: block;margin-top: -3.68%;');
            video.setAttribute('id', 'video-player');
            video.setAttribute('playsinline', '');
            video.setAttribute('crossOrigin', 'anonymous');
            this.shadowRoot?.appendChild(video);
            this.shadowRoot?.appendChild(videoCtrl);
            this.shadowRoot?.appendChild(videoStyles);
        }
        connectedCallback() {
            this.initVariables();
            fetch(new Request(`/v4/proxy/${this.getAttribute('data-manifest')}/play`, {
                method: 'POST'
            }));
            this.render();
            app.ports.elmToJs?.subscribe(this.portsFromElm);
        }
        disconnectedCallback() {
            app.ports.elmToJs?.unsubscribe(this.portsFromElm);
            this.maskInput.destroy();
            this.ui.destroy();
            return this.state.player.destroy().then(()=>{
                this.state = {
                    selectedTracks: [],
                    audiotracks: [],
                    manifest: '',
                    player: {},
                    currentSubtitle: '',
                    frameRate: 0,
                    startTimecode: '00:00:00:00'
                };
                this.timecodeMaskElt.removeEventListener('focus', this.inputFocusListener);
                this.timecodeMaskElt.removeEventListener('blur', this.inputBlurListener);
                this.timeMaskElt.removeEventListener('mousemove', this.moveTimecodeListener);
                this.timeMaskElt.removeEventListener('mouseleave', this.requestFrameTimecodeOverlayListener);
                this.timeMaskElt.removeEventListener('click', this.onTimeMaskClickListener);
                this.getVideo().removeEventListener('ended', this.ended);
                this.getVideo().removeEventListener('progress', this.onVideoLoading);
                this.getVideo().removeEventListener('timeupdate', this.videoProgressListener);
                this.getVideo().removeEventListener('click', this.playOrPause);
                this.getVideo().removeEventListener('dblclick', this.handleFullScreen);
                window.removeEventListener('keydown', preventDefaultWindowOnSpace);
                window.removeEventListener('keyup', this.keyUpVideo);
            });
        }
        initVariables() {
            const manifest = this.getAttribute('data-manifest');
            if (manifest) this.state.manifest = manifest;
            const audiostracks = this.getAttribute('data-audiostracks');
            if (audiostracks) {
                this.state.audiotracks = JSON.parse(audiostracks);
                if (!this.state.audiotracks.length) this.state.audiotracks.push('1');
            }
            const playbackSpeed = this.getAttribute('data-playbackspeed');
            if (playbackSpeed) this.getVideo().playbackRate = parseFloat(playbackSpeed);
            const subtitles = this.getAttribute('data-subtitles');
            if (subtitles) this.state.currentSubtitle = subtitles;
            const framerate = this.getAttribute('data-framerate');
            if (framerate) this.state.frameRate = parseFloat(framerate);
            const startTimecode = this.getAttribute('data-starttimecode');
            if (startTimecode) this.state.startTimecode = startTimecode;
        }
        static get observedAttributes() {
            return [
                'data-manifest',
                'data-audiostracks',
                'data-playbackspeed',
                'data-subtitles',
                'data-framerate',
                'data-starttimecode'
            ];
        }
        attributeChangedCallback(name, _, newValue) {
            switch(name){
                case 'data-audiostracks':
                    this.state.audiotracks = JSON.parse(newValue);
                    if (Object.entries(this.state.player).length !== 0) this.loadVideo();
                    break;
                case 'data-manifest':
                    const isInitialized = this.state.manifest !== '';
                    this.state.manifest = newValue;
                    // Clear the current player if the manifest change and it was already initialized
                    if (isInitialized) {
                        if (this.state.player.destroy) return this.state.player.destroy().then(()=>this.initPlayer());
                        this.initPlayer();
                    }
                    break;
                case 'data-starttimecode':
                    this.state.startTimecode = newValue;
                    break;
                case 'data-playbackspeed':
                    if (newValue) this.getVideo().playbackRate = parseFloat(newValue);
                    break;
                case 'data-framerate':
                    if (newValue) this.state.frameRate = parseFloat(newValue);
                    break;
                case 'data-subtitles':
                    if (newValue != null) {
                        this.state.currentSubtitle = newValue;
                        if (this.state.player.destroy) return this.state.player.destroy().then(()=>this.initPlayer());
                        this.initPlayer();
                    }
                    break;
                default:
            }
        }
        eventFromElm(event) {
            switch(event.action){
                case 'Play':
                    this.play();
                    break;
                case 'Pause':
                    this.pause();
                    break;
                case 'GoTo':
                    if (event.frame !== undefined) this.goToFrame(event.frame);
                    break;
                case 'GoToStart':
                    this.goToStart();
                    break;
                case 'GoToEnd':
                    this.goToEnd();
                    break;
                case 'SubstractTime':
                    if (event.seconds !== undefined) this.substractTime(event.seconds);
                    break;
                case 'AddTime':
                    if (event.seconds !== undefined) this.addTime(event.seconds);
                    break;
                case 'NextFrame':
                    this.nextFrame();
                    break;
                case 'PrevFrame':
                    this.prevFrame();
                    break;
                case 'Fullscreen':
                    this.handleFullScreen();
                    break;
                case 'Aspectratio':
                    if (event.trackSelection !== undefined) this.state.selectedTracks = event.trackSelection;
                    break;
                case 'GetPicture':
                    if (event.rawFrame !== undefined) this.rawFrame(event.rawFrame);
                    break;
            }
        }
        play() {
            this.getVideo().play();
        }
        pause() {
            this.getVideo().pause();
        }
        playOrPause(event) {
            const videoElt = event.currentTarget;
            if (videoElt.paused) videoElt.play();
            else videoElt.pause();
        }
        substractTime(seconds) {
            if (this.getVideo().currentTime - seconds > 0) this.getVideo().currentTime -= seconds;
            else this.getVideo().currentTime = 0;
        }
        addTime(seconds) {
            if (this.getVideo().currentTime + seconds < this.getVideo().duration) this.getVideo().currentTime += seconds;
            else // Since setting the duration of the video make it bug, just remove the little constant to make it works
            this.getVideo().currentTime = this.getVideo().duration - $3704c843920dcfc2$var$CONSTANT_VIDEO_INTERACTIVITY;
        }
        goToFrame(frame) {
            const currentFrame = computeCurrentFrame(this.getVideo(), this.state.frameRate, this.frameAccuracySupport);
            if (!isNaN(currentFrame)) {
                const lastFrameNumber = Math.floor(this.state.frameRate * this.getVideo().duration) - 1;
                if (frame < 0) frame = 0;
                if (frame > lastFrameNumber) frame = lastFrameNumber;
                this.getVideo().currentTime = frame / this.state.frameRate + $3704c843920dcfc2$var$CONSTANT_VIDEO_INTERACTIVITY;
            }
        }
        nextFrame() {
            const currentFrame = computeCurrentFrame(this.getVideo(), this.state.frameRate, this.frameAccuracySupport);
            if (!isNaN(currentFrame)) {
                const lastFrameNumber = Math.floor(this.state.frameRate * this.getVideo().duration) - 1;
                if (currentFrame < lastFrameNumber) this.getVideo().currentTime = (currentFrame + 1) / this.state.frameRate + $3704c843920dcfc2$var$CONSTANT_VIDEO_INTERACTIVITY;
            }
        }
        prevFrame() {
            const currentFrame = computeCurrentFrame(this.getVideo(), this.state.frameRate, this.frameAccuracySupport);
            if (!isNaN(currentFrame)) {
                const frameNumber = isNaN(currentFrame) ? null : currentFrame;
                if (frameNumber != null && frameNumber > 0) this.getVideo().currentTime = (currentFrame - 1) / this.state.frameRate + $3704c843920dcfc2$var$CONSTANT_VIDEO_INTERACTIVITY;
            }
        }
        goToStart() {
            this.getVideo().currentTime = 0;
        }
        goToEnd() {
            const totalFrames = Math.round(this.state.frameRate * this.getVideo().duration);
            this.getVideo().currentTime = (totalFrames - 1) / this.state.frameRate + $3704c843920dcfc2$var$CONSTANT_VIDEO_INTERACTIVITY;
        }
        rawFrame(params) {
            const currentFrame = computeCurrentFrame(this.getVideo(), this.state.frameRate, this.frameAccuracySupport);
            const frameNumber = isNaN(currentFrame) ? null : currentFrame;
            if (frameNumber != null) {
                const seconds = Math.floor(frameNumber / params.frameRate * 100) / 100;
                const imageUrl = `${window.nomalab.raw_frame_url}?bucket=${params.bucket}&key=${params.key}&seconds=${seconds}&user=${window.nomalab.user.id}`;
                const newWin = open('', '', 'height=1920,width=1080,toolbar=no,location=no,directories=no,status=no');
                if (newWin) newWin.document.write((0, $ffDwH.render)(imageUrl));
            }
        }
        getVideo() {
            return this.shadowRoot?.childNodes[0];
        }
        getMpdUrl() {
            const subtitle = this.state.currentSubtitle ? `?subtitle=${this.state.currentSubtitle}` : '';
            return `/v3/files/${this.state.manifest}/manifest${subtitle}`;
        }
        getMp4Url() {
            return fetch(this.getMpdUrl()).then((resp)=>{
                if (resp.ok) return resp.text().then((xml)=>{
                    let url = xml.match(/>([^>]+video_[^<]+\.mp4[^<]+)</g)[0].slice(1, -1);
                    let txt = document.createElement("textarea");
                    txt.innerHTML = url;
                    return txt.value;
                });
            });
        }
        // TODO Move this back in the elm
        displaySelectedVideo() {
            const videoStream = $3704c843920dcfc2$var$$('[name=selected-video-track]');
            if (videoStream) videoStream.checked = true;
        }
        onTimeMaskClick(event) {
            const b = this.timeMaskElt.getBoundingClientRect();
            const frame = Math.round((event.x - b.x) / b.width * this.state.frameRate * (this.getVideo().duration - 1 / this.state.frameRate));
            this.goToFrame(frame);
        }
        loadVideoOnly() {
            this.getMp4Url().then((url)=>{
                this.getVideo().src = url;
                this.getVideo().play();
            });
        }
        loadVideo() {
            this.state.player.setTextTrackVisibility(this.state.currentSubtitle != '' && this.state.currentSubtitle != null);
            const tracks = this.state.player.getVariantTracks();
            const trackIndex = parseInt(this.state.audiotracks[0]);
            const selectedTrack = tracks.find((el)=>{
                if (el.label?.includes('audio_stream')) {
                    const searchId = new RegExp("audio_stream_([^//]+)$");
                    const trackId = parseInt(el.label.replace(searchId, '$1'));
                    return trackId === (trackIndex || 0);
                }
                return false;
            });
            if (selectedTrack) {
                this.displaySelectedVideo();
                app.ports.updateAudioStreams.send([
                    [
                        trackIndex,
                        null
                    ]
                ]);
                this.state.player.selectVariantTrack(selectedTrack, true);
            }
            // Timecode input
            const timecodeMaskElt = $3704c843920dcfc2$var$$('.TimecodeEditable');
            if (timecodeMaskElt) {
                this.timecodeMaskElt = timecodeMaskElt;
                const lastTC = (0, $eqZ8F.Timecode).init({
                    framerate: this.state.frameRate,
                    timecode: this.state.startTimecode
                });
                lastTC.add([
                    Math.floor(this.state.frameRate * this.getVideo().duration) - 1
                ]);
                const tc = (0, $eqZ8F.Timecode).init({
                    framerate: this.state.frameRate,
                    timecode: this.state.startTimecode
                });
                this.maskInput = (0, $kjMit.inputMaskTimecode)(this.timecodeMaskElt, tc.frameCount, lastTC.frameCount, this.state.frameRate, (tc)=>{
                    tc.subtract([
                        this.state.startTimecode
                    ]);
                    this.goToFrame(tc.frameCount);
                });
                this.maskInput.setTc(tc);
                this.timecodeMaskElt.addEventListener('focus', this.inputFocusListener);
                this.timecodeMaskElt.addEventListener('blur', this.inputBlurListener);
            }
            // Timecode overlay on mousemove
            // TODO: do something better
            const timeMaskElt = $3704c843920dcfc2$var$$('.PlayerControlsTimeMask');
            if (timeMaskElt && !this.timeMaskElt.addEventListener) {
                this.timeMaskElt = timeMaskElt;
                this.timeMaskElt.addEventListener('mouseleave', this.requestFrameTimecodeOverlayListener);
                this.timeMaskElt.addEventListener('click', this.onTimeMaskClickListener);
                this.timeCursorElt = document.createElement('div');
                this.timeCursorElt.className = 'PlayerControlsTimeCursor';
                this.timeCursorElt.style.pointerEvents = 'none';
                this.timeTCElt = document.createElement('span');
                this.timeTCElt.className = 'PlayerControlsTimeTimecode';
                this.timeCursorElt.appendChild(this.timeTCElt);
                if (this.timeMaskElt) {
                    this.timeMaskElt.appendChild(this.timeCursorElt);
                    this.timeMaskElt.addEventListener('mousemove', this.moveTimecodeListener);
                }
            }
            this.state.player.addEventListener('buffering', this.buffer);
            this.getVideo().addEventListener('ended', this.ended);
            this.getVideo().addEventListener('progress', this.onVideoLoading);
            this.getVideo().addEventListener('timeupdate', this.videoProgressListener);
            this.getVideo().addEventListener('click', this.playOrPause);
            this.getVideo().addEventListener('dblclick', this.handleFullScreen);
            window.addEventListener('keydown', preventDefaultWindowOnSpace);
            window.addEventListener('keyup', this.keyUpVideo);
        }
        buffer(event) {
            const action = event.buffering ? 'Buffering' : 'StopBuffering';
            sendEventToElm({
                action: action
            });
        }
        ended() {
            sendEventToElm({
                action: 'Finished'
            });
        }
        onVideoLoading(event) {
            const videoElt = event.currentTarget;
            if (videoElt.buffered.length) {
                const eventForElm = {
                    action: 'Loaded',
                    buffer: [
                        {
                            start: videoElt.buffered.start(0),
                            end: videoElt.buffered.end(0)
                        }
                    ]
                };
                sendEventToElm(eventForElm);
            }
        }
        onVideoProgress(event) {
            const videoElt = event.currentTarget;
            const frameNumber = computeCurrentFrame(videoElt, this.state.frameRate, this.frameAccuracySupport);
            sendEventToElm({
                action: videoElt.paused ? 'isPaused' : 'Playing',
                frame: frameNumber
            });
            this.setTcFromFrame(frameNumber);
        }
        setTcFromFrame(frame) {
            const tc = (0, $eqZ8F.Timecode).init({
                framerate: this.state.frameRate
            });
            tc.setFrameNumberToTimecode(frame);
            tc.add([
                this.state.startTimecode
            ]);
            this.maskInput.setTc(tc);
        }
        moveTimecode(evt) {
            const b = this.timeMaskElt.getBoundingClientRect();
            if (evt.x < b.x + b.width && evt.x >= b.x && evt.y >= b.y && evt.y <= b.y + b.height) {
                const frame = Math.round((evt.x - b.x) / b.width * this.state.frameRate * (this.getVideo().duration - 1 / this.state.frameRate));
                const tc = (0, $eqZ8F.Timecode).init({
                    framerate: this.state.frameRate
                });
                tc.set(frame);
                tc.add([
                    this.state.startTimecode
                ]);
                requestAnimationFrame(()=>{
                    this.timeTCElt.innerHTML = tc.toString();
                    this.timeTCElt.style.transform = evt.offsetX < 80 ? `translateX(100%)` : '';
                    this.timeCursorElt.style.left = `${evt.x - b.x}px`;
                    this.timeMaskElt.style.opacity = '1';
                });
            } else requestAnimationFrame(()=>this.timeMaskElt.style.opacity = '0');
        }
        requestFrameTimecodeOverlay() {
            requestAnimationFrame(()=>this.timeMaskElt.style.opacity = '0');
        }
        warns(message) {
            const banner = $3704c843920dcfc2$var$$('.PlayerBanner');
            $3704c843920dcfc2$var$$('.PlayerBanner .BannerContent').innerHTML = message;
            banner.style.display = '';
            banner.addEventListener('click', function h() {
                banner.style.display = 'none';
                banner.removeEventListener('click', h);
            });
        }
        handleFullScreen() {
            const videoWrapper = $3704c843920dcfc2$var$$('#player-wrapper');
            const controlsWrapper = $3704c843920dcfc2$var$$('.PlayerControlsBox');
            let hoveringControls = false;
            let controlsFullscreenDelay = 0;
            function playerMouseMove() {
                if (controlsFullscreenDelay) clearTimeout(controlsFullscreenDelay);
                if (!hoveringControls) controlsFullscreenDelay = setTimeout(hideControls, 1000);
                toggleCtrl(true);
            }
            function controlsMouseEnter() {
                hoveringControls = true;
            }
            function controlsMouseLeave() {
                hoveringControls = false;
            }
            function hideControls() {
                toggleCtrl(false);
            }
            if (videoWrapper.webkitRequestFullscreen) null == document.webkitFullscreenElement ? videoWrapper.webkitRequestFullscreen() : document.webkitExitFullscreen();
            else if (videoWrapper.mozRequestFullScreen) null == document.mozFullScreenElement ? videoWrapper.mozRequestFullScreen() : document.mozCancelFullScreen();
            else if (videoWrapper.msRequestFullscreen) null == document.msFullscreenElement ? videoWrapper.msRequestFullscreen() : document.msExitFullscreen();
            else if (videoWrapper.requestFullscreen) null == document.fullscreenElement ? videoWrapper.requestFullscreen() : document.exitFullscreen();
            else if ($3704c843920dcfc2$var$IS_IOS) this.getVideo().webkitEnterFullscreen();
            function toggleCtrl(shown) {
                if (shown === undefined) {
                    videoWrapper.classList.remove('PlayerControlsHidden');
                    $3704c843920dcfc2$var$shakaVideoContainer.classList.remove('PlayerControlsShown');
                } else if (shown) {
                    videoWrapper.classList.remove('PlayerControlsHidden');
                    $3704c843920dcfc2$var$shakaVideoContainer.classList.add('PlayerControlsShown');
                } else {
                    videoWrapper.classList.add('PlayerControlsHidden');
                    $3704c843920dcfc2$var$shakaVideoContainer.classList.remove('PlayerControlsShown');
                }
            }
            function toggleFullscreen(full) {
                if (full) {
                    videoWrapper.classList.add('PlayerFullScreen');
                    $3704c843920dcfc2$var$shakaVideoContainer.classList.add('PlayerFullScreen');
                } else {
                    videoWrapper.classList.remove('PlayerFullScreen');
                    $3704c843920dcfc2$var$shakaVideoContainer.classList.remove('PlayerFullScreen');
                }
            }
            function toggle() {
                if (!document.webkitFullscreenElement && !document.mozFullScreenElement && !document.msFullscreenElement && !document.fullscreenElement) {
                    toggleCtrl();
                    toggleFullscreen(false);
                    if (controlsFullscreenDelay) clearTimeout(controlsFullscreenDelay);
                    videoWrapper.removeEventListener('mousemove', playerMouseMove);
                    controlsWrapper.removeEventListener('mouseenter', controlsMouseEnter);
                    controlsWrapper.removeEventListener('mouseleave', controlsMouseLeave);
                } else {
                    toggleFullscreen(true);
                    videoWrapper.addEventListener('mousemove', playerMouseMove);
                    controlsWrapper.addEventListener('mouseenter', controlsMouseEnter);
                    controlsWrapper.addEventListener('mouseleave', controlsMouseLeave);
                }
            }
            videoWrapper.addEventListener('fullscreenchange', toggle);
            videoWrapper.addEventListener('mozfullscreenchange', toggle);
            videoWrapper.addEventListener('MSFullscreenChange', toggle);
            videoWrapper.addEventListener('webkitfullscreenchange', toggle);
        }
        initPlayer() {
            // Init the shaka player
            this.state.player = new $6jqaU.Player(this.getVideo());
            const ui = new $6jqaU.ui.Overlay(this.state.player, $3704c843920dcfc2$var$shakaVideoContainer, this.getVideo());
            this.ui = ui;
            // disable shaka native controls https://shaka-player-demo.appspot.com/docs/api/shaka.extern.html#.UIConfiguration
            ui.configure({
                controlPanelElements: [],
                overflowMenuButtons: [],
                contextMenuElements: [],
                addSeekBar: false
            });
            this.state.player.configure({
                abr: {
                    enabled: false
                },
                streaming: {
                    bufferBehind: $3704c843920dcfc2$var$BUFFERBEHIND,
                    bufferingGoal: $3704c843920dcfc2$var$BUFFERINGGOAL
                }
            });
            this.state.player.load(this.getMpdUrl()).catch(()=>{
                this.loadVideoOnly();
                if (!$3704c843920dcfc2$var$IS_IOS) {
                    const message = navigator.language.startsWith('fr') ? "Essayez de mettre \xe0 jour votre navigateur (Chrome, Edge, Firefox...) pour lire la vid\xe9o avec le son, sinon contactez-nous." : 'Please try updating your brwoser (Chrome, Edge, Firefox...) to play the video with Sound, otherwise contact us.';
                    this.warns(message);
                }
            }).then(()=>{
                this.loadVideo();
                sendEventToElm({
                    action: 'Added'
                });
            });
        }
        render() {
            this.initPlayer();
        }
    }
    customElements.define('noma-player', Nomaplayer);
}

});
parcelRegister("ffDwH", function(module, exports) {

$parcel$export(module.exports, "render", () => $8463e20461391507$export$b3890eb0ae9dca99);
function $8463e20461391507$export$b3890eb0ae9dca99(imageUrl) {
    return `<html>
<head>
  <title>Nomalab</title>                                                  
</head>
<body style="background:#555D68; text-align:center">
  <style>
    @keyframes anim_spin {
      from { transform: rotate(0deg); } 
      to { transform: rotate(359deg); }
    }
    span {
      font-family: Open Sans, Roboto,sans-serif;
      font-size:13px;
      font-weight: 500;
      color: #CFD1D5;
      display: block;
    }
    svg {
      animation: anim_spin 1s linear infinite;
      fill: #3BAAFF;
    }
    div {
      margin: 250px 0 0 0;
    }
  </style>
  <div id="nomalabSpinner">
    <svg height="40px" viewBox="0 0 40 40" width="40px">
      <g transform="translate(5, 9)">
        <path d="M15,0 C21.0751322,0 26,4.92486775 26,11 C26,17.0751322 21.0751322,22 15,22 C9.26195744,22 4.55007179,17.6065 4.04484302,12 L6.05492878,12 C6.55237307,16.4999505 10.3674463,20 15,20 C19.9705627,20 24,15.9705627 24,11 C24,6.02943725 19.9705627,2 15,2 L15,0 Z"/>
        <polygon points="5 6 10 12 0 12"/>
      </g>
    </svg>
    <span>Extraction en cours...</span>
  </div>
  <script>
    var i = document.createElement('img');
    var loadedCb = function () {
      window.nomalabSpinner.style.display = 'none';
      window.document.body.appendChild(i);
    };

    var errorCb = function (err) {
      document.querySelector('#nomalabSpinner svg').style.display = 'none';
      document.querySelector('#nomalabSpinner span').innerHTML = 'Une erreur est survenue. Merci de contacter notre service op\xe9rations via le chat ou par mail \xe0 ops@nomalab.com';
    };
    
    i.onload = loadedCb;
    i.onerror = errorCb;
    i.style = "width: 100%";
    
    // get url and then create IMAGE

    let myRequest = new Request('${imageUrl}');

    fetch(myRequest)
    .then(function(response) {
      if (!response.ok) {
        throw new Error(\`HTTP error! status: \${response.status}\`);
      }
      return response.text();
    })
    .then(function(imgUrl) {
      i.src = imgUrl;
    });

  </script>
  </body>
</html>`;
}

});

parcelRegister("kjMit", function(module, exports) {

$parcel$export(module.exports, "inputMaskTimecode", () => $aaf81a275793b52d$export$4bccd78e60fd0875);

var $eqZ8F = parcelRequire("eqZ8F");
function $aaf81a275793b52d$export$4bccd78e60fd0875(el, minFrame, maxFrame, frameRate, cb) {
    let savedTC = (0, $eqZ8F.Timecode).init({
        framerate: frameRate
    });
    let isEditing = false;
    function doNothing(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
    }
    function formatTC(value) {
        let segments = value.split(':').map((i)=>i.padStart(2, '0'));
        while(segments.length < 4)segments.unshift('00');
        return segments.join(':');
    }
    const numbers = [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9'
    ];
    const autorizedKeyCodes = [
        37,
        39,
        38,
        40,
        8,
        46
    ];
    function onFocus() {
        isEditing = true;
        savedTC = (0, $eqZ8F.Timecode).init({
            framerate: frameRate
        });
        savedTC.set(el.value);
    }
    function updateValue() {
        try {
            let nextTC = (0, $eqZ8F.Timecode).init({
                framerate: frameRate
            });
            nextTC.set(formatTC(el.value));
            if (minFrame > nextTC.frame_count) nextTC.set(minFrame);
            else if (maxFrame < nextTC.frame_count) nextTC.set(maxFrame);
            savedTC = nextTC;
            savedTC.timecodeToFrameNumber();
            cb(savedTC);
            el.value = savedTC.toString();
        } catch (e) {
            el.value = savedTC.toString();
        }
        isEditing = false;
    }
    function onKeyDown(e) {
        if (autorizedKeyCodes.includes(e.keyCode) || e.ctrlKey || e.metaKey) {
            e.stopImmediatePropagation();
            return true;
        } else if (e.keyCode == 13 || e.keyCode == 27) el.blur();
        else if (numbers.includes(e.key)) {
            let value = el.value;
            let position = el.selectionStart;
            let newChar = e.key;
            if (position) {
                let prevChar = parseInt(value.charAt(position - 1));
                let prev2Char = parseInt(value.charAt(position - 2));
                let nextChar = value.charAt(position);
                let notSelecting = position == el.selectionEnd;
                // Can't have more than 2 consecutive digits
                if (!isNaN(prev2Char) && !isNaN(prevChar)) doNothing(e);
                else if (!isNaN(prevChar) && nextChar != ':' && canHaveMoreSegments() && notSelecting) {
                    el.value = value.slice(0, position) + newChar + ':' + value.slice(position);
                    el.setSelectionRange(position + 2, position + 2);
                    doNothing(e);
                }
            }
        } else if (e.key == ':') {
            // limit to 3 colons ':'
            if (!canHaveMoreSegments()) return doNothing(e);
        } else return doNothing(e);
    }
    function canHaveMoreSegments() {
        return el.value.split(':').length < 4;
    }
    function setTc(tc) {
        if (isEditing) return;
        savedTC = tc;
        el.value = savedTC.toString();
    }
    function setTcFromFrame(frame) {
        if (isEditing) return;
        savedTC.setFrameNumberToTimecode(frame);
        el.value = savedTC.toString();
    }
    function init() {
        el.addEventListener('focus', onFocus);
        el.addEventListener('blur', updateValue);
        el.addEventListener('keydown', onKeyDown);
    }
    function destroy() {
        el.removeEventListener('focus', onFocus);
        el.removeEventListener('blur', updateValue);
        el.removeEventListener('keydown', onKeyDown);
    }
    init();
    return {
        destroy: destroy,
        setTc: setTc,
        setTcFromFrame: setTcFromFrame
    };
}

});
parcelRegister("eqZ8F", function(module, exports) {

$parcel$export(module.exports, "Timecode", () => $41342b85841ebc6f$export$c7bb7bfc56e79955);
if (typeof Object.create !== 'function') Object.create = function(o) {
    let F = function() {};
    F.prototype = o;
    return new F();
};
function $41342b85841ebc6f$var$getValueFromDict(dict, name, default_value) {
    if (dict.hasOwnProperty(name)) return dict[name];
    else return default_value;
}
const $41342b85841ebc6f$export$c7bb7bfc56e79955 = {
    framerate: '',
    intFramerate: 0,
    dropFrame: false,
    hours: 0,
    minutes: 0,
    seconds: 0,
    frames: 0,
    frameCount: 0,
    init: function(args) {
        let obj = Object.create(this);
        obj.framerate = $41342b85841ebc6f$var$getValueFromDict(args, 'framerate', '29.97');
        obj.intFramerate = obj.getIntFramerate();
        obj.dropFrame = $41342b85841ebc6f$var$getValueFromDict(args, 'drop_frame', false);
        obj.hours = false;
        obj.minutes = false;
        obj.seconds = false;
        obj.frames = false;
        obj.frameCount = false;
        obj.set($41342b85841ebc6f$var$getValueFromDict(args, 'timecode', 0));
        return obj;
    },
    getIntFramerate: function() {
        if (this.framerate === 'ms') return 1000;
        else return Math.round(parseFloat(this.framerate));
    },
    set: function(timecode) {
        if (typeof timecode === 'string') {
            this.partsFromString(timecode);
            this.timecodeToFrameNumber();
            this.frameNumberToTimecode();
        } else if (typeof timecode === 'number') {
            this.frameCount = timecode;
            this.frameNumberToTimecode();
        } else if (timecode instanceof Date) {
            this.frameCount = this.dateToFrameNumber(timecode);
            this.frameNumberToTimecode();
        }
    },
    partsFromString: function(timecode) {
        // Parses timecode strings non-drop 'hh:mm:ss:ff', drop 'hh:mm:ss;ff', or milliseconds 'hh:mm:ss:fff'
        if (timecode.length === 11) this.frames = parseInt(timecode.slice(9, 11));
        else if (timecode.length === 12 && this.framerate === 'ms') this.frames = parseInt(timecode.slice(9, 12));
        else throw new Error(`Timecode string parsing error. ${timecode}`);
        this.hours = parseInt(timecode.slice(0, 2));
        this.minutes = parseInt(timecode.slice(3, 5));
        this.seconds = parseInt(timecode.slice(6, 8));
    },
    frameNumberToTimecode: function() {
        // Converts frame_count to timecode
        let frame_count = this.frameCount;
        if (this.dropFrame) {
            let parts = this.frameNumberToDropFrameTimecode(frame_count);
            this.hours = parts[0];
            this.minutes = parts[1];
            this.seconds = parts[2];
            this.frames = parts[3];
        } else {
            this.hours = frame_count / (3600 * this.intFramerate);
            if (this.hours > 23) {
                this.hours = this.hours % 24;
                frame_count = frame_count - 82800 * this.intFramerate;
            }
            this.minutes = frame_count % (3600 * this.intFramerate) / (60 * this.intFramerate);
            this.seconds = frame_count % (3600 * this.intFramerate) % (60 * this.intFramerate) / this.intFramerate;
            this.frames = frame_count % (3600 * this.intFramerate) % (60 * this.intFramerate) % this.intFramerate;
            this.hours = Math.floor(this.hours);
            this.minutes = Math.floor(this.minutes);
            this.seconds = Math.floor(this.seconds);
            this.frames = Math.floor(this.frames);
        }
    },
    timecodeToFrameNumber: function() {
        // converts the current timecode to frame_count.
        if (this.dropFrame) this.frameCount = this.dropFrameTimecodeToFrameNumber([
            this.hours,
            this.minutes,
            this.seconds,
            this.frames
        ]);
        else this.frameCount = (this.hours * 3600 + this.minutes * 60 + this.seconds) * this.intFramerate + this.frames;
    },
    _calculate: function(sign, timecodes) {
        // all timecodes are calculated in place
        let frameCount;
        let timecode;
        for(let i = 0; i < timecodes.length; i += 1){
            // if a string, number or Date is given, convert it to a timecode
            if (typeof timecodes[i] === 'string' || typeof timecodes[i] === 'number' || timecodes[i] instanceof Date) timecode = $41342b85841ebc6f$export$c7bb7bfc56e79955.init({
                framerate: this.framerate,
                timecode: timecodes[i],
                drop_frame: this.dropFrame
            });
            else timecode = timecodes[i];
            // make sure this is a valid timecode
            if (timecode.frameCount) {
                if (timecode.framerate != this.framerate) throw new Error('Timecode framerates must match to do calculations.');
                if (sign === '-') frameCount = timecode.frameCount * -1;
                else if (sign === '+') frameCount = timecode.frameCount;
                else throw new Error('Expected sign to be + or -.');
                this.frameCount = this.frameCount + frameCount;
                this.frameNumberToTimecode();
            }
        }
    },
    add: function(args) {
        /*
        // This takes one or more Timecode objects as arguments
        // If this has been initialized, add to this, otherwise just add timecodes given.
        var timecodes = [];
        if (this.frameCount) {
            timecodes.push(this);
        }
        */ this._calculate('+', args);
    },
    subtract: function(args) {
        this._calculate('-', args);
    },
    toString: function() {
        const zeroPad = function(number) {
            const pad = number < 10 ? '0' : '';
            return pad + Math.floor(number);
        };
        const delim = this.dropFrame ? ';' : ':';
        return `${zeroPad(this.hours)}:${zeroPad(this.minutes)}:${zeroPad(this.seconds)}${delim}${zeroPad(this.frames)}`;
    },
    frameNumberToDropFrameTimecode: function(frameNumber) {
        const framerate = parseFloat(this.framerate);
        const drop_frames = Math.round(framerate * 0.066666);
        const frames_per_hour = Math.round(framerate * 3600);
        const frames_per_24_hours = frames_per_hour * 24;
        const frames_per_10_minutes = Math.round(framerate * 600);
        const frames_per_minute = Math.round(framerate * 60);
        // Roll over clock if greater than 24 hours
        frameNumber = frameNumber % frames_per_24_hours;
        // If time is negative, count back from 24 hours
        if (frameNumber < 0) frameNumber = frames_per_24_hours + frameNumber;
        const d = Math.floor(frameNumber / frames_per_10_minutes);
        const m = frameNumber % frames_per_10_minutes;
        if (m > drop_frames) frameNumber = frameNumber + drop_frames * 9 * d + drop_frames * Math.floor((m - drop_frames) / frames_per_minute);
        else frameNumber = frameNumber + drop_frames * 9 * d;
        return [
            Math.floor(Math.floor(Math.floor(frameNumber / this.intFramerate) / 60) / 60),
            Math.floor(Math.floor(frameNumber / this.intFramerate) / 60) % 60,
            Math.floor(frameNumber / this.intFramerate) % 60,
            frameNumber % this.intFramerate
        ];
    },
    setFrameNumberToTimecode: function(frameNumber) {
        const framerate = parseFloat(this.framerate);
        const frames_per_hour = Math.round(framerate * 3600);
        const frames_per_24_hours = frames_per_hour * 24;
        // Roll over clock if greater than 24 hours
        frameNumber = frameNumber % frames_per_24_hours;
        // If time is negative, count back from 24 hours
        if (frameNumber < 0) frameNumber = frames_per_24_hours + frameNumber;
        this.hours = Math.floor(Math.floor(Math.floor(frameNumber / this.intFramerate) / 60) / 60);
        this.minutes = Math.floor(Math.floor(frameNumber / this.intFramerate) / 60) % 60;
        this.seconds = Math.floor(frameNumber / this.intFramerate) % 60;
        this.frames = frameNumber % this.intFramerate;
        this.timecodeToFrameNumber();
    },
    dropFrameTimecodeToFrameNumber: function(timecodeAsList) {
        const [hours, minutes, seconds, frames] = timecodeAsList;
        const drop_frames = Math.round(parseFloat(this.framerate) * 0.066666);
        const hour_frames = this.intFramerate * 3600;
        const minute_frames = this.intFramerate * 60;
        const total_minutes = hours * 60 + minutes;
        const frame_number = hour_frames * hours + minute_frames * minutes + this.intFramerate * seconds + frames - drop_frames * (total_minutes - Math.floor(total_minutes / 10));
        return frame_number;
    },
    /**
     * Converts the hour, minute, second, millisecond part of Date() object to the number of
     * frames using the current framerate
     * @param dt {Date}
     * @returns {number}
     */ dateToFrameNumber: function(dt) {
        const midnight = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), 0, 0, 0);
        return Math.floor((dt.getTime() - midnight.getTime()) / 1000 * parseFloat(this.framerate));
    }
};

});


parcelRegister("8dcRR", function(module, exports) {
/* braille.js
 *
 * Read the frame number coded in braille code
 * from the given video element.
 * returns NaN if failures while decoding
 *
 * braille : VideoHtmlElement -> Integer
 */ module.exports = function() {
    const numberOfSymbols = 7;
    const width = 392;
    const height = 60;
    const symbolWidth = width / numberOfSymbols;
    const symbolHeight = height;
    const colorMedian = 125;
    var brailleCoordinates = [
        [
            1 / 4,
            1 / 6
        ],
        [
            3 / 4,
            1 / 6
        ],
        [
            1 / 4,
            0.5
        ],
        [
            3 / 4,
            0.5
        ],
        [
            1 / 4,
            5 / 6
        ],
        [
            3 / 4,
            5 / 6
        ]
    ];
    var braille1 = JSON.stringify([
        1,
        0,
        0,
        0,
        0,
        0
    ]);
    var braille2 = JSON.stringify([
        1,
        0,
        1,
        0,
        0,
        0
    ]);
    var braille3 = JSON.stringify([
        1,
        1,
        0,
        0,
        0,
        0
    ]);
    var braille4 = JSON.stringify([
        1,
        1,
        0,
        1,
        0,
        0
    ]);
    var braille5 = JSON.stringify([
        1,
        0,
        0,
        1,
        0,
        0
    ]);
    var braille6 = JSON.stringify([
        1,
        1,
        1,
        0,
        0,
        0
    ]);
    var braille7 = JSON.stringify([
        1,
        1,
        1,
        1,
        0,
        0
    ]);
    var braille8 = JSON.stringify([
        1,
        0,
        1,
        1,
        0,
        0
    ]);
    var braille9 = JSON.stringify([
        0,
        1,
        1,
        0,
        0,
        0
    ]);
    var braille0 = JSON.stringify([
        0,
        1,
        1,
        1,
        0,
        0
    ]);
    // Would be better to test for all rgb to be exactly 0
    // but it appears sometime the value will be 2 or 3 or 4
    // so we just check it is in the lower half of the color range
    // (aka below 255/2, nearly)
    function isBlack(rgba) {
        return rgba[0] < colorMedian && rgba[1] < colorMedian && rgba[2] < colorMedian;
    }
    function parse(video) {
        let decodeCanvas = document.createElement('canvas');
        decodeCanvas.width = width;
        decodeCanvas.height = height;
        decodeCanvas.crossorigin = "anonymous";
        let decodeContext = decodeCanvas.getContext('2d');
        let frameNumber = '';
        if (!video) return 0;
        // void ctx.drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight)
        // braille font width is 56, height is 60 and drawn in the upper-left corner of
        // the video. we render 7 characters on each frame, making the total width 392.
        // however the 56px width includes letter-spacing, the interesting part of
        // a braille character is only 50px, so we take that into a account when decoding
        // the character.
        decodeContext.drawImage(video, 0, 0, width, height, 0, 0, width, height);
        // iterate over braille characters
        for(var i = 0; i < numberOfSymbols; i++){
            let candidate = JSON.stringify(// map over braille dots
            brailleCoordinates.map(function(rationalDotCoords) {
                // those are the coordinates of the center-most pixel of
                // the braille dot we are currently decoding
                var x = 50 * rationalDotCoords[0] + symbolWidth * i;
                var y = rationalDotCoords[1] * symbolHeight;
                var pixelData = decodeContext.getImageData(x, y, 1, 1).data;
                return isBlack(pixelData) ? 0 : 1;
            }));
            let decoded;
            switch(candidate){
                case braille0:
                    decoded = '0';
                    break;
                case braille1:
                    decoded = '1';
                    break;
                case braille2:
                    decoded = '2';
                    break;
                case braille3:
                    decoded = '3';
                    break;
                case braille4:
                    decoded = '4';
                    break;
                case braille5:
                    decoded = '5';
                    break;
                case braille6:
                    decoded = '6';
                    break;
                case braille7:
                    decoded = '7';
                    break;
                case braille8:
                    decoded = '8';
                    break;
                case braille9:
                    decoded = '9';
                    break;
                // returning NaN if decode failed
                default:
                    decoded = 'oops';
            }
            frameNumber += decoded;
        }
        return parseInt(frameNumber, 10);
    }
    return parse;
}();

});

parcelRegister("gguoi", function(module, exports) {

$parcel$export(module.exports, "$", () => $bd75b6fa0b73898b$export$3d8c2f653ac9d0b9, (v) => $bd75b6fa0b73898b$export$3d8c2f653ac9d0b9 = v);
/*
 * common.js
 */ var $bd75b6fa0b73898b$export$3c32761ab67e1b40;
var $bd75b6fa0b73898b$export$1a44d2b340da8eb5;
var $bd75b6fa0b73898b$export$3d8c2f653ac9d0b9;
var $bd75b6fa0b73898b$export$fe324b23443c13e2;
var $bd75b6fa0b73898b$export$185802fd694ee1f5;
var $bd75b6fa0b73898b$export$af88d00dbe7f521;
var $bd75b6fa0b73898b$export$627d822bae211d52;
$bd75b6fa0b73898b$export$3c32761ab67e1b40 = '<svg height="18px" width="18px" viewBox="0 0 18 18" class="IconIcon18"><rect class="Bg" height="18" width="18" x="0" y="0"></rect><rect class="Fg" height="8" width="3" x="5" y="5"></rect><rect class="Fg" height="8" width="3" x="10" y="5"></rect></svg>';
$bd75b6fa0b73898b$export$1a44d2b340da8eb5 = '<svg height="18px" width="18px" viewBox="0 0 18 18" class="IconIcon18"><rect class="Bg" height="18" width="18" x="0" y="0"></rect><polygon class="Fg" points="6 5 12 9 6 13"></polygon></svg>';
$bd75b6fa0b73898b$export$3d8c2f653ac9d0b9 = function $(s, el) {
    return (el || window.document).querySelector(s);
};
$bd75b6fa0b73898b$export$fe324b23443c13e2 = function $$(s, el) {
    return (el || window.document).querySelectorAll(s);
};
$bd75b6fa0b73898b$export$185802fd694ee1f5 = function create(t) {
    return window.document.createElement(t);
};
$bd75b6fa0b73898b$export$af88d00dbe7f521 = function logger(msg) {
    if (window.NOMALAB_DEBUG_MODE) {
        let m = typeof msg == 'object' ? JSON.stringify(msg, null, 2) : msg;
        console.log('%c[NOMALAB DEBUG] ' + m);
    }
};
$bd75b6fa0b73898b$export$627d822bae211d52 = function fixSubtitlePosition(video) {
    if (!video.textTracks[0] || !video.textTracks[0].cues) {
        console.log(video.textTracks);
        return;
    }
    let l = video.textTracks[0].cues.length;
    for(let i = 0; i < l; i++){
        let cue = video.textTracks[0].cues[i];
        if (cue.line == 0) cue.line = 1;
        video.textTracks[0].cues[i] = cue;
    }
};

});

parcelRegister("6jqaU", function(module, exports) {
/*
 @license
 Shaka Player
 Copyright 2016 Google LLC
 SPDX-License-Identifier: Apache-2.0
*/ (function() {
    var innerGlobal = typeof window != "undefined" ? window : $parcel$global;
    var exportTo = {};
    (function(window1, global1, module) {
        var p, aa = typeof Object.create == "function" ? Object.create : function(a) {
            function b() {}
            b.prototype = a;
            return new b;
        }, ba = typeof Object.defineProperties == "function" ? Object.defineProperty : function(a, b, c) {
            if (a == Array.prototype || a == Object.prototype) return a;
            a[b] = c.value;
            return a;
        };
        function ca(a) {
            a = [
                "object" == typeof globalThis && globalThis,
                a,
                "object" == typeof window1 && window1,
                "object" == typeof self && self,
                "object" == typeof global1 && global1
            ];
            for(var b = 0; b < a.length; ++b){
                var c = a[b];
                if (c && c.Math == Math) return c;
            }
            throw Error("Cannot find global object");
        }
        var da = ca(this);
        function ea(a, b) {
            if (b) a: {
                var c = da;
                a = a.split(".");
                for(var d = 0; d < a.length - 1; d++){
                    var e = a[d];
                    if (!(e in c)) break a;
                    c = c[e];
                }
                a = a[a.length - 1];
                d = c[a];
                b = b(d);
                b != d && b != null && ba(c, a, {
                    configurable: !0,
                    writable: !0,
                    value: b
                });
            }
        }
        var fa;
        if (typeof Object.setPrototypeOf == "function") fa = Object.setPrototypeOf;
        else {
            var ha;
            a: {
                var ia = {
                    a: !0
                }, ja = {};
                try {
                    ja.__proto__ = ia;
                    ha = ja.a;
                    break a;
                } catch (a) {}
                ha = !1;
            }
            fa = ha ? function(a, b) {
                a.__proto__ = b;
                if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
                return a;
            } : null;
        }
        var ka = fa;
        function la(a, b) {
            a.prototype = aa(b.prototype);
            a.prototype.constructor = a;
            if (ka) ka(a, b);
            else for(var c in b)if (c != "prototype") {
                if (Object.defineProperties) {
                    var d = Object.getOwnPropertyDescriptor(b, c);
                    d && Object.defineProperty(a, c, d);
                } else a[c] = b[c];
            }
            a.Yn = b.prototype;
        }
        function ma(a) {
            var b = 0;
            return function() {
                return b < a.length ? {
                    done: !1,
                    value: a[b++]
                } : {
                    done: !0
                };
            };
        }
        function u(a) {
            var b = typeof Symbol != "undefined" && Symbol.iterator && a[Symbol.iterator];
            if (b) return b.call(a);
            if (typeof a.length == "number") return {
                next: ma(a)
            };
            throw Error(String(a) + " is not an iterable or ArrayLike");
        }
        function x(a) {
            if (!(a instanceof Array)) {
                a = u(a);
                for(var b, c = []; !(b = a.next()).done;)c.push(b.value);
                a = c;
            }
            return a;
        }
        ea("Symbol", function(a) {
            function b(f) {
                if (this instanceof b) throw new TypeError("Symbol is not a constructor");
                return new c(d + (f || "") + "_" + e++, f);
            }
            function c(f, g) {
                this.g = f;
                ba(this, "description", {
                    configurable: !0,
                    writable: !0,
                    value: g
                });
            }
            if (a) return a;
            c.prototype.toString = function() {
                return this.g;
            };
            var d = "jscomp_symbol_" + (Math.random() * 1E9 >>> 0) + "_", e = 0;
            return b;
        });
        ea("Symbol.iterator", function(a) {
            if (a) return a;
            a = Symbol("Symbol.iterator");
            for(var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++){
                var d = da[b[c]];
                typeof d === "function" && typeof d.prototype[a] != "function" && ba(d.prototype, a, {
                    configurable: !0,
                    writable: !0,
                    value: function() {
                        return na(ma(this));
                    }
                });
            }
            return a;
        });
        function na(a) {
            a = {
                next: a
            };
            a[Symbol.iterator] = function() {
                return this;
            };
            return a;
        }
        function oa() {
            this.u = !1;
            this.l = null;
            this.h = void 0;
            this.g = 1;
            this.j = this.m = 0;
            this.C = this.i = null;
        }
        function pa(a) {
            if (a.u) throw new TypeError("Generator is already running");
            a.u = !0;
        }
        oa.prototype.A = function(a) {
            this.h = a;
        };
        function qa(a, b) {
            a.i = {
                Ui: b,
                gj: !0
            };
            a.g = a.m || a.j;
        }
        oa.prototype.return = function(a) {
            this.i = {
                return: a
            };
            this.g = this.j;
        };
        function F(a, b, c) {
            a.g = c;
            return {
                value: b
            };
        }
        oa.prototype.B = function(a) {
            this.g = a;
        };
        function H(a) {
            a.g = 0;
        }
        function ra(a, b, c) {
            a.m = b;
            c != void 0 && (a.j = c);
        }
        function sa(a, b) {
            a.m = 0;
            a.j = b || 0;
        }
        function ta(a, b, c) {
            a.g = b;
            a.m = c || 0;
        }
        function ua(a, b) {
            a.m = b || 0;
            b = a.i.Ui;
            a.i = null;
            return b;
        }
        function va(a) {
            a.C = [
                a.i
            ];
            a.m = 0;
            a.j = 0;
        }
        function xa(a, b) {
            var c = a.C.splice(0)[0];
            (c = a.i = a.i || c) ? c.gj ? a.g = a.m || a.j : c.B != void 0 && a.j < c.B ? (a.g = c.B, a.i = null) : a.g = a.j : a.g = b;
        }
        function ya(a) {
            this.g = new oa;
            this.h = a;
        }
        function Ba(a, b) {
            pa(a.g);
            var c = a.g.l;
            if (c) return Ga(a, "return" in c ? c["return"] : function(d) {
                return {
                    value: d,
                    done: !0
                };
            }, b, a.g.return);
            a.g.return(b);
            return Ha(a);
        }
        function Ga(a, b, c, d) {
            try {
                var e = b.call(a.g.l, c);
                if (!(e instanceof Object)) throw new TypeError("Iterator result " + e + " is not an object");
                if (!e.done) return a.g.u = !1, e;
                var f = e.value;
            } catch (g) {
                return a.g.l = null, qa(a.g, g), Ha(a);
            }
            a.g.l = null;
            d.call(a.g, f);
            return Ha(a);
        }
        function Ha(a) {
            for(; a.g.g;)try {
                var b = a.h(a.g);
                if (b) return a.g.u = !1, {
                    value: b.value,
                    done: !1
                };
            } catch (c) {
                a.g.h = void 0, qa(a.g, c);
            }
            a.g.u = !1;
            if (a.g.i) {
                b = a.g.i;
                a.g.i = null;
                if (b.gj) throw b.Ui;
                return {
                    value: b.return,
                    done: !0
                };
            }
            return {
                value: void 0,
                done: !0
            };
        }
        function Ia(a) {
            this.next = function(b) {
                pa(a.g);
                a.g.l ? b = Ga(a, a.g.l.next, b, a.g.A) : (a.g.A(b), b = Ha(a));
                return b;
            };
            this.throw = function(b) {
                pa(a.g);
                a.g.l ? b = Ga(a, a.g.l["throw"], b, a.g.A) : (qa(a.g, b), b = Ha(a));
                return b;
            };
            this.return = function(b) {
                return Ba(a, b);
            };
            this[Symbol.iterator] = function() {
                return this;
            };
        }
        function Ja(a) {
            function b(d) {
                return a.next(d);
            }
            function c(d) {
                return a.throw(d);
            }
            return new Promise(function(d, e) {
                function f(g) {
                    g.done ? d(g.value) : Promise.resolve(g.value).then(b, c).then(f, e);
                }
                f(a.next());
            });
        }
        function Q(a) {
            return Ja(new Ia(new ya(a)));
        }
        function Ma() {
            for(var a = Number(this), b = [], c = a; c < arguments.length; c++)b[c - a] = arguments[c];
            return b;
        }
        ea("Promise", function(a) {
            function b(g) {
                this.h = 0;
                this.i = void 0;
                this.g = [];
                this.u = !1;
                var h = this.j();
                try {
                    g(h.resolve, h.reject);
                } catch (k) {
                    h.reject(k);
                }
            }
            function c() {
                this.g = null;
            }
            function d(g) {
                return g instanceof b ? g : new b(function(h) {
                    h(g);
                });
            }
            if (a) return a;
            c.prototype.h = function(g) {
                if (this.g == null) {
                    this.g = [];
                    var h = this;
                    this.i(function() {
                        h.l();
                    });
                }
                this.g.push(g);
            };
            var e = da.setTimeout;
            c.prototype.i = function(g) {
                e(g, 0);
            };
            c.prototype.l = function() {
                for(; this.g && this.g.length;){
                    var g = this.g;
                    this.g = [];
                    for(var h = 0; h < g.length; ++h){
                        var k = g[h];
                        g[h] = null;
                        try {
                            k();
                        } catch (l) {
                            this.j(l);
                        }
                    }
                }
                this.g = null;
            };
            c.prototype.j = function(g) {
                this.i(function() {
                    throw g;
                });
            };
            b.prototype.j = function() {
                function g(l) {
                    return function(m) {
                        k || (k = !0, l.call(h, m));
                    };
                }
                var h = this, k = !1;
                return {
                    resolve: g(this.G),
                    reject: g(this.l)
                };
            };
            b.prototype.G = function(g) {
                if (g === this) this.l(new TypeError("A Promise cannot resolve to itself"));
                else if (g instanceof b) this.I(g);
                else {
                    a: switch(typeof g){
                        case "object":
                            var h = g != null;
                            break a;
                        case "function":
                            h = !0;
                            break a;
                        default:
                            h = !1;
                    }
                    h ? this.F(g) : this.m(g);
                }
            };
            b.prototype.F = function(g) {
                var h = void 0;
                try {
                    h = g.then;
                } catch (k) {
                    this.l(k);
                    return;
                }
                typeof h == "function" ? this.J(h, g) : this.m(g);
            };
            b.prototype.l = function(g) {
                this.A(2, g);
            };
            b.prototype.m = function(g) {
                this.A(1, g);
            };
            b.prototype.A = function(g, h) {
                if (this.h != 0) throw Error("Cannot settle(" + g + ", " + h + "): Promise already settled in state" + this.h);
                this.h = g;
                this.i = h;
                this.h === 2 && this.H();
                this.C();
            };
            b.prototype.H = function() {
                var g = this;
                e(function() {
                    if (g.D()) {
                        var h = da.console;
                        typeof h !== "undefined" && h.error(g.i);
                    }
                }, 1);
            };
            b.prototype.D = function() {
                if (this.u) return !1;
                var g = da.CustomEvent, h = da.Event, k = da.dispatchEvent;
                if (typeof k === "undefined") return !0;
                typeof g === "function" ? g = new g("unhandledrejection", {
                    cancelable: !0
                }) : typeof h === "function" ? g = new h("unhandledrejection", {
                    cancelable: !0
                }) : (g = da.document.createEvent("CustomEvent"), g.initCustomEvent("unhandledrejection", !1, !0, g));
                g.promise = this;
                g.reason = this.i;
                return k(g);
            };
            b.prototype.C = function() {
                if (this.g != null) {
                    for(var g = 0; g < this.g.length; ++g)f.h(this.g[g]);
                    this.g = null;
                }
            };
            var f = new c;
            b.prototype.I = function(g) {
                var h = this.j();
                g.kf(h.resolve, h.reject);
            };
            b.prototype.J = function(g, h) {
                var k = this.j();
                try {
                    g.call(h, k.resolve, k.reject);
                } catch (l) {
                    k.reject(l);
                }
            };
            b.prototype.then = function(g, h) {
                function k(q, r) {
                    return typeof q == "function" ? function(t) {
                        try {
                            l(q(t));
                        } catch (w) {
                            m(w);
                        }
                    } : r;
                }
                var l, m, n = new b(function(q, r) {
                    l = q;
                    m = r;
                });
                this.kf(k(g, l), k(h, m));
                return n;
            };
            b.prototype.catch = function(g) {
                return this.then(void 0, g);
            };
            b.prototype.kf = function(g, h) {
                function k() {
                    switch(l.h){
                        case 1:
                            g(l.i);
                            break;
                        case 2:
                            h(l.i);
                            break;
                        default:
                            throw Error("Unexpected state: " + l.h);
                    }
                }
                var l = this;
                this.g == null ? f.h(k) : this.g.push(k);
                this.u = !0;
            };
            b.resolve = d;
            b.reject = function(g) {
                return new b(function(h, k) {
                    k(g);
                });
            };
            b.race = function(g) {
                return new b(function(h, k) {
                    for(var l = u(g), m = l.next(); !m.done; m = l.next())d(m.value).kf(h, k);
                });
            };
            b.all = function(g) {
                var h = u(g), k = h.next();
                return k.done ? d([]) : new b(function(l, m) {
                    function n(t) {
                        return function(w) {
                            q[t] = w;
                            r--;
                            r == 0 && l(q);
                        };
                    }
                    var q = [], r = 0;
                    do q.push(void 0), r++, d(k.value).kf(n(q.length - 1), m), k = h.next();
                    while (!k.done);
                });
            };
            return b;
        });
        function Oa(a, b) {
            return Object.prototype.hasOwnProperty.call(a, b);
        }
        ea("WeakMap", function(a) {
            function b(k) {
                this.g = (h += Math.random() + 1).toString();
                if (k) {
                    k = u(k);
                    for(var l; !(l = k.next()).done;)l = l.value, this.set(l[0], l[1]);
                }
            }
            function c() {}
            function d(k) {
                var l = typeof k;
                return l === "object" && k !== null || l === "function";
            }
            function e(k) {
                if (!Oa(k, g)) {
                    var l = new c;
                    ba(k, g, {
                        value: l
                    });
                }
            }
            function f(k) {
                var l = Object[k];
                l && (Object[k] = function(m) {
                    if (m instanceof c) return m;
                    Object.isExtensible(m) && e(m);
                    return l(m);
                });
            }
            if (function() {
                if (!a || !Object.seal) return !1;
                try {
                    var k = Object.seal({}), l = Object.seal({}), m = new a([
                        [
                            k,
                            2
                        ],
                        [
                            l,
                            3
                        ]
                    ]);
                    if (m.get(k) != 2 || m.get(l) != 3) return !1;
                    m.delete(k);
                    m.set(l, 4);
                    return !m.has(k) && m.get(l) == 4;
                } catch (n) {
                    return !1;
                }
            }()) return a;
            var g = "$jscomp_hidden_" + Math.random();
            f("freeze");
            f("preventExtensions");
            f("seal");
            var h = 0;
            b.prototype.set = function(k, l) {
                if (!d(k)) throw Error("Invalid WeakMap key");
                e(k);
                if (!Oa(k, g)) throw Error("WeakMap key fail: " + k);
                k[g][this.g] = l;
                return this;
            };
            b.prototype.get = function(k) {
                return d(k) && Oa(k, g) ? k[g][this.g] : void 0;
            };
            b.prototype.has = function(k) {
                return d(k) && Oa(k, g) && Oa(k[g], this.g);
            };
            b.prototype.delete = function(k) {
                return d(k) && Oa(k, g) && Oa(k[g], this.g) ? delete k[g][this.g] : !1;
            };
            return b;
        });
        ea("Map", function(a) {
            function b() {
                var h = {};
                return h.Gc = h.next = h.head = h;
            }
            function c(h, k) {
                var l = h[1];
                return na(function() {
                    if (l) {
                        for(; l.head != h[1];)l = l.Gc;
                        for(; l.next != l.head;)return l = l.next, {
                            done: !1,
                            value: k(l)
                        };
                        l = null;
                    }
                    return {
                        done: !0,
                        value: void 0
                    };
                });
            }
            function d(h, k) {
                var l = k && typeof k;
                l == "object" || l == "function" ? f.has(k) ? l = f.get(k) : (l = "" + ++g, f.set(k, l)) : l = "p_" + k;
                var m = h[0][l];
                if (m && Oa(h[0], l)) for(h = 0; h < m.length; h++){
                    var n = m[h];
                    if (k !== k && n.key !== n.key || k === n.key) return {
                        id: l,
                        list: m,
                        index: h,
                        entry: n
                    };
                }
                return {
                    id: l,
                    list: m,
                    index: -1,
                    entry: void 0
                };
            }
            function e(h) {
                this[0] = {};
                this[1] = b();
                this.size = 0;
                if (h) {
                    h = u(h);
                    for(var k; !(k = h.next()).done;)k = k.value, this.set(k[0], k[1]);
                }
            }
            if (function() {
                if (!a || typeof a != "function" || !a.prototype.entries || typeof Object.seal != "function") return !1;
                try {
                    var h = Object.seal({
                        x: 4
                    }), k = new a(u([
                        [
                            h,
                            "s"
                        ]
                    ]));
                    if (k.get(h) != "s" || k.size != 1 || k.get({
                        x: 4
                    }) || k.set({
                        x: 4
                    }, "t") != k || k.size != 2) return !1;
                    var l = k.entries(), m = l.next();
                    if (m.done || m.value[0] != h || m.value[1] != "s") return !1;
                    m = l.next();
                    return m.done || m.value[0].x != 4 || m.value[1] != "t" || !l.next().done ? !1 : !0;
                } catch (n) {
                    return !1;
                }
            }()) return a;
            var f = new WeakMap;
            e.prototype.set = function(h, k) {
                h = h === 0 ? 0 : h;
                var l = d(this, h);
                l.list || (l.list = this[0][l.id] = []);
                l.entry ? l.entry.value = k : (l.entry = {
                    next: this[1],
                    Gc: this[1].Gc,
                    head: this[1],
                    key: h,
                    value: k
                }, l.list.push(l.entry), this[1].Gc.next = l.entry, this[1].Gc = l.entry, this.size++);
                return this;
            };
            e.prototype.delete = function(h) {
                h = d(this, h);
                return h.entry && h.list ? (h.list.splice(h.index, 1), h.list.length || delete this[0][h.id], h.entry.Gc.next = h.entry.next, h.entry.next.Gc = h.entry.Gc, h.entry.head = null, this.size--, !0) : !1;
            };
            e.prototype.clear = function() {
                this[0] = {};
                this[1] = this[1].Gc = b();
                this.size = 0;
            };
            e.prototype.has = function(h) {
                return !!d(this, h).entry;
            };
            e.prototype.get = function(h) {
                return (h = d(this, h).entry) && h.value;
            };
            e.prototype.entries = function() {
                return c(this, function(h) {
                    return [
                        h.key,
                        h.value
                    ];
                });
            };
            e.prototype.keys = function() {
                return c(this, function(h) {
                    return h.key;
                });
            };
            e.prototype.values = function() {
                return c(this, function(h) {
                    return h.value;
                });
            };
            e.prototype.forEach = function(h, k) {
                for(var l = this.entries(), m; !(m = l.next()).done;)m = m.value, h.call(k, m[1], m[0], this);
            };
            e.prototype[Symbol.iterator] = e.prototype.entries;
            var g = 0;
            return e;
        });
        function Pa(a, b) {
            a instanceof String && (a += "");
            var c = 0, d = !1, e = {
                next: function() {
                    if (!d && c < a.length) {
                        var f = c++;
                        return {
                            value: b(f, a[f]),
                            done: !1
                        };
                    }
                    d = !0;
                    return {
                        done: !0,
                        value: void 0
                    };
                }
            };
            e[Symbol.iterator] = function() {
                return e;
            };
            return e;
        }
        ea("Array.prototype.keys", function(a) {
            return a ? a : function() {
                return Pa(this, function(b) {
                    return b;
                });
            };
        });
        ea("Set", function(a) {
            function b(c) {
                this.g = new Map;
                if (c) {
                    c = u(c);
                    for(var d; !(d = c.next()).done;)this.add(d.value);
                }
                this.size = this.g.size;
            }
            if (function() {
                if (!a || typeof a != "function" || !a.prototype.entries || typeof Object.seal != "function") return !1;
                try {
                    var c = Object.seal({
                        x: 4
                    }), d = new a(u([
                        c
                    ]));
                    if (!d.has(c) || d.size != 1 || d.add(c) != d || d.size != 1 || d.add({
                        x: 4
                    }) != d || d.size != 2) return !1;
                    var e = d.entries(), f = e.next();
                    if (f.done || f.value[0] != c || f.value[1] != c) return !1;
                    f = e.next();
                    return f.done || f.value[0] == c || f.value[0].x != 4 || f.value[1] != f.value[0] ? !1 : e.next().done;
                } catch (g) {
                    return !1;
                }
            }()) return a;
            b.prototype.add = function(c) {
                c = c === 0 ? 0 : c;
                this.g.set(c, c);
                this.size = this.g.size;
                return this;
            };
            b.prototype.delete = function(c) {
                c = this.g.delete(c);
                this.size = this.g.size;
                return c;
            };
            b.prototype.clear = function() {
                this.g.clear();
                this.size = 0;
            };
            b.prototype.has = function(c) {
                return this.g.has(c);
            };
            b.prototype.entries = function() {
                return this.g.entries();
            };
            b.prototype.values = function() {
                return this.g.values();
            };
            b.prototype.keys = b.prototype.values;
            b.prototype[Symbol.iterator] = b.prototype.values;
            b.prototype.forEach = function(c, d) {
                var e = this;
                this.g.forEach(function(f) {
                    return c.call(d, f, f, e);
                });
            };
            return b;
        });
        ea("Array.prototype.values", function(a) {
            return a ? a : function() {
                return Pa(this, function(b, c) {
                    return c;
                });
            };
        });
        ea("Array.from", function(a) {
            return a ? a : function(b, c, d) {
                c = c != null ? c : function(h) {
                    return h;
                };
                var e = [], f = typeof Symbol != "undefined" && Symbol.iterator && b[Symbol.iterator];
                if (typeof f == "function") {
                    b = f.call(b);
                    for(var g = 0; !(f = b.next()).done;)e.push(c.call(d, f.value, g++));
                } else for(f = b.length, g = 0; g < f; g++)e.push(c.call(d, b[g], g));
                return e;
            };
        });
        ea("Object.is", function(a) {
            return a ? a : function(b, c) {
                return b === c ? b !== 0 || 1 / b === 1 / c : b !== b && c !== c;
            };
        });
        ea("Array.prototype.includes", function(a) {
            return a ? a : function(b, c) {
                var d = this;
                d instanceof String && (d = String(d));
                var e = d.length;
                c = c || 0;
                for(c < 0 && (c = Math.max(c + e, 0)); c < e; c++){
                    var f = d[c];
                    if (f === b || Object.is(f, b)) return !0;
                }
                return !1;
            };
        });
        function Qa(a, b, c) {
            if (a == null) throw new TypeError("The 'this' value for String.prototype." + c + " must not be null or undefined");
            if (b instanceof RegExp) throw new TypeError("First argument to String.prototype." + c + " must not be a regular expression");
            return a + "";
        }
        ea("String.prototype.includes", function(a) {
            return a ? a : function(b, c) {
                return Qa(this, b, "includes").indexOf(b, c || 0) !== -1;
            };
        });
        ea("String.fromCodePoint", function(a) {
            return a ? a : function(b) {
                for(var c = "", d = 0; d < arguments.length; d++){
                    var e = Number(arguments[d]);
                    if (e < 0 || e > 1114111 || e !== Math.floor(e)) throw new RangeError("invalid_code_point " + e);
                    e <= 65535 ? c += String.fromCharCode(e) : (e -= 65536, c += String.fromCharCode(e >>> 10 & 1023 | 55296), c += String.fromCharCode(e & 1023 | 56320));
                }
                return c;
            };
        });
        function Ra(a, b, c) {
            a instanceof String && (a = String(a));
            for(var d = a.length, e = 0; e < d; e++){
                var f = a[e];
                if (b.call(c, f, e, a)) return {
                    cj: e,
                    v: f
                };
            }
            return {
                cj: -1,
                v: void 0
            };
        }
        ea("Array.prototype.findIndex", function(a) {
            return a ? a : function(b, c) {
                return Ra(this, b, c).cj;
            };
        });
        ea("WeakSet", function(a) {
            function b(c) {
                this.g = new WeakMap;
                if (c) {
                    c = u(c);
                    for(var d; !(d = c.next()).done;)this.add(d.value);
                }
            }
            if (function() {
                if (!a || !Object.seal) return !1;
                try {
                    var c = Object.seal({}), d = Object.seal({}), e = new a([
                        c
                    ]);
                    if (!e.has(c) || e.has(d)) return !1;
                    e.delete(c);
                    e.add(d);
                    return !e.has(c) && e.has(d);
                } catch (f) {
                    return !1;
                }
            }()) return a;
            b.prototype.add = function(c) {
                this.g.set(c, !0);
                return this;
            };
            b.prototype.has = function(c) {
                return this.g.has(c);
            };
            b.prototype.delete = function(c) {
                return this.g.delete(c);
            };
            return b;
        });
        ea("Array.prototype.find", function(a) {
            return a ? a : function(b, c) {
                return Ra(this, b, c).v;
            };
        });
        ea("String.prototype.startsWith", function(a) {
            return a ? a : function(b, c) {
                var d = Qa(this, b, "startsWith"), e = d.length, f = b.length;
                c = Math.max(0, Math.min(c | 0, d.length));
                for(var g = 0; g < f && c < e;)if (d[c++] != b[g++]) return !1;
                return g >= f;
            };
        });
        ea("Object.entries", function(a) {
            return a ? a : function(b) {
                var c = [], d;
                for(d in b)Oa(b, d) && c.push([
                    d,
                    b[d]
                ]);
                return c;
            };
        });
        var Sa = typeof Object.assign == "function" ? Object.assign : function(a, b) {
            for(var c = 1; c < arguments.length; c++){
                var d = arguments[c];
                if (d) for(var e in d)Oa(d, e) && (a[e] = d[e]);
            }
            return a;
        };
        ea("Object.assign", function(a) {
            return a || Sa;
        });
        ea("Promise.prototype.finally", function(a) {
            return a ? a : function(b) {
                return this.then(function(c) {
                    return Promise.resolve(b()).then(function() {
                        return c;
                    });
                }, function(c) {
                    return Promise.resolve(b()).then(function() {
                        throw c;
                    });
                });
            };
        });
        ea("Array.prototype.entries", function(a) {
            return a ? a : function() {
                return Pa(this, function(b, c) {
                    return [
                        b,
                        c
                    ];
                });
            };
        });
        ea("Number.isNaN", function(a) {
            return a ? a : function(b) {
                return typeof b === "number" && isNaN(b);
            };
        });
        ea("String.prototype.repeat", function(a) {
            return a ? a : function(b) {
                var c = Qa(this, null, "repeat");
                if (b < 0 || b > 1342177279) throw new RangeError("Invalid count value");
                b |= 0;
                for(var d = ""; b;)if (b & 1 && (d += c), b >>>= 1) c += c;
                return d;
            };
        });
        ea("Number.EPSILON", function() {
            return 2.220446049250313E-16;
        });
        ea("Number.MAX_SAFE_INTEGER", function() {
            return 9007199254740991;
        });
        ea("Number.isFinite", function(a) {
            return a ? a : function(b) {
                return typeof b !== "number" ? !1 : !isNaN(b) && b !== Infinity && b !== -Infinity;
            };
        });
        ea("Object.values", function(a) {
            return a ? a : function(b) {
                var c = [], d;
                for(d in b)Oa(b, d) && c.push(b[d]);
                return c;
            };
        });
        ea("Math.log2", function(a) {
            return a ? a : function(b) {
                return Math.log(b) / Math.LN2;
            };
        });
        ea("String.prototype.endsWith", function(a) {
            return a ? a : function(b, c) {
                var d = Qa(this, b, "endsWith");
                c === void 0 && (c = d.length);
                c = Math.max(0, Math.min(c | 0, d.length));
                for(var e = b.length; e > 0 && c > 0;)if (d[--c] != b[--e]) return !1;
                return e <= 0;
            };
        });
        ea("Math.trunc", function(a) {
            return a ? a : function(b) {
                b = Number(b);
                if (isNaN(b) || b === Infinity || b === -Infinity || b === 0) return b;
                var c = Math.floor(Math.abs(b));
                return b < 0 ? -c : c;
            };
        });
        function Ta(a) {
            a = Math.trunc(a) || 0;
            a < 0 && (a += this.length);
            if (!(a < 0 || a >= this.length)) return this[a];
        }
        ea("Array.prototype.at", function(a) {
            return a ? a : Ta;
        });
        function Ua(a) {
            return a ? a : Ta;
        }
        ea("Int8Array.prototype.at", Ua);
        ea("Uint8Array.prototype.at", Ua);
        ea("Uint8ClampedArray.prototype.at", Ua);
        ea("Int16Array.prototype.at", Ua);
        ea("Uint16Array.prototype.at", Ua);
        ea("Int32Array.prototype.at", Ua);
        ea("Uint32Array.prototype.at", Ua);
        ea("Float32Array.prototype.at", Ua);
        ea("Float64Array.prototype.at", Ua);
        ea("String.prototype.at", function(a) {
            return a ? a : Ta;
        });
        var Va = this || self;
        function S(a, b) {
            a = a.split(".");
            var c = Va;
            a[0] in c || typeof c.execScript == "undefined" || c.execScript("var " + a[0]);
            for(var d; a.length && (d = a.shift());)a.length || b === void 0 ? c[d] && c[d] !== Object.prototype[d] ? c = c[d] : c = c[d] = {} : c[d] = b;
        }
        function T(a, b) {
            if (b) {
                if (b instanceof Map) for(var c = u(b.keys()), d = c.next(); !d.done; d = c.next())d = d.value, Object.defineProperty(this, d, {
                    value: b.get(d),
                    writable: !0,
                    enumerable: !0
                });
                else for(c in b)Object.defineProperty(this, c, {
                    value: b[c],
                    writable: !0,
                    enumerable: !0
                });
            }
            this.defaultPrevented = this.cancelable = this.bubbles = !1;
            this.timeStamp = window1.performance && window1.performance.now ? window1.performance.now() : Date.now();
            this.type = a;
            this.isTrusted = !1;
            this.target = this.currentTarget = null;
            this.g = !1;
        }
        function Xa(a) {
            var b = new T(a.type), c;
            for(c in a)Object.defineProperty(b, c, {
                value: a[c],
                writable: !0,
                enumerable: !0
            });
            return b;
        }
        T.prototype.preventDefault = function() {
            this.cancelable && (this.defaultPrevented = !0);
        };
        T.prototype.stopImmediatePropagation = function() {
            this.g = !0;
        };
        T.prototype.stopPropagation = function() {};
        S("shaka.util.FakeEvent", T);
        var Ya = {
            Im: "abrstatuschanged",
            Jm: "adaptation",
            Km: "audiotrackchanged",
            Lm: "audiotrackschanged",
            Mm: "boundarycrossed",
            Nm: "buffering",
            Om: "canupdatestarttime",
            Pm: "complete",
            Qm: "currentitemchanged",
            Rm: "downloadcompleted",
            Sm: "downloadfailed",
            Tm: "downloadheadersreceived",
            Um: "drmsessionupdate",
            Wm: "emsg",
            cn: "itemsinserted",
            dn: "itemsremoved",
            xn: "prft",
            Error: "error",
            Xm: "expirationupdated",
            Ym: "firstquartile",
            Zm: "gapjumped",
            fn: "keystatuschanged",
            ln: "loaded",
            mn: "loading",
            on: "manifestparsed",
            pn: "manifestupdated",
            qn: "mediaqualitychanged",
            rn: "mediasourcerecovered",
            tn: "metadataadded",
            Metadata: "metadata",
            un: "midpoint",
            vn: "nospatialvideoinfo",
            wn: "onstatechange",
            yn: "ratechange",
            Bn: "segmentappended",
            Cn: "sessiondata",
            Dn: "spatialvideoinfo",
            En: "stalldetected",
            Fn: "started",
            Gn: "statechanged",
            Hn: "streaming",
            In: "textchanged",
            Jn: "texttrackvisibility",
            Kn: "thirdquartile",
            Ln: "timelineregionadded",
            Mn: "timelineregionenter",
            Nn: "timelineregionexit",
            On: "trackschanged",
            Qn: "unloading",
            Sn: "variantchanged"
        };
        function Za() {}
        function $a() {}
        function ab() {}
        function bb(a) {
            var b = Ma.apply(1, arguments);
            cb.has(a) || (cb.add(a), ab.apply(Za, x(b)));
        }
        function db() {}
        function eb() {}
        function fb() {}
        var cb = new Set;
        window1.console && ((new Map).set(1, function() {
            return console.error.apply(console, x(Ma.apply(0, arguments)));
        }).set(2, function() {
            return console.warn.apply(console, x(Ma.apply(0, arguments)));
        }).set(3, function() {
            return console.info.apply(console, x(Ma.apply(0, arguments)));
        }).set(4, function() {
            return console.log.apply(console, x(Ma.apply(0, arguments)));
        }).set(5, function() {
            return console.debug.apply(console, x(Ma.apply(0, arguments)));
        }).set(6, function() {
            return console.debug.apply(console, x(Ma.apply(0, arguments)));
        }), ab = function() {
            return console.warn.apply(console, x(Ma.apply(0, arguments)));
        }, $a = function() {
            console.error.apply(console, x(Ma.apply(0, arguments)));
        });
        function hb() {
            this.g = new Map;
        }
        p = hb.prototype;
        p.push = function(a, b) {
            this.g.has(a) ? this.g.get(a).push(b) : this.g.set(a, [
                b
            ]);
        };
        p.get = function(a) {
            return this.g.has(a) ? this.g.get(a).slice() : null;
        };
        p.remove = function(a, b) {
            if (this.g.has(a)) {
                var c = this.g.get(a).filter(function(d) {
                    return d != b;
                });
                this.g.set(a, c);
                c.length || this.g.delete(a);
            }
        };
        p.forEach = function(a) {
            this.g.forEach(function(b, c) {
                a(c, b);
            });
        };
        p.size = function() {
            return this.g.size;
        };
        p.keys = function() {
            return Array.from(this.g.keys());
        };
        function kb() {
            this.hb = new hb;
            this.Xe = this;
        }
        kb.prototype.addEventListener = function(a, b) {
            this.hb && this.hb.push(a, b);
        };
        kb.prototype.removeEventListener = function(a, b) {
            this.hb && this.hb.remove(a, b);
        };
        kb.prototype.dispatchEvent = function(a) {
            if (!this.hb) return !0;
            var b = this.hb.get(a.type) || [], c = this.hb.get("All");
            c && (b = b.concat(c));
            b = u(b);
            for(c = b.next(); !c.done; c = b.next()){
                c = c.value;
                a.target = this.Xe;
                a.currentTarget = this.Xe;
                try {
                    c.handleEvent ? c.handleEvent(a) : c.call(this, a);
                } catch (d) {}
                if (a.g) break;
            }
            return a.defaultPrevented;
        };
        kb.prototype.release = function() {
            this.hb = null;
        };
        function lb(a, b) {
            var c = [];
            a = u(a);
            for(var d = a.next(); !d.done; d = a.next())c.push(b(d.value));
            return c;
        }
        function mb(a, b) {
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next())if (!b(c.value)) return !1;
            return !0;
        }
        function nb(a, b) {
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next())if (b(c.value)) return !0;
            return !1;
        }
        function ob(a, b) {
            var c = [];
            a = u(a);
            for(var d = a.next(); !d.done; d = a.next())d = d.value, b(d) && c.push(d);
            return c;
        }
        var pb = RegExp("^(?:([^:/?#.]+):)?(?://(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#(.*))?$"); /*
 @license
 Copyright 2006 The Closure Library Authors
 SPDX-License-Identifier: Apache-2.0
*/ 
        function qb(a) {
            var b;
            a instanceof qb ? (rb(this, a.lc), this.xd = a.xd, sb(this, a.Jb), tb(this, a.Sd), this.qb = a.qb, ub(this, a.g.clone()), this.fd = a.fd) : a && (b = String(a).match(pb)) ? (rb(this, b[1] || "", !0), this.xd = vb(b[2] || ""), sb(this, b[3] || "", !0), tb(this, b[4]), this.qb = vb(b[5] || "", !0), ub(this, b[6] || "", !0), this.fd = vb(b[7] || "")) : this.g = new wb(null);
        }
        p = qb.prototype;
        p.lc = "";
        p.xd = "";
        p.Jb = "";
        p.Sd = null;
        p.qb = "";
        p.fd = "";
        p.toString = function() {
            var a = [], b = this.lc;
            b && a.push(xb(b, zb, !0), ":");
            if (b = this.Jb) {
                a.push("//");
                var c = this.xd;
                c && a.push(xb(c, zb, !0), "@");
                a.push(encodeURIComponent(b).replace(/%25([0-9a-fA-F]{2})/g, "%$1"));
                b = this.Sd;
                b != null && a.push(":", String(b));
            }
            if (b = this.qb) this.Jb && b.charAt(0) != "/" && a.push("/"), a.push(xb(b, b.charAt(0) == "/" ? Bb : Cb, !0));
            (b = this.g.toString()) && a.push("?", b);
            (b = this.fd) && a.push("#", xb(b, Db));
            return a.join("");
        };
        p.resolve = function(a) {
            var b = this.clone();
            b.lc === "data" && (b = new qb);
            var c = !!a.lc;
            c ? rb(b, a.lc) : c = !!a.xd;
            c ? b.xd = a.xd : c = !!a.Jb;
            c ? sb(b, a.Jb) : c = a.Sd != null;
            var d = a.qb;
            if (c) tb(b, a.Sd);
            else if (c = !!a.qb) {
                if (d.charAt(0) != "/") {
                    if (this.Jb && !this.qb) d = "/" + d;
                    else {
                        var e = b.qb.lastIndexOf("/");
                        e != -1 && (d = b.qb.substr(0, e + 1) + d);
                    }
                }
                if (d == ".." || d == ".") d = "";
                else if (d.indexOf("./") != -1 || d.indexOf("/.") != -1) {
                    e = d.lastIndexOf("/", 0) == 0;
                    d = d.split("/");
                    for(var f = [], g = 0; g < d.length;){
                        var h = d[g++];
                        h == "." ? e && g == d.length && f.push("") : h == ".." ? ((f.length > 1 || f.length == 1 && f[0] != "") && f.pop(), e && g == d.length && f.push("")) : (f.push(h), e = !0);
                    }
                    d = f.join("/");
                }
            }
            c ? b.qb = d : c = a.g.toString() !== "";
            c ? ub(b, a.g.clone()) : c = !!a.fd;
            c && (b.fd = a.fd);
            return b;
        };
        p.clone = function() {
            return new qb(this);
        };
        function rb(a, b, c) {
            a.lc = c ? vb(b, !0) : b;
            a.lc && (a.lc = a.lc.replace(/:$/, ""));
        }
        function sb(a, b, c) {
            a.Jb = c ? vb(b, !0) : b;
        }
        function tb(a, b) {
            if (b) {
                b = Number(b);
                if (isNaN(b) || b < 0) throw Error("Bad port number " + b);
                a.Sd = b;
            } else a.Sd = null;
        }
        function ub(a, b, c) {
            b instanceof wb ? a.g = b : (c || (b = xb(b, Eb)), a.g = new wb(b));
        }
        function vb(a, b) {
            return a ? b ? decodeURI(a) : decodeURIComponent(a) : "";
        }
        function xb(a, b, c) {
            return a != null ? (a = encodeURI(a).replace(b, Fb), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
        }
        function Fb(a) {
            a = a.charCodeAt(0);
            return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
        }
        var zb = /[#\/\?@]/g, Cb = /[#\?:]/g, Bb = /[#\?]/g, Eb = /[#\?@]/g, Db = /#/g;
        function wb(a) {
            this.g = a || null;
        }
        function Gb(a) {
            if (!a.ob && (a.ob = new Map, a.ie = 0, a.g)) for(var b = a.g.split("&"), c = 0; c < b.length; c++){
                var d = b[c].indexOf("="), e = null;
                if (d >= 0) {
                    var f = b[c].substring(0, d);
                    e = b[c].substring(d + 1);
                } else f = b[c];
                f = decodeURIComponent(f);
                e = e || "";
                a.add(f, decodeURIComponent(e));
            }
        }
        p = wb.prototype;
        p.ob = null;
        p.ie = null;
        function Hb(a) {
            Gb(a);
            return a.ie;
        }
        p.add = function(a, b) {
            Gb(this);
            this.g = null;
            var c = this.ob.has(a) ? this.ob.get(a) : null;
            c || this.ob.set(a, c = []);
            c.push(b);
            this.ie++;
            return this;
        };
        p.set = function(a, b) {
            Gb(this);
            this.g = null;
            this.ob.has(a) ? this.ob.set(a, [
                b
            ]) : this.add(a, b);
            return this;
        };
        p.get = function(a) {
            Gb(this);
            return this.ob.get(a) || [];
        };
        p.toString = function() {
            if (this.g) return this.g;
            if (!this.ob || !this.ob.size) return "";
            for(var a = [], b = u(this.ob.keys()), c = b.next(); !c.done; c = b.next()){
                var d = c.value;
                c = encodeURIComponent(d);
                d = this.ob.get(d);
                for(var e = 0; e < d.length; e++){
                    var f = c;
                    d[e] !== "" && (f += "=" + encodeURIComponent(d[e]));
                    a.push(f);
                }
            }
            return this.g = a.join("&");
        };
        p.clone = function() {
            var a = new wb;
            a.g = this.g;
            if (this.ob) {
                for(var b = new Map, c = u(this.ob), d = c.next(); !d.done; d = c.next()){
                    var e = u(d.value);
                    d = e.next().value;
                    e = e.next().value;
                    b.set(d, e.concat());
                }
                a.ob = b;
                a.ie = this.ie;
            }
            return a;
        };
        function Ib() {}
        function Jb(a, b) {
            if (!a && !b) return !0;
            if (!a || !b || a.byteLength != b.byteLength) return !1;
            if ((ArrayBuffer.isView(a) ? a.buffer : a) == (ArrayBuffer.isView(b) ? b.buffer : b) && (a.byteOffset || 0) == (b.byteOffset || 0)) return !0;
            var c = Kb(a);
            b = Kb(b);
            for(var d = 0; d < a.byteLength; d++)if (c[d] != b[d]) return !1;
            return !0;
        }
        function Lb(a) {
            return ArrayBuffer.isView(a) ? a.byteOffset == 0 && a.byteLength == a.buffer.byteLength ? a.buffer : new Uint8Array(a).buffer : a;
        }
        function Kb(a, b, c) {
            c = c === void 0 ? Infinity : c;
            return Mb(a, b === void 0 ? 0 : b, c, Uint8Array);
        }
        function Nb(a, b, c) {
            c = c === void 0 ? Infinity : c;
            return Mb(a, b === void 0 ? 0 : b, c, Uint16Array);
        }
        function Ob(a, b, c) {
            c = c === void 0 ? Infinity : c;
            return Mb(a, b === void 0 ? 0 : b, c, DataView);
        }
        function Mb(a, b, c, d) {
            var e = ArrayBuffer.isView(a) ? a.buffer : a, f = 1;
            "BYTES_PER_ELEMENT" in d && (f = d.BYTES_PER_ELEMENT);
            var g = ((a.byteOffset || 0) + a.byteLength) / f;
            a = Math.floor(Math.max(0, Math.min(((a.byteOffset || 0) + b) / f, g)));
            return new d(e, a, Math.floor(Math.min(a + Math.max(c, 0), g)) - a);
        }
        S("shaka.util.BufferUtils", Ib);
        Ib.toDataView = Ob;
        Ib.toUint16 = Nb;
        Ib.toUint8 = Kb;
        Ib.toArrayBuffer = Lb;
        Ib.equal = Jb;
        function U(a, b, c) {
            var d = Ma.apply(3, arguments);
            this.severity = a;
            this.category = b;
            this.code = c;
            this.data = d;
            this.handled = !1;
            this.message = "Shaka Error " + this.code;
            if (Pb) try {
                throw Error(this.message || "Shaka Error");
            } catch (e) {
                this.stack = e.stack;
            }
        }
        U.prototype.toString = function() {
            return "shaka.util.Error " + JSON.stringify(this, null, "  ");
        };
        S("shaka.util.Error", U);
        var Pb = !0;
        U.Severity = {
            RECOVERABLE: 1,
            CRITICAL: 2
        };
        U.Category = {
            NETWORK: 1,
            TEXT: 2,
            MEDIA: 3,
            MANIFEST: 4,
            STREAMING: 5,
            DRM: 6,
            PLAYER: 7,
            CAST: 8,
            STORAGE: 9,
            ADS: 10
        };
        U.Code = {
            UNSUPPORTED_SCHEME: 1E3,
            BAD_HTTP_STATUS: 1001,
            HTTP_ERROR: 1002,
            TIMEOUT: 1003,
            MALFORMED_DATA_URI: 1004,
            REQUEST_FILTER_ERROR: 1006,
            RESPONSE_FILTER_ERROR: 1007,
            MALFORMED_TEST_URI: 1008,
            UNEXPECTED_TEST_REQUEST: 1009,
            ATTEMPTS_EXHAUSTED: 1010,
            SEGMENT_MISSING: 1011,
            INVALID_TEXT_HEADER: 2E3,
            INVALID_TEXT_CUE: 2001,
            UNABLE_TO_DETECT_ENCODING: 2003,
            BAD_ENCODING: 2004,
            INVALID_XML: 2005,
            INVALID_MP4_TTML: 2007,
            INVALID_MP4_VTT: 2008,
            UNABLE_TO_EXTRACT_CUE_START_TIME: 2009,
            INVALID_MP4_CEA: 2010,
            TEXT_COULD_NOT_GUESS_MIME_TYPE: 2011,
            CANNOT_ADD_EXTERNAL_TEXT_TO_SRC_EQUALS: 2012,
            TEXT_ONLY_WEBVTT_SRC_EQUALS: 2013,
            MISSING_TEXT_PLUGIN: 2014,
            UNSUPPORTED_EXTERNAL_THUMBNAILS_URI: 2017,
            BUFFER_READ_OUT_OF_BOUNDS: 3E3,
            JS_INTEGER_OVERFLOW: 3001,
            EBML_OVERFLOW: 3002,
            EBML_BAD_FLOATING_POINT_SIZE: 3003,
            MP4_SIDX_WRONG_BOX_TYPE: 3004,
            MP4_SIDX_INVALID_TIMESCALE: 3005,
            MP4_SIDX_TYPE_NOT_SUPPORTED: 3006,
            WEBM_CUES_ELEMENT_MISSING: 3007,
            WEBM_EBML_HEADER_ELEMENT_MISSING: 3008,
            WEBM_SEGMENT_ELEMENT_MISSING: 3009,
            WEBM_INFO_ELEMENT_MISSING: 3010,
            WEBM_DURATION_ELEMENT_MISSING: 3011,
            WEBM_CUE_TRACK_POSITIONS_ELEMENT_MISSING: 3012,
            WEBM_CUE_TIME_ELEMENT_MISSING: 3013,
            MEDIA_SOURCE_OPERATION_FAILED: 3014,
            MEDIA_SOURCE_OPERATION_THREW: 3015,
            VIDEO_ERROR: 3016,
            QUOTA_EXCEEDED_ERROR: 3017,
            TRANSMUXING_FAILED: 3018,
            CONTENT_TRANSFORMATION_FAILED: 3019,
            MSS_MISSING_DATA_FOR_TRANSMUXING: 3020,
            MSS_TRANSMUXING_FAILED: 3022,
            TRANSMUXING_NO_VIDEO_DATA: 3023,
            STREAMING_NOT_ALLOWED: 3024,
            UNABLE_TO_GUESS_MANIFEST_TYPE: 4E3,
            DASH_INVALID_XML: 4001,
            DASH_NO_SEGMENT_INFO: 4002,
            DASH_EMPTY_ADAPTATION_SET: 4003,
            DASH_EMPTY_PERIOD: 4004,
            DASH_WEBM_MISSING_INIT: 4005,
            DASH_UNSUPPORTED_CONTAINER: 4006,
            DASH_PSSH_BAD_ENCODING: 4007,
            DASH_NO_COMMON_KEY_SYSTEM: 4008,
            DASH_MULTIPLE_KEY_IDS_NOT_SUPPORTED: 4009,
            DASH_CONFLICTING_KEY_IDS: 4010,
            RESTRICTIONS_CANNOT_BE_MET: 4012,
            HLS_PLAYLIST_HEADER_MISSING: 4015,
            INVALID_HLS_TAG: 4016,
            HLS_INVALID_PLAYLIST_HIERARCHY: 4017,
            DASH_DUPLICATE_REPRESENTATION_ID: 4018,
            HLS_MULTIPLE_MEDIA_INIT_SECTIONS_FOUND: 4020,
            HLS_REQUIRED_ATTRIBUTE_MISSING: 4023,
            HLS_REQUIRED_TAG_MISSING: 4024,
            HLS_COULD_NOT_GUESS_CODECS: 4025,
            HLS_KEYFORMATS_NOT_SUPPORTED: 4026,
            DASH_UNSUPPORTED_XLINK_ACTUATE: 4027,
            DASH_XLINK_DEPTH_LIMIT: 4028,
            CONTENT_UNSUPPORTED_BY_BROWSER: 4032,
            CANNOT_ADD_EXTERNAL_TEXT_TO_LIVE_STREAM: 4033,
            NO_VARIANTS: 4036,
            PERIOD_FLATTENING_FAILED: 4037,
            INCONSISTENT_DRM_ACROSS_PERIODS: 4038,
            HLS_VARIABLE_NOT_FOUND: 4039,
            HLS_MSE_ENCRYPTED_MP2T_NOT_SUPPORTED: 4040,
            HLS_MSE_ENCRYPTED_LEGACY_APPLE_MEDIA_KEYS_NOT_SUPPORTED: 4041,
            NO_WEB_CRYPTO_API: 4042,
            CANNOT_ADD_EXTERNAL_THUMBNAILS_TO_LIVE_STREAM: 4045,
            MSS_INVALID_XML: 4046,
            MSS_LIVE_CONTENT_NOT_SUPPORTED: 4047,
            AES_128_INVALID_IV_LENGTH: 4048,
            AES_128_INVALID_KEY_LENGTH: 4049,
            DASH_CONFLICTING_AES_128: 4050,
            DASH_UNSUPPORTED_AES_128: 4051,
            DASH_INVALID_PATCH: 4052,
            HLS_EMPTY_MEDIA_PLAYLIST: 4053,
            DASH_MSE_ENCRYPTED_LEGACY_APPLE_MEDIA_KEYS_NOT_SUPPORTED: 4054,
            CANNOT_ADD_EXTERNAL_CHAPTERS_TO_LIVE_STREAM: 4054,
            STREAMING_ENGINE_STARTUP_INVALID_STATE: 5006,
            NO_RECOGNIZED_KEY_SYSTEMS: 6E3,
            REQUESTED_KEY_SYSTEM_CONFIG_UNAVAILABLE: 6001,
            FAILED_TO_CREATE_CDM: 6002,
            FAILED_TO_ATTACH_TO_VIDEO: 6003,
            INVALID_SERVER_CERTIFICATE: 6004,
            FAILED_TO_CREATE_SESSION: 6005,
            FAILED_TO_GENERATE_LICENSE_REQUEST: 6006,
            LICENSE_REQUEST_FAILED: 6007,
            LICENSE_RESPONSE_REJECTED: 6008,
            ENCRYPTED_CONTENT_WITHOUT_DRM_INFO: 6010,
            NO_LICENSE_SERVER_GIVEN: 6012,
            OFFLINE_SESSION_REMOVED: 6013,
            EXPIRED: 6014,
            SERVER_CERTIFICATE_REQUIRED: 6015,
            INIT_DATA_TRANSFORM_ERROR: 6016,
            SERVER_CERTIFICATE_REQUEST_FAILED: 6017,
            MIN_HDCP_VERSION_NOT_MATCH: 6018,
            ERROR_CHECKING_HDCP_VERSION: 6019,
            MISSING_EME_SUPPORT: 6020,
            LOAD_INTERRUPTED: 7E3,
            OPERATION_ABORTED: 7001,
            NO_VIDEO_ELEMENT: 7002,
            OBJECT_DESTROYED: 7003,
            CONTENT_NOT_LOADED: 7004,
            SRC_EQUALS_PRELOAD_NOT_SUPPORTED: 7005,
            PRELOAD_DESTROYED: 7006,
            QUEUE_INDEX_OUT_OF_BOUNDS: 7007,
            CAST_API_UNAVAILABLE: 8E3,
            NO_CAST_RECEIVERS: 8001,
            ALREADY_CASTING: 8002,
            UNEXPECTED_CAST_ERROR: 8003,
            CAST_CANCELED_BY_USER: 8004,
            CAST_CONNECTION_TIMED_OUT: 8005,
            CAST_RECEIVER_APP_UNAVAILABLE: 8006,
            STORAGE_NOT_SUPPORTED: 9E3,
            INDEXED_DB_ERROR: 9001,
            DEPRECATED_OPERATION_ABORTED: 9002,
            REQUESTED_ITEM_NOT_FOUND: 9003,
            MALFORMED_OFFLINE_URI: 9004,
            CANNOT_STORE_LIVE_OFFLINE: 9005,
            NO_INIT_DATA_FOR_OFFLINE: 9007,
            LOCAL_PLAYER_INSTANCE_REQUIRED: 9008,
            NEW_KEY_OPERATION_NOT_SUPPORTED: 9011,
            KEY_NOT_FOUND: 9012,
            MISSING_STORAGE_CELL: 9013,
            STORAGE_LIMIT_REACHED: 9014,
            DOWNLOAD_SIZE_CALLBACK_ERROR: 9015,
            MODIFY_OPERATION_NOT_SUPPORTED: 9016,
            INDEXED_DB_INIT_TIMED_OUT: 9017,
            CS_IMA_SDK_MISSING: 1E4,
            CS_AD_MANAGER_NOT_INITIALIZED: 10001,
            SS_IMA_SDK_MISSING: 10002,
            SS_AD_MANAGER_NOT_INITIALIZED: 10003,
            CURRENT_DAI_REQUEST_NOT_FINISHED: 10004,
            MT_AD_MANAGER_NOT_INITIALIZED: 10005,
            INTERSTITIAL_AD_MANAGER_NOT_INITIALIZED: 10006,
            VAST_INVALID_XML: 10007
        };
        function Qb(a) {
            this.h = a;
            this.g = void 0;
        }
        Qb.prototype.value = function() {
            this.g === void 0 && (this.g = this.h());
            return this.g;
        }; /*
 @license
 Shaka Player
 Copyright 2025 Google LLC
 SPDX-License-Identifier: Apache-2.0
*/ 
        function Rb() {
            return Sb.value();
        }
        var Tb = null, Ub = null, Sb = new Qb(function() {
            var a = void 0;
            Tb && (a = Tb());
            !a && Ub && (a = Ub());
            return a;
        });
        function Vb() {}
        function Wb(a) {
            if (!a) return "";
            a = Kb(a);
            a[0] == 239 && a[1] == 187 && a[2] == 191 && (a = a.subarray(3));
            if (window1.TextDecoder && !Rb().ki()) return a = (new TextDecoder).decode(a), a.includes("\ufffd") && $a('Decoded string contains an "unknown character" codepoint.  That probably means the UTF8 encoding was incorrect!'), a;
            for(var b = "", c = 0; c < a.length; ++c){
                var d = 65533;
                (a[c] & 128) == 0 ? d = a[c] : a.length >= c + 2 && (a[c] & 224) == 192 && (a[c + 1] & 192) == 128 ? (d = (a[c] & 31) << 6 | a[c + 1] & 63, c += 1) : a.length >= c + 3 && (a[c] & 240) == 224 && (a[c + 1] & 192) == 128 && (a[c + 2] & 192) == 128 ? (d = (a[c] & 15) << 12 | (a[c + 1] & 63) << 6 | a[c + 2] & 63, c += 2) : a.length >= c + 4 && (a[c] & 241) == 240 && (a[c + 1] & 192) == 128 && (a[c + 2] & 192) == 128 && (a[c + 3] & 192) == 128 && (d = (a[c] & 7) << 18 | (a[c + 1] & 63) << 12 | (a[c + 2] & 63) << 6 | a[c + 3] & 63, c += 3);
                if (d <= 65535) b += String.fromCharCode(d);
                else {
                    d -= 65536;
                    var e = d & 1023;
                    b += String.fromCharCode(55296 + (d >> 10));
                    b += String.fromCharCode(56320 + e);
                }
            }
            return b;
        }
        function Xb(a, b, c) {
            if (!a) return "";
            if (!c && a.byteLength % 2 != 0) throw new U(2, 2, 2004);
            c = Math.floor(a.byteLength / 2);
            var d = new Uint16Array(c);
            a = Ob(a);
            for(var e = 0; e < c; e++)d[e] = a.getUint16(e * 2, b);
            return Yb(d);
        }
        function Zb(a) {
            function b(d) {
                return c.byteLength <= d || c[d] >= 9 && c[d] <= 126;
            }
            if (!a) return "";
            var c = Kb(a);
            if (c[0] == 239 && c[1] == 187 && c[2] == 191) return Wb(c);
            if (c[0] == 254 && c[1] == 255) return Xb(c.subarray(2), !1);
            if (c[0] == 255 && c[1] == 254) return Xb(c.subarray(2), !0);
            if (c[0] == 0 && c[2] == 0) return Xb(a, !1);
            if (c[1] == 0 && c[3] == 0) return Xb(a, !0);
            if (b(0) && b(1) && b(2) && b(3)) return Wb(a);
            throw new U(2, 2, 2003);
        }
        function $b(a) {
            if (window1.TextEncoder && !Rb().ki()) {
                var b = new TextEncoder;
                return Lb(b.encode(a));
            }
            a = encodeURIComponent(a);
            a = unescape(a);
            b = new Uint8Array(a.length);
            for(var c = 0; c < a.length; c++)b[c] = a[c].charCodeAt(0);
            return Lb(b);
        }
        function ac(a, b) {
            for(var c = new ArrayBuffer(a.length * 2), d = new DataView(c), e = 0; e < a.length; ++e)d.setUint16(e * 2, a.charCodeAt(e), b);
            return c;
        }
        function Yb(a) {
            return bc.value()(a);
        }
        function cc(a) {
            var b = {
                "&amp;": "&",
                "&lt;": "<",
                "&gt;": ">",
                "&quot;": '"',
                "&apos;": "'",
                "&nbsp;": "\u00a0",
                "&lrm;": "\u200e",
                "&rlm;": "\u200f"
            }, c = /&(?:amp|lt|gt|quot|apos|nbsp|lrm|rlm|#[xX]?[0-9a-fA-F]+);/g, d = RegExp(c.source);
            return a && d.test(a) ? a.replace(c, function(e) {
                return e[1] == "#" ? (e = e[2] == "x" || e[2] == "X" ? parseInt(e.substring(3), 16) : parseInt(e.substring(2), 10), e >= 0 && e <= 1114111 ? String.fromCodePoint(e) : "") : b[e] || "'";
            }) : a || "";
        }
        S("shaka.util.StringUtils", Vb);
        Vb.resetFromCharCode = function() {
            bc.g = void 0;
        };
        Vb.toUTF16 = ac;
        Vb.toUTF8 = $b;
        Vb.fromBytesAutoDetect = Zb;
        Vb.fromUTF16 = Xb;
        Vb.fromUTF8 = Wb;
        var bc = new Qb(function() {
            function a(c) {
                try {
                    var d = new Uint8Array(c);
                    return String.fromCharCode.apply(null, d).length > 0;
                } catch (e) {
                    return !1;
                }
            }
            for(var b = {
                $c: 65536
            }; b.$c > 0; b = {
                $c: b.$c
            }, b.$c /= 2)if (a(b.$c)) return function(c) {
                return function(d) {
                    for(var e = "", f = 0; f < d.length; f += c.$c)e += String.fromCharCode.apply(null, d.subarray(f, f + c.$c));
                    return e;
                };
            }(b);
            return null;
        });
        function dc() {}
        function ec(a) {
            a = Yb(Kb(a));
            return btoa(a);
        }
        function fc(a, b) {
            b = b == void 0 ? !0 : b;
            a = ec(a).replace(/\+/g, "-").replace(/\//g, "_");
            return b ? a : a.replace(/[=]*$/, "");
        }
        function hc(a) {
            a = window1.atob(a.replace(/-/g, "+").replace(/_/g, "/"));
            for(var b = new Uint8Array(a.length), c = 0; c < a.length; ++c)b[c] = a.charCodeAt(c);
            return b;
        }
        function ic(a) {
            for(var b = a.length / 2, c = new Uint8Array(b), d = 0; d < b; d++)c[d] = window1.parseInt(a.substr(d * 2, 2), 16);
            return c;
        }
        function jc(a) {
            var b = Kb(a);
            a = "";
            b = u(b);
            for(var c = b.next(); !c.done; c = b.next())c = c.value, c = c.toString(16), c.length == 1 && (c = "0" + c), a += c;
            return a;
        }
        function lc() {
            for(var a = Ma.apply(0, arguments), b = 0, c = 0; c < a.length; ++c)b += a[c].byteLength;
            b = new Uint8Array(b);
            for(var d = c = 0; d < a.length; ++d){
                var e = a[d];
                ArrayBuffer.isView(e) && e.BYTES_PER_ELEMENT === 1 ? b.set(e, c) : b.set(Kb(e), c);
                c += e.byteLength;
            }
            return b;
        }
        S("shaka.util.Uint8ArrayUtils", dc);
        dc.concat = lc;
        dc.toHex = jc;
        dc.fromHex = ic;
        dc.fromBase64 = hc;
        dc.toBase64 = fc;
        dc.toStandardBase64 = ec;
        function mc(a, b, c) {
            c = c === void 0 ? "" : c;
            if (b.length == 0) return a;
            if (a.length == 1 && b.length == 1) {
                var d = new qb(a[0]);
                b = new qb(b[0]);
                b = d.resolve(b);
                c && ub(b, c);
                return [
                    b.toString()
                ];
            }
            b = b.map(function(h) {
                return new qb(h);
            });
            d = [];
            a = u(a);
            for(var e = a.next(); !e.done; e = a.next()){
                e = new qb(e.value);
                for(var f = u(b), g = f.next(); !g.done; g = f.next())g = e.resolve(g.value), c && ub(g, c), d.push(g.toString());
            }
            return d;
        }
        function nc(a, b, c, d) {
            a = {
                keySystem: a,
                encryptionScheme: b,
                licenseServerUri: "",
                distinctiveIdentifierRequired: !1,
                persistentStateRequired: !1,
                audioRobustness: "",
                videoRobustness: "",
                serverCertificate: null,
                serverCertificateUri: "",
                sessionType: "",
                initData: c || [],
                keyIds: new Set
            };
            d && (a.keySystemUris = new Set([
                d
            ]));
            return a;
        }
        function oc(a, b) {
            b = b === void 0 ? "cenc" : b;
            var c = [], d = [], e = [];
            a.forEach(function(g, h) {
                var k = h;
                k.length != 22 && (k = fc(ic(h), !1));
                var l = g;
                l.length != 22 && (l = fc(ic(g), !1));
                g = {
                    kty: "oct",
                    kid: k,
                    k: l
                };
                c.push(g);
                d.push(g.kid);
                e.push(h);
            });
            a = JSON.stringify({
                keys: c
            });
            var f = JSON.stringify({
                kids: d
            });
            f = [
                {
                    initData: Kb($b(f)),
                    initDataType: "keyids"
                }
            ];
            return {
                keySystem: "org.w3.clearkey",
                encryptionScheme: b,
                licenseServerUri: "data:application/json;base64," + window1.btoa(a),
                distinctiveIdentifierRequired: !1,
                persistentStateRequired: !1,
                audioRobustness: "",
                videoRobustness: "",
                serverCertificate: null,
                serverCertificateUri: "",
                sessionType: "",
                initData: f,
                keyIds: new Set(e)
            };
        }
        function pc(a, b) {
            if (b.length == 1) return b[0];
            a = qc(a, b);
            if (a != null) return a;
            throw new U(2, 4, 4025, b);
        }
        function qc(a, b) {
            var c = rc.get(a);
            c = u(c);
            for(var d = c.next(); !d.done; d = c.next()){
                d = d.value;
                for(var e = u(b), f = e.next(); !f.done; f = e.next())if (f = f.value, d.test(f.trim())) return f.trim();
            }
            return a == sc ? "" : null;
        }
        function tc(a, b) {
            var c = [];
            a = rc.get(a);
            a = u(a);
            for(var d = a.next(); !d.done; d = a.next()){
                d = d.value;
                for(var e = u(b), f = e.next(); !f.done; f = e.next())f = f.value, d.test(f.trim()) && c.push(f.trim());
            }
            return c;
        }
        var sc = "text", uc = {
            Ia: "video",
            na: "audio",
            Va: sc,
            yg: "image",
            Gm: "application"
        }, vc = 1 / 15, rc = (new Map).set("audio", [
            /^vorbis$/,
            /^Opus$/,
            /^opus$/,
            /^fLaC$/,
            /^flac$/,
            /^mp4a/,
            /^[ae]c-3$/,
            /^ac-4/,
            /^dts[cex]$/,
            /^iamf/,
            /^mhm[12]/,
            /^ac3$/,
            /^eac3$/,
            /^apac$/
        ]).set("video", [
            /^avc/,
            /^hev/,
            /^hvc/,
            /^vvc/,
            /^vvi/,
            /^vp0?[89]/,
            /^av01/,
            /^dvh/,
            /^dva/,
            /^dav/
        ]).set("text", [
            /^vtt$/,
            /^wvtt/,
            /^stpp/
        ]);
        function wc() {}
        function xc(a, b) {
            a = yc(a);
            b = yc(b);
            return a.split("-")[0] == b.split("-")[0];
        }
        function zc(a, b) {
            a = yc(a);
            b = yc(b);
            a = a.split("-");
            b = b.split("-");
            return a[0] == b[0] && a.length == 1 && b.length == 2;
        }
        function Ac(a, b) {
            a = yc(a);
            b = yc(b);
            a = a.split("-");
            b = b.split("-");
            return a.length == 2 && b.length == 2 && a[0] == b[0];
        }
        function yc(a) {
            a = u(a.split("-x-"));
            var b = a.next().value;
            b = b === void 0 ? "" : b;
            a = a.next().value;
            a = a === void 0 ? "" : a;
            var c = u(b.split("-"));
            b = c.next().value;
            b = b === void 0 ? "" : b;
            c = c.next().value;
            c = c === void 0 ? "" : c;
            a = a ? "x-" + a : "";
            b = b.toLowerCase();
            b = Bc.get(b) || b;
            c = c.toUpperCase();
            return (c ? b + "-" + c : b) + (a ? "-" + a : "");
        }
        function Cc(a, b) {
            var c = Dc(a), d = Dc(b);
            return a != c && b != d && c == d;
        }
        function Ec(a, b) {
            a = yc(a);
            b = yc(b);
            return b == a ? 4 : zc(b, a) ? 3 : Ac(b, a) ? 2 : zc(a, b) ? 1 : 0;
        }
        function Dc(a) {
            var b = a.indexOf("-");
            a = b >= 0 ? a.substring(0, b) : a;
            a = a.toLowerCase();
            return a = Bc.get(a) || a;
        }
        function Fc(a) {
            return a.language ? yc(a.language) : a.audio && a.audio.language ? yc(a.audio.language) : a.video && a.video.language ? yc(a.video.language) : "und";
        }
        function Gc(a, b) {
            a = yc(a);
            var c = new Set;
            b = u(b);
            for(var d = b.next(); !d.done; d = b.next())c.add(yc(d.value));
            b = u(c);
            for(d = b.next(); !d.done; d = b.next())if (d = d.value, d == a) return d;
            b = u(c);
            for(d = b.next(); !d.done; d = b.next())if (d = d.value, zc(d, a)) return d;
            b = u(c);
            for(d = b.next(); !d.done; d = b.next())if (d = d.value, Ac(d, a)) return d;
            c = u(c);
            for(b = c.next(); !b.done; b = c.next())if (b = b.value, zc(a, b)) return b;
            return null;
        }
        S("shaka.util.LanguageUtils", wc);
        wc.findClosestLocale = Gc;
        wc.getLocaleForVariant = Fc;
        wc.getLocaleForText = function(a) {
            return yc(a.language || "und");
        };
        wc.getBase = Dc;
        wc.relatedness = Ec;
        wc.areSiblings = Cc;
        wc.normalize = yc;
        wc.isSiblingOf = Ac;
        wc.isParentOf = zc;
        wc.areLanguageCompatible = xc;
        wc.areLocaleCompatible = function(a, b) {
            a = yc(a);
            b = yc(b);
            return a == b;
        };
        var Bc = new Map([
            [
                "aar",
                "aa"
            ],
            [
                "abk",
                "ab"
            ],
            [
                "afr",
                "af"
            ],
            [
                "aka",
                "ak"
            ],
            [
                "alb",
                "sq"
            ],
            [
                "amh",
                "am"
            ],
            [
                "ara",
                "ar"
            ],
            [
                "arg",
                "an"
            ],
            [
                "arm",
                "hy"
            ],
            [
                "asm",
                "as"
            ],
            [
                "ava",
                "av"
            ],
            [
                "ave",
                "ae"
            ],
            [
                "aym",
                "ay"
            ],
            [
                "aze",
                "az"
            ],
            [
                "bak",
                "ba"
            ],
            [
                "bam",
                "bm"
            ],
            [
                "baq",
                "eu"
            ],
            [
                "bel",
                "be"
            ],
            [
                "ben",
                "bn"
            ],
            [
                "bih",
                "bh"
            ],
            [
                "bis",
                "bi"
            ],
            [
                "bod",
                "bo"
            ],
            [
                "bos",
                "bs"
            ],
            [
                "bre",
                "br"
            ],
            [
                "bul",
                "bg"
            ],
            [
                "bur",
                "my"
            ],
            [
                "cat",
                "ca"
            ],
            [
                "ces",
                "cs"
            ],
            [
                "cha",
                "ch"
            ],
            [
                "che",
                "ce"
            ],
            [
                "chi",
                "zh"
            ],
            [
                "chu",
                "cu"
            ],
            [
                "chv",
                "cv"
            ],
            [
                "cor",
                "kw"
            ],
            [
                "cos",
                "co"
            ],
            [
                "cre",
                "cr"
            ],
            [
                "cym",
                "cy"
            ],
            [
                "cze",
                "cs"
            ],
            [
                "dan",
                "da"
            ],
            [
                "deu",
                "de"
            ],
            [
                "div",
                "dv"
            ],
            [
                "dut",
                "nl"
            ],
            [
                "dzo",
                "dz"
            ],
            [
                "ell",
                "el"
            ],
            [
                "eng",
                "en"
            ],
            [
                "epo",
                "eo"
            ],
            [
                "est",
                "et"
            ],
            [
                "eus",
                "eu"
            ],
            [
                "ewe",
                "ee"
            ],
            [
                "fao",
                "fo"
            ],
            [
                "fas",
                "fa"
            ],
            [
                "fij",
                "fj"
            ],
            [
                "fin",
                "fi"
            ],
            [
                "fra",
                "fr"
            ],
            [
                "fre",
                "fr"
            ],
            [
                "fry",
                "fy"
            ],
            [
                "ful",
                "ff"
            ],
            [
                "geo",
                "ka"
            ],
            [
                "ger",
                "de"
            ],
            [
                "gla",
                "gd"
            ],
            [
                "gle",
                "ga"
            ],
            [
                "glg",
                "gl"
            ],
            [
                "glv",
                "gv"
            ],
            [
                "gre",
                "el"
            ],
            [
                "grn",
                "gn"
            ],
            [
                "guj",
                "gu"
            ],
            [
                "hat",
                "ht"
            ],
            [
                "hau",
                "ha"
            ],
            [
                "heb",
                "he"
            ],
            [
                "her",
                "hz"
            ],
            [
                "hin",
                "hi"
            ],
            [
                "hmo",
                "ho"
            ],
            [
                "hrv",
                "hr"
            ],
            [
                "hun",
                "hu"
            ],
            [
                "hye",
                "hy"
            ],
            [
                "ibo",
                "ig"
            ],
            [
                "ice",
                "is"
            ],
            [
                "ido",
                "io"
            ],
            [
                "iii",
                "ii"
            ],
            [
                "iku",
                "iu"
            ],
            [
                "ile",
                "ie"
            ],
            [
                "ina",
                "ia"
            ],
            [
                "ind",
                "id"
            ],
            [
                "ipk",
                "ik"
            ],
            [
                "isl",
                "is"
            ],
            [
                "ita",
                "it"
            ],
            [
                "jav",
                "jv"
            ],
            [
                "jpn",
                "ja"
            ],
            [
                "kal",
                "kl"
            ],
            [
                "kan",
                "kn"
            ],
            [
                "kas",
                "ks"
            ],
            [
                "kat",
                "ka"
            ],
            [
                "kau",
                "kr"
            ],
            [
                "kaz",
                "kk"
            ],
            [
                "khm",
                "km"
            ],
            [
                "kik",
                "ki"
            ],
            [
                "kin",
                "rw"
            ],
            [
                "kir",
                "ky"
            ],
            [
                "kom",
                "kv"
            ],
            [
                "kon",
                "kg"
            ],
            [
                "kor",
                "ko"
            ],
            [
                "kua",
                "kj"
            ],
            [
                "kur",
                "ku"
            ],
            [
                "lao",
                "lo"
            ],
            [
                "lat",
                "la"
            ],
            [
                "lav",
                "lv"
            ],
            [
                "lim",
                "li"
            ],
            [
                "lin",
                "ln"
            ],
            [
                "lit",
                "lt"
            ],
            [
                "ltz",
                "lb"
            ],
            [
                "lub",
                "lu"
            ],
            [
                "lug",
                "lg"
            ],
            [
                "mac",
                "mk"
            ],
            [
                "mah",
                "mh"
            ],
            [
                "mal",
                "ml"
            ],
            [
                "mao",
                "mi"
            ],
            [
                "mar",
                "mr"
            ],
            [
                "may",
                "ms"
            ],
            [
                "mkd",
                "mk"
            ],
            [
                "mlg",
                "mg"
            ],
            [
                "mlt",
                "mt"
            ],
            [
                "mon",
                "mn"
            ],
            [
                "mri",
                "mi"
            ],
            [
                "msa",
                "ms"
            ],
            [
                "mya",
                "my"
            ],
            [
                "nau",
                "na"
            ],
            [
                "nav",
                "nv"
            ],
            [
                "nbl",
                "nr"
            ],
            [
                "nde",
                "nd"
            ],
            [
                "ndo",
                "ng"
            ],
            [
                "nep",
                "ne"
            ],
            [
                "nld",
                "nl"
            ],
            [
                "nno",
                "nn"
            ],
            [
                "nob",
                "nb"
            ],
            [
                "nor",
                "no"
            ],
            [
                "nya",
                "ny"
            ],
            [
                "oci",
                "oc"
            ],
            [
                "oji",
                "oj"
            ],
            [
                "ori",
                "or"
            ],
            [
                "orm",
                "om"
            ],
            [
                "oss",
                "os"
            ],
            [
                "pan",
                "pa"
            ],
            [
                "per",
                "fa"
            ],
            [
                "pli",
                "pi"
            ],
            [
                "pol",
                "pl"
            ],
            [
                "por",
                "pt"
            ],
            [
                "pus",
                "ps"
            ],
            [
                "que",
                "qu"
            ],
            [
                "roh",
                "rm"
            ],
            [
                "ron",
                "ro"
            ],
            [
                "rum",
                "ro"
            ],
            [
                "run",
                "rn"
            ],
            [
                "rus",
                "ru"
            ],
            [
                "sag",
                "sg"
            ],
            [
                "san",
                "sa"
            ],
            [
                "sin",
                "si"
            ],
            [
                "slk",
                "sk"
            ],
            [
                "slo",
                "sk"
            ],
            [
                "slv",
                "sl"
            ],
            [
                "sme",
                "se"
            ],
            [
                "smo",
                "sm"
            ],
            [
                "sna",
                "sn"
            ],
            [
                "snd",
                "sd"
            ],
            [
                "som",
                "so"
            ],
            [
                "sot",
                "st"
            ],
            [
                "spa",
                "es"
            ],
            [
                "sqi",
                "sq"
            ],
            [
                "srd",
                "sc"
            ],
            [
                "srp",
                "sr"
            ],
            [
                "ssw",
                "ss"
            ],
            [
                "sun",
                "su"
            ],
            [
                "swa",
                "sw"
            ],
            [
                "swe",
                "sv"
            ],
            [
                "tah",
                "ty"
            ],
            [
                "tam",
                "ta"
            ],
            [
                "tat",
                "tt"
            ],
            [
                "tel",
                "te"
            ],
            [
                "tgk",
                "tg"
            ],
            [
                "tgl",
                "tl"
            ],
            [
                "tha",
                "th"
            ],
            [
                "tib",
                "bo"
            ],
            [
                "tir",
                "ti"
            ],
            [
                "ton",
                "to"
            ],
            [
                "tsn",
                "tn"
            ],
            [
                "tso",
                "ts"
            ],
            [
                "tuk",
                "tk"
            ],
            [
                "tur",
                "tr"
            ],
            [
                "twi",
                "tw"
            ],
            [
                "uig",
                "ug"
            ],
            [
                "ukr",
                "uk"
            ],
            [
                "urd",
                "ur"
            ],
            [
                "uzb",
                "uz"
            ],
            [
                "ven",
                "ve"
            ],
            [
                "vie",
                "vi"
            ],
            [
                "vol",
                "vo"
            ],
            [
                "wel",
                "cy"
            ],
            [
                "wln",
                "wa"
            ],
            [
                "wol",
                "wo"
            ],
            [
                "xho",
                "xh"
            ],
            [
                "yid",
                "yi"
            ],
            [
                "yor",
                "yo"
            ],
            [
                "zha",
                "za"
            ],
            [
                "zho",
                "zh"
            ],
            [
                "zul",
                "zu"
            ]
        ]);
        function Hc(a) {
            kb.call(this);
            this.j = yc(a);
            this.i = new Map;
            this.g = new Set;
            this.h = new Map;
        }
        la(Hc, kb);
        p = Hc.prototype;
        p.release = function() {
            kb.prototype.release.call(this);
        };
        p.Li = function(a) {
            var b = this;
            this.g.clear();
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next())this.g.add(yc(c.value));
            Ic(this);
            a = ob(this.g, function(d) {
                return !b.h.has(d);
            });
            a.length && this.dispatchEvent(new T("unknown-locales", (new Map).set("locales", a)));
            a = ob(this.g, function(d) {
                return b.h.has(d);
            });
            a = (new Map).set("locales", a.length ? a : [
                this.j
            ]);
            this.dispatchEvent(new T("locale-changed", a));
        };
        p.Xa = function(a, b, c) {
            a = yc(a);
            c === void 0 && (c = Jc);
            var d = this.h.get(a) || new Map;
            b.forEach(function(e, f) {
                d.has(f) && c != Jc || d.set(f, e);
            });
            this.h.set(a, d);
            Ic(this);
            this.dispatchEvent(new T("locale-updated"));
            return this;
        };
        p.jm = function(a) {
            for(var b = u(a.keys()), c = b.next(); !c.done; c = b.next())c = c.value, a.set(c, this.resolve(c));
        };
        p.resolve = function(a) {
            var b = this.i.get(a);
            if (b) return b;
            a = (new Map).set("locales", Array.from(this.g)).set("missing", a);
            this.dispatchEvent(new T("unknown-localization", a));
            return "";
        };
        p.Lk = function() {
            return this.g;
        };
        function Ic(a) {
            for(var b = a.h, c = a.j, d = a.g, e = new Set, f = u(d), g = f.next(), h = {}; !g.done; h = {
                ye: void 0
            }, g = f.next()){
                h.ye = g.value;
                e.add(h.ye);
                e.add(Dc(h.ye));
                g = ob(b.keys(), function(l) {
                    return function(m) {
                        return Cc(m, l.ye);
                    };
                }(h));
                g.sort();
                g = u(g);
                for(var k = g.next(); !k.done; k = g.next())e.add(k.value);
                h = ob(b.keys(), function(l) {
                    return function(m) {
                        return Dc(m) == l.ye;
                    };
                }(h));
                h.sort();
                h = u(h);
                for(g = h.next(); !g.done; g = h.next())e.add(g.value);
            }
            e.add(c);
            c = [];
            e = u(e);
            for(f = e.next(); !f.done; f = e.next())(f = b.get(f.value)) && c.push(f);
            c.reverse();
            a.i.clear();
            b = u(c);
            for(e = b.next(); !e.done; e = b.next())e.value.forEach(function(l, m) {
                a.i.set(m, l);
            });
            b = a.i.keys();
            e = new Set;
            c = u(a.g);
            for(f = c.next(); !f.done; f = c.next())f = a.h.get(f.value) || new Map, Kc(f, b, e);
            e.size > 0 && (d = (new Map).set("locales", Array.from(d)).set("missing", Array.from(e)), a.dispatchEvent(new T("missing-localizations", d)));
        }
        function Kc(a, b, c) {
            b = u(b);
            for(var d = b.next(); !d.done; d = b.next())d = d.value, a.get(d) || c.add(d);
        }
        S("shaka.ui.Localization", Hc);
        Hc.prototype.getCurrentLocales = Hc.prototype.Lk;
        Hc.prototype.resolve = Hc.prototype.resolve;
        Hc.prototype.resolveDictionary = Hc.prototype.jm;
        Hc.prototype.insert = Hc.prototype.Xa;
        Hc.prototype.changeLocale = Hc.prototype.Li;
        Hc.prototype.release = Hc.prototype.release;
        var Jc = 1;
        Hc.ConflictResolution = {
            USE_OLD: 0,
            USE_NEW: Jc
        };
        Hc.UNKNOWN_LOCALES = "unknown-locales";
        Hc.UNKNOWN_LOCALIZATION = "unknown-localization";
        Hc.MISSING_LOCALIZATIONS = "missing-localizations";
        Hc.LOCALE_CHANGED = "locale-changed";
        Hc.LOCALE_UPDATED = "locale-updated";
        function Lc(a) {
            this.g = Math.exp(Math.log(.5) / a);
            this.i = this.h = 0;
        }
        Lc.prototype.sample = function(a, b) {
            var c = Math.pow(this.g, a);
            b = b * (1 - c) + c * this.h;
            isNaN(b) || (this.h = b, this.i += a);
        };
        function Mc(a) {
            return a.h / (1 - Math.pow(a.g, a.i));
        }
        function Nc() {
            this.h = new Lc(2);
            this.j = new Lc(5);
            this.g = 0;
            this.i = 128E3;
            this.l = 16E3;
        }
        Nc.prototype.configure = function(a) {
            this.i = a.minTotalBytes;
            this.l = a.minBytes;
            this.h.g = Math.exp(Math.log(.5) / a.fastHalfLife);
            this.j.g = Math.exp(Math.log(.5) / a.slowHalfLife);
        };
        Nc.prototype.sample = function(a, b) {
            if (!(b < this.l)) {
                var c = 8E3 * b / a;
                a /= 1E3;
                this.g += b;
                this.h.sample(a, c);
                this.j.sample(a, c);
            }
        };
        Nc.prototype.getBandwidthEstimate = function(a) {
            return this.g < this.i ? a : Math.min(Mc(this.h), Mc(this.j));
        };
        function Pc(a, b) {
            return typeof a === "number" && typeof b === "number" && isNaN(a) && isNaN(b) ? !0 : a === b;
        }
        function Qc(a, b) {
            b = a.indexOf(b);
            b > -1 && a.splice(b, 1);
        }
        function Rc(a, b, c) {
            c || (c = Pc);
            if (a.length != b.length) return !1;
            b = b.slice();
            a = u(a);
            for(var d = a.next(), e = {}; !d.done; e = {
                hj: void 0
            }, d = a.next()){
                e.hj = d.value;
                d = b.findIndex(function(f) {
                    return function(g) {
                        return c(f.hj, g);
                    };
                }(e));
                if (d == -1) return !1;
                b[d] = b[b.length - 1];
                b.pop();
            }
            return b.length == 0;
        }
        function Sc(a, b, c) {
            if (a === b) return !0;
            if (!a || !b) return a == b;
            c || (c = Pc);
            if (a.length != b.length) return !1;
            for(var d = 0; d < a.length; d++)if (!c(a[d], b[d])) return !1;
            return !0;
        }
        function Tc() {
            this.g = new hb;
        }
        p = Tc.prototype;
        p.release = function() {
            this.Sa();
            this.g = null;
        };
        p.o = function(a, b, c, d) {
            this.g && (a = new Uc(a, b, c, d), this.g.push(b, a));
        };
        p.ua = function(a, b, c, d) {
            function e(g) {
                f.Ea(a, b, e);
                c(g);
            }
            var f = this;
            this.o(a, b, e, d);
        };
        p.Ea = function(a, b, c) {
            if (this.g) {
                var d = this.g.get(b) || [];
                d = u(d);
                for(var e = d.next(); !e.done; e = d.next())e = e.value, e.target != a || c != e.listener && c || (e.Ea(), this.g.remove(b, e));
            }
        };
        p.Sa = function() {
            if (this.g) {
                for(var a = [], b = u(this.g.g.values()), c = b.next(); !c.done; c = b.next())a.push.apply(a, x(c.value));
                a = u(a);
                for(b = a.next(); !b.done; b = a.next())b.value.Ea();
                this.g.g.clear();
            }
        };
        S("shaka.util.EventManager", Tc);
        Tc.prototype.removeAll = Tc.prototype.Sa;
        Tc.prototype.unlisten = Tc.prototype.Ea;
        Tc.prototype.listenOnce = Tc.prototype.ua;
        Tc.prototype.listen = Tc.prototype.o;
        Tc.prototype.release = Tc.prototype.release;
        function Uc(a, b, c, d) {
            this.target = a;
            this.type = b;
            this.listener = c;
            this.g = Vc(a, d);
            this.target.addEventListener(b, c, this.g);
        }
        Uc.prototype.Ea = function() {
            this.target.removeEventListener(this.type, this.listener, this.g);
            this.listener = this.target = null;
            this.g = !1;
        };
        function Vc(a, b) {
            if (b == void 0) return !1;
            if (typeof b == "boolean") return b;
            var c = new Set([
                "passive",
                "capture"
            ]);
            Object.keys(b).filter(function(d) {
                return !c.has(d);
            });
            return Wc(a) ? b : b.capture || !1;
        }
        function Wc(a) {
            var b = Xc;
            if (b == void 0) {
                b = !1;
                try {
                    var c = {}, d = {
                        get: function() {
                            b = !0;
                            return !1;
                        }
                    };
                    Object.defineProperty(c, "passive", d);
                    Object.defineProperty(c, "capture", d);
                    d = function() {};
                    a.addEventListener("test", d, c);
                    a.removeEventListener("test", d, c);
                } catch (e) {
                    b = !1;
                }
                Xc = b;
            }
            return b || !1;
        }
        var Xc = void 0;
        S("shaka.config.AutoShowText", {
            NEVER: 0,
            ALWAYS: 1,
            IF_PREFERRED_TEXT_LANGUAGE: 2,
            IF_SUBTITLES_MAY_BE_NEEDED: 3
        });
        function Yc(a, b) {
            this.g = a;
            this.h = b;
        }
        Yc.prototype.toString = function() {
            return "v" + this.g + "." + this.h;
        };
        function Zc(a, b) {
            var c = new Yc(5, 0), d = $c, e = d.g, f = c.h - e.h;
            ((c.g - e.g || f) > 0 ? d.i : d.h)(d.g, c, a, b);
        }
        function ad(a, b, c, d) {
            ab([
                c,
                "has been deprecated and will be removed in",
                b,
                ". We are currently at version",
                a,
                ". Additional information:",
                d
            ].join(" "));
        }
        function bd(a, b, c, d) {
            $a([
                c,
                "has been deprecated and has been removed in",
                b,
                ". We are now at version",
                a,
                ". Additional information:",
                d
            ].join(" "));
        }
        var $c = null;
        function cd(a, b, c, d) {
            this.g = null;
            this.l = a;
            this.i = b;
            this.m = c;
            this.u = d;
            this.j = !1;
            a: {
                typeof libDPIModule === "undefined" && ab("Could not find LCEVC Library dependencies on this page");
                if (typeof LCEVCdec !== "undefined") this.h = LCEVCdec;
                else if (typeof LcevcDil !== "undefined") this.h = LcevcDil, this.j = !0, Zc("LcevcDil", "lcevc_dil.js is deprecated, please use lcevc_dec.js instead");
                else {
                    ab("Could not find LCEVC Library on this page");
                    a = !1;
                    break a;
                }
                typeof this.h.SupportObject === "undefined" ? (ab("Could not find LCEVC Library on this page"), a = !1) : (this.h.SupportObject.SupportStatus || ab(this.h.SupportObject.SupportError), a = typeof this.h !== "undefined" && typeof libDPIModule !== "undefined" && this.i instanceof HTMLCanvasElement && this.h.SupportObject.SupportStatus);
            }
            a && !this.g && this.h.SupportObject.webGLSupport(this.i) && (this.i.classList.remove("shaka-hidden"), this.g = this.j ? new this.h.LcevcDil(this.l, this.i, this.m) : new this.h.LCEVCdec(this.l, this.i, this.m));
        }
        function dd(a, b, c, d) {
            d.type !== "video" || a.u && !d.baseOriginalId || a.g && a.g.appendBuffer(b, "video", d.id, -c, !a.u);
        }
        function ed(a) {
            a.g && a.i.classList.add("shaka-hidden");
        }
        cd.prototype.release = function() {
            this.g && (this.g.close(), this.g = null);
        };
        function fd(a) {
            return a && typeof LCEVCdec !== "undefined" ? a.codecs == "lvc1" : !1;
        }
        S("shaka.lcevc.Dec", cd);
        cd.prototype.release = cd.prototype.release;
        function gd(a) {
            if (hd.has(a)) return hd.get(a);
            var b = window1.ManagedMediaSource || window1.MediaSource;
            return b ? (b = b.isTypeSupported(a), hd.set(a, b), b) : !1;
        }
        function id() {
            var a = window1.ManagedSourceBuffer || window1.SourceBuffer;
            return !!a && !!a.prototype && !!a.prototype.changeType;
        }
        function kd() {
            var a = window1.ManagedMediaSource || window1.MediaSource;
            return a && a.prototype ? !!a.prototype.setLiveSeekableRange && !!a.prototype.clearLiveSeekableRange : !1;
        }
        var hd = new Map;
        function ld() {}
        ld.prototype.extract = function() {};
        ld.prototype.decode = function() {
            return [];
        };
        ld.prototype.clear = function() {};
        ld.prototype.getStreams = function() {
            return [];
        };
        function md() {}
        md.prototype.init = function() {};
        md.prototype.parse = function() {
            return [];
        };
        function nd() {}
        p = nd.prototype;
        p.init = function() {};
        p.Uf = function() {};
        p.ce = function() {};
        p.remove = function() {};
        p.zg = function() {};
        S("shaka.media.IClosedCaptionParser", nd);
        function od(a) {
            this.h = new Map;
            this.i = 0;
            this.j = new md;
            if (a = pd(a.toLowerCase())) this.j = a();
            this.g = new ld;
            if (a = qd) this.g = a(), this.h.set(this.i, this.g);
        }
        p = od.prototype;
        p.init = function(a, b, c) {
            b = b === void 0 ? !1 : b;
            c = c === void 0 ? -1 : c;
            if (c != -1 && this.i != c) {
                b = c;
                var d = this.h.get(b);
                this.h.set(this.i, this.g);
                if (d) this.g = d;
                else {
                    if (d = qd) this.g = d();
                    this.h.set(b, this.g);
                }
            } else b || this.ce();
            this.j.init(a);
            c != -1 && (this.i = c);
        };
        p.Uf = function(a) {
            a = this.j.parse(a);
            a = u(a);
            for(var b = a.next(); !b.done; b = a.next()){
                b = b.value;
                var c = Kb(b.packet);
                c.length > 0 && this.g.extract(c, b.pts);
            }
            return this.g.decode();
        };
        p.ce = function() {
            this.g.clear();
        };
        p.remove = function(a) {
            a = a === void 0 ? [] : a;
            a = new Set(a);
            for(var b = u(this.h.keys()), c = b.next(); !c.done; c = b.next())if (c = c.value, !a.has(c)) {
                var d = this.h.get(c);
                d && d.clear();
                this.h.delete(c);
            }
        };
        p.zg = function() {
            return this.g.getStreams();
        };
        function rd(a, b) {
            sd.set(a, b);
        }
        function pd(a) {
            return sd.get(a);
        }
        S("shaka.media.ClosedCaptionParser", od);
        od.findDecoder = function() {
            return qd;
        };
        od.unregisterDecoder = function() {
            qd = null;
        };
        od.registerDecoder = function(a) {
            qd = a;
        };
        od.findParser = pd;
        od.unregisterParser = function(a) {
            sd.delete(a);
        };
        od.registerParser = rd;
        var sd = new Map, qd = null;
        function td() {
            this.id = "";
            this.regionAnchorY = this.regionAnchorX = this.viewportAnchorY = this.viewportAnchorX = 0;
            this.height = this.width = 100;
            this.viewportAnchorUnits = this.widthUnits = this.heightUnits = ud;
            this.scroll = vd;
        }
        S("shaka.text.CueRegion", td);
        var ud = 1;
        td.units = {
            PX: 0,
            PERCENTAGE: ud,
            LINES: 2
        };
        var vd = "";
        td.scrollMode = {
            NONE: vd,
            UP: "up"
        };
        function wd(a) {
            this.h = a || "";
            this.g = 0;
        }
        function xd(a) {
            yd(a, /[ \t]+/gm);
        }
        function yd(a, b) {
            b.lastIndex = a.g;
            b = b.exec(a.h);
            b = b == null ? null : {
                position: b.index,
                length: b[0].length,
                results: b
            };
            if (a.g == a.h.length || b == null || b.position != a.g) return null;
            a.g += b.length;
            return b.results;
        }
        function zd(a) {
            return a.g == a.h.length ? null : (a = yd(a, /[^ \t\n]*/gm)) ? a[0] : null;
        }
        function Ad(a) {
            a = yd(a, Bd);
            if (a == null) return null;
            var b = Number(a[2]), c = Number(a[3]);
            return b > 59 || c > 59 ? null : (Number(a[6]) || 0) / 1E3 + c + b * 60 + (Number(a[1]) || 0) * 3600;
        }
        function Dd(a) {
            return a ? Ad(new wd(a)) : null;
        }
        var Bd = /(?:(\d{1,}):)?(\d{2}):(\d{2})((\.(\d{1,3})))?/g;
        function Fd() {}
        function Gd(a) {
            function b(d) {
                switch(typeof d){
                    case "undefined":
                    case "boolean":
                    case "number":
                    case "string":
                    case "symbol":
                    case "function":
                        return d;
                    default:
                        if (!d || ArrayBuffer.isView(d)) return d;
                        if (c.has(d)) return null;
                        var e = Array.isArray(d);
                        if (d.constructor != Object && !e) return null;
                        c.add(d);
                        var f = e ? [] : {}, g;
                        for(g in d)f[g] = b(d[g]);
                        e && (f.length = d.length);
                        return f;
                }
            }
            var c = new WeakSet;
            return b(a);
        }
        function Hd(a) {
            var b = {}, c;
            for(c in a)b[c] = a[c];
            return b;
        }
        function Id(a) {
            if (Array.isArray(a)) {
                for(var b = [], c = 0; c < a.length; c++){
                    var d = c.toString(), e = a[c];
                    e !== void 0 && (e = Id(e)) && b.push(d + ":" + e);
                }
                a = "[" + b.join(",") + "]";
            } else if (typeof a == "function") a = "";
            else if (a instanceof Object) {
                c = Object.keys(a);
                c.sort();
                b = [];
                c = u(c);
                for(d = c.next(); !d.done; d = c.next())e = d.value, d = JSON.stringify(e), e = a[e], e !== void 0 && (e = Id(e)) && b.push(d + ":" + e);
                a = "{" + b.join(",") + "}";
            } else a = JSON.stringify(a);
            return a;
        }
        S("shaka.util.ObjectUtils", Fd);
        Fd.alphabeticalKeyOrderStringify = Id;
        Fd.shallowCloneObject = Hd;
        Fd.cloneObject = Gd; /*
 @license
 tXml
 Copyright 2015 Tobias Nickel
 SPDX-License-Identifier: MIT
*/ 
        function Jd(a, b) {
            var c = c === void 0 ? !1 : c;
            a = Zb(a);
            return Kd(a, b, c);
        }
        function Kd(a, b, c) {
            a = Ld(a, c === void 0 ? !1 : c);
            return !b && a.length ? a[0] : (a = a.find(function(d) {
                return b.split(",").includes(d.tagName);
            })) ? a : null;
        }
        function Md(a) {
            return Nd.has(a) ? Nd.get(a) : "";
        }
        function Ld(a, b) {
            function c(f, g) {
                g = g === void 0 ? !1 : g;
                for(var h = []; a[e];)if (a.charCodeAt(e) == 60) {
                    if (a.charCodeAt(e + 1) === 47) {
                        g = e + 2;
                        e = a.indexOf(">", e);
                        g = a.substring(g, e);
                        var k = g.indexOf(f);
                        if (k == -1) {
                            var l = f.indexOf(".");
                            l > 0 && (k = g.indexOf(f.substring(0, l)));
                        }
                        if (k == -1) throw f = a.substring(0, e).split("\n"), Error("Unexpected close tag\nLine: " + (f.length - 1) + "\nColumn: " + (f[f.length - 1].length + 1) + "\nChar: " + a[e]);
                        e + 1 && (e += 1);
                        break;
                    } else if (a.charCodeAt(e + 1) === 33) {
                        if (a.charCodeAt(e + 2) == 45) {
                            for(; e !== -1 && (a.charCodeAt(e) !== 62 || a.charCodeAt(e - 1) != 45 || a.charCodeAt(e - 2) != 45 || e == -1);)e = a.indexOf(">", e + 1);
                            e === -1 && (e = a.length);
                        } else if (a.charCodeAt(e + 2) === 91 && a.charCodeAt(e + 8) === 91 && a.substr(e + 3, 5).toLowerCase() === "cdata") {
                            k = a.indexOf("]]\x3e", e);
                            k == -1 ? (h.push(a.substr(e + 9)), e = a.length) : (h.push(a.substring(e + 9, k)), e = k + 3);
                            continue;
                        }
                        e++;
                        continue;
                    }
                    a: {
                        l = g;
                        e++;
                        var m = d(), n = {};
                        for(k = []; a.charCodeAt(e) !== 62 && a[e];){
                            var q = a.charCodeAt(e);
                            if (q > 64 && q < 91 || q > 96 && q < 123) {
                                q = d();
                                for(var r = a.charCodeAt(e); r && r !== 39 && r !== 34 && !(r > 64 && r < 91 || r > 96 && r < 123) && r !== 62;)e++, r = a.charCodeAt(e);
                                var t = e + 1;
                                e = a.indexOf(a[e], t);
                                t = a.slice(t, e);
                                if (r === 39 || r === 34) {
                                    if (e === -1) {
                                        l = {
                                            tagName: m,
                                            attributes: n,
                                            children: k,
                                            parent: null
                                        };
                                        if (b) for(m = 0; m < k.length; m++)typeof k[m] !== "string" && (k[m].parent = l);
                                        k = l;
                                        break a;
                                    }
                                } else t = null, e--;
                                if (q.startsWith("xmlns:")) {
                                    r = t;
                                    var w = q.split(":")[1];
                                    Nd.set(r, w);
                                    Od.set(w, r);
                                }
                                m === "tt" && q === "xml:space" && t === "preserve" && (l = !0);
                                n[q] = t;
                            }
                            e++;
                        }
                        a.charCodeAt(e - 1) !== 47 ? (e++, k = c(m, l)) : e++;
                        l = {
                            tagName: m,
                            attributes: n,
                            children: k,
                            parent: null
                        };
                        m = k.length;
                        for(n = 0; n < m; n++)q = k[n], typeof q !== "string" ? b && (q.parent = l) : n == m - 1 && q == "\n" && k.pop();
                        k = l;
                    }
                    h.push(k);
                    if (typeof k === "string") break;
                    k.tagName[0] === "?" && k.children && (h.push.apply(h, x(k.children)), k.children = []);
                } else k = e, e = a.indexOf("<", e) - 1, e === -2 && (e = a.length), k = a.slice(k, e + 1), g ? k.length > 0 && h.push(k) : h.length && k.length == 1 && k[0] == "\n" ? h.push(k) : k.trim().length > 0 && h.push(k), e++;
                return h;
            }
            function d() {
                for(var f = e; "\r\n\t>/= ".indexOf(a[e]) === -1 && a[e];)e++;
                return a.slice(f, e);
            }
            var e = 0;
            return c("");
        }
        function Pd(a) {
            return typeof a === "string";
        }
        function Qd(a) {
            var b = [];
            if (!a.children) return [];
            a = u(a.children);
            for(var c = a.next(); !c.done; c = a.next())c = c.value, typeof c !== "string" && b.push(c);
            return b;
        }
        function Rd(a, b) {
            var c = [];
            if (!a.children) return [];
            a = u(a.children);
            for(var d = a.next(); !d.done; d = a.next())d = d.value, d.tagName === b && c.push(d);
            return c;
        }
        function Sd(a) {
            if (typeof a === "string") return cc(a);
            a = a.children.reduce(function(b, c) {
                return typeof c === "string" ? b + c : b;
            }, "");
            return a === "" ? null : cc(a);
        }
        function Td(a) {
            if (!Array.from(a.children).every(function(b) {
                return typeof b === "string";
            })) return null;
            (a = Sd(a)) && (a = a.trim());
            return a;
        }
        function Ud(a, b, c) {
            c = c === void 0 ? [] : c;
            a.tagName === b && c.push(a);
            if (a.children) {
                a = u(a.children);
                for(var d = a.next(); !d.done; d = a.next())Ud(d.value, b, c);
            }
            return c;
        }
        function Vd(a, b) {
            a = Rd(a, b);
            return a.length != 1 ? null : a[0];
        }
        function Wd(a, b, c) {
            a = Xd(a, b, c);
            return a.length != 1 ? null : a[0];
        }
        function Zd(a, b, c, d) {
            d = d === void 0 ? null : d;
            var e = null;
            a = a.attributes[b];
            a != null && (e = c(a));
            return e == null ? d : e;
        }
        function $d(a, b, c) {
            b = Md(b);
            return a.attributes[b + ":" + c] || null;
        }
        function Xd(a, b, c) {
            var d = Md(b);
            b = [];
            if (a.children) for(c = d ? d + ":" + c : c, a = u(a.children), d = a.next(); !d.done; d = a.next())(d = d.value) && d.tagName === c && b.push(d);
            return b;
        }
        function ae(a, b, c) {
            b = u(b);
            for(var d = b.next(); !d.done; d = b.next())if (d = $d(a, d.value, c)) return d;
            return null;
        }
        function be(a) {
            if (!a) return null;
            /^\d+-\d+-\d+T\d+:\d+:\d+(\.\d+)?$/.test(a) && (a += "Z");
            a = Date.parse(a);
            return isNaN(a) ? null : a / 1E3;
        }
        function ce(a) {
            if (!a) return null;
            a = RegExp("^P(?:([0-9]*)Y)?(?:([0-9]*)M)?(?:([0-9]*)D)?(?:T(?:([0-9]*)H)?(?:([0-9]*)M)?(?:([0-9.]*)S)?)?$", "i").exec(a);
            if (!a) return null;
            a = 31536E3 * Number(a[1] || null) + 2592E3 * Number(a[2] || null) + 86400 * Number(a[3] || null) + 3600 * Number(a[4] || null) + 60 * Number(a[5] || null) + Number(a[6] || null);
            return isFinite(a) ? a : null;
        }
        function de(a) {
            var b = /([0-9]+)-([0-9]+)/.exec(a);
            if (!b) return null;
            a = Number(b[1]);
            if (!isFinite(a)) return null;
            b = Number(b[2]);
            return isFinite(b) ? {
                start: a,
                end: b
            } : null;
        }
        function ee(a) {
            a = Number(a);
            return a % 1 === 0 ? a : null;
        }
        function fe(a) {
            a = Number(a);
            return a % 1 === 0 && a > 0 ? a : null;
        }
        function ge(a) {
            a = Number(a);
            return a % 1 === 0 && a >= 0 ? a : null;
        }
        function he(a) {
            a = Number(a);
            return isNaN(a) ? null : a;
        }
        function ie(a) {
            return a ? a.toLowerCase() === "true" : !1;
        }
        function ke(a) {
            var b;
            var c = (b = a.match(/^(\d+)\/(\d+)$/)) ? Number(b[1]) / Number(b[2]) : Number(a);
            return isNaN(c) ? null : c;
        }
        function le(a) {
            var b = [];
            a = cc(a).split(/\/+(?=(?:[^'"]*['"][^'"]*['"])*[^'"]*$)/);
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next()){
                c = c.value;
                var d = c.match(/^([\w]+)/);
                if (d) {
                    var e = c.match(/(@id='(.*?)')/), f = c.match(/(@t='(\d+)')/), g = c.match(/(@n='(\d+)')/), h = c.match(/\[(\d+)\]/);
                    b.push({
                        name: d[0],
                        id: e ? e[0].match(/'(.*?)'/)[0].replace(/'/gm, "") : null,
                        t: f ? Number(f[0].match(/'(.*?)'/)[0].replace(/'/gm, "")) : null,
                        n: g ? Number(g[0].match(/'(.*?)'/)[0].replace(/'/gm, "")) : null,
                        position: h ? Number(h[1]) - 1 : null,
                        Mc: c.split("/@")[1] || null
                    });
                } else c.startsWith("@") && b.length && (b[b.length - 1].Mc = c.slice(1));
            }
            return b;
        }
        function me(a, b) {
            var c = le(b.attributes.sel || "");
            if (c.length) {
                var d = c[c.length - 1], e = b.attributes.pos || null;
                c = d.position;
                c == null && (d.t !== null && (c = ne(a, "t", d.t)), d.n !== null && (c = ne(a, "n", d.n)));
                c === null ? c = e === "prepend" ? 0 : a.length : e === "prepend" ? --c : e === "after" && ++c;
                e = b.tagName;
                (d = d.Mc) && a[c] ? oe(a[c], e, d, Td(b) || "") : (e !== "remove" && e !== "replace" || a.splice(c, 1), e !== "add" && e !== "replace" || a.splice.apply(a, [
                    c,
                    0
                ].concat(x(b.children))));
            }
        }
        function ne(a, b, c) {
            var d = 0;
            a = u(a);
            for(var e = a.next(); !e.done; e = a.next()){
                if (Number(e.value.attributes[b]) === c) return d;
                d++;
            }
            return null;
        }
        function oe(a, b, c, d) {
            if (b === "remove") delete a.attributes[c];
            else if (b === "add" || b === "replace") a.attributes[c] = d;
        }
        function pe(a) {
            var b = "", c = a.tagName.split(":");
            c.length > 0 && (b = c[0], b = Od.has(b) ? Od.get(b) : "");
            b = document.createElementNS(b, a.tagName);
            for(var d in a.attributes)b.setAttribute(d, a.attributes[d]);
            a = u(a.children);
            for(d = a.next(); !d.done; d = a.next())d = d.value, c = void 0, typeof d == "string" ? c = new Text(d) : c = pe(d), b.appendChild(c);
            return b;
        }
        function qe(a) {
            if (!a) return null;
            var b = {
                tagName: a.tagName,
                attributes: Hd(a.attributes),
                children: [],
                parent: null
            };
            a = u(a.children);
            for(var c = a.next(); !c.done; c = a.next())c = c.value, typeof c === "string" ? b.children.push(c) : (c = qe(c), c.parent = b, b.children.push(c));
            return b;
        }
        var Nd = new Map, Od = new Map;
        function re(a, b, c) {
            this.startTime = a;
            this.endTime = b;
            this.payload = c;
            this.region = new td;
            this.position = null;
            this.positionAlign = se;
            this.size = 0;
            this.textAlign = te;
            this.direction = ue;
            this.writingMode = ve;
            this.lineInterpretation = we;
            this.line = null;
            this.lineHeight = "";
            this.lineAlign = xe;
            this.displayAlign = ye;
            this.fontSize = this.border = this.backgroundImage = this.backgroundColor = this.color = "";
            this.fontWeight = ze;
            this.fontStyle = Ae;
            this.linePadding = this.letterSpacing = this.fontFamily = "";
            this.opacity = 1;
            this.textCombineUpright = "";
            this.textDecoration = [];
            this.textStrokeWidth = this.textStrokeColor = this.textShadow = "";
            this.wrapLine = !0;
            this.id = "";
            this.nestedCues = [];
            this.lineBreak = this.isContainer = !1;
            this.rubyTag = null;
            this.cellResolution = {
                columns: 32,
                rows: 15
            };
        }
        function Be(a, b) {
            a = new re(a, b, "");
            a.lineBreak = !0;
            return a;
        }
        re.prototype.clone = function() {
            var a = new re(0, 0, ""), b;
            for(b in this)a[b] = this[b], Array.isArray(a[b]) && (a[b] = a[b].slice());
            return a;
        };
        function Ce(a, b) {
            if (a.payload != b.payload || !(Math.abs(a.startTime - b.startTime) < .001 && Math.abs(a.endTime - b.endTime) < .001)) return !1;
            for(var c in a)if (c != "startTime" && c != "endTime" && c != "payload") {
                if (c == "nestedCues") {
                    if (!Sc(a.nestedCues, b.nestedCues, Ce)) return !1;
                } else if (c == "region" || c == "cellResolution") for(var d in a[c]){
                    if (a[c][d] != b[c][d]) return !1;
                }
                else if (Array.isArray(a[c])) {
                    if (!Sc(a[c], b[c])) return !1;
                } else if (a[c] != b[c]) return !1;
            }
            return !0;
        }
        function De(a, b) {
            b = b === void 0 ? new Map : b;
            var c = a.payload;
            if (c.includes("<")) {
                b.size === 0 && Ee(b);
                var d = c;
                c = [];
                for(var e = -1, f = 0; f < d.length; f++)d[f] === "<" ? e = f + 1 : d[f] === ">" && e > 0 && (e = d.substr(e, f - e), e.match(Fe) && c.push(e), e = -1);
                c = u(c);
                for(f = c.next(); !f.done; f = c.next())f = f.value, d = d.replace("<" + f + ">", '<div time="' + f + '">'), d += "</div>";
                a: {
                    f = d;
                    e = [];
                    var g = -1;
                    c = "";
                    d = !1;
                    for(var h = 0; h < f.length; h++)if (f[h] === "/") {
                        var k = f.indexOf(">", h);
                        if (k === -1) {
                            c = f;
                            break a;
                        }
                        if ((k = f.substring(h + 1, k)) && k == "v") {
                            d = !0;
                            var l = null;
                            e.length && (l = e[e.length - 1]);
                            if (l) {
                                if (l === k) c += "/" + k + ">";
                                else {
                                    if (!l.startsWith("v")) {
                                        c += f[h];
                                        continue;
                                    }
                                    c += "/" + l + ">";
                                }
                                h += k.length + 1;
                            } else c += f[h];
                        } else c += f[h];
                    } else f[h] === "<" ? (g = h + 1, f[g] != "v" && (g = -1)) : f[h] === ">" && g > 0 && (e.push(f.substr(g, h - g)), g = -1), c += f[h];
                    f = u(e);
                    for(e = f.next(); !e.done; e = f.next())e = e.value, g = e.replace(" ", ".voice-"), c = c.replace("<" + e + ">", "<" + g + ">"), c = c.replace("</" + e + ">", "</" + g + ">"), d || (c += "</" + g + ">");
                }
                c = Ge(c);
                a.payload = "";
                try {
                    var m = Kd("<span>" + c + "</span>", "span");
                } catch (n) {}
                if (m) {
                    if (m = m.children, m.length != 1 || m[0].tagName) for(m = u(m), c = m.next(); !c.done; c = m.next())He(c.value, a, b);
                    else a.payload = cc(c);
                } else a.payload = cc(c);
            } else a.payload = cc(c);
        }
        function Ee(a) {
            for(var b = u(Object.entries(Ie)), c = b.next(); !c.done; c = b.next()){
                var d = u(c.value);
                c = d.next().value;
                d = d.next().value;
                var e = new re(0, 0, "");
                e.color = d;
                a.set("." + c, e);
            }
            b = u(Object.entries(Ke));
            for(c = b.next(); !c.done; c = b.next())d = u(c.value), c = d.next().value, d = d.next().value, e = new re(0, 0, ""), e.backgroundColor = d, a.set("." + c, e);
        }
        function Ge(a) {
            var b = {
                "< ": "",
                " >": " &gt;"
            }, c = /(< +>|<\s|\s>)/g, d = RegExp(c.source);
            return a && d.test(a) ? a.replace(c, function(e) {
                return b[e] || "";
            }) : a || "";
        }
        function He(a, b, c) {
            var d = b.clone();
            d.nestedCues = [];
            d.payload = "";
            d.rubyTag = "";
            d.line = null;
            d.region = new td;
            d.position = null;
            d.size = 0;
            d.textAlign = te;
            if (a.tagName) for(var e = u(a.tagName.split(/(?=[ .])+/g)), f = e.next(); !f.done; f = e.next()){
                var g = f = f.value;
                if (g.startsWith(".voice-")) {
                    var h = g.split("-").pop();
                    g = 'v[voice="' + h + '"]';
                    c.has(g) || (g = "v[voice=" + h + "]");
                }
                c.has(g) && (h = d, g = c.get(g)) && (h.backgroundColor = Ne(g.backgroundColor, h.backgroundColor), h.color = Ne(g.color, h.color), h.fontFamily = Ne(g.fontFamily, h.fontFamily), h.fontSize = Ne(g.fontSize, h.fontSize), h.textShadow = Ne(g.textShadow, h.textShadow), h.fontWeight = g.fontWeight, h.fontStyle = g.fontStyle, h.opacity = g.opacity, h.rubyTag = g.rubyTag, h.textCombineUpright = g.textCombineUpright, h.wrapLine = g.wrapLine);
                switch(f){
                    case "br":
                        d = Be(d.startTime, d.endTime);
                        b.nestedCues.push(d);
                        return;
                    case "b":
                        d.fontWeight = Oe;
                        break;
                    case "i":
                        d.fontStyle = Pe;
                        break;
                    case "u":
                        d.textDecoration.push(Qe);
                        break;
                    case "font":
                        if (f = a.attributes.color) d.color = f;
                        break;
                    case "div":
                        f = a.attributes.time;
                        if (!f) break;
                        if (f = Dd(f)) d.startTime = f;
                        break;
                    case "ruby":
                    case "rp":
                    case "rt":
                        d.rubyTag = f;
                }
            }
            e = a.children;
            if (Pd(a) || e.length == 1 && Pd(e[0])) for(c = Sd(a).split("\n"), a = !0, c = u(c), e = c.next(); !e.done; e = c.next())e = e.value, a || (a = Be(d.startTime, d.endTime), b.nestedCues.push(a)), e.length > 0 && (a = d.clone(), a.payload = cc(e), b.nestedCues.push(a)), a = !1;
            else for(b.nestedCues.push(d), b = u(e), a = b.next(); !a.done; a = b.next())He(a.value, d, c);
        }
        function Ne(a, b) {
            return a && a.length > 0 ? a : b;
        }
        S("shaka.text.Cue", re);
        re.parseCuePayload = De;
        re.equal = Ce;
        re.prototype.clone = re.prototype.clone;
        var se = "auto";
        re.positionAlign = {
            LEFT: "line-left",
            RIGHT: "line-right",
            CENTER: "center",
            AUTO: se
        };
        var te = "center", Re = {
            LEFT: "left",
            RIGHT: "right",
            CENTER: te,
            START: "start",
            END: "end"
        };
        re.textAlign = Re;
        var ye = "after", Se = {
            BEFORE: "before",
            CENTER: "center",
            AFTER: ye
        };
        re.displayAlign = Se;
        var ue = "ltr";
        re.direction = {
            HORIZONTAL_LEFT_TO_RIGHT: ue,
            HORIZONTAL_RIGHT_TO_LEFT: "rtl"
        };
        var ve = "horizontal-tb";
        re.writingMode = {
            HORIZONTAL_TOP_TO_BOTTOM: ve,
            VERTICAL_LEFT_TO_RIGHT: "vertical-lr",
            VERTICAL_RIGHT_TO_LEFT: "vertical-rl"
        };
        var we = 0;
        re.lineInterpretation = {
            LINE_NUMBER: we,
            PERCENTAGE: 1
        };
        var xe = "start", Te = {
            CENTER: "center",
            START: xe,
            END: "end"
        };
        re.lineAlign = Te;
        var Ie = {
            white: "white",
            lime: "lime",
            cyan: "cyan",
            red: "red",
            yellow: "yellow",
            magenta: "magenta",
            blue: "blue",
            black: "black"
        };
        re.defaultTextColor = Ie;
        var Ke = {
            bg_white: "white",
            bg_lime: "lime",
            bg_cyan: "cyan",
            bg_red: "red",
            bg_yellow: "yellow",
            bg_magenta: "magenta",
            bg_blue: "blue",
            bg_black: "black"
        };
        re.defaultTextBackgroundColor = Ke;
        var ze = 400, Oe = 700;
        re.fontWeight = {
            NORMAL: ze,
            BOLD: Oe
        };
        var Ae = "normal", Pe = "italic", Ue = {
            NORMAL: Ae,
            ITALIC: Pe,
            OBLIQUE: "oblique"
        };
        re.fontStyle = Ue;
        var Qe = "underline";
        re.textDecoration = {
            UNDERLINE: Qe,
            LINE_THROUGH: "lineThrough",
            OVERLINE: "overline"
        };
        var Fe = /(?:(\d{1,}):)?(\d{2}):(\d{2})\.(\d{2,3})/g;
        function Ve() {}
        Ve.prototype.destroy = function() {};
        function We(a, b, c) {
            Xe.set(a.toLowerCase().split(";")[0] + "-" + c, {
                priority: c,
                Vf: b
            });
        }
        function Ye(a, b) {
            for(var c = a.toLowerCase().split(";")[0], d = u([
                Ze,
                $e,
                af,
                bf
            ]), e = d.next(); !e.done; e = d.next())if (e = Xe.get(c + "-" + e.value)) {
                var f = e.Vf(), g = f.isSupported(a, b);
                f.destroy();
                if (g) return e.Vf;
            }
            return null;
        }
        S("shaka.transmuxer.TransmuxerEngine", Ve);
        Ve.findTransmuxer = Ye;
        Ve.unregisterTransmuxer = function(a, b) {
            Xe.delete(a.toLowerCase().split(";")[0] + "-" + b);
        };
        Ve.registerTransmuxer = We;
        Ve.prototype.destroy = Ve.prototype.destroy;
        var Xe = new Map, bf = 1, af = 2, $e = 3, Ze = 4;
        Ve.PluginPriority = {
            FALLBACK: bf,
            PREFERRED_SECONDARY: af,
            PREFERRED: $e,
            APPLICATION: Ze
        };
        function cf() {}
        function df(a, b) {
            var c = a;
            b && !ef.includes(a) && (c += '; codecs="' + b + '"');
            return c;
        }
        function ff(a, b) {
            b && (a += '; codecs="' + b + '"');
            return a;
        }
        function gf(a, b, c) {
            var d = df(a, b);
            b = ff(a, b);
            Ye(b) ? (a = Ye(b)) ? (a = a(), c = a.convertCodecs(c, b), a.destroy()) : c = b : c = a != "video/mp2t" && c == "audio" ? d.replace("video", "audio") : d;
            return c;
        }
        function hf(a) {
            return a.split(";")[0].split("/")[1];
        }
        function jf(a) {
            var b = kf(a);
            a = b[0].toLowerCase();
            b = b[1].toLowerCase();
            switch(!0){
                case a === "mp4a" && b === "69":
                case a === "mp4a" && b === "6b":
                case a === "mp4a" && b === "40.34":
                    return "mp3";
                case a === "mp4a" && b === "66":
                case a === "mp4a" && b === "67":
                case a === "mp4a" && b === "68":
                case a === "mp4a" && b === "40.2":
                case a === "mp4a" && b === "40.02":
                case a === "mp4a" && b === "40.5":
                case a === "mp4a" && b === "40.05":
                case a === "mp4a" && b === "40.29":
                case a === "mp4a" && b === "40.42":
                    return "aac";
                case a === "mp4a" && b === "a5":
                case a === "ac3":
                case a === "ac-3":
                    return "ac-3";
                case a === "mp4a" && b === "a6":
                case a === "eac3":
                case a === "ec-3":
                    return "ec-3";
                case a === "ac-4":
                    return "ac-4";
                case a === "mp4a" && b === "b2":
                    return "dtsx";
                case a === "mp4a" && b === "a9":
                    return "dtsc";
                case a === "vp09":
                case a === "vp9":
                    return "vp9";
                case a === "avc1":
                case a === "avc3":
                    return "avc";
                case a === "hvc1":
                case a === "hev1":
                    return "hevc";
                case a === "vvc1":
                case a === "vvi1":
                    return "vvc";
                case a === "dvh1":
                case a === "dvhe":
                    return b && b.startsWith("05") ? "dovi-p5" : "dovi-hevc";
                case a === "dvav":
                case a === "dva1":
                    return "dovi-avc";
                case a === "dav1":
                    return "dovi-av1";
                case a === "dvc1":
                case a === "dvi1":
                    return "dovi-vvc";
            }
            return a;
        }
        function lf(a) {
            var b = [];
            a = u(a.split(","));
            for(var c = a.next(); !c.done; c = a.next())c = kf(c.value), b.push(c[0]);
            return b.sort().join(",");
        }
        function mf(a) {
            return a.split(";")[0];
        }
        function nf(a) {
            a = a.split(/ *; */);
            a.shift();
            return (a = a.find(function(b) {
                return b.startsWith("codecs=");
            })) ? a.split("=")[1].replace(/^"|"$/g, "") : "";
        }
        function of(a) {
            return a === "application/x-mpegurl" || a === "application/vnd.apple.mpegurl";
        }
        function kf(a) {
            a = a.split(".");
            var b = a[0];
            a.shift();
            return [
                b,
                a.join(".")
            ];
        }
        S("shaka.util.MimeUtils", cf);
        cf.getFullTypeWithAllCodecs = ff;
        cf.getFullType = df;
        (new Map).set("codecs", "codecs").set("frameRate", "framerate").set("bandwidth", "bitrate").set("width", "width").set("height", "height").set("channelsCount", "channels");
        var ef = [
            "audio/aac",
            "audio/ac3",
            "audio/ec3",
            "audio/mpeg"
        ];
        function pf(a) {
            this.i = null;
            this.j = a;
            this.D = !1;
            this.l = this.A = 0;
            this.m = Infinity;
            this.h = this.g = null;
            this.F = "";
            this.C = function() {};
            this.u = new Map;
        }
        function qf(a, b) {
            rf.set(a, b);
        }
        function sf(a) {
            return rf.get(a);
        }
        function tf(a) {
            return rf.has(a) ? !0 : a == "application/cea-608" || a == "application/cea-708" ? !!qd : !1;
        }
        pf.prototype.destroy = function() {
            this.j = this.i = null;
            this.u.clear();
            return Promise.resolve();
        };
        function uf(a, b, c, d, e) {
            var f, g, h, k, l, m, n;
            return Q(function(q) {
                if (q.g == 1) return F(q, Promise.resolve(), 2);
                if (!a.i || !a.j) return q.return();
                if (c == null || d == null) return a.i.parseInit(Kb(b)), q.return();
                f = a.D ? c : a.A;
                g = {
                    periodStart: a.A,
                    segmentStart: c,
                    segmentEnd: d,
                    vttOffset: f
                };
                h = a.i.parseMedia(Kb(b), g, e, []);
                k = u(h);
                for(l = k.next(); !l.done; l = k.next())m = l.value, a.C(m, e || null, g);
                n = h.filter(function(r) {
                    return r.startTime >= a.l && r.startTime < a.m;
                });
                a.j.append(n);
                a.g == null && (a.g = Math.max(c, a.l));
                a.h = Math.min(d, a.m);
                H(q);
            });
        }
        pf.prototype.remove = function(a, b) {
            var c = this;
            return Q(function(d) {
                if (d.g == 1) return F(d, Promise.resolve(), 2);
                !c.j || !c.j.remove(a, b) || c.g == null || b <= c.g || a >= c.h || (a <= c.g && b >= c.h ? c.g = c.h = null : a <= c.g && b < c.h ? c.g = b : a > c.g && b >= c.h && (c.h = a));
                H(d);
            });
        };
        function vf(a, b, c) {
            a.l = b;
            a.m = c;
        }
        function wf(a, b, c) {
            a.F = b;
            if (b = a.u.get(b)) for(var d = u(b.keys()), e = d.next(); !e.done; e = d.next())(e = b.get(e.value).filter(function(f) {
                return f.endTime <= c;
            })) && a.j.append(e);
        }
        function yf(a, b, c) {
            b.startTime += c;
            b.endTime += c;
            b = u(b.nestedCues);
            for(var d = b.next(); !d.done; d = b.next())yf(a, d.value, c);
        }
        function zf(a, b, c, d, e) {
            var f = c + " " + d, g = new Map;
            b = u(b);
            for(var h = b.next(); !h.done; h = b.next()){
                var k = h.value;
                h = k.stream;
                k = k.cue;
                g.has(h) || g.set(h, new Map);
                g.get(h).has(f) || g.get(h).set(f, []);
                yf(a, k, e);
                k.startTime >= a.l && k.startTime < a.m && (g.get(h).get(f).push(k), h == a.F && a.j.append([
                    k
                ]));
            }
            e = u(g.keys());
            for(f = e.next(); !f.done; f = e.next())for(f = f.value, a.u.has(f) || a.u.set(f, new Map), b = u(g.get(f).keys()), h = b.next(); !h.done; h = b.next())h = h.value, k = g.get(f).get(h), a.u.get(f).set(h, k);
            a.g = a.g == null ? Math.max(c, a.l) : Math.min(a.g, Math.max(c, a.l));
            a.h = Math.max(a.h, Math.min(d, a.m));
        }
        S("shaka.text.TextEngine", pf);
        pf.prototype.destroy = pf.prototype.destroy;
        pf.findParser = sf;
        pf.unregisterParser = function(a) {
            rf.delete(a);
        };
        pf.registerParser = qf;
        var rf = new Map;
        function Af(a) {
            this.h = a;
            this.g = null;
        }
        Af.prototype.$ = function(a) {
            var b = this;
            this.stop();
            var c = !0, d = null;
            this.g = function() {
                window1.clearTimeout(d);
                c = !1;
            };
            d = window1.setTimeout(function() {
                c && b.h();
            }, a * 1E3);
            return this;
        };
        Af.prototype.stop = function() {
            this.g && (this.g(), this.g = null);
        };
        function Bf(a) {
            this.h = a;
            this.g = null;
        }
        Bf.prototype.La = function() {
            this.stop();
            this.h();
            return this;
        };
        Bf.prototype.$ = function(a) {
            var b = this;
            this.stop();
            this.g = new Af(function() {
                b.h();
            }).$(a);
            return this;
        };
        Bf.prototype.wa = function(a) {
            var b = this;
            this.stop();
            this.g = new Af(function() {
                b.g.$(a);
                b.h();
            }).$(a);
            return this;
        };
        Bf.prototype.stop = function() {
            this.g && (this.g.stop(), this.g = null);
        };
        S("shaka.util.Timer", Bf);
        Bf.prototype.stop = Bf.prototype.stop;
        Bf.prototype.tickEvery = Bf.prototype.wa;
        Bf.prototype.tickAfter = Bf.prototype.$;
        Bf.prototype.tickNow = Bf.prototype.La;
        function Cf(a, b) {
            return a.concat(b);
        }
        function Df() {}
        function Ef(a) {
            return a != null;
        }
        function Ff(a, b) {
            return Promise.race([
                b,
                new Promise(function(c, d) {
                    new Bf(d).$(a);
                })
            ]);
        }
        function Gf() {}
        function Hf(a, b, c, d, e) {
            function f(z) {
                var y = String(z.width || "") + String(z.height || "") + String(Math.round(z.frameRate || 0)) + (z.hdr || "") + z.fastSwitching;
                z.dependencyStream && (y += z.dependencyStream.baseOriginalId || "");
                z.roles && (y += z.roles.sort().join("_"));
                return y;
            }
            function g(z) {
                var y = z.language + (z.channelsCount || 0) + (z.audioSamplingRate || 0) + z.roles.join(",") + z.label + z.groupId + z.fastSwitching;
                z.dependencyStream && (y += z.dependencyStream.baseOriginalId || "");
                return y;
            }
            if (e.length) {
                var h = a.textStreams;
                e = u(e);
                for(var k = e.next(), l = {}; !k.done; l = {
                    si: void 0
                }, k = e.next())if (l.si = k.value, k = h.filter(function(z) {
                    return function(y) {
                        return y.codecs.startsWith(z.si) || y.mimeType.startsWith(z.si) ? !0 : !1;
                    };
                }(l)), k.length) {
                    h = k;
                    break;
                }
                a.textStreams = h;
            }
            h = a.variants;
            if (b.length || c.length) h = If(h, b, c);
            if (d.length) {
                b = new hb;
                c = u(h);
                for(h = c.next(); !h.done; h = c.next())h = h.value, b.push(String(h.video.width || 0), h);
                var m = [];
                b.forEach(function(z, y) {
                    z = 0;
                    var A = [];
                    y = u(y);
                    for(var C = y.next(), E = {}; !C.done; E = {
                        xg: void 0
                    }, C = y.next())E.xg = C.value, C = d.filter(function(D) {
                        return function(B) {
                            return D.xg.decodingInfos[0][B];
                        };
                    }(E)).length, C > z ? (z = C, A = [
                        E.xg
                    ]) : C == z && A.push(E.xg);
                    m.push.apply(m, x(A));
                });
                h = m;
            }
            c = new Set;
            b = new Set;
            h = u(h);
            for(e = h.next(); !e.done; e = h.next())e = e.value, e.audio && c.add(e.audio), e.video && b.add(e.video);
            h = Array.from(c).sort(function(z, y) {
                return z.bandwidth - y.bandwidth;
            });
            var n = [];
            c = new Map;
            h = u(h);
            for(e = h.next(); !e.done; e = h.next()){
                e = e.value;
                k = g(e);
                l = c.get(k) || [];
                if (l.length) {
                    var q = l[l.length - 1], r = jf(q.codecs), t = jf(e.codecs);
                    r != t || e.bandwidth && q.bandwidth && !(e.bandwidth > q.bandwidth) || (l.push(e), n.push(e.id));
                } else l.push(e), n.push(e.id);
                c.set(k, l);
            }
            var w = {
                vp8: 1,
                avc: 1,
                "dovi-avc": .95,
                vp9: .9,
                vp09: .9,
                hevc: .85,
                "dovi-hevc": .8,
                "dovi-p5": .75,
                av01: .7,
                "dovi-av1": .65,
                vvc: .6
            };
            h = Array.from(b).sort(function(z, y) {
                if (!z.bandwidth || !y.bandwidth || z.bandwidth == y.bandwidth) {
                    if (z.codecs && y.codecs && z.codecs != y.codecs && z.width == y.width) {
                        var A = jf(z.codecs), C = jf(y.codecs);
                        if (A != C) return (w[A] || 1) - (w[C] || 1);
                    }
                    return z.width - y.width;
                }
                return z.bandwidth - y.bandwidth;
            });
            b = id();
            var v = [];
            c = new Map;
            h = u(h);
            for(e = h.next(); !e.done; e = h.next()){
                e = e.value;
                k = f(e);
                l = c.get(k) || [];
                if (l.length) {
                    q = l[l.length - 1];
                    if (!b && (r = jf(q.codecs), t = jf(e.codecs), r !== t)) continue;
                    r = jf(q.codecs);
                    t = jf(e.codecs);
                    r != t || e.bandwidth && q.bandwidth && !(e.bandwidth > q.bandwidth) || (l.push(e), v.push(e.id));
                } else l.push(e), v.push(e.id);
                c.set(k, l);
            }
            a.variants = a.variants.filter(function(z) {
                var y = z.audio;
                z = z.video;
                return y && !n.includes(y.id) || z && !v.includes(z.id) ? !1 : !0;
            });
        }
        function If(a, b, c) {
            b = u(b);
            for(var d = b.next(), e = {}; !d.done; e = {
                videoCodec: void 0
            }, d = b.next())if (e.videoCodec = d.value, d = a.filter(function(f) {
                return function(g) {
                    return g.video && g.video.codecs.startsWith(f.videoCodec);
                };
            }(e)), d.length) {
                a = d;
                break;
            }
            c = u(c);
            b = c.next();
            for(d = {}; !b.done; d = {
                audioCodec: void 0
            }, b = c.next())if (d.audioCodec = b.value, b = a.filter(function(f) {
                return function(g) {
                    return g.audio && g.audio.codecs.startsWith(f.audioCodec);
                };
            }(d)), b.length) {
                a = b;
                break;
            }
            return a;
        }
        function Jf(a, b, c) {
            a.variants = a.variants.filter(function(d) {
                return Kf(d, b, c);
            });
        }
        function Kf(a, b, c) {
            function d(h, k, l) {
                return h >= k && h <= l;
            }
            var e = a.video;
            if (e && e.width && e.height) {
                var f = e.width, g = e.height;
                g > f && (g = u([
                    g,
                    f
                ]), f = g.next().value, g = g.next().value);
                if (!d(f, b.minWidth, Math.min(b.maxWidth, c.width)) || !d(g, b.minHeight, Math.min(b.maxHeight, c.height)) || !d(e.width * e.height, b.minPixels, b.maxPixels)) return !1;
            }
            return a && a.video && a.video.frameRate && !d(a.video.frameRate, b.minFrameRate, b.maxFrameRate) || a && a.audio && a.audio.channelsCount && !d(a.audio.channelsCount, b.minChannelsCount, b.maxChannelsCount) || !d(a.bandwidth, b.minBandwidth, b.maxBandwidth) ? !1 : !0;
        }
        function Lf(a, b, c, d) {
            c = c === void 0 ? [] : c;
            d = d === void 0 ? {} : d;
            return Q(function(e) {
                if (e.g == 1) return F(e, Mf(a, b, b.offlineSessionIds.length > 0, c, d), 2);
                Nf(b);
                return F(e, Of(b), 0);
            });
        }
        function Mf(a, b, c, d, e) {
            var f, g;
            return Q(function(h) {
                if (h.g == 1) return Rb().Qj() && Pf(b.variants), F(h, Qf(b.variants, c, !1, d), 2);
                f = null;
                a && (g = a.g) && (f = g.keySystem);
                b.variants = b.variants.filter(function(k) {
                    var l = Rf(k, f, e);
                    if (!l) {
                        var m = [];
                        k.audio && m.push(Sf(k.audio));
                        k.video && m.push(Sf(k.video));
                    }
                    return l;
                });
                H(h);
            });
        }
        function Pf(a) {
            var b = (new Map).set("dvav", "avc3").set("dva1", "avc1").set("dvhe", "hev1").set("dvh1", "hvc1").set("dvc1", "vvc1").set("dvi1", "vvi1"), c = new Set;
            a = u(a);
            for(var d = a.next(); !d.done; d = a.next())d = d.value, d.video && c.add(d.video);
            c = u(c);
            for(a = c.next(); !a.done; a = c.next()){
                a = a.value;
                d = u(b);
                for(var e = d.next(); !e.done; e = d.next()){
                    var f = u(e.value);
                    e = f.next().value;
                    f = f.next().value;
                    if (a.codecs.includes(e)) {
                        a.codecs = a.codecs.replace(e, f);
                        break;
                    }
                }
            }
        }
        function Rf(a, b, c) {
            if (!a.decodingInfos.some(function(k) {
                return !k.supported || b && (k = k.keySystemAccess) && (c[k.keySystem] || k.keySystem) != b ? !1 : !0;
            })) return !1;
            var d = Rb(), e = d.Ub() === "Xbox";
            d = d.Ka() === "MOBILE" && d.Ja() === "GECKO";
            var f = a.video, g = f && f.width || 0, h = f && f.height || 0;
            if (e && f && (g > 1920 || h > 1080) && (f.codecs.includes("avc1.") || f.codecs.includes("avc3.")) || (e = f && f.dependencyStream) && !fd(e)) return !1;
            a = a.audio;
            return d && a && a.encrypted && a.codecs.toLowerCase().includes("opus") || a && a.dependencyStream ? !1 : !0;
        }
        function Tf(a, b) {
            var c, d, e, f, g, h, k;
            return Q(function(l) {
                if (l.g == 1) {
                    c = function(m, n) {
                        if (m) {
                            var q = Hd(m);
                            q.supported = m.supported && n.supported;
                            q.powerEfficient = m.powerEfficient && n.powerEfficient;
                            q.smooth = m.smooth && n.smooth;
                            n.keySystemAccess && !q.keySystemAccess && (q.keySystemAccess = n.keySystemAccess);
                            return q;
                        }
                        return n;
                    };
                    d = null;
                    e = [];
                    f = u(b);
                    g = f.next();
                    for(h = {}; !g.done; h = {
                        cache: void 0,
                        jf: void 0
                    }, g = f.next())k = g.value, h.jf = Id(k), h.cache = Uf, h.cache.has(h.jf) ? d = c(d, h.cache.get(h.jf)) : e.push(Vf(k).then(function(m) {
                        return function(n) {
                            var q = null;
                            n = u(n || []);
                            for(var r = n.next(); !r.done; r = n.next())q = c(q, r.value);
                            q && (m.cache.set(m.jf, q), d = c(d, q));
                        };
                    }(h)));
                    return F(l, Promise.all(e), 2);
                }
                d && a.decodingInfos.push(d);
                H(l);
            });
        }
        function Vf(a) {
            var b = [
                ""
            ];
            a.video && (b = nf(a.video.contentType).split(","));
            var c = [
                ""
            ];
            a.audio && (c = nf(a.audio.contentType).split(","));
            var d = [];
            b = u(b);
            for(var e = b.next(); !e.done; e = b.next()){
                e = e.value;
                for(var f = u(c), g = f.next(), h = {}; !g.done; h = {
                    ed: void 0
                }, g = f.next())g = g.value, h.ed = Gd(a), a.video && (h.ed.video.contentType = df(mf(h.ed.video.contentType), e)), a.audio && (h.ed.audio.contentType = df(mf(h.ed.audio.contentType), g)), d.push(new Promise(function(k) {
                    return function(l, m) {
                        (Rb().Ka() == "MOBILE" ? Ff(5, navigator.mediaCapabilities.decodingInfo(k.ed)) : navigator.mediaCapabilities.decodingInfo(k.ed)).then(function(n) {
                            l(n);
                        }).catch(m);
                    };
                }(h)));
            }
            return Promise.all(d).catch(function() {
                JSON.stringify(a);
                return null;
            });
        }
        function Qf(a, b, c, d) {
            var e, f, g, h, k, l, m, n, q, r, t, w, v, z, y, A, C, E, D;
            return Q(function(B) {
                switch(B.g){
                    case 1:
                        if (e = a.some(function(G) {
                            return G.decodingInfos.length;
                        })) return B.return();
                        f = u(d);
                        g = f.next();
                        h = {};
                    case 2:
                        if (g.done) {
                            B.B(4);
                            break;
                        }
                        h.vj = g.value;
                        k = !1;
                        l = u(a);
                        m = l.next();
                    case 5:
                        if (m.done) {
                            B.B(7);
                            break;
                        }
                        n = m.value;
                        q = Wf(n, b, c).filter(function(G) {
                            return function(I) {
                                I = I[0];
                                return (I.keySystemConfiguration && I.keySystemConfiguration.keySystem) === G.vj;
                            };
                        }(h));
                        r = u(q);
                        t = r.next();
                    case 8:
                        if (t.done) {
                            B.B(10);
                            break;
                        }
                        w = t.value;
                        return F(B, Tf(n, w), 9);
                    case 9:
                        t = r.next();
                        B.B(8);
                        break;
                    case 10:
                        n.decodingInfos.some(function(G) {
                            return G.supported;
                        }) && (k = !0);
                        m = l.next();
                        B.B(5);
                        break;
                    case 7:
                        if (k) return B.return();
                        h = {
                            vj: void 0
                        };
                        g = f.next();
                        B.B(2);
                        break;
                    case 4:
                        v = u(a), z = v.next();
                    case 12:
                        if (z.done) {
                            B.B(0);
                            break;
                        }
                        y = z.value;
                        A = Wf(y, b, c).filter(function(G) {
                            G = G[0];
                            G = G.keySystemConfiguration && G.keySystemConfiguration.keySystem;
                            return !G || !d.includes(G);
                        });
                        C = u(A);
                        E = C.next();
                    case 15:
                        if (E.done) {
                            z = v.next();
                            B.B(12);
                            break;
                        }
                        D = E.value;
                        return F(B, Tf(y, D), 16);
                    case 16:
                        E = C.next(), B.B(15);
                }
            });
        }
        function Wf(a, b, c) {
            var d = a.audio, e = a.video, f = [], g = [];
            if (e) for(var h = u(e.fullMimeTypes), k = h.next(); !k.done; k = h.next()){
                k = k.value;
                var l = nf(k);
                if (l.includes(",") && !d) {
                    var m = l.split(","), n = mf(k);
                    l = pc("video", m);
                    m = pc("audio", m);
                    m = Xf(m, n);
                    n = gf(n, m, "audio");
                    g.push({
                        contentType: n,
                        channels: 2,
                        bitrate: a.bandwidth || 1,
                        samplerate: 1,
                        spatialRendering: !1
                    });
                }
                l = Yf(l);
                k = {
                    contentType: gf(mf(k), l, "video"),
                    width: e.width || 64,
                    height: e.height || 64,
                    bitrate: e.bandwidth || a.bandwidth || 1,
                    framerate: e.frameRate || 30
                };
                if (e.hdr) switch(e.hdr){
                    case "PQ":
                        k.transferFunction = "pq";
                        break;
                    case "HLG":
                        k.transferFunction = "hlg";
                }
                e.colorGamut && (k.colorGamut = e.colorGamut);
                f.push(k);
            }
            if (d) for(h = u(d.fullMimeTypes), k = h.next(); !k.done; k = h.next())l = k.value, k = mf(l), l = Xf(nf(l), k), k = gf(k, l, "audio"), g.push({
                contentType: k,
                channels: d.channelsCount || 2,
                bitrate: d.bandwidth || a.bandwidth || 1,
                samplerate: d.audioSamplingRate || 1,
                spatialRendering: d.spatialAudio
            });
            h = [];
            f.length == 0 && f.push(null);
            g.length == 0 && g.push(null);
            f = u(f);
            for(k = f.next(); !k.done; k = f.next())for(k = k.value, l = u(g), n = l.next(); !n.done; n = l.next())n = n.value, m = {
                type: c ? "file" : "media-source"
            }, k && (m.video = k), n && (m.audio = n), h.push(m);
            g = (a.video ? a.video.drmInfos : []).concat(a.audio ? a.audio.drmInfos : []);
            if (!g.length) return [
                h
            ];
            a = [];
            c = new Map;
            g = u(g);
            for(f = g.next(); !f.done; f = g.next())f = f.value, c.get(f.keySystem) || c.set(f.keySystem, []), c.get(f.keySystem).push(f);
            g = b ? "required" : "optional";
            b = b ? [
                "persistent-license"
            ] : [
                "temporary"
            ];
            f = u(c.keys());
            for(k = f.next(); !k.done; k = f.next()){
                k = k.value;
                n = c.get(k);
                l = new Map;
                n = u(n);
                for(m = n.next(); !m.done; m = n.next()){
                    m = m.value;
                    var q = m.videoRobustness + "," + m.audioRobustness;
                    l.get(q) || l.set(q, []);
                    l.get(q).push(m);
                }
                l = u(l.values());
                for(n = l.next(); !n.done; n = l.next()){
                    n = n.value;
                    m = [];
                    q = u(h);
                    for(var r = q.next(); !r.done; r = q.next()){
                        r = Object.assign({}, r.value);
                        for(var t = {
                            keySystem: k,
                            initDataType: "cenc",
                            persistentState: g,
                            distinctiveIdentifier: "optional",
                            sessionTypes: b
                        }, w = u(n), v = w.next(); !v.done; v = w.next()){
                            v = v.value;
                            if (v.initData && v.initData.length) {
                                for(var z = new Set, y = u(v.initData), A = y.next(); !A.done; A = y.next())z.add(A.value.initDataType);
                                t.initDataType = v.initData[0].initDataType;
                            }
                            v.distinctiveIdentifierRequired && (t.distinctiveIdentifier = "required");
                            v.persistentStateRequired && (t.persistentState = "required");
                            v.sessionType && (t.sessionTypes = [
                                v.sessionType
                            ]);
                            d && (t.audio ? (v.encryptionScheme && (t.audio.encryptionScheme = t.audio.encryptionScheme || v.encryptionScheme), t.audio.robustness = t.audio.robustness || v.audioRobustness) : (t.audio = {
                                robustness: v.audioRobustness
                            }, v.encryptionScheme && (t.audio.encryptionScheme = v.encryptionScheme)), t.audio.robustness == "" && delete t.audio.robustness);
                            e && (t.video ? (v.encryptionScheme && (t.video.encryptionScheme = t.video.encryptionScheme || v.encryptionScheme), t.video.robustness = t.video.robustness || v.videoRobustness) : (t.video = {
                                robustness: v.videoRobustness
                            }, v.encryptionScheme && (t.video.encryptionScheme = v.encryptionScheme)), t.video.robustness == "" && delete t.video.robustness);
                        }
                        r.keySystemConfiguration = t;
                        m.push(r);
                    }
                    a.push(m);
                }
            }
            return a;
        }
        function Xf(a, b) {
            var c = Rb();
            return a.toLowerCase() == "flac" ? c.Ja() != "WEBKIT" ? "flac" : "fLaC" : a.toLowerCase() === "opus" ? c.Ja() != "WEBKIT" ? "opus" : hf(b) == "mp4" ? "Opus" : "opus" : a.toLowerCase() == "ac-3" && c.Fe() ? "ec-3" : a;
        }
        function Yf(a) {
            if (a.includes("avc1")) {
                var b = a.split(".");
                if (b.length == 3) return a = b.shift() + ".", a += parseInt(b.shift(), 10).toString(16), a += ("000" + parseInt(b.shift(), 10).toString(16)).slice(-4);
            } else if (a == "vp9") return "vp09.00.41.08";
            return a;
        }
        function Nf(a) {
            a.textStreams = a.textStreams.filter(function(b) {
                b = df(b.mimeType, b.codecs);
                return tf(b);
            });
        }
        function Of(a) {
            var b, c, d, e, f, g, h, k;
            return Q(function(l) {
                switch(l.g){
                    case 1:
                        b = [], c = u(a.imageStreams), d = c.next();
                    case 2:
                        if (d.done) {
                            l.B(4);
                            break;
                        }
                        e = d.value;
                        f = e.mimeType;
                        f == "application/mp4" && e.codecs == "mjpg" && (f = "image/jpg");
                        if (Zf.has(f)) {
                            l.B(5);
                            break;
                        }
                        g = $f.get(f);
                        if (!g) {
                            Zf.set(f, !1);
                            l.B(5);
                            break;
                        }
                        return F(l, ag(g), 7);
                    case 7:
                        h = l.h, Zf.set(f, h);
                    case 5:
                        (k = Zf.get(f)) && b.push(e);
                        d = c.next();
                        l.B(2);
                        break;
                    case 4:
                        a.imageStreams = b, H(l);
                }
            });
        }
        function ag(a) {
            return new Promise(function(b) {
                var c = new Image;
                c.src = a;
                "decode" in c ? c.decode().then(function() {
                    b(!0);
                }).catch(function() {
                    b(!1);
                }) : c.onload = c.onerror = function() {
                    b(c.height === 2);
                };
            });
        }
        function bg(a) {
            var b = a.audio, c = a.video, d = b ? b.mimeType : null, e = c ? c.mimeType : null, f = b ? b.codecs : null, g = c ? c.codecs : null, h = b ? b.groupId : null, k = [];
            c && k.push(c.mimeType);
            b && k.push(b.mimeType);
            k = k[0] || null;
            var l = [];
            b && l.push(b.kind);
            c && l.push(c.kind);
            l = l[0] || null;
            var m = new Set;
            if (b) for(var n = u(b.roles), q = n.next(); !q.done; q = n.next())m.add(q.value);
            if (c) for(n = u(c.roles), q = n.next(); !q.done; q = n.next())m.add(q.value);
            a = {
                id: a.id,
                active: !1,
                type: "variant",
                bandwidth: a.bandwidth,
                language: a.language,
                label: null,
                videoLabel: null,
                kind: l,
                width: null,
                height: null,
                frameRate: null,
                pixelAspectRatio: null,
                hdr: null,
                colorGamut: null,
                videoLayout: null,
                mimeType: k,
                audioMimeType: d,
                videoMimeType: e,
                codecs: "",
                audioCodec: f,
                videoCodec: g,
                primary: a.primary,
                roles: Array.from(m),
                audioRoles: null,
                videoRoles: null,
                forced: !1,
                videoId: null,
                audioId: null,
                audioGroupId: h,
                channelsCount: null,
                audioSamplingRate: null,
                spatialAudio: !1,
                tilesLayout: null,
                audioBandwidth: null,
                videoBandwidth: null,
                originalVideoId: null,
                originalAudioId: null,
                originalTextId: null,
                originalImageId: null,
                accessibilityPurpose: null,
                originalLanguage: null
            };
            if (c) {
                a.videoId = c.id;
                a.originalVideoId = c.originalId;
                a.width = c.width || null;
                a.height = c.height || null;
                a.frameRate = c.frameRate || null;
                a.pixelAspectRatio = c.pixelAspectRatio || null;
                a.videoBandwidth = c.bandwidth || null;
                a.hdr = c.hdr || null;
                a.colorGamut = c.colorGamut || null;
                a.videoLayout = c.videoLayout || null;
                a.videoRoles = c.roles;
                a.videoLabel = c.label;
                if (d = c.dependencyStream) a.width = d.width || a.width, a.height = d.height || a.height, a.videoCodec = d.codecs || a.videoCodec, a.videoBandwidth && d.bandwidth && (a.videoBandwidth += d.bandwidth);
                if (g.includes(",")) {
                    a.channelsCount = c.channelsCount;
                    a.audioSamplingRate = c.audioSamplingRate;
                    a.spatialAudio = c.spatialAudio;
                    a.originalLanguage = c.originalLanguage;
                    a.audioMimeType = e;
                    c = g.split(",");
                    try {
                        a.videoCodec = pc("video", c), a.audioCodec = pc("audio", c);
                    } catch (r) {}
                }
            }
            b && (a.audioId = b.id, a.originalAudioId = b.originalId, a.channelsCount = b.channelsCount, a.audioSamplingRate = b.audioSamplingRate, a.audioBandwidth = b.bandwidth || null, a.spatialAudio = b.spatialAudio, a.label = b.label, a.audioRoles = b.roles, a.accessibilityPurpose = b.accessibilityPurpose, a.originalLanguage = b.originalLanguage, b = b.dependencyStream) && (a.audioCodec = b.codecs || a.audioCodec, a.audioBandwidth && b.bandwidth && (a.audioBandwidth += b.bandwidth));
            b = [];
            a.videoCodec && b.push(a.videoCodec);
            a.audioCodec && b.push(a.audioCodec);
            a.codecs = b.join(", ");
            return a;
        }
        function cg(a) {
            return {
                id: a.id,
                active: !1,
                type: sc,
                bandwidth: a.bandwidth || 0,
                language: a.language,
                label: a.label,
                kind: a.kind || null,
                mimeType: a.mimeType,
                codecs: a.codecs || null,
                primary: a.primary,
                roles: a.roles,
                accessibilityPurpose: a.accessibilityPurpose,
                forced: a.forced,
                originalTextId: a.originalId,
                originalLanguage: a.originalLanguage
            };
        }
        function dg(a) {
            var b = a.width || null, c = a.height || null, d = null;
            a.segmentIndex && (d = eg(a.segmentIndex));
            var e = a.tilesLayout;
            d && (e = d.tilesLayout || e);
            e && b != null && (b /= Number(e.split("x")[0]));
            e && c != null && (c /= Number(e.split("x")[1]));
            return {
                id: a.id,
                type: "image",
                bandwidth: a.bandwidth || 0,
                width: b,
                height: c,
                mimeType: a.mimeType,
                codecs: a.codecs || null,
                tilesLayout: e || null,
                originalImageId: a.originalId
            };
        }
        function fg(a) {
            a.__shaka_id || (a.__shaka_id = gg++);
            return a.__shaka_id;
        }
        function hg(a) {
            var b = {
                id: fg(a),
                active: a.mode != "disabled",
                type: sc,
                bandwidth: 0,
                language: yc(a.language || "und"),
                label: a.label,
                kind: a.kind,
                mimeType: null,
                codecs: null,
                primary: !1,
                roles: [],
                accessibilityPurpose: null,
                forced: a.kind == "forced",
                originalTextId: a.id,
                originalLanguage: a.language
            };
            a.kind == "captions" && (b.mimeType = "unknown");
            a.kind == "subtitles" && (b.mimeType = "text/vtt");
            a.kind && (b.roles = [
                a.kind
            ]);
            return b;
        }
        function ig(a, b) {
            var c = a ? a.language : null;
            c = {
                id: fg(a || b),
                active: a ? a.enabled : b.selected,
                type: "variant",
                bandwidth: 0,
                language: yc(c || "und"),
                label: a ? a.label : null,
                videoLabel: null,
                kind: a ? a.kind : null,
                width: null,
                height: null,
                frameRate: null,
                pixelAspectRatio: null,
                hdr: null,
                colorGamut: null,
                videoLayout: null,
                mimeType: null,
                audioMimeType: null,
                videoMimeType: null,
                codecs: null,
                audioCodec: null,
                videoCodec: null,
                primary: a ? a.kind == "main" : !1,
                roles: [],
                forced: !1,
                audioRoles: null,
                videoRoles: null,
                videoId: null,
                audioId: null,
                audioGroupId: null,
                channelsCount: null,
                audioSamplingRate: null,
                spatialAudio: !1,
                tilesLayout: null,
                audioBandwidth: null,
                videoBandwidth: null,
                originalVideoId: b ? b.id : null,
                originalAudioId: a ? a.id : null,
                originalTextId: null,
                originalImageId: null,
                accessibilityPurpose: null,
                originalLanguage: c
            };
            a && a.kind && (c.roles = [
                a.kind
            ], c.audioRoles = [
                a.kind
            ]);
            a && a.configuration && (a.configuration.codec && (c.audioCodec = a.configuration.codec, c.codecs = c.audioCodec), a.configuration.bitrate && (c.audioBandwidth = a.configuration.bitrate, c.bandwidth += c.audioBandwidth), a.configuration.sampleRate && (c.audioSamplingRate = a.configuration.sampleRate), a.configuration.numberOfChannels && (c.channelsCount = a.configuration.numberOfChannels));
            if (b && b.configuration && (b.configuration.codec && (c.videoCodec = b.configuration.codec, c.codecs = c.codecs ? c.codecs + ("," + c.videoCodec) : c.videoCodec), b.configuration.bitrate && (c.videoBandwidth = b.configuration.bitrate, c.bandwidth += c.videoBandwidth), b.configuration.framerate && (c.frameRate = b.configuration.framerate), b.configuration.width && (c.width = b.configuration.width), b.configuration.height && (c.height = b.configuration.height), b.configuration.colorSpace && b.configuration.colorSpace.transfer)) switch(b.configuration.colorSpace.transfer){
                case "pq":
                    c.hdr = "PQ";
                    break;
                case "hlg":
                    c.hdr = "HLG";
                    break;
                case "bt709":
                    c.hdr = "SDR";
            }
            return c;
        }
        function jg(a) {
            return a.allowedByApplication && a.allowedByKeySystem && a.disabledUntilTime == 0;
        }
        function kg(a) {
            return a.filter(function(b) {
                return jg(b);
            });
        }
        function lg(a, b, c, d) {
            var e = a, f = a.filter(function(k) {
                return k.primary;
            });
            f.length && (e = f);
            var g = e.length ? e[0].language : "";
            e = e.filter(function(k) {
                return k.language == g;
            });
            if (b) {
                var h = Gc(yc(b), a.map(function(k) {
                    return k.language;
                }));
                h && (e = a.filter(function(k) {
                    return yc(k.language) == h;
                }));
            }
            e = e.filter(function(k) {
                return k.forced == d;
            });
            if (c) {
                if (a = mg(e, c), a.length) return a;
            } else if (a = e.filter(function(k) {
                return k.roles.length == 0;
            }), a.length) return a;
            a = e.map(function(k) {
                return k.roles;
            }).reduce(Cf, []);
            return a.length ? mg(e, a[0]) : e;
        }
        function mg(a, b) {
            return a.filter(function(c) {
                return c.roles.includes(b);
            });
        }
        function ng(a) {
            var b = [];
            a.audio && b.push(a.audio);
            a.video && b.push(a.video);
            return b;
        }
        function og(a, b) {
            b.length && (b = b.filter(function(c) {
                return jf(a.codecs) == jf(c.codecs);
            }).sort(function(c, d) {
                return c.bandwidth && d.bandwidth && c.bandwidth != d.bandwidth ? c.bandwidth - d.bandwidth : (c.width || 0) - (d.width || 0);
            }), a.trickModeVideo = b[0], b.length > 1 && (b = b.find(function(c) {
                return a.width == c.width && a.height == c.height;
            }))) && (a.trickModeVideo = b);
        }
        function Sf(a) {
            return a.type == "audio" ? "type=audio codecs=" + a.codecs + " bandwidth=" + a.bandwidth + " channelsCount=" + a.channelsCount + " audioSamplingRate=" + a.audioSamplingRate : a.type == "video" ? "type=video codecs=" + a.codecs + " bandwidth=" + a.bandwidth + " frameRate=" + a.frameRate + " width=" + a.width + " height=" + a.height : "unexpected stream type";
        }
        function pg(a, b, c) {
            if (c.autoShowText == 0) return !1;
            if (c.autoShowText == 1) return !0;
            var d = yc(c.preferredTextLanguage);
            b = yc(b.language);
            if (c.autoShowText == 2) return xc(b, d);
            if (c.autoShowText == 3) {
                if (!a) return !1;
                a = yc(a.language);
                return xc(b, d) && !xc(a, b);
            }
            ab("Invalid autoShowText setting!");
            return !1;
        }
        function qg(a) {
            var b = {
                id: 0,
                language: "und",
                disabledUntilTime: 0,
                primary: !1,
                audio: null,
                video: null,
                bandwidth: 100,
                allowedByApplication: !0,
                allowedByKeySystem: !0,
                decodingInfos: []
            };
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next()){
                c = c.value;
                var d = {
                    id: 0,
                    originalId: null,
                    groupId: null,
                    createSegmentIndex: function() {
                        return Promise.resolve();
                    },
                    segmentIndex: null,
                    mimeType: c ? mf(c) : "",
                    codecs: c ? nf(c) : "",
                    encrypted: !0,
                    drmInfos: [],
                    keyIds: new Set,
                    language: "und",
                    originalLanguage: null,
                    label: null,
                    type: "video",
                    primary: !1,
                    trickModeVideo: null,
                    dependencyStream: null,
                    emsgSchemeIdUris: null,
                    roles: [],
                    forced: !1,
                    channelsCount: null,
                    audioSamplingRate: null,
                    spatialAudio: !1,
                    closedCaptions: null,
                    accessibilityPurpose: null,
                    external: !1,
                    fastSwitching: !1,
                    fullMimeTypes: new Set,
                    isAudioMuxedInVideo: !1,
                    baseOriginalId: null
                };
                d.fullMimeTypes.add(df(d.mimeType, d.codecs));
                c.startsWith("audio/") ? (d.type = "audio", b.audio = d) : b.video = d;
            }
            return b;
        }
        S("shaka.util.StreamUtils", Gf);
        Gf.meetsRestrictions = Kf;
        var Uf = new Map, gg = 0, Zf = (new Map).set("image/svg+xml", !0).set("image/png", !0).set("image/jpeg", !0).set("image/jpg", !0), $f = (new Map).set("image/webp", "data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA").set("image/avif", "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A=");
        function rg() {
            var a = this;
            this.H = null;
            this.m = !1;
            this.C = new Nc;
            this.j = new Tc;
            navigator.connection && navigator.connection.addEventListener && this.j.o(navigator.connection, "change", function() {
                if (a.m && a.g.useNetworkInformation) {
                    a.C = new Nc;
                    a.g && a.C.configure(a.g.advanced);
                    var b = a.chooseVariant();
                    b && navigator.onLine && a.H(b, a.g.clearBufferSwitch, a.g.safeMarginSwitch);
                }
            });
            this.A = [];
            this.I = 1;
            this.J = !1;
            this.h = this.u = this.g = this.D = null;
            this.l = new Bf(function() {
                if (a.m && (a.g.restrictToElementSize || a.g.restrictToScreenSize)) {
                    var b = a.chooseVariant();
                    b && a.H(b, a.g.clearBufferSwitch, a.g.safeMarginSwitch);
                }
            });
            this.F = window1;
            "documentPictureInPicture" in window1 && this.j.o(window1.documentPictureInPicture, "enter", function() {
                a.F = window1.documentPictureInPicture.window;
                a.l && a.l.La();
                a.j.ua(a.F, "pagehide", function() {
                    a.F = window1;
                    a.l && a.l.La();
                });
            });
            this.G = this.i = null;
        }
        p = rg.prototype;
        p.stop = function() {
            this.H = null;
            this.m = !1;
            this.A = [];
            this.I = 1;
            this.u = this.D = null;
            this.h && (this.h.disconnect(), this.h = null);
            this.l && this.l.stop();
            this.G = this.i = null;
        };
        p.release = function() {
            this.stop();
            this.j.release();
            this.l = null;
        };
        p.init = function(a) {
            this.H = a;
        };
        p.chooseVariant = function(a) {
            a = a === void 0 ? !1 : a;
            var b = Infinity, c = Infinity;
            this.g.restrictToScreenSize && (c = this.g.ignoreDevicePixelRatio ? 1 : this.F.devicePixelRatio, b = this.F.screen.height * c, c *= this.F.screen.width);
            if (this.h && this.g.restrictToElementSize) {
                var d = this.g.ignoreDevicePixelRatio ? 1 : this.F.devicePixelRatio, e = this.u.clientHeight, f = this.u.clientWidth;
                this.i && document.pictureInPictureElement && document.pictureInPictureElement == this.u && (e = this.i.height, f = this.i.width);
                b = Math.min(b, e * d);
                c = Math.min(c, f * d);
            }
            e = this.A.filter(function(l) {
                return l && !(l.audio && l.audio.fastSwitching || l.video && l.video.fastSwitching);
            });
            e.length || (e = this.A);
            d = e;
            a && e.length != this.A.length && (d = this.A.filter(function(l) {
                return l && (l.audio && l.audio.fastSwitching || l.video && l.video.fastSwitching ? !0 : !1);
            }));
            a = sg(this, this.g.restrictions, d, Infinity, Infinity);
            if (b != Infinity || c != Infinity) {
                a = tg(a);
                a = u(a);
                for(e = a.next(); !e.done; e = a.next())if (e = e.value, e.height >= b && e.width >= c) {
                    b = e.height;
                    c = e.width;
                    break;
                }
                a = sg(this, this.g.restrictions, d, b, c);
            }
            b = this.getBandwidthEstimate();
            d.length && !a.length && (a = sg(this, null, d, Infinity, Infinity), a = [
                a[0]
            ]);
            c = a[0] || null;
            for(d = 0; d < a.length; d++){
                e = a[d];
                var g = isNaN(this.I) ? 1 : Math.abs(this.I);
                f = g * e.bandwidth / this.g.bandwidthDowngradeTarget;
                for(var h = {
                    bandwidth: Infinity
                }, k = d + 1; k < a.length; k++)if (e.bandwidth != a[k].bandwidth) {
                    h = a[k];
                    break;
                }
                g = g * h.bandwidth / this.g.bandwidthUpgradeTarget;
                b >= f && b <= g && (c.bandwidth != e.bandwidth || c.bandwidth == e.bandwidth && c.video && e.video && (c.video.width < e.video.width || c.video.height < e.video.height)) && (c = e);
            }
            this.D = Date.now();
            return c;
        };
        p.enable = function() {
            this.m = !0;
        };
        p.disable = function() {
            this.m = !1;
        };
        p.segmentDownloaded = function(a, b, c, d) {
            var e = a;
            this.g.removeLatencyFromFirstPacketTime && d && d.packetNumber === 1 && d.timeToFirstByte && (e = a - d.timeToFirstByte);
            e >= this.g.cacheLoadThreshold && this.C.sample(e, b);
            c && this.D != null && this.m && ug(this);
        };
        p.trySuggestStreams = function() {
            this.m && (this.D = Date.now(), ug(this, !0));
        };
        p.getBandwidthEstimate = function() {
            var a = this.g.defaultBandwidthEstimate;
            navigator.connection && navigator.connection.downlink && this.g.useNetworkInformation && (a = navigator.connection.downlink * 1E6);
            if (navigator.connection && navigator.connection.downlink && this.g.useNetworkInformation && this.g.preferNetworkInformationBandwidth) return a;
            a = this.C.getBandwidthEstimate(a);
            return this.G ? this.G.getBandwidthEstimate(a) : a;
        };
        p.setVariants = function(a) {
            if (Rc(a, this.A)) return !1;
            this.A = a;
            return !0;
        };
        p.playbackRateChanged = function(a) {
            this.I = a;
        };
        p.setMediaElement = function(a) {
            function b() {
                c.l.$(vg);
            }
            var c = this;
            this.u = a;
            this.h && (this.h.disconnect(), this.h = null);
            this.u && "ResizeObserver" in window1 && (this.h = new ResizeObserver(b), this.h.observe(this.u));
            this.j.o(a, "enterpictureinpicture", function(d) {
                d.pictureInPictureWindow && (c.i = d.pictureInPictureWindow, c.j.o(c.i, "resize", b));
            });
            this.j.o(a, "leavepictureinpicture", function() {
                c.i && c.j.Ea(c.i, "resize", b);
                c.i = null;
            });
        };
        p.setCmsdManager = function(a) {
            this.G = a;
        };
        p.configure = function(a) {
            this.g = a;
            this.C && this.g && this.C.configure(this.g.advanced);
        };
        function ug(a, b) {
            if (b === void 0 || !b) {
                if (!a.J) {
                    b = a.C;
                    if (!(b.g >= b.i)) return;
                    a.J = !0;
                    a.D -= (a.g.switchInterval - a.g.minTimeToSwitch) * 1E3;
                }
                if (Date.now() - a.D < a.g.switchInterval * 1E3) return;
            }
            b = a.chooseVariant();
            a.getBandwidthEstimate();
            b && a.H(b, a.g.clearBufferSwitch, a.g.safeMarginSwitch);
        }
        function sg(a, b, c, d, e) {
            if (a.G) {
                var f = a.G.Yi();
                f && (c = c.filter(function(g) {
                    return g.bandwidth && f ? g.bandwidth <= f : !0;
                }));
            }
            b && (c = c.filter(function(g) {
                return Kf(g, b, {
                    width: e,
                    height: d
                });
            }));
            return c.sort(function(g, h) {
                return g.bandwidth - h.bandwidth;
            });
        }
        function tg(a) {
            var b = [];
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next())(c = c.value.video) && c.height && c.width && b.push({
                height: c.height,
                width: c.width
            });
            return b.sort(function(d, e) {
                return d.width - e.width;
            });
        }
        S("shaka.abr.SimpleAbrManager", rg);
        rg.prototype.configure = rg.prototype.configure;
        rg.prototype.setCmsdManager = rg.prototype.setCmsdManager;
        rg.prototype.setMediaElement = rg.prototype.setMediaElement;
        rg.prototype.playbackRateChanged = rg.prototype.playbackRateChanged;
        rg.prototype.setVariants = rg.prototype.setVariants;
        rg.prototype.getBandwidthEstimate = rg.prototype.getBandwidthEstimate;
        rg.prototype.trySuggestStreams = rg.prototype.trySuggestStreams;
        rg.prototype.segmentDownloaded = rg.prototype.segmentDownloaded;
        rg.prototype.disable = rg.prototype.disable;
        rg.prototype.enable = rg.prototype.enable;
        rg.prototype.chooseVariant = rg.prototype.chooseVariant;
        rg.prototype.init = rg.prototype.init;
        rg.prototype.release = rg.prototype.release;
        rg.prototype.stop = rg.prototype.stop;
        var vg = 1;
        function wg(a, b) {
            if (a === b || !a.length || !b.length) return !0;
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next()){
                c = c.value;
                if (xg(c)) return !0;
                for(var d = u(b), e = d.next(); !e.done; e = d.next())if (e = e.value, c.keySystem === e.keySystem || xg(e)) return !0;
            }
            return !1;
        }
        function yg(a, b) {
            if (!a.length) return b;
            if (!b.length) return a;
            var c = [];
            a = u(a);
            for(var d = a.next(); !d.done; d = a.next()){
                d = d.value;
                for(var e = u(b), f = e.next(); !f.done; f = e.next())if (f = f.value, d.keySystem == f.keySystem) {
                    e = new Map;
                    for(var g = u((d.initData || []).concat(f.initData || [])), h = g.next(); !h.done; h = g.next())h = h.value, e.set(h.keyId, h);
                    e = Array.from(e.values());
                    g = d.keyIds && f.keyIds ? new Set([].concat(x(d.keyIds), x(f.keyIds))) : d.keyIds || f.keyIds;
                    c.push({
                        keySystem: d.keySystem,
                        licenseServerUri: d.licenseServerUri || f.licenseServerUri,
                        distinctiveIdentifierRequired: d.distinctiveIdentifierRequired || f.distinctiveIdentifierRequired,
                        persistentStateRequired: d.persistentStateRequired || f.persistentStateRequired,
                        videoRobustness: d.videoRobustness || f.videoRobustness,
                        audioRobustness: d.audioRobustness || f.audioRobustness,
                        serverCertificate: d.serverCertificate || f.serverCertificate,
                        serverCertificateUri: d.serverCertificateUri || f.serverCertificateUri,
                        initData: e,
                        keyIds: g
                    });
                    break;
                } else xg(d) ? c.push(d) : xg(f) && c.push(f);
            }
            return c;
        }
        function zg(a) {
            return a ? !!a.match(/^com\.(microsoft|chromecast)\.playready/) : !1;
        }
        function Bg(a) {
            return a ? !!a.match(/^com\.apple\.fps/) : !1;
        }
        function xg(a) {
            return (a = a.licenseServerUri) ? a.startsWith("data:application/json;base64,") : !1;
        }
        var Cg = new Qb(function() {
            return Lb(new Uint8Array([
                0
            ]));
        }), Dg = new Map;
        function Eg(a, b) {
            var c = Fg();
            this.l = a.maxAttempts == null ? c.maxAttempts : a.maxAttempts;
            this.j = a.baseDelay == null ? c.baseDelay : a.baseDelay;
            this.u = a.fuzzFactor == null ? c.fuzzFactor : a.fuzzFactor;
            this.m = a.backoffFactor == null ? c.backoffFactor : a.backoffFactor;
            this.g = 0;
            this.h = this.j;
            if (this.i = b === void 0 ? !1 : b) this.g = 1;
        }
        function Gg(a) {
            var b, c;
            return Q(function(d) {
                if (d.g == 1) {
                    if (a.g >= a.l) {
                        if (a.i) a.g = 1, a.h = a.j;
                        else throw new U(2, 7, 1010);
                    }
                    b = a.g;
                    a.g++;
                    if (b == 0) return d.return();
                    c = a.h * (1 + (Math.random() * 2 - 1) * a.u);
                    return F(d, new Promise(function(e) {
                        new Bf(e).$(c / 1E3);
                    }), 2);
                }
                a.h *= a.m;
                H(d);
            });
        }
        function Fg() {
            return {
                maxAttempts: 2,
                baseDelay: 1E3,
                backoffFactor: 2,
                fuzzFactor: .5,
                timeout: 3E4,
                stallTimeout: 5E3,
                connectionTimeout: 1E4
            };
        }
        function Lg() {
            var a, b, c = new Promise(function(d, e) {
                a = d;
                b = e;
            });
            c.resolve = a;
            c.reject = b;
            return c;
        }
        Lg.prototype.resolve = function() {};
        Lg.prototype.reject = function() {};
        function Mg(a, b) {
            this.promise = a;
            this.i = b;
            this.g = null;
        }
        function Ng(a) {
            return new Mg(Promise.reject(a), function() {
                return Promise.resolve();
            });
        }
        function Og() {
            var a = Promise.reject(new U(2, 7, 7001));
            a.catch(function() {});
            return new Mg(a, function() {
                return Promise.resolve();
            });
        }
        function Pg(a) {
            return new Mg(Promise.resolve(a), function() {
                return Promise.resolve();
            });
        }
        function Qg(a) {
            return new Mg(a, function() {
                return a.catch(function() {});
            });
        }
        Mg.prototype.abort = function() {
            this.g || (this.g = this.i());
            return this.g;
        };
        function Rg(a) {
            return new Mg(Promise.all(a.map(function(b) {
                return b.promise;
            })), function() {
                return Promise.all(a.map(function(b) {
                    return b.abort();
                }));
            });
        }
        Mg.prototype.finally = function(a) {
            this.promise.then(function() {
                return a(!0);
            }, function() {
                return a(!1);
            });
            return this;
        };
        Mg.prototype.bb = function(a, b) {
            function c(h) {
                return function(k) {
                    if (e.g && h) f.reject(g);
                    else {
                        var l = h ? a : b;
                        l ? d = Sg(l, k, f) : (h ? f.resolve : f.reject)(k);
                    }
                };
            }
            function d() {
                f.reject(g);
                return e.abort();
            }
            var e = this, f = new Lg;
            f.catch(function() {});
            var g = new U(2, 7, 7001);
            this.promise.then(c(!0), c(!1));
            return new Mg(f, function() {
                return d();
            });
        };
        function Sg(a, b, c) {
            try {
                var d = a(b);
                if (d && d.promise && d.abort) return c.resolve(d.promise), function() {
                    return d.abort();
                };
                c.resolve(d);
                return function() {
                    return Promise.resolve(d).then(function() {}, function() {});
                };
            } catch (e) {
                return c.reject(e), function() {
                    return Promise.resolve();
                };
            }
        }
        da.Object.defineProperties(Mg.prototype, {
            aborted: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.g !== null;
                }
            }
        });
        S("shaka.util.AbortableOperation", Mg);
        Mg.prototype.chain = Mg.prototype.bb;
        Mg.prototype["finally"] = Mg.prototype.finally;
        Mg.all = Rg;
        Mg.prototype.abort = Mg.prototype.abort;
        Mg.notAbortable = Qg;
        Mg.completed = Pg;
        Mg.aborted = Og;
        Mg.failed = Ng;
        function Tg() {
            this.g = [];
        }
        function Ug(a, b) {
            a.g.push(b.finally(function() {
                Qc(a.g, b);
            }));
        }
        Tg.prototype.destroy = function() {
            for(var a = [], b = u(this.g), c = b.next(); !c.done; c = b.next())c = c.value, c.promise.catch(function() {}), a.push(c.abort());
            this.g = [];
            return Promise.all(a);
        };
        function Vg(a, b, c, d, e, f, g) {
            kb.call(this);
            this.i = null;
            this.j = !1;
            this.A = new Tg;
            this.g = new Set;
            this.h = new Set;
            this.u = a || null;
            this.m = b || null;
            this.C = c || null;
            this.D = d || null;
            this.F = e || null;
            this.H = f || null;
            this.G = g || null;
            this.l = new Map;
        }
        la(Vg, kb);
        p = Vg.prototype;
        p.configure = function(a) {
            this.i = a;
        };
        function Wg(a, b, c, d) {
            d = d === void 0 ? !1 : d;
            c = c || Xg;
            var e = Yg.get(a);
            (!e || c >= e.priority) && Yg.set(a, {
                priority: c,
                Vf: b,
                Yl: d
            });
        }
        function Zg(a, b) {
            for(var c = u(a.g), d = c.next(); !d.done; d = c.next())b.g.add(d.value);
            a = u(a.h);
            for(c = a.next(); !c.done; c = a.next())b.h.add(c.value);
        }
        p.am = function(a) {
            this.g.add(a);
        };
        p.Bm = function(a) {
            this.g.delete(a);
        };
        p.qk = function() {
            this.g.clear();
        };
        p.bm = function(a) {
            this.h.add(a);
        };
        p.Cm = function(a) {
            this.h.delete(a);
        };
        p.rk = function() {
            this.h.clear();
        };
        p.Ni = function() {
            this.l.clear();
        };
        function $g(a, b, c) {
            return {
                uris: a,
                method: "GET",
                body: null,
                headers: {},
                allowCrossSiteCredentials: !1,
                retryParameters: b,
                licenseRequestType: null,
                sessionId: null,
                drmInfo: null,
                initData: null,
                initDataType: null,
                streamDataCallback: c === void 0 ? null : c
            };
        }
        p.destroy = function() {
            this.j = !0;
            this.g.clear();
            this.h.clear();
            this.l.clear();
            kb.prototype.release.call(this);
            return this.A.destroy();
        };
        p.request = function(a, b, c) {
            var d = this, e = new ah;
            if (this.j) {
                var f = Promise.reject(new U(2, 7, 7001));
                f.catch(function() {});
                return new bh(f, function() {
                    return Promise.resolve();
                }, e);
            }
            b.method = b.method || "GET";
            b.headers = b.headers || {};
            b.retryParameters = b.retryParameters ? Gd(b.retryParameters) : Fg();
            b.uris = Gd(b.uris);
            f = ch(this, a, b, c);
            var g = f.bb(function() {
                return dh(d, a, b, c, new Eg(b.retryParameters, !1), 0, null, e);
            }), h = g.bb(function(q) {
                return eh(d, a, q, c);
            }), k = Date.now(), l = 0;
            f.promise.then(function() {
                l = Date.now() - k;
            }, function() {});
            var m = 0;
            g.promise.then(function() {
                m = Date.now();
            }, function() {});
            var n = h.bb(function(q) {
                var r = Date.now() - m, t = q.response;
                t.timeMs += l;
                t.timeMs += r;
                q.Bl || !d.u || t.fromCache || b.method == "HEAD" || a != fh || d.u(t.timeMs, t.data.byteLength, gh(c), b, c);
                d.G && d.G(a, t, c);
                return t;
            }, function(q) {
                q && (q.severity = 2);
                throw q;
            });
            f = new bh(n.promise, function() {
                return n.abort();
            }, e);
            Ug(this.A, f);
            return f;
        };
        function ch(a, b, c, d) {
            function e(h) {
                f = f.bb(function() {
                    c.body && (c.body = Lb(c.body));
                    return h(b, c, d);
                });
            }
            var f = Pg(void 0);
            a.F && e(a.F);
            a = u(a.g);
            for(var g = a.next(); !g.done; g = a.next())e(g.value);
            return f.bb(void 0, function(h) {
                if (h instanceof U && h.code == 7001) throw h;
                throw new U(2, 1, 1006, h);
            });
        }
        function dh(a, b, c, d, e, f, g, h) {
            a.i.forceHTTP && (c.uris[f] = c.uris[f].replace("https://", "http://"));
            a.i.forceHTTPS && (c.uris[f] = c.uris[f].replace("http://", "https://"));
            f > 0 && a.H && a.H(b, d, c.uris[f], c.uris[f - 1]);
            var k = new qb(c.uris[f]), l = k.lc, m = !1;
            l || (l = location.protocol, l = l.slice(0, -1), rb(k, l), c.uris[f] = k.toString());
            l = l.toLowerCase();
            var n = (l = Yg.get(l)) ? l.Vf : null;
            if (!n) return Ng(new U(2, 1, 1E3, k));
            var q = l.Yl;
            (k = a.l.get(k.Jb)) && (c.headers["common-access-token"] = k);
            var r = null, t = null, w = !1, v = !1, z;
            return Qg(Gg(e)).bb(function() {
                if (a.j) return Og();
                z = Date.now();
                var y = 0;
                c.requestStartTime = Date.now();
                var A = n(c.uris[f], c, b, function(D, B, G) {
                    r && r.stop();
                    t && t.$(E / 1E3);
                    a.u && b == fh && (y++, c.packetNumber = y, a.u(D, B, gh(d), c, d), m = !0, h.g = G);
                }, function(D) {
                    v = !0;
                    c.timeToFirstByte = Date.now() - c.requestStartTime;
                    a.m && a.m(D, c, b);
                }, {
                    minBytesForProgressEvents: a.i.minBytesForProgressEvents
                });
                if (!q) return A;
                var C = c.retryParameters.connectionTimeout;
                C && (r = new Bf(function() {
                    w = !0;
                    A.abort();
                }), r.$(C / 1E3));
                var E = c.retryParameters.stallTimeout;
                E && (t = new Bf(function() {
                    w = !0;
                    A.abort();
                }));
                return A;
            }).bb(function(y) {
                r && r.stop();
                t && t.stop();
                y.timeMs == void 0 && (y.timeMs = Date.now() - z);
                var A = y.headers["common-access-token"];
                if (A) {
                    var C = new qb(y.uri);
                    a.l.set(C.Jb, A);
                }
                A = {
                    response: y,
                    Bl: m
                };
                !v && a.m && a.m(y.headers, c, b);
                a.C && a.C(c, y);
                return A;
            }, function(y) {
                r && r.stop();
                t && t.stop();
                if (a.D) {
                    var A = null, C = 0;
                    y instanceof U && (A = y, y.code == 1001 && (C = y.data[1]));
                    a.D(c, A, C, w);
                }
                if (a.j) return Og();
                w && (y = new U(1, 1, 1003, c.uris[f], b));
                if (y instanceof U) {
                    if (y.code == 7001) throw y;
                    if (y.code == 1010) throw g;
                    if (y.severity == 1) {
                        A = (new Map).set("error", y);
                        A = new T("retry", A);
                        A.cancelable = !0;
                        a.dispatchEvent(A);
                        if (A.defaultPrevented) throw y;
                        f = (f + 1) % c.uris.length;
                        return dh(a, b, c, d, e, f, y, h);
                    }
                }
                throw y;
            });
        }
        function eh(a, b, c, d) {
            var e = Pg(void 0);
            a = u(a.h);
            for(var f = a.next(), g = {}; !f.done; g = {
                Cj: void 0
            }, f = a.next())g.Cj = f.value, e = e.bb(function(h) {
                return function() {
                    var k = c.response;
                    k.data && (k.data = Lb(k.data));
                    return (0, h.Cj)(b, k, d);
                };
            }(g));
            return e.bb(function() {
                return c;
            }, function(h) {
                var k = 2;
                if (h instanceof U) {
                    if (h.code == 7001) throw h;
                    k = h.severity;
                }
                throw new U(k, 1, 1007, h);
            });
        }
        function gh(a) {
            if (a) {
                var b = a.segment;
                a = a.stream;
                if (b && a && a.fastSwitching && b.nd) return !1;
            }
            return !0;
        }
        S("shaka.net.NetworkingEngine", Vg);
        Vg.prototype.request = Vg.prototype.request;
        Vg.prototype.destroy = Vg.prototype.destroy;
        Vg.makeRequest = $g;
        Vg.defaultRetryParameters = function() {
            return Fg();
        };
        Vg.prototype.clearCommonAccessTokenMap = Vg.prototype.Ni;
        Vg.prototype.clearAllResponseFilters = Vg.prototype.rk;
        Vg.prototype.unregisterResponseFilter = Vg.prototype.Cm;
        Vg.prototype.registerResponseFilter = Vg.prototype.bm;
        Vg.prototype.clearAllRequestFilters = Vg.prototype.qk;
        Vg.prototype.unregisterRequestFilter = Vg.prototype.Bm;
        Vg.prototype.registerRequestFilter = Vg.prototype.am;
        Vg.unregisterScheme = function(a) {
            Yg.delete(a);
        };
        Vg.registerScheme = Wg;
        Vg.prototype.configure = Vg.prototype.configure;
        function ah() {
            this.g = 0;
        }
        Vg.NumBytesRemainingClass = ah;
        function bh(a, b, c) {
            Mg.call(this, a, b);
            this.h = c;
        }
        la(bh, Mg);
        Vg.PendingRequest = bh;
        var fh = 1;
        Vg.RequestType = {
            MANIFEST: 0,
            SEGMENT: fh,
            LICENSE: 2,
            APP: 3,
            TIMING: 4,
            SERVER_CERTIFICATE: 5,
            KEY: 6,
            ADS: 7,
            CONTENT_STEERING: 8,
            CMCD: 9
        };
        Vg.AdvancedRequestType = {
            INIT_SEGMENT: 0,
            MEDIA_SEGMENT: 1,
            MEDIA_PLAYLIST: 2,
            MASTER_PLAYLIST: 3,
            MPD: 4,
            MSS: 5,
            MPD_PATCH: 6,
            MEDIATAILOR_SESSION_INFO: 7,
            MEDIATAILOR_TRACKING_INFO: 8,
            MEDIATAILOR_STATIC_RESOURCE: 9,
            MEDIATAILOR_TRACKING_EVENT: 10,
            INTERSTITIAL_ASSET_LIST: 11,
            INTERSTITIAL_AD_URL: 12
        };
        var Xg = 3;
        Vg.PluginPriority = {
            FALLBACK: 1,
            PREFERRED: 2,
            APPLICATION: Xg
        };
        var Yg = new Map;
        function hh(a) {
            this.g = !1;
            this.h = new Lg;
            this.i = a;
        }
        hh.prototype.destroy = function() {
            var a = this;
            if (this.g) return this.h;
            this.g = !0;
            return this.i().then(function() {
                a.h.resolve();
            }, function() {
                a.h.resolve();
            });
        };
        function ih(a, b) {
            if (a.g) {
                if (b instanceof U && b.code == 7003) throw b;
                throw new U(2, 7, 7003, b);
            }
        }
        function jh(a) {
            for(var b = new Map, c = u(Object.keys(a)), d = c.next(); !d.done; d = c.next())d = d.value, b.set(d, a[d]);
            return b;
        }
        function kh(a) {
            var b = {};
            a.forEach(function(c, d) {
                b[d] = c;
            });
            return b;
        }
        function lh(a, b) {
            this.h = Ob(a);
            this.i = b == mh;
            this.g = 0;
        }
        p = lh.prototype;
        p.Pa = function() {
            return this.g < this.h.byteLength;
        };
        p.Wa = function() {
            return this.g;
        };
        p.getLength = function() {
            return this.h.byteLength;
        };
        p.ba = function() {
            try {
                var a = this.h.getUint8(this.g);
                this.g += 1;
                return a;
            } catch (b) {
                throw nh();
            }
        };
        p.Ha = function() {
            try {
                var a = this.h.getUint16(this.g, this.i);
                this.g += 2;
                return a;
            } catch (b) {
                throw nh();
            }
        };
        p.Z = function() {
            try {
                var a = this.h.getUint32(this.g, this.i);
                this.g += 4;
                return a;
            } catch (b) {
                throw nh();
            }
        };
        p.Sh = function() {
            try {
                var a = this.h.getInt32(this.g, this.i);
                this.g += 4;
                return a;
            } catch (b) {
                throw nh();
            }
        };
        p.Td = function() {
            try {
                if (this.i) {
                    var a = this.h.getUint32(this.g, !0);
                    var b = this.h.getUint32(this.g + 4, !0);
                } else b = this.h.getUint32(this.g, !1), a = this.h.getUint32(this.g + 4, !1);
            } catch (c) {
                throw nh();
            }
            if (b > 2097151) throw new U(2, 3, 3001);
            this.g += 8;
            return b * 4294967296 + a;
        };
        p.ac = function(a) {
            if (this.g + a > this.h.byteLength) throw nh();
            var b = Kb(this.h, this.g, a);
            this.g += a;
            return b;
        };
        p.skip = function(a) {
            if (this.g + a > this.h.byteLength) throw nh();
            this.g += a;
        };
        p.Dj = function(a) {
            if (this.g < a) throw nh();
            this.g -= a;
        };
        p.seek = function(a) {
            if (a < 0 || a > this.h.byteLength) throw nh();
            this.g = a;
        };
        p.od = function() {
            for(var a = this.g; this.Pa() && this.h.getUint8(this.g) != 0;)this.g += 1;
            a = Kb(this.h, a, this.g - a);
            this.g += 1;
            return Wb(a);
        };
        function nh() {
            return new U(2, 3, 3E3);
        }
        S("shaka.util.DataViewReader", lh);
        lh.prototype.readTerminatedString = lh.prototype.od;
        lh.prototype.seek = lh.prototype.seek;
        lh.prototype.rewind = lh.prototype.Dj;
        lh.prototype.skip = lh.prototype.skip;
        lh.prototype.readBytes = lh.prototype.ac;
        lh.prototype.readUint64 = lh.prototype.Td;
        lh.prototype.readInt32 = lh.prototype.Sh;
        lh.prototype.readUint32 = lh.prototype.Z;
        lh.prototype.readUint16 = lh.prototype.Ha;
        lh.prototype.readUint8 = lh.prototype.ba;
        lh.prototype.getLength = lh.prototype.getLength;
        lh.prototype.getPosition = lh.prototype.Wa;
        lh.prototype.hasMoreData = lh.prototype.Pa;
        var mh = 1;
        lh.Endianness = {
            BIG_ENDIAN: 0,
            LITTLE_ENDIAN: mh
        };
        function oh() {
            this.i = new Map;
            this.h = new Map;
            this.g = !1;
        }
        p = oh.prototype;
        p.box = function(a, b) {
            a = ph(a);
            this.i.set(a, qh);
            this.h.set(a, b);
            return this;
        };
        p.W = function(a, b) {
            a = ph(a);
            this.i.set(a, rh);
            this.h.set(a, b);
            return this;
        };
        p.stop = function() {
            this.g = !0;
        };
        p.parse = function(a, b, c) {
            a = new lh(a, 0);
            for(this.g = !1; a.Pa() && !this.g;)this.Qd(0, a, b, c);
        };
        p.Qd = function(a, b, c, d) {
            var e = b.Wa();
            if (d && e + 8 > b.getLength()) this.g = !0;
            else {
                var f = b.Z(), g = b.Z(), h = sh(g), k = !1;
                switch(f){
                    case 0:
                        f = b.getLength() - e;
                        break;
                    case 1:
                        if (d && b.Wa() + 8 > b.getLength()) {
                            this.g = !0;
                            return;
                        }
                        f = b.Td();
                        k = !0;
                }
                var l = this.h.get(g);
                if (l) {
                    var m = null, n = null;
                    if (this.i.get(g) == rh) {
                        if (d && b.Wa() + 4 > b.getLength()) {
                            this.g = !0;
                            return;
                        }
                        n = b.Z();
                        m = n >>> 24;
                        n &= 16777215;
                    }
                    g = e + f;
                    c && g > b.getLength() && (g = b.getLength());
                    d && g > b.getLength() ? this.g = !0 : (g -= b.Wa(), b = g > 0 ? b.ac(g) : new Uint8Array(0), b = new lh(b, 0), l({
                        name: h,
                        parser: this,
                        partialOkay: c || !1,
                        stopOnPartial: d || !1,
                        version: m,
                        flags: n,
                        reader: b,
                        size: f,
                        start: e + a,
                        has64BitSize: k
                    }));
                } else b.skip(Math.min(e + f - b.Wa(), b.getLength() - b.Wa()));
            }
        };
        function th(a) {
            for(var b = uh(a); a.reader.Pa() && !a.parser.g;)a.parser.Qd(a.start + b, a.reader, a.partialOkay, a.stopOnPartial);
        }
        function vh(a) {
            for(var b = uh(a), c = a.reader.Z(), d = 0; d < c && (a.parser.Qd(a.start + b, a.reader, a.partialOkay, a.stopOnPartial), !a.parser.g); d++);
        }
        function wh(a) {
            var b = uh(a);
            for(a.reader.skip(78); a.reader.Pa() && !a.parser.g;)a.parser.Qd(a.start + b, a.reader, a.partialOkay, a.stopOnPartial);
        }
        function xh(a) {
            var b = uh(a);
            a.reader.skip(8);
            var c = a.reader.Ha();
            a.reader.skip(6);
            c == 2 ? a.reader.skip(48) : a.reader.skip(12);
            for(c == 1 && a.reader.skip(16); a.reader.Pa() && !a.parser.g;)a.parser.Qd(a.start + b, a.reader, a.partialOkay, a.stopOnPartial);
        }
        function yh(a) {
            return function(b) {
                a(b.reader.ac(b.reader.getLength() - b.reader.Wa()));
            };
        }
        function ph(a) {
            var b = 0;
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next())b = b << 8 | c.value.charCodeAt(0);
            return b;
        }
        function sh(a) {
            return String.fromCharCode(a >> 24 & 255, a >> 16 & 255, a >> 8 & 255, a & 255);
        }
        function uh(a) {
            return 8 + (a.has64BitSize ? 8 : 0) + (a.flags != null ? 4 : 0);
        }
        S("shaka.util.Mp4Parser", oh);
        oh.headerSize = uh;
        oh.typeToString = sh;
        oh.allData = yh;
        oh.audioSampleEntry = xh;
        oh.visualSampleEntry = wh;
        oh.sampleDescription = vh;
        oh.children = th;
        oh.prototype.parseNext = oh.prototype.Qd;
        oh.prototype.parse = oh.prototype.parse;
        oh.prototype.stop = oh.prototype.stop;
        oh.prototype.fullBox = oh.prototype.W;
        oh.prototype.box = oh.prototype.box;
        var qh = 0, rh = 1;
        function zh(a) {
            var b = this;
            this.g = [];
            this.h = [];
            this.data = [];
            (new oh).box("moov", th).box("moof", th).W("pssh", function(c) {
                if (!(c.version > 1)) {
                    var d = Kb(c.reader.h, -12, c.size);
                    b.data.push(d);
                    b.g.push(jc(c.reader.ac(16)));
                    if (c.version > 0) {
                        d = c.reader.Z();
                        for(var e = 0; e < d; e++){
                            var f = jc(c.reader.ac(16));
                            b.h.push(f);
                        }
                    }
                }
            }).parse(a);
        }
        function Ah(a, b, c, d) {
            var e = a.length, f = 12 + b.length + 4 + e;
            d > 0 && (f += 4 + 16 * c.size);
            var g = new Uint8Array(f), h = Ob(g), k = 0;
            h.setUint32(k, f);
            k += 4;
            h.setUint32(k, 1886614376);
            k += 4;
            d < 1 ? h.setUint32(k, 0) : h.setUint32(k, 16777216);
            k += 4;
            g.set(b, k);
            k += b.length;
            if (d > 0) for(h.setUint32(k, c.size), k += 4, b = u(c), c = b.next(); !c.done; c = b.next())c = ic(c.value), g.set(c, k), k += c.length;
            h.setUint32(k, e);
            g.set(a, k + 4);
            return g;
        }
        function Bh(a) {
            var b = this;
            this.F = a;
            this.j = this.C = null;
            this.ea = this.R = !1;
            this.I = 0;
            this.g = null;
            this.u = new Tc;
            this.i = new Map;
            this.V = [];
            this.D = new Map;
            this.J = !1;
            this.m = new Lg;
            this.h = null;
            this.A = function(c) {
                c.severity == 2 && b.m.reject(c);
                a.onError(c);
            };
            this.Y = new Map;
            this.aa = new Map;
            this.K = new Bf(function() {
                return Ch(b);
            });
            this.P = !1;
            this.M = [];
            this.X = !1;
            this.G = new Bf(function() {
                Dh(b);
            });
            this.m.catch(function() {});
            this.l = new hh(function() {
                return Eh(b);
            });
            this.O = !1;
            this.L = this.H = null;
            this.S = function() {
                return !1;
            };
        }
        p = Bh.prototype;
        p.destroy = function() {
            return this.l.destroy();
        };
        function Eh(a) {
            return Q(function(b) {
                switch(b.g){
                    case 1:
                        return a.u.release(), a.u = null, a.m.reject(), a.G.stop(), a.G = null, a.K.stop(), a.K = null, F(b, Fh(a), 2);
                    case 2:
                        if (!a.j) {
                            b.B(3);
                            break;
                        }
                        ra(b, 4);
                        return F(b, a.j.setMediaKeys(null), 6);
                    case 6:
                        ta(b, 5);
                        break;
                    case 4:
                        ua(b);
                    case 5:
                        a.j = null;
                    case 3:
                        a.g = null, a.C = null, a.D = new Map, a.h = null, a.A = function() {}, a.F = null, a.O = !1, a.H = null, H(b);
                }
            });
        }
        p.configure = function(a, b) {
            this.h = a;
            b && (this.S = b);
            this.G && this.R && this.g && this.G.wa(this.h.updateExpirationTime);
        };
        function Gh(a, b, c) {
            a.ea = !0;
            a.D = new Map;
            a.P = c;
            return Hh(a, b, !1);
        }
        function Ih(a, b, c, d) {
            d = d === void 0 ? !0 : d;
            a.D = new Map;
            c = u(c);
            for(var e = c.next(); !e.done; e = c.next())a.D.set(e.value, {
                initData: null,
                initDataType: null
            });
            c = u(a.h.persistentSessionsMetadata);
            for(e = c.next(); !e.done; e = c.next())e = e.value, a.D.set(e.sessionId, {
                initData: e.initData,
                initDataType: e.initDataType
            });
            a.P = a.D.size > 0;
            return Hh(a, b, d);
        }
        function Jh(a, b, c, d, e, f) {
            var g, h, k, l, m;
            return Q(function(n) {
                if (n.g == 1) return g = [], f.length && g.push(f[0].contentType), e.length && g.push(e[0].contentType), h = function(q) {
                    q = nc(b, q, null);
                    q.licenseServerUri = c;
                    q.serverCertificate = d;
                    q.persistentStateRequired = !0;
                    q.sessionType = "persistent-license";
                    return q;
                }, k = qg(g), k.video && (l = h(f[0].encryptionScheme || ""), k.video.drmInfos.push(l)), k.audio && (m = h(e[0].encryptionScheme || ""), k.audio.drmInfos.push(m)), F(n, Qf([
                    k
                ], !0, a.O, []), 2);
                ih(a.l);
                return n.return(Kh(a, [
                    k
                ]));
            });
        }
        function Hh(a, b, c) {
            var d, e, f, g, h, k, l, m, n, q, r, t, w, v, z, y, A, C;
            return Q(function(E) {
                if (E.g == 1) {
                    Lh(a.h.clearKeys, b);
                    d = b.some(function(D) {
                        return D.video && D.video.drmInfos.length || D.audio && D.audio.drmInfos.length ? !0 : !1;
                    });
                    e = jh(a.h.servers);
                    f = jh(a.h.advanced || {});
                    !d && c && Mh(b, e);
                    g = new WeakSet;
                    h = u(b);
                    for(k = h.next(); !k.done; k = h.next())for(l = k.value, m = Nh(l), n = u(m), q = n.next(); !q.done; q = n.next())r = q.value, g.has(r) || (g.add(r), Oh(r, e, f, a.h.keySystemsMapping));
                    t = function(D, B) {
                        var G = [];
                        D = u(D);
                        for(var I = D.next(); !I.done; I = D.next()){
                            I = I.value;
                            var J = I[B] || f.has(I.keySystem) && f.get(I.keySystem)[B] || "", L;
                            if (L = J == "") L = (L = I.keySystem) ? !!L.match(/^com\.widevine\.alpha/) : !1;
                            L && (B == "audioRobustness" ? J = [
                                a.h.defaultAudioRobustnessForWidevine
                            ] : B == "videoRobustness" && (J = [
                                a.h.defaultVideoRobustnessForWidevine
                            ]));
                            if (typeof J === "string") G.push(I);
                            else if (Array.isArray(J)) for(J.length === 0 && (J = [
                                ""
                            ]), J = u(J), L = J.next(); !L.done; L = J.next()){
                                var K = {};
                                G.push(Object.assign({}, I, (K[B] = L.value, K)));
                            }
                        }
                        return G;
                    };
                    w = new WeakSet;
                    v = u(b);
                    for(z = v.next(); !z.done; z = v.next())y = z.value, y.video && !w.has(y.video) && (y.video.drmInfos = t(y.video.drmInfos, "videoRobustness"), y.video.drmInfos = t(y.video.drmInfos, "audioRobustness"), w.add(y.video)), y.audio && !w.has(y.audio) && (y.audio.drmInfos = t(y.audio.drmInfos, "videoRobustness"), y.audio.drmInfos = t(y.audio.drmInfos, "audioRobustness"), w.add(y.audio));
                    return F(E, Qf(b, a.P, a.O, a.h.preferredKeySystems), 2);
                }
                ih(a.l);
                A = d || e.size > 0;
                if (!A) return a.R = !0, E.return(Promise.resolve());
                C = Kh(a, b);
                return E.return(d ? C : C.catch(function() {}));
            });
        }
        function Ph(a) {
            var b;
            return Q(function(c) {
                switch(c.g){
                    case 1:
                        if (a.j.mediaKeys) return c.return();
                        if (!a.H) {
                            c.B(2);
                            break;
                        }
                        return F(c, a.H, 3);
                    case 3:
                        return ih(a.l), c.return();
                    case 2:
                        return ra(c, 4), a.H = a.j.setMediaKeys(a.C), F(c, a.H, 6);
                    case 6:
                        ta(c, 5);
                        break;
                    case 4:
                        b = ua(c), a.A(new U(2, 6, 6003, b.message));
                    case 5:
                        ih(a.l), H(c);
                }
            });
        }
        function Qh(a, b) {
            return Q(function(c) {
                if (c.g == 1) return F(c, Ph(a), 2);
                Rh(a, b.initDataType, Kb(b.initData));
                H(c);
            });
        }
        p.cc = function(a) {
            var b = this, c, d;
            return Q(function(e) {
                if (e.g == 1) {
                    if (b.j === a) return e.return();
                    if (!b.C) return b.u.ua(a, "encrypted", function() {
                        b.A(new U(2, 6, 6010));
                    }), e.return();
                    b.j = a;
                    b.h.delayLicenseRequestUntilPlayed && b.u.ua(b.j, "play", function() {
                        for(var f = u(b.M), g = f.next(); !g.done; g = f.next())Sh(b, g.value);
                        b.X = !0;
                        b.M = [];
                    });
                    b.j.remote ? (b.u.o(b.j.remote, "connect", function() {
                        return Fh(b);
                    }), b.u.o(b.j.remote, "connecting", function() {
                        return Fh(b);
                    }), b.u.o(b.j.remote, "disconnect", function() {
                        return Fh(b);
                    })) : "webkitCurrentPlaybackTargetIsWireless" in b.j && b.u.o(b.j, "webkitcurrentplaybacktargetiswirelesschanged", function() {
                        return Fh(b);
                    });
                    b.L = b.g ? b.g.initData.find(function(f) {
                        return f.initData.length > 0;
                    }) || null : null;
                    c = b.g.keySystem;
                    return (d = Rb().Kh(c)) || !(b.L || b.D.size || b.h.parseInbandPsshEnabled) ? (b.u.o(b.j, "encrypted", function(f) {
                        return Qh(b, f);
                    }), e.B(2)) : F(e, Ph(b), 2);
                }
                Th(b).catch(function() {});
                H(e);
            });
        };
        function Uh(a) {
            var b, c, d, e, f;
            return Q(function(g) {
                switch(g.g){
                    case 1:
                        if (!a.C || !a.g) return g.return();
                        if (!a.g.serverCertificateUri || a.g.serverCertificate && a.g.serverCertificate.length) {
                            g.B(2);
                            break;
                        }
                        b = $g([
                            a.g.serverCertificateUri
                        ], a.h.retryParameters);
                        ra(g, 3);
                        c = a.F.Dc.request(5, b, {
                            isPreload: a.S()
                        });
                        return F(g, c.promise, 5);
                    case 5:
                        d = g.h;
                        a.g.serverCertificate = Kb(d.data);
                        ta(g, 4);
                        break;
                    case 3:
                        throw e = ua(g), new U(2, 6, 6017, e);
                    case 4:
                        if (a.l.g) return g.return();
                    case 2:
                        if (!a.g.serverCertificate || !a.g.serverCertificate.length) return g.return();
                        ra(g, 6);
                        return F(g, a.C.setServerCertificate(a.g.serverCertificate), 8);
                    case 8:
                        ta(g, 0);
                        break;
                    case 6:
                        throw f = ua(g), new U(2, 6, 6004, f.message);
                }
            });
        }
        function Vh(a, b) {
            var c, d, e;
            return Q(function(f) {
                if (f.g == 1) return F(f, Wh(a, b, {
                    initData: null,
                    initDataType: null
                }), 2);
                if (f.g != 3) {
                    c = f.h;
                    if (!c) return f.return();
                    d = [];
                    if (e = a.i.get(c)) e.Rb = new Lg, d.push(e.Rb);
                    d.push(c.remove());
                    return F(f, Promise.all(d), 3);
                }
                a.i.delete(c);
                H(f);
            });
        }
        function Th(a) {
            var b, c, d, e, f;
            return Q(function(g) {
                if (g.g == 1) {
                    if (!a.D.size) return g.B(2);
                    a.D.forEach(function(h, k) {
                        Wh(a, k, h);
                    });
                    return F(g, a.m, 3);
                }
                if (g.g != 2) {
                    b = a.g && a.g.keyIds || new Set([]);
                    if (b.size > 0 && Xh(a)) return g.return(a.m);
                    a.J = !1;
                    a.m = new Lg;
                    a.m.catch(function() {});
                }
                c = (a.g ? a.g.initData : []) || [];
                d = u(c);
                for(e = d.next(); !e.done; e = d.next())f = e.value, Rh(a, f.initDataType, f.initData);
                Yh(a) && a.m.resolve();
                return g.return(a.m);
            });
        }
        function Rh(a, b, c) {
            if (c.length) {
                if (a.h.ignoreDuplicateInitData) {
                    var d = a.i.values();
                    d = u(d);
                    for(var e = d.next(); !e.done; e = d.next())if (Jb(c, e.value.initData)) return;
                    var f = !1;
                    a.D.forEach(function(g) {
                        !f && Jb(c, g.initData) && (f = !0);
                    });
                    if (f) return;
                }
                a.J = !0;
                a.i.size > 0 && Yh(a) && (a.m.resolve(), a.J = !1, a.m = new Lg, a.m.catch(function() {}));
                Zh(a, b, c, a.g.sessionType);
            }
        }
        function $h(a) {
            a = a.i.keys();
            a = lb(a, function(b) {
                return b.sessionId;
            });
            return Array.from(a);
        }
        p.nh = function() {
            var a = this, b = this.i.keys();
            b = lb(b, function(c) {
                var d = a.i.get(c);
                return {
                    sessionId: c.sessionId,
                    sessionType: d.type,
                    initData: d.initData,
                    initDataType: d.initDataType
                };
            });
            return Array.from(b);
        };
        p.me = function() {
            var a = Infinity, b = this.i.keys();
            b = u(b);
            for(var c = b.next(); !c.done; c = b.next())c = c.value, isNaN(c.expiration) || (a = Math.min(a, c.expiration));
            return a;
        };
        function ai(a) {
            return a.I ? a.I : NaN;
        }
        p.uf = function() {
            return kh(this.aa);
        };
        function Kh(a, b) {
            var c, d, e, f, g, h, k;
            return Q(function(l) {
                switch(l.g){
                    case 1:
                        c = new Map;
                        d = bi(a, b, c);
                        if (!d) {
                            if (!navigator.requestMediaKeySystemAccess) throw new U(2, 6, 6020);
                            throw new U(2, 6, 6001);
                        }
                        ih(a.l);
                        ra(l, 2);
                        d.getConfiguration();
                        var m = e = a.h.keySystemsMapping[d.keySystem] || d.keySystem, n = c.get(e), q = [], r = [], t = [], w = [], v = [], z = new Set, y = new Set;
                        ci(n, q, r, w, t, v, z, y);
                        var A = a.P ? "persistent-license" : "temporary";
                        m = {
                            keySystem: m,
                            encryptionScheme: q[0],
                            licenseServerUri: r[0],
                            distinctiveIdentifierRequired: n[0].distinctiveIdentifierRequired,
                            persistentStateRequired: n[0].persistentStateRequired,
                            sessionType: n[0].sessionType || A,
                            audioRobustness: n[0].audioRobustness || "",
                            videoRobustness: n[0].videoRobustness || "",
                            serverCertificate: w[0],
                            serverCertificateUri: t[0],
                            initData: v,
                            keyIds: z
                        };
                        y.size > 0 && (m.keySystemUris = y);
                        n = u(n);
                        for(y = n.next(); !y.done; y = n.next())y = y.value, y.distinctiveIdentifierRequired && (m.distinctiveIdentifierRequired = y.distinctiveIdentifierRequired), y.persistentStateRequired && (m.persistentStateRequired = y.persistentStateRequired);
                        a.g = m;
                        if (!a.g.licenseServerUri) throw new U(2, 6, 6012, a.g.keySystem);
                        return F(l, d.createMediaKeys(), 4);
                    case 4:
                        f = l.h;
                        ih(a.l);
                        a.C = f;
                        if (!(a.h.minHdcpVersion != "" && "getStatusForPolicy" in a.C)) {
                            l.B(5);
                            break;
                        }
                        ra(l, 6);
                        return F(l, a.C.getStatusForPolicy({
                            minHdcpVersion: a.h.minHdcpVersion
                        }), 8);
                    case 8:
                        g = l.h;
                        if (g != "usable") throw new U(2, 6, 6018);
                        ih(a.l);
                        ta(l, 5, 2);
                        break;
                    case 6:
                        h = ua(l, 2);
                        if (h instanceof U) throw h;
                        throw new U(2, 6, 6019, h.message);
                    case 5:
                        return a.R = !0, a.G.wa(a.h.updateExpirationTime), F(l, Uh(a), 9);
                    case 9:
                        ih(a.l);
                        ta(l, 0);
                        break;
                    case 2:
                        k = ua(l);
                        ih(a.l, k);
                        a.g = null;
                        if (k instanceof U) throw k;
                        throw new U(2, 6, 6002, k.message);
                }
            });
        }
        function bi(a, b, c) {
            for(var d = u(b), e = d.next(); !e.done; e = d.next()){
                e = u(Nh(e.value));
                for(var f = e.next(); !f.done; f = e.next())f = f.value, c.has(f.keySystem) || c.set(f.keySystem, []), c.get(f.keySystem).push(f);
            }
            if (c.size == 1 && c.has("")) throw new U(2, 6, 6E3);
            d = a.h.preferredKeySystems;
            d.length || (e = jh(a.h.servers), e.size == 1 && (d = Array.from(e.keys())));
            e = u(d);
            var g = e.next();
            for(f = {}; !g.done; f = {
                wj: void 0
            }, g = e.next()){
                f.wj = g.value;
                g = u(b);
                for(var h = g.next(); !h.done; h = g.next())if (h = h.value.decodingInfos.find(function(n) {
                    return function(q) {
                        return q.supported && q.keySystemAccess != null && q.keySystemAccess.keySystem == n.wj;
                    };
                }(f))) return h.keySystemAccess;
            }
            e = u([
                !0,
                !1
            ]);
            for(f = e.next(); !f.done; f = e.next())for(f = f.value, g = u(b), h = g.next(); !h.done; h = g.next()){
                h = u(h.value.decodingInfos);
                for(var k = h.next(); !k.done; k = h.next())if (k = k.value, k.supported && k.keySystemAccess) {
                    var l = k.keySystemAccess.keySystem;
                    if (!d.includes(l)) {
                        var m = c.get(l);
                        !m && a.h.keySystemsMapping[l] && (m = c.get(a.h.keySystemsMapping[l]));
                        l = u(m);
                        for(m = l.next(); !m.done; m = l.next())if (!!m.value.licenseServerUri == f) return k.keySystemAccess;
                    }
                }
            }
            return null;
        }
        function di(a) {
            Yh(a) && a.m.resolve();
        }
        function ei(a, b) {
            new Bf(function() {
                b.loaded = !0;
                di(a);
            }).$(gi);
        }
        function Wh(a, b, c) {
            var d, e, f, g, h, k, l;
            return Q(function(m) {
                switch(m.g){
                    case 1:
                        try {
                            d = a.C.createSession("persistent-license");
                        } catch (n) {
                            return e = new U(2, 6, 6005, n.message), a.A(e), m.return(Promise.reject(e));
                        }
                        a.u.o(d, "message", function(n) {
                            a.j && a.h.delayLicenseRequestUntilPlayed && a.j.paused && !a.X ? a.M.push(n) : Sh(a, n);
                        });
                        a.u.o(d, "keystatuseschange", function(n) {
                            return hi(a, n);
                        });
                        f = {
                            initData: c.initData,
                            initDataType: c.initDataType,
                            loaded: !1,
                            Nh: Infinity,
                            Rb: null,
                            type: "persistent-license"
                        };
                        a.i.set(d, f);
                        ra(m, 2);
                        return F(m, d.load(b), 4);
                    case 4:
                        return g = m.h, ih(a.l), g || (a.i.delete(d), h = a.h.persistentSessionOnlinePlayback ? 1 : 2, a.A(new U(h, 6, 6013)), f.loaded = !0), ei(a, f), di(a), m.return(d);
                    case 2:
                        k = ua(m), ih(a.l, k), a.i.delete(d), l = a.h.persistentSessionOnlinePlayback ? 1 : 2, a.A(new U(l, 6, 6005, k.message)), f.loaded = !0, di(a);
                    case 3:
                        return m.return(Promise.resolve());
                }
            });
        }
        function Zh(a, b, c, d) {
            try {
                var e = a.C.createSession(d);
            } catch (f) {
                a.A(new U(2, 6, 6005, f.message));
                return;
            }
            a.u.o(e, "message", function(f) {
                a.j && a.h.delayLicenseRequestUntilPlayed && a.j.paused && !a.X ? a.M.push(f) : Sh(a, f);
            });
            a.u.o(e, "keystatuseschange", function(f) {
                return hi(a, f);
            });
            a.i.set(e, {
                initData: c,
                initDataType: b,
                loaded: !1,
                Nh: Infinity,
                Rb: null,
                type: d
            });
            try {
                c = a.h.initDataTransform(c, b, a.g);
            } catch (f) {
                b = f;
                f instanceof U || (b = new U(2, 6, 6016, f));
                a.A(b);
                return;
            }
            a.h.logLicenseExchange && fc(c);
            e.generateRequest(b, c).catch(function(f) {
                if (!a.l.g) {
                    a.i.delete(e);
                    var g = f.errorCode;
                    if (g && g.systemCode) {
                        var h = g.systemCode;
                        h < 0 && (h += 4294967296);
                        h = "0x" + h.toString(16);
                    }
                    a.A(new U(2, 6, 6006, f.message, f, h));
                }
            });
        }
        function ii(a) {
            return Q(function(b) {
                return b.g == 1 ? a.J ? F(b, a.m, 3) : b.B(0) : F(b, Promise.all(a.V.map(function(c) {
                    return c.promise;
                })), 0);
            });
        }
        function Sh(a, b) {
            var c, d, e, f, g, h, k, l, m, n, q, r, t, w, v, z;
            Q(function(y) {
                switch(y.g){
                    case 1:
                        c = b.target;
                        a.h.logLicenseExchange && fc(b.message);
                        d = a.i.get(c);
                        e = a.g.licenseServerUri;
                        f = a.h.advanced[a.g.keySystem];
                        b.messageType == "individualization-request" && f && f.individualizationServer && (e = f.individualizationServer);
                        g = $g([
                            e
                        ], a.h.retryParameters);
                        g.body = b.message;
                        g.method = "POST";
                        g.licenseRequestType = b.messageType;
                        g.sessionId = c.sessionId;
                        g.drmInfo = a.g;
                        d && (g.initData = d.initData, g.initDataType = d.initDataType);
                        if (f && f.headers) for(h in f.headers)g.headers[h] = f.headers[h];
                        if (a.g.keySystem === "org.w3.clearkey") {
                            var A = g, C = a.g;
                            try {
                                var E = Zb(A.body);
                                if (E) {
                                    var D = JSON.parse(E);
                                    D.type || (D.type = C.sessionType, A.body = $b(JSON.stringify(D)));
                                }
                            } catch (B) {}
                        }
                        if (zg(a.g.keySystem)) {
                            if (A = Xb(g.body, !0, !0), A.includes("PlayReadyKeyMessage")) {
                                A = Kd(A, "PlayReadyKeyMessage");
                                C = Ud(A, "HttpHeader");
                                C = u(C);
                                for(E = C.next(); !E.done; E = C.next())D = E.value, E = Ud(D, "name")[0], D = Ud(D, "value")[0], g.headers[Sd(E)] = Sd(D);
                                A = Ud(A, "Challenge")[0];
                                g.body = hc(Sd(A));
                            } else g.headers["Content-Type"] = "text/xml; charset=utf-8";
                        }
                        k = Date.now();
                        ra(y, 2);
                        m = a.F.Dc.request(2, g, {
                            isPreload: a.S()
                        });
                        a.V.push(m);
                        return F(y, m.promise, 4);
                    case 4:
                        l = y.h;
                        Qc(a.V, m);
                        ta(y, 3);
                        break;
                    case 2:
                        n = ua(y);
                        if (a.l.g) return y.return();
                        q = {
                            sessionId: c.sessionId,
                            sessionType: d.type,
                            initData: d.initData,
                            initDataType: d.initDataType
                        };
                        r = new U(2, 6, 6007, n, q);
                        a.i.size == 1 ? (a.A(r), d && d.Rb && d.Rb.reject(r)) : (d && d.Rb && d.Rb.reject(r), a.i.delete(c), Yh(a) && (a.m.resolve(), a.K.$(.1)));
                        return y.return();
                    case 3:
                        if (a.l.g) return y.return();
                        a.I += (Date.now() - k) / 1E3;
                        a.h.logLicenseExchange && fc(l.data);
                        ra(y, 5);
                        return F(y, c.update(l.data), 7);
                    case 7:
                        ta(y, 6);
                        break;
                    case 5:
                        return w = (t = ua(y)) && t.message || String(t), v = new U(2, 6, 6008, w), a.A(v), d && d.Rb && d.Rb.reject(v), y.return();
                    case 6:
                        if (a.l.g) return y.return();
                        z = new T("drmsessionupdate");
                        a.F.onEvent(z);
                        d && (d.Rb && d.Rb.resolve(), ei(a, d));
                        H(y);
                }
            });
        }
        function hi(a, b) {
            b = b.target;
            var c = a.i.get(b), d = !1;
            b.keyStatuses.forEach(function(f, g) {
                if (typeof g == "string") {
                    var h = g;
                    g = f;
                    f = h;
                }
                h = Rb();
                if (zg(a.g.keySystem) && g.byteLength == 16 && h.Yh()) {
                    h = Ob(g);
                    var k = h.getUint32(0, !0), l = h.getUint16(4, !0), m = h.getUint16(6, !0);
                    h.setUint32(0, k, !1);
                    h.setUint16(4, l, !1);
                    h.setUint16(6, m, !1);
                }
                f != "status-pending" && (c.loaded = !0);
                f == "expired" && (d = !0);
                g = jc(g).slice(0, 32);
                a.Y.set(g, f);
            });
            var e = b.expiration - Date.now();
            (e < 0 || d && e < 1E3) && c && !c.Rb && (a.i.delete(b), ji(b));
            Yh(a) && (a.m.resolve(), a.K.$(ki));
        }
        function Ch(a) {
            var b = a.Y, c = a.aa;
            c.clear();
            b.forEach(function(d, e) {
                return c.set(e, d);
            });
            b = Array.from(c.values());
            b.length && b.every(function(d) {
                return d == "expired";
            }) && a.A(new U(2, 6, 6014));
            a.F.Rf(kh(c));
        }
        function li() {
            var a, b, c, d, e, f, g, h, k, l, m, n, q, r, t, w, v, z, y, A, C, E, D, B, G, I, J, L, K, N, P, O, M, R, W;
            return Q(function(wa) {
                if (wa.g == 1) {
                    a = "org.w3.clearkey com.widevine.alpha com.widevine.alpha.experiment com.microsoft.playready com.microsoft.playready.hardware com.microsoft.playready.recommendation com.microsoft.playready.recommendation.3000 com.microsoft.playready.recommendation.3000.clearlead com.chromecast.playready com.apple.fps.1_0 com.apple.fps com.huawei.wiseplay".split(" ");
                    if (!(window1.MediaKeys && window1.navigator && window1.navigator.requestMediaKeySystemAccess && window1.MediaKeySystemAccess && window1.MediaKeySystemAccess.prototype.getConfiguration)) {
                        b = {};
                        c = u(a);
                        for(d = c.next(); !d.done; d = c.next())e = d.value, b[e] = null;
                        return wa.return(b);
                    }
                    f = "1.0 1.1 1.2 1.3 1.4 2.0 2.1 2.2 2.3".split(" ");
                    g = [
                        "SW_SECURE_CRYPTO",
                        "SW_SECURE_DECODE",
                        "HW_SECURE_CRYPTO",
                        "HW_SECURE_DECODE",
                        "HW_SECURE_ALL"
                    ];
                    h = [
                        "150",
                        "2000",
                        "3000"
                    ];
                    k = {
                        "com.widevine.alpha": g,
                        "com.widevine.alpha.experiment": g,
                        "com.microsoft.playready.recommendation": h
                    };
                    l = [
                        {
                            contentType: 'video/mp4; codecs="avc1.42E01E"'
                        },
                        {
                            contentType: 'video/webm; codecs="vp8"'
                        }
                    ];
                    m = [
                        {
                            contentType: 'audio/mp4; codecs="mp4a.40.2"'
                        },
                        {
                            contentType: 'audio/webm; codecs="opus"'
                        }
                    ];
                    n = {
                        videoCapabilities: l,
                        audioCapabilities: m,
                        initDataTypes: [
                            "cenc",
                            "sinf",
                            "skd",
                            "keyids"
                        ]
                    };
                    q = [
                        null,
                        "cenc",
                        "cbcs"
                    ];
                    r = new Map;
                    t = Rb();
                    w = function(Y, Ka) {
                        var Na, La, Ea, za, Fa, Da, Aa, Ca, gb, ib, jb, Ab, yb;
                        return Q(function(Wa) {
                            switch(Wa.g){
                                case 1:
                                    return ra(Wa, 2), F(Wa, Ka.createMediaKeys(), 5);
                                case 5:
                                    Na = Wa.h;
                                case 4:
                                    ta(Wa, 3);
                                    break;
                                case 2:
                                    return ua(Wa), Wa.return();
                                case 3:
                                    Ea = (La = Ka.getConfiguration().sessionTypes) ? La.includes("persistent-license") : !1;
                                    t.oj() && (Ea = !1);
                                    za = Ka.getConfiguration().videoCapabilities;
                                    Fa = Ka.getConfiguration().audioCapabilities;
                                    Da = {
                                        persistentState: Ea,
                                        encryptionSchemes: [],
                                        videoRobustnessLevels: [],
                                        audioRobustnessLevels: [],
                                        minHdcpVersions: []
                                    };
                                    r.has(Y) && r.get(Y) ? Da = r.get(Y) : r.set(Y, Da);
                                    (Aa = za[0].encryptionScheme) && !Da.encryptionSchemes.includes(Aa) && Da.encryptionSchemes.push(Aa);
                                    (Ca = za[0].robustness) && !Da.videoRobustnessLevels.includes(Ca) && Da.videoRobustnessLevels.push(Ca);
                                    (gb = Fa[0].robustness) && !Da.audioRobustnessLevels.includes(gb) && Da.audioRobustnessLevels.push(gb);
                                    if ("getStatusForPolicy" in Na) {
                                        ib = [];
                                        jb = u(f);
                                        Ab = jb.next();
                                        for(yb = {}; !Ab.done; yb = {
                                            re: void 0
                                        }, Ab = jb.next())yb.re = Ab.value, Da.minHdcpVersions.includes(yb.re) || ib.push(Na.getStatusForPolicy({
                                            minHdcpVersion: yb.re
                                        }).then(function(Yd) {
                                            return function(Oc) {
                                                Oc != "usable" || Da.minHdcpVersions.includes(Yd.re) || Da.minHdcpVersions.push(Yd.re);
                                            };
                                        }(yb)));
                                        return F(Wa, Promise.all(ib), 0);
                                    }
                                    Wa.B(0);
                            }
                        });
                    };
                    v = function(Y, Ka, Na, La) {
                        var Ea, za, Fa, Da, Aa, Ca, gb, ib, jb, Ab, yb;
                        return Q(function(Wa) {
                            switch(Wa.g){
                                case 1:
                                    ra(Wa, 2);
                                    Ea = Gd(n);
                                    za = u(Ea.videoCapabilities);
                                    for(Fa = za.next(); !Fa.done; Fa = za.next())Da = Fa.value, Da.encryptionScheme = Ka, Da.robustness = Na;
                                    Aa = u(Ea.audioCapabilities);
                                    for(Ca = Aa.next(); !Ca.done; Ca = Aa.next())gb = Ca.value, gb.encryptionScheme = Ka, gb.robustness = La;
                                    ib = Gd(Ea);
                                    ib.persistentState = "required";
                                    ib.sessionTypes = [
                                        "persistent-license"
                                    ];
                                    jb = [
                                        ib,
                                        Ea
                                    ];
                                    yb = Rb();
                                    return yb.Ka() == "MOBILE" ? F(Wa, Ff(5, navigator.requestMediaKeySystemAccess(Y, jb)), 7) : F(Wa, navigator.requestMediaKeySystemAccess(Y, jb), 6);
                                case 6:
                                    Ab = Wa.h;
                                    Wa.B(5);
                                    break;
                                case 7:
                                    Ab = Wa.h;
                                case 5:
                                    return F(Wa, w(Y, Ab), 8);
                                case 8:
                                    ta(Wa, 0);
                                    break;
                                case 2:
                                    ua(Wa), H(Wa);
                            }
                        });
                    };
                    z = function(Y, Ka, Na, La) {
                        var Ea, za, Fa, Da;
                        return Q(function(Aa) {
                            switch(Aa.g){
                                case 1:
                                    return ra(Aa, 2), Ea = {
                                        type: "media-source",
                                        video: {
                                            contentType: l[0].contentType,
                                            width: 640,
                                            height: 480,
                                            bitrate: 1,
                                            framerate: 1
                                        },
                                        audio: {
                                            contentType: m[0].contentType,
                                            channels: 2,
                                            bitrate: 1,
                                            samplerate: 1
                                        },
                                        keySystemConfiguration: {
                                            keySystem: Y,
                                            video: {
                                                encryptionScheme: Ka,
                                                robustness: Na
                                            },
                                            audio: {
                                                encryptionScheme: Ka,
                                                robustness: La
                                            }
                                        }
                                    }, Fa = Rb(), Fa.Ka() == "MOBILE" ? F(Aa, Ff(5, navigator.mediaCapabilities.decodingInfo(Ea)), 7) : F(Aa, navigator.mediaCapabilities.decodingInfo(Ea), 6);
                                case 6:
                                    za = Aa.h;
                                    Aa.B(5);
                                    break;
                                case 7:
                                    za = Aa.h;
                                case 5:
                                    return Da = za.keySystemAccess, F(Aa, w(Y, Da), 8);
                                case 8:
                                    ta(Aa, 0);
                                    break;
                                case 2:
                                    ua(Aa), H(Aa);
                            }
                        });
                    };
                    y = u(a);
                    for(A = y.next(); !A.done; A = y.next())C = A.value, r.set(C, null);
                    E = function(Y) {
                        return Rb().Ja() === "WEBKIT" && Y === "org.w3.clearkey" ? !1 : !0;
                    };
                    D = [];
                    B = u(q);
                    for(G = B.next(); !G.done; G = B.next())for(I = G.value, J = u(a), L = J.next(); !L.done; L = J.next())K = L.value, E(K) && (D.push(v(K, I, "", "")), D.push(z(K, I, "", "")));
                    N = u(a);
                    for(P = N.next(); !P.done; P = N.next())for(O = P.value, M = u(k[O] || []), R = M.next(); !R.done; R = M.next())W = R.value, E(O) && (D.push(v(O, null, W, "")), D.push(v(O, null, "", W)), D.push(z(O, null, W, "")), D.push(z(O, null, "", W)));
                    return F(wa, Promise.all(D), 2);
                }
                return wa.return(kh(r));
            });
        }
        function ji(a) {
            return Q(function(b) {
                if (b.g == 1) return ra(b, 2), F(b, Ff(mi, Promise.all([
                    a.close().catch(function() {}),
                    a.closed
                ])), 4);
                if (b.g != 2) return ta(b, 0);
                ua(b);
                H(b);
            });
        }
        function Fh(a) {
            var b;
            return Q(function(c) {
                b = Array.from(a.i.entries());
                a.i.clear();
                return F(c, Promise.all(b.map(function(d) {
                    d = u(d);
                    var e = d.next().value;
                    var f = d.next().value;
                    return Q(function(g) {
                        if (g.g == 1) return ra(g, 2), a.ea || a.D.has(e.sessionId) || f.type !== "persistent-license" || a.h.persistentSessionOnlinePlayback ? F(g, ji(e), 5) : F(g, e.remove(), 5);
                        if (g.g != 2) return ta(g, 0);
                        ua(g);
                        H(g);
                    });
                })), 0);
            });
        }
        function Nh(a) {
            return (a.video ? a.video.drmInfos : []).concat(a.audio ? a.audio.drmInfos : []);
        }
        function Dh(a) {
            a.i.forEach(function(b, c) {
                var d = b.Nh, e = c.expiration;
                isNaN(e) && (e = Infinity);
                e != d && (a.F.onExpirationUpdated(c.sessionId, e), b.Nh = e);
            });
        }
        function Yh(a) {
            a = a.i.values();
            return mb(a, function(b) {
                return b.loaded;
            });
        }
        function Xh(a) {
            for(var b = u(a.g && a.g.keyIds || new Set([])), c = b.next(); !c.done; c = b.next())if (a.Y.get(c.value) !== "usable") return !1;
            return !0;
        }
        function Mh(a, b) {
            var c = [];
            b.forEach(function(d, e) {
                c.push({
                    keySystem: e,
                    licenseServerUri: d,
                    distinctiveIdentifierRequired: !1,
                    persistentStateRequired: !1,
                    audioRobustness: "",
                    videoRobustness: "",
                    serverCertificate: null,
                    serverCertificateUri: "",
                    initData: [],
                    keyIds: new Set
                });
            });
            a = u(a);
            for(b = a.next(); !b.done; b = a.next())b = b.value, b.video && (b.video.drmInfos = c), b.audio && (b.audio.drmInfos = c);
        }
        function ci(a, b, c, d, e, f, g, h) {
            var k = [];
            a = u(a);
            for(var l = a.next(), m = {}; !l.done; m = {
                Ta: void 0
            }, l = a.next()){
                m.Ta = l.value;
                b.includes(m.Ta.encryptionScheme) || b.push(m.Ta.encryptionScheme);
                m.Ta.keySystem == "org.w3.clearkey" && m.Ta.licenseServerUri.startsWith("data:application/json;base64,") ? k.includes(m.Ta.licenseServerUri) || k.push(m.Ta.licenseServerUri) : c.includes(m.Ta.licenseServerUri) || c.push(m.Ta.licenseServerUri);
                e.includes(m.Ta.serverCertificateUri) || e.push(m.Ta.serverCertificateUri);
                m.Ta.serverCertificate && (d.some(function(r) {
                    return function(t) {
                        return Jb(t, r.Ta.serverCertificate);
                    };
                }(m)) || d.push(m.Ta.serverCertificate));
                if (m.Ta.initData) {
                    l = u(m.Ta.initData);
                    for(var n = l.next(), q = {}; !n.done; q = {
                        Dh: void 0
                    }, n = l.next())q.Dh = n.value, f.some(function(r) {
                        return function(t) {
                            var w = r.Dh;
                            return t.keyId && t.keyId == w.keyId ? !0 : t.initDataType == w.initDataType && Jb(t.initData, w.initData);
                        };
                    }(q)) || f.push(q.Dh);
                }
                if (m.Ta.keyIds) for(l = u(m.Ta.keyIds), n = l.next(); !n.done; n = l.next())g.add(n.value);
                if (m.Ta.keySystemUris && h) for(m = u(m.Ta.keySystemUris), l = m.next(); !l.done; l = m.next())h.add(l.value);
            }
            if (k.length == 1) c.push(k[0]);
            else if (k.length > 0) {
                b = [];
                k = u(k);
                for(d = k.next(); !d.done; d = k.next())d = window1.atob(d.value.split("data:application/json;base64,").pop()), d = JSON.parse(d), b.push.apply(b, x(d.keys));
                k = JSON.stringify({
                    keys: b
                });
                c.push("data:application/json;base64," + window1.btoa(k));
            }
        }
        function Oh(a, b, c, d) {
            var e = a.keySystem;
            if (e && (e != "org.w3.clearkey" || !a.licenseServerUri)) {
                b.size && b.get(e) && (b = b.get(e), a.licenseServerUri = b);
                a.keyIds || (a.keyIds = new Set);
                if (c = c.get(e)) a.distinctiveIdentifierRequired || (a.distinctiveIdentifierRequired = c.distinctiveIdentifierRequired), a.persistentStateRequired || (a.persistentStateRequired = c.persistentStateRequired), a.serverCertificate || (a.serverCertificate = c.serverCertificate), c.sessionType && (a.sessionType = c.sessionType), a.serverCertificateUri || (a.serverCertificateUri = c.serverCertificateUri);
                d[e] && (a.keySystem = d[e]);
                window1.cast && window1.cast.__platform__ && e == "com.microsoft.playready" && (a.keySystem = "com.chromecast.playready");
            }
        }
        function Lh(a, b) {
            a = jh(a);
            if (a.size != 0) {
                a = oc(a);
                b = u(b);
                for(var c = b.next(); !c.done; c = b.next())c = c.value, c.video && (c.video.drmInfos = [
                    a
                ]), c.audio && (c.audio.drmInfos = [
                    a
                ]);
            }
        }
        var mi = 1, gi = 5, ki = .5;
        function ni() {
            this.g = oi;
            this.i = (new Map).set(oi, 2).set(pi, 1);
            this.h = 0;
        }
        function qi(a, b) {
            var c = a.g !== b;
            a.g = b;
            c && b === oi && (a.h = Date.now());
            return c;
        }
        var pi = 0, oi = 1; /*
 @license
 Shaka Player
 Copyright 2023 Google LLC
 SPDX-License-Identifier: Apache-2.0
*/ 
        function ui(a, b, c) {
            this.g = a;
            this.i = b;
            this.h = c;
        }
        function vi(a, b) {
            return Q(function(c) {
                if (c.g == 1) return F(c, Lf(a.h, b, a.g.drm.preferredKeySystems, a.g.drm.keySystemsMapping), 2);
                a.g.streaming.dontChooseCodecs || Hf(b, a.g.preferredVideoCodecs, a.g.preferredAudioCodecs, a.g.preferredDecodingAttributes, a.g.preferredTextFormats);
                if (!b.variants.some(jg)) throw new U(2, 4, 4032);
                return c.return(wi(a, b));
            });
        }
        function xi(a, b) {
            var c = a.g.restrictions;
            a = a.i;
            var d = !1;
            b = u(b.variants);
            for(var e = b.next(); !e.done; e = b.next()){
                e = e.value;
                var f = e.allowedByApplication;
                e.allowedByApplication = Kf(e, c, a);
                f != e.allowedByApplication && (d = !0);
            }
            return d;
        }
        function wi(a, b) {
            var c = xi(a, b);
            if (b) {
                var d = a.h ? a.h.g : null;
                if (d && a.h.C) {
                    for(var e = new Set, f = u(b.variants), g = f.next(); !g.done; g = f.next())g = g.value, g.audio && e.add(g.audio), g.video && e.add(g.video);
                    e = u(e);
                    for(f = e.next(); !f.done; f = e.next())yi(a, d.keySystem, f.value);
                }
                zi(a, b);
            }
            return c;
        }
        function yi(a, b, c) {
            c = u(c.drmInfos);
            for(var d = c.next(); !d.done; d = c.next())if (d = d.value, d.keySystem == b) {
                d = u(d.initData || []);
                for(var e = d.next(); !e.done; e = d.next())e = e.value, Rh(a.h, e.initDataType, e.initData);
            }
        }
        function zi(a, b) {
            a = a.h ? a.h.uf() : {};
            var c = Object.keys(a);
            c = c.length && c[0] == "00";
            var d = !1, e = !1, f = new Set, g = new Set, h = new Set;
            b = u(b.variants);
            for(var k = b.next(); !k.done; k = b.next())k = k.value, k.audio && h.add(k.audio), k.video && h.add(k.video), k.allowedByApplication ? k.allowedByKeySystem && (d = !0) : e = !0;
            h = u(h);
            for(b = h.next(); !b.done; b = h.next())if (b = b.value, b.keyIds.size) for(b = u(b.keyIds), k = b.next(); !k.done; k = b.next()){
                k = k.value;
                var l = a[c ? "00" : k];
                l ? Ai.includes(l) && g.add(l) : f.add(k);
            }
            if (!d) throw a = {
                hasAppRestrictions: e,
                missingKeys: Array.from(f),
                restrictedKeyStatuses: Array.from(g)
            }, new U(2, 4, 4012, a);
        }
        var Ai = [
            "output-restricted",
            "internal-error"
        ];
        function Bi() {}
        function Ci(a, b) {
            Di.set(a, b);
        }
        function Ei() {
            var a = {};
            Rb();
            if (Fi()) for(var b = u(Di.keys()), c = b.next(); !c.done; c = b.next())a[c.value] = !0;
            b = u([
                "application/dash+xml",
                "application/x-mpegurl",
                "application/vnd.apple.mpegurl",
                "application/vnd.ms-sstr+xml"
            ]);
            for(c = b.next(); !c.done; c = b.next())c = c.value, a[c] = Fi() ? Di.has(c) : Gi().canPlayType(c) != "";
            return a;
        }
        function Hi(a, b) {
            if (b) {
                var c = Di.get(b.toLowerCase());
                if (c) return c;
            }
            throw new U(2, 4, 4E3, a, b);
        }
        S("shaka.media.ManifestParser", Bi);
        Bi.unregisterParserByMime = function(a) {
            Di.delete(a);
        };
        Bi.registerParserByMime = Ci;
        Bi.registerParserByExtension = function() {
            Zc("ManifestParser.registerParserByExtension", "Please use an ManifestParser with registerParserByMime function.");
        };
        Bi.AccessibilityPurpose = {
            Rn: "visually impaired",
            $m: "hard of hearing",
            An: "spoken subtitles"
        };
        var Di = new Map;
        S("shaka.config.CodecSwitchingStrategy", {
            RELOAD: "reload",
            SMOOTH: "smooth"
        });
        function Ii(a, b) {
            var c = null, d = null, e = null, f = null, g = a.Z();
            b & 1 && (e = a.Td());
            b & 2 && (f = a.Z());
            b & 8 && (c = a.Z());
            b & 16 && (d = a.Z());
            return {
                trackId: g,
                je: c,
                ke: d,
                nk: e,
                Ej: f
            };
        }
        function Ji(a, b) {
            return b == 1 ? (b = a.Z(), a = a.Z(), {
                baseMediaDecodeTime: b * 4294967296 + a
            }) : {
                baseMediaDecodeTime: a.Z()
            };
        }
        function Ki(a, b) {
            b == 1 ? (a.skip(8), a.skip(8)) : (a.skip(4), a.skip(4));
            b = a.Z();
            a.skip(4);
            a = a.Ha();
            return {
                timescale: b,
                language: String.fromCharCode((a >> 10) + 96) + String.fromCharCode(((a & 960) >> 5) + 96) + String.fromCharCode((a & 31) + 96)
            };
        }
        function Li(a, b, c) {
            var d = a.Z(), e = [], f = null;
            c & 1 && (f = a.Sh());
            c & 4 && a.skip(4);
            for(var g = 0; g < d; g++){
                var h = {
                    $h: null,
                    sampleSize: null,
                    cg: null
                };
                c & 256 && (h.$h = a.Z());
                c & 512 && (h.sampleSize = a.Z());
                c & 1024 && a.skip(4);
                c & 2048 && (h.cg = b == 0 ? a.Z() : a.Sh());
                e.push(h);
            }
            return {
                Xn: d,
                Zh: e,
                Tg: f
            };
        }
        function Mi(a) {
            a.skip(6);
            a.skip(2);
            a.skip(8);
            var b = a.Ha();
            a.skip(2);
            a.skip(2);
            a.skip(2);
            a = a.Ha() + a.Ha() / 65536;
            return {
                channelCount: b,
                sampleRate: a
            };
        }
        function Ni(a) {
            a = a.Z();
            return {
                codec: sh(a)
            };
        }
        function Oi(a) {
            var b = null, c = null, d = a.ac(4);
            var e = String.fromCharCode(d[0]);
            e += String.fromCharCode(d[1]);
            e += String.fromCharCode(d[2]);
            e += String.fromCharCode(d[3]);
            if (e === "nclx") {
                switch(a.Ha()){
                    case 1:
                    case 5:
                    case 6:
                    case 7:
                        b = "srgb";
                        break;
                    case 9:
                        b = "rec2020";
                        break;
                    case 11:
                    case 12:
                        b = "p3";
                }
                d = a.Ha();
                a.Ha();
                switch(d){
                    case 1:
                    case 6:
                    case 13:
                    case 14:
                    case 15:
                        c = "SDR";
                        break;
                    case 16:
                        c = "PQ";
                        break;
                    case 18:
                        c = "HLG";
                }
            }
            return {
                colorGamut: b,
                Ne: c
            };
        }
        function Pi(a, b) {
            b = b === void 0 ? !1 : b;
            a = a.toString(16).toUpperCase();
            return b ? a : ("0" + a).slice(-2);
        }
        function Qi(a) {
            return (a < 10 ? "0" : "") + a;
        }
        function Ri(a) {
            this.g = a;
        }
        function Si(a) {
            for(var b = [], c = u(a.g), d = c.next(); !d.done; d = c.next()){
                var e = b, f = e.push;
                var g = d.value;
                d = Ti;
                var h = g.id + 1;
                var k = g.stream.width || 0, l = g.stream.height || 0;
                g.type == "audio" && (l = k = 0);
                var m = g.duration * g.timescale, n = Math.floor(m / (Ui + 1));
                m = Math.floor(m % (Ui + 1));
                h = new Uint8Array([
                    1,
                    0,
                    0,
                    7,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3
                ].concat(x(Vi(h, 4)), [
                    0,
                    0,
                    0,
                    0
                ], x(Vi(n, 4)), x(Vi(m, 4)), [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    64,
                    0,
                    0,
                    0
                ], x(Vi(k, 2)), [
                    0,
                    0
                ], x(Vi(l, 2)), [
                    0,
                    0
                ]));
                h = Ti("tkhd", h);
                k = Ti;
                n = g.duration * g.timescale;
                l = Math.floor(n / (Ui + 1));
                n = Math.floor(n % (Ui + 1));
                m = g.stream.language;
                m = m.charCodeAt(0) - 96 << 10 | m.charCodeAt(1) - 96 << 5 | m.charCodeAt(2) - 96;
                l = new Uint8Array([
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3
                ].concat(x(Vi(g.timescale, 4)), x(Vi(l, 4)), x(Vi(n, 4)), x(Vi(m, 2)), [
                    0,
                    0
                ]));
                l = Ti("mdhd", l);
                n = g;
                m = new Uint8Array([]);
                switch(n.type){
                    case "video":
                        m = Wi.value();
                        break;
                    case "audio":
                        m = Xi.value();
                }
                n = Ti("hdlr", m);
                a: {
                    switch(g.type){
                        case "video":
                            g = Ti("minf", Ti("vmhd", Yi.value()), Zi.value(), $i(g));
                            break a;
                        case "audio":
                            g = Ti("minf", Ti("smhd", aj.value()), Zi.value(), $i(g));
                            break a;
                    }
                    g = new Uint8Array([]);
                }
                g = k("mdia", l, n, g);
                d = d("trak", h, g);
                f.call(e, d);
            }
            b = lc.apply(dc, x(b));
            f = a.g[0];
            c = Ti;
            d = f.duration * f.timescale;
            e = Math.floor(d / (Ui + 1));
            d = Math.floor(d % (Ui + 1));
            e = new Uint8Array([
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                2,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                3
            ].concat(x(Vi(f.timescale, 4)), x(Vi(e, 4)), x(Vi(d, 4)), [
                0,
                1,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                64,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                255,
                255,
                255,
                255
            ]));
            e = Ti("mvhd", e);
            d = [];
            a = u(a.g);
            for(k = a.next(); !k.done; k = a.next())g = d, h = g.push, k = new Uint8Array([
                0,
                0,
                0,
                0
            ].concat(x(Vi(k.value.id + 1, 4)), [
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ])), k = Ti("trex", k), h.call(g, k);
            a = lc.apply(dc, x(d));
            a = Ti("mvex", a);
            d = [];
            if (f.encrypted) {
                f = u(f.stream.drmInfos);
                for(g = f.next(); !g.done; g = f.next())if (g = g.value, g.initData) for(g = u(g.initData), h = g.next(); !h.done; h = g.next())d.push(h.value.initData);
                f = lc.apply(dc, x(d));
            } else f = new Uint8Array([]);
            a = c("moov", e, b, a, f);
            b = bj.value();
            c = new Uint8Array(b.byteLength + a.byteLength);
            c.set(b);
            c.set(a, b.byteLength);
            return c;
        }
        function $i(a) {
            var b = Ti, c = "aac";
            a.codecs.includes("mp3") ? c = "mp3" : a.codecs.includes("ac-3") ? c = Rb().Fe() ? "ec-3" : "ac-3" : a.codecs.includes("ec-3") ? c = "ec-3" : a.codecs.includes("opus") && (c = "opus");
            var d = new Uint8Array([]);
            switch(a.type){
                case "video":
                    if (a.codecs.includes("avc1")) {
                        c = a.stream.width || 0;
                        d = a.stream.height || 0;
                        if (a.Ya.byteLength > 0) var e = Ti("avcC", a.Ya);
                        else {
                            e = Ti;
                            for(var f = 7, g = [], h = [], k = 0, l = 0, m = 0, n = 0; n < a.Hb.length; n++){
                                var q = cj(a.Hb[n]);
                                switch(q[0] & 31){
                                    case 7:
                                        g.push(q);
                                        f += q.length + 2;
                                        break;
                                    case 8:
                                        h.push(q), f += q.length + 2;
                                }
                            }
                            g.length > 0 && (k = g[0][1], m = g[0][2], l = g[0][3]);
                            f = new Uint8Array(f);
                            n = 0;
                            f[n++] = 1;
                            f[n++] = k;
                            f[n++] = m;
                            f[n++] = l;
                            f[n++] = 255;
                            f[n++] = 224 | g.length;
                            for(k = 0; k < g.length; k++)f[n++] = (g[k].length & 65280) >> 8, f[n++] = g[k].length & 255, f.set(g[k], n), n += g[k].length;
                            f[n++] = h.length;
                            for(g = 0; g < h.length; g++)f[n++] = (h[g].length & 65280) >> 8, f[n++] = h[g].length & 255, f.set(h[g], n), n += h[g].length;
                            e = e("avcC", f);
                        }
                        c = new Uint8Array([
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ].concat(x(Vi(c, 2)), x(Vi(d, 2)), [
                            0,
                            72,
                            0,
                            0,
                            0,
                            72,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            1,
                            19,
                            118,
                            105,
                            100,
                            101,
                            111,
                            106,
                            115,
                            45,
                            99,
                            111,
                            110,
                            116,
                            114,
                            105,
                            98,
                            45,
                            104,
                            108,
                            115,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            24,
                            17,
                            17
                        ]));
                        d = "avc1";
                        h = dj(a);
                        g = new Uint8Array([]);
                        a.encrypted && (g = ej(a.stream, a.codecs), d = "encv");
                        d = Ti(d, c, e, h, g);
                    } else a.codecs.includes("hvc1") && (d = a.stream.width || 0, e = a.stream.height || 0, c = new Uint8Array([]), a.Ya.byteLength > 0 && (c = Ti("hvcC", a.Ya)), d = new Uint8Array([
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ].concat(x(Vi(d, 2)), x(Vi(e, 2)), [
                        0,
                        72,
                        0,
                        0,
                        0,
                        72,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        19,
                        118,
                        105,
                        100,
                        101,
                        111,
                        106,
                        115,
                        45,
                        99,
                        111,
                        110,
                        116,
                        114,
                        105,
                        98,
                        45,
                        104,
                        108,
                        115,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        24,
                        17,
                        17
                    ])), e = "hvc1", h = dj(a), g = new Uint8Array([]), a.encrypted && (g = ej(a.stream, a.codecs), e = "encv"), d = Ti(e, d, c, h, g));
                    break;
                case "audio":
                    if (c == "mp3") a = Ti(".mp3", fj(a));
                    else if (c == "ac-3") c = Ti("dac3", a.Na), d = "ac-3", e = new Uint8Array([]), a.encrypted && (e = ej(a.stream, a.codecs), d = "enca"), a = Ti(d, fj(a), c, e);
                    else if (c == "ec-3") c = Ti("dec3", a.Na), d = "ec-3", e = new Uint8Array([]), a.encrypted && (e = ej(a.stream, a.codecs), d = "enca"), a = Ti(d, fj(a), c, e);
                    else if (c == "opus") c = Ti("dOps", a.Na), d = "Opus", e = new Uint8Array([]), a.encrypted && (e = ej(a.stream, a.codecs), d = "enca"), a = Ti(d, fj(a), c, e);
                    else {
                        if (a.Na.byteLength > 0) c = Ti("esds", a.Na);
                        else {
                            c = Ti;
                            d = a.id + 1;
                            e = a.stream.channelsCount || 2;
                            g = a.stream.audioSamplingRate || 44100;
                            k = pc("audio", a.codecs.split(","));
                            l = {
                                96E3: 0,
                                88200: 1,
                                64E3: 2,
                                48E3: 3,
                                44100: 4,
                                32E3: 5,
                                24E3: 6,
                                22050: 7,
                                16E3: 8,
                                12E3: 9,
                                11025: 10,
                                8E3: 11,
                                7350: 12
                            };
                            h = l[g];
                            if (k === "mp4a.40.5" || k === "mp4a.40.29") h = l[g * 2];
                            g = parseInt(k.split(".").pop(), 10);
                            d = new Uint8Array([
                                0,
                                0,
                                0,
                                0,
                                3,
                                25
                            ].concat(x(Vi(d, 2)), [
                                0,
                                4,
                                17,
                                64,
                                21,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                5,
                                2,
                                g << 3 | h >>> 1,
                                h << 7 | e << 3,
                                6,
                                1,
                                2
                            ]));
                            c = c("esds", d);
                        }
                        d = "mp4a";
                        e = new Uint8Array([]);
                        a.encrypted && (e = ej(a.stream, a.codecs), d = "enca");
                        a = Ti(d, fj(a), c, e);
                    }
                    d = a;
            }
            a = Ti("stsd", gj.value(), d);
            return b("stbl", a, Ti("stts", hj.value()), Ti("stsc", ij.value()), Ti("stsz", jj.value()), Ti("stco", kj.value()));
        }
        function dj(a) {
            if (!a.eb && !a.gb) return new Uint8Array([]);
            var b = a.gb;
            a = new Uint8Array([].concat(x(Vi(a.eb, 4)), x(Vi(b, 4))));
            return Ti("pasp", a);
        }
        function fj(a) {
            return new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                a.stream.channelsCount || 2,
                0,
                16,
                0,
                0,
                0,
                0
            ].concat(x(Vi(a.stream.audioSamplingRate || 44100, 2)), [
                0,
                0
            ]));
        }
        function ej(a, b) {
            var c = Ti;
            b = new Uint8Array([].concat(x(Vi(lj(b.split(".")[0]), 4))));
            b = Ti("frma", b);
            var d = "cenc";
            var e = a.drmInfos[0];
            e && e.encryptionScheme && (d = e.encryptionScheme);
            d = new Uint8Array([
                0,
                0,
                0,
                0
            ].concat(x(Vi(lj(d), 4)), [
                0,
                1,
                0,
                0
            ]));
            d = Ti("schm", d);
            e = Ti;
            var f = new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]);
            a = u(a.drmInfos);
            for(var g = a.next(); !g.done; g = a.next())if ((g = g.value) && g.keyIds && g.keyIds.size) {
                g = u(g.keyIds);
                for(var h = g.next(); !h.done; h = g.next())f = cj(h.value);
            }
            a = new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                8
            ]);
            f = Ti("tenc", a, f);
            return c("sinf", b, d, e("schi", f));
        }
        function mj(a) {
            var b = [];
            a = u(a.g);
            for(var c = a.next(); !c.done; c = a.next()){
                c = c.value;
                var d = b.push, e = d.apply;
                var f = Ti;
                var g = new Uint8Array([
                    0,
                    0,
                    0,
                    0
                ].concat(x(Vi(c.data ? c.data.sequenceNumber : 0, 4))));
                g = Ti("mfhd", g);
                var h;
                var k = c.data ? c.data.Gb : [];
                var l = new Uint8Array(4 + k.length);
                for(h = 0; h < k.length; h++){
                    var m = k[h].flags;
                    l[h + 4] = m.sb << 4 | m.wb << 2 | m.ub;
                }
                k = Ti("sdtp", l);
                var n = k.length + 32 + 20 + 8 + 16 + 8 + 8;
                l = Ti;
                h = new Uint8Array([
                    0,
                    0,
                    0,
                    58
                ].concat(x(Vi(c.id + 1, 4)), [
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]));
                h = Ti("tfhd", h);
                m = c.data ? c.data.baseMediaDecodeTime : 0;
                var q = Math.floor(m % (Ui + 1));
                m = new Uint8Array([
                    1,
                    0,
                    0,
                    0
                ].concat(x(Vi(Math.floor(m / (Ui + 1)), 4)), x(Vi(q, 4))));
                m = Ti("tfdt", m);
                var r = n;
                n = c.data ? c.data.Gb : [];
                q = n.length;
                var t = 12 + 16 * q, w = new Uint8Array(t);
                r += 8 + t;
                w.set([
                    c.type === "video" ? 1 : 0,
                    0,
                    15,
                    1
                ].concat(x(Vi(q, 4)), x(Vi(r, 4))), 0);
                for(r = 0; r < q; r++){
                    var v = n[r];
                    t = Vi(v.duration, 4);
                    var z = Vi(v.size, 4), y = v.flags;
                    v = Vi(v.Cb, 4);
                    w.set([].concat(x(t), x(z), [
                        y.Eb << 2 | y.sb,
                        y.wb << 6 | y.ub << 4 | y.Fb,
                        y.rb & 61440,
                        y.rb & 15
                    ], x(v)), 12 + 16 * r);
                }
                n = Ti("trun", w);
                k = l("traf", h, m, n, k);
                f = f("moof", g, k);
                e.call(d, b, [
                    f,
                    nj(c)
                ]);
            }
            return lc.apply(dc, x(b));
        }
        function nj(a) {
            a = (a.data ? a.data.Gb : []).map(function(b) {
                return b.data;
            });
            a = lc.apply(dc, x(a));
            return Ti("mdat", a);
        }
        function Vi(a, b) {
            var c = [];
            for(--b; b >= 0; b--)c.push(a >> 8 * b & 255);
            return c;
        }
        function cj(a) {
            for(var b = new Uint8Array(a.length / 2), c = 0; c < a.length / 2; c += 1)b[c] = parseInt(String(a[c * 2] + a[c * 2 + 1]), 16);
            return b;
        }
        function lj(a) {
            for(var b = 0, c = 0; c < a.length; c += 1)b |= a.charCodeAt(c) << (a.length - c - 1) * 8;
            return b;
        }
        function Ti(a) {
            var b = Ma.apply(1, arguments), c = oj.get(a);
            c || (c = [
                a.charCodeAt(0),
                a.charCodeAt(1),
                a.charCodeAt(2),
                a.charCodeAt(3)
            ], oj.set(a, c));
            for(var d = 8, e = b.length - 1; e >= 0; e--)d += b[e].byteLength;
            e = new Uint8Array(d);
            e[0] = d >> 24 & 255;
            e[1] = d >> 16 & 255;
            e[2] = d >> 8 & 255;
            e[3] = d & 255;
            e.set(c, 4);
            c = 0;
            for(d = 8; c < b.length; c++)e.set(b[c], d), d += b[c].byteLength;
            return e;
        }
        var Ui = 4294967295, oj = new Map, Wi = new Qb(function() {
            return new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                118,
                105,
                100,
                101,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                86,
                105,
                100,
                101,
                111,
                72,
                97,
                110,
                100,
                108,
                101,
                114,
                0
            ]);
        }), Xi = new Qb(function() {
            return new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                115,
                111,
                117,
                110,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                83,
                111,
                117,
                110,
                100,
                72,
                97,
                110,
                100,
                108,
                101,
                114,
                0
            ]);
        }), hj = new Qb(function() {
            return new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]);
        }), ij = new Qb(function() {
            return new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]);
        }), kj = new Qb(function() {
            return new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]);
        }), jj = new Qb(function() {
            return new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]);
        }), Yi = new Qb(function() {
            return new Uint8Array([
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]);
        }), aj = new Qb(function() {
            return new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]);
        }), gj = new Qb(function() {
            return new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1
            ]);
        }), bj = new Qb(function() {
            var a = new Uint8Array([
                105,
                115,
                111,
                109
            ]), b = new Uint8Array([
                97,
                118,
                99,
                49
            ]), c = new Uint8Array([
                0,
                0,
                0,
                1
            ]);
            return Ti("ftyp", a, c, a, b);
        }), Zi = new Qb(function() {
            var a = new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                12,
                117,
                114,
                108,
                32,
                0,
                0,
                0,
                1
            ]);
            a = Ti("dref", a);
            return Ti("dinf", a);
        });
        function pj(a) {
            a = Kb(a);
            var b = null;
            (new oh).box("moov", th).box("trak", th).box("mdia", th).box("minf", th).box("stbl", th).W("stsd", vh).box("enca", function(c) {
                b = c.reader.h;
                return xh(c);
            }).box("sinf", th).box("frma", function(c) {
                c.parser.stop();
                Ni(c.reader).codec === "ec-3" && b && b.getUint16(16) !== 2 && b.setUint16(16, 2);
            }).parse(a);
            return a;
        }
        function qj(a, b, c) {
            function d(r) {
                n.push({
                    box: r,
                    qj: 1701733217
                });
            }
            function e(r) {
                n.push({
                    box: r,
                    qj: 1701733238
                });
            }
            function f(r) {
                k = !0;
                r.parser.stop();
            }
            function g(r) {
                m.push(r);
                th(r);
            }
            var h = b = Kb(b), k = !1, l, m = [], n = [];
            (new oh).box("moov", g).box("trak", g).box("mdia", g).box("minf", g).box("stbl", g).W("stsd", function(r) {
                l = r;
                m.push(r);
                vh(r);
            }).W("encv", f).W("enca", f).W("dvav", e).W("dva1", e).W("dvh1", e).W("dvhe", e).W("dvc1", e).W("dvi1", e).W("hev1", e).W("hvc1", e).W("avc1", e).W("avc3", e).W("ac-3", d).W("ec-3", d).W("ac-4", d).W("Opus", d).W("fLaC", d).W("mp4a", d).parse(b);
            if (k) return b;
            if (n.length == 0 || !l) throw fb(jc(b)), new U(2, 3, 3019, c);
            n.reverse();
            c = u(n);
            for(var q = c.next(); !q.done; q = c.next())q = q.value, h = rj(a, h, l, q.box, m, q.qj);
            return Rb().zj() ? (a = new Uint8Array(b.byteLength + h.byteLength), a.set(h), a.set(b, h.byteLength), a) : h;
        }
        function sj(a) {
            a = Kb(a);
            var b = [];
            (new oh).box("mdat", function(g) {
                b.push(g);
            }).parse(a);
            for(var c = [], d = 0; d < b.length; d++){
                var e = b[d - 1], f = b[d];
                c.push(tj(a.subarray(e ? e.start + e.size : 0, f.start + f.size)));
            }
            return lc.apply(dc, x(c));
        }
        function tj(a) {
            function b(n) {
                g.push(n);
                th(n);
            }
            var c, d, e, f, g = [];
            (new oh).box("moof", b).box("traf", b).W("tfhd", function(n) {
                c = n;
                e = Ii(n.reader, n.flags);
            }).W("trun", function(n) {
                d = n;
                f = Li(n.reader, n.version, n.flags);
            }).parse(a);
            if (e && e.Ej !== 2) {
                var h = c.start + uh(c) + 4 + (e.nk !== null ? 8 : 0), k = Ob(a);
                if (e.Ej !== null) k.setUint32(h, 2);
                else {
                    uj(a, c.start, c.size + 4);
                    var l = k.getUint32(c.start + 8);
                    k.setUint32(c.start + 8, l | 2);
                    f && f.Tg !== null && k.setInt32(d.start + uh(d) + 4, f.Tg + 4);
                    l = a.subarray(0, h);
                    k = a.subarray(h);
                    a = new Uint8Array(a.byteLength + 4);
                    a.set(l);
                    l = [];
                    for(var m = 3; m >= 0; m--)l.push(2 >> 8 * m & 255);
                    a.set(new Uint8Array(l), h);
                    a.set(k, h + 4);
                    h = u(g);
                    for(k = h.next(); !k.done; k = h.next())k = k.value, uj(a, k.start, k.size + 4);
                }
            }
            return a;
        }
        function rj(a, b, c, d, e, f) {
            var g = ej(a, d.name), h = b.subarray(d.start, d.start + d.size);
            a = new Uint8Array(d.size + g.byteLength);
            a.set(h, 0);
            Ob(a).setUint32(4, f);
            a.set(g, d.size);
            uj(a, 0, a.byteLength);
            f = new Uint8Array(b.byteLength + a.byteLength);
            d = Rb().Bf() ? d.start : d.start + d.size;
            g = b.subarray(d);
            f.set(b.subarray(0, d));
            f.set(a, d);
            f.set(g, d + a.byteLength);
            b = u(e);
            for(e = b.next(); !e.done; e = b.next())e = e.value, uj(f, e.start, e.size + a.byteLength);
            a = Ob(f, c.start);
            c = uh(c);
            b = a.getUint32(c);
            a.setUint32(c, b + 1);
            return f;
        }
        function uj(a, b, c) {
            a = Ob(a, b);
            b = a.getUint32(0);
            b != 0 && (b == 1 ? (a.setUint32(8, c >> 32), a.setUint32(12, c & 4294967295)) : a.setUint32(0, c));
        }
        function vj(a) {
            function b(e) {
                d.push({
                    start: e.start,
                    size: e.size
                });
                th(e);
            }
            var c = Kb(a), d = [];
            (new oh).box("moov", b).box("trak", b).box("mdia", b).box("minf", b).box("stbl", b).box("stsd", function(e) {
                d.push({
                    start: e.start,
                    size: e.size
                });
                for(var f = Ob(c, e.start), g = 0; g < e.size - 3; g++){
                    var h = f.getUint32(g);
                    h == 1633889587 ? f.setUint32(g, 1700998451) : h == 1684103987 && f.setUint32(g, 1684366131);
                }
            }).parse(c);
            return c;
        }
        function wj(a, b, c, d, e, f, g, h) {
            this.T = a;
            this.startByte = b;
            this.endByte = c;
            this.Od = d === void 0 ? null : d;
            this.timescale = e === void 0 ? null : e;
            this.h = f === void 0 ? null : f;
            this.aesKey = g === void 0 ? null : g;
            this.g = this.mimeType = this.codecs = null;
            this.encrypted = h === void 0 ? !1 : h;
        }
        wj.prototype.Tc = function() {
            return this.startByte;
        };
        wj.prototype.Qc = function() {
            return this.endByte;
        };
        wj.prototype.He = function(a) {
            this.h = a;
        };
        wj.prototype.hc = function() {
            return this.h;
        };
        function xj(a, b) {
            return a === b ? !0 : a && b ? a.Tc() == b.Tc() && a.Qc() == b.Qc() && Sc(a.T().sort(), b.T().sort()) && Jb(a.hc(), b.hc()) : a == b;
        }
        S("shaka.media.InitSegmentReference", wj);
        wj.prototype.getEndByte = wj.prototype.Qc;
        wj.prototype.getStartByte = wj.prototype.Tc;
        function yj(a, b, c, d, e, f, g, h, k, l, m, n, q, r, t, w) {
            l = l === void 0 ? [] : l;
            r = r === void 0 ? zj : r;
            this.startTime = a;
            this.j = this.endTime = b;
            this.D = c;
            this.startByte = d;
            this.endByte = e;
            this.ia = f;
            this.timestampOffset = g;
            this.appendWindowStart = h;
            this.appendWindowEnd = k;
            this.g = l;
            this.tilesLayout = m === void 0 ? "" : m;
            this.C = n === void 0 ? null : n;
            this.h = q === void 0 ? null : q;
            this.status = r;
            this.preload = !1;
            this.l = !0;
            this.m = !1;
            this.aesKey = t === void 0 ? null : t;
            this.thumbnailSprite = null;
            this.i = -1;
            this.A = w === void 0 ? !1 : w;
            this.xe = this.nd = !1;
            a = u(this.g);
            for(b = a.next(); !b.done; b = a.next())b.value.mj();
            this.A && this.g.length && this.g[this.g.length - 1].lj();
            this.u = this.bandwidth = this.mimeType = this.codecs = null;
            this.F = !1;
        }
        p = yj.prototype;
        p.T = function() {
            return this.D();
        };
        p.getStartTime = function() {
            return this.startTime;
        };
        p.Nk = function() {
            return this.endTime;
        };
        p.Tc = function() {
            return this.startByte;
        };
        p.Qc = function() {
            return this.endByte;
        };
        p.ul = function() {
            return this.tilesLayout;
        };
        p.rl = function() {
            return this.C;
        };
        p.Uc = function() {
            return this.status;
        };
        p.Ql = function() {
            this.status = Aj;
        };
        p.Jh = function() {
            this.preload = !0;
        };
        p.isPreload = function() {
            return this.preload;
        };
        p.Nd = function() {
            this.l = !1;
        };
        p.Gl = function() {
            return this.l;
        };
        p.mj = function() {
            this.nd = !0;
        };
        p.Il = function() {
            return this.nd;
        };
        p.lj = function() {
            this.xe = !0;
        };
        p.Hl = function() {
            return this.xe;
        };
        p.kj = function() {
            this.m = !0;
        };
        p.Cl = function() {
            return this.m;
        };
        p.jg = function(a) {
            this.thumbnailSprite = a;
        };
        p.ql = function() {
            return this.thumbnailSprite;
        };
        p.offset = function(a) {
            this.startTime += a;
            this.endTime += a;
            this.j += a;
            for(var b = u(this.g), c = b.next(); !c.done; c = b.next())c = c.value, c.startTime += a, c.endTime += a, c.j += a;
        };
        p.pi = function(a) {
            this.h == null ? $a("Sync attempted without sync time!") : (a = this.h - a - this.startTime, Math.abs(a) >= .001 && this.offset(a));
        };
        p.He = function(a, b) {
            this.u = a;
            this.F = b === void 0 ? !1 : b;
        };
        p.hc = function(a) {
            var b = this.u;
            (a === void 0 || a) && this.F && (this.u = null);
            return b;
        };
        function Bj(a, b) {
            a.ia = b;
            a = u(a.g);
            for(var c = a.next(); !c.done; c = a.next())Bj(c.value, b);
        }
        S("shaka.media.SegmentReference", yj);
        yj.prototype.getSegmentData = yj.prototype.hc;
        yj.prototype.setSegmentData = yj.prototype.He;
        yj.prototype.syncAgainst = yj.prototype.pi;
        yj.prototype.offset = yj.prototype.offset;
        yj.prototype.getThumbnailSprite = yj.prototype.ql;
        yj.prototype.setThumbnailSprite = yj.prototype.jg;
        yj.prototype.hasByterangeOptimization = yj.prototype.Cl;
        yj.prototype.markAsByterangeOptimization = yj.prototype.kj;
        yj.prototype.isLastPartial = yj.prototype.Hl;
        yj.prototype.markAsLastPartial = yj.prototype.lj;
        yj.prototype.isPartial = yj.prototype.Il;
        yj.prototype.markAsPartial = yj.prototype.mj;
        yj.prototype.isIndependent = yj.prototype.Gl;
        yj.prototype.markAsNonIndependent = yj.prototype.Nd;
        yj.prototype.isPreload = yj.prototype.isPreload;
        yj.prototype.markAsPreload = yj.prototype.Jh;
        yj.prototype.markAsUnavailable = yj.prototype.Ql;
        yj.prototype.getStatus = yj.prototype.Uc;
        yj.prototype.getTileDuration = yj.prototype.rl;
        yj.prototype.getTilesLayout = yj.prototype.ul;
        yj.prototype.getEndByte = yj.prototype.Qc;
        yj.prototype.getStartByte = yj.prototype.Tc;
        yj.prototype.getEndTime = yj.prototype.Nk;
        yj.prototype.getStartTime = yj.prototype.getStartTime;
        yj.prototype.getUris = yj.prototype.T;
        var zj = 0, Aj = 1;
        yj.Status = {
            Hm: zj,
            Pn: Aj,
            nn: 2
        };
        function Cj(a) {
            return a.length == 1 && a.end(0) - a.start(0) < 1E-4;
        }
        function Dj(a) {
            return !a || Cj(a) ? null : a.length == 1 && a.start(0) < 0 ? 0 : a.length ? a.start(0) : null;
        }
        function Ej(a) {
            return !a || Cj(a) ? null : a.length ? a.end(a.length - 1) : null;
        }
        function Fj(a, b) {
            return !a || !a.length || Cj(a) || b > a.end(a.length - 1) ? !1 : b >= a.start(0);
        }
        function Gj(a, b) {
            if (!a || !a.length || Cj(a)) return 0;
            var c = 0;
            a = u(Hj(a));
            for(var d = a.next(); !d.done; d = a.next()){
                var e = d.value;
                d = e.start;
                e = e.end;
                e > b && (c += e - Math.max(d, b));
            }
            return c;
        }
        function Ij(a, b, c) {
            if (!a || !a.length || Cj(a)) return null;
            a = Hj(a).findIndex(function(d, e, f) {
                return d.start > b && (e == 0 || f[e - 1].end - b <= c);
            });
            return a >= 0 ? a : null;
        }
        function Hj(a) {
            if (!a) return [];
            for(var b = [], c = 0; c < a.length; c++)b.push({
                start: a.start(c),
                end: a.end(c)
            });
            return b;
        }
        function Jj() {}
        function V(a) {
            return document.createElement(a);
        }
        function Kj(a) {
            return document.createElementNS("http://www.w3.org/2000/svg", a);
        }
        function Lj() {
            var a = document.createElement("button");
            a.setAttribute("type", "button");
            return a;
        }
        function Mj(a, b) {
            var c = document.createElement("source");
            c.src = a;
            c.type = b === void 0 ? "" : b;
            return c;
        }
        function Nj(a) {
            for(var b = !1, c = a.getElementsByTagName("source"), d = c.length - 1; d >= 0; --d)a.removeChild(c[d]), b = !0;
            a.src && (a.removeAttribute("src"), b = !0);
            return b;
        }
        function Oj(a) {
            a = a.getElementsByClassName("shaka-overflow-quality-mark");
            return a.length ? a[0] : null;
        }
        function Pj(a) {
            for(; a.firstChild;)a.removeChild(a.firstChild);
        }
        function Gi() {
            if (Qj) return Qj;
            Rj || (Rj = new Bf(function() {
                Qj = null;
            }));
            (Qj = document.getElementsByTagName("video")[0] || document.getElementsByTagName("audio")[0]) || (Qj = document.createElement("video"));
            Rj.$(1);
            return Qj;
        }
        function Sj(a, b) {
            var c, d, e, f, g;
            return Q(function(h) {
                if (h.g == 1) return "fonts" in document && "FontFace" in window1 ? F(h, document.fonts.ready, 2) : h.return();
                if (!("entries" in document.fonts)) return h.return();
                c = function(k) {
                    k = k.entries();
                    for(var l = [], m = k.next(); m.done === !1;)l.push(m.value), m = k.next();
                    return l;
                };
                d = u(c(document.fonts));
                for(e = d.next(); !e.done; e = d.next())if (f = e.value, f.family === a && f.display === "swap") return h.return();
                g = new FontFace(a, "url(" + b + ")", {
                    display: "swap"
                });
                document.fonts.add(g);
                H(h);
            });
        }
        S("shaka.util.Dom", Jj);
        Jj.removeAllChildren = Pj;
        Jj.clearSourceFromVideo = Nj;
        var Rj = null, Qj = null; /*
 @license
 Shaka Player
 Copyright 2022 Google LLC
 SPDX-License-Identifier: Apache-2.0
*/ 
        function Tj() {}
        function Uj(a, b) {
            return b + 10 <= a.length && a[b] === 73 && a[b + 1] === 68 && a[b + 2] === 51 && a[b + 3] < 255 && a[b + 4] < 255 && a[b + 6] < 128 && a[b + 7] < 128 && a[b + 8] < 128 && a[b + 9] < 128 ? !0 : !1;
        }
        function Vj(a, b) {
            return b + 10 <= a.length && a[b] === 51 && a[b + 1] === 68 && a[b + 2] === 73 && a[b + 3] < 255 && a[b + 4] < 255 && a[b + 6] < 128 && a[b + 7] < 128 && a[b + 8] < 128 && a[b + 9] < 128 ? !0 : !1;
        }
        function Wj(a, b) {
            var c = (a[b] & 127) << 21;
            c |= (a[b + 1] & 127) << 14;
            c |= (a[b + 2] & 127) << 7;
            return c |= a[b + 3] & 127;
        }
        function Xj(a) {
            var b = {
                key: a.type,
                description: "",
                data: "",
                mimeType: null,
                pictureType: null
            };
            if (a.type === "APIC") {
                if (a.size < 2 || a.data[0] !== 3) return null;
                var c = a.data.subarray(1).indexOf(0);
                if (c === -1) return null;
                var d = Wb(Kb(a.data, 1, c)), e = a.data[2 + c], f = a.data.subarray(3 + c).indexOf(0);
                if (f === -1) return null;
                var g = Wb(Kb(a.data, 3 + c, f)), h;
                d === "--\x3e" ? h = Wb(Kb(a.data, 4 + c + f)) : h = Lb(a.data.subarray(4 + c + f));
                b.mimeType = d;
                b.pictureType = e;
                b.description = g;
                b.data = h;
                return b;
            }
            if (a.type === "TXXX") {
                if (a.size < 2 || a.data[0] !== 3) return null;
                d = a.data.subarray(1).indexOf(0);
                if (d === -1) return null;
                c = Wb(Kb(a.data, 1, d));
                a = Wb(Kb(a.data, 2 + d)).replace(/\0*$/, "");
                b.description = c;
                b.data = a;
                return b;
            }
            if (a.type === "WXXX") {
                if (a.size < 2 || a.data[0] !== 3) return null;
                d = a.data.subarray(1).indexOf(0);
                if (d === -1) return null;
                c = Wb(Kb(a.data, 1, d));
                a = Wb(Kb(a.data, 2 + d)).replace(/\0*$/, "");
                b.description = c;
                b.data = a;
                return b;
            }
            if (a.type === "PRIV") {
                if (a.size < 2) return null;
                c = a.data.indexOf(0);
                if (c === -1) return null;
                c = Wb(Kb(a.data, 0, c));
                b.description = c;
                c == "com.apple.streaming.transportStreamTimestamp" ? (c = a.data.subarray(c.length + 1), a = c[3] & 1, c = (c[4] << 23) + (c[5] << 15) + (c[6] << 7) + c[7], c /= 45, a && (c += 4.772185884E7), b.data = c) : (a = Lb(a.data.subarray(c.length + 1)), b.data = a);
                return b;
            }
            if (a.type[0] === "T") {
                if (a.size < 2 || a.data[0] !== 3) return null;
                a = Wb(a.data.subarray(1)).replace(/\0*$/, "");
                b.data = a;
                return b;
            }
            return a.type[0] === "W" ? (a = Wb(a.data).replace(/\0*$/, ""), b.data = a, b) : a.data ? (b.data = Lb(a.data), b) : null;
        }
        function Yj(a) {
            for(var b = 0, c = []; Uj(a, b);){
                var d = Wj(a, b + 6);
                a[b + 5] >> 6 & 1 && (b += 10);
                b += 10;
                for(d = b + d; b + 10 < d;){
                    var e = a.subarray(b), f = Wj(e, 4);
                    e = {
                        type: String.fromCharCode(e[0], e[1], e[2], e[3]),
                        size: f,
                        data: e.subarray(10, 10 + f)
                    };
                    (f = Xj(e)) && c.push(f);
                    b += e.size + 10;
                }
                Vj(a, b) && (b += 10);
            }
            return c;
        }
        function Zj(a, b) {
            for(var c = b = b === void 0 ? 0 : b, d = 0; Uj(a, b);)a[b + 5] >> 6 & 1 && (d += 10), d += 10, d += Wj(a, b + 6), Vj(a, b + 10) && (d += 10), b += d;
            return d > 0 ? a.subarray(c, c + d) : new Uint8Array([]);
        }
        S("shaka.util.Id3Utils", Tj);
        Tj.getID3Data = Zj;
        Tj.getID3Frames = Yj;
        function ak(a) {
            return new Date(Date.UTC(1900, 0, 1, 0, 0, 0, 0) + a).getTime();
        }
        function bk(a, b) {
            this.j = a;
            if (b === void 0 ? 0 : b) {
                b = new Uint8Array(a.byteLength);
                for(var c = 0, d = 0; d < a.byteLength; d++)d >= 2 && a[d] == 3 && a[d - 1] == 0 && a[d - 2] == 0 || (b[c] = a[d], c++);
                this.j = Kb(b, 0, c);
            }
            this.i = this.j.byteLength;
            this.g = this.h = 0;
        }
        function ck(a) {
            var b = a.j.byteLength - a.i, c = new Uint8Array(4), d = Math.min(4, a.i);
            d !== 0 && (c.set(a.j.subarray(b, b + d)), a.h = new lh(c, 0).Z(), a.g = d * 8, a.i -= d);
        }
        function dk(a, b) {
            if (a.g <= b) {
                b -= a.g;
                var c = Math.floor(b / 8);
                b -= c * 8;
                a.g -= c;
                ck(a);
            }
            a.h <<= b;
            a.g -= b;
        }
        function ek(a, b) {
            var c = Math.min(a.g, b), d = a.h >>> 32 - c;
            a.g -= c;
            a.g > 0 ? a.h <<= c : a.i > 0 && ck(a);
            c = b - c;
            return c > 0 ? d << c | ek(a, c) : d;
        }
        function fk(a) {
            var b;
            for(b = 0; b < a.g; ++b)if ((a.h & 2147483648 >>> b) !== 0) return a.h <<= b, a.g -= b, b;
            ck(a);
            return b + fk(a);
        }
        function gk(a) {
            dk(a, 1 + fk(a));
        }
        function hk(a) {
            var b = fk(a);
            return ek(a, b + 1) - 1;
        }
        function ik(a) {
            a = hk(a);
            return 1 & a ? 1 + a >>> 1 : -1 * (a >>> 1);
        }
        function jk(a) {
            return ek(a, 1) === 1;
        }
        function kk(a) {
            return ek(a, 8);
        }
        function lk(a, b) {
            for(var c = 8, d = 8, e = 0; e < b; e++)d !== 0 && (d = ik(a), d = (c + d + 256) % 256), c = d === 0 ? c : d;
        }
        function mk(a) {
            kk(a);
            hk(a);
            return hk(a);
        }
        S("shaka.util.ExpGolomb", bk);
        function nk() {
            this.I = null;
            this.J = !1;
            this.m = this.K = null;
            this.j = [];
            this.g = [];
            this.D = this.F = null;
            this.i = [];
            this.h = [];
            this.G = null;
            this.l = [];
            this.C = this.H = this.u = this.A = null;
        }
        p = nk.prototype;
        p.clearData = function() {
            this.j = [];
            this.g = [];
            this.i = [];
            this.h = [];
            this.l = [];
        };
        p.gg = function(a) {
            this.C != null && this.C != a && (this.u = this.A = null);
            this.C = a;
        };
        p.parse = function(a) {
            if (a.length < 564) return this;
            for(var b = Math.max(0, ok(a)), c = a.length - (a.length + b) % 188, d = !1, e = b; e < c; e += 188)if (a[e] == 71) {
                var f = !!(a[e + 1] & 64), g = ((a[e + 1] & 31) << 8) + a[e + 2];
                if ((a[e + 3] & 48) >> 4 > 1) {
                    var h = e + 5 + a[e + 4];
                    if (h == e + 188) continue;
                } else h = e + 4;
                switch(g){
                    case 0:
                        f && (h += a[h] + 1);
                        this.I = (a[h + 10] & 31) << 8 | a[h + 11];
                        break;
                    case 17:
                    case 8191:
                        break;
                    case this.I:
                        f && (h += a[h] + 1);
                        f = a;
                        g = {
                            audio: -1,
                            video: -1,
                            zf: -1,
                            audioCodec: "",
                            videoCodec: ""
                        };
                        var k = h + 3 + ((f[h + 1] & 15) << 8 | f[h + 2]) - 4;
                        for(h += 12 + ((f[h + 10] & 15) << 8 | f[h + 11]); h < k;){
                            var l = (f[h + 1] & 31) << 8 | f[h + 2], m = (f[h + 3] & 15) << 8 | f[h + 4];
                            switch(f[h]){
                                case 6:
                                    if (m > 0) for(var n = h + 5, q = m; q > 2;){
                                        var r = f[n + 1] + 2;
                                        switch(f[n]){
                                            case 5:
                                                var t = Yb(f.subarray(n + 2, n + r));
                                                g.audio == -1 && t === "Opus" ? (g.audio = l, g.audioCodec = "opus") : g.video == -1 && t === "AV01" && (g.video = l, g.videoCodec = "av1");
                                                break;
                                            case 106:
                                                g.audio == -1 && (g.audio = l, g.audioCodec = "ac3");
                                                break;
                                            case 122:
                                                g.audio == -1 && (g.audio = l, g.audioCodec = "ec3");
                                                break;
                                            case 124:
                                                g.audio == -1 && (g.audio = l, g.audioCodec = "aac");
                                                break;
                                            case 127:
                                                g.audioCodec == "opus" && (t = null, f[n + 2] === 128 && (t = f[n + 3]), t != null && (this.H = {
                                                    channelCount: (t & 15) === 0 ? 2 : t & 15,
                                                    pk: t,
                                                    sampleRate: 48E3
                                                }));
                                        }
                                        n += r;
                                        q -= r;
                                    }
                                    break;
                                case 15:
                                    g.audio == -1 && (g.audio = l, g.audioCodec = "aac");
                                    break;
                                case 17:
                                    g.audio == -1 && (g.audio = l, g.audioCodec = "aac-loas");
                                    break;
                                case 21:
                                    g.zf == -1 && (g.zf = l);
                                    break;
                                case 27:
                                    g.video == -1 && (g.video = l, g.videoCodec = "avc");
                                    break;
                                case 3:
                                case 4:
                                    g.audio == -1 && (g.audio = l, g.audioCodec = "mp3");
                                    break;
                                case 36:
                                    g.video == -1 && (g.video = l, g.videoCodec = "hvc");
                                    break;
                                case 129:
                                    g.audio == -1 && (g.audio = l, g.audioCodec = "ac3");
                                    break;
                                case 132:
                                case 135:
                                    g.audio == -1 && (g.audio = l, g.audioCodec = "ec3");
                            }
                            h += m + 5;
                        }
                        f = g;
                        f.video != -1 && (this.K = f.video, this.m = f.videoCodec);
                        f.audio != -1 && (this.F = f.audio, this.D = f.audioCodec);
                        f.zf != -1 && (this.G = f.zf);
                        d && !this.J && (d = !1, e = b - 188);
                        this.J = !0;
                        break;
                    case this.K:
                        h = a.subarray(h, e + 188);
                        f ? this.j.push([
                            h
                        ]) : this.j.length && this.j[this.j.length - 1] && this.j[this.j.length - 1].push(h);
                        break;
                    case this.F:
                        h = a.subarray(h, e + 188);
                        f ? this.i.push([
                            h
                        ]) : this.i.length && this.i[this.i.length - 1] && this.i[this.i.length - 1].push(h);
                        break;
                    case this.G:
                        h = a.subarray(h, e + 188);
                        f ? this.l.push([
                            h
                        ]) : this.l.length && this.l[this.l.length - 1] && this.l[this.l.length - 1].push(h);
                        break;
                    default:
                        d = !0;
                }
            }
            return this;
        };
        function pk(a, b) {
            if ((b[0] << 16 | b[1] << 8 | b[2]) !== 1) return null;
            var c = {
                data: new Uint8Array(0),
                packetLength: b[4] << 8 | b[5],
                pts: null,
                dts: null,
                nalus: []
            };
            if (c.packetLength && c.packetLength > b.byteLength - 6) return null;
            var d = b[7];
            if (d & 192) {
                var e = (b[9] & 14) * 536870912 + (b[10] & 255) * 4194304 + (b[11] & 254) * 16384 + (b[12] & 255) * 128 + (b[13] & 254) / 2;
                a.A == null && (a.A = e);
                c.pts = qk(e, a.A);
                a.A = c.pts;
                c.dts = c.pts;
                d & 64 && (d = (b[14] & 14) * 536870912 + (b[15] & 255) * 4194304 + (b[16] & 254) * 16384 + (b[17] & 255) * 128 + (b[18] & 254) / 2, a.u == null && (a.u = d), c.dts = c.pts != e ? qk(d, a.u) : d);
                a.u = c.dts;
            }
            a = b[8] + 9;
            if (b.byteLength <= a) return null;
            c.data = b.subarray(a);
            return c;
        }
        p.Xl = function(a) {
            Zc("TsParser.parseAvcNalus", "Please use parseNalus function instead.");
            return this.Ph(a, {
                Ae: null,
                state: null
            });
        };
        p.Ph = function(a, b) {
            var c = a.pts ? a.pts / 9E4 : null;
            a = a.data;
            var d = a.byteLength, e = 1;
            this.m == "hvc" && (e = 2);
            var f = b.state || 0, g = f, h = 0, k = [], l = -1, m = 0;
            f == -1 && (l = 0, m = this.m == "hvc" ? a[0] >> 1 & 63 : a[0] & 31, f = 0, h = 1);
            for(; h < d;){
                var n = a[h++];
                if (f) {
                    if (f === 1) f = n ? 0 : 2;
                    else if (n) {
                        if (n == 1) {
                            n = h - f - 1;
                            if (l >= 0) k.push({
                                data: a.subarray(l + e, n),
                                fullData: a.subarray(l, n),
                                type: m,
                                time: c,
                                state: null
                            });
                            else if (f = k.length ? k[k.length - 1] : b.Ae) g && h <= 4 - g && f.state && (f.data = f.data.subarray(0, f.data.byteLength - g), f.fullData = f.fullData.subarray(0, f.fullData.byteLength - g)), n > 0 && (n = a.subarray(0, n), f.data = lc(f.data, n), f.fullData = lc(f.fullData, n), f.state = 0);
                            h < d ? (m = this.m == "hvc" ? a[h] >> 1 & 63 : a[h] & 31, l = h, f = 0) : f = -1;
                        } else f = 0;
                    } else f = 3;
                } else f = n ? 0 : 1;
            }
            l >= 0 && f >= 0 && k.push({
                data: a.subarray(l + e, d),
                fullData: a.subarray(l, d),
                type: m,
                time: c,
                state: f
            });
            !k.length && b.Ae && (c = k.length ? k[k.length - 1] : b.Ae) && (c.data = lc(c.data, a), c.fullData = lc(c.fullData, a));
            b.state = f;
            return k;
        };
        p.getMetadata = function() {
            for(var a = [], b = u(this.l), c = b.next(); !c.done; c = b.next())c = lc.apply(dc, x(c.value)), (c = pk(this, c)) && a.push({
                cueTime: c.pts ? c.pts / 9E4 : null,
                data: c.data,
                frames: Yj(c.data),
                dts: c.dts,
                pts: c.pts
            });
            return a;
        };
        p.Db = function() {
            if (this.i.length && !this.h.length) for(var a = u(this.i), b = a.next(); !b.done; b = a.next()){
                var c = lc.apply(dc, x(b.value)), d = pk(this, c);
                b = this.h.length ? this.h[this.h.length - 1] : null;
                d && d.pts != null && d.dts != null && (!b || b.pts != d.pts && b.dts != d.dts) ? this.h.push(d) : this.h.length && (c = d ? d.data : c) && (b = this.h.pop(), b.data = lc(b.data, c), this.h.push(b));
            }
            return this.h;
        };
        p.Jd = function(a) {
            a = a === void 0 ? !0 : a;
            if (this.j.length && !this.g.length) {
                for(var b = u(this.j), c = b.next(); !c.done; c = b.next()){
                    var d = lc.apply(dc, x(c.value)), e = pk(this, d);
                    c = this.g.length ? this.g[this.g.length - 1] : null;
                    e && e.pts != null && e.dts != null && (!c || c.pts != e.pts && c.dts != e.dts) ? this.g.push(e) : this.g.length && (d = e ? e.data : d) && (c = this.g.pop(), c.data = lc(c.data, d), this.g.push(c));
                }
                if (a) {
                    b = {
                        Ae: null,
                        state: null
                    };
                    c = [];
                    d = u(this.g);
                    for(e = d.next(); !e.done; e = d.next())e = e.value, e.nalus = this.Ph(e, b), e.nalus.length && (c.push(e), b.Ae = e.nalus[e.nalus.length - 1]);
                    this.g = c;
                }
            }
            return a ? this.g : (a = this.g, this.g = [], a);
        };
        p.getStartTime = function(a) {
            if (a == "audio") {
                a = null;
                var b = this.Db();
                b.length && (a = b[0], a = Math.min(a.dts, a.pts) / 9E4);
                return a;
            }
            return a == "video" ? (a = null, b = this.Jd(!1), b.length && (a = b[0], a = Math.min(a.dts, a.pts) / 9E4), a) : null;
        };
        p.le = function() {
            return {
                audio: this.D,
                video: this.m
            };
        };
        p.yf = function() {
            for(var a = [], b = u(this.Jd()), c = b.next(); !c.done; c = b.next())a.push.apply(a, x(c.value.nalus));
            return a;
        };
        p.zl = function() {
            Zc("TsParser.getVideoResolution", "Please use getVideoInfo function instead.");
            var a = this.xh();
            return {
                height: a.height,
                width: a.width
            };
        };
        p.xh = function() {
            return this.m == "hvc" ? rk(this) : sk(this);
        };
        function tk(a) {
            var b = a.Jd();
            return b.length > 1 && (a = b[0].pts, b = b[1].pts, !isNaN(b - a)) ? String(1 / (b - a) * 9E4) : null;
        }
        function sk(a) {
            var b = {
                height: null,
                width: null,
                codec: null,
                frameRate: null
            }, c = a.yf();
            if (!c.length) return b;
            c = c.find(function(r) {
                return r.type == 7;
            });
            if (!c) return b;
            c = new bk(c.data);
            var d = kk(c), e = kk(c), f = kk(c);
            gk(c);
            if (uk.includes(d)) {
                var g = hk(c);
                g === 3 && dk(c, 1);
                gk(c);
                gk(c);
                dk(c, 1);
                if (jk(c)) {
                    g = g !== 3 ? 8 : 12;
                    for(var h = 0; h < g; h++)jk(c) && (h < 6 ? lk(c, 16) : lk(c, 64));
                }
            }
            gk(c);
            g = hk(c);
            if (g === 0) hk(c);
            else if (g === 1) for(dk(c, 1), gk(c), gk(c), g = hk(c), h = 0; h < g; h++)gk(c);
            gk(c);
            dk(c, 1);
            g = hk(c);
            h = hk(c);
            var k = ek(c, 1);
            k === 0 && dk(c, 1);
            dk(c, 1);
            var l = 0, m = 0, n = 0, q = 0;
            jk(c) && (l = hk(c), m = hk(c), n = hk(c), q = hk(c));
            b.height = String((2 - k) * (h + 1) * 16 - n * 2 - q * 2);
            b.width = String((g + 1) * 16 - l * 2 - m * 2);
            b.codec = "avc1." + ("0" + d.toString(16).toUpperCase()).slice(-2) + ("0" + e.toString(16).toUpperCase()).slice(-2) + ("0" + f.toString(16).toUpperCase()).slice(-2);
            b.frameRate = tk(a);
            return b;
        }
        function rk(a) {
            var b = {
                height: null,
                width: null,
                codec: null,
                frameRate: null
            }, c = a.yf();
            if (!c.length) return b;
            c = c.find(function(E) {
                return E.type == 33;
            });
            if (!c) return b;
            var d = new bk(c.fullData, !0);
            kk(d);
            kk(d);
            ek(d, 4);
            var e = ek(d, 3);
            jk(d);
            var f = ek(d, 2), g = ek(d, 1), h = ek(d, 5), k = ek(d, 32);
            c = kk(d);
            for(var l = kk(d), m = kk(d), n = kk(d), q = kk(d), r = kk(d), t = kk(d), w = [], v = [], z = 0; z < e; z++)w.push(jk(d)), v.push(jk(d));
            if (e > 0) for(z = e; z < 8; z++)ek(d, 2);
            for(z = 0; z < e; z++)w[z] && ek(d, 88), v[z] && kk(d);
            hk(d);
            e = hk(d);
            e == 3 && ek(d, 1);
            w = hk(d);
            v = hk(d);
            var y = z = 0, A = 0, C = 0;
            jk(d) && (z += hk(d), y += hk(d), A += hk(d), C += hk(d));
            b.width = String(w - (z + y) * (e === 1 || e === 2 ? 2 : 1));
            b.height = String(v - (A + C) * (e === 1 ? 2 : 1));
            d = function(E) {
                for(var D = 0, B = 0; B < 32; B++)D |= (E >> B & 1) << 31 - B;
                return D >>> 0;
            }(k);
            g = g == 1 ? "H" : "L";
            f = "hvc1" + ("." + [
                "",
                "A",
                "B",
                "C"
            ][f] + h);
            f += "." + d.toString(16).toUpperCase();
            f += "." + g + t;
            r && (f += "." + r.toString(16).toUpperCase());
            q && (f += "." + q.toString(16).toUpperCase());
            n && (f += "." + n.toString(16).toUpperCase());
            m && (f += "." + m.toString(16).toUpperCase());
            l && (f += "." + l.toString(16).toUpperCase());
            c && (f += "." + c.toString(16).toUpperCase());
            b.codec = f;
            b.frameRate = tk(a);
            return b;
        }
        function qk(a, b) {
            var c = 1;
            for(a > b && (c = -1); Math.abs(b - a) > 4294967296;)a += c * 8589934592;
            return a;
        }
        function vk(a) {
            return ok(a) < 0 ? !1 : !0;
        }
        function ok(a) {
            for(var b = Math.min(1E3, a.length - 564), c = 0; c < b;){
                if (a[c] == 71 && a[c + 188] == 71 && a[c + 376] == 71) return c;
                c++;
            }
            return -1;
        }
        S("shaka.util.TsParser", nk);
        nk.syncOffset = ok;
        nk.probe = vk;
        nk.prototype.getVideoInfo = nk.prototype.xh;
        nk.prototype.getVideoResolution = nk.prototype.zl;
        nk.prototype.getVideoNalus = nk.prototype.yf;
        nk.prototype.getCodecs = nk.prototype.le;
        nk.prototype.getStartTime = nk.prototype.getStartTime;
        nk.prototype.getVideoData = nk.prototype.Jd;
        nk.prototype.getAudioData = nk.prototype.Db;
        nk.prototype.getMetadata = nk.prototype.getMetadata;
        nk.prototype.parseNalus = nk.prototype.Ph;
        nk.prototype.parseAvcNalus = nk.prototype.Xl;
        nk.prototype.parse = nk.prototype.parse;
        nk.prototype.setDiscontinuitySequence = nk.prototype.gg;
        nk.prototype.clearData = nk.prototype.clearData;
        nk.Timescale = 9E4;
        var uk = [
            100,
            110,
            122,
            244,
            44,
            83,
            86,
            118,
            128,
            138,
            139,
            134
        ];
        function wk(a, b, c, d, e) {
            var f = this;
            this.g = a;
            this.O = c;
            this.C = d;
            this.Y = b;
            this.l = new Map;
            this.F = new Map;
            this.Ma = new Map;
            this.h = null;
            this.Fa = !1;
            this.H = e || null;
            this.u = new Map;
            this.A = new Tc;
            this.j = new Map;
            this.K = null;
            this.L = new Lg;
            this.xa = "";
            this.jb = !1;
            this.sa = !0;
            this.M = !1;
            this.D = this.P = null;
            this.i = xk(this, this.L);
            this.hb = this.G = !1;
            this.J = new hh(function() {
                return yk(f);
            });
            this.I = !1;
            this.V = "UNKNOWN";
            this.fb = this.ib = !1;
            this.Oa = new Lg;
            this.m = !1;
            this.ra = null;
            this.X = new Map;
            this.ea = this.R = this.oa = this.S = null;
            this.aa = new Lg;
            this.g.remote && (this.M = this.g.remote.state != "disconnected", this.A.o(this.g.remote, "connect", function() {
                f.M = f.g.remote.state != "disconnected";
            }), this.A.o(this.g.remote, "connecting", function() {
                f.M = f.g.remote.state != "disconnected";
            }), this.A.o(this.g.remote, "disconnect", function() {
                f.M = f.g.remote.state != "disconnected";
            }));
        }
        function xk(a, b) {
            a.sa = !0;
            if (window1.ManagedMediaSource) {
                a.D || (a.g.disableRemotePlayback = !0);
                var c = new ManagedMediaSource;
                a.A.o(c, "startstreaming", function() {
                    a.sa = !0;
                });
                a.A.o(c, "endstreaming", function() {
                    a.sa = !1;
                });
            } else c = new MediaSource;
            a.A.ua(c, "sourceopen", function() {
                URL.revokeObjectURL(a.xa);
                b.resolve();
            });
            a.A.ua(a.g, "playing", function() {
                a.jb = !0;
            });
            a.xa = zk(c);
            a.C.useSourceElements ? (a.g.removeAttribute("src"), a.P && a.g.removeChild(a.P), a.D && a.g.removeChild(a.D), a.P = Mj(a.xa), a.g.appendChild(a.P), a.D && a.g.appendChild(a.D), a.g.load()) : a.g.src = a.xa;
            return c;
        }
        function Ak(a, b, c) {
            a.g && window1.ManagedMediaSource && a.i && a.C.useSourceElements && (a.D && a.g.removeChild(a.D), a.D = Mj(b, c), a.g.appendChild(a.D), a.g.disableRemotePlayback = !1);
        }
        function Bk() {
            var a = 'video/mp4; codecs="avc1.42E01E",video/mp4; codecs="avc3.42E01E",video/mp4; codecs="hev1.1.6.L93.90",video/mp4; codecs="hvc1.1.6.L93.90",video/mp4; codecs="hev1.2.4.L153.B0"; eotf="smpte2084",video/mp4; codecs="hvc1.2.4.L153.B0"; eotf="smpte2084",video/mp4; codecs="hvc1.2.20000000.L153.B0",video/mp4; codecs="hvc1.2.4.L120.b0",video/mp4; codecs="hvc1.2.4.L123.b0",video/mp4; codecs="vp9",video/mp4; codecs="vp09.00.10.08",video/mp4; codecs="av01.0.01M.08",video/mp4; codecs="dvh1.05.01",video/mp4; codecs="dvh1.08.01",video/mp4; codecs="dav1.10.01",video/mp4; codecs="dvh1.20.01",audio/mp4; codecs="mp4a.40.2",audio/mp4; codecs="ac-3",audio/mp4; codecs="ec-3",audio/mp4; codecs="ac-4.02.01.01",audio/mp4; codecs="opus",audio/mp4; codecs="flac",audio/mp4; codecs="dtsc",audio/mp4; codecs="dtse",audio/mp4; codecs="dtsx",audio/mp4; codecs="apac.31.00",video/webm; codecs="vp8",video/webm; codecs="vp9",video/webm; codecs="vp09.00.10.08",audio/webm; codecs="vorbis",audio/webm; codecs="opus",video/mp2t; codecs="avc1.42E01E",video/mp2t; codecs="avc3.42E01E",video/mp2t; codecs="hvc1.1.6.L93.90",video/mp2t; codecs="mp4a.40.2",video/mp2t; codecs="ac-3",video/mp2t; codecs="ec-3",text/vtt,application/mp4; codecs="wvtt",application/ttml+xml,application/mp4; codecs="stpp"'.split(",").concat(x(ef)), b = {};
            Rb();
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next()){
                c = c.value;
                if (tf(c)) b[c] = !0;
                else if (Fi()) {
                    var d = mf(c), e = Xf(nf(c), d);
                    d = df(d, e);
                    b[c] = gd(d) || (Ye(d) ? !0 : !1);
                } else b[c] = Gi().canPlayType(c) != "";
                d = c.split(";")[0];
                b[d] = b[d] || b[c];
            }
            return b;
        }
        p = wk.prototype;
        p.destroy = function() {
            return this.J.destroy();
        };
        function yk(a) {
            var b, c, d, e, f, g, h, k, l, m, n, q, r, t, w;
            return Q(function(v) {
                if (v.g == 1) {
                    b = [];
                    c = u(a.u);
                    for(d = c.next(); !d.done; d = c.next())for(e = d.value, f = u(e), g = f.next().value, h = f.next().value, k = h[0], l = g, a.u.set(l, h.slice(0, 1)), k && b.push(k.p.catch(Df)), m = u(h.slice(1)), n = m.next(); !n.done; n = m.next())q = n.value, q.p.reject(new U(2, 7, 7003, void 0));
                    a.h && b.push(a.h.destroy());
                    return F(v, Promise.all(b), 2);
                }
                r = u(a.j.values());
                for(t = r.next(); !t.done; t = r.next())w = t.value, w.destroy();
                a.A && (a.A.release(), a.A = null);
                a.g && a.D && a.g.removeChild(a.D);
                a.g && a.P && (a.g.removeChild(a.P), a.g.load(), a.g.disableRemotePlayback = !1);
                a.g = null;
                a.P = null;
                a.D = null;
                a.C = null;
                a.i = null;
                a.h = null;
                a.Y = null;
                a.l.clear();
                a.Ma.clear();
                a.j.clear();
                a.K = null;
                a.u.clear();
                a.H = null;
                a.X.clear();
                a.O = null;
                H(v);
            });
        }
        p.init = function(a, b, c, d) {
            b = b === void 0 ? !1 : b;
            c = c === void 0 ? "UNKNOWN" : c;
            d = d === void 0 ? !1 : d;
            var e = this, f, g, h, k, l, m;
            return Q(function(n) {
                if (n.g == 1) return f = uc, F(n, e.L, 2);
                if (n.g != 3) {
                    if (!Ck(e) && !Dk(e)) return n.B(3);
                    $a("Expected MediaSource to be open during init(); reopening the media source.");
                    e.L = new Lg;
                    e.i = xk(e, e.L);
                    return F(n, e.L, 3);
                }
                e.I = b;
                e.V = c;
                e.ib = d;
                e.fb = !e.I && e.V == "HLS" && !e.ib;
                e.X.clear();
                e.S = null;
                e.oa = null;
                e.R = null;
                e.ea = null;
                e.aa = new Lg;
                g = u(a.keys());
                for(h = g.next(); !h.done; h = g.next())k = h.value, l = a.get(k), Ek(e, k, l, l.codecs), e.m ? (e.u.set(f.na, []), e.u.set(f.Ia, [])) : e.u.set(k, []);
                (m = a.get(f.na)) && m.isAudioMuxedInVideo && (e.m = !0);
                H(n);
            });
        };
        function Ek(a, b, c, d) {
            b == "audio" && d && (d = Xf(d, c.mimeType));
            var e = df(c.mimeType, d);
            if (b == sc) Fk(a, e, a.I, c.external);
            else {
                var f = a.C.forceTransmux;
                if (!gd(e) || !a.I && ef.includes(e)) f = !0;
                var g = ff(c.mimeType, d);
                if (f) {
                    f = qc("audio", (d || "").split(","));
                    d = qc("video", (d || "").split(","));
                    if (f && d) {
                        a.m = !0;
                        Ek(a, "audio", c, f);
                        Ek(a, "video", c, d);
                        return;
                    }
                    if (d = Ye(g)) e = d(), a.j.set(b, e), e = e.convertCodecs(b, g);
                }
                g = e + a.C.addExtraFeaturesToSourceBuffer(e);
                ih(a.J);
                try {
                    var h = a.i.addSourceBuffer(g);
                } catch (k) {
                    throw new U(2, 3, 3015, k, "The mediaSource_ status was " + a.i.readyState + " expected 'open'", null);
                }
                a.I && (h.mode = Gk);
                a.A.o(h, "error", function() {
                    var k = a.u.get(b)[0];
                    k.p.reject(new U(2, 3, 3014, a.g.error ? a.g.error.code : 0, k.uri));
                });
                a.A.o(h, "updateend", function() {
                    return Hk(a, b);
                });
                a.l.set(b, h);
                a.F.set(b, e);
                a.Ma.set(b, !!c.drmInfos.length);
            }
        }
        p.configure = function(a) {
            this.C = a;
            this.h && (this.h.C = a.modifyCueCallback);
        };
        function Jk(a) {
            return a.sa && !a.M && !a.G;
        }
        function Fk(a, b, c, d) {
            a.h || (a.h = new pf(a.Y), a.h && (a.h.C = a.C.modifyCueCallback));
            var e = a.h;
            d = d || a.Fa;
            a = a.V;
            b == "application/cea-608" || b == "application/cea-708" ? e.i = null : (e.i = rf.get(b)(), e.i.setSequenceMode ? e.i.setSequenceMode(c) : Zc("Text parsers w/ setSequenceMode", 'Text parsers should have a "setSequenceMode" method!'), e.i.setManifestType ? e.i.setManifestType(a) : Zc("Text parsers w/ setManifestType", 'Text parsers should have a "setManifestType" method!'), e.D = d);
        }
        function Ck(a) {
            return a.G ? !1 : a.i ? a.i.readyState == "ended" : !0;
        }
        function Dk(a) {
            return a.G ? !1 : a.i ? a.i.readyState == "closed" : !0;
        }
        function Kk(a, b) {
            return a.l.size ? b == sc ? a.h.g : Dj(Lk(a, b)) : null;
        }
        function Mk(a, b) {
            return a.l.size ? b == sc ? a.h.h : Ej(Lk(a, b)) : null;
        }
        function Nk(a, b, c) {
            if (b == sc) return a = a.h, a.h == null || a.h < c ? 0 : a.h - Math.max(c, a.g);
            a = Lk(a, b);
            return Gj(a, c);
        }
        p.Pc = function() {
            var a = {
                total: this.G ? [] : Hj(this.g.buffered),
                audio: Hj(Lk(this, "audio")),
                video: Hj(Lk(this, "video")),
                text: []
            };
            if (this.h) {
                var b = this.h.g, c = this.h.h;
                b != null && c != null && a.text.push({
                    start: b,
                    end: c
                });
            }
            return a;
        };
        function Lk(a, b) {
            if (a.G || a.M) return null;
            try {
                return a.l.get(b).buffered;
            } catch (c) {
                return a.l.has(b), null;
            }
        }
        function Ok(a, b, c, d, e, f) {
            var g = null, h = [], k = Kb(c);
            if (ef.includes(f)) b = Yj(k), b.length && d && ((c = b.find(function(r) {
                return r.description === "com.apple.streaming.transportStreamTimestamp";
            })) && typeof c.data == "number" && (g = Math.round(c.data) / 1E3), a.O.onMetadata([
                {
                    cueTime: d.startTime,
                    data: k,
                    frames: b,
                    dts: d.startTime,
                    pts: d.startTime
                }
            ], 0, d.endTime));
            else if (f.includes("/mp4") && d && d.ia && d.ia.timescale) {
                var l = d.ia.timescale;
                if (!isNaN(l)) {
                    var m = e.emsgSchemeIdUris != null && e.emsgSchemeIdUris.length > 0 || a.C.dispatchAllEmsgBoxes, n = 0, q = !1;
                    k = new oh;
                    m && k.W("emsg", function(r) {
                        var t = e.emsgSchemeIdUris;
                        if (r.version === 0) {
                            var w = r.reader.od();
                            var v = r.reader.od();
                            var z = r.reader.Z();
                            var y = r.reader.Z();
                            var A = r.reader.Z();
                            var C = r.reader.Z();
                            var E = d.startTime + y / z;
                        } else z = r.reader.Z(), E = r.reader.Td() / z + d.timestampOffset, y = E - d.startTime, A = r.reader.Z(), C = r.reader.Z(), w = r.reader.od(), v = r.reader.od();
                        r = r.reader.ac(r.reader.getLength() - r.reader.Wa());
                        if (t && t.includes(w) || a.C.dispatchAllEmsgBoxes) {
                            if (w == "urn:mpeg:dash:event:2012") a.O.Wl();
                            else if (t = new Uint8Array(r.byteLength), t.set(r), r = E + A / z, a.O.Ul({
                                startTime: E,
                                endTime: r,
                                schemeIdUri: w,
                                value: v,
                                timescale: z,
                                presentationTimeDelta: y,
                                eventDuration: A,
                                id: C,
                                messageData: t
                            }), w == "https://aomedia.org/emsg/ID3" || w == "https://developer.apple.com/streaming/emsg-id3") {
                                if (z = Yj(t), z.length) a.O.onMetadata([
                                    {
                                        cueTime: E,
                                        data: t,
                                        frames: z,
                                        dts: E,
                                        pts: E
                                    }
                                ], 0, r);
                            }
                        }
                    });
                    k.W("prft", function(r) {
                        var t = r.reader, w = r.version;
                        t.Z();
                        r = t.Z();
                        var v = t.Z();
                        r = r * 1E3 + v / 4294967296 * 1E3;
                        w === 0 ? t = t.Z() : (w = t.Z(), t = t.Z(), t = w * 4294967296 + t);
                        r = ak(r);
                        t = (new Map).set("detail", {
                            wallClockTime: r,
                            programStartDate: new Date(r - t / l * 1E3)
                        });
                        t = new T("prft", t);
                        a.O.onEvent(t);
                    }).box("moof", th).box("traf", th).W("tfdt", function(r) {
                        q || (n = Ji(r.reader, r.version).baseMediaDecodeTime / l, q = !0, m || r.parser.stop());
                    }).parse(c, !0);
                    q && d.timestampOffset == 0 && (g = n);
                }
            } else f.includes("/mp4") || f.includes("/webm") || !vk(k) || (a.X.has(b) || a.X.set(b, new nk), h = a.X.get(b), h.clearData(), h.gg(d.i), h.parse(k), k = h.getStartTime(b), k != null && (g = k), h = h.getMetadata());
            return {
                timestamp: g,
                metadata: h
            };
        }
        function Pk(a, b, c, d, e, f, g, h, k, l, m) {
            g = g === void 0 ? !1 : g;
            h = h === void 0 ? !1 : h;
            k = k === void 0 ? !1 : k;
            l = l === void 0 ? !1 : l;
            var n, q, r, t, w, v, z, y, A, C, E, D, B, G, I, J, L, K, N, P, O;
            return Q(function(M) {
                switch(M.g){
                    case 1:
                        n = uc;
                        if (b != n.Va) {
                            M.B(2);
                            break;
                        }
                        if (a.V != "HLS") {
                            M.B(3);
                            break;
                        }
                        return F(M, a.Oa, 4);
                    case 4:
                        q = M.h, a.h.A = q;
                    case 3:
                        return F(M, uf(a.h, c, d ? d.startTime : null, d ? d.endTime : null, d ? d.T()[0] : null), 5);
                    case 5:
                        return M.return();
                    case 2:
                        if (l || !a.m) {
                            M.B(6);
                            break;
                        }
                        return F(M, Pk(a, n.na, c, d, e, f, g, h, k, !0), 7);
                    case 7:
                        return F(M, Pk(a, n.Ia, c, d, e, f, g, h, k, !0), 8);
                    case 8:
                        return M.return();
                    case 6:
                        if (!a.l.has(b)) return M.return();
                        r = a.l.get(b).timestampOffset;
                        t = a.F.get(b);
                        a.j.has(b) && (t = a.j.get(b).getOriginalMimeType());
                        if (d && (w = Ok(a, b, c, d, e, t), v = w.timestamp, z = w.metadata, v != null && (a.S == null && b == n.Ia && (a.S = v, a.oa = d.startTime, a.R != null && (y = 0, a.oa == a.ea && (y = a.S - a.R), a.aa.resolve(y))), a.R == null && b == n.na && (a.R = v, a.ea = d.startTime, a.S != null && (A = 0, a.oa == a.ea && (A = a.S - a.R), a.aa.resolve(A))), C = v, E = ef, !a.I && E.includes(a.F.get(b)) && (C = 0), D = d.startTime - C, B = Math.abs(r - D), (B >= .001 || g || h) && (!k || D > 0 || !r) && (r = D, a.fb && (Qk(a, b, function() {
                            return Rk(a, b);
                        }, null), Qk(a, b, function() {
                            return Sk(a, b, r);
                        }, null))), (G = b == n.Ia || !a.l.has(n.Ia)) && a.Oa.resolve(r)), z.length)) a.O.onMetadata(z, r, d ? d.endTime : null);
                        f && b == n.Ia && (a.h || Fk(a, "application/cea-608", a.I, !1), a.K || (I = t.split(";", 1)[0], a.K = new od(I)), d ? (J = a.K.Uf(c), J.length && zf(a.h, J, d.startTime, d.endTime, r)) : a.K.init(c, h, m));
                        if (!a.j.has(b)) {
                            M.B(9);
                            break;
                        }
                        return F(M, a.j.get(b).transmux(c, e, d, a.i.duration, b), 10);
                    case 10:
                        L = M.h, ArrayBuffer.isView(L) ? c = L : (K = L, K.init != null && (N = K.init, Qk(a, b, function() {
                            a.H && dd(a.H, N, r, e);
                            a.l.get(b).appendBuffer(N);
                        }, d ? d.T()[0] : null)), c = K.data);
                    case 9:
                        c = Tk(a, e, c, d, b);
                        if (!d || !a.I || b == n.Va) {
                            M.B(11);
                            break;
                        }
                        if (!g && !h) {
                            M.B(11);
                            break;
                        }
                        P = d.startTime;
                        if (a.V != "HLS" || a.m || b != n.na || !a.l.has(n.Ia)) {
                            M.B(13);
                            break;
                        }
                        return F(M, a.aa, 14);
                    case 14:
                        O = M.h, Math.abs(O) > .15 && (P -= O);
                    case 13:
                        Qk(a, b, function() {
                            return Rk(a, b);
                        }, null), Qk(a, b, function() {
                            return Sk(a, b, P);
                        }, null);
                    case 11:
                        return F(M, Qk(a, b, function() {
                            var R = c;
                            a.H && dd(a.H, R, r, e);
                            a.l.get(b).appendBuffer(R);
                        }, d ? d.T()[0] : null), 15);
                    case 15:
                        H(M);
                }
            });
        }
        function Uk(a, b) {
            var c = Mk(a, "video") || 0;
            wf(a.h, b, c);
        }
        function Vk(a) {
            a.h && wf(a.h, "", 0);
        }
        p.remove = function(a, b, c, d) {
            var e = this, f;
            return Q(function(g) {
                return g.g == 1 ? (f = uc, a == f.Ia && e.K && e.K.remove(d), a == f.Va ? F(g, e.h.remove(b, c), 0) : c > b ? F(g, Qk(e, a, function() {
                    return Wk(e, a, b, c);
                }, null), 5) : g.B(0)) : e.m ? F(g, Qk(e, f.na, function() {
                    return Wk(e, f.na, b, c);
                }, null), 0) : g.B(0);
            });
        };
        function Xk(a, b) {
            var c;
            return Q(function(d) {
                return d.g == 1 ? (c = uc, b == c.Va ? a.h ? F(d, a.h.remove(0, Infinity), 0) : d.return() : F(d, Qk(a, b, function() {
                    return Wk(a, b, 0, a.i.duration);
                }, null), 4)) : a.m ? F(d, Qk(a, c.na, function() {
                    return Wk(a, c.na, 0, a.i.duration);
                }, null), 0) : d.B(0);
            });
        }
        p.flush = function(a) {
            var b = this, c;
            return Q(function(d) {
                return d.g == 1 ? (c = uc, a == c.Va ? d.return() : F(d, Qk(b, a, function() {
                    b.g.currentTime -= .001;
                    Hk(b, a);
                }, null), 2)) : b.m ? F(d, Qk(b, c.na, function() {
                    var e = c.na;
                    b.g.currentTime -= .001;
                    Hk(b, e);
                }, null), 0) : d.B(0);
            });
        };
        function Yk(a, b, c, d, e, f, g, h, k) {
            var l, m, n;
            return Q(function(q) {
                if (q.g == 1) {
                    l = uc;
                    if (b == l.Va) return f || (a.h.A = c), vf(a.h, d, e), q.return();
                    m = [];
                    return F(q, Zk(a, b, g, h, k), 2);
                }
                n = q.h;
                n || (m.push(Qk(a, b, function() {
                    return Rk(a, b);
                }, null)), a.m && m.push(Qk(a, l.na, function() {
                    return Rk(a, l.na);
                }, null)));
                f || (m.push(Qk(a, b, function() {
                    return Sk(a, b, c);
                }, null)), a.m && m.push(Qk(a, l.na, function() {
                    return Sk(a, l.na, c);
                }, null)));
                if (d != 0 || e != Infinity) m.push(Qk(a, b, function() {
                    return $k(a, b, d, e);
                }, null)), a.m && m.push(Qk(a, l.na, function() {
                    return $k(a, l.na, d, e);
                }, null));
                return m.length ? F(q, Promise.all(m), 0) : q.B(0);
            });
        }
        function al(a, b, c) {
            var d, e;
            return Q(function(f) {
                if (f.g == 1) {
                    d = uc;
                    if (b == d.Va) return f.return();
                    b == d.Ia && (a.Oa = new Lg);
                    if (!a.I || (e = Mk(a, b)) && Math.abs(e - c) < .15) return f.return();
                    Qk(a, b, function() {
                        return Rk(a, b);
                    }, null);
                    a.m && Qk(a, d.na, function() {
                        return Rk(a, d.na);
                    }, null);
                    return F(f, Qk(a, b, function() {
                        return Sk(a, b, c);
                    }, null), 2);
                }
                return a.m ? F(f, Qk(a, d.na, function() {
                    return Sk(a, d.na, c);
                }, null), 0) : f.B(0);
            });
        }
        p.endOfStream = function(a) {
            var b = this;
            return Q(function(c) {
                return F(c, bl(b, function() {
                    Ck(b) || Dk(b) || (a ? b.i.endOfStream(a) : b.i.endOfStream());
                }), 0);
            });
        };
        p.zb = function(a) {
            var b = this;
            return Q(function(c) {
                return F(c, bl(b, function() {
                    if (b.C.durationReductionEmitsUpdateEnd && a < b.i.duration) for(var d = u(b.l.keys()), e = d.next(); !e.done; e = d.next()){
                        e = e.value;
                        var f = {
                            start: function() {},
                            p: new Lg,
                            uri: null
                        };
                        b.u.get(e).unshift(f);
                    }
                    b.i.duration = a;
                    b.ra = a;
                }), 0);
            });
        };
        p.getDuration = function() {
            return this.i.duration;
        };
        function cl(a, b, c) {
            Q(function(d) {
                return a.J.g || a.g.error || a.M || a.G || Ck(a) || Dk(a) ? d.return() : F(d, bl(a, function() {
                    Ck(a) || Dk(a) || a.i.setLiveSeekableRange(b, c);
                }), 0);
            });
        }
        function dl(a) {
            Q(function(b) {
                return a.J.g || a.g.error || a.M || a.G || Ck(a) || Dk(a) ? b.return() : F(b, bl(a, function() {
                    Ck(a) || Dk(a) || a.i.clearLiveSeekableRange();
                }), 0);
            });
        }
        function Wk(a, b, c, d) {
            d <= c ? Hk(a, b) : a.l.get(b).remove(c, d);
        }
        function Rk(a, b) {
            var c = a.l.get(b), d = c.appendWindowStart, e = c.appendWindowEnd;
            c.abort();
            c.appendWindowStart = d;
            c.appendWindowEnd = e;
            Hk(a, b);
        }
        function Sk(a, b, c) {
            c < 0 && (c += .001);
            a.l.get(b).timestampOffset = c;
            Hk(a, b);
        }
        function $k(a, b, c, d) {
            var e = a.l.get(b);
            if (e.appendWindowEnd !== d || e.appendWindowStart !== c) e.appendWindowStart = 0, e.appendWindowEnd = d, e.appendWindowStart = c;
            Hk(a, b);
        }
        function Hk(a, b) {
            if (a.G || a.J.g) {
                var c = a.u.get(b);
                c && c.length && ((c = c[0]) && c.p && c.p.resolve(), a.u.set(b, []));
            } else if (c = a.u.get(b)[0]) c.p.resolve(), el(a, b);
        }
        function Qk(a, b, c, d) {
            ih(a.J);
            c = {
                start: c,
                p: new Lg,
                uri: d
            };
            a.u.get(b).push(c);
            a.u.get(b).length == 1 && fl(a, b);
            return c.p;
        }
        function bl(a, b) {
            var c, d, e, f, g, h, k, l, m, n, q, r, t;
            return Q(function(w) {
                switch(w.g){
                    case 1:
                        ih(a.J);
                        c = [];
                        d = Array.from(a.l.keys());
                        e = u(d);
                        f = e.next();
                        for(g = {}; !f.done; g = {
                            ready: void 0
                        }, f = e.next())h = f.value, g.ready = new Lg, k = {
                            start: function(v) {
                                return function() {
                                    return v.ready.resolve();
                                };
                            }(g),
                            p: g.ready,
                            uri: null
                        }, l = a.u.get(h), l.push(k), c.push(g.ready), l.length == 1 && k.start();
                        ra(w, 2);
                        return F(w, Promise.all(c), 4);
                    case 4:
                        ta(w, 3);
                        break;
                    case 2:
                        throw m = ua(w), m;
                    case 3:
                        return ra(w, 5, 6), F(w, b(), 6);
                    case 6:
                        va(w);
                        n = u(d);
                        for(q = n.next(); !q.done; q = n.next())r = q.value, el(a, r);
                        xa(w, 0);
                        break;
                    case 5:
                        throw t = ua(w), new U(2, 3, 3015, t, a.g.error || "No error in the media element", null);
                }
            });
        }
        function el(a, b) {
            a.u.get(b).shift();
            fl(a, b);
        }
        function fl(a, b) {
            var c = a.u.get(b)[0];
            if (c) try {
                c.start();
            } catch (d) {
                d.name == "QuotaExceededError" ? c.p.reject(new U(2, 3, 3017, b)) : Jk(a) ? c.p.reject(new U(2, 3, 3015, d, a.g.error || "No error in the media element", c.uri)) : c.p.reject(new U(2, 3, 3024, b)), el(a, b);
            }
        }
        function gl(a, b) {
            a.Y = b;
            a.h && (a.h.j = b);
        }
        function Tk(a, b, c, d, e) {
            if (hf(a.F.get(e)) != "mp4") return c;
            var f = d === null, g = a.Ma.get(e), h = a.O.Rk(), k = !1;
            d && d.ia && (k = d.ia.encrypted);
            d = d ? d.T()[0] : null;
            var l = Rb();
            a.C.correctEc3Enca && f && e === "audio" && (c = pj(c));
            a.C.insertFakeEncryptionInInit && g && l.Ud(h, e) && (f ? c = qj(b, c, d) : !k && l.Aj(e) && (c = sj(c)));
            f && l.Fe() && (c = vj(c));
            return c;
        }
        function hl(a, b, c, d) {
            return Qk(a, b, function() {
                if (b !== sc) {
                    a.F.get(b);
                    if (id()) {
                        a.j.has(b) && (a.j.get(b).destroy(), a.j.delete(b));
                        d && a.j.set(b, d);
                        var e = c + a.C.addExtraFeaturesToSourceBuffer(c);
                        a.l.get(b).changeType(e);
                        a.F.set(b, c);
                    }
                    Hk(a, b);
                }
            }, null);
        }
        function il(a, b) {
            var c, d, e, f, g, h, k, l, m, n, q, r, t, w, v, z, y, A, C, E;
            return Q(function(D) {
                if (D.g == 1) {
                    if (a.G || a.M) return D.return();
                    c = uc;
                    a.G = !0;
                    a.m = !1;
                    d = a.g.currentTime;
                    e = a.g.autoplay;
                    a.g.paused || (a.hb = !0);
                    a.jb && (a.g.autoplay = !1);
                    sa(D, 2);
                    a.A.Sa();
                    f = u(a.j.values());
                    for(g = f.next(); !g.done; g = f.next())h = g.value, h.destroy();
                    k = u(a.l.values());
                    for(l = k.next(); !l.done; l = k.next()){
                        m = l.value;
                        try {
                            a.i.removeSourceBuffer(m);
                        } catch (B) {}
                    }
                    a.j.clear();
                    a.l.clear();
                    n = a.i.duration;
                    a.L = new Lg;
                    a.i = xk(a, a.L);
                    return F(D, a.L, 4);
                }
                if (D.g != 2) {
                    !isNaN(n) && n ? a.i.duration = n : !isNaN(a.ra) && a.ra && (a.i.duration = a.ra);
                    q = new Lg;
                    r = a.i.sourceBuffers;
                    t = b.size;
                    w = 0;
                    v = function() {
                        w++;
                        w === t && (q.resolve(), a.A.Ea(r, "addsourcebuffer", v));
                    };
                    a.A.o(r, "addsourcebuffer", v);
                    z = u(b.keys());
                    for(y = z.next(); !y.done; y = z.next())A = y.value, C = b.get(A), Ek(a, A, C, C.codecs);
                    (E = b.get(c.na)) && E.isAudioMuxedInVideo && (a.m = !0);
                    a.m && !a.u.has(c.na) && a.u.set(c.na, []);
                    a.g.currentTime = d;
                    return F(D, q, 2);
                }
                va(D);
                a.G = !1;
                ih(a.J);
                a.A.ua(a.g, "canplaythrough", function() {
                    a.J.g || (a.g.autoplay = e, a.hb && (a.hb = !1, a.g.play()));
                });
                return xa(D, 0);
            });
        }
        function jl(a, b) {
            return bl(a, function() {
                return il(a, b);
            });
        }
        function kl(a, b, c, d) {
            var e = !1, f = qc("audio", (d || "").split(",")), g = qc("video", (d || "").split(",")), h = g;
            b == "audio" && (h = f);
            h || (h = d);
            d = df(c, h);
            var k = mf(a.F.get(b)), l = a.C.forceTransmux;
            !gd(d) || !a.I && ef.includes(d) ? l = !0 : l || c == k || (l = !Rb().lg() && ef.includes(c));
            if (l && (a = ff(c, h), c = Ye(a))) {
                var m = c();
                f && g && (e = !0);
                d = m.convertCodecs(b, a);
            }
            b = jf(nf(d));
            return {
                qc: m,
                Am: e,
                Ii: mf(d),
                codec: b,
                mimeType: d
            };
        }
        function ll(a, b, c, d, e) {
            if (b == sc) return {
                type: ml,
                Of: c,
                qc: null
            };
            var f = jf(nf(a.F.get(b))), g = mf(a.F.get(b)), h = kl(a, b, c, d), k = h.qc, l = h.Am, m = h.Ii, n = h.codec;
            h = h.mimeType;
            var q = !0;
            l && a.F.has("audio") && (c = kl(a, "audio", c, d), d = jf(nf(a.F.get("audio"))), q = mf(a.F.get("audio")), q = d == c.codec && q == c.Ii, c.qc && c.qc.destroy());
            if (f === n && g === m && q) return {
                type: ml,
                Of: h,
                qc: k
            };
            f = !0;
            if (a.m && !e.has("audio") || l && k && !a.j.has(b)) f = !1;
            if (f && a.C.codecSwitchingStrategy === "smooth" && id()) return {
                type: nl,
                Of: h,
                qc: k
            };
            k && k.destroy();
            return {
                type: ol,
                Of: h,
                qc: null
            };
        }
        function Zk(a, b, c, d, e) {
            var f, g, h, k, l, m;
            return Q(function(n) {
                if (n.g == 1) {
                    f = uc;
                    g = ll(a, b, c, d, e);
                    h = g.type;
                    k = g.qc;
                    l = g.Of;
                    if (m = e.get(f.na)) a.m = m.isAudioMuxedInVideo;
                    if (h == ml) return a.j.has(b) && !k ? (a.j.get(b).destroy(), a.j.delete(b)) : !a.j.has(b) && k ? a.j.set(b, k) : k && (a.j.has(b) && a.j.get(b).transmux !== k.transmux ? (a.j.get(b).destroy(), a.j.set(b, k)) : k.destroy()), n.return(!1);
                    if (h == nl) return F(n, hl(a, b, l, k), 3);
                    if (h != ol) return n.B(3);
                    k && k.destroy();
                    return F(n, jl(a, e), 3);
                }
                return n.return(!0);
            });
        }
        function pl(a, b, c, d, e) {
            a = ll(a, b, c, d, e);
            a.qc && a.qc.destroy();
            return a.type == ol;
        }
        var zk = window1.URL.createObjectURL, Gk = "sequence", ml = "none", ol = "reset", nl = "changeType";
        function yl(a, b, c) {
            this.i = a;
            this.F = b;
            this.A = this.l = Infinity;
            this.h = 1;
            this.g = this.j = null;
            this.C = 0;
            this.D = !0;
            this.J = !1;
            this.I = 0;
            this.G = c === void 0 ? !0 : c;
            this.H = 0;
            this.u = !1;
            this.m = a;
        }
        p = yl.prototype;
        p.getDuration = function() {
            return this.l;
        };
        p.Xk = function() {
            return this.h;
        };
        p.Nj = function(a) {
            this.i = a;
        };
        p.zb = function(a) {
            this.l = a;
        };
        p.fl = function() {
            return this.i;
        };
        p.Kj = function(a) {
            this.C = a;
        };
        p.sd = function(a) {
            a && !this.D && (this.J = !0);
            this.D = a;
        };
        p.hg = function(a) {
            this.A = a;
        };
        p.xf = function() {
            return this.A;
        };
        p.ci = function(a) {
            this.F = a;
        };
        p.Mk = function() {
            return this.F;
        };
        p.tj = function(a, b) {
            if (a.length != 0) {
                var c = (Date.now() + this.C) / 1E3;
                a = a.filter(function(e) {
                    return e.start + b < c;
                });
                if (a.length != 0) {
                    var d = a[a.length - 1].end + b;
                    this.Pf(a[0].start + b);
                    this.h = a.reduce(function(e, f) {
                        return Math.max(e, f.end - f.start);
                    }, this.h);
                    this.g = Math.max(this.g, d);
                    this.i != null && this.G && !this.u && (this.i = c - this.g - this.h);
                }
            }
        };
        p.Be = function(a) {
            if (a.length != 0) {
                var b = a[0].startTime, c = a[0].endTime, d = (Date.now() + this.C) / 1E3;
                a = u(a);
                for(var e = a.next(); !e.done; e = a.next())e = e.value, d < e.startTime || (b = Math.min(b, e.startTime), c = Math.max(c, e.endTime), this.h = Math.max(this.h, e.endTime - e.startTime));
                this.Pf(b);
                this.g = Math.max(this.g, c);
                this.i != null && this.G && !this.u && (this.i = d - this.g - this.h);
            }
        };
        p.sj = function(a, b) {
            this.Pf(a);
            b == Infinity || this.U() || (this.g = Math.max(this.g, b));
        };
        p.Yk = function() {
            return this.g;
        };
        p.Jf = function() {
            this.u = !0;
        };
        p.Kl = function() {
            return this.u;
        };
        p.ei = function(a) {
            this.m = a;
        };
        p.Qk = function() {
            return this.m;
        };
        p.Pf = function(a) {
            this.j == null ? this.j = a : this.J || (this.j = Math.min(this.j, a));
        };
        p.Lh = function(a) {
            this.h = Math.max(this.h, a);
        };
        p.offset = function(a) {
            this.j != null && (this.j += a);
            this.g != null && (this.g += a);
        };
        p.U = function() {
            return this.l == Infinity && !this.D;
        };
        p.ld = function() {
            return this.l != Infinity && !this.D;
        };
        p.Nb = function() {
            return Math.max(this.I, this.Sc() - this.A);
        };
        p.Pj = function(a) {
            this.I = a;
        };
        p.Sc = function() {
            return this.U() || this.ld() ? Math.min(Math.max(0, (Date.now() + this.C) / 1E3 - this.h - this.i) + this.H, this.l) : this.g ? Math.min(this.g, this.l) : this.l;
        };
        p.oe = function(a) {
            var b = Math.max(this.j, this.I);
            return this.A == Infinity ? Math.ceil(b * 1E3) / 1E3 : Math.max(b, Math.min(this.Sc() - this.A + a, this.Mb()));
        };
        p.fc = function() {
            return this.oe(0);
        };
        p.Mb = function() {
            return Math.max(0, this.Sc() - (this.U() || this.ld() ? this.F : 0));
        };
        p.dk = function() {
            return this.i == null || this.g != null && this.G ? !1 : !0;
        };
        p.Jj = function(a) {
            this.H = a;
        };
        p.Ck = function() {
            return this.H;
        };
        S("shaka.media.PresentationTimeline", yl);
        yl.prototype.getAvailabilityTimeOffset = yl.prototype.Ck;
        yl.prototype.setAvailabilityTimeOffset = yl.prototype.Jj;
        yl.prototype.usingPresentationStartTime = yl.prototype.dk;
        yl.prototype.getSeekRangeEnd = yl.prototype.Mb;
        yl.prototype.getSeekRangeStart = yl.prototype.fc;
        yl.prototype.getSafeSeekRangeStart = yl.prototype.oe;
        yl.prototype.getSegmentAvailabilityEnd = yl.prototype.Sc;
        yl.prototype.setUserSeekStart = yl.prototype.Pj;
        yl.prototype.getSegmentAvailabilityStart = yl.prototype.Nb;
        yl.prototype.isInProgress = yl.prototype.ld;
        yl.prototype.isLive = yl.prototype.U;
        yl.prototype.offset = yl.prototype.offset;
        yl.prototype.notifyMaxSegmentDuration = yl.prototype.Lh;
        yl.prototype.notifyMinSegmentStartTime = yl.prototype.Pf;
        yl.prototype.getInitialProgramDateTime = yl.prototype.Qk;
        yl.prototype.setInitialProgramDateTime = yl.prototype.ei;
        yl.prototype.isStartTimeLocked = yl.prototype.Kl;
        yl.prototype.lockStartTime = yl.prototype.Jf;
        yl.prototype.getMaxSegmentEndTime = yl.prototype.Yk;
        yl.prototype.notifyPeriodDuration = yl.prototype.sj;
        yl.prototype.notifySegments = yl.prototype.Be;
        yl.prototype.notifyTimeRange = yl.prototype.tj;
        yl.prototype.getDelay = yl.prototype.Mk;
        yl.prototype.setDelay = yl.prototype.ci;
        yl.prototype.getSegmentAvailabilityDuration = yl.prototype.xf;
        yl.prototype.setSegmentAvailabilityDuration = yl.prototype.hg;
        yl.prototype.setStatic = yl.prototype.sd;
        yl.prototype.setClockOffset = yl.prototype.Kj;
        yl.prototype.getPresentationStartTime = yl.prototype.fl;
        yl.prototype.setDuration = yl.prototype.zb;
        yl.prototype.setPresentationStartTime = yl.prototype.Nj;
        yl.prototype.getMaxSegmentDuration = yl.prototype.Xk;
        yl.prototype.getDuration = yl.prototype.getDuration;
        function zl(a, b, c, d) {
            var e = this;
            this.A = d;
            this.g = a;
            this.F = b;
            this.h = c;
            this.j = new Tc;
            this.m = !1;
            this.l = 0;
            this.D = !1;
            this.H = this.G = 0;
            this.u = Al(this);
            this.C = !1;
            this.j.o(a, "waiting", function() {
                return Bl(e);
            });
            this.i = new Bf(function() {
                Bl(e);
            }).wa(this.h.gapJumpTimerTime);
        }
        zl.prototype.release = function() {
            this.j && (this.j.release(), this.j = null);
            this.i != null && (this.i.stop(), this.i = null);
            this.u && (this.u.release(), this.u = null);
            this.g = this.F = this.A = null;
        };
        zl.prototype.Sf = function() {
            this.C = !0;
            this.i && this.i.wa(this.h.gapJumpTimerTime);
            Bl(this);
        };
        function Bl(a) {
            if (a.g.readyState != 0) {
                if (a.g.seeking) {
                    if (!a.m) return;
                } else a.m = !1;
                if (!a.g.paused || a.g.currentTime == a.l && (a.g.autoplay || a.g.currentTime != a.l)) {
                    var b;
                    if (!(b = !a.u)) {
                        b = a.u;
                        var c = b.h, d = Cl(c), e = c.g.currentTime, f = Date.now() / 1E3;
                        if (b.g != e || b.m != d) b.l = f, b.g = e, b.m = d, b.i = !1;
                        e = f - b.l;
                        if (d = e >= b.u && d && !b.i) b.j && b.j(b.g, e), b.i = !0, b.g = c.g.currentTime;
                        b = !d;
                    }
                    b && (b = a.g.currentTime, c = a.g.buffered, d = Ij(c, b, a.h.gapDetectionThreshold), d == null || d == 0 && !a.C || (e = c.start(d), (f = a.h.gapPadding) && (e = Math.ceil((e + f) * 100) / 100), e >= a.F.Mb() || e - b < .001 || (d != 0 && c.end(d - 1), Dl(a, e), b == a.l && (a.l = e), a.G++, a.A(new T("gapjumped")))));
                }
            }
        }
        function Dl(a, b) {
            a.D = !0;
            a.j.ua(a.g, "seeked", function() {
                a.D = !1;
            });
            a.g.currentTime = b;
        }
        function Al(a) {
            if (!a.h.stallEnabled) return null;
            var b = a.h.stallThreshold, c = a.h.stallSkip;
            return new El(new Fl(a.g), b, function() {
                var d;
                return Q(function(e) {
                    if (e.g == 1) return d = Hj(a.g.buffered), d.length ? c ? (a.g.currentTime += c, e.B(2)) : F(e, a.g.play(), 3) : e.return();
                    if (e.g != 2) {
                        if (!a.g) return e.return();
                        a.g.pause();
                        a.g.play();
                    }
                    a.H++;
                    a.A(new T("stalldetected"));
                    H(e);
                });
            });
        }
        function El(a, b, c) {
            this.h = a;
            this.m = Cl(a);
            this.g = a.g.currentTime;
            this.l = Date.now() / 1E3;
            this.i = !1;
            this.u = b;
            this.j = c;
        }
        El.prototype.release = function() {
            this.h && this.h.release();
            this.j = this.h = null;
        };
        function Fl(a) {
            var b = this;
            this.g = a;
            this.h = new Tc;
            this.i = !1;
            this.h.o(this.g, "audiofocuspaused", function() {
                b.i = !0;
            });
            this.h.o(this.g, "audiofocusgranted", function() {
                b.i = !1;
            });
            this.h.o(this.g, "audiofocuslost", function() {
                b.i = !0;
            });
        }
        function Cl(a) {
            if (a.g.paused || a.g.playbackRate == 0 || a.i || a.g.buffered.length == 0) var b = !1;
            else a: {
                b = a.g.currentTime;
                a = u(Hj(a.g.buffered));
                for(var c = a.next(); !c.done; c = a.next())if (c = c.value, !(b < c.start - .1 || b > c.end - .5)) {
                    b = !0;
                    break a;
                }
                b = !1;
            }
            return b;
        }
        Fl.prototype.release = function() {
            this.h && this.h.release();
            this.h = null;
        };
        function Gl(a, b, c, d) {
            b == HTMLMediaElement.HAVE_NOTHING || a.readyState >= b ? d() : (b = Hl.value().get(b), c.ua(a, b, d));
        }
        var Hl = new Qb(function() {
            return new Map([
                [
                    HTMLMediaElement.HAVE_METADATA,
                    "loadedmetadata"
                ],
                [
                    HTMLMediaElement.HAVE_CURRENT_DATA,
                    "loadeddata"
                ],
                [
                    HTMLMediaElement.HAVE_FUTURE_DATA,
                    "canplay"
                ],
                [
                    HTMLMediaElement.HAVE_ENOUGH_DATA,
                    "canplaythrough"
                ]
            ]);
        });
        function Il(a, b, c, d) {
            var e = this;
            this.g = a;
            this.m = b;
            this.A = c;
            this.l = null;
            this.j = function() {
                e.l == null && (e.l = d());
                return e.l;
            };
            this.u = !1;
            this.h = new Tc;
            this.i = new Jl(a);
            Gl(this.g, HTMLMediaElement.HAVE_METADATA, this.h, function() {
                Kl(e, e.j());
            });
        }
        Il.prototype.release = function() {
            this.h && (this.h.release(), this.h = null);
            this.i != null && (this.i.release(), this.i = null);
            this.m = function() {};
            this.g = null;
        };
        function Ll(a) {
            return a.u ? a.g.currentTime : a.j();
        }
        function Ml(a, b) {
            a.g.readyState > 0 ? Nl(a.i, b) : Gl(a.g, HTMLMediaElement.HAVE_METADATA, a.h, function() {
                Kl(a, a.j());
            });
        }
        function Kl(a, b) {
            Math.abs(a.g.currentTime - b) < .001 ? Ol(a) : (a.h.ua(a.g, "seeking", function() {
                Ol(a);
            }), Nl(a.i, a.g.currentTime && a.g.currentTime != 0 ? a.g.currentTime : b));
        }
        function Ol(a) {
            a.u = !0;
            a.h.o(a.g, "seeking", function() {
                return a.m();
            });
            a.A(a.g.currentTime);
        }
        function Jl(a) {
            var b = this;
            this.g = a;
            this.m = 10;
            this.j = this.l = this.i = 0;
            this.h = new Bf(function() {
                b.i <= 0 ? b.h.stop() : b.g.currentTime != b.l || b.g.currentTime === b.j ? b.h.stop() : (b.g.currentTime = b.j, b.i--);
            });
        }
        Jl.prototype.release = function() {
            this.h && (this.h.stop(), this.h = null);
            this.g = null;
        };
        function Nl(a, b) {
            a.l = a.g.currentTime;
            a.j = b;
            a.i = a.m;
            a.g.currentTime = b;
            a.h.wa(.1);
        }
        function Pl(a) {
            this.g = a;
            this.i = !1;
            this.h = null;
            this.j = new Tc;
        }
        p = Pl.prototype;
        p.ready = function() {
            function a() {
                if (b.h == null || b.h == 0 && b.g.duration != Infinity) b.i = !0;
                else {
                    var c = b.g.currentTime, d = null;
                    if (typeof b.h === "number") d = b.h;
                    else if (b.h instanceof Date) {
                        var e = Ql(b);
                        e !== null && (d = b.h.getTime() / 1E3 - e, d = Rl(b, d));
                    }
                    d == null ? b.i = !0 : (d < 0 && (d = Math.max(0, c + d)), c != d ? (b.j.ua(b.g, "seeking", function() {
                        b.i = !0;
                    }), b.g.currentTime = d) : b.i = !0);
                }
            }
            var b = this;
            Gl(this.g, HTMLMediaElement.HAVE_FUTURE_DATA, this.j, function() {
                a();
            });
        };
        p.release = function() {
            this.j && (this.j.release(), this.j = null);
            this.g = null;
        };
        p.Ag = function(a) {
            this.h = this.i ? this.h : a;
        };
        p.$e = function() {
            var a = this.i ? this.g.currentTime : this.h;
            a instanceof Date && (a = a.getTime() / 1E3 - (Ql(this) || 0), a = Rl(this, a));
            return a || 0;
        };
        p.Ci = function() {
            return 0;
        };
        p.Ai = function() {
            return 0;
        };
        p.Bi = function() {
            return !1;
        };
        p.rj = function() {};
        p.fj = function() {
            var a = Ej(this.g.buffered);
            return a != null && a >= this.g.duration - 1;
        };
        function Ql(a) {
            return a.g.getStartDate && (a = a.g.getStartDate().getTime(), !isNaN(a)) ? a / 1E3 : null;
        }
        function Rl(a, b) {
            a = a.g.seekable;
            a.length > 0 && (b = Math.max(a.start(0), b), b = Math.min(a.end(a.length - 1), b));
            return b;
        }
        function Sl(a, b, c, d, e, f) {
            var g = this;
            this.h = a;
            this.g = b.presentationTimeline;
            this.l = c;
            this.A = e;
            this.u = null;
            this.i = new zl(a, b.presentationTimeline, c, f);
            this.j = new Il(a, function() {
                a: {
                    var h = g.i;
                    h.m = !0;
                    h.C = !1;
                    h.i && h.i.wa(h.h.gapJumpTimerTime);
                    Bl(h);
                    var k = Ll(g.j);
                    h = Tl(g, k);
                    if (!kd() && Math.abs(h - k) > .001) {
                        k = !1;
                        var l = Rb().Fj();
                        if (l) {
                            var m = Date.now() / 1E3;
                            if (!g.u || g.u < m - l) g.u = m, k = !0;
                        } else k = !0;
                        if (k) {
                            Ml(g.j, h);
                            h = void 0;
                            break a;
                        }
                    }
                    g.A();
                    h = void 0;
                }
                return h;
            }, function(h) {
                var k = g.i;
                k.g.seeking && !k.m && (k.m = !0, k.l = h);
                k.i && k.i.wa(k.h.gapJumpTimerTime);
                Bl(k);
            }, function() {
                return Ul(g, d);
            });
            this.m = new Bf(function() {
                if (g.h.readyState != 0 && !g.h.paused) {
                    var h = Ll(g.j), k = g.g.fc(), l = g.g.Mb();
                    l - k < 3 && (k = l - 3);
                    h < k && (h = Tl(g, h), g.h.currentTime = h);
                }
            });
        }
        p = Sl.prototype;
        p.ready = function() {
            this.m.wa(.25);
        };
        p.release = function() {
            this.j && (this.j.release(), this.j = null);
            this.i && (this.i.release(), this.i = null);
            this.m && (this.m.stop(), this.m = null);
            this.h = this.j = this.g = this.l = null;
            this.A = function() {};
        };
        p.Ag = function(a) {
            Ml(this.j, Ul(this, a));
        };
        p.$e = function() {
            var a = Ll(this.j);
            return this.h.readyState > 0 && !this.h.paused ? Vl(this, a) : a;
        };
        p.Ci = function() {
            return this.i.H;
        };
        p.Ai = function() {
            return this.i.G;
        };
        p.Bi = function() {
            return this.i.D;
        };
        function Ul(a, b) {
            b == null ? b = a.g.getDuration() < Infinity ? a.g.fc() : a.g.Mb() : b instanceof Date ? b = b.getTime() / 1E3 - (a.g.m || a.g.i) : b < 0 && (b = a.g.Mb() + b);
            return Wl(a, Vl(a, b));
        }
        p.rj = function() {
            this.i.Sf();
        };
        p.fj = function() {
            if (this.g.U()) {
                var a = this.g.Sc(), b = Ej(this.h.buffered);
                if (b != null && b >= a) return !0;
            }
            return !1;
        };
        function Wl(a, b) {
            var c = a.g.getDuration();
            return b >= c ? c - a.l.durationBackoff : b;
        }
        function Tl(a, b) {
            var c = a.l.rebufferingGoal, d = a.l.safeSeekOffset, e = a.g.fc(), f = a.g.Mb(), g = a.g.getDuration();
            f - e < 3 && (e = f - 3);
            var h = a.g.oe(c), k = a.g.oe(d);
            c = a.g.oe(c + d);
            return b >= g ? Wl(a, b) : b > f ? f - a.l.safeSeekEndOffset : b < e ? a.g.U() && a.l.returnToEndOfLiveWindowWhenOutside ? f - a.l.safeSeekEndOffset : Fj(a.h.buffered, k) ? k : c : b >= h || Fj(a.h.buffered, b) ? b : c;
        }
        function Vl(a, b) {
            var c = a.g.fc();
            if (b < c) return c;
            a = a.g.Mb();
            return b > a ? a : b;
        }
        function Xl(a) {
            this.g = a;
            this.m = null;
            this.i = 0;
            this.u = !1;
        }
        p = Xl.prototype;
        p.getNumReferences = function() {
            return this.g.length;
        };
        p.getNumEvicted = function() {
            return this.i;
        };
        p.release = function() {
            this.u || (this.g = [], this.m && this.m.stop(), this.m = null);
        };
        p.Rl = function() {
            this.u = !0;
        };
        p.Lb = function(a) {
            for(var b = u(this.g), c = b.next(); !c.done; c = b.next())a(c.value);
        };
        function eg(a) {
            return a.g[0] || null;
        }
        p.find = function(a) {
            for(var b = this.g.length - 1, c = b; c >= 0; --c){
                var d = this.g[c], e = c < b ? this.g[c + 1].startTime : d.endTime;
                if (a >= d.startTime && a < e) return c + this.i;
            }
            return this.g.length && a < this.g[0].startTime ? this.i : null;
        };
        p.get = function(a) {
            if (this.g.length == 0) return null;
            a -= this.i;
            return a < 0 || a >= this.g.length ? null : this.g[a];
        };
        p.offset = function(a) {
            if (!this.u) for(var b = u(this.g), c = b.next(); !c.done; c = b.next())c.value.offset(a);
        };
        p.Lf = function(a) {
            if (!this.u && a.length) {
                var b = Math.round(a[0].startTime * 1E3) / 1E3;
                this.g = this.g.filter(function(c) {
                    return Math.round(c.startTime * 1E3) / 1E3 < b;
                });
                this.g.push.apply(this.g, x(a));
            }
        };
        p.ze = function(a, b) {
            var c = this;
            a = a.filter(function(d) {
                return d.endTime > b && (c.g.length == 0 || d.endTime > c.g[0].startTime);
            });
            this.Lf(a);
            this.cb(b);
        };
        p.cb = function(a) {
            if (!this.u) {
                var b = this.g.length;
                this.g = this.g.filter(function(c) {
                    return c.endTime > a;
                });
                this.i += b - this.g.length;
            }
        };
        p.Gd = function(a, b, c) {
            c = c === void 0 ? !1 : c;
            if (!this.u) {
                for(; this.g.length;)if (this.g[this.g.length - 1].startTime >= b) this.g.pop();
                else break;
                for(; this.g.length;)if (this.g[0].endTime <= a) this.g.shift(), c || this.i++;
                else break;
                this.g.length != 0 && (a = this.g[this.g.length - 1], b = new yj(a.startTime, b, a.D, a.startByte, a.endByte, a.ia, a.timestampOffset, a.appendWindowStart, a.appendWindowEnd, a.g, a.tilesLayout, a.C, a.h, a.status, a.aesKey), b.mimeType = a.mimeType, b.codecs = a.codecs, b.i = a.i, this.g[this.g.length - 1] = b);
            }
        };
        p.qg = function(a, b) {
            var c = this;
            this.u || (this.m && this.m.stop(), this.m = new Bf(function() {
                var d = b();
                d ? c.g.push.apply(c.g, x(d)) : (c.m.stop(), c.m = null);
            }), this.m.wa(a));
        };
        Xl.prototype[Symbol.iterator] = function() {
            return this.ec(0);
        };
        Xl.prototype.ec = function(a, b, c) {
            b = b === void 0 ? !1 : b;
            c = c === void 0 ? !1 : c;
            var d = this.find(a);
            if (d == null) return null;
            var e = this.get(d);
            c ? d++ : d--;
            var f = -1;
            if (e && e.g.length > 0) for(var g = e.g.length - 1; g >= 0; --g){
                var h = e.g[g];
                if (a >= h.startTime && a < h.endTime) {
                    if (!b) {
                        for(; g && !h.l;)g--, h = e.g[g];
                        if (!h.l) return $a("No independent partial segment found!"), null;
                    }
                    c ? d-- : d++;
                    f = g - 1;
                    break;
                }
            }
            return new Yl(this, d, f, c);
        };
        Xl.prototype.nf = function() {
            return -1;
        };
        function Zl(a, b, c) {
            a = new yj(a, a + b, function() {
                return c;
            }, 0, null, null, a, a, a + b);
            return new Xl([
                a
            ]);
        }
        S("shaka.media.SegmentIndex", Xl);
        Xl.forSingleSegment = Zl;
        Xl.prototype.getIteratorForTime = Xl.prototype.ec;
        Xl.prototype.updateEvery = Xl.prototype.qg;
        Xl.prototype.fit = Xl.prototype.Gd;
        Xl.prototype.evict = Xl.prototype.cb;
        Xl.prototype.mergeAndEvict = Xl.prototype.ze;
        Xl.prototype.offset = Xl.prototype.offset;
        Xl.prototype.get = Xl.prototype.get;
        Xl.prototype.find = Xl.prototype.find;
        Xl.prototype.markImmutable = Xl.prototype.Rl;
        Xl.prototype.release = Xl.prototype.release;
        Xl.prototype.getNumEvicted = Xl.prototype.getNumEvicted;
        Xl.prototype.getNumReferences = Xl.prototype.getNumReferences;
        function Yl(a, b, c, d) {
            this.i = a;
            this.h = b;
            this.g = c;
            this.reverse = d;
        }
        p = Yl.prototype;
        p.Yd = function(a) {
            this.reverse = a;
        };
        p.xk = function() {
            return this.h;
        };
        p.current = function() {
            var a = this.i.get(this.h);
            a && a.g.length > 0 && a.A && this.g >= a.g.length && (this.h++, this.g = 0, a = this.i.get(this.h));
            return a && a.g.length > 0 ? a.g[this.g] : a;
        };
        p.next = function() {
            var a = this.i.get(this.h);
            this.reverse ? a && a.g.length > 0 ? (this.g--, this.g < 0 && (this.h--, this.g = (a = this.i.get(this.h)) && a.g.length > 0 ? a.g.length - 1 : 0)) : (this.h--, this.g = 0) : a && a.g.length > 0 ? (this.g++, a.A && this.g == a.g.length && (this.h++, this.g = 0)) : (this.h++, this.g = 0);
            a = this.current();
            return {
                value: a,
                done: !a
            };
        };
        p.Wh = function() {
            var a = this.current();
            if (a.nd && !a.l && (a = this.i.get(this.h)) && a.g.length > 0) for(var b = a.g[this.g]; b.l && !(this.g <= 0);)this.g--, b = a.g[this.g];
        };
        S("shaka.media.SegmentIterator", Yl);
        Yl.prototype.resetToLastIndependent = Yl.prototype.Wh;
        Yl.prototype.next = Yl.prototype.next;
        Yl.prototype.current = Yl.prototype.current;
        Yl.prototype.currentPosition = Yl.prototype.xk;
        Yl.prototype.setReverse = Yl.prototype.Yd;
        function $l() {
            Xl.call(this, []);
            this.h = [];
        }
        la($l, Xl);
        p = $l.prototype;
        p.clone = function() {
            var a = new $l;
            a.h = this.h.slice();
            a.i = this.i;
            return a;
        };
        p.release = function() {
            for(var a = u(this.h), b = a.next(); !b.done; b = a.next())b.value.release();
            this.h = [];
        };
        p.Lb = function(a) {
            for(var b = u(this.h), c = b.next(); !c.done; c = b.next())c.value.Lb(a);
        };
        function am(a, b) {
            a = u(a.h);
            for(var c = a.next(); !c.done; c = a.next())b(c.value);
        }
        p.find = function(a) {
            for(var b = this.i, c = u(this.h), d = c.next(); !d.done; d = c.next()){
                d = d.value;
                var e = d.find(a);
                if (e != null) return e + b;
                b += d.getNumEvicted() + d.getNumReferences();
            }
            return null;
        };
        function bm(a, b) {
            a = u(a.h);
            for(var c = a.next(); !c.done; c = a.next())if (c = c.value, c.find(b) != null) return c.nf();
            return -1;
        }
        p.get = function(a) {
            for(var b = this.i, c = u(this.h), d = c.next(); !d.done; d = c.next()){
                d = d.value;
                var e = d.get(a - b);
                if (e) return e;
                e = d.getNumReferences();
                b += d.getNumEvicted() + e;
            }
            return null;
        };
        p.offset = function() {};
        p.Lf = function() {};
        p.cb = function(a) {
            if (this.h.length) {
                var b = this.h[0];
                b.cb(a);
                b.getNumReferences() == 0 && (this.h.shift(), this.i += b.getNumEvicted(), b.release(), this.cb(a));
            }
        };
        p.ze = function() {};
        p.Gd = function() {};
        p.qg = function() {};
        S("shaka.media.MetaSegmentIndex", $l);
        $l.prototype.updateEvery = $l.prototype.qg;
        $l.prototype.fit = $l.prototype.Gd;
        $l.prototype.mergeAndEvict = $l.prototype.ze;
        $l.prototype.evict = $l.prototype.cb;
        $l.prototype.merge = $l.prototype.Lf;
        $l.prototype.offset = $l.prototype.offset;
        $l.prototype.get = $l.prototype.get;
        $l.prototype.find = $l.prototype.find;
        $l.prototype.forEachTopLevelReference = $l.prototype.Lb;
        $l.prototype.release = $l.prototype.release;
        function cm(a) {
            var b = this;
            this.g = a;
            this.j = !1;
            this.i = this.g.wf();
            this.h = new Bf(function() {
                b.g.pj(b.i * .25);
            });
        }
        cm.prototype.release = function() {
            this.set(this.jd());
            this.h && (this.h.stop(), this.h = null);
            this.g = null;
        };
        cm.prototype.set = function(a) {
            this.i = a;
            dm(this);
        };
        cm.prototype.jd = function() {
            return this.g.jd();
        };
        function dm(a) {
            a.h.stop();
            var b = a.j ? 0 : a.i;
            if (b >= 0) try {
                a.g.wf() != b && a.g.gi(b);
                return;
            } catch (c) {}
            a.h.wa(.25);
            a.g.wf() != 0 && a.g.gi(0);
        }
        function em(a) {
            var b = this;
            this.j = a;
            this.h = new Tc;
            this.g = new Set;
            this.i = new Bf(function() {
                fm(b, !1);
            }).La();
            a.paused || this.i.wa(.25);
            this.h.o(a, "playing", function() {
                b.i.La().wa(.25);
            });
            this.h.o(a, "pause", function() {
                b.i.stop();
            });
        }
        em.prototype.release = function() {
            this.h && (this.h.release(), this.h = null);
            this.i.stop();
            for(var a = u(this.g), b = a.next(); !b.done; b = a.next())b.value.release();
            this.g.clear();
        };
        function fm(a, b) {
            var c = a.j.currentTime;
            a = u(a.g);
            for(var d = a.next(); !d.done; d = a.next())d.value.j(c, b);
        }
        function gm(a) {
            kb.call(this);
            this.g = new Map;
            this.h = a;
        }
        la(gm, kb);
        gm.prototype.release = function() {
            this.g.clear();
            kb.prototype.release.call(this);
        };
        function hm(a, b) {
            var c = a.g.get(b);
            c || (c = {
                Ee: [],
                Sg: null,
                contentType: b
            }, a.g.set(b, c));
            return c;
        }
        function im(a, b, c) {
            var d = hm(a, b.contentType);
            jm(a, d);
            a = {
                Od: b,
                position: c
            };
            d = d.Ee;
            b = d.findIndex(function(e) {
                return e.position >= c;
            });
            b >= 0 ? d.splice(b, d[b].position == c ? 1 : 0, a) : d.push(a);
        }
        gm.prototype.j = function(a) {
            for(var b = u(this.g.values()), c = b.next(); !c.done; c = b.next()){
                c = c.value;
                var d = c.Sg;
                a: {
                    var e = c.Ee;
                    for(var f = e.length - 1; f >= 0; f--){
                        var g = e[f];
                        if (g.position <= a) {
                            e = g.Od;
                            break a;
                        }
                    }
                    e = null;
                }
                f = e && !(d === e || d && e && d.bandwidth == e.bandwidth && d.audioSamplingRate == e.audioSamplingRate && d.codecs == e.codecs && d.contentType == e.contentType && d.frameRate == e.frameRate && d.height == e.height && d.mimeType == e.mimeType && d.channelsCount == e.channelsCount && d.pixelAspectRatio == e.pixelAspectRatio && d.width == e.width);
                g = e && d && e.label && d.label && d.label !== e.label;
                var h = e && d && e.language && d.language && d.language !== e.language;
                d = e && d && e.roles && d.roles && !Sc(d.roles, e.roles);
                (g || h || d) && km(this, a, e.contentType) && (c.Sg = e, d = new T("audiotrackchange", new Map([
                    [
                        "quality",
                        e
                    ],
                    [
                        "position",
                        a
                    ]
                ])), this.dispatchEvent(d));
                f && km(this, a, e.contentType) && (c.Sg = e, JSON.stringify(e), c = new T("qualitychange", new Map([
                    [
                        "quality",
                        e
                    ],
                    [
                        "position",
                        a
                    ]
                ])), this.dispatchEvent(c));
            }
        };
        function km(a, b, c) {
            return (a = a.h()[c]) && a.length > 0 && (c = a[a.length - 1].end, b >= a[0].start && b < c) ? !0 : !1;
        }
        function jm(a, b) {
            if ((a = a.h()[b.contentType]) && a.length > 0) {
                var c = a[0].start, d = a[a.length - 1].end, e = b.Ee;
                b.Ee = e.filter(function(f, g) {
                    return f.position <= c && g + 1 < e.length && e[g + 1].position <= c || f.position >= d ? !1 : !0;
                });
            } else b.Ee = [];
        }
        function lm(a) {
            var b = {
                bandwidth: a.bandwidth || 0,
                audioSamplingRate: null,
                codecs: a.codecs,
                contentType: a.type,
                frameRate: null,
                height: null,
                mimeType: a.mimeType,
                channelsCount: null,
                pixelAspectRatio: null,
                width: null,
                label: null,
                roles: a.roles,
                language: null
            };
            a.type == "video" && (b.frameRate = a.frameRate || null, b.height = a.height || null, b.pixelAspectRatio = a.pixelAspectRatio || null, b.width = a.width || null);
            a.type == "audio" && (b.audioSamplingRate = a.audioSamplingRate, b.channelsCount = a.channelsCount, b.label = a.label || null, b.language = a.language);
            return b;
        }
        function mm(a) {
            kb.call(this);
            this.h = new Map;
            this.i = a;
            this.g = null;
        }
        la(mm, kb);
        mm.prototype.release = function() {
            this.h.clear();
            this.g && (this.g.stop(), this.g = null);
            kb.prototype.release.call(this);
        };
        function nm(a, b) {
            var c = b.schemeIdUri + "_" + b.id + "_" + (b.startTime.toFixed(1) + "_" + b.endTime.toFixed(1));
            a.h.has(c) || (a.h.set(c, b), b = new T("regionadd", new Map([
                [
                    "region",
                    b
                ]
            ])), a.dispatchEvent(b), om(a));
        }
        function om(a) {
            a.g || (a.g = new Bf(function() {
                for(var b = a.i(), c = u(a.h), d = c.next(); !d.done; d = c.next()){
                    var e = u(d.value);
                    d = e.next().value;
                    e = e.next().value;
                    e.endTime < b.start && (a.h.delete(d), d = new T("regionremove", new Map([
                        [
                            "region",
                            e
                        ]
                    ])), a.dispatchEvent(d));
                }
                !a.h.size && a.g && (a.g.stop(), a.g = null);
            }).wa(2));
        }
        function pm(a, b, c, d, e) {
            function f(g, h) {
                return h.fastSwitching && g.nd && g.xe ? !1 : !0;
            }
            this.m = a;
            this.i = b;
            this.l = c;
            this.h = new Map;
            this.j = new Map;
            this.g = null;
            this.u = d;
            this.A = e || f;
        }
        function qm(a, b) {
            a.l = b;
            a = u(a.h.values());
            for(var c = a.next(); !c.done; c = a.next())c.value.g = b;
        }
        function rm(a, b, c) {
            c = c === void 0 ? !1 : c;
            if (!a.i.segmentIndex) return Promise.resolve();
            a.g || (a.g = a.i.segmentIndex.ec(b, !0, a.u));
            if (!a.g) return Promise.resolve();
            c && a.g.next();
            for(b = []; a.h.size < a.m;){
                c = a.g.next().value;
                if (!c) break;
                var d = !0;
                c.isPreload() && c.endByte != null && (d = !1);
                c.Uc() == 2 && (d = !1);
                c.hc(!1) && (d = !1);
                d && c.ia && b.push(sm(a, c.ia));
                d && !a.h.has(c) && (d = new tm(a.l), b.push(um(d, c, a.i)), a.h.set(c, d));
                if (!a.A(c, a.i)) break;
            }
            vm(a);
            return Promise.all(b);
        }
        function sm(a, b) {
            if (!a.i.segmentIndex || b.hc() || Array.from(a.j.keys()).some(function(e) {
                return xj(e, b);
            })) return Promise.resolve();
            var c = new tm(a.l), d = um(c, b, a.i);
            a.j.set(b, c);
            return d;
        }
        function wm(a, b) {
            b = u(b.keys());
            for(var c = b.next(); !c.done; c = b.next())(c = c.value) && xm(a, c);
        }
        function ym(a) {
            wm(a, a.h);
            wm(a, a.j);
            a.g = null;
        }
        pm.prototype.cb = function(a, b) {
            b = b === void 0 ? !1 : b;
            for(var c = u(this.h.keys()), d = c.next(); !d.done; d = c.next())d = d.value, a > d.endTime && xm(this, d);
            b && vm(this);
        };
        pm.prototype.Yd = function(a) {
            this.u = a;
            this.g && this.g.Yd(a);
        };
        function vm(a) {
            for(var b = Array.from(a.h.keys()), c = u(a.j.keys()), d = c.next(), e = {}; !d.done; e = {
                Eh: void 0
            }, d = c.next())e.Eh = d.value, b.some(function(f) {
                return function(g) {
                    return xj(g.ia, f.Eh);
                };
            }(e)) || xm(a, e.Eh);
        }
        function zm(a, b) {
            a.m = b;
            for(var c = Array.from(a.h.keys()); c.length > b;){
                var d = c.pop();
                d && xm(a, d);
            }
            vm(a);
        }
        function Am(a, b) {
            b && b !== a.i && (ym(a), a.i = b);
        }
        function xm(a, b) {
            var c = a.h;
            b instanceof wj && (c = a.j);
            a = c.get(b);
            c.delete(b);
            a && a.abort();
        }
        function tm(a) {
            this.g = a;
            this.Ce = this.ni = null;
        }
        function um(a, b, c) {
            var d = new Uint8Array(0);
            a.Ce = a.g(b, c, function(e) {
                return Q(function(f) {
                    if (f.g == 1) return d.byteLength > 0 ? d = lc(d, e) : d = e, a.ni ? F(f, a.ni(d), 3) : f.B(0);
                    d = new Uint8Array(0);
                    H(f);
                });
            });
            return a.Ce.promise.catch(function(e) {
                return e instanceof U && e.code == 7001 ? Promise.resolve() : Promise.reject(e);
            });
        }
        tm.prototype.abort = function() {
            this.Ce && this.Ce.abort();
        };
        S("shaka.config.CrossBoundaryStrategy", {
            KEEP: "keep",
            RESET: "reset",
            RESET_TO_ENCRYPTED: "reset_to_encrypted",
            RESET_ON_ENCRYPTION_CHANGE: "RESET_ON_ENCRYPTION_CHANGE"
        });
        function Bm(a) {
            var b = mf(a), c = b.split("/")[0];
            a = nf(a);
            return {
                type: c,
                mimeType: b,
                codecs: a,
                language: null,
                height: null,
                width: null,
                channelCount: null,
                sampleRate: null,
                closedCaptions: new Map,
                Ne: null,
                colorGamut: null,
                frameRate: null
            };
        }
        function Cm(a, b, c) {
            function d(B) {
                z = B.name;
                var G = B.reader;
                G.skip(24);
                var I = G.Ha(), J = G.Ha();
                G.skip(50);
                q = String(I);
                n = String(J);
                B.reader.Pa() && th(B);
            }
            function e(B) {
                var G = Mi(B.reader);
                r = G.channelCount;
                t = G.sampleRate;
                f(B.name);
            }
            function f(B) {
                B = B.toLowerCase();
                switch(B){
                    case "avc1":
                    case "avc3":
                        h.push(B + ".42E01E");
                        l = !0;
                        break;
                    case "hev1":
                    case "hvc1":
                        h.push(B + ".1.6.L93.90");
                        l = !0;
                        break;
                    case "dvh1":
                    case "dvhe":
                        h.push(B + ".05.04");
                        l = !0;
                        break;
                    case "vp09":
                        h.push(B + ".00.10.08");
                        l = !0;
                        break;
                    case "av01":
                        h.push(B + ".0.01M.08");
                        l = !0;
                        break;
                    case "mp4a":
                        g.push("mp4a.40.2");
                        k = !0;
                        break;
                    case "ac-3":
                    case "ec-3":
                    case "ac-4":
                    case "opus":
                    case "flac":
                        g.push(B);
                        k = !0;
                        break;
                    case "apac":
                        g.push("apac.31.00"), k = !0;
                }
            }
            var g = [], h = [], k = !1, l = !1, m = null, n = null, q = null, r = null, t = null, w = null, v = null, z;
            (new oh).box("moov", th).box("trak", th).box("mdia", th).W("mdhd", function(B) {
                m = Ki(B.reader, B.version).language;
            }).box("minf", th).box("stbl", th).W("stsd", vh).box("mp4a", function(B) {
                var G = Mi(B.reader);
                r = G.channelCount;
                t = G.sampleRate;
                B.reader.Pa() ? th(B) : f(B.name);
            }).box("esds", function(B) {
                B = B.reader;
                for(var G = "mp4a", I, J; B.Pa();){
                    I = B.ba();
                    for(var L = B.ba(); L & 128;)L = B.ba();
                    if (I == 3) B.Ha(), L = B.ba(), L & 128 && B.Ha(), L & 64 && B.skip(B.ba()), L & 32 && B.Ha();
                    else if (I == 4) J = B.ba(), B.skip(12);
                    else if (I == 5) break;
                }
                J && (G += "." + Pi(J), I == 5 && B.Pa() && (I = B.ba(), J = (I & 248) >> 3, J === 31 && B.Pa() && (J = 32 + ((I & 7) << 3) + ((B.ba() & 224) >> 5)), G += "." + J));
                g.push(G);
                k = !0;
            }).box("ac-3", e).box("ec-3", e).box("ac-4", e).box("Opus", e).box("fLaC", e).box("apac", e).box("avc1", d).box("avc3", d).box("hev1", d).box("hvc1", d).box("dva1", d).box("dvav", d).box("dvh1", d).box("dvhe", d).box("vp09", d).box("av01", d).box("avcC", function(B) {
                var G = z || "";
                switch(z){
                    case "dvav":
                        G = "avc3";
                        break;
                    case "dva1":
                        G = "avc1";
                }
                B = B.reader;
                B.skip(1);
                B = G + "." + Pi(B.ba()) + Pi(B.ba()) + Pi(B.ba());
                h.push(B);
                l = !0;
            }).box("hvcC", function(B) {
                var G = z || "";
                switch(z){
                    case "dvh1":
                        G = "hvc1";
                        break;
                    case "dvhe":
                        G = "hev1";
                }
                var I = B.reader;
                I.skip(1);
                B = I.ba();
                var J = [
                    "",
                    "A",
                    "B",
                    "C"
                ][B >> 6], L = B & 31, K = I.Z(), N = (B & 32) >> 5 ? "H" : "L";
                B = [
                    I.ba(),
                    I.ba(),
                    I.ba(),
                    I.ba(),
                    I.ba(),
                    I.ba()
                ];
                I = I.ba();
                for(var P = 0, O = 0; O < 32; O++){
                    P |= K & 1;
                    if (O == 31) break;
                    P <<= 1;
                    K >>= 1;
                }
                G = G + ("." + J + L) + ("." + Pi(P, !0));
                G += "." + N + I;
                J = "";
                for(L = B.length; L--;)if ((N = B[L]) || J) J = "." + N.toString(16).toUpperCase() + J;
                G += J;
                h.push(G);
                l = !0;
            }).box("dvcC", function(B) {
                var G = z || "";
                switch(z){
                    case "hvc1":
                        G = "dvh1";
                        break;
                    case "hev1":
                        G = "dvhe";
                        break;
                    case "avc1":
                        G = "dva1";
                        break;
                    case "avc3":
                        G = "dvav";
                        break;
                    case "av01":
                        G = "dav1";
                }
                var I = B.reader;
                I.skip(2);
                B = I.ba();
                I = I.ba();
                h.push(G + "." + Qi(B >> 1 & 127) + "." + Qi(B << 5 & 32 | I >> 3 & 31));
                l = !0;
            }).box("dvvC", function(B) {
                var G = z || "";
                switch(z){
                    case "hvc1":
                        G = "dvh1";
                        break;
                    case "hev1":
                        G = "dvhe";
                        break;
                    case "avc1":
                        G = "dva1";
                        break;
                    case "avc3":
                        G = "dvav";
                        break;
                    case "av01":
                        G = "dav1";
                }
                var I = B.reader;
                I.skip(2);
                B = I.ba();
                I = I.ba();
                h.push(G + "." + Qi(B >> 1 & 127) + "." + Qi(B << 5 & 32 | I >> 3 & 31));
                l = !0;
            }).W("vpcC", function(B) {
                var G = z || "", I = B.reader;
                B = I.ba();
                var J = I.ba();
                I = I.ba() >> 4 & 15;
                h.push(G + "." + Qi(B) + "." + Qi(J) + "." + Qi(I));
                l = !0;
            }).box("av1C", function(B) {
                var G = z || "";
                switch(z){
                    case "dav1":
                        G = "av01";
                }
                var I = B.reader;
                I.skip(1);
                B = I.ba();
                I = I.ba();
                var J = B >>> 5, L = (I & 64) >> 6;
                h.push(G + "." + J + "." + Qi(B & 31) + (I >>> 7 ? "H" : "M") + "." + Qi(J === 2 && L ? (I & 32) >> 5 ? 12 : 10 : L ? 10 : 8) + "." + ((I & 16) >> 4) + "." + ((I & 8) >> 3) + ((I & 4) >> 2) + (I & 3) + "." + Qi(1) + "." + Qi(1) + "." + Qi(1) + ".0");
                l = !0;
            }).box("enca", xh).box("encv", wh).box("sinf", th).box("frma", function(B) {
                B = Ni(B.reader).codec;
                f(B);
            }).box("colr", function(B) {
                h = h.map(function(J) {
                    if (J.startsWith("av01.")) {
                        var L = B.reader, K = L.Wa(), N = L.ac(4);
                        var P = String.fromCharCode(N[0]);
                        P += String.fromCharCode(N[1]);
                        P += String.fromCharCode(N[2]);
                        P += String.fromCharCode(N[3]);
                        if (P === "nclx") {
                            N = L.Ha();
                            P = L.Ha();
                            var O = L.Ha(), M = L.ba() >> 7, R = J.split(".");
                            R.length == 10 && (R[6] = Qi(N), R[7] = Qi(P), R[8] = Qi(O), R[9] = String(M), J = R.join("."));
                        }
                        L.seek(K);
                    }
                    return J;
                });
                var G = Oi(B.reader), I = G.colorGamut;
                w = G.Ne;
                v = I;
            }).parse(a || b, !0, !0);
            if (!g.length && !h.length) return null;
            var y = k && !l, A = new Map;
            if (l && !c) {
                c = new od("video/mp4");
                a && c.init(a);
                try {
                    c.Uf(b);
                    for(var C = u(c.zg()), E = C.next(); !E.done; E = C.next()){
                        var D = E.value;
                        A.set(D, D);
                    }
                } catch (B) {}
                c.ce();
            }
            return {
                type: y ? "audio" : "video",
                mimeType: y ? "audio/mp4" : "video/mp4",
                codecs: Dm(g.concat(h)).join(", "),
                language: m,
                height: n,
                width: q,
                channelCount: r,
                sampleRate: t,
                closedCaptions: A,
                Ne: w,
                colorGamut: v,
                frameRate: null
            };
        }
        function Dm(a) {
            var b = new Set, c = [];
            a = u(a);
            for(var d = a.next(); !d.done; d = a.next()){
                d = d.value;
                var e = lf(d);
                b.has(e) || (c.push(d), b.add(e));
            }
            b = tc("audio", c);
            d = tc("video", c);
            a = tc(sc, c);
            d = Em(d);
            b = b.concat(d).concat(a);
            return c.length && !b.length ? c : b;
        }
        function Em(a) {
            if (a.length <= 1) return a;
            var b = a.find(function(c) {
                return c.startsWith("dvav.") || c.startsWith("dva1.") || c.startsWith("dvh1.") || c.startsWith("dvhe.") || c.startsWith("dav1.") || c.startsWith("dvc1.") || c.startsWith("dvi1.");
            });
            return b ? gd('video/mp4; codecs="' + b + '"') ? [
                b
            ] : a.filter(function(c) {
                return c != b;
            }) : a;
        }
        function Fm(a) {
            var b = null;
            (new oh).box("moov", th).box("trak", th).box("mdia", th).box("minf", th).box("stbl", th).W("stsd", vh).box("encv", wh).box("enca", xh).box("sinf", th).box("schi", th).W("tenc", function(c) {
                c = c.reader;
                c.ba();
                c.ba();
                c.ba();
                c.ba();
                b = jc(c.ac(16));
            }).parse(a, !0);
            return b;
        }
        function Gm(a, b, c) {
            var d, e, f, g, h;
            return Q(function(k) {
                if (k.g == 1) return d = b, d.cryptoKey ? k.B(2) : F(k, d.fetchKey(), 3);
                e = d.iv;
                if (!e) for(e = Kb(new ArrayBuffer(16)), f = d.firstMediaSequenceNumber + c, g = e.byteLength - 1; g >= 0; g--)e[g] = f & 255, f >>= 8;
                b.blockCipherMode == "CBC" ? h = {
                    name: "AES-CBC",
                    iv: e
                } : h = {
                    name: "AES-CTR",
                    counter: e,
                    length: 64
                };
                return k.return(window1.crypto.subtle.decrypt(h, d.cryptoKey, a));
            });
        }
        function Hm(a, b, c, d, e) {
            a = $g(a, d, e);
            if (b != 0 || c != null) a.headers.Range = c ? "bytes=" + b + "-" + c : "bytes=" + b + "-";
            return a;
        }
        function Im(a, b) {
            var c = this;
            this.g = b;
            this.j = a;
            this.i = null;
            this.M = new Map;
            this.F = 1;
            this.C = this.u = null;
            this.S = 0;
            this.h = new Map;
            this.L = !1;
            this.V = null;
            this.D = !1;
            this.l = new hh(function() {
                return Jm(c);
            });
            this.P = Date.now() / 1E3;
            this.m = new Map;
            this.R = {
                projection: null,
                hfov: null
            };
            this.Y = 0;
            this.X = Infinity;
            this.H = null;
            this.O = [];
            this.A = new Bf(function() {
                if (c.j && c.g) {
                    if (c.j.presentationTimeline.U()) {
                        var d = c.j.presentationTimeline.fc(), e = c.j.presentationTimeline.Mb();
                        e - d > 1 ? cl(c.g.ha, d, e) : dl(c.g.ha);
                    } else dl(c.g.ha), c.A && c.A.stop();
                } else c.A && c.A.stop();
            });
            this.I = null;
            this.J = !1;
            this.K = new Bf(function() {
                var d = c.g.video;
                !d.ended && c.I && (c.J = !0, d.currentTime = c.I, c.I = null);
            });
            this.G = new Tc;
        }
        p = Im.prototype;
        p.destroy = function() {
            return this.l.destroy();
        };
        function Jm(a) {
            var b, c, d, e, f, g, h;
            return Q(function(k) {
                if (k.g == 1) {
                    a.A && a.A.stop();
                    a.A = null;
                    a.K && a.K.stop();
                    a.K = null;
                    a.G && (a.G.release(), a.G = null);
                    b = [];
                    c = u(a.h.values());
                    for(d = c.next(); !d.done; d = c.next())e = d.value, Km(e), b.push(Lm(e)), e.ka && (ym(e.ka), e.ka = null);
                    f = u(a.m.values());
                    for(g = f.next(); !g.done; g = f.next())h = g.value, ym(h);
                    return F(k, Promise.all(b), 2);
                }
                a.h.clear();
                a.m.clear();
                a.g = null;
                a.j = null;
                a.i = null;
                a.I = null;
                H(k);
            });
        }
        p.configure = function(a) {
            this.i = a;
            this.V = new Eg({
                maxAttempts: Math.max(a.retryParameters.maxAttempts, 2),
                baseDelay: a.retryParameters.baseDelay,
                backoffFactor: a.retryParameters.backoffFactor,
                fuzzFactor: a.retryParameters.fuzzFactor,
                timeout: 0,
                stallTimeout: 0,
                connectionTimeout: 0
            }, !0);
            if (a.disableAudioPrefetch) {
                var b = this.h.get("audio");
                b && b.ka && (ym(b.ka), b.ka = null);
                b = u(this.m.keys());
                for(var c = b.next(); !c.done; c = b.next())c = c.value, ym(this.m.get(c)), this.m.delete(c);
            }
            a.disableTextPrefetch && (b = this.h.get(sc)) && b.ka && (ym(b.ka), b.ka = null);
            a.disableVideoPrefetch && (b = this.h.get("video")) && b.ka && (ym(b.ka), b.ka = null);
            b = u(this.h.keys());
            for(c = b.next(); !c.done; c = b.next())c = this.h.get(c.value), c.ka ? (zm(c.ka, a.segmentPrefetchLimit), a.segmentPrefetchLimit > 0 || (ym(c.ka), c.ka = null)) : a.segmentPrefetchLimit > 0 && (c.ka = Mm(this, c.stream));
            a.disableAudioPrefetch || Nm(this);
        };
        function Om(a, b, c) {
            a.j.presentationTimeline.U() || (a.Y = b, a.X = c);
        }
        p.start = function(a) {
            var b = this;
            return Q(function(c) {
                if (c.g == 1) return F(c, Pm(b, a || new Map), 2);
                ih(b.l);
                b.L = !0;
                H(c);
            });
        };
        function Qm(a, b) {
            var c, d, e, f, g, h, k;
            Q(function(l) {
                switch(l.g){
                    case 1:
                        return c = uc, a.S++, d = a.S, ra(l, 2), F(l, Xk(a.g.ha, c.Va), 4);
                    case 4:
                        ta(l, 3);
                        break;
                    case 2:
                        if (e = ua(l), a.g) a.g.onError(e);
                    case 3:
                        f = df(b.mimeType, b.codecs), Fk(a.g.ha, f, a.j.sequenceMode, b.external), g = a.g.ha.Y, (h = g.isTextVisible() || a.i.alwaysStreamText) && a.S == d && (k = Rm(a, b), a.h.set(c.Va, k), Sm(a, k, 0)), H(l);
                }
            });
        }
        function Tm(a) {
            var b = a.h.get(sc);
            b && (Km(b), Lm(b).catch(function() {}), a.H = a.h.get(sc), a.h.delete(sc), b.stream && b.stream.closeSegmentIndex && b.stream.closeSegmentIndex());
            a.C = null;
        }
        function Um(a, b) {
            for(var c = a.g.Za() < 0, d = u(a.h.values()), e = d.next(); !e.done; e = d.next())e = e.value, e.Ba && e.Ba.Yd(c), e.ka && e.ka.Yd(c);
            d = u(a.m.values());
            for(e = d.next(); !e.done; e = d.next())e.value.Yd(c);
            if (c = a.h.get("video")) {
                if (d = c.stream) {
                    if (b) (b = d.trickModeVideo) && !c.Yc && (Vm(a, b, !1, 0, !1), c.Yc = d);
                    else if (b = c.Yc) c.Yc = null, Vm(a, b, !0, 0, !1);
                }
            }
        }
        function Wm(a, b, c, d, e, f) {
            c = c === void 0 ? !1 : c;
            d = d === void 0 ? 0 : d;
            e = e === void 0 ? !1 : e;
            f = f === void 0 ? !1 : f;
            a.u = b;
            a.L && (b.video && Vm(a, b.video, c, d, e, f), b.audio && Vm(a, b.audio, c, d, e, f));
        }
        function Xm(a, b) {
            Q(function(c) {
                if (c.g == 1) return a.H = null, a.C = b, a.L ? b.segmentIndex ? c.B(2) : F(c, b.createSegmentIndex(), 2) : c.return();
                Vm(a, b, !0, 0, !1);
                H(c);
            });
        }
        function Ym(a) {
            var b = a.h.get(sc);
            b && Vm(a, b.stream, !0, 0, !0);
        }
        function Zm(a, b) {
            for(var c = u(a.M.entries()), d = c.next(); !d.done; d = c.next()){
                var e = u(d.value);
                d = e.next().value;
                e = e.next().value;
                d.includes(b.type) && (e(), a.M.delete(d));
            }
        }
        function Vm(a, b, c, d, e, f) {
            var g = a.h.get(b.type);
            g || b.type != sc ? g && (g.Yc && (b.trickModeVideo ? (g.Yc = b, b = b.trickModeVideo) : g.Yc = null), g.stream != b || e) && (a.m.has(b) ? g.ka = a.m.get(b) : g.ka && Am(g.ka, b), b.type == sc && g.stream != b && (e = df(b.mimeType, b.codecs), Fk(a.g.ha, e, a.j.sequenceMode, b.external)), !a.m.has(g.stream) && g.stream.closeSegmentIndex && (g.Ra ? (e = "(" + g.type + ":" + g.stream.id + ")", a.M.has(e) || a.M.set(e, g.stream.closeSegmentIndex)) : g.stream.closeSegmentIndex()), e = g.stream.isAudioMuxedInVideo != b.isAudioMuxedInVideo, g.stream = b, g.Ba = null, g.Gg = !!f, b.dependencyStream ? g.Oc = Rm(a, b.dependencyStream) : g.Oc = null, $m(a), e && (g.yb = null, g.Ac = null, g.zc = null, b.isAudioMuxedInVideo && (b = null, g.type === "video" ? b = a.h.get("audio") : g.type === "audio" && (b = a.h.get("video")), b && (Lm(b).catch(function() {}), b.yb = null, b.Ac = null, b.zc = null, an(a, b), bn(a, b).catch(function(h) {
                if (a.g) a.g.onError(h);
            })))), c ? g.dc ? g.ae = !0 : g.Ra ? (g.uc = !0, g.Cd = d, g.ae = !0) : (Km(g), cn(a, g, !0, d).catch(function(h) {
                if (a.g) a.g.onError(h);
            })) : g.Ra || g.Ab || Sm(a, g, 0), bn(a, g).catch(function(h) {
                if (a.g) a.g.onError(h);
            })) : Qm(a, b);
        }
        function bn(a, b) {
            var c, d, e;
            return Q(function(f) {
                if (f.g == 1) {
                    if (!b.$a) return f.return();
                    c = b.stream;
                    d = b.$a;
                    return c.segmentIndex ? f.B(2) : F(f, c.createSegmentIndex(), 2);
                }
                if (f.g != 4) return e = c.dependencyStream, !e || e.segmentIndex ? f.B(4) : F(f, e.createSegmentIndex(), 4);
                if (b.$a != d || b.stream != c) return f.return();
                var g = a.g.Rc();
                var h = Mk(a.g.ha, b.type), k = b.stream.segmentIndex.find(b.Ua ? b.Ua.endTime : g), l = k == null ? null : b.stream.segmentIndex.get(k);
                k = l ? l.endByte ? l.endByte - l.startByte : null : null;
                l && !k && (k = (l.endTime - l.getStartTime()) * (b.stream.bandwidth || 0) / 8);
                k ? ((l = l.ia) && (k += (l.endByte ? l.endByte - l.startByte : null) || 0), l = a.g.getBandwidthEstimate(), g = k * 8 / l < (h || 0) - g - a.i.rebufferingGoal || b.$a.h.g > k ? !0 : !1) : g = !1;
                g && b.$a.abort();
                H(f);
            });
        }
        p.rd = function() {
            if (this.g) {
                for(var a = this.g.Rc(), b = u(this.h.keys()), c = b.next(); !c.done; c = b.next()){
                    var d = c.value;
                    c = this.h.get(d);
                    var e;
                    if (e = !this.J) e = this.g.ha, d == sc ? (e = e.h, e = e.g == null || e.h == null ? !1 : a >= e.g && a < e.h) : (e = Lk(e, d), e = Fj(e, a)), e = !e;
                    if (e) {
                        this.P = 0;
                        c.ka && (c.ka.g = null);
                        if (c.type === "audio") {
                            e = u(this.m.values());
                            for(var f = e.next(); !f.done; f = e.next())f.value.g = null;
                        }
                        c.Ba = null;
                        (Mk(this.g.ha, d) != null || c.Ra) && an(this, c);
                        c.$a && (c.$a.abort(), c.$a = null);
                        d === sc && (d = this.g.ha, d.K && d.K.ce());
                        c.rd = !0;
                    }
                    !this.J || c.dc || c.Ra || c.Ab || Sm(this, c, 0);
                }
                dn(this) && en(this);
            }
        };
        function an(a, b) {
            b.dc || b.uc || (b.Ra ? (b.uc = !0, b.Cd = 0) : Kk(a.g.ha, b.type) == null ? b.Ab == null && Sm(a, b, 0) : (Km(b), cn(a, b, !1, 0).catch(function(c) {
                if (a.g) a.g.onError(c);
            })));
        }
        function Pm(a, b) {
            var c, d, e, f, g, h, k, l;
            return Q(function(m) {
                if (m.g == 1) {
                    if (!a.u) throw new U(2, 5, 5006);
                    c = fn(a, !0);
                    d = a.g.ha;
                    return F(m, d.init(c, a.j.sequenceMode, a.j.type, a.j.ignoreManifestTimestampsInSegmentsMode), 2);
                }
                ih(a.l);
                a.updateDuration();
                e = u(c.keys());
                for(f = e.next(); !f.done; f = e.next())g = f.value, h = c.get(g), a.h.has(g) || (k = Rm(a, h), b.has(h.id) && (l = b.get(h.id), qm(l, function(n, q, r) {
                    return gn(n, q, r || null, a.i.retryParameters, a.g.Dc);
                }), k.ka = l), a.h.set(g, k), Sm(a, k, 0));
                $m(a);
                H(m);
            });
        }
        function Rm(a, b) {
            var c = {
                stream: b,
                type: b.type,
                Ba: null,
                ka: Mm(a, b),
                Ua: null,
                yb: null,
                If: null,
                Ac: null,
                zc: null,
                Gf: null,
                Hf: null,
                Yc: null,
                endOfStream: !1,
                Ra: !1,
                Ab: null,
                uc: !1,
                Cd: 0,
                ae: !1,
                dc: !1,
                rd: !0,
                Gg: !1,
                Th: !1,
                qe: !1,
                $a: null,
                Oc: null
            };
            b.dependencyStream && (c.Oc = Rm(a, b.dependencyStream));
            return c;
        }
        function Mm(a, b) {
            if (b.type === "video" && a.i.disableVideoPrefetch || b.type === "audio" && a.i.disableAudioPrefetch || b.type === sc && (b.mimeType == "application/cea-608" || b.mimeType == "application/cea-708") || b.type === sc && a.i.disableTextPrefetch) return null;
            if (a.m.has(b)) return a.m.get(b);
            var c = a.h.get(b.type);
            return (c = c && c.ka) && b === c.i ? c : a.i.segmentPrefetchLimit > 0 ? new pm(a.i.segmentPrefetchLimit, b, function(d, e, f) {
                return gn(d, e, f || null, a.i.retryParameters, a.g.Dc);
            }, a.g.Za() < 0, a.g.ym) : null;
        }
        function Nm(a) {
            for(var b = a.i.segmentPrefetchLimit, c = a.i.prefetchAudioLanguages, d = u(a.j.variants), e = d.next(), f = {}; !e.done; f = {
                Tb: void 0
            }, e = d.next())if (f.Tb = e.value, f.Tb.audio) {
                if (a.m.has(f.Tb.audio)) {
                    if (e = a.m.get(f.Tb.audio), zm(e, b), !(b > 0 && c.some(function(h) {
                        return function(k) {
                            return xc(h.Tb.audio.language, k);
                        };
                    }(f)))) {
                        var g = a.h.get(f.Tb.audio.type);
                        e !== (g && g.ka) && ym(e);
                        a.m.delete(f.Tb.audio);
                    }
                } else b <= 0 || !c.some(function(h) {
                    return function(k) {
                        return xc(h.Tb.audio.language, k);
                    };
                }(f)) || !(e = Mm(a, f.Tb.audio)) || (f.Tb.audio.segmentIndex || f.Tb.audio.createSegmentIndex(), a.m.set(f.Tb.audio, e));
            }
        }
        p.updateDuration = function() {
            var a = kd(), b = this.j.presentationTimeline.getDuration();
            b < Infinity ? (a && (this.A && this.A.stop(), dl(this.g.ha)), this.g.ha.zb(b)) : a ? (this.A && this.A.wa(.5), this.g.ha.zb(Infinity)) : this.g.ha.zb(4294967296);
        };
        function hn(a, b) {
            var c, d, e, f, g, h, k, l, m;
            return Q(function(n) {
                switch(n.g){
                    case 1:
                        ih(a.l);
                        c = uc;
                        if (b.Ra || b.Ab == null || b.dc) return n.return();
                        b.Ab = null;
                        if (!b.uc) {
                            n.B(2);
                            break;
                        }
                        return F(n, cn(a, b, b.ae, b.Cd), 3);
                    case 3:
                        return n.return();
                    case 2:
                        Zm(a, b);
                        if (b.stream.segmentIndex) {
                            n.B(4);
                            break;
                        }
                        d = b.stream;
                        ra(n, 5);
                        return F(n, b.stream.createSegmentIndex(), 7);
                    case 7:
                        ta(n, 6);
                        break;
                    case 5:
                        return e = ua(n), F(n, jn(a, b, e), 8);
                    case 8:
                        return n.return();
                    case 6:
                        if (d != b.stream) return d.closeSegmentIndex && d.closeSegmentIndex(), b.Ra || b.Ab || Sm(a, b, 0), n.return();
                    case 4:
                        if (!b.Oc) {
                            n.B(9);
                            break;
                        }
                        if (b.Oc.stream.segmentIndex) {
                            n.B(9);
                            break;
                        }
                        ra(n, 11);
                        return F(n, b.Oc.stream.createSegmentIndex(), 13);
                    case 13:
                        ta(n, 9);
                        break;
                    case 11:
                        ua(n);
                    case 9:
                        ra(n, 14);
                        f = kn(a, b);
                        f != null && (Sm(a, b, f), b.qe = !1);
                        ta(n, 15);
                        break;
                    case 14:
                        return g = ua(n), F(n, jn(a, b, g), 16);
                    case 16:
                        return n.return();
                    case 15:
                        if (b.type === c.Va) return n.return();
                        h = [
                            b
                        ];
                        k = b.type === c.na ? c.Ia : c.na;
                        (l = a.h.get(k)) && h.push(l);
                        if (!a.L || !h.every(function(q) {
                            return q.endOfStream;
                        })) {
                            n.B(0);
                            break;
                        }
                        return F(n, a.g.ha.endOfStream(), 18);
                    case 18:
                        ih(a.l), m = a.g.ha.getDuration(), m != 0 && m < a.j.presentationTimeline.getDuration() && a.j.presentationTimeline.zb(m), H(n);
                }
            });
        }
        function kn(a, b) {
            if (ln(b)) return Uk(a.g.ha, b.stream.originalId || ""), null;
            b.type == sc && Vk(a.g.ha);
            if (b.stream.isAudioMuxedInVideo && b.type == "audio") return null;
            if (b.type != sc && Dk(a.g.ha)) return mn(a, !0), null;
            var c = a.i.updateIntervalSeconds / Math.max(1, Math.abs(a.g.Za()));
            if (!Jk(a.g.ha) && b.type != sc) return c / 2;
            var d = a.g.Rc();
            if (b.type === "audio") for(var e = u(a.m.keys()), f = e.next(); !f.done; f = e.next())f = a.m.get(f.value), f.cb(d, !0), rm(f, d);
            e = b.Ua ? b.Ua.endTime : d;
            var g = Nk(a.g.ha, b.type, d);
            f = Math.max(1, Math.max(a.i.rebufferingGoal, a.i.bufferingGoal) * a.F);
            var h = a.j.presentationTimeline.getDuration() - e, k = Mk(a.g.ha, b.type);
            if (h < 1E-6 && k) return b.endOfStream = !0, b.type == "video" && (a = a.h.get(sc)) && ln(a) && (a.endOfStream = !0), null;
            b.endOfStream = !1;
            if (g >= f) return c / 2;
            h = !b.Ba;
            k = nn(a, b, d, k);
            if (!k) return c;
            g = b.yb;
            var l = k.ia;
            g && l && xj(l, g) && (g.g = l.g);
            g = !1;
            h && b.Gg && (g = !0, b.Gg = !1);
            h = Infinity;
            l = Array.from(a.h.values());
            l = u(l);
            for(var m = l.next(); !m.done; m = l.next())m = m.value, ln(m) || m.Ba && !m.Ba.current() || (h = Math.min(h, m.Ua ? m.Ua.endTime : d));
            if (e >= h + a.j.presentationTimeline.h) return c;
            b.ka && b.Ba && !a.m.has(b.stream) && (b.ka.cb(k.startTime + .001), rm(b.ka, k.startTime).catch(function() {}));
            if (dn(a) && on(a, b, k)) return null;
            pn(a, b, d, k, g).catch(function() {});
            b.Oc && qn(a, b.Oc, d, f);
            return null;
        }
        function nn(a, b, c, d) {
            if (b.Ba) return (c = b.Ba.current()) && b.Ua && Math.abs(b.Ua.startTime - c.startTime) < .001 && (c = b.Ba.next().value), c;
            if (b.Ua || d) return c = b.Ua ? b.Ua.endTime : d, a = a.g.Za() < 0, b.stream.segmentIndex && (b.Ba = b.stream.segmentIndex.ec(c, !1, a)), b.Ba && b.Ba.next().value;
            d = a.j.sequenceMode || dn(a) ? 0 : a.i.inaccurateManifestTolerance;
            var e = Math.max(c - d, 0);
            a = a.g.Za() < 0;
            var f = null;
            d && (b.stream.segmentIndex && (b.Ba = b.stream.segmentIndex.ec(e, !1, a)), f = b.Ba && b.Ba.next().value);
            f || (b.stream.segmentIndex && (b.Ba = b.stream.segmentIndex.ec(c, !1, a)), f = b.Ba && b.Ba.next().value);
            return f;
        }
        function pn(a, b, c, d, e) {
            var f, g, h, k, l, m, n, q, r, t, w, v, z, y, A, C, E, D;
            return Q(function(B) {
                switch(B.g){
                    case 1:
                        f = uc;
                        g = b.stream;
                        h = b.Ba;
                        b.Ra = !0;
                        ra(B, 2);
                        if (d.Uc() == 2) throw new U(1, 1, 1011);
                        return F(B, rn(a, b, d, e), 4);
                    case 4:
                        ih(a.l);
                        if (a.D) return B.return();
                        k = g.mimeType == "video/mp4" || g.mimeType == "audio/mp4";
                        l = window1.ReadableStream;
                        if ((m = a.i.lowLatencyMode && a.j.isLowLatency) && l && k && (a.j.type != "HLS" || d.m)) return r = new Uint8Array(0), w = t = !1, z = function(G) {
                            var I, J, L, K;
                            return Q(function(N) {
                                switch(N.g){
                                    case 1:
                                        if (t) return N.return();
                                        w = !0;
                                        ih(a.l);
                                        if (a.D) return N.return();
                                        ra(N, 2);
                                        r = lc(r, G);
                                        I = !1;
                                        J = 0;
                                        (new oh).box("mdat", function(P) {
                                            J = P.size + P.start;
                                            I = !0;
                                        }).parse(r, !1, !0);
                                        if (!I) {
                                            N.B(4);
                                            break;
                                        }
                                        L = r.subarray(0, J);
                                        r = r.subarray(J);
                                        return F(N, sn(a, b, c, g, d, L, !0, e), 5);
                                    case 5:
                                        b.ka && b.Ba && rm(b.ka, d.startTime, !0);
                                    case 4:
                                        ta(N, 0);
                                        break;
                                    case 2:
                                        v = K = ua(N), H(N);
                                }
                            });
                        }, F(B, tn(a, b, d, z), 9);
                        n = tn(a, b, d);
                        return F(B, n, 7);
                    case 7:
                        q = B.h;
                        ih(a.l);
                        if (a.D) return B.return();
                        ih(a.l);
                        return b.uc ? (b.Ra = !1, Sm(a, b, 0), B.return()) : F(B, sn(a, b, c, g, d, q, !1, e), 6);
                    case 9:
                        y = B.h;
                        if (v) throw v;
                        if (w) {
                            B.B(10);
                            break;
                        }
                        t = !0;
                        ih(a.l);
                        return a.D ? B.return() : b.uc ? (b.Ra = !1, Sm(a, b, 0), B.return()) : F(B, sn(a, b, c, g, d, y, !1, e), 10);
                    case 10:
                        b.ka && b.Ba && rm(b.ka, d.startTime, !0);
                    case 6:
                        ih(a.l);
                        if (a.D) return B.return();
                        b.Ua = d;
                        h.next();
                        b.Ra = !1;
                        b.Th = !1;
                        A = a.g.ha.Pc();
                        C = A[b.type];
                        eb(JSON.stringify(C));
                        b.uc || (E = null, b.type === f.Ia ? E = a.h.get(f.na) : b.type === f.na && (E = a.h.get(f.Ia)), E && E.type == f.na ? a.g.Sf(d, b.stream, E.stream.isAudioMuxedInVideo) : a.g.Sf(d, b.stream, b.stream.codecs.includes(",")));
                        Km(b);
                        Sm(a, b, 0);
                        ta(B, 0);
                        break;
                    case 2:
                        D = ua(B);
                        ih(a.l, D);
                        if (a.D) return B.return();
                        b.Ra = !1;
                        if (D.code == 7001) b.Ra = !1, Km(b), Sm(a, b, 0), B.B(0);
                        else if (b.type == f.Va && a.i.ignoreTextStreamFailures) a.h.delete(f.Va), B.B(0);
                        else {
                            if (D.code == 3017) return F(B, un(a, b, D), 0);
                            b.qe = !0;
                            D.category == 1 && b.ka && xm(b.ka, d);
                            D.severity = 2;
                            return F(B, jn(a, b, D), 0);
                        }
                }
            });
        }
        function qn(a, b, c, d) {
            var e, f, g, h, k, l, m, n, q, r, t;
            return Q(function(w) {
                switch(w.g){
                    case 1:
                        e = b.stream;
                        for(h = (g = (f = e.segmentIndex) && f.ec(c)) && g.next().value; h && a.O.includes(h.startTime);)h = g && g.next().value;
                        if (!h) {
                            w.B(0);
                            break;
                        }
                        k = h.ia;
                        if (!k || xj(k, b.yb)) {
                            w.B(3);
                            break;
                        }
                        b.yb = k;
                        ra(w, 4);
                        return F(w, tn(a, b, k), 6);
                    case 6:
                        l = w.h;
                        var v = a.g.ha;
                        v.H && dd(v.H, l, 0, e);
                        a.O = [];
                        ta(w, 3);
                        break;
                    case 4:
                        throw m = ua(w), b.yb = null, m;
                    case 3:
                        if (b.Ua && b.Ua == h) {
                            w.B(0);
                            break;
                        }
                        b.Ua = h;
                        ra(w, 8);
                        return F(w, tn(a, b, h), 10);
                    case 10:
                        n = w.h;
                        v = a.g.ha;
                        v.H && dd(v.H, n, 0, e);
                        a.O.push(h.startTime);
                        ta(w, 9);
                        break;
                    case 8:
                        throw q = ua(w), b.Ua = null, q;
                    case 9:
                        r = Math.max.apply(Math, [
                            0
                        ].concat(x(a.O)));
                        t = a.g.Rc();
                        if (t + d > r) return F(w, qn(a, b, h.startTime, d), 0);
                        w.B(0);
                }
            });
        }
        function un(a, b, c) {
            var d, e, f, g, h, k;
            return Q(function(l) {
                if (l.g == 1) {
                    d = Array.from(a.h.values());
                    if (e = d.some(function(m) {
                        return m != b && m.Th;
                    })) return l.B(2);
                    f = a.i.maxDisabledTime === 0 && c.code == 1011 ? 1 : a.i.maxDisabledTime;
                    if (g = a.g.disableStream(b.stream, f)) return l.return();
                    if (a.i.avoidEvictionOnQuotaExceededError) return Sm(a, b, 4), l.return();
                    h = Math.round(100 * a.F);
                    if (h > 20) a.F -= .2;
                    else if (h > 4) a.F -= .04;
                    else return b.qe = !0, a.D = !0, a.g.onError(c), l.return();
                    b.Th = !0;
                    k = a.g.Rc();
                    return F(l, vn(a, b, k), 2);
                }
                Sm(a, b, 4);
                H(l);
            });
        }
        function rn(a, b, c, d) {
            var e, f, g, h, k, l, m, n, q, r, t, w, v, z, y, A;
            return Q(function(C) {
                switch(C.g){
                    case 1:
                        e = uc;
                        f = b.Ua == null;
                        g = [];
                        h = Math.max(0, Math.max(c.appendWindowStart, a.Y) - .1);
                        k = Math.min(c.appendWindowEnd, a.X) + .1;
                        l = c.codecs || b.stream.codecs;
                        m = lf(l);
                        n = mf(c.mimeType || b.stream.mimeType);
                        q = c.timestampOffset;
                        if (q == b.If && h == b.Ac && k == b.zc && m == b.Gf && n == b.Hf) {
                            C.B(2);
                            break;
                        }
                        r = b.Gf && b.Hf && pl(a.g.ha, b.type, n, l, fn(a));
                        if (!r) {
                            C.B(3);
                            break;
                        }
                        t = null;
                        b.type === e.Ia ? t = a.h.get(e.na) : b.type === e.na && (t = a.h.get(e.Ia));
                        if (!t) {
                            C.B(3);
                            break;
                        }
                        return F(C, Lm(t).catch(function() {}), 5);
                    case 5:
                        t.yb = null, t.Ac = null, t.zc = null, an(a, t);
                    case 3:
                        return F(C, wn(a, b, q, h, k, c, m, n), 2);
                    case 2:
                        return xj(c.ia, b.yb) || (b.yb = c.ia, c.l && c.ia && (w = tn(a, b, c.ia), v = function() {
                            var E, D, B, G, I, J, L, K, N, P, O;
                            return Q(function(M) {
                                switch(M.g){
                                    case 1:
                                        return ra(M, 2), F(M, w, 4);
                                    case 4:
                                        return E = M.h, ih(a.l), D = null, B = new Map, G = {
                                            projection: null,
                                            hfov: null
                                        }, b.stream && (I = b.stream.videoLayout) && (J = I.split("/"), J.includes("PROJ-RECT") ? G.projection = "rect" : J.includes("PROJ-EQUI") ? G.projection = "equi" : J.includes("PROJ-HEQU") ? G.projection = "hequ" : J.includes("PROJ-PRIM") ? G.projection = "prim" : J.includes("PROJ-AIV") && (G.projection = "hequ")), L = new oh, L.box("moov", th).box("trak", th).box("mdia", th).W("mdhd", function(R) {
                                            D = Ki(R.reader, R.version).timescale;
                                        }).box("hdlr", function(R) {
                                            R = R.reader;
                                            R.skip(8);
                                            switch(R.od()){
                                                case "soun":
                                                    B.set(e.na, D);
                                                    break;
                                                case "vide":
                                                    B.set(e.Ia, D);
                                            }
                                            D = null;
                                        }), b.type !== e.Ia || G.projection || L.box("minf", th).box("stbl", th).W("stsd", vh).box("encv", wh).box("avc1", wh).box("avc3", wh).box("hev1", wh).box("hvc1", wh).box("dvav", wh).box("dva1", wh).box("dvh1", wh).box("dvhe", wh).box("dvc1", wh).box("dvi1", wh).box("vexu", th).box("proj", th).W("prji", function(R) {
                                            R = R.reader.od();
                                            G.projection = R;
                                        }).box("hfov", function(R) {
                                            R = R.reader.Z() / 1E3;
                                            G.hfov = R;
                                        }), L.parse(E, !0, !0), b.type === e.Ia && xn(a, G), B.has(b.type) ? c.ia.timescale = B.get(b.type) : D != null && (c.ia.timescale = D), K = b.stream.segmentIndex, K instanceof $l && (N = bm(K, c.startTime)), P = b.stream.closedCaptions && b.stream.closedCaptions.size > 0, F(M, a.g.Ji(b.type, E), 5);
                                    case 5:
                                        return F(M, Pk(a.g.ha, b.type, E, null, b.stream, P, b.rd, d, !1, !1, N), 6);
                                    case 6:
                                        ta(M, 0);
                                        break;
                                    case 2:
                                        throw O = ua(M), b.yb = null, O;
                                }
                            });
                        }, z = c.startTime, f && (y = Mk(a.g.ha, b.type), y != null && (z = y)), a.g.Vl(z, c.ia), g.push(v()))), A = b.Ua ? b.Ua.i : -1, c.i != A && g.push(al(a.g.ha, b.type, c.startTime)), F(C, Promise.all(g), 0);
                }
            });
        }
        function wn(a, b, c, d, e, f, g, h) {
            var k, l, m, n, q;
            return Q(function(r) {
                switch(r.g){
                    case 1:
                        k = uc;
                        l = fn(a);
                        ra(r, 2);
                        b.Ac = d;
                        b.zc = e;
                        g && (b.Gf = g);
                        h && (b.Hf = h);
                        b.If = c;
                        m = a.j.sequenceMode || a.j.type == "HLS";
                        n = null;
                        b.type === k.Ia ? n = a.h.get(k.na) : b.type === k.na && (n = a.h.get(k.Ia));
                        if (!(n && n.stream && n.stream.isAudioMuxedInVideo)) {
                            r.B(4);
                            break;
                        }
                        return F(r, Yk(a.g.ha, n.type, c, d, e, m, n.stream.mimeType, n.stream.codecs, l), 4);
                    case 4:
                        return F(r, Yk(a.g.ha, b.type, c, d, e, m, f.mimeType || b.stream.mimeType, f.codecs || b.stream.codecs, l), 6);
                    case 6:
                        ta(r, 0);
                        break;
                    case 2:
                        throw q = ua(r), b.Ac = null, b.zc = null, b.Gf = null, b.Hf = null, b.If = null, q;
                }
            });
        }
        function sn(a, b, c, d, e, f, g, h) {
            g = g === void 0 ? !1 : g;
            h = h === void 0 ? !1 : h;
            var k, l, m, n, q;
            return Q(function(r) {
                switch(r.g){
                    case 1:
                        return k = d.closedCaptions && d.closedCaptions.size > 0, a.i.shouldFixTimestampOffset && (l = d.mimeType == "video/mp4" || d.mimeType == "audio/mp4", m = null, e.ia && (m = e.ia.timescale), (n = l && m && d.type === "video" && a.j.type == "DASH") && (new oh).box("moof", th).box("traf", th).W("tfdt", function(t) {
                            var w, v, z, y, A, C;
                            return Q(function(E) {
                                w = Ji(t.reader, t.version);
                                v = w.baseMediaDecodeTime;
                                if (!v) return E.return();
                                z = -v / m;
                                y = Number(b.If) || 0;
                                if (!(y < z)) return E.B(0);
                                A = b.Ac;
                                C = b.zc;
                                return F(E, wn(a, b, z, A, C, e), 0);
                            });
                        }).parse(f, !1, g)), F(r, vn(a, b, c), 2);
                    case 2:
                        return ih(a.l), q = b.rd, b.rd = !1, F(r, a.g.Ji(b.type, f), 3);
                    case 3:
                        return F(r, Pk(a.g.ha, b.type, f, e, d, k, q, h, g), 4);
                    case 4:
                        ih(a.l), H(r);
                }
            });
        }
        function vn(a, b, c) {
            var d, e, f, g, h, k, l, m, n;
            return Q(function(q) {
                if (q.g == 1) {
                    d = b.stream.segmentIndex;
                    d instanceof $l && (d.cb(a.j.presentationTimeline.Nb()), e = [], am(d, function(r) {
                        e.push(r.nf());
                    }));
                    f = Math.max(a.i.bufferBehind * a.F, a.j.presentationTimeline.h);
                    g = Kk(a.g.ha, b.type);
                    if (g == null) return a.H == b && (a.H = null), q.return();
                    h = c - g;
                    k = a.i.evictionGoal;
                    l = a.j.presentationTimeline.fc();
                    m = a.j.presentationTimeline.Mb();
                    n = h - f;
                    m - l > k && (n = Math.max(h - f, l - k - g));
                    return n <= k ? q.return() : F(q, a.g.ha.remove(b.type, g, g + n, e), 2);
                }
                if (q.g != 4) return ih(a.l), a.H ? F(q, vn(a, a.H, c), 4) : q.B(0);
                ih(a.l);
                H(q);
            });
        }
        function ln(a) {
            return a && a.type == sc && (a.stream.mimeType == "application/cea-608" || a.stream.mimeType == "application/cea-708");
        }
        function tn(a, b, c, d) {
            var e, f, g, h, k;
            return Q(function(l) {
                switch(l.g){
                    case 1:
                        if (e = c.hc()) return l.return(e);
                        f = null;
                        if (b.ka) {
                            var m = b.ka, n = m.h;
                            c instanceof wj && (n = m.j);
                            n.has(c) ? (m = n.get(c), d && (m.ni = d), f = m.Ce) : f = null;
                        }
                        f || (f = gn(c, b.stream, d || null, a.i.retryParameters, a.g.Dc));
                        g = 0;
                        b.Ba && (g = b.Ba.h);
                        b.$a = f;
                        return F(l, f.promise, 2);
                    case 2:
                        h = l.h;
                        b.$a = null;
                        k = h.data;
                        if (!c.aesKey) {
                            l.B(3);
                            break;
                        }
                        return F(l, Gm(k, c.aesKey, g), 4);
                    case 4:
                        k = l.h;
                    case 3:
                        return l.return(k);
                }
            });
        }
        function gn(a, b, c, d, e, f) {
            f = f === void 0 ? !1 : f;
            var g = a instanceof yj ? a : void 0, h = g ? 1 : 0;
            a = Hm(a.T(), a.startByte, a.endByte, d, c);
            a.contentType = b.type;
            return e.request(fh, a, {
                type: h,
                stream: b,
                segment: g,
                isPreload: f
            });
        }
        function cn(a, b, c, d) {
            var e, f;
            return Q(function(g) {
                if (g.g == 1) return b.uc = !1, b.ae = !1, b.Cd = 0, b.dc = !0, b.Ua = null, b.Ba = null, b.ka && !a.m.has(b.stream) && ym(b.ka), d ? (e = a.g.Rc(), f = a.g.ha.getDuration(), F(g, a.g.ha.remove(b.type, e + d, f), 3)) : F(g, Xk(a.g.ha, b.type), 4);
                if (g.g != 3) return ih(a.l), c ? F(g, a.g.ha.flush(b.type), 3) : g.B(3);
                ih(a.l);
                b.dc = !1;
                b.endOfStream = !1;
                b.Ra || b.Ab || Sm(a, b, 0);
                H(g);
            });
        }
        function Sm(a, b, c) {
            var d = b.type;
            if (d != sc || a.h.has(d)) b.Ab = new Af(function() {
                var e;
                return Q(function(f) {
                    if (f.g == 1) return ra(f, 2), F(f, hn(a, b), 4);
                    if (f.g != 2) return ta(f, 0);
                    e = ua(f);
                    if (a.g) a.g.onError(e);
                    H(f);
                });
            }).$(c);
        }
        function Km(a) {
            a.Ab != null && (a.Ab.stop(), a.Ab = null);
        }
        function Lm(a) {
            return Q(function(b) {
                return a.$a ? F(b, a.$a.abort(), 0) : b.B(0);
            });
        }
        function jn(a, b, c) {
            var d;
            return Q(function(e) {
                if (e.g == 1) return c.code == 3024 ? (b.Ra = !1, Km(b), Sm(a, b, 0), e.return()) : F(e, Gg(a.V), 2);
                ih(a.l);
                if (c.category === 1 && c.code != 1003) {
                    if (b.Yc) return Um(a, !1), e.return();
                    d = a.i.maxDisabledTime === 0 && c.code == 1011 ? 1 : a.i.maxDisabledTime;
                    c.handled = a.g.disableStream(b.stream, d);
                    c.handled && (c.severity = 1);
                }
                if (!c.handled || c.code != 1011) a.g.onError(c);
                c.handled || a.i.failureCallback(c);
                H(e);
            });
        }
        function mn(a, b) {
            b = b === void 0 ? !1 : b;
            var c, d, e, f, g, h;
            return Q(function(k) {
                if (k.g == 1) {
                    c = Date.now() / 1E3;
                    d = a.i.minTimeBetweenRecoveries;
                    if (!b) {
                        if (!a.i.allowMediaSourceRecoveries || c - a.P < d) return k.return(!1);
                        a.P = c;
                    }
                    e = uc;
                    if (f = a.h.get(e.na)) Km(f), f.$a && (f.$a.abort(), f.$a = null), f.yb = null, f.Ac = null, f.zc = null, f.Ra = !1, f.uc = !1, f.Cd = 0, f.ae = !1, f.dc = !1, f.Ba && f.Ba.Wh();
                    if (g = a.h.get(e.Ia)) Km(g), g.$a && (g.$a.abort(), g.$a = null), g.yb = null, g.Ac = null, g.zc = null, g.Ra = !1, g.uc = !1, g.Cd = 0, g.ae = !1, g.dc = !1, g.Ba && g.Ba.Wh();
                    h = a.g.video.paused;
                    return F(k, jl(a.g.ha, fn(a)), 2);
                }
                !g || g.dc || g.Ra || g.Ab || Sm(a, g, 0);
                !f || f.dc || f.Ra || f.Ab || Sm(a, f, 0);
                h || a.g.video.play();
                return k.return(!0);
            });
        }
        function xn(a, b) {
            if (a.R.projection != b.projection || a.R.hfov != b.hfov) {
                if (b.projection != null || b.hfov != null) {
                    var c = (new Map).set("detail", b);
                    c = new T("spatialvideoinfo", c);
                } else c = new T("nospatialvideoinfo");
                c.cancelable = !0;
                a.g.onEvent(c);
                a.R = b;
            }
        }
        function dn(a) {
            if (a.i.crossBoundaryStrategy !== "keep") return !0;
            var b = Rb();
            if (!id() || !b.bd()) {
                b = u(a.h.keys());
                for(var c = b.next(); !c.done; c = b.next())if (c = a.h.get(c.value), c.type !== uc.Va && (c = c.stream) && c.fullMimeTypes && c.fullMimeTypes.size > 1) return !0;
            } else if (!b.lg()) {
                for(b = u(a.h.keys()), c = b.next(); !c.done; c = b.next())if (c = a.h.get(c.value), c.type !== uc.Va && (c = c.stream) && c.fullMimeTypes && c.fullMimeTypes.size > 1) {
                    a = new Set;
                    b = u(c.fullMimeTypes);
                    for(c = b.next(); !c.done; c = b.next())a.add(hf(c.value));
                    return a.size > 1;
                }
            }
            return !1;
        }
        function $m(a) {
            a.G.Sa();
            dn(a) && (a.G.o(a.g.video, "waiting", function() {
                return en(a);
            }), a.G.o(a.g.video, "timeupdate", function() {
                return en(a);
            }));
        }
        function en(a) {
            if (dn(a)) {
                a.K.stop();
                var b = a.g.Rc(), c = a.h.get("video") || a.h.get("audio");
                c && (c = c.yb) && c.g !== null && (b = c.g - b, b < 0 || b > 1 || (a.I = c.g + .1, a.K.$(b)));
            }
        }
        function on(a, b, c) {
            if (b.type === sc) return !1;
            var d = b.yb;
            if (!d) return !1;
            var e = c.ia;
            c = d.g !== e.g;
            a.i.crossBoundaryStrategy === "reset_to_encrypted" && (d.encrypted || e.encrypted || (c = !1), d.encrypted && (a.i.crossBoundaryStrategy = "keep"));
            a.i.crossBoundaryStrategy === "RESET_ON_ENCRYPTION_CHANGE" && d.encrypted == e.encrypted && (c = !1);
            if (a.i.crossBoundaryStrategy === "keep" && d.mimeType && e.mimeType) {
                var f = jf(nf(d.mimeType)), g = jf(nf(d.mimeType));
                d.mimeType == e.mimeType && f == g && (c = !1);
            }
            c && (a.J || b.rd) && (a.J = !1, mn(a, !0).then(function() {
                var h = (new Map).set("oldEncrypted", d.encrypted).set("newEncrypted", e.encrypted);
                a.g.onEvent(new T("boundarycrossed", h));
            }));
            return c;
        }
        function fn(a, b) {
            function c(f) {
                if (f.fullMimeTypes && f.fullMimeTypes.size > 1 && a.h.has(f.type)) {
                    var g = a.h.get(f.type), h = Mk(a.g.ha, g.type), k = a.g.Rc();
                    (g = nn(a, g, k, h)) && g.codecs && g.mimeType && (f.codecs = g.codecs, f.mimeType = g.mimeType);
                }
            }
            b = b === void 0 ? !1 : b;
            var d = new Map, e = a.u.audio;
            e && (c(e), d.set("audio", e));
            if (e = a.u.video) c(e), d.set("video", e);
            b && a.C && d.set(sc, a.C);
            return d;
        }
        function yn() {}
        function zn(a, b, c, d, e) {
            var f = e in d;
            var g = f ? c.constructor == Object && Object.keys(d).length == 0 : c.constructor == Object && Object.keys(c).length == 0;
            var h = f || g, k = !0, l;
            for(l in b){
                var m = e + "." + l, n = f ? d[e] : c[l];
                h || l in c ? b[l] === void 0 ? n === void 0 || h ? delete a[l] : a[l] = Gd(n) : g ? a[l] = b[l] : n.constructor == Object && b[l] && b[l].constructor == Object ? (a[l] || (a[l] = Gd(n)), m = zn(a[l], b[l], n, d, m), k = k && m) : typeof b[l] != typeof n || b[l] == null || typeof b[l] != "function" && b[l].constructor != n.constructor ? ($a("Invalid config, wrong type for " + m), k = !1) : typeof c[l] == "function" && c[l].length != b[l].length ? (ab("Unexpected number of arguments for " + m), a[l] = b[l]) : a[l] = Array.isArray(a[l]) ? b[l].slice() : b[l] : ($a("Invalid config, unrecognized key " + m), k = !1);
            }
            return k;
        }
        function An(a, b) {
            for(var c = {}, d = c, e = 0, f = 0;;){
                e = a.indexOf(".", e);
                if (e < 0) break;
                if (e == 0 || a[e - 1] != "\\") f = a.substring(f, e).replace(/\\\./g, "."), d[f] = {}, d = d[f], f = e + 1;
                e += 1;
            }
            d[a.substring(f).replace(/\\\./g, ".")] = b;
            return c;
        }
        function Bn(a, b) {
            return a && b;
        }
        function Cn(a, b) {
            function c(f) {
                for(var g = u(Object.keys(f)), h = g.next(); !h.done; h = g.next())if (h = h.value, !(f[h] instanceof HTMLElement)) {
                    if (e(f[h]) && Object.keys(f[h]).length === 0) delete f[h];
                    else {
                        var k = f[h];
                        Array.isArray(k) && k.length === 0 ? delete f[h] : typeof f[h] == "function" ? delete f[h] : e(f[h]) && (c(f[h]), Object.keys(f[h]).length === 0 && delete f[h]);
                    }
                }
            }
            function d(f, g) {
                return Object.keys(f).reduce(function(h, k) {
                    var l = f[k];
                    if (g.hasOwnProperty(k)) {
                        if (l instanceof HTMLElement && g[k] instanceof HTMLElement) l.isEqualNode(g[k]) || (h[k] = l);
                        else if (e(l) && e(g[k])) {
                            if (l = d(l, g[k]), Object.keys(l).length > 0 || !e(l)) h[k] = l;
                        } else Array.isArray(l) && Array.isArray(g[k]) ? Rc(l, g[k]) || (h[k] = l) : Number.isNaN(l) && Number.isNaN(g[k]) || l !== g[k] && (h[k] = l);
                    } else h[k] = l;
                    return h;
                }, {});
            }
            function e(f) {
                return f && typeof f === "object" && !Array.isArray(f);
            }
            a = d(a, b);
            c(a);
            return a;
        }
        S("shaka.util.ConfigUtils", yn);
        yn.getDifferenceFromConfigObjects = Cn;
        yn.convertToConfigObject = An;
        yn.mergeConfigObjects = zn;
        S("shaka.config.RepeatMode", {
            OFF: 0,
            ALL: 1,
            SINGLE: 2
        });
        function Dn() {}
        function En(a) {
            a = Zb(a);
            return new qb(a).Jb;
        }
        function Fn(a, b, c) {
            function d(h) {
                Ob(f).setUint32(g, h.byteLength, !0);
                g += 4;
                f.set(Kb(h), g);
                g += h.byteLength;
            }
            if (!c || !c.byteLength) throw new U(2, 6, 6015);
            var e;
            typeof b == "string" ? e = ac(b, !0) : e = b;
            a = Zb(a);
            a = ac(a, !0);
            var f = new Uint8Array(12 + a.byteLength + e.byteLength + c.byteLength), g = 0;
            d(a);
            d(e);
            d(c);
            return f;
        }
        function Gn(a, b, c) {
            if (b !== "skd") return a;
            b = c.serverCertificate;
            c = Zb(a).split("skd://").pop();
            return Fn(a, c, b);
        }
        function Hn(a, b) {
            a === 2 && (a = b.drmInfo) && Bg(a.keySystem) && (b.headers["Content-Type"] = "application/octet-stream");
        }
        S("shaka.drm.FairPlay", Dn);
        Dn.commonFairPlayResponse = function(a, b) {
            if (a === 2 && (a = b.originalRequest.drmInfo) && Bg(a.keySystem)) {
                try {
                    var c = Wb(b.data);
                } catch (e) {
                    return;
                }
                a = !1;
                c = c.trim();
                c.substr(0, 5) === "<ckc>" && c.substr(-6) === "</ckc>" && (c = c.slice(5, -6), a = !0);
                if (!a) try {
                    var d = JSON.parse(c);
                    d.ckc && (c = d.ckc, a = !0);
                    d.CkcMessage && (c = d.CkcMessage, a = !0);
                    d.License && (c = d.License, a = !0);
                } catch (e) {}
                a && (b.data = Lb(hc(c)));
            }
        };
        Dn.muxFairPlayRequest = function(a, b) {
            Hn(a, b);
        };
        Dn.expressplayFairPlayRequest = function(a, b) {
            if (a === 2) {
                var c = b.drmInfo;
                c && Bg(c.keySystem) && Hn(a, b);
            }
        };
        Dn.conaxFairPlayRequest = function(a, b) {
            Hn(a, b);
        };
        Dn.ezdrmFairPlayRequest = function(a, b) {
            Hn(a, b);
        };
        Dn.verimatrixFairPlayRequest = function(a, b) {
            a === 2 && (a = b.drmInfo) && Bg(a.keySystem) && (a = Kb(b.body), a = fc(a), b.headers["Content-Type"] = "application/x-www-form-urlencoded", b.body = $b("spc=" + a));
        };
        Dn.muxInitDataTransform = function(a, b, c) {
            return Gn(a, b, c);
        };
        Dn.expressplayInitDataTransform = function(a, b, c) {
            return Gn(a, b, c);
        };
        Dn.conaxInitDataTransform = function(a, b, c) {
            if (b !== "skd") return a;
            b = c.serverCertificate;
            c = Zb(a).split("skd://").pop().split("?").shift();
            c = window1.atob(c);
            var d = new ArrayBuffer(c.length * 2);
            d = Nb(d);
            for(var e = 0, f = c.length; e < f; e++)d[e] = c.charCodeAt(e);
            return Fn(a, d, b);
        };
        Dn.ezdrmInitDataTransform = function(a, b, c) {
            if (b !== "skd") return a;
            b = c.serverCertificate;
            c = Zb(a).split(";").pop();
            return Fn(a, c, b);
        };
        Dn.verimatrixInitDataTransform = function(a, b, c) {
            return Gn(a, b, c);
        };
        Dn.initDataTransform = Fn;
        Dn.defaultGetContentId = En;
        Dn.isFairPlaySupported = function() {
            var a;
            return Q(function(b) {
                if (b.g == 1) return a = {
                    initDataTypes: [
                        "cenc",
                        "sinf",
                        "skd"
                    ],
                    videoCapabilities: [
                        {
                            contentType: 'video/mp4; codecs="avc1.42E01E"'
                        }
                    ]
                }, ra(b, 2), F(b, navigator.requestMediaKeySystemAccess("com.apple.fps", [
                    a
                ]), 4);
                if (b.g != 2) return b.return(!0);
                ua(b);
                return b.return(!1);
            });
        };
        function In(a, b, c) {
            c = c === void 0 ? !0 : c;
            this.h = a;
            this.g = new Set([
                a
            ]);
            b = b || [];
            a = u(b);
            for(b = a.next(); !b.done; b = a.next())this.add(b.value, c);
        }
        In.prototype.add = function(a, b) {
            var c = this.h;
            b = b === void 0 ? !0 : b;
            var d;
            if (!(d = !!c.audio != !!a.audio || !!c.video != !!a.video || c.language != a.language) && (d = c.audio && a.audio)) {
                d = c.audio;
                var e = a.audio;
                d = !(!((!d.channelsCount || !e.channelsCount || d.channelsCount > 2 || e.channelsCount > 2) && d.channelsCount != e.channelsCount || d.spatialAudio !== e.spatialAudio || b && !Jn(d, e)) && Kn(d.roles, e.roles) && d.groupId === e.groupId);
            }
            !d && (d = c.video && a.video) && (c = c.video, d = a.video, d = !((!b || Jn(c, d)) && Kn(c.roles, d.roles)));
            return d ? !1 : (this.g.add(a), !0);
        };
        In.prototype.values = function() {
            return this.g.values();
        };
        function Jn(a, b) {
            if (a.mimeType != b.mimeType) return !1;
            a = a.codecs.split(",").map(function(d) {
                return lf(d);
            });
            b = b.codecs.split(",").map(function(d) {
                return lf(d);
            });
            if (a.length != b.length) return !1;
            a.sort();
            b.sort();
            for(var c = 0; c < a.length; c++)if (a[c] != b[c]) return !1;
            return !0;
        }
        function Kn(a, b) {
            a = new Set(a);
            b = new Set(b);
            a.delete("main");
            b.delete("main");
            if (a.size != b.size) return !1;
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next())if (!b.has(c.value)) return !1;
            return !0;
        }
        S("shaka.media.AdaptationSet", In);
        function Ln() {
            this.g = null;
        }
        Ln.prototype.configure = function(a) {
            this.g = a;
        };
        Ln.prototype.getConfiguration = function() {
            return this.g;
        };
        Ln.prototype.create = function(a) {
            var b;
            if (this.g.language) {
                var c = Mn(a, this.g.language);
                c.length && (b = c);
            }
            b || (b = a.filter(function(f) {
                return f.primary;
            }), b = b.length ? b : a);
            a = Nn(b, this.g.role);
            a.length && (b = a);
            a = On(b, this.g.videoRole);
            a.length && (b = a);
            this.g.videoLayout && (a = Pn(b, this.g.videoLayout), a.length && (b = a));
            this.g.hdrLevel && (a = Qn(b, this.g.hdrLevel), a.length && (b = a));
            var d = [
                this.g.channelCount,
                this.g.preferredAudioChannelCount
            ];
            a = d.filter(function(f, g) {
                return f && d.indexOf(f) === g;
            });
            if (a.length) {
                for(a = u(a), c = a.next(); !c.done; c = a.next())if (c = Rn(b, c.value), c.length) {
                    b = c;
                    break;
                }
            }
            this.g.audioLabel && (a = Sn(b, this.g.audioLabel), a.length && (b = a));
            this.g.videoLabel && (a = Tn(b, this.g.videoLabel), a.length && (b = a));
            a = Un(b, this.g.spatialAudio);
            a.length && (b = a);
            var e = [
                this.g.audioCodec,
                this.g.activeAudioCodec
            ].concat(x(this.g.preferredAudioCodecs));
            a = e.filter(function(f, g) {
                return f && e.indexOf(f) === g;
            });
            if (a.length) {
                for(a = u(a), c = a.next(); !c.done; c = a.next())if (c = Vn(b, c.value), c.length) {
                    b = c;
                    break;
                }
            }
            return new In(b[0], b, !(this.g.codecSwitchingStrategy == "smooth" && id()));
        };
        function Mn(a, b) {
            b = yc(b);
            var c = Gc(b, a.map(function(d) {
                return Fc(d);
            }));
            return c ? a.filter(function(d) {
                return c == Fc(d);
            }) : [];
        }
        function Nn(a, b) {
            return a.filter(function(c) {
                return c.audio ? b ? c.audio.roles.includes(b) : c.audio.roles.length == 0 : !1;
            });
        }
        function On(a, b) {
            return a.filter(function(c) {
                return c.video ? b ? c.video.roles.includes(b) : c.video.roles.length == 0 : !1;
            });
        }
        function Sn(a, b) {
            return a.filter(function(c) {
                return c.audio && c.audio.label ? c.audio.label.toLowerCase() == b.toLowerCase() : !1;
            });
        }
        function Tn(a, b) {
            return a.filter(function(c) {
                return c.video && c.video.label ? c.video.label.toLowerCase() == b.toLowerCase() : !1;
            });
        }
        function Rn(a, b) {
            return a.filter(function(c) {
                return c.audio && c.audio.channelsCount && c.audio.channelsCount > b ? !1 : !0;
            }).sort(function(c, d) {
                return c.audio || d.audio ? c.audio ? d.audio ? (d.audio.channelsCount || 0) - (c.audio.channelsCount || 0) : 1 : -1 : 0;
            });
        }
        function Qn(a, b) {
            if (b == "AUTO") {
                var c = a.some(function(d) {
                    return d.video && d.video.hdr && d.video.hdr == "HLG" ? !0 : !1;
                });
                b = Rb().Id(c);
            }
            return a.filter(function(d) {
                return d.video && d.video.hdr && d.video.hdr != b ? !1 : !0;
            });
        }
        function Pn(a, b) {
            return a.filter(function(c) {
                return c.video && c.video.videoLayout && c.video.videoLayout != b ? !1 : !0;
            });
        }
        function Un(a, b) {
            return a.filter(function(c) {
                return c.audio && c.audio.spatialAudio != b ? !1 : !0;
            });
        }
        function Vn(a, b) {
            return a.filter(function(c) {
                return c.audio && c.audio.codecs != b ? !1 : !0;
            });
        }
        function Wn() {}
        function Xn() {
            var a = Infinity, b = Rb();
            navigator.connection && navigator.connection.saveData && (a = 360);
            var c = {
                retryParameters: Fg(),
                servers: {},
                clearKeys: {},
                advanced: {},
                delayLicenseRequestUntilPlayed: !1,
                persistentSessionOnlinePlayback: !1,
                persistentSessionsMetadata: [],
                initDataTransform: function(h, k, l) {
                    "apple" === window1.shakaMediaKeysPolyfill && k == "skd" && (k = l.serverCertificate, l = En(h), h = Fn(h, l, k));
                    return h;
                },
                logLicenseExchange: !1,
                updateExpirationTime: 1,
                preferredKeySystems: [],
                keySystemsMapping: {},
                parseInbandPsshEnabled: !1,
                minHdcpVersion: "",
                ignoreDuplicateInitData: !0,
                defaultAudioRobustnessForWidevine: "SW_SECURE_CRYPTO",
                defaultVideoRobustnessForWidevine: "SW_SECURE_DECODE"
            }, d = "reload";
            id() && b.bd() && (d = "smooth");
            var e = {
                retryParameters: Fg(),
                availabilityWindowOverride: NaN,
                disableAudio: !1,
                disableVideo: !1,
                disableText: !1,
                disableThumbnails: !1,
                disableIFrames: !1,
                defaultPresentationDelay: 0,
                segmentRelativeVttTiming: !1,
                raiseFatalErrorOnManifestUpdateRequestFailure: !1,
                continueLoadingWhenPaused: !0,
                ignoreSupplementalCodecs: !1,
                updatePeriod: -1,
                ignoreDrmInfo: !1,
                enableAudioGroups: !0,
                dash: {
                    clockSyncUri: "",
                    disableXlinkProcessing: !0,
                    xlinkFailGracefully: !1,
                    ignoreMinBufferTime: !1,
                    autoCorrectDrift: !0,
                    initialSegmentLimit: 1E3,
                    ignoreSuggestedPresentationDelay: !1,
                    ignoreEmptyAdaptationSet: !1,
                    ignoreMaxSegmentDuration: !1,
                    keySystemsByURI: {
                        "urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b": "org.w3.clearkey",
                        "urn:uuid:e2719d58-a985-b3c9-781a-b030af78d30e": "org.w3.clearkey",
                        "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed": "com.widevine.alpha",
                        "urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95": "com.microsoft.playready",
                        "urn:uuid:79f0049a-4098-8642-ab92-e65be0885f95": "com.microsoft.playready",
                        "urn:uuid:94ce86fb-07ff-4f43-adb8-93d2fa968ca2": "com.apple.fps",
                        "urn:uuid:3d5e6d35-9b9a-41e8-b843-dd3c6e72c42c": "com.huawei.wiseplay"
                    },
                    manifestPreprocessor: Yn,
                    manifestPreprocessorTXml: Zn,
                    sequenceMode: !1,
                    useStreamOnceInPeriodFlattening: !1,
                    enableFastSwitching: !0
                },
                hls: {
                    ignoreTextStreamFailures: !1,
                    ignoreImageStreamFailures: !1,
                    defaultAudioCodec: "mp4a.40.2",
                    defaultVideoCodec: "avc1.42E01E",
                    ignoreManifestProgramDateTime: !1,
                    ignoreManifestProgramDateTimeForTypes: [],
                    mediaPlaylistFullMimeType: 'video/mp2t; codecs="avc1.42E01E, mp4a.40.2"',
                    liveSegmentsDelay: 3,
                    sequenceMode: b.vd(),
                    ignoreManifestTimestampsInSegmentsMode: !1,
                    disableCodecGuessing: !1,
                    disableClosedCaptionsDetection: !1,
                    allowLowLatencyByteRangeOptimization: !0,
                    allowRangeRequestsToGuessMimeType: !1
                },
                mss: {
                    manifestPreprocessor: Yn,
                    manifestPreprocessorTXml: Zn,
                    sequenceMode: !1,
                    keySystemsBySystemId: {
                        "9a04f079-9840-4286-ab92-e65be0885f95": "com.microsoft.playready",
                        "79f0049a-4098-8642-ab92-e65be0885f95": "com.microsoft.playready"
                    }
                }
            }, f = {
                trackSelectionCallback: function(h) {
                    return Q(function(k) {
                        return k.return(h);
                    });
                },
                downloadSizeCallback: function(h) {
                    var k;
                    return Q(function(l) {
                        if (l.g == 1) return navigator.storage && navigator.storage.estimate ? F(l, navigator.storage.estimate(), 3) : l.return(!0);
                        k = l.h;
                        return l.return(k.usage + h < k.quota * .95);
                    });
                },
                progressCallback: function(h, k) {
                    return Bn([
                        h,
                        k
                    ]);
                },
                usePersistentLicense: !0,
                numberOfParallelDownloads: 5
            }, g = {
                drm: c,
                manifest: e,
                streaming: {
                    retryParameters: Fg(),
                    failureCallback: function(h) {
                        return Bn([
                            h
                        ]);
                    },
                    rebufferingGoal: 0,
                    bufferingGoal: 10,
                    bufferBehind: 30,
                    evictionGoal: 1,
                    ignoreTextStreamFailures: !1,
                    alwaysStreamText: !1,
                    startAtSegmentBoundary: !1,
                    gapDetectionThreshold: .5,
                    gapPadding: 0,
                    gapJumpTimerTime: .25,
                    durationBackoff: 1,
                    safeSeekOffset: 5,
                    safeSeekEndOffset: 0,
                    stallEnabled: !0,
                    stallThreshold: 1,
                    stallSkip: .1,
                    useNativeHlsForFairPlay: !0,
                    inaccurateManifestTolerance: 2,
                    lowLatencyMode: !0,
                    preferNativeDash: !1,
                    preferNativeHls: !1,
                    updateIntervalSeconds: 1,
                    observeQualityChanges: !1,
                    maxDisabledTime: 30,
                    segmentPrefetchLimit: 1,
                    prefetchAudioLanguages: [],
                    disableAudioPrefetch: !1,
                    disableTextPrefetch: !1,
                    disableVideoPrefetch: !1,
                    liveSync: {
                        enabled: !1,
                        targetLatency: .5,
                        targetLatencyTolerance: .5,
                        maxPlaybackRate: 1.1,
                        minPlaybackRate: .95,
                        panicMode: !1,
                        panicThreshold: 60,
                        dynamicTargetLatency: {
                            enabled: !1,
                            stabilityThreshold: 60,
                            rebufferIncrement: .5,
                            maxAttempts: 10,
                            maxLatency: 4,
                            minLatency: 1
                        }
                    },
                    allowMediaSourceRecoveries: !0,
                    minTimeBetweenRecoveries: 5,
                    vodDynamicPlaybackRate: !1,
                    vodDynamicPlaybackRateLowBufferRate: .95,
                    vodDynamicPlaybackRateBufferRatio: .5,
                    preloadNextUrlWindow: 30,
                    loadTimeout: 30,
                    clearDecodingCache: !1,
                    dontChooseCodecs: !1,
                    shouldFixTimestampOffset: !1,
                    avoidEvictionOnQuotaExceededError: !1,
                    crossBoundaryStrategy: "keep",
                    returnToEndOfLiveWindowWhenOutside: !1
                },
                networking: {
                    forceHTTP: !1,
                    forceHTTPS: !1,
                    minBytesForProgressEvents: 16E3
                },
                mediaSource: {
                    codecSwitchingStrategy: d,
                    addExtraFeaturesToSourceBuffer: function(h) {
                        return Bn([
                            h
                        ], "");
                    },
                    forceTransmux: !1,
                    insertFakeEncryptionInInit: !0,
                    correctEc3Enca: !1,
                    modifyCueCallback: function(h, k) {
                        return Bn([
                            h,
                            k
                        ]);
                    },
                    dispatchAllEmsgBoxes: !1,
                    useSourceElements: !0,
                    durationReductionEmitsUpdateEnd: !0
                },
                offline: f,
                abrFactory: function() {
                    return new rg;
                },
                adaptationSetCriteriaFactory: function() {
                    return new (Function.prototype.bind.apply(Ln, [
                        null
                    ].concat(x(Ma.apply(0, arguments)))));
                },
                abr: {
                    enabled: !0,
                    useNetworkInformation: !0,
                    defaultBandwidthEstimate: 1E6,
                    switchInterval: 8,
                    bandwidthUpgradeTarget: .85,
                    bandwidthDowngradeTarget: .95,
                    restrictions: {
                        minWidth: 0,
                        maxWidth: Infinity,
                        minHeight: 0,
                        maxHeight: a,
                        minPixels: 0,
                        maxPixels: Infinity,
                        minFrameRate: 0,
                        maxFrameRate: Infinity,
                        minBandwidth: 0,
                        maxBandwidth: Infinity,
                        minChannelsCount: 0,
                        maxChannelsCount: Infinity
                    },
                    advanced: {
                        minTotalBytes: 128E3,
                        minBytes: 16E3,
                        fastHalfLife: 2,
                        slowHalfLife: 5
                    },
                    restrictToElementSize: !1,
                    restrictToScreenSize: !1,
                    ignoreDevicePixelRatio: !1,
                    clearBufferSwitch: !1,
                    safeMarginSwitch: 0,
                    cacheLoadThreshold: 5,
                    minTimeToSwitch: 0,
                    preferNetworkInformationBandwidth: !1,
                    removeLatencyFromFirstPacketTime: !0
                },
                autoShowText: 3,
                preferredAudioLanguage: "",
                preferredAudioLabel: "",
                preferredTextLanguage: "",
                preferredAudioRole: "",
                preferredVideoRole: "",
                preferredTextRole: "",
                preferredAudioChannelCount: 2,
                preferredVideoHdrLevel: "AUTO",
                preferredVideoLayout: "",
                preferredVideoLabel: "",
                preferredVideoCodecs: [],
                preferredAudioCodecs: [],
                preferredTextFormats: [],
                preferForcedSubs: !1,
                preferSpatialAudio: !1,
                preferredDecodingAttributes: [],
                restrictions: {
                    minWidth: 0,
                    maxWidth: Infinity,
                    minHeight: 0,
                    maxHeight: Infinity,
                    minPixels: 0,
                    maxPixels: Infinity,
                    minFrameRate: 0,
                    maxFrameRate: Infinity,
                    minBandwidth: 0,
                    maxBandwidth: Infinity,
                    minChannelsCount: 0,
                    maxChannelsCount: Infinity
                },
                playRangeStart: 0,
                playRangeEnd: Infinity,
                textDisplayer: {
                    captionsUpdatePeriod: .25,
                    fontScaleFactor: 1
                },
                textDisplayFactory: function() {
                    return null;
                },
                cmcd: {
                    enabled: !1,
                    sessionId: "",
                    contentId: "",
                    rtpSafetyFactor: 5,
                    useHeaders: !1,
                    includeKeys: [],
                    version: 1,
                    targets: []
                },
                cmsd: {
                    enabled: !0,
                    applyMaximumSuggestedBitrate: !0,
                    estimatedThroughputWeightRatio: .5
                },
                lcevc: {
                    enabled: !1,
                    dynamicPerformanceScaling: !0,
                    logLevel: 0,
                    drawLogo: !1,
                    poster: !0
                },
                ads: {
                    customPlayheadTracker: !1,
                    skipPlayDetection: !1,
                    supportsMultipleMediaElements: !0,
                    disableHLSInterstitial: !1,
                    disableDASHInterstitial: !1,
                    allowPreloadOnDomElements: !0,
                    allowStartInMiddleOfInterstitial: !0
                },
                ignoreHardwareResolution: !1,
                queue: {
                    preloadNextUrlWindow: Infinity,
                    preloadPrevItem: !0,
                    repeatMode: 0
                }
            };
            f.trackSelectionCallback = function(h) {
                return Q(function(k) {
                    return k.return($n(h, g.preferredAudioLanguage, g.preferredVideoHdrLevel));
                });
            };
            return b.ab(g);
        }
        function ao() {
            return {
                streaming: {
                    inaccurateManifestTolerance: 0,
                    segmentPrefetchLimit: 2,
                    updateIntervalSeconds: .1,
                    maxDisabledTime: 1,
                    retryParameters: {
                        baseDelay: 100
                    }
                },
                manifest: {
                    dash: {
                        autoCorrectDrift: !1
                    },
                    retryParameters: {
                        baseDelay: 100
                    }
                },
                drm: {
                    retryParameters: {
                        baseDelay: 100
                    }
                }
            };
        }
        function bo(a, b, c) {
            var d = {
                ".drm.keySystemsMapping": "",
                ".drm.servers": "",
                ".drm.clearKeys": "",
                ".drm.advanced": {
                    distinctiveIdentifierRequired: !1,
                    persistentStateRequired: !1,
                    videoRobustness: [],
                    audioRobustness: [],
                    sessionType: "",
                    serverCertificate: new Uint8Array(0),
                    serverCertificateUri: "",
                    individualizationServer: "",
                    headers: {}
                }
            };
            return zn(a, b, c || Xn(), d, "");
        }
        function $n(a, b, c) {
            var d = c;
            d == "AUTO" && (c = a.some(function(h) {
                return h.hdr && h.hdr == "HLG" ? !0 : !1;
            }), d = Rb().Id(c));
            var e = a.filter(function(h) {
                return h.type != "variant" || h.hdr && h.hdr != d ? !1 : !0;
            });
            c = [];
            var f = Gc(b, e.map(function(h) {
                return h.language;
            }));
            f && (c = e.filter(function(h) {
                return yc(h.language) == f;
            }));
            c.length == 0 && (c = e.filter(function(h) {
                return h.primary;
            }));
            c.length == 0 && (e.map(function(h) {
                return h.language;
            }), c = e);
            var g = c.filter(function(h) {
                return h.height && h.height <= 480;
            });
            g.length && (g.sort(function(h, k) {
                return k.height - h.height;
            }), c = g.filter(function(h) {
                return h.height == g[0].height;
            }));
            b = [];
            c.length && (e = Math.floor(c.length / 2), c.sort(function(h, k) {
                return h.bandwidth - k.bandwidth;
            }), b.push(c[e]));
            a = u(a);
            for(c = a.next(); !c.done; c = a.next())c = c.value, c.type != sc && c.type != "image" || b.push(c);
            return b;
        }
        function Yn(a) {
            return Bn([
                a
            ], a);
        }
        function Zn(a) {
            return Bn([
                a
            ], a);
        }
        S("shaka.util.PlayerConfiguration", Wn);
        Wn.mergeConfigObjects = bo;
        Wn.createDefaultForLL = ao;
        Wn.createDefault = Xn;
        function co() {
            this.g = null;
            this.h = [];
        }
        function eo(a, b) {
            var c = 0;
            a.g && a.g.state == b && (c += a.g.duration);
            a = u(a.h);
            for(var d = a.next(); !d.done; d = a.next())d = d.value, c += d.state == b ? d.duration : 0;
            return c;
        }
        function fo(a) {
            function b(f) {
                return {
                    timestamp: f.timestamp,
                    state: f.state,
                    duration: f.duration
                };
            }
            for(var c = [], d = u(a.h), e = d.next(); !e.done; e = d.next())c.push(b(e.value));
            a.g && c.push(b(a.g));
            return c;
        }
        function go() {
            this.i = this.h = null;
            this.g = [];
        }
        function ho(a, b, c) {
            a.i != b && (a.i = b, a.g.push({
                timestamp: Date.now() / 1E3,
                id: b.id,
                type: "text",
                fromAdaptation: c,
                bandwidth: null
            }));
        }
        function io() {
            this.D = this.V = NaN;
            this.l = "";
            this.j = this.jj = this.A = this.C = this.K = this.F = this.u = this.m = this.J = this.G = this.i = this.R = this.S = this.M = this.O = this.P = NaN;
            this.L = 0;
            this.H = this.I = NaN;
            this.g = new co;
            this.h = new go;
        }
        function jo(a, b, c) {
            a.P = b;
            a.O = c;
        }
        function ko(a, b, c) {
            a.V = b;
            a.D = c;
        }
        function lo(a, b) {
            a.i = isNaN(a.i) ? b : Math.max(a.i, b);
        }
        function mo(a, b) {
            a.j = isNaN(a.j) ? b : a.j + b;
        }
        function no(a) {
            var b = a.V, c = a.D, d = a.l, e = a.C, f = a.O, g = a.P, h = a.M, k = a.S, l = a.R, m = a.A, n = a.i, q = a.G, r = a.J, t = a.m, w = eo(a.g, "playing"), v = eo(a.g, "paused"), z = eo(a.g, "buffering"), y = a.u, A = a.F, C = a.K, E = a.jj, D = a.j, B = a.L, G = a.I, I = a.H, J = fo(a.g), L = [];
            a = u(a.h.g);
            for(var K = a.next(); !K.done; K = a.next())K = K.value, L.push({
                timestamp: K.timestamp,
                id: K.id,
                type: K.type,
                fromAdaptation: K.fromAdaptation,
                bandwidth: K.bandwidth
            });
            return {
                width: b,
                height: c,
                currentCodecs: d,
                streamBandwidth: e,
                decodedFrames: f,
                droppedFrames: g,
                corruptedFrames: h,
                stallsDetected: k,
                gapsJumped: l,
                estimatedBandwidth: m,
                completionPercent: n,
                loadLatency: q,
                manifestTimeSeconds: r,
                drmTimeSeconds: t,
                playTime: w,
                pauseTime: v,
                bufferingTime: z,
                licenseTime: y,
                liveLatency: A,
                maxSegmentDuration: C,
                manifestSizeBytes: E,
                bytesDownloaded: D,
                nonFatalErrorCount: B,
                manifestPeriodCount: G,
                manifestGapCount: I,
                stateHistory: J,
                switchHistory: L
            };
        }
        function oo(a, b, c, d) {
            kb.call(this);
            this.M = a;
            this.S = b;
            this.xa = d.networkingEngine;
            this.m = c;
            this.D = null;
            this.sa = 0;
            this.Ma = d.Dd;
            this.G = d.Ol;
            this.Oa = d.Pl;
            this.g = d.config;
            this.l = this.H = this.h = null;
            this.ea = !1;
            this.I = d.$l;
            this.oa = !1;
            this.i = null;
            this.Y = !1;
            this.A = null;
            this.L = new Map;
            this.ra = !1;
            this.Fa = d.Zl;
            this.V = new io;
            this.aa = new Lg;
            this.C = new Lg;
            this.O = null;
            this.j = !1;
            this.X = d.lk;
            this.R = this.u = null;
            this.P = !1;
            this.K = [];
            this.J = [];
            this.F = !0;
        }
        la(oo, kb);
        function po(a, b, c) {
            (a = b ? a.J : a.K) ? a.push(c) : c();
        }
        function qo(a) {
            if (a.J) for(var b = u(a.J), c = b.next(); !c.done; c = b.next())c = c.value, c();
            a.J = null;
        }
        function ro(a, b) {
            a.O = b;
            a.P = !0;
            if (a.K) {
                b = u(a.K);
                for(var c = b.next(); !c.done; c = b.next())c = c.value, c();
            }
            a.K = null;
        }
        p = oo.prototype;
        p.getStartTime = function() {
            return this.m;
        };
        p.hd = function() {
            return this.M;
        };
        p.rh = function() {
            return this.h;
        };
        function so(a) {
            a.oa = !0;
            return a.I;
        }
        p.getStats = function() {
            return this.V;
        };
        function to(a) {
            a.Y = !0;
            return a.i;
        }
        p.cl = function() {
            return this.u ? bg(this.u) : null;
        };
        p.al = function() {
            return this.R ? cg(this.R) : null;
        };
        function uo(a) {
            a.ra = !0;
            return a.L;
        }
        p.start = function() {
            var a = this;
            (function() {
                var b;
                return Q(function(c) {
                    switch(c.g){
                        case 1:
                            return F(c, Promise.resolve(), 2);
                        case 2:
                            return ra(c, 3), F(c, vo(a), 5);
                        case 5:
                            wo(a);
                            if ("webkit" === window1.shakaMediaKeysPolyfill) {
                                c.B(6);
                                break;
                            }
                            return F(c, xo(a), 7);
                        case 7:
                            wo(a);
                        case 6:
                            if (!a.X) {
                                c.B(8);
                                break;
                            }
                            return F(c, yo(a), 9);
                        case 9:
                            wo(a);
                        case 8:
                            if (!a.X || !a.i) {
                                c.B(10);
                                break;
                            }
                            return F(c, ii(a.i), 11);
                        case 11:
                            wo(a);
                        case 10:
                            a.C.resolve();
                            ta(c, 0);
                            break;
                        case 3:
                            b = ua(c), b instanceof U && (b.code == 7001 || b.code == 7003) || a.C.reject(b), H(c);
                    }
                });
            })();
        };
        p.dispatchEvent = function(a) {
            return this.O ? this.O.dispatchEvent(a) : kb.prototype.dispatchEvent.call(this, a);
        };
        p.onError = function(a) {
            a.severity === 2 && (this.C.reject(a), this.destroy());
            var b = (new Map).set("detail", a);
            b = new T("error", b);
            this.dispatchEvent(b);
            b.defaultPrevented && (a.handled = !0);
        };
        function wo(a) {
            if (a.j) throw new U(2, 7, 7003);
        }
        function zo(a, b) {
            a.dispatchEvent(new T("onstatechange", (new Map).set("state", b)));
        }
        function vo(a) {
            var b, c, d, e, f, g;
            return Q(function(h) {
                switch(h.g){
                    case 1:
                        zo(a, "manifest-parser");
                        a.l || (a.H = Hi(a.M, a.S), a.l = a.H(), a.l.configure(a.g.manifest, function() {
                            return a.F;
                        }));
                        b = Date.now() / 1E3;
                        zo(a, "manifest");
                        if (a.h) {
                            h.B(2);
                            break;
                        }
                        return F(h, a.l.start(a.M, a.Oa), 3);
                    case 3:
                        return a.h = h.h, F(h, Ao(a), 2);
                    case 2:
                        return a.aa.resolve(), c = new T("manifestparsed", void 0), F(h, Promise.resolve(), 5);
                    case 5:
                        a.dispatchEvent(c);
                        if (a.h.variants.length == 0) throw new U(2, 4, 4036);
                        Bo(a.h);
                        d = xi(a.G, a.h);
                        if (!d) {
                            h.B(6);
                            break;
                        }
                        e = new T("trackschanged", void 0);
                        return F(h, Promise.resolve(), 7);
                    case 7:
                        wo(a), a.dispatchEvent(e);
                    case 6:
                        f = Date.now() / 1E3, g = f - b, a.V.J = g, H(h);
                }
            });
        }
        function xo(a, b) {
            var c, d, e, f;
            return Q(function(g) {
                switch(g.g){
                    case 1:
                        if (!a.h || a.i) return g.return();
                        zo(a, "drm-engine");
                        a.sa = Date.now() / 1E3;
                        a.i = a.Ma();
                        a.G.h = a.i;
                        a.i.configure(a.g.drm, function() {
                            return a.F;
                        });
                        c = kg(a.h.variants);
                        d = !0;
                        a.h && a.h.presentationTimeline && (d = a.h.presentationTimeline.U());
                        return F(g, Ih(a.i, c, a.h.offlineSessionIds, d), 2);
                    case 2:
                        wo(a);
                        if (!b) {
                            g.B(3);
                            break;
                        }
                        return F(g, a.i.cc(b), 4);
                    case 4:
                        wo(a);
                    case 3:
                        return F(g, vi(a.G, a.h), 5);
                    case 5:
                        e = g.h;
                        if (!e) {
                            g.B(0);
                            break;
                        }
                        f = new T("trackschanged", void 0);
                        return F(g, Promise.resolve(), 7);
                    case 7:
                        a.dispatchEvent(f), H(g);
                }
            });
        }
        p.configure = function(a, b) {
            a = An(a, b);
            bo(this.g, a);
        };
        p.getConfiguration = function() {
            return Gd(this.g);
        };
        function Ao(a) {
            var b, c, d, e, f;
            return Q(function(g) {
                a.D || (a.D = a.g.adaptationSetCriteriaFactory(), a.D.configure({
                    language: a.g.preferredAudioLanguage,
                    role: a.g.preferredAudioRole,
                    videoRole: a.g.preferredVideoRole,
                    channelCount: a.g.preferredAudioChannelCount,
                    hdrLevel: a.g.preferredVideoHdrLevel,
                    spatialAudio: a.g.preferSpatialAudio,
                    videoLayout: a.g.preferredVideoLayout,
                    audioLabel: a.g.preferredAudioLabel,
                    videoLabel: a.g.preferredVideoLabel,
                    codecSwitchingStrategy: a.g.mediaSource.codecSwitchingStrategy,
                    audioCodec: "",
                    activeAudioCodec: "",
                    activeAudioChannelCount: 0,
                    preferredAudioCodecs: a.g.preferredAudioCodecs,
                    preferredAudioChannelCount: a.g.preferredAudioChannelCount
                }));
                if (a.h.variants.length != 1 && a.h.type != "HLS") return g.B(0);
                b = Co(a);
                if (!b) return g.B(0);
                c = [];
                d = u([
                    b.video,
                    b.audio
                ]);
                for(e = d.next(); !e.done; e = d.next())(f = e.value) && !f.segmentIndex && c.push(f.createSegmentIndex());
                return c.length > 0 ? F(g, Promise.all(c), 0) : g.B(0);
            });
        }
        function yo(a) {
            var b, c, d, e, f;
            return Q(function(g) {
                !a.u && (b = Co(a)) && (a.u = b);
                if (!a.u) return g.B(0);
                c = a.h.presentationTimeline.U();
                d = [];
                e = a.u;
                e.video && d.push(Do(a, e.video, c));
                e.audio && d.push(Do(a, e.audio, c));
                (f = lg(a.h.textStreams, a.g.preferredTextLanguage, a.g.preferredTextRole, a.g.preferForcedSubs)[0] || null) && pg(e.audio, f, a.g) && (d.push(Do(a, f, c)), a.R = f);
                return F(g, Promise.all(d), 0);
            });
        }
        function Co(a) {
            if (!a.A) {
                var b = a.g.abrFactory;
                a.A = b();
                a.A.configure(a.g.abr);
            }
            b = kg(a.h.variants);
            b = a.D.create(b);
            a.A.setVariants(Array.from(b.values()));
            return a.A.chooseVariant(!0);
        }
        function Do(a, b, c) {
            var d, e, f, g, h;
            return Q(function(k) {
                if (k.g == 1) return d = a.g.streaming.segmentPrefetchLimit || 2, e = new pm(d, b, function(l, m, n) {
                    return gn(l, m, n || null, a.g.streaming.retryParameters, a.xa, a.F);
                }, !1), a.L.set(b.id, e), b.segmentIndex ? k.B(2) : F(k, b.createSegmentIndex(), 2);
                f = typeof a.m === "number" ? a.m : 0;
                g = b.segmentIndex.ec(f);
                h = null;
                g && (h = g.current(), h || (h = g.next().value));
                h || (h = eg(b.segmentIndex));
                return h ? c ? h.ia ? F(k, sm(e, h.ia), 0) : k.B(0) : F(k, rm(e, h.startTime), 0) : k.B(0);
            });
        }
        p.Fm = function() {
            return this.C;
        };
        p.destroy = function() {
            var a = this, b, c, d;
            return Q(function(e) {
                if (e.g == 1) return a.j = !0, !a.l || a.ea ? e.B(2) : F(e, a.l.stop(), 2);
                if (e.g != 4) return a.A && a.A.release(), a.I && !a.oa && a.I.release(), !a.i || a.Y ? e.B(4) : F(e, a.i.destroy(), 4);
                if (a.L.size > 0 && !a.ra) for(b = u(a.L.values()), c = b.next(); !c.done; c = b.next())d = c.value, ym(d);
                H(e);
            });
        };
        function Bo(a) {
            function b(c) {
                return c.video && c.audio || c.video && c.video.codecs.includes(",");
            }
            a.variants.some(b) && (a.variants = a.variants.filter(b));
        }
        S("shaka.media.PreloadManager", oo);
        oo.prototype.destroy = oo.prototype.destroy;
        oo.prototype.waitForFinish = oo.prototype.Fm;
        oo.prototype.getPrefetchedTextTrack = oo.prototype.al;
        oo.prototype.getPrefetchedVariantTrack = oo.prototype.cl;
        function Eo(a, b) {
            kb.call(this);
            var c = this;
            this.i = a;
            this.l = b;
            this.g = new Map;
            this.m = [
                {
                    zd: null,
                    yd: Fo,
                    kd: function(d, e) {
                        return Go(c, "enter", d, e);
                    }
                },
                {
                    zd: Ho,
                    yd: Fo,
                    kd: function(d, e) {
                        return Go(c, "enter", d, e);
                    }
                },
                {
                    zd: Io,
                    yd: Fo,
                    kd: function(d, e) {
                        return Go(c, "enter", d, e);
                    }
                },
                {
                    zd: Fo,
                    yd: Ho,
                    kd: function(d, e) {
                        return Go(c, "exit", d, e);
                    }
                },
                {
                    zd: Fo,
                    yd: Io,
                    kd: function(d, e) {
                        return Go(c, "exit", d, e);
                    }
                },
                {
                    zd: Ho,
                    yd: Io,
                    kd: function(d, e) {
                        e ? Go(c, "skip", d, e) : (Go(c, "enter", d, e), Go(c, "exit", d, e));
                    }
                },
                {
                    zd: Io,
                    yd: Ho,
                    kd: function(d, e) {
                        return Go(c, "skip", d, e);
                    }
                }
            ];
            this.h = new Tc;
            this.h.o(this.i, "regionremove", function(d) {
                c.g.delete(d.region);
            });
        }
        la(Eo, kb);
        Eo.prototype.release = function() {
            this.i = null;
            this.g.clear();
            this.h.release();
            this.h = null;
            kb.prototype.release.call(this);
        };
        Eo.prototype.j = function(a, b) {
            if (!this.l || a != 0) {
                this.l = !1;
                for(var c = u(this.i.h.values()), d = c.next(); !d.done; d = c.next()){
                    d = d.value;
                    var e = this.g.get(d), f = a < d.startTime ? Ho : a > d.endTime ? Io : Fo;
                    this.g.set(d, f);
                    for(var g = u(this.m), h = g.next(); !h.done; h = g.next())h = h.value, h.zd == e && h.yd == f && h.kd(d, b);
                }
            }
        };
        function Go(a, b, c, d) {
            b = new T(b, new Map([
                [
                    "region",
                    c
                ],
                [
                    "seeking",
                    d
                ]
            ]));
            a.dispatchEvent(b);
        }
        var Ho = 1, Fo = 2, Io = 3;
        function Jo(a, b, c) {
            var d, e, f, g, h, k, l;
            return Q(function(m) {
                switch(m.g){
                    case 1:
                        var n = new qb(a).qb.split("/").pop().split(".");
                        d = n.length == 1 ? "" : n.pop().toLowerCase();
                        if (e = Ko.get(d)) return m.return(e);
                        f = 0;
                        g = $g([
                            a
                        ], c);
                        ra(m, 2);
                        g.method = "HEAD";
                        return F(m, b.request(f, g).promise, 4);
                    case 4:
                        h = m.h;
                        e = h.headers["content-type"];
                        ta(m, 3);
                        break;
                    case 2:
                        k = ua(m);
                        if (!k || k.code != 1002 && k.code != 1001) {
                            m.B(3);
                            break;
                        }
                        g.method = "GET";
                        return F(m, b.request(f, g).promise, 6);
                    case 6:
                        l = m.h, e = l.headers["content-type"];
                    case 3:
                        return m.return(e ? e.toLowerCase().split(";").shift() : "");
                }
            });
        }
        var Ko = (new Map).set("mp4", "video/mp4").set("m4v", "video/mp4").set("m4a", "audio/mp4").set("webm", "video/webm").set("weba", "audio/webm").set("mkv", "video/webm").set("ts", "video/mp2t").set("ogv", "video/ogg").set("ogg", "audio/ogg").set("mpg", "video/mpeg").set("mpeg", "video/mpeg").set("mov", "video/quicktime").set("m3u8", "application/x-mpegurl").set("mpd", "application/dash+xml").set("ism", "application/vnd.ms-sstr+xml").set("mp3", "audio/mpeg").set("aac", "audio/aac").set("flac", "audio/flac").set("wav", "audio/wav").set("sbv", "text/x-subviewer").set("srt", "text/srt").set("vtt", "text/vtt").set("webvtt", "text/vtt").set("ttml", "application/ttml+xml").set("lrc", "application/x-subtitle-lrc").set("ssa", "text/x-ssa").set("ass", "text/x-ssa").set("jpeg", "image/jpeg").set("jpg", "image/jpeg").set("png", "image/png").set("svg", "image/svg+xml").set("webp", "image/webp").set("avif", "image/avif").set("html", "text/html").set("htm", "text/html"); /*
 @license
 Copyright 2013 Ali Al Dallal

 Licensed under the MIT license.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in
 all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.
*/ 
        for(var Lo = {
            ach: "Lwo",
            ady: "\u0410\u0434\u044b\u0433\u044d\u0431\u0437\u044d",
            af: "Afrikaans",
            "af-NA": "Afrikaans (Namibia)",
            "af-ZA": "Afrikaans (South Africa)",
            ak: "T\u0255\u0265i",
            ar: "\u0627\u0644\u0639\u0631\u0628\u064a\u0629",
            "ar-AR": "\u0627\u0644\u0639\u0631\u0628\u064a\u0629",
            "ar-MA": "\u0627\u0644\u0639\u0631\u0628\u064a\u0629",
            "ar-SA": "\u0627\u0644\u0639\u0631\u0628\u064a\u0629 (\u0627\u0644\u0633\u0639\u0648\u062f\u064a\u0629)",
            "ay-BO": "Aymar aru",
            az: "Az\u0259rbaycan dili",
            "az-AZ": "Az\u0259rbaycan dili",
            "be-BY": "\u0411\u0435\u043b\u0430\u0440\u0443\u0441\u043a\u0430\u044f",
            bg: "\u0411\u044a\u043b\u0433\u0430\u0440\u0441\u043a\u0438",
            "bg-BG": "\u0411\u044a\u043b\u0433\u0430\u0440\u0441\u043a\u0438",
            bn: "\u09ac\u09be\u0982\u09b2\u09be",
            "bn-IN": "\u09ac\u09be\u0982\u09b2\u09be (\u09ad\u09be\u09b0\u09a4)",
            "bn-BD": "\u09ac\u09be\u0982\u09b2\u09be(\u09ac\u09be\u0982\u09b2\u09be\u09a6\u09c7\u09b6)",
            "bs-BA": "Bosanski",
            ca: "Catal\u00e0",
            "ca-ES": "Catal\u00e0",
            cak: "Maya Kaqchikel",
            "ck-US": "\u13e3\u13b3\u13a9 (tsalagi)",
            cs: "\u010ce\u0161tina",
            "cs-CZ": "\u010ce\u0161tina",
            cy: "Cymraeg",
            "cy-GB": "Cymraeg",
            da: "Dansk",
            "da-DK": "Dansk",
            de: "Deutsch",
            "de-AT": "Deutsch (\u00d6sterreich)",
            "de-DE": "Deutsch (Deutschland)",
            "de-CH": "Deutsch (Schweiz)",
            dsb: "Dolnoserb\u0161\u0107ina",
            el: "\u0395\u03bb\u03bb\u03b7\u03bd\u03b9\u03ba\u03ac",
            "el-GR": "\u0395\u03bb\u03bb\u03b7\u03bd\u03b9\u03ba\u03ac",
            en: "English",
            "en-GB": "English (UK)",
            "en-AU": "English (Australia)",
            "en-CA": "English (Canada)",
            "en-IE": "English (Ireland)",
            "en-IN": "English (India)",
            "en-PI": "English (Pirate)",
            "en-UD": "English (Upside Down)",
            "en-US": "English (US)",
            "en-ZA": "English (South Africa)",
            "en@pirate": "English (Pirate)",
            eo: "Esperanto",
            "eo-EO": "Esperanto",
            es: "Espa\u00f1ol",
            "es-AR": "Espa\u00f1ol (Argentine)",
            "es-419": "Espa\u00f1ol (Latinoam\u00e9rica)",
            "es-CL": "Espa\u00f1ol (Chile)",
            "es-CO": "Espa\u00f1ol (Colombia)",
            "es-EC": "Espa\u00f1ol (Ecuador)",
            "es-ES": "Espa\u00f1ol (Espa\u00f1a)",
            "es-LA": "Espa\u00f1ol (Latinoam\u00e9rica)",
            "es-NI": "Espa\u00f1ol (Nicaragua)",
            "es-MX": "Espa\u00f1ol (M\u00e9xico)",
            "es-US": "Espa\u00f1ol (Estados Unidos)",
            "es-VE": "Espa\u00f1ol (Venezuela)",
            et: "eesti keel",
            "et-EE": "Eesti (Estonia)",
            eu: "Euskara",
            "eu-ES": "Euskara",
            fa: "\u0641\u0627\u0631\u0633\u06cc",
            "fa-IR": "\u0641\u0627\u0631\u0633\u06cc",
            "fb-LT": "Leet Speak",
            ff: "Fulah",
            fi: "Suomi",
            "fi-FI": "Suomi",
            "fo-FO": "F\u00f8royskt",
            fr: "Fran\u00e7ais",
            "fr-CA": "Fran\u00e7ais (Canada)",
            "fr-FR": "Fran\u00e7ais (France)",
            "fr-BE": "Fran\u00e7ais (Belgique)",
            "fr-CH": "Fran\u00e7ais (Suisse)",
            "fy-NL": "Frysk",
            ga: "Gaeilge",
            "ga-IE": "Gaeilge (Gaelic)",
            gl: "Galego",
            "gl-ES": "Galego",
            "gn-PY": "Ava\u00f1e'\u1ebd",
            "gu-IN": "\u0a97\u0ac1\u0a9c\u0ab0\u0abe\u0aa4\u0ac0",
            "gx-GR": "\u1f19\u03bb\u03bb\u03b7\u03bd\u03b9\u03ba\u03ae \u1f00\u03c1\u03c7\u03b1\u03af\u03b1",
            he: "\u05e2\u05d1\u05e8\u05d9\u05ea\u200f",
            "he-IL": "\u05e2\u05d1\u05e8\u05d9\u05ea\u200f",
            hi: "\u0939\u093f\u0928\u094d\u0926\u0940",
            "hi-IN": "\u0939\u093f\u0928\u094d\u0926\u0940",
            hr: "Hrvatski",
            "hr-HR": "Hrvatski",
            hsb: "Hornjoserb\u0161\u0107ina",
            ht: "Krey\u00f2l",
            hu: "Magyar",
            "hu-HU": "Magyar",
            "hy-AM": "\u0540\u0561\u0575\u0565\u0580\u0565\u0576",
            id: "Bahasa Indonesia",
            "id-ID": "Bahasa Indonesia",
            is: "\u00cdslenska",
            "is-IS": "\u00cdslenska (Iceland)",
            it: "Italiano",
            "it-IT": "Italiano",
            ja: "\u65e5\u672c\u8a9e",
            "ja-JP": "\u65e5\u672c\u8a9e",
            "jv-ID": "Basa Jawa",
            "ka-GE": "\u10e5\u10d0\u10e0\u10d7\u10e3\u10da\u10d8",
            "kk-KZ": "\u049a\u0430\u0437\u0430\u049b\u0448\u0430",
            km: "\u1797\u17b6\u179f\u17b6\u1781\u17d2\u1798\u17c2\u179a",
            "km-KH": "\u1797\u17b6\u179f\u17b6\u1781\u17d2\u1798\u17c2\u179a",
            kab: "Taqbaylit",
            kn: "\u0c95\u0ca8\u0ccd\u0ca8\u0ca1",
            "kn-IN": "\u0c95\u0ca8\u0ccd\u0ca8\u0ca1 (India)",
            ko: "\ud55c\uad6d\uc5b4",
            "ko-KR": "\ud55c\uad6d\uc5b4 (\u97e9\u56fd)",
            ku: "Kurd\u00ee",
            "ku-TR": "Kurd\u00ee",
            la: "Latin",
            "la-VA": "Latin",
            lb: "L\u00ebtzebuergesch",
            "li-NL": "L\u00e8mb\u00f6rgs",
            lt: "Lietuvi\u0173",
            "lt-LT": "Lietuvi\u0173",
            lv: "Latvie\u0161u",
            "lv-LV": "Latvie\u0161u",
            mai: "\u092e\u0948\u0925\u093f\u0932\u0940, \u09ae\u09c8\u09a5\u09bf\u09b2\u09c0",
            "mg-MG": "Malagasy",
            mk: "\u041c\u0430\u043a\u0435\u0434\u043e\u043d\u0441\u043a\u0438",
            "mk-MK": "\u041c\u0430\u043a\u0435\u0434\u043e\u043d\u0441\u043a\u0438 (\u041c\u0430\u043a\u0435\u0434\u043e\u043d\u0441\u043a\u0438)",
            ml: "\u0d2e\u0d32\u0d2f\u0d3e\u0d33\u0d02",
            "ml-IN": "\u0d2e\u0d32\u0d2f\u0d3e\u0d33\u0d02",
            "mn-MN": "\u041c\u043e\u043d\u0433\u043e\u043b",
            mr: "\u092e\u0930\u093e\u0920\u0940",
            "mr-IN": "\u092e\u0930\u093e\u0920\u0940",
            ms: "Bahasa Melayu",
            "ms-MY": "Bahasa Melayu",
            mt: "Malti",
            "mt-MT": "Malti",
            my: "\u1017\u1019\u102c\u1005\u1000\u102c",
            nb: "Norsk (bokm\u00e5l)",
            "nb-NO": "Norsk (bokm\u00e5l)",
            ne: "\u0928\u0947\u092a\u093e\u0932\u0940",
            "ne-NP": "\u0928\u0947\u092a\u093e\u0932\u0940",
            nl: "Nederlands",
            "nl-BE": "Nederlands (Belgi\u00eb)",
            "nl-NL": "Nederlands (Nederland)",
            "nn-NO": "Norsk (nynorsk)",
            no: "Norsk",
            oc: "Occitan",
            "or-IN": "\u0b13\u0b21\u0b3c\u0b3f\u0b06",
            pa: "\u0a2a\u0a70\u0a1c\u0a3e\u0a2c\u0a40",
            "pa-IN": "\u0a2a\u0a70\u0a1c\u0a3e\u0a2c\u0a40 (\u0a2d\u0a3e\u0a30\u0a24 \u0a28\u0a42\u0a70)",
            pl: "Polski",
            "pl-PL": "Polski",
            "ps-AF": "\u067e\u069a\u062a\u0648",
            pt: "Portugu\u00eas",
            "pt-BR": "Portugu\u00eas (Brasil)",
            "pt-PT": "Portugu\u00eas (Portugal)",
            "qu-PE": "Qhichwa",
            "rm-CH": "Rumantsch",
            ro: "Rom\u00e2n\u0103",
            "ro-RO": "Rom\u00e2n\u0103",
            ru: "\u0420\u0443\u0441\u0441\u043a\u0438\u0439",
            "ru-RU": "\u0420\u0443\u0441\u0441\u043a\u0438\u0439",
            "sa-IN": "\u0938\u0902\u0938\u094d\u0915\u0943\u0924\u092e\u094d",
            "se-NO": "Davvis\u00e1megiella",
            "si-LK": "\u0db4\u0dc5\u0dcf\u0dad",
            sk: "Sloven\u010dina",
            "sk-SK": "Sloven\u010dina (Slovakia)",
            sl: "Sloven\u0161\u010dina",
            "sl-SI": "Sloven\u0161\u010dina",
            "so-SO": "Soomaaliga",
            sq: "Shqip",
            "sq-AL": "Shqip",
            sr: "\u0421\u0440\u043f\u0441\u043a\u0438",
            "sr-RS": "\u0421\u0440\u043f\u0441\u043a\u0438 (Serbia)",
            su: "Basa Sunda",
            sv: "Svenska",
            "sv-SE": "Svenska",
            sw: "Kiswahili",
            "sw-KE": "Kiswahili",
            ta: "\u0ba4\u0bae\u0bbf\u0bb4\u0bcd",
            "ta-IN": "\u0ba4\u0bae\u0bbf\u0bb4\u0bcd",
            te: "\u0c24\u0c46\u0c32\u0c41\u0c17\u0c41",
            "te-IN": "\u0c24\u0c46\u0c32\u0c41\u0c17\u0c41",
            tg: "\u0437\u0430\u0431\u043e\u0301\u043d\u0438 \u0442\u043e\u04b7\u0438\u043a\u04e3\u0301",
            "tg-TJ": "\u0442\u043e\u04b7\u0438\u043a\u04e3",
            th: "\u0e20\u0e32\u0e29\u0e32\u0e44\u0e17\u0e22",
            "th-TH": "\u0e20\u0e32\u0e29\u0e32\u0e44\u0e17\u0e22 (\u0e1b\u0e23\u0e30\u0e40\u0e17\u0e28\u0e44\u0e17\u0e22)",
            tl: "Filipino",
            "tl-PH": "Filipino",
            tlh: "tlhIngan-Hol",
            tr: "T\u00fcrk\u00e7e",
            "tr-TR": "T\u00fcrk\u00e7e",
            "tt-RU": "\u0442\u0430\u0442\u0430\u0440\u0447\u0430",
            uk: "\u0423\u043a\u0440\u0430\u0457\u043d\u0441\u044c\u043a\u0430",
            "uk-UA": "\u0423\u043a\u0440\u0430\u0457\u043d\u0441\u044c\u043a\u0430",
            ur: "\u0627\u0631\u062f\u0648",
            "ur-PK": "\u0627\u0631\u062f\u0648",
            uz: "O'zbek",
            "uz-UZ": "O'zbek",
            vi: "Ti\u1ebfng Vi\u1ec7t",
            "vi-VN": "Ti\u1ebfng Vi\u1ec7t",
            "xh-ZA": "isiXhosa",
            yi: "\u05d9\u05d9\u05b4\u05d3\u05d9\u05e9",
            "yi-DE": "\u05d9\u05d9\u05b4\u05d3\u05d9\u05e9 (German)",
            zh: "\u4e2d\u6587",
            "zh-HANS": "\u4e2d\u6587\u7b80\u4f53",
            "zh-HANT": "\u4e2d\u6587\u7e41\u9ad4",
            "zh-CN": "\u4e2d\u6587\uff08\u4e2d\u56fd\uff09",
            "zh-HK": "\u4e2d\u6587\uff08\u9999\u6e2f\uff09",
            "zh-SG": "\u4e2d\u6587\uff08\u65b0\u52a0\u5761\uff09",
            "zh-TW": "\u4e2d\u6587\uff08\u53f0\u7063\uff09",
            "zu-ZA": "isiZulu"
        }, Mo = u(Object.keys(Lo)), No = Mo.next(); !No.done; No = Mo.next()){
            var Oo = No.value;
            Lo[Oo.toLowerCase()] = Lo[Oo];
        }
        function Po(a, b) {
            if (a.lineBreak) return "\n";
            if (a.nestedCues.length) return a.nestedCues.map(function(g) {
                return Po(g, a);
            }).join("");
            if (!a.payload) return a.payload;
            var c = [], d = a.fontWeight >= Oe, e = a.fontStyle == Pe, f = a.textDecoration.includes(Qe);
            d && c.push([
                "b"
            ]);
            e && c.push([
                "i"
            ]);
            f && c.push([
                "u"
            ]);
            e = a.color;
            e == "" && b && (e = b.color);
            d = "";
            (e = Qo(e)) && (d += "." + e);
            e = a.backgroundColor;
            e == "" && b && (e = b.backgroundColor);
            (b = Qo(e)) && (d += ".bg_" + b);
            d && c.push([
                "c",
                d
            ]);
            return c.reduceRight(function(g, h) {
                var k = u(h);
                h = k.next().value;
                k = k.next().value;
                return "<" + h + (k === void 0 ? "" : k) + ">" + g + "</" + h + ">";
            }, a.payload);
        }
        function Qo(a) {
            a = a.toLowerCase();
            var b = a.replace(/\s/g, "").match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i);
            b ? a = "#" + (parseInt(b[1], 10) | 256).toString(16).slice(1) + (parseInt(b[2], 10) | 256).toString(16).slice(1) + (parseInt(b[3], 10) | 256).toString(16).slice(1) : a.startsWith("#") && a.length > 7 && (a = a.slice(0, 7));
            switch(a){
                case "white":
                case "#fff":
                case "#ffffff":
                    return "white";
                case "lime":
                case "#0f0":
                case "#00ff00":
                    return "lime";
                case "cyan":
                case "#0ff":
                case "#00ffff":
                    return "cyan";
                case "red":
                case "#f00":
                case "#ff0000":
                    return "red";
                case "yellow":
                case "#ff0":
                case "#ffff00":
                    return "yellow";
                case "magenta":
                case "#f0f":
                case "#ff00ff":
                    return "magenta";
                case "blue":
                case "#00f":
                case "#0000ff":
                    return "blue";
                case "black":
                case "#000":
                case "#000000":
                    return "black";
            }
            return null;
        }
        function Ro(a, b) {
            var c = [];
            a = u(So(a));
            for(var d = a.next(); !d.done; d = a.next())if (d = d.value, d.isContainer) c.push.apply(c, x(Ro(d.nestedCues, d)));
            else {
                var e = d.clone();
                e.nestedCues = [];
                e.payload = Po(d, b);
                c.push(e);
            }
            return c;
        }
        function So(a) {
            var b = [];
            a = u(a);
            for(var c = a.next(), d = {}; !c.done; d = {
                Pg: void 0
            }, c = a.next())d.Pg = c.value, b.some(function(e) {
                return function(f) {
                    return Ce(e.Pg, f);
                };
            }(d)) || b.push(d.Pg);
            return b;
        }
        function To(a) {
            function b(d) {
                for(var e = 5381, f = d.length; f;)e = e * 33 ^ d.charCodeAt(--f);
                return (e >>> 0).toString();
            }
            if (a.startTime >= a.endTime) return null;
            var c = new VTTCue(a.startTime, a.endTime, a.payload);
            c.id = b(a.startTime.toString()) + b(a.endTime.toString()) + b(a.payload);
            c.lineAlign = a.lineAlign;
            c.positionAlign = a.positionAlign;
            a.size && (c.size = a.size);
            try {
                c.align = a.textAlign;
            } catch (d) {}
            a.textAlign == "center" && c.align != "center" && (c.align = "middle");
            a.writingMode == "vertical-lr" ? c.vertical = "lr" : a.writingMode == "vertical-rl" && (c.vertical = "rl");
            a.lineInterpretation == 1 && (c.snapToLines = !1);
            a.line != null && (c.line = a.line);
            a.position != null && (c.position = a.position);
            return c;
        }
        function Uo(a, b) {
            var c = Ro(b), d = [];
            b = a.cues ? Array.from(a.cues) : [];
            c = u(c);
            for(var e = c.next(), f = {}; !e.done; f = {
                Kd: void 0
            }, e = c.next())f.Kd = e.value, !b.some(function(g) {
                return function(h) {
                    return h.startTime == g.Kd.startTime && h.endTime == g.Kd.endTime && h.text == g.Kd.payload ? !0 : !1;
                };
            }(f)) && f.Kd.payload && (e = To(f.Kd)) && d.push(e);
            b = d.slice().sort(function(g, h) {
                return g.startTime != h.startTime ? g.startTime - h.startTime : g.endTime != h.endTime ? g.endTime - h.startTime : "line" in VTTCue.prototype ? d.indexOf(h) - d.indexOf(g) : d.indexOf(g) - d.indexOf(h);
            });
            b = u(b);
            for(c = b.next(); !c.done; c = b.next())a.addCue(c.value);
        }
        function Vo(a, b) {
            var c = !1;
            a.mode === "disabled" && (c = !0, a.mode = "hidden");
            for(var d = 0; d < a.cues.length;){
                var e = a.cues[d];
                b(e) ? a.removeCue(e) : d++;
            }
            c && (a.mode = "disabled");
        }
        function Wo(a) {
            var b = this;
            this.i = a;
            this.l = new Tc;
            this.j = null;
            this.h = new Map;
            this.g = -1;
            this.A = !1;
            this.u = null;
            this.D = function() {
                b.l.Ea(b.i, "textchanged", b.m);
                b.l.Ea(b.j.textTracks, "change", b.C);
                for(var c = u(b.h.values()), d = c.next(); !d.done; d = c.next())d.value.remove();
                b.h.clear();
                b.g = -1;
                b.j = null;
            };
            this.m = function() {
                var c = new Map, d = b.i.yc();
                d = u(d);
                for(var e = d.next(); !e.done; e = d.next()){
                    e = e.value;
                    if (b.h.has(e.id)) {
                        var f = b.h.get(e.id);
                        e.active || f.track.mode === "disabled" || (f.track.mode = "disabled");
                        b.h.delete(e.id);
                    } else {
                        f = b.j.ownerDocument.createElement("track");
                        f.kind = Xo(e);
                        var g = f, h = void 0;
                        if (e.label) h = e.label;
                        else if (e.language) {
                            if (e.language in Lo) h = Lo[e.language];
                            else {
                                var k = Dc(e.language);
                                k in Lo && (h = Lo[k] + " (" + e.language + ")");
                            }
                        }
                        h || (h = e.originalTextId, e.language && e.language !== e.originalTextId && (h += " (" + e.language + ")"));
                        g.label = h;
                        e.language in Lo && (f.srclang = e.language);
                        Rb().Ja() === "CHROMIUM" && (f.src = "data:,WEBVTT");
                        f.track.mode = "disabled";
                        b.j.appendChild(f);
                    }
                    c.set(e.id, f);
                    e.active && (b.g = e.id);
                }
                d = u(b.h.values());
                for(e = d.next(); !e.done; e = d.next())e.value.remove();
                b.g > -1 && (c.has(b.g) ? (d = c.get(b.g).track, d.mode === "disabled" && (d.mode = b.A ? "showing" : "hidden")) : b.g = -1);
                b.h = c;
            };
            this.C = function() {
                if (!b.u) {
                    var c = b.j;
                    b.u = new Bf(function() {
                        b.u = null;
                        if (b.j === c) {
                            var d = -1, e = !1;
                            if (b.h.has(b.g)) {
                                var f = b.h.get(b.g);
                                f.track.mode === "showing" ? (d = b.g, e = !0) : f.track.mode === "hidden" && (d = b.g);
                            }
                            if (!e) for(e = u(b.h), f = e.next(); !f.done; f = e.next()){
                                var g = u(f.value);
                                f = g.next().value;
                                g = g.next().value;
                                if (g.track.mode === "showing") {
                                    d = f;
                                    break;
                                } else d < 0 && g.track.mode === "hidden" && (d = f);
                            }
                            e = u(b.h);
                            for(f = e.next(); !f.done; f = e.next())g = u(f.value), f = g.next().value, g = g.next().value, f !== d && g.track.mode !== "disabled" && (g.track.mode = "disabled");
                            b.g !== d && (b.g = d, d > -1 && b.i.fg({
                                id: d
                            }));
                            b.i.Zd(d > -1 && b.h.get(d).track.mode === "showing");
                        }
                    }).$(0);
                }
            };
            this.l.o(a, "loaded", function() {
                return b.enableTextDisplayer();
            });
            this.enableTextDisplayer();
        }
        p = Wo.prototype;
        p.configure = function() {};
        p.remove = function(a, b) {
            if (this.i) this.h.has(this.g) && Vo(this.h.get(this.g).track, function(c) {
                return c.startTime < b && c.endTime > a;
            });
            else return !1;
            return !0;
        };
        p.append = function(a) {
            this.h.has(this.g) && Uo(this.h.get(this.g).track, a);
        };
        p.destroy = function() {
            this.i && (this.j && this.D(), this.i = null);
            this.l && (this.l.release(), this.l = null);
            return Promise.resolve();
        };
        p.isTextVisible = function() {
            return this.A;
        };
        p.setTextVisibility = function(a) {
            this.A = a;
            if (this.h.has(this.g)) {
                var b = this.h.get(this.g).track;
                b.mode !== "disabled" && (a = a ? "showing" : "hidden", b.mode !== a && (b.mode = a));
            } else if (this.i && this.i.l === 3) {
                if (b = Array.from(this.i.h.textTracks).filter(function(d) {
                    return [
                        "captions",
                        "subtitles",
                        "forced"
                    ].includes(d.kind);
                }), a) {
                    a = null;
                    b = u(b);
                    for(var c = b.next(); !c.done; c = b.next())if (c = c.value, c.mode === "showing") {
                        a = null;
                        break;
                    } else a || c.mode !== "hidden" || (a = c);
                    a && (a.mode = "showing");
                } else for(a = u(b), b = a.next(); !b.done; b = a.next())b = b.value, b.mode === "showing" && (b.mode = "hidden");
            }
        };
        p.setTextLanguage = function() {};
        p.enableTextDisplayer = function() {
            !this.j && this.i && this.i.l === 2 && (this.j = this.i.h, this.l.ua(this.i, "unloading", this.D), this.l.o(this.i, "textchanged", this.m), this.l.o(this.j.textTracks, "change", this.C), this.m());
        };
        function Xo(a) {
            var b = Rb();
            return a.forced && b.Ja() === "WEBKIT" ? "forced" : a.kind === "caption" || a.roles && a.roles.some(function(c) {
                return c.includes("transcribes-spoken-dialog");
            }) && a.roles.some(function(c) {
                return c.includes("describes-music-and-sound");
            }) ? "captions" : "subtitles";
        }
        S("shaka.text.NativeTextDisplayer", Wo);
        Wo.prototype.enableTextDisplayer = Wo.prototype.enableTextDisplayer;
        Wo.prototype.setTextLanguage = Wo.prototype.setTextLanguage;
        Wo.prototype.setTextVisibility = Wo.prototype.setTextVisibility;
        Wo.prototype.isTextVisible = Wo.prototype.isTextVisible;
        Wo.prototype.destroy = Wo.prototype.destroy;
        Wo.prototype.append = Wo.prototype.append;
        Wo.prototype.remove = Wo.prototype.remove;
        Wo.prototype.configure = Wo.prototype.configure;
        function Yo(a, b) {
            Zc("SimpleTextDisplayer", "Please migrate to NativeTextDisplayer");
            this.h = a;
            this.i = b;
            this.g = null;
            a = u(Array.from(this.h.textTracks));
            for(b = a.next(); !b.done; b = a.next())b = b.value, b.kind !== "metadata" && b.kind !== "chapters" && (b.mode = "disabled", b.label == this.i && (this.g = b));
            this.g && (this.g.mode = "hidden");
        }
        p = Yo.prototype;
        p.configure = function() {};
        p.remove = function(a, b) {
            if (!this.g) return !1;
            Vo(this.g, function(c) {
                return c.startTime < b && c.endTime > a;
            });
            return !0;
        };
        p.append = function(a) {
            this.g && Uo(this.g, a);
        };
        p.destroy = function() {
            this.g && (Vo(this.g, function() {
                return !0;
            }), this.g.mode = "disabled");
            this.g = this.h = null;
            return Promise.resolve();
        };
        p.isTextVisible = function() {
            return this.g ? this.g.mode == "showing" : !1;
        };
        p.setTextVisibility = function(a) {
            a && !this.g && Zo(this);
            this.g && (this.g.mode = a ? "showing" : "hidden");
        };
        p.setTextLanguage = function() {};
        p.enableTextDisplayer = function() {
            Zo(this);
        };
        function Zo(a) {
            a.h && !a.g && (a.g = a.h.addTextTrack("subtitles", a.i), a.g.mode = "hidden");
        }
        S("shaka.text.SimpleTextDisplayer", Yo);
        Yo.prototype.enableTextDisplayer = Yo.prototype.enableTextDisplayer;
        Yo.prototype.setTextLanguage = Yo.prototype.setTextLanguage;
        Yo.prototype.setTextVisibility = Yo.prototype.setTextVisibility;
        Yo.prototype.isTextVisible = Yo.prototype.isTextVisible;
        Yo.prototype.destroy = Yo.prototype.destroy;
        Yo.prototype.append = Yo.prototype.append;
        Yo.prototype.remove = Yo.prototype.remove;
        Yo.prototype.configure = Yo.prototype.configure;
        function $o() {}
        p = $o.prototype;
        p.configure = function() {};
        p.remove = function() {};
        p.append = function() {};
        p.destroy = function() {};
        p.isTextVisible = function() {
            return !1;
        };
        p.setTextVisibility = function() {};
        p.setTextLanguage = function() {};
        p.enableTextDisplayer = function() {};
        S("shaka.text.StubTextDisplayer", $o);
        $o.prototype.enableTextDisplayer = $o.prototype.enableTextDisplayer;
        $o.prototype.setTextLanguage = $o.prototype.setTextLanguage;
        $o.prototype.setTextVisibility = $o.prototype.setTextVisibility;
        $o.prototype.isTextVisible = $o.prototype.isTextVisible;
        $o.prototype.destroy = $o.prototype.destroy;
        $o.prototype.append = $o.prototype.append;
        $o.prototype.remove = $o.prototype.remove;
        $o.prototype.configure = $o.prototype.configure;
        function ap(a, b) {
            var c = this;
            this.m = !1;
            this.h = [];
            this.j = a;
            this.u = b;
            this.D = this.A = null;
            this.g = V("div");
            this.g.classList.add("shaka-text-container");
            this.g.style.textAlign = "center";
            this.g.style.display = "flex";
            this.g.style.flexDirection = "column";
            this.g.style.alignItems = "center";
            this.g.style.justifyContent = "flex-end";
            this.C = new Bf(function() {
                c.j.paused || bp(c);
            });
            cp(this);
            this.l = new Map;
            this.i = new Tc;
            this.i.o(document, "fullscreenchange", function() {
                bp(c, !0);
            });
            this.i.o(this.j, "seeking", function() {
                bp(c, !0);
            });
            this.i.o(this.j, "ratechange", function() {
                cp(c);
            });
            this.i.o(this.j, "resize", function() {
                var d = c.j, e = d.videoWidth;
                d = d.videoHeight;
                e && d ? c.A = e / d : c.A = null;
            });
            this.F = null;
            "ResizeObserver" in window1 && (this.F = new ResizeObserver(function() {
                bp(c, !0);
            }), this.F.observe(this.g));
            this.G = new Map;
        }
        p = ap.prototype;
        p.configure = function(a) {
            this.D = a;
            cp(this);
            bp(this, !0);
        };
        p.append = function(a) {
            var b = [].concat(x(this.h));
            a = u(So(a));
            for(var c = a.next(), d = {}; !c.done; d = {
                Qg: void 0
            }, c = a.next())d.Qg = c.value, b.some(function(e) {
                return function(f) {
                    return Ce(f, e.Qg);
                };
            }(d)) || this.h.push(d.Qg);
            this.h.length && cp(this);
            bp(this);
        };
        p.destroy = function() {
            if (!this.g) return Promise.resolve();
            this.g.parentElement && this.u.removeChild(this.g);
            this.g = null;
            this.m = !1;
            this.h = [];
            this.C && (this.C.stop(), this.C = null);
            this.l.clear();
            this.i && (this.i.release(), this.i = null);
            this.F && (this.F.disconnect(), this.F = null);
            return Promise.resolve();
        };
        p.remove = function(a, b) {
            if (!this.g) return !1;
            var c = this.h.length;
            this.h = this.h.filter(function(d) {
                return d.startTime < a || d.endTime >= b;
            });
            bp(this, c > this.h.length);
            this.h.length || cp(this);
            return !0;
        };
        p.isTextVisible = function() {
            return this.m;
        };
        p.setTextVisibility = function(a) {
            (this.m = a) ? (this.g.parentElement || this.u.appendChild(this.g), bp(this, !0)) : this.g.parentElement && this.u.removeChild(this.g);
        };
        p.setTextLanguage = function(a) {
            a && a != "und" ? this.g.setAttribute("lang", a) : this.g.setAttribute("lang", "");
        };
        p.enableTextDisplayer = function() {};
        function cp(a) {
            a.C && (a.h.length ? a.C.wa((a.D ? a.D.captionsUpdatePeriod : .25) / Math.max(1, Math.abs(a.j.playbackRate))) : a.C.stop());
        }
        function dp(a, b) {
            for(; b != null;){
                if (b == a.g) return !0;
                b = b.parentElement;
            }
            return !1;
        }
        function ep(a, b, c, d, e) {
            var f = !1, g = [], h = [];
            b = u(b);
            for(var k = b.next(); !k.done; k = b.next()){
                k = k.value;
                e.push(k);
                var l = a.l.get(k), m = k.startTime <= d && k.endTime > d, n = l ? l.hk : null;
                l && (g.push(l.Rg), l.qd && g.push(l.qd), m || (f = !0, a.l.delete(k), l = null));
                m && (h.push(k), l ? dp(a, n) || (f = !0) : (fp(a, k, e), l = a.l.get(k), n = l.hk, f = !0));
                k.nestedCues.length > 0 && n && ep(a, k.nestedCues, n, d, e);
                e.pop();
            }
            if (f) {
                d = u(g);
                for(e = d.next(); !e.done; e = d.next())e = e.value, e.parentElement && e.parentElement.removeChild(e);
                h.sort(function(q, r) {
                    return q.startTime != r.startTime ? q.startTime - r.startTime : q.endTime - r.endTime;
                });
                h = u(h);
                for(d = h.next(); !d.done; d = h.next())d = a.l.get(d.value), d.qd ? (d.qd.contains(c) && d.qd.removeChild(c), c.appendChild(d.qd), d.qd.appendChild(d.Rg)) : c.appendChild(d.Rg);
            }
        }
        function bp(a, b) {
            if (a.g) {
                var c = a.j.currentTime;
                if (!a.m || (b === void 0 ? 0 : b)) {
                    b = u(a.G.values());
                    for(var d = b.next(); !d.done; d = b.next())Pj(d.value);
                    Pj(a.g);
                    a.l.clear();
                    a.G.clear();
                }
                a.m && ep(a, a.h, a.g, c, []);
            }
        }
        function fp(a, b, c) {
            var d = c.length > 1, e = d ? "span" : "div";
            b.lineBreak && (e = "br");
            b.rubyTag && (e = b.rubyTag);
            d = !d && b.nestedCues.length > 0;
            var f = V(e);
            e != "br" && gp(a, f, b, c, d);
            c = null;
            if (b.region && b.region.id) {
                var g = b.region, h = a.A === 4 / 3 ? 2.5 : 1.9;
                c = g.id + "_" + g.width + "x" + g.height + (g.heightUnits == ud ? "%" : "px") + "-" + g.viewportAnchorX + "x" + g.viewportAnchorY + (g.viewportAnchorUnits == ud ? "%" : "px");
                if (a.G.has(c)) c = a.G.get(c);
                else {
                    e = V("span");
                    var k = g.heightUnits == ud ? "%" : "px", l = g.widthUnits == ud ? "%" : "px", m = g.viewportAnchorUnits == ud ? "%" : "px";
                    e.id = "shaka-text-region---" + c;
                    e.classList.add("shaka-text-region");
                    e.style.position = "absolute";
                    var n = g.height, q = g.width;
                    g.heightUnits === 2 && (n = g.height * 5.33, k = "%");
                    g.widthUnits === 2 && (q = g.width * h, l = "%");
                    e.style.height = n + k;
                    e.style.width = q + l;
                    g.viewportAnchorUnits === 2 ? (h = g.viewportAnchorY / 75 * 100, k = g.viewportAnchorX / (a.A === 4 / 3 ? 160 : 210) * 100, h -= g.regionAnchorY * n / 100, k -= g.regionAnchorX * q / 100, e.style.top = h + "%", e.style.left = k + "%") : (e.style.top = g.viewportAnchorY - g.regionAnchorY * n / 100 + m, e.style.left = g.viewportAnchorX - g.regionAnchorX * q / 100 + m);
                    g.heightUnits !== 0 && g.widthUnits !== 0 && g.viewportAnchorUnits !== 0 && (g = Math.max(0, Math.min(100 - (parseInt(e.style.width.slice(0, -1), 10) || 0), parseInt(e.style.left.slice(0, -1), 10) || 0)), e.style.top = Math.max(0, Math.min(100 - (parseInt(e.style.height.slice(0, -1), 10) || 0), parseInt(e.style.top.slice(0, -1), 10) || 0)) + "%", e.style.left = g + "%");
                    e.style.display = "flex";
                    e.style.flexDirection = "column";
                    e.style.alignItems = "center";
                    e.style.justifyContent = b.displayAlign == "before" ? "flex-start" : b.displayAlign == "center" ? "center" : "flex-end";
                    a.G.set(c, e);
                    c = e;
                }
            }
            e = f;
            d && (e = V("span"), e.classList.add("shaka-text-wrapper"), e.style.backgroundColor = b.backgroundColor, e.style.lineHeight = "normal", f.appendChild(e));
            a.l.set(b, {
                Rg: f,
                hk: e,
                qd: c
            });
        }
        function hp(a) {
            var b = a.direction, c = a.positionAlign;
            a = a.textAlign;
            return c !== se ? c : a === "left" || a === "start" && b === ue || a === "end" && b === "rtl" ? "line-left" : a === "right" || a === "start" && b === "rtl" || a === "end" && b === ue ? "line-right" : "center";
        }
        function gp(a, b, c, d, e) {
            var f = b.style, g = c.nestedCues.length == 0, h = d.length > 1;
            f.whiteSpace = "pre-wrap";
            var k = c.payload.replace(/\s+$/g, function(m) {
                return "\u00a0".repeat(m.length);
            });
            f.webkitTextStrokeColor = c.textStrokeColor;
            f.webkitTextStrokeWidth = c.textStrokeWidth;
            f.color = c.color;
            f.direction = c.direction;
            f.opacity = c.opacity;
            f.paddingLeft = ip(c.linePadding, c, a.u);
            f.paddingRight = ip(c.linePadding, c, a.u);
            f.textCombineUpright = c.textCombineUpright;
            f.textShadow = c.textShadow;
            if (c.backgroundImage) f.backgroundImage = "url('" + c.backgroundImage + "')", f.backgroundRepeat = "no-repeat", f.backgroundSize = "contain", f.backgroundPosition = "center", c.backgroundColor && (f.backgroundColor = c.backgroundColor), f.width = "100%", f.height = "100%";
            else {
                if (c.nestedCues.length) var l = b;
                else l = V("span"), b.appendChild(l);
                c.border && (l.style.border = c.border);
                e || ((b = jp(d, function(m) {
                    return m.backgroundColor;
                })) ? l.style.backgroundColor = b : k && (l.style.backgroundColor = "rgba(0, 0, 0, 0.8)"));
                k && (l.setAttribute("translate", "no"), l.textContent = k);
            }
            if (h && !d[d.length - 1].isContainer) f.display = "inline";
            else {
                f.display = "flex";
                f.flexDirection = "column";
                f.alignItems = "center";
                if (c.textAlign == "left" || c.textAlign == "start") f.width = "100%", f.alignItems = "start";
                else if (c.textAlign == "right" || c.textAlign == "end") f.width = "100%", f.alignItems = "end";
                f.justifyContent = c.displayAlign == "before" ? "flex-start" : c.displayAlign == "center" ? "center" : "flex-end";
            }
            g || (f.margin = "0");
            f.fontFamily = c.fontFamily;
            f.fontWeight = c.fontWeight.toString();
            f.fontStyle = c.fontStyle;
            f.letterSpacing = c.letterSpacing;
            f.fontSize = ip(c.fontSize, c, a.u, a.D ? a.D.fontScaleFactor : 1);
            d = c.line;
            d != null && (g = c.lineInterpretation, g == we && (g = 1, h = 16, a.A && a.A < 1 && (h = 32), d = d < 0 ? 100 + d / h * 100 : d / h * 100), g == 1 && (f.position = "absolute", c.writingMode == ve ? (f.width = "100%", c.lineAlign == xe ? f.top = d + "%" : c.lineAlign == "end" && (f.bottom = 100 - d + "%")) : c.writingMode == "vertical-lr" ? (f.height = "100%", c.lineAlign == xe ? f.left = d + "%" : c.lineAlign == "end" && (f.right = 100 - d + "%")) : (f.height = "100%", c.lineAlign == xe ? f.right = d + "%" : c.lineAlign == "end" && (f.left = 100 - d + "%"))));
            f.lineHeight = c.lineHeight;
            a = hp(c);
            a == "line-left" ? (f.cssFloat = "left", c.position !== null && (f.position = "absolute", c.writingMode == ve ? (f.left = c.position + "%", f.width = "auto") : f.top = c.position + "%")) : a == "line-right" ? (f.cssFloat = "right", c.position !== null && (f.position = "absolute", c.writingMode == ve ? (f.right = 100 - c.position + "%", f.width = "auto") : f.bottom = c.position + "%")) : c.position !== null && c.position != 50 && (f.position = "absolute", c.writingMode == ve ? (f.left = c.position + "%", f.width = "auto") : f.top = c.position + "%", c.size && (f.transform = "translateX(-50%)"));
            f.textAlign = c.textAlign;
            f.textDecoration = c.textDecoration.join(" ");
            f.writingMode = c.writingMode;
            "writingMode" in document.documentElement.style && f.writingMode == c.writingMode || (f.webkitWritingMode = c.writingMode);
            c.size && (c.writingMode == ve ? f.width = c.size + "%" : f.height = c.size + "%");
        }
        function ip(a, b, c, d) {
            d = d === void 0 ? 1 : d;
            var e = (e = new RegExp(/(\d*\.?\d+)([a-z]+|%+)/).exec(a)) ? {
                value: Number(e[1]),
                unit: e[2]
            } : null;
            if (!e) return a;
            a = e.unit;
            d *= e.value;
            switch(a){
                case "%":
                    return d / 100 * c.clientHeight / b.cellResolution.rows + "px";
                case "c":
                    return c.clientHeight * d / b.cellResolution.rows + "px";
                default:
                    return d + a;
            }
        }
        function jp(a, b) {
            for(var c = a.length - 1; c >= 0; c--){
                var d = b(a[c]);
                if (d || d === 0) return d;
            }
            return null;
        }
        S("shaka.text.UITextDisplayer", ap);
        ap.prototype.enableTextDisplayer = ap.prototype.enableTextDisplayer;
        ap.prototype.setTextLanguage = ap.prototype.setTextLanguage;
        ap.prototype.setTextVisibility = ap.prototype.setTextVisibility;
        ap.prototype.isTextVisible = ap.prototype.isTextVisible;
        ap.prototype.remove = ap.prototype.remove;
        ap.prototype.destroy = ap.prototype.destroy;
        ap.prototype.append = ap.prototype.append;
        ap.prototype.configure = ap.prototype.configure;
        function kp(a, b) {
            function c(f) {
                for(var g = f, h = u(b), k = h.next(); !k.done; k = h.next())k = k.value, k.end && k.start < f && (g += k.end - k.start);
                f = Math.floor(g / 3600);
                h = Math.floor(g / 60 % 60);
                k = Math.floor(g % 60);
                g = Math.floor(g * 1E3 % 1E3);
                return (f < 10 ? "0" : "") + f + ":" + (h < 10 ? "0" : "") + h + ":" + (k < 10 ? "0" : "") + k + "." + (g < 100 ? g < 10 ? "00" : "0" : "") + g;
            }
            var d = Ro(a);
            a = "WEBVTT\n\n";
            d = u(d);
            for(var e = d.next(); !e.done; e = d.next())e = e.value, a += c(e.startTime) + " --\x3e " + c(e.endTime) + function(f) {
                var g = [];
                switch(f.textAlign){
                    case "left":
                        g.push("align:left");
                        break;
                    case "right":
                        g.push("align:right");
                        break;
                    case te:
                        g.push("align:middle");
                        break;
                    case "start":
                        g.push("align:start");
                        break;
                    case "end":
                        g.push("align:end");
                }
                switch(f.writingMode){
                    case "vertical-lr":
                        g.push("vertical:lr");
                        break;
                    case "vertical-rl":
                        g.push("vertical:rl");
                }
                return g.length ? " " + g.join(" ") : "";
            }(e) + "\n", a += e.payload + "\n\n";
            return a;
        }
        S("shaka.text.WebVttGenerator", function() {});
        function lp(a, b) {
            this.g = b;
            this.j = a;
            this.F = new Map;
            this.l = void 0;
            this.D = !1;
            this.J = !0;
            this.u = this.I = !1;
            this.C = this.A = void 0;
            this.H = 0;
            this.K = {
                request: !1,
                response: !1,
                event: !1
            };
            this.m = {};
            this.i = new Tc;
            this.G = [];
            this.h = null;
        }
        lp.prototype.setMediaElement = function(a) {
            this.h = a;
            mp(this);
        };
        lp.prototype.configure = function(a) {
            this.g = a;
            np(this);
        };
        function op(a) {
            a.F.clear();
            a.D = !1;
            a.J = !0;
            a.I = !1;
            a.u = !1;
            a.A = 0;
            a.C = 0;
            a.H = 0;
            a.K = {
                request: !1,
                response: !1,
                event: !1
            };
            pp(a);
            a.m = {};
            a.h = null;
            a.i.Sa();
        }
        function qp(a, b) {
            a.u = b;
            a.u ? a.l == rp ? a.l = sp : a.l == tp && (a.l = up) : a.l == sp ? a.l = rp : a.l == up && (a.l = tp);
        }
        function vp(a, b) {
            if (a.g && a.g.enabled && (wp(a, "ps", {
                td: "d"
            }), a.h && a.h.autoplay)) {
                var c = a.h.play();
                c && c.then(function() {
                    a.H = b;
                }).catch(function() {
                    a.H = 0;
                });
            }
        }
        function xp(a, b, c) {
            try {
                if (!a.g.enabled) return b;
                var d = yp(a);
                a: {
                    switch(c.toLowerCase()){
                        case "audio/mp4":
                        case "audio/webm":
                        case "audio/ogg":
                        case "audio/mpeg":
                        case "audio/aac":
                        case "audio/flac":
                        case "audio/wav":
                            var e = zp;
                            break a;
                        case "video/webm":
                        case "video/mp4":
                        case "video/mpeg":
                        case "video/mp2t":
                            e = Ap;
                            break a;
                        case "application/x-mpegurl":
                        case "application/vnd.apple.mpegurl":
                        case "application/dash+xml":
                        case "video/vnd.mpeg.dash.mpd":
                        case "application/vnd.ms-sstr+xml":
                            e = Bp;
                            break a;
                    }
                    e = void 0;
                }
                d.ot = e;
                d.su = !0;
                var f = Cp(d);
                return Dp(b, f);
            } catch (g) {
                return bb("CMCD_SRC_ERROR", "Could not generate src CMCD data.", g), b;
            }
        }
        function mp(a) {
            a.i.o(a.h, "playing", function() {
                a.C || (a.C = Date.now());
                wp(a, "ps", {
                    td: "p"
                });
            });
            a.i.o(a.h, "volumechange", function() {
                wp(a, a.h.muted ? "m" : "um");
            });
            a.i.o(a.h, "play", function() {
                a.A || (a.A = Date.now(), wp(a, "ps", {
                    td: "s"
                }));
            });
            a.i.o(a.h, "pause", function() {
                wp(a, "ps", {
                    td: "a"
                });
            });
            a.i.o(a.j, "buffering", function() {
                wp(a, "ps", {
                    td: "w"
                });
            });
            a.i.o(a.h, "seeking", function() {
                return wp(a, "ps", {
                    td: "k"
                });
            });
            a.i.o(document, "fullscreenchange", function() {
                wp(a, document.fullscreenElement ? "pe" : "pc");
            });
            var b = a.h;
            (b.webkitPresentationMode || b.webkitSupportsFullscreen) && a.i.o(b, "webkitpresentationmodechanged", function() {
                b.webkitPresentationMode ? wp(a, b.webkitPresentationMode !== "inline" ? "pe" : "pc") : b.webkitSupportsFullscreen && wp(a, b.webkitDisplayingFullscreen ? "pe" : "pc");
            });
            a.i.o(a.h, "enterpictureinpicture", function() {
                wp(a, "pe");
            });
            a.i.o(a.h, "leavepictureinpicture", function() {
                wp(a, "pc");
            });
            "documentPictureInPicture" in window1 && a.i.o(window1.documentPictureInPicture, "enter", function(c) {
                wp(a, "pe");
                a.i.ua(c.window, "pagehide", function() {
                    wp(a, "pc");
                });
            });
            a.i.o(document, "visibilitychange", function() {
                document.hidden ? wp(a, "b", {
                    bg: !0
                }) : wp(a, "b");
            });
            a.i.o(a.j, "complete", function() {
                wp(a, "ps", {
                    td: "e"
                });
            });
        }
        function np(a) {
            pp(a);
            var b = Ep(a);
            b = u(b);
            for(var c = b.next(); !c.done; c = b.next())if (c = c.value.timeInterval, c === void 0 && (c = Fp), c >= 1) {
                var d = new Bf(function() {
                    return wp(a, Gp);
                });
                d.wa(c);
                a.G.push(d);
            }
        }
        function pp(a) {
            if (a.G) for(var b = u(a.G), c = b.next(); !c.done; c = b.next())c.value.stop();
            a.G = [];
        }
        function Ep(a) {
            return (a = a.g.targets) ? a.filter(function(b) {
                return b.mode === Hp && b.enabled;
            }) : [];
        }
        function yp(a) {
            a.g.sessionId || (a.g.sessionId = window1.crypto.randomUUID());
            return {
                v: a.g.version,
                sf: a.l,
                sid: a.g.sessionId,
                cid: a.g.contentId,
                mtp: a.j.getBandwidthEstimate() / 1E3
            };
        }
        function wp(a, b, c) {
            c = c === void 0 ? {} : c;
            b = Object.assign({
                e: b,
                ts: Date.now()
            }, c);
            b = Ip(a, b, Hp);
            c = a.g.targets;
            if (!(a.g.version < Jp) && c) {
                var d = Ep(a);
                c = Array.from(new Set([].concat(x(Kp), x(Lp))));
                d = u(d);
                for(var e = d.next(); !e.done; e = d.next()){
                    e = e.value;
                    var f = Mp(e.includeKeys || [], c);
                    f.includes(Np) || f.push(Np);
                    f = Op(b, f);
                    var g = e.events || [], h = f.e, k = f.sta;
                    h && (!Pp.includes(h) || !(h !== "ps" || k && Qp.includes(k)) || g && g.length > 0 && !g.includes(h)) || Rp(a, f, e);
                }
            }
        }
        function Sp(a, b, c) {
            if (a.g.enabled) {
                c = Ip(a, c, Tp);
                var d = Up({
                    mode: Tp,
                    useHeaders: a.g.useHeaders,
                    includeKeys: a.g.includeKeys || []
                });
                a.m[d] || (a.m[d] = {
                    request: 1,
                    response: 1
                });
                c.sn = a.m[d].request++;
                d = a.g.includeKeys || [];
                var e = a.g.version == Jp ? Array.from(new Set([].concat(x(Kp), x(iq)))) : jq;
                d = Mp(d, e);
                c = Op(c, d);
                kq(c, b, a.g.useHeaders);
            }
        }
        function lq(a, b, c) {
            var d = a.g.targets;
            if (d) {
                var e = d.filter(function(k) {
                    return k.mode === mq && k.enabled === !0;
                });
                d = a.g.version == Jp ? Array.from(new Set([].concat(x(Kp), x(nq)))) : jq;
                c.rc = b.status || 0;
                c = Ip(a, c, mq);
                b.headers && b.headers["CMSD-Static"] && (c.cmsds = btoa(b.headers["CMSD-Static"]));
                b.headers && b.headers["CMSD-Dynamic"] && (c.cmsdd = btoa(b.headers["CMSD-Dynamic"]));
                e = u(e);
                for(var f = e.next(); !f.done; f = e.next()){
                    f = f.value;
                    var g = Mp(f.includeKeys || [], d), h = Up(f);
                    a.m[h] || (a.m[h] = {
                        request: 1,
                        response: 1
                    });
                    c.sn = a.m[h].response++;
                    g = Op(c, g);
                    Rp(a, g, f, b);
                }
            }
        }
        function Rp(a, b, c, d) {
            var e = Fg(), f = c.url;
            if (c.useHeaders) {
                b = oq(b);
                if (!Object.keys(b).length) return;
                d && Object.assign(d.headers, b);
                d = $g([
                    f
                ], e);
                Object.assign(d.headers, b);
            } else {
                b = Cp(b);
                if (!b) return;
                f = Dp(f, b);
                d && (d.uri = f);
                d = $g([
                    f
                ], e);
            }
            a.j.Vb().request(9, d);
        }
        function kq(a, b, c) {
            if (c) a = oq(a), Object.keys(a).length && Object.assign(b.headers, a);
            else {
                var d = Cp(a);
                d && (b.uris = b.uris.map(function(e) {
                    return Dp(e, d);
                }));
            }
        }
        function Mp(a, b) {
            if (!a || a.length === 0) return b;
            for(var c = u(a), d = c.next(); !d.done; d = c.next())b.includes(d.value);
            return a = a.filter(function(e) {
                return b.includes(e);
            });
        }
        function Op(a, b) {
            return Object.keys(a).reduce(function(c, d) {
                b.includes(d) && (c[d] = a[d]);
                return c;
            }, {});
        }
        function pq(a) {
            if (a.type === 0) return qq;
            if (a = a.stream) {
                var b = a.type;
                if (b == "video") return a.codecs && a.codecs.includes(",") ? Ap : rq;
                if (b == "audio") return zp;
                if (b == "text") return a.mimeType === "application/mp4" ? sq : tq;
            }
        }
        function Up(a) {
            var b = Object.keys(a).sort().reduce(function(c, d) {
                d !== "enabled" && (c[d] = a[d]);
                return c;
            }, {});
            return JSON.stringify(b);
        }
        function uq(a, b) {
            b = a.j.Pc()[b];
            if (!b.length) return NaN;
            var c = a.h ? a.h.currentTime : 0;
            return (a = b.find(function(d) {
                return d.start <= c && d.end >= c;
            })) ? (a.end - c) * 1E3 : NaN;
        }
        function vq(a, b) {
            b = a.j.Pc()[b];
            if (!b.length) return 0;
            var c = a.h ? a.h.currentTime : 0;
            return (a = b.find(function(d) {
                return d.start <= c && d.end >= c;
            })) ? (a.end - c) * 1E3 : 0;
        }
        function wq(a, b) {
            var c = a.j.Ob();
            if (!c.length) return NaN;
            a = c[0];
            c = u(c);
            for(var d = c.next(); !d.done; d = c.next())d = d.value, d.type === "variant" && d.bandwidth > a.bandwidth && (a = d);
            switch(b){
                case rq:
                    return a.videoBandwidth || NaN;
                case zp:
                    return a.audioBandwidth || NaN;
                default:
                    return a.bandwidth;
            }
        }
        function xq(a, b, c) {
            var d = b.segment, e = 0;
            d && (e = d.endTime - d.startTime);
            e = {
                d: e * 1E3,
                st: a.j.U() ? yq : zq
            };
            e.ot = pq(b);
            var f = e.ot === rq || e.ot === zp || e.ot === Ap || e.ot === sq;
            if (b = b.stream) {
                var g = a.j.Za();
                if (f && (e.bl = uq(a, b.type), e.ot !== sq)) {
                    var h = vq(a, b.type);
                    e.dl = g ? h / Math.abs(g) : h;
                }
                b.bandwidth && (e.br = b.bandwidth / 1E3);
                if (b.segmentIndex && d) {
                    if ((g = b.segmentIndex.ec(d.endTime, !0, g < 0)) && (g = g.next().value) && g != d) {
                        if (c && !Sc(d.T(), g.T())) {
                            h = g.T()[0];
                            var k = new URL(h);
                            c = new URL(c);
                            if (k.origin !== c.origin) c = h;
                            else {
                                h = k.pathname.split("/").slice(1);
                                for(c = c.pathname.split("/").slice(1, -1); h[0] === c[0];)h.shift(), c.shift();
                                for(; c.length;)c.shift(), h.unshift("..");
                                c = h.join("/");
                            }
                            e.nor = c;
                        }
                        !g.startByte && !g.endByte || d.startByte == g.startByte && d.endByte == g.endByte || (c = g.startByte + "-", g.endByte && (c += g.endByte), e.nrr = c);
                    }
                    c = a.j.Za() || 1;
                    g = vq(a, b.type) || 500;
                    d = (b = b.bandwidth) ? b * (d.endTime - d.startTime) / 1E3 / (g / c / 1E3) * a.g.rtpSafetyFactor : NaN;
                    isNaN(d) || (e.rtp = d);
                }
            }
            f && e.ot !== sq && (e.tb = wq(a, e.ot) / 1E3);
            return e;
        }
        function Ip(a, b, c) {
            Object.assign(b, yp(a));
            b.pr = a.j.Za();
            var d = b.ot === rq || b.ot === Ap;
            a.I && d && (b.bs = !0, b.su = !0, a.I = !1);
            b.su == null && (b.su = a.J);
            a.j.U() && (d = Aq(a.j), b.ltc = d || void 0);
            document.hidden && (b.bg = !0);
            d = a.C && a.A ? a.C - (a.H || a.A) : void 0;
            d == void 0 || a.K[c] || (b.msd = d, a.K[c] = !0);
            return b;
        }
        function Cp(a) {
            function b(n) {
                return c(n / 100) * 100;
            }
            function c(n) {
                return Math.round(n);
            }
            function d(n) {
                return !Number.isNaN(n) && n != null && n !== "" && n !== !1;
            }
            var e = [], f = {
                br: c,
                d: c,
                bl: b,
                dl: b,
                mtp: b,
                nor: function(n) {
                    return encodeURIComponent(n);
                },
                rtp: b,
                tb: c,
                ttfb: c,
                ttlb: c
            }, g = Object.keys(a || {}).sort();
            g = u(g);
            for(var h = g.next(); !h.done; h = g.next()){
                h = h.value;
                var k = a[h];
                if (d(k) && (h !== "v" || k !== 1) && (h != "pr" || k !== 1)) {
                    var l = f[h];
                    l && (k = l(k));
                    l = typeof k;
                    var m = void 0;
                    m = l === "string" && h !== "ot" && h !== "sf" && h !== "st" ? h + "=" + JSON.stringify(k) : l === "boolean" ? h : l === "symbol" ? h + "=" + k.description : h + "=" + k;
                    e.push(m);
                }
            }
            return e.join(",");
        }
        function oq(a) {
            var b = Object.keys(a), c = {}, d = [
                "Object",
                "Request",
                "Session",
                "Status"
            ], e = [
                {},
                {},
                {},
                {}
            ], f = {
                br: 0,
                d: 0,
                ot: 0,
                tb: 0,
                url: 0,
                bl: 1,
                dl: 1,
                mtp: 1,
                nor: 1,
                nrr: 1,
                su: 1,
                ltc: 1,
                ttfb: 1,
                ttlb: 1,
                ts: 1,
                rc: 1,
                cmsdd: 1,
                cmsds: 1,
                sn: 1,
                cid: 2,
                pr: 2,
                sf: 2,
                sid: 2,
                st: 2,
                v: 2,
                msd: 2,
                bs: 3,
                rtp: 3,
                bg: 3
            };
            b = u(b);
            for(var g = b.next(); !g.done; g = b.next())g = g.value, e[f[g] != null ? f[g] : 1][g] = a[g];
            for(a = 0; a < e.length; a++)(f = Cp(e[a])) && (c["CMCD-" + d[a]] = f);
            return c;
        }
        function Dp(a, b) {
            if (!b || a.includes("offline:")) return a;
            a = new qb(a);
            a.g.set("CMCD", b);
            return a.toString();
        }
        var Bp = "m", zp = "a", rq = "v", Ap = "av", qq = "i", tq = "c", sq = "tt", Jp = 2, zq = "v", yq = "l", rp = "d", sp = "ld", tp = "h", up = "lh";
        S("shaka.util.CmcdManager.StreamingFormat", {
            DASH: rp,
            hn: sp,
            HLS: tp,
            jn: up,
            zn: "s",
            OTHER: "o"
        });
        var jq = "br bl bs cid d dl mtp nor nrr ot pr rtp sf sid st su tb v".split(" "), Kp = "br ab bl tbl bs cdn cid ltc mtp pr sf sid bg sta st ts tpb tb lb tab lab pt ec msd v sn".split(" "), iq = "ab bl tbl bs cdn cid d dl ltc mtp nor ot pr rtp sf sid bg sta st su ts tpb tb lb tab lab pt ec msd v".split(" "), nq = "d dl nor ot rtp rc su ttfb ttfbb ttlb url cmsdd cmsds".split(" "), Lp = [
            "e",
            "sta"
        ], Pp = "ps e t c b m um pe pc".split(" "), Qp = "spawkrfeqd".split(""), Fp = 10, Np = "ts", Gp = "t", Tp = "request", mq = "response", Hp = "event";
        function Bq(a) {
            this.h = a;
            this.g = null;
        }
        p = Bq.prototype;
        p.configure = function(a) {
            this.h = a;
        };
        p.Yi = function() {
            return this.h.enabled && this.h.applyMaximumSuggestedBitrate && this.g && this.g.has(Cq) ? this.g.get(Cq) * 1E3 : null;
        };
        p.Xi = function() {
            return this.h.enabled && this.g && this.g.has(Dq) ? this.g.get(Dq) * 1E3 : null;
        };
        p.hl = function() {
            return this.h.enabled && this.g && this.g.has(Eq) ? this.g.get(Eq) : null;
        };
        p.il = function() {
            return this.h.enabled && this.g && this.g.has(Fq) ? this.g.get(Fq) : null;
        };
        p.getBandwidthEstimate = function(a) {
            var b = this.Xi();
            if (!b) return a;
            var c = this.h.estimatedThroughputWeightRatio;
            return c > 0 && c <= 1 ? a * (1 - c) + b * c : a;
        };
        function Gq(a) {
            return a ? a.toLowerCase() === "false" ? !1 : /^[-0-9]/.test(a) ? parseInt(a, 10) : a.replace(/["]+/g, "") : !0;
        }
        S("shaka.util.CmsdManager", Bq);
        Bq.prototype.getBandwidthEstimate = Bq.prototype.getBandwidthEstimate;
        Bq.prototype.getRoundTripTime = Bq.prototype.il;
        Bq.prototype.getResponseDelay = Bq.prototype.hl;
        Bq.prototype.getEstimatedThroughput = Bq.prototype.Xi;
        Bq.prototype.getMaxBitrate = Bq.prototype.Yi;
        var Dq = "etp", Cq = "mb", Eq = "rd", Fq = "rtt";
        function Hq() {
            this.g = null;
            this.h = [];
        }
        function Iq(a, b) {
            return Q(function(c) {
                if (c.g == 1) return a.g ? F(c, new Promise(function(d) {
                    return a.h.push(d);
                }), 2) : c.B(2);
                a.g = b;
                H(c);
            });
        }
        Hq.prototype.release = function() {
            this.h.length > 0 ? this.h.shift()() : this.g = null;
        };
        function X(a, b, c) {
            b = b === void 0 ? null : b;
            kb.call(this);
            var d = this;
            this.l = Jq;
            this.h = null;
            this.Oe = b;
            this.X = !1;
            this.Ze = new Tc;
            this.Pe = new Tc;
            this.j = new Tc;
            this.kc = new Tc;
            this.Hc = new Tc;
            this.G = this.H = this.F = this.J = null;
            this.bf = 0;
            this.ea = new Hq;
            this.O = this.Y = this.V = this.i = this.Ec = this.I = this.m = this.Le = this.R = this.Ei = this.ra = this.K = this.fb = this.Fa = this.Me = this.P = this.Ma = this.L = this.jb = null;
            this.aa = !1;
            this.Ue = this.u = null;
            this.Te = 1E9;
            this.Ye = [];
            this.ib = [];
            this.Bg = -1;
            this.g = Kq(this);
            this.Dg = ao();
            this.S = null;
            this.cf = -1;
            this.Pb = null;
            this.sa = {
                width: Infinity,
                height: Infinity
            };
            this.Se = new ui(this.g, this.sa, null);
            this.We = [];
            this.C = null;
            this.M = this.g.adaptationSetCriteriaFactory();
            this.M.configure({
                language: this.g.preferredAudioLanguage,
                role: this.g.preferredAudioRole,
                videoRole: this.g.preferredVideoRole,
                channelCount: 0,
                hdrLevel: this.g.preferredVideoHdrLevel,
                spatialAudio: this.g.preferSpatialAudio,
                videoLayout: this.g.preferredVideoLayout,
                audioLabel: this.g.preferredAudioLabel,
                videoLabel: this.g.preferredVideoLabel,
                codecSwitchingStrategy: this.g.mediaSource.codecSwitchingStrategy,
                audioCodec: "",
                activeAudioCodec: "",
                activeAudioChannelCount: 0,
                preferredAudioCodecs: this.g.preferredAudioCodecs,
                preferredAudioChannelCount: this.g.preferredAudioChannelCount
            });
            this.Ic = this.g.preferredTextLanguage;
            this.be = this.g.preferredTextRole;
            this.Re = this.g.preferForcedSubs;
            this.Qe = [];
            c && c(this);
            this.K = new lp(this, this.g.cmcd);
            this.ra = new Bq(this.g.cmsd);
            this.J = Lq(this);
            this.Vd = this.oa = this.xa = this.D = null;
            this.Fg = !1;
            this.Cg = [];
            this.Eg = new Bf(function() {
                return Q(function(e) {
                    if (e.g == 1) return d.oa ? F(e, d.cc(d.Vd, !0), 3) : e.B(0);
                    if (e.g != 4) return F(e, d.load(d.oa), 4);
                    d.Fg ? d.Vd.pause() : d.Vd.play();
                    d.oa = null;
                    d.Fg = !1;
                    H(e);
                });
            });
            Mq && (this.D = Mq(), this.D.configure(this.g.ads), this.Hc.o(this.D, "ad-content-pause-requested", function(e) {
                var f;
                return Q(function(g) {
                    if (g.g == 1) {
                        d.Eg.stop();
                        if (d.oa) return g.B(0);
                        d.Vd = d.h;
                        d.Fg = d.isEnded();
                        f = e.saveLivePosition || !1;
                        return F(g, d.Si(!0, f), 3);
                    }
                    d.oa = g.h;
                    H(g);
                });
            }), this.Hc.o(this.D, "ad-content-resume-requested", function(e) {
                e = e.offset || 0;
                if (d.oa) {
                    var f = d.oa;
                    f.m && e && (typeof f.m === "number" ? f.m += e : f.m.setTime(f.m.getTime() + e * 1E3));
                }
                d.Eg.$(.1);
            }), this.Hc.o(this.D, "ad-content-attach-requested", function() {
                return Q(function(e) {
                    return d.h || !d.Vd ? e.B(0) : F(e, d.cc(d.Vd, !0), 0);
                });
            }));
            Nq && (this.xa = Nq(this), this.xa.configure(this.g.queue));
            this.Ze.o(window1, "online", function() {
                Oq(d);
                d.Xh();
            });
            this.Ve = new Bf(function() {
                for(var e = Date.now() / 1E3, f = !1, g = !0, h = u(d.i.variants), k = h.next(); !k.done; k = h.next())k = k.value, k.disabledUntilTime > 0 && k.disabledUntilTime <= e && (k.disabledUntilTime = 0, f = !0), k.disabledUntilTime > 0 && (g = !1);
                g && d.Ve.stop();
                f && Pq(d, !1, void 0, !1, !1);
            });
            this.Oa = null;
            a && (Zc("Player w/ mediaElement", "Please migrate from initializing Player with a mediaElement; use the attach method instead."), this.cc(a, !0));
            this.A = null;
        }
        la(X, kb);
        function Qq(a) {
            a.R != null && (ed(a.R), a.R.release(), a.R = null);
        }
        function Rq(a, b, c) {
            c || b.lcevc.enabled ? (Qq(a), a.R == null && (a.R = new cd(a.h, a.Ei, b.lcevc, c), a.H && (a.H.H = a.R))) : Qq(a);
        }
        function Sq(a, b) {
            return new T(a, b);
        }
        p = X.prototype;
        p.destroy = function() {
            var a = this, b;
            return Q(function(c) {
                switch(c.g){
                    case 1:
                        if (a.l == Tq) return c.return();
                        Qq(a);
                        b = a.detach();
                        a.l = Tq;
                        return F(c, b, 2);
                    case 2:
                        return F(c, a.Ug(), 3);
                    case 3:
                        a.Ze && (a.Ze.release(), a.Ze = null);
                        a.Pe && (a.Pe.release(), a.Pe = null);
                        a.j && (a.j.release(), a.j = null);
                        a.kc && (a.kc.release(), a.kc = null);
                        a.Hc && (a.Hc.release(), a.Hc = null);
                        a.Ue = null;
                        a.g = null;
                        a.C = null;
                        a.Oe = null;
                        a.K = null;
                        a.ra = null;
                        if (!a.J) {
                            c.B(4);
                            break;
                        }
                        return F(c, a.J.destroy(), 5);
                    case 5:
                        a.J = null;
                    case 4:
                        a.u && (a.u.release(), a.u = null), a.xa && (a.xa.destroy(), a.xa = null), kb.prototype.release.call(a), H(c);
                }
            });
        };
        function Uq(a, b) {
            Vq.set(a, b);
        }
        function Wq() {
            window1.Promise || ab("A Promise implementation or polyfill is required");
            if (!(window1.Promise && window1.Uint8Array && Array.prototype.forEach) || (navigator.userAgent || "").includes("Trident/")) return !1;
            Rb();
            return Fi() ? !0 : Gi().canPlayType("application/x-mpegurl") != "";
        }
        function Xq(a, b) {
            a.dispatchEvent(Sq("onstatechange", (new Map).set("state", b)));
        }
        p.cc = function(a, b) {
            b = b === void 0 ? !0 : b;
            var c = this, d, e, f;
            return Q(function(g) {
                switch(g.g){
                    case 1:
                        if (c.l == Tq) throw new U(2, 7, 7E3);
                        d = c.h && c.h == a;
                        if (!c.h || c.h == a) {
                            g.B(2);
                            break;
                        }
                        return F(g, c.detach(), 2);
                    case 2:
                        return F(g, Yq(c, "attach"), 4);
                    case 4:
                        if (g.h) return g.return();
                        ra(g, 5, 6);
                        d || (Xq(c, "attach"), e = function() {
                            var h = Zq(c, !1);
                            h && $q(c, h);
                        }, c.Pe.o(a, "error", e), c.h = a, c.K && c.K.setMediaElement(a));
                        Rb();
                        if (!b || !Fi() || c.H) {
                            g.B(6);
                            break;
                        }
                        return F(g, ar(c), 6);
                    case 6:
                        va(g);
                        c.ea.release();
                        xa(g, 0);
                        break;
                    case 5:
                        return f = ua(g), F(g, c.detach(), 10);
                    case 10:
                        throw f;
                }
            });
        };
        p.Gi = function(a) {
            this.Ei = a;
        };
        p.detach = function(a) {
            a = a === void 0 ? !1 : a;
            var b = this;
            return Q(function(c) {
                if (c.g == 1) {
                    if (b.l == Tq) throw new U(2, 7, 7E3);
                    return F(c, b.tc(!1, a), 2);
                }
                if (c.g != 3) return F(c, Yq(b, "detach"), 3);
                if (c.h) return c.return();
                try {
                    b.h && (b.Pe.Sa(), b.h = null), Xq(b, "detach"), b.D && !a && b.D.release();
                } finally{
                    b.ea.release();
                }
                H(c);
            });
        };
        function Yq(a, b) {
            var c;
            return Q(function(d) {
                return d.g == 1 ? (c = ++a.bf, F(d, Iq(a.ea, b), 2)) : c != a.bf ? (a.ea.release(), d.return(!0)) : d.return(!1);
            });
        }
        p.tc = function(a, b) {
            a = a === void 0 ? !0 : a;
            b = b === void 0 ? !1 : b;
            var c = this, d, e, f, g, h, k, l, m, n, q, r, t, w;
            return Q(function(v) {
                switch(v.g){
                    case 1:
                        return c.l != Tq && (c.l = Jq), F(v, Yq(c, "unload"), 2);
                    case 2:
                        if (v.h) return v.return();
                        sa(v, 3);
                        c.aa = !1;
                        Xq(c, "unload");
                        Qq(c);
                        d = c.Qe.map(function(z) {
                            return z();
                        });
                        c.Qe = [];
                        return F(v, Promise.all(d), 5);
                    case 5:
                        c.dispatchEvent(Sq("unloading"));
                        c.Me && (c.Me.release(), c.Me = null);
                        c.Fa && (c.Fa.release(), c.Fa = null);
                        c.fb && (c.fb.release(), c.fb = null);
                        c.h && (c.j.Sa(), c.kc.Sa());
                        c.Ve.stop();
                        c.jb && (c.jb.release(), c.jb = null);
                        c.Ma && (c.Ma.stop(), c.Ma = null);
                        if (!c.I) {
                            v.B(6);
                            break;
                        }
                        return F(v, c.I.stop(), 7);
                    case 7:
                        c.I = null, c.Ec = null;
                    case 6:
                        c.u && c.u.stop();
                        if (!c.m) {
                            v.B(8);
                            break;
                        }
                        return F(v, c.m.destroy(), 9);
                    case 9:
                        c.m = null;
                    case 8:
                        c.L && (c.L.release(), c.L = null);
                        c.G && (c.G.release(), c.G = null);
                        if ("webkit" !== window1.shakaMediaKeysPolyfill || !c.F) {
                            v.B(10);
                            break;
                        }
                        return F(v, c.F.destroy(), 11);
                    case 11:
                        c.F = null;
                    case 10:
                        if (!c.H) {
                            v.B(12);
                            break;
                        }
                        return F(v, c.H.destroy(), 13);
                    case 13:
                        c.H = null;
                    case 12:
                        if (c.D && !b) c.D.onAssetUnload();
                        c.oa && !b && (c.oa.destroy(), c.oa = null);
                        b || c.Eg.stop();
                        c.K && op(c.K);
                        c.ra && (c.ra.g = null);
                        if (!c.A) {
                            v.B(14);
                            break;
                        }
                        return F(v, c.A.destroy(), 15);
                    case 15:
                        c.A = null;
                    case 14:
                        c.X = !1;
                        if (c.h) {
                            e = u(c.Cg);
                            for(f = e.next(); !f.done; f = e.next())g = f.value, g.src.startsWith("blob:") && URL.revokeObjectURL(g.src), g.remove();
                            c.Cg = [];
                            Nj(c.h) && c.h.load();
                        }
                        if (!c.F) {
                            v.B(16);
                            break;
                        }
                        return F(v, c.F.destroy(), 17);
                    case 17:
                        c.F = null;
                    case 16:
                        c.Oa && c.V != c.Oa.hd() && (c.Oa.j || c.Oa.destroy(), c.Oa = null);
                        c.V = null;
                        c.Y = null;
                        c.P = null;
                        if (c.i) {
                            h = u(c.i.variants);
                            for(k = h.next(); !k.done; k = h.next())for(l = k.value, m = u([
                                l.audio,
                                l.video
                            ]), n = m.next(); !n.done; n = m.next())(q = n.value) && q.segmentIndex && q.segmentIndex.release();
                            r = u(c.i.textStreams);
                            for(t = r.next(); !t.done; t = r.next())w = t.value, w.segmentIndex && w.segmentIndex.release();
                        }
                        c.g && c.g.streaming.clearDecodingCache && (Uf.clear(), Dg.clear());
                        c.i = null;
                        c.C = new io;
                        c.Di = null;
                        c.Pb = null;
                        c.S = null;
                        c.cf = -1;
                        c.Ye = [];
                        c.ib = [];
                        c.Bg = -1;
                        c.J && c.J.Ni();
                        br(c);
                    case 3:
                        va(v);
                        c.ea.release();
                        xa(v, 4);
                        break;
                    case 4:
                        Rb();
                        if (a && Fi() && !c.H && c.h) return F(v, ar(c), 0);
                        v.B(0);
                }
            });
        };
        p.Em = function(a) {
            this.O = a;
        };
        p.load = function(a, b, c) {
            b = b === void 0 ? null : b;
            var d = this, e, f, g, h, k, l, m, n, q, r, t, w, v, z;
            return Q(function(y) {
                switch(y.g){
                    case 1:
                        if (d.l == Tq) throw new U(2, 7, 7E3);
                        e = null;
                        f = "";
                        if (a instanceof oo) {
                            if (a.j) throw new U(2, 7, 7006);
                            e = a;
                            f = e.hd() || "";
                        } else f = a || "";
                        return F(y, Iq(d.ea, "load"), 2);
                    case 2:
                        d.ea.release();
                        if (!d.h) throw new U(2, 7, 7002);
                        if (!d.V) {
                            y.B(3);
                            break;
                        }
                        d.V = f;
                        return F(y, d.tc(!1), 3);
                    case 3:
                        g = ++d.bf;
                        h = function() {
                            return Q(function(A) {
                                if (A.g == 1) return d.bf == g ? A.B(0) : e ? F(A, e.destroy(), 3) : A.B(3);
                                throw new U(2, 7, 7E3);
                            });
                        };
                        k = function(A, C) {
                            return Q(function(E) {
                                switch(E.g){
                                    case 1:
                                        return sa(E, 2), F(E, Iq(d.ea, C), 4);
                                    case 4:
                                        return F(E, h(), 5);
                                    case 5:
                                        return F(E, A(), 6);
                                    case 6:
                                        return F(E, h(), 7);
                                    case 7:
                                        e && d.g && (e.g = d.g);
                                    case 2:
                                        va(E), d.ea.release(), xa(E, 0);
                                }
                            });
                        };
                        ra(y, 5, 6);
                        b == null && e && (b = e.getStartTime());
                        d.O = b;
                        d.aa = !1;
                        d.dispatchEvent(Sq("loading"));
                        if (e) {
                            c = e.S;
                            y.B(8);
                            break;
                        }
                        if (c) {
                            y.B(8);
                            break;
                        }
                        return F(y, k(function() {
                            return Q(function(A) {
                                if (A.g == 1) return F(A, cr(d, f), 2);
                                c = A.h;
                                H(A);
                            });
                        }, "guessMimeType_"), 8);
                    case 8:
                        l = !!e;
                        if (e) {
                            ro(e, d);
                            d.C = e.getStats();
                            y.B(11);
                            break;
                        }
                        return F(y, dr(d, f, b, c, !0, d.g), 12);
                    case 12:
                        (e = y.h) ? (e.F = !1, ro(e, d), d.C = e.getStats(), e.start(), e.C.catch(function() {})) : d.C = new io;
                    case 11:
                        m = !e;
                        n = Date.now() / 1E3;
                        d.C = e ? e.getStats() : new io;
                        d.V = f;
                        d.Y = c || null;
                        br(d);
                        q = function() {
                            var A = d.h ? d.h.buffered : null;
                            return {
                                start: Dj(A) || 0,
                                end: Ej(A) || 0
                            };
                        };
                        d.Fa = new mm(q);
                        d.Fa.addEventListener("regionadd", function(A) {
                            er(d, A.region, "metadataadded");
                        });
                        if (m) return F(y, k(function() {
                            return Q(function(A) {
                                return F(A, fr(d, c), 0);
                            });
                        }, "initializeSrcEqualsDrmInner_"), 23);
                        d.fb = new mm(q);
                        return F(y, k(function() {
                            return Q(function(A) {
                                if (A.g == 1) return F(A, Promise.race([
                                    e.aa,
                                    e.C
                                ]), 2);
                                d.Ec = e.H;
                                var C = e;
                                C.ea = !0;
                                d.I = C.l;
                                d.i = e.rh();
                                H(A);
                            });
                        }, "waitForFinish"), 15);
                    case 15:
                        if (d.H) {
                            y.B(16);
                            break;
                        }
                        return F(y, k(function() {
                            return Q(function(A) {
                                return F(A, ar(d), 0);
                            });
                        }, "initializeMediaSourceEngineInner_"), 16);
                    case 16:
                        return d.i && d.i.textStreams.length && (d.A.enableTextDisplayer ? d.A.enableTextDisplayer() : Zc("Text displayer w/ enableTextDisplayer", 'Text displayer should have a "enableTextDisplayer" method!')), F(y, k(function() {
                            return Q(function(A) {
                                return F(A, e.C, 0);
                            });
                        }, "waitForFinish"), 18);
                    case 18:
                        d.g = e.getConfiguration();
                        d.Se = e.G;
                        d.I && d.I.setMediaElement && d.h && d.I.setMediaElement(d.h);
                        d.Me = so(e);
                        d.Le = e.Fa;
                        if (r = e.D) d.M = r;
                        l && d.h && d.h.nodeName === "AUDIO" && (gr(d), d.configure("manifest.disableVideo", !0));
                        if (e.i) {
                            y.B(19);
                            break;
                        }
                        return F(y, k(function() {
                            return Q(function(A) {
                                return F(A, xo(e, d.h), 0);
                            });
                        }, "drmEngine_.init"), 19);
                    case 19:
                        return d.F = to(e), F(y, k(function() {
                            return Q(function(A) {
                                return F(A, d.F.cc(d.h), 0);
                            });
                        }, "drmEngine_.attach"), 21);
                    case 21:
                        return t = d.g.abrFactory, d.u && d.Ue == t || (d.Ue = t, d.u && d.u.release(), d.u = t(), typeof d.u.setMediaElement != "function" && (Zc("AbrManager w/o setMediaElement", "Please use an AbrManager with setMediaElement function."), d.u.setMediaElement = function() {}), typeof d.u.setCmsdManager != "function" && (Zc("AbrManager w/o setCmsdManager", "Please use an AbrManager with setCmsdManager function."), d.u.setCmsdManager = function() {}), typeof d.u.trySuggestStreams != "function" && (Zc("AbrManager w/o trySuggestStreams", "Please use an AbrManager with trySuggestStreams function."), d.u.trySuggestStreams = function() {}), d.u.configure(d.g.abr)), w = uo(e), v = e.u, F(y, k(function() {
                            return Q(function(A) {
                                return F(A, hr(d, n, v, w), 0);
                            });
                        }, "loadInner_"), 22);
                    case 22:
                        qo(e);
                        d.Y && Rb().kg() && of(d.Y) && Ak(d.H, d.V, d.Y);
                        y.B(14);
                        break;
                    case 23:
                        return F(y, k(function() {
                            return Q(function(A) {
                                return F(A, ir(d, n, c), 0);
                            });
                        }, "srcEqualsInner_"), 14);
                    case 14:
                        d.dispatchEvent(Sq("loaded"));
                    case 6:
                        va(y);
                        if (!e) {
                            y.B(25);
                            break;
                        }
                        return F(y, e.destroy(), 25);
                    case 25:
                        d.Oa = null;
                        xa(y, 0);
                        break;
                    case 5:
                        z = ua(y);
                        if (!z || z.code == 7E3) {
                            y.B(27);
                            break;
                        }
                        return F(y, d.tc(!1), 27);
                    case 27:
                        throw z;
                }
            });
        };
        function gr(a) {
            for(var b = u(a.i.variants), c = b.next(); !c.done; c = b.next())c = c.value, c.video && (c.video.closeSegmentIndex(), c.video = null), c.bandwidth = c.audio && c.audio.bandwidth ? c.audio.bandwidth : 0;
            a.i.variants = a.i.variants.filter(function(d) {
                return d.audio;
            });
        }
        p.ck = function(a, b) {
            a = a === void 0 ? !0 : a;
            b = b === void 0 ? !1 : b;
            var c = this, d;
            return Q(function(e) {
                return e.g == 1 ? F(e, jr(c), 2) : e.g != 3 ? (d = e.h, F(e, c.tc(a, b), 3)) : e.return(d);
            });
        };
        p.Si = function(a, b) {
            a = a === void 0 ? !1 : a;
            b = b === void 0 ? !1 : b;
            var c = this, d;
            return Q(function(e) {
                return e.g == 1 ? F(e, jr(c, b), 2) : e.g != 3 ? (d = e.h, F(e, c.detach(a), 3)) : e.return(d);
            });
        };
        function jr(a, b) {
            b = b === void 0 ? !1 : b;
            var c, d, e;
            return Q(function(f) {
                if (f.g == 1) {
                    c = null;
                    if (!(a.i && a.I && a.Ec && a.V && a.g)) return f.B(2);
                    d = a.h.currentTime;
                    a.U() && !b && (d = null);
                    return F(f, kr(a, a.V, d, a.Y, a.g, !0, !1), 3);
                }
                if (f.g != 2) {
                    c = f.h;
                    a.We.push(c);
                    a.I && a.I.setMediaElement && a.I.setMediaElement(null);
                    if (e = a.m ? a.m.u : null) c.u = e;
                    var g = c, h = a.I, k = a.Ec;
                    g.h = a.i;
                    g.l = h;
                    g.H = k;
                    c.D = a.M;
                    c.start();
                    a.i = null;
                    a.I = null;
                    a.Ec = null;
                    a.u = null;
                    a.Ue = null;
                }
                return f.return(c);
            });
        }
        p.preload = function(a, b, c, d) {
            b = b === void 0 ? null : b;
            var e = this, f, g;
            return Q(function(h) {
                if (h.g == 1) return f = Kq(e), bo(f, d || e.g, Kq(e)), F(h, dr(e, a, b, c, !1, f), 2);
                (g = h.h) ? g.start() : $q(e, new U(2, 7, 7005));
                return h.return(g);
            });
        };
        p.Ug = function() {
            var a = this, b, c, d, e;
            return Q(function(f) {
                b = [];
                c = u(a.We);
                for(d = c.next(); !d.done; d = c.next())e = d.value, e.j || b.push(e.destroy());
                a.We = [];
                return F(f, Promise.all(b), 0);
            });
        };
        function dr(a, b, c, d, e, f) {
            e = e === void 0 ? !1 : e;
            var g, h, k, l;
            return Q(function(m) {
                if (m.g == 1) return d ? m.B(2) : F(m, cr(a, b), 3);
                m.g != 2 && (d = m.h);
                if (g = lr(a, d)) return m.return(null);
                h = f || a.g;
                k = !1;
                e && a.h && a.h.nodeName === "AUDIO" && (k = !0);
                l = kr(a, b, c, d || null, h, !e, k);
                l = e ? l.then(function(n) {
                    n.F = !1;
                    return n;
                }) : l.then(function(n) {
                    a.We.push(n);
                    return n;
                });
                return m.return(l);
            });
        }
        function kr(a, b, c, d, e, f, g) {
            f = f === void 0 ? !0 : f;
            g = g === void 0 ? !1 : g;
            var h, k, l, m, n, q, r, t, w, v, z, y, A, C, E;
            return Q(function(D) {
                if (D.g == 1) {
                    h = null;
                    k = Gd(e);
                    g && (k.manifest.disableVideo = !0);
                    l = function() {
                        return h.P && h.j ? null : h;
                    };
                    m = function() {
                        return l() ? l().getConfiguration() : a.g;
                    };
                    if (a.sa.width != Infinity || a.sa.height != Infinity || a.g.ignoreHardwareResolution) return D.B(2);
                    n = Rb();
                    return F(D, n.wc(), 3);
                }
                D.g != 2 && (q = D.h, a.sa.width = q.width, a.sa.height = q.height);
                r = new ui(k, a.sa, null);
                t = {
                    networkingEngine: a.J,
                    filter: function(B) {
                        var G, I;
                        return Q(function(J) {
                            if (J.g == 1) return F(J, vi(r, B), 2);
                            if (J.g != 4) {
                                G = J.h;
                                if (!G) return J.B(0);
                                I = Sq("trackschanged");
                                return F(J, Promise.resolve(), 4);
                            }
                            h.dispatchEvent(I);
                            H(J);
                        });
                    },
                    makeTextStreamsForClosedCaptions: function(B) {
                        return mr(a, B);
                    },
                    onTimelineRegionAdded: function(B) {
                        nm(h.I, B);
                    },
                    onEvent: function(B) {
                        return h.dispatchEvent(B);
                    },
                    onError: function(B) {
                        return h.onError(B);
                    },
                    isLowLatencyMode: function() {
                        return m().streaming.lowLatencyMode;
                    },
                    updateDuration: function() {
                        a.m && h.P && a.m.updateDuration();
                    },
                    newDrmInfo: function(B) {
                        var G = h.i, I = G ? G.g : null;
                        I && G.C && yi(r, I.keySystem, B);
                    },
                    onManifestUpdated: function() {
                        var B = (new Map).set("isLive", a.U());
                        h.dispatchEvent(Sq("manifestupdated", B));
                        po(h, !1, function() {
                            if (a.D) a.D.onManifestUpdated(a.U());
                        });
                    },
                    getBandwidthEstimate: function() {
                        return a.u.getBandwidthEstimate();
                    },
                    onMetadata: function(B, G, I, J) {
                        var L = B;
                        if (B == "com.apple.hls.interstitial" || B == "com.apple.hls.overlay") {
                            if (L = "com.apple.quicktime.HLS", B = {
                                startTime: G,
                                endTime: I,
                                values: J
                            }, a.D) a.D.onHLSInterstitialMetadata(a, a.h, B);
                        }
                        J = u(J);
                        B = J.next();
                        for(var K = {}; !B.done; K = {
                            Rh: void 0
                        }, B = J.next())K.Rh = B.value, K.Rh.name != "ID" && po(h, !1, function(N) {
                            return function() {
                                nr(a, G, I, L, N.Rh);
                            };
                        }(K));
                    },
                    disableStream: function(B) {
                        return a.disableStream(B, a.g.streaming.maxDisabledTime);
                    },
                    addFont: function(B, G) {
                        return a.addFont(B, G);
                    }
                };
                w = new mm(function() {
                    return a.za();
                });
                w.addEventListener("regionadd", function(B) {
                    var G = B.region;
                    or(a, "timelineregionadded", G, h);
                    po(h, !1, function() {
                        a.D && (a.D.onDashTimedMetadata(G), a.D.onDASHInterstitialMetadata(a, a.h, G));
                    });
                });
                v = null;
                k.streaming.observeQualityChanges && (v = new gm(function() {
                    return a.Pc();
                }), v.addEventListener("qualitychange", function(B) {
                    pr(a, B.quality, B.position);
                }), v.addEventListener("audiotrackchange", function(B) {
                    pr(a, B.quality, B.position, !0);
                }));
                z = !0;
                y = {
                    Dc: a.J,
                    onError: function(B) {
                        return h.onError(B);
                    },
                    Rf: function(B) {
                        po(h, !0, function() {
                            a.F && qr(a, B);
                        });
                    },
                    onExpirationUpdated: function(B, G) {
                        var I = Sq("expirationupdated");
                        h.dispatchEvent(I);
                        if ((I = h.l) && I.onExpirationUpdated) I.onExpirationUpdated(B, G);
                    },
                    onEvent: function(B) {
                        h.dispatchEvent(B);
                        B.type == "drmsessionupdate" && z && (z = !1, B = Date.now() / 1E3 - h.sa, (a.C || h.getStats()).m = B, a.R && ed(a.R));
                    }
                };
                A = Lq(a, l);
                Zg(a.J, A);
                C = function() {
                    return a.Dd(y);
                };
                E = {
                    config: k,
                    Pl: t,
                    $l: w,
                    Zl: v,
                    Dd: C,
                    Ol: r,
                    networkingEngine: A,
                    lk: f
                };
                h = new oo(b, d, c, E);
                return D.return(h);
            });
        }
        function cr(a, b) {
            var c, d, e, f;
            return Q(function(g) {
                if (g.g == 1) return c = a.g.manifest.retryParameters, F(g, Jo(b, a.J, c), 2);
                d = g.h;
                d == "application/x-mpegurl" && (e = Rb(), e.Ja() === "WEBKIT" && (d = "application/vnd.apple.mpegurl"));
                d == "video/quicktime" && (f = Rb(), f.Ja() === "CHROMIUM" && (d = "video/mp4"));
                return g.return(d);
            });
        }
        function lr(a, b) {
            if (!Fi(Rb())) return !0;
            if (b) {
                if ((a.h || Gi()).canPlayType(b) == "") return !1;
                if (!Fi(Rb()) || !Di.has(b)) return !0;
                if (of(b)) return Rb().Ja() === "WEBKIT" && (a.g.drm.servers["com.apple.fps"] || a.g.drm.servers["com.apple.fps.1_0"]) ? a.g.streaming.useNativeHlsForFairPlay : a.g.streaming.preferNativeHls;
                if (b === "application/dash+xml" || b === "video/vnd.mpeg.dash.mpd") return a.g.streaming.preferNativeDash;
            }
            return !1;
        }
        function rr(a, b) {
            var c = a.g.textDisplayFactory;
            a.Di !== c || (b === void 0 ? 0 : b) ? (b = a.A, a.A = c(), a.A.configure ? a.A.configure(a.g.textDisplayer) : Zc("Text displayer w/ configure", 'Text displayer should have a "configure" method!'), a.A.setTextLanguage || Zc("Text displayer w/ setTextLanguage", 'Text displayer should have a "setTextLanguage" method!'), b ? (a.A.setTextVisibility(b.isTextVisible()), b.destroy().catch(function() {})) : a.A.setTextVisibility(a.X), a.H && gl(a.H, a.A), a.Di = c, a.m && Ym(a.m)) : a.A && a.A.configure && a.A.configure(a.g.textDisplayer);
        }
        function ar(a) {
            var b, c, d;
            return Q(function(e) {
                if (e.g == 1) return Rb(), Xq(a, "media-source"), a.g.mediaSource.useSourceElements && Nj(a.h), rr(a), b = sr(a.h, a.A, {
                    Rk: function() {
                        return a.keySystem();
                    },
                    onMetadata: function(f, g, h) {
                        f = u(f);
                        for(var k = f.next(); !k.done; k = f.next())if (k = k.value, k.data && typeof k.cueTime == "number" && k.frames) {
                            var l = k.cueTime + g, m = h;
                            m && l > m && (m = l);
                            for(var n = u(k.frames), q = n.next(); !q.done; q = n.next())nr(a, l, m, "org.id3", q.value);
                            if (a.D) a.D.onHlsTimedMetadata(k, l);
                        }
                    },
                    Ul: function(f) {
                        a.fb && nm(a.fb, {
                            schemeIdUri: f.schemeIdUri,
                            startTime: f.startTime,
                            endTime: f.endTime,
                            id: String(f.id),
                            emsg: f
                        });
                    },
                    onEvent: function(f) {
                        return a.dispatchEvent(f);
                    },
                    Wl: function() {
                        a.I && a.I.update && a.I.update();
                    }
                }, a.R, a.g.mediaSource), c = a.g.manifest, d = c.segmentRelativeVttTiming, b.Fa = d, F(e, b.L, 2);
                a.H = b;
                H(e);
            });
        }
        function tr(a, b, c) {
            function d() {
                return ur(a);
            }
            a.j.o(b, "playing", d);
            a.j.o(b, "pause", d);
            a.j.o(b, "ended", d);
            a.j.o(b, "ratechange", function() {
                var f = a.h.playbackRate;
                f != 0 && (a.L && (a.L.set(f), a.l == vr && a.u.playbackRateChanged(f), wr(a, f)), f = Sq("ratechange"), a.dispatchEvent(f));
            });
            b.remote && (a.j.o(b.remote, "connect", function() {
                a.m && b.remote.state == "connected" && xr(a);
                yr(a);
            }), a.j.o(b.remote, "connecting", function() {
                return yr(a);
            }), a.j.o(b.remote, "disconnect", function() {
                return Q(function(f) {
                    if (f.g == 1) return a.m && b.remote.state == "disconnected" ? F(f, mn(a.m), 3) : f.B(2);
                    f.g != 2 && xr(a);
                    yr(a);
                    H(f);
                });
            }));
            b.audioTracks && (a.j.o(b.audioTracks, "addtrack", function() {
                return yr(a);
            }), a.j.o(b.audioTracks, "removetrack", function() {
                return yr(a);
            }), a.j.o(b.audioTracks, "change", function() {
                return yr(a);
            }));
            b.videoTracks && (a.j.o(b.videoTracks, "addtrack", function() {
                return yr(a);
            }), a.j.o(b.videoTracks, "removetrack", function() {
                return yr(a);
            }), a.j.o(b.videoTracks, "change", function() {
                return yr(a);
            }));
            (b.webkitPresentationMode || b.webkitSupportsFullscreen) && a.j.o(b, "webkitpresentationmodechanged", function() {
                a.Oe && rr(a, !0);
            });
            if (b.textTracks) {
                var e = function() {
                    a.l === zr && a.A instanceof Wo && xr(a);
                    yr(a);
                };
                a.j.o(b.textTracks, "addtrack", function(f) {
                    if (f.track) switch(f = f.track, f.kind){
                        case "metadata":
                            Ar(a, f);
                            break;
                        case "chapters":
                            Br(a, f);
                            break;
                        default:
                            e();
                    }
                });
                a.j.o(b.textTracks, "removetrack", e);
                a.j.o(b.textTracks, "change", e);
            }
            b.preload != "none" && a.j.ua(b, "loadedmetadata", function() {
                a.C.G = Date.now() / 1E3 - c;
            });
        }
        function hr(a, b, c, d) {
            var e, f, g, h, k, l, m, n, q, r, t, w, v, z, y, A, C, E, D, B, G, I, J, L, K, N, P, O;
            return Q(function(M) {
                switch(M.g){
                    case 1:
                        Xq(a, "load");
                        e = a.h;
                        a.L = new cm({
                            wf: function() {
                                return e.playbackRate;
                            },
                            jd: function() {
                                return e.defaultPlaybackRate;
                            },
                            gi: function(R) {
                                e.playbackRate = R;
                            },
                            pj: function(R) {
                                e.currentTime += R;
                            }
                        });
                        tr(a, e, b);
                        "onchange" in window1.screen && a.j.o(window1.screen, "change", function() {
                            if (a.M.getConfiguration) {
                                var R = a.M.getConfiguration();
                                R.hdrLevel == "AUTO" ? Cr(a) : a.g.preferredVideoHdrLevel == "AUTO" && a.g.abr.enabled && (R.hdrLevel = "AUTO", a.M.configure(R), Cr(a));
                            }
                        });
                        f = !1;
                        g = u(a.i.variants);
                        for(h = g.next(); !h.done; h = g.next())k = h.value, (l = k.video && k.video.dependencyStream) && (f = fd(l));
                        Rq(a, a.g, f);
                        a.Ic = a.g.preferredTextLanguage;
                        a.be = a.g.preferredTextRole;
                        a.Re = a.g.preferForcedSubs;
                        Dr(a.i.presentationTimeline, a.g.playRangeStart, a.g.playRangeEnd);
                        a.u.init(function(R, W, wa) {
                            a.i && a.m && R != a.m.u && Er(a, R, !0, W === void 0 ? !1 : W, wa === void 0 ? 0 : wa);
                        });
                        a.u.setMediaElement(e);
                        a.u.setCmsdManager(a.ra);
                        a.m = Fr(a);
                        a.m.configure(a.g.streaming);
                        a.l = vr;
                        a.dispatchEvent(Sq("streaming"));
                        m = c;
                    case 2:
                        (q = a.m.u) || m || (m = Gr(a, !0));
                        r = [];
                        n = q || m;
                        t = u([
                            n.video,
                            n.audio
                        ]);
                        for(w = t.next(); !w.done; w = t.next())(v = w.value) && !v.segmentIndex && (r.push(v.createSegmentIndex()), v.dependencyStream && r.push(v.dependencyStream.createSegmentIndex()));
                        if (!(r.length > 0)) {
                            M.B(4);
                            break;
                        }
                        return F(M, Promise.all(r), 4);
                    case 4:
                        if (!n || n.disabledUntilTime != 0) {
                            M.B(2);
                            break;
                        }
                        if (a.I && a.I.onInitialVariantChosen) a.I.onInitialVariantChosen(n);
                        a.i.isLowLatency && (a.g.streaming.lowLatencyMode ? a.configure(a.Dg) : ab("Low-latency live stream detected, but low-latency streaming mode is not enabled in Shaka Player. Set streaming.lowLatencyMode configuration to true, and see https://bit.ly/3clctcj for details."));
                        a.K && (qp(a.K, a.i.isLowLatency && a.g.streaming.lowLatencyMode), vp(a.K, b * 1E3));
                        Dr(a.i.presentationTimeline, a.g.playRangeStart, a.g.playRangeEnd);
                        Om(a.m, a.g.playRangeStart, a.g.playRangeEnd);
                        a.aa = !0;
                        a.dispatchEvent(Sq("canupdatestarttime"));
                        z = function(R) {
                            a.G = Hr(a, R);
                            a.jb = Ir(a, R);
                            Jr(a, e, !1);
                        };
                        a.g.streaming.startAtSegmentBoundary || (y = a.O, y == null && a.i.startTime && (y = a.i.startTime), z(y));
                        if (q) {
                            M.B(7);
                            break;
                        }
                        if (!a.g.streaming.startAtSegmentBoundary) {
                            M.B(8);
                            break;
                        }
                        A = a.i.presentationTimeline;
                        a.O instanceof Date && (E = A.m || A.i, D = a.O.getTime() / 1E3 - E, D != null && (C = D));
                        C == null && (C = typeof a.O === "number" ? a.O : a.h.currentTime);
                        a.O == null && a.i.startTime && (C = a.i.startTime);
                        B = A.fc();
                        G = A.Mb();
                        C < B ? C = B : C > G && (C = G);
                        return F(M, Kr(m, C), 9);
                    case 9:
                        I = M.h, z(I);
                    case 8:
                        Er(a, m, !0, !1, 0);
                    case 7:
                        return a.G.ready(), J = a.yc().find(function(R) {
                            return R.active;
                        }), J || ((L = lg(a.i.textStreams, a.Ic, a.be, a.Re)[0] || null) && ho(a.C.h, L, !0), m && (L ? (pg(m.audio, L, a.g) && (a.X = !0), a.X && a.A.setTextVisibility(!0)) : (a.X = !1, a.A.setTextVisibility(!1)), Lr(a)), L && (a.g.streaming.alwaysStreamText || a.Xc()) && (Xm(a.m, L), Mr(a))), F(M, a.m.start(d), 10);
                    case 10:
                        a.g.abr.enabled && (a.u.enable(), Nr(a));
                        yr(a);
                        Cr(a);
                        a.i.variants.some(function(R) {
                            return R.primary;
                        });
                        if ((K = a.U()) && (a.g.streaming.liveSync && a.g.streaming.liveSync.enabled || a.i.serviceDescription || a.g.streaming.liveSync.panicMode) || a.g.streaming.vodDynamicPlaybackRate) N = function() {
                            return Or(a);
                        }, a.j.o(e, "timeupdate", N);
                        K || (P = function() {
                            return Pr(a);
                        }, a.j.o(e, "timeupdate", P), Pr(a), a.i.nextUrl && (a.g.streaming.preloadNextUrlWindow > 0 && (O = function() {
                            var R;
                            return Q(function(W) {
                                if (W.g == 1) {
                                    R = a.za().end - a.h.currentTime;
                                    if (isNaN(R) || !(R <= a.g.streaming.preloadNextUrlWindow)) return W.B(0);
                                    a.j.Ea(e, "timeupdate", O);
                                    return F(W, a.preload(a.i.nextUrl), 4);
                                }
                                a.Oa = W.h;
                                H(W);
                            });
                        }, a.j.o(e, "timeupdate", O)), a.j.o(e, "ended", function() {
                            a.load(a.Oa || a.i.nextUrl);
                        })));
                        if (a.D) a.D.onManifestUpdated(K);
                        H(M);
                }
            });
        }
        function fr(a, b) {
            var c, d, e;
            return Q(function(f) {
                return f.g == 1 ? (c = Date.now() / 1E3, d = !0, a.F = a.Dd({
                    Dc: a.J,
                    onError: function(g) {
                        $q(a, g);
                    },
                    Rf: function() {},
                    onExpirationUpdated: function() {
                        var g = Sq("expirationupdated");
                        a.dispatchEvent(g);
                    },
                    onEvent: function(g) {
                        a.dispatchEvent(g);
                        g.type == "drmsessionupdate" && d && (d = !1, a.C.m = Date.now() / 1E3 - c);
                    }
                }), a.F.configure(a.g.drm), e = qg([
                    b
                ]), a.F.O = !0, F(f, Ih(a.F, [
                    e
                ], []), 2)) : F(f, a.F.cc(a.h), 0);
            });
        }
        function ir(a, b, c) {
            var d, e, f, g, h, k, l, m, n, q, r, t;
            return Q(function(w) {
                switch(w.g){
                    case 1:
                        Xq(a, "src-equals");
                        d = a.h;
                        a.G = new Pl(d);
                        e = !1;
                        a.Qe.push(function() {
                            e = !0;
                        });
                        a.dispatchEvent(Sq("canupdatestarttime"));
                        a.O != null && a.G.Ag(a.O);
                        a.jb = Qr(a, a.O || 0);
                        a.L = new cm({
                            wf: function() {
                                return d.playbackRate;
                            },
                            jd: function() {
                                return d.defaultPlaybackRate;
                            },
                            gi: function(v) {
                                d.playbackRate = v;
                            },
                            pj: function(v) {
                                d.currentTime += v;
                            }
                        });
                        Jr(a, d, !0);
                        d.textTracks && (rr(a), f = function(v) {
                            if (!(a.A instanceof Wo)) {
                                var z = Rr(a).find(function(y) {
                                    return y.mode !== "disabled";
                                });
                                z && (z.mode = v ? "showing" : "hidden");
                                a.A instanceof Yo && (z = Sr(a)) && (z.mode = !v && a.A.isTextVisible() ? "showing" : "hidden");
                            }
                        }, a.j.o(d, "enterpictureinpicture", function() {
                            return f(!0);
                        }), a.j.o(d, "leavepictureinpicture", function() {
                            return f(!1);
                        }), d.remote ? (a.j.o(d.remote, "connect", function() {
                            return f(!1);
                        }), a.j.o(d.remote, "connecting", function() {
                            return f(!1);
                        }), a.j.o(d.remote, "disconnect", function() {
                            return f(!1);
                        })) : "webkitCurrentPlaybackTargetIsWireless" in d && a.j.o(d, "webkitcurrentplaybacktargetiswirelesschanged", function() {
                            return f(!1);
                        }), g = d, (g.webkitPresentationMode || g.webkitSupportsFullscreen) && a.j.o(g, "webkitpresentationmodechanged", function() {
                            g.webkitPresentationMode ? f(g.webkitPresentationMode !== "inline") : g.webkitSupportsFullscreen && f(g.webkitDisplayingFullscreen);
                        }));
                        tr(a, d, b);
                        h = xp(a.K, a.V, c);
                        !h.includes("#t=") && (a.g.playRangeStart > 0 || isFinite(a.g.playRangeEnd)) && (h += "#t=", a.g.playRangeStart > 0 && (h += a.g.playRangeStart), isFinite(a.g.playRangeEnd) && (h += "," + a.g.playRangeEnd));
                        if (!a.H) {
                            w.B(2);
                            break;
                        }
                        return F(w, a.H.destroy(), 3);
                    case 3:
                        a.H = null;
                    case 2:
                        return Nj(d), d.src = h, k = Rb(), k.Ka() == "TV" && d.load(), d.preload != "none" && !d.autoplay && of(c) && k.Ja() === "WEBKIT" && d.load(), a.l = zr, a.dispatchEvent(Sq("streaming")), l = new Lg, Gl(d, HTMLMediaElement.HAVE_METADATA, a.j, function() {
                            a.G.ready();
                            a.Y && of(a.Y) || l.resolve();
                        }), m = function() {
                            return new Promise(function(v) {
                                var z = new Bf(v);
                                a.j.o(d.textTracks, "change", function() {
                                    return z.$(.5);
                                });
                                z.$(.5);
                            });
                        }, Gl(d, HTMLMediaElement.HAVE_CURRENT_DATA, a.j, function() {
                            var v, z, y, A, C;
                            return Q(function(E) {
                                if (E.g == 1) return F(E, m(), 2);
                                if (e) return E.return();
                                Tr(a);
                                v = Rr(a);
                                v.some(function(D) {
                                    return D.mode === "showing";
                                }) && (a.X = !0, a.A.setTextVisibility(!0));
                                if (!(a.A instanceof Wo)) for(v.length && (a.A.enableTextDisplayer ? a.A.enableTextDisplayer() : Zc("Text displayer w/ enableTextDisplayer", 'Text displayer should have a "enableTextDisplayer" method')), z = !1, y = u(v), A = y.next(); !A.done; A = y.next())C = A.value, C.mode !== "disabled" && (z ? (C.mode = "disabled", ab("Found more than one enabled text track, disabling it", C)) : (Ur(a, C), z = !0));
                                Vr(a);
                                a.Y && of(a.Y) && l.resolve();
                                H(E);
                            });
                        }), d.error ? l.reject(Zq(a)) : d.preload == "none" && (ab('With <video preload="none">, the browser will not load anything until play() is called. We are unable to measure load latency in a meaningful way, and we cannot provide track info yet. Please do not use preload="none" with Shaka Player.'), l.resolve()), a.j.ua(d, "error", function() {
                            l.reject(Zq(a));
                        }), F(w, Ff(a.g.streaming.loadTimeout, l), 4);
                    case 4:
                        if ((n = a.U()) && (a.g.streaming.liveSync && a.g.streaming.liveSync.enabled || a.g.streaming.liveSync.panicMode) || a.g.streaming.vodDynamicPlaybackRate) q = function() {
                            return Or(a);
                        }, a.j.o(d, "timeupdate", q);
                        n || (r = function() {
                            return Pr(a);
                        }, a.j.o(d, "timeupdate", r), Pr(a));
                        a.D && (a.D.onManifestUpdated(n), n && (t = a.za().end, a.j.o(d, "progress", function() {
                            var v = a.za().end;
                            t != v && (a.D.onManifestUpdated(a.U()), t = v);
                        })));
                        a.aa = !0;
                        H(w);
                }
            });
        }
        function Tr(a) {
            var b = a.g.preferredAudioLanguage;
            b != "" && a.Gj(b, a.g.preferredAudioRole);
        }
        function Vr(a) {
            var b = a.g.preferredTextLanguage;
            b != "" && a.ai(b, a.g.preferredTextRole, a.g.preferForcedSubs);
        }
        function Ar(a, b) {
            if (b.kind == "metadata") {
                b.mode = "hidden";
                a.j.o(b, "cuechange", function() {
                    if (b.activeCues) {
                        for(var d = u(b.activeCues), e = d.next(); !e.done; e = d.next())if (e = e.value, nr(a, e.startTime, e.endTime, e.type, e.value), a.D) a.D.onCueMetadataChange(e.value);
                    }
                    if (b.cues) {
                        d = [];
                        e = u(b.cues);
                        for(var f = e.next(), g = {}; !f.done; g = {
                            Nc: void 0
                        }, f = e.next())g.Nc = f.value, g.Nc.type == "com.apple.quicktime.HLS" && g.Nc.startTime != null && (f = d.find(function(h) {
                            return function(k) {
                                return k.startTime == h.Nc.startTime && k.endTime == h.Nc.endTime;
                            };
                        }(g)), f || (f = {
                            startTime: g.Nc.startTime,
                            endTime: g.Nc.endTime,
                            values: []
                        }, d.push(f)), f.values.push(g.Nc.value));
                        d = u(d);
                        for(e = d.next(); !e.done; e = d.next())e = e.value, e.values.some(function(h) {
                            return h.key == "X-ASSET-URI" || h.key == "X-ASSET-LIST";
                        }) && a.D && (e.values.push({
                            key: "CUE",
                            description: "",
                            data: e.startTime != 0 || a.U() ? "ONCE" : "ONCE,PRE",
                            mimeType: null,
                            pictureType: null
                        }), a.D.onHLSInterstitialMetadata(a, a.h, e));
                    }
                });
                var c = new Bf(function() {
                    var d = Wr(a);
                    d = u(d);
                    for(var e = d.next(); !e.done; e = d.next())e.value.mode = "hidden";
                }).La().$(.5);
                a.Qe.push(function() {
                    c.stop();
                });
            }
        }
        function er(a, b, c) {
            b = (new Map).set("startTime", b.startTime).set("endTime", b.endTime).set("metadataType", b.schemeIdUri).set("payload", b.payload);
            a.dispatchEvent(Sq(c, b));
        }
        function nr(a, b, c, d, e) {
            a.Fa && (b = {
                schemeIdUri: d,
                startTime: b,
                endTime: c || Infinity,
                id: "",
                payload: e
            }, b.id = JSON.stringify(b), nm(a.Fa, b));
        }
        function Br(a, b) {
            if (b && b.kind == "chapters") {
                b.mode = "hidden";
                var c = new Bf(function() {
                    b.mode = "hidden";
                }).La().$(.5);
                a.Qe.push(function() {
                    c.stop();
                });
            }
        }
        p.fm = function() {
            for(var a = this.ea; a.g;)a.release();
        };
        p.Dd = function(a) {
            return new Bh(a);
        };
        function Lq(a, b) {
            function c(f) {
                b() ? b().dispatchEvent(f) : a.dispatchEvent(f);
            }
            function d(f) {
                b() ? po(b(), !0, f) : f();
            }
            b || (b = function() {
                return null;
            });
            var e = new Vg(function(f, g, h, k, l) {
                d(function() {
                    a.u && a.u.segmentDownloaded(f, g, h, k, l);
                });
            }, function(f, g, h) {
                g = (new Map).set("headers", f).set("request", g).set("requestType", h);
                c(Sq("downloadheadersreceived", g));
                d(function() {
                    if (a.ra) {
                        var k = a.ra;
                        if (k.h.enabled) {
                            var l = f["cmsd-static"];
                            if (l) try {
                                var m = new Map, n = l.split(",");
                                for(l = 0; l < n.length; l++){
                                    var q = n[l].split("=");
                                    m.set(q[0], Gq(q[1]));
                                }
                            } catch (z) {}
                            if (m = f["cmsd-dynamic"]) {
                                a: {
                                    try {
                                        var r = new Map, t = m.split(";");
                                        for(m = 1; m < t.length; m++){
                                            var w = t[m].split("=");
                                            r.set(w[0], Gq(w[1]));
                                        }
                                        var v = r;
                                        break a;
                                    } catch (z) {
                                        v = null;
                                        break a;
                                    }
                                    v = void 0;
                                }
                                v && (k.g = v);
                            }
                        }
                    }
                });
            }, function(f, g) {
                f = (new Map).set("request", f).set("response", g);
                c(Sq("downloadcompleted", f));
            }, function(f, g, h, k) {
                f = (new Map).set("request", f).set("error", g).set("httpResponseCode", h).set("aborted", k);
                c(Sq("downloadfailed", f));
            }, function(f, g, h) {
                d(function() {
                    if (a.K) {
                        var k = a.K, l = h;
                        l = l === void 0 ? {} : l;
                        if (k.g.enabled) {
                            if (g.method === "HEAD") Sp(k, g, {});
                            else switch(f){
                                case 0:
                                    try {
                                        if (k.g.enabled) {
                                            if (l.type) {
                                                a: {
                                                    switch(l.type){
                                                        case 4:
                                                            var m = k.u ? sp : rp;
                                                            break a;
                                                        case 3:
                                                        case 2:
                                                            m = k.u ? up : tp;
                                                            break a;
                                                        case 5:
                                                            m = "s";
                                                            break a;
                                                    }
                                                    m = void 0;
                                                }
                                                k.l = m;
                                            }
                                            Sp(k, g, {
                                                ot: Bp,
                                                su: !k.D
                                            });
                                        }
                                    } catch (q) {
                                        bb("CMCD_MANIFEST_ERROR", "Could not generate manifest CMCD data.", q);
                                    }
                                    break;
                                case fh:
                                    try {
                                        if (k.g.enabled) {
                                            var n = xq(k, l, g.uris[0]);
                                            n.ts = Date.now();
                                            k.F.set(g, n.ts);
                                            Sp(k, g, n);
                                        }
                                    } catch (q) {
                                        bb("CMCD_SEGMENT_ERROR", "Could not generate segment CMCD data.", q);
                                    }
                                    break;
                                case 2:
                                case 5:
                                case 6:
                                    Sp(k, g, {
                                        ot: "k"
                                    });
                                    break;
                                case 4:
                                    Sp(k, g, {
                                        ot: "o"
                                    });
                            }
                        }
                    }
                });
            }, function(f, g, h, k) {
                (f = b() ? b().l : a.I) && f.banLocation && f.banLocation(k);
            }, function(f, g, h) {
                if (g.data) {
                    var k = g.data.byteLength, l = b() ? b().getStats() : a.C;
                    l && (mo(l, k), f === 0 && (l.jj = k));
                    k = a.K;
                    h = h === void 0 ? {} : h;
                    switch(f){
                        case fh:
                            try {
                                var m = xq(k, h, g.uri);
                                g.originalRequest && g.originalRequest.timeToFirstByte != null && (m.ttfb = g.originalRequest.timeToFirstByte);
                                g.timeMs != null && (m.ttlb = g.timeMs);
                                var n = g.originalUri || g.uri;
                                if (n.includes("CMCD=")) try {
                                    var q = new URL(n);
                                    q.searchParams.delete("CMCD");
                                    var r = q.toString();
                                } catch (t) {
                                    r = n;
                                }
                                else r = n;
                                m.url = r;
                                k.F.has(g.originalRequest) ? (m.ts = k.F.get(g.originalRequest), k.F.delete(g.originalRequest)) : m.ts || (m.ts = Date.now());
                                lq(k, g, m);
                            } catch (t) {
                                bb("CMCD_SEGMENT_ERROR", "Could not generate response segment CMCD data.", t);
                            }
                    }
                }
            });
            e.configure(a.g.networking);
            return e;
        }
        function Hr(a, b) {
            return new Sl(a.h, a.i, a.g.streaming, b, function() {
                a.jb && fm(a.jb, !a.G.Bi());
                a.m && a.m.rd();
                a.P && Xr(a, "seeking");
            }, function(c) {
                return a.dispatchEvent(c);
            });
        }
        function Ir(a, b) {
            var c = a.U() || typeof b === "number" && b > 0;
            b = new Eo(a.Me, c);
            b.addEventListener("enter", function(f) {
                or(a, "timelineregionenter", f.region);
            });
            b.addEventListener("exit", function(f) {
                or(a, "timelineregionexit", f.region);
            });
            b.addEventListener("skip", function(f) {
                var g = f.region;
                f.seeking || (or(a, "timelineregionenter", g), or(a, "timelineregionexit", g));
            });
            var d = new Eo(a.Fa, c);
            d.addEventListener("enter", function(f) {
                er(a, f.region, "metadata");
            });
            c = new Eo(a.fb, c);
            c.addEventListener("enter", function(f) {
                f = (new Map).set("detail", f.region.emsg);
                a.dispatchEvent(Sq("emsg", f));
            });
            var e = new em(a.h);
            e.g.add(b);
            e.g.add(d);
            e.g.add(c);
            a.Le && e.g.add(a.Le);
            return e;
        }
        function Qr(a, b) {
            b = new Eo(a.Fa, b instanceof Date || b > 0);
            b.addEventListener("enter", function(d) {
                er(a, d.region, "metadata");
            });
            var c = new em(a.h);
            c.g.add(b);
            return c;
        }
        function Jr(a, b, c) {
            a.P = new ni;
            qi(a.P, pi);
            Yr(a);
            br(a);
            a.Ma = new Bf(function() {
                Xr(a);
            });
            a.g.streaming.rebufferingGoal && a.Ma.wa(.25);
            a.j.o(b, "waiting", function() {
                return Xr(a, "waiting");
            });
            a.j.o(b, "canplaythrough", function() {
                return Xr(a, "canplaythrough");
            });
            a.j.o(b, "playing", function() {
                return Xr(a, "playing");
            });
            a.j.o(b, "seeked", function() {
                return Xr(a, "seeked");
            });
            c && (a.j.o(b, "stalled", function() {
                return Xr(a, "stalled");
            }), a.j.o(b, "progress", function() {
                return Xr(a, "progress");
            }), a.j.o(b, "timeupdate", function() {
                return Xr(a, "timeupdate");
            }));
        }
        function Yr(a) {
            var b = a.g.streaming.rebufferingGoal;
            a.P.i.set(oi, Math.min(.5, b / 2)).set(pi, b);
        }
        function Xr(a, b) {
            if (a.g.streaming.rebufferingGoal) {
                b = a.H ? Ck(a.H) : !1;
                b = a.isEnded() || b || a.G.fj();
                var c = Gj(a.h.buffered, a.h.currentTime), d = a.P, e = d.i.get(d.g);
                qi(d, b || c >= e && c > 0 ? oi : pi) && br(a);
            } else if (b) {
                c = void 0;
                switch(b){
                    case "seeking":
                    case "waiting":
                        c = pi;
                        break;
                    case "canplaythrough":
                    case "playing":
                    case "seeked":
                        c = oi;
                }
                c !== void 0 && qi(a.P, c) && br(a);
            }
        }
        function sr(a, b, c, d, e) {
            return new wk(a, b, c, e, d);
        }
        function Fr(a) {
            return new Im(a.i, {
                Rc: function() {
                    return a.G ? a.G.$e() : 0;
                },
                getBandwidthEstimate: function() {
                    return a.u.getBandwidthEstimate();
                },
                Za: function() {
                    return a.Za();
                },
                video: a.h,
                ha: a.H,
                Dc: a.J,
                onError: function(b) {
                    return $q(a, b);
                },
                onEvent: function(b) {
                    return a.dispatchEvent(b);
                },
                Sf: function(b, c, d) {
                    var e = b.startTime, f = b.endTime, g = c.type;
                    if (g != sc) {
                        if (a.G) {
                            a.G.rj();
                            var h = Kk(a.H, g);
                            !a.U() && a.h.paused && !a.h.seeking && h != null && h > 0 && a.G.$e() < h && a.G.Ag(h);
                        }
                        Xr(a);
                    }
                    d = (new Map).set("start", e).set("end", f).set("contentType", g).set("isMuxed", d);
                    a.dispatchEvent(Sq("segmentappended", d));
                    a.u && c.fastSwitching && b.nd && b.xe && a.u.trySuggestStreams();
                },
                Vl: function(b, c) {
                    (c = c.Od) && a.Le && im(a.Le, c, b);
                },
                Ji: function(b, c) {
                    var d = a.F;
                    if (d.h.parseInbandPsshEnabled && !d.L && [
                        "audio",
                        "video"
                    ].includes(b)) {
                        b = new zh(Kb(c));
                        c = 0;
                        for(var e = u(b.data), f = e.next(); !f.done; f = e.next())c += f.value.length;
                        if (c == 0) d = Promise.resolve();
                        else {
                            c = new Uint8Array(c);
                            e = 0;
                            b = u(b.data);
                            for(f = b.next(); !f.done; f = b.next())f = f.value, c.set(f, e), e += f.length;
                            Rh(d, "cenc", c);
                            d = d.m;
                        }
                    } else d = Promise.resolve();
                    return d;
                },
                disableStream: function(b, c) {
                    return a.disableStream(b, c);
                },
                ym: function(b, c) {
                    return a.g.abr.enabled && c.fastSwitching && b.nd && b.xe ? !1 : !0;
                }
            });
        }
        p.configure = function(a, b) {
            var c = this.getConfiguration();
            arguments.length == 2 && typeof a == "string" && (a = An(a, b));
            "preferredVariantRole" in a && (Zc("preferredVariantRole configuration", "Please Use preferredAudioRole instead."), a.preferredAudioRole = a.preferredVariantRole, delete a.preferredVariantRole);
            a.streaming && "forceTransmuxTS" in a.streaming && (Zc("streaming.forceTransmuxTS configuration", "Please Use mediaSource.forceTransmux instead."), a.mediaSource = a.mediaSource || {}, a.mediaSource.mediaSource = a.streaming.forceTransmuxTS, delete a.streaming.forceTransmuxTS);
            a.streaming && "forceTransmux" in a.streaming && (Zc("streaming.forceTransmux configuration", "Please Use mediaSource.forceTransmux instead."), a.mediaSource = a.mediaSource || {}, a.mediaSource.mediaSource = a.streaming.forceTransmux, delete a.streaming.forceTransmux);
            if (a.streaming && "useNativeHlsOnSafari" in a.streaming) {
                Zc("streaming.useNativeHlsOnSafari configuration", "Please Use streaming.useNativeHlsForFairPlay or streaming.preferNativeHls instead.");
                var d = Rb();
                a.streaming.preferNativeHls = a.streaming.useNativeHlsOnSafari && d.Ja() === "WEBKIT";
                delete a.streaming.useNativeHlsOnSafari;
            }
            a.streaming && typeof a.streaming.liveSync == "boolean" && (Zc("streaming.liveSync", "Please Use streaming.liveSync.enabled instead."), d = a.streaming.liveSync, a.streaming.liveSync = {}, a.streaming.liveSync.enabled = d);
            if (a.streaming && !(a.streaming.liveSync && "targetLatency" in a.streaming.liveSync) && ("liveSyncMinLatency" in a.streaming || "liveSyncMaxLatency" in a.streaming)) {
                d = a.streaming.liveSyncMinLatency || 0;
                var e = Math.abs((a.streaming.liveSyncMaxLatency || 1) - d) / 2;
                a.streaming.liveSync = a.streaming.liveSync || {};
                a.streaming.liveSync.targetLatency = d + e;
                a.streaming.liveSync.targetLatencyTolerance = e;
            }
            a.streaming && "liveSyncMaxLatency" in a.streaming && (Zc("streaming.liveSyncMaxLatency", "Please Use streaming.liveSync.targetLatency and streaming.liveSync.targetLatencyTolerance instead. Or, set the values in your DASH manifest"), delete a.streaming.liveSyncMaxLatency);
            a.streaming && "liveSyncMinLatency" in a.streaming && (Zc("streaming.liveSyncMinLatency", "Please Use streaming.liveSync.targetLatency and streaming.liveSync.targetLatencyTolerance instead. Or, set the values in your DASH manifest"), delete a.streaming.liveSyncMinLatency);
            a.streaming && "liveSyncTargetLatency" in a.streaming && (Zc("streaming.liveSyncTargetLatency", "Please Use streaming.liveSync.targetLatency instead."), a.streaming.liveSync = a.streaming.liveSync || {}, a.streaming.liveSync.targetLatency = a.streaming.liveSyncTargetLatency, delete a.streaming.liveSyncTargetLatency);
            a.streaming && "liveSyncTargetLatencyTolerance" in a.streaming && (Zc("streaming.liveSyncTargetLatencyTolerance", "Please Use streaming.liveSync.targetLatencyTolerance instead."), a.streaming.liveSync = a.streaming.liveSync || {}, a.streaming.liveSync.targetLatencyTolerance = a.streaming.liveSyncTargetLatencyTolerance, delete a.streaming.liveSyncTargetLatencyTolerance);
            a.streaming && "liveSyncPlaybackRate" in a.streaming && (Zc("streaming.liveSyncPlaybackRate", "Please Use streaming.liveSync.maxPlaybackRate instead."), a.streaming.liveSync = a.streaming.liveSync || {}, a.streaming.liveSync.maxPlaybackRate = a.streaming.liveSyncPlaybackRate, delete a.streaming.liveSyncPlaybackRate);
            a.streaming && "liveSyncMinPlaybackRate" in a.streaming && (Zc("streaming.liveSyncMinPlaybackRate", "Please Use streaming.liveSync.minPlaybackRate instead."), a.streaming.liveSync = a.streaming.liveSync || {}, a.streaming.liveSync.minPlaybackRate = a.streaming.liveSyncMinPlaybackRate, delete a.streaming.liveSyncMinPlaybackRate);
            a.streaming && "liveSyncPanicMode" in a.streaming && (Zc("streaming.liveSyncPanicMode", "Please Use streaming.liveSync.panicMode instead."), a.streaming.liveSync = a.streaming.liveSync || {}, a.streaming.liveSync.panicMode = a.streaming.liveSyncPanicMode, delete a.streaming.liveSyncPanicMode);
            a.streaming && "liveSyncPanicThreshold" in a.streaming && (Zc("streaming.liveSyncPanicThreshold", "Please Use streaming.liveSync.panicThreshold instead."), a.streaming.liveSync = a.streaming.liveSync || {}, a.streaming.liveSync.panicThreshold = a.streaming.liveSyncPanicThreshold, delete a.streaming.liveSyncPanicThreshold);
            if (a.mediaSource && "sourceBufferExtraFeatures" in a.mediaSource) {
                Zc("mediaSource.sourceBufferExtraFeatures configuration", "Please Use mediaSource.addExtraFeaturesToSourceBuffer() instead.");
                var f = a.mediaSource.sourceBufferExtraFeatures;
                a.mediaSource.addExtraFeaturesToSourceBuffer = function() {
                    return f;
                };
                delete a.mediaSource.sourceBufferExtraFeatures;
            }
            a.manifest && a.manifest.hls && "useSafariBehaviorForLive" in a.manifest.hls && (Zc("manifest.hls.useSafariBehaviorForLive configuration", "Please Use liveSync config to keep on live Edge instead."), delete a.manifest.hls.useSafariBehaviorForLive);
            a.streaming && "parsePrftBox" in a.streaming && (Zc("streaming.parsePrftBox configuration", "Now fired without needing a configuration."), delete a.streaming.parsePrftBox);
            a.manifest && a.manifest.dash && "enableAudioGroups" in a.manifest.dash && (Zc("manifest.dash.enableAudioGroups configuration", "Please Use manifest.enableAudioGroups instead."), a.manifest.enableAudioGroups = a.manifest.dash.enableAudioGroups, delete a.manifest.dash.enableAudioGroups);
            a.streaming && "dispatchAllEmsgBoxes" in a.streaming && (Zc("streaming.dispatchAllEmsgBoxes configuration", "Please Use mediaSource.dispatchAllEmsgBoxes instead."), a.mediaSource = a.mediaSource || {}, a.mediaSource.dispatchAllEmsgBoxes = a.streaming.dispatchAllEmsgBoxes, delete a.streaming.dispatchAllEmsgBoxes);
            a.streaming && "autoLowLatencyMode" in a.streaming && (Zc("streaming.autoLowLatencyMode configuration", "Please Use streaming.lowLatencyMode instead."), a.streaming.lowLatencyMode = a.streaming.autoLowLatencyMode, delete a.streaming.autoLowLatencyMode);
            a.manifest && a.manifest.dash && "ignoreSupplementalCodecs" in a.manifest.dash && (Zc("manifest.dash.ignoreSupplementalCodecs configuration", "Please Use manifest.ignoreSupplementalCodecs instead."), a.manifest.ignoreSupplementalCodecs = a.manifest.dash.ignoreSupplementalCodecs, delete a.manifest.dash.ignoreSupplementalCodecs);
            a.manifest && a.manifest.hls && "ignoreSupplementalCodecs" in a.manifest.hls && (Zc("manifest.hls.ignoreSupplementalCodecs configuration", "Please Use manifest.ignoreSupplementalCodecs instead."), a.manifest.ignoreSupplementalCodecs = a.manifest.hls.ignoreSupplementalCodecs, delete a.manifest.hls.ignoreSupplementalCodecs);
            a.manifest && a.manifest.dash && "updatePeriod" in a.manifest.dash && (Zc("manifest.dash.updatePeriod configuration", "Please Use manifest.updatePeriod instead."), a.manifest.updatePeriod = a.manifest.dash.updatePeriod, delete a.manifest.dash.updatePeriod);
            a.manifest && a.manifest.hls && "updatePeriod" in a.manifest.hls && (Zc("manifest.hls.updatePeriod configuration", "Please Use manifest.updatePeriod instead."), a.manifest.updatePeriod = a.manifest.hls.updatePeriod, delete a.manifest.hls.updatePeriod);
            a.manifest && a.manifest.dash && "ignoreDrmInfo" in a.manifest.dash && (Zc("manifest.dash.ignoreDrmInfo configuration", "Please Use manifest.ignoreDrmInfo instead."), a.manifest.ignoreDrmInfo = a.manifest.dash.ignoreDrmInfo, delete a.manifest.dash.ignoreDrmInfo);
            if (a.drm && a.drm.advanced) {
                d = !1;
                for(var g in a.drm.advanced){
                    var h = a.drm.advanced[g];
                    e = h.videoRobustness;
                    h = h.audioRobustness;
                    "videoRobustness" in a.drm.advanced[g] && !Array.isArray(a.drm.advanced[g].videoRobustness) && (a.drm.advanced[g].videoRobustness = [
                        e
                    ], d = !0);
                    "audioRobustness" in a.drm.advanced[g] && !Array.isArray(a.drm.advanced[g].audioRobustness) && (a.drm.advanced[g].audioRobustness = [
                        h
                    ], d = !0);
                }
                d && Zc("AdvancedDrmConfiguration's videoRobustness and audioRobustness", "These properties are no longer strings but array of strings, please update your usage of these properties.");
            }
            a.streaming && "forceHTTP" in a.streaming && (Zc("streaming.forceHTTP configuration", "Please Use networking.forceHTTP instead."), a.networking = a.networking || {}, a.networking.forceHTTP = a.streaming.forceHTTP, delete a.streaming.forceHTTP);
            a.streaming && "forceHTTPS" in a.streaming && (Zc("streaming.forceHTTPS configuration", "Please Use networking.forceHTTP instead."), a.networking = a.networking || {}, a.networking.forceHTTPS = a.streaming.forceHTTPS, delete a.streaming.forceHTTPS);
            a.streaming && "minBytesForProgressEvents" in a.streaming && (Zc("streaming.minBytesForProgressEvents configuration", "Please Use networking.minBytesForProgressEvents instead."), a.networking = a.networking || {}, a.networking.minBytesForProgressEvents = a.streaming.minBytesForProgressEvents, delete a.streaming.minBytesForProgressEvents);
            g = bo(this.g, a, Kq(this));
            Zr(this, c);
            return g;
        };
        p.wk = function(a) {
            this.Dg = a;
        };
        function Zr(a, b) {
            a.Se = new ui(a.g, a.sa, a.F);
            if (a.I) {
                var c = Gd(a.g.manifest);
                a.h && a.h.nodeName === "AUDIO" && (c.disableVideo = !0);
                a.I.configure(c);
            }
            a.F && a.F.configure(a.g.drm);
            if (a.m) {
                a.m.configure(a.g.streaming);
                try {
                    a.l != Tq && wi(a.Se, a.i) && yr(a);
                } catch (e) {
                    $q(a, e);
                }
                a.u && Cr(a);
                c = a.m.u;
                !c || c.allowedByApplication && c.allowedByKeySystem || Pq(a);
            }
            a.J && a.J.configure(a.g.networking);
            a.H && (a.H.configure(a.g.mediaSource), a.H.Fa = a.g.manifest.segmentRelativeVttTiming);
            a.A && rr(a);
            a.u && (a.u.configure(a.g.abr), a.g.abr.enabled ? a.u.enable() : a.u.disable(), Nr(a));
            a.P && Yr(a);
            a.Ma && (a.g.streaming.rebufferingGoal ? a.Ma.wa(.25) : a.Ma.stop());
            a.i && Dr(a.i.presentationTimeline, a.g.playRangeStart, a.g.playRangeEnd);
            a.D && a.D.configure(a.g.ads);
            a.K && a.K.configure(a.g.cmcd);
            a.ra && a.ra.configure(a.g.cmsd);
            a.xa && a.xa.configure(a.g.queue);
            if (a.l == vr && a.M.getConfiguration) {
                c = a.M.getConfiguration();
                var d = !1;
                b.preferredVideoHdrLevel != a.g.preferredVideoHdrLevel && c.hdrLevel != a.g.preferredVideoHdrLevel && (c.hdrLevel = a.g.preferredVideoHdrLevel, d = !0);
                b.preferredVideoLayout != a.g.preferredVideoLayout && c.videoLayout != a.g.preferredVideoLayout && (c.videoLayout = a.g.preferredVideoLayout, d = !0);
                b.preferSpatialAudio != a.g.preferSpatialAudio && c.spatialAudio != a.g.preferSpatialAudio && (c.spatialAudio = a.g.preferSpatialAudio, d = !0);
                b.preferredVideoRole != a.g.preferredVideoRole && c.videoRole != a.g.preferredVideoRole && (c.videoRole = a.g.preferredVideoRole, d = !0);
                d && (a.M.configure(c), Pq(a));
            }
        }
        p.getConfiguration = function() {
            var a = Kq(this);
            bo(a, this.g, Kq(this));
            return a;
        };
        p.Ik = function() {
            return this.Dg;
        };
        p.Zi = function() {
            var a = Kq(this);
            bo(a, this.g, Kq(this));
            return Cn(this.g, Kq(this));
        };
        p.Wi = function() {
            if (this.h) {
                var a = this.h.buffered.length;
                a = a ? this.h.buffered.end(a - 1) : 0;
                var b = this.getConfiguration().streaming.bufferingGoal;
                b = Math.min(this.h.currentTime + b, this.za().end);
                if (a >= b) return 1;
                if (!(a <= this.h.currentTime) && a < b) return (a - this.h.currentTime) / (b - this.h.currentTime);
            }
            return 0;
        };
        p.Bj = function() {
            var a = this.getConfiguration(), b;
            for(b in this.g)delete this.g[b];
            bo(this.g, Kq(this), Kq(this));
            Zr(this, a);
        };
        p.Sk = function() {
            return this.l;
        };
        p.sh = function() {
            return this.i ? this.i.type : null;
        };
        p.Zk = function() {
            return this.h;
        };
        p.Vb = function() {
            return this.J;
        };
        p.hd = function() {
            return this.V;
        };
        p.tf = function() {
            return this.D ? this.D : null;
        };
        p.vf = function() {
            return this.xa ? this.xa : null;
        };
        p.U = function() {
            return this.i && !this.Da() ? this.i.presentationTimeline.U() : this.h && (this.h.src || this.Da()) ? this.h.duration == Infinity : !1;
        };
        p.ld = function() {
            return this.i ? this.i.presentationTimeline.ld() : !1;
        };
        p.Ld = function() {
            if (this.i && !this.Da()) {
                var a = this.i.variants;
                return a.length ? !a[0].video : !1;
            }
            return this.h && (this.h.src || this.Da()) ? this.h.videoTracks ? this.h.videoTracks.length == 0 : this.h.videoHeight == 0 : !1;
        };
        p.Hh = function() {
            if (this.i && !this.Da()) {
                var a = this.i.variants;
                if (!a.length) return !1;
                a = a[0];
                return a.audio || !a.video ? !1 : !a.video.codecs.includes(",");
            }
            return this.h && (this.h.src || this.Da()) && this.h.audioTracks ? this.h.audioTracks.length == 0 : !1;
        };
        p.za = function() {
            if (this.i && !this.Da()) {
                if (!this.aa && this.i.type == "HLS") return {
                    start: 0,
                    end: 0
                };
                var a = this.i.presentationTimeline;
                return {
                    start: a.fc(),
                    end: a.Mb()
                };
            }
            if (this.h && (this.h.src || this.Da()) && (a = this.h.seekable) && a.length) {
                var b = this.g ? this.g.playRangeStart : 0;
                b = Math.max(a.start(0), b);
                var c = this.g ? this.g.playRangeEnd : Infinity;
                a = Math.min(a.end(a.length - 1), c);
                return {
                    start: b,
                    end: a
                };
            }
            return {
                start: 0,
                end: 0
            };
        };
        p.Al = function() {
            this.U() && (this.h.currentTime = this.za().end);
        };
        p.El = function() {
            return this.aa;
        };
        p.keySystem = function() {
            var a = this.drmInfo();
            return a ? a.keySystem : "";
        };
        p.drmInfo = function() {
            return this.F ? this.F.g : null;
        };
        p.me = function() {
            return this.F ? this.F.me() : Infinity;
        };
        p.nh = function() {
            return this.F ? this.F.nh() : [];
        };
        p.uf = function() {
            return this.F ? this.F.uf() : {};
        };
        p.Cf = function() {
            return this.P ? this.P.g == pi : !!this.V;
        };
        p.Za = function() {
            return this.h ? this.L ? this.L.i : 1 : 0;
        };
        p.zi = function(a) {
            this.l == vr && this.m && Um(this.m, a);
        };
        p.sc = function(a, b) {
            b = b === void 0 ? !0 : b;
            a == 0 ? ab("A trick play rate of 0 is unsupported!") : (this.L.set(a), this.l == vr && (this.u.playbackRateChanged(a), this.zi(b && a != 1)), wr(this, a));
        };
        p.Bd = function() {
            var a = this.L.jd();
            this.l == zr && this.L.set(a);
            this.l == vr && (this.L.set(a), this.u.playbackRateChanged(a), this.zi(!1));
            this.kc.Sa();
        };
        p.Ob = function() {
            if (this.i && !this.Da()) {
                for(var a = this.m ? this.m.u : null, b = [], c = 0, d = u(this.i.variants), e = d.next(); !e.done; e = d.next())if (e = e.value, jg(e)) {
                    var f = bg(e);
                    f.active = e == a;
                    f.active || c == 1 || a == null || e.video != a.video || e.audio != a.audio || (f.active = !0);
                    f.active && c++;
                    b.push(f);
                }
                return b;
            }
            if (this.h && this.h.audioTracks) {
                var g = $r(this);
                a = Array.from(this.h.audioTracks);
                return a.length ? a.map(function(h) {
                    return ig(h, g);
                }) : g ? [
                    ig(null, g)
                ] : [];
            }
            return [];
        };
        p.yc = function() {
            if (this.i) {
                if (this.Da()) return [];
                for(var a = this.m ? this.m.C : null, b = [], c = u(this.i.textStreams), d = c.next(); !d.done; d = c.next()){
                    d = d.value;
                    var e = cg(d);
                    e.active = d == a;
                    b.push(e);
                }
                return b;
            }
            return this.h && this.h.src && this.h.textTracks ? Rr(this).map(function(f) {
                return hg(f);
            }) : [];
        };
        p.qh = function() {
            var a = this.Ye;
            this.i && (a = this.i.imageStreams);
            return a.map(function(b) {
                return dg(b);
            });
        };
        p.zk = function(a) {
            var b = this, c, d;
            return Q(function(e) {
                if (e.g == 1) return F(e, as(b, a), 2);
                c = e.h;
                if (!c) return e.return(null);
                d = [];
                c.segmentIndex.Lb(function(f) {
                    var g = bs(f.tilesLayout || c.tilesLayout);
                    if (g) for(var h = g.rows * g.columns, k = f.j - f.startTime, l = 0; l < h; l++){
                        var m = cs(f, c, f.startTime + k * l / h, g);
                        d.push(m);
                    }
                });
                c.closeSegmentIndex && c.closeSegmentIndex();
                return e.return(d);
            });
        };
        function bs(a) {
            return a ? (a = /(\d+)x(\d+)/.exec(a)) ? {
                columns: parseInt(a[1], 10),
                rows: parseInt(a[2], 10)
            } : null : null;
        }
        p.$i = function(a, b) {
            var c = this, d, e, f, g;
            return Q(function(h) {
                if (h.g == 1) return F(h, as(c, a), 2);
                d = h.h;
                if (!d) return h.return(null);
                e = d.segmentIndex.find(b);
                if (e == null) return h.return(null);
                f = d.segmentIndex.get(e);
                return (g = bs(f.tilesLayout || d.tilesLayout)) ? h.return(cs(f, d, b, g)) : h.return(null);
            });
        };
        function as(a, b) {
            var c, d;
            return Q(function(e) {
                if (e.g == 1) {
                    if (a.l != vr && a.l != zr) return e.return(null);
                    c = a.Ye;
                    a.i && (c = a.i.imageStreams);
                    d = c[0];
                    if (!d) return e.return(null);
                    b != null && (d = c.find(function(f) {
                        return f.id == b;
                    }));
                    return d ? d.segmentIndex ? e.B(2) : F(e, d.createSegmentIndex(), 2) : e.return(null);
                }
                return e.return(d);
            });
        }
        function cs(a, b, c, d) {
            var e = b.width || 0, f = b.height || 0, g = e / d.columns, h = f / d.rows, k = d.columns * d.rows, l = a.j - a.startTime;
            l = a.C || l / k;
            var m = a.startTime, n = 0, q = 0;
            k > 1 && (q = Math.floor((c - a.startTime) / l), m = a.startTime + q * l, n = q % d.columns * g, q = Math.floor(q / d.columns) * h);
            d = !1;
            if (c = a.thumbnailSprite) d = !0, h = c.height, n = c.positionX, q = c.positionY, g = c.width;
            return {
                segment: a,
                imageHeight: f,
                imageWidth: e,
                height: h,
                positionX: n,
                positionY: q,
                startTime: m,
                duration: l,
                uris: a.T(),
                startByte: a.Tc(),
                endByte: a.Qc(),
                width: g,
                sprite: d,
                mimeType: a.mimeType || b.mimeType,
                codecs: a.codecs || b.codecs
            };
        }
        p.fg = function(a) {
            function b() {
                var d = c.i.textStreams.find(function(e) {
                    return e.id == a.id;
                });
                d && d != c.m.C && (ho(c.C.h, d, !1), Xm(c.m, d), xr(c), Mr(c), c.Ic = d.language);
            }
            var c = this;
            if (this.i && this.G && (b(), !this.Da())) return;
            (function() {
                if (c.h && c.h.textTracks) {
                    var d = Rr(c), e = d.find(function(h) {
                        return fg(h) === a.id;
                    });
                    if (e) {
                        if (c.A instanceof Wo) {
                            d = u(d);
                            for(var f = d.next(); !f.done; f = d.next()){
                                f = f.value;
                                var g = f === e ? c.X ? "showing" : "hidden" : "disabled";
                                f.mode !== g && (f.mode = g);
                            }
                        } else d = d.find(function(h) {
                            return h.mode !== "disabled";
                        }), d !== e && (d && (d.mode = "disabled", c.j.Ea(d, "cuechange"), c.A.remove(0, Infinity)), e && Ur(c, e));
                        xr(c);
                        Mr(c);
                    }
                }
            })();
        };
        function Ur(a, b) {
            a.j.o(b, "cuechange", function() {
                a.A.remove(0, Math.max(0, a.h.currentTime - a.g.streaming.bufferBehind));
                var c = {
                    periodStart: 0,
                    segmentStart: 0,
                    segmentEnd: a.h.duration,
                    vttOffset: 0
                }, d = [], e = Array.from(b.activeCues || []);
                e = u(e);
                for(var f = e.next(); !f.done; f = e.next()){
                    f = f.value;
                    if (f.endTime === Infinity || f.endTime < f.startTime) f = null;
                    else {
                        var g = new re(f.startTime, f.endTime, f.text);
                        g.line = typeof f.line === "number" ? f.line : null;
                        f.lineAlign && (g.lineAlign = f.lineAlign);
                        g.lineInterpretation = f.snapToLines ? we : 1;
                        g.position = typeof f.position === "number" ? f.position : null;
                        f.positionAlign && (g.positionAlign = f.positionAlign);
                        g.size = f.size;
                        g.textAlign = f.align;
                        f.vertical === "lr" ? g.writingMode = "vertical-lr" : f.vertical === "rl" && (g.writingMode = "vertical-rl");
                        f.region && (g.region.id = f.region.id, g.region.height = f.region.lines, g.region.heightUnits = 2, g.region.regionAnchorX = f.region.regionAnchorX, g.region.regionAnchorY = f.region.regionAnchorY, g.region.scroll = f.region.scroll, g.region.viewportAnchorX = f.region.viewportAnchorX, g.region.viewportAnchorY = f.region.viewportAnchorY, g.region.viewportAnchorUnits = ud, g.region.width = f.region.width, g.region.widthUnits = ud);
                        De(g);
                        f = g;
                    }
                    f && ((g = a.g.mediaSource.modifyCueCallback) && g(f, null, c), d.push(f));
                }
                a.A.append(d);
            });
            b.mode = document.pictureInPictureElement ? "showing" : "hidden";
        }
        p.Ge = function(a, b, c) {
            function d() {
                var f = e.i.variants.find(function(h) {
                    return h.id == a.id;
                });
                if (f && jg(f)) {
                    var g = e.m.u;
                    e.g.abr.enabled && (g.video != f.video || g.audio && f.audio && g.audio.language == f.audio.language && g.audio.channelsCount == f.audio.channelsCount && g.audio.label == f.audio.label) && ab("Changing tracks while abr manager is enabled will likely result in the selected track being overridden. Consider disabling abr before calling selectVariantTrack().");
                    e.Da() ? Er(e, f, !1, !1, 0) : Er(e, f, !1, b || !1, c || 0);
                    e.M.configure({
                        language: f.language,
                        role: f.audio && f.audio.roles && f.audio.roles[0] || "",
                        videoRole: f.video && f.video.roles && f.video.roles[0] || "",
                        channelCount: f.audio && f.audio.channelsCount ? f.audio.channelsCount : 0,
                        hdrLevel: f.video && f.video.hdr ? f.video.hdr : "",
                        spatialAudio: f.audio && f.audio.spatialAudio ? f.audio.spatialAudio : !1,
                        videoLayout: f.video && f.video.videoLayout ? f.video.videoLayout : "",
                        audioLabel: f.audio && f.audio.label ? f.audio.label : "",
                        videoLabel: f.video && f.video.label ? f.video.label : "",
                        codecSwitchingStrategy: e.g.mediaSource.codecSwitchingStrategy,
                        audioCodec: f.audio && f.audio.codecs ? f.audio.codecs : "",
                        activeAudioCodec: g.audio && g.audio.codecs ? g.audio.codecs : "",
                        activeAudioChannelCount: g.audio && g.audio.channelsCount ? g.audio.channelsCount : 0,
                        preferredAudioCodecs: e.g.preferredAudioCodecs,
                        preferredAudioChannelCount: e.g.preferredAudioChannelCount
                    });
                    Cr(e);
                }
            }
            var e = this;
            b = b === void 0 ? !1 : b;
            c = c === void 0 ? 0 : c;
            if (this.i && this.G && (d(), !this.Da())) return;
            (function() {
                if (a.originalAudioId && e.h && e.h.audioTracks) {
                    var f = Array.from(e.h.audioTracks);
                    f = u(f);
                    for(var g = f.next(); !g.done; g = f.next())if (g = g.value, fg(g) == a.id) {
                        ds(e, g);
                        break;
                    }
                }
            })();
        };
        p.Hj = function(a, b) {
            function c() {
                var e = d.M.getConfiguration();
                e.audioCodec = a.codecs || "";
                e.audioLabel = a.label || "";
                e.channelCount = a.channelsCount || 0;
                e.language = a.language;
                e.role = a.roles[0] || "";
                e.spatialAudio = a.spatialAudio;
                d.M.configure(e);
                Pq(d, !0, b, !1, !1);
            }
            var d = this;
            b = b === void 0 ? 0 : b;
            if (this.i && this.G && (c(), !this.Da())) return;
            (function() {
                if (d.h && d.h.audioTracks) {
                    var e = yc(a.language), f = Array.from(d.h.audioTracks), g = null;
                    f = u(f);
                    for(var h = f.next(); !h.done; h = f.next()){
                        h = h.value;
                        var k = h.language || "und";
                        if (h.label == a.label && yc(k) == e && h.kind == a.roles[0]) {
                            g = h;
                            break;
                        }
                    }
                    g && ds(d, g);
                }
            })();
        };
        p.getAudioTracks = function() {
            if (this.i && !this.Da()) {
                var a = this.Ob();
                if (!a.length) return [];
                var b = a.find(function(f) {
                    return f.active;
                });
                if (!b) return [];
                var c = a;
                this.l != vr || this.Da() || (c = a.filter(function(f) {
                    return f.originalVideoId === b.originalVideoId && f.audioCodec;
                }));
                if (!c.length) return [];
                a = new Map;
                c = u(c);
                for(var d = c.next(); !d.done; d = c.next()){
                    d = d.value;
                    var e = d.originalAudioId;
                    e || d.audioId == null || (e = String(d.audioId));
                    e && (e += [
                        d.language,
                        d.label,
                        d.channelsCount,
                        d.spatialAudio
                    ].join("_"), a.set(e, {
                        active: d.active,
                        language: d.language,
                        label: d.label,
                        mimeType: d.audioMimeType,
                        codecs: d.audioCodec,
                        primary: d.primary,
                        roles: d.audioRoles || [],
                        accessibilityPurpose: d.accessibilityPurpose,
                        channelsCount: d.channelsCount,
                        audioSamplingRate: d.audioSamplingRate,
                        spatialAudio: d.spatialAudio,
                        originalLanguage: d.originalLanguage
                    }));
                }
                return Array.from(a.values());
            }
            return this.h && this.h.audioTracks ? Array.from(this.h.audioTracks).map(function(f) {
                var g = f.language;
                g = {
                    active: f.enabled,
                    language: yc(g || "und"),
                    label: f.label,
                    mimeType: null,
                    codecs: null,
                    primary: f.kind == "main",
                    roles: [],
                    accessibilityPurpose: null,
                    channelsCount: null,
                    audioSamplingRate: null,
                    spatialAudio: !1,
                    originalLanguage: g
                };
                f.kind && g.roles.push(f.kind);
                f.configuration && (f.configuration.codec && (g.codecs = f.configuration.codec), f.configuration.sampleRate && (g.audioSamplingRate = f.configuration.sampleRate), f.configuration.numberOfChannels && (g.channelsCount = f.configuration.numberOfChannels));
                return g;
            }) : [];
        };
        p.Ij = function(a, b, c) {
            b = b === void 0 ? !1 : b;
            c = c === void 0 ? 0 : c;
            var d = this.Ob();
            if (d.length) {
                var e = d.find(function(f) {
                    return f.active;
                });
                e && (d = d.find(function(f) {
                    return f.audioId === e.audioId && (f.videoBandwidth || f.bandwidth) == a.bandwidth && f.width == a.width && f.height == a.height && f.frameRate == a.frameRate && f.pixelAspectRatio == a.pixelAspectRatio && f.hdr == a.hdr && f.colorGamut == a.colorGamut && f.videoLayout == a.videoLayout && f.videoMimeType == a.mimeType && f.videoCodec == a.codecs && Sc(f.videoRoles, a.roles) && f.videoLabel == a.label;
                })) && !d.active && this.Ge(d, b, c);
            }
        };
        p.getVideoTracks = function() {
            if (this.l == zr || this.Da()) return [];
            var a = this.Ob();
            if (!a.length) return [];
            var b = a.find(function(f) {
                return f.active;
            });
            if (!b) return [];
            var c = a.filter(function(f) {
                return f.originalAudioId === b.originalAudioId && f.audioId === b.audioId && f.audioGroupId === b.audioGroupId && f.videoCodec;
            });
            if (!c.length) return [];
            a = new Map;
            c = u(c);
            for(var d = c.next(); !d.done; d = c.next()){
                d = d.value;
                var e = d.originalVideoId;
                e || d.videoId == null || (e = String(d.videoId));
                e && a.set(e, {
                    active: d.active,
                    bandwidth: d.videoBandwidth || d.bandwidth,
                    width: d.width,
                    height: d.height,
                    frameRate: d.frameRate,
                    pixelAspectRatio: d.pixelAspectRatio,
                    hdr: d.hdr,
                    colorGamut: d.colorGamut,
                    videoLayout: d.videoLayout,
                    mimeType: d.videoMimeType,
                    codecs: d.videoCodec,
                    roles: d.videoRoles || [],
                    label: d.videoLabel
                });
            }
            return Array.from(a.values());
        };
        p.Bk = function() {
            return es(this.Ob());
        };
        p.ol = function() {
            return es(this.yc());
        };
        p.Ak = function() {
            return Array.from(fs(this.Ob()));
        };
        p.ll = function() {
            return Array.from(fs(this.yc()));
        };
        p.Gj = function(a, b, c, d, e, f, g) {
            function h() {
                function l(t, w) {
                    return t.video || w.video ? t.video && w.video ? Math.abs((t.video.height || 0) - (w.video.height || 0)) + Math.abs((t.video.width || 0) - (w.video.width || 0)) : Infinity : 0;
                }
                var m = k.m.u;
                k.M = k.g.adaptationSetCriteriaFactory();
                k.M.configure({
                    language: a,
                    role: b || "",
                    videoRole: m.video && m.video.roles && m.video.roles[0] || "",
                    channelCount: c || 0,
                    hdrLevel: "",
                    spatialAudio: f || !1,
                    videoLayout: "",
                    audioLabel: g || "",
                    videoLabel: "",
                    codecSwitchingStrategy: k.g.mediaSource.codecSwitchingStrategy,
                    audioCodec: e || "",
                    activeAudioCodec: m.audio && m.audio.codecs ? m.audio.codecs : "",
                    activeAudioChannelCount: m.audio && m.audio.channelsCount ? m.audio.channelsCount : 0,
                    preferredAudioCodecs: k.g.preferredAudioCodecs,
                    preferredAudioChannelCount: k.g.preferredAudioChannelCount
                });
                var n = k.M.create(k.i.variants), q = null;
                n = u(n.values());
                for(var r = n.next(); !r.done; r = n.next())r = r.value, jg(r) && (!q || l(q, m) > l(r, m)) && (q = r);
                q != m && (q ? (m = bg(q), k.Ge(m, !0, d || 0)) : Pq(k));
            }
            var k = this;
            c = c === void 0 ? 0 : c;
            d = d === void 0 ? 0 : d;
            e = e === void 0 ? "" : e;
            f = f === void 0 ? !1 : f;
            g = g === void 0 ? "" : g;
            if (this.i && this.G && (h(), !this.Da())) return;
            (function() {
                if (k.h && k.h.audioTracks) {
                    var l = lg(k.Ob(), a, b || "", !1)[0];
                    l && k.Ge(l);
                }
            })();
        };
        p.ai = function(a, b, c) {
            function d() {
                e.Ic = a;
                e.be = b || "";
                e.Re = c || !1;
                var f = lg(e.i.textStreams, e.Ic, e.be, e.Re)[0] || null;
                f && f != e.m.C && (ho(e.C.h, f, !1), e.g.streaming.alwaysStreamText || e.Xc()) && (Xm(e.m, f), xr(e), Mr(e));
            }
            var e = this;
            c = c === void 0 ? !1 : c;
            if (this.i && this.G && (d(), !this.Da())) return;
            (function() {
                var f = lg(e.yc(), a, b || "", c || !1)[0];
                f && e.fg(f);
            })();
        };
        p.qm = function(a, b, c) {
            function d() {
                for(var f = null, g = u(e.i.variants), h = g.next(); !h.done; h = g.next())if (h = h.value, h.audio.label == a) {
                    f = h;
                    break;
                }
                f != null && (e.M = e.g.adaptationSetCriteriaFactory(), e.M.configure({
                    language: f.language,
                    role: "",
                    videoRole: "",
                    channelCount: 0,
                    hdrLevel: "",
                    spatialAudio: !1,
                    videoLayout: "",
                    videoLabel: "",
                    audioLabel: a,
                    codecSwitchingStrategy: e.g.mediaSource.codecSwitchingStrategy,
                    audioCodec: "",
                    activeAudioCodec: "",
                    activeAudioChannelCount: 0,
                    preferredAudioCodecs: e.g.preferredAudioCodecs,
                    preferredAudioChannelCount: e.g.preferredAudioChannelCount
                }), Pq(e, b, c));
            }
            var e = this;
            b = b === void 0 ? !0 : b;
            c = c === void 0 ? 0 : c;
            if (this.i && this.G && (d(), !this.Da())) return;
            (function() {
                if (e.h && e.h.audioTracks) {
                    var f = Array.from(e.h.audioTracks), g = null;
                    f = u(f);
                    for(var h = f.next(); !h.done; h = f.next())h = h.value, h.label == a && (g = h);
                    g && ds(e, g);
                }
            })();
        };
        p.Xc = function() {
            var a = this.X;
            return this.A ? this.A.isTextVisible() : a;
        };
        p.Fk = function() {
            return this.ib.map(function(a) {
                return cg(a);
            });
        };
        p.Ek = function(a) {
            Zc("getChapters", "Please use an getChaptersAsync.");
            if (!this.ib.length) return [];
            var b = yc(a);
            a = this.ib.filter(function(f) {
                return yc(f.language) == b;
            });
            if (!a.length) return [];
            var c = [], d = new Set;
            a = u(a);
            for(var e = a.next(); !e.done; e = a.next())e = e.value, e.segmentIndex && e.segmentIndex.Lb(function(f) {
                var g = f.T()[0], h = f.startTime + "-" + f.endTime + "-" + g;
                f = {
                    id: h,
                    title: g,
                    startTime: f.startTime,
                    endTime: f.endTime
                };
                d.has(h) || (c.push(f), d.add(h));
            });
            return c;
        };
        p.oh = function(a) {
            var b = this, c, d, e, f, g, h, k;
            return Q(function(l) {
                switch(l.g){
                    case 1:
                        if (!b.ib.length) return l.return([]);
                        c = yc(a);
                        d = b.ib.filter(function(m) {
                            return yc(m.language) == c;
                        });
                        if (!d.length) return l.return([]);
                        e = [];
                        f = new Set;
                        g = u(d);
                        h = g.next();
                    case 2:
                        if (h.done) {
                            l.B(4);
                            break;
                        }
                        k = h.value;
                        if (k.segmentIndex) {
                            l.B(5);
                            break;
                        }
                        return F(l, k.createSegmentIndex(), 5);
                    case 5:
                        k.segmentIndex.Lb(function(m) {
                            var n = m.T()[0], q = m.startTime + "-" + m.endTime + "-" + n;
                            m = {
                                id: q,
                                title: n,
                                startTime: m.startTime,
                                endTime: m.endTime
                            };
                            f.has(q) || (e.push(m), f.add(q));
                        });
                        h = g.next();
                        l.B(2);
                        break;
                    case 4:
                        return l.return(e);
                }
            });
        };
        function Rr(a) {
            return Array.from(a.h.textTracks).filter(function(b) {
                return b.kind != "metadata" && b.kind != "chapters" && b.label != "Shaka Player TextTrack";
            });
        }
        function Sr(a) {
            return Array.from(a.h.textTracks).find(function(b) {
                return b.label == "Shaka Player TextTrack";
            });
        }
        function Wr(a) {
            return Array.from(a.h.textTracks).filter(function(b) {
                return b.kind == "metadata";
            });
        }
        p.Zd = function(a) {
            a = !!a;
            this.X != a && (this.X = a, this.l == vr ? (this.A.setTextVisibility(a), this.g.streaming.alwaysStreamText || (a ? this.m.C || (a = lg(this.i.textStreams, this.Ic, this.be, this.Re), a.length > 0 && (Xm(this.m, a[0]), xr(this), Mr(this))) : Tm(this.m))) : this.h && this.h.src && this.h.textTracks && this.A.setTextVisibility(a), Lr(this));
        };
        p.$k = function() {
            if (this.G) var a = this.G.$e();
            else {
                if (this.O == null) return new Date;
                if (this.O instanceof Date) return this.O;
                a = this.O;
            }
            if (this.i && !this.Da()) {
                var b = this.i.presentationTimeline;
                return new Date(((b.m || b.i) + a) * 1E3);
            }
            return this.h && this.h.getStartDate ? (b = this.h.getStartDate(), isNaN(b.getTime()) ? null : new Date(b.getTime() + a * 1E3)) : null;
        };
        p.uh = function() {
            if (this.i && !this.Da()) {
                var a = this.i.presentationTimeline;
                a = a.m || a.i;
                return a === null ? null : new Date(a * 1E3);
            }
            return this.h && this.h.getStartDate ? (a = this.h.getStartDate(), isNaN(a.getTime()) ? null : a) : null;
        };
        p.xf = function() {
            return this.U() ? this.i ? this.i.presentationTimeline.xf() : null : null;
        };
        p.Pc = function() {
            if (this.l == vr) return this.H.Pc();
            var a = {
                total: [],
                audio: [],
                video: [],
                text: []
            };
            this.l == zr && (a.total = Hj(this.h.buffered));
            return a;
        };
        function Aq(a) {
            if (!a.h || !a.h.currentTime) return null;
            a = a.uh().getTime() + a.h.currentTime * 1E3;
            return Math.floor(Date.now() - a);
        }
        p.getBandwidthEstimate = function() {
            return this.u ? this.u.getBandwidthEstimate() : NaN;
        };
        p.getStats = function() {
            if (this.l != vr && this.l != zr) return {
                width: NaN,
                height: NaN,
                currentCodecs: "",
                streamBandwidth: NaN,
                decodedFrames: NaN,
                droppedFrames: NaN,
                corruptedFrames: NaN,
                stallsDetected: NaN,
                gapsJumped: NaN,
                estimatedBandwidth: NaN,
                completionPercent: NaN,
                loadLatency: NaN,
                manifestTimeSeconds: NaN,
                drmTimeSeconds: NaN,
                playTime: NaN,
                pauseTime: NaN,
                bufferingTime: NaN,
                licenseTime: NaN,
                liveLatency: NaN,
                maxSegmentDuration: NaN,
                manifestSizeBytes: NaN,
                bytesDownloaded: NaN,
                nonFatalErrorCount: NaN,
                manifestPeriodCount: NaN,
                manifestGapCount: NaN,
                switchHistory: [],
                stateHistory: []
            };
            ur(this);
            var a = this.h, b = a.currentTime / a.duration;
            isNaN(b) || this.U() || lo(this.C, Math.round(100 * b));
            this.G && (this.C.R = this.G.Ai(), this.C.S = this.G.Ci());
            a.getVideoPlaybackQuality && (b = a.getVideoPlaybackQuality(), jo(this.C, Number(b.droppedVideoFrames), Number(b.totalVideoFrames)), this.C.M = Number(b.corruptedVideoFrames));
            this.C.u = this.F ? ai(this.F) : NaN;
            ko(this.C, a.videoWidth || NaN, a.videoHeight || NaN);
            this.C.l = "";
            this.U() && this.uh() != null && (a = Aq(this) || 0, this.C.F = a / 1E3);
            b = this.Ob().find(function(e) {
                return e.active;
            });
            a = this.yc().find(function(e) {
                return e.active;
            });
            if (b) {
                if (b.bandwidth) {
                    var c = this.L ? this.L.i : 1, d = c * b.bandwidth;
                    a && a.bandwidth && (d += c * a.bandwidth);
                    this.C.C = d;
                }
                b.width && b.height && ko(this.C, b.width || NaN, b.height || NaN);
                b = b.codecs;
                a && (b += "," + (a.codecs || a.mimeType));
                b && (this.C.l = b);
            }
            this.l != vr || this.Da() || (this.i && (this.C.I = this.i.periodCount, this.C.H = this.i.gapCount, this.i.presentationTimeline && (this.C.K = this.i.presentationTimeline.h)), a = this.u.getBandwidthEstimate(), this.C.A = a);
            this.l == zr && mo(this.C, NaN);
            return no(this.C);
        };
        p.ee = function(a, b, c, d, e, f, g) {
            g = g === void 0 ? !1 : g;
            var h = this, k, l, m, n, q, r, t, w, v, z, y, A;
            return Q(function(C) {
                switch(C.g){
                    case 1:
                        if (h.l != vr && h.l != zr) throw new U(1, 7, 7004);
                        c != "subtitles" && c != "captions" && ab("Using a kind value different of `subtitles` or `captions` can cause unwanted issues.");
                        if (d) {
                            C.B(2);
                            break;
                        }
                        return F(C, gs(h, a), 3);
                    case 3:
                        d = C.h;
                    case 2:
                        k = [];
                        h.D && (k = h.D.getCuePoints());
                        if (h.l != zr) {
                            C.B(4);
                            break;
                        }
                        l = Rb();
                        g && l.Ja() === "WEBKIT" && (c = "forced");
                        return F(C, hs(h, a, b, c, d, f || "", k), 5);
                    case 5:
                        m = C.h;
                        if (m.track) return yr(h), C.return(hg(m.track));
                        throw new U(1, 2, 2012);
                    case 4:
                        n = uc;
                        q = h.za();
                        r = q.end - q.start;
                        h.i && (r = h.i.presentationTimeline.getDuration());
                        if (r == Infinity) throw new U(1, 4, 4033);
                        if (!k.length) {
                            C.B(6);
                            break;
                        }
                        return F(C, is(h, a, h.J, h.g.streaming.retryParameters), 7);
                    case 7:
                        t = C.h, w = js(h, t, d, k), v = new Blob([
                            w
                        ], {
                            type: "text/vtt"
                        }), a = zk(v), d = "text/vtt";
                    case 6:
                        z = {
                            id: h.Te++,
                            originalId: null,
                            groupId: null,
                            createSegmentIndex: function() {
                                return Promise.resolve();
                            },
                            segmentIndex: Zl(0, r, [
                                a
                            ]),
                            mimeType: d || "",
                            codecs: e || "",
                            kind: c,
                            encrypted: !1,
                            drmInfos: [],
                            keyIds: new Set,
                            language: b,
                            originalLanguage: b,
                            label: f || null,
                            type: n.Va,
                            primary: !1,
                            trickModeVideo: null,
                            dependencyStream: null,
                            emsgSchemeIdUris: null,
                            roles: [],
                            forced: !!g,
                            channelsCount: null,
                            audioSamplingRate: null,
                            spatialAudio: !1,
                            closedCaptions: null,
                            accessibilityPurpose: null,
                            external: !0,
                            fastSwitching: !1,
                            fullMimeTypes: new Set([
                                df(d || "", e || "")
                            ]),
                            isAudioMuxedInVideo: !1,
                            baseOriginalId: null
                        };
                        y = df(z.mimeType, z.codecs);
                        A = tf(y);
                        if (!A) throw new U(2, 2, 2014, d);
                        h.i.textStreams.push(z);
                        yr(h);
                        return C.return(cg(z));
                }
            });
        };
        p.ef = function(a, b) {
            var c = this, d, e, f, g, h, k, l, m, n, q, r, t, w, v, z, y, A, C;
            return Q(function(E) {
                switch(E.g){
                    case 1:
                        if (c.l != vr && c.l != zr) throw new U(1, 7, 7004);
                        if (b) {
                            E.B(2);
                            break;
                        }
                        return F(E, gs(c, a), 3);
                    case 3:
                        b = E.h;
                    case 2:
                        if (b != "text/vtt") throw new U(1, 2, 2017, a);
                        d = uc;
                        e = c.za();
                        f = e.end - e.start;
                        c.i && (f = c.i.presentationTimeline.getDuration());
                        if (f == Infinity) throw new U(1, 4, 4045);
                        return F(E, is(c, a, c.J, c.g.streaming.retryParameters), 4);
                    case 4:
                        g = E.h;
                        h = sf(b);
                        if (!h) throw new U(2, 2, 2014, b);
                        k = h();
                        l = {
                            periodStart: 0,
                            segmentStart: 0,
                            segmentEnd: f,
                            vttOffset: 0
                        };
                        m = Kb(g);
                        n = k.parseMedia(m, l, a, []);
                        q = [];
                        r = u(n);
                        t = r.next();
                        for(w = {}; !t.done; w = {
                            wg: void 0,
                            Ed: void 0
                        }, t = r.next())w.Ed = t.value, w.wg = null, v = function(D) {
                            return function() {
                                D.wg == null && (D.wg = mc([
                                    a
                                ], [
                                    D.Ed.payload
                                ]));
                                return D.wg || [];
                            };
                        }(w), z = new yj(w.Ed.startTime, w.Ed.endTime, v, 0, null, null, 0, 0, Infinity), w.Ed.payload.includes("#xywh") && (y = w.Ed.payload.split("#xywh=")[1].split(","), y.length === 4 && z.jg({
                            height: parseInt(y[3], 10),
                            positionX: parseInt(y[0], 10),
                            positionY: parseInt(y[1], 10),
                            width: parseInt(y[2], 10)
                        })), q.push(z);
                        A = b;
                        if (!q.length) {
                            E.B(5);
                            break;
                        }
                        return F(E, Jo(q[0].T()[0], c.J, c.g.manifest.retryParameters), 6);
                    case 6:
                        A = E.h;
                    case 5:
                        return C = {
                            id: c.Te++,
                            originalId: null,
                            groupId: null,
                            createSegmentIndex: function() {
                                return Promise.resolve();
                            },
                            segmentIndex: new Xl(q),
                            mimeType: A || "",
                            codecs: "",
                            kind: "",
                            encrypted: !1,
                            drmInfos: [],
                            keyIds: new Set,
                            language: "und",
                            originalLanguage: null,
                            label: null,
                            type: d.yg,
                            primary: !1,
                            trickModeVideo: null,
                            dependencyStream: null,
                            emsgSchemeIdUris: null,
                            roles: [],
                            forced: !1,
                            channelsCount: null,
                            audioSamplingRate: null,
                            spatialAudio: !1,
                            closedCaptions: null,
                            tilesLayout: "1x1",
                            accessibilityPurpose: null,
                            external: !0,
                            fastSwitching: !1,
                            fullMimeTypes: new Set([
                                df(A || "", "")
                            ]),
                            isAudioMuxedInVideo: !1,
                            baseOriginalId: null
                        }, c.l == zr ? c.Ye.push(C) : c.i.imageStreams.push(C), yr(c), E.return(dg(C));
                }
            });
        };
        p.df = function(a, b, c) {
            var d = this, e, f, g, h, k, l, m, n, q, r, t, w, v, z, y;
            return Q(function(A) {
                switch(A.g){
                    case 1:
                        if (d.l != vr && d.l != zr) throw new U(1, 7, 7004);
                        if (c) {
                            A.B(2);
                            break;
                        }
                        return F(A, gs(d, a), 3);
                    case 3:
                        c = A.h;
                    case 2:
                        e = uc;
                        f = d.za();
                        g = f.end - f.start;
                        d.i && (g = d.i.presentationTimeline.getDuration());
                        if (g == Infinity) throw new U(1, 4, 4054);
                        return F(A, is(d, a, d.J, d.g.streaming.retryParameters), 4);
                    case 4:
                        h = A.h;
                        k = sf(c);
                        if (!k) throw new U(2, 2, 2014, c);
                        l = k();
                        m = {
                            periodStart: 0,
                            segmentStart: 0,
                            segmentEnd: g,
                            vttOffset: 0
                        };
                        n = Kb(h);
                        q = l.parseMedia(n, m, a, []);
                        r = [];
                        t = u(q);
                        w = t.next();
                        for(v = {}; !w.done; v = {
                            pf: void 0
                        }, w = t.next())v.pf = w.value, z = new yj(v.pf.startTime, v.pf.endTime, function(C) {
                            return function() {
                                return [
                                    C.pf.payload
                                ];
                            };
                        }(v), 0, null, null, 0, 0, Infinity), r.push(z);
                        y = {
                            id: d.Te++,
                            originalId: null,
                            groupId: null,
                            createSegmentIndex: function() {
                                return Promise.resolve();
                            },
                            segmentIndex: new Xl(r),
                            mimeType: "text/plain",
                            codecs: "",
                            kind: "",
                            encrypted: !1,
                            drmInfos: [],
                            keyIds: new Set,
                            language: b,
                            originalLanguage: b,
                            label: null,
                            type: e.Va,
                            primary: !1,
                            trickModeVideo: null,
                            dependencyStream: null,
                            emsgSchemeIdUris: null,
                            roles: [],
                            forced: !1,
                            channelsCount: null,
                            audioSamplingRate: null,
                            spatialAudio: !1,
                            closedCaptions: null,
                            accessibilityPurpose: null,
                            external: !0,
                            fastSwitching: !1,
                            fullMimeTypes: new Set([
                                df("text/plain", "")
                            ]),
                            isAudioMuxedInVideo: !1,
                            baseOriginalId: null
                        };
                        d.ib.push(y);
                        yr(d);
                        return A.return(cg(y));
                }
            });
        };
        function gs(a, b) {
            var c;
            return Q(function(d) {
                switch(d.g){
                    case 1:
                        return ra(d, 2), F(d, Jo(b, a.J, a.g.streaming.retryParameters), 4);
                    case 4:
                        c = d.h;
                        ta(d, 3);
                        break;
                    case 2:
                        ua(d);
                    case 3:
                        if (c) return d.return(c);
                        throw new U(1, 2, 2011, b);
                }
            });
        }
        function hs(a, b, c, d, e, f, g) {
            var h, k, l, m;
            return Q(function(n) {
                if (n.g == 1) return e != "text/vtt" || g.length ? F(n, is(a, b, a.J, a.g.streaming.retryParameters), 3) : n.B(2);
                n.g != 2 && (h = n.h, k = js(a, h, e, g), l = new Blob([
                    k
                ], {
                    type: "text/vtt"
                }), b = zk(l), e = "text/vtt");
                m = document.createElement("track");
                a: {
                    var q = a.K, r = b;
                    try {
                        if (!q.g.enabled) {
                            var t = r;
                            break a;
                        }
                        var w = yp(q);
                        w.ot = tq;
                        w.su = !0;
                        var v = Cp(w);
                        t = Dp(r, v);
                        break a;
                    } catch (z) {
                        bb("CMCD_TEXT_TRACK_ERROR", "Could not generate text track CMCD data.", z);
                        t = r;
                        break a;
                    }
                    t = void 0;
                }
                m.src = t;
                m.label = f;
                m.kind = d;
                m.srclang = c;
                a.h.getAttribute("crossorigin") || a.h.setAttribute("crossorigin", "anonymous");
                a.h.appendChild(m);
                a.Cg.push(m);
                return n.return(m);
            });
        }
        function is(a, b, c, d) {
            var e, f, g;
            return Q(function(h) {
                if (h.g == 1) {
                    e = fh;
                    f = $g([
                        b
                    ], d);
                    f.method = "GET";
                    var k = a.K;
                    try {
                        k.g.enabled && Sp(k, f, {
                            ot: tq,
                            su: !0
                        });
                    } catch (l) {
                        bb("CMCD_TEXT_ERROR", "Could not generate text CMCD data.", l);
                    }
                    return F(h, c.request(e, f).promise, 2);
                }
                g = h.h;
                return h.return(g.data);
            });
        }
        function js(a, b, c, d) {
            var e = sf(c);
            if (e) return c = e(), a = {
                periodStart: 0,
                segmentStart: 0,
                segmentEnd: a.h.duration,
                vttOffset: 0
            }, b = Kb(b), b = c.parseMedia(b, a, null, []), kp(b, d);
            throw new U(2, 2, 2014, c);
        }
        p.wm = function(a, b) {
            this.sa.width = a;
            this.sa.height = b;
        };
        p.Xh = function(a) {
            if (this.l == vr) {
                var b = this.m;
                a = a === void 0 ? .1 : a;
                if (b.l.g) b = !1;
                else if (b.D) b = !1;
                else {
                    for(var c = u(b.h.values()), d = c.next(); !d.done; d = c.next())d = d.value, !d.qe || d.Ra || d.Ab || (d.qe = !1, Sm(b, d, a));
                    b = !0;
                }
            } else b = !1;
            return b;
        };
        p.rh = function() {
            ab("Shaka Player's internal Manifest structure is NOT covered by semantic versioning compatibility guarantees.  It may change at any time!  Please consider filing a feature request for whatever you use getManifest() for.");
            return this.i;
        };
        p.Wk = function() {
            return this.Ec;
        };
        p.Ok = function() {
            var a = {
                video: null,
                audio: null,
                text: null
            };
            if (this.l != vr) return a;
            var b = this.m.u, c = this.h.currentTime;
            b = u([
                b.video,
                b.audio,
                this.m.C
            ]);
            for(var d = b.next(); !d.done; d = b.next())if ((d = d.value) && d.segmentIndex) {
                var e = d.segmentIndex.find(c);
                e = d.segmentIndex.get(e);
                e = {
                    codecs: e.codecs || d.codecs,
                    mimeType: e.mimeType || d.mimeType,
                    bandwidth: e.bandwidth || d.bandwidth
                };
                d.type == "video" ? (e.width = d.width, e.height = d.height, a.video = e) : d.type == "audio" ? a.audio = e : d.type == sc && (a.text = e);
            }
            return a;
        };
        function Kq(a) {
            var b = Xn();
            b.streaming.failureCallback = function(c) {
                if (a.U()) {
                    var d = null;
                    c.code == 1001 || c.code == 1002 ? (d = 1, a.g.streaming.lowLatencyMode && (d = .1)) : c.code == 1003 && (d = .1);
                    d != null && (c.severity = 1, a.Xh(d));
                }
            };
            b.textDisplayFactory = function() {
                if (a.Oe) {
                    var c = a.h;
                    c = c.webkitDisplayingFullscreen || c.webkitPresentationMode && c.webkitPresentationMode != "inline" ? !1 : !0;
                } else c = !1;
                return c ? new ap(a.h, a.Oe) : "track" in document.createElement("track") ? new Wo(a) : new $o;
            };
            return b;
        }
        p.ji = function(a) {
            this.Oe = a;
        };
        function mr(a, b) {
            for(var c = new Set, d = u(b.textStreams), e = d.next(); !e.done; e = d.next())e = e.value, e.mimeType != "application/cea-608" && e.mimeType != "application/cea-708" || c.add(e.originalId);
            d = u(b.variants);
            for(e = d.next(); !e.done; e = d.next())if ((e = e.value.video) && e.closedCaptions) {
                for(var f = u(e.closedCaptions.keys()), g = f.next(); !g.done; g = f.next())if (g = g.value, !c.has(g)) {
                    var h = g.startsWith("CC") ? "application/cea-608" : "application/cea-708", k = new $l, l = e.closedCaptions.get(g);
                    h = {
                        id: a.Te++,
                        originalId: g,
                        groupId: null,
                        createSegmentIndex: function() {
                            return Promise.resolve();
                        },
                        segmentIndex: k,
                        mimeType: h,
                        codecs: "",
                        kind: "caption",
                        encrypted: !1,
                        drmInfos: [],
                        keyIds: new Set,
                        language: l,
                        originalLanguage: l,
                        label: null,
                        type: sc,
                        primary: !1,
                        trickModeVideo: null,
                        dependencyStream: null,
                        emsgSchemeIdUris: null,
                        roles: e.roles,
                        forced: !1,
                        channelsCount: null,
                        audioSamplingRate: null,
                        spatialAudio: !1,
                        closedCaptions: null,
                        accessibilityPurpose: null,
                        external: !1,
                        fastSwitching: !1,
                        fullMimeTypes: new Set([
                            df(h, "")
                        ]),
                        isAudioMuxedInVideo: !1,
                        baseOriginalId: null
                    };
                    b.textStreams.push(h);
                    c.add(g);
                }
            }
        }
        function Kr(a, b) {
            var c, d, e, f, g;
            return Q(function(h) {
                if (h.g == 1) return c = a.audio, d = a.video, e = function(k, l) {
                    var m, n, q;
                    return Q(function(r) {
                        if (r.g == 1) return k ? k.segmentIndex ? r.B(2) : F(r, k.createSegmentIndex(), 2) : r.return(null);
                        n = (m = k.segmentIndex.ec(l)) ? m.next().value : null;
                        if (!n) return r.return(null);
                        q = n.startTime;
                        return r.return(q);
                    });
                }, F(h, e(c, b), 2);
                if (h.g != 3) return f = h.h, F(h, e(d, b), 3);
                g = h.h;
                return g != null && f != null ? h.return(Math.max(g, f)) : g != null ? h.return(g) : f != null ? h.return(f) : h.return(b);
            });
        }
        function br(a) {
            var b = a.Cf();
            if (a.C && a.P && a.G) {
                if (a.g.streaming.rebufferingGoal == 0) {
                    var c = a.L;
                    c.j = !1;
                    dm(c);
                } else c = a.L, c.j = b, dm(c);
                a.K && (c = a.K, b || c.D || (c.D = !0), c.D && b && (c.I = !0, wp(c, "ps", {
                    td: "r"
                })), c.J = b);
                ur(a);
                c = a.g.streaming.liveSync.dynamicTargetLatency.maxAttempts;
                if (a.g.streaming.liveSync.dynamicTargetLatency.enabled && b && a.cf < c) {
                    c = a.g.streaming.liveSync.dynamicTargetLatency.maxLatency;
                    var d = a.g.streaming.liveSync.targetLatencyTolerance, e = a.g.streaming.liveSync.dynamicTargetLatency.rebufferIncrement;
                    a.S && (a.S = Math.min(a.S + ++a.cf * e, c - d));
                }
            }
            b = (new Map).set("buffering", b);
            a.dispatchEvent(Sq("buffering", b));
        }
        function wr(a, b) {
            a.kc.Sa();
            a.kc.o(a.h, "timeupdate", function() {
                var c = a.h.currentTime, d = a.za(), e = a.U(), f = e ? a.g.streaming.safeSeekOffset : 0;
                b > 0 ? (!e || b >= 1) && Math.floor(c) >= Math.floor(d.end) && a.Bd() : Math.floor(c) <= Math.floor(d.start + f) && a.Bd();
            });
        }
        function ur(a) {
            if (a.C && a.P) {
                var b = a.C.g, c = "playing";
                a.P.g == pi ? c = "buffering" : a.isEnded() ? c = "ended" : a.h.paused && (c = "paused");
                var d = c;
                if (b.g == null) b.g = {
                    timestamp: Date.now() / 1E3,
                    state: d,
                    duration: 0
                }, b = !0;
                else {
                    var e = Date.now() / 1E3;
                    b.g.duration = e - b.g.timestamp;
                    b.g.state == d ? b = !1 : (b.h.push(b.g), b.g = {
                        timestamp: e,
                        state: d,
                        duration: 0
                    }, b = !0);
                }
                b && (c = (new Map).set("newstate", c), a.dispatchEvent(Sq("statechanged", c)));
            }
        }
        function Or(a) {
            var b = a.h.playbackRate, c = a.U();
            if (a.g.streaming.vodDynamicPlaybackRate && !c) {
                var d = a.g.streaming.vodDynamicPlaybackRateLowBufferRate, e = a.Wi();
                e <= a.g.streaming.vodDynamicPlaybackRateBufferRatio ? b != d && a.sc(d, !1) : e == 1 && b !== a.L.jd() && a.Bd();
            }
            if (c && (c = a.za(), Number.isFinite(c.end) && !(a.h.currentTime < c.start || a.h.paused))) {
                d = a.g.streaming.liveSync.targetLatencyTolerance;
                e = a.g.streaming.liveSync.dynamicTargetLatency.enabled;
                var f = a.g.streaming.liveSync.dynamicTargetLatency.stabilityThreshold;
                if (a.g.streaming.liveSync && a.g.streaming.liveSync.enabled) {
                    var g = a.g.streaming.liveSync.targetLatency;
                    var h = g + d;
                    var k = Math.max(0, g - d);
                    var l = a.g.streaming.liveSync.maxPlaybackRate;
                    var m = a.g.streaming.liveSync.minPlaybackRate;
                } else a.i && a.i.serviceDescription && (g = a.i.serviceDescription.targetLatency, a.i.serviceDescription.targetLatency != null ? h = a.i.serviceDescription.targetLatency + d : a.i.serviceDescription.maxLatency != null && (h = a.i.serviceDescription.maxLatency), a.i.serviceDescription.targetLatency != null ? k = Math.max(0, a.i.serviceDescription.targetLatency - d) : a.i.serviceDescription.minLatency != null && (k = a.i.serviceDescription.minLatency), l = a.i.serviceDescription.maxPlaybackRate || a.g.streaming.liveSync.maxPlaybackRate, m = a.i.serviceDescription.minPlaybackRate || a.g.streaming.liveSync.minPlaybackRate);
                a.S || typeof g !== "number" || (a.S = g);
                var n = a.g.streaming.liveSync.dynamicTargetLatency.maxAttempts;
                e && a.Pb && a.S !== null && typeof g === "number" && a.cf < n && Date.now() - a.Pb > f * 1E3 && (f = a.g.streaming.liveSync.dynamicTargetLatency.minLatency, a.S = Math.max(a.S - (g - f) / 2, f + d), a.Pb = Date.now());
                e && a.S !== null && (h = a.S + d, k = a.S - d);
                g = c.end - a.h.currentTime;
                d = 0;
                a.l == zr && (e = a.h.buffered, e.length > 0 && (d = e.end(e.length - 1), d = Math.max(l, d - c.end)));
                c = a.g.streaming.liveSync.panicMode;
                e = a.g.streaming.liveSync.panicThreshold * 1E3;
                f = Date.now() - a.P.h;
                c && !m && (m = a.g.streaming.liveSync.minPlaybackRate);
                c && m && f <= e ? b != m && a.sc(m, !1) : h != void 0 && l && g - d > h ? (b != l && a.sc(l, !1), a.Pb = null) : k != void 0 && m && g - d < k ? (b != m && a.sc(m, !1), a.Pb = null) : b !== a.L.jd() && (a.Bd(), a.Pb = Date.now());
            }
        }
        function Pr(a) {
            if (a.h) {
                var b = function(e, f) {
                    var g = g === void 0 ? Number.EPSILON : g;
                    if (e === f) g = !0;
                    else {
                        var h = Math.abs(e - f);
                        g = h <= g ? !0 : g !== Number.EPSILON ? Math.abs(h - g) <= Number.EPSILON : !1;
                    }
                    return (g || f > e) && a.Bg < e ? (a.Bg = e, !0) : !1;
                }, c = a.za();
                c = c.end - c.start;
                c = c > 0 ? a.h.currentTime / c : 0;
                if (!isNaN(c)) {
                    c *= 100;
                    if (b(0, c)) var d = Sq("started");
                    else if (b(25, c)) d = Sq("firstquartile");
                    else if (b(50, c)) d = Sq("midpoint");
                    else if (b(75, c)) d = Sq("thirdquartile");
                    else {
                        if (b(100, c) || c > 100) d = Sq("complete");
                        a.g && a.g.playRangeEnd != Infinity && a.isEnded() && a.h.pause();
                    }
                    d && a.dispatchEvent(d);
                }
            }
        }
        function Cr(a) {
            try {
                zi(a.Se, a.i);
            } catch (c) {
                return $q(a, c), !1;
            }
            var b = kg(a.i.variants);
            b = a.M.create(b);
            a = a.u.setVariants(Array.from(b.values()));
            return typeof a == "boolean" ? a : !0;
        }
        function Gr(a, b) {
            b = b === void 0 ? !1 : b;
            return Cr(a) ? a.u.chooseVariant(b) : null;
        }
        function Pq(a, b, c, d, e) {
            b = b === void 0 ? !0 : b;
            c = c === void 0 ? 0 : c;
            d = d === void 0 ? !1 : d;
            e = e === void 0 ? !0 : e;
            var f = Gr(a);
            f && Er(a, f, e, b, c, d);
        }
        function Er(a, b, c, d, e, f) {
            f = f === void 0 ? !1 : f;
            var g = a.m.u;
            if (b == g) d && Wm(a.m, b, d, e, !0);
            else {
                var h = a.C.h;
                h.h != b && (h.h = b, h.g.push({
                    timestamp: Date.now() / 1E3,
                    id: b.id,
                    type: "variant",
                    fromAdaptation: c,
                    bandwidth: b.bandwidth
                }));
                Wm(a.m, b, d, e, f, c);
                d = null;
                g && (d = bg(g));
                g = bg(b);
                g.active = !0;
                if (a.R && (e = a.R, b = b.video)) {
                    b.dependencyStream && (b = b.dependencyStream);
                    f = 0;
                    h = -1;
                    switch(b.mimeType){
                        case "video/webm":
                            f = 1;
                            break;
                        case "video/mp4":
                            f = 2;
                    }
                    switch(a.sh()){
                        case "DASH":
                            h = 1;
                            break;
                        case "HLS":
                            h = 0;
                    }
                    e.g && (e.g.setLevelSwitching(b.id, !0), e.g.setContainerFormat(f), e.j || e.g.setStreamingFormat(h));
                }
                c ? (c = (new Map).set("oldTrack", d).set("newTrack", g), c = Sq("adaptation", c), ks(a, c)) : ls(a, d, g);
                ms(a, d, g);
            }
        }
        function ds(a, b) {
            var c = Array.from(a.h.audioTracks).find(function(e) {
                return e.enabled;
            });
            b.enabled = !0;
            if (c) {
                b.id !== c.id && (c.enabled = !1);
                var d = $r(a);
                c = ig(c, d);
                b = ig(b, d);
                ls(a, c, b);
                ms(a, c, b);
            }
        }
        function $r(a) {
            return a.h && a.h.videoTracks ? Array.from(a.h.videoTracks).find(function(b) {
                return b.selected;
            }) : null;
        }
        function yr(a) {
            var b = Sq("trackschanged");
            ks(a, b);
            ns(a);
        }
        function ls(a, b, c) {
            b = (new Map).set("oldTrack", b).set("newTrack", c);
            b = Sq("variantchanged", b);
            ks(a, b);
        }
        function ms(a, b, c) {
            var d = !1;
            b && b.audioId == c.audioId && b.audioGroupId == c.audioGroupId || (d = !0);
            d && ns(a);
        }
        function ns(a) {
            var b = Sq("audiotrackschanged");
            ks(a, b);
        }
        function xr(a) {
            var b = Sq("textchanged");
            ks(a, b);
        }
        function Lr(a) {
            var b = Sq("texttrackvisibility");
            ks(a, b);
        }
        function Nr(a) {
            a.g.abr.enabled || Oq(a);
            var b = (new Map).set("newStatus", a.g.abr.enabled);
            ks(a, Sq("abrstatuschanged", b));
        }
        function Mr(a) {
            var b = a.yc().find(function(c) {
                return c.active;
            });
            b && a.A && a.A.setTextLanguage && a.A.setTextLanguage(b.language);
        }
        function Oq(a, b) {
            b = b === void 0 ? !0 : b;
            if (a.l == vr) {
                a.Ve.stop();
                for(var c = u(a.i.variants), d = c.next(); !d.done; d = c.next())d.value.disabledUntilTime = 0;
                b && Cr(a);
            }
        }
        p.disableStream = function(a, b) {
            if (!this.g.abr.enabled || this.l === Tq || !navigator.onLine || b == 0 || !this.i) return !1;
            if (this.i.variants.some(function(h) {
                var k = h[a.type];
                return k && k.id !== a.id && !h.disabledUntilTime ? a.type == "audio" ? a.language === k.language : !0 : !1;
            })) {
                for(var c = !1, d = !1, e = u(this.i.variants), f = e.next(); !f.done; f = e.next()){
                    f = f.value;
                    var g = f[a.type];
                    g && (g.id === a.id ? (f.disabledUntilTime = Date.now() / 1E3 + b, c = !0) : g.trickModeVideo && g.trickModeVideo.id == a.id && (d = !0));
                }
                if (!c && d) return !1;
                this.Ve.wa(1);
                b = this.Pc().video.reduce(function(h, k) {
                    return h + k.end - k.start;
                }, 0);
                Pq(this, !1, b, !0, !1);
                return !0;
            }
            return !1;
        };
        function $q(a, b) {
            var c, d, e, f, g;
            return Q(function(h) {
                switch(h.g){
                    case 1:
                        if (a.l == Tq) return h.return();
                        b.severity === 1 && a.C.L++;
                        c = !0;
                        if (!(a.aa && a.i && a.m) || b.code != 3016 && b.code != 3014 && b.code != 3015 && b.code != 3024 && b.code != 3018) {
                            h.B(2);
                            break;
                        }
                        d = Rb();
                        if (d.Ja() === "WEBKIT" && b.code == 3016) return h.return();
                        ra(h, 3);
                        return F(h, mn(a.m), 5);
                    case 5:
                        e = h.h;
                        c = !e;
                        e && (f = Sq("mediasourcerecovered"), a.dispatchEvent(f));
                        ta(h, 2);
                        break;
                    case 3:
                        ua(h), c = !0;
                    case 2:
                        if (!c) return h.return();
                        b.severity === 2 && Oq(a, !1);
                        g = Sq("error", (new Map).set("detail", b));
                        a.dispatchEvent(g);
                        g.defaultPrevented && (b.handled = !0);
                        H(h);
                }
            });
        }
        p.addFont = function(a, b) {
            return Sj(a, b);
        };
        function or(a, b, c, d) {
            d = d === void 0 ? a : d;
            a = (new Map).set("detail", {
                schemeIdUri: c.schemeIdUri,
                value: c.value,
                startTime: c.startTime,
                endTime: c.endTime,
                id: c.id,
                timescale: c.timescale,
                eventElement: c.eventElement,
                eventNode: c.eventNode
            });
            d.dispatchEvent(Sq(b, a));
        }
        function pr(a, b, c, d) {
            d = d === void 0 ? !1 : d;
            b = (new Map).set("mediaQuality", {
                bandwidth: b.bandwidth,
                audioSamplingRate: b.audioSamplingRate,
                codecs: b.codecs,
                contentType: b.contentType,
                frameRate: b.frameRate,
                height: b.height,
                mimeType: b.mimeType,
                channelsCount: b.channelsCount,
                pixelAspectRatio: b.pixelAspectRatio,
                width: b.width,
                label: b.label,
                roles: b.roles,
                language: b.language
            }).set("position", c);
            a.dispatchEvent(Sq(d ? "audiotrackchanged" : "mediaqualitychanged", b));
        }
        function Zq(a, b) {
            b = b === void 0 ? !0 : b;
            if (!a.h.error) return b ? new U(2, 3, 3016) : null;
            var c = a.h.error.code;
            if (!b && c == 1) return null;
            if (b = a.h.error.msExtendedCode) b < 0 && (b += 4294967296), b = b.toString(16);
            return new U(2, 3, 3016, c, b, a.h.error.message);
        }
        function qr(a, b) {
            var c = Sq("keystatuschanged");
            a.dispatchEvent(c);
            var d = Object.keys(b);
            d.length == 1 && d[0] == "" && (d = [
                "00"
            ], b = {
                "00": b[""]
            });
            var e = d.length == 1 && d[0] == "00";
            c = !1;
            if (d.length) {
                d = a.keySystem();
                for(var f = jh(a.g.drm.clearKeys), g = function(t, w) {
                    t.allowedByKeySystem = !0;
                    w = u(w);
                    for(var v = w.next(); !v.done; v = w.next())if (v = v.value, (v = b[e ? "00" : v]) || a.F.L) t.allowedByKeySystem = t.allowedByKeySystem && !!v && !Ai.includes(v);
                }, h = u(a.i.variants), k = h.next(); !k.done; k = h.next()){
                    k = k.value;
                    var l = ng(k);
                    l = u(l);
                    for(var m = l.next(); !m.done; m = l.next()){
                        m = m.value;
                        var n = k.allowedByKeySystem;
                        if (m.keyIds.size) {
                            if (m.drmInfos.length && !f.size && a.i.type == "HLS") for(var q = u(m.drmInfos), r = q.next(); !r.done; r = q.next())r = r.value, r.keySystem == d && (r.keyIds.size ? g(k, r.keyIds) : g(k, m.keyIds));
                            else g(k, m.keyIds);
                        }
                        n != k.allowedByKeySystem && (c = !0);
                    }
                }
            }
            if (c && (yr(a), !Cr(a))) return;
            (c = a.m.u) && !c.allowedByKeySystem && Pq(a);
        }
        function Dr(a, b, c) {
            b > 0 && (a.U() || a.Pj(b));
            b = a.getDuration();
            c < b && (a.U() || a.zb(c));
        }
        function ks(a, b) {
            Q(function(c) {
                if (c.g == 1) return F(c, Promise.resolve(), 2);
                a.l != Tq && a.dispatchEvent(b);
                H(c);
            });
        }
        function fs(a) {
            var b = new Set;
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next())c = c.value, c.language ? b.add(yc(c.language)) : b.add("und");
            return b;
        }
        function es(a) {
            for(var b = new Map, c = new Map, d = 0; d < a.length; d++){
                var e = a[d], f = "und", g = [];
                e.language && (f = yc(e.language));
                e.type == "variant" ? g = e.audioRoles : g = e.roles;
                g && g.length || (g = [
                    ""
                ]);
                b.has(f) || b.set(f, new Set);
                g = u(g);
                for(var h = g.next(); !h.done; h = g.next())h = h.value, b.get(f).add(h), e.label && (c.has(f) || c.set(f, new Map), c.get(f).set(h, e.label));
            }
            var k = [];
            b.forEach(function(l, m) {
                l = u(l);
                for(var n = l.next(); !n.done; n = l.next()){
                    n = n.value;
                    var q = null;
                    c.has(m) && c.get(m).has(n) && (q = c.get(m).get(n));
                    k.push({
                        language: m,
                        role: n,
                        label: q
                    });
                }
            });
            return k;
        }
        p.Da = function() {
            return this.h && this.h.remote ? this.h.remote.state != "disconnected" : !1;
        };
        p.isEnded = function() {
            return !this.h || this.h.ended ? !0 : this.aa && !this.U() && this.h.currentTime >= this.za().end;
        };
        S("shaka.Player", X);
        X.prototype.isEnded = X.prototype.isEnded;
        X.prototype.isRemotePlayback = X.prototype.Da;
        X.prototype.addFont = X.prototype.addFont;
        X.prototype.setVideoContainer = X.prototype.ji;
        X.prototype.getFetchedPlaybackInfo = X.prototype.Ok;
        X.prototype.getManifestParserFactory = X.prototype.Wk;
        X.prototype.getManifest = X.prototype.rh;
        X.prototype.retryStreaming = X.prototype.Xh;
        X.prototype.setMaxHardwareResolution = X.prototype.wm;
        X.prototype.addChaptersTrack = X.prototype.df;
        X.prototype.addThumbnailsTrack = X.prototype.ef;
        X.prototype.addTextTrackAsync = X.prototype.ee;
        X.prototype.getStats = X.prototype.getStats;
        X.prototype.getBufferedInfo = X.prototype.Pc;
        X.prototype.getSegmentAvailabilityDuration = X.prototype.xf;
        X.prototype.getPresentationStartTimeAsDate = X.prototype.uh;
        X.prototype.getPlayheadTimeAsDate = X.prototype.$k;
        X.prototype.setTextTrackVisibility = X.prototype.Zd;
        X.prototype.getChaptersAsync = X.prototype.oh;
        X.prototype.getChapters = X.prototype.Ek;
        X.prototype.getChaptersTracks = X.prototype.Fk;
        X.prototype.isTextTrackVisible = X.prototype.Xc;
        X.prototype.selectVariantsByLabel = X.prototype.qm;
        X.prototype.selectTextLanguage = X.prototype.ai;
        X.prototype.selectAudioLanguage = X.prototype.Gj;
        X.prototype.getTextLanguages = X.prototype.ll;
        X.prototype.getAudioLanguages = X.prototype.Ak;
        X.prototype.getTextLanguagesAndRoles = X.prototype.ol;
        X.prototype.getAudioLanguagesAndRoles = X.prototype.Bk;
        X.prototype.getVideoTracks = X.prototype.getVideoTracks;
        X.prototype.selectVideoTrack = X.prototype.Ij;
        X.prototype.getAudioTracks = X.prototype.getAudioTracks;
        X.prototype.selectAudioTrack = X.prototype.Hj;
        X.prototype.selectVariantTrack = X.prototype.Ge;
        X.prototype.selectTextTrack = X.prototype.fg;
        X.prototype.getThumbnails = X.prototype.$i;
        X.prototype.getAllThumbnails = X.prototype.zk;
        X.prototype.getImageTracks = X.prototype.qh;
        X.prototype.getTextTracks = X.prototype.yc;
        X.prototype.getVariantTracks = X.prototype.Ob;
        X.prototype.cancelTrickPlay = X.prototype.Bd;
        X.prototype.trickPlay = X.prototype.sc;
        X.prototype.useTrickPlayTrackIfAvailable = X.prototype.zi;
        X.prototype.getPlaybackRate = X.prototype.Za;
        X.prototype.isBuffering = X.prototype.Cf;
        X.prototype.getKeyStatuses = X.prototype.uf;
        X.prototype.getActiveSessionsMetadata = X.prototype.nh;
        X.prototype.getExpiration = X.prototype.me;
        X.prototype.drmInfo = X.prototype.drmInfo;
        X.prototype.keySystem = X.prototype.keySystem;
        X.prototype.isFullyLoaded = X.prototype.El;
        X.prototype.goToLive = X.prototype.Al;
        X.prototype.seekRange = X.prototype.za;
        X.prototype.isVideoOnly = X.prototype.Hh;
        X.prototype.isAudioOnly = X.prototype.Ld;
        X.prototype.isInProgress = X.prototype.ld;
        X.prototype.isLive = X.prototype.U;
        X.prototype.getQueueManager = X.prototype.vf;
        X.prototype.getAdManager = X.prototype.tf;
        X.prototype.getAssetUri = X.prototype.hd;
        X.prototype.getNetworkingEngine = X.prototype.Vb;
        X.prototype.getMediaElement = X.prototype.Zk;
        X.prototype.getManifestType = X.prototype.sh;
        X.prototype.getLoadMode = X.prototype.Sk;
        X.prototype.resetConfiguration = X.prototype.Bj;
        X.prototype.getBufferFullness = X.prototype.Wi;
        X.prototype.getNonDefaultConfiguration = X.prototype.Zi;
        X.prototype.getConfigurationForLowLatency = X.prototype.Ik;
        X.prototype.getConfiguration = X.prototype.getConfiguration;
        X.prototype.configurationForLowLatency = X.prototype.wk;
        X.prototype.configure = X.prototype.configure;
        X.prototype.releaseAllMutexes = X.prototype.fm;
        X.prototype.destroyAllPreloads = X.prototype.Ug;
        X.prototype.preload = X.prototype.preload;
        X.prototype.detachAndSavePreload = X.prototype.Si;
        X.prototype.unloadAndSavePreload = X.prototype.ck;
        X.prototype.load = X.prototype.load;
        X.prototype.updateStartTime = X.prototype.Em;
        X.prototype.unload = X.prototype.tc;
        X.prototype.detach = X.prototype.detach;
        X.prototype.attachCanvas = X.prototype.Gi;
        X.prototype.attach = X.prototype.cc;
        X.probeSupport = function(a) {
            a = a === void 0 ? !0 : a;
            var b, c, d, e, f, g, h;
            return Q(function(k) {
                switch(k.g){
                    case 1:
                        b = {};
                        if (!a) {
                            k.B(2);
                            break;
                        }
                        return F(k, li(), 3);
                    case 3:
                        b = k.h;
                    case 2:
                        return c = Ei(), d = Bk(), e = Rb(), F(k, e.wc(), 4);
                    case 4:
                        return f = k.h, g = {
                            manifest: c,
                            media: d,
                            drm: b,
                            hardwareResolution: f
                        }, h = Vq, h.forEach(function(l, m) {
                            g[m] = l();
                        }), k.return(g);
                }
            });
        };
        X.isBrowserSupported = Wq;
        X.setQueueManagerFactory = function(a) {
            Nq = a;
        };
        X.setAdManagerFactory = function(a) {
            Mq = a;
        };
        X.registerSupportPlugin = Uq;
        X.prototype.destroy = X.prototype.destroy;
        var Tq = 0, Jq = 1, vr = 2, zr = 3;
        X.LoadMode = {
            DESTROYED: Tq,
            NOT_LOADED: Jq,
            MEDIA_SOURCE: vr,
            SRC_EQUALS: zr
        };
        X.version = "v4.16.0";
        var os = [
            "4",
            "16"
        ];
        $c = new function(a) {
            this.g = a;
            this.i = ad;
            this.h = bd;
        }(new Yc(Number(os[0]), Number(os[1])));
        var Vq = new Map, Mq = null, Nq = null;
        function ps() {
            this.g = [];
            this.i = this.m = this.l = this.j = this.h = 0;
        }
        function qs(a) {
            return a.g.length ? a.g.reduce(function(b, c) {
                return b + c;
            }, 0) / a.g.length : 0;
        }
        function rs(a, b, c) {
            var d = this;
            this.g = a;
            this.h = b;
            this.m = c;
            this.i = !1;
            this.j = this.h.getVolume();
            this.l = new Tc;
            this.l.o(this.h, google.ima.AdEvent.Type.PAUSED, function() {
                d.i = !0;
            });
            this.l.o(this.h, google.ima.AdEvent.Type.RESUMED, function() {
                d.i = !1;
            });
        }
        p = rs.prototype;
        p.needsSkipUI = function() {
            return !1;
        };
        p.isClientRendering = function() {
            return !0;
        };
        p.hasCustomClick = function() {
            return !0;
        };
        p.isUsingAnotherMediaElement = function() {
            return !0;
        };
        p.getDuration = function() {
            return this.g.getDuration();
        };
        p.getMinSuggestedDuration = function() {
            return this.g.getMinSuggestedDuration();
        };
        p.getRemainingTime = function() {
            return this.h.getRemainingTime();
        };
        p.isPaused = function() {
            return this.i;
        };
        p.isSkippable = function() {
            return this.g.getSkipTimeOffset() >= 0;
        };
        p.getTimeUntilSkippable = function() {
            var a = this.g.getSkipTimeOffset();
            a = this.getRemainingTime() - a;
            return Math.max(a, 0);
        };
        p.canSkipNow = function() {
            return this.h.getAdSkippableState();
        };
        p.skip = function() {
            return this.h.skip();
        };
        p.pause = function() {
            return this.h.pause();
        };
        p.play = function() {
            return this.h.resume();
        };
        p.getVolume = function() {
            return this.h.getVolume();
        };
        p.setVolume = function(a) {
            this.m.volume = a;
            return this.h.setVolume(a);
        };
        p.isMuted = function() {
            return this.h.getVolume() == 0;
        };
        p.isLinear = function() {
            return this.g.isLinear();
        };
        p.resize = function(a, b) {
            this.h.resize(a, b);
        };
        p.setMuted = function(a) {
            (this.m.muted = a) ? (this.j = this.getVolume(), this.h.setVolume(0)) : this.h.setVolume(this.j);
        };
        p.getSequenceLength = function() {
            var a = this.g.getAdPodInfo();
            return a == null ? 1 : a.getTotalAds();
        };
        p.getPositionInSequence = function() {
            var a = this.g.getAdPodInfo();
            return a == null ? 1 : a.getAdPosition();
        };
        p.getTitle = function() {
            return this.g.getTitle();
        };
        p.getDescription = function() {
            return this.g.getDescription();
        };
        p.getVastMediaBitrate = function() {
            return this.g.getVastMediaBitrate();
        };
        p.getVastMediaHeight = function() {
            return this.g.getVastMediaHeight();
        };
        p.getVastMediaWidth = function() {
            return this.g.getVastMediaWidth();
        };
        p.getVastAdId = function() {
            return "";
        };
        p.getAdId = function() {
            return this.g.getAdId();
        };
        p.getCreativeAdId = function() {
            return this.g.getCreativeAdId();
        };
        p.getAdvertiserName = function() {
            return this.g.getAdvertiserName();
        };
        p.getMediaUrl = function() {
            return this.g.getMediaUrl();
        };
        p.getTimeOffset = function() {
            var a = this.g.getAdPodInfo();
            return a == null ? 0 : a.getTimeOffset();
        };
        p.getPodIndex = function() {
            var a = this.g.getAdPodInfo();
            return a == null ? 0 : a.getPodIndex();
        };
        p.release = function() {
            this.h = this.g = null;
        };
        S("shaka.ads.ClientSideAd", rs);
        rs.prototype.release = rs.prototype.release;
        rs.prototype.getPodIndex = rs.prototype.getPodIndex;
        rs.prototype.getTimeOffset = rs.prototype.getTimeOffset;
        rs.prototype.getMediaUrl = rs.prototype.getMediaUrl;
        rs.prototype.getAdvertiserName = rs.prototype.getAdvertiserName;
        rs.prototype.getCreativeAdId = rs.prototype.getCreativeAdId;
        rs.prototype.getAdId = rs.prototype.getAdId;
        rs.prototype.getVastAdId = rs.prototype.getVastAdId;
        rs.prototype.getVastMediaWidth = rs.prototype.getVastMediaWidth;
        rs.prototype.getVastMediaHeight = rs.prototype.getVastMediaHeight;
        rs.prototype.getVastMediaBitrate = rs.prototype.getVastMediaBitrate;
        rs.prototype.getDescription = rs.prototype.getDescription;
        rs.prototype.getTitle = rs.prototype.getTitle;
        rs.prototype.getPositionInSequence = rs.prototype.getPositionInSequence;
        rs.prototype.getSequenceLength = rs.prototype.getSequenceLength;
        rs.prototype.setMuted = rs.prototype.setMuted;
        rs.prototype.resize = rs.prototype.resize;
        rs.prototype.isLinear = rs.prototype.isLinear;
        rs.prototype.isMuted = rs.prototype.isMuted;
        rs.prototype.setVolume = rs.prototype.setVolume;
        rs.prototype.getVolume = rs.prototype.getVolume;
        rs.prototype.play = rs.prototype.play;
        rs.prototype.pause = rs.prototype.pause;
        rs.prototype.skip = rs.prototype.skip;
        rs.prototype.canSkipNow = rs.prototype.canSkipNow;
        rs.prototype.getTimeUntilSkippable = rs.prototype.getTimeUntilSkippable;
        rs.prototype.isSkippable = rs.prototype.isSkippable;
        rs.prototype.isPaused = rs.prototype.isPaused;
        rs.prototype.getRemainingTime = rs.prototype.getRemainingTime;
        rs.prototype.getMinSuggestedDuration = rs.prototype.getMinSuggestedDuration;
        rs.prototype.getDuration = rs.prototype.getDuration;
        rs.prototype.isUsingAnotherMediaElement = rs.prototype.isUsingAnotherMediaElement;
        rs.prototype.hasCustomClick = rs.prototype.hasCustomClick;
        rs.prototype.isClientRendering = rs.prototype.isClientRendering;
        rs.prototype.needsSkipUI = rs.prototype.needsSkipUI;
        function ss() {}
        function ts(a, b) {
            var c = [];
            a = u(Rd(a, "Ad"));
            for(var d = a.next(); !d.done; d = a.next())if (d = Vd(d.value, "InLine")) {
                if (d = Vd(d, "Creatives")) {
                    d = u(Rd(d, "Creative"));
                    for(var e = d.next(); !e.done; e = d.next()){
                        e = e.value;
                        var f = Vd(e, "Linear");
                        f && us(c, b, f);
                        if (e = Vd(e, "NonLinearAds")) {
                            e = Rd(e, "NonLinear");
                            e = u(e);
                            for(var g = e.next(); !g.done; g = e.next())a: {
                                f = c;
                                var h = b, k = g.value, l = Vd(k, "StaticResource");
                                if (l) g = l.attributes.creativeType;
                                else {
                                    l = Vd(k, "HTMLResource");
                                    if (!l) break a;
                                    g = "text/html";
                                }
                                if (l = Td(l)) {
                                    g === "text/html" && (l = "data:text/html;charset=UTF-8," + encodeURIComponent(l));
                                    var m = Zd(k, "width", ee) || Zd(k, "expandedWidth", ee), n = Zd(k, "height", ee) || Zd(k, "expandedHeight", ee);
                                    if (m || n) {
                                        var q = null, r = Vd(k, "NonLinearClickThrough");
                                        r && (r = Td(r)) && (q = r);
                                        r = null;
                                        (k = k.attributes.minSuggestedDuration) && (r = Dd(k));
                                        k = 0;
                                        h != null && (k = h);
                                        f.push({
                                            id: null,
                                            groupId: null,
                                            startTime: k,
                                            endTime: null,
                                            uri: l,
                                            mimeType: g,
                                            isSkippable: !1,
                                            skipOffset: null,
                                            skipFor: null,
                                            canJump: !1,
                                            resumeOffset: 0,
                                            playoutLimit: r,
                                            once: !0,
                                            pre: h == null,
                                            post: h == Infinity,
                                            timelineRange: !1,
                                            loop: !1,
                                            overlay: {
                                                viewport: {
                                                    x: 0,
                                                    y: 0
                                                },
                                                topLeft: {
                                                    x: 0,
                                                    y: 0
                                                },
                                                size: {
                                                    x: m || 0,
                                                    y: n || 0
                                                }
                                            },
                                            displayOnBackground: !1,
                                            currentVideo: null,
                                            background: null,
                                            clickThroughUrl: q
                                        });
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return c;
        }
        function us(a, b, c) {
            var d = 0;
            b != null && (d = b);
            var e = null;
            c.attributes.skipoffset && (e = Dd(c.attributes.skipoffset), isNaN(e) && (e = null));
            var f = Vd(c, "MediaFiles");
            if (f) {
                var g = null;
                (c = Vd(c, "VideoClicks")) && (c = Vd(c, "ClickThrough")) && (c = Td(c)) && (g = c);
                f = c = Rd(f, "MediaFile");
                c = c.filter(function(k) {
                    return k.attributes.delivery == "streaming";
                });
                c.length && (f = c);
                f = f.sort(function(k, l) {
                    return (parseInt(l.attributes.height, 10) || 0) - (parseInt(k.attributes.height, 10) || 0);
                });
                f = u(f);
                for(c = f.next(); !c.done; c = f.next())if (c = c.value, !c.attributes.apiFramework) {
                    var h = Td(c);
                    if (h) {
                        a.push({
                            id: null,
                            groupId: null,
                            startTime: d,
                            endTime: null,
                            uri: h,
                            mimeType: c.attributes.type || null,
                            isSkippable: e != null,
                            skipOffset: e,
                            skipFor: null,
                            canJump: !1,
                            resumeOffset: 0,
                            playoutLimit: null,
                            once: !0,
                            pre: b == null,
                            post: b == Infinity,
                            timelineRange: !1,
                            loop: !1,
                            overlay: null,
                            displayOnBackground: !1,
                            currentVideo: null,
                            background: null,
                            clickThroughUrl: g
                        });
                        break;
                    }
                }
            }
        }
        function vs(a) {
            var b = [];
            a = u(Rd(a, "vmap:AdBreak"));
            for(var c = a.next(); !c.done; c = a.next()){
                var d = c.value, e = d.attributes.timeOffset;
                e && (c = null, e == "start" ? c = null : e == "end" ? c = Infinity : c = Dd(e), (d = Vd(d, "vmap:AdSource")) && (d = Vd(d, "vmap:AdTagURI")) && (d = Sd(d)) && b.push({
                    time: c,
                    uri: d
                }));
            }
            return b;
        }
        S("shaka.ads.Utils", ss);
        ss.ADS_LOADED = "ads-loaded";
        ss.AD_STARTED = "ad-started";
        ss.AD_FIRST_QUARTILE = "ad-first-quartile";
        ss.AD_MIDPOINT = "ad-midpoint";
        ss.AD_THIRD_QUARTILE = "ad-third-quartile";
        ss.AD_COMPLETE = "ad-complete";
        ss.AD_STOPPED = "ad-stopped";
        ss.AD_SKIPPED = "ad-skipped";
        ss.AD_VOLUME_CHANGED = "ad-volume-changed";
        ss.AD_MUTED = "ad-muted";
        ss.AD_PAUSED = "ad-paused";
        ss.AD_RESUMED = "ad-resumed";
        ss.AD_SKIP_STATE_CHANGED = "ad-skip-state-changed";
        ss.CUEPOINTS_CHANGED = "ad-cue-points-changed";
        ss.IMA_AD_MANAGER_LOADED = "ima-ad-manager-loaded";
        ss.IMA_STREAM_MANAGER_LOADED = "ima-stream-manager-loaded";
        ss.AD_CLICKED = "ad-clicked";
        ss.AD_PROGRESS = "ad-progress";
        ss.AD_BUFFERING = "ad-buffering";
        ss.AD_IMPRESSION = "ad-impression";
        ss.AD_DURATION_CHANGED = "ad-duration-changed";
        ss.AD_CLOSED = "ad-closed";
        ss.AD_LOADED = "ad-loaded";
        ss.ALL_ADS_COMPLETED = "all-ads-completed";
        ss.AD_LINEAR_CHANGED = "ad-linear-changed";
        ss.AD_METADATA = "ad-metadata";
        ss.AD_RECOVERABLE_ERROR = "ad-recoverable-error";
        ss.AD_ERROR = "ad-error";
        ss.AD_BREAK_READY = "ad-break-ready";
        ss.AD_INTERACTION = "ad-interaction";
        ss.AD_CONTENT_PAUSE_REQUESTED = "ad-content-pause-requested";
        ss.AD_CONTENT_RESUME_REQUESTED = "ad-content-resume-requested";
        ss.AD_CONTENT_ATTACH_REQUESTED = "ad-content-attach-requested";
        function ws(a, b, c, d, e) {
            var f = this;
            this.A = a;
            this.i = b;
            this.G = !1;
            this.C = this.u = null;
            this.H = NaN;
            this.l = e;
            this.j = null;
            this.h = new Tc;
            google.ima.settings.setLocale(c);
            google.ima.settings.setDisableCustomPlaybackForIOS10Plus(!0);
            this.F = new google.ima.AdDisplayContainer(this.A, this.i);
            this.F.initialize();
            this.m = new google.ima.AdsLoader(this.F);
            this.m.getSettings().setPlayerType("shaka-player");
            this.m.getSettings().setPlayerVersion("v4.16.0");
            this.g = null;
            this.D = d || new google.ima.AdsRenderingSettings;
            this.h.o(this.m, google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, function(g) {
                xs(f, g);
            });
            this.h.o(this.m, google.ima.AdErrorEvent.Type.AD_ERROR, function(g) {
                ys(f, g);
            });
            this.h.o(this.i, "ended", function() {
                f.m.contentComplete();
            });
            this.h.ua(this.i, "play", function() {
                f.G = !0;
            });
        }
        ws.prototype.configure = function(a) {
            this.u = a;
        };
        ws.prototype.stop = function() {
            this.g && this.g.stop();
            this.A && Pj(this.A);
        };
        ws.prototype.release = function() {
            this.stop();
            this.C && this.C.disconnect();
            this.h && this.h.release();
            this.g && this.g.destroy();
            this.m.destroy();
            this.F.destroy();
        };
        function ys(a, b) {
            b.getError();
            b = (new Map).set("originalEvent", b);
            a.l(new T("ad-error", b));
            zs(a, null);
            a.l(new T("ad-cue-points-changed", (new Map).set("cuepoints", [])));
        }
        function xs(a, b) {
            a.l(new T("ads-loaded", (new Map).set("loadTime", Date.now() / 1E3 - a.H)));
            if (a.u.customPlayheadTracker) {
                var c = {
                    currentTime: a.i.currentTime
                };
                a.g = b.getAdsManager(c, a.D);
                a.i.muted ? a.g.setVolume(0) : a.g.setVolume(a.i.volume);
                a.h.o(a.i, "timeupdate", function() {
                    a.i.duration && (c.currentTime = a.i.currentTime);
                });
                a.h.o(a.i, "volumechange", function() {
                    a.j && (a.j.setVolume(a.i.volume), a.i.muted && a.j.setMuted(!0));
                });
            } else a.g = b.getAdsManager(a.i, a.D);
            a.l(new T("ima-ad-manager-loaded", (new Map).set("imaAdManager", a.g)));
            var d = a.g.getCuePoints();
            if (d.length) {
                b = [];
                d = u(d);
                for(var e = d.next(); !e.done; e = d.next())b.push({
                    start: e.value,
                    end: null
                });
                a.l(new T("ad-cue-points-changed", (new Map).set("cuepoints", b)));
            }
            As(a);
            try {
                a.g.init(a.i.offsetWidth, a.i.offsetHeight), a.h.o(a.i, "loadeddata", function() {
                    a.g.resize(a.i.offsetWidth, a.i.offsetHeight);
                }), "ResizeObserver" in window1 ? (a.C = new ResizeObserver(function() {
                    a.g.resize(a.i.offsetWidth, a.i.offsetHeight);
                }), a.C.observe(a.i)) : a.h.o(document, "fullscreenchange", function() {
                    a.g.resize(a.i.offsetWidth, a.i.offsetHeight);
                }), a.G || a.u.skipPlayDetection ? a.g.start() : a.h.ua(a.i, "play", function() {
                    a.G = !0;
                    a.g.start();
                });
            } catch (f) {
                zs(a, null);
            }
        }
        function As(a) {
            function b(c, d) {
                c = (new Map).set("originalEvent", c);
                a.l(new T(d, c));
            }
            a.h.o(a.g, google.ima.AdErrorEvent.Type.AD_ERROR, function(c) {
                ys(a, c);
            });
            a.h.o(a.g, google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED, function(c) {
                Bs(a, c);
            });
            a.h.o(a.g, google.ima.AdEvent.Type.STARTED, function(c) {
                Bs(a, c);
            });
            a.h.o(a.g, google.ima.AdEvent.Type.FIRST_QUARTILE, function(c) {
                b(c, "ad-first-quartile");
            });
            a.h.o(a.g, google.ima.AdEvent.Type.MIDPOINT, function(c) {
                b(c, "ad-midpoint");
            });
            a.h.o(a.g, google.ima.AdEvent.Type.THIRD_QUARTILE, function(c) {
                b(c, "ad-third-quartile");
            });
            a.h.o(a.g, google.ima.AdEvent.Type.COMPLETE, function(c) {
                b(c, "ad-complete");
            });
            a.h.o(a.g, google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED, function(c) {
                zs(a, c);
            });
            a.h.o(a.g, google.ima.AdEvent.Type.ALL_ADS_COMPLETED, function(c) {
                zs(a, c);
            });
            a.h.o(a.g, google.ima.AdEvent.Type.SKIPPED, function(c) {
                b(c, "ad-skipped");
            });
            a.h.o(a.g, google.ima.AdEvent.Type.VOLUME_CHANGED, function(c) {
                b(c, "ad-volume-changed");
            });
            a.h.o(a.g, google.ima.AdEvent.Type.VOLUME_MUTED, function(c) {
                b(c, "ad-muted");
            });
            a.h.o(a.g, google.ima.AdEvent.Type.PAUSED, function(c) {
                a.j && (a.j.i = !0, b(c, "ad-paused"));
            });
            a.h.o(a.g, google.ima.AdEvent.Type.RESUMED, function(c) {
                a.j && (a.j.i = !1, b(c, "ad-resumed"));
            });
            a.h.o(a.g, google.ima.AdEvent.Type.SKIPPABLE_STATE_CHANGED, function(c) {
                a.j && b(c, "ad-skip-state-changed");
            });
            a.h.o(a.g, google.ima.AdEvent.Type.CLICK, function(c) {
                b(c, "ad-clicked");
            });
            a.h.o(a.g, google.ima.AdEvent.Type.AD_PROGRESS, function(c) {
                b(c, "ad-progress");
            });
            a.h.o(a.g, google.ima.AdEvent.Type.AD_BUFFERING, function(c) {
                b(c, "ad-buffering");
            });
            a.h.o(a.g, google.ima.AdEvent.Type.IMPRESSION, function(c) {
                b(c, "ad-impression");
            });
            a.h.o(a.g, google.ima.AdEvent.Type.DURATION_CHANGE, function(c) {
                b(c, "ad-duration-changed");
            });
            a.h.o(a.g, google.ima.AdEvent.Type.USER_CLOSE, function(c) {
                b(c, "ad-closed");
            });
            a.h.o(a.g, google.ima.AdEvent.Type.LOADED, function(c) {
                b(c, "ad-loaded");
            });
            a.h.o(a.g, google.ima.AdEvent.Type.ALL_ADS_COMPLETED, function(c) {
                b(c, "all-ads-completed");
            });
            a.h.o(a.g, google.ima.AdEvent.Type.LINEAR_CHANGED, function(c) {
                b(c, "ad-linear-changed");
            });
            a.h.o(a.g, google.ima.AdEvent.Type.AD_METADATA, function(c) {
                b(c, "ad-metadata");
            });
            a.h.o(a.g, google.ima.AdEvent.Type.LOG, function(c) {
                b(c, "ad-recoverable-error");
            });
            a.h.o(a.g, google.ima.AdEvent.Type.AD_BREAK_READY, function(c) {
                b(c, "ad-break-ready");
            });
            a.h.o(a.g, google.ima.AdEvent.Type.INTERACTION, function(c) {
                b(c, "ad-interaction");
            });
        }
        function Bs(a, b) {
            var c = b.getAd();
            c ? (a.j = new rs(c, a.g, a.i), b.type != google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED || a.u.supportsMultipleMediaElements || a.l(new T("ad-content-pause-requested")), b = (new Map).set("ad", a.j).set("sdkAdObject", c).set("originalEvent", b), a.l(new T("ad-started", b)), a.j.isLinear() && (a.A.setAttribute("ad-active", "true"), a.u.customPlayheadTracker || a.i.pause(), a.i.muted ? (b = a.j, b.j = a.i.volume, b.h.setVolume(0)) : a.j.setVolume(a.i.volume))) : ab("The IMA SDK fired a " + b.type + " event with no associated ad. Unable to play ad!");
        }
        function zs(a, b) {
            b && b.type == google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED && !a.u.supportsMultipleMediaElements && a.l(new T("ad-content-resume-requested"));
            a.l(new T("ad-stopped", (new Map).set("originalEvent", b)));
            a.j && a.j.isLinear() && (a.A.removeAttribute("ad-active"), a.u.customPlayheadTracker || a.i.ended || a.i.play());
        }
        function Cs(a, b, c, d, e, f) {
            this.g = a;
            this.h = b;
            this.j = (this.i = b.isSkippable) ? b.skipOffset || 0 : b.skipOffset;
            this.l = b.skipFor;
            this.C = c;
            this.u = d;
            this.m = e;
            this.A = f;
            this.D = b.overlay;
        }
        p = Cs.prototype;
        p.needsSkipUI = function() {
            return !0;
        };
        p.isClientRendering = function() {
            return !0;
        };
        p.hasCustomClick = function() {
            return this.h.clickThroughUrl != null;
        };
        p.isUsingAnotherMediaElement = function() {
            return this.A;
        };
        p.getDuration = function() {
            var a = this.g.duration;
            return isNaN(a) ? -1 : a;
        };
        p.getMinSuggestedDuration = function() {
            return this.getDuration();
        };
        p.getRemainingTime = function() {
            var a = this.g.duration;
            return isNaN(a) ? -1 : a - this.g.currentTime;
        };
        p.isPaused = function() {
            return this.g.paused;
        };
        p.isSkippable = function() {
            return this.i && this.l != null ? this.getDuration() - this.getRemainingTime() < this.j + this.l : this.i;
        };
        p.getTimeUntilSkippable = function() {
            if (this.isSkippable()) {
                var a = this.getRemainingTime() + this.j - this.getDuration();
                return Math.max(a, 0);
            }
            return Math.max(this.getRemainingTime(), 0);
        };
        p.canSkipNow = function() {
            return this.i && this.getTimeUntilSkippable() == 0;
        };
        p.skip = function() {
            this.canSkipNow() && this.C();
        };
        p.pause = function() {
            return this.g.pause();
        };
        p.play = function() {
            return this.g.play();
        };
        p.getVolume = function() {
            return this.g.volume;
        };
        p.setVolume = function(a) {
            this.g.volume = a;
        };
        p.isMuted = function() {
            return this.g.muted;
        };
        p.isLinear = function() {
            return this.D == null;
        };
        p.resize = function() {};
        p.setMuted = function(a) {
            this.g.muted = a;
        };
        p.getSequenceLength = function() {
            return this.u;
        };
        p.getPositionInSequence = function() {
            return this.m;
        };
        p.getTitle = function() {
            return "";
        };
        p.getDescription = function() {
            return "";
        };
        p.getVastMediaBitrate = function() {
            return 0;
        };
        p.getVastMediaHeight = function() {
            return 0;
        };
        p.getVastMediaWidth = function() {
            return 0;
        };
        p.getVastAdId = function() {
            return "";
        };
        p.getAdId = function() {
            return this.h.id || "";
        };
        p.getCreativeAdId = function() {
            return "";
        };
        p.getAdvertiserName = function() {
            return "";
        };
        p.getMediaUrl = function() {
            return this.h.uri;
        };
        p.getTimeOffset = function() {
            return 0;
        };
        p.getPodIndex = function() {
            return 0;
        };
        p.release = function() {
            this.g = null;
        };
        S("shaka.ads.InterstitialAd", Cs);
        Cs.prototype.release = Cs.prototype.release;
        Cs.prototype.getPodIndex = Cs.prototype.getPodIndex;
        Cs.prototype.getTimeOffset = Cs.prototype.getTimeOffset;
        Cs.prototype.getMediaUrl = Cs.prototype.getMediaUrl;
        Cs.prototype.getAdvertiserName = Cs.prototype.getAdvertiserName;
        Cs.prototype.getCreativeAdId = Cs.prototype.getCreativeAdId;
        Cs.prototype.getAdId = Cs.prototype.getAdId;
        Cs.prototype.getVastAdId = Cs.prototype.getVastAdId;
        Cs.prototype.getVastMediaWidth = Cs.prototype.getVastMediaWidth;
        Cs.prototype.getVastMediaHeight = Cs.prototype.getVastMediaHeight;
        Cs.prototype.getVastMediaBitrate = Cs.prototype.getVastMediaBitrate;
        Cs.prototype.getDescription = Cs.prototype.getDescription;
        Cs.prototype.getTitle = Cs.prototype.getTitle;
        Cs.prototype.getPositionInSequence = Cs.prototype.getPositionInSequence;
        Cs.prototype.getSequenceLength = Cs.prototype.getSequenceLength;
        Cs.prototype.setMuted = Cs.prototype.setMuted;
        Cs.prototype.resize = Cs.prototype.resize;
        Cs.prototype.isLinear = Cs.prototype.isLinear;
        Cs.prototype.isMuted = Cs.prototype.isMuted;
        Cs.prototype.setVolume = Cs.prototype.setVolume;
        Cs.prototype.getVolume = Cs.prototype.getVolume;
        Cs.prototype.play = Cs.prototype.play;
        Cs.prototype.pause = Cs.prototype.pause;
        Cs.prototype.skip = Cs.prototype.skip;
        Cs.prototype.canSkipNow = Cs.prototype.canSkipNow;
        Cs.prototype.getTimeUntilSkippable = Cs.prototype.getTimeUntilSkippable;
        Cs.prototype.isSkippable = Cs.prototype.isSkippable;
        Cs.prototype.isPaused = Cs.prototype.isPaused;
        Cs.prototype.getRemainingTime = Cs.prototype.getRemainingTime;
        Cs.prototype.getMinSuggestedDuration = Cs.prototype.getMinSuggestedDuration;
        Cs.prototype.getDuration = Cs.prototype.getDuration;
        Cs.prototype.isUsingAnotherMediaElement = Cs.prototype.isUsingAnotherMediaElement;
        Cs.prototype.hasCustomClick = Cs.prototype.hasCustomClick;
        Cs.prototype.isClientRendering = Cs.prototype.isClientRendering;
        Cs.prototype.needsSkipUI = Cs.prototype.needsSkipUI;
        function Ds(a, b, c) {
            this.g = a;
            this.j = b;
            this.h = c;
            this.i = a.overlay == null;
        }
        p = Ds.prototype;
        p.needsSkipUI = function() {
            return !0;
        };
        p.isClientRendering = function() {
            return !0;
        };
        p.hasCustomClick = function() {
            return this.g.clickThroughUrl != null;
        };
        p.isUsingAnotherMediaElement = function() {
            return !1;
        };
        p.getDuration = function() {
            return -1;
        };
        p.getMinSuggestedDuration = function() {
            return this.getDuration();
        };
        p.getRemainingTime = function() {
            return -1;
        };
        p.isPaused = function() {
            return !1;
        };
        p.isSkippable = function() {
            return !1;
        };
        p.getTimeUntilSkippable = function() {
            return 0;
        };
        p.canSkipNow = function() {
            return !1;
        };
        p.skip = function() {};
        p.pause = function() {};
        p.play = function() {};
        p.getVolume = function() {
            return 1;
        };
        p.setVolume = function() {};
        p.isMuted = function() {
            return !1;
        };
        p.isLinear = function() {
            return this.i;
        };
        p.resize = function() {};
        p.setMuted = function() {};
        p.getSequenceLength = function() {
            return this.j;
        };
        p.getPositionInSequence = function() {
            return this.h;
        };
        p.getTitle = function() {
            return "";
        };
        p.getDescription = function() {
            return "";
        };
        p.getVastMediaBitrate = function() {
            return 0;
        };
        p.getVastMediaHeight = function() {
            return 0;
        };
        p.getVastMediaWidth = function() {
            return 0;
        };
        p.getVastAdId = function() {
            return "";
        };
        p.getAdId = function() {
            return this.g.id || "";
        };
        p.getCreativeAdId = function() {
            return "";
        };
        p.getAdvertiserName = function() {
            return "";
        };
        p.getMediaUrl = function() {
            return this.g.uri;
        };
        p.getTimeOffset = function() {
            return 0;
        };
        p.getPodIndex = function() {
            return 0;
        };
        p.release = function() {};
        S("shaka.ads.InterstitialStaticAd", Ds);
        Ds.prototype.release = Ds.prototype.release;
        Ds.prototype.getPodIndex = Ds.prototype.getPodIndex;
        Ds.prototype.getTimeOffset = Ds.prototype.getTimeOffset;
        Ds.prototype.getMediaUrl = Ds.prototype.getMediaUrl;
        Ds.prototype.getAdvertiserName = Ds.prototype.getAdvertiserName;
        Ds.prototype.getCreativeAdId = Ds.prototype.getCreativeAdId;
        Ds.prototype.getAdId = Ds.prototype.getAdId;
        Ds.prototype.getVastAdId = Ds.prototype.getVastAdId;
        Ds.prototype.getVastMediaWidth = Ds.prototype.getVastMediaWidth;
        Ds.prototype.getVastMediaHeight = Ds.prototype.getVastMediaHeight;
        Ds.prototype.getVastMediaBitrate = Ds.prototype.getVastMediaBitrate;
        Ds.prototype.getDescription = Ds.prototype.getDescription;
        Ds.prototype.getTitle = Ds.prototype.getTitle;
        Ds.prototype.getPositionInSequence = Ds.prototype.getPositionInSequence;
        Ds.prototype.getSequenceLength = Ds.prototype.getSequenceLength;
        Ds.prototype.setMuted = Ds.prototype.setMuted;
        Ds.prototype.resize = Ds.prototype.resize;
        Ds.prototype.isLinear = Ds.prototype.isLinear;
        Ds.prototype.isMuted = Ds.prototype.isMuted;
        Ds.prototype.setVolume = Ds.prototype.setVolume;
        Ds.prototype.getVolume = Ds.prototype.getVolume;
        Ds.prototype.play = Ds.prototype.play;
        Ds.prototype.pause = Ds.prototype.pause;
        Ds.prototype.skip = Ds.prototype.skip;
        Ds.prototype.canSkipNow = Ds.prototype.canSkipNow;
        Ds.prototype.getTimeUntilSkippable = Ds.prototype.getTimeUntilSkippable;
        Ds.prototype.isSkippable = Ds.prototype.isSkippable;
        Ds.prototype.isPaused = Ds.prototype.isPaused;
        Ds.prototype.getRemainingTime = Ds.prototype.getRemainingTime;
        Ds.prototype.getMinSuggestedDuration = Ds.prototype.getMinSuggestedDuration;
        Ds.prototype.getDuration = Ds.prototype.getDuration;
        Ds.prototype.isUsingAnotherMediaElement = Ds.prototype.isUsingAnotherMediaElement;
        Ds.prototype.hasCustomClick = Ds.prototype.hasCustomClick;
        Ds.prototype.isClientRendering = Ds.prototype.isClientRendering;
        Ds.prototype.needsSkipUI = Ds.prototype.needsSkipUI;
        function Es(a, b, c, d) {
            var e = this;
            this.M = null;
            this.u = a;
            this.F = b;
            this.g = c;
            this.H = null;
            this.D = !0;
            this.h = this.g;
            this.i = d;
            this.S = new Set;
            this.I = new Set;
            this.G = new Map;
            this.L = new Map;
            this.j = new X;
            Fs(this);
            this.J = new Tc;
            this.l = new Tc;
            this.K = !1;
            this.Y = this.A = this.C = this.m = null;
            this.aa = !1;
            this.P = -1;
            this.X = function() {
                if (!e.K && e.m && !e.F.Da()) {
                    e.m = e.g.currentTime;
                    var f = Gs(e);
                    f && Hs(e, f, 1, 1, Date.now());
                }
            };
            this.V = function() {
                if (!(e.K || e.m || e.F.Da())) {
                    e.m = e.g.currentTime;
                    var f = Gs(e, !0);
                    f || (f = Gs(e));
                    f && Hs(e, f, 1, 1, Date.now());
                }
            };
            this.ea = function() {
                if (!e.K && e.m && !e.F.Da()) {
                    var f = e.g.currentTime;
                    e.C && !e.C.pre && !e.C.post && f < (e.C.endTime || e.C.startTime) && (e.C = null);
                }
            };
            this.R = new Bf(this.X);
            this.O = new Bf(function() {
                var f, g, h, k, l, m, n, q, r, t, w;
                return Q(function(v) {
                    switch(v.g){
                        case 1:
                            if (!e.I.size || e.m == null) {
                                v.B(0);
                                break;
                            }
                            f = e.F.l;
                            if (f == Tq || f == Jq) return v.return();
                            g = !1;
                            h = Array.from(e.I);
                            k = e.F.za();
                            l = u(h);
                            m = l.next();
                        case 3:
                            if (m.done) {
                                v.B(5);
                                break;
                            }
                            n = m.value;
                            if (n == e.C) {
                                v.B(4);
                                break;
                            }
                            q = n.endTime || n.startTime;
                            if (!(k.start - q >= 1)) {
                                r = n.startTime - e.m;
                                r > 0 && r <= 10 && (!e.G.has(n) && Is(n) && e.G.set(n, e.j.preload(n.uri, null, n.mimeType || void 0)), Js(e, n));
                                v.B(4);
                                break;
                            }
                            if (!e.G.has(n)) {
                                v.B(7);
                                break;
                            }
                            return F(v, e.G.get(n), 8);
                        case 8:
                            (t = v.h) && t.destroy(), e.G.delete(n);
                        case 7:
                            Ks(e, n), w = JSON.stringify(n), e.S.has(w) && e.S.delete(w), e.I.delete(n), Ls(e), n.overlay || (g = !0);
                        case 4:
                            m = l.next();
                            v.B(3);
                            break;
                        case 5:
                            g && Ms(e), H(v);
                    }
                });
            });
            this.configure(this.F.getConfiguration().ads);
        }
        p = Es.prototype;
        p.configure = function(a) {
            this.M = a;
            Ns(this);
        };
        function Os(a) {
            if (!a.aa && a.I.size) {
                a.J.o(a.g, "playing", a.V);
                a.J.o(a.g, "timeupdate", a.V);
                a.J.o(a.g, "seeked", a.ea);
                a.J.o(a.g, "ended", a.X);
                if ("requestVideoFrameCallback" in a.g && !Ps()) {
                    var b = a.g, c = function() {
                        a.P != -1 && (a.X(), a.P != -1 && (a.P = b.requestVideoFrameCallback(c)));
                    };
                    a.P = b.requestVideoFrameCallback(c);
                } else a.R.wa(.025);
                a.O && a.O.wa(1);
                a.aa = !0;
            }
        }
        function Ls(a) {
            a.aa && !a.I.size && (a.J.Ea(a.g, "playing", a.V), a.J.Ea(a.g, "timeupdate", a.V), a.J.Ea(a.g, "seeked", a.ea), a.J.Ea(a.g, "ended", a.X), a.P != -1 && (a.g.cancelVideoFrameCallback(a.P), a.P = -1), a.R && a.R.stop(), a.O && a.O.stop(), a.aa = !1);
        }
        function Ns(a) {
            if (a.u && a.M && !a.K) {
                var b = a.M.supportsMultipleMediaElements, c = a.g;
                c.webkitPresentationMode && c.webkitPresentationMode !== "inline" ? b = !1 : c.webkitDisplayingFullscreen && (b = !1);
                a.D == b && (a.D = !b, a.D ? (a.h = a.g, a.H && (a.H.parentElement && a.u.removeChild(a.H), a.H = null)) : (a.H || (b = document.createElement(a.g.tagName), b.autoplay = !0, b.style.position = "absolute", b.style.top = "0", b.style.left = "0", b.style.width = "100%", b.style.height = "100%", b.style.display = "none", b.setAttribute("playsinline", ""), a.H = b), a.h = a.H));
            } else a.D = !0;
        }
        p.stop = function() {
            this.l && this.l.Sa();
            this.S.clear();
            this.I.clear();
            this.j.Ug();
            if (this.G.size) {
                var a = Array.from(this.G.values());
                a = u(a);
                for(var b = a.next(); !b.done; b = a.next())(b = b.value) && b.then(function(c) {
                    c && c.destroy();
                });
            }
            this.G.clear();
            if (this.L.size) for(a = Array.from(this.L.keys()), a = u(a), b = a.next(); !b.done; b = a.next())Ks(this, b.value);
            this.L.clear();
            this.j.detach();
            this.K = !1;
            this.C = this.m = null;
            this.D = !0;
            this.h = this.g;
            this.H = null;
            Qs(this);
            Ls(this);
            this.u && Pj(this.u);
            this.A && (this.A.stop(), this.A = null);
        };
        p.release = function() {
            this.stop();
            this.J && this.J.release();
            this.l && this.l.release();
            this.R && (this.R.stop(), this.R = null);
            this.O && (this.O.stop(), this.O = null);
            this.j.destroy();
        };
        p.Wb = function() {
            return this.j;
        };
        function Rs(a, b) {
            var c;
            Q(function(d) {
                if (d.g == 1) return Fs(a), c = [], b && b.values.find(function(e) {
                    return e.key == "X-OVERLAY-ID";
                }) ? (c = Ss(b), d.B(2)) : F(d, Ts(a, b), 3);
                d.g != 2 && (c = d.h);
                c.length ? Us(a, c) : ab("Unsupported HLS interstitial", b);
                H(d);
            });
        }
        function Vs(a, b) {
            var c = Vd(b.eventNode, "OverlayEvent"), d = c.attributes.uri, e = c.attributes.mimeType, f = c.attributes.loop == "true", g = Zd(c, "z", ee);
            if (d && g != 0) {
                var h = null, k = Vd(c, "Background");
                if (k) {
                    var l = k.attributes.uri;
                    l ? h = "center / contain no-repeat url('" + l + "')" : h = Td(k);
                }
                k = 1920;
                l = 1080;
                var m = Vd(c, "Viewport");
                if (m) {
                    k = Zd(m, "x", ee);
                    if (k == null) return;
                    l = Zd(m, "y", ee);
                    if (l == null) return;
                }
                var n = {
                    viewport: {
                        x: k,
                        y: l
                    },
                    topLeft: {
                        x: 0,
                        y: 0
                    },
                    size: {
                        x: k,
                        y: l
                    }
                }, q = Vd(c, "Overlay");
                if (m && q) {
                    var r = Vd(q, "TopLeft"), t = Vd(q, "Size");
                    if (r && t) {
                        q = Zd(r, "x", ee);
                        if (q == null) return;
                        r = Zd(r, "y", ee);
                        if (r == null) return;
                        var w = Zd(t, "x", ee);
                        if (w == null) return;
                        t = Zd(t, "y", ee);
                        if (t == null) return;
                        n.topLeft.x = q;
                        n.topLeft.y = r;
                        n.size.x = w;
                        n.size.y = t;
                    }
                }
                q = null;
                c = Vd(c, "Squeeze");
                if (m && c && (t = Vd(c, "TopLeft"), c = Vd(c, "Size"), t && c)) {
                    m = Zd(t, "x", ee);
                    if (m == null) return;
                    q = Zd(t, "y", ee);
                    if (q == null) return;
                    t = Zd(c, "x", ee);
                    if (t == null) return;
                    c = Zd(c, "y", ee);
                    if (c == null) return;
                    q = {
                        viewport: {
                            x: k,
                            y: l
                        },
                        topLeft: {
                            x: m,
                            y: q
                        },
                        size: {
                            x: t,
                            y: c
                        }
                    };
                }
                Us(a, [
                    {
                        id: b.id,
                        groupId: null,
                        startTime: b.startTime,
                        endTime: b.endTime,
                        uri: d,
                        mimeType: e,
                        isSkippable: !1,
                        skipOffset: null,
                        skipFor: null,
                        canJump: !0,
                        resumeOffset: null,
                        playoutLimit: null,
                        once: !1,
                        pre: !1,
                        post: !1,
                        timelineRange: !0,
                        loop: f,
                        overlay: n,
                        displayOnBackground: g == -1,
                        currentVideo: q,
                        background: h,
                        clickThroughUrl: null
                    }
                ]);
            }
        }
        p.addAdUrlInterstitial = function(a) {
            var b = this, c, d, e, f, g, h, k, l, m;
            return Q(function(n) {
                if (n.g == 1) return c = {
                    type: 12
                }, F(n, Ws(b, a, c), 2);
                if (n.g != 3) {
                    d = n.h;
                    e = Jd(d, "VAST,vmap:VMAP");
                    if (!e) throw new U(2, 10, 10007);
                    f = [];
                    if (e.tagName == "VAST") return f = ts(e, b.m), n.B(3);
                    if (e.tagName != "vmap:VMAP") return n.B(3);
                    g = function(q) {
                        var r, t;
                        return Q(function(w) {
                            if (w.g == 1) return F(w, Ws(b, q.uri, c), 2);
                            r = w.h;
                            t = Jd(r, "VAST");
                            if (!t) throw new U(2, 10, 10007);
                            f.push.apply(f, x(ts(t, q.time)));
                            H(w);
                        });
                    };
                    h = [];
                    k = u(vs(e));
                    for(l = k.next(); !l.done; l = k.next())m = l.value, h.push(g(m));
                    return h.length ? F(n, Promise.all(h), 3) : n.B(3);
                }
                Us(b, f);
                H(n);
            });
        };
        function Us(a, b) {
            var c, d, e, f, g, h, k, l;
            Q(function(m) {
                switch(m.g){
                    case 1:
                        c = !1, d = u(b), e = d.next();
                    case 2:
                        if (e.done) {
                            m.B(4);
                            break;
                        }
                        f = e.value;
                        if (!f.uri) {
                            ab("Missing URL in interstitial", f);
                            m.B(3);
                            break;
                        }
                        if (f.mimeType) {
                            m.B(5);
                            break;
                        }
                        ra(m, 6);
                        g = a.j.Vb();
                        return F(m, Jo(f.uri, g, a.F.getConfiguration().streaming.retryParameters), 8);
                    case 8:
                        f.mimeType = m.h;
                        ta(m, 5);
                        break;
                    case 6:
                        ua(m);
                    case 5:
                        h = f.id || JSON.stringify(f);
                        if (a.S.has(h)) {
                            m.B(3);
                            break;
                        }
                        f.loop && !f.overlay && ab("Loop is only supported in overlay interstitials", f);
                        f.overlay || (c = !0);
                        a.S.add(h);
                        a.I.add(f);
                        k = !1;
                        f.pre && a.m == null ? k = !0 : f.startTime != 0 || f.canJump ? a.m != null && (l = f.startTime - a.m, l > 0 && l <= 10 && (k = !0)) : k = !0;
                        k && (!a.G.has(f) && Is(f) && a.G.set(f, a.j.preload(f.uri, null, f.mimeType || void 0)), Js(a, f));
                    case 3:
                        e = d.next();
                        m.B(2);
                        break;
                    case 4:
                        c && Ms(a), Os(a), H(m);
                }
            });
        }
        function Gs(a, b, c) {
            b = b === void 0 ? !1 : b;
            c = c === void 0 ? null : c;
            var d = 0, e = null;
            if (a.I.size && a.m != null) {
                var f = a.g.ended, g = Array.from(a.I).sort(function(n, q) {
                    return q.startTime - n.startTime;
                }), h = g;
                h = b ? g.filter(function(n) {
                    return n.pre;
                }) : f ? g.filter(function(n) {
                    return n.post;
                }) : g.filter(function(n) {
                    return !n.pre && !n.post;
                });
                g = u(h);
                for(h = g.next(); !h.done; h = g.next()){
                    h = h.value;
                    var k = !1;
                    if (b) k = h.pre;
                    else if (f) k = h.post;
                    else if (!h.pre && !h.post) {
                        var l = a.m - Math.round(h.startTime * 1E3) / 1E3, m = 1;
                        a.M.allowStartInMiddleOfInterstitial && h.endTime && h.endTime != Infinity && (m = h.endTime - h.startTime);
                        (l > 0 || l == 0 && a.m == 0) && (l <= m || !h.canJump) && (k = c == null && a.C && !a.C.pre && !a.C.post && a.C.startTime >= h.startTime ? !1 : !0);
                    }
                    k && (!a.C || h.startTime >= a.C.startTime) && (d == (c || 0) ? e = h : e && !h.canJump && Math.round(h.startTime * 1E3) / 1E3 - Math.round(e.startTime * 1E3) / 1E3 > .001 && (e = h, d = 0), d++);
                }
            }
            return e;
        }
        function Hs(a, b, c, d, e, f) {
            f = f === void 0 ? 0 : f;
            a.C = b;
            Ns(a);
            a.D || !a.u || a.h.parentElement || a.u.appendChild(a.h);
            d == 1 && c == 1 && (c = Array.from(a.I).filter(function(g) {
                return b.pre ? g.pre == b.pre : b.post ? g.post == b.post : Math.abs(g.startTime - b.startTime) < .001;
            }).length);
            b.once && (f++, a.I.delete(b), Ls(a), b.overlay || Ms(a));
            b.mimeType && (b.mimeType.startsWith("image/") || b.mimeType === "text/html") ? b.overlay ? Xs(a, b, c, d, f) : ab("Unsupported interstitial", b) : a.D && b.overlay ? ab("Unsupported interstitial", b) : Ys(a, b, c, d, e, f);
        }
        function Xs(a, b, c, d, e) {
            function f() {
                a.A && (a.A.stop(), a.A = null);
                a.u.removeChild(k);
                Qs(a, b);
                a.i(new T("ad-stopped"));
                a.l.Sa();
                var q = Gs(a, b.pre, d - e);
                q ? Hs(a, q, c, ++d, Date.now(), e) : a.K = !1;
            }
            a.K = !0;
            var g = b.overlay, h = b.mimeType == "text/html" ? "iframe" : "img", k = document.createElement(h);
            k.style.objectFit = "contain";
            k.style.position = "absolute";
            k.style.border = "none";
            Zs(a, b);
            a.i(new T("ad-started", (new Map).set("ad", new Ds(b, c, d))));
            h == "iframe" ? k.src = b.uri : (k.src = b.uri, k.onerror = function(q) {
                a.i(new T("ad-error", (new Map).set("originalEvent", q)));
                f();
            });
            var l = g.viewport, m = g.topLeft;
            g = g.size;
            l.x == 0 && l.y == 0 ? (k.width = b.overlay.size.x, k.height = b.overlay.size.y, k.style.bottom = "10%", k.style.left = "0", k.style.right = "0", k.style.width = "100%", b.overlay.size.y || h != "iframe" || (k.style.height = "auto")) : (k.style.height = g.y / l.y * 100 + "%", k.style.left = m.x / l.x * 100 + "%", k.style.top = m.y / l.y * 100 + "%", k.style.width = g.x / l.x * 100 + "%");
            a.u.appendChild(k);
            var n = Date.now();
            a.A && a.A.stop();
            a.A = new Bf(function() {
                b.playoutLimit && (Date.now() - n) / 1E3 > b.playoutLimit ? (a.i(new T("ad-complete")), f()) : b.endTime && a.g.currentTime > b.endTime ? (a.i(new T("ad-complete")), f()) : a.g.currentTime < b.startTime && (a.i(new T("ad-skipped")), f());
            });
            b.playoutLimit && !b.endTime ? a.A.$(b.playoutLimit) : b.endTime && a.A.wa(.025);
            a.l.o(a.g, "seeked", function() {
                var q = a.g.currentTime;
                if (q < b.startTime || b.endTime && q > b.endTime) a.A && a.A.stop(), a.i(new T("ad-skipped")), f();
            });
            b.clickThroughUrl && a.l.o(k, "click", function() {
                b.clickThroughUrl && window1.open(b.clickThroughUrl, "_blank");
            });
        }
        function Ys(a, b, c, d, e, f) {
            var g, h, k, l, m, n, q, r, t, w, v, z, y, A, C, E, D, B, G, I, J;
            Q(function(L) {
                switch(L.g){
                    case 1:
                        g = Date.now();
                        a.K = !0;
                        h = !1;
                        k = function() {
                            if (!a.D && !b.overlay && b.resumeOffset == null) {
                                if (b.timelineRange && b.endTime && b.endTime != Infinity) a.g.currentTime != b.endTime && (a.g.currentTime = b.endTime);
                                else {
                                    var K = Date.now();
                                    a.g.currentTime += (K - e) / 1E3;
                                    e = K;
                                }
                            }
                        };
                        l = function(K) {
                            var N, P;
                            return Q(function(O) {
                                if (O.g == 1) {
                                    k();
                                    N = Gs(a, b.pre, d - f);
                                    if (K && b.groupId) for(; N && N.groupId == b.groupId;)d++, N = Gs(a, b.pre, d - f);
                                    a.A && (!b.groupId || N && N.groupId != b.groupId) && (a.A.stop(), a.A = null);
                                    Qs(a, b);
                                    if (N && !N.overlay) return O.B(2);
                                    b.post && (a.m = null, a.C = null);
                                    return a.D ? F(O, a.j.detach(), 4) : F(O, a.j.tc(), 4);
                                }
                                O.g != 2 && (a.D && (P = b.resumeOffset, P == null && (P = b.timelineRange && b.endTime && b.endTime != Infinity ? b.endTime - (a.m || 0) : (Date.now() - e) / 1E3), a.i(new T("ad-content-resume-requested", (new Map).set("offset", P)))), a.i(new T("ad-stopped")), a.l.Sa(), a.K = !1, a.D ? Ms(a) : (a.h.style.display = "none", k(), a.g.ended || a.g.play()));
                                Ns(a);
                                N && (a.i(new T("ad-stopped")), a.l.Sa(), Hs(a, N, c, ++d, e, f));
                                H(O);
                            });
                        };
                        m = function(K) {
                            return Q(function(N) {
                                if (h) return N.return();
                                h = !0;
                                a.i(new T("ad-error", (new Map).set("originalEvent", K)));
                                return F(N, l(!1), 0);
                            });
                        };
                        n = function() {
                            return Q(function(K) {
                                if (K.g == 1) {
                                    if (h) return K.return();
                                    h = !0;
                                    return F(K, l(!1), 2);
                                }
                                a.i(new T("ad-complete"));
                                H(K);
                            });
                        };
                        a.Y = function() {
                            return Q(function(K) {
                                if (h) return K.return();
                                h = !0;
                                a.i(new T("ad-skipped"));
                                return F(K, l(!0), 0);
                            });
                        };
                        q = new Cs(a.h, b, a.Y, c, d, !a.D);
                        a.D || (q.setMuted(a.g.muted), q.setVolume(a.g.volume));
                        a.i(new T("ad-started", (new Map).set("ad", q)));
                        (r = q.canSkipNow()) && a.i(new T("ad-skip-state-changed"));
                        a.l.ua(a.j, "error", m);
                        a.l.o(a.h, "timeupdate", function() {
                            if (a.h.duration) {
                                var K = q.canSkipNow();
                                r != K && q.getRemainingTime() > 0 && q.getDuration() > 0 && a.i(new T("ad-skip-state-changed"));
                                r = K;
                            }
                        });
                        a.l.ua(a.j, "firstquartile", function() {
                            k();
                            a.i(new T("ad-first-quartile"));
                        });
                        a.l.ua(a.j, "midpoint", function() {
                            k();
                            a.i(new T("ad-midpoint"));
                        });
                        a.l.ua(a.j, "thirdquartile", function() {
                            k();
                            a.i(new T("ad-third-quartile"));
                        });
                        a.l.ua(a.j, "complete", n);
                        a.l.o(a.h, "play", function() {
                            a.i(new T("ad-resumed"));
                        });
                        a.l.o(a.h, "pause", function() {
                            var K = a.j.getConfiguration();
                            a.h.currentTime >= K.playRangeEnd ? n() : a.i(new T("ad-paused"));
                        });
                        a.l.o(a.h, "volumechange", function() {
                            a.h.muted ? a.i(new T("ad-muted")) : a.i(new T("ad-volume-changed"));
                        });
                        b.clickThroughUrl && (t = a.u || a.h, a.l.o(t, "click", function() {
                            b.clickThroughUrl && (q.isPaused() || q.pause(), window1.open(b.clickThroughUrl, "_blank"));
                        }));
                        if (!a.D || d != 1) {
                            L.B(2);
                            break;
                        }
                        a.i(new T("ad-content-pause-requested", (new Map).set("saveLivePosition", !0)));
                        w = new Lg;
                        v = function(K) {
                            return Q(function(N) {
                                if (N.g == 1) return K.state != "detach" ? N.B(0) : Ps() ? F(N, new Promise(function(P) {
                                    return new Bf(P).$(.1);
                                }), 3) : N.B(3);
                                w.resolve();
                                a.l.Ea(a.F, "onstatechange", v);
                                H(N);
                            });
                        };
                        a.l.o(a.F, "onstatechange", v);
                        return F(L, w, 2);
                    case 2:
                        return Zs(a, b), a.D || (a.h.style.display = "", b.overlay ? (a.h.loop = b.loop, z = b.overlay.viewport, y = b.overlay.topLeft, A = b.overlay.size, a.h.style.height = A.y / z.y * 100 + "%", a.h.style.left = y.x / z.x * 100 + "%", a.h.style.top = y.y / z.y * 100 + "%", a.h.style.width = A.x / z.x * 100 + "%") : (a.g.pause(), b.resumeOffset != null && b.resumeOffset != 0 && (a.g.currentTime += b.resumeOffset), a.h.loop = !1, a.h.style.height = "100%", a.h.style.left = "0", a.h.style.top = "0", a.h.style.width = "100%")), ra(L, 4), Fs(a), b.startTime && b.endTime && b.endTime != Infinity && b.startTime != b.endTime && (C = b.endTime - b.startTime, C > 0 && a.j.configure("playRangeEnd", C)), b.playoutLimit && !a.A && (a.A = new Bf(function() {
                            a.Y();
                        }).$(b.playoutLimit), a.j.configure("playRangeEnd", b.playoutLimit)), F(L, a.j.cc(a.h), 6);
                    case 6:
                        return E = null, a.M.allowStartInMiddleOfInterstitial && a.m != null && (D = a.m - b.startTime, Math.abs(D) > .25 && (E = D)), a.G.has(b) ? F(L, a.G.get(b), 10) : F(L, a.j.load(b.uri, E, b.mimeType || void 0), 8);
                    case 10:
                        return B = L.h, a.G.delete(b), B ? F(L, a.j.load(B), 8) : F(L, a.j.load(b.uri, E, b.mimeType || void 0), 8);
                    case 8:
                        a.h.play();
                        G = (Date.now() - g) / 1E3;
                        a.i(new T("ads-loaded", (new Map).set("loadTime", G)));
                        a.D && a.g.play();
                        b.overlay && (I = function() {
                            var K = a.g.currentTime - b.startTime;
                            Math.abs(K - a.h.currentTime) > .1 && (a.h.currentTime = K);
                        }, a.l.ua(a.h, "playing", I), a.l.o(a.g, "seeking", I), a.l.o(a.g, "seeked", function() {
                            var K = a.g.currentTime;
                            (K < b.startTime || b.endTime && K > b.endTime) && a.Y();
                        }));
                        ta(L, 0);
                        break;
                    case 4:
                        J = ua(L);
                        if (!a.K) return L.return();
                        m(J);
                        H(L);
                }
            });
        }
        function Zs(a, b) {
            b.displayOnBackground && (a.g.style.zIndex = "1");
            if (b.currentVideo != null) {
                var c = b.currentVideo;
                a.g.style.transformOrigin = "top left";
                var d = !0, e = [], f = c.topLeft.x / c.viewport.x * 100;
                f > 0 && f <= 100 && (e.push("translateX(" + f + "%)"), d = !1);
                f = c.topLeft.y / c.viewport.y * 100;
                f > 0 && f <= 100 && (e.push("translateY(" + f + "%)"), d = !1);
                f = c.size.x / c.viewport.x;
                f < 1 && e.push("scaleX(" + f + ")");
                c = c.size.y / c.viewport.y;
                f < 1 && e.push("scaleY(" + c + ")");
                e.length && (a.g.style.transform = e.join(" "));
                d && (a.g.style.transition = "transform 250ms");
            }
            a.u && (b.clickThroughUrl ? (a.u.setAttribute("ad-active", "true"), a.u.style.pointerEvents = "") : a.u.style.pointerEvents = "none", b.background && (a.u.style.background = b.background));
            a.H && (a.H.style.background = b.overlay ? "" : "rgb(0, 0, 0)");
        }
        function Qs(a, b) {
            if (!b || b.displayOnBackground) a.g.style.zIndex = "";
            b && b.currentVideo == null || (a.g.style.transformOrigin = "", a.g.style.transition = "", a.g.style.transform = "");
            a.u && (a.u.removeAttribute("ad-active"), a.u.style.pointerEvents = "", !b || b.background) && (a.u.style.background = "");
            a.H && (a.H.style.background = "");
        }
        function Ts(a, b) {
            var c, d, e, f, g, h, k, l, m, n, q, r, t, w, v, z, y, A, C, E, D, B, G, I, J, L, K, N, P, O, M, R, W, wa, Y, Ka, Na, La, Ea, za, Fa, Da;
            return Q(function(Aa) {
                switch(Aa.g){
                    case 1:
                        c = [];
                        if (!b) return Aa.return(c);
                        d = b.values.find(function(Ca) {
                            return Ca.key == "X-ASSET-URI";
                        });
                        e = b.values.find(function(Ca) {
                            return Ca.key == "X-ASSET-LIST";
                        });
                        if (!d && !e) return Aa.return(c);
                        f = null;
                        if (g = b.values.find(function(Ca) {
                            return Ca.key == "ID";
                        })) f = g.data;
                        h = f == null ? Math.floor(b.startTime * 10) / 10 : b.startTime;
                        (k = b.endTime) && b.endTime != Infinity && typeof b.endTime == "number" && (k = f == null ? Math.floor(b.endTime * 10) / 10 : b.endTime);
                        l = b.values.find(function(Ca) {
                            return Ca.key == "X-RESTRICT";
                        });
                        n = m = !0;
                        l && l.data && (q = l.data, m = !q.includes("SKIP"), n = !q.includes("JUMP"));
                        r = m ? 0 : null;
                        if (t = b.values.find(function(Ca) {
                            return Ca.key == "X-ENABLE-SKIP-AFTER";
                        })) w = t.data, r = parseFloat(w), isNaN(r) && (r = m ? 0 : null);
                        v = null;
                        if (z = b.values.find(function(Ca) {
                            return Ca.key == "X-ENABLE-SKIP-FOR";
                        })) y = z.data, v = parseFloat(y), isNaN(r) && (v = null);
                        A = null;
                        if (C = b.values.find(function(Ca) {
                            return Ca.key == "X-RESUME-OFFSET";
                        })) E = C.data, A = parseFloat(E), isNaN(A) && (A = null);
                        D = null;
                        if (B = b.values.find(function(Ca) {
                            return Ca.key == "X-PLAYOUT-LIMIT";
                        })) G = B.data, D = parseFloat(G), isNaN(D) && (D = null);
                        L = J = I = !1;
                        if (K = b.values.find(function(Ca) {
                            return Ca.key == "CUE";
                        })) N = K.data, I = N.includes("ONCE"), J = N.includes("PRE"), L = N.includes("POST");
                        P = !1;
                        (O = b.values.find(function(Ca) {
                            return Ca.key == "X-TIMELINE-OCCUPIES";
                        })) ? (M = O.data, P = M.includes("RANGE")) : !C && a.F.U() && (P = !J && !L);
                        if (d) {
                            R = d.data;
                            if (!R) return Aa.return(c);
                            c.push({
                                id: f,
                                groupId: null,
                                startTime: h,
                                endTime: k,
                                uri: R,
                                mimeType: null,
                                isSkippable: m,
                                skipOffset: r,
                                skipFor: v,
                                canJump: n,
                                resumeOffset: A,
                                playoutLimit: D,
                                once: I,
                                pre: J,
                                post: L,
                                timelineRange: P,
                                loop: !1,
                                overlay: null,
                                displayOnBackground: !1,
                                currentVideo: null,
                                background: null,
                                clickThroughUrl: null
                            });
                            Aa.B(2);
                            break;
                        }
                        if (!e) {
                            Aa.B(2);
                            break;
                        }
                        W = e.data;
                        if (!W) return Aa.return(c);
                        ra(Aa, 4);
                        wa = {
                            type: 11
                        };
                        return F(Aa, Ws(a, W, wa), 6);
                    case 6:
                        Y = Aa.h;
                        Ka = Wb(Y);
                        Na = JSON.parse(Ka);
                        if (La = Na["SKIP-CONTROL"]) Ea = La["ENABLE-SKIP-AFTER"], typeof Ea == "number" && (r = parseFloat(Ea), isNaN(Ea) && (r = m ? 0 : null)), za = La["ENABLE-SKIP-FOR"], typeof za == "number" && (v = parseFloat(za), isNaN(za) && (v = null));
                        for(Fa = 0; Fa < Na.ASSETS.length; Fa++)Da = Na.ASSETS[Fa], Da.URI && c.push({
                            id: f + "_shaka_asset_" + Fa,
                            groupId: f,
                            startTime: h,
                            endTime: k,
                            uri: Da.URI,
                            mimeType: null,
                            isSkippable: m,
                            skipOffset: r,
                            skipFor: v,
                            canJump: n,
                            resumeOffset: A,
                            playoutLimit: D,
                            once: I,
                            pre: J,
                            post: L,
                            timelineRange: P,
                            loop: !1,
                            overlay: null,
                            displayOnBackground: !1,
                            currentVideo: null,
                            background: null,
                            clickThroughUrl: null
                        });
                        ta(Aa, 2);
                        break;
                    case 4:
                        ua(Aa);
                    case 2:
                        return Aa.return(c);
                }
            });
        }
        function Ss(a) {
            var b = [];
            if (!a) return b;
            var c = a.values.find(function(v) {
                return v.key == "X-ASSET-URI";
            });
            if (!c) return b;
            c = c.data;
            if (!c) return b;
            var d = null, e = a.values.find(function(v) {
                return v.key == "X-OVERLAY-ID";
            });
            e && (d = e.data);
            e = d == null ? Math.floor(a.startTime * 10) / 10 : a.startTime;
            var f = a.endTime;
            a.endTime && a.endTime != Infinity && typeof a.endTime == "number" && (f = d == null ? Math.floor(a.endTime * 10) / 10 : a.endTime);
            var g = !1, h = !1, k = !1, l = a.values.find(function(v) {
                return v.key == "CUE";
            });
            l && (k = l.data, g = k.includes("ONCE"), h = k.includes("PRE"), k = k.includes("POST"));
            l = null;
            var m = a.values.find(function(v) {
                return v.key == "X-ASSET-MIMETYPE";
            });
            m && (l = m.data);
            m = !1;
            var n = a.values.find(function(v) {
                return v.key == "X-LOOP";
            });
            n && (m = n.data == "YES");
            n = 1;
            var q = a.values.find(function(v) {
                return v.key == "X-DEPTH";
            });
            q && (n = parseFloat(q.data), isNaN(n) && (n = 1));
            q = null;
            var r = a.values.find(function(v) {
                return v.key == "X-BACKGROUND";
            });
            r && (q = r.data);
            r = 1920;
            var t = 1080, w = a.values.find(function(v) {
                return v.key == "X-VIEWPORT";
            });
            if (w) {
                t = w.data.split("x");
                if (t.length != 2) return b;
                r = parseFloat(t[0]);
                t = parseFloat(t[1]);
            }
            r = {
                viewport: {
                    x: r,
                    y: t
                },
                topLeft: {
                    x: 0,
                    y: 0
                },
                size: {
                    x: r,
                    y: t
                }
            };
            if (t = a.values.find(function(v) {
                return v.key == "X-OVERLAY-POSITION";
            })) {
                t = t.data.split("x");
                if (t.length != 2) return b;
                r.topLeft.x = parseFloat(t[0]);
                r.topLeft.y = parseFloat(t[1]);
            }
            if (t = a.values.find(function(v) {
                return v.key == "X-OVERLAY-SIZE";
            })) {
                t = t.data.split("x");
                if (t.length != 2) return b;
                r.size.x = parseFloat(t[0]);
                r.size.y = parseFloat(t[1]);
            }
            t = null;
            if (w = a.values.find(function(v) {
                return v.key == "X-SQUEEZECURRENT";
            })) {
                if (t = parseFloat(w.data), isNaN(t) && (t = 1), t = {
                    viewport: {
                        x: 1920,
                        y: 1080
                    },
                    topLeft: {
                        x: 0,
                        y: 0
                    },
                    size: {
                        x: 1920 * t,
                        y: 1080 * t
                    }
                }, a = a.values.find(function(v) {
                    return v.key == "X-SQUEEZECURRENT-POSITION";
                })) {
                    a = a.data.split("x");
                    if (a.length != 2) return b;
                    t.topLeft.x = parseFloat(a[0]);
                    t.topLeft.y = parseFloat(a[1]);
                }
            }
            b.push({
                id: d,
                groupId: null,
                startTime: e,
                endTime: f,
                uri: c,
                mimeType: l,
                isSkippable: !1,
                skipOffset: null,
                skipFor: null,
                canJump: !0,
                resumeOffset: null,
                playoutLimit: null,
                once: g,
                pre: h,
                post: k,
                timelineRange: !0,
                loop: m,
                overlay: r,
                displayOnBackground: n == -1,
                currentVideo: t,
                background: q,
                clickThroughUrl: null
            });
            return b;
        }
        function Ms(a) {
            for(var b = [], c = u(a.I), d = c.next(), e = {}; !d.done; e = {
                Kc: void 0
            }, d = c.next())d = d.value, d.overlay || (e.Kc = {
                start: d.startTime,
                end: null
            }, d.pre ? (e.Kc.start = 0, e.Kc.end = null) : d.post ? (e.Kc.start = -1, e.Kc.end = null) : d.timelineRange && (e.Kc.end = d.endTime), b.find(function(f) {
                return function(g) {
                    return f.Kc.start == g.start && f.Kc.end == g.end;
                };
            }(e)) || b.push(e.Kc));
            a.i(new T("ad-cue-points-changed", (new Map).set("cuepoints", b)));
        }
        function Fs(a) {
            a.j.configure(a.F.Zi());
            a.j.configure("ads.disableHLSInterstitial", !0);
            a.j.configure("ads.disableDASHInterstitial", !0);
            a.j.configure("playRangeEnd", Infinity);
            Zg(a.F.Vb(), a.j.Vb());
        }
        function Ws(a, b, c) {
            var d, e, f;
            return Q(function(g) {
                if (g.g == 1) return d = $g([
                    b
                ], Fg()), e = a.F.Vb().request(7, d, c), F(g, e.promise, 2);
                f = g.h;
                return g.return(f.data);
            });
        }
        function Is(a) {
            return (a = a.mimeType) ? !a.startsWith("image/") && a !== "text/html" : !0;
        }
        function Ps() {
            var a = Rb().Ka();
            return a == "TV" || a == "CONSOLE" || a == "CAST" ? !0 : !1;
        }
        function Js(a, b) {
            if (!(a.L.has(b) || a.M && !a.M.allowPreloadOnDomElements)) {
                var c = function(f) {
                    var g = document.createElement("link");
                    g.rel = "preload";
                    g.href = f;
                    g.as = "image";
                    document.head.appendChild(g);
                    return g;
                }, d = [];
                if (b.background) {
                    var e = b.background.match(/url\(('|")?([^'"()]+)('|")\)?/);
                    e && d.push(c(e[2]));
                }
                b.mimeType.startsWith("image/") && d.push(c(b.uri));
                a.L.set(b, d);
            }
        }
        function Ks(a, b) {
            if (a.L.has(b)) {
                var c = a.L.get(b);
                c = u(c);
                for(var d = c.next(); !d.done; d = c.next())d = d.value, d.parentNode.removeChild(d);
                a.L.delete(b);
            }
        }
        function $s(a, b, c, d, e) {
            this.h = a;
            this.j = Dd(this.h.skipOffset);
            this.g = e;
            this.i = b;
            this.l = c;
            this.u = d;
            this.m = !1;
        }
        p = $s.prototype;
        p.needsSkipUI = function() {
            return !0;
        };
        p.isClientRendering = function() {
            return !1;
        };
        p.hasCustomClick = function() {
            return !1;
        };
        p.isUsingAnotherMediaElement = function() {
            return !1;
        };
        p.getDuration = function() {
            return this.h.durationInSeconds;
        };
        p.getMinSuggestedDuration = function() {
            return this.getDuration();
        };
        p.getRemainingTime = function() {
            return this.h.startTimeInSeconds + this.h.durationInSeconds - this.g.currentTime;
        };
        p.isPaused = function() {
            return this.g.paused;
        };
        p.isSkippable = function() {
            return typeof this.j == "number" ? !0 : !1;
        };
        p.getTimeUntilSkippable = function() {
            if (typeof this.j != "number") return this.getRemainingTime();
            var a = this.getRemainingTime() + this.j - this.getDuration();
            return Math.max(a, 0);
        };
        p.canSkipNow = function() {
            return this.getTimeUntilSkippable() == 0;
        };
        p.skip = function() {
            this.m = !0;
            this.g.currentTime += this.getRemainingTime();
        };
        p.pause = function() {
            return this.g.pause();
        };
        p.play = function() {
            return this.g.play();
        };
        p.getVolume = function() {
            return this.g.volume;
        };
        p.setVolume = function(a) {
            this.g.volume = a;
        };
        p.isMuted = function() {
            return this.g.muted;
        };
        p.isLinear = function() {
            return this.u;
        };
        p.resize = function() {};
        p.setMuted = function(a) {
            this.g.muted = a;
        };
        p.getSequenceLength = function() {
            return this.l ? this.l : 1;
        };
        p.getPositionInSequence = function() {
            return this.i ? this.i : 1;
        };
        p.getTitle = function() {
            return this.h.adTitle;
        };
        p.getDescription = function() {
            return "";
        };
        p.getVastMediaBitrate = function() {
            return 0;
        };
        p.getVastMediaHeight = function() {
            return 0;
        };
        p.getVastMediaWidth = function() {
            return 0;
        };
        p.getVastAdId = function() {
            return this.h.vastAdId || "";
        };
        p.getAdId = function() {
            return this.h.adId;
        };
        p.getCreativeAdId = function() {
            return this.h.creativeId;
        };
        p.getAdvertiserName = function() {
            return "";
        };
        p.getMediaUrl = function() {
            return null;
        };
        p.getTimeOffset = function() {
            return 0;
        };
        p.getPodIndex = function() {
            return 0;
        };
        p.release = function() {
            this.l = this.i = this.g = this.h = null;
        };
        S("shaka.ads.MediaTailorAd", $s);
        $s.prototype.release = $s.prototype.release;
        $s.prototype.getPodIndex = $s.prototype.getPodIndex;
        $s.prototype.getTimeOffset = $s.prototype.getTimeOffset;
        $s.prototype.getMediaUrl = $s.prototype.getMediaUrl;
        $s.prototype.getAdvertiserName = $s.prototype.getAdvertiserName;
        $s.prototype.getCreativeAdId = $s.prototype.getCreativeAdId;
        $s.prototype.getAdId = $s.prototype.getAdId;
        $s.prototype.getVastAdId = $s.prototype.getVastAdId;
        $s.prototype.getVastMediaWidth = $s.prototype.getVastMediaWidth;
        $s.prototype.getVastMediaHeight = $s.prototype.getVastMediaHeight;
        $s.prototype.getVastMediaBitrate = $s.prototype.getVastMediaBitrate;
        $s.prototype.getDescription = $s.prototype.getDescription;
        $s.prototype.getTitle = $s.prototype.getTitle;
        $s.prototype.getPositionInSequence = $s.prototype.getPositionInSequence;
        $s.prototype.getSequenceLength = $s.prototype.getSequenceLength;
        $s.prototype.setMuted = $s.prototype.setMuted;
        $s.prototype.resize = $s.prototype.resize;
        $s.prototype.isLinear = $s.prototype.isLinear;
        $s.prototype.isMuted = $s.prototype.isMuted;
        $s.prototype.setVolume = $s.prototype.setVolume;
        $s.prototype.getVolume = $s.prototype.getVolume;
        $s.prototype.play = $s.prototype.play;
        $s.prototype.pause = $s.prototype.pause;
        $s.prototype.skip = $s.prototype.skip;
        $s.prototype.canSkipNow = $s.prototype.canSkipNow;
        $s.prototype.getTimeUntilSkippable = $s.prototype.getTimeUntilSkippable;
        $s.prototype.isSkippable = $s.prototype.isSkippable;
        $s.prototype.isPaused = $s.prototype.isPaused;
        $s.prototype.getRemainingTime = $s.prototype.getRemainingTime;
        $s.prototype.getMinSuggestedDuration = $s.prototype.getMinSuggestedDuration;
        $s.prototype.getDuration = $s.prototype.getDuration;
        $s.prototype.isUsingAnotherMediaElement = $s.prototype.isUsingAnotherMediaElement;
        $s.prototype.hasCustomClick = $s.prototype.hasCustomClick;
        $s.prototype.isClientRendering = $s.prototype.isClientRendering;
        $s.prototype.needsSkipUI = $s.prototype.needsSkipUI;
        function at(a, b, c, d) {
            this.D = a;
            this.K = b;
            this.h = c;
            this.l = null;
            this.P = NaN;
            this.i = d;
            this.J = !1;
            this.C = null;
            this.j = [];
            this.M = [];
            this.L = this.F = this.g = null;
            this.G = new Map;
            this.m = [];
            this.A = [];
            this.H = "";
            this.O = !0;
            this.I = "";
            this.u = new Tc;
        }
        at.prototype.stop = function() {
            for(var a = u(this.m), b = a.next(); !b.done; b = a.next())b = b.value, this.u.Ea(b.target, b.type, b.listener);
            bt(this);
            this.m = [];
            this.A = [];
            this.H = "";
            this.O = !0;
            this.I = "";
            this.C = null;
            this.j = [];
            this.M = [];
            this.G.clear();
        };
        at.prototype.release = function() {
            this.stop();
            this.u && this.u.release();
        };
        at.prototype.onManifestUpdated = function(a) {
            this.J = a;
            this.H != "" && (ct(this, this.H, this.O), this.O = !1);
        };
        at.prototype.getCuePoints = function() {
            for(var a = [], b = u(this.j), c = b.next(); !c.done; c = b.next()){
                c = u(c.value.ads);
                for(var d = c.next(); !d.done; d = c.next())d = d.value, a.push({
                    start: d.startTimeInSeconds,
                    end: d.startTimeInSeconds + d.durationInSeconds
                });
            }
            return a;
        };
        function dt(a, b, c) {
            var d, e, f, g, h, k, l, m, n, q, r, t;
            Q(function(w) {
                if (w.g == 1) return d = {
                    type: 7
                }, e = $g([
                    b
                ], Fg()), e.method = "POST", c && (f = JSON.stringify(c), e.body = $b(f)), g = a.K.request(7, e, d), ra(w, 2), F(w, g.promise, 4);
                if (w.g != 2) {
                    h = w.h;
                    k = Wb(h.data);
                    l = JSON.parse(k);
                    if (l.manifestUrl && l.trackingUrl) m = new qb(b), n = new qb(l.trackingUrl), a.H = m.resolve(n).toString(), q = Date.now() / 1E3, r = q - a.P, a.i(new T("ads-loaded", (new Map).set("loadTime", r))), t = new qb(l.manifestUrl), a.l.resolve(m.resolve(t).toString()), a.l = null;
                    else throw Error("Insufficient data from MediaTailor.");
                    return ta(w, 0);
                }
                ua(w);
                if (!a.I.length) return a.l.reject("MediaTailor request returned an error and there was no backup asset uri provided."), a.l = null, w.return();
                a.l.resolve(a.I);
                a.l = null;
                H(w);
            });
        }
        function ct(a, b, c) {
            var d, e, f, g, h, k, l, m, n, q, r, t, w, v, z, y;
            Q(function(A) {
                if (A.g == 1) return d = {
                    type: 8
                }, e = $g([
                    b
                ], Fg()), f = a.K.request(7, e, d), ra(A, 2), F(A, f.promise, 4);
                if (A.g != 2) {
                    g = A.h;
                    h = [];
                    k = Wb(g.data);
                    l = JSON.parse(k);
                    if (l.avails.length > 0) {
                        if (JSON.stringify(a.j) != JSON.stringify(l.avails)) {
                            a.j = l.avails;
                            m = u(a.j);
                            for(n = m.next(); !n.done; n = m.next())for(q = n.value, r = u(q.nonLinearAdsList), t = r.next(); !t.done; t = r.next())for(w = t.value, v = u(w.nonLinearAdList), z = v.next(); !z.done; z = v.next())y = z.value, et(a, y);
                            h = a.getCuePoints();
                            a.i(new T("ad-cue-points-changed", (new Map).set("cuepoints", h)));
                        }
                    } else a.j.length && a.i(new T("ad-cue-points-changed", (new Map).set("cuepoints", h))), bt(a), a.j = [];
                    c && (a.J || h.length > 0) && ft(a);
                    return ta(A, 0);
                }
                ua(A);
                H(A);
            });
        }
        function et(a, b) {
            var c, d, e, f, g, h, k, l, m;
            Q(function(n) {
                if (n.g == 1) {
                    if (!b.staticResource) return n.return();
                    c = gt(b);
                    if (d = a.G.get(c)) return n.return();
                    e = {
                        type: 9
                    };
                    f = $g([
                        b.staticResource
                    ], Fg());
                    g = a.K.request(7, f, e);
                    ra(n, 2);
                    a.G.set(c, []);
                    return F(n, g.promise, 4);
                }
                if (n.g != 2) return h = n.h, k = Wb(h.data), l = JSON.parse(k), m = l.apps, a.G.set(c, m), ta(n, 0);
                ua(n);
                a.G.delete(c);
                H(n);
            });
        }
        function gt(a) {
            return [
                a.adId,
                a.adParameters,
                a.adSystem,
                a.adTitle,
                a.creativeAdId,
                a.creativeId,
                a.creativeSequence,
                a.height,
                a.width,
                a.staticResource
            ].join("");
        }
        function ft(a) {
            ht(a);
            a.J || (it(a), a.u.o(a.h, "seeked", function() {
                it(a);
            }), a.u.o(a.h, "ended", function() {
                bt(a);
            }));
            a.u.o(a.h, "timeupdate", function() {
                ht(a);
            });
        }
        function it(a) {
            var b = a.h.currentTime;
            if (b != 0 && a.C == null) {
                for(var c, d, e = u(a.j), f = e.next(); !f.done; f = e.next()){
                    f = f.value;
                    for(var g = u(f.ads), h = g.next(); !h.done; h = g.next())if (h = h.value, !d) h.startTimeInSeconds < b && (d = h, c = f);
                    else if (h.startTimeInSeconds < b && h.startTimeInSeconds > d.startTimeInSeconds + d.durationInSeconds) {
                        d = h;
                        c = f;
                        break;
                    }
                }
                c && d && !a.M.includes(d.adId) && (a.C = b, a.h.currentTime = c.startTimeInSeconds);
            }
        }
        function ht(a) {
            if (a.h.duration && (a.g || a.j.length)) {
                var b = a.h.currentTime, c = !1;
                if (a.g) {
                    c = !0;
                    var d = a.F, e = d.startTimeInSeconds + .5 * d.durationInSeconds, f = d.startTimeInSeconds + .75 * d.durationInSeconds;
                    b >= d.startTimeInSeconds + .25 * d.durationInSeconds && !a.A.includes("firstQuartile") ? (a.A.push("firstQuartile"), jt(a, "firstQuartile")) : b >= e && !a.A.includes("midpoint") ? (a.A.push("midpoint"), jt(a, "midpoint")) : b >= f && !a.A.includes("thirdQuartile") && (a.A.push("thirdQuartile"), jt(a, "thirdQuartile"));
                    d = a.g.getRemainingTime();
                    e = a.g.getDuration();
                    a.g.canSkipNow() && d > 0 && e > 0 && jt(a, "skipStateChanged");
                    e > 0 && (d <= 0 || d > e) && bt(a);
                }
                if (!a.g || !a.g.isLinear()) {
                    a: for(d = u(a.j), e = d.next(); !e.done; e = d.next()){
                        e = e.value;
                        if (a.g && a.g.isLinear()) break;
                        for(f = 0; f < e.ads.length; f++){
                            var g = e.ads[f], h = g.startTimeInSeconds + g.durationInSeconds;
                            if (g.startTimeInSeconds <= b && h > b) {
                                if (a.M.includes(g.adId)) {
                                    if (a.h.ended) continue;
                                    a.h.currentTime = h;
                                    break a;
                                }
                                bt(a);
                                a.L = e;
                                a.g = new $s(g, f + 1, e.ads.length, !0, a.h);
                                a.F = g;
                                f === 0 && jt(a, "breakStart");
                                kt(a);
                                break;
                            }
                        }
                    }
                    if (!a.g) for(d = u(a.j), e = d.next(); !e.done; e = d.next()){
                        e = e.value;
                        if (a.g) break;
                        for(f = 0; f < e.nonLinearAdsList.length; f++)if (g = e.nonLinearAdsList[f], g.nonLinearAdList.length) {
                            h = e.startTimeInSeconds;
                            var k = a.G.get(gt(g.nonLinearAdList[0]));
                            if (h <= b && k && k.length) {
                                bt(a);
                                h = a;
                                k = u(k);
                                for(var l = k.next(); !l.done; l = k.next())if (l = l.value, l.data.source.length) {
                                    var m = document.createElement("img");
                                    m.src = l.data.source[0].url;
                                    m.style.top = (l.placeholder.top || 0) + "%";
                                    m.style.height = 100 - (l.placeholder.top || 0) + "%";
                                    m.style.left = (l.placeholder.left || 0) + "%";
                                    m.style.maxWidth = 100 - (l.placeholder.left || 0) + "%";
                                    m.style.objectFit = "contain";
                                    m.style.position = "absolute";
                                    h.D.appendChild(m);
                                }
                                a.L = e;
                                a.g = new $s(g, f + 1, e.ads.length, !1, a.h);
                                a.F = g;
                                f === 0 && jt(a, "breakStart");
                                kt(a);
                                break;
                            }
                        }
                    }
                    c && !a.g && (b = a.h.currentTime, a.C && a.C > b && (a.h.currentTime = a.C), a.C = null);
                }
            }
        }
        function bt(a) {
            if (a.g) {
                for(; a.D.lastChild;)a.D.removeChild(a.D.firstChild);
                a.J || a.M.push(a.F.adId);
                var b = a.g.m;
                (b === void 0 ? 0 : b) ? jt(a, "skip") : jt(a, "complete");
                b = u(a.m);
                for(var c = b.next(); !c.done; c = b.next())c = c.value, a.u.Ea(c.target, c.type, c.listener);
                a.m = [];
                a.A = [];
                b = a.g.getPositionInSequence();
                c = a.g.getSequenceLength();
                b === c && jt(a, "breakEnd");
                a.g = null;
                a.F = null;
                a.L = null;
            }
        }
        function kt(a) {
            var b = !1;
            a.h.paused ? b = !0 : (jt(a, "impression"), jt(a, "start"));
            a.m.push({
                target: a.h,
                type: "volumechange",
                listener: function() {
                    a.h.muted && jt(a, "mute");
                }
            });
            a.m.push({
                target: a.h,
                type: "volumechange",
                listener: function() {
                    a.h.muted || jt(a, "unmute");
                }
            });
            a.m.push({
                target: a.h,
                type: "play",
                listener: function() {
                    b ? (jt(a, "impression"), jt(a, "start"), b = !1) : jt(a, "resume");
                }
            });
            a.m.push({
                target: a.h,
                type: "pause",
                listener: function() {
                    jt(a, "pause");
                }
            });
            for(var c = u(a.m), d = c.next(); !d.done; d = c.next())d = d.value, a.u.o(d.target, d.type, d.listener);
        }
        function jt(a, b) {
            var c = a.F.trackingEvents.find(function(f) {
                return f.eventType == b;
            });
            c || (c = a.L.adBreakTrackingEvents.find(function(f) {
                return f.eventType == b;
            }));
            if (c) {
                var d = {
                    type: 10
                };
                c = u(c.beaconUrls);
                for(var e = c.next(); !e.done; e = c.next())(e = e.value) && e != "" && (e = $g([
                    e
                ], Fg()), e.method = "POST", a.K.request(7, e, d));
            }
            switch(b){
                case "impression":
                    a.i(new T("ad-impression"));
                    break;
                case "start":
                    a.i(new T("ad-started", (new Map).set("ad", a.g)));
                    break;
                case "mute":
                    a.i(new T("ad-muted"));
                    break;
                case "unmute":
                    a.i(new T("ad-volume-changed"));
                    break;
                case "resume":
                    a.i(new T("ad-resumed"));
                    break;
                case "pause":
                    a.i(new T("ad-paused"));
                    break;
                case "firstQuartile":
                    a.i(new T("ad-first-quartile"));
                    break;
                case "midpoint":
                    a.i(new T("ad-midpoint"));
                    break;
                case "thirdQuartile":
                    a.i(new T("ad-third-quartile"));
                    break;
                case "complete":
                    a.i(new T("ad-complete"));
                    a.i(new T("ad-stopped"));
                    break;
                case "skip":
                    a.i(new T("ad-skipped"));
                    a.i(new T("ad-stopped"));
                    break;
                case "breakStart":
                    a.D.setAttribute("ad-active", "true");
                    break;
                case "breakEnd":
                    a.D.removeAttribute("ad-active");
                    break;
                case "skipStateChanged":
                    a.i(new T("ad-skip-state-changed"));
            }
        }
        function lt(a, b) {
            this.g = a;
            this.i = null;
            this.h = b;
        }
        p = lt.prototype;
        p.needsSkipUI = function() {
            return !0;
        };
        p.isClientRendering = function() {
            return !1;
        };
        p.hasCustomClick = function() {
            return !0;
        };
        p.isUsingAnotherMediaElement = function() {
            return !1;
        };
        p.getDuration = function() {
            return this.i ? this.i.duration : -1;
        };
        p.getMinSuggestedDuration = function() {
            return this.getDuration();
        };
        p.getRemainingTime = function() {
            return this.i ? this.i.duration - this.i.currentTime : -1;
        };
        p.isPaused = function() {
            return this.h.paused;
        };
        p.isSkippable = function() {
            return this.g.isSkippable();
        };
        p.getTimeUntilSkippable = function() {
            var a = this.g.getSkipTimeOffset();
            a = this.getRemainingTime() - a;
            return Math.max(a, 0);
        };
        p.canSkipNow = function() {
            return this.getTimeUntilSkippable() == 0;
        };
        p.skip = function() {
            this.h.currentTime += this.getRemainingTime();
        };
        p.pause = function() {
            return this.h.pause();
        };
        p.play = function() {
            return this.h.play();
        };
        p.getVolume = function() {
            return this.h.volume;
        };
        p.setVolume = function(a) {
            this.h.volume = a;
        };
        p.isMuted = function() {
            return this.h.muted;
        };
        p.isLinear = function() {
            return !0;
        };
        p.resize = function() {};
        p.setMuted = function(a) {
            this.h.muted = a;
        };
        p.getSequenceLength = function() {
            var a = this.g.getAdPodInfo();
            return a == null ? 1 : a.getTotalAds();
        };
        p.getPositionInSequence = function() {
            var a = this.g.getAdPodInfo();
            return a == null ? 1 : a.getAdPosition();
        };
        p.getTitle = function() {
            return this.g.getTitle();
        };
        p.getDescription = function() {
            return this.g.getDescription();
        };
        p.getVastMediaBitrate = function() {
            return 0;
        };
        p.getVastMediaHeight = function() {
            return this.g.getVastMediaHeight();
        };
        p.getVastMediaWidth = function() {
            return this.g.getVastMediaWidth();
        };
        p.getVastAdId = function() {
            return "";
        };
        p.getAdId = function() {
            return this.g.getAdId();
        };
        p.getCreativeAdId = function() {
            return this.g.getCreativeAdId();
        };
        p.getAdvertiserName = function() {
            return this.g.getAdvertiserName();
        };
        p.getMediaUrl = function() {
            return null;
        };
        p.getTimeOffset = function() {
            var a = this.g.getAdPodInfo();
            return a == null ? 0 : a.getTimeOffset();
        };
        p.getPodIndex = function() {
            var a = this.g.getAdPodInfo();
            return a == null ? 0 : a.getPodIndex();
        };
        p.release = function() {
            this.h = this.i = this.g = null;
        };
        S("shaka.ads.ServerSideAd", lt);
        lt.prototype.release = lt.prototype.release;
        lt.prototype.getPodIndex = lt.prototype.getPodIndex;
        lt.prototype.getTimeOffset = lt.prototype.getTimeOffset;
        lt.prototype.getMediaUrl = lt.prototype.getMediaUrl;
        lt.prototype.getAdvertiserName = lt.prototype.getAdvertiserName;
        lt.prototype.getCreativeAdId = lt.prototype.getCreativeAdId;
        lt.prototype.getAdId = lt.prototype.getAdId;
        lt.prototype.getVastAdId = lt.prototype.getVastAdId;
        lt.prototype.getVastMediaWidth = lt.prototype.getVastMediaWidth;
        lt.prototype.getVastMediaHeight = lt.prototype.getVastMediaHeight;
        lt.prototype.getVastMediaBitrate = lt.prototype.getVastMediaBitrate;
        lt.prototype.getDescription = lt.prototype.getDescription;
        lt.prototype.getTitle = lt.prototype.getTitle;
        lt.prototype.getPositionInSequence = lt.prototype.getPositionInSequence;
        lt.prototype.getSequenceLength = lt.prototype.getSequenceLength;
        lt.prototype.setMuted = lt.prototype.setMuted;
        lt.prototype.resize = lt.prototype.resize;
        lt.prototype.isLinear = lt.prototype.isLinear;
        lt.prototype.isMuted = lt.prototype.isMuted;
        lt.prototype.setVolume = lt.prototype.setVolume;
        lt.prototype.getVolume = lt.prototype.getVolume;
        lt.prototype.play = lt.prototype.play;
        lt.prototype.pause = lt.prototype.pause;
        lt.prototype.skip = lt.prototype.skip;
        lt.prototype.canSkipNow = lt.prototype.canSkipNow;
        lt.prototype.getTimeUntilSkippable = lt.prototype.getTimeUntilSkippable;
        lt.prototype.isSkippable = lt.prototype.isSkippable;
        lt.prototype.isPaused = lt.prototype.isPaused;
        lt.prototype.getRemainingTime = lt.prototype.getRemainingTime;
        lt.prototype.getMinSuggestedDuration = lt.prototype.getMinSuggestedDuration;
        lt.prototype.getDuration = lt.prototype.getDuration;
        lt.prototype.isUsingAnotherMediaElement = lt.prototype.isUsingAnotherMediaElement;
        lt.prototype.hasCustomClick = lt.prototype.hasCustomClick;
        lt.prototype.isClientRendering = lt.prototype.isClientRendering;
        lt.prototype.needsSkipUI = lt.prototype.needsSkipUI;
        function mt(a, b, c, d) {
            var e = this;
            this.A = a;
            this.l = b;
            this.j = null;
            this.G = NaN;
            this.i = d;
            this.H = !1;
            this.C = this.m = this.u = null;
            this.D = "";
            this.F = [];
            this.h = new Tc;
            a = new google.ima.dai.api.UiSettings;
            a.setLocale(c);
            this.g = new google.ima.dai.api.StreamManager(this.l, this.A, a);
            this.i(new T("ima-stream-manager-loaded", (new Map).set("imaStreamManager", this.g)));
            this.h.o(this.g, google.ima.dai.api.StreamEvent.Type.LOADED, function(f) {
                nt(e, f);
            });
            this.h.o(this.g, google.ima.dai.api.StreamEvent.Type.ERROR, function() {
                e.D.length ? e.j.resolve(e.D) : e.j.reject("IMA Stream request returned an error and there was no backup asset uri provided.");
                e.j = null;
            });
            this.h.o(this.g, google.ima.dai.api.StreamEvent.Type.AD_BREAK_STARTED, function() {});
            this.h.o(this.g, google.ima.dai.api.StreamEvent.Type.STARTED, function(f) {
                f = f.getAd();
                e.m = new lt(f, e.l);
                e.C && (e.m.i = e.C);
                e.i(new T("ad-started", (new Map).set("ad", e.m)));
                e.A.setAttribute("ad-active", "true");
            });
            this.h.o(this.g, google.ima.dai.api.StreamEvent.Type.AD_BREAK_ENDED, function() {
                e.A.removeAttribute("ad-active");
                var f = e.l.currentTime;
                e.u && e.u > f && (e.l.currentTime = e.u, e.u = null);
            });
            this.h.o(this.g, google.ima.dai.api.StreamEvent.Type.AD_PROGRESS, function(f) {
                e.C = f.getStreamData().adProgressData;
                e.m && (e.m.i = e.C);
            });
            this.h.o(this.g, google.ima.dai.api.StreamEvent.Type.FIRST_QUARTILE, function() {
                e.i(new T("ad-first-quartile"));
            });
            this.h.o(this.g, google.ima.dai.api.StreamEvent.Type.MIDPOINT, function() {
                e.i(new T("ad-midpoint"));
            });
            this.h.o(this.g, google.ima.dai.api.StreamEvent.Type.THIRD_QUARTILE, function() {
                e.i(new T("ad-third-quartile"));
            });
            this.h.o(this.g, google.ima.dai.api.StreamEvent.Type.COMPLETE, function() {
                e.i(new T("ad-complete"));
                e.i(new T("ad-stopped"));
                e.A.removeAttribute("ad-active");
                e.m = null;
            });
            this.h.o(this.g, google.ima.dai.api.StreamEvent.Type.SKIPPED, function() {
                e.i(new T("ad-skipped"));
                e.i(new T("ad-stopped"));
            });
            this.h.o(this.g, google.ima.dai.api.StreamEvent.Type.CUEPOINTS_CHANGED, function(f) {
                var g = f.getStreamData();
                f = [];
                g = u(g.cuepoints);
                for(var h = g.next(); !h.done; h = g.next())h = h.value, f.push({
                    start: h.start,
                    end: h.end
                });
                e.F = f;
                e.i(new T("ad-cue-points-changed", (new Map).set("cuepoints", f)));
            });
        }
        p = mt.prototype;
        p.configure = function() {};
        p.stop = function() {
            this.D = "";
            this.u = null;
            this.F = [];
        };
        p.release = function() {
            this.stop();
            this.h && this.h.release();
        };
        p.onCueMetadataChange = function(a) {
            if (a.key && a.data) {
                var b = {};
                b[a.key] = a.data;
                this.g.onTimedMetadata(b);
            }
        };
        p.getCuePoints = function() {
            return this.F;
        };
        function nt(a, b) {
            a.i(new T("ads-loaded", (new Map).set("loadTime", Date.now() / 1E3 - a.G)));
            b = b.getStreamData().url;
            a.j.resolve(b);
            a.j = null;
            a.H || a.h.o(a.l, "seeked", function() {
                var c = a.l.currentTime;
                if (c != 0) {
                    a.g.streamTimeForContentTime(c);
                    var d = a.g.previousCuePointForStreamTime(c);
                    d && !d.played && (a.u = c, a.l.currentTime = d.start);
                }
            });
        }
        function ot() {
            kb.call(this);
            this.h = this.i = this.j = this.g = null;
            this.m = new ps;
            this.u = navigator.language;
            this.l = null;
        }
        la(ot, kb);
        p = ot.prototype;
        p.setLocale = function(a) {
            this.u = a;
        };
        p.configure = function(a) {
            this.l = a;
            this.g && this.g.configure(this.l);
            this.j && this.j.configure(this.l);
            this.h && this.h.configure(this.l);
        };
        p.initInterstitial = function(a, b, c) {
            var d = this;
            this.g && this.g.release();
            this.g = new Es(a, b, c, function(e) {
                return pt(d, e);
            });
            this.g.configure(this.l);
        };
        p.initClientSide = function(a, b, c) {
            var d = this;
            if (!window1.google || !google.ima || !google.ima.AdsLoader) throw new U(2, 10, 1E4);
            this.j && this.j.release();
            this.j = new ws(a, b, this.u, c, function(e) {
                return pt(d, e);
            });
            this.j.configure(this.l);
        };
        p.release = function() {
            this.g && (this.g.release(), this.g = null);
            this.j && (this.j.release(), this.j = null);
            this.i && (this.i.release(), this.i = null);
            this.h && (this.h.release(), this.h = null);
            kb.prototype.release.call(this);
        };
        p.onAssetUnload = function() {
            this.g && this.g.stop();
            this.j && this.j.stop();
            this.i && this.i.stop();
            this.h && this.h.stop();
            this.dispatchEvent(new T("ad-stopped"));
            this.dispatchEvent(new T("ad-content-attach-requested"));
            this.m = new ps;
        };
        p.requestClientSideAds = function(a) {
            if (!this.j) throw new U(1, 10, 10001);
            var b = this.j;
            b.g && b.g.destroy();
            b.m && b.m.contentComplete();
            b.H = Date.now() / 1E3;
            b.m.requestAds(a);
        };
        p.updateClientSideAdsRenderingSettings = function(a) {
            if (!this.j) throw new U(1, 10, 10001);
            var b = this.j;
            b.D = a;
            b.g && b.g.updateAdsRenderingSettings(b.D);
        };
        p.initMediaTailor = function(a, b, c) {
            var d = this;
            this.i && this.i.release();
            this.i = new at(a, b, c, function(e) {
                return pt(d, e);
            });
        };
        p.requestMediaTailorStream = function(a, b, c) {
            if (!this.i) throw new U(1, 10, 10005);
            var d = this.i;
            c = c === void 0 ? "" : c;
            d.l ? a = Promise.reject(new U(1, 10, 10004)) : (d.l = new Lg, dt(d, a, b), d.I = c || "", d.P = Date.now() / 1E3, a = d.l);
            return a;
        };
        p.addMediaTailorTrackingUrl = function(a) {
            if (!this.i) throw new U(1, 10, 10005);
            var b = this.i;
            b.H = a;
            b.i(new T("ads-loaded", (new Map).set("loadTime", 0)));
        };
        p.initServerSide = function(a, b) {
            var c = this;
            if (!window1.google || !google.ima || !google.ima.dai) throw new U(2, 10, 10002);
            this.h && this.h.release();
            this.h = new mt(a, b, this.u, function(d) {
                return pt(c, d);
            });
            this.h.configure(this.l);
        };
        p.requestServerSideStream = function(a, b) {
            b = b === void 0 ? "" : b;
            if (!this.h) throw new U(1, 10, 10003);
            a.adTagParameters || (a.adTagParameters = {});
            var c = a.adTagParameters;
            (c.mpt || c.mpv) && ab('You have attempted to set "mpt" and/or "mpv" parameters of the ad tag. Please note that those parameters are used for Shaka adoption tracking and will be overridden.');
            a.adTagParameters.mpt = "shaka-player";
            a.adTagParameters.mpv = "v4.16.0";
            c = this.h;
            c.j ? a = Promise.reject(new U(1, 10, 10004)) : (a instanceof google.ima.dai.api.LiveStreamRequest && (c.H = !0), c.j = new Lg, c.g.requestStream(a), c.D = b || "", c.G = Date.now() / 1E3, a = c.j);
            return a;
        };
        p.replaceServerSideAdTagParameters = function(a) {
            if (!this.h) throw new U(1, 10, 10003);
            (a.mpt || a.mpv) && ab('You have attempted to set "mpt" and/or "mpv" parameters of the ad tag. Please note that those parameters are used for Shaka adoption tracking and will be overridden.');
            a.mpt = "Shaka Player";
            a.mpv = "v4.16.0";
            this.h.g.replaceAdTagParameters(a);
        };
        p.getServerSideCuePoints = function() {
            Zc("AdManager.getServerSideCuePoints", "Please use getCuePoints function.");
            return this.getCuePoints();
        };
        p.getCuePoints = function() {
            var a = [];
            this.h && (a = a.concat(this.h.getCuePoints()));
            this.i && (a = a.concat(this.i.getCuePoints()));
            return a;
        };
        p.getStats = function() {
            var a = this.m;
            return {
                loadTimes: a.g,
                averageLoadTime: qs(a),
                started: a.h,
                overlayAds: a.j,
                playedCompletely: a.l,
                skipped: a.m,
                errors: a.i
            };
        };
        p.onManifestUpdated = function(a) {
            if (this.i) this.i.onManifestUpdated(a);
        };
        p.onDashTimedMetadata = function(a) {
            this.h && a.schemeIdUri == "urn:google:dai:2018" && this.h.g.processMetadata(a.schemeIdUri, a.eventNode ? a.eventNode.attributes.messageData : null, a.startTime);
        };
        p.onHlsTimedMetadata = function(a, b) {
            this.h && this.h.g.processMetadata("ID3", a.data, b);
        };
        p.onCueMetadataChange = function(a) {
            if (this.h) this.h.onCueMetadataChange(a);
        };
        p.onHLSInterstitialMetadata = function(a, b, c) {
            this.l && this.l.disableHLSInterstitial || (this.g || this.initInterstitial(null, a, b), this.g && Rs(this.g, c));
        };
        p.onDASHInterstitialMetadata = function(a, b, c) {
            if (!this.l || !this.l.disableDASHInterstitial) {
                var d = c.schemeIdUri;
                if (d == "urn:mpeg:dash:event:alternativeMPD:insert:2025" || d == "urn:mpeg:dash:event:alternativeMPD:replace:2025") {
                    if (this.g || this.initInterstitial(null, a, b), this.g && (a = this.g, b = c.schemeIdUri == "urn:mpeg:dash:event:alternativeMPD:replace:2025", d = c.schemeIdUri == "urn:mpeg:dash:event:alternativeMPD:insert:2025", b || d)) {
                        for(var e = c.startTime, f = c.endTime, g = null, h = 0, k, l = u(c.eventNode.children), m = l.next(); !m.done; m = l.next())if (m = m.value, m.tagName == "AlternativeMPD") {
                            if (m = m.attributes.uri) {
                                k = m;
                                break;
                            }
                        } else if (m.tagName == "InsertPresentation" || m.tagName == "ReplacePresentation") {
                            var n = m.attributes.url;
                            if (n) {
                                k = cc(n);
                                (l = Zd(m, "maxDuration", ee)) && (g = l / c.timescale);
                                (l = Zd(m, "returnOffset", ee)) && (h = l / c.timescale);
                                b && h && (f = e + h);
                                break;
                            }
                        }
                        k && Us(a, [
                            {
                                id: c.id,
                                groupId: null,
                                startTime: e,
                                endTime: f,
                                uri: k,
                                mimeType: null,
                                isSkippable: !1,
                                skipOffset: null,
                                skipFor: null,
                                canJump: !0,
                                resumeOffset: d ? h : null,
                                playoutLimit: g,
                                once: !1,
                                pre: !1,
                                post: !1,
                                timelineRange: b && !d,
                                loop: !1,
                                overlay: null,
                                displayOnBackground: !1,
                                currentVideo: null,
                                background: null,
                                clickThroughUrl: null
                            }
                        ]);
                    }
                } else (d == "urn:mpeg:dash:event:2012" || d == "urn:scte:dash:scte214-events") && c.eventNode && Vd(c.eventNode, "OverlayEvent") && (this.g || this.initInterstitial(null, a, b), this.g && Vs(this.g, c));
            }
        };
        p.addCustomInterstitial = function(a) {
            if (!this.g) throw new U(1, 10, 10006);
            Us(this.g, [
                a
            ]);
        };
        p.addAdUrlInterstitial = function(a) {
            if (!this.g) throw new U(1, 10, 10006);
            return this.g.addAdUrlInterstitial(a);
        };
        p.getInterstitialPlayer = function() {
            if (!this.g) throw new U(1, 10, 10006);
            return this.g.Wb();
        };
        function pt(a, b) {
            if (b && b.type) switch(b.type){
                case "ads-loaded":
                    a.m.g.push(b.loadTime);
                    break;
                case "ad-started":
                    a.m.h++;
                    var c = b.ad;
                    c && !c.isLinear() && a.m.j++;
                    break;
                case "ad-complete":
                    a.m.l++;
                    break;
                case "ad-skipped":
                    a.m.m++;
                    break;
                case "ad-error":
                    a.m.i++;
            }
            a.dispatchEvent(b);
        }
        S("shaka.ads.AdManager", ot);
        ot.prototype.getInterstitialPlayer = ot.prototype.getInterstitialPlayer;
        ot.prototype.addAdUrlInterstitial = ot.prototype.addAdUrlInterstitial;
        ot.prototype.addCustomInterstitial = ot.prototype.addCustomInterstitial;
        ot.prototype.onDASHInterstitialMetadata = ot.prototype.onDASHInterstitialMetadata;
        ot.prototype.onHLSInterstitialMetadata = ot.prototype.onHLSInterstitialMetadata;
        ot.prototype.onCueMetadataChange = ot.prototype.onCueMetadataChange;
        ot.prototype.onHlsTimedMetadata = ot.prototype.onHlsTimedMetadata;
        ot.prototype.onDashTimedMetadata = ot.prototype.onDashTimedMetadata;
        ot.prototype.onManifestUpdated = ot.prototype.onManifestUpdated;
        ot.prototype.getStats = ot.prototype.getStats;
        ot.prototype.getCuePoints = ot.prototype.getCuePoints;
        ot.prototype.getServerSideCuePoints = ot.prototype.getServerSideCuePoints;
        ot.prototype.replaceServerSideAdTagParameters = ot.prototype.replaceServerSideAdTagParameters;
        ot.prototype.requestServerSideStream = ot.prototype.requestServerSideStream;
        ot.prototype.initServerSide = ot.prototype.initServerSide;
        ot.prototype.addMediaTailorTrackingUrl = ot.prototype.addMediaTailorTrackingUrl;
        ot.prototype.requestMediaTailorStream = ot.prototype.requestMediaTailorStream;
        ot.prototype.initMediaTailor = ot.prototype.initMediaTailor;
        ot.prototype.updateClientSideAdsRenderingSettings = ot.prototype.updateClientSideAdsRenderingSettings;
        ot.prototype.requestClientSideAds = ot.prototype.requestClientSideAds;
        ot.prototype.onAssetUnload = ot.prototype.onAssetUnload;
        ot.prototype.release = ot.prototype.release;
        ot.prototype.initClientSide = ot.prototype.initClientSide;
        ot.prototype.initInterstitial = ot.prototype.initInterstitial;
        ot.prototype.configure = ot.prototype.configure;
        ot.prototype.setLocale = ot.prototype.setLocale;
        ot.ADS_LOADED = "ads-loaded";
        ot.AD_STARTED = "ad-started";
        ot.AD_FIRST_QUARTILE = "ad-first-quartile";
        ot.AD_MIDPOINT = "ad-midpoint";
        ot.AD_THIRD_QUARTILE = "ad-third-quartile";
        ot.AD_COMPLETE = "ad-complete";
        ot.AD_STOPPED = "ad-stopped";
        ot.AD_SKIPPED = "ad-skipped";
        ot.AD_VOLUME_CHANGED = "ad-volume-changed";
        ot.AD_MUTED = "ad-muted";
        ot.AD_PAUSED = "ad-paused";
        ot.AD_RESUMED = "ad-resumed";
        ot.AD_SKIP_STATE_CHANGED = "ad-skip-state-changed";
        ot.CUEPOINTS_CHANGED = "ad-cue-points-changed";
        ot.IMA_AD_MANAGER_LOADED = "ima-ad-manager-loaded";
        ot.IMA_STREAM_MANAGER_LOADED = "ima-stream-manager-loaded";
        ot.AD_CLICKED = "ad-clicked";
        ot.AD_PROGRESS = "ad-progress";
        ot.AD_BUFFERING = "ad-buffering";
        ot.AD_IMPRESSION = "ad-impression";
        ot.AD_DURATION_CHANGED = "ad-duration-changed";
        ot.AD_CLOSED = "ad-closed";
        ot.AD_LOADED = "ad-loaded";
        ot.ALL_ADS_COMPLETED = "all-ads-completed";
        ot.AD_LINEAR_CHANGED = "ad-linear-changed";
        ot.AD_METADATA = "ad-metadata";
        ot.AD_RECOVERABLE_ERROR = "ad-recoverable-error";
        ot.AD_ERROR = "ad-error";
        ot.AD_BREAK_READY = "ad-break-ready";
        ot.AD_INTERACTION = "ad-interaction";
        ot.AD_CONTENT_PAUSE_REQUESTED = "ad-content-pause-requested";
        ot.AD_CONTENT_RESUME_REQUESTED = "ad-content-resume-requested";
        ot.AD_CONTENT_ATTACH_REQUESTED = "ad-content-attach-requested";
        Mq = function() {
            return new ot;
        };
        function qt(a) {
            return JSON.stringify(a, function(b, c) {
                if (typeof c != "function") {
                    if (c instanceof Event || c instanceof T) {
                        var d = {};
                        for(e in c)(b = c[e]) && typeof b == "object" ? e == "detail" && (d[e] = b) : e in Event || (d[e] = b);
                        return d;
                    }
                    if (c instanceof Error) {
                        var e = new Set([
                            "name",
                            "message",
                            "stack"
                        ]);
                        for(d in c)e.add(d);
                        d = u(Object.getOwnPropertyNames(c));
                        for(b = d.next(); !b.done; b = d.next())e.add(b.value);
                        d = {};
                        e = u(e);
                        for(b = e.next(); !b.done; b = e.next())b = b.value, d[b] = c[b];
                        c = {
                            __type__: "Error",
                            contents: d
                        };
                    } else if (c instanceof TimeRanges) {
                        e = {
                            __type__: "TimeRanges",
                            length: c.length,
                            start: [],
                            end: []
                        };
                        c = u(Hj(c));
                        for(d = c.next(); !d.done; d = c.next())d = d.value, b = d.end, e.start.push(d.start), e.end.push(b);
                        c = e;
                    } else c = ArrayBuffer.isView(c) && c.BYTES_PER_ELEMENT === 1 ? {
                        __type__: "Uint8Array",
                        entries: Array.from(c)
                    } : typeof c == "number" ? isNaN(c) ? "NaN" : isFinite(c) ? c : c < 0 ? "-Infinity" : "Infinity" : c;
                    return c;
                }
            });
        }
        function rt(a) {
            return JSON.parse(a, function(b, c) {
                if (c == "NaN") var d = NaN;
                else if (c == "-Infinity") d = -Infinity;
                else if (c == "Infinity") d = Infinity;
                else if (c && typeof c == "object" && c.__type__ == "TimeRanges") d = st(c);
                else if (c && typeof c == "object" && c.__type__ == "Uint8Array") d = new Uint8Array(c.entries);
                else if (c && typeof c == "object" && c.__type__ == "Error") {
                    b = c.contents;
                    c = Error(b.message);
                    for(d in b)c[d] = b[d];
                    d = c;
                } else d = c;
                return d;
            });
        }
        function st(a) {
            return {
                length: a.length,
                start: function(b) {
                    return a.start[b];
                },
                end: function(b) {
                    return a.end[b];
                }
            };
        }
        var tt = "ended play playing pause pausing ratechange seeked seeking timeupdate volumechange".split(" "), ut = "buffered currentTime duration ended loop muted paused playbackRate seeking videoHeight videoWidth volume".split(" "), vt = [
            "loop",
            "playbackRate"
        ], wt = [
            "pause",
            "play"
        ], xt = (new Map).set("getAssetUri", 2).set("getAudioLanguages", 4).set("getAudioLanguagesAndRoles", 4).set("getBufferFullness", 1).set("getBufferedInfo", 2).set("getExpiration", 2).set("getKeyStatuses", 2).set("getPlaybackRate", 2).set("getTextLanguages", 4).set("getTextLanguagesAndRoles", 4).set("isAudioOnly", 10).set("isBuffering", 1).set("isInProgress", 1).set("isLive", 10).set("isTextTrackVisible", 1).set("isVideoOnly", 10).set("keySystem", 10).set("seekRange", 1).set("getLoadMode", 10).set("getManifestType", 10).set("isFullyLoaded", 1).set("isEnded", 1).set("getBandwidthEstimate", 1), yt = (new Map).set("getConfiguration", 4).set("getConfigurationForLowLatency", 4).set("getStats", 5).set("getAudioTracks", 2).set("getChaptersTracks", 2).set("getImageTracks", 2).set("getVideoTracks", 2).set("getTextTracks", 2).set("getVariantTracks", 2), zt = (new Map).set("getPlayheadTimeAsDate", 1).set("getPresentationStartTimeAsDate", 20).set("getSegmentAvailabilityDuration", 20), At = [
            [
                "getConfiguration",
                "configure",
                "getConfigurationForLowLatency",
                "configurationForLowLatency"
            ]
        ], Bt = [
            [
                "isTextTrackVisible",
                "setTextTrackVisibility"
            ]
        ], Ct = "cancelTrickPlay configure configurationForLowLatency getChapters resetConfiguration retryStreaming selectAudioLanguage selectAudioTrack selectTextLanguage selectTextTrack selectVariantTrack selectVariantsByLabel selectVideoTrack setTextTrackVisibility trickPlay updateStartTime goToLive useTrickPlayTrackIfAvailable".split(" "), Dt = "addChaptersTrack addTextTrackAsync addThumbnailsTrack getAllThumbnails getChaptersAsync getThumbnails attach attachCanvas detach load unload".split(" ");
        function Et(a, b, c, d, e, f, g) {
            var h = this;
            this.H = a;
            this.K = g;
            this.l = new Bf(b);
            this.L = c;
            this.A = !1;
            this.C = d;
            this.G = e;
            this.M = f;
            this.i = this.m = !1;
            this.J = "";
            this.u = null;
            this.D = function() {
                return Ft(h);
            };
            this.F = function(k, l) {
                k = rt(l);
                switch(k.type){
                    case "event":
                        var m = k.targetName, n = Xa(k.event);
                        h.C(m, n);
                        break;
                    case "update":
                        m = k.update;
                        for(n in m){
                            k = h.g[n] || {};
                            for(var q in m[n])k[q] = m[n][q];
                        }
                        h.A && (h.L(), h.A = !1);
                        break;
                    case "asyncComplete":
                        if (q = k.id, n = k.error, l = k.res, k = h.h.get(q), h.h.delete(q), k) {
                            if (n) {
                                q = new U(n.severity, n.category, n.code);
                                for(m in n)q[m] = n[m];
                                k.reject(q);
                            } else k.resolve(l);
                        }
                }
            };
            this.g = {
                video: {},
                player: {}
            };
            this.I = 0;
            this.h = new Map;
            this.j = null;
            Gt.add(this);
        }
        p = Et.prototype;
        p.destroy = function() {
            Gt.delete(this);
            Ht(this);
            It && Jt(this);
            this.l && (this.l.stop(), this.l = null);
            this.G = this.C = null;
            this.i = this.m = !1;
            this.F = this.D = this.j = this.h = this.g = this.u = null;
            return Promise.resolve();
        };
        p.Qa = function() {
            return this.i;
        };
        p.Yf = function() {
            return this.J;
        };
        p.init = function() {
            if (this.H.length) {
                if (window1.chrome && chrome.cast && chrome.cast.isAvailable) {
                    this.m = !0;
                    this.l.La();
                    var a = new chrome.cast.SessionRequest(this.H, [], null, this.K, null);
                    a = new chrome.cast.ApiConfig(a, function(b) {
                        for(var c = u(Gt), d = c.next(); !d.done; d = c.next()){
                            d = d.value;
                            var e = b;
                            d.j = new Lg;
                            d.A = !0;
                            Kt(d, e);
                        }
                    }, function(b) {
                        for(var c = u(Gt), d = c.next(); !d.done; d = c.next())d = d.value, Lt = b == "available", d.l.La();
                    }, "origin_scoped");
                    chrome.cast.initialize(a, function() {}, function() {});
                    Lt && this.l.$(Mt);
                    (a = It) && a.status != chrome.cast.SessionStatus.STOPPED ? (this.j = new Lg, this.A = !0, Kt(this, a)) : It = null;
                } else window1.__onGCastApiAvailable !== Nt && (Ot = window1.__onGCastApiAvailable || null, window1.__onGCastApiAvailable = Nt);
            }
        };
        p.bi = function(a) {
            this.u = a;
            this.i && Pt(this, {
                type: "appData",
                appData: this.u
            });
        };
        p.cast = function() {
            var a = this;
            return Q(function(b) {
                if (!a.m) throw new U(1, 8, 8E3);
                if (!Lt) throw new U(1, 8, 8001);
                if (a.i) throw new U(1, 8, 8002);
                a.j = new Lg;
                chrome.cast.requestSession(function(c) {
                    return Kt(a, c);
                }, function(c) {
                    return Qt(a, c);
                });
                return F(b, a.j, 0);
            });
        };
        function Rt(a) {
            a.i && chrome.cast.requestSession(function(b) {
                return Kt(a, b);
            }, function(b) {
                return Qt(a, b);
            });
        }
        p.Hd = function() {
            if (this.i) {
                Ht(this);
                if (It) {
                    Jt(this);
                    try {
                        It.stop(function() {}, function() {});
                    } catch (a) {}
                    It = null;
                }
                Ft(this);
            }
        };
        p.get = function(a, b) {
            var c = this;
            if (a == "video") {
                if (wt.includes(b)) return function() {
                    return c.yj.apply(c, [
                        a,
                        b
                    ].concat(x(Ma.apply(0, arguments))));
                };
            } else if (a == "player") {
                if (zt.has(b) && !this.get("player", "isLive")()) return function() {};
                if (Ct.includes(b)) return function() {
                    return c.yj.apply(c, [
                        a,
                        b
                    ].concat(x(Ma.apply(0, arguments))));
                };
                if (Dt.includes(b)) return function() {
                    return c.gm.apply(c, [
                        a,
                        b
                    ].concat(x(Ma.apply(0, arguments))));
                };
                if (xt.has(b) || yt.has(b)) return function() {
                    return c.g[a][b];
                };
            }
            return this.g[a][b];
        };
        p.set = function(a, b, c) {
            this.g[a][b] = c;
            Pt(this, {
                type: "set",
                targetName: a,
                property: b,
                value: c
            });
        };
        function Kt(a, b) {
            var c = a.M();
            It = b;
            b.addUpdateListener(a.D);
            b.addMessageListener("urn:x-cast:com.google.shaka.v2", a.F);
            Ft(a);
            Pt(a, {
                type: "init",
                initState: c,
                appData: a.u
            });
            a.j.resolve();
        }
        function Qt(a, b) {
            var c = 8003;
            switch(b.code){
                case "cancel":
                    c = 8004;
                    break;
                case "timeout":
                    c = 8005;
                    break;
                case "receiver_unavailable":
                    c = 8006;
            }
            a.j.reject(new U(2, 8, c, b));
        }
        p.yj = function(a, b) {
            Pt(this, {
                type: "call",
                targetName: a,
                methodName: b,
                args: Ma.apply(2, arguments)
            });
        };
        p.gm = function(a, b) {
            var c = Ma.apply(2, arguments), d = new Lg, e = this.I.toString();
            this.I++;
            this.h.set(e, d);
            try {
                Pt(this, {
                    type: "asyncCall",
                    targetName: a,
                    methodName: b,
                    args: c,
                    id: e
                });
            } catch (f) {
                d.reject(f);
            }
            return d;
        };
        function Jt(a) {
            var b = It;
            b.removeUpdateListener(a.D);
            b.removeMessageListener("urn:x-cast:com.google.shaka.v2", a.F);
        }
        function Ft(a) {
            var b = It ? It.status == "connected" : !1;
            if (a.i && !b) {
                a.G();
                for(var c in a.g)a.g[c] = {};
                Ht(a);
            }
            a.i = b;
            a.J = b ? It.receiver.friendlyName : "";
            a.l.La();
        }
        function Ht(a) {
            if (a.h) for(var b = u(a.h.keys()), c = b.next(); !c.done; c = b.next()){
                c = c.value;
                var d = a.h.get(c);
                a.h.delete(c);
                d.reject(new U(1, 7, 7E3));
            }
        }
        function Pt(a, b) {
            b = qt(b);
            var c = It;
            try {
                c.sendMessage("urn:x-cast:com.google.shaka.v2", b, function() {}, db);
            } catch (d) {
                throw b = new U(2, 8, 8005, d), c = new T("error", (new Map).set("detail", b)), a.C("player", c), a.Hd(), b;
            }
        }
        var Mt = .02, Lt = !1, It = null, Ot = null, Gt = new Set;
        function Nt(a) {
            Ot ? window1.__onGCastApiAvailable = Ot : delete window1.__onGCastApiAvailable;
            Ot = null;
            if (a) for(var b = u(Gt), c = b.next(); !c.done; c = b.next())c.value.init();
            typeof window1.__onGCastApiAvailable === "function" && window1.__onGCastApiAvailable(a);
        }
        function St(a, b, c, d) {
            d = d === void 0 ? !1 : d;
            kb.call(this);
            var e = this;
            this.i = a;
            this.h = b;
            this.l = this.u = this.m = this.A = this.j = null;
            this.I = c;
            this.H = d;
            this.F = [];
            this.D = [];
            this.C = [];
            this.G = new Map;
            this.g = null;
            window1.chrome ? (this.g = new Et(c, function() {
                return Tt(e);
            }, function() {
                return Ut(e);
            }, function(f, g) {
                return Vt(e, f, g);
            }, function() {
                return Wt(e);
            }, function() {
                return Xt(e);
            }, d), Yt(this)) : (this.j = this.i, this.A = this.h);
        }
        la(St, kb);
        p = St.prototype;
        p.destroy = function(a) {
            this.g && (a === void 0 ? 0 : a) && this.g.Hd();
            this.l && (this.l.release(), this.l = null);
            a = [];
            this.h && (a.push(this.h.destroy()), this.h = null);
            this.g && (a.push(this.g.destroy()), this.g = null);
            this.A = this.j = this.i = null;
            kb.prototype.release.call(this);
            return Promise.all(a);
        };
        p.Vc = function() {
            return this.j;
        };
        p.Wb = function() {
            return this.A;
        };
        p.Kg = function() {
            return this.g ? this.g.m && Lt : !1;
        };
        p.Qa = function() {
            return this.g ? this.g.Qa() : !1;
        };
        p.Yf = function() {
            return this.g ? this.g.Yf() : "";
        };
        p.cast = function() {
            var a = this;
            return Q(function(b) {
                return b.g == 1 ? a.g ? F(b, a.g.cast(), 2) : b.return() : a.h ? F(b, a.h.tc(), 0) : b.return();
            });
        };
        p.bi = function(a) {
            this.g && this.g.bi(a);
        };
        p.Vj = function() {
            this.g && Rt(this.g);
        };
        p.Hd = function() {
            this.g && this.g.Hd();
        };
        p.Mi = function(a, b) {
            b = b === void 0 ? !1 : b;
            var c = this;
            return Q(function(d) {
                if (d.g == 1) {
                    if (a == c.I && b == c.H) return d.return();
                    c.I = a;
                    c.H = b;
                    if (!c.g) return d.return();
                    c.g.Hd();
                    return F(d, c.g.destroy(), 2);
                }
                c.g = null;
                c.g = new Et(a, function() {
                    return Tt(c);
                }, function() {
                    return Ut(c);
                }, function(e, f) {
                    return Vt(c, e, f);
                }, function() {
                    return Wt(c);
                }, function() {
                    return Xt(c);
                }, b);
                c.g.init();
                H(d);
            });
        };
        function Yt(a) {
            a.g.init();
            a.l = new Tc;
            for(var b = u(tt), c = b.next(); !c.done; c = b.next())a.l.o(a.i, c.value, function(f) {
                a.g.Qa() || (f = Xa(f), a.m.dispatchEvent(f));
            });
            for(var d in Ya)a.l.o(a.h, Ya[d], function(f) {
                a.g.Qa() || a.u.dispatchEvent(f);
            });
            a.j = {};
            b = {};
            for(var e in a.i)b = {
                we: b.we
            }, b.we = e, Object.defineProperty(a.j, b.we, {
                configurable: !1,
                enumerable: !0,
                get: function(f) {
                    return function() {
                        return Zt(a, f.we);
                    };
                }(b),
                set: function(f) {
                    return function(g) {
                        var h = f.we;
                        a.g.Qa() ? a.g.set("video", h, g) : a.i[h] = g;
                    };
                }(b)
            });
            a.A = {};
            $t(a, function(f) {
                Object.defineProperty(a.A, f, {
                    configurable: !1,
                    enumerable: !0,
                    get: function() {
                        return au(a, f);
                    }
                });
            });
            bu(a);
            a.m = new kb;
            a.m.Xe = a.j;
            a.u = new kb;
            a.u.Xe = a.A;
            a.l.o(a.h, "unloading", function() {
                a.g && a.g.Qa() || cu(a);
            });
        }
        function bu(a) {
            var b = new Map;
            $t(a, function(c, d) {
                b.has(d) ? (d = b.get(d), c.length < d.length ? a.G.set(c, d) : a.G.set(d, c)) : b.set(d, c);
            });
        }
        function $t(a, b) {
            function c(k) {
                return k == "constructor" || typeof d[k] != "function" ? !1 : !e.has(k);
            }
            var d = a.h, e = new Set, f;
            for(f in d)c(f) && (e.add(f), b(f, d[f]));
            a = Object.getPrototypeOf(d);
            for(f = Object.getPrototypeOf({}); a && a != f;){
                for(var g = u(Object.getOwnPropertyNames(a)), h = g.next(); !h.done; h = g.next())h = h.value, c(h) && (e.add(h), b(h, d[h]));
                a = Object.getPrototypeOf(a);
            }
        }
        function Xt(a) {
            var b = {
                video: {},
                player: {},
                playerAfterLoad: {},
                manifest: a.h.hd(),
                startTime: null,
                addThumbnailsTrackCalls: a.F,
                addTextTrackAsyncCalls: a.D,
                addChaptersTrackCalls: a.C
            };
            a.i.pause();
            for(var c = u(vt), d = c.next(); !d.done; d = c.next())d = d.value, b.video[d] = a.i[d];
            a.i.ended || (b.startTime = a.i.currentTime);
            c = u(At);
            for(d = c.next(); !d.done; d = c.next()){
                var e = d.value;
                d = e[1];
                e = a.h[e[0]]();
                b.player[d] = e;
            }
            c = u(Bt);
            for(d = c.next(); !d.done; d = c.next())e = d.value, d = e[1], e = a.h[e[0]](), b.playerAfterLoad[d] = e;
            return b;
        }
        function Tt(a) {
            var b = new T("caststatuschanged");
            a.dispatchEvent(b);
        }
        function Ut(a) {
            var b = new T(a.j.paused ? "pause" : "play");
            a.m.dispatchEvent(b);
        }
        function Wt(a) {
            for(var b = u(At), c = b.next(); !c.done; c = b.next()){
                var d = c.value;
                c = d[1];
                d = a.g.get("player", d[0])();
                a.h[c](d);
            }
            var e = a.F, f = a.D, g = a.C;
            cu(a);
            var h = a.g.get("player", "getAssetUri")();
            d = a.g.get("video", "ended");
            b = Promise.resolve();
            var k = a.i.autoplay;
            c = null;
            d || (c = a.g.get("video", "currentTime"));
            var l;
            (d = a.g.get("player", "getTextTracks")()) && d.length && (l = d.find(function(q) {
                return q.active;
            }));
            var m = a.g.get("player", "isTextTrackVisible")();
            h && (a.i.autoplay = !1, b = a.h.load(h, c));
            var n = {};
            c = u(vt);
            for(d = c.next(); !d.done; d = c.next())d = d.value, n[d] = a.g.get("video", d);
            b.then(function() {
                if (a.i) {
                    for(var q = u(e), r = q.next(); !r.done; r = q.next()){
                        r = r.value;
                        var t;
                        (t = a.Wb()).ef.apply(t, x(r));
                    }
                    q = u(f);
                    for(t = q.next(); !t.done; t = q.next()){
                        t = t.value;
                        var w;
                        (w = a.Wb()).ee.apply(w, x(t));
                    }
                    w = u(g);
                    for(q = w.next(); !q.done; q = w.next()){
                        q = q.value;
                        var v;
                        (v = a.Wb()).df.apply(v, x(q));
                    }
                    v = u(vt);
                    for(w = v.next(); !w.done; w = v.next())w = w.value, a.i[w] = n[w];
                    v = u(Bt);
                    for(w = v.next(); !w.done; w = v.next())q = w.value, w = q[1], q = a.g.get("player", q[0])(), a.h[w](q);
                    a.h.Zd(m);
                    l && a.h.ai(l.language, l.roles, l.forced);
                    a.i.autoplay = k;
                    h && a.i.play();
                }
            }, function(q) {
                q = (new Map).set("detail", q);
                q = new T("error", q);
                a.h.dispatchEvent(q);
            });
        }
        function Zt(a, b) {
            if (b == "addEventListener") return function(d, e, f) {
                return a.m.addEventListener(d, e, f);
            };
            if (b == "removeEventListener") return function(d, e, f) {
                return a.m.removeEventListener(d, e, f);
            };
            if (a.g.Qa() && Object.keys(a.g.g.video).length == 0) {
                var c = a.i[b];
                if (typeof c != "function") return c;
            }
            return a.g.Qa() ? a.g.get("video", b) : (b = a.i[b], typeof b == "function" && (b = b.bind(a.i)), b);
        }
        function au(a, b, c) {
            c = c === void 0 ? !1 : c;
            a.G.has(b) && (b = a.G.get(b));
            if (b == "addEventListener") return function(d, e, f) {
                return a.u.addEventListener(d, e, f);
            };
            if (b == "removeEventListener") return function(d, e, f) {
                return a.u.removeEventListener(d, e, f);
            };
            if (b == "getMediaElement") return function() {
                return a.j;
            };
            if (b == "getSharedConfiguration") return a.g.get("player", "getConfiguration");
            if (b == "getNetworkingEngine") return function() {
                return a.h.Vb();
            };
            if (b == "getDrmEngine") return function() {
                return a.h.F;
            };
            if (b == "getAdManager") return function() {
                return a.h.tf();
            };
            if (b == "getQueueManager") return function() {
                return a.h.vf();
            };
            if (b == "setVideoContainer") return function(d) {
                return a.h.ji(d);
            };
            if (!c) {
                if (b == "addThumbnailsTrack") return function() {
                    var d = Ma.apply(0, arguments);
                    a.F.push(d);
                    return au(a, b, !0).apply(null, x(d));
                };
                if (b == "addTextTrackAsync") return function() {
                    var d = Ma.apply(0, arguments);
                    a.D.push(d);
                    return au(a, b, !0).apply(null, x(d));
                };
                if (b == "addChaptersTrack") return function() {
                    var d = Ma.apply(0, arguments);
                    a.C.push(d);
                    return au(a, b, !0).apply(null, x(d));
                };
            }
            if (a.g.Qa()) {
                if (b == "getManifest" || b == "drmInfo") return function() {
                    ab(b + "() does not work while casting!");
                    return null;
                };
                if (b == "attach" || b == "detach") return function() {
                    ab(b + "() does not work while casting!");
                    return Promise.resolve();
                };
                if (b == "getChapters") return function() {
                    ab(b + "() does not work while casting!");
                    return [];
                };
            }
            return a.g.Qa() && Object.keys(a.g.g.video).length == 0 && (xt.has(b) || yt.has(b)) || !a.g.Qa() ? a.h[b].bind(a.h) : a.g.get("player", b);
        }
        function Vt(a, b, c) {
            a.g.Qa() && (b == "video" ? a.m.dispatchEvent(c) : b == "player" && (c.type == "unloading" && cu(a), a.u.dispatchEvent(c)));
        }
        function cu(a) {
            a.F = [];
            a.D = [];
            a.C = [];
        }
        S("shaka.cast.CastProxy", St);
        St.prototype.changeReceiverId = St.prototype.Mi;
        St.prototype.forceDisconnect = St.prototype.Hd;
        St.prototype.suggestDisconnect = St.prototype.Vj;
        St.prototype.setAppData = St.prototype.bi;
        St.prototype.cast = St.prototype.cast;
        St.prototype.receiverName = St.prototype.Yf;
        St.prototype.isCasting = St.prototype.Qa;
        St.prototype.canCast = St.prototype.Kg;
        St.prototype.getPlayer = St.prototype.Wb;
        St.prototype.getVideo = St.prototype.Vc;
        St.prototype.destroy = St.prototype.destroy;
        function du(a, b, c, d) {
            kb.call(this);
            var e = this;
            this.h = a;
            this.g = b;
            this.j = new Tc;
            this.I = {
                video: a,
                player: b
            };
            this.G = c || function() {};
            this.J = d || function(f) {
                return f;
            };
            this.i = null;
            this.H = !1;
            this.u = !0;
            this.m = 0;
            this.D = !1;
            this.C = !0;
            this.A = this.l = null;
            this.F = new Bf(function() {
                eu(e);
            });
            fu(this);
        }
        la(du, kb);
        p = du.prototype;
        p.isConnected = function() {
            return this.H;
        };
        p.Fl = function() {
            return this.u;
        };
        p.tm = function(a) {
            this.i = a;
        };
        p.tk = function() {
            this.i = null;
        };
        p.um = function(a) {
            this.i || (this.i = {
                metadataType: cast.receiver.media.MetadataType.GENERIC
            });
            this.i.title = a;
        };
        p.sm = function(a) {
            this.i || (this.i = {
                metadataType: cast.receiver.media.MetadataType.GENERIC
            });
            this.i.images = [
                {
                    url: a
                }
            ];
        };
        p.rm = function(a) {
            this.i || (this.i = {});
            this.i.artist = a;
            this.i.metadataType = cast.receiver.media.MetadataType.MUSIC_TRACK;
        };
        p.destroy = function() {
            var a = this, b, c;
            return Q(function(d) {
                if (d.g == 1) return a.j && (a.j.release(), a.j = null), b = [], a.g && (b.push(a.g.destroy()), a.g = null), a.F && (a.F.stop(), a.F = null), a.h = null, a.I = null, a.G = null, a.H = !1, a.u = !0, a.l = null, a.A = null, kb.prototype.release.call(a), F(d, Promise.all(b), 2);
                c = cast.receiver.CastReceiverManager.getInstance();
                c.stop();
                H(d);
            });
        };
        function fu(a) {
            var b = cast.receiver.CastReceiverManager.getInstance();
            b.onSenderConnected = function() {
                return gu(a);
            };
            b.onSenderDisconnected = function() {
                return gu(a);
            };
            b.onSystemVolumeChanged = function() {
                var e = cast.receiver.CastReceiverManager.getInstance().getSystemVolume();
                e && hu(a, {
                    type: "update",
                    update: {
                        video: {
                            volume: e.level,
                            muted: e.muted
                        }
                    }
                }, a.l);
                hu(a, {
                    type: "event",
                    targetName: "video",
                    event: {
                        type: "volumechange"
                    }
                }, a.l);
            };
            a.A = b.getCastMessageBus("urn:x-cast:com.google.cast.media");
            a.A.onMessage = function(e) {
                return iu(a, e);
            };
            a.l = b.getCastMessageBus("urn:x-cast:com.google.shaka.v2");
            a.l.onMessage = function(e) {
                return ju(a, e);
            };
            b.start();
            b = u(tt);
            for(var c = b.next(); !c.done; c = b.next())a.j.o(a.h, c.value, function(e) {
                return ku(a, "video", e);
            });
            for(var d in Ya)a.j.o(a.g, Ya[d], function(e) {
                return ku(a, "player", e);
            });
            a.j.o(a.h, "loadeddata", function() {
                a.D = !0;
            });
            a.j.o(a.g, "loading", function() {
                a.u = !1;
                lu(a);
            });
            a.j.o(a.h, "playing", function() {
                a.u = !1;
                lu(a);
            });
            a.j.o(a.h, "pause", function() {
                lu(a);
            });
            a.j.o(a.g, "unloading", function() {
                a.u = !0;
                lu(a);
            });
            a.j.o(a.h, "ended", function() {
                new Bf(function() {
                    a.h && a.h.ended && (a.u = !0, lu(a));
                }).$(mu);
            });
        }
        function gu(a) {
            a.m = 0;
            a.C = !0;
            a.H = cast.receiver.CastReceiverManager.getInstance().getSenders().length != 0;
            lu(a);
        }
        function lu(a) {
            var b;
            Q(function(c) {
                if (c.g == 1) return F(c, Promise.resolve(), 2);
                if (!a.g) return c.return();
                b = new T("caststatuschanged");
                a.dispatchEvent(b);
                nu(a) || ou(a);
                H(c);
            });
        }
        function pu(a, b, c) {
            var d, e, f, g, h, k, l, m, n, q, r, t, w, v, z, y, A, C, E;
            Q(function(D) {
                switch(D.g){
                    case 1:
                        for(d in b.player)e = b.player[d], a.g[d](e);
                        a.G(c);
                        f = a.h.autoplay;
                        return b.manifest ? (a.h.autoplay = !1, ra(D, 5), F(D, a.g.load(b.manifest, b.startTime), 7)) : F(D, Promise.resolve(), 3);
                    case 7:
                        if (b.addThumbnailsTrackCalls) for(g = u(b.addThumbnailsTrackCalls), h = g.next(); !h.done; h = g.next())k = h.value, a.g.ef.apply(a.g, x(k));
                        if (b.addTextTrackAsyncCalls) for(l = u(b.addTextTrackAsyncCalls), m = l.next(); !m.done; m = l.next())n = m.value, a.g.ee.apply(a.g, x(n));
                        if (b.addChaptersTrackCalls) for(q = u(b.addChaptersTrackCalls), r = q.next(); !r.done; r = q.next())t = r.value, a.g.df.apply(a.g, x(t));
                        ta(D, 3);
                        break;
                    case 5:
                        return w = ua(D), v = (new Map).set("detail", w), z = new T("error", v), a.g && a.g.dispatchEvent(z), D.return();
                    case 3:
                        if (!a.g) return D.return();
                        for(y in b.video)A = b.video[y], a.h[y] = A;
                        for(C in b.playerAfterLoad)E = b.playerAfterLoad[C], a.g[C](E);
                        a.h.autoplay = f;
                        b.manifest && (a.h.play(), ou(a));
                        H(D);
                }
            });
        }
        function ku(a, b, c) {
            a.g && (eu(a), hu(a, {
                type: "event",
                targetName: b,
                event: c
            }, a.l));
        }
        function eu(a) {
            a.F.$(qu);
            for(var b = {
                video: {},
                player: {}
            }, c = u(ut), d = c.next(); !d.done; d = c.next())d = d.value, b.video[d] = a.h[d];
            a.g.U() && zt.forEach(function(e, f) {
                a.m % e == 0 && (b.player[f] = a.g[f]());
            });
            xt.forEach(function(e, f) {
                a.m % e == 0 && (b.player[f] = a.g[f]());
            });
            if (c = cast.receiver.CastReceiverManager.getInstance().getSystemVolume()) b.video.volume = c.level, b.video.muted = c.muted;
            hu(a, {
                type: "update",
                update: b
            }, a.l);
            yt.forEach(function(e, f) {
                a.m % e == 0 && (e = {
                    player: {}
                }, e.player[f] = a.g[f](), hu(a, {
                    type: "update",
                    update: e
                }, a.l));
            });
            a.D && (a.m += 1);
            nu(a);
        }
        function nu(a) {
            return a.C && (a.h.duration || a.g.U()) ? (ru(a), a.C = !1, !0) : !1;
        }
        function ru(a, b) {
            var c = {
                contentId: a.g.hd(),
                streamType: a.g.U() ? "LIVE" : "BUFFERED",
                contentType: ""
            };
            a.g.U() || (c.duration = a.h.duration);
            a.i && (c.metadata = a.i);
            ou(a, b === void 0 ? 0 : b, c);
        }
        function ju(a, b) {
            var c = rt(b.data);
            switch(c.type){
                case "init":
                    a.m = 0;
                    a.D = !1;
                    a.C = !0;
                    pu(a, c.initState, c.appData);
                    eu(a);
                    break;
                case "appData":
                    a.G(c.appData);
                    break;
                case "set":
                    var d = c.targetName, e = c.property;
                    c = c.value;
                    if (d == "video") {
                        if (b = cast.receiver.CastReceiverManager.getInstance(), e == "volume") {
                            b.setSystemVolumeLevel(c);
                            break;
                        } else if (e == "muted") {
                            b.setSystemVolumeMuted(c);
                            break;
                        }
                    }
                    a.I[d][e] = c;
                    break;
                case "call":
                    d = a.I[c.targetName];
                    d[c.methodName].apply(d, c.args);
                    break;
                case "asyncCall":
                    d = c.targetName;
                    e = c.methodName;
                    d == "player" && e == "load" && (a.m = 0, a.D = !1);
                    var f = c.id, g = b.senderId;
                    b = a.I[d];
                    c = b[e].apply(b, c.args);
                    d == "player" && e == "load" && (c = c.then(function() {
                        a.C = !0;
                    }));
                    c.then(function(h) {
                        return su(a, g, f, null, h);
                    }, function(h) {
                        return su(a, g, f, h, null);
                    });
            }
        }
        function iu(a, b) {
            var c = rt(b.data);
            switch(c.type){
                case "PLAY":
                    a.h.play();
                    ou(a);
                    break;
                case "PAUSE":
                    a.h.pause();
                    ou(a);
                    break;
                case "SEEK":
                    b = c.currentTime;
                    var d = c.resumeState;
                    b != null && (a.h.currentTime = Number(b));
                    d && d == "PLAYBACK_START" ? (a.h.play(), ou(a)) : d && d == "PLAYBACK_PAUSE" && (a.h.pause(), ou(a));
                    break;
                case "STOP":
                    a.g.tc().then(function() {
                        a.g && ou(a);
                    });
                    break;
                case "GET_STATUS":
                    ru(a, Number(c.requestId));
                    break;
                case "VOLUME":
                    d = c.volume;
                    b = d.level;
                    d = d.muted;
                    var e = a.h.volume, f = a.h.muted;
                    b != null && (a.h.volume = Number(b));
                    d != null && (a.h.muted = d);
                    e == a.h.volume && f == a.h.muted || ou(a);
                    break;
                case "LOAD":
                    a.m = 0;
                    a.D = !1;
                    a.C = !1;
                    b = c.media;
                    d = c.currentTime;
                    e = a.J(b.contentId);
                    f = c.autoplay || !0;
                    a.G(b.customData);
                    f && (a.h.autoplay = !0);
                    a.g.load(e, d).then(function() {
                        a.g && ru(a);
                    }).catch(function(g) {
                        var h = "LOAD_FAILED";
                        g.category == 7 && g.code == 7E3 && (h = "LOAD_CANCELLED");
                        hu(a, {
                            requestId: Number(c.requestId),
                            type: h
                        }, a.A);
                    });
                    break;
                default:
                    hu(a, {
                        requestId: Number(c.requestId),
                        type: "INVALID_REQUEST",
                        reason: "INVALID_COMMAND"
                    }, a.A);
            }
        }
        function su(a, b, c, d, e) {
            a.g && hu(a, {
                type: "asyncComplete",
                id: c,
                error: d,
                res: e
            }, a.l, b);
        }
        function hu(a, b, c, d) {
            a.H && (a = qt(b), d ? c.getCastChannel(d).send(a) : c.broadcast(a));
        }
        function ou(a, b, c) {
            c = c === void 0 ? null : c;
            var d = {
                mediaSessionId: 0,
                playbackRate: a.h.playbackRate,
                playerState: a.u ? tu : a.g.Cf() ? uu : a.h.paused ? vu : wu,
                currentTime: a.h.currentTime,
                supportedMediaCommands: 63,
                volume: {
                    level: a.h.volume,
                    muted: a.h.muted
                }
            };
            c && (d.media = c);
            hu(a, {
                requestId: b === void 0 ? 0 : b,
                type: "MEDIA_STATUS",
                status: [
                    d
                ]
            }, a.A);
        }
        S("shaka.cast.CastReceiver", du);
        du.prototype.destroy = du.prototype.destroy;
        du.prototype.setContentArtist = du.prototype.rm;
        du.prototype.setContentImage = du.prototype.sm;
        du.prototype.setContentTitle = du.prototype.um;
        du.prototype.clearContentMetadata = du.prototype.tk;
        du.prototype.setContentMetadata = du.prototype.tm;
        du.prototype.isIdle = du.prototype.Fl;
        du.prototype.isConnected = du.prototype.isConnected;
        var qu = .5, mu = 5, tu = "IDLE", wu = "PLAYING", uu = "BUFFERING", vu = "PAUSED";
        function xu(a, b, c, d, e) {
            if (d >= e) return null;
            for(var f = -1, g = -1, h = 0; h < c.length; h++)if (c[h].some(function(C) {
                return C != null && C.g.trim() != "";
            })) {
                f = h;
                break;
            }
            for(h = c.length - 1; h >= 0; h--)if (c[h].some(function(C) {
                return C != null && C.g.trim() != "";
            })) {
                g = h;
                break;
            }
            if (f === -1 || g === -1) return null;
            for(var k = h = !1, l = "white", m = "black", n = yu(d, e, h, k, l, m); f <= g; f++){
                for(var q = c[f], r = -1, t = -1, w = 0; w < q.length; w++)if (q[w] != null && q[w].g.trim() !== "") {
                    r = w;
                    break;
                }
                for(w = q.length - 1; w >= 0; w--)if (q[w] != null && q[w].g.trim() !== "") {
                    t = w;
                    break;
                }
                if (r === -1 || t === -1) q = zu(d, e), a.nestedCues.push(q);
                else {
                    for(; r <= t; r++)if (w = q[r]) {
                        var v = w.l, z = w.i, y = w.j, A = w.h;
                        if (v != h || z != k || y != l || A != m) n.payload && a.nestedCues.push(n), n = yu(d, e, v, z, y, A), h = v, k = z, l = y, m = A;
                        n.payload += w.g;
                    } else n.payload += " ";
                    n.payload && a.nestedCues.push(n);
                    f !== g && (n = zu(d, e), a.nestedCues.push(n));
                    n = yu(d, e, h, k, l, m);
                }
            }
            return a.nestedCues.length ? {
                cue: a,
                stream: b
            } : null;
        }
        function yu(a, b, c, d, e, f) {
            a = new re(a, b, "");
            c && a.textDecoration.push(Qe);
            d && (a.fontStyle = Pe);
            a.color = e;
            a.backgroundColor = f;
            return a;
        }
        function zu(a, b) {
            a = new re(a, b, "");
            a.lineBreak = !0;
            return a;
        }
        function Au(a, b, c, d, e) {
            this.g = a;
            this.l = b;
            this.i = c;
            this.h = d;
            this.j = e;
        }
        function Bu(a, b) {
            this.i = [];
            this.g = 1;
            this.h = 0;
            this.F = a;
            this.D = b;
            this.j = this.m = !1;
            this.l = "white";
            this.u = "black";
            this.A = this.C = null;
            Cu(this);
        }
        function Du(a, b, c) {
            var d = "CC" + ((a.F << 1 | a.D) + 1), e = new re(b, c, "");
            e.lineInterpretation = 1;
            var f = Eu.get(a.g);
            f && (e.line = f);
            a.A != null && a.C != null && (e.position = 10 + Math.min(70, a.A * 10) + a.C * 2.5);
            (b = xu(e, d, a.i, b, c)) && a.g + b.cue.nestedCues.length - 3 > 15 && (f = Eu.get(a.g + 3 - b.cue.nestedCues.length)) && (e.line = f);
            return b;
        }
        function Cu(a) {
            Fu(a, 0, 15);
            a.g = 1;
        }
        function Gu(a, b, c) {
            if (!(c < 32 || c > 127)) {
                var d = "";
                switch(b){
                    case 0:
                        d = Hu.has(c) ? Hu.get(c) : String.fromCharCode(c);
                        break;
                    case 1:
                        d = Iu.get(c);
                        break;
                    case 2:
                        a.i[a.g].pop();
                        d = Ju.get(c);
                        break;
                    case 3:
                        a.i[a.g].pop(), d = Ku.get(c);
                }
                d && a.i[a.g].push(new Au(d, a.m, a.j, a.u, a.l));
            }
        }
        function Lu(a, b, c, d) {
            if (!(c < 0 || b < 0)) {
                if (b >= c) for(--d; d >= 0; d--)a.i[b + d] = a.i[c + d].map(function(f) {
                    return f;
                });
                else for(var e = 0; e < d; e++)a.i[b + e] = a.i[c + e].map(function(f) {
                    return f;
                });
            }
        }
        function Fu(a, b, c) {
            for(var d = 0; d <= c; d++)a.i[b + d] = [];
        }
        var Hu = new Map([
            [
                39,
                "\u2019"
            ],
            [
                42,
                "\u00e1"
            ],
            [
                92,
                "\u00e9"
            ],
            [
                92,
                "\u00e9"
            ],
            [
                94,
                "\u00ed"
            ],
            [
                95,
                "\u00f3"
            ],
            [
                96,
                "\u00fa"
            ],
            [
                123,
                "\u00e7"
            ],
            [
                124,
                "\u00f7"
            ],
            [
                125,
                "\u00d1"
            ],
            [
                126,
                "\u00f1"
            ],
            [
                127,
                "\u2588"
            ]
        ]), Iu = new Map([
            [
                48,
                "\u00ae"
            ],
            [
                49,
                "\u00b0"
            ],
            [
                50,
                "\u00bd"
            ],
            [
                51,
                "\u00bf"
            ],
            [
                52,
                "\u2122"
            ],
            [
                53,
                "\u00a2"
            ],
            [
                54,
                "\u00a3"
            ],
            [
                55,
                "\u266a"
            ],
            [
                56,
                "\u00e0"
            ],
            [
                57,
                " "
            ],
            [
                58,
                "\u00e8"
            ],
            [
                59,
                "\u00e2"
            ],
            [
                60,
                "\u00ea"
            ],
            [
                61,
                "\u00ee"
            ],
            [
                62,
                "\u00f4"
            ],
            [
                63,
                "\u00fb"
            ]
        ]), Ju = new Map([
            [
                32,
                "\u00c1"
            ],
            [
                33,
                "\u00c9"
            ],
            [
                34,
                "\u00d3"
            ],
            [
                35,
                "\u00da"
            ],
            [
                36,
                "\u00dc"
            ],
            [
                37,
                "\u00fc"
            ],
            [
                38,
                "\u2018"
            ],
            [
                39,
                "\u00a1"
            ],
            [
                40,
                "*"
            ],
            [
                41,
                "'"
            ],
            [
                42,
                "\u2500"
            ],
            [
                43,
                "\u00a9"
            ],
            [
                44,
                "\u2120"
            ],
            [
                45,
                "\u00b7"
            ],
            [
                46,
                "\u201c"
            ],
            [
                47,
                "\u201d"
            ],
            [
                48,
                "\u00c0"
            ],
            [
                49,
                "\u00c2"
            ],
            [
                50,
                "\u00c7"
            ],
            [
                51,
                "\u00c8"
            ],
            [
                52,
                "\u00ca"
            ],
            [
                53,
                "\u00cb"
            ],
            [
                54,
                "\u00eb"
            ],
            [
                55,
                "\u00ce"
            ],
            [
                56,
                "\u00cf"
            ],
            [
                57,
                "\u00ef"
            ],
            [
                58,
                "\u00d4"
            ],
            [
                59,
                "\u00d9"
            ],
            [
                60,
                "\u00f9"
            ],
            [
                61,
                "\u00db"
            ],
            [
                62,
                "\u00ab"
            ],
            [
                63,
                "\u00bb"
            ]
        ]), Ku = new Map([
            [
                32,
                "\u00c3"
            ],
            [
                33,
                "\u00e3"
            ],
            [
                34,
                "\u00cd"
            ],
            [
                35,
                "\u00cc"
            ],
            [
                36,
                "\u00ec"
            ],
            [
                37,
                "\u00d2"
            ],
            [
                38,
                "\u00f2"
            ],
            [
                39,
                "\u00d5"
            ],
            [
                40,
                "\u00f5"
            ],
            [
                41,
                "{"
            ],
            [
                42,
                "}"
            ],
            [
                43,
                "\\"
            ],
            [
                44,
                "^"
            ],
            [
                45,
                "_"
            ],
            [
                46,
                "|"
            ],
            [
                47,
                "~"
            ],
            [
                48,
                "\u00c4"
            ],
            [
                49,
                "\u00e4"
            ],
            [
                50,
                "\u00d6"
            ],
            [
                51,
                "\u00f6"
            ],
            [
                52,
                "\u00df"
            ],
            [
                53,
                "\u00a5"
            ],
            [
                54,
                "\u00a4"
            ],
            [
                55,
                "\u2502"
            ],
            [
                56,
                "\u00c5"
            ],
            [
                57,
                "\u00e5"
            ],
            [
                58,
                "\u00d8"
            ],
            [
                59,
                "\u00f8"
            ],
            [
                60,
                "\u250c"
            ],
            [
                61,
                "\u2510"
            ],
            [
                62,
                "\u2514"
            ],
            [
                63,
                "\u2518"
            ]
        ]), Eu = new Map([
            [
                1,
                10
            ],
            [
                2,
                15.33
            ],
            [
                3,
                20.66
            ],
            [
                4,
                26
            ],
            [
                5,
                31.33
            ],
            [
                6,
                36.66
            ],
            [
                7,
                42
            ],
            [
                8,
                47.33
            ],
            [
                9,
                52.66
            ],
            [
                10,
                58
            ],
            [
                11,
                63.33
            ],
            [
                12,
                68.66
            ],
            [
                13,
                74
            ],
            [
                14,
                79.33
            ],
            [
                15,
                84.66
            ]
        ]);
        function Mu(a, b) {
            this.h = 0;
            this.u = new Bu(a, b);
            this.i = new Bu(a, b);
            this.g = this.j = new Bu(a, b);
            this.l = 0;
            this.m = null;
        }
        function Nu(a, b, c) {
            a.g = a.i;
            var d = a.g, e = null;
            a.h !== 3 && a.h !== 4 && (e = Du(d, a.l, c), c = a.i, c.g = c.h > 0 ? c.h : 0, Fu(c, 0, 15), c = a.j, c.g = c.h > 0 ? c.h : 0, Fu(c, 0, 15), d.g = 15);
            a.h = 3;
            d.h = b;
            return e;
        }
        function Ou(a) {
            a.h = 1;
            a.g = a.j;
            a.g.h = 0;
        }
        function Pu(a) {
            bb("Cea608DataChannel", "CEA-608 text mode entered, but is unsupported");
            a.g = a.u;
            a.h = 4;
        }
        var Qu = "black green blue cyan red yellow magenta black".split(" "), Ru = "white green blue cyan red yellow magenta white_italics".split(" ");
        function Su(a, b) {
            this.J = b;
            this.M = a;
            this.K = this.l = !1;
            this.m = this.u = this.H = this.L = this.I = 0;
            this.G = 2;
            this.i = [];
            this.g = this.h = this.j = 0;
            this.F = this.C = !1;
            this.D = "white";
            this.A = "black";
            Tu(this);
        }
        function Tu(a) {
            a.i = [];
            for(var b = 0; b < 16; b++)a.i.push(Uu());
        }
        function Uu() {
            for(var a = [], b = 0; b < 42; b++)a.push(null);
            return a;
        }
        function Vu(a, b) {
            Wu(a) && (a.i[a.h][a.g] = new Au(b, a.F, a.C, a.A, a.D), a.g++);
        }
        function Wu(a) {
            var b = a.g < a.m && a.g >= 0;
            return a.h < a.u && a.h >= 0 && b;
        }
        Su.prototype.isVisible = function() {
            return this.l;
        };
        function Xu(a) {
            for(var b = 0, c = 1; c < 16; c++, b++)a.i[b] = a.i[c];
            for(c = 0; c < 1; c++, b++)a.i[b] = Uu();
        }
        function Yu(a, b, c) {
            var d = new re(a.j, b, "");
            d.textAlign = a.G === 0 ? "left" : a.G === 1 ? "right" : te;
            var e = d.region;
            a.J && (e.id += "svc" + a.J);
            e.id += "win" + a.M;
            e.height = a.u;
            e.width = a.m;
            e.heightUnits = 2;
            e.widthUnits = 2;
            e.viewportAnchorX = a.I;
            e.viewportAnchorY = a.L;
            e.viewportAnchorUnits = a.K ? ud : 2;
            switch(a.H){
                case 0:
                    e.regionAnchorX = 0;
                    e.regionAnchorY = 0;
                    break;
                case 1:
                    e.regionAnchorX = 50;
                    e.regionAnchorY = 0;
                    break;
                case 2:
                    e.regionAnchorX = 100;
                    e.regionAnchorY = 0;
                    break;
                case 3:
                    e.regionAnchorX = 0;
                    e.regionAnchorY = 50;
                    break;
                case 4:
                    e.regionAnchorX = 50;
                    e.regionAnchorY = 50;
                    break;
                case 5:
                    e.regionAnchorX = 100;
                    e.regionAnchorY = 50;
                    break;
                case 6:
                    e.regionAnchorX = 0;
                    e.regionAnchorY = 100;
                    break;
                case 7:
                    e.regionAnchorX = 50;
                    e.regionAnchorY = 100;
                    break;
                case 8:
                    e.regionAnchorX = 100, e.regionAnchorY = 100;
            }
            if (c = xu(d, "svc" + c, a.i, a.j, b)) a.j = b;
            return c;
        }
        Su.prototype.display = function() {
            this.l = !0;
        };
        function Zu() {
            this.i = [];
            this.h = null;
            this.g = 0;
        }
        function $u(a, b) {
            b.type === 3 ? (a.g = (b.value & 63) * 2 - 1, a.h = []) : a.h && (a.g > 0 && (a.h.push(b), a.g--), a.g === 0 && (a.i.push(new av(a.h)), a.h = null, a.g = 0));
        }
        function av(a) {
            this.g = 0;
            this.h = a;
        }
        av.prototype.Pa = function() {
            return this.g < this.h.length;
        };
        av.prototype.Wa = function() {
            return this.g;
        };
        function bv(a) {
            if (!a.Pa()) throw new U(2, 2, 3E3);
            return a.h[a.g++];
        }
        av.prototype.skip = function(a) {
            if (this.g + a > this.h.length) throw new U(2, 2, 3E3);
            this.g += a;
        };
        av.prototype.Dj = function(a) {
            if (this.g - a < 0) throw new U(2, 2, 3E3);
            this.g -= a;
        };
        function cv(a) {
            this.i = a;
            this.h = [
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null
            ];
            this.g = null;
        }
        function dv(a, b, c, d) {
            if (!a.g) return [];
            if (c == 24) return c = bv(b).value, d = bv(b).value, c = function(f) {
                return f.map(function(g) {
                    return ("0" + (g & 255).toString(16)).slice(-2);
                }).join("");
            }([
                c,
                d
            ]), Vu(a.g, String.fromCharCode(parseInt(c, 16))), [];
            b = a.g;
            var e = null;
            switch(c){
                case 8:
                    !Wu(b) || b.g <= 0 && b.h <= 0 || (b.g <= 0 ? (b.g = b.m - 1, b.h--) : b.g--, b.i[b.h][b.g] = null);
                    break;
                case 13:
                    b.isVisible() && (e = Yu(b, d, a.i));
                    b.h + 1 >= b.u ? Xu(b) : b.h++;
                    b.g = 0;
                    break;
                case 14:
                    b.isVisible() && (e = Yu(b, d, a.i));
                    b.i[b.h] = Uu();
                    b.g = 0;
                    break;
                case 12:
                    b.isVisible() && (e = Yu(b, d, a.i)), Tu(b), b.h = 0, b.g = 0;
            }
            return e ? [
                e
            ] : [];
        }
        function ev(a, b, c, d) {
            if (c >= 128 && c <= 135) d = c & 7, a.h[d] && (a.g = a.h[d]);
            else {
                if (c === 136) {
                    c = bv(b).value;
                    b = [];
                    c = u(fv(a, c));
                    for(var e = c.next(); !e.done; e = c.next()){
                        e = a.h[e.value];
                        if (e.isVisible()) {
                            var f = Yu(e, d, a.i);
                            f && b.push(f);
                        }
                        Tu(e);
                    }
                    return b;
                }
                if (c === 137) for(b = bv(b).value, b = u(fv(a, b)), c = b.next(); !c.done; c = b.next())c = a.h[c.value], c.isVisible() || (c.j = d), c.display();
                else {
                    if (c === 138) {
                        c = bv(b).value;
                        b = null;
                        c = u(fv(a, c));
                        for(e = c.next(); !e.done; e = c.next())e = a.h[e.value], e.isVisible() && (b = Yu(e, d, a.i)), e.l = !1;
                        return b ? [
                            b
                        ] : [];
                    }
                    if (c === 139) {
                        c = bv(b).value;
                        b = null;
                        c = u(fv(a, c));
                        for(e = c.next(); !e.done; e = c.next())e = a.h[e.value], e.isVisible() ? b = Yu(e, d, a.i) : e.j = d, e.l = !e.l;
                        return b ? [
                            b
                        ] : [];
                    }
                    if (c === 140) return b = bv(b).value, gv(a, b, d);
                    if (c === 143) return d = gv(a, 255, d), hv(a), d;
                    if (c === 144) b.skip(1), d = bv(b).value, a.g && (a.g.C = (d & 128) > 0, a.g.F = (d & 64) > 0);
                    else if (c === 145) d = bv(b).value, c = bv(b).value, b.skip(1), a.g && (b = iv((c & 48) >> 4, (c & 12) >> 2, c & 3), a.g.D = iv((d & 48) >> 4, (d & 12) >> 2, d & 3), a.g.A = b);
                    else if (c === 146) d = bv(b).value, b = bv(b).value, a.g && (a = a.g, a.h = d & 15, a.g = b & 63);
                    else if (c === 151) b.skip(1), b.skip(1), d = bv(b).value, b.skip(1), a.g && (a.g.G = d & 3);
                    else if (c >= 152 && c <= 159) {
                        c = (c & 15) - 8;
                        e = a.h[c] !== null;
                        e || (f = new Su(c, a.i), f.j = d, a.h[c] = f);
                        d = bv(b).value;
                        f = bv(b).value;
                        var g = bv(b).value, h = bv(b).value, k = bv(b).value;
                        b = bv(b).value;
                        e && (b & 7) === 0 || (b = a.h[c], b.h = 0, b.g = 0, b.F = !1, b.C = !1, b.D = "white", b.A = "black");
                        b = a.h[c];
                        b.l = (d & 32) > 0;
                        b.L = f & 127;
                        b.I = g;
                        b.H = (h & 240) >> 4;
                        b.K = (f & 128) > 0;
                        b.u = (h & 15) + 1;
                        b.m = (k & 63) + 1;
                        a.g = a.h[c];
                    }
                }
            }
            return [];
        }
        function fv(a, b) {
            for(var c = [], d = 0; d < 8; d++)(b & 1) === 1 && a.h[d] && c.push(d), b >>= 1;
            return c;
        }
        function gv(a, b, c) {
            var d = [];
            b = u(fv(a, b));
            for(var e = b.next(); !e.done; e = b.next()){
                e = e.value;
                var f = a.h[e];
                f.isVisible() && (f = Yu(f, c, a.i)) && d.push(f);
                a.h[e] = null;
            }
            return d;
        }
        function hv(a) {
            a.g = null;
            a.h = [
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null
            ];
        }
        function iv(a, b, c) {
            var d = {
                0: 0,
                1: 0,
                2: 1,
                3: 1
            };
            a = d[a];
            b = d[b];
            c = d[c];
            return jv[a << 2 | b << 1 | c];
        }
        var kv = new Map([
            [
                32,
                " "
            ],
            [
                33,
                "\u00a0"
            ],
            [
                37,
                "\u2026"
            ],
            [
                42,
                "\u0160"
            ],
            [
                44,
                "\u0152"
            ],
            [
                48,
                "\u2588"
            ],
            [
                49,
                "\u2018"
            ],
            [
                50,
                "\u2019"
            ],
            [
                51,
                "\u201c"
            ],
            [
                52,
                "\u201d"
            ],
            [
                53,
                "\u2022"
            ],
            [
                57,
                "\u2122"
            ],
            [
                58,
                "\u0161"
            ],
            [
                60,
                "\u0153"
            ],
            [
                61,
                "\u2120"
            ],
            [
                63,
                "\u0178"
            ],
            [
                118,
                "\u215b"
            ],
            [
                119,
                "\u215c"
            ],
            [
                120,
                "\u215d"
            ],
            [
                121,
                "\u215e"
            ],
            [
                122,
                "\u2502"
            ],
            [
                123,
                "\u2510"
            ],
            [
                124,
                "\u2514"
            ],
            [
                125,
                "\u2500"
            ],
            [
                126,
                "\u2518"
            ],
            [
                127,
                "\u250c"
            ]
        ]), jv = "black blue green cyan red magenta yellow white".split(" ");
        function lv() {
            this.h = [];
            this.g = [];
            this.i = new Zu;
            this.l = 0;
            this.m = new Map([
                [
                    "CC1",
                    new Mu(0, 0)
                ],
                [
                    "CC2",
                    new Mu(0, 1)
                ],
                [
                    "CC3",
                    new Mu(1, 0)
                ],
                [
                    "CC4",
                    new Mu(1, 1)
                ]
            ]);
            this.A = this.u = 0;
            this.j = new Map;
            this.D = !0;
            this.C = new Set;
            mv(this);
        }
        lv.prototype.clear = function() {
            this.l = 0;
            this.h = [];
            this.g = [];
            var a = this.i;
            a.i = [];
            a.h = [];
            a.g = 0;
            mv(this);
            a = u(this.j.values());
            for(var b = a.next(); !b.done; b = a.next())hv(b.value);
        };
        function mv(a) {
            a.u = 0;
            a.A = 0;
            for(var b = u(a.m.values()), c = b.next(); !c.done; c = b.next())c = c.value, c.h = 0, c.g = c.j, c.m = null, Cu(c.i), Cu(c.j), Cu(c.u);
            a.D = !0;
        }
        lv.prototype.extract = function(a, b) {
            if (this.D) {
                for(var c = u(this.m.values()), d = c.next(); !d.done; d = c.next())d.value.l = b;
                this.D = !1;
            }
            a = new lh(a, 0);
            if (!(a.getLength() < 8) && a.ba() === 181 && a.Ha() === 49 && a.Z() === 1195456820 && a.ba() === 3 && (c = a.ba(), (c & 64) !== 0)) for(c &= 31, a.skip(1), d = 0; d < c; d++){
                var e = a.ba(), f = (e & 4) >> 2, g = a.ba(), h = a.ba();
                f && (e &= 3, e === 0 || e === 1 ? this.h.push({
                    pts: b,
                    type: e,
                    Ib: g,
                    vc: h,
                    order: this.h.length
                }) : (this.g.push({
                    pts: b,
                    type: e,
                    value: g,
                    order: this.g.length
                }), this.g.push({
                    pts: b,
                    type: 2,
                    value: h,
                    order: this.g.length
                })));
            }
        };
        lv.prototype.decode = function() {
            function a(e, f) {
                return e.pts - f.pts || e.order - f.order;
            }
            var b = [];
            this.h.sort(a);
            this.g.sort(a);
            for(var c = u(this.h), d = c.next(); !d.done; d = c.next())(d = nv(this, d.value)) && b.push(d);
            c = u(this.g);
            for(d = c.next(); !d.done; d = c.next())$u(this.i, d.value);
            c = u(this.i.i);
            for(d = c.next(); !d.done; d = c.next())d = ov(this, d.value), b.push.apply(b, x(d));
            this.i.i = [];
            this.h = [];
            this.g = [];
            return b;
        };
        function nv(a, b) {
            var c = b.type;
            if ((b.Ib & 112) === 16) {
                var d = b.Ib >> 3 & 1;
                c === 0 ? a.u = d : a.A = d;
            }
            d = "CC" + ((c << 1 | (c ? a.A : a.u)) + 1);
            c = a.m.get(d);
            if (b.Ib === 255 && b.vc === 255 || !b.Ib && !b.vc || !pv(b.Ib) || !pv(b.vc)) return ++a.l >= 45 && mv(a), null;
            a.l = 0;
            b.Ib &= 127;
            b.vc &= 127;
            var e = b.Ib;
            if (e >= 1 && e <= 15 || !b.Ib && !b.vc) return null;
            e = null;
            if ((b.Ib & 112) === 16) a: {
                a.C.add(d), d = b.Ib;
                a = b.vc;
                if (c.m === (d << 8 | a)) c.m = null;
                else if (c.m = d << 8 | a, (d & 240) === 16 && (a & 192) === 64) {
                    b = [
                        11,
                        11,
                        1,
                        2,
                        3,
                        4,
                        12,
                        13,
                        14,
                        15,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10
                    ][(d & 7) << 1 | a >> 5 & 1];
                    d = "white";
                    e = !1;
                    var f = null;
                    var g = a > 95 ? a - 96 : a - 64;
                    g <= 13 ? d = Ru[Math.floor(g / 2)] : g <= 15 ? e = !0 : f = Math.floor((g - 16) / 2);
                    a = (a & 1) === 1;
                    c.h !== 4 && (g = c.g, c.h === 3 && b !== g.g && (c = 1 + b - g.h, Lu(g, c, 1 + g.g - g.h, g.h), Fu(g, 0, c - 1), Fu(g, b + 1, 15 - b)), g.g = b, g.m = a, g.j = e, g.l = d, g.A = f, g.u = "black");
                } else if ((d & 247) === 17 && (a & 240) === 32) c.g.m = !1, c.g.j = !1, c.g.l = "white", Gu(c.g, 0, 32), d = !1, b = Ru[(a & 14) >> 1], b === "white_italics" && (b = "white", d = !0), c.g.m = (a & 1) === 1, c.g.j = d, c.g.l = b;
                else if ((d & 247) === 16 && (a & 240) === 32 || (d & 247) === 23 && (a & 255) === 45) b = "black", (d & 7) === 0 && (b = Qu[(a & 14) >> 1]), c.g.u = b;
                else if ((d & 247) === 17 && (a & 240) === 48) Gu(c.g, 1, a);
                else if ((d & 246) === 18 && (a & 224) === 32) Gu(c.g, d & 1 ? 3 : 2, a);
                else {
                    if ((d & 246) === 20 && (a & 240) === 32) {
                        a = b.pts;
                        d = null;
                        switch(b.vc){
                            case 32:
                                Ou(c);
                                break;
                            case 33:
                                c = c.g;
                                c.i[c.g].pop();
                                break;
                            case 37:
                                d = Nu(c, 2, a);
                                break;
                            case 38:
                                d = Nu(c, 3, a);
                                break;
                            case 39:
                                d = Nu(c, 4, a);
                                break;
                            case 40:
                                Gu(c.g, 0, 32);
                                break;
                            case 41:
                                c.h = 2;
                                c.g = c.i;
                                c.g.h = 0;
                                c.l = a;
                                break;
                            case 42:
                                Cu(c.u);
                                Pu(c);
                                break;
                            case 43:
                                Pu(c);
                                break;
                            case 44:
                                b = c.i;
                                d = null;
                                c.h !== 4 && (d = Du(b, c.l, a));
                                Fu(b, 0, 15);
                                break;
                            case 45:
                                b = c.g;
                                c.h !== 3 ? d = null : (d = Du(b, c.l, a), e = b.g - b.h + 1, Lu(b, e - 1, e, b.h), Fu(b, 0, e - 1), Fu(b, b.g, 15 - b.g), c.l = a);
                                break;
                            case 46:
                                Fu(c.j, 0, 15);
                                break;
                            case 47:
                                b = null, c.h !== 4 && (b = Du(c.i, c.l, a)), d = c.j, c.j = c.i, c.i = d, Ou(c), c.l = a, d = b;
                        }
                        e = d;
                        break a;
                    }
                    (d == 23 || d == 31) && a >= 33 && a <= 35 && (c.g.C = a - 32);
                }
                e = null;
            }
            else a = b.vc, Gu(c.g, 0, b.Ib), Gu(c.g, 0, a);
            return e;
        }
        function ov(a, b) {
            var c = [];
            try {
                for(; b.Pa();){
                    var d = bv(b).value, e = (d & 224) >> 5, f = d & 31;
                    e === 7 && f != 0 && (e = bv(b).value & 63);
                    if (e != 0) {
                        a.C.add("svc" + e);
                        a.j.has(e) || a.j.set(e, new cv(e));
                        for(var g = a.j.get(e), h = b.Wa(); b.Wa() - h < f;){
                            e = g;
                            var k = b, l = bv(k), m = l.value, n = l.pts;
                            if (m === 16) {
                                var q = bv(k);
                                m = m << 16 | q.value;
                            }
                            if (m >= 0 && m <= 31) var r = dv(e, k, m, n);
                            else if (m >= 128 && m <= 159) r = ev(e, k, m, n);
                            else {
                                if (m >= 4096 && m <= 4127) e = k, k = m & 255, k >= 8 && k <= 15 ? e.skip(1) : k >= 16 && k <= 23 ? e.skip(2) : k >= 24 && k <= 31 && e.skip(3);
                                else if (m >= 4224 && m <= 4255) e = k, k = m & 255, k >= 128 && k <= 135 ? e.skip(4) : k >= 136 && k <= 143 && e.skip(5);
                                else if (m >= 32 && m <= 127) k = m, e.g && (k === 127 ? Vu(e.g, "\u266a") : Vu(e.g, String.fromCharCode(k)));
                                else if (m >= 160 && m <= 255) e.g && Vu(e.g, String.fromCharCode(m));
                                else if (m >= 4128 && m <= 4223) {
                                    if (k = m & 255, e.g) {
                                        if (kv.has(k)) {
                                            var t = kv.get(k);
                                            Vu(e.g, t);
                                        } else Vu(e.g, "_");
                                    }
                                } else m >= 4256 && m <= 4351 && e.g && ((m & 255) != 160 ? Vu(e.g, "_") : Vu(e.g, "[CC]"));
                                r = [];
                            }
                            c.push.apply(c, x(r));
                        }
                    }
                }
            } catch (w) {
                if (w instanceof U && w.code === 3E3) bb("CEA708_INVALID_DATA", "Buffer read out of bounds / invalid CEA-708 Data.");
                else throw w;
            }
            return c;
        }
        function pv(a) {
            for(var b = 0; a;)b ^= a & 1, a >>= 1;
            return b === 1;
        }
        lv.prototype.getStreams = function() {
            return Array.from(this.C);
        };
        S("shaka.cea.CeaDecoder", lv);
        qd = function() {
            return new lv;
        };
        function qv(a) {
            for(var b = [], c = a, d = a = 0; d < c.length;)a == 2 && c[d] == 3 ? (a = 0, c = [].concat(x(c)), c.splice(d, 1), c = new Uint8Array(c)) : c[d] == 0 ? a++ : a = 0, d++;
            a = c;
            for(d = 0; d < a.length;){
                for(c = 0; a[d] == 255;)c += 255, d++;
                c += a[d++];
                for(var e = 0; a[d] == 255;)e += 255, d++;
                e += a[d++];
                c == 4 && b.push(a.subarray(d, d + e));
                d += e;
            }
            return b;
        }
        function rv() {
            this.j = new Map;
            this.i = this.h = 0;
            this.g = sv;
        }
        rv.prototype.init = function(a) {
            function b(f) {
                f = f.name;
                tv.has(f) && (c.g = tv.get(f));
            }
            var c = this, d = [], e = [];
            (new oh).box("moov", th).box("mvex", th).W("trex", function(f) {
                var g = f.reader;
                g.skip(4);
                g.skip(4);
                f = g.Z();
                g = g.Z();
                c.h = f;
                c.i = g;
            }).box("trak", th).W("tkhd", function(f) {
                var g = f.reader;
                f = f.version;
                f == 1 ? (g.skip(8), g.skip(8)) : (g.skip(4), g.skip(4));
                var h = g.Z();
                f == 1 ? g.skip(8) : g.skip(4);
                g.skip(4);
                g.skip(8);
                g.skip(2);
                g.skip(2);
                g.skip(2);
                g.skip(2);
                g.skip(36);
                g.Ha();
                g.Ha();
                g.Ha();
                g.Ha();
                d.push(h);
            }).box("mdia", th).W("mdhd", function(f) {
                f = Ki(f.reader, f.version);
                e.push(f.timescale);
            }).box("minf", th).box("stbl", th).W("stsd", vh).box("avc1", b).box("avc3", b).box("dvav", b).box("dva1", b).box("hev1", b).box("hvc1", b).box("dvh1", b).box("dvhe", b).box("vvc1", b).box("vvi1", b).box("dvc1", b).box("dvi1", b).box("encv", wh).box("sinf", th).box("frma", function(f) {
                f = Ni(f.reader).codec;
                tv.has(f) && (c.g = tv.get(f));
            }).parse(a, !0, !0);
            if (!d.length || !e.length || d.length != e.length) throw new U(2, 2, 2010);
            this.g == sv && ab("Unable to determine bitstream format for CEA parsing!");
            d.forEach(function(f, g) {
                c.j.set(f, e[g]);
            });
        };
        rv.prototype.parse = function(a) {
            var b = this;
            if (this.g == sv) return [];
            var c = [], d = 0, e = [];
            (new oh).box("moof", function(f) {
                d = f.start;
                e = [];
                th(f);
            }).box("traf", function(f) {
                e.push({
                    baseMediaDecodeTime: null,
                    je: b.h,
                    ke: b.i,
                    uj: [],
                    timescale: 9E4
                });
                th(f);
            }).W("trun", function(f) {
                var g = e[e.length - 1];
                f = Li(f.reader, f.version, f.flags);
                g.uj.push(f);
            }).W("tfhd", function(f) {
                var g = e[e.length - 1];
                f = Ii(f.reader, f.flags);
                g.je = f.je || b.h;
                g.ke = f.ke || b.i;
                f = f.trackId;
                b.j.has(f) && (g.timescale = b.j.get(f));
            }).W("tfdt", function(f) {
                var g = e[e.length - 1];
                f = Ji(f.reader, f.version);
                g.baseMediaDecodeTime = f.baseMediaDecodeTime;
            }).box("mdat", function(f) {
                for(var g = d - f.start - 8, h = f.reader.Wa(), k = u(e), l = k.next(); !l.done; l = k.next())l = l.value, l.baseMediaDecodeTime === null ? ab("Unable to find base media decode time for CEA captions!") : (f.reader.seek(h), uv(b, f.reader, l.baseMediaDecodeTime, l.timescale, l.je, l.ke, g, l.uj, c));
            }).parse(a, !1, !0);
            return c;
        };
        function uv(a, b, c, d, e, f, g, h, k) {
            var l = 0, m = f, n = h.map(function(t) {
                return t.Zh;
            });
            n = [].concat.apply([], x(n));
            n.length && (m = n[0].sampleSize || f);
            for(b.skip(g + h[0].Tg); b.Pa();){
                g = b.Z();
                var q = b.ba(), r = null;
                r = !1;
                h = 1;
                switch(a.g){
                    case vv:
                        r = q & 31;
                        r = r == 6;
                        break;
                    case wv:
                        h = 2;
                        b.skip(1);
                        r = q >> 1 & 63;
                        r = r == 39 || r == 40;
                        break;
                    case xv:
                        h = 2;
                        b.skip(1);
                        r = q >> 1 & 63;
                        r = r == 23 || r == 24;
                        break;
                    default:
                        return;
                }
                if (r) for(q = 0, l < n.length && (q = n[l].cg || 0), q = (c + q) / d, h = u(qv(b.ac(g - h))), r = h.next(); !r.done; r = h.next())k.push({
                    packet: r.value,
                    pts: q
                });
                else try {
                    b.skip(g - h);
                } catch (t) {
                    break;
                }
                m -= g + 4;
                m == 0 && (c = l < n.length ? c + (n[l].$h || e) : c + e, l++, l < n.length ? m = n[l].sampleSize || f : m = f);
            }
        }
        S("shaka.cea.Mp4CeaParser", rv);
        var sv = 0, vv = 1, wv = 2, xv = 3, tv = (new Map).set("avc1", vv).set("avc3", vv).set("dvav", vv).set("dva1", vv).set("hev1", wv).set("hvc1", wv).set("dvh1", wv).set("dvhe", wv).set("vvc1", xv).set("vvi1", xv).set("dvc1", xv).set("dvi1", xv);
        rd("video/mp4", function() {
            return new rv;
        });
        function yv() {
            this.g = null;
        }
        yv.prototype.init = function() {};
        yv.prototype.parse = function(a) {
            this.g ? this.g.clearData() : this.g = new nk;
            var b = [];
            a = Kb(a);
            if (!vk(a)) return b;
            a = this.g.parse(a);
            var c = a.le(), d = a.yf();
            a = [];
            switch(c.video){
                case "avc":
                    a.push(6);
                    break;
                case "hvc":
                    a.push(39), a.push(40);
            }
            if (!a.length) return b;
            c = u(d);
            for(d = c.next(); !d.done; d = c.next())if (d = d.value, a.includes(d.type) && d.time != null) for(var e = u(qv(d.data)), f = e.next(); !f.done; f = e.next())b.push({
                packet: f.value,
                pts: d.time
            });
            return b;
        };
        S("shaka.cea.TsCeaParser", yv);
        rd("video/mp2t", function() {
            return new yv;
        });
        function zv(a) {
            var b = 0, c = Ob(a), d = c.getUint32(b, !0);
            if (d != a.byteLength) return [];
            a: {
                a = b + 4 + 2;
                for(b = []; a < c.byteLength - 1;){
                    d = c.getUint16(a, !0);
                    a += 2;
                    var e = c.getUint16(a, !0);
                    a += 2;
                    if ((e & 1) != 0 || e + a > c.byteLength) {
                        c = [];
                        break a;
                    }
                    var f = Kb(c, a, e);
                    b.push({
                        type: d,
                        value: f
                    });
                    a += e;
                }
                c = b;
            }
            return c;
        }
        function Av(a) {
            a = hc(Sd(a));
            a = zv(a).filter(function(b) {
                return b.type === Bv;
            })[0];
            if (!a) return null;
            a = Xb(a.value, !0);
            return (a = Kd(a, "WRMHEADER")) ? a : null;
        }
        function Cv(a) {
            try {
                var b = Av(a);
                if (b) a: {
                    for(var c = u(Ud(b, "DATA")), d = c.next(); !d.done; d = c.next()){
                        var e = d.value;
                        if (e.children) for(var f = u(e.children), g = f.next(); !g.done; g = f.next()){
                            var h = g.value;
                            if (h.tagName == "LA_URL") {
                                var k = Sd(h);
                                break a;
                            }
                        }
                    }
                    k = "";
                }
                else k = "";
                return k;
            } catch (l) {
                return "";
            }
        }
        var Bv = 1;
        function Dv() {
            this.g = new Map;
        }
        Dv.prototype.release = function() {
            this.g.clear();
        };
        function Ev(a, b, c, d) {
            var e = Fv(a, b), f = null;
            a = [];
            var g = [];
            b = null;
            var h = new Set(e.map(function(l) {
                return l.keyId;
            }));
            h.delete(null);
            var k = "cenc";
            if (h.size > 1) throw new U(2, 4, 4010);
            if (!c) {
                g = e.filter(function(l) {
                    return l.Wd == "urn:mpeg:dash:sea:2012";
                });
                if (g.length > 1) throw new U(2, 4, 4050);
                g.length && (b = Gv(g[0]));
                (g = e.find(function(l) {
                    return l.Wd == "urn:mpeg:dash:mp4protection:2011";
                })) && g.encryptionScheme && (k = g.encryptionScheme);
                g = e.filter(function(l) {
                    return l.Wd == "urn:mpeg:dash:mp4protection:2011" ? (f = l.init || f, !1) : l.Wd != "urn:mpeg:dash:sea:2012";
                });
                g.length && (a = Hv(f, k, g, d, h), a.length == 0 && (a = [
                    nc("", k, f)
                ]));
            }
            if (e.length && !b && (c || !g.length)) for(a = [], c = u(Object.values(d)), d = c.next(); !d.done; d = c.next())d = d.value, d != "org.w3.clearkey" && a.push(nc(d, k, f));
            if (h = Array.from(h)[0] || null) for(k = u(a), c = k.next(); !c.done; c = k.next())for(c = u(c.value.initData), d = c.next(); !d.done; d = c.next())d.value.keyId = h;
            return {
                Qi: h,
                Un: f,
                drmInfos: a,
                Hg: b,
                Vi: !0
            };
        }
        function Iv(a, b, c, d, e) {
            var f = Ev(a, b, d, e);
            if (c.Vi) {
                a = c.drmInfos.length == 1 && !c.drmInfos[0].keySystem;
                b = f.drmInfos.length == 0;
                if (c.drmInfos.length == 0 || a && !b) c.drmInfos = f.drmInfos;
                c.Vi = !1;
            } else if (f.drmInfos.length > 0 && (c.drmInfos = c.drmInfos.filter(function(g) {
                return f.drmInfos.some(function(h) {
                    return h.keySystem == g.keySystem;
                });
            }), c.drmInfos.length == 0)) throw new U(2, 4, 4008);
            return f.Qi || c.Qi;
        }
        function Jv(a) {
            var b = Wd(a.node, "https://dashif.org/CPS", "Laurl");
            if (b && (b = Sd(b))) return b;
            if ((b = Wd(a.node, "urn:microsoft:playready", "pro")) && Sd(b)) return Cv(b);
            if (a = Wd(a.node, "urn:mpeg:cenc:2013", "pssh")) {
                if (a = Sd(a)) {
                    b = hc(a);
                    a = 8;
                    b = Ob(b);
                    var c = b.getUint8(a);
                    a += 20;
                    c > 0 && (a += 4 + 16 * b.getUint32(a));
                    a = Kb(b, a + 4);
                    a = ec(a);
                    a = Kd("<pro>" + a + "</pro>");
                    return Cv(a);
                }
            }
            return "";
        }
        function Hv(a, b, c, d, e) {
            var f = [];
            c = u(c);
            for(var g = c.next(); !g.done; g = c.next()){
                g = g.value;
                var h = d[g.Wd];
                if (h) {
                    var k;
                    if ((k = Wd(g.node, "urn:microsoft:playready", "pro")) && Sd(k)) {
                        k = Sd(k);
                        k = hc(k);
                        var l = new Uint8Array([
                            154,
                            4,
                            240,
                            121,
                            152,
                            64,
                            66,
                            134,
                            171,
                            146,
                            230,
                            91,
                            224,
                            136,
                            95,
                            149
                        ]);
                        k = [
                            {
                                initData: Ah(k, l, new Set, 0),
                                initDataType: "cenc",
                                keyId: g.keyId
                            }
                        ];
                    } else k = null;
                    l = null;
                    if (g.Wd === "urn:uuid:e2719d58-a985-b3c9-781a-b030af78d30e") {
                        l = g;
                        var m = e;
                        if (m.size == 0) l = null;
                        else {
                            var n = new Uint8Array([
                                16,
                                119,
                                239,
                                236,
                                192,
                                178,
                                77,
                                2,
                                172,
                                227,
                                60,
                                30,
                                82,
                                226,
                                251,
                                75
                            ]), q = new Uint8Array([]);
                            l = [
                                {
                                    initData: Ah(q, n, m, 1),
                                    initDataType: "cenc",
                                    keyId: l.keyId
                                }
                            ];
                        }
                    }
                    k = nc(h, b, g.init || a || k || l);
                    if (h = Kv.get(h)) k.licenseServerUri = h(g);
                    a: {
                        if (g = Wd(g.node, "https://dashif.org/CPS", "Certurl")) {
                            if (g = Sd(g)) break a;
                        }
                        g = "";
                    }
                    k.serverCertificateUri = g;
                    f.push(k);
                }
            }
            return f;
        }
        function Fv(a, b) {
            var c = [];
            b = u(b);
            for(var d = b.next(); !d.done; d = b.next())(d = Lv(a, d.value)) && c.push(d);
            return c;
        }
        function Lv(a, b) {
            var c = b.attributes.schemeIdUri, d = $d(b, "urn:mpeg:cenc:2013", "default_KID"), e = Xd(b, "urn:mpeg:cenc:2013", "pssh").map(Td), f = b.attributes.value;
            if (!c) return null;
            c = c.toLowerCase();
            if (d && (d = d.replace(/-/g, "").toLowerCase(), d.includes(" "))) throw new U(2, 4, 4009);
            var g = [];
            try {
                g = e.map(function(h) {
                    if (!a.g.has(h)) {
                        var k = hc(h);
                        a.g.set(h, k);
                    }
                    return {
                        initDataType: "cenc",
                        initData: a.g.get(h),
                        keyId: null
                    };
                });
            } catch (h) {
                throw new U(2, 4, 4007);
            }
            return {
                node: b,
                Wd: c,
                keyId: d,
                init: g.length > 0 ? g : null,
                encryptionScheme: f
            };
        }
        function Gv(a) {
            if (!window1.crypto || !window1.crypto.subtle) throw ab("Web Crypto API is not available to decrypt AES-128. (Web Crypto only exists in secure origins like https)"), new U(2, 4, 4042);
            var b = Wd(a.node, "urn:mpeg:dash:schema:sea:2012", "SegmentEncryption");
            if (!b) throw new U(2, 4, 4051);
            if (b.attributes.schemeIdUri != "urn:mpeg:dash:sea:aes128-cbc:2013") throw new U(2, 4, 4051);
            b = Wd(a.node, "urn:mpeg:dash:schema:sea:2012", "CryptoPeriod");
            if (!b) throw new U(2, 4, 4051);
            a = b.attributes.IV;
            b = cc(b.attributes.keyUriTemplate);
            if (!a || !b) throw new U(2, 4, 4051);
            a = ic(a.substr(2));
            if (a.byteLength != 16) throw new U(2, 4, 4048);
            return {
                Ll: b,
                iv: a
            };
        }
        var Kv = (new Map).set("com.apple.fps", function(a) {
            if ("apple" === window1.shakaMediaKeysPolyfill) throw new U(2, 4, 4054);
            if (a = Wd(a.node, "https://dashif.org/CPS", "Laurl")) {
                if (a = Sd(a)) return a;
            }
            return "";
        }).set("com.widevine.alpha", function(a) {
            var b = Wd(a.node, "https://dashif.org/CPS", "Laurl");
            return b && (b = Sd(b)) ? b : (a = Wd(a.node, "urn:microsoft", "laurl")) ? cc(a.attributes.licenseUrl) || "" : "";
        }).set("com.microsoft.playready", Jv).set("com.microsoft.playready.recommendation", Jv).set("com.microsoft.playready.software", Jv).set("com.microsoft.playready.hardware", Jv).set("org.w3.clearkey", function(a) {
            var b = Wd(a.node, "https://dashif.org/CPS", "Laurl");
            return b && (b = Sd(b)) ? b : (a = Wd(a.node, "http://dashif.org/guidelines/clearKey", "Laurl")) && a.attributes.Lic_type === "EME-1.0" && a && (a = Sd(a)) ? a : "";
        });
        function Mv(a, b, c, d, e, f) {
            var g = (new Map).set("RepresentationID", b).set("Number", c).set("SubNumber", d).set("Bandwidth", e).set("Time", f);
            return a.replace(/\$(RepresentationID|Number|SubNumber|Bandwidth|Time)?(?:%0([0-9]+)([diouxX]))?\$/g, function(h, k, l, m) {
                if (h == "$$") return "$";
                var n = g.get(k);
                if (n == null) return h;
                k == "RepresentationID" && l && (l = void 0);
                k == "Time" && typeof n != "bigint" && (Math.abs(n - Math.round(n)) >= .2 && ab("Calculated $Time$ values must be close to integers"), n = Math.round(n));
                switch(m){
                    case void 0:
                    case "d":
                    case "i":
                    case "u":
                        h = n.toString();
                        break;
                    case "o":
                        h = n.toString(8);
                        break;
                    case "x":
                        h = n.toString(16);
                        break;
                    case "X":
                        h = n.toString(16).toUpperCase();
                        break;
                    default:
                        h = n.toString();
                }
                l = window1.parseInt(l, 10) || 1;
                return Array(Math.max(0, l - h.length) + 1).join("0") + h;
            });
        }
        function Nv(a, b) {
            var c = Ov(a, b, "timescale"), d = 1;
            c && (d = fe(c) || 1);
            c = Ov(a, b, "duration");
            var e = (c = fe(c || "")) ? c / d : null, f = Ov(a, b, "startNumber"), g = Number(Ov(a, b, "presentationTimeOffset")) || 0, h = ge(f || "");
            if (f == null || h == null) h = 1;
            f = null;
            if (b = Pv(a, b, "SegmentTimeline")) {
                b = Rd(b, "S");
                f = d;
                a = a.qa.duration || Infinity;
                for(var k = h, l = [], m = -g, n = 0; n < b.length; ++n){
                    var q = b[n], r = b[n + 1], t = Zd(q, "t", ge), w = Zd(q, "d", ge), v = Zd(q, "r", ee);
                    q = Zd(q, "k", ee) || 0;
                    t != null && (t -= g);
                    if (w) {
                        t = t != null ? t : m;
                        v = v || 0;
                        if (v < 0) {
                            if (r) {
                                r = Zd(r, "t", ge);
                                if (r == null) break;
                                else if (t >= r) break;
                                v = Math.ceil((r - t) / w) - 1;
                            } else {
                                if (a == Infinity) break;
                                else if (t / f >= a) break;
                                v = Math.ceil((a * f - t) / w) - 1;
                            }
                        }
                        l.length > 0 && t != m && (l[l.length - 1].end = t / f);
                        for(r = 0; r <= v; ++r)m = t + w, l.push({
                            start: t / f,
                            end: m / f,
                            xi: t,
                            Fc: q,
                            pm: l.length + k
                        }), t = m;
                    }
                }
                f = l;
            }
            return {
                timescale: d,
                pg: c,
                pb: e,
                Ie: h,
                Qb: g / d || 0,
                wd: g,
                timeline: f
            };
        }
        function Qv(a, b) {
            return [
                b(a.N),
                b(a.va),
                b(a.Aa)
            ].filter(Ef);
        }
        function Ov(a, b, c) {
            b = Qv(a, b);
            a = null;
            b = u(b);
            for(var d = b.next(); !d.done && !(a = d.value.attributes[c]); d = b.next());
            return a;
        }
        function Pv(a, b, c) {
            b = Qv(a, b);
            a = null;
            b = u(b);
            for(var d = b.next(); !d.done && !(a = Vd(d.value, c)); d = b.next());
            return a;
        }
        function Rv(a, b, c, d, e, f) {
            for(var g = $d(a, "http://www.w3.org/1999/xlink", "href"), h = $d(a, "http://www.w3.org/1999/xlink", "actuate") || "onRequest", k = u(Object.keys(a.attributes)), l = k.next(); !l.done; l = k.next()){
                l = l.value;
                var m = l.split(":"), n = Md("http://www.w3.org/1999/xlink");
                m[0] == n && delete a.attributes[l];
            }
            if (f >= 5) return Ng(new U(2, 4, 4028));
            if (h != "onLoad") return Ng(new U(2, 4, 4027));
            var q = mc([
                d
            ], [
                g
            ]);
            return e.request(0, $g(q, b)).bb(function(r) {
                r = Jd(r.data, a.tagName);
                if (!r) return Ng(new U(2, 4, 4001, g));
                for(a.children = []; r.children.length;){
                    var t = r.children.shift();
                    a.children.push(t);
                }
                t = u(Object.keys(r.attributes));
                for(var w = t.next(); !w.done; w = t.next())w = w.value, a.attributes[w] = r.attributes[w];
                return Sv(a, b, c, q[0], e, f + 1);
            });
        }
        function Sv(a, b, c, d, e, f) {
            f = f === void 0 ? 0 : f;
            if ($d(a, "http://www.w3.org/1999/xlink", "href")) {
                var g = Rv(a, b, c, d, e, f);
                c && (g = g.bb(void 0, function() {
                    return Sv(a, b, c, d, e, f);
                }));
                return g;
            }
            g = [];
            for(var h = u(Qd(a)), k = h.next(), l = {}; !k.done; l = {
                fe: void 0
            }, k = h.next())l.fe = k.value, $d(l.fe, "http://www.w3.org/1999/xlink", "href") == "urn:mpeg:dash:resolve-to-zero:2013" ? a.children = a.children.filter(function(m) {
                return function(n) {
                    return n !== m.fe;
                };
            }(l)) : l.fe.tagName != "SegmentTimeline" && g.push(Sv(l.fe, b, c, d, e, f));
            return Rg(g).bb(function() {
                return a;
            });
        }
        function Tv(a, b, c, d, e, f, g) {
            var h, k = (new oh).W("sidx", function(l) {
                h = Uv(b, d, e, f, g, c, l);
            });
            a && k.parse(a);
            if (h) return h;
            throw new U(2, 3, 3004);
        }
        function Uv(a, b, c, d, e, f, g) {
            var h = [];
            g.reader.skip(4);
            var k = g.reader.Z();
            if (k == 0) throw new U(2, 3, 3005);
            if (g.version == 0) {
                var l = g.reader.Z();
                var m = g.reader.Z();
            } else l = g.reader.Td(), m = g.reader.Td();
            g.reader.skip(2);
            var n = g.reader.Ha();
            a = a + g.size + m;
            for(m = 0; m < n; m++){
                var q = g.reader.Z(), r = (q & 2147483648) >>> 31;
                q &= 2147483647;
                var t = g.reader.Z();
                g.reader.skip(4);
                if (r == 1) throw new U(2, 3, 3006);
                h.push(new yj(l / k + c, (l + t) / k + c, function() {
                    return f;
                }, a, a + q - 1, b, c, d, e));
                l += t;
                a += q;
            }
            g.parser.stop();
            return h;
        }
        function Vv(a) {
            this.h = Ob(a);
            this.g = new lh(this.h, 0);
        }
        Vv.prototype.Pa = function() {
            return this.g.Pa();
        };
        function Wv(a) {
            var b = Xv(a);
            if (b.length > 7) throw new U(2, 3, 3002);
            var c = 0;
            b = u(b);
            for(var d = b.next(); !d.done; d = b.next())c = 256 * c + d.value;
            b = Xv(a);
            a: {
                d = u(Yv);
                for(var e = d.next(); !e.done; e = d.next())if (Jb(b, new Uint8Array(e.value))) {
                    d = !0;
                    break a;
                }
                d = !1;
            }
            if (d) b = a.h.byteLength - a.g.Wa();
            else {
                if (b.length == 8 && b[1] & 224) throw new U(2, 3, 3001);
                for(e = d = 0; e < b.length; e++){
                    var f = b[e];
                    d = e == 0 ? f & (1 << 8 - b.length) - 1 : 256 * d + f;
                }
                b = d;
            }
            b = a.g.Wa() + b <= a.h.byteLength ? b : a.h.byteLength - a.g.Wa();
            d = Ob(a.h, a.g.Wa(), b);
            a.g.skip(b);
            return new Zv(c, d);
        }
        function Xv(a) {
            var b = a.g.Wa(), c = a.g.ba();
            if (c == 0) throw new U(2, 3, 3002);
            c = 8 - Math.floor(Math.log2(c));
            a.g.skip(c - 1);
            return Kb(a.h, b, c);
        }
        var Yv = [
            [
                255
            ],
            [
                127,
                255
            ],
            [
                63,
                255,
                255
            ],
            [
                31,
                255,
                255,
                255
            ],
            [
                15,
                255,
                255,
                255,
                255
            ],
            [
                7,
                255,
                255,
                255,
                255,
                255
            ],
            [
                3,
                255,
                255,
                255,
                255,
                255,
                255
            ],
            [
                1,
                255,
                255,
                255,
                255,
                255,
                255,
                255
            ]
        ];
        function Zv(a, b) {
            this.id = a;
            this.g = b;
        }
        function $v(a) {
            if (a.g.byteLength > 8) throw new U(2, 3, 3002);
            if (a.g.byteLength == 8 && a.g.getUint8(0) & 224) throw new U(2, 3, 3001);
            for(var b = 0, c = 0; c < a.g.byteLength; c++){
                var d = a.g.getUint8(c);
                b = 256 * b + d;
            }
            return b;
        }
        function aw(a, b, c, d, e, f, g, h, k) {
            function l() {
                return e;
            }
            var m = [];
            a = new Vv(a.g);
            for(var n = null, q = null; a.Pa();){
                var r = Wv(a);
                if (r.id == 187) {
                    var t = bw(r);
                    t && (r = c * t.Dm, t = b + t.dm, n != null && m.push(new yj(n + g, r + g, l, q, t - 1, f, g, h, k)), n = r, q = t);
                }
            }
            n != null && m.push(new yj(n + g, d + g, l, q, null, f, g, h, k));
            return m;
        }
        function bw(a) {
            var b = new Vv(a.g);
            a = Wv(b);
            if (a.id != 179) throw new U(2, 3, 3013);
            a = $v(a);
            b = Wv(b);
            if (b.id != 183) throw new U(2, 3, 3012);
            b = new Vv(b.g);
            for(var c = 0; b.Pa();){
                var d = Wv(b);
                if (d.id == 241) {
                    c = $v(d);
                    break;
                }
            }
            return {
                Dm: a,
                dm: c
            };
        }
        function cw(a, b, c) {
            b = Pv(a, b, "Initialization");
            if (!b) return null;
            var d = a.N.mb(), e = b.attributes.sourceURL;
            e && (d = mc(d, [
                cc(e)
            ], a.Sb()));
            e = 0;
            var f = null;
            if (b = Zd(b, "range", de)) e = b.start, f = b.end;
            c = new wj(function() {
                return d;
            }, e, f, dw(a), null, null, c, a.va.encrypted);
            c.codecs = a.N.codecs;
            c.mimeType = a.N.mimeType;
            a.qa && !a.qa.Df && (c.g = a.qa.start + a.qa.duration);
            return c;
        }
        function ew(a, b, c) {
            var d = Number(Ov(a, fw, "presentationTimeOffset")) || 0, e = Ov(a, fw, "timescale"), f = 1;
            e && (f = fe(e) || 1);
            var g = d / f || 0, h = cw(a, fw, c);
            gw(a, h);
            var k = Hd(a);
            return {
                endTime: -1,
                timeline: -1,
                gd: function() {
                    var l = Pv(k, fw, "RepresentationIndex");
                    var m = k.N.mb();
                    l && (l = cc(l.attributes.sourceURL)) && (m = mc(m, [
                        l
                    ], k.Sb()));
                    l = hw(k);
                    return iw(k, b, h, m, l.start, l.end, g);
                },
                timescale: f
            };
        }
        function iw(a, b, c, d, e, f, g) {
            var h, k, l, m, n, q, r, t, w, v, z, y, A, C, E, D, B, G;
            return Q(function(I) {
                if (I.g == 1) return h = a.presentationTimeline, k = !a.Kb || !a.qa.Df, l = a.qa.start, m = a.qa.duration, n = a.N.mimeType.split("/")[1], q = b, r = null, t = [
                    q(d, e, f, !1),
                    n == "webm" ? q(c.T(), c.startByte, c.endByte, !0) : null
                ], q = null, F(I, Promise.all(t), 2);
                w = I.h;
                v = w[0];
                z = w[1] || null;
                y = null;
                A = l - g;
                C = l;
                E = m ? l + m : Infinity;
                if (n == "mp4") var J = Tv(v, e, d, c, A, C, E);
                else {
                    J = v;
                    var L = new Vv(z);
                    if (Wv(L).id != 440786851) throw new U(2, 3, 3008);
                    var K = Wv(L);
                    if (K.id != 408125543) throw new U(2, 3, 3009);
                    L = K.g.byteOffset;
                    K = new Vv(K.g);
                    for(var N = null; K.Pa();){
                        var P = Wv(K);
                        if (P.id == 357149030) {
                            N = P;
                            break;
                        }
                    }
                    if (!N) throw new U(2, 3, 3010);
                    N = new Vv(N.g);
                    P = 1E6;
                    for(K = null; N.Pa();){
                        var O = Wv(N);
                        if (O.id == 2807729) P = $v(O);
                        else if (O.id == 17545) {
                            if (O.g.byteLength == 4) K = O.g.getFloat32(0);
                            else if (O.g.byteLength == 8) K = O.g.getFloat64(0);
                            else throw new U(2, 3, 3003);
                        }
                    }
                    if (K == null) throw new U(2, 3, 3011);
                    N = P / 1E9;
                    K *= N;
                    J = Wv(new Vv(J));
                    if (J.id != 475249515) throw new U(2, 3, 3007);
                    J = aw(J, L, N, K, d, c, A, C, E);
                }
                y = J;
                D = u(y);
                for(B = D.next(); !B.done; B = D.next())G = B.value, G.codecs = a.N.codecs, G.mimeType = a.N.mimeType, G.bandwidth = a.bandwidth;
                h.Be(y);
                r = new Xl(y);
                k && r.Gd(C, E, !0);
                return I.return(r);
            });
        }
        function fw(a) {
            return a.Xd;
        }
        function hw(a) {
            var b = Pv(a, fw, "RepresentationIndex");
            a = Ov(a, fw, "indexRange");
            a = de(a || "");
            b && (a = Zd(b, "range", de, a));
            return a;
        }
        function gw(a, b) {
            jw(a, b);
            if (!hw(a)) throw new U(2, 4, 4002);
        }
        function jw(a, b) {
            var c = a.N.mimeType.split("/")[1];
            if (a.N.contentType != sc && c != "mp4" && c != "webm") throw new U(2, 4, 4006);
            if (c == "webm" && !b) throw new U(2, 4, 4005);
        }
        function dw(a) {
            var b = a.N;
            return {
                bandwidth: a.bandwidth,
                audioSamplingRate: b.audioSamplingRate,
                codecs: b.codecs,
                contentType: b.contentType,
                frameRate: b.frameRate || null,
                height: b.height || null,
                mimeType: b.mimeType,
                channelsCount: b.Qf,
                pixelAspectRatio: b.pixelAspectRatio || null,
                width: b.width || null,
                label: a.va.label || null,
                roles: a.roles || null,
                language: a.va.language || null
            };
        }
        function kw(a, b, c) {
            var d = cw(a, lw, c), e = mw(a);
            if (!e.pb && !e.timeline && e.Pd.length > 1) throw new U(2, 4, 4002);
            if (!e.pb && !a.qa.duration && !e.timeline && e.Pd.length == 1) throw new U(2, 4, 4002);
            if (e.timeline && e.timeline.length == 0) throw new U(2, 4, 4002);
            var f = null, g = null;
            a.Aa.id && a.N.id && (g = b.get(a.Aa.id + "," + a.N.id)) && (f = g.segmentIndex);
            var h = nw(a.qa.start, a.qa.duration, a.N.mb, e, d, c, a.N.mimeType, a.N.codecs, a.bandwidth, a.Sb);
            b = !f;
            f ? f.ze(h, a.presentationTimeline.Nb()) : f = new Xl(h);
            a.presentationTimeline.Be(h);
            a.Kb && a.qa.Df || f.Gd(a.qa.start, a.qa.duration ? a.qa.start + a.qa.duration : Infinity, b);
            g && (g.segmentIndex = f);
            return {
                endTime: -1,
                timeline: -1,
                gd: function() {
                    f && f.getNumReferences() != 0 || f.Lf(h);
                    return Promise.resolve(f);
                },
                timescale: e.timescale
            };
        }
        function lw(a) {
            return a.Jc;
        }
        function mw(a) {
            var b = ow(a);
            a = Nv(a, lw);
            var c = a.Ie;
            c == 0 && (c = 1);
            var d = 0;
            a.pb ? d = a.pb * (c - 1) : a.timeline && a.timeline.length > 0 && (d = a.timeline[0].start);
            return {
                pb: a.pb,
                startTime: d,
                Ie: c,
                Qb: a.Qb,
                timescale: a.timescale,
                timeline: a.timeline,
                Pd: b
            };
        }
        function nw(a, b, c, d, e, f, g, h, k, l) {
            var m = d.Pd.length;
            d.timeline && d.timeline.length != d.Pd.length && (m = Math.min(d.timeline.length, d.Pd.length));
            for(var n = a - d.Qb, q = b ? a + b : Infinity, r = [], t = d.startTime, w = {}, v = 0; v < m; w = {
                rg: void 0,
                dg: void 0
            }, v++){
                w.dg = d.Pd[v];
                var z = t;
                t = void 0;
                t = d.pb != null ? z + d.pb : d.timeline ? d.timeline[v].end : z + b;
                w.rg = null;
                w = new yj(a + z, a + t, function(y) {
                    return function() {
                        y.rg == null && (y.rg = mc(c(), [
                            y.dg.Sl
                        ], l()));
                        return y.rg;
                    };
                }(w), w.dg.start, w.dg.end, e, n, a, q, [], "", null, null, zj, f);
                w.codecs = h;
                w.mimeType = g;
                w.bandwidth = k;
                r.push(w);
            }
            return r;
        }
        function ow(a) {
            return [
                a.N.Jc,
                a.va.Jc,
                a.Aa.Jc
            ].filter(Ef).map(function(b) {
                return Rd(b, "SegmentURL");
            }).reduce(function(b, c) {
                return b.length > 0 ? b : c;
            }).map(function(b) {
                b.attributes.indexRange && !a.Ch && (a.Ch = !0);
                var c = cc(b.attributes.media);
                b = Zd(b, "mediaRange", de, {
                    start: 0,
                    end: null
                });
                return {
                    Sl: c,
                    start: b.start,
                    end: b.end
                };
            });
        }
        function pw(a, b, c, d, e, f, g, h, k, l) {
            k || a.N.Af || (a.N.Af = Ov(a, qw, "initialization"));
            var m = a.N.Af ? rw(a, g) : null, n = sw(a);
            tw(n);
            var q = Hd(a);
            if (n.ue) return jw(a, m), {
                endTime: -1,
                timeline: -1,
                gd: function() {
                    var z = Mv(n.ue, q.N.originalId, null, null, q.bandwidth || null, null);
                    z = mc(q.N.mb(), [
                        z
                    ]);
                    return iw(q, b, m, z, 0, null, n.Qb);
                },
                timescale: n.timescale
            };
            if (n.pb) return d || a.va.contentType === "image" || a.va.contentType === "text" || (d = a.qa.start, l = a.Aa.id, c = a.qa.duration, l = (l = l != null && f.get(l) || c) ? d + l : Infinity, a.presentationTimeline.Lh(n.pb), a.presentationTimeline.sj(d, l)), {
                endTime: -1,
                timeline: -1,
                gd: function() {
                    return uw(q, n, e, m, f, g, h, a.N.eg);
                },
                timescale: n.timescale
            };
            var r = null;
            d = d = null;
            a.Aa.id && a.N.id && (d = a.Aa.id + "," + a.N.id, d = c.get(d)) && (r = d.segmentIndex);
            var t = a.qa.start, w = a.qa.duration ? t + a.qa.duration : Infinity;
            if (r) l = r, vw(l, n, t, w, m, a.Kb), l.cb(a.presentationTimeline.Nb());
            else {
                c = 0;
                k = -1;
                if (a.Aa.id != null && a.N.id != null) {
                    var v = l.get(a.Aa.id);
                    if (v) k = v.timeline;
                    else for(l = u(l.values()), v = l.next(); !v.done; v = l.next())if (v = v.value, Math.abs(n.Qb - v.endTime) <= vc && v.Uh.includes(a.N.id)) {
                        k = v.timeline;
                        break;
                    } else v.timeline >= c && (c = v.timeline + 1);
                }
                k == -1 && (k = c);
                r = new ww(a.Kb, n, a.N.originalId, a.bandwidth, a.N.mb, a.Sb, t, w, m, g, a.N.eg, k);
            }
            n.timeline && a.va.contentType !== "image" && a.va.contentType !== "text" && a.presentationTimeline.tj(r.h ? r.h.timeline : [], t);
            d && a.Kb && (d.segmentIndex = r);
            d = (d = (d = n.timeline) && d[d.length - 1]) ? d.end + n.Qb : -1;
            l = -1;
            r instanceof ww && (l = r.nf());
            return {
                endTime: d,
                timeline: l,
                gd: function() {
                    r instanceof ww && r.getNumReferences() == 0 && vw(r, n, t, w, m, a.Kb);
                    return Promise.resolve(r);
                },
                timescale: n.timescale
            };
        }
        function qw(a) {
            return a.Zc;
        }
        function sw(a) {
            var b = Nv(a, qw), c = Ov(a, qw, "media"), d = Ov(a, qw, "index"), e = Ov(a, qw, "k"), f = 0;
            e && (f = parseInt(e, 10));
            return {
                pg: b.pg,
                pb: b.pb,
                timescale: b.timescale,
                Ie: b.Ie,
                Qb: b.Qb,
                wd: b.wd,
                timeline: b.timeline,
                jc: c && cc(c),
                ue: d,
                mimeType: a.N.mimeType,
                codecs: a.N.codecs,
                bandwidth: a.bandwidth,
                Tl: f
            };
        }
        function tw(a) {
            var b = a.ue ? 1 : 0;
            b += a.timeline ? 1 : 0;
            b += a.pb ? 1 : 0;
            if (b == 0) throw new U(2, 4, 4002);
            b != 1 && (a.ue && (a.timeline = null), a.pg = null, a.pb = null);
            if (!a.ue && !a.jc) throw new U(2, 4, 4002);
        }
        function uw(a, b, c, d, e, f, g, h) {
            function k(K) {
                var N = K - v, P = N * w, O = b.pg, M = N * O;
                "BigInt" in window1 && M > Number.MAX_SAFE_INTEGER && (M = BigInt(N) * BigInt(O));
                P += q;
                N = P + w;
                O = Math.min(N, m());
                var R = [], W = b.Tl;
                if (W) for(var wa = (O - P) / W, Y = {}, Ka = 0; Ka < W; Y = {
                    Tj: void 0
                }, Ka++){
                    var Na = P + wa * Ka, La = Na + wa;
                    Y.Tj = Ka;
                    Y = new yj(Na, La, function(Ea) {
                        return function() {
                            var za = Mv(z, A, K, Ea.Tj, y, M);
                            return mc(C(), [
                                za
                            ], E());
                        };
                    }(Y), 0, null, d, D, q, m(), [], "", null, null, zj, f);
                    Y.codecs = a.N.codecs;
                    Y.mimeType = a.N.mimeType;
                    h == 0 ? Ka > 0 && Y.Nd() : Ka % h != 0 && Y.Nd();
                    R.push(Y);
                }
                P = new yj(P, O, function() {
                    if (W) return [];
                    var Ea = Mv(z, A, K, null, y, M);
                    return mc(C(), [
                        Ea
                    ], E());
                }, 0, null, d, D, q, m(), R, "", null, null, zj, f, R.length > 0);
                P.codecs = a.N.codecs;
                P.mimeType = a.N.mimeType;
                P.bandwidth = a.bandwidth;
                P.j = N;
                return P;
            }
            function l() {
                var K = [
                    Math.max(n.Nb(), q),
                    Math.min(n.Sc(), m())
                ].map(function(N) {
                    return N - q;
                });
                K = [
                    Math.ceil(K[0] / w),
                    Math.ceil(K[1] / w) - 1
                ];
                a.N.Bb && K[1]++;
                return K.map(function(N) {
                    return N + v;
                });
            }
            function m() {
                var K = r != null && e.get(r) || t;
                return K ? q + K : Infinity;
            }
            var n = a.presentationTimeline, q = a.qa.start, r = a.Aa.id, t = a.qa.duration, w = b.pb, v = b.Ie, z = b.jc, y = a.bandwidth || null, A = a.N.originalId, C = a.N.mb, E = a.Sb, D = q - b.Qb, B = l();
            c = a.Kb ? Math.max(B[0], B[1] - c + 1) : B[0];
            g = g || B[1];
            B = [];
            for(var G = c; G <= g; ++G){
                var I = k(G);
                B.push(I);
            }
            var J = new Xl(B);
            B = n.Sc() < m();
            G = n.U();
            if (B || G) {
                var L = Math.max(c, g + 1);
                c = w;
                a.N.Bb && (c = .1);
                J.qg(c, function() {
                    var K = n.Nb();
                    J.cb(K);
                    var N = u(l());
                    N.next();
                    N = N.next().value;
                    for(var P = []; L <= N;){
                        var O = k(L);
                        P.push(O);
                        L++;
                    }
                    return K > m() && !P.length ? null : P;
                });
            }
            return Promise.resolve(J);
        }
        function rw(a, b) {
            var c = a.N.Af;
            c || (c = Ov(a, qw, "initialization"));
            if (!c) return null;
            c = cc(c);
            var d = a.N.originalId, e = a.bandwidth || null, f = a.N.mb, g = a.Sb;
            b = new wj(function() {
                var h = Mv(c, d, null, null, e, null);
                return mc(f(), [
                    h
                ], g());
            }, 0, null, dw(a), null, null, b, a.va.encrypted);
            b.codecs = a.N.codecs;
            b.mimeType = a.N.mimeType;
            a.qa && !a.qa.Df && (b.g = a.qa.start + a.qa.duration);
            return b;
        }
        function ww(a, b, c, d, e, f, g, h, k, l, m, n) {
            Xl.call(this, []);
            this.F = a;
            this.h = b;
            this.H = c;
            this.D = d;
            this.G = e;
            this.J = f;
            this.j = g;
            this.l = h;
            this.A = k;
            this.C = l;
            this.I = m;
            this.K = n;
            xw(this);
        }
        la(ww, Xl);
        p = ww.prototype;
        p.getNumReferences = function() {
            return this.h ? this.h.timeline.length : 0;
        };
        p.release = function() {
            Xl.prototype.release.call(this);
            this.h = null;
        };
        p.cb = function(a) {
            if (this.h) {
                for(var b = 0, c = this.h.timeline, d = 0; d < c.length; d += 1)if (c[d].end + this.j <= a) b += 1;
                else break;
                b > 0 && (this.h.timeline = c.slice(b), this.g.length >= b && (this.g = this.g.slice(b)), this.i += b, this.getNumReferences() === 0 && this.release());
            }
        };
        function vw(a, b, c, d, e, f) {
            yw(a, e);
            a.F = f;
            if (a.h) {
                a.h.wd !== b.wd && (a.h.timeline = b.timeline, a.h.wd = b.wd, a.h.Qb = b.Qb);
                a.h.jc !== b.jc && (a.h.jc = b.jc);
                c = a.h.timeline;
                if (c.length) {
                    var g = c[c.length - 1];
                    b = b.timeline.filter(function(h) {
                        return h.end > g.end;
                    });
                } else b = b.timeline.slice();
                b.length > 0 && a.h.timeline.push.apply(a.h.timeline, x(b));
                a.l !== d && (a.l = d);
            } else a.h = b, a.j = c, a.l = d;
            xw(a);
        }
        function yw(a, b) {
            if (a.A !== b) {
                a.A = b;
                a = u(a.g);
                for(var c = a.next(); !c.done; c = a.next())(c = c.value) && Bj(c, b);
            }
        }
        function xw(a) {
            if (a.h && !a.u) {
                for(var b = [], c = u(a.h.timeline), d = c.next(); !d.done; d = c.next())d = d.value, d.start >= a.l || d.end <= 0 || b.push(d);
                a.h.timeline = b;
                a.cb(a.j);
            }
        }
        p.find = function(a) {
            if (this.h && this.h.timeline && this.h.timeline.length && a < this.h.timeline[0].start + this.j) return this.i;
            if (!this.h) return null;
            var b = this.h.timeline;
            if (a < this.j || a >= this.l) return null;
            for(var c = b.length - 1, d = 0; d < b.length; d++){
                var e = b[d], f = e.start + this.j;
                e = d < c ? b[d + 1].start + this.j : this.l === Infinity ? e.end + this.j : this.l;
                if (a >= f && a < e) return d + this.i;
            }
            return null;
        };
        p.get = function(a) {
            var b = this;
            a -= this.i;
            if (a < 0 || a >= this.getNumReferences() || !this.h) return null;
            var c = this.g[a];
            if (!c) {
                c = this.h.timeline[a];
                var d = c.pm, e = c.xi + this.h.wd, f = this.j - this.h.Qb, g = this.j + c.end, h = g;
                a === this.getNumReferences() - 1 && this.l !== Infinity && (h = this.F && Math.abs(h - this.l) > .1 ? Math.min(h, this.l) : this.l);
                var k = this.h.codecs, l = this.h.mimeType, m = this.h.bandwidth, n = [], q = !1;
                c.Fc && this.h && this.h.jc && (q = this.h.jc.includes("$SubNumber$"));
                if (q) {
                    q = (c.end - c.start) / c.Fc;
                    for(var r = {}, t = 0; t < c.Fc; r = {
                        sg: void 0,
                        Uj: void 0
                    }, t++){
                        var w = c.start + q * t, v = w + q;
                        r.Uj = t;
                        r.sg = null;
                        r = new yj(this.j + w, this.j + v, function(z) {
                            return function() {
                                if (!b.h) return [];
                                z.sg == null && (z.sg = zw(b.h.jc, b.H, d, b.D, e, z.Uj, b.G, b.J));
                                return z.sg;
                            };
                        }(r), 0, null, this.A, f, this.j, this.l, [], "", null, null, zj, this.C);
                        r.codecs = k;
                        r.mimeType = l;
                        r.bandwidth = m;
                        this.I == 0 ? t > 0 && r.Nd() : t % this.I != 0 && r.Nd();
                        n.push(r);
                    }
                }
                c = new yj(this.j + c.start, h, function() {
                    return n.length > 0 || !b.h ? [] : zw(b.h.jc, b.H, d, b.D, e, null, b.G, b.J);
                }, 0, null, this.A, f, this.j, this.l, n, "", null, null, zj, this.C, n.length > 0);
                c.codecs = k;
                c.mimeType = l;
                c.j = g;
                c.bandwidth = m;
                this.g[a] = c;
            }
            return c;
        };
        p.Lb = function(a) {
            xw(this);
            for(var b = 0; b < this.getNumReferences(); b++){
                var c = this.get(b + this.i);
                c && a(c);
            }
        };
        function zw(a, b, c, d, e, f, g, h) {
            a = Mv(a, b, c, f, d || null, e);
            return mc(g(), [
                a
            ], h()).map(function(k) {
                return k.toString();
            });
        }
        p.nf = function() {
            return this.K;
        };
        function Aw(a) {
            this.u = null;
            this.C = a;
            this.H = new Tg;
            this.i = [];
            this.h = null;
            this.m = [];
            this.D = null;
            this.G = [];
            this.F = 300;
            this.l = new Map;
            this.j = new Map;
            this.g = null;
            this.A = "UNKNOWN";
        }
        Aw.prototype.configure = function(a) {
            this.u = a;
        };
        Aw.prototype.destroy = function() {
            this.C = this.u = null;
            this.i = [];
            this.h = null;
            this.m = [];
            this.G = [];
            this.l.clear();
            this.g != null && (this.g.stop(), this.g = null);
            return this.H.destroy();
        };
        Aw.prototype.setManifestType = function(a) {
            this.A = a;
        };
        function Bw(a, b) {
            var c, d, e, f, g, h, k;
            return Q(function(l) {
                if (l.g == 1) return c = mc(a.i, [
                    Cw(a, b)
                ]), d = $g(c, a.u.retryParameters), e = a.C.networkingEngine.request(8, d), Ug(a.H, e), ra(l, 2), F(l, e.promise, 4);
                if (l.g != 2) return f = l.h, g = Wb(f.data), h = JSON.parse(g), h.VERSION == 1 && Dw(a, h, f.uri), ta(l, 0);
                if ((k = ua(l)) && k.code == 7001) return l.return();
                a.g != null && (a.g.stop(), a.g = null);
                a.g = new Bf(function() {
                    Bw(a, b);
                });
                a.g.$(a.F);
                H(l);
            });
        }
        function Cw(a, b) {
            if (!a.m.length) return b;
            b = new qb(b);
            var c = a.D || a.m[0], d = Math.round(a.C.getBandwidthEstimate()), e = b.g;
            a.A == "DASH" ? (e.add("_DASH_pathway", c), e.add("_DASH_throughput", String(d))) : a.A == "HLS" && (e.add("_HLS_pathway", c), e.add("_HLS_throughput", String(d)));
            Hb(e) && ub(b, e);
            return b.toString();
        }
        function Dw(a, b, c) {
            a.g != null && (a.g.stop(), a.g = null);
            var d = b["RELOAD-URI"] || c;
            a.g = new Bf(function() {
                Bw(a, d);
            });
            if (c = b.TTL) a.F = c;
            a.g.$(a.F);
            a.m = b["PATHWAY-PRIORITY"] || [];
            a.G = b["PATHWAY-CLONES"] || [];
        }
        function Ew(a, b, c, d) {
            var e = a.l.get(b);
            e || (e = new Map);
            e.set(c, d);
            a.l.set(b, e);
        }
        Aw.prototype.banLocation = function(a) {
            this.j.set(a, Date.now() + 6E4);
        };
        function Fw(a, b, c) {
            c = c === void 0 ? !1 : c;
            b = a.l.get(b) || new Map;
            for(var d = [], e = u(a.m), f = e.next(), g = {}; !f.done; g = {
                Rd: void 0
            }, f = e.next())if (g.Rd = f.value, f = b.get(g.Rd)) d.push({
                Qh: g.Rd,
                location: f
            });
            else if (f = a.G.find(function(k) {
                return function(l) {
                    return l.an == k.Rd;
                };
            }(g))) {
                var h = b.get(f["BASE-ID"]);
                h && (f["URI-REPLACEMENT"].ik ? (h = new qb(h), sb(h, f["URI-REPLACEMENT"].ik), d.push({
                    Qh: g.Rd,
                    location: h.toString()
                })) : d.push({
                    Qh: g.Rd,
                    location: h
                }));
            }
            e = Date.now();
            g = u(a.j.keys());
            for(f = g.next(); !f.done; f = g.next())f = f.value, h = a.j.get(f), e > h && a.j.delete(f);
            d = d.filter(function(k) {
                for(var l = u(a.j.keys()), m = l.next(); !m.done; m = l.next())if (m.value.includes(new qb(k.location).Jb)) return !1;
                return !0;
            });
            d.length && (a.D = d[0].Qh);
            d = d.map(function(k) {
                return k.location;
            });
            if (!d.length && a.h) {
                for(e = u(a.h.split(",")), g = e.next(); !g.done; g = e.next())if (g = b.get(g.value)) a.D = a.h, d.push(g);
            }
            if (!d.length) for(b = u(b.values()), e = b.next(); !e.done; e = b.next())d.push(e.value);
            return c ? d : mc(a.i, d);
        }
        function Gw() {
            this.l = [];
            this.h = [];
            this.g = [];
            this.j = [];
            this.i = [];
            this.u = !1;
            this.m = new Set;
        }
        p = Gw.prototype;
        p.release = function() {
            for(var a = u(this.h.concat(this.g, this.j, this.i)), b = a.next(); !b.done; b = a.next())b = b.value, b.segmentIndex && b.segmentIndex.release();
            this.h = [];
            this.g = [];
            this.j = [];
            this.i = [];
            this.l = [];
            this.u = !1;
            this.m.clear();
        };
        p.xl = function() {
            return this.l;
        };
        p.wh = function() {
            return this.j.slice();
        };
        p.Pk = function() {
            return this.i;
        };
        p.Ri = function(a, b) {
            if (a) {
                if (a.type == "audio") for(var c = u(this.h), d = c.next(); !d.done; d = c.next())d = d.value, d.matchedStreams = d.matchedStreams.filter(function(e) {
                    return e !== a;
                });
                else if (a.type == "video") for(c = u(this.g), d = c.next(); !d.done; d = c.next())d = d.value, d.matchedStreams = d.matchedStreams.filter(function(e) {
                    return e !== a;
                }), d.trickModeVideo && (d.trickModeVideo.matchedStreams = d.trickModeVideo.matchedStreams.filter(function(e) {
                    return e !== a;
                })), d.dependencyStream && (d.dependencyStream.matchedStreams = d.dependencyStream.matchedStreams.filter(function(e) {
                    return e !== a;
                }));
                else if (a.type == sc) for(c = u(this.j), d = c.next(); !d.done; d = c.next())d = d.value, d.matchedStreams = d.matchedStreams.filter(function(e) {
                    return e !== a;
                });
                else if (a.type == "image") for(c = u(this.i), d = c.next(); !d.done; d = c.next())d = d.value, d.matchedStreams = d.matchedStreams.filter(function(e) {
                    return e !== a;
                });
                a.segmentIndex && a.closeSegmentIndex();
                this.m.delete(b);
            }
        };
        function Hw(a, b) {
            var c = [], d = [], e = [], f = [];
            a = u(a);
            for(var g = a.next(); !g.done; g = a.next()){
                var h = g.value;
                g = new Map(h.audioStreams.map(function(n) {
                    return [
                        Iw(n),
                        n
                    ];
                }));
                var k = new Map(h.videoStreams.map(function(n) {
                    return [
                        Jw(n),
                        n
                    ];
                })), l = new Map(h.textStreams.map(function(n) {
                    return [
                        Kw(n),
                        n
                    ];
                }));
                h = new Map(h.imageStreams.map(function(n) {
                    return [
                        Lw(n),
                        n
                    ];
                }));
                if (b) {
                    var m = Mw(sc);
                    l.set(Kw(m), m);
                    m = Mw("image");
                    h.set(Lw(m), m);
                }
                c.push(g);
                d.push(k);
                e.push(l);
                f.push(h);
            }
            return {
                Hi: c,
                fk: d,
                Zj: e,
                ej: f
            };
        }
        p.Og = function(a, b, c) {
            c = c === void 0 ? !1 : c;
            var d = this, e, f, g, h, k, l, m, n, q, r, t, w, v, z, y, A, C, E, D, B, G, I, J, L, K, N, P, O, M, R, W, wa;
            return Q(function(Y) {
                if (Y.g == 1) {
                    e = uc;
                    if (!b && a.length == 1) return f = Hw(a, !1), g = f.Hi, h = f.fk, k = f.Zj, l = f.ej, d.h = Array.from(g[0].values()), d.g = Array.from(h[0].values()), d.j = Array.from(k[0].values()), d.i = Array.from(l[0].values()), Y.B(2);
                    m = c ? d.m.size : 0;
                    n = -1;
                    for(q = 0; q < a.length; q++)r = a[q], d.m.has(r.id) || (d.m.add(r.id), n == -1 && (n = q));
                    if (n == -1) return Y.return();
                    t = Hw(a, !0);
                    w = t.Hi;
                    v = t.fk;
                    z = t.Zj;
                    y = t.ej;
                    return F(Y, Promise.all([
                        Nw(d, d.h, w, n, Ow, Pw, m),
                        Nw(d, d.g, v, n, Ow, Pw, m),
                        Nw(d, d.j, z, n, Ow, Pw, m),
                        Nw(d, d.i, y, n, Ow, Pw, m)
                    ]), 2);
                }
                A = 0;
                C = [];
                if (d.g.length && d.h.length) for(L = u(d.h), K = L.next(); !K.done; K = L.next())for(N = K.value, P = u(d.g), O = P.next(); !O.done; O = P.next())M = O.value, R = yg(N.drmInfos, M.drmInfos), N.drmInfos.length && M.drmInfos.length && !R.length || (W = (N.bandwidth || 0) + (M.bandwidth || 0), N.dependencyStream && (W += N.dependencyStream.bandwidth || 0), M.dependencyStream && (W += M.dependencyStream.bandwidth || 0), wa = A++, C.push({
                    id: wa,
                    language: N.language,
                    disabledUntilTime: 0,
                    primary: N.primary,
                    audio: N,
                    video: M,
                    bandwidth: W,
                    drmInfos: R,
                    allowedByApplication: !0,
                    allowedByKeySystem: !0,
                    decodingInfos: []
                }));
                else for(E = d.g.length ? d.g : d.h, D = u(E), B = D.next(); !B.done; B = D.next())G = B.value, I = A++, J = G.bandwidth || 0, G.dependencyStream && (J += G.dependencyStream.bandwidth || 0), C.push({
                    id: I,
                    language: G.language,
                    disabledUntilTime: 0,
                    primary: G.primary,
                    audio: G.type == e.na ? G : null,
                    video: G.type == e.Ia ? G : null,
                    bandwidth: J,
                    drmInfos: G.drmInfos,
                    allowedByApplication: !0,
                    allowedByKeySystem: !0,
                    decodingInfos: []
                });
                d.l = C;
                H(Y);
            });
        };
        function Qw(a) {
            var b, c, d, e, f, g, h, k, l, m, n, q, r, t, w, v, z, y, A, C, E, D, B, G, I, J, L, K, N, P;
            return Q(function(O) {
                switch(O.g){
                    case 1:
                        b = uc;
                        if (a.length == 1) return O.return(a[0]);
                        c = a.map(function(M) {
                            return new Map(M.filter(function(R) {
                                return R.type === b.na;
                            }).map(function(R) {
                                return [
                                    Iw(R),
                                    R
                                ];
                            }));
                        });
                        d = a.map(function(M) {
                            return new Map(M.filter(function(R) {
                                return R.type === b.Ia;
                            }).map(function(R) {
                                return [
                                    Jw(R),
                                    R
                                ];
                            }));
                        });
                        e = a.map(function(M) {
                            return new Map(M.filter(function(R) {
                                return R.type === b.Va;
                            }).map(function(R) {
                                return [
                                    Kw(R),
                                    R
                                ];
                            }));
                        });
                        f = a.map(function(M) {
                            return new Map(M.filter(function(R) {
                                return R.type === b.yg;
                            }).map(function(R) {
                                return [
                                    Lw(R),
                                    R
                                ];
                            }));
                        });
                        g = u(e);
                        for(h = g.next(); !h.done; h = g.next())k = h.value, l = Rw(b.Va), k.set(Kw(l), l);
                        m = u(f);
                        for(n = m.next(); !n.done; n = m.next())q = n.value, r = Rw(b.yg), q.set(Lw(r), r);
                        t = new Gw;
                        return F(O, Nw(t, [], c, 0, Sw, Tw, 0), 2);
                    case 2:
                        return w = O.h, F(O, Nw(t, [], d, 0, Sw, Tw, 0), 3);
                    case 3:
                        return v = O.h, F(O, Nw(t, [], e, 0, Sw, Tw, 0), 4);
                    case 4:
                        return z = O.h, F(O, Nw(t, [], f, 0, Sw, Tw, 0), 5);
                    case 5:
                        y = O.h;
                        A = 0;
                        if (v.length && w.length) for(G = u(w), I = G.next(); !I.done; I = G.next())for(J = I.value, L = u(v), K = L.next(); !K.done; K = L.next())N = K.value, P = A++, N.variantIds.push(P), J.variantIds.push(P);
                        else for(C = v.concat(w), E = u(C), D = E.next(); !D.done; D = E.next())B = D.value, B.variantIds = [
                            A++
                        ];
                        return O.return(v.concat(w).concat(z).concat(y));
                }
            });
        }
        function Nw(a, b, c, d, e, f, g) {
            var h, k, l, m, n, q, r, t, w, v, z, y, A, C, E, D, B, G, I, J;
            return Q(function(L) {
                switch(L.g){
                    case 1:
                        h = [];
                        for(k = 0; k < c.length; k++)k >= d ? h.push(new Set(c[k].values())) : h.push(new Set);
                        l = u(b);
                        m = l.next();
                    case 2:
                        if (m.done) {
                            L.B(4);
                            break;
                        }
                        n = m.value;
                        return F(L, Uw(a, n, c, d, f, h, g), 5);
                    case 5:
                        q = L.h;
                        if (!q) throw new U(2, 4, 4037);
                        m = l.next();
                        L.B(2);
                        break;
                    case 4:
                        r = u(h);
                        for(t = r.next(); !t.done; t = r.next())for(w = t.value, v = u(w), z = v.next(); !z.done; z = v.next())y = z.value, (A = Vw(a, y, c, e, f, h)) && b.push(A);
                        C = u(h);
                        for(E = C.next(); !E.done; E = C.next())for(D = E.value, B = u(D), G = B.next(), I = {}; !G.done; I = {
                            li: void 0
                        }, G = B.next())if (I.li = G.value, !Ww(I.li) && (J = b.some(function(K) {
                            return function(N) {
                                return Xw(K.li, N);
                            };
                        }(I)))) throw new U(2, 4, 4037);
                        return L.return(b);
                }
            });
        }
        function Uw(a, b, c, d, e, f, g) {
            return Q(function(h) {
                if (h.g == 1) return Yw(a, c, b, g > 0), b.matchedStreams ? b.segmentIndex ? F(h, Zw(b, d + g), 2) : h.B(2) : h.return(!1);
                $w(b, d, e, f, g);
                return h.return(!0);
            });
        }
        function Zw(a, b) {
            var c, d, e, f, g, h;
            return Q(function(k) {
                if (k.g == 1) {
                    c = [];
                    d = a.matchedStreams;
                    for(e = b; e < d.length; e++)f = d[e], c.push(f.createSegmentIndex()), f.trickModeVideo && !f.trickModeVideo.segmentIndex && c.push(f.trickModeVideo.createSegmentIndex()), f.dependencyStream && !f.dependencyStream.segmentIndex && c.push(f.dependencyStream.createSegmentIndex());
                    return F(k, Promise.all(c), 2);
                }
                if (a.segmentIndex instanceof $l) for(g = b; g < d.length; g++)h = d[g], h.segmentIndex && a.segmentIndex.h.push(h.segmentIndex);
                H(k);
            });
        }
        function Vw(a, b, c, d, e, f) {
            if (Ww(b)) return null;
            var g = d(b);
            Yw(a, c, g);
            g.createSegmentIndex && (g.createSegmentIndex = function() {
                return Q(function(h) {
                    if (g.segmentIndex) return h.B(0);
                    g.segmentIndex = new $l;
                    return F(h, Zw(g, 0), 0);
                });
            });
            if (!g.matchedStreams || !g.matchedStreams.length) return null;
            $w(g, 0, e, f, 0);
            return g;
        }
        function $w(a, b, c, d, e) {
            var f = a.matchedStreams;
            for(b += e; b < f.length; b++){
                var g = f[b];
                c(a, g);
                var h = !0;
                a.type == "audio" && Ec(a.language, g.language) == 0 && (h = !1);
                if (h && (d[b - e].delete(g), g.fullMimeTypes)) for(g = u(g.fullMimeTypes.values()), h = g.next(); !h.done; h = g.next())a.fullMimeTypes.add(h.value);
            }
        }
        function Ow(a) {
            var b = Object.assign({}, a);
            b.originalId = null;
            b.createSegmentIndex = function() {
                return Promise.resolve();
            };
            b.closeSegmentIndex = function() {
                b.segmentIndex && (b.segmentIndex.release(), b.segmentIndex = null);
                if (b.matchedStreams) for(var c = u(b.matchedStreams), d = c.next(); !d.done; d = c.next())d = d.value, d.segmentIndex && (d.segmentIndex.release(), d.segmentIndex = null);
            };
            b.roles = b.roles.slice();
            b.segmentIndex = null;
            b.emsgSchemeIdUris = [];
            b.keyIds = new Set(a.keyIds);
            b.closedCaptions = a.closedCaptions ? new Map(a.closedCaptions) : null;
            b.trickModeVideo = null;
            b.dependencyStream = null;
            return b;
        }
        function Sw(a) {
            var b = Object.assign({}, a);
            b.roles = b.roles.slice();
            b.keyIds = new Set(a.keyIds);
            b.segments = [];
            b.variantIds = [];
            b.closedCaptions = a.closedCaptions ? new Map(a.closedCaptions) : null;
            return b;
        }
        function Pw(a, b) {
            function c(g, h) {
                g || (g = []);
                h = u(h);
                for(var k = h.next(); !k.done; k = h.next())k = k.value, g.includes(k) || g.push(k);
                return g;
            }
            a.roles = c(a.roles, b.roles);
            b.emsgSchemeIdUris && (a.emsgSchemeIdUris = c(a.emsgSchemeIdUris, b.emsgSchemeIdUris));
            for(var d = u(b.keyIds), e = d.next(); !e.done; e = d.next())a.keyIds.add(e.value);
            a.originalId == null ? a.originalId = b.originalId : (d = b.originalId || "") && !a.originalId.endsWith(d) && (a.originalId += "," + d);
            d = yg(a.drmInfos, b.drmInfos);
            if (b.drmInfos.length && a.drmInfos.length && !d.length) throw new U(2, 4, 4038);
            a.drmInfos = d;
            a.encrypted = a.encrypted || b.encrypted;
            if (b.closedCaptions) for(a.closedCaptions || (a.closedCaptions = new Map), d = u(b.closedCaptions), e = d.next(); !e.done; e = d.next()){
                var f = u(e.value);
                e = f.next().value;
                f = f.next().value;
                a.closedCaptions.set(e, f);
            }
            a.bandwidth && b.bandwidth && (a.bandwidth = Math.max(a.bandwidth, b.bandwidth));
            b.trickModeVideo ? (a.trickModeVideo || (a.trickModeVideo = Ow(b.trickModeVideo), a.trickModeVideo.matchedStreams = [], a.trickModeVideo.createSegmentIndex = function() {
                if (a.trickModeVideo.segmentIndex) return Promise.resolve();
                for(var g = new $l, h = u(a.trickModeVideo.matchedStreams), k = h.next(); !k.done; k = h.next())g.h.push(k.value.segmentIndex);
                a.trickModeVideo.segmentIndex = g;
                return Promise.resolve();
            }), a.trickModeVideo.matchedStreams.push(b.trickModeVideo), Pw(a.trickModeVideo, b.trickModeVideo)) : a.trickModeVideo && (a.trickModeVideo.matchedStreams.push(b), Pw(a.trickModeVideo, b));
            b.dependencyStream ? (a.dependencyStream || (a.dependencyStream = Ow(b.dependencyStream), a.dependencyStream.matchedStreams = [], a.dependencyStream.createSegmentIndex = function() {
                if (a.dependencyStream.segmentIndex) return Promise.resolve();
                for(var g = new $l, h = u(a.dependencyStream.matchedStreams), k = h.next(); !k.done; k = h.next())g.h.push(k.value.segmentIndex);
                a.dependencyStream.segmentIndex = g;
                return Promise.resolve();
            }), a.dependencyStream.matchedStreams.push(b.dependencyStream), Pw(a.dependencyStream, b.dependencyStream)) : a.dependencyStream && (a.dependencyStream.matchedStreams.push(b), Pw(a.dependencyStream, b));
        }
        function Tw(a, b) {
            var c = a.roles;
            c || (c = []);
            for(var d = u(b.roles), e = d.next(); !e.done; e = d.next())e = e.value, c.includes(e) || c.push(e);
            a.roles = c;
            c = u(b.keyIds);
            for(d = c.next(); !d.done; d = c.next())a.keyIds.add(d.value);
            a.encrypted = a.encrypted && b.encrypted;
            a.segments.push.apply(a.segments, x(b.segments));
            if (b.closedCaptions) for(a.closedCaptions || (a.closedCaptions = new Map), b = u(b.closedCaptions), c = b.next(); !c.done; c = b.next())d = u(c.value), c = d.next().value, d = d.next().value, a.closedCaptions.set(c, d);
        }
        function Yw(a, b, c, d) {
            d = (d === void 0 ? 0 : d) ? c.matchedStreams : [];
            b = u(b);
            for(var e = b.next(); !e.done; e = b.next()){
                e = ax(a, e.value, c);
                if (!e) return;
                d.push(e);
            }
            c.matchedStreams = d;
        }
        function ax(a, b, c) {
            var d = {
                audio: Iw,
                video: Jw,
                text: Kw,
                image: Lw
            }[c.type], e = null, f = d(c);
            if (b.has(f)) e = b.get(f);
            else {
                f = ({
                    audio: function(l, m) {
                        return Xw(l, m);
                    },
                    video: function(l, m) {
                        return Xw(l, m);
                    },
                    text: bx,
                    image: cx
                })[c.type];
                for(var g = {
                    audio: dx,
                    video: ex,
                    text: fx,
                    image: gx
                }[c.type], h = u(b.values()), k = h.next(); !k.done; k = h.next())k = k.value, !f(c, k) || c.fastSwitching != k.fastSwitching || e && !g(c, e, k) || (e = k);
            }
            a.u && !Ww(e) && b.delete(d(e));
            return e;
        }
        function hx(a, b) {
            return a.mimeType != b.mimeType ? !1 : ix(a.codecs) === ix(b.codecs);
        }
        p.Oj = function(a) {
            this.u = a;
        };
        function Xw(a, b) {
            return a.drmInfos && !wg(a.drmInfos, b.drmInfos) ? !1 : !0;
        }
        function bx(a, b) {
            return b.language ? a.forced !== b.forced || Ec(a.language, b.language) == 0 || b.kind != a.kind ? !1 : !0 : !0;
        }
        function cx() {
            return !0;
        }
        function dx(a, b, c) {
            var d = jx(a, b, c);
            if (d === kx) return !0;
            if (d === lx) return !1;
            d = Ec(a.language, b.language);
            var e = Ec(a.language, c.language);
            if (e > d) return !0;
            if (e < d) return !1;
            if (b.label !== c.label) {
                if (a.label === b.label) return !1;
                if (a.label === c.label) return !0;
            }
            if (a.roles.length) {
                d = b.roles.filter(function(f) {
                    return a.roles.includes(f);
                });
                e = c.roles.filter(function(f) {
                    return a.roles.includes(f);
                });
                if (e.length > d.length) return !0;
                if (e.length < d.length) return !1;
                if (c.roles.length !== b.roles.length) return c.roles.length < b.roles.length;
            } else {
                if (!c.roles.length && b.roles.length) return !0;
                if (c.roles.length && !b.roles.length) return !1;
            }
            if (!b.primary && c.primary) return !0;
            if (b.primary && !c.primary) return !1;
            d = mx(a.channelsCount, b.channelsCount, c.channelsCount);
            if (d == kx) return !0;
            if (d == lx) return !1;
            d = mx(a.audioSamplingRate, b.audioSamplingRate, c.audioSamplingRate);
            return d == kx ? !0 : d == lx ? !1 : a.bandwidth && nx(a.bandwidth, b.bandwidth, c.bandwidth) == kx ? !0 : !1;
        }
        function ex(a, b, c) {
            var d = jx(a, b, c);
            if (d === kx) return !0;
            if (d === lx) return !1;
            d = mx(a.width * a.height, b.width * b.height, c.width * c.height);
            if (d == kx) return !0;
            if (d == lx) return !1;
            if (a.frameRate) {
                d = mx(a.frameRate, b.frameRate, c.frameRate);
                if (d == kx) return !0;
                if (d == lx) return !1;
            }
            return a.bandwidth && nx(a.bandwidth, b.bandwidth, c.bandwidth) == kx ? !0 : !1;
        }
        function fx(a, b, c) {
            var d = Ec(a.language, b.language), e = Ec(a.language, c.language);
            if (e > d) return !0;
            if (e < d) return !1;
            if (!b.primary && c.primary) return !0;
            if (b.primary && !c.primary) return !1;
            if (b.label !== c.label) {
                if (a.label === b.label) return !1;
                if (a.label === c.label) return !0;
            }
            if (a.roles.length) {
                d = b.roles.filter(function(f) {
                    return a.roles.includes(f);
                });
                e = c.roles.filter(function(f) {
                    return a.roles.includes(f);
                });
                if (e.length > d.length) return !0;
                if (e.length < d.length) return !1;
            } else {
                if (!c.roles.length && b.roles.length) return !0;
                if (c.roles.length && !b.roles.length) return !1;
            }
            return c.mimeType != a.mimeType || c.codecs != a.codecs || b.mimeType == a.mimeType && b.codecs == a.codecs ? !1 : !0;
        }
        function gx(a, b, c) {
            return mx(a.width * a.height, b.width * b.height, c.width * c.height) == kx ? !0 : !1;
        }
        function Rw(a) {
            return {
                id: 0,
                originalId: "",
                groupId: null,
                primary: !1,
                type: a,
                mimeType: "",
                codecs: "",
                language: "",
                originalLanguage: null,
                label: null,
                width: null,
                height: null,
                encrypted: !1,
                keyIds: new Set,
                segments: [],
                variantIds: [],
                roles: [],
                forced: !1,
                channelsCount: null,
                audioSamplingRate: null,
                spatialAudio: !1,
                closedCaptions: null,
                external: !1,
                fastSwitching: !1,
                isAudioMuxedInVideo: !1,
                baseOriginalId: null
            };
        }
        function Mw(a) {
            return {
                id: 0,
                originalId: "",
                groupId: null,
                createSegmentIndex: function() {
                    return Promise.resolve();
                },
                segmentIndex: new Xl([]),
                mimeType: "",
                codecs: "",
                encrypted: !1,
                drmInfos: [],
                keyIds: new Set,
                language: "",
                originalLanguage: null,
                label: null,
                type: a,
                primary: !1,
                trickModeVideo: null,
                dependencyStream: null,
                emsgSchemeIdUris: null,
                roles: [],
                forced: !1,
                channelsCount: null,
                audioSamplingRate: null,
                spatialAudio: !1,
                closedCaptions: null,
                accessibilityPurpose: null,
                external: !1,
                fastSwitching: !1,
                fullMimeTypes: new Set,
                isAudioMuxedInVideo: !1,
                baseOriginalId: null
            };
        }
        function mx(a, b, c) {
            if (b == a && a != c) return lx;
            if (c == a && a != b) return kx;
            if (b > a) {
                if (c <= a || c - a < b - a) return kx;
                if (c - a > b - a) return lx;
            } else {
                if (c > a) return lx;
                if (a - c < a - b) return kx;
                if (a - c > a - b) return lx;
            }
            return ox;
        }
        function jx(a, b, c) {
            var d = a.mimeType === b.mimeType && a.codecs === b.codecs, e = a.mimeType === c.mimeType && a.codecs === c.codecs;
            if (d && !e) return lx;
            if (!d && e) return kx;
            b = hx(a, b);
            a = hx(a, c);
            return b && !a ? lx : !b && a ? kx : ox;
        }
        function nx(a, b, c) {
            b = Math.abs(a - b);
            a = Math.abs(a - c);
            return a < b ? kx : b < a ? lx : ox;
        }
        function Ww(a) {
            switch(a.type){
                case sc:
                    return !a.language;
                case "image":
                    return !a.tilesLayout;
                default:
                    return !1;
            }
        }
        function Jw(a) {
            return px([
                a.fastSwitching,
                a.width,
                a.frameRate,
                a.codecs,
                a.mimeType,
                a.label,
                a.roles,
                a.closedCaptions ? Array.from(a.closedCaptions.entries()) : null,
                a.bandwidth,
                a.dependencyStream ? a.dependencyStream.baseOriginalId : null,
                Array.from(a.keyIds)
            ]);
        }
        function Iw(a) {
            return px([
                a.fastSwitching,
                a.channelsCount,
                a.language,
                a.bandwidth,
                a.label,
                a.codecs,
                a.mimeType,
                a.roles,
                a.audioSamplingRate,
                a.primary,
                a.dependencyStream ? a.dependencyStream.baseOriginalId : null,
                Array.from(a.keyIds)
            ]);
        }
        function Kw(a) {
            return px([
                a.language,
                a.label,
                a.codecs,
                a.mimeType,
                a.bandwidth,
                a.roles
            ]);
        }
        function Lw(a) {
            return px([
                a.width,
                a.codecs,
                a.mimeType
            ]);
        }
        function px(a) {
            return JSON.stringify(a);
        }
        function ix(a) {
            if (!qx.has(a)) {
                var b = jf(a);
                qx.set(a, b);
            }
            return qx.get(a);
        }
        S("shaka.util.PeriodCombiner", Gw);
        Gw.prototype.setUseStreamOnce = Gw.prototype.Oj;
        Gw.prototype.combinePeriods = Gw.prototype.Og;
        Gw.prototype.deleteStream = Gw.prototype.Ri;
        Gw.prototype.getImageStreams = Gw.prototype.Pk;
        Gw.prototype.getTextStreams = Gw.prototype.wh;
        Gw.prototype.getVariants = Gw.prototype.xl;
        var kx = 1, ox = 0, lx = -1, qx = new Map;
        function rx(a, b) {
            var c = new DOMParser, d = sx.value()(a);
            a = null;
            try {
                a = c.parseFromString(d, "text/xml");
            } catch (e) {
                return null;
            }
            c = a.documentElement;
            if (!c || c.getElementsByTagName("parsererror").length || c.tagName != b) return null;
            if (!("createNodeIterator" in document)) return c;
            for(b = document.createNodeIterator(a, NodeFilter.SHOW_ALL); a = b.nextNode();)if (a instanceof HTMLElement || a instanceof SVGElement) return null;
            return c;
        }
        function tx(a, b) {
            try {
                var c = Zb(a);
                return rx(c, b);
            } catch (d) {
                return null;
            }
        }
        var sx = new Qb(function() {
            if (typeof trustedTypes !== "undefined") {
                var a = trustedTypes.createPolicy("shaka-player#xml", {
                    createHTML: function(b) {
                        return b;
                    }
                });
                return function(b) {
                    return a.createHTML(b);
                };
            }
            return function(b) {
                return b;
            };
        });
        function ux() {
            var a = this;
            this.j = this.g = null;
            this.C = [];
            this.h = null;
            this.Fa = 1;
            this.H = [];
            this.l = {
                Nf: "",
                type: "",
                profiles: [],
                Cc: null,
                Bb: 0,
                mb: null,
                De: 0
            };
            this.A = new Map;
            this.D = new Map;
            this.u = new Map;
            this.F = new Map;
            this.sa = new Map;
            this.m = new Gw;
            this.K = 0;
            this.xa = new Lc(5);
            this.L = new Bf(function() {
                if (a.J && !a.g.continueLoadingWhenPaused && (a.I.Ea(a.J, "timeupdate"), a.J.paused)) {
                    a.I.ua(a.J, "timeupdate", function() {
                        return vx(a);
                    });
                    return;
                }
                vx(a);
            });
            this.P = new Tg;
            this.O = null;
            this.G = [];
            this.Y = Infinity;
            this.oa = !1;
            this.i = null;
            this.M = 0;
            this.R = !1;
            this.I = new Tc;
            this.J = null;
            this.S = !1;
            this.X = "";
            this.ea = function() {
                return !1;
            };
            this.V = [];
            this.aa = new Set;
            this.ra = new Dv;
        }
        p = ux.prototype;
        p.configure = function(a, b) {
            var c = this.j && a.updatePeriod != this.g.updatePeriod && a.updatePeriod >= 0;
            this.g = a;
            b && (this.ea = b);
            c && this.h && this.h.presentationTimeline.U() && this.L.La();
            this.i && this.i.configure(this.g);
            this.m && this.m.Oj(this.g.dash.useStreamOnceInPeriodFlattening);
        };
        p.start = function(a, b) {
            var c = this, d;
            return Q(function(e) {
                if (e.g == 1) return c.oa = b.isLowLatencyMode(), c.C = [
                    a
                ], c.j = b, F(e, wx(c), 2);
                d = e.h;
                c.j && xx(c, d);
                if (!c.j) throw new U(2, 7, 7001);
                return e.return(c.h);
            });
        };
        p.stop = function() {
            for(var a = u(this.u.values()), b = a.next(); !b.done; b = a.next())b = b.value, b.segmentIndex && b.segmentIndex.release();
            this.m && this.m.release();
            this.g = this.j = null;
            this.C = [];
            this.h = null;
            this.u.clear();
            this.F.clear();
            this.A.clear();
            this.D.clear();
            this.l = {
                Nf: "",
                type: "",
                profiles: [],
                Cc: null,
                Bb: 0,
                mb: null,
                De: 0
            };
            this.m = null;
            this.L != null && (this.L.stop(), this.L = null);
            this.i && this.i.destroy();
            this.I && (this.I.release(), this.I = null);
            this.aa.clear();
            this.ra.release();
            return this.P.destroy();
        };
        p.update = function() {
            var a = this, b;
            return Q(function(c) {
                if (c.g == 1) return ra(c, 2), F(c, wx(a), 4);
                if (c.g != 2) return ta(c, 0);
                b = ua(c);
                if (!a.j || !b) return c.return();
                a.j.onError(b);
                H(c);
            });
        };
        p.onExpirationUpdated = function() {};
        p.onInitialVariantChosen = function(a) {
            if (this.h && this.h.presentationTimeline.U()) {
                var b = a.video || a.audio;
                if (b && b.segmentIndex) {
                    a = this.h.presentationTimeline.Sc();
                    var c = b.segmentIndex.find(a);
                    c != null && (b = b.segmentIndex.get(c)) && (this.K = b.endTime - a, xx(this, 0));
                }
            }
        };
        p.banLocation = function(a) {
            this.i && this.i.banLocation(a);
        };
        p.setMediaElement = function(a) {
            this.J = a;
        };
        function wx(a) {
            var b, c, d, e, f, g, h, k, l, m, n;
            return Q(function(q) {
                if (q.g == 1) return b = 4, c = "MPD", d = yx(a), e = a.C, d.length ? (e = d, c = "Patch", b = 6) : a.C.length > 1 && a.i && (f = Fw(a.i, "Location", !0), f.length && (e = f)), g = $g(e, a.g.retryParameters), h = Date.now(), F(q, zx(a, g, 0, {
                    type: b
                }), 2);
                if (q.g != 3) {
                    k = q.h;
                    if (!a.j) return q.return(0);
                    k.uri && k.uri != k.originalUri && !a.C.includes(k.uri) && a.C.unshift(k.uri);
                    l = new qb(k.uri);
                    a.X = l.g.toString();
                    return F(q, Ax(a, k.data, k.uri, c), 3);
                }
                m = Date.now();
                n = (m - h) / 1E3;
                a.xa.sample(1, n);
                a.aa.clear();
                return q.return(n);
            });
        }
        function Ax(a, b, c, d) {
            var e, f, g, h, k, l, m, n, q, r, t;
            return Q(function(w) {
                if (w.g == 1) {
                    e = b;
                    f = a.g.dash.manifestPreprocessor;
                    g = Yn;
                    if (f != g) {
                        Zc("manifest.dash.manifestPreprocessor configuration", "Please Use manifest.dash.manifestPreprocessorTXml instead.");
                        h = tx(e, d);
                        if (!h) throw new U(2, 4, 4001, c);
                        f(h);
                        e = $b(h.outerHTML);
                    }
                    k = Jd(e, d);
                    if (!k) throw new U(2, 4, 4001, c);
                    l = a.g.dash.manifestPreprocessorTXml;
                    m = Zn;
                    l != m && l(k);
                    if (d === "Patch") return w.return(Bx(a, k));
                    if (n = a.g.dash.disableXlinkProcessing) return w.return(Cx(a, k, c));
                    q = a.g.dash.xlinkFailGracefully;
                    r = Sv(k, a.g.retryParameters, q, c, a.j.networkingEngine);
                    Ug(a.P, r);
                    return F(w, r.promise, 2);
                }
                t = w.h;
                return w.return(Cx(a, t, c));
            });
        }
        function Cx(a, b, c) {
            var d, e, f, g, h, k, l, m, n, q, r, t, w, v, z, y, A, C, E, D, B, G, I, J, L, K, N, P, O, M, R, W, wa, Y, Ka, Na, La, Ea, za, Fa, Da, Aa, Ca, gb, ib, jb, Ab, yb, Wa, Yd, Oc, Je, Cd, Ag, Ik, fi;
            return Q(function(jd) {
                switch(jd.g){
                    case 1:
                        a.i && a.i.l.clear();
                        d = [
                            c
                        ];
                        e = [];
                        f = new Map;
                        g = Rd(b, "Location");
                        h = u(g);
                        for(k = h.next(); !k.done; k = h.next())if (l = k.value, m = l.attributes.serviceLocation, n = Td(l)) q = mc(d, [
                            n
                        ])[0], m && (a.i ? Ew(a.i, "Location", m, q) : f.set(m, q)), e.push(q);
                        a.i ? (r = Fw(a.i, "Location", !0), r.length > 0 && (d = a.C = r)) : e.length && (d = a.C = e);
                        a.l.Nf = b.attributes.id || "";
                        a.l.De = Zd(b, "publishTime", be) || 0;
                        a.H = Rd(b, "PatchLocation");
                        t = Promise.resolve();
                        if ((w = Vd(b, "ContentSteering")) && a.j) {
                            v = w.attributes.defaultServiceLocation;
                            if (a.i) a.i.i = d, a.i.h = v;
                            else if (a.i = new Aw(a.j), a.i.configure(a.g), a.i.setManifestType("DASH"), a.i.i = d, a.i.h = v, z = Td(w)) (y = Zd(w, "queryBeforeStart", ie, !1)) ? t = Bw(a.i, z) : Bw(a.i, z);
                            A = u(f.keys());
                            for(C = A.next(); !C.done; C = A.next())E = C.value, D = f.get(E), Ew(a.i, "Location", E, D);
                        }
                        B = Rd(b, "BaseURL");
                        G = !1;
                        if (a.i) for(I = u(B), J = I.next(); !J.done; J = I.next())L = J.value, K = L.attributes.serviceLocation, N = Td(L), K && N && (Ew(a.i, "BaseURL", K, N), G = !0);
                        a.V.splice(0);
                        G && a.i || (P = B.map(Td), a.V.push.apply(a.V, x(mc(d, P))));
                        O = a.i;
                        M = a.V;
                        R = function() {
                            return O && G ? Fw(O, "BaseURL") : M.slice();
                        };
                        a.l.mb = R;
                        W = 0;
                        B && B.length && (W = Zd(B[0], "availabilityTimeOffset", he) || 0);
                        a.l.Bb = W;
                        a.K = Zd(b, "minimumUpdatePeriod", ce, -1);
                        wa = Zd(b, "availabilityStartTime", be);
                        Y = Zd(b, "timeShiftBufferDepth", ce);
                        Ka = a.g.dash.ignoreSuggestedPresentationDelay;
                        Na = null;
                        Ka || (Na = Zd(b, "suggestedPresentationDelay", ce));
                        La = a.g.dash.ignoreMaxSegmentDuration;
                        Ea = null;
                        La || (Ea = Zd(b, "maxSegmentDuration", ce));
                        za = b.attributes.type || "static";
                        a.h && a.h.presentationTimeline && (a.S = a.h.presentationTimeline.U() && za == "static");
                        a.l.type = za;
                        if (a.h) for(Fa = a.h.presentationTimeline, Da = Fa.Nb(), Aa = u(a.u.values()), Ca = Aa.next(); !Ca.done; Ca = Aa.next())gb = Ca.value, gb.segmentIndex && gb.segmentIndex.cb(Da);
                        else ib = a.g.dash.ignoreMinBufferTime, jb = 0, ib || (jb = Zd(b, "minBufferTime", ce) || 0), Ab = 0, Ab = Na != null ? Math.min(Na, Y || Infinity) : a.g.defaultPresentationDelay > 0 ? a.g.defaultPresentationDelay : Math.min(jb * 1.5, Y || Infinity), Fa = new yl(wa, Ab, a.g.dash.autoCorrectDrift);
                        Fa.sd(za == "static");
                        (yb = Fa.U()) && !isNaN(a.g.availabilityWindowOverride) && (Y = a.g.availabilityWindowOverride);
                        Y == null && (Y = Infinity);
                        Fa.hg(Y);
                        Wa = b.attributes.profiles || "";
                        a.l.profiles = Wa.split(",");
                        Yd = {
                            Kb: za != "static",
                            presentationTimeline: Fa,
                            Aa: null,
                            qa: null,
                            va: null,
                            N: null,
                            bandwidth: 0,
                            Ch: !1,
                            Bb: W,
                            Cc: null,
                            profiles: Wa.split(","),
                            roles: null,
                            Sb: function() {
                                return "";
                            }
                        };
                        return F(jd, t, 2);
                    case 2:
                        a.M = 0;
                        Oc = Dx(a, Yd, R, b, !1);
                        Je = Oc.duration;
                        Cd = Oc.periods;
                        (za != "static" || a.S) && Oc.Ti || Fa.zb(Je || Infinity);
                        a.R && a.oa && Fa.Jj(a.Y);
                        Fa.Lh(Ea || 1);
                        a.R && a.oa && (Ag = Na != null ? Na : a.g.defaultPresentationDelay, Fa.ci(Ag));
                        if (!a.h) return F(jd, a.m.Og(Cd, Yd.Kb), 6);
                        a.h.periodCount = Cd.length;
                        a.h.gapCount = a.M;
                        return F(jd, Ex(a, Cd, !1), 4);
                    case 6:
                        a.h = {
                            presentationTimeline: Fa,
                            variants: a.m.l,
                            textStreams: a.m.wh(),
                            imageStreams: a.m.i,
                            offlineSessionIds: [],
                            sequenceMode: a.g.dash.sequenceMode,
                            ignoreManifestTimestampsInSegmentsMode: !1,
                            type: "DASH",
                            serviceDescription: Fx(b),
                            nextUrl: Gx(b),
                            periodCount: Cd.length,
                            gapCount: a.M,
                            isLowLatency: a.R,
                            startTime: null
                        };
                        if (!Fa.dk()) {
                            jd.B(7);
                            break;
                        }
                        Ik = Rd(b, "UTCTiming");
                        return F(jd, Hx(a, R, Ik), 8);
                    case 8:
                        fi = jd.h;
                        if (!a.j) return jd.return();
                        Fa.Kj(fi);
                    case 7:
                        Fa.Jf(), a.m && !a.h.presentationTimeline.U() && a.m.release();
                    case 4:
                        a.j.makeTextStreamsForClosedCaptions(a.h), Ix(a), Jx(a, Cd), H(jd);
                }
            });
        }
        function Ex(a, b, c) {
            var d;
            return Q(function(e) {
                if (e.g == 1) return F(e, a.m.Og(b, !0, c), 2);
                a.h.variants = a.m.l;
                d = a.m.wh();
                d.length > 0 && (a.h.textStreams = d);
                a.h.imageStreams = a.m.i;
                a.j.filter(a.h);
                H(e);
            });
        }
        function Bx(a, b) {
            var c, d, e, f, g, h, k, l, m, n, q, r, t, w, v, z, y, A, C, E, D, B, G, I, J, L, K;
            return Q(function(N) {
                if (N.g == 1) {
                    c = b.attributes.mpdId;
                    d = Zd(b, "originalPublishTime", be);
                    if (!c || c !== a.l.Nf || d !== a.l.De) throw a.H = [], new U(1, 4, 4052);
                    e = [];
                    f = [];
                    g = new Set;
                    h = u(Qd(b));
                    for(k = h.next(); !k.done; k = h.next())if (l = k.value, m = le(l.attributes.sel || ""), n = m[m.length - 1], q = Td(l) || "", n.name === "MPD") {
                        if (n.Mc === "mediaPresentationDuration") {
                            r = Td(l) || "";
                            var P = ce(r);
                            if (P != null) {
                                a.l.Cc = P;
                                for(var O = u(a.A.values()), M = O.next(); !M.done; M = O.next())M.value.Cc = P;
                            }
                        } else if (n.Mc === "type") {
                            a.h.presentationTimeline.sd(q == "static");
                            a.l.type = q;
                            P = u(a.A.values());
                            for(O = P.next(); !O.done; O = P.next())O.value.Kb = q == "dynamic";
                            q == "static" && (a.K = -1);
                        } else n.Mc === "publishTime" ? a.l.De = be(q) || 0 : n.Mc === null && l.tagName === "add" && f.push(l);
                    } else if (n.name === "PatchLocation") me(a.H, l);
                    else if (n.name === "Period") l.tagName === "add" ? f.push(l) : l.tagName === "remove" && n.id && Kx(a, n.id);
                    else if (n.name === "SegmentTemplate") {
                        O = le(l.attributes.sel || "");
                        P = O[O.length - 1];
                        if (P.Mc) {
                            O = Lx(a, O);
                            M = Td(l) || "";
                            for(var R = u(O), W = R.next(); !W.done; W = R.next())W = a.A.get(W.value), oe(W.N.Zc, l.tagName, P.Mc, M);
                            P = O;
                        } else P = [];
                        t = P;
                        w = u(t);
                        for(v = w.next(); !v.done; v = w.next())z = v.value, g.add(z);
                    } else if (n.name === "SegmentTimeline" || n.name === "S") {
                        P = le(l.attributes.sel || "");
                        P = Lx(a, P);
                        O = u(P);
                        for(M = O.next(); !M.done; M = O.next())M = a.A.get(M.value), M = Pv(M, qw, "SegmentTimeline"), R = Rd(M, "S"), me(R, l), M.children = R;
                        y = P;
                        A = u(y);
                        for(C = A.next(); !C.done; C = A.next())E = C.value, g.add(E);
                    }
                    D = u(g);
                    for(B = D.next(); !B.done; B = D.next())G = B.value, Mx(a, G);
                    I = u(f);
                    for(J = I.next(); !J.done; J = I.next())L = J.value, e.push.apply(e, x(Nx(a, L)));
                    if (!e.length) return N.B(2);
                    a.h.periodCount += e.length;
                    a.h.gapCount = a.M;
                    return F(N, Ex(a, e, !0), 2);
                }
                a.l.type == "static" && (K = a.l.Cc, a.h.presentationTimeline.zb(K || Infinity));
                H(N);
            });
        }
        function Nx(a, b) {
            return Dx(a, {
                Kb: a.l.type == "dynamic",
                presentationTimeline: a.h.presentationTimeline,
                Aa: null,
                qa: null,
                va: null,
                N: null,
                bandwidth: 0,
                Ch: !1,
                Bb: a.l.Bb,
                profiles: a.l.profiles,
                Cc: a.l.Cc,
                roles: null,
                Sb: function() {
                    return "";
                }
            }, a.l.mb, b, !0).periods;
        }
        function Kx(a, b) {
            a.h.periodCount--;
            for(var c = u(a.A.keys()), d = c.next(); !d.done; d = c.next())if (d = d.value, d.startsWith(b)) {
                var e = a.A.get(d);
                Pv(e, qw, "SegmentTimeline").children = [];
                Mx(a, d);
                a.A.delete(d);
            }
            a.G = a.G.filter(function(f) {
                return f !== b;
            });
        }
        function Lx(a, b) {
            var c = "", d = "", e = -1, f = "";
            b = u(b);
            for(var g = b.next(); !g.done; g = b.next())g = g.value, g.name === "Period" ? c = g.id : g.name === "AdaptationSet" ? (d = g.id, g.position !== null && (e = g.position)) : g.name === "Representation" && (f = g.id);
            b = [];
            if (f) b.push(c + "," + f);
            else if (d) for(e = u(a.A.values()), a = e.next(); !a.done; a = e.next())a = a.value, a.Aa.id === c && a.va.id === d && a.N.id && b.push(c + "," + a.N.id);
            else if (e > -1) for(d = u(a.A.values()), a = d.next(); !a.done; a = d.next())a = a.value, a.Aa.id === c && a.va.position === e && a.N.id && b.push(c + "," + a.N.id);
            return b;
        }
        function Mx(a, b) {
            var c = a.A.get(b), d = a.u.get(b);
            d.segmentIndex && d.segmentIndex.cb(a.h.presentationTimeline.Nb());
            try {
                var e = pw(c, function(f, g, h, k) {
                    return Ox(a, f, g, h, k);
                }, a.u, !0, a.g.dash.initialSegmentLimit, a.sa, c.N.aesKey, null, !0, a.D);
                d.createSegmentIndex = function() {
                    return Q(function(f) {
                        if (f.g == 1) return d.segmentIndex ? f.B(0) : F(f, e.gd(), 3);
                        d.segmentIndex = f.h;
                        H(f);
                    });
                };
            } catch (f) {
                if (b = c.N.contentType, b != sc && b != "application" && b != "image" || f.code != 4002) throw f;
            }
        }
        function Fx(a) {
            var b = Vd(a, "ServiceDescription");
            if (!b) return null;
            a = Vd(b, "Latency");
            b = Vd(b, "PlaybackRate");
            if (!a && !b) return null;
            var c = {};
            a && ("target" in a.attributes && (c.targetLatency = parseInt(a.attributes.target, 10) / 1E3), "max" in a.attributes && (c.maxLatency = parseInt(a.attributes.max, 10) / 1E3), "min" in a.attributes && (c.minLatency = parseInt(a.attributes.min, 10) / 1E3));
            b && ("max" in b.attributes && (c.maxPlaybackRate = parseFloat(b.attributes.max)), "min" in b.attributes && (c.minPlaybackRate = parseFloat(b.attributes.min)));
            return c;
        }
        function Gx(a) {
            a = Rd(a, "SupplementalProperty");
            if (!a.length) return null;
            a = u(a);
            for(var b = a.next(); !b.done; b = a.next())if (b = b.value, b.attributes.schemeIdUri == "urn:mpeg:dash:chaining:2016") return b.attributes.value;
            return null;
        }
        function Dx(a, b, c, d, e) {
            var f = b.Cc;
            f || (f = Zd(d, "mediaPresentationDuration", ce), a.l.Cc = f);
            var g = 0;
            a.h && a.h.presentationTimeline && a.S && (g = a.h.presentationTimeline.fc());
            var h = [], k = g;
            d = Rd(d, "Period");
            for(var l = 0; l < d.length; l++){
                var m = d[l], n = d[l + 1], q = Zd(m, "start", ce, k), r = m.attributes.id, t = Zd(m, "duration", ce);
                q = l == 0 && q == 0 && a.S ? g : q;
                var w = null;
                if (n) {
                    var v = Zd(n, "start", ce);
                    v != null && (w = v - q + g);
                } else f != null && (w = f - q + g);
                v = vc;
                w && t && Math.abs(w - t) > v && w > t && a.M++;
                w == null && (w = t);
                if (!(a.O !== null && r !== null && q !== null && q < a.O) || a.G.includes(r) || l + 1 == d.length) {
                    q !== null && (a.O === null || q > a.O) && (a.O = q);
                    k = Px(a, b, c, {
                        start: q,
                        duration: w,
                        node: m,
                        Df: w == null || !n
                    });
                    h.push(k);
                    b.Aa.id && w && a.sa.set(b.Aa.id, w);
                    if (w == null) {
                        k = null;
                        break;
                    }
                    k = q + w;
                }
            }
            if (e) for(b = u(h), c = b.next(); !c.done; c = b.next())c = c.value.id, a.G.includes(c) || a.G.push(c);
            else a.G = h.map(function(z) {
                return z.id;
            });
            return f != null ? {
                periods: h,
                duration: f + g,
                Ti: !1
            } : {
                periods: h,
                duration: k,
                Ti: !0
            };
        }
        function Ix(a) {
            var b = Array.from(a.F.keys()).filter(function(h) {
                return !a.G.includes(h);
            });
            b = u(b);
            for(var c = b.next(); !c.done; c = b.next()){
                c = c.value;
                for(var d = !0, e = u(a.F.get(c)), f = e.next(); !f.done; f = e.next()){
                    f = f.value;
                    var g = a.u.get(f);
                    g && (g.segmentIndex && g.segmentIndex.getNumReferences() != 0 ? d = !1 : (a.m && a.m.Ri(g, c), a.u.delete(f)));
                }
                d && a.F.delete(c);
            }
        }
        function Jx(a, b) {
            b = new Set(b.map(function(e) {
                return e.id;
            }));
            for(var c = u(a.D.keys()), d = c.next(); !d.done; d = c.next())d = d.value, b.has(d) || a.D.delete(d);
        }
        function Px(a, b, c, d) {
            b.Aa = Qx(a, d.node, null, c);
            b.qa = d;
            b.Aa.Bb = b.Bb;
            b.Aa.id || (b.Aa.id = "__shaka_period_" + d.start);
            var e = Rd(d.node, "EventStream");
            c = b.presentationTimeline.Nb();
            e = u(e);
            for(var f = e.next(); !f.done; f = e.next())Rx(a, d.start, d.duration, f.value, c);
            c = Rd(d.node, "SupplementalProperty");
            c = u(c);
            for(e = c.next(); !e.done; e = c.next())if (e = e.value, e.attributes.schemeIdUri == "urn:mpeg:dash:urlparam:2014" && (e = Sx(a, e))) b.Sb = e;
            c = Rd(d.node, "AdaptationSet").map(function(r, t) {
                return Tx(a, b, t, r);
            }).filter(Ef);
            if (b.Kb) {
                e = [];
                f = u(c);
                for(var g = f.next(); !g.done; g = f.next()){
                    g = u(g.value.im);
                    for(var h = g.next(); !h.done; h = g.next())e.push(h.value);
                }
                if (e.length != new Set(e).size) throw new U(2, 4, 4018);
            }
            e = new Map;
            f = u(c);
            for(g = f.next(); !g.done; g = f.next())for(g = u(g.value.yk), h = g.next(); !h.done; h = g.next()){
                var k = u(h.value);
                h = k.next().value;
                k = k.next().value;
                e.set(h, k);
            }
            if (e.size) for(f = null, g = u(c), h = g.next(); !h.done; h = g.next()){
                h = h.value;
                k = [];
                for(var l = u(h.streams), m = l.next(), n = {}; !m.done; n = {
                    mi: void 0
                }, m = l.next())if (n.mi = m.value, e.has(n.mi.originalId)) {
                    f || (f = Rd(d.node, "AdaptationSet").map(function(r, t) {
                        return Tx(a, b, t, r);
                    }).filter(Ef));
                    m = u(f);
                    for(var q = m.next(); !q.done; q = m.next())if (q = q.value.streams.find(function(r) {
                        return function(t) {
                            return t.originalId == r.mi.originalId;
                        };
                    }(n))) q.dependencyStream = e.get(q.originalId), q.originalId += q.dependencyStream.originalId, k.push(q);
                }
                k.length && h.streams.push.apply(h.streams, x(k));
            }
            d = c.filter(function(r) {
                return !r.wi;
            });
            c = c.filter(function(r) {
                return r.wi;
            });
            if (!a.g.disableIFrames) {
                for(c = u(c), e = c.next(); !e.done; e = c.next())for(e = e.value, f = e.wi.split(" "), g = u(d), h = g.next(); !h.done; h = g.next())if (h = h.value, f.includes(h.id)) for(h = u(h.streams), k = h.next(); !k.done; k = h.next())og(k.value, e.streams);
            }
            c = Ux(a.g.disableAudio, d, "audio");
            e = Ux(a.g.disableVideo, d, "video");
            f = Ux(a.g.disableText, d, sc);
            d = Ux(a.g.disableThumbnails, d, "image");
            if (e.length === 0 && c.length === 0) throw new U(2, 4, 4004);
            return {
                id: b.Aa.id,
                audioStreams: c,
                videoStreams: e,
                textStreams: f,
                imageStreams: d
            };
        }
        function Ux(a, b, c) {
            return a || !b.length ? [] : b.reduce(function(d, e) {
                if (e.contentType != c) return d;
                d.push.apply(d, x(e.streams));
                return d;
            }, []);
        }
        function Tx(a, b, c, d) {
            function e(K) {
                var N = K.attributes["dvb:fontFamily"];
                K = K.attributes["dvb:url"];
                N && K && (K = mc(b.va.mb(), [
                    K
                ], b.Sb()), a.j.addFont(N, K[0]));
            }
            function f(K) {
                switch(K){
                    case 1:
                    case 5:
                    case 6:
                    case 7:
                        return "srgb";
                    case 9:
                        return "rec2020";
                    case 11:
                    case 12:
                        return "p3";
                }
            }
            function g(K) {
                switch(K){
                    case 1:
                    case 6:
                    case 13:
                    case 14:
                    case 15:
                        return "SDR";
                    case 16:
                        return "PQ";
                    case 18:
                        return "HLG";
                }
            }
            b.va = Qx(a, d, b.Aa, null);
            b.va.position = c;
            var h = !1;
            c = Rd(d, "Role");
            var k = c.map(function(K) {
                return K.attributes.value;
            }).filter(Ef), l = void 0, m = b.va.contentType == sc;
            m && (l = "subtitle");
            c = u(c);
            for(var n = c.next(); !n.done; n = c.next()){
                n = n.value;
                var q = n.attributes.schemeIdUri;
                if (q == null || q == "urn:mpeg:dash:role:2011") switch(n = n.attributes.value, n){
                    case "main":
                        h = !0;
                        break;
                    case "caption":
                    case "subtitle":
                        l = n;
                }
            }
            var r = Rd(d, "EssentialProperty");
            c = null;
            var t = !1;
            n = null;
            q = !1;
            r = u(r);
            for(var w = r.next(); !w.done; w = r.next()){
                w = w.value;
                var v = w.attributes.schemeIdUri;
                if (v == "http://dashif.org/guidelines/trickmode") c = w.attributes.value;
                else if (v == "urn:mpeg:mpegB:cicp:TransferCharacteristics") var z = g(parseInt(w.attributes.value, 10));
                else if (v == "urn:mpeg:mpegB:cicp:ColourPrimaries") var y = f(parseInt(w.attributes.value, 10));
                else v != "urn:mpeg:mpegB:cicp:MatrixCoefficients" && (v == "urn:mpeg:dash:ssr:2023" && a.g.dash.enableFastSwitching ? t = !0 : v == "urn:dvb:dash:fontdownload:2014" ? e(w) : v == "urn:mpeg:dash:urlparam:2014" ? (n = Sx(a, w)) || (q = !0) : q = !0);
            }
            if (q) return null;
            var A = null;
            q = Rd(d, "SupplementalProperty");
            q = u(q);
            for(r = q.next(); !r.done; r = q.next())r = r.value, w = r.attributes.schemeIdUri, w == "http://dashif.org/guidelines/last-segment-number" ? A = parseInt(r.attributes.value, 10) - 1 : w == "urn:mpeg:mpegB:cicp:TransferCharacteristics" ? z = g(parseInt(r.attributes.value, 10)) : w == "urn:mpeg:mpegB:cicp:ColourPrimaries" ? y = f(parseInt(r.attributes.value, 10)) : w == "urn:dvb:dash:fontdownload:2014" ? e(r) : w == "urn:mpeg:dash:urlparam:2014" && (n = Sx(a, r));
            n && (b.Sb = n);
            n = Rd(d, "Accessibility");
            var C = new Map, E;
            n = u(n);
            for(q = n.next(); !q.done; q = n.next())if (r = q.value, q = r.attributes.schemeIdUri, r = r.attributes.value, q != "urn:scte:dash:cc:cea-608:2015" || a.g.disableText) {
                if (q != "urn:scte:dash:cc:cea-708:2015" || a.g.disableText) q == "urn:mpeg:dash:role:2011" ? r != null && (k.push(r), r == "captions" && (l = "caption")) : q == "urn:tva:metadata:cs:AudioPurposeCS:2007" && (r == "1" ? E = "visually impaired" : r == "2" ? E = "hard of hearing" : r == "9" && (E = "spoken subtitles"));
                else if (q = 1, r != null) for(r = u(r.split(";")), w = r.next(); !w.done; w = r.next()){
                    v = w.value;
                    var D = w = void 0;
                    v.includes("=") ? (v = v.split("="), w = "svc" + v[0], D = v[1].split(",")[0].split(":").pop()) : (w = "svc" + q, q++, D = v);
                    C.set(w, yc(D));
                }
                else C.set("svc1", "und");
            } else if (q = 1, r != null) for(r = r.split(";"), w = u(r), v = w.next(); !v.done; v = w.next()){
                D = v.value;
                var B = v = void 0;
                D.includes("=") ? (D = D.split("="), v = D[0].startsWith("CC") ? D[0] : "CC" + D[0], B = D[1] || "und") : (v = "CC" + q, r.length == 2 ? q += 2 : q++, B = D);
                C.set(v, yc(B));
            }
            else C.set("CC1", "und");
            n = Rd(d, "ContentProtection");
            var G = Ev(a.ra, n, a.g.ignoreDrmInfo, a.g.dash.keySystemsByURI);
            b.va.encrypted = n.length > 0;
            var I = yc(b.va.language || "und"), J = b.va.label, L = new Map;
            d = Rd(d, "Representation");
            if (!a.g.ignoreSupplementalCodecs) {
                n = [];
                q = u(d);
                for(r = q.next(); !r.done; r = q.next())if (w = r.value, r = $d(w, "urn:scte:dash:scte214-extensions", "supplementalCodecs")) w = Gd(w), w.attributes.codecs = r.split(" ").join(","), w.attributes.id && (w.attributes.supplementalId = w.attributes.id + "_supplementalCodecs"), n.push(w);
                d.push.apply(d, x(n));
            }
            n = d.map(function(K) {
                var N = Vx(a, b, G, l, I, J, h, k, C, K, E, A);
                return N && (N.hdr = N.hdr || z, N.colorGamut = N.colorGamut || y, N.fastSwitching = t, K = K.attributes.dependencyId) ? (N.baseOriginalId = K, L.set(K, N), null) : N;
            }).filter(function(K) {
                return !!K;
            });
            if (n.length == 0 && L.size == 0) {
                c = b.va.contentType == "image";
                if (a.g.dash.ignoreEmptyAdaptationSet || m || c) return null;
                throw new U(2, 4, 4003);
            }
            if (!b.va.contentType || b.va.contentType == "application") for(b.va.contentType = Wx(n[0].mimeType, n[0].codecs), m = u(n), q = m.next(); !q.done; q = m.next())q.value.type = b.va.contentType;
            m = b.va.id || "__fake__" + a.Fa++;
            q = u(n);
            for(r = q.next(); !r.done; r = q.next()){
                r = r.value;
                w = u(G.drmInfos);
                for(v = w.next(); !v.done; v = w.next())v = v.value, v.keyIds = v.keyIds && r.keyIds ? new Set([].concat(x(v.keyIds), x(r.keyIds))) : v.keyIds || r.keyIds;
                a.g.enableAudioGroups && (r.groupId = m);
            }
            d = d.map(function(K) {
                return K.attributes.supplementalId || K.attributes.id;
            }).filter(Ef);
            return {
                id: m,
                contentType: b.va.contentType,
                language: I,
                Vn: h,
                streams: n,
                drmInfos: G.drmInfos,
                wi: c,
                im: d,
                yk: L
            };
        }
        function Sx(a, b) {
            if ((b = Wd(b, "urn:mpeg:dash:schema:urlparam:2014", "UrlQueryInfo")) && Zd(b, "useMPDUrlQuery", ie, !1)) {
                var c = b.attributes.queryTemplate;
                if (c) return function() {
                    return c == "$querypart$" ? a.X : c.split("&").map(function(d) {
                        if (d == "$querypart$") return a.X;
                        var e = /\$query:(.*?)\$/g.exec(d);
                        if (e && e.length == 2) {
                            e = e[1];
                            var f = new wb(a.X).get(e);
                            if (f.length) return e + "=" + f[0];
                        }
                        return d;
                    }).join("&");
                };
            }
            return null;
        }
        function Vx(a, b, c, d, e, f, g, h, k, l, m, n) {
            b.N = Qx(a, l, b.va, null);
            var q = b.N.id;
            a.Y = Math.min(a.Y, b.N.Bb);
            a.R = a.Y > 0;
            if (!Xx(b.N)) return null;
            var r = b.qa.start;
            b.bandwidth = Zd(l, "bandwidth", fe) || 0;
            b.roles = h;
            var t = Rd(l, "SupplementalProperty"), w = Rd(l, "EssentialProperty"), v = Rd(l, "ContentProtection");
            l = null;
            var z = w.find(function(O) {
                return O.attributes.schemeIdUri == "urn:mpeg:dash:urlparam:2014";
            });
            z ? l = Sx(a, z) : (z = t.find(function(O) {
                return O.attributes.schemeIdUri == "urn:mpeg:dash:urlparam:2014";
            })) && (l = Sx(a, z));
            l && (b.Sb = l);
            z = b.N.contentType;
            l = z == sc || z == "application";
            z = z == "image";
            v.length && (b.va.encrypted = !0);
            try {
                var y = void 0;
                if (c.Hg) {
                    var A = b.N.mb, C = b.Sb, E = mc(A(), [
                        c.Hg.Ll
                    ], C()), D = $g(E, a.g.retryParameters);
                    y = {
                        bitsKey: 128,
                        blockCipherMode: "CBC",
                        iv: c.Hg.iv,
                        firstMediaSequenceNumber: 0,
                        fetchKey: function() {
                            var O, M, R;
                            return Q(function(W) {
                                if (W.g == 1) return F(W, zx(a, D, 6), 2);
                                if (W.g != 3) {
                                    O = W.h;
                                    if (!O.data || O.data.byteLength != 16) throw new U(2, 4, 4049);
                                    M = {
                                        name: "AES-CBC"
                                    };
                                    R = y;
                                    return F(W, window1.crypto.subtle.importKey("raw", O.data, M, !0, [
                                        "decrypt"
                                    ]), 3);
                                }
                                R.cryptoKey = W.h;
                                y.fetchKey = void 0;
                                H(W);
                            });
                        }
                    };
                }
                b.N.aesKey = y;
                A = function(O, M, R, W) {
                    return Ox(a, O, M, R, W);
                };
                if (b.N.Xd) var B = ew(b, A, y);
                else if (b.N.Jc) B = kw(b, a.u, y);
                else if (b.N.Zc) B = pw(b, A, a.u, !!a.h, a.g.dash.initialSegmentLimit, a.sa, y, n, !1, a.D);
                else {
                    var G = b.qa.duration || 0, I = b.N.mb, J = b.N.mimeType, L = b.N.codecs;
                    B = {
                        endTime: -1,
                        timeline: -1,
                        gd: function() {
                            var O = Zl(r, G, I());
                            O.Lb(function(M) {
                                M.mimeType = J;
                                M.codecs = L;
                            });
                            return Promise.resolve(O);
                        },
                        timescale: 1
                    };
                }
            } catch (O) {
                if ((l || z) && O.code == 4002) return null;
                throw O;
            }
            n = Iv(a.ra, v, c, a.g.ignoreDrmInfo, a.g.dash.keySystemsByURI);
            n = new Set(n ? [
                n
            ] : []);
            v = !1;
            t.some(function(O) {
                return O.attributes.schemeIdUri == "tag:dolby.com,2018:dash:EC3_ExtensionType:2018" && O.attributes.value == "JOC";
            }) && (v = !0);
            t = !1;
            l && (t = h.includes("forced_subtitle") || h.includes("forced-subtitle"));
            var K;
            if (z && ((w = w.find(function(O) {
                return [
                    "http://dashif.org/thumbnail_tile",
                    "http://dashif.org/guidelines/thumbnail_tile"
                ].includes(O.attributes.schemeIdUri);
            })) && (K = w.attributes.value), !K)) return null;
            var N;
            l = b.N.codecs;
            b.profiles.includes("http://dashif.org/guidelines/dash-if-uhd#hevc-hdr-pq10") && (l.includes("hvc1.2.4.L153.B0") || l.includes("hev1.2.4.L153.B0")) && (N = "PQ");
            w = b.N.id ? b.Aa.id + "," + b.N.id : "";
            a.H.length && q && a.A.set(b.Aa.id + "," + q, Yx(b));
            b.N.Wf && Zx(a, b.N.Wf, B, b.presentationTimeline);
            B.endTime != -1 && b.Aa.id != null && b.N.id != null && ((q = a.D.get(b.Aa.id)) ? (q.endTime = B.endTime, q.Uh.includes(b.N.id) || q.Uh.push(b.N.id), a.D.set(b.Aa.id, q)) : a.D.set(b.Aa.id, {
                endTime: B.endTime,
                timeline: B.timeline,
                Uh: [
                    b.N.id
                ]
            }));
            var P = w && a.u.has(w) ? a.u.get(w) : {
                id: a.Fa++,
                originalId: b.N.id,
                groupId: null,
                createSegmentIndex: function() {
                    return Promise.resolve();
                },
                closeSegmentIndex: function() {
                    P.segmentIndex && (P.segmentIndex.release(), P.segmentIndex = null);
                },
                segmentIndex: null,
                mimeType: b.N.mimeType,
                codecs: l,
                frameRate: b.N.frameRate,
                pixelAspectRatio: b.N.pixelAspectRatio,
                bandwidth: b.bandwidth,
                width: b.N.width,
                height: b.N.height,
                kind: d,
                encrypted: c.drmInfos.length > 0,
                drmInfos: c.drmInfos,
                keyIds: n,
                language: e,
                originalLanguage: b.va.language,
                label: f,
                type: b.va.contentType,
                primary: g,
                trickModeVideo: null,
                dependencyStream: null,
                emsgSchemeIdUris: b.N.emsgSchemeIdUris,
                roles: h,
                forced: t,
                channelsCount: b.N.Qf,
                audioSamplingRate: b.N.audioSamplingRate,
                spatialAudio: v,
                closedCaptions: k,
                hdr: N,
                colorGamut: void 0,
                videoLayout: void 0,
                tilesLayout: K,
                accessibilityPurpose: m,
                external: !1,
                fastSwitching: !1,
                fullMimeTypes: new Set([
                    df(b.N.mimeType, b.N.codecs)
                ]),
                isAudioMuxedInVideo: !1,
                baseOriginalId: null
            };
            P.createSegmentIndex = function() {
                var O;
                return Q(function(M) {
                    if (M.g == 1) {
                        if (P.segmentIndex) return M.B(0);
                        O = P;
                        return F(M, B.gd(), 3);
                    }
                    O.segmentIndex = M.h;
                    H(M);
                });
            };
            w && b.Kb && !a.u.has(w) && (b = b.Aa.id || "", a.F.has(b) || a.F.set(b, []), a.u.set(w, P), a.F.get(b).push(w));
            return P;
        }
        function Zx(a, b, c, d) {
            if (!a.aa.has(b)) {
                a.aa.add(b);
                var e = Zd(b, "presentationTime", ge) || 0, f = Vd(b, "UTCTiming"), g;
                if (g = f && f.attributes.schemeIdUri) f = f.attributes.schemeIdUri, g = !(f === "urn:mpeg:dash:utc:http-ntp:2014" || f === "urn:mpeg:dash:utc:ntp:2014" || f === "urn:mpeg:dash:utc:sntp:2014");
                g ? b = (Zd(b, "wallClockTime", be) || 0) * 1E3 : (b = Zd(b, "wallClockTime", ge) || 0, b = ak(b));
                c = new Date(b - e / c.timescale * 1E3);
                e = c.getTime() / 1E3;
                isNaN(e) || (d.u || d.ei(e), d = (new Map).set("detail", {
                    wallClockTime: b,
                    programStartDate: c
                }), d = new T("prft", d), a.j.onEvent(d));
            }
        }
        function Yx(a) {
            function b(c) {
                if (!c) return null;
                c = Hd(c);
                c.Xd = null;
                c.Jc = null;
                c.Zc = qe(c.Zc);
                c.Wf = null;
                return c;
            }
            a = Hd(a);
            a.Aa = b(a.Aa);
            a.va = b(a.va);
            a.N = b(a.N);
            a.qa && (a.qa = Hd(a.qa), a.qa.node = null);
            return a;
        }
        function vx(a) {
            var b, c;
            return Q(function(d) {
                switch(d.g){
                    case 1:
                        return b = 0, ra(d, 2), F(d, wx(a), 4);
                    case 4:
                        b = d.h;
                        ta(d, 3);
                        break;
                    case 2:
                        if (c = ua(d), a.j) {
                            if (a.g.raiseFatalErrorOnManifestUpdateRequestFailure) return a.j.onError(c), d.return();
                            c.severity = 1;
                            a.j.onError(c);
                        }
                    case 3:
                        if (!a.j) return d.return();
                        a.j.onManifestUpdated();
                        xx(a, b);
                        H(d);
                }
            });
        }
        function xx(a, b) {
            if (!(a.K < 0)) {
                var c = a.K;
                a.g.updatePeriod >= 0 && (c = a.g.updatePeriod);
                a.L.$(Math.max(c - b, Mc(a.xa)));
            }
        }
        function Qx(a, b, c, d) {
            c = c || {
                contentType: "",
                mimeType: "",
                codecs: "",
                emsgSchemeIdUris: [],
                frameRate: void 0,
                pixelAspectRatio: void 0,
                Qf: null,
                audioSamplingRate: null,
                Bb: 0,
                eg: 1,
                encrypted: !1
            };
            d = d || c.mb;
            var e = b.attributes.id, f = b.attributes.supplementalId, g = Rd(b, "BaseURL"), h, k = !1;
            if (a.i) for(var l = u(g), m = l.next(); !m.done; m = l.next()){
                var n = m.value;
                m = n.attributes.serviceLocation;
                n = Td(n);
                m && n && (Ew(a.i, e, m, n), k = !0);
            }
            k && a.i || (h = g.map(Td));
            var q = a.i;
            a = b.attributes.contentType || c.contentType;
            l = b.attributes.mimeType || c.mimeType;
            m = Dm([
                b.attributes.codecs || c.codecs
            ]).join(",");
            n = Zd(b, "frameRate", ke) || c.frameRate;
            var r = b.attributes.sar || c.pixelAspectRatio, t = $x(Rd(b, "InbandEventStream"), c.emsgSchemeIdUris), w = Rd(b, "AudioChannelConfiguration");
            w = ay(w) || c.Qf;
            var v = Zd(b, "audioSamplingRate", ge) || c.audioSamplingRate;
            a || (a = Wx(l, m));
            var z = Vd(b, "SegmentBase"), y = Vd(b, "SegmentTemplate"), A = z ? Zd(z, "availabilityTimeOffset", he) || 0 : 0, C = y ? Zd(y, "availabilityTimeOffset", he) || 0 : 0, E = g && g.length ? Zd(g[0], "availabilityTimeOffset", he) || 0 : 0;
            A = c.Bb + E + A + C;
            C = null;
            (E = Vd(b, "SegmentSequenceProperties")) && (E = Zd(E, "cadence", fe)) && (C = E);
            E = b.attributes.label;
            var D = Rd(b, "Label");
            D && D.length && (D = D[0], Sd(D) && (E = Sd(D)));
            return {
                mb: function() {
                    return mc(d(), g.length ? q && k ? Fw(q, e) : h ? h : [] : []);
                },
                Xd: z || c.Xd,
                Jc: Vd(b, "SegmentList") || c.Jc,
                Zc: y || c.Zc,
                Wf: Vd(b, "ProducerReferenceTime") || c.Wf,
                width: Zd(b, "width", ge) || c.width,
                height: Zd(b, "height", ge) || c.height,
                contentType: a,
                mimeType: l,
                codecs: m,
                frameRate: n,
                pixelAspectRatio: r,
                emsgSchemeIdUris: t,
                id: f || e,
                originalId: e,
                language: b.attributes.lang,
                Qf: w,
                audioSamplingRate: v,
                Bb: A,
                Af: null,
                eg: C || c.eg,
                label: E || null,
                encrypted: !1
            };
        }
        function $x(a, b) {
            b = b.slice();
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next())c = c.value.attributes.schemeIdUri, b.includes(c) || b.push(c);
            return b;
        }
        function ay(a) {
            a = u(a);
            for(var b = a.next(); !b.done; b = a.next()){
                b = b.value;
                var c = b.attributes.schemeIdUri;
                if (c && (b = b.attributes.value)) switch(c){
                    case "urn:mpeg:dash:outputChannelPositionList:2012":
                        return b.trim().split(/ +/).length;
                    case "urn:mpeg:dash:23003:3:audio_channel_configuration:2011":
                    case "urn:dts:dash:audio_channel_configuration:2012":
                        b = parseInt(b, 10);
                        if (!b) continue;
                        return b;
                    case "tag:dolby.com,2015:dash:audio_channel_configuration:2015":
                        c = [
                            2,
                            1,
                            2,
                            2,
                            2,
                            2,
                            1,
                            2,
                            2,
                            1,
                            1,
                            1,
                            1,
                            2,
                            1,
                            1,
                            2,
                            2
                        ];
                        b = parseInt(b, 16);
                        if (!b) continue;
                        for(var d = 0, e = 0; e < c.length; e++)b & 1 << e && (d += c[e]);
                        if (d) return d;
                        continue;
                    case "tag:dolby.com,2014:dash:audio_channel_configuration:2011":
                    case "urn:dolby:dash:audio_channel_configuration:2011":
                        c = [
                            1,
                            1,
                            1,
                            1,
                            1,
                            2,
                            2,
                            1,
                            1,
                            2,
                            2,
                            2,
                            1,
                            2,
                            1,
                            1
                        ].reverse();
                        b = parseInt(b, 16);
                        if (!b) continue;
                        for(e = d = 0; e < c.length; e++)b & 1 << e && (d += c[e]);
                        if (d) return d;
                        continue;
                    case "urn:mpeg:mpegB:cicp:ChannelConfiguration":
                        if (c = [
                            0,
                            1,
                            2,
                            3,
                            4,
                            5,
                            6,
                            8,
                            2,
                            3,
                            4,
                            7,
                            8,
                            24,
                            8,
                            12,
                            10,
                            12,
                            14,
                            12,
                            14
                        ], (b = parseInt(b, 10)) && b > 0 && b < c.length) return c[b];
                }
            }
            return null;
        }
        function Xx(a) {
            var b = a.Xd ? 1 : 0;
            b += a.Jc ? 1 : 0;
            b += a.Zc ? 1 : 0;
            if (b == 0) return a.contentType == sc || a.contentType == "application" ? !0 : !1;
            b != 1 && (a.Xd && (a.Jc = null), a.Zc = null);
            return !0;
        }
        function by(a, b, c, d) {
            var e, f, g, h, k, l, m;
            return Q(function(n) {
                if (n.g == 1) return e = [
                    cc(c)
                ], f = mc(b(), e), g = $g(f, a.g.retryParameters), g.method = d, h = a.j.networkingEngine.request(4, g, {
                    isPreload: a.ea()
                }), Ug(a.P, h), F(n, h.promise, 2);
                k = n.h;
                if (d == "HEAD") {
                    if (!k.headers || !k.headers.date) return n.return(0);
                    l = k.headers.date;
                } else l = Wb(k.data);
                m = Date.parse(l);
                return isNaN(m) ? n.return(0) : n.return(m - Date.now());
            });
        }
        function Hx(a, b, c) {
            var d, e, f, g, h, k, l, m;
            return Q(function(n) {
                switch(n.g){
                    case 1:
                        d = c.map(function(q) {
                            return {
                                scheme: q.attributes.schemeIdUri,
                                value: q.attributes.value
                            };
                        }), e = a.g.dash.clockSyncUri, !d.length && e && d.push({
                            scheme: "urn:mpeg:dash:utc:http-head:2014",
                            value: e
                        }), f = u(d), g = f.next();
                    case 2:
                        if (g.done) {
                            n.B(4);
                            break;
                        }
                        h = g.value;
                        ra(n, 5);
                        k = h.scheme;
                        l = h.value;
                        switch(k){
                            case "urn:mpeg:dash:utc:http-head:2014":
                            case "urn:mpeg:dash:utc:http-head:2012":
                                return n.B(7);
                            case "urn:mpeg:dash:utc:http-xsdate:2014":
                            case "urn:mpeg:dash:utc:http-iso:2014":
                            case "urn:mpeg:dash:utc:http-xsdate:2012":
                            case "urn:mpeg:dash:utc:http-iso:2012":
                                return n.B(8);
                            case "urn:mpeg:dash:utc:direct:2014":
                            case "urn:mpeg:dash:utc:direct:2012":
                                return m = Date.parse(l), n.return(isNaN(m) ? 0 : m - Date.now());
                            case "urn:mpeg:dash:utc:http-ntp:2014":
                            case "urn:mpeg:dash:utc:ntp:2014":
                            case "urn:mpeg:dash:utc:sntp:2014":
                                ab("NTP UTCTiming scheme is not supported");
                                break;
                            default:
                                ab("Unrecognized scheme in UTCTiming element", k);
                        }
                        n.B(9);
                        break;
                    case 7:
                        return F(n, by(a, b, l, "HEAD"), 10);
                    case 10:
                        return n.return(n.h);
                    case 8:
                        return F(n, by(a, b, l, "GET"), 11);
                    case 11:
                        return n.return(n.h);
                    case 9:
                        ta(n, 3);
                        break;
                    case 5:
                        ua(n);
                    case 3:
                        g = f.next();
                        n.B(2);
                        break;
                    case 4:
                        return ab("A UTCTiming element should always be given in live manifests! This content may not play on clients with bad clocks!"), n.return(0);
                }
            });
        }
        function Rx(a, b, c, d, e) {
            var f = d.attributes.schemeIdUri || "", g = d.attributes.value || "", h = Zd(d, "timescale", ge) || 1, k = Zd(d, "presentationTimeOffset", ge) || 0;
            d = u(Rd(d, "Event"));
            for(var l = d.next(); !l.done; l = d.next()){
                l = l.value;
                var m = Zd(l, "presentationTime", ge) || 0, n = Zd(l, "duration", ge) || 0;
                m = Math.max((m - k) / h + b, b);
                n = m + n / h;
                c != null && (m = Math.min(m, b + c), n = Math.min(n, b + c));
                n < e || (l = {
                    schemeIdUri: f,
                    value: g,
                    startTime: m,
                    endTime: n,
                    id: l.attributes.id || "",
                    timescale: h,
                    eventElement: pe(l),
                    eventNode: qe(l)
                }, a.j.onTimelineRegionAdded(l));
            }
        }
        function Ox(a, b, c, d, e) {
            var f, g, h, k;
            return Q(function(l) {
                if (l.g == 1) return f = fh, g = e ? 0 : 1, h = Hm(b, c, d, a.g.retryParameters), F(l, zx(a, h, f, {
                    type: g
                }), 2);
                k = l.h;
                return l.return(k.data);
            });
        }
        function Wx(a, b) {
            b = df(a, b);
            return tf(b) ? sc : a.split("/")[0];
        }
        function zx(a, b, c, d) {
            d || (d = {});
            d.isPreload = a.ea();
            b = a.j.networkingEngine.request(c, b, d);
            Ug(a.P, b);
            return b.promise;
        }
        function yx(a) {
            var b = a.l.De;
            if (!a.l.Nf || !b || !a.H.length) return [];
            var c = Date.now() / 1E3, d = a.H.filter(function(e) {
                e = ge(e.attributes.ttl);
                return !e || b + e > c;
            }).map(Td).filter(Ef);
            return d.length ? mc(a.C, d) : [];
        }
        S("shaka.dash.DashParser", ux);
        Ci("application/dash+xml", function() {
            return new ux;
        });
        Ci("video/vnd.mpeg.dash.mpd", function() {
            return new ux;
        });
        function cy() {}
        S("shaka.dependencies", cy);
        cy.has = function(a) {
            return dy.has(a);
        };
        cy.add = function(a, b) {
            if (!ey[a]) throw Error(a + " is not supported");
            a == fy ? Zc("mux.js", "mux.js is no longer used in Shaka Player.") : dy.set(a, function() {
                return b;
            });
        };
        var fy = "muxjs", ey = {
            Wn: fy,
            ISOBoxer: "ISOBoxer"
        };
        cy.Allowed = ey;
        var dy = new Map([
            [
                "ISOBoxer",
                function() {
                    return window1.ISOBoxer;
                }
            ]
        ]);
        function gy() {
            this.j = new Qb(function() {
                return [
                    "Oculus",
                    "Quest"
                ].some(function(a) {
                    return navigator.userAgent.includes(a.toLowerCase());
                }) ? "VR" : navigator.userAgent.match(/Smart( ?|_)TV/i) || navigator.userAgent.match(/Android ?TV/i) ? "TV" : navigator.userAgentData ? navigator.userAgentData.mobile ? "MOBILE" : "DESKTOP" : /(?:iPhone|iPad|iPod)/.test(navigator.userAgent) ? "MOBILE" : navigator.userAgentData && navigator.userAgentData.platform ? navigator.userAgentData.platform.toLowerCase() == "android" ? "MOBILE" : "DESKTOP" : navigator.userAgent.includes("Android") ? "MOBILE" : "DESKTOP";
            });
            this.l = new Qb(function() {
                return navigator.vendor.includes("Apple") && (navigator.userAgent.includes("Version/") || navigator.userAgent.includes("OS/")) ? "WEBKIT" : navigator.userAgent.includes("Edge/") ? "EDGE" : navigator.userAgent.includes("Chrome/") ? "CHROMIUM" : navigator.userAgent.includes("Firefox/") ? "GECKO" : "UNKNOWN";
            });
        }
        function Fi() {
            var a = window1.ManagedMediaSource || window1.MediaSource;
            return a && a.isTypeSupported ? !0 : !1;
        }
        p = gy.prototype;
        p.mc = function() {
            return !!navigator.mediaCapabilities;
        };
        p.Ka = function() {
            return this.j.value();
        };
        p.Ja = function() {
            return this.l.value();
        };
        p.Ud = function() {
            return !1;
        };
        p.zj = function() {
            return !1;
        };
        p.Bf = function() {
            return !1;
        };
        p.Aj = function() {
            return !1;
        };
        p.Fe = function() {
            return !1;
        };
        p.vd = function() {
            return !0;
        };
        p.bd = function() {
            return !0;
        };
        p.Je = function() {
            return !0;
        };
        p.Fj = function() {
            return 0;
        };
        p.wc = function() {
            return Promise.resolve({
                width: Infinity,
                height: Infinity
            });
        };
        p.Qj = function() {
            return !1;
        };
        p.ki = function() {
            return !1;
        };
        p.ab = function(a) {
            var b = this.Ka();
            if (b === "TV" || b === "CONSOLE" || b === "CAST") a.ads.customPlayheadTracker = !0, a.ads.skipPlayDetection = !0, a.ads.supportsMultipleMediaElements = !1;
            return a;
        };
        p.oi = function() {
            return !!window1.indexedDB;
        };
        p.xj = function() {
            return [];
        };
        p.Id = function(a) {
            return window1.matchMedia !== void 0 && window1.matchMedia("(color-gamut: p3)").matches ? a ? "HLG" : "PQ" : "SDR";
        };
        p.kg = function() {
            return !1;
        };
        p.nj = function() {
            return !1;
        };
        p.Yh = function() {
            return !1;
        };
        p.mg = function() {
            return !0;
        };
        p.oj = function() {
            return !1;
        };
        p.Yj = function() {
            return !0;
        };
        p.ud = function() {
            return !1;
        };
        p.Kh = function(a) {
            return a === "com.apple.fps";
        };
        p.lg = function() {
            return !0;
        };
        p.toString = function() {
            return "Device: " + this.Ub() + " v" + this.Ga() + "; Type: " + this.Ka();
        };
        function hy() {
            gy.call(this);
            this.g = new Qb(function() {
                var a = navigator.userAgent.match(/Version\/(\d+)/);
                return a ? parseInt(a[1], 10) : (a = navigator.userAgent.match(/OS (\d+)(?:_\d+)?/)) ? parseInt(a[1], 10) : null;
            });
            this.h = new Qb(function() {
                return /(?:iPhone|iPad|iPod)/.test(navigator.userAgent) || navigator.maxTouchPoints > 1 ? "xr" in navigator ? "APPLE_VR" : "MOBILE" : "xr" in navigator ? "APPLE_VR" : "DESKTOP";
            });
        }
        la(hy, gy);
        p = hy.prototype;
        p.Ga = function() {
            return this.g.value();
        };
        p.Ub = function() {
            return "Apple Browser";
        };
        p.Ka = function() {
            return this.h.value();
        };
        p.Ja = function() {
            return "WEBKIT";
        };
        p.mc = function() {
            return !1;
        };
        p.Ud = function(a, b) {
            return b === "audio";
        };
        p.Bf = function() {
            return !0;
        };
        p.Aj = function(a) {
            return a === "audio";
        };
        p.ab = function(a) {
            gy.prototype.ab.call(this, a);
            a.abr.minTimeToSwitch = .5;
            return a;
        };
        p.kg = function() {
            return !0;
        };
        p.lg = function() {
            return !1;
        };
        (navigator.vendor || "").includes("Apple") && (/(?:iPhone|iPad|iPod)/.test(navigator.userAgent) || navigator.maxTouchPoints > 1 || navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform.toLowerCase() == "macos" || navigator.platform && navigator.platform.toLowerCase().includes("mac")) && (Tb = function() {
            return new hy;
        });
        function iy() {
            if (!jy()) throw Error("Not a Chromecast device!");
            gy.call(this);
            this.h = new Qb(function() {
                var a = navigator.userAgent.match(/Chrome\/(\d+)/);
                return a ? parseInt(a[1], 10) : null;
            });
            this.g = new Qb(function() {
                var a = navigator.userAgentData && navigator.userAgentData.platform || navigator.userAgent;
                a = a.toLowerCase();
                return a.includes("android") ? ky : a.includes("fuchsia") ? ly : my;
            });
        }
        la(iy, gy);
        p = iy.prototype;
        p.Ga = function() {
            return this.h.value();
        };
        p.Ub = function() {
            return "Chromecast with " + this.g.value();
        };
        p.Ka = function() {
            return "CAST";
        };
        p.Ja = function() {
            return "CHROMIUM";
        };
        p.mc = function() {
            return gy.prototype.mc.call(this) && this.g.value() !== my;
        };
        p.bd = function() {
            return this.g.value() !== my;
        };
        p.Fj = function() {
            switch(this.g.value()){
                case ky:
                    return 0;
                case ly:
                    return 3;
                default:
                    return 1;
            }
        };
        p.wc = function() {
            var a, b, c, d, e;
            return Q(function(f) {
                switch(f.g){
                    case 1:
                        a = window1.cast && cast.__platform__ && cast.__platform__.canDisplayType;
                        b = {
                            width: 1280,
                            height: 720
                        };
                        ra(f, 2);
                        if (!(c = a)) {
                            f.B(4);
                            break;
                        }
                        return F(f, cast.__platform__.canDisplayType('video/mp4; codecs="avc1.640028"; width=3840; height=2160'), 5);
                    case 5:
                        c = f.h;
                    case 4:
                        if (c) {
                            b.width = 3840;
                            b.height = 2160;
                            f.B(6);
                            break;
                        }
                        if (!(d = a)) {
                            f.B(7);
                            break;
                        }
                        return F(f, cast.__platform__.canDisplayType('video/mp4; codecs="avc1.640028"; width=1920; height=1080'), 8);
                    case 8:
                        d = f.h;
                    case 7:
                        d && (b.width = 1920, b.height = 1080);
                    case 6:
                        ta(f, 3);
                        break;
                    case 2:
                        e = ua(f), $a("Failed to check canDisplayType:", e);
                    case 3:
                        return f.return(b);
                }
            });
        };
        p.ab = function(a) {
            gy.prototype.ab.call(this, a);
            a.streaming.stallSkip = 0;
            return a;
        };
        p.oi = function() {
            return !1;
        };
        p.ud = function() {
            return !0;
        };
        function jy() {
            return navigator.userAgent.includes("CrKey") && !navigator.userAgent.includes("VIZIO SmartCast");
        }
        var ky = "Android", ly = "Fuchsia", my = "Linux";
        jy() && (Tb = function() {
            return new iy;
        });
        function ny() {
            gy.call(this);
            var a = this;
            this.i = new Qb(function() {
                var b = navigator.userAgent.match(/(Chrome|Firefox)\/(\d+)/);
                return b ? parseInt(b[2], 10) : null;
            });
            this.g = new Qb(function() {
                return navigator.userAgent.match(/Edge?\//) ? "Edge" : navigator.userAgent.includes("Chrome") ? "Chrome" : navigator.userAgent.includes("Firefox") ? "Firefox" : "Unknown";
            });
            this.h = new Qb(function() {
                return navigator.userAgentData && navigator.userAgentData.platform ? navigator.userAgentData.platform.toLowerCase() == "windows" : navigator.platform ? navigator.platform.toLowerCase().includes("win32") : !1;
            });
            this.A = new Qb(function() {
                return navigator.userAgent.match(/Edge?\//) ? !a.h.value() : !0;
            });
            this.u = new Qb(function() {
                return navigator.userAgent.includes("sony.hbbtv.tv");
            });
            this.m = new Qb(function() {
                return navigator.userAgentData && navigator.userAgentData.platform ? navigator.userAgentData.platform.toLowerCase() == "android" : navigator.userAgent.includes("Android") ? !0 : !1;
            });
        }
        la(ny, gy);
        p = ny.prototype;
        p.Ga = function() {
            return this.i.value();
        };
        p.Ub = function() {
            return this.g.value();
        };
        p.Ud = function(a) {
            return zg(a) ? this.g.value() === "Edge" && this.h.value() : !1;
        };
        p.zj = function() {
            return this.g.value() === "Edge" && this.h.value();
        };
        p.Bf = function() {
            return this.g.value() === "Edge" && this.h.value();
        };
        p.bd = function() {
            return this.A.value();
        };
        p.ab = function(a) {
            gy.prototype.ab.call(this, a);
            if (this.h.value()) switch(this.g.value()){
                case "Firefox":
                    a.drm.keySystemsMapping = {
                        "com.microsoft.playready": "com.microsoft.playready.recommendation"
                    };
                    break;
                case "Chrome":
                    a.drm.keySystemsMapping = {
                        "com.microsoft.playready": "com.microsoft.playready.recommendation.3000",
                        "com.microsoft.playready.recommendation": "com.microsoft.playready.recommendation.3000"
                    };
            }
            this.m.value() && (a.drm.defaultAudioRobustnessForWidevine = "", a.drm.defaultVideoRobustnessForWidevine = "");
            return a;
        };
        p.Yh = function() {
            return this.g.value() === "Edge" || this.u.value();
        };
        p.ud = function() {
            if (this.Ja() === "GECKO") {
                var a = this.Ga();
                return a !== null ? a >= 100 : gy.prototype.ud.call(this);
            }
            return gy.prototype.ud.call(this);
        };
        p.Kh = function(a) {
            return this.Ja() === "GECKO" ? a.startsWith("com.microsoft.playready.recommendation") : gy.prototype.Kh.call(this, a);
        };
        Ub = function() {
            return new ny;
        };
        function oy() {
            gy.apply(this, arguments);
        }
        la(oy, gy);
        p = oy.prototype;
        p.Ga = function() {
            return null;
        };
        p.Ub = function() {
            return "Hisense";
        };
        p.Ka = function() {
            return "TV";
        };
        p.mc = function() {
            return !1;
        };
        p.wc = function() {
            var a = {
                width: 1920,
                height: 1080
            }, b = null;
            if (window1.Hisense_Get4KSupportState) try {
                b = window1.Hisense_Get4KSupportState();
            } catch (c) {}
            b == null && (b = navigator.userAgent.includes("UHD"));
            b && (a.width = 3840, a.height = 2160);
            return Promise.resolve(a);
        };
        p.ab = function(a) {
            gy.prototype.ab.call(this, a);
            a.streaming.stallSkip = 0;
            return a;
        };
        if (navigator.userAgent.includes("Hisense") || navigator.userAgent.includes("VIDAA")) Tb = function() {
            return new oy;
        };
        function py() {
            gy.call(this);
            this.g = new Qb(function() {
                var a = navigator.userAgent.match(/PlayStation (\d+)/);
                return a ? parseInt(a[1], 10) : null;
            });
        }
        la(py, gy);
        p = py.prototype;
        p.Ub = function() {
            return "PlayStation";
        };
        p.Ka = function() {
            return "CONSOLE";
        };
        p.Ja = function() {
            return "WEBKIT";
        };
        p.Ga = function() {
            return this.g.value();
        };
        p.mc = function() {
            return !1;
        };
        p.vd = function() {
            return !1;
        };
        p.bd = function() {
            return !1;
        };
        p.ki = function() {
            return this.Ga() === 4;
        };
        p.wc = function() {
            var a, b, c, d, e;
            return Q(function(f) {
                switch(f.g){
                    case 1:
                        return a = {
                            width: 1920,
                            height: 1080
                        }, b = !1, ra(f, 2), F(f, window1.msdk.device.getDisplayInfo(), 4);
                    case 4:
                        c = f.h;
                        b = c.resolution === "4K";
                        ta(f, 3);
                        break;
                    case 2:
                        return ua(f), ra(f, 5), F(f, window1.msdk.device.getDisplayInfoImmediate(), 7);
                    case 7:
                        d = f.h;
                        b = d.resolution === "4K";
                        ta(f, 3);
                        break;
                    case 5:
                        e = ua(f), ab("PlayStation: Failed to get the display info:", e);
                    case 3:
                        return b && (a.width = 3840, a.height = 2160), f.return(a);
                }
            });
        };
        p.ab = function(a) {
            gy.prototype.ab.call(this, a);
            this.Ga() === 4 && a.drm.preferredKeySystems.push("com.microsoft.playready");
            a.streaming.clearDecodingCache = !0;
            return a;
        };
        p.Yh = function() {
            return this.Ga() === 4;
        };
        p.mg = function() {
            return this.Ga() !== 4;
        };
        navigator.userAgent.includes("PlayStation") && (Tb = function() {
            return new py;
        });
        function qy() {
            gy.call(this);
            var a = navigator.userAgent.match(/Tizen (\d+).(\d+)/);
            this.g = a ? parseInt(a[1], 10) : null;
            this.h = a ? parseInt(a[2], 10) : null;
        }
        la(qy, gy);
        p = qy.prototype;
        p.Ga = function() {
            return this.g;
        };
        p.Ub = function() {
            return "Tizen";
        };
        p.Ja = function() {
            return "CHROMIUM";
        };
        p.Ka = function() {
            return "TV";
        };
        p.Ud = function() {
            return !0;
        };
        p.Fe = function() {
            return this.Ga() === 3;
        };
        p.mc = function() {
            return !1;
        };
        p.vd = function() {
            var a = this.Ga();
            return a !== null ? a >= 4 : gy.prototype.vd.call(this);
        };
        p.bd = function() {
            return !1;
        };
        p.Je = function() {
            return this.g && this.h ? this.g === 5 ? this.h >= 5 : this.g > 5 : gy.prototype.Je.call(this);
        };
        p.wc = function() {
            var a = window1.devicePixelRatio;
            a = {
                width: window1.screen.width * a > 1920 ? 3840 : 1920,
                height: window1.screen.height * a > 1080 ? 2160 : 1080
            };
            try {
                if (webapis.systeminfo && webapis.systeminfo.getMaxVideoResolution) {
                    var b = webapis.systeminfo.getMaxVideoResolution();
                    a.width = b.width;
                    a.height = b.height;
                } else webapis.productinfo.is8KPanelSupported && webapis.productinfo.is8KPanelSupported() ? (a.width = 7680, a.height = 4320) : webapis.productinfo.isUdPanelSupported && webapis.productinfo.isUdPanelSupported() && (a.width = 3840, a.height = 2160);
            } catch (c) {
                ab("Tizen: Error detecting screen size, default screen size 1920x1080.");
            }
            return Promise.resolve(a);
        };
        p.ab = function(a) {
            gy.prototype.ab.call(this, a);
            a.drm.ignoreDuplicateInitData = this.Ga() !== 2;
            this.Ga() === 3 && (a.streaming.crossBoundaryStrategy = "reset_to_encrypted");
            a.streaming.shouldFixTimestampOffset = !0;
            a.streaming.stallSkip = 0;
            a.streaming.gapPadding = 2;
            return a;
        };
        p.xj = function() {
            var a = [];
            this.g !== null && this.g < 5 && a.push("opus");
            return a;
        };
        p.Id = function(a) {
            try {
                if (webapis.avinfo.isHdrTvSupport()) return a ? "HLG" : "PQ";
            } catch (b) {
                return gy.prototype.Id.call(this, a);
            }
            return "SDR";
        };
        p.nj = function() {
            return !0;
        };
        p.oj = function() {
            return this.Ga() === 3;
        };
        navigator.userAgent.includes("Tizen") && (Tb = function() {
            return new qy;
        });
        function ry() {
            gy.apply(this, arguments);
        }
        la(ry, gy);
        ry.prototype.Ga = function() {
            return null;
        };
        ry.prototype.Ub = function() {
            return "Vizio";
        };
        ry.prototype.Ka = function() {
            return "TV";
        };
        ry.prototype.mc = function() {
            return !1;
        };
        navigator.userAgent.includes("VIZIO SmartCast") && (Tb = function() {
            return new ry;
        });
        function sy() {
            gy.call(this);
            this.i = new Qb(function() {
                return navigator.userAgent.includes("DT_STB_BCM") || navigator.userAgent.includes("Sky_STB");
            });
            this.h = new Qb(function() {
                return navigator.userAgent.includes("SOPOpenBrowser");
            });
            this.g = new Qb(function() {
                if (navigator.userAgent.includes("DT_STB_BCM")) return 11;
                var a = navigator.userAgent.match(/Version\/(\d+)/);
                return a ? parseInt(a[1], 10) : (a = navigator.userAgent.match(/OS (\d+)(?:_\d+)?/)) ? parseInt(a[1], 10) : null;
            });
        }
        la(sy, gy);
        p = sy.prototype;
        p.Ga = function() {
            return this.g.value();
        };
        p.Ub = function() {
            return "WebKit STB";
        };
        p.Ka = function() {
            return "TV";
        };
        p.Ja = function() {
            return "WEBKIT";
        };
        p.mc = function() {
            return !1;
        };
        p.vd = function() {
            var a = this.g.value();
            return a !== null ? a >= 15 : !0;
        };
        p.Ud = function() {
            return this.h.value();
        };
        p.wc = function() {
            return Promise.resolve({
                width: window1.screen.width * window1.devicePixelRatio,
                height: window1.screen.height * window1.devicePixelRatio
            });
        };
        p.mg = function() {
            return !this.i.value();
        };
        p.lg = function() {
            return !1;
        };
        if (navigator.userAgent.includes("SOPOpenBrowser") || navigator.userAgent.includes("DT_STB_BCM") || navigator.userAgent.includes("Sky_STB") || !(!(navigator.vendor || "").includes("Apple") || /(?:iPhone|iPad|iPod)/.test(navigator.userAgent) || navigator.maxTouchPoints > 1 || navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform.toLowerCase() == "macos" || navigator.platform && navigator.platform.toLowerCase().includes("mac"))) Tb = function() {
            return new sy;
        };
        function ty() {
            gy.call(this);
            var a = this;
            this.h = uy();
            this.g = null;
            try {
                var b = new PalmServiceBridge;
                b.onservicecallback = function(c) {
                    c = JSON.parse(c);
                    a.g = c.vk["tv.model.supportHDR"] || c.vk["tv.config.supportDolbyHDRContents"] || !1;
                };
                b.call("luna://com.webos.service.config/getConfigs", JSON.stringify({
                    Tn: [
                        "tv.model.supportHDR",
                        "tv.config.supportDolbyHDRContents"
                    ]
                }));
            } catch (c) {
                ab("WebOS: getConfigs call failed", c);
            }
        }
        la(ty, gy);
        p = ty.prototype;
        p.Ga = function() {
            return this.h;
        };
        p.Ub = function() {
            return "WebOS";
        };
        p.Ka = function() {
            return "TV";
        };
        p.Ja = function() {
            return "CHROMIUM";
        };
        p.mc = function() {
            return !1;
        };
        p.vd = function() {
            var a = this.Ga();
            return a !== null ? a > 3 : gy.prototype.vd.call(this);
        };
        p.bd = function() {
            var a = this.Ga();
            return a !== null ? a > 6 : gy.prototype.bd.call(this);
        };
        p.Je = function() {
            var a = this.Ga();
            return a !== null ? a > 3 : gy.prototype.Je.call(this);
        };
        p.wc = function() {
            var a = {
                width: 1920,
                height: 1080
            };
            try {
                var b = JSON.parse(window1.PalmSystem.deviceInfo);
                a.width = Math.max(1920, b.screenWidth);
                a.height = Math.max(1080, b.screenHeight);
            } catch (c) {
                ab("WebOS: Error detecting screen size, default screen size 1920x1080.");
            }
            return Promise.resolve(a);
        };
        p.ab = function(a) {
            gy.prototype.ab.call(this, a);
            this.Ga() === 3 && (a.streaming.crossBoundaryStrategy = "reset");
            a.streaming.shouldFixTimestampOffset = !0;
            a.streaming.stallSkip = 0;
            return a;
        };
        p.Id = function(a) {
            return this.g == null ? (ab("WebOS: getConfigs call haven't finished"), gy.prototype.Id.call(this, a)) : this.g ? a ? "HLG" : "PQ" : "SDR";
        };
        function uy() {
            var a = null, b = navigator.userAgent.match(/Chrome\/(\d+)/);
            b && (a = parseInt(b[1], 10));
            switch(a){
                case 38:
                    return 3;
                case 53:
                    return 4;
                case 68:
                    return 5;
                case 79:
                    return 6;
                case 87:
                    return 22;
                case 94:
                    return 23;
                case 108:
                    return 24;
                case 120:
                    return 25;
                default:
                    return null;
            }
        }
        p.Yj = function() {
            return !1;
        };
        p.ud = function() {
            var a = this.Ga();
            return a !== null ? a >= 6 : gy.prototype.ud.call(this);
        };
        if (navigator.userAgent.includes("Web0S")) {
            var vy = new ty;
            Tb = function() {
                return vy;
            };
        }
        function wy() {
            gy.call(this);
            this.g = navigator.userAgent.includes("Edge/");
            var a = navigator.userAgent.match(/Edge?\/(\d+)/);
            this.h = a ? parseInt(a[1], 10) : null;
        }
        la(wy, gy);
        p = wy.prototype;
        p.Ga = function() {
            return this.h;
        };
        p.Ub = function() {
            return "Xbox";
        };
        p.Ka = function() {
            return "CONSOLE";
        };
        p.Ja = function() {
            return this.g ? "EDGE" : "CHROMIUM";
        };
        p.Ud = function() {
            return !0;
        };
        p.Bf = function() {
            return !0;
        };
        p.Qj = function() {
            return this.g;
        };
        p.wc = function() {
            var a = {
                width: 1920,
                height: 1080
            }, b = xy();
            if (b) try {
                var c = new b.Media.Protection.ProtectionCapabilities, d = b.Media.Protection.ProtectionCapabilityResult;
                b = null;
                do b = c.isTypeSupported('video/mp4;codecs="hvc1,mp4a";features="decode-res-x=3840,decode-res-y=2160,decode-bitrate=20000,decode-fps=30,decode-bpc=10,display-res-x=3840,display-res-y=2160,display-bpc=8"', "com.microsoft.playready.recommendation");
                while (b === d.maybe);
                b === d.probably && (a.width = 3840, a.height = 2160);
            } catch (e) {
                ab("Xbox: Error detecting screen size, default screen size 1920x1080.");
            }
            return Promise.resolve(a);
        };
        p.ab = function(a) {
            gy.prototype.ab.call(this, a);
            a.drm.parseInbandPsshEnabled = this.g;
            a.drm.preferredKeySystems.push("com.microsoft.playready");
            this.g && (a.streaming.gapPadding = .01);
            return a;
        };
        p.oi = function() {
            return !1;
        };
        function xy() {
            var a = null;
            try {
                a = typeof Windows !== "undefined" ? Windows : chrome.webview.hostObjects.sync.Windows;
            } catch (b) {}
            return a;
        }
        if (navigator.userAgent.includes("Xbox One") || xy() !== null) Tb = function() {
            return new wy;
        };
        function yy(a, b, c) {
            this.type = a;
            this.ma = b;
            this.segments = c || null;
        }
        function zy(a, b, c, d) {
            this.id = a;
            this.name = b;
            this.attributes = c;
            this.value = d === void 0 ? null : d;
        }
        zy.prototype.toString = function(a) {
            function b(e) {
                return e.name + "=" + (isNaN(Number(e.value)) ? '"' + e.value + '"' : e.value);
            }
            var c = "#" + this.name, d = this.attributes ? this.attributes.filter(function(e) {
                return a ? !a.has(e.name) : !0;
            }).map(b) : [];
            this.value && d.unshift(this.value);
            d.length > 0 && (c += ":" + d.join(","));
            return c;
        };
        function Ay(a, b) {
            if (b) return a.toString();
            b = (new Set).add("AUDIO").add("VIDEO").add("SUBTITLES").add("PATHWAY-ID").add("GROUP-ID").add("URI");
            return a.toString(b);
        }
        function By(a, b) {
            a = a.attributes.filter(function(c) {
                return c.name == b;
            });
            return a.length ? a[0] : null;
        }
        function Cy(a, b, c) {
            return (a = By(a, b)) ? a.value : c || null;
        }
        function Dy(a, b) {
            a = By(a, b);
            if (!a) throw new U(2, 4, 4023, b);
            return a.value;
        }
        function Ey(a, b, c) {
            c = c === void 0 ? [] : c;
            this.ma = b;
            this.g = a;
            this.Fc = c;
        }
        function Fy(a, b) {
            this.name = a;
            this.value = b;
        }
        function Gy(a, b) {
            return a.filter(function(c) {
                return c.name == b;
            });
        }
        function Hy(a, b) {
            return a.filter(function(c) {
                return Dy(c, "TYPE") == b;
            });
        }
        function Iy(a, b) {
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next())if (c = c.value, c.name === b) return c;
            return null;
        }
        function Jy(a, b, c) {
            c = c === void 0 ? 0 : c;
            return (a = Iy(a, b)) ? Number(a.value) : c;
        }
        function Ky(a, b, c) {
            return b ? Ly(a, [
                b
            ], c) : [];
        }
        function Ly(a, b, c) {
            if (!b.length) return [];
            var d = b;
            c && c.size && (d = b.map(function(e) {
                return My(e, c);
            }));
            return mc(a, d);
        }
        function My(a, b) {
            if (!b || !b.size) return a;
            a = String(a).replace(/%7B/g, "{").replace(/%7D/g, "}");
            var c = a.match(/{\$\w*}/g);
            if (c) {
                c = u(c);
                for(var d = c.next(); !d.done; d = c.next()){
                    d = d.value;
                    var e = d.slice(2, d.length - 1), f = b.get(e);
                    if (f) a = a.replace(d, f);
                    else throw new U(2, 4, 4039, e);
                }
            }
            return a;
        }
        function Ny() {
            this.g = 0;
        }
        function Oy(a, b) {
            b = Wb(b);
            b = b.replace(/\r\n|\r(?=[^\n]|$)/gm, "\n").trim();
            var c = b.split(/\n+/m);
            if (!/^#EXTM3U($|[ \t\n])/m.test(c[0])) throw new U(2, 4, 4015);
            b = 0;
            for(var d = !0, e = u(c), f = e.next(); !f.done; f = e.next())if (f = f.value, /^#(?!EXT)/m.test(f) || d) d = !1;
            else if (f = Py(a, f), --a.g, Qy.includes(f.name)) {
                b = 1;
                break;
            } else f.name == "EXT-X-STREAM-INF" && (d = !0);
            e = [];
            d = !0;
            for(f = 0; f < c.length; f++){
                var g = c[f], h = c[f + 1];
                if (/^#(?!EXT)/m.test(g) || d) d = !1;
                else {
                    g = Py(a, g);
                    if (Ry.includes(g.name)) {
                        if (b != 1) throw new U(2, 4, 4017);
                        g = c.splice(f, c.length - f);
                        c = [];
                        d = [];
                        f = [];
                        h = null;
                        g = u(g);
                        for(var k = g.next(); !k.done; k = g.next())k = k.value, /^(#EXT)/.test(k) ? (k = Py(a, k), Qy.includes(k.name) ? e.push(k) : k.name == "EXT-X-MAP" ? h = k : k.name == "EXT-X-PART" ? f.push(k) : k.name == "EXT-X-PRELOAD-HINT" ? Cy(k, "TYPE") == "PART" ? f.push(k) : Cy(k, "TYPE") == "MAP" && (k.name = "EXT-X-MAP", h = k) : d.push(k)) : /^#(?!EXT)/m.test(k) || (k = k.trim(), h && d.push(h), c.push(new Ey(k, d, f)), d = [], f = []);
                        f.length && (h && d.push(h), c.push(new Ey("", d, f)));
                        return new yy(b, e, c);
                    }
                    e.push(g);
                    g.name == "EXT-X-STREAM-INF" && (g.attributes.push(new Fy("URI", h)), d = !0);
                }
            }
            return new yy(b, e);
        }
        function Py(a, b) {
            a = a.g++;
            var c = b.match(/^#(EXT[^:]*)(?::(.*))?$/);
            if (!c) throw new U(2, 4, 4016, b);
            b = c[1];
            var d = c[2];
            c = [];
            var e;
            if (d) {
                d = new wd(d);
                var f;
                (f = yd(d, /^([^,=]+)(?:,|$)/g)) && (e = f[1]);
                for(var g = /([^=]+)=(?:"([^"]*)"|([^",]*))(?:,|$)/g; f = yd(d, g);)c.push(new Fy(f[1], f[2] || f[3])), xd(d);
            }
            return new zy(a, b, c, e);
        }
        var Qy = "EXT-X-TARGETDURATION EXT-X-MEDIA-SEQUENCE EXT-X-DISCONTINUITY-SEQUENCE EXT-X-PLAYLIST-TYPE EXT-X-I-FRAMES-ONLY EXT-X-ENDLIST EXT-X-SERVER-CONTROL EXT-X-SKIP EXT-X-PART-INF EXT-X-DATERANGE".split(" "), Ry = "EXTINF EXT-X-BYTERANGE EXT-X-DISCONTINUITY EXT-X-PROGRAM-DATE-TIME EXT-X-KEY EXT-X-DATERANGE EXT-X-MAP EXT-X-GAP EXT-X-TILES".split(" ");
        function Sy() {}
        function Ty(a, b) {
            try {
                var c = Uy(a);
                return Pg({
                    uri: a,
                    originalUri: a,
                    data: c.data,
                    headers: {
                        "content-type": c.contentType
                    },
                    originalRequest: b
                });
            } catch (d) {
                return Ng(d);
            }
        }
        function Uy(a) {
            var b = a.split(":");
            if (b.length < 2 || b[0] != "data") throw new U(2, 1, 1004, a);
            b = b.slice(1).join(":").split(",");
            if (b.length < 2) throw new U(2, 1, 1004, a);
            var c = b[0];
            a = window1.decodeURIComponent(b.slice(1).join(","));
            b = c.split(";");
            c = b[0];
            var d = !1;
            b.length > 1 && b[b.length - 1] == "base64" && (d = !0, b.pop());
            var e;
            d ? e = hc(a) : e = $b(a);
            return {
                data: e,
                contentType: c
            };
        }
        S("shaka.net.DataUriPlugin", Sy);
        Sy.parse = Ty;
        Wg("data", Ty);
        function Vy() {
            var a = this;
            this.g = this.h = null;
            this.G = 1;
            this.C = new Map;
            this.L = new Map;
            this.D = new Map;
            this.D.set("video", new Map);
            this.D.set("audio", new Map);
            this.D.set(sc, new Map);
            this.D.set("image", new Map);
            this.Ec = (new Map).set("com.apple.streamingkeydelivery", function(b, c, d) {
                return Wy(a, b, c, d);
            }).set("urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed", function(b) {
                var c = Dy(b, "METHOD");
                if ([
                    "SAMPLE-AES",
                    "SAMPLE-AES-CTR"
                ].includes(c)) {
                    var d = "cenc";
                    c == "SAMPLE-AES" && (d = "cbcs");
                    var e = Dy(b, "URI");
                    c = Uy(e.split("?")[0]);
                    e = e.split("?")[0];
                    a.I.has(e) || (c = Kb(c.data), a.I.set(e, c));
                    d = nc("com.widevine.alpha", d, [
                        {
                            initDataType: "cenc",
                            initData: a.I.get(e)
                        }
                    ]);
                    (b = Cy(b, "KEYID")) && d.keyIds.add(b.toLowerCase().substr(2));
                    b = Promise.resolve(d);
                } else b = Promise.resolve(null);
                return b;
            }).set("com.microsoft.playready", function(b) {
                var c = Dy(b, "METHOD");
                if ([
                    "SAMPLE-AES",
                    "SAMPLE-AES-CTR"
                ].includes(c)) {
                    var d = "cenc";
                    c == "SAMPLE-AES" && (d = "cbcs");
                    b = Dy(b, "URI");
                    b = Uy(b.split("?")[0]);
                    b = Kb(b.data);
                    c = new Uint8Array([
                        154,
                        4,
                        240,
                        121,
                        152,
                        64,
                        66,
                        134,
                        171,
                        146,
                        230,
                        91,
                        224,
                        136,
                        95,
                        149
                    ]);
                    c = Ah(b, c, new Set, 0);
                    d = nc("com.microsoft.playready", d, [
                        {
                            initDataType: "cenc",
                            initData: c
                        }
                    ]);
                    if (b = Kd([
                        "<PLAYREADY>",
                        fc(b),
                        "</PLAYREADY>"
                    ].join("\n"))) d.licenseServerUri = Cv(b);
                    d = Promise.resolve(d);
                } else d = Promise.resolve(null);
                return d;
            }).set("urn:uuid:3d5e6d35-9b9a-41e8-b843-dd3c6e72c42c", function(b) {
                var c = Dy(b, "METHOD");
                if ([
                    "SAMPLE-AES",
                    "SAMPLE-AES-CTR"
                ].includes(c)) {
                    var d = "cenc";
                    c == "SAMPLE-AES" && (d = "cbcs");
                    var e = Dy(b, "URI");
                    c = Uy(e.split("?")[0]);
                    e = e.split("?")[0];
                    a.I.has(e) || (c = Kb(c.data), a.I.set(e, c));
                    d = nc("com.huawei.wiseplay", d, [
                        {
                            initDataType: "cenc",
                            initData: a.I.get(e)
                        }
                    ]);
                    (b = Cy(b, "KEYID")) && d.keyIds.add(b.toLowerCase().substr(2));
                    b = Promise.resolve(d);
                } else b = Promise.resolve(null);
                return b;
            });
            this.jb = new Set;
            this.i = new Map;
            this.l = null;
            this.H = "";
            this.Oa = new Ny;
            this.M = -1;
            this.aa = Infinity;
            this.Y = this.Ic = this.ib = !1;
            this.F = new Bf(function() {
                if (a.V && !a.g.continueLoadingWhenPaused && (a.S.Ea(a.V, "timeupdate"), a.V.paused)) {
                    a.S.ua(a.V, "timeupdate", function() {
                        return Xy(a);
                    });
                    return;
                }
                Xy(a);
            });
            this.Fa = Yy;
            this.m = null;
            this.fb = 0;
            this.u = Infinity;
            this.hb = this.Ma = this.R = 0;
            this.X = new Tg;
            this.J = new Map;
            this.K = new Map;
            this.xa = new Map;
            this.oa = new Map;
            this.O = new Map;
            this.ra = new Map;
            this.sa = new Map;
            this.Hc = this.ea = !1;
            this.Pb = new Lc(5);
            this.j = null;
            this.P = !0;
            this.S = new Tc;
            this.A = this.V = null;
            this.kc = function() {
                return !1;
            };
            this.I = new Map;
        }
        p = Vy.prototype;
        p.configure = function(a, b) {
            var c = this.h && a.updatePeriod != this.g.updatePeriod && a.updatePeriod >= 0;
            this.g = a;
            b && (this.kc = b);
            this.j && this.j.configure(this.g);
            c && this.m && this.m.presentationTimeline.U() && this.F.La();
        };
        p.start = function(a, b) {
            var c = this, d;
            return Q(function(e) {
                return e.g == 1 ? (c.h = b, c.ea = b.isLowLatencyMode(), F(e, Zy(c, [
                    a
                ]).promise, 2)) : e.g != 3 ? (d = e.h, c.H = d.uri, F(e, $y(c, d.data), 3)) : e.return(c.m);
            });
        };
        p.stop = function() {
            this.F && (this.F.stop(), this.F = null);
            var a = [];
            this.X && (a.push(this.X.destroy()), this.X = null);
            this.g = this.h = null;
            this.jb.clear();
            this.m = null;
            this.i.clear();
            this.L.clear();
            this.K.clear();
            this.C.clear();
            this.xa.clear();
            this.oa.clear();
            this.O.clear();
            this.ra.clear();
            this.sa.clear();
            this.I.clear();
            this.j && this.j.destroy();
            this.S && (this.S.release(), this.S = null);
            return Promise.all(a);
        };
        p.update = function() {
            var a = this, b, c, d, e, f, g, h, k, l, m, n, q;
            return Q(function(r) {
                if (r.g == 1) {
                    if (!az(a)) return r.return();
                    b = [];
                    c = Array.from(a.i.values());
                    a.u = Infinity;
                    a.m.gapCount = 0;
                    d = c.filter(function(t) {
                        return t.stream.segmentIndex;
                    });
                    e = u(d);
                    for(f = e.next(); !f.done; f = e.next())g = f.value, b.push(bz(a, g));
                    return F(r, Promise.all(b), 2);
                }
                cz(a, d.map(function(t) {
                    return t.stream;
                }));
                h = d.some(function(t) {
                    return t.pe == 0;
                });
                d.length && !h && (k = dz, ez(a, k.jk), l = d.map(function(t) {
                    return t.Bc;
                }), a.l.zb(Math.min.apply(Math, x(l))), a.h.updateDuration());
                h && fz(a);
                m = u(d);
                for(n = m.next(); !n.done; n = m.next())q = n.value, q.stream.isAudioMuxedInVideo || !q.stream.segmentIndex || eg(q.stream.segmentIndex) || a.h.disableStream(q.stream);
                H(r);
            });
        };
        function gz(a, b) {
            return az(a) ? a.D.get(b.type) : b.Kf;
        }
        function bz(a, b) {
            var c, d, e, f, g, h, k, l, m, n, q, r, t, w, v, z, y, A, C, E, D, B, G, I, J, L, K, N, P, O, M, R, W, wa, Y, Ka, Na;
            return Q(function(La) {
                switch(La.g){
                    case 1:
                        if (b.stream.isAudioMuxedInVideo) return La.return();
                        c = [];
                        d = u(b.T());
                        for(e = d.next(); !e.done; e = d.next())f = e.value, g = new qb(f), h = g.g, b.lf && (b.Zb >= 0 && h.add("_HLS_msn", String(b.Zb)), b.$b >= 0 && h.add("_HLS_part", String(b.$b))), b.mf && h.add("_HLS_skip", "YES"), Hb(h) && ub(g, vb(h.toString())), c.push(g.toString());
                        ra(La, 2);
                        return F(La, Zy(a, c, !0).promise, 4);
                    case 4:
                        k = La.h;
                        ta(La, 3);
                        break;
                    case 2:
                        throw l = ua(La), a.h && a.h.disableStream(b.stream), l;
                    case 3:
                        if (!b.stream.segmentIndex) return La.return();
                        m = Oy(a.Oa, k.data);
                        if (m.type != 1) throw new U(2, 4, 4017);
                        n = k.uri;
                        n == k.originalUri || b.T().includes(n) || b.Zf.push(n);
                        q = Gy(m.ma, "EXT-X-DEFINE");
                        r = hz(a, q, n);
                        t = b.stream;
                        w = gz(a, b);
                        return F(La, iz(a, m, t.mimeType, b.T, r), 5);
                    case 5:
                        v = La.h;
                        z = v.keyIds;
                        y = v.drmInfos;
                        A = v.encrypted;
                        C = v.Fi;
                        t.encrypted || !A || C || (t.encrypted = !0);
                        E = function(Ea, za) {
                            return Ea.size === za.size && [].concat(x(Ea)).every(function(Fa) {
                                return za.has(Fa);
                            });
                        };
                        E(t.keyIds, z) || (t.keyIds = z, t.drmInfos = y, a.h.newDrmInfo(t));
                        D = jz(a, m, w, r, b.T, b.type);
                        B = D.segments;
                        if (G = D.bandwidth) t.bandwidth = G;
                        I = lm(t);
                        J = u(B);
                        for(L = J.next(); !L.done; L = J.next())K = L.value, K.ia && (K.ia.Od = I);
                        t.segmentIndex.ze(B, a.l.Nb());
                        B.length && (N = Jy(m.ma, "EXT-X-MEDIA-SEQUENCE", 0), O = (P = Iy(m.ma, "EXT-X-SKIP")) ? Number(Cy(P, "SKIPPED-SEGMENTS")) : 0, M = kz(N, B), R = M.Zb, W = M.$b, b.Zb = R + O, b.$b = W, wa = w.get(N), t.segmentIndex.cb(wa));
                        if (Y = eg(t.segmentIndex)) b.md = Y.startTime, Ka = B[B.length - 1], b.Bc = Ka.endTime;
                        if (Na = Iy(m.ma, "EXT-X-ENDLIST")) b.pe = !0;
                        lz(a, m);
                        mz(a, m.ma, t.type, r, b.T);
                        H(La);
                }
            });
        }
        p.onExpirationUpdated = function() {};
        p.onInitialVariantChosen = function() {};
        p.banLocation = function(a) {
            this.j && this.j.banLocation(a);
        };
        p.setMediaElement = function(a) {
            this.V = a;
        };
        function nz(a, b, c) {
            c = c === void 0 ? !1 : c;
            for(var d = a.M == -1, e = u(b), f = e.next(); !f.done; f = e.next()){
                f = f.value;
                var g = f.stream.segmentIndex, h = gz(a, f);
                if (g = eg(g)) {
                    h = u(h);
                    for(var k = h.next(); !k.done; k = h.next()){
                        k = u(k.value);
                        var l = k.next().value;
                        if (k.next().value == g.startTime) {
                            d && (a.M = Math.max(a.M, l));
                            f.Vg = l;
                            break;
                        }
                    }
                }
            }
            if (!(a.M < 0)) {
                for(b = u(b), d = b.next(); !d.done; d = b.next())if (d = d.value, oz(a, d.type) || c) {
                    if (e = d.stream.segmentIndex) {
                        if (f = a.M - d.Vg, f > 0 && (e.g.splice(0, f), e = eg(e))) e = -e.startTime, d.stream.segmentIndex.offset(e), pz(a, d, e);
                    }
                }
            }
        }
        function qz(a, b) {
            if (a.aa == Infinity) {
                b = u(b);
                for(var c = b.next(); !c.done; c = b.next())c = eg(c.value.stream.segmentIndex), c != null && c.h != null && (a.aa = Math.min(a.aa, c.h));
            }
            b = a.aa;
            if (b != Infinity) {
                c = u(a.i.values());
                for(var d = c.next(); !d.done; d = c.next())if (d = d.value, !oz(a, d.type)) {
                    var e = d.stream.segmentIndex;
                    if (e != null) {
                        var f = eg(e);
                        if (f) {
                            if (f.h == null) $a("Missing EXT-X-PROGRAM-DATE-TIME for stream", d.T(), "Expect AV sync issues!");
                            else for(pz(a, d, f.h - b - f.startTime), d = u(e), e = d.next(); !e.done; e = d.next())e.value.pi(b);
                        }
                    }
                }
            }
        }
        function pz(a, b, c) {
            if (!(Math.abs(c) < .001)) {
                b.md += c;
                b.Bc += c;
                a = gz(a, b);
                for(var d = u(a), e = d.next(); !e.done; e = d.next()){
                    var f = u(e.value);
                    e = f.next().value;
                    f = f.next().value;
                    a.set(e, f + c);
                }
                b.T();
            }
        }
        function $y(a, b) {
            var c, d, e, f, g, h, k, l, m, n, q, r, t, w, v, z, y, A, C, E, D, B, G, I, J, L, K, N, P, O, M, R, W, wa, Y, Ka, Na, La, Ea, za, Fa, Da, Aa;
            return Q(function(Ca) {
                switch(Ca.g){
                    case 1:
                        c = uc;
                        d = Oy(a.Oa, b);
                        e = Gy(d.ma, "EXT-X-DEFINE");
                        f = [];
                        g = [];
                        h = [];
                        a.l = new yl(null, 0);
                        a.l.sd(!0);
                        k = function() {
                            return [
                                a.H
                            ];
                        };
                        l = null;
                        m = new Map;
                        if (d.type == 1) return a.P = !1, R = Gy(d.ma, "EXT-X-DEFINE"), m = hz(a, R, a.H), l = c.Ia, W = "", wa = new Map, F(Ca, rz(a, a.G++, m, d, k, "", l, W, !0, "Media Playlist", null, wa, null, !1, null, !1), 7);
                        sz(a, e);
                        n = Gy(d.ma, "EXT-X-MEDIA");
                        q = Gy(d.ma, "EXT-X-STREAM-INF");
                        r = Gy(d.ma, "EXT-X-IMAGE-STREAM-INF");
                        t = Gy(d.ma, "EXT-X-I-FRAME-STREAM-INF");
                        w = Gy(d.ma, "EXT-X-SESSION-KEY");
                        v = Gy(d.ma, "EXT-X-SESSION-DATA");
                        z = Gy(d.ma, "EXT-X-CONTENT-STEERING");
                        tz(a, v);
                        return F(Ca, uz(a, z), 4);
                    case 4:
                        if (!a.g.ignoreSupplementalCodecs) {
                            y = [];
                            A = u(q);
                            C = A.next();
                            for(E = {}; !C.done; E = {
                                Wj: void 0
                            }, C = A.next())if (D = C.value, B = Cy(D, "SUPPLEMENTAL-CODECS")) E.Wj = B.split(/\s*,\s*/).map(function(gb) {
                                return gb.split("/")[0];
                            }), G = D.attributes.map(function(gb) {
                                return function(ib) {
                                    var jb = ib.name, Ab = ib.value;
                                    jb == "CODECS" && (Ab = gb.Wj.join(","), ib = ib.value.split(","), ib.length > 1 && (ib = qc("audio", ib)) && (Ab += "," + ib));
                                    return new Fy(jb, Ab);
                                };
                            }(E)), y.push(new zy(D.id, D.name, G, null));
                            q.push.apply(q, x(y));
                            I = [];
                            J = u(t);
                            L = J.next();
                            for(K = {}; !L.done; K = {
                                Xj: void 0
                            }, L = J.next())if (N = L.value, P = Cy(N, "SUPPLEMENTAL-CODECS")) K.Xj = P.split(/\s*,\s*/).map(function(gb) {
                                return gb.split("/")[0];
                            }), O = N.attributes.map(function(gb) {
                                return function(ib) {
                                    var jb = ib.name;
                                    ib = ib.value;
                                    jb == "CODECS" && (ib = gb.Xj.join(","));
                                    return new Fy(jb, ib);
                                };
                            }(K)), I.push(new zy(N.id, N.name, O, null));
                            t.push.apply(t, x(I));
                        }
                        vz(a, q);
                        wz(a, n);
                        M = xz(a, t);
                        return F(Ca, yz(a, q, w, n, k, a.C, M), 5);
                    case 5:
                        return f = Ca.h, g = zz(a, n), F(Ca, Az(a, r, t), 6);
                    case 6:
                        h = Ca.h;
                        Ca.B(3);
                        break;
                    case 7:
                        Y = Ca.h, a.i.set(a.H, Y), Y.stream && (Ka = lm(Y.stream), Y.stream.segmentIndex.Lb(function(gb) {
                            gb.ia && (gb.ia.Od = Ka);
                        })), l = Y.stream.type, Na = !0, a.g.disableAudio && Y.type == "audio" ? Na = !1 : a.g.disableVideo && Y.type == "video" && !Y.stream.codecs.includes(",") && (Na = !1), Na && f.push({
                            id: 0,
                            language: yc(W || "und"),
                            disabledUntilTime: 0,
                            primary: !0,
                            audio: Y.type == "audio" ? Y.stream : null,
                            video: Y.type == "video" ? Y.stream : null,
                            bandwidth: Y.stream.bandwidth || 0,
                            allowedByApplication: !0,
                            allowedByKeySystem: !0,
                            decodingInfos: []
                        });
                    case 3:
                        if (!a.h) throw new U(2, 7, 7001);
                        Bz(a, d);
                        d.type == 1 && (az(a) && (Cz(a, d), La = a.u, a.F.$(La)), Ea = Array.from(a.i.values()), Dz(a, Ea), fz(a), mz(a, d.ma, l, m, k));
                        a.m = {
                            presentationTimeline: a.l,
                            variants: f,
                            textStreams: g,
                            imageStreams: h,
                            offlineSessionIds: [],
                            sequenceMode: a.g.hls.sequenceMode,
                            ignoreManifestTimestampsInSegmentsMode: a.g.hls.ignoreManifestTimestampsInSegmentsMode,
                            type: "HLS",
                            serviceDescription: null,
                            nextUrl: null,
                            periodCount: 1,
                            gapCount: 0,
                            isLowLatency: !1,
                            startTime: a.A
                        };
                        if (a.Y || !a.g.hls.disableCodecGuessing) {
                            Ca.B(8);
                            break;
                        }
                        za = [];
                        Fa = u(a.m.variants);
                        for(Da = Fa.next(); !Da.done; Da = Fa.next())Aa = Da.value, Aa.audio && Aa.audio.codecs === "" && za.push(Aa.audio.createSegmentIndex()), Aa.video && Aa.video.codecs === "" && za.push(Aa.video.createSegmentIndex());
                        return F(Ca, Promise.all(za), 8);
                    case 8:
                        a.h.makeTextStreamsForClosedCaptions(a.m), H(Ca);
                }
            });
        }
        function Ez(a, b) {
            var c, d, e, f, g, h, k, l, m, n, q, r, t, w, v, z, y, A;
            return Q(function(C) {
                if (C.g == 1) {
                    c = Bm(a.g.hls.mediaPlaylistFullMimeType);
                    if (!b.length) return C.return(c);
                    d = Fz(a, b);
                    e = d.segment;
                    f = d.segmentIndex;
                    g = e.T();
                    h = g[0];
                    k = new qb(h);
                    l = k.qb.split(".").pop();
                    return (m = Gz.get(l)) ? C.return(Bm(m)) : F(C, Promise.all([
                        Hz(a, e.ia, 0),
                        Hz(a, e, f)
                    ]), 2);
                }
                n = C.h;
                q = n[1].mimeType;
                r = n[0].data;
                t = n[1].data;
                w = "mp4 mp4a m4s m4i m4a m4f cmfa mp4v m4v cmfv fmp4".split(" ");
                v = [
                    "audio/mp4",
                    "video/mp4",
                    "video/iso.segment"
                ];
                z = e.ia || v.includes(q);
                if (!z && vk(Kb(t))) {
                    var E = t, D = a.g.disableAudio, B = a.g.disableVideo, G = a.g.disableText;
                    var I = Kb(E);
                    var J = (new nk).parse(I), L = J.le();
                    I = J.xh();
                    var K = [], N = !1, P = !1;
                    if (!D) switch(L.audio){
                        case "aac":
                        case "aac-loas":
                            J.Db().length && (K.push("mp4a.40.2"), N = !0);
                            break;
                        case "mp3":
                            J.Db().length && (K.push("mp4a.40.34"), N = !0);
                            break;
                        case "ac3":
                            J.Db().length && (K.push("ac-3"), N = !0);
                            break;
                        case "ec3":
                            J.Db().length && (K.push("ec-3"), N = !0);
                            break;
                        case "opus":
                            J.Db().length && (K.push("opus"), N = !0);
                    }
                    if (!B) switch(L.video){
                        case "avc":
                            I.codec ? K.push(I.codec) : K.push("avc1.42E01E");
                            P = !0;
                            break;
                        case "hvc":
                            I.codec ? K.push(I.codec) : K.push("hvc1.1.6.L93.90");
                            P = !0;
                            break;
                        case "av1":
                            K.push("av01.0.01M.08"), P = !0;
                    }
                    if (K.length) {
                        D = N && !P;
                        B = new Map;
                        if (P && !G) {
                            G = new od("video/mp2t");
                            G.Uf(E);
                            E = u(G.zg());
                            for(P = E.next(); !P.done; P = E.next())P = P.value, B.set(P, P);
                            G.ce();
                        }
                        I = {
                            type: D ? "audio" : "video",
                            mimeType: "video/mp2t",
                            codecs: K.join(", "),
                            language: null,
                            height: I.height,
                            width: I.width,
                            channelCount: null,
                            sampleRate: null,
                            closedCaptions: B,
                            Ne: null,
                            colorGamut: null,
                            frameRate: I.frameRate
                        };
                    } else I = null;
                    if (y = I) return C.return(y);
                } else if (z || w.includes(l)) {
                    if (A = Cm(r, t, a.g.disableText)) return C.return(A);
                }
                return q ? C.return(Bm(q)) : C.return(c);
            });
        }
        function Hz(a, b, c) {
            var d, e, f, g, h, k;
            return Q(function(l) {
                switch(l.g){
                    case 1:
                        if (!b) return l.return({
                            mimeType: null,
                            data: null
                        });
                        d = fh;
                        e = Hm(b.T(), b.Tc(), b.Qc(), a.g.retryParameters);
                        f = b instanceof yj ? 1 : 0;
                        return F(l, Iz(a, e, d, {
                            type: f
                        }).promise, 2);
                    case 2:
                        g = l.h;
                        h = g.data;
                        if (!b.aesKey) {
                            l.B(3);
                            break;
                        }
                        return F(l, Gm(h, b.aesKey, c), 4);
                    case 4:
                        h = l.h;
                    case 3:
                        return b instanceof yj ? b.He(h, !0) : b.He(h), (k = g.headers["content-type"]) && (k = k.split(";")[0].toLowerCase()), l.return({
                            mimeType: k,
                            data: h
                        });
                }
            });
        }
        function fz(a) {
            if (az(a)) {
                if (a.Fa == Jz) {
                    for(var b = Infinity, c = Infinity, d = u(a.i.values()), e = d.next(); !e.done; e = d.next())e = e.value, e.stream.segmentIndex && e.stream.type != "text" && !e.stream.isAudioMuxedInVideo && (b = Math.min(b, e.Bc), c = Math.min(c, e.md));
                    b = b - c || 0;
                    isNaN(a.g.availabilityWindowOverride) || (b = a.g.availabilityWindowOverride);
                    a.l.hg(b);
                }
            } else a.l.zb(Kz(a));
            if (!a.l.u) for(b = u(a.i.values()), c = b.next(); !c.done; c = b.next())c = c.value, !c.stream.segmentIndex || c.type != "audio" && c.type != "video" || (c = eg(c.stream.segmentIndex)) && c.h && a.l.ei(c.h);
            a.l.Jf();
        }
        function sz(a, b) {
            var c = new qb(a.H).g;
            b = u(b);
            for(var d = b.next(); !d.done; d = b.next()){
                var e = d.value;
                d = Cy(e, "NAME");
                var f = Cy(e, "VALUE");
                e = Cy(e, "QUERYPARAM");
                d && f && (a.C.has(d) || a.C.set(d, f));
                e && (d = c.get(e)[0]) && !a.C.has(d) && a.C.set(e, d);
            }
        }
        function hz(a, b, c) {
            c = new qb(c).g;
            var d = new Map;
            b = u(b);
            for(var e = b.next(); !e.done; e = b.next()){
                var f = e.value, g = Cy(f, "NAME"), h = Cy(f, "VALUE");
                e = Cy(f, "QUERYPARAM");
                f = Cy(f, "IMPORT");
                g && h && (d.has(g) || d.set(g, h));
                e && (g = c.get(e)[0]) && !d.has(g) && d.set(e, g);
                f && (e = a.C.get(f)) && d.set(f, e);
            }
            return d;
        }
        function vz(a, b) {
            b = u(b);
            for(var c = b.next(); !c.done; c = b.next()){
                var d = c.value, e = Cy(d, "AUDIO");
                c = Cy(d, "VIDEO");
                var f = Cy(d, "SUBTITLES");
                d = Lz(a, d);
                if (f) {
                    var g = qc(sc, d);
                    a.K.set(f, g);
                    Qc(d, g);
                }
                e && (f = qc("audio", d), f || (f = a.g.hls.defaultAudioCodec), a.K.set(e, f));
                c && (e = qc("video", d), e || (e = a.g.hls.defaultVideoCodec), a.K.set(c, e));
            }
        }
        function tz(a, b) {
            b = u(b);
            for(var c = b.next(); !c.done; c = b.next()){
                var d = c.value, e = Cy(d, "DATA-ID");
                c = Cy(d, "URI");
                var f = Cy(d, "LANGUAGE");
                d = Cy(d, "VALUE");
                e = (new Map).set("id", e);
                c && e.set("uri", Ky([
                    a.H
                ], c, a.C)[0]);
                f && e.set("language", f);
                d && e.set("value", d);
                c = new T("sessiondata", e);
                if (a.h) a.h.onEvent(c);
            }
        }
        function uz(a, b) {
            var c, d, e, f, g, h;
            return Q(function(k) {
                if (!a.h || !a.g) return k.return();
                d = u(b);
                for(e = d.next(); !e.done; e = d.next())if (f = e.value, g = Cy(f, "PATHWAY-ID"), h = Cy(f, "SERVER-URI"), g && h) {
                    a.j = new Aw(a.h);
                    a.j.configure(a.g);
                    a.j.i = [
                        a.H
                    ];
                    a.j.setManifestType("HLS");
                    a.j.h = g;
                    c = Bw(a.j, h);
                    break;
                }
                return F(k, c, 0);
            });
        }
        function zz(a, b) {
            var c = Hy(b, "SUBTITLES");
            b = c.map(function(g) {
                if (a.g.disableText) return null;
                try {
                    return Mz(a, [
                        g
                    ], new Map).stream;
                } catch (h) {
                    if (a.g.hls.ignoreTextStreamFailures) return null;
                    throw h;
                }
            });
            c = u(c);
            for(var d = c.next(); !d.done; d = c.next()){
                var e = Dy(d.value, "GROUP-ID");
                if (d = a.K.get(e)) {
                    if (e = a.L.get(e)) {
                        e = u(e);
                        for(var f = e.next(); !f.done; f = e.next())f = f.value, f.stream.codecs = d, f.stream.mimeType = Nz(sc, d) || Oz(sc), Pz(f.stream);
                    }
                }
            }
            return b.filter(function(g) {
                return g;
            });
        }
        function Pz(a) {
            var b = new Set([
                df(a.mimeType, a.codecs)
            ]);
            a.segmentIndex && a.segmentIndex.Lb(function(c) {
                c.mimeType && b.add(df(c.mimeType, a.codecs));
            });
            a.fullMimeTypes = b;
        }
        function Az(a, b, c) {
            var d, e;
            return Q(function(f) {
                if (f.g == 1) return d = b.map(function(g) {
                    var h, k, l;
                    return Q(function(m) {
                        if (m.g == 1) {
                            if (h = a.g.disableThumbnails) return m.return(null);
                            ra(m, 2);
                            return F(m, Qz(a, g), 4);
                        }
                        if (m.g != 2) return k = m.h, m.return(k.stream);
                        l = ua(m);
                        if (a.g.hls.ignoreImageStreamFailures) return m.return(null);
                        throw l;
                    });
                }).concat(c.map(function(g) {
                    if (a.g.disableThumbnails) return null;
                    try {
                        var h = Rz(a, g);
                        return h.stream.type !== "image" ? null : h.stream;
                    } catch (k) {
                        if (a.g.hls.ignoreImageStreamFailures) return null;
                        throw k;
                    }
                })), F(f, Promise.all(d), 2);
                e = f.h;
                return f.return(e.filter(function(g) {
                    return g;
                }));
            });
        }
        function Sz(a, b, c) {
            b = b.filter(function(h) {
                var k = Cy(h, "URI") || "";
                h = Cy(h, "TYPE");
                return h != "SUBTITLES" && (k != "" || h == "AUDIO");
            });
            var d = {};
            b = u(b);
            for(var e = b.next(); !e.done; e = b.next()){
                e = e.value;
                var f = Ay(e, !a.j);
                d[f] ? d[f].push(e) : d[f] = [
                    e
                ];
            }
            for(var g in d)Mz(a, d[g], c, !1);
        }
        function xz(a, b) {
            return b.map(function(c) {
                c = Rz(a, c);
                return c.stream.type !== "video" ? null : c.stream;
            }).filter(function(c) {
                return c;
            });
        }
        function yz(a, b, c, d, e, f, g) {
            var h, k, l, m, n, q, r, t, w, v, z, y, A, C, E, D, B, G, I, J, L, K, N, P, O, M, R, W, wa, Y, Ka, Na, La, Ea, za, Fa;
            return Q(function(Da) {
                switch(Da.g){
                    case 1:
                        h = [];
                        k = new Set;
                        if (a.g.ignoreDrmInfo || !(c.length > 0)) {
                            Da.B(2);
                            break;
                        }
                        l = u(c);
                        m = l.next();
                    case 3:
                        if (m.done) {
                            Da.B(2);
                            break;
                        }
                        n = m.value;
                        q = Dy(n, "METHOD");
                        r = Cy(n, "KEYFORMAT") || "identity";
                        t = null;
                        if (q == "NONE") {
                            Da.B(4);
                            break;
                        }
                        if (Tz(q)) {
                            w = Ky(e(), Dy(n, "URI"), f);
                            v = w.sort().join("");
                            a.O.has(v) || (z = $g(w, a.g.retryParameters), y = Iz(a, z, 6).promise, a.O.set(v, y));
                            Da.B(4);
                            break;
                        }
                        if (r == "identity") return F(Da, Uz(a, n, "", e, null, f), 12);
                        A = a.Ec.get(r);
                        if (!A) {
                            C = null;
                            Da.B(10);
                            break;
                        }
                        return F(Da, A(n, "", null), 11);
                    case 11:
                        C = Da.h;
                    case 10:
                        t = C;
                        Da.B(6);
                        break;
                    case 12:
                        t = Da.h;
                    case 6:
                        if (t) {
                            if (t.keyIds) for(E = u(t.keyIds), D = E.next(); !D.done; D = E.next())B = D.value, k.add(B);
                            h.push(t);
                        }
                    case 4:
                        m = l.next();
                        Da.B(3);
                        break;
                    case 2:
                        G = {};
                        I = u(b);
                        for(J = I.next(); !J.done; J = I.next())L = J.value, K = Ay(L, !a.j), G[K] ? G[K].push(L) : G[K] = [
                            L
                        ];
                        N = [];
                        for(P in G)O = G[P], M = O[0], R = Cy(M, "FRAME-RATE"), W = Number(Cy(M, "AVERAGE-BANDWIDTH")) || Number(Dy(M, "BANDWIDTH")), wa = Cy(M, "RESOLUTION"), Y = u(wa ? wa.split("x") : [
                            null,
                            null
                        ]), Ka = Y.next().value, Na = Y.next().value, La = Cy(M, "VIDEO-RANGE"), (Ea = Cy(M, "REQ-VIDEO-LAYOUT")) && Ea.includes(",") && (za = Ea.split(",").filter(function(Aa) {
                            return Aa == "CH-STEREO" || Aa == "CH-MONO";
                        }), Ea = za[0]), Ea = Ea || "CH-MONO", Fa = Vz(a, O, d), N.push.apply(N, x(Wz(a, Fa.audio, Fa.video, W, Ka, Na, R, La, Ea, h, k, g)));
                        return Da.return(N.filter(function(Aa) {
                            return Aa != null;
                        }));
                }
            });
        }
        function Vz(a, b, c) {
            for(var d = {
                audio: [],
                video: []
            }, e = new Map, f = [], g = !1, h = !1, k = u(b), l = k.next(); !l.done; l = k.next()){
                var m = l.value;
                l = Cy(m, "AUDIO");
                var n = Cy(m, "VIDEO"), q = l || n;
                q && (f.includes(q) || f.push(q), (m = Cy(m, "PATHWAY-ID")) && e.set(q, m), l ? g = !0 : n && (h = !0));
            }
            f.length && c.length && (c = c.filter(function(t) {
                return f.includes(Dy(t, "GROUP-ID"));
            }), Sz(a, c, e));
            c = (e = f.sort().join(",")) && a.L.has(e) ? a.L.get(e) : [];
            g ? d.audio.push.apply(d.audio, x(c)) : h && d.video.push.apply(d.video, x(c));
            h = !1;
            var r = b.map(function(t) {
                return Dy(t, "URI");
            });
            g = d.audio.find(function(t) {
                return t && t.T().find(function(w) {
                    return r.includes(w);
                });
            });
            c = Lz(a, b[0]);
            k = qc("video", c);
            (l = qc("audio", c)) && !k ? (g = "audio", h = d.audio.length > 0 && !d.audio.some(function(t) {
                return t.stream.isAudioMuxedInVideo;
            })) : !d.audio.length && !d.video.length && l && k ? (g = "video", c = [
                [
                    k,
                    l
                ].join()
            ]) : d.audio.length && g ? (g = "audio", h = !0) : g = d.video.length && !d.audio.length ? "audio" : "video";
            h || (b = Xz(a, b, c, g), e && a.g.enableAudioGroups && (b.stream.groupId = e), b.stream.type == "audio" && g === "audio" && d.audio.some(function(t) {
                return t.stream.isAudioMuxedInVideo;
            }) && (a = d.audio[0].stream, b.stream.language = a.language, b.stream.channelsCount = a.channelsCount, b.stream.label = a.label, b.stream.audioSamplingRate = a.audioSamplingRate, b.stream.originalId = a.originalId, b.stream.originalLanguage = a.originalLanguage), d[b.stream.type] = [
                b
            ]);
            return d;
        }
        function Lz(a, b) {
            b = Cy(b, "CODECS") || "";
            a.Y = b.length > 0;
            a.Y || a.g.hls.disableCodecGuessing || (b = [], a.g.disableVideo || b.push(a.g.hls.defaultVideoCodec), a.g.disableAudio || b.push(a.g.hls.defaultAudioCodec), b = b.join(","));
            return Dm(b.split(/\s*,\s*/));
        }
        function kA(a) {
            return (a = Cy(a, "CHANNELS")) ? parseInt(a.split("/")[0], 10) : null;
        }
        function lA(a) {
            return (a = Cy(a, "SAMPLE-RATE")) ? parseInt(a, 10) : null;
        }
        function mA(a) {
            a = Cy(a, "CHANNELS");
            if (!a) return !1;
            a = a.split("/");
            return a.length != 2 ? !1 : a[1] === "JOC" || a[1].includes("ATMOS");
        }
        function nA(a) {
            a = Dy(a, "TYPE").toLowerCase();
            a == "subtitles" && (a = sc);
            return a;
        }
        function Wz(a, b, c, d, e, f, g, h, k, l, m, n) {
            for(var q = u(c), r = q.next(); !r.done; r = q.next())oA(r.value.stream, e, f, g, h, k, null);
            e = a.g.disableVideo;
            if (!c.length || e) c = [
                null
            ];
            e && (b = b.filter(function(z) {
                return !z.stream.isAudioMuxedInVideo;
            }));
            e = a.g.disableAudio;
            if (!b.length || e) b = [
                null
            ];
            e = [];
            b = u(b);
            for(f = b.next(); !f.done; f = b.next())for(f = f.value, g = u(c), h = g.next(); !h.done; h = g.next()){
                var t = h.value;
                if (h = f ? f.stream : null) h.drmInfos = l, h.keyIds = m;
                if (k = t ? t.stream : null) k.drmInfos = l, k.keyIds = m, a.g.disableIFrames || og(k, n);
                k && !h && (k.bandwidth = d);
                !k && h && (h.bandwidth = d);
                q = f ? f.stream.drmInfos : null;
                r = t ? t.stream.drmInfos : null;
                t = t ? t.T().sort().join(",") : "";
                var w = f ? f.T().sort().join(",") : "", v = [];
                h && h.codecs && v.push(h.codecs);
                k && k.codecs && v.push(k.codecs);
                t = [
                    t,
                    w,
                    v.sort()
                ].join("-");
                h && k && !wg(q, r) || a.jb.has(t) || (h = {
                    id: a.G++,
                    language: h ? h.language : "und",
                    disabledUntilTime: 0,
                    primary: !!h && h.primary || !!k && k.primary,
                    audio: h,
                    video: k,
                    bandwidth: d,
                    allowedByApplication: !0,
                    allowedByKeySystem: !0,
                    decodingInfos: []
                }, e.push(h), a.jb.add(t));
            }
            return e;
        }
        function wz(a, b) {
            b = Hy(b, "CLOSED-CAPTIONS");
            a.P = b.length == 0;
            b = u(b);
            for(var c = b.next(); !c.done; c = b.next()){
                var d = c.value, e = Cy(d, "LANGUAGE");
                c = yc(e || "und");
                e || (e = Cy(d, "NAME")) && (c = e);
                e = Dy(d, "GROUP-ID");
                d = Dy(d, "INSTREAM-ID").replace("SERVICE", "svc");
                a.J.get(e) || a.J.set(e, new Map);
                a.J.get(e).set(d, c);
            }
        }
        function Mz(a, b, c, d) {
            d = d === void 0 ? !0 : d;
            for(var e = [], f = [], g = new Map, h = u(b), k = h.next(), l = {}; !k.done; l = {
                dj: void 0
            }, k = h.next())k = k.value, l.dj = ++a.G, l = function(w) {
                return function() {
                    return "shaka://hls-muxed" + w.dj;
                };
            }(l), l = d ? Dy(k, "URI") : Cy(k, "URI") || l(), k = Dy(k, "GROUP-ID"), e.push(l), f.push(k), g.set(k, l);
            d = f.sort().join(",");
            k = b[0];
            b = "";
            h = nA(k);
            if (h == sc) b = Cy(k, "CODECS") || "";
            else for(f = u(f), l = f.next(); !l.done; l = f.next())if (l = l.value, a.K.has(l)) {
                b = a.K.get(l);
                break;
            }
            f = e.sort().join(",");
            if (a.i.has(f)) return a.i.get(f);
            l = a.G++;
            if (a.j) {
                g = u(g);
                for(var m = g.next(); !m.done; m = g.next()){
                    var n = u(m.value);
                    m = n.next().value;
                    n = n.next().value;
                    (m = c.get(m)) && Ew(a.j, l, m, n);
                }
            }
            c = Cy(k, "LANGUAGE");
            g = Cy(k, "NAME");
            m = Cy(k, "DEFAULT") == "YES";
            n = h == "audio" ? kA(k) : null;
            var q = h == "audio" ? mA(k) : !1, r = Cy(k, "CHARACTERISTICS"), t = Cy(k, "FORCED") == "YES";
            k = h == "audio" ? lA(k) : null;
            e = pA(a, l, e, b, h, c, m, g, n, null, r, t, k, q);
            e.stream && a.g.enableAudioGroups && (e.stream.groupId = d);
            a.L.has(d) ? a.L.get(d).push(e) : a.L.set(d, [
                e
            ]);
            a.i.set(f, e);
            return e;
        }
        function Qz(a, b) {
            var c, d, e, f, g, h, k, l, m, n;
            return Q(function(q) {
                if (q.g == 1) {
                    c = Dy(b, "URI");
                    d = Cy(b, "CODECS", "jpeg") || "";
                    if (a.i.has(c)) return q.return(a.i.get(c));
                    e = Cy(b, "LANGUAGE");
                    f = Cy(b, "NAME");
                    g = Cy(b, "CHARACTERISTICS");
                    h = pA(a, a.G++, [
                        c
                    ], d, "image", e, !1, f, null, null, g, !1, null, !1);
                    return (k = Cy(b, "RESOLUTION")) ? F(q, h.stream.createSegmentIndex(), 3) : q.B(2);
                }
                q.g != 2 && (l = eg(h.stream.segmentIndex), m = l.tilesLayout) && (h.stream.width = Number(k.split("x")[0]) * Number(m.split("x")[0]), h.stream.height = Number(k.split("x")[1]) * Number(m.split("x")[1]));
                if (n = Cy(b, "BANDWIDTH")) h.stream.bandwidth = Number(n);
                a.i.set(c, h);
                return q.return(h);
            });
        }
        function Rz(a, b) {
            var c = "video", d = Dy(b, "URI"), e = Cy(b, "CODECS") || "";
            e == "mjpg" && (c = "image");
            if (a.i.has(d)) return a.i.get(d);
            var f = Cy(b, "LANGUAGE"), g = Cy(b, "NAME"), h = Cy(b, "CHARACTERISTICS");
            c = pA(a, a.G++, [
                d
            ], e, c, f, !1, g, null, null, h, !1, null, !1);
            e = Cy(b, "RESOLUTION");
            f = u(e ? e.split("x") : [
                null,
                null
            ]);
            e = f.next().value;
            f = f.next().value;
            c.stream.width = Number(e) || void 0;
            c.stream.height = Number(f) || void 0;
            if (b = Cy(b, "BANDWIDTH")) c.stream.bandwidth = Number(b);
            a.i.set(d, c);
            return c;
        }
        function Xz(a, b, c, d) {
            for(var e = a.G++, f = [], g = u(b), h = g.next(); !h.done; h = g.next()){
                var k = h.value;
                h = Dy(k, "URI");
                k = Cy(k, "PATHWAY-ID");
                a.j && k && Ew(a.j, e, k, h);
                f.push(h);
            }
            g = f.sort().join(",") + c.sort().join(",");
            if (a.i.has(g)) return a.i.get(g);
            h = f.join(",");
            a: {
                b = Cy(b[0], "CLOSED-CAPTIONS");
                if (d == "video") {
                    if (a.g.disableText) {
                        a.P = !1;
                        b = null;
                        break a;
                    }
                    if (b) {
                        if (b != "NONE") {
                            b = a.J.get(b);
                            break a;
                        }
                        a.P = !1;
                    } else if (!b && a.J.size) for(b = u(a.J.keys()), b = b.next(); !b.done; b = b.next()){
                        b = a.J.get(b.value);
                        break a;
                    }
                }
                b = null;
            }
            c = pc(d, c);
            d = pA(a, e, f, c, d, null, !1, h, null, b, null, !1, null, !1);
            a.i.set(g, d);
            return d;
        }
        function pA(a, b, c, d, e, f, g, h, k, l, m, n, q, r) {
            function t(C) {
                var E, D, B, G, I, J, L, K, N, P, O, M, R, W, wa, Y, Ka, Na, La, Ea;
                return Q(function(za) {
                    switch(za.g){
                        case 1:
                            return E = uc, ra(za, 2), F(za, C.promise, 4);
                        case 4:
                            D = za.h;
                            if (C.aborted) return za.return();
                            B = D.uri;
                            B != D.originalUri && (G = z.T(), G.includes(B) || z.Zf.push(B));
                            I = Oy(a.Oa, D.data);
                            if (I.type != 1) throw new U(2, 4, 4017);
                            J = Gy(I.ma, "EXT-X-DEFINE");
                            L = hz(a, J, B);
                            K = !1;
                            (!a.Y && a.g.hls.disableCodecGuessing || a.P && e == E.Ia && !a.g.hls.disableClosedCaptionsDetection) && I.segments.length > 0 && (a.P = !1, K = !0);
                            N = !a.Y && a.g.hls.disableCodecGuessing;
                            P = az(a);
                            return F(za, rz(a, 0, L, I, w, d, e, f, g, h, k, l, m, n, q, r, void 0, K, N), 5);
                        case 5:
                            O = za.h;
                            if (C.aborted) return za.return();
                            M = O.stream;
                            Bz(a, I);
                            az(a) && !P && Cz(a, I);
                            z.md = O.md;
                            z.Bc = O.Bc;
                            z.mf = O.mf;
                            z.lf = O.lf;
                            z.pe = O.pe;
                            z.Kf = O.Kf;
                            z.Zb = O.Zb;
                            z.$b = O.$b;
                            v.segmentIndex = M.segmentIndex;
                            v.encrypted = M.encrypted;
                            v.drmInfos = M.drmInfos;
                            v.keyIds = M.keyIds;
                            v.mimeType = M.mimeType;
                            v.bandwidth = v.bandwidth || M.bandwidth;
                            v.codecs = v.codecs || M.codecs;
                            v.closedCaptions = v.closedCaptions || M.closedCaptions;
                            v.width = v.width || M.width;
                            v.height = v.height || M.height;
                            v.hdr = v.hdr || M.hdr;
                            v.colorGamut = v.colorGamut || M.colorGamut;
                            v.frameRate = v.frameRate || M.frameRate;
                            v.language == "und" && M.language != "und" && (v.language = M.language);
                            v.language = v.language || M.language;
                            v.channelsCount = v.channelsCount || M.channelsCount;
                            v.audioSamplingRate = v.audioSamplingRate || M.audioSamplingRate;
                            Pz(v);
                            v.drmInfos.length && a.h.newDrmInfo(v);
                            R = !1;
                            if (!l && v.closedCaptions || l && v.closedCaptions && l.size != v.closedCaptions.size) R = !0;
                            a.m && R && a.h.makeTextStreamsForClosedCaptions(a.m);
                            e == E.Va && (W = eg(M.segmentIndex)) && W.ia && (v.mimeType = "application/mp4", Pz(v));
                            wa = lm(v);
                            v.segmentIndex.Lb(function(Fa) {
                                Fa.ia && (Fa.ia.Od = wa);
                            });
                            qA(a) && (a.Ic ? Dz(a, [
                                z
                            ]) : (a.Ic = !0, Y = Array.from(a.i.values()), Ka = Y.filter(function(Fa) {
                                return Fa.stream.segmentIndex;
                            }), Dz(a, Ka), fz(a), Na = a.u, Na > 0 && a.F.$(Na)));
                            mz(a, I.ma, v.type, L, w);
                            a.m && (a.m.startTime = a.A);
                            ta(za, 0);
                            break;
                        case 2:
                            La = ua(za);
                            v.closeSegmentIndex();
                            if (La.code === 7001) return za.return();
                            Ea = a.h.disableStream(v);
                            if (!Ea) throw La;
                            H(za);
                    }
                });
            }
            function w() {
                return a.j && c.length > 1 ? Fw(a.j, b) : z.Zf.concat(Ly([
                    a.H
                ], c, a.C));
            }
            var v = rA(a, d, e, f, g, h, k, l, m, n, q, r);
            c.some(function(C) {
                return C.startsWith("shaka://hls-muxed");
            }) && (v.isAudioMuxedInVideo = !0, v.mimeType = "video/mp2t", Pz(v));
            var z = {
                stream: v,
                type: e,
                Zf: [],
                md: 0,
                Bc: 0,
                Kf: new Map,
                mf: !1,
                lf: !1,
                pe: !1,
                Vg: -1,
                Zb: -1,
                $b: -1,
                T: w
            }, y = null, A;
            v.createSegmentIndex = function() {
                if (y) return y;
                if (v.isAudioMuxedInVideo) return v.segmentIndex = new Xl([]), Promise.resolve();
                A = Zy(a, z.T(), !0);
                return y = new Promise(function(C) {
                    C(t(A));
                });
            };
            v.closeSegmentIndex = function() {
                y && !v.segmentIndex && A.abort();
                v.segmentIndex && (v.segmentIndex.release(), v.segmentIndex = null);
                y = null;
            };
            return z;
        }
        function Kz(a) {
            var b = Infinity;
            a = u(a.i.values());
            for(var c = a.next(); !c.done; c = a.next())c = c.value, c.stream.segmentIndex && c.stream.type != "text" && !c.stream.isAudioMuxedInVideo && (b = Math.min(b, c.Bc));
            return b;
        }
        function cz(a, b) {
            var c = [];
            b = u(b);
            for(var d = b.next(); !d.done; d = b.next())d = d.value, d.segmentIndex && d.segmentIndex.Lb(function(e) {
                c.push(e);
            });
            a.l.Be(c);
        }
        function Dz(a, b) {
            if (!az(a)) for(var c = Kz(a), d = u(b), e = d.next(); !e.done; e = d.next())e.value.stream.segmentIndex.Gd(0, c);
            cz(a, b.map(function(f) {
                return f.stream;
            }));
            d = Array.from(a.i.values()).filter(function(f) {
                return f.stream.segmentIndex;
            });
            c = d.some(function(f) {
                return f.stream.type == "audio";
            });
            e = d.some(function(f) {
                return f.stream.type == "video";
            });
            d = az(a) && !a.ib;
            c = !az(a) && a.ib && !(c && e);
            a.g.hls.ignoreManifestProgramDateTime || d || c ? nz(a, b, d) : (qz(a, b), a.g.hls.ignoreManifestProgramDateTimeForTypes.length > 0 && nz(a, b));
        }
        function oz(a, b) {
            return a.g.hls.ignoreManifestProgramDateTime ? !0 : a.g.hls.ignoreManifestProgramDateTimeForTypes.includes(b);
        }
        function qA(a) {
            if (!a.m) return !1;
            var b = [], c = [];
            a = u(a.m.variants);
            for(var d = a.next(); !d.done; d = a.next())d = d.value, d.video && b.push(d.video), d.audio && c.push(d.audio);
            return b.length > 0 && !b.some(function(e) {
                return e.segmentIndex;
            }) || c.length > 0 && !c.some(function(e) {
                return e.segmentIndex;
            }) ? !1 : !0;
        }
        function rz(a, b, c, d, e, f, g, h, k, l, m, n, q, r, t, w, v, z, y) {
            z = z === void 0 ? !0 : z;
            y = y === void 0 ? !0 : y;
            var A, C, E, D, B, G, I, J, L, K, N, P, O, M, R, W, wa, Y, Ka, Na, La, Ea, za, Fa, Da, Aa, Ca, gb, ib;
            return Q(function(jb) {
                switch(jb.g){
                    case 1:
                        A = d.segments || [];
                        C = A.every(function(Ab) {
                            return Iy(Ab.ma, "EXT-X-GAP") ? !0 : !1;
                        });
                        if (!A.length || C) throw new U(2, 4, 4053);
                        sA(a, d);
                        az(a) && lz(a, d);
                        E = az(a) ? a.D.get(g) : new Map;
                        D = jz(a, d, E, c, e, g);
                        B = D.segments;
                        G = D.bandwidth;
                        N = K = L = J = I = null;
                        if (!(B.length > 0 && z)) {
                            jb.B(2);
                            break;
                        }
                        return F(jb, Ez(a, B), 3);
                    case 3:
                        P = jb.h, g != P.type && az(a) && (a.D.set(P.type, a.D.get(g)), a.D.set(g, new Map)), g = P.type, h = P.language, m = P.channelCount, t = P.sampleRate, a.g.disableText || (n = P.closedCaptions), J = P.height, I = P.width, L = P.Ne, K = P.colorGamut, N = P.frameRate, y && (v = P.mimeType, f = P.codecs);
                    case 2:
                        if (v) {
                            jb.B(4);
                            break;
                        }
                        return F(jb, tA(a, g, f, B), 5);
                    case 5:
                        v = jb.h, g != sc || f || v != "application/mp4" || !B[0] || B[0].ia || (v = "text/vtt");
                    case 4:
                        return F(jb, iz(a, d, v, e, c), 6);
                    case 6:
                        O = jb.h;
                        M = O.drmInfos;
                        R = O.keyIds;
                        W = O.encrypted;
                        wa = O.Fi;
                        if (W && !M.length && !wa) throw new U(2, 4, 4026);
                        Y = rA(a, f, g, h, k, l, m, n, q, r, t, w);
                        Y.encrypted = W && !wa;
                        Y.drmInfos = M;
                        Y.keyIds = R;
                        Y.mimeType = v;
                        G && (Y.bandwidth = G);
                        Pz(Y);
                        g == "video" && (I || J || L || K) && oA(Y, I, J, N, L, null, K);
                        az(a) && lz(a, d);
                        Ka = B[0].startTime;
                        Na = B[B.length - 1];
                        La = Na.endTime;
                        Ea = new Xl(B);
                        Y.segmentIndex = Ea;
                        Fa = (za = Iy(d.ma, "EXT-X-SERVER-CONTROL")) ? By(za, "CAN-SKIP-UNTIL") != null : !1;
                        Da = za ? By(za, "CAN-BLOCK-RELOAD") != null : !1;
                        Aa = Jy(d.ma, "EXT-X-MEDIA-SEQUENCE", 0);
                        Ca = kz(Aa, B);
                        gb = Ca.Zb;
                        ib = Ca.$b;
                        return jb.return({
                            stream: Y,
                            type: g,
                            Zf: [],
                            T: e,
                            md: Ka,
                            Bc: La,
                            mf: Fa,
                            lf: Da,
                            pe: !1,
                            Vg: -1,
                            Zb: gb,
                            $b: ib,
                            Kf: E
                        });
                }
            });
        }
        function kz(a, b) {
            a = a + b.length - 1;
            var c = -1;
            if (!b.length) return a++, {
                Zb: a,
                $b: c
            };
            b = b[b.length - 1];
            var d = b.g;
            if (!b.g.length) return a++, b.m && (c = 0), {
                Zb: a,
                $b: c
            };
            c = d.length - 1;
            d[d.length - 1].isPreload() || (a++, c = 0);
            return {
                Zb: a,
                $b: c
            };
        }
        function rA(a, b, c, d, e, f, g, h, k, l, m, n) {
            var q = Nz(c, b) || Oz(c), r = [];
            if (k) {
                k = u(k.split(","));
                for(var t = k.next(); !t.done; t = k.next())r.push(t.value);
            }
            k = void 0;
            t = null;
            c == sc ? k = r.includes("public.accessibility.transcribes-spoken-dialog") && r.includes("public.accessibility.describes-music-and-sound") ? "caption" : "subtitle" : r.includes("public.accessibility.describes-video") && (t = "visually impaired");
            r.length || k !== "subtitle" || r.push("subtitle");
            a = {
                id: a.G++,
                originalId: f,
                groupId: null,
                createSegmentIndex: function() {
                    return Promise.resolve();
                },
                segmentIndex: null,
                mimeType: q,
                codecs: b,
                kind: c == sc ? "subtitle" : void 0,
                encrypted: !1,
                drmInfos: [],
                keyIds: new Set,
                language: yc(d || "und"),
                originalLanguage: d,
                label: f,
                type: c,
                primary: e,
                trickModeVideo: null,
                dependencyStream: null,
                emsgSchemeIdUris: null,
                frameRate: void 0,
                pixelAspectRatio: void 0,
                width: void 0,
                height: void 0,
                bandwidth: void 0,
                roles: r,
                forced: l,
                channelsCount: g,
                audioSamplingRate: m,
                spatialAudio: n,
                closedCaptions: h,
                hdr: void 0,
                colorGamut: void 0,
                videoLayout: void 0,
                tilesLayout: void 0,
                accessibilityPurpose: t,
                external: !1,
                fastSwitching: !1,
                fullMimeTypes: new Set,
                isAudioMuxedInVideo: !1,
                baseOriginalId: null
            };
            Pz(a);
            return a;
        }
        function iz(a, b, c, d, e) {
            var f, g, h, k, l, m, n, q, r, t, w, v, z, y, A, C, E, D, B, G, I, J, L, K, N, P, O, M, R;
            return Q(function(W) {
                switch(W.g){
                    case 1:
                        f = new Map;
                        if (!a.g.ignoreDrmInfo && b.segments) {
                            for(g = u(b.segments), h = g.next(); !h.done; h = g.next())if (k = h.value, l = Gy(k.ma, "EXT-X-KEY"), m = null, l.length) for(m = uA(a, b, k.ma, d, e), n = u(l), q = n.next(); !q.done; q = n.next())r = q.value, f.set(r, m);
                        }
                        w = t = !1;
                        v = [];
                        z = new Set;
                        y = u(f);
                        A = y.next();
                    case 2:
                        if (A.done) {
                            W.B(4);
                            break;
                        }
                        C = A.value;
                        E = u(C);
                        D = E.next().value;
                        B = E.next().value;
                        G = D;
                        I = B;
                        J = Dy(G, "METHOD");
                        if (J == "NONE") {
                            W.B(3);
                            break;
                        }
                        t = !0;
                        L = Cy(G, "KEYFORMAT") || "identity";
                        K = null;
                        if (Tz(J)) {
                            w = !0;
                            W.B(3);
                            break;
                        }
                        if (L == "identity") return F(W, Uz(a, G, c, d, I, e), 11);
                        N = a.Ec.get(L);
                        if (!N) {
                            P = null;
                            W.B(9);
                            break;
                        }
                        return F(W, N(G, c, I), 10);
                    case 10:
                        P = W.h;
                    case 9:
                        K = P;
                        W.B(6);
                        break;
                    case 11:
                        K = W.h;
                    case 6:
                        if (K) {
                            if (K.keyIds) for(O = u(K.keyIds), M = O.next(); !M.done; M = O.next())R = M.value, z.add(R);
                            v.push(K);
                        }
                    case 3:
                        A = y.next();
                        W.B(2);
                        break;
                    case 4:
                        return W.return({
                            drmInfos: v,
                            keyIds: z,
                            encrypted: t,
                            Fi: w
                        });
                }
            });
        }
        function vA(a, b, c, d, e) {
            if (!window1.crypto || !window1.crypto.subtle) throw ab("Web Crypto API is not available to decrypt AES. (Web Crypto only exists in secure origins like https)"), new U(2, 4, 4042);
            var f = 0, g = Cy(b, "IV", "");
            if (g) {
                var h = ic(g.substr(2));
                if (h.byteLength != 16) throw new U(2, 4, 4048);
            } else f = Jy(c.ma, "EXT-X-MEDIA-SEQUENCE", 0);
            var k = Ky(d(), Dy(b, "URI"), e), l = k.sort().join("");
            c = b.toString() + "-" + f + "-" + l;
            if (!a.oa.has(c)) {
                var m = {
                    bitsKey: 128,
                    blockCipherMode: "CBC",
                    iv: h,
                    firstMediaSequenceNumber: f
                };
                switch(Dy(b, "METHOD")){
                    case "AES-256":
                        m.bitsKey = 256;
                        break;
                    case "AES-256-CTR":
                        m.bitsKey = 256, m.blockCipherMode = "CTR";
                }
                m.fetchKey = function() {
                    var n, q, r, t;
                    return Q(function(w) {
                        if (w.g == 1) return a.O.has(l) || (n = $g(k, a.g.retryParameters), q = Iz(a, n, 6).promise, a.O.set(l, q)), F(w, a.O.get(l), 2);
                        if (w.g != 3) {
                            r = w.h;
                            if (!r.data || r.data.byteLength != m.bitsKey / 8) throw new U(2, 4, 4049);
                            t = {
                                name: m.blockCipherMode == "CTR" ? "AES-CTR" : "AES-CBC",
                                length: m.bitsKey
                            };
                            return F(w, window1.crypto.subtle.importKey("raw", r.data, t, !0, [
                                "decrypt"
                            ]), 3);
                        }
                        m.cryptoKey = w.h;
                        m.fetchKey = void 0;
                        H(w);
                    });
                };
                a.oa.set(c, m);
            }
            return a.oa.get(c);
        }
        function Bz(a, b) {
            a.A == null && (b = Iy(b.ma, "EXT-X-START")) && (a.A = Number(Dy(b, "TIME-OFFSET")));
        }
        function sA(a, b) {
            var c = Iy(b.ma, "EXT-X-PLAYLIST-TYPE");
            b = Iy(b.ma, "EXT-X-ENDLIST");
            b = c && c.value == "VOD" || b;
            c = c && c.value == "EVENT" && !b;
            c = !b && !c;
            b ? ez(a, Yy) : c ? ez(a, Jz) : ez(a, wA);
        }
        function lz(a, b) {
            var c = Infinity, d = b.segments;
            if (d.length) for(var e = d.length - 1; e >= 0;){
                var f = Iy(d[e].ma, "EXTINF");
                if (f) {
                    c = Number(f.value.split(",")[0]);
                    break;
                }
                e--;
            }
            d = Iy(b.ma, "EXT-X-TARGETDURATION");
            if (!d) throw new U(2, 4, 4024, "EXT-X-TARGETDURATION");
            d = Number(d.value);
            if (e = Iy(b.ma, "EXT-X-PART-INF")) a.R = Number(Dy(e, "PART-TARGET"));
            b = Iy(b.ma, "EXT-X-SERVER-CONTROL");
            a.ea && a.R ? (a.u = a.Hc ? a.R * 5 <= c ? Math.min(a.R, a.u) : Math.min(c, a.u) : Math.min(a.R, a.u), a.hb = b ? Number(Dy(b, "PART-HOLD-BACK")) : 0) : (a.u = Math.min(c, a.u), c = b ? By(b, "HOLD-BACK") : null, a.Ma = c ? Number(c.value) : 0);
            a.fb = Math.max(d, a.fb);
        }
        function Cz(a, b) {
            var c = 0;
            if (a.g.defaultPresentationDelay) c = a.g.defaultPresentationDelay;
            else if (a.hb) c = a.hb;
            else if (a.Ma) c = a.Ma;
            else for(var d = b.segments.length, e = d - Math.min(d, a.g.hls.liveSegmentsDelay); e < d; e++){
                var f = Iy(b.segments[e].ma, "EXTINF");
                c = f ? c + Number(f.value.split(",")[0]) : c + a.fb;
            }
            a.A && a.A < 0 && (c = Math.min(-a.A, c), a.A += c);
            a.l.Nj(0);
            a.l.ci(c);
            a.l.sd(!1);
        }
        function uA(a, b, c, d, e) {
            var f = Iy(c, "EXT-X-MAP");
            if (!f) return null;
            var g = Dy(f, "URI"), h = Ky(d(), g, e);
            g = [
                h.toString(),
                Cy(f, "BYTERANGE", "")
            ].join("-");
            if (!a.xa.has(g)) {
                var k = void 0, l = null, m = !1;
                c = u(c);
                for(var n = c.next(); !n.done; n = c.next())n = n.value, n.name == "EXT-X-KEY" ? (m = Dy(n, "METHOD"), Tz(m) && n.id < f.id ? (m = !1, k = vA(a, n, b, d, e)) : m = m != "NONE") : n.name == "EXT-X-BYTERANGE" && n.id < f.id && (l = n);
                b = xA(h, f, l, k, m);
                a.xa.set(g, b);
            }
            return a.xa.get(g);
        }
        function xA(a, b, c, d, e) {
            var f = 0, g = null;
            b = Cy(b, "BYTERANGE");
            !b && c && (b = c.value);
            b && (f = b.split("@"), g = Number(f[0]), f = Number(f[1]), g = f + g - 1, d && (c = g + 1 - f, c % 16 && (g += 16 - c % 16)));
            return new wj(function() {
                return a;
            }, f, g, null, null, null, d, e);
        }
        function yA(a, b, c, d, e, f, g, h, k) {
            function l(W) {
                W = new qb(W).qb.split(".").pop();
                var wa = zA.get(g).get(W);
                wa || (wa = Gz.get(W));
                return wa;
            }
            var m = d.ma, n = Iy(m, "EXTINF"), q = 0, r = 0, t = null;
            d.Fc.length && (a.m.isLowLatency = !0);
            var w = null;
            if (!a.g.hls.ignoreManifestProgramDateTime) {
                var v = Iy(m, "EXT-X-PROGRAM-DATE-TIME");
                v && v.value && (w = be(v.value), a.ib = !0);
            }
            var z = zj;
            Iy(m, "EXT-X-GAP") && (a.m.gapCount++, z = 2);
            if (!n) {
                if (d.Fc.length == 0) throw new U(2, 4, 4024, "EXTINF");
                if (!a.ea) return null;
            }
            var y = [];
            v = !1;
            var A = null, C = !1, E = !1;
            if (a.ea && d.Fc.length) {
                q = b && window1.ReadableStream && a.g.hls.allowLowLatencyByteRangeOptimization;
                for(var D = w, B = {}, G = 0; G < d.Fc.length; B = {
                    ug: void 0,
                    Tf: void 0
                }, G++){
                    var I = d.Fc[G], J = G == 0 ? c : y[y.length - 1], L = G == 0 ? e : J.endTime, K = Number(Cy(I, "DURATION")) || a.R;
                    if (K) {
                        var N = L + K, P = 0, O = null;
                        I.name == "EXT-X-PRELOAD-HINT" ? (P = (P = Cy(I, "BYTERANGE-START")) ? Number(P) : 0, (J = Cy(I, "BYTERANGE-LENGTH")) ? O = P + Number(J) - 1 : P && (O = Number.MAX_SAFE_INTEGER)) : (P = Cy(I, "BYTERANGE"), O = u(AA(J, P)), P = O.next().value, O = O.next().value);
                        B.Tf = Cy(I, "URI");
                        if (B.Tf) {
                            J = zj;
                            Cy(I, "GAP") == "YES" && (a.m.gapCount++, J = 2, C = !0);
                            B.ug = null;
                            var M = function(W) {
                                return function() {
                                    W.ug == null && (W.ug = Ky(h(), W.Tf, f));
                                    return W.ug;
                                };
                            }(B);
                            q && P >= 0 && O != null && (A = M, v = !0);
                            L = new yj(L, N, M, P, O, b, 0, 0, Infinity, [], "", null, D, J, k);
                            I.name == "EXT-X-PRELOAD-HINT" && (L.Jh(), E = !0);
                            Cy(I, "INDEPENDENT") != "YES" && G > 0 && L.Nd();
                            if (B = l(B.Tf)) L.mimeType = B, BA.has(B) && (L.ia = null);
                            y.push(L);
                            D && (D += K);
                        }
                    }
                }
            }
            if (n) {
                n = Number(n.value.split(",")[0]);
                if (n == 0) return null;
                q = e + n;
            } else if (y.length) q = y[y.length - 1].endTime;
            else return null;
            v && (C || y[0].startByte != 0 ? (v = !1, A = null) : y = []);
            (n = Iy(m, "EXT-X-BYTERANGE")) ? (t = u(AA(c, n.value)), r = t.next().value, t = t.next().value) : y.length && (r = y[0].startByte, t = y[y.length - 1].endByte);
            c = "";
            n = null;
            g == "image" && (c = "1x1", m = Iy(m, "EXT-X-TILES")) && (c = Dy(m, "LAYOUT"), (m = Cy(m, "DURATION")) && (n = Number(m)));
            var R = null;
            b = new yj(e, q, function() {
                if (A) return A();
                R == null && (R = Ky(h(), d.g, f));
                return R || [];
            }, r, t, b, 0, 0, Infinity, y, c, n, w, z, k, y.length > 0 && !!d.g);
            if (e = l(d.g)) b.mimeType = e, BA.has(e) && (b.ia = null);
            v && (a.Hc = !0, b.kj(), E && b.Jh());
            return b;
        }
        function AA(a, b) {
            var c = 0, d = null;
            b && (c = b.split("@"), b = Number(c[0]), c = c[1] ? Number(c[1]) : a.endByte + 1, d = c + b - 1);
            return [
                c,
                d
            ];
        }
        function mz(a, b, c, d, e) {
            if (c == "video" || c == "audio") {
                var f = a.l.m;
                if (f && !oz(a, c)) for(b = Gy(b, "EXT-X-DATERANGE"), b = b.filter(function(J) {
                    return By(J, "START-DATE") != null;
                }).sort(function(J, L) {
                    J = Dy(J, "START-DATE");
                    L = Dy(L, "START-DATE");
                    return J < L ? -1 : J > L ? 1 : 0;
                }), c = 0; c < b.length; c++){
                    var g = b[c];
                    try {
                        var h = Dy(g, "START-DATE"), k = be(h);
                        if (!isNaN(k)) {
                            var l = Math.max(0, k - f), m = null, n = Cy(g, "END-DATE");
                            if (n) {
                                var q = be(n);
                                if (!isNaN(q) && (m = q - f, m < 0)) continue;
                            }
                            if (m == null) {
                                var r = Cy(g, "DURATION") || Cy(g, "PLANNED-DURATION");
                                if (r) {
                                    var t = parseFloat(r);
                                    isNaN(t) || (m = l + t);
                                    if (k - f + t < 0) continue;
                                }
                            }
                            var w = Cy(g, "CLASS") || "com.apple.quicktime.HLS", v = Cy(g, "END-ON-NEXT") == "YES";
                            if (m == null && v) {
                                for(var z = c + 1; z < b.length; z++){
                                    var y = Cy(b[z], "CLASS") || "com.apple.quicktime.HLS";
                                    if (w == y) {
                                        var A = Dy(b[z], "START-DATE"), C = be(A);
                                        if (!isNaN(C) && C && C > k) {
                                            m = Math.max(0, C - f);
                                            break;
                                        }
                                    }
                                }
                                if (m == null) continue;
                            }
                            z = [
                                "CLASS",
                                "START-DATE",
                                "END-DATE",
                                "DURATION",
                                "END-ON-NEXT"
                            ];
                            for(var E = [], D = u(g.attributes), B = D.next(); !B.done; B = D.next()){
                                var G = B.value;
                                if (!z.includes(G.name)) {
                                    var I = My(G.value, d);
                                    if (G.name == "X-ASSET-URI" || G.name == "X-ASSET-LIST") I = Ky(e(), G.value, d)[0];
                                    E.push({
                                        key: G.name,
                                        description: "",
                                        data: I,
                                        mimeType: null,
                                        pictureType: null
                                    });
                                }
                            }
                            if (E.length > 1) a.h.onMetadata(w, l, m, E);
                        }
                    } catch (J) {}
                }
            }
        }
        function jz(a, b, c, d, e, f) {
            var g = b.segments, h = void 0, k = Jy(b.ma, "EXT-X-DISCONTINUITY-SEQUENCE", -1), l = Jy(b.ma, "EXT-X-MEDIA-SEQUENCE", 0), m = Iy(b.ma, "EXT-X-SKIP"), n = m ? Number(Cy(m, "SKIPPED-SEGMENTS")) : 0, q = l + n, r = 0;
            az(a) && c.has(q) && (r = c.get(q));
            r === 0 && a.Fa == Jz && c.size > 0 && !c.has(q) && a.l.i != null && (r = a.l.Nb());
            var t = [], w = null;
            m = [];
            for(var v = 0; v < g.length; v++){
                var z = g[v], y = v == 0 ? r : w.endTime;
                q = l + n + v;
                Iy(z.ma, "EXT-X-DISCONTINUITY") && (k++, w && w.ia && (w.ia.g = y));
                var A = u(z.ma);
                for(var C = A.next(); !C.done; C = A.next())C = C.value, C.name == "EXT-X-KEY" && (Tz(Dy(C, "METHOD")) ? h = vA(a, C, b, e, d) : h = void 0);
                c.set(q, y);
                A = uA(a, b, z.ma, e, d);
                if (y = yA(a, A, w, z, y, d, f, e, h)) (w = Jy(z.ma, "EXT-X-BITRATE")) ? m.push({
                    bitrate: w,
                    duration: y.endTime - y.startTime
                }) : m.length && (w = m.pop(), w.duration += y.endTime - y.startTime, m.push(w)), w = y, y.i = k, oz(a, f) && a.M != null && q < a.M || t.push(y);
            }
            b = void 0;
            m.length && (b = m.reduce(function(E, D) {
                return E + D.duration;
            }, 0), b = Math.round(m.reduce(function(E, D) {
                return E + D.bitrate * D.duration;
            }, 0) / b * 1E3));
            if (m = t.some(function(E) {
                return E.h != null;
            })) {
                for(c = {}, d = 0; d < t.length; c = {
                    rf: void 0,
                    qf: void 0,
                    hf: void 0,
                    pd: void 0,
                    gf: void 0
                }, d++)if (c.pd = t[d], c.pd.h == null) for(c.qf = 0, c.rf = d, e = function(E) {
                    return function() {
                        var D = t[E.rf];
                        if (D) {
                            if (D.h != null) return D.h + E.qf;
                            E.qf -= D.endTime - D.startTime;
                            E.rf += 1;
                        }
                        return null;
                    };
                }(c), c.gf = 0, c.hf = d, g = function(E) {
                    return function() {
                        var D = t[E.hf];
                        if (D) {
                            D != E.pd && (E.gf += D.endTime - D.startTime);
                            if (D.h != null) return D.h + E.gf;
                            --E.hf;
                        }
                        return null;
                    };
                }(c); c.pd.h == null;)c.pd.h = g(), c.pd.h == null && (c.pd.h = e());
            }
            if (m) for(c = u(t), d = c.next(); !d.done; d = c.next())for(e = d.value, d = e.h, e = u(e.g), g = e.next(); !g.done; g = e.next())g = g.value, g.h = d, d += g.endTime - g.startTime;
            c = a.aa;
            if (m && c != Infinity && !oz(a, f)) for(a = u(t), f = a.next(); !f.done; f = a.next())f.value.pi(c);
            return {
                segments: t,
                bandwidth: b
            };
        }
        function Nz(a, b) {
            if (a == sc) {
                if (b == "vtt" || b == "wvtt") return "text/vtt";
                if (b && b !== "") return "application/mp4";
            }
            return a != "image" || b && b != "jpeg" ? a == "audio" && b == "mp4a.40.34" ? "audio/mpeg" : b == "mjpg" ? "application/mp4" : null : "image/jpeg";
        }
        function Oz(a) {
            return a == sc ? "text/vtt" : zA.get(a).get("mp4");
        }
        function Fz(a, b) {
            a = az(a) ? Math.trunc((b.length - 1) / 2) : 0;
            for(var c = b[a]; c.Uc() == 2 && a + 1 < b.length;)a++, c = b[a];
            return {
                segment: c,
                segmentIndex: a
            };
        }
        function tA(a, b, c, d) {
            var e, f, g, h, k, l, m, n, q, r, t, w, v;
            return Q(function(z) {
                switch(z.g){
                    case 1:
                        e = fh;
                        f = Fz(a, d);
                        g = f.segment;
                        if (g.status == 2) return z.return(Oz(b));
                        h = g.T();
                        k = new qb(h[0]);
                        l = k.qb.split(".").pop();
                        m = zA.get(b);
                        if ((n = m.get(l)) || (n = Gz.get(l)) || (n = Nz(b, c))) return z.return(n);
                        r = 1;
                        t = $g(h, a.g.retryParameters);
                        ra(z, 2);
                        t.method = "HEAD";
                        return F(z, Iz(a, t, e, {
                            type: r
                        }).promise, 4);
                    case 4:
                        w = z.h;
                        q = w.headers["content-type"];
                        ta(z, 3);
                        break;
                    case 2:
                        v = ua(z);
                        if (!v || v.code != 1002 && v.code != 1001) {
                            z.B(3);
                            break;
                        }
                        t.method = "GET";
                        a.g.hls.allowRangeRequestsToGuessMimeType && (t.headers.Range = "bytes=0-0");
                        return F(z, Iz(a, t, e, {
                            type: r
                        }).promise, 6);
                    case 6:
                        w = z.h, q = w.headers["content-type"];
                    case 3:
                        if (!q) {
                            z.B(7);
                            break;
                        }
                        n = q.toLowerCase().split(";")[0];
                        if (n != "application/octet-stream") {
                            z.B(8);
                            break;
                        }
                        if (w.data.byteLength) {
                            z.B(9);
                            break;
                        }
                        t.method = "GET";
                        return F(z, Iz(a, t, e, {
                            type: r
                        }).promise, 10);
                    case 10:
                        w = z.h;
                    case 9:
                        vk(Kb(w.data)) && (n = "video/mp2t");
                    case 8:
                        if (n != "application/octet-stream") return z.return(n);
                    case 7:
                        return z.return(Oz(b));
                }
            });
        }
        function oA(a, b, c, d, e, f, g) {
            a && (a.width = Number(b) || void 0, a.height = Number(c) || void 0, a.frameRate = Number(d) || void 0, a.hdr = e || void 0, a.videoLayout = f || void 0, a.colorGamut = g || void 0);
        }
        function Zy(a, b, c) {
            return Iz(a, $g(b, a.g.retryParameters), 0, {
                type: c ? 2 : 3
            });
        }
        function Xy(a) {
            var b, c, d, e, f, g;
            return Q(function(h) {
                switch(h.g){
                    case 1:
                        if (!a.h) return h.return();
                        ra(h, 2);
                        b = Date.now();
                        return F(h, a.update(), 4);
                    case 4:
                        c = Date.now();
                        az(a) && (d = (c - b) / 1E3, a.Pb.sample(1, d), e = a.g.updatePeriod > 0 ? a.g.updatePeriod : a.u, f = Math.max(0, e - Mc(a.Pb)), a.F.$(f));
                        ta(h, 3);
                        break;
                    case 2:
                        g = ua(h);
                        if (!a.h) return h.return();
                        if (a.g.raiseFatalErrorOnManifestUpdateRequestFailure) return a.h.onError(g), h.return();
                        g.severity = 1;
                        a.h.onError(g);
                        a.F.$(.1);
                    case 3:
                        if (!a.h) return h.return();
                        a.h.onManifestUpdated();
                        H(h);
                }
            });
        }
        function az(a) {
            return a.Fa != Yy;
        }
        function ez(a, b) {
            a.Fa = b;
            a.l && a.l.sd(!az(a));
            az(a) || a.F.stop();
        }
        function Iz(a, b, c, d) {
            if (!a.X) throw new U(2, 7, 7001);
            d || (d = {});
            d.isPreload = a.kc();
            b = a.h.networkingEngine.request(c, b, d);
            Ug(a.X, b);
            return b;
        }
        function Tz(a) {
            return a == "AES-128" || a == "AES-256" || a == "AES-256-CTR";
        }
        function Wy(a, b, c, d) {
            var e, f, g, h, k, l;
            return Q(function(m) {
                if (m.g == 1) {
                    if (c == "video/mp2t") throw new U(2, 4, 4040);
                    if ("apple" === window1.shakaMediaKeysPolyfill) throw new U(2, 4, 4041);
                    e = Dy(b, "METHOD");
                    f = [
                        "SAMPLE-AES",
                        "SAMPLE-AES-CTR"
                    ];
                    if (!f.includes(e)) return m.return(null);
                    g = "cenc";
                    e == "SAMPLE-AES" && (g = "cbcs");
                    h = Dy(b, "URI");
                    k = nc("com.apple.fps", g, [
                        {
                            initDataType: "sinf",
                            initData: new Uint8Array(0),
                            keyId: null
                        }
                    ], h);
                    var n = new qb(h).Jb.replace(/-/g, "").toLowerCase();
                    return (l = n.length === 32 && /^[0-9a-f]+$/.test(n) ? n : null) || !d ? m.B(2) : F(m, CA(a, d), 3);
                }
                m.g != 2 && (l = m.h);
                l && k.keyIds.add(l);
                return m.return(k);
            });
        }
        function Uz(a, b, c, d, e, f) {
            var g, h, k, l, m, n, q, r, t, w, v, z;
            return Q(function(y) {
                switch(y.g){
                    case 1:
                        if (c == "video/mp2t") throw new U(2, 4, 4040);
                        if ("apple" === window1.shakaMediaKeysPolyfill) throw new U(2, 4, 4041);
                        g = Dy(b, "METHOD");
                        h = [
                            "SAMPLE-AES",
                            "SAMPLE-AES-CTR"
                        ];
                        if (!h.includes(g)) return y.return(null);
                        k = Ky(d(), Dy(b, "URI"), f);
                        if (k[0].startsWith("data:text/plain;base64,")) {
                            l = jc(hc(k[0].split("data:text/plain;base64,").pop()));
                            y.B(2);
                            break;
                        }
                        m = k.sort().join("");
                        a.ra.has(m) || (n = $g(k, a.g.retryParameters), q = Iz(a, n, 6).promise, a.ra.set(m, q));
                        return F(y, a.ra.get(m), 3);
                    case 3:
                        r = y.h, l = jc(r.data);
                    case 2:
                        t = "00000000000000000000000000000000";
                        if (!e) {
                            y.B(4);
                            break;
                        }
                        return F(y, CA(a, e), 5);
                    case 5:
                        (w = y.h) && (t = w);
                    case 4:
                        return v = new Map, v.set(t, l), z = "cenc", g == "SAMPLE-AES" && (z = "cbcs"), y.return(oc(v, z));
                }
            });
        }
        function CA(a, b) {
            var c, d, e, f;
            return Q(function(g) {
                if (g.g == 1) {
                    c = null;
                    if (a.sa.has(b)) return c = a.sa.get(b), g.B(2);
                    d = Hm(b.T(), b.Tc(), b.Qc(), a.g.retryParameters);
                    e = fh;
                    return F(g, Iz(a, d, e, {
                        type: 0
                    }).promise, 3);
                }
                g.g != 2 && (f = g.h, b.He(f.data), c = Fm(f.data), a.sa.set(b, c));
                return g.return(c);
            });
        }
        S("shaka.hls.HlsParser", Vy);
        var Gz = (new Map).set("aac", "audio/aac").set("ac3", "audio/ac3").set("ec3", "audio/ec3").set("mp3", "audio/mpeg"), DA = (new Map).set("mp4", "audio/mp4").set("mp4a", "audio/mp4").set("m4s", "audio/mp4").set("m4i", "audio/mp4").set("m4a", "audio/mp4").set("m4f", "audio/mp4").set("cmfa", "audio/mp4").set("ts", "video/mp2t").set("tsa", "video/mp2t"), EA = (new Map).set("mp4", "video/mp4").set("mp4v", "video/mp4").set("m4s", "video/mp4").set("m4i", "video/mp4").set("m4v", "video/mp4").set("m4f", "video/mp4").set("cmfv", "video/mp4").set("ts", "video/mp2t").set("tsv", "video/mp2t"), FA = (new Map).set("mp4", "application/mp4").set("m4s", "application/mp4").set("m4i", "application/mp4").set("m4f", "application/mp4").set("cmft", "application/mp4").set("vtt", "text/vtt").set("webvtt", "text/vtt").set("ttml", "application/ttml+xml"), GA = (new Map).set("jpg", "image/jpeg").set("png", "image/png").set("svg", "image/svg+xml").set("webp", "image/webp").set("avif", "image/avif"), zA = (new Map).set("audio", DA).set("video", EA).set("text", FA).set("image", GA), BA = new Set([
            "video/mp2t"
        ].concat(x(ef))), Yy = "VOD", wA = "EVENT", Jz = "LIVE", dz = {
            jk: Yy,
            Vm: wA,
            gn: Jz
        };
        Ci("application/x-mpegurl", function() {
            return new Vy;
        });
        Ci("application/vnd.apple.mpegurl", function() {
            return new Vy;
        });
        function HA(a) {
            return Cv(a);
        }
        var IA = (new Map).set("com.microsoft.playready", HA).set("com.microsoft.playready.recommendation", HA).set("com.microsoft.playready.software", HA).set("com.microsoft.playready.hardware", HA);
        function JA() {
            var a = this;
            this.h = this.g = null;
            this.l = [];
            this.j = null;
            this.A = 1;
            this.i = null;
            this.F = new Lc(5);
            this.u = new Bf(function() {
                KA(a);
            });
            this.D = new Tg;
            this.m = new Map;
            this.C = function() {
                return !1;
            };
        }
        p = JA.prototype;
        p.configure = function(a, b) {
            this.g = a;
            b && (this.C = b);
        };
        p.start = function(a, b) {
            var c = this;
            return Q(function(d) {
                if (d.g == 1) return c.l = [
                    a
                ], c.h = b, F(d, LA(c), 2);
                if (!c.h) throw new U(2, 7, 7001);
                return d.return(c.j);
            });
        };
        function KA(a) {
            var b;
            Q(function(c) {
                switch(c.g){
                    case 1:
                        return ra(c, 2), F(c, LA(a), 4);
                    case 4:
                        ta(c, 3);
                        break;
                    case 2:
                        b = ua(c), a.h && (b.severity = 1, a.h.onError(b));
                    case 3:
                        if (!a.h) return c.return();
                        H(c);
                }
            });
        }
        p.stop = function() {
            this.g = this.h = null;
            this.l = [];
            this.j = null;
            this.u != null && (this.u.stop(), this.u = null);
            this.m.clear();
            return this.D.destroy();
        };
        p.update = function() {
            var a = this, b;
            return Q(function(c) {
                if (c.g == 1) return ra(c, 2), F(c, LA(a), 4);
                if (c.g != 2) return ta(c, 0);
                b = ua(c);
                if (!a.h || !b) return c.return();
                a.h.onError(b);
                H(c);
            });
        };
        p.onExpirationUpdated = function() {};
        p.onInitialVariantChosen = function() {};
        p.banLocation = function() {};
        p.setMediaElement = function() {};
        function LA(a) {
            var b, c, d, e, f, g, h;
            return Q(function(k) {
                if (k.g == 1) return b = $g(a.l, a.g.retryParameters), c = a.h.networkingEngine, d = Date.now(), e = c.request(0, b, {
                    type: 5,
                    isPreload: a.C()
                }), Ug(a.D, e), F(k, e.promise, 2);
                f = k.h;
                if (!a.h) return k.return();
                f.uri && !a.l.includes(f.uri) && a.l.unshift(f.uri);
                var l = f.uri, m = f.data, n = a.g.mss.manifestPreprocessor;
                if (n != Yn) {
                    Zc("manifest.mss.manifestPreprocessor configuration", "Please Use manifest.mss.manifestPreprocessorTXml instead.");
                    m = tx(m, "SmoothStreamingMedia");
                    if (!m) throw new U(2, 4, 4046, l);
                    n(m);
                    m = $b(m.outerHTML);
                }
                var q = Jd(m, "SmoothStreamingMedia");
                if (!q) throw new U(2, 4, 4046, l);
                l = a.g.mss.manifestPreprocessorTXml;
                l != Zn && l(q);
                a.i || (a.i = new yl(null, 0));
                if (l = Zd(q, "IsLive", ie, !1)) throw new U(2, 4, 4047);
                a.i.sd(!l);
                n = Zd(q, "TimeScale", ge, 1E7);
                m = Zd(q, "DVRWindowLength", ge);
                l && (m === 0 || isNaN(m)) && (m = Infinity);
                var r = Zd(q, "CanSeek", ie, !1);
                m === 0 && r && (m = Infinity);
                r = null;
                m && m > 0 && (r = m / n);
                l && !isNaN(a.g.availabilityWindowOverride) && (r = a.g.availabilityWindowOverride);
                r == null && (r = Infinity);
                a.i.hg(r);
                m = Zd(q, "Duration", ge, Infinity);
                l || a.i.zb(m / n);
                l = {
                    variants: [],
                    textStreams: [],
                    timescale: n,
                    duration: m / n
                };
                var t;
                r = Rd(q, "Protection");
                n = a.g.mss.keySystemsBySystemId;
                m = [];
                r = u(r);
                for(t = r.next(); !t.done; t = r.next())m = m.concat(Rd(t.value, "ProtectionHeader"));
                if (m.length) {
                    r = [];
                    for(t = 0; t < m.length; t++){
                        var w = m[t], v = w.attributes.SystemID.toLowerCase(), z = n[v];
                        if (z) {
                            var y;
                            a: {
                                if (y = Av(w)) {
                                    y = u(Ud(y, "DATA"));
                                    for(var A = y.next(); !A.done; A = y.next())if (A = Vd(A.value, "KID")) {
                                        y = hc(Sd(A));
                                        y = new Uint8Array([
                                            y[3],
                                            y[2],
                                            y[1],
                                            y[0],
                                            y[5],
                                            y[4],
                                            y[7],
                                            y[6]
                                        ].concat(x(y.slice(8))));
                                        y = jc(y);
                                        break a;
                                    }
                                }
                                y = null;
                            }
                            A = hc(Sd(w));
                            v = ic(v.replace(/-/g, ""));
                            v = [
                                {
                                    initData: Ah(A, v, new Set, 0),
                                    initDataType: "cenc",
                                    keyId: y
                                }
                            ];
                            v = nc(z, "cenc", v);
                            y && v.keyIds.add(y);
                            if (z = IA.get(z)) v.licenseServerUri = z(w);
                            r.push(v);
                        }
                    }
                    n = r;
                } else n = [];
                t = n;
                r = [];
                n = [];
                m = [];
                q = Rd(q, "StreamIndex");
                q = u(q);
                for(w = q.next(); !w.done; w = q.next()){
                    w = w.value;
                    z = Rd(w, "QualityLevel");
                    v = l.timescale;
                    y = l.duration;
                    A = Rd(w, "c");
                    for(var C = [], E = 0, D = 0; D < A.length; ++D){
                        var B = A[D], G = A[D + 1], I = Zd(B, "t", ge), J = Zd(B, "d", ge);
                        B = Zd(B, "r", ee);
                        if (!J) break;
                        I = I != null ? I : E;
                        (B = B || 0) && B--;
                        if (B < 0) {
                            if (G) {
                                G = Zd(G, "t", ge);
                                if (G == null) break;
                                else if (I >= G) break;
                                B = Math.ceil((G - I) / J) - 1;
                            } else {
                                if (y == Infinity) break;
                                else if (I / v >= y) break;
                                B = Math.ceil((y * v - I) / J) - 1;
                            }
                        }
                        for(G = 0; G <= B; ++G)E = I + J, C.push({
                            start: I / v,
                            end: E / v,
                            xi: I
                        }), I = E;
                    }
                    v = C;
                    z = u(z);
                    for(y = z.next(); !y.done; y = z.next())(y = MA(a, w, y.value, v, t, l)) && (y.type != "audio" || a.g.disableAudio ? y.type != "video" || a.g.disableVideo ? y.type != sc || a.g.disableText || m.push(y) : n.push(y) : r.push(y));
                }
                q = [];
                r = u(r.length > 0 ? r : [
                    null
                ]);
                for(t = r.next(); !t.done; t = r.next())for(t = t.value, w = u(n.length > 0 ? n : [
                    null
                ]), C = w.next(); !C.done; C = w.next())z = q, v = z.push, y = a, A = t, C = C.value, D = 0, A && A.bandwidth && A.bandwidth > 0 && (D += A.bandwidth), C && C.bandwidth && C.bandwidth > 0 && (D += C.bandwidth), y = {
                    id: y.A++,
                    language: A ? A.language : "und",
                    disabledUntilTime: 0,
                    primary: !!A && A.primary || !!C && C.primary,
                    audio: A,
                    video: C,
                    bandwidth: D,
                    allowedByApplication: !0,
                    allowedByKeySystem: !0,
                    decodingInfos: []
                }, v.call(z, y);
                l.variants = q;
                l.textStreams = m;
                a.j ? (a.j.variants = l.variants, a.j.textStreams = l.textStreams, a.h.filter(a.j)) : (a.j = {
                    presentationTimeline: a.i,
                    variants: l.variants,
                    textStreams: l.textStreams,
                    imageStreams: [],
                    offlineSessionIds: [],
                    sequenceMode: a.g.mss.sequenceMode,
                    ignoreManifestTimestampsInSegmentsMode: !1,
                    type: "MSS",
                    serviceDescription: null,
                    nextUrl: null,
                    periodCount: 1,
                    gapCount: 0,
                    isLowLatency: !1,
                    startTime: null
                }, a.i.Jf());
                Promise.resolve();
                g = Date.now();
                h = (g - d) / 1E3;
                a.F.sample(1, h);
                H(k);
            });
        }
        function MA(a, b, c, d, e, f) {
            var g = b.attributes.Type;
            if (g !== "audio" && g !== "video" && g !== "text") return ab("Ignoring unrecognized type:", g), null;
            var h = b.attributes.Language, k = a.A++, l = Zd(c, "Bitrate", fe), m = Zd(c, "MaxWidth", fe), n = Zd(c, "MaxHeight", fe), q = Zd(c, "Channels", fe), r = Zd(c, "SamplingRate", fe), t = f.duration;
            d.length && (t = d[d.length - 1].end - d[0].start);
            var w = a.i.getDuration();
            a.i.zb(Math.min(t, w));
            var v = {
                id: k,
                originalId: b.attributes.Name || String(k),
                groupId: null,
                createSegmentIndex: function() {
                    return Promise.resolve();
                },
                closeSegmentIndex: function() {
                    return Promise.resolve();
                },
                segmentIndex: null,
                mimeType: "",
                codecs: "",
                frameRate: void 0,
                pixelAspectRatio: void 0,
                bandwidth: l || 0,
                width: m || void 0,
                height: n || void 0,
                kind: "",
                encrypted: e.length > 0,
                drmInfos: e,
                keyIds: new Set,
                language: yc(h || "und"),
                originalLanguage: h,
                label: "",
                type: "",
                primary: !1,
                trickModeVideo: null,
                dependencyStream: null,
                emsgSchemeIdUris: [],
                roles: [],
                forced: !1,
                channelsCount: q,
                audioSamplingRate: r,
                spatialAudio: !1,
                closedCaptions: null,
                hdr: void 0,
                colorGamut: void 0,
                videoLayout: void 0,
                tilesLayout: void 0,
                matchedStreams: [],
                mssPrivateData: {
                    duration: t,
                    timescale: f.timescale,
                    codecPrivateData: null
                },
                accessibilityPurpose: null,
                external: !1,
                fastSwitching: !1,
                fullMimeTypes: new Set,
                isAudioMuxedInVideo: !1,
                baseOriginalId: null
            };
            if (e = b.attributes.Subtype) (e = NA.get(e)) && v.roles.push(e), e === "main" && (v.primary = !0);
            e = c.attributes.FourCC;
            if (e === null || e === "") e = b.attributes.FourCC;
            if (!e) {
                if (g === "audio") e = "AAC";
                else if (g === "video") return ab('FourCC is not defined whereas it is required for a QualityLevel element for a StreamIndex of type "video"'), null;
            }
            if (!OA.includes(e.toUpperCase())) return ab("Codec not supported:", e), null;
            c = PA(c, g, e, v);
            v.mssPrivateData.codecPrivateData = c;
            switch(g){
                case "audio":
                    if (!c) return ab("Quality unsupported without CodecPrivateData", g), null;
                    v.type = "audio";
                    v.mimeType = "mss/audio/mp4";
                    v.codecs = QA(e, c);
                    break;
                case "video":
                    if (!c) return ab("Quality unsupported without CodecPrivateData", g), null;
                    v.type = "video";
                    v.mimeType = "mss/video/mp4";
                    v.codecs = RA(c);
                    break;
                case "text":
                    if (v.type = sc, v.mimeType = "application/mp4", e === "TTML" || e === "DFXP") v.codecs = "stpp";
            }
            v.fullMimeTypes.add(df(v.mimeType, v.codecs));
            v.createSegmentIndex = function() {
                if (v.segmentIndex) return Promise.resolve();
                if (a.m.has(v.id)) var z = a.m.get(v.id);
                else z = [], v.type == "video" && (z = v.mssPrivateData.codecPrivateData.split("00000001").slice(1)), z = {
                    id: v.id,
                    type: v.type,
                    codecs: v.codecs,
                    encrypted: v.encrypted,
                    timescale: v.mssPrivateData.timescale,
                    duration: v.mssPrivateData.duration,
                    Hb: z,
                    Na: new Uint8Array([]),
                    Ya: new Uint8Array([]),
                    eb: 0,
                    gb: 0,
                    data: null,
                    stream: v
                }, z = Si(new Ri([
                    z
                ])), a.m.set(v.id, z);
                z = SA(a, new wj(function() {
                    return [];
                }, 0, null, lm(v), v.mssPrivateData.timescale, z, null, v.encrypted), v, b, d);
                v.segmentIndex = new Xl(z);
                return Promise.resolve();
            };
            v.closeSegmentIndex = function() {
                v.segmentIndex && (v.segmentIndex.release(), v.segmentIndex = null);
            };
            return v;
        }
        function PA(a, b, c, d) {
            if (a = a.attributes.CodecPrivateData) return a;
            if (b !== "audio") return null;
            b = d.channelsCount || 2;
            a = d.audioSamplingRate || 44100;
            var e = {
                96E3: 0,
                88200: 1,
                64E3: 2,
                48E3: 3,
                44100: 4,
                32E3: 5,
                24E3: 6,
                22050: 7,
                16E3: 8,
                12E3: 9,
                11025: 10,
                8E3: 11,
                7350: 12
            };
            d = e[a];
            if (c === "AACH") return c = new Uint8Array(4), a = e[a * 2], c[0] = 40 | d >> 1, c[1] = d << 7 | b << 3 | a >> 1, c[2] = a << 7 | 8, c[3] = 0, b = new Uint16Array(2), b[0] = (c[0] << 8) + c[1], b[1] = (c[2] << 8) + c[3], b[0].toString(16) + b[1].toString(16);
            c = new Uint8Array(2);
            c[0] = 16 | d >> 1;
            c[1] = d << 7 | b << 3;
            b = new Uint16Array(1);
            b[0] = (c[0] << 8) + c[1];
            return b[0].toString(16);
        }
        function QA(a, b) {
            var c = 0;
            a === "AACH" && (c = 5);
            b ? c === 0 && (c = (parseInt(b.substr(0, 2), 16) & 248) >> 3) : (c = 2, a === "AACH" && (c = 5));
            return "mp4a.40." + c;
        }
        function RA(a) {
            var b = /00000001[0-9]7/.exec(a);
            return b.length && a ? "avc1." + a.substr(a.indexOf(b[0]) + 10, 6) : "";
        }
        function SA(a, b, c, d, e) {
            var f = d.attributes.Url.replace("{bitrate}", String(c.bandwidth));
            d = [];
            e = u(e);
            for(var g = e.next(), h = {}; !g.done; h = {
                ng: void 0
            }, g = e.next())h.ng = g.value, d.push(new yj(h.ng.start, h.ng.end, function(k) {
                return function() {
                    return mc(a.l, [
                        f.replace("{start time}", String(k.ng.xi))
                    ]);
                };
            }(h), 0, null, b, 0, 0, c.mssPrivateData.duration));
            return d;
        }
        S("shaka.mss.MssParser", JA);
        var OA = "AAC AACL AACH AACP AVC1 H264 TTML DFXP".split(" "), NA = (new Map).set("CAPT", "main").set("SUBT", "alternate").set("DESC", "main");
        Ci("application/vnd.ms-sstr+xml", function() {
            return new JA;
        });
        function TA(a, b, c, d, e, f, g) {
            if (c >= 200 && c <= 299 && c != 202 || c == 304) return {
                uri: e || d,
                originalUri: d,
                data: b,
                status: c,
                headers: a,
                fromCache: !!a["x-shaka-from-cache"],
                originalRequest: f
            };
            f = null;
            try {
                f = Zb(b);
            } catch (h) {}
            throw new U(c == 401 || c == 403 ? 2 : 1, 1, 1001, d, c, f, a, g, e || d);
        }
        function UA() {}
        function VA(a, b, c, d, e, f) {
            var g = new WA;
            try {
                jh(b.headers).forEach(function(m, n) {
                    g.append(n, m);
                });
            } catch (m) {
                return Ng(new U(1, 1, 1002, a, m, c));
            }
            var h = new XA, k = {
                Ki: !1,
                bk: !1
            };
            a = YA(a, b, c, {
                body: b.body || void 0,
                headers: g,
                method: b.method,
                signal: h.signal,
                credentials: b.allowCrossSiteCredentials ? "include" : void 0
            }, k, d, e, b.streamDataCallback, f.minBytesForProgressEvents || 0);
            a = new Mg(a, function() {
                k.Ki = !0;
                h.abort();
                return Promise.resolve();
            });
            if (b = b.retryParameters.timeout) {
                var l = new Bf(function() {
                    k.bk = !0;
                    h.abort();
                });
                l.$(b / 1E3);
                a.finally(function() {
                    l.stop();
                });
            }
            return a;
        }
        function YA(a, b, c, d, e, f, g, h, k) {
            var l, m, n, q, r, t, w, v, z, y, A, C, E, D, B;
            return Q(function(G) {
                switch(G.g){
                    case 1:
                        return l = ZA, m = $A, q = new ArrayBuffer(0), t = r = 0, w = {}, v = Date.now(), ra(G, 2), F(G, l(a, d), 4);
                    case 4:
                        n = G.h;
                        w = aB(n.headers);
                        g(w);
                        if (d.method == "HEAD") {
                            G.B(5);
                            break;
                        }
                        y = (z = n.headers.get("Content-Length")) ? parseInt(z, 10) : 0;
                        if (!n.body) return F(G, n.arrayBuffer(), 9);
                        A = n.clone().body.getReader();
                        C = function(I) {
                            function J() {
                                var L, K, N, P;
                                return Q(function(O) {
                                    switch(O.g){
                                        case 1:
                                            return ra(O, 2), F(O, A.read(), 4);
                                        case 4:
                                            L = O.h;
                                            ta(O, 3);
                                            break;
                                        case 2:
                                            return ua(O), O.return();
                                        case 3:
                                            if (L.done) {
                                                O.B(5);
                                                break;
                                            }
                                            r += L.value.byteLength;
                                            if (!h) {
                                                O.B(5);
                                                break;
                                            }
                                            return F(O, h(L.value), 5);
                                        case 5:
                                            K = Date.now();
                                            N = r - t;
                                            if (K - v > 100 && N >= k || L.done) P = L.done ? 0 : y - r, f(K - v, N, P), t = r, v = K;
                                            L.done ? I.close() : (I.enqueue(L.value), J());
                                            H(O);
                                    }
                                });
                            }
                            J();
                        };
                        new m({
                            start: C
                        });
                        return F(G, n.arrayBuffer(), 8);
                    case 8:
                        q = G.h;
                        G.B(5);
                        break;
                    case 9:
                        q = G.h, E = Date.now(), f(E - v, q.byteLength, 0);
                    case 5:
                        b.headers.Range && (D = b.headers.Range.replace("bytes=", "").split("-").filter(function(I) {
                            return I;
                        }).map(function(I) {
                            return parseInt(I, 10);
                        }), D.length == 2 && q.byteLength != D[1] - D[0] + 1 && ab("Payload length does not match range requested bytes", b, n));
                        ta(G, 3);
                        break;
                    case 2:
                        B = ua(G);
                        if (e.Ki) throw new U(1, 1, 7001, a, c);
                        if (e.bk) throw new U(1, 1, 1003, a, c);
                        throw new U(1, 1, 1002, a, B, c);
                    case 3:
                        return G.return(TA(w, q, n.status, a, n.url, b, c));
                }
            });
        }
        function aB(a) {
            var b = {};
            a.forEach(function(c, d) {
                b[d.trim()] = c;
            });
            return b;
        }
        function bB() {
            if (window1.ReadableStream) try {
                new ReadableStream({});
            } catch (a) {
                return !1;
            }
            else return !1;
            if (window1.Response) {
                if (!new Response("").body) return !1;
            } else return !1;
            return !(!window1.fetch || "polyfill" in window1.fetch || !window1.AbortController);
        }
        S("shaka.net.HttpFetchPlugin", UA);
        UA.isSupported = bB;
        UA.parse = VA;
        var ZA = window1.fetch, XA = window1.AbortController, $A = window1.ReadableStream, WA = window1.Headers;
        bB() && (Wg("http", VA, 2, !0), Wg("https", VA, 2, !0), Wg("blob", VA, 2, !0));
        function cB() {}
        function dB(a, b, c, d, e, f) {
            var g = new eB, h = Date.now(), k = 0, l = new Promise(function(m, n) {
                g.open(b.method, a, !0);
                g.responseType = "arraybuffer";
                g.timeout = b.retryParameters.timeout;
                g.withCredentials = b.allowCrossSiteCredentials;
                var q = {};
                g.onabort = function() {
                    n(new U(1, 1, 7001, a, c));
                };
                g.onreadystatechange = function() {
                    if (g.readyState === XMLHttpRequest.HEADERS_RECEIVED) {
                        var t = g.getAllResponseHeaders().trim().split("\r\n"), w = {};
                        t = u(t);
                        for(var v = t.next(); !v.done; v = t.next())v = v.value.split(": "), w[v[0].toLowerCase()] = v.slice(1).join(": ");
                        q = w;
                        e(q);
                    }
                };
                g.onload = function(t) {
                    var w = g.response;
                    try {
                        d(Date.now() - h, t.loaded - k, 0);
                        var v = TA(q, w, g.status, a, g.responseURL, b, c);
                        m(v);
                    } catch (z) {
                        n(z);
                    }
                };
                g.onerror = function(t) {
                    n(new U(1, 1, 1002, a, t, c));
                };
                g.ontimeout = function() {
                    n(new U(1, 1, 1003, a, c));
                };
                g.onprogress = function(t) {
                    var w = Date.now(), v = f.minBytesForProgressEvents || 0, z = t.loaded - k;
                    if (w - h > 100 && z >= v || t.lengthComputable && t.loaded == t.total) d(w - h, z, g.readyState == 4 ? 0 : t.total - t.loaded), k = t.loaded, h = w;
                };
                for(var r in b.headers)try {
                    g.setRequestHeader(r.toLowerCase(), b.headers[r]);
                } catch (t) {
                    throw new U(1, 1, 1002, a, t, c);
                }
                g.send(b.body);
            });
            return new Mg(l, function() {
                g.abort();
                return Promise.resolve();
            });
        }
        S("shaka.net.HttpXHRPlugin", cB);
        cB.parse = dB;
        var eB = window1.XMLHttpRequest;
        Wg("http", dB, 1, !0);
        Wg("https", dB, 1, !0);
        Wg("blob", dB, 1, !0);
        function fB(a, b, c, d, e) {
            this.g = a;
            this.i = b;
            this.groupId = c;
            this.h = d;
            this.j = e;
        }
        function gB(a) {
            var b = a.hc(!1);
            return b ? fc(b) : a.T().map(function(c) {
                return "{" + encodeURI(c.split("#xywh=")[0]) + "}";
            }).join("") + ":" + a.startByte + ":" + a.endByte;
        }
        function hB(a, b) {
            return Hm(a.g.T(), a.g.startByte, a.g.endByte, b.streaming.retryParameters);
        }
        function iB() {
            this.g = this.j = this.i = 0;
            this.h = new Map;
            this.l = 0;
        }
        function jB(a, b) {
            a.i += b;
            var c = a.l;
            a.l++;
            a.h.set(c, b);
            return c;
        }
        iB.prototype.close = function(a, b) {
            if (this.h.has(a)) {
                var c = this.h.get(a);
                this.h.delete(a);
                this.j += c;
                this.g += b;
            }
        };
        function kB(a) {
            return a.i == 0 ? 0 : a.j / a.i;
        }
        function lB(a) {
            var b = this;
            this.A = a;
            this.i = new Map;
            this.h = new hh(function() {
                return mB(b).catch(function() {});
            });
            this.j = [];
            this.u = function() {};
            this.m = function() {};
            this.g = new iB;
            this.l = !1;
        }
        lB.prototype.destroy = function() {
            return this.h.destroy();
        };
        function nB(a, b, c) {
            a.u = b;
            a.m = c;
        }
        function mB(a) {
            a.l = !0;
            var b = a.j.map(function(c) {
                return c();
            });
            a.j = [];
            return Promise.all(b);
        }
        lB.prototype.queue = function(a, b, c, d, e) {
            var f = this;
            ih(this.h);
            var g = (this.i.get(a) || Promise.resolve()).then(function() {
                var h, k, l, m, n, q, r;
                return Q(function(t) {
                    if (t.g == 1) return F(t, oB(f, b), 2);
                    h = t.h;
                    if (f.h.g) throw new U(2, 9, 7001);
                    if (d) for(m in k = Kb(h), l = new zh(k), l.data)n = Number(m), q = l.data[n], r = l.g[n], f.m(q, r);
                    f.g.close(c, h.byteLength);
                    f.u(kB(f.g), f.g.g);
                    return t.return(e(h));
                });
            });
            this.i.set(a, g);
            return g;
        };
        function pB(a, b, c, d, e, f) {
            ih(a.h);
            var g = (a.i.get(b) || Promise.resolve()).then(function() {
                if (a.h.g) throw new U(2, 9, 7001);
                if (e) {
                    var h = Kb(c);
                    h = new zh(h);
                    for(var k in h.data){
                        var l = Number(k);
                        a.m(h.data[l], h.g[l]);
                    }
                }
                a.g.close(d, c.byteLength);
                a.u(kB(a.g), a.g.g);
                return f(c);
            });
            a.i.set(b, g);
        }
        function qB(a) {
            return Q(function(b) {
                return b.g == 1 ? F(b, Promise.all(a.i.values()), 2) : b.return(a.g.g);
            });
        }
        function oB(a, b) {
            var c, d, e, f;
            return Q(function(g) {
                if (g.g == 1) return c = fh, d = a.A.request(c, b), e = function() {
                    return d.abort();
                }, a.j.push(e), F(g, d.promise, 2);
                f = g.h;
                Qc(a.j, e);
                return g.return(f.data);
            });
        }
        function rB(a, b) {
            var c = this;
            this.i = a;
            this.h = a.objectStore(b);
            this.g = new Lg;
            a.onabort = function(d) {
                d.preventDefault();
                c.g.reject();
            };
            a.onerror = function(d) {
                d.preventDefault();
                c.g.reject();
            };
            a.oncomplete = function() {
                c.g.resolve();
            };
        }
        rB.prototype.abort = function() {
            var a = this;
            return Q(function(b) {
                if (b.g == 1) {
                    try {
                        a.i.abort();
                    } catch (c) {}
                    ra(b, 2);
                    return F(b, a.g, 4);
                }
                if (b.g != 2) return ta(b, 0);
                ua(b);
                H(b);
            });
        };
        function sB(a, b) {
            return new Promise(function(c, d) {
                var e = a.h.openCursor();
                e.onerror = d;
                e.onsuccess = function() {
                    var f;
                    return Q(function(g) {
                        if (g.g == 1) {
                            if (e.result == null) return c(), g.return();
                            f = e.result;
                            return F(g, b(f.key, f.value, f), 2);
                        }
                        f.continue();
                        H(g);
                    });
                };
            });
        }
        rB.prototype.store = function() {
            return this.h;
        };
        rB.prototype.promise = function() {
            return this.g;
        };
        function tB(a) {
            this.h = a;
            this.g = [];
        }
        tB.prototype.destroy = function() {
            return Promise.all(this.g.map(function(a) {
                return a.abort();
            }));
        };
        function uB(a, b) {
            return vB(a, b, "readwrite");
        }
        function vB(a, b, c) {
            c = a.h.transaction([
                b
            ], c);
            var d = new rB(c, b);
            a.g.push(d);
            d.promise().then(function() {
                Qc(a.g, d);
            }, function() {
                Qc(a.g, d);
            });
            return d;
        }
        function wB(a, b, c) {
            this.h = new tB(a);
            this.i = b;
            this.g = c;
        }
        p = wB.prototype;
        p.destroy = function() {
            return this.h.destroy();
        };
        p.hasFixedKeySpace = function() {
            return !0;
        };
        p.addSegments = function() {
            return xB(this.i);
        };
        p.removeSegments = function(a, b) {
            return yB(this, this.i, a, b);
        };
        p.getSegments = function(a) {
            var b = this, c;
            return Q(function(d) {
                if (d.g == 1) return F(d, zB(b, b.i, a), 2);
                c = d.h;
                return d.return(c.map(function(e) {
                    return b.Pi(e);
                }));
            });
        };
        p.addManifests = function() {
            return xB(this.g);
        };
        p.updateManifest = function() {
            return Promise.reject(new U(2, 9, 9016, "Cannot modify values in " + this.g));
        };
        function AB(a, b, c) {
            a = uB(a.h, a.g);
            var d = a.store();
            d.get(b).onsuccess = function() {
                d.put(c, b);
            };
            return a.promise();
        }
        p.updateManifestExpiration = function(a, b) {
            var c = uB(this.h, this.g), d = c.store();
            d.get(a).onsuccess = function(e) {
                if (e = e.target.result) e.expiration = b, d.put(e, a);
            };
            return c.promise();
        };
        p.removeManifests = function(a, b) {
            return yB(this, this.g, a, b);
        };
        p.getManifests = function(a) {
            var b = this, c;
            return Q(function(d) {
                if (d.g == 1) return F(d, zB(b, b.g, a), 2);
                c = d.h;
                return d.return(Promise.all(c.map(function(e) {
                    return b.ge(e);
                })));
            });
        };
        p.getAllManifests = function() {
            var a = this, b, c;
            return Q(function(d) {
                return d.g == 1 ? (b = vB(a.h, a.g, "readonly"), c = new Map, F(d, sB(b, function(e, f) {
                    var g;
                    return Q(function(h) {
                        if (h.g == 1) return F(h, a.ge(f), 2);
                        g = h.h;
                        c.set(e, g);
                        H(h);
                    });
                }), 2)) : d.g != 3 ? F(d, b.promise(), 3) : d.return(c);
            });
        };
        p.Pi = function(a) {
            return a;
        };
        p.ge = function(a) {
            return Promise.resolve(a);
        };
        function xB(a) {
            return Promise.reject(new U(2, 9, 9011, "Cannot add new value to " + a));
        }
        p.add = function(a, b) {
            var c = this, d, e, f, g, h, k, l;
            return Q(function(m) {
                if (m.g == 1) {
                    d = uB(c.h, a);
                    e = d.store();
                    f = [];
                    g = u(b);
                    h = g.next();
                    for(k = {}; !h.done; k = {
                        Vh: void 0
                    }, h = g.next())l = h.value, k.Vh = e.add(l), k.Vh.onsuccess = function(n) {
                        return function() {
                            f.push(n.Vh.result);
                        };
                    }(k);
                    return F(m, d.promise(), 2);
                }
                return m.return(f);
            });
        };
        function yB(a, b, c, d) {
            a = uB(a.h, b);
            b = a.store();
            c = u(c);
            for(var e = c.next(), f = {}; !e.done; f = {
                Ih: void 0
            }, e = c.next())f.Ih = e.value, b.delete(f.Ih).onsuccess = function(g) {
                return function() {
                    return d(g.Ih);
                };
            }(f);
            return a.promise();
        }
        function zB(a, b, c) {
            var d, e, f, g, h, k, l;
            return Q(function(m) {
                if (m.g == 1) {
                    d = vB(a.h, b, "readonly");
                    e = d.store();
                    f = {};
                    g = [];
                    h = u(c);
                    k = h.next();
                    for(l = {}; !k.done; l = {
                        ag: void 0,
                        Ff: void 0
                    }, k = h.next())l.Ff = k.value, l.ag = e.get(l.Ff), l.ag.onsuccess = function(n) {
                        return function() {
                            n.ag.result == void 0 && g.push(n.Ff);
                            f[n.Ff] = n.ag.result;
                        };
                    }(l);
                    return F(m, d.promise(), 2);
                }
                if (g.length) throw new U(2, 9, 9012, "Could not find values for " + g);
                return m.return(c.map(function(n) {
                    return f[n];
                }));
            });
        }
        function BB(a) {
            this.g = new tB(a);
        }
        BB.prototype.destroy = function() {
            return this.g.destroy();
        };
        BB.prototype.getAll = function() {
            var a = this, b, c;
            return Q(function(d) {
                return d.g == 1 ? (b = vB(a.g, "session-ids", "readonly"), c = [], F(d, sB(b, function(e, f) {
                    c.push(f);
                }), 2)) : d.g != 3 ? F(d, b.promise(), 3) : d.return(c);
            });
        };
        BB.prototype.add = function(a) {
            var b = uB(this.g, "session-ids"), c = b.store();
            a = u(a);
            for(var d = a.next(); !d.done; d = a.next())c.add(d.value);
            return b.promise();
        };
        BB.prototype.remove = function(a) {
            var b = this, c;
            return Q(function(d) {
                return d.g == 1 ? (c = uB(b.g, "session-ids"), F(d, sB(c, function(e, f, g) {
                    a.includes(f.sessionId) && g.delete();
                }), 2)) : F(d, c.promise(), 0);
            });
        };
        function CB() {
            this.g = new Map;
        }
        CB.prototype.destroy = function() {
            for(var a = [], b = u(this.g.values()), c = b.next(); !c.done; c = b.next())a.push(c.value.destroy());
            this.g.clear();
            return Promise.all(a);
        };
        CB.prototype.init = function() {
            var a = this;
            DB.forEach(function(e, f) {
                (e = e()) && a.g.set(f, e);
            });
            for(var b = [], c = u(this.g.values()), d = c.next(); !d.done; d = c.next())b.push(d.value.init());
            return Promise.all(b);
        };
        function EB(a) {
            var b = null;
            a.g.forEach(function(c, d) {
                c.getCells().forEach(function(e, f) {
                    e.hasFixedKeySpace() || b || (b = {
                        path: {
                            Yb: d,
                            kb: f
                        },
                        kb: e
                    });
                });
            });
            if (b) return b;
            throw new U(2, 9, 9013, "Could not find a cell that supports add-operations");
        }
        function FB(a, b) {
            a.g.forEach(function(c, d) {
                c.getCells().forEach(function(e, f) {
                    b({
                        Yb: d,
                        kb: f
                    }, e);
                });
            });
        }
        function GB(a, b, c) {
            a = a.g.get(b);
            if (!a) throw new U(2, 9, 9013, "Could not find mechanism with name " + b);
            b = a.getCells().get(c);
            if (!b) throw new U(2, 9, 9013, "Could not find cell with name " + c);
            return b;
        }
        function HB(a, b) {
            a.g.forEach(function(c) {
                b(c.getEmeSessionCell());
            });
        }
        function IB(a) {
            var b = Array.from(a.g.keys());
            if (!b.length) throw new U(2, 9, 9E3, "No supported storage mechanisms found");
            return a.g.get(b[0]).getEmeSessionCell();
        }
        function JB(a) {
            var b, c, d;
            return Q(function(e) {
                return e.g == 1 ? (b = Array.from(a.g.values()), c = b.length > 0, c || (d = DB, d.forEach(function(f) {
                    (f = f()) && b.push(f);
                })), F(e, Promise.all(b.map(function(f) {
                    return f.erase();
                })), 2)) : c ? e.B(0) : F(e, Promise.all(b.map(function(f) {
                    return f.destroy();
                })), 0);
            });
        }
        function KB(a, b) {
            DB.set(a, b);
        }
        S("shaka.offline.StorageMuxer", CB);
        CB.unregister = function(a) {
            DB.delete(a);
        };
        CB.register = KB;
        CB.prototype.destroy = CB.prototype.destroy;
        var DB = new Map;
        function LB() {
            wB.apply(this, arguments);
        }
        la(LB, wB);
        LB.prototype.updateManifestExpiration = function(a, b) {
            var c = this, d, e, f;
            return Q(function(g) {
                d = uB(c.h, c.g);
                e = d.store();
                f = new Lg;
                e.get(a).onsuccess = function(h) {
                    (h = h.target.result) ? (h.expiration = b, e.put(h), f.resolve()) : f.reject(new U(2, 9, 9012, "Could not find values for " + a));
                };
                return F(g, Promise.all([
                    d.promise(),
                    f
                ]), 0);
            });
        };
        LB.prototype.ge = function(a) {
            var b, c, d, e, f, g;
            return Q(function(h) {
                if (h.g == 1) {
                    b = [];
                    for(c = 0; c < a.periods.length; ++c)d = c == a.periods.length - 1 ? a.duration : a.periods[c + 1].startTime, e = d - a.periods[c].startTime, f = MB(a.periods[c], e), b.push(f);
                    return F(h, Qw(b), 2);
                }
                g = h.h;
                return h.return({
                    creationTime: 0,
                    originalManifestUri: a.originalManifestUri,
                    duration: a.duration,
                    size: a.size,
                    expiration: a.expiration == null ? Infinity : a.expiration,
                    streams: g,
                    sessionIds: a.sessionIds,
                    drmInfo: a.drmInfo,
                    appMetadata: a.appMetadata,
                    sequenceMode: !1
                });
            });
        };
        function MB(a, b) {
            NB(a);
            for(var c = u(a.streams), d = c.next(); !d.done; d = c.next());
            return a.streams.map(function(e) {
                return OB(e, a.startTime, b);
            });
        }
        function OB(a, b, c) {
            var d = a.initSegmentUri ? PB(a.initSegmentUri) : null, e = b + a.presentationTimeOffset, f = b + c;
            return {
                id: a.id,
                originalId: null,
                groupId: null,
                primary: a.primary,
                type: a.contentType,
                mimeType: a.mimeType,
                codecs: a.codecs,
                frameRate: a.frameRate,
                pixelAspectRatio: void 0,
                hdr: void 0,
                colorGamut: void 0,
                videoLayout: void 0,
                kind: a.kind,
                language: a.language,
                originalLanguage: a.language || null,
                label: a.label,
                width: a.width,
                height: a.height,
                initSegmentKey: d,
                encrypted: a.encrypted,
                keyIds: new Set([
                    a.keyId
                ]),
                segments: a.segments.map(function(g) {
                    var h = PB(g.uri);
                    return {
                        startTime: b + g.startTime,
                        endTime: b + g.endTime,
                        dataKey: h,
                        initSegmentKey: d,
                        appendWindowStart: b,
                        appendWindowEnd: f,
                        timestampOffset: e,
                        tilesLayout: "",
                        mimeType: null,
                        codecs: null,
                        thumbnailSprite: null
                    };
                }),
                variantIds: a.variantIds,
                roles: [],
                forced: !1,
                audioSamplingRate: null,
                channelsCount: null,
                spatialAudio: !1,
                closedCaptions: null,
                tilesLayout: void 0,
                external: !1,
                fastSwitching: !1,
                isAudioMuxedInVideo: !1
            };
        }
        LB.prototype.Pi = function(a) {
            return {
                data: a.data
            };
        };
        function PB(a) {
            var b;
            if ((b = /^offline:[0-9]+\/[0-9]+\/([0-9]+)$/.exec(a)) || (b = /^offline:segment\/([0-9]+)$/.exec(a))) return Number(b[1]);
            throw new U(2, 9, 9004, "Could not parse uri " + a);
        }
        function NB(a) {
            var b = a.streams.filter(function(h) {
                return h.contentType == "audio";
            });
            a = a.streams.filter(function(h) {
                return h.contentType == "video";
            });
            if (!b.every(function(h) {
                return h.variantIds;
            }) || !a.every(function(h) {
                return h.variantIds;
            })) {
                for(var c = u(b), d = c.next(); !d.done; d = c.next())d.value.variantIds = [];
                c = u(a);
                for(d = c.next(); !d.done; d = c.next())d.value.variantIds = [];
                c = 0;
                if (a.length && !b.length) {
                    d = c++;
                    for(var e = u(a), f = e.next(); !f.done; f = e.next())f.value.variantIds.push(d);
                }
                if (!a.length && b.length) for(d = c++, e = u(b), f = e.next(); !f.done; f = e.next())f.value.variantIds.push(d);
                if (a.length && b.length) for(b = u(b), d = b.next(); !d.done; d = b.next())for(d = d.value, e = u(a), f = e.next(); !f.done; f = e.next()){
                    f = f.value;
                    var g = c++;
                    d.variantIds.push(g);
                    f.variantIds.push(g);
                }
            }
        }
        function QB() {
            wB.apply(this, arguments);
        }
        la(QB, wB);
        QB.prototype.ge = function(a) {
            var b, c, d, e, f, g;
            return Q(function(h) {
                if (h.g == 1) {
                    b = [];
                    for(c = 0; c < a.periods.length; ++c){
                        d = c == a.periods.length - 1 ? a.duration : a.periods[c + 1].startTime;
                        e = d - a.periods[c].startTime;
                        for(var k = a.periods[c], l = [], m = u(k.streams), n = m.next(); !n.done; n = m.next())n = n.value, n.variantIds.length != 0 && l.push(RB(n, k.startTime, k.startTime + e));
                        f = l;
                        b.push(f);
                    }
                    return F(h, Qw(b), 2);
                }
                g = h.h;
                return h.return({
                    appMetadata: a.appMetadata,
                    creationTime: 0,
                    drmInfo: a.drmInfo,
                    duration: a.duration,
                    expiration: a.expiration == null ? Infinity : a.expiration,
                    originalManifestUri: a.originalManifestUri,
                    sessionIds: a.sessionIds,
                    size: a.size,
                    streams: g,
                    sequenceMode: !1
                });
            });
        };
        function RB(a, b, c) {
            return {
                id: a.id,
                originalId: a.originalId,
                groupId: null,
                primary: a.primary,
                type: a.contentType,
                mimeType: a.mimeType,
                codecs: a.codecs,
                frameRate: a.frameRate,
                pixelAspectRatio: a.pixelAspectRatio,
                hdr: void 0,
                colorGamut: void 0,
                videoLayout: void 0,
                kind: a.kind,
                language: a.language,
                originalLanguage: a.language || null,
                label: a.label,
                width: a.width,
                height: a.height,
                encrypted: a.encrypted,
                keyIds: new Set([
                    a.keyId
                ]),
                segments: a.segments.map(function(d) {
                    return {
                        startTime: b + d.startTime,
                        endTime: b + d.endTime,
                        initSegmentKey: a.initSegmentKey,
                        appendWindowStart: b,
                        appendWindowEnd: c,
                        timestampOffset: b - a.presentationTimeOffset,
                        dataKey: d.dataKey,
                        tilesLayout: "",
                        mimeType: null,
                        codecs: null,
                        thumbnailSprite: null
                    };
                }),
                variantIds: a.variantIds,
                roles: [],
                forced: !1,
                audioSamplingRate: null,
                channelsCount: null,
                spatialAudio: !1,
                closedCaptions: null,
                tilesLayout: void 0,
                external: !1,
                fastSwitching: !1,
                isAudioMuxedInVideo: !1
            };
        }
        function SB() {
            wB.apply(this, arguments);
        }
        la(SB, wB);
        p = SB.prototype;
        p.hasFixedKeySpace = function() {
            return !1;
        };
        p.addSegments = function(a) {
            return this.add(this.i, a);
        };
        p.addManifests = function(a) {
            return this.add(this.g, a);
        };
        p.updateManifest = function(a, b) {
            return AB(this, a, b);
        };
        p.ge = function(a) {
            a.expiration == null && (a.expiration = Infinity);
            return Promise.resolve(a);
        };
        function TB() {
            this.m = this.j = this.i = this.h = this.g = this.l = null;
        }
        p = TB.prototype;
        p.init = function() {
            var a = this, b = new Lg, c = !1, d = new Bf(function() {
                c = !0;
                b.reject(new U(2, 9, 9017));
            });
            typeof UB === "number" && UB > 0 && d.$(UB);
            var e = window1.indexedDB.open("shaka_offline_db", 5);
            e.onsuccess = function() {
                if (!c) {
                    d.stop();
                    var f = e.result;
                    a.l = f;
                    var g = f.objectStoreNames;
                    g = g.contains("manifest") && g.contains("segment") ? new LB(f, "segment", "manifest") : null;
                    a.g = g;
                    g = f.objectStoreNames;
                    g = g.contains("manifest-v2") && g.contains("segment-v2") ? new QB(f, "segment-v2", "manifest-v2") : null;
                    a.h = g;
                    g = f.objectStoreNames;
                    g = g.contains("manifest-v3") && g.contains("segment-v3") ? new QB(f, "segment-v3", "manifest-v3") : null;
                    a.i = g;
                    g = f.objectStoreNames;
                    g = g.contains("manifest-v5") && g.contains("segment-v5") ? new SB(f, "segment-v5", "manifest-v5") : null;
                    a.j = g;
                    f = f.objectStoreNames.contains("session-ids") ? new BB(f) : null;
                    a.m = f;
                    b.resolve();
                }
            };
            e.onupgradeneeded = function() {
                for(var f = e.result, g = u([
                    "segment-v5",
                    "manifest-v5",
                    "session-ids"
                ]), h = g.next(); !h.done; h = g.next())h = h.value, f.objectStoreNames.contains(h) || f.createObjectStore(h, {
                    autoIncrement: !0
                });
            };
            e.onerror = function(f) {
                c || (d.stop(), b.reject(new U(2, 9, 9001, e.error)), f.preventDefault());
            };
            return b;
        };
        p.destroy = function() {
            var a = this;
            return Q(function(b) {
                switch(b.g){
                    case 1:
                        if (!a.g) {
                            b.B(2);
                            break;
                        }
                        return F(b, a.g.destroy(), 2);
                    case 2:
                        if (!a.h) {
                            b.B(4);
                            break;
                        }
                        return F(b, a.h.destroy(), 4);
                    case 4:
                        if (!a.i) {
                            b.B(6);
                            break;
                        }
                        return F(b, a.i.destroy(), 6);
                    case 6:
                        if (!a.j) {
                            b.B(8);
                            break;
                        }
                        return F(b, a.j.destroy(), 8);
                    case 8:
                        if (!a.m) {
                            b.B(10);
                            break;
                        }
                        return F(b, a.m.destroy(), 10);
                    case 10:
                        a.l && a.l.close(), H(b);
                }
            });
        };
        p.getCells = function() {
            var a = new Map;
            this.g && a.set("v1", this.g);
            this.h && a.set("v2", this.h);
            this.i && a.set("v3", this.i);
            this.j && a.set("v5", this.j);
            return a;
        };
        p.getEmeSessionCell = function() {
            return this.m;
        };
        p.erase = function() {
            var a = this;
            return Q(function(b) {
                switch(b.g){
                    case 1:
                        if (!a.g) {
                            b.B(2);
                            break;
                        }
                        return F(b, a.g.destroy(), 2);
                    case 2:
                        if (!a.h) {
                            b.B(4);
                            break;
                        }
                        return F(b, a.h.destroy(), 4);
                    case 4:
                        if (!a.i) {
                            b.B(6);
                            break;
                        }
                        return F(b, a.i.destroy(), 6);
                    case 6:
                        if (!a.j) {
                            b.B(8);
                            break;
                        }
                        return F(b, a.j.destroy(), 8);
                    case 8:
                        return a.l && a.l.close(), F(b, VB(), 10);
                    case 10:
                        return a.l = null, a.g = null, a.h = null, a.i = null, a.j = null, F(b, a.init(), 0);
                }
            });
        };
        function VB() {
            var a = new Lg, b = window1.indexedDB.deleteDatabase("shaka_offline_db");
            b.onblocked = function() {};
            b.onsuccess = function() {
                a.resolve();
            };
            b.onerror = function(c) {
                a.reject(new U(2, 9, 9001, b.error));
                c.preventDefault();
            };
            return a;
        }
        var UB = 5;
        S("shaka.offline.indexeddb.StorageMechanismOpenTimeout", UB);
        KB("idb", function() {
            return Rb().oi() ? new TB : null;
        });
        function WB(a, b, c, d) {
            this.g = a;
            this.i = b;
            this.h = c;
            this.l = d;
            this.j = [
                "offline:",
                a,
                "/",
                b,
                "/",
                c,
                "/",
                d
            ].join("");
        }
        WB.prototype.Yb = function() {
            return this.i;
        };
        WB.prototype.kb = function() {
            return this.h;
        };
        WB.prototype.key = function() {
            return this.l;
        };
        WB.prototype.toString = function() {
            return this.j;
        };
        function XB(a) {
            a = /^offline:([a-z]+)\/([^/]+)\/([^/]+)\/([0-9]+)$/.exec(a);
            if (a == null) return null;
            var b = a[1];
            if (b != "manifest" && b != "segment") return null;
            var c = a[2];
            if (!c) return null;
            var d = a[3];
            return d && b != null ? new WB(b, c, d, Number(a[4])) : null;
        }
        function YB(a, b) {
            this.h = a;
            this.g = b;
        }
        function ZB(a, b) {
            var c = new yl(null, 0);
            c.zb(b.duration);
            var d = b.streams.filter(function(l) {
                return l.type == "audio";
            }), e = b.streams.filter(function(l) {
                return l.type == "video";
            });
            d = $B(a, d, e, c);
            e = b.streams.filter(function(l) {
                return l.type == sc;
            }).map(function(l) {
                return aC(a, l, c);
            });
            var f = b.streams.filter(function(l) {
                return l.type == "image";
            }).map(function(l) {
                return aC(a, l, c);
            }), g = b.drmInfo ? [
                b.drmInfo
            ] : [];
            if (b.drmInfo) for(var h = u(d.values()), k = h.next(); !k.done; k = h.next())k = k.value, k.audio && k.audio.encrypted && (k.audio.drmInfos = g), k.video && k.video.encrypted && (k.video.drmInfos = g);
            return {
                presentationTimeline: c,
                offlineSessionIds: b.sessionIds,
                variants: Array.from(d.values()),
                textStreams: e,
                imageStreams: f,
                sequenceMode: b.sequenceMode || !1,
                ignoreManifestTimestampsInSegmentsMode: !1,
                type: b.type || "UNKNOWN",
                serviceDescription: null,
                nextUrl: null,
                periodCount: 1,
                gapCount: 0,
                isLowLatency: !1,
                startTime: null
            };
        }
        function $B(a, b, c, d) {
            for(var e = new Set, f = u(b), g = f.next(); !g.done; g = f.next()){
                g = u(g.value.variantIds);
                for(var h = g.next(); !h.done; h = g.next())e.add(h.value);
            }
            f = u(c);
            for(g = f.next(); !g.done; g = f.next())for(g = u(g.value.variantIds), h = g.next(); !h.done; h = g.next())e.add(h.value);
            f = new Map;
            e = u(e);
            for(g = e.next(); !g.done; g = e.next())g = g.value, f.set(g, {
                id: g,
                language: "",
                disabledUntilTime: 0,
                primary: !1,
                audio: null,
                video: null,
                bandwidth: 0,
                allowedByApplication: !0,
                allowedByKeySystem: !0,
                decodingInfos: []
            });
            b = u(b);
            for(e = b.next(); !e.done; e = b.next())for(g = e.value, e = aC(a, g, d), g = u(g.variantIds), h = g.next(); !h.done; h = g.next())h = f.get(h.value), h.language = e.language, h.primary = h.primary || e.primary, h.audio = e;
            c = u(c);
            for(b = c.next(); !b.done; b = c.next())for(e = b.value, b = aC(a, e, d), e = u(e.variantIds), g = e.next(); !g.done; g = e.next())g = f.get(g.value), g.primary = g.primary || b.primary, g.video = b;
            return f;
        }
        function aC(a, b, c) {
            var d = b.segments.map(function(e) {
                return bC(a, e, b);
            });
            c.Be(d);
            return {
                id: b.id,
                originalId: b.originalId,
                groupId: b.groupId,
                createSegmentIndex: function() {
                    return Promise.resolve();
                },
                segmentIndex: new Xl(d),
                mimeType: b.mimeType,
                codecs: b.codecs,
                width: b.width || void 0,
                height: b.height || void 0,
                frameRate: b.frameRate,
                pixelAspectRatio: b.pixelAspectRatio,
                hdr: b.hdr,
                colorGamut: b.colorGamut,
                videoLayout: b.videoLayout,
                kind: b.kind,
                encrypted: b.encrypted,
                drmInfos: [],
                keyIds: b.keyIds,
                language: b.language,
                originalLanguage: b.originalLanguage || null,
                label: b.label,
                type: b.type,
                primary: b.primary,
                trickModeVideo: null,
                dependencyStream: null,
                emsgSchemeIdUris: null,
                roles: b.roles,
                forced: b.forced,
                channelsCount: b.channelsCount,
                audioSamplingRate: b.audioSamplingRate,
                spatialAudio: b.spatialAudio,
                closedCaptions: b.closedCaptions,
                tilesLayout: b.tilesLayout,
                mssPrivateData: b.mssPrivateData,
                accessibilityPurpose: null,
                external: b.external,
                fastSwitching: b.fastSwitching,
                fullMimeTypes: new Set([
                    df(b.mimeType, b.codecs)
                ]),
                isAudioMuxedInVideo: !1,
                baseOriginalId: null
            };
        }
        function bC(a, b, c) {
            var d = new WB("segment", a.h, a.g, b.dataKey);
            a = new yj(b.startTime, b.endTime, function() {
                return [
                    d.toString()
                ];
            }, 0, null, b.initSegmentKey != null ? cC(a, b.initSegmentKey) : null, b.timestampOffset, b.appendWindowStart, b.appendWindowEnd, [], b.tilesLayout || "");
            a.mimeType = b.mimeType || c.mimeType || "";
            a.codecs = b.codecs || c.codecs || "";
            b.thumbnailSprite && a.jg(b.thumbnailSprite);
            return a;
        }
        function cC(a, b) {
            var c = new WB("segment", a.h, a.g, b);
            return new wj(function() {
                return [
                    c.toString()
                ];
            }, 0, null);
        }
        function dC() {
            this.g = null;
        }
        p = dC.prototype;
        p.configure = function() {};
        p.start = function(a, b) {
            var c = this, d, e, f, g, h, k, l;
            return Q(function(m) {
                switch(m.g){
                    case 1:
                        d = XB(a);
                        c.g = d;
                        if (d == null || d.g != "manifest") throw new U(2, 1, 9004, a);
                        e = new CB;
                        sa(m, 2);
                        return F(m, e.init(), 4);
                    case 4:
                        return F(m, GB(e, d.Yb(), d.kb()), 5);
                    case 5:
                        return f = m.h, F(m, f.getManifests([
                            d.key()
                        ]), 6);
                    case 6:
                        return g = m.h, h = g[0], k = new YB(d.Yb(), d.kb()), l = ZB(k, h), b.makeTextStreamsForClosedCaptions(l), m.return(l);
                    case 2:
                        return va(m), F(m, e.destroy(), 7);
                    case 7:
                        xa(m, 0);
                }
            });
        };
        p.stop = function() {
            return Promise.resolve();
        };
        p.update = function() {};
        p.onExpirationUpdated = function(a, b) {
            var c = this, d, e, f, g, h, k, l;
            return Q(function(m) {
                switch(m.g){
                    case 1:
                        return d = c.g, e = new CB, ra(m, 2, 3), F(m, e.init(), 5);
                    case 5:
                        return F(m, GB(e, d.Yb(), d.kb()), 6);
                    case 6:
                        return f = m.h, F(m, f.getManifests([
                            d.key()
                        ]), 7);
                    case 7:
                        g = m.h;
                        h = g[0];
                        k = h.sessionIds.includes(a);
                        l = h.expiration == void 0 || h.expiration > b;
                        if (!k || !l) {
                            m.B(3);
                            break;
                        }
                        return F(m, f.updateManifestExpiration(d.key(), b), 3);
                    case 3:
                        return va(m), F(m, e.destroy(), 10);
                    case 10:
                        xa(m, 0);
                        break;
                    case 2:
                        ua(m), m.B(3);
                }
            });
        };
        p.onInitialVariantChosen = function() {};
        p.banLocation = function() {};
        p.setMediaElement = function() {};
        Ci("application/x-offline-manifest", function() {
            return new dC;
        });
        function eC() {}
        function fC(a, b) {
            var c = XB(a);
            c && c.g == "manifest" ? (a = {
                uri: a,
                originalUri: a,
                data: new ArrayBuffer(0),
                headers: {
                    "content-type": "application/x-offline-manifest"
                },
                originalRequest: b
            }, a = Pg(a)) : a = c && c.g == "segment" ? gC(c.key(), c, b) : Ng(new U(2, 1, 9004, a));
            return a;
        }
        function gC(a, b, c) {
            var d = new CB;
            return Pg(void 0).bb(function() {
                return d.init();
            }).bb(function() {
                return GB(d, b.Yb(), b.kb());
            }).bb(function(e) {
                return e.getSegments([
                    b.key()
                ]);
            }).bb(function(e) {
                return {
                    uri: b,
                    data: e[0].data,
                    headers: {},
                    originalRequest: c
                };
            }).finally(function() {
                return d.destroy();
            });
        }
        S("shaka.offline.OfflineScheme", eC);
        eC.plugin = fC;
        Wg("offline", fC);
        function hC(a, b, c) {
            var d, e, f, g, h, k;
            return Q(function(l) {
                switch(l.g){
                    case 1:
                        d = [];
                        for(var m = [], n = u(c), q = n.next(); !q.done; q = n.next()){
                            q = q.value;
                            for(var r = !1, t = u(m), w = t.next(); !w.done; w = t.next())if (w = w.value, iC(w.info, q)) {
                                w.sessionIds.push(q.sessionId);
                                r = !0;
                                break;
                            }
                            r || m.push({
                                info: q,
                                sessionIds: [
                                    q.sessionId
                                ]
                            });
                        }
                        e = u(m);
                        f = e.next();
                    case 2:
                        if (f.done) {
                            l.B(4);
                            break;
                        }
                        g = f.value;
                        h = jC(a, b, g);
                        return F(l, h, 5);
                    case 5:
                        k = l.h;
                        d = d.concat(k);
                        f = e.next();
                        l.B(2);
                        break;
                    case 4:
                        return l.return(d);
                }
            });
        }
        function jC(a, b, c) {
            var d, e;
            return Q(function(f) {
                switch(f.g){
                    case 1:
                        return d = new Bh({
                            Dc: b,
                            onError: function() {},
                            Rf: function() {},
                            onExpirationUpdated: function() {},
                            onEvent: function() {}
                        }), ra(f, 2), d.configure(a), F(f, Jh(d, c.info.keySystem, c.info.licenseUri, c.info.serverCertificate, c.info.audioCapabilities, c.info.videoCapabilities), 4);
                    case 4:
                        ta(f, 3);
                        break;
                    case 2:
                        return ua(f), F(f, d.destroy(), 5);
                    case 5:
                        return f.return([]);
                    case 3:
                        return e = [], F(f, Promise.all(c.sessionIds.map(function(g) {
                            return Q(function(h) {
                                if (h.g == 1) return ra(h, 2), F(h, Vh(d, g), 4);
                                if (h.g != 2) return e.push(g), ta(h, 0);
                                ua(h);
                                H(h);
                            });
                        })), 6);
                    case 6:
                        return F(f, d.destroy(), 7);
                    case 7:
                        return f.return(e);
                }
            });
        }
        function iC(a, b) {
            function c(d, e) {
                return d.robustness == e.robustness && d.contentType == e.contentType;
            }
            return a.keySystem == b.keySystem && a.licenseUri == b.licenseUri && Rc(a.audioCapabilities, b.audioCapabilities, c) && Rc(a.videoCapabilities, b.videoCapabilities, c);
        }
        function kC(a, b, c) {
            var d = b.presentationTimeline.getDuration();
            b = lC(b);
            return {
                offlineUri: null,
                originalManifestUri: a,
                duration: d,
                size: 0,
                expiration: Infinity,
                tracks: b,
                appMetadata: c,
                isIncomplete: !1
            };
        }
        function mC(a, b) {
            var c = ZB(new YB(a.Yb(), a.kb()), b), d = b.appMetadata || {};
            c = lC(c);
            return {
                offlineUri: a.toString(),
                originalManifestUri: b.originalManifestUri,
                duration: b.duration,
                size: b.size,
                expiration: b.expiration,
                tracks: c,
                appMetadata: d,
                isIncomplete: b.isIncomplete || !1
            };
        }
        function lC(a) {
            var b = [], c = kg(a.variants);
            c = u(c);
            for(var d = c.next(); !d.done; d = c.next())b.push(bg(d.value));
            a = u(a.textStreams);
            for(c = a.next(); !c.done; c = a.next())b.push(cg(c.value));
            return b;
        }
        function nC() {
            this.g = new Map;
        }
        function oC(a, b) {
            var c = b.audio, d = b.video;
            c && !d && a.g.set(c.id, c.bandwidth || b.bandwidth);
            !c && d && a.g.set(d.id, d.bandwidth || b.bandwidth);
            if (c && d) {
                var e = c.bandwidth || 393216, f = d.bandwidth || b.bandwidth - e;
                f <= 0 && (f = b.bandwidth);
                a.g.set(c.id, e);
                a.g.set(d.id, f);
            }
        }
        function pC(a, b) {
            a.g.set(b.id, b.bandwidth || 2048);
        }
        function qC(a, b) {
            a = a.g.get(b);
            a == null && (a = 0);
            return a;
        }
        function rC(a) {
            var b = this;
            if (a && a.constructor != X) throw new U(2, 9, 9008);
            this.g = this.h = null;
            a ? (this.h = a.g, this.g = a.Vb()) : (this.h = Xn(), this.g = new Vg, this.g.configure(this.h.networking));
            this.i = [];
            this.l = [];
            var c = !a;
            this.j = new hh(function() {
                var d, e, f, g, h;
                return Q(function(k) {
                    switch(k.g){
                        case 1:
                            return F(k, Promise.all(b.l.map(function(l) {
                                return mB(l);
                            })), 2);
                        case 2:
                            d = function() {};
                            e = [];
                            f = u(b.i);
                            for(g = f.next(); !g.done; g = f.next())h = g.value, e.push(h.then(d, d));
                            return F(k, Promise.all(e), 3);
                        case 3:
                            if (!c) {
                                k.B(4);
                                break;
                            }
                            return F(k, b.g.destroy(), 4);
                        case 4:
                            b.h = null, b.g = null, H(k);
                    }
                });
            });
            this.m = 1E9;
        }
        function sC() {
            if (Fi(Rb())) a: {
                var a = u(DB.values());
                for(var b = a.next(); !b.done; b = a.next())if (b = b.value, b = b()) {
                    b.destroy();
                    a = !0;
                    break a;
                }
                a = !1;
            }
            else a = !1;
            return a;
        }
        p = rC.prototype;
        p.destroy = function() {
            return this.j.destroy();
        };
        p.configure = function(a, b) {
            arguments.length == 2 && typeof a == "string" && (a = An(a, b));
            return bo(this.h, a);
        };
        p.getConfiguration = function() {
            var a = Xn();
            bo(a, this.h, Xn());
            return a;
        };
        p.Vb = function() {
            return this.g;
        };
        p.store = function(a, b, c, d, e) {
            var f = this, g = this.getConfiguration(), h = new lB(this.g);
            this.l.push(h);
            b = tC(this, a, b || {}, d || [], e || [], function() {
                var k;
                return Q(function(l) {
                    if (l.g == 1) return c ? l.B(2) : F(l, Jo(a, f.g, g.manifest.retryParameters), 3);
                    l.g != 2 && (c = l.h);
                    k = Hi(a, c || null);
                    return l.return(k());
                });
            }, g, h);
            b = new Mg(b, function() {
                return mB(h);
            });
            b.finally(function() {
                Qc(f.l, h);
            });
            return uC(this, b);
        };
        function tC(a, b, c, d, e, f, g, h) {
            var k, l, m, n, q, r, t, w, v, z, y, A, C, E, D, B, G, I, J, L, K, N, P, O;
            return Q(function(M) {
                switch(M.g){
                    case 1:
                        return vC(), l = k = null, m = new CB, r = q = n = null, ra(M, 2, 3), F(M, f(), 5);
                    case 5:
                        return k = M.h, F(M, wC(a, b, k, g), 6);
                    case 6:
                        t = M.h;
                        xC(a);
                        w = !t.presentationTimeline.U() && !t.presentationTimeline.ld();
                        if (!w) throw new U(2, 9, 9005, b);
                        v = u(d);
                        z = v.next();
                    case 7:
                        if (z.done) {
                            M.B(9);
                            break;
                        }
                        y = z.value;
                        return F(M, yC(a, y, t), 10);
                    case 10:
                        A = M.h;
                        t.imageStreams.push(A);
                        xC(a);
                        z = v.next();
                        M.B(7);
                        break;
                    case 9:
                        C = u(e), E = C.next();
                    case 11:
                        if (E.done) return Lh(g.drm.clearKeys, t.variants), G = t.variants.some(function(R) {
                            if (R.audio) {
                                for(var W = u(R.audio.drmInfos), wa = W.next(); !wa.done; wa = W.next())if (wa.value.licenseServerUri.startsWith("data:")) return !0;
                            }
                            if (R.video) {
                                for(R = u(R.video.drmInfos), W = R.next(); !W.done; W = R.next())if (W.value.licenseServerUri.startsWith("data:")) return !0;
                            }
                            return !1;
                        }), I = g.offline.usePersistentLicense, G && (I = !1), F(M, a.Dd(t, function(R) {
                            r = r || R;
                        }, g, I), 15);
                        D = E.value;
                        return F(M, zC(a, t, D.uri, D.language, D.kind, D.mime, D.codecs), 14);
                    case 14:
                        B = M.h;
                        t.textStreams.push(B);
                        xC(a);
                        E = C.next();
                        M.B(11);
                        break;
                    case 15:
                        l = M.h;
                        xC(a);
                        if (r) throw r;
                        return F(M, AC(t, l, g, I), 16);
                    case 16:
                        return F(M, m.init(), 17);
                    case 17:
                        return xC(a), F(M, EB(m), 18);
                    case 18:
                        return n = M.h, xC(a), J = BC(l, t, b, c, g, h, I), L = J.Nl, K = J.ti, F(M, n.kb.addManifests([
                            L
                        ]), 19);
                    case 19:
                        N = M.h;
                        xC(a);
                        q = N[0];
                        xC(a);
                        if (r) throw r;
                        return F(M, CC(a, K, q, L, h, g, n.kb, t, l, I), 20);
                    case 20:
                        return xC(a), DC(t, L, l, I), F(M, n.kb.updateManifest(q, L), 21);
                    case 21:
                        return xC(a), P = new WB("manifest", n.path.Yb, n.path.kb, q), M.return(mC(P, L));
                    case 3:
                        return va(M), F(M, m.destroy(), 22);
                    case 22:
                        if (!k) {
                            M.B(23);
                            break;
                        }
                        return F(M, k.stop(), 23);
                    case 23:
                        if (!l) {
                            M.B(25);
                            break;
                        }
                        return F(M, l.destroy(), 25);
                    case 25:
                        xa(M, 0);
                        break;
                    case 2:
                        O = ua(M);
                        if (q == null) {
                            M.B(27);
                            break;
                        }
                        return F(M, EC(q), 27);
                    case 27:
                        throw r || O;
                }
            });
        }
        function CC(a, b, c, d, e, f, g, h, k, l) {
            var m, n, q, r, t, w, v, z, y, A, C;
            return Q(function(E) {
                switch(E.g){
                    case 1:
                        m = {};
                        n = 0;
                        q = function() {
                            if (a.j.g || e.l) throw new U(2, 9, 7001);
                        };
                        r = function(D, B) {
                            var G, I, J, L, K, N, P, O, M;
                            return Q(function(R) {
                                if (R.g == 1) {
                                    G = u(D);
                                    I = G.next();
                                    for(J = {}; !I.done; J = {
                                        xc: void 0
                                    }, I = G.next())J.xc = I.value, q(), L = hB(J.xc, f), K = J.xc.i, N = J.xc.h, P = function(W) {
                                        return function(wa) {
                                            var Y, Ka, Na, La;
                                            return Q(function(Ea) {
                                                switch(Ea.g){
                                                    case 1:
                                                        Y = W.xc.g;
                                                        Ka = Y.hc(!1);
                                                        if (!Y.aesKey || Ka) {
                                                            Ea.B(2);
                                                            break;
                                                        }
                                                        return F(Ea, Gm(wa, Y.aesKey, W.xc.j), 3);
                                                    case 3:
                                                        wa = Ea.h;
                                                    case 2:
                                                        return Na = gB(Y), F(Ea, g.addSegments([
                                                            {
                                                                data: wa
                                                            }
                                                        ]), 4);
                                                    case 4:
                                                        La = Ea.h, q(), m[Na] = La[0], n += wa.byteLength, H(Ea);
                                                }
                                            });
                                        };
                                    }(J), O = J.xc.g, (M = O.hc(!1)) ? pB(e, J.xc.groupId, M, K, N, P) : e.queue(J.xc.groupId, L, K, N, P);
                                    return F(R, qB(e), 2);
                                }
                                q();
                                if (!B || e.l) return R.B(0);
                                DC(h, d, k, l);
                                return F(R, g.updateManifest(c, d), 0);
                            });
                        };
                        t = !1;
                        ra(E, 2);
                        if (!FC(h) || !t || GC(h)) {
                            E.B(4);
                            break;
                        }
                        return F(E, r(b.filter(function(D) {
                            return D.h;
                        }), !0), 5);
                    case 5:
                        return q(), b = b.filter(function(D) {
                            return !D.h;
                        }), w = m, v = n, m = {}, n = 0, F(E, HC(g, c, d, w, v, function() {
                            return xC(a);
                        }), 6);
                    case 6:
                        q();
                    case 4:
                        if (t) {
                            E.B(7);
                            break;
                        }
                        return F(E, r(b, !1), 8);
                    case 8:
                        return q(), z = m, y = n, m = {}, n = 0, F(E, HC(g, c, d, z, y, function() {
                            return q();
                        }), 9);
                    case 9:
                        q();
                    case 7:
                        ta(E, 0);
                        break;
                    case 2:
                        return A = ua(E), C = Object.values(m), F(E, g.removeSegments(C, function() {}), 10);
                    case 10:
                        throw A;
                }
            });
        }
        function EC(a) {
            var b, c, d, e;
            return Q(function(f) {
                switch(f.g){
                    case 1:
                        return b = new CB, F(f, b.init(), 2);
                    case 2:
                        return F(f, EB(b), 3);
                    case 3:
                        return c = f.h, d = new WB("manifest", c.path.Yb, c.path.kb, a), F(f, b.destroy(), 4);
                    case 4:
                        return e = new rC, F(f, e.remove(d.toString()), 0);
                }
            });
        }
        function HC(a, b, c, d, e, f) {
            var g, h, k, l, m, n, q, r, t, w, v;
            return Q(function(z) {
                switch(z.g){
                    case 1:
                        g = !1;
                        ra(z, 2);
                        h = !0;
                        k = u(c.streams);
                        for(l = k.next(); !l.done; l = k.next())for(m = l.value, n = u(m.segments), q = n.next(); !q.done; q = n.next())r = q.value, t = r.pendingSegmentRefId ? d[r.pendingSegmentRefId] : null, t != null && (r.dataKey = t, r.pendingSegmentRefId = void 0), t = r.pendingInitSegmentRefId ? d[r.pendingInitSegmentRefId] : null, t != null && (r.initSegmentKey = t, r.pendingInitSegmentRefId = void 0), r.pendingSegmentRefId && (h = !1), r.pendingInitSegmentRefId && (h = !1);
                        c.size += e;
                        h && (c.isIncomplete = !1);
                        return F(z, a.updateManifest(b, c), 4);
                    case 4:
                        g = !0;
                        f();
                        ta(z, 0);
                        break;
                    case 2:
                        return w = ua(z), F(z, EC(b), 5);
                    case 5:
                        if (g) {
                            z.B(6);
                            break;
                        }
                        v = Object.values(d);
                        return F(z, a.removeSegments(v, function() {}), 6);
                    case 6:
                        throw w;
                }
            });
        }
        function AC(a, b, c, d) {
            var e, f, g, h, k, l, m, n, q, r, t, w, v, z, y, A, C, E, D, B, G, I, J, L, K, N, P, O, M, R;
            return Q(function(W) {
                switch(W.g){
                    case 1:
                        return e = {
                            width: Infinity,
                            height: Infinity
                        }, Jf(a, c.restrictions, e), F(W, Mf(b, a, d, c.drm.preferredKeySystems, c.drm.keySystemsMapping), 2);
                    case 2:
                        f = [];
                        g = c.preferredDecodingAttributes;
                        h = c.preferredVideoCodecs;
                        k = c.preferredAudioCodecs;
                        l = c.preferredTextFormats;
                        Hf(a, h, k, g, l);
                        m = u(a.variants);
                        for(n = m.next(); !n.done; n = m.next())q = n.value, f.push(bg(q));
                        r = u(a.textStreams);
                        for(t = r.next(); !t.done; t = r.next())w = t.value, f.push(cg(w));
                        v = u(a.imageStreams);
                        for(z = v.next(); !z.done; z = v.next())y = z.value, f.push(dg(y));
                        return F(W, c.offline.trackSelectionCallback(f), 3);
                    case 3:
                        A = W.h;
                        C = a.presentationTimeline.getDuration();
                        E = 0;
                        D = u(A);
                        for(B = D.next(); !B.done; B = D.next())G = B.value, I = G.bandwidth * C / 8, E += I;
                        ra(W, 4);
                        return F(W, c.offline.downloadSizeCallback(E), 6);
                    case 6:
                        J = W.h;
                        if (!J) throw new U(2, 9, 9014);
                        ta(W, 5);
                        break;
                    case 4:
                        L = ua(W);
                        if (L instanceof U) throw L;
                        throw new U(2, 9, 9015);
                    case 5:
                        K = new Set;
                        N = new Set;
                        P = new Set;
                        O = u(A);
                        for(M = O.next(); !M.done; M = O.next())R = M.value, R.type == "variant" && K.add(R.id), R.type == "text" && N.add(R.id), R.type == "image" && P.add(R.id);
                        a.variants = a.variants.filter(function(wa) {
                            return K.has(wa.id);
                        });
                        a.textStreams = a.textStreams.filter(function(wa) {
                            return N.has(wa.id);
                        });
                        a.imageStreams = a.imageStreams.filter(function(wa) {
                            return P.has(wa.id);
                        });
                        IC(a);
                        H(W);
                }
            });
        }
        function BC(a, b, c, d, e, f, g) {
            var h = kC(c, b, d), k = e.offline.progressCallback;
            nB(f, function(t, w) {
                h.size = w;
                k(h, t);
            }, function(t, w) {
                l && g && m == w && Rh(a, "cenc", t);
            });
            var l = FC(b) && !GC(b), m = null;
            l && (m = JC.get(a.g.keySystem));
            for(var n = new nC, q = u(b.textStreams), r = q.next(); !r.done; r = q.next())n.g.set(r.value.id, 52);
            q = u(b.imageStreams);
            for(r = q.next(); !r.done; r = q.next())pC(n, r.value);
            q = u(b.variants);
            for(r = q.next(); !r.done; r = q.next())oC(n, r.value);
            f = KC(f, n, b, e);
            e = f.streams;
            f = f.ti;
            (n = a.g) && g && (n.initData = []);
            return {
                Nl: {
                    creationTime: Date.now(),
                    originalManifestUri: c,
                    duration: b.presentationTimeline.getDuration(),
                    size: 0,
                    expiration: a.me(),
                    streams: e,
                    sessionIds: g ? $h(a) : [],
                    drmInfo: n,
                    appMetadata: d,
                    isIncomplete: !0,
                    sequenceMode: b.sequenceMode,
                    type: b.type
                },
                ti: f
            };
        }
        function FC(a) {
            return a.variants.some(function(b) {
                var c = b.audio && b.audio.encrypted;
                return b.video && b.video.encrypted || c;
            });
        }
        function GC(a) {
            return a.variants.some(function(b) {
                return (b.video ? b.video.drmInfos : []).concat(b.audio ? b.audio.drmInfos : []).some(function(c) {
                    return c.initData && c.initData.length;
                });
            });
        }
        function DC(a, b, c, d) {
            b.expiration = c.me();
            c = $h(c);
            b.sessionIds = d ? c : [];
            if (FC(a) && d && !c.length) throw new U(2, 9, 9007);
        }
        p.remove = function(a) {
            return LC(this, MC(this, a));
        };
        function MC(a, b) {
            var c, d, e, f, g, h;
            return Q(function(k) {
                switch(k.g){
                    case 1:
                        vC();
                        c = XB(b);
                        if (c == null || c.g != "manifest") throw new U(2, 9, 9004, b);
                        d = c;
                        e = new CB;
                        sa(k, 2);
                        return F(k, e.init(), 4);
                    case 4:
                        return F(k, GB(e, d.Yb(), d.kb()), 5);
                    case 5:
                        return f = k.h, F(k, f.getManifests([
                            d.key()
                        ]), 6);
                    case 6:
                        return g = k.h, h = g[0], F(k, Promise.all([
                            NC(a, h, e),
                            OC(f, d, h)
                        ]), 2);
                    case 2:
                        return va(k), F(k, e.destroy(), 8);
                    case 8:
                        xa(k, 0);
                }
            });
        }
        function PC(a, b) {
            for(var c = [], d = u(a.streams), e = d.next(); !e.done; e = d.next())e = e.value, b && e.type == "video" ? c.push({
                contentType: df(e.mimeType, e.codecs),
                robustness: a.drmInfo.videoRobustness
            }) : b || e.type != "audio" || c.push({
                contentType: df(e.mimeType, e.codecs),
                robustness: a.drmInfo.audioRobustness
            });
            return c;
        }
        function NC(a, b, c) {
            return Q(function(d) {
                return F(d, QC(a.g, a.h.drm, c, b), 0);
            });
        }
        function OC(a, b, c) {
            function d() {}
            var e = RC(c);
            mC(b, c);
            return Promise.all([
                a.removeSegments(e, d),
                a.removeManifests([
                    b.key()
                ], d)
            ]);
        }
        p.hm = function() {
            return LC(this, SC(this));
        };
        function SC(a) {
            var b, c, d, e, f, g, h, k, l, m;
            return Q(function(n) {
                switch(n.g){
                    case 1:
                        return vC(), b = a.g, c = a.h.drm, d = new CB, e = !1, sa(n, 2), F(n, d.init(), 4);
                    case 4:
                        f = [], HB(d, function(q) {
                            return f.push(q);
                        }), g = u(f), h = g.next();
                    case 5:
                        if (h.done) {
                            n.B(2);
                            break;
                        }
                        k = h.value;
                        return F(n, k.getAll(), 8);
                    case 8:
                        return l = n.h, F(n, hC(c, b, l), 9);
                    case 9:
                        return m = n.h, F(n, k.remove(m), 10);
                    case 10:
                        m.length != l.length && (e = !0);
                        h = g.next();
                        n.B(5);
                        break;
                    case 2:
                        return va(n), F(n, d.destroy(), 11);
                    case 11:
                        xa(n, 3);
                        break;
                    case 3:
                        return n.return(!e);
                }
            });
        }
        p.list = function() {
            return LC(this, TC());
        };
        function TC() {
            var a, b, c;
            return Q(function(d) {
                switch(d.g){
                    case 1:
                        return vC(), a = [], b = new CB, sa(d, 2), F(d, b.init(), 4);
                    case 4:
                        return c = Promise.resolve(), FB(b, function(e, f) {
                            c = c.then(function() {
                                var g;
                                return Q(function(h) {
                                    if (h.g == 1) return F(h, f.getAllManifests(), 2);
                                    g = h.h;
                                    g.forEach(function(k, l) {
                                        k = mC(new WB("manifest", e.Yb, e.kb, l), k);
                                        a.push(k);
                                    });
                                    H(h);
                                });
                            });
                        }), F(d, c, 2);
                    case 2:
                        return va(d), F(d, b.destroy(), 6);
                    case 6:
                        xa(d, 3);
                        break;
                    case 3:
                        return d.return(a);
                }
            });
        }
        function wC(a, b, c, d) {
            var e, f, g, h, k;
            return Q(function(l) {
                if (l.g == 1) return e = null, f = a.g, g = {
                    networkingEngine: f,
                    filter: function() {
                        return Promise.resolve();
                    },
                    makeTextStreamsForClosedCaptions: function() {},
                    onTimelineRegionAdded: function() {},
                    onEvent: function() {},
                    onError: function(m) {
                        e = m;
                    },
                    isLowLatencyMode: function() {
                        return !1;
                    },
                    updateDuration: function() {},
                    newDrmInfo: function() {},
                    onManifestUpdated: function() {},
                    getBandwidthEstimate: function() {
                        return d.abr.defaultBandwidthEstimate;
                    },
                    onMetadata: function() {},
                    disableStream: function() {},
                    addFont: function() {}
                }, c.configure(d.manifest), xC(a), F(l, c.start(b, g), 2);
                if (l.g != 3) return h = l.h, xC(a), k = UC(h), F(l, Promise.all(lb(k, function(m) {
                    return m.createSegmentIndex();
                })), 3);
                xC(a);
                if (e) throw e;
                return l.return(h);
            });
        }
        function yC(a, b, c) {
            var d, e, f, g, h, k, l, m, n, q, r, t, w, v, z;
            return Q(function(y) {
                switch(y.g){
                    case 1:
                        return F(y, VC(a, b), 2);
                    case 2:
                        d = y.h;
                        if (d != "text/vtt") throw new U(1, 2, 2017, b);
                        return F(y, WC(b, a.g, a.h.streaming.retryParameters), 3);
                    case 3:
                        e = y.h;
                        f = sf(d);
                        if (!f) throw new U(2, 2, 2014, d);
                        g = f();
                        h = {
                            periodStart: 0,
                            segmentStart: 0,
                            segmentEnd: c.presentationTimeline.getDuration(),
                            vttOffset: 0
                        };
                        k = Kb(e);
                        l = g.parseMedia(k, h, b, []);
                        m = [];
                        n = u(l);
                        q = n.next();
                        for(r = {}; !q.done; r = {
                            vg: void 0,
                            Fd: void 0
                        }, q = n.next())r.Fd = q.value, r.vg = null, t = function(A) {
                            return function() {
                                A.vg == null && (A.vg = mc([
                                    b
                                ], [
                                    A.Fd.payload
                                ]));
                                return A.vg || [];
                            };
                        }(r), w = new yj(r.Fd.startTime, r.Fd.endTime, t, 0, null, null, 0, 0, Infinity), r.Fd.payload.includes("#xywh") && (v = r.Fd.payload.split("#xywh=")[1].split(","), v.length === 4 && w.jg({
                            height: parseInt(v[3], 10),
                            positionX: parseInt(v[0], 10),
                            positionY: parseInt(v[1], 10),
                            width: parseInt(v[2], 10)
                        })), m.push(w);
                        z = d;
                        if (!m.length) {
                            y.B(4);
                            break;
                        }
                        return F(y, Jo(m[0].T()[0], a.g, a.h.manifest.retryParameters), 5);
                    case 5:
                        z = y.h;
                    case 4:
                        return y.return({
                            id: a.m++,
                            originalId: null,
                            groupId: null,
                            createSegmentIndex: function() {
                                return Promise.resolve();
                            },
                            segmentIndex: new Xl(m),
                            mimeType: z || "",
                            codecs: "",
                            kind: "",
                            encrypted: !1,
                            drmInfos: [],
                            keyIds: new Set,
                            language: "und",
                            originalLanguage: null,
                            label: null,
                            type: "image",
                            primary: !1,
                            trickModeVideo: null,
                            dependencyStream: null,
                            emsgSchemeIdUris: null,
                            roles: [],
                            forced: !1,
                            channelsCount: null,
                            audioSamplingRate: null,
                            spatialAudio: !1,
                            closedCaptions: null,
                            tilesLayout: "1x1",
                            accessibilityPurpose: null,
                            external: !0,
                            fastSwitching: !1,
                            fullMimeTypes: new Set([
                                df(z || "", "")
                            ]),
                            isAudioMuxedInVideo: !1,
                            baseOriginalId: null
                        });
                }
            });
        }
        function zC(a, b, c, d, e, f, g) {
            var h, k, l;
            return Q(function(m) {
                if (m.g == 1) return f ? m.B(2) : F(m, VC(a, c), 3);
                m.g != 2 && (f = m.h);
                h = {
                    id: a.m++,
                    originalId: null,
                    groupId: null,
                    createSegmentIndex: function() {
                        return Promise.resolve();
                    },
                    segmentIndex: Zl(0, b.presentationTimeline.getDuration(), [
                        c
                    ]),
                    mimeType: f || "",
                    codecs: g || "",
                    kind: e,
                    encrypted: !1,
                    drmInfos: [],
                    keyIds: new Set,
                    language: d,
                    originalLanguage: d,
                    label: null,
                    type: sc,
                    primary: !1,
                    trickModeVideo: null,
                    dependencyStream: null,
                    emsgSchemeIdUris: null,
                    roles: [],
                    forced: !1,
                    channelsCount: null,
                    audioSamplingRate: null,
                    spatialAudio: !1,
                    closedCaptions: null,
                    accessibilityPurpose: null,
                    external: !0,
                    fastSwitching: !1,
                    fullMimeTypes: new Set([
                        df(f || "", g || "")
                    ]),
                    isAudioMuxedInVideo: !1,
                    baseOriginalId: null
                };
                k = df(h.mimeType, h.codecs);
                l = tf(k);
                if (!l) throw new U(2, 2, 2014, f);
                return m.return(h);
            });
        }
        function VC(a, b) {
            var c;
            return Q(function(d) {
                switch(d.g){
                    case 1:
                        return ra(d, 2), F(d, Jo(b, a.g, a.h.streaming.retryParameters), 4);
                    case 4:
                        c = d.h;
                        ta(d, 3);
                        break;
                    case 2:
                        ua(d);
                    case 3:
                        if (c) return d.return(c);
                        throw new U(1, 2, 2011, b);
                }
            });
        }
        function WC(a, b, c) {
            var d, e, f;
            return Q(function(g) {
                if (g.g == 1) return d = fh, e = $g([
                    a
                ], c), e.method = "GET", F(g, b.request(d, e).promise, 2);
                f = g.h;
                return g.return(f.data);
            });
        }
        p.Dd = function(a, b, c, d) {
            var e = this, f;
            return Q(function(g) {
                return g.g == 1 ? (f = new Bh({
                    Dc: e.g,
                    onError: b,
                    Rf: function() {},
                    onExpirationUpdated: function() {},
                    onEvent: function() {}
                }), f.configure(c.drm), F(g, Gh(f, a.variants, d), 2)) : g.g != 3 ? F(g, Th(f), 3) : g.return(f);
            });
        };
        function KC(a, b, c, d) {
            var e = new Map, f = UC(c), g = new Map;
            f = u(f);
            for(var h = f.next(); !h.done; h = f.next()){
                h = h.value;
                var k = XC(a, b, c, h, d, e);
                g.set(h.id, k);
            }
            a = u(c.variants);
            for(b = a.next(); !b.done; b = a.next())b = b.value, b.audio && g.get(b.audio.id).variantIds.push(b.id), b.video && g.get(b.video.id).variantIds.push(b.id);
            return {
                streams: Array.from(g.values()),
                ti: Array.from(e.values())
            };
        }
        function XC(a, b, c, d, e, f) {
            var g = {
                id: d.id,
                originalId: d.originalId,
                groupId: d.groupId,
                primary: d.primary,
                type: d.type,
                mimeType: d.mimeType,
                codecs: d.codecs,
                frameRate: d.frameRate,
                pixelAspectRatio: d.pixelAspectRatio,
                hdr: d.hdr,
                colorGamut: d.colorGamut,
                videoLayout: d.videoLayout,
                kind: d.kind,
                language: d.language,
                originalLanguage: d.originalLanguage,
                label: d.label,
                width: d.width || null,
                height: d.height || null,
                encrypted: d.encrypted,
                keyIds: d.keyIds,
                segments: [],
                variantIds: [],
                roles: d.roles,
                forced: d.forced,
                channelsCount: d.channelsCount,
                audioSamplingRate: d.audioSamplingRate,
                spatialAudio: d.spatialAudio,
                closedCaptions: d.closedCaptions,
                tilesLayout: d.tilesLayout,
                mssPrivateData: d.mssPrivateData,
                external: d.external,
                fastSwitching: d.fastSwitching,
                isAudioMuxedInVideo: d.isAudioMuxedInVideo
            }, h = e.offline.numberOfParallelDownloads, k = h === 0 ? d.id : 0;
            YC(d, c.presentationTimeline.Nb(), function(l, m) {
                var n = gB(l), q = void 0;
                if (!f.has(n)) {
                    var r = l.endTime - l.startTime;
                    r = qC(b, d.id) * r;
                    r = jB(a.g, r);
                    f.set(n, new fB(l, r, k, !1, m));
                }
                l.ia && (q = gB(l.ia), f.has(q) || (r = qC(b, d.id) * .5, r = jB(a.g, r), f.set(q, new fB(l.ia, r, k, !0, m))));
                g.segments.push({
                    pendingInitSegmentRefId: q,
                    initSegmentKey: q ? 0 : null,
                    startTime: l.startTime,
                    endTime: l.endTime,
                    appendWindowStart: l.appendWindowStart,
                    appendWindowEnd: l.appendWindowEnd,
                    timestampOffset: l.timestampOffset,
                    tilesLayout: l.tilesLayout,
                    pendingSegmentRefId: n,
                    dataKey: 0,
                    mimeType: l.mimeType,
                    codecs: l.codecs,
                    thumbnailSprite: l.thumbnailSprite
                });
                h !== 0 && (k = (k + 1) % h);
            });
            return g;
        }
        function YC(a, b, c) {
            b = a.segmentIndex.find(b);
            if (b != null) for(var d = a.segmentIndex.get(b); d;)c(d, b), d = a.segmentIndex.get(++b);
        }
        function xC(a) {
            if (a.j.g) throw new U(2, 9, 7001);
        }
        function vC() {
            if (!sC()) throw new U(2, 9, 9E3);
        }
        function LC(a, b) {
            return Q(function(c) {
                if (c.g == 1) return a.i.push(b), sa(c, 2), F(c, b, 4);
                if (c.g != 2) return c.return(c.h);
                va(c);
                Qc(a.i, b);
                return xa(c, 0);
            });
        }
        function uC(a, b) {
            var c = b.promise;
            a.i.push(c);
            return b.finally(function() {
                Qc(a.i, c);
            });
        }
        function RC(a) {
            var b = new Set;
            a = u(a.streams);
            for(var c = a.next(); !c.done; c = a.next()){
                c = u(c.value.segments);
                for(var d = c.next(); !d.done; d = c.next())d = d.value, d.initSegmentKey != null && b.add(d.initSegmentKey), b.add(d.dataKey);
            }
            return Array.from(b);
        }
        function QC(a, b, c, d) {
            var e, f, g;
            return Q(function(h) {
                if (h.g == 1) {
                    if (!d.drmInfo) return h.return();
                    e = IB(c);
                    f = d.sessionIds.map(function(k) {
                        return {
                            sessionId: k,
                            keySystem: d.drmInfo.keySystem,
                            licenseUri: d.drmInfo.licenseServerUri,
                            serverCertificate: d.drmInfo.serverCertificate,
                            audioCapabilities: PC(d, !1),
                            videoCapabilities: PC(d, !0)
                        };
                    });
                    return F(h, hC(b, a, f), 2);
                }
                return h.g != 3 ? (g = h.h, F(h, e.remove(g), 3)) : F(h, e.add(f.filter(function(k) {
                    return !g.includes(k.sessionId);
                })), 0);
            });
        }
        function UC(a) {
            for(var b = new Set, c = u(a.variants), d = c.next(); !d.done; d = c.next())d = d.value, d.audio && b.add(d.audio), d.video && b.add(d.video);
            c = u(a.textStreams);
            for(d = c.next(); !d.done; d = c.next())b.add(d.value);
            a = u(a.imageStreams);
            for(c = a.next(); !c.done; c = a.next())b.add(c.value);
            return b;
        }
        function IC(a) {
            a.variants.map(function(f) {
                return f.video;
            });
            var b = new Set(a.variants.map(function(f) {
                return f.audio;
            }));
            a = a.textStreams;
            for(var c = u(b), d = c.next(); !d.done; d = c.next()){
                d = u(b);
                for(var e = d.next(); !e.done; e = d.next());
            }
            b = u(a);
            for(c = b.next(); !c.done; c = b.next())for(c = u(a), d = c.next(); !d.done; d = c.next());
        }
        S("shaka.offline.Storage", rC);
        rC.deleteAll = function() {
            var a;
            return Q(function(b) {
                return b.g == 1 ? (a = new CB, sa(b, 2), F(b, JB(a), 2)) : b.g != 5 ? (va(b), F(b, a.destroy(), 5)) : xa(b, 0);
            });
        };
        rC.prototype.list = rC.prototype.list;
        rC.prototype.removeEmeSessions = rC.prototype.hm;
        rC.prototype.remove = rC.prototype.remove;
        rC.prototype.store = rC.prototype.store;
        rC.prototype.getNetworkingEngine = rC.prototype.Vb;
        rC.prototype.getConfiguration = rC.prototype.getConfiguration;
        rC.prototype.configure = rC.prototype.configure;
        rC.prototype.destroy = rC.prototype.destroy;
        rC.support = sC;
        var JC = (new Map).set("org.w3.clearkey", "1077efecc0b24d02ace33c1e52e2fb4b").set("com.widevine.alpha", "edef8ba979d64acea3c827dcd51d21ed").set("com.microsoft.playready", "9a04f07998404286ab92e65be0885f95").set("com.microsoft.playready.recommendation", "9a04f07998404286ab92e65be0885f95").set("com.microsoft.playready.software", "9a04f07998404286ab92e65be0885f95").set("com.microsoft.playready.hardware", "9a04f07998404286ab92e65be0885f95").set("com.huawei.wiseplay", "3d5e6d359b9a41e8b843dd3c6e72c42c");
        Uq("offline", sC);
        function ZC() {}
        function $C() {
            for(var a = u(aD), b = a.next(); !b.done; b = a.next()){
                b = b.value;
                try {
                    b.callback();
                } catch (c) {
                    ab("Error installing polyfill!", c);
                }
            }
        }
        function bD(a, b) {
            a = {
                priority: b || 0,
                callback: a
            };
            for(b = 0; b < aD.length; b++)if (aD[b].priority < a.priority) {
                aD.splice(b, 0, a);
                return;
            }
            aD.push(a);
        }
        S("shaka.polyfill", ZC);
        ZC.register = bD;
        ZC.installAll = $C;
        var aD = [];
        function cD() {}
        function dD() {
            if (!Object.getOwnPropertyDescriptor(Element.prototype, "ariaHidden")) for(var a = u([
                "ariaHidden",
                "ariaLabel",
                "ariaPressed",
                "ariaSelected"
            ]), b = a.next(); !b.done; b = a.next())eD(b.value);
        }
        function eD(a) {
            var b = "aria-" + a.toLowerCase().replace(/^aria/, "");
            Object.defineProperty(Element.prototype, a, {
                get: function() {
                    return this.getAttribute(b);
                },
                set: function(c) {
                    c == null || c == void 0 ? this.removeAttribute(b) : this.setAttribute(b, c);
                }
            });
        }
        ZC.Aria = cD;
        cD.install = dD;
        bD(dD);
        function fD(a, b, c) {
            this.g = a;
            this.i = b || null;
            this.h = c || null;
            this.keySystem = a.keySystem;
        }
        fD.prototype.getConfiguration = function() {
            var a = this.g.getConfiguration();
            if (a.videoCapabilities) for(var b = u(a.videoCapabilities), c = b.next(); !c.done; c = b.next())c.value.encryptionScheme = this.i;
            if (a.audioCapabilities) for(b = u(a.audioCapabilities), c = b.next(); !c.done; c = b.next())c.value.encryptionScheme = this.h;
            return a;
        };
        fD.prototype.createMediaKeys = function() {
            return this.g.createMediaKeys();
        };
        function gD(a) {
            if (a.startsWith("com.apple")) return "cbcs";
            if (a.startsWith("com.widevine") || a.startsWith("com.microsoft") || a.startsWith("com.chromecast") || a.startsWith("org.w3") || a.startsWith("com.huawei")) return "cenc";
            ab("EmeEncryptionSchemePolyfill: Unknown key system:", a, "Please contribute!");
            return null;
        }
        function hD(a) {
            if (!a) return !1;
            a = a.getConfiguration();
            var b = a.audioCapabilities && a.audioCapabilities[0];
            return (a = a.videoCapabilities && a.videoCapabilities[0] || b) && a.encryptionScheme !== void 0 ? !0 : !1;
        }
        function iD(a, b) {
            return !a || a == b || (a == "cbcs" || a == "cbcs-1-9") && Rb().ud() ? !0 : !1;
        }
        function jD() {}
        var kD;
        function lD() {
            Rb().mg() && !kD && !navigator.emeEncryptionSchemePolyfilled && navigator.requestMediaKeySystemAccess && MediaKeySystemAccess.prototype.getConfiguration && (kD = navigator.requestMediaKeySystemAccess, navigator.requestMediaKeySystemAccess = mD, navigator.emeEncryptionSchemePolyfilled = !0);
        }
        function mD(a, b) {
            var c = this, d, e;
            return Q(function(f) {
                if (f.g == 1) return F(f, kD.call(c, a, b), 2);
                d = f.h;
                if (e = hD(d)) return navigator.requestMediaKeySystemAccess = kD, f.return(d);
                navigator.requestMediaKeySystemAccess = nD;
                return f.return(nD.call(c, a, b));
            });
        }
        function nD(a, b) {
            var c = this, d, e, f, g, h, k, l, m, n, q, r, t;
            return Q(function(w) {
                if (w.g == 1) {
                    d = gD(a);
                    e = [];
                    f = u(b);
                    for(g = f.next(); !g.done; g = f.next())h = g.value, k = oD(h.videoCapabilities, d), l = oD(h.audioCapabilities, d), h.videoCapabilities && h.videoCapabilities.length && !k.length || h.audioCapabilities && h.audioCapabilities.length && !l.length || (m = Object.assign({}, h), m.videoCapabilities = k, m.audioCapabilities = l, e.push(m));
                    if (!e.length) throw n = Error("Unsupported keySystem or supportedConfigurations."), n.name = "NotSupportedError", n.code = DOMException.NOT_SUPPORTED_ERR, n;
                    return F(w, kD.call(c, a, e), 2);
                }
                q = w.h;
                t = r = null;
                e[0] && (e[0].videoCapabilities && (r = e[0].videoCapabilities[0].encryptionScheme), e[0].audioCapabilities && (t = e[0].audioCapabilities[0].encryptionScheme));
                return w.return(new fD(q, r, t));
            });
        }
        function oD(a, b) {
            return a ? a.filter(function(c) {
                return iD(c.encryptionScheme, b);
            }) : a;
        }
        ZC.EmeEncryptionScheme = jD;
        jD.install = lD;
        bD(lD);
        function pD() {}
        function qD() {
            if (window1.Document) {
                var a = Element.prototype;
                a.requestFullscreen = a.requestFullscreen || a.mozRequestFullScreen || a.msRequestFullscreen || a.webkitRequestFullscreen;
                a = Document.prototype;
                a.exitFullscreen = a.exitFullscreen || a.mozCancelFullScreen || a.msExitFullscreen || a.webkitCancelFullScreen;
                "fullscreenElement" in document || (Object.defineProperty(document, "fullscreenElement", {
                    get: function() {
                        return document.mozFullScreenElement || document.msFullscreenElement || document.webkitCurrentFullScreenElement || document.webkitFullscreenElement;
                    }
                }), Object.defineProperty(document, "fullscreenEnabled", {
                    get: function() {
                        return document.mozFullScreenEnabled || document.msFullscreenEnabled || document.webkitFullscreenEnabled;
                    }
                }));
                document.addEventListener("webkitfullscreenchange", rD);
                document.addEventListener("webkitfullscreenerror", rD);
                document.addEventListener("mozfullscreenchange", rD);
                document.addEventListener("mozfullscreenerror", rD);
                document.addEventListener("MSFullscreenChange", rD);
                document.addEventListener("MSFullscreenError", rD);
            }
        }
        function rD(a) {
            var b = a.type.replace(/^(webkit|moz|MS)/, "").toLowerCase(), c = document.createEvent("Event");
            c.initEvent(b, a.bubbles, a.cancelable);
            a.target.dispatchEvent(c);
        }
        ZC.Fullscreen = pD;
        pD.install = qD;
        bD(qD);
        function sD() {}
        var tD;
        function uD() {
            Rb().mg() && !tD && !navigator.mediaCapabilitiesEncryptionSchemePolyfilled && navigator.mediaCapabilities && (tD = navigator.mediaCapabilities.decodingInfo, navigator.mediaCapabilities.decodingInfo = vD, navigator.mediaCapabilitiesEncryptionSchemePolyfilled = !0);
        }
        function vD(a) {
            var b = this, c, d, e;
            return Q(function(f) {
                switch(f.g){
                    case 1:
                        return F(f, tD.call(b, a), 2);
                    case 2:
                        c = f.h;
                        if (!c.supported || !a.keySystemConfiguration) return f.return(c);
                        d = c.keySystemAccess;
                        if (e = hD(d)) return navigator.mediaCapabilities.decodingInfo = tD, f.return(c);
                        navigator.mediaCapabilities.decodingInfo = wD;
                        if (d) {
                            f.B(3);
                            break;
                        }
                        return F(f, xD(a), 4);
                    case 4:
                        return c.keySystemAccess = f.h, f.return(c);
                    case 3:
                        return f.return(wD.call(b, a));
                }
            });
        }
        function wD(a) {
            var b = this, c, d, e, f, g, h, k;
            return Q(function(l) {
                switch(l.g){
                    case 1:
                        return d = c = null, !a.keySystemConfiguration || (e = a.keySystemConfiguration, f = e.keySystem, d = e.audio && e.audio.encryptionScheme, c = e.video && e.video.encryptionScheme, g = gD(f), h = {
                            powerEfficient: !1,
                            smooth: !1,
                            supported: !1,
                            keySystemAccess: null,
                            configuration: a
                        }, iD(d, g) && iD(c, g)) ? F(l, tD.call(b, a), 2) : l.return(h);
                    case 2:
                        k = l.h;
                        if (k.keySystemAccess) {
                            k.keySystemAccess = new fD(k.keySystemAccess, c, d);
                            l.B(3);
                            break;
                        }
                        if (!a.keySystemConfiguration) {
                            l.B(3);
                            break;
                        }
                        return F(l, xD(a), 5);
                    case 5:
                        k.keySystemAccess = l.h;
                    case 3:
                        return l.return(k);
                }
            });
        }
        function xD(a) {
            var b, c;
            return Q(function(d) {
                if (d.g == 1) {
                    var e = a.keySystemConfiguration, f = [], g = [];
                    e.audio && f.push({
                        robustness: e.audio.robustness || "",
                        contentType: a.audio.contentType,
                        encryptionScheme: e.audio.encryptionScheme
                    });
                    e.video && g.push({
                        robustness: e.video.robustness || "",
                        contentType: a.video.contentType,
                        encryptionScheme: e.video.encryptionScheme
                    });
                    e = {
                        initDataTypes: e.initDataType ? [
                            e.initDataType
                        ] : [],
                        distinctiveIdentifier: e.distinctiveIdentifier,
                        persistentState: e.persistentState,
                        sessionTypes: e.sessionTypes
                    };
                    f.length && (e.audioCapabilities = f);
                    g.length && (e.videoCapabilities = g);
                    b = e;
                    return F(d, navigator.requestMediaKeySystemAccess(a.keySystemConfiguration.keySystem, [
                        b
                    ]), 2);
                }
                c = d.h;
                return d.return(c);
            });
        }
        ZC.MCapEncryptionScheme = sD;
        sD.install = uD;
        bD(uD, -2);
        function yD() {}
        function zD() {
            Rb().mc() || (navigator.mediaCapabilities || (navigator.mediaCapabilities = {}), yD.originalMcap = navigator.mediaCapabilities, navigator.mediaCapabilities.decodingInfo = AD);
        }
        function AD(a) {
            var b, c, d, e, f, g, h, k, l, m, n;
            return Q(function(q) {
                switch(q.g){
                    case 1:
                        b = {
                            supported: !1,
                            powerEfficient: !0,
                            smooth: !0,
                            keySystemAccess: null,
                            configuration: a
                        };
                        Rb();
                        c = a.video;
                        d = a.audio;
                        if (a.type != "media-source") {
                            if (a.type == "file") {
                                if (c && (e = c.contentType, f = Gi().canPlayType(e) != "", !f) || d && (g = d.contentType, h = Gi().canPlayType(g) != "", !h)) return q.return(b);
                            } else return q.return(b);
                            q.B(2);
                            break;
                        }
                        if (!Fi()) return q.return(b);
                        if (!c) {
                            q.B(3);
                            break;
                        }
                        return F(q, BD(c), 4);
                    case 4:
                        if (k = q.h, !k) return q.return(b);
                    case 3:
                        if (d) {
                            var r = Rb().Ka(), t = d.contentType;
                            r === "CAST" && d.spatialRendering && (t += "; spatialRendering=true");
                            l = gd(t);
                            if (!l) return q.return(b);
                        }
                    case 2:
                        if (!a.keySystemConfiguration) return b.supported = !0, q.return(b);
                        m = a.keySystemConfiguration;
                        return F(q, CD(c, d, m), 6);
                    case 6:
                        if (n = q.h) b.supported = !0, b.keySystemAccess = n;
                    case 5:
                        return q.return(b);
                }
            });
        }
        function BD(a) {
            var b, c, d;
            return Q(function(e) {
                return e.g == 1 ? (b = Rb(), c = b.Ka(), c !== "CAST" ? e.B(2) : F(e, DD(a), 3)) : e.g != 2 ? (d = e.h, e.return(d)) : e.return(gd(a.contentType));
            });
        }
        function CD(a, b, c) {
            var d, e, f, g, h, k, l, m, n, q, r;
            return Q(function(t) {
                switch(t.g){
                    case 1:
                        d = [];
                        e = [];
                        c.audio && (f = {
                            robustness: c.audio.robustness || "",
                            contentType: b.contentType
                        }, Rb().nj() && b.contentType.includes('codecs="ac-3"') && (f.contentType = 'audio/mp4; codecs="ec-3"'), c.audio.encryptionScheme && (f.encryptionScheme = c.audio.encryptionScheme), d.push(f));
                        c.video && (g = {
                            robustness: c.video.robustness || "",
                            contentType: a.contentType
                        }, c.video.encryptionScheme && (g.encryptionScheme = c.video.encryptionScheme), e.push(g));
                        h = {
                            initDataTypes: [
                                c.initDataType
                            ],
                            distinctiveIdentifier: c.distinctiveIdentifier,
                            persistentState: c.persistentState,
                            sessionTypes: c.sessionTypes
                        };
                        d.length && (h.audioCapabilities = d);
                        e.length && (h.videoCapabilities = e);
                        k = a ? a.contentType : "";
                        l = b ? b.contentType : "";
                        m = mf(k) + ";" + lf(k);
                        n = mf(l) + ";" + lf(l);
                        q = c.keySystem;
                        r = null;
                        ra(t, 2);
                        if (Dg.has(m + "#" + n + "#" + q)) {
                            r = Dg.get(m + "#" + n + "#" + q) || null;
                            t.B(4);
                            break;
                        }
                        return F(t, navigator.requestMediaKeySystemAccess(c.keySystem, [
                            h
                        ]), 5);
                    case 5:
                        r = t.h, Dg.set(m + "#" + n + "#" + q, r);
                    case 4:
                        ta(t, 3);
                        break;
                    case 2:
                        ua(t);
                    case 3:
                        return t.return(r);
                }
            });
        }
        function DD(a) {
            var b, c, d, e, f;
            return Q(function(g) {
                if (g.g == 1) {
                    if (!(window1.cast && cast.__platform__ && cast.__platform__.canDisplayType)) return g.return(gd(a.contentType));
                    b = a.contentType;
                    a.width && a.height && a.width > 1280 && a.height > 720 && (b += "; width=" + a.width + "; height=" + a.height);
                    a.framerate && (c = Math.round(a.framerate), c < 24 || c > 30) && (b += "; framerate=" + a.framerate);
                    d = a.transferFunction || "";
                    switch(d){
                        case "":
                        case "srgb":
                            break;
                        case "pq":
                            b += "; eotf=smpte2084";
                            break;
                        case "hlg":
                            b += "; eotf=arib-std-b67";
                            break;
                        default:
                            return g.return(!1);
                    }
                    e = !1;
                    f = ED;
                    return f.has(b) ? (e = f.get(b), g.B(2)) : F(g, cast.__platform__.canDisplayType(b), 3);
                }
                g.g != 2 && (e = g.h, f.set(b, e));
                return g.return(e);
            });
        }
        ZC.MediaCapabilities = yD;
        yD.install = zD;
        yD.originalMcap = null;
        var ED = new Map;
        bD(zD, -1);
        function FD() {}
        function GD() {
            var a = Rb(), b = a.Ja() === "WEBKIT" ? a.Ga() : null;
            (window1.MediaSource || window1.ManagedMediaSource) && b && window1.MediaSource && (b <= 12 ? (HD(), ID()) : b <= 15 && HD());
            a = u(a.xj());
            for(b = a.next(); !b.done; b = a.next())JD(b.value);
            (window1.MediaSource || window1.ManagedMediaSource) && KD();
            window1.MediaSource && MediaSource.isTypeSupported('video/webm; codecs="vp9"') && !MediaSource.isTypeSupported('video/webm; codecs="vp09.00.10.08"') && LD();
        }
        function HD() {
            var a = MediaSource.prototype.addSourceBuffer;
            MediaSource.prototype.addSourceBuffer = function() {
                var b = a.apply(this, Ma.apply(0, arguments));
                b.abort = function() {};
                return b;
            };
        }
        function ID() {
            var a = SourceBuffer.prototype.remove;
            SourceBuffer.prototype.remove = function(b, c) {
                return a.call(this, b, c - .001);
            };
        }
        function KD() {
            if (window1.MediaSource) {
                var a = MediaSource.isTypeSupported.bind(MediaSource);
                MediaSource.isTypeSupported = function(c) {
                    return hf(c) != "mp2t" && a(c);
                };
            }
            if (window1.ManagedMediaSource) {
                var b = ManagedMediaSource.isTypeSupported.bind(ManagedMediaSource);
                window1.ManagedMediaSource.isTypeSupported = function(c) {
                    return hf(c) != "mp2t" && b(c);
                };
            }
        }
        function JD(a) {
            var b = MediaSource.isTypeSupported.bind(MediaSource);
            MediaSource.isTypeSupported = function(d) {
                return lf(d) != a && b(d);
            };
            if (window1.ManagedMediaSource) {
                var c = ManagedMediaSource.isTypeSupported.bind(ManagedMediaSource);
                window1.ManagedMediaSource.isTypeSupported = function(d) {
                    return lf(d) != a && c(d);
                };
            }
        }
        function LD() {
            var a = MediaSource.isTypeSupported;
            Rb().Yj() && (MediaSource.isTypeSupported = function(b) {
                var c = b.split(/ *; */), d = c.findIndex(function(g) {
                    return g.startsWith("codecs=");
                });
                if (d < 0) return a(b);
                var e = c[d].replace("codecs=", "").replace(/"/g, "").split(/\s*,\s*/), f = e.findIndex(function(g) {
                    return g.startsWith("vp09");
                });
                f >= 0 && (e[f] = "vp9", c[d] = 'codecs="' + e.join(",") + '"', b = c.join("; "));
                return a(b);
            });
        }
        ZC.MediaSource = FD;
        FD.install = GD;
        bD(GD);
        function MD() {}
        function ND() {
            screen.orientation && screen.orientation.unlock || (screen.orientation != void 0 ? OD() : window1.orientation != void 0 && PD());
        }
        function OD() {
            screen.orientation.lock === void 0 && (screen.orientation.lock = function() {
                return Promise.resolve();
            });
            screen.orientation.unlock === void 0 && (screen.orientation.unlock = function() {});
        }
        function PD() {
            function a() {
                switch(window1.orientation){
                    case -90:
                        b.type = "landscape-secondary";
                        b.angle = 270;
                        break;
                    case 0:
                        b.type = "portrait-primary";
                        b.angle = 0;
                        break;
                    case 90:
                        b.type = "landscape-primary";
                        b.angle = 90;
                        break;
                    case 180:
                        b.type = "portrait-secondary", b.angle = 180;
                }
            }
            var b = new QD;
            screen.orientation = b;
            a();
            window1.addEventListener("orientationchange", function() {
                a();
                var c = new T("change");
                b.dispatchEvent(c);
            });
        }
        ZC.Orientation = MD;
        MD.install = ND;
        function QD() {
            kb.call(this);
            this.type = "";
            this.angle = 0;
        }
        la(QD, kb);
        QD.prototype.lock = function(a) {
            function b(d) {
                return screen.lockOrientation ? screen.lockOrientation(d) : screen.mozLockOrientation ? screen.mozLockOrientation(d) : screen.msLockOrientation ? screen.msLockOrientation(d) : !1;
            }
            var c = !1;
            switch(a){
                case "natural":
                    c = b("default");
                    break;
                case "any":
                    c = !0;
                    this.unlock();
                    break;
                default:
                    c = b(a);
            }
            if (c) return Promise.resolve();
            a = Error("screen.orientation.lock() is not available on this device");
            a.name = "NotSupportedError";
            a.code = DOMException.NOT_SUPPORTED_ERR;
            return Promise.reject(a);
        };
        QD.prototype.unlock = function() {
            screen.unlockOrientation ? screen.unlockOrientation() : screen.mozUnlockOrientation ? screen.mozUnlockOrientation() : screen.msUnlockOrientation && screen.msUnlockOrientation();
        };
        bD(ND);
        function RD() {}
        var SD, TD, UD, VD, WD, XD;
        function YD(a) {
            if (window1.HTMLVideoElement && window1.WebKitMediaKeys && window1.shakaMediaKeysPolyfill != ZD) {
                if (a === void 0 ? 0 : a) SD = !0, TD = Object.getOwnPropertyDescriptor(HTMLMediaElement.prototype, "mediaKeys"), UD = HTMLMediaElement.prototype.setMediaKeys, VD = window1.MediaKeys, WD = window1.MediaKeySystemAccess, XD = navigator.requestMediaKeySystemAccess;
                delete HTMLMediaElement.prototype.mediaKeys;
                HTMLMediaElement.prototype.mediaKeys = null;
                HTMLMediaElement.prototype.setMediaKeys = $D;
                window1.MediaKeys = aE;
                window1.MediaKeySystemAccess = bE;
                navigator.requestMediaKeySystemAccess = cE;
                window1.shakaMediaKeysPolyfill = ZD;
                Uf.clear();
                Dg.clear();
            }
        }
        function cE(a, b) {
            try {
                var c = new bE(a, b);
                return Promise.resolve(c);
            } catch (d) {
                return Promise.reject(d);
            }
        }
        function $D(a) {
            var b = this.mediaKeys;
            b && b != a && dE(b, null);
            delete this.mediaKeys;
            return (this.mediaKeys = a) ? dE(a, this) : Promise.resolve();
        }
        function eE(a) {
            a = Kb(a.initData);
            if (Ob(a).getUint32(0, !0) + 4 != a.byteLength) throw new RangeError("Malformed FairPlay init data");
            a = Xb(a.subarray(4), !0);
            a = $b(a);
            var b = new Event("encrypted");
            b.initDataType = "skd";
            b.initData = Lb(a);
            this.dispatchEvent(b);
        }
        ZC.PatchedMediaKeysApple = RD;
        RD.uninstall = function() {
            window1.shakaMediaKeysPolyfill == ZD && SD && (SD = !1, Object.defineProperty(HTMLMediaElement.prototype, "mediaKeys", TD), HTMLMediaElement.prototype.setMediaKeys = UD, window1.MediaKeys = VD, window1.MediaKeySystemAccess = WD, navigator.requestMediaKeySystemAccess = XD, TD = XD = UD = WD = VD = null, window1.shakaMediaKeysPolyfill = "", Uf.clear(), Dg.clear());
        };
        RD.install = YD;
        function bE(a, b) {
            this.keySystem = a;
            if (a.startsWith("com.apple.fps")) for(a = u(b), b = a.next(); !b.done; b = a.next()){
                var c = b.value;
                if (c.persistentState == "required") b = null;
                else {
                    b = {
                        audioCapabilities: [],
                        videoCapabilities: [],
                        persistentState: "optional",
                        distinctiveIdentifier: "optional",
                        initDataTypes: c.initDataTypes,
                        sessionTypes: [
                            "temporary"
                        ],
                        label: c.label
                    };
                    var d = !1, e = !1;
                    if (c.audioCapabilities) for(var f = u(c.audioCapabilities), g = f.next(); !g.done; g = f.next())g = g.value, g.contentType && (d = !0, WebKitMediaKeys.isTypeSupported(this.keySystem, g.contentType.split(";")[0]) && (b.audioCapabilities.push(g), e = !0));
                    if (c.videoCapabilities) for(c = u(c.videoCapabilities), f = c.next(); !f.done; f = c.next())f = f.value, f.contentType && (d = !0, WebKitMediaKeys.isTypeSupported(this.keySystem, f.contentType.split(";")[0]) && (b.videoCapabilities.push(f), e = !0));
                    d || (e = WebKitMediaKeys.isTypeSupported(this.keySystem, "video/mp4"));
                    b = e ? b : null;
                }
                if (b) {
                    this.g = b;
                    return;
                }
            }
            a = Error("Unsupported keySystem");
            a.name = "NotSupportedError";
            a.code = DOMException.NOT_SUPPORTED_ERR;
            throw a;
        }
        bE.prototype.createMediaKeys = function() {
            var a = new aE(this.keySystem);
            return Promise.resolve(a);
        };
        bE.prototype.getConfiguration = function() {
            return this.g;
        };
        function aE(a) {
            this.h = new WebKitMediaKeys(a);
            this.g = new Tc;
        }
        aE.prototype.createSession = function(a) {
            a = a || "temporary";
            if (a != "temporary") throw new TypeError("Session type " + a + " is unsupported on this platform.");
            return new fE(this.h, a);
        };
        aE.prototype.setServerCertificate = function() {
            return Promise.resolve(!1);
        };
        function dE(a, b) {
            a.g.Sa();
            if (!b) return Promise.resolve();
            a.g.o(b, "webkitneedkey", eE);
            try {
                return Gl(b, HTMLMediaElement.HAVE_METADATA, a.g, function() {
                    b.webkitSetMediaKeys(a.h);
                }), Promise.resolve();
            } catch (c) {
                return Promise.reject(c);
            }
        }
        aE.prototype.getStatusForPolicy = function() {
            return Promise.resolve("usable");
        };
        function fE(a) {
            kb.call(this);
            this.i = null;
            this.l = a;
            this.g = this.h = null;
            this.j = new Tc;
            this.sessionId = "";
            this.expiration = NaN;
            this.closed = new Lg;
            this.keyStatuses = new gE;
            this.onkeystatuseschange = null;
        }
        la(fE, kb);
        p = fE.prototype;
        p.generateRequest = function(a, b) {
            var c = this;
            this.h = new Lg;
            try {
                var d = this.l.createSession("video/mp4", Kb(b));
                this.i = d;
                this.sessionId = d.sessionId || "";
                this.j.o(this.i, "webkitkeymessage", function(e) {
                    c.h && (c.h.resolve(), c.h = null);
                    e = (new Map).set("messageType", c.keyStatuses.Uc() == void 0 ? "license-request" : "license-renewal").set("message", Lb(e.message));
                    e = new T("message", e);
                    c.dispatchEvent(e);
                });
                this.j.o(d, "webkitkeyadded", function() {
                    c.g && (hE(c, "usable"), c.g.resolve(), c.g = null);
                });
                this.j.o(d, "webkitkeyerror", function() {
                    var e = Error("EME PatchedMediaKeysApple key error");
                    e.errorCode = c.i.error;
                    if (c.h != null) c.h.reject(e), c.h = null;
                    else if (c.g != null) c.g.reject(e), c.g = null;
                    else switch(c.i.error.code){
                        case WebKitMediaKeyError.MEDIA_KEYERR_OUTPUT:
                        case WebKitMediaKeyError.MEDIA_KEYERR_HARDWARECHANGE:
                            hE(c, "output-not-allowed");
                            break;
                        default:
                            hE(c, "internal-error");
                    }
                });
                hE(this, "status-pending");
            } catch (e) {
                this.h.reject(e);
            }
            return this.h;
        };
        p.load = function() {
            return Promise.reject(Error("MediaKeySession.load not yet supported"));
        };
        p.update = function(a) {
            this.g = new Lg;
            try {
                this.i.update(Kb(a));
            } catch (b) {
                this.g.reject(b);
            }
            return this.g;
        };
        p.close = function() {
            try {
                this.i.close(), this.closed.resolve(), this.j.Sa();
            } catch (a) {
                this.closed.reject(a);
            }
            return this.closed;
        };
        p.remove = function() {
            return Promise.reject(Error("MediaKeySession.remove is only applicable for persistent licenses, which are not supported on this platform"));
        };
        function hE(a, b) {
            var c = a.keyStatuses;
            c.size = b == void 0 ? 0 : 1;
            c.g = b;
            b = new T("keystatuseschange");
            a.dispatchEvent(b);
            if (a.onkeystatuseschange) a.onkeystatuseschange(b);
        }
        function gE() {
            this.size = 0;
            this.g = void 0;
        }
        p = gE.prototype;
        p.Uc = function() {
            return this.g;
        };
        p.forEach = function(a) {
            this.g && a(this.g, Cg.value());
        };
        p.get = function(a) {
            if (this.has(a)) return this.g;
        };
        p.has = function(a) {
            var b = Cg.value();
            return this.g && Jb(a, b) ? !0 : !1;
        };
        p.entries = function() {};
        p.keys = function() {};
        p.values = function() {};
        var ZD = "apple";
        bD(function() {
            window1.HTMLVideoElement && window1.WebKitMediaKeys && (navigator.requestMediaKeySystemAccess && MediaKeySystemAccess.prototype.getConfiguration || YD());
        });
        function iE() {}
        function jE() {
            if (window1.MediaKeys) {
                var a = Rb();
                MediaKeys.prototype.setServerCertificate && a.Je() || (MediaKeys.prototype.setServerCertificate = kE);
            }
        }
        function kE() {
            return Promise.resolve(!1);
        }
        ZC.PatchedMediaKeysCert = iE;
        iE.install = jE;
        bD(jE);
        function lE() {}
        function mE() {
            if (!(!window1.HTMLVideoElement || navigator.requestMediaKeySystemAccess && MediaKeySystemAccess.prototype.getConfiguration)) {
                if (HTMLMediaElement.prototype.webkitGenerateKeyRequest) nE = "webkit";
                else if (!HTMLMediaElement.prototype.generateKeyRequest) return;
                navigator.requestMediaKeySystemAccess = oE;
                delete HTMLMediaElement.prototype.mediaKeys;
                HTMLMediaElement.prototype.mediaKeys = null;
                HTMLMediaElement.prototype.setMediaKeys = pE;
                window1.MediaKeys = qE;
                window1.MediaKeySystemAccess = rE;
                window1.shakaMediaKeysPolyfill = sE;
            }
        }
        function tE(a) {
            var b = nE;
            return b ? b + a.charAt(0).toUpperCase() + a.slice(1) : a;
        }
        function oE(a, b) {
            try {
                var c = new rE(a, b);
                return Promise.resolve(c);
            } catch (d) {
                return Promise.reject(d);
            }
        }
        function pE(a) {
            var b = this.mediaKeys;
            b && b != a && uE(b, null);
            delete this.mediaKeys;
            (this.mediaKeys = a) && uE(a, this);
            return Promise.resolve();
        }
        ZC.PatchedMediaKeysWebkit = lE;
        lE.install = mE;
        function rE(a, b) {
            this.g = this.keySystem = a;
            var c = !1;
            a == "org.w3.clearkey" && (this.g = "webkit-org.w3.clearkey", c = !1);
            var d = !1;
            var e = document.getElementsByTagName("video");
            e = e.length ? e[0] : document.createElement("video");
            b = u(b);
            for(var f = b.next(); !f.done; f = b.next()){
                f = f.value;
                var g = {
                    audioCapabilities: [],
                    videoCapabilities: [],
                    persistentState: "optional",
                    distinctiveIdentifier: "optional",
                    initDataTypes: f.initDataTypes,
                    sessionTypes: [
                        "temporary"
                    ],
                    label: f.label
                }, h = !1;
                if (f.audioCapabilities) for(var k = u(f.audioCapabilities), l = k.next(); !l.done; l = k.next())l = l.value, l.contentType && (h = !0, e.canPlayType(l.contentType.split(";")[0], this.g) && (g.audioCapabilities.push(l), d = !0));
                if (f.videoCapabilities) for(k = u(f.videoCapabilities), l = k.next(); !l.done; l = k.next())l = l.value, l.contentType && (h = !0, e.canPlayType(l.contentType, this.g) && (g.videoCapabilities.push(l), d = !0));
                h || (d = e.canPlayType("video/mp4", this.g) || e.canPlayType("video/webm", this.g));
                f.persistentState == "required" && (c ? (g.persistentState = "required", g.sessionTypes = [
                    "persistent-license"
                ]) : d = !1);
                if (d) {
                    this.h = g;
                    return;
                }
            }
            c = "Unsupported keySystem";
            if (a == "org.w3.clearkey" || a == "com.widevine.alpha") c = "None of the requested configurations were supported.";
            a = Error(c);
            a.name = "NotSupportedError";
            a.code = DOMException.NOT_SUPPORTED_ERR;
            throw a;
        }
        rE.prototype.createMediaKeys = function() {
            var a = new qE(this.g);
            return Promise.resolve(a);
        };
        rE.prototype.getConfiguration = function() {
            return this.h;
        };
        function qE(a) {
            this.l = a;
            this.h = null;
            this.g = new Tc;
            this.i = [];
            this.j = new Map;
        }
        function uE(a, b) {
            a.h = b;
            a.g.Sa();
            var c = nE;
            b && (a.g.o(b, c + "needkey", function(d) {
                var e = new CustomEvent("encrypted");
                e.initDataType = "cenc";
                e.initData = Lb(d.initData);
                a.h.dispatchEvent(e);
            }), a.g.o(b, c + "keymessage", function(d) {
                var e = vE(a, d.sessionId);
                e && (d = (new Map).set("messageType", e.keyStatuses.Uc() == void 0 ? "licenserequest" : "licenserenewal").set("message", d.message), d = new T("message", d), e.h && (e.h.resolve(), e.h = null), e.dispatchEvent(d));
            }), a.g.o(b, c + "keyadded", function(d) {
                (d = vE(a, d.sessionId)) && d.ready();
            }), a.g.o(b, c + "keyerror", function(d) {
                var e = vE(a, d.sessionId);
                if (e) {
                    var f = Error("EME v0.1b key error"), g = d.errorCode;
                    g.systemCode = d.systemCode;
                    f.errorCode = g;
                    !d.sessionId && e.h ? (d.systemCode == 45 && (f.message = "Unsupported session type."), e.h.reject(f), e.h = null) : d.sessionId && e.g ? (e.g.reject(f), e.g = null) : (f = d.systemCode, d.errorCode.code == MediaKeyError.MEDIA_KEYERR_OUTPUT ? wE(e, "output-restricted") : f == 1 ? wE(e, "expired") : wE(e, "internal-error"));
                }
            }));
        }
        qE.prototype.createSession = function(a) {
            a = a || "temporary";
            if (a != "temporary" && a != "persistent-license") throw new TypeError("Session type " + a + " is unsupported on this platform.");
            var b = this.h || document.createElement("video");
            b.src || (b.src = "about:blank");
            a = new xE(b, this.l, a);
            this.i.push(a);
            return a;
        };
        qE.prototype.setServerCertificate = function() {
            return Promise.resolve(!1);
        };
        qE.prototype.getStatusForPolicy = function() {
            return Promise.resolve("usable");
        };
        function vE(a, b) {
            var c = a.j.get(b);
            return c ? c : (c = a.i.shift()) ? (c.sessionId = b, a.j.set(b, c), c) : null;
        }
        function xE(a, b, c) {
            kb.call(this);
            this.j = a;
            this.m = !1;
            this.g = this.h = null;
            this.i = b;
            this.l = c;
            this.sessionId = "";
            this.expiration = NaN;
            this.closed = new Lg;
            this.keyStatuses = new yE;
            this.onkeystatuseschange = null;
        }
        la(xE, kb);
        p = xE.prototype;
        p.ready = function() {
            wE(this, "usable");
            this.g && this.g.resolve();
            this.g = null;
        };
        function zE(a, b, c) {
            if (a.m) return Promise.reject(Error("The session is already initialized."));
            a.m = !0;
            try {
                if (a.l == "persistent-license") {
                    if (c) var d = Kb($b("LOAD_SESSION|" + c));
                    else {
                        var e = $b("PERSISTENT|");
                        d = lc(e, b);
                    }
                } else d = Kb(b);
            } catch (g) {
                return Promise.reject(g);
            }
            a.h = new Lg;
            var f = tE("generateKeyRequest");
            try {
                a.j[f](a.i, d);
            } catch (g) {
                if (g.name != "InvalidStateError") return a.h = null, Promise.reject(g);
                new Bf(function() {
                    try {
                        a.j[f](a.i, d);
                    } catch (h) {
                        a.h.reject(h), a.h = null;
                    }
                }).$(.01);
            }
            return a.h;
        }
        function AE(a, b, c) {
            if (a.g) a.g.then(function() {
                return AE(a, b, c);
            }).catch(function() {
                return AE(a, b, c);
            });
            else {
                a.g = b;
                if (a.i == "webkit-org.w3.clearkey") {
                    var d = Wb(c);
                    var e = JSON.parse(d);
                    e.keys[0].kty != "oct" && (a.g.reject(Error("Response is not a valid JSON Web Key Set.")), a.g = null);
                    d = hc(e.keys[0].k);
                    e = hc(e.keys[0].kid);
                } else d = Kb(c), e = null;
                var f = tE("addKey");
                try {
                    a.j[f](a.i, d, e, a.sessionId);
                } catch (g) {
                    a.g.reject(g), a.g = null;
                }
            }
        }
        function wE(a, b) {
            var c = a.keyStatuses;
            c.size = b == void 0 ? 0 : 1;
            c.g = b;
            b = new T("keystatuseschange");
            a.dispatchEvent(b);
            if (a.onkeystatuseschange) a.onkeystatuseschange(b);
        }
        p.generateRequest = function(a, b) {
            return zE(this, b, null);
        };
        p.load = function(a) {
            return this.l == "persistent-license" ? zE(this, null, a) : Promise.reject(Error("Not a persistent session."));
        };
        p.update = function(a) {
            var b = new Lg;
            AE(this, b, a);
            return b;
        };
        p.close = function() {
            if (this.l != "persistent-license") {
                if (!this.sessionId) return this.closed.reject(Error("The session is not callable.")), this.closed;
                var a = tE("cancelKeyRequest");
                try {
                    this.j[a](this.i, this.sessionId);
                } catch (b) {}
            }
            this.closed.resolve();
            return this.closed;
        };
        p.remove = function() {
            return this.l != "persistent-license" ? Promise.reject(Error("Not a persistent session.")) : this.close();
        };
        function yE() {
            this.size = 0;
            this.g = void 0;
        }
        p = yE.prototype;
        p.Uc = function() {
            return this.g;
        };
        p.forEach = function(a) {
            this.g && a(this.g, Cg.value());
        };
        p.get = function(a) {
            if (this.has(a)) return this.g;
        };
        p.has = function(a) {
            var b = Cg.value();
            return this.g && Jb(a, b) ? !0 : !1;
        };
        p.entries = function() {};
        p.keys = function() {};
        p.values = function() {};
        var nE = "", sE = "webkit";
        bD(mE);
        function BE() {}
        function CE() {
            if (window1.HTMLVideoElement) {
                var a = HTMLVideoElement.prototype;
                a.requestPictureInPicture && document.exitPictureInPicture || !a.webkitSupportsPresentationMode || (document.pictureInPictureEnabled = !0, document.pictureInPictureElement = null, a.requestPictureInPicture = DE, Object.defineProperty(a, "disablePictureInPicture", {
                    get: EE,
                    set: FE,
                    enumerable: !0,
                    configurable: !0
                }), document.exitPictureInPicture = GE, document.addEventListener("webkitpresentationmodechanged", HE, !0));
            }
        }
        function HE(a) {
            a = a.target;
            if (a.webkitPresentationMode == "picture-in-picture") {
                document.pictureInPictureElement = a;
                var b = new Event("enterpictureinpicture");
                a.dispatchEvent(b);
            } else document.pictureInPictureElement == a && (document.pictureInPictureElement = null), b = new Event("leavepictureinpicture"), a.dispatchEvent(b);
        }
        function DE() {
            return this.webkitSupportsPresentationMode("picture-in-picture") ? (this.webkitSetPresentationMode("picture-in-picture"), document.pictureInPictureElement = this, Promise.resolve()) : Promise.reject(Error("PiP not allowed by video element"));
        }
        function GE() {
            var a = document.pictureInPictureElement;
            return a ? (a.webkitSetPresentationMode("inline"), document.pictureInPictureElement = null, Promise.resolve()) : Promise.reject(Error("No picture in picture element found"));
        }
        function EE() {
            return this.hasAttribute("disablePictureInPicture") ? !0 : !this.webkitSupportsPresentationMode("picture-in-picture");
        }
        function FE(a) {
            a ? this.setAttribute("disablePictureInPicture", "") : this.removeAttribute("disablePictureInPicture");
        }
        ZC.PiPWebkit = BE;
        BE.install = CE;
        bD(CE);
        function IE() {}
        function JE() {
            window1.crypto && ("randomUUID" in window1.crypto || (window1.crypto.randomUUID = KE));
        }
        function KE() {
            var a = URL.createObjectURL(new Blob), b = a.toString();
            URL.revokeObjectURL(a);
            return b.substr(b.lastIndexOf("/") + 1);
        }
        ZC.RandomUUID = IE;
        IE.install = JE;
        bD(JE);
        function LE() {}
        function ME() {
            var a = Symbol.prototype;
            "description" in a || Object.defineProperty(a, "description", {
                get: NE
            });
        }
        function NE() {
            var a = /\((.*)\)/.exec(this.toString());
            return a ? a[1] : void 0;
        }
        ZC.Symbol = LE;
        LE.install = ME;
        bD(ME);
        function OE() {}
        function PE() {
            for(var a = u([
                Uint8Array,
                Uint8ClampedArray,
                Uint16Array,
                Uint32Array,
                Int8Array,
                Int16Array,
                Int32Array,
                Float32Array,
                Float64Array
            ]), b = a.next(); !b.done; b = a.next())b = b.value, b.prototype.indexOf || (b.prototype.indexOf = QE), b.prototype.lastIndexOf || (b.prototype.lastIndexOf = RE), b.prototype.includes || (b.prototype.includes = SE);
        }
        function QE(a, b) {
            return Array.prototype.indexOf.call(this, a, b);
        }
        function RE(a, b) {
            return Array.prototype.lastIndexOf.call(this, a, b);
        }
        function SE(a, b) {
            return this.indexOf(a, b) !== -1;
        }
        ZC.TypedArray = OE;
        OE.install = PE;
        bD(PE);
        function TE() {}
        function UE() {
            if (window1.HTMLMediaElement) {
                var a = HTMLMediaElement.prototype.play;
                HTMLMediaElement.prototype.play = function() {
                    var b = a.apply(this);
                    b && b.catch(function() {});
                    return b;
                };
            }
        }
        ZC.VideoPlayPromise = TE;
        TE.install = UE;
        bD(UE);
        function VE() {}
        function WE() {
            if (window1.HTMLVideoElement) {
                var a = HTMLVideoElement.prototype;
                !a.getVideoPlaybackQuality && ("webkitDroppedFrameCount" in a || typeof Gi().webkitDroppedFrameCount === "number") && (a.getVideoPlaybackQuality = XE);
            }
        }
        function XE() {
            return {
                droppedVideoFrames: this.webkitDroppedFrameCount,
                totalVideoFrames: this.webkitDecodedFrameCount,
                corruptedVideoFrames: 0,
                creationTime: NaN,
                totalFrameDelay: 0
            };
        }
        ZC.VideoPlaybackQuality = VE;
        VE.install = WE;
        bD(WE);
        function YE() {}
        function ZE() {
            if (!window1.VTTCue && window1.TextTrackCue) {
                var a = null, b = TextTrackCue.length;
                if (b == 3) a = $E;
                else if (b == 6) a = aF;
                else {
                    try {
                        var c = !!$E(1, 2, "");
                    } catch (d) {
                        c = !1;
                    }
                    c && (a = $E);
                }
                a && (window1.VTTCue = function(d, e, f) {
                    return a(d, e, f);
                });
            }
        }
        function $E(a, b, c) {
            return new window1.TextTrackCue(a, b, c);
        }
        function aF(a, b, c) {
            return new window1.TextTrackCue(a + "-" + b + "-" + c, a, b, c);
        }
        ZC.VTTCue = YE;
        YE.install = ZE;
        bD(ZE);
        function bF(a) {
            kb.call(this);
            this.g = a;
            this.m = null;
            this.h = [];
            this.j = -1;
            this.i = this.l = null;
            this.u = new Tc;
        }
        la(bF, kb);
        p = bF.prototype;
        p.destroy = function() {
            var a = this;
            return Q(function(b) {
                if (b.g == 1) return F(b, a.removeAllItems(), 2);
                a.g = null;
                a.u && (a.u.release(), a.u = null);
                kb.prototype.release.call(a);
                H(b);
            });
        };
        p.configure = function(a) {
            this.m = a;
        };
        p.getConfiguration = function() {
            return this.m;
        };
        p.getCurrentItem = function() {
            return this.h.length && this.j >= 0 && this.j < this.h.length ? this.h[this.j] : null;
        };
        p.getCurrentItemIndex = function() {
            return this.j;
        };
        p.getItems = function() {
            return this.h.slice();
        };
        p.insertItems = function(a) {
            this.h.push.apply(this.h, x(a));
            this.dispatchEvent(new T("itemsinserted"));
        };
        p.removeAllItems = function() {
            var a = this, b, c, d, e;
            return Q(function(f) {
                if (f.g == 1) return a.u.Sa(), a.h.length && a.j >= 0 ? F(f, a.g.tc(), 2) : f.B(2);
                if (f.g != 4) {
                    b = [];
                    a.i && (a.i.preloadManager.j || b.push(a.i.preloadManager.destroy()), a.i = null);
                    a.l && (a.l.preloadManager.j || b.push(a.l.preloadManager.destroy()), a.l = null);
                    c = u(a.h);
                    for(d = c.next(); !d.done; d = c.next())e = d.value, e.preloadManager && !e.preloadManager.j && b.push(e.preloadManager.destroy());
                    return b.length ? F(f, Promise.all(b), 4) : f.B(4);
                }
                a.h = [];
                a.j = -1;
                a.dispatchEvent(new T("itemsremoved"));
                H(f);
            });
        };
        p.playItem = function(a) {
            var b = this, c, d, e, f, g, h, k, l, m, n, q, r, t, w, v, z, y;
            return Q(function(A) {
                switch(A.g){
                    case 1:
                        b.u.Sa();
                        if (!b.h.length || a >= b.h.length) throw new U(2, 7, 7007);
                        c = b.getCurrentItem();
                        d = b.h[a];
                        b.j != a && (b.j = a, b.dispatchEvent(new T("currentitemchanged")));
                        e = b.g.h;
                        f = b.m ? b.m.preloadNextUrlWindow : 0;
                        f > 0 && (g = !1, b.u.o(e, "timeupdate", function() {
                            var C, E, D, B;
                            return Q(function(G) {
                                switch(G.g){
                                    case 1:
                                        if (b.l || b.h.length <= 1 || g || b.g.U() || !e.duration) return G.return();
                                        C = b.g.za().end - e.currentTime;
                                        if (isNaN(C)) {
                                            G.B(0);
                                            break;
                                        }
                                        if (!(C <= f)) {
                                            G.B(0);
                                            break;
                                        }
                                        E = b.m && b.m.repeatMode;
                                        D = null;
                                        b.j + 1 < b.h.length ? D = b.h[b.j + 1] : E == 1 && (D = b.h[0]);
                                        if (!D || D.preloadManager && !D.preloadManager.j) {
                                            G.B(0);
                                            break;
                                        }
                                        g = !0;
                                        B = null;
                                        ra(G, 5);
                                        return F(G, b.g.preload(D.manifestUri, D.startTime, D.mimeType, D.config), 7);
                                    case 7:
                                        B = G.h;
                                        ta(G, 6);
                                        break;
                                    case 5:
                                        ua(G), B = null;
                                    case 6:
                                        b.l = {
                                            item: D,
                                            preloadManager: B
                                        }, g = !1, H(G);
                                }
                            });
                        }));
                        b.u.o(b.g, "complete", function() {
                            var C = b.m && b.m.repeatMode, E = !1;
                            if (C == 2) E = !0;
                            else {
                                var D = b.j + 1;
                                D < b.h.length ? b.playItem(D) : C == 1 && (b.h.length == 1 ? E = !0 : b.playItem(0));
                            }
                            E && (e.paused ? (e.currentTime = b.g.za().start, e.play()) : b.u.o(e, "paused", function() {
                                e.currentTime = b.g.za().start;
                                e.play();
                            }));
                        });
                        h = d.manifestUri;
                        d.preloadManager && !d.preloadManager.j && (h = d.preloadManager);
                        k = !1;
                        b.l && b.l.item == d && b.l.preloadManager ? h = b.l.preloadManager : b.i && b.i.item == d && b.i.preloadManager && (h = b.i.preloadManager, k = !0);
                        if (!b.i) {
                            A.B(2);
                            break;
                        }
                        if (k || b.i.preloadManager.j) {
                            A.B(3);
                            break;
                        }
                        return F(A, b.i.preloadManager.destroy(), 3);
                    case 3:
                        b.i = null;
                    case 2:
                        if (!(b.m && b.m.preloadPrevItem && c && b.g.l === vr)) {
                            A.B(5);
                            break;
                        }
                        l = null;
                        ra(A, 6);
                        return F(A, b.g.ck(), 8);
                    case 8:
                        l = A.h;
                        ta(A, 7);
                        break;
                    case 6:
                        ua(A), l = null;
                    case 7:
                        b.i = {
                            item: c,
                            preloadManager: l
                        };
                    case 5:
                        return d.config && (b.g.Bj(), b.g.configure(d.config)), F(A, b.g.load(h, d.startTime, d.mimeType), 9);
                    case 9:
                        b.l = null;
                        if (d.extraText) for(m = u(d.extraText), n = m.next(); !n.done; n = m.next())q = n.value, q.mime ? b.g.ee(q.uri, q.language, q.kind, q.mime, q.codecs) : b.g.ee(q.uri, q.language, q.kind);
                        if (d.extraThumbnail) for(r = u(d.extraThumbnail), t = r.next(); !t.done; t = r.next())w = t.value, b.g.ef(w);
                        if (d.extraChapter) for(v = u(d.extraChapter), z = v.next(); !z.done; z = v.next())y = z.value, b.g.df(y.uri, y.language, y.mime);
                        H(A);
                }
            });
        };
        S("shaka.queue.QueueManager", bF);
        bF.prototype.playItem = bF.prototype.playItem;
        bF.prototype.removeAllItems = bF.prototype.removeAllItems;
        bF.prototype.insertItems = bF.prototype.insertItems;
        bF.prototype.getItems = bF.prototype.getItems;
        bF.prototype.getCurrentItemIndex = bF.prototype.getCurrentItemIndex;
        bF.prototype.getCurrentItem = bF.prototype.getCurrentItem;
        bF.prototype.getConfiguration = bF.prototype.getConfiguration;
        bF.prototype.configure = bF.prototype.configure;
        bF.prototype.destroy = bF.prototype.destroy;
        Nq = function(a) {
            return new bF(a);
        };
        function cF() {}
        cF.prototype.parseInit = function() {};
        cF.prototype.setSequenceMode = function() {};
        cF.prototype.setManifestType = function() {};
        cF.prototype.parseMedia = function(a, b) {
            var c = null, d = [];
            a = Wb(a).split(/\r?\n/);
            a = u(a);
            for(var e = a.next(); !e.done; e = a.next())if ((e = e.value) && !/^\s+$/.test(e) && (e = dF.exec(e))) {
                var f = eF.exec(e[1]);
                f = parseInt(f[1], 10) * 60 + parseFloat(f[2].replace(",", "."));
                e = new re(f, b.segmentEnd ? b.segmentEnd : f + 2, e[2]);
                c && (c.endTime = f, d.push(c));
                c = e;
            }
            c && d.push(c);
            return d;
        };
        S("shaka.text.LrcTextParser", cF);
        cF.prototype.parseMedia = cF.prototype.parseMedia;
        cF.prototype.setManifestType = cF.prototype.setManifestType;
        cF.prototype.setSequenceMode = cF.prototype.setSequenceMode;
        cF.prototype.parseInit = cF.prototype.parseInit;
        var dF = /^\[(\d{1,2}:\d{1,2}(?:[.,]\d{1,3})?)\](.*)/, eF = /^(\d+):(\d{1,2}(?:[.,]\d{1,3})?)$/;
        qf("application/x-subtitle-lrc", function() {
            return new cF;
        });
        function fF() {
            this.g = "UNKNOWN";
        }
        fF.prototype.parseInit = function() {};
        fF.prototype.setSequenceMode = function() {};
        fF.prototype.setManifestType = function(a) {
            this.g = a;
        };
        fF.prototype.parseMedia = function(a, b, c, d) {
            var e = Wb(a);
            a = [];
            if (e == "") return a;
            var f = Kd(e, "tt", !0);
            if (!f) throw new U(2, 2, 2005, "Failed to parse TTML.");
            e = Ud(f, "body")[0];
            if (!e) return [];
            var g = ae(f, gF, "frameRate"), h = ae(f, gF, "subFrameRate"), k = ae(f, gF, "frameRateMultiplier"), l = ae(f, gF, "tickRate"), m = ae(f, gF, "cellResolution"), n = f.attributes["xml:space"] || "default", q = ae(f, hF, "extent");
            if (n != "default" && n != "preserve") throw new U(2, 2, 2005, "Invalid xml:space value: " + n);
            n = n == "default";
            g = new iF(g, h, k, l);
            m = jF(m);
            h = Ud(f, "metadata")[0];
            h = (h ? h.children : []).filter(function(w) {
                return w != "\n";
            });
            k = Ud(f, "style");
            f = Ud(f, "region");
            l = [];
            for(var r = u(f), t = r.next(); !t.done; t = r.next())(t = kF(this, t.value, k, q)) && l.push(t);
            if (Rd(e, "p").length) throw new U(2, 2, 2001, "<p> can only be inside <div> in TTML");
            q = u(Rd(e, "div"));
            for(r = q.next(); !r.done; r = q.next())if (Rd(r.value, "span").length) throw new U(2, 2, 2001, "<span> can only be inside <p> in TTML");
            if (b = lF(this, e, b, g, h, k, f, l, n, m, null, !1, c, d)) b.backgroundColor || (b.backgroundColor = "transparent"), a.push(b);
            return a;
        };
        function lF(a, b, c, d, e, f, g, h, k, l, m, n, q, r) {
            var t = m;
            if (Pd(b)) {
                if (!n) return null;
                var w = {
                    tagName: "span",
                    children: [
                        Sd(b)
                    ],
                    attributes: {},
                    parent: null
                };
            } else w = b;
            for(var v = null, z = u(mF), y = z.next(); !y.done && !(v = nF(w, "backgroundImage", e, "#", y.value)[0]); y = z.next());
            z = null;
            y = ae(w, mF, "backgroundImage");
            var A = /^(urn:)(mpeg:[a-z0-9][a-z0-9-]{0,31}:)(subs:)([0-9]+)$/;
            if (y && A.test(y)) {
                z = parseInt(y.split(":").pop(), 10) - 1;
                if (z >= r.length) return null;
                z = r[z];
            } else q && y && !y.startsWith("#") && (A = new qb(q), y = new qb(y), (y = A.resolve(y).toString()) && (z = y));
            if (b.tagName == "p" || v || z) n = !0;
            b = n;
            y = (w.attributes["xml:space"] || (k ? "default" : "preserve")) == "default";
            A = w.children.every(Pd);
            k = [];
            if (!A) for(var C = u(w.children), E = C.next(); !E.done; E = C.next())(E = lF(a, E.value, c, d, e, f, g, h, y, l, w, n, q, r)) && k.push(E);
            e = m != null;
            q = Sd(w);
            q = w.children.length && q && /\S/.test(q);
            C = w.attributes.begin || w.attributes.end || w.attributes.dur;
            if (!(C || q || w.tagName == "br" || k.length != 0 || e && !y)) return null;
            r = oF(w, d);
            q = r.start;
            for(r = r.end; t && t.tagName && t.tagName != "tt";)r = pF(t, d, q, r), q = r.start, r = r.end, t = t.parent;
            q == null && (q = 0);
            q += c.periodStart;
            r = r == null ? Infinity : r + c.periodStart;
            a.g !== "HLS" && (q = Math.max(q, c.segmentStart), r = Math.min(r, c.segmentEnd));
            if (!C && k.length > 0) for(q = Infinity, r = 0, c = u(k), d = c.next(); !d.done; d = c.next())d = d.value, q = Math.min(q, d.startTime), r = Math.max(r, d.endTime);
            if (w.tagName == "br") return a = new re(q, r, ""), a.lineBreak = !0, a;
            c = "";
            A && (c = cc(Sd(w) || ""), y && (c = c.replace(/\s+/g, " ")));
            c = new re(q, r, c);
            c.nestedCues = k;
            n || (c.isContainer = !0);
            l && (c.cellResolution = l);
            l = nF(w, "region", g, "")[0];
            if (w.attributes.region && l && l.attributes["xml:id"]) {
                var D = l.attributes["xml:id"];
                c.region = h.filter(function(B) {
                    return B.id == D;
                })[0];
            }
            h = l;
            m && e && !w.attributes.region && !w.attributes.style && (h = nF(m, "region", g, "")[0]);
            qF(a, c, w, h, v, z, f, b, k.length == 0);
            return c;
        }
        function kF(a, b, c, d) {
            var e = new td, f = b.attributes["xml:id"];
            if (!f) return null;
            e.id = f;
            f = null;
            d && (f = rF.exec(d) || sF.exec(d));
            d = f ? Number(f[1]) : null;
            f = f ? Number(f[2]) : null;
            var g, h = tF(a, b, c, "extent");
            if (h) {
                var k = (g = rF.exec(h)) || sF.exec(h);
                k != null && (e.width = Number(k[1]), e.height = Number(k[2]), g || (d != null && (e.width = e.width * 100 / d), f != null && (e.height = e.height * 100 / f)), e.widthUnits = g || d != null ? ud : 0, e.heightUnits = g || f != null ? ud : 0);
            }
            if (a = tF(a, b, c, "origin")) {
                if (k = (g = rF.exec(a)) || sF.exec(a), k != null) e.viewportAnchorX = Number(k[1]), e.viewportAnchorY = Number(k[2]), g ? h || (e.width = 100 - e.viewportAnchorX, e.widthUnits = ud, e.height = 100 - e.viewportAnchorY, e.heightUnits = ud) : (f != null && (e.viewportAnchorY = e.viewportAnchorY * 100 / f), d != null && (e.viewportAnchorX = e.viewportAnchorX * 100 / d)), e.viewportAnchorUnits = g || d != null ? ud : 0;
            }
            return e;
        }
        function uF(a) {
            var b = a.match(/rgba\(([^)]+)\)/);
            return b && (b = b[1].split(","), b.length == 4) ? (b[3] = String(Number(b[3]) / 255), "rgba(" + b.join(",") + ")") : a;
        }
        function qF(a, b, c, d, e, f, g, h, k) {
            h = h || k;
            vF(a, c, d, g, "direction", h) == "rtl" && (b.direction = "rtl");
            k = vF(a, c, d, g, "writingMode", h);
            k == "tb" || k == "tblr" ? b.writingMode = "vertical-lr" : k == "tbrl" ? b.writingMode = "vertical-rl" : k == "rltb" || k == "rl" ? b.direction = "rtl" : k && (b.direction = ue);
            (k = vF(a, c, d, g, "textAlign", !0)) ? (b.positionAlign = wF.get(k), b.lineAlign = xF.get(k), b.textAlign = Re[k.toUpperCase()]) : b.textAlign = te;
            if (k = vF(a, c, d, g, "displayAlign", !0)) b.displayAlign = Se[k.toUpperCase()];
            if (k = vF(a, c, d, g, "color", h)) b.color = uF(k);
            if (k = vF(a, c, d, g, "backgroundColor", h)) b.backgroundColor = uF(k);
            if (k = vF(a, c, d, g, "border", h)) b.border = k;
            if (k = vF(a, c, d, g, "fontFamily", h)) switch(k){
                case "monospaceSerif":
                    b.fontFamily = "Courier New,Liberation Mono,Courier,monospace";
                    break;
                case "proportionalSansSerif":
                    b.fontFamily = "Arial,Helvetica,Liberation Sans,sans-serif";
                    break;
                case "sansSerif":
                    b.fontFamily = "sans-serif";
                    break;
                case "monospaceSansSerif":
                    b.fontFamily = "Consolas,monospace";
                    break;
                case "proportionalSerif":
                    b.fontFamily = "serif";
                    break;
                default:
                    b.fontFamily = k.split(",").filter(function(l) {
                        return l != "default";
                    }).join(",");
            }
            (k = vF(a, c, d, g, "fontWeight", h)) && k == "bold" && (b.fontWeight = Oe);
            k = vF(a, c, d, g, "wrapOption", h);
            b.wrapLine = k && k == "noWrap" ? !1 : !0;
            (k = vF(a, c, d, g, "lineHeight", h)) && k.match(yF) && (b.lineHeight = k);
            (k = vF(a, c, d, g, "fontSize", h)) && (k.match(yF) || k.match(zF)) && (b.fontSize = k);
            if (k = vF(a, c, d, g, "fontStyle", h)) b.fontStyle = Ue[k.toUpperCase()];
            e ? (f = e.attributes.imageType || e.attributes.imagetype, k = e.attributes.encoding, e = Sd(e).trim(), f == "PNG" && k == "Base64" && e && (b.backgroundImage = "data:image/png;base64," + e)) : f && (b.backgroundImage = f);
            if (e = vF(a, c, d, g, "textOutline", h)) e = e.split(" "), e[0].match(yF) ? b.textStrokeColor = b.color : (b.textStrokeColor = uF(e[0]), e.shift()), e[0] && e[0].match(yF) ? b.textStrokeWidth = e[0] : b.textStrokeColor = "";
            (e = vF(a, c, d, g, "letterSpacing", h)) && e.match(yF) && (b.letterSpacing = e);
            (e = vF(a, c, d, g, "linePadding", h)) && e.match(yF) && (b.linePadding = e);
            if (e = vF(a, c, d, g, "opacity", h)) b.opacity = parseFloat(e);
            (e = tF(a, d, g, "textDecoration")) && AF(b, e);
            (e = BF(a, c, g, "textDecoration")) && AF(b, e);
            if (e = vF(a, c, d, g, "textCombine", h)) b.textCombineUpright = e;
            switch(vF(a, c, d, g, "ruby", h)){
                case "container":
                    b.rubyTag = "ruby";
                    break;
                case "text":
                    b.rubyTag = "rt";
            }
        }
        function AF(a, b) {
            b = u(b.split(" "));
            for(var c = b.next(); !c.done; c = b.next())switch(c.value){
                case "underline":
                    a.textDecoration.includes(Qe) || a.textDecoration.push(Qe);
                    break;
                case "noUnderline":
                    a.textDecoration.includes(Qe) && Qc(a.textDecoration, Qe);
                    break;
                case "lineThrough":
                    a.textDecoration.includes("lineThrough") || a.textDecoration.push("lineThrough");
                    break;
                case "noLineThrough":
                    a.textDecoration.includes("lineThrough") && Qc(a.textDecoration, "lineThrough");
                    break;
                case "overline":
                    a.textDecoration.includes("overline") || a.textDecoration.push("overline");
                    break;
                case "noOverline":
                    a.textDecoration.includes("overline") && Qc(a.textDecoration, "overline");
            }
        }
        function vF(a, b, c, d, e, f) {
            f = f === void 0 ? !0 : f;
            return (b = BF(a, b, d, e)) ? b : f ? tF(a, c, d, e) : null;
        }
        function tF(a, b, c, d) {
            if (!b) return null;
            var e = ae(b, hF, d);
            return e ? e : CF(a, b, c, d);
        }
        function BF(a, b, c, d) {
            var e = ae(b, hF, d);
            return e ? e : CF(a, b, c, d);
        }
        function CF(a, b, c, d) {
            b = nF(b, "style", c, "");
            for(var e = null, f = 0; f < b.length; f++){
                var g = $d(b[f], "urn:ebu:tt:style", d);
                g || (g = ae(b[f], hF, d));
                g || (g = BF(a, b[f], c, d));
                g && (e = g);
            }
            return e;
        }
        function nF(a, b, c, d, e) {
            var f = [];
            if (!a || c.length < 1) return f;
            var g = a;
            for(a = null; !a && !(a = e ? $d(g, e, b) : g.attributes[b]) && (g = g.parent, g););
            if (b = a) {
                for(b = u(b.split(" ")), e = b.next(); !e.done; e = b.next())for(e = e.value, a = u(c), g = a.next(); !g.done; g = a.next())if (g = g.value, d + g.attributes["xml:id"] == e) {
                    f.push(g);
                    break;
                }
            }
            return f;
        }
        function pF(a, b, c, d) {
            a = oF(a, b);
            c == null ? c = a.start : a.start != null && (c += a.start);
            d == null ? d = a.end : a.start != null && (d += a.start);
            return {
                start: c,
                end: d
            };
        }
        function oF(a, b) {
            var c = DF(a.attributes.begin, b), d = DF(a.attributes.end, b);
            a = DF(a.attributes.dur, b);
            d == null && a != null && (d = c + a);
            return {
                start: c,
                end: d
            };
        }
        function DF(a, b) {
            var c = null;
            if (EF.test(a)) {
                a = EF.exec(a);
                c = Number(a[1]);
                var d = Number(a[2]), e = Number(a[3]), f = Number(a[4]);
                f += (Number(a[5]) || 0) / b.h;
                e += f / b.frameRate;
                c = e + d * 60 + c * 3600;
            } else if (FF.test(a)) c = GF(FF, a);
            else if (HF.test(a)) c = GF(HF, a);
            else if (IF.test(a)) a = IF.exec(a), c = Number(a[1]) / b.frameRate;
            else if (JF.test(a)) a = JF.exec(a), c = Number(a[1]) / b.g;
            else if (KF.test(a)) c = GF(KF, a);
            else if (a) throw new U(2, 2, 2001, "Could not parse cue time range in TTML");
            return c;
        }
        function GF(a, b) {
            a = a.exec(b);
            return a == null || a[0] == "" ? null : (Number(a[4]) || 0) / 1E3 + (Number(a[3]) || 0) + (Number(a[2]) || 0) * 60 + (Number(a[1]) || 0) * 3600;
        }
        function jF(a) {
            return a ? (a = /^(\d+) (\d+)$/.exec(a)) ? {
                columns: parseInt(a[1], 10),
                rows: parseInt(a[2], 10)
            } : null : null;
        }
        S("shaka.text.TtmlTextParser", fF);
        fF.prototype.parseMedia = fF.prototype.parseMedia;
        fF.prototype.setManifestType = fF.prototype.setManifestType;
        fF.prototype.setSequenceMode = fF.prototype.setSequenceMode;
        fF.prototype.parseInit = fF.prototype.parseInit;
        function iF(a, b, c, d) {
            this.frameRate = Number(a) || 30;
            this.h = Number(b) || 1;
            this.g = Number(d);
            this.g == 0 && (this.g = a ? this.frameRate * this.h : 1);
            c && (a = /^(\d+) (\d+)$/g.exec(c)) && (this.frameRate *= Number(a[1]) / Number(a[2]));
        }
        var rF = /^(\d{1,2}(?:\.\d+)?|100(?:\.0+)?)% (\d{1,2}(?:\.\d+)?|100(?:\.0+)?)%$/, zF = /^(\d{1,4}(?:\.\d+)?|100)%$/, yF = /^(\d+px|\d+em|\d*\.?\d+c)$/, sF = /^(\d+)px (\d+)px$/, EF = /^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/, FF = /^(?:(\d{2,}):)?(\d{2}):(\d{2})$/, HF = /^(?:(\d{2,}):)?(\d{2}):(\d{2}\.\d+)$/, IF = /^(\d*(?:\.\d*)?)f$/, JF = /^(\d*(?:\.\d*)?)t$/, KF = RegExp("^(?:(\\d*(?:\\.\\d*)?)h)?(?:(\\d*(?:\\.\\d*)?)m)?(?:(\\d*(?:\\.\\d*)?)s)?(?:(\\d*(?:\\.\\d*)?)ms)?$"), xF = (new Map).set("left", xe).set("center", "center").set("right", "end").set("start", xe).set("end", "end"), wF = (new Map).set("left", "line-left").set("center", "center").set("right", "line-right"), gF = [
            "http://www.w3.org/ns/ttml#parameter",
            "http://www.w3.org/2006/10/ttaf1#parameter"
        ], hF = [
            "http://www.w3.org/ns/ttml#styling",
            "http://www.w3.org/2006/10/ttaf1#styling"
        ], mF = [
            "http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt",
            "http://www.smpte-ra.org/schemas/2052-1/2013/smpte-tt"
        ];
        qf("application/ttml+xml", function() {
            return new fF;
        });
        function LF() {
            this.g = new fF;
        }
        LF.prototype.parseInit = function(a) {
            var b = !1;
            (new oh).box("moov", th).box("trak", th).box("mdia", th).box("minf", th).box("stbl", th).W("stsd", vh).box("stpp", function(c) {
                b = !0;
                c.parser.stop();
            }).parse(a);
            if (!b) throw new U(2, 2, 2007);
        };
        LF.prototype.setSequenceMode = function(a) {
            this.g.setSequenceMode(a);
        };
        LF.prototype.setManifestType = function(a) {
            this.g.setManifestType(a);
        };
        LF.prototype.parseMedia = function(a, b, c) {
            var d = [], e = null, f = [], g = new Map, h = [];
            (new oh).box("moof", th).box("traf", th).W("tfhd", function(z) {
                e = Ii(z.reader, z.flags).ke;
            }).W("trun", function(z) {
                z = Li(z.reader, z.version, z.flags);
                z = u(z.Zh);
                for(var y = z.next(); !y.done; y = z.next())h.push(y.value.sampleSize || e || 0);
            }).W("subs", function(z) {
                for(var y = z.reader, A = y.Z(), C = -1, E = 0; E < A; E++){
                    var D = y.Z();
                    C += D;
                    D = y.Ha();
                    for(var B = [], G = 0; G < D; G++)z.version == 1 ? B.push(y.Z()) : B.push(y.Ha()), y.ba(), y.ba(), y.Z();
                    g.set(C, B);
                }
            }).box("mdat", yh(function(z) {
                f.push(z);
            })).parse(a, !1);
            if (f.length == 0) throw new U(2, 2, 2007);
            for(var k = lc.apply(dc, x(f)), l = 0, m = 0; m < h.length; m++){
                var n = Kb(k, l, h[m]);
                l += h[m];
                var q = g.get(m);
                if (q && q.length) {
                    n = Kb(n, 0, q[0]);
                    for(var r = [], t = q[0], w = 1; w < q.length; w++){
                        var v = Kb(a, t, q[w]);
                        v = ec(v);
                        r.push("data:image/png;base64," + v);
                        t += q[w];
                    }
                    d = d.concat(this.g.parseMedia(n, b, c, r));
                } else d = d.concat(this.g.parseMedia(n, b, c, []));
            }
            return d;
        };
        S("shaka.text.Mp4TtmlParser", LF);
        LF.prototype.parseMedia = LF.prototype.parseMedia;
        LF.prototype.setManifestType = LF.prototype.setManifestType;
        LF.prototype.setSequenceMode = LF.prototype.setSequenceMode;
        LF.prototype.parseInit = LF.prototype.parseInit;
        qf('application/mp4; codecs="stpp"', function() {
            return new LF;
        });
        qf('application/mp4; codecs="stpp.ttml"', function() {
            return new LF;
        });
        qf('application/mp4; codecs="stpp.ttml.im1i"', function() {
            return new LF;
        });
        qf('application/mp4; codecs="stpp.ttml.im1t"', function() {
            return new LF;
        });
        qf('application/mp4; codecs="stpp.ttml.im2i"', function() {
            return new LF;
        });
        qf('application/mp4; codecs="stpp.ttml.im2t"', function() {
            return new LF;
        });
        qf('application/mp4; codecs="stpp.ttml.etd1"', function() {
            return new LF;
        });
        qf('application/mp4; codecs="stpp.ttml.etd1|im1t"', function() {
            return new LF;
        });
        qf('application/mp4; codecs="stpp.ttml.im1t|etd1"', function() {
            return new LF;
        });
        qf('application/mp4; codecs="stpp.TTML.im1t"', function() {
            return new LF;
        });
        function MF() {
            this.g = "UNKNOWN";
        }
        MF.prototype.parseInit = function() {};
        MF.prototype.setSequenceMode = function() {};
        MF.prototype.setManifestType = function(a) {
            this.g = a;
        };
        MF.prototype.parseMedia = function(a, b) {
            a = Wb(a);
            a = a.replace(/\r\n|\r(?=[^\n]|$)/gm, "\n");
            var c = a.split(/\n{2,}/m);
            if (!/^WEBVTT($|[ \t\n])/m.test(c[0])) throw new U(2, 2, 2E3);
            a = b.vttOffset;
            if (this.g == "HLS") {
                if (c[0].includes("X-TIMESTAMP-MAP")) {
                    var d = c[0];
                    a = d.match(/LOCAL:((?:(\d{1,}):)?(\d{2}):(\d{2})\.(\d{3}))/m);
                    d = d.match(/MPEGTS:(\d+)/m);
                    if (!a || !d) throw new U(2, 2, 2E3);
                    a = Dd(a[1]);
                    if (a == null) throw new U(2, 2, 2E3);
                    d = Number(d[1]);
                    for(var e = b.segmentStart - b.periodStart; e >= 95443.7176888889;)e -= 95443.7176888889, d += 8589934592;
                    a = b.periodStart + d / 9E4 - a;
                } else b.periodStart && b.vttOffset == b.periodStart && (a = 0);
            }
            b = [];
            d = u(c[0].split("\n"));
            for(e = d.next(); !e.done; e = d.next())if (e = e.value, /^Region:/.test(e)) {
                e = new wd(e);
                var f = new td;
                zd(e);
                xd(e);
                for(var g = zd(e); g;){
                    var h = f, k = g;
                    (g = /^id=(.*)$/.exec(k)) ? h.id = g[1] : (g = /^width=(\d{1,2}|100)%$/.exec(k)) ? h.width = Number(g[1]) : (g = /^lines=(\d+)$/.exec(k)) ? (h.height = Number(g[1]), h.heightUnits = 2) : (g = /^regionanchor=(\d{1,2}|100)%,(\d{1,2}|100)%$/.exec(k)) ? (h.regionAnchorX = Number(g[1]), h.regionAnchorY = Number(g[2])) : (g = /^viewportanchor=(\d{1,2}|100)%,(\d{1,2}|100)%$/.exec(k)) ? (h.viewportAnchorX = Number(g[1]), h.viewportAnchorY = Number(g[2])) : /^scroll=up$/.exec(k) && (h.scroll = "up");
                    xd(e);
                    g = zd(e);
                }
                b.push(f);
            }
            d = new Map;
            Ee(d);
            e = [];
            c = u(c.slice(1));
            for(f = c.next(); !f.done; f = c.next()){
                f = f.value.split("\n");
                if ((f.length != 1 || f[0]) && !/^NOTE($|[ \t])/.test(f[0]) && f[0] == "STYLE") {
                    h = [];
                    g = -1;
                    for(k = 1; k < f.length; k++)f[k].includes("::cue") && (h.push([]), g = h.length - 1), g != -1 && (h[g].push(f[k]), f[k].includes("}") && (g = -1));
                    h = u(h);
                    for(g = h.next(); !g.done; g = h.next()){
                        var l = g.value;
                        g = "global";
                        (k = l[0].match(/\((.*)\)/)) && (g = k.pop());
                        k = l.slice(1, -1);
                        l[0].includes("}") && (l = /\{(.*?)\}/.exec(l[0])) && (k = l[1].split(";"));
                        (l = d.get(g)) || (l = new re(0, 0, ""));
                        for(var m = !1, n = 0; n < k.length; n++){
                            var q = /^\s*([^:]+):\s*(.*)/.exec(k[n]);
                            if (q) {
                                var r = q[2].trim().replace(";", "");
                                switch(q[1].trim()){
                                    case "background-color":
                                    case "background":
                                        m = !0;
                                        l.backgroundColor = r;
                                        break;
                                    case "color":
                                        m = !0;
                                        l.color = r;
                                        break;
                                    case "font-family":
                                        m = !0;
                                        l.fontFamily = r;
                                        break;
                                    case "font-size":
                                        m = !0;
                                        l.fontSize = r;
                                        break;
                                    case "font-weight":
                                        if (parseInt(r, 10) >= 700 || r == "bold") m = !0, l.fontWeight = Oe;
                                        break;
                                    case "font-style":
                                        switch(r){
                                            case "normal":
                                                m = !0;
                                                l.fontStyle = Ae;
                                                break;
                                            case "italic":
                                                m = !0;
                                                l.fontStyle = Pe;
                                                break;
                                            case "oblique":
                                                m = !0, l.fontStyle = "oblique";
                                        }
                                        break;
                                    case "opacity":
                                        m = !0;
                                        l.opacity = parseFloat(r);
                                        break;
                                    case "text-combine-upright":
                                        m = !0;
                                        l.textCombineUpright = r;
                                        break;
                                    case "text-shadow":
                                        m = !0;
                                        l.textShadow = r;
                                        break;
                                    case "white-space":
                                        m = !0, l.wrapLine = r != "noWrap";
                                }
                            }
                        }
                        m && d.set(g, l);
                    }
                }
                l = f;
                m = a;
                if (l.length == 1 && !l[0] || /^NOTE($|[ \t])/.test(l[0]) || l[0] == "STYLE" || l[0] == "REGION") f = null;
                else if (f = null, l[0].includes("--\x3e") || (f = l[0], l.splice(0, 1)), h = new wd(l[0]), g = Ad(h), n = yd(h, /[ \t]+--\x3e[ \t]+/g), k = Ad(h), g == null || n == null || k == null) ab("Failed to parse VTT time code. Cue skipped:", f, l), f = null;
                else {
                    g += m;
                    k += m;
                    m = l.slice(1).join("\n").trim();
                    d.has("global") ? (l = d.get("global").clone(), l.startTime = g, l.endTime = k, l.payload = m) : l = new re(g, k, m);
                    xd(h);
                    for(g = zd(h); g;)NF(l, g, b), xd(h), g = zd(h);
                    De(l, d);
                    f != null && (l.id = f);
                    f = l;
                }
                f && e.push(f);
            }
            return e;
        };
        function NF(a, b, c) {
            var d;
            if (d = /^align:(start|middle|center|end|left|right)$/.exec(b)) b = d[1], b == "middle" ? a.textAlign = te : a.textAlign = Re[b.toUpperCase()];
            else if (d = /^vertical:(lr|rl)$/.exec(b)) a.writingMode = d[1] == "lr" ? "vertical-lr" : "vertical-rl";
            else if (d = /^size:([\d.]+)%$/.exec(b)) a.size = Number(d[1]);
            else if (d = /^position:([\d.]+)%(?:,(line-left|line-right|middle|center|start|end|auto))?$/.exec(b)) a.position = Number(d[1]), d[2] && (b = d[2], a.positionAlign = b == "line-left" || b == "start" ? "line-left" : b == "line-right" || b == "end" ? "line-right" : b == "center" || b == "middle" ? "center" : se);
            else if (d = /^region:(.*)$/.exec(b)) {
                if (b = OF(c, d[1])) a.region = b;
            } else if (c = /^line:([\d.]+)%(?:,(start|end|center))?$/.exec(b)) a.lineInterpretation = 1, a.line = Number(c[1]), c[2] && (a.lineAlign = Te[c[2].toUpperCase()]);
            else if (c = /^line:(-?\d+)(?:,(start|end|center))?$/.exec(b)) a.lineInterpretation = we, a.line = Number(c[1]), c[2] && (a.lineAlign = Te[c[2].toUpperCase()]);
        }
        function OF(a, b) {
            a = a.filter(function(c) {
                return c.id == b;
            });
            return a.length ? a[0] : null;
        }
        S("shaka.text.VttTextParser", MF);
        MF.prototype.parseMedia = MF.prototype.parseMedia;
        MF.prototype.setManifestType = MF.prototype.setManifestType;
        MF.prototype.setSequenceMode = MF.prototype.setSequenceMode;
        MF.prototype.parseInit = MF.prototype.parseInit;
        qf("text/vtt", function() {
            return new MF;
        });
        qf('text/vtt; codecs="vtt"', function() {
            return new MF;
        });
        qf('text/vtt; codecs="wvtt"', function() {
            return new MF;
        });
        function PF() {
            this.g = null;
        }
        PF.prototype.parseInit = function(a) {
            var b = this, c = !1;
            (new oh).box("moov", th).box("trak", th).box("mdia", th).W("mdhd", function(d) {
                d = Ki(d.reader, d.version);
                b.g = d.timescale;
            }).box("minf", th).box("stbl", th).W("stsd", vh).box("wvtt", function() {
                c = !0;
            }).parse(a);
            if (!this.g) throw new U(2, 2, 2008);
            if (!c) throw new U(2, 2, 2008);
        };
        PF.prototype.setSequenceMode = function() {};
        PF.prototype.setManifestType = function() {};
        PF.prototype.parseMedia = function(a, b) {
            if (!a.length) return [];
            if (!this.g) throw new U(2, 2, 2008);
            var c = 0, d = [], e, f = [], g = !1, h = !1, k = !1, l = null;
            (new oh).box("moof", th).box("traf", th).W("tfdt", function(A) {
                g = !0;
                c = Ji(A.reader, A.version).baseMediaDecodeTime;
            }).W("tfhd", function(A) {
                l = Ii(A.reader, A.flags).je;
            }).W("trun", function(A) {
                h = !0;
                d = Li(A.reader, A.version, A.flags).Zh;
            }).box("mdat", yh(function(A) {
                k = !0;
                e = A;
            })).parse(a, !1);
            if (!k && !g && !h) throw new U(2, 2, 2008);
            a = c;
            for(var m = new lh(e, 0), n = u(d), q = n.next(); !q.done; q = n.next()){
                q = q.value;
                var r = q.$h || l, t = q.cg ? c + q.cg : a;
                a = t + (r || 0);
                var w = 0;
                do {
                    var v = m.Z();
                    w += v;
                    var z = m.Z(), y = null;
                    sh(z) == "vttc" ? v > 8 && (y = m.ac(v - 8)) : m.skip(v - 8);
                    r && y && (v = QF(y, b.periodStart + t / this.g, b.periodStart + a / this.g), f.push(v));
                }while (q.sampleSize && w < q.sampleSize);
            }
            return f.filter(Ef);
        };
        function QF(a, b, c) {
            var d, e, f;
            (new oh).box("payl", yh(function(g) {
                d = Wb(g);
            })).box("iden", yh(function(g) {
                e = Wb(g);
            })).box("sttg", yh(function(g) {
                f = Wb(g);
            })).parse(a);
            return d ? RF(d, e, f, b, c) : null;
        }
        function RF(a, b, c, d, e) {
            a = new re(d, e, a);
            De(a);
            b && (a.id = b);
            if (c) for(b = new wd(c), c = zd(b); c;)NF(a, c, []), xd(b), c = zd(b);
            return a;
        }
        S("shaka.text.Mp4VttParser", PF);
        PF.prototype.parseMedia = PF.prototype.parseMedia;
        PF.prototype.setManifestType = PF.prototype.setManifestType;
        PF.prototype.setSequenceMode = PF.prototype.setSequenceMode;
        PF.prototype.parseInit = PF.prototype.parseInit;
        qf('application/mp4; codecs="wvtt"', function() {
            return new PF;
        });
        function SF() {}
        SF.prototype.parseInit = function() {};
        SF.prototype.setSequenceMode = function() {};
        SF.prototype.setManifestType = function() {};
        SF.prototype.parseMedia = function(a) {
            var b = Wb(a).replace(/\r+/g, "");
            b = b.trim();
            a = [];
            if (b == "") return a;
            b = u(b.split("\n\n"));
            for(var c = b.next(); !c.done; c = b.next()){
                c = c.value.split("\n");
                var d = new wd(c[0]), e = Ad(d), f = yd(d, /,/g);
                d = Ad(d);
                if (e == null || f == null || d == null) throw new U(2, 2, 2001, "Could not parse cue time range in SubViewer");
                a.push(new re(e, d, c.slice(1).join("\n").trim()));
            }
            return a;
        };
        S("shaka.text.SbvTextParser", SF);
        SF.prototype.parseMedia = SF.prototype.parseMedia;
        SF.prototype.setManifestType = SF.prototype.setManifestType;
        SF.prototype.setSequenceMode = SF.prototype.setSequenceMode;
        SF.prototype.parseInit = SF.prototype.parseInit;
        qf("text/x-subviewer", function() {
            return new SF;
        });
        function TF() {
            this.g = new MF;
        }
        TF.prototype.parseInit = function() {};
        TF.prototype.setSequenceMode = function() {};
        TF.prototype.setManifestType = function() {};
        TF.prototype.parseMedia = function(a, b, c) {
            a = Wb(a);
            a = UF(a);
            a = Kb($b(a));
            return this.g.parseMedia(a, b, c, []);
        };
        function UF(a) {
            var b = "WEBVTT\n\n";
            if (a == "") return b;
            a = a.replace(/\r+/g, "");
            a = a.trim();
            a = u(a.split("\n\n"));
            for(var c = a.next(); !c.done; c = a.next())c = c.value.split(/\n/), c[0].match(/\d+/) && c.shift(), c[0] = c[0].replace(/,/g, "."), b += c.join("\n").replace(/{b}/g, "<b>").replace(/{\/b}/g, "</b>").replace(/{i}/g, "<i>").replace(/{\/i}/g, "</i>").replace(/{u}/g, "<u>").replace(/{\/u}/g, "</u>") + "\n\n";
            return b;
        }
        S("shaka.text.SrtTextParser", TF);
        TF.srt2webvtt = UF;
        TF.prototype.parseMedia = TF.prototype.parseMedia;
        TF.prototype.setManifestType = TF.prototype.setManifestType;
        TF.prototype.setSequenceMode = TF.prototype.setSequenceMode;
        TF.prototype.parseInit = TF.prototype.parseInit;
        qf("text/srt", function() {
            return new TF;
        });
        function VF() {}
        VF.prototype.parseInit = function() {};
        VF.prototype.setSequenceMode = function() {};
        VF.prototype.setManifestType = function() {};
        VF.prototype.parseMedia = function(a) {
            var b = "", c = "", d = null, e = null;
            e = Wb(a).split(/\r?\n\s*\r?\n/);
            a = u(e);
            for(e = a.next(); !e.done; e = a.next()){
                var f = e.value;
                e = f;
                if (f = WF.exec(f)) d = f[1], e = f[2];
                d == "V4 Styles" || d == "V4+ Styles" ? (b = e, b = c ? b + ("\n" + e) : e) : d == "Events" && (c = c ? c + ("\n" + e) : e);
            }
            d = [];
            e = null;
            b = u(b.split(/\r?\n/));
            for(a = b.next(); !a.done; a = b.next())if (a = a.value, !/^\s*;/.test(a) && (f = XF.exec(a))) {
                if (a = f[1].trim(), f = f[2].trim(), a == "Format") e = f.split(YF);
                else if (a == "Style") {
                    a = f.split(YF);
                    f = {};
                    for(var g = 0; g < e.length && g < a.length; g++)f[e[g]] = a[g];
                    d.push(f);
                }
            }
            e = [];
            b = null;
            c = u(c.split(/\r?\n/));
            f = c.next();
            for(a = {}; !f.done; a = {
                Sj: void 0
            }, f = c.next())if (f = f.value, !/^\s*;/.test(f) && (g = XF.exec(f))) {
                if (f = g[1].trim(), g = g[2].trim(), f == "Format") b = g.split(YF);
                else if (f == "Dialogue") {
                    g = g.split(YF);
                    f = {};
                    for(var h = 0; h < b.length && h < g.length; h++)f[b[h]] = g[h];
                    h = ZF(f.Start);
                    var k = ZF(f.End);
                    g = new re(h, k, g.slice(b.length - 1).join(",").replace(/\\N/g, "\n").replace(/\{[^}]+\}/g, ""));
                    a.Sj = f.Style;
                    (a = d.find(function(l) {
                        return function(m) {
                            return m.Name == l.Sj;
                        };
                    }(a))) && $F(g, a);
                    e.push(g);
                }
            }
            return e;
        };
        function $F(a, b) {
            var c = b.Fontname;
            c && (a.fontFamily = c);
            if (c = b.Fontsize) a.fontSize = c + "px";
            if (c = b.PrimaryColour) {
                if (c = aG(c)) a.color = c;
            }
            if (c = b.BackColour) {
                if (c = aG(c)) a.backgroundColor = c;
            }
            b.Bold && (a.fontWeight = Oe);
            b.Italic && (a.fontStyle = Pe);
            b.Underline && a.textDecoration.push(Qe);
            if (c = b.Spacing) a.letterSpacing = c + "px";
            if (c = b.Alignment) switch(parseInt(c, 10)){
                case 1:
                    a.displayAlign = ye;
                    a.textAlign = "start";
                    break;
                case 2:
                    a.displayAlign = ye;
                    a.textAlign = te;
                    break;
                case 3:
                    a.displayAlign = ye;
                    a.textAlign = "end";
                    break;
                case 5:
                    a.displayAlign = "before";
                    a.textAlign = "start";
                    break;
                case 6:
                    a.displayAlign = "before";
                    a.textAlign = te;
                    break;
                case 7:
                    a.displayAlign = "before";
                    a.textAlign = "end";
                    break;
                case 9:
                    a.displayAlign = "center";
                    a.textAlign = "start";
                    break;
                case 10:
                    a.displayAlign = "center";
                    a.textAlign = te;
                    break;
                case 11:
                    a.displayAlign = "center", a.textAlign = "end";
            }
            if (b = b.AlphaLevel) a.opacity = parseFloat(b);
        }
        function aG(a) {
            a = parseInt(a.replace("&H", ""), 16);
            return a >= 0 ? "rgba(" + (a & 255) + "," + (a >> 8 & 255) + "," + (a >> 16 & 255) + "," + (a >> 24 & 255 ^ 255) / 255 + ")" : null;
        }
        function ZF(a) {
            a = bG.exec(a);
            return (a[1] ? parseInt(a[1].replace(":", ""), 10) : 0) * 3600 + parseInt(a[2], 10) * 60 + parseFloat(a[3]);
        }
        S("shaka.text.SsaTextParser", VF);
        VF.prototype.parseMedia = VF.prototype.parseMedia;
        VF.prototype.setManifestType = VF.prototype.setManifestType;
        VF.prototype.setSequenceMode = VF.prototype.setSequenceMode;
        VF.prototype.parseInit = VF.prototype.parseInit;
        var WF = /^\s*\[([^\]]+)\]\r?\n([\s\S]*)/, XF = /^\s*([^:]+):\s*(.*)/, YF = /\s*,\s*/, bG = /^(\d+:)?(\d{1,2}):(\d{1,2}(?:[.]\d{1,3})?)?$/;
        qf("text/x-ssa", function() {
            return new VF;
        });
        function cG(a, b) {
            var c = a[b + 1] & 1 ? 7 : 9;
            return b + c <= a.length && (a = ((a[b + 3] & 3) << 11 | a[b + 4] << 3 | (a[b + 5] & 224) >>> 5) - c, a > 0) ? {
                se: c,
                ya: a
            } : null;
        }
        function dG(a, b) {
            var c = [
                96E3,
                88200,
                64E3,
                48E3,
                44100,
                32E3,
                24E3,
                22050,
                16E3,
                12E3,
                11025,
                8E3,
                7350
            ], d = (a[b + 2] & 60) >>> 2;
            if (d > c.length - 1) return null;
            var e = ((a[b + 2] & 192) >>> 6) + 1, f = (a[b + 2] & 1) << 2;
            f |= (a[b + 3] & 192) >>> 6;
            return {
                sampleRate: c[d],
                channelCount: f,
                codec: "mp4a.40." + e
            };
        }
        function eG(a, b) {
            if (b + 1 < a.length && a[b] === 255 && (a[b + 1] & 246) === 240) {
                var c = a[b + 1] & 1 ? 7 : 9;
                if (b + c >= a.length) return !1;
                var d = (a[b + 3] & 3) << 11 | a[b + 4] << 3 | (a[b + 5] & 224) >>> 5;
                if (d <= c) return !1;
                b += d;
                return b === a.length || b + 1 < a.length && a[b] === 255 && (a[b + 1] & 246) === 240;
            }
            return !1;
        }
        function fG(a, b) {
            switch(a){
                case "mp4a.40.2":
                    if (b === 1) return new Uint8Array([
                        0,
                        200,
                        0,
                        128,
                        35,
                        128
                    ]);
                    if (b === 2) return new Uint8Array([
                        33,
                        0,
                        73,
                        144,
                        2,
                        25,
                        0,
                        35,
                        128
                    ]);
                    if (b === 3) return new Uint8Array([
                        0,
                        200,
                        0,
                        128,
                        32,
                        132,
                        1,
                        38,
                        64,
                        8,
                        100,
                        0,
                        142
                    ]);
                    if (b === 4) return new Uint8Array([
                        0,
                        200,
                        0,
                        128,
                        32,
                        132,
                        1,
                        38,
                        64,
                        8,
                        100,
                        0,
                        128,
                        44,
                        128,
                        8,
                        2,
                        56
                    ]);
                    if (b === 5) return new Uint8Array([
                        0,
                        200,
                        0,
                        128,
                        32,
                        132,
                        1,
                        38,
                        64,
                        8,
                        100,
                        0,
                        130,
                        48,
                        4,
                        153,
                        0,
                        33,
                        144,
                        2,
                        56
                    ]);
                    if (b === 6) return new Uint8Array([
                        0,
                        200,
                        0,
                        128,
                        32,
                        132,
                        1,
                        38,
                        64,
                        8,
                        100,
                        0,
                        130,
                        48,
                        4,
                        153,
                        0,
                        33,
                        144,
                        2,
                        0,
                        178,
                        0,
                        32,
                        8,
                        224
                    ]);
                    break;
                default:
                    if (b === 1) return new Uint8Array([
                        1,
                        64,
                        34,
                        128,
                        163,
                        78,
                        230,
                        128,
                        186,
                        8,
                        0,
                        0,
                        0,
                        28,
                        6,
                        241,
                        193,
                        10,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        94
                    ]);
                    if (b === 2 || b === 3) return new Uint8Array([
                        1,
                        64,
                        34,
                        128,
                        163,
                        94,
                        230,
                        128,
                        186,
                        8,
                        0,
                        0,
                        0,
                        0,
                        149,
                        0,
                        6,
                        241,
                        161,
                        10,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        94
                    ]);
            }
            return null;
        }
        function gG(a) {
            this.j = a;
            this.h = 0;
            this.g = new Map;
            this.i = null;
        }
        p = gG.prototype;
        p.destroy = function() {
            this.g.clear();
        };
        p.isSupported = function(a) {
            return a.toLowerCase().split(";")[0] == "audio/aac" ? gd(this.convertCodecs("audio", a)) : !1;
        };
        p.convertCodecs = function(a, b) {
            return b.toLowerCase().split(";")[0] == "audio/aac" ? 'audio/mp4; codecs="' + (nf(b) || "mp4a.40.2") + '"' : b;
        };
        p.getOriginalMimeType = function() {
            return this.j;
        };
        p.transmux = function(a, b, c, d) {
            for(var e = Kb(a), f = Zj(e), g = f.length; g < e.length && !eG(e, g); g++);
            a = c.endTime * 1E3;
            f = Yj(f);
            f.length && c && (f = f.find(function(m) {
                return m.description === "com.apple.streaming.transportStreamTimestamp";
            })) && (a = f.data);
            f = dG(e, g);
            if (!f) return Promise.reject(new U(2, 3, 3018, c ? c.T()[0] : null));
            b.audioSamplingRate = f.sampleRate;
            b.channelsCount = f.channelCount;
            for(var h = []; g < e.length;){
                var k = cG(e, g);
                if (!k) return Promise.reject(new U(2, 3, 3018, c ? c.T()[0] : null));
                var l = k.se + k.ya;
                g + l <= e.length && h.push({
                    data: e.subarray(g + k.se, g + l),
                    size: k.ya,
                    duration: 1024,
                    Cb: 0,
                    flags: {
                        Eb: 0,
                        wb: 0,
                        ub: 0,
                        rb: 0,
                        sb: 2,
                        Fb: 0
                    }
                });
                g += l;
            }
            e = f.sampleRate;
            a = Math.floor(a * e / 1E3);
            d = {
                id: b.id,
                type: "audio",
                codecs: f.codec,
                encrypted: b.encrypted && b.drmInfos.length > 0,
                timescale: e,
                duration: d,
                Hb: [],
                Na: new Uint8Array([]),
                Ya: new Uint8Array([]),
                eb: 0,
                gb: 0,
                data: {
                    sequenceNumber: this.h,
                    baseMediaDecodeTime: a,
                    Gb: h
                },
                stream: b
            };
            d = new Ri([
                d
            ]);
            c = b.id + "_" + c.i;
            this.g.has(c) ? b = this.g.get(c) : (b = Si(d), this.g.set(c, b));
            c = this.i !== b;
            d = mj(d);
            this.i = b;
            this.h++;
            return Promise.resolve({
                data: d,
                init: c ? b : null
            });
        };
        S("shaka.transmuxer.AacTransmuxer", gG);
        gG.prototype.transmux = gG.prototype.transmux;
        gG.prototype.getOriginalMimeType = gG.prototype.getOriginalMimeType;
        gG.prototype.convertCodecs = gG.prototype.convertCodecs;
        gG.prototype.isSupported = gG.prototype.isSupported;
        gG.prototype.destroy = gG.prototype.destroy;
        We("audio/aac", function() {
            return new gG("audio/aac");
        }, bf);
        function hG(a, b) {
            if (b + 8 > a.length || a[b] !== 11 || a[b + 1] !== 119) return null;
            var c = a[b + 4] >> 6;
            if (c >= 3) return null;
            var d = a[b + 4] & 63, e = [
                64,
                69,
                96,
                64,
                70,
                96,
                80,
                87,
                120,
                80,
                88,
                120,
                96,
                104,
                144,
                96,
                105,
                144,
                112,
                121,
                168,
                112,
                122,
                168,
                128,
                139,
                192,
                128,
                140,
                192,
                160,
                174,
                240,
                160,
                175,
                240,
                192,
                208,
                288,
                192,
                209,
                288,
                224,
                243,
                336,
                224,
                244,
                336,
                256,
                278,
                384,
                256,
                279,
                384,
                320,
                348,
                480,
                320,
                349,
                480,
                384,
                417,
                576,
                384,
                418,
                576,
                448,
                487,
                672,
                448,
                488,
                672,
                512,
                557,
                768,
                512,
                558,
                768,
                640,
                696,
                960,
                640,
                697,
                960,
                768,
                835,
                1152,
                768,
                836,
                1152,
                896,
                975,
                1344,
                896,
                976,
                1344,
                1024,
                1114,
                1536,
                1024,
                1115,
                1536,
                1152,
                1253,
                1728,
                1152,
                1254,
                1728,
                1280,
                1393,
                1920,
                1280,
                1394,
                1920
            ][d * 3 + c] * 2;
            if (b + e > a.length) return null;
            var f = a[b + 6] >> 5, g = 0;
            f === 2 ? g += 2 : (f & 1 && f !== 1 && (g += 2), f & 4 && (g += 2));
            g = (a[b + 6] << 8 | a[b + 7]) >> 12 - g & 1;
            var h = a[b + 5] & 7;
            a = new Uint8Array([
                c << 6 | a[b + 5] >> 3 << 1 | h >> 2,
                (h & 3) << 6 | f << 3 | g << 2 | d >> 4,
                d << 4 & 224
            ]);
            return {
                sampleRate: [
                    48E3,
                    44100,
                    32E3
                ][c],
                channelCount: [
                    2,
                    1,
                    2,
                    3,
                    3,
                    4,
                    4,
                    5
                ][f] + g,
                Na: a,
                ya: e
            };
        }
        function iG(a, b) {
            if (a[b] === 11 && a[b + 1] === 119) {
                var c = 0, d = 5;
                b += d;
                for(var e, f; d > 0;){
                    f = a[b];
                    var g = Math.min(d, 8), h = 8 - g;
                    e = 4278190080 >>> 24 + h << h;
                    e = (f & e) >> h;
                    c = c ? c << g | e : e;
                    b += 1;
                    d -= g;
                }
                if (c < 16) return !0;
            }
            return !1;
        }
        function jG(a) {
            this.j = a;
            this.h = 0;
            this.g = new Map;
            this.i = null;
        }
        p = jG.prototype;
        p.destroy = function() {
            this.g.clear();
        };
        p.isSupported = function(a) {
            return a.toLowerCase().split(";")[0] == "audio/ac3" ? gd(this.convertCodecs("audio", a)) : !1;
        };
        p.convertCodecs = function(a, b) {
            return b.toLowerCase().split(";")[0] == "audio/ac3" ? Rb().Fe() ? 'audio/mp4; codecs="ec-3"' : 'audio/mp4; codecs="ac-3"' : b;
        };
        p.getOriginalMimeType = function() {
            return this.j;
        };
        p.transmux = function(a, b, c, d) {
            a = Kb(a);
            for(var e = Zj(a), f = e.length; f < a.length && !iG(a, f); f++);
            var g = c.endTime * 1E3;
            e = Yj(e);
            e.length && c && (e = e.find(function(m) {
                return m.description === "com.apple.streaming.transportStreamTimestamp";
            })) && (g = e.data);
            e = 0;
            for(var h = new Uint8Array([]), k = []; f < a.length;){
                var l = hG(a, f);
                if (!l) return Promise.reject(new U(2, 3, 3018, c ? c.T()[0] : null));
                b.audioSamplingRate = l.sampleRate;
                b.channelsCount = l.channelCount;
                e = l.sampleRate;
                h = l.Na;
                k.push({
                    data: a.subarray(f, f + l.ya),
                    size: l.ya,
                    duration: 1536,
                    Cb: 0,
                    flags: {
                        Eb: 0,
                        wb: 0,
                        ub: 0,
                        rb: 0,
                        sb: 2,
                        Fb: 0
                    }
                });
                f += l.ya;
            }
            a = Math.floor(g * e / 1E3);
            d = {
                id: b.id,
                type: "audio",
                codecs: "ac-3",
                encrypted: b.encrypted && b.drmInfos.length > 0,
                timescale: e,
                duration: d,
                Hb: [],
                Na: h,
                Ya: new Uint8Array([]),
                eb: 0,
                gb: 0,
                data: {
                    sequenceNumber: this.h,
                    baseMediaDecodeTime: a,
                    Gb: k
                },
                stream: b
            };
            d = new Ri([
                d
            ]);
            c = b.id + "_" + c.i;
            this.g.has(c) ? b = this.g.get(c) : (b = Si(d), this.g.set(c, b));
            c = this.i !== b;
            d = mj(d);
            this.i = b;
            this.h++;
            return Promise.resolve({
                data: d,
                init: c ? b : null
            });
        };
        S("shaka.transmuxer.Ac3Transmuxer", jG);
        jG.prototype.transmux = jG.prototype.transmux;
        jG.prototype.getOriginalMimeType = jG.prototype.getOriginalMimeType;
        jG.prototype.convertCodecs = jG.prototype.convertCodecs;
        jG.prototype.isSupported = jG.prototype.isSupported;
        jG.prototype.destroy = jG.prototype.destroy;
        We("audio/ac3", function() {
            return new jG("audio/ac3");
        }, bf);
        function kG(a, b) {
            if (b + 8 > a.length || (a[b] << 8 | a[b + 1] << 0) !== 2935) return null;
            var c = new bk(a.subarray(b + 2));
            dk(c, 2);
            dk(c, 3);
            var d = ek(c, 11) + 1 << 1, e = ek(c, 2);
            if (e == 3) {
                e = ek(c, 2);
                e = [
                    24E3,
                    22060,
                    16E3
                ][e];
                var f = 3;
            } else e = [
                48E3,
                44100,
                32E3
            ][e], f = ek(c, 2);
            var g = ek(c, 3), h = ek(c, 1);
            c = ek(c, 5);
            if (b + d > a.byteLength) return null;
            a = Math.floor(d * e / ([
                1,
                2,
                3,
                6
            ][f] * 16));
            a = new Uint8Array([
                (a & 8160) >> 5,
                (a & 31) << 3,
                e << 6 | c << 1 | 0,
                0 | g << 1 | h << 0,
                0
            ]);
            return {
                sampleRate: e,
                channelCount: [
                    2,
                    1,
                    2,
                    3,
                    3,
                    4,
                    4,
                    5
                ][g] + h,
                Na: a,
                ya: d
            };
        }
        function lG(a) {
            this.j = a;
            this.h = 0;
            this.g = new Map;
            this.i = null;
        }
        p = lG.prototype;
        p.destroy = function() {
            this.g.clear();
        };
        p.isSupported = function(a) {
            return a.toLowerCase().split(";")[0] == "audio/ec3" ? gd(this.convertCodecs("audio", a)) : !1;
        };
        p.convertCodecs = function(a, b) {
            return b.toLowerCase().split(";")[0] == "audio/ec3" ? 'audio/mp4; codecs="ec-3"' : b;
        };
        p.getOriginalMimeType = function() {
            return this.j;
        };
        p.transmux = function(a, b, c, d) {
            a = Kb(a);
            for(var e = Zj(a), f = e.length; f < a.length && (a[f] << 8 | a[f + 1] << 0) !== 2935; f++);
            var g = c.endTime * 1E3;
            e = Yj(e);
            e.length && c && (e = e.find(function(m) {
                return m.description === "com.apple.streaming.transportStreamTimestamp";
            })) && (g = e.data);
            e = 0;
            for(var h = new Uint8Array([]), k = []; f < a.length;){
                var l = kG(a, f);
                if (!l) return Promise.reject(new U(2, 3, 3018, c ? c.T()[0] : null));
                b.audioSamplingRate = l.sampleRate;
                b.channelsCount = l.channelCount;
                e = l.sampleRate;
                h = l.Na;
                k.push({
                    data: a.subarray(f, f + l.ya),
                    size: l.ya,
                    duration: 1536,
                    Cb: 0,
                    flags: {
                        Eb: 0,
                        wb: 0,
                        ub: 0,
                        rb: 0,
                        sb: 2,
                        Fb: 0
                    }
                });
                f += l.ya;
            }
            a = Math.floor(g * e / 1E3);
            d = {
                id: b.id,
                type: "audio",
                codecs: "ec-3",
                encrypted: b.encrypted && b.drmInfos.length > 0,
                timescale: e,
                duration: d,
                Hb: [],
                Na: h,
                Ya: new Uint8Array([]),
                eb: 0,
                gb: 0,
                data: {
                    sequenceNumber: this.h,
                    baseMediaDecodeTime: a,
                    Gb: k
                },
                stream: b
            };
            d = new Ri([
                d
            ]);
            c = b.id + "_" + c.i;
            this.g.has(c) ? b = this.g.get(c) : (b = Si(d), this.g.set(c, b));
            c = this.i !== b;
            d = mj(d);
            this.i = b;
            this.h++;
            return Promise.resolve({
                data: d,
                init: c ? b : null
            });
        };
        S("shaka.transmuxer.Ec3Transmuxer", lG);
        lG.prototype.transmux = lG.prototype.transmux;
        lG.prototype.getOriginalMimeType = lG.prototype.getOriginalMimeType;
        lG.prototype.convertCodecs = lG.prototype.convertCodecs;
        lG.prototype.isSupported = lG.prototype.isSupported;
        lG.prototype.destroy = lG.prototype.destroy;
        We("audio/ec3", function() {
            return new lG("audio/ec3");
        }, bf);
        function mG(a) {
            if (!a.length) return null;
            var b = a.find(function(w) {
                return w.type == 7;
            });
            a = a.find(function(w) {
                return w.type == 8;
            });
            if (!b || !a) return null;
            var c = new bk(b.data), d = kk(c);
            kk(c);
            kk(c);
            gk(c);
            if (nG.includes(d) && (d = hk(c), d === 3 && dk(c, 1), gk(c), gk(c), dk(c, 1), jk(c))) {
                d = d !== 3 ? 8 : 12;
                for(var e = 0; e < d; e++)jk(c) && (e < 6 ? lk(c, 16) : lk(c, 64));
            }
            gk(c);
            d = hk(c);
            if (d === 0) hk(c);
            else if (d === 1) for(dk(c, 1), gk(c), gk(c), d = hk(c), e = 0; e < d; e++)gk(c);
            gk(c);
            dk(c, 1);
            var f = hk(c), g = hk(c), h = ek(c, 1);
            h === 0 && dk(c, 1);
            dk(c, 1);
            var k = 0, l = 0, m = 0, n = 0;
            jk(c) && (k = hk(c), l = hk(c), m = hk(c), n = hk(c));
            e = d = 1;
            if (jk(c) && jk(c)) {
                var q = kk(c), r = [
                    1,
                    12,
                    10,
                    16,
                    40,
                    24,
                    20,
                    32,
                    80,
                    18,
                    15,
                    64,
                    160,
                    4,
                    3,
                    2
                ], t = [
                    1,
                    11,
                    11,
                    11,
                    33,
                    11,
                    11,
                    11,
                    33,
                    11,
                    11,
                    33,
                    99,
                    3,
                    2,
                    1
                ];
                q > 0 && q <= 16 ? (d = r[q - 1], e = t[q - 1]) : q === 255 && (d = ek(c, 16), e = ek(c, 16));
            }
            c = (2 - h) * (g + 1) * 16 - m * 2 - n * 2;
            f = (f + 1) * 16 - k * 2 - l * 2;
            k = [];
            b = b.fullData;
            k.push(b.byteLength >>> 8 & 255);
            k.push(b.byteLength & 255);
            k = k.concat.apply(k, x(b));
            b = [];
            a = a.fullData;
            b.push(a.byteLength >>> 8 & 255);
            b.push(a.byteLength & 255);
            b = b.concat.apply(b, x(a));
            a = new Uint8Array([
                1,
                k[3],
                k[4],
                k[5],
                255,
                225
            ].concat(k, [
                1
            ], b));
            return {
                height: c,
                width: f,
                Ya: a,
                eb: d,
                gb: e
            };
        }
        function oG(a) {
            function b(t) {
                e = {
                    data: new Uint8Array([]),
                    frame: !1,
                    isKeyframe: !1,
                    pts: t.pts,
                    dts: t.dts,
                    nalus: []
                };
            }
            function c() {
                if (e && e.nalus.length && e.frame) {
                    for(var t = [], w = u(e.nalus), v = w.next(); !v.done; v = w.next()){
                        v = v.value;
                        var z = v.fullData.byteLength, y = new Uint8Array(4);
                        y[0] = z >> 24 & 255;
                        y[1] = z >> 16 & 255;
                        y[2] = z >> 8 & 255;
                        y[3] = z & 255;
                        t.push(y);
                        t.push(v.fullData);
                    }
                    e.data = lc.apply(dc, x(t));
                    d.push(e);
                }
            }
            for(var d = [], e = null, f = !1, g = 0; g < a.length; g++){
                var h = a[g], k = h.nalus, l = !1;
                e && k.length && !f && (c(), b(h));
                k = u(h.nalus);
                for(var m = k.next(); !m.done; m = k.next()){
                    m = m.value;
                    var n = !1;
                    switch(m.type){
                        case 1:
                            var q = !1;
                            n = !0;
                            var r = m.data;
                            l && r.length > 4 && (r = mk(new bk(r)), r === 2 || r === 4 || r === 7 || r === 9) && (q = !0);
                            q && e && e.frame && !e.isKeyframe && (c(), e = null);
                            e || b(h);
                            e.frame = !0;
                            e.isKeyframe = q;
                            break;
                        case 5:
                            n = !0;
                            e && e.frame && !e.isKeyframe && (c(), e = null);
                            e || b(h);
                            e.frame = !0;
                            e.isKeyframe = !0;
                            break;
                        case 6:
                            n = !0;
                            break;
                        case 7:
                            l = n = !0;
                            break;
                        case 8:
                            n = !0;
                            break;
                        case 9:
                            f = n = !0;
                            e && e.frame && (c(), e = null);
                            e || b(h);
                            break;
                        case 12:
                            n = !0;
                            break;
                        default:
                            n = !1;
                    }
                    e && n && e.nalus.push(m);
                }
            }
            c();
            return d;
        }
        var nG = [
            100,
            110,
            122,
            244,
            44,
            83,
            86,
            118,
            128,
            138,
            139,
            134
        ];
        function pG(a) {
            if (!a.length) return null;
            var b = a.find(function(g) {
                return g.type == 32;
            }), c = a.find(function(g) {
                return g.type == 33;
            }), d = a.find(function(g) {
                return g.type == 34;
            });
            if (!b || !c || !d) return null;
            var e = qG(b.fullData);
            a = rG(c.fullData);
            var f = sG(d.fullData);
            b = tG(b.fullData, c.fullData, d.fullData, {
                Mh: e.Mh,
                ri: e.ri,
                kh: a.kh,
                mh: a.mh,
                eh: a.eh,
                jh: a.jh,
                fh: a.fh,
                gh: a.gh,
                hh: a.hh,
                ih: a.ih,
                Yg: a.Yg,
                Zg: a.Zg,
                $g: a.$g,
                ah: a.ah,
                bh: a.bh,
                dh: a.dh,
                Mf: a.Mf,
                Ng: a.Ng,
                Jg: a.Jg,
                Ig: a.Ig,
                Oh: f.Oh,
                Xg: a.Xg,
                Wg: a.Wg
            });
            return {
                height: a.height,
                width: a.width,
                Ya: b,
                eb: a.om,
                gb: a.nm
            };
        }
        function qG(a) {
            var b = new bk(a, !0);
            kk(b);
            kk(b);
            ek(b, 4);
            ek(b, 2);
            ek(b, 6);
            a = ek(b, 3);
            b = jk(b);
            return {
                Mh: a + 1,
                ri: b
            };
        }
        function rG(a) {
            a = new bk(a, !0);
            kk(a);
            kk(a);
            var b = 0, c = 0, d = 0, e = 0;
            ek(a, 4);
            var f = ek(a, 3);
            jk(a);
            for(var g = ek(a, 2), h = ek(a, 1), k = ek(a, 5), l = kk(a), m = kk(a), n = kk(a), q = kk(a), r = kk(a), t = kk(a), w = kk(a), v = kk(a), z = kk(a), y = kk(a), A = kk(a), C = [], E = [], D = 0; D < f; D++)C.push(jk(a)), E.push(jk(a));
            if (f > 0) for(D = f; D < 8; D++)ek(a, 2);
            for(D = 0; D < f; D++)C[D] && ek(a, 88), E[D] && kk(a);
            hk(a);
            C = hk(a);
            C == 3 && ek(a, 1);
            E = hk(a);
            D = hk(a);
            jk(a) && (b += hk(a), c += hk(a), d += hk(a), e += hk(a));
            var B = hk(a), G = hk(a), I = hk(a);
            if (jk(a)) for(var J = 0; J <= f; J++)hk(a), hk(a), hk(a);
            else hk(a), hk(a), hk(a);
            hk(a);
            hk(a);
            hk(a);
            hk(a);
            hk(a);
            hk(a);
            if (jk(a) && jk(a)) for(J = 0; J < 4; J++)for(var L = 0; L < (J === 3 ? 2 : 6); L++)if (jk(a)) {
                var K = Math.min(64, 1 << 4 + (J << 1));
                J > 1 && ik(a);
                for(var N = 0; N < K; N++)ik(a);
            } else hk(a);
            jk(a);
            jk(a);
            jk(a) && (kk(a), hk(a), hk(a), jk(a));
            J = hk(a);
            for(K = L = 0; K < J; K++)if (N = !1, K !== 0 && (N = jk(a)), N) {
                K === J && hk(a);
                jk(a);
                hk(a);
                for(var P = N = 0; P <= L; P++){
                    var O = jk(a), M = !1;
                    O || (M = jk(a));
                    (O || M) && N++;
                }
                L = N;
            } else {
                P = hk(a);
                N = hk(a);
                L = P + N;
                for(O = 0; O < P; O++)hk(a), jk(a);
                for(P = 0; P < N; P++)hk(a), jk(a);
            }
            if (jk(a)) for(J = hk(a), L = 0; L < J; L++){
                for(K = 0; K < I + 4; K++)ek(a, 1);
                ek(a, 1);
            }
            J = I = 1;
            L = !0;
            K = 1;
            P = N = 0;
            jk(a);
            jk(a);
            if (jk(a)) {
                if (jk(a)) {
                    O = kk(a);
                    M = [
                        1,
                        12,
                        10,
                        16,
                        40,
                        24,
                        20,
                        32,
                        80,
                        18,
                        15,
                        64,
                        160,
                        4,
                        3,
                        2
                    ];
                    var R = [
                        1,
                        11,
                        11,
                        11,
                        33,
                        11,
                        11,
                        11,
                        33,
                        11,
                        11,
                        33,
                        99,
                        3,
                        2,
                        1
                    ];
                    O > 0 && O <= 16 ? (I = M[O - 1], J = R[O - 1]) : O === 255 && (I = ek(a, 16), J = ek(a, 16));
                }
                jk(a) && jk(a);
                jk(a) && (ek(a, 3), jk(a), jk(a) && (kk(a), kk(a), kk(a)));
                jk(a) && (hk(a), hk(a));
                jk(a);
                jk(a);
                jk(a);
                if (O = jk(a)) gk(a), gk(a), gk(a), gk(a);
                if (jk(a) && (K = ek(a, 32), N = ek(a, 32), jk(a) && hk(a), jk(a))) {
                    R = !1;
                    O = jk(a);
                    M = jk(a);
                    if (O || M) {
                        if (R = jk(a)) kk(a), ek(a, 5), jk(a), ek(a, 5);
                        ek(a, 4);
                        ek(a, 4);
                        R && ek(a, 4);
                        ek(a, 5);
                        ek(a, 5);
                        ek(a, 5);
                    }
                    for(var W = 0; W <= f; W++){
                        L = jk(a);
                        var wa = !0, Y = 1;
                        L || (wa = jk(a));
                        var Ka = !1;
                        wa ? hk(a) : Ka = jk(a);
                        Ka || (Y = hk(a) + 1);
                        if (O) {
                            for(wa = 0; wa < Y; wa++)hk(a), hk(a), R && (hk(a), hk(a));
                            jk(a);
                        }
                        if (M) {
                            for(wa = 0; wa < Y; wa++)hk(a), hk(a), R && (hk(a), hk(a));
                            jk(a);
                        }
                    }
                }
                jk(a) && (jk(a), jk(a), jk(a), P = hk(a), hk(a), hk(a), hk(a), hk(a));
            }
            return {
                eh: A,
                kh: g,
                mh: h,
                jh: k,
                fh: l,
                gh: m,
                hh: n,
                ih: q,
                Yg: r,
                Zg: t,
                $g: w,
                ah: v,
                bh: z,
                dh: y,
                Mf: P,
                Ng: C,
                Jg: B,
                Ig: G,
                width: E - (b + c) * (C === 1 || C === 2 ? 2 : 1),
                height: D - (d + e) * (C === 1 ? 2 : 1),
                om: I,
                nm: J,
                Xg: N / K,
                Wg: L
            };
        }
        function sG(a) {
            var b = new bk(a, !0);
            kk(b);
            kk(b);
            hk(b);
            hk(b);
            jk(b);
            jk(b);
            ek(b, 3);
            jk(b);
            jk(b);
            hk(b);
            hk(b);
            ik(b);
            jk(b);
            jk(b);
            jk(b) && hk(b);
            ik(b);
            ik(b);
            jk(b);
            jk(b);
            jk(b);
            jk(b);
            a = jk(b);
            b = jk(b);
            var c = 1;
            b && a ? c = 0 : b ? c = 3 : a && (c = 2);
            return {
                Oh: c
            };
        }
        function tG(a, b, c, d) {
            var e = new Uint8Array(23 + (5 + a.byteLength) + (5 + b.byteLength) + (5 + c.byteLength));
            e[0] = 1;
            e[1] = (d.kh & 3) << 6 | (d.mh ? 1 : 0) << 5 | d.jh & 31;
            e[2] = d.fh;
            e[3] = d.gh;
            e[4] = d.hh;
            e[5] = d.ih;
            e[6] = d.Yg;
            e[7] = d.Zg;
            e[8] = d.$g;
            e[9] = d.ah;
            e[10] = d.bh;
            e[11] = d.dh;
            e[12] = d.eh;
            e[13] = 240 | (d.Mf & 3840) >> 8;
            e[14] = d.Mf & 255;
            e[15] = 252 | d.Oh & 3;
            e[16] = 252 | d.Ng & 3;
            e[17] = 248 | d.Jg & 7;
            e[18] = 248 | d.Ig & 7;
            e[19] = 0;
            e[20] = parseInt(d.Xg, 10);
            e[21] = ((d.Wg ? 1 : 0) & 3) << 6 | (d.Mh & 7) << 3 | (d.ri ? 1 : 0) << 2 | 3;
            e[22] = 3;
            a = [
                a,
                b,
                c
            ];
            b = 23;
            c = a.length - 1;
            for(d = 0; d < a.length; d += 1)e.set(new Uint8Array([
                32 + d | (d === c ? 128 : 0),
                0,
                1
            ]), b), b += 3, e.set(new Uint8Array([
                a[d].byteLength >> 8,
                a[d].byteLength & 255
            ]), b), b += 2, e.set(a[d], b), b += a[d].byteLength;
            return e;
        }
        function uG(a, b) {
            var c = a[b + 1] >> 3 & 3, d = a[b + 1] >> 1 & 3, e = a[b + 2] >> 4 & 15, f = a[b + 2] >> 2 & 3;
            if (c !== 1 && e !== 0 && e !== 15 && f !== 3) {
                var g = a[b + 3] >> 6;
                e = vG[(c === 3 ? 3 - d : d === 3 ? 3 : 4) * 14 + e - 1] * 1E3;
                f = wG[(c === 3 ? 0 : c === 2 ? 1 : 2) * 3 + f];
                c = xG[c][d];
                var h = yG[d], k = Math.floor(c * e / f + (a[b + 2] >> 1 & 1)) * h, l = (navigator.userAgent || "").match(/Chrome\/(\d+)/i);
                (l = l ? parseInt(l[1], 10) : 0) && l <= 87 && d === 2 && e >= 224E3 && g === 0 && (a[b + 3] |= 128);
                return {
                    sampleRate: f,
                    channelCount: g === 3 ? 1 : 2,
                    ya: k,
                    lm: c * 8 * h
                };
            }
            return null;
        }
        function zG(a, b) {
            return a[b] === 255 && (a[b + 1] & 224) === 224 && (a[b + 1] & 6) !== 0;
        }
        function AG(a, b) {
            if (b + 1 < a.length && zG(a, b)) {
                var c = uG(a, b), d = 4;
                c && c.ya && (d = c.ya);
                b += d;
                return b === a.length || b + 1 < a.length && zG(a, b);
            }
            return !1;
        }
        var vG = [
            32,
            64,
            96,
            128,
            160,
            192,
            224,
            256,
            288,
            320,
            352,
            384,
            416,
            448,
            32,
            48,
            56,
            64,
            80,
            96,
            112,
            128,
            160,
            192,
            224,
            256,
            320,
            384,
            32,
            40,
            48,
            56,
            64,
            80,
            96,
            112,
            128,
            160,
            192,
            224,
            256,
            320,
            32,
            48,
            56,
            64,
            80,
            96,
            112,
            128,
            144,
            160,
            176,
            192,
            224,
            256,
            8,
            16,
            24,
            32,
            40,
            48,
            56,
            64,
            80,
            96,
            112,
            128,
            144,
            160
        ], wG = [
            44100,
            48E3,
            32E3,
            22050,
            24E3,
            16E3,
            11025,
            12E3,
            8E3
        ], xG = [
            [
                0,
                72,
                144,
                12
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                72,
                144,
                12
            ],
            [
                0,
                144,
                144,
                12
            ]
        ], yG = [
            0,
            1,
            1,
            4
        ];
        function BG(a) {
            this.j = a;
            this.h = 0;
            this.g = new Map;
            this.i = null;
        }
        p = BG.prototype;
        p.destroy = function() {
            this.g.clear();
        };
        p.isSupported = function(a) {
            return a.toLowerCase().split(";")[0] == "audio/mpeg" ? gd(this.convertCodecs("audio", a)) : !1;
        };
        p.convertCodecs = function(a, b) {
            return b.toLowerCase().split(";")[0] == "audio/mpeg" ? 'audio/mp4; codecs="mp3"' : b;
        };
        p.getOriginalMimeType = function() {
            return this.j;
        };
        p.transmux = function(a, b, c, d) {
            for(var e = Kb(a), f = Zj(e).length; f < e.length && !AG(e, f); f++);
            var g;
            for(a = []; f < e.length;){
                var h = uG(e, f);
                if (!h) return Promise.reject(new U(2, 3, 3018, c ? c.T()[0] : null));
                g || (g = h);
                f + h.ya <= e.length && a.push({
                    data: e.subarray(f, f + h.ya),
                    size: h.ya,
                    duration: 1152,
                    Cb: 0,
                    flags: {
                        Eb: 0,
                        wb: 0,
                        ub: 0,
                        rb: 0,
                        sb: 2,
                        Fb: 0
                    }
                });
                f += h.ya;
            }
            if (!g) return Promise.reject(new U(2, 3, 3018, c ? c.T()[0] : null));
            e = g.lm * 9E4 / g.sampleRate * this.h;
            d = {
                id: b.id,
                type: "audio",
                codecs: "mp3",
                encrypted: b.encrypted && b.drmInfos.length > 0,
                timescale: g.sampleRate,
                duration: d,
                Hb: [],
                Na: new Uint8Array([]),
                Ya: new Uint8Array([]),
                eb: 0,
                gb: 0,
                data: {
                    sequenceNumber: this.h,
                    baseMediaDecodeTime: e,
                    Gb: a
                },
                stream: b
            };
            d = new Ri([
                d
            ]);
            c = b.id + "_" + c.i;
            this.g.has(c) ? b = this.g.get(c) : (b = Si(d), this.g.set(c, b));
            c = this.i !== b;
            d = mj(d);
            this.i = b;
            this.h++;
            return Promise.resolve({
                data: d,
                init: c ? b : null
            });
        };
        S("shaka.transmuxer.Mp3Transmuxer", BG);
        BG.prototype.transmux = BG.prototype.transmux;
        BG.prototype.getOriginalMimeType = BG.prototype.getOriginalMimeType;
        BG.prototype.convertCodecs = BG.prototype.convertCodecs;
        BG.prototype.isSupported = BG.prototype.isSupported;
        BG.prototype.destroy = BG.prototype.destroy;
        We("audio/mpeg", function() {
            return new BG("audio/mpeg");
        }, bf);
        function CG(a) {
            this.h = a;
            this.g = null;
        }
        p = CG.prototype;
        p.destroy = function() {};
        p.isSupported = function(a) {
            if (a.toLowerCase().split(";")[0] != "video/mp2t") return !1;
            var b = nf(a).split(","), c = qc("audio", b);
            b = qc("video", b);
            return !c || b || jf(c) != "mp3" ? !1 : gd(this.convertCodecs("audio", a));
        };
        p.convertCodecs = function(a, b) {
            return b.toLowerCase().split(";")[0] == "video/mp2t" ? "audio/mpeg" : b;
        };
        p.getOriginalMimeType = function() {
            return this.h;
        };
        p.transmux = function(a, b, c, d, e) {
            this.g ? this.g.clearData() : this.g = new nk;
            this.g.gg(c.i);
            a = Kb(a);
            a = this.g.parse(a);
            if (a.le().audio != "mp3" || e != "audio") return Promise.reject(new U(2, 3, 3018, c ? c.T()[0] : null));
            c = new Uint8Array([]);
            e = u(a.Db());
            for(a = e.next(); !a.done; a = e.next())if (a = a.value.data) for(b = 0; b < a.length;)(d = uG(a, b)) ? (b + d.ya <= a.length && (c = lc(c, a.subarray(b, b + d.ya))), b += d.ya) : b++;
            return Promise.resolve(c);
        };
        S("shaka.transmuxer.MpegTsTransmuxer", CG);
        CG.prototype.transmux = CG.prototype.transmux;
        CG.prototype.getOriginalMimeType = CG.prototype.getOriginalMimeType;
        CG.prototype.convertCodecs = CG.prototype.convertCodecs;
        CG.prototype.isSupported = CG.prototype.isSupported;
        CG.prototype.destroy = CG.prototype.destroy;
        We("video/mp2t", function() {
            return new CG("video/mp2t");
        }, af); /*
 @license
 MSS Transmuxer
 Copyright 2015 Dash Industry Forum
 SPDX-License-Identifier: BSD-3-Clause
*/ 
        function DG(a) {
            this.h = a;
            (this.g = dy.get("ISOBoxer")()) && EG(this);
        }
        function EG(a) {
            function b() {
                this._procFullBox();
                this.flags & 1 && (this._procField("AlgorithmID", "uint", 24), this._procField("IV_size", "uint", 8), this._procFieldArray("KID", 16, "uint", 8));
                this._procField("sample_count", "uint", 32);
                this._procEntries("entry", this.sample_count, function(c) {
                    this._procEntryField(c, "InitializationVector", "data", 8);
                    this.flags & 2 && (this._procEntryField(c, "NumberOfEntries", "uint", 16), this._procSubEntries(c, "clearAndCryptedData", c.NumberOfEntries, function(d) {
                        this._procEntryField(d, "BytesOfClearData", "uint", 16);
                        this._procEntryField(d, "BytesOfEncryptedData", "uint", 32);
                    }));
                });
            }
            a.g.addBoxProcessor("saio", function() {
                this._procFullBox();
                this.flags & 1 && (this._procField("aux_info_type", "uint", 32), this._procField("aux_info_type_parameter", "uint", 32));
                this._procField("entry_count", "uint", 32);
                this._procFieldArray("offset", this.entry_count, "uint", this.version === 1 ? 64 : 32);
            });
            a.g.addBoxProcessor("saiz", function() {
                this._procFullBox();
                this.flags & 1 && (this._procField("aux_info_type", "uint", 32), this._procField("aux_info_type_parameter", "uint", 32));
                this._procField("default_sample_info_size", "uint", 8);
                this._procField("sample_count", "uint", 32);
                this.default_sample_info_size === 0 && this._procFieldArray("sample_info_size", this.sample_count, "uint", 8);
            });
            a.g.addBoxProcessor("senc", b);
            a.g.addBoxProcessor("uuid", function() {
                for(var c = !0, d = 0; d < 16; d++)this.usertype[d] !== FG[d] && (c = !1);
                c && (this._parsing && (this.type = "sepiff"), b.call(this));
            });
        }
        p = DG.prototype;
        p.destroy = function() {};
        p.isSupported = function(a, b) {
            var c = a.startsWith("mss/");
            if (!this.g || !c) return !1;
            if (b) return gd(this.convertCodecs(b, a));
            b = this.convertCodecs("audio", a);
            a = this.convertCodecs("video", a);
            return gd(b) || gd(a);
        };
        p.convertCodecs = function(a, b) {
            return b.replace("mss/", "");
        };
        p.getOriginalMimeType = function() {
            return this.h;
        };
        p.transmux = function(a, b, c) {
            if (!c) return Promise.resolve(Kb(a));
            if (!b.mssPrivateData) return Promise.reject(new U(2, 3, 3020, c ? c.T()[0] : null));
            try {
                var d, e = this.g.parseBuffer(a), f = e.fetch("tfhd");
                f.track_ID = b.id + 1;
                var g = e.fetch("tfdt"), h = e.fetch("traf");
                g === null && (g = this.g.createFullBox("tfdt", h, f), g.version = 1, g.flags = 0, g.baseMediaDecodeTime = Math.floor(c.startTime * b.mssPrivateData.timescale));
                var k = e.fetch("trun"), l = e.fetch("tfxd");
                l && l._parent.boxes.splice(l._parent.boxes.indexOf(l), 1);
                var m = e.fetch("tfrf");
                m && m._parent.boxes.splice(m._parent.boxes.indexOf(m), 1);
                var n = e.fetch("sepiff");
                if (n !== null) {
                    n.type = "senc";
                    n.usertype = void 0;
                    var q = e.fetch("saio");
                    if (q === null) {
                        q = this.g.createFullBox("saio", h);
                        q.version = 0;
                        q.flags = 0;
                        q.entry_count = 1;
                        q.offset = [
                            0
                        ];
                        var r = this.g.createFullBox("saiz", h);
                        r.version = 0;
                        r.flags = 0;
                        r.sample_count = n.sample_count;
                        r.default_sample_info_size = 0;
                        r.sample_info_size = [];
                        if (n.flags & 2) for(d = 0; d < n.sample_count; d += 1)r.sample_info_size[d] = 10 + 6 * n.entry[d].NumberOfEntries;
                        else r.default_sample_info_size = 8;
                    }
                }
                f.flags &= 16777214;
                f.flags |= 131072;
                k.flags |= 1;
                var t = e.fetch("moof");
                k.data_offset = t.getLength() + 8;
                var w = e.fetch("saio");
                w !== null && (w.offset[0] = GG(t, "traf") + GG(h, "senc") + 16);
                var v = Kb(e.write());
                return Promise.resolve(v);
            } catch (z) {
                return z instanceof U ? Promise.reject(z) : Promise.reject(new U(2, 3, 3022, c ? c.T()[0] : null));
            }
        };
        function GG(a, b) {
            for(var c = 8, d = 0; d < a.boxes.length && a.boxes[d].type !== b; d++)c += a.boxes[d].size;
            return c;
        }
        S("shaka.transmuxer.MssTransmuxer", DG);
        DG.prototype.transmux = DG.prototype.transmux;
        DG.prototype.getOriginalMimeType = DG.prototype.getOriginalMimeType;
        DG.prototype.convertCodecs = DG.prototype.convertCodecs;
        DG.prototype.isSupported = DG.prototype.isSupported;
        DG.prototype.destroy = DG.prototype.destroy;
        var FG = new Uint8Array([
            162,
            57,
            79,
            82,
            90,
            155,
            79,
            20,
            162,
            68,
            108,
            66,
            124,
            100,
            141,
            244
        ]);
        We("mss/audio/mp4", function() {
            return new DG("mss/audio/mp4");
        }, bf);
        We("mss/video/mp4", function() {
            return new DG("mss/video/mp4");
        }, bf);
        function HG(a) {
            this.m = a;
            this.g = 0;
            this.j = new Map;
            this.l = this.i = this.h = null;
        }
        p = HG.prototype;
        p.destroy = function() {
            this.j.clear();
            this.i && this.i.destroy();
        };
        p.isSupported = function(a, b) {
            if (a.toLowerCase().split(";")[0] != "video/mp2t") return !1;
            var c = a;
            b && (c = this.convertCodecs(b, a));
            var d = nf(c).split(",");
            c = qc("audio", d);
            d = qc("video", d);
            if (c && (c = jf(c), !IG.includes(c)) || d && (c = jf(d), !JG.includes(c))) return !1;
            if (b) return gd(this.convertCodecs(b, a));
            b = this.convertCodecs("audio", a);
            a = this.convertCodecs("video", a);
            return gd(b) || gd(a);
        };
        p.convertCodecs = function(a, b) {
            return b.toLowerCase().split(";")[0] == "video/mp2t" ? (b = nf(b).replace("mp4a.40.34", "mp3").split(",").map(function(c) {
                return Xf(c, "audio/mp4");
            }).map(Yf).join(","), a == "audio" ? 'audio/mp4; codecs="' + b + '"' : 'video/mp4; codecs="' + b + '"') : b;
        };
        p.getOriginalMimeType = function() {
            return this.m;
        };
        p.transmux = function(a, b, c, d, e) {
            var f = Kb(a);
            if (e == "audio" && !vk(f)) {
                for(var g = Zj(f), h = g.length; h < f.length; h++)if (AG(f, h)) return Promise.reject(new U(2, 3, 3018, c ? c.T()[0] : null));
                for(h = g.length; h < f.length; h++)if (eG(f, h)) return this.i || (this.i = new gG("audio/aac")), this.i.transmux(a, b, c, d, e);
                return Promise.reject(new U(2, 3, 3018, c ? c.T()[0] : null));
            }
            this.h ? this.h.clearData() : this.h = new nk;
            this.h.gg(c.i);
            var k = this.h.parse(f), l = [], m = k.le();
            try {
                var n = null;
                if (e == "video") {
                    switch(m.video){
                        case "avc":
                            var q = [], r = null, t = k.Jd(), w = oG(t);
                            if (!w.length) throw new U(2, 3, 3023, c ? c.T()[0] : null);
                            for(var v = 0; v < w.length; v++){
                                var z = w[v];
                                r == null && (r = z.dts);
                                var y = void 0;
                                y = v + 1 < w.length ? (w[v + 1].dts || 0) - (z.dts || 0) : w.length > 1 ? (z.dts || 0) - (w[v - 1].dts || 0) : (c.endTime - c.startTime) * 9E4;
                                q.push({
                                    data: z.data,
                                    size: z.data.byteLength,
                                    duration: y,
                                    Cb: Math.round((z.pts || 0) - (z.dts || 0)),
                                    flags: {
                                        Eb: 0,
                                        wb: 0,
                                        ub: 0,
                                        rb: 0,
                                        sb: z.isKeyframe ? 2 : 1,
                                        Fb: z.isKeyframe ? 0 : 1
                                    }
                                });
                            }
                            for(var A = [], C = u(t), E = C.next(); !E.done; E = C.next())A.push.apply(A, x(E.value.nalus));
                            var D = mG(A);
                            if (!D || r == null) throw new U(2, 3, 3018, c ? c.T()[0] : null);
                            b.height = D.height;
                            b.width = D.width;
                            n = {
                                id: b.id,
                                type: "video",
                                codecs: "avc1",
                                encrypted: b.encrypted && b.drmInfos.length > 0,
                                timescale: 9E4,
                                duration: d,
                                Hb: [],
                                Na: new Uint8Array([]),
                                Ya: D.Ya,
                                eb: D.eb,
                                gb: D.gb,
                                data: {
                                    sequenceNumber: this.g,
                                    baseMediaDecodeTime: r,
                                    Gb: q
                                },
                                stream: b
                            };
                            break;
                        case "hvc":
                            var B = [], G = null, I = [], J = k.Jd();
                            if (!J.length) throw new U(2, 3, 3023, c ? c.T()[0] : null);
                            for(var L = 0; L < J.length; L++){
                                var K = J[L], N = K.nalus;
                                I.push.apply(I, x(N));
                                for(var P = !1, O = [], M = !1, R = u(N), W = R.next(); !W.done; W = R.next()){
                                    var wa = W.value;
                                    switch(wa.type){
                                        case 1:
                                        case 0:
                                            var Y = M = !0;
                                            break;
                                        case 19:
                                        case 20:
                                        case 21:
                                            P = Y = M = !0;
                                            break;
                                        case 32:
                                            Y = !0;
                                            break;
                                        case 33:
                                            Y = !0;
                                            break;
                                        case 34:
                                            Y = !0;
                                            break;
                                        case 35:
                                            M = Y = !0;
                                            break;
                                        case 39:
                                        case 40:
                                            Y = !0;
                                            break;
                                        default:
                                            Y = !1;
                                    }
                                    if (M && Y) {
                                        var Ka = wa.fullData.byteLength, Na = new Uint8Array(4);
                                        Na[0] = Ka >> 24 & 255;
                                        Na[1] = Ka >> 16 & 255;
                                        Na[2] = Ka >> 8 & 255;
                                        Na[3] = Ka & 255;
                                        O.push(Na);
                                        O.push(wa.fullData);
                                    }
                                }
                                var La = O.length ? {
                                    data: lc.apply(dc, x(O)),
                                    isKeyframe: P
                                } : null;
                                if (La) {
                                    G == null && K.dts != null && (G = K.dts);
                                    var Ea = void 0;
                                    Ea = L + 1 < J.length ? (J[L + 1].dts || 0) - (K.dts || 0) : J.length > 1 ? (K.dts || 0) - (J[L - 1].dts || 0) : (c.endTime - c.startTime) * 9E4;
                                    B.push({
                                        data: La.data,
                                        size: La.data.byteLength,
                                        duration: Ea,
                                        Cb: Math.round((K.pts || 0) - (K.dts || 0)),
                                        flags: {
                                            Eb: 0,
                                            wb: 0,
                                            ub: 0,
                                            rb: 0,
                                            sb: La.isKeyframe ? 2 : 1,
                                            Fb: La.isKeyframe ? 0 : 1
                                        }
                                    });
                                }
                            }
                            var za = pG(I);
                            if (!za || G == null) throw new U(2, 3, 3018, c ? c.T()[0] : null);
                            b.height = za.height;
                            b.width = za.width;
                            n = {
                                id: b.id,
                                type: "video",
                                codecs: "hvc1",
                                encrypted: b.encrypted && b.drmInfos.length > 0,
                                timescale: 9E4,
                                duration: d,
                                Hb: [],
                                Na: new Uint8Array([]),
                                Ya: za.Ya,
                                eb: za.eb,
                                gb: za.gb,
                                data: {
                                    sequenceNumber: this.g,
                                    baseMediaDecodeTime: G,
                                    Gb: B
                                },
                                stream: b
                            };
                    }
                    n && (l.push(n), n = null);
                }
                if (e == "audio") {
                    switch(m.audio){
                        case "aac":
                            for(var Fa = [], Da, Aa = null, Ca = null, gb = null, ib = u(k.Db()), jb = ib.next(); !jb.done; jb = ib.next()){
                                var Ab = jb.value, yb = Ab.data;
                                if (yb) {
                                    var Wa = 0;
                                    if (Ca == -1 && gb) yb = lc(gb, Ab.data), Ca = null;
                                    else if (Ca != null && gb) {
                                        Wa = Math.max(0, Ca);
                                        var Yd = lc(gb, yb.subarray(0, Wa));
                                        Fa.push({
                                            data: Yd,
                                            size: Yd.byteLength,
                                            duration: 1024,
                                            Cb: 0,
                                            flags: {
                                                Eb: 0,
                                                wb: 0,
                                                ub: 0,
                                                rb: 0,
                                                sb: 2,
                                                Fb: 0
                                            }
                                        });
                                        Ca = gb = null;
                                    }
                                    Da = dG(yb, Wa);
                                    if (!Da) throw new U(2, 3, 3018, c ? c.T()[0] : null);
                                    b.audioSamplingRate = Da.sampleRate;
                                    b.channelsCount = Da.channelCount;
                                    Aa == null && Ab.pts !== null && (Aa = Ab.pts);
                                    for(; Wa < yb.length;){
                                        var Oc = cG(yb, Wa);
                                        if (!Oc) {
                                            gb = yb.subarray(Wa, yb.length);
                                            Ca = -1;
                                            break;
                                        }
                                        var Je = Oc.se + Oc.ya;
                                        Ca = Math.max(0, Wa + Je - yb.length);
                                        Ca != 0 ? gb = yb.subarray(Wa + Oc.se, Wa + Je) : Wa + Je <= yb.length && Fa.push({
                                            data: yb.subarray(Wa + Oc.se, Wa + Je),
                                            size: Oc.ya,
                                            duration: 1024,
                                            Cb: 0,
                                            flags: {
                                                Eb: 0,
                                                wb: 0,
                                                ub: 0,
                                                rb: 0,
                                                sb: 2,
                                                Fb: 0
                                            }
                                        });
                                        Wa += Je;
                                    }
                                }
                            }
                            if (!Da || Aa == null) {
                                Aa = c.startTime * 9E4;
                                var Cd = qc("audio", b.codecs.split(","));
                                if (!Cd || !b.channelsCount || !b.audioSamplingRate) throw new U(2, 3, 3018, c ? c.T()[0] : null);
                                Da = {
                                    sampleRate: b.audioSamplingRate,
                                    channelCount: b.channelsCount,
                                    codec: Cd
                                };
                                var Ag = fG(Cd, b.channelsCount);
                                if (!Ag) throw new U(2, 3, 3018, c ? c.T()[0] : null);
                                for(var Ik = Aa + (c.endTime - c.startTime) * 9E4, fi = Aa; fi < Ik;)Fa.push({
                                    data: Ag,
                                    size: Ag.byteLength,
                                    duration: 1024,
                                    Cb: 0,
                                    flags: {
                                        Eb: 0,
                                        wb: 0,
                                        ub: 0,
                                        rb: 0,
                                        sb: 2,
                                        Fb: 0
                                    }
                                }), fi += 1024 / Da.sampleRate * 9E4;
                            }
                            var jd = Da.sampleRate, AK = Aa / 9E4 * jd;
                            n = {
                                id: b.id,
                                type: "audio",
                                codecs: Da.codec,
                                encrypted: b.encrypted && b.drmInfos.length > 0,
                                timescale: jd,
                                duration: d,
                                Hb: [],
                                Na: new Uint8Array([]),
                                Ya: new Uint8Array([]),
                                eb: 0,
                                gb: 0,
                                data: {
                                    sequenceNumber: this.g,
                                    baseMediaDecodeTime: AK,
                                    Gb: Fa
                                },
                                stream: b
                            };
                            break;
                        case "ac3":
                            for(var Yz = [], ql = 0, Vp = new Uint8Array([]), rl = null, Zz = u(k.Db()), Wp = Zz.next(); !Wp.done; Wp = Zz.next()){
                                var Xp = Wp.value, Yp = Xp.data;
                                rl == null && Xp.pts !== null && (rl = Xp.pts);
                                for(var Hg = 0; Hg < Yp.length;){
                                    var Le = hG(Yp, Hg);
                                    Le ? (b.audioSamplingRate = Le.sampleRate, b.channelsCount = Le.channelCount, ql = Le.sampleRate, Vp = Le.Na, Yz.push({
                                        data: Yp.subarray(Hg, Hg + Le.ya),
                                        size: Le.ya,
                                        duration: 1536,
                                        Cb: 0,
                                        flags: {
                                            Eb: 0,
                                            wb: 0,
                                            ub: 0,
                                            rb: 0,
                                            sb: 2,
                                            Fb: 0
                                        }
                                    }), Hg += Le.ya) : Hg++;
                                }
                            }
                            if (ql == 0 || Vp.byteLength == 0 || rl == null) throw new U(2, 3, 3018, c ? c.T()[0] : null);
                            var BK = rl / 9E4 * ql;
                            n = {
                                id: b.id,
                                type: "audio",
                                codecs: "ac-3",
                                encrypted: b.encrypted && b.drmInfos.length > 0,
                                timescale: ql,
                                duration: d,
                                Hb: [],
                                Na: Vp,
                                Ya: new Uint8Array([]),
                                eb: 0,
                                gb: 0,
                                data: {
                                    sequenceNumber: this.g,
                                    baseMediaDecodeTime: BK,
                                    Gb: Yz
                                },
                                stream: b
                            };
                            break;
                        case "ec3":
                            for(var $z = [], sl = 0, Zp = new Uint8Array([]), tl = null, aA = u(k.Db()), $p = aA.next(); !$p.done; $p = aA.next()){
                                var aq = $p.value, bq = aq.data;
                                tl == null && aq.pts !== null && (tl = aq.pts);
                                for(var Ig = 0; Ig < bq.length;){
                                    var Me = kG(bq, Ig);
                                    Me ? (b.audioSamplingRate = Me.sampleRate, b.channelsCount = Me.channelCount, sl = Me.sampleRate, Zp = Me.Na, $z.push({
                                        data: bq.subarray(Ig, Ig + Me.ya),
                                        size: Me.ya,
                                        duration: 1536,
                                        Cb: 0,
                                        flags: {
                                            Eb: 0,
                                            wb: 0,
                                            ub: 0,
                                            rb: 0,
                                            sb: 2,
                                            Fb: 0
                                        }
                                    }), Ig += Me.ya) : Ig++;
                                }
                            }
                            if (sl == 0 || Zp.byteLength == 0 || tl == null) throw new U(2, 3, 3018, c ? c.T()[0] : null);
                            var CK = tl / 9E4 * sl;
                            n = {
                                id: b.id,
                                type: "audio",
                                codecs: "ec-3",
                                encrypted: b.encrypted && b.drmInfos.length > 0,
                                timescale: sl,
                                duration: d,
                                Hb: [],
                                Na: Zp,
                                Ya: new Uint8Array([]),
                                eb: 0,
                                gb: 0,
                                data: {
                                    sequenceNumber: this.g,
                                    baseMediaDecodeTime: CK,
                                    Gb: $z
                                },
                                stream: b
                            };
                            break;
                        case "mp3":
                            for(var bA = [], ul, vl = null, cA = u(k.Db()), cq = cA.next(); !cq.done; cq = cA.next()){
                                var dq = cq.value, ri = dq.data;
                                if (ri) {
                                    vl == null && dq.pts !== null && (vl = dq.pts);
                                    for(var xf = 0; xf < ri.length;){
                                        var Jg = uG(ri, xf);
                                        Jg ? (ul || (ul = Jg), xf + Jg.ya <= ri.length && bA.push({
                                            data: ri.subarray(xf, xf + Jg.ya),
                                            size: Jg.ya,
                                            duration: 1152,
                                            Cb: 0,
                                            flags: {
                                                Eb: 0,
                                                wb: 0,
                                                ub: 0,
                                                rb: 0,
                                                sb: 2,
                                                Fb: 0
                                            }
                                        }), xf += Jg.ya) : xf++;
                                    }
                                }
                            }
                            if (!ul || vl == null) throw new U(2, 3, 3018, c ? c.T()[0] : null);
                            var dA = ul.sampleRate, DK = vl / 9E4 * dA;
                            n = {
                                id: b.id,
                                type: "audio",
                                codecs: "mp3",
                                encrypted: b.encrypted && b.drmInfos.length > 0,
                                timescale: dA,
                                duration: d,
                                Hb: [],
                                Na: new Uint8Array([]),
                                Ya: new Uint8Array([]),
                                eb: 0,
                                gb: 0,
                                data: {
                                    sequenceNumber: this.g,
                                    baseMediaDecodeTime: DK,
                                    Gb: bA
                                },
                                stream: b
                            };
                            break;
                        case "opus":
                            var eA = [], wl = null, Ed = k.H;
                            if (!Ed) throw new U(2, 3, 3018, c ? c.T()[0] : null);
                            var kc = [];
                            switch(Ed.pk){
                                case 1:
                                case 2:
                                    kc = [
                                        0
                                    ];
                                    break;
                                case 0:
                                    kc = [
                                        255,
                                        1,
                                        1,
                                        0,
                                        1
                                    ];
                                    break;
                                case 128:
                                    kc = [
                                        255,
                                        2,
                                        0,
                                        0,
                                        1
                                    ];
                                    break;
                                case 3:
                                    kc = [
                                        1,
                                        2,
                                        1,
                                        0,
                                        2,
                                        1
                                    ];
                                    break;
                                case 4:
                                    kc = [
                                        1,
                                        2,
                                        2,
                                        0,
                                        1,
                                        2,
                                        3
                                    ];
                                    break;
                                case 5:
                                    kc = [
                                        1,
                                        3,
                                        2,
                                        0,
                                        4,
                                        1,
                                        2,
                                        3
                                    ];
                                    break;
                                case 6:
                                    kc = [
                                        1,
                                        4,
                                        2,
                                        0,
                                        4,
                                        1,
                                        2,
                                        3,
                                        5
                                    ];
                                    break;
                                case 7:
                                    kc = [
                                        1,
                                        4,
                                        2,
                                        0,
                                        4,
                                        1,
                                        2,
                                        3,
                                        5,
                                        6
                                    ];
                                    break;
                                case 8:
                                    kc = [
                                        1,
                                        5,
                                        3,
                                        0,
                                        6,
                                        1,
                                        2,
                                        3,
                                        4,
                                        5,
                                        7
                                    ];
                                    break;
                                case 130:
                                    kc = [
                                        1,
                                        1,
                                        2,
                                        0,
                                        1
                                    ];
                                    break;
                                case 131:
                                    kc = [
                                        1,
                                        1,
                                        3,
                                        0,
                                        1,
                                        2
                                    ];
                                    break;
                                case 132:
                                    kc = [
                                        1,
                                        1,
                                        4,
                                        0,
                                        1,
                                        2,
                                        3
                                    ];
                                    break;
                                case 133:
                                    kc = [
                                        1,
                                        1,
                                        5,
                                        0,
                                        1,
                                        2,
                                        3,
                                        4
                                    ];
                                    break;
                                case 134:
                                    kc = [
                                        1,
                                        1,
                                        6,
                                        0,
                                        1,
                                        2,
                                        3,
                                        4,
                                        5
                                    ];
                                    break;
                                case 135:
                                    kc = [
                                        1,
                                        1,
                                        7,
                                        0,
                                        1,
                                        2,
                                        3,
                                        4,
                                        5,
                                        6
                                    ];
                                    break;
                                case 136:
                                    kc = [
                                        1,
                                        1,
                                        8,
                                        0,
                                        1,
                                        2,
                                        3,
                                        4,
                                        5,
                                        6,
                                        7
                                    ];
                            }
                            var fA = new Uint8Array([
                                0,
                                Ed.channelCount,
                                0,
                                0,
                                Ed.sampleRate >>> 24 & 255,
                                Ed.sampleRate >>> 17 & 255,
                                Ed.sampleRate >>> 8 & 255,
                                Ed.sampleRate >>> 0 & 255,
                                0,
                                0
                            ].concat(x(kc)));
                            for(var gA = Ed.sampleRate, hA = u(k.Db()), eq = hA.next(); !eq.done; eq = hA.next()){
                                var fq = eq.value, Kg = fq.data;
                                wl == null && fq.pts !== null && (wl = fq.pts);
                                for(var si = 0; si < Kg.length;){
                                    for(var EK = (Kg[si + 1] & 16) !== 0, FK = (Kg[si + 1] & 8) !== 0, je = si + 2, xl = 0; Kg[je] === 255;)xl += 255, je += 1;
                                    xl += Kg[je];
                                    je += 1;
                                    je += EK ? 2 : 0;
                                    je += FK ? 2 : 0;
                                    var iA = Kg.slice(je, je + xl);
                                    eA.push({
                                        data: iA,
                                        size: iA.byteLength,
                                        duration: 960,
                                        Cb: 0,
                                        flags: {
                                            Eb: 0,
                                            wb: 0,
                                            ub: 0,
                                            rb: 0,
                                            sb: 2,
                                            Fb: 0
                                        }
                                    });
                                    si = je + xl;
                                }
                            }
                            if (fA.byteLength == 0 || wl == null) throw new U(2, 3, 3018, c ? c.T()[0] : null);
                            b.audioSamplingRate = Ed.sampleRate;
                            b.channelsCount = Ed.channelCount;
                            var GK = wl / 9E4 * gA;
                            n = {
                                id: b.id,
                                type: "audio",
                                codecs: "opus",
                                encrypted: b.encrypted && b.drmInfos.length > 0,
                                timescale: gA,
                                duration: d,
                                Hb: [],
                                Na: fA,
                                Ya: new Uint8Array([]),
                                eb: 0,
                                gb: 0,
                                data: {
                                    sequenceNumber: this.g,
                                    baseMediaDecodeTime: GK,
                                    Gb: eA
                                },
                                stream: b
                            };
                    }
                    n && (l.push(n), n = null);
                }
            } catch (gq) {
                return gq && gq.code == 3023 ? Promise.resolve(new Uint8Array([])) : Promise.reject(gq);
            }
            if (!l.length) return Promise.reject(new U(2, 3, 3018, c ? c.T()[0] : null));
            var jA = new Ri(l), hq = b.id + "_" + c.i;
            if (this.j.has(hq)) var ti = this.j.get(hq);
            else ti = Si(jA), this.j.set(hq, ti);
            var HK = this.l !== ti, IK = mj(jA);
            this.l = ti;
            this.g++;
            return Promise.resolve({
                data: IK,
                init: HK ? ti : null
            });
        };
        S("shaka.transmuxer.TsTransmuxer", HG);
        HG.prototype.transmux = HG.prototype.transmux;
        HG.prototype.getOriginalMimeType = HG.prototype.getOriginalMimeType;
        HG.prototype.convertCodecs = HG.prototype.convertCodecs;
        HG.prototype.isSupported = HG.prototype.isSupported;
        HG.prototype.destroy = HG.prototype.destroy;
        var IG = [
            "aac",
            "ac-3",
            "ec-3",
            "mp3",
            "opus"
        ], JG = [
            "avc",
            "hevc"
        ];
        We("video/mp2t", function() {
            return new HG("video/mp2t");
        }, $e);
        function KG() {}
        la(KG, Dn);
        S("shaka.util.FairPlayUtils", KG);
        function LG(a, b) {
            var c = this;
            this.parent = a;
            this.controls = b;
            this.eventManager = new Tc;
            this.localization = this.controls.sa;
            this.player = this.controls.Wb();
            this.video = this.controls.Vc();
            this.adManager = this.player.tf();
            this.ad = b.getAd();
            this.eventManager.o(this.adManager, "ad-started", function(d) {
                c.ad = d.ad;
            });
            this.eventManager.o(this.adManager, "ad-stopped", function() {
                c.ad = null;
            });
        }
        LG.prototype.release = function() {
            this.eventManager.release();
            this.ad = this.adManager = this.video = this.player = this.localization = this.eventManager = this.controls = this.parent = null;
        };
        S("shaka.ui.Element", LG);
        LG.prototype.release = LG.prototype.release;
        function MG(a, b) {
            this.parent = a;
            this.g = Kj("svg");
            this.h = Kj("path");
            this.g.classList.add("material-svg-icon");
            this.g.setAttribute("viewBox", "0 -960 960 960");
            b && this.use(b);
            this.g.appendChild(this.h);
            this.parent && a.appendChild(this.g);
        }
        MG.prototype.use = function(a) {
            a && typeof a == "string" && this.h.setAttribute("d", a);
        };
        MG.prototype.kl = function() {
            return this.g;
        };
        S("shaka.ui.MaterialSVGIcon", MG);
        MG.prototype.getSvgElement = MG.prototype.kl;
        MG.prototype.use = MG.prototype.use;
        function NG(a) {
            return OG(a, "shaka-back-to-overflow-button");
        }
        function OG(a, b) {
            a = a.getElementsByClassName(b);
            return a.length ? a[0] : null;
        }
        function PG(a) {
            a && (a = OG(a, "shaka-chosen-item")) && a.parentElement.focus();
        }
        function QG() {
            var a = new MG(null, "m382-354 339-339q12-12 28-12t28 12q12 12 12 28.5T777-636L410-268q-12 12-28 12t-28-12L182-440q-12-12-11.5-28.5T183-497q12-12 28.5-12t28.5 12l142 143Z").g;
            a.classList.add("shaka-chosen-item");
            a.ariaHidden = "true";
            return a;
        }
        function RG(a, b) {
            a && (b ? a.classList.remove("shaka-hidden") : a.classList.add("shaka-hidden"));
        }
        function SG(a, b) {
            var c = Math.floor(a / 86400), d = Math.floor(a % 86400 / 3600), e = Math.floor(a / 60 % 60);
            a = Math.floor(a % 60);
            a < 10 && (a = "0" + a);
            a = e + ":" + a;
            b && (e < 10 && (a = "0" + a), a = d + ":" + a, c > 0 && (d < 10 && (a = "0" + a), a = c + ":" + a));
            return a;
        }
        function TG(a, b) {
            LG.call(this, a, b);
            var c = this;
            this.g = Lj();
            this.g.classList.add("shaka-ad-info");
            this.g.disabled = !0;
            this.parent.appendChild(this.g);
            this.h = new Bf(function() {
                if (c.ad.isLinear()) {
                    var d = "", e = c.ad.getSequenceLength();
                    e > 1 && (d = c.ad.getPositionInSequence(), d = c.localization.resolve("AD_PROGRESS").replace("[AD_ON]", String(d)).replace("[NUM_ADS]", String(e)));
                    var f = Math.round(c.ad.getRemainingTime()), g = c.ad.getDuration();
                    f == -1 || g == -1 ? (c.g.textContent = d, RG(c.g, d != "")) : f > 0 ? (f = SG(g - f, !1) + " / " + SG(g, !1), d = e > 1 ? d + ("\u00a0\u00a0" + f) : c.localization.resolve("AD_TIME").replace("[AD_TIME]", f), c.g.textContent = d, RG(c.g, d != "")) : (c.h.stop(), c.g.textContent = "");
                }
            });
            this.eventManager.o(this.localization, "locale-updated", function() {});
            this.eventManager.o(this.localization, "locale-changed", function() {});
            this.eventManager.o(this.adManager, "ad-started", function() {
                c.h.La();
                c.h.wa(.5);
            });
            this.eventManager.o(this.adManager, "ad-stopped", function() {
                c.h.stop();
                c.g.textContent = "";
            });
            this.ad && (this.h.La(), this.h.wa(.5));
        }
        la(TG, LG);
        TG.prototype.release = function() {
            this.h.stop();
            this.h = null;
            LG.prototype.release.call(this);
        };
        S("shaka.ui.AdInfo", TG);
        function UG(a, b) {
            LG.call(this, a, b);
            var c = this;
            this.j = this.controls.g;
            this.h = this.controls.i;
            this.i = [];
            this.g = V("div");
            this.g.classList.add("shaka-no-propagation");
            this.g.classList.add("shaka-context-menu");
            this.g.classList.add("shaka-hidden");
            this.h.appendChild(this.g);
            this.eventManager.o(this.h, "contextmenu", function(d) {
                if (c.g.classList.contains("shaka-hidden")) {
                    d.preventDefault();
                    var e = c.h.getBoundingClientRect();
                    c.g.style.left = d.clientX - e.left + "px";
                    c.g.style.top = d.clientY - e.top + "px";
                    RG(c.g, !0);
                } else RG(c.g, !1);
            });
            this.eventManager.o(window1, "click", function() {
                RG(c.g, !1);
            });
            this.eventManager.o(this.g, "click", function() {
                RG(c.g, !1);
            });
            VG(this);
        }
        la(UG, LG);
        UG.prototype.release = function() {
            this.h = null;
            for(var a = u(this.i), b = a.next(); !b.done; b = a.next())b.value.release();
            this.i = [];
            LG.prototype.release.call(this);
        };
        UG.prototype.Oi = function() {
            RG(this.g, !1);
        };
        function WG(a, b) {
            XG.set(a, b);
        }
        function VG(a) {
            for(var b = u(a.j.contextMenuElements), c = b.next(); !c.done; c = b.next()){
                c = c.value;
                var d = XG.get(c);
                d ? a.i.push(d.create(a.g, a.controls)) : ab("Unrecognized context menu element:", c);
            }
        }
        S("shaka.ui.ContextMenu", UG);
        UG.registerElement = WG;
        UG.prototype.closeMenu = UG.prototype.Oi;
        var XG = new Map;
        function YG(a, b) {
            LG.call(this, a, b);
            var c = this;
            this.button = Lj();
            this.parent.appendChild(this.button);
            this.h = new MG(this.button);
            this.eventManager.o(this.localization, "locale-updated", function() {
                ZG(c);
            });
            this.eventManager.o(this.localization, "locale-changed", function() {
                ZG(c);
            });
            this.eventManager.o(this.video, "play", function() {
                ZG(c);
                c.g();
            });
            this.eventManager.o(this.video, "pause", function() {
                ZG(c);
                c.g();
            });
            this.eventManager.o(this.video, "seeking", function() {
                ZG(c);
                c.g();
            });
            this.eventManager.o(this.player, "loaded", function() {
                ZG(c);
                c.g();
            });
            this.eventManager.o(this.adManager, "ad-paused", function() {
                ZG(c);
                c.g();
            });
            this.eventManager.o(this.adManager, "ad-resumed", function() {
                ZG(c);
                c.g();
            });
            this.eventManager.o(this.adManager, "ad-started", function() {
                ZG(c);
                c.g();
            });
            this.eventManager.o(this.adManager, "ad-stopped", function() {
                ZG(c);
                c.g();
            });
            this.eventManager.o(this.button, "click", function() {
                c.controls.Ca() && $G(c.controls);
            });
            ZG(this);
            this.g();
        }
        la(YG, LG);
        YG.prototype.isPaused = function() {
            if (this.ad && this.ad.isLinear()) var a = this.ad.isPaused();
            else a = this.controls, a = a.C.paused && !a.S;
            return a;
        };
        YG.prototype.isEnded = function() {
            return this.ad && this.ad.isLinear() ? !1 : this.player ? this.player.isEnded() : !0;
        };
        function ZG(a) {
            if (a.isEnded() && a.video.duration) a.button.ariaLabel = a.localization.resolve("REPLAY");
            else {
                var b = a.isPaused() ? "PLAY" : "PAUSE";
                a.button.ariaLabel = a.localization.resolve(b);
            }
        }
        YG.prototype.g = function() {
            this.isEnded() && this.video.duration ? this.h.use("M480-80q-75 0-140.5-28.5t-114-77q-48.5-48.5-77-114T120-440q0-17 11.5-28.5T160-480q17 0 28.5 11.5T200-440q0 117 81.5 198.5T480-160q117 0 198.5-81.5T760-440q0-117-81.5-198.5T480-720h-6l34 34q12 12 11.5 28T508-630q-12 12-28.5 12.5T451-629L348-732q-12-12-12-28t12-28l103-103q12-12 28.5-11.5T508-890q11 12 11.5 28T508-834l-34 34h6q75 0 140.5 28.5t114 77q48.5 48.5 77 114T840-440q0 75-28.5 140.5t-77 114q-48.5 48.5-114 77T480-80Z") : this.h.use(this.isPaused() ? "M320-273v-414q0-17 12-28.5t28-11.5q5 0 10.5 1.5T381-721l326 207q9 6 13.5 15t4.5 19q0 10-4.5 19T707-446L381-239q-5 3-10.5 4.5T360-233q-16 0-28-11.5T320-273Z" : "M640-200q-33 0-56.5-23.5T560-280v-400q0-33 23.5-56.5T640-760q33 0 56.5 23.5T720-680v400q0 33-23.5 56.5T640-200Zm-320 0q-33 0-56.5-23.5T240-280v-400q0-33 23.5-56.5T320-760q33 0 56.5 23.5T400-680v400q0 33-23.5 56.5T320-200Z");
        };
        S("shaka.ui.PlayButton", YG);
        function aH(a, b) {
            YG.call(this, a, b);
            this.button.classList.add("shaka-play-button");
            this.button.classList.add("shaka-no-propagation");
        }
        la(aH, YG);
        aH.prototype.g = function() {
            this.isEnded() ? this.button.setAttribute("icon", "replay") : this.isPaused() ? this.button.setAttribute("icon", "play") : this.button.setAttribute("icon", "pause");
        };
        S("shaka.ui.BigPlayButton", aH);
        function bH(a, b) {
            LG.call(this, a, b);
            var c = this;
            this.m = null;
            this.i = this.D = !1;
            this.C = this.A = null;
            this.j = new Bf(function() {
                parseInt(c.h.textContent, 10) === 0 && cH(c.controls, !0);
                var d = parseInt(c.h.textContent, 10);
                d !== 0 && (c.video.currentTime = c.controls.ph() + d);
                c.g.style.opacity = "0";
                c.D = !1;
                c.h.textContent = "0s";
            });
            this.g = V("div");
            this.g.classList.add("shaka-no-propagation");
            this.parent.appendChild(this.g);
            this.h = V("span");
            this.h.textContent = "0s";
            this.g.appendChild(this.h);
            this.u = new MG(this.g);
            this.u.g.classList.add("shaka-forward-rewind-container-icon");
            this.l = !1;
            this.eventManager.o(this.g, "touchstart", function(d) {
                d.touches.length > 0 && (c.A = d.touches[0].clientX, c.C = d.touches[0].clientY);
                c.i = !1;
            });
            this.eventManager.o(this.g, "touchmove", function(d) {
                if (d.touches.length > 0 && c.A != null && c.C != null) {
                    var e = d.touches[0].clientX - c.A;
                    d = d.touches[0].clientY - c.C;
                    Math.sqrt(e * e + d * d) > 10 && (c.i = !0);
                }
            });
            this.eventManager.o(this.g, "touchend", function(d) {
                if (!c.i) {
                    if (c.controls.Lc()) d.preventDefault(), c.controls.Wc();
                    else if (c.controls.g.tapSeekDistance > 0) {
                        if (d.preventDefault(), d = c.controls.g.tapSeekDistance, !c.D) c.D = !0, c.m = Date.now(), c.j.$(.5);
                        else if (c.m + 500 > Date.now()) {
                            c.j.stop();
                            c.m = Date.now();
                            var e = parseInt(c.h.textContent, 10);
                            e = c.l ? e - d : e + d;
                            c.h.textContent = e.toString() + "s";
                            c.g.style.opacity = "1";
                            c.j.$(.5);
                        }
                    }
                }
            });
        }
        la(bH, LG);
        S("shaka.ui.HiddenSeekButton", bH);
        function dH(a, b) {
            bH.call(this, a, b);
            this.g.classList.add("shaka-fast-forward-container");
            this.u.use("M100-315v-330q0-18 12-29t28-11q5 0 11 1t11 5l248 166q9 6 13.5 14.5T428-480q0 10-4.5 18.5T410-447L162-281q-5 4-11 5t-11 1q-16 0-28-11t-12-29Zm400 0v-330q0-18 12-29t28-11q5 0 11 1t11 5l248 166q9 6 13.5 14.5T828-480q0 10-4.5 18.5T810-447L562-281q-5 4-11 5t-11 1q-16 0-28-11t-12-29Z");
            this.l = !1;
        }
        la(dH, bH);
        S("shaka.ui.HiddenFastForwardButton", dH);
        function eH(a, b) {
            bH.call(this, a, b);
            this.g.classList.add("shaka-rewind-container");
            this.u.use("M798-281 550-447q-9-6-13.5-14.5T532-480q0-10 4.5-18.5T550-513l248-166q5-4 11-5t11-1q16 0 28 11t12 29v330q0 18-12 29t-28 11q-5 0-11-1t-11-5Zm-400 0L150-447q-9-6-13.5-14.5T132-480q0-10 4.5-18.5T150-513l248-166q5-4 11-5t11-1q16 0 28 11t12 29v330q0 18-12 29t-28 11q-5 0-11-1t-11-5Z");
            this.l = !0;
        }
        la(eH, bH);
        S("shaka.ui.HiddenRewindButton", eH);
        function fH(a, b, c, d) {
            LG.call(this, a, b);
            var e = this;
            this.container = V("div");
            this.container.classList.add("shaka-range-container");
            this.container.classList.add.apply(this.container.classList, x(c));
            this.i = !1;
            this.bar = document.createElement("input");
            this.G = new Bf(function() {
                e.onChangeEnd();
                e.i = !1;
            });
            this.bar.classList.add("shaka-range-element");
            this.bar.classList.add.apply(this.bar.classList, x(d));
            this.bar.type = "range";
            this.bar.step = "any";
            this.bar.min = "0";
            this.bar.max = "1";
            this.bar.value = "0";
            this.bar.disabled = !this.controls.Ca();
            this.container.appendChild(this.bar);
            this.parent.appendChild(this.container);
            this.L = new Bf(function() {
                e.bar.disabled = !1;
            });
            this.eventManager.o(this.controls, "showingui", function() {
                e.L.$(0);
            });
            this.eventManager.o(this.controls, "hidingui", function() {
                e.L.stop();
                e.bar.disabled = !0;
            });
            this.eventManager.o(this.bar, "mousedown", function(f) {
                e.bar.disabled || (e.i = !0, e.onChangeStart(), f.stopPropagation());
            });
            this.eventManager.o(this.bar, "touchstart", function(f) {
                e.bar.disabled || (e.i = !0, gH(e, f), e.onChangeStart(), f.stopPropagation());
            });
            this.eventManager.o(this.bar, "input", function() {
                e.onChange();
            });
            this.eventManager.o(this.bar, "touchmove", function(f) {
                e.i && (gH(e, f), e.onChange(), f.stopPropagation());
            });
            this.eventManager.o(this.bar, "touchend", function(f) {
                e.i && (e.i = !1, gH(e, f), e.onChangeEnd(), f.stopPropagation());
            });
            this.eventManager.o(this.bar, "touchcancel", function(f) {
                e.i && (e.i = !1, gH(e, f), e.onChangeEnd(), f.stopPropagation());
            });
            this.eventManager.o(this.bar, "mouseup", function(f) {
                e.i && (e.i = !1, e.onChangeEnd(), f.stopPropagation());
            });
            this.eventManager.o(this.bar, "blur", function() {
                e.i && (e.i = !1, e.onChangeEnd());
            });
            this.eventManager.o(this.bar, "contextmenu", function(f) {
                f.preventDefault();
                f.stopPropagation();
            });
        }
        la(fH, LG);
        p = fH.prototype;
        p.release = function() {
            this.G && (this.G.stop(), this.G = null);
            LG.prototype.release.call(this);
        };
        p.setRange = function(a, b) {
            this.bar.min = a;
            this.bar.max = b;
        };
        p.onChangeStart = function() {};
        p.onChange = function() {};
        p.onChangeEnd = function() {};
        p.changeTo = function(a) {
            this.i || (this.i = !0, this.onChangeStart());
            var b = parseFloat(this.bar.min), c = parseFloat(this.bar.max);
            this.bar.value = a > c ? c : a < b ? b : a;
            this.onChange();
            this.G.$(.5);
        };
        p.getValue = function() {
            return parseFloat(this.bar.value);
        };
        p.setValue = function(a) {
            this.i || (this.bar.value = a);
        };
        function hH(a, b) {
            var c = a.bar.getBoundingClientRect(), d = parseFloat(a.bar.min), e = parseFloat(a.bar.max);
            a = parseFloat(a.bar.step) || 1;
            var f = c.left + 6;
            c = c.right - 6;
            b = d + (Math.max(f, Math.min(c, b)) - f) / (c - f) * (e - d);
            b = Math.round((b - d) / a) * a + d;
            return b = Math.min(e, Math.max(d, b));
        }
        function gH(a, b) {
            b.preventDefault();
            a.bar.value = hH(a, b.changedTouches[0].clientX);
        }
        S("shaka.ui.RangeElement", fH);
        fH.prototype.setValue = fH.prototype.setValue;
        fH.prototype.getValue = fH.prototype.getValue;
        fH.prototype.changeTo = fH.prototype.changeTo;
        fH.prototype.onChangeEnd = fH.prototype.onChangeEnd;
        fH.prototype.onChange = fH.prototype.onChange;
        fH.prototype.onChangeStart = fH.prototype.onChangeStart;
        fH.prototype.setRange = fH.prototype.setRange;
        function iH(a, b) {
            fH.call(this, a, b, [
                "shaka-seek-bar-container"
            ], [
                "shaka-seek-bar",
                "shaka-no-propagation",
                "shaka-show-controls-on-mouse-over"
            ]);
            var c = this;
            this.F = V("div");
            this.F.classList.add("shaka-ad-markers");
            this.container.insertBefore(this.F, this.container.childNodes[0]);
            this.I = this.controls.g;
            this.C = new Bf(function() {
                var d = c.getValue();
                c.player.U() || d == c.video.duration && (d -= .001);
                c.video.currentTime = d;
            });
            this.D = new Bf(function() {
                jH(c);
            });
            this.M = !1;
            this.h = V("div");
            this.h.id = "shaka-player-ui-thumbnail-container";
            this.g = V("img");
            this.g.id = "shaka-player-ui-thumbnail-image";
            this.g.draggable = !1;
            this.K = V("div");
            this.K.id = "shaka-player-ui-thumbnail-time-container";
            this.H = V("div");
            this.H.id = "shaka-player-ui-thumbnail-time";
            this.K.appendChild(this.H);
            this.h.appendChild(this.g);
            this.h.appendChild(this.K);
            this.container.appendChild(this.h);
            this.j = V("div");
            this.j.id = "shaka-player-ui-time-container";
            this.container.appendChild(this.j);
            this.l = this.u = null;
            this.J = !1;
            this.A = new Bf(function() {
                kH(c);
            });
            this.m = [];
            this.eventManager.o(this.bar, "input", function() {
                c.controls.Wc();
            });
            this.eventManager.o(this.localization, "locale-updated", function() {
                return lH(c);
            });
            this.eventManager.o(this.localization, "locale-changed", function() {
                return lH(c);
            });
            this.eventManager.o(this.adManager, "ad-started", function() {
                mH(c) || RG(c.container, !1);
            });
            this.eventManager.o(this.adManager, "ad-stopped", function() {
                mH(c) && RG(c.container, !0);
            });
            this.eventManager.o(this.adManager, "ad-cue-points-changed", function(d) {
                c.m = d.cuepoints;
                nH(c);
            });
            this.eventManager.o(this.player, "unloading", function() {
                c.m = [];
                nH(c);
                c.l && (c.l.abort(), c.l = null);
                c.u = null;
                kH(c);
                oH(c);
            });
            this.eventManager.o(this.bar, "mousemove", function(d) {
                if (c.controls.Lc()) oH(c), kH(c);
                else {
                    var e = hH(c, d.clientX), f = c.bar.getBoundingClientRect();
                    d = Math.max(0, d.clientX - f.left);
                    c.player.qh().length ? (oH(c), pH(c, d, e)) : (kH(c), qH(c, d, e));
                }
            });
            this.eventManager.o(this.container, "mouseleave", function() {
                oH(c);
                c.A.stop();
                c.A.$(.25);
            });
            this.setValue(this.video.currentTime);
            this.update();
            lH(this);
            this.ad && RG(this.container, !1);
        }
        la(iH, fH);
        p = iH.prototype;
        p.release = function() {
            this.C && (this.C.stop(), this.C = null, this.D.stop(), this.D = null);
            fH.prototype.release.call(this);
        };
        p.onChangeStart = function() {
            this.M = !this.video.paused;
            this.controls.ii(!0);
            this.video.pause();
            this.A.stop();
            this.J = !0;
        };
        p.onChange = function() {
            if (this.video.duration) {
                if (this.update(), this.C.$(.125), this.player.qh().length && !this.controls.Lc()) {
                    var a = parseFloat(this.bar.min), b = parseFloat(this.bar.max), c = this.bar.getBoundingClientRect(), d = Math.round(this.getValue());
                    pH(this, (d - a) / ((b - a) / c.width), d);
                } else kH(this);
            }
        };
        p.onChangeEnd = function() {
            this.C.La();
            this.controls.ii(!1);
            this.M && this.video.play();
            this.J && (this.J = !1, this.A.stop(), this.A.$(.25));
        };
        p.isShowing = function() {
            return !this.container.classList.contains("shaka-hidden");
        };
        p.update = function() {
            var a = this.I.seekBarColors, b = this.getValue(), c = this.video.buffered.length, d = c ? this.video.buffered.start(0) : 0, e = c ? this.video.buffered.end(c - 1) : 0;
            c = this.player.za();
            var f = c.end - c.start;
            this.setRange(c.start, c.end);
            mH(this) ? (RG(this.container, !0), d = (Math.max(d, c.start) - c.start) / f || 0, e = (Math.min(e, c.end) - c.start) / f || 0, b = (Math.min(Math.max(b, c.start), c.end) - c.start) / f || 0, this.container.style.background = "linear-gradient(" + [
                "to right",
                (this.I.showUnbufferedStart ? a.base : a.played) + " " + d * 100 + "%",
                a.played + " " + d * 100 + "%",
                a.played + " " + b * 100 + "%",
                a.buffered + " " + b * 100 + "%",
                a.buffered + " " + e * 100 + "%",
                a.base + " " + e * 100 + "%"
            ].join() + ")") : RG(this.container, !1);
        };
        function jH(a) {
            if (a.m.length) {
                for(var b = a.player.za(), c = b.end - b.start, d = [
                    "to right"
                ], e = [], f = a.I.seekBarColors.adBreaks, g = !1, h = u(a.m), k = h.next(); !k.done; k = h.next())if (k = k.value, k.start == -1 && !k.end) g = !0;
                else if (!k.end && k.start >= b.start || typeof k.end == "number" && k.end > b.start) {
                    var l = (Math.max(k.start, b.start) - b.start) / c || 0, m = l + .01;
                    k.end && (m = (k.end - b.start) / c || 0);
                    e.push({
                        start: l,
                        end: m
                    });
                }
                e = e.sort(function(n, q) {
                    return n.start - q.start;
                });
                b = u(e);
                for(c = b.next(); !c.done; c = b.next())c = c.value, d.push("transparent " + c.start * 100 + "%"), d.push(f + " " + c.start * 100 + "%"), d.push(f + " " + c.end * 100 + "%"), d.push("transparent " + c.end * 100 + "%");
                g && (d.push("transparent 99%"), d.push(f + " 99%"));
                a.F.style.background = "linear-gradient(" + d.join(",") + ")";
            } else a.F.style.background = "transparent", a.D.stop();
        }
        function nH(a) {
            function b() {
                jH(a);
                var c = a.player.za();
                c = c.end - c.start;
                a.player.U() && c > 5 && a.D.wa(.25);
            }
            a.player.aa ? b() : a.eventManager.ua(a.player, "loaded", b);
        }
        function mH(a) {
            var b = a.player.za();
            b = b.end - b.start;
            return a.player.U() && (b < 5 || !isFinite(b)) ? !1 : a.ad == null || !a.ad.isLinear();
        }
        function lH(a) {
            a.bar.ariaLabel = a.localization.resolve("SEEK");
        }
        function qH(a, b, c) {
            var d = a.j.clientWidth;
            a.j.style.width = "auto";
            a.j.style.height = "20px";
            a.j.style.top = "-30px";
            a.j.style.left = Math.min(a.bar.offsetWidth - d, Math.max(0, b - d / 2)) + "px";
            a.j.style.right = "";
            a.j.style.visibility = "visible";
            b = a.player.za();
            a.player.U() ? (c = b.end - c, c < 1 ? (a.j.textContent = a.localization.resolve("LIVE"), a.j.style.left = "", a.j.style.right = "0px") : a.j.textContent = "-" + SG(c, c >= 3600)) : (c -= b.start, a.j.textContent = SG(c, c >= 3600));
        }
        function pH(a, b, c) {
            var d, e, f, g, h, k, l, m, n, q, r, t, w, v, z, y, A, C;
            Q(function(E) {
                switch(E.g){
                    case 1:
                        c < 0 && (c = 0);
                        d = !1;
                        a.m.length && (d = a.m.some(function(D) {
                            return D.end ? c >= D.start && c <= D.end : !1;
                        }));
                        if (d) return kH(a), qH(a, b, c), E.return();
                        e = a.player.za();
                        f = Math.max(Math.ceil(e.start), Math.min(Math.floor(e.end), c));
                        a.player.U() ? (g = e.end - c, a.H.textContent = g < 1 ? a.localization.resolve("LIVE") : "-" + SG(g, g >= 3600)) : a.H.textContent = SG(c, c >= 3600);
                        return F(E, a.player.$i(null, f), 2);
                    case 2:
                        h = E.h;
                        if (!h || !h.uris || !h.uris.length) return kH(a), qH(a, b, c), E.return();
                        h.width < h.height ? a.h.classList.add("portrait-thumbnail") : a.h.classList.remove("portrait-thumbnail");
                        k = -10;
                        l = a.h.clientWidth;
                        m = Math.floor(l * 9 / 16);
                        a.h.style.height = m + "px";
                        a.h.style.top = -(m - k) + "px";
                        n = Math.min(a.bar.offsetWidth - l, Math.max(0, b - l / 2));
                        a.h.style.left = n + "px";
                        a.h.style.visibility = "visible";
                        q = h.uris[0].split("#xywh=")[0];
                        if (a.u && q === a.u.uris[0].split("#xywh=")[0] && h.startByte == a.u.startByte && h.endByte == a.u.endByte) {
                            E.B(3);
                            break;
                        }
                        a.u = h;
                        a.l && (a.l.abort(), a.l = null);
                        if (h.codecs != "mjpg" && !q.startsWith("offline:")) {
                            E.B(4);
                            break;
                        }
                        a.g.src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg"/>';
                        ra(E, 5);
                        r = fh;
                        t = Hm(h.uris, h.startByte, h.endByte, a.player.getConfiguration().streaming.retryParameters);
                        a.l = a.player.Vb().request(r, t, {
                            type: 1
                        });
                        return F(E, a.l.promise, 7);
                    case 7:
                        w = E.h;
                        a.l = null;
                        h.codecs == "mjpg" ? (v = (new oh).box("mdat", yh(function(D) {
                            q = URL.createObjectURL(new Blob([
                                D
                            ], {
                                type: "image/jpeg"
                            }));
                        })), v.parse(w.data, !1)) : (z = h.mimeType || "image/jpeg", y = new Blob([
                            w.data
                        ], {
                            type: z
                        }), q = URL.createObjectURL(y));
                        ta(E, 4);
                        break;
                    case 5:
                        A = ua(E);
                        if (A.code == 7001) return E.return();
                        throw A;
                    case 4:
                        try {
                            a.h.removeChild(a.g);
                        } catch (D) {}
                        a.g = V("img");
                        a.g.id = "shaka-player-ui-thumbnail-image";
                        a.g.draggable = !1;
                        a.g.src = q;
                        a.g.onload = function() {
                            q.startsWith("blob:") && URL.revokeObjectURL(q);
                        };
                        a.h.insertBefore(a.g, a.h.firstChild);
                    case 3:
                        C = l / h.width, h.imageHeight ? a.g.height = h.imageHeight : h.sprite || (a.g.style.height = "100%", a.g.style.objectFit = "contain"), h.imageWidth ? a.g.width = h.imageWidth : h.sprite || (a.g.style.width = "100%", a.g.style.objectFit = "contain"), a.g.style.left = "-" + C * h.positionX + "px", a.g.style.top = "-" + C * h.positionY + "px", a.g.style.transform = "scale(" + C + ")", a.g.style.transformOrigin = "left top", m = Math.floor(l * h.height / h.width), a.h.style.height = m + "px", a.h.style.top = -(m - k) + "px", H(E);
                }
            });
        }
        function kH(a) {
            a.h.style.visibility = "hidden";
        }
        function oH(a) {
            a.j.style.visibility = "hidden";
        }
        S("shaka.ui.SeekBar", iH);
        function rH() {}
        rH.prototype.create = function(a, b) {
            return new iH(a, b);
        };
        iH.Factory = rH;
        function sH(a, b) {
            LG.call(this, a, b);
            var c = this;
            this.j = V("div");
            this.j.classList.add("shaka-skip-ad-container");
            this.parent.appendChild(this.j);
            this.h = V("div");
            this.h.classList.add("shaka-skip-ad-counter");
            RG(this.h, !1);
            this.j.appendChild(this.h);
            this.g = Lj();
            this.g.classList.add("shaka-skip-ad-button");
            this.g.disabled = !0;
            RG(this.g, !1);
            this.g.classList.add("shaka-no-propagation");
            this.j.appendChild(this.g);
            tH(this);
            this.i = new Bf(function() {
                if (c.ad.isSkippable()) {
                    var d = Math.round(c.ad.getTimeUntilSkippable());
                    d > 0 ? c.h.textContent = d : (c.i.stop(), RG(c.h, !1));
                } else uH(c);
            });
            this.eventManager.o(this.localization, "locale-updated", function() {
                tH(c);
            });
            this.eventManager.o(this.localization, "locale-changed", function() {
                tH(c);
            });
            this.eventManager.o(this.adManager, "ad-started", function() {
                vH(c);
            });
            this.eventManager.o(this.adManager, "ad-skip-state-changed", function() {
                c.ad.isSkippable() ? c.ad.canSkipNow() && (c.g.disabled = !1, c.i.stop(), RG(c.h, !1)) : uH(c);
            });
            this.eventManager.o(this.adManager, "ad-stopped", function() {
                uH(c);
            });
            this.eventManager.o(this.g, "click", function() {
                c.ad.skip();
            });
            this.ad && vH(this);
        }
        la(sH, LG);
        sH.prototype.release = function() {
            this.i.stop();
            this.i = null;
            LG.prototype.release.call(this);
        };
        function tH(a) {
            a.g.textContent = a.localization.resolve("SKIP_AD");
        }
        function vH(a) {
            a.ad.isSkippable() && a.ad.needsSkipUI() && (RG(a.g, !0), RG(a.h, !0), a.h.textContent = "", a.i.La(), a.i.wa(.5));
        }
        function uH(a) {
            a.i.stop();
            a.g.disabled = !0;
            RG(a.g, !1);
            RG(a.h, !1);
        }
        S("shaka.ui.SkipAdButton", sH); /*
 @license
 glMatrix: https://github.com/toji/gl-matrix/
 Copyright 2015-2021, Brandon Jones, Colin MacKenzie IV
 SPDX-License-Identifier: MIT
*/ 
        function wH() {
            var a = new Float32Array(16);
            a[0] = 1;
            a[5] = 1;
            a[10] = 1;
            a[15] = 1;
            return a;
        }
        function xH(a, b, c) {
            b = 1 / Math.tan(b / 2);
            a[0] = b / c;
            a[1] = 0;
            a[2] = 0;
            a[3] = 0;
            a[4] = 0;
            a[5] = b;
            a[6] = 0;
            a[7] = 0;
            a[8] = 0;
            a[9] = 0;
            a[11] = -1;
            a[12] = 0;
            a[13] = 0;
            a[15] = 0;
            c = 1 / -99.9;
            a[10] = 100.1 * c;
            a[14] = 20 * c;
        }
        function yH(a, b, c) {
            var d = b[0], e = b[1], f = b[2], g = b[3], h = b[4], k = b[5], l = b[6], m = b[7], n = b[8], q = b[9], r = b[10], t = b[11], w = b[12], v = b[13], z = b[14];
            b = b[15];
            var y = c[0], A = c[1], C = c[2], E = c[3];
            a[0] = y * d + A * h + C * n + E * w;
            a[1] = y * e + A * k + C * q + E * v;
            a[2] = y * f + A * l + C * r + E * z;
            a[3] = y * g + A * m + C * t + E * b;
            y = c[4];
            A = c[5];
            C = c[6];
            E = c[7];
            a[4] = y * d + A * h + C * n + E * w;
            a[5] = y * e + A * k + C * q + E * v;
            a[6] = y * f + A * l + C * r + E * z;
            a[7] = y * g + A * m + C * t + E * b;
            y = c[8];
            A = c[9];
            C = c[10];
            E = c[11];
            a[8] = y * d + A * h + C * n + E * w;
            a[9] = y * e + A * k + C * q + E * v;
            a[10] = y * f + A * l + C * r + E * z;
            a[11] = y * g + A * m + C * t + E * b;
            y = c[12];
            A = c[13];
            C = c[14];
            E = c[15];
            a[12] = y * d + A * h + C * n + E * w;
            a[13] = y * e + A * k + C * q + E * v;
            a[14] = y * f + A * l + C * r + E * z;
            a[15] = y * g + A * m + C * t + E * b;
        }
        function zH(a, b) {
            var c = new Float32Array(3), d = b[0], e = b[1], f = b[2], g = b[4], h = b[5], k = b[6], l = b[8], m = b[9], n = b[10];
            c[0] = Math.sqrt(d * d + e * e + f * f);
            c[1] = Math.sqrt(g * g + h * h + k * k);
            c[2] = Math.sqrt(l * l + m * m + n * n);
            k = 1 / c[0];
            l = 1 / c[1];
            m = 1 / c[2];
            g = b[0] * k;
            c = b[1] * l;
            d = b[2] * m;
            e = b[4] * k;
            h = b[5] * l;
            f = b[6] * m;
            k *= b[8];
            l *= b[9];
            b = b[10] * m;
            m = g + h + b;
            m > 0 ? (b = Math.sqrt(m + 1) * 2, a[3] = .25 * b, a[0] = (f - l) / b, a[1] = (k - d) / b, a[2] = (c - e) / b) : g > h && g > b ? (b = Math.sqrt(1 + g - h - b) * 2, a[3] = (f - l) / b, a[0] = .25 * b, a[1] = (c + e) / b, a[2] = (k + d) / b) : h > b ? (b = Math.sqrt(1 + h - g - b) * 2, a[3] = (k - d) / b, a[0] = (c + e) / b, a[1] = .25 * b, a[2] = (f + l) / b) : (b = Math.sqrt(1 + b - g - h) * 2, a[3] = (c - e) / b, a[0] = (k + d) / b, a[1] = (f + l) / b, a[2] = .25 * b);
        }
        function AH(a, b) {
            var c = b[0], d = b[1], e = b[2];
            b = b[3];
            var f = c + c, g = d + d, h = e + e;
            c *= f;
            var k = d * f;
            d *= g;
            var l = e * f, m = e * g;
            e *= h;
            f *= b;
            g *= b;
            b *= h;
            a[0] = 1 - d - e;
            a[1] = k + b;
            a[2] = l - g;
            a[3] = 0;
            a[4] = k - b;
            a[5] = 1 - c - e;
            a[6] = m + f;
            a[7] = 0;
            a[8] = l + g;
            a[9] = m - f;
            a[10] = 1 - c - d;
            a[11] = 0;
            a[12] = 0;
            a[13] = 0;
            a[14] = 0;
            a[15] = 1;
        }
        function BH() {
            var a = new Float32Array(4);
            a[3] = 1;
            return a;
        }
        function CH(a, b) {
            var c = b[0], d = b[1], e = b[2];
            b = b[3];
            var f = c * c + d * d + e * e + b * b;
            f > 0 && (f = 1 / Math.sqrt(f));
            a[0] = c * f;
            a[1] = d * f;
            a[2] = e * f;
            a[3] = b * f;
        }
        function DH(a) {
            var b = [], c = [], d = [], e = Math.PI;
            a = (a === void 0 ? 0 : a) ? e / 2 : e;
            for(var f = 0; f <= 100; f++){
                var g = f * e / 100, h = Math.sin(g);
                g = Math.cos(g);
                for(var k = 0; k <= 100; k++){
                    var l = k * 2 * a / 100;
                    b.push(Math.sin(l) * h, g, Math.cos(l) * h);
                    c.push(k / 100, f / 100);
                }
            }
            for(e = 0; e < 100; e++)for(a = 0; a < 100; a++)f = e * 101 + a, h = f + 100 + 1, d.push(f, h, f + 1), d.push(h, h + 1, f + 1);
            return {
                ek: b,
                $j: c,
                indices: d
            };
        }
        function EH(a, b, c, d, e) {
            this.i = a;
            this.ra = b;
            this.u = c;
            this.g = d;
            this.A = new Tc;
            this.M = BH();
            this.h = BH();
            this.ea = this.oa = this.aa = this.l = null;
            this.F = wH();
            this.J = wH();
            this.O = wH();
            this.X = wH();
            this.D = null;
            this.P = !1;
            this.K = this.C = null;
            this.sa = this.xa = 0;
            this.Y = this.R = this.S = this.L = null;
            this.I = this.H = 0;
            this.j = 75;
            this.V = 0;
            this.m = e;
            this.G = -1;
            FH(this);
        }
        EH.prototype.release = function() {
            this.G != -1 && (this.i.cancelVideoFrameCallback(this.G), this.G = -1);
            this.A && (this.A.release(), this.A = null);
            this.C && (this.C.stop(), this.C = null);
            this.K && (this.K.stop(), this.K = null);
        };
        EH.prototype.$d = function() {
            (this.P = !this.P) || this.g.viewport(0, 0, this.u.width, this.u.height);
            GH(this, !1);
        };
        function FH(a) {
            HH(a);
            IH(a);
            JH(a);
            KH(a);
            LH(a);
            Gl(a.i, HTMLMediaElement.HAVE_CURRENT_DATA, a.A, function() {
                a.i.readyState >= HTMLMediaElement.HAVE_ENOUGH_DATA && GH(a);
                if ("requestVideoFrameCallback" in a.i) {
                    var b = function() {
                        a.G != -1 && (GH(a), a.G != -1 && (a.G = a.i.requestVideoFrameCallback(b)));
                    };
                    a.G = a.i.requestVideoFrameCallback(b);
                } else {
                    var c;
                    a.A.o(a.i, "canplaythrough", function() {
                        GH(a);
                    });
                    a.A.o(a.i, "playing", function() {
                        a.C && a.C.stop();
                        if (!c) {
                            var d = a.ra.Ob();
                            d = u(d);
                            for(var e = d.next(); !e.done; e = d.next())(e = e.value.frameRate) && (!c || c < e) && (c = e);
                        }
                        c || (c = 60);
                        GH(a);
                        a.C = new Bf(function() {
                            GH(a);
                        }).La().wa(1 / c);
                    });
                    a.A.o(a.i, "pause", function() {
                        a.C && a.C.stop();
                        a.C = null;
                        GH(a);
                    });
                    a.A.o(a.i, "seeked", function() {
                        GH(a);
                    });
                    a.A.o(document, "visibilitychange", function() {
                        GH(a);
                    });
                }
            });
        }
        function HH(a) {
            var b = a.F, c = [
                0,
                0,
                0
            ], d = [
                1,
                0,
                0
            ], e = [
                0,
                1,
                0
            ], f = c[0], g = c[1];
            c = c[2];
            var h = e[0];
            var k = e[1];
            var l = e[2];
            var m = d[0];
            e = d[1];
            var n = d[2];
            if (Math.abs(f - m) < 1E-6 && Math.abs(g - e) < 1E-6 && Math.abs(c - n) < 1E-6) for(f = 0; f < 16; f++)b[f] = f % 5 == 0 ? 1 : 0;
            else {
                d = f - m;
                e = g - e;
                m = c - n;
                var q = 1 / Math.sqrt(d * d + e * e + m * m);
                d *= q;
                e *= q;
                m *= q;
                n = k * m - l * e;
                l = l * d - h * m;
                h = h * e - k * d;
                (q = Math.sqrt(n * n + l * l + h * h)) ? (q = 1 / q, n *= q, l *= q, h *= q) : h = l = n = 0;
                k = e * h - m * l;
                var r = m * n - d * h;
                var t = d * l - e * n;
                (q = Math.sqrt(k * k + r * r + t * t)) ? (q = 1 / q, k *= q, r *= q, t *= q) : t = r = k = 0;
                b[0] = n;
                b[1] = k;
                b[2] = d;
                b[3] = 0;
                b[4] = l;
                b[5] = r;
                b[6] = e;
                b[7] = 0;
                b[8] = h;
                b[9] = t;
                b[10] = m;
                b[11] = 0;
                b[12] = -(n * f + l * g + h * c);
                b[13] = -(k * f + r * g + t * c);
                b[14] = -(d * f + e * g + m * c);
                b[15] = 1;
            }
            zH(a.M, a.F);
            a = b = a.X;
            c = [
                4,
                4,
                4
            ];
            f = c[0];
            g = c[1];
            c = c[2];
            b[0] = a[0] * f;
            b[1] = a[1] * f;
            b[2] = a[2] * f;
            b[3] = a[3] * f;
            b[4] = a[4] * g;
            b[5] = a[5] * g;
            b[6] = a[6] * g;
            b[7] = a[7] * g;
            b[8] = a[8] * c;
            b[9] = a[9] * c;
            b[10] = a[10] * c;
            b[11] = a[11] * c;
            b[12] = a[12];
            b[13] = a[13];
            b[14] = a[14];
            b[15] = a[15];
        }
        function IH(a) {
            MH(a);
            a.g.viewport(0, 0, a.g.drawingBufferWidth, a.g.drawingBufferHeight);
            a.g.clearColor(0, 0, 0, 1);
            a.g.enable(a.g.CULL_FACE);
            a.g.cullFace(a.g.FRONT);
            a.g.clear(a.g.COLOR_BUFFER_BIT);
        }
        function JH(a) {
            var b = NH(a, a.g.VERTEX_SHADER), c = NH(a, a.g.FRAGMENT_SHADER);
            a.l = a.g.createProgram();
            a.g.attachShader(a.l, b);
            a.g.attachShader(a.l, c);
            a.g.linkProgram(a.l);
            a.m == "cubemap" ? (a.S = a.g.getAttribLocation(a.l, "aVertexPosition"), a.R = a.g.getAttribLocation(a.l, "aTextureCoord")) : (a.S = a.g.getAttribLocation(a.l, "a_vPosition"), a.g.enableVertexAttribArray(a.S), a.R = a.g.getAttribLocation(a.l, "a_TexCoordinate"), a.g.enableVertexAttribArray(a.R));
        }
        function NH(a, b) {
            switch(b){
                case a.g.VERTEX_SHADER:
                    var c = a.m == "cubemap" ? "attribute vec4 aVertexPosition;\nattribute vec2 aTextureCoord;\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\nvarying highp vec2 vTextureCoord;\nvarying highp vec3 vLighting;\nvoid main(void) {\n  gl_Position = uProjectionMatrix * uModelViewMatrix * aVertexPosition;\n  vTextureCoord = aTextureCoord;\n}" : "attribute vec4 a_vPosition;\n// Per-vertex texture coordinate info\nattribute vec2 a_TexCoordinate;\nuniform mat4 u_VPMatrix;\n// Passed into the fragment shader.\nvarying vec2 v_TexCoordinate;\nvarying vec3 pass_position;\nvoid main()\n{\n gl_Position = u_VPMatrix * a_vPosition;\n // Pass through texture coord\n v_TexCoordinate = a_TexCoordinate;\n pass_position = a_vPosition.xyz;\n}";
                    break;
                case a.g.FRAGMENT_SHADER:
                    c = a.m == "cubemap" ? "varying highp vec2 vTextureCoord;\nuniform sampler2D uSampler;\nvoid main(void) {\n  highp vec4 texelColor = texture2D(uSampler, vTextureCoord);\n  gl_FragColor = vec4(texelColor.rgb , texelColor.a);\n}" : "precision highp float;\n#define PI 3.141592653589793238462643383279\nvarying vec2 v_TexCoordinate;\nvarying vec3 pass_position;\nuniform sampler2D uSampler;\nvoid main(void) {\nhighp float xValue =\n      (PI + atan(pass_position.z, pass_position.x)) / (2.0 * PI);\n vec2 tc = vec2(xValue, v_TexCoordinate.t);\n tc = vec2(tc.x , tc.y);\nhighp vec4 texelColor =\n      texture2D(uSampler, tc);\n  gl_FragColor = vec4(texelColor.rgb, texelColor.a);\n}";
                    break;
                default:
                    return null;
            }
            b = a.g.createShader(b);
            a.g.shaderSource(b, c);
            a.g.compileShader(b);
            return b;
        }
        function KH(a) {
            a.L = a.m == "cubemap" ? {
                ek: [
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    1,
                    -1,
                    1,
                    1,
                    -1,
                    1,
                    -1,
                    -1,
                    1,
                    -1,
                    -1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    -1,
                    -1,
                    -1,
                    1,
                    1,
                    -1,
                    1,
                    1,
                    1,
                    1,
                    -1,
                    1,
                    1,
                    1,
                    -1,
                    -1,
                    1,
                    1,
                    -1,
                    1,
                    1,
                    1,
                    1,
                    -1,
                    1,
                    -1,
                    -1,
                    -1,
                    1,
                    -1,
                    -1,
                    1,
                    -1,
                    1,
                    -1,
                    -1,
                    1,
                    -1,
                    -1,
                    -1,
                    -1,
                    1,
                    -1,
                    1,
                    1,
                    -1,
                    1,
                    -1,
                    -1
                ],
                $j: [
                    2 / 3,
                    .5,
                    1 / 3,
                    .5,
                    1 / 3,
                    0,
                    2 / 3,
                    0,
                    2 / 3,
                    .5,
                    2 / 3,
                    0,
                    1,
                    0,
                    1,
                    .5,
                    1,
                    1,
                    2 / 3,
                    1,
                    2 / 3,
                    .5,
                    1,
                    .5,
                    0,
                    .5,
                    0,
                    0,
                    1 / 3,
                    0,
                    1 / 3,
                    .5,
                    0,
                    .5,
                    1 / 3,
                    .5,
                    1 / 3,
                    1,
                    0,
                    1,
                    1 / 3,
                    1,
                    1 / 3,
                    .5,
                    2 / 3,
                    .5,
                    2 / 3,
                    1
                ],
                indices: [
                    0,
                    1,
                    2,
                    0,
                    2,
                    3,
                    4,
                    5,
                    6,
                    4,
                    6,
                    7,
                    8,
                    9,
                    10,
                    8,
                    10,
                    11,
                    12,
                    13,
                    14,
                    12,
                    14,
                    15,
                    16,
                    17,
                    18,
                    16,
                    18,
                    19,
                    20,
                    21,
                    22,
                    20,
                    22,
                    23
                ]
            } : a.m == "halfequirectangular" ? DH(!0) : DH();
            a.aa = a.g.createBuffer();
            a.g.bindBuffer(a.g.ARRAY_BUFFER, a.aa);
            a.g.bufferData(a.g.ARRAY_BUFFER, new Float32Array(a.L.ek), a.g.STATIC_DRAW);
            a.oa = a.g.createBuffer();
            a.g.bindBuffer(a.g.ARRAY_BUFFER, a.oa);
            a.g.bufferData(a.g.ARRAY_BUFFER, new Float32Array(a.L.$j), a.g.STATIC_DRAW);
            a.ea = a.g.createBuffer();
            a.g.bindBuffer(a.g.ELEMENT_ARRAY_BUFFER, a.ea);
            a.g.bufferData(a.g.ELEMENT_ARRAY_BUFFER, new Uint16Array(a.L.indices), a.g.STATIC_DRAW);
        }
        function LH(a) {
            a.Y = a.g.createTexture();
            a.g.bindTexture(a.g.TEXTURE_2D, a.Y);
            a.g.texParameteri(a.g.TEXTURE_2D, a.g.TEXTURE_WRAP_S, a.g.CLAMP_TO_EDGE);
            a.g.texParameteri(a.g.TEXTURE_2D, a.g.TEXTURE_WRAP_T, a.g.CLAMP_TO_EDGE);
            a.g.texParameteri(a.g.TEXTURE_2D, a.g.TEXTURE_MIN_FILTER, a.g.NEAREST);
            a.g.texParameteri(a.g.TEXTURE_2D, a.g.TEXTURE_MAG_FILTER, a.g.NEAREST);
        }
        function GH(a, b) {
            b = b === void 0 ? !0 : b;
            var c = a.ra.l == vr;
            if (!(!a.i || a.i.readyState < 2 || !c && a.i.playbackRate == 0)) {
                xH(a.J, a.j * Math.PI / 180, 1.5625);
                a.m == "cubemap" ? xH(a.J, a.j * Math.PI / 180, 2.5) : xH(a.J, a.j * Math.PI / 180, 1.5625);
                a.g.useProgram(a.l);
                a.g.clear(a.g.COLOR_BUFFER_BIT);
                MH(a);
                b && (a.g.activeTexture(a.g.TEXTURE0), a.g.bindTexture(a.g.TEXTURE_2D, a.Y), a.g.pixelStorei(a.g.UNPACK_PREMULTIPLY_ALPHA_WEBGL, 0), a.g.texImage2D(a.g.TEXTURE_2D, 0, a.g.RGBA, a.g.RGBA, a.g.UNSIGNED_BYTE, a.i));
                if (a.m == "equirectangular" || a.m == "halfequirectangular") yH(a.O, a.F, a.X), yH(a.O, a.J, a.O);
                a.g.bindBuffer(a.g.ARRAY_BUFFER, a.aa);
                a.g.vertexAttribPointer(a.S, 3, a.g.FLOAT, !1, 0, 0);
                a.g.enableVertexAttribArray(a.S);
                a.g.bindBuffer(a.g.ARRAY_BUFFER, a.oa);
                a.g.vertexAttribPointer(a.R, 2, a.g.FLOAT, !1, 0, 0);
                a.g.enableVertexAttribArray(a.R);
                a.g.bindBuffer(a.g.ELEMENT_ARRAY_BUFFER, a.ea);
                a.m == "cubemap" ? (a.g.uniformMatrix4fv(a.g.getUniformLocation(a.l, "uProjectionMatrix"), !1, a.J), a.g.uniformMatrix4fv(a.g.getUniformLocation(a.l, "uModelViewMatrix"), !1, a.O)) : a.g.uniformMatrix4fv(a.g.getUniformLocation(a.l, "u_VPMatrix"), !1, a.O);
                a.g.uniform1i(a.g.getUniformLocation(a.l, "uSampler"), 0);
                a.P && a.g.viewport(0, 0, a.u.width / 2, a.u.height);
                a.g.drawElements(a.g.TRIANGLES, a.L.indices.length, a.g.UNSIGNED_SHORT, 0);
                a.P && (a.g.viewport(a.u.width / 2, 0, a.u.width / 2, a.u.height), a.g.drawElements(a.g.TRIANGLES, a.L.indices.length, a.g.UNSIGNED_SHORT, 0));
            }
        }
        function MH(a) {
            var b = a.i.videoWidth;
            b || (b = a.u.scrollWidth);
            var c = a.i.videoHeight;
            c || (c = a.u.scrollHeight);
            if (a.xa !== b || a.sa !== c) {
                a.u.width = b;
                a.u.height = c;
                a.xa = b;
                a.sa = c;
                var d = b / c, e = a.J, f = -d, g = 1 / (d - f);
                e[0] = 0 * g;
                e[1] = 0;
                e[2] = 0;
                e[3] = 0;
                e[4] = 0;
                e[5] = 0;
                e[6] = 0;
                e[7] = 0;
                e[8] = (d + f) * g;
                e[9] = 0;
                e[10] = -1;
                e[11] = -1;
                e[12] = 0;
                e[13] = 0;
                e[14] = -0;
                e[15] = 0;
                a.J = e;
                a.g.viewport(0, 0, b, c);
            }
        }
        function OH(a, b, c, d) {
            var e = Infinity, f = 90 * Math.PI / 180;
            a.m == "halfequirectangular" && (e = 90 * Math.PI / 180, f /= 2);
            var g = a.m == "cubemap" ? a.O : a.F;
            a.H += b;
            a.I += c;
            if (a.H < e && a.H > -e) {
                e = Math.sin(b);
                b = Math.cos(b);
                var h = g[0], k = g[1], l = g[2], m = g[3], n = g[8], q = g[9], r = g[10], t = g[11];
                g !== g && (g[4] = g[4], g[5] = g[5], g[6] = g[6], g[7] = g[7], g[12] = g[12], g[13] = g[13], g[14] = g[14], g[15] = g[15]);
                g[0] = h * b - n * e;
                g[1] = k * b - q * e;
                g[2] = l * b - r * e;
                g[3] = m * b - t * e;
                g[8] = h * e + n * b;
                g[9] = k * e + q * b;
                g[10] = l * e + r * b;
                g[11] = m * e + t * b;
            } else a.H -= b;
            a.I < f && a.I > -f ? (f = wH(), e = wH(), b = -1 * c, c = Math.sin(b), b = Math.cos(b), h = e[4], k = e[5], l = e[6], m = e[7], n = e[8], q = e[9], r = e[10], t = e[11], e !== f && (f[0] = e[0], f[1] = e[1], f[2] = e[2], f[3] = e[3], f[12] = e[12], f[13] = e[13], f[14] = e[14], f[15] = e[15]), f[4] = h * b + n * c, f[5] = k * b + q * c, f[6] = l * b + r * c, f[7] = m * b + t * c, f[8] = n * b - h * c, f[9] = q * b - k * c, f[10] = r * b - l * c, f[11] = t * b - m * c, yH(g, f, g)) : a.I -= c;
            c = wH();
            f = wH();
            e = Math.sin(d);
            d = Math.cos(d);
            b = f[0];
            h = f[1];
            k = f[2];
            l = f[3];
            m = f[4];
            n = f[5];
            q = f[6];
            r = f[7];
            f !== c && (c[8] = f[8], c[9] = f[9], c[10] = f[10], c[11] = f[11], c[12] = f[12], c[13] = f[13], c[14] = f[14], c[15] = f[15]);
            c[0] = b * d + m * e;
            c[1] = h * d + n * e;
            c[2] = k * d + q * e;
            c[3] = l * d + r * e;
            c[4] = m * d - b * e;
            c[5] = n * d - h * e;
            c[6] = q * d - k * e;
            c[7] = r * d - l * e;
            yH(g, c, g);
            GH(a, !1);
        }
        function PH(a, b) {
            if (b === void 0 || b) zH(a.h, a.F), a.V = 0, a.D = BH(), a.D[0] = (a.h[0] - a.M[0]) / 20, a.D[1] = (a.h[1] - a.M[1]) / 20, a.D[2] = (a.h[2] - a.M[2]) / 20, a.D[3] = (a.h[3] - a.M[3]) / 20;
            a.h[0] -= a.D[0];
            a.h[1] -= a.D[1];
            a.h[2] -= a.D[2];
            a.h[3] -= a.D[3];
            b = wH();
            CH(a.h, a.h);
            AH(b, a.h);
            a.F = b;
            a.K && (a.K.stop(), a.K = null);
            a.V < 20 ? a.K = new Bf(function() {
                PH(a, !1);
                a.H = 0;
                a.I = 0;
                a.V++;
                GH(a, !1);
            }).$(.025) : (AH(b, a.M), a.F = b);
        }
        function QH(a, b, c, d, e) {
            kb.call(this);
            var f = this;
            this.i = a;
            this.l = b;
            this.G = c;
            this.K = d;
            this.A = e;
            this.u = new Tc;
            this.h = new Tc;
            this.C = RH(this.l);
            this.g = null;
            this.m = !1;
            this.J = this.I = this.H = this.F = this.D = 0;
            this.j = null;
            this.u.o(d, "loading", function() {
                f.g && PH(f.g);
                SH(f);
            });
            this.u.o(d, "spatialvideoinfo", function(g) {
                g = g.detail;
                switch(g.projection){
                    case "rect":
                        f.j = null;
                        break;
                    case "equi":
                        f.j = "equirectangular";
                        break;
                    case "hequ":
                        switch(g.hfov){
                            case 360:
                                f.j = "equirectangular";
                                break;
                            case 180:
                                f.j = "halfequirectangular";
                                break;
                            default:
                                g.hfov == null ? f.j = "halfequirectangular" : f.j = null;
                        }
                        break;
                    case "fish":
                        f.j = "halfequirectangular";
                        break;
                    default:
                        f.j = null;
                }
                SH(f);
            });
            this.u.o(d, "nospatialvideoinfo", function() {
                f.j = null;
                SH(f);
            });
            this.u.o(d, "unloading", function() {
                f.j = null;
                SH(f);
            });
            SH(this);
        }
        la(QH, kb);
        p = QH.prototype;
        p.release = function() {
            this.u && (this.u.release(), this.u = null);
            this.h && (this.h.release(), this.h = null);
            this.g && (this.g.release(), this.g = null);
            kb.prototype.release.call(this);
        };
        p.configure = function(a) {
            this.A = a;
            SH(this);
        };
        p.Lg = function() {
            return this.l ? !!this.C : !!RH(document.createElement("canvas"));
        };
        p.Xb = function() {
            return !!this.g;
        };
        p.$d = function() {
            this.g ? this.g.$d() : ab("Not playing VR content");
        };
        p.Bh = function(a) {
            this.g ? OH(this.g, a * TH, 0, 0) : ab("Not playing VR content");
        };
        p.yh = function(a) {
            this.g ? OH(this.g, 0, a * TH, 0) : ab("Not playing VR content");
        };
        p.Ah = function(a) {
            this.g ? OH(this.g, 0, 0, a * TH) : ab("Not playing VR content");
        };
        function SH(a) {
            if (a.A.displayInVrMode || a.j) {
                a.l || (a.l = document.createElement("canvas"), a.l.classList.add("shaka-vr-canvas-container"), a.G.parentElement.insertBefore(a.l, a.G.nextElementSibling), a.C = RH(a.l));
                var b = a.j || a.A.defaultVrProjectionMode;
                a.g ? a.g.m != b && (a.h.Sa(), a.g.release(), UH(a, b)) : (a.l.style.display = "", UH(a, b), a.dispatchEvent(new T("vrstatuschanged", (new Map).set("newStatus", a.Xb()))));
            } else !a.A.displayInVrMode && !a.j && a.l && a.g && (a.l.style.display = "none", a.h.Sa(), a.g.release(), a.g = null, a.dispatchEvent(new T("vrstatuschanged", (new Map).set("newStatus", a.Xb()))));
        }
        function UH(a, b) {
            a.C && a.l && (a.g = new EH(a.G, a.K, a.l, a.C, b), VH(a));
        }
        function RH(a) {
            if (!a) return null;
            var b = Rb().Ka();
            if (b == "TV" || b == "CONSOLE" || b == "CAST") return null;
            b = u([
                "webgl2",
                "webgl"
            ]);
            for(var c = b.next(); !c.done; c = b.next())if (c = a.getContext(c.value)) return c;
            return null;
        }
        function VH(a) {
            a.h.o(a.i, "mousedown", function(d) {
                if (!a.m) {
                    var e = d.clientX;
                    d = d.clientY;
                    a.m = !0;
                    a.D = e;
                    a.F = d;
                }
            });
            navigator.maxTouchPoints > 0 && a.h.o(a.i, "touchstart", function(d) {
                if (!a.m) {
                    var e = d.touches[0].clientX;
                    d = d.touches[0].clientY;
                    a.m = !0;
                    a.D = e;
                    a.F = d;
                }
            });
            a.h.o(a.i, "wheel", function(d) {
                if (!a.m) {
                    var e = a.g, f = d.deltaY;
                    f /= 50;
                    e.j >= 20 && e.j <= 100 && (e.j += f);
                    e.j < 20 ? e.j = 20 : e.j > 100 && (e.j = 100);
                    GH(e, !1);
                    d.preventDefault();
                    d.stopPropagation();
                }
            });
            a.h.o(a.i, "mousemove", function(d) {
                a.m && WH(a, d.clientX, d.clientY);
            });
            navigator.maxTouchPoints > 0 && a.h.o(a.i, "touchmove", function(d) {
                a.m && WH(a, d.touches[0].clientX, d.touches[0].clientY);
                d.preventDefault();
            });
            a.h.o(a.i, "mouseleave", function() {
                a.m = !1;
            });
            a.h.o(a.i, "mouseup", function() {
                a.m = !1;
            });
            navigator.maxTouchPoints > 0 && a.h.o(a.i, "touchend", function() {
                a.m = !1;
            });
            var b = !1;
            if (window1.DeviceOrientationEvent) {
                if (typeof DeviceMotionEvent.requestPermission == "function") {
                    var c = function() {
                        DeviceMotionEvent.requestPermission().then(function(d) {
                            d !== "granted" || b || (b = !0, XH(a));
                        });
                    };
                    DeviceMotionEvent.requestPermission().then(function(d) {
                        a.h.Ea(a.i, "click", c);
                        a.h.Ea(a.i, "mouseup", c);
                        navigator.maxTouchPoints > 0 && a.h.Ea(a.i, "touchend", c);
                        d !== "granted" ? (a.h.ua(a.i, "click", c), a.h.ua(a.i, "mouseup", c), navigator.maxTouchPoints > 0 && a.h.ua(a.i, "touchend", c)) : (b = !0, XH(a));
                    }).catch(function() {
                        a.h.Ea(a.i, "click", c);
                        a.h.Ea(a.i, "mouseup", c);
                        navigator.maxTouchPoints > 0 && a.h.Ea(a.i, "touchend", c);
                        a.h.ua(a.i, "click", c);
                        a.h.ua(a.i, "mouseup", c);
                        navigator.maxTouchPoints > 0 && a.h.ua(a.i, "touchend", c);
                    });
                } else b = !0, XH(a);
            }
        }
        function XH(a) {
            a.h.o(window1, "deviceorientation", function(b) {
                if (a.g) {
                    var c = (b.alpha || 0) - a.H, d = (b.beta || 0) - a.I, e = (b.gamma || 0) - a.J;
                    if (Math.abs(c) > 10 || Math.abs(d) > 10 || Math.abs(e) > 5) d = e = c = 0;
                    a.H = b.alpha || 0;
                    a.I = b.beta || 0;
                    a.J = b.gamma || 0;
                    b = screen.orientation.angle;
                    b == 90 || b == -90 ? OH(a.g, c * TH * -1, e * TH * -1, 0) : OH(a.g, c * TH * -1, d * TH, 0);
                }
            });
        }
        function WH(a, b, c) {
            var d = -0.6 * Math.PI / 180;
            OH(a.g, (b - a.D) * d, (c - a.F) * -1 * d, 0);
            a.D = b;
            a.F = c;
        }
        var TH = Math.PI / 180;
        function Z(a, b, c, d, e) {
            kb.call(this);
            var f = this;
            this.Y = !0;
            this.g = e;
            this.F = new St(c, a, this.g.castReceiverAppId, this.g.castAndroidReceiverCompatible);
            this.ra = !0;
            this.C = this.F.Vc();
            this.u = c;
            this.m = this.F.Wb();
            this.aa = a;
            this.l = b;
            this.Pb = d;
            this.oa = this.m.tf();
            this.A = this.j = null;
            this.S = !1;
            this.J = [];
            this.fb = [];
            this.Oa = !1;
            this.K = new Bf(function() {
                f.l.classList.add("no-cursor");
                f.Oa = !1;
                YH(f);
            });
            this.ea = new Bf(function() {
                f.i.removeAttribute("shown");
                ZH(f);
                $H(f);
                f.X && f.X.Oi();
                f.O.$(f.g.closeMenusDelay);
            });
            this.O = new Bf(function() {
                for(var g = u(f.J), h = g.next(); !h.done; h = g.next())RG(h.value, !1);
                f.g.enableTooltips && f.G.classList.add("shaka-tooltips-on");
            });
            this.xa = new Bf(function() {
                f.Ca() && aI(f);
            });
            this.P = null;
            this.I = [];
            this.sa = bI();
            this.h = new Tc;
            this.D = null;
            this.configure(this.g);
            cI(this);
            dI(this);
            this.V = new Set;
            eI(this);
            this.xa.wa(this.g.refreshTickInSeconds);
            this.h.o(this.sa, "locale-changed", function(g) {
                g = g.locales[0];
                f.oa.setLocale(g);
                f.l.setAttribute("lang", g);
            });
            this.oa.initInterstitial(this.H, this.aa, this.u);
            this.h.o(this.m, "texttrackvisibility", function() {
                $H(f);
            });
            this.h.o(this.m, "unloading", function() {
                f.j || (f.xb() && fI(f), f.Md() && f.cd());
            });
        }
        la(Z, kb);
        p = Z.prototype;
        p.destroy = function(a) {
            a = a === void 0 ? !1 : a;
            var b = this;
            return Q(function(c) {
                switch(c.g){
                    case 1:
                        if (document.pictureInPictureElement != b.u) {
                            c.B(2);
                            break;
                        }
                        return F(c, document.exitPictureInPicture(), 2);
                    case 2:
                        b.h && (b.h.release(), b.h = null);
                        b.K && (b.K.stop(), b.K = null);
                        b.ea && (b.ea.stop(), b.ea = null);
                        b.O && (b.O.stop(), b.O = null);
                        b.xa && (b.xa.stop(), b.xa = null);
                        b.D && (b.D.release(), b.D = null);
                        gI(b);
                        b.i && (b.l.removeChild(b.i), b.i = null);
                        if (!b.F) {
                            c.B(4);
                            break;
                        }
                        return F(c, b.F.destroy(a), 5);
                    case 5:
                        b.F = null;
                    case 4:
                        b.L && (b.l.removeChild(b.L), b.L = null);
                        b.H && (b.l.removeChild(b.H), b.H = null);
                        if (!b.aa) {
                            c.B(6);
                            break;
                        }
                        return F(c, b.aa.destroy(), 7);
                    case 7:
                        b.aa = null;
                    case 6:
                        b.m = null, b.u = null, b.C = null, b.sa = null, b.V.clear(), hI(b), kb.prototype.release.call(b), H(c);
                }
            });
        };
        function gI(a) {
            for(var b = u(a.I), c = b.next(); !c.done; c = b.next())c.value.release();
            a.I = [];
        }
        function iI(a, b) {
            jI.set(a, b);
        }
        p.kk = function(a) {
            this.ra = a;
            eI(this);
        };
        p.Ml = function() {
            YH(this);
        };
        p.configure = function(a) {
            var b = this;
            this.g = a;
            this.F.Mi(a.castReceiverAppId, a.castAndroidReceiverCompatible);
            this.A && (this.A = null);
            this.Ma && (this.Ma = null);
            this.X && (this.X = null);
            this.D && this.D.configure(a);
            this.i ? (Pj(this.i), gI(this)) : (kI(this), lI(this), this.D = new QH(this.i, this.Pb, this.u, this.m, this.g));
            this.l.classList.add("shaka-video-container");
            this.u.classList.add("shaka-video");
            mI(this);
            this.g.addBigPlayButton && nI(this);
            this.g.customContextMenu && (this.X = new UG(this.G, this), this.I.push(this.X));
            this.L || oI(this);
            this.g.seekOnTaps && (pI(this), qI(this));
            this.Fa = V("div");
            this.Fa.classList.add("shaka-server-side-ad-container");
            this.i.appendChild(this.Fa);
            rI(this);
            this.J = Array.from(this.l.getElementsByClassName("shaka-settings-menu"));
            this.J.push.apply(this.J, x(Array.from(this.l.getElementsByClassName("shaka-overflow-menu"))));
            this.fb = Array.from(this.l.getElementsByClassName("shaka-show-controls-on-mouse-over"));
            YH(this);
            a = u(this.l.getElementsByClassName("shaka-no-propagation"));
            for(var c = a.next(); !c.done; c = a.next()){
                c = c.value;
                var d = function(e) {
                    return e.stopPropagation();
                };
                this.h.o(c, "click", d);
                this.h.o(c, "dblclick", d);
                navigator.maxTouchPoints > 0 && this.h.o(c, "touchend", function(e) {
                    b.Ca() && e.stopPropagation();
                });
            }
        };
        p.di = function(a) {
            (this.Y = a) ? (this.l.setAttribute("shaka-controls", "true"), this.u.tabIndex = -1, this.u.controls = !1) : this.l.removeAttribute("shaka-controls");
            YH(this);
        };
        p.Lj = function(a) {
            this.u.controls = a;
            this.u.tabIndex = a ? 0 : -1;
            a && this.di(!1);
        };
        p.getAd = function() {
            return this.j;
        };
        p.Dk = function() {
            return this.F;
        };
        p.Vk = function() {
            return this.sa;
        };
        p.yl = function() {
            return this.l;
        };
        p.Vc = function() {
            return this.C;
        };
        p.Uk = function() {
            return this.u;
        };
        p.Wb = function() {
            return this.m;
        };
        p.Tk = function() {
            return this.aa;
        };
        p.Kk = function() {
            return this.i;
        };
        p.jl = function() {
            return this.Fa;
        };
        p.Gk = function() {
            return this.H;
        };
        p.Hk = function() {
            return this.g;
        };
        p.Jl = function() {
            return this.S;
        };
        p.ii = function(a) {
            (this.S = a) ? this.K.stop() : this.K.$(3);
        };
        p.Dl = function() {
            return this.ra;
        };
        p.ph = function() {
            return this.A ? this.A.getValue() : this.C.currentTime;
        };
        p.Mj = function(a) {
            this.P = a;
        };
        p.Lc = function() {
            return this.J.some(function(a) {
                return !a.classList.contains("shaka-hidden");
            });
        };
        p.Wc = function() {
            this.O.La();
        };
        function sI(a) {
            return !document.fullscreenEnabled || a.u.webkitSupportsFullscreen && a.g.preferVideoFullScreenInVisionOS && Rb().Ka() == "APPLE_VR" ? !1 : !0;
        }
        function tI(a) {
            return "documentPictureInPicture" in window1 && a.g.preferDocumentPictureInPicture;
        }
        p.ve = function() {
            return this.F.Qa() ? !1 : sI(this) || (!this.j || !this.j.isUsingAnotherMediaElement()) && this.u.webkitSupportsFullscreen ? !0 : !1;
        };
        p.xb = function() {
            if (sI(this)) return !!document.fullscreenElement;
            var a = this.u;
            return a.webkitSupportsFullscreen ? a.webkitDisplayingFullscreen : !1;
        };
        function uI(a) {
            var b, c, d;
            return Q(function(e) {
                switch(e.g){
                    case 1:
                        ra(e, 2);
                        if (!sI(a)) {
                            b = a.u;
                            b.webkitSupportsFullscreen && b.webkitEnterFullscreen();
                            e.B(4);
                            break;
                        }
                        if (!a.Md()) {
                            e.B(5);
                            break;
                        }
                        return F(e, a.cd(), 6);
                    case 6:
                        if (!tI(a)) {
                            e.B(5);
                            break;
                        }
                        return F(e, new Promise(function(f) {
                            new Bf(f).$(.05);
                        }), 5);
                    case 5:
                        return c = a.g.fullScreenElement, F(e, c.requestFullscreen({
                            navigationUI: "hide"
                        }), 9);
                    case 9:
                        if (!a.g.forceLandscapeOnFullscreen || !screen.orientation) {
                            e.B(4);
                            break;
                        }
                        ra(e, 11);
                        return F(e, screen.orientation.lock("landscape"), 13);
                    case 13:
                        ta(e, 4, 2);
                        break;
                    case 11:
                        ua(e, 2);
                    case 4:
                        ta(e, 0);
                        break;
                    case 2:
                        d = ua(e), a.dispatchEvent(new T("error", (new Map).set("detail", d))), H(e);
                }
            });
        }
        function fI(a) {
            var b;
            return Q(function(c) {
                if (!sI(a)) return b = a.u, b.webkitSupportsFullscreen && b.webkitExitFullscreen(), c.B(0);
                screen.orientation && screen.orientation.unlock();
                return F(c, document.exitFullscreen(), 0);
            });
        }
        p.og = function() {
            var a = this;
            return Q(function(b) {
                return a.xb() ? F(b, fI(a), 0) : F(b, uI(a), 0);
            });
        };
        p.Ef = function() {
            return this.F.Qa() ? !1 : document.pictureInPictureEnabled || tI(this) ? !this.u.disablePictureInPicture : !1;
        };
        p.Md = function() {
            return !!(window1.documentPictureInPicture && window1.documentPictureInPicture.window || document.pictureInPictureElement);
        };
        p.cd = function() {
            var a = this, b, c;
            return Q(function(d) {
                switch(d.g){
                    case 1:
                        ra(d, 2);
                        if (tI(a)) {
                            if (!a.xb()) {
                                d.B(10);
                                break;
                            }
                            return F(d, fI(a), 10);
                        }
                        return document.pictureInPictureElement ? F(d, document.exitPictureInPicture(), 5) : (a.xb() && fI(a), b = a.u, F(d, b.requestPictureInPicture(), 5));
                    case 10:
                        return F(d, vI(a), 5);
                    case 5:
                        ta(d, 0);
                        break;
                    case 2:
                        c = ua(d), a.dispatchEvent(new T("error", (new Map).set("detail", c))), H(d);
                }
            });
        };
        function vI(a) {
            var b, c, d, e, f, g;
            return Q(function(h) {
                if (h.g == 1) {
                    if (window1.documentPictureInPicture.window) return window1.documentPictureInPicture.window.close(), h.return();
                    b = a.l;
                    c = b.getBoundingClientRect();
                    return F(h, window1.documentPictureInPicture.requestWindow({
                        width: c.width,
                        height: c.height
                    }), 2);
                }
                d = h.h;
                wI(d);
                e = b.parentNode || document.body;
                f = a.l.cloneNode(!0);
                f.style.visibility = "hidden";
                f.style.height = getComputedStyle(b).height;
                e.appendChild(f);
                g = document.createElement("style");
                g.append("[data-shaka-player-container] {\n      width: 100% !important; max-height: 100%}");
                d.document.head.append(g);
                d.document.body.append(b);
                a.h.ua(d, "pagehide", function() {
                    f.replaceWith(b);
                });
                H(h);
            });
        }
        function wI(a) {
            var b = [].concat(x(document.styleSheets)).map(function(d) {
                try {
                    return [].concat(x(d.cssRules)).map(function(f) {
                        return f.cssText;
                    }).join("");
                } catch (f) {
                    var e = document.createElement("link");
                    e.rel = "stylesheet";
                    e.type = d.type;
                    e.media = d.media;
                    e.href = d.href;
                    a.document.head.appendChild(e);
                }
                return "";
            }).filter(Boolean).join("\n"), c = document.createElement("style");
            c.textContent = b;
            a.document.head.appendChild(c);
        }
        p.Rj = function() {
            RG(this.R, !0);
            RG(this.H, !0);
            this.j.hasCustomClick() ? this.i.setAttribute("ad-active", "true") : this.i.removeAttribute("ad-active");
        };
        p.aj = function() {
            RG(this.R, !1);
            RG(this.H, !1);
            this.i.removeAttribute("ad-active");
        };
        function $G(a) {
            if (a.Y) {
                if (a.j && (a.j && a.j.isPaused() ? a.j.play() : a.j && a.j.pause(), a.j.isLinear())) return;
                a.C.duration && (a.C.paused && !a.S ? (a.m.isEnded() && (a.C.currentTime = a.m.za().start), a.C.play()) : a.C.pause());
            }
        }
        function kI(a) {
            a.i = V("div");
            a.i.classList.add("shaka-controls-container");
            a.l.appendChild(a.i);
            a.l.setAttribute("shaka-controls", "true");
            a.h.o(a.i, "touchend", function(b) {
                a.C.duration && (a.Ca() ? (a.P = Date.now(), cH(a, !0)) : xI(a, b), b.cancelable && b.preventDefault());
            });
            a.h.o(a.i, "click", function() {
                cH(a);
            });
            a.h.o(a.i, "dblclick", function() {
                a.g.doubleClickForFullscreen && a.ve() && a.og();
            });
        }
        function nI(a) {
            var b = V("div");
            b.classList.add("shaka-play-button-container");
            a.i.appendChild(b);
            a.Ma = new aH(b, a);
            a.I.push(a.Ma);
        }
        function mI(a) {
            var b = V("div");
            b.classList.add("shaka-scrim-container");
            a.i.appendChild(b);
        }
        function yI(a) {
            a.R = V("div");
            a.R.classList.add("shaka-ad-controls");
            var b = a.j != null && a.j.isLinear();
            RG(a.R, b);
            a.M.appendChild(a.R);
            b = new sH(a.R, a);
            a.I.push(b);
        }
        function oI(a) {
            a.L = V("div");
            a.L.classList.add("shaka-spinner-container");
            a.l.appendChild(a.L);
            var b = V("div");
            b.classList.add("shaka-spinner");
            a.L.appendChild(b);
            b.insertAdjacentHTML("beforeend", '<svg focusable="false" stroke="currentColor"\n         viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg"\n         width="50px" height="50px" class="q-spinner text-grey-9">\n      <g transform="translate(1 1)" stroke-width="6" fill="none"\n        fill-rule="evenodd">\n        <circle stroke-opacity=".5" cx="18" cy="18" r="16"></circle>\n        <path d="M34 18c0-9.94-8.06-16-16-16">\n          <animateTransform attributeName="transform" type="rotate"\n            from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite">\n          </animateTransform>\n        </path>\n      </g>\n    </svg>');
        }
        function pI(a) {
            var b = V("div");
            b.classList.add("shaka-hidden-fast-forward-container");
            a.i.appendChild(b);
            a.ib = new dH(b, a);
            a.I.push(a.ib);
        }
        function qI(a) {
            var b = V("div");
            b.classList.add("shaka-hidden-rewind-container");
            a.i.appendChild(b);
            a.jb = new eH(b, a);
            a.I.push(a.jb);
        }
        function rI(a) {
            a.M = V("div");
            a.M.classList.add("shaka-bottom-controls");
            a.M.classList.add("shaka-no-propagation");
            a.i.appendChild(a.M);
            a.h.o(a.M, "click", function(e) {
                e.target.closest(".shaka-overflow-button") || a.Wc();
            });
            yI(a);
            zI(a);
            a.G = V("div");
            a.G.classList.add("shaka-controls-button-panel");
            a.G.classList.add("shaka-show-controls-on-mouse-over");
            a.g.enableTooltips && a.G.classList.add("shaka-tooltips-on");
            a.M.appendChild(a.G);
            for(var b = u(a.g.controlPanelElements), c = b.next(); !c.done; c = b.next())if (c = c.value, jI.get(c)) {
                var d = jI.get(c).create(a.G, a);
                a.I.push(d);
                c == "time_and_duration" && (c = new TG(a.G, a), a.I.push(c));
            } else ab("Unrecognized control panel element requested:", c);
        }
        function zI(a) {
            if (a.g.addSeekBar) a.A = AI.create(a.M, a), a.I.push(a.A);
            else {
                for(var b = u(a.J), c = b.next(); !c.done; c = b.next())c.value.classList.add("shaka-low-position");
                a = a.G;
                a.classList.contains("shaka-tooltips-on") && a.classList.add("shaka-tooltips-low-position");
            }
        }
        function lI(a) {
            a.H = V("div");
            a.H.classList.add("shaka-client-side-ad-container");
            RG(a.H, !1);
            a.h.o(a.H, "click", function() {
                cH(a);
            });
            a.l.appendChild(a.H);
        }
        function cI(a) {
            a.h.o(a.m, "buffering", function() {
                BI(a);
            });
            BI(a);
            a.h.o(window1, "keydown", function(b) {
                CI(a, b);
            });
            a.h.o(window1, "click", function() {
                return a.Wc();
            });
            a.h.o(a, "submenuopen", function() {
                a.Wc();
            });
            a.h.o(a.C, "play", function() {
                YH(a);
            });
            a.h.o(a.C, "pause", function() {
                YH(a);
            });
            a.h.o(a.l, "mousemove", function(b) {
                xI(a, b);
            });
            a.h.o(a.l, "touchmove", function(b) {
                xI(a, b);
            }, {
                passive: !0
            });
            a.h.o(a.l, "touchend", function(b) {
                xI(a, b);
            }, {
                passive: !0
            });
            a.h.o(a.l, "mouseleave", function() {
                a.P || a.K.La();
            });
            a.h.o(a.l, "wheel", function(b) {
                xI(a, b);
            }, {
                passive: !0
            });
            a.h.o(a.F, "caststatuschanged", function() {
                eI(a);
            });
            a.h.o(a.D, "vrstatuschanged", function() {
                a.dispatchEvent(new T("vrstatuschanged"));
            });
            a.h.o(a.l, "keydown", function(b) {
                a.g.enableKeyboardPlaybackControlsInWindow || a.xb() || DI(a, b);
            });
            a.h.o(a.l, "keyup", function(b) {
                a.g.enableKeyboardPlaybackControlsInWindow || a.xb() || a.V.delete(b.key);
            });
            a.h.o(window1, "keydown", function(b) {
                (a.g.enableKeyboardPlaybackControlsInWindow || a.xb()) && DI(a, b);
            });
            a.h.o(window1, "keyup", function(b) {
                (a.g.enableKeyboardPlaybackControlsInWindow || a.xb()) && a.V.delete(b.key);
            });
            a.h.o(a.oa, "ad-started", function(b) {
                a.j = b.ad;
                a.Rj();
                BI(a);
            });
            a.h.o(a.oa, "ad-stopped", function() {
                a.j = null;
                a.aj();
                BI(a);
            });
            screen.orientation && a.h.o(screen.orientation, "change", function() {
                return Q(function(b) {
                    return F(b, EI(a), 0);
                });
            });
        }
        function dI(a) {
            if (a.g.setupMediaSession && navigator.mediaSession) {
                var b = function(f, g) {
                    try {
                        navigator.mediaSession.setActionHandler(f, function(h) {
                            g(h);
                        });
                    } catch (h) {}
                }, c = function() {
                    if (a.j && a.j.isLinear()) d();
                    else {
                        var f = a.m.za(), g = f.end - f.start;
                        f = parseFloat((a.C.currentTime - f.start).toFixed(2));
                        a.m.U() && Math.abs(g - f) < 1 && (g = Infinity);
                        try {
                            navigator.mediaSession.setPositionState({
                                duration: Math.max(0, g),
                                playbackRate: a.C.playbackRate,
                                position: Math.max(0, f)
                            });
                        } catch (h) {}
                    }
                }, d = function() {
                    try {
                        navigator.mediaSession.setPositionState();
                    } catch (f) {}
                }, e = function(f) {
                    var g = a.g.keyboardSeekDistance;
                    switch(f.action){
                        case "pause":
                            $G(a);
                            break;
                        case "play":
                            $G(a);
                            break;
                        case "seekbackward":
                            if (f.seekOffset && !isFinite(f.seekOffset)) break;
                            a.j && a.j.isLinear() || FI(a, a.A.getValue() - (f.seekOffset || g));
                            break;
                        case "seekforward":
                            if (f.seekOffset && !isFinite(f.seekOffset)) break;
                            a.j && a.j.isLinear() || FI(a, a.A.getValue() + (f.seekOffset || g));
                            break;
                        case "seekto":
                            if (f.seekTime && !isFinite(f.seekTime)) break;
                            a.j && a.j.isLinear() || FI(a, a.m.za().start + f.seekTime);
                            break;
                        case "stop":
                            a.m.tc();
                            break;
                        case "enterpictureinpicture":
                            a.j && a.j.isLinear() || a.cd();
                    }
                };
                b("pause", e);
                b("play", e);
                b("seekbackward", e);
                b("seekforward", e);
                b("seekto", e);
                b("stop", e);
                ("documentPictureInPicture" in window1 || document.pictureInPictureEnabled) && b("enterpictureinpicture", e);
                b = function() {
                    a.m.U() || a.m.za().start != 0 ? (c(), a.h.o(a.C, "timeupdate", c)) : d();
                };
                a.m.aa && b();
                a.h.o(a.m, "loaded", b);
                a.h.o(a.m, "unloading", function() {
                    a.h.Ea(a.C, "timeupdate", c);
                });
                a.h.o(a.m, "metadata", function(f) {
                    if (f = f.payload) {
                        var g;
                        f.key == "TIT2" && f.data && (g = f.data);
                        var h;
                        f.key == "APIC" && f.mimeType == "--\x3e" && (h = f.data);
                        g && (f = {
                            title: g,
                            artwork: []
                        }, navigator.mediaSession.metadata && (f = navigator.mediaSession.metadata, f.title = g), navigator.mediaSession.metadata = new MediaMetadata(f));
                        h && (g = a.u, h != g.poster && (g.poster = h), g = {
                            title: "",
                            artwork: [
                                {
                                    src: h
                                }
                            ]
                        }, navigator.mediaSession.metadata && (g = navigator.mediaSession.metadata, g.artwork = [
                            {
                                src: h
                            }
                        ]), navigator.mediaSession.metadata = new MediaMetadata(g));
                    }
                });
            }
        }
        function hI(a) {
            if (a.g.setupMediaSession && navigator.mediaSession) {
                try {
                    navigator.mediaSession.setPositionState();
                } catch (b) {}
                a = function(b) {
                    try {
                        navigator.mediaSession.setActionHandler(b, null);
                    } catch (c) {}
                };
                a("pause");
                a("play");
                a("seekbackward");
                a("seekforward");
                a("seekto");
                a("stop");
                a("enterpictureinpicture");
            }
        }
        function EI(a) {
            return Q(function(b) {
                return a.C && a.C.readyState != 0 && !a.F.Qa() && a.g.enableFullscreenOnRotation && a.ve() ? screen.orientation.type.includes("landscape") && !a.xb() ? F(b, uI(a), 0) : screen.orientation.type.includes("portrait") && a.xb() ? F(b, fI(a), 0) : b.B(0) : b.return();
            });
        }
        function xI(a, b) {
            b.type == "mousemove" && (a.i.classList.remove("shaka-keyboard-navigation"), YH(a));
            b.type == "touchstart" || b.type == "touchmove" || b.type == "touchend" || b.type == "keyup" ? a.P = Date.now() : a.P + 1E3 < Date.now() && (a.P = null);
            a.P && b.type == "mousemove" || (a.l.classList.remove("no-cursor"), a.Oa = !0, a.O.stop(), a.Ca() || (aI(a), YH(a)), a.K.stop(), b.type != "touchend" && b.type != "wheel" && b.type != "keyup" && a.P || a.K.$(3));
        }
        function GI(a) {
            return window1.matchMedia("hover: hover").matches ? a.fb.some(function(b) {
                return b.matches(":hover");
            }) : !1;
        }
        function $H(a) {
            var b = a.l.getElementsByClassName("shaka-text-container")[0];
            b && (a.Ca() ? b.style.bottom = a.M.clientHeight + "px" : b.style.bottom = "0px");
        }
        function YH(a) {
            var b = a.j ? a.j.isPaused() : !1, c = a.C.paused && !a.S, d = a.i.classList.contains("shaka-keyboard-navigation");
            b || (!a.j || !a.j.isLinear()) && c || a.Oa || d || GI(a) ? (aI(a), a.i.getAttribute("shown") == null && (a.i.setAttribute("shown", "true"), ZH(a)), $H(a), a.ea.stop()) : a.ea.$(a.g.fadeDelay);
            a.Lc() && a.G.classList.remove("shaka-tooltips-on");
        }
        function cH(a, b) {
            b = b === void 0 ? !1 : b;
            a.Y && !a.Xb() && (a.Lc() ? a.O.La() : a.g.singleClickForPlayAndPause ? $G(a) : b && a.Ca() && a.bj());
        }
        function eI(a) {
            var b = a.F.Qa();
            a.dispatchEvent(new T("caststatuschanged", (new Map).set("newStatus", b)));
            b ? a.i.getAttribute("casting") == null && (a.i.setAttribute("casting", "true"), ZH(a)) : a.i.getAttribute("casting") != null && (a.i.removeAttribute("casting"), ZH(a));
        }
        function DI(a, b) {
            var c = document.activeElement, d = c && c.classList ? c.classList.contains("shaka-volume-bar") : !1, e = c && c.classList && c.classList.contains("shaka-seek-bar"), f = a.xb();
            c = a.i.contains(c);
            f = f || a.g.enableKeyboardPlaybackControlsInWindow;
            c && xI(a, b);
            if (a.g.enableKeyboardPlaybackControls && a.m.hd()) {
                var g = a.g.keyboardSeekDistance, h = a.g.keyboardLargeSeekDistance;
                switch(b.key){
                    case "ArrowLeft":
                        a.A && g > 0 && (e || f) && !d && (b.preventDefault(), FI(a, a.A.getValue() - g));
                        break;
                    case "ArrowRight":
                        a.A && g > 0 && (e || f) && !d && (b.preventDefault(), FI(a, a.A.getValue() + g));
                        break;
                    case "PageDown":
                        a.A && h > 0 && (e || f) && (b.preventDefault(), FI(a, a.A.getValue() - h));
                        break;
                    case "PageUp":
                        a.A && h > 0 && (e || f) && (b.preventDefault(), FI(a, a.A.getValue() + h));
                        break;
                    case "Home":
                        a.A && FI(a, a.m.za().start);
                        break;
                    case "End":
                        a.A && FI(a, a.m.za().end);
                        break;
                    case "c":
                        a.m.Zd(!a.m.Xc());
                        break;
                    case "f":
                        a.ve() && a.og();
                        break;
                    case "m":
                        a.j && a.j.isLinear() ? a.j.setMuted(!a.j.isMuted()) : a.u.muted = !a.u.muted;
                        break;
                    case "p":
                        a.Ef() && a.cd();
                        break;
                    case ">":
                        b = a.g.playbackRates.indexOf(a.m.Za());
                        b > -1 && b + 1 < a.g.playbackRates.length && a.m.sc(a.g.playbackRates[b + 1], !1);
                        break;
                    case "<":
                        b = a.g.playbackRates.indexOf(a.m.Za());
                        b > -1 && b - 1 >= 0 && a.m.sc(a.g.playbackRates[b - 1], !1);
                        break;
                    case " ":
                        (e || f && !c) && $G(a);
                }
            }
        }
        function BI(a) {
            a.Y && (a.j && a.j.isClientRendering() && a.j.isLinear() ? RG(a.L, !1) : RG(a.L, a.m.Cf()));
        }
        p.Ca = function() {
            return this.Y ? this.i.getAttribute("shown") != null || this.i.getAttribute("casting") != null : !1;
        };
        function ZH(a) {
            a.Ca() ? a.dispatchEvent(new T("showingui")) : a.dispatchEvent(new T("hidingui"));
        }
        function FI(a, b) {
            a.C.currentTime = b;
            aI(a);
        }
        function aI(a) {
            if (a.A) {
                if (a.A.setValue(a.C.currentTime), a.A.update(), a.A.isShowing()) {
                    for(var b = u(a.J), c = b.next(); !c.done; c = b.next())c.value.classList.remove("shaka-low-position");
                    b = a.G;
                    b.classList.contains("shaka-tooltips-on") && b.classList.remove("shaka-tooltips-low-position");
                } else {
                    b = u(a.J);
                    for(c = b.next(); !c.done; c = b.next())c.value.classList.add("shaka-low-position");
                    b = a.G;
                    b.classList.contains("shaka-tooltips-on") && b.classList.add("shaka-tooltips-low-position");
                }
            }
            a.dispatchEvent(new T("timeandseekrangeupdated"));
        }
        function CI(a, b) {
            a.V.add(b.key);
            var c = a.Lc();
            b.key == "Tab" && (a.i.classList.add("shaka-keyboard-navigation"), YH(a), a.h.o(window1, "mousedown", function() {
                a.h.Ea(window1, "mousedown");
            }));
            b.key == "Escape" && a.O.La();
            c && a.V.has("Tab") && HI(a, b);
        }
        function HI(a, b) {
            var c = a.J.filter(function(f) {
                return !f.classList.contains("shaka-hidden");
            });
            if (c.length) {
                var d = c[0];
                if (d.childNodes.length) {
                    for(c = d.firstElementChild; c && c.classList.contains("shaka-hidden");)c = c.nextElementSibling;
                    for(d = d.lastElementChild; d && d.classList.contains("shaka-hidden");)d = d.previousElementSibling;
                    var e = document.activeElement;
                    a.V.has("Shift") ? e == c && (b.preventDefault(), d.focus()) : e == d && (b.preventDefault(), c.focus());
                }
            }
        }
        p.zm = function() {
            var a = new Event("mousemove", {
                bubbles: !1,
                cancelable: !1
            });
            xI(this, a);
        };
        p.bj = function() {
            this.K.La();
        };
        p.Lg = function() {
            return this.D.Lg();
        };
        p.Xb = function() {
            return this.D.Xb();
        };
        p.wl = function() {
            var a = this.D;
            if (a.g) {
                a = a.g;
                zH(a.h, a.F);
                var b = a.h;
                a = b[0];
                var c = b[1], d = b[2];
                b = b[3];
                var e = d * d, f = b * b;
                var g = a * a + c * c + e + f;
                var h = a * b - c * d;
                h > .499995 * g ? (g = Math.PI / 2, a = 2 * Math.atan2(c, a)) : h < -0.499995 * g ? (g = -Math.PI / 2, a = 2 * Math.atan2(c, a)) : (g = Math.asin(2 * (a * d - b * c)), a = Math.atan2(2 * (a * b + c * d), 1 - 2 * (e + f)));
                a = Math.acos(Math.cos(a) * Math.cos(g)) * 180 / Math.PI;
            } else ab("Not playing VR content"), a = null;
            return a;
        };
        p.vl = function() {
            var a = this.D;
            a.g ? a = a.g.j : (ab("Not playing VR content"), a = null);
            return a;
        };
        p.xm = function(a) {
            var b = this.D;
            b.g ? (a < 0 ? (ab("Field of view should be greater than 0"), a = 0) : a > 100 && (ab("Field of view should be less than 100"), a = 100), b = b.g, b.j = a, GH(b, !1)) : ab("Not playing VR content");
        };
        p.$d = function() {
            this.D.$d();
        };
        p.Bh = function(a) {
            this.D.Bh(a);
        };
        p.yh = function(a) {
            this.D.yh(a);
        };
        p.Ah = function(a) {
            this.D.Ah(a);
        };
        function bI() {
            var a = new Hc("en");
            a.Xa("ar", new Map([
                [
                    "AD_DURATION",
                    "\u0645\u062f\u0629 \u0627\u0644\u0625\u0639\u0644\u0627\u0646"
                ],
                [
                    "AD_PROGRESS",
                    "\u0627\u0644\u0625\u0639\u0644\u0627\u0646 [AD_ON] \u0645\u0646 [NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "\u0625\u062d\u0635\u0627\u0621\u0627\u062a \u0627\u0644\u0625\u0639\u0644\u0627\u0646\u0627\u062a"
                ],
                [
                    "AD_TIME",
                    "\u0627\u0644\u0625\u0639\u0644\u0627\u0646: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "\u062a\u0644\u0642\u0627\u0626\u064a"
                ],
                [
                    "BACK",
                    "\u0631\u062c\u0648\u0639"
                ],
                [
                    "CAPTIONS",
                    "\u0627\u0644\u062a\u0631\u062c\u0645\u0629 \u0648\u0627\u0644\u0634\u0631\u062d"
                ],
                [
                    "CAST",
                    "\u0625\u0631\u0633\u0627\u0644..."
                ],
                [
                    "CHAPTERS",
                    "\u0627\u0644\u0641\u0635\u0648\u0644"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "\u062d\u0641\u0638 \u0625\u0637\u0627\u0631 \u0627\u0644\u0641\u064a\u062f\u064a\u0648"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "\u062a\u0643\u0631\u0627\u0631 \u0627\u0644\u0641\u064a\u062f\u064a\u0648 \u0627\u0644\u062d\u0627\u0644\u064a"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    '\u0627\u0644\u062f\u062e\u0648\u0644 \u0641\u064a \u0648\u0636\u0639 "\u0646\u0627\u0641\u0630\u0629 \u0636\u0645\u0646 \u0646\u0627\u0641\u0630\u0629"'
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "\u0625\u0646\u0647\u0627\u0621 \u0648\u0636\u0639 \u0645\u0644\u0621 \u0627\u0644\u0634\u0627\u0634\u0629"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "\u0625\u064a\u0642\u0627\u0641 \u062a\u0643\u0631\u0627\u0631 \u0627\u0644\u0641\u064a\u062f\u064a\u0648 \u0627\u0644\u062d\u0627\u0644\u064a"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    '\u0627\u0644\u062e\u0631\u0648\u062c \u0645\u0646 \u0648\u0636\u0639 "\u0646\u0627\u0641\u0630\u0629 \u0636\u0645\u0646 \u0646\u0627\u0641\u0630\u0629"'
                ],
                [
                    "FAST_FORWARD",
                    "\u062a\u0642\u062f\u064a\u0645 \u0633\u0631\u064a\u0639"
                ],
                [
                    "FULL_SCREEN",
                    "\u0645\u0644\u0621 \u0627\u0644\u0634\u0627\u0634\u0629"
                ],
                [
                    "LANGUAGE",
                    "\u0627\u0644\u0644\u063a\u0629"
                ],
                [
                    "LIVE",
                    "\u0645\u0628\u0627\u0634\u0631"
                ],
                [
                    "LOOP",
                    "\u062a\u0643\u0631\u0627\u0631"
                ],
                [
                    "MORE_SETTINGS",
                    "\u0645\u0632\u064a\u062f \u0645\u0646 \u0627\u0644\u0625\u0639\u062f\u0627\u062f\u0627\u062a"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "\u0644\u063a\u0627\u062a \u0645\u062a\u0639\u062f\u062f\u0629"
                ],
                [
                    "MUTE",
                    "\u0643\u062a\u0645 \u0627\u0644\u0635\u0648\u062a"
                ],
                [
                    "NOT_APPLICABLE",
                    "\u063a\u064a\u0631 \u0633\u0627\u0631\u064d"
                ],
                [
                    "OFF",
                    "\u0625\u064a\u0642\u0627\u0641"
                ],
                [
                    "ON",
                    "\u062a\u0634\u063a\u064a\u0644"
                ],
                [
                    "PAUSE",
                    "\u0625\u064a\u0642\u0627\u0641 \u0645\u0624\u0642\u062a"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "\u0646\u0627\u0641\u0630\u0629 \u0636\u0645\u0646 \u0627\u0644\u0646\u0627\u0641\u0630\u0629"
                ],
                [
                    "PLAY",
                    "\u0627\u0644\u062a\u0634\u063a\u064a\u0644"
                ],
                [
                    "PLAYBACK_RATE",
                    "\u0633\u0631\u0639\u0629 \u0627\u0644\u062a\u0634\u063a\u064a\u0644"
                ],
                [
                    "QUALITY",
                    "\u0627\u0644\u062c\u0648\u062f\u0629"
                ],
                [
                    "RECENTER_VR",
                    "\u0625\u0639\u0627\u062f\u0629 \u0627\u0644\u062a\u0648\u0633\u064a\u0637"
                ],
                [
                    "REPLAY",
                    "\u0625\u0639\u0627\u062f\u0629 \u0627\u0644\u062a\u0634\u063a\u064a\u0644"
                ],
                [
                    "RESOLUTION",
                    "\u062f\u0631\u062c\u0629 \u0627\u0644\u062f\u0642\u0629"
                ],
                [
                    "REWIND",
                    "\u062a\u0631\u062c\u064a\u0639"
                ],
                [
                    "SEEK",
                    "\u0627\u0644\u0628\u062d\u062b \u0628\u0627\u0644\u062a\u0645\u0631\u064a\u0631"
                ],
                [
                    "SKIP_AD",
                    "\u062a\u062e\u0637\u0651\u064a \u0627\u0644\u0625\u0639\u0644\u0627\u0646"
                ],
                [
                    "SKIP_TO_LIVE",
                    "\u0627\u0644\u0627\u0646\u062a\u0642\u0627\u0644 \u0625\u0644\u0649 \u0628\u062b \u0645\u0628\u0627\u0634\u0631"
                ],
                [
                    "STATISTICS",
                    "\u0627\u0644\u0625\u062d\u0635\u0627\u0621\u0627\u062a"
                ],
                [
                    "SUBTITLE_FORCED",
                    "\u0639\u0631\u0636 \u0625\u062c\u0628\u0627\u0631\u064a"
                ],
                [
                    "SURROUND",
                    "\u0635\u0648\u062a \u0645\u062d\u064a\u0637\u064a"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "\u0625\u064a\u0642\u0627\u0641 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u062c\u0633\u0651\u0645 \u0623\u0648 \u062a\u0641\u0639\u064a\u0644\u0647"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "\u063a\u064a\u0631 \u0645\u062d\u062f\u062f"
                ],
                [
                    "UNMUTE",
                    "\u0625\u0639\u0627\u062f\u0629 \u0627\u0644\u0635\u0648\u062a"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "\u063a\u064a\u0631 \u0645\u0639\u0631\u0648\u0641"
                ],
                [
                    "VOLUME",
                    "\u0645\u0633\u062a\u0648\u0649 \u0627\u0644\u0635\u0648\u062a"
                ]
            ]));
            a.Xa("de", new Map([
                [
                    "AD_DURATION",
                    "Dauer der Werbeanzeige"
                ],
                [
                    "AD_PROGRESS",
                    "Werbung\u00a0[AD_ON] von\u00a0[NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "Anzeigenstatistiken"
                ],
                [
                    "AD_TIME",
                    "Werbeanzeige: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "Automatisch"
                ],
                [
                    "BACK",
                    "Zur\u00fcck"
                ],
                [
                    "CAPTIONS",
                    "Untertitel"
                ],
                [
                    "CAST",
                    "Streamen..."
                ],
                [
                    "CHAPTERS",
                    "Kapitel"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "Videoframe speichern"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "In Endlosschleife spielen"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "Bild im Bild aktivieren"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "Vollbildmodus beenden"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "Endlosschleife stoppen"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "Bild im Bild beenden"
                ],
                [
                    "FAST_FORWARD",
                    "Vorspulen"
                ],
                [
                    "FULL_SCREEN",
                    "Vollbildmodus"
                ],
                [
                    "LANGUAGE",
                    "Sprache"
                ],
                [
                    "LIVE",
                    "Live"
                ],
                [
                    "LOOP",
                    "Schleife"
                ],
                [
                    "MORE_SETTINGS",
                    "Weitere Einstellungen"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "Mehrere Sprachen"
                ],
                [
                    "MUTE",
                    "Stummschalten"
                ],
                [
                    "NOT_APPLICABLE",
                    "Nicht zutreffend"
                ],
                [
                    "OFF",
                    "Aus"
                ],
                [
                    "ON",
                    "Ein"
                ],
                [
                    "PAUSE",
                    "Pause"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "Bild im Bild"
                ],
                [
                    "PLAY",
                    "Wiedergabe"
                ],
                [
                    "PLAYBACK_RATE",
                    "Geschwindigkeit"
                ],
                [
                    "QUALITY",
                    "Qualit\u00e4t"
                ],
                [
                    "RECENTER_VR",
                    "Zentrieren"
                ],
                [
                    "REPLAY",
                    "Noch einmal wiedergeben"
                ],
                [
                    "RESOLUTION",
                    "Aufl\u00f6sung"
                ],
                [
                    "REWIND",
                    "Zur\u00fcckspulen"
                ],
                [
                    "SEEK",
                    "Suche"
                ],
                [
                    "SKIP_AD",
                    "\u00dcberspringen"
                ],
                [
                    "SKIP_TO_LIVE",
                    "Zum Live-Videostream wechseln"
                ],
                [
                    "STATISTICS",
                    "Statistiken"
                ],
                [
                    "SUBTITLE_FORCED",
                    "Erzwungen"
                ],
                [
                    "SURROUND",
                    "Surround"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "Einstellung \u201estereoskopisch\u201c ein\u2011/ausschalten"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "Unbestimmt"
                ],
                [
                    "UNMUTE",
                    "Stummschaltung aufheben"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "Unbekannt"
                ],
                [
                    "VOLUME",
                    "Lautst\u00e4rke"
                ]
            ]));
            a.Xa("en", new Map([
                [
                    "AD_DURATION",
                    "Ad duration"
                ],
                [
                    "AD_PROGRESS",
                    "Ad [AD_ON] of [NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "Ad statistics"
                ],
                [
                    "AD_TIME",
                    "Ad: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "Auto"
                ],
                [
                    "BACK",
                    "Back"
                ],
                [
                    "CAPTIONS",
                    "Captions"
                ],
                [
                    "CAST",
                    "Cast..."
                ],
                [
                    "CHAPTERS",
                    "Chapters"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "Save video frame"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "Loop the current video"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "Enter Picture-in-Picture"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "Exit full screen"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "Stop looping the current video"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "Exit Picture-in-Picture"
                ],
                [
                    "FAST_FORWARD",
                    "Fast-forward"
                ],
                [
                    "FULL_SCREEN",
                    "Full screen"
                ],
                [
                    "LANGUAGE",
                    "Language"
                ],
                [
                    "LIVE",
                    "Live"
                ],
                [
                    "LOOP",
                    "Loop"
                ],
                [
                    "MORE_SETTINGS",
                    "More settings"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "Multiple languages"
                ],
                [
                    "MUTE",
                    "Mute"
                ],
                [
                    "NOT_APPLICABLE",
                    "Not applicable"
                ],
                [
                    "OFF",
                    "Off"
                ],
                [
                    "ON",
                    "On"
                ],
                [
                    "PAUSE",
                    "Pause"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "Picture-in-Picture"
                ],
                [
                    "PLAY",
                    "Play"
                ],
                [
                    "PLAYBACK_RATE",
                    "Playback speed"
                ],
                [
                    "QUALITY",
                    "Quality"
                ],
                [
                    "RECENTER_VR",
                    "Recenter"
                ],
                [
                    "REPLAY",
                    "Replay"
                ],
                [
                    "RESOLUTION",
                    "Resolution"
                ],
                [
                    "REWIND",
                    "Rewind"
                ],
                [
                    "SEEK",
                    "Seek"
                ],
                [
                    "SKIP_AD",
                    "Skip Ad"
                ],
                [
                    "SKIP_NEXT",
                    "Next"
                ],
                [
                    "SKIP_PREVIOUS",
                    "Previous"
                ],
                [
                    "SKIP_TO_LIVE",
                    "Skip ahead to live"
                ],
                [
                    "STATISTICS",
                    "Statistics"
                ],
                [
                    "SUBTITLE_FORCED",
                    "Forced"
                ],
                [
                    "SURROUND",
                    "Surround"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "Toggle stereoscopic"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "Undetermined"
                ],
                [
                    "UNMUTE",
                    "Unmute"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "Unrecognized"
                ],
                [
                    "VOLUME",
                    "Volume"
                ]
            ]));
            a.Xa("en-GB", new Map([
                [
                    "AD_DURATION",
                    "Ad duration"
                ],
                [
                    "AD_PROGRESS",
                    "Ad [AD_ON] of [NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "Ad statistics"
                ],
                [
                    "AD_TIME",
                    "Ad: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "Auto"
                ],
                [
                    "BACK",
                    "Back"
                ],
                [
                    "CAPTIONS",
                    "Captions"
                ],
                [
                    "CAST",
                    "Cast..."
                ],
                [
                    "CHAPTERS",
                    "Chapters"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "Save video frame"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "Loop the current video"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "Enter picture-in-picture"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "Exit full screen"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "Stop looping the current video"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "Exit picture-in-picture"
                ],
                [
                    "FAST_FORWARD",
                    "Fast-forward"
                ],
                [
                    "FULL_SCREEN",
                    "Full screen"
                ],
                [
                    "LANGUAGE",
                    "Language"
                ],
                [
                    "LIVE",
                    "Live"
                ],
                [
                    "LOOP",
                    "Loop"
                ],
                [
                    "MORE_SETTINGS",
                    "More settings"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "Multiple languages"
                ],
                [
                    "MUTE",
                    "Mute"
                ],
                [
                    "NOT_APPLICABLE",
                    "Not applicable"
                ],
                [
                    "OFF",
                    "Off"
                ],
                [
                    "ON",
                    "On"
                ],
                [
                    "PAUSE",
                    "Pause"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "Picture-in-picture"
                ],
                [
                    "PLAY",
                    "Play"
                ],
                [
                    "PLAYBACK_RATE",
                    "Playback speed"
                ],
                [
                    "QUALITY",
                    "Quality"
                ],
                [
                    "RECENTER_VR",
                    "Recentre"
                ],
                [
                    "REPLAY",
                    "Replay"
                ],
                [
                    "RESOLUTION",
                    "Resolution"
                ],
                [
                    "REWIND",
                    "Rewind"
                ],
                [
                    "SEEK",
                    "Seek"
                ],
                [
                    "SKIP_AD",
                    "Skip ad"
                ],
                [
                    "SKIP_TO_LIVE",
                    "Skip ahead to live"
                ],
                [
                    "STATISTICS",
                    "Statistics"
                ],
                [
                    "SUBTITLE_FORCED",
                    "Forced"
                ],
                [
                    "SURROUND",
                    "Surround"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "Toggle stereoscopic"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "Undetermined"
                ],
                [
                    "UNMUTE",
                    "Unmute"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "Unrecognised"
                ],
                [
                    "VOLUME",
                    "volume"
                ]
            ]));
            a.Xa("es", new Map([
                [
                    "AD_DURATION",
                    "Duraci\u00f3n del anuncio"
                ],
                [
                    "AD_PROGRESS",
                    "Anuncio [AD_ON] de [NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "Estad\u00edsticas del anuncio"
                ],
                [
                    "AD_TIME",
                    "Anuncio: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "Autom\u00e1tico"
                ],
                [
                    "BACK",
                    "Atr\u00e1s"
                ],
                [
                    "CAPTIONS",
                    "Subt\u00edtulos"
                ],
                [
                    "CAST",
                    "Enviar..."
                ],
                [
                    "CHAPTERS",
                    "Cap\u00edtulos"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "Guardar fotograma"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "Reproducir en bucle el v\u00eddeo actual"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "Activar el modo imagen en imagen"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "Salir del modo de pantalla completa"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "Dejar de reproducir en bucle el v\u00eddeo actual"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "Salir del modo imagen en imagen"
                ],
                [
                    "FAST_FORWARD",
                    "Avanzar r\u00e1pidamente"
                ],
                [
                    "FULL_SCREEN",
                    "Pantalla completa"
                ],
                [
                    "LANGUAGE",
                    "Idioma"
                ],
                [
                    "LIVE",
                    "En directo"
                ],
                [
                    "LOOP",
                    "Reproducir en bucle"
                ],
                [
                    "MORE_SETTINGS",
                    "M\u00e1s ajustes"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "Varios idiomas"
                ],
                [
                    "MUTE",
                    "Silenciar"
                ],
                [
                    "NOT_APPLICABLE",
                    "No aplicable"
                ],
                [
                    "OFF",
                    "Desactivado"
                ],
                [
                    "ON",
                    "Activado"
                ],
                [
                    "PAUSE",
                    "Pausar"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "Imagen en imagen"
                ],
                [
                    "PLAY",
                    "Reproducir"
                ],
                [
                    "PLAYBACK_RATE",
                    "Velocidad de reproducci\u00f3n"
                ],
                [
                    "QUALITY",
                    "Calidad"
                ],
                [
                    "RECENTER_VR",
                    "Volver a centrar"
                ],
                [
                    "REPLAY",
                    "Volver a reproducir"
                ],
                [
                    "RESOLUTION",
                    "Resoluci\u00f3n"
                ],
                [
                    "REWIND",
                    "Rebobinar"
                ],
                [
                    "SEEK",
                    "Buscar"
                ],
                [
                    "SKIP_AD",
                    "Saltar anuncio"
                ],
                [
                    "SKIP_NEXT",
                    "Siguiente"
                ],
                [
                    "SKIP_PREVIOUS",
                    "Anterior"
                ],
                [
                    "SKIP_TO_LIVE",
                    "Ir al v\u00eddeo en directo"
                ],
                [
                    "STATISTICS",
                    "Estad\u00edsticas"
                ],
                [
                    "SUBTITLE_FORCED",
                    "Forzado"
                ],
                [
                    "SURROUND",
                    "Envolvente"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "Activar/Desactivar estereosc\u00f3pica"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "Sin especificar"
                ],
                [
                    "UNMUTE",
                    "Activar sonido"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "No reconocida"
                ],
                [
                    "VOLUME",
                    "Volumen"
                ]
            ]));
            a.Xa("es-419", new Map([
                [
                    "AD_DURATION",
                    "Duraci\u00f3n del anuncio"
                ],
                [
                    "AD_PROGRESS",
                    "Anuncio [AD_ON] de [NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "Estad\u00edsticas de anuncios"
                ],
                [
                    "AD_TIME",
                    "Anuncio: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "Autom\u00e1tico"
                ],
                [
                    "BACK",
                    "Atr\u00e1s"
                ],
                [
                    "CAPTIONS",
                    "Subt\u00edtulos"
                ],
                [
                    "CAST",
                    "Transmitir..."
                ],
                [
                    "CHAPTERS",
                    "Cap\u00edtulos"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "Guardar fotograma"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "Repetir indefinidamente el video actual"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "Ingresar al modo de pantalla en pantalla"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "Salir de pantalla completa"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "Detener la repetici\u00f3n indefinida del video actual"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "Salir del modo de pantalla en pantalla"
                ],
                [
                    "FAST_FORWARD",
                    "Avanzar"
                ],
                [
                    "FULL_SCREEN",
                    "Pantalla completa"
                ],
                [
                    "LANGUAGE",
                    "Idioma"
                ],
                [
                    "LIVE",
                    "En directo"
                ],
                [
                    "LOOP",
                    "Repetir indefinidamente"
                ],
                [
                    "MORE_SETTINGS",
                    "M\u00e1s opciones de configuraci\u00f3n"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "Varios idiomas"
                ],
                [
                    "MUTE",
                    "Silenciar"
                ],
                [
                    "NOT_APPLICABLE",
                    "No aplicable"
                ],
                [
                    "OFF",
                    "Desactivado"
                ],
                [
                    "ON",
                    "Activado"
                ],
                [
                    "PAUSE",
                    "Detener"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "Pantalla en pantalla"
                ],
                [
                    "PLAY",
                    "Reproducir"
                ],
                [
                    "PLAYBACK_RATE",
                    "Velocidad de reproducci\u00f3n"
                ],
                [
                    "QUALITY",
                    "Calidad"
                ],
                [
                    "RECENTER_VR",
                    "Volver a centrar"
                ],
                [
                    "REPLAY",
                    "Volver a reproducir"
                ],
                [
                    "RESOLUTION",
                    "Resoluci\u00f3n"
                ],
                [
                    "REWIND",
                    "Retroceder"
                ],
                [
                    "SEEK",
                    "Buscar"
                ],
                [
                    "SKIP_AD",
                    "Omitir anuncio"
                ],
                [
                    "SKIP_TO_LIVE",
                    "Adelantar hasta la transmisi\u00f3n en vivo"
                ],
                [
                    "STATISTICS",
                    "Estad\u00edsticas"
                ],
                [
                    "SUBTITLE_FORCED",
                    "Forzado"
                ],
                [
                    "SURROUND",
                    "Sonido envolvente"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "Activar o desactivar el modo estereosc\u00f3pico"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "Sin especificar"
                ],
                [
                    "UNMUTE",
                    "Dejar de silenciar"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "No reconocida"
                ],
                [
                    "VOLUME",
                    "Volumen"
                ]
            ]));
            a.Xa("fr", new Map([
                [
                    "AD_DURATION",
                    "Dur\u00e9e de l'annonce"
                ],
                [
                    "AD_PROGRESS",
                    "Annonce\u00a0[AD_ON] sur\u00a0[NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "Statistiques sur les annonces"
                ],
                [
                    "AD_TIME",
                    "Annonce\u00a0: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "Automatique"
                ],
                [
                    "BACK",
                    "Retour"
                ],
                [
                    "CAPTIONS",
                    "Sous-titres"
                ],
                [
                    "CAST",
                    "Caster\u2026"
                ],
                [
                    "CHAPTERS",
                    "Chapitres"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "T\u00e9l\u00e9charger l'image de la vid\u00e9o"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "Lire en boucle la vid\u00e9o en cours"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "Utiliser le mode Picture-in-Picture"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "Quitter le mode plein \u00e9cran"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "Arr\u00eater la lecture en boucle de la vid\u00e9o en cours"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "Quitter le mode\u00a0PIP (Picture-in-picture)"
                ],
                [
                    "FAST_FORWARD",
                    "Avance rapide"
                ],
                [
                    "FULL_SCREEN",
                    "Plein \u00e9cran"
                ],
                [
                    "LANGUAGE",
                    "Langue"
                ],
                [
                    "LIVE",
                    "En direct"
                ],
                [
                    "LOOP",
                    "R\u00e9p\u00e9ter"
                ],
                [
                    "MORE_SETTINGS",
                    "Plus de param\u00e8tres"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "Plusieurs langues"
                ],
                [
                    "MUTE",
                    "Couper le son"
                ],
                [
                    "NOT_APPLICABLE",
                    "Non applicable"
                ],
                [
                    "OFF",
                    "D\u00e9sactiv\u00e9e"
                ],
                [
                    "ON",
                    "Activ\u00e9e"
                ],
                [
                    "PAUSE",
                    "Pause"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "Picture-in-Picture"
                ],
                [
                    "PLAY",
                    "Visionner"
                ],
                [
                    "PLAYBACK_RATE",
                    "Vitesse de lecture"
                ],
                [
                    "QUALITY",
                    "Qualit\u00e9"
                ],
                [
                    "RECENTER_VR",
                    "Recentrer"
                ],
                [
                    "REPLAY",
                    "Revoir"
                ],
                [
                    "RESOLUTION",
                    "R\u00e9solution"
                ],
                [
                    "REWIND",
                    "Retour arri\u00e8re"
                ],
                [
                    "SEEK",
                    "Chercher"
                ],
                [
                    "SKIP_AD",
                    "Passer l'annonce"
                ],
                [
                    "SKIP_NEXT",
                    "Suivante"
                ],
                [
                    "SKIP_PREVIOUS",
                    "Pr\u00e9c\u00e9dente"
                ],
                [
                    "SKIP_TO_LIVE",
                    "Acc\u00e9der \u00e0 la partie la plus r\u00e9cente du direct"
                ],
                [
                    "STATISTICS",
                    "Statistiques"
                ],
                [
                    "SUBTITLE_FORCED",
                    "Forc\u00e9"
                ],
                [
                    "SURROUND",
                    "Surround"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "Activer/D\u00e9sactiver le mode st\u00e9r\u00e9oscopique"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "Langue ind\u00e9termin\u00e9e"
                ],
                [
                    "UNMUTE",
                    "R\u00e9activer le son"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "Non reconnu"
                ],
                [
                    "VOLUME",
                    "Volume"
                ]
            ]));
            a.Xa("it", new Map([
                [
                    "AD_DURATION",
                    "Durata dell'annuncio"
                ],
                [
                    "AD_PROGRESS",
                    "Annuncio [AD_ON] di [NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "Statistiche sugli annunci"
                ],
                [
                    "AD_TIME",
                    "Annuncio: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "Automatica"
                ],
                [
                    "BACK",
                    "Indietro"
                ],
                [
                    "CAPTIONS",
                    "Sottotitoli"
                ],
                [
                    "CAST",
                    "Trasmetti..."
                ],
                [
                    "CHAPTERS",
                    "Capitoli"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "Salva fotogramma"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "Riproduci in loop il video corrente"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "Attiva Picture in picture"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "Esci da schermo intero"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "Interrompi riproduzione in loop del video corrente"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "Esci da Picture in picture"
                ],
                [
                    "FAST_FORWARD",
                    "Avanti veloce"
                ],
                [
                    "FULL_SCREEN",
                    "Schermo intero"
                ],
                [
                    "LANGUAGE",
                    "Lingua"
                ],
                [
                    "LIVE",
                    "Dal vivo"
                ],
                [
                    "LOOP",
                    "Riproduci in loop"
                ],
                [
                    "MORE_SETTINGS",
                    "Altre impostazioni"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "Pi\u00f9 lingue"
                ],
                [
                    "MUTE",
                    "Disattiva audio"
                ],
                [
                    "NOT_APPLICABLE",
                    "Non applicabile"
                ],
                [
                    "OFF",
                    "Disattivo"
                ],
                [
                    "ON",
                    "Attivo"
                ],
                [
                    "PAUSE",
                    "Metti in pausa"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "Picture in picture"
                ],
                [
                    "PLAY",
                    "Riproduci"
                ],
                [
                    "PLAYBACK_RATE",
                    "Velocit\u00e0 di riproduzione"
                ],
                [
                    "QUALITY",
                    "Qualit\u00e0"
                ],
                [
                    "RECENTER_VR",
                    "Ricentra"
                ],
                [
                    "REPLAY",
                    "Riproduci di nuovo"
                ],
                [
                    "RESOLUTION",
                    "Risoluzione"
                ],
                [
                    "REWIND",
                    "Riavvolgi"
                ],
                [
                    "SEEK",
                    "Cerca"
                ],
                [
                    "SKIP_AD",
                    "Salta annuncio"
                ],
                [
                    "SKIP_TO_LIVE",
                    "Passa alla trasmissione dal vivo"
                ],
                [
                    "STATISTICS",
                    "Statistiche"
                ],
                [
                    "SUBTITLE_FORCED",
                    "Forzata"
                ],
                [
                    "SURROUND",
                    "Surround"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "Pulsante di attivazione/disattivazione stereoscopico"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "Indeterminata"
                ],
                [
                    "UNMUTE",
                    "Riattiva audio"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "Non riconosciuto"
                ],
                [
                    "VOLUME",
                    "Volume"
                ]
            ]));
            a.Xa("ja", new Map([
                [
                    "AD_DURATION",
                    "\u5e83\u544a\u518d\u751f\u6642\u9593"
                ],
                [
                    "AD_PROGRESS",
                    "[AD_ON] \u756a\u76ee\u306e\u5e83\u544a\uff08\u5168 [NUM_ADS] \u500b\uff09"
                ],
                [
                    "AD_STATISTICS",
                    "\u5e83\u544a\u306e\u7d71\u8a08\u60c5\u5831"
                ],
                [
                    "AD_TIME",
                    "\u5e83\u544a: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "\u81ea\u52d5"
                ],
                [
                    "BACK",
                    "\u623b\u308b"
                ],
                [
                    "CAPTIONS",
                    "\u5b57\u5e55"
                ],
                [
                    "CAST",
                    "\u30ad\u30e3\u30b9\u30c8..."
                ],
                [
                    "CHAPTERS",
                    "\u7ae0"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "\u52d5\u753b\u30d5\u30ec\u30fc\u30e0\u3092\u4fdd\u5b58"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "\u73fe\u5728\u306e\u52d5\u753b\u3092\u30eb\u30fc\u30d7\u518d\u751f"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "\u30d4\u30af\u30c1\u30e3\u30fc \u30a4\u30f3 \u30d4\u30af\u30c1\u30e3\u30fc\u3092\u958b\u59cb"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "\u5168\u753b\u9762\u8868\u793a\u3092\u7d42\u4e86"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "\u73fe\u5728\u306e\u52d5\u753b\u306e\u30eb\u30fc\u30d7\u518d\u751f\u3092\u505c\u6b62"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "\u30d4\u30af\u30c1\u30e3\u30fc \u30a4\u30f3 \u30d4\u30af\u30c1\u30e3\u30fc\u3092\u7d42\u4e86"
                ],
                [
                    "FAST_FORWARD",
                    "\u65e9\u9001\u308a"
                ],
                [
                    "FULL_SCREEN",
                    "\u5168\u753b\u9762\u8868\u793a"
                ],
                [
                    "LANGUAGE",
                    "\u8a00\u8a9e"
                ],
                [
                    "LIVE",
                    "\u30e9\u30a4\u30d6"
                ],
                [
                    "LOOP",
                    "\u30eb\u30fc\u30d7"
                ],
                [
                    "MORE_SETTINGS",
                    "\u8a73\u7d30\u8a2d\u5b9a"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "\u591a\u8a00\u8a9e"
                ],
                [
                    "MUTE",
                    "\u30df\u30e5\u30fc\u30c8"
                ],
                [
                    "NOT_APPLICABLE",
                    "\u8a72\u5f53\u306a\u3057"
                ],
                [
                    "OFF",
                    "\u30aa\u30d5"
                ],
                [
                    "ON",
                    "\u30aa\u30f3"
                ],
                [
                    "PAUSE",
                    "\u4e00\u6642\u505c\u6b62"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "\u30d4\u30af\u30c1\u30e3\u30fc \u30a4\u30f3 \u30d4\u30af\u30c1\u30e3\u30fc"
                ],
                [
                    "PLAY",
                    "\u518d\u751f"
                ],
                [
                    "PLAYBACK_RATE",
                    "\u518d\u751f\u901f\u5ea6"
                ],
                [
                    "QUALITY",
                    "\u54c1\u8cea"
                ],
                [
                    "RECENTER_VR",
                    "\u4e2d\u5fc3\u3092\u518d\u8a2d\u5b9a"
                ],
                [
                    "REPLAY",
                    "\u3082\u3046\u4e00\u5ea6\u518d\u751f"
                ],
                [
                    "RESOLUTION",
                    "\u89e3\u50cf\u5ea6"
                ],
                [
                    "REWIND",
                    "\u5dfb\u304d\u623b\u3057"
                ],
                [
                    "SEEK",
                    "\u30b7\u30fc\u30af\u518d\u751f"
                ],
                [
                    "SKIP_AD",
                    "\u5e83\u544a\u3092\u30b9\u30ad\u30c3\u30d7"
                ],
                [
                    "SKIP_TO_LIVE",
                    "\u30e9\u30a4\u30d6\u914d\u4fe1\u307e\u3067\u30b9\u30ad\u30c3\u30d7"
                ],
                [
                    "STATISTICS",
                    "\u7d71\u8a08\u60c5\u5831"
                ],
                [
                    "SUBTITLE_FORCED",
                    "\u5f37\u5236"
                ],
                [
                    "SURROUND",
                    "\u30b5\u30e9\u30a6\u30f3\u30c9"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "\u7acb\u4f53\u753b\u50cf\u3092\u5207\u308a\u66ff\u3048\u308b"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "\u4e0d\u660e"
                ],
                [
                    "UNMUTE",
                    "\u30df\u30e5\u30fc\u30c8\u3092\u89e3\u9664"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "\u4e0d\u660e"
                ],
                [
                    "VOLUME",
                    "\u97f3\u91cf"
                ]
            ]));
            a.Xa("ko", new Map([
                [
                    "AD_DURATION",
                    "\uad11\uace0 \uae30\uac04"
                ],
                [
                    "AD_PROGRESS",
                    "\uad11\uace0 [AD_ON]/[NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "\uad11\uace0 \ud1b5\uacc4"
                ],
                [
                    "AD_TIME",
                    "\uad11\uace0: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "\uc790\ub3d9"
                ],
                [
                    "BACK",
                    "\ub4a4\ub85c"
                ],
                [
                    "CAPTIONS",
                    "\uc790\ub9c9"
                ],
                [
                    "CAST",
                    "\uc804\uc1a1..."
                ],
                [
                    "CHAPTERS",
                    "\uc7a5"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "\ub3d9\uc601\uc0c1 \ud504\ub808\uc784 \uc800\uc7a5"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "\ud604\uc7ac \ub3d9\uc601\uc0c1 \ubc18\ubcf5 \uc7ac\uc0dd"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "PIP \ubaa8\ub4dc \uc2dc\uc791"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "\uc804\uccb4\ud654\uba74 \ub2eb\uae30"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "\ud604\uc7ac \ub3d9\uc601\uc0c1 \ubc18\ubcf5 \uc7ac\uc0dd \uc911\uc9c0"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "PIP \ubaa8\ub4dc \uc885\ub8cc"
                ],
                [
                    "FAST_FORWARD",
                    "\ube68\ub9ac \uac10\uae30"
                ],
                [
                    "FULL_SCREEN",
                    "\uc804\uccb4\ud654\uba74"
                ],
                [
                    "LANGUAGE",
                    "\uc5b8\uc5b4"
                ],
                [
                    "LIVE",
                    "\uc2e4\uc2dc\uac04"
                ],
                [
                    "LOOP",
                    "\ubc18\ubcf5 \uc7ac\uc0dd"
                ],
                [
                    "MORE_SETTINGS",
                    "\uc124\uc815 \ub354\ubcf4\uae30"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "\uc5ec\ub7ec \uc5b8\uc5b4"
                ],
                [
                    "MUTE",
                    "\uc74c\uc18c\uac70"
                ],
                [
                    "NOT_APPLICABLE",
                    "\ud574\ub2f9 \uc0ac\ud56d \uc5c6\uc74c"
                ],
                [
                    "OFF",
                    "\uc0ac\uc6a9 \uc548\ud568"
                ],
                [
                    "ON",
                    "\uc0ac\uc6a9"
                ],
                [
                    "PAUSE",
                    "\uc77c\uc2dc\uc911\uc9c0"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "PIP \ubaa8\ub4dc"
                ],
                [
                    "PLAY",
                    "\uc7ac\uc0dd"
                ],
                [
                    "PLAYBACK_RATE",
                    "\uc7ac\uc0dd \uc18d\ub3c4"
                ],
                [
                    "QUALITY",
                    "\ud488\uc9c8"
                ],
                [
                    "RECENTER_VR",
                    "\uc911\uc2ec \uc7ac\uc124\uc815"
                ],
                [
                    "REPLAY",
                    "\ub2e4\uc2dc\ubcf4\uae30"
                ],
                [
                    "RESOLUTION",
                    "\ud574\uc0c1\ub3c4"
                ],
                [
                    "REWIND",
                    "\ub418\uac10\uae30"
                ],
                [
                    "SEEK",
                    "\ucc3e\uae30"
                ],
                [
                    "SKIP_AD",
                    "\uad11\uace0 \uac74\ub108\ub6f0\uae30"
                ],
                [
                    "SKIP_TO_LIVE",
                    "\ub77c\uc774\ube0c \ub3d9\uc601\uc0c1\uc73c\ub85c \uac74\ub108\ub6f0\uae30"
                ],
                [
                    "STATISTICS",
                    "\ud1b5\uacc4"
                ],
                [
                    "SUBTITLE_FORCED",
                    "\uac15\uc81c"
                ],
                [
                    "SURROUND",
                    "\uc11c\ub77c\uc6b4\ub4dc"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "\uc785\uccb4 \ubcf4\uae30 \uc804\ud658"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "\ubbf8\uc815"
                ],
                [
                    "UNMUTE",
                    "\uc74c\uc18c\uac70 \ud574\uc81c"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "\uc54c \uc218 \uc5c6\uc74c"
                ],
                [
                    "VOLUME",
                    "\ubcfc\ub968"
                ]
            ]));
            a.Xa("nl", new Map([
                [
                    "AD_DURATION",
                    "Advertentieduur"
                ],
                [
                    "AD_PROGRESS",
                    "Advertentie [AD_ON] van [NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "Advertentiestatistieken"
                ],
                [
                    "AD_TIME",
                    "Advertentie: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "Automatisch"
                ],
                [
                    "BACK",
                    "Terug"
                ],
                [
                    "CAPTIONS",
                    "Ondertiteling"
                ],
                [
                    "CAST",
                    "Casten..."
                ],
                [
                    "CHAPTERS",
                    "Hoofdstukken"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "Videoframe opslaan"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "De huidige video lussen"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "Scherm-in-scherm openen"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "Volledig scherm sluiten"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "De huidige video niet meer lussen"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "Scherm-in-scherm afsluiten"
                ],
                [
                    "FAST_FORWARD",
                    "Vooruitspoelen"
                ],
                [
                    "FULL_SCREEN",
                    "Volledig scherm"
                ],
                [
                    "LANGUAGE",
                    "Taal"
                ],
                [
                    "LIVE",
                    "Live"
                ],
                [
                    "LOOP",
                    "Lussen"
                ],
                [
                    "MORE_SETTINGS",
                    "Meer instellingen"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "Meerdere talen"
                ],
                [
                    "MUTE",
                    "Geluid uitzetten"
                ],
                [
                    "NOT_APPLICABLE",
                    "Niet van toepassing"
                ],
                [
                    "OFF",
                    "Uit"
                ],
                [
                    "ON",
                    "Aan"
                ],
                [
                    "PAUSE",
                    "Onderbreken"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "Scherm-in-scherm"
                ],
                [
                    "PLAY",
                    "Afspelen"
                ],
                [
                    "PLAYBACK_RATE",
                    "Afspeelsnelheid"
                ],
                [
                    "QUALITY",
                    "Kwaliteit"
                ],
                [
                    "RECENTER_VR",
                    "Opnieuw centreren"
                ],
                [
                    "REPLAY",
                    "Opnieuw afspelen"
                ],
                [
                    "RESOLUTION",
                    "Resolutie"
                ],
                [
                    "REWIND",
                    "Terugspoelen"
                ],
                [
                    "SEEK",
                    "Zoeken"
                ],
                [
                    "SKIP_AD",
                    "Advertentie overslaan"
                ],
                [
                    "SKIP_TO_LIVE",
                    "Doorgaan naar live"
                ],
                [
                    "STATISTICS",
                    "Statistieken"
                ],
                [
                    "SUBTITLE_FORCED",
                    "Afgedwongen"
                ],
                [
                    "SURROUND",
                    "Surround"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "Stereoscopisch aan-/uitzetten"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "Onbepaald"
                ],
                [
                    "UNMUTE",
                    "Geluid aanzetten"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "Onbekend"
                ],
                [
                    "VOLUME",
                    "Volume"
                ]
            ]));
            a.Xa("pl", new Map([
                [
                    "AD_DURATION",
                    "Czas trwania reklamy"
                ],
                [
                    "AD_PROGRESS",
                    "Reklama\u00a0[AD_ON] z\u00a0[NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "Statystyki reklam"
                ],
                [
                    "AD_TIME",
                    "Reklama: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "Automatycznie"
                ],
                [
                    "BACK",
                    "Wstecz"
                ],
                [
                    "CAPTIONS",
                    "Napisy"
                ],
                [
                    "CAST",
                    "Przesy\u0142aj..."
                ],
                [
                    "CHAPTERS",
                    "Rozdzia\u0142y"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "Zapisz klatk\u0119 filmu"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "Odtwarzaj bie\u017c\u0105cy film w\u00a0p\u0119tli"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "W\u0142\u0105cz tryb obrazu w\u00a0obrazie"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "Zamknij pe\u0142ny ekran"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "Wy\u0142\u0105cz odtwarzanie bie\u017c\u0105cego filmu w\u00a0p\u0119tli"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "Wy\u0142\u0105cz tryb obrazu w\u00a0obrazie"
                ],
                [
                    "FAST_FORWARD",
                    "Przewi\u0144 do przodu"
                ],
                [
                    "FULL_SCREEN",
                    "Pe\u0142ny ekran"
                ],
                [
                    "LANGUAGE",
                    "J\u0119zyk"
                ],
                [
                    "LIVE",
                    "Na \u017cywo"
                ],
                [
                    "LOOP",
                    "Odtwarzaj w\u00a0p\u0119tli"
                ],
                [
                    "MORE_SETTINGS",
                    "Wi\u0119cej ustawie\u0144"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "Wiele j\u0119zyk\u00f3w"
                ],
                [
                    "MUTE",
                    "Wycisz"
                ],
                [
                    "NOT_APPLICABLE",
                    "Nie dotyczy"
                ],
                [
                    "OFF",
                    "Wy\u0142\u0105czone"
                ],
                [
                    "ON",
                    "W\u0142\u0105czone"
                ],
                [
                    "PAUSE",
                    "Wstrzymaj"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "Obraz w\u00a0obrazie"
                ],
                [
                    "PLAY",
                    "Odtw\u00f3rz"
                ],
                [
                    "PLAYBACK_RATE",
                    "Szybko\u015b\u0107 odtwarzania"
                ],
                [
                    "QUALITY",
                    "Jako\u015b\u0107"
                ],
                [
                    "RECENTER_VR",
                    "Wy\u015brodkuj"
                ],
                [
                    "REPLAY",
                    "Odtw\u00f3rz ponownie"
                ],
                [
                    "RESOLUTION",
                    "Rozdzielczo\u015b\u0107"
                ],
                [
                    "REWIND",
                    "Przewi\u0144 do ty\u0142u"
                ],
                [
                    "SEEK",
                    "Szukaj"
                ],
                [
                    "SKIP_AD",
                    "Pomi\u0144 reklam\u0119"
                ],
                [
                    "SKIP_NEXT",
                    "Dalej"
                ],
                [
                    "SKIP_PREVIOUS",
                    "Poprzedni"
                ],
                [
                    "SKIP_TO_LIVE",
                    "Przejd\u017a do transmisji na \u017cywo"
                ],
                [
                    "STATISTICS",
                    "Statystyki"
                ],
                [
                    "SUBTITLE_FORCED",
                    "Wymuszone"
                ],
                [
                    "SURROUND",
                    "Przestrzenny"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "Prze\u0142\u0105cz tryb stereoskopowy"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "Nie okre\u015blono"
                ],
                [
                    "UNMUTE",
                    "Wy\u0142\u0105cz wyciszenie"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "Nierozpoznany"
                ],
                [
                    "VOLUME",
                    "G\u0142o\u015bno\u015b\u0107"
                ]
            ]));
            a.Xa("pt-BR", new Map([
                [
                    "AD_DURATION",
                    "Dura\u00e7\u00e3o do an\u00fancio"
                ],
                [
                    "AD_PROGRESS",
                    "An\u00fancio [AD_ON] de [NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "Estat\u00edsticas de an\u00fancios"
                ],
                [
                    "AD_TIME",
                    "An\u00fancio: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "Autom\u00e1tica"
                ],
                [
                    "BACK",
                    "Voltar"
                ],
                [
                    "CAPTIONS",
                    "Legendas"
                ],
                [
                    "CAST",
                    "Transmitir..."
                ],
                [
                    "CHAPTERS",
                    "Cap\u00edtulos"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "Salvar frame do v\u00eddeo"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "Repetir o v\u00eddeo atual"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "Entrar no modo picture-in-picture"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "Sair do modo tela cheia"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "Parar repeti\u00e7\u00e3o do v\u00eddeo atual"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "Sair de picture-in-picture"
                ],
                [
                    "FAST_FORWARD",
                    "Avan\u00e7ar"
                ],
                [
                    "FULL_SCREEN",
                    "Tela cheia"
                ],
                [
                    "LANGUAGE",
                    "Idioma"
                ],
                [
                    "LIVE",
                    "Ao vivo"
                ],
                [
                    "LOOP",
                    "Repetir"
                ],
                [
                    "MORE_SETTINGS",
                    "Mais defini\u00e7\u00f5es"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "V\u00e1rios idiomas"
                ],
                [
                    "MUTE",
                    "Desativar som"
                ],
                [
                    "NOT_APPLICABLE",
                    "N\u00e3o relevante"
                ],
                [
                    "OFF",
                    "Desativado"
                ],
                [
                    "ON",
                    "Ativado"
                ],
                [
                    "PAUSE",
                    "Pausar"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "Picture-in-picture"
                ],
                [
                    "PLAY",
                    "Reproduzir"
                ],
                [
                    "PLAYBACK_RATE",
                    "Velocidade da reprodu\u00e7\u00e3o"
                ],
                [
                    "QUALITY",
                    "Qualidade"
                ],
                [
                    "RECENTER_VR",
                    "Centralizar"
                ],
                [
                    "REPLAY",
                    "Repetir"
                ],
                [
                    "RESOLUTION",
                    "Resolu\u00e7\u00e3o"
                ],
                [
                    "REWIND",
                    "Voltar"
                ],
                [
                    "SEEK",
                    "Procurar"
                ],
                [
                    "SKIP_AD",
                    "Pular an\u00fancio"
                ],
                [
                    "SKIP_TO_LIVE",
                    "Pular para transmiss\u00e3o ao vivo"
                ],
                [
                    "STATISTICS",
                    "Estat\u00edsticas"
                ],
                [
                    "SUBTITLE_FORCED",
                    "Exibi\u00e7\u00e3o for\u00e7ada"
                ],
                [
                    "SURROUND",
                    "Surround"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "Alternar imagem estereosc\u00f3pica"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "Indeterminado"
                ],
                [
                    "UNMUTE",
                    "Ativar som"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "N\u00e3o reconhecido"
                ],
                [
                    "VOLUME",
                    "Volume"
                ]
            ]));
            a.Xa("ru", new Map([
                [
                    "AD_DURATION",
                    "\u041f\u0440\u043e\u0434\u043e\u043b\u0436\u0438\u0442\u0435\u043b\u044c\u043d\u043e\u0441\u0442\u044c \u0440\u0435\u043a\u043b\u0430\u043c\u044b"
                ],
                [
                    "AD_PROGRESS",
                    "\u0420\u0435\u043a\u043b\u0430\u043c\u0430 [AD_ON] \u0438\u0437 [NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043a\u0430 \u043e\u0431\u044a\u044f\u0432\u043b\u0435\u043d\u0438\u0439"
                ],
                [
                    "AD_TIME",
                    "\u0420\u0435\u043a\u043b\u0430\u043c\u0430: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "\u0410\u0432\u0442\u043e"
                ],
                [
                    "BACK",
                    "\u041d\u0430\u0437\u0430\u0434"
                ],
                [
                    "CAPTIONS",
                    "\u0421\u0443\u0431\u0442\u0438\u0442\u0440\u044b"
                ],
                [
                    "CAST",
                    "\u0422\u0440\u0430\u043d\u0441\u043b\u0438\u0440\u043e\u0432\u0430\u0442\u044c..."
                ],
                [
                    "CHAPTERS",
                    "\u042d\u043f\u0438\u0437\u043e\u0434\u044b"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "\u0421\u043e\u0445\u0440\u0430\u043d\u0438\u0442\u044c \u043a\u0430\u0434\u0440 \u0432\u0438\u0434\u0435\u043e"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "\u0417\u0430\u0446\u0438\u043a\u043b\u0438\u0442\u044c \u0442\u0435\u043a\u0443\u0449\u0435\u0435 \u0432\u0438\u0434\u0435\u043e"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    '\u041f\u0435\u0440\u0435\u0439\u0442\u0438 \u0432 \u0440\u0435\u0436\u0438\u043c "\u041a\u0430\u0440\u0442\u0438\u043d\u043a\u0430 \u0432 \u043a\u0430\u0440\u0442\u0438\u043d\u043a\u0435"'
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "\u041e\u0431\u044b\u0447\u043d\u044b\u0439 \u0440\u0435\u0436\u0438\u043c"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "\u041e\u0442\u043c\u0435\u043d\u0438\u0442\u044c \u0437\u0430\u0446\u0438\u043a\u043b\u0438\u0432\u0430\u043d\u0438\u0435 \u0442\u0435\u043a\u0443\u0449\u0435\u0433\u043e \u0432\u0438\u0434\u0435\u043e"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    '\u0412\u044b\u0439\u0442\u0438 \u0438\u0437 \u0440\u0435\u0436\u0438\u043c\u0430 "\u041a\u0430\u0440\u0442\u0438\u043d\u043a\u0430 \u0432 \u043a\u0430\u0440\u0442\u0438\u043d\u043a\u0435"'
                ],
                [
                    "FAST_FORWARD",
                    "\u041f\u0435\u0440\u0435\u043c\u043e\u0442\u043a\u0430 \u0432\u043f\u0435\u0440\u0435\u0434"
                ],
                [
                    "FULL_SCREEN",
                    "\u041f\u043e\u043b\u043d\u043e\u044d\u043a\u0440\u0430\u043d\u043d\u044b\u0439 \u0440\u0435\u0436\u0438\u043c"
                ],
                [
                    "LANGUAGE",
                    "\u042f\u0437\u044b\u043a"
                ],
                [
                    "LIVE",
                    "\u041f\u0440\u044f\u043c\u043e\u0439 \u044d\u0444\u0438\u0440"
                ],
                [
                    "LOOP",
                    "\u0417\u0430\u0446\u0438\u043a\u043b\u0438\u0442\u044c"
                ],
                [
                    "MORE_SETTINGS",
                    "\u0414\u043e\u043f\u043e\u043b\u043d\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0435 \u043d\u0430\u0441\u0442\u0440\u043e\u0439\u043a\u0438"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "\u041d\u0435\u0441\u043a\u043e\u043b\u044c\u043a\u043e \u044f\u0437\u044b\u043a\u043e\u0432"
                ],
                [
                    "MUTE",
                    "\u041e\u0442\u043a\u043b\u044e\u0447\u0438\u0442\u044c \u0437\u0432\u0443\u043a"
                ],
                [
                    "NOT_APPLICABLE",
                    "\u041d\u0435\u043f\u0440\u0438\u043c\u0435\u043d\u0438\u043c\u043e"
                ],
                [
                    "OFF",
                    "\u0412\u044b\u043a\u043b."
                ],
                [
                    "ON",
                    "\u0412\u043a\u043b."
                ],
                [
                    "PAUSE",
                    "\u041f\u0430\u0443\u0437\u0430"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "\u041a\u0430\u0440\u0442\u0438\u043d\u043a\u0430 \u0432 \u043a\u0430\u0440\u0442\u0438\u043d\u043a\u0435"
                ],
                [
                    "PLAY",
                    "\u0412\u043e\u0441\u043f\u0440\u043e\u0438\u0437\u0432\u0435\u0441\u0442\u0438"
                ],
                [
                    "PLAYBACK_RATE",
                    "\u0421\u043a\u043e\u0440\u043e\u0441\u0442\u044c \u0432\u043e\u0441\u043f\u0440\u043e\u0438\u0437\u0432\u0435\u0434\u0435\u043d\u0438\u044f"
                ],
                [
                    "QUALITY",
                    "\u041a\u0430\u0447\u0435\u0441\u0442\u0432\u043e"
                ],
                [
                    "RECENTER_VR",
                    "\u0426\u0435\u043d\u0442\u0440\u0438\u0440\u043e\u0432\u0430\u0442\u044c \u0437\u0430\u043d\u043e\u0432\u043e"
                ],
                [
                    "REPLAY",
                    "\u041f\u043e\u0432\u0442\u043e\u0440\u0438\u0442\u044c"
                ],
                [
                    "RESOLUTION",
                    "\u0420\u0430\u0437\u0440\u0435\u0448\u0435\u043d\u0438\u0435"
                ],
                [
                    "REWIND",
                    "\u041f\u0435\u0440\u0435\u043c\u043e\u0442\u0430\u0442\u044c \u043d\u0430\u0437\u0430\u0434"
                ],
                [
                    "SEEK",
                    "\u041f\u0435\u0440\u0435\u043c\u043e\u0442\u043a\u0430"
                ],
                [
                    "SKIP_AD",
                    "\u041f\u0440\u043e\u043f\u0443\u0441\u0442\u0438\u0442\u044c"
                ],
                [
                    "SKIP_TO_LIVE",
                    "\u041f\u0440\u043e\u043f\u0443\u0441\u0442\u0438\u0442\u044c \u0438 \u043f\u0435\u0440\u0435\u0439\u0442\u0438 \u043a \u043f\u0440\u044f\u043c\u043e\u0439 \u0442\u0440\u0430\u043d\u0441\u043b\u044f\u0446\u0438\u0438"
                ],
                [
                    "STATISTICS",
                    "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043a\u0430"
                ],
                [
                    "SUBTITLE_FORCED",
                    "\u0421\u0443\u0431\u0442\u0438\u0442\u0440\u044b \u043f\u0440\u0438\u043d\u0443\u0434\u0438\u0442\u0435\u043b\u044c\u043d\u043e"
                ],
                [
                    "SURROUND",
                    "\u041e\u0431\u044a\u0435\u043c\u043d\u044b\u0439 \u0437\u0432\u0443\u043a"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "\u0412\u043a\u043b\u044e\u0447\u0438\u0442\u044c \u0438\u043b\u0438 \u043e\u0442\u043a\u043b\u044e\u0447\u0438\u0442\u044c \u0441\u0442\u0435\u0440\u0435\u043e\u0441\u043a\u043e\u043f\u0438\u0447\u0435\u0441\u043a\u0438\u0439 \u0440\u0435\u0436\u0438\u043c"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "\u041d\u0435 \u0443\u043a\u0430\u0437\u0430\u043d\u043e"
                ],
                [
                    "UNMUTE",
                    "\u0412\u043a\u043b\u044e\u0447\u0438\u0442\u044c \u0437\u0432\u0443\u043a"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "\u041d\u0435 \u0440\u0430\u0441\u043f\u043e\u0437\u043d\u0430\u043d\u043e"
                ],
                [
                    "VOLUME",
                    "\u0413\u0440\u043e\u043c\u043a\u043e\u0441\u0442\u044c"
                ]
            ]));
            a.Xa("th", new Map([
                [
                    "AD_DURATION",
                    "\u0e23\u0e30\u0e22\u0e30\u0e40\u0e27\u0e25\u0e32\u0e42\u0e06\u0e29\u0e13\u0e32"
                ],
                [
                    "AD_PROGRESS",
                    "\u0e42\u0e06\u0e29\u0e13\u0e32 [AD_ON] \u0e08\u0e32\u0e01 [NUM_ADS] \u0e23\u0e32\u0e22\u0e01\u0e32\u0e23"
                ],
                [
                    "AD_STATISTICS",
                    "\u0e2a\u0e16\u0e34\u0e15\u0e34\u0e42\u0e06\u0e29\u0e13\u0e32"
                ],
                [
                    "AD_TIME",
                    "\u0e42\u0e06\u0e29\u0e13\u0e32: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "\u0e2d\u0e31\u0e15\u0e42\u0e19\u0e21\u0e31\u0e15\u0e34"
                ],
                [
                    "BACK",
                    "\u0e01\u0e25\u0e31\u0e1a"
                ],
                [
                    "CAPTIONS",
                    "\u0e04\u0e33\u0e1a\u0e23\u0e23\u0e22\u0e32\u0e22\u0e41\u0e17\u0e19\u0e40\u0e2a\u0e35\u0e22\u0e07"
                ],
                [
                    "CAST",
                    "\u0e41\u0e04\u0e2a\u0e15\u0e4c..."
                ],
                [
                    "CHAPTERS",
                    "\u0e1a\u0e17"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "\u0e1a\u0e31\u0e19\u0e17\u0e36\u0e01\u0e40\u0e1f\u0e23\u0e21\u0e27\u0e34\u0e14\u0e35\u0e42\u0e2d"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "\u0e27\u0e19\u0e0b\u0e49\u0e33\u0e27\u0e34\u0e14\u0e35\u0e42\u0e2d\u0e1b\u0e31\u0e08\u0e08\u0e38\u0e1a\u0e31\u0e19"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "\u0e40\u0e02\u0e49\u0e32\u0e2a\u0e39\u0e48\u0e01\u0e32\u0e23\u0e41\u0e2a\u0e14\u0e07\u0e20\u0e32\u0e1e\u0e0b\u0e49\u0e2d\u0e19\u0e20\u0e32\u0e1e"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "\u0e2d\u0e2d\u0e01\u0e08\u0e32\u0e01\u0e01\u0e32\u0e23\u0e41\u0e2a\u0e14\u0e07\u0e41\u0e1a\u0e1a\u0e40\u0e15\u0e47\u0e21\u0e2b\u0e19\u0e49\u0e32\u0e08\u0e2d"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "\u0e2b\u0e22\u0e38\u0e14\u0e27\u0e19\u0e0b\u0e49\u0e33\u0e27\u0e34\u0e14\u0e35\u0e42\u0e2d\u0e1b\u0e31\u0e08\u0e08\u0e38\u0e1a\u0e31\u0e19"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "\u0e2d\u0e2d\u0e01\u0e08\u0e32\u0e01\u0e01\u0e32\u0e23\u0e41\u0e2a\u0e14\u0e07\u0e20\u0e32\u0e1e\u0e0b\u0e49\u0e2d\u0e19\u0e20\u0e32\u0e1e"
                ],
                [
                    "FAST_FORWARD",
                    "\u0e01\u0e23\u0e2d\u0e44\u0e1b\u0e02\u0e49\u0e32\u0e07\u0e2b\u0e19\u0e49\u0e32"
                ],
                [
                    "FULL_SCREEN",
                    "\u0e40\u0e15\u0e47\u0e21\u0e2b\u0e19\u0e49\u0e32\u0e08\u0e2d"
                ],
                [
                    "LANGUAGE",
                    "\u0e20\u0e32\u0e29\u0e32"
                ],
                [
                    "LIVE",
                    "\u0e2a\u0e14"
                ],
                [
                    "LOOP",
                    "\u0e25\u0e39\u0e1b"
                ],
                [
                    "MORE_SETTINGS",
                    "\u0e01\u0e32\u0e23\u0e15\u0e31\u0e49\u0e07\u0e04\u0e48\u0e32\u0e40\u0e1e\u0e34\u0e48\u0e21\u0e40\u0e15\u0e34\u0e21"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "\u0e2b\u0e25\u0e32\u0e22\u0e20\u0e32\u0e29\u0e32"
                ],
                [
                    "MUTE",
                    "\u0e1b\u0e34\u0e14\u0e40\u0e2a\u0e35\u0e22\u0e07"
                ],
                [
                    "NOT_APPLICABLE",
                    "\u0e44\u0e21\u0e48\u0e40\u0e01\u0e35\u0e48\u0e22\u0e27\u0e02\u0e49\u0e2d\u0e07"
                ],
                [
                    "OFF",
                    "\u0e1b\u0e34\u0e14"
                ],
                [
                    "ON",
                    "\u0e40\u0e1b\u0e34\u0e14"
                ],
                [
                    "PAUSE",
                    "\u0e2b\u0e22\u0e38\u0e14\u0e0a\u0e31\u0e48\u0e27\u0e04\u0e23\u0e32\u0e27"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "\u0e01\u0e32\u0e23\u0e41\u0e2a\u0e14\u0e07\u0e20\u0e32\u0e1e\u0e0b\u0e49\u0e2d\u0e19\u0e20\u0e32\u0e1e"
                ],
                [
                    "PLAY",
                    "\u0e40\u0e25\u0e48\u0e19"
                ],
                [
                    "PLAYBACK_RATE",
                    "\u0e04\u0e27\u0e32\u0e21\u0e40\u0e23\u0e47\u0e27\u0e43\u0e19\u0e01\u0e32\u0e23\u0e40\u0e25\u0e48\u0e19"
                ],
                [
                    "QUALITY",
                    "\u0e04\u0e38\u0e13\u0e20\u0e32\u0e1e"
                ],
                [
                    "RECENTER_VR",
                    "\u0e08\u0e31\u0e14\u0e01\u0e36\u0e48\u0e07\u0e01\u0e25\u0e32\u0e07\u0e43\u0e2b\u0e21\u0e48"
                ],
                [
                    "REPLAY",
                    "\u0e40\u0e25\u0e48\u0e19\u0e0b\u0e49\u0e33"
                ],
                [
                    "RESOLUTION",
                    "\u0e04\u0e27\u0e32\u0e21\u0e25\u0e30\u0e40\u0e2d\u0e35\u0e22\u0e14"
                ],
                [
                    "REWIND",
                    "\u0e01\u0e23\u0e2d\u0e01\u0e25\u0e31\u0e1a"
                ],
                [
                    "SEEK",
                    "\u0e04\u0e49\u0e19\u0e2b\u0e32"
                ],
                [
                    "SKIP_AD",
                    "\u0e02\u0e49\u0e32\u0e21\u0e42\u0e06\u0e29\u0e13\u0e32"
                ],
                [
                    "SKIP_TO_LIVE",
                    "\u0e02\u0e49\u0e32\u0e21\u0e44\u0e1b\u0e17\u0e35\u0e48\u0e01\u0e32\u0e23\u0e16\u0e48\u0e32\u0e22\u0e17\u0e2d\u0e14\u0e2a\u0e14"
                ],
                [
                    "STATISTICS",
                    "\u0e2a\u0e16\u0e34\u0e15\u0e34"
                ],
                [
                    "SUBTITLE_FORCED",
                    "\u0e1a\u0e31\u0e07\u0e04\u0e31\u0e1a"
                ],
                [
                    "SURROUND",
                    "\u0e40\u0e0b\u0e2d\u0e23\u0e4c\u0e23\u0e32\u0e27\u0e14\u0e4c"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "\u0e40\u0e1b\u0e34\u0e14/\u0e1b\u0e34\u0e14\u0e1f\u0e35\u0e40\u0e08\u0e2d\u0e23\u0e4c\u0e2a\u0e32\u0e21\u0e21\u0e34\u0e15\u0e34"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "\u0e44\u0e21\u0e48\u0e01\u0e33\u0e2b\u0e19\u0e14"
                ],
                [
                    "UNMUTE",
                    "\u0e40\u0e1b\u0e34\u0e14\u0e40\u0e2a\u0e35\u0e22\u0e07"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "\u0e17\u0e35\u0e48\u0e44\u0e21\u0e48\u0e23\u0e39\u0e49\u0e08\u0e31\u0e01"
                ],
                [
                    "VOLUME",
                    "\u0e23\u0e30\u0e14\u0e31\u0e1a\u0e40\u0e2a\u0e35\u0e22\u0e07"
                ]
            ]));
            a.Xa("tr", new Map([
                [
                    "AD_DURATION",
                    "Reklam s\u00fcresi"
                ],
                [
                    "AD_PROGRESS",
                    "[AD_ON]/[NUM_ADS] reklam"
                ],
                [
                    "AD_STATISTICS",
                    "Reklam istatistikleri"
                ],
                [
                    "AD_TIME",
                    "Reklam: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "Otomatik"
                ],
                [
                    "BACK",
                    "Geri"
                ],
                [
                    "CAPTIONS",
                    "Altyaz\u0131lar"
                ],
                [
                    "CAST",
                    "Yay\u0131nla..."
                ],
                [
                    "CHAPTERS",
                    "B\u00f6l\u00fcmler"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "Video karesini kaydet"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "Mevcut videoyu d\u00f6ng\u00fcye al"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "Pencere i\u00e7inde Pencere moduna gir"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "Tam ekrandan \u00e7\u0131k"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "Mevcut videonun d\u00f6ng\u00fcs\u00fcn\u00fc durdur"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "Pencere \u0130\u00e7inde Pencereden \u00c7\u0131k"
                ],
                [
                    "FAST_FORWARD",
                    "\u0130leri sar"
                ],
                [
                    "FULL_SCREEN",
                    "Tam ekran"
                ],
                [
                    "LANGUAGE",
                    "Dil"
                ],
                [
                    "LIVE",
                    "Canl\u0131"
                ],
                [
                    "LOOP",
                    "D\u00f6ng\u00fc"
                ],
                [
                    "MORE_SETTINGS",
                    "Daha fazla ayar"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "Birden \u00e7ok dil"
                ],
                [
                    "MUTE",
                    "Sesi kapat"
                ],
                [
                    "NOT_APPLICABLE",
                    "Ge\u00e7erli de\u011fil"
                ],
                [
                    "OFF",
                    "Kapal\u0131"
                ],
                [
                    "ON",
                    "A\u00e7\u0131k"
                ],
                [
                    "PAUSE",
                    "Duraklat"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "Pencere \u0130\u00e7inde Pencere"
                ],
                [
                    "PLAY",
                    "Oynat"
                ],
                [
                    "PLAYBACK_RATE",
                    "\u00c7alma h\u0131z\u0131"
                ],
                [
                    "QUALITY",
                    "Kalite"
                ],
                [
                    "RECENTER_VR",
                    "Ortala"
                ],
                [
                    "REPLAY",
                    "Tekrar Oynat"
                ],
                [
                    "RESOLUTION",
                    "\u00c7\u00f6z\u00fcn\u00fcrl\u00fck"
                ],
                [
                    "REWIND",
                    "Geri sar"
                ],
                [
                    "SEEK",
                    "Ara"
                ],
                [
                    "SKIP_AD",
                    "Reklam\u0131 Atla"
                ],
                [
                    "SKIP_TO_LIVE",
                    "Canl\u0131 yay\u0131na atla"
                ],
                [
                    "STATISTICS",
                    "\u0130statistikler"
                ],
                [
                    "SUBTITLE_FORCED",
                    "Zorunlu"
                ],
                [
                    "SURROUND",
                    "Surround"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "Stereoskopik modu a\u00e7/kapat"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "Belirsiz"
                ],
                [
                    "UNMUTE",
                    "Sesi a\u00e7"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "Tan\u0131nmayan"
                ],
                [
                    "VOLUME",
                    "Ses"
                ]
            ]));
            a.Xa("zh", new Map([
                [
                    "AD_DURATION",
                    "\u5e7f\u544a\u6301\u7eed\u65f6\u95f4"
                ],
                [
                    "AD_PROGRESS",
                    "\u5e7f\u544a [AD_ON]/[NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "\u5e7f\u544a\u7edf\u8ba1\u4fe1\u606f"
                ],
                [
                    "AD_TIME",
                    "\u5e7f\u544a\uff1a[AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "\u81ea\u52a8"
                ],
                [
                    "BACK",
                    "\u8fd4\u56de"
                ],
                [
                    "CAPTIONS",
                    "\u5b57\u5e55"
                ],
                [
                    "CAST",
                    "\u6295\u653e\u2026"
                ],
                [
                    "CHAPTERS",
                    "\u7ae0\u8282"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "\u4fdd\u5b58\u89c6\u9891\u5e27"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "\u5faa\u73af\u64ad\u653e\u5f53\u524d\u89c6\u9891"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "\u8fdb\u5165\u201c\u753b\u4e2d\u753b\u201d\u6a21\u5f0f"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "\u9000\u51fa\u5168\u5c4f\u6a21\u5f0f"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "\u505c\u6b62\u5faa\u73af\u64ad\u653e\u5f53\u524d\u89c6\u9891"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "\u9000\u51fa\u201c\u753b\u4e2d\u753b\u201d\u6a21\u5f0f"
                ],
                [
                    "FAST_FORWARD",
                    "\u5feb\u8fdb"
                ],
                [
                    "FULL_SCREEN",
                    "\u5168\u5c4f"
                ],
                [
                    "LANGUAGE",
                    "\u8bed\u8a00"
                ],
                [
                    "LIVE",
                    "\u76f4\u64ad"
                ],
                [
                    "LOOP",
                    "\u5faa\u73af\u64ad\u653e"
                ],
                [
                    "MORE_SETTINGS",
                    "\u66f4\u591a\u8bbe\u7f6e"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "\u591a\u79cd\u8bed\u8a00"
                ],
                [
                    "MUTE",
                    "\u9759\u97f3"
                ],
                [
                    "NOT_APPLICABLE",
                    "\u4e0d\u9002\u7528"
                ],
                [
                    "OFF",
                    "\u5173\u95ed"
                ],
                [
                    "ON",
                    "\u5f00\u542f"
                ],
                [
                    "PAUSE",
                    "\u6682\u505c"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "\u753b\u4e2d\u753b"
                ],
                [
                    "PLAY",
                    "\u64ad\u653e"
                ],
                [
                    "PLAYBACK_RATE",
                    "\u64ad\u653e\u901f\u5ea6"
                ],
                [
                    "QUALITY",
                    "\u753b\u8d28"
                ],
                [
                    "RECENTER_VR",
                    "\u91cd\u65b0\u7f6e\u4e2d"
                ],
                [
                    "REPLAY",
                    "\u91cd\u653e"
                ],
                [
                    "RESOLUTION",
                    "\u5206\u8fa8\u7387"
                ],
                [
                    "REWIND",
                    "\u5feb\u9000"
                ],
                [
                    "SEEK",
                    "\u8fdb\u5ea6"
                ],
                [
                    "SKIP_AD",
                    "\u8df3\u8fc7\u5e7f\u544a"
                ],
                [
                    "SKIP_TO_LIVE",
                    "\u8df3\u81f3\u5f53\u524d\u76f4\u64ad"
                ],
                [
                    "STATISTICS",
                    "\u7edf\u8ba1\u4fe1\u606f"
                ],
                [
                    "SUBTITLE_FORCED",
                    "\u5df2\u5f3a\u5236\u663e\u793a"
                ],
                [
                    "SURROUND",
                    "\u73af\u7ed5\u58f0"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "\u5207\u6362\u7acb\u4f53\u58f0"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "\u672a\u786e\u5b9a"
                ],
                [
                    "UNMUTE",
                    "\u53d6\u6d88\u9759\u97f3"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "\u65e0\u6cd5\u8bc6\u522b"
                ],
                [
                    "VOLUME",
                    "\u97f3\u91cf"
                ]
            ]));
            a.Xa("zh-TW", new Map([
                [
                    "AD_DURATION",
                    "\u5ee3\u544a\u9577\u5ea6"
                ],
                [
                    "AD_PROGRESS",
                    "\u5ee3\u544a [AD_ON]/[NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "\u5ee3\u544a\u7d71\u8a08\u8cc7\u6599"
                ],
                [
                    "AD_TIME",
                    "\u5ee3\u544a\uff1a[AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "\u81ea\u52d5"
                ],
                [
                    "BACK",
                    "\u8fd4\u56de"
                ],
                [
                    "CAPTIONS",
                    "\u5b57\u5e55"
                ],
                [
                    "CAST",
                    "\u6295\u653e..."
                ],
                [
                    "CHAPTERS",
                    "\u7ae0\u7bc0"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "\u5132\u5b58\u5f71\u7247\u5f71\u683c"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "\u5faa\u74b0\u64ad\u653e\u76ee\u524d\u7684\u5f71\u7247"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "\u9032\u5165\u5b50\u6bcd\u756b\u9762"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "\u9000\u51fa\u5168\u87a2\u5e55\u6a21\u5f0f"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "\u505c\u6b62\u5faa\u74b0\u64ad\u653e\u76ee\u524d\u7684\u5f71\u7247"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "\u96e2\u958b\u5b50\u6bcd\u756b\u9762"
                ],
                [
                    "FAST_FORWARD",
                    "\u5feb\u8f49"
                ],
                [
                    "FULL_SCREEN",
                    "\u5168\u87a2\u5e55"
                ],
                [
                    "LANGUAGE",
                    "\u8a9e\u8a00"
                ],
                [
                    "LIVE",
                    "\u76f4\u64ad"
                ],
                [
                    "LOOP",
                    "\u5faa\u74b0\u64ad\u653e"
                ],
                [
                    "MORE_SETTINGS",
                    "\u986f\u793a\u66f4\u591a\u8a2d\u5b9a"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "\u591a\u7a2e\u8a9e\u8a00"
                ],
                [
                    "MUTE",
                    "\u975c\u97f3"
                ],
                [
                    "NOT_APPLICABLE",
                    "\u4e0d\u9069\u7528"
                ],
                [
                    "OFF",
                    "\u95dc\u9589"
                ],
                [
                    "ON",
                    "\u958b\u555f"
                ],
                [
                    "PAUSE",
                    "\u66ab\u505c"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "\u5b50\u6bcd\u756b\u9762"
                ],
                [
                    "PLAY",
                    "\u64ad\u653e"
                ],
                [
                    "PLAYBACK_RATE",
                    "\u64ad\u653e\u901f\u5ea6"
                ],
                [
                    "QUALITY",
                    "\u97f3\u8cea"
                ],
                [
                    "RECENTER_VR",
                    "\u91cd\u65b0\u7f6e\u4e2d"
                ],
                [
                    "REPLAY",
                    "\u91cd\u64ad"
                ],
                [
                    "RESOLUTION",
                    "\u89e3\u6790\u5ea6"
                ],
                [
                    "REWIND",
                    "\u5012\u8f49"
                ],
                [
                    "SEEK",
                    "\u641c\u5c0b"
                ],
                [
                    "SKIP_AD",
                    "\u7565\u904e\u5ee3\u544a"
                ],
                [
                    "SKIP_TO_LIVE",
                    "\u8df3\u81f3\u5f53\u524d\u76f4\u64ad"
                ],
                [
                    "STATISTICS",
                    "\u7d71\u8a08\u8cc7\u6599"
                ],
                [
                    "SUBTITLE_FORCED",
                    "\u5f37\u5236\u986f\u793a"
                ],
                [
                    "SURROUND",
                    "\u74b0\u5834\u97f3\u6548"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "\u5207\u63db\u7acb\u9ad4\u5f71\u50cf"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "\u4e0d\u660e"
                ],
                [
                    "UNMUTE",
                    "\u53d6\u6d88\u975c\u97f3"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "\u7121\u6cd5\u8fa8\u8b58"
                ],
                [
                    "VOLUME",
                    "\u97f3\u91cf"
                ]
            ]));
            a.Li(navigator.languages || []);
            return a;
        }
        S("shaka.ui.Controls", Z);
        Z.prototype.incrementRoll = Z.prototype.Ah;
        Z.prototype.incrementPitch = Z.prototype.yh;
        Z.prototype.incrementYaw = Z.prototype.Bh;
        Z.prototype.toggleStereoscopicMode = Z.prototype.$d;
        Z.prototype.setVRFieldOfView = Z.prototype.xm;
        Z.prototype.getVRFieldOfView = Z.prototype.vl;
        Z.prototype.getVRNorth = Z.prototype.wl;
        Z.prototype.isPlayingVR = Z.prototype.Xb;
        Z.prototype.canPlayVR = Z.prototype.Lg;
        Z.prototype.hideUI = Z.prototype.bj;
        Z.prototype.showUI = Z.prototype.zm;
        Z.prototype.isOpaque = Z.prototype.Ca;
        Z.prototype.hideAdUI = Z.prototype.aj;
        Z.prototype.showAdUI = Z.prototype.Rj;
        Z.prototype.togglePiP = Z.prototype.cd;
        Z.prototype.isPiPEnabled = Z.prototype.Md;
        Z.prototype.isPiPAllowed = Z.prototype.Ef;
        Z.prototype.toggleFullScreen = Z.prototype.og;
        Z.prototype.isFullScreenEnabled = Z.prototype.xb;
        Z.prototype.isFullScreenSupported = Z.prototype.ve;
        Z.prototype.hideSettingsMenus = Z.prototype.Wc;
        Z.prototype.anySettingsMenusAreOpen = Z.prototype.Lc;
        Z.prototype.setLastTouchEventTime = Z.prototype.Mj;
        Z.prototype.getDisplayTime = Z.prototype.ph;
        Z.prototype.isCastAllowed = Z.prototype.Dl;
        Z.prototype.setSeeking = Z.prototype.ii;
        Z.prototype.isSeeking = Z.prototype.Jl;
        Z.prototype.getConfig = Z.prototype.Hk;
        Z.prototype.getClientSideAdContainer = Z.prototype.Gk;
        Z.prototype.getServerSideAdContainer = Z.prototype.jl;
        Z.prototype.getControlsContainer = Z.prototype.Kk;
        Z.prototype.getLocalPlayer = Z.prototype.Tk;
        Z.prototype.getPlayer = Z.prototype.Wb;
        Z.prototype.getLocalVideo = Z.prototype.Uk;
        Z.prototype.getVideo = Z.prototype.Vc;
        Z.prototype.getVideoContainer = Z.prototype.yl;
        Z.prototype.getLocalization = Z.prototype.Vk;
        Z.prototype.getCastProxy = Z.prototype.Dk;
        Z.prototype.getAd = Z.prototype.getAd;
        Z.prototype.setEnabledNativeControls = Z.prototype.Lj;
        Z.prototype.setEnabledShakaControls = Z.prototype.di;
        Z.prototype.configure = Z.prototype.configure;
        Z.prototype.loadComplete = Z.prototype.Ml;
        Z.prototype.allowCast = Z.prototype.kk;
        Z.registerSeekBar = function(a) {
            AI = a;
        };
        Z.registerElement = iI;
        Z.prototype.destroy = Z.prototype.destroy;
        var jI = new Map, AI = new rH;
        function II(a, b) {
            function c() {
                return JI(d);
            }
            LG.call(this, a, b);
            var d = this;
            this.m = this.controls.g;
            this.l = this.controls.i;
            this.u = this.controls.l;
            this.j = [];
            KI(this);
            this.g = V("div");
            this.g.classList.add("shaka-overflow-menu");
            this.g.classList.add("shaka-no-propagation");
            this.g.classList.add("shaka-show-controls-on-mouse-over");
            this.g.classList.add("shaka-hidden");
            this.l.appendChild(this.g);
            LI(this);
            this.eventManager.o(this.localization, "locale-updated", function() {
                MI(d);
            });
            this.eventManager.o(this.localization, "locale-changed", function() {
                MI(d);
            });
            this.eventManager.o(this.adManager, "ad-started", function() {
                d.ad && d.ad.isLinear() && RG(d.h, !1);
            });
            this.eventManager.o(this.adManager, "ad-stopped", function() {
                RG(d.h, !0);
            });
            this.eventManager.o(this.controls, "submenuopen", function() {
                RG(d.g, !1);
            });
            this.eventManager.o(this.g, "touchstart", function(e) {
                d.controls.Mj(Date.now());
                e.stopPropagation();
            });
            this.eventManager.o(this.h, "click", function() {
                d.controls.Ca() && NI(d);
            });
            MI(this);
            this.ad && this.ad.isLinear() && RG(this.h, !1);
            this.i = null;
            window1.ResizeObserver ? (this.i = new ResizeObserver(c), this.i.observe(this.controls.l)) : this.eventManager.o(window1, "resize", c);
        }
        la(II, LG);
        II.prototype.release = function() {
            this.l = null;
            for(var a = u(this.j), b = a.next(); !b.done; b = a.next())b.value.release();
            this.j = [];
            this.i && (this.i.disconnect(), this.i = null);
            LG.prototype.release.call(this);
        };
        function OI(a, b) {
            PI.set(a, b);
        }
        function KI(a) {
            a.h = Lj();
            a.h.classList.add("shaka-overflow-menu-button");
            a.h.classList.add("shaka-no-propagation");
            a.h.classList.add("shaka-tooltip");
            new MG(a.h).use("M433-80q-27 0-46.5-18T363-142l-9-66q-13-5-24.5-12T307-235l-62 26q-25 11-50 2t-39-32l-47-82q-14-23-8-49t27-43l53-40q-1-7-1-13.5v-27q0-6.5 1-13.5l-53-40q-21-17-27-43t8-49l47-82q14-23 39-32t50 2l62 26q11-8 23-15t24-12l9-66q4-26 23.5-44t46.5-18h94q27 0 46.5 18t23.5 44l9 66q13 5 24.5 12t22.5 15l62-26q25-11 50-2t39 32l47 82q14 23 8 49t-27 43l-53 40q1 7 1 13.5v27q0 6.5-2 13.5l53 40q21 17 27 43t-8 49l-48 82q-14 23-39 32t-50-2l-60-26q-11 8-23 15t-24 12l-9 66q-4 26-23.5 44T527-80h-94Zm49-260q58 0 99-41t41-99q0-58-41-99t-99-41q-59 0-99.5 41T342-480q0 58 40.5 99t99.5 41Z");
            var b = V("span");
            b.classList.add("shaka-overflow-quality-mark");
            b.style.display = "none";
            a.h.appendChild(b);
            a.parent.appendChild(a.h);
        }
        function LI(a) {
            for(var b = u(a.m.overflowMenuButtons), c = b.next(); !c.done; c = b.next())c = c.value, PI.get(c) ? (c = PI.get(c), a.j.push(c.create(a.g, a.controls))) : ab("Unrecognized overflow menu element requested:", c);
        }
        function NI(a) {
            if (a.controls.Lc()) a.controls.Wc();
            else {
                RG(a.g, !0);
                YH(a.controls);
                var b = function(c) {
                    return c.classList.contains("shaka-hidden") == 0;
                };
                nb(a.g.childNodes, b) && ob(a.g.childNodes, b)[0].focus();
                JI(a);
            }
        }
        function MI(a) {
            a.h.ariaLabel = a.localization.resolve("MORE_SETTINGS");
        }
        function JI(a) {
            var b = a.g.getBoundingClientRect(), c = window1.getComputedStyle(a.g), d = parseFloat(c.paddingTop);
            c = parseFloat(c.paddingBottom);
            var e = a.u.getBoundingClientRect();
            a.g.style.maxHeight = b.bottom - e.top - d - c + "px";
        }
        S("shaka.ui.OverflowMenu", II);
        II.registerElement = OI;
        function QI() {}
        QI.prototype.create = function(a, b) {
            return new II(a, b);
        };
        iI("overflow_menu", new QI);
        var PI = new Map;
        function RI(a, b) {
            function c(e) {
                return d.i[e];
            }
            LG.call(this, a, b);
            var d = this;
            this.h = Lj();
            this.h.classList.add("shaka-ad-statistics-button");
            this.u = new MG(this.h, "M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Zm120 200q-17 0-28.5 11.5T280-520v200q0 17 11.5 28.5T320-280q17 0 28.5-11.5T360-320v-200q0-17-11.5-28.5T320-560Zm160-120q-17 0-28.5 11.5T440-640v320q0 17 11.5 28.5T480-280q17 0 28.5-11.5T520-320v-320q0-17-11.5-28.5T480-680Zm160 240q-17 0-28.5 11.5T600-400v80q0 17 11.5 28.5T640-280q17 0 28.5-11.5T680-320v-80q0-17-11.5-28.5T640-440Z");
            a = V("label");
            a.classList.add("shaka-overflow-button-label");
            a.classList.add("shaka-simple-overflow-button-label-inline");
            this.A = V("span");
            a.appendChild(this.A);
            this.l = V("span");
            this.l.classList.add("shaka-current-selection-span");
            a.appendChild(this.l);
            this.h.appendChild(a);
            this.parent.appendChild(this.h);
            this.g = V("div");
            this.g.classList.add("shaka-no-propagation");
            this.g.classList.add("shaka-show-controls-on-mouse-over");
            this.g.classList.add("shaka-ad-statistics-container");
            this.g.classList.add("shaka-hidden");
            this.controls.i.appendChild(this.g);
            this.D = [];
            this.i = this.adManager.getStats();
            RG(this.h, this.i.started > 0);
            this.m = new Map;
            this.C = (new Map).set("loadTimes", function(e) {
                var f = 0;
                e = u(d.i[e]);
                for(var g = e.next(); !g.done; g = e.next())f += parseFloat(g.value);
                return f;
            }).set("averageLoadTime", c).set("started", c).set("overlayAds", c).set("playedCompletely", c).set("skipped", c).set("errors", c);
            this.j = new Bf(function() {
                d.i = d.adManager.getStats();
                for(var e = u(d.D), f = e.next(); !f.done; f = e.next())f = f.value, d.m.get(f).textContent = d.C.get(f)(f);
            });
            SI(this);
            TI(this);
            this.eventManager.o(this.localization, "locale-updated", function() {
                SI(d);
            });
            this.eventManager.o(this.localization, "locale-changed", function() {
                SI(d);
            });
            this.eventManager.o(this.h, "click", function() {
                d.controls.Ca() && (UI(d), SI(d));
            });
            this.eventManager.o(this.player, "loading", function() {
                RG(d.h, !1);
            });
            this.eventManager.o(this.adManager, "ad-started", function() {
                RG(d.h, !0);
            });
        }
        la(RI, LG);
        function UI(a) {
            a.g.classList.contains("shaka-hidden") ? (a.u.use("M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm120-440q-17 0-28.5 11.5T280-520v200q0 17 11.5 28.5T320-280q17 0 28.5-11.5T360-320v-200q0-17-11.5-28.5T320-560Zm160-120q-17 0-28.5 11.5T440-640v320q0 17 11.5 28.5T480-280q17 0 28.5-11.5T520-320v-320q0-17-11.5-28.5T480-680Zm160 240q-17 0-28.5 11.5T600-400v80q0 17 11.5 28.5T640-280q17 0 28.5-11.5T680-320v-80q0-17-11.5-28.5T640-440Z"), a.j.wa(.1), RG(a.g, !0)) : (a.u.use("M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Zm120 200q-17 0-28.5 11.5T280-520v200q0 17 11.5 28.5T320-280q17 0 28.5-11.5T360-320v-200q0-17-11.5-28.5T320-560Zm160-120q-17 0-28.5 11.5T440-640v320q0 17 11.5 28.5T480-280q17 0 28.5-11.5T520-320v-320q0-17-11.5-28.5T480-680Zm160 240q-17 0-28.5 11.5T600-400v80q0 17 11.5 28.5T640-280q17 0 28.5-11.5T680-320v-80q0-17-11.5-28.5T640-440Z"), a.j.stop(), RG(a.g, !1));
        }
        function SI(a) {
            a.A.textContent = a.localization.resolve("AD_STATISTICS");
            a.h.ariaLabel = a.localization.resolve("AD_STATISTICS");
            a.l.textContent = a.localization.resolve(a.g.classList.contains("shaka-hidden") ? "OFF" : "ON");
        }
        function VI(a, b) {
            var c = V("div"), d = V("label");
            d.textContent = b + ":";
            c.appendChild(d);
            d = V("span");
            d.textContent = a.C.get(b)(b);
            c.appendChild(d);
            a.m.set(b, d);
            return c;
        }
        function TI(a) {
            var b = V("div");
            b.classList.add("shaka-no-propagation");
            b.classList.add("shaka-statistics-close");
            var c = new MG(b, "M480-424 284-228q-11 11-28 11t-28-11q-11-11-11-28t11-28l196-196-196-196q-11-11-11-28t11-28q11-11 28-11t28 11l196 196 196-196q11-11 28-11t28 11q11 11 11 28t-11 28L536-480l196 196q11 11 11 28t-11 28q-11 11-28 11t-28-11L480-424Z").g;
            c.classList.add("material-icons", "notranslate");
            a.g.appendChild(b);
            a.eventManager.o(c, "click", function() {
                UI(a);
            });
            b = u(a.controls.g.adStatisticsList);
            for(c = b.next(); !c.done; c = b.next())c = c.value, c in a.i ? (a.g.appendChild(VI(a, c)), a.D.push(c)) : ab("Unrecognized ad statistic element:", c);
        }
        RI.prototype.release = function() {
            this.j.stop();
            this.j = null;
            LG.prototype.release.call(this);
        };
        S("shaka.ui.AdStatisticsButton", RI);
        function WI() {}
        WI.prototype.create = function(a, b) {
            return new RI(a, b);
        };
        OI("ad_statistics", new WI);
        WG("ad_statistics", new WI);
        function XI(a, b) {
            LG.call(this, a, b);
            var c = this;
            this.g = Lj();
            this.g.classList.add("shaka-airplay-button");
            this.g.classList.add("shaka-tooltip");
            this.g.ariaPressed = "false";
            new MG(this.g).use("M312-120q-14 0-22-9.5t-8-20.5q0-5 2-10.5t7-10.5l161-161q6-6 13-9t15-3q8 0 15 3t13 9l161 161q5 5 7 10.5t2 10.5q0 11-8 20.5t-22 9.5H312ZM160-840h640q33 0 56.5 23.5T880-760v480q0 33-23.5 56.5T800-200h-7q-16 0-30.5-6T737-223L565-395q-17-17-39-26t-46-9q-24 0-46 9t-39 26L223-223q-11 11-25.5 17t-30.5 6h-7q-33 0-56.5-23.5T80-280v-480q0-33 23.5-56.5T160-840Z");
            window1.WebKitPlaybackTargetAvailabilityEvent || this.g.classList.add("shaka-hidden");
            a = V("label");
            a.classList.add("shaka-overflow-button-label");
            a.classList.add("shaka-overflow-menu-only");
            this.i = V("span");
            a.appendChild(this.i);
            this.h = V("span");
            this.h.classList.add("shaka-current-selection-span");
            a.appendChild(this.h);
            this.g.appendChild(a);
            this.parent.appendChild(this.g);
            YI(this);
            ZI(this);
            this.eventManager.o(this.localization, "locale-updated", function() {
                YI(c);
            });
            this.eventManager.o(this.localization, "locale-changed", function() {
                YI(c);
            });
            this.eventManager.o(this.g, "click", function() {
                c.controls.Ca() && c.controls.Vc().webkitShowPlaybackTargetPicker();
            });
            a = this.controls.Vc();
            this.eventManager.o(a, "webkitplaybacktargetavailabilitychanged", function(d) {
                var e = c.player.l == zr;
                RG(c.g, d.availability == "available" && e);
            });
            this.eventManager.o(a, "webkitcurrentplaybacktargetiswirelesschanged", function() {
                ZI(c);
            });
        }
        la(XI, LG);
        function ZI(a) {
            var b = a.controls.Vc();
            a.g.ariaPressed = b && b.webkitCurrentPlaybackTargetIsWireless ? "true" : "false";
        }
        function YI(a) {
            a.g.ariaLabel = a.localization.resolve("AIRPLAY");
            a.i.textContent = a.localization.resolve("AIRPLAY");
        }
        S("shaka.ui.AirPlayButton", XI);
        function $I() {}
        $I.prototype.create = function(a, b) {
            return new XI(a, b);
        };
        OI("airplay", new $I);
        iI("airplay", new $I);
        function aJ(a, b) {
            LG.call(this, a, b);
            var c = this;
            this.g = document.createElement("canvas");
            this.g.style.position = "absolute";
            this.g.style.top = "0";
            this.g.style.left = "0";
            this.g.style.pointerEvents = "none";
            this.parent.appendChild(this.g);
            bJ(this);
            this.i = this.h = null;
            window1.ResizeObserver ? (this.i = new ResizeObserver(function() {
                return bJ(c);
            }), this.i.observe(this.parent)) : window1.addEventListener("resize", function() {
                return bJ(c);
            });
        }
        la(aJ, LG);
        function cJ(a) {
            return (a = a.g.getContext("2d")) ? a : null;
        }
        function bJ(a) {
            a.g.width = a.parent.offsetWidth;
            a.g.height = a.parent.offsetHeight;
        }
        aJ.prototype.ig = function(a, b) {
            a = {
                type: "static",
                text: a,
                position: "top-right",
                color: "rgba(255, 255, 255, 0.7)",
                size: 20,
                alpha: .7,
                interval: 2E3,
                skip: 500,
                displayDuration: 2E3,
                transitionDuration: .5
            };
            b = Object.assign({}, a, b || a);
            if (b.type === "static") {
                if (a = cJ(this)) {
                    a.clearRect(0, 0, this.g.width, this.g.height);
                    a.globalAlpha = b.alpha;
                    a.fillStyle = b.color;
                    a.font = b.size + "px Arial";
                    var c = a.measureText(b.text);
                    switch(b.position){
                        case "top-left":
                            c = 20;
                            var d = b.size + 20;
                            break;
                        case "top-right":
                            c = this.g.width - c.width - 20;
                            d = b.size + 20;
                            break;
                        case "bottom-left":
                            c = 20;
                            d = this.g.height - 20;
                            break;
                        case "bottom-right":
                            c = this.g.width - c.width - 20;
                            d = this.g.height - 20;
                            break;
                        default:
                            c = (this.g.width - c.width) / 2, d = (this.g.height + b.size) / 2;
                    }
                    a.fillText(b.text, c, d);
                }
            } else b.type === "dynamic" && dJ(this, b);
        };
        function dJ(a, b) {
            function c() {
                if (a.h) {
                    e.clearRect(0, 0, a.g.width, a.g.height);
                    switch(h){
                        case "fadeIn":
                            g = Math.min(b.alpha, g + l);
                            g >= b.alpha && (h = "display");
                            break;
                        case "display":
                            --k <= 0 && (h = "fadeOut");
                            break;
                        case "fadeOut":
                            g = Math.max(0, g - l), g <= 0 && (h = "transition", f = d(), k = Math.round(b.displayDuration * 60), h = "fadeIn");
                    }
                    g > 0 && (e.globalAlpha = g, e.fillStyle = b.color, e.font = b.size + "px Arial", e.fillText(b.text, f.left, f.top));
                    a.h && (a.h = requestAnimationFrame(c));
                }
            }
            function d() {
                e.font = b.size + "px Arial";
                var n = e.measureText(b.text).width, q = b.size;
                n = [
                    {
                        left: 20,
                        top: q + 20
                    },
                    {
                        left: a.g.width - n - 20,
                        top: q + 20
                    },
                    {
                        left: 20,
                        top: a.g.height - 20
                    },
                    {
                        left: a.g.width - n - 20,
                        top: a.g.height - 20
                    },
                    {
                        left: (a.g.width - n) / 2,
                        top: (a.g.height + q) / 2
                    }
                ];
                q = n[m];
                m = (m + 1) % n.length;
                return q;
            }
            var e = a.g.getContext("2d"), f = {
                left: 0,
                top: 0
            }, g = 0, h = "fadeIn", k = Math.round(b.displayDuration * 60), l = 1 / (Math.round(b.transitionDuration * 60) / 2), m = 0;
            f = d();
            a.h = requestAnimationFrame(c);
        }
        aJ.prototype.$f = function() {
            this.h && (cancelAnimationFrame(this.h), this.h = null);
            var a = cJ(this);
            a && a.clearRect(0, 0, this.g.width, this.g.height);
        };
        aJ.prototype.release = function() {
            var a = this;
            this.g && this.g.parentNode && this.g.parentNode.removeChild(this.g);
            this.i ? (this.i.disconnect(), this.i = null) : window1.removeEventListener("resize", function() {
                return bJ(a);
            });
            LG.prototype.release.call(this);
        };
        S("shaka.ui.Watermark", aJ);
        aJ.prototype.removeWatermark = aJ.prototype.$f;
        aJ.prototype.setTextWatermark = aJ.prototype.ig;
        function eJ(a, b, c, d) {
            d = d === void 0 ? null : d;
            this.j = a;
            this.l = b;
            this.h = fJ(this);
            var e = "", f = !1;
            b.dataset && b.dataset.shakaPlayerCastReceiverId ? (f = b.dataset, e = f.shakaPlayerCastReceiverId, f = f.shakaPlayerCastAndroidReceiverCompatible === "true") : c.dataset && c.dataset.shakaPlayerCastReceiverId && (f = c.dataset, e = f.shakaPlayerCastReceiverId, f = f.shakaPlayerCastAndroidReceiverCompatible === "true");
            e.length && (this.h.castReceiverAppId = e, this.h.castAndroidReceiverCompatible = f);
            b.dataset.shakaPlayerContainer = "";
            b.ui = this;
            this.Fh() && b.classList.add("shaka-mobile");
            this.g = new Z(a, b, c, d, this.h);
            c.controls || a.ji(b);
            b.ui = this;
            c.ui = this;
            this.i = null;
        }
        p = eJ.prototype;
        p.destroy = function(a) {
            a = a === void 0 ? !1 : a;
            var b = this;
            return Q(function(c) {
                if (c.g == 1) return b.g ? F(c, b.g.destroy(a), 2) : c.B(2);
                if (c.g != 4) return b.g = null, b.j ? F(c, b.j.destroy(), 4) : c.B(4);
                b.j = null;
                b.i = null;
                H(c);
            });
        };
        p.Fh = function() {
            return Rb().Ka() == "MOBILE";
        };
        p.Gh = function() {
            return Rb().Ka() == "TV";
        };
        p.getConfiguration = function() {
            var a = fJ(this);
            zn(a, this.h, fJ(this), {}, "");
            return a;
        };
        p.configure = function(a, b) {
            arguments.length == 2 && typeof a == "string" && (a = An(a, b));
            var c = Object.assign({}, this.h);
            zn(c, a, fJ(this), {}, "");
            var d = Cn(c, this.h);
            if (Object.keys(d).length && (this.h = c, this.g.configure(this.h), this.g.dispatchEvent(new T("uiupdated")), (c = this.h.castSenderUrl) && this.h.castReceiverAppId && window1.chrome && !chrome.cast && !this.Gh())) {
                d = !1;
                for(var e = u(document.getElementsByTagName("script")), f = e.next(); !f.done; f = e.next())if (f.value.src === c) {
                    d = !0;
                    break;
                }
                d || (d = document.createElement("script"), d.src = c, d.defer = !0, document.head.appendChild(d));
            }
        };
        p.Jk = function() {
            return this.g;
        };
        p.vm = function(a) {
            this.g.di(a);
        };
        p.ig = function(a, b) {
            a && !this.i && this.l && this.g && (this.i = new aJ(this.l, this.g));
            this.i && this.i.ig(a, b);
        };
        p.$f = function() {
            this.i && this.i.$f();
        };
        function fJ(a) {
            var b = "play_pause skip_previous skip_next mute volume time_and_duration spacer overflow_menu".split(" ");
            window1.chrome && b.push("cast");
            "remote" in HTMLMediaElement.prototype ? b.push("remote") : window1.WebKitPlaybackTargetAvailabilityEvent && b.push("airplay");
            b.push("fullscreen");
            b = {
                controlPanelElements: b,
                overflowMenuButtons: "captions quality language chapter picture_in_picture playback_rate recenter_vr toggle_stereoscopic".split(" "),
                statisticsList: "width height currentCodecs corruptedFrames decodedFrames droppedFrames drmTimeSeconds licenseTime liveLatency loadLatency bufferingTime manifestTimeSeconds estimatedBandwidth streamBandwidth maxSegmentDuration pauseTime playTime completionPercent manifestSizeBytes bytesDownloaded nonFatalErrorCount manifestPeriodCount manifestGapCount".split(" "),
                adStatisticsList: "loadTimes averageLoadTime started overlayAds playedCompletely skipped errors".split(" "),
                contextMenuElements: [
                    "loop",
                    "picture_in_picture",
                    "save_video_frame",
                    "statistics",
                    "ad_statistics"
                ],
                playbackRates: [
                    .5,
                    .75,
                    1,
                    1.25,
                    1.5,
                    1.75,
                    2
                ],
                fastForwardRates: [
                    2,
                    4,
                    8,
                    1
                ],
                rewindRates: [
                    -1,
                    -2,
                    -4,
                    -8
                ],
                addSeekBar: !0,
                addBigPlayButton: !1,
                customContextMenu: !1,
                castReceiverAppId: "",
                castAndroidReceiverCompatible: !1,
                clearBufferOnQualityChange: !0,
                showUnbufferedStart: !1,
                seekBarColors: {
                    base: "rgba(255, 255, 255, 0.3)",
                    buffered: "rgba(255, 255, 255, 0.54)",
                    played: "rgb(255, 255, 255)",
                    adBreaks: "rgb(255, 204, 0)"
                },
                volumeBarColors: {
                    base: "rgba(255, 255, 255, 0.54)",
                    level: "rgb(255, 255, 255)"
                },
                qualityMarks: {
                    720: "",
                    1080: "HD",
                    1440: "2K",
                    2160: "4K",
                    4320: "8K"
                },
                trackLabelFormat: gJ,
                textTrackLabelFormat: gJ,
                fadeDelay: 0,
                closeMenusDelay: 2,
                doubleClickForFullscreen: !0,
                singleClickForPlayAndPause: !0,
                enableKeyboardPlaybackControls: !0,
                enableFullscreenOnRotation: !1,
                forceLandscapeOnFullscreen: !1,
                enableTooltips: !0,
                keyboardSeekDistance: 5,
                keyboardLargeSeekDistance: 60,
                fullScreenElement: a.l,
                preferDocumentPictureInPicture: !0,
                showAudioChannelCountVariants: !0,
                seekOnTaps: !1,
                tapSeekDistance: 10,
                refreshTickInSeconds: .125,
                displayInVrMode: !1,
                defaultVrProjectionMode: "equirectangular",
                setupMediaSession: !0,
                preferVideoFullScreenInVisionOS: !0,
                showAudioCodec: !0,
                showVideoCodec: !0,
                castSenderUrl: "https://www.gstatic.com/cv/js/sender/v1/cast_sender.js",
                enableKeyboardPlaybackControlsInWindow: !1,
                alwaysShowVolumeBar: !1
            };
            if (a.Fh()) {
                b.addBigPlayButton = !0;
                b.singleClickForPlayAndPause = !1;
                b.seekOnTaps = !0;
                b.enableTooltips = !1;
                b.doubleClickForFullscreen = !1;
                a = Rb();
                b.enableFullscreenOnRotation = a.Ja() !== "WEBKIT";
                b.forceLandscapeOnFullscreen = !0;
                var c = [
                    "play_pause",
                    "skip_previous",
                    "skip_next",
                    "volume"
                ];
                b.controlPanelElements = b.controlPanelElements.filter(function(e) {
                    return !c.includes(e);
                });
                b.overflowMenuButtons = b.overflowMenuButtons.filter(function(e) {
                    return !c.includes(e);
                });
                b.contextMenuElements = b.contextMenuElements.filter(function(e) {
                    return !c.includes(e);
                });
            } else if (a.Gh()) {
                b.addBigPlayButton = !0;
                b.singleClickForPlayAndPause = !1;
                b.enableTooltips = !1;
                b.doubleClickForFullscreen = !1;
                var d = "play_pause cast remote airplay volume save_video_frame".split(" ");
                b.controlPanelElements = b.controlPanelElements.filter(function(e) {
                    return !d.includes(e);
                });
                b.overflowMenuButtons = b.overflowMenuButtons.filter(function(e) {
                    return !d.includes(e);
                });
                b.contextMenuElements = b.contextMenuElements.filter(function(e) {
                    return !d.includes(e);
                });
            }
            return b;
        }
        function hJ() {
            var a, b, c, d, e, f, g, h, k, l, m, n, q, r, t, w, v, z, y, A, C, E;
            return Q(function(D) {
                switch(D.g){
                    case 1:
                        $C();
                        if (!Wq()) return iJ("shaka-ui-load-failed", jJ), D.return();
                        a = document.querySelectorAll("[data-shaka-player-container]");
                        b = document.querySelectorAll("[data-shaka-player]");
                        c = document.querySelectorAll("[data-shaka-player-canvas]");
                        d = document.querySelectorAll("[data-shaka-player-vr-canvas]");
                        if (!b.length && !a.length) {
                            D.B(2);
                            break;
                        }
                        if (b.length && !a.length) {
                            e = u(b);
                            for(f = e.next(); !f.done; f = e.next())g = f.value, g.ui || (h = document.createElement("div"), k = g.parentElement, k.replaceChild(h, g), h.appendChild(g), l = kJ(h, c, d), m = l.ij, n = l.gk, lJ(h, g, m, n));
                            D.B(2);
                            break;
                        }
                        q = u(a);
                        r = q.next();
                    case 4:
                        if (r.done) {
                            D.B(2);
                            break;
                        }
                        t = r.value;
                        if (t.ui) {
                            D.B(5);
                            break;
                        }
                        w = null;
                        v = u(b);
                        for(z = v.next(); !z.done; z = v.next())if (y = z.value, y.parentElement == t) {
                            w = y;
                            break;
                        }
                        w || (w = document.createElement("video"), w.setAttribute("playsinline", ""), t.appendChild(w));
                        A = kJ(t, c, d);
                        C = A.ij;
                        E = A.gk;
                        ra(D, 7);
                        return F(D, lJ(t, w, C, E), 9);
                    case 9:
                        ta(D, 5);
                        break;
                    case 7:
                        return ua(D), iJ("shaka-ui-load-failed", mJ), D.return();
                    case 5:
                        r = q.next();
                        D.B(4);
                        break;
                    case 2:
                        iJ("shaka-ui-loaded"), H(D);
                }
            });
        }
        function iJ(a, b) {
            var c = null;
            b != void 0 && (c = {
                reasonCode: b
            });
            a = new CustomEvent(a, {
                detail: c
            });
            document.dispatchEvent(a);
        }
        function lJ(a, b, c, d) {
            var e, f, g, h, k, l, m, n, q, r;
            return Q(function(t) {
                switch(t.g){
                    case 1:
                        e = new X;
                        f = new eJ(e, a, b, d ? d : null);
                        e.Gi(c);
                        b.controls && f.g.Lj(!0);
                        g = [];
                        if (h = b.getAttribute("src")) g.push(h), b.removeAttribute("src");
                        k = u(b.getElementsByTagName("source"));
                        for(l = k.next(); !l.done; l = k.next())m = l.value, g.push(m.src), b.removeChild(m);
                        return F(t, e.cc(b), 2);
                    case 2:
                        n = u(g), q = n.next();
                    case 3:
                        if (q.done) {
                            t.B(0);
                            break;
                        }
                        r = q.value;
                        ra(t, 6);
                        return F(t, f.g.Wb().load(r), 8);
                    case 8:
                        t.B(0);
                        break;
                    case 6:
                        ua(t);
                    case 4:
                        q = n.next(), t.B(3);
                }
            });
        }
        function kJ(a, b, c) {
            var d = null;
            b = u(b);
            for(var e = b.next(); !e.done; e = b.next())if (e = e.value, e.parentElement == a) {
                d = e;
                break;
            }
            d || (d = document.createElement("canvas"), d.classList.add("shaka-canvas-container"), a.appendChild(d));
            b = null;
            c = u(c);
            for(e = c.next(); !e.done; e = c.next())if (e = e.value, e.parentElement == a) {
                b = e;
                break;
            }
            return {
                ij: d,
                gk: b
            };
        }
        S("shaka.ui.Overlay", eJ);
        eJ.prototype.removeWatermark = eJ.prototype.$f;
        eJ.prototype.setTextWatermark = eJ.prototype.ig;
        eJ.prototype.setEnabled = eJ.prototype.vm;
        eJ.prototype.getControls = eJ.prototype.Jk;
        eJ.prototype.configure = eJ.prototype.configure;
        eJ.prototype.getConfiguration = eJ.prototype.getConfiguration;
        eJ.prototype.isSmartTV = eJ.prototype.Gh;
        eJ.prototype.isMobile = eJ.prototype.Fh;
        eJ.prototype.destroy = eJ.prototype.destroy;
        var gJ = 0;
        eJ.TrackLabelFormat = {
            LANGUAGE: gJ,
            ROLE: 1,
            LANGUAGE_ROLE: 2,
            LABEL: 3
        };
        var jJ = 0, mJ = 1;
        eJ.FailReasonCode = {
            NO_BROWSER_SUPPORT: jJ,
            PLAYER_FAILED_TO_LOAD: mJ
        };
        document.readyState == "complete" ? Q(function(a) {
            if (a.g == 1) return F(a, Promise.resolve(), 2);
            hJ();
            H(a);
        }) : window1.addEventListener("load", hJ);
        function nJ(a) {
            function b(d) {
                return {
                    codecs: d.codecs,
                    channelCount: d.channelCount,
                    language: d.language,
                    roles: d.roles,
                    spatialAudio: d.spatialAudio
                };
            }
            var c = b(a[0]);
            return a.every(function(d) {
                return JSON.stringify(b(d)) === JSON.stringify(c);
            });
        }
        function oJ(a, b, c, d, e, f, g, h) {
            function k(J) {
                var L = "";
                J == "aac" ? L = "AAC" : J === "ac-3" ? L = "Dolby" : J === "ec-3" ? L = "DD+" : J === "ac-4" ? L = "Dolby AC-4" : J === "opus" ? L = "Opus" : J === "flac" && (L = "fLaC");
                return L ? " " + L : L;
            }
            function l(J) {
                var L = "";
                J >= 5 && (L = " " + e.resolve("SURROUND"));
                return L;
            }
            function m(J, L, K, N, P, O) {
                L = [
                    J,
                    L,
                    O
                ];
                g && N != null && L.push(N);
                h && n(J) && P && L.push(P);
                K && f == 3 && L.push(K);
                return L.join(": ");
            }
            function n(J) {
                return r.has(J) && r.get(J).size > 1;
            }
            var q = a.find(function(J) {
                return J.active == 1;
            });
            a.length > 1 && a[0].label && f != 3 && nJ(a) && (f = 3);
            for(var r = new Map, t = u(a), w = t.next(); !w.done; w = t.next())w = w.value, w.codecs && (r.has(w.language) || r.set(w.language, new Set), r.get(w.language).add(jf(w.codecs)));
            t = NG(b);
            Pj(b);
            b.appendChild(t);
            t = new Set;
            q = q ? m(q.language, q.roles.join(", "), q.label, q.channelsCount, q.codecs && jf(q.codecs), q.spatialAudio) : "";
            a = u(a);
            var v = a.next();
            for(w = {}; !v.done; w = {
                bc: void 0
            }, v = a.next()){
                w.bc = v.value;
                v = w.bc.language;
                var z = w.bc.roles.join(", "), y = w.bc.label, A = w.bc.channelsCount, C = w.bc.codecs && jf(w.bc.codecs), E = w.bc.spatialAudio, D = m(v, z, y, A, C, E);
                if (!t.has(D)) {
                    t.add(D);
                    var B = Lj();
                    B.addEventListener("click", function(J) {
                        return function() {
                            c(J.bc);
                        };
                    }(w));
                    var G = V("span");
                    B.appendChild(G);
                    G.textContent = pJ(v, e);
                    var I = "";
                    h && g && E && (C == "ec-3" || C == "ac-4") ? I += " Dolby Atmos" : (h && n(v) && (I += k(C)), g && (I += l(A)));
                    switch(f){
                        case gJ:
                            G.textContent += I;
                            break;
                        case 1:
                            G.textContent += I;
                            z ? G.textContent = z : (ab("Track #" + JSON.stringify(w.bc) + " does not have a role, but the UI is configured to only show role."), G.textContent = "?");
                            break;
                        case 2:
                            G.textContent += I;
                            z && (G.textContent += ": " + z);
                            break;
                        case 3:
                            y ? G.textContent = y : (ab("Track #" + JSON.stringify(w.bc) + " does not have a label, but the UI is configured to only show labels."), G.textContent = "?");
                    }
                    D == q && (B.appendChild(QG()), G.classList.add("shaka-chosen-item"), B.ariaSelected = "true", d.textContent = G.textContent);
                    b.appendChild(B);
                }
            }
        }
        function qJ(a, b, c, d, e, f, g) {
            function h(A, C, E) {
                A = [
                    A,
                    C
                ];
                E && g == 3 && A.push(E);
                return A.join(": ");
            }
            var k = a.find(function(A) {
                return A.active == 1;
            }), l = NG(b);
            Pj(b);
            b.appendChild(l);
            l = new Set;
            k = k ? h(k.language, k.roles.join(", "), k.label) : "";
            a = u(a);
            for(var m = a.next(), n = {}; !m.done; n = {
                dd: void 0
            }, m = a.next()){
                n.dd = m.value;
                m = n.dd.language;
                var q = n.dd.forced, r = f.resolve("SUBTITLE_FORCED"), t = n.dd.roles.join(", "), w = n.dd.label, v = h(m, t, w);
                if (!l.has(v)) {
                    l.add(v);
                    var z = Lj();
                    z.addEventListener("click", function(A) {
                        return function() {
                            c(A.dd);
                        };
                    }(n));
                    var y = V("span");
                    z.appendChild(y);
                    y.textContent = pJ(m, f);
                    switch(g){
                        case gJ:
                            q && (y.textContent += " (" + r + ")");
                            break;
                        case 1:
                            t ? y.textContent = t : (ab("Track #" + n.dd.id + " does not have a role, but the UI is configured to only show role."), y.textContent = "?");
                            q && (y.textContent += " (" + r + ")");
                            break;
                        case 2:
                            t && (y.textContent += ": " + t);
                            q && (y.textContent += " (" + r + ")");
                            break;
                        case 3:
                            w ? y.textContent = w : (ab("Track #" + n.dd.id + " does not have a label, but the UI is configured to only show labels."), y.textContent = "?");
                    }
                    d && v == k && (z.appendChild(QG()), y.classList.add("shaka-chosen-item"), z.ariaSelected = "true", e.textContent = y.textContent);
                    b.appendChild(z);
                }
            }
        }
        function pJ(a, b) {
            if (!a && !b) return "";
            switch(a){
                case "mul":
                    return b.resolve("MULTIPLE_LANGUAGES");
                case "und":
                    return b.resolve("UNDETERMINED_LANGUAGE");
                case "zxx":
                    return b.resolve("NOT_APPLICABLE");
            }
            var c = Dc(a);
            return a in Lo ? Lo[a] : c in Lo ? Lo[c] + " (" + a + ")" : b.resolve("UNRECOGNIZED_LANGUAGE") + " (" + a + ")";
        }
        function rJ(a, b, c) {
            function d() {
                return sJ(e);
            }
            LG.call(this, a, b);
            var e = this;
            this.m = this.controls.l;
            tJ(this, c);
            uJ(this);
            vJ(this);
            this.eventManager.o(this.button, "click", function() {
                e.controls.Ca() && (e.menu.classList.contains("shaka-hidden") ? (e.controls.dispatchEvent(new T("submenuopen")), RG(e.menu, !0), PG(e.menu), sJ(e)) : RG(e.menu, !1));
            });
            this.j = null;
            window1.ResizeObserver ? (this.j = new ResizeObserver(d), this.j.observe(this.controls.l)) : this.eventManager.o(window1, "resize", d);
        }
        la(rJ, LG);
        rJ.prototype.release = function() {
            this.j && (this.j.disconnect(), this.j = null);
            LG.prototype.release.call(this);
        };
        function tJ(a, b) {
            a.button = Lj();
            a.button.classList.add("shaka-overflow-button");
            a.icon = new MG(a.button, b);
            b = V("label");
            b.classList.add("shaka-overflow-button-label");
            b.classList.add("shaka-overflow-menu-only");
            b.classList.add("shaka-overflow-button-label-inline");
            a.nameSpan = V("span");
            b.appendChild(a.nameSpan);
            a.currentSelection = V("span");
            a.currentSelection.classList.add("shaka-current-selection-span");
            b.appendChild(a.currentSelection);
            a.button.appendChild(b);
            a.parent.appendChild(a.button);
        }
        function uJ(a) {
            a.menu = V("div");
            a.menu.classList.add("shaka-no-propagation");
            a.menu.classList.add("shaka-show-controls-on-mouse-over");
            a.menu.classList.add("shaka-settings-menu");
            a.menu.classList.add("shaka-hidden");
            a.backButton = Lj();
            a.backButton.classList.add("shaka-back-to-overflow-button");
            a.menu.appendChild(a.backButton);
            a.eventManager.o(a.backButton, "click", function() {
                a.controls.Wc();
            });
            a.u = new MG(a.backButton, "M480-424 284-228q-11 11-28 11t-28-11q-11-11-11-28t11-28l196-196-196-196q-11-11-11-28t11-28q11-11 28-11t28 11l196 196 196-196q11-11 28-11t28 11q11 11 11 28t-11 28L536-480l196 196q11 11 11 28t-11 28q-11 11-28 11t-28-11L480-424Z");
            a.backSpan = V("span");
            a.backButton.appendChild(a.backSpan);
            a.controls.i.appendChild(a.menu);
        }
        function vJ(a) {
            a.parent.classList.contains("shaka-overflow-menu") && (a.u.use("m432-480 156 156q11 11 11 28t-11 28q-11 11-28 11t-28-11L348-452q-6-6-8.5-13t-2.5-15q0-8 2.5-15t8.5-13l184-184q11-11 28-11t28 11q11 11 11 28t-11 28L432-480Z"), a.eventManager.o(a.menu, "click", function() {
                function b(c) {
                    return c.classList.contains("shaka-hidden") == 0;
                }
                RG(a.menu, !1);
                RG(a.parent, !0);
                nb(a.parent.childNodes, b) && ob(a.parent.childNodes, b)[0].focus();
                YH(a.controls);
                sJ(a);
            }));
        }
        function sJ(a) {
            var b = a.menu.getBoundingClientRect(), c = window1.getComputedStyle(a.menu), d = parseFloat(c.paddingTop);
            c = parseFloat(c.paddingBottom);
            var e = a.m.getBoundingClientRect();
            a.menu.style.maxHeight = b.bottom - e.top - d - c + "px";
        }
        S("shaka.ui.SettingsMenu", rJ);
        function wJ(a, b) {
            rJ.call(this, a, b, "M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-155.5t86-127Q252-817 325-848.5T480-880q83 0 155.5 31.5t127 86q54.5 54.5 86 127T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80Zm0-82q26-36 45-75t31-83H404q12 44 31 83t45 75Zm-104-16q-18-33-31.5-68.5T322-320H204q29 50 72.5 87t99.5 55Zm208 0q56-18 99.5-55t72.5-87H638q-9 38-22.5 73.5T584-178ZM170-400h136q-3-20-4.5-39.5T300-480q0-21 1.5-40.5T306-560H170q-5 20-7.5 39.5T160-480q0 21 2.5 40.5T170-400Zm216 0h188q3-20 4.5-39.5T580-480q0-21-1.5-40.5T574-560H386q-3 20-4.5 39.5T380-480q0 21 1.5 40.5T386-400Zm268 0h136q5-20 7.5-39.5T800-480q0-21-2.5-40.5T790-560H654q3 20 4.5 39.5T660-480q0 21-1.5 40.5T654-400Zm-16-240h118q-29-50-72.5-87T584-782q18 33 31.5 68.5T638-640Zm-234 0h152q-12-44-31-83t-45-75q-26 36-45 75t-31 83Zm-200 0h118q9-38 22.5-73.5T376-782q-56 18-99.5 55T204-640Z");
            var c = this;
            this.button.classList.add("shaka-language-button");
            this.button.classList.add("shaka-tooltip-status");
            this.menu.classList.add("shaka-audio-languages");
            this.eventManager.o(this.localization, "locale-updated", function() {
                xJ(c);
            });
            this.eventManager.o(this.localization, "locale-changed", function() {
                xJ(c);
            });
            this.eventManager.o(this.player, "loading", function() {
                yJ(c);
            });
            this.eventManager.o(this.player, "loaded", function() {
                yJ(c);
            });
            this.eventManager.o(this.player, "unloading", function() {
                yJ(c);
            });
            this.eventManager.o(this.player, "audiotrackschanged", function() {
                yJ(c);
            });
            xJ(this);
            yJ(this);
        }
        la(wJ, rJ);
        function yJ(a) {
            var b = a.player.getAudioTracks() || [];
            oJ(b, a.menu, function(c) {
                a.player.Hj(c);
                a.player.configure("preferredAudioLanguage", c.language);
                c.label && a.player.configure("preferredAudioLabel", c.label);
                c.channelsCount && a.player.configure("preferredAudioChannelCount", c.channelsCount);
                a.player.configure("preferSpatialAudio", c.spatialAudio);
            }, a.currentSelection, a.localization, a.controls.g.trackLabelFormat, a.controls.g.showAudioChannelCountVariants, a.controls.g.showAudioCodec);
            PG(a.menu);
            a.controls.dispatchEvent(new T("languageselectionupdated"));
            a.button.setAttribute("shaka-status", a.currentSelection.innerText);
            RG(a.button, a.menu.getElementsByTagName("button").length > 2);
        }
        function xJ(a) {
            a.backButton.ariaLabel = a.localization.resolve("BACK");
            a.button.ariaLabel = a.localization.resolve("LANGUAGE");
            a.nameSpan.textContent = a.localization.resolve("LANGUAGE");
            a.backSpan.textContent = a.localization.resolve("LANGUAGE");
        }
        S("shaka.ui.AudioLanguageSelection", wJ);
        function zJ() {}
        zJ.prototype.create = function(a, b) {
            return new wJ(a, b);
        };
        OI("language", new zJ);
        iI("language", new zJ);
        function AJ(a, b) {
            LG.call(this, a, b);
            var c = this;
            this.h = this.controls.F;
            this.g = Lj();
            this.g.classList.add("shaka-cast-button");
            this.g.classList.add("shaka-tooltip");
            this.g.ariaPressed = "false";
            this.l = new MG(this.g, "M880-240q0 33-23.5 56.5T800-160H633q-14 0-23.5-10.5T599-195q-6-95-43.5-177.5t-98-146.5q-60.5-64-141-105T143-676q-26-3-44.5-20.5T80-740q0-26 18.5-43t44.5-17h657q33 0 56.5 23.5T880-720v480Zm-560 80q-16 0-28-9.5T277-195q-11-63-56.5-107T112-357q-15-2-23.5-14.5T80-400q0-17 11-28.5t26-9.5q94 12 160.5 79T357-198q2 16-9 27t-28 11Zm160 0q-17 0-28.5-11T438-199q-14-128-104.5-217T115-518q-16-2-25.5-14T80-560q0-17 10.5-29t25.5-10q161 13 274 125t128 273q2 17-9.5 29T480-160Zm-350 0q-21 0-35.5-14.5T80-210q0-21 14.5-35.5T130-260q21 0 35.5 14.5T180-210q0 21-14.5 35.5T130-160Z");
            a = V("label");
            a.classList.add("shaka-overflow-button-label");
            a.classList.add("shaka-overflow-menu-only");
            a.classList.add("shaka-simple-overflow-button-label-inline");
            this.j = V("span");
            a.appendChild(this.j);
            this.i = V("span");
            this.i.classList.add("shaka-current-selection-span");
            a.appendChild(this.i);
            this.g.appendChild(a);
            this.parent.appendChild(this.g);
            BJ(this);
            CJ(this);
            this.eventManager.o(this.localization, "locale-updated", function() {
                BJ(c);
            });
            this.eventManager.o(this.localization, "locale-changed", function() {
                BJ(c);
            });
            this.eventManager.o(this.g, "click", function() {
                c.controls.Ca() && DJ(c);
            });
            this.eventManager.o(this.controls, "caststatuschanged", function() {
                CJ(c);
            });
        }
        la(AJ, LG);
        function DJ(a) {
            var b;
            Q(function(c) {
                if (c.g == 1) {
                    if (a.h.Qa()) return a.h.Vj(), c.B(0);
                    ra(c, 3);
                    a.g.disabled = !0;
                    return F(c, a.h.cast(), 5);
                }
                if (c.g != 3) return a.g.disabled = !1, ta(c, 0);
                b = ua(c);
                a.g.disabled = !1;
                b.code != 8004 && a.controls.dispatchEvent(new T("error", (new Map).set("detail", b)));
                H(c);
            });
        }
        function CJ(a) {
            var b = a.h.Kg() && a.controls.ra, c = a.h.Qa();
            RG(a.g, b);
            a.l.use(c ? "M720-600v240q0 17-11.5 28.5T680-320h-87q-8 0-14.5-4.5T569-337q-29-81-81.5-147T364-596q-16-10-11.5-27t21.5-17h306q17 0 28.5 11.5T720-600ZM320-160q-16 0-28-9.5T277-195q-11-63-56.5-107T112-357q-15-2-23.5-14.5T80-400q0-17 11-28.5t26-9.5q94 12 160.5 79T357-198q2 16-9 27t-28 11Zm160 0q-17 0-28.5-11T438-199q-14-128-104.5-217T115-518q-16-2-25.5-14T80-560q0-17 10.5-29t25.5-10q161 13 274 125.5T518-201q2 17-9.5 29T480-160Zm-340 0q-25 0-42.5-17.5T80-220q0-25 17.5-42.5T140-280q25 0 42.5 17.5T200-220q0 25-17.5 42.5T140-160Zm740-560v480q0 33-23.5 56.5T800-160H638q-17 0-28.5-11.5T598-200q0-17 11.5-28.5T638-240h162v-480H160v6q0 17-11.5 28.5T120-674q-17 0-28.5-11.5T80-714v-6q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720Z" : "M880-240q0 33-23.5 56.5T800-160H633q-14 0-23.5-10.5T599-195q-6-95-43.5-177.5t-98-146.5q-60.5-64-141-105T143-676q-26-3-44.5-20.5T80-740q0-26 18.5-43t44.5-17h657q33 0 56.5 23.5T880-720v480Zm-560 80q-16 0-28-9.5T277-195q-11-63-56.5-107T112-357q-15-2-23.5-14.5T80-400q0-17 11-28.5t26-9.5q94 12 160.5 79T357-198q2 16-9 27t-28 11Zm160 0q-17 0-28.5-11T438-199q-14-128-104.5-217T115-518q-16-2-25.5-14T80-560q0-17 10.5-29t25.5-10q161 13 274 125t128 273q2 17-9.5 29T480-160Zm-350 0q-21 0-35.5-14.5T80-210q0-21 14.5-35.5T130-260q21 0 35.5 14.5T180-210q0 21-14.5 35.5T130-160Z");
            b && (a.g.ariaPressed = c ? "true" : "false");
            EJ(a);
        }
        function EJ(a) {
            a.i.textContent = a.h.Qa() ? a.h.Yf() : a.localization.resolve("OFF");
        }
        function BJ(a) {
            a.g.ariaLabel = a.localization.resolve("CAST");
            a.j.textContent = a.localization.resolve("CAST");
            EJ(a);
        }
        S("shaka.ui.CastButton", AJ);
        function FJ() {}
        FJ.prototype.create = function(a, b) {
            return new AJ(a, b);
        };
        OI("cast", new FJ);
        iI("cast", new FJ);
        function GJ(a, b) {
            rJ.call(this, a, b, "m400-200-182 91q-20 10-39-1.5T160-145v-495q0-33 23.5-56.5T240-720h320q33 0 56.5 23.5T640-640v495q0 23-19 34.5t-39 1.5l-182-91Zm360-40q-17 0-28.5-11.5T720-280v-520H320q-17 0-28.5-11.5T280-840q0-17 11.5-28.5T320-880h400q33 0 56.5 23.5T800-800v520q0 17-11.5 28.5T760-240Z");
            var c = this;
            this.button.classList.add("shaka-chapter-button");
            this.menu.classList.add("shaka-chapters");
            this.button.classList.add("shaka-tooltip-status");
            this.g = [];
            this.h = "und";
            this.eventManager.o(this.localization, "locale-updated", function() {
                HJ(c);
                IJ(c);
            });
            this.eventManager.o(this.localization, "locale-changed", function() {
                HJ(c);
                IJ(c);
            });
            this.eventManager.o(this.player, "unloading", function() {
                JJ(c);
                c.h = "und";
                c.g = [];
            });
            this.eventManager.o(this.player, "trackschanged", function() {
                IJ(c);
            });
            HJ(this);
            IJ(this);
        }
        la(GJ, rJ);
        function HJ(a) {
            a.backButton.ariaLabel = a.localization.resolve("BACK");
            a.button.ariaLabel = a.localization.resolve("CHAPTERS");
            a.nameSpan.textContent = a.localization.resolve("CHAPTERS");
            a.backSpan.textContent = a.localization.resolve("CHAPTERS");
        }
        function JJ(a) {
            var b = NG(a.menu);
            Pj(a.menu);
            a.menu.appendChild(b);
            RG(a.button, !1);
        }
        function IJ(a) {
            var b, c, d, e, f, g, h, k, l, m, n, q, r, t;
            Q(function(w) {
                switch(w.g){
                    case 1:
                        b = function(v, z) {
                            return !v && !z || v.id === z.id && v.title === z.title && v.startTime === z.startTime && v.endTime === z.endTime;
                        }, c = "und", d = [], e = a.localization.g, f = u(Array.from(e)), g = f.next();
                    case 2:
                        if (g.done) {
                            w.B(4);
                            break;
                        }
                        c = h = g.value;
                        if (!a.player) {
                            w.B(5);
                            break;
                        }
                        return F(w, a.player.oh(c), 6);
                    case 6:
                        d = w.h || [];
                    case 5:
                        if (d.length) {
                            w.B(4);
                            break;
                        }
                        g = f.next();
                        w.B(2);
                        break;
                    case 4:
                        if (d.length) {
                            w.B(7);
                            break;
                        }
                        c = "und";
                        if (!a.player) {
                            w.B(7);
                            break;
                        }
                        return F(w, a.player.oh(c), 9);
                    case 9:
                        d = w.h || [];
                    case 7:
                        k = c !== a.h;
                        l = a.g.length !== d.length || !a.g.some(function(v, z) {
                            z = d.at(z);
                            return b(v, z) || d.some(function(y) {
                                return b(v, y);
                            });
                        });
                        a.h = c;
                        a.g = d;
                        if (!d.length) JJ(a);
                        else if (k || l) {
                            m = u(a.g);
                            n = m.next();
                            for(q = {}; !n.done; q = {
                                Mg: void 0
                            }, n = m.next())q.Mg = n.value, r = Lj(), t = V("span"), t.classList.add("shaka-chapter"), t.textContent = q.Mg.title, r.appendChild(t), a.eventManager.o(r, "click", function(v) {
                                return function() {
                                    a.controls.Ca() && (a.video.currentTime = v.Mg.startTime);
                                };
                            }(q)), a.menu.appendChild(r);
                            RG(a.button, !0);
                            PG(a.menu);
                        }
                        H(w);
                }
            });
        }
        S("shaka.ui.ChapterSelection", GJ);
        function KJ() {}
        KJ.prototype.create = function(a, b) {
            return new GJ(a, b);
        };
        OI("chapter", new KJ);
        iI("chapter", new KJ);
        function LJ(a, b) {
            LG.call(this, a, b);
            var c = this;
            this.g = Lj();
            this.g.classList.add("shaka-fast-forward-button");
            this.g.classList.add("shaka-tooltip-status");
            this.g.setAttribute("shaka-status", "1x");
            new MG(this.g).use("M100-315v-330q0-18 12-29t28-11q5 0 11 1t11 5l248 166q9 6 13.5 14.5T428-480q0 10-4.5 18.5T410-447L162-281q-5 4-11 5t-11 1q-16 0-28-11t-12-29Zm400 0v-330q0-18 12-29t28-11q5 0 11 1t11 5l248 166q9 6 13.5 14.5T828-480q0 10-4.5 18.5T810-447L562-281q-5 4-11 5t-11 1q-16 0-28-11t-12-29Z");
            this.parent.appendChild(this.g);
            MJ(this);
            this.h = this.controls.g.fastForwardRates;
            this.eventManager.o(this.localization, "locale-updated", function() {
                MJ(c);
            });
            this.eventManager.o(this.localization, "locale-changed", function() {
                MJ(c);
            });
            this.eventManager.o(this.g, "click", function() {
                if (c.controls.Ca() && c.video.duration) {
                    var d = c.h.indexOf(c.player.Za()) + 1;
                    d = d != c.h.length ? c.h[d] : c.h[0];
                    c.video.paused && c.video.play();
                    c.player.sc(d);
                    c.g.setAttribute("shaka-status", d + "x");
                }
            });
            this.eventManager.o(this.player, "ratechange", function() {
                c.g.setAttribute("shaka-status", c.player.Za() + "x");
            });
        }
        la(LJ, LG);
        function MJ(a) {
            a.g.ariaLabel = a.localization.resolve("FAST_FORWARD");
        }
        S("shaka.ui.FastForwardButton", LJ);
        function NJ() {}
        NJ.prototype.create = function(a, b) {
            return new LJ(a, b);
        };
        iI("fast_forward", new NJ);
        function OJ(a, b) {
            LG.call(this, a, b);
            var c = this;
            this.h = this.controls.u;
            this.g = Lj();
            this.g.classList.add("shaka-fullscreen-button");
            this.g.classList.add("shaka-tooltip");
            this.i = new MG(this.g, "M200-200h80q17 0 28.5 11.5T320-160q0 17-11.5 28.5T280-120H160q-17 0-28.5-11.5T120-160v-120q0-17 11.5-28.5T160-320q17 0 28.5 11.5T200-280v80Zm560 0v-80q0-17 11.5-28.5T800-320q17 0 28.5 11.5T840-280v120q0 17-11.5 28.5T800-120H680q-17 0-28.5-11.5T640-160q0-17 11.5-28.5T680-200h80ZM200-760v80q0 17-11.5 28.5T160-640q-17 0-28.5-11.5T120-680v-120q0-17 11.5-28.5T160-840h120q17 0 28.5 11.5T320-800q0 17-11.5 28.5T280-760h-80Zm560 0h-80q-17 0-28.5-11.5T640-800q0-17 11.5-28.5T680-840h120q17 0 28.5 11.5T840-800v120q0 17-11.5 28.5T800-640q-17 0-28.5-11.5T760-680v-80Z");
            PJ(this);
            this.parent.appendChild(this.g);
            QJ(this);
            this.eventManager.o(this.localization, "locale-updated", function() {
                QJ(c);
            });
            this.eventManager.o(this.localization, "locale-changed", function() {
                QJ(c);
            });
            this.eventManager.o(this.g, "click", function() {
                return Q(function(d) {
                    return c.controls.Ca() ? F(d, c.controls.og(), 0) : d.return();
                });
            });
            this.eventManager.o(document, "fullscreenchange", function() {
                c.i.use(c.controls.xb() ? "M240-240h-80q-17 0-28.5-11.5T120-280q0-17 11.5-28.5T160-320h120q17 0 28.5 11.5T320-280v120q0 17-11.5 28.5T280-120q-17 0-28.5-11.5T240-160v-80Zm480 0v80q0 17-11.5 28.5T680-120q-17 0-28.5-11.5T640-160v-120q0-17 11.5-28.5T680-320h120q17 0 28.5 11.5T840-280q0 17-11.5 28.5T800-240h-80ZM240-720v-80q0-17 11.5-28.5T280-840q17 0 28.5 11.5T320-800v120q0 17-11.5 28.5T280-640H160q-17 0-28.5-11.5T120-680q0-17 11.5-28.5T160-720h80Zm480 0h80q17 0 28.5 11.5T840-680q0 17-11.5 28.5T800-640H680q-17 0-28.5-11.5T640-680v-120q0-17 11.5-28.5T680-840q17 0 28.5 11.5T720-800v80Z" : "M200-200h80q17 0 28.5 11.5T320-160q0 17-11.5 28.5T280-120H160q-17 0-28.5-11.5T120-160v-120q0-17 11.5-28.5T160-320q17 0 28.5 11.5T200-280v80Zm560 0v-80q0-17 11.5-28.5T800-320q17 0 28.5 11.5T840-280v120q0 17-11.5 28.5T800-120H680q-17 0-28.5-11.5T640-160q0-17 11.5-28.5T680-200h80ZM200-760v80q0 17-11.5 28.5T160-640q-17 0-28.5-11.5T120-680v-120q0-17 11.5-28.5T160-840h120q17 0 28.5 11.5T320-800q0 17-11.5 28.5T280-760h-80Zm560 0h-80q-17 0-28.5-11.5T640-800q0-17 11.5-28.5T680-840h120q17 0 28.5 11.5T840-800v120q0 17-11.5 28.5T800-640q-17 0-28.5-11.5T760-680v-80Z");
                QJ(c);
            });
            this.eventManager.o(this.h, "loadedmetadata", function() {
                PJ(c);
            });
            this.eventManager.o(this.h, "loadeddata", function() {
                PJ(c);
            });
            this.eventManager.o(this.adManager, "ad-started", function() {
                PJ(c);
            });
            this.eventManager.o(this.adManager, "ad-stopped", function() {
                PJ(c);
            });
        }
        la(OJ, LG);
        function PJ(a) {
            a.controls.ve() ? a.g.classList.remove("shaka-hidden") : a.g.classList.add("shaka-hidden");
        }
        function QJ(a) {
            var b = a.controls.xb() ? "EXIT_FULL_SCREEN" : "FULL_SCREEN";
            a.g.ariaLabel = a.localization.resolve(b);
        }
        S("shaka.ui.FullscreenButton", OJ);
        function RJ() {}
        RJ.prototype.create = function(a, b) {
            return new OJ(a, b);
        };
        iI("fullscreen", new RJ);
        function SJ(a, b) {
            LG.call(this, a, b);
            var c = this;
            this.g = Lj();
            this.g.classList.add("shaka-loop-button");
            this.g.classList.add("shaka-tooltip");
            this.m = new MG(this.g, "m274-200 34 34q12 12 11.5 28T308-110q-12 12-28.5 12.5T251-109L148-212q-6-6-8.5-13t-2.5-15q0-8 2.5-15t8.5-13l103-103q12-12 28.5-11.5T308-370q11 12 11.5 28T308-314l-34 34h406v-120q0-17 11.5-28.5T720-440q17 0 28.5 11.5T760-400v120q0 33-23.5 56.5T680-200H274Zm412-480H280v120q0 17-11.5 28.5T240-520q-17 0-28.5-11.5T200-560v-120q0-33 23.5-56.5T280-760h406l-34-34q-12-12-11.5-28t11.5-28q12-12 28.5-12.5T709-851l103 103q6 6 8.5 13t2.5 15q0 8-2.5 15t-8.5 13L709-589q-12 12-28.5 11.5T652-590q-11-12-11.5-28t11.5-28l34-34Z");
            a = V("label");
            a.classList.add("shaka-overflow-button-label");
            a.classList.add("shaka-overflow-menu-only");
            a.classList.add("shaka-simple-overflow-button-label-inline");
            this.j = V("span");
            this.j.textContent = this.localization.resolve("LOOP");
            a.appendChild(this.j);
            this.i = V("span");
            this.i.classList.add("shaka-current-selection-span");
            a.appendChild(this.i);
            this.g.appendChild(a);
            TJ(this);
            this.parent.appendChild(this.g);
            this.eventManager.o(this.localization, "locale-updated", function() {
                TJ(c);
            });
            this.eventManager.o(this.localization, "locale-changed", function() {
                TJ(c);
            });
            this.eventManager.o(this.g, "click", function() {
                c.controls.Ca() && (c.video.loop = !c.video.loop, c.h.La(), c.h.wa(1));
            });
            this.l = this.video.loop;
            this.h = new Bf(function() {
                c.l != c.video.loop && (TJ(c), c.l = c.video.loop);
            });
            this.h.wa(1);
            this.eventManager.o(this.player, "unloading", function() {
                UJ(c);
            });
            this.eventManager.o(this.player, "loaded", function() {
                UJ(c);
            });
            this.eventManager.o(this.player, "manifestupdated", function() {
                UJ(c);
            });
            this.eventManager.o(this.video, "durationchange", function() {
                UJ(c);
            });
        }
        la(SJ, LG);
        SJ.prototype.release = function() {
            this.h.stop();
            this.h = null;
            LG.prototype.release.call(this);
        };
        function TJ(a) {
            a.j.textContent = a.localization.resolve("LOOP");
            a.i.textContent = a.localization.resolve(a.video.loop ? "ON" : "OFF");
            a.m.use(a.video.loop ? "M120-40q-33 0-56.5-23.5T40-120v-720q0-33 23.5-56.5T120-920h720q33 0 56.5 23.5T920-840v720q0 33-23.5 56.5T840-40H120Zm154-160h406q33 0 56.5-23.5T760-280v-120q0-17-11.5-28.5T720-440q-17 0-28.5 11.5T680-400v120H274l34-34q12-12 11.5-28T308-370q-12-12-28.5-12.5T251-371L148-268q-6 6-8.5 13t-2.5 15q0 8 2.5 15t8.5 13l103 103q12 12 28.5 11.5T308-110q11-12 11.5-28T308-166l-34-34Zm412-480-34 34q-12 12-11.5 28t11.5 28q12 12 28.5 12.5T709-589l103-103q6-6 8.5-13t2.5-15q0-8-2.5-15t-8.5-13L709-851q-12-12-28.5-11.5T652-850q-11 12-11.5 28t11.5 28l34 34H280q-33 0-56.5 23.5T200-680v120q0 17 11.5 28.5T240-520q17 0 28.5-11.5T280-560v-120h406Z" : "m274-200 34 34q12 12 11.5 28T308-110q-12 12-28.5 12.5T251-109L148-212q-6-6-8.5-13t-2.5-15q0-8 2.5-15t8.5-13l103-103q12-12 28.5-11.5T308-370q11 12 11.5 28T308-314l-34 34h406v-120q0-17 11.5-28.5T720-440q17 0 28.5 11.5T760-400v120q0 33-23.5 56.5T680-200H274Zm412-480H280v120q0 17-11.5 28.5T240-520q-17 0-28.5-11.5T200-560v-120q0-33 23.5-56.5T280-760h406l-34-34q-12-12-11.5-28t11.5-28q12-12 28.5-12.5T709-851l103 103q6 6 8.5 13t2.5 15q0 8-2.5 15t-8.5 13L709-589q-12 12-28.5 11.5T652-590q-11-12-11.5-28t11.5-28l34-34Z");
            a.g.ariaLabel = a.localization.resolve(a.video.loop ? "EXIT_LOOP_MODE" : "ENTER_LOOP_MODE");
        }
        function UJ(a) {
            RG(a.g, !a.player.U());
        }
        S("shaka.ui.LoopButton", SJ);
        function VJ() {}
        VJ.prototype.create = function(a, b) {
            return new SJ(a, b);
        };
        OI("loop", new VJ);
        iI("loop", new VJ);
        WG("loop", new VJ);
        function WJ(a, b) {
            LG.call(this, a, b);
            var c = this;
            this.g = Lj();
            this.g.classList.add("shaka-mute-button");
            this.g.classList.add("shaka-tooltip");
            this.j = new MG(this.g, "M760-481q0-83-44-151.5T598-735q-15-7-22-21.5t-2-29.5q6-16 21.5-23t31.5 0q97 43 155 131.5T840-481q0 108-58 196.5T627-153q-16 7-31.5 0T574-176q-5-15 2-29.5t22-21.5q74-34 118-102.5T760-481ZM280-360H160q-17 0-28.5-11.5T120-400v-160q0-17 11.5-28.5T160-600h120l132-132q19-19 43.5-8.5T480-703v446q0 27-24.5 37.5T412-228L280-360Zm380-120q0 42-19 79.5T591-339q-10 6-20.5.5T560-356v-250q0-12 10.5-17.5t20.5.5q31 25 50 63t19 80Z");
            a = V("label");
            a.classList.add("shaka-overflow-button-label");
            a.classList.add("shaka-overflow-menu-only");
            this.h = V("span");
            this.h.textContent = this.localization.resolve("MUTE");
            a.appendChild(this.h);
            this.i = V("span");
            this.i.classList.add("shaka-current-selection-span");
            a.appendChild(this.i);
            this.g.appendChild(a);
            this.parent.appendChild(this.g);
            XJ(this);
            YJ(this);
            this.eventManager.o(this.localization, "locale-updated", function() {
                XJ(c);
            });
            this.eventManager.o(this.localization, "locale-changed", function() {
                XJ(c);
            });
            this.eventManager.o(this.g, "click", function() {
                c.controls.Ca() && (c.ad && c.ad.isLinear() ? c.ad.setMuted(!c.ad.isMuted()) : c.video.muted || c.video.volume != 0 ? c.video.muted = !c.video.muted : c.video.volume = 1);
            });
            this.eventManager.o(this.video, "volumechange", function() {
                XJ(c);
                YJ(c);
            });
            this.eventManager.o(this.player, "loading", function() {
                XJ(c);
                YJ(c);
            });
            this.eventManager.o(this.player, "loaded", function() {
                ZJ(c);
            });
            this.eventManager.o(this.player, "unloading", function() {
                ZJ(c);
            });
            this.eventManager.o(this.player, "trackschanged", function() {
                ZJ(c);
            });
            this.eventManager.o(this.controls, "caststatuschanged", function() {
                XJ(c);
                YJ(c);
            });
            this.eventManager.o(this.adManager, "ad-volume-changed", function() {
                XJ(c);
                YJ(c);
            });
            this.eventManager.o(this.adManager, "ad-muted", function() {
                XJ(c);
                YJ(c);
            });
            this.eventManager.o(this.adManager, "ad-started", function() {
                ZJ(c);
            });
            this.eventManager.o(this.adManager, "ad-stopped", function() {
                c.ad = null;
                XJ(c);
                YJ(c);
                ZJ(c);
            });
            ZJ(this);
        }
        la(WJ, LG);
        function XJ(a) {
            var b = a.ad ? a.ad.isMuted() ? "UNMUTE" : "MUTE" : a.video.muted || a.video.volume == 0 ? "UNMUTE" : "MUTE";
            a.g.ariaLabel = a.localization.resolve(b);
            a.h.textContent = a.localization.resolve(b);
        }
        function YJ(a) {
            var b = a.ad ? a.ad.isMuted() ? "M671-177q-11 7-22 13t-23 11q-15 7-30.5 0T574-176q-6-15 1.5-29.5T598-227q4-2 7.5-4t7.5-4L480-368v111q0 27-24.5 37.5T412-228L280-360H160q-17 0-28.5-11.5T120-400v-160q0-17 11.5-28.5T160-600h88L84-764q-11-11-11-28t11-28q11-11 28-11t28 11l680 680q11 11 11 28t-11 28q-11 11-28 11t-28-11l-93-93Zm89-304q0-83-44-151.5T598-735q-15-7-22-21.5t-2-29.5q6-16 21.5-23t31.5 0q97 43 155 131t58 197q0 33-6 65.5T817-353q-8 22-24.5 27.5t-30.5.5q-14-5-22.5-18t-.5-30q11-26 16-52.5t5-55.5ZM591-623q33 21 51 63t18 80v10q0 5-1 10-2 13-14 17t-22-6l-51-51q-6-6-9-13.5t-3-15.5v-77q0-12 10.5-17.5t20.5.5Zm-201-59q-6-6-6-14t6-14l22-22q19-19 43.5-8.5T480-703v63q0 14-12 19t-22-5l-56-56Z" : "M760-481q0-83-44-151.5T598-735q-15-7-22-21.5t-2-29.5q6-16 21.5-23t31.5 0q97 43 155 131.5T840-481q0 108-58 196.5T627-153q-16 7-31.5 0T574-176q-5-15 2-29.5t22-21.5q74-34 118-102.5T760-481ZM280-360H160q-17 0-28.5-11.5T120-400v-160q0-17 11.5-28.5T160-600h120l132-132q19-19 43.5-8.5T480-703v446q0 27-24.5 37.5T412-228L280-360Zm380-120q0 42-19 79.5T591-339q-10 6-20.5.5T560-356v-250q0-12 10.5-17.5t20.5.5q31 25 50 63t19 80Z" : a.video.muted || a.video.volume == 0 ? "M671-177q-11 7-22 13t-23 11q-15 7-30.5 0T574-176q-6-15 1.5-29.5T598-227q4-2 7.5-4t7.5-4L480-368v111q0 27-24.5 37.5T412-228L280-360H160q-17 0-28.5-11.5T120-400v-160q0-17 11.5-28.5T160-600h88L84-764q-11-11-11-28t11-28q11-11 28-11t28 11l680 680q11 11 11 28t-11 28q-11 11-28 11t-28-11l-93-93Zm89-304q0-83-44-151.5T598-735q-15-7-22-21.5t-2-29.5q6-16 21.5-23t31.5 0q97 43 155 131t58 197q0 33-6 65.5T817-353q-8 22-24.5 27.5t-30.5.5q-14-5-22.5-18t-.5-30q11-26 16-52.5t5-55.5ZM591-623q33 21 51 63t18 80v10q0 5-1 10-2 13-14 17t-22-6l-51-51q-6-6-9-13.5t-3-15.5v-77q0-12 10.5-17.5t20.5.5Zm-201-59q-6-6-6-14t6-14l22-22q19-19 43.5-8.5T480-703v63q0 14-12 19t-22-5l-56-56Z" : "M760-481q0-83-44-151.5T598-735q-15-7-22-21.5t-2-29.5q6-16 21.5-23t31.5 0q97 43 155 131.5T840-481q0 108-58 196.5T627-153q-16 7-31.5 0T574-176q-5-15 2-29.5t22-21.5q74-34 118-102.5T760-481ZM280-360H160q-17 0-28.5-11.5T120-400v-160q0-17 11.5-28.5T160-600h120l132-132q19-19 43.5-8.5T480-703v446q0 27-24.5 37.5T412-228L280-360Zm380-120q0 42-19 79.5T591-339q-10 6-20.5.5T560-356v-250q0-12 10.5-17.5t20.5.5q31 25 50 63t19 80Z";
            a.j.use(b);
        }
        function ZJ(a) {
            var b = !0;
            a.ad && a.ad.isLinear() ? b = !0 : a.player.Hh() && (b = !1);
            RG(a.g, b);
        }
        S("shaka.ui.MuteButton", WJ);
        function $J() {}
        $J.prototype.create = function(a, b) {
            return new WJ(a, b);
        };
        OI("mute", new $J);
        iI("mute", new $J);
        WG("mute", new $J);
        function aK(a, b) {
            LG.call(this, a, b);
            var c = this;
            this.j = this.controls.u;
            this.g = Lj();
            this.g.classList.add("shaka-pip-button");
            this.g.classList.add("shaka-tooltip");
            this.l = new MG(this.g, "M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-120h240q17 0 28.5-11.5T760-320v-160q0-17-11.5-28.5T720-520H480q-17 0-28.5 11.5T440-480v160q0 17 11.5 28.5T480-280Zm120-120Z");
            a = V("label");
            a.classList.add("shaka-overflow-button-label");
            a.classList.add("shaka-overflow-menu-only");
            a.classList.add("shaka-simple-overflow-button-label-inline");
            this.i = V("span");
            this.i.textContent = this.localization.resolve("PICTURE_IN_PICTURE");
            a.appendChild(this.i);
            this.h = V("span");
            this.h.classList.add("shaka-current-selection-span");
            a.appendChild(this.h);
            this.g.appendChild(a);
            bK(this);
            this.parent.appendChild(this.g);
            this.controls.Ef() || RG(this.g, !1);
            this.eventManager.o(this.localization, "locale-updated", function() {
                bK(c);
            });
            this.eventManager.o(this.localization, "locale-changed", function() {
                bK(c);
            });
            this.eventManager.o(this.g, "click", function() {
                c.controls.Ca() && c.controls.cd();
            });
            this.eventManager.o(this.j, "enterpictureinpicture", function() {
                cK(c);
            });
            this.eventManager.o(this.j, "leavepictureinpicture", function() {
                dK(c);
            });
            this.eventManager.o(this.controls, "caststatuschanged", function() {
                eK(c);
            });
            this.eventManager.o(this.player, "trackschanged", function() {
                eK(c);
            });
            "documentPictureInPicture" in window1 && this.eventManager.o(window1.documentPictureInPicture, "enter", function(d) {
                cK(c);
                c.eventManager.ua(d.window, "pagehide", function() {
                    dK(c);
                });
            });
        }
        la(aK, LG);
        function cK(a) {
            a.l.use("M160-160q-33 0-56.5-23.5T80-240v-240q0-17 11.5-28.5T120-520h240q33 0 56.5-23.5T440-600v-160q0-17 11.5-28.5T480-800h320q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm360-400q-17 0-28.5 11.5T480-520v160q0 17 11.5 28.5T520-320q17 0 28.5-11.5T560-360v-63l95 95q12 12 28 12t28-12q12-12 12-28.5T711-385l-95-95h64q17 0 28.5-11.5T720-520q0-17-11.5-28.5T680-560H520Zm-400-40q-17 0-28.5-11.5T80-640v-120q0-17 11.5-28.5T120-800h200q17 0 28.5 11.5T360-760v120q0 17-11.5 28.5T320-600H120Z");
            a.g.ariaLabel = a.localization.resolve("EXIT_PICTURE_IN_PICTURE");
            a.h.textContent = a.localization.resolve("ON");
        }
        function dK(a) {
            a.l.use("M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-120h240q17 0 28.5-11.5T760-320v-160q0-17-11.5-28.5T720-520H480q-17 0-28.5 11.5T440-480v160q0 17 11.5 28.5T480-280Zm120-120Z");
            a.g.ariaLabel = a.localization.resolve("ENTER_PICTURE_IN_PICTURE");
            a.h.textContent = a.localization.resolve("OFF");
        }
        function bK(a) {
            a.i.textContent = a.localization.resolve("PICTURE_IN_PICTURE");
            var b = a.controls.Md();
            a.g.ariaLabel = a.localization.resolve(b ? "EXIT_PICTURE_IN_PICTURE" : "ENTER_PICTURE_IN_PICTURE");
            a.h.textContent = a.localization.resolve(b ? "ON" : "OFF");
        }
        function eK(a) {
            Q(function(b) {
                if (!a.controls.Ef()) return RG(a.g, !1), a.controls.Md() ? F(b, a.controls.cd(), 0) : b.B(0);
                if (!a.player || !a.player.Ld()) return RG(a.g, !0), b.B(0);
                RG(a.g, !1);
                return a.controls.Md() ? F(b, a.controls.cd(), 0) : b.B(0);
            });
        }
        S("shaka.ui.PipButton", aK);
        function fK() {}
        fK.prototype.create = function(a, b) {
            return new aK(a, b);
        };
        OI("picture_in_picture", new fK);
        iI("picture_in_picture", new fK);
        WG("picture_in_picture", new fK);
        function gK(a, b) {
            rJ.call(this, a, b, "m426-330 195-125q14-9 14-25t-14-25L426-630q-15-10-30.5-1.5T380-605v250q0 18 15.5 26.5T426-330ZM121-440q17 0 30.5 11t18.5 28q6 23 14.5 43.5T204-317q9 15 7.5 32T198-256q-11 11-27 10t-25-14q-22-31-37-66.5T86-400q-3-16 7.5-28t27.5-12Zm77-264q12 12 13 29t-7 31q-11 20-19.5 41T170-559q-5 17-18.5 28T121-520q-17 0-27.5-12.5T87-561q8-38 23-73.5t36-66.5q9-13 25-13.5t27 10.5Zm56 505q12-13 29.5-14t32.5 8q20 11 40.5 20t42.5 15q17 5 28 18t11 30q0 17-12.5 27T397-88q-38-8-71.5-23T260-146q-14-9-15.5-25t9.5-28Zm186-639q0 17-10.5 30T402-790q-23 6-44 14.5T317-755q-15 9-32.5 7.5T255-761q-12-12-10.5-28.5T260-815q32-20 66.5-34.5T399-872q16-3 28.5 7t12.5 27Zm360 358q0-113-69.5-199.5T553-792q-15-4-24-17t-9-29q0-16 11-26.5t25-7.5q140 28 232 137t92 255q0 146-92 255T556-88q-14 3-25-7.5T520-122q0-16 9-29t24-17q108-26 177.5-112.5T800-480Z");
            var c = this;
            this.button.classList.add("shaka-playbackrate-button");
            this.menu.classList.add("shaka-playback-rates");
            this.button.classList.add("shaka-tooltip-status");
            Array.from(a.classList).includes("shaka-overflow-menu") || (this.g = V("span"), this.g.classList.add("shaka-overflow-playback-rate-mark"), this.button.appendChild(this.g));
            this.eventManager.o(this.localization, "locale-updated", function() {
                hK(c);
            });
            this.eventManager.o(this.localization, "locale-changed", function() {
                hK(c);
            });
            this.eventManager.o(this.player, "loaded", function() {
                iK(c);
            });
            this.eventManager.o(this.player, "ratechange", function() {
                iK(c);
            });
            hK(this);
            jK(this);
            iK(this);
        }
        la(gK, rJ);
        function hK(a) {
            a.backButton.ariaLabel = a.localization.resolve("BACK");
            a.button.ariaLabel = a.localization.resolve("PLAYBACK_RATE");
            a.nameSpan.textContent = a.localization.resolve("PLAYBACK_RATE");
            a.backSpan.textContent = a.localization.resolve("PLAYBACK_RATE");
        }
        function iK(a) {
            var b = a.player.Za(), c = OG(a.menu, "material-svg-icon shaka-chosen-item");
            if (c) {
                var d = c.parentElement;
                d.removeAttribute("aria-selected");
                var e = d.getElementsByTagName("span")[0];
                e && e.classList.remove("shaka-chosen-item");
                d.removeChild(c);
            }
            if (c = Array.from(a.menu.querySelectorAll("span")).find(function(f) {
                return f.textContent == b + "x";
            })) d = c.parentElement, d.appendChild(QG()), d.ariaSelected = "true", c.classList.add("shaka-chosen-item");
            a.currentSelection.textContent = b + "x";
            a.button.setAttribute("shaka-status", b + "x");
            a.g && (a.g.textContent = b + "x");
        }
        function jK(a) {
            for(var b = u(a.controls.g.playbackRates), c = b.next(), d = {}; !c.done; d = {
                Xf: void 0
            }, c = b.next()){
                d.Xf = c.value;
                c = Lj();
                var e = V("span");
                e.textContent = d.Xf + "x";
                c.appendChild(e);
                a.eventManager.o(c, "click", function(f) {
                    return function() {
                        f.Xf == a.video.defaultPlaybackRate ? a.player.Bd() : a.player.sc(f.Xf, !1);
                    };
                }(d));
                a.menu.appendChild(c);
            }
            PG(a.menu);
        }
        S("shaka.ui.PlaybackRateSelection", gK);
        function kK() {}
        kK.prototype.create = function(a, b) {
            return new gK(a, b);
        };
        OI("playback_rate", new kK);
        iI("playback_rate", new kK);
        function lK(a, b) {
            LG.call(this, a, b);
            var c = this;
            this.g = Lj();
            this.g.classList.add("shaka-current-time");
            mK(this, "0:00");
            this.parent.appendChild(this.g);
            this.eventManager.o(this.g, "click", function() {
                c.controls.Ca() && c.player.U() && (c.video.currentTime = c.player.za().end);
            });
            this.eventManager.o(this.player, "loading", function() {
                RG(c.g, !0);
            });
            this.eventManager.o(this.controls, "timeandseekrangeupdated", function() {
                var d = c.controls.S, e = c.controls.ph(), f = c.player.za(), g = f.end - f.start;
                isFinite(g) ? c.player.U() ? (e = Math.max(0, Math.floor(f.end - e)), g = g >= 3600, e >= 1 || d ? (mK(c, "- " + SG(e, g)), c.g.disabled = !1) : (mK(c, c.localization.resolve("LIVE")), c.g.disabled = !0)) : (d = g >= 3600, e = SG(Math.max(0, e - f.start), d), g && (e += " / " + SG(g, d)), mK(c, e), c.g.disabled = !0) : (mK(c, c.localization.resolve("LIVE")), c.g.disabled = !0);
            });
            this.eventManager.o(this.player, "trackschanged", function() {
                c.player.U() && (c.g.ariaLabel = c.localization.resolve("SKIP_TO_LIVE"));
            });
            this.eventManager.o(this.adManager, "ad-started", function() {
                RG(c.g, !c.ad.isLinear());
            });
            this.eventManager.o(this.adManager, "ad-stopped", function() {
                RG(c.g, !0);
            });
        }
        la(lK, LG);
        function mK(a, b) {
            b != a.g.textContent && (a.g.textContent = b);
        }
        S("shaka.ui.PresentationTimeTracker", lK);
        function nK() {}
        nK.prototype.create = function(a, b) {
            return new lK(a, b);
        };
        iI("time_and_duration", new nK);
        function oK(a, b) {
            LG.call(this, a, b);
            var c = this;
            this.g = Lj();
            this.g.classList.add("shaka-recenter-vr-button");
            this.g.classList.add("shaka-tooltip");
            this.g.ariaPressed = "false";
            new MG(this.g, "M479-359q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35Zm-57 222-85-85q-12-12-11.5-28.5T338-279q12-12 28.5-12t28.5 12l85 86 85-85q11-11 28-11t28 11q11 11 11 28t-11 28l-85 85q-12 12-27 18t-30 6q-15 0-30-6t-27-18ZM221-337l-85-85q-12-12-18-27t-6-30q0-15 6-30t18-27l85-85q12-12 28.5-12t28.5 12q12 12 12 28.5T278-564l-86 86 85 85q11 11 11 28t-11 28q-11 11-28 11t-28-11Zm116-401 85-85q12-12 27-18t30-6q15 0 30 6t27 18l85 85q12 12 12 28t-12 28q-12 12-28.5 12T564-682l-86-85-85 85q-11 11-28 11t-28-11q-11-11-11-28t11-28Zm344 343 85-85-85-85q-11-11-11-28t11-28q11-11 28-11t28 11l85 85q12 12 18 27t6 30q0 15-6 30t-18 27l-85 85q-12 12-28 11.5T681-338q-12-12-12-28.5t12-28.5Z");
            a = V("label");
            a.classList.add("shaka-overflow-button-label");
            a.classList.add("shaka-overflow-menu-only");
            this.i = V("span");
            a.appendChild(this.i);
            this.h = V("span");
            this.h.classList.add("shaka-current-selection-span");
            a.appendChild(this.h);
            this.g.appendChild(a);
            this.parent.appendChild(this.g);
            pK(this);
            this.eventManager.o(this.localization, "locale-updated", function() {
                pK(c);
            });
            this.eventManager.o(this.localization, "locale-changed", function() {
                pK(c);
            });
            var d = this.controls.D;
            this.eventManager.o(this.g, "click", function() {
                c.controls.Ca() && (d.g ? PH(d.g) : ab("Not playing VR content"));
            });
            this.eventManager.o(d, "vrstatuschanged", function() {
                RG(c.g, c.controls.Xb());
            });
            RG(this.g, this.controls.Xb());
        }
        la(oK, LG);
        function pK(a) {
            a.g.ariaLabel = a.localization.resolve("RECENTER_VR");
            a.i.textContent = a.localization.resolve("RECENTER_VR");
        }
        S("shaka.ui.RecenterVRButton", oK);
        function qK() {}
        qK.prototype.create = function(a, b) {
            return new oK(a, b);
        };
        OI("recenter_vr", new qK);
        iI("recenter_vr", new qK);
        function rK(a, b) {
            LG.call(this, a, b);
            var c = this;
            this.i = Rb().kg();
            this.g = Lj();
            this.g.classList.add("shaka-remote-button");
            this.g.classList.add("shaka-tooltip");
            this.g.ariaPressed = "false";
            this.l = new MG(this.g, this.i ? "M312-120q-14 0-22-9.5t-8-20.5q0-5 2-10.5t7-10.5l161-161q6-6 13-9t15-3q8 0 15 3t13 9l161 161q5 5 7 10.5t2 10.5q0 11-8 20.5t-22 9.5H312ZM160-840h640q33 0 56.5 23.5T880-760v480q0 33-23.5 56.5T800-200h-7q-16 0-30.5-6T737-223L565-395q-17-17-39-26t-46-9q-24 0-46 9t-39 26L223-223q-11 11-25.5 17t-30.5 6h-7q-33 0-56.5-23.5T80-280v-480q0-33 23.5-56.5T160-840Z" : "M880-240q0 33-23.5 56.5T800-160H633q-14 0-23.5-10.5T599-195q-6-95-43.5-177.5t-98-146.5q-60.5-64-141-105T143-676q-26-3-44.5-20.5T80-740q0-26 18.5-43t44.5-17h657q33 0 56.5 23.5T880-720v480Zm-560 80q-16 0-28-9.5T277-195q-11-63-56.5-107T112-357q-15-2-23.5-14.5T80-400q0-17 11-28.5t26-9.5q94 12 160.5 79T357-198q2 16-9 27t-28 11Zm160 0q-17 0-28.5-11T438-199q-14-128-104.5-217T115-518q-16-2-25.5-14T80-560q0-17 10.5-29t25.5-10q161 13 274 125t128 273q2 17-9.5 29T480-160Zm-350 0q-21 0-35.5-14.5T80-210q0-21 14.5-35.5T130-260q21 0 35.5 14.5T180-210q0 21-14.5 35.5T130-160Z");
            a = V("label");
            a.classList.add("shaka-overflow-button-label");
            a.classList.add("shaka-overflow-menu-only");
            this.m = V("span");
            a.appendChild(this.m);
            this.j = V("span");
            this.j.classList.add("shaka-current-selection-span");
            a.appendChild(this.j);
            this.g.appendChild(a);
            this.parent.appendChild(this.g);
            this.h = -1;
            sK(this);
            RG(this.g, !1);
            this.video.remote ? (this.eventManager.o(this.localization, "locale-updated", function() {
                sK(c);
            }), this.eventManager.o(this.localization, "locale-changed", function() {
                sK(c);
            }), this.eventManager.o(this.controls, "caststatuschanged", function() {
                tK(c);
            }), this.eventManager.o(this.g, "click", function() {
                c.controls.Ca() && c.video.remote.prompt().catch(function() {});
            }), this.eventManager.o(this.video.remote, "connect", function() {
                tK(c);
                uK(c);
            }), this.eventManager.o(this.video.remote, "connecting", function() {
                tK(c);
                uK(c);
            }), this.eventManager.o(this.video.remote, "disconnect", function() {
                tK(c);
                uK(c);
            }), this.eventManager.o(this.player, "loaded", function() {
                tK(c);
            }), tK(this, !0), uK(this)) : this.g.classList.add("shaka-hidden");
        }
        la(rK, LG);
        rK.prototype.release = function() {
            this.video.remote && this.h != -1 && this.video.remote.cancelWatchAvailability(this.h).catch(function() {});
            LG.prototype.release.call(this);
        };
        function tK(a, b) {
            b = b === void 0 ? !1 : b;
            var c, d;
            Q(function(e) {
                switch(e.g){
                    case 1:
                        if (a.controls.F.Kg() && a.controls.ra || !a.video.remote) {
                            RG(a.g, !1);
                            a.h != -1 && (a.video.remote.cancelWatchAvailability(a.h), a.h = -1);
                            e.B(0);
                            break;
                        }
                        if (a.video.remote.state == "disconnected" || b) {
                            c = function(f) {
                                if (a.player) {
                                    var g = a.video.disableRemotePlayback, h = !0;
                                    Rb().kg() && a.player.l == vr && a.player.sh() != "HLS" && (h = !1);
                                    RG(a.g, h && f && !g);
                                } else RG(a.g, !1);
                            };
                            ra(e, 7);
                            if (a.h == -1) {
                                e.B(9);
                                break;
                            }
                            return F(e, a.video.remote.cancelWatchAvailability(a.h), 10);
                        }
                        RG(a.g, !0);
                        if (a.h == -1) {
                            e.B(0);
                            break;
                        }
                        return F(e, a.video.remote.cancelWatchAvailability(a.h), 6);
                    case 6:
                        a.h = -1;
                        e.B(0);
                        break;
                    case 10:
                        a.h = -1;
                    case 9:
                        ta(e, 8);
                        break;
                    case 7:
                        ua(e);
                    case 8:
                        return ra(e, 11), F(e, a.video.remote.watchAvailability(c), 13);
                    case 13:
                        d = e.h;
                        a.h = d;
                        ta(e, 0);
                        break;
                    case 11:
                        ua(e), c(!0), H(e);
                }
            });
        }
        function sK(a) {
            var b = a.i ? a.localization.resolve("AIRPLAY") : a.localization.resolve("CAST");
            a.g.ariaLabel = b;
            a.m.textContent = b;
        }
        function uK(a) {
            a.i || (a.video.remote.state == "disconnected" ? a.l.use("M880-240q0 33-23.5 56.5T800-160H633q-14 0-23.5-10.5T599-195q-6-95-43.5-177.5t-98-146.5q-60.5-64-141-105T143-676q-26-3-44.5-20.5T80-740q0-26 18.5-43t44.5-17h657q33 0 56.5 23.5T880-720v480Zm-560 80q-16 0-28-9.5T277-195q-11-63-56.5-107T112-357q-15-2-23.5-14.5T80-400q0-17 11-28.5t26-9.5q94 12 160.5 79T357-198q2 16-9 27t-28 11Zm160 0q-17 0-28.5-11T438-199q-14-128-104.5-217T115-518q-16-2-25.5-14T80-560q0-17 10.5-29t25.5-10q161 13 274 125t128 273q2 17-9.5 29T480-160Zm-350 0q-21 0-35.5-14.5T80-210q0-21 14.5-35.5T130-260q21 0 35.5 14.5T180-210q0 21-14.5 35.5T130-160Z") : a.l.use("M720-600v240q0 17-11.5 28.5T680-320h-87q-8 0-14.5-4.5T569-337q-29-81-81.5-147T364-596q-16-10-11.5-27t21.5-17h306q17 0 28.5 11.5T720-600ZM320-160q-16 0-28-9.5T277-195q-11-63-56.5-107T112-357q-15-2-23.5-14.5T80-400q0-17 11-28.5t26-9.5q94 12 160.5 79T357-198q2 16-9 27t-28 11Zm160 0q-17 0-28.5-11T438-199q-14-128-104.5-217T115-518q-16-2-25.5-14T80-560q0-17 10.5-29t25.5-10q161 13 274 125.5T518-201q2 17-9.5 29T480-160Zm-340 0q-25 0-42.5-17.5T80-220q0-25 17.5-42.5T140-280q25 0 42.5 17.5T200-220q0 25-17.5 42.5T140-160Zm740-560v480q0 33-23.5 56.5T800-160H638q-17 0-28.5-11.5T598-200q0-17 11.5-28.5T638-240h162v-480H160v6q0 17-11.5 28.5T120-674q-17 0-28.5-11.5T80-714v-6q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720Z"));
        }
        S("shaka.ui.RemoteButton", rK);
        function vK() {}
        vK.prototype.create = function(a, b) {
            return new rK(a, b);
        };
        OI("remote", new vK);
        iI("remote", new vK);
        function wK(a, b) {
            rJ.call(this, a, b, "M480-120q-17 0-28.5-11.5T440-160v-160q0-17 11.5-28.5T480-360q17 0 28.5 11.5T520-320v40h280q17 0 28.5 11.5T840-240q0 17-11.5 28.5T800-200H520v40q0 17-11.5 28.5T480-120Zm-320-80q-17 0-28.5-11.5T120-240q0-17 11.5-28.5T160-280h160q17 0 28.5 11.5T360-240q0 17-11.5 28.5T320-200H160Zm160-160q-17 0-28.5-11.5T280-400v-40H160q-17 0-28.5-11.5T120-480q0-17 11.5-28.5T160-520h120v-40q0-17 11.5-28.5T320-600q17 0 28.5 11.5T360-560v160q0 17-11.5 28.5T320-360Zm160-80q-17 0-28.5-11.5T440-480q0-17 11.5-28.5T480-520h320q17 0 28.5 11.5T840-480q0 17-11.5 28.5T800-440H480Zm160-160q-17 0-28.5-11.5T600-640v-160q0-17 11.5-28.5T640-840q17 0 28.5 11.5T680-800v40h120q17 0 28.5 11.5T840-720q0 17-11.5 28.5T800-680H680v40q0 17-11.5 28.5T640-600Zm-480-80q-17 0-28.5-11.5T120-720q0-17 11.5-28.5T160-760h320q17 0 28.5 11.5T520-720q0 17-11.5 28.5T480-680H160Z");
            var c = this;
            this.button.classList.add("shaka-resolution-button");
            this.button.classList.add("shaka-tooltip-status");
            this.menu.classList.add("shaka-resolutions");
            this.h = V("span");
            this.h.classList.add("shaka-current-auto-quality");
            this.h.style.display = "none";
            this.i = V("sup");
            this.i.classList.add("shaka-current-quality-mark");
            this.i.style.display = "none";
            Array.from(a.classList).includes("shaka-overflow-menu") ? this.parent.parentElement && (this.g = Oj(this.parent.parentElement)) : (this.g = V("span"), this.g.classList.add("shaka-overflow-playback-rate-mark"), this.button.appendChild(this.g));
            a = V("span");
            this.button.childNodes[1].appendChild(a);
            a.appendChild(this.currentSelection);
            a.appendChild(this.h);
            a.appendChild(this.i);
            this.eventManager.o(this.localization, "locale-updated", function() {
                xK(c);
            });
            this.eventManager.o(this.localization, "locale-changed", function() {
                xK(c);
            });
            this.eventManager.o(this.player, "loading", function() {
                yK(c);
                zK(c);
            });
            this.eventManager.o(this.player, "loaded", function() {
                yK(c);
                zK(c);
            });
            this.eventManager.o(this.player, "unloading", function() {
                yK(c);
                zK(c);
            });
            this.eventManager.o(this.player, "variantchanged", function() {
                yK(c);
                zK(c);
            });
            this.eventManager.o(this.player, "trackschanged", function() {
                yK(c);
                zK(c);
            });
            this.eventManager.o(this.player, "abrstatuschanged", function() {
                yK(c);
                zK(c);
            });
            this.eventManager.o(this.player, "adaptation", function() {
                yK(c);
                zK(c);
            });
            yK(this);
        }
        la(wK, rJ);
        function zK(a) {
            var b = a.player.getConfiguration().abr.enabled;
            if (a.player.Ld()) {
                a.i.textContent = "";
                a.i.style.display = "none";
                a.g && (a.g.textContent = "", a.g.style.display = "none");
                var c = a.player.Ob() || [], d = c.find(function(e) {
                    return e.active;
                });
                d && (b ? (a.h.textContent = d.bandwidth ? JK(a, d, c) : "Unknown", a.h.style.display = "") : a.h.style.display = "none");
            } else c = a.player.getVideoTracks() || [], (d = c.find(function(e) {
                return e.active;
            })) ? (b ? (a.h.textContent = d.height && d.width ? KK(a, d, c) : d.bandwidth ? LK(d.bandwidth) : "Unknown", a.h.style.display = "") : a.h.style.display = "none", b = MK(a, d.width, d.height), a.i.textContent = b, a.i.style.display = b !== "" ? "" : "none", a.g && (a.g.textContent = b, a.g.style.display = b !== "" ? "" : "none")) : a.g && (b = a.player.getStats(), b = MK(a, b.width, b.height), a.g.textContent = b, a.g.style.display = b !== "" ? "" : "none");
        }
        function MK(a, b, c) {
            if (!b || !c) return "";
            c > b && (c = u([
                c,
                b
            ]), b = c.next().value, c = c.next().value);
            b / c > 16 / 9 && (c = Math.round(b * 9 / 16));
            a = a.controls.g.qualityMarks;
            return c >= 8640 ? c + "p" : c >= 4320 ? a["4320"] : c >= 2160 ? a["2160"] : c >= 1440 ? a["1440"] : c >= 1080 ? a["1080"] : c >= 720 ? a["720"] : "";
        }
        function yK(a) {
            var b = NG(a.menu);
            Pj(a.menu);
            a.menu.appendChild(b);
            b = 0;
            b = a.player.Ld() ? NK(a) : OK(a);
            var c = Lj();
            c.classList.add("shaka-enable-abr-button");
            a.eventManager.o(c, "click", function() {
                a.player.configure({
                    abr: {
                        enabled: !0
                    }
                });
                yK(a);
            });
            a.l = V("span");
            a.l.textContent = a.localization.resolve("AUTO_QUALITY");
            c.appendChild(a.l);
            a.player.getConfiguration().abr.enabled && (c.ariaSelected = "true", c.appendChild(QG()), a.l.classList.add("shaka-chosen-item"), a.currentSelection.textContent = a.localization.resolve("AUTO_QUALITY"));
            a.button.setAttribute("shaka-status", a.currentSelection.textContent);
            a.menu.appendChild(c);
            PG(a.menu);
            a.controls.dispatchEvent(new T("resolutionselectionupdated"));
            xK(a);
            RG(a.button, b > 0);
        }
        function NK(a) {
            var b = [];
            a.player.l == zr || a.player.Da() || (b = a.player.Ob() || []);
            var c = b.find(function(k) {
                return k.active;
            });
            c && (b = b.filter(function(k) {
                if (k.language != c.language || a.controls.g.showAudioChannelCountVariants && k.channelsCount && c.channelsCount && k.channelsCount != c.channelsCount) return !1;
                var l = a.controls.g.trackLabelFormat;
                return (l == 1 || l == 2) && JSON.stringify(k.audioRoles) != JSON.stringify(c.audioRoles) || l == 3 && k.label != c.label || !k.bandwidth ? !1 : !0;
            }));
            b = b.filter(function(k, l) {
                return b.findIndex(function(m) {
                    return m.bandwidth == k.bandwidth;
                }) == l;
            });
            b.sort(function(k, l) {
                return l.bandwidth - k.bandwidth;
            });
            for(var d = a.player.getConfiguration().abr.enabled, e = u(b), f = e.next(), g = {}; !f.done; g = {
                Ke: void 0
            }, f = e.next()){
                g.Ke = f.value;
                f = Lj();
                f.classList.add("explicit-resolution");
                a.eventManager.o(f, "click", function(k) {
                    return function() {
                        var l = k.Ke;
                        a.player.configure({
                            abr: {
                                enabled: !1
                            }
                        });
                        a.player.Ge(l, a.controls.g.clearBufferOnQualityChange);
                    };
                }(g));
                var h = V("span");
                h.textContent = g.Ke.bandwidth ? JK(a, g.Ke, b) : "Unknown";
                f.appendChild(h);
                d || g.Ke != c || (f.ariaSelected = "true", f.appendChild(QG()), h.classList.add("shaka-chosen-item"), a.currentSelection.textContent = h.textContent);
                a.menu.appendChild(f);
            }
            return b.length;
        }
        function OK(a) {
            var b = a.player.getVideoTracks() || [], c = b.find(function(m) {
                return m.active;
            });
            b = b.filter(function(m, n) {
                return b.findIndex(function(q) {
                    var r = q.height == m.height && q.bandwidth == m.bandwidth && q.frameRate == m.frameRate && q.hdr == m.hdr && q.videoLayout == m.videoLayout && Sc(q.roles, m.roles);
                    r && a.controls.g.showVideoCodec && q.codecs && m.codecs && (r = jf(q.codecs) == jf(m.codecs));
                    return r;
                }) == n;
            });
            b.sort(function(m, n) {
                return n.height == m.height || m.height == null || n.height == null ? n.bandwidth - m.bandwidth : n.height - m.height;
            });
            for(var d = a.player.getConfiguration().abr.enabled, e = u(b), f = e.next(), g = {}; !f.done; g = {
                nc: void 0
            }, f = e.next()){
                g.nc = f.value;
                f = Lj();
                f.classList.add("explicit-resolution");
                a.eventManager.o(f, "click", function(m) {
                    return function() {
                        var n = m.nc;
                        a.player.configure({
                            abr: {
                                enabled: !1
                            }
                        });
                        a.player.Ij(n, a.controls.g.clearBufferOnQualityChange);
                    };
                }(g));
                var h = V("span");
                h.textContent = g.nc.height && g.nc.width ? KK(a, g.nc, b) : g.nc.bandwidth ? LK(g.nc.bandwidth) : "Unknown";
                f.appendChild(h);
                var k = MK(a, g.nc.width, g.nc.height);
                if (k !== "") {
                    var l = V("sup");
                    l.classList.add("shaka-quality-mark");
                    l.textContent = k;
                    f.appendChild(l);
                }
                d || g.nc != c || (f.ariaSelected = "true", f.appendChild(QG()), h.classList.add("shaka-chosen-item"), a.currentSelection.textContent = h.textContent);
                a.menu.appendChild(f);
            }
            return b.length;
        }
        function KK(a, b, c) {
            function d(m, n) {
                return m != n && m.height == n.height && m.hdr == n.hdr && e(m) == e(n) && Math.round(m.frameRate || 0) == Math.round(n.frameRate || 0);
            }
            function e(m) {
                return m.codecs ? jf(m.codecs).startsWith("dovi-") : !1;
            }
            var f = b.height || 0, g = b.width || 0;
            f > g && (f = u([
                f,
                g
            ]), g = f.next().value, f = f.next().value);
            var h = f;
            g / f > 16 / 9 && (h = Math.round(g * 9 / 16));
            g = h + "p";
            f = new Set;
            h = u(c);
            for(var k = h.next(); !k.done; k = h.next())k = k.value, k.frameRate && f.add(Math.round(k.frameRate));
            f.size > 1 && (f = b.frameRate) && (f >= 50 || f <= 20) && (g += Math.round(b.frameRate));
            if (b.hdr == "PQ" || b.hdr == "HLG") g = e(b) ? g + " Dolby Vision" : g + " HDR";
            (b.videoLayout || "").includes("CH-STEREO") && (g += " 3D");
            if (c.some(function(m) {
                return d(b, m);
            }) && (c.some(function(m) {
                return d(b, m) && m.bandwidth == b.bandwidth;
            }) || (g += " (" + LK(b.bandwidth) + ")"), a.controls.g.showVideoCodec)) {
                var l = function(m) {
                    var n = "";
                    m && (n = jf(m).toUpperCase());
                    return n ? " " + n : n;
                };
                c.some(function(m) {
                    return d(b, m) && l(m.codecs) != l(b.codecs);
                }) && (g += l(b.codecs));
            }
            return g;
        }
        function JK(a, b, c) {
            var d = LK(b.bandwidth);
            if (a.controls.g.showAudioCodec) {
                var e = function(f) {
                    var g = "";
                    f && (g = jf(f).toUpperCase());
                    return g ? " " + g : g;
                };
                c.some(function(f) {
                    return e(f.codecs) != e(b.codecs);
                }) && (d += e(b.codecs));
            }
            return d;
        }
        function LK(a) {
            return a >= 1E6 ? (a / 1E6).toFixed(1).replace(".0", "") + " Mbps" : Math.floor(a / 1E3) + " Kbps";
        }
        function xK(a) {
            var b = a.player.Ld() ? "QUALITY" : "RESOLUTION";
            a.button.ariaLabel = a.localization.resolve(b);
            a.backButton.ariaLabel = a.localization.resolve(b);
            a.backSpan.textContent = a.localization.resolve(b);
            a.nameSpan.textContent = a.localization.resolve(b);
            a.l.textContent = a.localization.resolve("AUTO_QUALITY");
            a.player.getConfiguration().abr.enabled && (a.currentSelection.textContent = a.localization.resolve("AUTO_QUALITY"));
        }
        S("shaka.ui.ResolutionSelection", wK);
        function PK() {}
        PK.prototype.create = function(a, b) {
            return new wK(a, b);
        };
        OI("quality", new PK);
        iI("quality", new PK);
        function QK(a, b) {
            LG.call(this, a, b);
            var c = this;
            this.g = Lj();
            this.g.classList.add("shaka-rewind-button");
            this.g.classList.add("shaka-tooltip-status");
            this.g.setAttribute("shaka-status", this.localization.resolve("OFF"));
            new MG(this.g).use("M798-281 550-447q-9-6-13.5-14.5T532-480q0-10 4.5-18.5T550-513l248-166q5-4 11-5t11-1q16 0 28 11t12 29v330q0 18-12 29t-28 11q-5 0-11-1t-11-5Zm-400 0L150-447q-9-6-13.5-14.5T132-480q0-10 4.5-18.5T150-513l248-166q5-4 11-5t11-1q16 0 28 11t12 29v330q0 18-12 29t-28 11q-5 0-11-1t-11-5Z");
            this.parent.appendChild(this.g);
            RK(this);
            this.h = this.controls.g.rewindRates;
            this.eventManager.o(this.localization, "locale-updated", function() {
                RK(c);
            });
            this.eventManager.o(this.localization, "locale-changed", function() {
                RK(c);
            });
            this.eventManager.o(this.g, "click", function() {
                if (c.controls.Ca() && c.video.duration) {
                    var d = c.h.indexOf(c.player.Za()) + 1;
                    d = d != c.h.length ? c.h[d] : c.h[0];
                    c.video.paused && c.video.play();
                    c.player.sc(d);
                    c.g.setAttribute("shaka-status", d + "x");
                }
            });
            this.eventManager.o(this.player, "ratechange", function() {
                c.g.setAttribute("shaka-status", c.player.Za() + "x");
            });
        }
        la(QK, LG);
        function RK(a) {
            a.g.ariaLabel = a.localization.resolve("REWIND");
        }
        S("shaka.ui.RewindButton", QK);
        function SK() {}
        SK.prototype.create = function(a, b) {
            return new QK(a, b);
        };
        iI("rewind", new SK);
        function TK(a, b) {
            LG.call(this, a, b);
            var c = this;
            this.j = this.controls.F;
            this.g = Lj();
            this.g.classList.add("shaka-save.video-frame-button");
            this.g.classList.add("shaka-tooltip");
            new MG(this.g, "M480-337q-8 0-15-2.5t-13-8.5L308-492q-12-12-11.5-28t11.5-28q12-12 28.5-12.5T365-549l75 75v-286q0-17 11.5-28.5T480-800q17 0 28.5 11.5T520-760v286l75-75q12-12 28.5-11.5T652-548q11 12 11.5 28T652-492L508-348q-6 6-13 8.5t-15 2.5ZM240-160q-33 0-56.5-23.5T160-240v-80q0-17 11.5-28.5T200-360q17 0 28.5 11.5T240-320v80h480v-80q0-17 11.5-28.5T760-360q17 0 28.5 11.5T800-320v80q0 33-23.5 56.5T720-160H240Z");
            a = V("label");
            a.classList.add("shaka-overflow-button-label");
            a.classList.add("shaka-overflow-menu-only");
            this.h = V("span");
            this.h.textContent = this.localization.resolve("DOWNLOAD_VIDEO_FRAME");
            a.appendChild(this.h);
            this.i = V("span");
            this.i.classList.add("shaka-current-selection-span");
            a.appendChild(this.i);
            this.g.appendChild(a);
            UK(this);
            this.parent.appendChild(this.g);
            this.eventManager.o(this.localization, "locale-updated", function() {
                UK(c);
            });
            this.eventManager.o(this.localization, "locale-changed", function() {
                UK(c);
            });
            this.eventManager.o(this.g, "click", function() {
                var d = document.createElement("canvas"), e = d.getContext("2d"), f = c.controls.u;
                d.width = f.videoWidth;
                d.height = f.videoHeight;
                e.drawImage(f, 0, 0, d.width, d.height);
                d = d.toDataURL("image/png");
                e = document.createElement("a");
                e.href = d;
                e.download = "videoframe_" + f.currentTime.toFixed(3) + ".png";
                e.click();
            });
            this.eventManager.o(this.controls.D, "vrstatuschanged", function() {
                VK(c);
            });
            this.eventManager.o(this.adManager, "ad-started", function() {
                VK(c);
            });
            this.eventManager.o(this.adManager, "ad-stopped", function() {
                VK(c);
            });
            this.eventManager.o(this.player, "unloading", function() {
                VK(c);
            });
            this.eventManager.o(this.player, "loaded", function() {
                VK(c);
            });
            this.eventManager.o(this.video, "play", function() {
                VK(c);
            });
            this.eventManager.o(this.video, "pause", function() {
                VK(c);
            });
            this.eventManager.o(this.video, "seeking", function() {
                VK(c);
            });
            this.eventManager.o(this.controls, "caststatuschanged", function() {
                VK(c);
            });
            VK(this);
        }
        la(TK, LG);
        function VK(a) {
            var b = !0;
            a.controls.Xb() && (b = !1);
            b && a.j.Qa() && (b = !1);
            b && (a.player.drmInfo() || a.player.Ld()) && (b = !1);
            b && a.ad && (b = !1);
            b && a.video.remote && a.video.remote.state != "disconnected" && (b = !1);
            RG(a.g, b);
        }
        function UK(a) {
            a.g.ariaLabel = a.localization.resolve("DOWNLOAD_VIDEO_FRAME");
            a.h.textContent = a.localization.resolve("DOWNLOAD_VIDEO_FRAME");
        }
        S("shaka.ui.SaveVideoFrameButton", TK);
        function WK() {}
        WK.prototype.create = function(a, b) {
            return new TK(a, b);
        };
        OI("save_video_frame", new WK);
        WG("save_video_frame", new WK);
        function XK(a, b) {
            LG.call(this, a, b);
            var c = this;
            if (this.g = this.player.vf()) this.h = Lj(), this.h.classList.add("shaka-skip-next-button"), this.h.classList.add("shaka-tooltip"), new MG(this.h).use("M660-280v-400q0-17 11.5-28.5T700-720q17 0 28.5 11.5T740-680v400q0 17-11.5 28.5T700-240q-17 0-28.5-11.5T660-280Zm-440-35v-330q0-18 12-29t28-11q5 0 11 1t11 5l248 166q9 6 13.5 14.5T548-480q0 10-4.5 18.5T530-447L282-281q-5 4-11 5t-11 1q-16 0-28-11t-12-29Z"), this.parent.appendChild(this.h), YK(this), ZK(this), this.eventManager.o(this.localization, "locale-updated", function() {
                YK(c);
            }), this.eventManager.o(this.localization, "locale-changed", function() {
                YK(c);
            }), this.eventManager.o(this.h, "click", function() {
                c.controls.Ca() && c.g.playItem(c.g.getCurrentItemIndex() + 1);
            }), this.eventManager.o(this.g, "currentitemchanged", function() {
                ZK(c);
            }), this.eventManager.o(this.g, "itemsinserted", function() {
                ZK(c);
            }), this.eventManager.o(this.g, "itemsremoved", function() {
                ZK(c);
            }), this.eventManager.o(this.player, "loading", function() {
                ZK(c);
            });
        }
        la(XK, LG);
        function YK(a) {
            a.h.ariaLabel = a.localization.resolve("SKIP_NEXT");
        }
        function ZK(a) {
            var b = a.g.getItems().length;
            b = b > 1 && a.g.getCurrentItemIndex() + 1 < b;
            RG(a.h, b);
        }
        S("shaka.ui.SkipNextButton", XK);
        function $K() {}
        $K.prototype.create = function(a, b) {
            return new XK(a, b);
        };
        iI("skip_next", new $K);
        function aL(a, b) {
            LG.call(this, a, b);
            var c = this;
            if (this.g = this.player.vf()) this.h = Lj(), this.h.classList.add("shaka-skip-previous-button"), this.h.classList.add("shaka-tooltip"), new MG(this.h).use("M220-280v-400q0-17 11.5-28.5T260-720q17 0 28.5 11.5T300-680v400q0 17-11.5 28.5T260-240q-17 0-28.5-11.5T220-280Zm458-1L430-447q-9-6-13.5-14.5T412-480q0-10 4.5-18.5T430-513l248-166q5-4 11-5t11-1q16 0 28 11t12 29v330q0 18-12 29t-28 11q-5 0-11-1t-11-5Z"), this.parent.appendChild(this.h), bL(this), cL(this), this.eventManager.o(this.localization, "locale-updated", function() {
                bL(c);
            }), this.eventManager.o(this.localization, "locale-changed", function() {
                bL(c);
            }), this.eventManager.o(this.h, "click", function() {
                c.controls.Ca() && c.g.playItem(c.g.getCurrentItemIndex() - 1);
            }), this.eventManager.o(this.g, "currentitemchanged", function() {
                cL(c);
            }), this.eventManager.o(this.g, "itemsinserted", function() {
                cL(c);
            }), this.eventManager.o(this.g, "itemsremoved", function() {
                cL(c);
            }), this.eventManager.o(this.player, "loading", function() {
                cL(c);
            });
        }
        la(aL, LG);
        function bL(a) {
            a.h.ariaLabel = a.localization.resolve("SKIP_PREVIOUS");
        }
        function cL(a) {
            var b = a.g.getItems().length > 1 && a.g.getCurrentItemIndex() > 0;
            RG(a.h, b);
        }
        S("shaka.ui.SkipPreviousButton", aL);
        function dL() {}
        dL.prototype.create = function(a, b) {
            return new aL(a, b);
        };
        iI("skip_previous", new dL);
        function eL(a, b) {
            YG.call(this, a, b);
            this.button.classList.add("shaka-small-play-button");
            this.button.classList.add("shaka-tooltip");
        }
        la(eL, YG);
        S("shaka.ui.SmallPlayButton", eL);
        function fL() {}
        fL.prototype.create = function(a, b) {
            return new eL(a, b);
        };
        iI("play_pause", new fL);
        function gL(a, b) {
            LG.call(this, a, b);
            a = V("div");
            a.classList.add("shaka-spacer");
            a.ariaHidden = "true";
            this.parent.appendChild(a);
        }
        la(gL, LG);
        S("shaka.ui.Spacer", gL);
        function hL() {}
        hL.prototype.create = function(a, b) {
            return new gL(a, b);
        };
        iI("spacer", new hL);
        function iL(a, b) {
            function c(m) {
                m = parseInt(l.g[m], 10);
                return m > 2E9 ? (m / 1E9).toFixed(2) + "GB" : m > 1E6 ? (m / 1E6).toFixed(2) + "MB" : m > 1E3 ? (m / 1E3).toFixed(2) + "KB" : m + "B";
            }
            function d(m) {
                return l.g[m] + " (gaps)";
            }
            function e(m) {
                return SG(l.g[m], !1) + " (m)";
            }
            function f(m) {
                return Math.round(l.g[m] / 1E3) + " (kbits/s)";
            }
            function g(m) {
                return l.g[m].toFixed(2) + " (s)";
            }
            function h(m) {
                return l.g[m] + " (frames)";
            }
            function k(m) {
                return l.g[m] + " (px)";
            }
            LG.call(this, a, b);
            var l = this;
            this.i = Lj();
            this.i.classList.add("shaka-statistics-button");
            this.u = new MG(this.i, "M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Zm120 200q-17 0-28.5 11.5T280-520v200q0 17 11.5 28.5T320-280q17 0 28.5-11.5T360-320v-200q0-17-11.5-28.5T320-560Zm160-120q-17 0-28.5 11.5T440-640v320q0 17 11.5 28.5T480-280q17 0 28.5-11.5T520-320v-320q0-17-11.5-28.5T480-680Zm160 240q-17 0-28.5 11.5T600-400v80q0 17 11.5 28.5T640-280q17 0 28.5-11.5T680-320v-80q0-17-11.5-28.5T640-440Z");
            a = V("label");
            a.classList.add("shaka-overflow-button-label");
            a.classList.add("shaka-simple-overflow-button-label-inline");
            this.A = V("span");
            a.appendChild(this.A);
            this.l = V("span");
            this.l.classList.add("shaka-current-selection-span");
            a.appendChild(this.l);
            this.i.appendChild(a);
            this.parent.appendChild(this.i);
            this.h = V("div");
            this.h.classList.add("shaka-no-propagation");
            this.h.classList.add("shaka-show-controls-on-mouse-over");
            this.h.classList.add("shaka-statistics-container");
            this.h.classList.add("shaka-hidden");
            this.controls.i.appendChild(this.h);
            this.D = [];
            this.F = [
                "stateHistory",
                "switchHistory"
            ];
            this.g = this.player.getStats();
            this.m = new Map;
            this.C = (new Map).set("width", k).set("height", k).set("currentCodecs", function(m) {
                return l.g[m];
            }).set("completionPercent", function(m) {
                return l.g[m] + " (%)";
            }).set("bufferingTime", g).set("drmTimeSeconds", g).set("licenseTime", g).set("liveLatency", g).set("loadLatency", g).set("manifestTimeSeconds", g).set("estimatedBandwidth", f).set("streamBandwidth", f).set("maxSegmentDuration", g).set("pauseTime", e).set("playTime", e).set("corruptedFrames", h).set("decodedFrames", h).set("droppedFrames", h).set("stallsDetected", function(m) {
                return l.g[m] + " (stalls)";
            }).set("gapsJumped", d).set("manifestSizeBytes", c).set("bytesDownloaded", c).set("nonFatalErrorCount", function(m) {
                return l.g[m] + " (errors)";
            }).set("manifestPeriodCount", function(m) {
                return l.g[m] + " (periods)";
            }).set("manifestGapCount", d);
            this.j = new Bf(function() {
                l.g = l.player.getStats();
                for(var m = u(l.D), n = m.next(); !n.done; n = m.next()){
                    var q = n.value;
                    n = l.m.get(q);
                    n.textContent = l.C.get(q)(q);
                    n && n.parentElement && (q = l.g[q], typeof q == "string" ? RG(n.parentElement, q != "") : RG(n.parentElement, !isNaN(q)));
                }
            });
            jL(this);
            kL(this);
            this.eventManager.o(this.localization, "locale-updated", function() {
                jL(l);
            });
            this.eventManager.o(this.localization, "locale-changed", function() {
                jL(l);
            });
            this.eventManager.o(this.i, "click", function() {
                lL(l);
                jL(l);
            });
        }
        la(iL, LG);
        function lL(a) {
            a.h.classList.contains("shaka-hidden") ? (a.u.use("M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm120-440q-17 0-28.5 11.5T280-520v200q0 17 11.5 28.5T320-280q17 0 28.5-11.5T360-320v-200q0-17-11.5-28.5T320-560Zm160-120q-17 0-28.5 11.5T440-640v320q0 17 11.5 28.5T480-280q17 0 28.5-11.5T520-320v-320q0-17-11.5-28.5T480-680Zm160 240q-17 0-28.5 11.5T600-400v80q0 17 11.5 28.5T640-280q17 0 28.5-11.5T680-320v-80q0-17-11.5-28.5T640-440Z"), a.j.wa(.1), RG(a.h, !0)) : (a.u.use("M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Zm120 200q-17 0-28.5 11.5T280-520v200q0 17 11.5 28.5T320-280q17 0 28.5-11.5T360-320v-200q0-17-11.5-28.5T320-560Zm160-120q-17 0-28.5 11.5T440-640v320q0 17 11.5 28.5T480-280q17 0 28.5-11.5T520-320v-320q0-17-11.5-28.5T480-680Zm160 240q-17 0-28.5 11.5T600-400v80q0 17 11.5 28.5T640-280q17 0 28.5-11.5T680-320v-80q0-17-11.5-28.5T640-440Z"), a.j.stop(), RG(a.h, !1));
        }
        function jL(a) {
            a.A.textContent = a.localization.resolve("STATISTICS");
            a.i.ariaLabel = a.localization.resolve("STATISTICS");
            a.l.textContent = a.localization.resolve(a.h.classList.contains("shaka-hidden") ? "OFF" : "ON");
        }
        function mL(a, b) {
            var c = V("div"), d = V("label");
            d.textContent = b + ":";
            c.appendChild(d);
            d = V("span");
            d.textContent = a.C.get(b)(b);
            c.appendChild(d);
            a.m.set(b, d);
            return c;
        }
        function kL(a) {
            var b = V("div");
            b.classList.add("shaka-no-propagation");
            b.classList.add("shaka-statistics-close");
            var c = new MG(b, "M480-424 284-228q-11 11-28 11t-28-11q-11-11-11-28t11-28l196-196-196-196q-11-11-11-28t11-28q11-11 28-11t28 11l196 196 196-196q11-11 28-11t28 11q11 11 11 28t-11 28L536-480l196 196q11 11 11 28t-11 28q-11 11-28 11t-28-11L480-424Z").g;
            c.classList.add("material-icons", "notranslate");
            a.h.appendChild(b);
            a.eventManager.o(c, "click", function() {
                lL(a);
            });
            b = u(a.controls.g.statisticsList);
            for(c = b.next(); !c.done; c = b.next())if (c = c.value, c in a.g && !a.F.includes(c)) {
                var d = mL(a, c);
                a.h.appendChild(d);
                a.D.push(c);
            } else ab("Unrecognized statistic element:", c);
        }
        iL.prototype.release = function() {
            this.j.stop();
            this.j = null;
            LG.prototype.release.call(this);
        };
        S("shaka.ui.StatisticsButton", iL);
        function nL() {}
        nL.prototype.create = function(a, b) {
            return new iL(a, b);
        };
        OI("statistics", new nL);
        WG("statistics", new nL);
        function oL(a, b) {
            rJ.call(this, a, b, "M200-160q-33 0-56.5-23.5T120-240v-480q0-33 23.5-56.5T200-800h560q33 0 56.5 23.5T840-720v480q0 33-23.5 56.5T760-160H200Zm80-200h120q17 0 28.5-11.5T440-400v-20q0-9-6-15t-15-6h-18q-9 0-15 6t-6 15h-80v-120h80q0 9 6 15t15 6h18q9 0 15-6t6-15v-20q0-17-11.5-28.5T400-600H280q-17 0-28.5 11.5T240-560v160q0 17 11.5 28.5T280-360Zm400-240H560q-17 0-28.5 11.5T520-560v160q0 17 11.5 28.5T560-360h120q17 0 28.5-11.5T720-400v-20q0-9-6-15t-15-6h-18q-9 0-15 6t-6 15h-80v-120h80q0 9 6 15t15 6h18q9 0 15-6t6-15v-20q0-17-11.5-28.5T680-600Z");
            var c = this;
            this.button.classList.add("shaka-caption-button");
            this.button.classList.add("shaka-tooltip-status");
            this.menu.classList.add("shaka-text-languages");
            this.player && this.player.Xc() ? this.button.ariaPressed = "true" : this.button.ariaPressed = "false";
            pL(this);
            this.eventManager.o(this.localization, "locale-updated", function() {
                qL(c);
                rL(c);
            });
            this.eventManager.o(this.localization, "locale-changed", function() {
                qL(c);
                rL(c);
            });
            this.eventManager.o(this.player, "loading", function() {
                sL(c);
                rL(c);
            });
            this.eventManager.o(this.player, "loaded", function() {
                sL(c);
                rL(c);
            });
            this.eventManager.o(this.player, "unloading", function() {
                sL(c);
                rL(c);
            });
            this.eventManager.o(this.player, "texttrackvisibility", function() {
                sL(c);
                rL(c);
            });
            this.eventManager.o(this.player, "textchanged", function() {
                rL(c);
            });
            this.eventManager.o(this.player, "trackschanged", function() {
                rL(c);
            });
            sL(this);
            qL(this);
            rL(this);
        }
        la(oL, rJ);
        function pL(a) {
            var b = Lj();
            b.ariaSelected = "true";
            a.menu.appendChild(b);
            b.appendChild(QG());
            a.g = V("span");
            b.appendChild(a.g);
        }
        function sL(a) {
            a.player.Xc() ? (a.icon.use("M200-160q-33 0-56.5-23.5T120-240v-480q0-33 23.5-56.5T200-800h560q33 0 56.5 23.5T840-720v480q0 33-23.5 56.5T760-160H200Zm80-200h120q17 0 28.5-11.5T440-400v-20q0-9-6-15t-15-6h-18q-9 0-15 6t-6 15h-80v-120h80q0 9 6 15t15 6h18q9 0 15-6t6-15v-20q0-17-11.5-28.5T400-600H280q-17 0-28.5 11.5T240-560v160q0 17 11.5 28.5T280-360Zm400-240H560q-17 0-28.5 11.5T520-560v160q0 17 11.5 28.5T560-360h120q17 0 28.5-11.5T720-400v-20q0-9-6-15t-15-6h-18q-9 0-15 6t-6 15h-80v-120h80q0 9 6 15t15 6h18q9 0 15-6t6-15v-20q0-17-11.5-28.5T680-600Z"), a.button.ariaPressed = "true") : (a.icon.use("M791-57 687-160H200q-33 0-56.5-23.5T120-240v-487l-65-65q-12-12-12-28.5T55-849q12-12 28.5-12t28.5 12l736 736q12 12 12 28t-12 28q-12 12-28.5 12T791-57ZM280-360h120q17 0 28.5-11.5T440-400v-25q0-8-6-14t-14-6h-20q-8 0-14 6t-6 14v5h-80v-127l-45-45v1q-7 5-11 13t-4 18v160q0 17 11.5 28.5T280-360Zm560-360v388q0 27-24.5 37.5T772-303l-66-66q7-5 10.5-13.5T720-400v-20q0-8-6-14t-14-6h-20q-8 0-14 6t-6 14h-5l-75-75v-45h80v5q0 8 6 14t14 6h20q8 0 14-6t6-14v-25q0-17-11.5-28.5T680-600H560q-17 0-28.5 11.5T520-560v5L343-732q-19-19-8.5-43.5T372-800h388q33 0 56.5 23.5T840-720Z"), a.button.ariaPressed = "false");
            a.controls.dispatchEvent(new T("captionselectionupdated"));
        }
        function rL(a) {
            var b = a.player.yc() || [];
            qJ(b, a.menu, function(d) {
                return tL(a, d);
            }, a.player.Xc(), a.currentSelection, a.localization, a.controls.g.textTrackLabelFormat);
            var c = Lj();
            c.classList.add("shaka-turn-captions-off-button");
            a.eventManager.o(c, "click", function() {
                a.player.Zd(!1);
                rL(a);
            });
            c.appendChild(a.g);
            a.menu.appendChild(c);
            a.player.Xc() ? a.g.classList.remove("shaka-chosen-item") : (c.ariaSelected = "true", c.appendChild(QG()), a.g.classList.add("shaka-chosen-item"), a.currentSelection.textContent = a.localization.resolve("OFF"));
            a.button.setAttribute("shaka-status", a.currentSelection.textContent);
            PG(a.menu);
            a.controls.dispatchEvent(new T("captionselectionupdated"));
            RG(a.button, b.length > 0);
        }
        function tL(a, b) {
            return Q(function(c) {
                if (c.g == 1) return a.player.fg(b), F(c, a.player.Zd(!0), 2);
                a.player.configure("preferredTextLanguage", b.language);
                a.player.configure("preferForcedSubs", b.forced);
                H(c);
            });
        }
        function qL(a) {
            a.button.ariaLabel = a.localization.resolve("CAPTIONS");
            a.backButton.ariaLabel = a.localization.resolve("BACK");
            a.nameSpan.textContent = a.localization.resolve("CAPTIONS");
            a.backSpan.textContent = a.localization.resolve("CAPTIONS");
            a.g.textContent = a.localization.resolve("OFF");
        }
        S("shaka.ui.TextSelection", oL);
        function uL() {}
        uL.prototype.create = function(a, b) {
            return new oL(a, b);
        };
        OI("captions", new uL);
        iI("captions", new uL);
        function vL(a, b) {
            LG.call(this, a, b);
            var c = this;
            this.g = Lj();
            this.g.classList.add("shaka-toggle-stereoscopic-button");
            this.g.classList.add("shaka-tooltip");
            this.g.ariaPressed = "false";
            new MG(this.g, "M620-360H520q-8 0-14-6t-6-14v-200q0-8 6-14t14-6h100q17 0 28.5 11.5T660-560v160q0 17-11.5 28.5T620-360Zm-200 0h-90q-13 0-21.5-8.5T300-390q0-13 8.5-21.5T330-420h70v-40h-40q-8 0-14-6t-6-14q0-8 6-14t14-6h40v-40h-70q-13 0-21.5-8.5T300-570q0-13 8.5-21.5T330-600h90q17 0 28.5 11.5T460-560v160q0 17-11.5 28.5T420-360Zm140-60h40v-120h-40v120Zm280-20q-17 0-28.5-11.5T800-480q0-115-72.5-203T542-794l30 30q11 11 11 28t-11 28q-11 11-28 11t-28-11L387-837q-8-8-4.5-20t14.5-15q20-5 41-6.5t42-1.5q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 17-11.5 28.5T840-440ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-17 11.5-28.5T120-520q17 0 28.5 11.5T160-480q0 115 72.5 203T418-166l-30-30q-11-11-11-28t11-28q11-11 28-11t28 11l129 129q8 8 4.5 20T563-88q-20 5-41 6.5T480-80Z");
            a = V("label");
            a.classList.add("shaka-overflow-button-label");
            a.classList.add("shaka-overflow-menu-only");
            this.i = V("span");
            a.appendChild(this.i);
            this.h = V("span");
            this.h.classList.add("shaka-current-selection-span");
            a.appendChild(this.h);
            this.g.appendChild(a);
            this.parent.appendChild(this.g);
            wL(this);
            this.eventManager.o(this.localization, "locale-updated", function() {
                wL(c);
            });
            this.eventManager.o(this.localization, "locale-changed", function() {
                wL(c);
            });
            var d = this.controls.D;
            this.eventManager.o(this.g, "click", function() {
                c.controls.Ca() && d.$d();
            });
            this.eventManager.o(d, "vrstatuschanged", function() {
                RG(c.g, c.controls.Xb());
            });
            RG(this.g, this.controls.Xb());
        }
        la(vL, LG);
        function wL(a) {
            a.g.ariaLabel = a.localization.resolve("TOGGLE_STEREOSCOPIC");
            a.i.textContent = a.localization.resolve("TOGGLE_STEREOSCOPIC");
        }
        S("shaka.ui.ToggleStereoscopicButton", vL);
        function xL() {}
        xL.prototype.create = function(a, b) {
            return new vL(a, b);
        };
        OI("toggle_stereoscopic", new xL);
        iI("toggle_stereoscopic", new xL);
        function yL(a, b) {
            fH.call(this, a, b, [
                "shaka-volume-bar-container"
            ], [
                "shaka-volume-bar"
            ]);
            var c = this;
            this.g = this.controls.g;
            this.g.alwaysShowVolumeBar || this.container.classList.add("shaka-volume-bar-container-allow-hiding");
            this.setRange(0, 100);
            this.eventManager.o(this.video, "volumechange", function() {
                return zL(c);
            });
            this.eventManager.o(this.player, "loading", function() {
                return zL(c);
            });
            this.eventManager.o(this.player, "loaded", function() {
                return AL(c);
            });
            this.eventManager.o(this.player, "unloading", function() {
                return AL(c);
            });
            this.eventManager.o(this.player, "trackschanged", function() {
                return AL(c);
            });
            this.eventManager.o(this.controls, "caststatuschanged", function() {
                return zL(c);
            });
            this.eventManager.o(this.adManager, "ad-volume-changed", function() {
                return BL(c);
            });
            this.eventManager.o(this.adManager, "ad-muted", function() {
                return BL(c);
            });
            this.eventManager.o(this.adManager, "ad-started", function() {
                return AL(c);
            });
            this.eventManager.o(this.adManager, "ad-stopped", function() {
                AL(c);
                zL(c);
            });
            this.eventManager.o(this.localization, "locale-updated", function() {
                return CL(c);
            });
            this.eventManager.o(this.localization, "locale-changed", function() {
                return CL(c);
            });
            zL(this);
            CL(this);
            if (this.ad) this.onChange();
            AL(this);
        }
        la(yL, fH);
        yL.prototype.onChange = function() {
            this.ad && this.ad.isLinear() ? this.ad.setVolume(this.getValue() / 100) : (this.video.volume = this.getValue() / 100, this.video.volume > 0 && (this.video.muted = !1));
        };
        function zL(a) {
            a.video.muted ? a.setValue(0) : a.setValue(a.video.volume * 100);
            DL(a);
        }
        function BL(a) {
            var b = a.ad.getVolume();
            a.setValue(b * 100);
            DL(a);
        }
        function DL(a) {
            var b = a.g.volumeBarColors, c = [
                "to right"
            ];
            c.push(b.level + a.getValue() + "%");
            c.push(b.base + a.getValue() + "%");
            c.push(b.base + "100%");
            a.container.style.background = "linear-gradient(" + c.join(",") + ")";
        }
        function CL(a) {
            a.bar.ariaLabel = a.localization.resolve("VOLUME");
        }
        function AL(a) {
            var b = !0;
            a.ad && a.ad.isLinear() ? b = !0 : a.player.Hh() && (b = !1);
            RG(a.container, b);
        }
        S("shaka.ui.VolumeBar", yL);
        function EL() {}
        EL.prototype.create = function(a, b) {
            return new yL(a, b);
        };
        iI("volume", new EL);
    }).call(exportTo, innerGlobal, innerGlobal, undefined);
    for(var k in exportTo.shaka)module.exports[k] = exportTo.shaka[k];
})();

});


parcelRegister("5pxJW", function(module, exports) {



module.exports = function(app) {
    var env = window.nomalab.aws;
    var Evaporate = (parcelRequire("kB1JX"));
    var SparkMD5 = (parcelRequire("3D2Yk"));
    var sha256 = (parcelRequire("cAIoR")).sha256;
    var evaporateInstance;
    var uploadCount = 0;
    var wakeLocking = null;
    var elmToJs = app.ports.uploadToJs;
    var jsToElm = app.ports.uploadToElm;
    function evaporateIdGen(key) {
        return decodeURIComponent(evaporateInstance.config.bucket + '/' + key);
    }
    elmToJs.subscribe(function(evt) {
        console.log("Upload to Js", evt.name, evt.event);
        switch(evt.name){
            case 'Upload':
                upload(evt.event);
                break;
            case 'Pause':
                evaporateInstance.pause(evaporateIdGen(evt.event), {
                    force: true
                });
                break;
            case 'Resume':
                evaporateInstance.resume(evaporateIdGen(evt.event));
                break;
            case 'Cancel':
                evaporateInstance.cancel(evaporateIdGen(evt.event));
                break;
        }
    });
    function onEvent(name, event) {
        // console.log("Upload to Elm", name, event)
        jsToElm.send({
            name: name,
            event: event
        });
    }
    Evaporate.create({
        signerUrl: "/v3/aws/signature",
        aws_key: env.awsKey,
        bucket: env.s3Bucket,
        awsRegion: env.awsRegion,
        awsSignatureVersion: env.awsSigVersion.slice(-1),
        s3Acceleration: true,
        logging: false,
        onlyRetryForSameFileName: true,
        cryptoMd5Method: function(data) {
            return btoa(SparkMD5.ArrayBuffer.hash(data, true));
        },
        // cryptoHmacMethod: function (signingKey, stringToSign) {
        //   return '';
        // },
        cryptoHexEncodedHash256: function(data) {
            return sha256(data);
        },
        computeContentMd5: true,
        allowS3ExistenceOptimization: true,
        s3FileCacheHoursAgo: 5,
        partSize: 104857600,
        encodeFilename: false,
        cloudfront: true
    }).then(function(instance) {
        if (instance.supported) evaporateInstance = instance;
        else onUnsupported();
    }).catch(function(err) {
        console.log("couldn't start Evaporate", err);
        onUnsupported();
    });
    function onUnsupported() {
        onEvent("Unsupported");
    }
    function upload(settings) {
        var source = settings.source;
        var fileId = settings.fileId;
        var key = settings.key;
        var userId = settings.userId;
        var file = settings.file;
        // This is actually the same id as the internal of Evaporate
        // but do not rely on it
        var evaporateId = evaporateIdGen(key);
        var lastProgress = 0, progressThrottle = 10000;
        var config = {
            name: key,
            file: file.blob,
            xAmzHeadersAtInitiate: {
                'x-amz-meta-user': '' + userId,
                'x-amz-meta-filename': '' + btoa(encodeURI(file.name)),
                'x-amz-meta-mime_type': '' + encodeURI(file.mimeType),
                'x-amz-meta-upload_start_time': new Date().toISOString()
            },
            started: onStarted,
            pausing: onPausing,
            paused: onPaused,
            resumed: onResumed,
            complete: onComplete,
            error: onError,
            uploadInitiated: onUploadInitiated,
            cancelled: onCancelled,
            progress: function(percentage, stats) {
                if (percentage >= 1 || Date.now() - progressThrottle > lastProgress) {
                    lastProgress = Date.now();
                    onProgress(percentage, stats);
                }
            }
        };
        try {
            evaporateInstance.add(config, {
                signParams: {
                    fileId: fileId,
                    source: source
                }
            }).catch(function(err) {
                // the user probably cancelled the operation
                // but we will react on the event rather than here
                console.log("Upload break", err);
            });
            onInit();
        } catch (err) {
            onError(err);
        }
        function onInit() {
            uploadStarted();
            onEvent("Created", {
                id: evaporateId,
                fileId: fileId,
                s3Id: null,
                name: file.name,
                progress: 0,
                progressedAt: new Date().toISOString(),
                pausing: false,
                pausedAt: null,
                size: file.size,
                mimeType: file.mimeType,
                blob: file.blob,
                secondsLeft: null,
                completedAt: null,
                error: null
            });
        }
        function onStarted() {
            onEvent("Started", {
                fileId: fileId
            });
        }
        function onComplete(xhr, awsObjectKey, stats) {
            uploadEnded();
            onEvent("Completed", {
                fileId: fileId,
                stats: normalizeStats(stats),
                s3Key: awsObjectKey,
                completedAt: new Date().toISOString()
            });
        }
        function onError(error) {
            uploadEnded();
            onEvent("Error", {
                fileId: fileId,
                error: error.toString()
            });
        }
        function onProgress(percentage, stats) {
            onEvent("Progress", {
                fileId: fileId,
                stats: normalizeStats(stats),
                progress: percentage,
                at: new Date().toISOString()
            });
        }
        function onPausing() {
            onEvent("Pausing", {
                fileId: fileId
            });
        }
        function onPaused() {
            uploadEnded();
            onEvent("Paused", {
                fileId: fileId,
                at: new Date().toISOString()
            });
        }
        function onResumed() {
            uploadStarted();
            onEvent("Resumed", {
                fileId: fileId
            });
        }
        function onUploadInitiated(s3UploadId) {
            onEvent("UploadInitiated", {
                fileId: fileId,
                s3UploadId: s3UploadId
            });
        }
        function onNameChanged(awsObjectKey) {
            onEvent("NameChanged", {
                fileId: fileId,
                s3Key: awsObjectKey
            });
        }
        function onCancelled() {
            uploadEnded();
            onEvent("Cancelled", {
                fileId: fileId
            });
        }
    }
    function uploadStarted() {
        uploadCount++;
        if ('wakeLock' in navigator && !wakeLocking) navigator.wakeLock.request('screen').then(function(w) {
            wakeLocking = w;
        });
    }
    function uploadEnded() {
        uploadCount--;
        if (uploadCount < 1 && wakeLocking && wakeLocking.release) {
            wakeLocking.release('screen');
            wakeLocking = null;
        }
    }
    function normalizeStats(stats) {
        if (stats.secondsLeft < 0) stats.secondsLeft = null;
        else stats.secondsLeft = stats.secondsLeft;
        // Looks like Evaporate might have a speed at NaN when resuming an upload
        if (isNaN(stats.speed)) {
            stats.speed = 0;
            stats.readableSpeed = '';
        }
        return stats;
    }
    window.addEventListener('beforeunload', function(e) {
        if (uploadCount > 0) {
            var message = "Vous avez des uploads en cours, voulez-vous abandonner ?";
            e.returnValue = message;
            return message;
        } else return true;
    });
} // enf of exports
;

});
parcelRegister("kB1JX", function(module, exports) {
/*Copyright (c) 2016, TT Labs, Inc.
 All rights reserved.

 Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

 Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.

 Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

 Neither the name of the TT Labs, Inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.*/ /***************************************************************************************************
 *                                                                                                 *
 *  version 2.1.4                                                                                  *
 *                                                                                                 *
 ***************************************************************************************************/ (function() {
    "use strict";
    var FAR_FUTURE = new Date('2060-10-22'), HOURS_AGO, PENDING = 0, EVAPORATING = 2, COMPLETE = 3, PAUSED = 4, CANCELED = 5, ERROR = 10, ABORTED = 20, PAUSING = 30, PAUSED_STATUSES = [
        PAUSED,
        PAUSING
    ], ACTIVE_STATUSES = [
        PENDING,
        EVAPORATING,
        ERROR
    ], ETAG_OF_0_LENGTH_BLOB = '"d41d8cd98f00b204e9800998ecf8427e"', PARTS_MONITOR_INTERVAL_MS = 120000, IMMUTABLE_OPTIONS = [
        'maxConcurrentParts',
        'logging',
        'cloudfront',
        'encodeFilename',
        'computeContentMd5',
        'allowS3ExistenceOptimization',
        'onlyRetryForSameFileName',
        'timeUrl',
        'cryptoMd5Method',
        'cryptoHexEncodedHash256',
        'awsRegion',
        'awsSignatureVersion',
        'evaporateChanged'
    ], S3_EXTRA_ENCODED_CHARS = {
        33: "%21",
        39: "%27",
        40: "%28",
        41: "%29",
        42: "%2A" // *
    }, l;
    var Evaporate = function(config) {
        this.config = extend({
            readableStreams: false,
            readableStreamPartMethod: null,
            bucket: null,
            logging: true,
            maxConcurrentParts: 5,
            partSize: 6291456,
            retryBackoffPower: 2,
            maxRetryBackoffSecs: 300,
            progressIntervalMS: 1000,
            cloudfront: false,
            s3Acceleration: false,
            mockLocalStorage: false,
            encodeFilename: true,
            computeContentMd5: false,
            allowS3ExistenceOptimization: false,
            onlyRetryForSameFileName: false,
            timeUrl: null,
            cryptoMd5Method: null,
            cryptoHexEncodedHash256: null,
            aws_key: null,
            awsRegion: 'us-east-1',
            awsSignatureVersion: '4',
            sendCanonicalRequestToSignerUrl: false,
            s3FileCacheHoursAgo: null,
            signParams: {},
            signHeaders: {},
            customAuthMethod: undefined,
            maxFileSize: null,
            signResponseHandler: null,
            xhrWithCredentials: false,
            // undocumented, experimental
            localTimeOffset: undefined,
            evaporateChanged: function() {},
            abortCompletionThrottlingMs: 1000
        }, config);
        if (typeof window !== 'undefined' && window.console) {
            l = window.console;
            l.d = l.log;
            l.w = window.console.warn ? l.warn : l.d;
            l.e = window.console.error ? l.error : l.d;
        }
        this._instantiationError = this.validateEvaporateOptions();
        if (typeof this._instantiationError === 'string') {
            this.supported = false;
            return;
        } else delete this._instantiationError;
        if (!this.config.logging) // Reset the logger to be a no_op
        l = noOpLogger();
        var _d = new Date();
        HOURS_AGO = new Date(_d.setHours(_d.getHours() - (this.config.s3FileCacheHoursAgo || -100)));
        if (typeof config.localTimeOffset === 'number') this.localTimeOffset = config.localTimeOffset;
        else {
            var self = this;
            Evaporate.getLocalTimeOffset(this.config).then(function(offset) {
                self.localTimeOffset = offset;
            });
        }
        this.pendingFiles = {};
        this.queuedFiles = [];
        this.filesInProcess = [];
        historyCache = new HistoryCache(this.config.mockLocalStorage);
    };
    Evaporate.create = function(config) {
        var evapConfig = extend({}, config);
        return Evaporate.getLocalTimeOffset(evapConfig).then(function(offset) {
            evapConfig.localTimeOffset = offset;
            return new Promise(function(resolve, reject) {
                var e = new Evaporate(evapConfig);
                if (e.supported === true) resolve(e);
                else reject(e._instantiationError);
            });
        });
    };
    Evaporate.getLocalTimeOffset = function(config) {
        return new Promise(function(resolve, reject) {
            if (typeof config.localTimeOffset === 'number') return resolve(config.localTimeOffset);
            if (config.timeUrl) {
                var xhr = new XMLHttpRequest();
                xhr.open("GET", config.timeUrl + '?requestTime=' + new Date().getTime());
                xhr.onreadystatechange = function() {
                    if (xhr.readyState === 4) {
                        if (xhr.status === 200) {
                            var server_date = new Date(Date.parse(xhr.responseText)), offset = server_date - new Date();
                            l.d('localTimeOffset is', offset, 'ms');
                            resolve(offset);
                        }
                    }
                };
                xhr.onerror = function(xhr) {
                    l.e('xhr error timeUrl', xhr);
                    reject('Fetching offset time failed with status: ' + xhr.status);
                };
                xhr.send();
            } else resolve(0);
        });
    };
    Evaporate.prototype.config = {};
    Evaporate.prototype.localTimeOffset = 0;
    Evaporate.prototype.supported = false;
    Evaporate.prototype._instantiationError = undefined;
    Evaporate.prototype.evaporatingCount = 0;
    Evaporate.prototype.pendingFiles = {};
    Evaporate.prototype.filesInProcess = [];
    Evaporate.prototype.queuedFiles = [];
    Evaporate.prototype.startNextFile = function(reason) {
        if (!this.queuedFiles.length || this.evaporatingCount >= this.config.maxConcurrentParts) return;
        var fileUpload = this.queuedFiles.shift();
        if (fileUpload.status === PENDING) {
            l.d('Starting', decodeURIComponent(fileUpload.name), 'reason:', reason);
            this.evaporatingCnt(1);
            fileUpload.start();
        } else {
            // Add the file back to the stack, it's not ready
            l.d('Requeued', decodeURIComponent(fileUpload.name), 'status:', fileUpload.status, 'reason:', reason);
            this.queuedFiles.push(fileUpload);
        }
    };
    Evaporate.prototype.fileCleanup = function(fileUpload) {
        removeAtIndex(this.queuedFiles, fileUpload);
        if (removeAtIndex(this.filesInProcess, fileUpload)) this.evaporatingCnt(-1);
        fileUpload.done();
        this.consumeRemainingSlots();
    };
    Evaporate.prototype.queueFile = function(fileUpload) {
        this.filesInProcess.push(fileUpload);
        this.queuedFiles.push(fileUpload);
        if (this.filesInProcess.length === 1) this.startNextFile('first file');
    };
    Evaporate.prototype.add = function(file, pConfig) {
        var self = this, fileConfig;
        return new Promise(function(resolve, reject) {
            var c = extend(pConfig, {});
            IMMUTABLE_OPTIONS.forEach(function(a) {
                delete c[a];
            });
            fileConfig = extend(self.config, c);
            if (typeof file === 'undefined' || typeof file.file === 'undefined') return reject('Missing file');
            if (fileConfig.maxFileSize && file.file.size > fileConfig.maxFileSize) return reject('File size too large. Maximum size allowed is ' + fileConfig.maxFileSize);
            if (typeof file.name === 'undefined') return reject('Missing attribute: name');
            if (fileConfig.encodeFilename) // correctly encode to an S3 object name, considering '/' and ' '
            file.name = s3EncodedObjectName(file.name);
            var fileUpload = new FileUpload(extend({
                started: function() {},
                uploadInitiated: function() {},
                progress: function() {},
                complete: function() {},
                cancelled: function() {},
                paused: function() {},
                resumed: function() {},
                pausing: function() {},
                nameChanged: function() {},
                info: function() {},
                warn: function() {},
                error: function() {},
                beforeSigner: undefined,
                xAmzHeadersAtInitiate: {},
                notSignedHeadersAtInitiate: {},
                xAmzHeadersCommon: null,
                xAmzHeadersAtUpload: {},
                xAmzHeadersAtComplete: {}
            }, file, {
                status: PENDING,
                priority: 0,
                loadedBytes: 0,
                sizeBytes: file.file.size,
                eTag: ''
            }), fileConfig, self), fileKey = fileUpload.id;
            self.pendingFiles[fileKey] = fileUpload;
            self.queueFile(fileUpload);
            // Resolve or reject the Add promise based on how the fileUpload completes
            fileUpload.deferredCompletion.promise.then(function() {
                self.fileCleanup(fileUpload);
                resolve(decodeURIComponent(fileUpload.name));
            }, function(reason) {
                self.fileCleanup(fileUpload);
                reject(reason);
            });
        });
    };
    Evaporate.prototype.cancel = function(id) {
        return typeof id === 'undefined' ? this._cancelAll() : this._cancelOne(id);
    };
    Evaporate.prototype._cancelAll = function() {
        l.d('Canceling all file uploads');
        var promises = [];
        for(var key in this.pendingFiles)if (this.pendingFiles.hasOwnProperty(key)) {
            var file = this.pendingFiles[key];
            if (ACTIVE_STATUSES.indexOf(file.status) > -1) promises.push(file.stop());
        }
        if (!promises.length) promises.push(Promise.reject('No files to cancel.'));
        return Promise.all(promises);
    };
    Evaporate.prototype._cancelOne = function(id) {
        var promise = [];
        if (this.pendingFiles[id]) promise.push(this.pendingFiles[id].stop());
        else promise.push(Promise.reject('File does not exist'));
        return Promise.all(promise);
    };
    Evaporate.prototype.pause = function(id, options) {
        options = options || {};
        var force = typeof options.force === 'undefined' ? false : options.force;
        return typeof id === 'undefined' ? this._pauseAll(force) : this._pauseOne(id, force);
    };
    Evaporate.prototype._pauseAll = function(force) {
        l.d('Pausing all file uploads');
        var promises = [];
        for(var key in this.pendingFiles)if (this.pendingFiles.hasOwnProperty(key)) {
            var file = this.pendingFiles[key];
            if (ACTIVE_STATUSES.indexOf(file.status) > -1) this._pause(file, force, promises);
        }
        return Promise.all(promises);
    };
    Evaporate.prototype._pauseOne = function(id, force) {
        var promises = [], file = this.pendingFiles[id];
        if (typeof file === 'undefined') promises.push(Promise.reject('Cannot pause a file that has not been added.'));
        else if (file.status === PAUSED) promises.push(Promise.reject('Cannot pause a file that is already paused.'));
        if (!promises.length) this._pause(file, force, promises);
        return Promise.all(promises);
    };
    Evaporate.prototype._pause = function(fileUpload, force, promises) {
        promises.push(fileUpload.pause(force));
        removeAtIndex(this.filesInProcess, fileUpload);
        removeAtIndex(this.queuedFiles, fileUpload);
    };
    Evaporate.prototype.resume = function(id) {
        return typeof id === 'undefined' ? this._resumeAll() : this._resumeOne(id);
    };
    Evaporate.prototype._resumeAll = function() {
        l.d('Resuming all file uploads');
        for(var key in this.pendingFiles)if (this.pendingFiles.hasOwnProperty(key)) {
            var file = this.pendingFiles[key];
            if (PAUSED_STATUSES.indexOf(file.status) > -1) this.resumeFile(file);
        }
        return Promise.resolve();
    };
    Evaporate.prototype._resumeOne = function(id) {
        var file = this.pendingFiles[id], promises = [];
        if (typeof file === 'undefined') promises.push(Promise.reject('Cannot pause a file that does not exist.'));
        else if (PAUSED_STATUSES.indexOf(file.status) === -1) promises.push(Promise.reject('Cannot resume a file that has not been paused.'));
        else this.resumeFile(file);
        return Promise.all(promises);
    };
    Evaporate.prototype.resumeFile = function(fileUpload) {
        fileUpload.resume();
        this.queueFile(fileUpload);
    };
    Evaporate.prototype.forceRetry = function() {};
    Evaporate.prototype.consumeRemainingSlots = function() {
        var avail = this.config.maxConcurrentParts - this.evaporatingCount;
        if (!avail) return;
        for(var i = 0; i < this.filesInProcess.length; i++){
            var file = this.filesInProcess[i];
            var consumed = file.consumeSlots();
            if (consumed < 0) continue;
            avail -= consumed;
            if (!avail) return;
        }
    };
    Evaporate.prototype.validateEvaporateOptions = function() {
        this.supported = !(typeof File === 'undefined' || typeof Promise === 'undefined');
        if (!this.supported) return 'Evaporate requires support for File and Promise';
        if (this.config.readableStreams) {
            if (typeof this.config.readableStreamPartMethod !== 'function') return "Option readableStreamPartMethod is required when readableStreams is set.";
        } else {
            if (typeof Blob === 'undefined' || typeof (Blob.prototype.webkitSlice || Blob.prototype.mozSlice || Blob.prototype.slice) === 'undefined') return 'Evaporate requires support for Blob [webkitSlice || mozSlice || slice]';
        }
        if (!this.config.signerUrl && typeof this.config.customAuthMethod !== 'function') return "Option signerUrl is required unless customAuthMethod is present.";
        if (!this.config.bucket) return "The AWS 'bucket' option must be present.";
        if (this.config.computeContentMd5) {
            this.supported = typeof FileReader.prototype.readAsArrayBuffer !== 'undefined';
            if (!this.supported) return 'The browser\'s FileReader object does not support readAsArrayBuffer';
            if (typeof this.config.cryptoMd5Method !== 'function') return 'Option computeContentMd5 has been set but cryptoMd5Method is not defined.';
            if (this.config.awsSignatureVersion === '4') {
                if (typeof this.config.cryptoHexEncodedHash256 !== 'function') return 'Option awsSignatureVersion is 4 but cryptoHexEncodedHash256 is not defined.';
            }
        } else if (this.config.awsSignatureVersion === '4') return 'Option awsSignatureVersion is 4 but computeContentMd5 is not enabled.';
        return true;
    };
    Evaporate.prototype.evaporatingCnt = function(incr) {
        this.evaporatingCount = Math.max(0, this.evaporatingCount + incr);
        this.config.evaporateChanged(this, this.evaporatingCount);
    };
    function FileUpload(file, con, evaporate) {
        this.fileTotalBytesUploaded = 0;
        this.s3Parts = [];
        this.partsOnS3 = [];
        this.partsInProcess = [];
        this.partsToUpload = [];
        this.numParts = -1;
        this.con = extend({}, con);
        this.evaporate = evaporate;
        this.localTimeOffset = evaporate.localTimeOffset;
        this.deferredCompletion = defer();
        extend(this, file);
        this.id = decodeURIComponent(this.con.bucket + '/' + this.name);
        this.signParams = con.signParams;
    }
    FileUpload.prototype.con = undefined;
    FileUpload.prototype.evaporate = undefined;
    FileUpload.prototype.localTimeOffset = 0;
    FileUpload.prototype.id = undefined;
    FileUpload.prototype.status = PENDING;
    FileUpload.prototype.numParts = -1;
    FileUpload.prototype.fileTotalBytesUploaded = 0;
    FileUpload.prototype.partsInProcess = [];
    FileUpload.prototype.partsToUpload = [];
    FileUpload.prototype.s3Parts = [];
    FileUpload.prototype.partsOnS3 = [];
    FileUpload.prototype.deferredCompletion = undefined;
    FileUpload.prototype.abortedByUser = false;
    // Progress and Stats
    FileUpload.prototype.progressInterval = undefined;
    FileUpload.prototype.startTime = undefined;
    FileUpload.prototype.loaded = 0;
    FileUpload.prototype.totalUploaded = 0;
    FileUpload.prototype.updateLoaded = function(loadedNow) {
        this.loaded += loadedNow;
        this.fileTotalBytesUploaded += loadedNow;
    };
    FileUpload.prototype.progessStats = function() {
        // Adapted from https://github.com/fkjaekel
        // https://github.com/TTLabs/EvaporateJS/issues/13
        if (this.fileTotalBytesUploaded === 0) return {
            speed: 0,
            readableSpeed: "",
            loaded: 0,
            totalUploaded: 0,
            remainingSize: this.sizeBytes,
            secondsLeft: -1,
            fileSize: this.sizeBytes
        };
        this.totalUploaded += this.loaded;
        var delta = (new Date() - this.startTime) / 1000, avgSpeed = this.totalUploaded / delta, remainingSize = this.sizeBytes - this.fileTotalBytesUploaded, stats = {
            speed: avgSpeed,
            readableSpeed: readableFileSize(avgSpeed),
            loaded: this.loaded,
            totalUploaded: this.fileTotalBytesUploaded,
            remainingSize: remainingSize,
            secondsLeft: -1,
            fileSize: this.sizeBytes
        };
        if (avgSpeed > 0) stats.secondsLeft = Math.round(remainingSize / avgSpeed);
        return stats;
    };
    FileUpload.prototype.onProgress = function() {
        if ([
            ABORTED,
            PAUSED
        ].indexOf(this.status) === -1) {
            this.progress(this.fileTotalBytesUploaded / this.sizeBytes, this.progessStats());
            this.loaded = 0;
        }
    };
    FileUpload.prototype.startMonitor = function() {
        clearInterval(this.progressInterval);
        this.startTime = new Date();
        this.loaded = 0;
        this.totalUploaded = 0;
        this.onProgress();
        this.progressInterval = setInterval(this.onProgress.bind(this), this.con.progressIntervalMS);
    };
    FileUpload.prototype.stopMonitor = function() {
        clearInterval(this.progressInterval);
    };
    // Evaporate proxies
    FileUpload.prototype.startNextFile = function(reason) {
        this.evaporate.startNextFile(reason);
    };
    FileUpload.prototype.evaporatingCnt = function(incr) {
        this.evaporate.evaporatingCnt(incr);
    };
    FileUpload.prototype.consumeRemainingSlots = function() {
        this.evaporate.consumeRemainingSlots();
    };
    FileUpload.prototype.getRemainingSlots = function() {
        var evapCount = this.evaporate.evaporatingCount;
        if (!this.partsInProcess.length && evapCount > 0) // we can use our file slot
        evapCount -= 1;
        return this.con.maxConcurrentParts - evapCount;
    };
    FileUpload.prototype.lastPartSatisfied = Promise.resolve('onStart');
    FileUpload.prototype.start = function() {
        this.status = EVAPORATING;
        this.startMonitor();
        this.started(this.id);
        if (this.uploadId) {
            l.d('resuming FileUpload ', this.id);
            return this.consumeSlots();
        }
        var awsKey = this.name;
        this.getUnfinishedFileUpload();
        var existenceOptimized = this.con.computeContentMd5 && this.con.allowS3ExistenceOptimization && typeof this.firstMd5Digest !== 'undefined' && typeof this.eTag !== 'undefined';
        if (this.uploadId) {
            if (existenceOptimized) return this.reuseS3Object(awsKey).then(this.deferredCompletion.resolve).catch(this.uploadFileFromScratch.bind(this));
            this.resumeInterruptedUpload().then(this._uploadComplete.bind(this)).catch(this.uploadFileFromScratch.bind(this));
        } else this.uploadFileFromScratch("");
    };
    FileUpload.prototype.uploadFileFromScratch = function(reason) {
        if (ACTIVE_STATUSES.indexOf(this.status) === -1) return;
        l.d(reason);
        this.uploadId = undefined;
        return this.uploadFile(this.name).then(this._uploadComplete.bind(this)).catch(this._abortUpload.bind(this));
    };
    FileUpload.prototype._uploadComplete = function() {
        this.completeUpload().then(this.deferredCompletion.resolve);
    };
    FileUpload.prototype.stop = function() {
        l.d('stopping FileUpload ', this.id);
        this.setStatus(CANCELED);
        this.info('Canceling uploads...');
        this.abortedByUser = true;
        var self = this;
        return this.abortUpload().then(function() {
            throw "User aborted the upload";
        }).catch(function(reason) {
            self.deferredCompletion.reject(reason);
        });
    };
    FileUpload.prototype.pause = function(force) {
        l.d('pausing FileUpload, force:', !!force, this.id);
        var promises = [];
        this.info('Pausing uploads...');
        this.status = PAUSING;
        if (force) this.abortParts(true);
        else {
            promises = this.partsInProcess.map(function(p) {
                return this.s3Parts[p].awsRequest.awsDeferred.promise;
            }, this);
            this.pausing();
        }
        return Promise.all(promises).then((function() {
            this.stopMonitor();
            this.status = PAUSED;
            this.startNextFile('pause');
            this.paused();
        }).bind(this));
    };
    FileUpload.prototype.resume = function() {
        this.status = PENDING;
        this.resumed();
    };
    FileUpload.prototype.done = function() {
        clearInterval(this.progressInterval);
        this.startNextFile('file done');
        this.partsOnS3 = [];
        this.s3Parts = [];
    };
    FileUpload.prototype._startCompleteUpload = function(callComplete) {
        return function() {
            var promise = callComplete ? this.completeUpload() : Promise.resolve();
            promise.then(this.deferredCompletion.resolve.bind(this));
        };
    };
    FileUpload.prototype._abortUpload = function() {
        if (!this.abortedByUser) {
            var self = this;
            this.abortUpload().then(function() {
                self.deferredCompletion.reject('File upload aborted due to a part failing to upload');
            }, this.deferredCompletion.reject.bind(this));
        }
    };
    FileUpload.prototype.abortParts = function(pause) {
        var self = this;
        var toAbort = this.partsInProcess.slice(0);
        toAbort.forEach(function(i) {
            var s3Part = self.s3Parts[i];
            if (s3Part) {
                s3Part.awsRequest.abort();
                if (pause) s3Part.status = PENDING;
                removeAtIndex(self.partsInProcess, s3Part.partNumber);
                if (self.partsToUpload.length) self.evaporatingCnt(-1);
            }
        });
    };
    FileUpload.prototype.makeParts = function(firstPart) {
        this.numParts = Math.ceil(this.sizeBytes / this.con.partSize) || 1; // issue #58
        var partsDeferredPromises = [];
        var self = this;
        function cleanUpAfterPart(s3Part) {
            removeAtIndex(self.partsToUpload, s3Part.partNumber);
            removeAtIndex(self.partsInProcess, s3Part.partNumber);
            if (self.partsToUpload.length) self.evaporatingCnt(-1);
        }
        function resolve(s3Part) {
            return function() {
                cleanUpAfterPart(s3Part);
                if (self.partsToUpload.length) self.consumeRemainingSlots();
                if (self.partsToUpload.length < self.con.maxConcurrentParts) self.startNextFile('part resolve');
            };
        }
        function reject(s3Part) {
            return function() {
                cleanUpAfterPart(s3Part);
            };
        }
        var limit = firstPart ? 1 : this.numParts;
        for(var part = 1; part <= limit; part++){
            var s3Part = this.s3Parts[part];
            if (typeof s3Part !== "undefined") {
                if (s3Part.status === COMPLETE) continue;
            } else s3Part = this.makePart(part, PENDING, this.sizeBytes);
            s3Part.awsRequest = new PutPart(this, s3Part);
            s3Part.awsRequest.awsDeferred.promise.then(resolve(s3Part), reject(s3Part));
            this.partsToUpload.push(part);
            partsDeferredPromises.push(this.s3Parts[part].awsRequest.awsDeferred.promise);
        }
        return partsDeferredPromises;
    };
    FileUpload.prototype.makePart = function(partNumber, status, size) {
        var s3Part = {
            status: status,
            loadedBytes: 0,
            loadedBytesPrevious: null,
            isEmpty: size === 0,
            md5_digest: null,
            partNumber: partNumber
        };
        this.s3Parts[partNumber] = s3Part;
        return s3Part;
    };
    FileUpload.prototype.setStatus = function(s) {
        this.status = s;
    };
    FileUpload.prototype.createUploadFile = function() {
        if (this.status === ABORTED) return;
        var fileKey = uploadKey(this), newUpload = {
            awsKey: this.name,
            bucket: this.con.bucket,
            uploadId: this.uploadId,
            fileSize: this.sizeBytes,
            fileType: this.file.type,
            lastModifiedDate: dateISOString(this.file.lastModified),
            partSize: this.con.partSize,
            signParams: this.con.signParams,
            createdAt: new Date().toISOString()
        };
        saveUpload(fileKey, newUpload);
    };
    FileUpload.prototype.updateUploadFile = function(updates) {
        var fileKey = uploadKey(this), uploads = getSavedUploads(), upload = extend({}, uploads[fileKey], updates);
        saveUpload(fileKey, upload);
    };
    FileUpload.prototype.completeUploadFile = function(xhr) {
        var uploads = getSavedUploads(), upload = uploads[uploadKey(this)];
        if (typeof upload !== 'undefined') {
            upload.completedAt = new Date().toISOString();
            upload.eTag = this.eTag;
            upload.firstMd5Digest = this.firstMd5Digest;
            uploads[uploadKey(this)] = upload;
            historyCache.setItem('awsUploads', JSON.stringify(uploads));
        }
        this.complete(xhr, this.name, this.progessStats());
        this.setStatus(COMPLETE);
        this.onProgress();
    };
    FileUpload.prototype.removeUploadFile = function() {
        if (typeof this.file !== 'undefined') removeUpload(uploadKey(this));
    };
    FileUpload.prototype.getUnfinishedFileUpload = function() {
        var savedUploads = getSavedUploads(true), u = savedUploads[uploadKey(this)];
        if (this.canRetryUpload(u)) {
            this.uploadId = u.uploadId;
            this.name = u.awsKey;
            this.eTag = u.eTag;
            this.firstMd5Digest = u.firstMd5Digest;
            this.signParams = u.signParams;
        }
    };
    FileUpload.prototype.canRetryUpload = function(u) {
        // Must be the same file name, file size, last_modified, file type as previous upload
        if (typeof u === 'undefined') return false;
        var completedAt = new Date(u.completedAt || FAR_FUTURE);
        // check that the part sizes and bucket match, and if the file name of the upload
        // matches if onlyRetryForSameFileName is true
        return this.con.partSize === u.partSize && completedAt > HOURS_AGO && this.con.bucket === u.bucket && (this.con.onlyRetryForSameFileName ? this.name === u.awsKey : true);
    };
    FileUpload.prototype.partSuccess = function(eTag, putRequest) {
        var part = putRequest.part;
        l.d(putRequest.request.step, 'ETag:', eTag);
        if (part.isEmpty || eTag !== ETAG_OF_0_LENGTH_BLOB) {
            part.eTag = eTag;
            part.status = COMPLETE;
            this.partsOnS3.push(part);
            return true;
        } else {
            part.status = ERROR;
            putRequest.resetLoadedBytes();
            var msg = [
                'eTag matches MD5 of 0 length blob for part #',
                putRequest.partNumber,
                'Retrying part.'
            ].join(" ");
            l.w(msg);
            this.warn(msg);
        }
    };
    FileUpload.prototype.listPartsSuccess = function(listPartsRequest, partsXml) {
        this.info('uploadId', this.uploadId, 'is not complete. Fetching parts from part marker', listPartsRequest.partNumberMarker);
        partsXml = partsXml.replace(/(\r\n|\n|\r)/gm, ""); // strip line breaks to ease the regex requirements
        var partRegex = /<Part>(.+?)<\/Part\>/g;
        while(true){
            var cp = (partRegex.exec(partsXml) || [])[1];
            if (!cp) break;
            var partSize = parseInt(elementText(cp, "Size"), 10);
            this.fileTotalBytesUploaded += partSize;
            this.partsOnS3.push({
                eTag: elementText(cp, "ETag").replace(/&quot;/g, '"'),
                partNumber: parseInt(elementText(cp, "PartNumber"), 10),
                size: partSize,
                LastModified: elementText(cp, "LastModified")
            });
        }
        return elementText(partsXml, "IsTruncated") === 'true' ? elementText(partsXml, "NextPartNumberMarker") : undefined;
    };
    FileUpload.prototype.makePartsfromPartsOnS3 = function() {
        if (ACTIVE_STATUSES.indexOf(this.status) === -1) return;
        this.nameChanged(this.name);
        this.partsOnS3.forEach((function(cp) {
            var uploadedPart = this.makePart(cp.partNumber, COMPLETE, cp.size);
            uploadedPart.eTag = cp.eTag;
            uploadedPart.loadedBytes = cp.size;
            uploadedPart.loadedBytesPrevious = cp.size;
            uploadedPart.finishedUploadingAt = cp.LastModified;
        }).bind(this));
    };
    FileUpload.prototype.completeUpload = function() {
        var self = this;
        return new CompleteMultipartUpload(this).send().then(function(xhr) {
            self.eTag = elementText(xhr.responseText, "ETag").replace(/&quot;/g, '"');
            self.completeUploadFile(xhr);
        });
    };
    FileUpload.prototype.getCompletedPayload = function() {
        var completeDoc = [];
        completeDoc.push('<CompleteMultipartUpload>');
        this.s3Parts.forEach(function(part, partNumber) {
            if (partNumber > 0) [
                '<Part><PartNumber>',
                partNumber,
                '</PartNumber><ETag>',
                part.eTag,
                '</ETag></Part>'
            ].forEach(function(a) {
                completeDoc.push(a);
            });
        });
        completeDoc.push('</CompleteMultipartUpload>');
        return completeDoc.join("");
    };
    FileUpload.prototype.consumeSlots = function() {
        if (this.partsToUpload.length === 0) return -1;
        if (this.partsToUpload.length !== this.partsInProcess.length && this.status === EVAPORATING) {
            var partsToUpload = Math.min(this.getRemainingSlots(), this.partsToUpload.length);
            if (!partsToUpload) return -1;
            var satisfied = 0;
            for(var i = 0; i < this.partsToUpload.length; i++){
                var s3Part = this.s3Parts[this.partsToUpload[i]];
                if (s3Part.status === EVAPORATING) continue;
                if (this.canStartPart(s3Part)) {
                    if (this.partsInProcess.length && this.partsToUpload.length > 1) this.evaporatingCnt(1);
                    this.partsInProcess.push(s3Part.partNumber);
                    var awsRequest = s3Part.awsRequest;
                    this.lastPartSatisfied.then(awsRequest.delaySend.bind(awsRequest));
                    this.lastPartSatisfied = awsRequest.getStartedPromise();
                } else continue;
                satisfied += 1;
                if (satisfied === partsToUpload) break;
            }
            var allInProcess = this.partsToUpload.length === this.partsInProcess.length, remainingSlots = this.getRemainingSlots();
            if (allInProcess && remainingSlots > 0) // We don't need any more slots...
            this.startNextFile('consume slots');
            return remainingSlots;
        }
        return 0;
    };
    FileUpload.prototype.canStartPart = function(part) {
        return this.partsInProcess.indexOf(part.partNumber) === -1 && !part.awsRequest.errorExceptionStatus();
    };
    FileUpload.prototype.uploadFile = function(awsKey) {
        this.removeUploadFile();
        var self = this;
        return new InitiateMultipartUpload(self, awsKey).send().then(function() {
            self.uploadInitiated(self.uploadId);
            self.partsToUpload = [];
            return self.uploadParts().then(function() {}, function(reason) {
                throw reason;
            });
        });
    };
    FileUpload.prototype.uploadParts = function() {
        this.loaded = 0;
        this.totalUploaded = 0;
        if (ACTIVE_STATUSES.indexOf(this.status) === -1) return Promise.reject('Part uploading stopped because the file was canceled');
        var promises = this.makeParts();
        this.setStatus(EVAPORATING);
        this.startTime = new Date();
        this.consumeSlots();
        return Promise.all(promises);
    };
    FileUpload.prototype.abortUpload = function() {
        return new Promise((function(resolve, reject) {
            if (typeof this.uploadId === 'undefined') {
                resolve();
                return;
            }
            new DeleteMultipartUpload(this).send().then(resolve, reject);
        }).bind(this)).then((function() {
            this.setStatus(ABORTED);
            this.cancelled();
            this.removeUploadFile();
        }).bind(this), this.deferredCompletion.reject.bind(this));
    };
    FileUpload.prototype.resumeInterruptedUpload = function() {
        return new ResumeInterruptedUpload(this).send().then(this.uploadParts.bind(this));
    };
    FileUpload.prototype.reuseS3Object = function(awsKey) {
        var self = this;
        // Attempt to reuse entire uploaded object on S3
        this.makeParts(1);
        this.partsToUpload = [];
        var firstS3Part = this.s3Parts[1];
        function reject(reason) {
            self.name = awsKey;
            throw reason;
        }
        return firstS3Part.awsRequest.getPartMd5Digest().then(function() {
            if (self.firstMd5Digest === firstS3Part.md5_digest) return new ReuseS3Object(self, awsKey).send().then(function(xhr) {
                l.d('headObject found matching object on S3.');
                self.completeUploadFile(xhr);
                self.nameChanged(self.name);
            }).catch(reject);
            else {
                var msg = self.con.allowS3ExistenceOptimization ? 'File\'s first part MD5 digest does not match what was stored.' : 'allowS3ExistenceOptimization is not enabled.';
                reject(msg);
            }
        });
    };
    function SignedS3AWSRequest(fileUpload, request) {
        this.fileUpload = fileUpload;
        this.con = fileUpload.con;
        this.attempts = 1;
        this.localTimeOffset = this.fileUpload.localTimeOffset;
        this.awsDeferred = defer();
        this.started = defer();
        this.awsUrl = awsUrl(this.con);
        this.awsHost = uri(this.awsUrl).hostname;
        var r = extend({}, request);
        if (fileUpload.contentType) r.contentType = fileUpload.contentType;
        this.updateRequest(r);
    }
    SignedS3AWSRequest.prototype.fileUpload = undefined;
    SignedS3AWSRequest.prototype.con = undefined;
    SignedS3AWSRequest.prototype.awsUrl = undefined;
    SignedS3AWSRequest.prototype.awsHost = undefined;
    SignedS3AWSRequest.prototype.authorize = function() {};
    SignedS3AWSRequest.prototype.localTimeOffset = 0;
    SignedS3AWSRequest.prototype.awsDeferred = undefined;
    SignedS3AWSRequest.prototype.started = undefined;
    SignedS3AWSRequest.prototype.getPath = function() {
        var path = '/' + this.con.bucket + '/' + this.fileUpload.name;
        if (this.con.cloudfront || this.awsUrl.indexOf('cloudfront') > -1) path = '/' + this.fileUpload.name;
        return path;
    };
    SignedS3AWSRequest.prototype.updateRequest = function(request) {
        this.request = request;
        var SigningClass = signingVersion(this, l);
        this.signer = new SigningClass(request);
    };
    SignedS3AWSRequest.prototype.success = function() {
        this.awsDeferred.resolve(this.currentXhr);
    };
    SignedS3AWSRequest.prototype.backOffWait = function() {
        return this.attempts === 1 ? 0 : 1000 * Math.min(this.con.maxRetryBackoffSecs, Math.pow(this.con.retryBackoffPower, this.attempts - 2));
    };
    SignedS3AWSRequest.prototype.error = function(reason) {
        if (this.errorExceptionStatus()) return;
        this.signer.error();
        l.d(this.request.step, 'error:', this.fileUpload.id, reason);
        if (typeof this.errorHandler(reason) !== 'undefined') return;
        this.fileUpload.warn('Error in ', this.request.step, reason);
        this.fileUpload.setStatus(ERROR);
        var self = this, backOffWait = this.backOffWait();
        this.attempts += 1;
        setTimeout(function() {
            if (!self.errorExceptionStatus()) self.trySend();
        }, backOffWait);
    };
    SignedS3AWSRequest.prototype.errorHandler = function() {};
    SignedS3AWSRequest.prototype.errorExceptionStatus = function() {
        return false;
    };
    SignedS3AWSRequest.prototype.getPayload = function() {
        return Promise.resolve(null);
    };
    SignedS3AWSRequest.prototype.success_status = function(xhr) {
        return xhr.status >= 200 && xhr.status <= 299 || this.request.success404 && xhr.status === 404;
    };
    SignedS3AWSRequest.prototype.stringToSign = function() {
        return encodeURIComponent(this.signer.stringToSign());
    };
    SignedS3AWSRequest.prototype.canonicalRequest = function() {
        return this.signer.canonicalRequest();
    };
    SignedS3AWSRequest.prototype.signResponse = function(payload, stringToSign, signatureDateTime) {
        var self = this;
        return new Promise(function(resolve) {
            if (typeof self.con.signResponseHandler === 'function') return self.con.signResponseHandler(payload, stringToSign, signatureDateTime).then(resolve);
            resolve(payload);
        });
    };
    SignedS3AWSRequest.prototype.sendRequestToAWS = function() {
        var self = this;
        return new Promise(function(resolve, reject) {
            var xhr = new XMLHttpRequest();
            self.currentXhr = xhr;
            var url = [
                self.awsUrl,
                self.getPath(),
                self.request.path
            ].join(""), all_headers = {};
            if (self.request.query_string) url += self.request.query_string;
            extend(all_headers, self.request.not_signed_headers);
            extend(all_headers, self.request.x_amz_headers);
            xhr.onreadystatechange = function() {
                if (xhr.readyState === 4) {
                    if (self.success_status(xhr)) {
                        if (self.request.response_match && xhr.response.match(new RegExp(self.request.response_match)) === undefined) reject('AWS response does not match set pattern: ' + self.request.response_match);
                        else resolve();
                    } else {
                        var reason = xhr.responseText ? getAwsResponse(xhr) : ' ';
                        reason += 'status:' + xhr.status;
                        reject(reason);
                    }
                }
            };
            xhr.open(self.request.method, url);
            xhr.setRequestHeader('Authorization', self.signer.authorizationString());
            for(var key in all_headers)if (all_headers.hasOwnProperty(key)) xhr.setRequestHeader(key, all_headers[key]);
            self.signer.setHeaders(xhr);
            if (self.request.contentType) xhr.setRequestHeader('Content-Type', self.request.contentType);
            if (self.request.md5_digest) xhr.setRequestHeader('Content-MD5', self.request.md5_digest);
            xhr.onerror = function(xhr) {
                var reason = xhr.responseText ? getAwsResponse(xhr) : 'transport error';
                reject(reason);
            };
            if (typeof self.request.onProgress === 'function') xhr.upload.onprogress = self.request.onProgress;
            self.getPayload().then(xhr.send.bind(xhr), reject);
            setTimeout(function() {
                self.started.resolve('request sent ' + self.request.step);
            }, 20);
            self.signer.payload = null;
            self.payloadPromise = undefined;
        });
    };
    //see: http://docs.amazonwebservices.com/AmazonS3/latest/dev/RESTAuthentication.html#ConstructingTheAuthenticationHeader
    SignedS3AWSRequest.prototype.authorize = function() {
        this.request.dateString = this.signer.dateString(this.localTimeOffset);
        this.request.x_amz_headers = extend(this.request.x_amz_headers, {
            'x-amz-date': this.request.dateString
        });
        return this.signer.getPayload().then((function() {
            return authorizationMethod(this).authorize();
        }).bind(this));
    };
    SignedS3AWSRequest.prototype.authorizationSuccess = function(authorization) {
        l.d(this.request.step, 'signature:', authorization);
        this.request.auth = authorization;
    };
    SignedS3AWSRequest.prototype.trySend = function() {
        var self = this;
        return this.authorize().then(function(value) {
            self.authorizationSuccess(value);
            if (self.fileUpload.status === ABORTED) return;
            self.sendRequestToAWS().then(self.success.bind(self), self.error.bind(self));
        }, self.error.bind(self));
    };
    SignedS3AWSRequest.prototype.send = function() {
        this.trySend();
        return this.awsDeferred.promise;
    };
    function CancelableS3AWSRequest(fileUpload, request) {
        SignedS3AWSRequest.call(this, fileUpload, request);
    }
    CancelableS3AWSRequest.prototype = Object.create(SignedS3AWSRequest.prototype);
    CancelableS3AWSRequest.prototype.constructor = CancelableS3AWSRequest;
    CancelableS3AWSRequest.prototype.errorExceptionStatus = function() {
        return [
            ABORTED,
            CANCELED
        ].indexOf(this.fileUpload.status) > -1;
    };
    function SignedS3AWSRequestWithRetryLimit(fileUpload, request, maxRetries) {
        if (maxRetries > -1) this.maxRetries = maxRetries;
        SignedS3AWSRequest.call(this, fileUpload, request);
    }
    SignedS3AWSRequestWithRetryLimit.prototype = Object.create(CancelableS3AWSRequest.prototype);
    SignedS3AWSRequestWithRetryLimit.prototype.constructor = SignedS3AWSRequestWithRetryLimit;
    SignedS3AWSRequestWithRetryLimit.prototype.maxRetries = 1;
    SignedS3AWSRequestWithRetryLimit.prototype.errorHandler = function(reason) {
        if (this.attempts > this.maxRetries) {
            var msg = [
                'MaxRetries exceeded. Will re-upload file id ',
                this.fileUpload.id,
                ', ',
                reason
            ].join("");
            l.w(msg);
            this.awsDeferred.reject(msg);
            return true;
        }
    };
    SignedS3AWSRequestWithRetryLimit.prototype.rejectedSuccess = function() {
        var reason = Array.prototype.slice.call(arguments, 1).join("");
        this.awsDeferred.reject(reason);
        return false;
    };
    // see: http://docs.amazonwebservices.com/AmazonS3/latest/API/mpUploadInitiate.html
    function InitiateMultipartUpload(fileUpload, awsKey) {
        var request = {
            method: 'POST',
            path: '?uploads',
            step: 'initiate',
            x_amz_headers: fileUpload.xAmzHeadersAtInitiate,
            not_signed_headers: fileUpload.notSignedHeadersAtInitiate,
            response_match: '<UploadId>(.+)<\/UploadId>'
        };
        CancelableS3AWSRequest.call(this, fileUpload, request);
        this.awsKey = awsKey;
    }
    InitiateMultipartUpload.prototype = Object.create(CancelableS3AWSRequest.prototype);
    InitiateMultipartUpload.prototype.constructor = InitiateMultipartUpload;
    InitiateMultipartUpload.prototype.success = function() {
        var match = this.currentXhr.response.match(new RegExp(this.request.response_match));
        this.fileUpload.uploadId = match[1];
        this.fileUpload.awsKey = this.awsKey;
        l.d('InitiateMultipartUpload ID is', this.fileUpload.uploadId);
        this.fileUpload.createUploadFile();
        this.awsDeferred.resolve(this.currentXhr);
    };
    //http://docs.amazonwebservices.com/AmazonS3/latest/API/mpUploadComplete.html
    function CompleteMultipartUpload(fileUpload) {
        fileUpload.info('will attempt to complete upload');
        var request = {
            method: 'POST',
            contentType: 'application/xml; charset=UTF-8',
            path: '?uploadId=' + fileUpload.uploadId,
            x_amz_headers: fileUpload.xAmzHeadersCommon || fileUpload.xAmzHeadersAtComplete,
            step: 'complete'
        };
        CancelableS3AWSRequest.call(this, fileUpload, request);
    }
    CompleteMultipartUpload.prototype = Object.create(CancelableS3AWSRequest.prototype);
    CompleteMultipartUpload.prototype.constructor = CompleteMultipartUpload;
    CompleteMultipartUpload.prototype.getPayload = function() {
        return Promise.resolve(this.fileUpload.getCompletedPayload());
    };
    //http://docs.amazonwebservices.com/AmazonS3/latest/API/mpUploadComplete.html
    function ReuseS3Object(fileUpload, awsKey) {
        this.awsKey = awsKey;
        fileUpload.info('will attempt to verify existence of the file');
        var request = {
            method: 'HEAD',
            path: '',
            x_amz_headers: fileUpload.xAmzHeadersCommon,
            success404: true,
            step: 'head_object'
        };
        SignedS3AWSRequestWithRetryLimit.call(this, fileUpload, request);
    }
    ReuseS3Object.prototype = Object.create(SignedS3AWSRequestWithRetryLimit.prototype);
    ReuseS3Object.prototype.constructor = ReuseS3Object;
    ReuseS3Object.prototype.awsKey = undefined;
    ReuseS3Object.prototype.success = function() {
        var eTag = this.currentXhr.getResponseHeader('Etag');
        if (eTag !== this.fileUpload.eTag && !this.rejectedSuccess('uploadId ', this.fileUpload.id, ' found on S3 but the Etag doesn\'t match.')) return;
        this.awsDeferred.resolve(this.currentXhr);
    };
    //http://docs.amazonwebservices.com/AmazonS3/latest/API/mpUploadListParts.html
    function ResumeInterruptedUpload(fileUpload) {
        SignedS3AWSRequestWithRetryLimit.call(this, fileUpload);
        this.updateRequest(this.setupRequest(0));
    }
    ResumeInterruptedUpload.prototype = Object.create(SignedS3AWSRequestWithRetryLimit.prototype);
    ResumeInterruptedUpload.prototype.constructor = ResumeInterruptedUpload;
    ResumeInterruptedUpload.prototype.awsKey = undefined;
    ResumeInterruptedUpload.prototype.partNumberMarker = 0;
    ResumeInterruptedUpload.prototype.setupRequest = function(partNumberMarker) {
        var msg = [
            'setupRequest() for uploadId:',
            this.fileUpload.uploadId,
            'for part marker:',
            partNumberMarker
        ].join(" ");
        l.d(msg);
        this.fileUpload.info(msg);
        this.awsKey = this.fileUpload.name;
        this.partNumberMarker = partNumberMarker;
        var request = {
            method: 'GET',
            path: [
                '?uploadId=',
                this.fileUpload.uploadId
            ].join(""),
            query_string: "&part-number-marker=" + partNumberMarker,
            x_amz_headers: this.fileUpload.xAmzHeadersCommon,
            step: 'get upload parts',
            success404: true
        };
        this.request = request;
        return request;
    };
    ResumeInterruptedUpload.prototype.success = function() {
        if (this.currentXhr.status === 404) {
            // Success! Upload is no longer recognized, so there is nothing to fetch
            if (this.rejectedSuccess('uploadId ', this.fileUpload.id, ' not found on S3.')) this.awsDeferred.resolve(this.currentXhr);
            return;
        }
        var nextPartNumber = this.fileUpload.listPartsSuccess(this, this.currentXhr.responseText);
        if (nextPartNumber) {
            var request = this.setupRequest(nextPartNumber); // let's fetch the next set of parts
            this.updateRequest(request);
            this.trySend();
        } else {
            this.fileUpload.makePartsfromPartsOnS3();
            this.awsDeferred.resolve(this.currentXhr);
        }
    };
    //http://docs.aws.amazon.com/AmazonS3/latest/API/mpUploadUploadPart.html
    function PutPart(fileUpload, part) {
        this.part = part;
        this.partNumber = part.partNumber;
        this.start = (this.partNumber - 1) * fileUpload.con.partSize;
        this.end = Math.min(this.partNumber * fileUpload.con.partSize, fileUpload.sizeBytes);
        var request = {
            method: 'PUT',
            path: '?partNumber=' + this.partNumber + '&uploadId=' + fileUpload.uploadId,
            step: 'upload #' + this.partNumber,
            x_amz_headers: fileUpload.xAmzHeadersCommon || fileUpload.xAmzHeadersAtUpload,
            contentSha256: "UNSIGNED-PAYLOAD",
            onProgress: this.onProgress.bind(this)
        };
        SignedS3AWSRequest.call(this, fileUpload, request);
    }
    PutPart.prototype = Object.create(SignedS3AWSRequest.prototype);
    PutPart.prototype.constructor = PutPart;
    PutPart.prototype.part = 1;
    PutPart.prototype.payloadPromise = undefined;
    PutPart.prototype.start = 0;
    PutPart.prototype.end = 0;
    PutPart.prototype.partNumber = undefined;
    PutPart.prototype.getPartMd5Digest = function() {
        var self = this, part = this.part;
        return new Promise(function(resolve, reject) {
            if (self.con.computeContentMd5 && !part.md5_digest) self.getPayload().then(function(data) {
                var md5_digest = self.con.cryptoMd5Method(data);
                if (self.partNumber === 1 && self.con.computeContentMd5 && typeof self.fileUpload.firstMd5Digest === "undefined") {
                    self.fileUpload.firstMd5Digest = md5_digest;
                    self.fileUpload.updateUploadFile({
                        firstMd5Digest: md5_digest
                    });
                }
                resolve(md5_digest);
            }, reject);
            else resolve(part.md5_digest);
        }).then(function(md5_digest) {
            if (md5_digest) {
                l.d(self.request.step, 'MD5 digest:', md5_digest);
                self.request.md5_digest = md5_digest;
                self.part.md5_digest = md5_digest;
            }
        });
    };
    PutPart.prototype.sendRequestToAWS = function() {
        this.stalledInterval = setInterval(this.stalledPartMonitor(), PARTS_MONITOR_INTERVAL_MS);
        this.stalledPartMonitor();
        return SignedS3AWSRequest.prototype.sendRequestToAWS.call(this);
    };
    PutPart.prototype.send = function() {
        if (this.part.status !== COMPLETE && [
            ABORTED,
            PAUSED,
            CANCELED
        ].indexOf(this.fileUpload.status) === -1) {
            l.d('uploadPart #', this.partNumber, this.attempts === 1 ? 'submitting' : 'retrying');
            this.part.status = EVAPORATING;
            this.attempts += 1;
            this.part.loadedBytesPrevious = null;
            var self = this;
            return this.getPartMd5Digest().then(function() {
                l.d('Sending', self.request.step);
                SignedS3AWSRequest.prototype.send.call(self);
            });
        }
    };
    PutPart.prototype.success = function() {
        clearInterval(this.stalledInterval);
        var eTag = this.currentXhr.getResponseHeader('ETag');
        this.currentXhr = null;
        if (this.fileUpload.partSuccess(eTag, this)) this.awsDeferred.resolve(this.currentXhr);
    };
    PutPart.prototype.onProgress = function(evt) {
        if (evt.loaded > 0) {
            var loadedNow = evt.loaded - this.part.loadedBytes;
            if (loadedNow) {
                this.part.loadedBytes = evt.loaded;
                this.fileUpload.updateLoaded(loadedNow);
            }
        }
    };
    PutPart.prototype.stalledPartMonitor = function() {
        var lastLoaded = this.part.loadedBytes;
        var self = this;
        return function() {
            clearInterval(self.stalledInterval);
            if ([
                EVAPORATING,
                ERROR,
                PAUSING,
                PAUSED
            ].indexOf(self.fileUpload.status) === -1 && self.part.status !== ABORTED && self.part.loadedBytes < this.size) {
                if (lastLoaded === self.part.loadedBytes) {
                    l.w('Part stalled. Will abort and retry:', self.partNumber, decodeURIComponent(self.fileUpload.name));
                    self.abort();
                    if (!self.errorExceptionStatus()) self.delaySend();
                } else self.stalledInterval = setInterval(self.stalledPartMonitor(), PARTS_MONITOR_INTERVAL_MS);
            }
        };
    };
    PutPart.prototype.resetLoadedBytes = function() {
        this.fileUpload.updateLoaded(-this.part.loadedBytes);
        this.part.loadedBytes = 0;
        this.fileUpload.onProgress();
    };
    PutPart.prototype.errorExceptionStatus = function() {
        return [
            CANCELED,
            ABORTED,
            PAUSED,
            PAUSING
        ].indexOf(this.fileUpload.status) > -1;
    };
    PutPart.prototype.delaySend = function() {
        var backOffWait = this.backOffWait();
        this.attempts += 1;
        setTimeout(this.send.bind(this), backOffWait);
    };
    PutPart.prototype.errorHandler = function(reason) {
        clearInterval(this.stalledInterval);
        if (reason.match(/status:404/)) {
            var errMsg = '404 error on part PUT. The part and the file will abort. ' + reason;
            l.w(errMsg);
            this.fileUpload.error(errMsg);
            this.part.status = ABORTED;
            this.awsDeferred.reject(errMsg);
            return true;
        }
        this.resetLoadedBytes();
        this.part.status = ERROR;
        if (!this.errorExceptionStatus()) this.delaySend();
        return true;
    };
    PutPart.prototype.abort = function() {
        if (this.currentXhr) this.currentXhr.abort();
        this.resetLoadedBytes();
        this.attempts = 1;
    };
    PutPart.size = 0;
    PutPart.prototype.streamToArrayBuffer = function(stream) {
        return new Promise((function(resolve, reject) {
            // stream is empty or ended
            if (!stream.readable) return resolve([]);
            var arr = new Uint8Array(Math.min(this.con.partSize, this.end - this.start)), i = 0;
            stream.on('data', onData);
            stream.on('end', onEnd);
            stream.on('error', onEnd);
            stream.on('close', onClose);
            function onData(data) {
                if (data.byteLength === 1) return;
                arr.set(data, i);
                i += data.byteLength;
            }
            function onEnd(err) {
                if (err) reject(err);
                else resolve(arr);
                cleanup();
            }
            function onClose() {
                resolve(arr);
                cleanup();
            }
            function cleanup() {
                arr = null;
                stream.removeListener('data', onData);
                stream.removeListener('end', onEnd);
                stream.removeListener('error', onEnd);
                stream.removeListener('close', onClose);
            }
        }).bind(this));
    };
    PutPart.prototype.getPayload = function() {
        if (typeof this.payloadPromise === 'undefined') this.payloadPromise = this.con.readableStreams ? this.payloadFromStream() : this.payloadFromBlob();
        return this.payloadPromise;
    };
    PutPart.prototype.payloadFromStream = function() {
        var stream = this.con.readableStreamPartMethod(this.fileUpload.file, this.start, this.end - 1);
        return new Promise((function(resolve, reject) {
            var streamPromise = this.streamToArrayBuffer(stream);
            streamPromise.then((function(data) {
                resolve(data);
            }).bind(this), reject);
        }).bind(this));
    };
    PutPart.prototype.payloadFromBlob = function() {
        // browsers' implementation of the Blob.slice function has been renamed a couple of times, and the meaning of the
        // 2nd parameter changed. For example Gecko went from slice(start,length) -> mozSlice(start, end) -> slice(start, end).
        // As of 12/12/12, it seems that the unified 'slice' is the best bet, hence it being first in the list. See
        // https://developer.mozilla.org/en-US/docs/DOM/Blob for more info.
        var file = this.fileUpload.file, slicerFn = file.slice ? 'slice' : file.mozSlice ? 'mozSlice' : 'webkitSlice', blob = file[slicerFn](this.start, this.end);
        if (this.con.computeContentMd5) return new Promise(function(resolve) {
            var reader = new FileReader();
            reader.onloadend = function() {
                var buffer = this.result && typeof this.result.buffer !== 'undefined', result = buffer ? new Uint8Array(this.result.buffer) : this.result;
                resolve(result);
            };
            reader.readAsArrayBuffer(blob);
        });
        return Promise.resolve(blob);
    };
    PutPart.prototype.stalledInterval = -1;
    PutPart.prototype.getStartedPromise = function() {
        return this.started.promise;
    };
    //http://docs.amazonwebservices.com/AmazonS3/latest/API/mpUploadAbort.html
    function DeleteMultipartUpload(fileUpload) {
        fileUpload.info('will attempt to abort the upload');
        fileUpload.abortParts();
        var request = {
            method: 'DELETE',
            path: '?uploadId=' + fileUpload.uploadId,
            x_amz_headers: fileUpload.xAmzHeadersCommon,
            success404: true,
            step: 'abort'
        };
        SignedS3AWSRequest.call(this, fileUpload, request);
    }
    DeleteMultipartUpload.prototype = Object.create(SignedS3AWSRequest.prototype);
    DeleteMultipartUpload.prototype.constructor = DeleteMultipartUpload;
    DeleteMultipartUpload.prototype.maxRetries = 1;
    DeleteMultipartUpload.prototype.success = function() {
        this.fileUpload.setStatus(ABORTED);
        this.awsDeferred.resolve(this.currentXhr);
    };
    DeleteMultipartUpload.prototype.errorHandler = function(reason) {
        if (this.attempts > this.maxRetries) {
            var msg = 'Error aborting upload, Exceeded retries deleting the file upload: ' + reason;
            l.w(msg);
            this.fileUpload.error(msg);
            this.awsDeferred.reject(msg);
            return true;
        }
    };
    function signingVersion(awsRequest, l) {
        var con = awsRequest.con;
        function AwsSignature(request) {
            this.request = request;
        }
        AwsSignature.prototype.request = {};
        AwsSignature.prototype.error = function() {};
        AwsSignature.prototype.authorizationString = function() {};
        AwsSignature.prototype.stringToSign = function() {};
        AwsSignature.prototype.canonicalRequest = function() {};
        AwsSignature.prototype.setHeaders = function() {};
        AwsSignature.prototype.datetime = function(timeOffset) {
            return new Date(new Date().getTime() + timeOffset);
        };
        AwsSignature.prototype.dateString = function(timeOffset) {
            return this.datetime(timeOffset).toISOString().slice(0, 19).replace(/-|:/g, '') + "Z";
        };
        function AwsSignatureV2(request) {
            AwsSignature.call(this, request);
        }
        AwsSignatureV2.prototype = Object.create(AwsSignature.prototype);
        AwsSignatureV2.prototype.constructor = AwsSignatureV2;
        AwsSignatureV2.prototype.authorizationString = function() {
            return [
                'AWS ',
                con.aws_key,
                ':',
                this.request.auth
            ].join('');
        };
        AwsSignatureV2.prototype.stringToSign = function() {
            var x_amz_headers = '', result, header_key_array = [];
            for(var key in this.request.x_amz_headers)if (this.request.x_amz_headers.hasOwnProperty(key)) header_key_array.push(key);
            header_key_array.sort();
            header_key_array.forEach((function(header_key) {
                x_amz_headers += header_key + ':' + this.request.x_amz_headers[header_key] + '\n';
            }).bind(this));
            result = this.request.method + '\n' + (this.request.md5_digest || '') + '\n' + (this.request.contentType || '') + '\n' + '\n' + x_amz_headers + (con.cloudfront ? '/' + con.bucket : '') + awsRequest.getPath() + this.request.path;
            l.d('V2 stringToSign:', result);
            return result;
        };
        AwsSignatureV2.prototype.dateString = function(timeOffset) {
            return this.datetime(timeOffset).toUTCString();
        };
        AwsSignatureV2.prototype.getPayload = function() {
            return Promise.resolve();
        };
        function AwsSignatureV4(request) {
            this._cr = undefined;
            AwsSignature.call(this, request);
        }
        AwsSignatureV4.prototype = Object.create(AwsSignature.prototype);
        AwsSignatureV4.prototype.constructor = AwsSignatureV4;
        AwsSignatureV4.prototype._cr = undefined;
        AwsSignatureV4.prototype.payload = null;
        AwsSignatureV4.prototype.error = function() {
            this._cr = undefined;
        };
        AwsSignatureV4.prototype.getPayload = function() {
            return awsRequest.getPayload().then((function(data) {
                this.payload = data;
            }).bind(this));
        };
        AwsSignatureV4.prototype.authorizationString = function() {
            var authParts = [];
            var credentials = this.credentialString();
            var headers = this.canonicalHeaders();
            authParts.push([
                'AWS4-HMAC-SHA256 Credential=',
                con.aws_key,
                '/',
                credentials
            ].join(''));
            authParts.push('SignedHeaders=' + headers.signedHeaders);
            authParts.push('Signature=' + this.request.auth);
            return authParts.join(', ');
        };
        AwsSignatureV4.prototype.stringToSign = function() {
            var signParts = [];
            signParts.push('AWS4-HMAC-SHA256');
            signParts.push(this.request.dateString);
            signParts.push(this.credentialString());
            signParts.push(con.cryptoHexEncodedHash256(this.canonicalRequest()));
            var result = signParts.join('\n');
            l.d('V4 stringToSign:', result);
            return result;
        };
        AwsSignatureV4.prototype.credentialString = function() {
            var credParts = [];
            credParts.push(this.request.dateString.slice(0, 8));
            credParts.push(con.awsRegion);
            credParts.push('s3');
            credParts.push('aws4_request');
            return credParts.join('/');
        };
        AwsSignatureV4.prototype.canonicalQueryString = function() {
            var qs = awsRequest.request.query_string || '', search = uri([
                awsRequest.awsUrl,
                this.request.path,
                qs
            ].join("")).search, searchParts = search.length ? search.split('&') : [], encoded = [], nameValue, i;
            for(i = 0; i < searchParts.length; i++){
                nameValue = searchParts[i].split("=");
                encoded.push({
                    name: encodeURIComponent(nameValue[0]),
                    value: nameValue.length > 1 ? encodeURIComponent(nameValue[1]) : null
                });
            }
            var sorted = encoded.sort(function(a, b) {
                if (a.name < b.name) return -1;
                else if (a.name > b.name) return 1;
                return 0;
            });
            var result = [];
            for(i = 0; i < sorted.length; i++){
                nameValue = sorted[i].value ? [
                    sorted[i].name,
                    sorted[i].value
                ].join("=") : sorted[i].name + '=';
                result.push(nameValue);
            }
            return result.join('&');
        };
        AwsSignatureV4.prototype.getPayloadSha256Content = function() {
            var result = this.request.contentSha256 || con.cryptoHexEncodedHash256(this.payload || '');
            l.d(this.request.step, 'getPayloadSha256Content:', result);
            return result;
        };
        AwsSignatureV4.prototype.canonicalHeaders = function() {
            var canonicalHeaders = [], keys = [], i;
            function addHeader(name, value) {
                var key = name.toLowerCase();
                keys.push(key);
                canonicalHeaders[key] = value.replace(/\s+/g, ' ');
            }
            if (this.request.md5_digest) addHeader("Content-Md5", this.request.md5_digest);
            addHeader('Host', awsRequest.awsHost);
            if (this.request.contentType) addHeader('Content-Type', this.request.contentType || '');
            var amzHeaders = this.request.x_amz_headers || {};
            for(var key in amzHeaders)if (amzHeaders.hasOwnProperty(key)) addHeader(key, amzHeaders[key]);
            var sortedKeys = keys.sort(function(a, b) {
                if (a < b) return -1;
                else if (a > b) return 1;
                return 0;
            });
            var result = [];
            var unsigned_headers = [], not_signed = this.request.not_signed_headers || [], signed_headers = [];
            for(i = 0; i < not_signed.length; i++)unsigned_headers.push(not_signed[i].toLowerCase());
            for(i = 0; i < sortedKeys.length; i++){
                var k = sortedKeys[i];
                result.push([
                    k,
                    canonicalHeaders[k]
                ].join(":"));
                if (unsigned_headers.indexOf(k) === -1) signed_headers.push(k);
            }
            return {
                canonicalHeaders: result.join("\n"),
                signedHeaders: signed_headers.join(";")
            };
        };
        AwsSignatureV4.prototype.canonicalRequest = function() {
            if (typeof this._cr !== 'undefined') return this._cr;
            var canonParts = [];
            canonParts.push(this.request.method);
            canonParts.push(uri([
                awsRequest.awsUrl,
                awsRequest.getPath(),
                this.request.path
            ].join("")).pathname);
            canonParts.push(this.canonicalQueryString() || '');
            var headers = this.canonicalHeaders();
            canonParts.push(headers.canonicalHeaders + '\n');
            canonParts.push(headers.signedHeaders);
            canonParts.push(this.getPayloadSha256Content());
            this._cr = canonParts.join("\n");
            l.d(this.request.step, 'V4 CanonicalRequest:', this._cr);
            return this._cr;
        };
        AwsSignatureV4.prototype.setHeaders = function(xhr) {
            xhr.setRequestHeader("x-amz-content-sha256", this.getPayloadSha256Content());
        };
        return con.awsSignatureVersion === '4' ? AwsSignatureV4 : AwsSignatureV2;
    }
    function authorizationMethod(awsRequest) {
        var fileUpload = awsRequest.fileUpload, con = fileUpload.con, request = awsRequest.request;
        function AuthorizationMethod() {
            this.request = request;
        }
        AuthorizationMethod.prototype = Object.create(AuthorizationMethod.prototype);
        AuthorizationMethod.prototype.request = {};
        AuthorizationMethod.makeSignParamsObject = function(params) {
            var out = {};
            for(var param in params){
                if (!params.hasOwnProperty(param)) continue;
                if (typeof params[param] === 'function') out[param] = params[param]();
                else out[param] = params[param];
            }
            return out;
        };
        AuthorizationMethod.prototype.authorize = function() {
            return new Promise(function(resolve, reject) {
                var xhr = new XMLHttpRequest();
                awsRequest.currentXhr = xhr;
                var stringToSign = awsRequest.stringToSign(), url = [
                    con.signerUrl,
                    '?to_sign=',
                    stringToSign,
                    '&datetime=',
                    request.dateString
                ];
                if (con.sendCanonicalRequestToSignerUrl) {
                    url.push('&canonical_request=');
                    url.push(encodeURIComponent(awsRequest.canonicalRequest()));
                }
                url = url.join("");
                var signParams = AuthorizationMethod.makeSignParamsObject(fileUpload.signParams);
                for(var param in signParams){
                    if (!signParams.hasOwnProperty(param)) continue;
                    url += '&' + encodeURIComponent(param) + '=' + encodeURIComponent(signParams[param]);
                }
                if (con.xhrWithCredentials) xhr.withCredentials = true;
                xhr.onreadystatechange = function() {
                    if (xhr.readyState === 4) {
                        if (xhr.status === 200) awsRequest.signResponse(xhr.response, stringToSign, request.dateString).then(resolve);
                        else {
                            if ([
                                401,
                                403
                            ].indexOf(xhr.status) > -1) {
                                var reason = "status:" + xhr.status;
                                fileUpload.deferredCompletion.reject('Permission denied ' + reason);
                                return reject(reason);
                            }
                            reject("Signature fetch returned status: " + xhr.status);
                        }
                    }
                };
                xhr.onerror = function(xhr) {
                    reject('authorizedSend transport error: ' + xhr.responseText);
                };
                xhr.open('GET', url);
                var signHeaders = AuthorizationMethod.makeSignParamsObject(con.signHeaders);
                for(var header in signHeaders){
                    if (!signHeaders.hasOwnProperty(header)) continue;
                    xhr.setRequestHeader(header, signHeaders[header]);
                }
                if (typeof fileUpload.beforeSigner === 'function') fileUpload.beforeSigner(xhr, url);
                xhr.send();
            });
        };
        function AuthorizationCustom() {
            AuthorizationMethod.call(this);
        }
        AuthorizationCustom.prototype = Object.create(AuthorizationMethod.prototype);
        AuthorizationCustom.prototype.authorize = function() {
            return con.customAuthMethod(AuthorizationMethod.makeSignParamsObject(fileUpload.signParams), AuthorizationMethod.makeSignParamsObject(con.signHeaders), awsRequest.stringToSign(), request.dateString, awsRequest.canonicalRequest()).catch(function(reason) {
                fileUpload.deferredCompletion.reject(reason);
                throw reason;
            });
        };
        if (typeof con.customAuthMethod === 'function') return new AuthorizationCustom();
        return new AuthorizationMethod();
    }
    function awsUrl(con) {
        var url;
        if (con.aws_url) url = [
            con.aws_url
        ];
        else {
            if (con.s3Acceleration) {
                url = [
                    "https://",
                    con.bucket,
                    ".s3-accelerate"
                ];
                con.cloudfront = true;
            } else {
                url = [
                    "https://",
                    con.cloudfront ? con.bucket + "." : "",
                    "s3"
                ];
                if (con.awsRegion !== "us-east-1") url.push("-", con.awsRegion);
            }
            url.push(".amazonaws.com");
        }
        return url.join("");
    }
    function s3EncodedObjectName(fileName) {
        var fileParts = fileName.split('/'), encodedParts = [];
        fileParts.forEach(function(p) {
            var buf = [], enc = encodeURIComponent(p);
            for(var i = 0; i < enc.length; i++)buf.push(S3_EXTRA_ENCODED_CHARS[enc.charCodeAt(i)] || enc.charAt(i));
            encodedParts.push(buf.join(""));
        });
        return encodedParts.join('/');
    }
    function uri(url) {
        var p, href = url || '/';
        try {
            p = new URL(href);
        } catch (e) {
            p = document.createElement('a');
            p.href = href;
        }
        return {
            protocol: p.protocol,
            hostname: p.hostname,
            // IE omits the leading slash, so add it if it's missing
            pathname: p.pathname.replace(/(^\/?)/, "/"),
            port: p.port,
            search: p.search[0] === '?' ? p.search.substr(1) : p.search,
            hash: p.hash,
            host: p.host // => "example.com:3000"
        };
    }
    function dateISOString(date) {
        // Try to get the modified date as an ISO String, if the date exists
        return date ? new Date(date).toISOString() : '';
    }
    function getAwsResponse(xhr) {
        var code = elementText(xhr.responseText, "Code"), msg = elementText(xhr.responseText, "Message");
        return code.length ? [
            'AWS Code: ',
            code,
            ', Message:',
            msg
        ].join("") : '';
    }
    function elementText(source, element) {
        var match = source.match([
            "<",
            element,
            ">(.+)</",
            element,
            ">"
        ].join(""));
        return match ? match[1] : '';
    }
    function defer() {
        var deferred = {}, promise;
        promise = new Promise(function(resolve, reject) {
            deferred = {
                resolve: resolve,
                reject: reject
            };
        });
        return {
            resolve: deferred.resolve,
            reject: deferred.reject,
            promise: promise
        };
    }
    function extend(obj1, obj2, obj3) {
        function ext(target, source) {
            if (typeof source !== 'object') return;
            for(var key in source)if (source.hasOwnProperty(key)) target[key] = source[key];
        }
        obj1 = obj1 || {};
        obj2 = obj2 || {};
        obj3 = obj3 || {};
        ext(obj2, obj3);
        ext(obj1, obj2);
        return obj1;
    }
    function getSavedUploads(purge) {
        var uploads = JSON.parse(historyCache.getItem('awsUploads') || '{}');
        if (purge) {
            for(var key in uploads)if (uploads.hasOwnProperty(key)) {
                var upload = uploads[key], completedAt = new Date(upload.completedAt || FAR_FUTURE);
                if (completedAt < HOURS_AGO) // The upload is recent, let's keep it
                delete uploads[key];
            }
            historyCache.setItem('awsUploads', JSON.stringify(uploads));
        }
        return uploads;
    }
    function uploadKey(fileUpload) {
        // The key tries to give a signature to a file in the absence of its path.
        // "<filename>-<mimetype>-<modifieddate>-<filesize>"
        return [
            fileUpload.file.name,
            fileUpload.file.type,
            dateISOString(fileUpload.file.lastModified),
            fileUpload.sizeBytes
        ].join("-");
    }
    function saveUpload(uploadKey, upload) {
        var uploads = getSavedUploads();
        uploads[uploadKey] = upload;
        historyCache.setItem('awsUploads', JSON.stringify(uploads));
    }
    function removeUpload(uploadKey) {
        var uploads = getSavedUploads();
        delete uploads[uploadKey];
        historyCache.setItem('awsUploads', JSON.stringify(uploads));
    }
    function removeAtIndex(a, i) {
        var idx = a.indexOf(i);
        if (idx > -1) {
            a.splice(idx, 1);
            return true;
        }
    }
    function readableFileSize(size) {
        // Adapted from https://github.com/fkjaekel
        // https://github.com/TTLabs/EvaporateJS/issues/13
        var units = [
            'B',
            'Kb',
            'Mb',
            'Gb',
            'Tb',
            'Pb',
            'Eb',
            'Zb',
            'Yb'
        ], i = 0;
        while(size >= 1024){
            size /= 1024;
            ++i;
        }
        return [
            size.toFixed(2).replace('.00', ''),
            units[i]
        ].join(" ");
    }
    var historyCache;
    function HistoryCache(mockLocalStorage) {
        var supported = HistoryCache.supported();
        this.cacheStore = mockLocalStorage ? {} : supported ? localStorage : undefined;
    }
    HistoryCache.prototype.supported = false;
    HistoryCache.prototype.cacheStore = undefined;
    HistoryCache.prototype.getItem = function(key) {
        if (this.cacheStore) return this.cacheStore[key];
    };
    HistoryCache.prototype.setItem = function(key, value) {
        if (this.cacheStore) this.cacheStore[key] = value;
    };
    HistoryCache.prototype.removeItem = function(key) {
        if (this.cacheStore) return delete this.cacheStore[key];
    };
    HistoryCache.supported = function() {
        var result = false;
        if (typeof window !== 'undefined') {
            if (!('localStorage' in window)) return result;
        } else return result;
        // Try to use storage (it might be disabled, e.g. user is in private mode)
        try {
            var k = '___test';
            localStorage[k] = 'OK';
            var test = localStorage[k];
            delete localStorage[k];
            return test === 'OK';
        } catch (e) {
            return result;
        }
    };
    function noOpLogger() {
        return {
            d: function() {},
            w: function() {},
            e: function() {}
        };
    }
    l = noOpLogger();
    if (module.exports) module.exports = Evaporate;
    else if (typeof window !== 'undefined') window.Evaporate = Evaporate;
})();

});

parcelRegister("3D2Yk", function(module, exports) {
(function(factory) {
    var glob, e;
    // Node/CommonJS
    module.exports = factory();
})(function(undefined) {
    'use strict';
    /*
     * Fastest md5 implementation around (JKM md5).
     * Credits: Joseph Myers
     *
     * @see http://www.myersdaily.org/joseph/javascript/md5-text.html
     * @see http://jsperf.com/md5-shootout/7
     */ /* this function is much faster,
      so if possible we use it. Some IEs
      are the only ones I know of that
      need the idiotic second function,
      generated by an if clause.  */ var add32 = function(a, b) {
        return a + b & 0xFFFFFFFF;
    }, hex_chr = [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        'a',
        'b',
        'c',
        'd',
        'e',
        'f'
    ];
    function cmn(q, a, b, x, s, t) {
        a = add32(add32(a, q), add32(x, t));
        return add32(a << s | a >>> 32 - s, b);
    }
    function md5cycle(x, k) {
        var a = x[0], b = x[1], c = x[2], d = x[3];
        a += (b & c | ~b & d) + k[0] - 680876936 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[1] - 389564586 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[2] + 606105819 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[3] - 1044525330 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[4] - 176418897 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[5] + 1200080426 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[6] - 1473231341 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[7] - 45705983 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[8] + 1770035416 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[9] - 1958414417 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[10] - 42063 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[11] - 1990404162 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[12] + 1804603682 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[13] - 40341101 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[14] - 1502002290 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[15] + 1236535329 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & d | c & ~d) + k[1] - 165796510 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[6] - 1069501632 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[11] + 643717713 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[0] - 373897302 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[5] - 701558691 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[10] + 38016083 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[15] - 660478335 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[4] - 405537848 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[9] + 568446438 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[14] - 1019803690 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[3] - 187363961 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[8] + 1163531501 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[13] - 1444681467 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[2] - 51403784 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[7] + 1735328473 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[12] - 1926607734 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b ^ c ^ d) + k[5] - 378558 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[8] - 2022574463 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[11] + 1839030562 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[14] - 35309556 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[1] - 1530992060 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[4] + 1272893353 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[7] - 155497632 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[10] - 1094730640 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[13] + 681279174 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[0] - 358537222 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[3] - 722521979 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[6] + 76029189 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[9] - 640364487 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[12] - 421815835 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[15] + 530742520 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[2] - 995338651 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (c ^ (b | ~d)) + k[0] - 198630844 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[7] + 1126891415 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[14] - 1416354905 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[5] - 57434055 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[12] + 1700485571 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[3] - 1894986606 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[10] - 1051523 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[1] - 2054922799 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[8] + 1873313359 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[15] - 30611744 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[6] - 1560198380 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[13] + 1309151649 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[4] - 145523070 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[11] - 1120210379 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[2] + 718787259 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[9] - 343485551 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        x[0] = a + x[0] | 0;
        x[1] = b + x[1] | 0;
        x[2] = c + x[2] | 0;
        x[3] = d + x[3] | 0;
    }
    function md5blk(s) {
        var md5blks = [], i; /* Andy King said do it this way. */ 
        for(i = 0; i < 64; i += 4)md5blks[i >> 2] = s.charCodeAt(i) + (s.charCodeAt(i + 1) << 8) + (s.charCodeAt(i + 2) << 16) + (s.charCodeAt(i + 3) << 24);
        return md5blks;
    }
    function md5blk_array(a) {
        var md5blks = [], i; /* Andy King said do it this way. */ 
        for(i = 0; i < 64; i += 4)md5blks[i >> 2] = a[i] + (a[i + 1] << 8) + (a[i + 2] << 16) + (a[i + 3] << 24);
        return md5blks;
    }
    function md51(s) {
        var n = s.length, state = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ], i, length, tail, tmp, lo, hi;
        for(i = 64; i <= n; i += 64)md5cycle(state, md5blk(s.substring(i - 64, i)));
        s = s.substring(i - 64);
        length = s.length;
        tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        for(i = 0; i < length; i += 1)tail[i >> 2] |= s.charCodeAt(i) << (i % 4 << 3);
        tail[i >> 2] |= 0x80 << (i % 4 << 3);
        if (i > 55) {
            md5cycle(state, tail);
            for(i = 0; i < 16; i += 1)tail[i] = 0;
        }
        // Beware that the final length might not fit in 32 bits so we take care of that
        tmp = n * 8;
        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
        lo = parseInt(tmp[2], 16);
        hi = parseInt(tmp[1], 16) || 0;
        tail[14] = lo;
        tail[15] = hi;
        md5cycle(state, tail);
        return state;
    }
    function md51_array(a) {
        var n = a.length, state = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ], i, length, tail, tmp, lo, hi;
        for(i = 64; i <= n; i += 64)md5cycle(state, md5blk_array(a.subarray(i - 64, i)));
        // Not sure if it is a bug, however IE10 will always produce a sub array of length 1
        // containing the last element of the parent array if the sub array specified starts
        // beyond the length of the parent array - weird.
        // https://connect.microsoft.com/IE/feedback/details/771452/typed-array-subarray-issue
        a = i - 64 < n ? a.subarray(i - 64) : new Uint8Array(0);
        length = a.length;
        tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        for(i = 0; i < length; i += 1)tail[i >> 2] |= a[i] << (i % 4 << 3);
        tail[i >> 2] |= 0x80 << (i % 4 << 3);
        if (i > 55) {
            md5cycle(state, tail);
            for(i = 0; i < 16; i += 1)tail[i] = 0;
        }
        // Beware that the final length might not fit in 32 bits so we take care of that
        tmp = n * 8;
        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
        lo = parseInt(tmp[2], 16);
        hi = parseInt(tmp[1], 16) || 0;
        tail[14] = lo;
        tail[15] = hi;
        md5cycle(state, tail);
        return state;
    }
    function rhex(n) {
        var s = '', j;
        for(j = 0; j < 4; j += 1)s += hex_chr[n >> j * 8 + 4 & 0x0F] + hex_chr[n >> j * 8 & 0x0F];
        return s;
    }
    function hex(x) {
        var i;
        for(i = 0; i < x.length; i += 1)x[i] = rhex(x[i]);
        return x.join('');
    }
    // In some cases the fast add32 function cannot be used..
    if (hex(md51('hello')) !== '5d41402abc4b2a76b9719d911017c592') add32 = function(x, y) {
        var lsw = (x & 0xFFFF) + (y & 0xFFFF), msw = (x >> 16) + (y >> 16) + (lsw >> 16);
        return msw << 16 | lsw & 0xFFFF;
    };
    // ---------------------------------------------------
    /**
     * ArrayBuffer slice polyfill.
     *
     * @see https://github.com/ttaubert/node-arraybuffer-slice
     */ if (typeof ArrayBuffer !== 'undefined' && !ArrayBuffer.prototype.slice) (function() {
        function clamp(val, length) {
            val = val | 0 || 0;
            if (val < 0) return Math.max(val + length, 0);
            return Math.min(val, length);
        }
        ArrayBuffer.prototype.slice = function(from, to) {
            var length = this.byteLength, begin = clamp(from, length), end = length, num, target, targetArray, sourceArray;
            if (to !== undefined) end = clamp(to, length);
            if (begin > end) return new ArrayBuffer(0);
            num = end - begin;
            target = new ArrayBuffer(num);
            targetArray = new Uint8Array(target);
            sourceArray = new Uint8Array(this, begin, num);
            targetArray.set(sourceArray);
            return target;
        };
    })();
    // ---------------------------------------------------
    /**
     * Helpers.
     */ function toUtf8(str) {
        if (/[\u0080-\uFFFF]/.test(str)) str = unescape(encodeURIComponent(str));
        return str;
    }
    function utf8Str2ArrayBuffer(str, returnUInt8Array) {
        var length = str.length, buff = new ArrayBuffer(length), arr = new Uint8Array(buff), i;
        for(i = 0; i < length; i += 1)arr[i] = str.charCodeAt(i);
        return returnUInt8Array ? arr : buff;
    }
    function arrayBuffer2Utf8Str(buff) {
        return String.fromCharCode.apply(null, new Uint8Array(buff));
    }
    function concatenateArrayBuffers(first, second, returnUInt8Array) {
        var result = new Uint8Array(first.byteLength + second.byteLength);
        result.set(new Uint8Array(first));
        result.set(new Uint8Array(second), first.byteLength);
        return returnUInt8Array ? result : result.buffer;
    }
    function hexToBinaryString(hex) {
        var bytes = [], length = hex.length, x;
        for(x = 0; x < length - 1; x += 2)bytes.push(parseInt(hex.substr(x, 2), 16));
        return String.fromCharCode.apply(String, bytes);
    }
    // ---------------------------------------------------
    /**
     * SparkMD5 OOP implementation.
     *
     * Use this class to perform an incremental md5, otherwise use the
     * static methods instead.
     */ function SparkMD5() {
        // call reset to init the instance
        this.reset();
    }
    /**
     * Appends a string.
     * A conversion will be applied if an utf8 string is detected.
     *
     * @param {String} str The string to be appended
     *
     * @return {SparkMD5} The instance itself
     */ SparkMD5.prototype.append = function(str) {
        // Converts the string to utf8 bytes if necessary
        // Then append as binary
        this.appendBinary(toUtf8(str));
        return this;
    };
    /**
     * Appends a binary string.
     *
     * @param {String} contents The binary string to be appended
     *
     * @return {SparkMD5} The instance itself
     */ SparkMD5.prototype.appendBinary = function(contents) {
        this._buff += contents;
        this._length += contents.length;
        var length = this._buff.length, i;
        for(i = 64; i <= length; i += 64)md5cycle(this._hash, md5blk(this._buff.substring(i - 64, i)));
        this._buff = this._buff.substring(i - 64);
        return this;
    };
    /**
     * Finishes the incremental computation, reseting the internal state and
     * returning the result.
     *
     * @param {Boolean} raw True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */ SparkMD5.prototype.end = function(raw) {
        var buff = this._buff, length = buff.length, i, tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ], ret;
        for(i = 0; i < length; i += 1)tail[i >> 2] |= buff.charCodeAt(i) << (i % 4 << 3);
        this._finish(tail, length);
        ret = hex(this._hash);
        if (raw) ret = hexToBinaryString(ret);
        this.reset();
        return ret;
    };
    /**
     * Resets the internal state of the computation.
     *
     * @return {SparkMD5} The instance itself
     */ SparkMD5.prototype.reset = function() {
        this._buff = '';
        this._length = 0;
        this._hash = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ];
        return this;
    };
    /**
     * Gets the internal state of the computation.
     *
     * @return {Object} The state
     */ SparkMD5.prototype.getState = function() {
        return {
            buff: this._buff,
            length: this._length,
            hash: this._hash.slice()
        };
    };
    /**
     * Gets the internal state of the computation.
     *
     * @param {Object} state The state
     *
     * @return {SparkMD5} The instance itself
     */ SparkMD5.prototype.setState = function(state) {
        this._buff = state.buff;
        this._length = state.length;
        this._hash = state.hash;
        return this;
    };
    /**
     * Releases memory used by the incremental buffer and other additional
     * resources. If you plan to use the instance again, use reset instead.
     */ SparkMD5.prototype.destroy = function() {
        delete this._hash;
        delete this._buff;
        delete this._length;
    };
    /**
     * Finish the final calculation based on the tail.
     *
     * @param {Array}  tail   The tail (will be modified)
     * @param {Number} length The length of the remaining buffer
     */ SparkMD5.prototype._finish = function(tail, length) {
        var i = length, tmp, lo, hi;
        tail[i >> 2] |= 0x80 << (i % 4 << 3);
        if (i > 55) {
            md5cycle(this._hash, tail);
            for(i = 0; i < 16; i += 1)tail[i] = 0;
        }
        // Do the final computation based on the tail and length
        // Beware that the final length may not fit in 32 bits so we take care of that
        tmp = this._length * 8;
        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
        lo = parseInt(tmp[2], 16);
        hi = parseInt(tmp[1], 16) || 0;
        tail[14] = lo;
        tail[15] = hi;
        md5cycle(this._hash, tail);
    };
    /**
     * Performs the md5 hash on a string.
     * A conversion will be applied if utf8 string is detected.
     *
     * @param {String}  str The string
     * @param {Boolean} [raw] True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */ SparkMD5.hash = function(str, raw) {
        // Converts the string to utf8 bytes if necessary
        // Then compute it using the binary function
        return SparkMD5.hashBinary(toUtf8(str), raw);
    };
    /**
     * Performs the md5 hash on a binary string.
     *
     * @param {String}  content The binary string
     * @param {Boolean} [raw]     True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */ SparkMD5.hashBinary = function(content, raw) {
        var hash = md51(content), ret = hex(hash);
        return raw ? hexToBinaryString(ret) : ret;
    };
    // ---------------------------------------------------
    /**
     * SparkMD5 OOP implementation for array buffers.
     *
     * Use this class to perform an incremental md5 ONLY for array buffers.
     */ SparkMD5.ArrayBuffer = function() {
        // call reset to init the instance
        this.reset();
    };
    /**
     * Appends an array buffer.
     *
     * @param {ArrayBuffer} arr The array to be appended
     *
     * @return {SparkMD5.ArrayBuffer} The instance itself
     */ SparkMD5.ArrayBuffer.prototype.append = function(arr) {
        var buff = concatenateArrayBuffers(this._buff.buffer, arr, true), length = buff.length, i;
        this._length += arr.byteLength;
        for(i = 64; i <= length; i += 64)md5cycle(this._hash, md5blk_array(buff.subarray(i - 64, i)));
        this._buff = i - 64 < length ? new Uint8Array(buff.buffer.slice(i - 64)) : new Uint8Array(0);
        return this;
    };
    /**
     * Finishes the incremental computation, reseting the internal state and
     * returning the result.
     *
     * @param {Boolean} raw True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */ SparkMD5.ArrayBuffer.prototype.end = function(raw) {
        var buff = this._buff, length = buff.length, tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ], i, ret;
        for(i = 0; i < length; i += 1)tail[i >> 2] |= buff[i] << (i % 4 << 3);
        this._finish(tail, length);
        ret = hex(this._hash);
        if (raw) ret = hexToBinaryString(ret);
        this.reset();
        return ret;
    };
    /**
     * Resets the internal state of the computation.
     *
     * @return {SparkMD5.ArrayBuffer} The instance itself
     */ SparkMD5.ArrayBuffer.prototype.reset = function() {
        this._buff = new Uint8Array(0);
        this._length = 0;
        this._hash = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ];
        return this;
    };
    /**
     * Gets the internal state of the computation.
     *
     * @return {Object} The state
     */ SparkMD5.ArrayBuffer.prototype.getState = function() {
        var state = SparkMD5.prototype.getState.call(this);
        // Convert buffer to a string
        state.buff = arrayBuffer2Utf8Str(state.buff);
        return state;
    };
    /**
     * Gets the internal state of the computation.
     *
     * @param {Object} state The state
     *
     * @return {SparkMD5.ArrayBuffer} The instance itself
     */ SparkMD5.ArrayBuffer.prototype.setState = function(state) {
        // Convert string to buffer
        state.buff = utf8Str2ArrayBuffer(state.buff, true);
        return SparkMD5.prototype.setState.call(this, state);
    };
    SparkMD5.ArrayBuffer.prototype.destroy = SparkMD5.prototype.destroy;
    SparkMD5.ArrayBuffer.prototype._finish = SparkMD5.prototype._finish;
    /**
     * Performs the md5 hash on an array buffer.
     *
     * @param {ArrayBuffer} arr The array buffer
     * @param {Boolean}     [raw] True to get the raw string, false to get the hex one
     *
     * @return {String} The result
     */ SparkMD5.ArrayBuffer.hash = function(arr, raw) {
        var hash = md51_array(new Uint8Array(arr)), ret = hex(hash);
        return raw ? hexToBinaryString(ret) : ret;
    };
    return SparkMD5;
});

});

parcelRegister("cAIoR", function(module, exports) {
/**
 * [js-sha256]{@link https://github.com/emn178/js-sha256}
 *
 * @version 0.9.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2017
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    'use strict';
    var ERROR = 'input is invalid type';
    var WINDOW = typeof window === 'object';
    var root = WINDOW ? window : {};
    if (root.JS_SHA256_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === 'object';
    var NODE_JS = !root.JS_SHA256_NO_NODE_JS && false;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === 'function' && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
    var HEX_CHARS = '0123456789abcdef'.split('');
    var EXTRA = [
        -2147483648,
        8388608,
        32768,
        128
    ];
    var SHIFT = [
        24,
        16,
        8,
        0
    ];
    var K = [
        0x428a2f98,
        0x71374491,
        0xb5c0fbcf,
        0xe9b5dba5,
        0x3956c25b,
        0x59f111f1,
        0x923f82a4,
        0xab1c5ed5,
        0xd807aa98,
        0x12835b01,
        0x243185be,
        0x550c7dc3,
        0x72be5d74,
        0x80deb1fe,
        0x9bdc06a7,
        0xc19bf174,
        0xe49b69c1,
        0xefbe4786,
        0x0fc19dc6,
        0x240ca1cc,
        0x2de92c6f,
        0x4a7484aa,
        0x5cb0a9dc,
        0x76f988da,
        0x983e5152,
        0xa831c66d,
        0xb00327c8,
        0xbf597fc7,
        0xc6e00bf3,
        0xd5a79147,
        0x06ca6351,
        0x14292967,
        0x27b70a85,
        0x2e1b2138,
        0x4d2c6dfc,
        0x53380d13,
        0x650a7354,
        0x766a0abb,
        0x81c2c92e,
        0x92722c85,
        0xa2bfe8a1,
        0xa81a664b,
        0xc24b8b70,
        0xc76c51a3,
        0xd192e819,
        0xd6990624,
        0xf40e3585,
        0x106aa070,
        0x19a4c116,
        0x1e376c08,
        0x2748774c,
        0x34b0bcb5,
        0x391c0cb3,
        0x4ed8aa4a,
        0x5b9cca4f,
        0x682e6ff3,
        0x748f82ee,
        0x78a5636f,
        0x84c87814,
        0x8cc70208,
        0x90befffa,
        0xa4506ceb,
        0xbef9a3f7,
        0xc67178f2
    ];
    var OUTPUT_TYPES = [
        'hex',
        'array',
        'digest',
        'arrayBuffer'
    ];
    var blocks = [];
    if (root.JS_SHA256_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    if (ARRAY_BUFFER && (root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(outputType, is224) {
        return function(message) {
            return new Sha256(is224, true).update(message)[outputType]();
        };
    };
    var createMethod = function(is224) {
        var method = createOutputMethod('hex', is224);
        if (NODE_JS) method = nodeWrap(method, is224);
        method.create = function() {
            return new Sha256(is224);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createOutputMethod(type, is224);
        }
        return method;
    };
    var nodeWrap = function(method, is224) {
        var crypto = eval("require('crypto')");
        var Buffer = eval("require('buffer').Buffer");
        var algorithm = is224 ? 'sha224' : 'sha256';
        var nodeMethod = function(message) {
            if (typeof message === 'string') return crypto.createHash(algorithm).update(message, 'utf8').digest('hex');
            else {
                if (message === null || message === undefined) throw new Error(ERROR);
                else if (message.constructor === ArrayBuffer) message = new Uint8Array(message);
            }
            if (Array.isArray(message) || ArrayBuffer.isView(message) || message.constructor === Buffer) return crypto.createHash(algorithm).update(new Buffer(message)).digest('hex');
            else return method(message);
        };
        return nodeMethod;
    };
    var createHmacOutputMethod = function(outputType, is224) {
        return function(key, message) {
            return new HmacSha256(key, is224, true).update(message)[outputType]();
        };
    };
    var createHmacMethod = function(is224) {
        var method = createHmacOutputMethod('hex', is224);
        method.create = function(key) {
            return new HmacSha256(key, is224);
        };
        method.update = function(key, message) {
            return method.create(key).update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createHmacOutputMethod(type, is224);
        }
        return method;
    };
    function Sha256(is224, sharedMemory) {
        if (sharedMemory) {
            blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            this.blocks = blocks;
        } else this.blocks = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        if (is224) {
            this.h0 = 0xc1059ed8;
            this.h1 = 0x367cd507;
            this.h2 = 0x3070dd17;
            this.h3 = 0xf70e5939;
            this.h4 = 0xffc00b31;
            this.h5 = 0x68581511;
            this.h6 = 0x64f98fa7;
            this.h7 = 0xbefa4fa4;
        } else {
            this.h0 = 0x6a09e667;
            this.h1 = 0xbb67ae85;
            this.h2 = 0x3c6ef372;
            this.h3 = 0xa54ff53a;
            this.h4 = 0x510e527f;
            this.h5 = 0x9b05688c;
            this.h6 = 0x1f83d9ab;
            this.h7 = 0x5be0cd19;
        }
        this.block = this.start = this.bytes = this.hBytes = 0;
        this.finalized = this.hashed = false;
        this.first = true;
        this.is224 = is224;
    }
    Sha256.prototype.update = function(message) {
        if (this.finalized) return;
        var notString, type = typeof message;
        if (type !== 'string') {
            if (type === 'object') {
                if (message === null) throw new Error(ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(ERROR);
                }
            } else throw new Error(ERROR);
            notString = true;
        }
        var code, index = 0, i, length = message.length, blocks = this.blocks;
        while(index < length){
            if (this.hashed) {
                this.hashed = false;
                blocks[0] = this.block;
                blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            }
            if (notString) for(i = this.start; index < length && i < 64; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < 64; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            this.bytes += i - this.start;
            if (i >= 64) {
                this.block = blocks[16];
                this.start = i - 64;
                this.hash();
                this.hashed = true;
            } else this.start = i;
        }
        if (this.bytes > 4294967295) {
            this.hBytes += this.bytes / 4294967296 << 0;
            this.bytes = this.bytes % 4294967296;
        }
        return this;
    };
    Sha256.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex;
        blocks[16] = this.block;
        blocks[i >> 2] |= EXTRA[i & 3];
        this.block = blocks[16];
        if (i >= 56) {
            if (!this.hashed) this.hash();
            blocks[0] = this.block;
            blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
        }
        blocks[14] = this.hBytes << 3 | this.bytes >>> 29;
        blocks[15] = this.bytes << 3;
        this.hash();
    };
    Sha256.prototype.hash = function() {
        var a = this.h0, b = this.h1, c = this.h2, d = this.h3, e = this.h4, f = this.h5, g = this.h6, h = this.h7, blocks = this.blocks, j, s0, s1, maj, t1, t2, ch, ab, da, cd, bc;
        for(j = 16; j < 64; ++j){
            // rightrotate
            t1 = blocks[j - 15];
            s0 = (t1 >>> 7 | t1 << 25) ^ (t1 >>> 18 | t1 << 14) ^ t1 >>> 3;
            t1 = blocks[j - 2];
            s1 = (t1 >>> 17 | t1 << 15) ^ (t1 >>> 19 | t1 << 13) ^ t1 >>> 10;
            blocks[j] = blocks[j - 16] + s0 + blocks[j - 7] + s1 << 0;
        }
        bc = b & c;
        for(j = 0; j < 64; j += 4){
            if (this.first) {
                if (this.is224) {
                    ab = 300032;
                    t1 = blocks[0] - 1413257819;
                    h = t1 - 150054599 << 0;
                    d = t1 + 24177077 << 0;
                } else {
                    ab = 704751109;
                    t1 = blocks[0] - 210244248;
                    h = t1 - 1521486534 << 0;
                    d = t1 + 143694565 << 0;
                }
                this.first = false;
            } else {
                s0 = (a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10);
                s1 = (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
                ab = a & b;
                maj = ab ^ a & c ^ bc;
                ch = e & f ^ ~e & g;
                t1 = h + s1 + ch + K[j] + blocks[j];
                t2 = s0 + maj;
                h = d + t1 << 0;
                d = t1 + t2 << 0;
            }
            s0 = (d >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10);
            s1 = (h >>> 6 | h << 26) ^ (h >>> 11 | h << 21) ^ (h >>> 25 | h << 7);
            da = d & a;
            maj = da ^ d & b ^ ab;
            ch = h & e ^ ~h & f;
            t1 = g + s1 + ch + K[j + 1] + blocks[j + 1];
            t2 = s0 + maj;
            g = c + t1 << 0;
            c = t1 + t2 << 0;
            s0 = (c >>> 2 | c << 30) ^ (c >>> 13 | c << 19) ^ (c >>> 22 | c << 10);
            s1 = (g >>> 6 | g << 26) ^ (g >>> 11 | g << 21) ^ (g >>> 25 | g << 7);
            cd = c & d;
            maj = cd ^ c & a ^ da;
            ch = g & h ^ ~g & e;
            t1 = f + s1 + ch + K[j + 2] + blocks[j + 2];
            t2 = s0 + maj;
            f = b + t1 << 0;
            b = t1 + t2 << 0;
            s0 = (b >>> 2 | b << 30) ^ (b >>> 13 | b << 19) ^ (b >>> 22 | b << 10);
            s1 = (f >>> 6 | f << 26) ^ (f >>> 11 | f << 21) ^ (f >>> 25 | f << 7);
            bc = b & c;
            maj = bc ^ b & d ^ cd;
            ch = f & g ^ ~f & h;
            t1 = e + s1 + ch + K[j + 3] + blocks[j + 3];
            t2 = s0 + maj;
            e = a + t1 << 0;
            a = t1 + t2 << 0;
        }
        this.h0 = this.h0 + a << 0;
        this.h1 = this.h1 + b << 0;
        this.h2 = this.h2 + c << 0;
        this.h3 = this.h3 + d << 0;
        this.h4 = this.h4 + e << 0;
        this.h5 = this.h5 + f << 0;
        this.h6 = this.h6 + g << 0;
        this.h7 = this.h7 + h << 0;
    };
    Sha256.prototype.hex = function() {
        this.finalize();
        var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
        var hex = HEX_CHARS[h0 >> 28 & 0x0F] + HEX_CHARS[h0 >> 24 & 0x0F] + HEX_CHARS[h0 >> 20 & 0x0F] + HEX_CHARS[h0 >> 16 & 0x0F] + HEX_CHARS[h0 >> 12 & 0x0F] + HEX_CHARS[h0 >> 8 & 0x0F] + HEX_CHARS[h0 >> 4 & 0x0F] + HEX_CHARS[h0 & 0x0F] + HEX_CHARS[h1 >> 28 & 0x0F] + HEX_CHARS[h1 >> 24 & 0x0F] + HEX_CHARS[h1 >> 20 & 0x0F] + HEX_CHARS[h1 >> 16 & 0x0F] + HEX_CHARS[h1 >> 12 & 0x0F] + HEX_CHARS[h1 >> 8 & 0x0F] + HEX_CHARS[h1 >> 4 & 0x0F] + HEX_CHARS[h1 & 0x0F] + HEX_CHARS[h2 >> 28 & 0x0F] + HEX_CHARS[h2 >> 24 & 0x0F] + HEX_CHARS[h2 >> 20 & 0x0F] + HEX_CHARS[h2 >> 16 & 0x0F] + HEX_CHARS[h2 >> 12 & 0x0F] + HEX_CHARS[h2 >> 8 & 0x0F] + HEX_CHARS[h2 >> 4 & 0x0F] + HEX_CHARS[h2 & 0x0F] + HEX_CHARS[h3 >> 28 & 0x0F] + HEX_CHARS[h3 >> 24 & 0x0F] + HEX_CHARS[h3 >> 20 & 0x0F] + HEX_CHARS[h3 >> 16 & 0x0F] + HEX_CHARS[h3 >> 12 & 0x0F] + HEX_CHARS[h3 >> 8 & 0x0F] + HEX_CHARS[h3 >> 4 & 0x0F] + HEX_CHARS[h3 & 0x0F] + HEX_CHARS[h4 >> 28 & 0x0F] + HEX_CHARS[h4 >> 24 & 0x0F] + HEX_CHARS[h4 >> 20 & 0x0F] + HEX_CHARS[h4 >> 16 & 0x0F] + HEX_CHARS[h4 >> 12 & 0x0F] + HEX_CHARS[h4 >> 8 & 0x0F] + HEX_CHARS[h4 >> 4 & 0x0F] + HEX_CHARS[h4 & 0x0F] + HEX_CHARS[h5 >> 28 & 0x0F] + HEX_CHARS[h5 >> 24 & 0x0F] + HEX_CHARS[h5 >> 20 & 0x0F] + HEX_CHARS[h5 >> 16 & 0x0F] + HEX_CHARS[h5 >> 12 & 0x0F] + HEX_CHARS[h5 >> 8 & 0x0F] + HEX_CHARS[h5 >> 4 & 0x0F] + HEX_CHARS[h5 & 0x0F] + HEX_CHARS[h6 >> 28 & 0x0F] + HEX_CHARS[h6 >> 24 & 0x0F] + HEX_CHARS[h6 >> 20 & 0x0F] + HEX_CHARS[h6 >> 16 & 0x0F] + HEX_CHARS[h6 >> 12 & 0x0F] + HEX_CHARS[h6 >> 8 & 0x0F] + HEX_CHARS[h6 >> 4 & 0x0F] + HEX_CHARS[h6 & 0x0F];
        if (!this.is224) hex += HEX_CHARS[h7 >> 28 & 0x0F] + HEX_CHARS[h7 >> 24 & 0x0F] + HEX_CHARS[h7 >> 20 & 0x0F] + HEX_CHARS[h7 >> 16 & 0x0F] + HEX_CHARS[h7 >> 12 & 0x0F] + HEX_CHARS[h7 >> 8 & 0x0F] + HEX_CHARS[h7 >> 4 & 0x0F] + HEX_CHARS[h7 & 0x0F];
        return hex;
    };
    Sha256.prototype.toString = Sha256.prototype.hex;
    Sha256.prototype.digest = function() {
        this.finalize();
        var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
        var arr = [
            h0 >> 24 & 0xFF,
            h0 >> 16 & 0xFF,
            h0 >> 8 & 0xFF,
            h0 & 0xFF,
            h1 >> 24 & 0xFF,
            h1 >> 16 & 0xFF,
            h1 >> 8 & 0xFF,
            h1 & 0xFF,
            h2 >> 24 & 0xFF,
            h2 >> 16 & 0xFF,
            h2 >> 8 & 0xFF,
            h2 & 0xFF,
            h3 >> 24 & 0xFF,
            h3 >> 16 & 0xFF,
            h3 >> 8 & 0xFF,
            h3 & 0xFF,
            h4 >> 24 & 0xFF,
            h4 >> 16 & 0xFF,
            h4 >> 8 & 0xFF,
            h4 & 0xFF,
            h5 >> 24 & 0xFF,
            h5 >> 16 & 0xFF,
            h5 >> 8 & 0xFF,
            h5 & 0xFF,
            h6 >> 24 & 0xFF,
            h6 >> 16 & 0xFF,
            h6 >> 8 & 0xFF,
            h6 & 0xFF
        ];
        if (!this.is224) arr.push(h7 >> 24 & 0xFF, h7 >> 16 & 0xFF, h7 >> 8 & 0xFF, h7 & 0xFF);
        return arr;
    };
    Sha256.prototype.array = Sha256.prototype.digest;
    Sha256.prototype.arrayBuffer = function() {
        this.finalize();
        var buffer = new ArrayBuffer(this.is224 ? 28 : 32);
        var dataView = new DataView(buffer);
        dataView.setUint32(0, this.h0);
        dataView.setUint32(4, this.h1);
        dataView.setUint32(8, this.h2);
        dataView.setUint32(12, this.h3);
        dataView.setUint32(16, this.h4);
        dataView.setUint32(20, this.h5);
        dataView.setUint32(24, this.h6);
        if (!this.is224) dataView.setUint32(28, this.h7);
        return buffer;
    };
    function HmacSha256(key, is224, sharedMemory) {
        var i, type = typeof key;
        if (type === 'string') {
            var bytes = [], length = key.length, index = 0, code;
            for(i = 0; i < length; ++i){
                code = key.charCodeAt(i);
                if (code < 0x80) bytes[index++] = code;
                else if (code < 0x800) {
                    bytes[index++] = 0xc0 | code >> 6;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else if (code < 0xd800 || code >= 0xe000) {
                    bytes[index++] = 0xe0 | code >> 12;
                    bytes[index++] = 0x80 | code >> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | key.charCodeAt(++i) & 0x3ff);
                    bytes[index++] = 0xf0 | code >> 18;
                    bytes[index++] = 0x80 | code >> 12 & 0x3f;
                    bytes[index++] = 0x80 | code >> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                }
            }
            key = bytes;
        } else {
            if (type === 'object') {
                if (key === null) throw new Error(ERROR);
                else if (ARRAY_BUFFER && key.constructor === ArrayBuffer) key = new Uint8Array(key);
                else if (!Array.isArray(key)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(key)) throw new Error(ERROR);
                }
            } else throw new Error(ERROR);
        }
        if (key.length > 64) key = new Sha256(is224, true).update(key).array();
        var oKeyPad = [], iKeyPad = [];
        for(i = 0; i < 64; ++i){
            var b = key[i] || 0;
            oKeyPad[i] = 0x5c ^ b;
            iKeyPad[i] = 0x36 ^ b;
        }
        Sha256.call(this, is224, sharedMemory);
        this.update(iKeyPad);
        this.oKeyPad = oKeyPad;
        this.inner = true;
        this.sharedMemory = sharedMemory;
    }
    HmacSha256.prototype = new Sha256();
    HmacSha256.prototype.finalize = function() {
        Sha256.prototype.finalize.call(this);
        if (this.inner) {
            this.inner = false;
            var innerHash = this.array();
            Sha256.call(this, this.is224, this.sharedMemory);
            this.update(this.oKeyPad);
            this.update(innerHash);
            Sha256.prototype.finalize.call(this);
        }
    };
    var exports = createMethod();
    exports.sha256 = exports;
    exports.sha224 = createMethod(true);
    exports.sha256.hmac = createHmacMethod();
    exports.sha224.hmac = createHmacMethod(true);
    if (COMMON_JS) module.exports = exports;
    else {
        root.sha256 = exports.sha256;
        root.sha224 = exports.sha224;
        if (AMD) define(function() {
            return exports;
        });
    }
})();

});


parcelRegister("kRPup", function(module, exports) {
module.exports = function player(app) {
    var key = 'nomalabLastAudioQualification';
    function init() {
        if (localStorage.getItem(key) === null) localStorage.setItem(key, JSON.stringify({}));
    }
    function clean() {
        if (localStorage.getItem(key) != null) {
            localStorage.setItem(key, JSON.stringify({}));
            app.ports.content.send(getContent());
        }
    }
    function set(k, v, l, t) {
        var s = JSON.parse(localStorage.getItem(key));
        s[k] = {
            v: v,
            l: l,
            t: t
        };
        localStorage.setItem(key, JSON.stringify(s));
    }
    function get(record) {
        return {
            fileId: record.fileId,
            channels: record.channels,
            result: getContent()
        };
    }
    function getContent() {
        var store = JSON.parse(localStorage.getItem(key));
        var r = [];
        Object.keys(store).forEach(function(k) {
            r.push({
                index: parseInt(k, 10),
                version: store[k].v,
                layout: store[k].l,
                typeVersion: store[k].t
            });
        });
        return r;
    }
    init();
    app.ports.get.subscribe(function(record) {
        app.ports.lastAudioQualification.send(get(record));
    });
    app.ports.info.subscribe(function() {
        app.ports.content.send(getContent());
    });
    app.ports.clean.subscribe(clean);
    app.ports.save.subscribe(function(recordList) {
        recordList.forEach(function(record) {
            if (record.layout !== null && record.typeVersion !== null) set(record.index, record.version, record.layout, record.typeVersion);
        });
        app.ports.content.send(getContent());
    });
    return app;
};

});

"use strict";
const $be336afef88fa60f$var$global_ = window || self || $parcel$global || Function('return this')();
const $be336afef88fa60f$var$setTimeout_ = setTimeout;
const $be336afef88fa60f$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $be336afef88fa60f$var$secret = -Math.random();
let $be336afef88fa60f$var$promiseSlot; // 👻
Object.defineProperty(Object.prototype, "_elm_ffi_read_", {
    get () {
        return this.value;
    },
    set (code) {
        try {
            this.value = Function(code)();
        } catch (e) {
            console.error(e);
        }
    }
});
Object.defineProperty(Object.prototype, "_elm_ffi_create_", {
    get () {
        return this.value;
    },
    set ({ args: args, code: code }) {
        this.value = $be336afef88fa60f$var$AsyncFunction(...args, code);
    }
});
Object.defineProperty(Object.prototype, "_elm_ffi_apply_", {
    get () {
        return this.value;
    },
    set ({ holder: holder, params: params }) {
        try {
            const f = this;
            this.value = {
                "AW": $be336afef88fa60f$var$secret
            };
            $be336afef88fa60f$var$promiseSlot = ()=>holder["_elm_ffi_create_"](...params).then((val)=>f.value = {
                        "OK": val
                    }).catch((err)=>f.value = {
                        "ER": err
                    });
        } catch (err) {
            this.value = {
                "ER": err
            };
        }
    }
});
$be336afef88fa60f$var$global_.setTimeout = (callback, time, ...args)=>time === $be336afef88fa60f$var$secret ? $be336afef88fa60f$var$promiseSlot().finally(callback) : $be336afef88fa60f$var$setTimeout_(callback, time, ...args);


// needed for ie11
if (!Object.assign) Object.assign = function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (source.hasOwnProperty(key)) target[key] = source[key];
    }
    return target;
};
// safari
// from https://github.com/uxitten/polyfill
if (!String.prototype.padStart) String.prototype.padStart = function padStart(targetLength, padString) {
    targetLength = targetLength >> 0;
    padString = String(typeof padString !== 'undefined' ? padString : ' ');
    if (this.length > targetLength) return String(this);
    else {
        targetLength = targetLength - this.length;
        if (targetLength > padString.length) padString += padString.repeat(targetLength / padString.length);
        return padString.slice(0, targetLength) + String(this);
    }
};
/*
ES6 classes shim for custom elements

> See: https://github.com/webcomponents/custom-elements/blob/d8ecb29ad12abf79cc40ddfb4771d7673e59fce0/tests/html/shim.html
> and: https://github.com/webcomponents/custom-elements/blob/master/src/native-shim.js

EXAMPLE:

function MyTag() {
  return HTMLElement.apply(this);
}

MyTag.prototype = Object.create(HTMLElement.prototype);
MyTag.prototype.constructor = MyTag;

MyTag.prototype.connectedCallback = function() {
    // when added
}
MyTag.prototype.disconnectedCallback = function() {
    // when removed
}
MyTag.prototype.attributeChangedCallback = function() {
    // when attribute changed
}
MyTag.prototype.adoptedCallback = function() {
    // when added too?
}

*/ (function() {
    if (window.Reflect === undefined || window.customElements === undefined || window.customElements.polyfillWrapFlushCallback) return;
    var BuiltInHTMLElement = HTMLElement;
    var wrapperForTheName = {
        'HTMLElement': function HTMLElement1() {
            return Reflect.construct(BuiltInHTMLElement, [], this.constructor);
        }
    };
    window.HTMLElement = wrapperForTheName['HTMLElement'];
    HTMLElement.prototype = BuiltInHTMLElement.prototype;
    HTMLElement.prototype.constructor = HTMLElement;
    Object.setPrototypeOf(HTMLElement, BuiltInHTMLElement);
})();
//
window.toArray = function(e) {
    return Array.prototype.slice.call(e);
};
// LOGGING (HACK)
Object.defineProperty(Object.prototype, "_elm_ffi_log_str_", {
    get () {
        return this.value;
    },
    set (str) {
        console.log(str);
        this.value = str;
    }
});


var $53dd92cf139b6a84$exports = {};
// hi-tech versioning system
if (localStorage.getItem('version') != 'v01') {
    localStorage.clear();
    localStorage.setItem('version', 'v01');
}
function $53dd92cf139b6a84$var$defaults(name, def) {
    return {
        showAside: $53dd92cf139b6a84$var$get('showAside', '/settings'),
        browserArchive: $53dd92cf139b6a84$var$get('browserArchive', 'seeAll'),
        browserAccept: $53dd92cf139b6a84$var$get('browserAccept', 'seeAll')
    };
}
function $53dd92cf139b6a84$var$subscribe(app) {
    app.ports.setPreference.subscribe(function(value) {
        // sent as a tuple
        $53dd92cf139b6a84$var$set(value[0], value[1]);
    });
    app.ports.resetPreference.subscribe(function(value) {
        localStorage.clear();
    });
    app.ports.downloadAll.subscribe(function(className) {
        let elems = document.getElementsByClassName(className);
        for(let i = 0; i < elems.length; i++)elems[i].click();
    });
}
function $53dd92cf139b6a84$var$get(name, def) {
    return localStorage.getItem(name) || def;
}
function $53dd92cf139b6a84$var$set(name, value) {
    localStorage.setItem(name, value);
}
$53dd92cf139b6a84$exports = {
    defaults: $53dd92cf139b6a84$var$defaults,
    subscribe: $53dd92cf139b6a84$var$subscribe
};


var $cc2b0350e0cbd02a$exports = {};
!function(n) {
    "use strict";
    function r(n, r, t) {
        return t.a = n, t.f = r, t;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(t) {
                return n(r, t);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(t) {
                return function(e) {
                    return n(r, t, e);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return n(r, t, e, u);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return n(r, t, e, u, a);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return r(6, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return n(r, t, e, u, a, i);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(n) {
        return r(7, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return n(r, t, e, u, a, i, o);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F8(n) {
        return r(8, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return n(r, t, e, u, a, i, o, c);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F9(n) {
        return r(9, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return n(r, t, e, u, a, i, o, c, f);
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, t) {
        return 2 === n.a ? n.f(r, t) : n(r)(t);
    }
    function A3(n, r, t, e) {
        return 3 === n.a ? n.f(r, t, e) : n(r)(t)(e);
    }
    function A4(n, r, t, e, u) {
        return 4 === n.a ? n.f(r, t, e, u) : n(r)(t)(e)(u);
    }
    function A5(n, r, t, e, u, a) {
        return 5 === n.a ? n.f(r, t, e, u, a) : n(r)(t)(e)(u)(a);
    }
    function A6(n, r, t, e, u, a, i) {
        return 6 === n.a ? n.f(r, t, e, u, a, i) : n(r)(t)(e)(u)(a)(i);
    }
    function A7(n, r, t, e, u, a, i, o) {
        return 7 === n.a ? n.f(r, t, e, u, a, i, o) : n(r)(t)(e)(u)(a)(i)(o);
    }
    function A8(n, r, t, e, u, a, i, o, c) {
        return 8 === n.a ? n.f(r, t, e, u, a, i, o, c) : n(r)(t)(e)(u)(a)(i)(o)(c);
    }
    function A9(n, r, t, e, u, a, i, o, c, f) {
        return 9 === n.a ? n.f(r, t, e, u, a, i, o, c, f) : n(r)(t)(e)(u)(a)(i)(o)(c)(f);
    }
    var t = F3(function(n, r, t) {
        for(var e = Array(n), u = 0; n > u; u++)e[u] = t(r + u);
        return e;
    }), e = F2(function(n, r) {
        for(var t = Array(n), e = 0; n > e && r.b; e++)t[e] = r.a, r = r.b;
        return t.length = e, d(t, r);
    }), u = F2(function(n, r) {
        return r[n];
    });
    function a(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    function i(n, r) {
        for(var t, e = [], u = o(n, r, 0, e); u && (t = e.pop()); u = o(t.a, t.b, 0, e));
        return u;
    }
    function o(n, r, t, e) {
        if (t > 100) return e.push(d(n, r)), !0;
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && a(5), !1;
        for(var u in 0 > n.$ && (n = pt(n), r = pt(r)), n)if (!o(n[u], r[u], t + 1, e)) return !1;
        return !0;
    }
    var c = F2(i), f = F2(function(n, r) {
        return !i(n, r);
    });
    function s(n, r, t) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (t = s(n.a, r.a)) || (t = s(n.b, r.b)) ? t : s(n.c, r.c);
        for(; n.b && r.b && !(t = s(n.a, r.a)); n = n.b, r = r.b);
        return t || (n.b ? 1 : r.b ? -1 : 0);
    }
    var l = F2(function(n, r) {
        var t = s(n, r);
        return 0 > t ? ht : t ? gt : $t;
    });
    function d(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function b(n, r, t) {
        return {
            a: n,
            b: r,
            c: t
        };
    }
    function m(n) {
        return n;
    }
    function p(n, r) {
        var t = {};
        for(var e in n)t[e] = n[e];
        for(var e in r)t[e] = r[e];
        return t;
    }
    var v = F2($);
    function $(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var t = h(n.a, r);
        n = n.b;
        for(var e = t; n.b; n = n.b)e = e.b = h(n.a, r);
        return t;
    }
    var g = {
        $: 0
    };
    function h(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var k = F2(h);
    function C(n) {
        for(var r = g, t = n.length; t--;)r = h(n[t], r);
        return r;
    }
    function j(n) {
        for(var r = []; n.b; n = n.b)r.push(n.a);
        return r;
    }
    var w = F3(function(n, r, t) {
        for(var e = []; r.b && t.b; r = r.b, t = t.b)e.push(A2(n, r.a, t.a));
        return C(e);
    }), A = F2(function(n, r) {
        return C(j(r).sort(function(r, t) {
            return s(n(r), n(t));
        }));
    }), L = F2(function(n, r) {
        return C(j(r).sort(function(r, t) {
            var e = A2(n, r, t);
            return e === $t ? 0 : e === ht ? -1 : 1;
        }));
    }), y = F2(function(n, r) {
        return n + r;
    }), S = F2(function(n, r) {
        return n - r;
    }), F = F2(function(n, r) {
        return n * r;
    }), T = F2(function(n, r) {
        var t = r % n;
        return 0 === n ? a(11) : t > 0 && 0 > n || 0 > t && n > 0 ? t + n : t;
    }), Q = Math.ceil, I = Math.floor, B = Math.round, W = Math.log, P = isNaN, M = F2(function(n, r) {
        return n + r;
    }), q = F2(function(n, r) {
        return n + r;
    }), D = F3(function(n, r, t) {
        for(var e = t.length, u = 0; e > u;){
            var a = t[u], i = t.charCodeAt(u);
            u++, 55296 > i || i > 56319 || (a += t[u], u++), r = A2(n, m(a), r);
        }
        return r;
    }), X = F2(function(n, r) {
        return r.split(n);
    }), E = F2(function(n, r) {
        return r.join(n);
    }), R = F3(function(n, r, t) {
        return t.slice(n, r);
    }), x = F2(function(n, r) {
        for(var t = r.length; t--;){
            var e = r[t], u = r.charCodeAt(t);
            if (56320 > u || u > 57343 || (e = r[--t] + e), !n(m(e))) return !1;
        }
        return !0;
    }), O = F2(function(n, r) {
        return r.indexOf(n) > -1;
    }), z = F2(function(n, r) {
        return 0 === r.indexOf(n);
    }), N = F2(function(n, r) {
        return r.length >= n.length && r.lastIndexOf(n) === r.length - n.length;
    }), H = F2(function(n, r) {
        var t = n.length;
        if (1 > t) return g;
        for(var e = 0, u = []; (e = r.indexOf(n, e)) > -1;)u.push(e), e += t;
        return C(u);
    });
    function V(n) {
        return n + "";
    }
    function U(n) {
        return {
            $: 2,
            b: n
        };
    }
    var J = U(function(n) {
        return "number" != typeof n ? pn("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? yt(n) : !isFinite(n) || n % 1 ? pn("an INT", n) : yt(n);
    }), Z = U(function(n) {
        return "boolean" == typeof n ? yt(n) : pn("a BOOL", n);
    }), K = U(function(n) {
        return "number" == typeof n ? yt(n) : pn("a FLOAT", n);
    }), _ = U(function(n) {
        return yt(n);
    }), G = U(function(n) {
        return "string" == typeof n ? yt(n) : n instanceof String ? yt(n + "") : pn("a STRING", n);
    }), Y = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    }), nn = F2(function(n, r) {
        return {
            $: 7,
            e: n,
            b: r
        };
    });
    function rn(n, r) {
        return {
            $: 9,
            f: n,
            g: r
        };
    }
    var tn = F2(function(n, r) {
        return {
            $: 10,
            b: r,
            h: n
        };
    }), en = F2(function(n, r) {
        return rn(n, [
            r
        ]);
    }), un = F3(function(n, r, t) {
        return rn(n, [
            r,
            t
        ]);
    }), an = F4(function(n, r, t, e) {
        return rn(n, [
            r,
            t,
            e
        ]);
    }), on = F5(function(n, r, t, e, u) {
        return rn(n, [
            r,
            t,
            e,
            u
        ]);
    }), cn = F9(function(n, r, t, e, u, a, i, o, c) {
        return rn(n, [
            r,
            t,
            e,
            u,
            a,
            i,
            o,
            c
        ]);
    }), fn = F2(function(n, r) {
        try {
            return ln(n, JSON.parse(r));
        } catch (n) {
            return jt(A2(wt, "This is not valid JSON! " + n.message, r));
        }
    }), sn = F2(function(n, r) {
        return ln(n, r);
    });
    function ln(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? yt(n.c) : pn("null", r);
            case 3:
                return bn(r) ? dn(n.b, r, C) : pn("a LIST", r);
            case 4:
                return bn(r) ? dn(n.b, r, mn) : pn("an ARRAY", r);
            case 6:
                var t = n.d;
                if ("object" != typeof r || null === r || !(t in r)) return pn("an OBJECT with a field named `" + t + "`", r);
                var e = ln(n.b, r[t]);
                return je(e) ? e : jt(A2(At, t, e.a));
            case 7:
                var u = n.e;
                return bn(r) ? r.length > u ? (e = ln(n.b, r[u]), je(e) ? e : jt(A2(Lt, u, e.a))) : pn("a LONGER array. Need index " + u + " but only see " + r.length + " entries", r) : pn("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || bn(r)) return pn("an OBJECT", r);
                var a = g;
                for(var i in r)if (r.hasOwnProperty(i)) {
                    if (e = ln(n.b, r[i]), !je(e)) return jt(A2(At, i, e.a));
                    a = h(d(i, e.a), a);
                }
                return yt(Jt(a));
            case 9:
                for(var o = n.f, c = n.g, f = 0; c.length > f; f++){
                    if (e = ln(c[f], r), !je(e)) return e;
                    o = o(e.a);
                }
                return yt(o);
            case 10:
                return e = ln(n.b, r), je(e) ? ln(n.h(e.a), r) : e;
            case 11:
                for(var s = g, l = n.g; l.b; l = l.b){
                    if (e = ln(l.a, r), je(e)) return e;
                    s = h(e.a, s);
                }
                return jt(St(Jt(s)));
            case 1:
                return jt(A2(wt, n.a, r));
            case 0:
                return yt(n.a);
        }
    }
    function dn(n, r, t) {
        for(var e = r.length, u = Array(e), a = 0; e > a; a++){
            var i = ln(n, r[a]);
            if (!je(i)) return jt(A2(Lt, a, i.a));
            u[a] = i.a;
        }
        return yt(t(u));
    }
    function bn(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function mn(n) {
        return A2(Ce, n.length, function(r) {
            return n[r];
        });
    }
    function pn(n, r) {
        return jt(A2(wt, "Expecting " + n, r));
    }
    function vn(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return vn(n.b, r.b);
            case 6:
                return n.d === r.d && vn(n.b, r.b);
            case 7:
                return n.e === r.e && vn(n.b, r.b);
            case 9:
                return n.f === r.f && $n(n.g, r.g);
            case 10:
                return n.h === r.h && vn(n.b, r.b);
            case 11:
                return $n(n.g, r.g);
        }
    }
    function $n(n, r) {
        var t = n.length;
        if (t !== r.length) return !1;
        for(var e = 0; t > e; e++)if (!vn(n[e], r[e])) return !1;
        return !0;
    }
    var gn = F2(function(n, r) {
        return JSON.stringify(r, null, n) + "";
    });
    function hn(n) {
        return n;
    }
    function kn(n) {
        return n;
    }
    var Cn = F3(function(n, r, t) {
        return t[n] = r, t;
    });
    function jn(n) {
        return {
            $: 0,
            a: n
        };
    }
    function wn(n) {
        return {
            $: 1,
            a: n
        };
    }
    function An(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var Ln = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), yn = F2(function(n, r) {
        return {
            $: 4,
            b: n,
            d: r
        };
    }), Sn = 0;
    function Fn(n) {
        var r = {
            $: 0,
            e: Sn++,
            f: n,
            g: null,
            h: []
        };
        return Pn(r), r;
    }
    function Tn(n) {
        return An(function(r) {
            r(jn(Fn(n)));
        });
    }
    function Qn(n, r) {
        n.h.push(r), Pn(n);
    }
    var In = F2(function(n, r) {
        return An(function(t) {
            Qn(n, r), t(jn(0));
        });
    }), Bn = !1, Wn = [];
    function Pn(n) {
        if (Wn.push(n), !Bn) {
            for(Bn = !0; n = Wn.shift();)Mn(n);
            Bn = !1;
        }
    }
    function Mn(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, Pn(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    function qn(n) {
        return An(function(r) {
            var t = setTimeout(function() {
                r(jn(0));
            }, n);
            return function() {
                clearTimeout(t);
            };
        });
    }
    var Dn = {};
    function Xn(n, r, t, e, u) {
        return {
            b: n,
            c: r,
            d: t,
            e: e,
            f: u
        };
    }
    function En(n, r) {
        var t = {
            g: r,
            h: void 0
        }, e = n.c, u = n.d, a = n.e, i = n.f;
        function o(n) {
            return A2(Ln, o, {
                $: 5,
                b: function(r) {
                    var o = r.a;
                    return 0 === r.$ ? A3(u, t, o, n) : a && i ? A4(e, t, o.i, o.j, n) : A3(e, t, a ? o.i : o.j, n);
                }
            });
        }
        return t.h = Fn(A2(Ln, o, n.b));
    }
    var Rn = F2(function(n, r) {
        return An(function(t) {
            n.g(r), t(jn(0));
        });
    }), xn = F2(function(n, r) {
        return A2(In, n.h, {
            $: 0,
            a: r
        });
    });
    function On(n) {
        return function(r) {
            return {
                $: 1,
                k: n,
                l: r
            };
        };
    }
    function zn(n) {
        return {
            $: 2,
            m: n
        };
    }
    var Nn = F2(function(n, r) {
        return {
            $: 3,
            n: n,
            o: r
        };
    });
    function Hn(n, r, t) {
        var e = {};
        for(var u in Vn(!0, r, e, null), Vn(!1, t, e, null), n)Qn(n[u], {
            $: "fx",
            a: e[u] || {
                i: g,
                j: g
            }
        });
    }
    function Vn(n, r, t, e) {
        switch(r.$){
            case 1:
                var u = r.k, a = function(n, r, t, e) {
                    function u(n) {
                        for(var r = t; r; r = r.q)n = r.p(n);
                        return n;
                    }
                    return A2(n ? Dn[r].e : Dn[r].f, u, e);
                }(n, u, e, r.l);
                return void (t[u] = function(n, r, t) {
                    return t = t || {
                        i: g,
                        j: g
                    }, n ? t.i = h(r, t.i) : t.j = h(r, t.j), t;
                }(n, a, t[u]));
            case 2:
                for(var i = r.m; i.b; i = i.b)Vn(n, i.a, t, e);
                return;
            case 3:
                return void Vn(n, r.o, t, {
                    p: r.n,
                    q: e
                });
        }
    }
    function Un(n) {
        Dn[n] && a(3);
    }
    function Jn(n, r) {
        return Un(n), Dn[n] = {
            e: Zn,
            r: r,
            a: Kn
        }, On(n);
    }
    var Zn = F2(function(n, r) {
        return r;
    });
    function Kn(n) {
        var r = [], t = Dn[n].r, e = qn(0);
        return Dn[n].b = e, Dn[n].c = F3(function(n, u) {
            for(; u.b; u = u.b)for(var a = r, i = kn(t(u.a)), o = 0; a.length > o; o++)a[o](i);
            return e;
        }), {
            subscribe: function(n) {
                r.push(n);
            },
            unsubscribe: function(n) {
                var t = (r = r.slice()).indexOf(n);
                0 > t || r.splice(t, 1);
            }
        };
    }
    function _n(n, r) {
        return Un(n), Dn[n] = {
            f: Gn,
            r: r,
            a: Yn
        }, On(n);
    }
    var Gn = F2(function(n, r) {
        return function(t) {
            return n(r(t));
        };
    });
    function Yn(n, r) {
        var t = g, e = Dn[n].r, u = jn(null);
        return Dn[n].b = u, Dn[n].c = F3(function(n, r) {
            return t = r, u;
        }), {
            send: function(n) {
                var u = A2(sn, e, n);
                je(u) || a(4);
                for(var i = u.a, o = t; o.b; o = o.b)r(o.a(i));
            }
        };
    }
    var nr = "undefined" != typeof document ? document : {};
    function rr(n, r) {
        n.appendChild(r);
    }
    function tr(n) {
        return {
            $: 0,
            a: n
        };
    }
    var er = F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var i = e.a;
                a += i.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 1,
                c: r,
                d: jr(t),
                e: u,
                f: n,
                b: a
            };
        });
    }), ur = er(void 0), ar = F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var i = e.a;
                a += i.b.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 2,
                c: r,
                d: jr(t),
                e: u,
                f: n,
                b: a
            };
        });
    }), ir = ar(void 0), or = F2(function(n, r) {
        return {
            $: 4,
            j: n,
            k: r,
            b: 1 + (r.b || 0)
        };
    });
    function cr(n, r) {
        return {
            $: 5,
            l: n,
            m: r,
            k: void 0
        };
    }
    var fr = F3(function(n, r, t) {
        return cr([
            n,
            r,
            t
        ], function() {
            return A2(n, r, t);
        });
    }), sr = F4(function(n, r, t, e) {
        return cr([
            n,
            r,
            t,
            e
        ], function() {
            return A3(n, r, t, e);
        });
    }), lr = F5(function(n, r, t, e, u) {
        return cr([
            n,
            r,
            t,
            e,
            u
        ], function() {
            return A4(n, r, t, e, u);
        });
    }), dr = F2(function(n, r) {
        return {
            $: "a0",
            n: n,
            o: r
        };
    }), br = F2(function(n, r) {
        return {
            $: "a1",
            n: n,
            o: r
        };
    }), mr = F2(function(n, r) {
        return {
            $: "a2",
            n: n,
            o: r
        };
    }), pr = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    });
    function vr(n) {
        return "script" == n ? "p" : n;
    }
    function $r(n) {
        return /^\s*(javascript:|data:text\/html)/i.test(n) ? "" : n;
    }
    var gr, hr = F2(function(n, r) {
        return "a0" === r.$ ? A2(dr, r.n, function(n, r) {
            var t = Ie(r);
            return {
                $: r.$,
                a: t ? A3(Te, 3 > t ? kr : Cr, Qe(n), r.a) : A2(Fe, n, r.a)
            };
        }(n, r.o)) : r;
    }), kr = F2(function(n, r) {
        return d(n(r.a), r.b);
    }), Cr = F2(function(n, r) {
        return {
            nE: n(r.nE),
            qX: r.qX,
            o1: r.o1
        };
    });
    function jr(n) {
        for(var r = {}; n.b; n = n.b){
            var t = n.a, e = t.$, u = t.n, a = t.o;
            if ("a2" !== e) {
                var i = r[e] || (r[e] = {});
                "a3" === e && "class" === u ? wr(i, u, a) : i[u] = a;
            } else "className" === u ? wr(r, u, kn(a)) : r[u] = kn(a);
        }
        return r;
    }
    function wr(n, r, t) {
        var e = n[r];
        n[r] = e ? e + " " + t : t;
    }
    function Ar(n, r) {
        var t = n.$;
        if (5 === t) return Ar(n.k || (n.k = n.m()), r);
        if (0 === t) return nr.createTextNode(n.a);
        if (4 === t) {
            for(var e = n.k, u = n.j; 4 === e.$;)"object" != typeof u ? u = [
                u,
                e.j
            ] : u.push(e.j), e = e.k;
            var a = {
                j: u,
                p: r
            };
            return (i = Ar(e, a)).elm_event_node_ref = a, i;
        }
        if (3 === t) return Lr(i = n.h(n.g), r, n.d), i;
        var i = n.f ? nr.createElementNS(n.f, n.c) : nr.createElement(n.c);
        Lr(i, r, n.d);
        for(var o = n.e, c = 0; o.length > c; c++)rr(i, Ar(1 === t ? o[c] : o[c].b, r));
        return i;
    }
    function Lr(n, r, t) {
        for(var e in t){
            var u = t[e];
            "a1" === e ? yr(n, u) : "a0" === e ? Tr(n, r, u) : "a3" === e ? Sr(n, u) : "a4" === e ? Fr(n, u) : ("value" !== e && "checked" !== e || n[e] !== u) && (n[e] = u);
        }
    }
    function yr(n, r) {
        var t = n.style;
        for(var e in r)t[e] = r[e];
    }
    function Sr(n, r) {
        for(var t in r){
            var e = r[t];
            void 0 !== e ? n.setAttribute(t, e) : n.removeAttribute(t);
        }
    }
    function Fr(n, r) {
        for(var t in r){
            var e = r[t], u = e.f, a = e.o;
            void 0 !== a ? n.setAttributeNS(u, t, a) : n.removeAttributeNS(u, t);
        }
    }
    function Tr(n, r, t) {
        var e = n.elmFs || (n.elmFs = {});
        for(var u in t){
            var a = t[u], i = e[u];
            if (a) {
                if (i) {
                    if (i.q.$ === a.$) {
                        i.q = a;
                        continue;
                    }
                    n.removeEventListener(u, i);
                }
                i = Qr(r, a), n.addEventListener(u, i, gr && {
                    passive: 2 > Ie(a)
                }), e[u] = i;
            } else n.removeEventListener(u, i), e[u] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                gr = !0;
            }
        }));
    } catch (n) {}
    function Qr(n, r) {
        function t(r) {
            var e = t.q, u = ln(e.a, r);
            if (je(u)) {
                for(var a, i = Ie(e), o = u.a, c = i ? 3 > i ? o.a : o.nE : o, f = 1 == i ? o.b : 3 == i && o.qX, s = (f && r.stopPropagation(), (2 == i ? o.b : 3 == i && o.o1) && r.preventDefault(), n); a = s.j;){
                    if ("function" == typeof a) c = a(c);
                    else for(var l = a.length; l--;)c = a[l](c);
                    s = s.p;
                }
                s(c, f);
            }
        }
        return t.q = r, t;
    }
    function Ir(n, r) {
        return n.$ == r.$ && vn(n.a, r.a);
    }
    function Br(n, r, t, e) {
        var u = {
            $: r,
            r: t,
            s: e,
            t: void 0,
            u: void 0
        };
        return n.push(u), u;
    }
    function Wr(n, r, t, e) {
        if (n !== r) {
            var u = n.$, a = r.$;
            if (u !== a) {
                if (1 !== u || 2 !== a) return void Br(t, 0, e, r);
                r = function(n) {
                    for(var r = n.e, t = r.length, e = Array(t), u = 0; t > u; u++)e[u] = r[u].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: e,
                        f: n.f,
                        b: n.b
                    };
                }(r), a = 1;
            }
            switch(a){
                case 5:
                    for(var i = n.l, o = r.l, c = i.length, f = c === o.length; f && c--;)f = i[c] === o[c];
                    if (f) return void (r.k = n.k);
                    r.k = r.m();
                    var s = [];
                    return Wr(n.k, r.k, s, 0), void (s.length > 0 && Br(t, 1, e, s));
                case 4:
                    for(var l = n.j, d = r.j, b = !1, m = n.k; 4 === m.$;)b = !0, "object" != typeof l ? l = [
                        l,
                        m.j
                    ] : l.push(m.j), m = m.k;
                    for(var p = r.k; 4 === p.$;)b = !0, "object" != typeof d ? d = [
                        d,
                        p.j
                    ] : d.push(p.j), p = p.k;
                    return b && l.length !== d.length ? void Br(t, 0, e, r) : ((b ? function(n, r) {
                        for(var t = 0; n.length > t; t++)if (n[t] !== r[t]) return !1;
                        return !0;
                    }(l, d) : l === d) || Br(t, 2, e, d), void Wr(m, p, t, e + 1));
                case 0:
                    return void (n.a !== r.a && Br(t, 3, e, r.a));
                case 1:
                    return void Pr(n, r, t, e, qr);
                case 2:
                    return void Pr(n, r, t, e, Dr);
                case 3:
                    if (n.h !== r.h) return void Br(t, 0, e, r);
                    var v = Mr(n.d, r.d);
                    v && Br(t, 4, e, v);
                    var $ = r.i(n.g, r.g);
                    return void ($ && Br(t, 5, e, $));
            }
        }
    }
    function Pr(n, r, t, e, u) {
        if (n.c === r.c && n.f === r.f) {
            var a = Mr(n.d, r.d);
            a && Br(t, 4, e, a), u(n, r, t, e);
        } else Br(t, 0, e, r);
    }
    function Mr(n, r, t) {
        var e;
        for(var u in n)if ("a1" !== u && "a0" !== u && "a3" !== u && "a4" !== u) {
            if (u in r) {
                var a = n[u], i = r[u];
                a === i && "value" !== u && "checked" !== u || "a0" === t && Ir(a, i) || ((e = e || {})[u] = i);
            } else (e = e || {})[u] = t ? "a1" === t ? "" : "a0" === t || "a3" === t ? void 0 : {
                f: n[u].f,
                o: void 0
            } : "string" == typeof n[u] ? "" : null;
        } else {
            var o = Mr(n[u], r[u] || {}, u);
            o && ((e = e || {})[u] = o);
        }
        for(var c in r)c in n || ((e = e || {})[c] = r[c]);
        return e;
    }
    function qr(n, r, t, e) {
        var u = n.e, a = r.e, i = u.length, o = a.length;
        i > o ? Br(t, 6, e, {
            v: o,
            i: i - o
        }) : o > i && Br(t, 7, e, {
            v: i,
            e: a
        });
        for(var c = o > i ? i : o, f = 0; c > f; f++){
            var s = u[f];
            Wr(s, a[f], t, ++e), e += s.b || 0;
        }
    }
    function Dr(n, r, t, e) {
        for(var u = [], a = {}, i = [], o = n.e, c = r.e, f = o.length, s = c.length, l = 0, d = 0, b = e; f > l && s > d;){
            var m = (y = o[l]).a, p = (S = c[d]).a, v = y.b, $ = S.b, g = void 0, h = void 0;
            if (m !== p) {
                var k = o[l + 1], C = c[d + 1];
                if (k) {
                    var j = k.a, w = k.b;
                    h = p === j;
                }
                if (C) {
                    var A = C.a, L = C.b;
                    g = m === A;
                }
                if (g && h) Wr(v, L, u, ++b), Er(a, u, m, $, d, i), b += v.b || 0, Rr(a, u, m, w, ++b), b += w.b || 0, l += 2, d += 2;
                else if (g) b++, Er(a, u, p, $, d, i), Wr(v, L, u, b), b += v.b || 0, l += 1, d += 2;
                else if (h) Rr(a, u, m, v, ++b), b += v.b || 0, Wr(w, $, u, ++b), b += w.b || 0, l += 2, d += 1;
                else {
                    if (!k || j !== A) break;
                    Rr(a, u, m, v, ++b), Er(a, u, p, $, d, i), b += v.b || 0, Wr(w, L, u, ++b), b += w.b || 0, l += 2, d += 2;
                }
            } else Wr(v, $, u, ++b), b += v.b || 0, l++, d++;
        }
        for(; f > l;){
            var y;
            b++, Rr(a, u, (y = o[l]).a, v = y.b, b), b += v.b || 0, l++;
        }
        for(; s > d;){
            var S, F = F || [];
            Er(a, u, (S = c[d]).a, S.b, void 0, F), d++;
        }
        (u.length > 0 || i.length > 0 || F) && Br(t, 8, e, {
            w: u,
            x: i,
            y: F
        });
    }
    var Xr = "_elmW6BL";
    function Er(n, r, t, e, u, a) {
        var i = n[t];
        if (!i) return a.push({
            r: u,
            A: i = {
                c: 0,
                z: e,
                r: u,
                s: void 0
            }
        }), void (n[t] = i);
        if (1 === i.c) {
            a.push({
                r: u,
                A: i
            }), i.c = 2;
            var o = [];
            return Wr(i.z, e, o, i.r), i.r = u, void (i.s.s = {
                w: o,
                A: i
            });
        }
        Er(n, r, t + Xr, e, u, a);
    }
    function Rr(n, r, t, e, u) {
        var a = n[t];
        if (a) {
            if (0 === a.c) {
                a.c = 2;
                var i = [];
                return Wr(e, a.z, i, u), void Br(r, 9, u, {
                    w: i,
                    A: a
                });
            }
            Rr(n, r, t + Xr, e, u);
        } else {
            var o = Br(r, 9, u, void 0);
            n[t] = {
                c: 1,
                z: e,
                r: u,
                s: o
            };
        }
    }
    function xr(n, r, t, e) {
        Or(n, r, t, 0, 0, r.b, e);
    }
    function Or(n, r, t, e, u, a, i) {
        for(var o = t[e], c = o.r; c === u;){
            var f = o.$;
            if (1 === f) xr(n, r.k, o.s, i);
            else if (8 === f) o.t = n, o.u = i, (s = o.s.w).length > 0 && Or(n, r, s, 0, u, a, i);
            else if (9 === f) {
                o.t = n, o.u = i;
                var s, l = o.s;
                l && (l.A.s = n, (s = l.w).length > 0 && Or(n, r, s, 0, u, a, i));
            } else o.t = n, o.u = i;
            if (!(o = t[++e]) || (c = o.r) > a) return e;
        }
        var d = r.$;
        if (4 === d) {
            for(var b = r.k; 4 === b.$;)b = b.k;
            return Or(n, b, t, e, u + 1, a, n.elm_event_node_ref);
        }
        for(var m = r.e, p = n.childNodes, v = 0; m.length > v; v++){
            u++;
            var $ = 1 === d ? m[v] : m[v].b, g = u + ($.b || 0);
            if (!(u > c || c > g || (o = t[e = Or(p[v], $, t, e, u, g, i)]) && (c = o.r) <= a)) return e;
            u = g;
        }
        return e;
    }
    function zr(n, r) {
        for(var t = 0; r.length > t; t++){
            var e = r[t], u = e.t, a = Nr(u, e);
            u === n && (n = a);
        }
        return n;
    }
    function Nr(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, t) {
                    var e = n.parentNode, u = Ar(r, t);
                    return u.elm_event_node_ref || (u.elm_event_node_ref = n.elm_event_node_ref), e && u !== n && e.replaceChild(u, n), u;
                }(n, r.s, r.u);
            case 4:
                return Lr(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return zr(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var t = r.s, e = 0; t.i > e; e++)n.removeChild(n.childNodes[t.v]);
                return n;
            case 7:
                for(var u = (t = r.s).e, i = n.childNodes[e = t.v]; u.length > e; e++)n.insertBefore(Ar(u[e], r.u), i);
                return n;
            case 9:
                if (!(t = r.s)) return n.parentNode.removeChild(n), n;
                var o = t.A;
                return void 0 !== o.r && n.parentNode.removeChild(n), o.s = zr(n, t.w), n;
            case 8:
                return function(n, r) {
                    var t = r.s, e = function(n, r) {
                        if (n) {
                            for(var t = nr.createDocumentFragment(), e = 0; n.length > e; e++){
                                var u = n[e].A;
                                rr(t, 2 === u.c ? u.s : Ar(u.z, r.u));
                            }
                            return t;
                        }
                    }(t.y, r);
                    n = zr(n, t.w);
                    for(var u = t.x, a = 0; u.length > a; a++){
                        var i = u[a], o = i.A, c = 2 === o.c ? o.s : Ar(o.z, r.u);
                        n.insertBefore(c, n.childNodes[i.r]);
                    }
                    return e && rr(n, e), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                a(10);
        }
    }
    function Hr(n) {
        if (3 === n.nodeType) return tr(n.textContent);
        if (1 !== n.nodeType) return tr("");
        for(var r = g, t = n.attributes, e = t.length; e--;){
            var u = t[e];
            r = h(A2(pr, u.name, u.value), r);
        }
        var a = n.tagName.toLowerCase(), i = g, o = n.childNodes;
        for(e = o.length; e--;)i = h(Hr(o[e]), i);
        return A3(ur, a, r, i);
    }
    var Vr = F4(function(n, r, t, e) {
        return function(n, r, t, e, u, i) {
            var o = A2(sn, n, r ? r.flags : void 0);
            je(o) || a(2);
            var c = {}, f = (o = t(o.a)).a, s = i(d, f), l = function(n, r) {
                var t;
                for(var e in Dn){
                    var u = Dn[e];
                    u.a && ((t = t || {})[e] = u.a(e, r)), n[e] = En(u, r);
                }
                return t;
            }(c, d);
            function d(n, r) {
                s(f = (o = A2(e, n, f)).a, r), Hn(c, o.b, u(f));
            }
            return Hn(c, o.b, u(f)), l ? {
                ports: l
            } : {};
        }(r, e, n.m, n.r, n.q1, function(r, t) {
            var u = n.s, a = e.node, i = Hr(a);
            return function(n, r) {
                r(n);
                var t = 0;
                function e() {
                    t = 1 === t ? 0 : (Ur(e), r(n), 1);
                }
                return function(u, a) {
                    n = u, a ? (r(n), 2 === t && (t = 1)) : (0 === t && Ur(e), t = 2);
                };
            }(t, function(n) {
                var t = u(n), e = function(n, r) {
                    var t = [];
                    return Wr(n, r, t, 0), t;
                }(i, t);
                a = function(n, r, t, e) {
                    return 0 === t.length ? n : (xr(n, r, t, e), zr(n, t));
                }(a, i, e, r), i = t;
            });
        });
    }), Ur = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    });
    var Jr = {
        addEventListener: function() {},
        removeEventListener: function() {}
    }, Zr = "undefined" != typeof document ? document : Jr, Kr = "undefined" != typeof window ? window : Jr, _r = F3(function(n, r, t) {
        return Tn(An(function() {
            function e(n) {
                Fn(t(n));
            }
            return n.addEventListener(r, e, gr && {
                passive: !0
            }), function() {
                n.removeEventListener(r, e);
            };
        }));
    }), Gr = F2(function(n, r) {
        var t = ln(n, r);
        return je(t) ? kt(t.a) : Ct;
    });
    var Yr = F2(function(n, r) {
        return function(n, r) {
            return An(function(t) {
                Ur(function() {
                    var e = document.getElementById(n);
                    t(e ? jn(r(e)) : wn(We(n)));
                });
            });
        }(r, function(r) {
            return r[n](), 0;
        });
    }), nt = F3(function(n, r, t) {
        return An(function(e) {
            function u(n) {
                e(r(t.cX.a(n)));
            }
            var a = new XMLHttpRequest;
            a.addEventListener("error", function() {
                u(ho);
            }), a.addEventListener("timeout", function() {
                u(jo);
            }), a.addEventListener("load", function() {
                u(function(n, r) {
                    return A2(r.status >= 200 && 300 > r.status ? go : vo, function(n) {
                        return {
                            r6: n.responseURL,
                            bq: n.status,
                            qV: n.statusText,
                            l0: rt(n.getAllResponseHeaders())
                        };
                    }(r), n(r.response));
                }(t.cX.b, a));
            }), wo(t.h2) && function(n, r, t) {
                r.upload.addEventListener("progress", function(e) {
                    r.c || Fn(A2(Ao, n, d(t, Co({
                        qg: e.loaded,
                        qy: e.total
                    }))));
                }), r.addEventListener("progress", function(e) {
                    r.c || Fn(A2(Ao, n, d(t, ko({
                        pk: e.loaded,
                        qy: e.lengthComputable ? kt(e.total) : Ct
                    }))));
                });
            }(n, a, t.h2.a);
            try {
                a.open(t.aR, t.r6, !0);
            } catch (n) {
                return u($o(t.r6));
            }
            return function(n, r) {
                for(var t = r.l0; t.b; t = t.b)n.setRequestHeader(t.a.a, t.a.b);
                n.timeout = r.dO.a || 0, n.responseType = r.cX.d, n.withCredentials = r.iH;
            }(a, t), t.eq.a && a.setRequestHeader("Content-Type", t.eq.a), a.send(t.eq.b), function() {
                a.c = !0, a.abort();
            };
        });
    });
    function rt(n) {
        if (!n) return Lu;
        for(var r = Lu, t = n.split("\r\n"), e = t.length; e--;){
            var u = t[e], a = u.indexOf(": ");
            if (a > 0) {
                var i = u.substring(0, a), o = u.substring(a + 2);
                r = A3(Wo, i, function(n) {
                    return kt(wo(n) ? o + ", " + n.a : o);
                }, r);
            }
        }
        return r;
    }
    var tt = F3(function(n, r, t) {
        return {
            $: 0,
            d: n,
            b: r,
            a: t
        };
    }), et = F2(function(n, r) {
        return {
            $: 0,
            d: r.d,
            b: r.b,
            a: function(t) {
                return n(r.a(t));
            }
        };
    }), ut = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), at = F5(function(n, r, t, e, u) {
        for(var a = n.length, i = u.length >= r + a, o = 0; i && a > o;){
            var c = u.charCodeAt(r);
            i = n[o++] === u[r++] && (10 === c ? (t++, e = 1) : (e++, 55296 == (63488 & c) ? n[o++] === u[r++] : 1));
        }
        return b(i ? r : -1, t, e);
    }), it = F3(function(n, r, t) {
        return t.length > r ? 55296 == (63488 & t.charCodeAt(r)) ? n(t.substr(r, 2)) ? r + 2 : -1 : n(t[r]) ? "\n" === t[r] ? -2 : r + 1 : -1 : -1;
    }), ot = F2(function(n, r) {
        return An(function() {
            var t = setInterval(function() {
                Fn(r);
            }, n);
            return function() {
                clearInterval(t);
            };
        });
    }), ct = F2(function(n, r) {
        var t = "g";
        n.nU && (t += "m"), n.jD && (t += "i");
        try {
            return kt(RegExp(r, t));
        } catch (n) {
            return Ct;
        }
    }), ft = F2(function(n, r) {
        return null !== r.match(n);
    }), st = F3(function(n, r, t) {
        for(var e, u = [], a = 0, i = t, o = r.lastIndex, c = -1; a++ < n && (e = r.exec(i)) && c != r.lastIndex;){
            for(var f = e.length - 1, s = Array(f); f > 0;){
                var l = e[f];
                s[--f] = l ? kt(l) : Ct;
            }
            u.push(A4(ek, e[0], e.index, a, C(s))), c = r.lastIndex;
        }
        return r.lastIndex = o, C(u);
    }), lt = F4(function(n, r, t, e) {
        var u = 0;
        return e.replace(r, function(r) {
            if (u++ >= n) return r;
            for(var e = arguments.length - 3, a = Array(e); e > 0;){
                var i = arguments[e];
                a[--e] = i ? kt(i) : Ct;
            }
            return t(A4(ek, r, arguments[arguments.length - 2], u, C(a)));
        });
    }), dt = 1 / 0, bt = k, mt = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.d, u = n, a = A3(n, t.b, t.c, A3(mt, n, r, t.e));
            n = u, r = a, t = e;
        }
    }), pt = function(n) {
        return A3(mt, F3(function(n, r, t) {
            return A2(bt, d(n, r), t);
        }), g, n);
    }, vt = function(n) {
        return A3(mt, F3(function(n, r, t) {
            return A2(bt, n, t);
        }), g, n);
    }, $t = 1, gt = 2, ht = 0, kt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ct = {
        $: 1
    }, jt = function(n) {
        return {
            $: 1,
            a: n
        };
    }, wt = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), At = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Lt = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), yt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, St = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Ft = y, Tt = x, Qt = v, It = gn, Bt = V, Wt = F2(function(n, r) {
        return A2(E, n, j(r));
    }), Pt = F2(function(n, r) {
        return C(A2(X, n, r));
    }), Mt = function(n) {
        return A2(Wt, "\n    ", A2(Pt, "\n", n));
    }, qt = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r;
            var e = t.b, u = n, a = A2(n, t.a, r);
            n = u, r = a, t = e;
        }
    }), Dt = function(n) {
        return A3(qt, F2(function(n, r) {
            return r + 1;
        }), 0, n);
    }, Xt = w, Et = S, Rt = F3(function(n, r, t) {
        for(;;){
            if (s(n, r) >= 1) return t;
            var e = n, u = r - 1, a = A2(bt, r, t);
            n = e, r = u, t = a;
        }
    }), xt = F2(function(n, r) {
        return A3(Rt, n, r, g);
    }), Ot = F2(function(n, r) {
        return A3(Xt, n, A2(xt, 0, Dt(r) - 1), r);
    }), zt = function(n) {
        var r = n.charCodeAt(0);
        return 55296 > r || r > 56319 ? r : 1024 * (r - 55296) + n.charCodeAt(1) - 56320 + 65536;
    }, Nt = function(n) {
        var r = zt(n);
        return r >= 97 && 122 >= r;
    }, Ht = function(n) {
        var r = zt(n);
        return 90 >= r && r >= 65;
    }, Vt = function(n) {
        var r = zt(n);
        return 57 >= r && r >= 48;
    }, Ut = function(n) {
        return Nt(n) || Ht(n) || Vt(n);
    }, Jt = function(n) {
        return A3(qt, bt, g, n);
    }, Zt = F2(function(n, r) {
        return "\n\n(" + Bt(n + 1) + ") " + Mt(Kt(r));
    }), Kt = function(n) {
        return A2(_t, n, g);
    }, _t = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                var t = n.a, e = n.b, u = function() {
                    var n, r, e = (r = (n = t).charCodeAt(0)) ? kt(55296 > r || r > 56319 ? d(n[0], n.slice(1)) : d(n[0] + n[1], n.slice(2))) : Ct;
                    if (1 === e.$) return !1;
                    var u, a = e.a, i = a.b;
                    return (Nt(u = a.a) || Ht(u)) && A2(Tt, Ut, i);
                }();
                n = e, r = A2(bt, u ? "." + t : "['" + t + "']", r);
                continue n;
            case 1:
                e = n.b;
                var a = "[" + Bt(n.a) + "]";
                n = e, r = A2(bt, a, r);
                continue n;
            case 2:
                var i = n.a;
                if (i.b) {
                    if (i.b.b) {
                        var o = function() {
                            return r.b ? "The Json.Decode.oneOf at json" + A2(Wt, "", Jt(r)) : "Json.Decode.oneOf";
                        }() + " failed in the following " + Bt(Dt(i)) + " ways:";
                        return A2(Wt, "\n\n", A2(bt, o, A2(Ot, Zt, i)));
                    }
                    n = e = i.a;
                    continue n;
                }
                return "Ran into a Json.Decode.oneOf with no possibilities" + function() {
                    return r.b ? " at json" + A2(Wt, "", Jt(r)) : "!";
                }();
            default:
                var c = n.a, f = n.b;
                return (o = function() {
                    return r.b ? "Problem with the value at json" + A2(Wt, "", Jt(r)) + ":\n\n    " : "Problem with the given value:\n\n";
                }()) + (Mt(A2(It, 4, f)) + "\n\n") + c;
        }
    }), Gt = 32, Yt = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), ne = [], re = Q, te = F2(function(n, r) {
        return W(r) / W(n);
    }), ee = re(A2(te, 2, Gt)), ue = A4(Yt, 0, ee, ne, ne), ae = t, ie = function(n) {
        return {
            $: 1,
            a: n
        };
    }, oe = F2(function(n, r) {
        return n(r);
    }), ce = F2(function(n, r) {
        return r(n);
    }), fe = c, se = I, le = function(n) {
        return n.length;
    }, de = F2(function(n, r) {
        return s(n, r) > 0 ? n : r;
    }), be = F, me = function(n) {
        return {
            $: 0,
            a: n
        };
    }, pe = e, ve = F2(function(n, r) {
        for(;;){
            var t = A2(pe, Gt, n), e = t.b, u = A2(bt, me(t.a), r);
            if (!e.b) return Jt(u);
            n = e, r = u;
        }
    }), $e = function(n) {
        return n.a;
    }, ge = F2(function(n, r) {
        for(;;){
            var t = re(r / Gt);
            if (1 === t) return A2(pe, Gt, n).a;
            n = A2(ve, n, g), r = t;
        }
    }), he = F2(function(n, r) {
        if (r.n) {
            var t = r.n * Gt, e = se(A2(te, Gt, t - 1)), u = n ? Jt(r.u) : r.u, a = A2(ge, u, r.n);
            return A4(Yt, le(r.t) + t, A2(de, 5, e * ee), a, r.t);
        }
        return A4(Yt, le(r.t), ee, ne, r.t);
    }), ke = F5(function(n, r, t, e, u) {
        for(;;){
            if (0 > r) return A2(he, !1, {
                u: e,
                n: t / Gt | 0,
                t: u
            });
            var a = ie(A3(ae, Gt, r, n));
            r -= Gt, e = A2(bt, a, e);
        }
    }), Ce = F2(function(n, r) {
        if (n > 0) {
            var t = n % Gt;
            return A5(ke, r, n - t - Gt, n, g, A3(ae, t, n - t, r));
        }
        return ue;
    }), je = function(n) {
        return !n.$;
    }, we = tn, Ae = Z, Le = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), ye = Le, Se = ye("div"), Fe = en, Te = un, Qe = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ie = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, Be = function(n) {
        return n;
    }, We = Be, Pe = F6(function(n, r, t, e, u, a) {
        return {
            fk: a,
            fy: r,
            gu: e,
            gB: t,
            gK: n,
            ph: u
        };
    }), Me = O, qe = function(n) {
        return n.length;
    }, De = R, Xe = F2(function(n, r) {
        return 1 > n ? r : A3(De, n, qe(r), r);
    }), Ee = H, Re = function(n) {
        return "" === n;
    }, xe = F2(function(n, r) {
        return 1 > n ? "" : A3(De, 0, n, r);
    }), Oe = function(n) {
        for(var r = 0, t = n.charCodeAt(0), e = 43 == t || 45 == t ? 1 : 0, u = e; n.length > u; ++u){
            var a = n.charCodeAt(u);
            if (48 > a || a > 57) return Ct;
            r = 10 * r + a - 48;
        }
        return u == e ? Ct : kt(45 == t ? -r : r);
    }, ze = F5(function(n, r, t, e, u) {
        if (Re(u) || A2(Me, "@", u)) return Ct;
        var a = A2(Ee, ":", u);
        if (a.b) {
            if (a.b.b) return Ct;
            var i = a.a, o = Oe(A2(Xe, i + 1, u));
            if (1 === o.$) return Ct;
            var c = o;
            return kt(A6(Pe, n, A2(xe, i, u), c, r, t, e));
        }
        return kt(A6(Pe, n, u, Ct, r, t, e));
    }), Ne = F4(function(n, r, t, e) {
        if (Re(e)) return Ct;
        var u = A2(Ee, "/", e);
        if (u.b) {
            var a = u.a;
            return A5(ze, n, A2(Xe, a, e), r, t, A2(xe, a, e));
        }
        return A5(ze, n, "/", r, t, e);
    }), He = F3(function(n, r, t) {
        if (Re(t)) return Ct;
        var e = A2(Ee, "?", t);
        if (e.b) {
            var u = e.a;
            return A4(Ne, n, kt(A2(Xe, u + 1, t)), r, A2(xe, u, t));
        }
        return A4(Ne, n, Ct, r, t);
    }), Ve = F2(function(n, r) {
        if (Re(r)) return Ct;
        var t = A2(Ee, "#", r);
        if (t.b) {
            var e = t.a;
            return A3(He, n, kt(A2(Xe, e + 1, r)), A2(xe, e, r));
        }
        return A3(He, n, Ct, r);
    }), Ue = z, Je = jn, Ze = Je(0), Ke = F4(function(n, r, t, e) {
        if (e.b) {
            var u = e.a, a = e.b;
            if (a.b) {
                var i = a.a, o = a.b;
                if (o.b) {
                    var c = o.a, f = o.b;
                    if (f.b) {
                        var s = f.b;
                        return A2(n, u, A2(n, i, A2(n, c, A2(n, f.a, t > 500 ? A3(qt, n, r, Jt(s)) : A4(Ke, n, r, t + 1, s)))));
                    }
                    return A2(n, u, A2(n, i, A2(n, c, r)));
                }
                return A2(n, u, A2(n, i, r));
            }
            return A2(n, u, r);
        }
        return r;
    }), _e = F3(function(n, r, t) {
        return A4(Ke, n, r, 0, t);
    }), Ge = F2(function(n, r) {
        return A3(_e, F2(function(r, t) {
            return A2(bt, n(r), t);
        }), g, r);
    }), Ye = Ln, nu = F2(function(n, r) {
        return A2(Ye, function(r) {
            return Je(n(r));
        }, r);
    }), ru = F3(function(n, r, t) {
        return A2(Ye, function(r) {
            return A2(Ye, function(t) {
                return Je(A2(n, r, t));
            }, t);
        }, r);
    }), tu = function(n) {
        return A3(_e, ru(bt), Je(g), n);
    }, eu = Rn, uu = F2(function(n, r) {
        var t = r;
        return Tn(A2(Ye, eu(n), t));
    }), au = F3(function(n, r) {
        return A2(nu, function() {
            return 0;
        }, tu(A2(Ge, uu(n), r)));
    }), iu = F3(function() {
        return Je(0);
    }), ou = F2(function(n, r) {
        return A2(nu, n, r);
    });
    Dn.Task = Xn(Ze, au, iu, ou);
    var cu, fu = On("Task"), su = F2(function(n, r) {
        return fu(A2(nu, n, r));
    }), lu = Vr, du = Y, bu = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var t = r.b;
            if (n(r.a)) return !0;
            r = t;
        }
    }), mu = F3(function(n, r, t) {
        return n(r(t));
    }), pu = function(n) {
        return !n;
    }, vu = F2(function(n, r) {
        return !A2(bu, A2(mu, pu, n), r);
    }), $u = F5(function(n, r, t, e, u) {
        return {
            $: -1,
            a: n,
            b: r,
            c: t,
            d: e,
            e: u
        };
    }), gu = {
        $: -2
    }, hu = F5(function(n, r, t, e, u) {
        if (-1 !== u.$ || u.a) {
            if (-1 !== e.$ || e.a || -1 !== e.d.$ || e.d.a) return A5($u, n, r, t, e, u);
            var a = e.d;
            return i = e.e, A5($u, 0, e.b, e.c, A5($u, 1, a.b, a.c, a.d, a.e), A5($u, 1, r, t, i, u));
        }
        var i, o = u.b, c = u.c, f = u.d, s = u.e;
        return -1 !== e.$ || e.a ? A5($u, n, o, c, A5($u, 0, r, t, e, f), s) : A5($u, 0, r, t, A5($u, 1, e.b, e.c, e.d, i = e.e), A5($u, 1, o, c, f, s));
    }), ku = l, Cu = F3(function(n, r, t) {
        if (-2 === t.$) return A5($u, 0, n, r, gu, gu);
        var e = t.a, u = t.b, a = t.c, i = t.d, o = t.e;
        switch(A2(ku, n, u)){
            case 0:
                return A5(hu, e, u, a, A3(Cu, n, r, i), o);
            case 1:
                return A5($u, e, u, r, i, o);
            default:
                return A5(hu, e, u, a, i, A3(Cu, n, r, o));
        }
    }), ju = F3(function(n, r, t) {
        var e = A3(Cu, n, r, t);
        return -1 !== e.$ || e.a ? e : A5($u, 1, e.b, e.c, e.d, e.e);
    }), wu = function(n) {
        return !n.b;
    }, Au = F2(function(n, r) {
        var t = r.a, e = r.b;
        switch(n.$){
            case 0:
                return wu(n.a.c) ? d(t, e) : d(t, A2(bt, n, e));
            case 1:
                return d(t, A2(vu, function(n) {
                    return wu(n.c);
                }, n.b) ? e : A2(bt, n, e));
            case 2:
            case 4:
                return wu(n.b) ? d(t, e) : d(t, A2(bt, n, e));
            case 3:
                return d(t, A2(bt, n, e));
            case 5:
            case 7:
            case 8:
                return wu(n.a) ? d(t, e) : d(t, A2(bt, n, e));
            case 6:
                var u = n.a;
                return Re(u.kx) ? d(t, e) : d(A3(ju, u.nW, u.kx, t), e);
            default:
                return d(t, A2(vu, function(n) {
                    return wu(n.b);
                }, n.a) ? e : A2(bt, n, e));
        }
    }), Lu = gu, yu = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Su = F2(function(n, r) {
        return r.b ? A3(_e, bt, r, n) : n;
    }), Fu = F2(function(n, r) {
        return A2(Su, A2(Ge, function(n) {
            return yu({
                kx: n.b,
                nW: n.a
            });
        }, pt(n)), r);
    }), Tu = F2(function(n, r) {
        return r.$ ? Ct : kt(n(r.a));
    }), Qu = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), Iu = function(n) {
        return A2(Qu, "", A2(Tu, function(n) {
            return '@charset "' + n + '"';
        }, n));
    }, Bu = F2(function(n, r) {
        return A3(_e, F2(function(r, t) {
            return n(r) ? A2(bt, r, t) : t;
        }), g, r);
    }), Wu = function(n) {
        return "(" + n.fe + A2(Qu, "", A2(Tu, Qt(": "), n.sa)) + ")";
    }, Pu = function(n) {
        var r = F3(function(n, r, t) {
            return n + " " + A2(Wt, " and ", A2(bt, function(n) {
                switch(n){
                    case 0:
                        return "print";
                    case 1:
                        return "screen";
                    default:
                        return "speech";
                }
            }(r), A2(Ge, Wu, t)));
        });
        switch(n.$){
            case 0:
                return A2(Wt, " and ", A2(Ge, Wu, n.a));
            case 1:
                return A3(r, "only", n.a, n.b);
            case 2:
                return A3(r, "not", n.a, n.b);
            default:
                return n.a;
        }
    }, Mu = F2(function(n, r) {
        return '@import "' + n + Pu(r) + '"';
    }), qu = function(n) {
        var r = n.b;
        return A2(Wt, "\n", A2(Ge, Mu(n.a), r));
    }, Du = function(n) {
        return "@namespace " + n.a + '"' + n.b + '"';
    }, Xu = "    ", Eu = function(n) {
        return $(Xu, n);
    }, Ru = function(n) {
        return n + ";";
    }, xu = function(n) {
        return A2(Wt, "\n", A2(Ge, A2(mu, Eu, Ru), n));
    }, Ou = q, zu = function(n) {
        return "::" + n;
    }, Nu = function(n) {
        switch(n){
            case 0:
                return "+";
            case 1:
                return "~";
            case 2:
                return ">";
            default:
                return "";
        }
    }, Hu = function(n) {
        switch(n.$){
            case 0:
                return "." + n.a;
            case 1:
                return "#" + n.a;
            case 2:
                return ":" + n.a;
            default:
                return "[" + n.a + "]";
        }
    }, Vu = function(n) {
        switch(n.$){
            case 0:
            default:
                return A2(Wt, "", A2(bt, n.a, A2(Ge, Hu, r = n.b)));
            case 1:
                var r;
                return wu(r = n.a) ? "*" : A2(Wt, "", A2(Ge, Hu, r));
        }
    }, Uu = function(n) {
        var r = n.b;
        return A2(Wt, " ", C([
            Nu(n.a),
            Vu(r)
        ]));
    }, Ju = function(n) {
        var r = n.b, t = n.c, e = A2(bt, Vu(n.a), A2(Ge, Uu, r)), u = A2(Wt, "", C([
            A2(Qu, "", A2(Tu, zu, t))
        ]));
        return A2(Ou, A2(Wt, " ", A2(Bu, A2(mu, pu, Re), e)), u);
    }, Zu = F2(function(n, r) {
        var t = r.c;
        return A2(Wt, "", C([
            A2(Wt, ", ", A2(Ge, Ju, A2(bt, r.a, r.b))),
            " {\n",
            n,
            xu(t),
            "\n",
            n,
            "}"
        ]));
    }), Ku = function(n) {
        switch(n.$){
            case 0:
                return A2(Zu, "", n.a);
            case 1:
                var r = n.b;
                return "@media " + A2(Wt, ",\n", A2(Ge, Pu, n.a)) + " {\n" + A2(Wt, "\n\n", A2(Ge, A2(mu, Eu, Zu(Xu)), r)) + "\n}";
            case 2:
            case 3:
            case 4:
            case 5:
            case 7:
            case 8:
            default:
                return "TODO";
            case 6:
                return "@keyframes " + n.a.nW + " {\n" + n.a.kx + "\n}";
        }
    }, _u = function(n) {
        return A3(_e, Su, g, n);
    }, Gu = F2(function(n, r) {
        return _u(A2(Ge, n, r));
    }), Yu = function(n) {
        return {
            $: 8,
            a: n
        };
    }, na = function(n) {
        return {
            $: 5,
            a: n
        };
    }, ra = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), ta = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), ea = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), ua = function(n) {
        return {
            $: 0,
            a: n
        };
    }, aa = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), ia = function(n) {
        return {
            $: 7,
            a: n
        };
    }, oa = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), ca = F2(function(n, r) {
        return r.b ? r.b.b ? A2(bt, r.a, A2(ca, n, r.b)) : C([
            n(r.a)
        ]) : r;
    }), fa = F2(function(n, r) {
        return A3(ea, r.a, r.b, $(r.c, C([
            n
        ])));
    }), sa = F2(function(n, r) {
        if (!r.b) return r;
        if (r.b.b) return A2(bt, r.a, A2(sa, n, r.b));
        switch(r.a.$){
            case 0:
                return C([
                    ua(A2(fa, n, r.a.a))
                ]);
            case 1:
                var t = r.a, e = t.b;
                return C([
                    A2(oa, t.a, A2(ca, fa(n), e))
                ]);
            default:
                return r;
        }
    }), la = F2(function(n, r) {
        if (r.b.b) {
            var t = r.a, e = r.b, u = (i = r.c, A2(Ge, n, e)), a = n(t);
            return C([
                A3(ea, t, e, i),
                A3(ea, a, u, g)
            ]);
        }
        var i, o = r.a;
        return C([
            A3(ea, o, g, i = r.c),
            A3(ea, n(o), g, g)
        ]);
    }), da = F2(function(n, r) {
        return A3(ta, r.a, r.b, kt(n));
    }), ba = F2(function(n, r) {
        return A2(la, da(n), r);
    }), ma = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), pa = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), va = function(n) {
        return {
            $: 1,
            a: n
        };
    }, $a = F2(function(n, r) {
        switch(r.$){
            case 0:
                return A2(pa, r.a, $(r.b, C([
                    n
                ])));
            case 1:
                return va($(r.a, C([
                    n
                ])));
            default:
                return A2(ma, r.a, $(r.b, C([
                    n
                ])));
        }
    }), ga = F2(function(n, r) {
        if (r.b) {
            if (r.b.b) return A2(bt, r.a, A2(ga, n, r.b));
            var t = r.a;
            return C([
                d(t.a, A2($a, n, t.b))
            ]);
        }
        return g;
    }), ha = F2(function(n, r) {
        if (r.b.b) return t = r.c, A3(ta, r.a, A2(ga, n, r.b), t);
        var t = r.c;
        return A3(ta, A2($a, n, r.a), g, t);
    }), ka = F2(function(n, r) {
        return A2(la, ha(n), r);
    }), Ca = function(n) {
        n: for(;;){
            if (n.b) {
                if (n.a.$) {
                    n = t = n.b;
                    continue n;
                }
                var r = n.a.a, t = n.b;
                return $(A2(bt, r.a, r.b), Ca(t));
            }
            return g;
        }
    }, ja = F5(function(n, r, t, e, u) {
        return {
            $: 3,
            a: n,
            b: r,
            c: t,
            d: e,
            e: u
        };
    }), wa = F2(function(n, r) {
        n: for(;;){
            if (!r.b) return r;
            if (r.b.b) break n;
            switch(r.a.$){
                case 0:
                    return A2(Ge, ua, n(s = r.a.a));
                case 1:
                    if (r.a.b.b) {
                        if (r.a.b.b.b) {
                            var t = r.a, e = t.b, u = e.a, a = A2(wa, n, C([
                                A2(oa, t.a, e.b)
                            ]));
                            if (a.b && 1 === a.a.$ && !a.b.b) {
                                var i = a.a;
                                return C([
                                    A2(oa, i.a, A2(bt, u, i.b))
                                ]);
                            }
                            return a;
                        }
                        var o = r.a;
                        return C([
                            A2(oa, o.a, n(s = o.b.a))
                        ]);
                    }
                    break n;
                case 2:
                    var c = r.a;
                    return C([
                        A2(aa, c.a, A2(wa, n, c.b))
                    ]);
                case 3:
                    var f = r.a, s = f.e;
                    return A2(Ge, A4(ja, f.a, f.b, f.c, f.d), n(s));
                default:
                    return r;
            }
        }
        return A2(bt, u = r.a, A2(wa, n, r.b));
    }), Aa = M, La = F4(function(n, r, t, e) {
        return {
            aE: e,
            aM: t,
            av: r,
            qi: n
        };
    }), ya = 3432918353, Sa = 461845907, Fa = F2(function(n, r) {
        return (65535 & r) * n + (((r >>> 16) * n & 65535) << 16);
    }), Ta = f, Qa = F2(function(n, r) {
        return r << n | r >>> 32 - n;
    }), Ia = D, Ba = F2(function(n, r) {
        return A2(Fa, 5, A2(Qa, 13, n ^ A2(Fa, Sa, A2(Qa, 15, A2(Fa, ya, r))))) + 3864292196;
    }), Wa = F2(function(n, r) {
        var t = r.aM | (255 & zt(n)) << r.qi;
        return 24 === r.qi ? {
            aE: r.aE + 1,
            aM: 0,
            av: A2(Ba, r.av, t),
            qi: 0
        } : {
            aE: r.aE + 1,
            aM: t,
            av: r.av,
            qi: r.qi + 8
        };
    }), Pa = F2(function(n, r) {
        var t, e, u, a;
        return ((a = A2(Fa, 3266489909, (u = A2(Fa, 2246822507, (e = ((t = A3(Ia, Wa, A4(La, 0, n, 0, 0), r)).aM ? t.av ^ A2(Fa, Sa, A2(Qa, 15, A2(Fa, ya, t.aM))) : t.av) ^ t.aE) ^ e >>> 16)) ^ u >>> 13)) ^ a >>> 16) >>> 0;
    }), Ma = function(n) {
        return j(n).join("");
    }, qa = T, Da = function(n) {
        n: for(;;)switch(n){
            case 0:
                return "0";
            case 1:
                return "1";
            case 2:
                return "2";
            case 3:
                return "3";
            case 4:
                return "4";
            case 5:
                return "5";
            case 6:
                return "6";
            case 7:
                return "7";
            case 8:
                return "8";
            case 9:
                return "9";
            case 10:
                return "a";
            case 11:
                return "b";
            case 12:
                return "c";
            case 13:
                return "d";
            case 14:
                return "e";
            case 15:
                return "f";
            default:
                continue n;
        }
    }, Xa = F2(function(n, r) {
        for(;;){
            if (16 > r) return A2(bt, Da(r), n);
            n = A2(bt, Da(A2(qa, 16, r)), n), r = r / 16 | 0;
        }
    }), Ea = function(n) {
        return Ma(0 > n ? A2(bt, "-", A2(Xa, g, -n)) : A2(Xa, g, n));
    }, Ra = function(n) {
        return n.b ? kt(n.a) : Ct;
    }, xa = function(n) {
        n: for(;;){
            if (n.b) {
                if (n.b.b) {
                    n = n.b;
                    continue n;
                }
                return kt(C([
                    n.a
                ]));
            }
            return Ct;
        }
    }, Oa = function(n) {
        var r, t = function(n) {
            return n.b ? A2(bt, n.a, t(n.b)) : g;
        };
        return C([
            (r = t(n), {
                $: 9,
                a: r
            })
        ]);
    }, za = function(n) {
        return C([
            n
        ]);
    }, Na = F2(function(n, r) {
        return r.$ ? r : A2(oa, n, C([
            r.a
        ]));
    }), Ha = F3(function(n, r, t) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    var e = r.a;
                    n -= 1, r = r.b, t = A2(bt, e, t);
                    continue n;
                }
                return t;
            }
            return t;
        }
    }), Va = F2(function(n, r) {
        return Jt(A3(Ha, n, r, g));
    }), Ua = F3(function(n, r, t) {
        if (r > 0) {
            var e = d(r, t);
            n: for(;;){
                r: for(;;){
                    if (!e.b.b) return t;
                    if (!e.b.b.b) {
                        if (1 === e.a) break n;
                        break r;
                    }
                    switch(e.a){
                        case 1:
                            break n;
                        case 2:
                            var u = e.b;
                            return C([
                                u.a,
                                u.b.a
                            ]);
                        case 3:
                            if (e.b.b.b.b) {
                                var a = e.b, i = a.b;
                                return C([
                                    a.a,
                                    i.a,
                                    i.b.a
                                ]);
                            }
                            break r;
                        default:
                            if (e.b.b.b.b && e.b.b.b.b.b) {
                                var o = e.b, c = o.b, f = c.b, s = f.b, l = s.b;
                                return A2(bt, o.a, A2(bt, c.a, A2(bt, f.a, A2(bt, s.a, n > 1e3 ? A2(Va, r - 4, l) : A3(Ua, n + 1, r - 4, l)))));
                            }
                            break r;
                    }
                }
                return t;
            }
            return C([
                e.b.a
            ]);
        }
        return g;
    }), Ja = F2(function(n, r) {
        return A3(Ua, 0, n, r);
    }), Za = F5(function(n, r, t, e, u) {
        return u.$ ? u : A5(ja, n, r, t, e, u.a);
    }), Ka = F2(function(n, r) {
        switch(r.$){
            case 0:
                return A2(oa, n, C([
                    r.a
                ]));
            case 1:
                var t = r.b;
                return A2(oa, $(n, r.a), t);
            case 2:
                var e = r.b;
                return A2(aa, r.a, A2(Ge, Ka(n), e));
            case 3:
                return A5(ja, r.a, r.b, r.c, r.d, r.e);
            default:
                return r;
        }
    }), _a = function(n) {
        return n;
    }, Ga = F4(function(n, r, t, e) {
        var u = function(n) {
            var r;
            return A2(Qu, g, (r = n).b ? kt(r.b) : Ct);
        }, a = A2(Ya, r, A2(Qu, g, xa(e))), o = function() {
            var n = d(Ra(a), function(n) {
                n: for(;;){
                    if (n.b) {
                        if (n.b.b) {
                            n = n.b;
                            continue n;
                        }
                        return kt(n.a);
                    }
                    return Ct;
                }
            }(e));
            if (n.a.$ || n.b.$) return e;
            var r = n.a.a, t = n.b.a;
            return $(A2(Ja, Dt(e) - 1, e), C([
                i(t, r) ? t : r
            ]));
        }();
        return $(o, $(u(A2(Qu, g, A2(Tu, function(r) {
            return _u(A2(ca, Ya(n), A2(Ge, za, A2(wa, t, r))));
        }, xa(e)))), u(a)));
    }), Ya = F2(function(n, r) {
        if (!n.b) return r;
        switch(n.a.$){
            case 0:
                return A2(Ya, i = n.b, A2(sa, n.a.a, r));
            case 1:
                var t = n.a;
                return A4(Ga, p = t.b, i = n.b, ka(t.a), r);
            case 2:
                var e = n.a, u = e.a, a = e.b, i = n.b, o = F2(function(n, r) {
                    var t = n.c, e = r.b, a = r.c;
                    return A3(ta, n.a, $(n.b, A2(bt, d(u, r.a), e)), function(n) {
                        n: for(;;){
                            if (n.b) {
                                var r = n.a;
                                if (1 === r.$) {
                                    n = n.b;
                                    continue n;
                                }
                                return r;
                            }
                            return Ct;
                        }
                    }(C([
                        a,
                        t
                    ])));
                }), c = function(n) {
                    switch(n.$){
                        case 0:
                            var t = n.a, e = t.a, u = t.b, a = t.c, i = A2(Gu, function(n) {
                                return A2(Ge, o(n), A2(bt, e, u));
                            }, Ca(r)), c = i.b ? C([
                                ua(A3(ea, i.a, i.b, g))
                            ]) : g;
                            return A2(Ya, a, c);
                        case 1:
                            return A2(ti, n.a, n.b);
                        case 2:
                            return A2(ei, n.a, n.b);
                        case 3:
                            var f = n.e;
                            return A2(Ge, A4(Za, n.a, n.b, n.c, n.d), ni(f));
                        case 4:
                            return C([
                                A2(ra, n.a, n.b)
                            ]);
                        case 5:
                            return C([
                                na(n.a)
                            ]);
                        case 6:
                            return C([
                                ia(n.a)
                            ]);
                        case 7:
                            return C([
                                Yu(n.a)
                            ]);
                        default:
                            return Oa(n.a);
                    }
                };
                return _u($(C([
                    A2(Ya, i, r)
                ]), A2(Ge, c, A2(Gu, _a, a))));
            case 3:
                var f = n.a;
                return A4(Ga, p = f.b, i = n.b, ba(f.a), r);
            case 5:
                var s = n.a.a, l = (i = n.b, function(n) {
                    return A2(Aa, "_", Ea(A2(Pa, 15739, n)));
                }(s));
                return A2(Su, A2(Ya, i, A2(sa, "animation-name:" + l, r)), C([
                    yu({
                        kx: s,
                        nW: l
                    })
                ]));
            case 4:
                var b = n.a, m = b.a, p = b.b, v = (i = n.b, function() {
                    var n = Ca(r);
                    if (n.b) {
                        var t = n.a, e = n.b;
                        return A2(Ge, Na(m), A2(Ya, p, za(ua(A3(ea, t, e, g)))));
                    }
                    return g;
                }());
                return $(A2(Ya, i, r), v);
            default:
                return A2(Ya, $(n.a.a, i = n.b), r);
        }
    }), ni = function(n) {
        return A2(Ya, n.c, C([
            ua(A3(ea, n.a, n.b, g))
        ]));
    }, ri = function(n) {
        if (n.b) {
            var r = n.b;
            return $(ui(n.a), ri(r));
        }
        return g;
    }, ti = F2(function(n, r) {
        return A2(Gu, function(r) {
            return A2(Ge, Ka(n), ni(r));
        }, r);
    }), ei = F2(function(n, r) {
        var t = ri(A2(Gu, _a, r));
        return C([
            A2(aa, n, t)
        ]);
    }), ui = function(n) {
        switch(n.$){
            case 0:
                return ni(r = n.a);
            case 1:
                return A2(ti, n.a, n.b);
            case 2:
                return A2(ei, n.a, n.b);
            case 3:
                var r = n.e;
                return A2(Ge, A4(Za, n.a, n.b, n.c, n.d), ni(r));
            case 4:
                return C([
                    A2(ra, n.a, n.b)
                ]);
            case 5:
                return C([
                    na(n.a)
                ]);
            case 6:
                return C([
                    ia(n.a)
                ]);
            case 7:
                return C([
                    Yu(n.a)
                ]);
            default:
                return Oa(n.a);
        }
    }, ai = function(n) {
        var r, t, e;
        return function(n) {
            var r = n.eA, t = n.fA, e = n.gh, u = n.ky;
            return A2(Wt, "\n\n", A2(Bu, A2(mu, pu, Re), C([
                Iu(r),
                A2(Wt, "\n", A2(Ge, qu, t)),
                A2(Wt, "\n", A2(Ge, Du, e)),
                A2(Wt, "\n\n", A2(Ge, Ku, u))
            ])));
        }(function(n) {
            var r = n.eA, t = n.fA, e = n.gh, u = n.ky, a = A3(_e, Au, d(Lu, g), u);
            return {
                eA: r,
                ky: A2(Fu, a.a, a.b),
                fA: t,
                gh: e
            };
        }((t = (r = n).fA, e = r.gh, {
            eA: r.eA,
            ky: ri(A2(Gu, _a, r.he)),
            fA: t,
            gh: e
        })));
    }, ii = function(n) {
        return A2(Wt, "\n\n", A2(Ge, ai, n));
    }, oi = function(n) {
        return ur(vr(n));
    }, ci = function(n) {
        return {
            eA: Ct,
            fA: g,
            gh: g,
            he: n
        };
    }, fi = tr, si = function(n) {
        return {
            $: 4,
            a: n
        };
    }, li = si, di = function(n) {
        return {
            $: 0,
            a: n
        };
    }, bi = sn, mi = function(n) {
        return n.e;
    }, pi = null, vi = {
        lz: Lu,
        c9: 1,
        nE: "",
        as: pi,
        O: !1,
        Q: 400,
        ah: !1
    }, $i = function(n) {
        return A3(qt, F2(function(n, r) {
            return A3(Cn, n.a, n.b, r);
        }), {}, n);
    }, gi = hn, hi = F2(function(n, r) {
        return r.$ ? jt(n(r.a)) : yt(r.a);
    }), ki = F2(function(n, r) {
        return p(r, {
            nE: n
        });
    }), Ci = hi(function(n) {
        var r;
        return r = Kt(n), $i(C([
            d("_elm_ffi_log_str_", gi(r))
        ])), A2(ki, Kt(n), vi);
    }), ji = F2(function(n, r) {
        return Ci(A2(bi, mi(n), r));
    }), wi = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Ai = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Li = function(n) {
        return {
            $: 11,
            a: n
        };
    }, yi = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Si = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Fi = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Ti = "Have you setup elm-ffi? https://github.com/Warry/elm-ffi#readme", Qi = _, Ii = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), Bi = G, Wi = A2(Ii, "en", A2(bi, Bi, A2(Ii, gi(Ti), A2(bi, A2(du, "_elm_ffi_read_", Qi), $i(C([
        d("_elm_ffi_read_", gi('\n    const hashLocationLang = window.location.hash.startsWith("#lang=") ? window.location.hash.slice(6,8) : undefined;\n    const navigatorLang = window.navigator.language;\n    return hashLocationLang ?? navigatorLang;\n    '))
    ])))))), Pi = A2(Ue, "fr", Wi) ? function(n) {
        return n.bX;
    } : function(n) {
        return n.bQ;
    }, Mi = Pi({
        bQ: "End date",
        bX: "Date de fin"
    }), qi = F2(function(n, r) {
        return {
            e: r,
            g: n
        };
    }), Di = A2(qi, gi, Bi), Xi = function(n) {
        return n({
            jb: Ct,
            eg: !1,
            kt: Di,
            kO: !1,
            kT: "",
            lm: g,
            lO: !1,
            fq: !1,
            l2: "",
            mL: !0,
            m$: "",
            nX: !0,
            gy: "",
            sa: ""
        });
    }, Ei = F2(function(n, r) {
        return {
            eC: r,
            e5: !0,
            m$: n,
            sb: Lu
        };
    }), Ri = Pi({
        bQ: "Select organizations: ",
        bX: "S\xe9lectionnez les organisations: "
    }), xi = A, Oi = Pi({
        bQ: "Start date",
        bX: "Date de d\xe9but"
    }), zi = function(n) {
        return n.toLowerCase();
    }, Ni = function(n) {
        var r = A2(Ge, function(n) {
            return d(n.oB, n.gp);
        }, A2(xi, A2(mu, zi, function(n) {
            return n.gp;
        }), n.oD));
        return {
            lg: Xi(function(n) {
                return p(n, {
                    m$: Mi,
                    gy: "DD/MM/YY"
                });
            }),
            ll: Ct,
            oD: A2(Ei, Ri, r),
            qL: Xi(function(n) {
                return p(n, {
                    m$: Oi,
                    gy: "DD/MM/YY"
                });
            })
        };
    }, Hi = Pi({
        bQ: "Confirmation",
        bX: "Confirmation"
    }), Vi = Pi({
        bQ: "Disable organization emails",
        bX: "D\xe9sactiver les mails de l'organisation"
    }), Ui = Pi({
        bQ: "Email",
        bX: "Email"
    }), Ji = hn, Zi = A2(qi, Ji, Ae), Ki = function(n) {
        return n({
            kt: Zi,
            kO: !1,
            lm: g,
            lO: !1,
            fq: !1,
            l2: "",
            mj: "",
            mL: !0,
            m$: "",
            gy: "",
            sa: !1
        });
    }, _i = Pi({
        bQ: "Name",
        bX: "Nom"
    }), Gi = Pi({
        bQ: "New password",
        bX: "Nouveau mot de passe"
    }), Yi = Pi({
        bQ: "Password",
        bX: "Mot de passe"
    }), no = F2(function(n, r) {
        return {
            kN: Ki(function(r) {
                return p(r, {
                    m$: Vi,
                    sa: n.kN
                });
            }),
            k6: Xi(function(r) {
                return p(r, {
                    kO: !0,
                    m$: Ui,
                    sa: n.k6
                });
            }),
            ll: Ct,
            nW: Xi(function(r) {
                return p(r, {
                    m$: _i,
                    sa: n.nW
                });
            }),
            n1: Xi(function(n) {
                return p(n, {
                    m$: Gi
                });
            }),
            n2: Xi(function(n) {
                return p(n, {
                    m$: Hi
                });
            }),
            oN: Xi(function(n) {
                return p(n, {
                    m$: Yi
                });
            }),
            oO: Ct,
            re: Ct,
            sd: r
        };
    }), ro = (cu = Ct, function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(m) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return function($) {
                                                                            return {
                                                                                cz: i,
                                                                                cJ: o,
                                                                                cO: cu,
                                                                                cP: v,
                                                                                c5: l,
                                                                                c6: n,
                                                                                c7: m,
                                                                                dd: p,
                                                                                dm: t,
                                                                                dn: s,
                                                                                oD: r,
                                                                                ds: $,
                                                                                dv: c,
                                                                                dy: b,
                                                                                dF: d,
                                                                                dK: a,
                                                                                dT: u,
                                                                                dU: e,
                                                                                dZ: f
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })(Ct)(Ct)(Ct)(Ct)(Ct)(Ct)(Ct)(Ct)(Ct)(Ct)(Ct)(Ct)(Ct)(Ct)(Ct)(Ct)(Ct)(Ct), to = zn, eo = F2(function(n, r) {
        return d(r, to(n));
    }), uo = A2(eo, g, {
        oJ: ro
    }), ao = F3(function(n, r, t) {
        return {
            ea: !1,
            bN: n.bN,
            e8: {
                dC: Bt(n.oc)
            },
            mF: n.mF,
            aa: g,
            f1: "",
            b5: !1,
            r6: t,
            r8: r,
            dW: {
                ft: n.ft,
                mK: !1,
                ih: n.ih
            }
        };
    }), io = Lu, oo = Xi(Be), co = {
        kt: Ct,
        ll: Ct,
        nc: !0
    }, fo = function(n) {
        return {
            im: p(oo, {
                sa: n.bN.js
            }),
            iw: Ct,
            ix: p(oo, {
                eg: !0,
                kT: "addInBrowserInput"
            }),
            iT: p(oo, {
                sa: n.bN.jt
            }),
            jI: g,
            jJ: g,
            k$: Ct,
            k1: p(oo, {
                eg: !0,
                kT: "editInBrowserInput"
            }),
            ll: Ct,
            fJ: g,
            mC: g,
            mF: n.mF,
            n3: Ct,
            op: io,
            ox: Ct,
            oy: p(oo, {
                sa: "alphabetical"
            }),
            px: !0,
            qb: Ct,
            Q: co,
            q0: io,
            r9: n.r8.oz
        };
    }, so = {
        pX: p(Xi(Be), {
            kT: "searchInBrowserInput",
            nX: !1,
            gy: Pi({
                bQ: "Search...",
                bX: "Rechercher..."
            })
        }),
        pY: g,
        pZ: !1
    }, lo = {
        $: 0
    }, bo = {
        $: 1
    }, mo = function(n) {
        return {
            iN: lo,
            kW: Ct,
            kX: Ct,
            ll: Ct,
            bT: g,
            oL: bo,
            pe: "",
            r7: !1,
            r8: n
        };
    }, po = fn, vo = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), $o = function(n) {
        return {
            $: 0,
            a: n
        };
    }, go = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), ho = {
        $: 2
    }, ko = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Co = function(n) {
        return {
            $: 0,
            a: n
        };
    }, jo = {
        $: 1
    }, wo = function(n) {
        return !n.$;
    }, Ao = xn, Lo = F2(function(n, r) {
        n: for(;;){
            if (-2 === r.$) return Ct;
            var t = r.c, e = r.d, u = r.e;
            switch(A2(ku, n, r.b)){
                case 0:
                    r = e;
                    continue n;
                case 1:
                    return kt(t);
                default:
                    r = u;
                    continue n;
            }
        }
    }), yo = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.e.d.$ || n.e.d.a) {
                var r = n.d, t = n.e;
                return i = t.b, o = t.c, e = t.d, s = t.e, A5($u, 1, n.b, n.c, A5($u, 0, r.b, r.c, r.d, r.e), A5($u, 0, i, o, e, s));
            }
            var e, u = n.d, a = n.e, i = a.b, o = a.c, c = (e = a.d).d, f = e.e, s = a.e;
            return A5($u, 0, e.b, e.c, A5($u, 1, n.b, n.c, A5($u, 0, u.b, u.c, u.d, u.e), c), A5($u, 1, i, o, f, s));
        }
        return n;
    }, So = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.d.d.$ || n.d.d.a) {
                var r = n.d, t = n.e;
                return f = t.b, s = t.c, l = t.d, d = t.e, A5($u, 1, e = n.b, u = n.c, A5($u, 0, r.b, r.c, r.d, o = r.e), A5($u, 0, f, s, l, d));
            }
            var e = n.b, u = n.c, a = n.d, i = a.d, o = a.e, c = n.e, f = c.b, s = c.c, l = c.d, d = c.e;
            return A5($u, 0, a.b, a.c, A5($u, 1, i.b, i.c, i.d, i.e), A5($u, 1, e, u, o, A5($u, 0, f, s, l, d)));
        }
        return n;
    }, Fo = F7(function(n, r, t, e, u, a, i) {
        if (-1 !== a.$ || a.a) {
            n: for(;;){
                if (-1 === i.$ && 1 === i.a) {
                    if (-1 === i.d.$) {
                        if (1 === i.d.a) return So(r);
                        break n;
                    }
                    return So(r);
                }
                break n;
            }
            return r;
        }
        return A5($u, t, a.b, a.c, a.d, A5($u, 0, e, u, a.e, i));
    }), To = function(n) {
        if (-1 === n.$ && -1 === n.d.$) {
            var r = n.a, t = n.b, e = n.c, u = n.d, a = u.d, i = n.e;
            if (1 === u.a) {
                if (-1 !== a.$ || a.a) {
                    var o = yo(n);
                    if (-1 === o.$) {
                        var c = o.e;
                        return A5(hu, o.a, o.b, o.c, To(o.d), c);
                    }
                    return gu;
                }
                return A5($u, r, t, e, To(u), i);
            }
            return A5($u, r, t, e, To(u), i);
        }
        return gu;
    }, Qo = F2(function(n, r) {
        if (-2 === r.$) return gu;
        var t = r.a, e = r.b, u = r.c, a = r.d, i = r.e;
        if (0 > s(n, e)) {
            if (-1 === a.$ && 1 === a.a) {
                var o = a.d;
                if (-1 !== o.$ || o.a) {
                    var c = yo(r);
                    if (-1 === c.$) {
                        var f = c.e;
                        return A5(hu, c.a, c.b, c.c, A2(Qo, n, c.d), f);
                    }
                    return gu;
                }
                return A5($u, t, e, u, A2(Qo, n, a), i);
            }
            return A5($u, t, e, u, A2(Qo, n, a), i);
        }
        return A2(Io, n, A7(Fo, n, r, t, e, u, a, i));
    }), Io = F2(function(n, r) {
        if (-1 === r.$) {
            var t = r.a, e = r.b, u = r.c, a = r.d, o = r.e;
            if (i(n, e)) {
                var c = function(n) {
                    for(;;){
                        if (-1 !== n.$ || -1 !== n.d.$) return n;
                        n = n.d;
                    }
                }(o);
                return -1 === c.$ ? A5(hu, t, c.b, c.c, a, To(o)) : gu;
            }
            return A5(hu, t, e, u, a, A2(Qo, n, o));
        }
        return gu;
    }), Bo = F2(function(n, r) {
        var t = A2(Qo, n, r);
        return -1 !== t.$ || t.a ? t : A5($u, 1, t.b, t.c, t.d, t.e);
    }), Wo = F3(function(n, r, t) {
        var e = r(A2(Lo, n, t));
        return e.$ ? A2(Bo, n, t) : A3(ju, n, e.a, t);
    }), Po = F3(function(n, r, t) {
        return r(n(t));
    }), Mo = F2(function(n, r) {
        return A3(tt, "", Be, A2(Po, r, n));
    }), qo = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Do = {
        $: 2
    }, Xo = {
        $: 1
    }, Eo = F2(function(n, r) {
        switch(r.$){
            case 0:
                return jt({
                    $: 0,
                    a: r.a
                });
            case 1:
                return jt(Xo);
            case 2:
                return jt(Do);
            case 3:
                return jt(function(n) {
                    return {
                        $: 3,
                        a: n
                    };
                }(r.a.bq));
            default:
                return A2(hi, qo, n(r.b));
        }
    }), Ro = F2(function(n, r) {
        return A2(Mo, n, Eo(function(n) {
            return A2(hi, Kt, A2(po, r, n));
        }));
    }), xo = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Oo = nn, zo = F4(function(n, r, t, e) {
        return A2(Oo, t, A2(we, function(u) {
            return i(u, r) ? e : 10 > t ? A4(zo, n, r, t + 1, e) : xo("Can't find : " + r);
        }, A2(du, n, Bi)));
    }), No = A2(du, "refs", A4(zo, "id", "master", 0, A2(du, "ref", Bi))), Ho = {
        $: 0
    }, Vo = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Uo = F2(function(n, r) {
        return {
            gR: n,
            hD: r
        };
    }), Jo = Je(A2(Uo, Lu, g)), Zo = function(n) {
        return An(function(r) {
            var t = n.f;
            2 === t.$ && t.c && t.c(), n.f = null, r(jn(0));
        });
    }, Ko = Tn, _o = F3(function(n, r, t) {
        n: for(;;){
            if (r.b) {
                var e = r.a, u = r.b;
                if (e.$) {
                    var a = e.a;
                    return A2(Ye, function(r) {
                        var e = a.h2;
                        return A3(_o, n, u, 1 === e.$ ? t : A3(ju, e.a, r, t));
                    }, Ko(A3(nt, n, eu(n), a)));
                }
                var i = e.a, o = A2(Lo, i, t);
                if (1 === o.$) {
                    r = u;
                    continue n;
                }
                return A2(Ye, function() {
                    return A3(_o, n, u, A2(Bo, i, t));
                }, Zo(o.a));
            }
            return Je(t);
        }
    }), Go = F4(function(n, r, t, e) {
        return A2(Ye, function(n) {
            return Je(A2(Uo, n, t));
        }, A3(_o, n, r, e.gR));
    }), Yo = F3(function(n, r, t) {
        var e = n(r);
        return e.$ ? t : A2(bt, e.a, t);
    }), nc = F2(function(n, r) {
        return A3(_e, Yo(n), g, r);
    }), rc = F4(function(n, r, t, e) {
        var u = e.b;
        return i(r, e.a) ? kt(A2(eu, n, u(t))) : Ct;
    }), tc = F3(function(n, r, t) {
        return A2(Ye, function() {
            return Je(t);
        }, tu(A2(nc, A3(rc, n, r.a, r.b), t.hD)));
    }), ec = F2(function(n, r) {
        if (r.$) {
            var t = r.a;
            return Vo({
                iH: t.iH,
                eq: t.eq,
                cX: A2(et, n, t.cX),
                l0: t.l0,
                aR: t.aR,
                dO: t.dO,
                h2: t.h2,
                r6: t.r6
            });
        }
        return {
            $: 0,
            a: r.a
        };
    }), uc = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), ac = F2(function(n, r) {
        return A2(uc, r.a, A2(Po, r.b, n));
    });
    Dn.Http = Xn(Jo, Go, tc, ec, ac);
    var ic, oc, cc, fc, sc, lc, dc, bc, mc, pc, vc = On("Http"), $c = (On("Http"), function(n) {
        return function(n) {
            return vc(Vo({
                iH: !1,
                eq: n.eq,
                cX: n.cX,
                l0: n.l0,
                aR: n.aR,
                dO: n.dO,
                h2: n.h2,
                r6: n.r6
            }));
        }({
            eq: Ho,
            cX: n.cX,
            l0: g,
            aR: "GET",
            dO: Ct,
            h2: Ct,
            r6: n.r6
        });
    }), gc = "https://nomalab.prismic.io/api/v2", hc = d({
        f1: "",
        oI: Ct,
        ce: Ct
    }, (ic = function(n) {
        return {
            $: 0,
            a: n
        };
    }, $c({
        cX: A2(Ro, ic, No),
        r6: gc
    }))), kc = Pi({
        bQ: "Can downlaod",
        bX: "Autoriser \xe0 t\xe9l\xe9charger"
    }), Cc = Ki(function(n) {
        return p(n, {
            mj: "checkbox-canDownload",
            m$: kc
        });
    }), jc = Pi({
        bQ: "Can upload",
        bX: "Autoriser \xe0 uploader"
    }), wc = Ki(function(n) {
        return p(n, {
            mj: "checkbox-canUpload",
            m$: jc
        });
    }), Ac = Pi({
        bQ: "Email",
        bX: "Email"
    }), Lc = Pi({
        bQ: "Invited user\u2019s email",
        bX: "Email de l\u2019utilisateur invit\xe9"
    }), yc = Xi(function(n) {
        return p(n, {
            m$: Ac,
            gy: Lc
        });
    }), Sc = Pi({
        bQ: "Expiration date",
        bX: "Date d\u2019Expiration"
    }), Fc = Xi(function(n) {
        return p(n, {
            m$: Sc
        });
    }), Tc = Pi({
        bQ: "Message",
        bX: "Message"
    }), Qc = Xi(function(n) {
        return p(n, {
            m$: Tc,
            gy: Tc
        });
    }), Ic = {
        jx: Cc,
        jy: wc,
        kQ: !1,
        k6: yc,
        ll: Ct,
        lq: Fc,
        lW: Ct,
        nE: Qc
    }, Bc = {
        $: 0
    }, Wc = {
        oq: !1,
        os: !1,
        Q: Bc,
        rO: Bc,
        rY: Bc
    }, Pc = {
        lW: {
            $: 0
        },
        fH: "",
        gn: !1
    }, Mc = {
        ea: Wc,
        iY: 0,
        cT: Pc,
        e9: co,
        mj: "",
        fJ: Ic,
        nd: !0,
        ne: !0,
        Q: co,
        rA: Lu
    }, qc = {
        aN: 0
    }, Dc = F2(function(n, r) {
        return A3(ju, n, 0, r);
    }), Xc = function(n) {
        return A3(qt, Dc, io, n);
    }, Ec = {
        i5: g,
        ef: g,
        or: Xc(g),
        si: g
    }, Rc = F8(function(n, r, t, e, u, a, i, o) {
        return {
            e_: t,
            lR: o,
            fn: n,
            j: r,
            fo: i,
            mf: e,
            nP: u,
            p$: a
        };
    }), xc = B, Oc = function(n) {
        return xc(n);
    }, zc = F2(function(n, r) {
        return se(r) % se(n);
    }), Nc = F2(function(n, r) {
        var t = 24 * xc(3600 * r.fn), e = xc(60 * r.fn * 10), u = 0 > n % t ? t + n : n % t, a = u % e, i = xc(.066666 * r.fn), o = se(u / e), c = s(a, i) > 0 ? u + 9 * i * o + i * se((a - i) / e) : u + 9 * i * o;
        return C([
            se(se(se(c / r.j) / 60) / 60),
            A2(zc, 60, se(c / r.j) / 60),
            A2(zc, 60, c / r.j),
            c % r.j
        ]);
    }), Hc = F3(function(n, r, t) {
        for(;;){
            var e = A2(pe, Gt, n), u = e.a, a = e.b;
            if (0 > s(le(u), Gt)) return A2(he, !0, {
                u: r,
                n: t,
                t: u
            });
            n = a, r = A2(bt, ie(u), r), t += 1;
        }
    }), Vc = 4294967295 >>> 32 - ee, Uc = u, Jc = F3(function(n, r, t) {
        for(;;){
            var e = A2(Uc, Vc & r >>> n, t);
            if (e.$) return A2(Uc, Vc & r, e.a);
            n -= ee, t = e.a;
        }
    }), Zc = F2(function(n, r) {
        var t = r.a, e = r.b, u = r.c, a = r.d;
        return 0 > n || s(n, t) > -1 ? Ct : s(n, function(n) {
            return n >>> 5 << 5;
        }(t)) > -1 ? kt(A2(Uc, Vc & n, a)) : kt(A3(Jc, e, n, u));
    }), Kc = function(n) {
        if (n.e_) {
            var r = A2(Nc, n.lR, n), t = F2(function(n, r) {
                var t;
                return A2(Zc, n, (t = r).b ? A3(Hc, t, g, 0) : ue);
            });
            return p(n, {
                fo: A2(Qu, 0, A2(t, 3, r)),
                mf: A2(Qu, 0, A2(t, 0, r)),
                nP: A2(Qu, 0, A2(t, 1, r)),
                p$: A2(Qu, 0, A2(t, 2, r))
            });
        }
        var e = se(n.lR / (3600 * n.j)), u = e > 23 ? d(e % 24, n.lR - 82800 * n.j) : d(e, n.lR), a = u.b;
        return p(n, {
            fo: a % (3600 * n.j) % (60 * n.j) % n.j,
            mf: u.a,
            nP: se(a % (3600 * n.j) / (60 * n.j)),
            p$: se(a % (3600 * n.j) % (60 * n.j) / n.j)
        });
    }, _c = function(n) {
        if (0 === n.length || /[\sxbo]/.test(n)) return Ct;
        var r = +n;
        return r == r ? kt(r) : Ct;
    }, Gc = F2(function(n, r) {
        var t = _c(r);
        return t.$ ? n : t.a;
    }), Yc = F2(function(n, r) {
        var t = Oe(r);
        return t.$ ? n : t.a;
    }), nf = F2(function(n, r) {
        var t = 11 === qe(n) ? A3(De, 9, 11, n) : "00";
        return p(r, {
            fo: r.fo + A2(Yc, 0, t),
            mf: r.mf + A2(Gc, 0, A3(De, 0, 2, n)),
            nP: r.nP + A2(Gc, 0, A3(De, 3, 5, n)),
            p$: r.p$ + A2(Gc, 0, A3(De, 6, 8, n))
        });
    }), rf = F2(function(n, r) {
        return Kc(function(n) {
            var r = n.e_ ? function(n) {
                var r = n.p$, t = n.nP, e = 60 * n.j, u = n.mf, a = 60 * u + t, i = 3600 * n.j, o = n.fo, c = xc(.066666 * n.fn), f = i * u + e * t + n.j * r + o - c * (a - se(a / 10));
                return xc(f);
            }(n) : function(n) {
                return xc(3600 * n.j * n.mf + 60 * n.j * n.nP + n.j * n.p$ + n.fo);
            }(n);
            return p(n, {
                lR: r
            });
        }(A2(nf, n, r)));
    }), tf = F3(function(n, r, t) {
        return A2(rf, "00:00:00:00", A8(Rc, A2(Gc, 29.97, n), Oc(A2(Gc, 29.97, n)), t, 0, 0, 0, r, 0));
    }), ef = A3(tf, "25", 0, !1), uf = {
        iy: !1,
        i_: !1,
        ew: g,
        kl: 0,
        kn: ef,
        lS: 25,
        mG: !1,
        mI: !1,
        mM: !1,
        gz: 1,
        qO: "00:00:00:00",
        q4: kt("")
    }, af = {
        $: 0
    }, of = Pi({
        bQ: "Choose a delivery channel",
        bX: "Choisissez une chaine de livraison"
    }), cf = Pi({
        bQ: "Request reason",
        bX: "Donnez le motif du refus"
    }), ff = {
        nw: Xi(function(n) {
            return p(n, {
                gy: of
            });
        }),
        nx: Xi(function(n) {
            return p(n, {
                gy: cf
            });
        }),
        ny: af,
        gn: !1
    }, sf = {
        $: 0
    }, lf = {
        $: 0
    }, df = Pi({
        bQ: "Add timecode",
        bX: "Ajouter le timecode"
    }), bf = Pi({
        bQ: "Comment",
        bX: "Commenter"
    }), mf = {
        eC: g,
        e5: !0,
        m$: "",
        gn: !1,
        gy: "",
        sa: Ct
    }, pf = Pi({
        bQ: "Job's type choice",
        bX: "Choix type de Job"
    }), vf = Pi({
        bQ: "Ads",
        bX: "Publicit\xe9s"
    }), $f = Pi({
        bQ: "End credits",
        bX: "G\xe9n\xe9rique de fin"
    }), gf = Pi({
        bQ: "Introduction",
        bX: "Introduction"
    }), hf = Pi({
        bQ: "Textless elements",
        bX: "Fonds neutres"
    }), kf = Pi({
        bQ: "Opening credits",
        bX: "G\xe9n\xe9rique de d\xe9but"
    }), Cf = Pi({
        bQ: "Program",
        bX: "Programme"
    }), jf = Pi({
        bQ: "Clip",
        bX: "Extrait"
    }), wf = C([
        d("openingCredits", kf),
        d("endingCredits", $f),
        d("introduction", gf),
        d("program", Cf),
        d("trailer", jf),
        d("advertising", vf),
        d("neutralBases", hf)
    ]), Af = Pi({
        bQ: "Segment choice",
        bX: "Choix Segments"
    }), Lf = function(n) {
        switch(n){
            case 0:
                return "Spotcheck";
            case 1:
                return "QC";
            case 2:
                return "DownloadAsIs";
            case 3:
                return "SimpleTranscode";
            default:
                return "PADTranscode";
        }
    }, yf = C([
        d(Lf(1), Lf(1)),
        d(Lf(0), Lf(0))
    ]), Sf = {
        is: !1,
        it: !1,
        iP: {
            c2: 3,
            sc: lf
        },
        d9: Lu,
        jY: !1,
        jZ: sf,
        kb: sf,
        kp: Ct,
        k0: Lu,
        k2: Lu,
        k3: Lu,
        ll: Ct,
        l$: !1,
        mR: p(mf, {
            eC: yf,
            gy: pf
        }),
        nE: Xi(function(n) {
            return p(n, {
                gy: bf
            });
        }),
        p1: Ct,
        p2: p(mf, {
            eC: wf,
            gy: Af
        }),
        qq: !1,
        qM: sf,
        qN: sf,
        qO: "00:00:00:00",
        rh: 0,
        hZ: Ki(function(n) {
            return p(n, {
                mj: "commentTitmecode",
                m$: df
            });
        })
    }, Ff = {
        e5: !0,
        ll: Ct,
        pg: g,
        pM: Ct,
        p8: Ct,
        sf: Lu
    }, Tf = {
        km: Ct
    }, Qf = {
        $: 0
    }, If = Qf, Bf = {
        $: 0
    }, Wf = Pi({
        bQ: "content type",
        bX: "type de contenu"
    }), Pf = function(n) {
        switch(n){
            case 0:
                return "1.33";
            case 1:
                return "1.66";
            case 2:
                return "1.77";
            case 3:
                return "1.85";
            case 4:
                return "2.00";
            case 5:
                return "2.20";
            case 6:
                return "2.35";
            case 7:
                return "2.39";
            default:
                return "2.40";
        }
    }, Mf = Pf, qf = function(n) {
        switch(n){
            case 0:
                return "SD";
            case 1:
                return "HD";
            case 2:
                return "UHD";
            case 3:
                return "2k";
            case 4:
                return "4k";
            default:
                return "DCP";
        }
    }, Df = qf, Xf = function(n) {
        return n ? "Clean (C)" : "Master (M)";
    }, Ef = Pi({
        bQ: "Textless elements",
        bX: "Fonds neutres"
    }), Rf = Pi({
        bQ: "Program",
        bX: "Programme"
    }), xf = Pi({
        bQ: "Teaser",
        bX: "Teaser"
    }), Of = Pi({
        bQ: "Trailer",
        bX: "Bande-annonce"
    }), zf = function(n) {
        switch(n){
            case 0:
                return Rf;
            case 1:
                return Of;
            case 2:
                return xf;
            default:
                return Ef;
        }
    }, Nf = Pi({
        bQ: "file format",
        bX: "format du fichier"
    }), Hf = Pi({
        bQ: "file type",
        bX: "type de fichier"
    }), Vf = Pi({
        bQ: "first airdate",
        bX: "date de 1ere diffusion"
    }), Uf = Pi({
        bQ: "internal ID",
        bX: "identifiant interne"
    }), Jf = Pi({
        bQ: "Ad Broadcaster ID",
        bX: "ID Diffuseur Pub"
    }), Zf = C([
        d("A", "Pour votre sant\xe9, mangez au moins cinq fruits et l\xe9gumes par jour"),
        d("B", "Pour votre sant\xe9, pratiquez une activit\xe9 physique r\xe9guli\xe8re"),
        d("C", "Pour votre sant\xe9, \xe9vitez de manger trop gras, trop sucr\xe9, trop sal\xe9"),
        d("D", "Pour votre sant\xe9, \xe9vitez de grignoter entre les repas"),
        d("E", "Apprenez \xe0 votre enfant \xe0 ne pas grignoter entre les repas"),
        d("F", "Bouger, jouer est indispensable au d\xe9veloppement de votre enfant"),
        d("G", "En plus du lait, l\u2019eau est la seule boisson indispensable"),
        d("H", "Pour ta sant\xe9, mange au moins cinq fruits et l\xe9gumes par jour"),
        d("I", "Pour ta sant\xe9, pratique une activit\xe9 physique r\xe9guli\xe8re"),
        d("J", "Pour ta sant\xe9, \xe9vite de manger trop gras, trop sucr\xe9, trop sal\xe9"),
        d("K", "Pour ta sant\xe9, \xe9vite de grignoter entre les repas"),
        d("L", "Pour bien grandir, mange au moins cinq fruits et l\xe9gumes par jour"),
        d("M", "Pour \xeatre en forme, d\xe9pense-toi bien"),
        d("N", "Pour bien grandir, ne mange pas trop gras, trop sucr\xe9, trop sal\xe9"),
        d("O", "Pour \xeatre en forme, \xe9vite de grignoter dans la journ\xe9e"),
        d("P", "Pour les trajets courts, privil\xe9giez la marche ou le v\xe9lo"),
        d("Q", "Pensez \xe0 covoiturer"),
        d("R", "Au quotidien, prenez les transports en commun"),
        d("V", "Jouer comporte des risques : endettement, d\xe9pendance,\u2026 Appelez le 09 74 75 13 13 (appel non surtax\xe9)"),
        d("W", "Jouer comporte des risques : isolement, endettement,\u2026 Appelez le 09 74 75 13 13 (appel non surtax\xe9)"),
        d("X", "Jouer comporte des risques : d\xe9pendance, isolement,\u2026 Appelez le 09 74 75 13 13 (appel non surtax\xe9)"),
        d("INC", "Inconnue")
    ]), Kf = Pi({
        bQ: "legal mentions",
        bX: "mentions l\xe9gales"
    }), _f = Pi({
        bQ: "production company",
        bX: "soci\xe9t\xe9 de production"
    }), Gf = Pi({
        bQ: "company name",
        bX: "raison sociale"
    }), Yf = Pi({
        bQ: "production year",
        bX: "ann\xe9e de production"
    }), ns = Pi({
        bQ: "pubID",
        bX: "pubID"
    }), rs = function(n) {
        return n ? "Clean" : "Master";
    }, ts = function(n) {
        switch(n){
            case 0:
                return "Program";
            case 1:
                return "Trailer";
            case 2:
                return "Teaser";
            default:
                return "Neutral bases";
        }
    }, es = Pi({
        bQ: "title",
        bX: "titre"
    }), us = function(n) {
        var r = C([
            d(ts(0), zf(0)),
            d(ts(1), zf(1)),
            d(ts(2), zf(2)),
            d(ts(3), zf(3))
        ]), t = A2(bt, d("", "Sans mentions l\xe9gales"), A2(Ge, function(n) {
            var r = n.a;
            return d(r, r + ": " + n.b);
        }, Zf)), e = n.mF ? ns : Uf, u = n.mF ? Jf : "", a = C([
            d(rs(0), Xf(0)),
            d(rs(1), Xf(1))
        ]), i = C([
            d(qf(0), Df(0)),
            d(qf(1), Df(1)),
            d(qf(2), Df(2)),
            d(qf(3), Df(3)),
            d(qf(4), Df(4)),
            d(qf(5), Df(5))
        ]), o = n.mF ? Gf : _f, c = C([
            d(Pf(0), Mf(0)),
            d(Pf(1), Mf(1)),
            d(Pf(2), Mf(2)),
            d(Pf(3), Mf(3)),
            d(Pf(4), Mf(4)),
            d(Pf(5), Mf(5)),
            d(Pf(6), Mf(6)),
            d(Pf(7), Mf(7)),
            d(Pf(8), Mf(8))
        ]);
        return {
            jr: Xi(function(n) {
                return p(n, {
                    m$: e,
                    gy: ""
                });
            }),
            bP: p(mf, {
                eC: c,
                m$: "display aspect ratio"
            }),
            k8: Ki(function(n) {
                return p(n, {
                    m$: "auto release"
                });
            }),
            lB: p(mf, {
                eC: i,
                m$: Nf
            }),
            F: p(mf, {
                eC: a,
                m$: Hf
            }),
            lF: Xi(function(n) {
                return p(n, {
                    m$: Vf,
                    gy: "DD/MM/YYYY"
                });
            }),
            b_: Xi(function(n) {
                return p(n, {
                    m$: u,
                    gy: ""
                });
            }),
            mF: n.mF,
            b2: p(mf, {
                eC: t,
                m$: Kf
            }),
            cb: p(mf, {
                eC: c,
                m$: "original aspect ratio"
            }),
            cg: Xi(function(n) {
                return p(n, {
                    m$: o,
                    gy: ""
                });
            }),
            ch: Xi(function(n) {
                return p(n, {
                    m$: Yf,
                    gy: ""
                });
            }),
            ci: p(mf, {
                eC: r,
                m$: Wf
            }),
            o9: Ct,
            Q: Bf,
            rC: Xi(function(n) {
                return p(n, {
                    m$: es,
                    gy: ""
                });
            })
        };
    }, as = {
        lm: Lu,
        or: io,
        o8: Lu,
        pq: Lu,
        hI: Lu
    }, is = Pi({
        bQ: "Can download (extra costs apply)",
        bX: "Autoriser le t\xe9l\xe9chargement (soumis \xe0 facturation)"
    }), os = Ki(function(n) {
        return p(n, {
            mj: "checkbox-canDownload",
            m$: is
        });
    }), cs = Pi({
        bQ: "Can Upload",
        bX: "Autoriser \xe0 l'upload"
    }), fs = Ki(function(n) {
        return p(n, {
            mj: "checkbox-canUpload",
            m$: cs
        });
    }), ss = Pi({
        bQ: "Email",
        bX: "Email"
    }), ls = Pi({
        bQ: "Invited user\u2019s email",
        bX: "Email de l\u2019utilisateur invit\xe9"
    }), ds = Xi(function(n) {
        return p(n, {
            m$: ss,
            gy: ls
        });
    }), bs = Pi({
        bQ: "Expiration date",
        bX: "Date d\u2019Expiration"
    }), ms = Xi(function(n) {
        return p(n, {
            m$: bs
        });
    }), ps = Pi({
        bQ: "Message",
        bX: "Message"
    }), vs = Xi(function(n) {
        return p(n, {
            m$: ps,
            gy: ps
        });
    }), $s = {
        jx: os,
        jy: fs,
        kQ: !1,
        k6: ds,
        ll: Ct,
        lq: ms,
        nE: vs
    }, gs = {
        $: 0
    }, hs = Pi({
        bQ: "audio mapping",
        bX: "mapping audio"
    }), ks = Pi({
        bQ: "channel",
        bX: "chaine"
    }), Cs = Pi({
        bQ: "host",
        bX: "host"
    }), js = Pi({
        bQ: "password",
        bX: "mot de passe"
    }), ws = Pi({
        bQ: "path",
        bX: "path"
    }), As = Pi({
        bQ: "port (default 21)",
        bX: "port (default 21)"
    }), Ls = Pi({
        bQ: "user",
        bX: "utilisateur"
    }), ys = Pi({
        bQ: "file\u2019s type",
        bX: "type de fichier"
    }), Ss = {
        ll: Ct,
        mq: Xi(function(n) {
            return p(n, {
                m$: Cs,
                gy: Cs
            });
        }),
        mr: Xi(function(n) {
            return p(n, {
                m$: js,
                gy: js
            });
        }),
        ms: Xi(function(n) {
            return p(n, {
                m$: ws,
                gy: ws
            });
        }),
        mt: Xi(function(n) {
            return p(n, {
                m$: As,
                gy: As
            });
        }),
        mw: Xi(function(n) {
            return p(n, {
                m$: Ls,
                gy: Ls
            });
        }),
        p7: Xi(function(n) {
            return p(n, {
                m$: "",
                gy: ys,
                sa: "Material"
            });
        })
    }, Fs = Pi({
        bQ: "S3 file\u2019s bucket",
        bX: "bucket du fichier S3"
    }), Ts = Pi({
        bQ: "S3 file\u2019s key",
        bX: "cl\xe9 du fichier S3"
    }), Qs = Pi({
        bQ: "file\u2019s type",
        bX: "type de fichier"
    }), Is = {
        mu: Xi(function(n) {
            return p(n, {
                m$: Fs,
                gy: Fs
            });
        }),
        mv: Xi(function(n) {
            return p(n, {
                m$: Ts,
                gy: Ts
            });
        }),
        p7: Xi(function(n) {
            return p(n, {
                m$: "",
                gy: Qs,
                sa: "Material"
            });
        })
    }, Bs = Pi({
        bQ: "Request reason",
        bX: "Raison de la demande"
    }), Ws = Pi({
        bQ: "Segmentation rules",
        bX: "R\xe8gles de segmentation"
    }), Ps = {
        iM: gs,
        ea: gs,
        i4: Xi(function(n) {
            return p(n, {
                gy: hs
            });
        }),
        bG: Xi(function(n) {
            return p(n, {
                gy: ks
            });
        }),
        kc: gs,
        kd: Xi(function(n) {
            return p(n, {
                gy: Bs
            });
        }),
        km: Ct,
        kz: Xi(function(n) {
            return p(n, {
                gy: "Choose Deep Probe Template"
            });
        }),
        kC: gs,
        kD: gs,
        lX: Ss,
        l4: !0,
        l5: !0,
        l6: !0,
        o2: gs,
        o3: g,
        ds: g,
        pt: gs,
        pu: gs,
        pv: gs,
        pI: Is,
        dy: g,
        p3: Xi(function(n) {
            return p(n, {
                gy: Ws
            });
        }),
        g9: Ct,
        qp: Xi(function(n) {
            return p(n, {
                gy: "Choose File"
            });
        }),
        rZ: gs
    }, Ms = {
        e5: !0,
        pg: Ct,
        sf: Lu
    }, qs = function(n) {
        return {
            ik: ff,
            ir: Sf,
            ea: Wc,
            iY: 0,
            iZ: !1,
            i6: Ff,
            i9: Tf,
            jp: !1,
            j6: Ec,
            kF: If,
            cT: Pc,
            k$: us(n),
            e9: co,
            bT: as,
            mj: "",
            fJ: $s,
            na: !1,
            nf: !0,
            ow: Ps,
            oK: {
                bF: Ct,
                co: Ct
            },
            oR: Ct,
            oT: !0,
            oU: uf,
            pg: Ct,
            qm: !1,
            qn: !1,
            qo: !1,
            Q: co,
            q5: Ms,
            q9: Lu,
            rM: !0
        };
    }, Ds = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Xs = yn, Es = F2(function(n, r) {
        return fu(A2(Xs, A2(mu, A2(mu, Je, n), jt), A2(Ye, A2(mu, A2(mu, Je, n), yt), r)));
    }), Rs = Es, xs = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Os = xs({
        $: 20
    }), zs = F2(function(n, r) {
        return {
            eq: Ho,
            aR: n,
            cf: yt,
            P: g,
            r6: r
        };
    }), Ns = function(n) {
        return A2(Wt, "", n);
    }, Hs = function(n) {
        return n.$ ? "/v4" + function(n) {
            switch(n.$){
                case 0:
                    return "/organizations" + (1 === (u = n.a).$ ? "" : "/" + (u.a + function(n) {
                        switch(n){
                            case 1:
                                return "";
                            case 0:
                                return "/audioMapping";
                            case 2:
                                return "/segmentationRules";
                            case 3:
                                return "/formats";
                            default:
                                return "/extraFormats";
                        }
                    }(u.b)));
                case 1:
                    return "/shows/" + (i = n.a).a + (i.b ? "/events" : "/showMetadata");
                case 2:
                    return "/admin" + function(n) {
                        switch(n.$){
                            case 0:
                                return "/files/csv";
                            case 1:
                                return "/metadata/schemas";
                            case 2:
                                return "/metadata/schemas/" + n.a;
                            default:
                                return "/app" + function(n) {
                                    return n.$ ? "/" + n.a : "";
                                }(n.a);
                        }
                    }(n.a);
                case 3:
                    return "/broadcastables/" + ((a = n.a).a + function(n) {
                        switch(n){
                            case 0:
                                return "/analysis";
                            case 1:
                                return "/delivery";
                            case 2:
                                return "/deliver";
                            default:
                                return "/transcode/ad";
                        }
                    }(a.b));
                case 4:
                    return "/segmentationRules" + ((e = n.a).$ ? "/" + e.a : "");
                case 5:
                    return "/users" + function(n) {
                        switch(n.$){
                            case 0:
                                return "/login";
                            case 1:
                                var r = n.b;
                                return "/sso?email=" + (n.a + A2(Po, Tu(Qt("&redirect=")), Qu(""))(r));
                            case 2:
                                return "/askResetPassword";
                            case 3:
                                return "/resetPassword";
                            default:
                                return "/revoke";
                        }
                    }(n.a);
                case 6:
                    return "/audioMappings" + ((t = n.a).$ ? "/" + t.a : "");
                default:
                    return "/files/" + (r = n.a).a + (r.b ? "/qualifySubtitles" : "/qualifyAudio");
            }
            var r, t, e, u, a, i;
        }(n.a) : "/v3" + function(n) {
            switch(n.$){
                case 0:
                    return "/unitaries" + function(n) {
                        return n.$ ? "/" + n.a : "";
                    }(n.a);
                case 1:
                    return "/collections" + function(n) {
                        return n.$ ? "/" + n.a : "";
                    }(n.a);
                case 2:
                    return "/seasons" + function(n) {
                        return n.$ ? "/" + n.a : "";
                    }(n.a);
                case 3:
                    return "/episodes" + function(n) {
                        return n.$ ? "/" + n.a : "";
                    }(n.a);
                case 4:
                    return "/hierarchy" + function(n) {
                        var r = n.a;
                        switch(n.b){
                            case 0:
                                return "/" + r;
                            case 1:
                                return "/" + r + "/archive";
                            case 2:
                                return "/" + r + "/unarchive";
                            case 3:
                                return "/" + r + "/trash";
                            case 4:
                                return "/" + r + "/untrash";
                            case 5:
                                return "/" + r + "/invitations";
                            case 6:
                                return "/" + r + "/shows";
                            default:
                                return "/" + r + "/events";
                        }
                    }(n.a);
                case 5:
                    return "/shows/" + ((o = n.a).a + function(n) {
                        switch(n){
                            case 0:
                                return "";
                            case 1:
                                return "/invitations";
                            case 2:
                                return "/metadata";
                            case 3:
                                return "/files";
                            case 4:
                                return "/versions";
                            case 5:
                                return "/versions/admin";
                            case 6:
                                return "/accept";
                            case 7:
                                return "/archive";
                            case 8:
                                return "/unarchive";
                            case 9:
                                return "/trash";
                            default:
                                return "/untrash";
                        }
                    }(o.b));
                case 6:
                    return "/organizations" + function(n) {
                        switch(n.$){
                            case 0:
                                return "";
                            case 2:
                                return "/" + (n.a + function(n) {
                                    switch(n){
                                        case 0:
                                            return "";
                                        case 1:
                                            return "/filelist";
                                        case 2:
                                            return "/jobs";
                                        case 3:
                                            return "/subtitleFormats";
                                        default:
                                            return "/shows/deliveries";
                                    }
                                }(n.b));
                            default:
                                return "/deliverables";
                        }
                    }(n.a);
                case 7:
                    return "/channels" + ((i = n.a).$ ? "/" + i.a : "");
                case 8:
                    return "/webhooks" + function(n) {
                        switch(n.$){
                            case 0:
                                return "";
                            case 1:
                                return "/api";
                            case 2:
                                return "/api/" + n.a;
                            case 3:
                                return "/email";
                            default:
                                return "/email/" + n.a;
                        }
                    }(n.a);
                case 9:
                    return "/testplans" + function(n) {
                        switch(n.$){
                            case 0:
                                return "";
                            case 1:
                                return "/" + n.a;
                            default:
                                return "S3";
                        }
                    }(n.a);
                case 10:
                    return "/formats" + function(n) {
                        switch(n.$){
                            case 0:
                                return "";
                            case 1:
                                return "/" + n.a;
                            default:
                                return "/framerates";
                        }
                    }(n.a);
                case 11:
                    return "/subtitleFormats" + function(n) {
                        switch(n.$){
                            case 0:
                                return "";
                            case 1:
                                return "/" + n.a;
                            default:
                                return "/framerates";
                        }
                    }(n.a);
                case 12:
                    return "/users" + function(n) {
                        switch(n.$){
                            case 0:
                                return "/logout";
                            case 1:
                                return "/impersonate";
                            case 2:
                                return "";
                            case 3:
                                return "/" + n.a;
                            case 4:
                                return "/password";
                            case 5:
                                return "/switch";
                            default:
                                return "/invitation";
                        }
                    }(n.a);
                case 13:
                    return "/uploads";
                case 14:
                    return "/invitations" + ((a = n.a).$ ? "/" + a.a + "/sftp" : "/" + a.a);
                case 15:
                    return "/reports?start=" + (u = n.a).a + "&end=" + (u.b + Ns(A2(Ge, function(n) {
                        return "&organization=" + n;
                    }, u.c)));
                case 16:
                    return "/comments/" + (e = n.a).a + (e.b ? "/answers" : "");
                case 17:
                    return "/answers/answers/" + n.a;
                case 18:
                    return "/broadcastables/" + ((t = n.a).a + function(n) {
                        switch(n){
                            case 0:
                                return "/copyToShow";
                            case 1:
                                return "/copyToOrganization";
                            case 2:
                                return "/qualify";
                            case 3:
                                return "/comments";
                            default:
                                return "/audioMapping";
                        }
                    }(t.b));
                case 19:
                    return "/files" + (1 === (r = n.a).$ ? "/search?keyName=" + r.a : "/" + (r.a + function(n) {
                        switch(n){
                            case 0:
                                return "";
                            case 1:
                                return "/download";
                            case 2:
                                return "/pause";
                            case 3:
                                return "/markDelivery";
                            case 4:
                                return "/restartVerification";
                            case 5:
                                return "/restartProxyTranscode";
                            case 6:
                                return "/startProxyHiResTranscode";
                            case 7:
                                return "/uploads";
                            case 8:
                                return "/uploads/name";
                            case 9:
                                return "/uploads/progress";
                            case 10:
                                return "/uploads/s3Id";
                            case 11:
                                return "/uploads/error";
                            case 12:
                                return "/uploads/pause";
                            default:
                                return "/segments";
                        }
                    }(r.b)));
                case 20:
                    return "/dashboard";
                case 21:
                    return "/aws/copy";
                case 22:
                    return "/admin/ftp/copy";
                case 23:
                    return "/status";
                case 24:
                    return function(n) {
                        switch(n.$){
                            case 0:
                                return "/organizations/" + n.a + "/jobs";
                            case 1:
                                return "/jobs/" + n.a + "/start";
                            case 2:
                                return "/jobs/" + n.a + "/complete";
                            default:
                                return "/jobs/notcompleted";
                        }
                    }(n.a);
                case 25:
                    return "/admin" + function(n) {
                        switch(n.$){
                            case 0:
                                return "/files/" + n.a + "/probe";
                            case 1:
                                return "/analysis";
                            case 2:
                                return "/analysis/simple";
                            case 3:
                                return "/analysis/" + n.a;
                            case 4:
                                return "/analysis/tasks/organization/" + n.a;
                            default:
                                return "/analysis/tasks/show/" + n.a;
                        }
                    }(n.a);
                case 26:
                    return "/admin" + function(n) {
                        switch(n.$){
                            case 0:
                                return "/shows/path";
                            case 2:
                                return "/files/csv";
                            default:
                                return "/jobs/" + n.a + "/acknowledge";
                        }
                    }(n.a);
                default:
                    return "/segments/" + n.a;
            }
            var r, t, e, u, a, i, o;
        }(n.a);
    }, Vs = function(n) {
        return A2(zs, "GET", Hs(n));
    }, Us = F2(function(n, r) {
        return Ci(A2(po, mi(n), r));
    }), Js = "Une erreur est survenue. Merci de contacter notre service op\xe9rations via le chat ou par mail \xe0 ops@nomalab.com", Zs = F2(function(n, r) {
        var t = A2(Us, n, r);
        return t.$ ? jt({
            lz: Lu,
            nE: "Impossible de lire les donn\xe9es. " + Js,
            Q: 500
        }) : yt(t.a);
    }), Ks = F2(function(n, r) {
        return {
            eq: r.eq,
            aR: r.aR,
            cf: n,
            P: r.P,
            r6: r.r6
        };
    }), _s = A2(mu, Ks, Zs), Gs = wn, Ys = F2(function(n, r) {
        return A2(Xs, A2(mu, Gs, n), r);
    }), nl = Ys, rl = function(n) {
        return encodeURIComponent(n);
    }, tl = function(n) {
        return n.b;
    }, el = F3(function(n, r, t) {
        return {
            lz: t,
            nE: r,
            Q: n
        };
    }), ul = function(n) {
        var r = n;
        return {
            e: r.e,
            g: function(n) {
                return $i(r.g(n));
            }
        };
    }, al = F3(function(n, r, t) {
        var e = t;
        return {
            e: r(e.e),
            g: n(e.g)
        };
    }), il = function(n) {
        return A3(qt, F2(function(n, r) {
            return A3(ju, n.a, n.b, r);
        }), Lu, n);
    }, ol = function(n) {
        return A2(Fe, il, function(n) {
            return {
                $: 8,
                b: n
            };
        }(n));
    }, cl = F2(function(n, r) {
        if (-2 === r.$) return gu;
        var t = r.b, e = r.d, u = r.e;
        return A5($u, r.a, t, A2(n, t, r.c), A2(cl, n, e), A2(cl, n, u));
    }), fl = A2(al, function(n) {
        return A2(mu, A2(mu, $i, pt), cl(function() {
            return n;
        }));
    }, ol), sl = function(n) {
        return n.g;
    }, ll = F4(function(n, r, t, e) {
        var u = e;
        return {
            e: A3(Te, F2(function(n, r) {
                return n(r);
            }), u.e, A2(du, n, mi(t))),
            g: function(e) {
                return A2(bt, d(n, A2(sl, t, r(e))), u.g(e));
            }
        };
    }), dl = J, bl = hn, ml = A2(qi, bl, dl), pl = function(n) {
        return {
            $: 3,
            b: n
        };
    }, vl = F2(function(n, r) {
        return A3(qt, function(n) {
            return F2(function(r, t) {
                return t.push(n(r)), t;
            });
        }(n), [], r);
    }), $l = A2(al, vl, pl), gl = function(n) {
        return {
            e: Qe(n),
            g: function() {
                return g;
            }
        };
    }, hl = ul(A4(ll, "fields", function(n) {
        return n.lz;
    }, fl($l(Di)), A4(ll, "message", function(n) {
        return n.nE;
    }, Di, A4(ll, "status", function(n) {
        return n.Q;
    }, ml, gl(el))))), kl = ul(A4(ll, "message", function(n) {
        return n.nE;
    }, Di, gl(function(n) {
        return {
            nE: n
        };
    }))), Cl = ul(A4(ll, "error", function(n) {
        return n.ll;
    }, kl, gl(function(n) {
        return {
            ll: n
        };
    }))), jl = A2(tt, "", Be), wl = function(n) {
        return n.$ ? Gs(n.a) : Je(n.a);
    }, Al = function(n) {
        var r, t, e;
        return A2(nl, function(n) {
            return n;
        }, (r = {
            eq: n.eq,
            l0: g,
            aR: n.aR,
            ps: (e = n.cf, jl(function(n) {
                switch(n.$){
                    case 1:
                        return jt({
                            lz: Lu,
                            nE: "Timeout",
                            Q: 0
                        });
                    case 2:
                        return jt({
                            lz: Lu,
                            nE: "NetworkError",
                            Q: 0
                        });
                    case 0:
                        return jt({
                            lz: Lu,
                            nE: "BadUrl",
                            Q: 0
                        });
                    case 3:
                        var r = n.a, t = n.b, u = A2(Us, hl, t);
                        if (u.$) {
                            var a = A2(Us, kl, t);
                            if (a.$) {
                                var i = A2(Us, Cl, t);
                                return jt(i.$ ? {
                                    lz: Lu,
                                    nE: Js,
                                    Q: 500
                                } : {
                                    lz: Lu,
                                    nE: i.a.ll.nE,
                                    Q: r.bq
                                });
                            }
                            return jt({
                                lz: Lu,
                                nE: a.a.nE,
                                Q: r.bq
                            });
                        }
                        return jt(u.a);
                    default:
                        var o = n.b;
                        if (400 > (r = n.a).bq) return e(o);
                        var c = A2(Us, hl, o);
                        if (c.$) {
                            var f = A2(Us, kl, o);
                            if (f.$) {
                                var s = A2(Us, Cl, o);
                                return jt(s.$ ? {
                                    lz: Lu,
                                    nE: Js,
                                    Q: 500
                                } : {
                                    lz: Lu,
                                    nE: s.a.ll.nE,
                                    Q: r.bq
                                });
                            }
                            return jt({
                                lz: Lu,
                                nE: f.a.nE,
                                Q: r.bq
                            });
                        }
                        return jt(c.a);
                }
            })),
            dO: Ct,
            r6: $(n.r6, (t = n.P, wu(t) ? "" : A2(Ou, "?", A2(Wt, "&", A2(Ge, function(n) {
                return rl(n.a) + "=" + rl(n.b);
            }, t)))))
        }, A3(nt, 0, wl, {
            iH: !1,
            eq: r.eq,
            cX: r.ps,
            l0: r.l0,
            aR: r.aR,
            dO: r.dO,
            h2: Ct,
            r6: r.r6
        })));
    }, Ll = function(n) {
        return {
            $: 14,
            a: n
        };
    }, yl = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Sl = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Fl = function(n) {
        return {
            $: 12,
            a: n
        };
    }, Tl = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Ql = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Il = function(n) {
        return {
            $: 13,
            a: n
        };
    }, Bl = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Wl = function(n) {
        return {
            $: 15,
            a: n
        };
    }, Pl = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ml = function(n) {
        return {
            $: 6,
            a: n
        };
    }, ql = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Dl = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Xl = function(n) {
        return {
            $: 11,
            a: n
        };
    }, El = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Rl = function(n) {
        return {
            $: 5,
            a: n
        };
    }, xl = function(n) {
        switch(n){
            case "segmentation":
                return yt(0);
            case "deep_probe":
                return yt(1);
            default:
                return jt("can't handle this analyze job kind");
        }
    }, Ol = function(n) {
        return n ? "deep_probe" : "segmentation";
    }, zl = F2(function(n, r) {
        return {
            e: A2(we, function(n) {
                var t = r(n);
                return t.$ ? xo("unknown enum: " + n) : Qe(t.a);
            }, Bi),
            g: A2(mu, gi, n)
        };
    }), Nl = A2(zl, Ol, xl), Hl = F2(function(n) {
        return n;
    }), Vl = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Ul = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Jl = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r);
            if (1 === e.$) return A2(Vl, e.a, e.b);
            var u = e.a, a = e.c, i = n(e.b)(a);
            if (1 === i.$) {
                var o = i.a;
                return A2(Vl, u || o, i.b);
            }
            return o = i.a, A3(Ul, u || o, i.b, i.c);
        };
    }), Zl = Jl, Kl = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), _l = F4(function(n, r, t, e) {
        return {
            eE: r,
            j4: e,
            gC: t,
            pB: n
        };
    }), Gl = {
        $: 0
    }, Yl = F2(function(n, r) {
        return A2(Kl, Gl, A4(_l, n.pB, n.eE, r, n.al));
    }), nd = (oc = {
        $: 10
    }, function(n) {
        return i(qe(n.a), n.b8) ? A3(Ul, !1, 0, n) : A2(Vl, !1, A2(Yl, n, oc));
    }), rd = it, td = F5(function(n, r, t, e, u) {
        for(;;){
            var a = A3(rd, n, r, u.a);
            if (i(a, -1)) return A3(Ul, 0 > s(u.b8, r), 0, {
                eE: e,
                al: u.al,
                f: u.f,
                b8: r,
                pB: t,
                a: u.a
            });
            i(a, -2) ? (r += 1, t += 1, e = 1) : (r = a, e += 1);
        }
    }), ed = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r);
            if (1 === e.$) return A2(Vl, e.a, e.b);
            var u = e.b, a = e.c;
            return A3(Ul, e.a, A2(n, A3(De, r.b8, a.b8, r.a), u), a);
        };
    }), ud = function(n) {
        return A2(ed, Hl, n);
    }, ad = function(n) {
        return function(n) {
            return function(r) {
                return A2(Vl, !1, A2(Yl, r, n));
            };
        }({
            $: 12,
            a: n
        });
    }, id = function(n) {
        return function(r) {
            return A3(Ul, !1, n, r);
        };
    }, od = A2(Zl, function(n) {
        if (qe(n) > 9) return ad("Expected at most 9 digits, but got " + Bt(qe(n)));
        var r = _c("0." + n);
        return r.$ ? ad('Invalid float: "' + n + '"') : id(xc(1e3 * r.a));
    }, ud((pc = Vt, function(n) {
        return A5(td, pc, n.b8, n.pB, n.eE, n);
    }))), cd = Be, fd = F6(function(n, r, t, e, u, a) {
        return cd(n + 60 * r * 60000 + 60 * (t - a) * 1e3 + 1e3 * e + u);
    }), sd = F3(function(n, r, t) {
        var e = r, u = t;
        return function(r) {
            var t = e(r);
            if (1 === t.$) return A2(Vl, t.a, t.b);
            var a = t.a, i = t.b, o = u(t.c);
            if (1 === o.$) {
                var c = o.a;
                return A2(Vl, a || c, o.b);
            }
            c = o.a;
            var f = o.c;
            return A3(Ul, a || c, A2(n, i, o.b), f);
        };
    }), ld = F2(function(n, r) {
        return A3(sd, Hl, n, r);
    }), dd = ld, bd = F2(function(n, r) {
        return A3(sd, oe, n, r);
    }), md = bd, pd = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), vd = F3(function(n, r, t) {
        n: for(;;){
            if (t.b) {
                var e = t.b, u = (0, t.a)(n);
                if (u.$) {
                    var a;
                    if ((a = u).a) return a;
                    r = A2(pd, r, a.b), t = e;
                    continue n;
                }
                return u;
            }
            return A2(Vl, !1, r);
        }
    }), $d = function(n) {
        return function(r) {
            return A3(vd, r, Gl, n);
        };
    }, gd = function(n) {
        return {
            $: 1,
            a: n
        };
    }, hd = function(n) {
        return {
            $: 0,
            a: n
        };
    }, kd = {
        $: 11
    }, Cd = F2(function(n, r) {
        return function(t) {
            var e = A3(rd, n, t.b8, t.a);
            return i(e, -1) ? A2(Vl, !1, A2(Yl, t, r)) : i(e, -2) ? A3(Ul, !0, 0, {
                eE: 1,
                al: t.al,
                f: t.f,
                b8: t.b8 + 1,
                pB: t.pB + 1,
                a: t.a
            }) : A3(Ul, !0, 0, {
                eE: t.eE + 1,
                al: t.al,
                f: t.f,
                b8: e,
                pB: t.pB,
                a: t.a
            });
        };
    }), jd = function(n) {
        return A2(Cd, n, kd);
    }, wd = F4(function(n, r, t, e) {
        for(;;){
            var u = t(r)(e);
            if (u.$) return a = u.a, A2(Vl, n || a, u.b);
            var a = u.a, i = u.b, o = u.c;
            if (i.$) return A3(Ul, n || a, i.a, o);
            n = n || a, r = i.a, e = o;
        }
    }), Ad = F2(function(n, r) {
        return function(t) {
            return A4(wd, !1, n, r, t);
        };
    }), Ld = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r);
            if (e.$) return A2(Vl, e.a, e.b);
            var u = e.c;
            return A3(Ul, e.a, n(e.b), u);
        };
    }), yd = Ld, Sd = function(n) {
        return n.$ ? function(n) {
            return {
                $: 1,
                a: n
            };
        }(n.a) : function(n) {
            return {
                $: 0,
                a: n
            };
        }(n.a);
    }, Fd = F2(function(n, r) {
        return A2(Ad, n, function(n) {
            return A2(yd, Sd, r(n));
        });
    }), Td = function(n) {
        return A2(Fd, "", function(r) {
            if (i(qe(r), n)) {
                var t = Oe(r);
                return t.$ ? ad('Invalid integer: "' + r + '"') : A2(yd, gd, id(t.a));
            }
            return A2(yd, function(n) {
                return hd(A2(Ou, r, n));
            }, ud(jd(Vt)));
        });
    }, Qd = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Id = at, Bd = function(n) {
        return function(n) {
            var r = n.a, t = n.b, e = !Re(r);
            return function(n) {
                var u = A5(Id, r, n.b8, n.pB, n.eE, n.a), a = u.a, o = u.b, c = u.c;
                return i(a, -1) ? A2(Vl, !1, A2(Yl, n, t)) : A3(Ul, e, 0, {
                    eE: c,
                    al: n.al,
                    f: n.f,
                    b8: a,
                    pB: o,
                    a: n.a
                });
            };
        }(A2(Qd, n, {
            $: 8,
            a: n
        }));
    }, Wd = function(n) {
        return ad("Invalid day: " + Bt(n));
    }, Pd = function(n) {
        return !(A2(qa, 4, n) || !A2(qa, 100, n) && A2(qa, 400, n));
    }, Md = function(n) {
        var r = n - 1;
        return (r / 4 | 0) - (r / 100 | 0) + (r / 400 | 0);
    }, qd = function(n) {
        var r = n.a, t = n.b, e = n.c;
        if (0 > e) return Wd(e);
        var u = function(n) {
            var u = 31536e6 * (r - 1970), a = 864e5 * ((3 > t || !Pd(r) ? e - 1 : e) + (Md(r) - Md(1970)));
            return id(n + u + a);
        };
        switch(t){
            case 1:
                return e > 31 ? Wd(e) : u(0);
            case 2:
                return e > 29 || 29 === e && !Pd(r) ? Wd(e) : u(26784e5);
            case 3:
                return e > 31 ? Wd(e) : u(50976e5);
            case 4:
                return e > 30 ? Wd(e) : u(7776e6);
            case 5:
                return e > 31 ? Wd(e) : u(10368e6);
            case 6:
                return e > 30 ? Wd(e) : u(130464e5);
            case 7:
                return e > 31 ? Wd(e) : u(156384e5);
            case 8:
                return e > 31 ? Wd(e) : u(183168e5);
            case 9:
                return e > 30 ? Wd(e) : u(209952e5);
            case 10:
                return e > 31 ? Wd(e) : u(235872e5);
            case 11:
                return e > 30 ? Wd(e) : u(262656e5);
            case 12:
                return e > 31 ? Wd(e) : u(288576e5);
            default:
                return ad('Invalid month: "' + Bt(t) + '"');
        }
    }, Dd = A2(Zl, qd, A2(md, A2(md, A2(md, id(F3(function(n, r, t) {
        return b(n, r, t);
    })), Td(4)), $d(C([
        A2(md, A2(dd, id(Be), Bd("-")), Td(2)),
        Td(2)
    ]))), $d(C([
        A2(md, A2(dd, id(Be), Bd("-")), Td(2)),
        Td(2)
    ])))), Xd = (cc = F3(function(n, r, t) {
        return n * (60 * r) + t;
    }), A2(md, id(Be), $d(C([
        A2(yd, function() {
            return 0;
        }, Bd("Z")),
        A2(md, A2(md, A2(md, id(cc), $d(C([
            A2(yd, function() {
                return 1;
            }, Bd("+")),
            A2(yd, function() {
                return -1;
            }, Bd("-"))
        ]))), Td(2)), $d(C([
            A2(md, A2(dd, id(Be), Bd(":")), Td(2)),
            Td(2),
            id(0)
        ]))),
        A2(dd, id(0), nd)
    ])))), Ed = A2(Zl, function(n) {
        return $d(C([
            A2(md, A2(md, A2(md, A2(md, A2(md, A2(dd, id(fd(n)), Bd("T")), Td(2)), $d(C([
                A2(md, A2(dd, id(Be), Bd(":")), Td(2)),
                Td(2)
            ]))), $d(C([
                A2(md, A2(dd, id(Be), Bd(":")), Td(2)),
                Td(2)
            ]))), $d(C([
                A2(md, A2(dd, id(Be), Bd(".")), od),
                id(0)
            ]))), A2(dd, Xd, nd)),
            A2(dd, id(A6(fd, n, 0, 0, 0, 0, 0)), nd)
        ]));
    }, Dd), Rd = F3(function(n, r, t) {
        return {
            eE: r,
            gC: t,
            pB: n
        };
    }), xd = function(n) {
        return A3(Rd, n.pB, n.eE, n.gC);
    }, Od = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                return r;
            case 1:
                var t = n.b;
                n = n.a, r = A2(bt, t, r);
                continue n;
            default:
                var e = n.b;
                n = n.a, r = A2(Od, e, r);
                continue n;
        }
    }), zd = F2(function(n, r) {
        var t = n({
            eE: 1,
            al: g,
            f: 1,
            b8: 0,
            pB: 1,
            a: r
        });
        return t.$ ? jt(A2(Od, t.b, g)) : yt(t.b);
    }), Nd = F2(function(n, r) {
        var t = A2(zd, n, r);
        return t.$ ? jt(A2(Ge, xd, t.a)) : yt(t.a);
    }), Hd = function(n) {
        return A2(Nd, Ed, n);
    }, Vd = A2(Po, Hd, hi(Hl("Can't parse date"))), Ud = A2(we, function(n) {
        var r = Vd(n);
        return r.$ ? xo(r.a) : Qe(r.a);
    }, Bi), Jd = F2(function(n, r) {
        return se(n / r);
    }), Zd = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r + n;
            var e = t.a, u = t.b;
            if (0 > s(e.ht, r)) return r + e.b8;
            t = u;
        }
    }), Kd = F2(function(n, r) {
        var t = n.b;
        return A3(Zd, n.a, A2(Jd, r, 6e4), t);
    }), _d = function(n) {
        var r = A2(Jd, n, 1440) + 719468, t = (0 > r ? r - 146096 : r) / 146097 | 0, e = r - 146097 * t, u = (e - (e / 1460 | 0) + (e / 36524 | 0) - (e / 146096 | 0)) / 365 | 0, a = e - (365 * u + (u / 4 | 0) - (u / 100 | 0)), i = (5 * a + 2) / 153 | 0, o = i + (10 > i ? 3 : -9);
        return {
            eU: a - ((153 * i + 2) / 5 | 0) + 1,
            ga: o,
            ii: u + 400 * t + (o > 2 ? 0 : 1)
        };
    }, Gd = F2(function(n, r) {
        return _d(A2(Kd, n, r)).eU;
    }), Yd = F2(function(n, r) {
        return A2(qa, 24, A2(Jd, A2(Kd, n, r), 60));
    }), nb = F2(function(n, r) {
        return A2(qa, 1e3, r);
    }), rb = F2(function(n, r) {
        return A2(qa, 60, A2(Kd, n, r));
    }), tb = F2(function(n, r) {
        switch(_d(A2(Kd, n, r)).ga){
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            case 7:
                return 6;
            case 8:
                return 7;
            case 9:
                return 8;
            case 10:
                return 9;
            case 11:
                return 10;
            default:
                return 11;
        }
    }), eb = function(n) {
        return A2(Aa, n, "");
    }, ub = F3(function(n, r, t) {
        return n > 0 ? A3(ub, n >> 1, $(r, r), 1 & n ? $(t, r) : t) : t;
    }), ab = F2(function(n, r) {
        return A3(ub, n, r, "");
    }), ib = F3(function(n, r, t) {
        return $(A2(ab, n - qe(t), eb(r)), t);
    }), ob = F2(function(n, r) {
        return A3(ib, n, "0", Bt(r));
    }), cb = F2(function(n, r) {
        return A2(qa, 60, A2(Jd, r, 1e3));
    }), fb = F2(function(n, r) {
        return _d(A2(Kd, n, r)).ii;
    }), sb = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), lb = A2(sb, 0, g), db = function(n) {
        return A2(ob, 4, A2(fb, lb, n)) + "-" + A2(ob, 2, function(n) {
            switch(n){
                case 0:
                    return 1;
                case 1:
                    return 2;
                case 2:
                    return 3;
                case 3:
                    return 4;
                case 4:
                    return 5;
                case 5:
                    return 6;
                case 6:
                    return 7;
                case 7:
                    return 8;
                case 8:
                    return 9;
                case 9:
                    return 10;
                case 10:
                    return 11;
                default:
                    return 12;
            }
        }(A2(tb, lb, n))) + "-" + A2(ob, 2, A2(Gd, lb, n)) + "T" + A2(ob, 2, A2(Yd, lb, n)) + ":" + A2(ob, 2, A2(rb, lb, n)) + ":" + A2(ob, 2, A2(cb, lb, n)) + "." + A2(ob, 3, A2(nb, lb, n)) + "Z";
    }, bb = {
        e: Ud,
        g: function(n) {
            return gi(db(n));
        }
    }, mb = function(n) {
        switch(n){
            case "Request":
                return yt(0);
            case "Finish":
                return yt(1);
            default:
                return jt("not a Analyze kind");
        }
    }, pb = function(n) {
        return n ? "Finish" : "Request";
    }, vb = A2(zl, pb, mb), $b = function(n) {
        return {
            $: 11,
            g: n
        };
    }, gb = function(n) {
        return $b(C([
            A2(Fe, kt, n),
            Qe(Ct)
        ]));
    }, hb = function(n) {
        return {
            e: gb(mi(n)),
            g: function(r) {
                return 1 === r.$ ? pi : A2(sl, n, r.a);
            }
        };
    }, kb = F4(function(n, r, t, e) {
        var u = e;
        return {
            e: A3(Te, F2(function(n, r) {
                return n(r);
            }), u.e, gb(A2(du, n, mi(t)))),
            g: function(e) {
                return A2(bt, d(n, A2(sl, hb(t), r(e))), u.g(e));
            }
        };
    }), Cb = ul(A4(kb, "ruleName", function(n) {
        return n.dw;
    }, Di, A4(kb, "error", function(n) {
        return n.ll;
    }, Di, A4(kb, "fileName", function(n) {
        return n.c0;
    }, Di, A4(kb, "fileId", function(n) {
        return n.A;
    }, Di, A4(ll, "sourceName", function(n) {
        return n.dD;
    }, Di, A4(ll, "sourceId", function(n) {
        return n.hh;
    }, Di, A4(ll, "timestamp", function(n) {
        return n.h$;
    }, bb, A4(kb, "subtitle", function(n) {
        return n.hE;
    }, Di, A4(ll, "title", function(n) {
        return n.rB;
    }, Di, A4(ll, "analyzeKind", function(n) {
        return n.cy;
    }, Nl, A4(ll, "kind", function(n) {
        return n.c9;
    }, vb, A4(ll, "show", function(n) {
        return n.g9;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return {
                                                            cy: e,
                                                            ll: l,
                                                            A: f,
                                                            c0: s,
                                                            mj: n,
                                                            c9: t,
                                                            dw: d,
                                                            g9: r,
                                                            hh: o,
                                                            dD: c,
                                                            hE: a,
                                                            h$: i,
                                                            rB: u
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))), jb = F6(function(n, r, t, e, u, a) {
        return {
            mj: n,
            g9: r,
            dC: u,
            hE: e,
            h$: a,
            rB: t
        };
    }), wb = F6(function(n, r, t, e, u, a) {
        return {
            bB: a,
            k6: t,
            mj: n,
            nW: r,
            oz: e,
            gp: u
        };
    }), Ab = ul(A4(ll, "avatar", function(n) {
        return n.bB;
    }, Di, A4(kb, "organizationName", function(n) {
        return n.gp;
    }, Di, A4(kb, "organization", function(n) {
        return n.oz;
    }, Di, A4(ll, "email", function(n) {
        return n.k6;
    }, Di, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(wb)))))))), Lb = ul(A4(ll, "timestamp", function(n) {
        return n.h$;
    }, bb, A4(ll, "source", function(n) {
        return n.dC;
    }, Ab, A4(kb, "subtitle", function(n) {
        return n.hE;
    }, Di, A4(ll, "title", function(n) {
        return n.rB;
    }, Di, A4(ll, "show", function(n) {
        return n.g9;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(jb)))))))), yb = function(n) {
        var r = n;
        return {
            e: A2(we, function(n) {
                return A2(r.e, n, xo(n + "did not match"));
            }, A2(Oo, 0, Bi)),
            g: function(n) {
                return r.b4(n);
            }
        };
    }, Sb = F8(function(n, r, t, e, u, a, i, o) {
        return {
            mj: n,
            nE: i,
            g9: r,
            dC: a,
            hE: e,
            hZ: o,
            h$: u,
            rB: t
        };
    }), Fb = ul(A4(kb, "timecode", function(n) {
        return n.hZ;
    }, Di, A4(ll, "message", function(n) {
        return n.nE;
    }, Di, A4(ll, "source", function(n) {
        return n.dC;
    }, Ab, A4(ll, "timestamp", function(n) {
        return n.h$;
    }, bb, A4(kb, "subtitle", function(n) {
        return n.hE;
    }, Di, A4(ll, "title", function(n) {
        return n.rB;
    }, Di, A4(ll, "show", function(n) {
        return n.g9;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(Sb)))))))))), Tb = function(n) {
        return {
            e: function() {
                return Be;
            },
            b4: n
        };
    }, Qb = F7(function(n, r, t, e, u, a, i) {
        return {
            c1: i,
            mj: n,
            g9: r,
            dC: a,
            hE: e,
            h$: u,
            rB: t
        };
    }), Ib = ul(A4(ll, "fileName", function(n) {
        return n.c1;
    }, Di, A4(ll, "source", function(n) {
        return n.dC;
    }, Ab, A4(ll, "timestamp", function(n) {
        return n.h$;
    }, bb, A4(kb, "subtitle", function(n) {
        return n.hE;
    }, Di, A4(ll, "title", function(n) {
        return n.rB;
    }, Di, A4(ll, "show", function(n) {
        return n.g9;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(Qb))))))))), Bb = F8(function(n, r, t, e, u, a, i, o) {
        return {
            lA: i,
            c0: o,
            mj: n,
            g9: r,
            dC: u,
            hE: e,
            h$: a,
            rB: t
        };
    }), Wb = ul(A4(ll, "fileName", function(n) {
        return n.c0;
    }, Di, A4(ll, "file", function(n) {
        return n.lA;
    }, Di, A4(ll, "timestamp", function(n) {
        return n.h$;
    }, bb, A4(ll, "source", function(n) {
        return n.dC;
    }, Ab, A4(kb, "subtitle", function(n) {
        return n.hE;
    }, Di, A4(ll, "title", function(n) {
        return n.rB;
    }, Di, A4(ll, "show", function(n) {
        return n.g9;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(Bb)))))))))), Pb = F9(function(n, r, t, e, u, a, i, o, c) {
        return {
            c_: o,
            A: a,
            c$: c,
            c0: i,
            mj: n,
            g9: r,
            hE: e,
            h$: u,
            rB: t
        };
    }), Mb = ul(A4(ll, "fileKey", function(n) {
        return n.c$;
    }, Di, A4(ll, "fileBucket", function(n) {
        return n.c_;
    }, Di, A4(ll, "fileName", function(n) {
        return n.c0;
    }, Di, A4(ll, "fileId", function(n) {
        return n.A;
    }, Di, A4(ll, "timestamp", function(n) {
        return n.h$;
    }, bb, A4(kb, "subtitle", function(n) {
        return n.hE;
    }, Di, A4(ll, "title", function(n) {
        return n.rB;
    }, Di, A4(ll, "show", function(n) {
        return n.g9;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(Pb))))))))))), qb = function(n) {
        switch(n){
            case "Add":
                return yt(0);
            case "Remove":
                return yt(1);
            default:
                return yt(2);
        }
    }, Db = function(n) {
        switch(n){
            case 0:
                return "Add";
            case 1:
                return "Remove";
            default:
                return "NoChanges";
        }
    }, Xb = A2(zl, Db, qb), Eb = function(n) {
        switch(n){
            case "Add":
                return yt(0);
            case "Update":
                return yt(1);
            case "Delete":
                return yt(2);
            default:
                return jt("not a kind of inviatation");
        }
    }, Rb = function(n) {
        switch(n){
            case 0:
                return "Add";
            case 1:
                return "Update";
            default:
                return "Delete";
        }
    }, xb = A2(zl, Rb, Eb), Ob = function(n) {
        switch(n){
            case "Delivery":
                return yt(0);
            case "Master":
                return yt(1);
            default:
                return jt("not ShowKind");
        }
    }, zb = function(n) {
        return n ? "Master" : "Delivery";
    }, Nb = A2(zl, zb, Ob), Hb = ul(A4(kb, "expireAt", function(n) {
        return n.cY;
    }, bb, A4(ll, "upload", function(n) {
        return n.r$;
    }, Xb, A4(ll, "download", function(n) {
        return n.cT;
    }, Xb, A4(ll, "target", function(n) {
        return n.ru;
    }, Ab, A4(ll, "source", function(n) {
        return n.dC;
    }, Ab, A4(ll, "kind", function(n) {
        return n.c9;
    }, xb, A4(ll, "timestamp", function(n) {
        return n.h$;
    }, bb, A4(kb, "subtitle", function(n) {
        return n.hE;
    }, Di, A4(ll, "title", function(n) {
        return n.rB;
    }, Di, A4(ll, "showKind", function(n) {
        return n.qt;
    }, Nb, A4(ll, "show", function(n) {
        return n.g9;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return {
                                                        cT: f,
                                                        cY: l,
                                                        mj: n,
                                                        c9: i,
                                                        g9: r,
                                                        qt: t,
                                                        dC: o,
                                                        hE: u,
                                                        ru: c,
                                                        h$: a,
                                                        rB: e,
                                                        r$: s
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))), Vb = F7(function(n, r, t, e, u, a, i) {
        return {
            mj: n,
            c9: a,
            g9: r,
            dC: i,
            hE: e,
            h$: u,
            rB: t
        };
    }), Ub = function(n) {
        switch(n){
            case "Create":
                return yt(0);
            case "Accept":
                return yt(1);
            case "NewVersion":
                return yt(2);
            default:
                return jt("Not an event kind");
        }
    }, Jb = function(n) {
        switch(n){
            case 0:
                return "Create";
            case 1:
                return "Accept";
            default:
                return "NewVersion";
        }
    }, Zb = A2(zl, Jb, Ub), Kb = ul(A4(ll, "source", function(n) {
        return n.dC;
    }, Ab, A4(ll, "kind", function(n) {
        return n.c9;
    }, Zb, A4(ll, "timestamp", function(n) {
        return n.h$;
    }, bb, A4(kb, "subtitle", function(n) {
        return n.hE;
    }, Di, A4(ll, "title", function(n) {
        return n.rB;
    }, Di, A4(ll, "show", function(n) {
        return n.g9;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(Vb))))))))), _b = F6(function(n, r, t, e, u, a) {
        return {
            mj: n,
            g9: r,
            dC: u,
            hE: e,
            h$: a,
            rB: t
        };
    }), Gb = ul(A4(ll, "timestamp", function(n) {
        return n.h$;
    }, bb, A4(kb, "source", function(n) {
        return n.dC;
    }, Ab, A4(kb, "subtitle", function(n) {
        return n.hE;
    }, Di, A4(ll, "title", function(n) {
        return n.rB;
    }, Di, A4(ll, "show", function(n) {
        return n.g9;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(_b)))))))), Yb = F9(function(n, r, t, e, u, a, i, o, c) {
        return {
            ke: c,
            mj: n,
            fI: i,
            g7: o,
            g9: r,
            dC: u,
            hE: e,
            h$: a,
            rB: t
        };
    }), nm = ul(A4(ll, "createdAt", function(n) {
        return n.ke;
    }, bb, A4(ll, "sftpUser", function(n) {
        return n.g7;
    }, Di, A4(ll, "invitationId", function(n) {
        return n.fI;
    }, Di, A4(ll, "timestamp", function(n) {
        return n.h$;
    }, bb, A4(ll, "source", function(n) {
        return n.dC;
    }, Ab, A4(kb, "subtitle", function(n) {
        return n.hE;
    }, Di, A4(ll, "title", function(n) {
        return n.rB;
    }, Di, A4(ll, "show", function(n) {
        return n.g9;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(Yb))))))))))), rm = function(n) {
        switch(n){
            case "Request":
                return yt(0);
            case "Finish":
                return yt(1);
            default:
                return jt("not a Transcode kind");
        }
    }, tm = function(n) {
        return n ? "Finish" : "Request";
    }, em = A2(zl, tm, rm), um = function(n) {
        switch(n){
            case "deliverable":
            case "deliverable_subtitle":
                return yt(2);
            case "proxy_hi_res":
                return yt(1);
            case "proxy_low_res":
            case "proxy_audio":
            case "proxy_subtitle":
                return yt(0);
            case "copy":
                return yt(3);
            case "audio_merge":
                return yt(4);
            case "proxy_dcp":
                return yt(5);
            case "proxy_imf":
                return yt(6);
            default:
                return jt("can't handle this transcode job kind");
        }
    }, am = function(n) {
        switch(n){
            case 0:
                return "proxy";
            case 1:
                return "proxy_hi_res";
            case 2:
                return "deliverable";
            case 3:
                return "copy";
            case 4:
                return "audio_merge";
            case 5:
                return "proxy_dcp";
            default:
                return "proxy_imf";
        }
    }, im = A2(zl, am, um), om = {
        $: 12
    }, cm = {
        $: 11
    }, fm = {
        $: 0
    }, sm = {
        $: 7
    }, lm = {
        $: 10
    }, dm = {
        $: 9
    }, bm = {
        $: 5
    }, mm = {
        $: 8
    }, pm = {
        $: 2
    }, vm = {
        $: 3
    }, $m = {
        $: 4
    }, gm = {
        $: 1
    }, hm = {
        $: 6
    }, km = function(n) {
        switch(n){
            case "VD":
                return yt(fm);
            case "VO":
                return yt(gm);
            case "VI":
                return yt(pm);
            case "VIVD":
                return yt(vm);
            case "VIVO":
                return yt($m);
            case "VDVO":
                return yt(bm);
            case "VOAD":
                return yt(hm);
            case "VDAD":
                return yt(sm);
            case "VDVOAD":
                return yt(mm);
            case "VDVIVONLY":
                return yt(dm);
            case "VDVIMEVONLY":
                return yt(lm);
            case "NoSound":
                return yt(cm);
            case "AsMaster":
                return yt(om);
            default:
                return yt({
                    $: 13,
                    a: n
                });
        }
    }, Cm = function(n) {
        switch(n.$){
            case 1:
                return "VO";
            case 0:
                return "VD";
            case 2:
                return "VI";
            case 3:
                return "VIVD";
            case 4:
                return "VIVO";
            case 5:
                return "VDVO";
            case 6:
                return "VOAD";
            case 7:
                return "VDAD";
            case 8:
                return "VDVOAD";
            case 9:
                return "VDVIVONLY";
            case 10:
                return "VDVIMEVONLY";
            case 11:
                return "NoSound";
            case 12:
                return "AsMaster";
            default:
                return n.a;
        }
    }, jm = A2(zl, Cm, km), wm = ul(A4(ll, "transcodeKind", function(n) {
        return n.dS;
    }, im, A4(kb, "targetOrganization", function(n) {
        return n.dH;
    }, Di, A4(kb, "subtitlesFileName", function(n) {
        return n.aZ;
    }, Di, A4(kb, "mxfVersion", function(n) {
        return n.dg;
    }, jm, A4(kb, "mxfOut", function(n) {
        return n.df;
    }, Di, A4(kb, "mxfIn", function(n) {
        return n.de;
    }, Di, A4(kb, "error", function(n) {
        return n.ll;
    }, Di, A4(ll, "nbWarning", function(n) {
        return n.di;
    }, ml, A4(ll, "formatName", function(n) {
        return n.c4;
    }, Di, A4(ll, "fileName", function(n) {
        return n.c0;
    }, Di, A4(ll, "fileId", function(n) {
        return n.A;
    }, Di, A4(ll, "kind", function(n) {
        return n.c9;
    }, em, A4(ll, "timestamp", function(n) {
        return n.h$;
    }, bb, A4(kb, "subtitle", function(n) {
        return n.hE;
    }, Di, A4(ll, "title", function(n) {
        return n.rB;
    }, Di, A4(ll, "show", function(n) {
        return n.g9;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(m) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return {
                                                                            ll: s,
                                                                            A: i,
                                                                            c0: o,
                                                                            c4: c,
                                                                            mj: n,
                                                                            c9: a,
                                                                            de: l,
                                                                            df: d,
                                                                            dg: b,
                                                                            di: f,
                                                                            g9: r,
                                                                            hE: e,
                                                                            aZ: m,
                                                                            dH: p,
                                                                            h$: u,
                                                                            rB: t,
                                                                            dS: v
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))))), Am = F6(function(n, r, t, e, u, a) {
        return {
            mj: n,
            g9: r,
            dC: u,
            hE: e,
            h$: a,
            rB: t
        };
    }), Lm = ul(A4(ll, "timestamp", function(n) {
        return n.h$;
    }, bb, A4(ll, "source", function(n) {
        return n.dC;
    }, Ab, A4(kb, "subtitle", function(n) {
        return n.hE;
    }, Di, A4(ll, "title", function(n) {
        return n.rB;
    }, Di, A4(ll, "show", function(n) {
        return n.g9;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(Am)))))))), ym = F6(function(n, r, t, e, u, a) {
        return {
            mj: n,
            g9: r,
            dC: u,
            hE: e,
            h$: a,
            rB: t
        };
    }), Sm = ul(A4(ll, "timestamp", function(n) {
        return n.h$;
    }, bb, A4(ll, "source", function(n) {
        return n.dC;
    }, Ab, A4(kb, "subtitle", function(n) {
        return n.hE;
    }, Di, A4(ll, "title", function(n) {
        return n.rB;
    }, Di, A4(ll, "show", function(n) {
        return n.g9;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(ym)))))))), Fm = function(n) {
        switch(n){
            case "Start":
                return yt(0);
            case "Finish":
                return yt(1);
            default:
                return jt("not an Upload kind");
        }
    }, Tm = function(n) {
        return n ? "Finish" : "Start";
    }, Qm = A2(zl, Tm, Fm), Im = ul(A4(kb, "nbFiles", function(n) {
        return n.dh;
    }, ml, A4(kb, "error", function(n) {
        return n.ll;
    }, Di, A4(ll, "fileName", function(n) {
        return n.c0;
    }, Di, A4(ll, "fileId", function(n) {
        return n.A;
    }, Di, A4(ll, "kind", function(n) {
        return n.c9;
    }, Qm, A4(ll, "timestamp", function(n) {
        return n.h$;
    }, bb, A4(kb, "subtitle", function(n) {
        return n.hE;
    }, Di, A4(ll, "title", function(n) {
        return n.rB;
    }, Di, A4(ll, "show", function(n) {
        return n.g9;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return {
                                                ll: c,
                                                A: i,
                                                c0: o,
                                                mj: n,
                                                c9: a,
                                                dh: f,
                                                g9: r,
                                                hE: e,
                                                h$: u,
                                                rB: t
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))), Bm = F4(function(n, r, t, e) {
        var u = e;
        return {
            e: F2(function(r, e) {
                return i(r, n) ? t : A2(u.e, r, e);
            }),
            b4: u.b4(r(function(r) {
                return A2(vl, Be, A2(bt, gi(n), r));
            }))
        };
    }), Wm = F3(function(n, r, t) {
        return A3(Bm, n, F2(function(n, r) {
            return n(C([
                A2(sl, t, r)
            ]));
        }), A2(Fe, r, A2(Oo, 1, mi(t))));
    }), Pm = F9(function(n, r, t, e, u, a, i, o, c) {
        return {
            ll: c,
            A: a,
            c0: i,
            mj: n,
            bn: o,
            g9: r,
            hE: e,
            h$: u,
            rB: t
        };
    }), Mm = F2(function(n, r) {
        return {
            nY: n,
            ar: r
        };
    }), qm = ul(A4(ll, "nbWarnings", function(n) {
        return n.ar;
    }, ml, A4(ll, "nbErrors", function(n) {
        return n.nY;
    }, ml, gl(Mm)))), Dm = ul(A4(kb, "error", function(n) {
        return n.ll;
    }, Di, A4(kb, "result", function(n) {
        return n.bn;
    }, qm, A4(ll, "fileName", function(n) {
        return n.c0;
    }, Di, A4(ll, "fileId", function(n) {
        return n.A;
    }, Di, A4(ll, "timestamp", function(n) {
        return n.h$;
    }, bb, A4(kb, "subtitle", function(n) {
        return n.hE;
    }, Di, A4(ll, "title", function(n) {
        return n.rB;
    }, Di, A4(ll, "show", function(n) {
        return n.g9;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(Pm))))))))))), Xm = yb(A4(Wm, "Analyze", Ll, Cb, A4(Wm, "ProxyPlayed", Wl, Gb, A4(Wm, "Invitation", Il, Hb, A4(Wm, "Delete", Fl, Ib, A4(Wm, "Untrash", El, Lm, A4(Wm, "Trash", Dl, Lm, A4(Wm, "Unarchive", Xl, Sm, A4(Wm, "Archive", yl, Lb, A4(Wm, "Download", Tl, Wb, A4(Wm, "SftpLogin", Ml, nm, A4(Wm, "Upload", Rl, Im, A4(Wm, "Transcode", ql, wm, A4(Wm, "QualityCheck", Pl, Dm, A4(Wm, "Ingest", Ql, Mb, A4(Wm, "Comment", Sl, Fb, A4(Wm, "Lifecycle", Bl, Kb, Tb(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(m) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        switch(v.$){
                                                                            case 4:
                                                                                return n(v.a);
                                                                            case 3:
                                                                                return r(v.a);
                                                                            case 1:
                                                                                return t(v.a);
                                                                            case 0:
                                                                                return e(v.a);
                                                                            case 2:
                                                                                return u(v.a);
                                                                            case 5:
                                                                                return a(v.a);
                                                                            case 7:
                                                                                return o(v.a);
                                                                            case 6:
                                                                                return i(v.a);
                                                                            case 8:
                                                                                return c(v.a);
                                                                            case 11:
                                                                                return f(v.a);
                                                                            case 9:
                                                                                return s(v.a);
                                                                            case 10:
                                                                                return l(v.a);
                                                                            case 12:
                                                                                return d(v.a);
                                                                            case 13:
                                                                                return b(v.a);
                                                                            case 14:
                                                                                return p(v.a);
                                                                            default:
                                                                                return m(v.a);
                                                                        }
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))))))), Em = $l(Xm), Rm = Al(A2(_s, Em, Vs(Os))), xm = A2(eo, C([
        A2(Rs, Ds, Rm)
    ]), {
        ll: Ct,
        oI: 0,
        rA: Lu
    }), Om = function(n) {
        return {
            $: 0,
            a: n
        };
    }, zm = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Nm = xs(zm({
        $: 0
    })), Hm = F4(function(n, r, t, e) {
        return {
            bJ: r,
            gp: e,
            gW: n,
            g2: t
        };
    }), Vm = F6(function(n, r, t, e, u, a) {
        return {
            ke: t,
            bM: r,
            mj: n,
            nW: u,
            oB: e,
            hw: a
        };
    }), Um = function(n) {
        switch(n){
            case "active":
                return yt(0);
            case "archived":
                return yt(1);
            case "restoring":
                return yt(2);
            default:
                return jt("Unrecognized state: " + n);
        }
    }, Jm = function(n) {
        switch(n){
            case 0:
                return "active";
            case 1:
                return "archived";
            default:
                return "restoring";
        }
    }, Zm = A2(zl, Jm, Um), Km = ul(A4(ll, "state", function(n) {
        return n.hw;
    }, Zm, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "organizationId", function(n) {
        return n.oB;
    }, Di, A4(ll, "createdAt", function(n) {
        return n.ke;
    }, bb, A4(ll, "creator", function(n) {
        return n.bM;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(Vm)))))))), _m = function(n) {
        return yt("Own" === n ? 0 : 1);
    }, Gm = function(n) {
        return n ? "Invited" : "Own";
    }, Ym = A2(zl, Gm, _m), np = F2(function(n, r) {
        return {
            cW: r,
            dx: n
        };
    }), rp = F2(function(n, r) {
        return {
            cV: n,
            dB: r
        };
    }), tp = F6(function(n, r, t, e, u, a) {
        return {
            ke: t,
            bM: r,
            mj: n,
            nW: u,
            bo: e,
            hw: a
        };
    }), ep = ul(A4(ll, "state", function(n) {
        return n.hw;
    }, Zm, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "seasonId", function(n) {
        return n.bo;
    }, Di, A4(ll, "createdAt", function(n) {
        return n.ke;
    }, bb, A4(ll, "creator", function(n) {
        return n.bM;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(tp)))))))), up = function(n) {
        return A4(ll, "updatedAt", function(n) {
            return n.cu;
        }, bb, A4(ll, "updater", function(n) {
            return n.cv;
        }, Di, A4(ll, "createdAt", function(n) {
            return n.ke;
        }, bb, A4(ll, "creator", function(n) {
            return n.bM;
        }, Di, A4(ll, "id", function(n) {
            return n.mj;
        }, Di, gl(n))))));
    }, ap = A2(qi, Be, Qi), ip = ul(A4(ll, "trashed", function(n) {
        return n.h6;
    }, Zi, A4(ll, "parent", function(n) {
        return n.gs;
    }, Di, A4(ll, "state", function(n) {
        return n.hw;
    }, Zm, A4(ll, "kind", function(n) {
        return n.c9;
    }, Nb, A4(kb, "commandInfoXML", function(n) {
        return n.eG;
    }, ap, A4(ll, "accepted", function(n) {
        return n.il;
    }, Zi, A4(ll, "organization", function(n) {
        return n.oz;
    }, Di, A4(kb, "title2", function(n) {
        return n.rD;
    }, Di, A4(ll, "title1", function(n) {
        return n.rC;
    }, Di, up(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return {
                                                                il: c,
                                                                eG: f,
                                                                ke: t,
                                                                bM: r,
                                                                mj: n,
                                                                c9: s,
                                                                oz: o,
                                                                gs: d,
                                                                hw: l,
                                                                rC: a,
                                                                rD: i,
                                                                h6: b,
                                                                cu: u,
                                                                cv: e
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))), op = ul(A4(ll, "shows", function(n) {
        return n.dB;
    }, $l(ip), A4(ll, "episode", function(n) {
        return n.cV;
    }, ep, gl(rp)))), cp = F6(function(n, r, t, e, u, a) {
        return {
            a7: e,
            ke: t,
            bM: r,
            mj: n,
            nW: u,
            hw: a
        };
    }), fp = ul(A4(ll, "state", function(n) {
        return n.hw;
    }, Zm, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "collectionId", function(n) {
        return n.a7;
    }, Di, A4(ll, "createdAt", function(n) {
        return n.ke;
    }, bb, A4(ll, "creator", function(n) {
        return n.bM;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(cp)))))))), sp = ul(A4(ll, "episodes", function(n) {
        return n.cW;
    }, $l(op), A4(ll, "season", function(n) {
        return n.dx;
    }, fp, gl(np)))), lp = ul(A4(ll, "organizationName", function(n) {
        return n.gp;
    }, Di, A4(ll, "seasons", function(n) {
        return n.g2;
    }, $l(sp), A4(ll, "collection", function(n) {
        return n.bJ;
    }, Km, A4(ll, "role", function(n) {
        return n.gW;
    }, Ym, gl(Hm)))))), dp = $l(lp), bp = nu, mp = function(n) {
        var r = n.b;
        return A2(Ye, function(n) {
            return A2(nu, function(r) {
                return d(n, r);
            }, r);
        }, n.a);
    }, pp = function(n) {
        return {
            $: 0,
            a: n
        };
    }, vp = xs(pp({
        $: 0
    })), $p = F4(function(n, r, t, e) {
        return {
            gp: e,
            gW: n,
            dB: t,
            rW: r
        };
    }), gp = F6(function(n, r, t, e, u, a) {
        return {
            ke: t,
            bM: r,
            mj: n,
            nW: u,
            oB: e,
            hw: a
        };
    }), hp = ul(A4(ll, "state", function(n) {
        return n.hw;
    }, Zm, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "organizationId", function(n) {
        return n.oB;
    }, Di, A4(ll, "createdAt", function(n) {
        return n.ke;
    }, bb, A4(ll, "creator", function(n) {
        return n.bM;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(gp)))))))), kp = ul(A4(ll, "organizationName", function(n) {
        return n.gp;
    }, Di, A4(ll, "shows", function(n) {
        return n.dB;
    }, $l(ip), A4(ll, "unitary", function(n) {
        return n.rW;
    }, hp, A4(ll, "role", function(n) {
        return n.gW;
    }, Ym, gl($p)))))), Cp = $l(kp), jp = (fc = F2(function(n, r) {
        return Al(A2(_s, r, Vs(n)));
    }), sc = A2(bp, Ge(function(n) {
        return {
            $: 1,
            a: n
        };
    }), A2(fc, vp, Cp)), lc = function(n) {
        return $(n.a, n.b);
    }, dc = A2(bp, Ge(function(n) {
        return {
            $: 0,
            a: n
        };
    }), A2(fc, Nm, dp)), A2(Rs, Om, A2(bp, lc, mp(d(dc, sc))))), wp = Nn, Ap = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Lp = F2(function(n, r) {
        return r.$ ? Ct : n(r.a);
    }), yp = F5(function(n, r, t, e, u) {
        return {
            ao: e,
            oK: t,
            af: r,
            sa: u,
            az: n
        };
    }), Sp = function(n) {
        return n.b && ("" !== n.a || n.b.b) ? A2(bt, n.a, Sp(n.b)) : g;
    }, Fp = F2(function(n, r) {
        return kt(1 === r.$ ? C([
            n
        ]) : A2(bt, n, r.a));
    }), Tp = function(n) {
        try {
            return kt(decodeURIComponent(n));
        } catch (n) {
            return Ct;
        }
    }, Qp = F2(function(n, r) {
        var t = A2(Pt, "=", n);
        if (t.b && t.b.b && !t.b.b.b) {
            var e = t.b.a, u = Tp(t.a);
            if (1 === u.$) return r;
            var a = u.a, i = Tp(e);
            return 1 === i.$ ? r : A3(Wo, a, Fp(i.a), r);
        }
        return r;
    }), Ip = F2(function(n, r) {
        var t;
        return function(n) {
            n: for(;;){
                if (n.b) {
                    var r = n.a, t = r.af;
                    if (t.b) {
                        if ("" !== t.a || t.b.b) {
                            n = n.b;
                            continue n;
                        }
                        return kt(r.sa);
                    }
                    return kt(r.sa);
                }
                return Ct;
            }
        }(n(A5(yp, g, function(n) {
            var r = A2(Pt, "/", n);
            return Sp(r.b && "" === r.a ? r.b : r);
        }(r.gu), 1 === (t = r.ph).$ ? Lu : A3(_e, Qp, Lu, A2(Pt, "&", t.a)), r.fk, Be)));
    }), Bp = F3(function(n, r, t) {
        var e;
        return A2(Qu, t, A2(Lp, Ip(r), A2(Ue, "http://", e = "http://domain.co" + n) ? A2(Ve, 0, A2(Xe, 7, e)) : A2(Ue, "https://", e) ? A2(Ve, 1, A2(Xe, 8, e)) : Ct));
    }), Wp = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Pp = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Mp = {
        $: 6
    }, qp = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Dp = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), Xp = {
        $: 9
    }, Ep = {
        $: 8
    }, Rp = F3(function(n, r, t) {
        return {
            $: 1,
            a: n,
            b: r,
            c: t
        };
    }), xp = {
        $: 0
    }, Op = {
        $: 7
    }, zp = F2(function(n, r) {
        return A5(yp, r.az, r.af, r.oK, r.ao, n(r.sa));
    }), Np = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = r.az, u = r.af, a = r.oK, i = r.ao;
            return A2(Ge, zp(r.sa), t(A5(yp, e, u, a, i, n)));
        };
    }), Hp = function(n) {
        return function(r) {
            return A2(Gu, function(n) {
                return n(r);
            }, n);
        };
    }, Vp = F2(function(n, r) {
        var t = n, e = r;
        return function(n) {
            return A2(Gu, e, t(n));
        };
    }), Up = F2(function(n, r) {
        return A2(Vp, n, function(n) {
            var r = n;
            return function(n) {
                var t = n.oK;
                return C([
                    A5(yp, n.az, n.af, t, n.ao, (0, n.sa)(r(t)))
                ]);
            };
        }(r));
    }), Jp = {
        $: 1
    }, Zp = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Kp = function(n) {
        return {
            lV: n
        };
    }, _p = function(n) {
        return function(r) {
            var t = r.az, e = r.af, u = r.oK, a = r.ao, o = r.sa;
            if (e.b) {
                var c = e.a, f = e.b;
                return i(c, n) ? C([
                    A5(yp, A2(bt, c, t), f, u, a, o)
                ]) : g;
            }
            return g;
        };
    }, Gp = F2(function(n, r) {
        return function(t) {
            return r(A2(Qu, g, A2(Lo, n, t)));
        };
    }), Yp = function(n) {
        return A2(Gp, n, function(n) {
            return n.b && !n.b.b ? kt(n.a) : Ct;
        });
    }, nv = Hp(C([
        A2(Np, A2(mu, A2(mu, Zp, Kp), Lp(Tp)), A2(Up, _p("login"), Yp("from"))),
        A2(Np, Jp, _p("forgotPassword")),
        A2(Np, F2(function(n, r) {
            return {
                $: 2,
                a: {
                    k6: A2(Qu, "", n),
                    rH: A2(Qu, "", r)
                }
            };
        }), A2(Up, A2(Up, _p("resetPassword"), Yp("email")), Yp("token"))),
        A2(Np, F3(function(n, r, t) {
            return {
                $: 3,
                a: {
                    k6: A2(Qu, "", r),
                    pl: A2(Qu, "/", A2(Lp, Tp, n)),
                    rH: A2(Qu, "", t)
                }
            };
        }), A2(Up, A2(Up, A2(Up, _p("invitation"), Yp("redirect")), Yp("email")), Yp("token")))
    ])), rv = {
        $: 6
    }, tv = {
        $: 7
    }, ev = function(n) {
        return {
            $: 18,
            a: n
        };
    }, uv = {
        $: 16
    }, av = {
        $: 11
    }, iv = {
        $: 0
    }, ov = function(n) {
        return {
            $: 14,
            a: n
        };
    }, cv = {
        $: 15
    }, fv = {
        $: 2
    }, sv = {
        $: 10
    }, lv = {
        $: 1
    }, dv = {
        $: 17
    }, bv = {
        $: 8
    }, mv = {
        $: 13
    }, pv = {
        $: 12
    }, vv = {
        $: 5
    }, $v = {
        $: 4
    }, gv = {
        $: 3
    }, hv = {
        $: 9
    }, kv = function(n) {
        return {
            c9: n
        };
    }, Cv = Hp(C([
        A2(Np, function(n) {
            return kv(n);
        }, A2(Up, _p("dashboard"), Yp("kind")))
    ])), jv = F4(function(n, r, t, e) {
        return {
            C: e,
            c9: r,
            oz: n,
            Q: t
        };
    }), wv = F2(function(n, r) {
        return A2(Gp, n, function(n) {
            return n.b && !n.b.b ? A2(Lo, n.a, r) : Ct;
        });
    }), Av = Hp(C([
        A2(Np, F4(function(n, r, t, e) {
            return A4(jv, n, r, t, e);
        }), A2(Up, A2(Up, A2(Up, A2(Up, _p("jobs"), Yp("organization")), Yp("kind")), Yp("status")), A2(wv, "acknowledge", il(C([
            d("true", !0),
            d("false", !1)
        ])))))
    ])), Lv = function(n) {
        return C([
            n
        ]);
    }, yv = Hp(C([
        A2(Np, iv, Lv),
        A2(Np, lv, _p("adminOrganizations")),
        A2(Np, fv, _p("onboarding")),
        A2(Np, gv, _p("adminUsers")),
        A2(Np, $v, _p("adminUploads")),
        A2(Np, vv, _p("adminTestPlans")),
        A2(Np, rv, _p("adminAudioMappings")),
        A2(Np, tv, _p("adminChannels")),
        A2(Np, bv, _p("adminResearchs")),
        A2(Np, hv, _p("adminWebhooks")),
        A2(Np, sv, _p("adminOrganizationFileListings")),
        A2(Np, av, _p("adminFormats")),
        A2(Np, pv, _p("adminSubtitleFormats")),
        A2(Np, mv, _p("adminSegmentationRules")),
        A2(Np, ov, Av),
        A2(Np, cv, _p("metadata")),
        A2(Np, uv, _p("deepProbe")),
        A2(Np, dv, _p("probes")),
        A2(Np, ev, Cv)
    ])), Sv = Hp(C([
        A2(Np, 0, Lv),
        A2(Np, 1, _p("settings"))
    ])), Fv = Hp(C([
        A2(Np, 0, Lv),
        A2(Np, 1, _p("actions")),
        A2(Np, 2, _p("settings")),
        A2(Np, 3, _p("events")),
        A2(Np, 4, _p("verif")),
        A2(Np, 5, _p("comments"))
    ])), Tv = F2(function(n, r) {
        return function(n) {
            var t = n.az, e = n.af, u = n.oK, a = n.ao, i = n.sa;
            if (e.b) {
                var o = e.a, c = e.b, f = r(o);
                if (f.$) return g;
                var s = f.a;
                return C([
                    A5(yp, A2(bt, o, t), c, u, a, i(s))
                ]);
            }
            return g;
        };
    }), Qv = A2(Tv, "STRING", kt), Iv = Hp(C([
        A2(Np, xp, Lv),
        A2(Np, F4(function(n, r, t, e) {
            return A3(Rp, n, r, {
                bF: t,
                co: A2(Tu, Hl(!1), e)
            });
        }), A2(Vp, Hp(C([
            _p("show"),
            _p("master")
        ])), A2(Vp, Qv, A2(Up, A2(Up, Fv, Yp("broadcastable")), Yp("sortVerifByDate"))))),
        A2(Np, Dp, A2(Vp, _p("hierarchy"), A2(Vp, Qv, Sv))),
        A2(Np, Wp, A2(Vp, _p("account"), nv)),
        A2(Np, Pp, A2(Vp, _p("admin"), yv)),
        A2(Np, qp, A2(Vp, _p("help"), Qv)),
        A2(Np, Mp, _p("archive")),
        A2(Np, Ep, _p("settings")),
        A2(Np, Xp, _p("report")),
        A2(Np, Op, _p("upload")),
        A2(Np, Ap, A2(Vp, _p("notFound"), Qv))
    ])), Bv = function(n) {
        return A3(Bp, n, Iv, Ap(n));
    }, Wv = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Pv = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Mv = function(n) {
        switch(n){
            case 0:
                return "";
            case 1:
                return "/actions";
            case 2:
                return "/settings";
            case 3:
                return "/events";
            case 4:
                return "/verif";
            default:
                return "/comments";
        }
    }, qv = function(n) {
        return A3(Bp, n, Fv, 2);
    }, Dv = Jn("setPreference", function(n) {
        var r = n.b;
        return A2(vl, Be, C([
            gi(n.a),
            gi(r)
        ]));
    }), Xv = function(n) {
        var r = n.a, t = n.b, e = r.g9, u = r.al, a = u.bN, i = a.qj, o = e.iY, c = Mv(o);
        return o ? d(p(r, {
            al: p(u, {
                bN: p(a, {
                    qj: c
                })
            })
        }), to(C([
            t,
            Dv(d("showAside", c))
        ]))) : d(p(r, {
            g9: p(e, {
                iY: qv(i)
            })
        }), t);
    }, Ev = function(n) {
        var r = n.al.r6;
        switch(r.$){
            case 1:
            case 2:
                return kt(r.a);
            default:
                return Ct;
        }
    }, Rv = function(n) {
        return {
            $: 2,
            a: n
        };
    }, xv = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ov = function(n) {
        return {
            $: 4,
            a: n
        };
    }, zv = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Nv = function(n) {
        return Al(A2(_s, Em, Vs(function(n) {
            return xs(Ov(A2(zv, n, 7)));
        }(n))));
    }, Hv = F2(function(n, r) {
        return {
            bg: n,
            fJ: r
        };
    }), Vv = F9(function(n, r, t, e, u, a, i, o, c) {
        return {
            ke: t,
            bM: r,
            mj: n,
            c9: i,
            nW: e,
            oz: u,
            gs: a,
            hw: o,
            h6: c
        };
    }), Uv = function(n) {
        switch(n){
            case "Collection":
                return yt(0);
            case "Season":
                return yt(2);
            case "Episode":
                return yt(3);
            default:
                return yt(1);
        }
    }, Jv = function(n) {
        switch(n){
            case 0:
                return "Collection";
            case 1:
                return "Unitary";
            case 2:
                return "Season";
            default:
                return "Episode";
        }
    }, Zv = A2(zl, Jv, Uv), Kv = ul(A4(ll, "trashed", function(n) {
        return n.h6;
    }, Zi, A4(ll, "state", function(n) {
        return n.hw;
    }, Zm, A4(ll, "kind", function(n) {
        return n.c9;
    }, Zv, A4(kb, "parent", function(n) {
        return n.gs;
    }, Di, A4(ll, "organization", function(n) {
        return n.oz;
    }, Di, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "createdAt", function(n) {
        return n.ke;
    }, bb, A4(ll, "creator", function(n) {
        return n.bM;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(Vv))))))))))), _v = F2(function(n, r) {
        return {
            fH: r,
            r8: n
        };
    }), Gv = F8(function(n, r, t, e, u, a, i, o) {
        return {
            cT: e,
            cY: u,
            mj: n,
            c9: i,
            qs: o,
            hj: a,
            r$: t,
            r8: r
        };
    }), Yv = function(n) {
        switch(n){
            case "Collection":
                return yt(0);
            case "Season":
                return yt(2);
            case "Episode":
                return yt(3);
            default:
                return yt(1);
        }
    }, n$ = function(n) {
        switch(n){
            case 0:
                return "Collection";
            case 1:
                return "Unitary";
            case 2:
                return "Season";
            default:
                return "Episode";
        }
    }, r$ = A2(zl, n$, Yv), t$ = ul(A4(kb, "showId", function(n) {
        return n.qs;
    }, Di, A4(kb, "kind", function(n) {
        return n.c9;
    }, r$, A4(kb, "sourceNodeId", function(n) {
        return n.hj;
    }, Di, A4(kb, "expireAt", function(n) {
        return n.cY;
    }, bb, A4(ll, "download", function(n) {
        return n.cT;
    }, Zi, A4(ll, "upload", function(n) {
        return n.r$;
    }, Zi, A4(ll, "user", function(n) {
        return n.r8;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(Gv)))))))))), e$ = F9(function(n, r, t, e, u, a, i, o, c) {
        return {
            iz: i,
            bB: e,
            ke: c,
            kN: o,
            k6: t,
            mj: n,
            nW: r,
            oz: u,
            oD: a
        };
    }), u$ = F3(function(n, r, t) {
        return {
            nh: t,
            oB: n,
            gp: r
        };
    }), a$ = ul(A4(kb, "logo", function(n) {
        return n.nh;
    }, Di, A4(ll, "organizationName", function(n) {
        return n.gp;
    }, Di, A4(ll, "organizationId", function(n) {
        return n.oB;
    }, Di, gl(u$))))), i$ = ul(A4(kb, "createdAt", function(n) {
        return n.ke;
    }, bb, A4(ll, "disableOrganizationEmails", function(n) {
        return n.kN;
    }, Zi, A4(ll, "admin", function(n) {
        return n.iz;
    }, Zi, A4(ll, "organizations", function(n) {
        return n.oD;
    }, $l(a$), A4(kb, "organization", function(n) {
        return n.oz;
    }, Di, A4(ll, "avatar", function(n) {
        return n.bB;
    }, Di, A4(ll, "email", function(n) {
        return n.k6;
    }, Di, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(e$))))))))))), o$ = ul(A4(ll, "invitation", function(n) {
        return n.fH;
    }, t$, A4(ll, "user", function(n) {
        return n.r8;
    }, i$, gl(_v)))), c$ = ul(A4(ll, "invitations", function(n) {
        return n.fJ;
    }, $l(o$), A4(ll, "node", function(n) {
        return n.bg;
    }, Kv, gl(Hv)))), f$ = function(n) {
        return Al(A2(_s, c$, Vs(function(n) {
            return xs(Ov(A2(zv, n, 0)));
        }(n))));
    }, s$ = function(n) {
        return to(C([
            A2(Rs, xv, f$(n)),
            A2(Rs, Rv, Nv(n))
        ]));
    }, l$ = {
        $: 1
    }, d$ = (bc = cd, An(function(n) {
        n(jn(bc(Date.now())));
    })), b$ = su, m$ = A2(b$, Hl(l$), d$), p$ = to(g), v$ = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return g;
            var e = t.a, u = t.b, a = e.eL;
            if (a.$) {
                if (i(e.mj, n)) return A2(bt, e.mj, r);
                t = u;
            } else {
                var o = a.b, c = A3(v$, n, A2(bt, e.mj, r), o);
                if (c.b) return c;
                t = u;
            }
        }
    }), $$ = function(n) {
        var r = n.qb;
        return r.$ ? n : p(n, {
            op: A3(qt, Dc, n.op, A3(v$, r.a, g, $(n.jI, n.fJ)))
        });
    }, g$ = F2(function(n, r) {
        return $$(p(r, {
            px: !0,
            qb: kt(n)
        }));
    }), h$ = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), k$ = function(n) {
        return A2(h$, n, !1);
    }, C$ = {
        cz: g,
        kL: Ct,
        ll: Ct,
        oD: Lu,
        ph: Xi(function(n) {
            return p(n, {
                gy: "Search Audio Mapping by Organization, Name or Tracks",
                sa: ""
            });
        }),
        re: Ct,
        rs: k$("Organization")
    }, j$ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, w$ = F6(function(n, r, t, e, u, a) {
        return {
            mj: n,
            mH: u,
            mJ: a,
            nW: t,
            oz: r,
            rL: e
        };
    }), A$ = F3(function(n, r, t) {
        return {
            m3: n,
            rQ: r,
            sd: t
        };
    }), L$ = {
        lz: Lu,
        c9: 0,
        nE: "",
        as: pi,
        O: !1,
        Q: 400,
        ah: !1
    }, y$ = function(n) {
        switch(n){
            case "Stereo":
                return yt(0);
            case "OneTrackStereo":
                return yt(1);
            case "OneTrack5.1":
                return yt(2);
            case "OneTrack7.1":
                return yt(3);
            case "5.1SMPTE(L/R/C/LFE/SL/SR)":
                return yt(4);
            case "5.1ISO(L/R/SL/SR/C/LFE)":
                return yt(5);
            default:
                return jt(A2(ki, "Unknown output layout", L$));
        }
    }, S$ = function(n) {
        switch(n){
            case 0:
                return "Stereo";
            case 1:
                return "OneTrackStereo";
            case 2:
                return "OneTrack5.1";
            case 3:
                return "OneTrack7.1";
            case 4:
                return "5.1SMPTE(L/R/C/LFE/SL/SR)";
            default:
                return "5.1ISO(L/R/SL/SR/C/LFE)";
        }
    }, F$ = A2(zl, S$, y$), T$ = function(n) {
        switch(n){
            case "Original":
                return yt(0);
            case "Dubbed":
                return yt(1);
            case "AudioDescription":
                return yt(2);
            case "International":
                return yt(3);
            case "VoiceOnly":
                return yt(4);
            case "Silence":
                return yt(5);
            case "MusicAndEffects":
                return yt(6);
            case "Custom1":
                return yt(7);
            case "Custom2":
                return yt(8);
            case "Custom3":
                return yt(9);
            case "Custom4":
                return yt(10);
            case "Custom5":
                return yt(11);
            case "Custom6":
                return yt(12);
            case "Custom7":
                return yt(13);
            case "Custom8":
                return yt(14);
            case "Custom9":
                return yt(15);
            case "Custom10":
                return yt(16);
            default:
                return jt(A2(ki, "Unknown output type version", L$));
        }
    }, Q$ = function(n) {
        switch(n){
            case 0:
                return "Original";
            case 1:
                return "Dubbed";
            case 2:
                return "AudioDescription";
            case 3:
                return "International";
            case 4:
                return "VoiceOnly";
            case 5:
                return "Silence";
            case 6:
                return "MusicAndEffects";
            case 7:
                return "Custom1";
            case 8:
                return "Custom2";
            case 9:
                return "Custom3";
            case 10:
                return "Custom4";
            case 11:
                return "Custom5";
            case 12:
                return "Custom6";
            case 13:
                return "Custom7";
            case 14:
                return "Custom8";
            case 15:
                return "Custom9";
            default:
                return "Custom10";
        }
    }, I$ = A2(zl, Q$, T$), B$ = function(n) {
        switch(n){
            case "ARA":
                return yt(0);
            case "BUL":
                return yt(1);
            case "CHI":
                return yt(2);
            case "CZE":
                return yt(3);
            case "KOR":
                return yt(4);
            case "DAN":
                return yt(5);
            case "DUT":
                return yt(6);
            case "GRE":
                return yt(9);
            case "HEB":
                return yt(7);
            case "HIN":
                return yt(8);
            case "NLD":
                return yt(10);
            case "RUS":
                return yt(11);
            case "SWE":
                return yt(14);
            case "SLV":
                return yt(12);
            case "SRP":
                return yt(13);
            case "TAM":
                return yt(15);
            case "THA":
                return yt(16);
            case "FRA":
                return yt(17);
            case "FRE_CA":
                return yt(18);
            case "GER":
                return yt(19);
            case "ITA":
                return yt(20);
            case "POR":
                return yt(21);
            case "ENG":
                return yt(22);
            case "SPA":
                return yt(23);
            case "JPN":
                return yt(24);
            case "NOR":
                return yt(25);
            case "UKR":
                return yt(26);
            case "FIN":
                return yt(27);
            case "ESP":
                return yt(28);
            case "POR_BR":
                return yt(29);
            case "RON":
                return yt(30);
            case "HRV":
                return yt(31);
            case "GLA":
                return yt(32);
            case "HUN":
                return yt(33);
            case "IND":
                return yt(34);
            case "TUR":
                return yt(35);
            case "POL":
                return yt(36);
            case "INT":
                return yt(37);
            case "NOTHING":
                return yt(38);
            default:
                return jt("Not a version");
        }
    }, W$ = function(n) {
        switch(n){
            case 0:
                return "ARA";
            case 1:
                return "BUL";
            case 2:
                return "CHI";
            case 3:
                return "CZE";
            case 4:
                return "KOR";
            case 5:
                return "DAN";
            case 6:
                return "DUT";
            case 9:
                return "GRE";
            case 7:
                return "HEB";
            case 8:
                return "HIN";
            case 10:
                return "NLD";
            case 11:
                return "RUS";
            case 12:
                return "SLV";
            case 13:
                return "SRP";
            case 14:
                return "SWE";
            case 15:
                return "TAM";
            case 16:
                return "THA";
            case 17:
                return "FRA";
            case 18:
                return "FRE_CA";
            case 19:
                return "GER";
            case 20:
                return "ITA";
            case 21:
                return "POR";
            case 22:
                return "ENG";
            case 23:
                return "SPA";
            case 24:
                return "JPN";
            case 25:
                return "NOR";
            case 26:
                return "UKR";
            case 27:
                return "FIN";
            case 28:
                return "ESP";
            case 29:
                return "POR_BR";
            case 30:
                return "RON";
            case 31:
                return "HRV";
            case 32:
                return "GLA";
            case 33:
                return "HUN";
            case 34:
                return "IND";
            case 35:
                return "TUR";
            case 36:
                return "POL";
            case 37:
                return "INT";
            default:
                return "";
        }
    }, P$ = A2(zl, W$, B$), M$ = ul(A4(ll, "version", function(n) {
        return n.sd;
    }, hb(P$), A4(ll, "typeVersion", function(n) {
        return n.rQ;
    }, I$, A4(ll, "layout", function(n) {
        return n.m3;
    }, F$, gl(A$))))), q$ = ul(A4(ll, "isExtraDefault", function(n) {
        return n.mJ;
    }, Zi, A4(ll, "isDefault", function(n) {
        return n.mH;
    }, Zi, A4(ll, "tracks", function(n) {
        return n.rL;
    }, $l(M$), A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "organization", function(n) {
        return n.oz;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(w$)))))))), D$ = $l(q$), X$ = function(n) {
        return {
            $: 1,
            a: n
        };
    }, E$ = function(n) {
        return {
            $: 6,
            a: n
        };
    }, R$ = X$(E$({
        $: 0
    })), x$ = Al(A2(_s, D$, Vs(R$))), O$ = function(n) {
        switch(n){
            case "CanalPlus":
                return yt(0);
            case "CanalPlusPub":
                return yt(1);
            case "Lagardere":
                return yt(2);
            case "M6":
                return yt(3);
            case "M6Pub":
                return yt(4);
            case "M6PubDigital":
                return yt(5);
            case "Salto":
                return yt(6);
            case "FranceTV":
                return yt(7);
            case "AmauryMediaPub":
                return yt(8);
            case "Ligue1PlusPub":
                return yt(9);
            case "MediawanPub":
                return yt(10);
            case "MediawanLigue1PlusPub":
                return yt(11);
            case "Tf1Pub":
                return yt(12);
            case "RmcBfmPub":
                return yt(13);
            case "RmcBfmPubTV":
                return yt(14);
            case "Novo19":
                return yt(15);
            case "GameOnePub":
                return yt(16);
            case "ParamountPub":
                return yt(17);
            case "BeinSportPub":
                return yt(18);
            case "FTVPub":
                return yt(19);
            case "ETF1":
                return yt(20);
            default:
                return jt(A2(ki, "Unknown broadcaster", L$));
        }
    }, z$ = function(n) {
        switch(n){
            case 0:
                return "CanalPlus";
            case 1:
                return "CanalPlusPub";
            case 2:
                return "Lagardere";
            case 3:
                return "M6";
            case 4:
                return "M6Pub";
            case 5:
                return "M6PubDigital";
            case 6:
                return "Salto";
            case 7:
                return "FranceTV";
            case 8:
                return "AmauryMediaPub";
            case 9:
                return "Ligue1PlusPub";
            case 10:
                return "MediawanPub";
            case 11:
                return "MediawanLigue1PlusPub";
            case 12:
                return "Tf1Pub";
            case 13:
                return "RmcBfmPub";
            case 14:
                return "RmcBfmPubTV";
            case 15:
                return "Novo19";
            case 16:
                return "GameOnePub";
            case 17:
                return "ParamountPub";
            case 18:
                return "BeinSportPub";
            case 19:
                return "FTVPub";
            default:
                return "ETF1";
        }
    }, N$ = A2(zl, z$, O$), H$ = F2(function(n, r) {
        return {
            mj: n,
            mH: r
        };
    }), V$ = ul(A4(ll, "isDefault", function(n) {
        return n.mH;
    }, Zi, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(H$)))), U$ = ul(A4(ll, "autoDeleteShows", function(n) {
        return n.cA;
    }, Zi, A4(ll, "staticIp", function(n) {
        return n.dE;
    }, Zi, A4(ll, "adNomalabDest", function(n) {
        return n.iv;
    }, Zi, A4(ll, "isAdvertiser", function(n) {
        return n.mF;
    }, Zi, A4(ll, "segmentationRules", function(n) {
        return n.dy;
    }, $l(Di), A4(ll, "extraFormats", function(n) {
        return n.fc;
    }, $l(V$), A4(ll, "subtitleFormats", function(n) {
        return n.dF;
    }, $l(Di), A4(ll, "formats", function(n) {
        return n.c5;
    }, $l(V$), A4(kb, "logo", function(n) {
        return n.nh;
    }, Di, A4(ll, "replication", function(n) {
        return n.pp;
    }, Zi, A4(ll, "allowDeliveryWithoutTranscoding", function(n) {
        return n.iI;
    }, Zi, A4(ll, "manualDelivery", function(n) {
        return n.nA;
    }, Zi, A4(kb, "broadcaster", function(n) {
        return n.jq;
    }, N$, A4(ll, "enableAutoReject", function(n) {
        return n.la;
    }, Zi, A4(ll, "enableAutoAccept", function(n) {
        return n.k8;
    }, Zi, A4(ll, "enableUploadSuccessEmail", function(n) {
        return n.ld;
    }, Zi, A4(ll, "enableVideoReadyEmail", function(n) {
        return n.le;
    }, Zi, A4(ll, "enableCreationEmail", function(n) {
        return n.lb;
    }, Zi, A4(kb, "downloadFileName", function(n) {
        return n.kV;
    }, Di, A4(kb, "destination", function(n) {
        return n.kK;
    }, Di, A4(ll, "qcMasterReportTemplate", function(n) {
        return n.pa;
    }, Di, A4(ll, "qcMasterTestPlan", function(n) {
        return n.pb;
    }, Di, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "createdAt", function(n) {
        return n.ke;
    }, bb, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(m) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return function($) {
                                                                            return function(g) {
                                                                                return function(h) {
                                                                                    return function(k) {
                                                                                        return function(C) {
                                                                                            return function(j) {
                                                                                                return function(w) {
                                                                                                    return function(A) {
                                                                                                        return {
                                                                                                            iv: j,
                                                                                                            iI: m,
                                                                                                            cA: A,
                                                                                                            jq: d,
                                                                                                            ke: r,
                                                                                                            kK: a,
                                                                                                            kV: i,
                                                                                                            k8: s,
                                                                                                            la: l,
                                                                                                            lb: o,
                                                                                                            ld: f,
                                                                                                            le: c,
                                                                                                            fc: h,
                                                                                                            c5: $,
                                                                                                            mj: n,
                                                                                                            mF: C,
                                                                                                            nh: v,
                                                                                                            nA: b,
                                                                                                            nW: t,
                                                                                                            pa: u,
                                                                                                            pb: e,
                                                                                                            pp: p,
                                                                                                            dy: k,
                                                                                                            dE: w,
                                                                                                            dF: g
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))))))))))))), J$ = $l(U$), Z$ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, K$ = X$(Z$({
        $: 1
    })), _$ = A2(bp, il, A2(bp, Ge(function(n) {
        return d(n.mj, n);
    }), Al(A2(_s, J$, Vs(K$))))), G$ = A2(Rs, j$, mp(d(x$, _$))), Y$ = d(C$, G$), ng = F2(function(n, r) {
        return d(n, r);
    }), rg = F2(function(n, r) {
        return function(t) {
            var e = b(Xi(function(n) {
                return p(n, {
                    m$: "Layout",
                    sa: S$(r.m3)
                });
            }), Xi(function(n) {
                return p(n, {
                    m$: "TypeVersion",
                    sa: Q$(r.rQ)
                });
            }), Xi(function(n) {
                var t;
                return p(n, {
                    m$: "Version",
                    sa: (t = r.sd, t.$ ? n.sa : W$(t.a))
                });
            }));
            return p(t, {
                mj: n,
                p4: e.a,
                p5: e.b,
                p6: e.c
            });
        }({
            mj: 0,
            p4: Xi(Be),
            p5: Xi(Be),
            p6: Xi(Be)
        });
    }), tg = function(n) {
        var r = function(n) {
            return A2(Po, Tu(n), Qu(""));
        };
        return {
            mH: Ki(function(r) {
                return p(r, {
                    m$: "Set default",
                    sa: A2(Qu, !1, A2(Tu, function(n) {
                        return n.mH;
                    }, n))
                });
            }),
            mJ: Ki(function(r) {
                return p(r, {
                    m$: "Set extra default",
                    sa: A2(Qu, !1, A2(Tu, function(n) {
                        return n.mJ;
                    }, n))
                });
            }),
            nW: Xi(function(t) {
                return p(t, {
                    m$: "Name",
                    sa: A2(r, function(n) {
                        return n.nW;
                    }, n)
                });
            }),
            oz: Xi(function(t) {
                return p(t, {
                    m$: "Organization",
                    sa: A2(r, function(n) {
                        return n.oz;
                    }, n)
                });
            }),
            oF: n,
            rL: n.$ ? Lu : A2(cl, rg, il(A2(Ot, ng, n.a.rL)))
        };
    }, eg = F2(function(n, r) {
        return p(r, {
            ll: kt(n.nE),
            re: Ct
        });
    }), ug = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.e, u = n, a = A3(n, t.b, t.c, A3(ug, n, r, t.d));
            n = u, r = a, t = e;
        }
    }), ag = F2(function(n, r) {
        return A3(ug, F3(function(r, t, e) {
            return A2(n, r, t) ? A3(ju, r, t, e) : e;
        }), Lu, r);
    }), ig = function(n) {
        return n.b ? kt(A3(qt, de, n.a, n.b)) : Ct;
    }, og = function(n) {
        return {
            $: 8,
            a: n
        };
    }, cg = ul(A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(function(n) {
        return {
            mj: n
        };
    }))), fg = F5(function(n, r, t, e, u) {
        return {
            mH: e,
            mJ: u,
            nW: r,
            oz: n,
            rL: t
        };
    }), sg = ul(A4(ll, "isExtraDefault", function(n) {
        return n.mJ;
    }, Zi, A4(ll, "isDefault", function(n) {
        return n.mH;
    }, Zi, A4(ll, "tracks", function(n) {
        return n.rL;
    }, $l(M$), A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "organization", function(n) {
        return n.oz;
    }, Di, gl(fg))))))), lg = function(n) {
        return {
            lz: Lu,
            c9: 0,
            nE: n,
            as: pi,
            O: !1,
            Q: 400,
            ah: !1
        };
    }, dg = F2(function(n, r) {
        return r.$ ? jt(r.a) : yt(n(r.a));
    }), bg = F4(function(n, r, t, e) {
        if (1 === r.$) return jt(r.a);
        var u = r.a;
        if (1 === t.$) return jt(t.a);
        var a = t.a;
        return 1 === e.$ ? jt(e.a) : yt(A3(n, u, a, e.a));
    }), mg = F2(function(n, r) {
        return A2(bu, function(r) {
            return i(r, n);
        }, r);
    }), pg = function(n) {
        return A2(Ii, g, A3(_e, F2(function(n, r) {
            var t = d(n, r);
            return t.b.$ ? jt(t.b.a) : t.a.$ ? jt(t.a.a) : yt(A2(bt, t.a.a, t.b.a));
        }), yt(g), A2(Ge, function(n) {
            var r = n.b;
            return A4(bg, A$, y$(r.p4.sa), T$(r.p5.sa), A2(mg, r.p5.sa, C([
                "Original",
                "Dubbed",
                "AudioDescription"
            ])) && "" !== r.p6.sa ? A2(hi, lg, A2(dg, kt, B$(r.p6.sa))) : yt(Ct));
        }, pt(n))));
    }, vg = A2(mu, Ks, Zs), $g = function(n) {
        return A2(zs, "POST", Hs(n));
    }, gg = function(n) {
        return sl(n);
    }, hg = F2(function(n, r) {
        return p(r, {
            eq: n
        });
    }), kg = F2(function(n, r) {
        return hg(A2(ut, "application/json", A2(It, 0, A2(gg, n, r))));
    }), Cg = function(n) {
        var r;
        return A2(Rs, og, Al(A2(vg, cg, A3(kg, sg, {
            mH: (r = n).mH.sa,
            mJ: r.mJ.sa,
            nW: r.nW.sa,
            oz: r.oz.sa,
            rL: pg(r.rL)
        }, $g(R$)))));
    }, jg = function(n) {
        return {
            $: 11,
            a: n
        };
    }, wg = function(n) {
        return X$(E$({
            $: 1,
            a: n
        }));
    }, Ag = function(n) {
        return A2(zs, "DELETE", Hs(n));
    }, Lg = Ks(Hl(yt(0))), yg = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Sg = function(n) {
        return A2(zs, "PUT", Hs(n));
    }, Fg = F2(function(n, r) {
        return Al(Lg(A3(kg, sg, {
            mH: r.mH.sa,
            mJ: r.mJ.sa,
            nW: r.nW.sa,
            oz: r.oz.sa,
            rL: pg(r.rL)
        }, Sg(wg(n.mj)))));
    }), Tg = F2(function(n, r) {
        return A2(Rs, yg, A2(Fg, n, r));
    }), Qg = F2(function(n, r) {
        return p(n, {
            sa: r
        });
    }), Ig = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(Qg, r, t = n.a);
            case 1:
                return p(e = A2(Qg, r, t = n.a), {
                    lO: !0
                });
            default:
                var t = n.a, e = p(r, {
                    lO: !1,
                    fq: !0
                });
                return A2(Qg, e, t);
        }
    }), Bg = F2(function(n, r) {
        return p(n, {
            fq: !0,
            sa: r
        });
    }), Wg = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(Bg, r, t = n.a);
            case 1:
                return p(e = A2(Bg, r, t = n.a), {
                    lO: !0
                });
            default:
                var t = n.a, e = p(r, {
                    lO: !1,
                    fq: !0
                });
                return A2(Bg, e, t);
        }
    }), Pg = F2(function(n, r) {
        switch(n.$){
            case 0:
                return p(r, {
                    p4: A2(Wg, n.a, r.p4)
                });
            case 1:
                return p(r, {
                    p5: A2(Wg, n.a, r.p5)
                });
            default:
                return p(r, {
                    p6: A2(Wg, n.a, r.p6)
                });
        }
    }), Mg = F2(function(n, r) {
        switch(n.$){
            case 2:
                return A2(eo, g, p(r, {
                    kL: kt(tg(kt(n.a)))
                }));
            case 1:
                return A2(eo, g, p(r, {
                    kL: kt(tg(Ct))
                }));
            case 4:
                return A2(eo, g, p(r, {
                    kL: Ct,
                    ll: Ct,
                    re: Ct
                }));
            case 3:
                return A2(eo, g, p(r, {
                    ll: Ct,
                    re: Ct
                }));
            case 5:
                var t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        oz: A2(Wg, t, n.oz)
                    });
                }, r.kL);
                return A2(eo, g, p(r, {
                    kL: e
                }));
            case 6:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        nW: A2(Wg, t, n.nW)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 7:
                var u = r.kL;
                return A2(eo, C(1 === u.$ ? [
                    p$
                ] : 1 === (d = (e = u.a).oF).$ ? [
                    Cg(e)
                ] : [
                    A2(Tg, d.a, e)
                ]), r);
            case 10:
                return A2(eo, C([
                    (l = n.a, A2(Rs, jg, function(n) {
                        return Al(Lg(Ag(wg(n.mj))));
                    }(l)))
                ]), r);
            case 8:
                return (a = n.a).$ ? A2(eo, g, A2(eg, a.a, r)) : A2(eo, C([
                    G$
                ]), p(r, {
                    ll: Ct,
                    re: kt("Audio mapping created")
                }));
            case 9:
                return (a = n.a).$ ? A2(eo, g, A2(eg, a.a, r)) : A2(eo, C([
                    G$
                ]), p(r, {
                    ll: Ct,
                    re: kt("Audio mapping updated")
                }));
            case 11:
                return (a = n.a).$ ? A2(eo, g, A2(eg, a.a, r)) : A2(eo, C([
                    G$
                ]), p(r, {
                    ll: Ct,
                    re: kt("Audio mapping deleted")
                }));
            case 0:
                var a;
                if ((a = n.a).$) return A2(eo, g, A2(eg, a.a, r));
                var o = a.a;
                return A2(eo, g, p(r, {
                    cz: o.a,
                    oD: o.b
                }));
            case 12:
                t = n.a;
                var c = n.b;
                n: for(; !t.a.$;)return e = A2(Tu, function(n) {
                    return p(n, {
                        rL: A2(cl, F2(function(n, r) {
                            return i(n, c) ? A2(Pg, t, r) : r;
                        }), n.rL)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
                return A2(eo, g, r);
            case 14:
                return c = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        rL: A2(ag, F2(function(n) {
                            return !i(n, c);
                        }), n.rL)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 13:
                var f = A2(Qu, 0, A2(Tu, function(n) {
                    return A2(Qu, 0, ig(vt(n.rL)));
                }, r.kL)), s = A2(rg, f + 1, A3(A$, 0, 5, Ct));
                return e = A2(Tu, function(n) {
                    return p(n, {
                        rL: A3(ju, f + 1, s, n.rL)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 16:
                return A2(eo, g, p(r, {
                    ph: A2(Wg, t = n.a, r.ph)
                }));
            case 15:
                return A2(eo, g, p(r, {
                    rs: n.a
                }));
            case 17:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        mH: A2(Ig, t, n.mH)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            default:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        mJ: A2(Ig, t, n.mJ)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
        }
        var l, d;
    }), qg = {
        $: 1
    }, Dg = function(n) {
        return {
            $: 16,
            a: n
        };
    }, Xg = F2(function(n, r) {
        return A2(Qu, "", A2(Tu, function(n) {
            return n.nW;
        }, A2(Lo, r.oz, n)));
    }), Eg = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Rg = function(n) {
        return {
            $: 10,
            a: n
        };
    }, xg = ye("button"), Og = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), zg = F2(function(n, r) {
        return A2(pr, function(n) {
            return /^(on|formAction$)/i.test(n) ? "data-" + n : n;
        }(n), $r(r));
    }), Ng = F2(function(n, r) {
        return A3(Og, A2(zg, n, r), g, "");
    }), Hg = Ng("class"), Vg = Hg, Ug = dr, Jg = F2(function(n, r) {
        return A3(Og, A2(Ug, n, r), g, "");
    }), Zg = F2(function(n, r) {
        return A2(Jg, n, {
            $: 0,
            a: r
        });
    }), Kg = F2(function(n, r) {
        var t;
        return A2(xg, C([
            (t = r, A2(Zg, "click", Qe(t))),
            Vg("IconButton")
        ]), C([
            n
        ]));
    }), _g = F2(function(n, r) {
        return A2(mr, function(n) {
            return "innerHTML" == n || "formAction" == n ? "data-" + n : n;
        }(n), $r(r));
    }), Gg = F2(function(n, r) {
        return A3(Og, A2(_g, n, r), g, "");
    }), Yg = F2(function(n, r) {
        return A2(Gg, n, gi(r));
    }), nh = Yg("className"), rh = {
        $: 0
    }, th = Be, eh = F2(function(n, r) {
        return {
            v: n,
            jI: r
        };
    }), uh = F2(function(n, r) {
        return A2(eh, g, C([
            n(r)
        ]));
    }), ah = F2(function(n, r) {
        return th({
            nW: n,
            hf: rh,
            ie: uh(r)
        });
    }), ih = function(n) {
        var r = n.rE, t = n.rF, e = n.kr;
        return {
            jW: A2(Ge, function(n) {
                return n;
            }, n.jW),
            kr: e,
            rE: r,
            rF: t
        };
    }, oh = F3(function(n, r, t) {
        return {
            nW: n,
            hf: t,
            ie: r
        };
    }), ch = function(n) {
        return si(fi(n));
    }, fh = function(n) {
        return A2(eh, g, C([
            ch(n)
        ]));
    }, sh = function(n) {
        var r = n.hf;
        return A3(oh, n.nW, A2(mu, fh, n.ie), r);
    }, lh = function(n) {
        return {
            $: 3,
            a: xi(n)
        };
    }, dh = F2(function(n, r) {
        var t;
        return sh({
            nW: n,
            hf: lh((t = r, A2(mu, zi, t))),
            ie: r
        });
    }), bh = function(n) {
        return 0 > n || n > 1114111 ? "\uFFFD" : n > 65535 ? String.fromCharCode(Math.floor((n -= 65536) / 1024) + 55296, n % 1024 + 56320) : String.fromCharCode(n);
    }, mh = Ma(C([
        bh(160)
    ])), ph = ye("span"), vh = br, $h = F2(function(n, r) {
        return A3(Og, A2(vh, n, r), g, "");
    }), gh = $h, hh = function(n) {
        return A2(ph, C([
            A2(gh, "color", "#555")
        ]), C([
            ch($(mh, n))
        ]));
    }, kh = function(n) {
        return A2(ph, C([
            A2(gh, "color", "#ccc")
        ]), C([
            ch($(mh, n))
        ]));
    }, Ch = ye("th"), jh = function(n) {
        var r = n.a, t = n.b, e = n.c, u = function() {
            switch(t.$){
                case 0:
                    return C([
                        ch(r)
                    ]);
                case 1:
                    var n = t.a;
                    return C([
                        ch(r),
                        n ? hh("\u2193") : kh("\u2193")
                    ]);
                default:
                    if (1 === t.a.$) return C([
                        ch(r),
                        kh("\u2195")
                    ]);
                    var e = t.a.a;
                    return C([
                        ch(r),
                        hh(e ? "\u2191" : "\u2193")
                    ]);
            }
        }();
        return A2(Ch, C([
            e
        ]), u);
    }, wh = {
        jA: Ct,
        pC: function() {
            return g;
        },
        rj: g,
        rv: g,
        dM: Ct,
        dN: function(n) {
            return A2(eh, g, A2(Ge, jh, n));
        }
    }, Ah = Ng("height"), Lh = Ng("points"), yh = F4(function(n, r, t, e) {
        return {
            $: 1,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), Sh = yh, Fh = Sh("http://www.w3.org/2000/svg"), Th = Fh("polygon"), Qh = Fh("svg"), Ih = Ng("viewBox"), Bh = Ng("width"), Wh = A2(Qh, C([
        Ah("16px"),
        Bh("16px"),
        Ih("0 0 16 16"),
        Vg("IconDelete")
    ]), C([
        A2(Th, C([
            Vg("Fg"),
            Lh("4 5 6 3 13 11 11 13")
        ]), g),
        A2(Th, C([
            Vg("Fg"),
            Lh("13 5 11 3 3 11 5 13")
        ]), g)
    ])), Ph = A2(Qh, C([
        Ah("16px"),
        Bh("16px"),
        Ih("0 0 16 16"),
        Vg("IconKo")
    ]), C([
        A2(Th, C([
            Vg("Fg"),
            Lh("4 5 6 3 13 11 11 13")
        ]), g),
        A2(Th, C([
            Vg("Fg"),
            Lh("13 5 11 3 3 11 5 13")
        ]), g)
    ])), Mh = function(n) {
        return A2(Zg, "click", Qe(n));
    }, qh = Yg("type"), Dh = F2(function(n, r) {
        return A2(xg, C([
            qh("button"),
            Mh(r),
            nh("ButtonMini")
        ]), C([
            ch(n)
        ]));
    }), Xh = A2(Qh, C([
        Ah("16px"),
        Bh("16px"),
        Ih("0 0 16 16"),
        Vg("IconOk")
    ]), C([
        A2(Th, C([
            Vg("Fg"),
            Lh("2 8 7 13 15 5 13 3 7 9 4 6")
        ]), g)
    ])), Eh = C([
        nh("Table")
    ]), Rh = function(n) {
        return A6(w$, n.mj, n.oz, n.nW, n.rL, n.mH, n.mJ);
    }, xh = function(n) {
        var r = n.rQ;
        return S$(n.m3) + " " + Q$(r);
    }, Oh = ih({
        jW: C([
            A2(ah, "Edit", A2(mu, A2(mu, Dh("Edit"), Eg), Rh)),
            A2(dh, "Organization", function(n) {
                return n.gp;
            }),
            A2(dh, "Name", function(n) {
                return n.nW;
            }),
            A2(ah, "Default", function(n) {
                return n.mH || n.mJ ? Xh : Ph;
            }),
            A2(dh, "Tracks", A2(Po, function(n) {
                return n.rL;
            }, A2(Po, Ge(xh), Wt(", ")))),
            A2(ah, "Delete", A2(mu, A2(mu, Kg(Wh), Rg), Rh))
        ]),
        kr: p(wh, {
            pC: function() {
                return C([
                    nh("TableTr")
                ]);
            },
            rj: Eh,
            rv: C([
                nh("TableTd")
            ])
        }),
        rE: function(n) {
            return n.mj;
        },
        rF: function(n) {
            return {
                $: 15,
                a: n
            };
        }
    }), zh = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Nh = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Hh = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Vh = function(n) {
        return A2(Yg, "autocomplete", n ? "on" : "off");
    }, Uh = F2(function(n, r) {
        return A2(Gg, n, Ji(r));
    }), Jh = Uh("autofocus"), Zh = function(n) {
        return nh(A2(Wt, " ", A2(Ge, $e, A2(Bu, tl, n))));
    }, Kh = F3(function(n, r, t) {
        return A2(n, r, C([
            ch(t)
        ]));
    }), _h = Kh(ph), Gh = function(n) {
        return wu(n) ? ch("") : A2(Se, C([
            nh("InputErrors")
        ]), A2(Ge, _h(C([
            nh("InputError")
        ])), n));
    }, Yh = F2(function(n, r) {
        return A2(Se, C([
            nh("InputWrapper"),
            Zh(C([
                d("InputHasError", wu(n.lm))
            ]))
        ]), C([
            r,
            Gh(n.lm)
        ]));
    }), nk = Uh("disabled"), rk = ye("input"), tk = Yg("name"), ek = F4(function(n, r, t, e) {
        return {
            fB: r,
            b4: n,
            og: t,
            q$: e
        };
    }), uk = ct, ak = function(n) {
        return A2(uk, {
            jD: !1,
            nU: !1
        }, n);
    }, ik = /.^/, ok = lt(dt), ck = function(n) {
        return "" !== n ? A3(ok, A2(Qu, ik, ak("[^a-z0-9]+")), function() {
            return "_";
        }, zi(n)) : n;
    }, fk = Yg("id"), sk = function(n) {
        return "" === n ? Zh(g) : fk(n);
    }, lk = F2(function(n, r) {
        return A3(_e, du, r, n);
    }), dk = A2(lk, C([
        "target",
        "value"
    ]), Bi), bk = function(n) {
        return A2(Zg, "blur", A2(Fe, n, dk));
    }, mk = function(n) {
        return A2(Zg, "focus", A2(Fe, n, dk));
    }, pk = function(n) {
        return d(n, !0);
    }, vk = F2(function(n, r) {
        return A2(Jg, n, {
            $: 1,
            a: r
        });
    }), $k = function(n) {
        return A2(vk, "input", A2(Fe, pk, A2(Fe, n, dk)));
    }, gk = Yg("placeholder"), hk = Yg("value"), kk = function(n) {
        return A2(Yh, n, A2(rk, C([
            nh("InputText"),
            sk(n.kT),
            qh("text"),
            $k(zh),
            bk(Nh),
            mk(Hh),
            hk(n.sa),
            gk(n.gy),
            tk(ck(n.m$)),
            nk(n.kO),
            Vh(n.nX),
            n.eg ? Jh(!0) : Zh(g)
        ]), g));
    }, Ck = F3(function(n, r, t) {
        return {
            $: 2,
            a: n,
            b: r,
            c: t
        };
    }), jk = F4(function(n, r, t, e) {
        return {
            $: 3,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), wk = or, Ak = hr, Lk = F2(function(n, r) {
        var t = r.b, e = r.c;
        return A3(Og, A2(Ak, n, r.a), t, e);
    }), yk = F2(function(n, r) {
        switch(r.$){
            case 0:
                var t = r.b, e = r.c;
                return A3(Le, r.a, A2(Ge, Lk(n), t), A2(Ge, yk(n), e));
            case 1:
                return t = r.c, e = r.d, A4(yh, r.a, r.b, A2(Ge, Lk(n), t), A2(Ge, yk(n), e));
            case 2:
                return t = r.b, e = r.c, A3(Ck, r.a, A2(Ge, Lk(n), t), A2(Ge, function(r) {
                    return d(r.a, A2(yk, n, r.b));
                }, e));
            case 3:
                return t = r.c, e = r.d, A4(jk, r.a, r.b, A2(Ge, Lk(n), t), A2(Ge, function(r) {
                    return d(r.a, A2(yk, n, r.b));
                }, e));
            default:
                return si(A2(wk, n, r.a));
        }
    }), Sk = yk, Fk = ye("caption"), Tk = F3(function(n, r, t) {
        switch(r.$){
            case 0:
                return t;
            case 1:
                return (e = r.a)(t);
            case 2:
                return Jt((e = r.a)(t));
            case 3:
                var e = r.a;
                return n ? Jt(e(t)) : e(t);
            default:
                return e = r.a, n ? e(t) : Jt(e(t));
        }
    }), Qk = F2(function(n, r) {
        for(;;){
            if (!r.b) return Ct;
            var t = r.a.hf, e = r.b;
            if (i(r.a.nW, n)) return kt(t);
            r = e;
        }
    }), Ik = F3(function(n, r, t) {
        var e = n.b, u = A2(Qk, n.a, r);
        return 1 === u.$ ? t : A3(Tk, e, u.a, t);
    }), Bk = F3(function(n, r, t) {
        return A3(Ik, r, n.jW, t);
    }), Wk = Ck, Pk = Wk, Mk = ye("table"), qk = ye("tfoot"), Dk = ye("thead"), Xk = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Ek = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Rk = {
        $: 0
    }, xk = F3(function(n, r, t) {
        return A2(Zg, "click", A2(Fe, t, A3(Te, h$, Qe(n), Qe(r))));
    }), Ok = F3(function(n, r, t) {
        var e = n.a, u = n.b, a = t.nW;
        switch(t.hf.$){
            case 0:
                return b(a, Rk, A3(xk, e, u, r));
            case 1:
                return b(a, Ek(!i(a, e)), A3(xk, a, !1, r));
            case 2:
                return b(a, Ek(i(a, e)), A3(xk, a, !1, r));
            case 3:
                return i(a, e) ? b(a, Xk(kt(!u)), A3(xk, a, !u, r)) : b(a, Xk(Ct), A3(xk, a, !1, r));
            default:
                return i(a, e) ? b(a, Xk(kt(u)), A3(xk, a, !u, r)) : b(a, Xk(Ct), A3(xk, a, !1, r));
        }
    }), zk = ye("tr"), Nk = lr, Hk = F2(function(n, r) {
        var t = n.b, e = n.c;
        return wu(t) ? r : A3(ju, e, t, r);
    }), Vk = function(n) {
        return n.a;
    }, Uk = function(n) {
        return ir(vr(n));
    }, Jk = F2(function(n, r) {
        return A2(ar, n, vr(r));
    }), Zk = function(n) {
        return er(vr(n));
    }, Kk = F2(function(n, r) {
        var t = n.a, e = n.b, u = r.a, a = r.b;
        switch(e.$){
            case 4:
                return d(A2(bt, d(t, l = e.a), u), a);
            case 0:
                var i = e.a, o = e.c, c = A3(qt, _k, d(g, A3(qt, Hk, a, v = e.b)), o), f = c.a, s = c.b, l = A3(oi, i, A2(Ge, Vk, v), Jt(f));
                return d(A2(bt, d(t, l), u), s);
            case 1:
                var b = e.a, m = (i = e.b, o = e.d, A3(qt, _k, d(g, A3(qt, Hk, a, v = e.c)), o));
                return f = m.a, s = m.b, l = A4(Zk, b, i, A2(Ge, Vk, v), Jt(f)), d(A2(bt, d(t, l), u), s);
            case 2:
                i = e.a, o = e.c;
                var p = A3(qt, Kk, d(g, A3(qt, Hk, a, v = e.b)), o);
                return f = p.a, s = p.b, l = A3(Uk, i, A2(Ge, Vk, v), Jt(f)), d(A2(bt, d(t, l), u), s);
            default:
                b = e.a, i = e.b, o = e.d;
                var v, $ = A3(qt, Kk, d(g, A3(qt, Hk, a, v = e.c)), o);
                return f = $.a, s = $.b, l = A4(Jk, b, i, A2(Ge, Vk, v), Jt(f)), d(A2(bt, d(t, l), u), s);
        }
    }), _k = F2(function(n, r) {
        var t = r.a, e = r.b;
        switch(n.$){
            case 4:
                return d(A2(bt, f = n.a, t), e);
            case 0:
                var u = n.a, a = n.c, i = A3(qt, _k, d(g, A3(qt, Hk, e, m = n.b)), a), o = i.a, c = i.b, f = A3(oi, u, A2(Ge, Vk, m), Jt(o));
                return d(A2(bt, f, t), c);
            case 1:
                var s = n.a, l = (u = n.b, a = n.d, A3(qt, _k, d(g, A3(qt, Hk, e, m = n.c)), a));
                return o = l.a, c = l.b, f = A4(Zk, s, u, A2(Ge, Vk, m), Jt(o)), d(A2(bt, f, t), c);
            case 2:
                u = n.a, a = n.c;
                var b = A3(qt, Kk, d(g, A3(qt, Hk, e, m = n.b)), a);
                return o = b.a, c = b.b, f = A3(Uk, u, A2(Ge, Vk, m), Jt(o)), d(A2(bt, f, t), c);
            default:
                s = n.a, u = n.b, a = n.d;
                var m, p = A3(qt, Kk, d(g, A3(qt, Hk, e, m = n.c)), a);
                return o = p.a, c = p.b, f = A4(Jk, s, u, A2(Ge, Vk, m), Jt(o)), d(A2(bt, f, t), c);
        }
    }), Gk = F2(function(n, r) {
        return A5($u, 1, n, r, gu, gu);
    }), Yk = F2(function(n, r) {
        for(;;){
            if (!r.b) return n;
            var t = r.a, e = t.b, u = t.c, a = r.b;
            Re(u) || (n = kt(d(u, e))), r = a;
        }
    }), nC = function(n) {
        var r = A2(Yk, Ct, n);
        if (1 === r.$) return Lu;
        var t = r.a;
        return A2(Gk, t.a, t.b);
    }, rC = function(n) {
        return {
            $: 0,
            a: n
        };
    }, tC = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), eC = function(n) {
        return {
            $: 0,
            a: n
        };
    }, uC = F2(function(n, r) {
        return C([
            eC(A3(tC, A3(ta, r, g, Ct), g, n))
        ]);
    }), aC = function(n) {
        return A2(uC, n.b, va(C([
            rC(n.a)
        ])));
    }, iC = function(n) {
        return A3(oi, "style", g, za(fi(ii(za(ci(A2(Ge, aC, pt(n))))))));
    }, oC = F3(function(n, r, t) {
        var e = A2(Ge, Vk, r), u = nC(r), a = A3(qt, _k, d(g, u), t), i = a.a, o = iC(a.b);
        return A3(oi, n, e, A2(bt, o, Jt(i)));
    }), cC = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var t = r.b;
            if (i(n, r.a.a)) return !0;
            r = t;
        }
    }), fC = F2(function(n, r) {
        n: for(;;){
            if (r.b) {
                var t = r.b, e = "_" + r.a.a;
                if (A2(cC, e, t)) {
                    n = e, r = t;
                    continue n;
                }
                return e;
            }
            return n;
        }
    }), sC = F2(function(n, r) {
        return d(A2(fC, "_", r), iC(n));
    }), lC = F3(function(n, r, t) {
        var e = A2(Ge, Vk, r), u = nC(r), a = A3(qt, Kk, d(g, u), t), i = a.a;
        return A3(Uk, n, e, A2(bt, A2(sC, a.b, i), Jt(i)));
    }), dC = F4(function(n, r, t, e) {
        var u = A2(Ge, Vk, t), a = nC(t), i = A3(qt, Kk, d(g, a), e), o = i.a;
        return A4(Jk, n, r, u, A2(bt, A2(sC, i.b, o), Jt(o)));
    }), bC = F4(function(n, r, t, e) {
        var u = A2(Ge, Vk, t), a = nC(t), i = A3(qt, _k, d(g, a), e), o = i.a, c = iC(i.b);
        return A4(Zk, n, r, u, A2(bt, c, Jt(o)));
    }), mC = function(n) {
        switch(n.$){
            case 4:
                return n.a;
            case 0:
                return A3(oC, n.a, n.b, n.c);
            case 1:
                return A4(bC, n.a, n.b, n.c, n.d);
            case 2:
                return A3(lC, n.a, n.b, n.c);
            default:
                return A4(dC, n.a, n.b, n.c, n.d);
        }
    }, pC = F4(function(n, r, t, e) {
        return mC(A3(n, r, t, e));
    }), vC = F4(function(n, r, t, e) {
        return si(A5(Nk, pC, n, r, t, e));
    }), $C = vC, gC = ye("td"), hC = F2(function(n, r) {
        var t = (0, r.ie)(n);
        return A2(gC, t.v, t.jI);
    }), kC = F3(function(n, r, t) {
        return A2(zk, r(t), A2(Ge, hC(t), n));
    }), CC = F4(function(n, r, t, e) {
        return d(n(e), A4($C, kC, r, t, e));
    }), jC = F3(function(n, r, t) {
        var e, u, a = n.rE, i = n.jW, o = n.kr, c = o.dN(A2(Ge, A2(Ok, r, n.rF), i)), f = A2(Dk, c.v, C([
            A2(zk, g, c.jI)
        ])), s = A3(Bk, n, r, t), l = A3(Pk, "tbody", o.rv, A2(Ge, A3(CC, a, i, o.pC), s)), d = 1 === (e = o.dM).$ ? A2(bt, l, g) : A2(bt, A2(qk, e.a.v, e.a.jI), A2(bt, l, g));
        return A2(Mk, o.rj, 1 === (u = o.jA).$ ? A2(bt, f, d) : A2(bt, A2(Fk, u.a.v, u.a.jI), A2(bt, f, d)));
    }), wC = {
        $: 3
    }, AC = function(n) {
        return A2(Se, C([
            nh("BannerInvalid")
        ]), C([
            Ph,
            A2(_h, C([
                nh("BannerContent")
            ]), n)
        ]));
    }, LC = function(n) {
        return A2(Se, C([
            nh("BannerValid")
        ]), C([
            Xh,
            A2(_h, C([
                nh("BannerContent")
            ]), n)
        ]));
    }, yC = function(n) {
        var r = n.ll;
        if (r.$) {
            var t = n.re;
            if (t.$) return ch("");
            var e = t.a;
            return A2(Se, C([
                Mh(wC)
            ]), C([
                LC(e)
            ]));
        }
        var u = r.a;
        return A2(Se, C([
            Mh(wC)
        ]), C([
            AC(u)
        ]));
    }, SC = {
        $: 4
    }, FC = function(n) {
        return {
            $: 17,
            a: n
        };
    }, TC = function(n) {
        return {
            $: 18,
            a: n
        };
    }, QC = function(n) {
        return {
            $: 6,
            a: n
        };
    }, IC = function(n) {
        return {
            $: 5,
            a: n
        };
    }, BC = {
        $: 13
    }, WC = {
        $: 7
    }, PC = ch(""), MC = Qu(PC), qC = function(n) {
        return A2(Po, Tu(n), MC);
    }, DC = function(n) {
        return {
            $: 0,
            a: n
        };
    }, XC = Uh("checked"), EC = A2(lk, C([
        "target",
        "checked"
    ]), Ae), RC = function(n) {
        return A2(Zg, "change", A2(Fe, n, EC));
    }, xC = function(n) {
        var r;
        return A2(Yh, n, A2(rk, C([
            nh("InputCheckbox"),
            (r = n.mj, "" === r ? Zh(g) : fk(r)),
            qh("checkbox"),
            RC(DC),
            XC(n.sa),
            nk(n.kO)
        ]), g));
    }, OC = ye("label"), zC = OC, NC = F2(function(n, r) {
        return "" === n.m$ ? r : A2(zC, C([
            nh("InputLabel")
        ]), C([
            A2(Se, C([
                nh("InputLabelText")
            ]), C([
                ch(n.m$),
                n.mL ? ch("") : A2(_h, C([
                    nh("InputMandatory")
                ]), "*")
            ])),
            r
        ]));
    }), HC = function(n) {
        return A2(NC, n, xC(n));
    }, VC = function(n) {
        return A2(NC, n, kk(n));
    }, UC = Fh("g"), JC = A2(Qh, C([
        Ah("20px"),
        Bh("20px"),
        Ih("0 0 20 20"),
        Vg("IconChoice")
    ]), C([
        A2(UC, C([
            Vg("Fg")
        ]), C([
            A2(Th, C([
                Lh("10 4 7 8 13 8")
            ]), g),
            A2(Th, C([
                Lh("10 16 7 12 13 12")
            ]), g)
        ]))
    ])), ZC = F2(function(n, r) {
        return A2(Qu, "", Ra(A2(Ge, tl, A2(Bu, function(r) {
            return i(r.a, n);
        }, r))));
    }), KC = ye("option"), _C = ye("select"), GC = Uh("selected"), YC = F2(function(n, r) {
        var t = A2(KC, C([
            hk(""),
            GC("" === n.sa)
        ]), C([
            ch(n.gy)
        ]));
        return A2(_C, C([
            nh("InputSelectSelect"),
            $k(zh),
            gk(n.gy),
            nk(n.kO)
        ]), A2(bt, t, A2(Ge, function(r) {
            var t = r.a, e = r.b;
            return A2(KC, C([
                hk(t),
                GC(i(t, n.sa))
            ]), C([
                ch(e)
            ]));
        }, r)));
    }), nj = F2(function(n, r) {
        return A2(Se, C([
            nh("InputWrapper"),
            Zh(C([
                d("InputWrapperDisabled", n.kO),
                d("InputHasError", wu(n.lm))
            ]))
        ]), C([
            A2(Se, C([
                nh("InputSelect"),
                Zh(C([
                    d("InputSelectEmpty", "" === n.sa)
                ]))
            ]), C([
                A2(Se, C([
                    nh("InputSelectChoice")
                ]), C([
                    JC
                ])),
                A2(_h, C([
                    nh("InputSelectValue")
                ]), "" === n.sa || wu(r) ? n.gy : A2(ZC, n.sa, r)),
                A2(YC, n, r)
            ])),
            Gh(n.lm)
        ]));
    }), rj = F2(function(n, r) {
        return A2(NC, n, A2(nj, n, r));
    }), tj = ye("form"), ej = function(n) {
        return d(n, !0);
    }, uj = F2(function(n, r) {
        return A2(Jg, n, {
            $: 2,
            a: r
        });
    }), aj = function(n) {
        return A2(uj, "submit", A2(Fe, ej, Qe(n)));
    }, ij = function(n) {
        return A2(xg, C([
            qh("submit"),
            nh("Button")
        ]), C([
            ch(n)
        ]));
    }, oj = F4(function(n, r, t, e) {
        var u = r.a, a = r.b, i = t.a, o = t.b;
        return A2(Se, C([
            nh("ModalWrapper")
        ]), C([
            A2(Se, C([
                nh("ModalTitle")
            ]), C([
                ch(n),
                A2(Dh, i, o)
            ])),
            A2(tj, C([
                aj(a),
                nh("ModalForm")
            ]), C([
                A2(Se, C([
                    nh("ModalContent")
                ]), e),
                A2(Se, C([
                    nh("ModalSubmit")
                ]), C([
                    A2(Dh, i, o),
                    ij(u)
                ]))
            ]))
        ]));
    }), cj = F2(function(n, r) {
        return {
            $: 12,
            a: n,
            b: r
        };
    }), fj = function(n) {
        switch(n){
            case 0:
                return Pi({
                    bQ: "Arabic",
                    bX: "Arabe"
                });
            case 1:
                return Pi({
                    bQ: "Bulgarian",
                    bX: "Bulgare"
                });
            case 2:
                return Pi({
                    bQ: "Chinese",
                    bX: "Chinois"
                });
            case 3:
                return Pi({
                    bQ: "Czech",
                    bX: "Tch\xe8que"
                });
            case 4:
                return Pi({
                    bQ: "Korean",
                    bX: "Cor\xe9en"
                });
            case 5:
                return Pi({
                    bQ: "Danish",
                    bX: "Danois"
                });
            case 6:
                return Pi({
                    bQ: "Flemish",
                    bX: "Flamand"
                });
            case 9:
                return Pi({
                    bQ: "Greek",
                    bX: "Grec"
                });
            case 7:
                return Pi({
                    bQ: "Hebrew",
                    bX: "H\xe9breu"
                });
            case 8:
                return Pi({
                    bQ: "Hindi",
                    bX: "Hindi"
                });
            case 10:
                return Pi({
                    bQ: "Dutch",
                    bX: "N\xe9erlandais"
                });
            case 11:
                return Pi({
                    bQ: "Russian",
                    bX: "Russe"
                });
            case 14:
                return Pi({
                    bQ: "Swedish",
                    bX: "Su\xe9dois"
                });
            case 12:
                return Pi({
                    bQ: "Slovenian",
                    bX: "Slov\xe8ne"
                });
            case 13:
                return Pi({
                    bQ: "Serbian",
                    bX: "Serbe"
                });
            case 15:
                return Pi({
                    bQ: "Tamil",
                    bX: "Tamoul"
                });
            case 16:
                return Pi({
                    bQ: "Thai",
                    bX: "Tha\xef"
                });
            case 17:
                return Pi({
                    bQ: "French",
                    bX: " Fran\xe7ais"
                });
            case 18:
                return Pi({
                    bQ: "Canadian french",
                    bX: "Fran\xe7ais canadien"
                });
            case 19:
                return Pi({
                    bQ: "German",
                    bX: "Allemand"
                });
            case 20:
                return Pi({
                    bQ: "Italian",
                    bX: "Italien"
                });
            case 21:
                return Pi({
                    bQ: "Portuguese",
                    bX: "Portugais"
                });
            case 22:
                return Pi({
                    bQ: " English",
                    bX: "Anglais"
                });
            case 23:
                return Pi({
                    bQ: "Spanish",
                    bX: "Espagnol"
                });
            case 24:
                return Pi({
                    bQ: "Japanese",
                    bX: "Japonais"
                });
            case 25:
                return Pi({
                    bQ: "Norwegian",
                    bX: "Norv\xe9gien"
                });
            case 26:
                return Pi({
                    bQ: "Ukrainian",
                    bX: "Ukrainien"
                });
            case 27:
                return Pi({
                    bQ: "Finnish",
                    bX: "Finnois"
                });
            case 28:
                return Pi({
                    bQ: "Castilian Spanish",
                    bX: "Espagnol castillan"
                });
            case 29:
                return Pi({
                    bQ: "Brazilian portuguese",
                    bX: "Portugais br\xe9silien"
                });
            case 30:
                return Pi({
                    bQ: "Romanian",
                    bX: "Roumain"
                });
            case 31:
                return Pi({
                    bQ: "Croatian",
                    bX: "Croate"
                });
            case 32:
                return Pi({
                    bQ: "Scottish Gaelic",
                    bX: "Ga\xe9lique \xe9cossais"
                });
            case 33:
                return Pi({
                    bQ: "Hungarian",
                    bX: "Hongrois"
                });
            case 34:
                return Pi({
                    bQ: "Indonesian",
                    bX: "Indon\xe9sien"
                });
            case 35:
                return Pi({
                    bQ: "Turkish",
                    bX: "Turc"
                });
            case 36:
                return Pi({
                    bQ: "Polish",
                    bX: "Polonais"
                });
            case 37:
                return Pi({
                    bQ: " International",
                    bX: " International"
                });
            default:
                return Pi({
                    bQ: "",
                    bX: ""
                });
        }
    }, sj = A2(xi, tl, C([
        d(W$(0), fj(0)),
        d(W$(1), fj(1)),
        d(W$(2), fj(2)),
        d(W$(3), fj(3)),
        d(W$(4), fj(4)),
        d(W$(5), fj(5)),
        d(W$(6), fj(6)),
        d(W$(7), fj(7)),
        d(W$(8), fj(8)),
        d(W$(9), fj(9)),
        d(W$(10), fj(10)),
        d(W$(11), fj(11)),
        d(W$(12), fj(12)),
        d(W$(13), fj(13)),
        d(W$(14), fj(14)),
        d(W$(15), fj(15)),
        d(W$(16), fj(16)),
        d(W$(17), fj(17)),
        d(W$(18), fj(18)),
        d(W$(19), fj(19)),
        d(W$(20), fj(20)),
        d(W$(21), fj(21)),
        d(W$(22), fj(22)),
        d(W$(23), fj(23)),
        d(W$(24), fj(24)),
        d(W$(25), fj(25)),
        d(W$(26), fj(26)),
        d(W$(27), fj(27)),
        d(W$(28), fj(28)),
        d(W$(29), fj(29)),
        d(W$(30), fj(30)),
        d(W$(31), fj(31)),
        d(W$(32), fj(32)),
        d(W$(33), fj(33)),
        d(W$(34), fj(34)),
        d(W$(35), fj(35)),
        d(W$(36), fj(36)),
        d(W$(38), fj(38))
    ])), lj = F3(function(n, r, t) {
        return A2(xg, $(C([
            qh("button"),
            Mh(t),
            nh("ButtonMini")
        ]), A2(Ge, function(n) {
            return A2(gh, n.a, n.b);
        }, r)), C([
            ch(n)
        ]));
    }), dj = function(n) {
        return {
            $: 0,
            a: n
        };
    }, bj = function(n) {
        return {
            $: 1,
            a: n
        };
    }, mj = function(n) {
        return {
            $: 2,
            a: n
        };
    }, pj = F4(function(n, r, t, e) {
        return A2(Se, C([
            nh("Select2Container")
        ]), C([
            A2(Sk, dj, A2(rj, n.p4, r)),
            A2(Sk, bj, A2(rj, n.p5, t)),
            A2(mg, n.p5.sa, C([
                "Original",
                "Dubbed",
                "AudioDescription"
            ])) ? A2(Sk, mj, A2(rj, n.p6, e)) : ch("")
        ]));
    }), vj = function(n) {
        return A2(qC, function(r) {
            var t = A2(bt, d("", ""), A2(xi, A2(mu, zi, tl), A2(Ge, function(n) {
                return d(n.a, n.b.nW);
            }, pt(n.oD)))), e = function(n) {
                return 1 !== n.oF.$;
            }(r) ? d("Save", "Edit AudioMapping") : d("Create", "New AudioMapping");
            return A4(oj, e.b, d(e.a, WC), d("Close", SC), $(C([
                yC(n),
                A2(Sk, IC, A2(rj, r.oz, t)),
                A2(Sk, FC, HC(r.mH)),
                A2(Sk, TC, HC(r.mJ)),
                A2(Sk, QC, VC(r.nW))
            ]), $(function(n) {
                var r = sj, t = C([
                    d(Q$(0), Q$(0)),
                    d(Q$(1), Q$(1)),
                    d(Q$(2), Q$(2)),
                    d(Q$(3), Q$(3)),
                    d(Q$(4), Q$(4)),
                    d(Q$(6), Q$(6)),
                    d(Q$(5), Q$(5)),
                    d(Q$(7), Q$(7)),
                    d(Q$(8), Q$(8)),
                    d(Q$(9), Q$(9)),
                    d(Q$(10), Q$(10)),
                    d(Q$(11), Q$(11)),
                    d(Q$(12), Q$(12)),
                    d(Q$(13), Q$(13)),
                    d(Q$(14), Q$(14)),
                    d(Q$(15), Q$(15)),
                    d(Q$(16), Q$(16)),
                    d("", "")
                ]), e = C([
                    d(S$(0), S$(0)),
                    d(S$(1), S$(1)),
                    d(S$(2), S$(2)),
                    d(S$(3), S$(3)),
                    d(S$(4), S$(4)),
                    d(S$(5), S$(5))
                ]);
                return A2(Ge, tl, pt(A2(cl, F2(function(n, u) {
                    var a;
                    return A2(Se, C([
                        A2(gh, "position", "relative"),
                        A2(gh, "margin", "25px 0")
                    ]), C([
                        A2(Sk, function(r) {
                            return A2(cj, r, n);
                        }, A4(pj, u, e, t, r)),
                        A3(lj, "remove", C([
                            d("position", "absolute"),
                            d("right", "0")
                        ]), (a = n, {
                            $: 14,
                            a: a
                        }))
                    ]));
                }), n.rL)));
            }(r), C([
                A2(Dh, "Add New Track", BC)
            ]))));
        }, n.kL);
    }, $j = F7(function(n, r, t, e, u, a, i) {
        return {
            mj: n,
            mH: a,
            mJ: i,
            nW: e,
            oz: r,
            gp: t,
            rL: u
        };
    }), gj = F2(function(n, r) {
        return A7($j, r.mj, r.oz, n, r.nW, r.rL, r.mH, r.mJ);
    }), hj = ye("a"), kj = Ng("d"), Cj = Fh("path"), jj = A2(Qh, C([
        Ah("20px"),
        Bh("20px"),
        Ih("29 30 20 20"),
        Vg("IconBack")
    ]), C([
        A2(UC, C([
            Vg("Fg")
        ]), C([
            A2(Cj, C([
                kj("M29.8248086,42.1420204 L40.1751914,49.0422759 C40.6277051,49.3439517 41,49.1402383 41,48.5827792 L41,46.6015165 C41,46.0355006 40.6434763,45.3247546 40.2036819,44.9949089 L35.6666667,41.592148 L48.0081969,41.592148 C48.5446944,41.592148 49,41.1402382 49,40.5827791 L49,38.6015169 C49,38.0355012 48.5559546,37.592148 48.0081969,37.592148 L35.6666669,37.592148 L40.2036819,34.1893866 C40.6354685,33.8655467 41,33.1402382 41,32.5827791 L41,30.6015169 C41,30.0355012 40.6307206,29.8383343 40.1751914,30.1420204 L29.8248086,37.0422756 C29.3725854,37.3437578 29.000478,39.0431593 29.0000005,39.6004433 C29,40.1487948 29.3692794,41.8383343 29.8248086,42.1420204 Z")
            ]), g)
        ]))
    ])), wj = function(n) {
        return A2(Yg, "href", n);
    }, Aj = function(n) {
        return Se(A2(bt, A2(gh, "display", "flex"), A2(bt, A2(gh, "flex-direction", "row"), n)));
    }, Lj = A2(Qh, C([
        Ah("27px"),
        Bh("27px"),
        Ih("0 0 27 27"),
        Vg("IconSettings")
    ]), C([
        A2(UC, C([
            Vg("Fg")
        ]), C([
            A2(Cj, C([
                kj("M13.5,18.1264335 L11.8004065,19 L10.913745,17.2428633 L9.05040653,16.8991869 L9.31535158,14.9296466 L8,13.5 L9.31535158,12.0703534 L9.05040653,10.1008131 L10.913745,9.75713667 L11.8004065,8 L13.5,8.87356649 L15.1995935,8 L16.086255,9.75713667 L17.9495935,10.1008131 L17.6846484,12.0703534 L19,13.5 L17.6846484,14.9296466 L17.9495935,16.8991869 L16.086255,17.2428633 L15.1995935,19 L13.5,18.1264335 Z M13.5,16 C14.8807119,16 16,14.8807119 16,13.5 C16,12.1192881 14.8807119,11 13.5,11 C12.1192881,11 11,12.1192881 11,13.5 C11,14.8807119 12.1192881,16 13.5,16 Z")
            ]), g)
        ]))
    ])), yj = ye("h3"), Sj = F2(function(n, r) {
        return A2(n, g, C([
            ch(r)
        ]));
    }), Fj = Sj(yj), Tj = ye("h1"), Qj = Sj(Tj), Ij = function(n) {
        return A2(Se, C([
            nh("LayoutAppBarWrapper")
        ]), C([
            A2(qC, function(n) {
                return A2(hj, C([
                    nh("LayoutHomeButton"),
                    wj(n)
                ]), C([
                    jj
                ]));
            }, n.fx),
            A2(qC, function(n) {
                return A2(hj, C([
                    nh("LayoutBackButton"),
                    wj(n)
                ]), C([
                    jj
                ]));
            }, n.eh),
            A2(Se, C([
                nh("LayoutAppBar")
            ]), C([
                A2(Se, C([
                    nh("LayoutAppBarTitle")
                ]), C([
                    Fj(A2(Qu, "\xa0", n.mj)),
                    A2(Aj, g, C([
                        Qj(n.rB)
                    ])),
                    Fj("\xa0")
                ])),
                A2(Se, C([
                    nh("LayoutAppBarActions")
                ]), C([
                    A2(Qu, ch(""), n.d1)
                ]))
            ])),
            A2(qC, function(n) {
                return A2(hj, C([
                    nh("LayoutFwdButton"),
                    wj(n)
                ]), C([
                    Lj
                ]));
            }, n.fj)
        ]));
    }, Bj = {
        d1: Ct,
        eh: Ct,
        fj: Ct,
        fx: Ct,
        mj: Ct,
        rB: ""
    }, Wj = F3(function(n, r, t) {
        return A2(Se, C([
            nh("LayoutPageWrapper")
        ]), C([
            Ij(p(Bj, {
                d1: r,
                rB: n
            })),
            A2(Se, C([
                nh("LayoutPageContent")
            ]), C([
                A2(hj, C([
                    wj("#"),
                    fk("LayoutPageTop")
                ]), C([
                    ch(" ")
                ])),
                t
            ]))
        ]));
    }), Pj = F2(function(n, r) {
        var t = zi(r.ph.sa), e = A2(Bu, function(n) {
            return A2(mu, A2(mu, Me(t), zi), function(n) {
                return n.gp;
            })(n) || A2(mu, A2(mu, Me(t), zi), function(n) {
                return n.nW;
            })(n) || A2(mu, A2(mu, A2(mu, A2(mu, Me(t), zi), Wt("/")), Ge(xh)), function(n) {
                return n.rL;
            })(n);
        }, A2(Ge, function(n) {
            return A2(gj, A2(Xg, r.oD, n), n);
        }, r.cz));
        return A3(Wj, "Audio Mappings", kt(A2(Dh, "New\u2026", qg)), A2(Se, g, C([
            A2(Sk, Dg, kk(r.ph)),
            yC(r),
            vj(r),
            A3(jC, Oh, r.rs, e)
        ])));
    }), Mj = {
        l: function(n) {
            return n.cz;
        },
        m: Y$,
        p: F2(function(n, r) {
            return p(n, {
                cz: r
            });
        }),
        q: function(n) {
            return {
                $: 7,
                a: n
            };
        },
        r: Mg,
        s: Pj
    }, qj = {
        cJ: g,
        kL: Ct,
        ll: Ct,
        oD: Lu,
        re: Ct
    }, Dj = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Xj = F3(function(n, r, t) {
        return {
            mj: n,
            oz: r,
            sa: t
        };
    }), Ej = ul(A4(ll, "value", function(n) {
        return n.sa;
    }, Di, A4(ll, "organization", function(n) {
        return n.oz;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(Xj))))), Rj = $l(Ej), xj = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Oj = xs(xj({
        $: 0
    })), zj = Al(A2(_s, Rj, Vs(Oj))), Nj = A2(bp, il, A2(bp, Ge(function(n) {
        return d(n.mj, n);
    }), Al(A2(_s, J$, Vs(K$))))), Hj = A2(Rs, Dj, mp(d(zj, Nj))), Vj = d(qj, Hj), Uj = function(n) {
        return {
            nW: Xi(function(r) {
                return p(r, {
                    m$: "Name",
                    sa: A2(Qu, "", A2(Tu, function(n) {
                        return n.sa;
                    }, n))
                });
            }),
            oz: Xi(function(r) {
                return p(r, {
                    m$: "Organization",
                    sa: A2(Qu, "", A2(Tu, function(n) {
                        return n.oz;
                    }, n))
                });
            }),
            oF: n
        };
    }, Jj = F2(function(n, r) {
        return p(r, {
            ll: kt(n.nE),
            re: Ct
        });
    }), Zj = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Kj = F2(function(n, r) {
        return {
            oz: n,
            sa: r
        };
    }), _j = ul(A4(ll, "value", function(n) {
        return n.sa;
    }, Di, A4(ll, "organization", function(n) {
        return n.oz;
    }, Di, gl(Kj)))), Gj = function(n) {
        var r;
        return A2(Rs, Zj, Al(A2(vg, Ej, A3(kg, _j, {
            oz: (r = n).oz.sa,
            sa: r.nW.sa
        }, $g(Oj)))));
    }, Yj = function(n) {
        return {
            $: 10,
            a: n
        };
    }, nw = function(n) {
        return xs(xj({
            $: 1,
            a: n
        }));
    }, rw = function(n) {
        return {
            $: 8,
            a: n
        };
    }, tw = F2(function(n, r) {
        return Al(A2(_s, Ej, A3(kg, _j, {
            oz: r.oz.sa,
            sa: r.nW.sa
        }, Sg(nw(n.mj)))));
    }), ew = F2(function(n, r) {
        return A2(Rs, rw, A2(tw, n, r));
    }), uw = F2(function(n, r) {
        switch(n.$){
            case 2:
                return A2(eo, g, p(r, {
                    kL: kt(Uj(kt(n.a)))
                }));
            case 1:
                return A2(eo, g, p(r, {
                    kL: kt(Uj(Ct))
                }));
            case 3:
                return A2(eo, g, p(r, {
                    kL: Ct,
                    ll: Ct,
                    re: Ct
                }));
            case 4:
                var t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        oz: A2(Wg, t, n.oz)
                    });
                }, r.kL);
                return A2(eo, g, p(r, {
                    kL: e
                }));
            case 5:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        nW: A2(Wg, t, n.nW)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 6:
                var u = r.kL;
                return A2(eo, C(1 === u.$ ? [
                    p$
                ] : 1 === (c = (e = u.a).oF).$ ? [
                    Gj(e)
                ] : [
                    A2(ew, c.a, e)
                ]), r);
            case 9:
                return A2(eo, C([
                    (o = n.a, A2(Rs, Yj, function(n) {
                        return A2(bp, Hl(n), Al(Lg(Ag(nw(n.mj)))));
                    }(o)))
                ]), r);
            case 7:
                return (a = n.a).$ ? A2(eo, g, A2(Jj, a.a, r)) : A2(eo, C([
                    Hj
                ]), p(r, {
                    ll: Ct,
                    re: kt("Channel created")
                }));
            case 8:
                return (a = n.a).$ ? A2(eo, g, A2(Jj, a.a, r)) : A2(eo, C([
                    Hj
                ]), p(r, {
                    ll: Ct,
                    re: kt("Channel updated")
                }));
            case 10:
                return (a = n.a).$ ? A2(eo, g, A2(Jj, a.a, r)) : A2(eo, C([
                    Hj
                ]), r);
            default:
                var a;
                if ((a = n.a).$) return A2(eo, g, A2(Jj, a.a, r));
                var i = a.a;
                return A2(eo, g, p(r, {
                    cJ: i.a,
                    oD: i.b
                }));
        }
        var o, c;
    }), aw = {
        $: 1
    }, iw = function(n) {
        return {
            $: 9,
            a: n
        };
    }, ow = F2(function(n, r) {
        return A2(Qu, "", A2(Tu, function(n) {
            return n.nW;
        }, A2(Lo, r.oz, n)));
    }), cw = C([
        ch("Edit"),
        ch("Organization"),
        ch("Name"),
        ch("Delete")
    ]), fw = F3(function(n, r, t) {
        return A2(gC, C([
            nh("TableTd"),
            Zh(C([
                d("TableRight", i(n - 1, r))
            ]))
        ]), C([
            t
        ]));
    }), sw = F3(function(n, r, t) {
        return A2(gC, C([
            nh("TableHeader")
        ]), C([
            t
        ]));
    }), lw = F2(function(n, r) {
        return A2(zk, C([
            nh("TableTr")
        ]), A2(Ot, n(Dt(r)), r));
    }), dw = F2(function(n, r) {
        return A2(Mk, C([
            nh("Table")
        ]), A2(bt, A2(lw, sw, n), A2(Ge, lw(fw), r)));
    }), bw = {
        $: 3
    }, mw = function(n) {
        return {
            $: 5,
            a: n
        };
    }, pw = function(n) {
        return {
            $: 4,
            a: n
        };
    }, vw = {
        $: 6
    }, $w = fr, gw = F2(function(n, r) {
        return mC(n(r));
    }), hw = F2(function(n, r) {
        return si(A3($w, gw, n, r));
    }), kw = hw, Cw = C([
        d("A", "A"),
        d("\u24B6", "A"),
        d("\uFF21", "A"),
        d("\xc0", "A"),
        d("\xc1", "A"),
        d("\xc2", "A"),
        d("\u1EA6", "A"),
        d("\u1EA4", "A"),
        d("\u1EAA", "A"),
        d("\u1EA8", "A"),
        d("\xc3", "A"),
        d("\u0100", "A"),
        d("\u0102", "A"),
        d("\u1EB0", "A"),
        d("\u1EAE", "A"),
        d("\u1EB4", "A"),
        d("\u1EB2", "A"),
        d("\u0226", "A"),
        d("\u01E0", "A"),
        d("\xc4", "A"),
        d("\u01DE", "A"),
        d("\u1EA2", "A"),
        d("\xc5", "A"),
        d("\u01FA", "A"),
        d("\u01CD", "A"),
        d("\u0200", "A"),
        d("\u0202", "A"),
        d("\u1EA0", "A"),
        d("\u1EAC", "A"),
        d("\u1EB6", "A"),
        d("\u1E00", "A"),
        d("\u0104", "A"),
        d("\u023A", "A"),
        d("\u2C6F", "A"),
        d("\uA732", "AA"),
        d("\xc6", "AE"),
        d("\u01FC", "AE"),
        d("\u01E2", "AE"),
        d("\uA734", "AO"),
        d("\uA736", "AU"),
        d("\uA738", "AV"),
        d("\uA73A", "AV"),
        d("\uA73C", "AY"),
        d("B", "B"),
        d("\u24B7", "B"),
        d("\uFF22", "B"),
        d("\u1E02", "B"),
        d("\u1E04", "B"),
        d("\u1E06", "B"),
        d("\u0243", "B"),
        d("\u0182", "B"),
        d("\u0181", "B"),
        d("C", "C"),
        d("\u24B8", "C"),
        d("\uFF23", "C"),
        d("\u0106", "C"),
        d("\u0108", "C"),
        d("\u010A", "C"),
        d("\u010C", "C"),
        d("\xc7", "C"),
        d("\u1E08", "C"),
        d("\u0187", "C"),
        d("\u023B", "C"),
        d("\uA73E", "C"),
        d("D", "D"),
        d("\u24B9", "D"),
        d("\uFF24", "D"),
        d("\u1E0A", "D"),
        d("\u010E", "D"),
        d("\u1E0C", "D"),
        d("\u1E10", "D"),
        d("\u1E12", "D"),
        d("\u1E0E", "D"),
        d("\u0110", "D"),
        d("\u018B", "D"),
        d("\u018A", "D"),
        d("\u0189", "D"),
        d("\uA779", "D"),
        d("\u01F1", "DZ"),
        d("\u01C4", "DZ"),
        d("\u01F2", "Dz"),
        d("\u01C5", "Dz"),
        d("E", "E"),
        d("\u24BA", "E"),
        d("\uFF25", "E"),
        d("\xc8", "E"),
        d("\xc9", "E"),
        d("\xca", "E"),
        d("\u1EC0", "E"),
        d("\u1EBE", "E"),
        d("\u1EC4", "E"),
        d("\u1EC2", "E"),
        d("\u1EBC", "E"),
        d("\u0112", "E"),
        d("\u1E14", "E"),
        d("\u1E16", "E"),
        d("\u0114", "E"),
        d("\u0116", "E"),
        d("\xcb", "E"),
        d("\u1EBA", "E"),
        d("\u011A", "E"),
        d("\u0204", "E"),
        d("\u0206", "E"),
        d("\u1EB8", "E"),
        d("\u1EC6", "E"),
        d("\u0228", "E"),
        d("\u1E1C", "E"),
        d("\u0118", "E"),
        d("\u1E18", "E"),
        d("\u1E1A", "E"),
        d("\u0190", "E"),
        d("\u018E", "E"),
        d("F", "F"),
        d("\u24BB", "F"),
        d("\uFF26", "F"),
        d("\u1E1E", "F"),
        d("\u0191", "F"),
        d("\uA77B", "F"),
        d("G", "G"),
        d("\u24BC", "G"),
        d("\uFF27", "G"),
        d("\u01F4", "G"),
        d("\u011C", "G"),
        d("\u1E20", "G"),
        d("\u011E", "G"),
        d("\u0120", "G"),
        d("\u01E6", "G"),
        d("\u0122", "G"),
        d("\u01E4", "G"),
        d("\u0193", "G"),
        d("\uA7A0", "G"),
        d("\uA77D", "G"),
        d("\uA77E", "G"),
        d("H", "H"),
        d("\u24BD", "H"),
        d("\uFF28", "H"),
        d("\u0124", "H"),
        d("\u1E22", "H"),
        d("\u1E26", "H"),
        d("\u021E", "H"),
        d("\u1E24", "H"),
        d("\u1E28", "H"),
        d("\u1E2A", "H"),
        d("\u0126", "H"),
        d("\u2C67", "H"),
        d("\u2C75", "H"),
        d("\uA78D", "H"),
        d("I", "I"),
        d("\u24BE", "I"),
        d("\uFF29", "I"),
        d("\xcc", "I"),
        d("\xcd", "I"),
        d("\xce", "I"),
        d("\u0128", "I"),
        d("\u012A", "I"),
        d("\u012C", "I"),
        d("\u0130", "I"),
        d("\xcf", "I"),
        d("\u1E2E", "I"),
        d("\u1EC8", "I"),
        d("\u01CF", "I"),
        d("\u0208", "I"),
        d("\u020A", "I"),
        d("\u1ECA", "I"),
        d("\u012E", "I"),
        d("\u1E2C", "I"),
        d("\u0197", "I"),
        d("J", "J"),
        d("\u24BF", "J"),
        d("\uFF2A", "J"),
        d("\u0134", "J"),
        d("\u0248", "J"),
        d("K", "K"),
        d("\u24C0", "K"),
        d("\uFF2B", "K"),
        d("\u1E30", "K"),
        d("\u01E8", "K"),
        d("\u1E32", "K"),
        d("\u0136", "K"),
        d("\u1E34", "K"),
        d("\u0198", "K"),
        d("\u2C69", "K"),
        d("\uA740", "K"),
        d("\uA742", "K"),
        d("\uA744", "K"),
        d("\uA7A2", "K"),
        d("L", "L"),
        d("\u24C1", "L"),
        d("\uFF2C", "L"),
        d("\u013F", "L"),
        d("\u0139", "L"),
        d("\u013D", "L"),
        d("\u1E36", "L"),
        d("\u1E38", "L"),
        d("\u013B", "L"),
        d("\u1E3C", "L"),
        d("\u1E3A", "L"),
        d("\u0141", "L"),
        d("\u023D", "L"),
        d("\u2C62", "L"),
        d("\u2C60", "L"),
        d("\uA748", "L"),
        d("\uA746", "L"),
        d("\uA780", "L"),
        d("\u01C7", "LJ"),
        d("\u01C8", "Lj"),
        d("M", "M"),
        d("\u24C2", "M"),
        d("\uFF2D", "M"),
        d("\u1E3E", "M"),
        d("\u1E40", "M"),
        d("\u1E42", "M"),
        d("\u2C6E", "M"),
        d("\u019C", "M"),
        d("N", "N"),
        d("\u24C3", "N"),
        d("\uFF2E", "N"),
        d("\u01F8", "N"),
        d("\u0143", "N"),
        d("\xd1", "N"),
        d("\u1E44", "N"),
        d("\u0147", "N"),
        d("\u1E46", "N"),
        d("\u0145", "N"),
        d("\u1E4A", "N"),
        d("\u1E48", "N"),
        d("\u0220", "N"),
        d("\u019D", "N"),
        d("\uA790", "N"),
        d("\uA7A4", "N"),
        d("\u01CA", "NJ"),
        d("\u01CB", "Nj"),
        d("O", "O"),
        d("\u24C4", "O"),
        d("\uFF2F", "O"),
        d("\xd2", "O"),
        d("\xd3", "O"),
        d("\xd4", "O"),
        d("\u1ED2", "O"),
        d("\u1ED0", "O"),
        d("\u1ED6", "O"),
        d("\u1ED4", "O"),
        d("\xd5", "O"),
        d("\u1E4C", "O"),
        d("\u022C", "O"),
        d("\u1E4E", "O"),
        d("\u014C", "O"),
        d("\u1E50", "O"),
        d("\u1E52", "O"),
        d("\u014E", "O"),
        d("\u022E", "O"),
        d("\u0230", "O"),
        d("\xd6", "O"),
        d("\u022A", "O"),
        d("\u1ECE", "O"),
        d("\u0150", "O"),
        d("\u01D1", "O"),
        d("\u020C", "O"),
        d("\u020E", "O"),
        d("\u01A0", "O"),
        d("\u1EDC", "O"),
        d("\u1EDA", "O"),
        d("\u1EE0", "O"),
        d("\u1EDE", "O"),
        d("\u1EE2", "O"),
        d("\u1ECC", "O"),
        d("\u1ED8", "O"),
        d("\u01EA", "O"),
        d("\u01EC", "O"),
        d("\xd8", "O"),
        d("\u01FE", "O"),
        d("\u0186", "O"),
        d("\u019F", "O"),
        d("\uA74A", "O"),
        d("\uA74C", "O"),
        d("\u01A2", "OI"),
        d("\uA74E", "OO"),
        d("\u0222", "OU"),
        d("\x8c", "OE"),
        d("\u0152", "OE"),
        d("\x9c", "oe"),
        d("\u0153", "oe"),
        d("P", "P"),
        d("\u24C5", "P"),
        d("\uFF30", "P"),
        d("\u1E54", "P"),
        d("\u1E56", "P"),
        d("\u01A4", "P"),
        d("\u2C63", "P"),
        d("\uA750", "P"),
        d("\uA752", "P"),
        d("\uA754", "P"),
        d("Q", "Q"),
        d("\u24C6", "Q"),
        d("\uFF31", "Q"),
        d("\uA756", "Q"),
        d("\uA758", "Q"),
        d("\u024A", "Q"),
        d("R", "R"),
        d("\u24C7", "R"),
        d("\uFF32", "R"),
        d("\u0154", "R"),
        d("\u1E58", "R"),
        d("\u0158", "R"),
        d("\u0210", "R"),
        d("\u0212", "R"),
        d("\u1E5A", "R"),
        d("\u1E5C", "R"),
        d("\u0156", "R"),
        d("\u1E5E", "R"),
        d("\u024C", "R"),
        d("\u2C64", "R"),
        d("\uA75A", "R"),
        d("\uA7A6", "R"),
        d("\uA782", "R"),
        d("S", "S"),
        d("\u24C8", "S"),
        d("\uFF33", "S"),
        d("\u1E9E", "S"),
        d("\u015A", "S"),
        d("\u1E64", "S"),
        d("\u015C", "S"),
        d("\u1E60", "S"),
        d("\u0160", "S"),
        d("\u1E66", "S"),
        d("\u1E62", "S"),
        d("\u1E68", "S"),
        d("\u0218", "S"),
        d("\u015E", "S"),
        d("\u2C7E", "S"),
        d("\uA7A8", "S"),
        d("\uA784", "S"),
        d("T", "T"),
        d("\u24C9", "T"),
        d("\uFF34", "T"),
        d("\u1E6A", "T"),
        d("\u0164", "T"),
        d("\u1E6C", "T"),
        d("\u021A", "T"),
        d("\u0162", "T"),
        d("\u1E70", "T"),
        d("\u1E6E", "T"),
        d("\u0166", "T"),
        d("\u01AC", "T"),
        d("\u01AE", "T"),
        d("\u023E", "T"),
        d("\uA786", "T"),
        d("\uA728", "TZ"),
        d("U", "U"),
        d("\u24CA", "U"),
        d("\uFF35", "U"),
        d("\xd9", "U"),
        d("\xda", "U"),
        d("\xdb", "U"),
        d("\u0168", "U"),
        d("\u1E78", "U"),
        d("\u016A", "U"),
        d("\u1E7A", "U"),
        d("\u016C", "U"),
        d("\xdc", "U"),
        d("\u01DB", "U"),
        d("\u01D7", "U"),
        d("\u01D5", "U"),
        d("\u01D9", "U"),
        d("\u1EE6", "U"),
        d("\u016E", "U"),
        d("\u0170", "U"),
        d("\u01D3", "U"),
        d("\u0214", "U"),
        d("\u0216", "U"),
        d("\u01AF", "U"),
        d("\u1EEA", "U"),
        d("\u1EE8", "U"),
        d("\u1EEE", "U"),
        d("\u1EEC", "U"),
        d("\u1EF0", "U"),
        d("\u1EE4", "U"),
        d("\u1E72", "U"),
        d("\u0172", "U"),
        d("\u1E76", "U"),
        d("\u1E74", "U"),
        d("\u0244", "U"),
        d("V", "V"),
        d("\u24CB", "V"),
        d("\uFF36", "V"),
        d("\u1E7C", "V"),
        d("\u1E7E", "V"),
        d("\u01B2", "V"),
        d("\uA75E", "V"),
        d("\u0245", "V"),
        d("\uA760", "VY"),
        d("W", "W"),
        d("\u24CC", "W"),
        d("\uFF37", "W"),
        d("\u1E80", "W"),
        d("\u1E82", "W"),
        d("\u0174", "W"),
        d("\u1E86", "W"),
        d("\u1E84", "W"),
        d("\u1E88", "W"),
        d("\u2C72", "W"),
        d("X", "X"),
        d("\u24CD", "X"),
        d("\uFF38", "X"),
        d("\u1E8A", "X"),
        d("\u1E8C", "X"),
        d("Y", "Y"),
        d("\u24CE", "Y"),
        d("\uFF39", "Y"),
        d("\u1EF2", "Y"),
        d("\xdd", "Y"),
        d("\u0176", "Y"),
        d("\u1EF8", "Y"),
        d("\u0232", "Y"),
        d("\u1E8E", "Y"),
        d("\u0178", "Y"),
        d("\u1EF6", "Y"),
        d("\u1EF4", "Y"),
        d("\u01B3", "Y"),
        d("\u024E", "Y"),
        d("\u1EFE", "Y"),
        d("Z", "Z"),
        d("\u24CF", "Z"),
        d("\uFF3A", "Z"),
        d("\u0179", "Z"),
        d("\u1E90", "Z"),
        d("\u017B", "Z"),
        d("\u017D", "Z"),
        d("\u1E92", "Z"),
        d("\u1E94", "Z"),
        d("\u01B5", "Z"),
        d("\u0224", "Z"),
        d("\u2C7F", "Z"),
        d("\u2C6B", "Z"),
        d("\uA762", "Z"),
        d("a", "a"),
        d("\u24D0", "a"),
        d("\uFF41", "a"),
        d("\u1E9A", "a"),
        d("\xe0", "a"),
        d("\xe1", "a"),
        d("\xe2", "a"),
        d("\u1EA7", "a"),
        d("\u1EA5", "a"),
        d("\u1EAB", "a"),
        d("\u1EA9", "a"),
        d("\xe3", "a"),
        d("\u0101", "a"),
        d("\u0103", "a"),
        d("\u1EB1", "a"),
        d("\u1EAF", "a"),
        d("\u1EB5", "a"),
        d("\u1EB3", "a"),
        d("\u0227", "a"),
        d("\u01E1", "a"),
        d("\xe4", "a"),
        d("\u01DF", "a"),
        d("\u1EA3", "a"),
        d("\xe5", "a"),
        d("\u01FB", "a"),
        d("\u01CE", "a"),
        d("\u0201", "a"),
        d("\u0203", "a"),
        d("\u1EA1", "a"),
        d("\u1EAD", "a"),
        d("\u1EB7", "a"),
        d("\u1E01", "a"),
        d("\u0105", "a"),
        d("\u2C65", "a"),
        d("\u0250", "a"),
        d("\uA733", "aa"),
        d("\xe6", "ae"),
        d("\u01FD", "ae"),
        d("\u01E3", "ae"),
        d("\uA735", "ao"),
        d("\uA737", "au"),
        d("\uA739", "av"),
        d("\uA73B", "av"),
        d("\uA73D", "ay"),
        d("b", "b"),
        d("\u24D1", "b"),
        d("\uFF42", "b"),
        d("\u1E03", "b"),
        d("\u1E05", "b"),
        d("\u1E07", "b"),
        d("\u0180", "b"),
        d("\u0183", "b"),
        d("\u0253", "b"),
        d("c", "c"),
        d("\u24D2", "c"),
        d("\uFF43", "c"),
        d("\u0107", "c"),
        d("\u0109", "c"),
        d("\u010B", "c"),
        d("\u010D", "c"),
        d("\xe7", "c"),
        d("\u1E09", "c"),
        d("\u0188", "c"),
        d("\u023C", "c"),
        d("\uA73F", "c"),
        d("\u2184", "c"),
        d("d", "d"),
        d("\u24D3", "d"),
        d("\uFF44", "d"),
        d("\u1E0B", "d"),
        d("\u010F", "d"),
        d("\u1E0D", "d"),
        d("\u1E11", "d"),
        d("\u1E13", "d"),
        d("\u1E0F", "d"),
        d("\u0111", "d"),
        d("\u018C", "d"),
        d("\u0256", "d"),
        d("\u0257", "d"),
        d("\uA77A", "d"),
        d("\u01F3", "dz"),
        d("\u01C6", "dz"),
        d("e", "e"),
        d("\u24D4", "e"),
        d("\uFF45", "e"),
        d("\xe8", "e"),
        d("\xe9", "e"),
        d("\xea", "e"),
        d("\u1EC1", "e"),
        d("\u1EBF", "e"),
        d("\u1EC5", "e"),
        d("\u1EC3", "e"),
        d("\u1EBD", "e"),
        d("\u0113", "e"),
        d("\u1E15", "e"),
        d("\u1E17", "e"),
        d("\u0115", "e"),
        d("\u0117", "e"),
        d("\xeb", "e"),
        d("\u1EBB", "e"),
        d("\u011B", "e"),
        d("\u0205", "e"),
        d("\u0207", "e"),
        d("\u1EB9", "e"),
        d("\u1EC7", "e"),
        d("\u0229", "e"),
        d("\u1E1D", "e"),
        d("\u0119", "e"),
        d("\u1E19", "e"),
        d("\u1E1B", "e"),
        d("\u0247", "e"),
        d("\u025B", "e"),
        d("\u01DD", "e"),
        d("f", "f"),
        d("\u24D5", "f"),
        d("\uFF46", "f"),
        d("\u1E1F", "f"),
        d("\u0192", "f"),
        d("\uA77C", "f"),
        d("g", "g"),
        d("\u24D6", "g"),
        d("\uFF47", "g"),
        d("\u01F5", "g"),
        d("\u011D", "g"),
        d("\u1E21", "g"),
        d("\u011F", "g"),
        d("\u0121", "g"),
        d("\u01E7", "g"),
        d("\u0123", "g"),
        d("\u01E5", "g"),
        d("\u0260", "g"),
        d("\uA7A1", "g"),
        d("\u1D79", "g"),
        d("\uA77F", "g"),
        d("h", "h"),
        d("\u24D7", "h"),
        d("\uFF48", "h"),
        d("\u0125", "h"),
        d("\u1E23", "h"),
        d("\u1E27", "h"),
        d("\u021F", "h"),
        d("\u1E25", "h"),
        d("\u1E29", "h"),
        d("\u1E2B", "h"),
        d("\u1E96", "h"),
        d("\u0127", "h"),
        d("\u2C68", "h"),
        d("\u2C76", "h"),
        d("\u0265", "h"),
        d("\u0195", "hv"),
        d("i", "i"),
        d("\u24D8", "i"),
        d("\uFF49", "i"),
        d("\xec", "i"),
        d("\xed", "i"),
        d("\xee", "i"),
        d("\u0129", "i"),
        d("\u012B", "i"),
        d("\u012D", "i"),
        d("\xef", "i"),
        d("\u1E2F", "i"),
        d("\u1EC9", "i"),
        d("\u01D0", "i"),
        d("\u0209", "i"),
        d("\u020B", "i"),
        d("\u1ECB", "i"),
        d("\u012F", "i"),
        d("\u1E2D", "i"),
        d("\u0268", "i"),
        d("\u0131", "i"),
        d("j", "j"),
        d("\u24D9", "j"),
        d("\uFF4A", "j"),
        d("\u0135", "j"),
        d("\u01F0", "j"),
        d("\u0249", "j"),
        d("k", "k"),
        d("\u24DA", "k"),
        d("\uFF4B", "k"),
        d("\u1E31", "k"),
        d("\u01E9", "k"),
        d("\u1E33", "k"),
        d("\u0137", "k"),
        d("\u1E35", "k"),
        d("\u0199", "k"),
        d("\u2C6A", "k"),
        d("\uA741", "k"),
        d("\uA743", "k"),
        d("\uA745", "k"),
        d("\uA7A3", "k"),
        d("l", "l"),
        d("\u24DB", "l"),
        d("\uFF4C", "l"),
        d("\u0140", "l"),
        d("\u013A", "l"),
        d("\u013E", "l"),
        d("\u1E37", "l"),
        d("\u1E39", "l"),
        d("\u013C", "l"),
        d("\u1E3D", "l"),
        d("\u1E3B", "l"),
        d("\u017F", "l"),
        d("\u0142", "l"),
        d("\u019A", "l"),
        d("\u026B", "l"),
        d("\u2C61", "l"),
        d("\uA749", "l"),
        d("\uA781", "l"),
        d("\uA747", "l"),
        d("\u01C9", "lj"),
        d("m", "m"),
        d("\u24DC", "m"),
        d("\uFF4D", "m"),
        d("\u1E3F", "m"),
        d("\u1E41", "m"),
        d("\u1E43", "m"),
        d("\u0271", "m"),
        d("\u026F", "m"),
        d("n", "n"),
        d("\u24DD", "n"),
        d("\uFF4E", "n"),
        d("\u01F9", "n"),
        d("\u0144", "n"),
        d("\xf1", "n"),
        d("\u1E45", "n"),
        d("\u0148", "n"),
        d("\u1E47", "n"),
        d("\u0146", "n"),
        d("\u1E4B", "n"),
        d("\u1E49", "n"),
        d("\u019E", "n"),
        d("\u0272", "n"),
        d("\u0149", "n"),
        d("\uA791", "n"),
        d("\uA7A5", "n"),
        d("\u01CC", "nj"),
        d("o", "o"),
        d("\u24DE", "o"),
        d("\uFF4F", "o"),
        d("\xf2", "o"),
        d("\xf3", "o"),
        d("\xf4", "o"),
        d("\u1ED3", "o"),
        d("\u1ED1", "o"),
        d("\u1ED7", "o"),
        d("\u1ED5", "o"),
        d("\xf5", "o"),
        d("\u1E4D", "o"),
        d("\u022D", "o"),
        d("\u1E4F", "o"),
        d("\u014D", "o"),
        d("\u1E51", "o"),
        d("\u1E53", "o"),
        d("\u014F", "o"),
        d("\u022F", "o"),
        d("\u0231", "o"),
        d("\xf6", "o"),
        d("\u022B", "o"),
        d("\u1ECF", "o"),
        d("\u0151", "o"),
        d("\u01D2", "o"),
        d("\u020D", "o"),
        d("\u020F", "o"),
        d("\u01A1", "o"),
        d("\u1EDD", "o"),
        d("\u1EDB", "o"),
        d("\u1EE1", "o"),
        d("\u1EDF", "o"),
        d("\u1EE3", "o"),
        d("\u1ECD", "o"),
        d("\u1ED9", "o"),
        d("\u01EB", "o"),
        d("\u01ED", "o"),
        d("\xf8", "o"),
        d("\u01FF", "o"),
        d("\u0254", "o"),
        d("\uA74B", "o"),
        d("\uA74D", "o"),
        d("\u0275", "o"),
        d("\u01A3", "oi"),
        d("\u0223", "ou"),
        d("\uA74F", "oo"),
        d("p", "p"),
        d("\u24DF", "p"),
        d("\uFF50", "p"),
        d("\u1E55", "p"),
        d("\u1E57", "p"),
        d("\u01A5", "p"),
        d("\u1D7D", "p"),
        d("\uA751", "p"),
        d("\uA753", "p"),
        d("\uA755", "p"),
        d("q", "q"),
        d("\u24E0", "q"),
        d("\uFF51", "q"),
        d("\u024B", "q"),
        d("\uA757", "q"),
        d("\uA759", "q"),
        d("r", "r"),
        d("\u24E1", "r"),
        d("\uFF52", "r"),
        d("\u0155", "r"),
        d("\u1E59", "r"),
        d("\u0159", "r"),
        d("\u0211", "r"),
        d("\u0213", "r"),
        d("\u1E5B", "r"),
        d("\u1E5D", "r"),
        d("\u0157", "r"),
        d("\u1E5F", "r"),
        d("\u024D", "r"),
        d("\u027D", "r"),
        d("\uA75B", "r"),
        d("\uA7A7", "r"),
        d("\uA783", "r"),
        d("s", "s"),
        d("\u24E2", "s"),
        d("\uFF53", "s"),
        d("\xdf", "s"),
        d("\u015B", "s"),
        d("\u1E65", "s"),
        d("\u015D", "s"),
        d("\u1E61", "s"),
        d("\u0161", "s"),
        d("\u1E67", "s"),
        d("\u1E63", "s"),
        d("\u1E69", "s"),
        d("\u0219", "s"),
        d("\u015F", "s"),
        d("\u023F", "s"),
        d("\uA7A9", "s"),
        d("\uA785", "s"),
        d("\u1E9B", "s"),
        d("t", "t"),
        d("\u24E3", "t"),
        d("\uFF54", "t"),
        d("\u1E6B", "t"),
        d("\u1E97", "t"),
        d("\u0165", "t"),
        d("\u1E6D", "t"),
        d("\u021B", "t"),
        d("\u0163", "t"),
        d("\u1E71", "t"),
        d("\u1E6F", "t"),
        d("\u0167", "t"),
        d("\u01AD", "t"),
        d("\u0288", "t"),
        d("\u2C66", "t"),
        d("\uA787", "t"),
        d("\uA729", "tz"),
        d("u", "u"),
        d("\u24E4", "u"),
        d("\uFF55", "u"),
        d("\xf9", "u"),
        d("\xfa", "u"),
        d("\xfb", "u"),
        d("\u0169", "u"),
        d("\u1E79", "u"),
        d("\u016B", "u"),
        d("\u1E7B", "u"),
        d("\u016D", "u"),
        d("\xfc", "u"),
        d("\u01DC", "u"),
        d("\u01D8", "u"),
        d("\u01D6", "u"),
        d("\u01DA", "u"),
        d("\u1EE7", "u"),
        d("\u016F", "u"),
        d("\u0171", "u"),
        d("\u01D4", "u"),
        d("\u0215", "u"),
        d("\u0217", "u"),
        d("\u01B0", "u"),
        d("\u1EEB", "u"),
        d("\u1EE9", "u"),
        d("\u1EEF", "u"),
        d("\u1EED", "u"),
        d("\u1EF1", "u"),
        d("\u1EE5", "u"),
        d("\u1E73", "u"),
        d("\u0173", "u"),
        d("\u1E77", "u"),
        d("\u1E75", "u"),
        d("\u0289", "u"),
        d("v", "v"),
        d("\u24E5", "v"),
        d("\uFF56", "v"),
        d("\u1E7D", "v"),
        d("\u1E7F", "v"),
        d("\u028B", "v"),
        d("\uA75F", "v"),
        d("\u028C", "v"),
        d("\uA761", "vy"),
        d("w", "w"),
        d("\u24E6", "w"),
        d("\uFF57", "w"),
        d("\u1E81", "w"),
        d("\u1E83", "w"),
        d("\u0175", "w"),
        d("\u1E87", "w"),
        d("\u1E85", "w"),
        d("\u1E98", "w"),
        d("\u1E89", "w"),
        d("\u2C73", "w"),
        d("x", "x"),
        d("\u24E7", "x"),
        d("\uFF58", "x"),
        d("\u1E8B", "x"),
        d("\u1E8D", "x"),
        d("y", "y"),
        d("\u24E8", "y"),
        d("\uFF59", "y"),
        d("\u1EF3", "y"),
        d("\xfd", "y"),
        d("\u0177", "y"),
        d("\u1EF9", "y"),
        d("\u0233", "y"),
        d("\u1E8F", "y"),
        d("\xff", "y"),
        d("\u1EF7", "y"),
        d("\u1E99", "y"),
        d("\u1EF5", "y"),
        d("\u01B4", "y"),
        d("\u024F", "y"),
        d("\u1EFF", "y"),
        d("z", "z"),
        d("\u24E9", "z"),
        d("\uFF5A", "z"),
        d("\u017A", "z"),
        d("\u1E91", "z"),
        d("\u017C", "z"),
        d("\u017E", "z"),
        d("\u1E93", "z"),
        d("\u1E95", "z"),
        d("\u01B6", "z")
    ]), jw = il(Cw), ww = function(n) {
        return A3(Ia, F2(function(n, r) {
            var t = A2(Lo, n, jw);
            return $(r, t.$ ? eb(n) : t.a);
        }), "", n);
    }, Aw = A2(mu, zi, ww), Lw = F2(function(n, r) {
        var t = d(n, r);
        if (t.a.$) return t.b.$ ? A2(ku, t.a.a, t.b.a) : 0;
        if (t.b.$) return 2;
        var e = t.b.a;
        return A2(ku, Aw(t.a.a), Aw(e));
    }), yw = F2(function(n, r) {
        n: for(;;){
            var t = d(n, r);
            if (t.a.b) {
                if (t.b.b) {
                    var e = t.a, u = e.b, a = t.b, i = a.b, o = A2(Lw, e.a, a.a);
                    if (1 === o) {
                        n = u, r = i;
                        continue n;
                    }
                    return o;
                }
                return 2;
            }
            return t.b.b ? 0 : 1;
        }
    }), Sw = A2(Qu, ik, ak("[0-9]+|[^0-9]+")), Fw = st(dt), Tw = P, Qw = function(n) {
        return Tw(n) ? Ct : kt({
            $: 1,
            a: n
        });
    }, Iw = function(n) {
        return A2(Qu, {
            $: 0,
            a: n
        }, A2(Lp, Qw, Oe(n)));
    }, Bw = function(n) {
        return A2(Ge, A2(mu, Iw, function(n) {
            return n.b4;
        }), A2(Fw, Sw, n));
    }, Ww = F3(function(n, r, t) {
        return A2(yw, Bw(n(r)), Bw(n(t)));
    }), Pw = L, Mw = Pw(Ww(tl)), qw = F2(function(n, r) {
        return A2(kw, A2(mu, r, Mw), n);
    }), Dw = function(n) {
        return A2(qC, function(r) {
            var t = A2(bt, d("", ""), A2(Ge, function(n) {
                return d(n.a, n.b.nW);
            }, pt(n.oD))), e = function(n) {
                return 1 !== n.oF.$;
            }(r) ? d("Save", "Edit Channel") : d("Create", "New Channel");
            return A4(oj, e.b, d(e.a, vw), d("Cancel", bw), C([
                A2(Sk, pw, A2(qw, t, rj(r.oz))),
                A2(Sk, mw, VC(r.nW))
            ]));
        }, n.kL);
    }, Xw = F2(function(n, r) {
        var t, e;
        return A3(Wj, "Channels", kt(A2(Dh, "New\u2026", aw)), A2(Se, g, C([
            Dw(r),
            A2(dw, cw, (t = d(r.cJ, r.oD), e = t.b, A2(Ge, function(n) {
                var r;
                return C([
                    A2(Dh, "Edit", (r = n, {
                        $: 2,
                        a: r
                    })),
                    ch(A2(ow, e, n)),
                    ch(n.sa),
                    A2(Kg, Wh, iw(n))
                ]);
            }, t.a)))
        ])));
    }), Ew = {
        l: function(n) {
            return n.cJ;
        },
        m: Vj,
        p: F2(function(n, r) {
            return p(n, {
                cJ: r
            });
        }),
        q: function(n) {
            return {
                $: 8,
                a: n
            };
        },
        r: uw,
        s: Xw
    }, Rw = function(n) {
        return {
            $: 5,
            a: n
        };
    }, xw = A2(Rs, Rw, Al(A2(_s, J$, Vs(K$)))), Ow = function(n) {
        return {
            $: 6,
            a: n
        };
    }, zw = $l(i$), Nw = function(n) {
        return {
            $: 12,
            a: n
        };
    }, Hw = xs(Nw({
        $: 2
    })), Vw = A2(Rs, Ow, Al(A2(_s, zw, Vs(Hw)))), Uw = {
        kt: g,
        m_: !1,
        nc: !1,
        oD: g,
        oK: kv(Ct),
        rs: k$("Completed At"),
        dU: g
    }, Jw = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Zw = Ye, Kw = function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return {
                                                            C: l,
                                                            io: d,
                                                            j_: u,
                                                            j$: s,
                                                            ke: t,
                                                            lt: i,
                                                            mj: n,
                                                            fO: r,
                                                            oz: o,
                                                            pr: c,
                                                            g9: a,
                                                            qP: e,
                                                            qQ: f
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }, _w = function(n) {
        switch(n){
            case "DownloadAsIs":
                return yt(0);
            case "PADTranscode":
                return yt(1);
            case "SimpleTranscode":
                return yt(2);
            case "QC":
                return yt(3);
            case "Spotcheck":
                return yt(4);
            default:
                return jt("job type not found");
        }
    }, Gw = function(n) {
        switch(n){
            case 0:
                return "DownloadAsIs";
            case 1:
                return "PADTranscode";
            case 2:
                return "SimpleTranscode";
            case 3:
                return "QC";
            default:
                return "Spotcheck";
        }
    }, Yw = A2(zl, Gw, _w), nA = ul(A4(ll, "acknowledgedBy", function(n) {
        return n.io;
    }, hb(Di), A4(ll, "acknowledge", function(n) {
        return n.C;
    }, Zi, A4(ll, "completedBy", function(n) {
        return n.j$;
    }, hb(Di), A4(ll, "startedBy", function(n) {
        return n.qQ;
    }, hb(Di), A4(ll, "requester", function(n) {
        return n.pr;
    }, Di, A4(ll, "organization", function(n) {
        return n.oz;
    }, Di, A4(kb, "externalJobId", function(n) {
        return n.lt;
    }, Di, A4(ll, "show", function(n) {
        return n.g9;
    }, Di, A4(kb, "completedAt", function(n) {
        return n.j_;
    }, bb, A4(kb, "startedAt", function(n) {
        return n.qP;
    }, bb, A4(ll, "createdAt", function(n) {
        return n.ke;
    }, bb, A4(ll, "jobType", function(n) {
        return n.fO;
    }, Yw, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(Kw))))))))))))))), rA = $l(nA), tA = function(n) {
        return {
            $: 24,
            a: n
        };
    }, eA = xs(tA({
        $: 3
    })), uA = Al(A2(_s, rA, Vs(eA))), aA = function(n) {
        return {
            ha: n
        };
    }, iA = function(n) {
        return {
            $: 26,
            a: n
        };
    }, oA = xs(iA({
        $: 0
    })), cA = ul(A4(ll, "showIds", function(n) {
        return n.ha;
    }, $l(Di), gl(aA))), fA = F2(function(n, r) {
        return {
            gu: r,
            qs: n
        };
    }), sA = function(n) {
        return {
            sa: n
        };
    }, lA = ul(A4(ll, "value", function(n) {
        return n.sa;
    }, Di, gl(sA))), dA = ul(A4(ll, "path", function(n) {
        return n.gu;
    }, $l(lA), A4(ll, "showId", function(n) {
        return n.qs;
    }, Di, gl(fA)))), bA = $l(dA), mA = F2(function(n, r) {
        var t;
        return (t = n.mj, function(n) {
            return function(r) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return {
                                                            C: l,
                                                            io: d,
                                                            j_: u,
                                                            j$: s,
                                                            ke: r,
                                                            lt: i,
                                                            mj: t,
                                                            fO: n,
                                                            oz: o,
                                                            pr: c,
                                                            qu: a,
                                                            qP: e,
                                                            qQ: f
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        })(n.fO)(n.ke)(n.qP)(n.j_)(r)(n.lt)(n.oz)(n.pr)(n.qQ)(n.j$)(n.C)(n.io);
    }), pA = F2(function(n, r) {
        return A2(mA, r, A2(Qu, A2(fA, r.mj, C([
            sA(r.mj)
        ])), Ra(A2(Bu, function(n) {
            return i(n.qs, r.g9);
        }, n))));
    }), vA = function(n) {
        return A2(bp, function(r) {
            return A2(Ge, pA(r), n);
        }, Al(A2(_s, bA, A3(kg, cA, aA(A2(Ge, function(n) {
            return n.g9;
        }, n)), $g(oA)))));
    }, $A = A2(Zw, vA, uA), gA = A2(Rs, Jw, $A), hA = A2(eo, C([
        gA,
        xw,
        Vw
    ]), Uw), kA = function(n) {
        return {
            $: 11,
            a: n
        };
    }, CA = Je, jA = function(n) {
        return A2(b$, Hl({
            $: 8,
            a: n
        }), CA(0));
    }, wA = function(n) {
        return to(C([
            gA,
            jA(n)
        ]));
    }, AA = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(eo, g, r);
            case 9:
                return A2(eo, g, p(r, {
                    kt: g
                }));
            case 4:
                return A2(eo, g, p(r, {
                    rs: n.a
                }));
            case 7:
                return A2(eo, g, p(r, {
                    m_: !r.m_
                }));
            case 2:
                return A2(eo, g, p(r, (u = n.a).$ ? {
                    kt: g
                } : {
                    kt: u.a,
                    nc: !1
                }));
            case 1:
                return A2(eo, C([
                    gA
                ]), r);
            case 5:
                return A2(eo, g, (u = n.a).$ ? r : p(r, {
                    oD: u.a
                }));
            case 6:
                return A2(eo, g, (u = n.a).$ ? r : p(r, {
                    dU: u.a
                }));
            case 8:
                return A2(eo, g, p(r, {
                    oK: e = n.a
                }));
            case 3:
                var t = n.a, e = t.a;
                return A2(eo, g, (u = t.b).$ ? r : p(r, {
                    kt: u.a,
                    nc: !1,
                    oK: e
                }));
            case 10:
                return A2(eo, C([
                    A2(Rs, kA, (a = n.a.mj, Al(Lg(Sg(xs(iA({
                        $: 1,
                        a: a
                    })))))))
                ]), r);
            default:
                var u;
                return A2(eo, (u = n.a).$ ? g : C([
                    wA(r.oK)
                ]), r);
        }
        var a;
    }), LA = {
        $: 1
    }, yA = ye("h2"), SA = F3(function(n, r, t) {
        return A2(Se, C([
            A2(gh, "margin", "10px")
        ]), C([
            A2(yA, g, C([
                ch(r)
            ])),
            t
        ]));
    }), FA = function(n) {
        return Kw(n.mj)(n.fO)(n.ke)(n.qP)(n.j_)(n.qu.qs)(n.lt)(n.oz)(n.pr)(n.qQ)(n.j$)(n.C)(n.io);
    }, TA = {
        $: 7
    }, QA = F2(function(n, r) {
        return A2(Qu, n, A2(Tu, function(r) {
            return $(n, r ? "true" : "false");
        }, r));
    }), IA = function(n) {
        var r = b(n.oz, n.c9, n.Q);
        return 1 === r.a.$ ? 1 === r.b.$ ? 1 === r.c.$ ? "/jobs" + A2(QA, "?acknowledge=", n.C) : "/jobs?status=" + (r.c.a + A2(QA, "&acknowledge=", n.C)) : r.c.$ ? "/jobs?kind=" + (r.b.a + A2(QA, "&acknowledge=", n.C)) : "/jobs?kind=" + r.b.a + "&status=" + (r.c.a + A2(QA, "&acknowledge=", n.C)) : r.b.$ ? 1 === r.c.$ ? "/jobs?organization=" + (r.a.a + A2(QA, "&acknowledge=", n.C)) : "/jobs?organization=" + r.a.a + "&status=" + (r.c.a + A2(QA, "&acknowledge=", n.C)) : 1 === r.c.$ ? "/jobs?organization=" + r.a.a + "&kind=" + (r.b.a + A2(QA, "&acknowledge=", n.C)) : "/jobs?organization=" + r.a.a + "&kind=" + r.b.a + "&status=" + (r.c.a + A2(QA, "&acknowledge=", n.C));
    }, BA = function(n) {
        switch(n.$){
            case 0:
                return "/";
            case 1:
                var r = n.c;
                return "/show/" + (n.a + (Mv(n.b) + function() {
                    var n = d(r.bF, r.co);
                    n: for(;;){
                        if (1 === n.a.$) {
                            if (n.b.$ || n.b.a) break n;
                            return "?sortVerifByDate=";
                        }
                        if (1 === n.b.$) return "?broadcastable=" + n.a.a;
                        if (n.b.a) break n;
                        return "?broadcastable=" + n.a.a + "&sortVerifByDate=";
                    }
                    return "";
                }()));
            case 2:
                return "/hierarchy/" + n.a + (n.b ? "/settings" : "");
            case 3:
                return function(n) {
                    switch(n.$){
                        case 1:
                            return "/account/forgotPassword";
                        case 0:
                            var r = n.a.lV;
                            if (1 === r.$) return "/account/login";
                            switch(r.a){
                                case "/":
                                case "/logout":
                                    return "/account/login";
                                default:
                                    return "/account/login?from=" + r.a;
                            }
                        case 2:
                            return "/account/resetPassword?email=" + n.a.k6 + "&token=" + n.a.rH;
                        default:
                            var t = n.a;
                            return "/account/invitation?redirect=" + t.pl + "&email=" + t.k6 + "&token=" + t.rH;
                    }
                }(n.a);
            case 4:
                switch(n.a.$){
                    case 0:
                        return "/admin";
                    case 1:
                        return "/admin/adminOrganizations";
                    case 2:
                        return "/admin/onboarding";
                    case 3:
                        return "/admin/adminUsers";
                    case 4:
                        return "/admin/adminUploads";
                    case 5:
                        return "/admin/adminTestPlans";
                    case 6:
                        return "/admin/adminAudioMappings";
                    case 7:
                        return "/admin/adminChannels";
                    case 8:
                        return "/admin/adminResearchs";
                    case 9:
                        return "/admin/adminWebhooks";
                    case 10:
                        return "/admin/adminOrganizationFileListings";
                    case 11:
                        return "/admin/adminFormats";
                    case 12:
                        return "/admin/adminSubtitleFormats";
                    case 13:
                        return "/admin/adminSegmentationRules";
                    case 14:
                        return "/admin" + IA(r = n.a.a);
                    case 15:
                        return "/admin/metadata";
                    case 16:
                        return "/admin/deepProbe";
                    case 17:
                        return "/admin/probes";
                    default:
                        return "/admin" + function(n) {
                            var r = n.c9;
                            return r.$ ? "/dashboard" : "/dashboard?kind=" + r.a;
                        }(r = n.a.a);
                }
            case 5:
                return "/help/" + n.a;
            case 6:
                return "/archive";
            case 7:
                return "/upload";
            case 8:
                return "/settings";
            case 9:
                return "/report";
            default:
                return "/404";
        }
    }, WA = function(n) {
        return BA(Pp(ev(n)));
    }, PA = F2(function(n, r) {
        return b(i(n.oK.c9, kt(zi(r.a))), WA({
            c9: kt(zi(r.a))
        }), r.b);
    }), MA = function(n) {
        return n ? fk("CatchClickAll") : Zh(g);
    }, qA = function(n) {
        var r = n.a, t = n.b, e = n.c;
        return A2(hj, C([
            nh("SelectItem"),
            Zh(C([
                d("SelectItemSelected", r)
            ])),
            wj(t)
        ]), C([
            ch(e)
        ]));
    }, DA = F4(function(n, r, t, e) {
        var u = A2(Qu, e, Ra(A2(nc, function(n) {
            return n.a ? kt(n.c) : Ct;
        }, t)));
        return A2(Se, C([
            nh("Select"),
            Zh(C([
                d("SelectOpened", n)
            ])),
            Mh(r),
            MA(n)
        ]), C([
            A2(Se, C([
                nh("SelectButton")
            ]), C([
                A2(Se, C([
                    nh("SelectButtonIcon")
                ]), C([
                    JC
                ])),
                A2(_h, C([
                    nh("SelectButtonTitle")
                ]), u)
            ])),
            A2(Se, C([
                nh("SelectList")
            ]), A2(Ge, qA, t))
        ]));
    }), XA = function(n) {
        var r = C([
            d("", "All Types"),
            d("DownloadAsIs", "DownloadAsIs"),
            d("PadTranscode", "PadTranscode"),
            d("SimpleTranscode", "SimpleTranscode"),
            d("QC", "QC"),
            d("Spotcheck", "Spotcheck")
        ]);
        return A4(DA, n.m_, TA, A2(Ge, PA(n), r), "Filter by type");
    }, EA = function(n) {
        return {
            $: 10,
            a: n
        };
    }, RA = function(n) {
        return {
            $: 4,
            a: n
        };
    }, xA = F2(function(n, r) {
        return A2(eh, g, C([
            n(r)
        ]));
    }), OA = F2(function(n, r) {
        return th({
            nW: n,
            hf: rh,
            ie: xA(r)
        });
    }), zA = function(n) {
        return {
            $: 4,
            a: xi(n)
        };
    }, NA = function(n) {
        return n;
    }, HA = F3(function(n, r, t) {
        return th({
            nW: n,
            hf: zA(A2(mu, NA, t)),
            ie: xA(r)
        });
    }), VA = Ng("datetime"), UA = function(n) {
        return A3(ye, "format-time", C([
            VA(db(n))
        ]), C([
            ch(db(n))
        ]));
    }, JA = F2(function(n, r) {
        return A3(HA, n, function(n) {
            return UA(r(n));
        }, r);
    }), ZA = F2(function(n, r) {
        if (r.$) return "";
        var t = r.a;
        return A2(Qu, "", A2(Tu, function(n) {
            return n.nW;
        }, Ra(A2(Bu, function(n) {
            return i(n.mj, t);
        }, n))));
    }), KA = F2(function(n, r) {
        return A2(Qu, "", A2(Tu, function(n) {
            return n.nW;
        }, Ra(A2(Bu, function(n) {
            return i(n.mj, r);
        }, n.oD))));
    }), _A = F2(function(n, r) {
        return th({
            nW: n,
            hf: zA(A2(mu, A2(mu, function(n) {
                return A2(Qu, 0, n);
            }, Tu(NA)), r)),
            ie: xA(function(n) {
                return A2(Qu, A2(Se, g, g), A2(Tu, UA, r(n)));
            })
        });
    }), GA = function(n) {
        return A3(qt, F2(function(n, r) {
            return r + "/" + n;
        }), "", A2(Ge, function(n) {
            return n.sa;
        }, n.gu));
    }, YA = F2(function(n, r) {
        return {
            nW: n,
            hf: lh(r),
            ie: A2(mu, fh, r)
        };
    }), nL = C([
        nh("Table")
    ]), rL = function() {
        return C([
            nh("TableTr")
        ]);
    }, tL = function(n) {
        return ih({
            jW: C([
                A2(OA, "Acknowledge", A2(mu, Dh("Acknowledge"), EA)),
                A2(YA, "Organization", A2(mu, KA(n), function(n) {
                    return n.oz;
                })),
                A2(YA, "Type", A2(mu, Gw, function(n) {
                    return n.fO;
                })),
                A2(JA, "Created At", function(n) {
                    return n.ke;
                }),
                A2(YA, "Requester", A2(mu, A2(mu, ZA(n.dU), kt), function(n) {
                    return n.pr;
                })),
                A2(_A, "Started At", function(n) {
                    return n.qP;
                }),
                A2(YA, "Started By", A2(mu, ZA(n.dU), function(n) {
                    return n.qQ;
                })),
                A2(YA, "External Job Id", A2(mu, Qu(""), function(n) {
                    return n.lt;
                })),
                A2(OA, "Show", A2(mu, function(n) {
                    return A2(hj, C([
                        wj("/show/" + n.qs)
                    ]), C([
                        ch(GA(n))
                    ]));
                }, function(n) {
                    return n.qu;
                })),
                A2(YA, "Id", function(n) {
                    return n.mj;
                })
            ]),
            kr: p(wh, {
                pC: rL,
                rj: nL,
                rv: C([
                    nh("TableTd")
                ])
            }),
            rE: function(n) {
                return n.mj;
            },
            rF: RA
        });
    }, eL = F2(function(n, r) {
        return A2(Se, C([
            A2(gh, "margin", "10px")
        ]), C([
            wu(n.kt) ? ch("All jobs are completed !") : A3(jC, tL(n), n.rs, r)
        ]));
    }), uL = F2(function(n, r) {
        var t = r.oK.c9, e = A2(Bu, function(n) {
            if (t.$) return !0;
            var r = t.a;
            if (qe(r) > 0) {
                var e = FA(n);
                return i(zi(Gw(e.fO)), r);
            }
            return !0;
        }, r.kt);
        return A3(Wj, "Dashboard", kt(A2(Dh, "Refresh", LA)), A2(Se, g, C([
            A2(Se, C([
                nh("DarkZone"),
                nh("Filter")
            ]), C([
                A2(Se, C([
                    nh("JobsFilters")
                ]), C([
                    XA(r)
                ]))
            ])),
            A3(SA, r, "Not Completed Jobs: (" + Bt(Dt(e)) + ")", A2(eL, r, e))
        ])));
    }), aL = {
        l: function(n) {
            return n.cO;
        },
        m: hA,
        p: F2(function(n, r) {
            return p(n, {
                cO: r
            });
        }),
        q: function(n) {
            return {
                $: 0,
                a: n
            };
        },
        r: AA,
        s: uL
    }, iL = {
        kt: g,
        kL: Ct,
        ll: Ct,
        re: Ct,
        rs: k$("Id")
    }, oL = function(n) {
        return {
            $: 1,
            a: n
        };
    }, cL = function(n) {
        return {
            $: 25,
            a: n
        };
    }, fL = xs(cL({
        $: 1
    })), sL = F2(function(n, r) {
        return {
            jH: r,
            ak: n
        };
    }), lL = F3(function(n, r, t) {
        return {
            nB: t,
            nI: r,
            nW: n
        };
    }), dL = function(n) {
        switch(n){
            case "silence":
                return yt(0);
            case "blackframe":
                return yt(1);
            default:
                return jt("Deep Probe Kind not found");
        }
    }, bL = function(n) {
        return n ? "blackframe" : "silence";
    }, mL = A2(zl, bL, dL), pL = ul(A4(ll, "max", function(n) {
        return n.nB;
    }, ml, A4(ll, "min", function(n) {
        return n.nI;
    }, ml, A4(ll, "name", function(n) {
        return n.nW;
    }, mL, gl(lL))))), vL = $l(pL), $L = F2(function(n, r) {
        return {
            mj: n,
            nW: r
        };
    }), gL = ul(A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl($L)))), hL = ul(A4(ll, "checks", function(n) {
        return n.jH;
    }, vL, A4(ll, "configuration", function(n) {
        return n.ak;
    }, gL, gl(sL)))), kL = $l(hL), CL = A2(bp, xi(A2(Po, function(n) {
        return n.ak;
    }, function(n) {
        return n.mj;
    })), Al(A2(_s, kL, Vs(fL)))), jL = A2(Rs, oL, CL), wL = A2(eo, C([
        jL
    ]), iL), AL = function(n) {
        return b(Xi(function(r) {
            return p(r, {
                m$: "Type",
                sa: bL(n.nW)
            });
        }), Xi(function(r) {
            return p(r, {
                m$: "Min (ms for silence, frame for blackframe)",
                sa: Bt(n.nI)
            });
        }), Xi(function(r) {
            return p(r, {
                m$: "Max (ms for silence, frame for blackframe)",
                sa: Bt(n.nB)
            });
        }));
    }, LL = F2(function(n, r) {
        return p(r, {
            ll: kt(n.nE),
            re: Ct
        });
    }), yL = function(n) {
        return {
            $: 11,
            a: n
        };
    }, SL = F2(function(n, r) {
        return {
            jH: r,
            nW: n
        };
    }), FL = F2(function(n, r) {
        return {
            nW: n,
            aT: r
        };
    }), TL = F2(function(n, r) {
        return {
            nB: r,
            nI: n
        };
    }), QL = ul(A4(ll, "max", function(n) {
        return n.nB;
    }, ml, A4(ll, "min", function(n) {
        return n.nI;
    }, ml, gl(TL)))), IL = ul(A4(ll, "parameters", function(n) {
        return n.aT;
    }, QL, A4(ll, "name", function(n) {
        return n.nW;
    }, mL, gl(FL)))), BL = $l(IL), WL = ul(A4(ll, "checks", function(n) {
        return n.jH;
    }, BL, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, gl(SL)))), PL = function(n) {
        return A2(nc, tl, pt(A2(cl, F2(function(n, r) {
            var t = r.b, e = r.c, u = dL(r.a.sa);
            return u.$ ? Ct : kt(A2(FL, u.a, A2(TL, A2(Qu, 0, Oe(t.sa)), A2(Qu, 0, Oe(e.sa)))));
        }), n)));
    }, ML = function(n) {
        return A2(Rs, yL, function(n) {
            return Al(Lg(A3(kg, WL, {
                jH: PL(n.jH),
                nW: n.nW.sa
            }, $g(fL))));
        }(n));
    }, qL = function(n) {
        return {
            $: 13,
            a: n
        };
    }, DL = function(n) {
        return xs(cL({
            $: 3,
            a: n
        }));
    }, XL = F3(function(n, r, t) {
        return {
            jH: t,
            mj: n,
            nW: r
        };
    }), EL = ul(A4(ll, "checks", function(n) {
        return n.jH;
    }, BL, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(XL))))), RL = function(n) {
        return {
            $: 12,
            a: n
        };
    }, xL = function(n) {
        return A2(Rs, RL, function(n) {
            var r = DL(A2(Qu, "", A2(Tu, A2(Po, function(n) {
                return n.ak;
            }, function(n) {
                return n.mj;
            }), n.oF)));
            return Al(Lg(A3(kg, EL, {
                jH: PL(n.jH),
                mj: A2(Qu, "", A2(Tu, A2(mu, function(n) {
                    return n.mj;
                }, function(n) {
                    return n.ak;
                }), n.oF)),
                nW: n.nW.sa
            }, Sg(r))));
        }(n));
    }, OL = function(n) {
        return A2(cl, F2(function(n, r) {
            return AL(r);
        }), il(A2(Ot, ng, n)));
    }, zL = function(n) {
        return {
            jH: A2(Qu, Lu, A2(Tu, A2(mu, OL, function(n) {
                return n.jH;
            }), n)),
            nW: Xi(function(r) {
                return p(r, {
                    m$: "Name",
                    sa: A2(Qu, "", A2(Tu, A2(mu, function(n) {
                        return n.nW;
                    }, function(n) {
                        return n.ak;
                    }), n))
                });
            }),
            oF: n
        };
    }, NL = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(eo, g, p(r, {
                    rs: n.a
                }));
            case 2:
                return A2(eo, g, p(r, {
                    kL: kt(zL(Ct))
                }));
            case 3:
                return A2(eo, g, p(r, {
                    kL: kt(zL(kt(n.a)))
                }));
            case 4:
                var t = r.kL;
                return A2(eo, 1 === t.$ ? g : C(1 === (u = t.a).oF.$ ? [
                    ML(u)
                ] : [
                    xL(u)
                ]), r);
            case 5:
                return A2(eo, C([
                    (s = n.a, A2(Rs, qL, function(n) {
                        return Al(Lg(A3(kg, EL, {
                            jH: g,
                            mj: n.ak.mj,
                            nW: n.ak.nW
                        }, Ag(DL(n.ak.mj)))));
                    }(s)))
                ]), r);
            case 6:
                return A2(eo, g, p(r, {
                    kL: Ct
                }));
            case 7:
                var e = n.a, u = A2(Tu, function(n) {
                    return p(n, {
                        nW: A2(Wg, e, n.nW)
                    });
                }, r.kL);
                return A2(eo, g, p(r, {
                    kL: u
                }));
            case 11:
                return (a = n.a).$ ? A2(eo, g, A2(LL, a.a, r)) : A2(eo, C([
                    jL
                ]), p(r, {
                    kL: Ct,
                    ll: Ct,
                    re: kt("Template created")
                }));
            case 12:
                return (a = n.a).$ ? A2(eo, g, A2(LL, a.a, r)) : A2(eo, C([
                    jL
                ]), p(r, {
                    kL: Ct,
                    ll: Ct,
                    re: kt("Template updated")
                }));
            case 13:
                return (a = n.a).$ ? A2(eo, g, A2(LL, a.a, r)) : A2(eo, C([
                    jL
                ]), r);
            case 1:
                var a;
                return A2(eo, g, (a = n.a).$ ? A2(LL, a.a, r) : p(r, {
                    kt: a.a
                }));
            case 14:
                var o = AL(A3(lL, 0, 1e3, 2e3)), c = A2(Qu, 0, A2(Tu, function(n) {
                    return A2(Qu, 0, ig(vt(n.jH)));
                }, r.kL));
                return u = A2(Tu, function(n) {
                    return p(n, {
                        jH: A3(ju, c + 1, o, n.jH)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: u
                }));
            case 8:
                e = n.a;
                var f = n.b;
                return u = A2(Tu, function(n) {
                    return p(n, {
                        jH: A2(cl, F2(function(n, r) {
                            var t = r.a, u = r.b, a = r.c;
                            return i(n, f) ? b(A2(Wg, e, t), u, a) : b(t, u, a);
                        }), n.jH)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: u
                }));
            case 9:
                return e = n.a, f = n.b, u = A2(Tu, function(n) {
                    return p(n, {
                        jH: A2(cl, F2(function(n, r) {
                            var t = r.a, u = r.b, a = r.c;
                            return i(n, f) ? b(t, A2(Wg, e, u), a) : b(t, u, a);
                        }), n.jH)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: u
                }));
            case 10:
                return e = n.a, f = n.b, u = A2(Tu, function(n) {
                    return p(n, {
                        jH: A2(cl, F2(function(n, r) {
                            var t = r.a, u = r.b, a = r.c;
                            return i(n, f) ? b(t, u, A2(Wg, e, a)) : b(t, u, a);
                        }), n.jH)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: u
                }));
            default:
                return f = n.a, u = A2(Tu, function(n) {
                    return p(n, {
                        jH: A2(ag, F2(function(n) {
                            return !i(n, f);
                        }), n.jH)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: u
                }));
        }
        var s;
    }), HL = {
        $: 2
    }, VL = function(n) {
        return {
            $: 3,
            a: n
        };
    }, UL = function(n) {
        return {
            $: 5,
            a: n
        };
    }, JL = F2(function(n, r) {
        return A2(eh, g, C([
            n(r)
        ]));
    }), ZL = F2(function(n, r) {
        return th({
            nW: n,
            hf: rh,
            ie: JL(r)
        });
    }), KL = C([
        nh("Table")
    ]), _L = function(n) {
        return n.nW ? "blackframe \u2208 [ frame " + Bt(n.nI) + ", frame " + Bt(n.nB) + "]" : "silence \u2208 [" + Bt(n.nI) + " ms, " + Bt(n.nB) + " ms]";
    }, GL = function(n) {
        return A3(qt, F2(function(n, r) {
            return $(r, $(qe(r) > 0 ? ", " : "", _L(n)));
        }), "", n);
    }, YL = ih({
        jW: C([
            A2(YA, "Name", A2(Po, function(n) {
                return n.ak;
            }, function(n) {
                return n.nW;
            })),
            A2(YA, "Description", A2(mu, GL, function(n) {
                return n.jH;
            })),
            A2(ZL, "", A2(mu, Dh("Edit"), VL)),
            A2(ZL, "", A2(mu, Dh("Delete"), UL))
        ]),
        kr: p(wh, {
            pC: function() {
                return C([
                    nh("TableTr")
                ]);
            },
            rj: KL,
            rv: C([
                nh("TableTd")
            ])
        }),
        rE: A2(Po, function(n) {
            return n.ak;
        }, function(n) {
            return n.mj;
        }),
        rF: function(n) {
            return {
                $: 0,
                a: n
            };
        }
    }), ny = {
        $: 6
    }, ry = function(n) {
        return {
            $: 7,
            a: n
        };
    }, ty = {
        $: 14
    }, ey = {
        $: 4
    }, uy = F2(function(n, r) {
        return {
            $: 10,
            a: n,
            b: r
        };
    }), ay = F2(function(n, r) {
        return {
            $: 9,
            a: n,
            b: r
        };
    }), iy = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), oy = Yg("max"), cy = Yg("min"), fy = F3(function(n, r, t) {
        return A2(Yh, n, A2(rk, C([
            nh("InputText"),
            sk(n.kT),
            qh("number"),
            $k(zh),
            bk(Nh),
            mk(Hh),
            hk(n.sa),
            gk(n.gy),
            tk(ck(n.m$)),
            nk(n.kO),
            cy(A2(Qu, "", A2(Tu, Bt, r))),
            oy(A2(Qu, "", A2(Tu, Bt, t))),
            n.eg ? Jh(!0) : Zh(g)
        ]), g));
    }), sy = F3(function(n, r, t) {
        return A2(NC, n, A3(fy, n, r, t));
    }), ly = function(n) {
        return A2(qC, function(n) {
            var r, t, e, u = function(n) {
                return A2(Qu, !1, A2(Tu, function() {
                    return !0;
                }, n.oF));
            }(n) ? d("Save", "Edit Template") : d("Create", "New Template");
            return A4(oj, u.b, d(u.a, ey), d("Cancel", ny), C([
                A2(Sk, ry, VC(n.nW)),
                (r = n.jH, t = C([
                    d("silence", "silence"),
                    d("blackframe", "blackframe")
                ]), e = F2(function(n, r) {
                    var e, u = r.a, a = r.b, i = r.c;
                    return A2(Se, C([
                        A2(gh, "position", "relative"),
                        A2(gh, "margin", "10px"),
                        A2(gh, "padding", "5px")
                    ]), C([
                        A2(Sk, function(r) {
                            return A2(iy, r, n);
                        }, A2(rj, u, t)),
                        A2(Sk, function(r) {
                            return A2(ay, r, n);
                        }, A3(sy, a, kt(0), Ct)),
                        A2(Sk, function(r) {
                            return A2(uy, r, n);
                        }, A3(sy, i, kt(0), Ct)),
                        A3(lj, "remove", C([
                            d("position", "absolute"),
                            d("left", "0")
                        ]), (e = n, {
                            $: 15,
                            a: e
                        }))
                    ]));
                }), A2(Se, C([
                    A2(gh, "padding", "10px 0")
                ]), A2(Ge, tl, pt(A2(cl, e, r))))),
                A2(Dh, "Add New Check", ty)
            ]));
        }, n.kL);
    }, dy = F2(function(n, r) {
        return A3(Wj, "Deep Probe Templates", kt(A2(Dh, "New\u2026", HL)), A2(Se, g, C([
            ly(r),
            A3(jC, YL, r.rs, r.kt)
        ])));
    }), by = {
        l: function(n) {
            return n.cP;
        },
        m: wL,
        p: F2(function(n, r) {
            return p(n, {
                cP: r
            });
        }),
        q: function(n) {
            return {
                $: 17,
                a: n
            };
        },
        r: NL,
        s: dy
    }, my = {
        kL: Ct,
        ll: Ct,
        c5: g,
        lT: g,
        ph: Xi(function(n) {
            return p(n, {
                gy: "Search Formats by Name, Specification, AudioCodec, Start Timecode, Frame Rate or FFMpeg Args",
                sa: ""
            });
        }),
        dF: g,
        re: Ct,
        rs: k$("Name"),
        dK: Lu
    }, py = function(n) {
        return {
            $: 0,
            a: n
        };
    }, vy = F4(function(n, r, t, e) {
        return {
            c5: n,
            lU: r,
            dF: e,
            dK: t
        };
    }), $y = function(n) {
        switch(n){
            case "pcm_s16le":
                return yt(1);
            case "pcm_s24le":
                return yt(0);
            case "pcm_s24be":
                return yt(2);
            case "libfdk_aac":
                return yt(3);
            case "libmp3lame":
                return yt(4);
            case "MOV_Conteneur":
                return yt(5);
            default:
                return jt(p(A2(ki, "can't parse str to audio codec", L$), {
                    O: !0,
                    ah: !0
                }));
        }
    }, gy = function(n) {
        switch(n){
            case 1:
                return "pcm_s16le";
            case 0:
                return "pcm_s24le";
            case 2:
                return "pcm_s24be";
            case 3:
                return "libfdk_aac";
            case 4:
                return "libmp3lame";
            default:
                return "MOV_Conteneur";
        }
    }, hy = A2(zl, gy, $y), ky = F2(function(n, r) {
        return {
            jO: r,
            jP: n
        };
    }), Cy = ul(A4(ll, "clipMax", function(n) {
        return n.jO;
    }, ml, A4(ll, "clipMin", function(n) {
        return n.jP;
    }, ml, gl(ky)))), jy = F4(function(n, r, t, e) {
        return {
            es: e,
            fV: n,
            gV: r,
            h1: t
        };
    }), wy = ul(A4(ll, "bottomPx", function(n) {
        return n.es;
    }, ml, A4(ll, "topPx", function(n) {
        return n.h1;
    }, ml, A4(ll, "rightPx", function(n) {
        return n.gV;
    }, ml, A4(ll, "leftPx", function(n) {
        return n.fV;
    }, ml, gl(jy)))))), Ay = K, Ly = hn, yy = A2(qi, Ly, Ay), Sy = function(n) {
        switch(n){
            case "Mxf":
                return yt(0);
            case "Mp4":
                return yt(1);
            case "ProRes422":
                return yt(2);
            case "ProRes4444":
                return yt(3);
            case "TwoPass":
                return yt(4);
            case "AVCIntra100":
                return yt(5);
            case "IMX50":
                return yt(6);
            case "Mp4Salto":
                return yt(7);
            case "MxfProgressive":
                return yt(12);
            case "MovH264":
                return yt(8);
            case "MkvH264":
                return yt(9);
            case "MovHevc":
                return yt(10);
            case "Mp4Hevc":
                return yt(11);
            case "XAVCIntra300":
                return yt(13);
            case "WMV":
                return yt(14);
            case "Demux":
                return yt(15);
            case "AudioExtract":
                return yt(16);
            default:
                return jt(A2(ki, "Unknown format spec", L$));
        }
    }, Fy = function(n) {
        switch(n){
            case 0:
                return "Mxf";
            case 1:
                return "Mp4";
            case 2:
                return "ProRes422";
            case 3:
                return "ProRes4444";
            case 4:
                return "TwoPass";
            case 5:
                return "AVCIntra100";
            case 6:
                return "IMX50";
            case 7:
                return "Mp4Salto";
            case 12:
                return "MxfProgressive";
            case 8:
                return "MovH264";
            case 9:
                return "MkvH264";
            case 10:
                return "MovHevc";
            case 11:
                return "Mp4Hevc";
            case 13:
                return "XAVCIntra300";
            case 14:
                return "WMV";
            case 15:
                return "Demux";
            default:
                return "AudioExtract";
        }
    }, Ty = A2(zl, Fy, Sy), Qy = F3(function(n, r, t) {
        return {
            cQ: t,
            mj: n,
            dk: r
        };
    }), Iy = ul(A4(ll, "denominator", function(n) {
        return n.cQ;
    }, ml, A4(ll, "numerator", function(n) {
        return n.dk;
    }, ml, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(Qy))))), By = F8(function(n, r, t, e, u, a, i, o) {
        return {
            jS: u,
            jT: e,
            kq: a,
            l9: i,
            mY: o,
            m5: t,
            o0: r,
            o5: n
        };
    }), Wy = ul(A4(ll, "keyframe", function(n) {
        return n.mY;
    }, ml, A4(ll, "highTiers", function(n) {
        return n.l9;
    }, Zi, A4(ll, "curveTransfert", function(n) {
        return n.kq;
    }, Di, A4(ll, "colorPrimaries", function(n) {
        return n.jS;
    }, Di, A4(ll, "colorspace", function(n) {
        return n.jT;
    }, Di, A4(ll, "level", function(n) {
        return n.m5;
    }, Di, A4(ll, "preset", function(n) {
        return n.o0;
    }, Di, A4(ll, "profil", function(n) {
        return n.o5;
    }, Di, gl(By)))))))))), Py = F8(function(n, r, t, e, u, a, i, o) {
        return {
            iA: u,
            iW: r,
            iX: t,
            jw: e,
            j5: n,
            kB: i,
            pf: o,
            se: a
        };
    }), My = ul(A4(kb, "qmax", function(n) {
        return n.pf;
    }, ml, A4(ll, "deint", function(n) {
        return n.kB;
    }, Zi, A4(ll, "version12", function(n) {
        return n.se;
    }, Zi, A4(kb, "afd", function(n) {
        return n.iA;
    }, ml, A4(ll, "BWF", function(n) {
        return n.jw;
    }, Zi, A4(ll, "as11", function(n) {
        return n.iX;
    }, Zi, A4(ll, "as10", function(n) {
        return n.iW;
    }, Zi, A4(ll, "controlInstantaneousBitrate", function(n) {
        return n.j5;
    }, Zi, gl(Py)))))))))), qy = F4(function(n, r, t, e) {
        return {
            ft: r,
            pN: t,
            pP: e,
            ih: n
        };
    }), Dy = ul(A4(ll, "scaleLetterbox", function(n) {
        return n.pP;
    }, Zi, A4(ll, "scaleAspectRatio", function(n) {
        return n.pN;
    }, Zi, A4(ll, "heightScale", function(n) {
        return n.ft;
    }, ml, A4(ll, "widthScale", function(n) {
        return n.ih;
    }, ml, gl(qy)))))), Xy = function(n) {
        switch(n){
            case "PARTIAL":
                return yt(0);
            case "COMPLETE":
                return yt(1);
            case "COMPLETE_WITHOUT_PARTIAL":
                return yt(2);
            case "SDH":
                return yt(3);
            default:
                return jt("Not a subtitle type version");
        }
    }, Ey = function(n) {
        switch(n){
            case 0:
                return "PARTIAL";
            case 1:
                return "COMPLETE";
            case 2:
                return "COMPLETE_WITHOUT_PARTIAL";
            default:
                return "SDH";
        }
    }, Ry = A2(zl, Ey, Xy), xy = F2(function(n, r) {
        return {
            ev: n,
            fR: r
        };
    }), Oy = ul(A4(ll, "key", function(n) {
        return n.fR;
    }, Di, A4(ll, "bucket", function(n) {
        return n.ev;
    }, Di, gl(xy)))), zy = F2(function(n, r) {
        return {
            d4: r,
            ek: n
        };
    }), Ny = F8(function(n, r, t, e, u, a, i, o) {
        return {
            d3: e,
            e$: t,
            fB: n,
            c9: r,
            hg: a,
            hi: i,
            dD: u,
            hJ: o
        };
    }), Hy = function(n) {
        switch(n){
            case "Mire":
                return yt(0);
            case "Black":
                return yt(1);
            case "Slate":
                return yt(2);
            case "Video":
                return yt(3);
            case "Countdown":
                return yt(4);
            default:
                return jt("not a Segment Kind");
        }
    }, Vy = function(n) {
        switch(n){
            case 0:
                return "Mire";
            case 1:
                return "Black";
            case 2:
                return "Slate";
            case 3:
                return "Video";
            default:
                return "Countdown";
        }
    }, Uy = A2(zl, Vy, Hy), Jy = ul(A4(ll, "subtract", function(n) {
        return n.hJ;
    }, Zi, A4(kb, "sourceKey", function(n) {
        return n.hi;
    }, Di, A4(kb, "sourceBucket", function(n) {
        return n.hg;
    }, Di, A4(kb, "sourceName", function(n) {
        return n.dD;
    }, Di, A4(ll, "additionalFrameCount", function(n) {
        return n.d3;
    }, ml, A4(ll, "duration", function(n) {
        return n.e$;
    }, ml, A4(ll, "kind", function(n) {
        return n.c9;
    }, Uy, A4(ll, "index", function(n) {
        return n.fB;
    }, ml, gl(Ny)))))))))), Zy = ul(A4(ll, "after", function(n) {
        return n.d4;
    }, $l(Jy), A4(ll, "before", function(n) {
        return n.ek;
    }, $l(Jy), gl(zy)))), Ky = ul(A4(kb, "subtitlesSettings", function(n) {
        return n.dG;
    }, Oy, A4(ll, "copyMetadata", function(n) {
        return n.j8;
    }, Zi, A4(kb, "subtitleFormat", function(n) {
        return n.q2;
    }, Di, A4(kb, "subtitleTypeVersion", function(n) {
        return n.q7;
    }, Ry, A4(kb, "subtitleVersion", function(n) {
        return n.q8;
    }, P$, A4(ll, "qcReportTemplate", function(n) {
        return n.pc;
    }, Di, A4(ll, "qcTestPlan", function(n) {
        return n.pd;
    }, Di, A4(kb, "hevcParams", function(n) {
        return n.G;
    }, Wy, A4(kb, "clip", function(n) {
        return n.bI;
    }, Cy, A4(kb, "scale", function(n) {
        return n.aW;
    }, Dy, A4(kb, "crop", function(n) {
        return n.aH;
    }, wy, A4(ll, "encodeSubtitle", function(n) {
        return n.lf;
    }, Zi, A4(kb, "videoBitrate", function(n) {
        return n.sj;
    }, yy, A4(ll, "writeTimecode", function(n) {
        return n.sr;
    }, Zi, A4(kb, "videoEdit", function(n) {
        return n.dV;
    }, Zy, A4(kb, "audioGain", function(n) {
        return n.i3;
    }, yy, A4(kb, "loudnessTruePeak", function(n) {
        return n.nk;
    }, yy, A4(kb, "loudnessProgram", function(n) {
        return n.ni;
    }, yy, A4(kb, "loudnessRange", function(n) {
        return n.nj;
    }, yy, A4(kb, "noLoudness", function(n) {
        return n.n6;
    }, Zi, A4(kb, "options", function(n) {
        return n.N;
    }, My, A4(kb, "bmxArgs", function(n) {
        return n.ji;
    }, Di, A4(kb, "audioArgs", function(n) {
        return n.i$;
    }, Di, A4(kb, "ffmpegArgs", function(n) {
        return n.ly;
    }, Di, A4(ll, "noFrameRateConversion", function(n) {
        return n.n5;
    }, Zi, A4(ll, "frameRate", function(n) {
        return n.lS;
    }, Iy, A4(ll, "startTimecode", function(n) {
        return n.qO;
    }, Di, A4(kb, "audioBitrate", function(n) {
        return n.i0;
    }, ml, A4(ll, "audioCodec", function(n) {
        return n.i1;
    }, hy, A4(ll, "specification", function(n) {
        return n.qG;
    }, Ty, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(m) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return function($) {
                                                                            return function(g) {
                                                                                return function(h) {
                                                                                    return function(k) {
                                                                                        return function(C) {
                                                                                            return function(j) {
                                                                                                return function(w) {
                                                                                                    return function(A) {
                                                                                                        return function(L) {
                                                                                                            return function(y) {
                                                                                                                return function(S) {
                                                                                                                    return function(F) {
                                                                                                                        return function(T) {
                                                                                                                            return function(Q) {
                                                                                                                                return function(I) {
                                                                                                                                    return {
                                                                                                                                        i$: f,
                                                                                                                                        i0: u,
                                                                                                                                        i1: e,
                                                                                                                                        i3: v,
                                                                                                                                        ji: s,
                                                                                                                                        bI: w,
                                                                                                                                        j8: Q,
                                                                                                                                        aH: C,
                                                                                                                                        lf: k,
                                                                                                                                        ly: c,
                                                                                                                                        lS: i,
                                                                                                                                        G: A,
                                                                                                                                        mj: n,
                                                                                                                                        ni: m,
                                                                                                                                        nj: b,
                                                                                                                                        nk: p,
                                                                                                                                        nW: r,
                                                                                                                                        n5: o,
                                                                                                                                        n6: d,
                                                                                                                                        N: l,
                                                                                                                                        pc: y,
                                                                                                                                        pd: L,
                                                                                                                                        aW: j,
                                                                                                                                        qG: t,
                                                                                                                                        qO: a,
                                                                                                                                        q2: T,
                                                                                                                                        q7: F,
                                                                                                                                        q8: S,
                                                                                                                                        dG: I,
                                                                                                                                        sj: h,
                                                                                                                                        dV: $,
                                                                                                                                        sr: g
                                                                                                                                    };
                                                                                                                                };
                                                                                                                            };
                                                                                                                        };
                                                                                                                    };
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))))))))))))))))))))))), _y = $l(Ky), Gy = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Yy = xs(Gy({
        $: 0
    })), nS = Al(A2(_s, _y, Vs(Yy))), rS = $l(Iy), tS = xs(Gy({
        $: 2
    })), eS = Al(A2(_s, rS, Vs(tS))), uS = F7(function(n, r, t, e, u, a, i) {
        return {
            kR: a,
            lB: t,
            mj: n,
            nW: r,
            b8: i,
            q3: u,
            q6: e
        };
    }), aS = function(n) {
        switch(n){
            case "open_subtitling":
                return yt(0);
            case "teletext_level_1":
                return yt(1);
            case "teletext_level_2":
                return yt(2);
            default:
                return jt(A2(ki, "Unknown subtitle display standard", L$));
        }
    }, iS = function(n) {
        switch(n){
            case 0:
                return "open_subtitling";
            case 1:
                return "teletext_level_1";
            default:
                return "teletext_level_2";
        }
    }, oS = A2(zl, iS, aS), cS = function(n) {
        switch(n){
            case "STL":
                return yt(0);
            case "WebVTT":
                return yt(1);
            case "SRT":
                return yt(2);
            case "ASS":
                return yt(3);
            default:
                return jt(A2(ki, "Unknown subtitle file format", L$));
        }
    }, fS = function(n) {
        switch(n){
            case 0:
                return "STL";
            case 1:
                return "WebVTT";
            case 2:
                return "SRT";
            default:
                return "ASS";
        }
    }, sS = A2(zl, fS, cS), lS = ul(A4(kb, "offset", function(n) {
        return n.b8;
    }, Di, A4(kb, "display_standard", function(n) {
        return n.kR;
    }, oS, A4(kb, "frame_rate", function(n) {
        return n.q3;
    }, Iy, A4(kb, "start_timecode", function(n) {
        return n.q6;
    }, Di, A4(ll, "format", function(n) {
        return n.lB;
    }, sS, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(uS))))))))), dS = $l(lS), bS = function(n) {
        return {
            $: 11,
            a: n
        };
    }, mS = xs(bS({
        $: 0
    })), pS = Al(A2(_s, dS, Vs(mS))), vS = F3(function(n, r, t) {
        return {
            bC: t,
            mj: n,
            nW: r
        };
    }), $S = ul(A4(ll, "batonIdentifier", function(n) {
        return n.bC;
    }, Di, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(vS))))), gS = $l($S), hS = function(n) {
        return {
            $: 9,
            a: n
        };
    }, kS = xs(hS({
        $: 0
    })), CS = A2(bp, il, A2(bp, Ge(function(n) {
        return d(n.mj, n);
    }), Al(A2(_s, gS, Vs(kS))))), jS = F5(function(n, r, t, e, u) {
        return A2(Ye, function(r) {
            return A2(Ye, function(t) {
                return A2(Ye, function(e) {
                    return A2(Ye, function(u) {
                        return Je(A4(n, r, t, e, u));
                    }, u);
                }, e);
            }, t);
        }, r);
    }), wS = jS, AS = A2(Rs, py, A5(wS, vy, nS, eS, CS, pS)), LS = d(my, AS), yS = function(n) {
        return {
            $: 59,
            a: n
        };
    }, SS = F2(function(n, r) {
        return p(r, {
            ll: kt(n.nE),
            re: Ct
        });
    }), FS = V, TS = Pi({
        bQ: "Add after video...",
        bX: "Ajouter apr\xe8s la vid\xe9o..."
    }), QS = Pi({
        bQ: "Add before video...",
        bX: "Ajouter avant la vid\xe9o..."
    }), IS = C([
        d("Mire", "Mire"),
        d("Black", "Noir"),
        d("Slate", "Panneau"),
        d("Video", "Video"),
        d("Countdown", "Compte \xe0 rebours")
    ]), BS = function(n) {
        var r, t = A2(Qu, "", A2(Tu, function(n) {
            return n.fR;
        }, A2(Lp, function(n) {
            return n.dG;
        }, n))), e = A2(Qu, "", A2(Tu, function(n) {
            return n.ev;
        }, A2(Lp, function(n) {
            return n.dG;
        }, n))), u = A2(Qu, "", A2(Tu, W$, A2(Lp, function(n) {
            return n.q8;
        }, n))), a = A2(Qu, "", A2(Tu, Ey, A2(Lp, function(n) {
            return n.q7;
        }, n))), i = A2(Qu, "", A2(Lp, function(n) {
            return n.q2;
        }, n)), o = function(n) {
            return A2(Po, Tu(n), Qu(""));
        };
        return {
            iA: Xi(function(r) {
                return p(r, {
                    m$: "AFD",
                    sa: A2(Qu, "", A2(Tu, Bt, A2(Lp, function(n) {
                        return A2(Lp, function(n) {
                            return n.iA;
                        }, n.N);
                    }, n)))
                });
            }),
            iW: Ki(function(r) {
                return p(r, {
                    m$: "AS10",
                    sa: A2(Qu, !1, A2(Lp, function(n) {
                        return A2(Tu, function(n) {
                            return n.iW;
                        }, n.N);
                    }, n))
                });
            }),
            iX: Ki(function(r) {
                return p(r, {
                    m$: "AS11",
                    sa: A2(Qu, !1, A2(Lp, function(n) {
                        return A2(Tu, function(n) {
                            return n.iX;
                        }, n.N);
                    }, n))
                });
            }),
            i$: Xi(function(r) {
                return p(r, {
                    m$: "Args",
                    sa: A2(Qu, "", A2(Lp, function(n) {
                        return n.i$;
                    }, n))
                });
            }),
            i0: Xi(function(r) {
                return p(r, {
                    m$: "Audio Bitrate (kb/s)",
                    sa: A2(Qu, "384", A2(Tu, Bt, A2(Lp, function(n) {
                        return n.i0;
                    }, n)))
                });
            }),
            i1: Xi(function(r) {
                return p(r, {
                    m$: "Codec",
                    sa: A2(o, A2(Po, function(n) {
                        return n.i1;
                    }, gy), n)
                });
            }),
            i3: Xi(function(r) {
                return p(r, {
                    m$: "Gain",
                    sa: A2(Qu, "0", A2(Tu, FS, A2(Lp, function(n) {
                        return n.i3;
                    }, n)))
                });
            }),
            ji: Xi(function(r) {
                return p(r, {
                    m$: "BMX Args",
                    sa: A2(Qu, "", A2(Lp, function(n) {
                        return n.ji;
                    }, n))
                });
            }),
            ju: Ki(function(n) {
                return p(n, {
                    m$: "Burned subtitle",
                    sa: "" !== u && "" !== a
                });
            }),
            jw: Ki(function(r) {
                return p(r, {
                    m$: "BWF wrapping",
                    sa: A2(Qu, !1, A2(Lp, function(n) {
                        return A2(Tu, function(n) {
                            return n.jw;
                        }, n.N);
                    }, n))
                });
            }),
            jO: Xi(function(r) {
                return p(r, {
                    m$: "value max (luminance)",
                    sa: A2(Qu, "235", A2(Lp, function(n) {
                        return A2(Tu, function(n) {
                            return Bt(n.jO);
                        }, n.bI);
                    }, n))
                });
            }),
            jP: Xi(function(r) {
                return p(r, {
                    m$: "Value min (luminance)",
                    sa: A2(Qu, "16", A2(Lp, function(n) {
                        return A2(Tu, function(n) {
                            return Bt(n.jP);
                        }, n.bI);
                    }, n))
                });
            }),
            jS: Xi(function(r) {
                return p(r, {
                    m$: "Color Primaries",
                    sa: A2(Qu, "bt709", A2(Tu, function(n) {
                        return n.jS;
                    }, A2(Lp, function(n) {
                        return n.G;
                    }, n)))
                });
            }),
            jT: Xi(function(r) {
                return p(r, {
                    m$: "Colorspace",
                    sa: A2(Qu, "bt709", A2(Tu, function(n) {
                        return n.jT;
                    }, A2(Lp, function(n) {
                        return n.G;
                    }, n)))
                });
            }),
            j5: Ki(function(r) {
                return p(r, {
                    m$: "Control instantaneous bitrate",
                    sa: A2(Qu, !1, A2(Lp, function(n) {
                        return A2(Tu, function(n) {
                            return n.j5;
                        }, n.N);
                    }, n))
                });
            }),
            j8: Ki(function(r) {
                return p(r, {
                    m$: "Copy metadata",
                    sa: A2(Qu, !1, A2(Tu, function(n) {
                        return n.j8;
                    }, n))
                });
            }),
            kf: Xi(function(r) {
                return p(r, {
                    m$: "Crop pixel bottom",
                    sa: A2(Qu, "0", A2(Lp, function(n) {
                        return A2(Tu, function(n) {
                            return Bt(n.es);
                        }, n.aH);
                    }, n))
                });
            }),
            kg: Xi(function(r) {
                return p(r, {
                    m$: "Crop pixel left",
                    sa: A2(Qu, "0", A2(Lp, function(n) {
                        return A2(Tu, function(n) {
                            return Bt(n.fV);
                        }, n.aH);
                    }, n))
                });
            }),
            kh: Xi(function(r) {
                return p(r, {
                    m$: "Crop pixel right",
                    sa: A2(Qu, "0", A2(Lp, function(n) {
                        return A2(Tu, function(n) {
                            return Bt(n.gV);
                        }, n.aH);
                    }, n))
                });
            }),
            ki: Xi(function(r) {
                return p(r, {
                    m$: "Crop pixel top",
                    sa: A2(Qu, "0", A2(Lp, function(n) {
                        return A2(Tu, function(n) {
                            return Bt(n.h1);
                        }, n.aH);
                    }, n))
                });
            }),
            kq: Xi(function(r) {
                return p(r, {
                    m$: "CurveTransfert",
                    sa: A2(Qu, "bt709", A2(Tu, function(n) {
                        return n.kq;
                    }, A2(Lp, function(n) {
                        return n.G;
                    }, n)))
                });
            }),
            kB: Ki(function(r) {
                return p(r, {
                    m$: "Force deinterlacing",
                    sa: A2(Qu, !1, A2(Lp, function(n) {
                        return A2(Tu, function(n) {
                            return n.kB;
                        }, n.N);
                    }, n))
                });
            }),
            lf: Ki(function(r) {
                return p(r, {
                    m$: "Encode ASS Subtitle File",
                    sa: A2(Qu, !1, A2(Tu, function(n) {
                        return n.lf;
                    }, n))
                });
            }),
            ly: Xi(function(r) {
                return p(r, {
                    m$: "Args",
                    sa: A2(Qu, "", A2(Lp, function(n) {
                        return n.ly;
                    }, n))
                });
            }),
            lS: Xi(function(r) {
                return p(r, {
                    m$: "FrameRate",
                    sa: A2(o, A2(Po, function(n) {
                        return n.lS;
                    }, function(n) {
                        return n.mj;
                    }), n)
                });
            }),
            l9: Ki(function(r) {
                return p(r, {
                    m$: "HighTiers",
                    sa: A2(Qu, !1, A2(Tu, function(n) {
                        return n.l9;
                    }, A2(Lp, function(n) {
                        return n.G;
                    }, n)))
                });
            }),
            mY: Xi(function(r) {
                return p(r, {
                    m$: "Keyframe",
                    sa: A2(Qu, "250", A2(Lp, function(n) {
                        return A2(Tu, function(n) {
                            return Bt(n.mY);
                        }, n.G);
                    }, n))
                });
            }),
            m5: Xi(function(r) {
                return p(r, {
                    m$: "Level",
                    sa: A2(Qu, "0", A2(Tu, function(n) {
                        return n.m5;
                    }, A2(Lp, function(n) {
                        return n.G;
                    }, n)))
                });
            }),
            ni: Xi(function(r) {
                return p(r, {
                    m$: "Target Program Loudness",
                    sa: A2(Qu, "-23", A2(Tu, FS, A2(Lp, function(n) {
                        return n.ni;
                    }, n)))
                });
            }),
            nj: Xi(function(r) {
                return p(r, {
                    m$: "Target Loudness Range",
                    sa: A2(Qu, "11", A2(Tu, FS, A2(Lp, function(n) {
                        return n.nj;
                    }, n)))
                });
            }),
            nk: Xi(function(r) {
                return p(r, {
                    m$: "Target True Peak",
                    sa: A2(Qu, "-1.3", A2(Tu, FS, A2(Lp, function(n) {
                        return n.nk;
                    }, n)))
                });
            }),
            nW: Xi(function(r) {
                return p(r, {
                    m$: "Name",
                    sa: A2(o, function(n) {
                        return n.nW;
                    }, n)
                });
            }),
            n5: Ki(function(r) {
                return p(r, {
                    m$: "No FrameRate Conversion",
                    sa: A2(Qu, !1, A2(Tu, function(n) {
                        return n.n5;
                    }, n))
                });
            }),
            n6: Ki(function(r) {
                return p(r, {
                    m$: "No Loudness",
                    sa: A2(Qu, !1, A2(Lp, function(n) {
                        return n.n6;
                    }, n))
                });
            }),
            oF: n,
            o0: Xi(function(r) {
                return p(r, {
                    m$: "Preset",
                    sa: A2(Qu, "medium", A2(Tu, function(n) {
                        return n.o0;
                    }, A2(Lp, function(n) {
                        return n.G;
                    }, n)))
                });
            }),
            o5: Xi(function(r) {
                return p(r, {
                    m$: "Profil",
                    sa: A2(Qu, "main", A2(Tu, function(n) {
                        return n.o5;
                    }, A2(Lp, function(n) {
                        return n.G;
                    }, n)))
                });
            }),
            pc: Xi(function(r) {
                return p(r, {
                    m$: "QC report template",
                    sa: A2(Qu, "", A2(Tu, function(n) {
                        return n.pc;
                    }, n))
                });
            }),
            pd: Xi(function(r) {
                return p(r, {
                    m$: "QC test plan",
                    sa: A2(Qu, "", A2(Tu, function(n) {
                        return n.pd;
                    }, n))
                });
            }),
            pf: Xi(function(r) {
                return p(r, {
                    m$: "Overwrite qmax",
                    sa: A2(Qu, "", A2(Tu, Bt, A2(Lp, function(n) {
                        return A2(Lp, function(n) {
                            return n.pf;
                        }, n.N);
                    }, n)))
                });
            }),
            pN: Ki(function(r) {
                return p(r, {
                    m$: "Enable Keep aspect ratio",
                    sa: A2(Qu, !1, A2(Tu, function(n) {
                        return n.pN;
                    }, A2(Lp, function(n) {
                        return n.aW;
                    }, n)))
                });
            }),
            pO: Xi(function(r) {
                return p(r, {
                    m$: "Height",
                    sa: A2(Qu, "1080", A2(Lp, function(n) {
                        return A2(Tu, function(n) {
                            return Bt(n.ft);
                        }, n.aW);
                    }, n))
                });
            }),
            pP: Ki(function(r) {
                return p(r, {
                    m$: "Enable Letterbox and Pillarbox",
                    sa: A2(Qu, !1, A2(Tu, function(n) {
                        return n.pP;
                    }, A2(Lp, function(n) {
                        return n.aW;
                    }, n)))
                });
            }),
            pQ: Xi(function(r) {
                return p(r, {
                    m$: "Width",
                    sa: A2(Qu, "1920", A2(Lp, function(n) {
                        return A2(Tu, function(n) {
                            return Bt(n.ih);
                        }, n.aW);
                    }, n))
                });
            }),
            qk: Ki(function(r) {
                return p(r, {
                    m$: "Clip / PSE Parameters",
                    sa: A2(Qu, !1, A2(Lp, function(n) {
                        return A2(Tu, function() {
                            return !0;
                        }, n.bI);
                    }, n))
                });
            }),
            ql: Ki(function(r) {
                return p(r, {
                    m$: "Crop Parameters",
                    sa: A2(Qu, !1, A2(Lp, function(n) {
                        return A2(Tu, function() {
                            return !0;
                        }, n.aH);
                    }, n))
                });
            }),
            qr: Ki(function(r) {
                return p(r, {
                    m$: "HEVC : ",
                    sa: A2(Qu, !0, A2(Lp, function(n) {
                        return A2(Tu, function() {
                            return !0;
                        }, n.G);
                    }, n))
                });
            }),
            qv: Ki(function(r) {
                return p(r, {
                    m$: "Scale Parameters",
                    sa: A2(Qu, !1, A2(Lp, function(n) {
                        return A2(Tu, function() {
                            return !0;
                        }, n.aW);
                    }, n))
                });
            }),
            qG: Xi(function(r) {
                return p(r, {
                    m$: "Specification",
                    sa: A2(o, A2(Po, function(n) {
                        return n.qG;
                    }, Fy), n)
                });
            }),
            qO: Xi(function(r) {
                return p(r, {
                    m$: "Start Timecode",
                    sa: A2(o, function(n) {
                        return n.qO;
                    }, n)
                });
            }),
            qW: kt((r = n.$ ? Ct : n.a.dV, {
                iB: p(mf, {
                    eC: IS,
                    gy: TS
                }),
                je: p(mf, {
                    eC: IS,
                    gy: QS
                }),
                dV: A2(Qu, A2(zy, g, g), r)
            })),
            q2: Xi(function(n) {
                return p(n, {
                    m$: "Subtitle format",
                    sa: i
                });
            }),
            q7: Xi(function(n) {
                return p(n, {
                    m$: "Subtitle type version",
                    sa: a
                });
            }),
            q8: Xi(function(n) {
                return p(n, {
                    m$: "Subtitle version",
                    sa: u
                });
            }),
            rb: Xi(function(n) {
                return p(n, {
                    m$: "bucket",
                    sa: e
                });
            }),
            rc: Ki(function(n) {
                return p(n, {
                    m$: "Settings file (.txt)",
                    sa: "" !== e && "" !== t
                });
            }),
            rd: Xi(function(n) {
                return p(n, {
                    m$: "key",
                    sa: t
                });
            }),
            se: Ki(function(r) {
                return p(r, {
                    m$: "Version 1.2",
                    sa: A2(Qu, !1, A2(Lp, function(n) {
                        return A2(Tu, function(n) {
                            return n.se;
                        }, n.N);
                    }, n))
                });
            }),
            sj: Xi(function(r) {
                return p(r, {
                    m$: "Bitrate (Mbits/s)",
                    sa: A2(Qu, "5", A2(Tu, FS, A2(Lp, function(n) {
                        return n.sj;
                    }, n)))
                });
            }),
            sr: Ki(function(r) {
                return p(r, {
                    m$: "Write Timecode",
                    sa: A2(Qu, !1, A2(Tu, function(n) {
                        return n.sr;
                    }, n))
                });
            })
        };
    }, WS = C([
        0,
        12
    ]), PS = C([
        1,
        11,
        7,
        8,
        10,
        9,
        4,
        14
    ]), MS = function(n) {
        return {
            $: 53,
            a: n
        };
    }, qS = C([
        16
    ]), DS = {
        lz: Lu,
        c9: 3,
        nE: "",
        as: pi,
        O: !0,
        Q: 500,
        ah: !1
    }, XS = C([
        0,
        2,
        3,
        5,
        6,
        12,
        13,
        1,
        11,
        7,
        8,
        10,
        9,
        4,
        14
    ]), ES = F4(function(n, r, t, e) {
        return {
            ee: r,
            hp: n,
            hG: e,
            hH: t
        };
    }), RS = F3(function(n, r, t) {
        return 1 === r.$ || 1 === t.$ ? Ct : kt(A2(n, r.a, t.a));
    }), xS = F5(function(n, r, t, e, u) {
        return 1 === r.$ || 1 === t.$ || 1 === e.$ || 1 === u.$ ? Ct : kt(A4(n, r.a, t.a, e.a, u.a));
    }), OS = F5(function(n, r, t, e, u) {
        if (1 === r.$) return jt(r.a);
        var a = r.a;
        if (1 === t.$) return jt(t.a);
        var i = t.a;
        if (1 === e.$) return jt(e.a);
        var o = e.a;
        return 1 === u.$ ? jt(u.a) : yt(A4(n, a, i, o, u.a));
    }), zS = C([
        1,
        4,
        7,
        8,
        10,
        11,
        9
    ]), NS = C([
        0,
        5,
        6,
        12,
        13
    ]), HS = C([
        0,
        12,
        6
    ]), VS = function(n) {
        var r = function(r) {
            return A2(mg, r, qS) ? n.sr.sa : !A2(mg, r, zS) || n.sr.sa;
        }, t = function(r) {
            return 1 === r || 11 === r || 10 === r || 8 === r || 9 === r || 14 === r ? _c(n.sj.sa) : Ct;
        }, e = "" === n.q8.sa ? yt(Ct) : A2(dg, function(n) {
            return kt(n);
        }, B$(n.q8.sa)), u = n.rc.sa ? kt({
            ev: n.rb.sa,
            fR: n.rd.sa
        }) : Ct, a = A2(hi, function(n) {
            return A2(ki, n, DS);
        }, e), i = "" === n.q2.sa ? Ct : kt(n.q2.sa), o = "" === n.q7.sa ? yt(Ct) : A2(dg, function(n) {
            return kt(n);
        }, Xy(n.q7.sa)), c = A2(hi, function(n) {
            return A2(ki, n, DS);
        }, o), f = Sy(n.qG.sa), s = function(r) {
            return 6 !== r && 4 !== r && n.qv.sa ? A3(RS, F2(function(r, t) {
                return {
                    ft: t,
                    pN: n.pN.sa,
                    pP: n.pP.sa,
                    ih: r
                };
            }), Oe(n.pQ.sa), Oe(n.pO.sa)) : Ct;
        }, l = function(r) {
            return A2(mg, r, NS) ? kt({
                iA: "" === n.iA.sa ? Ct : Oe(n.iA.sa),
                iW: !!A2(mg, r, WS) && n.iW.sa,
                iX: 5 === r && n.iX.sa,
                jw: n.jw.sa,
                j5: !!A2(mg, r, WS) && n.j5.sa,
                kB: n.kB.sa,
                pf: A2(mg, r, HS) && "" !== n.pf.sa ? Oe(n.pf.sa) : Ct,
                se: !!A2(mg, r, WS) && n.se.sa
            }) : Ct;
        }, d = function(r) {
            return A2(mg, r, XS) ? kt(n.n6.sa) : Ct;
        }, b = function(r) {
            return A2(mg, r, XS) && !n.n6.sa ? _c(n.nk.sa) : Ct;
        }, m = function(r) {
            return A2(mg, r, XS) && !n.n6.sa ? _c(n.nj.sa) : Ct;
        }, p = function(r) {
            return A2(mg, r, XS) && !n.n6.sa ? _c(n.ni.sa) : Ct;
        }, v = function(r) {
            return n.qr.sa || 11 === r || 10 === r ? A2(Tu, function(r) {
                return {
                    jS: n.jS.sa,
                    jT: n.jT.sa,
                    kq: n.kq.sa,
                    l9: n.l9.sa,
                    mY: r,
                    m5: n.m5.sa,
                    o0: n.o0.sa,
                    o5: n.o5.sa
                };
            }, Oe(n.mY.sa)) : Ct;
        }, $ = "" === n.ly.sa ? Ct : kt(n.ly.sa), g = function(r) {
            return 4 === r && n.lf.sa;
        }, h = function(r) {
            return 4 !== r && n.ql.sa ? A5(xS, F4(function(n, r, t, e) {
                return {
                    es: e,
                    fV: n,
                    gV: r,
                    h1: t
                };
            }), Oe(n.kg.sa), Oe(n.kh.sa), Oe(n.ki.sa), Oe(n.kf.sa)) : Ct;
        }, k = n.qk.sa ? A3(RS, F2(function(n, r) {
            return {
                jO: r,
                jP: n
            };
        }), Oe(n.jP.sa), Oe(n.jO.sa)) : Ct, C = "" === n.ji.sa ? Ct : kt(n.ji.sa), j = function(r) {
            return A2(mg, r, XS) && !n.n6.sa ? _c(n.i3.sa) : Ct;
        }, w = $y(n.i1.sa), A = "" === n.i$.sa ? Ct : kt(n.i$.sa);
        return A2(dg, function(e) {
            var a, o = e.hp, c = e.ee, f = e.hH, w = e.hG;
            return {
                i$: A,
                i0: (a = o, 1 === a || 16 === a || 11 === a || 10 === a || 8 === a || 9 === a || 14 === a ? Oe(n.i0.sa) : Ct),
                i1: c,
                i3: j(o),
                ji: C,
                bI: k,
                j8: n.j8.sa,
                aH: h(o),
                lf: g(o),
                ly: $,
                lS: n.lS.sa,
                G: v(o),
                ni: p(o),
                nj: m(o),
                nk: b(o),
                nW: n.nW.sa,
                n5: n.n5.sa,
                n6: d(o),
                N: l(o),
                pc: n.pc.sa,
                pd: n.pd.sa,
                aW: s(o),
                qG: o,
                qO: n.qO.sa,
                q2: i,
                q7: w,
                q8: f,
                dG: u,
                sj: t(o),
                dV: A2(Tu, function(n) {
                    return n.dV;
                }, n.qW),
                sr: r(o)
            };
        }, A5(OS, ES, f, w, a, c));
    }, US = ul(A4(kb, "subtitlesSettings", function(n) {
        return n.dG;
    }, Oy, A4(ll, "copyMetadata", function(n) {
        return n.j8;
    }, Zi, A4(kb, "subtitleFormat", function(n) {
        return n.q2;
    }, Di, A4(kb, "subtitleTypeVersion", function(n) {
        return n.q7;
    }, Ry, A4(kb, "subtitleVersion", function(n) {
        return n.q8;
    }, P$, A4(ll, "qcReportTemplate", function(n) {
        return n.pc;
    }, Di, A4(ll, "qcTestPlan", function(n) {
        return n.pd;
    }, Di, A4(kb, "hevcParams", function(n) {
        return n.G;
    }, Wy, A4(kb, "clip", function(n) {
        return n.bI;
    }, Cy, A4(kb, "scale", function(n) {
        return n.aW;
    }, Dy, A4(kb, "crop", function(n) {
        return n.aH;
    }, wy, A4(kb, "videoEdit", function(n) {
        return n.dV;
    }, Zy, A4(ll, "encodeSubtitle", function(n) {
        return n.lf;
    }, Zi, A4(kb, "videoBitrate", function(n) {
        return n.sj;
    }, yy, A4(ll, "writeTimecode", function(n) {
        return n.sr;
    }, Zi, A4(kb, "audioGain", function(n) {
        return n.i3;
    }, yy, A4(kb, "loudnessTruePeak", function(n) {
        return n.nk;
    }, yy, A4(kb, "loudnessProgram", function(n) {
        return n.ni;
    }, yy, A4(kb, "loudnessRange", function(n) {
        return n.nj;
    }, yy, A4(kb, "noLoudness", function(n) {
        return n.n6;
    }, Zi, A4(kb, "options", function(n) {
        return n.N;
    }, My, A4(kb, "bmxArgs", function(n) {
        return n.ji;
    }, Di, A4(kb, "audioArgs", function(n) {
        return n.i$;
    }, Di, A4(kb, "ffmpegArgs", function(n) {
        return n.ly;
    }, Di, A4(ll, "noFrameRateConversion", function(n) {
        return n.n5;
    }, Zi, A4(ll, "frameRate", function(n) {
        return n.lS;
    }, Di, A4(ll, "startTimecode", function(n) {
        return n.qO;
    }, Di, A4(kb, "audioBitrate", function(n) {
        return n.i0;
    }, ml, A4(ll, "audioCodec", function(n) {
        return n.i1;
    }, hy, A4(ll, "specification", function(n) {
        return n.qG;
    }, Ty, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, gl(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(m) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return function($) {
                                                                            return function(g) {
                                                                                return function(h) {
                                                                                    return function(k) {
                                                                                        return function(C) {
                                                                                            return function(j) {
                                                                                                return function(w) {
                                                                                                    return function(A) {
                                                                                                        return function(L) {
                                                                                                            return function(y) {
                                                                                                                return function(S) {
                                                                                                                    return function(F) {
                                                                                                                        return function(T) {
                                                                                                                            return function(Q) {
                                                                                                                                return {
                                                                                                                                    i$: c,
                                                                                                                                    i0: e,
                                                                                                                                    i1: t,
                                                                                                                                    i3: p,
                                                                                                                                    ji: f,
                                                                                                                                    bI: j,
                                                                                                                                    j8: T,
                                                                                                                                    aH: k,
                                                                                                                                    lf: g,
                                                                                                                                    ly: o,
                                                                                                                                    lS: a,
                                                                                                                                    G: w,
                                                                                                                                    ni: b,
                                                                                                                                    nj: d,
                                                                                                                                    nk: m,
                                                                                                                                    nW: n,
                                                                                                                                    n5: i,
                                                                                                                                    n6: l,
                                                                                                                                    N: s,
                                                                                                                                    pc: L,
                                                                                                                                    pd: A,
                                                                                                                                    aW: C,
                                                                                                                                    qG: r,
                                                                                                                                    qO: u,
                                                                                                                                    q2: F,
                                                                                                                                    q7: S,
                                                                                                                                    q8: y,
                                                                                                                                    dG: Q,
                                                                                                                                    sj: $,
                                                                                                                                    dV: h,
                                                                                                                                    sr: v
                                                                                                                                };
                                                                                                                            };
                                                                                                                        };
                                                                                                                    };
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))))))))))))))))))), JS = function(n) {
        return n.O || n.ah ? {
            lz: Lu,
            nE: Js,
            Q: n.Q
        } : {
            lz: n.lz,
            nE: n.nE,
            Q: n.Q
        };
    }, ZS = Gs, KS = function(n) {
        return n.$ ? ZS(n.a) : CA(n.a);
    }, _S = function(n) {
        return A2(Rs, MS, A2(Zw, function(n) {
            return Al(A2(vg, Ky, A3(kg, US, n, $g(Yy))));
        }, A2(nl, JS, KS(VS(n)))));
    }, GS = function(n) {
        return {
            $: 56,
            a: n
        };
    }, YS = function(n) {
        return xs(Gy({
            $: 1,
            a: n
        }));
    }, nF = function(n) {
        return {
            $: 54,
            a: n
        };
    }, rF = F2(function(n, r) {
        return A2(Zw, function(r) {
            return Al(A2(_s, Ky, A3(kg, US, r, Sg(YS(n.mj)))));
        }, A2(nl, JS, KS(VS(r))));
    }), tF = F2(function(n, r) {
        return A2(Rs, nF, A2(rF, n, r));
    }), eF = F2(function(n, r) {
        var t = r.b;
        return d(n(r.a), t);
    }), uF = F2(function(n, r) {
        return "Mire" === n ? {
            d3: 0,
            e$: 10,
            fB: r,
            c9: 0,
            hg: Ct,
            hi: Ct,
            dD: Ct,
            hJ: !1
        } : "Slate" === n ? {
            d3: 0,
            e$: 10,
            fB: r,
            c9: 2,
            hg: Ct,
            hi: Ct,
            dD: Ct,
            hJ: !1
        } : "Video" === n ? {
            d3: 0,
            e$: 10,
            fB: r,
            c9: 3,
            hg: Ct,
            hi: Ct,
            dD: Ct,
            hJ: !1
        } : "Countdown" === n ? {
            d3: 0,
            e$: 10,
            fB: r,
            c9: 4,
            hg: Ct,
            hi: Ct,
            dD: Ct,
            hJ: !1
        } : {
            d3: 0,
            e$: 10,
            fB: r,
            c9: 1,
            hg: Ct,
            hi: Ct,
            dD: Ct,
            hJ: !1
        };
    }), aF = F3(function(n, r, t) {
        var e = n ? t.ek : t.d4, u = $(e, C([
            A2(uF, r, Dt(e))
        ]));
        return p(t, n ? {
            ek: u
        } : {
            d4: u
        });
    }), iF = F2(function(n, r) {
        return A2(Ge, function(n) {
            return p(n.b, {
                fB: n.a
            });
        }, A2(Ot, ng, A2(nc, function(r) {
            var t = r.b;
            return i(r.a, n) ? Ct : kt(t);
        }, A2(Ge, function(n) {
            return d(n.fB, n);
        }, r))));
    }), oF = F2(function(n, r) {
        return p(r, {
            d4: A2(iF, n, r.d4)
        });
    }), cF = F2(function(n, r) {
        return p(r, {
            ek: A2(iF, n, r.ek)
        });
    }), fF = function(n) {
        return p(n, {
            gn: !n.gn
        });
    }, sF = F2(function(n, r) {
        switch(n.$){
            case 0:
                return r;
            case 1:
                var t = Oe(n.a);
                return t.$ ? r : p(r, {
                    e$: t.a
                });
            case 2:
                var e = Oe(n.a);
                return e.$ ? r : p(r, {
                    d3: e.a
                });
            case 4:
                return p(r, {
                    dD: kt(n.a)
                });
            case 3:
                return p(r, {
                    hg: kt(n.a)
                });
            case 5:
                return p(r, {
                    hi: kt(n.a)
                });
            default:
                return p(r, {
                    hJ: n.a
                });
        }
    }), lF = F4(function(n, r, t, e) {
        var u = A2(Ge, function(n) {
            return i(r, n.fB) ? A2(sF, t, n) : n;
        }, n ? e.ek : e.d4);
        return p(e, n ? {
            ek: u
        } : {
            d4: u
        });
    }), dF = F2(function(n, r) {
        n: for(;;){
            if (n.$) return A2(eo, g, p(r, n.b.$ ? {
                dV: A3(aF, n.a, n.b.a, r.dV)
            } : n.a ? {
                je: fF(r.je)
            } : {
                iB: fF(r.iB)
            }));
            if (n.a) {
                if (n.c.$) break n;
                return A2(eo, g, p(r, {
                    dV: A2(cF, n.b, r.dV)
                }));
            }
            if (n.c.$) break n;
            return A2(eo, g, p(r, {
                dV: A2(oF, n.b, r.dV)
            }));
        }
        return A2(eo, g, p(r, {
            dV: A4(lF, n.a, n.b, n.c, r.dV)
        }));
    }), bF = F2(function(n, r) {
        var t, e = (t = r.qW).$ ? d(Ct, p$) : A2(eF, kt, A2(dF, n, t.a)), u = e.b;
        return d(kt(p(r, {
            qW: e.a
        })), u);
    }), mF = F2(function(n, r) {
        switch(n.$){
            case 2:
                return A2(eo, g, p(r, {
                    kL: kt(BS(kt(n.a)))
                }));
            case 1:
                return A2(eo, g, p(r, {
                    kL: kt(BS(Ct))
                }));
            case 3:
                return A2(eo, g, p(r, {
                    kL: Ct,
                    ll: Ct,
                    re: Ct
                }));
            case 4:
                var t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        nW: A2(Wg, t, n.nW)
                    });
                }, r.kL);
                return A2(eo, g, p(r, {
                    kL: e
                }));
            case 5:
                t = n.a;
                var u = A2(Tu, function(n) {
                    var r = A2(mg, n.qG.sa, A2(Ge, Fy, PS)), t = A2(mg, n.qG.sa, A2(Ge, Fy, WS));
                    return p(n, {
                        n6: n.n6.fq ? n.n6 : A2(Qg, n.n6, r),
                        qk: n.qk.fq ? n.qk : A2(Qg, n.qk, t)
                    });
                }, e = A2(Tu, function(n) {
                    return p(n, {
                        qG: A2(Wg, t, n.qG)
                    });
                }, r.kL));
                return A2(eo, g, p(r, {
                    kL: u
                }));
            case 6:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        i1: A2(Wg, t, n.i1)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 7:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        i0: A2(Wg, t, n.i0)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 8:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        qO: A2(Wg, t, n.qO)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 9:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        lS: A2(Wg, t, n.lS)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 10:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        n5: A2(Ig, t, n.n5)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 11:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        ly: A2(Wg, t, n.ly)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 12:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        i$: A2(Wg, t, n.i$)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 13:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        ji: A2(Wg, t, n.ji)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 14:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        j5: A2(Ig, t, n.j5)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 15:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        iW: A2(Ig, t, n.iW)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 16:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        iX: A2(Ig, t, n.iX)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 17:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        jw: A2(Ig, t, n.jw)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 18:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        iA: A2(Wg, t, n.iA)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 19:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        se: A2(Ig, t, n.se)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 20:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        n6: A2(Ig, t, n.n6)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 21:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        nj: A2(Wg, t, n.nj)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 22:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        ni: A2(Wg, t, n.ni)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 23:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        nk: A2(Wg, t, n.nk)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 24:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        i3: A2(Wg, t, n.i3)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 33:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        sr: A2(Ig, t, n.sr)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 34:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        lf: A2(Ig, t, n.lf)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 35:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        kB: A2(Ig, t, n.kB)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 36:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        pf: A2(Wg, t, n.pf)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 41:
                t = n.a;
                var a = A2(Tu, function(n) {
                    return n.qr.sa ? p(n, {
                        mY: A2(Bg, n.mY, "250")
                    }) : n;
                }, e = A2(Tu, function(n) {
                    return p(n, {
                        qr: A2(Ig, t, n.qr)
                    });
                }, r.kL));
                return A2(eo, g, p(r, {
                    kL: a
                }));
            case 25:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        o5: A2(Wg, t, n.o5)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 26:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        o0: A2(Wg, t, n.o0)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 27:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        m5: A2(Wg, t, n.m5)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 32:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        mY: A2(Wg, t, n.mY)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 28:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        l9: A2(Ig, t, n.l9)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 29:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        jT: A2(Wg, t, n.jT)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 30:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        jS: A2(Wg, t, n.jS)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 31:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        kq: A2(Wg, t, n.kq)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 37:
                return t = n.a, a = A2(Tu, function(n) {
                    return n.ql.sa ? p(n, {
                        kf: A2(Bg, n.kf, "0"),
                        kg: A2(Bg, n.kg, "0"),
                        kh: A2(Bg, n.kh, "0"),
                        ki: A2(Bg, n.ki, "0")
                    }) : n;
                }, e = A2(Tu, function(n) {
                    return p(n, {
                        ql: A2(Ig, t, n.ql)
                    });
                }, r.kL)), A2(eo, g, p(r, {
                    kL: a
                }));
            case 48:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        kg: A2(Wg, t, n.kg)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 49:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        kh: A2(Wg, t, n.kh)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 50:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        ki: A2(Wg, t, n.ki)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 51:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        kf: A2(Wg, t, n.kf)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 39:
                return t = n.a, a = A2(Tu, function(n) {
                    return n.qv.sa ? p(n, {
                        pO: A2(Bg, n.pO, "1080"),
                        pQ: A2(Bg, n.pQ, "1920")
                    }) : n;
                }, e = A2(Tu, function(n) {
                    return p(n, {
                        qv: A2(Ig, t, n.qv)
                    });
                }, r.kL)), A2(eo, g, p(r, {
                    kL: a
                }));
            case 40:
                t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        qk: A2(Ig, t, n.qk)
                    });
                }, r.kL);
                var i = function(n) {
                    switch(n){
                        case "ProRes422":
                        case "ProRes4444":
                        case "AVCIntra100":
                        case "XAVCIntra300":
                            return d("70", "935");
                        default:
                            return d("16", "235");
                    }
                }(A2(Qu, "", A2(Tu, A2(Po, function(n) {
                    return n.qG;
                }, function(n) {
                    return n.sa;
                }), r.kL))), o = i.a, c = i.b;
                return a = A2(Tu, function(n) {
                    return n.qk.sa ? p(n, {
                        jO: A2(Bg, n.jO, c),
                        jP: A2(Bg, n.jP, o)
                    }) : n;
                }, e), A2(eo, g, p(r, {
                    kL: a
                }));
            case 42:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        jP: A2(Wg, t, n.jP)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 43:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        jO: A2(Wg, t, n.jO)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 38:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        sj: A2(Wg, t, n.sj)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 46:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        pQ: A2(Wg, t, n.pQ)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 47:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        pO: A2(Wg, t, n.pO)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 44:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        pN: A2(Ig, t, n.pN)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 45:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        pP: A2(Ig, t, n.pP)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 59:
                t = n.a;
                var f = A2(Qu, d(Ct, p$), A2(Tu, bF(t), r.kL));
                return e = f.a, A2(eo, C([
                    A2(wp, yS, f.b)
                ]), p(r, {
                    kL: e
                }));
            case 52:
                var s = r.kL;
                return A2(eo, C(1 === s.$ ? [
                    p$
                ] : 1 === (v = (e = s.a).oF).$ ? [
                    _S(e)
                ] : [
                    A2(tF, v.a, e)
                ]), r);
            case 55:
                return A2(eo, C([
                    (m = n.a, A2(Rs, GS, function(n) {
                        return A2(bp, Hl(n), Al(Lg(Ag(YS(n.mj)))));
                    }(m)))
                ]), r);
            case 53:
                return (l = n.a).$ ? A2(eo, g, A2(SS, l.a, r)) : A2(eo, C([
                    AS
                ]), p(r, {
                    kL: Ct,
                    ll: Ct,
                    re: kt("Audio mapping created")
                }));
            case 54:
                return (l = n.a).$ ? A2(eo, g, A2(SS, l.a, r)) : A2(eo, C([
                    AS
                ]), p(r, {
                    kL: Ct,
                    ll: Ct,
                    re: kt("Audio mapping updated")
                }));
            case 56:
                return (l = n.a).$ ? A2(eo, g, A2(SS, l.a, r)) : A2(eo, C([
                    AS
                ]), r);
            case 0:
                var l;
                if ((l = n.a).$) return A2(eo, g, A2(SS, l.a, r));
                var b = l.a;
                return A2(eo, g, p(r, {
                    c5: b.c5,
                    lT: b.lU,
                    dF: b.dF,
                    dK: b.dK
                }));
            case 58:
                return A2(eo, g, p(r, {
                    ph: A2(Wg, t = n.a, r.ph)
                }));
            case 57:
                return A2(eo, g, p(r, {
                    rs: n.a
                }));
            case 60:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        pd: A2(Wg, t, n.pd)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 61:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        pc: A2(Wg, t, n.pc)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 62:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, n.ju.sa ? {
                        ju: A2(Ig, t, n.ju),
                        q2: A2(Bg, n.q2, ""),
                        q7: A2(Bg, n.q7, ""),
                        q8: A2(Bg, n.q8, "")
                    } : {
                        ju: A2(Ig, t, n.ju)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 63:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        q8: A2(Wg, t, n.q8)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 64:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        q7: A2(Wg, t, n.q7)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 65:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        q2: A2(Wg, t, n.q2)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 66:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        j8: A2(Ig, t, n.j8)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 67:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, n.rc.sa ? {
                        rb: A2(Bg, n.rb, ""),
                        rc: A2(Ig, t, n.rc),
                        rd: A2(Bg, n.rd, "")
                    } : {
                        rc: A2(Ig, t, n.rc)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 68:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        rb: A2(Wg, t, n.rb)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            default:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        rd: A2(Wg, t, n.rd)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
        }
        var m, v;
    }), pF = {
        $: 1
    }, vF = function(n) {
        return {
            $: 58,
            a: n
        };
    }, $F = function(n) {
        return n ? "True" : "False";
    }, gF = function(n) {
        return {
            $: 2,
            a: n
        };
    }, hF = function(n) {
        return {
            $: 57,
            a: n
        };
    }, kF = function(n) {
        return {
            $: 55,
            a: n
        };
    }, CF = function(n) {
        return "left: " + Bt(n.fV) + ", right: " + Bt(n.gV) + ", top: " + Bt(n.h1) + ", bottom: " + Bt(n.es);
    }, jF = F2(function(n, r) {
        return A2(eh, g, C([
            n(r)
        ]));
    }), wF = F2(function(n, r) {
        return th({
            nW: n,
            hf: rh,
            ie: jF(r)
        });
    }), AF = F2(function(n, r) {
        var t;
        return sh({
            nW: n,
            hf: lh((t = r, A2(mu, zi, t))),
            ie: r
        });
    }), LF = function(n) {
        return Bt(n.dk) + "/" + Bt(n.cQ);
    }, yF = function(n) {
        return "profil: " + n.o5 + ", preset: " + n.o0 + ", level: " + n.m5 + ", colorspace: " + n.jT + ", colorPrimaries: " + n.jS + ", curveTransfert: " + n.kq + ", highTiers: " + $F(n.l9) + ", keyframe: " + Bt(n.mY);
    }, SF = function(n) {
        var r, t;
        return "control instanstaneous bitrate: " + $F(n.j5) + ", as10: " + $F(n.iW) + ", as11: " + $F(n.iX) + ", use bwf wrapping: " + $F(n.jw) + ", afd: " + (1 === (t = n.iA).$ ? "N/A" : Bt(t.a)) + ", mxf version 1.2: " + $F(n.se) + ", force deinterlacing: " + $F(n.kB) + ", overwritten qmax: " + (1 === (r = n.pf).$ ? "N/A" : Bt(r.a));
    }, FF = function(n) {
        return "width: " + Bt(n.ih) + ", height: " + Bt(n.ft) + ", keep aspect ratio: " + $F(n.pN) + ", letter/pillar box: " + $F(n.pP);
    }, TF = F2(function(n, r) {
        var t = r.q2;
        if (t.$) return "N/A";
        var e = t.a;
        return A2(Qu, "N/A", Ra(A2(Ge, function(n) {
            return n.nW;
        }, A2(Bu, function(n) {
            return i(n.mj, e);
        }, n))));
    }), QF = C([
        nh("Table")
    ]), IF = F2(function(n, r) {
        return A2(Qu, "", A2(Tu, function(n) {
            return n.nW;
        }, A2(Lo, r.pd, n)));
    }), BF = function() {
        return C([
            nh("TableTr")
        ]);
    }, WF = F2(function(n, r) {
        return ih({
            jW: C([
                A2(wF, "Edit", A2(mu, Dh("Edit"), gF)),
                A2(AF, "Name", function(n) {
                    return n.nW;
                }),
                A2(AF, "Specification", A2(mu, Fy, function(n) {
                    return n.qG;
                })),
                A2(AF, "Test plan", IF(n)),
                A2(AF, "Report template", function(n) {
                    return n.pc;
                }),
                A2(AF, "startTimecode", function(n) {
                    return n.qO;
                }),
                A2(AF, "FrameRate", A2(mu, LF, function(n) {
                    return n.lS;
                })),
                A2(AF, "Video Args", A2(mu, Qu("N/A"), function(n) {
                    return n.ly;
                })),
                A2(AF, "Audio Args", A2(mu, Qu("N/A"), function(n) {
                    return n.i$;
                })),
                A2(AF, "BMX Args", A2(mu, Qu("N/A"), function(n) {
                    return n.ji;
                })),
                A2(AF, "Crop Parameters", A2(mu, A2(mu, Qu("N/A"), Tu(CF)), function(n) {
                    return n.aH;
                })),
                A2(AF, "Scale Parameters", A2(mu, A2(mu, Qu("N/A"), Tu(FF)), function(n) {
                    return n.aW;
                })),
                A2(AF, "Hevc Parameters", A2(mu, A2(mu, Qu("N/A"), Tu(yF)), function(n) {
                    return n.G;
                })),
                A2(AF, "MXF Options", A2(mu, A2(mu, Qu("N/A"), Tu(SF)), function(n) {
                    return n.N;
                })),
                A2(AF, "No Loudness", A2(mu, A2(mu, Qu("N/A"), Tu($F)), function(n) {
                    return n.n6;
                })),
                A2(AF, "Subtitle Version", A2(mu, A2(mu, Qu("N/A"), Tu(W$)), function(n) {
                    return n.q8;
                })),
                A2(AF, "Subtitle Type Version", A2(mu, A2(mu, Qu("N/A"), Tu(Ey)), function(n) {
                    return n.q7;
                })),
                A2(AF, "Subtitle Format", TF(r)),
                A2(wF, "Delete", A2(mu, Kg(Wh), kF))
            ]),
            kr: p(wh, {
                pC: BF,
                rj: QF,
                rv: C([
                    nh("TableTd")
                ])
            }),
            rE: function(n) {
                return n.mj;
            },
            rF: hF
        });
    }), PF = function(n) {
        return {
            $: 15,
            a: n
        };
    }, MF = function(n) {
        return {
            $: 16,
            a: n
        };
    }, qF = function(n) {
        return {
            $: 62,
            a: n
        };
    }, DF = function(n) {
        return {
            $: 17,
            a: n
        };
    }, XF = function(n) {
        return {
            $: 14,
            a: n
        };
    }, EF = function(n) {
        return {
            $: 40,
            a: n
        };
    }, RF = function(n) {
        return {
            $: 37,
            a: n
        };
    }, xF = function(n) {
        return {
            $: 35,
            a: n
        };
    }, OF = function(n) {
        return {
            $: 41,
            a: n
        };
    }, zF = function(n) {
        return {
            $: 28,
            a: n
        };
    }, NF = function(n) {
        return {
            $: 10,
            a: n
        };
    }, HF = function(n) {
        return {
            $: 20,
            a: n
        };
    }, VF = function(n) {
        return {
            $: 39,
            a: n
        };
    }, UF = function(n) {
        return {
            $: 34,
            a: n
        };
    }, JF = function(n) {
        return {
            $: 67,
            a: n
        };
    }, ZF = function(n) {
        return {
            $: 33,
            a: n
        };
    }, KF = function(n) {
        return {
            $: 19,
            a: n
        };
    }, _F = {
        $: 3
    }, GF = function(n) {
        return {
            $: 66,
            a: n
        };
    }, YF = function(n) {
        return {
            $: 18,
            a: n
        };
    }, nT = function(n) {
        return {
            $: 44,
            a: n
        };
    }, rT = function(n) {
        return {
            $: 12,
            a: n
        };
    }, tT = function(n) {
        return {
            $: 7,
            a: n
        };
    }, eT = function(n) {
        return {
            $: 6,
            a: n
        };
    }, uT = function(n) {
        return {
            $: 24,
            a: n
        };
    }, aT = function(n) {
        return {
            $: 13,
            a: n
        };
    }, iT = function(n) {
        return {
            $: 43,
            a: n
        };
    }, oT = function(n) {
        return {
            $: 42,
            a: n
        };
    }, cT = function(n) {
        return {
            $: 30,
            a: n
        };
    }, fT = function(n) {
        return {
            $: 29,
            a: n
        };
    }, sT = function(n) {
        return {
            $: 51,
            a: n
        };
    }, lT = function(n) {
        return {
            $: 48,
            a: n
        };
    }, dT = function(n) {
        return {
            $: 49,
            a: n
        };
    }, bT = function(n) {
        return {
            $: 50,
            a: n
        };
    }, mT = function(n) {
        return {
            $: 31,
            a: n
        };
    }, pT = function(n) {
        return {
            $: 11,
            a: n
        };
    }, vT = function(n) {
        return {
            $: 9,
            a: n
        };
    }, $T = function(n) {
        return {
            $: 47,
            a: n
        };
    }, gT = function(n) {
        return {
            $: 32,
            a: n
        };
    }, hT = function(n) {
        return {
            $: 45,
            a: n
        };
    }, kT = function(n) {
        return {
            $: 27,
            a: n
        };
    }, CT = function(n) {
        return {
            $: 22,
            a: n
        };
    }, jT = function(n) {
        return {
            $: 21,
            a: n
        };
    }, wT = function(n) {
        return {
            $: 23,
            a: n
        };
    }, AT = function(n) {
        return {
            $: 4,
            a: n
        };
    }, LT = function(n) {
        return {
            $: 26,
            a: n
        };
    }, yT = function(n) {
        return {
            $: 25,
            a: n
        };
    }, ST = function(n) {
        return {
            $: 61,
            a: n
        };
    }, FT = function(n) {
        return {
            $: 60,
            a: n
        };
    }, TT = function(n) {
        return {
            $: 36,
            a: n
        };
    }, QT = function(n) {
        return {
            $: 5,
            a: n
        };
    }, IT = function(n) {
        return {
            $: 8,
            a: n
        };
    }, BT = function(n) {
        return {
            $: 65,
            a: n
        };
    }, WT = function(n) {
        return {
            $: 64,
            a: n
        };
    }, PT = function(n) {
        return {
            $: 63,
            a: n
        };
    }, MT = function(n) {
        return {
            $: 68,
            a: n
        };
    }, qT = function(n) {
        return {
            $: 69,
            a: n
        };
    }, DT = function(n) {
        return {
            $: 38,
            a: n
        };
    }, XT = function(n) {
        return {
            $: 46,
            a: n
        };
    }, ET = {
        $: 52
    }, RT = C([
        3,
        4
    ]), xT = ye("br"), OT = C([
        "bt709",
        "bt2020",
        "unknown"
    ]), zT = C([
        "bt709",
        "bt2020_ncl",
        "bt2020_cl",
        "unknown"
    ]), NT = C([
        "bt709",
        "bt2020-10",
        "bt2020-12",
        "unknown"
    ]), HT = ye("h4"), VT = C([
        10,
        11
    ]), UT = ye("hr"), JT = F2(function(n, r) {
        return n ? r : PC;
    }), ZT = C([
        0,
        5,
        6
    ]), KT = C([
        "0",
        "1",
        "2.1",
        "2",
        "3",
        "3.1",
        "4",
        "4.1",
        "5",
        "5.1",
        "5.2",
        "6",
        "6.1",
        "6.2",
        "8.5"
    ]), _T = C([
        10,
        8
    ]), GT = C([
        1,
        11
    ]), YT = C([
        "ultrafast",
        "superfast",
        "veryfast",
        "faster",
        "fast",
        "medium",
        "slow",
        "slower",
        "veryslow",
        "placebo"
    ]), nQ = C([
        "main",
        "main-intra",
        "main444-8",
        "main444-intra",
        "main10",
        "main10-intra",
        "main422-10",
        "main422-10-intra",
        "main444-10",
        "main444-10-intra",
        "main12",
        "main12-intra",
        "main422-12",
        "main422-12-intra",
        "main444-12-intra",
        "main444-12"
    ]), rQ = function(n) {
        switch(n){
            case 0:
                return Pi({
                    bQ: "Partial",
                    bX: "Partiel"
                });
            case 1:
                return Pi({
                    bQ: "Complete",
                    bX: "Complet"
                });
            case 2:
                return Pi({
                    bQ: "Complete without partial",
                    bX: "Complet sans partiel"
                });
            default:
                return Pi({
                    bQ: "SDH",
                    bX: "SME"
                });
        }
    }, tQ = A2(xi, tl, C([
        d(Ey(0), rQ(0)),
        d(Ey(1), rQ(1)),
        d(Ey(2), rQ(2)),
        d(Ey(3), rQ(3))
    ])), eQ = A2(xi, tl, C([
        d(W$(0), fj(0)),
        d(W$(1), fj(1)),
        d(W$(2), fj(2)),
        d(W$(3), fj(3)),
        d(W$(4), fj(4)),
        d(W$(5), fj(5)),
        d(W$(6), fj(6)),
        d(W$(7), fj(7)),
        d(W$(8), fj(8)),
        d(W$(9), fj(9)),
        d(W$(10), fj(10)),
        d(W$(11), fj(11)),
        d(W$(12), fj(12)),
        d(W$(13), fj(13)),
        d(W$(14), fj(14)),
        d(W$(15), fj(15)),
        d(W$(16), fj(16)),
        d(W$(17), fj(17)),
        d(W$(18), fj(18)),
        d(W$(19), fj(19)),
        d(W$(20), fj(20)),
        d(W$(21), fj(21)),
        d(W$(22), fj(22)),
        d(W$(23), fj(23)),
        d(W$(24), fj(24)),
        d(W$(25), fj(25)),
        d(W$(26), fj(26)),
        d(W$(27), fj(27)),
        d(W$(28), fj(28)),
        d(W$(29), fj(29)),
        d(W$(30), fj(30)),
        d(W$(31), fj(31)),
        d(W$(32), fj(32)),
        d(W$(33), fj(33)),
        d(W$(34), fj(34)),
        d(W$(35), fj(35)),
        d(W$(36), fj(36)),
        d(W$(37), fj(37))
    ])), uQ = Yg("target"), aQ = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), iQ = {
        $: 0
    }, oQ = function(n) {
        return {
            $: 1,
            a: n
        };
    }, cQ = F2(function(n, r) {
        var t = r.a, e = r.b;
        return A2(Se, C([
            nh("SelectItem"),
            Zh(C([
                d("SelectItemSelected", i(n.sa, kt(t)))
            ])),
            Mh(oQ(t))
        ]), C([
            ch(e)
        ]));
    }), fQ = function(n) {
        return A2(Se, C([
            nh("Select"),
            Zh(C([
                d("SelectDisabled", !n.e5),
                d("SelectOpened", n.gn)
            ])),
            Mh(iQ),
            MA(n.gn)
        ]), C([
            A2(Se, C([
                nh("SelectButton")
            ]), C([
                A2(Se, C([
                    nh("SelectButtonIcon")
                ]), C([
                    JC
                ])),
                A2(_h, C([
                    nh("SelectButtonTitle")
                ]), A2(Qu, n.gy, A2(Tu, tl, Ra(A2(Bu, function(r) {
                    return i(kt(r.a), n.sa);
                }, n.eC)))))
            ])),
            A2(Se, C([
                nh("SelectList")
            ]), A2(Ge, cQ(n), n.eC))
        ]));
    }, sQ = function(n) {
        return {
            $: 6,
            a: n
        };
    }, lQ = {
        $: 0
    }, dQ = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), bQ = function(n) {
        return {
            $: 2,
            a: n
        };
    }, mQ = function(n) {
        return {
            $: 1,
            a: n
        };
    }, pQ = Pi({
        bQ: "Frame Count",
        bX: "Images suppl\xe9mentaires"
    }), vQ = Pi({
        bQ: "Black",
        bX: "Noir"
    }), $Q = A2(Qh, C([
        Ah("18px"),
        Bh("18px"),
        Ih("0 0 18 18"),
        Vg("IconPlus")
    ]), C([
        A2(UC, C([
            Vg("Fg")
        ]), C([
            A2(Th, C([
                Lh("4 5.5 7.5 9 4 12.5 5.5 14 9 10.5 12.5 14 14 12.5 10.5 9 14 5.5 12.5 4 9 7.5 5.5 4")
            ]), g)
        ]))
    ])), gQ = Pi({
        bQ: "Countdown",
        bX: "Compte \xe0 rebours"
    }), hQ = Pi({
        bQ: "Duration",
        bX: "Dur\xe9e"
    }), kQ = Pi({
        bQ: "(Frames)",
        bX: "(Images)"
    }), CQ = Pi({
        bQ: "Mire",
        bX: "Mire"
    }), jQ = Pi({
        bQ: "(Seconds)",
        bX: "(Secondes)"
    }), wQ = Pi({
        bQ: "Slate",
        bX: "Panneau"
    }), AQ = Pi({
        bQ: "Shift start timecode",
        bX: "D\xe9caler le start timecode"
    }), LQ = F2(function(n, r) {
        switch(r.c9){
            case 3:
                return A2(Se, C([
                    nh("StichSegment")
                ]), C([
                    A2(Se, C([
                        nh("StichSegmentDelete"),
                        Mh(A3(dQ, n, r.fB, lQ))
                    ]), C([
                        $Q
                    ])),
                    A2(_h, C([
                        nh("StichSegmentTitle")
                    ]), "video"),
                    A2(JT, n, A2(Se, C([
                        nh("StichSegmentSubtract")
                    ]), C([
                        A2(rk, C([
                            qh("checkbox"),
                            XC(r.hJ),
                            RC(function(t) {
                                return A3(dQ, n, r.fB, sQ(t));
                            })
                        ]), g),
                        A2(_h, C([
                            nh("StichSegmentTitle")
                        ]), AQ)
                    ]))),
                    A2(Se, C([
                        nh("StichVideoSegment")
                    ]), C([
                        A2(_h, C([
                            nh("StichSegmentUnit")
                        ]), "name"),
                        A2(rk, C([
                            gk("source name"),
                            hk(A2(Qu, "", r.dD)),
                            nh("StichSegmentUrl"),
                            $k(function(t) {
                                return A3(dQ, n, r.fB, {
                                    $: 4,
                                    a: t
                                });
                            })
                        ]), g),
                        A2(_h, C([
                            nh("StichSegmentUnit")
                        ]), "bucket"),
                        A2(rk, C([
                            gk("source bucket"),
                            hk(A2(Qu, "", r.hg)),
                            nh("StichSegmentUrl"),
                            $k(function(t) {
                                return A3(dQ, n, r.fB, {
                                    $: 3,
                                    a: t
                                });
                            })
                        ]), g),
                        A2(_h, C([
                            nh("StichSegmentUnit")
                        ]), "key"),
                        A2(rk, C([
                            gk("source key"),
                            hk(A2(Qu, "", r.hi)),
                            nh("StichSegmentUrl"),
                            $k(function(t) {
                                return A3(dQ, n, r.fB, {
                                    $: 5,
                                    a: t
                                });
                            })
                        ]), g)
                    ]))
                ]));
            case 0:
                return A2(Se, C([
                    nh("StichSegment")
                ]), C([
                    A2(Se, C([
                        nh("StichSegmentDelete"),
                        Mh(A3(dQ, n, r.fB, lQ))
                    ]), C([
                        $Q
                    ])),
                    A2(_h, C([
                        nh("StichSegmentTitle")
                    ]), CQ),
                    A2(JT, n, A2(Se, C([
                        nh("StichSegmentSubtract")
                    ]), C([
                        A2(rk, C([
                            qh("checkbox"),
                            XC(r.hJ),
                            RC(function(t) {
                                return A3(dQ, n, r.fB, sQ(t));
                            })
                        ]), g),
                        A2(_h, C([
                            nh("StichSegmentTitle")
                        ]), AQ)
                    ]))),
                    A2(_h, C([
                        nh("StichSegmentUnit")
                    ]), jQ),
                    A2(rk, C([
                        gk(hQ),
                        hk(Bt(r.e$)),
                        nh("StichSegmentDuration"),
                        $k(function(t) {
                            return A3(dQ, n, r.fB, mQ(t));
                        })
                    ]), g),
                    A2(_h, C([
                        nh("StichSegmentUnit")
                    ]), kQ),
                    A2(rk, C([
                        gk(pQ),
                        hk(Bt(r.d3)),
                        nh("StichSegmentDuration"),
                        $k(function(t) {
                            return A3(dQ, n, r.fB, bQ(t));
                        })
                    ]), g)
                ]));
            case 1:
                return A2(Se, C([
                    nh("StichSegment")
                ]), C([
                    A2(Se, C([
                        nh("StichSegmentDelete"),
                        Mh(A3(dQ, n, r.fB, lQ))
                    ]), C([
                        $Q
                    ])),
                    A2(_h, C([
                        nh("StichSegmentTitle")
                    ]), vQ),
                    A2(JT, n, A2(Se, C([
                        nh("StichSegmentSubtract")
                    ]), C([
                        A2(rk, C([
                            qh("checkbox"),
                            XC(r.hJ),
                            RC(function(t) {
                                return A3(dQ, n, r.fB, sQ(t));
                            })
                        ]), g),
                        A2(_h, C([
                            nh("StichSegmentTitle")
                        ]), AQ)
                    ]))),
                    A2(_h, C([
                        nh("StichSegmentUnit")
                    ]), jQ),
                    A2(rk, C([
                        gk(hQ),
                        hk(Bt(r.e$)),
                        nh("StichSegmentDuration"),
                        $k(function(t) {
                            return A3(dQ, n, r.fB, mQ(t));
                        })
                    ]), g),
                    A2(_h, C([
                        nh("StichSegmentUnit")
                    ]), kQ),
                    A2(rk, C([
                        gk(pQ),
                        hk(Bt(r.d3)),
                        nh("StichSegmentDuration"),
                        $k(function(t) {
                            return A3(dQ, n, r.fB, bQ(t));
                        })
                    ]), g)
                ]));
            case 4:
                return A2(Se, C([
                    nh("StichSegment")
                ]), C([
                    A2(Se, C([
                        nh("StichSegmentDelete"),
                        Mh(A3(dQ, n, r.fB, lQ))
                    ]), C([
                        $Q
                    ])),
                    A2(_h, C([
                        nh("StichSegmentTitle")
                    ]), gQ),
                    A2(JT, n, A2(Se, C([
                        nh("StichSegmentSubtract")
                    ]), C([
                        A2(rk, C([
                            qh("checkbox"),
                            XC(r.hJ),
                            RC(function(t) {
                                return A3(dQ, n, r.fB, sQ(t));
                            })
                        ]), g),
                        A2(_h, C([
                            nh("StichSegmentTitle")
                        ]), AQ)
                    ]))),
                    A2(_h, C([
                        nh("StichSegmentUnit")
                    ]), jQ),
                    A2(rk, C([
                        gk(hQ),
                        hk(Bt(r.e$)),
                        nh("StichSegmentDuration"),
                        $k(function(t) {
                            return A3(dQ, n, r.fB, mQ(t));
                        })
                    ]), g)
                ]));
            default:
                return A2(Se, C([
                    nh("StichSegment")
                ]), C([
                    A2(Se, C([
                        nh("StichSegmentDelete"),
                        Mh(A3(dQ, n, r.fB, lQ))
                    ]), C([
                        $Q
                    ])),
                    A2(_h, C([
                        nh("StichSegmentTitle")
                    ]), wQ),
                    A2(JT, n, A2(Se, C([
                        nh("StichSegmentSubtract")
                    ]), C([
                        A2(rk, C([
                            qh("checkbox"),
                            XC(r.hJ),
                            RC(function(t) {
                                return A3(dQ, n, r.fB, sQ(t));
                            })
                        ]), g),
                        A2(_h, C([
                            nh("StichSegmentTitle")
                        ]), AQ)
                    ]))),
                    A2(_h, C([
                        nh("StichSegmentUnit")
                    ]), jQ),
                    A2(rk, C([
                        gk(hQ),
                        hk(Bt(r.e$)),
                        nh("StichSegmentDuration"),
                        $k(function(t) {
                            return A3(dQ, n, r.fB, mQ(t));
                        })
                    ]), g),
                    A2(_h, C([
                        nh("StichSegmentUnit")
                    ]), kQ),
                    A2(rk, C([
                        gk(pQ),
                        hk(Bt(r.d3)),
                        nh("StichSegmentDuration"),
                        $k(function(t) {
                            return A3(dQ, n, r.fB, bQ(t));
                        })
                    ]), g)
                ]));
        }
    }), yQ = function(n) {
        return A2(Se, C([
            nh("StitchAdd")
        ]), $(A2(Ge, LQ(!1), A2(xi, function(n) {
            return n.fB;
        }, n.dV.d4)), C([
            A2(Sk, aQ(!1), fQ(n.iB))
        ])));
    }, SQ = function(n) {
        return A2(Se, C([
            nh("StitchAdd")
        ]), $(A2(Ge, LQ(!0), A2(xi, function(n) {
            return n.fB;
        }, n.dV.ek)), C([
            A2(Sk, aQ(!0), fQ(n.je))
        ])));
    }, FQ = function(n) {
        return A2(qC, function(r) {
            var t = A2(Ge, function(n) {
                return d(n.a, n.b.nW);
            }, A2(xi, A2(Po, tl, A2(Po, function(n) {
                return n.nW;
            }, zi)), pt(n.dK))), e = A2(Ge, function(n) {
                return d(n.mj, n.nW);
            }, n.dF), u = A2(Ge, function(n) {
                return d(n, n);
            }, nQ), a = A2(Ge, function(n) {
                return d(n, n);
            }, YT), o = A2(Ge, function(n) {
                return d(n, n);
            }, KT), c = i(r.qG.sa, Fy(14)), f = i(r.qG.sa, Fy(4)), s = i(r.qG.sa, Fy(9)), l = function(n) {
                return A2(mg, r.qG.sa, A2(Ge, Fy, n));
            }, b = l(_T), m = l(zS), p = l(GT), v = l(NS), $ = l(WS), h = l(HS), k = l(XS), j = l(ZT), w = i(r.qG.sa, Fy(6)), A = l(VT), L = r.ju.sa, y = i(r.qG.sa, Fy(16)), S = A2(mg, r.i1.sa, A2(Ge, gy, RT)), F = i(r.qG.sa, Fy(5)), T = A2(Ge, function(n) {
                return d(n.mj, LF(n));
            }, n.lT), Q = A2(Ge, function(n) {
                return d(n, n);
            }, A2(Ge, Fy, C([
                0,
                1,
                9,
                2,
                3,
                4,
                10,
                11,
                5,
                6,
                7,
                12,
                8,
                13,
                14,
                15,
                16
            ]))), I = A2(Ge, function(n) {
                return d(n, n);
            }, NT), B = A2(Ge, function(n) {
                return d(n, n);
            }, zT), W = A2(Ge, function(n) {
                return d(n, n);
            }, OT), P = A2(Ge, function(n) {
                return d(gy(n), function(n) {
                    switch(n){
                        case 1:
                            return "pcm_s16le (.wav 16 bits)";
                        case 0:
                            return "pcm_s24le (.wav 24 bits)";
                        case 2:
                            return "pcm_s24be (.aif)";
                        case 3:
                            return "libfdk_aac (.aac)";
                        case 4:
                            return "libmp3lame (.mp3)";
                        default:
                            return "pcm_s24le (.mov)";
                    }
                }(n));
            }, C([
                1,
                0,
                2,
                3,
                4,
                5
            ])), M = A2(Ge, function(n) {
                return d(n, n);
            }, A2(Ge, gy, C([
                1,
                0
            ]))), q = function(n) {
                return 1 !== n.oF.$;
            }(r) ? d("Save", "Edit Format") : d("Create", "New Format");
            return A4(oj, q.b, d(q.a, ET), d("Cancel", _F), C([
                A2(hj, C([
                    wj("https://docs.google.com/document/d/1INml9A9VneiIqDZlNB8FnKTU_NkmstV5SAEFFO2nSmQ"),
                    uQ("_blank")
                ]), C([
                    ch("Help Format Creation")
                ])),
                A2(Sk, AT, VC(r.nW)),
                A2(Sk, QT, A2(rj, r.qG, Q)),
                A2(JT, m || y, A2(Sk, ZF, HC(r.sr))),
                A2(JT, r.sr.sa || !(m || y), A2(Sk, IT, VC(r.qO))),
                A2(Sk, GF, HC(r.j8)),
                A2(xT, g, g),
                A2(UT, g, g),
                A2(xT, g, g),
                A2(HT, g, C([
                    ch("QC")
                ])),
                A2(Sk, FT, A2(rj, r.pd, t)),
                A2(Sk, ST, VC(r.pc)),
                A2(JT, !y, A2(Se, g, C([
                    A2(xT, g, g),
                    A2(UT, g, g),
                    A2(xT, g, g),
                    A2(HT, g, C([
                        ch("Video")
                    ])),
                    A2(JT, p || b || s || c, A2(Sk, DT, VC(r.sj))),
                    A2(Sk, vT, A2(rj, r.lS, T)),
                    A2(Sk, NF, HC(r.n5))
                ]))),
                A2(JT, j, A2(Sk, xF, HC(r.kB))),
                A2(JT, !y, A2(Sk, pT, VC(r.ly))),
                A2(JT, v, A2(Se, g, C([
                    A2(xT, g, g),
                    A2(UT, g, g),
                    A2(xT, g, g),
                    A2(HT, g, C([
                        ch("MXf Parameters")
                    ]))
                ]))),
                A2(JT, h, A2(Sk, TT, VC(r.pf))),
                A2(JT, $, A2(Se, g, C([
                    A2(Sk, XF, HC(r.j5)),
                    A2(Sk, PF, HC(r.iW)),
                    A2(Sk, KF, HC(r.se))
                ]))),
                A2(JT, F, A2(Sk, MF, HC(r.iX))),
                A2(JT, v, A2(Se, g, C([
                    A2(Sk, DF, HC(r.jw)),
                    A2(Sk, YF, VC(r.iA)),
                    A2(Sk, aT, VC(r.ji))
                ]))),
                A2(JT, A, A2(Se, g, C([
                    A2(xT, g, g),
                    A2(UT, g, g),
                    A2(xT, g, g),
                    A2(Se, g, C([
                        A2(Sk, OF, A2(HT, g, C([
                            HC(r.qr)
                        ]))),
                        A2(JT, r.qr.sa, A2(Se, C([
                            nh("EditContainer")
                        ]), C([
                            A2(Sk, yT, A2(rj, r.o5, u)),
                            A2(Sk, kT, A2(rj, r.m5, o)),
                            A2(Sk, LT, A2(rj, r.o0, a)),
                            A2(Sk, zF, HC(r.l9)),
                            A2(Sk, gT, VC(r.mY)),
                            A2(Sk, fT, A2(rj, r.jT, B)),
                            A2(Sk, cT, A2(rj, r.jS, W)),
                            A2(Sk, mT, A2(rj, r.kq, I))
                        ])))
                    ]))
                ]))),
                A2(xT, g, g),
                A2(UT, g, g),
                A2(xT, g, g),
                A2(HT, g, C([
                    ch("Audio")
                ])),
                A2(JT, !y, A2(Sk, eT, A2(rj, r.i1, M))),
                A2(JT, p || b || s || c, A2(Sk, tT, VC(r.i0))),
                A2(JT, k && !y, A2(Se, g, C([
                    A2(Sk, HF, HC(r.n6)),
                    A2(JT, !r.n6.sa, A2(Se, g, C([
                        A2(Sk, jT, VC(r.nj)),
                        A2(Sk, CT, VC(r.ni)),
                        A2(Sk, wT, VC(r.nk)),
                        A2(Sk, uT, VC(r.i3))
                    ])))
                ]))),
                A2(JT, !y, A2(Sk, rT, VC(r.i$))),
                A2(JT, y, A2(Se, g, C([
                    A2(Sk, eT, A2(rj, r.i1, P)),
                    A2(JT, S, A2(Sk, tT, VC(r.i0))),
                    A2(Sk, vT, A2(rj, r.lS, T))
                ]))),
                A2(JT, !(f || y), A2(Se, g, C([
                    A2(xT, g, g),
                    A2(UT, g, g),
                    A2(xT, g, g),
                    A2(HT, g, C([
                        ch("Effects")
                    ])),
                    A2(Sk, RF, HC(r.ql)),
                    A2(JT, r.ql.sa, A2(Se, C([
                        nh("EditContainer")
                    ]), C([
                        A2(Sk, lT, VC(r.kg)),
                        A2(Sk, dT, VC(r.kh)),
                        A2(Sk, bT, VC(r.ki)),
                        A2(Sk, sT, VC(r.kf))
                    ])))
                ]))),
                A2(JT, !(w || f || y), A2(Se, g, C([
                    A2(Sk, VF, HC(r.qv)),
                    A2(JT, r.qv.sa, A2(Se, C([
                        nh("EditContainer")
                    ]), C([
                        A2(Sk, XT, VC(r.pQ)),
                        A2(Sk, $T, VC(r.pO)),
                        A2(Sk, nT, HC(r.pN)),
                        A2(Sk, hT, HC(r.pP))
                    ])))
                ]))),
                A2(JT, !(f || y), A2(Se, g, C([
                    A2(Sk, EF, HC(r.qk)),
                    A2(JT, r.qk.sa, A2(Se, C([
                        nh("EditContainer")
                    ]), C([
                        A2(Sk, oT, VC(r.jP)),
                        A2(Sk, iT, VC(r.jO))
                    ])))
                ]))),
                A2(JT, !y, A2(Se, g, C([
                    A2(qC, function(n) {
                        return A2(Se, C([
                            nh("EditSection")
                        ]), C([
                            A2(xT, g, g),
                            A2(UT, g, g),
                            A2(xT, g, g),
                            A2(HT, g, C([
                                ch("Edit Options")
                            ])),
                            A2(Se, C([
                                nh("EditContainer")
                            ]), C([
                                A2(Sk, yS, SQ(n)),
                                A2(Sk, yS, yQ(n))
                            ]))
                        ]));
                    }, r.qW)
                ]))),
                A2(JT, !y, A2(Se, g, C([
                    A2(xT, g, g),
                    A2(UT, g, g),
                    A2(xT, g, g),
                    A2(HT, g, C([
                        ch("Subtitle")
                    ])),
                    A2(JT, f, A2(Se, g, C([
                        A2(Sk, UF, HC(r.lf))
                    ]))),
                    A2(Sk, qF, HC(r.ju)),
                    A2(JT, L, A2(Se, C([
                        nh("EditContainer")
                    ]), C([
                        A2(Sk, PT, A2(rj, r.q8, eQ)),
                        A2(Sk, WT, A2(rj, r.q7, tQ)),
                        A2(Sk, BT, A2(rj, r.q2, e))
                    ]))),
                    A2(Sk, JF, HC(r.rc)),
                    A2(JT, r.rc.sa, A2(Se, C([
                        nh("EditContainer")
                    ]), C([
                        A2(Sk, MT, VC(r.rb)),
                        A2(Sk, qT, VC(r.rd))
                    ])))
                ])))
            ]));
        }, n.kL);
    }, TQ = F2(function(n, r) {
        var t = zi(r.ph.sa), e = A2(Bu, function(n) {
            return A2(mu, A2(mu, Me(t), zi), function(n) {
                return n.nW;
            })(n) || A2(mu, A2(mu, A2(mu, Me(t), zi), Fy), function(n) {
                return n.qG;
            })(n) || A2(mu, A2(mu, Me(t), zi), function(n) {
                return n.qO;
            })(n) || A2(mu, A2(mu, A2(mu, Me(t), zi), LF), function(n) {
                return n.lS;
            })(n) || A2(mu, A2(mu, A2(mu, Me(t), zi), Qu("N/A")), function(n) {
                return n.ly;
            })(n) || A2(mu, A2(mu, A2(mu, Me(t), zi), Qu("N/A")), function(n) {
                return n.i$;
            })(n) || A2(mu, A2(mu, A2(mu, Me(t), zi), Qu("N/A")), function(n) {
                return n.ji;
            })(n) || A2(mu, A2(mu, A2(mu, A2(mu, Me(t), zi), Qu("N/A")), Tu(SF)), function(n) {
                return n.N;
            })(n) || A2(mu, A2(mu, A2(mu, A2(mu, Me(t), zi), Qu("N/A")), Tu($F)), function(n) {
                return n.n6;
            })(n) || A2(mu, A2(mu, A2(mu, A2(mu, Me(t), zi), Qu("N/A")), Tu(W$)), function(n) {
                return n.q8;
            })(n) || A2(mu, A2(mu, A2(mu, A2(mu, Me(t), zi), Qu("N/A")), Tu(Ey)), function(n) {
                return n.q7;
            })(n) || A2(mu, A2(mu, A2(mu, Me(t), zi), Qu("N/A")), function(n) {
                return n.q2;
            })(n);
        }, r.c5);
        return A3(Wj, "Formats", kt(A2(Dh, "New\u2026", pF)), A2(Se, g, C([
            A2(Sk, vF, kk(r.ph)),
            FQ(r),
            A3(jC, A2(WF, r.dK, r.dF), r.rs, e)
        ])));
    }), QQ = {
        l: function(n) {
            return n.c5;
        },
        m: LS,
        p: F2(function(n, r) {
            return p(n, {
                c5: r
            });
        }),
        q: function(n) {
            return {
                $: 12,
                a: n
            };
        },
        r: mF,
        s: TQ
    }, IQ = F2(function(n, r) {
        return {
            eV: n,
            sd: r
        };
    }), BQ = F2(function(n, r) {
        return {
            jc: n,
            ll: r
        };
    }), WQ = ul(A4(kb, "error", function(n) {
        return n.ll;
    }, Di, A4(ll, "available", function(n) {
        return n.jc;
    }, Zi, gl(BQ)))), PQ = ul(A4(ll, "version", function(n) {
        return n.sd;
    }, Di, A4(ll, "db", function(n) {
        return n.eV;
    }, WQ, gl(IQ)))), MQ = xs({
        $: 23
    }), qQ = Al(A2(_s, PQ, Vs(MQ))), DQ = A2(Rs, Be, qQ), XQ = d({
        lk: Ct
    }, DQ), EQ = F2(function(n, r) {
        return A2(eo, g, p(r, {
            lk: kt(n)
        }));
    }), RQ = F2(function(n, r) {
        return A2(zk, C([
            nh("KeyValueRow")
        ]), C([
            A2(gC, C([
                nh("KeyValueKey")
            ]), C([
                n
            ])),
            A2(gC, C([
                nh("KeyValueValue")
            ]), C([
                r
            ]))
        ]));
    }), xQ = RQ, OQ = F2(function(n, r) {
        return A2(xQ, ch(n), ch(r));
    }), zQ = Ng("transform"), NQ = A2(Qh, C([
        Ah("40px"),
        Bh("40px"),
        Ih("0 0 40 40"),
        Vg("IconSpinner")
    ]), C([
        A2(UC, C([
            zQ("translate(5, 9)")
        ]), C([
            A2(Cj, C([
                kj("M15,0 C21.0751322,0 26,4.92486775 26,11 C26,17.0751322 21.0751322,22 15,22 C9.26195744,22 4.55007179,17.6065 4.04484302,12 L6.05492878,12 C6.55237307,16.4999505 10.3674463,20 15,20 C19.9705627,20 24,15.9705627 24,11 C24,6.02943725 19.9705627,2 15,2 L15,0 Z"),
                Vg("Fg")
            ]), g),
            A2(Th, C([
                Vg("Fg"),
                Lh("5 6 10 12 0 12")
            ]), g)
        ]))
    ])), HQ = F2(function(n, r) {
        return A3(Wj, "Flubber status", Ct, A2(Se, g, function() {
            var n = r.lk;
            if (1 === n.$) return C([
                NQ
            ]);
            var t = n.a;
            if (t.$) {
                var e = t.a;
                return C([
                    A2(_h, C([
                        nh("failed")
                    ]), e.nE)
                ]);
            }
            var u = t.a;
            return C([
                A2(OQ, "Version", u.sd),
                A2(OQ, "Database", u.eV.jc ? "OK" : "KO: " + A2(Qu, "No error", u.eV.ll))
            ]);
        }()));
    }), VQ = {
        l: function(n) {
            return n.c6;
        },
        m: XQ,
        p: F2(function(n, r) {
            return p(n, {
                c6: r
            });
        }),
        q: function(n) {
            return {
                $: 1,
                a: n
            };
        },
        r: EQ,
        s: HQ
    }, UQ = function(n) {
        return {
            $: 2,
            a: n
        };
    }, JQ = A2(Rs, UQ, Al(A2(_s, J$, Vs(K$)))), ZQ = function(n) {
        return {
            $: 3,
            a: n
        };
    }, KQ = A2(Rs, ZQ, Al(A2(_s, zw, Vs(Hw)))), _Q = {
        $9: !1,
        kt: g,
        m_: !1,
        nc: !1,
        oC: !1,
        oD: g,
        oK: A4(jv, Ct, Ct, Ct, Ct),
        qU: !1,
        rs: k$("Completed At"),
        dU: g
    }, GQ = A2(eo, C([
        JQ,
        KQ
    ]), _Q), YQ = F2(function(n, r) {
        switch(n.$){
            case 10:
                return A2(eo, g, p(r, {
                    kt: g
                }));
            case 4:
                return A2(eo, g, p(r, {
                    rs: n.a
                }));
            case 5:
                return A2(eo, g, p(r, {
                    oC: !r.oC
                }));
            case 6:
                return A2(eo, g, p(r, {
                    m_: !r.m_
                }));
            case 7:
                return A2(eo, g, p(r, {
                    qU: !r.qU
                }));
            case 8:
                return A2(eo, g, p(r, {
                    $9: !r.$9
                }));
            case 2:
                return A2(eo, g, (u = n.a).$ ? r : p(r, {
                    oD: u.a
                }));
            case 9:
                return A2(eo, g, p(r, {
                    oK: e = n.a
                }));
            case 1:
                var t = n.a, e = t.a;
                return A2(eo, g, p(r, (u = t.b).$ ? {
                    kt: g
                } : {
                    kt: u.a,
                    nc: !1,
                    oK: e
                }));
            case 0:
                return A2(eo, g, p(r, (u = n.a).$ ? {
                    kt: g
                } : {
                    kt: u.a,
                    nc: !1
                }));
            default:
                var u;
                return A2(eo, g, (u = n.a).$ ? r : p(r, {
                    dU: u.a
                }));
        }
    }), nI = function(n) {
        return {
            $: 4,
            a: n
        };
    }, rI = F2(function(n, r) {
        return A2(eh, g, C([
            n(r)
        ]));
    }), tI = F2(function(n, r) {
        return th({
            nW: n,
            hf: rh,
            ie: rI(r)
        });
    }), eI = F3(function(n, r, t) {
        return th({
            nW: n,
            hf: zA(A2(mu, NA, t)),
            ie: rI(r)
        });
    }), uI = F2(function(n, r) {
        return A3(eI, n, function(n) {
            return UA(r(n));
        }, r);
    }), aI = F2(function(n, r) {
        if (r.$) return "";
        var t = r.a;
        return A2(Qu, "", A2(Tu, function(n) {
            return n.nW;
        }, Ra(A2(Bu, function(n) {
            return i(n.mj, t);
        }, n))));
    }), iI = F2(function(n, r) {
        return A2(Qu, "", A2(Tu, function(n) {
            return n.nW;
        }, Ra(A2(Bu, function(n) {
            return i(n.mj, r);
        }, n.oD))));
    }), oI = F2(function(n, r) {
        return th({
            nW: n,
            hf: zA(A2(mu, A2(mu, function(n) {
                return A2(Qu, 0, n);
            }, Tu(NA)), r)),
            ie: rI(function(n) {
                return A2(Qu, A2(Se, g, g), A2(Tu, UA, r(n)));
            })
        });
    }), cI = C([
        nh("Table")
    ]), fI = function() {
        return C([
            nh("TableTr")
        ]);
    }, sI = function(n) {
        return ih({
            jW: C([
                A2(YA, "Organization", A2(mu, iI(n), function(n) {
                    return n.oz;
                })),
                A2(YA, "Type", A2(mu, Gw, function(n) {
                    return n.fO;
                })),
                A2(uI, "Created At", function(n) {
                    return n.ke;
                }),
                A2(YA, "Requester", A2(mu, A2(mu, aI(n.dU), kt), function(n) {
                    return n.pr;
                })),
                A2(oI, "Started At", function(n) {
                    return n.qP;
                }),
                A2(YA, "Started By", A2(mu, aI(n.dU), function(n) {
                    return n.qQ;
                })),
                A2(oI, "Completed At", function(n) {
                    return n.j_;
                }),
                A2(YA, "Completed By", A2(mu, aI(n.dU), function(n) {
                    return n.j$;
                })),
                A2(YA, "Acknowledge By", A2(mu, aI(n.dU), function(n) {
                    return n.io;
                })),
                A2(YA, "External Job Id", A2(mu, Qu(""), function(n) {
                    return n.lt;
                })),
                A2(tI, "Show", A2(mu, function(n) {
                    return A2(hj, C([
                        wj("/show/" + n.qs)
                    ]), C([
                        ch(GA(n))
                    ]));
                }, function(n) {
                    return n.qu;
                })),
                A2(YA, "Id", function(n) {
                    return n.mj;
                })
            ]),
            kr: p(wh, {
                pC: fI,
                rj: cI,
                rv: C([
                    nh("TableTd")
                ])
            }),
            rE: function(n) {
                return n.mj;
            },
            rF: nI
        });
    }, lI = {
        $: 5
    }, dI = F2(function(n, r) {
        return b(i(n.oK.oz, kt(r.mj)), "/admin" + IA({
            C: n.oK.C,
            c9: n.oK.c9,
            oz: kt(r.mj),
            Q: n.oK.Q
        }), r.nW);
    }), bI = ye("p"), mI = {
        $: 8
    }, pI = function(n) {
        switch(zi(n)){
            case "true":
                return kt(!0);
            case "false":
                return kt(!1);
            default:
                return Ct;
        }
    }, vI = F2(function(n, r) {
        return b(i(n.oK.C, pI(zi(r.a))), "/admin" + IA({
            C: pI(zi(r.a)),
            c9: n.oK.c9,
            oz: n.oK.oz,
            Q: n.oK.Q
        }), r.b);
    }), $I = function(n) {
        var r = C([
            d("", "Acknowledged and Not Acknowledged"),
            d("true", "Acknowledged"),
            d("false", "Not Acknowledged")
        ]);
        return A4(DA, n.$9, mI, A2(Ge, vI(n), r), "Filter by Acknowledged");
    }, gI = {
        $: 7
    }, hI = F2(function(n, r) {
        return b(i(n.oK.Q, kt(zi(r.a))), "/admin" + IA({
            C: n.oK.C,
            c9: n.oK.c9,
            oz: n.oK.oz,
            Q: kt(zi(r.a))
        }), r.b);
    }), kI = function(n) {
        var r = C([
            d("", "All Status"),
            d("true", "true"),
            d("false", "false")
        ]);
        return A4(DA, n.qU, gI, A2(Ge, hI(n), r), "Filter by Status");
    }, CI = {
        $: 6
    }, jI = F2(function(n, r) {
        return b(i(n.oK.c9, kt(zi(r.a))), "/admin" + IA({
            C: n.oK.C,
            c9: kt(zi(r.a)),
            oz: n.oK.oz,
            Q: n.oK.Q
        }), r.b);
    }), wI = function(n) {
        var r = C([
            d("", "All Types"),
            d("DownloadAsIs", "DownloadAsIs"),
            d("PadTranscode", "PadTranscode"),
            d("SimpleTranscode", "SimpleTranscode"),
            d("QC", "QC"),
            d("Spotcheck", "Spotcheck")
        ]);
        return A4(DA, n.m_, CI, A2(Ge, jI(n), r), "Filter by type");
    }, AI = F2(function(n, r) {
        return A2(Se, C([
            nh("DarkZone"),
            nh("Filter")
        ]), C([
            A2(Se, C([
                nh("JobsFilters")
            ]), C([
                wI(n),
                kI(n),
                $I(n)
            ])),
            A2(Se, C([
                nh("Summary")
            ]), C([
                A2(yA, g, C([
                    ch("Summary")
                ])),
                A2(bI, g, C([
                    ch("")
                ])),
                A2(bI, g, C([
                    ch("Total Jobs: " + Bt(Dt(r)))
                ]))
            ]))
        ]));
    }), LI = F2(function(n, r) {
        var t = r.oK.c9, e = r.oK.Q, u = r.oK.C, a = A2(Bu, function(n) {
            return i(kt(n.C), u) || i(u, Ct);
        }, A2(Bu, function(n) {
            if (t.$) return !0;
            var r = t.a;
            if (qe(r) > 0) {
                var e = FA(n);
                return i(zi(Gw(e.fO)), r);
            }
            return !0;
        }, A2(Bu, function(n) {
            n: for(; !e.$;)switch(e.a){
                case "true":
                    return !i(n.j_, Ct);
                case "false":
                    return i(n.j_, Ct);
                default:
                    break n;
            }
            return !0;
        }, r.kt)));
        return A3(Wj, "Jobs", kt(function(n) {
            var r = A2(xi, A2(mu, zi, function(n) {
                return n.nW;
            }), n.oD);
            return A4(DA, n.oC, lI, A2(Ge, dI(n), r), "Choose origanization");
        }(r)), r.nc ? A2(Se, C([
            nh("EmptySection")
        ]), C([
            A2(Se, g, C([
                ch("loading...")
            ]))
        ])) : A2(Se, g, C([
            A2(AI, r, a),
            A3(jC, sI(r), r.rs, a)
        ])));
    }), yI = {
        l: function(n) {
            return n.c7;
        },
        m: GQ,
        p: F2(function(n, r) {
            return p(n, {
                c7: r
            });
        }),
        q: function(n) {
            return {
                $: 15,
                a: n
            };
        },
        r: YQ,
        s: LI
    }, SI = {
        $: 10
    }, FI = function(n) {
        return {
            $: 0,
            a: n
        };
    }, TI = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), QI = function(n) {
        return {
            $: 6,
            a: n
        };
    }, II = F2(function(n, r) {
        return A2(mA, r, A2(Qu, A2(fA, r.mj, C([
            sA(r.mj)
        ])), Ra(A2(Bu, function(n) {
            return i(n.qs, r.g9);
        }, n))));
    }), BI = function(n) {
        return A2(bp, function(r) {
            return A2(Ge, II(r), n);
        }, Al(A2(_s, bA, A3(kg, cA, aA(A2(Ge, function(n) {
            return n.g9;
        }, n)), $g(oA)))));
    }, WI = function(n) {
        return A2(Rs, FI, function(n) {
            return A2(Zw, BI, function(n) {
                return Al(A2(_s, rA, Vs(xs(QI(A2(TI, n, 2))))));
            }(n));
        }(n));
    }, PI = function(n) {
        return A2(b$, Hl({
            $: 9,
            a: n
        }), CA(0));
    }, MI = {
        kL: Ct,
        ll: Ct,
        ph: Xi(function(n) {
            return p(n, {
                gy: "Search Audio Mapping by Organization, Name or Tracks",
                sa: ""
            });
        }),
        pR: g,
        re: Ct,
        rs: k$("Organization")
    }, qI = function(n) {
        return {
            $: 0,
            a: n
        };
    }, DI = F4(function(n, r, t, e) {
        return {
            kJ: t,
            lz: e,
            mj: n,
            nW: r
        };
    }), XI = F5(function(n, r, t, e, u) {
        var a = u;
        return {
            e: A3(Te, F2(function(n, r) {
                return n(r);
            }), a.e, $b(C([
                A2(du, n, mi(t)),
                Qe(e)
            ]))),
            g: function(e) {
                return A2(bt, d(n, A2(sl, t, r(e))), a.g(e));
            }
        };
    }), EI = F3(function(n, r, t) {
        return {
            nW: n,
            rR: r,
            sb: t
        };
    }), RI = ul(A4(ll, "values", function(n) {
        return n.sb;
    }, $l(Di), A4(ll, "type", function(n) {
        return n.rR;
    }, Di, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, gl(EI))))), xI = ul(A5(XI, "fields", function(n) {
        return n.lz;
    }, $l(RI), g, A4(ll, "description", function(n) {
        return n.kJ;
    }, Di, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(DI)))))), OI = function(n) {
        return {
            $: 2,
            a: n
        };
    }, zI = X$(OI({
        $: 1
    })), NI = Al(A2(_s, $l(xI), Vs(zI))), HI = A2(Rs, qI, NI), VI = d(MI, HI), UI = F2(function(n, r) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    n -= 1, r = r.b;
                    continue n;
                }
                return r;
            }
            return r;
        }
    }), JI = F2(function(n, r) {
        return p(r, {
            ll: kt(n.nE),
            re: Ct
        });
    }), ZI = function(n) {
        return Xi(function(r) {
            return p(r, {
                m$: "Value",
                sa: n
            });
        });
    }, KI = function(n) {
        return {
            nW: Xi(function(r) {
                return p(r, {
                    m$: "Label",
                    sa: n.nW
                });
            }),
            rR: Xi(function(r) {
                return p(r, {
                    m$: "Type",
                    sa: n.rR
                });
            }),
            sb: A2(Ge, ZI, n.sb)
        };
    }, _I = KI({
        nW: "",
        rR: "",
        sb: g
    }), GI = function(n) {
        return {
            $: 7,
            a: n
        };
    }, YI = F3(function(n, r, t) {
        return {
            kJ: r,
            lz: t,
            nW: n
        };
    }), nB = ul(A4(ll, "fields", function(n) {
        return n.lz;
    }, $l(RI), A4(ll, "description", function(n) {
        return n.kJ;
    }, Di, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, gl(YI))))), rB = function(n) {
        return A2(Rs, GI, function(n) {
            return Al(Lg(A3(kg, nB, {
                kJ: n.kJ.sa,
                lz: A2(Ge, function(n) {
                    return {
                        nW: n.nW.sa,
                        rR: n.rR.sa,
                        sb: A2(Ge, function(n) {
                            return n.sa;
                        }, n.sb)
                    };
                }, n.lz),
                nW: n.nW.sa
            }, $g(zI))));
        }(n));
    }, tB = function(n) {
        return {
            $: 9,
            a: n
        };
    }, eB = function(n) {
        return X$(OI({
            $: 2,
            a: n
        }));
    }, uB = function(n) {
        return {
            $: 8,
            a: n
        };
    }, aB = F2(function(n, r) {
        return Al(Lg(A3(kg, nB, {
            kJ: r.kJ.sa,
            lz: A2(Ge, function(n) {
                return {
                    nW: n.nW.sa,
                    rR: n.rR.sa,
                    sb: A2(Ge, function(n) {
                        return n.sa;
                    }, n.sb)
                };
            }, r.lz),
            nW: r.nW.sa
        }, Sg(eB(n.mj)))));
    }), iB = F2(function(n, r) {
        return A2(Rs, uB, A2(aB, n, r));
    }), oB = function(n) {
        var r = function(n) {
            return A2(Po, Tu(n), Qu(""));
        };
        return {
            kJ: Xi(function(t) {
                return p(t, {
                    m$: "Description",
                    sa: A2(r, function(n) {
                        return n.kJ;
                    }, n)
                });
            }),
            lz: n.$ ? g : A2(Ge, KI, n.a.lz),
            nW: Xi(function(t) {
                return p(t, {
                    m$: "Name",
                    sa: A2(r, function(n) {
                        return n.nW;
                    }, n)
                });
            }),
            oF: n
        };
    }, cB = F2(function(n, r) {
        var t = n.kL;
        return t.$ ? n : p(n, {
            kL: kt(r(t.a))
        });
    }), fB = F3(function(n, r, t) {
        return A2(cB, n, function(n) {
            return p(n, {
                lz: A2(Ot, F2(function(n, e) {
                    return i(n, r) ? t(e) : e;
                }), n.lz)
            });
        });
    }), sB = F4(function(n, r, t, e) {
        return A3(fB, n, r, function(n) {
            return p(n, {
                sb: A2(Ot, F2(function(n, r) {
                    return i(n, t) ? A2(Wg, e, r) : r;
                }), n.sb)
            });
        });
    }), lB = F2(function(n, r) {
        switch(n.$){
            case 2:
                return A2(eo, g, p(r, {
                    kL: kt(oB(kt(n.a)))
                }));
            case 1:
                return A2(eo, g, p(r, {
                    kL: kt(oB(Ct))
                }));
            case 5:
                return A2(eo, g, p(r, {
                    kL: Ct,
                    ll: Ct,
                    re: Ct
                }));
            case 3:
                var t = n.a;
                return A2(eo, g, A2(cB, r, function(n) {
                    return p(n, {
                        nW: A2(Wg, t, n.nW)
                    });
                }));
            case 4:
                return t = n.a, A2(eo, g, A2(cB, r, function(n) {
                    return p(n, {
                        kJ: A2(Wg, t, n.kJ)
                    });
                }));
            case 6:
                var e = r.kL;
                if (1 === e.$) return A2(eo, C([
                    p$
                ]), r);
                var u = e.a;
                return A2(eo, C([
                    (f = u.oF, 1 === f.$ ? rB(u) : A2(iB, f.a, u))
                ]), r);
            case 10:
                return A2(eo, C([
                    (c = n.a, A2(Rs, tB, function(n) {
                        return Al(Lg(Ag(eB(n.mj))));
                    }(c)))
                ]), r);
            case 7:
                return (a = n.a).$ ? A2(eo, g, A2(JI, a.a, r)) : A2(eo, C([
                    HI
                ]), p(r, {
                    ll: Ct,
                    re: kt("Schema created")
                }));
            case 8:
                return (a = n.a).$ ? A2(eo, g, A2(JI, a.a, r)) : A2(eo, C([
                    HI
                ]), p(r, {
                    ll: Ct,
                    re: kt("Schema updated")
                }));
            case 9:
                return (a = n.a).$ ? A2(eo, g, A2(JI, a.a, r)) : A2(eo, C([
                    HI
                ]), r);
            case 0:
                var a;
                return A2(eo, g, (a = n.a).$ ? A2(JI, a.a, r) : p(r, {
                    pR: a.a
                }));
            case 19:
                return A2(eo, g, p(r, {
                    ph: A2(Wg, t = n.a, r.ph)
                }));
            case 18:
                return A2(eo, g, p(r, {
                    rs: n.a
                }));
            case 11:
                return A2(eo, g, A2(cB, r, function(n) {
                    return p(n, {
                        lz: _u(C([
                            n.lz,
                            C([
                                _I
                            ])
                        ]))
                    });
                }));
            case 12:
                return A2(eo, g, A3(fB, r, i = n.a, function(n) {
                    return p(n, {
                        sb: _u(C([
                            n.sb,
                            C([
                                ZI("")
                            ])
                        ]))
                    });
                }));
            case 13:
                return t = n.b, A2(eo, g, A3(fB, r, n.a, function(n) {
                    return p(n, {
                        nW: A2(Wg, t, n.nW)
                    });
                }));
            case 14:
                return t = n.b, A2(eo, g, A3(fB, r, n.a, function(n) {
                    return p(n, {
                        rR: A2(Wg, t, n.rR)
                    });
                }));
            case 15:
                return A2(eo, g, A4(sB, r, i = n.a, o = n.b, t = n.c));
            case 16:
                var i = n.a;
                return A2(eo, g, A2(cB, r, function(n) {
                    return p(n, {
                        lz: _u(C([
                            A2(Ja, i, n.lz),
                            A2(UI, i + 1, n.lz)
                        ]))
                    });
                }));
            default:
                var o = n.b;
                return A2(eo, g, A3(fB, r, i = n.a, function(n) {
                    return p(n, {
                        sb: _u(C([
                            A2(Ja, o, n.sb),
                            A2(UI, o + 1, n.sb)
                        ]))
                    });
                }));
        }
        var c, f;
    }), dB = {
        $: 1
    }, bB = function(n) {
        return {
            $: 19,
            a: n
        };
    }, mB = function(n) {
        return {
            $: 2,
            a: n
        };
    }, pB = function(n) {
        return {
            $: 10,
            a: n
        };
    }, vB = F2(function(n, r) {
        return A2(eh, g, C([
            n(r)
        ]));
    }), $B = F2(function(n, r) {
        return th({
            nW: n,
            hf: rh,
            ie: vB(r)
        });
    }), gB = F2(function(n, r) {
        var t;
        return sh({
            nW: n,
            hf: lh((t = r, A2(mu, zi, t))),
            ie: r
        });
    }), hB = C([
        nh("Table")
    ]), kB = ih({
        jW: C([
            A2($B, "Edit", A2(mu, Dh("Edit"), mB)),
            A2(gB, "Name", function(n) {
                return n.nW;
            }),
            A2(gB, "Description", function(n) {
                return n.kJ;
            }),
            A2($B, "Delete", A2(mu, Kg(Wh), pB))
        ]),
        kr: p(wh, {
            pC: function() {
                return C([
                    nh("TableTr")
                ]);
            },
            rj: hB,
            rv: C([
                nh("TableTd")
            ])
        }),
        rE: function(n) {
            return n.mj;
        },
        rF: function(n) {
            return {
                $: 18,
                a: n
            };
        }
    }), CB = {
        $: 5
    }, jB = function(n) {
        return {
            $: 4,
            a: n
        };
    }, wB = F2(function(n, r) {
        return {
            $: 13,
            a: n,
            b: r
        };
    }), AB = F2(function(n, r) {
        return {
            $: 14,
            a: n,
            b: r
        };
    }), LB = F3(function(n, r, t) {
        return {
            $: 15,
            a: n,
            b: r,
            c: t
        };
    }), yB = function(n) {
        return {
            $: 3,
            a: n
        };
    }, SB = {
        $: 11
    }, FB = function(n) {
        return {
            $: 12,
            a: n
        };
    }, TB = F2(function(n, r) {
        return {
            $: 17,
            a: n,
            b: r
        };
    }), QB = {
        $: 6
    }, IB = F2(function(n, r) {
        return A2(Se, C([
            nh("ButtonIcon"),
            Mh(r)
        ]), C([
            n
        ]));
    }), BB = ye("textarea"), WB = function(n) {
        return A2(Yh, n, A2(BB, C([
            nh("InputTextarea"),
            sk(n.kT),
            $k(zh),
            bk(Nh),
            mk(Hh),
            hk(n.sa),
            gk(n.gy),
            tk(ck(n.m$)),
            nk(n.kO)
        ]), g));
    }, PB = function(n) {
        return A2(NC, n, WB(n));
    }, MB = C([
        d("string", "String"),
        d("date", "Date"),
        d("number", "Number"),
        d("boolean", "Boolean")
    ]), qB = function(n) {
        return A2(qC, function(n) {
            var r = function(n) {
                return 1 !== n.oF.$;
            }(n) ? d("Save", "Edit Schema") : d("Create", "New Schema");
            return A4(oj, r.b, d(r.a, QB), d("Cancel", CB), C([
                A2(Sk, yB, VC(n.nW)),
                A2(Sk, jB, PB(n.kJ)),
                A2(Se, g, C([
                    A2(Se, g, A2(Ot, F2(function(n, r) {
                        var t;
                        return A2(Se, g, C([
                            A2(Se, C([
                                nh("FieldTitle")
                            ]), C([
                                A2(IB, Wh, (t = n, {
                                    $: 16,
                                    a: t
                                })),
                                Fj("Field #" + Bt(n + 1))
                            ])),
                            A2(Sk, wB(n), VC(r.nW)),
                            A2(Sk, AB(n), A2(rj, r.rR, MB)),
                            A2(JT, "string" === r.rR.sa, A2(Se, C([
                                nh("InputLabel")
                            ]), C([
                                A2(ph, C([
                                    nh("InputLabelText")
                                ]), C([
                                    ch("Possible values:")
                                ])),
                                A2(Se, C([
                                    nh("FieldBloc")
                                ]), $(i(r.sb, g) ? C([
                                    ch("All values are accepted.")
                                ]) : A2(Ot, F2(function(r, t) {
                                    return A2(Se, C([
                                        nh("FieldLine")
                                    ]), C([
                                        A2(Sk, A2(LB, n, r), VC(t)),
                                        A2(IB, Wh, A2(TB, n, r))
                                    ]));
                                }), r.sb), C([
                                    A2(Dh, "Add possible Value", FB(n))
                                ])))
                            ])))
                        ]));
                    }), n.lz)),
                    A2(Se, g, C([
                        A2(Dh, "Add New Field", SB)
                    ]))
                ])),
                A2(UT, g, g)
            ]));
        }, n.kL);
    }, DB = F2(function(n, r) {
        var t = zi(r.ph.sa), e = A2(Bu, function(n) {
            return A2(mu, A2(mu, Me(t), zi), function(n) {
                return n.nW;
            })(n) || A2(mu, A2(mu, Me(t), zi), function(n) {
                return n.kJ;
            })(n);
        }, r.pR);
        return A3(Wj, "Metadata Schemas", kt(A2(Dh, "New\u2026", dB)), A2(Se, g, C([
            A2(Sk, bB, kk(r.ph)),
            qB(r),
            A3(jC, kB, r.rs, e)
        ])));
    }), XB = {
        l: function(n) {
            return n.dd;
        },
        m: VI,
        p: F2(function(n, r) {
            return p(n, {
                dd: r
            });
        }),
        q: function(n) {
            return {
                $: 16,
                a: n
            };
        },
        r: lB,
        s: DB
    }, EB = {
        iR: Lu,
        kL: Ct,
        ll: Ct,
        oA: g,
        oD: g,
        ph: Xi(function(n) {
            return p(n, {
                gy: "Search Organizations",
                sa: ""
            });
        }),
        re: Ct,
        rs: k$("Organization")
    }, RB = function(n) {
        return {
            $: 0,
            a: n
        };
    }, xB = function(n) {
        return {
            $: 3,
            a: n
        };
    }, OB = X$(OI(xB({
        $: 0
    }))), zB = F3(function(n, r, t) {
        return {
            iQ: r,
            e4: t,
            oB: n
        };
    }), NB = ul(A4(kb, "enablePayment", function(n) {
        return n.e4;
    }, Zi, A4(ll, "app", function(n) {
        return n.iQ;
    }, Di, A4(ll, "organizationId", function(n) {
        return n.oB;
    }, Di, gl(zB))))), HB = $l(NB), VB = Al(A2(_s, HB, Vs(OB))), UB = Al(A2(_s, J$, Vs(K$))), JB = A2(Rs, RB, mp(d(UB, VB))), ZB = d(EB, JB), KB = function(n) {
        return {
            $: 5,
            a: n
        };
    }, _B = F3(function(n, r, t) {
        return {
            iQ: r,
            e4: t,
            oB: n
        };
    }), GB = ul(A4(ll, "enablePayment", function(n) {
        return n.e4;
    }, Zi, A4(ll, "app", function(n) {
        return n.iQ;
    }, Di, A4(ll, "organizationId", function(n) {
        return n.oB;
    }, Di, gl(_B))))), YB = function(n) {
        return Al(Lg(A3(kg, GB, n, $g(OB))));
    }, nW = {
        n$: Ct,
        oB: Ct
    }, rW = F2(function(n, r) {
        return p(r, {
            ll: kt(n.nE),
            re: Ct
        });
    }), tW = F2(function(n, r) {
        for(;;){
            if (!r.b) return Ct;
            var t = r.a, e = r.b;
            if (i(n, t.mj)) return kt(t);
            r = e;
        }
    }), eW = function(n) {
        return {
            $: 6,
            a: n
        };
    }, uW = F2(function(n, r) {
        return {
            iQ: n,
            e4: r
        };
    }), aW = ul(A4(ll, "enablePayment", function(n) {
        return n.e4;
    }, Zi, A4(ll, "app", function(n) {
        return n.iQ;
    }, Di, gl(uW)))), iW = F2(function(n, r) {
        return Al(Lg(A3(kg, aW, r, Sg(function(n) {
            return X$(OI(xB({
                $: 1,
                a: n
            })));
        }(n)))));
    }), oW = F3(function(n, r, t) {
        return A2(Rs, eW, A2(iW, n, {
            iQ: r,
            e4: t
        }));
    }), cW = F2(function(n, r) {
        switch(n.$){
            case 0:
                if (n.a.$) return A2(eo, g, A2(rW, n.a.a, r));
                var t = n.a.a, e = t.a, u = t.b, a = A3(_e, F2(function(n, r) {
                    return A3(Wo, n.oB, function(r) {
                        if (r.$) {
                            var t = A2(tW, n.oB, e);
                            if (t.$) return Ct;
                            var u = t.a;
                            return kt({
                                iQ: n,
                                oz: u,
                                pW: zi(u.nW)
                            });
                        }
                        return kt(p(r.a, {
                            iQ: n
                        }));
                    }, r);
                }), Lu, u);
                return A2(eo, g, p(r, {
                    iR: a,
                    oA: u,
                    oD: e
                }));
            case 2:
                return A2(eo, g, p(r, {
                    kL: Ct,
                    ll: Ct,
                    re: Ct
                }));
            case 3:
                var i = A2(Ge, A2(mu, Rs(KB), YB), A2(Qu, g, A2(Tu, za, A2(Lp, function(n) {
                    var r = d(n.oB, n.n$);
                    return r.a.$ || r.b.$ ? Ct : kt({
                        iQ: r.b.a,
                        e4: !1,
                        oB: r.a.a
                    });
                }, r.kL))));
                return A2(eo, i, p(r, {
                    kL: A2(Tu, function(n) {
                        return p(n, {
                            n$: Ct
                        });
                    }, r.kL),
                    ll: Ct,
                    re: Ct
                }));
            case 4:
                var o = n.a;
                return A2(eo, g, p(r, {
                    kL: kt(p(A2(Qu, nW, r.kL), {
                        oB: "" === o ? Ct : kt(o)
                    }))
                }));
            case 11:
                var c = n.a;
                return A2(eo, g, p(r, {
                    kL: kt(p(A2(Qu, nW, r.kL), {
                        n$: "" === c ? Ct : kt(c)
                    }))
                }));
            case 1:
                return A2(eo, g, p(r, {
                    ll: Ct,
                    re: Ct
                }));
            case 5:
                return (f = n.a).$ ? A2(eo, g, A2(rW, f.a, r)) : A2(eo, C([
                    JB
                ]), p(r, {
                    ll: Ct,
                    re: kt("Onboarded organization onto app")
                }));
            case 6:
                var f;
                return (f = n.a).$ ? A2(eo, g, A2(rW, f.a, r)) : A2(eo, C([
                    JB
                ]), p(r, {
                    ll: Ct,
                    re: kt("Updated onboarded organization onto app")
                }));
            case 8:
                return A2(eo, g, p(r, {
                    kL: kt(p(nW, {
                        oB: kt(n.a.oz.mj)
                    }))
                }));
            case 9:
                return A2(eo, g, p(r, {
                    kL: kt(nW),
                    ll: Ct,
                    re: Ct
                }));
            case 7:
                return A2(eo, g, p(r, {
                    ph: A2(Wg, n.a, r.ph)
                }));
            case 10:
                return A2(eo, g, p(r, {
                    rs: n.a
                }));
            default:
                return A2(eo, C([
                    A3(oW, o = n.a, n.b, n.c)
                ]), p(r, {
                    ll: Ct,
                    re: Ct
                }));
        }
    }), fW = function(n) {
        return {
            $: 7,
            a: n
        };
    }, sW = {
        $: 9
    }, lW = function(n) {
        return {
            $: 8,
            a: n
        };
    }, dW = F2(function(n, r) {
        return A2(eh, g, C([
            n(r)
        ]));
    }), bW = F2(function(n, r) {
        return th({
            nW: n,
            hf: rh,
            ie: dW(r)
        });
    }), mW = F2(function(n, r) {
        var t;
        return sh({
            nW: n,
            hf: lh((t = r, A2(mu, zi, t))),
            ie: r
        });
    }), pW = ih({
        jW: C([
            A2(bW, "Edit", A2(mu, Dh("Edit"), lW)),
            A2(mW, "Organization", A2(Po, function(n) {
                return n.oz;
            }, function(n) {
                return n.nW;
            })),
            A2(bW, "Apps (checked is ACTIVATED payment)", function(n) {
                return A2(Se, g, C([
                    A2(ph, C([
                        nh("OrganizationOnboarding")
                    ]), C([
                        A2(ph, C([
                            nh("OrganizationOnboardingCheck")
                        ]), C([
                            i(n.iQ.e4, kt(!0)) ? ch("\u2705") : ch("\u274C")
                        ])),
                        ch(n.iQ.iQ)
                    ]))
                ]));
            })
        ]),
        kr: p(wh, {
            pC: function() {
                return C([
                    nh("TableTr")
                ]);
            },
            rj: C([
                nh("Table")
            ]),
            rv: C([
                nh("TableTd")
            ])
        }),
        rE: A2(Po, function(n) {
            return n.oz;
        }, function(n) {
            return n.mj;
        }),
        rF: function(n) {
            return {
                $: 10,
                a: n
            };
        }
    }), vW = function(n) {
        return A3(mt, F3(function(n, r, t) {
            return A2(bt, r, t);
        }), g, n);
    }, $W = {
        $: 1
    }, gW = function(n) {
        var r = n.ll;
        if (r.$) {
            var t = n.re;
            if (t.$) return ch("");
            var e = t.a;
            return A2(Se, C([
                Mh($W)
            ]), C([
                LC(e)
            ]));
        }
        var u = r.a;
        return A2(Se, C([
            Mh($W)
        ]), C([
            AC(u)
        ]));
    }, hW = {
        $: 2
    }, kW = {
        $: 3
    }, CW = function(n) {
        return {
            $: 11,
            a: n
        };
    }, jW = function(n) {
        return {
            $: 4,
            a: n
        };
    }, wW = C([
        "adnomalab",
        "m6pub",
        "nomalab",
        "via"
    ]), AW = {
        jM: Ct,
        bH: g,
        kO: !1,
        lu: g,
        mi: Ct,
        mD: !1,
        bh: !1,
        bi: !1,
        m$: "",
        ol: Ct,
        rB: "",
        r6: Ct
    }, LW = Zh(g), yW = Qu(LW), SW = function(n) {
        return A2(mu, yW, Tu(n));
    }, FW = function(n) {
        return A2(i(n.r6, Ct) ? Se : hj, A2(Su, n.lu, C([
            A2(SW, Mh, n.ol),
            A2(SW, nh, n.jM),
            A2(SW, wj, n.r6),
            Zh(C([
                d("CustomButtonActive", n.mD),
                d("CustomButtonDisabled", n.kO),
                d("CustomButtonPrimary", n.bh)
            ])),
            Zh(n.bH),
            nh("CustomButton"),
            nh("CustomButtonMini")
        ])), C([
            function() {
                var r = n.mi;
                if (r.$) return ch("");
                var t = r.a;
                return A2(Se, C([
                    nh("CustomButtonIcon")
                ]), C([
                    t
                ]));
            }(),
            n.bi ? A2(xg, C([
                nh("CustomButtonLabel"),
                qh("submit")
            ]), C([
                ch(n.m$)
            ])) : A2(_h, C([
                nh("CustomButtonLabel")
            ]), n.m$)
        ]));
    }, TW = F3(function(n, r, t) {
        return {
            $: 12,
            a: n,
            b: r,
            c: t
        };
    }), QW = F2(function(n, r) {
        return A2(OC, C([
            nh("OrganizationEditApp")
        ]), C([
            A2(rk, C([
                qh("checkbox"),
                XC(i(r.e4, kt(!0))),
                RC(A2(TW, n, r.iQ))
            ]), g),
            A2(ph, g, C([
                ch(r.iQ)
            ]))
        ]));
    }), IW = function(n) {
        return A2(qC, function(r) {
            return A4(oj, "Edit Organization", d("Close", hW), d("Close", hW), function() {
                var t = A2(Lp, function(r) {
                    return A2(tW, r, n.oD);
                }, r.oB);
                if (t.$) return C([
                    gW(n),
                    A2(_C, C([
                        $k(jW)
                    ]), A2(bt, A2(KC, C([
                        hk("")
                    ]), C([
                        ch("Choose organization...")
                    ])), A2(Ge, function(n) {
                        return A2(KC, C([
                            hk(n.mj)
                        ]), C([
                            ch(n.nW)
                        ]));
                    }, n.oD)))
                ]);
                var e = t.a, u = A2(Tu, function(n) {
                    return n.iQ;
                }, A2(Lo, e.mj, n.iR));
                return C([
                    A2(yj, g, C([
                        ch("Editing "),
                        ch(e.nW)
                    ])),
                    gW(n),
                    A2(Se, g, C([
                        A2(qC, QW(e.mj), u)
                    ])),
                    A2(JT, i(u, Ct), A2(Se, g, C([
                        A2(_C, C([
                            $k(CW),
                            A2(Qu, Zh(g), A2(Tu, hk, r.n$))
                        ]), A2(bt, A2(KC, C([
                            hk("")
                        ]), C([
                            ch("Add app...")
                        ])), A2(Ge, function(n) {
                            return A2(KC, C([
                                hk(n)
                            ]), C([
                                ch(n)
                            ]));
                        }, wW))),
                        FW(p(AW, {
                            mD: !i(r.n$, Ct),
                            m$: "Add New App",
                            ol: kt(kW)
                        }))
                    ])))
                ]);
            }());
        }, n.kL);
    }, BW = F2(function(n, r) {
        var t = zi(r.ph.sa), e = A2(Bu, A2(mu, Me(t), function(n) {
            return n.pW;
        }), vW(r.iR));
        return A3(Wj, "Organizations: onboarding", kt(A2(Dh, "New\u2026", sW)), A2(Se, g, C([
            A2(Sk, fW, kk(r.ph)),
            gW(r),
            IW(r),
            A3(jC, pW, r.rs, e)
        ])));
    }), WW = {
        l: function(n) {
            return n.dm;
        },
        m: ZB,
        p: F2(function(n, r) {
            return p(n, {
                dm: r
            });
        }),
        q: function(n) {
            return {
                $: 3,
                a: n
            };
        },
        r: cW,
        s: BW
    }, PW = function(n) {
        return {
            $: 1,
            a: n
        };
    }, MW = A2(Rs, PW, Al(A2(_s, J$, Vs(K$)))), qW = {
        iS: Xi(Be),
        kt: g,
        ku: Ct,
        nR: Xi(Be),
        oD: g,
        oE: Xi(Be),
        rs: k$("Name"),
        sy: Xi(Be)
    }, DW = A2(eo, C([
        MW
    ]), qW), XW = function(n) {
        return {
            $: 6,
            a: n
        };
    }, EW = function(n) {
        return {
            $: 0,
            a: n
        };
    }, RW = ul(A4(ll, "path", function(n) {
        return n.gu;
    }, Di, A4(ll, "show", function(n) {
        return n.g9;
    }, Di, A4(ll, "showName", function(n) {
        return n.hb;
    }, Di, A4(kb, "duration", function(n) {
        return n.e$;
    }, yy, A4(ll, "state", function(n) {
        return n.hw;
    }, Zm, A4(ll, "key", function(n) {
        return n.fR;
    }, Di, A4(ll, "bucket", function(n) {
        return n.ev;
    }, Di, A4(kb, "mimeType", function(n) {
        return n.nH;
    }, Di, A4(ll, "size", function(n) {
        return n.qy;
    }, yy, A4(ll, "createdAt", function(n) {
        return n.ke;
    }, bb, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, gl(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return {
                                                    ev: u,
                                                    ke: r,
                                                    e$: o,
                                                    fR: a,
                                                    nH: e,
                                                    nW: n,
                                                    gu: s,
                                                    g9: f,
                                                    hb: c,
                                                    qy: t,
                                                    hw: i
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))), xW = $l(RW), OW = function(n) {
        return A2(Rs, EW, function(n) {
            return Al(A2(_s, xW, Vs(xs(QI(A2(TI, n, 1))))));
        }(n));
    }, zW = F2(function(n, r) {
        switch(n.$){
            case 7:
                return A2(eo, g, p(r, {
                    rs: n.a
                }));
            case 2:
                return A2(eo, (t = n.a).$ ? g : C([
                    OW(t.a)
                ]), p(r, {
                    oE: A2(Wg, t, r.oE)
                }));
            case 3:
                var t = n.a;
                return A2(eo, C([
                    OW(r.oE.sa)
                ]), p(r, {
                    iS: A2(Wg, t, r.iS)
                }));
            case 4:
                return t = n.a, A2(eo, C([
                    OW(r.oE.sa)
                ]), p(r, {
                    nR: A2(Wg, t, r.nR)
                }));
            case 5:
                return t = n.a, A2(eo, C([
                    OW(r.oE.sa)
                ]), p(r, {
                    sy: A2(Wg, t, r.sy)
                }));
            case 1:
                return A2(eo, g, (e = n.a).$ ? r : p(r, {
                    oD: e.a
                }));
            case 6:
                return A2(eo, g, p(r, {
                    ku: kt(n.a)
                }));
            default:
                var e;
                if ((e = n.a).$) return A2(eo, g, p(r, {
                    kt: g
                }));
                var u = e.a;
                return A2(eo, C([
                    A2(b$, XW, d$)
                ]), p(r, {
                    kt: u
                }));
        }
    }), NW = F2(function(n, r) {
        return n ? r : LW;
    }), HW = Yg("title"), VW = function(n) {
        return A2(i(n.r6, Ct) ? Se : hj, A2(Su, n.lu, C([
            A2(NW, !n.kO, A2(SW, Mh, n.ol)),
            A2(SW, nh, n.jM),
            A2(NW, !n.kO, A2(SW, wj, n.r6)),
            HW(n.rB),
            nk(n.kO),
            Zh(C([
                d("CustomButtonActive", n.mD),
                d("CustomButtonDisabled", n.kO),
                d("CustomButtonPrimary", n.bh)
            ])),
            Zh(n.bH),
            nh("CustomButton")
        ])), C([
            function() {
                var r = n.mi;
                if (r.$) return ch("");
                var t = r.a;
                return A2(Se, C([
                    nh("CustomButtonIcon")
                ]), C([
                    t
                ]));
            }(),
            n.bi ? A2(xg, C([
                nh("CustomButtonLabel")
            ]), C([
                ch(n.m$)
            ])) : A2(_h, C([
                nh("CustomButtonLabel")
            ]), n.m$)
        ]));
    }, UW = A2(Qh, C([
        Ah("16px"),
        Bh("16px"),
        Ih("0 0 16 16"),
        Vg("IconOk")
    ]), C([
        A2(Th, C([
            Vg("Fg"),
            Lh("8 4 12 12 4 12")
        ]), g)
    ])), JW = F2(function(n, r) {
        return A2(Se, C([
            nh("BannerCTA")
        ]), C([
            A2(Se, C([
                nh("BannerCTAIcon")
            ]), C([
                UW
            ])),
            A2(_h, C([
                nh("BannerCTALabel")
            ]), n),
            VW(r)
        ]));
    }), ZW = Ng, KW = X$(OI({
        $: 0
    })), _W = A2(JW, "Download organizations files listing", p(AW, {
        lu: C([
            A2(ZW, "target", "_blank"),
            A2(ZW, "data-prevent-history", "true"),
            A2(ZW, "download", "organizations-files-listing.csv")
        ]),
        m$: "Generate CSV",
        r6: kt(Hs(KW))
    })), GW = F2(function() {
        return A3(Wj, "Organization File Listing", Ct, A2(Se, C([
            nh("AdminPadding")
        ]), C([
            _W
        ])));
    }), YW = {
        l: function(n) {
            return n.dn;
        },
        m: DW,
        p: F2(function(n, r) {
            return p(n, {
                dn: r
            });
        }),
        q: function(n) {
            return {
                $: 11,
                a: n
            };
        },
        r: zW,
        s: GW
    }, nP = {
        kL: Ct,
        ll: Ct,
        fc: g,
        c5: g,
        oD: g,
        ph: Xi(function(n) {
            return p(n, {
                gy: "Search Organization by Name, Test Plan or Format",
                sa: ""
            });
        }),
        dy: g,
        dF: g,
        re: Ct,
        rs: k$("Name"),
        dK: Lu
    }, rP = function(n) {
        return {
            $: 0,
            a: n
        };
    }, tP = Al(A2(_s, _y, Vs(Yy))), eP = Al(A2(_s, J$, Vs(K$))), uP = F5(function(n, r, t, e, u) {
        return {
            lG: n,
            m2: r,
            nC: e,
            nJ: t,
            pi: u
        };
    }), aP = F3(function(n, r, t) {
        return {
            cU: t,
            am: r,
            dR: n
        };
    }), iP = ul(A4(ll, "durationMax", function(n) {
        return n.cU;
    }, ml, A4(ll, "durationMin", function(n) {
        return n.am;
    }, ml, A4(ll, "totalBreaks", function(n) {
        return n.dR;
    }, ml, gl(aP))))), oP = ul(A4(ll, "ranges", function(n) {
        return n.pi;
    }, $l(iP), A4(kb, "maxInterval", function(n) {
        return n.nC;
    }, ml, A4(kb, "minInterval", function(n) {
        return n.nJ;
    }, ml, A4(kb, "lastPoint", function(n) {
        return n.m2;
    }, ml, A4(kb, "firstPoint", function(n) {
        return n.lG;
    }, ml, gl(uP))))))), cP = F3(function(n, r, t) {
        return {
            am: t,
            b8: r,
            rB: n
        };
    }), fP = ul(A4(kb, "durationMin", function(n) {
        return n.am;
    }, ml, A4(kb, "offset", function(n) {
        return n.b8;
    }, ml, A4(kb, "title", function(n) {
        return n.rB;
    }, Di, gl(cP))))), sP = function(n) {
        switch(n){
            case "anime":
                return yt(0);
            case "telenovela":
                return yt(1);
            case "other":
                return yt(2);
            default:
                return jt(A2(ki, "can't parse str to typology", L$));
        }
    }, lP = function(n) {
        switch(n){
            case 0:
                return "anime";
            case 1:
                return "telenovela";
            default:
                return "other";
        }
    }, dP = A2(zl, lP, sP), bP = ul(A4(ll, "skipM2CProxy", function(n) {
        return n.qA;
    }, Zi, A4(ll, "typology", function(n) {
        return n.rS;
    }, dP, A4(ll, "postCredits", function(n) {
        return n.oX;
    }, Zi, A4(kb, "minOutro", function(n) {
        return n.nM;
    }, ml, A4(kb, "minIntro", function(n) {
        return n.nK;
    }, ml, A4(ll, "skipIntro", function(n) {
        return n.qz;
    }, Zi, A4(ll, "endingCredits", function(n) {
        return n.bR;
    }, fP, A4(ll, "openingCredits", function(n) {
        return n.b9;
    }, fP, A4(ll, "adBreaks", function(n) {
        return n.aA;
    }, oP, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return {
                                                    aA: t,
                                                    bR: u,
                                                    mj: n,
                                                    nK: i,
                                                    nM: o,
                                                    nW: r,
                                                    b9: e,
                                                    oX: c,
                                                    qz: a,
                                                    qA: s,
                                                    rS: f
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))), mP = $l(bP), pP = function(n) {
        return {
            $: 4,
            a: n
        };
    }, vP = X$(pP({
        $: 0
    })), $P = Al(A2(_s, mP, Vs(vP))), gP = Al(A2(_s, dS, Vs(mS))), hP = A2(bp, il, A2(bp, Ge(function(n) {
        return d(n.mj, n);
    }), Al(A2(_s, gS, Vs(kS))))), kP = F6(function(n, r, t, e, u, a) {
        return A2(Ye, function(r) {
            return A2(Ye, function(t) {
                return A2(Ye, function(e) {
                    return A2(Ye, function(u) {
                        return A2(Ye, function(a) {
                            return Je(A5(n, r, t, e, u, a));
                        }, a);
                    }, u);
                }, e);
            }, t);
        }, r);
    }), CP = kP, jP = A2(Rs, rP, A6(CP, F5(function(n, r, t, e, u) {
        return {
            c5: t,
            oD: n,
            dy: u,
            dF: e,
            dK: r
        };
    }), eP, hP, tP, gP, $P)), wP = d(nP, jP), AP = F2(function(n, r) {
        return p(r, {
            ll: kt(n.nE),
            re: Ct
        });
    }), LP = F2(function(n, r) {
        var t = Ki(function(t) {
            return p(t, {
                m$: r ? "Select default extra format" : "Select default format",
                sa: n.mH
            });
        });
        return {
            mj: Xi(function(t) {
                return p(t, {
                    m$: r ? "Extra Format" : "Format",
                    sa: n.mj
                });
            }),
            mH: t
        };
    }), yP = C([
        "\\${originalFileName}",
        "\\${broadcasterId}",
        "\\${collectionName}",
        "\\${seasonName}",
        "\\${episodeName}",
        "\\${showTitle}",
        "\\${date}"
    ]), SP = function(n) {
        return {
            iv: Ki(function(r) {
                return p(r, 1 === n.$ ? {
                    m$: "Ad.nomalab destination",
                    sa: !1
                } : {
                    m$: "Ad.nomalab destination",
                    sa: n.a.iv
                });
            }),
            iI: Ki(function(r) {
                return p(r, 1 === n.$ ? {
                    m$: "Allow Delivery Without Transcoding",
                    sa: !1
                } : {
                    m$: "Toggle Allow Delivery Without Transcoding",
                    sa: n.a.iI
                });
            }),
            jq: Xi(function(r) {
                var t = A2(Lp, function(n) {
                    return n.jq;
                }, n);
                return p(r, 1 === t.$ ? {
                    m$: "Broadcaster",
                    sa: ""
                } : {
                    m$: "Broadcaster",
                    sa: z$(t.a)
                });
            }),
            kK: Xi(function(r) {
                if (1 === n.$) return p(r, {
                    m$: "Delivery destination",
                    gy: A3(qt, F2(function(n, r) {
                        return r + "_" + n;
                    }), "ex : ftp://test:test@localhost/upload/", A2(Ge, Xe(1), yP)),
                    sa: ""
                });
                var t = n.a;
                return p(r, {
                    m$: "Delivery destination",
                    gy: A3(qt, F2(function(n, r) {
                        return r + (n + "_");
                    }), "ex : ftp://test:test@localhost/upload/", A2(Ge, Xe(1), yP)),
                    sa: A2(Qu, "", t.kK)
                });
            }),
            kV: Xi(function(r) {
                if (1 === n.$) return p(r, {
                    m$: "Download File Name",
                    gy: A3(qt, F2(function(n, r) {
                        return r + "_" + n;
                    }), "", A2(Ge, Xe(1), yP)),
                    sa: ""
                });
                var t = n.a;
                return p(r, {
                    m$: "Download File Name",
                    gy: A3(qt, F2(function(n, r) {
                        return r + (n + "_");
                    }), "", A2(Ge, Xe(1), yP)),
                    sa: A2(Qu, "", t.kV)
                });
            }),
            k8: Ki(function(r) {
                return p(r, 1 === n.$ ? {
                    m$: "Toggle auto accept feature",
                    sa: !1
                } : {
                    m$: "Toggle auto accept feature",
                    sa: n.a.k8
                });
            }),
            k9: Ki(function(r) {
                return p(r, 1 === n.$ ? {
                    m$: "Toggle auto delete shows",
                    sa: !1
                } : {
                    m$: "Toggle auto delete shows",
                    sa: n.a.cA
                });
            }),
            la: Ki(function(r) {
                return p(r, 1 === n.$ ? {
                    m$: "Toggle auto reject feature",
                    sa: !1
                } : {
                    m$: "Toggle auto reject feature",
                    sa: n.a.la
                });
            }),
            lb: Ki(function(r) {
                return p(r, 1 === n.$ ? {
                    m$: "Toggle creation mail",
                    sa: !1
                } : {
                    m$: "Toggle creation mail",
                    sa: n.a.lb
                });
            }),
            lc: Ki(function(r) {
                return p(r, 1 === n.$ ? {
                    m$: "Toggle static ip for delivery",
                    sa: !1
                } : {
                    m$: "Toggle static ip for delivery",
                    sa: n.a.dE
                });
            }),
            ld: Ki(function(r) {
                return p(r, 1 === n.$ ? {
                    m$: "Toggle upload success mail",
                    sa: !1
                } : {
                    m$: "Toggle upload success mail",
                    sa: n.a.ld
                });
            }),
            le: Ki(function(r) {
                return p(r, 1 === n.$ ? {
                    m$: "Toggle video ready mail",
                    sa: !0
                } : {
                    m$: "Toggle video ready mail",
                    sa: n.a.le
                });
            }),
            fc: function() {
                if (n.$) return Lu;
                var r = n.a;
                return A2(cl, F2(function(n, r) {
                    return A2(LP, r, !0);
                }), il(A2(Ot, ng, r.fc)));
            }(),
            c5: function() {
                if (n.$) return Lu;
                var r = n.a;
                return A2(cl, F2(function(n, r) {
                    return A2(LP, r, !1);
                }), il(A2(Ot, ng, r.c5)));
            }(),
            mF: Ki(function(r) {
                return p(r, 1 === n.$ ? {
                    m$: "Advertiser",
                    sa: !1
                } : {
                    m$: "Advertiser",
                    sa: n.a.mF
                });
            }),
            nh: Xi(function(r) {
                var t = A2(Lp, function(n) {
                    return n.nh;
                }, n);
                return p(r, t.$ ? {
                    m$: "Logo",
                    sa: ""
                } : {
                    m$: "Logo",
                    sa: t.a
                });
            }),
            nA: Ki(function(r) {
                return p(r, 1 === n.$ ? {
                    m$: "Toggle manual delivery",
                    sa: !1
                } : {
                    m$: "Toggle manual delivery",
                    sa: n.a.nA
                });
            }),
            nW: Xi(function(r) {
                return p(r, {
                    m$: "Name",
                    sa: A2(Qu, "", A2(Tu, function(n) {
                        return n.nW;
                    }, n))
                });
            }),
            oF: n,
            pa: Xi(function(r) {
                return p(r, {
                    m$: "QC master report template",
                    sa: A2(Qu, "", A2(Tu, function(n) {
                        return n.pa;
                    }, n))
                });
            }),
            pb: Xi(function(r) {
                return p(r, {
                    m$: "QC master test plan",
                    sa: A2(Qu, "", A2(Tu, function(n) {
                        return n.pb;
                    }, n))
                });
            }),
            pp: Ki(function(r) {
                return p(r, 1 === n.$ ? {
                    m$: "Toggle files replication",
                    sa: !1
                } : {
                    m$: "Toggle files replication",
                    sa: n.a.pp
                });
            }),
            dy: function() {
                if (n.$) return Lu;
                var r = n.a;
                return A2(cl, F2(function(n, r) {
                    return Xi(function(n) {
                        return p(n, {
                            m$: "Segmentation rule",
                            sa: r
                        });
                    });
                }), il(A2(Ot, ng, r.dy)));
            }(),
            dF: function() {
                if (n.$) return Lu;
                var r = n.a;
                return A2(cl, F2(function(n, r) {
                    return Xi(function(n) {
                        return p(n, {
                            m$: "Subtitle Format",
                            sa: r
                        });
                    });
                }), il(A2(Ot, ng, r.dF)));
            }()
        };
    }, FP = function(n) {
        return {
            $: 36,
            a: n
        };
    }, TP = F3(function(n, r, t) {
        if (1 === r.$) return jt(r.a);
        var e = r.a;
        return 1 === t.$ ? jt(t.a) : yt(A2(n, e, t.a));
    }), QP = function(n) {
        return A2(Ii, g, A3(_e, F2(function(n, r) {
            var t = d(n, r);
            return t.b.$ ? jt(t.b.a) : t.a.$ ? jt(t.a.a) : yt(A2(bt, t.a.a, t.b.a));
        }), yt(g), A2(Ge, function(n) {
            var r = n.b;
            return A3(TP, H$, yt(r.mj.sa), yt(r.mH.sa));
        }, pt(n))));
    }, IP = ul(A4(ll, "autoDeleteShows", function(n) {
        return n.cA;
    }, Zi, A4(ll, "staticIp", function(n) {
        return n.dE;
    }, Zi, A4(kb, "metadataSchema", function(n) {
        return n.f6;
    }, Di, A4(ll, "adNomalabDest", function(n) {
        return n.iv;
    }, Zi, A4(ll, "noProxy", function(n) {
        return n.gj;
    }, Zi, A4(ll, "noQC", function(n) {
        return n.gk;
    }, Zi, A4(ll, "isAdvertiser", function(n) {
        return n.mF;
    }, Zi, A4(ll, "segmentationRules", function(n) {
        return n.dy;
    }, $l(Di), A4(ll, "extraFormats", function(n) {
        return n.fc;
    }, $l(V$), A4(ll, "subtitleFormats", function(n) {
        return n.dF;
    }, $l(Di), A4(ll, "formats", function(n) {
        return n.c5;
    }, $l(V$), A4(kb, "logo", function(n) {
        return n.nh;
    }, Di, A4(ll, "replication", function(n) {
        return n.pp;
    }, Zi, A4(ll, "allowDeliveryWithoutTranscoding", function(n) {
        return n.iI;
    }, Zi, A4(ll, "manualDelivery", function(n) {
        return n.nA;
    }, Zi, A4(kb, "broadcaster", function(n) {
        return n.jq;
    }, N$, A4(ll, "enableAutoReject", function(n) {
        return n.la;
    }, Zi, A4(ll, "enableAutoAccept", function(n) {
        return n.k8;
    }, Zi, A4(ll, "enableUploadSuccessEmail", function(n) {
        return n.ld;
    }, Zi, A4(ll, "enableVideoReadyEmail", function(n) {
        return n.le;
    }, Zi, A4(ll, "enableCreationEmail", function(n) {
        return n.lb;
    }, Zi, A4(kb, "downloadFileName", function(n) {
        return n.kV;
    }, Di, A4(kb, "destination", function(n) {
        return n.kK;
    }, Di, A4(ll, "qcMasterReportTemplate", function(n) {
        return n.pa;
    }, Di, A4(ll, "qcMasterTestPlan", function(n) {
        return n.pb;
    }, Di, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, gl(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(m) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return function($) {
                                                                            return function(g) {
                                                                                return function(h) {
                                                                                    return function(k) {
                                                                                        return function(C) {
                                                                                            return function(j) {
                                                                                                return function(w) {
                                                                                                    return function(A) {
                                                                                                        return function(L) {
                                                                                                            return {
                                                                                                                iv: j,
                                                                                                                iI: d,
                                                                                                                cA: L,
                                                                                                                jq: s,
                                                                                                                kK: e,
                                                                                                                kV: u,
                                                                                                                k8: c,
                                                                                                                la: f,
                                                                                                                lb: a,
                                                                                                                ld: o,
                                                                                                                le: i,
                                                                                                                fc: $,
                                                                                                                c5: p,
                                                                                                                mF: h,
                                                                                                                nh: m,
                                                                                                                nA: l,
                                                                                                                f6: w,
                                                                                                                nW: n,
                                                                                                                gj: C,
                                                                                                                gk: k,
                                                                                                                pa: t,
                                                                                                                pb: r,
                                                                                                                pp: b,
                                                                                                                dy: g,
                                                                                                                dE: A,
                                                                                                                dF: v
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))))))))))))))))), BP = F2(function(n, r) {
        return Re(r) ? yt(Ct) : A2(dg, kt, n(r));
    }), WP = ul(A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(function(n) {
        return {
            mj: n
        };
    }))), PP = function(n) {
        var r;
        return A2(Rs, FP, A2(Zw, function(n) {
            return Al(A2(vg, WP, A3(kg, IP, {
                iv: r.iv.sa,
                iI: r.iI.sa,
                cA: r.k9.sa,
                jq: n,
                kK: Re(r.kK.sa) ? Ct : kt(r.kK.sa),
                kV: Re(r.kV.sa) ? Ct : kt(r.kV.sa),
                k8: r.k8.sa,
                la: r.la.sa,
                lb: r.lb.sa,
                ld: r.ld.sa,
                le: r.le.sa,
                fc: QP(r.fc),
                c5: QP(r.c5),
                mF: r.mF.sa,
                nh: Re(r.nh.sa) ? Ct : kt(r.nh.sa),
                nA: r.nA.sa,
                f6: Ct,
                nW: r.nW.sa,
                gj: !1,
                gk: !1,
                pa: r.pa.sa,
                pb: r.pb.sa,
                pp: r.pp.sa,
                dy: A2(Ge, function(n) {
                    return n.b.sa;
                }, pt(r.dy)),
                dE: r.lc.sa,
                dF: A2(Ge, function(n) {
                    return n.b.sa;
                }, pt(r.dF))
            }, $g(K$))));
        }, A2(nl, JS, KS(A2(BP, O$, (r = n).jq.sa)))));
    }, MP = function(n) {
        return {
            $: 39,
            a: n
        };
    }, qP = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), DP = function(n) {
        return X$(Z$(A2(qP, n, 1)));
    }, XP = function(n) {
        return {
            $: 37,
            a: n
        };
    }, EP = F2(function(n, r) {
        return A2(Zw, function(t) {
            return Al(Lg(A3(kg, IP, {
                iv: r.iv.sa,
                iI: r.iI.sa,
                cA: r.k9.sa,
                jq: t,
                kK: Re(r.kK.sa) ? Ct : kt(r.kK.sa),
                kV: Re(r.kV.sa) ? Ct : kt(r.kV.sa),
                k8: r.k8.sa,
                la: r.la.sa,
                lb: r.lb.sa,
                ld: r.ld.sa,
                le: r.le.sa,
                fc: QP(r.fc),
                c5: QP(r.c5),
                mF: r.mF.sa,
                nh: Re(r.nh.sa) ? Ct : kt(r.nh.sa),
                nA: r.nA.sa,
                f6: Ct,
                nW: r.nW.sa,
                gj: !1,
                gk: !1,
                pa: r.pa.sa,
                pb: r.pb.sa,
                pp: r.pp.sa,
                dy: A2(Ge, function(n) {
                    return n.b.sa;
                }, pt(r.dy)),
                dE: r.lc.sa,
                dF: A2(Ge, function(n) {
                    return n.b.sa;
                }, pt(r.dF))
            }, Sg(DP(n.mj)))));
        }, A2(nl, JS, KS(A2(BP, O$, r.jq.sa))));
    }), RP = F2(function(n, r) {
        return A2(Rs, XP, A2(EP, n, r));
    }), xP = F2(function(n, r) {
        return p(r, n.$ ? {
            mH: A2(Ig, n.a, r.mH)
        } : {
            mj: A2(Wg, n.a, r.mj)
        });
    }), OP = F2(function(n, r) {
        switch(n.$){
            case 2:
                return A2(eo, g, p(r, {
                    kL: kt(SP(kt(n.a)))
                }));
            case 1:
                return A2(eo, g, p(r, {
                    kL: kt(SP(Ct))
                }));
            case 3:
                return A2(eo, g, p(r, {
                    kL: Ct,
                    ll: Ct,
                    re: Ct
                }));
            case 5:
                var t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        nW: A2(Wg, t, n.nW)
                    });
                }, r.kL);
                return A2(eo, g, p(r, {
                    kL: e
                }));
            case 6:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        pb: A2(Wg, t, n.pb)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 9:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        pa: A2(Wg, t, n.pa)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 7:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        kK: A2(Wg, t, n.kK)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 8:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        kV: A2(Wg, t, n.kV)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 40:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        nh: A2(Wg, t, n.nh)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 10:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        lb: A2(Ig, t, n.lb)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 11:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        le: A2(Ig, t, n.le)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 12:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        ld: A2(Ig, t, n.ld)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 13:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        k8: A2(Ig, t, n.k8)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 14:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        la: A2(Ig, t, n.la)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 15:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        jq: A2(Wg, t, n.jq)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 16:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        nA: A2(Ig, t, n.nA)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 17:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        iI: A2(Ig, t, n.iI)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 18:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        pp: A2(Ig, t, n.pp)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 19:
                t = n.a;
                var u = n.b;
                return e = A2(Tu, function(n) {
                    return p(n, {
                        c5: A2(cl, F2(function(n, r) {
                            return i(n, u) ? A2(xP, t, r) : r;
                        }), n.c5)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 31:
                return u = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        c5: A2(ag, F2(function(n) {
                            return !i(n, u);
                        }), n.c5)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 27:
                var a = A2(LP, {
                    mj: "",
                    mH: !1
                }, !1), o = A2(Qu, 0, A2(Tu, function(n) {
                    return A2(Qu, 0, ig(vt(n.c5)));
                }, r.kL));
                return e = A2(Tu, function(n) {
                    return p(n, {
                        c5: A3(ju, o + 1, a, n.c5)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 20:
                return t = n.a, u = n.b, e = A2(Tu, function(n) {
                    return p(n, {
                        dF: A2(cl, F2(function(n, r) {
                            return i(n, u) ? A2(Wg, t, r) : r;
                        }), n.dF)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 32:
                return u = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        dF: A2(ag, F2(function(n) {
                            return !i(n, u);
                        }), n.dF)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 28:
                return a = Xi(function(n) {
                    return p(n, {
                        m$: "Subtitle Format",
                        sa: ""
                    });
                }), o = A2(Qu, 0, A2(Tu, function(n) {
                    return A2(Qu, 0, ig(vt(n.dF)));
                }, r.kL)), e = A2(Tu, function(n) {
                    return p(n, {
                        dF: A3(ju, o + 1, a, n.dF)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 21:
                return t = n.a, u = n.b, e = A2(Tu, function(n) {
                    return p(n, {
                        fc: A2(cl, F2(function(n, r) {
                            return i(n, u) ? A2(xP, t, r) : r;
                        }), n.fc)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 33:
                return u = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        fc: A2(ag, F2(function(n) {
                            return !i(n, u);
                        }), n.fc)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 29:
                return a = A2(LP, {
                    mj: "",
                    mH: !1
                }, !0), o = A2(Qu, 0, A2(Tu, function(n) {
                    return A2(Qu, 0, ig(vt(n.fc)));
                }, r.kL)), e = A2(Tu, function(n) {
                    return p(n, {
                        fc: A3(ju, o + 1, a, n.fc)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 22:
                return t = n.a, u = n.b, e = A2(Tu, function(n) {
                    return p(n, {
                        dy: A2(cl, F2(function(n, r) {
                            return i(n, u) ? A2(Wg, t, r) : r;
                        }), n.dy)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 34:
                return u = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        dy: A2(ag, F2(function(n) {
                            return !i(n, u);
                        }), n.dy)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 30:
                return a = Xi(function(n) {
                    return p(n, {
                        m$: "Segmentation Rule",
                        sa: ""
                    });
                }), o = A2(Qu, 0, A2(Tu, function(n) {
                    return A2(Qu, 0, ig(vt(n.dy)));
                }, r.kL)), e = A2(Tu, function(n) {
                    return p(n, {
                        dy: A3(ju, o + 1, a, n.dy)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 23:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        mF: A2(Ig, t, n.mF)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 24:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        iv: A2(Ig, t, n.iv)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 25:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        lc: A2(Ig, t, n.lc)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 26:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        k9: A2(Ig, t, n.k9)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 35:
                var c = r.kL;
                return A2(eo, C(1 === c.$ ? [
                    p$
                ] : 1 === (d = (e = c.a).oF).$ ? [
                    PP(e)
                ] : [
                    A2(RP, d.a, e)
                ]), r);
            case 38:
                return A2(eo, C([
                    (l = n.a, A2(Rs, MP, function(n) {
                        return Al(Lg(Ag(DP(n.mj))));
                    }(l)))
                ]), r);
            case 36:
                return (f = n.a).$ ? A2(eo, g, A2(AP, f.a, r)) : A2(eo, C([
                    jP
                ]), p(r, {
                    ll: Ct,
                    re: kt("Organization created")
                }));
            case 37:
                return (f = n.a).$ ? A2(eo, g, A2(AP, f.a, r)) : A2(eo, C([
                    jP
                ]), p(r, {
                    ll: Ct,
                    re: kt("Organization updated")
                }));
            case 4:
                return A2(eo, g, p(r, {
                    ll: Ct
                }));
            case 39:
                return (f = n.a).$ ? A2(eo, g, A2(AP, f.a, r)) : A2(eo, C([
                    jP
                ]), r);
            case 0:
                var f;
                if ((f = n.a).$) return A2(eo, g, A2(AP, f.a, r));
                var s = f.a;
                return A2(eo, g, p(r, {
                    c5: s.c5,
                    oD: s.oD,
                    dy: s.dy,
                    dF: s.dF,
                    dK: s.dK
                }));
            case 42:
                return A2(eo, g, p(r, {
                    ph: A2(Wg, t = n.a, r.ph)
                }));
            default:
                return A2(eo, g, p(r, {
                    rs: n.a
                }));
        }
        var l, d;
    }), zP = {
        $: 1
    }, NP = function(n) {
        return {
            $: 42,
            a: n
        };
    }, HP = function(n) {
        return {
            $: 2,
            a: n
        };
    }, VP = function(n) {
        return {
            $: 41,
            a: n
        };
    }, UP = function(n) {
        return {
            $: 38,
            a: n
        };
    }, JP = F2(function(n, r) {
        return A2(eh, g, C([
            n(r)
        ]));
    }), ZP = F2(function(n, r) {
        return th({
            nW: n,
            hf: rh,
            ie: JP(r)
        });
    }), KP = F2(function(n, r) {
        var t;
        return sh({
            nW: n,
            hf: lh((t = r, A2(mu, zi, t))),
            ie: r
        });
    }), _P = F2(function(n, r) {
        return A2(Ge, function(r) {
            var t = A2(Bu, function(n) {
                return i(n.mj, r.mj);
            }, n);
            return t.b ? t.a.nW : "";
        }, r.fc);
    }), GP = F2(function(n, r) {
        return A2(Ge, function(r) {
            var t = A2(Bu, function(n) {
                return i(n.mj, r.mj);
            }, n);
            return t.b ? t.a.nW : "";
        }, r.c5);
    }), YP = F2(function(n, r) {
        return A2(Qu, "", A2(Tu, function(n) {
            return n.nW;
        }, A2(Lo, r.pb, n)));
    }), nM = F2(function(n, r) {
        return A2(Ge, function(r) {
            var t = A2(Bu, function(n) {
                return i(n.mj, r);
            }, n);
            return t.b ? t.a.nW : "";
        }, r.dy);
    }), rM = F2(function(n, r) {
        return A2(Ge, function(r) {
            var t = A2(Bu, function(n) {
                return i(n.mj, r);
            }, n);
            return t.b ? t.a.nW : "";
        }, r.dF);
    }), tM = C([
        nh("Table")
    ]), eM = function() {
        return C([
            nh("TableTr")
        ]);
    }, uM = F4(function(n, r, t, e) {
        return ih({
            jW: C([
                A2(ZP, "Edit", A2(mu, Dh("Edit"), HP)),
                A2(KP, "Name", function(n) {
                    return n.nW;
                }),
                A2(KP, "Master Test plan", YP(n)),
                A2(KP, "Master Report template", function(n) {
                    return n.pa;
                }),
                A2(KP, "Destination", A2(mu, Qu(""), function(n) {
                    return n.kK;
                })),
                A2(ZP, "Manual Delivery", function(n) {
                    return n.nA ? Xh : Ph;
                }),
                A2(ZP, "Allow Delivery Without Transcoding", function(n) {
                    return n.iI ? Xh : Ph;
                }),
                A2(ZP, "Replication", function(n) {
                    return n.pp ? Xh : Ph;
                }),
                A2(ZP, "Toggle creation mail", function(n) {
                    return n.lb ? Xh : Ph;
                }),
                A2(ZP, "Toggle video ready mail", function(n) {
                    return n.le ? Xh : Ph;
                }),
                A2(ZP, "Toggle upload success mail", function(n) {
                    return n.ld ? Xh : Ph;
                }),
                A2(ZP, "Toggle auto accept feature", function(n) {
                    return n.k8 ? Xh : Ph;
                }),
                A2(ZP, "Toggle auto reject feature", function(n) {
                    return n.la ? Xh : Ph;
                }),
                A2(KP, "Broadcaster workflow", function(n) {
                    return A2(Qu, "", A2(Tu, z$, n.jq));
                }),
                A2(KP, "Formats", A2(Po, GP(r), Wt(", "))),
                A2(KP, "SubtitleFormats", A2(Po, rM(t), Wt(", "))),
                A2(KP, "SegmentationRules", A2(Po, nM(e), Wt(", "))),
                A2(KP, "ExtraFormats", A2(Po, _P(r), Wt(", "))),
                A2(ZP, "Advertiser", function(n) {
                    return n.mF ? Xh : Ph;
                }),
                A2(ZP, "Ad.Nomalab destination", function(n) {
                    return n.iv ? Xh : Ph;
                }),
                A2(ZP, "Delete", A2(mu, Kg(Wh), UP)),
                A2(ZP, "Toggle static ip for delivery", function(n) {
                    return n.dE ? Xh : Ph;
                }),
                A2(ZP, "Toggle auto delete shows", function(n) {
                    return n.cA ? Xh : Ph;
                })
            ]),
            kr: p(wh, {
                pC: eM,
                rj: tM,
                rv: C([
                    nh("TableTd")
                ])
            }),
            rE: function(n) {
                return n.mj;
            },
            rF: VP
        });
    }), aM = {
        $: 4
    }, iM = function(n) {
        var r = n.ll;
        if (r.$) return A2(Se, g, g);
        var t = r.a;
        return A2(Se, C([
            Mh(aM)
        ]), C([
            AC(t)
        ]));
    }, oM = {
        $: 3
    }, cM = function(n) {
        return {
            $: 17,
            a: n
        };
    }, fM = function(n) {
        return {
            $: 15,
            a: n
        };
    }, sM = function(n) {
        return {
            $: 7,
            a: n
        };
    }, lM = function(n) {
        return {
            $: 8,
            a: n
        };
    }, dM = function(n) {
        return {
            $: 24,
            a: n
        };
    }, bM = function(n) {
        return {
            $: 23,
            a: n
        };
    }, mM = function(n) {
        return {
            $: 40,
            a: n
        };
    }, pM = function(n) {
        return {
            $: 16,
            a: n
        };
    }, vM = function(n) {
        return {
            $: 5,
            a: n
        };
    }, $M = function(n) {
        return {
            $: 9,
            a: n
        };
    }, gM = function(n) {
        return {
            $: 6,
            a: n
        };
    }, hM = function(n) {
        return {
            $: 18,
            a: n
        };
    }, kM = function(n) {
        return {
            $: 13,
            a: n
        };
    }, CM = function(n) {
        return {
            $: 26,
            a: n
        };
    }, jM = function(n) {
        return {
            $: 14,
            a: n
        };
    }, wM = function(n) {
        return {
            $: 10,
            a: n
        };
    }, AM = function(n) {
        return {
            $: 25,
            a: n
        };
    }, LM = function(n) {
        return {
            $: 12,
            a: n
        };
    }, yM = function(n) {
        return {
            $: 11,
            a: n
        };
    }, SM = {
        $: 29
    }, FM = {
        $: 27
    }, TM = {
        $: 30
    }, QM = {
        $: 28
    }, IM = {
        $: 35
    }, BM = F2(function(n, r) {
        return {
            $: 21,
            a: n,
            b: r
        };
    }), WM = function(n) {
        return {
            $: 1,
            a: n
        };
    }, PM = function(n) {
        return {
            $: 0,
            a: n
        };
    }, MM = F2(function(n, r) {
        return A2(Se, g, C([
            A2(Sk, PM, A2(rj, n.mj, r)),
            A2(Sk, WM, HC(n.mH))
        ]));
    }), qM = F2(function(n, r) {
        var t = A2(bt, d("", ""), A2(Ge, function(n) {
            return d(n.mj, n.nW);
        }, A2(xi, A2(Po, function(n) {
            return n.nW;
        }, zi), r)));
        return A2(Ge, tl, pt(A2(cl, F2(function(n, r) {
            var e;
            return A2(Se, C([
                A2(gh, "position", "relative"),
                A2(gh, "margin", "25px 0")
            ]), C([
                A2(Sk, function(r) {
                    return A2(BM, r, n);
                }, A2(MM, r, t)),
                A3(lj, "remove", C([
                    d("position", "absolute"),
                    d("right", "0")
                ]), (e = n, {
                    $: 33,
                    a: e
                }))
            ]));
        }), n.fc)));
    }), DM = F2(function(n, r) {
        return {
            $: 19,
            a: n,
            b: r
        };
    }), XM = F2(function(n, r) {
        var t = A2(bt, d("", ""), A2(Ge, function(n) {
            return d(n.mj, n.nW);
        }, A2(xi, A2(Po, function(n) {
            return n.nW;
        }, zi), r)));
        return A2(Ge, tl, pt(A2(cl, F2(function(n, r) {
            var e;
            return A2(Se, C([
                A2(gh, "position", "relative"),
                A2(gh, "margin", "25px 0")
            ]), C([
                A2(Sk, function(r) {
                    return A2(DM, r, n);
                }, A2(MM, r, t)),
                A3(lj, "remove", C([
                    d("position", "absolute"),
                    d("right", "0")
                ]), (e = n, {
                    $: 31,
                    a: e
                }))
            ]));
        }), n.c5)));
    }), EM = F2(function(n, r) {
        return {
            $: 22,
            a: n,
            b: r
        };
    }), RM = F2(function(n, r) {
        var t = A2(bt, d("", ""), A2(Ge, function(n) {
            return d(n.mj, n.nW);
        }, A2(xi, A2(Po, function(n) {
            return n.nW;
        }, zi), r)));
        return A2(Ge, tl, pt(A2(cl, F2(function(n, r) {
            var e;
            return A2(Se, C([
                A2(gh, "position", "relative"),
                A2(gh, "margin", "25px 0")
            ]), C([
                A2(Sk, function(r) {
                    return A2(EM, r, n);
                }, A2(rj, r, t)),
                A3(lj, "remove", C([
                    d("position", "absolute"),
                    d("right", "0")
                ]), (e = n, {
                    $: 34,
                    a: e
                }))
            ]));
        }), n.dy)));
    }), xM = F2(function(n, r) {
        return {
            $: 20,
            a: n,
            b: r
        };
    }), OM = F2(function(n, r) {
        var t = A2(bt, d("", ""), A2(Ge, function(n) {
            return d(n.mj, n.nW);
        }, A2(xi, A2(Po, function(n) {
            return n.nW;
        }, zi), r)));
        return A2(Ge, tl, pt(A2(cl, F2(function(n, r) {
            var e;
            return A2(Se, C([
                A2(gh, "position", "relative"),
                A2(gh, "margin", "25px 0")
            ]), C([
                A2(Sk, function(r) {
                    return A2(xM, r, n);
                }, A2(rj, r, t)),
                A3(lj, "remove", C([
                    d("position", "absolute"),
                    d("right", "0")
                ]), (e = n, {
                    $: 32,
                    a: e
                }))
            ]));
        }), n.dF)));
    }), zM = function(n) {
        return A2(qC, function(r) {
            var t = A2(Ge, function(n) {
                return d(n.a, n.b.nW);
            }, A2(xi, A2(Po, tl, A2(Po, function(n) {
                return n.nW;
            }, zi)), pt(n.dK))), e = C([
                d("", ""),
                d(z$(0), z$(0)),
                d(z$(1), z$(1)),
                d(z$(3), z$(3)),
                d(z$(4), z$(4)),
                d(z$(5), z$(5)),
                d(z$(2), z$(2)),
                d(z$(6), z$(6)),
                d(z$(7), z$(7)),
                d(z$(8), z$(8)),
                d(z$(9), z$(9)),
                d(z$(10), z$(10)),
                d(z$(11), z$(11)),
                d(z$(12), z$(12)),
                d(z$(13), z$(13)),
                d(z$(14), z$(14)),
                d(z$(15), z$(15)),
                d(z$(16), z$(16)),
                d(z$(17), z$(17)),
                d(z$(18), z$(18)),
                d(z$(19), z$(19)),
                d(z$(20), z$(20))
            ]), u = function(n) {
                return 1 !== n.oF.$;
            }(r) ? d("Save", "Edit Organization") : d("Create", "New Organization");
            return A4(oj, u.b, d(u.a, IM), d("Cancel", oM), $(C([
                iM(n),
                A2(Sk, vM, VC(r.nW)),
                A2(Sk, gM, A2(rj, r.pb, t)),
                A2(Sk, $M, VC(r.pa)),
                A2(Sk, sM, VC(r.kK)),
                A2(Sk, lM, VC(r.kV)),
                A2(Sk, pM, HC(r.nA)),
                A2(Sk, cM, HC(r.iI)),
                A2(Sk, wM, HC(r.lb)),
                A2(Sk, yM, HC(r.le)),
                A2(Sk, LM, HC(r.ld)),
                A2(Sk, kM, HC(r.k8)),
                A2(Sk, jM, HC(r.la)),
                A2(Sk, AM, HC(r.lc)),
                A2(Sk, CM, HC(r.k9)),
                A2(Sk, fM, A2(rj, r.jq, e)),
                A2(Sk, mM, VC(r.nh)),
                A2(UT, g, g),
                A2(UT, g, g),
                A2(HT, g, C([
                    ch("Advertisement")
                ])),
                A2(Sk, bM, HC(r.mF)),
                A2(Sk, dM, HC(r.iv)),
                A2(xT, g, g),
                A2(xT, g, g),
                A2(HT, g, C([
                    ch("Replication")
                ])),
                A2(Sk, hM, HC(r.pp)),
                A2(xT, g, g),
                A2(xT, g, g)
            ]), $(A2(XM, r, n.c5), $(C([
                A2(Dh, "Add New Format", FM),
                A2(xT, g, g),
                A2(xT, g, g)
            ]), $(A2(OM, r, n.dF), $(C([
                A2(Dh, "Add New Subtitle Format", QM),
                A2(xT, g, g),
                A2(xT, g, g)
            ]), $(A2(qM, r, n.c5), $(C([
                A2(Dh, "Add New Extra Format", SM),
                A2(xT, g, g),
                A2(xT, g, g)
            ]), $(A2(RM, r, n.dy), C([
                A2(Dh, "Add New Segmentation rule", TM)
            ]))))))))));
        }, n.kL);
    }, NM = F2(function(n, r) {
        var t, e, u, a = zi(r.ph.sa), i = A2(Bu, (t = d(r.dK, r.c5), e = t.a, u = t.b, function(n) {
            return A2(mu, A2(mu, Me(a), zi), function(n) {
                return n.nW;
            })(n) || A2(Me, a, zi(A2(YP, e, n))) || A2(Me, a, zi(A2(Wt, ", ", A2(GP, u, n))));
        }), r.oD);
        return A3(Wj, "Organizations", kt(A2(Dh, "New\u2026", zP)), A2(Se, g, C([
            iM(r),
            A2(Sk, NP, kk(r.ph)),
            zM(r),
            A3(jC, A4(uM, r.dK, r.c5, r.dF, r.dy), r.rs, i)
        ])));
    }), HM = {
        l: function(n) {
            return n.oD;
        },
        m: wP,
        p: F2(function(n, r) {
            return p(n, {
                oD: r
            });
        }),
        q: function(n) {
            return {
                $: 2,
                a: n
            };
        },
        r: OP,
        s: NM
    }, VM = function(n) {
        return {
            $: 1,
            a: n
        };
    }, UM = A2(Rs, VM, Al(A2(_s, J$, Vs(K$)))), JM = {
        kt: g,
        oD: g,
        oE: Xi(Be),
        rs: k$("Completed At")
    }, ZM = A2(eo, C([
        UM
    ]), JM), KM = function(n) {
        return {
            $: 0,
            a: n
        };
    }, _M = F4(function(n, r, t, e) {
        return {
            lA: t,
            bn: r,
            gU: e,
            g9: n
        };
    }), GM = F4(function(n, r, t, e) {
        return {
            e6: e,
            fB: n,
            nW: r,
            ht: t
        };
    }), YM = ul(A4(ll, "end_millis", function(n) {
        return n.e6;
    }, ml, A4(ll, "start_millis", function(n) {
        return n.ht;
    }, ml, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "index", function(n) {
        return n.fB;
    }, ml, gl(GM)))))), nq = F2(function(n, r) {
        return {
            mj: n,
            nW: r
        };
    }), rq = ul(A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(nq)))), tq = F7(function(n, r, t, e, u, a, i) {
        return {
            jH: u,
            j_: e,
            ke: t,
            ll: r,
            mj: n,
            f_: a,
            rx: i
        };
    }), eq = F2(function(n, r) {
        return {
            nW: n,
            aT: r
        };
    }), uq = F2(function(n, r) {
        return {
            nB: r,
            nI: n
        };
    }), aq = ul(A4(ll, "max", function(n) {
        return n.nB;
    }, ml, A4(ll, "min", function(n) {
        return n.nI;
    }, ml, gl(uq)))), iq = ul(A4(ll, "duration", function(n) {
        return n.e$;
    }, aq, gl(function(n) {
        return {
            e$: n
        };
    }))), oq = ul(A4(ll, "parameters", function(n) {
        return n.aT;
    }, iq, A4(ll, "name", function(n) {
        return n.nW;
    }, mL, gl(eq)))), cq = ul(A4(ll, "templateName", function(n) {
        return n.rx;
    }, Di, A4(ll, "log", function(n) {
        return n.f_;
    }, Di, A4(ll, "checks", function(n) {
        return n.jH;
    }, $l(oq), A4(kb, "completedAt", function(n) {
        return n.j_;
    }, bb, A4(ll, "createdAt", function(n) {
        return n.ke;
    }, bb, A4(kb, "error", function(n) {
        return n.ll;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(tq))))))))), fq = F2(function(n, r) {
        return {
            mj: n,
            nW: r
        };
    }), sq = ul(A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(fq)))), lq = ul(A4(ll, "check_results", function(n) {
        return n.gU;
    }, $l(YM), A4(ll, "file", function(n) {
        return n.lA;
    }, rq, A4(ll, "result", function(n) {
        return n.bn;
    }, cq, A4(ll, "show", function(n) {
        return n.g9;
    }, sq, gl(_M)))))), dq = $l(lq), bq = F2(function(n, r) {
        return {
            cP: r,
            qu: n
        };
    }), mq = F2(function(n, r) {
        return A2(bq, A2(Qu, A2(fA, r.g9.mj, C([
            sA(r.g9.mj)
        ])), Ra(A2(Bu, function(n) {
            return i(n.qs, r.g9.mj);
        }, n))), r);
    }), pq = function(n) {
        return A2(bp, function(r) {
            return A2(Ge, mq(r), n);
        }, Al(A2(_s, bA, A3(kg, cA, aA(A2(Ge, A2(Po, function(n) {
            return n.g9;
        }, function(n) {
            return n.mj;
        }), n)), $g(oA)))));
    }, vq = function(n) {
        return A2(Rs, KM, function(n) {
            return A2(Zw, pq, function(n) {
                return Al(A2(_s, dq, Vs(xs(cL({
                    $: 4,
                    a: n
                })))));
            }(n));
        }(n));
    }, $q = F2(function(n, r) {
        switch(n.$){
            case 3:
                return A2(eo, g, p(r, {
                    rs: n.a
                }));
            case 2:
                var t = n.a;
                return A2(eo, t.$ ? g : C([
                    vq(t.a)
                ]), p(r, {
                    oE: A2(Wg, t, r.oE)
                }));
            case 1:
                return A2(eo, g, (e = n.a).$ ? r : p(r, {
                    oD: e.a
                }));
            default:
                var e;
                return A2(eo, g, p(r, (e = n.a).$ ? {
                    kt: g
                } : {
                    kt: e.a
                }));
        }
    }), gq = F2(function(n, r) {
        return A2(eh, g, C([
            n(r)
        ]));
    }), hq = F2(function(n, r) {
        return th({
            nW: n,
            hf: rh,
            ie: gq(r)
        });
    }), kq = F3(function(n, r, t) {
        return th({
            nW: n,
            hf: zA(A2(mu, NA, t)),
            ie: gq(r)
        });
    }), Cq = F2(function(n, r) {
        return A3(kq, n, function(n) {
            return UA(r(n));
        }, r);
    }), jq = F2(function(n, r) {
        return th({
            nW: n,
            hf: zA(A2(mu, A2(mu, function(n) {
                return A2(Qu, 0, n);
            }, Tu(NA)), r)),
            ie: gq(function(n) {
                return A2(Qu, A2(Se, g, g), A2(Tu, UA, r(n)));
            })
        });
    }), wq = C([
        nh("Table")
    ]), Aq = function(n) {
        return A3(lL, n.nW, n.aT.e$.nI, n.aT.e$.nB);
    }, Lq = ih({
        jW: C([
            A2(hq, "Show", function(n) {
                return A2(hj, C([
                    wj("/show/" + n.cP.g9.mj)
                ]), C([
                    ch(GA(n.qu))
                ]));
            }),
            A2(Cq, "Created At", A2(Po, function(n) {
                return n.cP;
            }, A2(Po, function(n) {
                return n.bn;
            }, function(n) {
                return n.ke;
            }))),
            A2(jq, "Completed At", A2(Po, function(n) {
                return n.cP;
            }, A2(Po, function(n) {
                return n.bn;
            }, function(n) {
                return n.j_;
            }))),
            A2(YA, "Deep probe Name", A2(mu, A2(mu, function(n) {
                return n.rx;
            }, function(n) {
                return n.bn;
            }), function(n) {
                return n.cP;
            })),
            A2(YA, "Configuration", A2(mu, A2(mu, A2(mu, A2(mu, A2(mu, Wt(", "), Ge(_L)), Ge(Aq)), function(n) {
                return n.jH;
            }), function(n) {
                return n.bn;
            }), function(n) {
                return n.cP;
            }))
        ]),
        kr: p(wh, {
            pC: function() {
                return C([
                    nh("TableTr")
                ]);
            },
            rj: wq,
            rv: C([
                nh("TableTd")
            ])
        }),
        rE: A2(Po, function(n) {
            return n.cP;
        }, A2(Po, function(n) {
            return n.bn;
        }, function(n) {
            return n.mj;
        })),
        rF: function(n) {
            return {
                $: 3,
                a: n
            };
        }
    }), yq = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Sq = F2(function(n, r) {
        var t = A2(Se, C([
            nh("InputSelect"),
            Zh(C([
                d("InputSelectEmpty", "" === n.sa)
            ]))
        ]), C([
            A2(Se, C([
                nh("InputSelectChoice")
            ]), C([
                JC
            ])),
            A2(_h, C([
                nh("InputSelectValue")
            ]), "" === n.sa || wu(r) ? n.gy : A2(ZC, n.sa, r)),
            A2(_C, C([
                nh("InputSelectSelect"),
                $k(zh),
                hk(n.sa),
                gk(n.gy),
                nk(n.kO)
            ]), A2(Ge, function(r) {
                var t = r.a, e = r.b;
                return A2(KC, C([
                    hk(t),
                    GC(i(t, n.sa))
                ]), C([
                    ch(e)
                ]));
            }, r))
        ]));
        return A2(Se, C([
            nh("InputWrapperDark"),
            Zh(C([
                d("InputHasError", wu(n.lm))
            ]))
        ]), C([
            t,
            Gh(n.lm)
        ]));
    }), Fq = F2(function(n, r) {
        return A2(Se, C([
            nh("DarkZone"),
            nh("Filter")
        ]), C([
            A2(Se, g, g),
            A2(Se, C([
                nh("Summary")
            ]), C([
                A2(yA, g, C([
                    ch("Summary")
                ])),
                A2(bI, g, C([
                    ch("")
                ])),
                A2(bI, g, C([
                    ch("Total Probes: " + Bt(Dt(r)))
                ]))
            ]))
        ]));
    }), Tq = F2(function(n, r) {
        return A3(Wj, "Deep Probes", kt(function(n) {
            var r = A2(xi, A2(mu, zi, tl), A2(Ge, function(n) {
                return d(n.mj, n.nW);
            }, n.oD)), t = A2(bt, d("", ""), r);
            return A2(Se, C([
                A2(gh, "min-width", "100px")
            ]), C([
                A2(Sk, yq, A2(Sq, n.oE, t))
            ]));
        }(r)), qe(r.oE.sa) > 0 ? A2(Se, g, C([
            A2(Fq, r, r.kt),
            A3(jC, Lq, r.rs, r.kt)
        ])) : A2(Se, C([
            nh("EmptySection")
        ]), C([
            A2(Se, g, C([
                ch("Choose Organization")
            ]))
        ])));
    }), Qq = {
        l: function(n) {
            return n.ds;
        },
        m: ZM,
        p: F2(function(n, r) {
            return p(n, {
                ds: r
            });
        }),
        q: function(n) {
            return {
                $: 18,
                a: n
            };
        },
        r: $q,
        s: Tq
    }, Iq = {
        kt: g,
        ll: Ct,
        pX: Xi(function(n) {
            return p(n, {
                m$: "fileToFind"
            });
        })
    }, Bq = A2(eo, g, Iq), Wq = function(n) {
        return A2(Bg, n, "");
    }, Pq = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Mq = function(n) {
        switch(n){
            case "ProxyManifest":
                return yt(0);
            case "ProxyDashVideo":
                return yt(1);
            case "ProxyAudio":
                return yt(2);
            case "ProxySubtitle":
                return yt(3);
            case "VerificationReportPdf":
                return yt(4);
            case "VerificationReportXml":
                return yt(5);
            case "Video":
                return yt(6);
            case "Audio":
                return yt(7);
            case "Subtitle":
                return yt(8);
            default:
                return yt(9);
        }
    }, qq = function(n) {
        switch(n){
            case 0:
                return "ProxyManifest";
            case 1:
                return "ProxyDashVideo";
            case 2:
                return "ProxyAudio";
            case 3:
                return "ProxySubtitle";
            case 4:
                return "VerificationReportPdf";
            case 5:
                return "VerificationReportXml";
            case 6:
                return "Video";
            case 7:
                return "Audio";
            case 8:
                return "Subtitle";
            default:
                return "Extra";
        }
    }, Dq = A2(zl, qq, Mq), Xq = ul(A4(ll, "parent", function(n) {
        return n.gs;
    }, Di, A4(kb, "stateExpireAt", function(n) {
        return n.hx;
    }, bb, A4(ll, "showState", function(n) {
        return n.hc;
    }, Zm, A4(ll, "showKind", function(n) {
        return n.qt;
    }, Nb, A4(ll, "accepted", function(n) {
        return n.il;
    }, Zi, A4(ll, "organization", function(n) {
        return n.oz;
    }, Di, A4(kb, "title2", function(n) {
        return n.rD;
    }, Di, A4(ll, "title1", function(n) {
        return n.rC;
    }, Di, A4(ll, "showId", function(n) {
        return n.qs;
    }, Di, A4(ll, "state", function(n) {
        return n.hw;
    }, Zm, A4(ll, "kind", function(n) {
        return n.c9;
    }, Dq, A4(ll, "key", function(n) {
        return n.fR;
    }, Di, A4(ll, "bucket", function(n) {
        return n.ev;
    }, Di, A4(kb, "mimeType", function(n) {
        return n.nH;
    }, Di, A4(ll, "size", function(n) {
        return n.qy;
    }, ml, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "createdAt", function(n) {
        return n.ke;
    }, bb, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(m) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return function($) {
                                                                            return {
                                                                                il: b,
                                                                                ev: a,
                                                                                ke: r,
                                                                                mj: n,
                                                                                fR: i,
                                                                                c9: o,
                                                                                nH: u,
                                                                                nW: t,
                                                                                oz: d,
                                                                                gs: $,
                                                                                qs: f,
                                                                                qt: m,
                                                                                hc: p,
                                                                                qy: e,
                                                                                hw: c,
                                                                                hx: v,
                                                                                rC: s,
                                                                                rD: l
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))))))))), Eq = $l(Xq), Rq = function(n) {
        return {
            $: 19,
            a: n
        };
    }, xq = function(n) {
        return Al(A2(_s, Eq, Vs(xs(Rq({
            $: 1,
            a: n
        })))));
    }, Oq = F2(function(n, r) {
        switch(n.$){
            case 1:
                return A2(eo, g, p(r, {
                    ll: Ct,
                    pX: A2(Wg, n.a, r.pX)
                }));
            case 2:
                return A2(eo, C([
                    (u = r.pX.sa, A2(Rs, Pq, xq(u)))
                ]), r);
            default:
                var t = n.a;
                if (!t.$ && t.a.b) {
                    var e = t.a;
                    return A2(eo, g, p(r, {
                        kt: A2(bt, e.a, e.b),
                        ll: Ct,
                        pX: Wq(r.pX)
                    }));
                }
                return A2(eo, g, p(r, {
                    kt: g,
                    ll: kt("le fichier " + r.pX.sa + " n'a pas \xe9t\xe9 trouv\xe9"),
                    pX: Wq(r.pX)
                }));
        }
        var u;
    }), zq = Sj(HT), Nq = F2(function(n, r) {
        return A2(Se, C([
            nh("BannerError")
        ]), C([
            A2(Se, C([
                nh("BannerHeader")
            ]), C([
                Wh,
                zq(n)
            ])),
            A2(Se, C([
                nh("BannerContent")
            ]), C([
                r
            ]))
        ]));
    }), Hq = function(n) {
        var r = n.ll;
        return 1 === r.$ ? A2(Se, C([
            A2(gh, "margin", "50px auto"),
            A2(gh, "text-align", "center")
        ]), C([
            ch("Search file by id")
        ])) : A2(Nq, "File not found", ch(r.a));
    }, Vq = function(n) {
        return s(n, 1073741824) > -1 ? Bt(re(n / 1073741824)) + " GB" : s(n, 1048576) > -1 ? Bt(re(n / 1048576)) + " MB" : 1024 > n ? n > 1 ? Bt(n) + " bytes" : 1 === n ? Bt(n) + " byte" : "0 bytes" : Bt(re(n / 1024)) + " KB";
    }, Uq = Se(C([
        nh("LayoutHeader")
    ])), Jq = F2(function(n, r) {
        return A2(zk, C([
            nh("KeyValueWrapperHeader")
        ]), C([
            A2(gC, C([
                nh("KeyValueHeader")
            ]), C([
                n
            ])),
            A2(gC, C([
                nh("KeyValueValue")
            ]), C([
                r
            ]))
        ]));
    }), Zq = Jq, Kq = function(n) {
        return A2(_h, C([
            nh("LayoutHeaderTitle")
        ]), n);
    }, _q = function(n) {
        var r, t, e;
        return C([
            Uq(C([
                Kq(n.nW),
                Kq(n.fR)
            ])),
            A2(Zq, ch("FILE"), A2(Se, g, g)),
            A2(OQ, "Id", n.mj),
            A2(xQ, ch("Created At"), UA(n.ke)),
            A2(OQ, "Size", Vq(n.qy)),
            A2(OQ, "MimeType", (e = n.nH, 1 === e.$ ? "No mime type" : e.a)),
            A2(OQ, "Bucket", n.ev),
            A2(OQ, "Kind", qq(n.c9)),
            A2(OQ, "File Archived", Jm(n.hw)),
            A2(Zq, ch("SHOW"), A2(Se, g, g)),
            A2(xQ, ch("Id"), A2(hj, C([
                wj("/show/" + n.qs)
            ]), C([
                ch(n.qs)
            ]))),
            A2(OQ, "title", n.rC),
            A2(OQ, "title2", (t = n.rD, 1 === t.$ ? "No title" : t.a)),
            A2(OQ, "Organization", n.oz),
            A2(OQ, "Accepted", (r = n.il, r ? "\u2714" : "\u2716")),
            A2(OQ, "kind", zb(n.qt)),
            A2(OQ, "Archived", Jm(n.hw)),
            A2(xQ, ch("Parent"), A2(hj, C([
                wj("/hierarchy/" + n.gs)
            ]), C([
                ch(n.gs)
            ])))
        ]);
    }, Gq = F2(function(n, r) {
        if (n.b) {
            if (n.b.b) {
                var t = n.b;
                return $(_q(n.a), A2(Gq, t, r));
            }
            return _q(n.a);
        }
        return C([
            Hq(r)
        ]);
    }), Yq = function(n) {
        return {
            $: 1,
            a: n
        };
    }, nD = {
        $: 2
    }, rD = F2(function(n, r) {
        return A3(Wj, "Researchs", kt(function(n) {
            return A2(Se, C([
                A2(gh, "display", "flex")
            ]), C([
                A2(tj, C([
                    aj(nD)
                ]), C([
                    A2(Sk, Yq, kk(n.pX)),
                    A2(Dh, "search", nD)
                ]))
            ]));
        }(r)), A2(Se, g, A2(Gq, r.kt, r)));
    }), tD = {
        l: function(n) {
            return n.dv;
        },
        m: Bq,
        p: F2(function(n, r) {
            return p(n, {
                dv: r
            });
        }),
        q: function(n) {
            return {
                $: 9,
                a: n
            };
        },
        r: Oq,
        s: rD
    }, eD = F6(function(n, r, t, e, u, a) {
        var i, o = u, c = 1 === (i = o.l(r)).$ ? d(n, d(o.m.a, to(C([
            o.m.b,
            a
        ])))) : d(r, d(i.a, a)), f = c.b, s = f.b;
        return d(A2(o.p, c.a, kt(f.a)), A2(wp, o.q, s));
    }), uD = F5(function(n, r, t, e, u) {
        return A6(eD, n, r, t, e, u, p$);
    }), aD = {
        kL: Ct,
        ll: Ct,
        dy: g,
        re: Ct,
        rs: k$("Name")
    }, iD = function(n) {
        return {
            $: 0,
            a: n
        };
    }, oD = Al(A2(_s, mP, Vs(vP))), cD = A2(Rs, iD, oD), fD = d(aD, cD), sD = F2(function(n, r) {
        return p(r, {
            ll: kt(n.nE),
            re: Ct
        });
    }), lD = function(n) {
        return {
            $: 25,
            a: n
        };
    }, dD = F2(function(n, r) {
        return r.$ ? jt(n) : yt(r.a);
    }), bD = function(n) {
        var r, t = sP(n.rS.sa), e = {
            am: Re(n.ot.sa) ? Ct : Oe(n.ot.sa),
            b8: Re(n.ou.sa) ? Ct : Oe(n.ou.sa),
            rB: Re(n.ov.sa) ? Ct : kt(n.ov.sa)
        }, u = Re(n.nM.sa) ? Ct : Oe(n.nM.sa), a = Re(n.nK.sa) ? Ct : Oe(n.nK.sa), i = {
            am: Re(n.lh.sa) ? Ct : Oe(n.lh.sa),
            b8: Re(n.li.sa) ? Ct : Oe(n.li.sa),
            rB: Re(n.lj.sa) ? Ct : kt(n.lj.sa)
        }, o = {
            lG: Re(n.lG.sa) ? Ct : Oe(n.lG.sa),
            m2: Re(n.m2.sa) ? Ct : Oe(n.m2.sa),
            nC: Re(n.nC.sa) ? Ct : Oe(n.nC.sa),
            nJ: Re(n.nJ.sa) ? Ct : Oe(n.nJ.sa),
            pi: (r = n.pi, A2(Ii, g, A3(_e, F2(function(n, r) {
                var t = d(n, r);
                return t.b.$ ? jt(t.b.a) : t.a.$ ? jt(t.a.a) : yt(A2(bt, t.a.a, t.b.a));
            }), yt(g), A2(Ge, function(n) {
                var r = n.b;
                return A4(bg, aP, A2(dD, "Invalid ad value", Oe(r.iu.sa)), A2(dD, "Invalid min value", Oe(r.nI.sa)), A2(dD, "Invalid max value", Oe(r.nB.sa)));
            }, pt(r)))))
        };
        return A2(dg, function(r) {
            return {
                aA: o,
                bR: i,
                nK: a,
                nM: u,
                nW: n.nW.sa,
                b9: e,
                oX: n.oX.sa,
                qz: n.qz.sa,
                qA: n.qA.sa,
                rS: r
            };
        }, t);
    }, mD = ul(A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(function(n) {
        return {
            mj: n
        };
    }))), pD = ul(A4(ll, "skipM2CProxy", function(n) {
        return n.qA;
    }, Zi, A4(ll, "typology", function(n) {
        return n.rS;
    }, dP, A4(ll, "postCredits", function(n) {
        return n.oX;
    }, Zi, A4(kb, "minOutro", function(n) {
        return n.nM;
    }, ml, A4(kb, "minIntro", function(n) {
        return n.nK;
    }, ml, A4(ll, "skipIntro", function(n) {
        return n.qz;
    }, Zi, A4(ll, "endingCredits", function(n) {
        return n.bR;
    }, fP, A4(ll, "openingCredits", function(n) {
        return n.b9;
    }, fP, A4(ll, "adBreaks", function(n) {
        return n.aA;
    }, oP, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, gl(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return {
                                                aA: r,
                                                bR: e,
                                                nK: a,
                                                nM: i,
                                                nW: n,
                                                b9: t,
                                                oX: o,
                                                qz: u,
                                                qA: f,
                                                rS: c
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))), vD = function(n) {
        return A2(Rs, lD, A2(Zw, function(n) {
            return Al(A2(vg, mD, A3(kg, pD, n, $g(vP))));
        }, A2(nl, JS, KS(bD(n)))));
    }, $D = function(n) {
        return {
            $: 28,
            a: n
        };
    }, gD = function(n) {
        return X$(pP({
            $: 1,
            a: n
        }));
    }, hD = function(n) {
        return {
            $: 26,
            a: n
        };
    }, kD = F2(function(n, r) {
        return A2(Zw, function(r) {
            return Al(Lg(A3(kg, pD, r, Sg(gD(n.mj)))));
        }, A2(nl, JS, KS(bD(r))));
    }), CD = F2(function(n, r) {
        return A2(Rs, hD, A2(kD, n, r));
    }), jD = function(n) {
        var r = function(n) {
            return A2(Po, Tu(n), Qu(""));
        };
        return {
            lh: Xi(function(r) {
                return p(r, {
                    m$: "Minimum credits duration to detect (in seconds)",
                    sa: A2(Qu, "", A2(Tu, Bt, A2(Lp, function(n) {
                        return n.am;
                    }, A2(Tu, function(n) {
                        return n.bR;
                    }, n))))
                });
            }),
            li: Xi(function(r) {
                return p(r, {
                    m$: "Credits Duration (in seconds)",
                    sa: A2(Qu, "", A2(Tu, Bt, A2(Lp, function(n) {
                        return n.b8;
                    }, A2(Tu, function(n) {
                        return n.bR;
                    }, n))))
                });
            }),
            lj: Xi(function(r) {
                return p(r, {
                    m$: "Text to detect in the first shot of the end credits (enter one line of text maximum)",
                    sa: A2(Qu, "", A2(Lp, function(n) {
                        return n.rB;
                    }, A2(Tu, function(n) {
                        return n.bR;
                    }, n)))
                });
            }),
            lG: Xi(function(r) {
                return p(r, {
                    m$: "Minimum distance between the start of the program and the first ad break (in minutes)",
                    sa: A2(Qu, "", A2(Tu, Bt, A2(Lp, function(n) {
                        return n.lG;
                    }, A2(Tu, function(n) {
                        return n.aA;
                    }, n))))
                });
            }),
            m2: Xi(function(r) {
                return p(r, {
                    m$: "Minimum distance between the last ad break and the end of the program (in minutes)",
                    sa: A2(Qu, "", A2(Tu, Bt, A2(Lp, function(n) {
                        return n.m2;
                    }, A2(Tu, function(n) {
                        return n.aA;
                    }, n))))
                });
            }),
            nC: Xi(function(r) {
                return p(r, {
                    m$: "Maximum interval between two ad breaks (in minutes)",
                    sa: A2(Qu, "", A2(Tu, Bt, A2(Lp, function(n) {
                        return n.nC;
                    }, A2(Tu, function(n) {
                        return n.aA;
                    }, n))))
                });
            }),
            nJ: Xi(function(r) {
                return p(r, {
                    m$: "Minimum interval between two ad breaks (in minutes)",
                    sa: A2(Qu, "", A2(Tu, Bt, A2(Lp, function(n) {
                        return n.nJ;
                    }, A2(Tu, function(n) {
                        return n.aA;
                    }, n))))
                });
            }),
            nK: Xi(function(r) {
                return p(r, {
                    m$: "Minimum intro duration (in seconds)",
                    sa: A2(Qu, "", A2(Tu, Bt, A2(Lp, function(n) {
                        return n.nK;
                    }, n)))
                });
            }),
            nM: Xi(function(r) {
                return p(r, {
                    m$: "Minimum outro duration (in seconds)",
                    sa: A2(Qu, "", A2(Tu, Bt, A2(Lp, function(n) {
                        return n.nM;
                    }, n)))
                });
            }),
            nW: Xi(function(t) {
                return p(t, {
                    m$: "Name",
                    sa: A2(r, function(n) {
                        return n.nW;
                    }, n)
                });
            }),
            ot: Xi(function(r) {
                return p(r, {
                    m$: "Minimum credits duration to detect (in seconds)",
                    sa: A2(Qu, "", A2(Tu, Bt, A2(Lp, function(n) {
                        return n.am;
                    }, A2(Tu, function(n) {
                        return n.b9;
                    }, n))))
                });
            }),
            ou: Xi(function(r) {
                return p(r, {
                    m$: "Credits duration (in seconds). Enter a negative value if the series title appears at the end of the credits.",
                    sa: A2(Qu, "", A2(Tu, Bt, A2(Lp, function(n) {
                        return n.b8;
                    }, A2(Tu, function(n) {
                        return n.b9;
                    }, n))))
                });
            }),
            ov: Xi(function(r) {
                return p(r, {
                    m$: "Series Title (enter one line of text maximum)",
                    sa: A2(Qu, "", A2(Lp, function(n) {
                        return n.rB;
                    }, A2(Tu, function(n) {
                        return n.b9;
                    }, n)))
                });
            }),
            oF: n,
            oX: Ki(function(r) {
                return p(r, {
                    m$: "Enable outro detection",
                    sa: A2(Qu, !1, A2(Tu, function(n) {
                        return n.oX;
                    }, n))
                });
            }),
            pi: A2(cl, F2(function(n, r) {
                return {
                    iu: Xi(function(n) {
                        return p(n, {
                            m$: "Number of ad breaks",
                            sa: Bt(r.dR)
                        });
                    }),
                    nB: Xi(function(n) {
                        return p(n, {
                            m$: "To program duration (in minutes)",
                            sa: Bt(r.cU)
                        });
                    }),
                    nI: Xi(function(n) {
                        return p(n, {
                            m$: "From program duration (in minutes)",
                            sa: Bt(r.am)
                        });
                    })
                };
            }), il(A2(Ot, ng, A2(Qu, g, A2(Tu, A2(Po, function(n) {
                return n.aA;
            }, function(n) {
                return n.pi;
            }), n))))),
            qz: Ki(function(r) {
                return p(r, {
                    m$: "Enable intro detection",
                    sa: A2(Qu, !1, A2(Tu, function(n) {
                        return n.qz;
                    }, n))
                });
            }),
            qA: Ki(function(r) {
                return p(r, {
                    m$: "Skip M2C proxy creation",
                    sa: A2(Qu, !1, A2(Tu, function(n) {
                        return n.qA;
                    }, n))
                });
            }),
            rS: Xi(function(t) {
                return p(t, {
                    m$: "Typology",
                    sa: A2(r, A2(Po, function(n) {
                        return n.rS;
                    }, lP), n)
                });
            })
        };
    }, wD = F2(function(n, r) {
        switch(n.$){
            case 0:
                return p(r, {
                    iu: A2(Wg, n.a, r.iu)
                });
            case 1:
                return p(r, {
                    nI: A2(Wg, n.a, r.nI)
                });
            default:
                return p(r, {
                    nB: A2(Wg, n.a, r.nB)
                });
        }
    }), AD = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(eo, g, (f = n.a).$ ? A2(sD, f.a, r) : p(r, {
                    dy: f.a
                }));
            case 1:
                return A2(eo, g, p(r, {
                    kL: kt(jD(Ct))
                }));
            case 2:
                return A2(eo, g, p(r, {
                    kL: kt(jD(kt(n.a)))
                }));
            case 3:
                var t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        nW: A2(Wg, t, n.nW)
                    });
                }, r.kL);
                return A2(eo, g, p(r, {
                    kL: e
                }));
            case 4:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        lG: A2(Wg, t, n.lG)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 5:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        m2: A2(Wg, t, n.m2)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 6:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        nJ: A2(Wg, t, n.nJ)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 7:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        nC: A2(Wg, t, n.nC)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 11:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        ov: A2(Wg, t, n.ov)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 12:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        ou: A2(Wg, t, n.ou)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 13:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        ot: A2(Wg, t, n.ot)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 14:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        lj: A2(Wg, t, n.lj)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 15:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        li: A2(Wg, t, n.li)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 16:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        lh: A2(Wg, t, n.lh)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 17:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        qz: A2(Ig, t, n.qz)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 18:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        nK: A2(Wg, t, n.nK)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 19:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        nM: A2(Wg, t, n.nM)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 20:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        oX: A2(Ig, t, n.oX)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 21:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        rS: A2(Wg, t, n.rS)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 10:
                var u = n.a;
                return e = A2(Tu, function(n) {
                    return p(n, {
                        pi: A2(ag, F2(function(n) {
                            return !i(n, u);
                        }), n.pi)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 8:
                t = n.a, u = n.b;
                n: for(; !t.a.$;)return e = A2(Tu, function(n) {
                    return p(n, {
                        pi: A2(cl, F2(function(n, r) {
                            return i(n, u) ? A2(wD, t, r) : r;
                        }), n.pi)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
                return A2(eo, g, r);
            case 9:
                var a = A2(Qu, 0, A2(Tu, function(n) {
                    return A2(Qu, 0, ig(vt(n.pi)));
                }, r.kL)), o = (d = {
                    cU: 0,
                    am: 0,
                    dR: a + 1
                }, b = Xi(function(n) {
                    return p(n, {
                        m$: "From program duration (in minutes)",
                        sa: Bt(d.am)
                    });
                }), m = Xi(function(n) {
                    return p(n, {
                        m$: "To program duration (in minutes)",
                        sa: Bt(d.cU)
                    });
                }), {
                    iu: Xi(function(n) {
                        return p(n, {
                            m$: "Number of ad breaks",
                            sa: Bt(d.dR)
                        });
                    }),
                    nB: m,
                    nI: b
                });
                return e = A2(Tu, function(n) {
                    return p(n, {
                        pi: A3(ju, a + 1, o, n.pi)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 22:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        qA: A2(Ig, t, n.qA)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 23:
                return A2(eo, g, p(r, {
                    kL: Ct,
                    ll: Ct,
                    re: Ct
                }));
            case 24:
                var c = r.kL;
                return A2(eo, C(1 === c.$ ? [
                    p$
                ] : 1 === (l = (e = c.a).oF).$ ? [
                    vD(e)
                ] : [
                    A2(CD, l.a, e)
                ]), r);
            case 25:
                return (f = n.a).$ ? A2(eo, g, A2(sD, f.a, r)) : A2(eo, C([
                    cD
                ]), p(r, {
                    kL: Ct,
                    ll: Ct,
                    re: kt("Segmentation rule created")
                }));
            case 26:
                return (f = n.a).$ ? A2(eo, g, A2(sD, f.a, r)) : A2(eo, C([
                    cD
                ]), p(r, {
                    kL: Ct,
                    ll: Ct,
                    re: kt("Segmentation rule updated")
                }));
            case 27:
                return A2(eo, C([
                    (s = n.a, A2(Rs, $D, function(n) {
                        return Al(Lg(Ag(gD(n.mj))));
                    }(s)))
                ]), r);
            case 28:
                var f;
                return (f = n.a).$ ? A2(eo, g, A2(sD, f.a, r)) : A2(eo, C([
                    cD
                ]), r);
            default:
                return A2(eo, g, p(r, {
                    rs: n.a
                }));
        }
        var s, l, d, b, m;
    }), LD = {
        $: 1
    }, yD = function(n) {
        return {
            $: 2,
            a: n
        };
    }, SD = function(n) {
        return {
            $: 27,
            a: n
        };
    }, FD = F2(function(n, r) {
        if (r.b) {
            var t = r.a, e = r.b, u = F2(function(r, t) {
                return A2(bt, n, A2(bt, r, t));
            });
            return A2(bt, t, A3(_e, u, g, e));
        }
        return g;
    }), TD = function(n) {
        return A2(ph, g, A2(FD, A2(xT, g, g), A2(Ge, ch, A2(Pt, "\n", function(n) {
            var r, t, e, u, a = (r = n.nJ).$ ? "N/A" : Bt(r.a), i = (t = n.nC).$ ? "N/A" : Bt(t.a), o = (e = n.m2).$ ? "N/A" : Bt(e.a);
            return "first point: " + ((u = n.lG).$ ? "N/A" : Bt(u.a)) + "\nlast point: " + o + "\nmininum interval: " + a + "\nmaximum interval: " + i + "\nranges:" + (wu(n.pi) ? "N/A" : A2(Wt, "", A2(Ge, function(n) {
                return "\n- total breaks: " + Bt(n.dR) + ", duration min: " + Bt(n.am) + ", duration max: " + Bt(n.cU);
            }, n.pi)));
        }(n)))));
    }, QD = function(n) {
        return A2(ph, g, A2(FD, A2(xT, g, g), A2(Ge, ch, A2(Pt, "\n", function(n) {
            return "title: " + A2(Qu, "N/A", n.rB) + "\noffset: " + A2(Qu, "N/A", A2(Tu, Bt, n.b8)) + "\nminimum credits duration: " + A2(Qu, "N/A", A2(Tu, Bt, n.am));
        }(n)))));
    }, ID = F2(function(n, r) {
        return A2(eh, g, C([
            n(r)
        ]));
    }), BD = F2(function(n, r) {
        return th({
            nW: n,
            hf: rh,
            ie: ID(r)
        });
    }), WD = F2(function(n, r) {
        var t;
        return sh({
            nW: n,
            hf: lh((t = r, A2(mu, zi, t))),
            ie: r
        });
    }), PD = ih({
        jW: C([
            A2(BD, "Edit", A2(mu, Dh("Edit"), yD)),
            A2(WD, "Name", function(n) {
                return n.nW;
            }),
            A2(WD, "Typology", A2(mu, lP, function(n) {
                return n.rS;
            })),
            A2(BD, "Opening Credits", A2(mu, QD, function(n) {
                return n.b9;
            })),
            A2(BD, "End Credits", A2(mu, QD, function(n) {
                return n.bR;
            })),
            A2(BD, "Ad breaks", A2(mu, TD, function(n) {
                return n.aA;
            })),
            A2(BD, "Intro Detection", function(n) {
                return n.qz ? Xh : Ph;
            }),
            A2(WD, "Minimum Intro Duration", A2(mu, A2(mu, Qu("N/A"), Tu(Bt)), function(n) {
                return n.nK;
            })),
            A2(BD, "Outro Detection", function(n) {
                return n.oX ? Xh : Ph;
            }),
            A2(WD, "Minimum Outro Duration", A2(mu, A2(mu, Qu("N/A"), Tu(Bt)), function(n) {
                return n.nM;
            })),
            A2(BD, "Skip M2C proxy", function(n) {
                return n.qA ? Xh : Ph;
            }),
            A2(BD, "Delete", A2(mu, Kg(Wh), SD))
        ]),
        kr: p(wh, {
            pC: function() {
                return C([
                    nh("TableTr")
                ]);
            },
            rj: C([
                nh("Table")
            ]),
            rv: C([
                nh("TableTd")
            ])
        }),
        rE: function(n) {
            return n.mj;
        },
        rF: function(n) {
            return {
                $: 29,
                a: n
            };
        }
    }), MD = function(n) {
        return {
            $: 20,
            a: n
        };
    }, qD = function(n) {
        return {
            $: 17,
            a: n
        };
    }, DD = function(n) {
        return {
            $: 22,
            a: n
        };
    }, XD = {
        $: 23
    }, ED = function(n) {
        return {
            $: 16,
            a: n
        };
    }, RD = function(n) {
        return {
            $: 15,
            a: n
        };
    }, xD = function(n) {
        return {
            $: 14,
            a: n
        };
    }, OD = function(n) {
        return {
            $: 4,
            a: n
        };
    }, zD = function(n) {
        return {
            $: 5,
            a: n
        };
    }, ND = function(n) {
        return {
            $: 7,
            a: n
        };
    }, HD = function(n) {
        return {
            $: 6,
            a: n
        };
    }, VD = function(n) {
        return {
            $: 18,
            a: n
        };
    }, UD = function(n) {
        return {
            $: 19,
            a: n
        };
    }, JD = function(n) {
        return {
            $: 3,
            a: n
        };
    }, ZD = function(n) {
        return {
            $: 13,
            a: n
        };
    }, KD = function(n) {
        return {
            $: 12,
            a: n
        };
    }, _D = function(n) {
        return {
            $: 11,
            a: n
        };
    }, GD = function(n) {
        return {
            $: 21,
            a: n
        };
    }, YD = {
        $: 9
    }, nX = {
        $: 24
    }, rX = function(n) {
        return -2 === n.$;
    }, tX = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), eX = function(n) {
        return {
            $: 0,
            a: n
        };
    }, uX = function(n) {
        return {
            $: 2,
            a: n
        };
    }, aX = function(n) {
        return {
            $: 1,
            a: n
        };
    }, iX = function(n) {
        return A2(Ge, tl, pt(A2(cl, F2(function(n, r) {
            var t, e;
            return A2(Se, C([
                A2(gh, "position", "relative"),
                A2(gh, "margin", "0 0 25px 0")
            ]), C([
                A2(Sk, function(r) {
                    return A2(tX, r, n);
                }, (e = r, A2(Se, g, C([
                    A2(Sk, eX, VC(e.iu)),
                    A2(Sk, aX, VC(e.nI)),
                    A2(Sk, uX, VC(e.nB))
                ])))),
                A3(lj, "remove", C([
                    d("position", "absolute"),
                    d("right", "0")
                ]), (t = n, {
                    $: 10,
                    a: t
                }))
            ]));
        }), n.pi)));
    }, oX = function(n) {
        return A2(qC, function(n) {
            var r = A2(Ge, function(n) {
                return d(n, n);
            }, A2(Ge, lP, C([
                0,
                1,
                2
            ]))), t = function(n) {
                return 1 !== n.oF.$;
            }(n) ? d("Save", "Edit Rule") : d("Create", "New Rule");
            return A4(oj, t.b, d(t.a, nX), d("Cancel", XD), C([
                A2(Sk, JD, VC(n.nW)),
                A2(Sk, GD, A2(rj, n.rS, r)),
                A2(Sk, DD, HC(n.qA)),
                A2(xT, g, g),
                A2(Se, g, $(C([
                    A2(yj, g, C([
                        ch("Ad breaks")
                    ])),
                    A2(xT, g, g),
                    A2(HT, g, C([
                        ch("Ranges")
                    ])),
                    A2(bI, g, C([
                        ch("Define the number of ad breaks required for a program duration.")
                    ])),
                    A2(bI, g, C([
                        ch("Example:")
                    ])),
                    A2(bI, g, C([
                        ch("- Number of ad breaks: 1, from program duration 0 to 45 (exclusive) min")
                    ])),
                    A2(bI, g, C([
                        ch("- Number of ad breaks: 2, from program duration 45 (inclusive) to 60 min")
                    ])),
                    A2(bI, g, C([
                        ch("If a program is less than 45 minutes long, it requires 1 ad break.")
                    ])),
                    A2(bI, g, C([
                        ch("If a program is between 45 and 60 minutes long, it requires 2 ad breaks.")
                    ])),
                    A2(xT, g, g)
                ]), $(iX(n), A2(bt, A2(Dh, "New range", YD), rX(n.pi) ? g : C([
                    A2(xT, g, g),
                    A2(xT, g, g),
                    A2(HT, g, C([
                        ch("Limits")
                    ])),
                    A2(Sk, OD, VC(n.lG)),
                    A2(Sk, zD, VC(n.m2)),
                    A2(xT, g, g),
                    A2(HT, g, C([
                        ch("Interval")
                    ])),
                    A2(Sk, HD, VC(n.nJ)),
                    A2(Sk, ND, VC(n.nC))
                ]))))),
                A2(xT, g, g),
                A2(yj, g, C([
                    ch("Opening credits")
                ])),
                A2(Sk, ZD, VC(n.ot)),
                A2(Sk, _D, VC(n.ov)),
                A2(Sk, KD, VC(n.ou)),
                A2(xT, g, g),
                A2(yj, g, C([
                    ch("End credits")
                ])),
                A2(Sk, ED, VC(n.lh)),
                A2(Sk, xD, VC(n.lj)),
                A2(Sk, RD, VC(n.li)),
                A2(xT, g, g),
                A2(yj, g, C([
                    ch("Other detections")
                ])),
                A2(Sk, qD, HC(n.qz)),
                A2(Sk, VD, VC(n.nK)),
                A2(Sk, MD, HC(n.oX)),
                A2(Sk, UD, VC(n.nM))
            ]));
        }, n.kL);
    }, cX = F2(function(n, r) {
        return A3(Wj, "Segmentation Rules", kt(A2(Dh, "New\u2026", LD)), A2(Se, g, C([
            oX(r),
            A3(jC, PD, r.rs, r.dy)
        ])));
    }), fX = {
        l: function(n) {
            return n.dy;
        },
        m: fD,
        p: F2(function(n, r) {
            return p(n, {
                dy: r
            });
        }),
        q: function(n) {
            return {
                $: 14,
                a: n
            };
        },
        r: AD,
        s: cX
    }, sX = {
        kL: Ct,
        ll: Ct,
        lT: g,
        dF: g,
        re: Ct,
        rs: k$("Name")
    }, lX = function(n) {
        return {
            $: 0,
            a: n
        };
    }, dX = xs(bS({
        $: 2
    })), bX = Al(A2(_s, rS, Vs(dX))), mX = A2(Rs, lX, mp(d(pS, bX))), pX = d(sX, mX), vX = F2(function(n, r) {
        return p(r, {
            ll: kt(n.nE),
            re: Ct
        });
    }), $X = function(n) {
        return {
            $: 11,
            a: n
        };
    }, gX = function(n) {
        return n.$ ? Ct : kt(n.a);
    }, hX = function(n) {
        var r = "" === n.q6.sa ? Ct : kt(n.q6.sa), t = "" === n.q3.sa ? Ct : kt(n.q3.sa), e = "" === n.b8.sa ? Ct : kt(n.b8.sa), u = cS(n.lB.sa);
        return A2(dg, function(u) {
            var a;
            return {
                kR: (a = u, a ? Ct : gX(aS(n.kR.sa))),
                lB: u,
                nW: n.nW.sa,
                b8: e,
                q3: t,
                q6: r
            };
        }, u);
    }, kX = F6(function(n, r, t, e, u, a) {
        return {
            kR: u,
            lB: r,
            nW: n,
            b8: a,
            q3: e,
            q6: t
        };
    }), CX = ul(A4(kb, "offset", function(n) {
        return n.b8;
    }, Di, A4(kb, "displayStandard", function(n) {
        return n.kR;
    }, oS, A4(kb, "frameRate", function(n) {
        return n.q3;
    }, Di, A4(kb, "startTimecode", function(n) {
        return n.q6;
    }, Di, A4(ll, "format", function(n) {
        return n.lB;
    }, sS, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, gl(kX)))))))), jX = function(n) {
        return A2(Rs, $X, A2(Zw, function(n) {
            return Al(A2(vg, lS, A3(kg, CX, n, $g(mS))));
        }, A2(nl, JS, KS(hX(n)))));
    }, wX = function(n) {
        return {
            $: 14,
            a: n
        };
    }, AX = function(n) {
        return xs(bS({
            $: 1,
            a: n
        }));
    }, LX = function(n) {
        return {
            $: 12,
            a: n
        };
    }, yX = F2(function(n, r) {
        return A2(Zw, function(r) {
            return Al(A2(_s, lS, A3(kg, CX, r, Sg(AX(n.mj)))));
        }, A2(nl, JS, KS(hX(r))));
    }), SX = F2(function(n, r) {
        return A2(Rs, LX, A2(yX, n, r));
    }), FX = function(n) {
        var r = function(n) {
            return A2(Po, Tu(n), Qu(""));
        };
        return {
            kR: Xi(function(r) {
                return p(r, {
                    m$: "Display Standard",
                    sa: A2(Qu, "teletext_level_1", A2(Tu, iS, A2(Lp, function(n) {
                        return n.kR;
                    }, n)))
                });
            }),
            lB: Xi(function(t) {
                return p(t, {
                    m$: "File Format",
                    sa: A2(r, A2(Po, function(n) {
                        return n.lB;
                    }, fS), n)
                });
            }),
            nW: Xi(function(t) {
                return p(t, {
                    m$: "Name",
                    sa: A2(r, function(n) {
                        return n.nW;
                    }, n)
                });
            }),
            b8: Xi(function(r) {
                return p(r, {
                    m$: "Offset Timecode",
                    sa: A2(Qu, "", A2(Lp, function(n) {
                        return n.b8;
                    }, n))
                });
            }),
            oF: n,
            q3: Xi(function(r) {
                return p(r, {
                    m$: "Frame Rate",
                    sa: A2(Qu, "", A2(Lp, function(n) {
                        return A2(Tu, function(n) {
                            return n.mj;
                        }, n.q3);
                    }, n))
                });
            }),
            q6: Xi(function(r) {
                return p(r, {
                    m$: "Start Timecode",
                    sa: A2(Qu, "", A2(Lp, function(n) {
                        return n.q6;
                    }, n))
                });
            })
        };
    }, TX = F2(function(n, r) {
        switch(n.$){
            case 0:
                if ((i = n.a).$) return A2(eo, g, A2(vX, i.a, r));
                var t = i.a;
                return A2(eo, g, p(r, {
                    lT: t.b,
                    dF: t.a
                }));
            case 1:
                return A2(eo, g, p(r, {
                    kL: kt(FX(Ct))
                }));
            case 2:
                return A2(eo, g, p(r, {
                    kL: kt(FX(kt(n.a)))
                }));
            case 3:
                var e = n.a, u = A2(Tu, function(n) {
                    return p(n, {
                        nW: A2(Wg, e, n.nW)
                    });
                }, r.kL);
                return A2(eo, g, p(r, {
                    kL: u
                }));
            case 4:
                return e = n.a, u = A2(Tu, function(n) {
                    return p(n, {
                        lB: A2(Wg, e, n.lB)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: u
                }));
            case 5:
                return e = n.a, u = A2(Tu, function(n) {
                    return p(n, {
                        q6: A2(Wg, e, n.q6)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: u
                }));
            case 6:
                return e = n.a, u = A2(Tu, function(n) {
                    return p(n, {
                        q3: A2(Wg, e, n.q3)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: u
                }));
            case 7:
                return e = n.a, u = A2(Tu, function(n) {
                    return p(n, {
                        kR: A2(Wg, e, n.kR)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: u
                }));
            case 8:
                return e = n.a, u = A2(Tu, function(n) {
                    return p(n, {
                        b8: A2(Wg, e, n.b8)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: u
                }));
            case 9:
                return A2(eo, g, p(r, {
                    kL: Ct,
                    ll: Ct,
                    re: Ct
                }));
            case 10:
                var a = r.kL;
                return A2(eo, C(1 === a.$ ? [
                    p$
                ] : 1 === (c = (u = a.a).oF).$ ? [
                    jX(u)
                ] : [
                    A2(SX, c.a, u)
                ]), r);
            case 11:
                return (i = n.a).$ ? A2(eo, g, A2(vX, i.a, r)) : A2(eo, C([
                    mX
                ]), p(r, {
                    kL: Ct,
                    ll: Ct,
                    re: kt("Subtitle format created")
                }));
            case 12:
                return (i = n.a).$ ? A2(eo, g, A2(vX, i.a, r)) : A2(eo, C([
                    mX
                ]), p(r, {
                    kL: Ct,
                    ll: Ct,
                    re: kt("Subtitle format updated")
                }));
            case 13:
                return A2(eo, C([
                    (o = n.a, A2(Rs, wX, function(n) {
                        return A2(bp, Hl(n), Al(Lg(Ag(AX(n.mj)))));
                    }(o)))
                ]), r);
            case 14:
                var i;
                return (i = n.a).$ ? A2(eo, g, A2(vX, i.a, r)) : A2(eo, C([
                    mX
                ]), r);
            default:
                return A2(eo, g, p(r, {
                    rs: n.a
                }));
        }
        var o, c;
    }), QX = {
        $: 1
    }, IX = function(n) {
        return {
            $: 2,
            a: n
        };
    }, BX = function(n) {
        return {
            $: 13,
            a: n
        };
    }, WX = F2(function(n, r) {
        return A2(eh, g, C([
            n(r)
        ]));
    }), PX = F2(function(n, r) {
        return th({
            nW: n,
            hf: rh,
            ie: WX(r)
        });
    }), MX = F2(function(n, r) {
        var t;
        return sh({
            nW: n,
            hf: lh((t = r, A2(mu, zi, t))),
            ie: r
        });
    }), qX = ih({
        jW: C([
            A2(PX, "Edit", A2(mu, Dh("Edit"), IX)),
            A2(MX, "Name", function(n) {
                return n.nW;
            }),
            A2(MX, "File Format", A2(mu, fS, function(n) {
                return n.lB;
            })),
            A2(MX, "Start Timecode", A2(mu, Qu("N/A"), function(n) {
                return n.q6;
            })),
            A2(MX, "Frame Rate", A2(mu, A2(mu, Qu("N/A"), Tu(LF)), function(n) {
                return n.q3;
            })),
            A2(MX, "Display Standard", A2(mu, A2(mu, Qu("N/A"), Tu(iS)), function(n) {
                return n.kR;
            })),
            A2(MX, "Offset Timecode", A2(mu, Qu("N/A"), function(n) {
                return n.b8;
            })),
            A2(PX, "Delete", A2(mu, Kg(Wh), BX))
        ]),
        kr: p(wh, {
            pC: function() {
                return C([
                    nh("TableTr")
                ]);
            },
            rj: C([
                nh("Table")
            ]),
            rv: C([
                nh("TableTd")
            ])
        }),
        rE: function(n) {
            return n.mj;
        },
        rF: function(n) {
            return {
                $: 15,
                a: n
            };
        }
    }), DX = {
        $: 9
    }, XX = function(n) {
        return {
            $: 7,
            a: n
        };
    }, EX = function(n) {
        return {
            $: 4,
            a: n
        };
    }, RX = function(n) {
        return {
            $: 3,
            a: n
        };
    }, xX = function(n) {
        return {
            $: 8,
            a: n
        };
    }, OX = function(n) {
        return {
            $: 6,
            a: n
        };
    }, zX = function(n) {
        return {
            $: 5,
            a: n
        };
    }, NX = {
        $: 10
    }, HX = function(n) {
        return A2(qC, function(r) {
            var t = A2(Ge, function(n) {
                return d(n.mj, LF(n));
            }, n.lT), e = A2(Ge, function(n) {
                return d(n, n);
            }, A2(Ge, fS, C([
                0,
                1,
                2,
                3
            ]))), u = A2(Ge, function(n) {
                return d(n, n);
            }, A2(Ge, iS, C([
                0,
                1,
                2
            ]))), a = function(n) {
                return 1 !== n.oF.$;
            }(r) ? d("Save", "Edit Format") : d("Create", "New Format");
            return A4(oj, a.b, d(a.a, NX), d("Cancel", DX), C([
                A2(Sk, RX, VC(r.nW)),
                A2(Sk, EX, A2(rj, r.lB, e)),
                A2(Sk, zX, VC(r.q6)),
                A2(Sk, OX, A2(rj, r.q3, t)),
                A2(JT, i(r.lB.sa, fS(0)), A2(Sk, XX, A2(rj, r.kR, u))),
                A2(Sk, xX, VC(r.b8))
            ]));
        }, n.kL);
    }, VX = F2(function(n, r) {
        return A3(Wj, "Subtitle Formats", kt(A2(Dh, "New\u2026", QX)), A2(Se, g, C([
            HX(r),
            A3(jC, qX, r.rs, r.dF)
        ])));
    }), UX = {
        l: function(n) {
            return n.dF;
        },
        m: pX,
        p: F2(function(n, r) {
            return p(n, {
                dF: r
            });
        }),
        q: function(n) {
            return {
                $: 13,
                a: n
            };
        },
        r: TX,
        s: VX
    }, JX = {
        iG: yt(d(g, g)),
        ll: Ct,
        re: Ct
    }, ZX = function(n) {
        return {
            $: 0,
            a: n
        };
    }, KX = Al(A2(_s, gS, Vs(kS))), _X = xs(hS({
        $: 2
    })), GX = Al(A2(_s, $l(Di), Vs(_X))), YX = A2(Rs, ZX, mp(d(KX, GX))), nE = A2(eo, C([
        YX
    ]), JX), rE = F2(function(n, r) {
        return p(r, {
            ll: kt(n.nE),
            re: Ct
        });
    }), tE = function(n) {
        return {
            $: 4,
            a: n
        };
    }, eE = function(n) {
        return A2(Rs, tE, function(n) {
            return A2(bp, function() {
                return n;
            }, Al(Lg(Ag(xs(hS({
                $: 1,
                a: n.mj
            }))))));
        }(n));
    }, uE = function(n) {
        return {
            $: 2,
            a: n
        };
    }, aE = ul(A4(ll, "tpKey", function(n) {
        return n.rK;
    }, Di, gl(function(n) {
        return {
            rK: n
        };
    }))), iE = F2(function(n, r) {
        switch(n.$){
            case 1:
                return A2(eo, C([
                    (u = n.a, A2(Rs, uE, Al(A2(vg, $S, A3(kg, aE, {
                        rK: u
                    }, $g(kS))))))
                ]), r);
            case 2:
                return (t = n.a).$ ? A2(eo, g, A2(rE, e = t.a, r)) : A2(eo, C([
                    YX
                ]), p(r, {
                    ll: Ct,
                    re: kt("Test plan imported")
                }));
            case 0:
                return A2(eo, g, (t = n.a).$ ? p(A2(rE, e = t.a, r), {
                    iG: jt(e)
                }) : p(r, {
                    iG: yt(t.a)
                }));
            case 3:
                return A2(eo, C([
                    eE(n.a)
                ]), r);
            default:
                var t, e;
                return (t = n.a).$ ? A2(eo, g, A2(rE, e = t.a, r)) : A2(eo, C([
                    YX
                ]), p(r, {
                    ll: Ct,
                    re: kt("Test plan deleted")
                }));
        }
        var u;
    }), oE = ye("b"), cE = Sj(oE), fE = C([
        ch("Name"),
        ch("Import")
    ]), sE = C([
        ch("Name"),
        ch("Delete")
    ]), lE = F2(function(n, r) {
        var t = function() {
            var n = r.iG;
            if (n.$) {
                var t = n.a;
                return d(A2(_h, C([
                    nh("failed")
                ]), t.nE), A2(_h, C([
                    nh("failed")
                ]), t.nE));
            }
            var e, u = n.a, a = u.b;
            return d(A2(dw, sE, (e = u.a, A2(Ge, function(n) {
                var r;
                return C([
                    cE(n.nW),
                    A2(Kg, Wh, (r = n, {
                        $: 3,
                        a: r
                    }))
                ]);
            }, A2(xi, A2(mu, zi, function(n) {
                return n.nW;
            }), e)))), A2(dw, fE, A2(Ge, function(n) {
                var r;
                return C([
                    cE(n),
                    A2(Dh, "import", (r = n, {
                        $: 1,
                        a: r
                    }))
                ]);
            }, A2(xi, zi, a))));
        }(), e = t.a, u = t.b;
        return A3(Wj, "Verification parameters", Ct, A2(Se, g, C([
            A2(UT, g, g),
            Fj("Imported test plans"),
            e,
            Fj("Available in S3"),
            u
        ])));
    }), dE = {
        l: function(n) {
            return n.dK;
        },
        m: nE,
        p: F2(function(n, r) {
            return p(n, {
                dK: r
            });
        }),
        q: function(n) {
            return {
                $: 6,
                a: n
            };
        },
        r: iE,
        s: lE
    }, bE = function(n) {
        return {
            $: 5,
            a: n
        };
    }, mE = function(n) {
        return {
            $: 2,
            a: n
        };
    }, pE = F2(function(n, r) {
        return {
            oM: r,
            dT: n
        };
    }), vE = F6(function(n, r, t, e, u, a) {
        return {
            f_: u,
            oQ: n,
            o6: r,
            gI: e,
            qP: t,
            dX: a
        };
    }), $E = A2(we, function(n) {
        var r = function(n) {
            switch(n){
                case "Waiting":
                    return yt(0);
                case "Downloading":
                    return yt(1);
                case "Encoding":
                    return yt(2);
                case "Packaging":
                    return yt(3);
                case "Uploading":
                    return yt(4);
                case "Finished":
                    return yt(5);
                default:
                    return jt("can't get phase from string " + n);
            }
        }(n);
        return r.$ ? xo(r.a) : Qe(r.a);
    }, Bi), gE = function(n) {
        return gi(function(n) {
            switch(n){
                case 0:
                    return "Waiting";
                case 1:
                    return "Downloading";
                case 2:
                    return "Encoding";
                case 3:
                    return "Packaging";
                case 4:
                    return "Uploading";
                default:
                    return "Finished";
            }
        }(n));
    }, hE = A2(qi, gE, $E), kE = F3(function(n, r, t) {
        return {
            eM: r,
            fg: t,
            nW: n
        };
    }), CE = ul(A4(ll, "firstFrameApprox", function(n) {
        return n.fg;
    }, ml, A4(ll, "count", function(n) {
        return n.eM;
    }, ml, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, gl(kE))))), jE = ul(A4(ll, "warning", function(n) {
        return n.dX;
    }, $l(CE), A4(kb, "log", function(n) {
        return n.f_;
    }, Di, A4(ll, "progressedAt", function(n) {
        return n.gI;
    }, bb, A4(ll, "startedAt", function(n) {
        return n.qP;
    }, bb, A4(kb, "progress", function(n) {
        return n.o6;
    }, yy, A4(ll, "phase", function(n) {
        return n.oQ;
    }, hE, gl(vE)))))))), wE = F9(function(n, r, t, e, u, a, i, o, c) {
        return {
            j_: e,
            ll: u,
            dq: t,
            o6: n,
            gI: r,
            pJ: a,
            aX: o,
            dC: c,
            qH: i
        };
    }), AE = ul(A4(kb, "source", function(n) {
        return n.dC;
    }, Di, A4(kb, "secondsLeft", function(n) {
        return n.aX;
    }, ml, A4(ll, "speed", function(n) {
        return n.qH;
    }, yy, A4(kb, "s3Id", function(n) {
        return n.pJ;
    }, Di, A4(kb, "error", function(n) {
        return n.ll;
    }, Di, A4(kb, "completedAt", function(n) {
        return n.j_;
    }, bb, A4(kb, "pausedAt", function(n) {
        return n.dq;
    }, bb, A4(ll, "progressedAt", function(n) {
        return n.gI;
    }, bb, A4(ll, "progress", function(n) {
        return n.o6;
    }, yy, gl(wE))))))))))), LE = F3(function(n, r, t) {
        return {
            ll: r,
            o6: n,
            bn: t
        };
    }), yE = F3(function(n, r, t) {
        return {
            nY: n,
            ar: r,
            cj: t
        };
    }), SE = F2(function(n, r) {
        return {
            lA: n,
            aw: r
        };
    }), FE = F3(function(n, r, t) {
        return {
            lP: n,
            fU: r,
            qy: t
        };
    }), TE = ul(A4(kb, "size", function(n) {
        return n.qy;
    }, ml, A4(kb, "lastModified", function(n) {
        return n.fU;
    }, bb, A4(kb, "format", function(n) {
        return n.lP;
    }, Di, gl(FE))))), QE = F6(function(n, r, t, e, u, a) {
        return {
            mj: n,
            b1: a,
            nW: e,
            b6: t,
            gs: r,
            gJ: u
        };
    }), IE = F9(function(n, r, t, e, u, a, i, o, c) {
        return {
            eb: a,
            v: n,
            f0: i,
            gc: e,
            gg: t,
            gH: c,
            g8: o,
            hM: u,
            id: r
        };
    }), BE = F2(function(n, r) {
        return {
            nW: n,
            sa: r
        };
    }), WE = ul(A4(kb, "value", function(n) {
        return n.sa;
    }, Di, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, gl(BE)))), PE = F2(function(n, r) {
        return {
            fR: n,
            sa: r
        };
    }), ME = ul(A4(ll, "$", function(n) {
        return n.v;
    }, ul(A4(kb, "value", function(n) {
        return n.sa;
    }, Di, A4(kb, "key", function(n) {
        return n.fR;
    }, Di, gl(PE)))), gl(function(n) {
        return {
            v: n
        };
    }))), qE = fl($l(ME)), DE = ul(A4(kb, "ProgramLoudnessEBU", function(n) {
        return n.gH;
    }, $l(qE), A4(kb, "MaxShortTermLoudness", function(n) {
        return n.g8;
    }, $l(ME), A4(kb, "mapping", function(n) {
        return n.f0;
    }, $l(ME), A4(kb, "area", function(n) {
        return n.eb;
    }, $l(ME), A4(kb, "SystemItem", function(n) {
        return n.hM;
    }, $l(qE), A4(kb, "TimeCodeTrack", function(n) {
        return n.gc;
    }, $l(qE), A4(kb, "TimecodeTrack", function(n) {
        return n.gg;
    }, $l(qE), A4(kb, "VideoTrackProperty", function(n) {
        return n.id;
    }, $l(qE), A4(ll, "$", function(n) {
        return n.v;
    }, WE, gl(IE))))))))))), XE = F2(function(n, r) {
        return {
            lm: r,
            dY: n
        };
    }), EE = F8(function(n, r, t, e, u, a, i, o) {
        return {
            eB: r,
            kJ: u,
            e7: o,
            mj: n,
            g6: t,
            hv: i,
            hL: e,
            hX: a
        };
    }), RE = ul(A4(kb, "endsmptetimecode", function(n) {
        return n.e7;
    }, Di, A4(kb, "startsmptetimecode", function(n) {
        return n.hv;
    }, Di, A4(kb, "smptetimecode", function(n) {
        return n.hX;
    }, Di, A4(ll, "description", function(n) {
        return n.kJ;
    }, Di, A4(ll, "synopsis", function(n) {
        return n.hL;
    }, Di, A4(ll, "severity", function(n) {
        return n.g6;
    }, Di, A4(kb, "checkId", function(n) {
        return n.eB;
    }, Di, A4(kb, "id", function(n) {
        return n.mj;
    }, Di, gl(EE)))))))))), xE = ul(A4(ll, "$", function(n) {
        return n.v;
    }, RE, gl(function(n) {
        return {
            v: n
        };
    }))), OE = ul(A4(ll, "errors", function(n) {
        return n.lm;
    }, $l(xE), A4(ll, "warnings", function(n) {
        return n.dY;
    }, $l(xE), gl(XE)))), zE = function(n) {
        return {
            $: 0,
            a: n
        };
    }, NE = function(n) {
        return {
            $: 2,
            a: n
        };
    }, HE = {
        $: 3
    }, VE = function(n) {
        return {
            $: 1,
            a: n
        };
    }, UE = F4(function(n, r, t, e) {
        return {
            cJ: t,
            fL: e,
            nj: r,
            gH: n
        };
    }), JE = F2(function(n, r) {
        return {
            m$: n,
            h7: r
        };
    }), ZE = ul(A4(ll, "truePeakLevel", function(n) {
        return n.h7;
    }, Di, A4(ll, "label", function(n) {
        return n.m$;
    }, Di, gl(JE)))), KE = ul(A4(ll, "isMute", function(n) {
        return n.fL;
    }, Zi, A4(ll, "channels", function(n) {
        return n.cJ;
    }, $l(ZE), A4(kb, "loudnessRange", function(n) {
        return n.nj;
    }, Di, A4(kb, "programLoudness", function(n) {
        return n.gH;
    }, Di, gl(UE)))))), _E = function(n) {
        return {
            $: 1,
            a: n
        };
    }, GE = function(n) {
        return {
            $: 0,
            a: n
        };
    }, YE = {
        $: 2
    }, nR = F2(function(n, r) {
        return {
            e$: r,
            qO: n
        };
    }), rR = ul(A4(kb, "duration", function(n) {
        return n.e$;
    }, Di, A4(kb, "startTimecode", function(n) {
        return n.qO;
    }, Di, gl(nR)))), tR = F3(function(n, r, t) {
        return {
            go: n,
            gF: t,
            hY: r
        };
    }), eR = F3(function(n, r, t) {
        return {
            fN: t,
            nW: n,
            sd: r
        };
    }), uR = ul(A4(kb, "issuer", function(n) {
        return n.fN;
    }, Di, A4(kb, "version", function(n) {
        return n.sd;
    }, Di, A4(kb, "name", function(n) {
        return n.nW;
    }, Di, gl(eR))))), aR = F5(function(n, r, t, e, u) {
        return {
            e$: n,
            fs: u,
            f3: e,
            hk: t,
            hN: r
        };
    }), iR = ul(A4(kb, "hasVitc", function(n) {
        return n.fs;
    }, Di, A4(kb, "materialPackageStart", function(n) {
        return n.f3;
    }, Di, A4(kb, "sourcePackageStart", function(n) {
        return n.hk;
    }, Di, A4(kb, "systemItemStart", function(n) {
        return n.hN;
    }, Di, A4(kb, "duration", function(n) {
        return n.e$;
    }, Di, gl(aR))))))), oR = ul(A4(ll, "product", function(n) {
        return n.gF;
    }, uR, A4(ll, "timeCodes", function(n) {
        return n.hY;
    }, iR, A4(kb, "operationalPattern", function(n) {
        return n.go;
    }, Di, gl(tR))))), cR = F2(function(n, r) {
        return A3(Bm, n, function(n) {
            return n(g);
        }, Qe(r));
    }), fR = yb(A3(cR, "UnsupportedContainer", YE, A4(Wm, "Mov", _E, rR, A4(Wm, "Mxf", GE, oR, Tb(F4(function(n, r, t, e) {
        switch(e.$){
            case 0:
                return n(e.a);
            case 1:
                return r(e.a);
            default:
                return t;
        }
    })))))), sR = F6(function(n, r, t, e, u, a) {
        return {
            d2: t,
            ex: e,
            eD: u,
            bP: n,
            lS: r,
            g$: a
        };
    }), lR = ul(A4(kb, "scanningType", function(n) {
        return n.g$;
    }, Di, A4(kb, "chromaFormat", function(n) {
        return n.eD;
    }, Di, A4(kb, "cadencePattern", function(n) {
        return n.ex;
    }, Di, A4(kb, "activePixelsArea", function(n) {
        return n.d2;
    }, Di, A4(kb, "frameRate", function(n) {
        return n.lS;
    }, Di, A4(kb, "displayAspectRatio", function(n) {
        return n.bP;
    }, Di, gl(sR)))))))), dR = yb(A3(cR, "UnknownNodeType", HE, A4(Wm, "Container", NE, fR, A4(Wm, "VideoProgram", VE, lR, A4(Wm, "AudioProgram", zE, KE, Tb(F5(function(n, r, t, e, u) {
        switch(u.$){
            case 0:
                return n(u.a);
            case 1:
                return r(u.a);
            case 2:
                return t(u.a);
            default:
                return e;
        }
    }))))))), bR = ul(A4(ll, "issues", function(n) {
        return n.b1;
    }, OE, A4(ll, "properties", function(n) {
        return n.gJ;
    }, fl(DE), A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "nodeType", function(n) {
        return n.b6;
    }, dR, A4(ll, "parent", function(n) {
        return n.gs;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(QE)))))))), mR = ul(A4(ll, "streams", function(n) {
        return n.aw;
    }, fl(bR), A4(ll, "file", function(n) {
        return n.lA;
    }, TE, gl(SE)))), pR = ul(A4(kb, "report", function(n) {
        return n.cj;
    }, mR, A4(ll, "nbWarnings", function(n) {
        return n.ar;
    }, ml, A4(ll, "nbErrors", function(n) {
        return n.nY;
    }, ml, gl(yE))))), vR = ul(A4(kb, "result", function(n) {
        return n.bn;
    }, pR, A4(kb, "error", function(n) {
        return n.ll;
    }, Di, A4(ll, "progress", function(n) {
        return n.o6;
    }, yy, gl(LE))))), $R = ul(A4(kb, "format", function(n) {
        return n.lP;
    }, Ky, A4(kb, "stateExpireAt", function(n) {
        return n.hx;
    }, bb, A4(ll, "state", function(n) {
        return n.hw;
    }, Zm, A4(kb, "transcoding", function(n) {
        return n.rN;
    }, jE, A4(kb, "sourceId", function(n) {
        return n.hh;
    }, Di, A4(kb, "verification", function(n) {
        return n.sc;
    }, vR, A4(kb, "uploadedAt", function(n) {
        return n.ia;
    }, bb, A4(kb, "upload", function(n) {
        return n.r$;
    }, AE, A4(kb, "uploaderId", function(n) {
        return n.r1;
    }, Di, A4(ll, "kind", function(n) {
        return n.c9;
    }, Dq, A4(ll, "key", function(n) {
        return n.fR;
    }, Di, A4(ll, "bucket", function(n) {
        return n.ev;
    }, Di, A4(kb, "mimeType", function(n) {
        return n.nH;
    }, Di, A4(ll, "size", function(n) {
        return n.qy;
    }, ml, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "createdAt", function(n) {
        return n.ke;
    }, bb, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(m) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return {
                                                                            ev: a,
                                                                            ke: r,
                                                                            lP: v,
                                                                            mj: n,
                                                                            fR: i,
                                                                            c9: o,
                                                                            nH: u,
                                                                            nW: t,
                                                                            qy: e,
                                                                            hh: d,
                                                                            hw: m,
                                                                            hx: p,
                                                                            rN: b,
                                                                            r$: f,
                                                                            ia: s,
                                                                            r1: c,
                                                                            sc: l
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))))), gR = F2(function(n, r) {
        return {
            fR: r,
            r0: n
        };
    }), hR = ul(A4(ll, "key", function(n) {
        return n.fR;
    }, Di, A4(ll, "uploadId", function(n) {
        return n.r0;
    }, Di, gl(gR)))), kR = ul(A4(ll, "parts", function(n) {
        return n.oM;
    }, $l(hR), A4(ll, "uploads", function(n) {
        return n.dT;
    }, $l($R), gl(pE)))), CR = xs({
        $: 13,
        a: 0
    }), jR = Al(A2(_s, kR, Vs(CR))), wR = Al(A2(_s, zw, Vs(Hw))), AR = mp(d(jR, wR)), LR = {
        iC: g,
        db: Ct,
        dO: Ct
    }, yR = {
        iC: LR,
        oc: 0,
        rX: g,
        dT: g
    }, SR = d(yR, A2(Rs, mE, AR)), FR = function(n) {
        return {
            $: 6,
            a: n
        };
    }, TR = function(n) {
        return {
            $: 1,
            a: n
        };
    }, QR = function(n) {
        return {
            $: 4,
            a: n
        };
    }, IR = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), BR = function(n) {
        return xs(Rq(A2(IR, n, 7)));
    }, WR = function(n) {
        return {
            $: 1,
            a: n
        };
    }, PR = F2(function(n, r) {
        return A2(b$, WR, A2(bp, function(t) {
            return {
                ed: t,
                nE: r,
                g6: n
            };
        }, d$));
    }), MR = PR(1), qR = F2(function(n, r) {
        var t = F2(function(r, t) {
            var e = t.a, u = t.b;
            return n(r) ? d(A2(bt, r, e), u) : d(e, A2(bt, r, u));
        });
        return A3(_e, t, d(g, g), r);
    }), DR = F3(function(n, r, t) {
        return A3(qt, F2(function(n, r) {
            var e = r.a, u = r.b, a = Ra(A2(Bu, function(r) {
                return i(n.r1, kt(r.mj));
            }, t)), o = A2(qR, function(r) {
                return i(kt(r.r0), A2(Lp, function(n) {
                    return n.pJ;
                }, n.r$));
            }, u), c = o.b;
            return d(A2(bt, {
                lA: n,
                oM: o.a,
                r8: a
            }, e), c);
        }), d(g, r), Jt(n));
    }), XR = PR(0), ER = F2(function(n, r) {
        switch(n.$){
            case 0:
                return d(r, p$);
            case 1:
                var t = n.a;
                return d(p(r, {
                    iC: 1 === (e = r.db).$ ? A2(bt, t, r.iC) : A2(Ja, e.a, A2(bt, t, r.iC))
                }), p$);
            default:
                return t = n.a, d(p(r, {
                    iC: A2(Bu, function(n) {
                        return !i(n, t);
                    }, r.iC)
                }), p$);
        }
        var e;
    }), RR = F2(function(n, r) {
        switch(n.$){
            case 1:
                return A2(eo, g, p(r, {
                    oc: n.a
                }));
            case 0:
                return A2(eo, g, r);
            case 2:
                if ((o = n.a).$) return A2(eo, C([
                    A2(wp, FR, MR(o.a.nE))
                ]), r);
                var t = o.a, e = t.a, u = A3(DR, e.dT, e.oM, t.b), a = u.a, i = u.b;
                return A2(eo, C([
                    A2(b$, TR, d$)
                ]), p(r, {
                    rX: i,
                    dT: a
                }));
            case 3:
                return A2(eo, C([
                    A2(Rs, QR, (s = n.a, Al(Lg(Ag(BR(s))))))
                ]), r);
            case 4:
                var o;
                return A2(eo, C((o = n.a).$ ? [
                    A2(wp, FR, MR(o.a.nE))
                ] : [
                    A2(wp, FR, XR("Upload deleted"))
                ]), r);
            case 5:
                return A2(eo, C([
                    A2(Rs, mE, AR)
                ]), r);
            default:
                var c = A2(ER, n.a, r.iC), f = c.a;
                return A2(eo, C([
                    A2(wp, FR, c.b)
                ]), p(r, {
                    iC: f
                }));
        }
        var s;
    }), xR = Sj(yA), OR = function(n) {
        return {
            $: 3,
            a: n
        };
    }, zR = function(n) {
        return Bt(se(100 * n)) + "%";
    }, NR = {
        $: 4
    }, HR = {
        $: 2
    }, VR = {
        $: 1
    }, UR = F2(function(n, r) {
        return i(n.dq, Ct) ? r ? VR : function(n) {
            return {
                $: 0,
                a: n
            };
        }({
            aX: n.aX
        }) : HR;
    }), JR = F3(function(n, r, t) {
        var e = Ra(A2(Bu, function(r) {
            return i(r.A, n);
        }, t)), u = r.ll;
        if (u.$) {
            if (i(r.j_, Ct) && 1 !== r.o6) {
                if (e.$) return A2(UR, r, !1);
                var a = e.a;
                return i(a.j_, Ct) ? A2(UR, r, a.dr) : NR;
            }
            return NR;
        }
        return function(n) {
            return {
                $: 5,
                a: n
            };
        }({
            ll: u.a
        });
    }), ZR = F3(function(n, r, t) {
        return 1 > n ? "" : 1 === n ? $(r, $(Bt(n), t)) : r + (Bt(n) + (t + "s"));
    }), KR = function(n) {
        return 86400 > n ? 3600 > n ? 60 > n ? A3(ZR, n, "", " seconde") : A3(ZR, n / 60 | 0, "", " minute") : $(A3(ZR, n / 3600 | 0, "", " heure"), A3(ZR, A2(qa, 60, n), " et ", " minute")) : $(A3(ZR, n / 86400 | 0, "", " jour"), A3(ZR, A2(qa, 24, n), " et ", " heure"));
    }, _R = Pi({
        bQ: "in error",
        bX: "en erreur"
    }), GR = Pi({
        bQ: "Calcultating the remaining time...",
        bX: "Calcul du temps restant..."
    }), YR = Pi({
        bQ: "paused",
        bX: "en pause"
    }), nx = Pi({
        bQ: "pausing...",
        bX: "mis en pause..."
    }), rx = Pi({
        bQ: "seems stopped since ",
        bX: "semble \xe0 l\u2019arr\xeat depuis "
    }), tx = function(n) {
        switch(n.$){
            case 0:
                var r = n.a.aX;
                return r.$ ? GR : KR(r.a);
            case 1:
                return nx;
            case 2:
                return YR;
            case 3:
                var t = KR(n.a.p0);
                return "" === t ? "" : $(rx, t);
            case 4:
                return "";
            default:
                return _R;
        }
    }, ex = function(n) {
        switch(n.$){
            case 5:
                return "En erreur : " + n.a.ll;
            case 4:
                return "Termin\xe9";
            default:
                return tx(n);
        }
    }, ux = F2(function(n, r) {
        return A2(Ge, function(n) {
            var t = d(n.lA.r$, n.r8);
            if (t.a.$ || t.b.$) return g;
            var e = t.a.a, u = t.b.a;
            return C([
                cE(n.lA.nW),
                ch(zR(e.o6)),
                A2(Se, g, C([
                    UA(e.gI),
                    ch(r - NA(e.gI) > 6e5 ? "\xa0 \xa0 ???" : "")
                ])),
                ch(Vq(xc(e.qH)) + "/s"),
                ch(ex(A3(JR, n.lA.mj, e, g))),
                ch(u.nW),
                ch(Bt(Dt(n.oM))),
                A2(Kg, Wh, OR(n.lA.mj))
            ]);
        }, n);
    }), ax = C([
        ch("Fichier"),
        ch("Progression"),
        ch("Last Updated"),
        ch("Last Speed Recorded"),
        ch("Statut"),
        ch("User"),
        ch("S3 parts"),
        ch("Supprimer")
    ]), ix = ye("ul"), ox = function(n) {
        return {
            $: 2,
            a: n
        };
    }, cx = ye("li"), fx = function(n) {
        return A2(cx, C([
            Mh(ox(n))
        ]), C([
            ch(n.nE)
        ]));
    }, sx = function(n) {
        var r;
        return A2(Se, g, C([
            (r = n.iC, A2(ix, g, A2(Ge, fx, r)))
        ]));
    }, lx = function(n) {
        return A2(cx, C([
            A2(gh, "list-style", "disc"),
            A2(gh, "margin-top", "5px")
        ]), C([
            ch(n.fR)
        ]));
    }, dx = F2(function(n, r) {
        return A3(Wj, "Uploads", Ct, A2(Se, g, C([
            A2(Sk, FR, sx(r.iC)),
            A2(dw, ax, A2(ux, r.dT, r.oc)),
            xR("Unlinked S3 parts"),
            A2(ix, C([
                A2(gh, "padding-left", "1.5em")
            ]), A2(Ge, lx, r.rX))
        ])));
    }), bx = {
        l: function(n) {
            return n.dT;
        },
        m: SR,
        p: F2(function(n, r) {
            return p(n, {
                dT: r
            });
        }),
        q: bE,
        r: RR,
        s: dx
    }, mx = {
        kL: Ct,
        ll: Ct,
        oD: Lu,
        ph: Xi(function(n) {
            return p(n, {
                gy: "Search User or Email or Organization",
                sa: ""
            });
        }),
        re: Ct,
        rs: k$("Full name"),
        dU: g
    }, px = function(n) {
        return {
            $: 1,
            a: n
        };
    }, vx = A2(bp, il, A2(bp, Ge(function(n) {
        return d(n.mj, n);
    }), A2(bp, xi(function(n) {
        return n.nW;
    }), Al(A2(_s, J$, Vs(K$)))))), $x = A2(bp, xi(function(n) {
        return n.nW;
    }), Al(A2(_s, zw, Vs(Hw)))), gx = A2(Rs, px, mp(d($x, vx))), hx = A2(eo, C([
        gx
    ]), mx), kx = function(n) {
        return {
            $: 17,
            a: n
        };
    }, Cx = {
        $: 0
    }, jx = function(n) {
        return {
            $: 24,
            a: n
        };
    }, wx = function(n) {
        return {
            $: 15,
            a: n
        };
    }, Ax = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Lx = X$(Ax({
        $: 2
    })), yx = ul(A4(ll, "email", function(n) {
        return n.k6;
    }, Di, gl(function(n) {
        return {
            k6: n
        };
    }))), Sx = function(n) {
        return Al(Lg(A3(kg, yx, n, $g(Lx))));
    }, Fx = F2(function(n, r) {
        return Gs($i(C([
            d("name", gi(n)),
            d("message", gi(r))
        ])));
    }), Tx = function(n) {
        return Ye(function(r) {
            var t = A2(bi, n, r);
            return t.$ ? A2(Fx, "JSON Decode Error", Kt(t.a)) : Je(t.a);
        });
    }, Qx = qn, Ix = function(n) {
        var r;
        return A2(Ii, A2(Fx, "FFI Error", Ti), (r = A2(du, "_elm_ffi_apply_", $b(C([
            A2(Fe, Je, A2(du, "OK", Qi)),
            A2(we, A2(mu, Qe, Bx(n)), A2(du, "AW", Ay)),
            A2(Fe, Gs, A2(du, "ER", Qi))
        ]))), A2(bi, r, n)));
    }, Bx = function(n) {
        return A2(Po, Qx, Ye(function() {
            return Ix(n);
        }));
    }, Wx = F2(function(n, r) {
        return Ix($i(C([
            d("_elm_ffi_apply_", $i(C([
                d("holder", r),
                d("params", A2(vl, Be, n))
            ])))
        ])));
    }), Px = F2(function(n, r) {
        return $i(C([
            d("_elm_ffi_create_", $i(C([
                d("args", A2(vl, gi, n)),
                d("code", gi(r))
            ])))
        ]));
    }), Mx = F2(function(n, r) {
        var t = A2(Px, A2(Ge, $e, n), r);
        return function(r) {
            return A2(Wx, A2(Ge, A2(Po, tl, ce(r)), n), t);
        };
    }), qx = (mc = A2(Mx, C([
        d("message", gi)
    ]), "return confirm(message);"), function(n) {
        return A2(Xs, function() {
            return Je(!1);
        }, A2(Tx, Ae, mc(n)));
    }), Dx = F2(function(n, r) {
        return p(r, {
            ll: kt(n.nE),
            re: Ct
        });
    }), Xx = Yr("focus"), Ex = function(n) {
        return {
            lz: Lu,
            nE: "",
            Q: n
        };
    }, Rx = ul(A4(ll, "user", function(n) {
        return n.r8;
    }, Di, gl(function(n) {
        return {
            r8: n
        };
    }))), xx = xs(Nw({
        $: 1
    })), Ox = function(n) {
        return Al(Lg(A3(kg, Rx, {
            r8: n.mj
        }, $g(xx))));
    }, zx = function(n) {
        return {
            $: 12,
            a: n
        };
    }, Nx = F7(function(n, r, t, e, u, a, i) {
        return {
            iz: a,
            kN: i,
            k6: r,
            nW: n,
            oz: t,
            oD: u,
            oN: e
        };
    }), Hx = ul(A4(ll, "disableOrganizationEmails", function(n) {
        return n.kN;
    }, Zi, A4(ll, "admin", function(n) {
        return n.iz;
    }, Zi, A4(ll, "organizations", function(n) {
        return n.oD;
    }, $l(Di), A4(ll, "password", function(n) {
        return n.oN;
    }, Di, A4(kb, "organization", function(n) {
        return n.oz;
    }, Di, A4(ll, "email", function(n) {
        return n.k6;
    }, Di, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, gl(Nx))))))))), Vx = function(n) {
        return A2(Rs, zx, function(n) {
            var r = A2(Ge, function(n) {
                return n.b.sa;
            }, pt(n.oD)), t = Ra(r);
            return Al(A2(vg, i$, A3(kg, Hx, {
                iz: n.iz.sa,
                kN: n.kN.sa,
                k6: n.k6.sa,
                nW: n.nW.sa,
                oz: t,
                oD: r,
                oN: n.oN.sa
            }, $g(Hw))));
        }(n));
    }, Ux = function(n) {
        return {
            $: 14,
            a: n
        };
    }, Jx = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Zx = A2(mu, A2(mu, xs, Nw), Jx), Kx = function(n) {
        return A2(Rs, Ux, function(n) {
            return Al(Lg(Ag(Zx(n.mj))));
        }(n));
    }, _x = function(n) {
        return {
            $: 13,
            a: n
        };
    }, Gx = F6(function(n, r, t, e, u, a) {
        return {
            iz: u,
            kN: a,
            k6: r,
            nW: n,
            oz: t,
            oD: e
        };
    }), Yx = ul(A4(ll, "disableOrganizationEmails", function(n) {
        return n.kN;
    }, Zi, A4(ll, "admin", function(n) {
        return n.iz;
    }, Zi, A4(ll, "organizations", function(n) {
        return n.oD;
    }, $l(Di), A4(kb, "organization", function(n) {
        return n.oz;
    }, Di, A4(ll, "email", function(n) {
        return n.k6;
    }, Di, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, gl(Gx)))))))), nO = F2(function(n, r) {
        var t = A2(Ge, function(n) {
            return n.b.sa;
        }, pt(r.oD)), e = Ra(t);
        return Al(A2(_s, i$, A3(kg, Yx, {
            iz: r.iz.sa,
            kN: r.kN.sa,
            k6: r.k6.sa,
            nW: r.nW.sa,
            oz: e,
            oD: t
        }, Sg(Zx(n.mj)))));
    }), rO = F2(function(n, r) {
        return A2(Rs, _x, A2(nO, n, r));
    }), tO = Jn("redirectAndRefresh", gi), eO = ul(A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(function(n) {
        return {
            mj: n
        };
    }))), uO = X$(Ax({
        $: 4
    })), aO = BA(xp), iO = function(n) {
        return Xi(function(r) {
            return p(r, {
                m$: "Organization",
                sa: n.oB
            });
        });
    }, oO = F2(function(n) {
        var r;
        return {
            iz: Ki(function(r) {
                return p(r, {
                    m$: "Admin",
                    sa: A2(Qu, !1, A2(Tu, function(n) {
                        return n.iz;
                    }, n))
                });
            }),
            kN: Ki(function(r) {
                return p(r, {
                    m$: "Disable Emails",
                    sa: A2(Qu, !1, A2(Tu, function(n) {
                        return n.kN;
                    }, n))
                });
            }),
            k6: Xi(function(r) {
                return p(r, {
                    m$: "Email",
                    sa: A2(Qu, "", A2(Tu, function(n) {
                        return n.k6;
                    }, n))
                });
            }),
            nW: Xi(function(r) {
                return p(r, {
                    m$: "Name",
                    sa: A2(Qu, "", A2(Tu, function(n) {
                        return n.nW;
                    }, n))
                });
            }),
            oD: n.$ ? Lu : (r = n.a.oD, A2(cl, F2(function(n, r) {
                return iO(r);
            }), il(A2(Ot, ng, r)))),
            oF: n,
            oN: Xi(function(n) {
                return p(n, {
                    m$: "Password"
                });
            })
        };
    }), cO = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(eo, g, r);
            case 1:
                if ((f = n.a).$) return A2(eo, g, A2(Dx, f.a, r));
                var t = f.a;
                return A2(eo, g, p(r, {
                    oD: t.b,
                    dU: t.a
                }));
            case 2:
                return A2(eo, g, p(r, {
                    kL: kt(A2(oO, Ct, r.oD))
                }));
            case 3:
                var e = n.a;
                return A2(eo, C([
                    A2(Rs, function() {
                        return Cx;
                    }, Xx("LayoutPageTop"))
                ]), p(r, {
                    kL: kt(A2(oO, kt(e), r.oD)),
                    ll: Ct,
                    re: Ct
                }));
            case 6:
                return A2(eo, g, p(r, {
                    kL: Ct,
                    ll: Ct,
                    re: Ct
                }));
            case 7:
                var u = n.a, a = A2(Tu, function(n) {
                    return p(n, {
                        nW: A2(Wg, u, n.nW)
                    });
                }, r.kL);
                return A2(eo, g, p(r, {
                    kL: a
                }));
            case 8:
                return u = n.a, a = A2(Tu, function(n) {
                    return p(n, {
                        k6: A2(Wg, u, n.k6)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: a
                }));
            case 9:
                return u = n.a, a = A2(Tu, function(n) {
                    return p(n, {
                        oN: A2(Wg, u, n.oN)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: a
                }));
            case 10:
                return u = n.a, a = A2(Tu, function(n) {
                    return p(n, {
                        iz: A2(Ig, u, n.iz)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: a
                }));
            case 11:
                return u = n.a, a = A2(Tu, function(n) {
                    return p(n, {
                        kN: A2(Ig, u, n.kN)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: a
                }));
            case 4:
                var o = r.kL;
                if (1 === o.$) return A2(eo, g, r);
                var c = (a = o.a).oF;
                return A2(eo, C(1 === c.$ ? [
                    Vx(a)
                ] : [
                    A2(rO, m = c.a, a)
                ]), r);
            case 12:
                return (f = n.a).$ ? A2(eo, g, A2(Dx, f.a, r)) : A2(eo, C([
                    gx
                ]), p(r, {
                    kL: Ct,
                    ll: Ct,
                    re: kt("User created")
                }));
            case 13:
                return (f = n.a).$ ? A2(eo, g, A2(Dx, f.a, r)) : A2(eo, C([
                    gx
                ]), p(r, {
                    kL: Ct,
                    ll: Ct,
                    re: kt("User updated")
                }));
            case 5:
                return A2(eo, C([
                    Kx(m = n.a)
                ]), r);
            case 14:
            case 15:
                return (f = n.a).$ ? A2(eo, g, A2(Dx, f.a, r)) : A2(eo, C([
                    gx
                ]), r);
            case 16:
                return A2(eo, C([
                    A2(Rs, kx, Ox(m = n.a))
                ]), r);
            case 17:
                var f;
                return A2(eo, 1 === (f = n.a).$ ? g : C([
                    tO(aO)
                ]), r);
            case 18:
                u = n.a;
                var s = n.b;
                return a = A2(Tu, function(n) {
                    return p(n, {
                        oD: A2(cl, F2(function(n, r) {
                            return i(n, s) ? A2(Wg, u, r) : r;
                        }), n.oD)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: a
                }));
            case 20:
                return s = n.a, a = A2(Tu, function(n) {
                    return p(n, {
                        oD: A2(ag, F2(function(n) {
                            return !i(n, s);
                        }), n.oD)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: a
                }));
            case 19:
                var l = A2(Qu, 0, A2(Tu, function(n) {
                    return A2(Qu, 0, ig(vt(n.oD)));
                }, r.kL)), d = A2(Qu, "", Ra(A2(Ge, function(n) {
                    return n.mj;
                }, A2(Ge, tl, pt(r.oD))))), b = iO(A3(u$, d, "", Ct));
                return a = A2(Tu, function(n) {
                    return p(n, {
                        oD: A3(ju, l + 1, b, n.oD)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: a
                }));
            case 22:
                return A2(eo, g, p(r, {
                    ph: A2(Wg, u = n.a, r.ph)
                }));
            case 21:
                return A2(eo, g, p(r, {
                    rs: n.a
                }));
            case 23:
                return A2(eo, C([
                    A2(Rs, jx, Sx({
                        k6: n.a
                    }))
                ]), r);
            case 24:
                return A2(eo, g, p(r, n.a.$ ? {
                    ll: kt(n.a.a.nE)
                } : {
                    re: kt("Sent email to reset password.")
                }));
            default:
                var m = n.a;
                return A2(eo, C([
                    A2(Rs, wx, A2(Zw, function(n) {
                        return n ? Al(Lg(A3(kg, eO, {
                            mj: m.mj
                        }, $g(uO)))) : CA(0);
                    }, A2(nl, function() {
                        return Ex(0);
                    }, qx("Confirm this unreversible action"))))
                ]), r);
        }
    }), fO = {
        $: 2
    }, sO = function(n) {
        return {
            $: 22,
            a: n
        };
    }, lO = function(n) {
        return {
            $: 3,
            a: n
        };
    }, dO = function(n) {
        return {
            $: 16,
            a: n
        };
    }, bO = function(n) {
        return {
            $: 25,
            a: n
        };
    }, mO = function(n) {
        return {
            $: 21,
            a: n
        };
    }, pO = function(n) {
        return {
            $: 5,
            a: n
        };
    }, vO = function(n) {
        return n ? "\u2714" : "\u2716";
    }, $O = F2(function(n, r) {
        return A2(eh, g, C([
            n(r)
        ]));
    }), gO = function(n) {
        return th({
            nW: "",
            hf: rh,
            ie: $O(n)
        });
    }, hO = F2(function(n, r) {
        var t;
        return sh({
            nW: n,
            hf: lh((t = r, A2(mu, zi, t))),
            ie: r
        });
    }), kO = F2(function(n, r) {
        return A3(ib, n, "0", Bt(r));
    }), CO = function(n) {
        switch(n){
            case 0:
                return "01";
            case 1:
                return "02";
            case 2:
                return "03";
            case 3:
                return "04";
            case 4:
                return "05";
            case 5:
                return "06";
            case 6:
                return "07";
            case 7:
                return "08";
            case 8:
                return "09";
            case 9:
                return "10";
            case 10:
                return "11";
            default:
                return "12";
        }
    }, jO = F2(function(n, r) {
        return $(A2(kO, 4, A2(fb, lb, r)), $(n, $(CO(A2(tb, lb, r)), $(n, A2(kO, 2, A2(Gd, lb, r))))));
    }), wO = function(n) {
        return A2(jO, "/", n);
    }, AO = C([
        nh("Table")
    ]), LO = function() {
        return C([
            nh("TableTr")
        ]);
    }, yO = F2(function(n, r) {
        return Ns(A2(FD, ", ", A2(Ge, function(r) {
            return A2(Qu, "", A2(Tu, function(n) {
                return n.nW;
            }, A2(Lo, r.oB, n)));
        }, r.oD)));
    }), SO = {
        $: 6
    }, FO = function(n) {
        return {
            $: 10,
            a: n
        };
    }, TO = function(n) {
        return {
            $: 11,
            a: n
        };
    }, QO = function(n) {
        return {
            $: 8,
            a: n
        };
    }, IO = function(n) {
        return {
            $: 7,
            a: n
        };
    }, BO = function(n) {
        return {
            $: 9,
            a: n
        };
    }, WO = {
        $: 19
    }, PO = function(n) {
        return {
            $: 23,
            a: n
        };
    }, MO = {
        $: 4
    }, qO = function(n) {
        return A2(Qu, !1, A2(Tu, function() {
            return !0;
        }, n.oF));
    }, DO = function(n) {
        return A2(NC, n, function(n) {
            return A2(Yh, n, A2(rk, C([
                nh("InputPassword"),
                sk(n.kT),
                qh("password"),
                $k(zh),
                bk(Nh),
                mk(Hh),
                hk(n.sa),
                gk(n.gy),
                tk(ck(n.m$)),
                nk(n.kO),
                A2(ZW, "autocomplete", "current-password")
            ]), g));
        }(n));
    }, XO = F2(function(n, r) {
        return {
            $: 18,
            a: n,
            b: r
        };
    }), EO = function(n) {
        return {
            $: 20,
            a: n
        };
    }, RO = F2(function(n, r) {
        var t = A2(Ge, function(n) {
            return d(n.a, n.b.nW);
        }, A2(xi, function(n) {
            return n.b.nW;
        }, pt(r)));
        return A2(Ge, tl, pt(A2(cl, F2(function(n, r) {
            return A2(Se, C([
                A2(gh, "position", "relative"),
                A2(gh, "margin", "25px 0")
            ]), C([
                A2(Sk, function(r) {
                    return A2(XO, r, n);
                }, A2(nj, r, t)),
                A3(lj, "remove", C([
                    d("position", "absolute"),
                    d("right", "0")
                ]), EO(n))
            ]));
        }), n.oD)));
    }), xO = function(n) {
        return A2(qC, function(r) {
            var t = qO(r) ? d("Save", "Edit user") : d("Create", "New User");
            return A4(oj, t.b, d(t.a, MO), d("Cancel", SO), $(C([
                A2(Sk, IO, VC(r.nW)),
                A2(Sk, QO, VC(r.k6)),
                qO(r) ? ch("") : A2(Sk, BO, DO(r.oN)),
                A2(Sk, FO, HC(r.iz)),
                A2(Sk, TO, HC(r.kN))
            ]), $(A2(RO, r, n.oD), C([
                A2(Dh, "Add New Organization", WO),
                A2(Dh, "Reset password", PO(r.k6.sa)),
                A2(qC, LC, n.re),
                A2(qC, AC, n.ll)
            ]))));
        }, n.kL);
    }, OO = F2(function(n, r) {
        var t, e = zi(r.ph.sa), u = A2(Bu, function(n) {
            return A2(mu, A2(mu, Me(e), zi), function(n) {
                return n.nW;
            })(n) || A2(mu, A2(mu, Me(e), zi), function(n) {
                return n.k6;
            })(n) || A2(mu, A2(mu, Me(e), zi), yO(r.oD))(n);
        }, r.dU);
        return A3(Wj, "Users", kt(A2(Dh, "New\u2026", fO)), A2(Se, g, C([
            A2(Sk, sO, kk(r.ph)),
            xO(r),
            A3(jC, (t = r.oD, ih({
                jW: C([
                    gO(A2(mu, Dh("edit"), lO)),
                    A2(hO, "Full name", function(n) {
                        return n.nW;
                    }),
                    A2(hO, "Email address", function(n) {
                        return n.k6;
                    }),
                    A2(hO, "Admin", A2(mu, vO, function(n) {
                        return n.iz;
                    })),
                    A2(hO, "Disable Organization Emails", A2(mu, vO, function(n) {
                        return n.kN;
                    })),
                    A2(hO, "Organizations", yO(t)),
                    A2(hO, "Creation date", A2(mu, A2(mu, Qu("Unknown"), Tu(wO)), function(n) {
                        return n.ke;
                    })),
                    gO(A2(mu, Dh("Log as"), dO)),
                    gO(A2(mu, Dh("Delete"), pO)),
                    gO(A2(mu, Dh("Revoke"), bO))
                ]),
                kr: p(wh, {
                    pC: LO,
                    rj: AO,
                    rv: C([
                        nh("TableTd")
                    ])
                }),
                rE: function(n) {
                    return n.mj;
                },
                rF: mO
            })), r.rs, u)
        ])));
    }), zO = {
        l: function(n) {
            return n.dU;
        },
        m: hx,
        p: F2(function(n, r) {
            return p(n, {
                dU: r
            });
        }),
        q: function(n) {
            return {
                $: 4,
                a: n
            };
        },
        r: cO,
        s: OO
    }, NO = {
        kL: Ct,
        ll: Ct,
        oD: g,
        re: Ct,
        rs: k$("Organization"),
        dZ: g
    }, HO = function(n) {
        return {
            $: 0,
            a: n
        };
    }, VO = Al(A2(_s, J$, Vs(K$))), UO = F5(function(n, r, t, e, u) {
        return {
            iq: e,
            ln: t,
            mj: n,
            oz: r,
            oK: u
        };
    }), JO = function(n) {
        switch(n){
            case "ShowCreation":
                return yt(0);
            case "ProxyReady":
                return yt(1);
            case "FileQualified":
                return yt(2);
            case "FileDownload":
                return yt(3);
            case "VersionAccepted":
                return yt(4);
            case "VersionRejected":
                return yt(5);
            case "InvitationAdded":
                return yt(6);
            case "InvitationUpdated":
                return yt(7);
            case "InvitationRemoved":
                return yt(8);
            case "UploaderAdded":
                return yt(9);
            case "UploaderRemoved":
                return yt(10);
            case "UploadFinished":
                return yt(11);
            case "QCFinished":
                return yt(12);
            default:
                return jt("Can't parse webhook event " + n);
        }
    }, ZO = function(n) {
        switch(n){
            case 0:
                return "ShowCreation";
            case 1:
                return "ProxyReady";
            case 2:
                return "FileQualified";
            case 3:
                return "FileDownload";
            case 4:
                return "VersionAccepted";
            case 5:
                return "VersionRejected";
            case 6:
                return "InvitationAdded";
            case 7:
                return "InvitationUpdated";
            case 8:
                return "InvitationRemoved";
            case 9:
                return "UploaderAdded";
            case 10:
                return "UploaderRemoved";
            case 11:
                return "UploadFinished";
            default:
                return "QCFinished";
        }
    }, KO = A2(zl, ZO, JO), _O = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), GO = function(n) {
        return {
            $: 1,
            a: n
        };
    }, YO = function(n) {
        switch(n){
            case "Json":
                return yt(0);
            case "SaltoMam":
                return yt(1);
            case "SaltoContent":
                return yt(2);
            case "ADN":
                return yt(3);
            default:
                return jt("Can't parse api call format " + n);
        }
    }, nz = A2(we, function(n) {
        var r = YO(n);
        return r.$ ? xo(r.a) : Qe(r.a);
    }, Bi), rz = function(n) {
        switch(n){
            case "Manager":
                return yt(0);
            case "Uploader":
                return yt(1);
            case "EventSpecified":
                return yt(2);
            default:
                return jt("Can't parse email target " + n);
        }
    }, tz = A2(we, function(n) {
        var r = rz(n);
        return r.$ ? xo(r.a) : Qe(r.a);
    }, Bi), ez = on, uz = A2(we, function(n) {
        var r = n.a, t = n.b, e = t.a, u = d(r, b(e, t.b, t.c));
        n: for(;;){
            if (u.b.a.$) {
                if ("Email" !== u.a || 1 !== u.b.b.$ || u.b.c.$) break n;
                return Qe(GO(u.b.c.a));
            }
            if ("ApiCall" !== u.a || u.b.b.$ || 1 !== u.b.c.$) break n;
            var a = u.b;
            return Qe(A2(_O, a.a.a, a.b.a));
        }
        return xo("Can't decode webhook params with kind " + r + " and url " + A2(Qu, "", e));
    }, A5(ez, F4(function(n, r, t, e) {
        return d(n, b(r, t, e));
    }), A2(du, "kind", Bi), gb(A2(du, "url", Bi)), gb(A2(du, "format", nz)), gb(A2(du, "target", tz)))), az = function(n) {
        switch(n){
            case 0:
                return "Json";
            case 1:
                return "SaltoMam";
            case 2:
                return "SaltoContent";
            default:
                return "ADN";
        }
    }, iz = function(n) {
        return gi(az(n));
    }, oz = function(n) {
        switch(n){
            case 0:
                return "Manager";
            case 1:
                return "Uploader";
            default:
                return "EventSpecified";
        }
    }, cz = function(n) {
        return gi(oz(n));
    }, fz = ul(A4(ll, "params", function(n) {
        return n.oK;
    }, A2(qi, function(n) {
        if (n.$) {
            var r = n.a;
            return $i(C([
                d("kind", gi("Email")),
                d("target", cz(r))
            ]));
        }
        var t = n.a, e = n.b;
        return $i(C([
            d("kind", gi("ApiCall")),
            d("url", gi(t)),
            d("format", iz(e))
        ]));
    }, uz), A4(ll, "activated", function(n) {
        return n.iq;
    }, Zi, A4(ll, "event", function(n) {
        return n.ln;
    }, KO, A4(ll, "organization", function(n) {
        return n.oz;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(UO))))))), sz = $l(fz), lz = function(n) {
        return {
            $: 8,
            a: n
        };
    }, dz = xs(lz({
        $: 0
    })), bz = Al(A2(_s, sz, Vs(dz))), mz = A2(Rs, HO, mp(d(bz, VO))), pz = d(NO, mz), vz = F2(function(n, r) {
        return p(r, {
            ll: kt(n.nE),
            re: Ct
        });
    }), $z = function(n) {
        return {
            $: 12,
            a: n
        };
    }, gz = F2(function(n, r) {
        return r.$ ? jt(r.a) : n(r.a);
    }), hz = F5(function(n, r, t, e, u) {
        return {
            iq: t,
            ln: r,
            lP: u,
            oz: n,
            r6: e
        };
    }), kz = ul(A4(ll, "format", function(n) {
        return n.lP;
    }, A2(zl, az, YO), A4(ll, "url", function(n) {
        return n.r6;
    }, Di, A4(ll, "activated", function(n) {
        return n.iq;
    }, Zi, A4(ll, "event", function(n) {
        return n.ln;
    }, KO, A4(ll, "organization", function(n) {
        return n.oz;
    }, Di, gl(hz))))))), Cz = F4(function(n, r, t, e) {
        return {
            iq: t,
            ln: r,
            oz: n,
            ru: e
        };
    }), jz = ul(A4(ll, "target", function(n) {
        return n.ru;
    }, A2(zl, oz, rz), A4(ll, "activated", function(n) {
        return n.iq;
    }, Zi, A4(ll, "event", function(n) {
        return n.ln;
    }, KO, A4(ll, "organization", function(n) {
        return n.oz;
    }, Di, gl(Cz)))))), wz = xs(lz({
        $: 1
    })), Az = xs(lz({
        $: 3
    })), Lz = function(n) {
        var r, t;
        return A2(Rs, $z, (t = JO((r = n).ln.sa), A2(Zw, function(n) {
            return Al(A2(vg, fz, n));
        }, KS(A2(hi, function(n) {
            return JS(A2(ki, n, L$));
        }, A2(gz, function(n) {
            return function(n) {
                switch(r.c9.sa){
                    case "api":
                        return A2(dg, function(t) {
                            return A3(kg, kz, {
                                iq: r.iq.sa,
                                ln: n,
                                lP: t,
                                oz: r.oz.sa,
                                r6: r.r6.sa
                            }, $g(wz));
                        }, YO(r.lP.sa));
                    case "email":
                        return A2(dg, function(t) {
                            return A3(kg, jz, {
                                iq: r.iq.sa,
                                ln: n,
                                oz: r.oz.sa,
                                ru: t
                            }, $g(Az));
                        }, rz(r.ru.sa));
                    default:
                        return jt("Can't parse kind from form");
                }
            }(n);
        }, t))))));
    }, yz = function(n) {
        return {
            $: 15,
            a: n
        };
    }, Sz = function(n) {
        return xs(lz(function(n) {
            return {
                $: 2,
                a: n
            };
        }(n)));
    }, Fz = function(n) {
        return xs(lz(function(n) {
            return {
                $: 4,
                a: n
            };
        }(n)));
    }, Tz = function(n) {
        return {
            $: 13,
            a: n
        };
    }, Qz = F2(function(n, r) {
        var t = JO(r.ln.sa);
        return A2(Zw, function(n) {
            return Al(A2(_s, fz, n));
        }, KS(A2(hi, function(n) {
            return JS(A2(ki, n, L$));
        }, A2(gz, function(t) {
            return function(t) {
                return n.oK.$ ? A2(dg, function(e) {
                    return A3(kg, jz, {
                        iq: r.iq.sa,
                        ln: t,
                        oz: r.oz.sa,
                        ru: e
                    }, Sg(Fz(n.mj)));
                }, rz(r.ru.sa)) : A2(dg, function(e) {
                    return A3(kg, kz, {
                        iq: r.iq.sa,
                        ln: t,
                        lP: e,
                        oz: r.oz.sa,
                        r6: r.r6.sa
                    }, Sg(Sz(n.mj)));
                }, YO(r.lP.sa));
            }(t);
        }, t))));
    }), Iz = F2(function(n, r) {
        return A2(Rs, Tz, A2(Qz, n, r));
    }), Bz = function(n) {
        var r = function(n) {
            return A2(Po, Tu(n), Qu(""));
        };
        return {
            iq: Ki(function(r) {
                return p(r, {
                    m$: "Activ\xe9",
                    sa: A2(Qu, !0, A2(Tu, function(n) {
                        return n.iq;
                    }, n))
                });
            }),
            ln: Xi(function(t) {
                return p(t, {
                    m$: "\xc9v\xe9nement",
                    sa: A2(r, function(n) {
                        return ZO(n.ln);
                    }, n)
                });
            }),
            lP: Xi(function(t) {
                return p(t, {
                    m$: "Format",
                    sa: A2(r, function(n) {
                        var r = n.oK;
                        return r.$ ? "" : az(r.b);
                    }, n)
                });
            }),
            c9: Xi(function(t) {
                return p(t, {
                    m$: "Type",
                    sa: A2(r, function(n) {
                        return n.oK.$ ? "email" : "api";
                    }, n)
                });
            }),
            oz: Xi(function(t) {
                return p(t, {
                    m$: "Organization",
                    sa: A2(r, function(n) {
                        return n.oz;
                    }, n)
                });
            }),
            oF: n,
            ru: Xi(function(t) {
                return p(t, {
                    m$: "Cible",
                    sa: A2(r, function(n) {
                        var r = n.oK;
                        return r.$ ? oz(r.a) : "";
                    }, n)
                });
            }),
            r6: Xi(function(t) {
                return p(t, {
                    m$: "Url",
                    sa: A2(r, function(n) {
                        var r = n.oK;
                        return r.$ ? "" : r.a;
                    }, n)
                });
            })
        };
    }, Wz = F2(function(n, r) {
        switch(n.$){
            case 2:
                return A2(eo, g, p(r, {
                    kL: kt(Bz(kt(n.a)))
                }));
            case 1:
                return A2(eo, g, p(r, {
                    kL: kt(Bz(Ct))
                }));
            case 3:
                return A2(eo, g, p(r, {
                    kL: Ct,
                    ll: Ct,
                    re: Ct
                }));
            case 4:
                var t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        oz: A2(Wg, t, n.oz)
                    });
                }, r.kL);
                return A2(eo, g, p(r, {
                    kL: e
                }));
            case 5:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        ln: A2(Wg, t, n.ln)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 6:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        iq: A2(Ig, t, n.iq)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 7:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        c9: A2(Wg, t, n.c9)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 8:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        r6: A2(Wg, t, n.r6)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 9:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        lP: A2(Wg, t, n.lP)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 10:
                return t = n.a, e = A2(Tu, function(n) {
                    return p(n, {
                        ru: A2(Wg, t, n.ru)
                    });
                }, r.kL), A2(eo, g, p(r, {
                    kL: e
                }));
            case 11:
                var u = r.kL;
                return A2(eo, C(1 === u.$ ? [
                    p$
                ] : 1 === (c = (e = u.a).oF).$ ? [
                    Lz(e)
                ] : [
                    A2(Iz, c.a, e)
                ]), r);
            case 14:
                return A2(eo, C([
                    (o = n.a, A2(Rs, yz, function(n) {
                        var r = n.oK.$ ? Fz : Sz;
                        return A2(bp, Hl(n), Al(Lg(Ag(r(n.mj)))));
                    }(o)))
                ]), r);
            case 12:
                return (a = n.a).$ ? A2(eo, g, A2(vz, a.a, r)) : A2(eo, C([
                    mz
                ]), p(r, {
                    ll: Ct,
                    re: kt("webhook created")
                }));
            case 13:
                return (a = n.a).$ ? A2(eo, g, A2(vz, a.a, r)) : A2(eo, C([
                    mz
                ]), p(r, {
                    ll: Ct,
                    re: kt("webhook updated")
                }));
            case 15:
                return (a = n.a).$ ? A2(eo, g, A2(vz, a.a, r)) : A2(eo, C([
                    mz
                ]), r);
            case 0:
                var a;
                if ((a = n.a).$) return A2(eo, g, A2(vz, a.a, r));
                var i = a.a;
                return A2(eo, g, p(r, {
                    oD: i.b,
                    dZ: i.a
                }));
            default:
                return A2(eo, g, p(r, {
                    rs: n.a
                }));
        }
        var o, c;
    }), Pz = {
        $: 1
    }, Mz = function(n) {
        return {
            $: 16,
            a: n
        };
    }, qz = F2(function(n, r) {
        return A2(eh, g, C([
            n(r)
        ]));
    }), Dz = F2(function(n, r) {
        return th({
            nW: n,
            hf: rh,
            ie: qz(r)
        });
    }), Xz = F2(function(n, r) {
        var t;
        return sh({
            nW: n,
            hf: lh((t = r, A2(mu, zi, t))),
            ie: r
        });
    }), Ez = C([
        nh("Table")
    ]), Rz = function() {
        return C([
            nh("TableTr")
        ]);
    }, xz = function(n) {
        var r = n.oK;
        return r.$ ? "" : az(r.b);
    }, Oz = F2(function(n, r) {
        return A2(Qu, "", A2(Tu, function(n) {
            return n.nW;
        }, Ra(A2(Bu, function(n) {
            return i(n.mj, r.oz);
        }, n))));
    }), zz = function(n) {
        var r = n.oK;
        return r.$ ? oz(r.a) : "";
    }, Nz = function(n) {
        return n.oK.$ ? "Email" : "ApiCall";
    }, Hz = function(n) {
        var r = n.oK;
        return r.$ ? "" : r.a;
    }, Vz = {
        $: 3
    }, Uz = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Jz = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Zz = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Kz = function(n) {
        return {
            $: 7,
            a: n
        };
    }, _z = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Gz = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Yz = function(n) {
        return {
            $: 8,
            a: n
        };
    }, nN = {
        $: 11
    }, rN = function(n) {
        return 1 !== n.oF.$;
    }, tN = function(n) {
        return A2(qC, function(r) {
            var t = C([
                d("", ""),
                d(ZO(0), ZO(0)),
                d(ZO(1), ZO(1)),
                d(ZO(2), ZO(2)),
                d(ZO(3), ZO(3)),
                d(ZO(4), ZO(4)),
                d(ZO(5), ZO(5)),
                d(ZO(6), ZO(6)),
                d(ZO(7), ZO(7)),
                d(ZO(8), ZO(8)),
                d(ZO(9), ZO(9)),
                d(ZO(10), ZO(10)),
                d(ZO(11), ZO(11)),
                d(ZO(12), ZO(12))
            ]), e = A2(bt, d("", ""), A2(Ge, function(n) {
                return d(n.mj, n.nW);
            }, n.oD)), u = C([
                d("", ""),
                d("api", "Call Api"),
                d("email", "Email")
            ]), a = r.c9, i = C([
                d("", ""),
                d(oz(0), oz(0)),
                d(oz(1), oz(1)),
                d(oz(2), oz(2))
            ]), o = C([
                d("", ""),
                d(az(0), az(0)),
                d(az(1), az(1)),
                d(az(2), az(2)),
                d(az(3), az(3))
            ]), c = function() {
                switch(r.c9.sa){
                    case "api":
                        return C([
                            A2(Sk, Yz, VC(r.r6)),
                            A2(Sk, Zz, A2(rj, r.lP, o))
                        ]);
                    case "email":
                        return C([
                            A2(Sk, Gz, A2(rj, r.ru, i))
                        ]);
                    default:
                        return g;
                }
            }(), f = rN(r) ? d("Save", "Edit Webhook") : d("Create", "New Webhook");
            return A4(oj, f.b, d(f.a, nN), d("Cancel", Vz), $(C([
                A2(Sk, _z, A2(qw, e, rj(r.oz))),
                A2(Sk, Jz, A2(rj, r.ln, t)),
                A2(Sk, Uz, HC(r.iq)),
                A2(Sk, Kz, A2(rj, p(a, {
                    kO: rN(r)
                }), u))
            ]), c));
        }, n.kL);
    }, eN = F2(function(n, r) {
        var t;
        return A3(Wj, "Organizations", kt(A2(Dh, "New\u2026", Pz)), A2(Se, g, C([
            tN(r),
            A3(jC, (t = r.oD, ih({
                jW: C([
                    A2(Dz, "Edit", function(n) {
                        return A2(Dh, "Edit", function(n) {
                            return {
                                $: 2,
                                a: n
                            };
                        }(n));
                    }),
                    A2(Xz, "Organization", Oz(t)),
                    A2(Xz, "Event", A2(mu, ZO, function(n) {
                        return n.ln;
                    })),
                    A2(Dz, "Icon", function(n) {
                        return n.iq ? Xh : Ph;
                    }),
                    A2(Xz, "Type", Nz),
                    A2(Xz, "Url", Hz),
                    A2(Xz, "Format", xz),
                    A2(Xz, "Target", zz),
                    A2(Dz, "Delete", function(n) {
                        return A2(Kg, Wh, function(n) {
                            return {
                                $: 14,
                                a: n
                            };
                        }(n));
                    })
                ]),
                kr: p(wh, {
                    pC: Rz,
                    rj: Ez,
                    rv: C([
                        nh("TableTd")
                    ])
                }),
                rE: function(n) {
                    return n.mj;
                },
                rF: Mz
            })), r.rs, r.dZ)
        ])));
    }), uN = {
        l: function(n) {
            return n.dZ;
        },
        m: pz,
        p: F2(function(n, r) {
            return p(n, {
                dZ: r
            });
        }),
        q: function(n) {
            return {
                $: 10,
                a: n
            };
        },
        r: Wz,
        s: eN
    }, aN = F3(function(n, r, t) {
        var e = A4(eD, ro, t.oJ, n, r), u = A4(uD, ro, t.oJ, n, r), a = function() {
            switch(r.$){
                case 0:
                    return u(VQ);
                case 1:
                    return u(HM);
                case 2:
                    return u(WW);
                case 3:
                    return u(zO);
                case 4:
                    return u(bx);
                case 5:
                    return u(dE);
                case 6:
                    return u(Mj);
                case 7:
                    return u(Ew);
                case 8:
                    return u(tD);
                case 9:
                    return u(uN);
                case 10:
                    return u(YW);
                case 11:
                    return u(QQ);
                case 12:
                    return u(UX);
                case 13:
                    return u(fX);
                case 14:
                    return A2(e, yI, (n = r.a, to(C([
                        A2(Qu, A2(b$, Hl(SI), CA(0)), A2(Tu, function(n) {
                            return WI(n);
                        }, n.oz)),
                        PI(n)
                    ]))));
                case 15:
                    return u(XB);
                case 16:
                    return u(by);
                case 17:
                    return u(Qq);
                default:
                    return A2(e, aL, wA(r.a));
            }
            var n;
        }(), i = a.a;
        return A2(eo, C([
            A2(wp, Be, a.b)
        ]), p(t, {
            oJ: i
        }));
    }), iN = function(n) {
        return {
            $: 1,
            a: n
        };
    }, oN = F2(function(n, r) {
        return {
            eq: r,
            rB: n
        };
    }), cN = function(n) {
        return {
            $: 0,
            a: n
        };
    }, fN = function(n) {
        return {
            $: 1,
            a: n
        };
    }, sN = function(n) {
        return {
            $: 2,
            a: n
        };
    }, lN = function(n) {
        return {
            $: 3,
            a: n
        };
    }, dN = function(n) {
        return {
            $: 4,
            a: n
        };
    }, bN = function(n) {
        return {
            $: 5,
            a: n
        };
    }, mN = function(n) {
        return {
            $: 7,
            a: n
        };
    }, pN = function(n) {
        return {
            $: 6,
            a: n
        };
    }, vN = function(n) {
        return {
            $: 8,
            a: n
        };
    }, $N = F3(function(n, r, t) {
        return {
            m$: t,
            ho: r,
            cs: n
        };
    }), gN = F3(function(n, r, t) {
        return {
            e6: r,
            hn: t,
            ht: n
        };
    }), hN = Te(ce), kN = {
        $: 0
    }, CN = function(n) {
        return {
            $: 2,
            a: n
        };
    }, jN = {
        $: 1
    }, wN = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), AN = function(n) {
        return {
            $: 1,
            a: n
        };
    }, LN = F5(function(n, r, t, e, u) {
        return {
            mj: n,
            fY: u,
            hd: t,
            rt: e,
            h8: r
        };
    }), yN = function(n) {
        return {
            $: 5,
            c: n
        };
    }, SN = F3(function(n, r, t) {
        return A2(we, function(e) {
            var u = A2(bi, n, e);
            if (u.$) return Qe(t);
            var a = u.a, i = A2(bi, $b(C([
                r,
                yN(t)
            ])), a);
            return i.$ ? xo(Kt(i.a)) : Qe(i.a);
        }, Qi);
    }), FN = F4(function(n, r, t, e) {
        return A2(hN, A3(SN, A2(du, n, Qi), r, t), e);
    }), TN = F3(function(n, r, t) {
        return A2(hN, A2(du, n, r), t);
    }), QN = A3(TN, "type", Bi, A3(TN, "tags", pl(Bi), A3(TN, "slug", Bi, A4(FN, "uid", gb(Bi), Ct, A3(TN, "id", Bi, Qe(LN)))))), IN = F3(function(n, r, t) {
        return A2(hN, A2(lk, n, r), t);
    }), BN = A2(we, function(n) {
        switch(n){
            case "Document":
                return A3(IN, C([
                    "isBroken"
                ]), Ae, A3(IN, g, QN, Qe(wN)));
            case "Web":
                return A3(IN, C([
                    "url"
                ]), Bi, Qe(AN));
            default:
                return xo("Unknown link type: " + n);
        }
    }, A2(du, "link_type", Bi)), WN = A2(hN, A2(we, function(n) {
        switch(n){
            case "em":
                return Qe(kN);
            case "strong":
                return Qe(jN);
            case "hyperlink":
                return A2(Fe, CN, A2(du, "data", BN));
            default:
                return xo("Unknown span type: " + n);
        }
    }, A2(du, "type", Bi)), A3(TN, "end", dl, A3(TN, "start", dl, Qe(gN)))), PN = A4(FN, "label", gb(Bi), Ct, A3(TN, "spans", pl(WN), A3(TN, "text", Bi, Qe($N)))), MN = F4(function(n, r, t, e) {
        return {
            iJ: n,
            j9: r,
            kM: e,
            r6: t
        };
    }), qN = function(n) {
        return $b(C([
            yN(Ct),
            A2(Fe, kt, n)
        ]));
    }, DN = A3(TN, "dimensions", A3(TN, "height", dl, A3(TN, "width", dl, Qe(F2(function(n, r) {
        return {
            ft: r,
            ih: n
        };
    })))), A3(TN, "url", Bi, A3(TN, "copyright", qN(Bi), A3(TN, "alt", qN(Bi), Qe(MN))))), XN = A2(Fe, Be, pl(A2(we, function(n) {
        switch(n){
            case "heading1":
                return A2(Fe, cN, PN);
            case "heading2":
                return A2(Fe, fN, PN);
            case "heading3":
                return A2(Fe, sN, PN);
            case "heading4":
                return A2(Fe, lN, PN);
            case "heading5":
                return A2(Fe, dN, PN);
            case "heading6":
                return A2(Fe, bN, PN);
            case "paragraph":
                return A2(Fe, pN, PN);
            case "list-item":
                return A2(Fe, mN, PN);
            case "image":
                return A2(Fe, vN, DN);
            default:
                return xo("Unknown structured field type: " + n);
        }
    }, A2(du, "type", Bi)))), EN = A2(du, "results", A2(Oo, 0, A2(du, "data", A3(Te, oN, A2(du, "title", A2(Oo, 0, A2(du, "text", Bi))), A2(du, "body", XN))))), RN = F5(function(n, r, t, e, u) {
        return "" === n ? p$ : $c({
            cX: A2(Ro, u, e),
            r6: gc + "/documents/search?ref=" + n + "&q=%5B%5Bat%28my." + r + ".uid%2C%20%22" + t + "%22%29%5D%5D&lang=*"
        });
    }), xN = F5(function(n, r, t, e, u) {
        if ("" === n) return p$;
        var a = Pi({
            bQ: "en-GB",
            bX: "fr-FR"
        });
        return $c({
            cX: A2(Ro, u, e),
            r6: gc + "/documents/search?ref=" + n + "&q=%5B%5Bat%28my." + r + ".uid%2C%20%22" + t + "%22%29%5D%5D&lang=" + a
        });
    }), ON = F2(function(n, r) {
        return "table" === r ? A5(xN, n, "help", "table", EN, iN) : A5(RN, n, "help", r, EN, iN);
    }), zN = F2(function(n, r) {
        return A2(eo, C([
            A2(ON, r.f1, n)
        ]), p(r, {
            ce: kt(n)
        }));
    }), NN = F3(function(n, r, t) {
        switch(r.$){
            case 1:
                var e = r.b, u = r.c;
                if (i(kt(c = r.a), Ev(t)) && !n) {
                    var a = p(o = t.g9, {
                        iY: e,
                        oK: u
                    });
                    return Xv(A2(eo, g, p(t, {
                        eu: A2(g$, c, t.eu),
                        g9: a
                    })));
                }
                var o = qs(t.al);
                return Xv(A2(eo, C([
                    A2(wp, Pv(c), m$)
                ]), p(t, {
                    eu: A2(g$, c, t.eu),
                    g9: p(o, {
                        iY: e,
                        mj: c,
                        oK: u
                    })
                })));
            case 2:
                var c;
                if (e = r.b, i(kt(c = r.a), Ev(t)) && !n) {
                    var f = p(t.n8, {
                        iY: e
                    });
                    return A2(eo, g, p(t, {
                        eu: A2(g$, c, t.eu),
                        n8: f
                    }));
                }
                var s = s$(c), l = Mc;
                return A2(eo, C([
                    A2(wp, Wv, s)
                ]), p(t, {
                    eu: A2(g$, c, t.eu),
                    n8: p(l, {
                        iY: e,
                        mj: c
                    })
                }));
            case 4:
                var b = t.al, m = A3(aN, t.al, r.a, t.iz), v = m.a;
                return A2(eo, C([
                    A2(wp, wi, m.b)
                ]), p(t, {
                    iz: v,
                    al: p(b, {
                        ea: !1
                    })
                }));
            case 5:
                var $ = A2(zN, r.a, t.l2);
                return v = $.a, A2(eo, C([
                    A2(wp, Li, $.b)
                ]), p(t, {
                    l2: v
                }));
            case 6:
                return d(v = p(t, {
                    al: p(b = t.al, {
                        ea: !0
                    })
                }), p$);
            case 0:
                return d(v = p(t, {
                    al: p(b = t.al, {
                        ea: !1
                    })
                }), p$);
            default:
                return A2(eo, g, t);
        }
    }), HN = F2(function(n, r) {
        var t = Bv(n.r6), e = A3(ao, n, r, t), u = xm.a, a = xm.b, i = hc.a, o = hc.b, c = uo.b, f = {
            iz: uo.a,
            eu: fo(e),
            al: e,
            kY: qc,
            ll: Ct,
            l2: i,
            mO: !0,
            n8: Mc,
            cj: Ni(e.r8),
            pW: so,
            dz: A2(no, r, n.sd),
            g9: qs(e),
            rA: u,
            r$: mo(e.r8)
        }, s = A3(NN, !0, t, f), l = s.a;
        return A2(eo, C([
            A2(wp, Si, s.b),
            A2(wp, A2(mu, Si, Fi), a),
            A2(wp, A2(mu, Si, wi), c),
            A2(wp, A2(mu, Si, Li), o),
            A2(wp, A2(mu, Si, Ai), jp)
        ]), yi(l));
    }), VN = function(n) {
        return {
            $: 1,
            a: n
        };
    }, UN = function(n) {
        return {
            $: 3,
            a: n
        };
    }, JN = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ZN = function(n) {
        return {
            $: 2,
            a: n
        };
    }, KN = {
        $: 0
    }, _N = {
        k6: Xi(function(n) {
            return p(n, {
                m$: "Email"
            });
        }),
        nE: KN
    }, GN = Pi({
        bQ: "Confirm your password",
        bX: "Confirmez votre mot de passe"
    }), YN = Pi({
        bQ: "Last & First Name",
        bX: "Nom & Pr\xe9nom"
    }), nH = Pi({
        bQ: "Create your password",
        bX: "Cr\xe9ez votre mot de passe"
    }), rH = {
        $: 0
    }, tH = Pi({
        bQ: "Email",
        bX: "Email"
    }), eH = Pi({
        bQ: "Password",
        bX: "Mot de passe"
    }), uH = function(n) {
        var r = n.lV;
        return {
            k6: Xi(function(n) {
                return p(n, {
                    m$: tH
                });
            }),
            lV: r,
            nE: rH,
            oN: Xi(function(n) {
                return p(n, {
                    kT: "inputLoginPassword",
                    m$: eH
                });
            }),
            qJ: 0,
            qK: Ct
        };
    }, aH = {
        $: 0
    }, iH = Pi({
        bQ: "Password confirmation",
        bX: "Confirmation du mot de passe"
    }), oH = Pi({
        bQ: "Password",
        bX: "Mot de passe"
    }), cH = function(n) {
        var r = Bv(n), t = function() {
            if (3 !== r.$) return JN(uH({
                lV: Ct
            }));
            switch(r.a.$){
                case 1:
                    return VN(_N);
                case 2:
                    return ZN((e = (t = r.a.a).k6, u = t.rH, {
                        j1: Xi(function(n) {
                            return p(n, {
                                m$: iH
                            });
                        }),
                        k6: e,
                        nE: aH,
                        oN: Xi(function(n) {
                            return p(n, {
                                m$: oH
                            });
                        }),
                        oO: Ct,
                        rH: u
                    }));
                case 3:
                    return UN((n = r.a.a, {
                        j1: Xi(function(n) {
                            return p(n, {
                                m$: GN
                            });
                        }),
                        k6: n.k6,
                        ll: Ct,
                        nW: Xi(function(n) {
                            return p(n, {
                                m$: YN
                            });
                        }),
                        oN: Xi(function(n) {
                            return p(n, {
                                m$: nH
                            });
                        }),
                        oO: Ct,
                        pl: n.pl,
                        rH: n.rH
                    }));
                default:
                    return JN(uH(r.a.a));
            }
            var n, t, e, u;
        }();
        return d(r, t);
    }, fH = function(n) {
        return {
            $: 4,
            a: n
        };
    }, sH = function(n) {
        return {
            $: 1,
            a: n
        };
    }, lH = Nn, dH = _n("newurl", Bi), bH = function(n) {
        return {
            $: 15,
            a: n
        };
    }, mH = function(n) {
        return {
            $: 0,
            a: n
        };
    }, pH = function(n) {
        return {
            $: 13,
            a: n
        };
    }, vH = function(n) {
        return {
            $: 3,
            a: n
        };
    }, $H = function(n) {
        return {
            $: 9,
            a: n
        };
    }, gH = zn, hH = gH(g), kH = _n("onKeypressNoInput", dl), CH = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), jH = F2(function(n, r) {
        return {
            gx: r,
            hD: n
        };
    }), wH = Je(A2(jH, g, Lu)), AH = function(n) {
        return d($(n.a ? "w_" : "d_", n.b), n);
    }, LH = F6(function(n, r, t, e, u, a) {
        var i = A3(ug, F3(function(e, u, a) {
            n: for(;;){
                var i = a.a, o = a.b;
                if (i.b) {
                    var c = i.a, f = c.a, l = c.b, b = i.b;
                    if (0 > s(f, e)) {
                        a = d(b, A3(n, f, l, o));
                        continue n;
                    }
                    return s(f, e) > 0 ? d(i, A3(t, e, u, o)) : d(b, A4(r, f, l, u, o));
                }
                return d(i, A3(t, e, u, o));
            }
        }), d(pt(e), a), u), o = i.a, c = i.b;
        return A3(qt, F2(function(r, t) {
            return A3(n, r.a, r.b, t);
        }), c, o);
    }), yH = F2(function(n, r) {
        return {
            ln: r,
            fR: n
        };
    }), SH = F3(function(n, r, t) {
        return A2(nu, function(n) {
            return d(r, n);
        }, A3(_r, t.a ? Kr : Zr, t.b, function(t) {
            return A2(Ao, n, A2(yH, r, t));
        }));
    }), FH = F2(function(n, r) {
        return A3(ug, ju, r, n);
    }), TH = F3(function(n, r, t) {
        var e = F3(function(r, t, e) {
            var u = e.c;
            return b(e.a, e.b, A2(bt, A3(SH, n, r, t), u));
        }), u = F3(function(n, r, t) {
            var e = t.b, u = t.c;
            return b(A2(bt, r, t.a), e, u);
        }), a = F4(function(n, r, t, e) {
            var u = e.c;
            return b(e.a, A3(ju, n, r, e.b), u);
        }), i = A2(Ge, AH, r), o = A6(LH, u, a, e, t.gx, il(i), b(g, Lu, g)), c = o.b, f = o.c;
        return A2(Ye, function(n) {
            return Je(A2(jH, i, A2(FH, c, il(n))));
        }, A2(Ye, function() {
            return tu(f);
        }, tu(A2(Ge, Zo, o.a))));
    }), QH = F3(function(n, r, t) {
        var e = r.fR, u = r.ln, a = A2(nc, function(n) {
            var r = n.b.c;
            return i(n.a, e) ? A2(Gr, r, u) : Ct;
        }, t.hD);
        return A2(Ye, function() {
            return Je(t);
        }, tu(A2(Ge, eu(n), a)));
    }), IH = F2(function(n, r) {
        return A3(CH, r.a, r.b, A2(Fe, n, r.c));
    });
    Dn["Browser.Events"] = Xn(wH, TH, QH, 0, IH);
    var BH = On("Browser.Events"), WH = F3(function(n, r, t) {
        return BH(A3(CH, n, r, t));
    }), PH = F2(function(n, r) {
        return n(r ? 1 : 0);
    }), MH = {
        $: 5
    }, qH = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), DH = F2(function(n, r) {
        return {
            gE: r,
            hO: n
        };
    }), XH = Je(A2(DH, Lu, Lu)), EH = F2(function(n, r) {
        var t = n.a, e = n.b, u = A2(Lo, t, r);
        return A3(ju, t, 1 === u.$ ? C([
            e
        ]) : A2(bt, e, u.a), r);
    }), RH = ot, xH = F3(function(n, r, t) {
        if (r.b) {
            var e = r.a, u = r.b, a = Ko(A2(RH, e, A2(Ao, n, e)));
            return A2(Ye, function(r) {
                return A3(xH, n, u, A3(ju, e, r, t));
            }, a);
        }
        return Je(t);
    }), OH = F3(function(n, r, t) {
        var e = t.gE, u = F3(function(n, r, t) {
            var e = t.c;
            return b(t.a, t.b, A2(Ye, function() {
                return e;
            }, Zo(r)));
        }), a = A3(qt, EH, Lu, r), i = A6(LH, F3(function(n, r, t) {
            var e = t.b, u = t.c;
            return b(A2(bt, n, t.a), e, u);
        }), F4(function(n, r, t, e) {
            var u = e.c;
            return b(e.a, A3(ju, n, t, e.b), u);
        }), u, a, e, b(g, Lu, Je(0))), o = i.a, c = i.b;
        return A2(Ye, function(n) {
            return Je(A2(DH, a, n));
        }, A2(Ye, function() {
            return A3(xH, n, o, c);
        }, i.c));
    }), zH = F3(function(n, r, t) {
        var e = A2(Lo, r, t.hO);
        if (1 === e.$) return Je(t);
        var u = e.a, a = function(r) {
            return tu(A2(Ge, function(t) {
                return A2(eu, n, t(r));
            }, u));
        };
        return A2(Ye, function() {
            return Je(t);
        }, A2(Ye, a, d$));
    }), NH = F2(function(n, r) {
        return A2(qH, r.a, A2(mu, n, r.b));
    });
    Dn.Time = Xn(XH, OH, zH, 0, NH);
    var HH, VH, UH, JH, ZH, KH, _H, GH, YH, nV, rV = On("Time"), tV = F2(function(n, r) {
        return rV(A2(qH, n, r));
    }), eV = function(n) {
        return {
            $: 0,
            a: n
        };
    }, uV = function(n) {
        return 1 === n.dO.$ ? hH : A2(tV, 1e3, eV);
    }, aV = function(n) {
        return gH(C([
            A2(tV, 5e3, Hl(MH)),
            A2(lH, FR, uV(n.iC))
        ]));
    }, iV = function(n) {
        return {
            $: 2,
            a: n
        };
    }, oV = function(n) {
        return {
            $: 1,
            a: n
        };
    }, cV = function(n) {
        return {
            $: 6,
            a: n
        };
    }, fV = function(n) {
        return {
            $: 4,
            a: n
        };
    }, sV = function(n) {
        return {
            $: 0,
            a: n
        };
    }, lV = function(n) {
        return {
            $: 5,
            a: n
        };
    }, dV = function(n) {
        return {
            $: 10,
            a: n
        };
    }, bV = {
        $: 11
    }, mV = function(n) {
        return {
            $: 8,
            a: n
        };
    }, pV = function(n) {
        return {
            $: 7,
            a: n
        };
    }, vV = function(n) {
        return {
            $: 2,
            a: n
        };
    }, $V = function(n) {
        return {
            $: 9,
            a: n
        };
    }, gV = function(n) {
        return {
            $: 1,
            a: n
        };
    }, hV = function(n) {
        return {
            $: 3,
            a: n
        };
    }, kV = A2(TN, "fileId", Bi), CV = kV(Qe(function(n) {
        return {
            A: n
        };
    })), jV = F4(function(n, r, t, e) {
        return {
            j_: e,
            A: n,
            gY: t,
            hy: r
        };
    }), wV = F7(function(n, r, t, e, u, a, i) {
        return {
            lD: i,
            nb: t,
            pj: r,
            pm: u,
            aX: a,
            qH: n,
            rJ: e
        };
    }), AV = A3(TN, "fileSize", dl, A3(TN, "secondsLeft", qN(dl), A3(TN, "remainingSize", dl, A3(TN, "totalUploaded", dl, A3(TN, "loaded", dl, A3(TN, "readableSpeed", Bi, A3(TN, "speed", Ay, Qe(wV)))))))), LV = A3(TN, "completedAt", Ud, A3(TN, "s3Key", Bi, A3(TN, "stats", AV, kV(Qe(jV))))), yV = F2(function(n, r) {
        return {
            ll: r,
            A: n
        };
    }), SV = A3(TN, "error", Bi, kV(Qe(yV))), FV = F2(function(n, r) {
        return {
            A: n,
            gY: r
        };
    }), TV = A3(TN, "s3Key", Bi, kV(Qe(FV))), QV = F2(function(n, r) {
        return {
            ed: r,
            A: n
        };
    }), IV = A3(TN, "at", Ud, kV(Qe(QV))), BV = kV(Qe(function(n) {
        return {
            A: n
        };
    })), WV = F4(function(n, r, t, e) {
        return {
            ed: e,
            A: n,
            o6: t,
            hy: r
        };
    }), PV = A3(TN, "at", Ud, A3(TN, "progress", Ay, A3(TN, "stats", AV, kV(Qe(WV))))), MV = kV(Qe(function(n) {
        return {
            A: n
        };
    })), qV = kV(Qe(function(n) {
        return {
            A: n
        };
    })), DV = A3(TN, "error", qN(Bi), A3(TN, "completedAt", qN(Ud), A3(TN, "secondsLeft", qN(dl), A3(TN, "blob", Qi, A3(TN, "mimeType", qN(Bi), A3(TN, "size", dl, A3(TN, "pausedAt", qN(Ud), A3(TN, "pausing", Ae, A3(TN, "progressedAt", Ud, A3(TN, "progress", Ay, A3(TN, "name", Bi, A3(TN, "s3Id", qN(Bi), A3(TN, "fileId", Bi, A3(TN, "id", Bi, Qe(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return {
                                                                jg: s,
                                                                j_: d,
                                                                ll: b,
                                                                A: r,
                                                                mj: n,
                                                                nH: f,
                                                                nW: e,
                                                                dq: o,
                                                                dr: i,
                                                                o6: u,
                                                                gI: a,
                                                                pJ: t,
                                                                aX: l,
                                                                qy: c
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))), XV = F2(function(n, r) {
        return {
            A: n,
            pK: r
        };
    }), EV = A3(TN, "s3UploadId", Bi, kV(Qe(XV))), RV = _n("uploadToElm", A2(we, function(n) {
        return A2(we, function(r) {
            return Qe({
                ln: r,
                nW: n
            });
        }, A2(du, "event", Qi));
    }, A2(du, "name", Bi))), xV = A2(lH, function(n) {
        var r = n.nW, t = n.ln, e = function() {
            switch(r){
                case "Created":
                    return A2(Fe, sV, DV);
                case "Started":
                    return A2(Fe, gV, qV);
                case "Progress":
                    return A2(Fe, vV, PV);
                case "UploadInitiated":
                    return A2(Fe, hV, EV);
                case "Completed":
                    return A2(Fe, fV, LV);
                case "Error":
                    return A2(Fe, lV, SV);
                case "Cancelled":
                    return A2(Fe, cV, CV);
                case "Pausing":
                    return A2(Fe, pV, BV);
                case "Paused":
                    return A2(Fe, mV, IV);
                case "Resumed":
                    return A2(Fe, $V, MV);
                case "NameChanged":
                    return A2(Fe, dV, TV);
                default:
                    return xo("not an Event");
            }
        }(), u = A2(bi, e, t);
        return u.$ ? bV : u.a;
    }, RV(Be)), OV = {
        $: 6
    }, zV = function(n) {
        return {
            $: 5,
            a: n
        };
    }, NV = A2(WH, 0, "mousemove"), HV = A2(WH, 0, "mouseup"), VV = F2(function(n, r) {
        return {
            ss: n,
            sx: r
        };
    }), UV = A3(Te, VV, A2(du, "pageX", dl), A2(du, "pageY", dl)), JV = function(n) {
        return 1 === n.kW.$ ? hH : gH(C([
            NV(A2(Fe, zV, UV)),
            HV(Qe(OV))
        ]));
    }, ZV = function() {
        return hH;
    }, KV = function(n) {
        return {
            $: 26,
            a: n
        };
    }, _V = function(n) {
        return {
            $: 37,
            a: n
        };
    }, GV = function(n) {
        return {
            $: 10,
            a: n
        };
    }, YV = function(n) {
        return {
            $: 38,
            a: n
        };
    }, nU = function(n) {
        return {
            $: 11,
            a: n
        };
    }, rU = _n("jsToElm", Qi), tU = function(n) {
        return {
            $: 12,
            a: n
        };
    }, eU = function(n) {
        return {
            $: 13,
            a: n
        };
    }, uU = _n("content", pl(A2(we, function(n) {
        return A2(we, function(r) {
            return A2(we, function(t) {
                return A2(we, function(e) {
                    return Qe({
                        fB: e,
                        m3: t,
                        rQ: r,
                        sd: n
                    });
                }, A2(du, "index", dl));
            }, A2(du, "layout", Bi));
        }, A2(du, "typeVersion", Bi));
    }, A2(du, "version", $b(C([
        yN(Ct),
        A2(Fe, kt, Bi)
    ])))))), aU = _n("lastAudioQualification", A2(we, function(n) {
        return A2(we, function(r) {
            return A2(we, function(t) {
                return Qe({
                    cJ: t,
                    A: r,
                    bn: n
                });
            }, A2(du, "channels", pl(dl)));
        }, A2(du, "fileId", Bi));
    }, A2(du, "result", pl(A2(we, function(n) {
        return A2(we, function(r) {
            return A2(we, function(t) {
                return A2(we, function(e) {
                    return Qe({
                        fB: e,
                        m3: t,
                        rQ: r,
                        sd: n
                    });
                }, A2(du, "index", dl));
            }, A2(du, "layout", Bi));
        }, A2(du, "typeVersion", Bi));
    }, A2(du, "version", $b(C([
        yN(Ct),
        A2(Fe, kt, Bi)
    ])))))))), iU = function(n) {
        return {
            $: 27,
            a: n
        };
    }, oU = _n("sendPlayerName", Bi), cU = _n("updateAudioStreams", pl(A2(we, function(n) {
        return A2(we, function(r) {
            return Qe(d(n, r));
        }, A2(Oo, 1, $b(C([
            yN(Ct),
            A2(Fe, kt, Bi)
        ]))));
    }, A2(Oo, 0, dl)))), fU = F2(function(n, r) {
        return gH(C([
            A2(lH, KV, gH(C([
                aU(tU),
                uU(eU)
            ]))),
            A2(lH, GV, gH(C([
                oU(iU)
            ]))),
            cU(_V),
            A2(bu, function(n) {
                return i(n.j_, Ct);
            }, r.aa) || n.na ? A2(tV, 5e3, Hl(l$)) : hH,
            A2(lH, YV, rU(nU))
        ]));
    }), sU = _n("viewport", A2(we, function(n) {
        return A2(we, function(r) {
            return A2(we, function(t) {
                return Qe({
                    ft: t,
                    mK: r,
                    ih: n
                });
            }, A2(du, "height", dl));
        }, A2(du, "isFullscreen", Ae));
    }, A2(du, "width", dl))), lU = function(n) {
        return {
            $: 1,
            a: n
        };
    }, dU = function(n) {
        return {
            $: 3,
            a: n
        };
    }, bU = function(n) {
        return {
            $: 0,
            a: n
        };
    }, mU = function(n) {
        return {
            $: 2,
            a: n
        };
    }, pU = {
        $: 1
    }, vU = function(n) {
        return {
            $: 2,
            a: n
        };
    }, $U = function(n) {
        return p(n, {
            lm: g
        });
    }, gU = F3(function(n, r, t) {
        return n(t) ? kt(r) : Ct;
    }), hU = ft, kU = (HH = A2(Qu, ik, ak("^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$")), hU(HH)), CU = A2(gU, A2(mu, pu, kU), "Cet email n'est pas valide"), jU = F3(function(n, r, t) {
        return p(t, {
            lz: A3(Wo, n, function(n) {
                return kt(1 === n.$ ? r : A2(Su, n.a, r));
            }, t.lz)
        });
    }), wU = {
        lz: Lu,
        Z: Ct
    }, AU = A2(gU, function(n) {
        return "" === n;
    }, "Ce champ est obligatoire"), LU = F3(function(n, r, t) {
        return n(t) ? r(t) : Ct;
    }), yU = A3(jU, "email", C([
        A2(Po, function(n) {
            return n.k6;
        }, AU),
        A2(Po, function(n) {
            return n.k6;
        }, A2(LU, function(n) {
            return "" !== n;
        }, CU))
    ]), wU), SU = F2(function(n, r) {
        return kt(1 === r.$ ? C([
            n
        ]) : A2(bt, n, r.a));
    }), FU = F3(function(n, r, t) {
        return p(t, {
            lz: A3(Wo, n, SU(r), t.lz)
        });
    }), TU = F2(function(n, r) {
        var t = vi;
        return A3(ug, F3(function(n, e, u) {
            return A3(qt, F2(function(e, u) {
                var a = e(r);
                return 1 === a.$ ? u : jt(A3(FU, n, a.a, u.$ ? u.a : t));
            }), u, e);
        }), function() {
            var e = n.Z;
            if (1 === e.$) return yt(r);
            var u = (0, e.a)(r);
            return 1 === u.$ ? yt(r) : jt(A2(ki, u.a, t));
        }(), n.lz);
    }), QU = function(n) {
        return {
            $: 2,
            a: n
        };
    }, IU = F3(function(n, r, t) {
        return p(n, {
            lm: A2(Qu, g, A2(Lo, r, t.lz))
        });
    }), BU = F2(function(n, r) {
        return p(n, {
            k6: A3(IU, n.k6, "email", r),
            nE: "" === r.nE ? KN : QU(r.nE)
        });
    }), WU = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(eo, g, p(r, {
                    k6: A2(Wg, n.a, r.k6)
                }));
            case 1:
                var t = {
                    k6: r.k6.sa
                }, e = A2(TU, yU, t);
                return 1 === e.$ ? A2(eo, g, A2(BU, r, JS(e.a))) : A2(eo, C([
                    A2(Rs, vU, Sx(t))
                ]), p(r, {
                    nE: KN
                }));
            default:
                var u = n.a;
                if (u.$) return A2(eo, g, A2(BU, r, u.a));
                var a = function(n) {
                    return p(n, {
                        k6: $U(n.k6),
                        nE: KN
                    });
                }(r);
                return A2(eo, g, p(a, {
                    nE: pU
                }));
        }
    }), PU = function(n) {
        return {
            $: 5,
            a: n
        };
    }, MU = xs(Nw({
        $: 6
    })), qU = F5(function(n, r, t, e, u) {
        return {
            j2: u,
            k6: n,
            nW: t,
            oN: e,
            rH: r
        };
    }), DU = ul(A4(ll, "confirmation", function(n) {
        return n.j2;
    }, Di, A4(ll, "password", function(n) {
        return n.oN;
    }, Di, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "token", function(n) {
        return n.rH;
    }, Di, A4(ll, "email", function(n) {
        return n.k6;
    }, Di, gl(qU))))))), XU = Ks(Hl(yt(0))), EU = F2(function(n, r) {
        return p(n, {
            j1: A3(IU, n.j1, "confirm", r),
            ll: kt(r.nE),
            nW: A3(IU, n.nW, "name", r),
            oN: A3(IU, n.oN, "password", r)
        });
    }), RU = F2(function(n, r) {
        var t = r.a, e = qe(t) > 0 || qe(n.sa) > 0 ? i(t, n.sa) ? " : OK" : " : KO" : "";
        return p(n, {
            m$: $(GN, e)
        });
    }), xU = function(n) {
        return A2(Po, hU(A2(Qu, ik, ak(n))), pu);
    }, OU = F2(function(n, r) {
        return 9 > qe(n) ? kt(1) : A2(xU, "[a-z]", n) ? kt(2) : A2(xU, "[A-Z]", n) ? kt(3) : A2(xU, "[0-9]", n) ? kt(4) : A2(xU, "[^A-Za-z0-9]", n) ? kt(5) : i(n, r) || "" === r ? Ct : kt(0);
    }), zU = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(eo, g, r);
            case 1:
                return A2(eo, g, p(r, {
                    nW: A2(Wg, e = n.a, r.nW)
                }));
            case 2:
                var t = p(r, {
                    j1: A2(RU, r.j1, e = n.a),
                    oN: A2(Wg, e, r.oN)
                });
                return A2(eo, g, p(t, {
                    oO: A2(OU, t.oN.sa, t.j1.sa)
                }));
            case 3:
                var e;
                return A2(eo, g, p(r, {
                    j1: A2(Wg, e = n.a, A2(RU, r.oN, e))
                }));
            case 4:
                var u = {
                    j2: r.j1.sa,
                    k6: r.k6,
                    nW: r.nW.sa,
                    oN: r.oN.sa,
                    rH: r.rH
                };
                return i(r.oO, Ct) ? A2(eo, C([
                    A2(Rs, PU, (o = u, Al(XU(A3(kg, DU, o, $g(MU))))))
                ]), r) : A2(eo, g, r);
            default:
                var a = n.a;
                return a.$ ? A2(eo, g, A2(EU, r, a.a)) : A2(eo, C([
                    tO(r.pl)
                ]), r);
        }
        var o;
    }), NU = function(n) {
        return {
            $: 6,
            a: n
        };
    }, HU = {
        $: 3
    }, VU = {
        $: 0
    }, UU = function(n) {
        return {
            $: 7,
            a: n
        };
    }, JU = Jn("gotoSSO", gi), ZU = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), KU = F2(function(n, r) {
        return X$(Ax(A2(ZU, n, r)));
    }), _U = ul(A4(kb, "sso", function(n) {
        return n.qJ;
    }, Di, gl(function(n) {
        return {
            qJ: n
        };
    }))), GU = function(n) {
        return Al(A2(_s, _U, Vs(A2(KU, n.k6.sa, n.lV))));
    }, YU = F2(function(n, r) {
        return {
            k6: n,
            oN: r
        };
    }), nJ = ul(A4(ll, "password", function(n) {
        return n.oN;
    }, Di, A4(ll, "email", function(n) {
        return n.k6;
    }, Di, gl(YU)))), rJ = X$(Ax({
        $: 0
    })), tJ = function(n) {
        return Al(XU(A3(kg, nJ, n, $g(rJ))));
    }, eJ = A3(jU, "password", C([
        A2(Po, function(n) {
            return n.oN;
        }, AU)
    ]), A3(jU, "email", C([
        A2(Po, function(n) {
            return n.k6;
        }, AU),
        A2(Po, function(n) {
            return n.k6;
        }, A2(LU, function(n) {
            return "" !== n;
        }, CU))
    ]), wU)), uJ = function(n) {
        return {
            $: 2,
            a: n
        };
    }, aJ = F2(function(n, r) {
        return p(n, {
            k6: A3(IU, n.k6, "email", r),
            nE: "" === r.nE ? rH : uJ(r.nE),
            oN: A3(IU, n.oN, "password", r)
        });
    }), iJ = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                return A2(eo, g, r);
            case 1:
                return A2(eo, g, p(r, {
                    k6: A2(Wg, n.a, r.k6)
                }));
            case 2:
                var t = p(r, {
                    oN: A2(Wg, n.a, r.oN)
                });
                if (r.qJ) return A2(eo, g, t);
                n = HU, r = t;
                continue n;
            case 3:
                if ("" === r.k6.sa) return A2(eo, g, r);
                if (i(r.qK, kt(r.k6.sa)) && 1 !== r.qJ) {
                    var e = {
                        k6: r.k6.sa,
                        oN: r.oN.sa
                    }, u = A2(TU, eJ, e);
                    return 1 === u.$ ? A2(eo, g, A2(aJ, r, JS(u.a))) : A2(eo, C([
                        A2(Rs, NU, tJ(e))
                    ]), r);
                }
                return A2(eo, C([
                    A2(Rs, UU, GU(r))
                ]), p(r, {
                    qJ: 1,
                    qK: kt(r.k6.sa)
                }));
            case 5:
                return A2(eo, C([
                    JU(n.a)
                ]), r);
            case 4:
                var a = r.oN;
                return A2(eo, g, p(r, {
                    k6: p(r.k6, {
                        sa: ""
                    }),
                    nE: rH,
                    oN: p(a, {
                        sa: ""
                    }),
                    qJ: 0
                }));
            case 6:
                return (o = n.a).$ ? A2(eo, g, A2(aJ, r, c = o.a)) : A2(eo, C([
                    function() {
                        var n = r.lV;
                        return tO(1 === n.$ ? "/" : n.a);
                    }()
                ]), p(r, {
                    nE: rH
                }));
            default:
                var o;
                if ((o = n.a).$) {
                    var c = o.a;
                    return A2(eo, g, A2(aJ, p(r, {
                        qJ: 0
                    }), c));
                }
                var f = o.a.qJ;
                return f.$ ? A2(eo, C([
                    A2(Rs, Hl(VU), Xx("inputLoginPassword"))
                ]), p(r, {
                    nE: rH,
                    qJ: 2
                })) : A2(eo, C([
                    JU(f.a)
                ]), r);
        }
    }), oJ = function(n) {
        return {
            $: 4,
            a: n
        };
    }, cJ = X$(Ax({
        $: 3
    })), fJ = F4(function(n, r, t, e) {
        return {
            j2: t,
            k6: n,
            oN: r,
            rH: e
        };
    }), sJ = ul(A4(ll, "token", function(n) {
        return n.rH;
    }, Di, A4(ll, "confirmation", function(n) {
        return n.j2;
    }, Di, A4(ll, "password", function(n) {
        return n.oN;
    }, Di, A4(ll, "email", function(n) {
        return n.k6;
    }, Di, gl(fJ)))))), lJ = function(n) {
        return {
            $: 2,
            a: n
        };
    }, dJ = F2(function(n, r) {
        return p(n, {
            j1: A3(IU, n.j1, "confirm", r),
            nE: "" === r.nE ? aH : lJ(r.nE),
            oN: A3(IU, n.oN, "password", r)
        });
    }), bJ = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(eo, g, r);
            case 1:
                var t = p(r, {
                    oN: A2(Wg, n.a, r.oN)
                });
                return A2(eo, g, p(t, {
                    oO: A2(OU, t.oN.sa, t.j1.sa)
                }));
            case 2:
                return t = p(r, {
                    j1: A2(Wg, n.a, r.j1)
                }), A2(eo, g, p(t, {
                    oO: A2(OU, t.oN.sa, t.j1.sa)
                }));
            case 3:
                var e = {
                    j2: r.j1.sa,
                    k6: r.k6,
                    oN: r.oN.sa,
                    rH: r.rH
                };
                return i(r.oO, Ct) ? A2(eo, C([
                    A2(Rs, oJ, (u = e, Al(Lg(A3(kg, sJ, u, $g(cJ))))))
                ]), r) : A2(eo, g, r);
            default:
                return n.a.$ ? A2(eo, g, A2(dJ, r, n.a.a)) : A2(eo, C([
                    tO("/")
                ]), r);
        }
        var u;
    }), mJ = F2(function(n, r) {
        var t = d(r.oI, n);
        n: for(;;)switch(t.b.$){
            case 0:
                if (t.a.$) break n;
                var e = A2(iJ, t.b.a, t.a.a), u = e.b;
                return d(p(r, {
                    oI: JN(e.a)
                }), A2(wp, bU, u));
            case 1:
                if (1 === t.a.$) {
                    var a = A2(WU, t.b.a, t.a.a);
                    return u = a.b, d(p(r, {
                        oI: VN(a.a)
                    }), A2(wp, lU, u));
                }
                break n;
            case 2:
                if (2 === t.a.$) {
                    var i = A2(bJ, t.b.a, t.a.a);
                    return u = i.b, d(p(r, {
                        oI: ZN(i.a)
                    }), A2(wp, mU, u));
                }
                break n;
            case 3:
                if (3 === t.a.$) {
                    var o = A2(zU, t.b.a, t.a.a);
                    return u = o.b, d(p(r, {
                        oI: UN(o.a)
                    }), A2(wp, dU, u));
                }
                break n;
            default:
                var c = cH(t.b.a);
                return d(p(r, {
                    oI: c.b,
                    r6: c.a
                }), p$);
        }
        return d(r, p$);
    }), pJ = function(n) {
        return {
            $: 2,
            a: n
        };
    }, vJ = function(n) {
        return {
            $: 7,
            a: n
        };
    }, $J = function(n) {
        return {
            $: 10,
            a: n
        };
    }, gJ = function(n) {
        return {
            $: 6,
            a: n
        };
    }, hJ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, kJ = F2(function(n, r) {
        return A2(mg, n, vW(r));
    }), CJ = F4(function(n, r, t, e) {
        return A2(kJ, r, e) ? jt(A3(ju, n, t, e)) : yt(A3(ju, n, r, e));
    }), jJ = function(n) {
        return A2(Qu, !1, A2(Tu, function(n) {
            return !n.$;
        }, A2(Tu, function(n) {
            return n.j_;
        }, n.r$)));
    }, wJ = function(n) {
        return !i(A2(Tu, function(n) {
            return n.oQ;
        }, n.rN), kt(5));
    }, AJ = F2(function(n, r) {
        return i(n.dt, Ct) ? 1 === r.$ ? 0 : function(n) {
            var r = n.lA, t = n.o7, e = n.kE;
            if (i(r.r$, Ct)) {
                var u = r.sc;
                if (1 === u.$) return 1;
                var a = u.a.bn;
                return 1 === a.$ ? 1 : a.a.nY > 0 ? 2 : i(A2(Tu, wJ, t.nm), kt(!0)) || A2(bu, function(n) {
                    return 5 !== n.rN.oQ;
                }, e) ? 1 : 3;
            }
            return 1;
        }(r.a) : 4;
    }), LJ = C([
        ".aac",
        ".ac3",
        ".aif",
        ".aiff",
        ".alac",
        ".amb",
        ".amr",
        ".ape",
        ".aob",
        ".au",
        ".caf",
        ".dts",
        ".flac",
        ".m4a",
        ".mka",
        ".mov",
        ".mp2",
        ".mp3",
        ".mpc",
        ".oga",
        ".ogg",
        ".opus",
        ".ra",
        ".sln",
        ".spx",
        ".tta",
        ".voc",
        ".wav",
        ".wave",
        ".wavpack",
        ".wma",
        ".wv"
    ]), yJ = N, SJ = F2(function(n, r) {
        return A2(bu, function(r) {
            return A2(yJ, r, n);
        }, r);
    }), FJ = C([
        ".srt",
        ".stl",
        ".sub",
        ".ssa",
        ".ass",
        ".vtt",
        ".scc",
        ".cap",
        ".ttml"
    ]), TJ = C([
        ".mxf",
        ".mov",
        ".mpg",
        ".mpeg",
        ".mp4",
        ".mp2",
        ".ts",
        ".m2ts",
        ".gxf",
        ".m2t",
        ".mkv"
    ]), QJ = function(n) {
        var r = n.nH;
        n: for(; !r.$;)switch(r.a){
            case "application/mxf":
            case "video/quicktime":
            case "video/mpeg":
            case "video/mp4":
                return 0;
            case "audio/mp3":
            case "audio/wav":
                return 1;
            default:
                break n;
        }
        var t = zi(n.nW);
        return A2(SJ, t, TJ) ? 0 : A2(SJ, t, FJ) ? 2 : A2(SJ, t, LJ) ? 1 : 3;
    }, IJ = F3(function(n, r, t) {
        return A3(qt, F2(function(r, t) {
            switch(QJ(r)){
                case 0:
                    var e = A4(CJ, r.nW, 0, 3, t);
                    if (e.$) return e.a;
                    var u = e.a;
                    return A2(AJ, n.S.bF, n.S.bT.f2) && A2(Qu, !1, A2(Tu, jJ, A2(Tu, function(n) {
                        return n.lA;
                    }, n.S.bT.f2))) ? A3(Wo, r.nW, function() {
                        return kt(3);
                    }, u) : u;
                case 1:
                    return A3(ju, r.nW, 1, t);
                case 2:
                    return A3(ju, r.nW, 2, t);
                default:
                    return t;
            }
        }), t, r);
    }), BJ = F5(function(n, r, t) {
        if (r.$) return bo;
        var e = r.a;
        return hJ(t.$ || t.a.$ ? e : A3(IJ, t.a.a, n, e));
    }), WJ = F2(function(n, r) {
        return n.iz || A2(bu, function(n) {
            return i(n.oB, r);
        }, n.oD);
    }), PJ = F2(function(n, r) {
        return A2(bu, function(r) {
            return i(n.mj, r.r8) && r.r$;
        }, r);
    }), MJ = F3(function(n, r, t) {
        return A2(WJ, n, r) || A2(PJ, n, t);
    }), qJ = F2(function(n, r) {
        return !(r.r8.iz || 1 === n.g9.c9);
    }), DJ = {
        D: g,
        ln: g,
        ab: Ct
    }, XJ = F2(function(n, r) {
        return {
            D: r.D,
            ln: r.ln,
            ab: n
        };
    }), EJ = function(n) {
        return A2(XJ, kt(n), DJ);
    }, RJ = F3(function(n, r, t) {
        if (n.$ || n.a.$) return EJ(t);
        var e, u = n.a.a, a = A2(qJ, u, t) ? A2(Bu, function(n) {
            return 2 === QJ(n);
        }, r) : r, i = (e = d(n, t.oL)).a.$ ? 1 === e.b.$ ? d($(a, t.bT), t.oL) : d(a, bo) : e.b.$ ? d(a, hJ(Lu)) : d($(a, t.bT), t.oL), o = i.a, c = A5(BJ, a, i.b, n, t.pe, t.r7);
        return EJ(A3(MJ, t.r8, u.oz.mj, A2(Ge, function(n) {
            return n.fH;
        }, u.fJ)) ? p(t, {
            bT: o,
            oL: c
        }) : t);
    }), xJ = {
        $: 32
    }, OJ = to(C([
        A2(b$, Hl(xJ), d$),
        A2(b$, Hl(l$), d$)
    ])), zJ = F4(function(n, r, t, e) {
        var u = n(A2(Qu, t, e.ab)), a = A2(bu, fe(2), e.ln) ? p(u, {
            g9: p(u.g9, {
                oT: !0
            })
        }) : u, i = A2(Ge, function(n) {
            switch(n){
                case 0:
                    return A2(wp, Ai, jp);
                case 1:
                case 3:
                    return A2(wp, Pv(u.g9.mj), m$);
                case 2:
                    return A2(wp, Pv(u.g9.mj), OJ);
                default:
                    return A2(wp, Wv, s$(u.n8.mj));
            }
        }, e.ln), o = A2(wp, r, to(e.D));
        return A2(eo, A2(bt, o, i), a);
    }), NJ = F2(function(n, r) {
        return !A2(Lo, n, r).$;
    }), HJ = F2(function(n, r) {
        var t = n, e = r.sb;
        return p(r, A2(NJ, t, e) ? {
            sb: A2(Bo, t, e)
        } : {
            sb: A3(ju, t, "", e)
        });
    }), VJ = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(eo, g, p(r, {
                    ll: Ct
                }));
            case 1:
                return A2(eo, g, p(r, {
                    qL: A2(Wg, n.a, r.qL)
                }));
            case 2:
                return A2(eo, g, p(r, {
                    lg: A2(Wg, n.a, r.lg)
                }));
            default:
                return A2(eo, g, p(r, {
                    oD: A2(HJ, n.a, r.oD)
                }));
        }
    }), UJ = function(n) {
        return {
            $: 8,
            a: n
        };
    }, JJ = function(n) {
        return {
            $: 10,
            a: n
        };
    }, ZJ = F3(function(n, r, t) {
        return {
            kN: t,
            k6: r,
            nW: n
        };
    }), KJ = ul(A4(ll, "disableOrganizationEmails", function(n) {
        return n.kN;
    }, Zi, A4(kb, "email", function(n) {
        return n.k6;
    }, Di, A4(kb, "name", function(n) {
        return n.nW;
    }, Di, gl(ZJ))))), _J = function(n) {
        return A2(zs, "PATCH", Hs(n));
    }, GJ = Jn("refresh", function() {
        return pi;
    }), YJ = Pi({
        bQ: "New name saved",
        bX: "Nouveau nom enregistr\xe9"
    }), nZ = Pi({
        bQ: "New password saved",
        bX: "Nouveau mot de passe enregistr\xe9"
    }), rZ = F3(function(n, r, t) {
        return {
            j2: t,
            n0: r,
            oN: n
        };
    }), tZ = ul(A4(ll, "confirmation", function(n) {
        return n.j2;
    }, Di, A4(ll, "newPassword", function(n) {
        return n.n0;
    }, Di, A4(ll, "password", function(n) {
        return n.oN;
    }, Di, gl(rZ))))), eZ = xs(Nw({
        $: 4
    })), uZ = F2(function(n, r) {
        var t = r.a, e = qe(t) > 0 || qe(n.sa) > 0 ? i(t, n.sa) ? " : OK" : " : KO" : "";
        return p(n, {
            m$: $(Hi, e)
        });
    }), aZ = F2(function(n, r) {
        switch(n.$){
            case 7:
                return A2(eo, g, p(r, {
                    ll: Ct,
                    re: Ct
                }));
            case 0:
                return A2(eo, g, p(r, {
                    nW: A2(Wg, e = n.a, r.nW)
                }));
            case 1:
                return A2(eo, g, p(r, {
                    k6: A2(Wg, e = n.a, r.k6)
                }));
            case 5:
                return A2(eo, g, p(r, {
                    kN: A2(Ig, e = n.a, r.kN)
                }));
            case 2:
                return A2(eo, g, p(r, {
                    oN: A2(Wg, e = n.a, r.oN)
                }));
            case 3:
                var t = p(r, {
                    n1: A2(Wg, e = n.a, r.n1),
                    n2: A2(uZ, r.n2, e)
                });
                return A2(eo, g, p(t, {
                    oO: A2(OU, t.n1.sa, t.n2.sa)
                }));
            case 4:
                var e;
                return t = p(r, {
                    n2: A2(Wg, e = n.a, A2(uZ, r.n1, e))
                }), A2(eo, g, p(t, {
                    oO: A2(OU, t.n1.sa, t.n2.sa)
                }));
            case 6:
                return A2(eo, C([
                    A2(Rs, UJ, (o = {
                        kN: r.kN.sa,
                        k6: kt(r.k6.sa),
                        nW: kt(r.nW.sa)
                    }, Al(Lg(A3(kg, KJ, o, _J(Hw))))))
                ]), p(r, {
                    ll: Ct
                }));
            case 8:
                return (a = n.a).$ ? A2(eo, g, p(r, {
                    ll: kt(a.a),
                    re: Ct
                })) : A2(eo, C([
                    GJ(0)
                ]), p(r, {
                    ll: Ct,
                    re: kt(YJ)
                }));
            case 9:
                var u = i(r.oO, Ct) ? A2(Rs, JJ, function(n) {
                    return Al(Lg(A3(kg, tZ, n, $g(eZ))));
                }({
                    j2: r.n2.sa,
                    n0: r.n1.sa,
                    oN: r.oN.sa
                })) : p$;
                return A2(eo, C([
                    u
                ]), p(r, {
                    ll: Ct
                }));
            default:
                var a;
                return A2(eo, g, p(r, (a = n.a).$ ? {
                    ll: kt(a.a),
                    re: Ct
                } : {
                    ll: Ct,
                    n1: Xi(function(n) {
                        return p(n, {
                            m$: Gi
                        });
                    }),
                    n2: Xi(function(n) {
                        return p(n, {
                            m$: Hi
                        });
                    }),
                    oN: Xi(function(n) {
                        return p(n, {
                            m$: Yi
                        });
                    }),
                    re: kt(nZ)
                }));
        }
        var o;
    }), iZ = F3(function(n, r, t) {
        var e, u = function(n) {
            return {
                l: n.l,
                m: n.m,
                p: n.p,
                q: n.q,
                r: n.r
            };
        }(t), a = (e = u.l(n)).$ ? d(Ct, p$) : A2(eF, kt, A2(u.r, r, e.a)), i = a.b;
        return d(A2(u.p, n, a.a), A2(wp, u.q, i));
    }), oZ = F2(function(n, r) {
        var t = n, e = iZ(r.oJ), u = function() {
            switch(t.$){
                case 1:
                    return A2(e, t.a, VQ);
                case 2:
                    return A2(e, t.a, HM);
                case 3:
                    return A2(e, t.a, WW);
                case 4:
                    return A2(e, t.a, zO);
                case 5:
                    return A2(e, t.a, bx);
                case 6:
                    return A2(e, t.a, dE);
                case 7:
                    return A2(e, t.a, Mj);
                case 8:
                    return A2(e, t.a, Ew);
                case 9:
                    return A2(e, t.a, tD);
                case 10:
                    return A2(e, t.a, uN);
                case 11:
                    return A2(e, t.a, YW);
                case 12:
                    return A2(e, t.a, QQ);
                case 13:
                    return A2(e, t.a, UX);
                case 14:
                    return A2(e, t.a, fX);
                case 15:
                    return A2(e, t.a, yI);
                case 16:
                    return A2(e, t.a, XB);
                case 17:
                    return A2(e, t.a, by);
                case 18:
                    return A2(e, t.a, Qq);
                default:
                    return A2(e, t.a, aL);
            }
        }(), a = u.a;
        return A2(eo, C([
            A2(wp, Be, u.b)
        ]), p(r, {
            oJ: a
        }));
    }), cZ = function(n) {
        return {
            $: 4,
            a: n
        };
    }, fZ = {
        $: 0
    }, sZ = function(n) {
        return {
            $: 7,
            a: n
        };
    }, lZ = function(n) {
        return Al(Lg(Ag(BR(n))));
    }, dZ = ul(A4(ll, "error", function(n) {
        return n.ll;
    }, Di, gl(function(n) {
        return {
            ll: n
        };
    }))), bZ = F2(function(n, r) {
        return Al(Lg(A3(kg, dZ, r, _J(xs(Rq(A2(IR, n, 11)))))));
    }), mZ = xs(Nw({
        $: 0
    })), pZ = Al(Lg($g(mZ))), vZ = ul(A4(ll, "name", function(n) {
        return n.nW;
    }, Di, gl(function(n) {
        return {
            nW: n
        };
    }))), $Z = F2(function(n, r) {
        return Al(Lg(A3(kg, vZ, r, _J(xs(Rq(A2(IR, n, 8)))))));
    }), gZ = function(n) {
        return Al(Lg(Sg(xs(Rq(A2(IR, n, 12))))));
    }, hZ = F4(function(n, r, t, e) {
        return {
            eH: r,
            o6: n,
            aX: e,
            qH: t
        };
    }), kZ = ul(A4(kb, "secondsLeft", function(n) {
        return n.aX;
    }, ml, A4(ll, "speed", function(n) {
        return n.qH;
    }, yy, A4(ll, "completed", function(n) {
        return n.eH;
    }, Zi, A4(ll, "progress", function(n) {
        return n.o6;
    }, yy, gl(hZ)))))), CZ = F2(function(n, r) {
        return Al(Lg(A3(kg, kZ, r, _J(xs(Rq(A2(IR, n, 9)))))));
    }), jZ = Jn("resetPreference", function() {
        return pi;
    }), wZ = ul(A4(ll, "s3Id", function(n) {
        return n.pJ;
    }, Di, gl(function(n) {
        return {
            pJ: n
        };
    }))), AZ = F2(function(n, r) {
        return Al(Lg(A3(kg, wZ, r, _J(xs(Rq(A2(IR, n, 10)))))));
    }), LZ = xs(Nw({
        $: 5
    })), yZ = ul(A4(ll, "organization", function(n) {
        return n.oz;
    }, Di, gl(function(n) {
        return {
            oz: n
        };
    }))), SZ = function(n) {
        return Al(Lg(A3(kg, yZ, {
            oz: n
        }, $g(LZ))));
    }, FZ = F3(function(n, r, t) {
        return p(t, {
            aa: A2(Ge, function(t) {
                return i(t.A, n) ? r(t) : t;
            }, t.aa)
        });
    }), TZ = F2(function(n, r) {
        return p(r, {
            aa: A2(Bu, function(r) {
                return !i(r.A, n);
            }, r.aa)
        });
    }), QZ = F2(function(n, r) {
        switch(n.$){
            case 0:
                return d(r, p$);
            case 1:
                return d(p(r, {
                    dW: n.a
                }), p$);
            case 3:
                return d(r, to(C([
                    A2(Rs, cZ, pZ),
                    jZ(0)
                ])));
            case 4:
                return d(r, 1 === n.a.$ ? p$ : tO("/"));
            case 2:
                var t = n.a;
                switch(t.$){
                    case 0:
                        return d(p(r, {
                            aa: A2(bt, t.a, r.aa)
                        }), p$);
                    case 1:
                        return d(A3(FZ, l = t.a.A, function(n) {
                            return p(n, {
                                dq: Ct
                            });
                        }, r), p$);
                    case 2:
                        var e = t.a.o6, u = t.a.ed, a = A2(CZ, l = t.a.A, {
                            eH: !1,
                            o6: e,
                            aX: (o = t.a.hy).aX,
                            qH: o.qH
                        });
                        return d(A3(FZ, l, function(n) {
                            return p(n, {
                                o6: e,
                                gI: u,
                                aX: o.aX
                            });
                        }, r), A2(Rs, Hl(fZ), a));
                    case 3:
                        var i = t.a.pK;
                        return a = A2(AZ, l = t.a.A, {
                            pJ: i
                        }), d(A3(FZ, l, function(n) {
                            return p(n, {
                                pJ: kt(i)
                            });
                        }, r), A2(Rs, function() {
                            return fZ;
                        }, a));
                    case 7:
                        return d(A3(FZ, l = t.a.A, function(n) {
                            return p(n, {
                                dr: !0
                            });
                        }, r), p$);
                    case 8:
                        return u = t.a.ed, a = gZ(l = t.a.A), d(A3(FZ, l, function(n) {
                            return p(n, {
                                dq: kt(u),
                                dr: !1
                            });
                        }, r), A2(Rs, function() {
                            return fZ;
                        }, a));
                    case 9:
                        return d(A3(FZ, l = t.a.A, function(n) {
                            return p(n, {
                                dq: Ct,
                                dr: !1
                            });
                        }, r), p$);
                    case 10:
                        return a = A2($Z, l = t.a.A, {
                            nW: c = t.a.gY
                        }), d(A3(FZ, l, function(n) {
                            return p(n, {
                                nW: c
                            });
                        }, r), A2(Rs, function() {
                            return fZ;
                        }, a));
                    case 4:
                        var o = t.a.hy, c = t.a.gY, f = t.a.j_;
                        return a = A2(CZ, l = t.a.A, {
                            eH: !0,
                            o6: 1,
                            aX: kt(0),
                            qH: o.qH
                        }), d(A3(FZ, l, function(n) {
                            return p(n, {
                                j_: kt(f),
                                o6: 1,
                                aX: Ct
                            });
                        }, r), A2(Rs, Hl(fZ), a));
                    case 5:
                        var s = t.a.ll;
                        return a = A2(bZ, l = t.a.A, {
                            ll: s
                        }), d(A3(FZ, l, function(n) {
                            return p(n, {
                                ll: kt(s)
                            });
                        }, r), A2(Rs, function() {
                            return fZ;
                        }, a));
                    case 6:
                        var l;
                        return a = lZ(l = t.a.A), d(A2(TZ, l, r), A2(Rs, function() {
                            return fZ;
                        }, a));
                    default:
                        return d(r, p$);
                }
            case 5:
                return d(p(r, {
                    b5: !r.b5
                }), p$);
            case 6:
                return d(r, A2(Rs, sZ, SZ(n.a)));
            default:
                return d(r, 1 === n.a.$ ? p$ : tO(aO));
        }
    }), IZ = F2(function(n, r) {
        return {
            $: 9,
            a: n,
            b: r
        };
    }), BZ = F2(function(n, r) {
        return {
            $: 10,
            a: n,
            b: r
        };
    }), WZ = function(n) {
        return {
            $: 6,
            a: n
        };
    }, PZ = ul(A4(ll, "name", function(n) {
        return n.nW;
    }, Di, gl(function(n) {
        return {
            nW: n
        };
    }))), MZ = F2(function(n, r) {
        return {
            nW: r,
            bo: n
        };
    }), qZ = ul(A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "seasonId", function(n) {
        return n.bo;
    }, Di, gl(MZ)))), DZ = function(n) {
        return {
            $: 3,
            a: n
        };
    }, XZ = xs(DZ({
        $: 0
    })), EZ = function(n) {
        return xs(Ov(A2(zv, n, 6)));
    }, RZ = F2(function(n, r) {
        return {
            c9: r,
            nW: n
        };
    }), xZ = ul(A4(ll, "kind", function(n) {
        return n.c9;
    }, Nb, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, gl(RZ)))), OZ = Pi({
        bQ: "Can\u2019t add.",
        bX: "Impossible d\u2019effectuer l\u2019ajout."
    }), zZ = F2(function(n, r) {
        return {
            a7: n,
            nW: r
        };
    }), NZ = ul(A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "collectionId", function(n) {
        return n.a7;
    }, Di, gl(zZ)))), HZ = function(n) {
        return {
            $: 2,
            a: n
        };
    }, VZ = xs(HZ({
        $: 0
    })), UZ = ul(A4(ll, "name", function(n) {
        return n.nW;
    }, Di, gl(function(n) {
        return {
            nW: n
        };
    }))), JZ = F3(function(n, r, t) {
        var e = F4(function(n, r, t, e) {
            return A2(bp, function(n) {
                return n.mj;
            }, Al(A3(kg, t, e, A2(vg, r, $g(n)))));
        });
        if (r.$) return ZS({
            lz: Lu,
            nE: OZ,
            Q: 400
        });
        if (r.a.$) return A4(e, EZ(n), ip, xZ, 1 === r.a.a ? {
            c9: 1,
            nW: t
        } : {
            c9: 0,
            nW: t
        });
        switch(r.a.a){
            case 3:
                return A4(e, vp, hp, UZ, {
                    nW: t
                });
            case 2:
                return A4(e, XZ, ep, qZ, {
                    nW: t,
                    bo: n
                });
            case 0:
                return A4(e, Nm, Km, PZ, {
                    nW: t
                });
            default:
                return A4(e, VZ, fp, NZ, {
                    a7: n,
                    nW: t
                });
        }
    }), ZZ = F2(function(n, r) {
        return {
            kt: r,
            ll: kt(n),
            nc: !1
        };
    }), KZ = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), _Z = function(n) {
        return {
            $: 1,
            a: n
        };
    }, GZ = {
        d0: 3,
        il: !1,
        eL: _Z(0),
        mj: "",
        fK: !0,
        m$: "",
        gl: 2,
        oz: "",
        gp: "",
        gs: "",
        gW: 1,
        hw: 0,
        h6: !1
    }, YZ = function(n) {
        return !!n.hw;
    }, nK = "seeAccepted", rK = "seeActives", tK = "seeAll", eK = "seeArchives", uK = "seeNonAccepted", aK = "seeTrashed", iK = F5(function(n, r, t, e, u) {
        var a = YZ(u), o = !u.h6 && i(n.iT.sa, tK) || u.h6 && i(n.iT.sa, aK) || !u.h6 && a && i(n.iT.sa, eK) || !u.h6 && !a && i(n.iT.sa, rK), c = i(n.im.sa, tK) || u.il && i(n.im.sa, nK) || !u.il && i(n.im.sa, uK), f = o && c ? 0 : 1;
        return p(GZ, {
            d0: u.il ? 1 : 2,
            il: u.il,
            eL: _Z(1 === u.c9 ? 1 : 0),
            mj: u.mj,
            m$: u.rC,
            gl: f,
            oz: r,
            gs: t,
            gW: e,
            hw: u.hw,
            h6: u.h6
        });
    }), oK = A2(qt, F2(function(n, r) {
        var t = d(r, n.d0);
        n: for(;;)switch(t.a){
            case 1:
                if (1 === t.b) return 1;
                break n;
            case 2:
                if (2 === t.b) return 2;
                break n;
            case 3:
                return t.b;
            default:
                break n;
        }
        return 0;
    }), 3), cK = A2(qt, F2(function(n, r) {
        var t = d(r, n.gl);
        n: for(;;){
            r: for(;;)switch(t.a){
                case 0:
                    return 0;
                case 2:
                    switch(t.b){
                        case 0:
                            break n;
                        case 2:
                            return 2;
                        default:
                            break r;
                    }
                default:
                    if (t.b) break r;
                    break n;
            }
            return 1;
        }
        return 0;
    }), 2), fK = Pw(Ww(function(n) {
        return n.m$;
    })), sK = F2(function(n, r) {
        var t = r.gp, e = r.bJ.oB, u = function(u) {
            var a = fK(A2(Ge, A4(iK, n, e, u.cV.mj, r.gW), u.dB));
            return p(GZ, {
                d0: oK(a),
                eL: A2(KZ, 2, a),
                mj: u.cV.mj,
                fK: wu(a),
                m$: u.cV.nW,
                gl: cK(a),
                oz: e,
                gp: t,
                gW: r.gW,
                hw: u.cV.hw
            });
        }, a = function(n) {
            var a = fK(A2(Ge, u, n.cW));
            return p(GZ, {
                d0: oK(a),
                eL: A2(KZ, 1, a),
                mj: n.dx.mj,
                fK: wu(a),
                m$: n.dx.nW,
                gl: cK(a),
                oz: e,
                gp: t,
                gW: r.gW,
                hw: n.dx.hw
            });
        }, i = fK(A2(Ge, a, r.g2));
        return p(GZ, {
            d0: oK(i),
            eL: A2(KZ, 0, i),
            mj: r.bJ.mj,
            fK: wu(i),
            m$: r.bJ.nW,
            gl: cK(i),
            oz: e,
            gp: t,
            gW: r.gW,
            hw: r.bJ.hw
        });
    }), lK = function(n) {
        return Ge(function(r) {
            if (r.$) {
                var t = r.a, e = t.rW.oB, u = fK(A2(Ge, A4(iK, n, e, t.rW.mj, t.gW), t.dB));
                return p(GZ, {
                    d0: oK(u),
                    eL: A2(KZ, 3, u),
                    mj: t.rW.mj,
                    fK: wu(u),
                    m$: t.rW.nW,
                    gl: cK(u),
                    oz: e,
                    gp: t.gp,
                    gW: t.gW,
                    hw: t.rW.hw
                });
            }
            return A2(sK, n, r.a);
        });
    }, dK = function(n) {
        var r = fK(A2(lK, n, n.mC));
        return p(n, {
            jI: fK(A2(lK, n, n.jJ)),
            fJ: r
        });
    }, bK = F2(function(n, r) {
        return A2(su, r, A2(Xs, Hl(Je(0)), A2(Ye, Hl(Xx(n)), Qx(150))));
    }), mK = F2(function(n, r) {
        return A2(Qu, !1, A2(Tu, fe(n), r));
    }), pK = F2(function(n, r) {
        return A2(NJ, n, r);
    }), vK = Jn("redirect", gi), $K = {
        bF: Ct,
        co: kt(!0)
    }, gK = function(n) {
        return BA(A3(Rp, n, 0, $K));
    }, hK = F2(function(n, r) {
        return n.$ ? p$ : n.a.$ ? vK(gK(r)) : p$;
    }), kK = F2(function(n, r) {
        return A2(Bo, n, r);
    }), CK = F2(function(n, r) {
        return {
            D: n,
            ln: r.ln,
            ab: r.ab
        };
    }), jK = F2(function(n, r) {
        return A2(CK, A2(bt, n, r.D), r);
    }), wK = F3(function(n, r, t) {
        return A2(jK, Dv(d(n, r)), EJ(t));
    }), AK = function(n) {
        return {
            kt: kt(n),
            ll: Ct,
            nc: !1
        };
    }, LK = ul(A4(ll, "name", function(n) {
        return n.nW;
    }, Di, gl(function(n) {
        return {
            nW: n
        };
    }))), yK = ul(A4(ll, "name", function(n) {
        return n.nW;
    }, Di, gl(function(n) {
        return {
            nW: n
        };
    }))), SK = Pi({
        bQ: "Can\u2019t edit.",
        bX: "Impossible d\u2019effectuer l\u2019\xe9dition."
    }), FK = ul(A4(ll, "name", function(n) {
        return n.nW;
    }, Di, gl(function(n) {
        return {
            nW: n
        };
    }))), TK = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), QK = function(n) {
        return {
            $: 5,
            a: n
        };
    }, IK = function(n) {
        return xs(QK(A2(TK, n, 0)));
    }, BK = ul(A4(ll, "name", function(n) {
        return n.nW;
    }, Di, gl(function(n) {
        return {
            nW: n
        };
    }))), WK = ul(A4(ll, "name", function(n) {
        return n.nW;
    }, Di, gl(function(n) {
        return {
            nW: n
        };
    }))), PK = F3(function(n, r, t) {
        var e = F3(function(n, r, t) {
            return Al(A3(kg, r, t, XU(Sg(n))));
        });
        if (r.$) return ZS({
            lz: Lu,
            nE: SK,
            Q: 400
        });
        if (r.a.$) return A3(e, IK(n), WK, {
            nW: t
        });
        switch(r.a.a){
            case 3:
                return A3(e, function(n) {
                    return xs(pp(function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(n)));
                }(n), BK, {
                    nW: t
                });
            case 2:
                return A3(e, function(n) {
                    return xs(DZ(function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(n)));
                }(n), yK, {
                    nW: t
                });
            case 0:
                return A3(e, function(n) {
                    return xs(zm(function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(n)));
                }(n), LK, {
                    nW: t
                });
            default:
                return A3(e, function(n) {
                    return xs(HZ(function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(n)));
                }(n), FK, {
                    nW: t
                });
        }
    }), MK = F2(function(n, r) {
        return A2(CK, $(n, r.D), r);
    }), qK = F2(function(n, r) {
        return {
            D: r.D,
            ln: n,
            ab: r.ab
        };
    }), DK = F2(function(n, r) {
        return A2(qK, A2(bt, n, r.ln), r);
    }), XK = F2(function(n, r) {
        switch(n.$){
            case 0:
                if (n.a.$) return EJ(p(r, {
                    Q: A2(ZZ, n.a.a, r.Q.kt)
                }));
                var t = n.a.a, e = A3(_e, F2(function(n, r) {
                    var t = r.a, e = r.b;
                    return n.a.gW ? d(t, A2(bt, n, e)) : d(A2(bt, n, t), e);
                }), d(g, g), t), u = e.a, a = e.b;
                return A2(MK, C([
                    A2(Qu, p$, A2(Tu, function(n) {
                        return r.px ? A2(bK, n, WZ) : p$;
                    }, r.qb))
                ]), EJ($$(dK(p(r, {
                    jJ: u,
                    mC: a,
                    px: !1,
                    Q: AK(0)
                })))));
            case 2:
                var o = A2(pK, k = n.a, r.op), c = A2(o ? kK : Dc, k, r.op), f = o && i(r.iw, kt(k)) ? Ct : r.iw;
                return EJ(p(r, {
                    iw: f,
                    op: c
                }));
            case 1:
                return EJ(p(r, {
                    ox: A2(mK, k = n.a, r.ox) ? Ct : kt(k)
                }));
            case 3:
                var s = n.a, l = n.b;
                return A2(MK, C([
                    A2(bK, "new-add-form", WZ)
                ]), EJ(p(r, {
                    iw: kt(l),
                    ix: p(oo, {
                        kT: "addInBrowserInput"
                    }),
                    n3: s,
                    op: A2(Dc, l, r.op)
                })));
            case 4:
                var b = n.a, m = n.b, v = r.k1;
                return A2(MK, C([
                    A2(bK, v.kT, WZ)
                ]), EJ(p(r, {
                    k$: A2(mK, m.mj, r.k$) ? Ct : kt(m.mj),
                    k1: p(v, {
                        sa: m.m$
                    }),
                    n3: b
                })));
            case 5:
                return EJ(p(r, {
                    iw: Ct,
                    k$: Ct,
                    ox: Ct
                }));
            case 6:
                return DJ;
            case 7:
                var $ = r.ix.sa;
                return A2(MK, C([
                    A2(Rs, IZ(h = n.a), A3(JZ, h, r.n3, $))
                ]), EJ(p(r, {
                    q0: A2(Dc, h, r.q0)
                })));
            case 8:
                return $ = r.k1.sa, A2(MK, C([
                    A2(Rs, BZ(k = n.a), A3(PK, k, r.n3, $))
                ]), EJ(p(r, {
                    q0: A2(Dc, k, r.q0)
                })));
            case 9:
                if (n.b.$) return k = n.a, EJ(p(r, {
                    ll: kt(n.b.a),
                    q0: A2(kK, k, r.q0)
                }));
                var h = n.a;
                return A2(MK, C([
                    A2(hK, r.n3, k = n.b.a)
                ]), A2(DK, 0, EJ(p(r, {
                    iw: Ct,
                    ix: oo,
                    ll: Ct,
                    n3: Ct,
                    px: !0,
                    qb: kt(k),
                    q0: A2(kK, h, r.q0)
                }))));
            case 10:
                var k;
                return n.b.$ ? (k = n.a, EJ(p(r, {
                    ll: kt(n.b.a),
                    q0: A2(kK, k, r.q0)
                }))) : A2(DK, 0, EJ(p(r, {
                    k$: Ct,
                    k1: oo,
                    ll: Ct,
                    n3: Ct,
                    q0: A2(kK, k = n.a, r.q0)
                })));
            case 11:
                return EJ(p(r, {
                    ix: A2(Wg, n.a, r.ix)
                }));
            case 12:
                return EJ(p(r, {
                    k1: A2(Wg, n.a, r.k1)
                }));
            case 16:
                return EJ(p(r, {
                    ll: Ct
                }));
            case 13:
                var j = p(r, {
                    iT: A2(Wg, n.a, r.iT),
                    op: io
                });
                return A3(wK, "browserArchive", j.iT.sa, A3(ce, A2(Tu, g$, r.qb), Qu(Be), dK(j)));
            case 14:
                return j = p(r, {
                    im: A2(Wg, n.a, r.im),
                    op: io
                }), A3(wK, "browserAccept", j.im.sa, A3(ce, A2(Tu, g$, r.qb), Qu(Be), dK(j)));
            default:
                return EJ(p(r, {
                    oy: A2(Wg, n.a, r.k1)
                }));
        }
    }), EK = {
        $: 2
    }, RK = {
        $: 3
    }, xK = F3(function(n, r, t) {
        return A3(qt, F2(function(n, e) {
            return A3(qt, F2(function(r, t) {
                return !!t || A2(hU, A2(Qu, ik, ak("(\\b" + n + ")")), r);
            }), !1, A2(Ge, A2(Po, zi, ww), A2(bt, t.m$, r))) && e;
        }), !0, n);
    }), OK = F5(function(n, r, t, e, u) {
        return A3(xK, n, r, e) ? A2(bt, b(r, t, e), u) : u;
    }), zK = F2(function(n, r) {
        return A2(_e, F2(function(t, e) {
            var u = t.eL;
            if (u.$) return A5(OK, r, n, u.a, t, e);
            var a = u.b;
            return $(A3(zK, $(n, C([
                t.m$
            ])), r, a), e);
        }), g);
    }), NK = F3(function(n, r, t) {
        switch(n.$){
            case 0:
                if (2 === n.a.$) return A2(eo, C([
                    A2(su, Hl(EK), Qx(200))
                ]), r);
                var e = A2(Wg, n.a, r.pX), u = C(ww(zi(e.sa)).trim().split(/\s+/g)), a = $(A3(zK, g, u, t.jI), A3(zK, g, u, t.fJ));
                return A2(eo, g, {
                    pX: e,
                    pY: a,
                    pZ: !0
                });
            case 1:
                return A2(eo, r.pZ ? g : C([
                    A2(bK, r.pX.kT, Hl(RK))
                ]), {
                    pX: A2(Wg, zh(""), r.pX),
                    pY: A3(zK, g, g, t.jI),
                    pZ: !r.pZ
                });
            case 2:
                return A2(eo, g, p(r, {
                    pZ: !1
                }));
            default:
                return A2(eo, g, r);
        }
    }), HK = Pi({
        bQ: "A video is already there.",
        bX: "Il y a d\xe9j\xe0 une vid\xe9o."
    }), VK = Pi({
        bQ: "MXF video file needed",
        bX: "Vous devez d\xe9poser un fichier vid\xe9o MXF"
    }), UK = F4(function(n, r, t, e) {
        return A3(ju, n, r, A2(cl, F2(function(n, e) {
            return i(e, r) ? t : e;
        }), e));
    }), JK = F3(function(n, r, t) {
        var e = function(n) {
            return d(n, Ct);
        }, u = function(n) {
            return d(t, kt(n));
        }, a = d(t, r);
        if (a.a.$) return e(t);
        var i = a.a.a, o = a.b, c = d(o, QJ(n));
        n: for(;;)switch(c.a){
            case 0:
                if (c.b) break n;
                return A3(mu, e, hJ, A4(UK, n.nW, 0, 3, i));
            case 1:
                switch(c.b){
                    case 1:
                        return e(hJ(A3(ju, n.nW, o, i)));
                    case 0:
                        return A2(SJ, zi(n.nW), LJ) ? e(hJ(A3(ju, n.nW, o, i))) : u(VK);
                    default:
                        break n;
                }
            case 2:
                if (2 === c.b) return e(hJ(A3(ju, n.nW, o, i)));
                break n;
            default:
                return e(hJ(A3(ju, n.nW, o, i)));
        }
        return u(VK);
    }), ZK = function(n) {
        return A2(CK, C([
            n
        ]), DJ);
    }, KK = F3(function(n, r, t) {
        return A2(Qu, n, A2(Lo, t.nW, r));
    }), _K = function(n) {
        return {
            $: 2,
            a: n
        };
    }, GK = Pi({
        bQ: "No more parts to send but job is not complete",
        bX: "No more parts to send but job is not complete"
    }), YK = F3(function(n, r, t) {
        if (t.$) return EJ(p(n, {
            iN: _K(t.a)
        }));
        var e = t.a;
        return 1 === e.$ ? $(r, A2(Bu, function(n) {
            return !A2(mg, n, r);
        }, e.b)).b ? DJ : EJ(p(n, {
            iN: _K(JS(A2(ki, GK, L$)))
        })) : EJ(p(n, {
            iN: e
        }));
    }), n_ = F2(function(n, r) {
        return A3(qt, F2(function(n, r) {
            return A2(Bo, n.nW, r);
        }), r, n);
    }), r_ = F2(function(n, r) {
        var t, e = (t = r.oL).$ ? bo : hJ(A2(n_, n, t.a));
        return EJ(p(r, {
            bT: A2(Bu, function(r) {
                return !A2(mg, r, n);
            }, r.bT),
            oL: e
        }));
    }), t_ = F3(function(n, r, t) {
        return {
            $: 12,
            a: n,
            b: r,
            c: t
        };
    }), e_ = F5(function(n, r, t, e, u) {
        return {
            c9: u,
            nH: t,
            nW: n,
            qy: r,
            dC: e
        };
    }), u_ = function(n) {
        switch(n){
            case 0:
                return "Material";
            case 1:
                return "Audio";
            case 2:
                return "Subtitle";
            default:
                return "Extra";
        }
    }, a_ = function(n) {
        switch(n){
            case "Material":
                return yt(0);
            case "Audio":
                return yt(1);
            case "Subtitle":
                return yt(2);
            default:
                return yt(3);
        }
    }, i_ = A2(zl, u_, a_), o_ = ul(A4(ll, "kind", function(n) {
        return n.c9;
    }, i_, A4(kb, "source", function(n) {
        return n.dC;
    }, Di, A4(kb, "mimeType", function(n) {
        return n.nH;
    }, Di, A4(ll, "size", function(n) {
        return n.qy;
    }, ml, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, gl(e_))))))), c_ = Xs, f_ = F2(function(n, r) {
        return {
            c9: r,
            nW: n
        };
    }), s_ = ul(A4(ll, "kind", function(n) {
        return n.c9;
    }, i_, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, gl(f_)))), l_ = function(n) {
        return xs(QK(A2(TK, n, 3)));
    }, d_ = F3(function(n, r, t) {
        return Al(A2(_s, $R, A3(kg, s_, {
            c9: r,
            nW: t
        }, Sg(l_(n)))));
    }), b_ = F4(function(n, r, t, e) {
        return A2(c_, function(n) {
            return 409 === n.Q ? A3(d_, r, t, e.nW) : ZS(n);
        }, Al(A2(vg, $R, A3(kg, o_, {
            c9: t,
            nH: e.nH,
            nW: e.nW,
            qy: e.qy,
            dC: kt(n.dC)
        }, $g(l_(r))))));
    }), m_ = F4(function(n, r, t, e) {
        return A2(DK, 1, A2(MK, A2(Ge, function(e) {
            return A2(Rs, A2(t_, n, e), A4(b_, n, r, t(e), e));
        }, e.bT), EJ(mo(e.r8))));
    }), p_ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, v_ = function(n) {
        switch(n.$){
            case 0:
                return {
                    ln: (r = n.a, $i(C([
                        d("source", gi(r.dC)),
                        d("userId", gi(r.ib)),
                        d("fileId", gi(r.A)),
                        d("key", gi(r.fR)),
                        d("file", (t = r.lA, $i(C([
                            d("name", gi(t.nW)),
                            d("size", bl(t.qy)),
                            d("mimeType", A2(Qu, pi, A2(Tu, gi, t.nH))),
                            d("blob", t.jg)
                        ]))))
                    ]))),
                    nW: "Upload"
                };
            case 1:
                return {
                    ln: gi(n.a),
                    nW: "Pause"
                };
            case 2:
                return {
                    ln: gi(n.a),
                    nW: "Resume"
                };
            default:
                return {
                    ln: gi(n.a),
                    nW: "Cancel"
                };
        }
        var r, t;
    }, $_ = Jn("uploadToJs", function(n) {
        return $i(C([
            d("event", n.ln),
            d("name", gi(n.nW))
        ]));
    }), g_ = A2(mu, $_, v_), h_ = A2(mu, g_, p_), k_ = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A4(m_, n.a, n.b.mj, A2(KK, 3, n.c), r);
            case 1:
                return EJ(mo(r.r8));
            case 2:
                return A2(r_, C([
                    t = n.a
                ]), r);
            case 4:
                var t = n.a, e = n.b;
                return 1 === e.jv ? EJ(p(r, {
                    kW: kt(b(t, {
                        ss: e.b8.ss,
                        sx: e.b8.sx
                    }, {
                        ss: e.oI.ss,
                        sx: e.oI.sx
                    }))
                })) : DJ;
            case 5:
                var u = r.kW;
                if (1 === u.$) return DJ;
                var a = u.a;
                return EJ(p(r, {
                    kW: kt(b(t = a.a, a.b, n.a))
                }));
            case 6:
                var i = (s = d(r.kW, r.kX)).a.$ || s.b.$ ? d(r.oL, Ct) : A3(JK, s.a.a.a, s.b.a, r.oL);
                return EJ(p(r, {
                    kW: Ct,
                    ll: i.b,
                    oL: i.a
                }));
            case 7:
                return EJ(p(r, {
                    kX: kt(n.a)
                }));
            case 8:
                return EJ(p(r, {
                    kX: Ct
                }));
            case 3:
                return DJ;
            case 9:
                return EJ(p(r, {
                    ll: Ct
                }));
            case 10:
                return A3(RJ, n.a, n.b, r);
            case 11:
                var o = n.a, c = r.iN;
                switch(c.$){
                    case 1:
                        return A3(YK, r, c.b, o);
                    case 0:
                        return A3(YK, r, g, o);
                    default:
                        return DJ;
                }
            default:
                if (n.c.$) return EJ(p(r, {
                    ll: kt(HK)
                }));
                var f = n.c.a;
                return ZK(h_({
                    lA: t = n.b,
                    A: f.mj,
                    fR: f.fR,
                    dC: n.a.dC,
                    ib: "TODODODODO"
                }));
        }
        var s;
    }), C_ = F2(function(n, r) {
        if (n.$) return A2(eo, g, p(r, {
            oI: kt(n.a)
        }));
        if (n.a.$) return A2(eo, g, r);
        var t = n.a.a;
        return A2(eo, C([
            A2(Qu, p$, A2(Tu, ON(t), r.ce))
        ]), p(r, {
            f1: t
        }));
    }), j_ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, w_ = function(n) {
        return {
            $: 5,
            a: n
        };
    }, A_ = function(n) {
        return {
            $: 4,
            a: n
        };
    }, L_ = function(n) {
        return {
            $: 6,
            a: n
        };
    }, y_ = F2(function(n, r) {
        return {
            $: 10,
            a: n,
            b: r
        };
    }), S_ = F2(function(n, r) {
        return {
            $: 12,
            a: n,
            b: r
        };
    }), F_ = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), T_ = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Q_ = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), I_ = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), B_ = F2(function(n, r) {
        return {
            $: 11,
            a: n,
            b: r
        };
    }), W_ = F2(function(n, r) {
        return {
            $: 13,
            a: n,
            b: r
        };
    }), P_ = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), M_ = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), q_ = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), D_ = F2(function(n, r) {
        return {
            $: 9,
            a: n,
            b: r
        };
    }), X_ = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), E_ = F2(function(n, r) {
        return {
            $: 7,
            a: n,
            b: r
        };
    }), R_ = function(n) {
        if (1 === n.$) return 0;
        switch(n.a.$){
            case 13:
                return 1;
            case 0:
                return 2;
            case 12:
                return 3;
            case 1:
                return 4;
            case 5:
                return 5;
            case 6:
                return 6;
            case 9:
                return 7;
            case 8:
                return 8;
            case 7:
                return 9;
            case 2:
                return 11;
            case 4:
                return 12;
            case 3:
                return 13;
            case 10:
                return 14;
            default:
                return 15;
        }
    }, x_ = F2(function(n, r) {
        return s(R_(kt(n)), R_(r)) > 0 ? kt(n) : r;
    }), O_ = Pi({
        bQ: " done",
        bX: " est termin\xe9e"
    }), z_ = Pi({
        bQ: " failed",
        bX: " a \xe9chou\xe9"
    }), N_ = Pi({
        bQ: " done generating ",
        bX: " est termin\xe9e g\xe9n\xe9rant "
    }), H_ = Pi({
        bQ: "Segmentation of file ",
        bX: "La segmentation du fichier "
    }), V_ = Pi({
        bQ: " started",
        bX: " a d\xe9marr\xe9"
    }), U_ = Pi({
        bQ: " with rule ",
        bX: " avec la r\xe8gle "
    }), J_ = Pi({
        bQ: "File ",
        bX: "Le fichier "
    }), Z_ = Pi({
        bQ: " has been uploaded",
        bX: " a \xe9t\xe9 upload\xe9"
    }), K_ = Pi({
        bQ: " creeated invitation ",
        bX: " s\u2019est cr\xe9\xe9 une invitation "
    }), __ = Pi({
        bQ: " deleted invitation",
        bX: " a supprim\xe9 son invitation"
    }), G_ = Pi({
        bQ: " deleted invitation for ",
        bX: " a supprim\xe9 l\u2019invitation de "
    }), Y_ = Pi({
        bQ: " edit invitation ",
        bX: " a \xe9dit\xe9 son invitation "
    }), nG = Pi({
        bQ: " invited ",
        bX: " a invit\xe9 "
    }), rG = Pi({
        bQ: " expire at ",
        bX: " expirant le "
    }), tG = function(n) {
        var r = A2(kO, 4, A2(fb, lb, n)), t = CO(A2(tb, lb, n));
        return A2(kO, 2, A2(Gd, lb, n)) + "/" + t + "/" + r;
    }, eG = function(n) {
        return A2(Qu, "", A2(Tu, function(n) {
            return $(rG, n);
        }, A2(Tu, tG, n)));
    }, uG = Pi({
        bQ: " to download and upload",
        bX: " autorisant le t\xe9l\xe9chargement et l\u2019upload"
    }), aG = Pi({
        bQ: " to download",
        bX: " autorisant le t\xe9l\xe9chargement"
    }), iG = Pi({
        bQ: " authorize download and unauthorize upload",
        bX: " autorisant le t\xe9l\xe9chargement et supprimant l\u2019upload"
    }), oG = Pi({
        bQ: " authorizing download and delivery",
        bX: " autorisant le t\xe9l\xe9chargement et la livraison"
    }), cG = Pi({
        bQ: " authorize download and unauthorize delivery",
        bX: " autorisant le t\xe9l\xe9chargement et supprimant la livraison"
    }), fG = Pi({
        bQ: " to delivery",
        bX: " autorisant la livraison"
    }), sG = Pi({
        bQ: " unauthorizing delivery",
        bX: " supprimant la livraison"
    }), lG = Pi({
        bQ: " authorizing delivery and unauthorizing download",
        bX: " autorisant la livraison et supprimant le t\xe9l\xe9chargement"
    }), dG = Pi({
        bQ: " unauthorizing delivery and download",
        bX: " supprimant la livraison et le t\xe9l\xe9chargement"
    }), bG = Pi({
        bQ: " to upload",
        bX: " autorisant l\u2019upload"
    }), mG = Pi({
        bQ: " to watch only",
        bX: " autorisant le visionnage seulement"
    }), pG = Pi({
        bQ: " unauthorizing upload",
        bX: " supprimant l\u2019upload"
    }), vG = Pi({
        bQ: " authorizing upload and unauthorizing download",
        bX: " autorisant l\u2019upload et supprimant le t\xe9l\xe9chargement"
    }), $G = Pi({
        bQ: " unauthorizing download",
        bX: " supprimant le t\xe9l\xe9chargement"
    }), gG = Pi({
        bQ: " unauthorizing upload and download",
        bX: " supprimant l\u2019upload et le t\xe9l\xe9chargement"
    }), hG = F3(function(n, r, t) {
        var e = d(n, r);
        switch(e.a){
            case 0:
                switch(e.b){
                    case 0:
                        return t ? oG : uG;
                    case 1:
                        return t ? cG : iG;
                    default:
                        return aG;
                }
            case 1:
                switch(e.b){
                    case 0:
                        return t ? lG : vG;
                    case 1:
                        return t ? dG : gG;
                    default:
                        return $G;
                }
            default:
                switch(e.b){
                    case 0:
                        return t ? fG : bG;
                    case 1:
                        return t ? sG : pG;
                    default:
                        return mG;
                }
        }
    }), kG = Pi({
        bQ: "unknown user",
        bX: "utilisateur inconnu"
    }), CG = Pi({
        bQ: "Video was watched by a guest : ",
        bX: "La vid\xe9o \xe0 \xe9t\xe9 visionn\xe9e par un invit\xe9 : "
    }), jG = Pi({
        bQ: " ended with ",
        bX: " s\u2019est termin\xe9e avec "
    }), wG = F4(function(n, r, t, e) {
        return 1 === r.$ || 1 === t.$ || 1 === e.$ ? Ct : kt(A3(n, r.a, t.a, e.a));
    }), AG = Pi({
        bQ: "Copy of file ",
        bX: "La copie du fichier "
    }), LG = Pi({
        bQ: " for file ",
        bX: " pour le fichier "
    }), yG = Pi({
        bQ: "Creation of ",
        bX: "La g\xe9n\xe9ration du "
    }), SG = Pi({
        bQ: "deliverable with parameters ",
        bX: "livrable avec pour param\xe8tres "
    }), FG = Pi({
        bQ: " High Res ",
        bX: " Haute Def "
    }), TG = Pi({
        bQ: " and subtitles ",
        bX: " et sous-titres "
    }), QG = F2(function(n, r) {
        var t = n.aZ;
        return "TC IN = " + n.dI + ", TC OUT = " + n.dJ + ", version " + Cm(n.sd) + ", format = " + (r + (t.$ ? "" : $(TG, t.a)));
    }), IG = F3(function(n, r, t) {
        switch(n){
            case 0:
                return "proxy";
            case 1:
                return "proxy" + FG;
            case 3:
            default:
                return "";
            case 2:
                return 1 === t.$ ? SG + "format = " + r : $(SG, A2(QG, t.a, r));
        }
    }), BG = Pi({
        bQ: "organization ",
        bX: "vers l\u2019organisation "
    }), WG = F6(function(n, r, t, e, u, a) {
        var i = A2(Qu, "", A2(Tu, function(n) {
            return $(BG, n);
        }, u));
        return 3 === a ? AG + (n + " ") + (i + e) : yG + (A3(IG, a, t, r) + (LG + (n + " "))) + (i + e);
    }), PG = Pi({
        bQ: " warning",
        bX: " warning"
    }), MG = Pi({
        bQ: " warnings",
        bX: " warnings"
    }), qG = Pi({
        bQ: "files uploaded",
        bX: "fichiers upload\xe9s"
    }), DG = Pi({
        bQ: " sent with success",
        bX: " a \xe9t\xe9 envoy\xe9 avec succ\xe8s"
    }), XG = Pi({
        bQ: "Uploading of ",
        bX: "L'upload de "
    }), EG = Pi({
        bQ: " uploading",
        bX: " est en cours d\u2019upload"
    }), RG = Pi({
        bQ: " and ",
        bX: " et "
    }), xG = Pi({
        bQ: " error ",
        bX: " erreur "
    }), OG = Pi({
        bQ: " errors ",
        bX: " erreurs "
    }), zG = Pi({
        bQ: " failed. Report generation impossible",
        bX: " a \xe9chou\xe9e. Impossible de g\xe9n\xe9rer le rapport"
    }), NG = Pi({
        bQ: "Automated analysis ",
        bX: "L'analyse automatique du fichier "
    }), HG = Pi({
        bQ: " archived program",
        bX: " a archiv\xe9 le programme"
    }), VG = Pi({
        bQ: " commented program",
        bX: " a comment\xe9 le programme"
    }), UG = Pi({
        bQ: " deleted ",
        bX: " a supprim\xe9 "
    }), JG = Pi({
        bQ: " downloaded program",
        bX: " a t\xe9l\xe9charg\xe9 le programme"
    }), ZG = Pi({
        bQ: "program accepted by ",
        bX: "le programme a \xe9t\xe9 accept\xe9 par "
    }), KG = Pi({
        bQ: " required a new version",
        bX: " a demand\xe9 une nouvelle version du programme"
    }), _G = Pi({
        bQ: " created program",
        bX: " a cr\xe9\xe9 le programme"
    }), GG = Pi({
        bQ: " from organization ",
        bX: " de l\u2019organisation "
    }), YG = Pi({
        bQ: " created SFTP access.",
        bX: " a cr\xe9\xe9 un acc\xe9s SFTP."
    }), nY = Pi({
        bQ: " deleted program",
        bX: " a supprim\xe9 le programme"
    }), rY = Pi({
        bQ: " unarchived program",
        bX: " a d\xe9sarchiv\xe9 le programme"
    }), tY = Pi({
        bQ: " undeleted program",
        bX: " a restaur\xe9 le programme"
    }), eY = function(n) {
        switch(n.$){
            case 4:
                return function(n) {
                    switch(n.c9){
                        case 0:
                            return $(n.dC.nW, _G);
                        case 1:
                            return $(ZG, $(n.dC.nW, A2(Qu, " ", A2(Tu, function(n) {
                                return $(GG, n);
                            }, n.dC.gp))));
                        default:
                            return $(n.dC.nW, KG);
                    }
                }(n.a);
            case 3:
                return $(n.a.dC.nW, VG);
            case 1:
                return $(J_, $(n.a.c0, Z_));
            case 0:
                return function(n) {
                    var r = n.c0, t = n.bn;
                    if (1 === n.ll.$) {
                        if (1 === t.$) return $(NG, $(r, V_));
                        var e = t.a;
                        return $(NG, $(r, $(jG, $(Bt(e.nY), $(e.nY > 1 ? OG : xG, $(RG, $(Bt(e.ar), e.ar > 1 ? MG : PG)))))));
                    }
                    return $(NG, $(r, zG));
                }(n.a);
            case 2:
                return e = (t = n.a).c4, u = t.di, a = t.ll, o = t.de, c = t.df, f = t.dg, s = t.aZ, l = t.dH, b = t.dS, A6(WG, t.c0, A4(wG, F3(function(n, r, t) {
                    return {
                        aZ: s,
                        dI: n,
                        dJ: r,
                        sd: t
                    };
                }), o, c, f), e, t.c9 ? 1 === a.$ ? u ? $(jG, $(Bt(u), 1 === u ? PG : MG)) : O_ : z_ : V_, l, b);
            case 5:
                return function(n) {
                    var r, t = (r = n.dh).$ ? "" : "(" + Bt(r.a) + " " + qG + ")", e = d(n.c9, n.ll);
                    return e.a ? 1 === e.b.$ ? $(n.rB, $(DG, t)) : $(XG, $(n.rB, z_)) : $(n.rB, EG);
                }(n.a);
            case 6:
                return function(n) {
                    return $(n.dC.nW, $(A2(Qu, "", A2(Tu, function(n) {
                        return " (" + n + ") ";
                    }, n.dC.gp)), YG));
                }(n.a);
            case 7:
                return (r = n.a).dC.nW + (A2(Qu, "", A2(Tu, function(n) {
                    return " (" + n + ") ";
                }, r.dC.gp)) + (JG + " ")) + r.c0;
            case 8:
                return $(n.a.dC.nW, HG);
            case 11:
                return $(n.a.dC.nW, rY);
            case 9:
                return $(n.a.dC.nW, nY);
            case 10:
                return $(n.a.dC.nW, tY);
            case 12:
                return function(n) {
                    return $(n.dC.nW, $(UG, n.c1));
                }(n.a);
            case 13:
                return function(n) {
                    var r = n.dC, t = n.ru, e = n.cT, u = n.r$, a = n.cY, o = !n.qt;
                    switch(n.c9){
                        case 0:
                            return i(r.mj, t.mj) ? $(r.nW, $(K_, $(A3(hG, e, u, o), eG(a)))) : $(r.nW, $(nG, $(t.nW, $(A3(hG, e, u, o), eG(a)))));
                        case 1:
                            return i(r.mj, t.mj) ? $(r.nW, $(Y_, $(A3(hG, e, u, o), eG(a)))) : $(r.nW, $(Y_, $(t.nW, $(A3(hG, e, u, o), eG(a)))));
                        default:
                            return i(r.mj, t.mj) ? $(r.nW, __) : $(r.nW, $(G_, $(t.nW, A3(hG, e, u, o))));
                    }
                }(n.a);
            case 14:
                return function(n) {
                    var r = n.dD, t = n.c0, e = n.dw;
                    if (n.cy) return "";
                    if (n.c9) {
                        if (1 === n.ll.$) {
                            if (1 === t.$) return $(H_, $(r, 1 === e.$ ? O_ : $(U_, $(e.a, O_))));
                            var u = t.a;
                            return $(H_, $(r, 1 === e.$ ? $(N_, u) : $(U_, $(e.a, $(N_, u)))));
                        }
                        return $(H_, $(r, 1 === e.$ ? z_ : $(U_, $(e.a, z_))));
                    }
                    return $(H_, $(r, 1 === e.$ ? V_ : $(U_, $(e.a, V_))));
                }(n.a);
            default:
                return function(n) {
                    return $(CG, A2(Qu, kG, A2(Tu, function(n) {
                        return n.k6;
                    }, n.dC)));
                }(n.a);
        }
        var r, t, e, u, a, o, c, f, s, l, b;
    }, uY = function(n) {
        switch(n.$){
            case 4:
            case 3:
            case 6:
            case 7:
            case 8:
            case 11:
            case 9:
            case 10:
            case 12:
            case 13:
                return {
                    mj: (r = n.a).mj,
                    g9: r.g9,
                    dC: kt(r.dC),
                    hE: r.hE,
                    h$: r.h$,
                    rB: r.rB
                };
            default:
                var r;
                return {
                    mj: (r = n.a).mj,
                    g9: r.g9,
                    dC: Ct,
                    hE: r.hE,
                    h$: r.h$,
                    rB: r.rB
                };
        }
    }, aY = A2(Po, uY, function(n) {
        return n.h$;
    }), iY = A2(qt, F2(function(n, r) {
        var t = eY(n), e = d(n, r);
        switch(e.a.$){
            case 4:
                var u = e.b;
                return A2(x_, A2((o = e.a.a).c9 ? W_ : F_, t, o.h$), u);
            case 3:
                return u = e.b, A2(x_, A2(S_, t, (o = e.a.a).h$), u);
            case 1:
                return u = e.b, A2(x_, A2(T_, t, (o = e.a.a).h$), u);
            case 0:
                u = e.b;
                var a = (o = e.a.a).bn;
                return A2(x_, A2(a.$ ? D_ : a.a.nY > 0 ? X_ : E_, t, o.h$), u);
            case 2:
                return u = e.b, A2(x_, A2((o = e.a.a).c9 ? I_ : Q_, t, o.h$), u);
            case 5:
                return u = e.b, (o = e.a.a).c9 ? i(o.ll, Ct) ? A2(x_, A2(q_, t, o.h$), u) : A2(x_, A2(P_, t, o.h$), u) : A2(x_, A2(M_, t, o.h$), u);
            case 8:
                return u = e.b, A2(x_, A2(y_, t, (o = e.a.a).h$), u);
            case 11:
                var o;
                return u = e.b, A2(x_, A2(B_, t, (o = e.a.a).h$), u);
            default:
                return u = e.b, A2(x_, A2(W_, t, aY(e.a)), u);
        }
    }), Ct), oY = A2(Po, uY, function(n) {
        return n.g9;
    }), cY = A2(Po, uY, function(n) {
        return n.rB;
    }), fY = F3(function(n, r, t) {
        return A2(Wo, n, function(n) {
            return kt(1 === n.$ ? A2(Gk, r, C([
                t
            ])) : A3(Wo, r, function(n) {
                return kt(1 === n.$ ? C([
                    t
                ]) : A2(bt, t, n.a));
            }, n.a));
        });
    }), sY = (VH = F2(function(n, r) {
        return {
            e9: A2(xi, A2(mu, A2(mu, be(-1), NA), aY), r),
            aJ: !0,
            qs: A2(Qu, "", A2(Tu, oY, Ra(r))),
            Q: iY(r),
            h_: n,
            rB: A2(Qu, "", A2(Tu, cY, Ra(r)))
        };
    }), A2(Po, A2(_e, F2(function(n, r) {
        return A4(fY, wO(aY(n)), oY(n), n, r);
    }), Lu), cl(F2(function(n, r) {
        return A2(cl, VH, r);
    })))), lY = F2(function(n, r) {
        return A2(Tu, function(n) {
            return n.mj;
        }, Ra(A2(nc, function(r) {
            var t = r.fH;
            return i(r.r8.mj, n.r8.mj) ? kt(t) : Ct;
        }, r.fJ)));
    }), dY = F2(function(n, r) {
        return A2(CK, A2(Ge, wp(n), r.D), r);
    }), bY = F2(function(n, r) {
        return A2(XJ, A2(Tu, n, r.ab), r);
    }), mY = F2(function(n, r) {
        return A2(mu, bY(n), dY(r));
    }), pY = F2(function(n, r) {
        return A2(Wo, n, function(n) {
            return n.$ ? Ct : kt(A3(Wo, r, function(n) {
                if (n.$) return Ct;
                var r = n.a;
                return kt(p(r, {
                    aJ: !r.aJ
                }));
            }, n.a));
        });
    }), vY = function(n) {
        return {
            $: 10,
            a: n
        };
    }, $Y = function(n) {
        return {
            $: 8,
            a: n
        };
    }, gY = function(n) {
        return {
            $: 12,
            a: n
        };
    }, hY = function(n) {
        return {
            $: 14,
            a: n
        };
    }, kY = F5(function(n, r, t, e, u) {
        return {
            cT: e,
            k6: n,
            cY: u,
            nE: r,
            r$: t
        };
    }), CY = ul(A4(kb, "expireAt", function(n) {
        return n.cY;
    }, bb, A4(ll, "download", function(n) {
        return n.cT;
    }, Zi, A4(ll, "upload", function(n) {
        return n.r$;
    }, Zi, A4(ll, "message", function(n) {
        return n.nE;
    }, Di, A4(ll, "email", function(n) {
        return n.k6;
    }, Di, gl(kY))))))), jY = F2(function(n, r) {
        return Al(A2(vg, t$, A3(kg, CY, r, $g(xs(Ov(A2(zv, n.mj, 5)))))));
    }), wY = function(n) {
        return p(n, {
            ll: Ct
        });
    }, AY = function(n) {
        return {
            $: 14,
            a: n
        };
    }, LY = function(n) {
        return xs(AY(function(n) {
            return {
                $: 0,
                a: n
            };
        }(n)));
    }, yY = function(n) {
        return Lp(function(r) {
            return Ra(A2(nc, function(r) {
                var t = r.fH;
                return i(r.r8.mj, n.r8.mj) ? kt(t.mj) : Ct;
            }, r.fJ));
        });
    }, SY = function(n) {
        return A2(Fd, "", function(r) {
            if (i(qe(r), n)) {
                var t = Oe(r);
                return t.$ ? ad('Invalid integer: "' + r + '"') : A2(yd, gd, id(t.a));
            }
            return A2(yd, function(n) {
                return hd(A2(Ou, r, n));
            }, ud(jd(Vt)));
        });
    }, FY = function(n) {
        var r = n.b, t = n.c;
        return Vd(A2(kO, 4, n.a) + "-" + A2(kO, 2, r) + "-" + A2(kO, 2, t) + "T00:00:00.000Z");
    }, TY = function(n) {
        var r = A2(md, A2(md, A2(md, id(F3(function(n, r, t) {
            return b(n, r, t);
        })), A2(dd, SY(4), Bd("-"))), A2(dd, SY(2), Bd("-"))), SY(2));
        return A2(gz, FY, A2(hi, Hl("Can't parse date"), A2(Nd, r, n)));
    }, QY = F5(function(n, r, t, e, u) {
        return {
            ke: u,
            fz: n,
            f$: t,
            oN: e,
            gA: r
        };
    }), IY = F4(function(n, r, t, e) {
        var u = e;
        return {
            e: $b(C([
                A3(Te, F2(function(n, r) {
                    return n(r);
                }), u.e, gb(A2(du, n, mi(t))))
            ])),
            g: function(e) {
                return A2(bt, d(n, A2(sl, hb(t), r(e))), u.g(e));
            }
        };
    }), BY = ul(A4(IY, "createdAt", function(n) {
        return n.ke;
    }, bb, A4(IY, "password", function(n) {
        return n.oN;
    }, Di, A4(ll, "login", function(n) {
        return n.f$;
    }, Di, A4(ll, "port", function(n) {
        return n.gA;
    }, ml, A4(ll, "hostname", function(n) {
        return n.fz;
    }, Di, gl(QY))))))), WY = function(n) {
        return xs(AY(function(n) {
            return {
                $: 1,
                a: n
            };
        }(n)));
    }, PY = function(n) {
        return Al(A2(_s, BY, $g(WY(n))));
    }, MY = function(n) {
        return Al(Lg(Ag(WY(n))));
    }, qY = F2(function(n, r) {
        return A2(qK, $(n, r.ln), r);
    }), DY = F4(function(n, r, t, e) {
        switch(n.$){
            case 0:
                return EJ(p(r, {
                    k6: A2(Wg, n.a, r.k6)
                }));
            case 1:
                return EJ(p(r, {
                    nE: A2(Wg, n.a, r.nE)
                }));
            case 2:
                return EJ(p(r, {
                    lq: A2(Wg, n.a, r.lq)
                }));
            case 4:
                return EJ(p(r, {
                    jx: A2(Ig, n.a, r.jx)
                }));
            case 3:
                return EJ(p(r, {
                    jy: A2(Ig, n.a, r.jy)
                }));
            case 5:
                return EJ(r);
            case 6:
                return EJ(p(r, {
                    kQ: !r.kQ
                }));
            case 7:
                return A2(MK, C([
                    A2(Rs, $Y, (b = n.a, Al(Lg(Ag(LY(b.mj))))))
                ]), EJ(wY(r)));
            case 8:
                return (u = n.a).$ ? EJ(p(r, {
                    ll: kt(u.a)
                })) : (d = C([
                    4
                ]), A2(qK, d, DJ));
            case 10:
                var u;
                return (u = n.a).$ ? EJ(p(r, {
                    ll: kt(u.a)
                })) : A2(qY, C([
                    4
                ]), EJ(p(r, {
                    jx: Cc,
                    jy: wc,
                    kQ: !1,
                    k6: yc,
                    lq: Fc,
                    nE: Qc
                })));
            case 9:
                var a = n.a, o = A2(hi, function() {
                    return Ct;
                }, A2(dg, Be, TY(r.lq.sa))), c = {
                    cT: r.jx.sa,
                    k6: r.k6.sa,
                    cY: o.$ ? Ct : kt(o.a),
                    nE: r.nE.sa,
                    r$: r.jy.sa
                };
                return A2(MK, C([
                    A2(Rs, vY, A2(jY, a, c))
                ]), EJ(wY(r)));
            case 11:
                var f = A2(yY, t, e);
                if (f.$) return DJ;
                var s = f.a;
                return i(r.lW, Ct) ? ZK(A2(Rs, gY, function(n) {
                    return A2(Zw, function() {
                        return PY(n);
                    }, MY(n));
                }(s))) : ZK(A2(Rs, gY, PY(s)));
            case 12:
                return EJ(p(r, {
                    lW: kt(n.a)
                }));
            case 13:
                var l = A2(yY, t, e);
                return l.$ ? DJ : ZK(A2(Rs, hY, MY(s = l.a)));
            default:
                return EJ(p(r, 1 === n.a.$ ? {
                    lW: kt(jt(n.a.a))
                } : {
                    lW: Ct
                }));
        }
        var d, b;
    }), XY = function(n) {
        return {
            $: 3,
            a: n
        };
    }, EY = function(n) {
        return {
            $: 4,
            a: n
        };
    }, RY = function(n) {
        return {
            $: 5,
            a: n
        };
    }, xY = function(n) {
        return {
            $: 3,
            a: n
        };
    }, OY = {
        $: 1
    }, zY = {
        $: 2
    }, NY = function(n) {
        return xs(QK(A2(TK, n, 7)));
    }, HY = function(n) {
        return Al(Lg($g(NY(n))));
    }, VY = function(n) {
        return Al(XU($g(function(n) {
            return xs(Ov(A2(zv, n, 1)));
        }(n))));
    }, UY = function(n) {
        return Al(Lg($g(function(n) {
            return xs(QK(A2(TK, n, 9)));
        }(n))));
    }, JY = function(n) {
        return Al(XU($g(function(n) {
            return xs(Ov(A2(zv, n, 3)));
        }(n))));
    }, ZY = function(n) {
        return xs(QK(A2(TK, n, 8)));
    }, KY = function(n) {
        return Al(Lg($g(ZY(n))));
    }, _Y = function(n) {
        return Al(XU($g(function(n) {
            return xs(Ov(A2(zv, n, 2)));
        }(n))));
    }, GY = function(n) {
        return Al(Lg($g(function(n) {
            return xs(QK(A2(TK, n, 10)));
        }(n))));
    }, YY = function(n) {
        return Al(XU($g(function(n) {
            return xs(Ov(A2(zv, n, 4)));
        }(n))));
    }, n1 = F2(function(n, r) {
        switch(n.$){
            case 0:
                return EJ(p(r, {
                    Q: Bc
                }));
            case 1:
                return EJ(p(r, {
                    oq: !r.oq
                }));
            case 2:
                return EJ(p(r, {
                    os: !r.os
                }));
            case 3:
                return (t = n.a).$ ? EJ(p(r, {
                    Q: xY(t.a)
                })) : A2(qY, C([
                    4,
                    0,
                    1
                ]), EJ(p(r, {
                    Q: zY
                })));
            case 4:
                return (t = n.a).$ ? EJ(p(r, {
                    rO: xY(t.a)
                })) : A2(qY, C([
                    4,
                    0,
                    1
                ]), EJ(p(r, {
                    rO: zY
                })));
            case 5:
                var t;
                return (t = n.a).$ ? EJ(p(r, {
                    rY: xY(t.a)
                })) : A2(qY, C([
                    4,
                    0,
                    1
                ]), EJ(p(r, {
                    rY: zY
                })));
            case 6:
                return A2(MK, C([
                    A2(Rs, XY, ((e = n.a).mN ? HY : VY)(e.mj))
                ]), EJ(p(r, {
                    Q: OY
                })));
            case 7:
                return A2(MK, C([
                    A2(Rs, XY, ((e = n.a).mN ? KY : _Y)(e.mj))
                ]), EJ(p(r, {
                    Q: OY
                })));
            case 8:
                return A2(MK, C([
                    A2(Rs, EY, ((e = n.a).mN ? UY : JY)(e.mj))
                ]), EJ(p(r, {
                    Q: OY
                })));
            default:
                var e;
                return A2(MK, C([
                    A2(Rs, RY, ((e = n.a).mN ? GY : YY)(e.mj))
                ]), EJ(p(r, {
                    Q: OY
                })));
        }
    }), r1 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, t1 = {
        $: 1
    }, e1 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, u1 = function(n) {
        return {
            $: 4,
            a: n
        };
    }, a1 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, i1 = function(n) {
        return {
            $: 4,
            a: n
        };
    }, o1 = function(n) {
        return {
            $: 6,
            a: n
        };
    }, c1 = function(n) {
        return Al(A2(_s, BY, $g(WY(n))));
    }, f1 = function(n) {
        return Al(Lg(Ag(WY(n))));
    }, s1 = F2(function(n, r) {
        switch(n.$){
            case 1:
                return EJ(p(r, {
                    gn: !r.gn
                }));
            case 0:
                var t = n.a;
                return A2(jK, A2(Rs, r1, Al(A2(_s, BY, Vs(WY(t))))), EJ(p(r, {
                    fH: t,
                    gn: !0
                })));
            case 3:
                switch(r.lW.$){
                    case 3:
                    case 2:
                        return ZK(A2(Rs, i1, A2(Zw, function() {
                            return c1(e);
                        }, f1(e = r.fH))));
                    default:
                        return ZK(A2(Rs, i1, c1(r.fH)));
                }
            case 2:
                return EJ(p(r, n.a.$ ? {
                    lW: t1
                } : {
                    lW: a1(n.a.a)
                }));
            case 4:
                return EJ(p(r, n.a.$ ? {
                    lW: u1(n.a.a)
                } : {
                    lW: e1(n.a.a)
                }));
            case 5:
                return ZK(A2(Rs, o1, f1(r.fH)));
            default:
                return EJ(p(r, 1 === n.a.$ ? {
                    lW: u1(n.a.a)
                } : {
                    lW: t1,
                    gn: !1
                }));
        }
        var e;
    }), l1 = F3(function(n, r, t) {
        switch(n.$){
            case 0:
                return ZK(s$(r.mj));
            case 2:
                if ((u = n.a).$) return EJ(p(r, {
                    e9: A2(ZZ, u.a, r.e9.kt)
                }));
                var e = u.a;
                return EJ(p(r, {
                    e9: AK(e),
                    rA: sY(e)
                }));
            case 1:
                var u;
                if ((u = n.a).$) return EJ(p(r, {
                    Q: A2(ZZ, u.a, r.Q.kt)
                }));
                var a = u.a;
                return A2(jK, function() {
                    var n = A2(lY, t, a);
                    if (n.$) return p$;
                    var r = n.a;
                    return A2(b$, A2(mu, A_, j_), CA(r));
                }(), EJ(p(r, {
                    ne: !1,
                    Q: AK(a)
                })));
            case 4:
                return A3(mY, function(n) {
                    return p(r, {
                        cT: n
                    });
                }, A_, A2(s1, n.a, r.cT));
            case 5:
                return A3(mY, function(n) {
                    return p(r, {
                        ea: n
                    });
                }, w_, A2(n1, n.a, r.ea));
            case 6:
                return A3(mY, function(n) {
                    return p(r, {
                        fJ: n
                    });
                }, L_, A4(DY, n.a, r.fJ, t, r.Q.kt));
            default:
                var i = n.a;
                return EJ(p(r, {
                    rA: A3(pY, i.a, i.b, r.rA)
                }));
        }
    }), d1 = F2(function(n, r) {
        return p(r, 0 === n.$ ? {
            aN: 1
        } : {
            aN: 0
        });
    }), b1 = function(n) {
        return {
            $: 6,
            a: n
        };
    }, m1 = function(n) {
        return {
            $: 5,
            a: n
        };
    }, p1 = function(n) {
        return {
            $: 7,
            a: n
        };
    }, v1 = function(n) {
        return {
            $: 11,
            a: n
        };
    }, $1 = function(n) {
        return {
            $: 25,
            a: n
        };
    }, g1 = function(n) {
        return {
            $: 29,
            a: n
        };
    }, h1 = function(n) {
        return {
            $: 14,
            a: n
        };
    }, k1 = function(n) {
        return {
            $: 13,
            a: n
        };
    }, C1 = function(n) {
        return {
            $: 8,
            a: n
        };
    }, j1 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, w1 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, A1 = function(n) {
        return {
            $: 4,
            a: n
        };
    }, L1 = function(n) {
        return {
            $: 39,
            a: n
        };
    }, y1 = function(n) {
        return {
            $: 12,
            a: n
        };
    }, S1 = function(n) {
        return {
            $: 21,
            a: n
        };
    }, F1 = F2(function(n, r) {
        return {
            $: 20,
            a: n,
            b: r
        };
    }), T1 = function(n) {
        return {
            $: 23,
            a: n
        };
    }, Q1 = function(n) {
        return {
            $: 27,
            a: n
        };
    }, I1 = F3(function(n, r, t) {
        return A2(rf, r, A8(Rc, n, Oc(n), t, 0, 0, 0, 0, 0));
    }), B1 = F3(function(n, r, t) {
        return A3(qt, F2(function(r, t) {
            return Kc(p(t, {
                lR: A2(n, t.lR, r.lR)
            }));
        }), r, A2(Ge, function(n) {
            return A3(I1, r.fn, n, r.e_);
        }, t));
    }), W1 = F2(function(n, r) {
        return A3(B1, Ft, n, r);
    }), P1 = F2(function(n, r) {
        return A2(W1, r, C([
            n
        ]));
    }), M1 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, q1 = A2(mu, g_, M1), D1 = function(n) {
        return xs(Rq(A2(IR, n, 0)));
    }, X1 = function(n) {
        return Al(Lg(Ag(D1(n))));
    }, E1 = Jn("downloadAll", gi), R1 = function(n) {
        return A2(CK, n, DJ);
    }, x1 = function(n) {
        return A2(qK, C([
            n
        ]), DJ);
    }, O1 = F6(function(n, r, t, e, u, a) {
        return (function(n) {
            return function(r) {
                return function(t) {
                    return function(e) {
                        return function(u) {
                            return function(a) {
                                return function(i) {
                                    return function(o) {
                                        return function(c) {
                                            return function(f) {
                                                return {
                                                    i2: o,
                                                    ev: c,
                                                    e$: t,
                                                    lS: i,
                                                    fR: f,
                                                    nT: r,
                                                    p9: u,
                                                    qa: a,
                                                    qO: n,
                                                    q4: e
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        })(n)(r)(t)(Ct)(e)(g)(u)(a)(Ct)(Ct);
    }), z1 = F2(function(n, r) {
        if (1 === r.$) return n.S;
        var t = r.a;
        return A2(Qu, n.S, Ra(A2(Bu, function(n) {
            return i(n.bF.mj, t);
        }, n.bl)));
    }), N1 = F2(function(n, r) {
        return A2(z1, r, n.oK.bF);
    }), H1 = F3(function(n, r, t) {
        return Ra(A2(Bu, function(n) {
            return i(n.lA.mj, t);
        }, A2(N1, n, r).bT.ef));
    }), V1 = F3(function(n, r, t) {
        return A2(Lp, A2(Po, function(n) {
            return n.o7;
        }, function(n) {
            return n.nm;
        }), A3(H1, n, r, t));
    }), U1 = function(n) {
        return 1 === n.$ ? kt(n.a) : Ct;
    }, J1 = function(n) {
        switch(n){
            case 0:
                return "mono";
            case 1:
                return "dual mono";
            case 2:
                return "stereo";
            case 3:
                return "stereo L";
            case 4:
                return "stereo R";
            case 5:
                return "5.1";
            case 6:
                return "5.1 L";
            case 7:
                return "5.1 R";
            case 8:
                return "5.1 C";
            case 9:
                return "5.1 SL";
            case 10:
                return "5.1 SR";
            case 11:
                return "5.1 LFE";
            case 12:
                return "7.1";
            default:
                return "multiple audio on 1 track";
        }
    }, Z1 = function(n) {
        return A2(Ge, function(n) {
            return A2(ng, n.fB, A2(Tu, J1, n.aD));
        }, A2(xi, function(n) {
            return n.fB;
        }, A2(nc, U1, n.aw)));
    }, K1 = function(n) {
        return A2(Ge, function(n) {
            return A2(ng, n.fB, A2(Tu, J1, n.aD));
        }, A2(xi, function(n) {
            return n.fB;
        }, A2(nc, U1, n.aw)));
    }, _1 = function(n) {
        return n.$ ? Ct : kt(n.a);
    }, G1 = function(n) {
        return A2(Qu, function(n) {
            return A2(Qu, Ct, A2(Tu, function(n) {
                return n.e$;
            }, function(n) {
                return Ra(A2(xi, function(n) {
                    return n.fB;
                }, A2(nc, U1, n.aw)));
            }(n)));
        }(n), A2(Tu, function(n) {
            return n.e$;
        }, Ra(A2(xi, function(n) {
            return n.fB;
        }, A2(nc, _1, n.aw)))));
    }, Y1 = function(n) {
        return A2(Qu, Ct, A2(Tu, function(n) {
            return n.e$;
        }, function(n) {
            return Ra(A2(xi, function(n) {
                return n.fB;
            }, A2(nc, U1, n.aw)));
        }(n)));
    }, n0 = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), r0 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, t0 = function(n) {
        return Al(A2(_s, Em, Vs(function(n) {
            return X$(r0(A2(n0, n, 1)));
        }(n))));
    }, e0 = function(n) {
        return xc(1e3 * n.au / n.at) / 1e3;
    }, u0 = function(n) {
        return A2(Tu, e0, Ra(A2(xi, function(n) {
            return n.fB;
        }, A2(nc, _1, n.aw))));
    }, a0 = function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return {
                                                S: i,
                                                cJ: c,
                                                bM: r,
                                                bS: a,
                                                fJ: f,
                                                c7: u,
                                                dd: e,
                                                oz: t,
                                                bl: o,
                                                g9: n
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }, i0 = F3(function(n, r, t) {
        return {
            bF: n,
            bL: t,
            bT: r
        };
    }), o0 = F9(function(n, r, t, e, u, a, i, o, c) {
        return {
            ke: t,
            eW: e,
            e$: u,
            fn: a,
            fp: c,
            mj: n,
            dt: i,
            g9: r,
            h9: o
        };
    }), c0 = ul(A4(kb, "generatedWithMapping", function(n) {
        return n.fp;
    }, jm, A4(kb, "uploadLog", function(n) {
        return n.h9;
    }, Di, A4(kb, "rejection", function(n) {
        return n.dt;
    }, Di, A4(kb, "framerate", function(n) {
        return n.fn;
    }, yy, A4(kb, "duration", function(n) {
        return n.e$;
    }, yy, A4(kb, "deliveryProgress", function(n) {
        return n.eW;
    }, ml, A4(ll, "createdAt", function(n) {
        return n.ke;
    }, bb, A4(ll, "show", function(n) {
        return n.g9;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(o0))))))))))), f0 = F3(function(n, r, t) {
        return {
            ef: r,
            f2: n,
            ae: t
        };
    }), s0 = F9(function(n, r, t, e, u, a, i, o, c) {
        return {
            a8: r,
            kE: i,
            lA: n,
            o7: e,
            gP: a,
            gQ: u,
            g3: o,
            aw: t,
            hI: c
        };
    }), l0 = F4(function(n, r, t, e) {
        return {
            mj: n,
            gp: t,
            rB: r,
            rN: e
        };
    }), d0 = ul(A4(ll, "transcoding", function(n) {
        return n.rN;
    }, jE, A4(ll, "organizationName", function(n) {
        return n.gp;
    }, Di, A4(ll, "title", function(n) {
        return n.rB;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(l0)))))), b0 = F6(function(n, r, t, e, u, a) {
        return {
            ai: u,
            e$: e,
            A: n,
            fi: t,
            c4: r,
            hZ: a
        };
    }), m0 = ul(A4(kb, "timecode", function(n) {
        return n.hZ;
    }, Di, A4(kb, "bitRate", function(n) {
        return n.ai;
    }, ml, A4(kb, "duration", function(n) {
        return n.e$;
    }, yy, A4(ll, "formatLongName", function(n) {
        return n.fi;
    }, Di, A4(ll, "formatName", function(n) {
        return n.c4;
    }, Di, A4(ll, "fileId", function(n) {
        return n.A;
    }, Di, gl(b0)))))))), p0 = F7(function(n, r, t, e, u, a, i) {
        return {
            ke: e,
            bM: t,
            lA: u,
            bd: a,
            be: i,
            mj: n,
            m$: r
        };
    }), v0 = function(n) {
        switch(n){
            case 0:
                return "openingCredits";
            case 1:
                return "endingCredits";
            case 2:
                return "introduction";
            case 3:
                return "program";
            case 4:
                return "trailer";
            case 5:
                return "advertising";
            case 6:
                return "testPattern";
            case 7:
                return "black";
            case 8:
                return "slate";
            case 9:
                return "neutralBases";
            default:
                return "customDelivery";
        }
    }, $0 = function(n) {
        switch(n){
            case "openingCredits":
                return yt(0);
            case "endingCredits":
                return yt(1);
            case "introduction":
                return yt(2);
            case "program":
                return yt(3);
            case "trailer":
                return yt(4);
            case "advertising":
                return yt(5);
            case "testPattern":
                return yt(6);
            case "black":
                return yt(7);
            case "slate":
                return yt(8);
            case "neutralBases":
                return yt(9);
            case "customDelivery":
                return yt(10);
            default:
                return jt("Can't parse segment from string: " + n);
        }
    }, g0 = A2(zl, v0, $0), h0 = ul(A4(ll, "frameOut", function(n) {
        return n.be;
    }, ml, A4(ll, "frameIn", function(n) {
        return n.bd;
    }, ml, A4(ll, "file", function(n) {
        return n.lA;
    }, Di, A4(ll, "createdAt", function(n) {
        return n.ke;
    }, bb, A4(ll, "creator", function(n) {
        return n.bM;
    }, i$, A4(ll, "label", function(n) {
        return n.m$;
    }, g0, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(p0))))))))), k0 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, C0 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, j0 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, w0 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, A0 = function(n) {
        switch(n){
            case "Mono":
                return yt(0);
            case "DualMono":
                return yt(1);
            case "Stereo":
                return yt(2);
            case "StereoL":
                return yt(3);
            case "StereoR":
                return yt(4);
            case "FiveDotOne":
                return yt(5);
            case "FiveDotOneL":
                return yt(6);
            case "FiveDotOneR":
                return yt(7);
            case "FiveDotOneC":
                return yt(8);
            case "FiveDotOneSL":
                return yt(9);
            case "FiveDotOneSR":
                return yt(10);
            case "FiveDotOneLFE":
                return yt(11);
            case "SevenDotOne":
                return yt(12);
            case "OneTrack":
                return yt(13);
            default:
                return jt("Unknown Layout");
        }
    }, L0 = function(n) {
        switch(n){
            case 0:
                return "Mono";
            case 1:
                return "DualMono";
            case 2:
                return "Stereo";
            case 3:
                return "StereoL";
            case 4:
                return "StereoR";
            case 5:
                return "FiveDotOne";
            case 6:
                return "FiveDotOneL";
            case 7:
                return "FiveDotOneR";
            case 8:
                return "FiveDotOneC";
            case 9:
                return "FiveDotOneSL";
            case 10:
                return "FiveDotOneSR";
            case 11:
                return "FiveDotOneLFE";
            case 12:
                return "SevenDotOne";
            default:
                return "OneTrack";
        }
    }, y0 = A2(zl, L0, A0), S0 = function(n) {
        switch(n){
            case "ORIGINAL":
                return yt(0);
            case "DUBBED":
                return yt(1);
            case "AD":
                return yt(2);
            case "MUTE":
                return yt(3);
            case "INT":
                return yt(4);
            case "ME":
                return yt(5);
            case "VONLY":
                return yt(6);
            case "C1":
                return yt(7);
            case "C2":
                return yt(8);
            case "C3":
                return yt(9);
            case "C4":
                return yt(10);
            case "C5":
                return yt(11);
            case "C6":
                return yt(12);
            case "C7":
                return yt(13);
            case "C8":
                return yt(14);
            case "C9":
                return yt(15);
            case "C10":
                return yt(16);
            default:
                return jt("Not an audio type version");
        }
    }, F0 = function(n) {
        switch(n){
            case 0:
                return "ORIGINAL";
            case 1:
                return "DUBBED";
            case 2:
                return "AD";
            case 3:
                return "MUTE";
            case 4:
                return "INT";
            case 5:
                return "ME";
            case 6:
                return "VONLY";
            case 7:
                return "C1";
            case 8:
                return "C2";
            case 9:
                return "C3";
            case 10:
                return "C4";
            case 11:
                return "C5";
            case 12:
                return "C6";
            case 13:
                return "C7";
            case 14:
                return "C8";
            case 15:
                return "C9";
            default:
                return "C10";
        }
    }, T0 = A2(zl, F0, S0), Q0 = ul(A4(kb, "typeVersion", function(n) {
        return n.rQ;
    }, T0, A4(kb, "version", function(n) {
        return n.sd;
    }, P$, A4(kb, "channelLayout", function(n) {
        return n.aD;
    }, y0, A4(kb, "bitRate", function(n) {
        return n.ai;
    }, ml, A4(ll, "bitsPerSample", function(n) {
        return n.eo;
    }, ml, A4(ll, "channels", function(n) {
        return n.cJ;
    }, ml, A4(ll, "sampleFormat", function(n) {
        return n.gZ;
    }, Di, A4(ll, "sampleRate", function(n) {
        return n.g_;
    }, ml, A4(kb, "duration", function(n) {
        return n.e$;
    }, yy, A4(ll, "codecLongName", function(n) {
        return n.aF;
    }, Di, A4(ll, "codecName", function(n) {
        return n.aj;
    }, Di, A4(ll, "index", function(n) {
        return n.fB;
    }, ml, A4(ll, "fileId", function(n) {
        return n.A;
    }, Di, gl(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return {
                                                            ai: f,
                                                            eo: c,
                                                            aD: s,
                                                            cJ: o,
                                                            aF: e,
                                                            aj: t,
                                                            e$: u,
                                                            A: n,
                                                            fB: r,
                                                            gZ: i,
                                                            g_: a,
                                                            rQ: d,
                                                            sd: l
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))), I0 = F3(function(n, r, t) {
        return {
            A: n,
            fB: r,
            hZ: t
        };
    }), B0 = ul(A4(kb, "timecode", function(n) {
        return n.hZ;
    }, Di, A4(ll, "index", function(n) {
        return n.fB;
    }, ml, A4(ll, "fileId", function(n) {
        return n.A;
    }, Di, gl(I0))))), W0 = ul(A4(kb, "typeVersion", function(n) {
        return n.rQ;
    }, Ry, A4(kb, "subtitleType", function(n) {
        return n.hF;
    }, Di, A4(kb, "lastCueTimecode", function(n) {
        return n.fT;
    }, Di, A4(kb, "firstCueTimecode", function(n) {
        return n.ff;
    }, Di, A4(kb, "startTimecode", function(n) {
        return n.qO;
    }, Di, A4(kb, "frameRateDenominator", function(n) {
        return n.fl;
    }, ml, A4(kb, "frameRateNumerator", function(n) {
        return n.fm;
    }, ml, A4(kb, "version", function(n) {
        return n.sd;
    }, P$, A4(kb, "codecLongName", function(n) {
        return n.aF;
    }, Di, A4(kb, "codecName", function(n) {
        return n.aj;
    }, Di, A4(ll, "index", function(n) {
        return n.fB;
    }, ml, A4(ll, "fileId", function(n) {
        return n.A;
    }, Di, gl(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return {
                                                        aF: e,
                                                        aj: t,
                                                        A: n,
                                                        ff: c,
                                                        fl: i,
                                                        fm: a,
                                                        fB: r,
                                                        fT: f,
                                                        qO: o,
                                                        hF: s,
                                                        rQ: l,
                                                        sd: u
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))), P0 = ul(A4(kb, "nbFrames", function(n) {
        return n.gi;
    }, ml, A4(kb, "timecode", function(n) {
        return n.hZ;
    }, Di, A4(kb, "scanningType", function(n) {
        return n.g$;
    }, Di, A4(kb, "chromaSubsampling", function(n) {
        return n.cK;
    }, Di, A4(kb, "profile", function(n) {
        return n.gG;
    }, Di, A4(kb, "level", function(n) {
        return n.m5;
    }, ml, A4(ll, "rFrameRateDenominator", function(n) {
        return n.at;
    }, ml, A4(ll, "rFrameRateNumerator", function(n) {
        return n.au;
    }, ml, A4(kb, "bitRate", function(n) {
        return n.ai;
    }, ml, A4(ll, "displayAspectRatioDenominator", function(n) {
        return n.cR;
    }, ml, A4(ll, "displayAspectRatioNumerator", function(n) {
        return n.cS;
    }, ml, A4(ll, "height", function(n) {
        return n.ft;
    }, ml, A4(ll, "width", function(n) {
        return n.ih;
    }, ml, A4(kb, "duration", function(n) {
        return n.e$;
    }, yy, A4(ll, "codecLongName", function(n) {
        return n.aF;
    }, Di, A4(ll, "codecName", function(n) {
        return n.aj;
    }, Di, A4(ll, "index", function(n) {
        return n.fB;
    }, ml, A4(ll, "fileId", function(n) {
        return n.A;
    }, Di, gl(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(m) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return function($) {
                                                                            return {
                                                                                ai: f,
                                                                                cK: m,
                                                                                aF: e,
                                                                                aj: t,
                                                                                cR: c,
                                                                                cS: o,
                                                                                e$: u,
                                                                                A: n,
                                                                                ft: i,
                                                                                fB: r,
                                                                                m5: d,
                                                                                gi: $,
                                                                                gG: b,
                                                                                at: l,
                                                                                au: s,
                                                                                g$: p,
                                                                                hZ: v,
                                                                                ih: a
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))))))))), M0 = yb(A4(Wm, "DataStream", C0, B0, A4(Wm, "SubtitleStream", j0, W0, A4(Wm, "AudioStream", k0, Q0, A4(Wm, "VideoStream", w0, P0, Tb(F5(function(n, r, t, e, u) {
        switch(u.$){
            case 0:
                return n(u.a);
            case 1:
                return r(u.a);
            case 2:
                return t(u.a);
            default:
                return e(u.a);
        }
    }))))))), q0 = F2(function(n, r) {
        return {
            fv: r,
            nm: n
        };
    }), D0 = ul(A4(kb, "hiRes", function(n) {
        return n.fv;
    }, $R, A4(kb, "lowRes", function(n) {
        return n.nm;
    }, $R, gl(q0)))), X0 = F2(function(n, r) {
        return {
            nW: n,
            hZ: r
        };
    }), E0 = ul(A4(ll, "timecode", function(n) {
        return n.hZ;
    }, Di, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, gl(X0)))), R0 = ul(A4(ll, "subtitleWarnings", function(n) {
        return n.hI;
    }, $l(E0), A4(ll, "segments", function(n) {
        return n.g3;
    }, $l(h0), A4(ll, "deliveries", function(n) {
        return n.kE;
    }, $l(d0), A4(kb, "reportPdf", function(n) {
        return n.gP;
    }, $R, A4(kb, "reportXml", function(n) {
        return n.gQ;
    }, $R, A4(ll, "proxies", function(n) {
        return n.o7;
    }, D0, A4(ll, "streams", function(n) {
        return n.aw;
    }, $l(M0), A4(kb, "container", function(n) {
        return n.a8;
    }, m0, A4(ll, "file", function(n) {
        return n.lA;
    }, $R, gl(s0))))))))))), x0 = ul(A4(ll, "subtitles", function(n) {
        return n.ae;
    }, $l(R0), A4(ll, "audios", function(n) {
        return n.ef;
    }, $l(R0), A4(kb, "material", function(n) {
        return n.f2;
    }, R0, gl(f0))))), O0 = F2(function(n, r) {
        return {
            c2: n,
            sc: r
        };
    }), z0 = function(n) {
        switch(n){
            case "RedFlag":
                return yt(0);
            case "OrangeFlag":
                return yt(1);
            case "GreenFlag":
                return yt(2);
            default:
                return yt(3);
        }
    }, N0 = function(n) {
        switch(n){
            case 0:
                return "RedFlag";
            case 1:
                return "OrangeFlag";
            case 2:
                return "GreenFlag";
            default:
                return "BlueFlag";
        }
    }, H0 = A2(zl, N0, z0), V0 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, U0 = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), J0 = F3(function(n, r, t) {
        return {
            e_: t,
            lS: r,
            sa: n
        };
    }), Z0 = ul(A4(ll, "dropFrame", function(n) {
        return n.e_;
    }, Zi, A4(ll, "frameRate", function(n) {
        return n.lS;
    }, yy, A4(ll, "value", function(n) {
        return n.sa;
    }, ml, gl(J0))))), K0 = F4(function(n, r, t, e) {
        return A3(Bm, n, F3(function(n, r, u) {
            return n(C([
                A2(sl, t, r),
                A2(sl, e, u)
            ]));
        }), A3(Te, r, A2(Oo, 1, mi(t)), A2(Oo, 2, mi(e))));
    }), _0 = yb(A5(K0, "VerificationRange", U0, Z0, Z0, A4(Wm, "VerificationFrame", V0, Z0, A3(cR, "Verification", lf, Tb(F4(function(n, r, t, e) {
        switch(e.$){
            case 0:
                return n;
            case 1:
                return r(e.a);
            default:
                return A2(t, e.a, e.b);
        }
    })))))), G0 = ul(A4(ll, "verification", function(n) {
        return n.sc;
    }, _0, A4(ll, "flag", function(n) {
        return n.c2;
    }, H0, gl(O0)))), Y0 = F7(function(n, r, t, e, u, a, i) {
        return {
            bK: a,
            ke: t,
            bM: r,
            mj: n,
            nE: i,
            cu: u,
            cv: e
        };
    }), n2 = ul(A4(ll, "message", function(n) {
        return n.nE;
    }, Di, A4(ll, "comment", function(n) {
        return n.bK;
    }, Di, A4(ll, "updatedAt", function(n) {
        return n.cu;
    }, bb, A4(ll, "updater", function(n) {
        return n.cv;
    }, Di, A4(ll, "createdAt", function(n) {
        return n.ke;
    }, bb, A4(ll, "creator", function(n) {
        return n.bM;
    }, i$, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(Y0))))))))), r2 = $l(n2), t2 = F3(function(n, r, t) {
        return {
            e: A2(Fe, n, mi(t)),
            g: function(n) {
                return A2(sl, t, r(n));
            }
        };
    }), e2 = A3(t2, function(n) {
        return function(n) {
            return {
                $: 0,
                a: n
            };
        }(n);
    }, function(n) {
        return n.a;
    }, Di), u2 = ul(A4(ll, "answers", function(n) {
        return n.d9;
    }, r2, A4(ll, "annotations", function(n) {
        return n.T;
    }, $l(G0), A4(kb, "frame", function(n) {
        return n.bY;
    }, Z0, A4(ll, "message", function(n) {
        return n.nE;
    }, Di, A4(ll, "broadcastable", function(n) {
        return n.bF;
    }, Di, A4(ll, "updatedAt", function(n) {
        return n.cu;
    }, bb, A4(ll, "updater", function(n) {
        return n.cv;
    }, Di, A4(ll, "createdAt", function(n) {
        return n.ke;
    }, bb, A4(ll, "creator", function(n) {
        return n.bM;
    }, i$, A4(ll, "id", function(n) {
        return n.mj;
    }, e2, gl(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return {
                                                T: c,
                                                d9: f,
                                                bF: a,
                                                ke: t,
                                                bM: r,
                                                bY: o,
                                                mj: n,
                                                nE: i,
                                                cu: u,
                                                cv: e
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))), a2 = $l(u2), i2 = ul(A4(ll, "comments", function(n) {
        return n.bL;
    }, a2, A4(ll, "files", function(n) {
        return n.bT;
    }, x0, A4(ll, "broadcastable", function(n) {
        return n.bF;
    }, c0, gl(i0))))), o2 = $l(i2), c2 = F5(function(n, r, t, e, u) {
        return {
            a8: e,
            lA: n,
            gL: r,
            g3: t,
            aw: u
        };
    }), f2 = ul(A4(ll, "streams", function(n) {
        return n.aw;
    }, $l(M0), A4(kb, "container", function(n) {
        return n.a8;
    }, m0, A4(ll, "segments", function(n) {
        return n.g3;
    }, $l(h0), A4(kb, "proxy", function(n) {
        return n.gL;
    }, $R, A4(ll, "file", function(n) {
        return n.lA;
    }, $R, gl(c2))))))), s2 = $l(f2), l2 = F2(function(n, r) {
        return {
            fH: n,
            r8: r
        };
    }), d2 = ul(A4(ll, "user", function(n) {
        return n.r8;
    }, i$, A4(ll, "invitation", function(n) {
        return n.fH;
    }, t$, gl(l2)))), b2 = function(n) {
        switch(n){
            case "QC":
                return yt(1);
            case "Spotcheck":
                return yt(0);
            case "DownloadAsIs":
                return yt(2);
            case "SimpleTranscode":
                return yt(3);
            case "PADTranscode":
                return yt(4);
            default:
                return jt("Can't parse jobtype " + n);
        }
    }, m2 = A2(zl, Lf, b2), p2 = ul(A4(kb, "format", function(n) {
        return n.lP;
    }, Di, A4(kb, "externalJobId", function(n) {
        return n.lt;
    }, Di, A4(ll, "jobType", function(n) {
        return n.fO;
    }, m2, A4(ll, "requester", function(n) {
        return n.pr;
    }, Di, A4(ll, "organization", function(n) {
        return n.oz;
    }, Di, A4(ll, "show", function(n) {
        return n.g9;
    }, Di, A4(kb, "completedAt", function(n) {
        return n.j_;
    }, bb, A4(kb, "startedAt", function(n) {
        return n.qP;
    }, bb, A4(ll, "createdAt", function(n) {
        return n.ke;
    }, bb, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return {
                                                j_: e,
                                                ke: r,
                                                lt: c,
                                                lP: f,
                                                mj: n,
                                                fO: o,
                                                oz: a,
                                                pr: i,
                                                g9: u,
                                                qP: t
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))), v2 = function(n) {
        switch(n){
            case "1.33":
                return yt(0);
            case "1.66":
                return yt(1);
            case "1.77":
                return yt(2);
            case "1.85":
                return yt(3);
            case "2.00":
                return yt(4);
            case "2.20":
                return yt(5);
            case "2.35":
                return yt(6);
            case "2.39":
                return yt(7);
            case "2.40":
                return yt(8);
            default:
                return jt("Can't parse aspect ratio " + n);
        }
    }, $2 = A2(zl, Pf, v2), g2 = function(n) {
        switch(n){
            case "SD":
                return yt(0);
            case "HD":
                return yt(1);
            case "UHD":
                return yt(2);
            case "2k":
                return yt(3);
            case "4k":
                return yt(4);
            case "DCP":
                return yt(5);
            default:
                return jt("Can't parse file format " + n);
        }
    }, h2 = A2(zl, qf, g2), k2 = function(n) {
        switch(n){
            case "Master":
                return yt(0);
            case "Clean":
                return yt(1);
            default:
                return jt("Can't parse file type " + n);
        }
    }, C2 = A2(zl, rs, k2), j2 = function(n) {
        switch(n){
            case "Program":
                return yt(0);
            case "Trailer":
                return yt(1);
            case "Teaser":
                return yt(2);
            case "Neutral bases":
                return yt(3);
            default:
                return jt("Can't parse program type " + n);
        }
    }, w2 = A2(zl, ts, j2), L2 = ul(A4(kb, "idBroadcaster", function(n) {
        return n.b_;
    }, Di, A4(kb, "legalMentions", function(n) {
        return n.b2;
    }, Di, A4(kb, "originalAspectRatio", function(n) {
        return n.cb;
    }, $2, A4(kb, "displayAspectRatio", function(n) {
        return n.bP;
    }, $2, A4(kb, "fileFormat", function(n) {
        return n.lB;
    }, h2, A4(kb, "fileType", function(n) {
        return n.F;
    }, C2, A4(kb, "programType", function(n) {
        return n.ci;
    }, w2, A4(kb, "productionYear", function(n) {
        return n.ch;
    }, ml, A4(kb, "productionCompanyName", function(n) {
        return n.cg;
    }, Di, A4(ll, "enableAutoAccept", function(n) {
        return n.k8;
    }, Zi, A4(kb, "broadcasterShowId", function(n) {
        return n.jr;
    }, Di, A4(kb, "firstBroadcastedAt", function(n) {
        return n.lF;
    }, bb, A4(ll, "show", function(n) {
        return n.g9;
    }, Di, gl(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return {
                                                            jr: t,
                                                            bP: f,
                                                            k8: e,
                                                            lB: c,
                                                            F: o,
                                                            lF: r,
                                                            b_: d,
                                                            b2: l,
                                                            cb: s,
                                                            cg: u,
                                                            ch: a,
                                                            ci: i,
                                                            g9: n
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))), y2 = F2(function(n, r) {
        return {
            mj: n,
            nW: r
        };
    }), S2 = ul(A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(y2)))), T2 = F2(function(n, r) {
        return {
            mj: n,
            nW: r
        };
    }), Q2 = ul(A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(T2)))), I2 = ul(A4(ll, "subtitleFormats", function(n) {
        return n.dF;
    }, $l(Q2), A4(ll, "formats", function(n) {
        return n.c5;
    }, $l(S2), A4(kb, "logo", function(n) {
        return n.nh;
    }, Di, A4(ll, "allowDeliveryWithoutTranscoding", function(n) {
        return n.iI;
    }, Zi, A4(ll, "manualDelivery", function(n) {
        return n.nA;
    }, Zi, A4(kb, "broadcaster", function(n) {
        return n.jq;
    }, N$, A4(ll, "enableAutoReject", function(n) {
        return n.la;
    }, Zi, A4(ll, "enableAutoAccept", function(n) {
        return n.k8;
    }, Zi, A4(ll, "enableUploadSuccessEmail", function(n) {
        return n.ld;
    }, Zi, A4(ll, "enableVideoReadyEmail", function(n) {
        return n.le;
    }, Zi, A4(ll, "enableCreationEmail", function(n) {
        return n.lb;
    }, Zi, A4(ll, "qcMasterReportTemplate", function(n) {
        return n.pa;
    }, Di, A4(ll, "qcMasterTestPlan", function(n) {
        return n.pb;
    }, Di, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "createdAt", function(n) {
        return n.ke;
    }, bb, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(m) {
                                                                return function(p) {
                                                                    return {
                                                                        iI: d,
                                                                        jq: s,
                                                                        ke: r,
                                                                        k8: c,
                                                                        la: f,
                                                                        lb: a,
                                                                        ld: o,
                                                                        le: i,
                                                                        c5: m,
                                                                        mj: n,
                                                                        nh: b,
                                                                        nA: l,
                                                                        nW: t,
                                                                        pa: u,
                                                                        pb: e,
                                                                        dF: p
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))))))), B2 = ul(A4(ll, "invitations", function(n) {
        return n.fJ;
    }, $l(d2), A4(ll, "channels", function(n) {
        return n.cJ;
    }, $l(Ej), A4(ll, "previousBroadcastables", function(n) {
        return n.bl;
    }, o2, A4(ll, "activeBroadcastable", function(n) {
        return n.S;
    }, i2, A4(ll, "extras", function(n) {
        return n.bS;
    }, s2, A4(ll, "jobs", function(n) {
        return n.c7;
    }, $l(p2), A4(ll, "metadata", function(n) {
        return n.dd;
    }, L2, A4(ll, "organization", function(n) {
        return n.oz;
    }, I2, A4(ll, "creator", function(n) {
        return n.bM;
    }, i$, A4(ll, "show", function(n) {
        return n.g9;
    }, ip, gl(a0)))))))))))), W2 = function(n) {
        return Al(A2(_s, B2, Vs(IK(n))));
    }, P2 = function(n) {
        return 3 === n.$ ? kt(n.a) : Ct;
    }, M2 = function(n) {
        return Ra(A2(xi, function(n) {
            return n.fB;
        }, A2(nc, _1, n.aw)));
    }, q2 = F2(function(n, r) {
        return r.$ ? n : kt(r.a);
    }), D2 = function(n) {
        var r = A2(Lp, function(n) {
            return n.hZ;
        }, M2(n)), t = A2(Lp, function(n) {
            return n.hZ;
        }, Ra(A2(xi, function(n) {
            return n.fB;
        }, A2(nc, P2, n.aw))));
        return A2(q2, r, A2(q2, t, A2(Lp, function(n) {
            return n.hZ;
        }, n.a8)));
    }, X2 = function(n) {
        var r = A2(Lp, function(n) {
            return n.hZ;
        }, Ra(A2(xi, function(n) {
            return n.fB;
        }, A2(nc, _1, n.aw)))), t = A2(Lp, function(n) {
            return n.hZ;
        }, Ra(A2(xi, function(n) {
            return n.fB;
        }, A2(nc, P2, n.aw))));
        return A2(q2, r, A2(q2, t, A2(Lp, function(n) {
            return n.hZ;
        }, n.a8)));
    }, E2 = function(n) {
        return n.Q.nc || n.e9.nc;
    }, R2 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, x2 = function(n) {
        return X$(r0(A2(n0, n, 0)));
    }, O2 = F2(function(n, r) {
        return n ? A2(Rs, R2, function(n) {
            return Al(A2(_s, L2, Vs(x2(n))));
        }(r)) : p$;
    }), z2 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, N2 = A2(mu, g_, z2), H2 = F2(function(n, r) {
        return A2(Tu, A2(mu, function(n) {
            return n.ev;
        }, function(n) {
            return n.lA;
        }), A2(N1, n, r).bT.f2);
    }), V2 = F2(function(n, r) {
        return A2(Tu, A2(mu, function(n) {
            return n.fR;
        }, function(n) {
            return n.lA;
        }), A2(N1, n, r).bT.f2);
    }), U2 = F2(function(n, r) {
        return A2(Lp, function(n) {
            var r = n.rN;
            return r.$ ? Ct : 5 === r.a.oQ ? kt(n) : Ct;
        }, A2(Lp, A2(Po, function(n) {
            return n.o7;
        }, n.ir.l$ ? function(n) {
            return n.fv;
        } : function(n) {
            return n.nm;
        }), A2(N1, n, r).bT.f2));
    }), J2 = function(n) {
        var r = n.Q.kt;
        if (1 === r.$) return Ct;
        var t, e = r.a, u = (t = A2(Tu, function(n) {
            return n.q4;
        }, n.oR)).$ || t.a.$ ? Ct : kt(t.a.a), a = A2(N1, n, e).bT.f2, i = A2(Qu, "00:00:00:00", A2(Lp, D2, a)), o = A2(Lp, function(n) {
            return kt((n.au / n.at * 1e3 | 0) / 1e3);
        }, A2(Lp, M2, a)), c = A2(Lp, function(n) {
            return n.e$;
        }, A2(Lp, M2, a));
        return A2(Tu, function(r) {
            return {
                i2: A2(Qu, g, A2(Tu, Z1, a)),
                ev: A2(H2, n, e),
                e$: c,
                lS: o,
                fR: A2(V2, n, e),
                nT: A2(Qu, r.mj, A2(Tu, function(n) {
                    return n.nT;
                }, n.oR)),
                p9: A2(Lp, function(n) {
                    return n.p9;
                }, n.oR),
                qa: A2(Qu, g, A2(Tu, function(n) {
                    return n.qa;
                }, n.oR)),
                qO: i,
                q4: u
            };
        }, A2(U2, n, e));
    }, Z2 = function(n) {
        return p(n.i6, {
            p8: Ct
        });
    }, K2 = F2(function(n, r) {
        var t;
        return p(n.oU, {
            lS: 1 === (t = r.lS).$ ? 0 : t.a,
            qO: r.qO,
            q4: r.q4
        });
    }), _2 = F2(function(n, r) {
        var t = J2(n);
        return EJ(p(n, {
            i6: r ? Z2(n) : n.i6,
            oR: t,
            oU: 1 === t.$ ? n.oU : A2(K2, n, t.a)
        }));
    }), G2 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Y2 = A2(mu, g_, G2), n3 = function(n) {
        var r = n.Q;
        return p(n, {
            e9: p(n.e9, {
                nc: !0
            }),
            Q: p(r, {
                nc: !0
            })
        });
    }, r3 = Jn("info", function() {
        return pi;
    }), t3 = r3(0), e3 = Jn("getPlayerName", function() {
        return pi;
    }), u3 = e3(0), a3 = function(n) {
        return A2(b$, Be, CA(function(n) {
            return {
                $: 35,
                a: n
            };
        }(n)));
    }, i3 = function(n) {
        switch(n){
            case 0:
            case 4:
            case 5:
            default:
                return 3;
            case 1:
            case 6:
                return 0;
            case 2:
            case 7:
                return 1;
            case 3:
            case 8:
                return 2;
        }
    }, o3 = F3(function(n, r, t) {
        return {
            ip: n,
            ew: r,
            bY: t
        };
    }), c3 = F2(function(n, r) {
        return {
            e6: r,
            ht: n
        };
    }), f3 = A3(Te, c3, A2(du, "start", Ay), A2(du, "end", Ay)), s3 = an, l3 = A4(s3, o3, A2(du, "action", Bi), A2(du, "buffer", pl(f3)), A2(du, "frame", dl)), d3 = F4(function(n, r, t, e) {
        return A2(rf, t, A8(Rc, n, Oc(n), e, 0, 0, 0, r, 0));
    }), b3 = Jn("elmToJs", Be), m3 = (UH = $i(C([
        d("action", gi("Fullscreen"))
    ])), b3(UH)), p3 = F3(function(n, r, t) {
        var e = $i(C([
            d("action", gi("GetPicture")),
            d("rawFrame", $i(C([
                d("frameRate", Ly(t.lS)),
                d("bucket", gi(n)),
                d("key", gi(r))
            ])))
        ]));
        return b3(e);
    }), v3 = function() {
        var n = $i(C([
            d("action", gi("GoToEnd"))
        ]));
        return b3(n);
    }(), $3 = function() {
        var n = $i(C([
            d("action", gi("GoToStart"))
        ]));
        return b3(n);
    }(), g3 = function() {
        var n = $i(C([
            d("action", gi("NextFrame"))
        ]));
        return b3(n);
    }(), h3 = function() {
        var n = $i(C([
            d("action", gi("Pause"))
        ]));
        return b3(n);
    }(), k3 = function() {
        var n = $i(C([
            d("action", gi("Play"))
        ]));
        return b3(n);
    }(), C3 = function() {
        var n = $i(C([
            d("action", gi("PrevFrame"))
        ]));
        return b3(n);
    }(), j3 = F2(function(n, r) {
        var t = $i(C([
            d("action", gi(n + "Time")),
            d("seconds", Ly(r))
        ]));
        return b3(t);
    }), w3 = F2(function(n, r) {
        switch(n.$){
            case 0:
                return d(p(r, {
                    mI: !1,
                    mM: !0
                }), k3);
            case 1:
                return d(p(r, {
                    mM: !1
                }), h3);
            case 6:
                return d(r, A2(j3, n.a, n.b));
            case 2:
                return d(p(r, {
                    kl: 0,
                    kn: A4(d3, r.lS, 0, "00:00:00:00", !1)
                }), $3);
            case 3:
                return d(r, v3);
            case 4:
                return function(n) {
                    return d(n, n.mM ? p$ : g3);
                }(r);
            case 5:
                return function(n) {
                    return d(n, n.mM ? p$ : C3);
                }(r);
            case 7:
                return d(r, m3);
            case 8:
                return d(p(r, {
                    i_: !r.i_
                }), p$);
            case 9:
                var t = n.a, e = n.b;
                return d(r, A3(p3, t.$ ? "" : t.a, e.$ ? "" : e.a, r));
            case 10:
                return d(p(r, {
                    gz: n.a
                }), p$);
            default:
                var u = (a = A2(bi, l3, n.a)).$ ? {
                    ip: "",
                    ew: g,
                    bY: 0
                } : a.a;
                return d("Added" === u.ip ? p(r, {
                    iy: !0
                }) : "Buffering" === u.ip ? p(r, {
                    mG: !0
                }) : "StopBuffering" === u.ip ? p(r, {
                    mG: !1
                }) : "Finished" === u.ip ? p(r, {
                    mI: !0,
                    mM: !1
                }) : "Loaded" === u.ip ? p(r, {
                    ew: u.ew
                }) : "Playing" === u.ip ? p(r, {
                    kl: u.bY,
                    kn: A4(d3, r.lS, u.bY, "00:00:00:00", !1),
                    mI: !1,
                    mM: !0
                }) : "isPaused" === u.ip ? p(r, {
                    kl: u.bY,
                    kn: A4(d3, r.lS, u.bY, "00:00:00:00", !1),
                    mM: !1
                }) : r, p$);
        }
        var a;
    }), L3 = function(n) {
        return {
            $: 6,
            a: n
        };
    }, y3 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, S3 = function(n) {
        return {
            $: 8,
            a: n
        };
    }, T3 = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Q3 = {
        $: 3
    }, I3 = {
        $: 1
    }, B3 = Pi({
        bQ: "The selected channel doesn\u2019t exist",
        bX: "La chaine s\xe9lectionn\xe9e n\u2019existe pas."
    }), W3 = Pi({
        bQ: "You need to choose another channel",
        bX: "Vous devez choisir une chaine."
    }), P3 = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), M3 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, q3 = function(n) {
        return X$(M3(A2(P3, n, 1)));
    }, D3 = ul(A4(kb, "channel", function(n) {
        return n.bG;
    }, Di, gl(function(n) {
        return {
            bG: n
        };
    }))), X3 = F2(function(n, r) {
        var t = "" === r ? Ct : kt(r);
        return Al(Lg(A3(kg, D3, {
            bG: t
        }, $g(q3(n.mj)))));
    }), E3 = F4(function(n, r, t, e) {
        var u = wu(t) ? CA(0) : "" === e ? ZS(JS(A2(ki, W3, vi))) : A2(bu, function(n) {
            return i(n.sa, e);
        }, t) ? CA(0) : ZS(JS(A2(ki, B3, vi)));
        return A2(Zw, function() {
            return function(n) {
                return Al(Lg($g(xs(QK(A2(TK, n.mj, 6))))));
            }(n);
        }, A2(Zw, function() {
            return n.c9 ? CA(0) : A2(X3, r, e);
        }, u));
    }), R3 = ul(A4(ll, "rejection", function(n) {
        return n.dt;
    }, Di, gl(function(n) {
        return {
            dt: n
        };
    }))), x3 = F2(function(n, r) {
        return A2(bp, function() {
            return 0;
        }, Al(A2(_s, c0, A3(kg, R3, {
            dt: r
        }, $g(xs(QK(A2(TK, n.mj, 4))))))));
    }), O3 = function(n) {
        return 1 === n.$;
    }, z3 = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), N3 = function(n) {
        return {
            $: 18,
            a: n
        };
    }, H3 = F2(function(n, r) {
        return Al(Lg(Sg(xs(N3(A2(z3, r.mj, 2))))));
    }), V3 = A2(Po, Wq, $U), U3 = F2(function(n, r) {
        switch(n.$){
            case 0:
                return EJ(p(r, {
                    gn: !r.gn
                }));
            case 1:
                return EJ(p(r, {
                    nx: A2(Wg, n.a, r.nx)
                }));
            case 2:
                return EJ(p(r, {
                    nw: A2(Wg, n.a, r.nw)
                }));
            case 3:
                var t = n.a, e = n.b, u = O3(r.ny) ? r : p(r, {
                    ny: I3
                });
                return A2(MK, C([
                    A2(Rs, T3, A2(H3, t, e))
                ]), EJ(u));
            case 4:
            case 6:
                return (o = n.a).$ ? EJ(p(r, {
                    ny: y3(o.a)
                })) : A2(DK, 1, EJ(p(r, {
                    nw: V3(r.nw),
                    nx: V3(r.nx),
                    ny: af
                })));
            case 5:
                t = n.a;
                var a = n.b, i = n.c;
                return O3(r.ny) ? DJ : A2(MK, C([
                    A2(Rs, L3, A4(E3, t, a, i, r.nw.sa))
                ]), EJ(p(r, {
                    ny: I3
                })));
            case 7:
                return t = n.a, O3(r.ny) ? DJ : "" === r.nx.sa ? EJ(p(r, {
                    ny: Q3
                })) : A2(MK, C([
                    A2(Rs, S3, A2(x3, t, r.nx.sa))
                ]), EJ(p(r, {
                    ny: I3
                })));
            case 8:
                var o;
                return (o = n.a).$ ? EJ(p(r, {
                    ny: y3(o.a)
                })) : A2(DK, 2, EJ(p(r, {
                    nw: V3(r.nw),
                    nx: V3(r.nx),
                    ny: af,
                    gn: !1
                })));
            default:
                return EJ(p(r, {
                    ny: af
                }));
        }
    }), J3 = F2(function(n, r) {
        return {
            $: 28,
            a: n,
            b: r
        };
    }), Z3 = F2(function(n, r) {
        return {
            $: 26,
            a: n,
            b: r
        };
    }), K3 = F2(function(n, r) {
        return {
            $: 24,
            a: n,
            b: r
        };
    }), _3 = F2(function(n, r) {
        return {
            $: 22,
            a: n,
            b: r
        };
    }), G3 = F2(function(n, r) {
        return {
            $: 19,
            a: n,
            b: r
        };
    }), Y3 = function(n) {
        return {
            $: 14,
            a: n
        };
    }, n6 = function(n) {
        return {
            $: 42,
            a: n
        };
    }, r6 = function(n) {
        return {
            $: 38,
            a: n
        };
    }, t6 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, e6 = {
        $: 1
    }, u6 = F2(function(n, r) {
        return {
            $: 20,
            a: n,
            b: r
        };
    }), a6 = function(n) {
        return {
            $: 15,
            a: n
        };
    }, i6 = function(n) {
        return {
            $: 40,
            a: n
        };
    }, o6 = function(n) {
        return {
            $: 45,
            a: n
        };
    }, c6 = {
        $: 2
    }, f6 = F7(function(n, r, t, e, u, a, i) {
        return {
            bK: a,
            ke: t,
            bM: r,
            mj: n,
            nE: i,
            cu: u,
            cv: e
        };
    }), s6 = ul(A4(ll, "message", function(n) {
        return n.nE;
    }, Di, A4(ll, "comment", function(n) {
        return n.bK;
    }, Di, A4(ll, "updatedAt", function(n) {
        return n.cu;
    }, bb, A4(ll, "updater", function(n) {
        return n.cv;
    }, Di, A4(ll, "createdAt", function(n) {
        return n.ke;
    }, bb, A4(ll, "creator", function(n) {
        return n.bM;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(f6))))))))), l6 = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), d6 = function(n) {
        return {
            $: 16,
            a: n
        };
    }, b6 = function(n) {
        return n.a;
    }, m6 = ul(A4(ll, "message", function(n) {
        return n.nE;
    }, Di, gl(function(n) {
        return {
            nE: n
        };
    }))), p6 = F2(function(n, r) {
        var t;
        return Al(A2(vg, s6, A3(kg, m6, {
            nE: r
        }, $g((t = b6(n.mj), xs(d6(A2(l6, t, 1))))))));
    }), v6 = F9(function(n, r, t, e, u, a, i, o, c) {
        return {
            T: c,
            et: a,
            ke: t,
            bM: r,
            fo: o,
            mj: n,
            nE: i,
            cu: u,
            cv: e
        };
    }), $6 = ul(A4(ll, "annotations", function(n) {
        return n.T;
    }, $l(G0), A4(kb, "frame", function(n) {
        return n.fo;
    }, Z0, A4(ll, "message", function(n) {
        return n.nE;
    }, Di, A4(kb, "broadcastableId", function(n) {
        return n.et;
    }, Di, up(v6)))))), g6 = function(n) {
        return xs(N3(A2(z3, n, 3)));
    }, h6 = F3(function(n, r, t) {
        return {
            T: t,
            bY: r,
            nE: n
        };
    }), k6 = ul(A4(ll, "annotations", function(n) {
        return n.T;
    }, $l(G0), A4(kb, "frame", function(n) {
        return n.bY;
    }, Z0, A4(ll, "message", function(n) {
        return n.nE;
    }, Di, gl(h6))))), C6 = function(n) {
        return {
            e_: n.e_,
            lS: n.fn,
            sa: n.lR
        };
    }, j6 = function(n) {
        var r = n.bD, t = n.nE;
        return Al(A2(vg, $6, A3(kg, k6, {
            T: g,
            bY: A2(Tu, C6, n.kp),
            nE: t
        }, $g(g6(r)))));
    }, w6 = function(n) {
        return Al(Lg(Sg(xs(tA(function(n) {
            return {
                $: 2,
                a: n
            };
        }(n))))));
    }, L6 = F4(function(n, r, t, e) {
        return {
            lt: t,
            lP: e,
            fO: r,
            g9: n
        };
    }), y6 = ul(A4(kb, "format", function(n) {
        return n.lP;
    }, Di, A4(kb, "externalJobId", function(n) {
        return n.lt;
    }, Di, A4(ll, "jobType", function(n) {
        return n.fO;
    }, Yw, A4(ll, "show", function(n) {
        return n.g9;
    }, Di, gl(L6)))))), S6 = F2(function(n, r) {
        var t = r.r8.oz;
        if (t.$) return ZS(A3(el, 1, "Organization not available", Lu));
        var e = t.a, u = n.mR.sa;
        if (u.$) return ZS(A3(el, 1, "JobType not selected", Lu));
        var a = _w(u.a);
        return a.$ ? ZS(A3(el, 1, "JobType not found", Lu)) : Al(Lg(A3(kg, y6, A4(L6, r.g9.mj, a.a, Ct, Ct), $g(function(n) {
            return xs(tA(function(n) {
                return {
                    $: 0,
                    a: n
                };
            }(n)));
        }(e)))));
    }), T6 = F3(function(n, r, t) {
        return {
            bd: r,
            be: t,
            m$: n
        };
    }), Q6 = ul(A4(ll, "frameOut", function(n) {
        return n.be;
    }, ml, A4(ll, "frameIn", function(n) {
        return n.bd;
    }, ml, A4(ll, "label", function(n) {
        return n.m$;
    }, g0, gl(T6))))), I6 = function(n) {
        return xs(Rq(A2(IR, n, 13)));
    }, B6 = function(n) {
        return Al(XU(A3(kg, Q6, {
            bd: n.bd,
            be: n.be,
            m$: n.m$
        }, $g(I6(n.A)))));
    }, W6 = function(n) {
        return xs(function(n) {
            return {
                $: 17,
                a: n
            };
        }(n));
    }, P6 = function(n) {
        return Al(Lg(Ag(W6(n.mj))));
    }, M6 = function(n) {
        return xs(d6(A2(l6, n, 0)));
    }, q6 = function(n) {
        return Al(Lg(Ag(M6(n))));
    }, D6 = Pi({
        bQ: "Error while trying to delete comment",
        bX: "Echec de la suppression du commentaire."
    }), X6 = function(n) {
        return xs(function(n) {
            return {
                $: 27,
                a: n
            };
        }(n));
    }, E6 = function(n) {
        return Al(Lg(Ag(X6(n))));
    }, R6 = m6, x6 = F2(function(n, r) {
        return Al(A2(_s, s6, A3(kg, R6, {
            nE: r
        }, Sg(W6(n.mj)))));
    }), O6 = F2(function(n, r) {
        return {
            T: r,
            nE: n
        };
    }), z6 = ul(A4(ll, "annotations", function(n) {
        return n.T;
    }, $l(G0), A4(ll, "message", function(n) {
        return n.nE;
    }, Di, gl(O6)))), N6 = F3(function(n, r, t) {
        var e, u = (e = A2(Lo, b6(r.mj), n.k0)).$ ? r.T : C([
            e.a
        ]);
        return Al(A2(_s, $6, A3(kg, z6, {
            T: u,
            nE: t
        }, Sg(M6(b6(r.mj))))));
    }), H6 = function(n) {
        return Xi(function(r) {
            return p(r, {
                sa: n
            });
        });
    }, V6 = F2(function(n, r) {
        return A2(Ye, function(r) {
            return A2(nu, function(n) {
                return d(r, n);
            }, n(r));
        }, r);
    }), U6 = F3(function(n, r, t) {
        var e, u = $0(t), a = (e = A2(Lo, b6(r.mj), n.k0)).$ ? A2(dD, "No annotations", Ra(r.T)) : yt(e.a), i = A2(gz, function(n) {
            var t = n.sc;
            return 2 === t.$ ? yt(d(t.a.sa, t.b.sa)) : jt("Can't get frame info from annotations for segment " + b6(r.mj));
        }, a);
        return A2(Zw, function(n) {
            var t = n.b;
            return Al(XU(A3(kg, Q6, {
                bd: t.a,
                be: t.b,
                m$: n.a
            }, Sg(X6(b6(r.mj))))));
        }, A2(nl, function(n) {
            return JS(A2(ki, n, L$));
        }, A2(V6, function() {
            return KS(i);
        }, KS(u))));
    }), J6 = function(n) {
        var r = $i(C([
            d("action", gi("GoTo")),
            d("frame", bl(n))
        ]));
        return b3(r);
    }, Z6 = function(n) {
        return Ra(Jt(A2(xi, A2(mu, NA, function(n) {
            return n.ke;
        }), A2(Bu, function(n) {
            return i(n.j_, Ct) && i(n.qP, Ct);
        }, A2(Bu, function(n) {
            return 1 === n.fO || !n.fO;
        }, n)))));
    }, K6 = function(n) {
        return Ra(Jt(A2(xi, A2(mu, NA, function(n) {
            return n.ke;
        }), A2(Bu, function(n) {
            return i(n.j_, Ct) && !i(n.qP, Ct);
        }, A2(Bu, function(n) {
            return 1 === n.fO || !n.fO;
        }, n)))));
    }, _6 = A3(jU, "message", C([
        A2(Po, function(n) {
            return n.nE;
        }, AU)
    ]), wU), G6 = A3(jU, "message", C([
        A2(Po, function(n) {
            return n.nE;
        }, AU)
    ]), wU), Y6 = function(n) {
        switch(n){
            case "G\xe9n\xe9rique":
            case "Programme":
            case "Trailer":
            case "Mire":
            case "Noir":
            case "Panneau":
            case "Fonds neutres":
                return kt(3);
            default:
                return Ct;
        }
    }, n4 = function(n) {
        return Al(Lg(Sg(xs(tA(function(n) {
            return {
                $: 1,
                a: n
            };
        }(n))))));
    }, r4 = function(n) {
        return Al(Lg($g(xs(Rq(A2(IR, n, 6))))));
    }, t4 = function(n) {
        return p(n, {
            gn: !n.gn
        });
    }, e4 = F2(function(n, r) {
        return p(r, {
            c2: n
        });
    }), u4 = F3(function(n, r, t) {
        var e = function() {
            var e = d(n, t.sc);
            if (e.a) switch(e.b.$){
                case 1:
                case 2:
                    return A2(U0, e.b.a, r);
                default:
                    return t.sc;
            }
            else switch(e.b.$){
                case 0:
                case 1:
                    return V0(r);
                default:
                    return A2(U0, r, e.b.b);
            }
        }();
        return p(t, {
            sc: e
        });
    }), a4 = Pi({
        bQ: "Answer",
        bX: "R\xe9pondre"
    }), i4 = Xi(function(n) {
        return p(n, {
            gy: a4
        });
    }), o4 = F3(function(n, r, t) {
        return A3(Wo, n, function(n) {
            return kt(A2(Wg, r, 1 === n.$ ? i4 : n.a));
        }, t);
    }), c4 = F3(function(n, r, t) {
        return A3(Wo, n, function(n) {
            return 1 === n.$ ? Ct : kt(A3(IU, $U(n.a), "message", r));
        }, t);
    }), f4 = F2(function(n, r) {
        return p(n, {
            sa: kt(r)
        });
    }), s4 = function(n) {
        var r = n.bD, t = n.nE;
        return Al(A2(vg, $6, A3(kg, k6, {
            T: C([
                n.iP
            ]),
            bY: Ct,
            nE: t
        }, $g(g6(r)))));
    }, l4 = F3(function(n, r, t) {
        n: for(;;)switch(n.$){
            case 35:
                return EJ(n.a.$ ? p(r, {
                    p1: gX($0(M = n.a.a)),
                    p2: A2(f4, r.p2, M)
                }) : p(r, {
                    p2: t4(r.p2)
                }));
            case 36:
                return EJ(n.a.$ ? p(r, {
                    mR: A2(f4, r.mR, M = n.a.a)
                }) : p(r, {
                    mR: t4(r.mR)
                }));
            case 0:
                var e = n.a, u = r.iP, a = function() {
                    var n = Y6(r.nE.sa);
                    return 1 === n.$ ? r : p(r, {
                        iP: p(u, {
                            c2: n.a
                        })
                    });
                }();
                return EJ(p(a, {
                    nE: A2(Wg, e, r.nE)
                }));
            case 1:
                return EJ(p(r, {
                    iP: A3(u4, n.a, C6(t.kn), r.iP)
                }));
            case 2:
                return EJ(p(r, {
                    iP: A2(e4, n.a, r.iP),
                    p1: Ct
                }));
            case 37:
                return A2(MK, C([
                    A2(Rs, r6, A2(S6, r, n.a))
                ]), EJ(p(r, {
                    jZ: sf,
                    kb: e6,
                    qM: sf
                })));
            case 38:
                return (P = n.a).$ ? EJ(p(r, {
                    kb: t6(P.a)
                })) : A2(DK, 1, EJ(p(r, {
                    jZ: sf,
                    kb: c6,
                    qM: sf
                })));
            case 39:
                var i = Z6(n.a);
                return i.$ ? EJ(r) : A2(MK, C([
                    A2(Rs, i6, n4(i.a.mj))
                ]), EJ(p(r, {
                    jZ: sf,
                    kb: sf,
                    qM: e6
                })));
            case 40:
                return (P = n.a).$ ? EJ(p(r, {
                    qM: t6(P.a)
                })) : A2(DK, 1, EJ(p(r, {
                    jZ: sf,
                    kb: sf,
                    qM: c6
                })));
            case 41:
                var o = K6(n.a);
                return o.$ ? EJ(r) : A2(MK, C([
                    A2(Rs, n6, w6(o.a.mj))
                ]), EJ(p(r, {
                    jZ: e6,
                    kb: sf,
                    qM: sf
                })));
            case 42:
                return (P = n.a).$ ? EJ(p(r, {
                    jZ: t6(P.a)
                })) : A2(DK, 1, EJ(p(r, {
                    jZ: c6,
                    kb: sf,
                    qM: sf
                })));
            case 43:
                return EJ(r);
            case 3:
                return EJ(p(r, {
                    iP: p(u = r.iP, {
                        sc: lf
                    })
                }));
            case 4:
                var c = A2(Ig, e = n.a, r.hZ), f = c.sa ? kt(t.kn) : Ct;
                return EJ(p(r, {
                    kp: f,
                    hZ: c
                }));
            case 34:
                var s = n.a;
                return EJ(p(r, {
                    kp: kt(A2(P1, s.qO, A3(tf, FS(s.lS), s.fo, !1)))
                }));
            case 5:
                return EJ(p(r, {
                    d9: A3(o4, n.a, e = n.b, r.d9)
                }));
            case 6:
                var l = n.b;
                return EJ(p(r, {
                    k3: A3(Wo, M = n.a, function(n) {
                        return 1 === n.$ ? Ct : kt(A2(Wg, l, n.a));
                    }, r.k3)
                }));
            case 7:
                var d = n.a, m = A2(TU, G6, {
                    nE: r.nE.sa
                });
                if (m.$) {
                    n = Y3(jt(JS(k = m.a)));
                    continue n;
                }
                return R1(C([
                    A2(Rs, Y3, j6({
                        bD: d.mj,
                        kp: r.kp,
                        nE: r.nE.sa
                    }))
                ]));
            case 8:
                d = n.a;
                var v = n.b, $ = b(r.iP.c2, r.iP.sc, r.p1);
                if (3 !== $.a || 2 !== $.b.$ || $.c.$) return R1(C([
                    A2(Rs, Y3, s4({
                        iP: r.iP,
                        bD: d.mj,
                        kp: r.kp,
                        nE: A2(Qu, r.nE.sa, A2(Tu, v0, r.p1))
                    }))
                ]));
                var h = $.b;
                return R1(C([
                    A2(Rs, a6, B6({
                        A: v.mj,
                        bd: h.a.sa,
                        be: h.b.sa,
                        m$: $.c.a
                    }))
                ]));
            case 14:
                if ((P = n.a).$) {
                    var k = P.a;
                    return EJ(p(r, {
                        nE: A3(IU, $U(r.nE), "message", k)
                    }));
                }
                return A2(DK, 1, EJ(p(r, {
                    kp: Ct,
                    nE: $U(Wq(r.nE)),
                    hZ: A2(Qg, r.hZ, !1)
                })));
            case 15:
                return (P = n.a).$ ? (k = P.a, EJ(p(r, {
                    nE: A3(IU, $U(r.nE), "message", k)
                }))) : A2(DK, 1, EJ(p(r, {
                    kp: Ct,
                    nE: $U(Wq(r.nE)),
                    hZ: A2(Qg, r.hZ, !1)
                })));
            case 44:
                return A2(MK, C([
                    A2(Rs, o6, r4(n.a))
                ]), EJ(p(r, {
                    qN: e6
                })));
            case 45:
                return (P = n.a).$ ? EJ(p(r, {
                    qN: t6(P.a)
                })) : A2(DK, 1, EJ(p(r, {
                    qN: c6
                })));
            case 16:
                return EJ(p(r, {
                    k3: A3(ju, M = n.a.mj, H6(l = n.a.nE), r.k3)
                }));
            case 17:
                return EJ(p(r, {
                    k3: A2(Bo, M = n.a, r.k3)
                }));
            case 18:
                var j = A2(Lo, b6((F = n.a).mj), r.k3);
                if (1 === j.$) return DJ;
                var w = A2(TU, G6, {
                    nE: (I = j.a).sa
                });
                if (w.$) {
                    n = A2(G3, F, jt(JS(k = w.a)));
                    continue n;
                }
                return R1(C([
                    A2(Rs, G3(F), A3(N6, r, F, I.sa))
                ]));
            case 19:
                var A = n.a;
                return (P = n.b).$ ? (k = P.a, EJ(p(r, {
                    k3: A3(c4, b6(A.mj), k, r.k3)
                }))) : A2(DK, 1, EJ(p(r, {
                    k3: A2(Bo, P.a.mj, r.k3)
                })));
            case 20:
                return A = n.a, (P = n.b).$ ? (k = P.a, EJ(p(r, {
                    k3: A3(c4, b6(A.mj), k, r.k3)
                }))) : A2(DK, 1, EJ(p(r, {
                    k3: A2(Bo, b6(A.mj), r.k3)
                })));
            case 9:
                var L = A2(Lo, b6((F = n.a).mj), r.k3);
                if (1 === L.$) return DJ;
                var y = A2(TU, G6, {
                    nE: (I = L.a).sa
                });
                if (y.$) {
                    n = A2(G3, F, jt(JS(k = y.a)));
                    continue n;
                }
                return R1(C(F.mj.$ ? [
                    A2(Rs, u6(F), A3(U6, r, F, I.sa))
                ] : [
                    A2(Rs, G3(F), A3(N6, r, F, I.sa))
                ]));
            case 13:
                return A = n.a, (P = n.b).$ ? (k = P.a, EJ(p(r, {
                    k3: A3(c4, b6(A.mj), k, r.k3)
                }))) : A2(DK, 1, EJ(p(r, {
                    k3: A2(Bo, P.a.mj, r.k3)
                })));
            case 10:
                return u = n.a, EJ(p(r, {
                    k0: A3(ju, M = n.b, A3(u4, n.c, C6(t.kn), u), r.k0)
                }));
            case 12:
                return EJ(p(r, {
                    k0: A3(ju, M = n.b, p(u = n.a, {
                        sc: lf
                    }), r.k0)
                }));
            case 11:
                return EJ(p(r, {
                    k0: A3(ju, M = n.b, A2(e4, n.c, u = n.a), r.k0)
                }));
            case 21:
                var S = (F = n.a).mj;
                return A2(MK, C(S.$ ? [
                    A2(Rs, _3(M = S.a), E6(M))
                ] : [
                    A2(Rs, _3(M = S.a), q6(M))
                ]), EJ(p(r, {
                    ll: Ct
                })));
            case 22:
                return (P = n.b).$ ? EJ(p(r, {
                    ll: kt(D6)
                })) : x1(1);
            case 23:
                l = A2(Qu, "", A2(Tu, function(n) {
                    return n.sa;
                }, A2(Lo, b6((F = n.a).mj), r.d9)));
                var F, T = A2(TU, _6, {
                    nE: l
                });
                if (T.$) {
                    n = A2(K3, F, jt(JS(k = T.a)));
                    continue n;
                }
                return R1(C([
                    A2(Rs, K3(F), A2(p6, F, l))
                ]));
            case 24:
                return A = n.a, (P = n.b).$ ? (k = P.a, EJ(p(r, {
                    d9: A3(c4, b6(A.mj), k, r.d9)
                }))) : A2(DK, 1, EJ(p(r, {
                    d9: A2(Bo, b6(A.mj), r.d9)
                })));
            case 25:
                var Q = A2(Lo, (W = n.a).mj, r.k3);
                if (1 === Q.$) return DJ;
                var I, B = A2(TU, _6, {
                    iP: g,
                    nE: (I = Q.a).sa
                });
                if (B.$) {
                    n = A2(Z3, W, jt(JS(k = B.a)));
                    continue n;
                }
                return R1(C([
                    A2(Rs, Z3(W), A2(x6, W, I.sa))
                ]));
            case 26:
                var W = n.a;
                return (P = n.b).$ ? EJ(p(r, {
                    k3: A3(c4, W.mj, k = P.a, r.k3)
                })) : A2(DK, 1, EJ(p(r, {
                    k3: A2(Bo, P.a.mj, r.k3)
                })));
            case 27:
                return R1(C([
                    A2(Rs, J3((W = n.a).mj), P6(W))
                ]));
            case 28:
                var P, M = n.a;
                return (P = n.b).$ ? EJ(p(r, {
                    d9: A3(c4, M, k = P.a, r.d9)
                })) : x1(1);
            case 29:
                return EJ(p(r, {
                    is: !r.is
                }));
            case 30:
                return EJ(p(r, {
                    it: !r.it
                }));
            case 33:
                return DJ;
            case 31:
                return EJ(p(r, {
                    jY: !r.jY
                }));
            default:
                return R1(C([
                    J6(n.a)
                ]));
        }
    }), d4 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, b4 = function(n) {
        return {
            $: 5,
            a: n
        };
    }, m4 = {
        $: 6
    }, p4 = function(n) {
        return {
            $: 10,
            a: n
        };
    }, v4 = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), $4 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, g4 = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), h4 = function(n) {
        return {
            $: 7,
            a: n
        };
    }, k4 = Pi({
        bQ: "Wrong layout and/or version",
        bX: "Erreur sur une version et/ou un agencement"
    }), C4 = F4(function(n, r, t, e) {
        return {
            aD: t,
            fB: n,
            rQ: e,
            sd: r
        };
    }), j4 = ul(A4(ll, "typeVersion", function(n) {
        return n.rQ;
    }, T0, A4(ll, "channelLayout", function(n) {
        return n.aD;
    }, y0, A4(kb, "version", function(n) {
        return n.sd;
    }, P$, A4(ll, "index", function(n) {
        return n.fB;
    }, ml, gl(C4)))))), w4 = F5(function(n, r, t, e, u) {
        var a = b(r, t, e);
        return a.b.$ || a.c.$ ? ZS({
            lz: Lu,
            nE: k4,
            Q: 400
        }) : Al(Lg(A3(kg, j4, {
            aD: a.b.a,
            fB: u,
            rQ: a.c.a,
            sd: r
        }, $g(X$(h4(A2(g4, n, 0)))))));
    }), L4 = Jn("clean", function() {
        return pi;
    }), y4 = Jn("get", function(n) {
        return $i(C([
            d("channels", vl(bl)(n.cJ)),
            d("fileId", gi(n.A))
        ]));
    }), S4 = function(n) {
        return i(n, F0(2)) || i(n, F0(1)) || i(n, F0(0));
    }, T4 = F2(function(n, r) {
        return d(r.a, n(r.b));
    }), Q4 = F3(function(n, r, t) {
        return t.$ ? n : r(t.a);
    }), I4 = Jn("save", vl(function(n) {
        return $i(C([
            d("index", bl(n.fB)),
            d("layout", function(n) {
                return A3(Q4, pi, gi, n);
            }(n.m3)),
            d("typeVersion", function(n) {
                return A3(Q4, pi, gi, n);
            }(n.rQ)),
            d("version", function(n) {
                return A3(Q4, pi, gi, n);
            }(n.sd))
        ]));
    })), B4 = F2(function(n, r) {
        switch(n.$){
            case 8:
                var t = n.a, e = n.b;
                return e.$ ? EJ(p(r, {
                    ll: kt(e.a)
                })) : A2(DK, 1, EJ(p(r, {
                    ll: Ct,
                    pg: g,
                    sf: A2(Bo, t, r.sf)
                })));
            case 10:
                return DJ;
            case 3:
                var u = n.a, a = n.b, o = n.c, c = n.d, f = {
                    m3: Xi(function(n) {
                        return p(n, {
                            m$: "Disposition",
                            sa: A2(Qu, "", c)
                        });
                    }),
                    rQ: Xi(function(n) {
                        return p(n, {
                            m$: "TypeVersion",
                            sa: A2(Qu, "", a)
                        });
                    }),
                    sd: Xi(function(n) {
                        return p(n, {
                            m$: "Version",
                            sa: A2(Qu, "", o)
                        });
                    })
                };
                return EJ(p(r, {
                    pg: C([
                        u
                    ]),
                    sf: A3(ju, u, f, r.sf)
                }));
            case 0:
                var s = n.b;
                return EJ(p(r, {
                    sf: A3(Wo, t = n.a, Tu(function(n) {
                        return p(n, {
                            sd: A2(Wg, s, n.sd)
                        });
                    }), r.sf)
                }));
            case 2:
                return s = n.b, EJ(p(r, {
                    sf: A3(Wo, t = n.a, Tu(function(n) {
                        return p(n, {
                            rQ: A2(Wg, s, n.rQ)
                        });
                    }), r.sf)
                }));
            case 6:
                return A2(DK, 1, EJ(r));
            case 5:
                return A2(MK, C([
                    A2(b$, Hl(m4), Qx(200))
                ]), EJ(r));
            case 7:
                return EJ(p(r, {
                    pg: g,
                    sf: A2(Bo, u = n.a, r.sf)
                }));
            case 1:
                return s = n.b, EJ(p(r, {
                    sf: A3(Wo, t = n.a, Tu(function(n) {
                        return p(n, {
                            m3: A2(Wg, s, n.m3)
                        });
                    }), r.sf)
                }));
            case 9:
                var l = (P = d(n.a, r.p8)).a.$ ? Ct : 1 === P.a.a.$ ? 1 === P.b.$ ? kt($4(B = P.a.a.a)) : 1 === P.b.a.$ ? i(B = P.a.a.a, P.b.a.a) ? Ct : kt($4(B)) : kt($4(B = P.a.a.a)) : 1 === P.b.$ || P.b.a.$ ? kt(d4(W = P.a.a.a)) : i(W = P.a.a.a, P.b.a.a) ? Ct : kt(d4(W));
                return A2(MK, C([
                    A2(b$, p4, CA(l))
                ]), EJ(p(r, {
                    p8: l
                })));
            case 4:
                t = n.a;
                var m = function(n) {
                    var r = Oe(n);
                    return r.$ ? -1 : r.a;
                }, v = function() {
                    var n = A2(Lo, t, r.sf);
                    if (1 === n.$) return b(Ct, Ct, Ct);
                    var e = n.a.sd, u = n.a.m3, a = n.a.rQ, i = S4(a.sa) ? e.sa : "NOTHING";
                    return b(gX(B$(i)), gX(A0(u.sa)), gX(S0(a.sa)));
                }(), $ = v.a, h = v.b, k = v.c, j = A2(T4, m, (M = A2(Pt, "/", t)).b && M.b.b ? d(M.a, M.b.a) : d("", "")), w = j.a, A = j.b;
                return A2(MK, C([
                    A2(Rs, v4(t), A5(w4, w, $, h, k, A))
                ]), EJ(r));
            case 11:
                var L = n.a, y = A2(Tu, function(n) {
                    return n.fR;
                }, Ra(L)), S = function() {
                    if (y.$) return p$;
                    var n = Ra(A2(Pt, "/", y.a));
                    if (n.$) return p$;
                    var r = n.a;
                    return y4({
                        cJ: A2(Ge, function(n) {
                            return n.fB;
                        }, L),
                        A: r
                    });
                }();
                return ZK(S);
            case 12:
                return R1(C([
                    A2(Rs, b4, (I = n.a, A3(qt, F2(function(n, r) {
                        var t = n.a, e = n.b;
                        return A2(Zw, function() {
                            var n = Ra(A2(Bu, function(n) {
                                return i(n.fB, t + 1);
                            }, I.bn));
                            if (n.$) return CA(0);
                            var r = n.a;
                            return A5(w4, I.A, gX(B$(A2(Qu, "NOTHING", r.sd))), gX(A0(r.m3)), gX(S0(r.rQ)), e);
                        }, r);
                    }), CA(0), A2(Ot, ng, I.cJ))))
                ]));
            case 14:
                return R1(C([
                    L4(0),
                    r3(0)
                ]));
            case 15:
                var F = n.a;
                return R1(C([
                    I4(A2(Ot, F2(function(n, r) {
                        return {
                            fB: n + 1,
                            m3: A2(Tu, L0, r.m3),
                            rQ: A2(Tu, F0, r.rQ),
                            sd: A2(Tu, W$, r.sd)
                        };
                    }), F)),
                    r3(0)
                ]));
            default:
                var T = n.a, Q = Dt(T) ? A3(qt, F2(function(n, r) {
                    return r + "stream " + Bt(n.fB) + " " + A2(Qu, "", n.sd) + " " + A2(Ii, " ", A2(dg, J1, A0(n.m3))) + " " + n.rQ;
                }), "", T) : "";
                return EJ(p(r, {
                    pM: kt(Q)
                }));
        }
        var I, B, W, P, M;
    }), W4 = F2(function() {
        return DJ;
    }), P4 = F4(function(n, r, t, e) {
        return {
            $: 4,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), M4 = function(n) {
        return {
            $: 6,
            a: n
        };
    }, q4 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, D4 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, X4 = {
        $: 1
    }, E4 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, R4 = {
        $: 1
    }, x4 = {
        $: 0
    }, O4 = {
        $: 0
    }, z4 = F2(function(n, r) {
        return A2(Ye, function(r) {
            var t = r.a, e = r.b;
            return A2(nu, function(n) {
                return b(t, e, n);
            }, n(d(t, e)));
        }, r);
    }), N4 = Pi({
        bQ: "Please qualify audio before deliver.",
        bX: "Veuillez qualifier les pistes audios avant de livrer."
    }), H4 = Pi({
        bQ: "Choose one or more segments to include",
        bX: "Choisissez un ou plusieurs segments \xe0 inclure"
    }), V4 = F2(function(n, r) {
        return {
            ae: r,
            cr: n
        };
    }), U4 = F3(function(n, r, t) {
        return {
            lP: t,
            mj: n,
            nW: r
        };
    }), J4 = ul(A4(kb, "format", function(n) {
        return n.lP;
    }, Di, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(U4))))), Z4 = ul(A4(kb, "subtitles", function(n) {
        return n.ae;
    }, J4, A4(ll, "targetOrg", function(n) {
        return n.cr;
    }, Di, gl(V4)))), K4 = F2(function(n, r) {
        return A2(bp, function(n) {
            return n.mj;
        }, Al(A2(_s, ip, A3(kg, Z4, {
            ae: r.ae,
            cr: r.ru
        }, $g(xs(N3(A2(z3, n, 1))))))));
    }), _4 = F2(function(n, r) {
        return {
            ae: r,
            cq: n
        };
    }), G4 = ul(A4(kb, "subtitles", function(n) {
        return n.ae;
    }, J4, A4(ll, "targetId", function(n) {
        return n.cq;
    }, Di, gl(_4)))), Y4 = F2(function(n, r) {
        return A2(bp, function(n) {
            return n.mj;
        }, Al(A2(_s, ip, A3(kg, G4, {
            ae: r.ae,
            cq: r.ru
        }, $g(xs(N3(A2(z3, n, 0))))))));
    }), n5 = function(n) {
        return A2(Tu, e0, Ra(A2(xi, function(n) {
            return n.fB;
        }, A2(nc, _1, n.aw))));
    }, r5 = function(n) {
        return Ra(A2(xi, function(n) {
            return n.fB;
        }, A2(nc, _1, n.aw)));
    }, t5 = F2(function(n, r) {
        return r.$ ? n : kt(r.a);
    }), e5 = function(n) {
        var r = A2(Lp, function(n) {
            return n.hZ;
        }, r5(n)), t = A2(Lp, function(n) {
            return n.hZ;
        }, Ra(A2(xi, function(n) {
            return n.fB;
        }, A2(nc, P2, n.aw))));
        return A2(t5, r, A2(t5, t, A2(Lp, function(n) {
            return n.hZ;
        }, n.a8)));
    }, u5 = F3(function(n, r, t) {
        return A2(Wt, r, A2(Pt, n, t));
    }), a5 = F2(function(n, r) {
        return A3(B1, Et, n, r);
    }), i5 = F2(function(n, r) {
        return A2(a5, r, C([
            n
        ]));
    }), o5 = F3(function(n, r, t) {
        var e = A2(Qu, "00:00:00:00", A2(Tu, function(n) {
            return A3(u5, ";", ":", n);
        }, e5(n))), u = F2(function(n, r) {
            return A2(i5, e, A3(I1, r, n, !1)).lR;
        }), a = n5(n), i = A2(Qu, 0, A2(Tu, u(t), a)), o = A2(Qu, 0, A2(Tu, u(r), a));
        return Al(A2(vg, Di, A3(kg, Q6, {
            bd: o,
            be: i,
            m$: 10
        }, $g(I6(n.lA.mj)))));
    }), c5 = Pi({
        bQ: "Video duration differs from at least one of standalone audio files duration. The deliverable duration may be incorrect.",
        bX: "La dur\xe9e de la vid\xe9o est diff\xe9rente de la dur\xe9e d'au moins un des audios seuls. La dur\xe9e du livrable pourrait \xeatre incorrecte."
    }), f5 = Pi({
        bQ: "Container duration is not available.",
        bX: "Dur\xe9e du conteneur non disponible."
    }), s5 = Pi({
        bQ: "Video is not loaded. Container and video stream durations are not available.",
        bX: "La vid\xe9o n'est pas charg\xe9e. Dur\xe9es du conteneur et du flux video indisponible."
    }), l5 = F2(function(n, r) {
        return Pi({
            bQ: "Container duration (" + FS(n) + " s) and video stream duration (" + FS(r) + " s) are not equals. TC out is calculated with container duration.",
            bX: "La dur\xe9e du conteneur (" + FS(n) + " s) et la dur\xe9e du flux video (" + FS(r) + " s) sont in\xe9gales. Le TC out est calcul\xe9 avec la dur\xe9e du conteneur."
        });
    }), d5 = Pi({
        bQ: "Video stream duration is not available.",
        bX: "Dur\xe9e du flux video non disponible."
    }), b5 = F4(function(n, r, t, e) {
        return A4(d3, r, xc(t * r - 1), n, e);
    }), m5 = function(n) {
        return A2(nc, U1, n.aw);
    }, p5 = function(n) {
        return A2(z1, n, Ct);
    }, v5 = function(n) {
        var r = function(n) {
            return A3(ib, 2, "0", FS(n));
        }, t = n.e_ ? ";" : ":";
        return r(n.mf) + ":" + r(n.nP) + ":" + (r(n.p$) + (t + A3(ib, 2, "0", Bt(n.fo))));
    }, $5 = function(n) {
        var r, t = A2(Lp, function(n) {
            return n.bT.f2;
        }, A2(Tu, p5, n)), e = A2(Qu, "00:00:00:00", A2(Tu, function(n) {
            return A3(u5, ";", ":", n);
        }, A2(Lp, e5, t))), u = A2(Lp, function(n) {
            return n.e$;
        }, A2(Lp, r5, t)), a = A2(Lp, n5, t), i = A2(Lp, function(n) {
            return n.e$;
        }, A2(Lp, function(n) {
            return n.a8;
        }, t)), o = A3(RS, F2(function(n, r) {
            return v5(A4(b5, e, r, n, !1));
        }), i, a), c = A2(Qu, !1, A3(RS, fe, i, u)), f = (r = d(i, u)).a.$ ? kt(r.b.$ ? s5 : f5) : r.b.$ ? kt(d5) : c ? Ct : kt(A2(l5, r.a.a, r.b.a)), s = F2(function(n, r) {
            var t;
            return (0 > (t = n - r) ? -t : t) > 1;
        }), l = A2(bu, function(n) {
            return A2(Qu, !1, A3(RS, s, n, u));
        }, A2(Ge, function(n) {
            return n.e$;
        }, A2(Gu, m5, A2(Qu, g, A2(Tu, function(n) {
            return n.bT.ef;
        }, A2(Tu, p5, n)))))) ? kt(c5) : Ct, m = d(a, o);
        return m.a.$ || m.b.$ ? b("--:--:--:--", "--:--:--:--", d(f, l)) : b(e, m.b.a, d(f, l));
    }, g5 = F9(function(n, r, t, e, u, a, i, o, c) {
        return {
            fb: i,
            fd: o,
            lP: a,
            fZ: c,
            g3: t,
            ae: u,
            cq: n,
            cr: r,
            ic: e
        };
    }), h5 = ul(A4(kb, "lockedUntil", function(n) {
        return n.fZ;
    }, Di, A4(kb, "extraVersionMapping", function(n) {
        return n.fd;
    }, jm, A4(kb, "extraFormat", function(n) {
        return n.fb;
    }, Di, A4(ll, "format", function(n) {
        return n.lP;
    }, Di, A4(kb, "subtitles", function(n) {
        return n.ae;
    }, J4, A4(ll, "versionMapping", function(n) {
        return n.ic;
    }, jm, A4(ll, "segments", function(n) {
        return n.g3;
    }, $l(Di), A4(ll, "targetOrg", function(n) {
        return n.cr;
    }, Di, A4(kb, "targetId", function(n) {
        return n.cq;
    }, Di, gl(g5))))))))))), k5 = ul(A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(function(n) {
        return {
            mj: n
        };
    }))), C5 = Pi({
        bQ: "Program delivery for",
        bX: "Programmer la livraison pour"
    }), j5 = Pi({
        bQ: "Choose subtitles (optional)",
        bX: "Choisir des sous-titres (optionnel)"
    }), w5 = Pi({
        bQ: "Can not deliver without format",
        bX: "On ne peut pas livrer sans format"
    }), L5 = Pi({
        bQ: "Extra format (optional)",
        bX: "Format compl\xe9mentaire (optionnel)"
    }), y5 = F2(function(n, r) {
        var t = Ra(A2(Bu, function(n) {
            return i(n.mj, r);
        }, n));
        return !t.$ && !t.a.q7.$;
    }), S5 = Pi({
        bQ: "Black",
        bX: "Noir"
    }), T5 = Pi({
        bQ: "Custom delivery",
        bX: "Livraison custom"
    }), Q5 = Pi({
        bQ: "Slate",
        bX: "Panneau"
    }), I5 = Pi({
        bQ: "Bar and tone",
        bX: "Mire"
    }), B5 = function(n) {
        switch(n.m$){
            case 0:
                return kf;
            case 1:
                return $f;
            case 2:
                return gf;
            case 3:
                return Cf;
            case 4:
                return jf;
            case 5:
                return vf;
            case 6:
                return I5;
            case 7:
                return S5;
            case 8:
                return Q5;
            case 9:
                return hf;
            default:
                return T5;
        }
    }, W5 = function(n) {
        var r = function(n) {
            if (1 === n.$) {
                var r = n.a;
                return !i(r.rQ, Ct) && !i(r.aD, Ct);
            }
            return !1;
        };
        return A2(Qu, !1, A2(Tu, function(n) {
            return 0 >= Dt(n) || Dt(A2(Bu, r, n)) > 0;
        }, A2(Tu, A2(mu, Bu(function(n) {
            return 1 === n.$;
        }), function(n) {
            return n.aw;
        }), A2(Lp, A2(Po, function(n) {
            return n.bT;
        }, function(n) {
            return n.f2;
        }), n))));
    }, P5 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, M5 = F2(function(n, r) {
        return {
            dj: n,
            dB: r
        };
    }), q5 = F4(function(n, r, t, e) {
        return {
            mj: r,
            nW: t,
            gs: e,
            qs: n
        };
    }), D5 = ul(A4(ll, "parent", function(n) {
        return n.gs;
    }, hb(Di), A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, A4(ll, "showId", function(n) {
        return n.qs;
    }, Di, gl(q5)))))), X5 = ul(A4(ll, "shows", function(n) {
        return n.dB;
    }, $l(ip), A4(ll, "nodes", function(n) {
        return n.dj;
    }, $l(D5), gl(M5)))), E5 = F4(function(n, r, t, e) {
        return {
            mj: n,
            mH: e,
            nW: r,
            q7: t
        };
    }), R5 = ul(A4(ll, "isDefault", function(n) {
        return n.mH;
    }, Zi, A4(kb, "subtitleTypeVersion", function(n) {
        return n.q7;
    }, Ry, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(E5)))))), x5 = $l(R5), O5 = F4(function(n, r, t, e) {
        return {
            mH: t,
            mJ: e,
            nW: n,
            rL: r
        };
    }), z5 = ul(A4(ll, "isExtraDefault", function(n) {
        return n.mJ;
    }, Zi, A4(ll, "isDefault", function(n) {
        return n.mH;
    }, Zi, A4(ll, "tracks", function(n) {
        return n.rL;
    }, $l(M$), A4(ll, "name", function(n) {
        return n.nW;
    }, Di, gl(O5)))))), N5 = $l(z5), H5 = function(n) {
        return A2(Rs, P5, A6(CP, F5(function(n, r, t, e, u) {
            return {
                fc: u,
                c5: n,
                dj: t.dj,
                dB: t.dB,
                dF: r,
                ic: e
            };
        }), function(n) {
            return Al(A2(_s, x5, Vs(X$(Z$(A2(qP, n, 3))))));
        }(n), function(n) {
            return Al(A2(_s, dS, Vs(xs(QI(A2(TI, n, 3))))));
        }(n), function(n) {
            return Al(A2(_s, X5, Vs(xs(QI(A2(TI, n, 4))))));
        }(n), function(n) {
            return Al(A2(_s, N5, Vs(X$(Z$(A2(qP, n, 0))))));
        }(n), function(n) {
            return Al(A2(_s, x5, Vs(X$(Z$(A2(qP, n, 4))))));
        }(n)));
    }, V5 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, U5 = F3(function(n, r, t) {
        return {
            iI: t,
            mj: n,
            nW: r
        };
    }), J5 = ul(A4(ll, "allowDeliveryWithoutTranscoding", function(n) {
        return n.iI;
    }, Zi, A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(U5))))), Z5 = $l(J5), K5 = xs(QI({
        $: 1
    })), _5 = Al(A2(_s, Z5, Vs(K5))), G5 = $l(h0), Y5 = ru, n9 = function(n) {
        return A2(Rs, V5, A3(Y5, F2(function(n, r) {
            return d(n, r);
        }), _5, function(n) {
            return Al(A2(_s, G5, Vs(I6(n))));
        }(n)));
    }, r9 = Pi({
        bQ: "Organization",
        bX: "Organisation"
    }), t9 = Pi({
        bQ: "Program",
        bX: "Programme"
    }), e9 = function(n) {
        return p(n, {
            sb: Lu
        });
    }, u9 = tu, a9 = Pi({
        bQ: "Can not deliver the original organization",
        bX: "On ne peut pas livrer l\u2019organisation d\u2019origine"
    }), i9 = Pi({
        bQ: "Please choose an option for subtitles",
        bX: "Veuillez choisir une option pour les sous-titres"
    }), o9 = Pi({
        bQ: "Subtitling method",
        bX: "Mode de sous-titrage"
    }), c9 = Pi({
        bQ: "Version mapping",
        bX: "Version mapping"
    }), f9 = Pi({
        bQ: "Extra version mapping",
        bX: "Version mapping compl\xe9mentaire"
    }), s9 = F3(function(n, r, t) {
        n: for(;;)switch(n.$){
            case 0:
                var e = d(t, A2(Lp, function(n) {
                    var r = n.bT.f2;
                    return r.$ ? Ra(n.bT.ef) : kt(r.a);
                }, A2(Tu, p5, t)));
                return e.a.$ || e.b.$ ? DJ : A2(MK, C([
                    n9((_ = e.b.a).lA.mj)
                ]), A2(DK, 0, EJ(R4)));
            case 1:
                switch(r.$){
                    case 0:
                        n = O4;
                        continue n;
                    case 1:
                        return DJ;
                    default:
                        return EJ(Qf);
                }
            case 2:
                if ((k = n.a).$) return EJ(Qf);
                var u = k.a, a = u.a, o = A2(xi, function(n) {
                    return n.bd;
                }, u.b), c = A2(Ge, function(n) {
                    return d(n.mj, B5(n));
                }, o), f = $5(t), s = f.a, l = f.b, m = f.c, v = m.a, $ = m.b, h = {
                    lC: o,
                    oD: a,
                    qc: Ct,
                    qd: {
                        kG: Xi(function(n) {
                            return p(n, {
                                mL: !0,
                                m$: C5
                            });
                        }),
                        fb: Xi(function(n) {
                            return p(n, {
                                gy: L5
                            });
                        }),
                        fd: Xi(function(n) {
                            return p(n, {
                                gy: f9
                            });
                        }),
                        lP: Xi(function(n) {
                            return p(n, {
                                gy: "Format"
                            });
                        }),
                        nE: v,
                        nQ: $,
                        oz: Xi(function(n) {
                            return p(n, {
                                gy: r9
                            });
                        }),
                        g3: A2(Ei, H4, c),
                        g9: Xi(function(n) {
                            return p(n, {
                                gy: t9
                            });
                        }),
                        q2: Xi(function(n) {
                            return p(n, {
                                gy: o9
                            });
                        }),
                        ra: Xi(function(n) {
                            return p(n, {
                                gy: j5
                            });
                        }),
                        dI: Xi(function(n) {
                            return p(n, {
                                gy: "Timecode in",
                                sa: s
                            });
                        }),
                        dJ: Xi(function(n) {
                            return p(n, {
                                gy: "Timecode out",
                                sa: l
                            });
                        }),
                        rG: !i(c, g),
                        ic: Xi(function(n) {
                            return p(n, {
                                gy: c9
                            });
                        })
                    },
                    Q: x4
                };
                return EJ(E4(h));
            case 3:
                var k = n.a;
                if (2 === r.$) {
                    var j = r.a;
                    if (k.$) return EJ(Qf);
                    var w = k.a.dj, A = k.a.dB, L = k.a.c5, y = k.a.dF, S = k.a.ic, F = k.a.fc, T = (mn = j.qd).fb, Q = mn.fd, I = mn.lP, B = mn.ic, W = A2(Qu, "", A2(Tu, function(n) {
                        return n.nW;
                    }, Ra(A2(Bu, function(n) {
                        return n.mH;
                    }, S)))), P = A2(Qu, "", A2(Tu, function(n) {
                        return n.nW;
                    }, Ra(A2(Bu, function(n) {
                        return n.mJ;
                    }, S)))), M = A2(Qu, "", 1 === Dt(L) ? A2(Tu, function(n) {
                        return n.mj;
                    }, Ra(L)) : A2(Tu, function(n) {
                        return n.mj;
                    }, Ra(A2(Bu, function(n) {
                        return n.mH;
                    }, L)))), q = p(mn, {
                        fb: p(T, {
                            sa: A2(Qu, "", 1 === Dt(F) ? A2(Tu, function(n) {
                                return n.mj;
                            }, Ra(F)) : A2(Tu, function(n) {
                                return n.mj;
                            }, Ra(A2(Bu, function(n) {
                                return n.mH;
                            }, F))))
                        }),
                        fd: p(Q, {
                            sa: P
                        }),
                        lP: p(I, {
                            sa: M
                        }),
                        ic: p(B, {
                            sa: W
                        })
                    });
                    return h = p(j, {
                        qc: kt({
                            fc: F,
                            c5: L,
                            dj: w,
                            dB: A,
                            dF: y,
                            ic: S
                        }),
                        qd: q
                    }), EJ(E4(h));
                }
                return DJ;
            case 4:
                var D = n.a, X = n.b, E = n.c, R = n.d, x = function() {
                    return 1 === E.$ ? A2(K4, D, {
                        ae: R,
                        ru: X
                    }) : A2(Y4, D, {
                        ae: R,
                        ru: E.a
                    });
                }();
                return ZK(A2(Rs, M4, x));
            case 5:
                var O = n.a, z = (D = n.b, n.c), N = (E = n.d, d(z, r));
                if (N.a.$ || 2 !== N.b.$) return DJ;
                X = N.a.a, y = A2(Qu, g, A2(Tu, function(n) {
                    return n.dF;
                }, (h = N.b.a).qc));
                var H = Re(h.qd.ra.sa) || wu(y) || !Re(h.qd.q2.sa) ? "Burning" === h.qd.q2.sa || Re(h.qd.q2.sa) ? yt(Ct) : yt(kt(h.qd.q2.sa)) : jt(A2(ki, i9, L$)), V = A2(Tu, p5, t), U = "" === h.qd.kG.sa ? Ct : kt(h.qd.kG.sa);
                if ("AsSource" === h.qd.lP.sa) {
                    R = function() {
                        if (V.$) return Ct;
                        var n = V.a;
                        return kt({
                            lP: A2(Ii, Ct, H),
                            mj: h.qd.ra.sa,
                            nW: A2(Qu, "", A2(Tu, A2(Po, function(n) {
                                return n.lA;
                            }, function(n) {
                                return n.nW;
                            }), Ra(A2(Bu, function(n) {
                                return i(n.lA.mj, h.qd.ra.sa);
                            }, n.bT.ae))))
                        });
                    }(), n = A4(P4, D, X, E, R);
                    continue n;
                }
                var J = function(n) {
                    return KS(km(n));
                }, Z = KS(H), K = vt(h.qd.g3.sb), _ = A2(Lp, function(n) {
                    return n.bT.f2;
                }, V), G = KS(1 === Dt(L = A2(Qu, g, A2(Tu, function(n) {
                    return n.c5;
                }, h.qc))) ? yt(A2(Qu, "", Ra(A2(Ge, function(n) {
                    return n.mj;
                }, L)))) : Re(h.qd.lP.sa) ? jt(A2(ki, w5, L$)) : yt(h.qd.lP.sa)), Y = Re(h.qd.fb.sa) || "NoExtra" === h.qd.fb.sa ? KS(yt(Ct)) : A2(bp, kt, J(h.qd.fd.sa)), nn = KS(Re(h.qd.fb.sa) || "NoExtra" === h.qd.fb.sa ? yt(Ct) : yt(kt(h.qd.fb.sa))), rn = d(h.qd.dI.sa, h.qd.dJ.sa), tn = (s = rn.a, l = rn.b, function() {
                    var n = d(K, _);
                    return n.a.b || n.b.$ ? CA(n.a) : h.qd.dI.fq || h.qd.dJ.fq ? A2(bp, za, A3(o5, n.b.a, s, l)) : u9(g);
                }()), en = A2(Zw, function(n) {
                    var r, t = n.a, e = t.a, u = e.a, a = e.b, o = e.c, c = t.b, f = n.b, s = n.c;
                    return i(E, Ct) && i(z, kt(O.oz)) ? ZS(JS(A2(ki, a9, L$))) : W5(V) ? (r = "" === h.qd.ra.sa ? {
                        bD: D,
                        fb: f,
                        fd: s,
                        lP: a,
                        fZ: U,
                        g3: c,
                        ae: Ct,
                        ru: E,
                        cr: X,
                        ic: u
                    } : {
                        bD: D,
                        fb: f,
                        fd: s,
                        lP: a,
                        fZ: U,
                        g3: c,
                        ae: function() {
                            if (V.$) return Ct;
                            var n = V.a;
                            return kt({
                                lP: o,
                                mj: h.qd.ra.sa,
                                nW: A2(Qu, "", A2(Tu, A2(Po, function(n) {
                                    return n.lA;
                                }, function(n) {
                                    return n.nW;
                                }), Ra(A2(Bu, function(n) {
                                    return i(n.lA.mj, h.qd.ra.sa);
                                }, n.bT.ae))))
                            });
                        }(),
                        ru: E,
                        cr: X,
                        ic: u
                    }, A2(bp, function(n) {
                        return n.mj;
                    }, Al(A2(_s, k5, A3(kg, h5, {
                        fb: r.fb,
                        fd: r.fd,
                        lP: r.lP,
                        fZ: r.fZ,
                        g3: r.g3,
                        ae: r.ae,
                        cq: r.ru,
                        cr: r.cr,
                        ic: r.ic
                    }, $g(X$(M3(A2(P3, r.bD, 2))))))))) : ZS(JS(A2(ki, N4, L$)));
                }, A2(z4, function() {
                    return Y;
                }, A2(V6, function() {
                    return nn;
                }, A2(Zw, function(n) {
                    return A2(bp, function(r) {
                        return d(n, r);
                    }, tn);
                }, A2(nl, JS, A2(z4, function() {
                    return Z;
                }, A2(V6, function() {
                    return G;
                }, J(h.qd.ic.sa))))))));
                return A2(jK, A2(Rs, M4, en), EJ(E4(p(h, {
                    Q: X4
                }))));
            case 6:
                var un = n.a;
                if (2 === r.$) {
                    if (h = r.a, 1 === un.$) return EJ(E4(p(h, {
                        Q: q4(un.a.nE)
                    })));
                    var an = un.a, on = (A = A2(Qu, g, A2(Tu, function(n) {
                        return n.dB;
                    }, h.qc)), A2(Bu, A2(Po, function(n) {
                        return n.mj;
                    }, Ta(an)), A)), cn = (mn = h.qd).g9, fn = mn.oz, sn = A2(Tu, function(n) {
                        return p(n, {
                            dB: on
                        });
                    }, h.qc), ln = E4(p(h, {
                        qc: sn,
                        qd: p(mn, {
                            oz: p(fn, {
                                sa: ""
                            }),
                            g9: p(cn, {
                                sa: ""
                            })
                        }),
                        Q: D4(an)
                    }));
                    return A2(DK, 1, EJ(ln));
                }
                return DJ;
            case 17:
                var dn = n.a;
                return 2 === r.$ ? (q = p(mn = (h = r.a).qd, {
                    kG: A2(Wg, dn, mn.kG)
                }), EJ(E4(p(h, {
                    qd: q
                })))) : DJ;
            case 9:
                return dn = n.a, 2 === r.$ ? (q = p(mn = (h = r.a).qd, {
                    ic: A2(Wg, dn, mn.ic)
                }), EJ(E4(p(h, {
                    qd: q
                })))) : DJ;
            case 10:
                return dn = n.a, 2 === r.$ ? (q = p(mn = (h = r.a).qd, {
                    fd: A2(Wg, dn, mn.fd)
                }), EJ(E4(p(h, {
                    qd: q
                })))) : DJ;
            case 11:
                return dn = n.a, 2 === r.$ ? (q = p(mn = (h = r.a).qd, {
                    ra: A2(Wg, dn, mn.ra)
                }), EJ(E4(p(h, {
                    qd: q
                })))) : DJ;
            case 12:
                return dn = n.a, 2 === r.$ ? (q = p(mn = (h = r.a).qd, {
                    q2: A2(Wg, dn, mn.q2)
                }), EJ(E4(p(h, {
                    qd: q
                })))) : DJ;
            case 13:
                return dn = n.a, 2 === r.$ ? (q = p(mn = (h = r.a).qd, {
                    fb: A2(Wg, dn, mn.fb)
                }), EJ(E4(p(h, {
                    qd: q
                })))) : DJ;
            case 16:
                return L = n.a, dn = n.b, 2 === r.$ ? (q = p(mn = (h = r.a).qd, A2(y5, L, mn.q2.sa) ? {
                    lP: A2(Wg, dn, mn.lP),
                    q2: A2(Bg, mn.q2, ""),
                    ra: A2(Bg, mn.ra, "")
                } : {
                    lP: A2(Wg, dn, mn.lP)
                }), EJ(E4(p(h, {
                    qd: q
                })))) : DJ;
            case 14:
                return dn = n.a, 2 === r.$ ? (q = p(mn = (h = r.a).qd, {
                    oz: A2(Wg, dn, mn.oz)
                }), A2(MK, C([
                    H5(q.oz.sa)
                ]), EJ(E4(p(h, {
                    qd: q
                }))))) : DJ;
            case 15:
                return dn = n.a, 2 === r.$ ? (q = p(mn = (h = r.a).qd, {
                    g9: A2(Wg, dn, mn.g9)
                }), EJ(E4(p(h, {
                    qd: q
                })))) : DJ;
            case 7:
                return dn = n.a, 2 === r.$ ? (q = p(mn = (h = r.a).qd, {
                    dI: A2(Wg, dn, mn.dI)
                }), EJ(E4(p(h, {
                    qd: q
                })))) : DJ;
            case 8:
                return dn = n.a, 2 === r.$ ? (q = p(mn = (h = r.a).qd, {
                    dJ: A2(Wg, dn, mn.dJ)
                }), EJ(E4(p(h, {
                    qd: q
                })))) : DJ;
            case 18:
                return dn = n.a, 2 === r.$ ? (q = p(mn = (h = r.a).qd, {
                    g3: A2(HJ, dn, mn.g3)
                }), EJ(E4(p(h, {
                    qd: q
                })))) : DJ;
            case 19:
                var bn = n.a;
                if (2 === r.$) {
                    var mn = (h = r.a).qd, pn = $5(t), vn = (s = pn.a, l = pn.b, pn.c);
                    return q = p(mn, {
                        nE: v = vn.a,
                        nQ: $ = vn.b,
                        g3: e9(mn.g3),
                        dI: A2(Bg, mn.dI, s),
                        dJ: A2(Bg, mn.dJ, l),
                        rG: bn
                    }), EJ(E4(p(h, {
                        qd: q
                    })));
                }
                return DJ;
            default:
                var $n = b(r, n.a, n.b);
                r: for(;;){
                    if (2 === $n.a.$) {
                        if ($n.b) {
                            if ($n.c.$) break r;
                            return q = p(mn = (h = $n.a.a).qd, {
                                dJ: p(l = mn.dJ, {
                                    fq: !0,
                                    sa: v5($n.c.a)
                                })
                            }), EJ(E4(p(h, {
                                qd: q
                            })));
                        }
                        if ($n.c.$) break r;
                        q = p(mn = (h = $n.a.a).qd, {
                            dI: p(s = mn.dI, {
                                fq: !0,
                                sa: v5($n.c.a)
                            })
                        });
                        return EJ(E4(p(h, {
                            qd: q
                        })));
                    }
                    break r;
                }
                return DJ;
        }
    }), l9 = function(n) {
        return {
            $: 4,
            a: n
        };
    }, d9 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, b9 = {
        $: 1
    }, m9 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, p9 = {
        $: 2
    }, v9 = function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return {
                                                        jr: r,
                                                        bP: c,
                                                        k8: t,
                                                        lB: o,
                                                        F: i,
                                                        lF: n,
                                                        b_: l,
                                                        b2: s,
                                                        cb: f,
                                                        cg: e,
                                                        ch: u,
                                                        ci: a
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }, $9 = TP(ce), g9 = Pi({
        bQ: "Invalid date",
        bX: "Date invalide"
    }), h9 = Pi({
        bQ: "Invalid production year",
        bX: "Ann\xe9e de production invalide"
    }), k9 = ul(A4(kb, "idBroadcaster", function(n) {
        return n.b_;
    }, Di, A4(kb, "legalMentions", function(n) {
        return n.b2;
    }, Di, A4(kb, "originalAspectRatio", function(n) {
        return n.cb;
    }, $2, A4(kb, "displayAspectRatio", function(n) {
        return n.bP;
    }, $2, A4(kb, "fileFormat", function(n) {
        return n.lB;
    }, h2, A4(kb, "fileType", function(n) {
        return n.F;
    }, C2, A4(kb, "programType", function(n) {
        return n.ci;
    }, w2, A4(kb, "productionYear", function(n) {
        return n.ch;
    }, ml, A4(kb, "productionCompanyName", function(n) {
        return n.cg;
    }, Di, A4(ll, "enableAutoAccept", function(n) {
        return n.k8;
    }, Zi, A4(kb, "broadcasterShowId", function(n) {
        return n.jr;
    }, Di, A4(kb, "firstBroadcastedAt", function(n) {
        return n.lF;
    }, bb, gl(v9)))))))))))))), C9 = F2(function(n, r) {
        return p(r, {
            nE: n
        });
    }), j9 = F2(function(n, r) {
        var t, e, u, a, i, o = 1 === (t = r.ci.sa).$ ? yt(Ct) : A2(hi, function(n) {
            return A2(C9, n, Ex(400));
        }, A2(dg, kt, j2(t.a))), c = function() {
            if ("" === r.ch.sa) return yt(Ct);
            var n = Oe(r.ch.sa);
            return n.$ ? jt(A2(C9, h9, Ex(400))) : yt(kt(n.a));
        }(), f = "" === r.cg.sa ? Ct : kt(r.cg.sa), s = 1 === (e = r.cb.sa).$ ? yt(Ct) : A2(hi, function(n) {
            return A2(C9, n, Ex(400));
        }, A2(dg, kt, v2(e.a))), l = yt(r.b2.sa), d = "" === r.b_.sa ? Ct : kt(r.b_.sa), b = 1 === (u = r.F.sa).$ ? yt(Ct) : A2(hi, function(n) {
            return A2(C9, n, Ex(400));
        }, A2(dg, kt, k2(u.a))), m = 1 === (a = r.lB.sa).$ ? yt(Ct) : A2(hi, function(n) {
            return A2(C9, n, Ex(400));
        }, A2(dg, kt, g2(a.a))), p = 1 === (i = r.bP.sa).$ ? yt(Ct) : A2(hi, function(n) {
            return A2(C9, n, Ex(400));
        }, A2(dg, kt, v2(i.a))), v = "" === r.lF.sa ? yt(Ct) : A2(hi, function() {
            return A2(C9, g9, Ex(400));
        }, A2(dg, kt, TY(r.lF.sa))), $ = "" === r.jr.sa ? Ct : kt(r.jr.sa);
        return A2(Zw, function(t) {
            return r.mF ? A2(Zw, function() {
                return Al(A2(_s, L2, Vs(x2(n))));
            }, Al(A3(kg, k9, t, $g(x2(n))))) : Al(A2(_s, L2, A3(kg, k9, t, Sg(xs(QK(A2(TK, n, 2)))))));
        }, KS(A2($9, yt(d), A2($9, l, A2($9, s, A2($9, p, A2($9, m, A2($9, b, A2($9, o, A2($9, c, A2($9, yt(f), A2($9, yt(r.k8.sa), A2($9, yt($), A2($9, v, yt(v9)))))))))))))));
    }), w9 = F2(function(n, r) {
        return Al(A2(_s, ip, A3(kg, WK, {
            nW: r.rC.sa
        }, Sg(IK(n)))));
    }), L9 = F2(function(n, r) {
        switch(n.$){
            case 0:
                switch(n.a.$){
                    case 0:
                        return EJ(p(r, {
                            rC: A2(Wg, c = n.a.a, r.rC)
                        }));
                    case 1:
                        return EJ(p(r, {
                            jr: A2(Wg, c = n.a.a, r.jr)
                        }));
                    case 2:
                        return EJ(p(r, {
                            lF: A2(Wg, c = n.a.a, r.lF)
                        }));
                    case 3:
                        return EJ(p(r, {
                            k8: A2(Ig, c = n.a.a, r.k8)
                        }));
                    case 4:
                        return EJ(p(r, {
                            cg: A2(Wg, c = n.a.a, r.cg)
                        }));
                    case 5:
                        return EJ(p(r, {
                            ch: A2(Wg, c = n.a.a, r.ch)
                        }));
                    case 6:
                        var t = r.ci;
                        return EJ(p(r, (c = n.a.a).$ ? {
                            ci: p(t, {
                                sa: kt(c.a)
                            })
                        } : {
                            ci: p(t, {
                                gn: !t.gn
                            })
                        }));
                    case 7:
                        var e = r.F;
                        return EJ(p(r, (c = n.a.a).$ ? {
                            F: p(e, {
                                sa: kt(c.a)
                            })
                        } : {
                            F: p(e, {
                                gn: !e.gn
                            })
                        }));
                    case 8:
                        var u = r.lB;
                        return EJ(p(r, (c = n.a.a).$ ? {
                            lB: p(u, {
                                sa: kt(c.a)
                            })
                        } : {
                            lB: p(u, {
                                gn: !u.gn
                            })
                        }));
                    case 9:
                        var a = r.bP;
                        return EJ(p(r, (c = n.a.a).$ ? {
                            bP: p(a, {
                                sa: kt(c.a)
                            })
                        } : {
                            bP: p(a, {
                                gn: !a.gn
                            })
                        }));
                    case 10:
                        var i = r.cb;
                        return EJ(p(r, (c = n.a.a).$ ? {
                            cb: p(i, {
                                sa: kt(c.a)
                            })
                        } : {
                            cb: p(i, {
                                gn: !i.gn
                            })
                        }));
                    case 11:
                        var o = r.b2;
                        return (c = n.a.a).$ ? EJ(p(r, {
                            b2: p(o, {
                                sa: kt(c.a)
                            })
                        })) : DJ;
                    default:
                        var c;
                        return EJ(p(r, {
                            b_: A2(Wg, c = n.a.a, r.b_)
                        }));
                }
            case 1:
                return A2(MK, C([
                    A2(Rs, d9, A2(w9, (f = n.a).mj, r)),
                    A2(Rs, l9, A2(j9, f.mj, r))
                ]), EJ(p(r, {
                    Q: p9
                })));
            case 2:
                if ((s = n.a).$) return EJ(p(r, {
                    Q: m9(s.a)
                }));
                var f = s.a;
                return A2(qY, C([
                    1,
                    0
                ]), EJ(p(r, {
                    Q: Bf,
                    rC: A2(Bg, r.rC, f.rC)
                })));
            case 4:
                return A2(DK, 1, A2(bY, function(n) {
                    return p(n, {
                        Q: Bf
                    });
                }, A2(L9, R2(s = n.a), r)));
            case 3:
                var s;
                if ((s = n.a).$) return EJ(p(r, {
                    Q: m9(s.a)
                }));
                t = r.ci;
                var l = A2(Bg, r.ch, A2(Qu, "", A2(Tu, Bt, ($ = s.a).ch))), d = A2(Bg, r.cg, A2(Qu, "", $.cg)), b = (i = r.cb, o = r.b2, r.b_), m = A2(Bg, r.lF, A2(Qu, "", A2(Tu, wO, $.lF))), v = (e = r.F, u = r.lB, A2(Qg, r.k8, $.k8));
                return a = r.bP, EJ(p(r, {
                    jr: A2(Bg, r.jr, A2(Qu, "", $.jr)),
                    bP: p(a, {
                        sa: A2(Tu, Pf, $.bP)
                    }),
                    k8: v,
                    lB: p(u, {
                        sa: A2(Tu, qf, $.lB)
                    }),
                    F: p(e, {
                        sa: A2(Tu, rs, $.F)
                    }),
                    lF: m,
                    b_: b,
                    b2: p(o, {
                        sa: $.b2
                    }),
                    cb: p(i, {
                        sa: A2(Tu, Pf, $.cb)
                    }),
                    cg: d,
                    ch: l,
                    ci: p(t, {
                        sa: A2(Tu, ts, $.ci)
                    }),
                    o9: kt($)
                }));
            case 5:
                f = n.a;
                var $ = n.b;
                return r.mF ? EJ(p(r, {
                    Q: b9,
                    rC: A2(Bg, r.rC, f.rC)
                })) : (t = r.ci, i = r.cb, e = r.F, u = r.lB, a = r.bP, EJ(p(r, {
                    jr: A2(Bg, r.jr, A2(Qu, "", $.jr)),
                    bP: p(a, {
                        sa: A2(Tu, Pf, $.bP)
                    }),
                    k8: A2(Qg, r.k8, $.k8),
                    lB: p(u, {
                        sa: A2(Tu, qf, $.lB)
                    }),
                    F: p(e, {
                        sa: A2(Tu, rs, $.F)
                    }),
                    lF: A2(Bg, r.lF, A2(Qu, "", A2(Tu, wO, $.lF))),
                    cb: p(i, {
                        sa: A2(Tu, Pf, $.cb)
                    }),
                    cg: A2(Bg, r.cg, A2(Qu, "", $.cg)),
                    ch: A2(Bg, r.ch, A2(Qu, "", A2(Tu, Bt, $.ch))),
                    ci: p(t, {
                        sa: A2(Tu, ts, $.ci)
                    }),
                    Q: b9,
                    rC: A2(Bg, r.rC, f.rC)
                })));
            default:
                return EJ(p(r, {
                    Q: Bf
                }));
        }
    }), y9 = function(n) {
        return {
            $: 7,
            a: n
        };
    }, S9 = F2(function(n, r) {
        return {
            $: 11,
            a: n,
            b: r
        };
    }), T9 = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Q9 = function(n) {
        return {
            $: 8,
            a: n
        };
    }, I9 = function(n) {
        return Al(Lg(Ag(D1(n))));
    }, B9 = F2(function(n, r) {
        switch(n.$){
            case 3:
                return EJ(p(r, {
                    pq: A3(Wo, (u = n.a).mj, function(n) {
                        return kt(A2(Qu, !0, A2(Tu, pu, n)));
                    }, r.pq)
                }));
            case 5:
                return EJ(p(r, {
                    o8: A3(Wo, (a = n.a) + "-" + n.b, function(n) {
                        return kt(A2(Qu, !0, A2(Tu, pu, n)));
                    }, r.o8)
                }));
            case 6:
                return EJ(p(r, {
                    hI: A3(Wo, (u = n.a).mj, function(n) {
                        return kt(A2(Qu, !0, A2(Tu, pu, n)));
                    }, r.hI)
                }));
            case 0:
                return R1(C([
                    N2((u = n.b).fR),
                    A2(Es, T9, gZ(u.mj))
                ]));
            case 1:
                var t = n.b, e = i3((u = n.c).c9);
                return R1(C([
                    Y2(u.fR),
                    A2(Es, Q9, A3(d_, t, e, u.nW))
                ]));
            case 2:
                var u;
                return R1(C([
                    q1((u = n.b).fR),
                    A2(Es, y9, lZ(u.mj))
                ]));
            case 9:
            case 8:
            case 7:
                return x1(1);
            case 4:
                return EJ(p(r, {
                    or: A2(A2(pK, a = n.a, r.or) ? kK : Dc, a, r.or)
                }));
            case 10:
                return R1(C([
                    A2(Es, S9(a = n.a), I9(a))
                ]));
            case 11:
                var a = n.a, i = n.b;
                if (i.$) {
                    var o = i.a;
                    return EJ(p(r, {
                        lm: A3(Wo, a, function() {
                            return kt(o.nE);
                        }, r.lm)
                    }));
                }
                return x1(1);
            default:
                return DJ;
        }
    }), W9 = F2(function(n, r) {
        return {
            $: 9,
            a: n,
            b: r
        };
    }), P9 = function(n) {
        return {
            $: 11,
            a: n
        };
    }, M9 = function(n) {
        return {
            $: 8,
            a: n
        };
    }, q9 = F2(function(n, r) {
        return Al(A2(vg, t$, A3(kg, CY, r, $g(xs(QK(A2(TK, n.mj, 1)))))));
    }), D9 = function(n) {
        return p(n, {
            ll: Ct
        });
    }, X9 = F2(function(n, r) {
        return s(n, r) > 0;
    }), E9 = d$, R9 = Pi({
        bQ: "Wrong expiration date: must be greater than today.",
        bX: "Date d\u2019expiration erron\xe9e : doit \xeatre sup\xe9rieur \xe0 aujourd'hui."
    }), x9 = F2(function(n, r) {
        switch(n.$){
            case 0:
                return EJ(p(r, {
                    k6: A2(Wg, n.a, r.k6),
                    ll: Ct
                }));
            case 1:
                return EJ(p(r, {
                    ll: Ct,
                    nE: A2(Wg, n.a, r.nE)
                }));
            case 2:
                return EJ(p(r, {
                    ll: Ct,
                    lq: A2(Wg, n.a, r.lq)
                }));
            case 4:
                return EJ(p(r, {
                    jx: A2(Ig, n.a, r.jx),
                    ll: Ct
                }));
            case 3:
                return EJ(p(r, {
                    jy: A2(Ig, n.a, r.jy),
                    ll: Ct
                }));
            case 5:
                return EJ(r);
            case 6:
                return EJ(p(r, {
                    kQ: !r.kQ,
                    ll: Ct
                }));
            case 7:
                return A2(MK, C([
                    A2(Rs, M9, (o = n.a, Al(Lg(Ag(LY(o.mj))))))
                ]), EJ(D9(r)));
            case 8:
                return (t = n.a).$ ? EJ(p(r, {
                    ll: kt(t.a)
                })) : x1(1);
            case 11:
                var t;
                return (t = n.a).$ ? EJ(p(r, {
                    ll: kt(t.a)
                })) : A2(qY, C([
                    1
                ]), EJ(p(r, {
                    jx: os,
                    jy: fs,
                    kQ: !1,
                    k6: ds,
                    ll: Ct,
                    lq: ms,
                    nE: vs
                })));
            case 9:
                var e = n.a, u = n.b, a = A2(hi, function() {
                    return Ct;
                }, A2(dg, Be, TY(r.lq.sa))), i = {
                    cT: r.jx.sa,
                    k6: r.k6.sa,
                    cY: a.$ ? Ct : kt(a.a),
                    nE: r.nE.sa,
                    r$: r.jy.sa
                };
                return a.$ || A2(X9, a.a, u) ? A2(MK, C([
                    A2(Rs, P9, A2(q9, e, i))
                ]), EJ(D9(r))) : EJ(p(r, {
                    ll: kt(A3(el, 1, R9, Lu))
                }));
            default:
                return A2(MK, C([
                    A2(b$, W9(e = n.a), E9)
                ]), EJ(r));
        }
        var o;
    }), O9 = function(n) {
        return {
            $: 37,
            a: n
        };
    }, z9 = function(n) {
        return {
            $: 21,
            a: n
        };
    }, N9 = function(n) {
        return {
            $: 10,
            a: n
        };
    }, H9 = function(n) {
        return {
            $: 31,
            a: n
        };
    }, V9 = function(n) {
        return {
            $: 33,
            a: n
        };
    }, U9 = function(n) {
        return {
            $: 32,
            a: n
        };
    }, J9 = function(n) {
        return {
            $: 19,
            a: n
        };
    }, Z9 = function(n) {
        return {
            $: 7,
            a: n
        };
    }, K9 = function(n) {
        return {
            $: 12,
            a: n
        };
    }, _9 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, G9 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Y9 = function(n) {
        return {
            $: 5,
            a: n
        };
    }, n8 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, r8 = {
        $: 1
    }, t8 = function(n) {
        return {
            $: 11,
            a: n
        };
    }, e8 = function(n) {
        return {
            $: 39,
            a: n
        };
    }, u8 = {
        $: 2
    }, a8 = function(n) {
        return {
            $: 23,
            a: n
        };
    }, i8 = function(n) {
        return {
            $: 16,
            a: n
        };
    }, o8 = F2(function(n, r) {
        return A2(bp, function() {
            return 0;
        }, Al(A2(_s, c0, A3(kg, R3, {
            dt: r
        }, $g(xs(QK(A2(TK, n.mj, 5))))))));
    }), c8 = function(n) {
        return Al(Lg($g(xs(Rq(A2(IR, n.mj, 3))))));
    }, f8 = xs(cL({
        $: 2
    })), s8 = F2(function(n, r) {
        return {
            mj: n,
            nW: r
        };
    }), l8 = ul(A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(s8)))), d8 = $l(l8), b8 = Al(A2(_s, d8, Vs(f8))), m8 = F2(function(n, r) {
        return {
            mj: n,
            nW: r
        };
    }), p8 = ul(A4(ll, "name", function(n) {
        return n.nW;
    }, Di, A4(ll, "id", function(n) {
        return n.mj;
    }, Di, gl(m8)))), v8 = $l(p8), $8 = F2(function(n, r) {
        return {
            gX: r,
            hP: n
        };
    }), g8 = ul(A4(ll, "rulesId", function(n) {
        return n.gX;
    }, Di, A4(ll, "task", function(n) {
        return n.hP;
    }, Di, gl($8)))), h8 = F3(function(n, r, t) {
        return Al(Lg(A3(kg, g8, {
            gX: t,
            hP: r
        }, $g(X$(M3(A2(P3, n, 0)))))));
    }), k8 = ul(A4(ll, "configuration", function(n) {
        return n.ak;
    }, Di, gl(function(n) {
        return {
            ak: n
        };
    }))), C8 = F2(function(n, r) {
        return Al(Lg(A3(kg, k8, {
            ak: r
        }, $g(function(n) {
            return xs(cL(function(n) {
                return {
                    $: 0,
                    a: n
                };
            }(n)));
        }(n)))));
    }), j8 = function(n) {
        return Al(Lg($g(xs(Rq(A2(IR, n.mj, 5))))));
    }, w8 = F2(function(n, r) {
        var t = "" === r ? Ct : kt(r);
        return Al(Lg(A3(kg, D3, {
            bG: t
        }, $g(q3(n.mj)))));
    }), L8 = Jn("switchPlayer", function() {
        return pi;
    }), y8 = F8(function(n, r, t, e, u, a, i, o) {
        return {
            j_: o,
            eL: u,
            ku: r,
            lA: e,
            mj: n,
            f_: i,
            bn: a,
            rw: t
        };
    }), S8 = F2(function(n, r) {
        return {
            fR: n,
            sa: r
        };
    }), T8 = function(n) {
        return A8(y8, n.bn.mj, n.bn.ke, n.bn.rx, n.lA.nW, A2(Ot, F2(function(n, r) {
            var t;
            return A2(S8, Bt(n), (t = Aq(r)).nW ? "blackframe \u2208 [" + Bt(t.nI) + " ms, " + Bt(t.nB) + " ms]" : "silence \u2208 [" + Bt(t.nI) + " ms, " + Bt(t.nB) + " ms]");
        }), n.bn.jH), n.gU, n.bn.f_, n.bn.j_);
    }, Q8 = function(n) {
        return Al(Lg($g(ZY(n.mj))));
    }, I8 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, B8 = F7(function(n, r, t, e, u, a, i) {
        return {
            bF: a,
            fy: t,
            c9: i,
            oN: r,
            gu: u,
            gB: e,
            r8: n
        };
    }), W8 = ul(A4(ll, "kind", function(n) {
        return n.c9;
    }, i_, A4(ll, "versionId", function(n) {
        return n.bF;
    }, Di, A4(ll, "path", function(n) {
        return n.gu;
    }, Di, A4(ll, "port", function(n) {
        return n.gB;
    }, Di, A4(ll, "host", function(n) {
        return n.fy;
    }, Di, A4(ll, "password", function(n) {
        return n.oN;
    }, Di, A4(ll, "user", function(n) {
        return n.r8;
    }, Di, gl(B8))))))))), P8 = xs({
        $: 22
    }), M8 = function(n) {
        switch(n){
            case "Material":
                return 0;
            case "Audio":
                return 1;
            case "Subtitle":
                return 2;
            default:
                return 3;
        }
    }, q8 = F7(function(n, r, t, e, u, a, i) {
        var o = A7(B8, r, t, e, u, a, n.mj, M8(i));
        return Al(Lg(A3(kg, W8, o, $g(P8))));
    }), D8 = F2(function(n, r) {
        switch(n.$){
            case 0:
                return R1(C([
                    A2(Rs, I8, A7(q8, n.a, r.mw.sa, r.mr.sa, r.mq.sa, r.mt.sa, r.ms.sa, r.p7.sa))
                ]));
            case 1:
                var t = n.a;
                return EJ(p(r, t.$ ? {
                    ll: kt(t.a)
                } : {
                    ll: Ct,
                    mq: Wq(r.mq),
                    mr: Wq(r.mr),
                    ms: Wq(r.ms),
                    mt: Wq(r.mt),
                    mw: Wq(r.mw),
                    p7: Wq(r.p7)
                }));
            case 2:
                return EJ(p(r, {
                    mw: A2(Wg, n.a, r.mw)
                }));
            case 3:
                return EJ(p(r, {
                    mr: A2(Wg, n.a, r.mr)
                }));
            case 4:
                return EJ(p(r, {
                    mq: A2(Wg, n.a, r.mq)
                }));
            case 5:
                return EJ(p(r, {
                    mt: A2(Wg, n.a, r.mt)
                }));
            case 6:
                return EJ(p(r, {
                    ms: A2(Wg, n.a, r.ms)
                }));
            default:
                return EJ(p(r, {
                    p7: A2(Wg, n.a, r.p7)
                }));
        }
    }), X8 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, E8 = xs({
        $: 21,
        a: 0
    }), R8 = F4(function(n, r, t, e) {
        return {
            bF: t,
            ev: n,
            fR: r,
            c9: e
        };
    }), x8 = ul(A4(ll, "kind", function(n) {
        return n.c9;
    }, i_, A4(ll, "broadcastable", function(n) {
        return n.bF;
    }, Di, A4(ll, "key", function(n) {
        return n.fR;
    }, Di, A4(ll, "bucket", function(n) {
        return n.ev;
    }, Di, gl(R8)))))), O8 = F4(function(n, r, t, e) {
        return Al(Lg(A3(kg, x8, {
            bF: n.mj,
            ev: r,
            fR: t,
            c9: M8(e)
        }, $g(E8))));
    }), z8 = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(MK, C([
                    A2(Rs, X8, A4(O8, n.a, r.mu.sa, r.mv.sa, r.p7.sa))
                ]), EJ(r));
            case 1:
                return EJ(n.a.$ ? r : p(r, {
                    mu: Wq(r.mu),
                    mv: Wq(r.mv),
                    p7: Wq(r.p7)
                }));
            case 2:
                return EJ(p(r, {
                    mu: A2(Wg, n.a, r.mu)
                }));
            case 3:
                return EJ(p(r, {
                    mv: A2(Wg, n.a, r.mv)
                }));
            default:
                return EJ(p(r, {
                    p7: A2(Wg, n.a, r.p7)
                }));
        }
    }), N8 = ul(A4(ll, "versionMapping", function(n) {
        return n.ic;
    }, jm, gl(function(n) {
        return {
            ic: n
        };
    }))), H8 = F2(function(n, r) {
        return Al(Lg(A3(kg, N8, {
            ic: r
        }, $g(xs(N3(A2(z3, n.mj, 4)))))));
    }), V8 = F2(function(n, r) {
        switch(n.$){
            case 11:
                return A3(mY, function(n) {
                    return p(r, {
                        pI: n
                    });
                }, t8, A2(z8, n.a, r.pI));
            case 12:
                return A3(mY, function(n) {
                    return p(r, {
                        lX: n
                    });
                }, K9, A2(D8, n.a, r.lX));
            case 29:
                return EJ(p(r, {
                    kz: A2(Wg, n.a, r.kz)
                }));
            case 30:
                return EJ(p(r, {
                    qp: A2(Wg, n.a, r.qp)
                }));
            case 6:
                return A2(MK, C([
                    A2(Rs, Z9, (b = n.a, Al(Lg($g(X$(M3(A2(P3, b.mj, 3))))))))
                ]), EJ(p(r, {
                    kD: r8
                })));
            case 7:
                return (f = n.a).$ ? EJ(p(r, {
                    kD: _9(f.a)
                })) : A2(DK, 1, EJ(p(r, {
                    kD: u8
                })));
            case 0:
                return A2(MK, C([
                    A2(Rs, n8, (l = n.a, Al(Lg($g(xs(Rq(A2(IR, l.mj, 4))))))))
                ]), EJ(p(r, {
                    pv: r8
                })));
            case 1:
                return (f = n.a).$ ? EJ(p(r, {
                    pv: _9(f.a)
                })) : A2(DK, 1, EJ(p(r, {
                    pv: u8
                })));
            case 2:
                return A2(MK, C([
                    A2(Rs, G9, j8(n.a))
                ]), EJ(p(r, {
                    pt: r8
                })));
            case 3:
                return (f = n.a).$ ? EJ(p(r, {
                    pt: _9(f.a)
                })) : A2(DK, 1, EJ(p(r, {
                    pt: u8
                })));
            case 4:
                return A2(MK, C([
                    A2(Rs, Y9, A2(w8, n.a, r.bG.sa))
                ]), EJ(p(r, {
                    pu: r8
                })));
            case 5:
                return (f = n.a).$ ? EJ(p(r, {
                    pu: _9(f.a)
                })) : A2(DK, 1, EJ(p(r, {
                    pu: u8
                })));
            case 8:
                return EJ(p(r, {
                    bG: A2(Wg, n.a, r.bG)
                }));
            case 13:
                return EJ(p(r, {
                    kd: A2(Wg, n.a, r.kd)
                }));
            case 9:
                return A2(MK, C([
                    A2(Rs, N9, A2(o8, n.a, r.kd.sa))
                ]), EJ(p(r, {
                    kc: r8
                })));
            case 10:
                return (f = n.a).$ ? EJ(p(r, {
                    kc: _9(f.a)
                })) : A2(DK, 1, EJ(p(r, {
                    kc: u8,
                    kd: V3(r.kd)
                })));
            case 14:
                switch(n.a){
                    case 9:
                        return EJ(p(r, {
                            kD: gs
                        }));
                    case 0:
                        return EJ(p(r, {
                            pv: gs
                        }));
                    case 1:
                        return EJ(p(r, {
                            pt: gs
                        }));
                    case 2:
                        return EJ(p(r, {
                            pu: gs
                        }));
                    case 3:
                        return EJ(p(r, {
                            kc: gs
                        }));
                    case 4:
                        return EJ(p(r, {
                            rZ: gs
                        }));
                    case 6:
                        return EJ(p(r, {
                            kC: gs
                        }));
                    case 7:
                        return EJ(p(r, {
                            ea: gs
                        }));
                    case 8:
                        return EJ(p(r, {
                            iM: gs
                        }));
                    default:
                        return DJ;
                }
            case 15:
                var t = n.a, e = km(n.b.sa);
                return e.$ ? DJ : A2(DK, 1, A2(MK, C([
                    A2(Rs, i8, A2(H8, t, e.a))
                ]), EJ(p(r, {
                    rZ: r8
                }))));
            case 16:
                var u = n.a;
                return u.$ ? EJ(p(r, {
                    rZ: _9(u.a)
                })) : A2(DK, 1, EJ(p(r, {
                    rZ: u8
                })));
            case 17:
                return EJ(p(r, {
                    i4: A2(Wg, n.a, r.i4),
                    rZ: gs
                }));
            case 18:
                return A2(MK, C([
                    A2(Rs, J9, c8(n.a))
                ]), EJ(p(r, {
                    kC: r8
                })));
            case 19:
                return (f = n.a).$ ? EJ(p(r, {
                    kC: _9(f.a)
                })) : A2(DK, 1, EJ(p(r, {
                    kC: u8
                })));
            case 20:
                return A2(MK, C([
                    A2(Rs, z9, (s = n.a, Al(Lg($g(NY(s.mj))))))
                ]), EJ(p(r, {
                    ea: r8
                })));
            case 21:
                return (f = n.a).$ ? EJ(p(r, {
                    ea: _9(f.a)
                })) : A2(DK, 1, A2(DK, 0, EJ(p(r, {
                    ea: u8
                }))));
            case 22:
                return A2(MK, C([
                    A2(Rs, a8, Q8(n.a))
                ]), EJ(p(r, {
                    ea: r8
                })));
            case 23:
                return (f = n.a).$ ? EJ(p(r, {
                    ea: _9(f.a)
                })) : A2(DK, 1, A2(DK, 0, EJ(p(r, {
                    ea: u8
                }))));
            case 24:
                return A2(MK, C([
                    L8(0)
                ]), EJ(r));
            case 27:
                return EJ(p(r, {
                    km: kt(n.a)
                }));
            case 28:
                return A2(jK, A2(Rs, H9, A2(C8, n.a, n.b)), EJ(p(r, {
                    o2: r8
                })));
            case 31:
                return EJ(p(r, (f = n.a).$ ? {
                    o2: _9(f.a)
                } : {
                    o2: u8
                }));
            case 25:
                var a = (m = d(r.l5, r.g9)).a && !m.b.$ ? A2(Rs, U9, Al(A2(_s, dq, Vs(xs(cL(function(n) {
                    return {
                        $: 5,
                        a: n
                    };
                }(m.b.a.g9.mj))))))) : p$;
                return A2(jK, a, EJ(p(r, {
                    l5: !r.l5
                })));
            case 32:
                if ((f = n.a).$) return EJ(p(r, {
                    o2: _9(f.a)
                }));
                var o = f.a;
                return EJ(p(r, {
                    o2: u8,
                    ds: A2(Ge, A2(mu, ng(!1), T8), o)
                }));
            case 26:
                var c = n.a;
                return EJ(p(r, {
                    ds: A2(Ge, function(n) {
                        return i(A2(Po, tl, function(n) {
                            return n.mj;
                        })(n), c) ? d(!n.a, n.b) : n;
                    }, r.ds)
                }));
            case 34:
                return A2(jK, A2(Rs, V9, b8), EJ(p(r, {
                    l4: !1
                })));
            case 33:
                return EJ(p(r, (f = n.a).$ ? {
                    o2: _9(f.a)
                } : {
                    o3: f.a
                }));
            case 35:
                return EJ(p(r, {
                    g9: kt(n.a)
                }));
            case 36:
                return A2(MK, C([
                    A2(Rs, O9, A3(h8, n.a, "Media2Cloud", n.b))
                ]), EJ(p(r, {
                    iM: r8
                })));
            case 37:
                return EJ(p(r, (f = n.a).$ ? {
                    iM: _9(f.a)
                } : {
                    iM: u8
                }));
            case 40:
                return A2(jK, A2(Rs, e8, Al(A2(_s, v8, Vs(X$(Z$(A2(qP, n.a, 2))))))), EJ(p(r, {
                    l6: !1
                })));
            case 38:
                return EJ(p(r, {
                    p3: A2(Wg, n.a, r.p3)
                }));
            default:
                var f;
                return EJ(p(r, (f = n.a).$ ? {
                    iM: _9(f.a)
                } : {
                    dy: f.a
                }));
        }
        var s, l, b, m;
    }), U8 = {
        $: 5
    }, J8 = F2(function(n, r) {
        return {
            $: 7,
            a: n,
            b: r
        };
    }), Z8 = Pi({
        bQ: "Wrong layout and/or version",
        bX: "Erreur sur une version et/ou un agencement"
    }), K8 = F3(function(n, r, t) {
        return {
            fB: n,
            rQ: t,
            sd: r
        };
    }), _8 = ul(A4(ll, "typeVersion", function(n) {
        return n.rQ;
    }, Ry, A4(ll, "version", function(n) {
        return n.sd;
    }, P$, A4(ll, "index", function(n) {
        return n.fB;
    }, ml, gl(K8))))), G8 = F4(function(n, r, t, e) {
        var u = d(r, t);
        return u.a.$ || u.b.$ ? ZS({
            lz: Lu,
            nE: Z8,
            Q: 400
        }) : Al(Lg(A3(kg, _8, {
            fB: e,
            rQ: u.b.a,
            sd: u.a.a
        }, $g(X$(h4(A2(g4, n, 1)))))));
    }), Y8 = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 2:
                var t = n.a, e = n.b, u = n.c, a = {
                    rQ: Xi(function(n) {
                        return p(n, {
                            m$: "TypeVersion",
                            sa: A2(Qu, "", u)
                        });
                    }),
                    sd: Xi(function(n) {
                        return p(n, {
                            m$: "Version",
                            sa: A2(Qu, "", e)
                        });
                    })
                };
                return EJ(p(r, {
                    pg: kt(t),
                    sf: A3(ju, t, a, r.sf)
                }));
            case 0:
                var i = n.b;
                return EJ(p(r, {
                    sf: A3(Wo, o = n.a, Tu(function(n) {
                        return p(n, {
                            sd: A2(Wg, i, n.sd)
                        });
                    }), r.sf)
                }));
            case 1:
                return i = n.b, EJ(p(r, {
                    sf: A3(Wo, o = n.a, Tu(function(n) {
                        return p(n, {
                            rQ: A2(Wg, i, n.rQ)
                        });
                    }), r.sf)
                }));
            case 5:
                return DJ;
            case 7:
                n = U8;
                continue n;
            case 4:
                return A2(MK, C([
                    A2(b$, Hl(U8), Qx(200))
                ]), EJ(r));
            case 6:
                return EJ(p(r, {
                    pg: Ct,
                    sf: A2(Bo, t = n.a, r.sf)
                }));
            default:
                var o = n.a, c = function(n) {
                    var r = Oe(n);
                    return r.$ ? -1 : r.a;
                }, f = function(n) {
                    var r = A2(Pt, "/", n);
                    return r.b && r.b.b ? d(r.a, r.b.a) : d("", "");
                }, s = function() {
                    var n = A2(Lo, o, r.sf);
                    if (1 === n.$) return d(Ct, Ct);
                    var t = n.a.rQ;
                    return d(gX(B$(n.a.sd.sa)), gX(Xy(t.sa)));
                }(), l = s.a, b = s.b, m = A2(T4, c, f(o)).a;
                return A2(MK, C([
                    A2(Rs, J8(o), A4(G8, m, l, b, 0))
                ]), EJ(p(r, {
                    pg: Ct
                })));
        }
    }), n7 = F3(function(n, r, t) {
        n: for(;;)switch(n.$){
            case 0:
                return EJ(r);
            case 17:
                return EJ(p(r, {
                    qm: !r.qm
                }));
            case 16:
                var e = r.j6;
                return EJ(p(r, {
                    j6: p(e, {
                        or: A2(A2(pK, X = n.a, e.or) ? kK : Dc, X, e.or)
                    })
                }));
            case 18:
                return EJ(p(r, {
                    qn: !r.qn
                }));
            case 19:
                return EJ(p(r, {
                    qo: !r.qo
                }));
            case 1:
                return E2(r) && !i(r.Q.kt, Ct) ? EJ(p(r, {
                    na: !0
                })) : A2(MK, C([
                    A2(Rs, w1, W2(r.mj)),
                    A2(Rs, j1, t0(r.mj)),
                    A2(wp, C1, A2(O2, t.mF, r.mj)),
                    t3,
                    u3
                ]), EJ(n3(p(r, {
                    na: !1
                }))));
            case 3:
                return EJ(p(r, (E = n.a).$ ? {
                    e9: A2(ZZ, E.a, r.e9.kt)
                } : {
                    e9: AK(E.a)
                }));
            case 39:
                return n.a.$ ? DJ : ZK(GJ(0));
            case 2:
                if ((E = n.a).$) return EJ(p(r, {
                    Q: A2(ZZ, E.a, r.Q.kt)
                }));
                var u = r.oU, a = r.ir, o = i(t.r8.oz, kt((w = E.a).oz.mj)) ? Be : jK(A2(Rs, L1, SZ(w.oz.mj))), c = function(n) {
                    return n.bT.f2;
                }(A2(N1, r, w)), f = A2(Qu, "00:00:00:00", A2(Lp, D2, c)), s = !i(A2(Tu, A2(Po, function(n) {
                    return n.g9;
                }, function(n) {
                    return n.mj;
                }), r.Q.kt), kt(w.g9.mj)), l = function() {
                    var n = r.oR;
                    if (n.$) return J2(r);
                    var t = n.a;
                    return s ? J2(r) : kt(t);
                }();
                return o(A2(MK, C([
                    A2(wp, GV, a3(w)),
                    A2(wp, KV, t3)
                ]), EJ(p(r, {
                    ir: p(a, {
                        qO: f
                    }),
                    oR: l,
                    oU: function() {
                        return l.$ ? u : A2(K2, r, l.a);
                    }(),
                    Q: AK(w)
                }))));
            case 30:
                var m = n.a, v = J2(r), $ = function() {
                    return v.$ ? r.oU : A2(K2, r, v.a);
                }();
                return EJ(p(r, {
                    oR: A2(Tu, function(n) {
                        return p(n, {
                            q4: m
                        });
                    }, v),
                    oT: !1,
                    oU: p($, {
                        q4: m
                    })
                }));
            case 26:
                if (10 === n.a.$) {
                    var h = n.a.a;
                    if (h.$) return A2(_2, p(r, {
                        oR: Ct
                    }), !0);
                    var k = h.a, j = r.Q.kt;
                    if (j.$) return EJ(r);
                    var w = j.a, A = function() {
                        if (k.$) {
                            var n = k.a, t = A2(Pt, "/", n);
                            if (t.b && t.b.b) {
                                var e = t.a, u = t.b.a;
                                return b(A3(H1, r, w, e), A3(V1, r, w, e), Oe(u));
                            }
                            return b(A3(H1, r, w, n), A3(V1, r, w, n), Ct);
                        }
                        return b(Ct, A2(Lp, A2(Po, function(n) {
                            return n.o7;
                        }, function(n) {
                            return n.nm;
                        }), A2(N1, r, w).bT.f2), Ct);
                    }(), L = A.a, y = A.b, S = A.c, F = A2(Qu, Ct, A2(Tu, Y1, L)), T = A2(Qu, g, A2(Tu, Z1, L));
                    return f = A2(Qu, "00:00:00:00", A2(Lp, D2, L)), EJ(y.$ ? r : p(r, {
                        oR: kt(A6(O1, f, y.a.mj, F, S, kt(25), T)),
                        oT: !1
                    }));
                }
                return A3(mY, function(n) {
                    var t, e = 1 === (t = n.p8).$ ? r.i6.p8 : kt(t.a);
                    return p(r, {
                        i6: p(n, {
                            p8: e
                        })
                    });
                }, KV, A2(B4, H = n.a, r.i6));
            case 27:
                if (7 === (H = n.a).$) {
                    if ((E = H.b).$) return DJ;
                    var Q = p(r.i6, {
                        sf: A2(Bo, H.a, r.i6.sf)
                    }), I = p(r, {
                        i6: Q
                    });
                    return A2(DK, 1, EJ(I));
                }
                return A3(mY, function(n) {
                    return p(r, {
                        q5: n
                    });
                }, Q1, A2(Y8, H, r.q5));
            case 4:
                switch(n.a.$){
                    case 12:
                        if (n.a.a.$) return A2(_2, p(r, {
                            oR: Ct
                        }), !1);
                        if (i(kt(X = n.a.a.a), A2(Tu, function(n) {
                            return n.nT;
                        }, r.oR))) return A2(_2, r, !0);
                        var B = function() {
                            var n = r.Q.kt;
                            return n.$ ? Ct : Ra(A2(nc, Be, A2(nc, function(n) {
                                return A2(Tu, function(r) {
                                    return i(r.mj, X) ? kt(n) : Ct;
                                }, n.gL);
                            }, n.a.bS)));
                        }(), W = A2(Qu, Ct, A2(Tu, u0, B));
                        return f = A2(Qu, "00:00:00:00", A2(Lp, X2, B)), F = A2(Qu, Ct, A2(Tu, G1, B)), EJ(p(r, {
                            i6: Z2(r),
                            oR: A2(Tu, A2(mu, A5(O1, f, X, F, Ct, W), K1), B),
                            oT: !1
                        }));
                    case 13:
                        var P = i(kt(kt(X = n.a.a)), A2(Tu, function(n) {
                            return n.q4;
                        }, r.oR)) ? Ct : kt(X), M = ($ = r.oU, A2(Tu, function(n) {
                            return p(n, {
                                q4: P
                            });
                        }, r.oR));
                        return EJ(p(r, {
                            oR: M,
                            oU: p($, {
                                q4: P
                            })
                        }));
                    default:
                        return A3(mY, function(n) {
                            return p(r, {
                                bT: n
                            });
                        }, A1, A2(B9, H = n.a, r.bT));
                }
            case 5:
                if (33 === n.a.$) {
                    var q = r.ir;
                    return A2(_2, p(r, {
                        ir: p(q, {
                            l$: !q.l$
                        }),
                        oR: Ct,
                        oU: uf
                    }), !0);
                }
                return A3(mY, function(n) {
                    return p(r, {
                        ir: n
                    });
                }, m1, A3(l4, H = n.a, r.ir, r.oU));
            case 6:
                return A3(mY, function(n) {
                    return p(r, {
                        ik: n
                    });
                }, b1, A2(U3, H = n.a, r.ik));
            case 7:
                return A3(mY, function(n) {
                    return p(r, {
                        ea: n
                    });
                }, p1, A2(n1, H = n.a, r.ea));
            case 8:
                return A3(mY, function(n) {
                    return p(r, {
                        k$: n
                    });
                }, C1, A2(L9, H = n.a, r.k$));
            case 9:
                return EJ(r);
            case 10:
                return A3(mY, function(n) {
                    return p(r, {
                        ow: n
                    });
                }, GV, A2(V8, H = n.a, r.ow));
            case 11:
                return A3(mY, function(n) {
                    return p(r, {
                        i9: n
                    });
                }, v1, A2(W4, H = n.a, r.i9));
            case 12:
                return A3(mY, function(n) {
                    return p(r, {
                        fJ: n
                    });
                }, y1, A2(x9, H = n.a, r.fJ));
            case 13:
                return A3(mY, function(n) {
                    return p(r, {
                        cT: n
                    });
                }, k1, A2(s1, H = n.a, r.cT));
            case 14:
                if (20 === n.a.$ && 1 === n.a.b.$) {
                    n = h1(A2(F1, n.a.a, kt(A2(P1, r.oU.qO, r.oU.kn))));
                    continue n;
                }
                return A3(mY, function(n) {
                    return p(r, {
                        kF: n
                    });
                }, h1, A3(s9, H = n.a, r.kF, r.Q.kt));
            case 15:
                return M = r.oR, EJ(p(r, {
                    jp: !r.jp,
                    oR: r.jp ? Ct : M,
                    oT: !!r.jp || r.oT,
                    oU: r.jp ? uf : r.oU
                }));
            case 20:
                return R1(C([
                    N2((B = n.b).fR),
                    A2(Rs, S1, gZ(B.mj))
                ]));
            case 24:
                return R1(C([
                    q1((B = n.b).fR),
                    A2(Rs, $1, lZ(B.mj))
                ]));
            case 22:
                w = n.b;
                var D = i3((B = n.c).c9);
                return R1(C([
                    Y2(B.fR),
                    A2(Rs, T1, A3(d_, w, D, B.nW))
                ]));
            case 21:
            case 23:
            case 25:
                return x1(1);
            case 28:
                var X;
                return A2(MK, C([
                    A2(Rs, g1, X1(X = n.a))
                ]), EJ(r));
            case 29:
                var E;
                return (E = n.a).$ ? DJ : A2(DK, 1, EJ(r));
            case 31:
                return A2(_2, p(r, {
                    oT: !1
                }), !1);
            case 33:
                return EJ(p(r, {
                    rM: !1
                }));
            case 34:
                return EJ(p(r, {
                    rM: !0
                }));
            case 32:
                return EJ(p(r, {
                    oT: !0,
                    oU: uf
                }));
            case 36:
                var R = n.a, x = R.a, O = R.b, z = A2(Tu, function(n) {
                    return p(n, {
                        p9: kt(x),
                        qa: A2(mg, x, A2(Ge, $e, n.qa)) ? A2(Bu, function(n) {
                            return !i(n.a, x);
                        }, n.qa) : A2(bt, d(x, O), n.qa)
                    });
                }, r.oR);
                return A2(_2, p(r, {
                    oR: z,
                    oT: !1
                }), !1);
            case 35:
                return EJ(p(r, {
                    iZ: !r.iZ
                }));
            case 37:
                var N = n.a;
                return z = A2(Tu, function(n) {
                    return p(n, {
                        qa: N
                    });
                }, r.oR), EJ(p(r, {
                    oR: z
                }));
            case 38:
                var H, V = A2(w3, H = n.a, r.oU);
                return Q = V.a, A2(jK, A2(wp, YV, V.b), EJ(p(r, {
                    oU: Q
                })));
            default:
                return ZK(E1(n.a));
        }
    }), r7 = F2(function(n, r) {
        if (n.$) {
            var t = n.a;
            return A2(eo, g, p(r, {
                rA: A3(pY, t.a, t.b, r.rA)
            }));
        }
        var e = n.a;
        return A2(eo, g, p(r, e.$ ? {
            ll: kt(e.a.nE)
        } : {
            ll: Ct,
            rA: sY(e.a)
        }));
    }), t7 = {
        $: 1
    }, e7 = function(n) {
        return 1 === n.al.r6.$ ? function(n) {
            return {
                $: 0,
                a: n
            };
        }(n.g9.Q.kt) : t7;
    }, u7 = F2(function(n, r) {
        switch(n.$){
            case 14:
                return A2(eo, g, r);
            case 3:
                var t = Bv(n.a), e = A3(NN, !1, t, r), u = (f = e.a).al;
                return A2(eo, C([
                    e.b
                ]), p(f, {
                    al: p(u, {
                        r6: t
                    })
                }));
            case 13:
                return A2(eo, g, 27 === n.a ? p(r, {
                    r$: mo(r.al.r8)
                }) : r);
            case 1:
                var a = n.a, o = n.b;
                return i(a, r.g9.mj) ? A4(zJ, function(n) {
                    return p(r, {
                        g9: n
                    });
                }, Pv(a), r.g9, A3(n7, o, r.g9, r.al)) : A2(eo, g, r);
            case 2:
                return A4(zJ, function(n) {
                    return p(r, {
                        n8: n
                    });
                }, Wv, r.n8, A3(l1, o = n.a, r.n8, r.al));
            case 5:
                var c = A2(r7, o = n.a, r.rA), f = c.a;
                return A2(eo, C([
                    A2(wp, Fi, c.b)
                ]), p(r, {
                    rA: f
                }));
            case 8:
                var s = A2(oZ, o = n.a, r.iz);
                return f = s.a, A2(eo, C([
                    A2(wp, wi, s.b)
                ]), p(r, {
                    iz: f
                }));
            case 7:
                var l = A2(VJ, o = n.a, r.cj);
                return f = l.a, A2(eo, C([
                    A2(wp, vJ, l.b)
                ]), p(r, {
                    cj: f
                }));
            case 6:
                var d = A2(aZ, o = n.a, r.dz);
                return f = d.a, A2(eo, C([
                    A2(wp, gJ, d.b)
                ]), p(r, {
                    dz: f
                }));
            case 0:
                var b = A2(QZ, o = n.a, r.al);
                return f = b.a, A2(eo, C([
                    A2(wp, mH, b.b)
                ]), p(r, {
                    al: f
                }));
            case 9:
                return A4(zJ, function(n) {
                    return p(r, {
                        r$: n
                    });
                }, $H, r.r$, A2(k_, o = n.a, r.r$));
            case 10:
                var m = A3(NK, o = n.a, r.pW, r.eu);
                return f = m.a, A2(eo, C([
                    A2(wp, $J, m.b)
                ]), p(r, {
                    pW: f
                }));
            case 11:
                var v = A2(C_, o = n.a, r.l2);
                return f = v.a, A2(eo, C([
                    A2(wp, Li, v.b)
                ]), p(r, {
                    l2: f
                }));
            case 12:
                if (2 === n.a.$) {
                    var $ = n.a.a, h = A4(zJ, function(n) {
                        return p(r, {
                            r$: n
                        });
                    }, $H, r.r$, A3(RJ, e7(r), $, r.r$));
                    return f = h.a, A2(eo, C([
                        h.b
                    ]), p(f, {
                        kY: A2(d1, pJ($), r.kY)
                    }));
                }
                return A2(eo, g, p(r, {
                    kY: A2(d1, o = n.a, r.kY)
                }));
            case 4:
                return A4(zJ, function(n) {
                    return p(r, {
                        eu: n
                    });
                }, Ai, r.eu, A2(XK, o = n.a, r.eu));
            default:
                return A2(eo, g, p(r, {
                    mO: !n.a
                }));
        }
    }), a7 = F2(function(n, r) {
        var t = d(r, n);
        n: for(;;){
            if (t.a.$) {
                if (t.b.$) break n;
                var e = A2(u7, t.b.a, t.a.a);
                return a = e.b, d(yi(e.a), A2(wp, Si, a));
            }
            if (1 === t.b.$) {
                var u = A2(mJ, t.b.a, t.a.a), a = u.b;
                return d(di(u.a), A2(wp, sH, a));
            }
            break n;
        }
        return d(r, p$);
    }), i7 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, o7 = {
        $: 1
    }, c7 = Pi({
        bQ: "Back to login",
        bX: "Retour au login"
    }), f7 = F2(function(n, r) {
        return A2(tj, C([
            aj(n),
            nh("AccountForm")
        ]), r);
    }), s7 = F2(function(n, r) {
        return A2(hj, C([
            wj(n)
        ]), C([
            A2(bI, g, C([
                ch(r)
            ]))
        ]));
    }), l7 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, d7 = function(n) {
        switch(n.$){
            case 0:
                return "/";
            case 1:
                switch(n.a.$){
                    case 1:
                        return "/account/forgotPassword";
                    case 0:
                        var r = n.a.a.lV;
                        if (1 === r.$) return "/account/login";
                        switch(r.a){
                            case "/":
                            case "/logout":
                                return "/account/login";
                            default:
                                return "/account/login?from=" + r.a;
                        }
                    case 2:
                        return "/account/resetPassword?email=" + n.a.a.k6 + "&token=" + n.a.a.rH;
                    default:
                        return "/account/invitation?redirect=" + n.a.a.pl + "&email=" + n.a.a.k6 + "&token=" + n.a.a.rH;
                }
            case 2:
                switch(n.a){
                    case 0:
                        return "/services/forProd";
                    case 1:
                        return "/services/forTv";
                    case 2:
                        return "/services";
                    default:
                        return "/services/references";
                }
            case 3:
                return "/legal";
            default:
                return "/404";
        }
    }, b7 = d7(l7(function(n) {
        return {
            $: 0,
            a: n
        };
    }({
        lV: Ct
    }))), m7 = Pi({
        bQ: "Password forgotten",
        bX: "Mot de passe oubli\xe9"
    }), p7 = Pi({
        bQ: "Recover",
        bX: "R\xe9cup\xe8rer"
    }), v7 = Pi({
        bQ: "Email sent",
        bX: "Email envoy\xe9"
    }), $7 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, g7 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, h7 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, k7 = {
        $: 4
    }, C7 = Pi({
        bQ: "Answer invitation",
        bX: "R\xe9pondre \xe0 l\u2019invitation"
    }), j7 = function(n) {
        return A2(Se, C([
            nh("BannerEmptyness")
        ]), C([
            UW,
            A2(_h, C([
                nh("BannerContent")
            ]), n)
        ]));
    }, w7 = function(n) {
        switch(n){
            case 0:
                return Pi({
                    bQ: "Confirmation doesn't match password",
                    bX: "La confirmation est differente du mot de passe"
                });
            case 1:
                return Pi({
                    bQ: "Password is too short (min. 9)",
                    bX: "Mot de passe trop court (min. 9)"
                });
            case 2:
                return Pi({
                    bQ: "Password must contain at least a lowercase char.",
                    bX: "Le mot de passe doit contenir au moins un caract\xe8re minuscule."
                });
            case 3:
                return Pi({
                    bQ: "Password must contain at least an uppercase char.",
                    bX: "Le mot de passe doit contenir au moins caract\xe8re majuscule."
                });
            case 4:
                return Pi({
                    bQ: "Password must contain at least a number.",
                    bX: "Le mot de passe doit contenir au moins un chiffre."
                });
            default:
                return Pi({
                    bQ: "Password must contain at least a special char.",
                    bX: "Le mot de passe doit contenir au moins un caract\xe8re sp\xe9cial."
                });
        }
    }, L7 = Pi({
        bQ: "Send",
        bX: "Envoyer"
    }), y7 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, S7 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, T7 = Pi({
        bQ: "Access Nomalab",
        bX: "Acc\xe9der \xe0 Nomalab"
    }), Q7 = Pi({
        bQ: "Connection",
        bX: "Connexion"
    }), I7 = d7(l7({
        $: 1
    })), B7 = Pi({
        bQ: "Forgot password?",
        bX: "Mot de passe oubli\xe9"
    }), W7 = Pi({
        bQ: "Submit Email",
        bX: "Valider Email"
    }), P7 = Pi({
        bQ: "Email sent. You have 48h to validate.",
        bX: "Un email vient de vous \xeatre envoy\xe9. Vous disposez de 48h pour le valider."
    }), M7 = function(n) {
        return A2(Se, C([
            nh("AccountMessage")
        ]), C([
            function() {
                switch(n.$){
                    case 0:
                        return ch("");
                    case 1:
                        return A2(_h, C([
                            nh("AccountSuccess")
                        ]), P7);
                    default:
                        var r = n.a;
                        return A2(_h, C([
                            nh("AccountFail")
                        ]), r);
                }
            }()
        ]));
    }, q7 = Ng("fill"), D7 = Ng("stroke"), X7 = Ng("stroke-linejoin"), E7 = Ng("stroke-width"), R7 = A2(Qh, C([
        Ih("0 0 524 134"),
        Bh("524px")
    ]), C([
        A2(UC, g, C([
            A2(Cj, C([
                kj("M419.771468,31.2572374 L419.771468,96.3052532 L429.351007,98.6620653 L429.351007,103.847052 L401.85773,103.847052 L401.85773,98.6620653 L410.000338,96.3052532 L410.000338,38.7990363 L401.85773,36.9135866 L401.85773,31.7285998 L419.771468,31.2572374 Z M433.014638,56.7108088 C439.91194,54.1968632 446.234372,52.9399093 451.982124,52.9399093 C457.602149,52.9399093 461.912898,54.0554559 464.914502,56.2865826 C467.916106,58.5177093 469.416885,62.2728591 469.416885,67.5521447 L469.416885,96.3052532 L477.080516,98.1907029 L477.080516,103.37569 L462.232231,103.847052 L460.220528,97.247978 C455.111415,102.275869 450.066242,104.789777 445.084857,104.789777 C440.103471,104.789777 436.367489,103.564247 433.876796,101.11315 C431.386104,98.6620531 430.140776,95.1740059 430.140776,90.648904 C430.140776,80.907365 437.485016,76.0366685 452.173715,76.0366685 L459.837346,76.0366685 L459.837346,68.4948696 C459.837346,62.8384921 456.803856,60.0103458 450.736784,60.0103458 C447.288133,60.0103458 444.446232,60.3560081 442.210995,61.0473432 L441.06145,61.4244331 L439.720315,68.4948696 L433.493615,68.4948696 L433.014638,56.7108088 Z M459.837346,82.1643802 L453.131669,82.1643802 C448.341876,82.1643802 444.941174,82.7771452 442.92946,84.0026937 C440.917747,85.2282421 439.911906,87.1293849 439.911906,89.7061791 C439.911906,92.157276 440.502638,94.026995 441.68412,95.315392 C442.865603,96.6037891 444.573937,97.247978 446.809174,97.247978 C447.89486,97.247978 448.996496,97.0594349 450.114114,96.6823431 C451.231733,96.3052513 452.317403,95.8338936 453.371158,95.2682558 C454.424912,94.7026181 455.366891,94.089853 456.197122,93.4299423 C457.027352,92.7700316 457.697913,92.1572666 458.208825,91.5916288 L459.837346,89.7061791 L459.837346,82.1643802 Z M489.197547,31.2572374 L489.197547,58.4077135 C493.859613,54.7624925 498.649334,52.9399093 503.566856,52.9399093 C510.33643,52.9399093 515.381603,55.1081548 518.702527,59.4447109 C522.02345,63.781267 523.683887,69.9403412 523.683887,77.9221183 C523.683887,81.8187339 523.10912,85.4167645 521.95957,88.716318 C520.81002,92.0158715 519.117651,94.8597298 516.882414,97.247978 C514.647178,99.6362263 511.901071,101.490233 508.644011,102.810055 C505.386952,104.129876 501.619037,104.789777 497.340155,104.789777 C494.083096,104.726928 491.161366,104.585521 488.574877,104.365551 C485.988389,104.145581 483.705288,103.721359 481.725507,103.092872 L479.618009,102.432965 L479.618009,38.7990363 L471.954378,36.9135866 L471.954378,31.7285998 L489.197547,31.2572374 Z M489.197547,96.3052532 C490.730281,96.9337395 494.051155,97.247978 499.160268,97.247978 C501.714824,97.247978 503.90213,96.7766203 505.722252,95.8338907 C507.542373,94.8911611 509.043153,93.5870715 510.224635,91.9215825 C511.406117,90.2560936 512.268267,88.2763912 512.81111,85.9824159 C513.353954,83.6884406 513.625371,81.1902446 513.625371,78.4877532 C513.625371,72.8313757 512.651461,68.4163251 510.703612,65.2424688 C508.755763,62.0686126 505.738238,60.4817082 501.650948,60.4817082 C498.457752,60.4817082 495.887268,61.0944733 493.939419,62.3200217 C491.99157,63.5455702 490.410962,64.9753553 489.197547,66.6094199 L489.197547,96.3052532 Z"),
                q7("#3BAAFF")
            ]), g),
            A2(Cj, C([
                kj("M172.806239,53.8826342 L173.668397,60.5759807 C174.307037,60.0731916 175.201118,59.381867 176.350668,58.501986 C177.500219,57.6221051 178.857306,56.7736612 180.421972,55.9566289 C181.986638,55.1395966 183.710938,54.43256 185.594923,53.8354979 C187.478909,53.2384359 189.442694,52.9399093 191.48634,52.9399093 C196.659316,52.9399093 200.507059,54.4325421 203.029684,57.4178524 C205.552308,60.4031628 206.813602,64.5668226 206.813602,69.9089569 L206.813602,96.3052532 L213.998256,98.6620653 L213.998256,103.847052 L191.007363,103.847052 L191.007363,98.6620653 L197.234063,96.3052532 L197.234063,70.8516818 C197.234063,67.4578553 196.563502,64.9596594 195.22236,63.3570191 C193.881218,61.7543788 191.837603,60.9530707 189.091455,60.9530707 C187.750313,60.9530707 186.425156,61.1259018 185.115946,61.4715693 C183.806736,61.8172369 182.59334,62.2728827 181.475722,62.8385204 C180.358103,63.4041582 179.368227,64.0169232 178.506065,64.6768339 C177.643902,65.3367446 176.925444,65.9809335 176.350668,66.6094199 L174.722147,68.4948696 L174.722147,96.3052532 L180.948847,98.6620653 L180.948847,103.847052 L157,103.847052 L157,98.6620653 L165.142608,96.3052532 L165.142608,61.4244331 L157,59.5389834 L157,54.3539966 L172.806239,53.8826342 Z M213.703933,79.619023 C213.703933,75.5967102 214.294665,71.9358319 215.476147,68.6362783 C216.65763,65.3367248 218.334032,62.5242904 220.505405,60.1988908 C222.676778,57.8734911 225.247262,56.0823318 228.216934,54.825359 C231.186606,53.5683863 234.459582,52.9399093 238.035961,52.9399093 C245.188719,52.9399093 250.744796,55.1710025 254.704359,59.6332559 C258.663921,64.0955092 260.643673,70.2860073 260.643673,78.2049357 C260.643673,82.1015513 260.068906,85.6681581 258.919356,88.904863 C257.769805,92.1415678 256.157266,94.9382903 254.081689,97.2951143 C252.006112,99.6519382 249.483525,101.490233 246.513853,102.810055 C243.544181,104.129876 240.239273,104.789777 236.59903,104.789777 C229.318545,104.789777 223.682639,102.652955 219.691145,98.3792479 C215.69965,94.1055404 213.703933,87.8521947 213.703933,79.619023 L213.703933,79.619023 Z M237.65278,60.4817082 C228.392513,60.4817082 223.762448,66.6093586 223.762448,78.8648431 C223.762448,91.1203277 228.232855,97.247978 237.173803,97.247978 C241.835868,97.247978 245.236571,95.6767856 247.376012,92.5343537 C249.515453,89.3919218 250.585157,84.6783446 250.585157,78.3934807 C250.585157,66.4522394 246.274408,60.4817082 237.65278,60.4817082 L237.65278,60.4817082 Z M276.113543,53.8826342 L276.975701,60.5759807 C277.869796,59.7589484 278.955466,58.8947926 280.232744,57.9834873 C281.510023,57.0721821 282.915008,56.2394501 284.447741,55.4852664 C285.980475,54.7310828 287.593015,54.1183177 289.285409,53.646953 C290.977802,53.1755882 292.654205,52.9399093 294.314666,52.9399093 C300.764921,52.9399093 305.203397,55.6423602 307.630225,61.0473432 C308.779776,59.9160677 310.120898,58.8633688 311.653632,57.8892149 C313.186365,56.915061 314.766973,56.0509051 316.395503,55.2967215 C318.024033,54.5425378 319.620607,53.9611966 321.185273,53.5526805 C322.749938,53.1441643 324.170889,52.9399093 325.448167,52.9399093 C335.347074,52.9399093 340.296452,58.5962019 340.296452,69.9089569 L340.296452,96.3052532 L347.481107,98.6620653 L347.481107,103.847052 L324.490213,103.847052 L324.490213,98.6620653 L330.716914,96.3052532 L330.716914,70.8516818 C330.716914,67.3950066 330.110216,64.8810988 328.896801,63.3098828 C327.683387,61.7386669 325.703635,60.9530707 322.957487,60.9530707 C321.616345,60.9530707 320.32312,61.1259018 319.077774,61.4715693 C317.832428,61.8172369 316.666929,62.2728827 315.581242,62.8385204 C314.495556,63.4041582 313.537612,64.0169232 312.707381,64.6768339 C311.87715,65.3367446 311.206589,65.9809335 310.695678,66.6094199 L309.162951,68.4948696 L309.162951,96.3052532 L315.389652,98.6620653 L315.389652,103.847052 L293.356713,103.847052 L293.356713,98.6620653 L299.583413,96.3052532 L299.583413,70.8516818 C299.583413,67.3950066 298.976715,64.8810988 297.7633,63.3098828 C296.549886,61.7386669 294.570134,60.9530707 291.823986,60.9530707 C290.482844,60.9530707 289.189619,61.1259018 287.944273,61.4715693 C286.698927,61.8172369 285.533428,62.2728827 284.447741,62.8385204 C283.362055,63.4041582 282.404111,64.0169232 281.57388,64.6768339 C280.743649,65.3367446 280.073088,65.9809335 279.562177,66.6094199 L278.02945,68.4948696 L278.02945,96.3052532 L284.256151,98.6620653 L284.256151,103.847052 L260.307304,103.847052 L260.307304,98.6620653 L268.449912,96.3052532 L268.449912,61.4244331 L260.307304,59.5389834 L260.307304,54.3539966 L276.113543,53.8826342 Z M353.539622,56.7108088 C360.436925,54.1968632 366.759357,52.9399093 372.507109,52.9399093 C378.127133,52.9399093 382.437883,54.0554559 385.439486,56.2865826 C388.44109,58.5177093 389.94187,62.2728591 389.94187,67.5521447 L389.94187,96.3052532 L397.605501,98.1907029 L397.605501,103.37569 L382.757215,103.847052 L380.745512,97.247978 C375.636399,102.275869 370.591226,104.789777 365.609841,104.789777 C360.628456,104.789777 356.892473,103.564247 354.401781,101.11315 C351.911088,98.6620531 350.665761,95.1740059 350.665761,90.648904 C350.665761,80.907365 358.01,76.0366685 372.6987,76.0366685 L380.362331,76.0366685 L380.362331,68.4948696 C380.362331,62.8384921 377.328841,60.0103458 371.261769,60.0103458 C367.813118,60.0103458 364.971216,60.3560081 362.735979,61.0473432 L361.586435,61.4244331 L360.245299,68.4948696 L354.018599,68.4948696 L353.539622,56.7108088 Z M380.362331,82.1643802 L373.656654,82.1643802 C368.86686,82.1643802 365.466158,82.7771452 363.454445,84.0026937 C361.442732,85.2282421 360.43689,87.1293849 360.43689,89.7061791 C360.43689,92.157276 361.027622,94.026995 362.209105,95.315392 C363.390587,96.6037891 365.098921,97.247978 367.334158,97.247978 C368.419845,97.247978 369.52148,97.0594349 370.639099,96.6823431 C371.756717,96.3052513 372.842388,95.8338936 373.896142,95.2682558 C374.949897,94.7026181 375.891875,94.089853 376.722106,93.4299423 C377.552337,92.7700316 378.222898,92.1572666 378.733809,91.5916288 L380.362331,89.7061791 L380.362331,82.1643802 Z"),
                q7("#FFFFFF"),
                Hg("HomeLogoNomalab")
            ]), g),
            A2(UC, C([
                D7("#252F3A"),
                X7("round"),
                E7("4"),
                zQ("translate(2.000000, 2.000000)")
            ]), C([
                A2(Th, C([
                    q7("#FFFFFF"),
                    Lh("40 10 60 0 120 30 120 50 100 60 140 80 140 100 80 130 60 120 60 100 20 120 0 110 0 50 20 40 40 50")
                ]), g),
                A2(Th, C([
                    q7("#3BAAFF"),
                    Lh("80 10 60 20 60 40 40 50 60 60 80 50 100 60 100 40 80 30")
                ]), g),
                A2(Th, C([
                    q7("#3BAAFF"),
                    Lh("40 50 20 60 20 80 0 90 20 100 40 90 60 100 60 80 40 70")
                ]), g),
                A2(Th, C([
                    q7("#3BAAFF"),
                    Lh("100 60 80 70 80 90 60 100 80 110 100 100 120 110 120 90 100 80")
                ]), g)
            ]))
        ]))
    ])), x7 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, O7 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, z7 = {
        $: 3
    }, N7 = Pi({
        bQ: "Back to login",
        bX: "Retour au login"
    }), H7 = Pi({
        bQ: "Change",
        bX: "Changer"
    }), V7 = function(n) {
        return A2(NC, n, function(n) {
            return A2(Yh, n, A2(rk, C([
                nh("InputPassword"),
                sk(n.kT),
                qh("password"),
                $k(zh),
                bk(Nh),
                mk(Hh),
                hk(n.sa),
                gk(n.gy),
                tk(ck(n.m$)),
                nk(n.kO),
                A2(ZW, "autocomplete", "new-password")
            ]), g));
        }(n));
    }, U7 = Pi({
        bQ: "Lost password",
        bX: "Mot de passe oubli\xe9"
    }), J7 = Pi({
        bQ: "Your password has been changed",
        bX: "Votre mot de passe a \xe9t\xe9 chang\xe9"
    }), Z7 = function(n) {
        switch(n.$){
            case 0:
                return ch("");
            case 1:
                return ch(J7);
            default:
                return ch(n.a);
        }
    }, K7 = function(n) {
        return {
            $: 12,
            a: n
        };
    }, _7 = {
        $: 0
    }, G7 = {
        $: 1
    }, Y7 = F2(function(n, r) {
        return A2(Jg, n, function(n) {
            return {
                $: 3,
                a: n
            };
        }(r));
    }), nnn = F2(function(n, r) {
        return A2(Y7, n, Qe({
            nE: r,
            o1: !0,
            qX: !1
        }));
    }), rnn = nnn("dragenter"), tnn = nnn("dragleave"), enn = nnn("dragover"), unn = F3(function(n, r, t) {
        return A2(Y7, n, A2(Fe, function(n) {
            return {
                nE: t(n),
                o1: !0,
                qX: !0
            };
        }, r));
    }), ann = F2(function(n, r) {
        return A3(unn, "drop", r, function(r) {
            return n(pJ(r));
        });
    }), inn = F2(function(n, r) {
        return C([
            rnn(n(_7)),
            tnn(n(G7)),
            enn(n(_7)),
            A2(ann, n, r)
        ]);
    }), onn = F4(function(n, r, t, e) {
        return {
            jg: e,
            nH: t,
            nW: n,
            qy: r
        };
    }), cnn = A5(ez, onn, A2(du, "name", Bi), A2(du, "size", dl), A2(du, "type", A2(Fe, function(n) {
        return qe(n) > 0 ? kt(n) : Ct;
    }, Bi)), Qi), fnn = A2(lk, C([
        "dataTransfer",
        "files"
    ]), pl(cnn)), snn = function(n) {
        return 1 === n.aN;
    }, lnn = F2(function(n, r) {
        return kw(A2(mu, Sk(n), r));
    }), dnn = sr, bnn = F3(function(n, r, t) {
        return mC(A2(n, r, t));
    }), mnn = F3(function(n, r, t) {
        return si(A4(dnn, bnn, n, r, t));
    }), pnn = mnn, vnn = F2(function(n, r) {
        return pnn(F2(function(t, e) {
            return A2(Sk, n, A2(r, t, e));
        }));
    }), $nn = F2(function(n, r) {
        return $C(F3(function(t, e, u) {
            return A2(Sk, n, A3(r, t, e, u));
        }));
    }), gnn = {
        $: 0
    }, hnn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, knn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Cnn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, jnn = Pi({
        bQ: "Please contact our customer service via email or chat ",
        bX: "Merci de contacter notre service op\xe9rations via le chat ou par mail "
    }), wnn = C([
        ch(jnn),
        A2(hj, C([
            wj("mailto:ops@nomalab.com")
        ]), C([
            ch("ops@nomalab.com")
        ])),
        ch(".")
    ]), Ann = F2(function(n, r) {
        return A2(Nq, n, A2(Se, g, C([
            "" === r.nE && rX(r.lz) ? A2(bI, g, wnn) : ch(""),
            "" === r.nE ? ch("") : A2(bI, g, C([
                ch(r.nE)
            ])),
            rX(r.lz) ? ch("") : A2(ix, g, A2(Ge, function(n) {
                return A2(cx, g, C([
                    ch(n)
                ]));
            }, _u(vW(r.lz))))
        ])));
    }), Lnn = Pi({
        bQ: "Generate",
        bX: "G\xe9n\xe9rer"
    }), ynn = Pi({
        bQ: "error occurred",
        bX: "Une erreur est survenue"
    }), Snn = ynn, Fnn = function(n) {
        return A2(Yh, n, A2(rk, C([
            nh("InputText"),
            qh("date"),
            $k(zh),
            hk(n.sa),
            gk(n.gy),
            tk(ck(n.m$)),
            nk(n.kO)
        ]), g));
    }, Tnn = function(n) {
        return A2(NC, n, Fnn(n));
    }, Qnn = Pi({
        bQ: "Report",
        bX: "Rapport"
    }), Inn = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Bnn = F3(function(n, r, t) {
        return xs(function(n) {
            return {
                $: 15,
                a: n
            };
        }(A3(Inn, n, r, t)));
    }), Wnn = F2(function(n, r) {
        var t = r.a, e = r.b;
        return A2(Se, C([
            nh("SelectMultipleItem"),
            Zh(C([
                d("SelectMultipleItemSelected", A2(NJ, t, n.sb))
            ])),
            Mh(t)
        ]), C([
            ch(e)
        ]));
    }), Pnn = function(n) {
        var r = A2(Se, C([
            nh("SelectMultiple"),
            Zh(C([
                d("SelectMultipleDisabled", !n.e5)
            ]))
        ]), C([
            A2(Se, C([
                nh("SelectMultipleList")
            ]), A2(Ge, Wnn(n), n.eC))
        ]));
        return "" === n.m$ ? r : A2(OC, C([
            nh("SelectMultipleLabel")
        ]), C([
            A2(Se, C([
                nh("SelectMultipleLabelText")
            ]), C([
                ch(n.m$)
            ])),
            r
        ]));
    }, Mnn = F2(function(n, r) {
        var t, e = "rapport_" + r.qL.sa + "_" + r.lg.sa + ".csv";
        return A2(Se, C([
            nh("AccountReportWrapper")
        ]), C([
            Ij(p(Bj, {
                rB: Qnn
            })),
            A2(Se, C([
                nh("AccountReportContainer")
            ]), C([
                A2(Se, C([
                    Mh(gnn)
                ]), C([
                    (t = r.ll, t.$ ? ch("") : A2(Ann, Snn, t.a))
                ])),
                A2(Sk, Cnn, Tnn(r.qL)),
                A2(Sk, hnn, Tnn(r.lg)),
                A2(Sk, knn, Pnn(r.oD)),
                FW(p(AW, {
                    jM: kt("AccountReportSubmit"),
                    lu: C([
                        A2(ZW, "target", "_blank"),
                        A2(ZW, "data-prevent-history", "true"),
                        A2(ZW, "download", e)
                    ]),
                    m$: Lnn,
                    r6: kt(Hs(A3(Bnn, r.qL.sa, r.lg.sa, vt(r.oD.sb))))
                }))
            ]))
        ]));
    }), qnn = {
        $: 7
    }, Dnn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Xnn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Enn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Rnn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, xnn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Onn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, znn = {
        $: 6
    }, Nnn = {
        $: 9
    }, Hnn = Pi({
        bQ: "Change password",
        bX: "Changer de mot de passe"
    }), Vnn = Pi({
        bQ: "General Informations",
        bX: "Informations g\xe9n\xe9rales"
    }), Unn = Pi({
        bQ: "Save",
        bX: "Enregistrer"
    }), Jnn = Pi({
        bQ: "Settings",
        bX: "Param\xe8tres"
    }), Znn = F2(function(n, r) {
        return A2(xg, C([
            Mh(r),
            qh("button"),
            nh("Button")
        ]), C([
            ch(n)
        ]));
    }), Knn = F3(function(n, r, t) {
        var e = r.a, u = r.b;
        return A2(Se, C([
            A2(gh, "max-width", "500px"),
            A2(gh, "margin", "10px")
        ]), C([
            A2(yA, g, C([
                ch(n)
            ])),
            A2(Se, g, t),
            A2(Se, C([
                A2(gh, "display", "flex"),
                A2(gh, "justify-content", "flex-end")
            ]), C([
                A2(Znn, e, u)
            ]))
        ]));
    }), _nn = Pi({
        bQ: "Success",
        bX: "Succ\xe8s"
    }), Gnn = F2(function(n, r) {
        return A2(Se, C([
            nh("BannerSuccess")
        ]), C([
            A2(Se, C([
                nh("BannerHeader")
            ]), C([
                Wh,
                zq(n)
            ])),
            A2(Se, C([
                nh("BannerContent")
            ]), C([
                r
            ]))
        ]));
    }), Ynn = F2(function(n, r) {
        var t, e, u;
        return A2(Se, C([
            nh("SettingsContainer")
        ]), C([
            Ij(p(Bj, {
                rB: Jnn
            })),
            A2(Se, C([
                Mh(qnn)
            ]), C([
                (u = r.ll, u.$ ? ch("") : A2(Ann, Snn, u.a)),
                (e = r.re, e.$ ? ch("") : A2(Gnn, _nn, ch(e.a)))
            ])),
            A3(Knn, Vnn, d(Unn, znn), C([
                A2(Sk, Enn, VC(r.nW)),
                A2(Sk, Xnn, VC(r.k6)),
                A2(Sk, Dnn, HC(r.kN))
            ])),
            A3(Knn, Hnn, d(Unn, Nnn), C([
                A2(Sk, Onn, DO(r.oN)),
                A2(Sk, Rnn, V7(r.n1)),
                A2(Sk, xnn, V7(r.n2)),
                (t = r.oO, t.$ ? ch("") : j7(w7(t.a)))
            ])),
            A2(Se, C([
                nh("Version")
            ]), C([
                ch("version " + r.sd)
            ]))
        ]));
    }), nrn = F4(function(n, r, t, e) {
        var u = e, a = u.l(n);
        return a.$ ? A2(Se, g, g) : A2(Sk, u.q, A2(u.s, r, a.a));
    }), rrn = F3(function(n, r, t) {
        var e = A3(nrn, t.oJ, n, r);
        return A3(Pk, "div", C([
            nh("AdminWrapper"),
            nh("DarkZone")
        ]), C([
            function() {
                switch(r.$){
                    case 0:
                        return d("AdminHome", A2(Sk, Be, e(VQ)));
                    case 1:
                        return d("AdminOrganizations", A2(Sk, Be, e(HM)));
                    case 2:
                        return d("AdminOnboarding", A2(Sk, Be, e(WW)));
                    case 3:
                        return d("AdminUsers", A2(Sk, Be, e(zO)));
                    case 4:
                        return d("AdminUploads", A2(Sk, Be, e(bx)));
                    case 5:
                        return d("AdminTestPlans", A2(Sk, Be, e(dE)));
                    case 6:
                        return d("AdminAudioMappings", A2(Sk, Be, e(Mj)));
                    case 7:
                        return d("AdminChannels", A2(Sk, Be, e(Ew)));
                    case 8:
                        return d("AdminResearchs", A2(Sk, Be, e(tD)));
                    case 9:
                        return d("AdminWebhooks", A2(Sk, Be, e(uN)));
                    case 10:
                        return d("AdminOrganizationListings", A2(Sk, Be, e(YW)));
                    case 11:
                        return d("AdminFormats", A2(Sk, Be, e(QQ)));
                    case 12:
                        return d("AdminSubtitleFormats", A2(Sk, Be, e(UX)));
                    case 13:
                        return d("AdminSegmentationRules", A2(Sk, Be, e(fX)));
                    case 14:
                        return d("AdminJobs", A2(Sk, Be, e(yI)));
                    case 15:
                        return d("AdminMetadata", A2(Sk, Be, e(XB)));
                    case 16:
                        return d("AdminDeepProbe", A2(Sk, Be, e(by)));
                    case 17:
                        return d("AdminProbe", A2(Sk, Be, e(Qq)));
                    default:
                        return d("AdminDashboard", A2(Sk, Be, e(aL)));
                }
            }()
        ]));
    }), trn = {
        $: 5
    }, ern = BA(Pp(iv)), urn = BA(Mp), arn = A2(Qh, C([
        Ah("42px"),
        Bh("25px"),
        Vg("IconBreadcrumb")
    ]), C([
        A2(Cj, C([
            kj("M 4 0L 0 0L 21 21.5L 0 42L 4 42L 25 21.5L 4 0Z")
        ]), g)
    ])), irn = Qh(C([
        Ah("18px"),
        Bh("18px"),
        Ih("0 0 18 18")
    ])), orn = irn(C([
        A2(Cj, C([
            Vg("Fg"),
            kj("M5,7 L5,3 L14.001899,3 L15,2 L18,2 L18,15 L6,15 L0,7 L5,7 Z M7,5 L7,7 L11,7 L16,13 L16,5 L7,5 Z"),
            zQ("translate(9.000000, 8.500000) scale(-1, 1) translate(-9.000000, -8.500000) ")
        ]), g)
    ])), crn = function(n) {
        var r = n.a, t = n.b;
        return A2(hj, C([
            nh("HeaderBreadcrumbItem"),
            wj(r)
        ]), C([
            orn,
            A2(_h, C([
                nh("HeaderBreadcrumbLabel")
            ]), t),
            arn
        ]));
    }, frn = function(n) {
        return BA(A2(Dp, n, 0));
    }, srn = F2(function(n, r) {
        var t = F3(function(n, r, e) {
            for(;;){
                if (!e.b) return g;
                var u = e.a, a = e.b, o = u.eL;
                if (o.$) {
                    if (i(u.mj, n)) return A2(bt, d(gK(u.mj), u.m$), r);
                    e = a;
                } else {
                    var c = o.b, f = frn(u.mj);
                    if (i(u.mj, n)) return A2(bt, d(f, u.m$), r);
                    var s = A3(t, n, A2(bt, d(f, u.m$), r), c);
                    if (s.b) return s;
                    e = a;
                }
            }
        });
        return Jt(A3(t, n, g, $(r.jI, r.fJ)));
    }), lrn = F2(function(n, r) {
        return r.$ ? A2(Lp, function(r) {
            return Ra(A2(Bu, function(n) {
                return i(n.oB, r);
            }, n.oD));
        }, n.oz) : kt(r.a);
    }), drn = Ng("fill-rule"), brn = A2(Qh, C([
        Bh("64"),
        Ah("62")
    ]), C([
        A2(UC, C([
            zQ("translate(0 .528)"),
            q7("#181F29")
        ]), C([
            A2(Cj, C([
                kj("M52.944 28.472L56 26.944V14L28 0 16 6v12l-4-2-12 6v28.944l12 6 12-6v4l12 6 28-14V34l-11.056-5.528z")
            ]), g)
        ])),
        A2(UC, C([
            zQ("translate(4 5)"),
            q7("#FFF")
        ]), C([
            A2(Cj, C([
                kj("M24 40l8-4v-8l8-4-8-4-8 4-8-4v8l8 4v8z")
            ]), g),
            A2(Cj, C([
                kj("M40 24l8-4v-8L32 4v8l8 4v8z")
            ]), g),
            A2(Cj, C([
                kj("M16 20l8-4V8l8-4-8-4-8 4v16z")
            ]), g),
            A2(Cj, C([
                kj("M48 44l8-4v-8l-16-8v8l8 4v8z")
            ]), g),
            A2(Cj, C([
                kj("M24 40l-8-4-8 4-8-4v8l8 4 16-8z")
            ]), g),
            A2(Cj, C([
                kj("M48 44l-8-4-8 4-8-4v8l8 4 16-8z")
            ]), g),
            A2(Cj, C([
                kj("M0 36l8-4v-8l8-4-8-4-8 4v16z")
            ]), g)
        ])),
        A2(UC, C([
            zQ("translate(4 9)"),
            q7("#3BAAFF")
        ]), C([
            A2(Cj, C([
                kj("M16 16l-8 4v8l-8 4 8 4 8-4 8 4v-8l-8-4v-8z")
            ]), g),
            A2(Cj, C([
                kj("M32 0l-8 4v8l-8 4 8 4 8-4 8 4v-8l-8-4V0z")
            ]), g),
            A2(Cj, C([
                kj("M40 20l-8 4v8l-8 4 8 4 8-4 8 4v-8l-8-4v-8z")
            ]), g)
        ])),
        A2(UC, C([
            zQ("translate(1.764 7.382)"),
            q7("#181F29")
        ]), C([
            A2(Cj, C([
                drn("evenodd"),
                kj("M35.236 0v9l8 4v16l8 4v10.236l-9-4.5-8 4-16-8-8 4L0 33.618 9.236 29v-8l16-8V5l10-5zm-8 6.236v8l-6.764 3.382 5.764 2.882 8-4 7 3.5v-5.764l-8-4v-7l-6 3zM40 21.618l-5.764-2.882-8 4-7-3.5V25l8 4v7l6-3v-8L40 21.618zM25.236 36v-5.764l-8-4v-7l-6 3v8l-6.764 3.382 5.764 2.882 8-4 7 3.5zm3.236 1.618l6.764-3.382v-8l6-3v7l8 4V40l-7-3.5-8 4-5.764-2.882z")
            ]), g)
        ]))
    ])), mrn = ye("img"), prn = function(n) {
        return A2(Yg, "src", n);
    }, vrn = function(n) {
        return A2(hj, C([
            nh("HeaderBreadcrumbItem"),
            wj(aO)
        ]), C([
            function() {
                if (n.$) return A2(_h, C([
                    nh("HeaderBreadcrumbLabel")
                ]), "Stock");
                var r = n.a, t = r.nh;
                if (t.$) return A2(_h, C([
                    nh("HeaderBreadcrumbLabel")
                ]), r.gp);
                var e = t.a;
                return A2(mrn, C([
                    nh("HeaderBreadcrumbItemLogo"),
                    prn(e)
                ]), g);
            }(),
            arn
        ]));
    }, $rn = BA(Ep), grn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, hrn = {
        $: 1
    }, krn = A2(Qh, C([
        Ah("32px"),
        Bh("32px"),
        Ih("0 0 32 32"),
        Vg("IconSearch")
    ]), C([
        A2(UC, C([
            Vg("Fg")
        ]), C([
            A2(Th, C([
                Lh("22.7071068 19.2928932 22 18.5857864 20.5857864 20 21.2928932 20.7071068 23.2928932 22.7071068 24 23.4142136 25.4142136 22 24.7071068 21.2928932")
            ]), g),
            A2(Cj, C([
                kj("M20,15 C20,12.790861 18.209139,11 16,11 C13.790861,11 12,12.790861 12,15 C12,17.209139 13.790861,19 16,19 C18.209139,19 20,17.209139 20,15 Z M10,15 C10,11.6862915 12.6862915,9 16,9 C19.3137085,9 22,11.6862915 22,15 C22,18.3137085 19.3137085,21 16,21 C12.6862915,21 10,18.3137085 10,15 Z")
            ]), g)
        ]))
    ])), Crn = A2(Qh, C([
        Ah("27px"),
        Bh("27px"),
        Ih("0 0 27 27"),
        Vg("IconLaab")
    ]), C([
        A2(UC, C([
            Vg("Stroked"),
            E7("2")
        ]), C([
            A2(Cj, C([
                kj("M13.5,18 C15.9852814,18 18,15.9852814 18,13.5 M13.5,9 C11.0147186,9 9,11.0147186 9,13.5"),
                zQ("translate(13.500000, 13.500000) scale(-1, 1) translate(-13.500000, -13.500000) ")
            ]), g),
            A2(Cj, C([
                kj("M15.5,15.5 L18.5,18.5")
            ]), g),
            A2(Cj, C([
                kj("M8.5,8.5 L11.5,11.5")
            ]), g)
        ]))
    ])), jrn = A2(Qh, C([
        Ah("27px"),
        Bh("27px"),
        Ih("0 0 27 27"),
        Vg("IconPadok")
    ]), C([
        A2(UC, C([
            Vg("IconPadok"),
            q7("none"),
            E7("2")
        ]), C([
            A2(Cj, C([
                kj("M13.5,18 C15.9852814,18 18,15.9852814 18,13.5 C18,11.0147186 15.9852814,9 13.5,9 C11.0147186,9 9,11.0147186 9,13.5"),
                zQ("translate(13.500000, 13.500000) scale(-1, 1) translate(-13.500000, -13.500000) ")
            ]), g),
            A2(Cj, C([
                kj("M13.5,13.5 L17.5,17.5")
            ]), g)
        ]))
    ])), wrn = function(n) {
        var r = n.a, t = n.c, e = 1 === n.b ? b("SearchResultsMaster", Crn, gK(t.mj)) : b("SearchResultsShow", jrn, gK(t.mj)), u = e.a, a = e.b;
        return A2(hj, C([
            wj(e.c),
            nh("SearchResultsItem"),
            nh(u)
        ]), C([
            A2(Se, C([
                nh("SearchResultsPath")
            ]), A2(FD, ch(" / "), A2(Ge, ch, r))),
            A2(Se, C([
                nh("SearchResultsTitle")
            ]), C([
                a,
                ch(t.m$)
            ]))
        ]));
    }, Arn = function(n) {
        return A2(Se, C([
            Zh(C([
                d("Search", !0),
                d("SearchClosed", !n.pZ)
            ]))
        ]), C([
            A2(Se, C([
                nh("SearchIcon"),
                Mh(hrn)
            ]), C([
                n.pZ ? $Q : krn
            ])),
            A2(Se, C([
                nh("SearchInput"),
                Zh(C([
                    d("Searching", n.pZ)
                ]))
            ]), C([
                A2(Sk, grn, kk(n.pX))
            ])),
            A2(Se, C([
                nh("SearchResults")
            ]), A2(Ge, wrn, n.pY))
        ]));
    }, Lrn = function(n) {
        var r = function() {
            var r = n.al.r6;
            switch(r.$){
                case 0:
                    return C([
                        vrn(A2(lrn, n.al.r8, Ct))
                    ]);
                case 1:
                    var t = r.a;
                    return A2(bt, vrn(A2(lrn, n.al.r8, function(n) {
                        return A2(Tu, function(n) {
                            return {
                                nh: n.oz.nh,
                                oB: n.oz.mj,
                                gp: n.oz.nW
                            };
                        }, n.g9.Q.kt);
                    }(n))), A2(Ge, crn, A2(srn, t, n.eu)));
                case 2:
                    return t = r.a, A2(bt, vrn(A2(lrn, n.al.r8, function(n) {
                        return A2(Lp, function(r) {
                            return Ra(A2(Bu, function(n) {
                                return i(n.oB, r.bg.oz);
                            }, n.al.r8.oD));
                        }, n.n8.Q.kt);
                    }(n))), A2(Ge, crn, A2(srn, t, n.eu)));
                case 6:
                    return C([
                        crn(d(urn, "Archive"))
                    ]);
                case 8:
                    return C([
                        crn(d($rn, "Settings"))
                    ]);
                case 4:
                    return C([
                        crn(d(ern, "Admin"))
                    ]);
                default:
                    return g;
            }
        }();
        return A2(Se, C([
            nh("HeaderWrapper")
        ]), C([
            A2(hj, C([
                !n.al.b5 && i(n.al.r6, xp) ? Mh(mH(trn)) : wj(aO),
                nh("HeaderLogo")
            ]), C([
                brn
            ])),
            A2(Sk, $J, A2(kw, Arn, n.pW)),
            A2(Se, C([
                nh("HeaderBreadcrumb")
            ]), A2(bt, arn, r))
        ]));
    }, yrn = A2(Qh, C([
        Ah("24px"),
        Bh("24px"),
        Ih("0 0 24 24"),
        Vg("IconSettings")
    ]), C([
        A2(UC, C([
            Vg("Fg")
        ]), C([
            A2(Cj, C([
                kj("M4.5.257l3.771 3.771c.409 1.889-2.33 4.66-4.242 4.242l-3.771-3.77c-.172.584-.258 1.188-.258 1.792 0 1.602.607 3.202 1.83 4.426 1.351 1.351 3.164 1.958 4.931 1.821.933-.072 1.852.269 2.514.931l9.662 9.662c.578.578 1.337.868 2.097.868 1.661 0 3.001-1.364 2.966-3.03-.016-.737-.306-1.47-.868-2.033l-9.662-9.663c-.662-.661-1.002-1.581-.931-2.514.137-1.767-.471-3.58-1.82-4.93-1.225-1.224-2.825-1.83-4.428-1.83-.603 0-1.207.086-1.791.257zm17.5 20.743c0 .553-.447 1-1 1-.553 0-1-.448-1-1s.447-1 1-1 1 .447 1 1z")
            ]), g)
        ]))
    ])), Srn = A2(Qh, C([
        Ah("30px"),
        Bh("20px"),
        Ih("0 0 26 36"),
        Vg("IconBigFile")
    ]), C([
        A2(Cj, C([
            kj("M10,0 L26,0 L26,36 L0,36 L0,10 L10,0 Z M2,11 L2,34 L24,34 L24,2 L11,2 L2,11 Z"),
            Vg("Fg")
        ]), g),
        A2(Th, C([
            Vg("Fg"),
            Lh("12 12 12 0 10 0 10 10 0 10 0 12")
        ]), g)
    ])), Frn = Ng("clip-rule"), Trn = A2(Qh, C([
        Ah("26px"),
        Bh("26px"),
        Ih("0 0 26 26"),
        Vg("IconBigFile")
    ]), C([
        A2(Cj, C([
            kj("M12.0498 15.0713C12.0498 14.251 12.1494 13.5977 12.3486 13.1113C12.5479 12.625 12.9111 12.1475 13.4385 11.6787C13.9717 11.2041 14.3262 10.8203 14.502 10.5273C14.6777 10.2285 14.7656 9.91504 14.7656 9.58691C14.7656 8.59668 14.3086 8.10156 13.3945 8.10156C12.9609 8.10156 12.6123 8.23633 12.3486 8.50586C12.0908 8.76953 11.9561 9.13574 11.9443 9.60449H9.39551C9.40723 8.48535 9.76758 7.60938 10.4766 6.97656C11.1914 6.34375 12.1641 6.02734 13.3945 6.02734C14.6367 6.02734 15.6006 6.3291 16.2861 6.93262C16.9717 7.53027 17.3145 8.37695 17.3145 9.47266C17.3145 9.9707 17.2031 10.4424 16.9805 10.8877C16.7578 11.3271 16.3682 11.8164 15.8115 12.3555L15.0996 13.0322C14.6543 13.46 14.3994 13.9609 14.335 14.5352L14.2998 15.0713H12.0498ZM11.7949 17.7695C11.7949 17.377 11.9268 17.0547 12.1904 16.8027C12.46 16.5449 12.8027 16.416 13.2188 16.416C13.6348 16.416 13.9746 16.5449 14.2383 16.8027C14.5078 17.0547 14.6426 17.377 14.6426 17.7695C14.6426 18.1562 14.5107 18.4756 14.2471 18.7275C13.9893 18.9795 13.6465 19.1055 13.2188 19.1055C12.791 19.1055 12.4453 18.9795 12.1816 18.7275C11.9238 18.4756 11.7949 18.1562 11.7949 17.7695Z"),
            Vg("Fg")
        ]), g),
        A2(Cj, C([
            drn("evenodd"),
            Frn("evenodd"),
            kj("M13 24C19.0751 24 24 19.0751 24 13C24 6.92487 19.0751 2 13 2C6.92487 2 2 6.92487 2 13C2 19.0751 6.92487 24 13 24ZM13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26Z"),
            Vg("Fg")
        ]), g)
    ])), Qrn = Pi({
        bQ: "Help",
        bX: "Aide"
    }), Irn = function(n) {
        return BA(qp(n));
    }, Brn = Pi({
        bQ: "Settings",
        bX: "Param\xe8tres"
    }), Wrn = Pi({
        bQ: "Stock",
        bX: "Stock"
    }), Prn = function(n) {
        return n.e5 ? A2(hj, C([
            wj(n.r6),
            nh("MenuItem"),
            Zh(C([
                d("Active", n.R)
            ]))
        ]), C([
            A2(Se, C([
                nh("MenuItemIcon")
            ]), C([
                n.mi
            ])),
            A2(Se, C([
                nh("MenuItemTitle")
            ]), C([
                ch(n.rB)
            ]))
        ])) : ch("");
    }, Mrn = Fh("rect"), qrn = Ng("x"), Drn = Ng("y"), Xrn = A2(Qh, C([
        Ah("30px"),
        Bh("20px"),
        Ih("0 0 26 36"),
        Vg("IconBigFile")
    ]), C([
        A2(Cj, C([
            drn("evenodd"),
            Frn("evenodd"),
            kj("M19 4H12V28H19V4ZM10 2V30H21V2H10Z"),
            Vg("Fg")
        ]), g),
        A2(Mrn, C([
            qrn("14"),
            Drn("6"),
            Bh("3"),
            Ah("22"),
            Vg("Fg")
        ]), g),
        A2(Cj, C([
            drn("evenodd"),
            Frn("evenodd"),
            kj("M26 14H21V28H26V14ZM19 12V30H28V12H19Z"),
            Vg("Fg")
        ]), g),
        A2(Cj, C([
            drn("evenodd"),
            Frn("evenodd"),
            kj("M10 10H4V28H10V10ZM2 8V30H11V8H2Z"),
            Vg("Fg")
        ]), g),
        A2(Mrn, C([
            qrn("4"),
            Drn("12"),
            Bh("6"),
            Ah("2"),
            Vg("Fg")
        ]), g),
        A2(Mrn, C([
            qrn("4"),
            Drn("16"),
            Bh("6"),
            Ah("2"),
            Vg("Fg")
        ]), g),
        A2(Mrn, C([
            qrn("4"),
            Drn("20"),
            Bh("6"),
            Ah("2"),
            Vg("Fg")
        ]), g),
        A2(Mrn, C([
            qrn("4"),
            Drn("24"),
            Bh("6"),
            Ah("2"),
            Vg("Fg")
        ]), g),
        A2(Cj, C([
            drn("evenodd"),
            Frn("evenodd"),
            kj("M21 17L26 12.015L26 14L21 19L21 17Z"),
            Vg("Fg")
        ]), g),
        A2(Cj, C([
            drn("evenodd"),
            Frn("evenodd"),
            kj("M21 21L26 16.015L26 18L21 23L21 21Z"),
            Vg("Fg")
        ]), g),
        A2(Cj, C([
            drn("evenodd"),
            Frn("evenodd"),
            kj("M21 25L26 20.015L26 22L21 27L21 25Z"),
            Vg("Fg")
        ]), g),
        A2(Cj, C([
            drn("evenodd"),
            Frn("evenodd"),
            kj("M22 28L26 24.0149L26 26L24 28L22 28Z"),
            Vg("Fg")
        ]), g)
    ])), Ern = Pi({
        bQ: "Organizations",
        bX: "Organizations"
    }), Rrn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, xrn = function(n) {
        var r = A2(Qu, "", n.r8.oz);
        return A2(Ge, function(t) {
            return function(n) {
                return A2(hj, C([
                    n.cM ? wj(aO) : Mh(Rrn(n.mj)),
                    nh("MenuItem"),
                    Zh(C([
                        d("Active", n.R)
                    ]))
                ]), C([
                    A2(Se, C([
                        nh("MenuItemIcon")
                    ]), C([
                        function() {
                            var r = n.nh;
                            if (r.$) return ch("");
                            var t = r.a;
                            return A2(Se, C([
                                nh("MenuAvatar")
                            ]), C([
                                A2(mrn, C([
                                    prn(t)
                                ]), g)
                            ]));
                        }()
                    ])),
                    A2(Se, C([
                        nh("MenuItemTitle")
                    ]), C([
                        ch(n.nW)
                    ]))
                ]));
            }({
                R: i(t.oB, r) && function() {
                    switch(n.r6.$){
                        case 0:
                        case 1:
                        case 2:
                            return !0;
                        default:
                            return !1;
                    }
                }(),
                cM: i(t.oB, r),
                mj: t.oB,
                nh: t.nh,
                nW: t.gp
            });
        }, A2(Pw, Ww(function(n) {
            return n.gp;
        }), n.r8.oD));
    }, Orn = function(n) {
        return 1 > Dt(n.r8.oD) ? ch("") : A2(Se, C([
            nh("MenuGroup"),
            Mh(trn)
        ]), C([
            A2(Se, C([
                nh("MenuItem")
            ]), C([
                A2(Se, C([
                    nh("MenuItemIcon")
                ]), C([
                    Xrn
                ])),
                A2(Se, C([
                    nh("MenuItemTitle")
                ]), C([
                    ch(Ern)
                ]))
            ])),
            A2(Se, C([
                nh("MenuList")
            ]), xrn(n))
        ]));
    }, zrn = function(n) {
        return Se(C(n.b5 ? [
            nh("MenuWrapper"),
            nh("MenuOpened"),
            Mh(trn),
            MA(n.b5)
        ] : [
            nh("MenuWrapper"),
            nh("MenuClosed")
        ]));
    }, Nrn = function(n) {
        var r = function(n) {
            return {
                l2: {
                    R: 5 === n.r6.$,
                    e5: !0,
                    mi: Trn,
                    rB: Qrn,
                    r6: Irn("table")
                },
                dz: {
                    R: 8 === n.r6.$,
                    e5: !0,
                    mi: yrn,
                    rB: Brn,
                    r6: $rn
                },
                dB: {
                    R: !n.ea,
                    e5: !0,
                    mi: Srn,
                    rB: Wrn,
                    r6: aO
                }
            };
        }(n);
        return A2(zrn, n, C([
            A2(Se, C([
                nh("MenuMain")
            ]), C([
                Prn(r.dB),
                Orn(n),
                A2(Se, C([
                    nh("MenuSpacer")
                ]), g),
                Prn(r.l2),
                Prn(r.dz),
                A2(Se, C([
                    nh("MenuIntercom")
                ]), g)
            ]))
        ]));
    }, Hrn = {
        $: 1
    }, Vrn = F2(function(n, r) {
        return {
            $: 10,
            a: n,
            b: r
        };
    }), Urn = Uh("multiple"), Jrn = A2(lk, C([
        "target",
        "files"
    ]), pl(cnn)), Zrn = F2(function(n) {
        var r;
        return r = C([
            fk("nativeInputFile"),
            nh("UploadInput"),
            A2(Zg, "change", A2(Fe, function(r) {
                return A2(Vrn, n.oI, r);
            }, Jrn))
        ]), A2(rk, A2(bt, qh("file"), A2(bt, Urn(!0), r)), g);
    }), Krn = F2(function(n, r) {
        return n.mh || !i(r.bT, g) || !i(r.ll, Ct);
    }), _rn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Grn = Pi({
        bQ: ". Please choose a destination:",
        bX: ". Veuillez choisir une destination :"
    }), Yrn = Pi({
        bQ: "Choose destination",
        bX: "Choisir une destination"
    }), ntn = Pi({
        bQ: " file",
        bX: " fichier"
    }), rtn = Pi({
        bQ: "Create new delivery",
        bX: "Cr\xe9er une nouvelle livraison"
    }), ttn = Pi({
        bQ: "Create new master",
        bX: "Cr\xe9er un nouveau master"
    }), etn = Pi({
        bQ: "You are about to upload ",
        bX: "Vous \xeates sur le point d\u2019uploader "
    }), utn = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), atn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, itn = F8(function(n, r, t, e, u, a, i, o) {
        return {
            jv: a,
            jN: t,
            ko: o,
            mZ: n,
            b8: e,
            oI: r,
            pS: u,
            ru: i
        };
    }), otn = A2(we, function(n) {
        n: for(; !n.$;)switch(n.a){
            case 0:
                return Qe(0);
            case 1:
                return Qe(1);
            case 2:
                return Qe(2);
            case 3:
                return Qe(3);
            default:
                break n;
        }
        return A2(we, function(n) {
            n: for(; !n.$;)switch(n.a){
                case 0:
                    return Qe(1);
                case 1:
                    return Qe(2);
                case 2:
                    return Qe(3);
                case 4:
                    return Qe(4);
                case 5:
                    return Qe(5);
                default:
                    break n;
            }
            return Qe(0);
        }, gb(A2(du, "button", dl)));
    }, gb(A2(du, "which", dl))), ctn = function(n) {
        return {
            ok: n
        };
    }, ftn = A2(Fe, ctn, A2(du, "offsetWidth", Ay)), stn = A2(du, "currentTarget", ftn), ltn = F4(function(n, r, t, e) {
        return {
            iJ: n,
            kk: r,
            nG: t,
            qi: e
        };
    }), dtn = A5(ez, ltn, A2(du, "altKey", Ae), A2(du, "ctrlKey", Ae), A2(du, "metaKey", Ae), A2(du, "shiftKey", Ae)), btn = cn, mtn = function(n) {
        return A3(Te, VV, A2(du, n + "X", dl), A2(du, n + "Y", dl));
    }, ptn = A2(we, function() {
        var n = yt(0);
        return 1 === n.$ ? xo(n.a) : Qe(n.a);
    }, A2(du, "target", Qi)), vtn = A9(btn, itn, dtn, mtn("page"), mtn("client"), mtn("offset"), mtn("screen"), otn, ptn, stn), $tn = F2(function(n, r) {
        var t = A2(Y7, "mousedown", Qe({
            nE: atn(r),
            o1: !1,
            qX: !1
        })), e = n ? C([
            A2(Zg, "mousedown", A2(Fe, utn(r), vtn))
        ]) : g;
        return A2(Se, C([
            nh("UploadFile")
        ]), C([
            A2(Se, A2(bt, nh("UploadFileTitle"), e), C([
                Srn,
                A2(Se, C([
                    nh("UploadFileSummary")
                ]), C([
                    A2(ph, C([
                        nh("UploadFileName"),
                        HW(r.nW)
                    ]), C([
                        ch(r.nW)
                    ])),
                    A2(_h, C([
                        nh("UploadFileSize")
                    ]), Vq(r.qy))
                ]))
            ])),
            A2(Se, C([
                nh("UploadRemove"),
                t
            ]), C([
                Wh
            ]))
        ]));
    }), gtn = F3(function(n, r, t) {
        return A2(Se, C([
            nh("UploadDrag"),
            A2(gh, "left", Bt(t.ss - r.ss) + "px"),
            A2(gh, "top", Bt(t.sx - r.sx) + "px")
        ]), C([
            A2($tn, !1, n)
        ]));
    }), htn = {
        $: 9
    }, ktn = Pi({
        bQ: "An error occurred.",
        bX: "Une erreur est survenue."
    }), Ctn = function(n) {
        return 1 === n.ll.$ ? ch("") : A2(Se, C([
            nh("UploadError")
        ]), C([
            A2(Se, g, C([
                ch(ktn)
            ])),
            A2(Se, C([
                nh("UploadErrorClose"),
                Mh(htn)
            ]), C([
                Wh
            ]))
        ]));
    }, jtn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, wtn = {
        $: 8
    }, Atn = Pi({
        bQ: "No file",
        bX: "Aucun fichier"
    }), Ltn = function(n) {
        return A2(Zg, "mouseenter", Qe(n));
    }, ytn = function(n) {
        return A2(Zg, "mouseleave", Qe(n));
    }, Stn = Pk("ul"), Ftn = F3(function(n, r, t) {
        var e = function() {
            if (1 === r.$) return g;
            var n = r.a;
            return C([
                A2(gh, "user-select", "none"),
                Ltn(jtn(n)),
                ytn(wtn)
            ]);
        }();
        return A2(Se, e, C([
            A2(yA, C([
                nh("UploadSubtitle")
            ]), C([
                ch(n)
            ])),
            A2(Stn, C([
                nh("UploadSection")
            ]), wu(t) ? C([
                d("empty", A2(cx, C([
                    nh("UploadItem")
                ]), C([
                    ch(Atn)
                ])))
            ]) : A2(Ge, function(n) {
                return d(n.nW, A2(cx, C([
                    nh("UploadItem")
                ]), C([
                    A2($tn, !i(r, Ct), n)
                ])));
            }, t))
        ]));
    }), Ttn = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Qtn = Pi({
        bQ: "Add",
        bX: "Ajouter"
    }), Itn = Pi({
        bQ: "Extra",
        bX: "Compl\xe9mentaire"
    }), Btn = Pi({
        bQ: "Master being loaded...",
        bX: "Master en cours de chargement..."
    }), Wtn = Pi({
        bQ: " into master ",
        bX: " au master "
    }), Ptn = Pi({
        bQ: "Subtitles",
        bX: "Sous titres"
    }), Mtn = F4(function(n, r, t, e) {
        var u = function(r) {
            return 1 === n.$ || A2(qJ, n.a, e) ? ch("") : r;
        }, a = A3(qt, F2(function(n, t) {
            var e = A2(Lo, n.nW, r);
            if (e.$) return p(t, {
                bS: A2(bt, n, t.bS)
            });
            switch(e.a){
                case 0:
                    return p(t, {
                        cw: A2(bt, n, t.cw)
                    });
                case 1:
                    return p(t, {
                        ef: A2(bt, n, t.ef)
                    });
                case 2:
                    return p(t, {
                        ae: A2(bt, n, t.ae)
                    });
                default:
                    return p(t, {
                        bS: A2(bt, n, t.bS)
                    });
            }
        }), {
            ef: g,
            bS: g,
            ae: g,
            cw: g
        }, e.bT), i = a.cw, o = a.ef, c = a.ae, f = a.bS;
        return C([
            u(A3(Ftn, "Video", kt(0), i)),
            u(A3(Ftn, "Audios", kt(1), o)),
            A3(Ftn, Ptn, kt(2), c),
            A3(Ftn, Itn, kt(3), f),
            A2(xT, g, g),
            function() {
                if (1 === n.$) return A2(xg, C([
                    nk(!0)
                ]), C([
                    ch(Btn)
                ]));
                var u = n.a;
                return A2(Se, g, C([
                    A2(_h, C([
                        nh("UploadDesc")
                    ]), $(etn, $(Bt(Dt(e.bT)), $(ntn, $(Dt(e.bT) > 1 ? "s" : "", Wtn))))),
                    A2(Znn, Qtn, A3(Ttn, t.e8, u.g9, r))
                ]));
            }()
        ]);
    }), qtn = Pi({
        bQ: "Your files",
        bX: "Vos fichiers"
    }), Dtn = F2(function(n, r) {
        return A2(Se, C([
            nh("UploadContainer")
        ]), C([
            A2(Se, C([
                nh("UploadTitle")
            ]), C([
                ch("Upload")
            ])),
            A2(Se, C([
                nh("UploadClose"),
                Mh(Hrn)
            ]), C([
                Wh
            ])),
            Ctn(r),
            A2(Se, C([
                nh("UploadContent")
            ]), function() {
                var t = d(n.oI, r.oL);
                n: for(;;){
                    if (t.a.$) {
                        if (1 === t.b.$) return C([
                            A2(_h, C([
                                nh("UploadDesc")
                            ]), $(etn, $(Bt(Dt(r.bT)), $(ntn, $(Dt(r.bT) > 1 ? "s" : "", Grn))))),
                            A3(Ftn, qtn, Ct, r.bT),
                            A2(Sk, _rn, A2(nj, Xi(function(n) {
                                return p(n, {
                                    gy: Yrn
                                });
                            }), C([
                                d("liv", rtn),
                                d("mas", ttn)
                            ])))
                        ]);
                        break n;
                    }
                    if (t.b.$) break n;
                    var e = t.a.a, u = t.b.a;
                    return e.$ ? C([
                        ch("")
                    ]) : A4(Mtn, e, u, n, r);
                }
                return C([
                    ch(A2(Qu, "", r.ll))
                ]);
            }()),
            function() {
                var n = r.kW;
                if (1 === n.$) return ch("");
                var t = n.a;
                return A3(gtn, t.a, t.b, t.c);
            }()
        ]));
    }), Xtn = Pi({
        bQ: "Please drop your file(s) to upload to Nomalab",
        bX: "D\xe9posez le(s) fichier(s) pour lancer un upload sur Nomalab"
    }), Etn = A2(Se, C([
        nh("UploadDropping")
    ]), C([
        ch(Xtn)
    ])), Rtn = F2(function(n, r) {
        if (A2(Krn, n, r)) {
            var t = n.oI;
            if (t.$ || t.a.$) return ch("");
            var e = t.a.a;
            return A3(MJ, n.r8, e.oz.mj, A2(Ge, function(n) {
                return n.fH;
            }, e.fJ)) ? A2(Se, C([
                nh("UploadWrapper")
            ]), C([
                A2(Se, C([
                    nh("UploadMask"),
                    Mh(Hrn)
                ]), g),
                i(r.bT, g) && i(r.ll, Ct) ? Etn : A2(Dtn, n, r),
                A2(Zrn, n, r)
            ])) : ch("");
        }
        return A2(Zrn, n, r);
    }), xtn = ye("em"), Otn = ye("strong"), ztn = F2(function(n, r) {
        var t, e = function(n) {
            var r = n.hn;
            switch(r.$){
                case 0:
                    return xtn(g);
                case 1:
                    return Otn(g);
                default:
                    return hj(function(n) {
                        for(;;){
                            if (n.$) return C([
                                wj(n.a)
                            ]);
                            var r = n.a;
                            if ("help" === r.fY) return C([
                                wj("/help/" + A2(Qu, "table", r.h8))
                            ]);
                        }
                    }(r.a));
            }
        }, u = F2(function(n, t) {
            var u = t.a, a = t.b, i = A3(De, n.ht, n.e6, r.cs);
            return d($(u, C([
                ch(A3(De, a, n.ht, r.cs)),
                A2(e, n, C([
                    ch(i)
                ]))
            ])), n.e6);
        });
        return A2(n, A2(Qu, g, A2(Tu, function(n) {
            return C([
                nh(n)
            ]);
        }, r.m$)), $((t = A3(qt, u, d(g, 0), A2(xi, function(n) {
            return n.ht;
        }, r.ho))).a, C([
            ch(A2(Xe, t.b, r.cs))
        ])));
    }), Ntn = ye("h5"), Htn = ye("h6"), Vtn = function(n) {
        switch(n.$){
            case 8:
                return A2(mrn, C([
                    prn(n.a.r6)
                ]), g);
            case 0:
                return A2(ztn, Tj, r = n.a);
            case 1:
                return A2(ztn, yA, r = n.a);
            case 2:
                return A2(ztn, yj, r = n.a);
            case 3:
                return A2(ztn, HT, r = n.a);
            case 4:
                return A2(ztn, Ntn, r = n.a);
            case 5:
                return A2(ztn, Htn, r = n.a);
            case 6:
                return A2(ztn, bI, r = n.a);
            default:
                var r = n.a;
                return A2(ztn, F2(function(n, r) {
                    return A2(ix, g, C([
                        A2(cx, n, r)
                    ]));
                }), r);
        }
    }, Utn = function(n) {
        var r = n;
        return A2(Se, C([
            nh("structuredText")
        ]), A2(Ge, Vtn, r));
    }, Jtn = function(n) {
        switch(n.Q){
            case 0:
                return Pi({
                    bQ: "Connection lost.",
                    bX: "Perte de connection avec le serveur, v\xe9rifiez votre connection internet"
                });
            case 401:
            case 403:
                return Pi({
                    bQ: "You might not be authorized to acces this ressource.",
                    bX: "Vous ne semblez pas - ou plus - autoris\xe9 \xe0 consulter cette ressource"
                });
            case 404:
                return Pi({
                    bQ: "This ressource doesn't seem to exist.",
                    bX: "Cette ressource n'existe pas ou a \xe9t\xe9 supprim\xe9e"
                });
            default:
                return "" === n.nE ? Js : n.nE;
        }
    }, Ztn = function(n) {
        var r = n.Q.ll;
        return r.$ ? ch("") : AC(Jtn(r.a));
    }, Ktn = A2(Se, C([
        nh("LoadingWrapper")
    ]), C([
        A2(Se, C([
            nh("LoadingSpinner")
        ]), C([
            NQ
        ]))
    ])), _tn = F2(function(n, r) {
        return A2(Se, C([
            nh("ShowWrapper")
        ]), C([
            A2(Se, C([
                nh("ShowMain")
            ]), C([
                Ij(p(Bj, {
                    eh: kt(aO)
                })),
                Ktn,
                Ztn(r)
            ])),
            A2(Se, C([
                nh("ShowAside")
            ]), g)
        ]));
    }), Gtn = function(n) {
        return n.iz;
    }, Ytn = F2(function(n, r) {
        return Gtn(n) || i(n.oz, kt(r.oz));
    }), nen = function(n) {
        return frn(n.mj);
    }, ren = function(n) {
        return !n.hw;
    }, ten = function(n) {
        return "" !== n.cT.fH;
    }, een = {
        $: 6
    }, uen = function(n) {
        return A2(Se, C([
            nh("BannerAdvice")
        ]), C([
            UW,
            A2(_h, C([
                nh("BannerContent")
            ]), n)
        ]));
    }, aen = F2(function(n, r) {
        return Gtn(n) || i(n.oz, kt(r.oz));
    }), ien = Pi({
        bQ: "Invitations",
        bX: "Invitations"
    }), oen = Pi({
        bQ: "Invite",
        bX: "Inviter"
    }), cen = Pi({
        bQ: "No invitations.",
        bX: "Aucune invitation."
    }), fen = A2(Qh, C([
        Ah("18px"),
        Bh("18px"),
        Ih("0 0 18 18"),
        Vg("IconPlus")
    ]), C([
        A2(UC, C([
            Vg("Fg")
        ]), C([
            A2(Cj, C([
                kj("M10,8 L10,3 L8,3 L8,8 L3,8 L3,10 L8,10 L8,15 L10,15 L10,10 L15,10 L15,8 L10,8 Z")
            ]), g)
        ]))
    ])), sen = function(n) {
        return {
            $: 9,
            a: n
        };
    }, len = function(n) {
        return {
            $: 0,
            a: n
        };
    }, den = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ben = function(n) {
        return {
            $: 1,
            a: n
        };
    }, men = function(n) {
        return {
            $: 4,
            a: n
        };
    }, pen = function(n) {
        return {
            $: 3,
            a: n
        };
    }, ven = function(n) {
        return {
            $: 5,
            a: n
        };
    }, $en = Pi({
        bQ: "Allow download (extra costs applies)",
        bX: "Autoriser le t\xe9l\xe9chargement (soumis \xe0 facturation)"
    }), gen = Pi({
        bQ: "Allow upload ",
        bX: "Autoriser l'upload"
    }), hen = Pi({
        bQ: "Allow view",
        bX: "Autoriser \xe0 visionner"
    }), ken = A2(Qh, C([
        Ah("16px"),
        Bh("16px"),
        Ih("0 0 16 16")
    ]), C([
        A2(Cj, C([
            Vg("Fg"),
            kj("M8 10H3V6H8V3L13 8L8 13V10Z")
        ]), g)
    ])), Cen = Se(C([
        nh("ButtonSubmitWrapper")
    ])), jen = function(n) {
        return Cen(C([
            VW(p(AW, {
                mi: kt(ken),
                bh: !0,
                bi: !0,
                m$: n
            }))
        ]));
    }, wen = Yg("htmlFor"), Aen = F2(function(n, r) {
        return A2(OC, C([
            wen(r.mj),
            nh("InputCheckboxLine")
        ]), C([
            xC(r),
            ch(n)
        ]));
    }), Len = F3(function(n, r) {
        return A2(tj, C([
            aj(sen(n.bg)),
            nh("InvitationsForm"),
            nh("DarkZone")
        ]), C([
            A2(Sk, len, kk(r.k6)),
            A2(Sk, den, Tnn(r.lq)),
            A2(Sk, ben, WB(r.nE)),
            A2(Sk, ven, A2(Aen, hen, Ki(function(n) {
                return p(n, {
                    kO: !0,
                    mj: "checkbox-canView",
                    m$: hen,
                    sa: !0
                });
            }))),
            A2(Sk, pen, A2(Aen, gen, r.jy)),
            A2(Sk, men, A2(Aen, $en, r.jx)),
            jen(oen)
        ]));
    }), yen = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Sen = irn(C([
        A2(Cj, C([
            Vg("Fg"),
            kj("M3,6 L3,3 L12.001899,3 L13,2 L16,2 L16,15 L4,15 L2,6 L3,6 Z M5,5 L5,6 L13,6 L14,13 L14,5 L5,5 Z"),
            zQ("translate(9.000000, 8.500000) scale(-1, 1) translate(-9.000000, -8.500000) ")
        ]), g)
    ])), Fen = irn(C([
        A2(UC, C([
            Vg("Fg"),
            zQ("translate(2.000000, 1.000000)")
        ]), C([
            A2(Cj, C([
                kj("M4,0 L10,0 L14,4 L14,13 L4,13 L4,0 Z M6,2 L6,11 L12,11 L12,5 L9,5 L9,2 L6,2 Z")
            ]), g),
            A3(Fh, "polygon", C([
                Lh("0 3 3 3 3 5 2 5 2 14 10 14 10 16 0 16")
            ]), g)
        ]))
    ])), Ten = irn(C([
        A2(Cj, C([
            Vg("Fg"),
            kj("M3,1 L11,1 L15,5 L15,17 L3,17 L3,1 Z M5,3 L5,15 L13,15 L13,6 L9,6 L9,3 L5,3 Z")
        ]), g)
    ])), Qen = function(n) {
        return A2(Se, C([
            nh(n ? "FullCube" : "EmptyCube")
        ]), g);
    }, Ien = function(n) {
        return A3(ye, "format-date", C([
            VA(db(n))
        ]), C([
            ch(db(n))
        ]));
    }, Ben = F4(function(n, r, t, e) {
        return i(r.fH.hj, kt(t.bg.mj)) ? A2(aen, n.r8, t.bg) ? A2(gC, g, C([
            A2(Se, C([
                nh("InvitationDelete"),
                Mh(yen(r.fH))
            ]), C([
                Wh
            ]))
        ])) : ch("") : A2(gC, g, C([
            A2(Se, C([
                nh("InvitationSourceKind")
            ]), C([
                A2(qC, function(n) {
                    var r;
                    return A2(hj, C([
                        wj((r = n, frn(r)))
                    ]), C([
                        e
                    ]));
                }, r.fH.hj)
            ]))
        ]));
    }), Wen = F3(function(n, r, t) {
        var e;
        return A2(zk, g, C([
            A2(gC, g, C([
                Qen(!0)
            ])),
            A2(gC, g, C([
                Qen(t.fH.r$)
            ])),
            A2(gC, g, C([
                Qen(t.fH.cT)
            ])),
            A2(gC, C([
                nh("InvitationEmail"),
                HW(t.r8.k6)
            ]), C([
                (e = t.fH.cY, e.$ ? ch("") : Ien(e.a)),
                ch("   "),
                ch(t.r8.k6)
            ])),
            function() {
                var e = t.fH.c9;
                n: for(; !e.$;)switch(e.a){
                    case 0:
                        return A4(Ben, n, t, r, Sen);
                    case 2:
                        return A4(Ben, n, t, r, Fen);
                    default:
                        break n;
                }
                return i(t.fH.qs, Ct) ? A2(aen, n.r8, r.bg) ? A2(gC, g, C([
                    A2(Se, C([
                        nh("InvitationDelete"),
                        Mh(yen(t.fH))
                    ]), C([
                        Wh
                    ]))
                ])) : ch("") : A2(gC, g, C([
                    A2(Se, C([
                        nh("InvitationSourceKind")
                    ]), C([
                        A2(qC, function(n) {
                            var r;
                            return A2(hj, C([
                                wj((r = n, gK(r)))
                            ]), C([
                                Ten
                            ]));
                        }, t.fH.qs)
                    ]))
                ]));
            }()
        ]));
    }), Pen = F3(function(n, r, t) {
        return A2(Se, C([
            nh("InvitationsWrapper")
        ]), C([
            Uq(C([
                Kq(ien),
                A2(aen, n.r8, t.bg) ? VW(p(AW, {
                    jM: Ct,
                    mi: kt(fen),
                    mD: !1,
                    m$: oen,
                    ol: kt(een)
                })) : ch("")
            ])),
            r.kQ ? A3(Len, t, r, n.r8) : ch(""),
            wu(t.fJ) ? uen(cen) : A2(Mk, C([
                nh("InvitationsTable")
            ]), A2(Ge, A2(Wen, n, t), A2(xi, A2(Po, function(n) {
                return n.r8;
            }, function(n) {
                return n.k6;
            }), t.fJ)))
        ]));
    }), Men = function(n) {
        return {
            $: 6,
            a: n
        };
    }, qen = {
        $: 0
    }, Den = {
        $: 1
    }, Xen = {
        $: 2
    }, Een = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Ren = function(n) {
        return {
            $: 7,
            a: n
        };
    }, xen = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Oen = Se(C([
        nh("LayoutHeaderActions")
    ])), zen = Pi({
        bQ: "Archive",
        bX: "Archiver"
    }), Nen = Pi({
        bQ: "All files will be put into long lasting storage, retrieving them can take up to 12h. (extra costs applies for unarchiving)",
        bX: "Tous les fichiers iront en stockage longue dur\xe9e, les r\xe9cup\xe9rer prend jusqu'\xe0 12h et ils seront remis \xe0 disposition pour une dur\xe9e de 7 jours. (le d\xe9sarchivage est soumis \xe0 facturation)"
    }), Hen = Pi({
        bQ: "Archiving...",
        bX: "Archivage..."
    }), Ven = Pi({
        bQ: "Cancel",
        bX: "Annuler"
    }), Uen = Pi({
        bQ: "Operation failed",
        bX: "L'op\xe9ration a \xe9chou\xe9"
    }), Jen = irn(C([
        A2(Cj, C([
            Vg("Fg"),
            kj("M5 8H13V14H5V8Z")
        ]), g),
        A2(Cj, C([
            Vg("Fg"),
            kj("M7.99957 7.68778C7.99978 7.78914 8 7.89313 8 8H6C6 7.90491 5.99978 7.80885 5.99956 7.71229C5.99854 7.26829 5.9975 6.81375 6.01771 6.39485C6.04227 5.88549 6.10037 5.34942 6.2604 4.8605C6.42521 4.35697 6.71365 3.85763 7.22215 3.49794C7.72555 3.14186 8.33543 3 9 3C9.66457 3 10.2745 3.14186 10.7779 3.49794C11.2864 3.85763 11.5748 4.35697 11.7396 4.8605C11.8996 5.34942 11.9577 5.88549 11.9823 6.39485C12.0025 6.81376 12.0015 7.26829 12.0004 7.71229C12.0002 7.80885 12 7.90491 12 8H10C10 7.89313 10.0002 7.78914 10.0004 7.68778C10.0013 7.24641 10.0022 6.85479 9.98462 6.49119C9.94969 5.76704 9.89141 5 9 5C8.10859 5 8.05031 5.76704 8.01538 6.49119C7.99785 6.85479 7.99866 7.24641 7.99957 7.68778Z")
        ]), g)
    ])), Zen = irn(C([
        A2(Cj, C([
            Vg("Fg"),
            kj("M12.5 15H5.5C4.948 15 4.5 14.552 4.5 14V6H13.5V14C13.5 14.552 13.052 15 12.5 15ZM8 8C8 7.724 7.776 7.5 7.5 7.5C7.224 7.5 7 7.724 7 8V12.5C7 12.776 7.224 13 7.5 13C7.776 13 8 12.776 8 12.5V8ZM11 8C11 7.724 10.776 7.5 10.5 7.5C10.224 7.5 10 7.724 10 8V12.5C10 12.776 10.224 13 10.5 13C10.776 13 11 12.776 11 12.5V8ZM14 5.5H4V4.5H7V3.75C7 3.3365 7.3365 3 7.75 3H10.25C10.6625 3 11 3.3355 11 3.75V4.5H14V5.5ZM8 4.5H10V4H8V4.5Z")
        ]), g)
    ])), Ken = Pi({
        bQ: "Delete",
        bX: "Supprimer"
    }), _en = Pi({
        bQ: "Ressource deleted",
        bX: "Ressource supprim\xe9e"
    }), Gen = Pi({
        bQ: "Delete...",
        bX: "Suppression..."
    }), Yen = Pi({
        bQ: "Delete",
        bX: "Supprimer"
    }), nun = Pi({
        bQ: "Unarchive",
        bX: "D\xe9sarchiver"
    }), run = Pi({
        bQ: "Your files are now into long lasting storage. Retrieving them can take up to 12h and for a 7 days period. (extra costs applies for unarchiving)",
        bX: "Vos fichiers sont maintenant en stockage longue dur\xe9e, les r\xe9cup\xe9rer prend jusqu'\xe0 12h et ils seront remis \xe0 disposition pour une dur\xe9e de 7 jours. (le d\xe9sarchivage est soumis \xe0 facturation)"
    }), tun = Pi({
        bQ: "Your files will be available within 12h and for a 7 days period only.",
        bX: "Vos fichiers seront disponibles dans les 12h et pour une dur\xe9e de 7 jours."
    }), eun = Pi({
        bQ: "Undelete",
        bX: "Restaurer"
    }), uun = Pi({
        bQ: "These files are deleted",
        bX: "Ces fichiers sont supprim\xe9s"
    }), aun = Pi({
        bQ: "Ressource restored",
        bX: "Ressource restaur\xe9e"
    }), iun = F3(function(n, r, t) {
        return A2(Se, C([
            nh("ShowArchiveActions"),
            nh("ShowArchiveStatusNone")
        ]), C([
            VW(p(AW, {
                kO: n,
                mi: kt(Jen),
                m$: r,
                ol: kt(t)
            }))
        ]));
    }), oun = F2(function(n, r) {
        var t, e = 2 === r.hw;
        return A2(Se, C([
            nh("ShowArchives")
        ]), C([
            Uq(C([
                A2(JT, 1 === r.hw, A2(ph, C([
                    nh("ShowArchivesLock")
                ]), C([
                    Jen
                ]))),
                Kq(0 === r.hw ? zen : nun),
                Oen(C([
                    VW(p(AW, {
                        kO: e,
                        mi: kt(n.oq ? $Q : fen),
                        mD: n.oq,
                        m$: n.oq ? Ven : Hen,
                        ol: kt(Den)
                    }))
                ]))
            ])),
            A2(JT, n.oq || e, A2(Se, C([
                nh("InvitationsForm")
            ]), C([
                3 === n.Q.$ ? A2(Se, C([
                    nh("ShowArchiveActions"),
                    Mh(qen)
                ]), C([
                    AC(Uen)
                ])) : ch(""),
                A2(Se, g, function() {
                    switch(r.hw){
                        case 0:
                            return C([
                                j7(Nen),
                                A3(iun, i(n.Q, OY), zen, Men(r))
                            ]);
                        case 1:
                            return C([
                                AC(run),
                                A3(iun, i(n.Q, OY), nun, Ren(r))
                            ]);
                        default:
                            return C([
                                j7(tun)
                            ]);
                    }
                }())
            ]))),
            Uq(C([
                A2(JT, r.h6, A2(ph, C([
                    nh("ShowArchivesLock")
                ]), C([
                    Zen
                ]))),
                Kq(r.h6 ? eun : Yen),
                Oen(C([
                    VW(p(AW, {
                        mi: kt(n.os ? $Q : fen),
                        mD: n.os,
                        m$: n.os ? Ven : Gen,
                        ol: kt(Xen)
                    }))
                ]))
            ])),
            A2(JT, n.os, A2(Se, C([
                nh("InvitationsForm")
            ]), C([
                A2(Se, g, C(r.h6 ? [
                    AC(uun),
                    A2(JT, r.mE, A3(iun, i(n.rO, OY), eun, xen(r)))
                ] : [
                    i(n.rY, zY) ? AC(aun) : i(n.rO, zY) ? AC(_en) : AC((t = r.mN, Pi({
                        bQ: "Warning, this action will delete permanently every files in this " + (t ? "Show" : "folder"),
                        bX: "Attention, cette action entrainera la suppression d\xe9finitive de tous les fichiers pr\xe9sents dans ce " + (t ? "Show" : "dossier")
                    }))),
                    A3(iun, i(n.rO, OY), Ken, Een(r))
                ]))
            ])))
        ]));
    }), cun = Pi({
        bQ: "Downloads",
        bX: "T\xe9l\xe9chargements"
    }), fun = {
        $: 3
    }, sun = {
        $: 5
    }, lun = Pi({
        bQ: "Create a SFTP server access, accessible from any FTP client software.",
        bX: "Cr\xe9er un acc\xe8s serveur SFTP, accessible avec n'importe quel client FTP (logiciel)."
    }), dun = Pi({
        bQ: "Create SFTP access",
        bX: "Cr\xe9er acc\xe8s SFTP"
    }), bun = function(n) {
        return A2(OQ, n.a, n.b);
    }, mun = function(n) {
        return A2(Mk, C([
            nh("KeyValueWrapper")
        ]), A2(Ge, bun, n));
    }, pun = Uh("readOnly"), vun = Pi({
        bQ: "Revoke SFTP access",
        bX: "R\xe9voquer acc\xe8s SFTP"
    }), $un = Pi({
        bQ: "Renew SFTP access",
        bX: "Renouveler acc\xe8s SFTP"
    }), gun = Pi({
        bQ: "Here are the credentials for your SFTP server. Keep them safe as their are being given only once.",
        bX: "Voici les identifiants de votre serveur SFTP, gardez-les pr\xe9cieusement car il ne vous seront donn\xe9s qu'une fois."
    }), hun = Pi({
        bQ: "A SFTP server access already exists, click on 'renew' if you can't retrieve the credentials.",
        bX: "Un acc\xe8s serveur SFTP existe, si vous n'avez plus les identifiants cliquez sur le bouton 'renouveler' pour en obtenir de nouveaux. Les anciens acc\xe8s seront supprim\xe9s."
    }), kun = A2(Qh, C([
        Ah("7px"),
        Bh("7px"),
        Ih("401 651 7 7"),
        Vg("IconSmallDownload")
    ]), C([
        A2(Th, C([
            Vg("Fg"),
            drn("evenodd"),
            Lh("403 651 406 651 406 654 408 654 404.678829 658 401 654 403 654")
        ]), g)
    ])), Cun = function(n) {
        var r, t = n.lW;
        switch(t.$){
            case 0:
                return g;
            case 1:
                return C([
                    uen(lun),
                    A2(Se, C([
                        nh("DownloadOptionsButtons")
                    ]), C([
                        VW(p(AW, {
                            mi: kt(kun),
                            m$: dun,
                            ol: kt(fun)
                        }))
                    ]))
                ]);
            case 3:
                var e = t.a;
                return C([
                    LC(gun),
                    A2(Se, C([
                        nh("DownloadOptionsCredentials")
                    ]), C([
                        (r = "sftp://" + e.f$ + ":" + A2(Qu, "", e.oN) + "@" + e.fz, A2(Se, C([
                            nh("DownloadSftpLink")
                        ]), C([
                            ch("url: "),
                            A2(rk, C([
                                hk(r),
                                pun(!0),
                                nh("DownloadSftpUrl")
                            ]), g)
                        ]))),
                        mun(C([
                            d("hostname", e.fz),
                            d("port", Bt(e.gA)),
                            d("login", e.f$),
                            d("password", A2(Qu, "*****", e.oN))
                        ]))
                    ])),
                    A2(Se, C([
                        nh("DownloadOptionsButtons")
                    ]), C([
                        VW(p(AW, {
                            mi: kt($Q),
                            m$: vun,
                            ol: kt(sun)
                        })),
                        VW(p(AW, {
                            mi: kt(kun),
                            m$: $un,
                            ol: kt(fun)
                        }))
                    ]))
                ]);
            case 2:
                return e = t.a, C([
                    uen(hun),
                    A2(Se, C([
                        nh("DownloadOptionsCredentials")
                    ]), C([
                        mun(C([
                            d("hostname", e.fz),
                            d("port", Bt(e.gA)),
                            d("login", e.f$)
                        ]))
                    ])),
                    A2(Se, C([
                        nh("DownloadOptionsButtons")
                    ]), C([
                        VW(p(AW, {
                            mi: kt($Q),
                            m$: vun,
                            ol: kt(sun)
                        })),
                        VW(p(AW, {
                            mi: kt(kun),
                            m$: $un,
                            ol: kt(fun)
                        }))
                    ]))
                ]);
            default:
                return C([
                    AC(Jtn(t.a)),
                    A2(Se, C([
                        nh("DownloadOptionsButtons")
                    ]), C([
                        VW(p(AW, {
                            mi: kt(kun),
                            m$: dun,
                            ol: kt(fun)
                        }))
                    ]))
                ]);
        }
    }, jun = function(n) {
        return A2(Se, g, C([
            Uq(C([
                Kq(cun)
            ])),
            A2(Se, C([
                nh("InvitationsForm")
            ]), Cun(n))
        ]));
    }, wun = irn(C([
        A2(Cj, C([
            Vg("Fg"),
            kj("M9,13.1999999 L7.14589803,14.7063391 L6.53130198,12.3978713 L4.14589803,12.5267115 L5.0055627,10.2978714 L3,9 L5.0055627,7.70212865 L4.14589803,5.47328849 L6.53130198,5.60212868 L7.14589803,3.2936609 L9,4.80000007 L10.854102,3.2936609 L11.468698,5.60212868 L13.854102,5.47328849 L12.9944373,7.70212865 L15,9 L12.9944373,10.2978714 L13.854102,12.5267115 L11.468698,12.3978713 L10.854102,14.7063391 L9,13.1999999 Z M9,11 C10.1045695,11 11,10.1045695 11,9 C11,7.8954305 10.1045695,7 9,7 C7.8954305,7 7,7.8954305 7,9 C7,10.1045695 7.8954305,11 9,11 Z")
        ]), g)
    ])), Aun = F3(function(n, r, t) {
        return C([
            A2(Se, C([
                nh("AsideHeader")
            ]), C([
                A2(Se, C([
                    nh("AsideTabs")
                ]), C([
                    A2(hj, C([
                        Zh(C([
                            d("AsideTab", !0),
                            d("AsideTabActive", !0)
                        ]))
                    ]), C([
                        A2(Se, C([
                            nh("AsideTabsIcon")
                        ]), C([
                            wun
                        ])),
                        ch("Actions")
                    ]))
                ])),
                A2(hj, C([
                    nh("LayoutFwdButton"),
                    wj(nen(r))
                ]), C([
                    $Q
                ]))
            ])),
            A2(Se, C([
                nh("AsideBody")
            ]), C([
                A2(Sk, L_, A3(Pen, n, r.fJ, t)),
                A2(JT, ten(r) && ren(t.bg), A2(Sk, A_, jun(r.cT))),
                A2(JT, A2(Ytn, n.r8, t.bg), A2(Sk, w_, A2(oun, r.ea, {
                    mj: t.bg.mj,
                    mE: n.r8.iz,
                    mN: !1,
                    hw: t.bg.hw,
                    h6: t.bg.h6
                })))
            ]))
        ]);
    }), Lun = function(n) {
        return {
            $: 3,
            a: n
        };
    }, yun = F4(function(n, r, t, e) {
        var u;
        return Ij(p(Bj, {
            eh: kt(frn(t.mj)),
            fj: r ? kt((u = t.mj, BA(A2(Dp, u, 1)))) : Ct,
            fx: kt(aO),
            rB: e.nW
        }));
    }), Sun = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Fun = F2(function(n, r) {
        return A2(Se, C([
            nh("Avatar"),
            nh("AvatarLetter"),
            nh(n)
        ]), C([
            ch(A3(De, 0, 1, r))
        ]));
    }), Tun = F2(function(n, r) {
        var t = i(n.k6, r.k6) ? "AvatarMe" : i(n.oz, r.oz) ? "AvatarCowork" : "AvatarAlien";
        return A2(Fun, t, r.k6);
    }), Qun = A2(Qh, C([
        Ah("16px"),
        Bh("16px"),
        Ih("0 0 16 16"),
        Vg("IconBullet")
    ]), C([
        A2(UC, C([
            Vg("Bg")
        ]), C([
            A2(Mrn, C([
                Ah("8"),
                Bh("8"),
                qrn("4"),
                Drn("4")
            ]), g)
        ]))
    ])), Iun = A2(Qh, C([
        Ah("18px"),
        Bh("18px"),
        Ih("0 0 18 18"),
        Vg("IconPlus")
    ]), C([
        A2(UC, C([
            Vg("Fg")
        ]), C([
            A2(Cj, C([
                kj("M3.58334909,5.81668873 C3.26117429,5.365644 3.4556644,5 3.99539757,5 L12.0046024,5 C12.5543453,5 12.7451752,5.35675466 12.4166509,5.81668873 L8.58334909,11.1833113 C8.26117429,11.634356 7.74517524,11.6432453 7.41665091,11.1833113 L3.58334909,5.81668873 Z")
            ]), g)
        ]))
    ])), Bun = A2(Qh, C([
        Ah("18px"),
        Bh("18px"),
        Ih("0 0 18 18"),
        Vg("IconPlus")
    ]), C([
        A2(UC, C([
            Vg("Fg")
        ]), C([
            A2(Cj, C([
                kj("M5,3.99539757 C5,3.44565467 5.35675466,3.25482476 5.81668873,3.58334909 L11.1833113,7.41665091 C11.634356,7.73882571 11.6432453,8.25482476 11.1833113,8.58334909 L5.81668873,12.4166509 C5.365644,12.7388257 5,12.5443356 5,12.0046024 L5,3.99539757 Z")
            ]), g)
        ]))
    ])), Wun = A2(Po, uY, function(n) {
        return n.dC;
    }), Pun = Pi({
        bQ: "Archived",
        bX: "Archiv\xe9"
    }), Mun = {
        jR: "#3BAAFF",
        eP: "#1D507B",
        eQ: "#13334F",
        ks: "#0E2339",
        l8: "#62BBFF",
        ma: "#89CCFF",
        m6: "#B0DDFF",
        m7: "#D7EEFF",
        m8: "#EBF6FF",
        nl: "#318CD3",
        nn: "#276EA7"
    }, qun = Pi({
        bQ: "Comment",
        bX: "Commentaire"
    }), Dun = Pi({
        bQ: "Deliver started",
        bX: "Envoi d\xe9marr\xe9"
    }), Xun = Pi({
        bQ: "Delivered",
        bX: "Livr\xe9"
    }), Eun = Pi({
        bQ: "Delivery",
        bX: "Livraison"
    }), Run = {
        jR: "#1FB86A",
        eP: "#12553F",
        eQ: "#0E3531",
        ks: "#0C252A",
        l8: "#4BC687",
        ma: "#78D4A5",
        m6: "#A5E2C3",
        m7: "#D2F0E1",
        m8: "#E9F8F0",
        nl: "#1A975B",
        nn: "#16764D"
    }, xun = "#878E96", Oun = "#3C4451", zun = "#232D3A", Nun = "#181f29", Hun = "#9FA4AB", Vun = "#B7BBC0", Uun = "#CFD1D5", Jun = "#E7E8EA", Zun = "#6E757F", Kun = "#555D68", _un = Pi({
        bQ: "New",
        bX: "Nouveau"
    }), Gun = {
        jR: "#FF5A5A",
        eP: "#6C3039",
        eQ: "#3B232E",
        ks: "#221B28",
        l8: "#FF7B7B",
        ma: "#FF9C9C",
        m6: "#FFBDBD",
        m7: "#FFDEDE",
        m8: "#FFEEEE",
        nl: "#CE4C4F",
        nn: "#9a2b32"
    }, Yun = F2(function(n, r) {
        return A2(ph, C([
            A2(gh, "color", n),
            nh("TimelineEventLabel")
        ]), C([
            ch(r),
            A2(ph, C([
                nh("TimelineEventLabelPin"),
                A2(gh, "background-color", n)
            ]), C([
                ch(" ")
            ]))
        ]));
    }), nan = Pi({
        bQ: "Transcode",
        bX: "Transcode"
    }), ran = Pi({
        bQ: "Unarchived",
        bX: "D\xe9sarchiv\xe9"
    }), tan = Pi({
        bQ: "Upload",
        bX: "Upload"
    }), ean = Pi({
        bQ: "Verification",
        bX: "Verification"
    }), uan = function(n) {
        if (1 === n.$) return ch("");
        switch(n.a.$){
            case 13:
                return ch("");
            case 0:
                return A2(Yun, Mun.jR, _un);
            case 1:
                return A2(Yun, Mun.jR, tan);
            case 5:
                return A2(Yun, xun, nan);
            case 6:
                return A2(Yun, Run.jR, nan);
            case 9:
                return A2(Yun, Mun.jR, ean);
            case 7:
                return A2(Yun, Run.jR, ean);
            case 8:
                return A2(Yun, Gun.jR, ean);
            case 2:
                return A2(Yun, Run.jR, Dun);
            case 3:
                return A2(Yun, Run.jR, Xun);
            case 4:
                return A2(Yun, Gun.jR, Eun);
            case 10:
                return A2(Yun, xun, Pun);
            case 11:
                return A2(Yun, xun, ran);
            default:
                return A2(Yun, xun, qun);
        }
    }, aan = F4(function(n, r, t, e) {
        var u, a = Dt(e.e9) > 1;
        return A2(Se, C([
            nh("TimelineEvent")
        ]), C([
            A2(Se, C([
                nh("TimelineEventTitle")
            ]), C([
                uan(e.Q),
                a ? A2(Se, C([
                    Mh(A2(Sun, r, t))
                ]), C([
                    e.aJ ? Bun : Iun
                ])) : A2(Se, g, C([
                    Qun
                ])),
                A2(s7, gK(e.qs), e.rB)
            ])),
            e.aJ ? (u = e.Q, A2(Se, C([
                nh("TimelineEventTitleMessage")
            ]), function() {
                if (1 === u.$) return g;
                switch(u.a.$){
                    case 13:
                        var n = u.a, r = n.b;
                        return C([
                            ch(n.a),
                            ch(" "),
                            UA(r)
                        ]);
                    case 0:
                        var t = u.a;
                        return r = t.b, C([
                            ch(t.a),
                            ch(" "),
                            UA(r)
                        ]);
                    case 1:
                        var e = u.a;
                        return r = e.b, C([
                            ch(e.a),
                            ch(" "),
                            UA(r)
                        ]);
                    case 5:
                        var a = u.a;
                        return r = a.b, C([
                            ch(a.a),
                            ch(" "),
                            UA(r)
                        ]);
                    case 6:
                        var i = u.a;
                        return r = i.b, C([
                            ch(i.a),
                            ch(" "),
                            UA(r)
                        ]);
                    case 9:
                        var o = u.a;
                        return r = o.b, C([
                            ch(o.a),
                            ch(" "),
                            UA(r)
                        ]);
                    case 7:
                        var c = u.a;
                        return r = c.b, C([
                            ch(c.a),
                            ch(" "),
                            UA(r)
                        ]);
                    case 8:
                        var f = u.a;
                        return r = f.b, C([
                            ch(f.a),
                            ch(" "),
                            UA(r)
                        ]);
                    case 2:
                        var s = u.a;
                        return r = s.b, C([
                            ch(s.a),
                            ch(" "),
                            UA(r)
                        ]);
                    case 3:
                        var l = u.a;
                        return r = l.b, C([
                            ch(l.a),
                            ch(" "),
                            UA(r)
                        ]);
                    case 4:
                        var d = u.a;
                        return r = d.b, C([
                            ch(d.a),
                            ch(" "),
                            UA(r)
                        ]);
                    case 10:
                        var b = u.a;
                        return r = b.b, C([
                            ch(b.a),
                            ch(" "),
                            UA(r)
                        ]);
                    case 11:
                        var m = u.a;
                        return r = m.b, C([
                            ch(m.a),
                            ch(" "),
                            UA(r)
                        ]);
                    default:
                        var p = u.a;
                        return r = p.b, C([
                            ch(p.a),
                            ch(" "),
                            UA(r)
                        ]);
                }
            }())) : A2(Se, C([
                nh("TimelineGroup")
            ]), A2(Ge, function(r) {
                var t;
                return A2(Se, C([
                    nh("TimelineGroupEvent")
                ]), C([
                    (t = Wun(r), t.$ ? Qun : A2(Tun, n, t.a)),
                    A2(Se, C([
                        nh("TimelineEventMessage")
                    ]), C([
                        ch(eY(r)),
                        UA(aY(r))
                    ]))
                ]));
            }, e.e9))
        ]));
    }), ian = F3(function(n, r, t) {
        return vW(A2(cl, F2(function(t, e) {
            return A4(aan, n, r, t, e);
        }), t));
    }), oan = F2(function(n, r) {
        return Jt(vW(A2(cl, F2(function(r, t) {
            var e, u, a;
            return A2(Se, g, A2(bt, A2(_h, C([
                nh("TimelineDate")
            ]), (u = A3(De, 0, 4, e = r), a = A3(De, 5, 7, e), A3(De, 8, 10, e) + "/" + a + "/" + u)), A3(ian, n, r, t)));
        }), r)));
    }), can = F4(function(n, r, t) {
        return C([
            A4(yun, n, !0, r, t.bg),
            Ztn(r),
            A2(Sk, Lun, A2(Se, C([
                nh("ShowHomeWrapper")
            ]), A2(oan, n.r8, r.rA)))
        ]);
    }), fan = F4(function(n, r, t, e) {
        return A2(Se, C([
            nh("ShowWrapper")
        ]), C([
            A2(Se, C([
                nh("ShowMain")
            ]), A4(can, n, r, t, e)),
            A2(Se, C([
                nh("ShowAside")
            ]), A3(Aun, n, r, t))
        ]));
    }), san = F3(function(n, r, t) {
        var e = r.Q.kt;
        return e.$ ? A2(_tn, n, r) : A4(fan, n, r, e.a, t);
    }), lan = function(n) {
        var r = n.Q.ll;
        return r.$ ? ch("") : AC(Jtn(r.a));
    }, dan = F2(function(n, r) {
        return A2(bu, function(r) {
            return i(n.mj, r.r8) && r.cT;
        }, r);
    }), ban = F3(function(n, r, t) {
        return !A2(WJ, n, r) && A2(dan, n, t) && A2(PJ, n, t);
    }), man = function(n) {
        return A3(ban, n.r8, n.oz.mj, A2(Ge, function(n) {
            return n.fH;
        }, n.fJ));
    }, pan = F2(function(n, r) {
        return Dt(A2(Bu, function(n) {
            return i(n.oB, r);
        }, n.oD)) > 0;
    }), van = {
        $: 0
    }, $an = F3(function(n, r, t) {
        return n.il ? van : function(n) {
            return {
                $: 1,
                a: n
            };
        }(A2(AJ, r, t));
    }), gan = F3(function(n, r, t) {
        return {
            S: t.S,
            iY: r.iY,
            cJ: t.cJ,
            bM: t.bM,
            e8: n.e8,
            bS: t.bS,
            fJ: t.fJ,
            mF: n.mF,
            c7: t.c7,
            aa: n.aa,
            dd: t.dd,
            oz: t.oz,
            oK: r.oK,
            oS: r.oR,
            bl: t.bl,
            g9: t.g9,
            Q: A3($an, t.g9, t.S.bF, t.S.bT.f2),
            r8: n.r8
        };
    }), han = function(n) {
        return gK(n.mj);
    }, kan = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Can = F2(function(n, r) {
        return A2(z1, n, r.oK.bF);
    }), jan = function(n) {
        return i(A2(Tu, function(n) {
            return YZ(n.lA);
        }, n.S.bT.f2), kt(!0));
    }, wan = function(n) {
        return a0(n.g9)(n.bM)(n.oz)(n.dd)(n.c7)(n.bS)(n.S)(n.bl)(n.cJ)(n.fJ);
    }, Aan = {
        $: 0
    }, Lan = {
        $: 1
    }, yan = {
        $: 2
    }, San = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Fan = {
        $: 0
    }, Tan = Pi({
        bQ: "Acceptation",
        bX: "Acceptation"
    }), Qan = Pi({
        bQ: "Capsule accepted",
        bX: "Capsule accept\xe9e"
    }), Ian = Pi({
        bQ: "Master accepted",
        bX: "Master accept\xe9"
    }), Ban = function(n) {
        return A2(Se, C([
            nh("AcceptationBorderWrapper")
        ]), C([
            n
        ]));
    }, Wan = Pi({
        bQ: "Capsule rejected",
        bX: "Capsule rejet\xe9e"
    }), Pan = Pi({
        bQ: "Master rejected",
        bX: "Master rejet\xe9"
    }), Man = Pi({
        bQ: "Please fill in the motivation for rejection",
        bX: "Veuillez donner un motif de refus"
    }), qan = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Dan = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Xan = F3(function(n, r, t) {
        return {
            $: 5,
            a: n,
            b: r,
            c: t
        };
    }), Ean = {
        $: 0
    }, Ran = function(n) {
        return {
            $: 2,
            a: n
        };
    }, xan = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Oan = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), zan = {
        $: 1
    }, Nan = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Han = function(n) {
        return Nan(function(n) {
            return {
                $: 2,
                a: n
            };
        }(n));
    }, Van = Ean, Uan = Nan({
        $: 1
    }), Jan = F2(function(n, r) {
        var t = r.lV, e = r.f2;
        return A2(WJ, n, r.g9.oz) ? i(t.dt, Ct) ? 1 === e.$ ? Han("Vous devez uploader un fichier vid\xe9o et attendre la fin de son analyse automatique.") : 1 === A2(Lp, function(n) {
            return n.bn;
        }, e.a.sc).$ ? Han("La validation n'est accessible qu'une fois l'analyse automatique termin\xe9e.") : Van : Han("Cette capsule a d\xe9j\xe0 \xe9t\xe9 rejet\xe9e.") : Uan;
    }), Zan = F2(function(n, r) {
        return Gtn(n) ? Ean : r;
    }), Kan = Nan({
        $: 0
    }), _an = F4(function(n, r, t, e) {
        return A2(Zan, n, A2(WJ, n, t.oz) ? t.il ? Uan : e : Kan);
    }), Gan = F2(function(n, r) {
        return A4(_an, n, r.al, r.g9, A2(Jan, n, r));
    }), Yan = function(n) {
        return A2(xg, C([
            nh("ButtonDisabled"),
            nk(!0)
        ]), C([
            ch(n)
        ]));
    }, nin = Ng("id"), rin = irn(C([
        A2(Cj, C([
            kj("M6.75,10.4726562 L6.83203125,10.0351562 C6.90039097,9.67057109 6.99609313,9.35612111 7.11914062,9.09179688 C7.24218812,8.82747264 7.40397035,8.59049584 7.60449219,8.38085938 C7.80501402,8.17122291 8.12629987,7.92057438 8.56835938,7.62890625 C8.97396036,7.36458201 9.25992755,7.14811282 9.42626953,6.97949219 C9.59261151,6.81087155 9.67578125,6.63541758 9.67578125,6.453125 C9.67578125,6.13411299 9.47070518,5.97460938 9.06054688,5.97460938 C8.48632525,5.97460938 7.77311624,6.22297929 6.92089844,6.71972656 L6.10742188,4.78515625 C7.16016151,4.1699188 8.21060674,3.86230469 9.25878906,3.86230469 C10.1748093,3.86230469 10.9028293,4.06738076 11.4428711,4.47753906 C11.9829129,4.88769736 12.2529297,5.45279588 12.2529297,6.17285156 C12.2529297,6.57845255 12.1902676,6.93391774 12.0649414,7.23925781 C11.9396153,7.54459788 11.759604,7.81917196 11.5249023,8.06298828 C11.2902006,8.3068046 10.9016954,8.5927718 10.359375,8.92089844 C9.90364355,9.1943373 9.57893977,9.42219961 9.38525391,9.60449219 C9.19156804,9.78678477 9.06510446,9.9781891 9.00585938,10.1787109 L8.90332031,10.4726562 L6.75,10.4726562 Z M6.203125,13.1318359 C6.203125,12.6442033 6.3512355,12.2568374 6.64746094,11.9697266 C6.94368638,11.6826158 7.3515599,11.5390625 7.87109375,11.5390625 C8.26758011,11.5390625 8.57177628,11.6313467 8.78369141,11.815918 C8.99560653,12.0004892 9.1015625,12.2613915 9.1015625,12.5986328 C9.1015625,13.0999374 8.95686994,13.4873033 8.66748047,13.7607422 C8.378091,14.0341811 7.98047128,14.1708984 7.47460938,14.1708984 C7.07812302,14.1708984 6.76709097,14.0820321 6.54150391,13.9042969 C6.31591684,13.7265616 6.203125,13.4690772 6.203125,13.1318359 Z"),
            nin("?")
        ]), g)
    ])), tin = F3(function(n, r, t) {
        if (t.$) return C(r.$ ? [
            ij(n)
        ] : [
            A2(Znn, n, r.a)
        ]);
        var e = t.a;
        return C([
            A2(Se, C([
                HW(e)
            ]), C([
                Yan(n)
            ])),
            A2(Se, C([
                HW(e),
                nh("AcceptationWarning")
            ]), C([
                rin
            ]))
        ]);
    }), ein = F4(function(n, r, t, e) {
        return A2(Zan, n, A2(WJ, n, t.oz) ? t.il ? Uan : e : Kan);
    }), uin = F2(function(n, r) {
        return A4(ein, n, r.al, r.g9, A2(Jan, n, r));
    }), ain = Pi({
        bQ: "End file\u2019s qualification",
        bX: "Finir la qualification du fichier"
    }), iin = Pi({
        bQ: "You do not have the right to perform this action",
        bX: "Vous n\u2019avez pas le droit d\u2019effectuer cette action"
    }), oin = Pi({
        bQ: "Ongoing processing",
        bX: "Traitement en cours"
    }), cin = F2(function(n, r) {
        if (1 === n.$) return kt(oin);
        if (!r.$) return Ct;
        var t = r.a;
        switch(t.$){
            case 0:
                return kt("");
            case 1:
                return kt(iin);
            default:
                return kt(t.a);
        }
    }), fin = F3(function(n, r, t) {
        if (1 === t.$) return A2(cin, n.ny, r);
        var e = t.a.sc;
        return 1 === e.$ || 1 === e.a.bn.$ ? kt(oin) : A2(cin, n.ny, r);
    }), sin = Pi({
        bQ: "Accept",
        bX: "Accepter"
    }), lin = Pi({
        bQ: "Accept master",
        bX: "Accepter le master"
    }), din = Pi({
        bQ: "Ask for new upload",
        bX: "Demander un nouvel upload"
    }), bin = Pi({
        bQ: "Qualify",
        bX: "Qualifier"
    }), min = Pi({
        bQ: "Accept and deliver",
        bX: "Accepter et livrer"
    }), pin = Pi({
        bQ: "Accept the capsule and deliver it to broadcaster",
        bX: "Accepter la capsule et la livrer au diffuseur"
    }), vin = Pi({
        bQ: "Reject file and ask for a re-upload.",
        bX: "Rejeter les fichiers et demander un nouvel upload."
    }), $in = Se(C([
        nh("ButtonToolbar")
    ])), gin = F3(function(n, r, t) {
        var e = A3(fin, t, A2(uin, n.r8, {
            al: n,
            lV: r.bF,
            f2: A2(Tu, function(n) {
                return n.lA;
            }, r.bT.f2),
            g9: n.g9
        }), A2(Tu, function(n) {
            return n.lA;
        }, r.bT.f2)), u = A3(fin, t, Ean, A2(Tu, function(n) {
            return n.lA;
        }, r.bT.f2)), a = A3(fin, t, A2(Gan, n.r8, {
            al: n,
            lV: r.bF,
            f2: A2(Tu, function(n) {
                return n.lA;
            }, r.bT.f2),
            g9: n.g9
        }), A2(Tu, function(n) {
            return n.lA;
        }, r.bT.f2)), i = n.g9.c9 ? d(sin, lin) : d(min, pin), o = i.a, c = i.b;
        return C([
            Gtn(n.r8) ? A2(Se, C([
                nh("AcceptationLeft"),
                nh("AcceptationNormal")
            ]), C([
                A2(_h, C([
                    nh("AcceptationText")
                ]), ain),
                $in(A3(tin, bin, Dan(A2(Oan, n.g9, r.bF)), u))
            ])) : ch(""),
            A2(Se, C([
                nh("AcceptationMiddle"),
                nh("AcceptationOk")
            ]), C([
                A2(_h, C([
                    nh("AcceptationTextOk")
                ]), c),
                wu(n.cJ) ? ch("") : A2(Sk, Ran, A2(rj, t.nw, A2(Ge, function(n) {
                    return d(n.sa, n.sa);
                }, n.cJ))),
                $in(A3(tin, o, Dan(A3(Xan, n.g9, r.bF, n.cJ)), a))
            ])),
            A2(Se, C([
                nh("AcceptationRight")
            ]), C([
                A2(tj, C([
                    aj(qan(n.g9)),
                    nh("AcceptationKo")
                ]), C([
                    A2(_h, C([
                        nh("AcceptationRejectionText")
                    ]), vin),
                    A2(Sk, xan, WB(t.nx)),
                    $in(A3(tin, din, zan, e))
                ]))
            ]))
        ]);
    }), hin = F3(function(n, r, t) {
        return A2(JT, Gtn(n.r8) || !0, function() {
            var e, u = (e = r.bF.dt).$ ? n.g9.il ? Aan : jan(n) ? yan : Lan : function(n) {
                return {
                    $: 3,
                    a: n
                };
            }(e.a);
            switch(u.$){
                case 1:
                    return A2(Se, C([
                        nh("Acceptation"),
                        fk("accept"),
                        Zh(C([
                            d("AcceptationAccepted", n.g9.il),
                            d("AcceptationRefused", !i(r.bF.dt, Ct))
                        ]))
                    ]), C([
                        Uq(C([
                            Kq(Tan),
                            Oen(C([
                                VW(p(AW, {
                                    mi: kt(t.gn ? $Q : Xh),
                                    mD: t.gn,
                                    m$: Tan,
                                    ol: kt(Fan)
                                }))
                            ]))
                        ])),
                        A2(JT, t.gn, A2(Se, C([
                            nh("InvitationsForm")
                        ]), C([
                            function() {
                                var n = t.ny;
                                switch(n.$){
                                    case 2:
                                        var r = n.a;
                                        return A2(Se, C([
                                            Mh(San(0))
                                        ]), C([
                                            A2(Ann, Snn, r)
                                        ]));
                                    case 3:
                                        return A2(Se, C([
                                            Mh(San(0))
                                        ]), C([
                                            AC(Man)
                                        ]));
                                    default:
                                        return ch("");
                                }
                            }(),
                            A2(WJ, n.r8, n.g9.oz) ? A2(Se, C([
                                nh("AcceptationChoices")
                            ]), A3(gin, n, r, t)) : ch("")
                        ])))
                    ]));
                case 2:
                    return ch("");
                case 0:
                    return Ban(LC(n.g9.c9 ? Ian : Qan));
                default:
                    return Ban(A2(Nq, n.g9.c9 ? Pan : Wan, ch(u.a)));
            }
        }());
    }), kin = Pi({
        bQ: "Segmentation IA",
        bX: "Segmentation IA"
    }), Cin = {
        $: 0
    }, jin = Pi({
        bQ: "Video archived",
        bX: "Fichier vid\xe9o archiv\xe9"
    }), win = Pi({
        bQ: "Proxy required",
        bX: "Proxy requis"
    }), Ain = Pi({
        bQ: "Video file required",
        bX: "Fichier vid\xe9o requis"
    }), Lin = F2(function(n, r) {
        if (3 === n.$) {
            var t = n.a;
            return A2(Se, C([
                Mh(r)
            ]), C([
                A2(Ann, Snn, t)
            ]));
        }
        return ch("");
    }), yin = function(n) {
        switch(n.$){
            case 0:
                return A2(Se, C([
                    nh("OperationStatus"),
                    nh("OperationStatusNone")
                ]), g);
            case 1:
                return A2(Se, C([
                    nh("OperationStatus"),
                    nh("OperationStatusRunning")
                ]), g);
            case 2:
                return A2(Se, C([
                    nh("OperationStatus"),
                    nh("OperationStatusSuccess")
                ]), g);
            default:
                return A2(Se, C([
                    nh("OperationStatus"),
                    nh("OperationStatusFailure")
                ]), g);
        }
    }, Sin = F3(function(n, r, t) {
        return A2(Se, C([
            nh("Operation")
        ]), C([
            yin(n),
            A2(Se, C([
                nh("OperationContent")
            ]), A2(bt, A2(Lin, n, r), t))
        ]));
    }), Fin = F2(function(n, r) {
        var t = d(n.bT.f2, A2(Lp, A2(Po, function(n) {
            return n.o7;
        }, function(n) {
            return n.nm;
        }), n.bT.f2));
        if (1 === t.a.$) return A3(Sin, Cin, 0, C([
            ch(Ain)
        ]));
        if (1 === t.b.$) return A3(Sin, Cin, 0, C([
            ch(win)
        ]));
        var e = t.b.a;
        return YZ(t.a.a.lA) ? A3(Sin, Cin, 0, C([
            ch(jin)
        ])) : r(e);
    }), Tin = F2(function(n, r) {
        return A2(Se, C([
            nh("Operation")
        ]), C([
            yin(Cin),
            A2(Se, C([
                nh("OperationContent"),
                nh("PlayerSettings")
            ]), C([
                A2(Se, g, C([
                    ch(A2(Qu, "", n.km))
                ])),
                A2(hj, C([
                    wj("/neoplayer/" + r),
                    nh("Button"),
                    uQ("_blank"),
                    A2(ZW, "data-prevent-history", "true")
                ]), C([
                    ch("Neo Player")
                ]))
            ]))
        ]));
    }), Qin = F3(function(n, r, t) {
        var e;
        return "df35fcfb-a68e-42f4-8d9f-74d3df15125c" === (e = n.r8).mj || "f4f90af8-0702-49ff-89c0-aafecd8afec9" === e.mj || "f086968b-9a32-449b-bd87-5419c15973ec" === e.mj || "7c9b1827-1d6c-4fa0-8864-598812d5efd5" === e.mj || "5de3e02c-06aa-496f-a4f6-f5aac29114ee" === e.mj || "d00b873f-d6aa-4c16-8342-3e4e08a6d658" === e.mj || "354b2862-a0b9-4292-93a2-437d51a2df47" === e.mj ? A2(Se, C([
            nh("Segmentation")
        ]), C([
            A2(Se, C([
                nh("LayoutHeader"),
                A2(gh, "margin-bottom", "0px")
            ]), C([
                A2(_h, C([
                    nh("LayoutHeaderTitle")
                ]), kin)
            ])),
            A2(Fin, r, function() {
                return A2(Tin, t, n.g9.mj);
            })
        ])) : ch("");
    }), Iin = {
        $: 1
    }, Bin = function(n) {
        return Dt(n.oD) > 0;
    }, Win = Pi({
        bQ: "Cancel",
        bX: "Annuler"
    }), Pin = Pi({
        bQ: "Deliveries",
        bX: "Livraisons"
    }), Min = A2(Qh, C([
        Ah("18px"),
        Bh("18px"),
        Ih("0 0 18 18"),
        Vg("IconSpinner")
    ]), C([
        A2(Cj, C([
            Vg("Fg"),
            kj("M4.94601622,4.57669369 C3.74989521,5.67353545 3,7.24919402 3,9 C3,12.3137085 5.6862915,15 9,15 C12.3137085,15 15,12.3137085 15,9 C15,6.64729493 13.6458726,4.61086325 11.6744855,3.62757252 L11.2601446,5.69927685 C12.3108237,6.42010318 13,7.62956872 13,9 C13,11.209139 11.209139,13 9,13 C6.790861,13 5,11.209139 5,9 C5,7.98151039 5.38065278,7.051927 6.00745306,6.34575509 L7,8 L9,4 L4,3 L4.94601622,4.57669369 Z")
        ]), g)
    ])), qin = Pi({
        bQ: "Downloading before delivery",
        bX: "T\xe9l\xe9chargement avant livraison"
    }), Din = Pi({
        bQ: "Encoding in progress before delivery",
        bX: "Encodage en cours avant livraison"
    }), Xin = Pi({
        bQ: "Delivered",
        bX: "Livr\xe9"
    }), Ein = Pi({
        bQ: "Packaging in progress before delivery",
        bX: "Enpaquetage en cours avant livraison"
    }), Rin = Pi({
        bQ: "Uploading in progress before delivery",
        bX: "Transfert en cours"
    }), xin = Pi({
        bQ: "Waiting for delivery",
        bX: "Livraison en attente"
    }), Oin = irn(C([
        A2(Cj, C([
            Vg("Fg"),
            kj("M3,1 L11,1 L15,5 L15,17 L3,17 L3,1 Z M6,11 L9,14 L13,9 L12,7 L9,11 L7,9 L6,11 Z")
        ]), g)
    ])), zin = function(n) {
        return A2(hj, C([
            wj(gK(n.mj)),
            nh("DownloadsLinksItem"),
            5 === n.rN.oQ ? nh("ShowDeliveriesSuccess") : Zh(g)
        ]), C([
            A2(ph, C([
                nh("DownloadsLinksItemIcon")
            ]), C([
                5 === n.rN.oQ ? Oin : Min
            ])),
            A2(ph, C([
                nh("DownloadsLinksItemWrapper")
            ]), C([
                A2(ph, C([
                    nh("DownloadsLinksItemName")
                ]), C([
                    ch(n.gp),
                    ch(" / "),
                    ch(n.rB)
                ])),
                A2(ph, C([
                    nh("DownloadsLinksItemDetails")
                ]), C([
                    function() {
                        switch(n.rN.oQ){
                            case 0:
                                return ch(xin);
                            case 1:
                                return ch(qin);
                            case 2:
                                return ch(Din);
                            case 3:
                                return ch(Ein);
                            case 4:
                                return ch(Rin);
                            default:
                                return ch(Xin);
                        }
                    }(),
                    ch(" - "),
                    UA(n.rN.qP)
                ]))
            ]))
        ]));
    }, Nin = function(n) {
        return A2(Ge, zin, A2(Pw, Ww(function(n) {
            return n.rB;
        }), n));
    }, Hin = Pi({
        bQ: "New delivery",
        bX: "Nouvelle livraison"
    }), Vin = Pi({
        bQ: "No delivery yet.",
        bX: "Aucune livraison."
    }), Uin = Pi({
        bQ: "No material available.",
        bX: "Pas de mat\xe9riel disponible."
    }), Jin = F4(function(n, r, t, e) {
        return {
            $: 5,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), Zin = function(n) {
        return {
            $: 14,
            a: n
        };
    }, Kin = Pi({
        bQ: "This action will not re-encode, but copy source files to destination.",
        bX: "Cette action ne va pas r\xe9-encoder, mais seulement copier les sources \xe0 destination."
    }), _in = Pi({
        bQ: "Error occurred during delivery",
        bX: "Une erreur est survenue pendant la livraison"
    }), Gin = Pi({
        bQ: "Delivery has started...",
        bX: "La livraison a commenc\xe9..."
    }), Yin = Pi({
        bQ: "Loading...",
        bX: "Chargement..."
    }), non = Pi({
        bQ: "You can not deliver this master on any program.",
        bX: "Vous ne pouvez livrer ce master sur aucun programme."
    }), ron = irn(C([
        A2(Cj, C([
            Vg("Fg"),
            kj("M12.5918 14.7207L12.377 15.5996C11.7324 15.8535 11.2181 16.0456 10.834 16.1758C10.4499 16.3125 10.0039 16.3809 9.49609 16.3809C8.71484 16.3809 8.10612 16.1921 7.66992 15.8145C7.24023 15.4303 7.02539 14.9453 7.02539 14.3594C7.02539 14.1315 7.04167 13.9004 7.07422 13.666C7.10677 13.4251 7.15885 13.1549 7.23047 12.8555L8.03125 10.0039C8.10286 9.73047 8.16146 9.47331 8.20703 9.23242C8.25911 8.98503 8.28516 8.76042 8.28516 8.55859C8.28516 8.19401 8.21029 7.9401 8.06055 7.79688C7.91081 7.65365 7.62435 7.58203 7.20117 7.58203C6.99284 7.58203 6.77799 7.61458 6.55664 7.67969C6.3418 7.74479 6.15625 7.80664 6 7.86523L6.21484 6.98633C6.74219 6.77148 7.24674 6.58919 7.72852 6.43945C8.21029 6.2832 8.66602 6.20508 9.0957 6.20508C9.87044 6.20508 10.4661 6.39388 10.8828 6.77148C11.306 7.14258 11.5176 7.6276 11.5176 8.22656C11.5176 8.35026 11.5013 8.56836 11.4688 8.88086C11.4427 9.19336 11.3906 9.47982 11.3125 9.74023L10.5117 12.582C10.4466 12.8099 10.388 13.0703 10.3359 13.3633C10.2839 13.6562 10.2578 13.8776 10.2578 14.0273C10.2578 14.4049 10.3424 14.6621 10.5117 14.7988C10.681 14.9355 10.974 15.0039 11.3906 15.0039C11.5859 15.0039 11.8073 14.9714 12.0547 14.9062C12.3021 14.8346 12.4811 14.7728 12.5918 14.7207ZM11.7969 3.79688C11.7969 4.29167 11.6081 4.71484 11.2305 5.06641C10.8594 5.41146 10.4102 5.58398 9.88281 5.58398C9.35547 5.58398 8.90299 5.41146 8.52539 5.06641C8.14779 4.71484 7.95898 4.29167 7.95898 3.79688C7.95898 3.30208 8.14779 2.87891 8.52539 2.52734C8.90299 2.17578 9.35547 2 9.88281 2C10.4102 2 10.8594 2.17578 11.2305 2.52734C11.6081 2.87891 11.7969 3.30208 11.7969 3.79688Z")
        ]), g)
    ])), ton = function(n) {
        return A2(Se, C([
            nh("BannerTodo")
        ]), C([
            A2(Se, C([
                nh("BannerTodoIcon")
            ]), C([
                ron
            ])),
            A2(Se, C([
                nh("BannerTodoBody")
            ]), C([
                A2(_h, C([
                    nh("BannerTodoTitle")
                ]), n)
            ]))
        ]));
    }, eon = Pi({
        bQ: "An error occurred while searching for delivery capsules in the organization ",
        bX: "Une erreur est survenue pendant la recherche des capsules de livraison dans l\u2019organisation "
    }), uon = Pi({
        bQ: "Start delivery",
        bX: "D\xe9marrer la livraison"
    }), aon = Pi({
        bQ: "No version mapping are associated to this organization. Contact ops@nomalab.com",
        bX: "Aucune version mapping n'est associ\xe9e \xe0 cette organisation. Veuillez contacter ops@nomalab.com."
    }), ion = function(n) {
        return {
            $: 17,
            a: n
        };
    }, oon = function(n) {
        return {
            $: 13,
            a: n
        };
    }, con = function(n) {
        return {
            $: 10,
            a: n
        };
    }, fon = F2(function(n, r) {
        return {
            $: 16,
            a: n,
            b: r
        };
    }), son = function(n) {
        return {
            $: 15,
            a: n
        };
    }, lon = function(n) {
        return {
            $: 12,
            a: n
        };
    }, don = function(n) {
        return {
            $: 11,
            a: n
        };
    }, bon = function(n) {
        return {
            $: 7,
            a: n
        };
    }, mon = function(n) {
        return {
            $: 8,
            a: n
        };
    }, pon = function(n) {
        return {
            $: 9,
            a: n
        };
    }, von = function(n) {
        return {
            $: 18,
            a: n
        };
    }, $on = function(n) {
        return {
            $: 19,
            a: n
        };
    }, gon = Pi({
        bQ: "No transcoding delivery",
        bX: "Livraison source sans encodage"
    }), hon = Pi({
        bQ: "Automatic creation",
        bX: "Cr\xe9ation automatique"
    }), kon = Pi({
        bQ: "Burn subtitles",
        bX: "Sous-titres incrust\xe9s"
    }), Con = Pi({
        bQ: "Extra",
        bX: "Compl\xe9mentaire"
    }), jon = F2(function(n, r) {
        return A2(F2(function(n, t) {
            for(;;){
                var e = A2(Lo, n, r);
                if (1 === e.$) return t;
                var u = e.a, a = u.gs;
                if (1 === a.$) return A2(bt, u.nW, t);
                n = a.a, t = A2(bt, u.nW, t);
            }
        }), n, g);
    }), won = Se(C([
        A2(gh, "display", "contents")
    ])), Aon = function(n) {
        return A2(Yh, n, A2(rk, C([
            nh("InputText"),
            sk(n.kT),
            qh("text"),
            $k(zh),
            bk(Nh),
            mk(Hh),
            hk(n.sa),
            gk(n.gy),
            tk(ck(n.m$)),
            nk(n.kO),
            pun(!0)
        ]), g));
    }, Lon = Pi({
        bQ: "You can not deliver any of this organization\u2019s programs.",
        bX: "Vous ne pouvez livrer aucun des programmes de cette organisation."
    }), yon = F2(function(n, r) {
        return 1 > n ? r : A3(De, 0, -n, r);
    }), Son = Pi({
        bQ: "Mark in/out",
        bX: "Mark in/out"
    }), Fon = Pi({
        bQ: "No subtitles",
        bX: "Sans sous-titres"
    }), Ton = Pi({
        bQ: "No extra",
        bX: "Sans compl\xe9mentaire"
    }), Qon = Pi({
        bQ: "No segment on this master",
        bX: "Il n'y a pas de segment pour ce master"
    }), Ion = Pi({
        bQ: "Segment(s)",
        bX: "Segment(s)"
    }), Bon = Pi({
        bQ: "Sidecar format : ",
        bX: "Format \xe0 part : "
    }), Won = Pi({
        bQ: "Warning, some subtitles have been detected with wrong position, they will be automatically readjusted when you will play and burn them.",
        bX: "Attention, certaines lignes de sous-titres sont d\xe9tect\xe9es avec des placements m\xe9dian, ils seront automatiquement repositionn\xe9s lors de la visualisation et l'incrustation."
    }), Pon = Pi({
        bQ: "The timezone used is",
        bX: "La timezone utilis\xe9e est"
    }), Mon = F4(function(n, r, t, e) {
        var u, a, o, c, f = A2(bt, d("", Fon), A2(nc, function(n) {
            var r;
            return (r = n.lA.r$).$ || !i(r.a.j_, Ct) ? kt(d(n.lA.mj, n.lA.nW)) : Ct;
        }, n.bT.ae)), s = A2(Qu, !1, A2(Tu, A2(Po, function(n) {
            return n.hI;
        }, A2(Po, wu, pu)), Ra(A2(Bu, function(n) {
            return i(n.lA.mj, t.ra.sa);
        }, n.bT.ae)))), l = "AsSource" !== t.lP.sa, m = F2(function(n, r) {
            return n ? r : ch("");
        }), p = "" !== t.ra.sa, v = "" !== t.fb.sa && "NoExtra" !== t.fb.sa, h = Dt(n.bT.ae) > 0, k = b(e.dj, e.dB, e.ic), j = k.b, w = k.c, A = il(A2(Ge, function(n) {
            return d(n.mj, n);
        }, k.a)), L = $(A2(Pw, Ww(tl), A2(Ge, T4(Wt(" > ")), A2(Ge, function(n) {
            return d(n.mj, $(A2(jon, n.gs, A), C([
                n.rC
            ])));
        }, A2(Bu, ren, j)))), C([
            d("Aucun", hon)
        ])), y = A2(Ge, function(n) {
            return d(n.nW, n.nW);
        }, w), S = b(e.c5, e.dF, e.fc), F = S.a, T = S.b, Q = S.c, I = A2(bt, d("NoExtra", Ton), A2(Ge, function(n) {
            return d(n.mj, n.nW);
        }, Q)), B = Dt(I) > 1, W = (u = A2(Pw, Ww(tl), A2(Ge, function(n) {
            return d(n.mj, n.nW);
        }, F)), r.iI ? $(u, C([
            d("AsSource", gon)
        ])) : u), P = A2(y5, F, t.lP.sa);
        return d(L, C([
            A2(Se, g, wu(L) ? C("" === t.oz.sa ? [
                ch("")
            ] : [
                AC(Lon)
            ]) : C([
                A2(Sk, son, A2(nj, t.g9, L)),
                A2(m, l, A2(Sk, pon, A2(nj, t.ic, y))),
                A2(Sk, fon(F), A2(nj, t.lP, W)),
                A2(m, h && !P, A2(Sk, don, A2(nj, t.ra, f))),
                A2(m, h && !P && p, A2(Sk, lon, A2(nj, t.q2, (a = t.ra.sa, o = A2(Qu, "", Ra(A2(Ge, function(n) {
                    return n.lA.nW;
                }, A2(Bu, function(n) {
                    return i(n.lA.mj, a);
                }, n.bT.ae)))), A2(bu, function(n) {
                    return A2(yJ, n, zi(o));
                }, C([
                    ".stl",
                    ".vtt",
                    ".srt",
                    ".ass"
                ])) ? A2(bt, l ? d("Burning", kon) : d("", ""), A2(Pw, Ww(tl), A2(Ge, function(n) {
                    return d(n.mj, $(Bon, n.nW));
                }, T))) : g)))),
                A2(m, s, j7(Won)),
                A2(m, B, won(C([
                    A2(Se, C([
                        nh("ShowDeliveriesItemTitle")
                    ]), C([
                        ch(Con)
                    ])),
                    A2(Sk, oon, A2(nj, t.fb, I)),
                    A2(m, v, A2(Sk, con, A2(nj, t.fd, y)))
                ]))),
                A2(Se, g, C([
                    A2(Sk, ion, (c = t.kG, A2(NC, c, function(n) {
                        var r;
                        return A2(Yh, n, A2(rk, C([
                            nh("InputText"),
                            qh("datetime-local"),
                            A2(Zg, "input", A2(Fe, function(n) {
                                return zh(n);
                            }, A2(du, "timezone", Bi))),
                            hk((r = n.sa, A2(yon, 6, r))),
                            gk(n.gy),
                            tk(ck(n.m$)),
                            nk(n.kO)
                        ]), g));
                    }(c))))
                ])),
                A2(ph, g, C([
                    ch(Pon + " "),
                    A3(ye, "time-zone", g, g)
                ])),
                A2(Se, C([
                    nh("ShowDeliverySegmentsTabs")
                ]), C([
                    A2(Se, C([
                        Mh($on(!0)),
                        nh("ShowDeliverySegmentsTab"),
                        Zh(C([
                            d("ShowDeliverySegmentsTabActive", t.rG)
                        ]))
                    ]), C([
                        ch(Ion)
                    ])),
                    A2(Se, C([
                        Mh($on(!1)),
                        nh("ShowDeliverySegmentsTab"),
                        Zh(C([
                            d("ShowDeliverySegmentsTabActive", !t.rG)
                        ]))
                    ]), C([
                        ch(Son)
                    ]))
                ])),
                A2(m, l, A2(Se, C([
                    nh("ShowDeliverySegmentsContent")
                ]), C(t.rG ? [
                    i(t.g3.eC, g) ? ch(Qon) : A2(Sk, von, Pnn(t.g3))
                ] : [
                    A2(ph, C([
                        nh("MasterTimecodeInputCls")
                    ]), C([
                        A2(Sk, bon, Aon(t.dI)),
                        A2(Znn, "Mark in", A2(F1, 0, Ct))
                    ])),
                    A2(ph, C([
                        nh("MasterTimecodeInputCls")
                    ]), C([
                        A2(Sk, mon, Aon(t.dJ)),
                        A2(Znn, "Mark out", A2(F1, 1, Ct))
                    ]))
                ])))
            ]))
        ]));
    }), qon = F3(function(n, r, t) {
        switch(n.$){
            case 0:
                return ch("");
            case 1:
                return A2(Se, C([
                    nh("InvitationsForm")
                ]), C([
                    uen(Yin)
                ]));
            default:
                var e = n.a.oD, u = n.a.qc, a = n.a.qd, o = n.a.Q, c = !i(A2(Tu, function(n) {
                    return n.ic;
                }, u), Ct), f = A2(Qu, g, A2(Tu, function(n) {
                    return n.ic;
                }, u)), s = A2(Qu, g, A2(Tu, function(n) {
                    return n.dB;
                }, u)), l = A2(Pw, Ww(tl), A2(Ge, function(n) {
                    return d(n.mj, n.nW);
                }, e)), b = A2(Tu, function(n) {
                    return n.mj;
                }, Ra(A2(Bu, function(n) {
                    return i(n.oz, a.oz.sa) && i(n.mj, a.g9.sa);
                }, s))), m = Ra(A2(Bu, function(n) {
                    return i(n.mj, a.oz.sa);
                }, e)), p = A2(Tu, function(n) {
                    return n.mj;
                }, m), v = i(o, X4), h = (w = d(m, u)).a.$ || w.b.$ ? d(g, g) : A4(Mon, r, w.a.a, a, w.b.a), k = h.a, j = h.b;
                return wu(l) ? A2(Se, C([
                    nh("InvitationsForm")
                ]), C([
                    j7(non)
                ])) : Dt(A2(Bu, function(n) {
                    return !qe(n.a);
                }, k)) > 0 ? A2(Se, C([
                    nh("InvitationsForm")
                ]), C([
                    j7($(eon, A2(Qu, a.oz.sa, Ra(A2(Ge, function(n) {
                        return n.nW;
                    }, A2(Bu, function(n) {
                        return i(n.mj, a.oz.sa);
                    }, e))))))
                ])) : A2(tj, C([
                    aj(A4(Jin, t.g9, t.S.bF.mj, p, b))
                ]), $(C([
                    A2(Qu, ch(""), A2(Tu, ton, a.nE)),
                    A2(Qu, ch(""), A2(Tu, j7, a.nQ)),
                    A2(Sk, Zin, A2(nj, a.oz, l))
                ]), $(j, C([
                    A2(Se, C([
                        nh("DeliveryFormBanners")
                    ]), C([
                        function() {
                            switch(o.$){
                                case 2:
                                    return A2(Nq, _in, ch(o.a));
                                case 3:
                                    return LC(Gin);
                                default:
                                    return "AsSource" === a.lP.sa ? uen(Kin) : "" !== a.oz.sa && c && !Dt(f) ? j7(aon) : ch("");
                            }
                        }(),
                        v || "" === a.g9.sa ? Yan(uon) : ij(uon)
                    ]))
                ]))));
        }
        var w;
    }), Don = F3(function(n, r, t) {
        var e, u, a, o = (e = r.bT.f2).$ ? Ra(r.bT.ef) : kt(e.a);
        if (A2(WJ, (u = t).r8, u.g9.oz) || A3(ban, (a = u).r8, a.oz.mj, A2(Ge, function(n) {
            return n.fH;
        }, a.fJ)) && Bin(u.r8)) {
            if (o.$) return j7(Uin);
            var c = o.a;
            return A2(Se, C([
                fk("delivery")
            ]), C([
                Uq(C([
                    Kq(Pin),
                    A2(JT, !jan(t), Oen(C([
                        VW(p(AW, {
                            kO: i(n, R4),
                            mi: i(n, Qf) ? kt(fen) : kt($Q),
                            mD: !i(n, Qf),
                            m$: i(n, Qf) ? Hin : Win,
                            ol: kt(Iin)
                        }))
                    ])))
                ])),
                A3(qon, n, r, t),
                i(c.kE, g) ? uen(Vin) : A2(Se, C([
                    nh("DownloadsLinks")
                ]), Nin(c.kE))
            ]));
        }
        return ch("");
    }), Xon = {
        $: 6
    }, Eon = Pi({
        bQ: "Cancel",
        bX: "Annuler"
    }), Ron = Pi({
        bQ: "Invitations",
        bX: "Invitations"
    }), xon = Pi({
        bQ: "Invite",
        bX: "Inviter"
    }), Oon = Pi({
        bQ: "No invitations.",
        bX: "Aucune invitation."
    }), zon = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Non = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Hon = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Von = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Uon = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Jon = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Zon = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Kon = Pi({
        bQ: "Allow view",
        bX: "Autoriser \xe0 visionner"
    }), _on = Pi({
        bQ: "The files are archived at this time. Please unarchive before download or upload.",
        bX: "Les fichiers sont actuellement archiv\xe9s. Veuillez d\xe9sarchiver avant t\xe9l\xe9chargement ou upload."
    }), Gon = F2(function(n, r) {
        return A2(tj, C([
            aj(Zon(n.g9)),
            nh("InvitationsForm"),
            nh("DarkZone")
        ]), C([
            A2(Sk, zon, kk(r.k6)),
            A2(Sk, Non, Tnn(r.lq)),
            A2(Sk, Hon, WB(r.nE)),
            A2(Sk, Jon, A2(Aen, Kon, Ki(function(n) {
                return p(n, {
                    kO: !0,
                    mj: "checkbox-canView",
                    m$: Kon,
                    sa: !0
                });
            }))),
            A2(Sk, Uon, A2(Aen, cs, r.jy)),
            A2(Sk, Von, A2(Aen, is, r.jx)),
            A2(JT, YZ(n.g9) && (r.jx.sa || r.jy.sa), j7(_on)),
            jen(xon),
            A2(Qu, ch(""), A2(Tu, A2(Po, function(n) {
                return n.nE;
            }, AC), r.ll))
        ]));
    }), Yon = function(n) {
        return {
            $: 7,
            a: n
        };
    }, ncn = F2(function(n, r) {
        return BA(A2(Dp, n, r));
    }), rcn = function(n) {
        return A2(ncn, n, 1);
    }, tcn = function(n) {
        return A2(Se, C([
            nh(n ? "FullCube" : "EmptyCube")
        ]), g);
    }, ecn = F2(function(n, r) {
        var t;
        return A2(zk, g, C([
            A2(gC, g, C([
                tcn(!0)
            ])),
            A2(gC, g, C([
                tcn(r.fH.r$)
            ])),
            A2(gC, g, C([
                tcn(r.fH.cT)
            ])),
            A2(gC, C([
                nh("InvitationEmail"),
                HW(r.r8.k6)
            ]), C([
                ch(r.r8.k6),
                ch("   "),
                (t = r.fH.cY, t.$ ? ch("") : Ien(t.a))
            ])),
            function() {
                if (i(n.r8.oz, Ct)) return ch("");
                var t = r.fH.c9;
                n: for(; !t.$;)switch(t.a){
                    case 0:
                        return A2(gC, g, C([
                            A2(Se, C([
                                nh("InvitationSourceKind")
                            ]), C([
                                A2(qC, function(n) {
                                    return A2(hj, C([
                                        wj(rcn(n))
                                    ]), C([
                                        Sen
                                    ]));
                                }, r.fH.hj)
                            ]))
                        ]));
                    case 2:
                        return A2(gC, g, C([
                            A2(Se, C([
                                nh("InvitationSourceKind")
                            ]), C([
                                A2(qC, function(n) {
                                    return A2(hj, C([
                                        wj(rcn(n))
                                    ]), C([
                                        Fen
                                    ]));
                                }, r.fH.hj)
                            ]))
                        ]));
                    default:
                        break n;
                }
                return i(r.fH.qs, Ct) ? A2(gC, g, C([
                    A2(Se, C([
                        nh("InvitationSourceKind")
                    ]), C([
                        A2(qC, function(n) {
                            return A2(hj, C([
                                wj(rcn(n))
                            ]), C([
                                Ten
                            ]));
                        }, r.fH.hj)
                    ]))
                ])) : A2(WJ, n.r8, n.g9.oz) ? A2(gC, g, C([
                    A2(Se, C([
                        nh("InvitationDelete"),
                        Mh(Yon(r.fH))
                    ]), C([
                        Wh
                    ]))
                ])) : ch("");
            }()
        ]));
    }), ucn = F2(function(n, r) {
        return A2(Se, C([
            nh("InvitationsWrapper")
        ]), C([
            Uq(C([
                Kq(Ron),
                A2(WJ, n.r8, n.g9.oz) ? VW(p(AW, {
                    jM: Ct,
                    mi: kt(r.kQ ? $Q : fen),
                    mD: r.kQ,
                    m$: r.kQ ? Eon : xon,
                    ol: kt(Xon)
                })) : ch("")
            ])),
            r.kQ ? A2(Gon, n, r) : ch(""),
            wu(n.fJ) ? uen(Oon) : A2(Mk, C([
                nh("InvitationsTable")
            ]), A2(Ge, ecn(n), A2(xi, A2(Po, function(n) {
                return n.r8;
            }, function(n) {
                return n.k6;
            }), n.fJ)))
        ]));
    }), acn = Pi({
        bQ: "Client ID",
        bX: "Identifiant client"
    }), icn = Lf, ocn = F2(function(n, r) {
        return A2(Se, C([
            nh("JobsRow")
        ]), C([
            A2(ph, C([
                nh("JobsRowLabel")
            ]), C([
                ch(n)
            ])),
            A2(Se, C([
                nh("JobsRowContent")
            ]), C([
                ch(r)
            ]))
        ]));
    }), ccn = function(n) {
        return A2(Se, C([
            nh("JobsContent")
        ]), C([
            A2(ocn, "Type", icn(n.fO)),
            A2(ocn, acn, A2(Qu, "", n.lt))
        ]));
    }, fcn = Pi({
        bQ: "Job in progress",
        bX: "Travaux en cours"
    }), scn = Uq(C([
        Kq(fcn)
    ])), lcn = function(n) {
        return {
            $: 20,
            a: n
        };
    }, dcn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, bcn = {
        $: 34
    }, mcn = function(n) {
        return {
            $: 40,
            a: n
        };
    }, pcn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, vcn = function(n) {
        return {
            $: 38,
            a: n
        };
    }, $cn = function(n) {
        return {
            $: 17,
            a: n
        };
    }, gcn = F2(function(n, r) {
        return {
            $: 36,
            a: n,
            b: r
        };
    }), hcn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, kcn = function(n) {
        return {
            $: 22,
            a: n
        };
    }, Ccn = F2(function(n, r) {
        return {
            $: 15,
            a: n,
            b: r
        };
    }), jcn = Pi({
        bQ: "Archive show",
        bX: "Archiver le show"
    }), wcn = Pi({
        bQ: "Same as source",
        bX: "Comme la source"
    }), Acn = Pi({
        bQ: "Deliver all ad destinations",
        bX: "Livrer vers toutes les destinations ad"
    }), Lcn = Pi({
        bQ: "Mark as delivered",
        bX: "Marquer comme livr\xe9"
    }), ycn = ye("details"), Scn = ye("summary"), Fcn = F2(function(n, r) {
        return A2(ycn, C([
            nh("LayoutDetails")
        ]), C([
            A2(Scn, C([
                nh("LayoutDetailsHeader")
            ]), C([
                n
            ])),
            A2(Se, C([
                nh("LayoutDetailsContent")
            ]), r)
        ]));
    }), Tcn = Pi({
        bQ: "FTP Upload",
        bX: "Upload FTP"
    }), Qcn = function(n) {
        return 2 === n.hw;
    }, Icn = Pi({
        bQ: "Generate Segmentation",
        bX: "G\xe9n\xe9rer Segmentation"
    }), Bcn = Pi({
        bQ: "Silent",
        bX: "Silencieux"
    }), Wcn = Pi({
        bQ: "Dubbed version only",
        bX: "Version doubl\xe9e seulement"
    }), Pcn = Pi({
        bQ: "Dubbed version + audiodescription",
        bX: "Version doubl\xe9e + audiodescription"
    }), Mcn = Pi({
        bQ: "Dubbed version + Music & effect + international version + Voice Only",
        bX: "Version doubl\xe9e + Music & effect + version internationale + Voice Only"
    }), qcn = Pi({
        bQ: "Dubbed + International version + Voice Only",
        bX: "Version doubl\xe9e + internationale + Voice Only"
    }), Dcn = Pi({
        bQ: "Original version + dubbed version",
        bX: "Version originale + doubl\xe9e"
    }), Xcn = Pi({
        bQ: "Dubbed + original + audiodescription version",
        bX: "Version doubl\xe9e + originale + audiodescription"
    }), Ecn = Pi({
        bQ: "International version only",
        bX: "Version internationale seulement"
    }), Rcn = Pi({
        bQ: "International + Dubbed version",
        bX: "Version internationale + doubl\xe9e"
    }), xcn = Pi({
        bQ: "International + original version",
        bX: "Version internationale originale"
    }), Ocn = Pi({
        bQ: "Original version only",
        bX: "Version originale seulement"
    }), zcn = Pi({
        bQ: "Original version + audiodescription",
        bX: "Version originale + audiodescription"
    }), Ncn = Pi({
        bQ: "none",
        bX: "aucun"
    }), Hcn = Pi({
        bQ: "Reupload file",
        bX: "Reuploader le fichier"
    }), Vcn = Pi({
        bQ: "Retranscode proxy",
        bX: "Retranscoder le proxy"
    }), Ucn = Pi({
        bQ: "Restart verification",
        bX: "Relancer la v\xe9rification"
    }), Jcn = Pi({
        bQ: "Restoring the show, this can take up to 12h.",
        bX: "Restoration du show, cela peut prendre jusque 12h."
    }), Zcn = Pi({
        bQ: "S3 Upload",
        bX: "Upload S3"
    }), Kcn = Pi({
        bQ: "Saved audio mapping: ",
        bX: "Mapping Audio enregistr\xe9 : "
    }), _cn = Pi({
        bQ: "Select a rule",
        bX: "S\xe9lectionner une r\xe8gle"
    }), Gcn = Pi({
        bQ: "Admin Operations",
        bX: "Op\xe9rations Admin"
    }), Ycn = Pi({
        bQ: "Unarchive show",
        bX: "D\xe9sarchiver le show"
    }), nfn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, rfn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, tfn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, efn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, ufn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, afn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ifn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, ofn = C([
        d("Material", "Material"),
        d("Audio", "Audio"),
        d("Subtitle", "Subtitle"),
        d("Extra", "Extra")
    ]), cfn = Pi({
        bQ: "Start FTP Upload",
        bX: "Start FTP Upload"
    }), ffn = F2(function(n, r) {
        var t;
        return A2(tj, C([
            aj(nfn(n))
        ]), C([
            (t = r.ll, t.$ ? ch("") : A2(Ann, Snn, t.a)),
            A2(Se, C([
                nh("FTPCopyWrapper")
            ]), C([
                A2(Sk, afn, kk(r.mw)),
                A2(Sk, tfn, kk(r.mr)),
                A2(Sk, rfn, kk(r.mq)),
                A2(Sk, ufn, kk(r.mt)),
                A2(Sk, efn, kk(r.ms)),
                A2(Sk, ifn, A2(rj, r.p7, ofn))
            ])),
            ij(cfn)
        ]));
    }), sfn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, lfn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, dfn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, bfn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, mfn = Pi({
        bQ: "Send",
        bX: "Envoyer"
    }), pfn = F2(function(n, r) {
        return A2(tj, C([
            aj(sfn(n))
        ]), C([
            A2(Se, C([
                nh("S3CopyWrapper")
            ]), C([
                A2(Sk, lfn, kk(r.mu)),
                A2(Sk, dfn, kk(r.mv)),
                A2(Sk, bfn, A2(rj, r.p7, ofn))
            ])),
            ij(mfn)
        ]));
    }), vfn = function(n) {
        return {
            $: 9,
            a: n
        };
    }, $fn = function(n) {
        return {
            $: 13,
            a: n
        };
    }, gfn = Pi({
        bQ: "Ask new upload",
        bX: "Demander un nouvel upload"
    }), hfn = function(n) {
        return {
            $: 14,
            a: n
        };
    }, kfn = F2(function(n, r) {
        if (3 === n.$) {
            var t = n.a;
            return A2(Se, C([
                Mh(hfn(r))
            ]), C([
                A2(Ann, Snn, t)
            ]));
        }
        return ch("");
    }), Cfn = function(n) {
        switch(n.$){
            case 0:
                return A2(Se, C([
                    nh("OperationStatus"),
                    nh("OperationStatusNone")
                ]), g);
            case 1:
                return A2(Se, C([
                    nh("OperationStatus"),
                    nh("OperationStatusRunning")
                ]), g);
            case 2:
                return A2(Se, C([
                    nh("OperationStatus"),
                    nh("OperationStatusSuccess")
                ]), g);
            default:
                return A2(Se, C([
                    nh("OperationStatus"),
                    nh("OperationStatusFailure")
                ]), g);
        }
    }, jfn = F3(function(n, r, t) {
        return A2(Se, C([
            nh("Operation")
        ]), C([
            Cfn(n),
            A2(Se, C([
                nh("OperationContent")
            ]), A2(bt, A2(kfn, n, r), t))
        ]));
    }), wfn = F2(function(n, r) {
        return A3(jfn, r.kc, 3, C([
            A2(Sk, $fn, WB(r.kd)),
            A2(Znn, gfn, vfn(n.g9))
        ]));
    }), Afn = function(n) {
        return {
            $: 29,
            a: n
        };
    }, Lfn = F2(function(n, r) {
        return {
            $: 28,
            a: n,
            b: r
        };
    }), yfn = function(n) {
        return {
            $: 30,
            a: n
        };
    }, Sfn = {
        $: 25
    }, Ffn = F2(function(n, r) {
        return n.$ ? r : A2(bt, n.a, r);
    }), Tfn = A2(_e, Ffn, g), Qfn = function(n) {
        var r = F2(function(n, r) {
            return d(r.mj, n + " " + r.nW);
        }), t = Tfn(A2(Ge, A2(Po, function(n) {
            return n.bT;
        }, A2(Po, function(n) {
            return n.f2;
        }, Tu(A2(Po, function(n) {
            return n.lA;
        }, r("(active)"))))), A2(Qu, g, A2(Tu, function(n) {
            return n.bl;
        }, n.g9)))), e = A2(Qu, Ct, A2(Tu, A2(Po, function(n) {
            return n.S;
        }, A2(Po, function(n) {
            return n.bT;
        }, A2(Po, function(n) {
            return n.f2;
        }, Tu(A2(Po, function(n) {
            return n.lA;
        }, r("(active)")))))), n.g9));
        return $(g, A2(Ffn, e, t));
    }, Ifn = F2(function(n, r) {
        var t = n.b;
        if (t.$) return $(r, C([
            n.a
        ]));
        var e = t.a;
        return $(r, $(C([
            n.a
        ]), e));
    }), Bfn = function(n) {
        return {
            $: 26,
            a: n
        };
    }, Wfn = function(n) {
        return A2(Ng, "colspan", Bt(n));
    }, Pfn = F2(function(n, r) {
        return A2(hj, C([
            wj(n),
            nh("Button")
        ]), C([
            ch(r)
        ]));
    }), Mfn = function(n) {
        var r = "stream " + Bt(n.fB) + ": " + n.nW + " -> [" + Bt(n.ht) + "ms, " + Bt(n.e6) + "ms]";
        return A2(zk, g, C([
            A2(gC, g, C([
                ch(r)
            ]))
        ]));
    }, qfn = function(n) {
        return A2(zk, g, C([
            A2(gC, g, C([
                ch(n.fR + ": " + n.sa)
            ]))
        ]));
    }, Dfn = F2(function(n, r) {
        if (n) {
            var t = A2(Ge, Mfn, r.bn);
            return kt(C([
                A2(zk, g, C([
                    A2(gC, C([
                        Wfn(4)
                    ]), C([
                        ch("Configurations")
                    ]))
                ])),
                A2(zk, g, C([
                    A2(gC, C([
                        Wfn(4)
                    ]), C([
                        A2(Mk, g, A2(Ge, qfn, r.eL))
                    ]))
                ])),
                A2(zk, g, C([
                    A2(gC, C([
                        Wfn(4)
                    ]), C([
                        ch("Results")
                    ]))
                ])),
                A2(zk, g, C([
                    A2(gC, C([
                        Wfn(4)
                    ]), C([
                        wu(t) ? i(r.j_, Ct) ? ch("") : ch("nothing reported") : A2(Mk, g, t)
                    ]))
                ])),
                A2(zk, g, C([
                    A2(gC, C([
                        Wfn(4),
                        nh("ProbeLog")
                    ]), C([
                        A2(Pfn, r.f_, "LOGS"),
                        A2(Qu, ch("Currently running"), A2(Tu, function() {
                            return ch("Completed ");
                        }, r.j_)),
                        A2(Qu, ch(""), A2(Tu, UA, r.j_))
                    ]))
                ]))
            ]));
        }
        return Ct;
    }), Xfn = function(n) {
        var r = n.a, t = n.b;
        return d(A2(zk, g, C([
            A2(gC, C([
                Mh(Bfn(t.mj)),
                nh("ProbeItem")
            ]), C([
                ch(r ? "\u25BC" : "\u25B6")
            ])),
            A2(gC, g, C([
                UA(t.ku)
            ])),
            A2(gC, g, C([
                ch(t.rw)
            ])),
            A2(gC, g, C([
                ch(t.lA)
            ]))
        ])), A2(Dfn, r, t));
    }, Efn = function(n) {
        return wu(n.ds) ? ch("No probes on show...") : A2(Mk, C([
            nh("DeepProbeTable")
        ]), A2(bt, A2(zk, g, C([
            A2(gC, g, C([
                ch("")
            ])),
            A2(gC, g, C([
                ch("Date")
            ])),
            A2(gC, g, C([
                ch("Template")
            ])),
            A2(gC, g, C([
                ch("File")
            ]))
        ])), A3(qt, Ifn, g, A2(Ge, Xfn, n.ds))));
    }, Rfn = function(n) {
        var r = A2(Ge, function(n) {
            return d(n.mj, n.nW);
        }, n.o3);
        return A2(Se, C([
            nh("Operation")
        ]), C([
            Cfn(n.o2),
            A2(Se, C([
                nh("OperationContent")
            ]), C([
                A2(Sk, Afn, A2(nj, n.kz, r)),
                A2(Sk, yfn, A2(nj, n.qp, Qfn(n))),
                qe(n.qp.sa) > 0 && qe(n.kz.sa) > 0 ? A2(Znn, "Launch Deep Probe", A2(Lfn, n.qp.sa, n.kz.sa)) : ch(""),
                A3(lj, n.l5 ? "Show Probes" : "Hide Probes", C([
                    d("align-self", "flex-end"),
                    d("position", "relative"),
                    d("top", "10px"),
                    d("margin", "0 0 10px 0")
                ]), Sfn),
                n.l5 ? ch("") : Efn(n)
            ]))
        ]));
    }, xfn = Pi({
        bQ: "Video archived",
        bX: "Fichier vid\xe9o archiv\xe9"
    }), Ofn = Pi({
        bQ: "Vid\xe9o file required",
        bX: "Fichier vid\xe9o requis"
    }), zfn = F2(function(n, r) {
        var t = n.bT.f2;
        if (1 === t.$) return A3(jfn, gs, 5, C([
            ch(Ofn)
        ]));
        var e = t.a;
        return YZ(e.lA) ? A3(jfn, gs, 5, C([
            ch(xfn)
        ])) : r(e.lA);
    }), Nfn = Pi({
        bQ: "Proxy required",
        bX: "Proxy requis"
    }), Hfn = F2(function(n, r) {
        var t = d(n.bT.f2, A2(Lp, A2(Po, function(n) {
            return n.o7;
        }, function(n) {
            return n.nm;
        }), n.bT.f2));
        if (1 === t.a.$) return A3(jfn, gs, 5, C([
            ch(Ofn)
        ]));
        if (1 === t.b.$) return A3(jfn, gs, 5, C([
            ch(Nfn)
        ]));
        var e = t.b.a;
        return YZ(t.a.a.lA) ? A3(jfn, gs, 5, C([
            ch(xfn)
        ])) : r(e);
    }), Vfn = F2(function(n, r) {
        if (1 === r.$) return ch("");
        var t = r.a;
        return A2(Se, C([
            nh("Operation")
        ]), C([
            Cfn(gs),
            A2(Se, C([
                nh("OperationContent")
            ]), C([
                A2(Pfn, t, n)
            ]))
        ]));
    }), Ufn = F4(function(n, r, t, e) {
        return A3(jfn, r, t, C([
            A2(Znn, n, e)
        ]));
    }), Jfn = F2(function(n, r) {
        return A2(Se, C([
            nh("Operation")
        ]), C([
            Cfn(gs),
            A2(Se, C([
                nh("OperationContent"),
                nh("PlayerSettings")
            ]), C([
                A2(Se, g, C([
                    ch(A2(Qu, "", n.km))
                ])),
                A2(hj, C([
                    wj("/neoplayer/" + r),
                    nh("Button"),
                    uQ("_blank"),
                    A2(ZW, "data-prevent-history", "true")
                ]), C([
                    ch("Neo Player")
                ]))
            ]))
        ]));
    }), Zfn = F3(function(n, r, t) {
        var e;
        return Gtn(n.r8) ? A2(Se, C([
            nh("Operations")
        ]), C([
            A2(_h, C([
                nh("OperationsHeader")
            ]), Gcn),
            A2(Fcn, Kq(Zcn), C([
                A2(Sk, t8, A2(pfn, r.bF, t.pI))
            ])),
            A2(Fcn, Kq(Tcn), C([
                A2(Sk, K9, A2(ffn, r.bF, t.lX))
            ])),
            A4(Ufn, Acn, t.kD, 9, dcn(r.bF)),
            A2(zfn, r, function(n) {
                return A4(Ufn, Ucn, t.pv, 0, function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                }(n));
            }),
            A2(zfn, r, function(n) {
                return A4(Ufn, Vcn, t.pt, 1, function(n) {
                    return {
                        $: 2,
                        a: n
                    };
                }(n));
            }),
            (e = wu(n.cJ) ? ch("") : A2(Sk, pcn, A2(rj, t.bG, A2(Ge, function(n) {
                return d(n.sa, n.sa);
            }, n.cJ))), A3(jfn, t.pu, 2, C([
                e,
                A2(Znn, Hcn, hcn(r.bF))
            ]))),
            A2(wfn, n, t),
            A2(Hfn, r, function(n) {
                return A2(Vfn, "proxy log", A2(Lp, function(n) {
                    return n.f_;
                }, n.rN));
            }),
            A2(zfn, r, function(n) {
                return A2(Vfn, "transcode log", A2(Lp, function(n) {
                    return n.f_;
                }, n.rN));
            }),
            A2(Vfn, "upload log", r.bF.h9),
            A2(zfn, r, function() {
                var n, e = C([
                    d(Cm(fm), Wcn),
                    d(Cm(gm), Ocn),
                    d(Cm(pm), Ecn),
                    d(Cm(bm), Dcn),
                    d(Cm(hm), zcn),
                    d(Cm(sm), Pcn),
                    d(Cm(vm), Rcn),
                    d(Cm($m), xcn),
                    d(Cm(mm), Xcn),
                    d(Cm(dm), qcn),
                    d(Cm(lm), Mcn),
                    d(Cm(cm), Bcn),
                    d(Cm(om), wcn)
                ]), u = (n = r.bF.fp).$ ? Ncn : Cm(n.a);
                return A3(jfn, t.rZ, 4, C([
                    A2(Sk, $cn, A2(nj, t.i4, e)),
                    A2(Znn, "update audio mapping", A2(Ccn, r.bF, t.i4)),
                    A2(Se, g, C([
                        ch($(Kcn, u))
                    ]))
                ]));
            }),
            A2(zfn, r, function(n) {
                return A4(Ufn, Lcn, t.kC, 6, function(n) {
                    return {
                        $: 18,
                        a: n
                    };
                }(n));
            }),
            Qcn(n.g9) ? A3(jfn, gs, 5, C([
                ch(Jcn)
            ])) : YZ(n.g9) ? A4(Ufn, Ycn, t.ea, 7, kcn(n.g9)) : A4(Ufn, jcn, t.ea, 7, lcn(n.g9)),
            A2(Hfn, r, function() {
                return A2(Jfn, t, n.g9.mj);
            }),
            A2(zfn, r, function() {
                return t.l6 ? A2(Se, C([
                    nh("Operation")
                ]), C([
                    Cfn(gs),
                    A2(Se, C([
                        nh("OperationContent"),
                        nh("PlayerSettings")
                    ]), C([
                        A2(Se, g, C([
                            ch("Segmentation")
                        ])),
                        A2(Znn, _cn, mcn(n.oz.mj))
                    ]))
                ])) : A3(jfn, t.iM, 8, C([
                    A2(Sk, vcn, A2(nj, t.p3, A2(Ge, function(n) {
                        return d(n.mj, n.nW);
                    }, t.dy))),
                    A2(Znn, Icn, A2(gcn, r.bF.mj, t.p3.sa))
                ]));
            }),
            t.l4 ? A2(Se, C([
                nh("Operation")
            ]), C([
                Cfn(gs),
                A2(Se, C([
                    nh("OperationContent"),
                    nh("PlayerSettings")
                ]), C([
                    A2(Se, g, C([
                        ch("Deep Probe")
                    ])),
                    A2(Znn, "Show", bcn)
                ]))
            ])) : Rfn(t)
        ])) : ch("");
    }), Kfn = {
        $: 1
    }, _fn = function(n) {
        return xs(Rq(A2(IR, n, 1)));
    }, Gfn = function(n) {
        return s(n, 1073741824) > -1 ? Bt(re(n / 1073741824)) + " GB" : s(n, 1048576) > -1 ? Bt(re(n / 1048576)) + " MB" : 1024 > n ? n > 1 ? Bt(n) + " bytes" : 1 === n ? Bt(n) + " byte" : "0 bytes" : Bt(re(n / 1024)) + " KB";
    }, Yfn = Pi({
        bQ: "SFTP access",
        bX: "Acc\xe8s SFTP"
    }), nsn = function(n) {
        switch(n.$){
            case 0:
                switch(n.a){
                    case 0:
                        return "MXF (Material eXchange Format)";
                    case 1:
                        return "QuickTime File Format";
                    default:
                        return "Fichier vid\xe9o MP4";
                }
            case 1:
                return "Fichier de sous-titres";
            default:
                return "Fichier audio MP3";
        }
    }, rsn = {
        $: 1
    }, tsn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, esn = C([
        {
            E: ".mxf",
            F: tsn(0),
            nH: "application/mxf"
        },
        {
            E: ".mov",
            F: tsn(1),
            nH: "video/quicktime"
        },
        {
            E: ".mp4",
            F: tsn(2),
            nH: "video/mp4"
        },
        {
            E: ".mp3",
            F: {
                $: 2,
                a: 0
            },
            nH: "audio/mp3"
        },
        {
            E: ".srt",
            F: rsn,
            nH: "application/x-subrip"
        },
        {
            E: ".ass",
            F: rsn,
            nH: "application/x-ass"
        },
        {
            E: ".stl",
            F: rsn,
            nH: "text/subtitle"
        },
        {
            E: ".vtt",
            F: rsn,
            nH: "text/vtt"
        },
        {
            E: ".scc",
            F: rsn,
            nH: "text/scc"
        }
    ]), usn = F2(function(n, r) {
        return A2(yJ, n, zi(r.nW));
    }), asn = F2(function(n, r) {
        return A2(Qu, !1, A2(Tu, function(r) {
            return i(r, n);
        }, r.nH));
    }), isn = function(n) {
        return A2(Tu, function(n) {
            return n.F;
        }, Ra(A2(Bu, function(r) {
            return A2(asn, r.nH, n) || A2(usn, r.E, n);
        }, esn)));
    }, osn = F2(function(n, r) {
        if (function(n) {
            return A2(bu, function(r) {
                var t = r.fH;
                return i(r.r8.mj, n.r8.mj) && t.cT;
            }, n.fJ);
        }(n) && !i(n.S.bT.f2, Ct)) {
            var t = function(n) {
                var r = n.f2;
                return 1 === r.$ ? g : $(C([
                    r.a
                ]), $(n.ef, n.ae));
            }(n.S.bT), e = "" === r.fH ? A2(Qu, Kfn, A2(Tu, function(n) {
                return j_(n);
            }, function(n) {
                return A2(Tu, function(n) {
                    return n.mj;
                }, function(n) {
                    return Ra(A2(nc, function(r) {
                        var t = r.fH;
                        return i(r.r8.mj, n.r8.mj) ? kt(t) : Ct;
                    }, n.fJ));
                }(n));
            }(n))) : Kfn;
            return A2(Se, g, C([
                Uq(C([
                    Kq(cun),
                    Oen(C([
                        VW(p(AW, {
                            mi: kt(r.gn ? $Q : fen),
                            mD: r.gn,
                            m$: Yfn,
                            ol: kt(e)
                        }))
                    ]))
                ])),
                A2(JT, r.gn, A2(Se, C([
                    nh("InvitationsForm")
                ]), Cun(r))),
                (u = A2(Ge, function(n) {
                    var r;
                    return {
                        eZ: A2(Wt, " - ", C([
                            (r = isn(n.lA), 1 === r.$ ? "" : nsn(r.a) + " - "),
                            Gfn(n.lA.qy)
                        ])),
                        mi: Ten,
                        rB: n.lA.nW,
                        r6: Hs(_fn(n.lA.mj))
                    };
                }, t), A2(Se, C([
                    nh("DownloadsLinks")
                ]), A2(Ge, function(n) {
                    var r;
                    return A2(hj, C([
                        wj(n.r6),
                        nh("DownloadsLinksItem"),
                        (r = n.rB, A2(Yg, "download", r)),
                        A2(ZW, "data-prevent-history", "true"),
                        HW(n.rB)
                    ]), C([
                        A2(ph, C([
                            nh("DownloadsLinksItemIcon")
                        ]), C([
                            n.mi
                        ])),
                        A2(ph, C([
                            nh("DownloadsLinksItemWrapper")
                        ]), C([
                            A2(ph, C([
                                nh("DownloadsLinksItemName")
                            ]), C([
                                ch(n.rB)
                            ])),
                            A2(ph, C([
                                nh("DownloadsLinksItemDetails")
                            ]), C([
                                ch(n.eZ)
                            ]))
                        ]))
                    ]));
                }, u)))
            ]));
        }
        var u;
        return ch("");
    }), csn = F2(function(n, r) {
        var t, e, u = !jan(n), a = A2(Can, wan(n), r);
        return C([
            A2(Sk, h1, A3(Don, r.kF, a, n)),
            A2(Sk, b1, A3(hin, n, a, r.ik)),
            A2(JT, u, A2(Sk, k1, A2(osn, n, r.cT))),
            A2(Sk, y1, A2(ucn, n, r.fJ)),
            A2(Sk, kan, (t = n, e = A2(Bu, function(n) {
                return 1 === n.j_.$;
            }, t.c7), wu(e) ? ch("") : A2(Se, C([
                nh("JobsWrapper")
            ]), A2(bt, scn, A2(Ge, ccn, e))))),
            A2(Sk, p1, A2(oun, r.ea, {
                mj: n.g9.mj,
                mE: n.r8.iz,
                mN: !0,
                hw: n.g9.hw,
                h6: n.g9.h6
            })),
            A2(Sk, v1, A3(Qin, n, a, r.i9)),
            A2(Sk, GV, A3(Zfn, n, a, r.ow))
        ]);
    }), fsn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ssn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, lsn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, dsn = F4(function(n, r, t, e) {
        return {
            T: C([
                {
                    c2: 3,
                    sc: A2(U0, {
                        e_: e,
                        lS: t,
                        sa: n.bd
                    }, {
                        e_: e,
                        lS: t,
                        sa: n.be
                    })
                }
            ]),
            d9: g,
            bF: r,
            ke: n.ke,
            bM: n.bM,
            bY: Ct,
            mj: lsn(n.mj),
            nE: v0(n.m$),
            cu: n.ke,
            cv: n.bM.mj
        };
    }), bsn = function(n) {
        return A2(Tu, e0, Ra(A2(xi, function(n) {
            return n.fB;
        }, A2(nc, _1, n.aw))));
    }, msn = F3(function(n, r, t) {
        var e = A2(Lp, bsn, r.bT.f2), u = A2(Gu, function(n) {
            return 1 === e.$ ? g : C([
                A4(dsn, n, r.bF.mj, e.a, !1)
            ]);
        }, A2(Qu, g, A2(Tu, function(n) {
            return n.g3;
        }, r.bT.f2))), a = A2(Ge, function(n) {
            return {
                ed: aY(n),
                mQ: ssn(n)
            };
        }, t), i = A2(Ge, function(n) {
            return {
                ed: n.ke,
                mQ: fsn(n)
            };
        }, $(r.bL, u));
        return A2(Pw, F2(function(n, r) {
            return A2(X9, n.ed, r.ed) ? 0 : 2;
        }), A2(Su, i, a));
    }), psn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, vsn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, $sn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, gsn = Pi({
        bQ: "Add timecode",
        bX: "Ajouter un timecode"
    }), hsn = A2(ph, C([
        nh("TimecodeSep")
    ]), C([
        ch(":")
    ])), ksn = A2(Po, Bt, A2(ib, 2, "0")), Csn = function(n) {
        switch(n){
            case 0:
                return "TimecodeHH";
            case 1:
                return "TimecodeMM";
            case 2:
                return "TimecodeSS";
            default:
                return "TimecodeFF";
        }
    }, jsn = F2(function(n, r) {
        var t = function() {
            switch(n){
                case 0:
                    return A2(Po, xc, ksn)(r.mf);
                case 1:
                    return A2(Po, xc, ksn)(r.nP);
                case 2:
                    return A2(Po, xc, ksn)(r.p$);
                default:
                    return ksn(r.fo);
            }
        }();
        return A2(Se, C([
            nh("TimecodeUnit"),
            nh(Csn(n))
        ]), C([
            ch(t)
        ]));
    }), wsn = function(n) {
        return A2(Se, C([
            nh("TimecodeWrapper")
        ]), C([
            A2(jsn, 0, n),
            hsn,
            A2(jsn, 1, n),
            hsn,
            A2(jsn, 2, n),
            hsn,
            A2(jsn, 3, n)
        ]));
    }, Asn = F2(function(n, r) {
        var t;
        return A2(tj, C([
            aj(vsn(n.bF)),
            nh("ActivityCommentForm"),
            nh("DarkZone")
        ]), C([
            A2(Se, C([
                nh("ActivityCommentFormMessage")
            ]), C([
                A2(Sk, $sn, WB(r.nE))
            ])),
            A2(Se, C([
                nh("ActivityCommentFormSubmit")
            ]), C([
                A2(Se, C([
                    nh("ActivityCommentTimecode")
                ]), C([
                    A2(Sk, psn, xC(r.hZ)),
                    (t = r.kp, t.$ ? A2(_h, C([
                        nh("ActivityCommentTimecodeLabel")
                    ]), gsn) : wsn(A2(P1, r.qO, t.a)))
                ])),
                ij(bf)
            ]))
        ]));
    }), Lsn = function(n) {
        return {
            $: 35,
            a: n
        };
    }, ysn = {
        $: 3
    }, Ssn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Fsn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Tsn = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), Qsn = Ng("list"), Isn = function(n) {
        return A2(Yh, n, A2(rk, C([
            nh("InputTextarea"),
            sk(n.kT),
            $k(zh),
            bk(Nh),
            mk(Hh),
            hk(n.sa),
            gk(n.gy),
            Qsn(A2(Qu, "", n.jb)),
            Vh(!1),
            qh("search"),
            tk(ck(n.m$)),
            nk(n.kO),
            n.eg ? Jh(!0) : Zh(g)
        ]), g));
    }, Bsn = Pi({
        bQ: "...End timecode",
        bX: "...Timecode de fin"
    }), Wsn = Pi({
        bQ: "Examples...",
        bX: "Examples..."
    }), Psn = function(n) {
        switch(n){
            case 1:
                return "OrangeFlag";
            case 0:
                return "RedFlag";
            default:
                return "BlueFlag";
        }
    }, Msn = F2(function(n, r) {
        return A4(d3, n.lS, n.sa, r.qO, n.e_);
    }), qsn = A2(Qh, C([
        Ah("16px"),
        Bh("16px"),
        Ih("0 0 16 16"),
        Vg("IconDelete")
    ]), C([
        A2(Cj, C([
            Vg("Fg"),
            kj("M12 3H4V13H12V11H8V5H12V3Z")
        ]), g)
    ])), Dsn = A2(Qh, C([
        Ah("16px"),
        Bh("16px"),
        Ih("0 0 16 16"),
        Vg("IconDelete")
    ]), C([
        A2(Cj, C([
            Vg("Fg"),
            kj("M4 3H12V13H4V11H8V5H4V3Z")
        ]), g)
    ])), Xsn = ye("optgroup"), Esn = Pi({
        bQ: "Publish",
        bX: "Publier"
    }), Rsn = Pi({
        bQ: "Verification Report",
        bX: "Rapport de v\xe9rification"
    }), xsn = Pi({
        bQ: "Verification: reason",
        bX: "V\xe9rification: motif"
    }), Osn = A2(Qh, C([
        Ah("16px"),
        Bh("16px"),
        Ih("0 0 16 16"),
        Vg("IconDelete")
    ]), C([
        A2(Cj, C([
            Vg("Fg"),
            kj("M11.3982 3.21591L13.6357 3.8496L10.4672 15.037L8.22975 14.4033L11.3982 3.21591Z")
        ]), g),
        A2(Cj, C([
            Vg("Fg"),
            kj("M8.37838 9.61152L10.2794 2.89907L2.61646 4.35424L8.37838 9.61152Z")
        ]), g)
    ])), zsn = F2(function(n, r) {
        var t = function(t) {
            return A2(Se, C([
                nh(Psn(t)),
                nh("ActivityVerificationFlag"),
                Zh(C([
                    d("ActivityVerificationFlagSelected", i(t, r))
                ])),
                Mh(n(t))
            ]), C([
                Osn
            ]));
        };
        return A2(Se, C([
            nh("ActivityVerificationFlagSelect")
        ]), C([
            t(3),
            t(1),
            t(0)
        ]));
    }), Nsn = F2(function(n, r) {
        var t = n.bT.f2;
        return 1 === t.$ ? ch("") : A2(tj, C([
            aj(A2(Tsn, n.bF, t.a.lA)),
            nh("ActivityCommentForm"),
            nh("DarkZone"),
            nh(Psn(r.iP.c2))
        ]), C([
            A2(ph, C([
                nh("ActivityTitle")
            ]), C([
                ch(Rsn)
            ])),
            A2(Se, C([
                nh("ActivityCommentVerifHeader")
            ]), C([
                3 === r.iP.c2 ? A2(Sk, Lsn, fQ(r.p2)) : A2(Sk, $sn, Isn(p(r.nE, {
                    jb: kt("VerificationMotifs"),
                    gy: xsn
                }))),
                A2(zsn, Ssn, r.iP.c2)
            ])),
            A3(ye, "datalist", C([
                fk("VerificationMotifs")
            ]), C([
                A2(Xsn, C([
                    A2(ZW, "label", Wsn)
                ]), A2(Ge, function(n) {
                    return A2(KC, g, C([
                        ch(n)
                    ]));
                }, A2(Ge, tl, wf)))
            ])),
            A2(Se, C([
                nh("ActivityCommentVerif")
            ]), C([
                function() {
                    var n = r.iP.sc;
                    switch(n.$){
                        case 0:
                            return A2(Se, C([
                                nh("ActivityCommentVerifTc")
                            ]), C([
                                A2(IB, qsn, Fsn(0)),
                                A2(_h, C([
                                    nh("ActivityCommentVerifLabel")
                                ]), gsn)
                            ]));
                        case 1:
                            var t = n.a;
                            return A2(Se, C([
                                nh("ActivityCommentVerifTc")
                            ]), C([
                                A2(IB, qsn, Fsn(0)),
                                wsn(A2(Msn, t, r)),
                                A2(IB, Dsn, Fsn(1)),
                                A2(_h, C([
                                    nh("ActivityCommentVerifLabel")
                                ]), Bsn),
                                A2(IB, Wh, ysn)
                            ]));
                        default:
                            t = n.a;
                            var e = n.b;
                            return A2(Se, C([
                                nh("ActivityCommentVerifTc")
                            ]), C([
                                A2(IB, qsn, Fsn(0)),
                                wsn(A2(Msn, t, r)),
                                A2(IB, Dsn, Fsn(1)),
                                wsn(A2(Msn, e, r)),
                                A2(IB, Wh, ysn)
                            ]));
                    }
                }()
            ])),
            A2(Se, C([
                nh("ActivityCommentFormSubmit")
            ]), C([
                ij(Esn)
            ]))
        ]));
    }), Hsn = function(n) {
        return !i(n.T, g);
    }, Vsn = function(n) {
        var r = n.mQ;
        if (r.$) return 0;
        var t = r.a;
        return Hsn(t) ? A2(Qu, 0, A2(Tu, function(n) {
            var r = n.sc;
            switch(r.$){
                case 1:
                case 2:
                    return r.a.sa;
                default:
                    return 0;
            }
        }, Ra(t.T))) : 0;
    }, Usn = F2(function(n, r) {
        return 4 === n.iY ? A2(xi, Vsn, A2(Bu, function(n) {
            var r = n.mQ;
            return !r.$ && Hsn(r.a);
        }, r)) : r;
    }), Jsn = function(n) {
        switch(n){
            case 0:
                return "Neutral";
            case 1:
                return "Good";
            case 2:
                return "Bad";
            default:
                return "Warn";
        }
    }, Zsn = F3(function(n, r, t) {
        var e = function() {
            switch(t.$){
                case 2:
                    return A2(mg, t.a.dS, C([
                        4,
                        5,
                        6
                    ]));
                case 14:
                    return A2(mg, t.a.cy, C([
                        1
                    ]));
                default:
                    return !1;
            }
        }(), u = aY(t), a = A2(X9, r, u), i = function() {
            switch(t.$){
                case 4:
                    switch((r = t.a).c9){
                        case 0:
                            return d(0, A2(Tun, n, r.dC));
                        case 1:
                            return d(1, A2(Tun, n, r.dC));
                        default:
                            return d(2, A2(Tun, n, r.dC));
                    }
                case 3:
                    return d(0, A2(Tun, n, (r = t.a).dC));
                case 0:
                    var r = t.a;
                    return d(function() {
                        if (1 === r.ll.$) {
                            var n = r.bn;
                            if (n.$) return 0;
                            var t = n.a;
                            return t.nY > 0 ? 2 : t.ar > 0 ? 3 : 1;
                        }
                        return 2;
                    }(), Qun);
                case 2:
                    return d(1 === (r = t.a).c9 ? 1 === r.ll.$ ? r.di ? 3 : 1 : 2 : 0, Qun);
                case 5:
                    return d((r = t.a).c9 ? 1 === r.ll.$ ? 1 : 2 : 0, Qun);
                case 14:
                    return d(1 === (r = t.a).c9 ? 1 === r.ll.$ ? 1 : 2 : 0, Qun);
                default:
                    return d(0, Qun);
            }
        }(), o = i.a, c = i.b;
        return e ? ch("") : A2(Se, C([
            nh("EventsItem"),
            nh(Jsn(o)),
            Zh(C([
                d("EventsItemArchived", a)
            ]))
        ]), C([
            A2(Se, C([
                nh("EventsItemIcon")
            ]), C([
                c
            ])),
            A2(Se, C([
                nh("EventsItemBody")
            ]), C([
                A2(_h, C([
                    nh("EventsItemLabel")
                ]), eY(t)),
                ch(eb(bh(160))),
                A2(ph, C([
                    nh("EventsItemDate")
                ]), C([
                    UA(u)
                ]))
            ]))
        ]));
    }), Ksn = function(n) {
        return {
            $: 17,
            a: n
        };
    }, _sn = function(n) {
        return {
            $: 21,
            a: n
        };
    }, Gsn = function(n) {
        return {
            $: 32,
            a: n
        };
    }, Ysn = function(n) {
        return {
            $: 16,
            a: n
        };
    }, nln = function(n) {
        return A2(Se, C([
            nh("TimecodeDarker")
        ]), C([
            wsn(n)
        ]));
    }, rln = irn(C([
        A2(Cj, C([
            Vg("Fg"),
            kj("M5,11 L7,13 L6,14 L4,14 L4,12 L5,11 Z M12,4 L14,6 L8,12 L6,10 L12,4 Z")
        ]), g)
    ])), tln = F2(function(n, r) {
        return A2(Se, C([
            nh("ButtonMiniIcon"),
            Mh(r)
        ]), C([
            n
        ]));
    }), eln = Pi({
        bQ: ", modified",
        bX: ", modifi\xe9"
    }), uln = ch(eb(bh(160))), aln = F2(function(n, r) {
        return A2(ph, C([
            nh(n)
        ]), C([
            UA(r)
        ]));
    }), iln = function(n) {
        return A2(Pw, F2(function(n, r) {
            return A2(X9, n.ke, r.ke) ? 2 : 0;
        }), n);
    }, oln = function(n) {
        return {
            $: 27,
            a: n
        };
    }, cln = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), fln = Pi({
        bQ: "Save",
        bX: "Sauvegarder"
    }), sln = F3(function(n, r, t) {
        return A2(tj, C([
            aj(n),
            nh("ActivityCommentEditForm")
        ]), C([
            A2(Sk, cln(r), kk(t)),
            A2(Se, C([
                nh("ActivityCommentHideSubmit")
            ]), C([
                ij(fln)
            ]))
        ]));
    }), lln = F3(function(n, r, t) {
        return A2(Se, C([
            nh("ActivityAnswer")
        ]), C([
            A2(Tun, n.r8, t.bM),
            A2(Se, C([
                nh("ActivityCommentContent")
            ]), C([
                A2(Se, C([
                    nh("ActivityCommentHeader")
                ]), C([
                    A2(_h, C([
                        nh("ActivityCommentAuthor")
                    ]), "" === t.bM.nW ? t.bM.k6 : t.bM.nW),
                    uln,
                    A2(aln, "ActivityCommentDate", t.ke),
                    uln,
                    i(t.ke, t.cu) ? ch("") : ch(eln),
                    A2(Se, C([
                        nh("ActivityCommentActions")
                    ]), C([
                        i(t.bM.mj, n.r8.mj) ? A2(NJ, t.mj, r.k3) ? A2(tln, $Q, Ksn(t.mj)) : A2(tln, rln, Ysn({
                            mj: t.mj,
                            nE: t.nE
                        })) : ch("")
                    ])),
                    A2(Se, C([
                        nh("ActivityCommentDelete")
                    ]), C([
                        i(t.bM.mj, n.r8.mj) ? A2(tln, $Q, oln(t)) : ch("")
                    ]))
                ])),
                function() {
                    var n = A2(Lo, t.mj, r.k3);
                    if (1 === n.$) return A2(_h, C([
                        nh("ActivityAnswerMessage")
                    ]), t.nE);
                    var e = n.a;
                    return A3(sln, function(n) {
                        return {
                            $: 25,
                            a: n
                        };
                    }(t), t.mj, e);
                }()
            ]))
        ]));
    }), dln = function(n) {
        return {
            $: 23,
            a: n
        };
    }, bln = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), mln = F4(function(n, r, t, e) {
        return A2(tj, C([
            aj(dln(e)),
            nh("ActivityAnswerForm")
        ]), C([
            A2(Tun, n.r8, n.r8),
            A2(Sk, bln(b6(e.mj)), kk(A2(Qu, i4, A2(Lo, b6(e.mj), t.d9)))),
            A2(Se, C([
                nh("ActivityCommentHideSubmit")
            ]), C([
                ij(a4)
            ]))
        ]));
    }), pln = F4(function(n, r, t, e) {
        return A2(Se, C([
            nh("ActivityItem"),
            nh("ActivityComment")
        ]), C([
            A2(Tun, n.r8, e.bM),
            A2(Se, C([
                nh("ActivityCommentContent")
            ]), C([
                A2(Se, C([
                    nh("ActivityCommentHeader")
                ]), C([
                    A2(_h, C([
                        nh("ActivityCommentAuthor")
                    ]), "" === e.bM.nW ? e.bM.k6 : e.bM.nW),
                    uln,
                    A2(aln, "ActivityCommentDate", e.ke),
                    uln,
                    i(e.ke, e.cu) ? ch("") : ch(eln),
                    A2(_h, C([
                        nh("ActivityCommentSpacer")
                    ]), ""),
                    A2(Se, C([
                        nh("ActivityCommentActions")
                    ]), C([
                        i(e.bM.mj, n.r8.mj) ? A2(NJ, b6(e.mj), t.k3) ? A2(tln, $Q, Ksn(b6(e.mj))) : A2(tln, rln, Ysn({
                            mj: b6(e.mj),
                            nE: e.nE
                        })) : ch("")
                    ])),
                    A2(Se, C([
                        nh("ActivityCommentDelete")
                    ]), C([
                        i(e.bM.mj, n.r8.mj) ? A2(tln, $Q, _sn(e)) : ch("")
                    ]))
                ])),
                function() {
                    var n = A2(Lo, b6(e.mj), t.k3);
                    if (1 === n.$) return A2(Se, C([
                        nh("ActivityCommentWrap")
                    ]), C([
                        A2(_h, C([
                            nh("ActivityCommentMessage")
                        ]), e.nE),
                        A2(qC, function(n) {
                            var r = n.sa, e = n.lS, u = n.e_;
                            return A2(Se, C([
                                nh("ActivityCommentTimecode")
                            ]), C([
                                A2(IB, Bun, Gsn(r)),
                                nln(A4(d3, e, r, t.qO, u))
                            ]));
                        }, e.bY)
                    ]));
                    var r = n.a;
                    return A3(sln, function(n) {
                        return {
                            $: 18,
                            a: n
                        };
                    }(e), b6(e.mj), r);
                }(),
                A2(Se, C([
                    nh("ActivityAnswers")
                ]), A2(Ge, A2(lln, n, t), iln(e.d9))),
                A4(mln, n, r, t, e)
            ]))
        ]));
    }), vln = function(n) {
        switch(n){
            case "openingCredits":
                return kf;
            case "endingCredits":
                return $f;
            case "introduction":
                return gf;
            case "program":
                return Cf;
            case "trailer":
                return jf;
            case "advertising":
                return vf;
            case "testPattern":
                return I5;
            case "black":
                return S5;
            case "slate":
                return Q5;
            case "neutralBases":
                return hf;
            default:
                return n;
        }
    }, $ln = function(n) {
        return {
            $: 9,
            a: n
        };
    }, gln = F2(function(n, r) {
        return {
            $: 12,
            a: n,
            b: r
        };
    }), hln = F3(function(n, r, t) {
        return {
            $: 11,
            a: n,
            b: r,
            c: t
        };
    }), kln = F3(function(n, r, t) {
        return {
            $: 10,
            a: n,
            b: r,
            c: t
        };
    }), Cln = Pi({
        bQ: "Edit",
        bX: "Editer"
    }), jln = F2(function(n, r) {
        var t = d(A2(Lo, b6(r.mj), n.k0), Ra(r.T));
        return t.a.$ ? t.b.$ ? {
            c2: 3,
            sc: lf
        } : t.b.a : t.a.a;
    }), wln = F2(function(n, r) {
        var t = d(n, r);
        return t.a.$ ? t.b.$ ? lf : t.b.a.sc : t.a.a.sc;
    }), Aln = F2(function(n, r) {
        var t = function(t) {
            return A2(Se, C([
                nh(Psn(t)),
                nh("ActivityVerificationFlag"),
                Zh(C([
                    d("ActivityVerificationFlagSelected", i(t, r))
                ])),
                Mh(n(t))
            ]), C([
                Osn
            ]));
        };
        return A2(Se, C([
            nh("ActivityVerificationFlagSelect")
        ]), C([
            t(1),
            t(0)
        ]));
    }), Lln = F4(function(n, r, t, e) {
        var u = A2(jln, n, t);
        return A2(tj, C([
            aj($ln(t)),
            nh(Psn(u.c2))
        ]), C([
            3 === u.c2 ? A2(Se, C([
                nh("ActivityVerificationMessage"),
                nh(Psn(u.c2))
            ]), C([
                ch(vln(t.nE))
            ])) : A2(Se, C([
                nh("ActivityCommentVerifHeader")
            ]), C([
                A2(Sk, cln(b6(t.mj)), Isn(p(e, {
                    jb: kt("VerificationMotifs"),
                    kT: "editverif" + b6(t.mj),
                    gy: xsn
                }))),
                A2(Aln, A2(hln, u, b6(t.mj)), u.c2)
            ])),
            A2(Se, C([
                nh("ActivityCommentVerif")
            ]), C([
                function() {
                    var r = A2(wln, A2(Lo, b6(t.mj), n.k0), Ra(t.T));
                    switch(r.$){
                        case 0:
                            return A2(Se, C([
                                nh("ActivityCommentVerifTc")
                            ]), C([
                                A2(IB, qsn, A3(kln, u, b6(t.mj), 0)),
                                A2(_h, C([
                                    nh("ActivityCommentVerifLabel")
                                ]), gsn)
                            ]));
                        case 1:
                            var e = r.a;
                            return A2(Se, C([
                                nh("ActivityCommentVerifTc")
                            ]), C([
                                A2(IB, qsn, A3(kln, u, b6(t.mj), 0)),
                                wsn(A2(Msn, e, n)),
                                A2(IB, Dsn, A3(kln, u, b6(t.mj), 1)),
                                A2(_h, C([
                                    nh("ActivityCommentVerifLabel")
                                ]), Bsn),
                                A2(IB, Wh, A2(gln, u, b6(t.mj)))
                            ]));
                        default:
                            e = r.a;
                            var a = r.b;
                            return A2(Se, C([
                                nh("ActivityCommentVerifTc")
                            ]), C([
                                A2(IB, qsn, A3(kln, u, b6(t.mj), 0)),
                                wsn(A2(Msn, e, n)),
                                A2(IB, Dsn, A3(kln, u, b6(t.mj), 1)),
                                wsn(A2(Msn, a, n)),
                                A2(IB, Wh, A2(gln, u, b6(t.mj)))
                            ]));
                    }
                }()
            ])),
            A2(Se, C([
                nh("ActivityCommentFormSubmit")
            ]), C([
                ij(Cln)
            ]))
        ]));
    }), yln = F4(function(n, r, t, e) {
        return A2(qC, function(u) {
            return A2(Se, C([
                nh("ActivityItem"),
                nh("ActivityComment"),
                nh(Psn(u.c2))
            ]), C([
                A2(Tun, n.r8, e.bM),
                A2(Se, C([
                    nh("ActivityCommentContent")
                ]), $(C([
                    A2(Se, C([
                        nh("ActivityCommentHeader")
                    ]), C([
                        A2(_h, C([
                            nh("ActivityCommentAuthor")
                        ]), "" === e.bM.nW ? e.bM.k6 : e.bM.nW),
                        uln,
                        A2(aln, "ActivityCommentDate", e.ke),
                        i(e.ke, e.cu) ? ch("") : ch(eln),
                        A2(_h, C([
                            nh("ActivityCommentSpacer")
                        ]), ""),
                        A2(Se, C([
                            nh("ActivityCommentActions")
                        ]), C([
                            !i(e.bM.mj, n.r8.mj) && n.r8.iz ? ch("") : A2(NJ, b6(e.mj), t.k3) ? A2(tln, $Q, Ksn(b6(e.mj))) : A2(tln, rln, Ysn({
                                mj: b6(e.mj),
                                nE: e.nE
                            })),
                            A2(Se, C([
                                nh("ActivityCommentDelete")
                            ]), C([
                                i(e.bM.mj, n.r8.mj) ? A2(tln, $Q, _sn(e)) : ch("")
                            ]))
                        ]))
                    ])),
                    function() {
                        var n = A2(Lo, b6(e.mj), t.k3);
                        if (1 === n.$) return A2(Se, C([
                            nh("ActivityVerificationBloc")
                        ]), C([
                            function() {
                                var n = u.sc;
                                switch(n.$){
                                    case 0:
                                        return ch("");
                                    case 1:
                                        var r = n.a;
                                        return A2(Se, C([
                                            nh("ActivityCommentVerifTc")
                                        ]), C([
                                            A2(IB, Bun, Gsn(r.sa)),
                                            nln(A2(Msn, r, t))
                                        ]));
                                    default:
                                        r = n.a;
                                        var e = n.b;
                                        return A2(Se, C([
                                            nh("ActivityCommentVerifTc")
                                        ]), C([
                                            A2(IB, Bun, Gsn(r.sa)),
                                            nln(A2(Msn, r, t)),
                                            A2(IB, Bun, Gsn(e.sa)),
                                            nln(A2(Msn, e, t))
                                        ]));
                                }
                            }(),
                            A2(Se, C([
                                nh("ActivityVerificationMessage"),
                                nh(Psn(u.c2))
                            ]), C([
                                ch(vln(e.nE))
                            ]))
                        ]));
                        var a = n.a;
                        return A2(Se, C([
                            nh("ActivityVerificationBloc")
                        ]), C([
                            A4(Lln, t, r, e, a)
                        ]));
                    }()
                ]), 1 === e.mj.$ ? g : C([
                    A2(Se, C([
                        nh("ActivityAnswers")
                    ]), A2(Ge, A2(lln, n, t), iln(e.d9))),
                    A4(mln, n, r, t, e)
                ])))
            ]));
        }, Ra(e.T));
    }), Sln = F4(function(n, r, t, e) {
        return Hsn(e) ? A4(yln, n, r, t, e) : A4(pln, n, r, t, e);
    }), Fln = F4(function(n, r, t, e) {
        var u = d(e.mQ, n.iY);
        n: for(;;)if (1 === u.a.$) switch(u.b){
            case 0:
                return 3 === u.a.a.$ ? Ct : kt(A3(Zsn, n.r8, r.bF.ke, u.a.a));
            case 3:
                return kt(A3(Zsn, n.r8, r.bF.ke, u.a.a));
            default:
                break n;
        }
        else switch(u.b){
            case 0:
                return kt(A4(Sln, n, r, t, a = u.a.a));
            case 4:
                return Hsn(a = u.a.a) ? kt(A4(yln, n, r, t, a)) : Ct;
            case 5:
                var a;
                return Hsn(a = u.a.a) ? Ct : kt(A4(pln, n, r, t, a));
            default:
                break n;
        }
        return Ct;
    }), Tln = F4(function(n, r, t, e) {
        var u = i(n.oK.co, kt(!1)) ? Be : Usn(n);
        return A2(Se, C([
            nh("ActivityContent"),
            nh("DarkZone")
        ]), A2(nc, A3(Fln, n, r, t), u(e)));
    }), Qln = function(n) {
        return {
            $: 36,
            a: n
        };
    }, Iln = Pi({
        bQ: "Complete Last started Job",
        bX: "Finir dernier Job d\xe9marr\xe9"
    }), Bln = Pi({
        bQ: "Create New Job",
        bX: "Nouveau Job"
    }), Wln = Pi({
        bQ: "Start Last created Job",
        bX: "D\xe9marrer dernier Job cr\xe9\xe9"
    }), Pln = function(n) {
        return {
            $: 43,
            a: n
        };
    }, Mln = F2(function(n, r) {
        if (3 === n.$) {
            var t = n.a;
            return A2(Se, C([
                Mh(Pln(r))
            ]), C([
                A2(Ann, Snn, t)
            ]));
        }
        return ch("");
    }), qln = function(n) {
        switch(n.$){
            case 0:
                return A2(Se, C([
                    nh("OperationStatus"),
                    nh("OperationStatusNone")
                ]), g);
            case 1:
                return A2(Se, C([
                    nh("OperationStatus"),
                    nh("OperationStatusRunning")
                ]), g);
            case 2:
                return A2(Se, C([
                    nh("OperationStatus"),
                    nh("OperationStatusSuccess")
                ]), g);
            default:
                return A2(Se, C([
                    nh("OperationStatus"),
                    nh("OperationStatusFailure")
                ]), g);
        }
    }, Dln = F3(function(n, r, t) {
        return A2(Se, C([
            nh("Operation")
        ]), C([
            qln(n),
            A2(Se, C([
                nh("OperationContent"),
                nh("VerifOperationContent")
            ]), A2(bt, A2(Mln, n, r), t))
        ]));
    }), Xln = function(n) {
        return Ra(Jt(A2(xi, A2(mu, NA, function(n) {
            return n.ke;
        }), A2(Bu, function(n) {
            return !i(n.j_, Ct);
        }, A2(Bu, function(n) {
            return 1 === n.fO;
        }, n.c7)))));
    }, Eln = function(n) {
        return Ra(Jt(A2(xi, A2(mu, NA, function(n) {
            return n.ke;
        }), A2(Bu, function(n) {
            return i(n.j_, Ct);
        }, A2(Bu, function(n) {
            return 1 === n.fO;
        }, n.c7)))));
    }, Rln = F2(function(n, r) {
        if (r.$) return ch("");
        var t = r.a;
        return A2(Se, g, C([
            ch(n),
            ch(" "),
            UA(t.ke)
        ]));
    }), xln = F2(function(n, r) {
        var t = A2(Bu, function(r) {
            return i(r.fO, n);
        }, r.c7), e = A2(nc, function(n) {
            return n.qP;
        }, A2(Bu, function(n) {
            return i(n.j_, Ct);
        }, t)), u = function(n) {
            return Bt(Dt(n));
        }, a = F4(function(r, t, e, a) {
            return u(r) + " " + Lf(n) + " jobs ( " + u(t) + " created, " + u(e) + " started, " + u(a) + " completed )";
        }), o = A2(Bu, function(n) {
            return i(n.j_, Ct) && i(n.qP, Ct);
        }, t), c = A2(nc, function(n) {
            return n.j_;
        }, t);
        return wu(t) ? ch("") : A2(Se, C([
            nh("VerifContent")
        ]), C([
            ch(A4(a, t, o, e, c)),
            A2(Rln, "Last completed " + Lf(n) + " Job", Xln(r)),
            A2(Rln, "Last uncompleted " + Lf(n) + " Job", Eln(r))
        ]));
    }), Oln = F3(function(n, r) {
        var t = A2(Bu, function(n) {
            return 1 === n.fO || !n.fO;
        }, r.c7), e = A2(Bu, function(n) {
            return i(n.j_, Ct) && !i(n.qP, Ct);
        }, t), u = A2(Bu, function(n) {
            return i(n.j_, Ct) && i(n.qP, Ct);
        }, t), a = wu(u) ? Yan(Wln) : A2(Znn, Wln, function(n) {
            return {
                $: 39,
                a: n
            };
        }(r.c7)), o = wu(e) ? Yan(Iln) : A2(Znn, Iln, function(n) {
            return {
                $: 41,
                a: n
            };
        }(r.c7)), c = wu(u) && wu(e) ? A2(Znn, Bln, function(n) {
            return {
                $: 37,
                a: n
            };
        }(r)) : Yan(Bln);
        return Gtn(r.r8) ? A2(Se, C([
            nh("Operations")
        ]), C([
            A2(_h, C([
                nh("OperationsHeader")
            ]), "Operation Admin"),
            A2(xln, 1, r),
            A2(xln, 0, r),
            A3(Dln, n.kb, 0, C([
                A2(Sk, Qln, fQ(n.mR)),
                c
            ])),
            A3(Dln, n.qM, 0, C([
                a
            ])),
            A3(Dln, n.jZ, 0, C([
                o
            ]))
        ])) : ch("");
    }), zln = {
        $: 30
    }, Nln = Pi({
        bQ: "Order by date",
        bX: "Trier par date"
    }), Hln = Pi({
        bQ: "Order by timecode",
        bX: "Trier par timecode"
    }), Vln = F3(function(n, r, t) {
        return BA(A3(Rp, n, r, t));
    }), Uln = F3(function(n, r, t) {
        var e = A2(Qu, "", Ra(A2(nc, function(n) {
            return n.a ? kt(n.c) : Ct;
        }, t)));
        return A2(Se, C([
            nh("Select"),
            Zh(C([
                d("SelectOpened", n)
            ])),
            Mh(r),
            MA(n)
        ]), C([
            A2(Se, C([
                nh("SelectButton")
            ]), C([
                A2(Se, C([
                    nh("SelectButtonIcon")
                ]), C([
                    JC
                ])),
                A2(_h, C([
                    nh("SelectButtonTitle")
                ]), e)
            ])),
            A2(Se, C([
                nh("SelectList")
            ]), A2(Ge, qA, t))
        ]));
    }), Jln = F3(function(n, r, t) {
        var e = n.oK;
        return 4 === n.iY ? A2(Se, C([
            nh("ActivityHeader")
        ]), C([
            A3(Uln, t.it, zln, C([
                b(i(e.co, Ct), A3(Vln, n.g9.mj, n.iY, p(e, {
                    co: Ct
                })), Hln),
                b(i(e.co, kt(!1)), A3(Vln, n.g9.mj, n.iY, p(e, {
                    co: kt(!1)
                })), Nln)
            ]))
        ])) : ch("");
    }), Zln = {
        $: 33
    }, Kln = function(n) {
        return 5 === n.oQ;
    }, _ln = function(n) {
        return A2(Qu, !1, A2(Tu, function(n) {
            return function(n) {
                return A2(Qu, !1, A2(Tu, Kln, n.rN));
            }(n) || !i(n.ia, Ct);
        }, A2(Tu, function(n) {
            return n.lA;
        }, n.S.bT.f2)));
    }, Gln = Pi({
        bQ: "Switch Proxy",
        bX: "Changer de proxy"
    }), Yln = Pi({
        bQ: "For a more thourough verification, you can switch to a high-qualitity proxy.",
        bX: "Pour une v\xe9rification plus pouss\xe9e, vous pouvez choisir un proxy mp4 de meilleure qualit\xe9."
    }), ndn = Pi({
        bQ: "Switch to hi-res proxy",
        bX: "Afficher le 'proxy hi-res'"
    }), rdn = Pi({
        bQ: "Switch back to low-res proxy",
        bX: "Retour au 'proxy low-res'"
    }), tdn = Pi({
        bQ: "Generate new proxy verif",
        bX: "G\xe9n\xe9ration du proxy de v\xe9rification"
    }), edn = F2(function(n, r) {
        return A2(Se, C([
            nh("Operation")
        ]), C([
            qln(sf),
            A2(Se, C([
                nh("OperationContent")
            ]), C([
                ch(n),
                r
            ]))
        ]));
    }), udn = Pi({
        bQ: "Currently watching hi-res proxy",
        bX: "Vous \xeates sur le 'proxy hi-res'"
    }), adn = Pi({
        bQ: "Currently watching low-res proxy",
        bX: "Vous \xeates sur le 'proxy low-res'"
    }), idn = F3(function(n, r, t) {
        var e, u = Gtn(r.r8), a = _ln(r), i = function(n) {
            return A2(Qu, !1, A2(Tu, function(n) {
                var r = n.rN;
                return !r.$ && 5 === r.a.oQ;
            }, A2(Lp, A2(Po, function(n) {
                return n.o7;
            }, function(n) {
                return n.fv;
            }), n.bT.f2)));
        }(t);
        return A2(JT, a && u || i, A2(Se, C([
            nh("RegularOperations")
        ]), C([
            A2(_h, C([
                nh("RegularOperationsHeader")
            ]), Gln),
            u ? A3(Dln, n.qN, 0, C([
                (e = t.bT.f2, 1 === e.$ ? ch("") : A2(Znn, tdn, function(n) {
                    return {
                        $: 44,
                        a: n
                    };
                }(e.a.lA.mj)))
            ])) : uen(Yln),
            A2(JT, i, n.l$ ? A2(edn, udn, A2(Znn, rdn, Zln)) : A2(edn, adn, A2(Znn, ndn, Zln)))
        ])));
    }), odn = F4(function(n, r, t, e) {
        return A2(Se, C([
            nh("Activity")
        ]), C([
            A3(Jln, n, r, t),
            A2(Qu, ch(""), A2(Tu, AC, t.ll)),
            A2(Se, C([
                nh("ActivityContent"),
                nh("DarkZone")
            ]), function() {
                switch(n.iY){
                    case 4:
                        return C([
                            A3(Oln, t, n, r),
                            A3(idn, t, n, r),
                            A2(Nsn, r, t),
                            A4(Tln, n, r, t, A3(msn, n, r, e))
                        ]);
                    case 5:
                        return C([
                            A2(Asn, r, t),
                            A4(Tln, n, r, t, A3(msn, n, r, e))
                        ]);
                    default:
                        return C([
                            A4(Tln, n, r, t, A3(msn, n, r, e))
                        ]);
                }
            }())
        ]));
    }), cdn = F2(function(n, r) {
        var t, e, u = A2(Can, wan(n), r);
        return C([
            (e = r.Q.ll, 1 === e.$ ? ch("") : AC(Jtn(e.a))),
            (t = r.e9.kt, t.$ ? ch("") : A2(Sk, m1, A4(odn, n, u, r.ir, t.a)))
        ]);
    }), fdn = {
        $: 35
    }, sdn = Pi({
        bQ: "Actions",
        bX: "Actions"
    }), ldn = Pi({
        bQ: "Activity",
        bX: "Activit\xe9"
    }), ddn = Pi({
        bQ: "Comments",
        bX: "Commentaires"
    }), bdn = Pi({
        bQ: "Settings",
        bX: "Param\xe8tres"
    }), mdn = Pi({
        bQ: "Verification report",
        bX: "Rapport de v\xe9rification"
    }), pdn = function(n) {
        switch(n){
            case 0:
            case 1:
                return sdn;
            case 2:
                return bdn;
            case 3:
                return ldn;
            case 4:
                return mdn;
            default:
                return ddn;
        }
    }, vdn = F2(function(n, r) {
        return BA(A3(Rp, n, r, $K));
    }), $dn = F2(function(n, r) {
        return A2(hj, C([
            nh("AsideMenuItem"),
            wj(A2(vdn, n.g9.mj, r)),
            Zh(C([
                d("Active", i(r, n.iY))
            ]))
        ]), C([
            ch(pdn(r))
        ]));
    }), gdn = F2(function(n, r) {
        return A2(Se, C([
            nh("AsideTabs"),
            Mh(fdn),
            MA(r.iZ),
            Zh(C([
                d("AsideMenuOpened", r.iZ)
            ]))
        ]), C([
            A2(Se, C([
                nh("AsideTab")
            ]), C([
                A2(Se, C([
                    nh("AsideTabInner")
                ]), C([
                    A2(Se, C([
                        nh("AsideTabsIcon")
                    ]), C([
                        wun
                    ])),
                    A2(_h, C([
                        nh("AsideTabLabel")
                    ]), pdn(n.iY)),
                    JC
                ]))
            ])),
            A2(Se, C([
                nh("AsideMenu")
            ]), C([
                A2($dn, n, 1),
                A2($dn, n, 2),
                A2($dn, n, 3),
                A2($dn, n, 4),
                A2($dn, n, 5)
            ]))
        ]));
    }), hdn = function(n) {
        return 2 === n.$ ? kt(n.a) : Ct;
    }, kdn = irn(C([
        A2(Cj, C([
            Vg("Fg"),
            kj("M3,1 L11,1 L15,5 L15,17 L3,17 L3,1 Z M8,12 L8,10 L6,10 L6,12 L8,12 Z M12,14 L12,8 L9,10 L9,12 L12,14 Z")
        ]), g)
    ])), Cdn = Pi({
        bQ: "audio stream ",
        bX: "stream audio "
    }), jdn = Pi({
        bQ: "Channels",
        bX: "Canaux"
    }), wdn = Pi({
        bQ: "File duration",
        bX: "Dur\xe9e totale"
    }), Adn = function(n) {
        return A3(ib, 2, "0", Bt(n));
    }, Ldn = function(n) {
        var r = se(1e3 * n), t = r % 1e3, e = r / 1e3 | 0, u = e % 60;
        return Adn(e / 60 | 0) + " min " + Adn(u) + " sec " + Adn(t) + " ms";
    }, ydn = function(n) {
        var r = A2(Lp, function(n) {
            return n.e$;
        }, n);
        return 1 === r.$ ? "?" : Ldn(r.a);
    }, Sdn = irn(C([
        A2(Cj, C([
            Vg("Fg"),
            kj("M3,1 L11,1 L15,5 L15,17 L3,17 L3,1 Z M5,9 L5,11 L13,11 L13,9 L5,9 Z M5,13 L5,15 L10,15 L10,13 L5,13 Z")
        ]), g)
    ])), Fdn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Tdn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Qdn = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Idn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Bdn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Wdn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Pdn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Mdn = function(n) {
        return {
            $: 12,
            a: n
        };
    }, qdn = function(n) {
        return {
            $: 11,
            a: n
        };
    }, Ddn = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Xdn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Edn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Rdn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, xdn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Odn = Pi({
        bQ: "Save",
        bX: "Sauvegarder"
    }), zdn = function(n) {
        return A2(Se, C([
            nh("SelectNative")
        ]), C([
            A2(_C, C([
                nh("Select"),
                nk(!n.e5),
                $k(oQ)
            ]), A2(Ge, function(r) {
                var t = r.a, e = r.b;
                return A2(KC, C([
                    hk(t),
                    GC(i(kt(t), n.sa))
                ]), C([
                    ch(e)
                ]));
            }, n.eC))
        ]));
    }, Ndn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Hdn = F2(function(n, r) {
        return n.e3 || !i(r.sa, Ct) && !i(r.sa, kt(""));
    }), Vdn = F2(function(n, r) {
        var t = r.mp;
        return A2(Hdn, n, r) ? A2(Se, C([
            nh("EditRow")
        ]), C([
            A2(_h, C([
                nh("EditRowLabel")
            ]), r.mp.m$),
            A2(Se, C([
                nh("EditRowContent")
            ]), C([
                n.e3 ? A2(Sk, A2(mu, Ndn, r.q), r.o(p(t, {
                    kO: n.hC
                }))) : ch(A2(Qu, "", r.sa))
            ]))
        ])) : ch("");
    }), Udn = F2(function(n, r) {
        var t = r.mp;
        return n.e3 || r.sa ? A2(Se, C([
            nh("EditRow")
        ]), C([
            A2(_h, C([
                nh("EditRowLabel")
            ]), r.mp.m$),
            A2(Se, C([
                nh("EditRowContent")
            ]), C([
                n.e3 ? A2(Sk, A2(mu, Ndn, r.q), r.o(t)) : r.sa ? Xh : Ph
            ]))
        ])) : ch("");
    }), Jdn = F2(function(n, r) {
        var t = r.mp, e = A2(Lp, function(n) {
            return Ra(A2(nc, function(r) {
                var t = r.b;
                return i(r.a, n) ? kt(t) : Ct;
            }, t.eC));
        }, r.sa);
        return A2(Hdn, n, r) ? A2(Se, C([
            nh("EditRow")
        ]), C([
            A2(_h, C([
                nh("EditRowLabel")
            ]), t.m$),
            A2(Se, C([
                nh("EditRowContent")
            ]), C([
                n.e3 ? A2(Sk, A2(mu, Ndn, r.q), r.o(t)) : ch(A2(Qu, "", e))
            ]))
        ])) : ch("");
    }), Zdn = function(n) {
        return A2(Yh, n, A2(rk, C([
            nh("InputText"),
            qh("number"),
            $k(zh),
            hk(n.sa),
            gk(n.gy),
            tk(ck(n.m$)),
            nk(n.kO),
            cy("1900"),
            oy("9999")
        ]), g));
    }, Kdn = F3(function(n, r, t) {
        var e, u = r.g9, a = r.dd, i = r.mF, o = i ? A2(Qu, {
            jr: Ct,
            bP: Ct,
            k8: !1,
            lB: Ct,
            F: Ct,
            lF: Ct,
            b_: Ct,
            b2: Ct,
            cb: Ct,
            cg: Ct,
            ch: Ct,
            ci: Ct,
            g9: u.rC
        }, t.o9) : a, c = Jdn(n), f = Udn(n), s = Vdn(n);
        return A2(Se, C([
            nh("EditContent")
        ]), C([
            (e = t.Q, 3 === e.$ ? A2(Ann, Snn, e.a) : ch("")),
            s({
                mp: t.rC,
                o: kk,
                q: xdn,
                sa: kt(u.rC)
            }),
            s({
                mp: t.jr,
                o: kk,
                q: Tdn,
                sa: o.jr
            }),
            s({
                mp: t.lF,
                o: Fnn,
                q: Pdn,
                sa: A2(Tu, tG, o.lF)
            }),
            A2(JT, i, c({
                mp: t.b2,
                o: zdn,
                q: qdn,
                sa: o.b2
            })),
            A2(JT, i, s({
                mp: t.b_,
                o: kk,
                q: Mdn,
                sa: o.b_
            })),
            A2(JT, 1 !== u.c9 && !i, f({
                mp: t.k8,
                o: xC,
                q: Idn,
                sa: o.k8
            })),
            s({
                mp: t.cg,
                o: kk,
                q: Xdn,
                sa: o.cg
            }),
            s({
                mp: t.ch,
                o: Zdn,
                q: Edn,
                sa: A2(Tu, Bt, o.ch)
            }),
            c({
                mp: t.ci,
                o: fQ,
                q: Rdn,
                sa: A2(Tu, zf, o.ci)
            }),
            c({
                mp: t.F,
                o: fQ,
                q: Wdn,
                sa: A2(Tu, Xf, o.F)
            }),
            c({
                mp: t.lB,
                o: fQ,
                q: Bdn,
                sa: A2(Tu, Df, o.lB)
            }),
            c({
                mp: t.bP,
                o: fQ,
                q: Qdn,
                sa: A2(Tu, Mf, o.bP)
            }),
            c({
                mp: t.cb,
                o: fQ,
                q: Ddn,
                sa: A2(Tu, Mf, o.cb)
            }),
            A2(JT, n.e3, A2(Se, C([
                nh("EditFooter")
            ]), C([
                (n.hC ? Yan : ij)(Odn)
            ])))
        ]));
    }), _dn = Pi({
        bQ: "Informations",
        bX: "Informations"
    }), Gdn = {
        $: 6
    }, Ydn = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), nbn = Pi({
        bQ: "Cancel",
        bX: "Annuler"
    }), rbn = Pi({
        bQ: "Edit",
        bX: "Editer"
    }), tbn = F4(function(n, r, t) {
        return A2(Se, C([
            nh("EditHeaderActions")
        ]), C(n.e3 ? [
            VW(p(AW, {
                kO: n.hC,
                mi: kt($Q),
                mD: !0,
                m$: nbn,
                ol: kt(Gdn)
            }))
        ] : [
            VW(p(AW, {
                mi: kt(rln),
                mD: !1,
                m$: rbn,
                ol: kt(A2(Ydn, r, t))
            }))
        ]));
    }), ebn = F5(function(n, r, t, e, u) {
        return Uq(C([
            Kq(_dn),
            A2(WJ, n.r8, n.g9.oz) ? A4(tbn, r, t, e, u) : ch("")
        ]));
    }), ubn = F2(function(n, r) {
        var t = function(n) {
            return {
                e3: 0 !== n.Q.$,
                hC: i(n.Q, p9)
            };
        }(r);
        return A2(tj, C([
            nh("EditWrapper"),
            aj(Fdn(n.g9)),
            Zh(C([
                d("EditEditing", t.e3)
            ]))
        ]), C([
            A5(ebn, n, t, n.g9, n.dd, r),
            A3(Kdn, t, n, r)
        ]));
    }), abn = Pi({
        bQ: "Audio Qualification",
        bX: "Qualification Audio"
    }), ibn = function(n) {
        return {
            $: 11,
            a: n
        };
    }, obn = {
        $: 14
    }, cbn = function(n) {
        return {
            $: 15,
            a: n
        };
    }, fbn = Pi({
        bQ: "Apply",
        bX: "Appliquer"
    }), sbn = Pi({
        bQ: "Audio Layout",
        bX: "Agencement Audio"
    }), lbn = Pi({
        bQ: "Copy",
        bX: "Copier"
    }), dbn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, bbn = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), mbn = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), pbn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), vbn = F4(function(n, r, t, e) {
        return {
            $: 3,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), $bn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, gbn = F2(function(n, r) {
        return function(n) {
            return {
                $: 0,
                a: n
            };
        }(n + ":" + r);
    }), hbn = F2(function(n, r) {
        return n + "(" + A2(Wt, ", ", r) + ")";
    }), kbn = F3(function(n, r, t) {
        return {
            a4: 1,
            a6: t,
            jR: 0,
            bf: r,
            bm: n,
            sa: A2(hbn, "rgb", A2(Ge, Bt, C([
                n,
                r,
                t
            ])))
        };
    }), Cbn = _h(C([
        (GH = C([
            (ZH = A3(kbn, 59, 170, 255), A2(gbn, "color", ZH.sa)),
            (JH = {
                Y: 0,
                sa: "bold"
            }, A2(gbn, "font-weight", JH.sa))
        ]), YH = function(n) {
            return wu(n) ? "unstyled" : A2(Aa, "_", Ea(A2(Pa, 15739, ii(za(ci(za(A2(uC, n, va(g)))))))));
        }(GH), nV = A2(_g, "className", gi(YH)), A3(Og, nV, GH, YH))
    ])), jbn = function(n) {
        switch(n){
            case 0:
                return Pi({
                    bQ: "Original version",
                    bX: "Version originale"
                });
            case 1:
                return Pi({
                    bQ: "Dubbed version",
                    bX: "Version doubl\xe9e"
                });
            case 2:
                return Pi({
                    bQ: "Audio Description",
                    bX: "Audiodescription"
                });
            case 3:
                return Pi({
                    bQ: "Silence",
                    bX: "Silence"
                });
            case 4:
                return Pi({
                    bQ: "International",
                    bX: "International"
                });
            case 5:
                return Pi({
                    bQ: "Music and effects",
                    bX: "Musique et effets"
                });
            case 6:
                return Pi({
                    bQ: "Voice only",
                    bX: "Voix seule"
                });
            case 7:
                return Pi({
                    bQ: "Custom 1",
                    bX: "Custom 1"
                });
            case 8:
                return Pi({
                    bQ: "Custom 2",
                    bX: "Custom 2"
                });
            case 9:
                return Pi({
                    bQ: "Custom 3",
                    bX: "Custom 3"
                });
            case 10:
                return Pi({
                    bQ: "Custom 4",
                    bX: "Custom 4"
                });
            case 11:
                return Pi({
                    bQ: "Custom 5",
                    bX: "Custom 5"
                });
            case 12:
                return Pi({
                    bQ: "Custom 6",
                    bX: "Custom 6"
                });
            case 13:
                return Pi({
                    bQ: "Custom 7",
                    bX: "Custom 7"
                });
            case 14:
                return Pi({
                    bQ: "Custom 8",
                    bX: "Custom 8"
                });
            case 15:
                return Pi({
                    bQ: "Custom 9",
                    bX: "Custom 9"
                });
            default:
                return Pi({
                    bQ: "Custom 10",
                    bX: "Custom 10"
                });
        }
    }, wbn = C([
        d(F0(0), jbn(0)),
        d(F0(1), jbn(1)),
        d(F0(4), jbn(4)),
        d(F0(2), jbn(2)),
        d(F0(3), jbn(3)),
        d(F0(5), jbn(5)),
        d(F0(6), jbn(6)),
        d(F0(7), jbn(7)),
        d(F0(8), jbn(8)),
        d(F0(9), jbn(9)),
        d(F0(10), jbn(10)),
        d(F0(11), jbn(11)),
        d(F0(12), jbn(12)),
        d(F0(13), jbn(13)),
        d(F0(14), jbn(14)),
        d(F0(15), jbn(15)),
        d(F0(16), jbn(16))
    ]), Abn = Pi({
        bQ: "Cancel",
        bX: "Annuler"
    }), Lbn = zk(C([
        nh("TableTrHead")
    ])), ybn = ye("i"), Sbn = Sj(ybn), Fbn = function(n) {
        return kt(function(n) {
            return {
                $: 9,
                a: n
            };
        }(n));
    }, Tbn = Pi({
        bQ: "Back to video",
        bX: "Retour au media principal"
    }), Qbn = Pi({
        bQ: "Play",
        bX: "Lecture"
    }), Ibn = F2(function(n, r) {
        var t = n.p8;
        if (t.$) return Qbn;
        var e = d(t.a, r);
        n: for(;;){
            if (e.a.$) {
                if (e.b.$ || 1 !== e.b.a.$) break n;
                return i(e.a.a, e.b.a.a) ? Tbn : Qbn;
            }
            if (e.b.$ || e.b.a.$) break n;
            return i(e.a.a, e.b.a.a) ? Tbn : Qbn;
        }
        return Qbn;
    }), Bbn = Pi({
        bQ: "Qualify",
        bX: "Qualifier"
    }), Wbn = Pi({
        bQ: "Save",
        bX: "Enregistrer"
    }), Pbn = F2(function(n, r) {
        return "" === n.sa && i(n.lm, g) ? A2(Se, C([
            nh("InputWrapper"),
            nh("InputWrapperPrechoice"),
            Zh(C([
                d("InputWrapperDisabled", n.kO)
            ]))
        ]), A2(bt, A2(Se, C([
            nh("InputSelectAllChoice")
        ]), C([
            JC,
            A2(YC, n, r)
        ])), A2(Ge, function(n) {
            var r = n.a, t = n.b;
            return A2(_h, C([
                nh("InputSelectPrechoice"),
                Mh(zh(r))
            ]), t);
        }, r))) : A2(nj, n, r);
    }), Mbn = Mk(C([
        nh("Table")
    ])), qbn = function(n) {
        return A2(gC, C([
            nh("TableTd")
        ]), C([
            n
        ]));
    }, Dbn = function(n) {
        return A2(gC, C([
            nh("TableTh")
        ]), C([
            n
        ]));
    }, Xbn = zk(C([
        nh("TableTr")
    ])), Ebn = function(n) {
        var r = F2(function(n, r) {
            var t = n.b, e = r.b;
            return d(A2(bt, n.a, r.a), A2(bt, t, e));
        });
        return A3(_e, r, d(g, g), n);
    }, Rbn = F6(function(n, r, t, e, u, a) {
        var o, c, f, s, l = A2(Tu, fj, e.sd), m = A2(Tu, W$, e.sd), v = A2(Tu, jbn, e.rQ), $ = A2(Tu, F0, e.rQ), g = i(t.pg, C([
            e.fR
        ])), h = C([
            d(L0(1), J1(1)),
            d(L0(2), J1(2))
        ]), k = C([
            d(L0(5), J1(5)),
            d(L0(13), J1(13))
        ]), j = C([
            d(L0(0), J1(0)),
            d(L0(3), J1(3)),
            d(L0(4), J1(4)),
            d(L0(6), J1(6)),
            d(L0(7), J1(7)),
            d(L0(8), J1(8)),
            d(L0(11), J1(11)),
            d(L0(9), J1(9)),
            d(L0(10), J1(10))
        ]), w = C([
            d(L0(12), J1(12)),
            d(L0(13), J1(13))
        ]), A = function() {
            switch(e.cJ){
                case "1":
                    return j;
                case "2":
                    return h;
                case "6":
                    return k;
                case "8":
                    return w;
                default:
                    return C([
                        d(L0(0), J1(0)),
                        d(L0(2), J1(2)),
                        d(L0(3), J1(3)),
                        d(L0(4), J1(4)),
                        d(L0(1), J1(1)),
                        d(L0(6), J1(6)),
                        d(L0(7), J1(7)),
                        d(L0(8), J1(8)),
                        d(L0(11), J1(11)),
                        d(L0(9), J1(9)),
                        d(L0(10), J1(10)),
                        d(L0(12), J1(12)),
                        d(L0(13), J1(13))
                    ]);
            }
        }(), L = A2(Tu, J1, e.m3), y = A2(Tu, L0, e.m3), S = !i(L, Ct) && !i(v, Ct), F = !(o = A2(Lo, e.fR, t.sf)).$ && S4(o.a.rQ.sa), T = t.e5 && A3(MJ, r.r8, r.g9.oz, A2(Ge, function(n) {
            return n.fH;
        }, r.fJ)), Q = C(S ? [
            A2(qC, Cbn, L),
            A2(qC, cE, v),
            A2(qC, Sbn, l)
        ] : [
            cE(e.rB)
        ]), I = A2(Qu, b(ch(""), ch(""), ch("")), A2(Tu, function(n) {
            var r;
            return b(A2(Sk, mbn(e.fR), A2(Pbn, n.rQ, wbn)), (r = n.sd, A2(Sk, pbn(e.fR), A2(Pbn, p(r, {
                kO: !F
            }), sj))), A2(Sk, bbn(e.fR), A2(Pbn, n.m3, A)));
        }, A2(Lp, function() {
            return A2(Lo, e.fR, t.sf);
        }, Ra(t.pg)))), B = I.a, W = I.b, P = I.c;
        return A2(Se, C([
            nh("AudioQualifyFilesAudioStream")
        ]), C([
            A2(Se, C([
                nh("AudioQualifyFilesHeader")
            ]), C([
                kdn,
                A2(Se, C([
                    nh("AudioQualifyFilesTitle")
                ]), Q),
                u ? A2(Se, C([
                    nh("PlayAudio")
                ]), C([
                    FW(p(AW, {
                        mi: kt(ken),
                        m$: A2(Ibn, t, a),
                        ol: Fbn(a)
                    }))
                ])) : ch(""),
                T ? A2(Se, C([
                    nh("AudioQualifyQualifyEdit")
                ]), C([
                    FW(p(AW, {
                        mi: kt(g ? $Q : rln),
                        bh: g,
                        m$: g ? Abn : Bbn,
                        ol: kt(g ? dbn(e.fR) : A4(vbn, e.fR, $, m, y))
                    }))
                ])) : ch("")
            ])),
            i(t.pg, C([
                e.fR
            ])) ? A2(tj, C([
                aj($bn(e.fR)),
                nh("AudioQualifyQualifyForm")
            ]), C([
                P,
                B,
                W,
                jen(Wbn)
            ])) : ch(""),
            A2(Se, C([
                nh("AudioQualifyFilesDesc")
            ]), (c = Ebn(e.kI), f = c.a, s = c.b, C([
                Mbn(C([
                    Lbn(A2(Ge, A2(mu, Dbn, ch), f)),
                    Xbn(A2(Ge, A2(mu, qbn, ch), s))
                ]))
            ])))
        ]));
    }), xbn = F5(function(n, r, t, e, u) {
        if (wu(t)) return ch("");
        var a, i = A2(xi, function(n) {
            return n.fB;
        }, t), o = F2(function(n, r) {
            return A2(Tu, function(n) {
                return n.$ ? $4(n.a + "/" + Bt(r)) : d4(r + 1);
            }, n);
        });
        return A2(Se, C([
            nh("AudioQualifyWrapper")
        ]), C([
            A2(Se, g, A2(Ot, F2(function(t, a) {
                return A6(Rbn, t, n, r, a, e, A2(o, u, t));
            }), i)),
            r.e5 && A3(MJ, n.r8, n.g9.oz, A2(Ge, function(n) {
                return n.fH;
            }, n.fJ)) && (u.$ || 1 !== u.a.$) ? A2(Se, C([
                nh("AudioQualifyMemo")
            ]), C([
                A2(ph, C([
                    nh("AudioQualifyMemoLabel")
                ]), C([
                    ch(sbn)
                ])),
                FW(p(AW, {
                    mi: Ct,
                    m$: lbn,
                    ol: kt(cbn(t))
                })),
                (a = r.pM, 1 === a.$ || "" === a.a ? ch("") : FW(p(AW, {
                    mi: Ct,
                    m$: fbn,
                    ol: kt(ibn(t))
                })))
            ])) : ch(""),
            function() {
                if (r.e5) {
                    if (u.$ || 1 !== u.a.$) {
                        var n = r.pM;
                        if (1 === n.$) return ch("");
                        if ("" === n.a) return ch("");
                        var t = n.a;
                        return A2(ph, C([
                            nh("AudioQualifyMemoRecap")
                        ]), C([
                            ch(fbn + " '" + t + "' ?"),
                            A2(tln, Wh, obn)
                        ]));
                    }
                    return ch("");
                }
                return ch("");
            }()
        ]));
    }), Obn = F5(function(n, r, t, e, u) {
        return A2(Se, C([
            nh("AudioQualify")
        ]), C([
            Uq(C([
                Kq(abn)
            ])),
            A5(xbn, n, r, t, e, u)
        ]));
    }), zbn = Pi({
        bQ: "Subtitle Qualification",
        bX: "Qualification des sous-titres"
    }), Nbn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Hbn = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Vbn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Ubn = F3(function(n, r, t) {
        return {
            $: 2,
            a: n,
            b: r,
            c: t
        };
    }), Jbn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Zbn = Pi({
        bQ: "Qualify",
        bX: "Qualifier"
    }), Kbn = Pi({
        bQ: "Save",
        bX: "Enregistrer"
    }), _bn = F5(function(n, r, t, e) {
        var u = A2(Tu, fj, e.sd), a = A2(Tu, W$, e.sd), o = A2(Tu, rQ, e.rQ), c = A2(Tu, Ey, e.rQ), f = t.e5 && A3(MJ, r.r8, r.g9.oz, A2(Ge, function(n) {
            return n.fH;
        }, r.fJ)), s = A2(Qu, d(ch(""), ch("")), A2(Tu, function(n) {
            return d(A2(Sk, Vbn(e.fR), A2(nj, n.sd, eQ)), A2(Sk, Hbn(e.fR), A2(nj, n.rQ, tQ)));
        }, A2(Lp, function() {
            return A2(Lo, e.fR, t.sf);
        }, t.pg))), l = s.a, b = s.b;
        return A2(Se, C([
            nh("SubtitleQualifyFilesSubtitleStream")
        ]), C([
            A2(Se, C([
                nh("SubtitleQualifyFilesHeader")
            ]), C([
                kdn,
                A2(_h, C([
                    nh("SubtitleQualifyFilesTitle")
                ]), e.rB),
                f ? A2(Se, C([
                    nh("SubtitleQualifyQualifyEdit")
                ]), C([
                    FW(p(AW, {
                        mi: kt(ken),
                        mD: i(t.pg, kt(e.fR)),
                        m$: Zbn,
                        ol: i(t.pg, kt(e.fR)) ? kt(Nbn(e.fR)) : kt(A3(Ubn, e.fR, a, c))
                    }))
                ])) : ch("")
            ])),
            i(t.pg, kt(e.fR)) ? A2(tj, C([
                aj(Jbn(e.fR)),
                nh("SubtitleQualifyQualifyForm")
            ]), C([
                l,
                b,
                ij(Kbn)
            ])) : A2(Se, C([
                nh("SubtitleQualifyQualify")
            ]), C([
                A2(qC, _h(C([
                    nh("SubtitleQualifyQualifyItem")
                ])), u),
                A2(qC, _h(C([
                    nh("SubtitleQualifyQualifyItem")
                ])), o)
            ]))
        ]));
    }), Gbn = F4(function(n, r, t, e) {
        return wu(t) ? ch("") : A2(Se, C([
            nh("SubtitleQualifyWrapper")
        ]), C([
            A2(Se, g, A2(Ot, F2(function(t, u) {
                return A5(_bn, t, n, r, u, e);
            }), t))
        ]));
    }), Ybn = F4(function(n, r, t, e) {
        return A2(Se, C([
            nh("SubtitleQualify")
        ]), C([
            Uq(C([
                Kq(zbn)
            ])),
            A4(Gbn, n, r, t, e)
        ]));
    }), nmn = F2(function(n, r) {
        var t = !1, e = A2(Can, wan(n), r), u = A3(_e, Qt, g, A2(Ge, function(n) {
            return A2(Ge, function(r) {
                return {
                    A: r.A,
                    fB: r.fB,
                    nW: n.lA.nW,
                    rQ: r.rQ,
                    sd: r.sd
                };
            }, A2(nc, hdn, n.aw));
        }, e.bT.ae)), a = A2(Pw, Ww(function(n) {
            return n.rB;
        }), A2(Ge, function(n) {
            return {
                mi: Sdn,
                fB: n.fB,
                fR: n.A + "/" + Bt(n.fB),
                rB: n.nW,
                rQ: n.rQ,
                sd: n.sd
            };
        }, u)), i = function() {
            var n = e.bT.f2;
            return n.$ ? g : n.a.aw;
        }(), o = A2(nc, U1, i), c = A2(Pw, Ww(function(n) {
            return n.rB;
        }), A2(Ge, function(n) {
            return {
                cJ: Bt(n.cJ),
                kI: C([
                    d("Codec", n.aF),
                    d(wdn, ydn(kt(n))),
                    d(jdn, Bt(n.cJ))
                ]),
                mi: kdn,
                fB: n.fB,
                fR: n.A + "/" + Bt(n.fB),
                m3: n.aD,
                rB: $(Cdn, A3(ib, 2, "0", Bt(n.fB))),
                rQ: n.rQ,
                sd: n.sd
            };
        }, o));
        return C([
            A2(Sk, C1, A2(ubn, n, r.k$)),
            A2(Sk, KV, A5(Obn, n, r.i6, c, t, kt(d4(-1)))),
            A2(Sk, Q1, A4(Ybn, n, r.q5, a, t))
        ]);
    }), rmn = F2(function(n, r) {
        return C([
            A2(Se, C([
                nh("AsideHeader")
            ]), C([
                A2(gdn, n, r),
                A2(hj, C([
                    nh("LayoutFwdButton"),
                    wj(han(r))
                ]), C([
                    $Q
                ]))
            ])),
            A2(Se, C([
                nh("AsideBody")
            ]), function() {
                switch(n.iY){
                    case 1:
                    case 0:
                        return A2(csn, n, r);
                    case 2:
                        return A2(nmn, n, r);
                    default:
                        return A2(cdn, n, r);
                }
            }())
        ]);
    }), tmn = F2(function(n, r) {
        return n ? r : ch("");
    }), emn = function(n) {
        return {
            $: 40,
            a: n
        };
    }, umn = {
        $: 17
    }, amn = {
        $: 18
    }, imn = {
        $: 19
    }, omn = F3(function(n, r, t) {
        return A2(WJ, n, r) || A2(dan, n, t);
    }), cmn = function(n) {
        return {
            $: 28,
            a: n
        };
    }, fmn = Pi({
        bQ: "Delete",
        bX: "Supprimer"
    }), smn = Pi({
        bQ: "Download",
        bX: "T\xe9l\xe9charger"
    }), lmn = F3(function(n, r, t) {
        var e = n.Q.kt;
        return !(e.$ || !t.iz && 9 !== r.c9 && (e.a.g9.c9 || 8 !== r.c9 && 7 !== r.c9));
    }), dmn = Pi({
        bQ: "In progress...",
        bX: "En cours..."
    }), bmn = function(n) {
        switch(n){
            case 0:
                return "ProgressIdle";
            case 1:
                return "ProgressActive";
            case 2:
                return "ProgressError";
            case 3:
                return "ProgressWarning";
            case 4:
                return "ProgressPaused";
            default:
                return "ProgressCompleted";
        }
    }, mmn = function(n) {
        var r = function() {
            var r = n.o6;
            if (1 === r.$) return d(d(dmn, 100), d(!1, !0));
            var t = r.a;
            return d(d(zR(t), 100 * t), d(1 > t, !1));
        }(), t = r.a, e = t.a, u = t.b, a = r.b, i = a.a, o = a.b;
        return A2(Se, C([
            nh("ProgressBarOuter"),
            HW(e)
        ]), C([
            A2(Se, C([
                nh("ProgressBarInner"),
                nh(bmn(n.Q)),
                Zh(C([
                    d("ProgressBarProgressing", i),
                    d("ProgressBarAnimated", o)
                ])),
                A2(gh, "width", FS(u) + "%")
            ]), g)
        ]));
    }, pmn = F7(function(n, r, t, e, u, a, o) {
        var c, f, s, l = function() {
            var n = u.r$;
            if (1 === n.$) return ch("");
            var r = n.a;
            return i(r.j_, Ct) ? i(r.ll, Ct) ? i(r.dq, Ct) ? mmn({
                o6: kt(r.o6),
                Q: 1
            }) : mmn({
                o6: kt(r.o6),
                Q: 4
            }) : mmn({
                o6: kt(r.o6),
                Q: 2
            }) : ch("");
        }(), b = A2(Qu, !0, A2(Tu, function(n) {
            return !i(n.j_, Ct);
        }, u.r$)) ? A2(Se, C([
            nh("MasterFilesDownload")
        ]), C([
            FW(!YZ(u) && r || Gtn(e) ? p(AW, {
                lu: C([
                    A2(ZW, "target", "_blank"),
                    A2(ZW, "data-prevent-history", "true"),
                    nh(a)
                ]),
                mi: kt(kun),
                bh: !0,
                m$: smn + " (" + Vq(u.qy) + ")",
                r6: kt(u.r6)
            }) : p(AW, {
                m$: Vq(u.qy)
            })),
            A3(lmn, t, u, e) ? FW(p(AW, {
                mi: kt(Wh),
                m$: fmn,
                ol: kt(cmn(u.mj))
            })) : ch("")
        ])) : ch("");
        return A2(Se, C([
            nh("MasterFilesAsset"),
            Zh(C([
                d("MasterFilesShowDesc", n)
            ]))
        ]), C([
            A2(Se, C([
                nh("MasterFilesHeader")
            ]), C([
                A2(Se, C([
                    nh("MasterFilesIcon")
                ]), C([
                    u.mi
                ])),
                A2(_h, C([
                    nh("MasterFilesTitle")
                ]), u.rB),
                l,
                b
            ])),
            u.kI.b ? A2(Se, C([
                nh("MasterFilesDesc")
            ]), (c = Ebn(u.kI), f = c.a, s = c.b, C([
                Mbn(C([
                    Lbn(A2(Ge, A2(mu, Dbn, ch), f)),
                    Xbn(A2(Ge, A2(mu, qbn, ch), s))
                ]))
            ]))) : ch(""),
            A2(Se, C([
                nh("MasterFilesChildren")
            ]), u.jI),
            o
        ]));
    }), vmn = F2(function(n, r) {
        return r.$ ? n : kt(r.a);
    }), $mn = function(n) {
        var r = A2(Lp, function(n) {
            return n.hZ;
        }, Ra(A2(nc, _1, n.aw))), t = A2(Lp, function(n) {
            return n.hZ;
        }, Ra(A2(xi, function(n) {
            return n.fB;
        }, A2(nc, P2, n.aw))));
        return A2(vmn, r, A2(vmn, t, A2(Lp, function(n) {
            return n.hZ;
        }, n.a8)));
    }, gmn = F3(function(n, r, t) {
        return A2(Se, C([
            nh("MasterChild"),
            nh(n)
        ]), C([
            A2(Se, C([
                nh("MasterChildLabel")
            ]), r),
            A2(Se, C([
                nh("MasterChildProgress")
            ]), t)
        ]));
    }), hmn = F2(function(n, r) {
        return {
            $: 24,
            a: n,
            b: r
        };
    }), kmn = F2(function(n, r) {
        return A2(Dh, Win, A2(hmn, n, r));
    }), Cmn = F2(function(n, r) {
        return {
            $: 20,
            a: n,
            b: r
        };
    }), jmn = Pi({
        bQ: "Pause",
        bX: "Pause"
    }), wmn = F2(function(n, r) {
        return A2(Dh, jmn, A2(Cmn, n, r));
    }), Amn = F3(function(n, r, t) {
        return {
            $: 22,
            a: n,
            b: r,
            c: t
        };
    }), Lmn = Pi({
        bQ: "Resume",
        bX: "Reprendre"
    }), ymn = F3(function(n, r, t) {
        return A2(Dh, Lmn, A3(Amn, n, r, t));
    }), Smn = F5(function(n, r, t, e, u) {
        if (!i(kt(n.dC), e.dC) && !i(u, NR)) return C([
            A2(kmn, n, t)
        ]);
        switch(u.$){
            case 0:
                return C([
                    A2(wmn, n, t),
                    A2(kmn, n, t)
                ]);
            case 1:
            case 4:
            default:
                return g;
            case 2:
                return C([
                    A3(ymn, n, r, t),
                    A2(kmn, n, t)
                ]);
            case 3:
                return C([
                    A2(kmn, n, t)
                ]);
        }
    }), Fmn = F3(function(n, r, t) {
        var e = t.r$;
        if (1 === e.$) return ch("");
        var u = e.a;
        return u.j_.$ ? A3(gmn, "UploadChild", A5(Smn, n.e8, r.g9.mj, t, u, A3(JR, t.mj, u, n.aa)), g) : ch("");
    }), Tmn = F4(function(n, r, t, e) {
        var u = e.lA, a = e.aw, i = e.o7, o = function() {
            var n = i.nm;
            if (n.$) return !1;
            var r = A2(Tu, function(n) {
                return n.oQ;
            }, n.a.rN);
            return !r.$ && 5 === r.a;
        }(), c = A5(xbn, r, t.i6, A2(nc, function(n) {
            if (1 === n.$) {
                var r = n.a;
                return kt({
                    cJ: Bt(r.cJ),
                    kI: C([
                        d("Codec", r.aF),
                        d(wdn, A2(Qu, "?", A2(Tu, Ldn, r.e$))),
                        d(jdn, Bt(r.cJ)),
                        d("Start Timecode", A2(Qu, "N/A", $mn(e)))
                    ]),
                    mi: kdn,
                    fB: r.fB,
                    fR: u.mj + "/" + Bt(r.fB),
                    m3: r.aD,
                    rB: $(Cdn, A3(ib, 2, "0", Bt(r.fB))),
                    rQ: r.rQ,
                    sd: r.sd
                });
            }
            return Ct;
        }, a), o, kt($4(u.mj)));
        return A7(pmn, t.qn, A3(omn, r.r8, r.g9.oz, A2(Ge, function(n) {
            return n.fH;
        }, r.fJ)), t, r.r8, {
            jI: C([
                A2(Sk, KV, c)
            ]),
            kI: g,
            lx: Ct,
            mi: kdn,
            mj: u.mj,
            c9: u.c9,
            qy: u.qy,
            hw: u.hw,
            rB: u.nW,
            r$: u.r$,
            r6: Hs(_fn(u.mj))
        }, "audioFile", A3(Fmn, n, r, u));
    }), Qmn = Pi({
        bQ: "Audios alone",
        bX: "Audios seuls"
    }), Imn = function(n) {
        return xc(n.cS / n.cR * 100) / 100;
    }, Bmn = F2(function(n, r) {
        var t = r * n.au / n.at, e = se(r), u = e * n.au / n.at, a = e % 60;
        return Adn(e / 60 | 0) + " min " + Adn(a) + " sec " + A3(ib, 2, "0", Bt(xc(t - u))) + " frame(s)";
    }), Wmn = function(n) {
        var r = n.e$;
        return r.$ ? "N/A" : A2(Bmn, n, r.a);
    }, Pmn = F3(function(n, r, t) {
        var e, u, a;
        return A2(Se, C([
            nh("MasterFilesAsset"),
            Zh(C([
                d("MasterFilesShowDesc", n.qm)
            ]))
        ]), C([
            t,
            r.kI.b ? A2(Se, C([
                nh("MasterFilesDesc")
            ]), (e = Ebn(r.kI), u = e.a, a = e.b, C([
                Mbn(C([
                    Lbn(A2(Ge, A2(mu, Dbn, ch), u)),
                    Xbn(A2(Ge, A2(mu, qbn, ch), a))
                ]))
            ]))) : ch(""),
            n.qm ? A2(Se, C([
                nh("MasterFilesChildren")
            ]), r.jI) : ch("")
        ]));
    }), Mmn = function(n) {
        return s(n, 1e9) > -1 ? Bt(n / 1e9 | 0) + " Gbps" : s(n, 1e6) > -1 ? Bt(n / 1e6 | 0) + " Mbps" : 1e3 > n ? Bt(n) + " bps" : Bt(n / 1e3 | 0) + " kbps";
    }, qmn = Pi({
        bQ: "Level",
        bX: "Niveau"
    }), Dmn = Pi({
        bQ: "Quality",
        bX: "Qualit\xe9"
    }), Xmn = function(n) {
        var r = d(d(Gtn(n.r8), A2(WJ, n.r8, n.g9.oz)), n.g9.c9);
        return !!r.a.a || !!r.a.b && 1 === r.b;
    }, Emn = function(n) {
        return A3(omn, n.r8, n.g9.oz, A2(Ge, function(n) {
            return n.fH;
        }, n.fJ));
    }, Rmn = irn(C([
        A2(Cj, C([
            Vg("Fg"),
            kj("M3,1 L11,1 L15,5 L15,17 L3,17 L3,1 Z M6,7 L6,13 L12,10 L6,7 Z")
        ]), g)
    ])), xmn = F2(function(n, r) {
        return n.qm ? A2(Se, C([
            nh("MasterFilesVideoStream")
        ]), C([
            A2(Se, C([
                nh("MasterFilesHeader")
            ]), C([
                Rmn,
                A2(_h, C([
                    nh("MasterFilesTitle")
                ]), r.rB)
            ])),
            A2(Se, C([
                nh("MasterFilesDesc")
            ]), function() {
                var n = Ebn(r.kI), t = n.a, e = n.b;
                return C([
                    Mbn(C([
                        Lbn(A2(Ge, A2(mu, Dbn, ch), t)),
                        Xbn(A2(Ge, A2(mu, qbn, ch), e))
                    ]))
                ]);
            }())
        ])) : A2(Se, g, g);
    }), Omn = function(n) {
        return {
            $: 10,
            a: n
        };
    }, zmn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Nmn = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), Hmn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Vmn = function(n) {
        return A3(MJ, n.r8, n.g9.oz, A2(Ge, function(n) {
            return n.fH;
        }, n.fJ));
    }, Umn = Pi({
        bQ: "Upload was interrupted, re-upload exactly the same file to resume where it was.",
        bX: "L\u2019upload a \xe9t\xe9 interrompu, r\xe9-uploadez exactement le m\xeame fichier pour reprendre o\xf9 il en \xe9tait."
    }), Jmn = Pi({
        bQ: "Delete",
        bX: "Supprimer"
    }), Zmn = Pi({
        bQ: "Download",
        bX: "T\xe9l\xe9charger"
    }), Kmn = function(n) {
        return {
            $: 12,
            a: n
        };
    }, _mn = Pi({
        bQ: "Hide",
        bX: "Masquer"
    }), Gmn = Pi({
        bQ: "Show",
        bX: "Montrer"
    }), Ymn = F3(function(n, r, t) {
        if (n.$) return " ";
        var e = n.a;
        return i(kt(e), t) || i(kt(e), r) ? _mn : Gmn;
    }), npn = F2(function(n, r) {
        return A2(Lp, function(n) {
            var t = A2(Lp, A2(mu, Tu(function(n) {
                return n.oQ;
            }), function(n) {
                return n.rN;
            }), r);
            if (t.$ || 5 !== t.a) return Ct;
            switch(n.c9){
                case 0:
                    return kt(function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(n.mj));
                case 3:
                    return kt(function(n) {
                        return {
                            $: 0,
                            a: n
                        };
                    }(n.mj));
                default:
                    return Ct;
            }
        }, r);
    }), rpn = function(n) {
        return A2(Qh, C([
            Ah("18px"),
            Bh("18px"),
            Ih("0 0 18 18"),
            Vg("IconIcon18")
        ]), A2(bt, A2(Mrn, C([
            Vg("Bg"),
            Ah("18"),
            Bh("18"),
            qrn("0"),
            Drn("0")
        ]), g), n));
    }, tpn = rpn(C([
        A2(Th, C([
            Vg("Fg"),
            Lh("6 5 12 9 6 13")
        ]), g)
    ])), epn = F4(function(n, r, t, e) {
        var u, a = A2(npn, n, r), o = a.$ ? d(Ct, Ct) : 1 === a.a.$ ? i(kt(u = a.a.a), t) ? d(kt(Kmn(Ct)), kt(u)) : d(kt(Kmn(kt(u))), kt(u)) : d(kt(function(n) {
            return {
                $: 13,
                a: n
            };
        }(u = a.a.a)), kt(u)), c = o.a, f = o.b, s = FW(p(AW, {
            mi: kt(tpn),
            m$: A3(Ymn, f, t, e),
            ol: c
        }));
        return 9 !== n.c9 || i(a, Ct) ? ch("") : s;
    }), upn = Pi({
        bQ: "Error occurred while deleting file.",
        bX: "Une erreur est survenue lors de la suppression du fichier."
    }), apn = Pi({
        bQ: "Are you uploading from another tab or window? If not, you can re-upload exactly the same file to resume where it was.",
        bX: "Uploadez-vous depuis un autre onglet ou fen\xeatre? Si non, vous pouvez r\xe9-uploadez exactement le m\xeame fichier pour reprendre o\xf9 il en \xe9tait."
    }), ipn = function(n) {
        switch(n){
            case 3:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, opn = A2(qt, F2(function(n, r) {
        if (1 === n.$) return r;
        var t = n.a;
        return 0 > s(ipn(t), ipn(r)) ? t : r;
    }), 0), cpn = function(n) {
        return A2(Se, C([
            nh("LayoutSmallHeader")
        ]), C([
            Fj(n)
        ]));
    }, fpn = F2(function(n, r) {
        var t = 1 === n.$ ? "FrameRate not defined. Unable to compute timecode for frame" + Bt(r.fg) : v5(A3(tf, FS(n.a), r.fg, !1));
        return A2(zk, C([
            nh("TranscodeWarning")
        ]), C([
            A2(gC, C([
                nh("TranscodeWarningField")
            ]), C([
                ch(r.nW)
            ])),
            A2(gC, C([
                nh("TranscodeWarningField")
            ]), C([
                ch(Bt(r.eM))
            ])),
            A2(gC, C([
                nh("TranscodeWarningField")
            ]), C([
                ch(t)
            ]))
        ]));
    }), spn = Pi({
        bQ: "Count",
        bX: "Nombre total"
    }), lpn = Pi({
        bQ: "First error at",
        bX: "Premiere erreur \xe0"
    }), dpn = Pi({
        bQ: "Message",
        bX: "Message"
    }), bpn = F2(function(n, r) {
        var t = n.rN;
        if (1 === t.$) return ch("");
        var e = t.a.dX;
        return wu(e) ? ch("") : A2(Se, C([
            nh("FileOperationWarning")
        ]), C([
            cpn("Warnings"),
            Mbn($(C([
                Lbn(C([
                    Dbn(ch(dpn)),
                    Dbn(ch(spn)),
                    Dbn(ch(lpn))
                ]))
            ]), A2(Ge, fpn(r), e)))
        ]));
    }), mpn = Pi({
        bQ: "Download ",
        bX: "T\xe9l\xe9charger "
    }), ppn = function(n) {
        var r = n.m$;
        return A2(hj, C([
            wj(n.r6),
            A2(ZW, "target", "_blank"),
            A2(ZW, "download", ""),
            A2(ZW, "data-prevent-history", "true"),
            nh("ReportLinksButton")
        ]), C([
            A2(Se, C([
                nh("ReportLinksIcon")
            ]), C([
                kun
            ])),
            A2(_h, C([
                nh("ReportLinksLabel")
            ]), r)
        ]));
    }, vpn = function(n) {
        var r = b(Gtn(n.r8), A2(WJ, n.r8, n.g9.oz) || A3(omn, n.r8, n.g9.oz, A2(Ge, function(n) {
            return n.fH;
        }, n.fJ)), n.g9.c9);
        return !!r.a || !(!r.b || 1 !== r.c);
    }, $pn = function(n) {
        return A2(Se, C([
            nh("LayoutSubHeader")
        ]), C([
            xR(n)
        ]));
    }, gpn = Pi({
        bQ: "Summary automated analysis",
        bX: "R\xe9sum\xe9 analyse automatique"
    }), hpn = function(n) {
        return n ? "\u2714" : "\u2716";
    }, kpn = Qu("unknown"), Cpn = F3(function(n, r, t) {
        return A2(n, t, r);
    }), jpn = RQ, wpn = F2(function(n, r) {
        return A2(jpn, ch(n), ch(r));
    }), Apn = RQ, Lpn = F2(function(n, r) {
        return A2(Apn, ch(n), ch(r));
    }), ypn = F2(function(n, r) {
        return A2(Zq, ch(n), ch(r));
    }), Spn = Pi({
        bQ: "Unavailable information",
        bX: "Informations indisponibles"
    }), Fpn = Sbn(Spn), Tpn = function(n) {
        var r, t = (r = n.b6).$ ? Ct : kt(r.a), e = kpn(A2(Tu, A2(Cpn, Qt, " LUFS"), A2(Lp, function(n) {
            return n.gH;
        }, t))), u = A2(Qu, ch("unknown"), A2(Tu, function(n) {
            return A2(Se, g, A2(bt, A2(Lpn, "channel", "value"), A2(Ge, function(n) {
                return A2(wpn, n.m$, n.h7 + " DbTP");
            }, n)));
        }, A2(Tu, function(n) {
            return n.cJ;
        }, t))), a = kpn(A2(Tu, A2(Cpn, Qt, " LU"), A2(Lp, function(n) {
            return n.nj;
        }, t))), i = kpn(A2(Tu, hpn, A2(Tu, function(n) {
            return n.fL;
        }, t)));
        return A2(bt, A2(ypn, "Type (ID-Parent)", n.nW + " (" + n.mj + "-" + n.gs + ")"), C(t.$ ? [
            Fpn
        ] : [
            A2(OQ, "Mute track ?", i),
            A2(OQ, "Program Loudness EBU", e),
            A2(OQ, "Loudness Range EBU", a),
            A2(xQ, ch("True Peak EBU"), u)
        ]));
    }, Qpn = function(n) {
        var r, t = (r = n, vW(A2(ag, F2(function(n, r) {
            return !r.b6.$;
        }), r.aw)));
        return A2(Se, g, A2(bt, cpn("Audio Streams"), A3(_e, Qt, g, A2(Ge, Tpn, A2(xi, function(n) {
            return A2(Qu, 0, Oe(n.mj));
        }, t)))));
    }, Ipn = function(n) {
        var r = A2(Qu, YE, A2(Lp, function(n) {
            var r = n.b6;
            return 2 === r.$ ? kt(r.a) : Ct;
        }, A2(Lo, "0", n.aw)));
        return A2(Se, g, A2(bt, cpn("Container"), function() {
            switch(r.$){
                case 1:
                    return function(n) {
                        return C([
                            A2(OQ, "Format", "MOV"),
                            A2(OQ, "Duration SMPTE", kpn(n.e$)),
                            A2(OQ, "Start timecode", kpn(n.qO))
                        ]);
                    }(r.a);
                case 0:
                    return function(n) {
                        return C([
                            A2(OQ, "Duration SMPTE (source package TC)", kpn(n.hY.e$)),
                            A2(OQ, "Format & Pattern", "MXF " + A2(Qu, "(unknown pattern)", n.go)),
                            A2(OQ, "Product Name & Version", A2(Qu, "(unknown product)", n.gF.nW) + " " + A2(Qu, "(unknown version)", n.gF.sd)),
                            A2(OQ, "Company Name", kpn(n.gF.fN)),
                            A2(ypn, "Item", "Start timecode"),
                            A2(OQ, "Source package", kpn(n.hY.hk)),
                            A2(OQ, "Material package", kpn(n.hY.f3)),
                            A2(OQ, "System item", kpn(n.hY.hN)),
                            A2(OQ, "VITC presence", kpn(n.hY.fs))
                        ]);
                    }(r.a);
                default:
                    return C([
                        Fpn
                    ]);
            }
        }()));
    }, Bpn = function(n) {
        return A2(Se, g, C([
            cpn("Content summary"),
            Mbn($(C([
                Lbn(C([
                    Dbn(ch("Name")),
                    qbn(ch("ID")),
                    qbn(ch("Parent"))
                ]))
            ]), A2(Ge, function(n) {
                return Xbn(C([
                    Dbn(ch(n.nW)),
                    qbn(ch(n.mj)),
                    qbn(ch(n.gs))
                ]));
            }, A2(xi, function(n) {
                return A2(Qu, 0, Oe(n.mj));
            }, A2(Bu, function(n) {
                return 2 !== n.b6.$;
            }, vW(n.aw))))))
        ]));
    }, Wpn = function(n) {
        var r, t = Ra((r = n, vW(A2(ag, F2(function(n, r) {
            return 1 === r.b6.$;
        }), r.aw)))), e = A2(Lp, function(n) {
            var r = n.b6;
            return 1 === r.$ ? kt(r.a) : Ct;
        }, t), u = d(t, e);
        if (u.a.$ || u.b.$) return A2(Se, g, C([
            Fpn
        ]));
        var a = u.a.a, i = u.b.a;
        return A2(Se, g, C([
            cpn("Video Stream"),
            A2(ypn, "Type (ID-Parent)", a.nW + " (" + a.mj + "-" + a.gs + ")"),
            A2(OQ, "Chroma format", kpn(i.eD)),
            A2(OQ, "Frame rate", kpn(i.lS)),
            A2(OQ, "Scanning type", kpn(i.g$)),
            A2(OQ, "Cadence", kpn(i.ex)),
            A2(OQ, "Active pixels", kpn(i.d2)),
            A2(OQ, "Display Aspect Ratio", kpn(i.bP))
        ]));
    }, Ppn = function(n) {
        return A2(Se, g, C([
            $pn(gpn),
            Ipn(n),
            Bpn(n),
            Wpn(n),
            Qpn(n)
        ]));
    }, Mpn = Pi({
        bQ: "Critical errors reported by automated analysis",
        bX: "Erreurs critiques relev\xe9es par l'analyse automatique"
    }), qpn = F2(function(n, r) {
        return n + " (" + r + ")";
    }), Dpn = Pi({
        bQ: "Crit\xe8re d\u2019analyse",
        bX: "Crit\xe8re d\u2019analyse"
    }), Xpn = Pi({
        bQ: " Specified criteria: ",
        bX: " Specified criteria: "
    }), Epn = ye("tbody"), Rpn = Epn(g), xpn = Pi({
        bQ: "Localization",
        bX: "Localisation"
    }), Opn = ye("code"), zpn = Sj(Opn), Npn = F2(function(n, r) {
        var t, e, u = (e = d(r.v.hX, r.v.e7)).a.$ ? Ct : kt(1 === e.b.$ ? e.a.a : e.a.a + " - " + e.b.a), a = A2(Qu, A2(Qu, "", r.v.eB), r.v.mj), i = (t = A2(Pt, Xpn, r.v.kJ)).b && t.b.b && !t.b.b.b ? d(t.a, kt(t.b.a)) : d(r.v.kJ, Ct), o = i.a, c = i.b;
        return Rpn($(C([
            Lbn(C([
                Dbn(ch(a)),
                qbn(ch(o))
            ]))
        ]), $(function() {
            if (1 === u.$) return g;
            var n = u.a;
            return C([
                Xbn(C([
                    Dbn(ch(xpn)),
                    qbn(zpn(n))
                ]))
            ]);
        }(), function() {
            if (1 === c.$) return g;
            var n = c.a;
            return C([
                Xbn(C([
                    Dbn(ch(Dpn)),
                    qbn(zpn(n))
                ]))
            ]);
        }())));
    }), Hpn = F3(function(n, r, t) {
        var e = n(t);
        if (e.b) {
            var u = e;
            return kt(A2(cx, g, C([
                cpn(t.nW + " (" + t.mj + "-" + t.gs + ")"),
                Mbn(A2(Ge, Npn(r), u))
            ])));
        }
        return Ct;
    }), Vpn = F4(function(n, r, t, e) {
        return A2(Se, C([
            nh("ReportSection")
        ]), C([
            $pn(t),
            A2(ix, g, A2(nc, Be, A2(Ge, A2(Hpn, r, e), vW(n.aw))))
        ]));
    }), Upn = function(n) {
        var r = Bt(Dt(A2(Gu, function(n) {
            return n.b1.lm;
        }, vW(n.aw))));
        return A4(Vpn, n, function(n) {
            return n.b1.lm;
        }, A2(qpn, Mpn, r), "red");
    }, Jpn = Pi({
        bQ: "File summary",
        bX: "R\xe9sum\xe9 fichier"
    }), Zpn = A2(mu, yt, db), Kpn = F2(function(n, r) {
        var t = kpn(A2(Lp, A2(mu, gX, Zpn), n.lA.fU)), e = kpn(A2(Tu, Vq, n.lA.qy));
        return A2(Se, g, C([
            A2(OQ, "File name", r.nW),
            A2(OQ, "Modification date", t),
            A2(OQ, "File size", e)
        ]));
    }), _pn = F2(function(n, r) {
        return A2(Se, C([
            nh("ReportSection")
        ]), C([
            $pn(Jpn),
            A2(Kpn, n, r)
        ]));
    }), Gpn = Pi({
        bQ: "Download the full report (",
        bX: "T\xe9l\xe9charger le rapport complet ("
    }), Ypn = F3(function(n, r, t) {
        return 1 === t.$ ? ch("") : ppn({
            m$: Gpn + (r + ")"),
            r6: Hs(_fn(t.a.mj))
        });
    }), nvn = Pi({
        bQ: "Warnings reported by automated analysis",
        bX: "Signalements relev\xe9s par l'analyse automatique"
    }), rvn = function(n) {
        var r = Bt(Dt(A2(Gu, function(n) {
            return n.b1.dY;
        }, vW(n.aw))));
        return A4(Vpn, n, function(n) {
            return n.b1.dY;
        }, A2(qpn, nvn, r), "orange");
    }, tvn = F4(function(n, r, t, e) {
        return A2(Se, C([
            nh("ReportWrapper")
        ]), C([
            A2(Se, C([
                nh("ReportLinks")
            ]), C([
                A3(Ypn, r, "xml", e.gQ),
                A3(Ypn, r, "pdf", e.gP),
                vpn(n) ? ppn({
                    m$: mpn + (e.lA.nW + " (") + Vq(e.lA.qy) + ")",
                    r6: Hs(_fn(e.lA.mj))
                }) : ch("")
            ])),
            A2(_pn, t, e.lA),
            A2(UT, g, g),
            Ppn(t),
            A2(UT, g, g),
            Upn(t),
            A2(UT, g, g),
            rvn(t)
        ]));
    }), evn = F3(function(n, r) {
        var t = r.bT.f2;
        if (1 === t.$) return ch("");
        var e = t.a, u = A2(Lp, function(n) {
            return n.bn;
        }, e.lA.sc);
        if (1 === u.$) return ch("");
        var a = u.a.cj;
        return 1 === a.$ ? ch("") : A4(tvn, n, r, a.a, e);
    }), uvn = {
        $: 0
    }, avn = Pi({
        bQ: "Processing - downloading stage",
        bX: "En traitement - phase de t\xe9l\xe9chargement"
    }), ivn = Pi({
        bQ: "Processing - encoding stage",
        bX: "En traitement - phase d'encodage"
    }), ovn = Pi({
        bQ: "Finished",
        bX: "Termin\xe9"
    }), cvn = Pi({
        bQ: "Processing - packaging stage",
        bX: "En traitement - phase de packaging"
    }), fvn = Pi({
        bQ: "Processing - uploading stage",
        bX: "En traitement - phase d'upload"
    }), svn = Pi({
        bQ: "Processing - waiting stage",
        bX: "En traitement - phase d'attente"
    }), lvn = function(n) {
        switch(n){
            case 0:
                return svn;
            case 1:
                return avn;
            case 2:
                return ivn;
            case 3:
                return cvn;
            case 4:
                return fvn;
            default:
                return ovn;
        }
    }, dvn = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), bvn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, mvn = F2(function(n, r) {
        return A2(Qu, bvn(n), A2(Tu, function(r) {
            return A2(dvn, n, r);
        }, r));
    }), pvn = Pi({
        bQ: "Done",
        bX: "Termin\xe9"
    }), vvn = function(n) {
        var r = n.dX, t = !!n.o6.$, e = function() {
            var r = n.o6;
            switch(r.$){
                case 0:
                    return pvn;
                case 1:
                    return (t = r.a) + "...";
                default:
                    var t, e = r.b;
                    return "" === (t = r.a) ? zR(e) : t + " : " + zR(e);
            }
        }(), u = !i(n.ll, Ct), a = A2(Qu, u ? 2 : t ? 1 : r ? 3 : 5, n.J);
        return d(kt(t ? 3 : u ? 1 : r ? 2 : 0), A2(Se, C([
            nh("FileOperation")
        ]), C([
            A2(Se, C([
                nh("FileOperationSummary")
            ]), C([
                A2(Se, C([
                    nh("FileOperationIcon")
                ]), C([
                    i(n.eZ, Ct) ? Iun : Bun
                ])),
                A2(Se, C([
                    nh("FileOperationIcon")
                ]), C([
                    n.mi
                ])),
                A2(Se, C([
                    nh("FileOperationLabel")
                ]), C([
                    A2(_h, C([
                        nh("FileOperationLabelTitle")
                    ]), n.m$),
                    A2(_h, C([
                        nh("FileOperationLabelProgress")
                    ]), " (" + e + ")")
                ])),
                A2(Se, C([
                    nh("FileOperationProgress")
                ]), C([
                    mmn({
                        o6: function() {
                            var r = n.o6;
                            switch(r.$){
                                case 0:
                                    return kt(1);
                                case 2:
                                    return kt(r.b);
                                default:
                                    return Ct;
                            }
                        }(),
                        Q: a
                    })
                ]))
            ])),
            function() {
                var r = n.ll;
                if (r.$) {
                    var t = n.eZ;
                    if (1 === t.$) return ch("");
                    var e = t.a;
                    return A2(Se, C([
                        nh("FileOperationDetails")
                    ]), C([
                        A2(ph, C([
                            nh("FileOperationDetailsLabel")
                        ]), C([
                            e.m$
                        ])),
                        wu(e.d1) ? ch("") : A2(Se, C([
                            nh("FileOperationDetailsActions")
                        ]), e.d1)
                    ]));
                }
                var u = r.a;
                return A2(Se, C([
                    nh("FileOperationDetails")
                ]), C([
                    A2(_h, C([
                        nh("FileOperationDetailsLabel")
                    ]), u)
                ]));
            }()
        ])));
    }, $vn = F2(function(n, r) {
        if (1 === r.$) return d(Ct, ch(""));
        var t = r.a.rN;
        if (1 === t.$) return d(Ct, ch(""));
        var e = t.a.oQ, u = t.a.o6, a = t.a.dX;
        return vvn(5 === e ? {
            eZ: Ct,
            ll: Ct,
            mi: ch(""),
            m$: n,
            o6: uvn,
            J: Ct,
            dX: !wu(a)
        } : {
            eZ: Ct,
            ll: Ct,
            mi: ch(""),
            m$: n,
            o6: A2(mvn, lvn(e), u),
            J: Ct,
            dX: !1
        });
    }), gvn = Pi({
        bQ: "Processing",
        bX: "G\xe9n\xe9ration"
    }), hvn = F2(function(n, r) {
        return A3(ye, "format-distance", C([
            A2(ZW, "startdate", db(n)),
            A2(ZW, "enddate", db(r))
        ]), C([
            ch("...")
        ]));
    }), kvn = Pi({
        bQ: "Duration: ",
        bX: "Dur\xe9e : "
    }), Cvn = F2(function(n, r) {
        return A2(Qu, bvn(n), A2(Tu, function(r) {
            return 1 > r ? A2(dvn, n, r) : uvn;
        }, r));
    }), jvn = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), wvn = Pi({
        bQ: "Cancel",
        bX: "Annuler"
    }), Avn = F2(function(n, r) {
        return A2(Dh, wvn, A2(jvn, n, r));
    }), Lvn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), yvn = Pi({
        bQ: "Pause",
        bX: "Pause"
    }), Svn = F2(function(n, r) {
        return A2(Dh, yvn, A2(Lvn, n, r));
    }), Fvn = F3(function(n, r, t) {
        return {
            $: 1,
            a: n,
            b: r,
            c: t
        };
    }), Tvn = Pi({
        bQ: "Resume",
        bX: "Reprendre"
    }), Qvn = F3(function(n, r, t) {
        return A2(Dh, Tvn, A3(Fvn, n, r, t));
    }), Ivn = F5(function(n, r, t, e, u) {
        if (!i(kt(n.dC), e.dC)) return C([
            A2(Avn, n, t)
        ]);
        switch(u.$){
            case 0:
                return C([
                    A2(Svn, n, t),
                    A2(Avn, n, t)
                ]);
            case 1:
            case 4:
            default:
                return g;
            case 2:
                return C([
                    A3(Qvn, n, r, t),
                    A2(Avn, n, t)
                ]);
            case 3:
                return C([
                    A2(Avn, n, t)
                ]);
        }
    }), Bvn = F2(function(n, r) {
        var t = r.ia;
        if (t.$) {
            var e = r.r$;
            if (1 === e.$) return d(Ct, ch(""));
            var u = e.a, a = A3(JR, r.mj, u, n.aa), o = kt(A2(Qu, u.o6, Ra(A2(nc, function(n) {
                return i(r.mj, n.A) ? kt(n.o6) : Ct;
            }, n.aa)))), c = function() {
                switch(a.$){
                    case 0:
                    case 4:
                        return d(Ct, kt(tx(a)));
                    case 1:
                    case 2:
                        return d(kt(4), kt(tx(a)));
                    case 3:
                        return d(kt(0), kt(tx(a)));
                    default:
                        return d(Ct, Ct);
                }
            }(), f = c.a, s = c.b;
            return vvn({
                eZ: function() {
                    if (1 === s.$) return Ct;
                    var t = s.a;
                    return kt({
                        d1: A5(Ivn, n.e8, n.g9.mj, r, u, a),
                        m$: ch(t)
                    });
                }(),
                ll: u.ll,
                mi: ch(""),
                m$: "Upload",
                o6: A2(Cvn, "", o),
                J: f,
                dX: !1
            });
        }
        var l = t.a;
        return vvn({
            eZ: kt({
                d1: g,
                m$: A2(ph, g, C([
                    ch(kvn),
                    A2(hvn, r.ke, l)
                ]))
            }),
            ll: Ct,
            mi: ch(""),
            m$: "Upload",
            o6: uvn,
            J: Ct,
            dX: !1
        });
    }), Wvn = Pi({
        bQ: " errors and ",
        bX: " erreurs et "
    }), Pvn = Pi({
        bQ: "Nothing to report",
        bX: "Rien \xe0 signaler"
    }), Mvn = Pi({
        bQ: "Automated analysis",
        bX: "Analyse automatique"
    }), qvn = Pi({
        bQ: "Unable to generate the verification report: ",
        bX: "Impossible de g\xe9n\xe9rer le rapport de v\xe9rification : "
    }), Dvn = Pi({
        bQ: " warnings.",
        bX: " avertissements."
    }), Xvn = F7(function(n, r, t, e, u, a, o) {
        var c, f, s, l = function() {
            var r = o.lA.r$;
            if (1 === r.$) return !1;
            var t = r.a;
            return i(kt(n.r8.mj), o.lA.r1) && A2(vu, function(n) {
                return !i(n.A, o.lA.mj);
            }, n.aa) && function() {
                switch(A3(JR, o.lA.mj, t, n.aa).$){
                    case 2:
                    case 3:
                    case 0:
                    case 1:
                        return !0;
                    default:
                        return !1;
                }
            }();
        }(), m = function() {
            var r = o.lA.r$;
            if (1 === r.$) return !1;
            var t = r.a;
            return i(kt(n.r8.mj), o.lA.r1) && function() {
                switch(A3(JR, o.lA.mj, t, n.aa).$){
                    case 2:
                    case 3:
                        return i(n.aa, g);
                    default:
                        return !1;
                }
            }();
        }(), v = function(n) {
            var r = n.sc;
            if (1 === r.$) return d(Ct, ch(""));
            var t = r.a, e = function() {
                var n = t.bn;
                if (1 === n.$) {
                    var r = t.ll;
                    return 1 === r.$ ? b(A2(dvn, "", t.o6), Ct, Ct) : b(uvn, kt($(qvn, r.a)), kt({
                        d1: g,
                        m$: ch(Pvn)
                    }));
                }
                var e, u = n.a;
                return b(uvn, u.nY > 0 ? kt($(Bt(u.nY), $(Wvn, $(Bt(u.ar), Dvn)))) : Ct, (e = u.ar > 0 ? $(Bt(u.ar), Dvn) : Pvn, kt({
                    d1: g,
                    m$: ch(e)
                })));
            }(), u = e.a;
            return vvn({
                eZ: e.c,
                ll: e.b,
                mi: ch(""),
                m$: Mvn,
                o6: u,
                J: Ct,
                dX: !1
            });
        }(o.lA), h = v.a, k = v.b, j = A2(Bvn, n, o.lA), w = j.a, A = j.b, L = A2($vn, "Proxy", o.o7.nm), y = L.a, S = L.b, F = A2($vn, "Proxy (hi-res)", o.o7.fv), T = F.a, Q = F.b, I = function(n) {
            var r = n.rN;
            if (1 === r.$) return d(Ct, ch(""));
            var t = r.a.o6, e = r.a.oQ;
            return vvn(5 === e ? {
                eZ: Ct,
                ll: Ct,
                mi: ch(""),
                m$: gvn,
                o6: uvn,
                J: Ct,
                dX: !1
            } : {
                eZ: Ct,
                ll: Ct,
                mi: ch(""),
                m$: gvn,
                o6: A2(mvn, lvn(e), t),
                J: Ct,
                dX: !1
            });
        }(o.lA), B = I.b, W = opn(C([
            I.a,
            h,
            y,
            T,
            w
        ])), P = 3 !== W && A2(Qu, i(o.lA.r1, Ct), A2(Tu, function(n) {
            return !i(n.j_, Ct);
        }, o.lA.r$)), M = !!W || A2(pK, o.lA.mj, t.or), q = function() {
            switch(W){
                case 3:
                    return "FileStatusOperation";
                case 1:
                    return "FileStatusFailure";
                case 2:
                    return "FileStatusWarning";
                default:
                    return "FileStatusSuccess";
            }
        }();
        return A2(Se, C([
            nh("FileItem")
        ]), C([
            A2(Se, C([
                nh("FileStatus"),
                nh(q)
            ]), g),
            A2(Se, C([
                nh("FileContent")
            ]), A2(bt, A2(Se, C([
                nh("FileDescription")
            ]), C([
                A2(Se, C([
                    nh("FileDescriptionTitle")
                ]), C([
                    A2(Se, C([
                        Mh(zmn(o.lA.mj)),
                        nh("FileTitle")
                    ]), C([
                        M ? Iun : Bun,
                        A2(_h, C([
                            nh("FileDescriptionTitleName")
                        ]), o.lA.nW)
                    ])),
                    A4(epn, o.lA, o.o7.nm, u, a),
                    e && 9 === o.lA.c9 ? FW(p(AW, {
                        mi: kt(Wh),
                        m$: Jmn,
                        ol: kt(Omn(o.lA.mj))
                    })) : ch(""),
                    e && P && ren(o.lA) ? FW(p(AW, {
                        lu: C([
                            A2(ZW, "target", "_blank"),
                            A2(ZW, "data-prevent-history", "true"),
                            nh("masterFile")
                        ]),
                        mi: kt(kun),
                        bh: !0,
                        m$: Zmn + " (" + Vq(o.lA.qy) + ")",
                        r6: kt(Hs(_fn(o.lA.mj)))
                    })) : ch("")
                ])),
                A2(Se, C([
                    nh("FileDescriptionDetails")
                ]), C([
                    (s = isn(o.lA), ch(1 === s.$ ? "" : nsn(s.a) + " - ")),
                    ch(Gfn(o.lA.qy)),
                    ch(" "),
                    UA(o.lA.ke)
                ]))
            ])), M ? C([
                B,
                Vmn(n) ? A2(Se, C([
                    Mh(Hmn(o.lA))
                ]), C([
                    k
                ])) : ch(""),
                (f = A2(Lo, o.lA.mj, t.pq), f.$ ? ch("") : f.a && i(kt(o.lA.mj), A2(Tu, function(n) {
                    return n.lA.mj;
                }, r.bT.f2)) ? A3(evn, n, r, {}) : ch("")),
                (c = o.o7.nm, 1 === c.$ ? ch("") : A2(Se, C([
                    Mh(A2(Nmn, c.a.mj, "lowRes"))
                ]), C([
                    S
                ]))),
                function() {
                    var n = o.o7.nm;
                    if (1 === n.$) return ch("");
                    var r = n.a, e = A2(Lo, r.mj + "-lowRes", t.o8);
                    return e.$ ? ch("") : e.a ? A2(bpn, r, bsn(o)) : ch("");
                }(),
                function() {
                    if (n.r8.iz) {
                        var r = o.o7.fv;
                        return 1 === r.$ ? ch("") : A2(Se, C([
                            Mh(A2(Nmn, r.a.mj, "hiRes"))
                        ]), C([
                            Q
                        ]));
                    }
                    return ch("");
                }(),
                function() {
                    var n = o.o7.fv;
                    if (1 === n.$) return ch("");
                    var r = n.a, e = A2(Lo, r.mj + "-hiRes", t.o8);
                    return e.$ ? ch("") : e.a ? A2(bpn, r, bsn(o)) : ch("");
                }(),
                A,
                function() {
                    if (m) return j7(Umn);
                    if (l) return j7(apn);
                    if (A2(NJ, o.lA.mj, t.lm)) {
                        var n = A2(Lo, o.lA.mj, t.lm);
                        return AC(1 === n.$ ? upn : n.a);
                    }
                    return ch("");
                }()
            ]) : g))
        ]));
    }), Evn = F5(function(n, r, t, e, u) {
        var a, i = t.lA, o = t.aw, c = 1 === (a = A2(Tu, function(n) {
            return n.fi;
        }, t.a8)).$ ? "?" : a.a, f = p(r.i6, {
            e5: !1
        }), s = A3(qt, F2(function(n, r) {
            var t = r.a, e = r.b, u = r.c;
            switch(n.$){
                case 0:
                    return b(A2(bt, n.a, t), e, u);
                case 1:
                    return b(t, A2(bt, n.a, e), u);
                default:
                    return b(t, e, u);
            }
        }), b(g, g, g), o), l = s.a, m = A2(Ge, function(n) {
            var r, t, e, u = 1 === (r = n.g$).$ ? "" : A2(xe, 1, r.a), a = 1 === (t = n.m5).$ ? "N/A" : Bt(t.a), i = 1 === (e = n.cK).$ ? "" : " (" + e.a + ")", o = "@" + A2(Qu, "N/A", A2(Tu, Mmn, n.ai));
            return {
                kI: C([
                    d("Codec", n.aF),
                    d(wdn, Wmn(n)),
                    d(Dmn, Bt(n.ih) + "x" + (Bt(n.ft) + (o + i))),
                    d("Framerate", $(FS(e0(n)), u)),
                    d(qmn, a),
                    d("Profil", A2(Qu, "N/A", n.gG)),
                    d("Aspect Ratio", FS(Imn(n)) + ":1")
                ]),
                mi: Rmn,
                rB: "video stream " + A3(ib, 2, "0", Bt(n.fB))
            };
        }, l);
        return A3(Pmn, r, {
            jI: $(A2(Ge, xmn(r), m), C([
                A2(Sk, KV, A5(xbn, n, f, e, !1, kt(d4(-1))))
            ])),
            kI: C([
                d("Type", c),
                d(wdn, A2(Qu, "N/A", A2(Tu, Wmn, Ra(l)))),
                d("Start Timecode", A2(Qu, "N/A", $mn(t)))
            ]),
            lx: Ct,
            mi: Rmn,
            mj: i.mj,
            c9: i.c9,
            qy: i.qy,
            hw: i.hw,
            rB: i.nW,
            r$: i.r$,
            r6: Hs(_fn(i.mj))
        }, function() {
            var t = u.bT.f2;
            if (t.$) return ch("");
            var e = t.a;
            return A2(Sk, A1, A7(Xvn, n, u, r.bT, Xmn(n) || Emn(n), Ct, Ct, e));
        }());
    }), Rvn = Pi({
        bQ: "Main file",
        bX: "Fichier principal"
    }), xvn = Pi({
        bQ: "Download all",
        bX: "Tout t\xe9l\xe9charger"
    }), Ovn = Pi({
        bQ: "Hide details",
        bX: "Masquer les d\xe9tails"
    }), zvn = Pi({
        bQ: "Show details",
        bX: "Afficher les d\xe9tails"
    }), Nvn = function(n) {
        return Pw(Ww(n));
    }, Hvn = Pi({
        bQ: "subtitles",
        bX: "Sous-titres"
    }), Vvn = function(n) {
        return {
            $: 30,
            a: n
        };
    }, Uvn = Pi({
        bQ: "Hide",
        bX: "Masquer"
    }), Jvn = Pi({
        bQ: "Show",
        bX: "Afficher"
    }), Zvn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Kvn = Pi({
        bQ: "Subtitle analysis",
        bX: "Analyse des sous-titres"
    }), _vn = F2(function(n, r) {
        var t, e, u = vvn({
            eZ: Ct,
            ll: Ct,
            mi: ch(""),
            m$: Kvn,
            o6: uvn,
            J: Ct,
            dX: !wu(r.hI)
        }), a = u.b, i = opn(C([
            u.a
        ])), o = function() {
            switch(i){
                case 3:
                    return "FileStatusOperation";
                case 1:
                    return "FileStatusFailure";
                case 2:
                    return "FileStatusWarning";
                default:
                    return "FileStatusSuccess";
            }
        }();
        return A2(Se, C([
            nh("FileItem")
        ]), C([
            A2(Se, C([
                nh("FileStatus"),
                nh(o)
            ]), g),
            A2(Se, C([
                nh("FileContent")
            ]), C([
                A2(Se, C([
                    Mh(Zvn(r.lA))
                ]), C([
                    a
                ])),
                (e = A2(Lo, r.lA.mj, n.hI), e.$ ? ch("") : e.a ? wu((t = r).hI) ? ch("") : A2(Se, C([
                    nh("FileOperationWarning")
                ]), C([
                    cpn("Warnings"),
                    Mbn($(C([
                        Lbn(C([
                            Dbn(ch("Warning")),
                            Dbn(ch("Timecode"))
                        ]))
                    ]), A2(Ge, function(n) {
                        return A2(zk, C([
                            nh("TranscodeWarning")
                        ]), C([
                            A2(gC, C([
                                nh("TranscodeWarningField")
                            ]), C([
                                ch(n.nW)
                            ])),
                            A2(gC, C([
                                nh("TranscodeWarningField")
                            ]), C([
                                ch(n.hZ)
                            ]))
                        ]));
                    }, t.hI)))
                ])) : ch(""))
            ]))
        ]));
    }), Gvn = F4(function(n, r, t, e) {
        var u, a, o, c, f = A2(Tu, fj, e.sd), s = A2(Tu, rQ, e.rQ);
        return A2(Se, C([
            nh("MasterFilesAudioStream")
        ]), C([
            A2(Se, C([
                nh("MasterFilesHeader")
            ]), C([
                Sdn,
                A2(_h, C([
                    nh("MasterFilesTitle")
                ]), e.rB),
                A2(Se, C([
                    nh("MasterQualify")
                ]), C([
                    A2(qC, _h(C([
                        nh("MasterQualifyItem")
                    ])), f),
                    A2(qC, _h(C([
                        nh("MasterQualifyItem")
                    ])), s),
                    A2(Se, C([
                        nh("PlayAudio")
                    ]), C([
                        5 === e.oQ ? FW(p(AW, {
                            mi: kt(tpn),
                            m$: function() {
                                var n = r.oR;
                                return n.$ ? Jvn : i(n.a.q4, e.gL) ? Uvn : Jvn;
                            }(),
                            ol: kt(Vvn((c = r.oR, c.$ ? e.gL : i(c.a.q4, e.gL) ? Ct : e.gL)))
                        })) : ch("")
                    ]))
                ]))
            ])),
            A2(JT, !wu(t.hI), A2(Se, C([
                nh("MasterFilesAsset")
            ]), C([
                A2(Sk, A1, A2(_vn, r.bT, t))
            ]))),
            A2(Se, C([
                nh("MasterFilesDesc")
            ]), (u = Ebn(e.kI), a = u.a, o = u.b, C([
                Mbn(C([
                    Lbn(A2(Ge, A2(mu, Dbn, ch), a)),
                    Xbn(A2(Ge, A2(mu, qbn, ch), o))
                ]))
            ])))
        ]));
    }), Yvn = F3(function(n, r, t) {
        var e, u, a = t.lA, i = t.aw, o = t.o7, c = A2(Lp, function(n) {
            return 2 === n.$ ? n.a.sd : Ct;
        }, Ra(i)), f = A2(Lp, function(n) {
            return 2 === n.$ ? n.a.rQ : Ct;
        }, Ra(i)), s = A2(Qu, {
            ff: Ct,
            lS: Ct,
            fT: Ct,
            qO: Ct,
            hF: Ct
        }, A2(Tu, function(n) {
            if (2 === n.$) {
                var r = n.a;
                return {
                    ff: r.ff,
                    lS: A3(RS, F2(function(n, r) {
                        return xc(1e3 * n / r) / 1e3;
                    }), r.fm, r.fl),
                    fT: r.fT,
                    qO: r.qO,
                    hF: r.hF
                };
            }
            return {
                ff: Ct,
                lS: Ct,
                fT: Ct,
                qO: Ct,
                hF: Ct
            };
        }, Ra(i))), l = s.lS, b = s.qO, m = s.ff, p = s.fT, v = s.hF, $ = 1 === (e = A2(Tu, function(n) {
            return n.fi;
        }, t.a8)).$ ? A2(Qu, "?", v) : e.a, h = (u = A2(Tu, function(e) {
            var u;
            return A4(Gvn, n, r, t, {
                kI: C([
                    d("Type", $),
                    d("Framerate", A2(Qu, "N/A", A2(Tu, FS, l))),
                    d("Start Timecode", A2(Qu, "N/A", b)),
                    d("First Subtitle Timecode", A2(Qu, "N/A", m)),
                    d("Last Subtitle Timecode", A2(Qu, "N/A", p))
                ]),
                mi: Sdn,
                fR: a.mj,
                oQ: (u = e.rN, u.$ ? 0 : u.a.oQ),
                gL: A2(Tu, function(n) {
                    return n.mj;
                }, o.nm),
                rB: Hvn,
                rQ: f,
                sd: c
            });
        }, o.nm)).$ ? g : za(u.a);
        return A7(pmn, r.qo, A3(omn, n.r8, n.g9.oz, A2(Ge, function(n) {
            return n.fH;
        }, n.fJ)), r, n.r8, {
            jI: h,
            kI: g,
            lx: Ct,
            mi: kdn,
            mj: a.mj,
            c9: a.c9,
            qy: a.qy,
            hw: a.hw,
            rB: a.nW,
            r$: a.r$,
            r6: Hs(_fn(a.mj))
        }, "subtitleFile", ch(""));
    }), n$n = F5(function(n, r, t, e, u) {
        var a = A2(Nvn, A2(Po, function(n) {
            return n.lA;
        }, function(n) {
            return n.nW;
        }), u.bT.ae), o = A2(Nvn, A2(Po, function(n) {
            return n.lA;
        }, function(n) {
            return n.nW;
        }), u.bT.ef), c = Xmn(t) || Emn(t);
        return A2(Se, C([
            nh("MasterFilesWrapper")
        ]), C([
            A2(tmn, !i(u.bT.f2, Ct), A2(Se, C([
                nh("ReversedLayout")
            ]), C([
                Kq(Rvn),
                FW(p(AW, {
                    mi: kt(UW),
                    mD: r.qm,
                    m$: r.qm ? Ovn : zvn,
                    ol: kt(umn)
                }))
            ]))),
            function() {
                var n = u.bT.f2;
                return n.$ ? ch("") : A2(Se, g, C([
                    A5(Evn, t, r, n.a, e, u)
                ]));
            }(),
            A2(tmn, !i(u.bT.ef, g), Uq(C([
                Kq(Qmn),
                A2(JT, c, FW(p(AW, {
                    mi: kt(kun),
                    m$: xvn,
                    ol: kt(emn("audioFile"))
                }))),
                uln,
                FW(p(AW, {
                    mi: kt(UW),
                    mD: r.qn,
                    m$: r.qn ? Ovn : zvn,
                    ol: kt(amn)
                }))
            ]))),
            A2(tmn, !i(u.bT.ef, g), A2(Se, g, A2(Ge, A3(Tmn, n, t, r), o))),
            A2(tmn, !i(u.bT.ae, g), Uq(C([
                Kq(Hvn),
                A2(JT, c, FW(p(AW, {
                    mi: kt(kun),
                    m$: xvn,
                    ol: kt(emn("subtitleFile"))
                }))),
                uln,
                FW(p(AW, {
                    mi: kt(UW),
                    mD: r.qo,
                    m$: r.qo ? Ovn : zvn,
                    ol: kt(imn)
                }))
            ]))),
            A2(tmn, !i(u.bT.ae, g), A2(Se, g, A2(Ge, A2(Yvn, t, r), a)))
        ]));
    }), r$n = function(n) {
        var r = n.o7.nm;
        if (r.$) return !1;
        var t = r.a.rN;
        return !t.$ && 5 === t.a.oQ;
    }, t$n = F2(function(n, r) {
        return A2(Qu, g, Ra(A2(Ge, function(n) {
            return n.aw;
        }, A2(Bu, A2(Po, function(n) {
            return n.o7;
        }, A2(Po, function(n) {
            return n.nm;
        }, F2(function(n, r) {
            return A2(Qu, !1, A2(Tu, function(r) {
                return i(n, kt(r.mj));
            }, r));
        })(n))), A2(Bu, r$n, r)))));
    }), e$n = function(n) {
        return A2(Ge, function(n) {
            return {
                a8: Ct,
                kE: g,
                lA: n.lA,
                o7: {
                    fv: Ct,
                    nm: n.gL
                },
                gP: Ct,
                gQ: Ct,
                g3: n.g3,
                aw: g,
                hI: g
            };
        }, A2(Pw, Ww(A2(Po, function(n) {
            return n.lA;
        }, function(n) {
            return n.nW;
        })), n.bS));
    }, u$n = function(n) {
        return A2(Lp, A2(Po, function(n) {
            return n.o7;
        }, function(n) {
            return n.nm;
        }), n.bT.f2);
    }, a$n = function(n) {
        if (n.$) return !1;
        var r = n.a.rN;
        return !r.$ && 5 === r.a.oQ;
    }, i$n = {
        $: 0
    }, o$n = {
        $: 31
    }, c$n = irn(C([
        A2(Th, C([
            Vg("Fg"),
            Lh("6 5 12 9 6 13")
        ]), g)
    ])), f$n = Pi({
        bQ: "Play",
        bX: "Play"
    }), s$n = Pi({
        bQ: "Audios(s)",
        bX: "Audio(s)"
    }), l$n = Pi({
        bQ: "Video format",
        bX: "Format Video"
    }), d$n = Pi({
        bQ: "Main file specifications",
        bX: "Description technique du fichier principal"
    }), b$n = Pi({
        bQ: " audio stream(s)",
        bX: " stream(s) audio(s)"
    }), m$n = C([
        d(2997, 100),
        d(3e4, 1001),
        d(5994, 100),
        d(6e4, 1001)
    ]), p$n = F2(function(n, r) {
        var t, e = A2(mg, d(n.au, n.at), m$n) ? A2(Me, ";", r) ? "DF" : "NDF" : "", u = function() {
            var r = n.cK;
            return 1 === r.$ ? "" : " (" + r.a + ")";
        }(), a = "@" + A2(Qu, "N/A", A2(Tu, Mmn, n.ai));
        return A2(Wt, " \u2022 ", C([
            (t = n.aj, t.toUpperCase()),
            Bt(n.ih) + "x" + (Bt(n.ft) + (a + u)),
            FS(e0(n)) + " fps " + e,
            FS(Imn(n)) + ":1"
        ]));
    }), v$n = F4(function(n, r, t, e) {
        var u = A2(xi, function(n) {
            return n.bd;
        }, t), a = n.au / n.at, i = function(r) {
            return B5(r) + " (" + A2(Bmn, n, (1 + r.be - r.bd) / a) + ")";
        };
        return A2(Se, C([
            nh("PlayerFoldInfos")
        ]), C([
            A2(Se, C([
                nh("PlayerFoldInfosTitle")
            ]), C([
                ch(d$n)
            ])),
            A2(Se, C([
                nh("PlayerFoldInfo")
            ]), C([
                A2(_h, C([
                    nh("PlayerFoldInfoLabel")
                ]), l$n),
                A2(_h, C([
                    nh("PlayerFoldInfoValue")
                ]), A2(p$n, n, e))
            ])),
            A2(Se, C([
                nh("PlayerFoldInfo")
            ]), C([
                A2(_h, C([
                    nh("PlayerFoldInfoLabel")
                ]), wdn),
                A2(_h, C([
                    nh("PlayerFoldInfoValue")
                ]), Wmn(n))
            ])),
            A2(Se, C([
                nh("PlayerFoldInfo")
            ]), C([
                A2(_h, C([
                    nh("PlayerFoldInfoLabel")
                ]), s$n),
                A2(Se, C([
                    nh("PlayerFoldInfoValues")
                ]), C([
                    A2(_h, C([
                        nh("PlayerFoldInfoValue")
                    ]), $(Bt(Dt(r)), b$n))
                ]))
            ])),
            wu(t) ? ch("") : A2(Se, C([
                nh("PlayerFoldInfo")
            ]), C([
                A2(_h, C([
                    nh("PlayerFoldInfoLabel")
                ]), Ion),
                A2(Se, C([
                    nh("PlayerFoldInfoValues")
                ]), A2(Ge, A2(mu, _h(C([
                    nh("PlayerFoldInfoValue")
                ])), i), u))
            ]))
        ]));
    }), $$n = {
        $: 8
    }, g$n = {
        $: 7
    }, h$n = F2(function(n, r) {
        return {
            $: 9,
            a: n,
            b: r
        };
    }), k$n = {
        $: 3
    }, C$n = {
        $: 2
    }, j$n = {
        $: 4
    }, w$n = {
        $: 5
    }, A$n = function(n) {
        return {
            $: 10,
            a: n
        };
    }, L$n = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), y$n = A2(Qh, C([
        Ah("1080"),
        Bh("1920"),
        Ih("0 0 1920 1080")
    ]), C([
        A2(Mrn, C([
            q7("#74F7FF"),
            Ah("3"),
            Bh("1920"),
            Drn("22")
        ]), g),
        A2(Mrn, C([
            q7("#70FF00"),
            Ah("3"),
            Bh("1920"),
            Drn("133")
        ]), g),
        A2(Mrn, C([
            q7("#FF4BF8"),
            Ah("3"),
            Bh("1920"),
            Drn("140")
        ]), g),
        A2(Mrn, C([
            q7("#FF4BF8"),
            Ah("3"),
            Bh("1920"),
            Drn("940")
        ]), g),
        A2(Mrn, C([
            q7("#70FF00"),
            Ah("3"),
            Bh("1920"),
            Drn("947")
        ]), g),
        A2(Mrn, C([
            q7("#74F7FF"),
            Ah("3"),
            Bh("1920"),
            Drn("1058")
        ]), g),
        A2(Mrn, C([
            q7("#74F7FF"),
            Ah("31"),
            Bh("58"),
            Drn("22")
        ]), g),
        A2(Mrn, C([
            q7("#70FF00"),
            Ah("31"),
            Bh("58"),
            Drn("105")
        ]), g),
        A2(Mrn, C([
            q7("#FF4BF8"),
            Ah("31"),
            Bh("58"),
            Drn("140")
        ]), g),
        A2(Cj, C([
            kj("M13.6935 43H10.783V31.0332L7.30859 32.1826V29.6582L13.3813 27.3379H13.6935V43ZM18.7389 41.4746C18.7389 40.9805 18.8933 40.5794 19.2022 40.2715C19.5178 39.9635 19.9105 39.8096 20.3805 39.8096C20.8572 39.8096 21.2499 39.9635 21.5587 40.2715C21.8743 40.5794 22.0321 40.9805 22.0321 41.4746C22.0321 41.9616 21.8777 42.359 21.5689 42.667C21.26 42.9678 20.8639 43.1182 20.3805 43.1182C19.9038 43.1182 19.511 42.9678 19.2022 42.667C18.8933 42.359 18.7389 41.9616 18.7389 41.4746ZM34.0265 31.5166C34.0265 32.2757 33.8485 32.9489 33.4926 33.5361C33.1369 34.1234 32.6467 34.5924 32.0224 34.9434C32.734 35.3086 33.298 35.8135 33.7143 36.458C34.1305 37.0954 34.3386 37.8473 34.3386 38.7139C34.3386 40.1032 33.8955 41.2025 33.0093 42.0117C32.123 42.8138 30.9179 43.2148 29.3939 43.2148C27.8698 43.2148 26.6613 42.8102 25.7684 42.001C24.8754 41.1917 24.429 40.096 24.429 38.7139C24.429 37.8473 24.6371 37.0918 25.0534 36.4473C25.4696 35.8027 26.0302 35.3014 26.7351 34.9434C26.1108 34.5924 25.6206 34.1234 25.2649 33.5361C24.9157 32.9489 24.7412 32.2757 24.7412 31.5166C24.7412 30.1846 25.1574 29.1247 25.9899 28.3369C26.8224 27.542 27.9537 27.1445 29.3838 27.1445C30.8071 27.1445 31.9351 27.5384 32.7676 28.3262C33.6068 29.1068 34.0265 30.1702 34.0265 31.5166ZM31.418 38.4883C31.418 37.8079 31.2335 37.2637 30.8642 36.8555C30.4949 36.4473 29.9981 36.2432 29.3737 36.2432C28.756 36.2432 28.2626 36.4473 27.8933 36.8555C27.524 37.2565 27.3395 37.8008 27.3395 38.4883C27.3395 39.1543 27.5207 39.6914 27.8832 40.0996C28.2458 40.5078 28.7494 40.7119 29.3939 40.7119C30.0249 40.7119 30.5184 40.515 30.8743 40.1211C31.2368 39.7272 31.418 39.1829 31.418 38.4883ZM31.116 31.667C31.116 31.0583 30.9649 30.5713 30.6628 30.2061C30.3606 29.8337 29.9344 29.6475 29.3838 29.6475C28.8399 29.6475 28.417 29.8265 28.1149 30.1846C27.8127 30.5426 27.6617 31.0368 27.6617 31.667C27.6617 32.29 27.8127 32.7913 28.1149 33.1709C28.417 33.5505 28.8433 33.7402 29.3939 33.7402C29.9444 33.7402 30.3674 33.5505 30.6628 33.1709C30.9649 32.7913 31.116 32.29 31.116 31.667ZM36.7456 35.3086L37.5915 27.3594H45.8092V29.9482H39.9783L39.6157 33.3105C40.3072 32.9167 41.0424 32.7197 41.8212 32.7197C43.2177 32.7197 44.312 33.1816 45.1043 34.1055C45.8965 35.0293 46.2927 36.3219 46.2927 37.9834C46.2927 38.9932 46.0912 39.8991 45.6884 40.7012C45.2923 41.4961 44.7216 42.1156 43.9763 42.5596C43.2311 42.9964 42.3516 43.2148 41.3378 43.2148C40.4516 43.2148 39.6291 43.0251 38.8705 42.6455C38.1118 42.2588 37.511 41.7181 37.0678 41.0234C36.6314 40.3288 36.3997 39.5374 36.3729 38.6494H39.2532C39.3136 39.3011 39.5251 39.8096 39.8876 40.1748C40.2569 40.5329 40.7369 40.7119 41.3278 40.7119C41.9857 40.7119 42.4926 40.4613 42.8484 39.96C43.2043 39.4515 43.3822 38.7354 43.3822 37.8115C43.3822 36.9235 43.1774 36.2432 42.7679 35.7705C42.3583 35.2979 41.7776 35.0615 41.0256 35.0615C40.3341 35.0615 39.7735 35.2549 39.3438 35.6416L39.0619 35.9209L36.7456 35.3086Z"),
            q7("black")
        ]), g),
        A2(Cj, C([
            kj("M16.6709 125H6.62018V122.873L11.3635 117.48C12.0148 116.721 12.4949 116.059 12.8037 115.493C13.1192 114.927 13.277 114.39 13.277 113.882C13.277 113.187 13.1125 112.643 12.7835 112.249C12.4545 111.848 11.9846 111.648 11.3736 111.648C10.7157 111.648 10.1954 111.891 9.81267 112.378C9.43664 112.858 9.24866 113.492 9.24866 114.279H6.32812C6.32812 113.327 6.53962 112.457 6.96259 111.669C7.39227 110.881 7.99653 110.265 8.77533 109.821C9.55411 109.37 10.437 109.145 11.424 109.145C12.9345 109.145 14.1061 109.531 14.9386 110.305C15.7779 111.078 16.1975 112.17 16.1975 113.581C16.1975 114.354 16.0095 115.142 15.6335 115.944C15.2576 116.746 14.613 117.681 13.6999 118.748L10.3665 122.497H16.6709V125ZM18.7353 123.475C18.7353 122.98 18.8897 122.579 19.1986 122.271C19.5142 121.964 19.9069 121.81 20.3769 121.81C20.8536 121.81 21.2463 121.964 21.5551 122.271C21.8707 122.579 22.0285 122.98 22.0285 123.475C22.0285 123.962 21.8741 124.359 21.5653 124.667C21.2565 124.968 20.8603 125.118 20.3769 125.118C19.9002 125.118 19.5075 124.968 19.1986 124.667C18.8897 124.359 18.7353 123.962 18.7353 123.475ZM27.4264 115.805H28.9773C29.7159 115.805 30.2631 115.608 30.6189 115.214C30.9748 114.82 31.1526 114.297 31.1526 113.646C31.1526 113.015 30.9748 112.525 30.6189 112.174C30.2698 111.823 29.7864 111.648 29.1687 111.648C28.6114 111.648 28.1448 111.812 27.7689 112.142C27.3929 112.464 27.2049 112.886 27.2049 113.409H24.2944C24.2944 112.593 24.4992 111.862 24.9088 111.218C25.325 110.566 25.9024 110.058 26.6409 109.692C27.3862 109.327 28.2053 109.145 29.0982 109.145C30.6491 109.145 31.8644 109.542 32.7438 110.337C33.6234 111.125 34.0631 112.213 34.0631 113.603C34.0631 114.319 33.8583 114.978 33.4488 115.579C33.0392 116.181 32.5021 116.643 31.8375 116.965C32.6633 117.28 33.2775 117.753 33.6804 118.383C34.09 119.013 34.2947 119.758 34.2947 120.617C34.2947 122.007 33.818 123.12 32.8647 123.958C31.9181 124.796 30.6626 125.215 29.0982 125.215C27.6345 125.215 26.4361 124.803 25.503 123.979C24.5764 123.156 24.1132 122.067 24.1132 120.714H27.0236C27.0236 121.301 27.2284 121.781 27.6379 122.153C28.0542 122.526 28.5645 122.712 29.1687 122.712C29.8603 122.712 30.4007 122.519 30.7901 122.132C31.1863 121.738 31.3843 121.219 31.3843 120.574C31.3843 119.013 30.5786 118.232 28.9673 118.232H27.4264V115.805ZM36.742 117.309L37.5879 109.359H45.8056V111.948H39.9747L39.6121 115.311C40.3036 114.917 41.0388 114.72 41.8176 114.72C43.2141 114.72 44.3085 115.182 45.1007 116.105C45.8929 117.029 46.2891 118.322 46.2891 119.983C46.2891 120.993 46.0876 121.899 45.6848 122.701C45.2887 123.496 44.718 124.116 43.9727 124.56C43.2275 124.996 42.348 125.215 41.3342 125.215C40.448 125.215 39.6255 125.025 38.8669 124.646C38.1082 124.259 37.5074 123.718 37.0642 123.023C36.6278 122.329 36.3961 121.537 36.3693 120.649H39.2496C39.31 121.301 39.5215 121.81 39.884 122.175C40.2533 122.533 40.7333 122.712 41.3242 122.712C41.9821 122.712 42.489 122.461 42.8448 121.96C43.2007 121.451 43.3786 120.735 43.3786 119.812C43.3786 118.924 43.1738 118.243 42.7643 117.771C42.3547 117.298 41.774 117.062 41.022 117.062C40.3305 117.062 39.7699 117.255 39.3402 117.642L39.0583 117.921L36.742 117.309Z"),
            q7("black")
        ]), g),
        A2(Cj, C([
            kj("M16.6709 163H6.62018V160.873L11.3635 155.48C12.0148 154.721 12.4949 154.059 12.8037 153.493C13.1192 152.927 13.277 152.39 13.277 151.882C13.277 151.187 13.1125 150.643 12.7835 150.249C12.4545 149.848 11.9846 149.647 11.3736 149.647C10.7157 149.647 10.1954 149.891 9.81267 150.378C9.43664 150.858 9.24866 151.492 9.24866 152.279H6.32812C6.32812 151.327 6.53962 150.457 6.96259 149.669C7.39227 148.881 7.99653 148.265 8.77533 147.821C9.55411 147.37 10.437 147.145 11.424 147.145C12.9345 147.145 14.1061 147.531 14.9386 148.305C15.7779 149.078 16.1975 150.17 16.1975 151.581C16.1975 152.354 16.0095 153.142 15.6335 153.944C15.2576 154.746 14.613 155.681 13.6999 156.748L10.3665 160.497H16.6709V163ZM18.7353 161.475C18.7353 160.98 18.8897 160.579 19.1986 160.271C19.5142 159.964 19.9069 159.81 20.3769 159.81C20.8536 159.81 21.2463 159.964 21.5551 160.271C21.8707 160.579 22.0285 160.98 22.0285 161.475C22.0285 161.962 21.8741 162.359 21.5653 162.667C21.2565 162.968 20.8603 163.118 20.3769 163.118C19.9002 163.118 19.5075 162.968 19.1986 162.667C18.8897 162.359 18.7353 161.962 18.7353 161.475ZM27.4264 153.805H28.9773C29.7159 153.805 30.2631 153.608 30.6189 153.214C30.9748 152.82 31.1526 152.297 31.1526 151.646C31.1526 151.015 30.9748 150.525 30.6189 150.174C30.2698 149.823 29.7864 149.647 29.1687 149.647C28.6114 149.647 28.1448 149.812 27.7689 150.142C27.3929 150.464 27.2049 150.886 27.2049 151.409H24.2944C24.2944 150.593 24.4992 149.862 24.9088 149.218C25.325 148.566 25.9024 148.058 26.6409 147.692C27.3862 147.327 28.2053 147.145 29.0982 147.145C30.6491 147.145 31.8644 147.542 32.7438 148.337C33.6234 149.125 34.0631 150.213 34.0631 151.603C34.0631 152.319 33.8583 152.978 33.4488 153.579C33.0392 154.181 32.5021 154.643 31.8375 154.965C32.6633 155.28 33.2775 155.753 33.6804 156.383C34.09 157.013 34.2947 157.758 34.2947 158.617C34.2947 160.007 33.818 161.12 32.8647 161.958C31.9181 162.796 30.6626 163.215 29.0982 163.215C27.6345 163.215 26.4361 162.803 25.503 161.979C24.5764 161.156 24.1132 160.067 24.1132 158.714H27.0236C27.0236 159.301 27.2284 159.781 27.6379 160.153C28.0542 160.526 28.5645 160.712 29.1687 160.712C29.8603 160.712 30.4007 160.519 30.7901 160.132C31.1863 159.738 31.3843 159.219 31.3843 158.574C31.3843 157.013 30.5786 156.232 28.9673 156.232H27.4264V153.805ZM43.1168 156.748C42.3581 157.543 41.4719 157.94 40.458 157.94C39.1623 157.94 38.125 157.468 37.3462 156.522C36.5674 155.57 36.178 154.288 36.178 152.677C36.178 151.653 36.3861 150.715 36.8024 149.862C37.2254 149.003 37.8128 148.337 38.5648 147.864C39.3167 147.384 40.1626 147.145 41.1026 147.145C42.0694 147.145 42.9287 147.402 43.6807 147.918C44.4327 148.434 45.0168 149.175 45.4331 150.142C45.8493 151.108 46.0608 152.215 46.0675 153.461V154.61C46.0675 157.217 45.4599 159.265 44.2447 160.755C43.0295 162.244 41.3074 163.039 39.0783 163.14L38.3634 163.15V160.562L39.0079 160.551C41.539 160.429 42.9087 159.161 43.1168 156.748ZM41.1731 155.566C41.643 155.566 42.0459 155.438 42.3816 155.18C42.724 154.922 42.9825 154.61 43.157 154.245V152.967C43.157 151.914 42.969 151.098 42.5931 150.518C42.2171 149.938 41.7135 149.647 41.0824 149.647C40.4984 149.647 40.0184 149.934 39.6423 150.507C39.2664 151.073 39.0783 151.785 39.0783 152.645C39.0783 153.497 39.2596 154.199 39.6222 154.75C39.9915 155.294 40.5084 155.566 41.1731 155.566Z"),
            q7("black")
        ]), g)
    ])), S$n = rpn(C([
        A2(Mrn, C([
            Vg("Fg"),
            Ah("1"),
            Bh("18"),
            qrn("0"),
            Drn("2")
        ]), g),
        A2(Mrn, C([
            Vg("Fg"),
            Ah("1"),
            Bh("18"),
            qrn("0"),
            Drn("4")
        ]), g),
        A2(Mrn, C([
            Vg("Fg"),
            Ah("1"),
            Bh("18"),
            qrn("0"),
            Drn("12")
        ]), g),
        A2(Mrn, C([
            Vg("Fg"),
            Ah("1"),
            Bh("18"),
            qrn("0"),
            Drn("14")
        ]), g)
    ])), F$n = rpn(C([
        A2(Cj, C([
            Vg("Fg"),
            kj("M5.04443 10.3306H1.81641V8.92871H5.04443V10.3306ZM9.34238 13H7.52695V7.2207L5.74375 7.7417V6.3667L9.17588 5.17969H9.34238V13ZM13.6726 11.3672C13.6726 11.2132 13.592 11.0897 13.4309 10.9966C13.2697 10.9035 12.9636 10.8068 12.5124 10.7065C12.0612 10.6063 11.6888 10.4756 11.3952 10.3145C11.1016 10.1497 10.8778 9.95101 10.7238 9.71826C10.5699 9.48551 10.4929 9.21875 10.4929 8.91797C10.4929 8.38444 10.7131 7.9458 11.1535 7.60205C11.5939 7.25472 12.1704 7.08105 12.883 7.08105C13.6493 7.08105 14.2652 7.25472 14.7307 7.60205C15.1962 7.94938 15.4289 8.40592 15.4289 8.97168H13.6135C13.6135 8.50618 13.3682 8.27344 12.8776 8.27344C12.6879 8.27344 12.5285 8.32715 12.3996 8.43457C12.2707 8.53841 12.2063 8.66911 12.2063 8.82666C12.2063 8.98779 12.285 9.11849 12.4426 9.21875C12.6001 9.31901 12.8508 9.40137 13.1945 9.46582C13.5419 9.53027 13.8462 9.60726 14.1076 9.69678C14.9813 9.99756 15.4182 10.5365 15.4182 11.3135C15.4182 11.8434 15.1818 12.2749 14.7092 12.6079C14.2401 12.9409 13.6314 13.1074 12.883 13.1074C12.3853 13.1074 11.9413 13.0179 11.551 12.8389C11.1607 12.6598 10.8563 12.4163 10.6379 12.1084C10.4195 11.8005 10.3103 11.4764 10.3103 11.1362H12.0021C12.0093 11.4048 12.0988 11.6017 12.2707 11.7271C12.4426 11.8488 12.6628 11.9097 12.9313 11.9097C13.1784 11.9097 13.3628 11.8595 13.4846 11.7593C13.6099 11.659 13.6726 11.5283 13.6726 11.3672Z")
        ]), g)
    ])), T$n = Pi({
        bQ: "Back 1s",
        bX: "Retour 1s en arri\xe8re"
    }), Q$n = rpn(C([
        A2(Cj, C([
            Vg("Fg"),
            kj("M4.04443 10.3306H0.816406V8.92871H4.04443V10.3306ZM5.5376 9.17578L6.01562 5.17969H10.5864V6.58691H7.4873L7.31006 8.13916C7.43896 8.06396 7.60726 7.99772 7.81494 7.94043C8.0262 7.88314 8.2321 7.85449 8.43262 7.85449C9.20964 7.85449 9.80583 8.08545 10.2212 8.54736C10.6401 9.0057 10.8496 9.65023 10.8496 10.481C10.8496 10.9823 10.7368 11.437 10.5112 11.8452C10.2892 12.2498 9.97591 12.5614 9.57129 12.7798C9.16667 12.9982 8.68864 13.1074 8.13721 13.1074C7.64665 13.1074 7.18652 13.0072 6.75684 12.8066C6.32715 12.6025 5.99056 12.325 5.74707 11.9741C5.50358 11.6196 5.38363 11.2204 5.38721 10.7764H7.20264C7.22054 11.0628 7.31185 11.2902 7.47656 11.4585C7.64128 11.6268 7.85791 11.7109 8.12646 11.7109C8.73519 11.7109 9.03955 11.2598 9.03955 10.3574C9.03955 9.52311 8.66715 9.10596 7.92236 9.10596C7.49984 9.10596 7.18473 9.24202 6.97705 9.51416L5.5376 9.17578ZM14.8726 11.3672C14.8726 11.2132 14.792 11.0897 14.6309 10.9966C14.4697 10.9035 14.1636 10.8068 13.7124 10.7065C13.2612 10.6063 12.8888 10.4756 12.5952 10.3145C12.3016 10.1497 12.0778 9.95101 11.9238 9.71826C11.7699 9.48551 11.6929 9.21875 11.6929 8.91797C11.6929 8.38444 11.9131 7.9458 12.3535 7.60205C12.7939 7.25472 13.3704 7.08105 14.083 7.08105C14.8493 7.08105 15.4652 7.25472 15.9307 7.60205C16.3962 7.94938 16.6289 8.40592 16.6289 8.97168H14.8135C14.8135 8.50618 14.5682 8.27344 14.0776 8.27344C13.8879 8.27344 13.7285 8.32715 13.5996 8.43457C13.4707 8.53841 13.4062 8.66911 13.4062 8.82666C13.4062 8.98779 13.485 9.11849 13.6426 9.21875C13.8001 9.31901 14.0508 9.40137 14.3945 9.46582C14.7419 9.53027 15.0462 9.60726 15.3076 9.69678C16.1813 9.99756 16.6182 10.5365 16.6182 11.3135C16.6182 11.8434 16.3818 12.2749 15.9092 12.6079C15.4401 12.9409 14.8314 13.1074 14.083 13.1074C13.5853 13.1074 13.1413 13.0179 12.751 12.8389C12.3607 12.6598 12.0563 12.4163 11.8379 12.1084C11.6195 11.8005 11.5103 11.4764 11.5103 11.1362H13.2021C13.2093 11.4048 13.2988 11.6017 13.4707 11.7271C13.6426 11.8488 13.8628 11.9097 14.1313 11.9097C14.3784 11.9097 14.5628 11.8595 14.6846 11.7593C14.8099 11.659 14.8726 11.5283 14.8726 11.3672Z")
        ]), g)
    ])), I$n = Pi({
        bQ: "Back 5s",
        bX: "Retour 5s en arri\xe8re"
    }), B$n = rpn(C([
        A2(Th, C([
            Vg("Fg"),
            Lh("11 5 11 13 6 9")
        ]), g)
    ])), W$n = Pi({
        bQ: "Error",
        bX: "Erreur"
    }), P$n = function(n) {
        return A2(Ng, "tabIndex", Bt(n));
    }, M$n = A2(rk, C([
        nh("TimecodeInput"),
        nh("TimecodeEditable"),
        P$n(0),
        qh("text")
    ]), g), q$n = Pi({
        bQ: "End",
        bX: "Fin"
    }), D$n = rpn(C([
        A2(Th, C([
            Vg("Fg"),
            Lh("7 5 7 13 12 9")
        ]), g),
        A2(Th, C([
            Vg("Fg"),
            Lh("3 5 3 13 8 9")
        ]), g),
        A2(Mrn, C([
            Vg("Fg"),
            Ah("8"),
            Bh("1.5"),
            qrn("11.75"),
            Drn("5")
        ]), g)
    ])), X$n = rpn(C([
        A2(Th, C([
            Vg("Fg"),
            Lh("7 5 7 13 12 9")
        ]), g)
    ])), E$n = rpn(C([
        A2(Cj, C([
            Vg("Fg"),
            kj("M9.1347656 5.1386719 L5.7011719 6.3242188 L5.7011719 7.6992188 L7.4863281 7.1796875 L7.4863281 12.958984 L9.3007812 12.958984 L9.3007812 12.957031 L9.3007812 5.1386719 L9.1347656 5.1386719z M12.841797 7.0390625 C12.128797 7.0390625 11.551328 7.2125469 11.111328 7.5605469 C10.671328 7.9035469 10.451172 8.3429531 10.451172 8.8769531 C10.451172 9.1769531 10.528641 9.4447344 10.681641 9.6777344 A1.895 1.895 0 0 0 11.353516 10.273438 C11.646516 10.434438 12.019703 10.565016 12.470703 10.666016 C12.921703 10.766016 13.228625 10.861078 13.390625 10.955078 C13.551625 11.047078 13.630859 11.172172 13.630859 11.326172 A0.479 0.479 0 0 1 13.443359 11.71875 C13.321359 11.81875 13.136672 11.867188 12.888672 11.867188 C12.620672 11.867187 12.400516 11.807547 12.228516 11.685547 C12.056516 11.560547 11.967937 11.363703 11.960938 11.095703 L10.269531 11.095703 A1.654 1.654 0 0 0 10.597656 12.066406 A2.228 2.228 0 0 0 11.509766 12.798828 C11.899766 12.976828 12.343797 13.066406 12.841797 13.066406 C13.589797 13.066406 14.197969 12.899406 14.667969 12.566406 C15.139969 12.233406 15.376953 11.801484 15.376953 11.271484 C15.376953 10.494484 14.940406 9.9552969 14.066406 9.6542969 C13.805406 9.5652969 13.500344 9.4888281 13.152344 9.4238281 C12.808344 9.3598281 12.558391 9.2777344 12.400391 9.1777344 C12.243391 9.0777344 12.164062 8.9461562 12.164062 8.7851562 A0.483 0.483 0 0 1 12.357422 8.3925781 C12.486422 8.2855781 12.645938 8.2324219 12.835938 8.2324219 C13.326938 8.2324219 13.572266 8.4646875 13.572266 8.9296875 L15.388672 8.9296875 C15.388672 8.3646875 15.155453 7.9085469 14.689453 7.5605469 C14.224453 7.2135469 13.607797 7.0390625 12.841797 7.0390625z M2.7246094 7.7363281 L2.7246094 8.8867188 L1.7753906 8.8867188 L1.7753906 10.289062 L2.7246094 10.289062 L2.7246094 11.394531 L4.0683594 11.394531 L4.0683594 10.289062 L5.0039062 10.289062 L5.0039062 10.287109 L5.0039062 8.8867188 L4.0683594 8.8867188 L4.0683594 7.7363281 L2.7246094 7.7363281z")
        ]), g)
    ])), R$n = Pi({
        bQ: "Forward 1s",
        bX: "Avance 1s en avant"
    }), x$n = rpn(C([
        A2(Cj, C([
            Vg("Fg"),
            kj("M6.015625 5.1796875 L5.5371094 9.1757812 L6.9765625 9.5136719 C7.1845625 9.2416719 7.499875 9.1054688 7.921875 9.1054688 C8.666875 9.1054688 9.0390625 9.4554219 9.0390625 10.357422 C9.0390625 11.260422 8.7349531 11.710938 8.1269531 11.710938 C7.8569531 11.710938 7.6405625 11.626031 7.4765625 11.457031 C7.3115625 11.289031 7.221125 11.062391 7.203125 10.775391 L5.3867188 10.775391 A2.036 2.036 0 0 0 5.7460938 11.974609 A2.505 2.505 0 0 0 6.7578125 12.806641 C7.1878125 13.006641 7.6467187 13.107422 8.1367188 13.107422 C8.6887188 13.107422 9.1663125 12.997297 9.5703125 12.779297 A2.294 2.294 0 0 0 10.511719 11.845703 C10.737719 11.437703 10.849609 10.981469 10.849609 10.480469 C10.849609 9.6494688 10.640703 9.005875 10.220703 8.546875 C9.8057031 8.084875 9.2105937 7.8535156 8.4335938 7.8535156 C8.2325938 7.8535156 8.0254531 7.8824531 7.8144531 7.9394531 C7.6064531 7.9974531 7.4395469 8.0636719 7.3105469 8.1386719 L7.4863281 6.5878906 L10.585938 6.5878906 L10.585938 5.1796875 L6.015625 5.1796875z M14.082031 7.0800781 C13.369031 7.0800781 12.793516 7.2545625 12.353516 7.6015625 C11.913516 7.9455625 11.693359 8.3839687 11.693359 8.9179688 A1.416 1.416 0 0 0 11.923828 9.71875 A1.895 1.895 0 0 0 12.595703 10.314453 C12.889703 10.476453 13.262891 10.607031 13.712891 10.707031 C14.164891 10.807031 14.469859 10.903094 14.630859 10.996094 C14.791859 11.089094 14.873047 11.213188 14.873047 11.367188 A0.479 0.479 0 0 1 14.685547 11.759766 C14.563547 11.859766 14.377859 11.910156 14.130859 11.910156 C13.862859 11.910156 13.642703 11.848562 13.470703 11.726562 C13.298703 11.601562 13.208172 11.405719 13.201172 11.136719 L11.509766 11.136719 A1.654 1.654 0 0 0 11.837891 12.107422 A2.228 2.228 0 0 0 12.751953 12.837891 C13.141953 13.017891 13.584031 13.107422 14.082031 13.107422 C14.830031 13.107422 15.439203 12.940422 15.908203 12.607422 C16.381203 12.274422 16.617188 11.8425 16.617188 11.3125 C16.617187 10.5355 16.181594 9.9973125 15.308594 9.6953125 C15.046594 9.6063125 14.742531 9.5307969 14.394531 9.4667969 C14.051531 9.4017969 13.799578 9.31875 13.642578 9.21875 C13.484578 9.11775 13.40625 8.9861719 13.40625 8.8261719 A0.483 0.483 0 0 1 13.599609 8.4355469 C13.727609 8.3275469 13.888125 8.2734375 14.078125 8.2734375 C14.568125 8.2734375 14.814453 8.5066563 14.814453 8.9726562 L16.628906 8.9726562 C16.628906 8.4066562 16.396641 7.9485625 15.931641 7.6015625 C15.465641 7.2545625 14.848031 7.0800781 14.082031 7.0800781z M1.7949219 7.7265625 L1.7949219 8.9296875 L0.81640625 8.9296875 L0.81640625 10.330078 L1.7949219 10.330078 L1.7949219 11.384766 L3.1386719 11.384766 L3.1386719 10.330078 L4.0449219 10.330078 L4.0449219 8.9296875 L3.1386719 8.9296875 L3.1386719 7.7265625 L1.7949219 7.7265625z")
        ]), g)
    ])), O$n = Pi({
        bQ: "Forward 5s",
        bX: "Avance 5s en avant"
    }), z$n = Pi({
        bQ: "Full Screen",
        bX: "Plein \xe9cran"
    }), N$n = rpn(C([
        A2(Mrn, C([
            Vg("Fg"),
            Ah("4"),
            Bh("2"),
            qrn("3"),
            Drn("3")
        ]), g),
        A2(Mrn, C([
            Vg("Fg"),
            Ah("4"),
            Bh("2"),
            qrn("13"),
            Drn("3")
        ]), g),
        A2(Mrn, C([
            Vg("Fg"),
            Ah("4"),
            Bh("2"),
            qrn("3"),
            Drn("12")
        ]), g),
        A2(Mrn, C([
            Vg("Fg"),
            Ah("4"),
            Bh("2"),
            qrn("13"),
            Drn("12")
        ]), g),
        A2(Mrn, C([
            Vg("Fg"),
            Ah("2"),
            Bh("2"),
            qrn("5"),
            Drn("3")
        ]), g),
        A2(Mrn, C([
            Vg("Fg"),
            Ah("2"),
            Bh("2"),
            qrn("11"),
            Drn("3")
        ]), g),
        A2(Mrn, C([
            Vg("Fg"),
            Ah("2"),
            Bh("2"),
            qrn("5"),
            Drn("14")
        ]), g),
        A2(Mrn, C([
            Vg("Fg"),
            Ah("2"),
            Bh("3"),
            qrn("11"),
            Drn("14")
        ]), g)
    ])), H$n = Pi({
        bQ: "Initialization",
        bX: "Initialisation"
    }), V$n = Pi({
        bQ: "Next Frame",
        bX: "Frame suivante"
    }), U$n = Pi({
        bQ: "normal speed",
        bX: "Vitesses normale"
    }), J$n = Pi({
        bQ: "Previous Frame",
        bX: "Frame pr\xe9c\xe9dente"
    }), Z$n = Pi({
        bQ: "Show raw frame",
        bX: "Afficher image originale"
    }), K$n = A2(Qh, C([
        Ah("18px"),
        Bh("18px"),
        Ih("0 0 20 20"),
        Vg("IconRawImage")
    ]), C([
        A2(UC, C([
            Vg("Fg")
        ]), C([
            A2(Cj, C([
                kj("m17.31864,1.25l-14.67396,0c-1.18282,0 -2.14468,0.96154 -2.14468,2.14576l0,13.48626c0,1.18282 0.96186,2.14334 2.14468,2.14334l14.6739,0c1.18282,0 2.14366,-0.96052 2.14366,-2.14334l0,-13.48626c0.00006,-1.18422 -0.96078,-2.14576 -2.1436,-2.14576zm-4.55665,3.19115c1.14384,0 2.07149,0.92771 2.07149,2.07149s-0.92771,2.07149 -2.07149,2.07149c-1.14416,0 -2.07149,-0.92771 -2.07149,-2.07149s0.92733,-2.07149 2.07149,-2.07149zm3.88406,12.60171l-6.66508,0l-6.36814,0c-0.57211,0 -0.82691,-0.41393 -0.569,-0.9246l3.55506,-7.04144c0.25759,-0.5106 0.74851,-0.55618 1.09617,-0.10188l3.57474,4.67161c0.34766,0.45436 0.95532,0.49302 1.35751,0.08595l0.87451,-0.88556c0.40187,-0.40707 0.99398,-0.35667 1.32196,0.11185l2.26452,3.23469c0.32735,0.46922 0.12987,0.84938 -0.44224,0.84938z")
            ]), g)
        ]))
    ])), _$n = A2(Qh, C([
        Ah("1080"),
        Bh("1920"),
        Ih("0 0 1920 1080")
    ]), C([
        A2(Mrn, C([
            q7("#FFD600"),
            Ah("31"),
            Bh("130"),
            Drn("54"),
            qrn("97")
        ]), g),
        A2(Mrn, C([
            D7("#FFD600"),
            q7("none"),
            Ah("972"),
            Bh("1728"),
            Drn("54"),
            qrn("96")
        ]), g),
        A2(Cj, C([
            kj("M113.5 66.4531C113.433 65.8329 113.154 65.3499 112.662 65.0043C112.174 64.6586 111.539 64.4858 110.758 64.4858C110.209 64.4858 109.738 64.5687 109.345 64.7344C108.952 64.9001 108.651 65.125 108.443 65.4091C108.234 65.6932 108.128 66.0175 108.123 66.3821C108.123 66.6851 108.192 66.9479 108.329 67.1705C108.471 67.393 108.663 67.5824 108.904 67.7386C109.146 67.8902 109.413 68.018 109.707 68.1222C110.001 68.2263 110.297 68.3139 110.595 68.3849L111.958 68.7259C112.508 68.8537 113.036 69.0265 113.542 69.2443C114.054 69.4621 114.511 69.7367 114.913 70.0682C115.32 70.3996 115.642 70.7997 115.879 71.2685C116.116 71.7372 116.234 72.2865 116.234 72.9162C116.234 73.7685 116.016 74.5189 115.581 75.1676C115.145 75.8116 114.515 76.3158 113.691 76.6804C112.872 77.0402 111.88 77.2202 110.716 77.2202C109.584 77.2202 108.601 77.045 107.768 76.6946C106.94 76.3442 106.291 75.8329 105.822 75.1605C105.358 74.4882 105.107 73.669 105.069 72.7031H107.662C107.699 73.2098 107.856 73.6312 108.13 73.9673C108.405 74.3035 108.762 74.5545 109.203 74.7202C109.648 74.8859 110.145 74.9688 110.694 74.9688C111.267 74.9688 111.769 74.8835 112.2 74.7131C112.636 74.5379 112.976 74.2964 113.223 73.9886C113.469 73.6761 113.594 73.3116 113.599 72.8949C113.594 72.5161 113.483 72.2036 113.265 71.9574C113.047 71.7064 112.742 71.4981 112.349 71.3324C111.961 71.1619 111.506 71.0104 110.985 70.8778L109.331 70.4517C108.133 70.1439 107.186 69.6776 106.49 69.0526C105.798 68.4228 105.453 67.5871 105.453 66.5455C105.453 65.6884 105.685 64.938 106.149 64.294C106.618 63.6501 107.254 63.1506 108.059 62.7955C108.864 62.4356 109.776 62.2557 110.794 62.2557C111.826 62.2557 112.73 62.4356 113.507 62.7955C114.288 63.1506 114.901 63.6454 115.346 64.2798C115.791 64.9096 116.021 65.634 116.035 66.4531H113.5ZM118.583 77V62.4545H128.043V64.6634H121.218V68.6122H127.553V70.821H121.218V74.7912H128.1V77H118.583ZM143.182 67.3622H140.526C140.45 66.9266 140.31 66.5407 140.107 66.2045C139.903 65.8636 139.65 65.5748 139.347 65.3381C139.044 65.1013 138.698 64.9238 138.31 64.8054C137.926 64.6823 137.512 64.6207 137.067 64.6207C136.276 64.6207 135.575 64.8196 134.964 65.2173C134.354 65.6103 133.875 66.188 133.53 66.9503C133.184 67.7079 133.011 68.6335 133.011 69.7273C133.011 70.84 133.184 71.7775 133.53 72.5398C133.88 73.2973 134.358 73.8703 134.964 74.2585C135.575 74.642 136.274 74.8338 137.06 74.8338C137.495 74.8338 137.902 74.777 138.281 74.6634C138.665 74.545 139.008 74.3722 139.311 74.1449C139.619 73.9176 139.877 73.6383 140.085 73.3068C140.298 72.9754 140.445 72.5966 140.526 72.1705L143.182 72.1847C143.082 72.8759 142.867 73.5246 142.536 74.1307C142.209 74.7367 141.78 75.2718 141.25 75.7358C140.72 76.1951 140.099 76.5549 139.389 76.8153C138.679 77.071 137.891 77.1989 137.024 77.1989C135.746 77.1989 134.605 76.9029 133.601 76.3111C132.597 75.7192 131.806 74.8646 131.229 73.7472C130.651 72.6297 130.362 71.2898 130.362 69.7273C130.362 68.16 130.653 66.8201 131.236 65.7074C131.818 64.59 132.611 63.7353 133.615 63.1435C134.619 62.5516 135.755 62.2557 137.024 62.2557C137.834 62.2557 138.587 62.3693 139.283 62.5966C139.979 62.8239 140.599 63.1577 141.143 63.598C141.688 64.0336 142.135 64.5687 142.486 65.2031C142.841 65.8329 143.073 66.5526 143.182 67.3622ZM154.764 62.4545H157.399V71.9574C157.399 72.9991 157.153 73.9152 156.66 74.706C156.172 75.4967 155.486 76.1146 154.6 76.5597C153.715 77 152.681 77.2202 151.497 77.2202C150.308 77.2202 149.271 77 148.386 76.5597C147.501 76.1146 146.814 75.4967 146.326 74.706C145.839 73.9152 145.595 72.9991 145.595 71.9574V62.4545H148.23V71.7372C148.23 72.3433 148.362 72.883 148.627 73.3565C148.897 73.83 149.276 74.2017 149.764 74.4716C150.252 74.7367 150.829 74.8693 151.497 74.8693C152.164 74.8693 152.742 74.7367 153.23 74.4716C153.722 74.2017 154.101 73.83 154.366 73.3565C154.631 72.883 154.764 72.3433 154.764 71.7372V62.4545ZM164.585 64.6634V62.4545H176.19V64.6634H171.694V77H169.08V64.6634H164.585ZM181.062 62.4545V77H178.427V62.4545H181.062ZM183.276 64.6634V62.4545H194.881V64.6634H190.385V77H187.772V64.6634H183.276ZM197.118 77V62.4545H202.573C203.69 62.4545 204.628 62.6487 205.385 63.0369C206.148 63.4252 206.723 63.9697 207.111 64.6705C207.504 65.3665 207.701 66.1785 207.701 67.1065C207.701 68.0393 207.502 68.849 207.104 69.5355C206.711 70.2173 206.131 70.7453 205.364 71.1193C204.597 71.4886 203.655 71.6733 202.537 71.6733H198.652V69.4858H202.182C202.836 69.4858 203.371 69.3958 203.787 69.2159C204.204 69.0312 204.512 68.7637 204.711 68.4134C204.914 68.0582 205.016 67.6226 205.016 67.1065C205.016 66.5904 204.914 66.1501 204.711 65.7855C204.507 65.4162 204.197 65.1368 203.78 64.9474C203.364 64.7533 202.826 64.6562 202.168 64.6562H199.753V77H197.118ZM204.632 70.4091L208.233 77H205.293L201.756 70.4091H204.632ZM210.126 77V62.4545H219.586V64.6634H212.761V68.6122H219.096V70.821H212.761V74.7912H219.643V77H210.126Z"),
            q7("black")
        ]), g)
    ])), G$n = Pi({
        bQ: "Speed X 2",
        bX: "Vitesse X 2"
    }), Y$n = Pi({
        bQ: "Speed X 4",
        bX: "Vitesse X 4"
    }), ngn = Pi({
        bQ: "Start",
        bX: "D\xe9but"
    }), rgn = rpn(C([
        A2(Th, C([
            Vg("Fg"),
            Lh("11 5 11 13 6 9")
        ]), g),
        A2(Th, C([
            Vg("Fg"),
            Lh("15 5 15 13 10 9")
        ]), g),
        A2(Mrn, C([
            Vg("Fg"),
            Ah("8"),
            Bh("1.5"),
            qrn("4.75"),
            Drn("5")
        ]), g)
    ])), tgn = rpn(C([
        A2(Cj, C([
            Vg("Fg"),
            kj("M5.3833 8.02344L6.37988 6.13184H8.60156L6.79248 9.47705L8.69043 13H6.45605L5.37695 10.9688L4.31689 13H2.06982L3.97412 9.47705L2.17139 6.13184H4.41846L5.3833 8.02344ZM14.1271 13H11.9816V6.16992L9.87414 6.78564V5.16064L13.9303 3.75781H14.1271V13Z")
        ]), g)
    ])), egn = rpn(C([
        A2(Cj, C([
            Vg("Fg"),
            kj("M12.433594 3.234375 C11.644303 3.234375 11.024458 3.3490632 10.576172 3.5761719 C10.131717 3.7989131 9.7881853 4.1212769 9.5429688 4.5449219 C9.2977522 4.9641994 9.1290656 5.5495757 9.0371094 6.3007812 L11.380859 6.5175781 C11.445995 5.9760113 11.573975 5.5987719 11.761719 5.3847656 C11.953294 5.1707594 12.197236 5.0625 12.496094 5.0625 C12.783457 5.0625 13.02124 5.1673144 13.208984 5.3769531 C13.40056 5.5822244 13.496094 5.8323792 13.496094 6.125 C13.496094 6.3957834 13.40056 6.6810661 13.208984 6.9824219 C13.017409 7.2837776 12.578418 7.7257665 11.892578 8.3066406 C10.769946 9.2543825 10.003721 10.076595 9.59375 10.775391 C9.1876102 11.469819 8.9437429 12.213393 8.8632812 13.003906 L15.886719 13.003906 L15.886719 10.828125 L12.232422 10.828125 C12.446986 10.587914 12.631971 10.394588 12.789062 10.246094 C12.949986 10.0976 13.267006 9.8360791 13.738281 9.4648438 C14.531403 8.8271925 15.076142 8.2418162 15.375 7.7089844 C15.677689 7.1761525 15.830078 6.6184447 15.830078 6.0332031 C15.830078 5.4829014 15.697968 4.9860368 15.433594 4.5449219 C15.173051 4.0994395 14.813297 3.7706469 14.353516 3.5566406 C13.897566 3.3426344 13.257368 3.234375 12.433594 3.234375z M2.0703125 6.1328125 L3.9746094 9.6542969 L2.171875 13 L4.4179688 13 L5.3828125 11.109375 L6.3789062 13 L8.6015625 13 L6.7929688 9.6542969 L8.6914062 6.1328125 L6.4550781 6.1328125 L5.3769531 8.1621094 L4.3164062 6.1328125 L2.0703125 6.1328125z")
        ]), g)
    ])), ugn = rpn(C([
        A2(Cj, C([
            Vg("Fg"),
            kj("M5.3833 8.02344L6.37988 6.13184H8.60156L6.79248 9.47705L8.69043 13H6.45605L5.37695 10.9688L4.31689 13H2.06982L3.97412 9.47705L2.17139 6.13184H4.41846L5.3833 8.02344ZM15.0348 9.38818H15.9742V11.0386H15.0348V13H12.8956V11.0386H9.32189L9.19494 9.73096L12.8956 3.77686V3.75781H15.0348V9.38818ZM11.2325 9.38818H12.8956V6.54443L12.7623 6.76025L11.2325 9.38818Z")
        ]), g)
    ])), agn = {
        $: 1
    }, ign = {
        $: 0
    }, ogn = rpn(C([
        A2(Mrn, C([
            Vg("Fg"),
            Ah("8"),
            Bh("3"),
            qrn("5"),
            Drn("5")
        ]), g),
        A2(Mrn, C([
            Vg("Fg"),
            Ah("8"),
            Bh("3"),
            qrn("10"),
            Drn("5")
        ]), g)
    ])), cgn = function(n) {
        return n.mM ? A2(Se, C([
            nh("PlayerControlsPlayPause"),
            HW("Lire / Mettre en pause"),
            Mh(agn)
        ]), C([
            ogn
        ])) : A2(Se, C([
            nh("PlayerControlsPlayPause"),
            HW("Lire / Mettre en pause"),
            Mh(ign)
        ]), C([
            tpn
        ]));
    }, fgn = F2(function(n, r) {
        var t, e = (t = 100 * (r.e6 - r.ht) / n) > 100 ? "100" : FS(t);
        return A2(Se, C([
            nh("PlayerControlsTimeBuffered"),
            A2(gh, "left", "0%"),
            A2(gh, "width", e + "%")
        ]), g);
    }), sgn = F3(function(n, r, t) {
        var e, u, a = (e = se(r * t) - 1, (u = 100 * n.kl / e) > 100 ? "100" : FS(u));
        return A2(Se, C([
            nh("PlayerControlsTimeProgress"),
            A2(gh, "left", "0%"),
            A2(gh, "width", a + "%")
        ]), g);
    }), lgn = F3(function(n, r, t) {
        var e = 1 === r.$ ? 0 : r.a, u = C(1 === t.$ ? [
            A2(Se, C([
                nh("PlayerControlsTimeProgress"),
                A2(gh, "width", "0%")
            ]), g)
        ] : [
            A3(sgn, n, t.a, e)
        ]), a = 1 > Dt(n.ew) ? C([
            A2(Se, C([
                nh("PlayerControlsTimeBuffered"),
                A2(gh, "left", "0%"),
                A2(gh, "width", "0%")
            ]), g)
        ]) : A2(Ge, fgn(e), n.ew);
        return A2(Se, C([
            nh("PlayerControlsTime")
        ]), A2(bt, A2(Se, C([
            nh("PlayerControlsTimeMask")
        ]), g), A2(bt, ch(""), A2(bt, A2(Se, C([
            nh("PlayerControlsBufferProgress")
        ]), a), u))));
    }), dgn = F3(function(n, r, t) {
        var e, u = {
            i7: function() {
                var n = t.p9;
                return 1 === n.$ ? g : C([
                    Bt(n.a)
                ]);
            }(),
            nz: t.nT,
            gz: Ct,
            ae: r.q4
        }, a = r.mG || !r.iy ? "block" : "none", o = r.i_ && !n || !r.i_ && n ? "block" : "none";
        return A2(Se, C([
            nh("PlayerVideoWrapper"),
            fk("player-wrapper"),
            P$n(1)
        ]), C([
            A2(Se, C([
                nh("PlayerBox")
            ]), C([
                A2(Se, C([
                    nh("BannerEmptyness"),
                    nh("PlayerBanner"),
                    A2(gh, "display", "none")
                ]), C([
                    UW,
                    A2(ph, C([
                        nh("BannerContent")
                    ]), C([
                        ch(W$n)
                    ]))
                ])),
                A2(Se, C([
                    nh("PlayerVideo"),
                    Zh(C([
                        d("PlayerDeployed", r.iy),
                        d("PlayerCollapsed", !r.iy)
                    ]))
                ]), C([
                    A2(Se, C([
                        nh("PlayerVideoBuffering"),
                        A2(gh, "display", a)
                    ]), C([
                        (e = H$n, A2(Se, C([
                            nh("LoadingWrapper")
                        ]), C([
                            A2(Se, C([
                                nh("LoadingSpinner")
                            ]), C([
                                NQ,
                                A2(Se, C([
                                    nh("LoadingSpinnerText")
                                ]), C([
                                    ch(e)
                                ]))
                            ]))
                        ])))
                    ])),
                    A3(ye, "noma-player", C([
                        A2(ZW, "data-manifest", u.nz),
                        A2(ZW, "data-audiostracks", "[" + A2(Wt, ",", u.i7) + "]"),
                        A2(ZW, "data-playbackspeed", FS(r.gz)),
                        A2(ZW, "data-subtitles", A2(Qu, "", u.ae)),
                        A2(ZW, "data-framerate", FS(r.lS)),
                        A2(ZW, "data-starttimecode", t.qO)
                    ]), g),
                    A2(Se, C([
                        nh("PlayerAspectRatio"),
                        A2(gh, "display", o),
                        A2(gh, "z-index", "3")
                    ]), C([
                        n ? _$n : y$n
                    ]))
                ]))
            ])),
            A2(Se, C([
                nh("PlayerControlsBox")
            ]), C([
                A2(Se, C([
                    nh("PlayerControls")
                ]), C([
                    cgn(r),
                    A3(lgn, r, t.e$, t.lS)
                ])),
                A2(Se, C([
                    nh("PlayerControls")
                ]), C([
                    M$n,
                    A2(Se, C([
                        nh("PlayerControlsStart"),
                        HW(ngn),
                        Mh(C$n)
                    ]), C([
                        rgn
                    ])),
                    A2(Se, C([
                        nh("PlayerControlsBackward"),
                        HW(J$n),
                        Mh(w$n)
                    ]), C([
                        B$n
                    ])),
                    A2(Se, C([
                        nh("PlayerControlsForward"),
                        HW(V$n),
                        Mh(j$n)
                    ]), C([
                        X$n
                    ])),
                    A2(Se, C([
                        nh("PlayerControlsEnd"),
                        HW(q$n),
                        Mh(k$n)
                    ]), C([
                        D$n
                    ])),
                    A2(_h, C([
                        nh("PlayerOperationsSeparator")
                    ]), ""),
                    A2(Se, C([
                        nh("PlayerGoBack1s"),
                        HW(T$n),
                        Mh(A2(L$n, "Substract", 1))
                    ]), C([
                        F$n
                    ])),
                    A2(Se, C([
                        nh("PlayerGoBack5s"),
                        HW(I$n),
                        Mh(A2(L$n, "Substract", 5))
                    ]), C([
                        Q$n
                    ])),
                    A2(Se, C([
                        nh("PlayerGoForward1s"),
                        HW(R$n),
                        Mh(A2(L$n, "Add", 1))
                    ]), C([
                        E$n
                    ])),
                    A2(Se, C([
                        nh("PlayerGoForward5s"),
                        HW(O$n),
                        Mh(A2(L$n, "Add", 5))
                    ]), C([
                        x$n
                    ])),
                    A2(_h, C([
                        nh("PlayerOperationsSeparator")
                    ]), ""),
                    A2(Se, C([
                        nh("PlayerPlaybackSpeed1"),
                        Zh(C([
                            d("PlayerSelectedSpeed", i(r.gz, 1))
                        ])),
                        HW(U$n),
                        Mh(A$n(1))
                    ]), C([
                        tgn
                    ])),
                    A2(Se, C([
                        nh("PlayerPlaybackSpeed2"),
                        Zh(C([
                            d("PlayerSelectedSpeed", i(r.gz, 2))
                        ])),
                        HW(G$n),
                        Mh(A$n(2))
                    ]), C([
                        egn
                    ])),
                    A2(Se, C([
                        nh("PlayerPlaybackSpeed4"),
                        Zh(C([
                            d("PlayerSelectedSpeed", i(r.gz, 4))
                        ])),
                        HW(Y$n),
                        Mh(A$n(4))
                    ]), C([
                        ugn
                    ])),
                    A2(_h, C([
                        nh("PlayerOperationsSpacer")
                    ]), ""),
                    A2(Se, C([
                        nh("PlayerControlsRatio"),
                        HW("aspect ratio"),
                        Mh($$n)
                    ]), C([
                        S$n
                    ])),
                    A2(Se, C([
                        nh("ButtonDisplayRawImage"),
                        HW(Z$n),
                        Mh(A2(h$n, t.ev, t.fR))
                    ]), C([
                        K$n
                    ])),
                    A2(Se, C([
                        nh("PlayerControlsFullScreen"),
                        HW(z$n),
                        Mh(g$n)
                    ]), C([
                        N$n
                    ]))
                ]))
            ]))
        ]));
    }), bgn = F5(function(n, r, t, e, u) {
        var a = A2(Qu, "", A2(Lp, $mn, A2(Can, wan(r), u).bT.f2)), i = A2(Qu, g, A2(Tu, function(n) {
            return n.g3;
        }, A2(Can, wan(r), u).bT.f2)), o = u$n(A2(Can, wan(r), u)), c = a$n(o) ? o$n : i$n;
        if (t.$) return u.oT ? ch("") : A2(Se, C([
            fk("player"),
            nh("PlayerUnfold")
        ]), C([
            (f = u.oR, 1 === f.$ ? ch("") : A2(Sk, YV, A3(dgn, n, u.oU, f.a)))
        ]));
        var f, s, l = t.a;
        return u.oT ? A2(Se, C([
            nh("PlayerFold"),
            Zh(C([
                d("PlayerFolded", u.oT)
            ]))
        ]), C([
            a$n(o) ? A2(Se, C([
                nh("PlayerFoldPreview"),
                Mh(c)
            ]), C([
                A2(Se, C([
                    nh("PlayerFoldPlay")
                ]), C([
                    c$n
                ])),
                A2(Se, C([
                    nh("PlayerFoldProxy")
                ]), C([
                    ch(f$n)
                ]))
            ])) : A2(Se, C([
                nh("PlayerFoldPreview")
            ]), C([
                A2(Se, C([
                    nh("PlayerFoldSpinner")
                ]), C([
                    NQ
                ]))
            ])),
            A4(v$n, l, e, i, a)
        ])) : A2(Se, C([
            fk("player"),
            nh("PlayerUnfold")
        ]), C([
            (s = u.oR, 1 === s.$ ? ch("") : A2(Sk, YV, A3(dgn, n, u.oU, s.a)))
        ]));
    }), mgn = Pi({
        bQ: "No audio stream present for this video.",
        bX: "Aucun stream audio pr\xe9sente pour cette vid\xe9o"
    }), pgn = function(n) {
        return {
            $: 36,
            a: n
        };
    }, vgn = F2(function(n, r) {
        var t = A2(Qu, "", A2(Tu, fj, r.sd)), e = A2(Qu, "", A2(Tu, jbn, r.rQ)), u = A2(Tu, J1, r.aD);
        return A2(OC, C([
            nh("TracksTrackSelectLabel")
        ]), C([
            A2(rk, C([
                qh("radio"),
                hk(Bt(r.fB)),
                tk("selected-audio-track" + A3(ib, 2, "0", Bt(r.fB))),
                Mh(pgn(d(r.fB, u))),
                XC(A2(mg, r.fB, A2(Qu, g, A2(Tu, A2(mu, Ge($e), function(n) {
                    return n.qa;
                }), n.oR))))
            ]), g),
            A2(ph, C([
                nh("TracksTrackSelectItem")
            ]), C([
                A2(_h, C([
                    nh("TracksTrackSelectItemIndex")
                ]), A3(ib, 2, "0", Bt(r.fB))),
                A2(_h, C([
                    nh("TracksTrackSelectItemTitle")
                ]), t + " " + e),
                A2(_h, C([
                    nh("TracksTrackSelectItemProp")
                ]), Bt(r.cJ) + " channel(s)"),
                A2(_h, C([
                    nh("TracksTrackSelectItemProp")
                ]), A2(Qu, "", u))
            ]))
        ]));
    }), $gn = function(n) {
        return A2(OC, C([
            nh("TracksTrackSelectLabel")
        ]), C([
            A2(rk, C([
                qh("radio"),
                hk(Bt(n.fB)),
                tk("selected-subtitle-track")
            ]), g),
            A2(ph, C([
                nh("TracksTrackSelectItem")
            ]), C([
                A2(_h, C([
                    nh("TracksTrackSelectItemTitle")
                ]), "subtitle stream " + A3(ib, 2, "0", Bt(n.fB))),
                A2(_h, C([
                    nh("TracksTrackSelectItemProp")
                ]), A2(Qu, "", A2(Tu, fj, n.sd)))
            ]))
        ]));
    }, ggn = F2(function(n, r) {
        return A2(Se, C([
            nh("TracksTrack")
        ]), C([
            A2(Se, C([
                nh("TracksTrackIcon")
            ]), C([
                n
            ])),
            A2(Se, C([
                nh("TracksTrackSelect")
            ]), r)
        ]));
    }), hgn = A2(OC, C([
        nh("TracksTrackSelectLabel")
    ]), C([
        A2(rk, C([
            qh("checkbox"),
            tk("selected-video-track")
        ]), g),
        A2(ph, C([
            nh("TracksTrackSelectItem")
        ]), C([
            A2(_h, C([
                nh("TracksTrackSelectItemTitle")
            ]), "Video"),
            A2(_h, C([
                nh("TracksTrackSelectItemProp")
            ]), "")
        ]))
    ])), kgn = F3(function(n, r, t) {
        return A2(Se, C([
            nh("Tracks")
        ]), C([
            A2(ggn, Rmn, C([
                hgn
            ])),
            A2(ggn, kdn, i(r, g) ? C([
                j7(mgn)
            ]) : A2(Ge, vgn(n), A2(xi, function(n) {
                return n.fB;
            }, r))),
            i(t, g) ? ch("") : A2(ggn, Sdn, A2(Ge, $gn, t))
        ]));
    }), Cgn = Pi({
        bQ: "Additional material",
        bX: "Mat\xe9riel compl\xe9mentaire"
    }), jgn = F5(function(n, r, t, e, u) {
        var a = e$n(n), i = A3(omn, n.r8, n.g9.oz, A2(Ge, function(n) {
            return n.fH;
        }, n.fJ));
        return A2(Se, C([
            nh("FilesWrapper")
        ]), C([
            wu(a) ? ch("") : A2(Se, g, A2(Ge, A6(Xvn, n, r, u, i, t, e), a))
        ]));
    }), wgn = Pi({
        bQ: "File upload",
        bX: "Upload de fichier"
    }), Agn = Pi({
        bQ: "Looking for upload?",
        bX: "Vous voulez uploader des fichiers ?"
    }), Lgn = Pi({
        bQ: A2(Se, g, C([
            A2(bI, g, C([
                ch("You can only upload subtitles.")
            ])),
            A2(bI, g, C([
                ch("You are not allowed to deliver directly into the destination placeholder. First, you have to upload your master file into your own stock in Nomalab, then you will be able to start the delivery in Nomalab."),
                ch("For the records, you can follow the 3 steps tutorial available on this link: "),
                A2(hj, C([
                    wj(Irn("table"))
                ]), C([
                    ch("Read help")
                ])),
                ch(". If you need any assistance, you can also contact us via the Chat on the bottom left of this page.")
            ]))
        ])),
        bX: A2(Se, g, C([
            A2(bI, g, C([
                ch("Vous ne pouver uploader que des sous-titres.")
            ])),
            A2(bI, g, C([
                ch("Vous ne pouvez pas uploader directement dans la capsule de r\xe9ception de votre destinataire. "),
                ch("Vous devez dans un premier temps uploader votre master dans le stock de votre organisation. "),
                ch("Pour rappel, un tutoriel avec les 3 etapes \xe0 suivre pour livrer un programme avec Nomalab est disponible sur le lien suivant : "),
                A2(hj, C([
                    wj(Irn("table"))
                ]), C([
                    ch("Consulter l'aide")
                ])),
                ch(". En cas de besoin, vous pouvez contacter notre \xe9quipe op\xe9rationnelle via le bouton de messagerie instantan\xe9e disponible en bas \xe0 gauche de l'interface")
            ]))
        ]))
    }), ygn = A2(Se, C([
        nh("PadokUpload"),
        nh("PadokUploadKo")
    ]), C([
        A2(_h, C([
            nh("PadokUploadTitle"),
            nh("PadokUploadTitleKo")
        ]), Agn),
        A2(Se, C([
            nh("PadokUploadInfo")
        ]), C([
            Lgn
        ]))
    ])), Sgn = Pi({
        bQ: "You can upload files",
        bX: "Vous pouvez uploader des fichiers"
    }), Fgn = Pi({
        bQ: "Drop files here or ",
        bX: "Glisser-d\xe9poser les fichiers dans la fen\xeatre, ou "
    }), Tgn = F2(function(n, r) {
        return A2(OC, C([
            wen(n),
            nh("InputFileLabel")
        ]), C([
            ch(r)
        ]));
    }), Qgn = Pi({
        bQ: "select manually",
        bX: "s\xe9lectionner manuellement"
    }), Ign = A2(Se, C([
        nh("PadokUpload")
    ]), C([
        A2(_h, C([
            nh("PadokUploadTitle")
        ]), Sgn),
        A2(Se, C([
            nh("PadokUploadInfo")
        ]), C([
            ch(Fgn),
            A2(Tgn, "nativeInputFile", Qgn)
        ]))
    ])), Bgn = Pi({
        bQ: " and ",
        bX: " et "
    }), Wgn = Pi({
        bQ: ' Go to the "Settings" tab, Invitations area, to invite your contacts via their email adresses to upload files.',
        bX: ' Allez dans l\'onglet "Param\xe8tres" \xe0 gauche de l\'\xe9cran, zone "invitations", puis invitez vos contacts avec leurs adresses mail en upload.'
    }), Pgn = Pi({
        bQ: " has been invited to upload files.",
        bX: " a \xe9t\xe9 invit\xe9(e) \xe0 uploader les fichiers."
    }), Mgn = Pi({
        bQ: "Nobody is assigned for upload.",
        bX: "Si une autre personne doit uploader le fichier pour vous, "
    }), qgn = Pi({
        bQ: " others were invited to upload files.",
        bX: " autres ont \xe9t\xe9 invit\xe9(e)s \xe0 uploader les fichiers."
    }), Dgn = function(n) {
        return i(n.nW, n.k6) ? n.nW : n.nW + " (" + n.k6 + ")";
    }, Xgn = Pi({
        bQ: " were invited to upload files.",
        bX: " ont \xe9t\xe9 invit\xe9(e)s \xe0 uploader les fichiers."
    }), Egn = function(n) {
        var r = A2(Bu, A2(Po, function(n) {
            return n.fH;
        }, function(n) {
            return n.r$;
        }), n.fJ);
        return A2(Se, C([
            nh("PadokUploadInvitation")
        ]), C([
            ch(function() {
                if (r.b) {
                    if (r.b.b) {
                        if (r.b.b.b) {
                            var n = r.b;
                            return A2(Wt, " ", C([
                                Dgn(r.a.r8),
                                Bgn,
                                Bt(Dt(n)),
                                qgn
                            ]));
                        }
                        var t = r.b.a;
                        return A2(Wt, " ", C([
                            Dgn(r.a.r8),
                            Bgn,
                            Dgn(t.r8),
                            Xgn
                        ]));
                    }
                    return A2(Wt, " ", C([
                        Dgn(r.a.r8),
                        Pgn
                    ]));
                }
                return Mgn;
            }()),
            ch(A2(WJ, n.r8, n.g9.oz) ? Wgn : "")
        ]));
    }, Rgn = function(n) {
        var r = !n.g9.c9 && !n.r8.iz, t = A3(MJ, n.r8, n.g9.oz, A2(Ge, function(n) {
            return n.fH;
        }, n.fJ));
        return A2(Se, C([
            nh("PadokUploadWrapper")
        ]), C([
            r ? ygn : t ? Ign : A2(_h, C([
                nh("PadokUploadTitle")
            ]), wgn),
            Egn(n)
        ]));
    }, xgn = {
        $: 15
    }, Ogn = Pi({
        bQ: "Current capsule",
        bX: "Capsule courante"
    }), zgn = Pi({
        bQ: "Current master",
        bX: "Master courant"
    }), Ngn = Pi({
        bQ: "No video file",
        bX: "Pas de fichier vid\xe9o"
    }), Hgn = Pi({
        bQ: " (Rejected)",
        bX: " (Rejet\xe9)"
    }), Vgn = F2(function(n, r) {
        var t = n.oK;
        return !Dt(n.bl) || man(n) && !Bin(n.r8) ? ch("") : A2(Se, C([
            nh("ShowSelectBroadcastable")
        ]), C([
            A3(Uln, r.jp, xgn, A2(bt, b(i(t.bF, Ct), A3(Vln, n.g9.mj, n.iY, p(t, {
                bF: Ct
            })), function() {
                var r = d(n.S.bT.f2, n.g9.c9);
                return 1 === r.a.$ ? r.b ? zgn : Ogn : r.b ? r.a.a.lA.nW + " (" + zgn + ")" : r.a.a.lA.nW + " (" + Ogn + ")";
            }()), A2(Ge, function(r) {
                var e;
                return b(i(t.bF, kt(r.bF.mj)), A3(Vln, n.g9.mj, n.iY, p(t, {
                    bF: kt(r.bF.mj)
                })), 1 === (e = r.bT.f2).$ ? Ngn : $(e.a.lA.nW, Hgn));
            }, n.bl)))
        ]));
    }), Ugn = Pi({
        bQ: "Hide player",
        bX: "Masquer la video"
    }), Jgn = irn(C([
        A2(Cj, C([
            Vg("Fg"),
            kj("M4.94601622,4.57669369 C3.74989521,5.67353545 3,7.24919402 3,9 C3,12.3137085 5.6862915,15 9,15 C12.3137085,15 15,12.3137085 15,9 C15,6.64729493 13.6458726,4.61086325 11.6744855,3.62757252 L11.2601446,5.69927685 C12.3108237,6.42010318 13,7.62956872 13,9 C13,11.209139 11.209139,13 9,13 C6.790861,13 5,11.209139 5,9 C5,7.98151039 5.38065278,7.051927 6.00745306,6.34575509 L7,8 L9,4 L4,3 L4.94601622,4.57669369 Z")
        ]), g)
    ])), Zgn = Pi({
        bQ: "Refresh",
        bX: "Rafra\xeechir"
    }), Kgn = F4(function(n, r, t, e) {
        var u = A2(Tu, Ou("#"), t.jr), a = kt(r.ea ? urn : aO), i = man(n) ? Ct : t.cx ? kt(A2(vdn, e.mj, qv(r.bN.qj))) : Ct, o = kt(gK(e.mj)), c = A2(Aj, g, C([
            VW(p(AW, {
                mi: kt(e.Q.nc ? Min : Jgn),
                m$: Zgn,
                ol: kt(l$)
            })),
            e.oT ? ch("") : VW(p(AW, {
                mi: kt($Q),
                m$: Ugn,
                ol: kt(xJ)
            }))
        ]));
        return Ij(p(Bj, {
            d1: kt(c),
            eh: o,
            fj: i,
            fx: a,
            mj: u,
            rB: t.rB
        }));
    }), _gn = F2(function(n, r) {
        return A2(Se, C([
            nh("BannerCTA")
        ]), C([
            A2(Se, C([
                nh("BannerCTAIcon")
            ]), C([
                ron
            ])),
            A2(_h, C([
                nh("BannerCTALabel")
            ]), n),
            VW(r)
        ]));
    }), Ggn = Pi({
        bQ: "Deliver",
        bX: "Livrer"
    }), Ygn = Pi({
        bQ: "Proceed to delivery",
        bX: "Proc\xe9der \xe0 la livraison"
    }), nhn = Pi({
        bQ: "Qualify",
        bX: "Qualifier"
    }), rhn = Pi({
        bQ: "All audios are not qualified",
        bX: "Toutes les pistes audios ne sont pas qualifi\xe9es"
    }), thn = F3(function(n, r, t) {
        var e = !jan(n);
        return _ln(n) && function(n) {
            return A3(MJ, n.r8, n.oz.mj, A2(Ge, function(n) {
                return n.fH;
            }, n.fJ));
        }(n) ? A2(Se, C([
            nh("ShowTodos")
        ]), C([
            A2(tmn, t, A2(_gn, rhn, p(AW, {
                mi: kt(ken),
                m$: nhn,
                r6: kt(A2(vdn, r.mj, 2))
            }))),
            A2(tmn, e, A2(_gn, Ygn, p(AW, {
                mi: kt(ken),
                m$: Ggn,
                ol: kt(h1(Iin)),
                r6: kt(A2(vdn, r.mj, 1))
            })))
        ])) : ch("");
    }), ehn = F3(function(n, r, t) {
        var e, u, a, o = e$n(r), c = A2(Can, wan(r), t), f = u$n(c), s = (e = c.bT.f2).$ ? g : e.a.aw, l = (u = c.bT.f2).$ ? g : A2(nc, hdn, u.a.aw), b = (a = c.bT.f2).$ ? Ct : Ra(A2(nc, _1, a.a.aw)), m = A2(nc, U1, s), p = A2(Pw, Ww(function(n) {
            return n.rB;
        }), A2(Ge, function(n) {
            return {
                cJ: Bt(n.cJ),
                kI: C([
                    d("Codec", n.aF),
                    d(wdn, ydn(kt(n))),
                    d(jdn, Bt(n.cJ))
                ]),
                mi: kdn,
                fB: n.fB,
                fR: n.A + "/" + Bt(n.fB),
                m3: n.aD,
                rB: $(Cdn, A3(ib, 2, "0", Bt(n.fB))),
                rQ: n.rQ,
                sd: n.sd
            };
        }, m)), v = A2(bu, function(n) {
            return i(n.rQ, Ct);
        }, m), h = $(function() {
            var n = c.bT.f2;
            return n.$ ? g : C([
                n.a
            ]);
        }(), A2(Su, o, c.bT.ef));
        return C([
            A4(Kgn, r, n, {
                cx: !0,
                jr: A2(Qu, r.dd.jr, A2(Tu, function(n) {
                    return n.jr;
                }, t.k$.o9)),
                rB: r.g9.rC
            }, t),
            lan(t),
            A2(Se, C([
                nh("ShowHomeWrapper")
            ]), C([
                A3(thn, r, t, v),
                A2(Vgn, r, t),
                A5(bgn, n.mF, r, b, m, t),
                A2(tmn, a$n(f), A3(kgn, t, A2(nc, U1, A2(t$n, A2(Tu, function(n) {
                    return n.mj;
                }, f), h)), l)),
                A5(n$n, n, t, r, p, c),
                A2(tmn, !i(r.bS, g), Uq(C([
                    Kq(Cgn)
                ]))),
                A2(Sk, A1, A5(jgn, r, c, A2(Tu, function(n) {
                    return n.nT;
                }, t.oR), A2(Lp, function(n) {
                    return n.q4;
                }, t.oR), t.bT)),
                A3(MJ, n.r8, r.g9.oz, A2(Ge, function(n) {
                    return n.fH;
                }, r.fJ)) ? Rgn(r) : ch("")
            ]))
        ]);
    }), uhn = F3(function(n, r, t) {
        var e = A3(gan, n, r, t), u = A2(pan, e.r8, e.g9.oz);
        return man(e), A2(Se, C([
            nh("ShowWrapper"),
            nh(e.g9.il && u ? "ShowAccepted" : "ShowNoop")
        ]), C([
            A2(Se, C([
                nh("ShowMain")
            ]), A3(ehn, n, e, r)),
            A2(Se, C([
                nh("ShowAside")
            ]), A2(rmn, e, r))
        ]));
    }), ahn = F2(function(n, r) {
        var t = r.Q.kt;
        return 1 === t.$ ? function(n) {
            return A2(Se, C([
                nh("ShowWrapper")
            ]), C([
                A2(Se, C([
                    nh("ShowMain")
                ]), C([
                    Ij(p(Bj, {
                        fx: kt(aO)
                    })),
                    lan(n)
                ])),
                A2(Se, C([
                    nh("ShowAside")
                ]), g)
            ]));
        }(r) : A3(uhn, n, r, t.a);
    }), ihn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ohn = F2(function(n, r) {
        return A2(Se, C([
            nh("TimelineWrapper")
        ]), C([
            function() {
                var n = r.ll;
                return 1 === n.$ ? ch("") : A2(Nq, Snn, ch(n.a));
            }(),
            A2(Sk, ihn, A2(Se, C([
                nh("TimelineList")
            ]), A2(oan, n.r8, r.rA)))
        ]));
    }), chn = A2(Se, C([
        nh("BrowserWrapper")
    ]), C([
        Ktn
    ])), fhn = function(n) {
        return {
            $: 14,
            a: n
        };
    }, shn = function(n) {
        return {
            $: 13,
            a: n
        };
    }, lhn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, dhn = function(n) {
        return {
            $: 15,
            a: n
        };
    }, bhn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, mhn = Pi({
        bQ: "Accepted only",
        bX: "Accept\xe9s seulement"
    }), phn = Pi({
        bQ: "Display all",
        bX: "Tout afficher"
    }), vhn = Pi({
        bQ: "Non-accepted only",
        bX: "Non-accept\xe9s seulement"
    }), $hn = C([
        d(tK, phn),
        d(nK, mhn),
        d(uK, vhn)
    ]), ghn = Pi({
        bQ: "Actives only",
        bX: "Actifs seulement"
    }), hhn = Pi({
        bQ: "Archives only",
        bX: "Archives seulement"
    }), khn = Pi({
        bQ: "Trash",
        bX: "Corbeille"
    }), Chn = C([
        b(!1, tK, phn),
        b(!1, rK, ghn),
        b(!1, eK, hhn),
        b(!0, aK, khn)
    ]), jhn = Pi({
        bQ: "New",
        bX: "Nouveau"
    }), whn = Pi({
        bQ: "Add Advertiser",
        bX: "Ajouter un Annonceur"
    }), Ahn = Pi({
        bQ: "Add Collection",
        bX: "Ajouter une Collection"
    }), Lhn = function(n) {
        return {
            $: 11,
            a: n
        };
    }, yhn = {
        $: 5
    }, Shn = A2(Se, C([
        nh("LoadingMiniSpinner")
    ]), C([
        Jgn
    ])), Fhn = Pi({
        bQ: "New Ad",
        bX: "Nouveau Spot"
    }), Thn = Pi({
        bQ: "New Advertiser",
        bX: "Nouvel Annonceur"
    }), Qhn = Pi({
        bQ: "New Capsule",
        bX: "Nouvelle Capsule"
    }), Ihn = Pi({
        bQ: "New Collection",
        bX: "Nouvelle Collection"
    }), Bhn = Pi({
        bQ: "New Episode",
        bX: "Nouvel Episode"
    }), Whn = Pi({
        bQ: "New Master",
        bX: "Nouveau Master"
    }), Phn = Pi({
        bQ: "New Product",
        bX: "Nouveau Produit"
    }), Mhn = Pi({
        bQ: "New Season",
        bX: "Nouvelle Saison"
    }), qhn = Pi({
        bQ: "New Title",
        bX: "Nouveau Titre"
    }), Dhn = Pi({
        bQ: "New Unitary",
        bX: "Nouvel Unitaire"
    }), Xhn = A2(Qh, C([
        Ah("18px"),
        Bh("18px"),
        Ih("0 0 18 18"),
        Vg("IconPlus")
    ]), C([
        A2(UC, C([
            Vg("Fg")
        ]), C([
            A2(Cj, C([
                kj("M10,8 L10,4 L8,4 L8,8 L4,8 L4,10 L8,10 L8,14 L10,14 L10,10 L14,10 L14,8 L10,8 Z")
            ]), g)
        ]))
    ])), Ehn = F2(function(n, r) {
        var t = function(n) {
            return {
                $: 7,
                a: n
            };
        }(r), e = function() {
            var r = n.n3;
            if (r.$) return "";
            if (r.a.$) return 1 === r.a.a ? n.mF ? Fhn : Whn : Qhn;
            switch(r.a.a){
                case 0:
                    return n.mF ? Thn : Ihn;
                case 1:
                    return n.mF ? Phn : Mhn;
                case 2:
                    return n.mF ? qhn : Bhn;
                default:
                    return Dhn;
            }
        }(), u = n.ix;
        return A2(tj, C([
            aj(t),
            nh("BrowserNewForm")
        ]), C([
            A2(Se, C([
                nh("BrowserNewFormIcon")
            ]), C([
                function() {
                    var r = n.n3;
                    n: for(; !r.$;){
                        if (r.a.$) return 1 === r.a.a ? Crn : jrn;
                        switch(r.a.a){
                            case 0:
                                return Sen;
                            case 1:
                                return Fen;
                            default:
                                break n;
                        }
                    }
                    return Ten;
                }()
            ])),
            A2(Sk, Lhn, kk(p(u, {
                kT: "new-add-form",
                gy: e
            }))),
            A2(xg, C([
                qh("submit"),
                nh("BrowserNewFormIcon")
            ]), C([
                A2(pK, r, n.q0) ? Shn : Xhn
            ])),
            A2(Se, C([
                nh("BrowserNewFormIcon"),
                Mh(yhn)
            ]), C([
                $Q
            ]))
        ]));
    }), Rhn = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), xhn = function(n) {
        return Mh(n);
    }, Ohn = function(n) {
        var r = n.a, t = n.b, e = n.c;
        return A2(Se, C([
            nh("BrowserOptionsItem"),
            xhn(A2(Rhn, kt(r), t))
        ]), C([
            ch(e)
        ]));
    }, zhn = Pi({
        bQ: "Add Unitary",
        bX: "Ajouter un Unitaire"
    }), Nhn = "alphabeticalInversed", Hhn = Pi({
        bQ: "Reverse alphabetical",
        bX: "Alphab\xe9tique invers\xe9"
    }), Vhn = Pi({
        bQ: "Alphabetical",
        bX: "Alphab\xe9tique"
    }), Uhn = C([
        d("alphabetical", Vhn),
        d(Nhn, Hhn)
    ]), Jhn = {
        $: 16
    }, Zhn = Pi({
        bQ: "Vous n\u2019avez aucune enveloppe.",
        bX: "Vous n\u2019avez aucune enveloppe."
    }), Khn = function(n) {
        return A2(Se, C([
            nh("BrowserErrors"),
            Mh(Jhn)
        ]), C([
            wu(n.jI) && wu(n.fJ) ? j7(Zhn) : ch(""),
            function() {
                var r = n.ll;
                return r.$ ? ch("") : A2(Ann, Snn, r.a);
            }()
        ]));
    }, _hn = F3(function(n, r, t) {
        return {
            $: 1,
            a: n,
            b: r,
            c: t
        };
    }), Ghn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Yhn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, nkn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, rkn = function(n) {
        switch(n){
            case 0:
                return "MixedAccepted";
            case 1:
                return "AcceptedContent";
            case 2:
                return "NonAcceptedContent";
            default:
                return "EmptyAccepted";
        }
    }, tkn = F4(function(n, r, t, e) {
        return A2(Se, C([
            nh("BrowserIcon")
        ]), C([
            A2(pK, r.mj, n) ? t : e
        ]));
    }), ekn = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), ukn = F3(function(n, r, t) {
        var e = A2(mK, t.mj, n.k$);
        return A2(Se, C([
            nh("BrowserEdit"),
            xhn(A2(ekn, r, t))
        ]), C([
            e ? $Q : rln
        ]));
    }), akn = function(n) {
        return {
            $: 12,
            a: n
        };
    }, ikn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, okn = F2(function(n, r) {
        var t = n.k1;
        return A2(tj, C([
            aj(ikn(r.mj))
        ]), C([
            A2(Sk, akn, kk(t))
        ]));
    }), ckn = Pi({
        bQ: "Add Ad",
        bX: "Ajouter un Spot"
    }), fkn = Pi({
        bQ: "Add Capsule",
        bX: "Ajouter une Capsule"
    }), skn = Pi({
        bQ: "Add Episode",
        bX: "Ajouter un \xc9pisode"
    }), lkn = Pi({
        bQ: "Add Master",
        bX: "Ajouter un Master"
    }), dkn = Pi({
        bQ: "Add Product",
        bX: "Ajouter un Produit"
    }), bkn = Pi({
        bQ: "Add Season",
        bX: "Ajouter une Saison"
    }), mkn = Pi({
        bQ: "Add Title",
        bX: "Ajouter un Titre"
    }), pkn = irn(C([
        A2(UC, C([
            Vg("Fg"),
            zQ("translate(1.000000, 0.000000)")
        ]), C([
            A2(Cj, C([
                kj("M6,0 L12,0 L16,4 L16,13 L6,13 L6,0 Z M8,2 L8,11 L14,11 L14,5 L11,5 L11,2 L8,2 Z")
            ]), g),
            A3(Fh, "polygon", C([
                Lh("0 5 5 5 5 7 2 7 2 16 8 16 8 14 10 14 10 18 0 18")
            ]), g)
        ]))
    ])), vkn = F3(function(n, r, t) {
        if (1 === t.$) {
            var e = t.a, u = t.b, a = t.c, i = A2(mK, r.mj, n.iw);
            return A2(Se, C([
                nh("BrowserOptions"),
                Mh(i ? yhn : A2(Rhn, kt(e), u)),
                Zh(C([
                    d("BrowserOptionsOpened", i)
                ])),
                HW(a)
            ]), C([
                A2(Se, C([
                    nh("BrowserOptionsTitle")
                ]), C([
                    i ? $Q : fen
                ]))
            ]));
        }
        var o = t.a;
        return i = A2(mK, r.mj, n.ox), A2(Se, C([
            nh("BrowserOptions"),
            Mh(bhn(r.mj)),
            MA(i),
            Zh(C([
                d("BrowserOptionsOpened", i)
            ]))
        ]), C([
            A2(Se, C([
                nh("BrowserOptionsTitle")
            ]), C([
                i ? $Q : fen
            ])),
            i ? A2(Se, C([
                nh("BrowserOptionsMenu")
            ]), A2(Ge, Ohn, o)) : ch("")
        ]));
    }), $kn = F4(function(n, r, t, e) {
        var u = t.mF ? dkn : bkn, a = t.mF ? ckn : lkn, o = t.mF ? mkn : skn, c = i(t.qb, kt(e.mj)), f = A2(pK, e.mj, t.op), s = A2(mK, e.mj, t.iw), l = 2 === e.gl && YZ(e), m = 1 !== e.gl && !l;
        if (c || s || m) {
            var p = e.eL;
            if (p.$) return v = p.a, d(e.mj, A2(Se, C([
                nh("BrowserTitle"),
                Zh(C([
                    d("BrowserTitleOpened", A2(mK, e.mj, r)),
                    d("BrowserTitleHidden", c && !m)
                ])),
                nh("BrowserItemWrapper")
            ]), C([
                A2(hj, C([
                    fk(e.mj),
                    nh("BrowserItem"),
                    wj(gK(e.mj))
                ]), C([
                    A2(Se, C([
                        nh("BrowserIcon")
                    ]), C([
                        1 === v ? Crn : jrn
                    ])),
                    A2(ph, C([
                        nh(1 === v ? "BrowserLabelMaster" : "BrowserLabelShow")
                    ]), C([
                        A2(mK, e.mj, t.k$) ? A2(okn, t, e) : ch(e.m$)
                    ])),
                    e.il ? A2(Se, C([
                        nh("BrowserIcon")
                    ]), C([
                        A2(ph, C([
                            nh("BrowserShowAccepted")
                        ]), g)
                    ])) : ch(""),
                    e.h6 ? A2(Se, C([
                        nh("BrowserIcon")
                    ]), C([
                        Zen
                    ])) : YZ(e) ? A2(Se, C([
                        nh("BrowserIcon")
                    ]), C([
                        Jen
                    ])) : ch("")
                ])),
                A2(mK, e.oz, n.r8.oz) ? A3(ukn, t, kt(nkn(v)), e) : ch(""),
                A2(pK, e.mj, t.op) ? A2(Se, C([
                    nh("BrowserList")
                ]), C([
                    A2(mK, e.mj, t.iw) ? A2(Ehn, t, e.mj) : ch("")
                ])) : ch("")
            ])));
            var v = p.a, h = p.b, k = function() {
                switch(v){
                    case 0:
                        return b(d("BrowserCollection", 0), d(orn, Sen), d(A3(_hn, lhn(1), e.mj, u), kt(frn(e.mj))));
                    case 1:
                        return b(d("BrowserSeason", 1), d(pkn, Fen), d(A3(_hn, lhn(2), e.mj, o), kt(frn(e.mj))));
                    case 2:
                        return b(d("BrowserEpisode", 2), d(Ten, Ten), d(Ghn(C([
                            b(nkn(1), e.mj, a),
                            b(nkn(0), e.mj, fkn)
                        ])), kt(frn(e.mj))));
                    default:
                        return b(d("BrowserCollection", 3), d(Ten, Ten), d(Ghn(C([
                            b(nkn(1), e.mj, lkn),
                            b(nkn(0), e.mj, fkn)
                        ])), kt(frn(e.mj))));
                }
            }(), j = k.b, w = j.a, A = j.b, L = k.c, y = L.a, S = L.b;
            return d(e.mj, A2(Se, C([
                nh(k.a.a),
                nh(rkn(e.d0))
            ]), C([
                A2(Se, C([
                    nh("BrowserItemWrapper"),
                    Zh(C([
                        d("BrowserOpened", f),
                        d("BrowserAdding", s),
                        d("BrowserEmpty", 2 === e.gl || c && !m),
                        d("BrowserShowAccepted", 1 === e.d0),
                        d("BrowserTitleOpened", A2(mK, e.mj, r)),
                        d("BrowserHasMenuOpened", A2(mK, e.mj, t.ox))
                    ]))
                ]), $(C([
                    A2(Se, C([
                        nh("BrowserItem"),
                        Mh(Yhn(e.mj))
                    ]), C([
                        A4(tkn, t.op, e, w, A),
                        A2(ph, C([
                            nh("BrowserLabelMaster")
                        ]), C([
                            A2(mK, e.mj, t.k$) ? A2(okn, t, e) : ch(e.m$)
                        ])),
                        e.h6 ? A2(Se, C([
                            nh("BrowserIcon")
                        ]), C([
                            Zen
                        ])) : 1 === e.hw ? A2(Se, C([
                            nh("BrowserIcon")
                        ]), C([
                            Jen
                        ])) : ch("")
                    ])),
                    function() {
                        var r = d(S, A2(mK, e.oz, n.r8.oz));
                        if (!r.a.$ && r.b) {
                            var t = r.a.a;
                            return A2(hj, C([
                                nh("BrowserAttachment"),
                                wj(t),
                                fk(e.mj)
                            ]), C([
                                wun
                            ]));
                        }
                        return ch("");
                    }()
                ]), A2(mK, e.oz, n.r8.oz) ? C([
                    A3(ukn, t, kt(lhn(v)), e),
                    A3(vkn, t, e, y)
                ]) : g)),
                f ? A3(Pk, "div", C([
                    nh("BrowserList"),
                    Zh(C([
                        d("BrowserListOpened", f),
                        d("BrowserAdding", s)
                    ]))
                ]), (i(t.oy.sa, Nhn) ? Jt : Be)(A2(Ge, A3($kn, n, r, t), h))) : ch(""),
                s ? A2(Se, g, C([
                    A2(Ehn, t, e.mj)
                ])) : ch("")
            ])));
        }
        return d(e.mj, ch(""));
    }), gkn = F3(function(n, r, t) {
        return A2(bt, d("head", function() {
            var n = Ra(t.jI);
            if (n.$) return ch("");
            var r, e = n.a;
            return A2(_h, C([
                nh("BrowserSection")
            ]), Pi({
                bQ: (r = e.gp) + "\u2019s Stock",
                bX: "Stock de " + r
            }));
        }()), (i(t.oy.sa, Nhn) ? Jt : Be)(A2(Ge, A3($kn, n, r, t), t.jI)));
    }), hkn = F3(function(n, r, t) {
        var e = function(n) {
            return vt(n);
        }(Xc(A2(Ge, function(n) {
            return n.gp;
        }, A2(Bu, function(r) {
            return i(YZ(r), n.ea);
        }, t.fJ))));
        return A2(bt, d("Invitations", A2(_h, C([
            nh("BrowserSection")
        ]), "Invitations")), A2(Ge, function(e) {
            return d(e, A3(Pk, "div", g, A2(bt, d("org", A2(_h, C([
                nh("BrowserSubSection")
            ]), e)), A2(Ge, A3($kn, n, r, t), A2(Bu, function(n) {
                return i(n.gp, e);
            }, t.fJ)))));
        }, e));
    }), kkn = F3(function(n, r, t) {
        var e = t.mF ? whn : Ahn, u = C(t.mF ? [
            b(lhn(0), "", e)
        ] : [
            b(lhn(0), "", e),
            b(lhn(3), "", zhn)
        ]), a = A2(mK, "", t.ox), o = !i(n.r8.oz, Ct), c = A2(nc, function(r) {
            return r.a && !n.r8.iz ? Ct : kt(d(r.b, r.c));
        }, Chn);
        return A2(Se, C([
            nh("BrowserWrapper")
        ]), C([
            A2(Se, C([
                nh("BrowserHeader")
            ]), C([
                A2(Se, C([
                    nh("BrowserOrder")
                ]), C([
                    A2(Sk, shn, A2(nj, t.iT, c)),
                    A2(Sk, fhn, A2(nj, t.im, $hn)),
                    A2(Sk, dhn, A2(nj, t.oy, Uhn))
                ])),
                A2(Se, C([
                    nh("BrowserNewButton")
                ]), C([
                    o ? VW(p(AW, {
                        lu: C([
                            MA(a)
                        ]),
                        mi: kt(fen),
                        mD: a,
                        m$: jhn,
                        ol: kt(bhn(""))
                    })) : ch(""),
                    A2(mK, "", t.ox) ? A2(Se, C([
                        nh("BrowserOptionsMenu")
                    ]), A2(Ge, Ohn, u)) : ch("")
                ]))
            ])),
            A2(Se, C([
                nh("BrowserNew")
            ]), C([
                A2(mK, "", t.iw) ? A2(Ehn, t, "") : ch("")
            ])),
            Khn(t),
            A2(Se, C([
                nh("Browser")
            ]), C([
                A3(Pk, "div", g, A3(gkn, n, r, t)),
                A3(Pk, "div", g, A3(hkn, n, r, t))
            ]))
        ]));
    }), Ckn = F3(function(n, r, t) {
        return 1 === t.Q.kt.$ ? chn : A3(kkn, n, r, t);
    }), jkn = F5(function(n, r, t, e, u) {
        return A3(Pk, "div", C([
            nh("ShowsWrapper"),
            nh(r.r6.$ ? "ActiveShow" : "ActiveShows")
        ]), C([
            d("Browser", A2(Sk, Ai, A3(Ckn, r, t, e))),
            d(n, u)
        ]));
    }), wkn = {
        $: 3
    }, Akn = BA(Pp(rv)), Lkn = BA(Pp(vv)), ykn = BA(Pp($v)), Skn = BA(Pp(tv)), Fkn = BA(Pp(uv)), Tkn = BA(Pp(av)), Qkn = function(n) {
        return 4 === n.$ && 18 === n.a.$;
    }, Ikn = function(n) {
        return 4 === n.$ && 14 === n.a.$;
    }, Bkn = BA(Pp(cv)), Wkn = BA(Pp(fv)), Pkn = BA(Pp(sv)), Mkn = BA(Pp(lv)), qkn = BA(Pp(dv)), Dkn = Pi({
        bQ: "Report",
        bX: "Rapport"
    }), Xkn = BA(Xp), Ekn = BA(Pp(bv)), Rkn = BA(Pp(mv)), xkn = BA(Pp(pv)), Okn = F3(function(n, r, t) {
        return A2(hj, C([
            Zh(C([
                d("MenuSettingsActive", n)
            ])),
            nh("MenuSettingsItem"),
            wj(r)
        ]), C([
            t
        ]));
    }), zkn = BA(Pp(gv)), Nkn = BA(Pp(hv)), Hkn = function(n) {
        var r;
        return A2(Se, C([
            nh("MenuSettingsSub")
        ]), C([
            A3(Okn, Qkn(n.r6), WA({
                c9: Ct
            }), ch("Dashboard")),
            A3(Okn, i(n.r6, Xp), Xkn, ch(Dkn)),
            A3(Okn, i(n.r6, Pp(lv)), Mkn, ch("Organizations")),
            A3(Okn, i(n.r6, Pp(fv)), Wkn, ch("Onboarding")),
            A3(Okn, i(n.r6, Pp(gv)), zkn, ch("Users")),
            A3(Okn, i(n.r6, Pp($v)), ykn, ch("Uploads")),
            A3(Okn, i(n.r6, Pp(vv)), Lkn, ch("Test Plans")),
            A3(Okn, i(n.r6, Pp(rv)), Akn, ch("Audio Mappings")),
            A3(Okn, i(n.r6, Pp(tv)), Skn, ch("Channels")),
            A3(Okn, i(n.r6, Pp(bv)), Ekn, ch("Researchs")),
            A3(Okn, i(n.r6, Pp(hv)), Nkn, ch("Webhooks")),
            A3(Okn, i(n.r6, Pp(sv)), Pkn, ch("Organization file listing")),
            A3(Okn, i(n.r6, Pp(av)), Tkn, ch("Formats")),
            A3(Okn, i(n.r6, Pp(pv)), xkn, ch("Subtitle Formats")),
            A3(Okn, i(n.r6, Pp(mv)), Rkn, ch("Segmentation rules")),
            A3(Okn, Ikn(n.r6), (r = A4(jv, Ct, Ct, Ct, Ct), BA(Pp(ov(r)))), ch("Jobs")),
            A3(Okn, i(n.r6, Pp(cv)), Bkn, ch("Metadata")),
            A3(Okn, i(n.r6, Pp(uv)), Fkn, ch("Deep Probe Templates")),
            A3(Okn, i(n.r6, Pp(dv)), qkn, ch("Deep Probes")),
            A3(Okn, i(n.r6, Pp(iv)), ern, ch("Flubber"))
        ]));
    }, Vkn = A2(Qh, C([
        Ah("40px"),
        Bh("40px"),
        Ih("0 0 27 27"),
        Vg("IconSettings")
    ]), C([
        A2(UC, C([
            Vg("Fg")
        ]), C([
            A2(Cj, C([
                kj("M11.3255145,8.62757252 L11.7398554,10.6992769 C10.6891763,11.4201032 10,12.6295687 10,14 C10,16.209139 11.790861,18 14,18 C16.209139,18 18,16.209139 18,14 C18,12.6295687 17.3108237,11.4201032 16.2601446,10.6992769 L16.6744855,8.62757252 C18.6458726,9.61086325 20,11.6472949 20,14 C20,17.3137085 17.3137085,20 14,20 C10.6862915,20 8,17.3137085 8,14 C8,11.6472949 9.35412735,9.61086325 11.3255145,8.62757252 Z M13,7 L15,7 L15,15 L13,15 L13,7 Z")
            ]), g)
        ]))
    ])), Ukn = Pi({
        bQ: "Logout",
        bX: "D\xe9connexion"
    }), Jkn = function(n) {
        return A2(Se, C([
            nh("MenuSettingsSub")
        ]), C([
            A3(Okn, i(n.r6, Xp), Xkn, ch(Dkn))
        ]));
    }, Zkn = F3(function(n, r, t) {
        var e, u;
        return A3(Pk, "div", C([
            nh("SettingsWrapper")
        ]), C([
            d("SettingsMenu", A2(Sk, mH, (e = r, u = 8 === e.r6.$, A2(Se, C([
                nh("MenuSettings")
            ]), C([
                e.r8.iz ? Hkn(e) : Jkn(e),
                A2(hj, C([
                    nh("MenuSettingsItem"),
                    nh("MenuSettingsProfile"),
                    wj($rn),
                    Zh(C([
                        d("MenuSettingsActive", u)
                    ]))
                ]), C([
                    A2(Se, C([
                        nh("MenuSettingsIcon")
                    ]), C([
                        yrn
                    ])),
                    A2(Se, C([
                        nh("MenuSettingsTitle")
                    ]), C([
                        A2(Se, C([
                            nh("UserCardName")
                        ]), C([
                            ch(e.r8.nW)
                        ]))
                    ]))
                ])),
                A2(Se, C([
                    nh("MenuSettingsItem"),
                    nh("MenuSettingsLogout"),
                    Mh(wkn)
                ]), C([
                    A2(Se, C([
                        nh("MenuSettingsIcon")
                    ]), C([
                        Vkn
                    ])),
                    A2(Se, C([
                        nh("MenuSettingsTitle")
                    ]), C([
                        ch(Ukn)
                    ]))
                ]))
            ]))))),
            d(n, t)
        ]));
    }), Kkn = function(n) {
        if (1 === n.$) return A2(Sk, Si, function(n) {
            var r = 1 === n.al.r6.$ ? A2(inn, K7, fnn) : g;
            return A2(Se, A2(bt, Zh(C([
                d("IsFullscreen", n.al.dW.mK),
                d("AsideOpened", function() {
                    var r = n.al.r6;
                    switch(r.$){
                        case 1:
                        case 2:
                            return !!r.b;
                        default:
                            return !1;
                    }
                }())
            ])), r), C([
                A2(Se, C([
                    nh("AppWrapper")
                ]), C([
                    Lrn(n),
                    A3(Pk, "div", C([
                        nh("Wrapper")
                    ]), C([
                        d("Menu", A3(lnn, mH, Nrn, n.al)),
                        function() {
                            var r = n.al.r6;
                            switch(r.$){
                                case 8:
                                    return d("Settings", A3(Zkn, "", n.al, A4(vnn, gJ, Ynn, n.al, n.dz)));
                                case 9:
                                    return d("Report", A3(Zkn, "", n.al, A4(vnn, vJ, Mnn, n.al, n.cj)));
                                case 0:
                                    return d("APP", A5(jkn, "Shows", n.al, Ct, n.eu, A4(vnn, Fi, ohn, n.al, n.rA)));
                                case 2:
                                    return d("APP", A5(jkn, "Hierarchy", n.al, kt(r.a), n.eu, A5($nn, Wv, san, n.al, n.n8, n.eu)));
                                case 1:
                                    return d("APP", A5(jkn, "Show", n.al, kt(r.a), n.eu, A4(vnn, Pv(n.g9.mj), ahn, n.al, n.g9)));
                                case 6:
                                    return d("APP", A5(jkn, "Archive", n.al, Ct, n.eu, A4(vnn, Fi, ohn, n.al, n.rA)));
                                case 4:
                                    return d("Admin", A3(Zkn, "", n.al, A5($nn, wi, rrn, n.al, r.a, n.iz)));
                                case 5:
                                    return d("Help", function(n) {
                                        var r = n.oI;
                                        if (r.$) return A2(Se, C([
                                            nh("SettingsWrapper")
                                        ]), C([
                                            NQ
                                        ]));
                                        if (r.a.$) return ch("Erreur 404");
                                        var t = r.a.a;
                                        return A2(Se, C([
                                            nh("SettingsWrapper")
                                        ]), C([
                                            A3(Wj, t.rB, Ct, A2(Se, C([
                                                nh("Help")
                                            ]), C([
                                                Utn(t.eq)
                                            ])))
                                        ]));
                                    }(n.l2));
                                case 7:
                                    return d("Upload", A4(vnn, $H, Rtn, {
                                        e8: n.al.e8,
                                        mh: snn(n.kY),
                                        oI: e7(n),
                                        r8: n.al.r8
                                    }, n.r$));
                                default:
                                    return d("notfound", A2(Se, C([
                                        nh("SettingsWrapper")
                                    ]), C([
                                        ch("NOT FOUND")
                                    ])));
                            }
                        }()
                    ])),
                    A4(vnn, $H, Rtn, {
                        e8: n.al.e8,
                        mh: snn(n.kY),
                        oI: e7(n),
                        r8: n.al.r8
                    }, n.r$)
                ]))
            ]));
        }(n.a));
        var r = n.a;
        return function(n) {
            return A2(Se, C([
                nh("AccountPageWrapper")
            ]), C([
                A2(Se, g, C([
                    A2(hj, C([
                        nh("AccountPageLogo"),
                        wj("/")
                    ]), C([
                        R7
                    ]))
                ])),
                A2(Se, C([
                    nh("AccountPageContent")
                ]), n)
            ]));
        }(C([
            function() {
                var n = r.oI;
                switch(n.$){
                    case 0:
                        var t = n.a;
                        return A2(Sk, A2(mu, sH, bU), function(n) {
                            var r = 2 !== n.qJ;
                            return A2(f7, HU, C([
                                A2(Se, C([
                                    nh("AccountHeader")
                                ]), C([
                                    A2(_h, C([
                                        nh("AccountTitle")
                                    ]), T7)
                                ])),
                                A2(Se, C([
                                    nh("AccountFormFields")
                                ]), C([
                                    A2(Sk, y7, VC(n.k6)),
                                    A2(Se, C([
                                        Zh(C([
                                            d("AccountFormPassword", !0),
                                            d("AccountFormPasswordHide", r)
                                        ]))
                                    ]), C([
                                        A2(Sk, S7, DO(n.oN))
                                    ]))
                                ])),
                                A2(Se, C([
                                    nh("AccountMessage")
                                ]), C([
                                    M7(n.nE)
                                ])),
                                A2(Se, C([
                                    nh("AccountFooter")
                                ]), C([
                                    A2(Se, C([
                                        nh("AccountFooterLinks")
                                    ]), C([
                                        A2(JT, !r, A2(s7, I7, B7))
                                    ])),
                                    ij(r ? W7 : Q7)
                                ]))
                            ]));
                        }(t));
                    case 1:
                        return t = n.a, A2(Sk, A2(mu, sH, lU), function(n) {
                            return A2(f7, o7, C([
                                A2(Se, C([
                                    nh("AccountHeader")
                                ]), C([
                                    A2(_h, C([
                                        nh("AccountTitle")
                                    ]), m7)
                                ])),
                                A2(Se, C([
                                    nh("AccountFormFields")
                                ]), C([
                                    A2(Sk, i7, VC(n.k6))
                                ])),
                                A2(Se, C([
                                    nh("AccountMessage")
                                ]), C([
                                    function() {
                                        var r = n.nE;
                                        switch(r.$){
                                            case 0:
                                                return ch("");
                                            case 1:
                                                return A2(_h, C([
                                                    nh("succeed")
                                                ]), v7);
                                            default:
                                                var t = r.a;
                                                return A2(_h, C([
                                                    nh("failed")
                                                ]), t);
                                        }
                                    }()
                                ])),
                                A2(Se, C([
                                    nh("AccountFooter")
                                ]), C([
                                    A2(Se, C([
                                        nh("AccountFooterLinks")
                                    ]), C([
                                        A2(s7, b7, c7)
                                    ])),
                                    ij(p7)
                                ]))
                            ]));
                        }(t));
                    case 2:
                        return t = n.a, A2(Sk, A2(mu, sH, mU), function(n) {
                            var r;
                            return A2(f7, z7, C([
                                A2(Se, C([
                                    nh("AccountHeader")
                                ]), C([
                                    A2(_h, C([
                                        nh("AccountTitle")
                                    ]), U7)
                                ])),
                                A2(Se, C([
                                    nh("AccountFormFields")
                                ]), C([
                                    A2(Sk, O7, V7(n.oN)),
                                    A2(Sk, x7, V7(n.j1)),
                                    Z7(n.nE),
                                    (r = n.oO, r.$ ? ch("") : j7(w7(r.a)))
                                ])),
                                A2(Se, C([
                                    nh("AccountFooter")
                                ]), C([
                                    A2(Se, C([
                                        nh("AccountFooterLinks")
                                    ]), C([
                                        A2(s7, b7, N7)
                                    ])),
                                    ij(H7)
                                ]))
                            ]));
                        }(t));
                    default:
                        return t = n.a, A2(Sk, A2(mu, sH, dU), function(n) {
                            var r;
                            return A2(f7, k7, C([
                                A2(Se, C([
                                    nh("AccountHeader")
                                ]), C([
                                    A2(_h, C([
                                        nh("AccountTitle")
                                    ]), C7)
                                ])),
                                A2(Se, C([
                                    nh("AccountFormFields")
                                ]), C([
                                    A2(Sk, g7, VC(n.nW)),
                                    A2(Sk, h7, DO(n.oN)),
                                    A2(Sk, $7, DO(n.j1)),
                                    (r = n.oO, r.$ ? ch("") : j7(w7(r.a)))
                                ])),
                                A2(Se, C([
                                    nh("AccountMessage")
                                ]), C([
                                    A2(qC, _h(C([
                                        nh("failed")
                                    ])), n.ll)
                                ])),
                                A2(Se, C([
                                    nh("AccountFooter")
                                ]), C([
                                    A2(Se, C([
                                        nh("AccountFooterLinks")
                                    ]), g),
                                    ij(L7)
                                ]))
                            ]));
                        }(t));
                }
            }()
        ]));
    }, _kn = function(n) {
        switch(n.$){
            case 0:
                return Bt(n.a) + "px";
            case 1:
                return FS(n.a) + "%";
            case 2:
                return FS(n.a) + "em";
            default:
                return "auto";
        }
    }, Gkn = gbn, Ykn = function(n) {
        return A2(Gkn, "bottom", _kn(n));
    }, nCn = function(n) {
        return A2(Gkn, "left", _kn(n));
    }, rCn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, tCn = rCn, eCn = {
        ij: A2(Gkn, "position", "absolute"),
        lH: A2(Gkn, "position", "fixed"),
        du: A2(Gkn, "position", "relative"),
        qS: A2(Gkn, "position", "static"),
        hz: A2(Gkn, "position", "sticky")
    }, uCn = function(n) {
        return function(n) {
            return {
                $: 0,
                a: n
            };
        }(n);
    }, aCn = function(n) {
        return A2(Gkn, "top", _kn(n));
    }, iCn = F3(function(n, r, t) {
        return tCn(C([
            eCn.ij,
            aCn(uCn(n)),
            Ykn(uCn(r)),
            nCn(uCn(t))
        ]));
    }), oCn = function(n) {
        return A2(Gkn, "right", _kn(n));
    }, cCn = F4(function(n, r, t, e) {
        return tCn(C([
            eCn.ij,
            aCn(uCn(n)),
            oCn(uCn(r)),
            Ykn(uCn(t)),
            nCn(uCn(e))
        ]));
    }), fCn = F2(function(n, r) {
        return A2(uC, r, va(C([
            rC(n)
        ])));
    }), sCn = fCn, lCn = {
        jh: A2(Gkn, "display", "block"),
        bU: A2(Gkn, "display", "flex"),
        ml: A2(Gkn, "display", "inline"),
        mm: A2(Gkn, "display", "inline-block"),
        mn: A2(Gkn, "display", "inline-flex"),
        mo: A2(Gkn, "display", "inline-table"),
        m9: A2(Gkn, "display", "list-item"),
        n9: A2(Gkn, "display", "none"),
        pG: A2(Gkn, "display", "run-in"),
        ri: A2(Gkn, "display", "table"),
        rk: A2(Gkn, "display", "table-caption"),
        rl: A2(Gkn, "display", "table-cell"),
        rm: A2(Gkn, "display", "table-column"),
        rn: A2(Gkn, "display", "table-column-group"),
        ro: A2(Gkn, "display", "table-footer-group"),
        rp: A2(Gkn, "display", "table-header-group"),
        rq: A2(Gkn, "display", "table-row"),
        rr: A2(Gkn, "display", "table-row-group")
    }, dCn = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), bCn = dCn(3), mCn = bCn, pCn = F2(function(n, r) {
        return A2(uC, r, A2(ma, n, g));
    }), vCn = pCn, $Cn = F2(function(n, r) {
        return A2(vCn, "", C([
            mCn(A2(Ge, ce(r), n))
        ]));
    }), gCn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, hCn = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), kCn = F2(function(n, r) {
        var t = A2(Gu, _a, r), e = function(r) {
            n: for(;;){
                if (!r.b) return g;
                switch(r.a.$){
                    case 0:
                        r = a = r.b;
                        continue n;
                    case 1:
                        var t = r.a, u = t.b, a = r.b;
                        return A2(bt, A2(hCn, A2(Su, n, t.a), u), e(a));
                    default:
                        return A2(bt, r.a, e(a = r.b));
                }
            }
        }, u = function(n) {
            n: for(;;){
                if (n.b) {
                    if (n.a.$) {
                        n = n.b;
                        continue n;
                    }
                    return A2(bt, n.a.a, u(n.b));
                }
                return g;
            }
        }, a = A2(hCn, n, u(t));
        return A2(bt, a, e(t));
    }), CCn = F2(function(n, r) {
        return A2(kCn, A2(Ge, gCn, n), r);
    }), jCn = CCn, wCn = function(n) {
        return {
            ja: A2(Gkn, n, "auto"),
            l3: A2(Gkn, n, "hidden"),
            pU: A2(Gkn, n, "scroll"),
            sl: A2(Gkn, n, "visible")
        };
    }, ACn = wCn("overflow"), LCn = C([
        A2(jCn, C([
            "(min-width: 1400px)"
        ]), C([
            A2($Cn, C([
                sCn("LayoutBackButton"),
                sCn("LayoutHomeButton"),
                sCn("LayoutFwdButton")
            ]), C([
                lCn.n9
            ])),
            A2($Cn, C([
                sCn("SettingsWrapper"),
                sCn("ShowsWrapper")
            ]), C([
                A4(cCn, 0, 0, 0, 94),
                ACn.l3
            ])),
            A2(sCn, "BrowserWrapper", C([
                A3(iCn, 0, 0, 0)
            ])),
            A2($Cn, C([
                sCn("TimelineWrapper"),
                sCn("ShowWrapper"),
                sCn("MasterWrapper")
            ]), C([
                A4(cCn, 0, 0, 0, 404)
            ]))
        ]))
    ]), yCn = Gkn("animation"), SCn = C([
        A2(sCn, "IsFullscreen", C([
            mCn(C([
                A2(sCn, "ShowPlayer", C([
                    yCn("none")
                ]))
            ]))
        ]))
    ]), FCn = function(n) {
        return A2(Gkn, "flex-basis", _kn(n));
    }, TCn = {
        jU: A2(Gkn, "flex-direction", "column"),
        jV: A2(Gkn, "flex-direction", "column-reverse"),
        pB: A2(Gkn, "flex-direction", "row"),
        pE: A2(Gkn, "flex-direction", "row-reverse")
    }, QCn = tCn(C([
        lCn.bU,
        TCn.jU
    ])), ICn = A2(mu, Gkn("flex-shrink"), Bt), BCn = function(n) {
        return A2(Gkn, "height", _kn(n));
    }, WCn = function(n) {
        return function(n) {
            return {
                $: 1,
                a: n
            };
        }(n);
    }, PCn = F3(function(n, r, t) {
        return A2(sCn, n, C([
            mCn(C([
                A2(sCn, r, t)
            ]))
        ]));
    }), MCn = Gkn("transition"), qCn = tCn(C([
        MCn("all cubic-bezier(0.8, 0, 0.1, 1) 80ms")
    ])), DCn = Gkn("transform"), XCn = F3(function(n, r, t) {
        return DCn("translate3d(" + Bt(n) + "px," + Bt(r) + "px," + Bt(t) + "px)");
    }), ECn = gbn, RCn = C([
        A2(jCn, C([
            "(min-width: 1000px) and (max-width: 1400px)"
        ]), C([
            A2(sCn, "ShowWrapper", C([
                ICn(0),
                FCn(WCn(100)),
                qCn
            ])),
            A2($Cn, C([
                sCn("ShowWrapper")
            ]), C([
                A3(XCn, 404, 0, 0),
                A4(cCn, 0, 0, 0, 0)
            ])),
            A2(sCn, "TimelineWrapper", C([
                A4(cCn, 0, 0, 0, 404)
            ])),
            A2(sCn, "MasterWrapper", C([
                A4(cCn, 0, 0, 0, 404)
            ])),
            A2(sCn, "ShowsWrapper", C([
                QCn,
                A4(cCn, 0, 0, 0, 94),
                ACn.l3
            ])),
            A2(sCn, "SettingsWrapper", C([
                A4(cCn, 0, 0, 0, 94),
                ACn.l3
            ])),
            A2(sCn, "BrowserWrapper", C([
                qCn,
                A3(iCn, 0, 0, 0)
            ])),
            A2(sCn, "ShowMain", C([
                A2(ECn, "width", "calc(100% - 404px)"),
                ICn(0)
            ])),
            A2(vCn, ".ShowMain:only-child", C([
                eCn.ij,
                BCn(WCn(100))
            ])),
            A2(sCn, "LayoutBackButton", C([
                lCn.n9
            ])),
            A2(sCn, "LayoutHomeButton", C([
                lCn.n9
            ])),
            A2(sCn, "AsideOpened", C([
                mCn(C([
                    A2(sCn, "ShowWrapper", C([
                        A3(XCn, 0, 0, 0)
                    ])),
                    A2(sCn, "BrowserWrapper", C([
                        A3(XCn, -404, 0, 0)
                    ])),
                    A2(sCn, "LayoutBackButton", C([
                        lCn.bU
                    ])),
                    A3(PCn, "ShowMain", "LayoutFwdButton", C([
                        lCn.n9
                    ]))
                ]))
            ]))
        ]))
    ]), xCn = tCn(C([
        lCn.bU,
        TCn.pB
    ])), OCn = C([
        A2(sCn, "AppWrapper", C([
            xCn,
            A4(cCn, 4, 4, 4, 4),
            A3(XCn, 0, 0, 0),
            ACn.l3
        ])),
        A2(sCn, "Wrapper", C([
            xCn,
            A4(cCn, 44, 0, 0, 0),
            A3(XCn, 0, 0, 0),
            ACn.l3
        ]))
    ]), zCn = F2(function(n, r) {
        return $Cn(A2(Ge, n, r));
    }), NCn = {
        $: 3
    }, HCn = F2(function(n, r) {
        return A2(Gkn, "border", Bt(n) + "px solid " + r);
    }), VCn = {
        jl: A2(Gkn, "clear", "both"),
        da: A2(Gkn, "clear", "left"),
        n9: A2(Gkn, "clear", "none"),
        pz: A2(Gkn, "clear", "right")
    }, UCn = Gkn("color"), JCn = ECn("fill"), ZCn = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), KCn = function(n) {
        return ZCn(function(n) {
            return {
                $: 2,
                a: n
            };
        }(n));
    }, _Cn = KCn("first-child"), GCn = _Cn, YCn = {
        da: A2(Gkn, "float", "left"),
        n9: A2(Gkn, "float", "none"),
        pz: A2(Gkn, "float", "right")
    }, njn = {
        jj: A2(Gkn, "font-weight", "600"),
        jk: A2(Gkn, "font-weight", "700"),
        m7: A2(Gkn, "font-weight", "400"),
        oa: A2(Gkn, "font-weight", "500")
    }, rjn = function(n) {
        return bCn(C([
            A2(fCn, "Fg", C([
                A2(ECn, "fill", n)
            ]))
        ]));
    }, tjn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ejn = F2(function(n, r) {
        return A2(uC, r, va(C([
            tjn(n)
        ])));
    }), ujn = ejn, ajn = function(n) {
        return A2(Gkn, "margin", _kn(n));
    }, ijn = function(n) {
        return A2(Gkn, "margin-top", _kn(n));
    }, ojn = function(n) {
        return A2(Gkn, "opacity", FS(n / 100));
    }, cjn = function(n) {
        return A2(Gkn, "padding", _kn(n));
    }, fjn = function(n) {
        return A2(Gkn, "width", _kn(n));
    }, sjn = function(n) {
        return ZCn(rC(n));
    }, ljn = uCn(0), djn = C([
        A2(jCn, C([
            "print"
        ]), C([
            A2(vCn, ".Button", C([
                A2(ECn, "display", "none !important")
            ])),
            A2(sCn, "IconBreadcrumb", C([
                JCn(Uun)
            ])),
            A2(sCn, "Private", C([
                ACn.pU
            ])),
            A2(sCn, "HeaderLogo", C([
                aCn(NCn),
                nCn(NCn)
            ])),
            A3(zCn, vCn, C([
                "button",
                "form"
            ]), C([
                A2(ECn, "display", "none !important")
            ])),
            A2(ujn, "player", C([
                A2(ECn, "display", "none !important")
            ])),
            A3(zCn, sCn, C([
                "MasterFilesDesc"
            ]), C([
                A2(ECn, "display", "flex !important")
            ])),
            A3(zCn, vCn, C([
                ".ActivityItem",
                "tr"
            ]), C([
                A2(ECn, "page-break-inside", "avoid")
            ])),
            A3(zCn, sCn, C([
                "Search",
                "MenuWrapper",
                "BrowserWrapper",
                "PlayerVideoWrapper",
                "LayoutFwdButton",
                "LayoutHomeButton",
                "LayoutAppBarActions",
                "LayoutBackButton",
                "CustomButton",
                "PadokUploadWrapper",
                "ProgressBarOuter",
                "ActivityHeader",
                "ButtonMiniIcon",
                "ActivityAnswerForm",
                "FileOperationLabelProgress",
                "FileOperationProgress",
                "FileOperationIcon",
                "PadokUploadWrapper",
                "DeliveryChild",
                "UploadChild",
                "PlayerFoldPreview",
                "AcceptationHeaderActions",
                "Button",
                "ReportLinksButton",
                "HeaderLogo",
                "Acceptation",
                "LayoutAppBarWrapper",
                "FileOperation",
                "ActivityHeader",
                "ActivityCommentForm",
                "Operations"
            ]), C([
                A2(ECn, "display", "none !important")
            ])),
            A2(sCn, "HeaderBreadcrumbLabel", C([
                UCn(Nun),
                njn.jj
            ])),
            A2(sCn, "HeaderBreadcrumb", C([
                rjn(Nun + "!important"),
                A2(HCn, 3, Nun),
                ijn(uCn(8))
            ])),
            A2(sCn, "IconBreadcrumb", C([
                GCn(C([
                    lCn.n9
                ]))
            ])),
            A2(sCn, "ActivityItem", C([
                A2(ECn, "order", "10"),
                A2(sjn, "RedFlag", C([
                    A2(ECn, "order", "1")
                ]))
            ])),
            A2(sCn, "ActivityContent", C([
                A2(HCn, 0, "!important")
            ])),
            A2(sCn, "ActivityItem", C([
                A2(HCn, 2, Nun)
            ])),
            A2(vCn, ".ActivityVerificationMessage:after", C([
                A2(ECn, "content", '" "'),
                VCn.jl,
                lCn.jh,
                BCn(uCn(1))
            ])),
            A2(sCn, "ActivityCommentVerifTc", C([
                YCn.da,
                ajn(uCn(5)),
                mCn(C([
                    A2(sCn, "ButtonIcon", C([
                        ojn(0)
                    ])),
                    A2(sCn, "TimecodeWrapper", C([
                        A2(HCn, 2, Oun)
                    ])),
                    A2(sCn, "TimecodeUnit", C([
                        UCn(Oun)
                    ]))
                ]))
            ])),
            A3(zCn, sCn, C([
                "AppWrapper",
                "Wrapper",
                "ShowsWrapper",
                "ShowWrapper",
                "ShowMain",
                "ShowAside",
                "ShowHomeWrapper",
                "MasterFilesWrapper"
            ]), C([
                DCn("translate(0,0)"),
                fjn(NCn),
                BCn(NCn),
                aCn(ljn),
                oCn(ljn),
                Ykn(ljn),
                nCn(ljn),
                A2(ECn, "overflow", "unset !important"),
                A2(ECn, "display", "unset !important"),
                A2(ECn, "position", "unset !important")
            ])),
            A3(zCn, sCn, C([
                "MasterFilesWrapper",
                "ShowAside"
            ]), C([
                A2(HCn, 3, Nun),
                ijn(uCn(4)),
                A2(ECn, "display", "block !important")
            ])),
            A2(sCn, "FileStatus", C([
                A2(HCn, 0, "black")
            ])),
            A2(sCn, "AsideTab", C([
                A2(HCn, 0, "black"),
                cjn(ljn),
                lCn.jh,
                fjn(ljn)
            ])),
            A3(zCn, sCn, C([
                "AsideTabsIcon",
                "IconChoice"
            ]), C([
                lCn.n9
            ])),
            A3(zCn, sCn, C([
                "AsideHeader",
                "AsideTabsLabel",
                "AsideTabInner",
                "AsideTabs",
                "AsideTab"
            ]), C([
                lCn.jh,
                fjn(NCn),
                BCn(NCn),
                cjn(ljn),
                A2(HCn, 0, "black !important")
            ])),
            A2(sCn, "AsideHeader", C([
                ajn(uCn(10))
            ])),
            A2(sCn, "Activity", C([
                ajn(uCn(3))
            ])),
            A2(sCn, "HeaderBreadcrumbItemLogo", C([
                A2(HCn, 0, "black")
            ])),
            A3(zCn, sCn, C([
                "ShowHomeWrapper",
                "ShowWrapper"
            ]), C([
                QCn
            ])),
            A3(zCn, sCn, C([
                "ActivityVerificationMessage",
                "ShowWrapper"
            ]), C([
                UCn(Nun)
            ]))
        ]))
    ]), bjn = C([
        A2(jCn, C([
            "(max-width: 650px)"
        ]), C([
            A2($Cn, C([
                sCn("SettingsWrapper"),
                sCn("ShowsWrapper")
            ]), C([
                A4(cCn, 0, 0, 0, 0)
            ])),
            A2(sCn, "MenuWrapper", C([
                lCn.n9,
                A2(sjn, "MenuOpened", C([
                    lCn.bU
                ]))
            ])),
            A2(sCn, "OptionalMenuItem", C([
                A2(ECn, "display", "none !important")
            ]))
        ]))
    ]), mjn = {
        cC: A2(Gkn, "align-items", "baseline"),
        jF: A2(Gkn, "align-items", "center"),
        bV: A2(Gkn, "align-items", "flex-end"),
        lN: A2(Gkn, "align-items", "flex-start"),
        qY: A2(Gkn, "align-items", "stretch")
    }, pjn = Gkn("background"), vjn = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), $jn = function(n) {
        return vjn(n);
    }, gjn = $jn("before"), hjn = F2(function(n, r) {
        return A2(Gkn, "border-bottom", Bt(n) + "px solid " + r);
    }), kjn = F2(function(n, r) {
        return A2(Gkn, "border-top", Bt(n) + "px solid " + r);
    }), Cjn = function(n) {
        return A2(Gkn, "font-size", _kn(n));
    }, jjn = tCn(C([
        Cjn(uCn(20)),
        njn.jj
    ])), wjn = {
        jF: A2(Gkn, "justify-content", "center"),
        bV: A2(Gkn, "justify-content", "flex-end"),
        lN: A2(Gkn, "justify-content", "flex-start"),
        hl: A2(Gkn, "justify-content", "space-around"),
        qF: A2(Gkn, "justify-content", "space-between")
    }, Ajn = F2(function(n, r) {
        return A2(Gkn, "margin", A2(Wt, " ", A2(Ge, _kn, C([
            n,
            r
        ]))));
    }), Ljn = F3(function(n, r, t) {
        return A2(Gkn, "margin", A2(Wt, " ", A2(Ge, _kn, C([
            n,
            r,
            t
        ]))));
    }), yjn = function(n) {
        return A2(Gkn, "max-width", _kn(n));
    }, Sjn = F2(function(n, r) {
        return A2(Gkn, "padding", A2(Wt, " ", A2(Ge, _kn, C([
            n,
            r
        ]))));
    }), Fjn = function(n) {
        return A2(Gkn, "padding-left", _kn(n));
    }, Tjn = function(n) {
        return A2(Gkn, "padding-right", _kn(n));
    }, Qjn = {
        jF: A2(Gkn, "text-align", "center"),
        fP: A2(Gkn, "text-align", "justify"),
        da: A2(Gkn, "text-align", "left"),
        pz: A2(Gkn, "text-align", "right")
    }, Ijn = "#fff", Bjn = A2(mu, Gkn("z-index"), Bt), Wjn = C([
        A2(sCn, "AccountPageWrapper", C([
            yjn(uCn(580)),
            A3(Ljn, uCn(50), NCn, uCn(0)),
            A2(Sjn, uCn(0), uCn(10))
        ])),
        A2(sCn, "AccountPageLogo", C([
            lCn.jh,
            DCn("scale(0.7)")
        ])),
        A2(jCn, C([
            "(max-width: 650px)"
        ]), C([
            A2(sCn, "AccountPageLogo", C([
                mCn(C([
                    A2(vCn, "svg", C([
                        fjn(WCn(100))
                    ]))
                ]))
            ]))
        ])),
        A2(sCn, "AccountPageContent", C([
            A2(HCn, 4, Mun.ks),
            A2(Ajn, uCn(40), uCn(0))
        ])),
        A2(sCn, "AccountWrapper", g),
        A2(sCn, "AccountForm", C([
            pjn(Ijn),
            cjn(uCn(10))
        ])),
        A2(sCn, "AccountFormFields", C([
            cjn(uCn(10))
        ])),
        A2(sCn, "AccountTitle", C([
            jjn
        ])),
        A2(sCn, "AccountSubmit", g),
        A2(sCn, "AccountLink", C([
            QCn,
            fjn(uCn(200)),
            A2(Sjn, uCn(5), uCn(0))
        ])),
        A2(sCn, "AccountMessage", g),
        A2(sCn, "AccountSuccess", C([
            UCn(Run.jR),
            A2(Sjn, uCn(5), uCn(0))
        ])),
        A2(sCn, "AccountFail", C([
            UCn(Gun.jR),
            A2(Sjn, uCn(5), uCn(0))
        ])),
        A2(sCn, "AccountHeader", C([
            cjn(uCn(10)),
            A2(hjn, 2, zun),
            Qjn.jF,
            ajn(uCn(4)),
            UCn(zun)
        ])),
        A2(sCn, "AccountFooter", C([
            xCn,
            cjn(uCn(10)),
            A2(kjn, 2, zun),
            ajn(uCn(4))
        ])),
        A2(sCn, "AccountFooterLinks", C([
            QCn,
            fjn(uCn(220)),
            Tjn(uCn(20)),
            Qjn.pz
        ])),
        A2(jCn, C([
            "(device-aspect-ratio: 40/71)"
        ]), C([
            A2(sCn, "AccountFooterLinks", C([
                QCn,
                fjn(uCn(175))
            ]))
        ])),
        A2(sCn, "BetaLoginFooter", C([
            xCn,
            wjn.qF,
            mjn.jF
        ])),
        A2(sCn, "AccountSSO", C([
            eCn.du
        ])),
        A2(jCn, C([
            "(min-width: 650px)"
        ]), C([
            A2(sCn, "AccountSSO", C([
                Fjn(uCn(235))
            ]))
        ])),
        A2(sCn, "AccountFormPassword", C([
            eCn.du,
            ACn.l3
        ])),
        A2(sCn, "AccountFormPasswordHide", C([
            eCn.du,
            gjn(C([
                A2(ECn, "content", '" "'),
                eCn.ij,
                A2(ECn, "inset", "0"),
                Bjn(90),
                pjn("white")
            ]))
        ]))
    ]), Pjn = Gkn("background-color"), Mjn = F2(function(n, r) {
        return A2(Gkn, "flex", Bt(n) + " " + Bt(r));
    }), qjn = function(n) {
        return A2(Gkn, "min-width", _kn(n));
    }, Djn = tCn(C([
        A2(Mjn, 1, 1),
        qjn(ljn)
    ])), Xjn = tCn(C([
        lCn.bU,
        TCn.pE
    ])), Ejn = KCn("hover"), Rjn = wCn("overflow-x"), xjn = wCn("overflow-y"), Ojn = {
        jz: A2(Gkn, "text-transform", "capitalize"),
        ns: A2(Gkn, "text-transform", "lowercase"),
        n9: A2(Gkn, "text-transform", "none"),
        r5: A2(Gkn, "text-transform", "uppercase")
    }, zjn = C([
        A2(sCn, "AccountReportWrapper", C([
            QCn,
            Djn,
            Pjn(zun)
        ])),
        A2(sCn, "AccountReportContainer", C([
            Rjn.l3,
            xjn.ja,
            QCn,
            Djn,
            cjn(uCn(20)),
            yjn(uCn(800)),
            fjn(WCn(100))
        ])),
        A2(sCn, "AccountReportSubmit", C([
            Pjn(zun),
            Xjn,
            mCn(C([
                A2(sCn, "CustomButtonLabel", C([
                    UCn(Ijn),
                    Pjn(Mun.nl),
                    Ojn.r5,
                    njn.jk,
                    Cjn(uCn(10)),
                    Ejn(C([
                        Pjn(Mun.jR)
                    ]))
                ]))
            ]))
        ]))
    ]), Njn = function(n) {
        return A2(Gkn, "margin-bottom", _kn(n));
    }, Hjn = C([
        A2(sCn, "SettingsWrapper", C([
            xCn,
            Djn,
            A4(cCn, 0, 0, 0, 94)
        ])),
        A2(sCn, "SettingsTitle", C([
            Cjn(uCn(18)),
            UCn(Ijn)
        ])),
        A2(sCn, "SettingsForm", C([
            cjn(uCn(10)),
            yjn(uCn(500)),
            Pjn(zun)
        ])),
        A2(sCn, "SettingsContainer", C([
            Pjn(zun),
            Rjn.l3,
            xjn.ja,
            QCn,
            Djn
        ])),
        A2(sCn, "Version", C([
            Qjn.jF,
            Njn(uCn(5)),
            eCn.ij,
            oCn(uCn(15)),
            ijn(uCn(10))
        ]))
    ]), Vjn = _u(C([
        Wjn,
        Hjn,
        zjn
    ])), Ujn = dCn(2), Jjn = {
        iD: A2(Gkn, "cursor", "alias"),
        iF: A2(Gkn, "cursor", "all-scroll"),
        ja: A2(Gkn, "cursor", "auto"),
        jE: A2(Gkn, "cursor", "cell"),
        jQ: A2(Gkn, "cursor", "col-resize"),
        j3: A2(Gkn, "cursor", "context-menu"),
        j7: A2(Gkn, "cursor", "copy"),
        kj: A2(Gkn, "cursor", "crosshair"),
        kA: A2(Gkn, "cursor", "default"),
        kZ: A2(Gkn, "cursor", "e-resize"),
        lo: A2(Gkn, "cursor", "ew-resize"),
        lZ: A2(Gkn, "cursor", "grab"),
        l_: A2(Gkn, "cursor", "grabbing"),
        l2: A2(Gkn, "cursor", "help"),
        nS: A2(Gkn, "cursor", "move"),
        nV: A2(Gkn, "cursor", "n-resize"),
        nZ: A2(Gkn, "cursor", "ne-resize"),
        n_: A2(Gkn, "cursor", "nesw-resize"),
        n4: A2(Gkn, "cursor", "no-drop"),
        n9: A2(Gkn, "cursor", "none"),
        ob: A2(Gkn, "cursor", "not-allowed"),
        oe: A2(Gkn, "cursor", "ns-resize"),
        oh: A2(Gkn, "cursor", "nw-resize"),
        oi: A2(Gkn, "cursor", "nwse-resize"),
        oV: A2(Gkn, "cursor", "pointer"),
        o6: A2(Gkn, "cursor", "progress"),
        pD: A2(Gkn, "cursor", "row-resize"),
        pL: A2(Gkn, "cursor", "s-resize"),
        pV: A2(Gkn, "cursor", "se-resize"),
        rg: A2(Gkn, "cursor", "sw-resize"),
        cs: A2(Gkn, "cursor", "text"),
        sh: A2(Gkn, "cursor", "vertical-text"),
        sm: A2(Gkn, "cursor", "w-resize"),
        sn: A2(Gkn, "cursor", "wait"),
        sz: A2(Gkn, "cursor", "zoom-in"),
        sA: A2(Gkn, "cursor", "zoom-out")
    }, Zjn = function(n) {
        return tCn(C([
            A2(ECn, "gap", Bt(n) + "px")
        ]));
    }, Kjn = A2(mu, Gkn("flex-grow"), Bt), _jn = function(n) {
        return A2(Gkn, "line-height", _kn(n));
    }, Gjn = F4(function(n, r, t, e) {
        return A2(Gkn, "margin", A2(Wt, " ", A2(Ge, _kn, C([
            n,
            r,
            t,
            e
        ]))));
    }), Yjn = function(n) {
        return A2(Gkn, "margin-left", _kn(n));
    }, nwn = function(n) {
        return A2(Gkn, "margin-right", _kn(n));
    }, rwn = function(n) {
        return A2(Gkn, "min-height", _kn(n));
    }, twn = C([
        A2(sCn, "AdminWrapper", C([
            xCn,
            Djn
        ])),
        A2(jCn, C([
            "(min-width: 1000px)"
        ]), g),
        A2(sCn, "AdminTabsWrapper", C([
            xCn,
            Djn,
            rwn(uCn(0))
        ])),
        A2(sCn, "AdminHeader", C([
            BCn(uCn(80)),
            cjn(uCn(10)),
            Pjn(xun),
            Njn(uCn(4)),
            xCn
        ])),
        A2(sCn, "AdminPadding", C([
            yjn(uCn(800)),
            A2(Ajn, uCn(15), NCn),
            A2(HCn, 3, Nun)
        ])),
        A2(sCn, "AdminTitle", C([
            Djn,
            UCn(Nun),
            cjn(uCn(15)),
            _jn(uCn(30))
        ])),
        A2(sCn, "AdminTabs", C([
            QCn,
            fjn(uCn(200)),
            nwn(uCn(4)),
            ACn.ja
        ])),
        A2(sCn, "AdminTab", C([
            BCn(uCn(48)),
            A2(Sjn, uCn(15), uCn(25)),
            Cjn(uCn(14)),
            Njn(uCn(4)),
            Jjn.oV,
            UCn(Zun),
            Pjn(zun),
            xCn,
            Ejn(C([
                UCn(Ijn),
                Pjn(Mun.jR)
            ])),
            A2(sjn, "AdminTabActive", C([
                UCn(Mun.m6),
                Pjn(Mun.nn)
            ])),
            mCn(C([
                A2(vCn, "a", C([
                    UCn("inherit")
                ]))
            ]))
        ])),
        A2(sCn, "AdminContent", C([
            UCn(Vun),
            Djn,
            ACn.ja
        ])),
        A2(sCn, "EditContainer", C([
            Yjn(uCn(220))
        ])),
        A2(sCn, "EditSection", C([
            ijn(uCn(20))
        ])),
        A2(sCn, "EmptySection", C([
            lCn.bU,
            mjn.jF,
            wjn.jF,
            rwn(uCn(300))
        ])),
        A2(sCn, "Summary", C([
            cjn(uCn(10)),
            mCn(C([
                A2(vCn, "h2", C([
                    A2(Sjn, uCn(10), uCn(0))
                ])),
                A2(vCn, "p", C([
                    A2(Ajn, uCn(10), uCn(0))
                ]))
            ]))
        ])),
        A2(sCn, "Filter", C([
            Ujn(C([
                A2(vCn, ":first-child", C([
                    lCn.bU,
                    ajn(uCn(0)),
                    A2(Sjn, uCn(0), uCn(10)),
                    Pjn(Nun)
                ]))
            ]))
        ])),
        A2(sCn, "FilterSelect", C([
            fjn(uCn(225)),
            A4(Gjn, uCn(6), uCn(0), uCn(10), uCn(10)),
            lCn.bU,
            Ujn(C([
                A2(vCn, ":first-child", C([
                    lCn.bU,
                    FCn(WCn(40)),
                    mjn.jF
                ]))
            ]))
        ])),
        A2(sCn, "JobsFilters", C([
            mjn.jF,
            Ujn(C([
                A2(vCn, ".Select", C([
                    BCn(uCn(32)),
                    Njn(uCn(4))
                ]))
            ]))
        ])),
        A2(sCn, "LayoutAppBarActions", C([
            qjn(uCn(100))
        ])),
        A2(sCn, "AdminForumSubsection", C([
            Yjn(uCn(100))
        ])),
        A2(sCn, "FieldTitle", C([
            xCn,
            Zjn(6)
        ])),
        A2(sCn, "FieldBloc", C([
            QCn,
            Kjn(1)
        ])),
        A2(sCn, "FieldLine", C([
            xCn,
            mjn.jF,
            Kjn(1)
        ])),
        A2(vCn, ".FieldLine .InputLabel", C([
            xCn,
            mjn.jF,
            Kjn(1)
        ])),
        A2(sCn, "OrganizationOnboarding", C([
            xCn,
            mjn.jF,
            A2(Sjn, ljn, uCn(6)),
            A2(ECn, "gap", "3px")
        ])),
        A2(sCn, "OrganizationEditApp", C([
            xCn,
            mjn.jF,
            cjn(uCn(6)),
            A2(ECn, "gap", "6px")
        ]))
    ]), ewn = C([
        A2(sCn, "EditContainer", C([
            Yjn(uCn(220))
        ])),
        A2(sCn, "EditSection", C([
            ijn(uCn(20))
        ]))
    ]), uwn = {
        od: A2(Gkn, "flex-wrap", "nowrap"),
        sp: A2(Gkn, "flex-wrap", "wrap"),
        sq: A2(Gkn, "flex-wrap", "wrap-reverse")
    }, awn = {
        mP: A2(Gkn, "font-style", "italic"),
        oa: A2(Gkn, "font-style", "normal"),
        oj: A2(Gkn, "font-style", "oblique")
    }, iwn = F4(function(n, r, t, e) {
        return A2(Gkn, "padding", A2(Wt, " ", A2(Ge, _kn, C([
            n,
            r,
            t,
            e
        ]))));
    }), own = C([
        A2(sCn, "StitchWrapper", C([
            QCn,
            Njn(uCn(4))
        ])),
        A2(sCn, "StitchHeader", C([
            xCn,
            cjn(uCn(10)),
            Pjn(Kun),
            UCn(Nun),
            Njn(uCn(4))
        ])),
        A2(sCn, "StitchTitle", C([
            Cjn(uCn(16)),
            _jn(uCn(28)),
            njn.jj,
            Djn
        ])),
        A2(sCn, "StitchAdd", C([
            A2(HCn, 2, Oun),
            ijn(uCn(3)),
            UCn(Ijn),
            xCn,
            uwn.sp,
            wjn.lN,
            A4(iwn, uCn(0), uCn(0), uCn(3), uCn(3)),
            A4(Gjn, uCn(0), uCn(0), uCn(10), uCn(0)),
            mCn(C([
                A2(sCn, "Select", C([
                    FCn(WCn(30)),
                    A2(HCn, 0, Nun),
                    A4(Gjn, uCn(3), uCn(3), uCn(0), uCn(0))
                ])),
                A2(sCn, "SelectButtonIcon", C([
                    BCn(uCn(30))
                ]))
            ]))
        ])),
        A2(sCn, "StichSegment", C([
            xCn,
            Kjn(1),
            FCn(WCn(100)),
            cjn(uCn(3)),
            A4(Gjn, uCn(3), uCn(3), uCn(0), uCn(0)),
            Pjn(Nun),
            Pjn(Oun),
            mjn.jF
        ])),
        A2(sCn, "StichSegmentTitle", C([
            Djn,
            A2(Sjn, ljn, uCn(6))
        ])),
        A2(sCn, "StichSegmentUnit", C([
            UCn(xun),
            awn.mP,
            Tjn(uCn(3))
        ])),
        A2(sCn, "StichSegmentDuration", C([
            fjn(uCn(60)),
            UCn(Mun.jR),
            njn.jk,
            Qjn.pz,
            Pjn(Nun)
        ])),
        A2(sCn, "StichSegmentDelete", C([
            BCn(uCn(18)),
            Yjn(uCn(3))
        ])),
        A2(sCn, "StichSegmentUrl", C([
            Kjn(1),
            UCn(Mun.jR),
            njn.jk,
            Qjn.pz,
            Pjn(Nun),
            qjn(uCn(315))
        ])),
        A2(sCn, "StichVideoSegment", C([
            QCn,
            Yjn(uCn(10))
        ])),
        A2(sCn, "StichSegmentSubtract", C([
            xCn,
            Djn,
            nwn(uCn(10))
        ]))
    ]), cwn = _u(C([
        own,
        ewn
    ])), fwn = _u(C([
        cwn,
        twn
    ])), swn = F2(function(n, r) {
        return tCn(C([
            eCn.ij,
            aCn(uCn(n)),
            oCn(uCn(r))
        ]));
    }), lwn = "#000", dwn = F2(function(n, r) {
        return A2(Gkn, "border-left", Bt(n) + "px solid " + r);
    }), bwn = F2(function(n, r) {
        return A2(Gkn, "border-right", Bt(n) + "px solid " + r);
    }), mwn = function(n) {
        return A2(uC, n, va(g));
    }, pwn = Gkn("font-family"), vwn = function(n) {
        return A2(Gkn, "max-height", _kn(n));
    }, $wn = F3(function(n, r, t) {
        return A2(Gkn, "padding", A2(Wt, " ", A2(Ge, _kn, C([
            n,
            r,
            t
        ]))));
    }), gwn = function(n) {
        return A2(Gkn, "padding-bottom", _kn(n));
    }, hwn = "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHAAAAA4CAYAAAAl63xKAAAAAXNSR0IArs4c6QAABZJJREFUeAHtXMly1DAQVRIDYQmBIlxYTsCFUMWV4v8LyImiCk7AieVCKJYAEwIkzFN4To+mtXgjM5nWRba1up+6n6SWvXTr/sMDNw6rq6vu+o2bbuPKhltaWsKjqXBwcOC2P267d2/fuN3d3Yl0rfyTJ498nkvrl+u8e7/2xmVHbn9/3z9bW7voNjfv1eklF+zH61cvfXZZvyz/+csnf/vgwUP5uL5+8eK529n56u+Xl5fHMjjrTp86XafnLlj/rdt3VLlp75+rM5ceyq9CAXQegEAgACcEkgKTwPGFUR6AaOWRxhA2LAFnntIYA+zqxlXf39IyWr67dzcnBuSPH9/d7vKoMZDoy9BBkx9k7gG8uLbumCEEAh3TgJMjFddaeb7U150vtcZJ4GKaznJDxxwIsDrSsrQFcoj+Uq60WFJ+W1uPDwFEwwBBA4KdosZJ4JgWK890NC4bzgFHjX//7q2v4tr1G6qJYv1ajBcvDSkg91Z+ugsX1kqrUvOhLzG5qQX+Pfz2bcf9/vPb38Xk5zVQViKB/Dk2jQhnGnKDrK/JNYGTGo/yMdOu1R2OWHBsaQiBRLsUYGkdMh/aBse21Wi2HeNYtDUFIDtAIHmfi0PBYcTAHCMYxx5O+toCmeLYKIA5wJiuAcdJEGw0gnHscBzrARzSRhNoajQB52SJ6caxlESz2APYVrVLbHTYHQmkcWx3jq1AkJw0tAUyZaNDAHlPIHmfi6m5cjptHLvpKgh/ntdBAH6ROdab0HD6LDVy1tdB1FxqNDV1UTh2YhYaAjkP6yACyFgCuQgcOwEghUAgAWCXcJx7jQSytP/U3HnjWBXA0pfO5eNAMI4dbq+4evbsqbO9xrw7jRpNTZ0Vjq1Go5HtNUb8eZqFkUDOAsdW586dN39eC38egdRA1p5Rc/vm2IodYQM0DVhKMJg/j5JoHlOuErg+94rrSYwGJLuLxmP+KOaRMd1C5s/L+/MoN03+chUQ2yuuAWRFXWICx40A1oWO4BlHHmansRCO2JPuzwvlIIEs4dgawFBw5s9zbh7WsZUGHDXF/HmHh6dmeR1bwQOBkOM4qdryFBpNQMxGM10rzzTj2PZnZrwJTZ25oJAZSyBKbDTL9REbx05KEf5YD6D58yYFk7vjFqGcJebKaOl9cGw9idEa6OOZcWxcihwIXTi2CECAANPZNJSca2Sd0jQbxx6dYsv5Y5MA/o9zjQSQsQTSODZ/ZiYJYB82GsAYx3J4lsU0rSUcmwSQFXWx0WVdbp9r0Tk2CSDFmgIyZ6NZRyo2jm3/7Udle43z/e1HBZ5rGqiRJTY6Vbdx7FkvHjnrlpv+UnYxqqgAxnEFDgTj2PZnZlQO5JaV+fOG9+dReeTyiRrJtNRe8QSABM78eYeim4dvPzyAGnD0LuBVOCJCxyxHCOKYjYZ5bBpoWo1j899XVh+2P9Qft0DQBE5uneGaANmZmabDMZ2fcm17ZqbiKNeAk023tdGyDl5T441ju3NstTL+xYh9A8+h1Syehb3i8UJ+vajXmqrDnCJAe6Vp5ZEMLlGocXJyRI1HeePY5v+ZoUWcmIVCmGHQgCNAdmbm+M/MJAE0f144nPV7zpq1DYmh94qTAM7DOkiKVDPVSA+XPzTtsiyvQ4sz63vFSQD5UubPoyTKYmokZ/hlpaZzlewVFwE4XXV/T8IRL483GsfmObYXAAGCXPiXwmscWyYparTGsZ0AnIV1EESwyOvYTgCW2OiSMWYcWyKlozzUSHBsJwBZkababX6cetTF/q5OOsdGAcSLl4YUkEOvg1J9XASOnQIwHLGzvg5KAbgI69gawBA4OZ1PCUlLo0b+j3WQ1n747CRzbPL7QABxnIEDwTg27o8t/j5QAsktK/PndffnUa70zsTW0/Q+0FLSE/QXU2aja+FG/18AAAAASUVORK5CYII=) repeat", kwn = F4(function(n, r, t, e) {
        return A2(Gkn, "text-shadow", _kn(n) + " " + _kn(r) + " " + _kn(t) + " " + e);
    }), Cwn = BCn(uCn(24)), jwn = {
        d7: A2(Gkn, "user-select", "all"),
        ja: A2(Gkn, "user-select", "auto"),
        eK: A2(Gkn, "user-select", "contain"),
        n9: A2(Gkn, "user-select", "none"),
        cs: A2(Gkn, "user-select", "text")
    }, wwn = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), Awn = function(n) {
        return wwn(A2(Ge, gCn, n));
    }, Lwn = C([
        A2(ujn, "player-template", C([
            lCn.n9
        ])),
        A2(sCn, "PlayerVideoWrapper", C([
            QCn
        ])),
        A2(sCn, "PlayerBox", C([
            QCn,
            mjn.jF,
            wjn.jF,
            pjn(Oun),
            A2(HCn, 6, Oun)
        ])),
        A2(sCn, "PlayerVideoBuffering", C([
            eCn.ij,
            aCn(uCn(0)),
            Ykn(uCn(0)),
            nCn(uCn(0)),
            oCn(uCn(0)),
            QCn,
            mjn.jF,
            wjn.jF
        ])),
        A2(sCn, "PlayerVideo", C([
            eCn.du
        ])),
        A2(sCn, "PlayerDeployed", C([
            Djn,
            ACn.l3,
            A2(ECn, "aspect-ratio", "16 / 9"),
            A2(ECn, "max-height", "calc(100vh - 215px)"),
            Ujn(C([
                A2(vCn, "video", C([
                    ijn(WCn(-3.78))
                ]))
            ]))
        ])),
        A2(vCn, "noma-player", C([
            A2(ECn, "aspect-ratio", "16 / 9")
        ])),
        A2(sCn, "PlayerFullScreen", C([
            mCn(C([
                A2(sCn, "PlayerBox", C([
                    Djn,
                    cjn(ljn),
                    A2(HCn, 0, Oun),
                    xCn,
                    wjn.jF,
                    A2(Awn, C([
                        "(min-aspect-ratio: 16/9)"
                    ]), C([
                        QCn
                    ]))
                ])),
                A2(sCn, "PlayerDeployed", C([
                    A2(ECn, "max-height", "100%"),
                    A2(ECn, "max-width", "100%")
                ])),
                A2(sCn, "PlayerControlsBox", C([
                    A2(ECn, "outline", "3px solid black"),
                    A2(kjn, 3, Oun)
                ]))
            ]))
        ])),
        A2(sCn, "PlayerCollapsed", C([
            BCn(uCn(124)),
            pjn("radial-gradient(ellipse at center, rgba(24,31,41,0) 0%,rgba(24,31,41,.9) 100%), " + hwn),
            ACn.l3
        ])),
        A2(sCn, "PlayerVideoBuffering", C([
            eCn.ij,
            aCn(uCn(0)),
            Ykn(uCn(0)),
            nCn(uCn(0)),
            oCn(uCn(0)),
            lCn.bU,
            mjn.jF,
            wjn.jF
        ])),
        A2(sCn, "PlayerControls", C([
            xCn,
            cjn(uCn(3)),
            Fjn(uCn(0)),
            A2(HCn, 3, Oun),
            A2(kjn, 0, Oun),
            Pjn(Nun),
            uwn.sp,
            Ujn(C([
                mwn(C([
                    Yjn(uCn(3)),
                    Cwn,
                    jwn.n9,
                    ICn(1)
                ]))
            ])),
            mCn(C([
                A2(vCn, ".InputSelect", C([
                    ajn(ljn)
                ]))
            ]))
        ])),
        A2(sCn, "PlayerControlsHidden", C([
            A2(sjn, "PlayerFullScreen", C([
                mCn(C([
                    A2(sCn, "PlayerControlsBox", C([
                        qCn,
                        ojn(0)
                    ]))
                ])),
                Jjn.n9
            ]))
        ])),
        A2($Cn, C([
            sCn("PlayerControlsPlayPause"),
            sCn("PlayerControlsForward"),
            sCn("PlayerControlsBackward"),
            sCn("PlayerControlsSound"),
            sCn("PlayerControlsOptions"),
            sCn("PlayerControlsFullScreen"),
            sCn("PlayerControlsStart"),
            sCn("PlayerControlsEnd"),
            sCn("PlayerPlaybackSpeed1"),
            sCn("PlayerPlaybackSpeed2"),
            sCn("PlayerPlaybackSpeed4"),
            sCn("PlayerGoBack1s"),
            sCn("PlayerControlsRatio"),
            sCn("PlayerGoBack5s"),
            sCn("PlayerGoForward1s"),
            sCn("PlayerGoForward5s"),
            sCn("ButtonDisplayRawImage")
        ]), C([
            Cwn,
            Jjn.oV,
            cjn(uCn(3)),
            Pjn(zun),
            Ejn(C([
                Pjn(Mun.jR),
                mCn(C([
                    A2(sCn, "Fg", C([
                        JCn(Ijn)
                    ]))
                ]))
            ])),
            mCn(C([
                A2(sCn, "Bg", C([
                    JCn("none")
                ]))
            ]))
        ])),
        A2(sCn, "PlayerBanner", C([
            fjn(WCn(100))
        ])),
        A2(sCn, "PlayerControlsTime", C([
            eCn.du,
            Djn,
            Pjn(zun)
        ])),
        A2(sCn, "PlayerControlsTimeMask", C([
            eCn.ij,
            aCn(uCn(0)),
            Ykn(uCn(0)),
            nCn(uCn(0)),
            oCn(uCn(0)),
            ojn(0),
            Bjn(100)
        ])),
        A2(sCn, "PlayerControlsTimeProgress", C([
            eCn.ij,
            aCn(uCn(0)),
            Ykn(uCn(0)),
            nCn(uCn(0)),
            Cwn,
            Pjn(Mun.jR),
            Bjn(10)
        ])),
        A2(sCn, "PlayerControlsTimeBuffered", C([
            eCn.ij,
            aCn(uCn(0)),
            Ykn(uCn(0)),
            Cwn,
            Pjn(Mun.eP),
            Bjn(5)
        ])),
        A2(sCn, "PlayerControlsTimeCursor", C([
            eCn.ij,
            Ykn(uCn(0)),
            A2(bwn, 2, Mun.jR),
            BCn(uCn(60)),
            gwn(uCn(40)),
            Bjn(15)
        ])),
        A2(sCn, "PlayerControlsTimeTimecode", C([
            Pjn(Mun.jR),
            UCn(Ijn),
            eCn.ij,
            oCn(uCn(0)),
            lCn.jh,
            pwn("monospace"),
            njn.jj,
            A4(kwn, uCn(1), uCn(1), uCn(0), "rgba(0,0,0,.3)"),
            A2(Sjn, uCn(6), uCn(10))
        ])),
        A2(sCn, "PlayerControlsTimeGhost", C([
            eCn.ij,
            aCn(uCn(-6)),
            BCn(uCn(40)),
            ojn(0),
            fjn(WCn(100))
        ])),
        A2(sCn, "PlayerControlsDuration", C([
            pwn("monospace"),
            UCn(Uun),
            Pjn(Kun),
            A4(kwn, uCn(1), uCn(1), uCn(0), "rgba(0,0,0,.3)"),
            A2(Sjn, ljn, uCn(6))
        ])),
        A2(sCn, "PlayerControlsBox", C([
            QCn,
            Bjn(4)
        ])),
        A2(sCn, "PlayerControlsBoxLeft", C([
            QCn,
            Djn
        ])),
        A2(sCn, "PlayerControlsBoxRight", C([
            QCn
        ])),
        A2(vCn, ".PlayerControlsBoxRight .PlayerControls", C([
            A2(dwn, 0, Oun)
        ])),
        A2(sCn, "PlayerSelection", C([
            A3($wn, uCn(0), uCn(3), uCn(3)),
            Pjn(Oun)
        ])),
        A2(vCn, ".PlayerSelection .Select:nth-child(1)", C([
            A2(kjn, 3, Nun)
        ])),
        A2(sCn, "PlayerOperations", C([
            cjn(uCn(3)),
            A2(bwn, 3, Oun),
            A2(hjn, 3, Oun),
            pjn(Nun),
            QCn,
            Djn
        ])),
        A2(sCn, "PlayerOperationsSeparator", C([
            Pjn(zun),
            ojn(30),
            fjn(uCn(10))
        ])),
        A2(sCn, "PlayerOperationsSpacer", C([
            Pjn(zun),
            ojn(30),
            Kjn(1)
        ])),
        A2(sCn, "PlayerOperationsMarkinout", C([
            mCn(C([
                A2(sCn, "CustomButton", C([
                    A3($wn, uCn(3), ljn, ljn)
                ]))
            ]))
        ])),
        A2(sCn, "PlayerControlsOptions", C([
            eCn.du
        ])),
        A2(sCn, "PlayerControlsOptionsMenu", C([
            lCn.n9,
            A2(swn, 33, 0),
            pjn(Mun.jR),
            UCn(Ijn)
        ])),
        A2(sCn, "PlayerControlsOptionsMenuOpened", C([
            Pjn(Mun.jR),
            mCn(C([
                A2(sCn, "Fg", C([
                    JCn(Ijn)
                ]))
            ]))
        ])),
        A3(PCn, "PlayerControlsOptionsMenuOpened", "PlayerControlsOptionsMenu", C([
            QCn,
            fjn(uCn(150))
        ])),
        A2(sCn, "PlayerOperationsMarkin", g),
        A2(sCn, "PlayerOperationsMarkout", g),
        A2(sCn, "PlayerOperationsSonagram", g),
        A2(sCn, "PlayerSonagram", C([
            ijn(uCn(4))
        ])),
        A2(sCn, "PlayerMarkinout", C([
            ijn(uCn(4)),
            Pjn(Kun)
        ])),
        A2(sCn, "PlayerSelectedSpeed", C([
            pjn(Oun)
        ])),
        A2(sCn, "PlayerAspectRatio", C([
            A4(cCn, 0, 0, 0, 0),
            mCn(C([
                A2(vCn, "svg", C([
                    eCn.ij,
                    aCn(WCn(50)),
                    nCn(uCn(0)),
                    DCn("translateY(calc(-50% - 2px))"),
                    fjn(WCn(100)),
                    BCn(NCn)
                ]))
            ]))
        ])),
        A2($Cn, C([
            vCn(".PlayerVideoWrapper:fullscreen"),
            vCn(".PlayerVideoWrapper:-webkit-full-screen"),
            vCn(".PlayerVideoWrapper:-moz-full-screen"),
            vCn(".PlayerVideoWrapper:-ms-fullscreen")
        ]), C([
            eCn.lH,
            aCn(uCn(0)),
            Ykn(uCn(0)),
            nCn(uCn(0)),
            oCn(uCn(0)),
            yjn(WCn(100)),
            vwn(WCn(100)),
            pjn(Nun),
            ACn.l3,
            Bjn(3)
        ])),
        A2($Cn, C([
            vCn(".PlayerVideoWrapper:fullscreen .PlayerDeployed"),
            vCn(".PlayerVideoWrapper:-webkit-full-screen .PlayerDeployed"),
            vCn(".PlayerVideoWrapper:-moz-full-screen .PlayerDeployed"),
            vCn(".PlayerVideoWrapper:-ms-fullscreen .PlayerDeployed")
        ]), C([
            A2(HCn, 0, lwn)
        ])),
        A2($Cn, C([
            vCn(".PlayerVideoWrapper:fullscreen .PlayerControlsBox"),
            vCn(".PlayerVideoWrapper:-webkit-full-screen .PlayerControlsBox"),
            vCn(".PlayerVideoWrapper:-moz-full-screen .PlayerControlsBox"),
            vCn(".PlayerVideoWrapper:-ms-fullscreen .PlayerControlsBox")
        ]), C([
            eCn.lH,
            Ykn(uCn(20)),
            nCn(WCn(50)),
            DCn("translateX(-50%)"),
            fjn(WCn(100)),
            yjn(uCn(1e3)),
            pjn("transparent"),
            Ujn(C([
                A2($Cn, C([
                    sCn("PlayerControlsBoxLeft"),
                    sCn("PlayerControlsBoxRight")
                ]), C([
                    TCn.jV,
                    A2(kjn, 3, Oun)
                ]))
            ]))
        ])),
        A2($Cn, C([
            vCn(".PlayerVideoWrapper:-moz-full-screen .PlayerControlsBox")
        ]), C([
            eCn.ij
        ])),
        A2($Cn, C([
            vCn(".IPhone")
        ]), C([
            mCn(C([
                A2($Cn, C([
                    vCn(".PlayerVideoWrapper")
                ]), C([
                    fjn(WCn(50)),
                    aCn(uCn(0))
                ]))
            ]))
        ])),
        A2($Cn, C([
            vCn(".IPad")
        ]), C([
            mCn(C([
                A2($Cn, C([
                    vCn(".PlayerVideoWrapper")
                ]), C([
                    fjn(WCn(100)),
                    aCn(uCn(20))
                ]))
            ]))
        ])),
        A2($Cn, C([
            vCn(".IOSTheater")
        ]), C([
            mCn(C([
                A2($Cn, C([
                    vCn(".ShowSelectBroadcastable")
                ]), C([
                    lCn.n9
                ])),
                A2($Cn, C([
                    vCn(".ShowAside")
                ]), C([
                    lCn.n9
                ])),
                A2($Cn, C([
                    vCn(".Acceptation")
                ]), C([
                    lCn.n9
                ])),
                A2($Cn, C([
                    vCn(".MasterFilesWrapper")
                ]), C([
                    lCn.n9
                ])),
                A2($Cn, C([
                    vCn(".DownloadWrapper")
                ]), C([
                    lCn.n9
                ])),
                A2($Cn, C([
                    vCn(".FilesWrapper")
                ]), C([
                    lCn.n9
                ])),
                A2($Cn, C([
                    vCn(".LayoutAppBarWrapper")
                ]), C([
                    lCn.n9
                ])),
                A2($Cn, C([
                    vCn(".BrowserWrapper")
                ]), C([
                    lCn.n9
                ])),
                A2($Cn, C([
                    vCn(".MenuWrapper")
                ]), C([
                    lCn.n9
                ])),
                A2($Cn, C([
                    vCn(".HeaderWrapper")
                ]), C([
                    lCn.n9
                ])),
                A2($Cn, C([
                    vCn(".ShowsWrapper.ActiveShow")
                ]), C([
                    nCn(uCn(0))
                ])),
                A2($Cn, C([
                    vCn(".ShowWrapper.ShowNoop")
                ]), C([
                    DCn("translate3d(0px,0px,0px)")
                ])),
                A2($Cn, C([
                    vCn(".Wrapper")
                ]), C([
                    aCn(uCn(0))
                ])),
                A2($Cn, C([
                    vCn(".ShowMain")
                ]), C([
                    fjn(WCn(100))
                ])),
                A2($Cn, C([
                    vCn(".ShowHomeWrapper")
                ]), C([
                    mjn.jF,
                    wjn.jF
                ])),
                A2($Cn, C([
                    vCn(".PadokUploadWrapper")
                ]), C([
                    lCn.n9
                ])),
                A2($Cn, C([
                    vCn(".PlayerVideoWrapper")
                ]), C([
                    eCn.lH,
                    nCn(WCn(50)),
                    DCn("translateX(-50%)"),
                    yjn(uCn(1070)),
                    pjn("transparent")
                ])),
                A2($Cn, C([
                    vCn("video")
                ]), C([
                    fjn(WCn(100))
                ]))
            ]))
        ]))
    ]), ywn = Gkn("border-color"), Swn = "#EC79ED", Fwn = "#8C96F7", Twn = "#57E5D0", Qwn = C([
        A2(sCn, "Avatar", C([
            fjn(uCn(24)),
            BCn(uCn(24)),
            Pjn(zun)
        ])),
        A2(sCn, "AvatarLetter", C([
            _jn(uCn(20)),
            Qjn.jF,
            Ojn.r5,
            njn.jk,
            A2(HCn, 2, xun),
            UCn(xun)
        ])),
        A2(sCn, "AvatarMe", C([
            UCn(Twn),
            ywn(Twn)
        ])),
        A2(sCn, "AvatarCowork", C([
            UCn(Fwn),
            ywn(Fwn)
        ])),
        A2(sCn, "AvatarAlien", C([
            UCn(Swn),
            ywn(Swn)
        ]))
    ]), Iwn = F2(function(n, r) {
        return A2(sCn, n, C([
            UCn(r.m6),
            mCn(C([
                A2(vCn, "svg", C([
                    pjn(r.nn),
                    ajn(uCn(2)),
                    mCn(C([
                        A2(sCn, "Fg", C([
                            JCn(r.jR)
                        ]))
                    ]))
                ])),
                A2(sCn, "BannerHeader", C([
                    pjn(r.jR),
                    UCn(Ijn),
                    Djn,
                    xCn
                ])),
                A2(vCn, "h4", C([
                    Cjn(uCn(12)),
                    UCn(Ijn),
                    Ojn.r5,
                    cjn(uCn(2)),
                    A4(kwn, uCn(1), uCn(1), uCn(2), "rgba(0,0,0,0.4)")
                ])),
                A2(sCn, "BannerContent", C([
                    pjn(r.nl),
                    A2(Sjn, uCn(5), uCn(10))
                ]))
            ]))
        ]));
    }), Bwn = {
        jR: "#FCB63B",
        eP: "#6A542C",
        eQ: "#3A3527",
        ks: "#212425",
        l8: "#FCC462",
        ma: "#FDD389",
        m6: "#FDE1B0",
        m7: "#FEF0D7",
        m8: "#FEF7EB",
        nl: "#CB9536",
        nn: "#9B7531"
    }, Wwn = function(n) {
        return function(n) {
            return {
                $: 2,
                a: n
            };
        }(n);
    }, Pwn = F2(function(n, r) {
        return A2(sCn, n, C([
            pjn(r.eQ),
            UCn(r.jR),
            njn.jj,
            xCn,
            mjn.jF,
            cjn(uCn(6)),
            _jn(Wwn(1.5)),
            Ujn(C([
                A2(vCn, "svg", C([
                    pjn(r.nn),
                    ajn(uCn(2)),
                    mCn(C([
                        A2(sCn, "Fg", C([
                            JCn(r.ks)
                        ]))
                    ]))
                ])),
                A2(sCn, "BannerContent", C([
                    A2(Sjn, ljn, uCn(4)),
                    Djn
                ]))
            ]))
        ]));
    }), Mwn = {
        fW: A2(Gkn, "text-decoration", "line-through"),
        n9: A2(Gkn, "text-decoration", "none"),
        gq: A2(Gkn, "text-decoration", "overline"),
        rV: A2(Gkn, "text-decoration", "underline")
    }, qwn = C([
        A2(Iwn, "BannerError", Gun),
        A2(Iwn, "BannerWarning", Bwn),
        A2(Iwn, "BannerSuccess", Run),
        A2(Iwn, "BannerAction", Mun),
        A2(Pwn, "BannerInvalid", Gun),
        A2(Pwn, "BannerEmptyness", Bwn),
        A2(Pwn, "BannerValid", Run),
        A2(Pwn, "BannerAdvice", Mun),
        A2(sCn, "BannerTodo", C([
            xCn,
            Pjn("#5E2F83"),
            UCn("#E6B0FF")
        ])),
        A2(sCn, "BannerTodoIcon", C([
            ajn(uCn(6)),
            rjn(Nun),
            Ujn(C([
                mwn(C([
                    A2(HCn, 2, Nun)
                ]))
            ]))
        ])),
        A2(sCn, "BannerTodoBody", C([
            QCn,
            ajn(uCn(6)),
            UCn("#E6B0FF"),
            Djn,
            mCn(C([
                A2(vCn, "a", C([
                    Mwn.rV,
                    UCn("inherit"),
                    Ejn(C([
                        UCn(Ijn)
                    ]))
                ]))
            ]))
        ])),
        A2(sCn, "BannerTodoTitle", C([
            UCn(Ijn)
        ])),
        A2(sCn, "BannerCTA", C([
            xCn,
            mjn.jF,
            Pjn(zun),
            mCn(C([
                A2(sCn, "CustomButton", C([
                    A4(iwn, ljn, ljn, ljn, uCn(3))
                ])),
                A2(sCn, "CustomButtonLabel", C([
                    Pjn("#5E2F83"),
                    UCn(Ijn)
                ])),
                A2(sCn, "CustomButtonIcon", C([
                    rjn("#AB47BC")
                ]))
            ]))
        ])),
        A2(sCn, "BannerCTAIcon", C([
            rjn("#AB47BC"),
            fjn(uCn(30)),
            Qjn.jF
        ])),
        A2(sCn, "BannerCTALabel", C([
            Djn,
            UCn(Hun)
        ]))
    ]), Dwn = F2(function(n, r) {
        return rCn(C([
            A2(kjn, n, r),
            A2(dwn, n, r)
        ]));
    }), Xwn = tCn(C([
        wjn.jF,
        mjn.jF,
        lCn.bU
    ])), Ewn = C([
        QCn,
        Pjn(zun),
        Jjn.oV,
        Ujn(C([
            A2($Cn, C([
                sCn("BrowserOpened"),
                sCn("BrowserListOpened")
            ]), C([
                Pjn(Oun),
                Ujn(C([
                    A2(sCn, "BrowserItem", C([
                        Pjn(zun),
                        UCn(Vun),
                        rjn(Mun.jR)
                    ]))
                ]))
            ])),
            A2(sCn, "BrowserAdding", C([
                Pjn(Mun.nn)
            ]))
        ]))
    ]), Rwn = C([
        A2(sCn, "BrowserWrapper", C([
            QCn,
            fjn(uCn(400)),
            mCn(C([
                A2(sCn, "LayoutAppBarWrapper", C([
                    Yjn(uCn(82))
                ]))
            ]))
        ])),
        A2(sCn, "Browser", C([
            QCn,
            ACn.ja,
            UCn(xun),
            Djn
        ])),
        A2(sCn, "BrowserHeader", C([
            Pjn(Mun.nn),
            cjn(uCn(6)),
            xCn
        ])),
        A2(sCn, "BrowserSection", C([
            pjn(xun),
            UCn(Nun),
            njn.jk,
            A2(Sjn, uCn(5), uCn(10)),
            xCn,
            A3(Ljn, uCn(4), uCn(0), uCn(0))
        ])),
        A2(sCn, "BrowserSubSection", C([
            pjn(Kun),
            UCn(Jun),
            njn.jk,
            A2(Sjn, uCn(5), uCn(10)),
            xCn,
            A3(Ljn, uCn(4), uCn(0), uCn(0))
        ])),
        A2(sCn, "BrowserOrder", C([
            cjn(uCn(1)),
            Tjn(ljn),
            Djn,
            pjn(Nun),
            xCn
        ])),
        A2(sCn, "BrowserNewButton", C([
            eCn.du
        ])),
        A2(sCn, "BrowserSection", C([
            A2(ECn, "position", "sticky"),
            aCn(uCn(4)),
            Bjn(4),
            A2(ECn, "outline", "4px solid " + Nun)
        ])),
        A2(sCn, "BrowserSubSection", C([
            A2(ECn, "position", "sticky"),
            aCn(uCn(4)),
            Bjn(4),
            A2(ECn, "outline", "4px solid " + Nun)
        ])),
        A2(vCn, ".BrowserCollection > .BrowserItemWrapper.BrowserOpened", C([
            A2(ECn, "position", "sticky"),
            aCn(uCn(33)),
            Bjn(3),
            A2(ECn, "outline", "2px solid " + Nun)
        ])),
        A2(vCn, ".BrowserSeason > .BrowserItemWrapper.BrowserOpened", C([
            A2(ECn, "position", "sticky"),
            aCn(uCn(63)),
            Bjn(2),
            A2(ECn, "outline", "2px solid " + Nun)
        ])),
        A2($Cn, C([
            sCn("BrowserCollection"),
            sCn("BrowserSeason"),
            sCn("BrowserEpisode")
        ]), C([
            mCn(C([
                A2($Cn, C([
                    sCn("BrowserSeason"),
                    sCn("BrowserEpisode"),
                    sCn("BrowserTitle")
                ]), C([
                    Yjn(uCn(13)),
                    A2(Dwn, 2, Nun)
                ]))
            ]))
        ])),
        A2(sCn, "BrowserCollection", $(C([
            ijn(uCn(4)),
            Pjn(zun)
        ]), Ewn)),
        A2(sCn, "BrowserSeason", $(C([
            A2(kjn, 2, Nun),
            Pjn(zun)
        ]), Ewn)),
        A2(sCn, "BrowserEpisode", $(C([
            A2(kjn, 2, Nun),
            Pjn(zun)
        ]), Ewn)),
        A2(sCn, "BrowserTitle", A2(bt, A2(Dwn, 2, Nun), Ewn)),
        A2(sCn, "BrowserItem", C([
            _jn(uCn(24)),
            ajn(uCn(2)),
            xCn,
            Djn,
            UCn(xun)
        ])),
        A2(sCn, "BrowserItemWrapper", C([
            xCn
        ])),
        A2(vCn, ".BrowserHasMenuOpened", C([
            A2(ECn, "z-index", "8 !important")
        ])),
        A2(sCn, "BrowserLabelMaster", C([
            Djn,
            A2(ECn, "overflow-wrap", "break-word"),
            A2(ECn, "word-wrap", "break-word"),
            A2(ECn, "hyphens", "auto"),
            Cjn(uCn(14)),
            njn.jj,
            mCn(C([
                A2(sCn, "InputText", C([
                    cjn(ljn),
                    ajn(ljn),
                    A2(HCn, 0, zun),
                    UCn(Mun.jR),
                    BCn(NCn)
                ]))
            ]))
        ])),
        A2(sCn, "BrowserLabelShow", C([
            Djn,
            A2(ECn, "overflow-wrap", "break-word"),
            A2(ECn, "word-wrap", "break-word"),
            A2(ECn, "hyphens", "auto"),
            Cjn(uCn(14)),
            njn.jj,
            mCn(C([
                A2(sCn, "InputText", C([
                    cjn(ljn),
                    ajn(ljn),
                    A2(HCn, 0, zun),
                    UCn(Mun.jR),
                    BCn(NCn)
                ]))
            ]))
        ])),
        A2(sCn, "BrowserIcon", C([
            fjn(uCn(24)),
            BCn(uCn(24)),
            Xwn,
            rjn(Kun)
        ])),
        A2(sCn, "BrowserOptions", C([
            eCn.du,
            A2(sjn, "BrowserOptionsOpened", C([
                mCn(C([
                    A2($Cn, C([
                        sCn("BrowserOptionsTitle")
                    ]), C([
                        Pjn(Mun.jR),
                        rjn(Ijn)
                    ])),
                    A2(sCn, "BrowserOptionsMenu", C([
                        A2(swn, 25, 3),
                        A2(HCn, 1, Nun)
                    ]))
                ]))
            ]))
        ])),
        A2($Cn, C([
            sCn("BrowserOptionsTitle"),
            sCn("BrowserAttachment"),
            sCn("BrowserEdit")
        ]), C([
            fjn(uCn(24)),
            BCn(uCn(24)),
            Xwn,
            qCn,
            Jjn.oV,
            Pjn(zun),
            A2(HCn, 2, zun),
            A4(Gjn, uCn(2), uCn(2), uCn(2), uCn(0)),
            rjn(Kun),
            Ejn(C([
                Pjn(Mun.jR),
                rjn(Ijn)
            ]))
        ])),
        A2(sCn, "BrowserOptionsMenu", C([
            A2(swn, 29, 0),
            Pjn(Mun.jR),
            A2(HCn, 3, Nun),
            UCn(Ijn),
            Bjn(99),
            fjn(uCn(200)),
            cjn(uCn(3))
        ])),
        A2(sCn, "BrowserOptionsItem", C([
            cjn(uCn(5)),
            Jjn.oV,
            Ejn(C([
                Pjn(Mun.nl)
            ]))
        ])),
        A2(sCn, "BrowserOptionsLink", C([
            cjn(uCn(5)),
            Jjn.oV,
            UCn(Mun.m6),
            lCn.jh,
            Ejn(C([
                Pjn(Mun.nn),
                UCn(Ijn)
            ]))
        ])),
        A2(sCn, "BrowserNewForm", C([
            xCn,
            cjn(uCn(1)),
            Pjn(Nun),
            mCn(C([
                A2(sCn, "InputText", C([
                    A2(Sjn, uCn(0), uCn(4)),
                    Pjn(Mun.jR),
                    UCn(Ijn)
                ]))
            ]))
        ])),
        A3(PCn, "BrowserNew", "BrowserNewForm", C([
            A2(HCn, 8, Mun.nn),
            A2(kjn, 0, ""),
            mCn(C([
                A2(sCn, "InputText", C([
                    ajn(uCn(2)),
                    A2(HCn, 0, ""),
                    BCn(uCn(26))
                ]))
            ]))
        ])),
        A2(sCn, "BrowserNewFormIcon", C([
            fjn(uCn(30)),
            BCn(uCn(30)),
            Xwn,
            A2(HCn, 2, Nun),
            Pjn(Mun.jR),
            rjn(Ijn)
        ])),
        A3(PCn, "Browser", "BrowserNewForm", C([
            A2(HCn, 0, ""),
            A2(hjn, 3, Mun.nn),
            A2(dwn, 13, Mun.nn),
            Tjn(uCn(0)),
            mCn(C([
                A2(sCn, "InputText", C([
                    ajn(uCn(1)),
                    A2(HCn, 0, ""),
                    BCn(uCn(28))
                ])),
                A2(sCn, "BrowserNewFormIcon", C([
                    A2(HCn, 1, Nun)
                ]))
            ]))
        ])),
        A2(sCn, "BrowserSubmitting", C([
            Pjn(Mun.jR)
        ])),
        A2(sCn, "BrowserErrors", C([
            Ujn(C([
                mwn(C([
                    ijn(uCn(4))
                ]))
            ]))
        ])),
        A2(sCn, "BrowserList", C([
            QCn
        ])),
        A2(sCn, "BrowserListOpened", C([
            lCn.bU
        ])),
        A2(sCn, "BrowserItem", C([
            Pjn(zun)
        ])),
        A2(sCn, "BrowserOpened", C([
            Ujn(C([
                A2(sCn, "BrowserItemWrapper", C([
                    Ujn(C([
                        A2(sCn, "BrowserIcon", C([
                            rjn(Mun.jR)
                        ]))
                    ]))
                ]))
            ]))
        ])),
        A2(sCn, "BrowserTitleOpened", C([
            Pjn(Mun.jR),
            A2(sjn, "BrowserEmpty", C([
                Pjn(Bwn.eP),
                Ujn(C([
                    A2(sCn, "BrowserItem", C([
                        UCn(Bwn.jR)
                    ]))
                ]))
            ])),
            Ujn(C([
                A2(sCn, "BrowserItem", C([
                    UCn(Mun.jR)
                ]))
            ]))
        ])),
        A2(sCn, "BrowserTitleHidden", C([
            ojn(50)
        ])),
        A2(sCn, "BrowserLink", C([
            _jn(uCn(24)),
            xCn,
            Djn,
            UCn(xun)
        ])),
        A2(sCn, "BrowserEmpty", C([
            mCn(C([
                A2(sCn, "BrowserLabelMaster", C([
                    ojn(50)
                ]))
            ]))
        ])),
        A2(sCn, "BrowserShowAccepted", C([
            Ujn(C([
                A2(sCn, "BrowserItem", C([
                    Ujn(C([
                        A2(sCn, "BrowserIcon", C([
                            rjn(Run.nn)
                        ]))
                    ]))
                ]))
            ])),
            A2(sjn, "BrowserOpened", C([
                Ujn(C([
                    A2(sCn, "BrowserItem", C([
                        Ujn(C([
                            A2(sCn, "BrowserIcon", C([
                                rjn(Run.jR)
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ]))
    ]), xwn = {
        ja: A2(Gkn, "align-self", "auto"),
        cC: A2(Gkn, "align-self", "baseline"),
        jF: A2(Gkn, "align-self", "center"),
        bV: A2(Gkn, "align-self", "flex-end"),
        lN: A2(Gkn, "align-self", "flex-start"),
        qY: A2(Gkn, "align-self", "stretch")
    }, Own = function(n) {
        return A2(Gkn, "border-radius", _kn(n));
    }, zwn = KCn("active"), Nwn = F2(function(n, r) {
        return rCn(A2(Ge, ce(r), n));
    })(C([
        Ejn,
        sjn("Active"),
        zwn
    ])), Hwn = fjn(uCn(28)), Vwn = KCn("visited"), Uwn = C([
        A2(sCn, "ButtonToolbar", C([
            xCn,
            Pjn(Nun),
            cjn(uCn(3)),
            wjn.bV,
            BCn(uCn(28)),
            mCn(C([
                mwn(C([
                    Yjn(uCn(3)),
                    GCn(C([
                        Yjn(uCn(0))
                    ]))
                ]))
            ]))
        ])),
        A2(sCn, "ButtonCounter", g),
        A2(sCn, "ButtonLabel", g),
        A2(sCn, "Button", C([
            Cjn(uCn(12)),
            Pjn(Mun.nl),
            UCn(Mun.m7),
            A2(Sjn, uCn(4), uCn(8)),
            Jjn.oV,
            lCn.jh,
            Ojn.r5,
            njn.jk,
            xwn.bV,
            Ejn(C([
                UCn(Ijn),
                Pjn(Mun.jR)
            ]))
        ])),
        A2(sCn, "ButtonIcon", C([
            Xwn,
            Hwn,
            Cwn,
            Jjn.oV,
            rjn(Mun.m7),
            Pjn(Mun.nl),
            Ejn(C([
                rjn(Ijn),
                Pjn(Mun.jR)
            ]))
        ])),
        A2(sCn, "ButtonMini", C([
            Cjn(uCn(10)),
            njn.jj,
            A2(Sjn, uCn(2), uCn(5)),
            Pjn(Mun.nl),
            UCn(Mun.m7),
            Ojn.r5,
            njn.jk,
            A2(Ajn, uCn(0), uCn(2)),
            Ejn(C([
                UCn(Ijn),
                Pjn(Mun.jR)
            ]))
        ])),
        A2(sCn, "ButtonMiniIcon", C([
            fjn(uCn(18)),
            BCn(uCn(18)),
            cjn(uCn(0)),
            rjn(Oun),
            Jjn.oV,
            Ejn(C([
                Pjn(Mun.jR),
                rjn(zun)
            ]))
        ])),
        A2(sCn, "ButtonBlock", C([
            Qjn.jF,
            Pjn(Oun),
            cjn(uCn(5)),
            Njn(uCn(4)),
            Ejn(C([
                Pjn(Kun),
                UCn(Uun)
            ]))
        ])),
        A2(sCn, "ButtonDisabled", C([
            Cjn(uCn(12)),
            Pjn(Zun),
            UCn(Jun),
            A2(Sjn, uCn(4), uCn(8)),
            Jjn.oV,
            lCn.jh,
            Ojn.r5,
            njn.jk,
            xwn.bV
        ])),
        A2(sCn, "CustomButton", C([
            BCn(uCn(32)),
            Cjn(uCn(13)),
            njn.jj,
            Pjn(Nun),
            cjn(uCn(3)),
            Jjn.oV,
            xCn,
            Nwn(C([
                mCn(C([
                    A2(sCn, "CustomButtonLabel", C([
                        Pjn(Mun.jR),
                        UCn(Ijn)
                    ]))
                ]))
            ])),
            A2(sjn, "CustomButtonActive", C([
                mCn(C([
                    A2(sCn, "CustomButtonIcon", C([
                        Pjn(Mun.jR)
                    ])),
                    A2(sCn, "CustomButtonLabel", C([
                        Pjn(Mun.jR),
                        UCn(Ijn)
                    ])),
                    A2(sCn, "Fg", C([
                        JCn(Ijn)
                    ]))
                ]))
            ])),
            A2(sjn, "CustomButtonDisabled", C([
                ojn(30),
                Jjn.kA
            ])),
            A2(sjn, "CustomButtonMini", C([
                BCn(uCn(26)),
                Cjn(uCn(12)),
                cjn(uCn(3)),
                _jn(uCn(18)),
                mCn(C([
                    A2(sCn, "CustomButtonIcon", C([
                        fjn(uCn(18))
                    ])),
                    A2(sCn, "CustomButtonLabel", C([
                        A2(Sjn, uCn(1), uCn(3))
                    ]))
                ]))
            ])),
            A2(sjn, "CustomButtonPrimary", C([
                mCn(C([
                    A2(sCn, "CustomButtonIcon", C([
                        rjn(Mun.jR)
                    ])),
                    A2(sCn, "CustomButtonLabel", C([
                        pjn(Mun.nl),
                        UCn(Mun.m7)
                    ]))
                ])),
                Ejn(C([
                    mCn(C([
                        A2(sCn, "CustomButtonLabel", C([
                            UCn(Ijn),
                            Pjn(Mun.jR)
                        ]))
                    ]))
                ])),
                Vwn(C([
                    mCn(C([
                        A2(sCn, "CustomButtonLabel", C([
                            UCn(Nun),
                            Pjn(xun)
                        ]))
                    ]))
                ]))
            ])),
            A2(sjn, "CustomButtonDisabled", C([
                mCn(C([
                    A2(sCn, "CustomButtonIcon", C([
                        pjn(Kun + " !important")
                    ])),
                    A2(sCn, "CustomButtonLabel", C([
                        pjn(Kun + " !important"),
                        UCn(xun + " !important")
                    ])),
                    A2(sCn, "Fg", C([
                        JCn(xun + " !important")
                    ]))
                ]))
            ]))
        ])),
        A2(vCn, "button", C([
            Own(uCn(0))
        ])),
        A2(sCn, "CustomButtonIcon", C([
            Pjn(zun),
            UCn(Hun),
            xCn,
            Xwn,
            fjn(uCn(28)),
            nwn(uCn(2)),
            mCn(C([
                A2(sCn, "Fg", C([
                    JCn(Mun.jR)
                ]))
            ]))
        ])),
        A2(sCn, "CustomButtonLabel", C([
            Pjn(xun),
            UCn(Nun),
            A2(Sjn, uCn(0), uCn(8)),
            njn.jj,
            xCn,
            mjn.jF
        ])),
        A2(sCn, "ButtonSubmitWrapper", C([
            xCn,
            wjn.bV
        ]))
    ]), Jwn = C([
        A2(sCn, "DropDown", C([
            eCn.du
        ])),
        A2(sCn, "DropDownMenu", C([
            A2(swn, 20, 0),
            QCn,
            cjn(uCn(2)),
            lCn.n9
        ])),
        A2(sCn, "DropDownItem", C([
            xCn,
            cjn(uCn(4))
        ]))
    ]), Zwn = C([
        A2(sCn, "EventsItem", C([
            xCn,
            Njn(uCn(2)),
            Pjn(zun),
            UCn(Hun),
            cjn(uCn(4))
        ])),
        A2(sCn, "EventsItemIcon", C([
            fjn(uCn(24)),
            BCn(uCn(24)),
            Xwn
        ])),
        A2(sCn, "EventsItemBody", C([
            Djn,
            A2(Sjn, uCn(2), uCn(6))
        ])),
        A2(sCn, "EventsItemLabel", g),
        A2(sCn, "EventsItemDate", C([
            ojn(70)
        ])),
        A2(sCn, "Neutral", g),
        A2(sCn, "Good", C([
            Pjn(Run.nl),
            UCn(Ijn)
        ])),
        A2(sCn, "Bad", C([
            Pjn(Gun.nl),
            UCn(Ijn)
        ])),
        A2(sCn, "Warn", C([
            Pjn(Bwn.nl),
            UCn(Ijn)
        ])),
        A2(sCn, "Live", C([
            Pjn(Mun.nl),
            UCn(Ijn)
        ])),
        A2(sCn, "EventsItemArchived", C([
            ojn(70)
        ]))
    ]), Kwn = C([
        A2(sCn, "InputCheckbox", C([
            A2(Sjn, uCn(4), uCn(8)),
            ijn(uCn(10))
        ])),
        A2(sCn, "InputCheckboxLine", C([
            xCn,
            ijn(uCn(3)),
            cjn(uCn(6)),
            pjn(zun),
            mCn(C([
                A2(sCn, "InputWrapper", C([
                    yjn(uCn(20))
                ])),
                A2(sCn, "InputCheckbox", C([
                    ijn(uCn(2))
                ]))
            ]))
        ]))
    ]), _wn = F4(function(n, r, t, e) {
        return A2(Gkn, "box-shadow", function(n) {
            var r = n.a, t = r.b, e = n.b, u = e.a, a = e.b, i = n.c;
            return _kn(r.a) + " " + _kn(t) + " " + _kn(u) + " " + a + (i ? " inset" : "");
        }(b(d(n, r), d(t, e), !1)));
    }), Gwn = KCn("focus"), Ywn = tCn(C([
        Djn,
        UCn(Uun),
        A2(Sjn, uCn(1), uCn(4)),
        ajn(uCn(2)),
        A2(HCn, 2, Kun),
        Pjn(zun),
        A2(sjn, "InputSelectEmpty", C([
            ywn(Oun),
            UCn(xun),
            Pjn(Nun)
        ])),
        Gwn(C([
            ywn(Mun.jR)
        ]))
    ])), nAn = function(n) {
        return A2(Gkn, "padding-top", _kn(n));
    }, rAn = {
        ja: A2(Gkn, "pointer-events", "auto"),
        n9: A2(Gkn, "pointer-events", "none")
    }, tAn = {
        bI: A2(Gkn, "text-overflow", "clip"),
        k5: A2(Gkn, "text-overflow", "ellipsis"),
        qZ: A2(Gkn, "text-overflow", "string")
    }, eAn = {
        oa: A2(Gkn, "white-space", "normal"),
        od: A2(Gkn, "white-space", "nowrap"),
        oY: A2(Gkn, "white-space", "pre"),
        oZ: A2(Gkn, "white-space", "pre-line"),
        o_: A2(Gkn, "white-space", "pre-wrap")
    }, uAn = tCn(C([
        tAn.k5,
        ACn.l3,
        eAn.od
    ])), aAn = C([
        A2(sCn, "DarkZone", g),
        A2(sCn, "InputWrapper", C([
            Djn,
            QCn
        ])),
        A2(sCn, "InputWrapperDark", C([
            Djn,
            QCn,
            Pjn(zun)
        ])),
        A2(sCn, "InputLabel", C([
            xCn,
            A2(Ajn, uCn(10), uCn(0))
        ])),
        A2(jCn, C([
            "(max-width: 650px)"
        ]), C([
            A2(sCn, "InputLabel", C([
                QCn
            ]))
        ])),
        A2(sCn, "InputLabelText", C([
            fjn(uCn(220)),
            nAn(uCn(10))
        ])),
        A2(sCn, "InputText", C([
            Ywn
        ])),
        A2(sCn, "InputSearch", g),
        A2(sCn, "InputPassword", C([
            Ywn
        ])),
        A2(sCn, "InputTextarea", C([
            Ywn
        ])),
        A2(sCn, "InputSelect", C([
            Ywn,
            xCn,
            eCn.du,
            mjn.jF
        ])),
        A2(sCn, "InputSelectMini", C([
            yjn(uCn(100)),
            ajn(ljn),
            cjn(ljn)
        ])),
        A2(sCn, "InputSelectValue", C([
            njn.jj,
            Djn,
            uAn
        ])),
        A2(sCn, "InputSelectChoice", C([
            fjn(uCn(20)),
            BCn(uCn(20))
        ])),
        A2(sCn, "InputSelectSelect", C([
            ojn(0),
            A4(cCn, 0, 0, 0, 0),
            fjn(WCn(100))
        ])),
        A2(sCn, "InputWrapperPrechoice", C([
            Ywn,
            xCn,
            ACn.l3,
            Zjn(2),
            cjn(uCn(2)),
            eCn.du,
            Tjn(uCn(50))
        ])),
        A2(sCn, "InputSelectAllChoice", C([
            A2(swn, 0, 0),
            Ykn(ljn),
            fjn(uCn(30)),
            Pjn(xun),
            A2(HCn, 3, Kun),
            A4(_wn, uCn(-5), uCn(0), uCn(5), zun),
            rjn(Nun),
            Xwn,
            Ejn(C([
                Pjn(Mun.jR),
                rjn(Ijn)
            ]))
        ])),
        A2(sCn, "InputSelectPrechoice", C([
            UCn(Vun),
            A3($wn, uCn(0), uCn(3), uCn(1)),
            Jjn.oV,
            A2(HCn, 1, Oun),
            Ejn(C([
                Pjn(Mun.jR),
                UCn(Ijn)
            ]))
        ])),
        A2(sCn, "InputSelectEmpty", C([
            Ujn(C([
                A2(sCn, "InputSelectValue", C([
                    ojn(60),
                    njn.oa
                ]))
            ]))
        ])),
        A2(sCn, "InputErrors", g),
        A2(sCn, "InputError", C([
            UCn(Gun.jR)
        ])),
        A2(sCn, "InputMandatory", C([
            UCn(Mun.jR)
        ])),
        A2(sCn, "InputWrapperDisabled", C([
            ojn(50),
            rAn.n9
        ])),
        A2(sCn, "InputFileLabel", C([
            Mwn.rV,
            Jjn.oV
        ]))
    ]), iAn = F3(function(n, r, t) {
        return tCn(C([
            eCn.ij,
            aCn(uCn(n)),
            oCn(uCn(r)),
            nCn(uCn(t))
        ]));
    }), oAn = dCn(0), cAn = KCn("checked"), fAn = tCn(C([
        tAn.k5,
        eAn.od,
        ACn.l3
    ])), sAn = C([
        A2(sCn, "Select", C([
            xCn,
            Djn,
            eCn.du,
            Pjn(xun),
            A2(HCn, 3, Nun),
            Ejn(C([
                mCn(C([
                    A2(sCn, "SelectButtonTitle", C([
                        UCn(Ijn),
                        Pjn(Mun.jR),
                        fAn
                    ]))
                ]))
            ])),
            A2(sjn, "SelectOpened", C([
                Pjn(Mun.jR),
                mCn(C([
                    A2(sCn, "SelectList", C([
                        QCn
                    ])),
                    A2(sCn, "SelectButtonTitle", C([
                        UCn(Ijn)
                    ])),
                    A2(sCn, "SelectButtonIcon", C([
                        Pjn(Mun.jR),
                        rjn(Ijn)
                    ]))
                ]))
            ]))
        ])),
        A2(sCn, "SelectNative", C([
            yjn(uCn(50))
        ])),
        A2(sCn, "SelectDisabled", g),
        A2(sCn, "SelectButton", C([
            xCn,
            Djn
        ])),
        A2(sCn, "SelectButtonIcon", C([
            cjn(uCn(3)),
            Pjn(zun),
            A2(bwn, 2, Nun),
            fjn(uCn(28)),
            BCn(uCn(26)),
            rjn(Mun.jR)
        ])),
        A2(sCn, "SelectButtonTitle", C([
            Djn,
            xCn,
            A2(Sjn, uCn(0), uCn(8)),
            UCn(Nun),
            njn.jj,
            mjn.jF,
            tAn.k5,
            eAn.od,
            ACn.l3
        ])),
        A2(sCn, "SelectList", C([
            lCn.n9,
            A3(iAn, 26, -3, -3),
            Bjn(99),
            Pjn(Mun.jR),
            UCn(Ijn),
            A2(HCn, 3, Nun),
            cjn(uCn(3))
        ])),
        A2(sCn, "SelectItem", C([
            cjn(uCn(6)),
            UCn(Ijn),
            Ejn(C([
                Pjn(Mun.nl)
            ]))
        ])),
        A2(sCn, "SelectItemSelected", C([
            Pjn(Mun.nn)
        ])),
        A2(sCn, "SelectEmpty", g),
        A2(sCn, "SelectRadios", C([
            QCn,
            Pjn(Nun),
            A3($wn, uCn(0), uCn(3), uCn(3))
        ])),
        A2(sCn, "SelectRadio", C([
            xCn
        ])),
        A2(sCn, "SelectRadiosItem", C([
            xCn,
            Pjn(zun),
            A2(HCn, 3, Oun),
            ijn(uCn(3)),
            Djn,
            mjn.jF,
            Ejn(C([
                UCn(Ijn)
            ]))
        ])),
        A2(sCn, "SelectRadiosLabel", C([
            A2(Sjn, uCn(6), uCn(4))
        ])),
        A2(sCn, "SelectRadiosType", C([
            A2(Ajn, uCn(0), uCn(6)),
            fjn(uCn(18)),
            BCn(uCn(18)),
            A2(HCn, 2, xun),
            A2(ECn, "box-shadow", "inset 0 0 0 2px " + zun),
            Own(uCn(10))
        ])),
        A2(sCn, "SelectRadiosInput", C([
            eCn.ij,
            aCn(uCn(-9999)),
            nCn(uCn(-9999)),
            cAn(C([
                oAn(C([
                    A2(sCn, "SelectRadiosItem", C([
                        ywn(Mun.jR),
                        UCn(Ijn),
                        mCn(C([
                            A2(sCn, "SelectRadiosType", C([
                                ywn(Mun.jR),
                                Pjn(Mun.jR)
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ]))
    ]), lAn = C([
        A2(sCn, "SelectMultiple", C([
            xCn,
            Djn,
            eCn.du,
            Pjn(xun),
            A2(HCn, 3, Nun)
        ])),
        A2(sCn, "SelectMultipleDisabled", g),
        A2(sCn, "SelectMultipleLabel", C([
            QCn,
            A2(Ajn, uCn(10), uCn(0))
        ])),
        A2(sCn, "SelectMultipleLabelText", C([
            gwn(uCn(10))
        ])),
        A2(sCn, "SelectMultipleList", C([
            QCn,
            Djn,
            Pjn(xun),
            UCn(Ijn),
            cjn(uCn(3))
        ])),
        A2(sCn, "SelectMultipleItem", C([
            cjn(uCn(6)),
            UCn(Ijn),
            Ejn(C([
                Pjn(Mun.nl)
            ]))
        ])),
        A2(sCn, "SelectMultipleItemSelected", C([
            Pjn(Mun.nn)
        ]))
    ]), dAn = tCn(C([
        ijn(uCn(3)),
        GCn(C([
            ijn(uCn(0))
        ]))
    ])), bAn = C([
        A2(sCn, "HeaderWrapper", C([
            xCn,
            Djn,
            dAn,
            mjn.jF,
            BCn(uCn(40)),
            Pjn(Oun)
        ])),
        A2(sCn, "HeaderLogo", C([
            eCn.du,
            aCn(uCn(-5)),
            nCn(uCn(-4)),
            xwn.lN,
            Bjn(99)
        ])),
        A2(sCn, "HeaderBreadcrumb", C([
            xCn,
            Djn
        ])),
        A2(sCn, "HeaderBreadcrumbItem", C([
            xCn,
            mjn.jF,
            UCn(Uun),
            Fjn(uCn(10)),
            Ejn(C([
                UCn(Ijn)
            ]))
        ])),
        A2(sCn, "HeaderBreadcrumbItemLogo", C([
            A2(HCn, 3, Nun),
            lCn.jh,
            vwn(uCn(32)),
            yjn(uCn(50)),
            fjn(NCn),
            BCn(NCn),
            A2(ECn, "object-fit", "cover")
        ])),
        A2(sCn, "HeaderBreadcrumbItemDisabled", C([
            xCn,
            mjn.jF,
            UCn(Hun),
            Fjn(uCn(10)),
            rjn(xun)
        ])),
        A2(sCn, "HeaderBreadcrumbLabel", C([
            Tjn(uCn(10)),
            Fjn(uCn(6)),
            xCn,
            mjn.jF
        ]))
    ]), mAn = "#AB47BC", pAn = ECn("stroke"), vAn = C([
        A2(sCn, "Bg", C([
            JCn(Oun)
        ])),
        A2(sCn, "Fg", C([
            JCn(Mun.jR)
        ])),
        A2(sCn, "IconButton", g),
        A2(sCn, "Stroked", C([
            pAn(Mun.jR)
        ])),
        A2(sCn, "IconChoice", g),
        A2(sCn, "IconSort", g),
        A2(sCn, "IconSearch", g),
        A2(sCn, "IconSmallDownload", g),
        A2(sCn, "IconDelete", g),
        A2(sCn, "IconKo", g),
        A2(sCn, "IconOk", g),
        A2(sCn, "IconBigFile", g),
        A2(sCn, "IconFileWithLabel", g),
        A2(sCn, "IconBullet", g),
        A2(sCn, "IconAvatar", g),
        A2(sCn, "IconSpinner", g),
        A2(sCn, "IconIcon18", g),
        A2(sCn, "IconIcon24", g),
        A2(sCn, "IconLogo", g),
        A2(sCn, "IconLaab", g),
        A2(sCn, "IconPadok", C([
            pAn(mAn)
        ])),
        A2(sCn, "IconSettings", g),
        A2(sCn, "IconPlus", g),
        A2(sCn, "IconBack", g),
        A2(sCn, "IconBreadcrumb", C([
            JCn(Nun)
        ]))
    ]), $An = function(n) {
        return KCn("nth-child(" + n + ")");
    }, gAn = C([
        A2(sCn, "KeyValueWrapper", C([
            QCn,
            Pjn(zun),
            Njn(uCn(4))
        ])),
        A2(sCn, "KeyValueRow", C([
            xCn,
            A2($An, "odd", C([
                pjn("rgba(255,255,255,0.05)")
            ]))
        ])),
        A2(sCn, "KeyValueKey", C([
            njn.jj,
            fjn(WCn(38)),
            UCn(Hun),
            A2(Sjn, uCn(4), uCn(10))
        ])),
        A2(sCn, "KeyValueValue", C([
            Djn,
            UCn(Uun),
            A2(Sjn, uCn(4), uCn(10))
        ])),
        A2(sCn, "KeyValueHeader", C([
            njn.jj,
            Cjn(uCn(15)),
            UCn(Hun),
            A2(Sjn, uCn(6), uCn(20))
        ])),
        A2(sCn, "KeyValueWrapperHeader", C([
            xCn,
            pjn(zun)
        ]))
    ]), hAn = C([
        A2(sCn, "LayoutPageWrapper", C([
            fjn(WCn(100)),
            QCn,
            Djn,
            ACn.ja
        ])),
        A2(sCn, "LayoutPageHeader", C([
            cjn(uCn(10))
        ])),
        A2(sCn, "LayoutPageTitle", C([
            lCn.ml,
            Fjn(uCn(10))
        ])),
        A2(sCn, "LayoutPageContent", C([
            Pjn(Oun),
            QCn,
            Djn,
            ACn.ja
        ])),
        A2(sCn, "LayoutPageActions", C([
            YCn.pz
        ])),
        A2(sCn, "LayoutAppBarWrapper", C([
            BCn(uCn(80)),
            xCn,
            Njn(uCn(4))
        ])),
        A2(sCn, "LayoutAppBar", C([
            A2(Sjn, uCn(8), uCn(15)),
            Pjn(xun),
            xCn,
            Djn,
            mCn(C([
                A2(vCn, "h1", C([
                    UCn(Nun),
                    ACn.l3,
                    BCn(uCn(25))
                ])),
                A2(vCn, "h2", C([
                    UCn("rgba(255,255,255,.8)")
                ])),
                A2(vCn, "h3", C([
                    UCn("rgba(0,0,0,.6)"),
                    Cjn(uCn(13)),
                    ijn(uCn(2)),
                    Ojn.r5,
                    njn.jj
                ]))
            ]))
        ])),
        A2(sCn, "LayoutAppBarTitle", C([
            QCn,
            wjn.jF,
            Djn
        ])),
        A2(sCn, "LayoutAppBarActions", C([
            xwn.jF,
            xCn,
            BCn(uCn(32))
        ])),
        A2(sCn, "LayoutHeader", C([
            xCn,
            mjn.jF,
            A2(Sjn, ljn, uCn(8)),
            BCn(uCn(48)),
            Pjn(Mun.nn),
            UCn(Nun),
            Njn(uCn(4)),
            mCn(C([
                A2(sCn, "ButtonLabel", C([
                    Pjn(Kun)
                ]))
            ]))
        ])),
        A2(sCn, "LayoutHeaderTitle", C([
            Cjn(uCn(15)),
            Fjn(uCn(8)),
            njn.jk,
            Djn,
            UCn(Ijn),
            A4(kwn, uCn(1), uCn(1), uCn(1), lwn)
        ])),
        A2(sCn, "LayoutSubHeader", C([
            xCn,
            A2(Sjn, uCn(5), uCn(10)),
            Pjn(Oun),
            UCn(Uun),
            Njn(uCn(4))
        ])),
        A2(sCn, "LayoutSmallHeader", C([
            xCn,
            A2(Sjn, uCn(4), uCn(10)),
            Pjn(Oun),
            UCn(xun),
            Njn(uCn(4))
        ])),
        A2(sCn, "LayoutHeaderActions", g),
        A2($Cn, C([
            sCn("LayoutHomeButton"),
            sCn("LayoutBackButton")
        ]), C([
            xCn,
            Xwn,
            fjn(uCn(80)),
            Pjn(xun),
            nwn(uCn(2)),
            mCn(C([
                A2(sCn, "Fg", C([
                    JCn(Kun)
                ]))
            ])),
            Ejn(C([
                Pjn(Uun)
            ]))
        ])),
        A2(sCn, "LayoutBloc", C([
            Pjn(zun),
            cjn(uCn(3)),
            Njn(uCn(3))
        ])),
        A2(sCn, "LayoutDetails", C([
            Pjn(zun),
            cjn(uCn(3)),
            ijn(uCn(3))
        ])),
        A2(sCn, "LayoutDetailsHeader", C([
            cjn(uCn(3)),
            UCn(Uun)
        ])),
        A2(sCn, "LayoutDetailsContent", C([
            cjn(uCn(6)),
            Pjn(Nun)
        ])),
        A2(sCn, "LayoutFwdButton", C([
            xCn,
            Xwn,
            fjn(uCn(80)),
            Pjn(xun),
            A2(dwn, 2, Nun),
            mCn(C([
                A2(sCn, "Fg", C([
                    JCn(Kun)
                ]))
            ])),
            Ejn(C([
                Pjn(Uun)
            ]))
        ]))
    ]), kAn = C([
        A2(sCn, "LoadingWrapper", C([
            BCn(WCn(100)),
            fjn(WCn(100)),
            mjn.jF,
            wjn.jF,
            lCn.bU,
            xCn,
            Djn
        ])),
        A2(sCn, "LoadingSpinner", C([
            fjn(uCn(100)),
            BCn(uCn(40)),
            Qjn.jF
        ])),
        A2(sCn, "LoadingMiniSpinner", C([
            fjn(uCn(18)),
            BCn(uCn(18))
        ])),
        A2(sCn, "IconSpinner", C([
            A2(ECn, "animation", "anim_spin 1s linear infinite")
        ]))
    ]), CAn = F2(function(n, r) {
        return tCn(C([
            eCn.ij,
            aCn(uCn(n)),
            nCn(uCn(r))
        ]));
    }), jAn = F2(function(n, r) {
        return A3(XCn, r, n, 0);
    }), wAn = C([
        A2(sCn, "MenuWrapper", C([
            A4(cCn, 0, 0, 0, 0),
            xCn,
            Pjn("rgba(24, 31, 41, .6)"),
            Bjn(9)
        ])),
        A2(sCn, "MenuMain", C([
            QCn,
            Pjn(Nun),
            A2(ECn, "outline", "4px solid " + Nun)
        ])),
        A2(sCn, "MenuHeader", C([
            BCn(uCn(80)),
            xCn
        ])),
        A2(sCn, "MenuHeaderTitle", C([
            xCn,
            Djn,
            cjn(uCn(15)),
            mjn.jF,
            Pjn(xun),
            UCn(Nun)
        ])),
        A2(sCn, "MenuList", C([
            QCn,
            Pjn(Nun),
            A2(HCn, 10, Oun),
            mCn(C([
                A2(sCn, "MenuItem", C([
                    BCn(uCn(40))
                ])),
                A2(sCn, "MenuItemIcon", C([
                    fjn(uCn(50))
                ]))
            ]))
        ])),
        A2(jCn, C([
            "(max-width: 650px)"
        ]), C([
            A2(sCn, "MenuWrapper", C([
                ACn.ja
            ]))
        ])),
        A2(jCn, C([
            "(min-width: 650px)"
        ]), C([
            A2(sCn, "MenuList", C([
                Djn,
                lCn.n9,
                ACn.ja,
                A4(cCn, 0, 100, 0, 304),
                yjn(uCn(400)),
                cjn(uCn(4)),
                A2(ECn, "outline", "4px solid " + Nun)
            ])),
            A2(vCn, ".MenuOpened .MenuGroup:hover .MenuList", C([
                lCn.bU
            ])),
            A2(vCn, ".MenuOpened .MenuMain", C([
                fjn(uCn(300))
            ])),
            A2(vCn, ".MenuOpened .MenuGroup:hover > .MenuItem", C([
                mCn(C([
                    A2(sCn, "MenuItemIcon", C([
                        Pjn(Mun.nl),
                        rjn(Ijn)
                    ])),
                    A2(sCn, "MenuItemTitle", C([
                        Pjn(Oun),
                        UCn(Ijn)
                    ]))
                ]))
            ]))
        ])),
        A2(sCn, "MenuItem", C([
            BCn(uCn(80)),
            A2(hjn, 4, Nun),
            eCn.du,
            Bjn(99),
            xCn,
            Jjn.oV,
            mCn(C([
                A2(sCn, "Fg", C([
                    JCn(Mun.nl),
                    qCn
                ])),
                A2(sCn, "Stroked", C([
                    pAn(Mun.nl),
                    qCn
                ]))
            ])),
            Nwn(C([
                mCn(C([
                    A2(sCn, "MenuItemIcon", C([
                        Pjn(Oun)
                    ])),
                    A2(sCn, "MenuItemTitle", C([
                        Pjn(Oun),
                        UCn(Ijn)
                    ])),
                    A2(sCn, "Fg", C([
                        JCn(Mun.jR)
                    ])),
                    A2(sCn, "Stroked", C([
                        pAn(Ijn)
                    ]))
                ]))
            ])),
            Ejn(C([
                mCn(C([
                    A2(sCn, "MenuItemIcon", C([
                        Pjn(Mun.nl),
                        rjn(Ijn)
                    ]))
                ]))
            ])),
            A2(sjn, "MenuLogout", C([
                mCn(C([
                    A2(sCn, "Fg", C([
                        JCn(Gun.nn)
                    ]))
                ])),
                Ejn(C([
                    Ujn(C([
                        mwn(C([
                            Pjn(Gun.nl)
                        ]))
                    ]))
                ]))
            ]))
        ])),
        A2(vCn, ".MenuItemIcon:hover + .MenuItemTitle", C([
            lCn.bU
        ])),
        A2(sCn, "MenuItemTitle", C([
            BCn(WCn(100)),
            A2(CAn, 0, 94),
            A2(Sjn, ljn, uCn(25)),
            Pjn(zun),
            Cjn(uCn(16)),
            Cjn(uCn(18)),
            njn.jj,
            UCn(Hun),
            QCn,
            wjn.jF,
            A2(ECn, "outline", "4px solid " + Nun)
        ])),
        A2(sCn, "MenuClosed", C([
            fjn(uCn(90)),
            mCn(C([
                A2(sCn, "MenuItemTitle", C([
                    lCn.n9
                ]))
            ]))
        ])),
        A2(sCn, "MenuOpened", C([
            A2(ECn, "outline", "4px solid " + Nun),
            mCn(C([
                A2(sCn, "MenuItem", C([
                    fjn(NCn),
                    lCn.bU
                ])),
                A2(sCn, "MenuItemTitle", C([
                    eCn.du,
                    nCn(uCn(4)),
                    lCn.bU,
                    Djn,
                    qjn(uCn(210)),
                    fjn(NCn)
                ]))
            ]))
        ])),
        A2(sCn, "MenuItemIcon", C([
            fjn(uCn(90)),
            BCn(WCn(100)),
            Pjn(zun),
            qCn,
            Xwn,
            rjn(xun),
            ICn(0)
        ])),
        A2(sCn, "MenuUser", C([
            eCn.ij,
            Ykn(uCn(0)),
            nCn(uCn(0)),
            fjn(uCn(80)),
            BCn(uCn(148)),
            A2(kjn, 2, Nun),
            A2(jAn, 0, 0),
            qCn
        ])),
        A2(sCn, "MenuAvatar", C([
            A2(HCn, 3, zun),
            Pjn(zun),
            mCn(C([
                A2(vCn, "img", C([
                    vwn(uCn(28)),
                    yjn(uCn(50))
                ]))
            ]))
        ])),
        A2(sCn, "UserCard", C([
            Qjn.jF
        ])),
        A2(sCn, "UserCardStatus", g),
        A2(sCn, "MenuSpacer", C([
            Djn,
            Njn(uCn(4)),
            Pjn(zun)
        ])),
        A2(sCn, "MenuIntercom", C([
            BCn(uCn(90)),
            Pjn(Oun)
        ])),
        A2(sCn, "MenuSettings", C([
            QCn,
            A2(HCn, 10, zun),
            cjn(uCn(4)),
            A2(Awn, C([
                "(min-width: 650px)"
            ]), C([
                fjn(uCn(280)),
                nwn(uCn(4))
            ]))
        ])),
        A2(sCn, "MenuSettingsExpand", C([
            Djn,
            Pjn(zun),
            ijn(uCn(4))
        ])),
        A2(sCn, "MenuSettingsItems", C([
            QCn,
            Djn,
            cjn(uCn(4)),
            A2(HCn, 10, Oun),
            BCn(uCn(100)),
            xjn.ja
        ])),
        A2(sCn, "MenuSettingsItem", C([
            xCn,
            cjn(uCn(16)),
            Pjn(zun),
            ijn(uCn(4)),
            Ejn(C([
                Pjn(Oun)
            ])),
            GCn(C([
                ijn(ljn)
            ]))
        ])),
        A2(sCn, "MenuSettingsTitle", C([
            QCn,
            xwn.jF,
            Djn
        ])),
        A2(sCn, "MenuSettingsProfile", C([
            Cjn(uCn(16)),
            rjn(Mun.jR),
            Pjn(Oun),
            UCn("rgba(255,255,255,.5)"),
            Ejn(C([
                UCn(Ijn),
                Pjn(Mun.eP)
            ]))
        ])),
        A2(sCn, "MenuSettingsLogout", C([
            Cjn(uCn(16)),
            rjn(Gun.jR),
            Jjn.oV,
            Pjn(Gun.eQ),
            UCn(Gun.ma),
            Ejn(C([
                UCn(Ijn),
                Pjn(Gun.eP)
            ]))
        ])),
        A2(sCn, "MenuSettingsSub", C([
            QCn,
            Djn,
            ACn.ja
        ])),
        A2(sCn, "SettingsTitle", C([
            Cjn(uCn(18)),
            UCn(Ijn)
        ])),
        A2(sCn, "SettingsForm", C([
            cjn(uCn(10)),
            yjn(uCn(500)),
            Pjn(zun)
        ])),
        A2(sCn, "MenuSettingsActive", C([
            Pjn(Mun.nl),
            UCn(Mun.m6),
            Ejn(C([
                Pjn(Mun.jR)
            ]))
        ])),
        A2(sCn, "SettingsContainer", C([
            Pjn(zun),
            Rjn.l3,
            xjn.ja,
            QCn,
            Djn
        ])),
        A2(sCn, "MenuSettingsIcon", C([
            fjn(uCn(44)),
            BCn(uCn(44)),
            nwn(uCn(10)),
            xCn,
            mjn.jF,
            wjn.jF,
            Pjn(Nun)
        ]))
    ]), AAn = F4(function(n, r, t, e) {
        return "rgba(" + Bt(n) + "," + Bt(r) + "," + Bt(t) + "," + FS(e) + ")";
    }), LAn = C([
        A2(sCn, "ModalWrapper", C([
            Pjn(Nun),
            Bjn(999),
            A4(_wn, uCn(-5), uCn(0), uCn(0), A4(AAn, 24, 31, 41, .3)),
            Njn(uCn(0)),
            Fjn(uCn(3))
        ])),
        A2(jCn, C([
            "(min-width: 1000px)"
        ]), C([
            A2(sCn, "ModalWrapper", C([
                eCn.lH,
                aCn(uCn(0)),
                Ykn(uCn(0)),
                oCn(uCn(0)),
                fjn(WCn(80)),
                yjn(uCn(800)),
                ajn(uCn(0)),
                ACn.ja
            ]))
        ])),
        A2(sCn, "ModalTitle", C([
            Pjn(Oun),
            xCn,
            cjn(uCn(10)),
            Cjn(uCn(20)),
            UCn(Hun),
            wjn.qF,
            eCn.hz,
            Bjn(99),
            aCn(uCn(0)),
            A2(hjn, 3, Nun)
        ])),
        A2(sCn, "ModalContent", C([
            QCn,
            Zjn(3),
            cjn(uCn(10)),
            gwn(uCn(20)),
            Pjn(zun),
            UCn(Hun)
        ])),
        A2(sCn, "ModalSubmit", C([
            xCn,
            Zjn(6),
            wjn.bV,
            cjn(uCn(10)),
            eCn.hz,
            Bjn(99),
            Ykn(uCn(0)),
            Pjn(Oun),
            A2(kjn, 3, Nun)
        ]))
    ]), yAn = C([
        A2(sCn, "ProgressIdle", C([
            Pjn(Mun.jR),
            ojn(50)
        ])),
        A2(sCn, "ProgressActive", C([
            Pjn(Mun.jR)
        ])),
        A2(sCn, "ProgressPaused", C([
            Pjn(Bwn.jR)
        ])),
        A2(sCn, "ProgressError", C([
            Pjn(Gun.jR)
        ])),
        A2(sCn, "ProgressWarning", C([
            Pjn(Bwn.jR)
        ])),
        A2(sCn, "ProgressCompleted", C([
            Pjn(Run.jR)
        ])),
        A2(sCn, "ProgressBarProgressing", C([
            A2(bwn, 3, Oun)
        ])),
        A2(sCn, "ProgressBarOuter", C([
            A2(HCn, 3, zun),
            Pjn(Zun)
        ])),
        A2(sCn, "ProgressBarInner", C([
            lCn.jh,
            BCn(uCn(16))
        ])),
        A2(sCn, "ProgressBarAnimated", C([
            A2(ECn, "background-size", "1rem 1rem"),
            A2(ECn, "background-image", "linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent)"),
            A2(ECn, "-webkit-animation", "progress-bar-animated 1s linear infinite"),
            A2(ECn, "animation", "progress-bar-animated 1s linear infinite")
        ]))
    ]), SAn = C([
        A2(sCn, "Search", C([
            xCn,
            Pjn(Nun),
            cjn(uCn(3)),
            BCn(uCn(32)),
            mCn(C([
                A2(vCn, "input", C([
                    A2(HCn, 0, ""),
                    Djn,
                    Pjn(zun),
                    ajn(ljn)
                ]))
            ]))
        ])),
        A2(sCn, "SearchIcon", C([
            Pjn(zun),
            Xwn,
            fjn(uCn(28))
        ])),
        A2(sCn, "SearchInput", C([
            Djn,
            xCn,
            Yjn(uCn(2)),
            lCn.n9,
            Gwn(C([
                lCn.bU
            ])),
            A2(sjn, "Searching", C([
                lCn.bU
            ]))
        ])),
        A2(sCn, "SearchResults", C([
            QCn,
            ACn.ja,
            Djn,
            eCn.lH,
            aCn(uCn(36)),
            nCn(uCn(94)),
            fjn(uCn(330)),
            vwn(WCn(90)),
            A4(iwn, uCn(0), uCn(4), uCn(4), uCn(4)),
            Bjn(9),
            Pjn(Nun),
            qCn,
            A2(ECn, "outline", "3px solid " + Nun)
        ])),
        A2(sCn, "SearchClosed", C([
            mCn(C([
                A2(sCn, "SearchResults", C([
                    rAn.n9,
                    ojn(0)
                ]))
            ]))
        ])),
        A2(sCn, "SearchResultsItem", C([
            Pjn(zun),
            A2(Sjn, uCn(4), uCn(8)),
            A2(HCn, 2, zun),
            Njn(uCn(2)),
            Ejn(C([
                A2(HCn, 2, Oun),
                Ujn(C([
                    A2(sCn, "SearchResultsTitle", C([
                        UCn(Uun)
                    ]))
                ]))
            ]))
        ])),
        A2(sCn, "SearchResultsPath", C([
            UCn(xun),
            fAn
        ])),
        A2(sCn, "SearchResultsMaster", C([
            rjn(Mun.jR)
        ])),
        A2(sCn, "SearchResultsShow", C([
            rjn(mAn)
        ])),
        A2(sCn, "SearchResultsTitle", C([
            Cjn(uCn(14)),
            njn.jj,
            UCn(Mun.jR),
            xCn,
            mjn.jF
        ]))
    ]), FAn = C([
        A2(sCn, "Switch", C([
            Jjn.oV,
            fjn(uCn(30)),
            BCn(uCn(15)),
            Own(uCn(15)),
            pjn(xun),
            lCn.jh,
            eCn.du,
            xwn.jF
        ])),
        A2(sCn, "Switcher", C([
            eCn.ij,
            aCn(uCn(3)),
            nCn(uCn(3)),
            fjn(uCn(9)),
            BCn(uCn(9)),
            MCn("300ms"),
            pjn(Ijn),
            Own(WCn(50))
        ])),
        A2(sCn, "SwitchChecked", C([
            pjn(Mun.jR),
            mCn(C([
                A2(sCn, "Switcher", C([
                    A2(ECn, "left", "calc(100% - " + Bt(3) + "px)"),
                    DCn("translateX(-100%)")
                ]))
            ]))
        ])),
        A2(sCn, "SwitchDisabled", C([
            Jjn.kA,
            ojn(50)
        ]))
    ]), TAn = {
        cC: A2(Gkn, "vertical-align", "baseline"),
        jm: A2(Gkn, "vertical-align", "bottom"),
        m4: A2(Gkn, "vertical-align", "length"),
        f7: A2(Gkn, "vertical-align", "middle"),
        q_: A2(Gkn, "vertical-align", "sub"),
        rf: A2(Gkn, "vertical-align", "super"),
        ry: A2(Gkn, "vertical-align", "text-bottom"),
        rz: A2(Gkn, "vertical-align", "text-top"),
        rI: A2(Gkn, "vertical-align", "top")
    }, QAn = C([
        A2(sCn, "Table", C([
            qjn(WCn(100)),
            eCn.du,
            fjn(WCn(100))
        ])),
        A2(sCn, "TableHeader", C([
            BCn(uCn(40)),
            TAn.f7,
            Qjn.da,
            A2(kjn, 2, zun),
            A2(hjn, 2, zun),
            cjn(uCn(10)),
            A2(sjn, "TableRight", C([
                Qjn.pz
            ]))
        ])),
        A2(vCn, "th", C([
            BCn(uCn(40)),
            TAn.f7,
            Qjn.da,
            A2(kjn, 2, zun),
            A2(hjn, 2, zun),
            cjn(uCn(10)),
            A2(sjn, "TableRight", C([
                Qjn.pz
            ]))
        ])),
        A2(sCn, "TableTr", C([
            pjn("rgba(0,0,0,0.0)"),
            UCn(Uun),
            A2($An, "odd", C([
                pjn("rgba(0,0,0,0.1)")
            ]))
        ])),
        A2(sCn, "TableTrHead", C([
            Pjn(zun),
            UCn(xun)
        ])),
        A2(vCn, "td", C([
            A2(Sjn, uCn(3), uCn(10))
        ])),
        A2(sCn, "TableTdBold", C([
            A2(Sjn, uCn(3), uCn(10)),
            njn.jj,
            UCn(Jun)
        ])),
        A2(sCn, "TableTh", C([
            A2(Sjn, uCn(3), uCn(10)),
            UCn(xun),
            njn.jj,
            Qjn.da
        ]))
    ]), IAn = function(n) {
        return A2(Gkn, "letter-spacing", _kn(n));
    }, BAn = $jn("selection"), WAn = C([
        A2(sCn, "TimecodeWrapper", C([
            xCn,
            cjn(uCn(3)),
            Pjn(Nun),
            Cwn,
            _jn(uCn(16))
        ])),
        A2(sCn, "TimecodeSep", C([
            A2(Sjn, uCn(0), uCn(2)),
            wjn.jF
        ])),
        A2(sCn, "TimecodeUnit", C([
            Pjn(zun),
            UCn(xun),
            A2(Sjn, uCn(0), uCn(3)),
            wjn.jF,
            njn.jj,
            IAn(uCn(2)),
            xCn,
            Djn
        ])),
        A2(sCn, "TimecodeHH", C([
            UCn(Uun)
        ])),
        A2(sCn, "TimecodeMM", C([
            UCn(Uun)
        ])),
        A2(sCn, "TimecodeSS", g),
        A2(sCn, "TimecodeFF", C([
            UCn(Zun)
        ])),
        A2(vCn, "input[type=number]::-webkit-inner-spin-button, input[type=number]::-webkit-outer-spin-button", C([
            ajn(uCn(0)),
            A2(ECn, "-webkit-appearance", "none")
        ])),
        A2(sCn, "TimecodeEditable", C([
            A2(bwn, 2, Nun),
            Pjn(zun),
            UCn(xun),
            Cwn,
            A2(Sjn, uCn(0), uCn(3)),
            _jn(uCn(24)),
            wjn.jF,
            njn.jj,
            IAn(uCn(2)),
            xCn,
            fjn(uCn(120)),
            Qjn.jF,
            BAn(C([
                UCn(Ijn),
                Pjn(Mun.jR)
            ]))
        ])),
        A2(sCn, "TimecodeDarker", C([
            mCn(C([
                A2(sCn, "TimecodeWrapper", C([
                    Pjn(Oun)
                ])),
                A2(sCn, "TimecodeUnit", C([
                    Pjn(Nun)
                ]))
            ]))
        ]))
    ]), PAn = C([
        A2(sCn, "UploadWrapper", C([
            eCn.lH,
            aCn(uCn(0)),
            Ykn(uCn(0)),
            nCn(uCn(0)),
            oCn(uCn(0)),
            Bjn(999999)
        ])),
        A2(sCn, "UploadMask", C([
            A4(cCn, 0, 0, 0, 0),
            Pjn(Mun.jR),
            ojn(75)
        ])),
        A2(sCn, "UploadClose", C([
            A2(swn, 20, 20),
            Ejn(C([
                UCn(Mun.jR)
            ]))
        ])),
        A2(sCn, "UploadDropping", C([
            A4(cCn, 40, 40, 40, 40),
            Xwn,
            UCn(Ijn),
            Cjn(uCn(16))
        ])),
        A2(sCn, "UploadContainer", C([
            A4(cCn, 88, 88, 88, 88),
            Pjn(Nun),
            Rjn.l3,
            xjn.ja
        ])),
        A2(sCn, "UploadContent", C([
            A2(Sjn, uCn(20), uCn(50)),
            yjn(uCn(600)),
            A2(Ajn, uCn(0), NCn)
        ])),
        A2(sCn, "UploadTitle", C([
            Cjn(uCn(20)),
            UCn(Ijn),
            ajn(uCn(20)),
            njn.jj,
            Qjn.jF
        ])),
        A2(sCn, "UploadSubtitle", C([
            UCn("white"),
            nAn(uCn(20))
        ])),
        A2(sCn, "UploadInput", C([
            lCn.n9
        ])),
        A2(sCn, "UploadDesc", C([
            Cjn(uCn(16)),
            UCn(Hun)
        ])),
        A2(sCn, "UploadError", C([
            UCn(Gun.m6),
            Pjn(Gun.nn),
            cjn(uCn(10)),
            xCn,
            mjn.jF,
            wjn.jF
        ])),
        A2(sCn, "UploadErrorClose", C([
            Yjn(uCn(10)),
            mCn(C([
                A2(sCn, "Fg", C([
                    JCn(Gun.m6),
                    Jjn.oV
                ])),
                A2(sCn, "IconDelete", C([
                    lCn.jh
                ]))
            ]))
        ])),
        A2(sCn, "UploadDrag", C([
            eCn.lH,
            Pjn("rgba(22, 32, 46, 0.6)"),
            UCn("white"),
            jwn.n9,
            rAn.n9
        ])),
        A2(sCn, "UploadItem", C([
            ijn(uCn(15))
        ])),
        A2(sCn, "UploadFile", C([
            eCn.du,
            xCn,
            mjn.jF
        ])),
        A2(sCn, "UploadFileTitle", C([
            xCn,
            Djn
        ])),
        A2(sCn, "UploadFileSummary", C([
            QCn,
            Yjn(uCn(10)),
            ICn(1),
            qjn(uCn(0))
        ])),
        A2(sCn, "UploadFileName", C([
            eAn.od,
            ACn.l3,
            tAn.k5
        ])),
        A2(sCn, "UploadFileSize", C([
            eAn.od
        ])),
        A2(sCn, "UploadRemove", C([
            Yjn(uCn(10))
        ])),
        A2(sCn, "UploadFilesItemIconStamps", C([
            eCn.ij,
            QCn,
            aCn(uCn(43)),
            nCn(uCn(30)),
            DCn("translate(-50%,-50%)")
        ])),
        A2(sCn, "UploadFilesItemIconStamp", C([
            xCn,
            qjn(uCn(20)),
            BCn(uCn(17)),
            _jn(uCn(17)),
            ajn(uCn(2)),
            A2(Sjn, uCn(0), uCn(5)),
            Own(uCn(10)),
            tCn(C([
                Cjn(uCn(12)),
                njn.jj
            ])),
            UCn(Ijn),
            wjn.jF,
            mCn(C([
                A2(sCn, "Fg", C([
                    JCn(Ijn)
                ]))
            ]))
        ])),
        A2(sCn, "UploadFilesItemNormal", C([
            mCn(C([
                A2(sCn, "UploadFilesItemIconStamp", C([
                    Pjn(Mun.jR)
                ])),
                A2(sCn, "Bg", C([
                    JCn(Mun.jR)
                ]))
            ]))
        ])),
        A2(sCn, "UploadFilesItemWarning", C([
            mCn(C([
                A2(sCn, "UploadFilesItemIconStamp", C([
                    pjn(Bwn.nl)
                ])),
                A2(sCn, "UploadFilesItemWarning", C([
                    pjn(Bwn.nl)
                ])),
                A2(sCn, "Bg", C([
                    JCn(Bwn.nl)
                ]))
            ]))
        ])),
        A2(sCn, "UploadCardIdWarning", C([
            UCn(Ijn),
            fjn(uCn(50)),
            wjn.jF,
            Pjn(Bwn.nl),
            njn.jj,
            cjn(uCn(4)),
            ajn(uCn(4))
        ])),
        A2(sCn, "UploadCardName", C([
            Djn,
            wjn.jF,
            njn.jk,
            UCn(Uun),
            cjn(uCn(4)),
            ajn(uCn(4))
        ])),
        A2(sCn, "UploadCardWrapper", C([
            QCn
        ])),
        A2(sCn, "UploadCardRow", C([
            xCn,
            A2($An, "odd", C([
                pjn("rgba(255,255,255,0.05)")
            ]))
        ]))
    ]), MAn = C([
        A2(sCn, "FTPCopyWrapper", C([
            QCn,
            mCn(C([
                A2(vCn, ".InputWrapper:last-child", C([
                    BCn(uCn(30))
                ]))
            ]))
        ]))
    ]), qAn = C([
        A2(sCn, "S3CopyWrapper", C([
            mCn(C([
                A2(vCn, ".InputWrapper:last-child", C([
                    BCn(uCn(30))
                ]))
            ]))
        ]))
    ]), DAn = _u(C([
        Qwn,
        qwn,
        Rwn,
        SAn,
        Uwn,
        Jwn,
        Zwn,
        Kwn,
        aAn,
        sAn,
        lAn,
        vAn,
        gAn,
        hAn,
        kAn,
        bAn,
        wAn,
        LAn,
        yAn,
        FAn,
        QAn,
        WAn,
        PAn,
        qAn,
        MAn
    ])), XAn = C([
        A2(sCn, "AsideTabs", C([
            xCn,
            Djn,
            Pjn(xun),
            A3($wn, uCn(10), uCn(20), uCn(0)),
            eCn.du,
            rjn(Nun)
        ])),
        A2(sCn, "AsideTab", C([
            cjn(uCn(15)),
            njn.jj,
            A2(HCn, 4, Nun),
            A2(hjn, 0, ""),
            Yjn(uCn(-4)),
            Cjn(uCn(16)),
            njn.jk,
            xCn,
            Djn,
            mjn.jF,
            UCn(Nun),
            Pjn(Mun.nn),
            Njn(uCn(-4)),
            gwn(uCn(19)),
            Jjn.oV,
            Ejn(C([
                UCn(Nun),
                pjn(Mun.nl),
                gwn(uCn(15)),
                A2(hjn, 4, Mun.nn),
                mCn(C([
                    A2(sCn, "AsideTabsIcon", C([
                        A2(HCn, 3, Nun),
                        rjn(Nun)
                    ]))
                ]))
            ]))
        ])),
        A2(sCn, "AsideTabInner", C([
            ajn(uCn(6)),
            cjn(uCn(6)),
            A2(HCn, 3, Nun),
            xCn,
            Djn,
            mjn.jF
        ])),
        A2(sCn, "AsideTabLabel", C([
            xCn,
            Djn
        ])),
        A2(sCn, "AsideTabsIcon", C([
            A2(HCn, 3, Nun),
            rjn(Nun),
            nwn(uCn(8)),
            fjn(uCn(30)),
            BCn(uCn(30)),
            Xwn
        ])),
        A2(sCn, "AsideToggleButton", C([
            xCn,
            Xwn,
            fjn(uCn(80)),
            Pjn(xun),
            nwn(uCn(4)),
            mCn(C([
                A2(sCn, "Fg", C([
                    JCn(Kun)
                ]))
            ])),
            Ejn(C([
                Pjn(Uun)
            ]))
        ])),
        A2(sCn, "AsideHeader", C([
            xCn,
            BCn(uCn(80))
        ])),
        A2(sCn, "AsideBody", C([
            QCn,
            Djn,
            ijn(uCn(4)),
            A2(ECn, "gap", "3px"),
            ACn.ja,
            A2(kjn, 6, Mun.nn),
            GCn(g)
        ])),
        A2(jCn, C([
            "(min-width: 600px)"
        ]), C([
            A2(sCn, "AsideBody", C([
                Yjn(uCn(4))
            ]))
        ])),
        A2(sCn, "MasterFilesShowDesc", C([
            mCn(C([
                A2(sCn, "MasterFilesDesc", C([
                    lCn.bU,
                    Pjn(Nun)
                ])),
                A2(vCn, ".TableTr", C([
                    UCn(xun)
                ]))
            ]))
        ])),
        A2(sCn, "MasterFilesAsset", C([
            Pjn(Kun),
            Njn(uCn(4))
        ])),
        A2(sCn, "AsideMenu", C([
            A2(CAn, 80, 16),
            oCn(uCn(20)),
            Bjn(99),
            QCn,
            lCn.n9,
            A2(HCn, 2, Nun),
            pjn(Mun.nl)
        ])),
        A2(sCn, "AsideMenuItem", C([
            xCn,
            cjn(uCn(16)),
            UCn(Nun),
            Cjn(uCn(15)),
            njn.jj,
            A2(HCn, 2, Nun),
            Nwn(C([
                pjn(Mun.l8)
            ]))
        ])),
        A3(PCn, "AsideMenuOpened", "AsideMenu", C([
            lCn.bU
        ])),
        A3(PCn, "AsideMenuOpened", "AsideTab", C([
            pjn(Mun.l8)
        ]))
    ]), EAn = function(n) {
        return A2(KCn, "not(:first-child)", n);
    }, RAn = C([
        A2(sCn, "DownloadList", C([
            QCn,
            A2(HCn, 3, Oun),
            cjn(uCn(3))
        ])),
        A2(sCn, "DownloadListItemWrapper", C([
            xCn,
            EAn(C([
                A2(kjn, 3, Oun)
            ]))
        ])),
        A2(sCn, "DownloadListIcon", C([
            pjn(Oun),
            rjn(Ijn),
            mCn(C([
                A2(vCn, "svg", C([
                    fjn(uCn(18))
                ]))
            ]))
        ])),
        A2(sCn, "DownloadListItem", C([
            QCn,
            Djn
        ])),
        A2(sCn, "DownloadListItemTitle", C([
            xCn
        ])),
        A2(sCn, "DownloadListItemDesc", C([
            xCn,
            Pjn(Uun)
        ])),
        A2(sCn, "DownloadListItemBullet", g),
        A2(sCn, "DownloadListItemFilename", C([
            Djn
        ])),
        A2(sCn, "DownloadListItemDownload", C([
            xCn
        ])),
        A2(sCn, "DownloadListItemDownloadIcon", g),
        A2(sCn, "DownloadListItemDownloadLabel", g),
        A2(sCn, "DownloadListItemSpecs", g),
        A2(sCn, "DownloadListAlt", g)
    ]), xAn = tCn(C([
        mjn.jF,
        wjn.jF
    ])), OAn = C([
        A2(sCn, "AudioQualifyWrapper", C([
            QCn,
            ijn(uCn(4)),
            Njn(uCn(2)),
            A2(Sjn, ljn, uCn(2)),
            pjn(Kun)
        ])),
        A2(sCn, "AudioQualifyTitleHeader", C([
            xCn,
            pjn(Kun),
            mjn.jF,
            UCn(Jun)
        ])),
        A2(sCn, "AudioQualifyTitle", C([
            njn.jk,
            A2(Sjn, uCn(5), uCn(10)),
            Njn(uCn(4)),
            Djn
        ])),
        A2(sCn, "AudioQualifyMemo", C([
            xCn,
            cjn(uCn(4))
        ])),
        A2(sCn, "AudioQualifyMemoLabel", C([
            xCn,
            Djn,
            UCn(Uun),
            A2(Sjn, uCn(0), uCn(5))
        ])),
        A2(sCn, "AudioQualifyMemoRecap", C([
            A2(Sjn, uCn(3), uCn(5)),
            Qjn.pz,
            UCn(Uun),
            awn.mP,
            mCn(C([
                A2(vCn, ".ButtonMiniIcon", C([
                    lCn.mm,
                    ajn(uCn(5)),
                    Ejn(C([
                        Pjn(Gun.jR)
                    ]))
                ]))
            ]))
        ])),
        A2(sCn, "AudioQualifyFilesAudioStream", C([
            Pjn(Oun),
            Njn(uCn(2)),
            A2(HCn, 2, zun)
        ])),
        A2(sCn, "AudioQualifyQualify", C([
            xCn,
            wjn.bV,
            Fjn(uCn(26)),
            pjn(zun)
        ])),
        A2(sCn, "AudioQualifyQualifyItem", C([
            A2(Sjn, uCn(3), uCn(5)),
            UCn(Uun),
            Djn
        ])),
        A2(sCn, "AudioQualifyQualifyEdit", g),
        A2(sCn, "AudioQualifyQualifyForm", C([
            Pjn(zun),
            QCn,
            cjn(uCn(4)),
            mCn(C([
                A2(vCn, "label", C([
                    A2(Sjn, uCn(0), uCn(4)),
                    _jn(uCn(28)),
                    xCn
                ]))
            ]))
        ])),
        A2(sCn, "AudioQualifyFilesHeader", C([
            xCn,
            mjn.jF,
            rwn(uCn(32)),
            Fjn(uCn(6)),
            Tjn(uCn(3))
        ])),
        A2(sCn, "AudioQualifyFilesTitle", C([
            Djn,
            UCn(Jun),
            A2(Sjn, uCn(3), uCn(6)),
            njn.jj,
            xCn,
            Zjn(6)
        ])),
        A2(sCn, "AudioQualifyFilesDesc", C([
            lCn.n9,
            Njn(uCn(2))
        ])),
        A2(sCn, "MasterFilesShowDesc", C([
            mCn(C([
                A2(sCn, "AudioQualifyFilesDesc", C([
                    lCn.bU,
                    Pjn(Nun)
                ])),
                A2(vCn, ".TableTr", C([
                    UCn(xun)
                ]))
            ]))
        ])),
        A2(sCn, "PlayAudio", C([
            A2(Ajn, uCn(0), uCn(5))
        ])),
        A2(sCn, "AudioQualifyCheckbox", C([
            mCn(C([
                A2(sCn, "InputWrapper", C([
                    fjn(uCn(30)),
                    A2(ECn, "flex", "unset")
                ]))
            ]))
        ]))
    ]), zAn = {
        jn: A2(Gkn, "word-break", "break-all"),
        mX: A2(Gkn, "word-break", "keep-all"),
        oa: A2(Gkn, "word-break", "normal")
    }, NAn = C([
        A2(sCn, "SubtitleQualifyWrapper", C([
            QCn,
            ijn(uCn(4)),
            Njn(uCn(2)),
            A2(Sjn, ljn, uCn(2)),
            pjn(Kun)
        ])),
        A2(sCn, "SubtitleQualifyTitleHeader", C([
            xCn,
            pjn(Kun),
            mjn.jF,
            UCn(Jun)
        ])),
        A2(sCn, "SubtitleQualifyTitle", C([
            njn.jk,
            A2(Sjn, uCn(5), uCn(10)),
            Njn(uCn(4)),
            Djn
        ])),
        A2(sCn, "SubtitleQualifyMemo", C([
            xCn,
            cjn(uCn(4))
        ])),
        A2(sCn, "SubtitleQualifyMemoLabel", C([
            xCn,
            Djn,
            UCn(Uun),
            A2(Sjn, uCn(0), uCn(5))
        ])),
        A2(sCn, "SubtitleQualifyMemoRecap", C([
            A2(Sjn, uCn(3), uCn(5)),
            Qjn.pz,
            UCn(Uun),
            awn.mP,
            mCn(C([
                A2(vCn, ".ButtonMiniIcon", C([
                    lCn.mm,
                    ajn(uCn(5)),
                    Ejn(C([
                        Pjn(Gun.jR)
                    ]))
                ]))
            ]))
        ])),
        A2(sCn, "SubtitleQualifyFilesSubtitleStream", C([
            Pjn(Oun),
            Njn(uCn(2)),
            A2(HCn, 2, zun)
        ])),
        A2(sCn, "SubtitleQualifyQualify", C([
            xCn,
            wjn.bV,
            Fjn(uCn(26)),
            pjn(zun)
        ])),
        A2(sCn, "SubtitleQualifyQualifyItem", C([
            A2(Sjn, uCn(3), uCn(5)),
            UCn(Uun),
            Djn
        ])),
        A2(sCn, "SubtitleQualifyQualifyEdit", g),
        A2(sCn, "SubtitleQualifyQualifyForm", C([
            Pjn(zun),
            QCn,
            cjn(uCn(4)),
            mCn(C([
                A2(vCn, "label", C([
                    A2(Sjn, uCn(0), uCn(4)),
                    _jn(uCn(28)),
                    xCn
                ]))
            ]))
        ])),
        A2(sCn, "SubtitleQualifyFilesHeader", C([
            xCn,
            mjn.jF,
            rwn(uCn(32)),
            Fjn(uCn(6)),
            Tjn(uCn(3))
        ])),
        A2(sCn, "SubtitleQualifyFilesTitle", C([
            Djn,
            UCn(Jun),
            A2(Sjn, uCn(3), uCn(6)),
            njn.jj,
            zAn.jn
        ])),
        A2(sCn, "SubtitleQualifyFilesDesc", C([
            lCn.n9,
            Njn(uCn(2))
        ])),
        A2(sCn, "MasterFilesShowDesc", C([
            mCn(C([
                A2(sCn, "SubtitleQualifyFilesDesc", C([
                    lCn.bU,
                    Pjn(Nun)
                ])),
                A2(vCn, ".TableTr", C([
                    UCn(xun)
                ]))
            ]))
        ])),
        A2(sCn, "PlaySubtitle", C([
            A2(Ajn, uCn(0), uCn(5))
        ])),
        A2(sCn, "SubtitleQualifyCheckbox", C([
            mCn(C([
                A2(sCn, "InputWrapper", C([
                    fjn(uCn(30)),
                    A2(ECn, "flex", "unset")
                ]))
            ]))
        ]))
    ]), HAn = _u(C([
        OAn,
        NAn,
        C([
            A2($Cn, C([
                sCn("MasterWrapper"),
                sCn("MasterShadow")
            ]), C([
                qCn,
                QCn
            ])),
            A2(sCn, "MasterWrapper", C([
                ojn(100),
                A3(XCn, 0, 0, 0)
            ])),
            A2(sCn, "MasterShadow", C([
                ojn(0),
                A3(XCn, 100, 0, 0)
            ])),
            A2(sCn, "MasterHeader", C([
                BCn(uCn(80)),
                cjn(uCn(10)),
                Pjn(Mun.jR),
                QCn
            ])),
            A2(sCn, "MasterHeaderId", C([
                UCn(Mun.nn),
                BCn(uCn(14))
            ])),
            A2(sCn, "MasterHeaderTitle", C([
                UCn(Nun),
                jjn,
                Djn
            ])),
            A2(sCn, "MasterHome", C([
                xCn,
                Djn,
                ACn.ja
            ])),
            A2(sCn, "MasterTitle", C([
                Pjn(Kun),
                Ojn.r5,
                A2(Sjn, ljn, uCn(10)),
                _jn(uCn(36)),
                UCn(Uun),
                xCn
            ])),
            A2(sCn, "MasterFiles", C([
                QCn,
                Djn
            ])),
            A2(sCn, "MasterFilesTitleDesc", C([
                UCn(Hun),
                Cjn(uCn(12))
            ])),
            A2(sCn, "MasterHeaderSubTitle", C([
                UCn(Hun),
                Cjn(uCn(12))
            ])),
            A2(sCn, "MasterMaterialWrapper", C([
                QCn
            ])),
            A2(sCn, "MasterMaterialTitle", C([
                Pjn(Oun),
                Ojn.r5,
                Cjn(uCn(12)),
                A2(Sjn, uCn(5), uCn(10))
            ])),
            A2(sCn, "MasterMaterialTitleType", C([
                UCn(Hun)
            ])),
            A2(sCn, "MasterMaterialTitleFormat", C([
                UCn(Mun.jR)
            ])),
            A2(sCn, "MasterMaterialItem", C([
                Pjn(zun),
                A2(Sjn, uCn(4), uCn(10)),
                xCn,
                Njn(uCn(4))
            ])),
            A2(sCn, "MasterMaterialItemThumb", C([
                fjn(uCn(160)),
                BCn(uCn(90)),
                Pjn(zun),
                lCn.bU,
                xAn
            ])),
            A2(sCn, "MasterMaterialItemDetails", C([
                UCn(xun),
                A2(HCn, 3, "rgba(0,0,0,0.2)"),
                Djn,
                ACn.ja
            ])),
            A2(sCn, "MasterWarning", C([
                BCn(uCn(40)),
                cjn(uCn(10)),
                pjn(Bwn.nl),
                UCn(Ijn),
                njn.jk,
                Cjn(uCn(14)),
                lCn.bU,
                A2(hjn, 4, Nun)
            ])),
            A2(sCn, "MasterError", g),
            A2(sCn, "MasterFilesWrapper", C([
                QCn,
                UCn(Uun),
                Rjn.ja
            ])),
            A2(sCn, "MasterFilesAsset", C([
                A2(Sjn, uCn(3), uCn(0)),
                Pjn(Kun),
                Njn(uCn(4))
            ])),
            A2(sCn, "MasterFilesToggleDesc", g),
            A2(sCn, "MasterFilesChildren", C([
                ajn(uCn(3)),
                mCn(C([
                    A2(sCn, "Fg", C([
                        JCn(xun)
                    ]))
                ]))
            ])),
            A2(sCn, "MasterFilesHeader", C([
                xCn,
                mjn.jF,
                rwn(uCn(32)),
                Ujn(C([
                    A2(sCn, "ProgressBarOuter", C([
                        Djn,
                        yjn(uCn(250))
                    ]))
                ]))
            ])),
            A2(sCn, "MasterFilesIcon", C([
                fjn(uCn(28)),
                BCn(uCn(28)),
                Xwn
            ])),
            A2(sCn, "MasterStreamIcon", C([
                fjn(uCn(22)),
                BCn(uCn(22)),
                Xwn
            ])),
            A2(sCn, "MasterFilesTitle", C([
                Djn,
                Cjn(uCn(15)),
                A2(Sjn, uCn(3), uCn(6)),
                njn.jj,
                zAn.jn
            ])),
            A2(sCn, "MasterFilesDownload", C([
                lCn.bU,
                TCn.pB,
                mCn(C([
                    A2(sCn, "CustomButton", C([
                        nwn(uCn(5))
                    ])),
                    A2(vCn, "CustomButton:last-child", C([
                        nwn(uCn(10))
                    ]))
                ]))
            ])),
            A2(sCn, "MasterFilesDesc", C([
                lCn.n9,
                Njn(uCn(4)),
                eCn.du
            ])),
            A2(sCn, "MasterFilesVideoStream", C([
                Pjn(Oun),
                Njn(uCn(2)),
                A2(HCn, 2, zun),
                Fjn(uCn(6)),
                Tjn(uCn(3))
            ])),
            A2(sCn, "MasterFilesShowDesc", C([
                mCn(C([
                    A2(sCn, "MasterFilesDesc", C([
                        lCn.bU,
                        Pjn(Nun)
                    ])),
                    A2(vCn, ".TableTr", C([
                        UCn(xun)
                    ]))
                ]))
            ])),
            A2(sCn, "MasterTimecodeInputCls", C([
                xCn,
                Djn
            ])),
            A2(sCn, "MasterFilesAudioStream", C([
                Pjn(Oun),
                Njn(uCn(2)),
                A2(HCn, 2, zun)
            ])),
            A2(sCn, "MasterChild", C([
                xCn,
                cjn(uCn(5)),
                Pjn(Kun),
                Njn(uCn(4)),
                mjn.jF
            ])),
            A2(sCn, "MasterChildLabel", C([
                Kjn(1),
                ICn(1),
                qjn(uCn(250)),
                eAn.od,
                ACn.l3,
                tAn.k5,
                njn.jj,
                UCn(Jun),
                Ujn(C([
                    A2(vCn, "a", C([
                        UCn("#F3F3F4"),
                        Mwn.rV
                    ]))
                ]))
            ])),
            A2(sCn, "MasterTimecodeInput", C([
                xCn,
                Djn
            ])),
            A2(sCn, "MasterChildProgress", C([
                fjn(WCn(50)),
                ICn(1),
                yjn(uCn(250))
            ])),
            A2(sCn, "MasterQualify", C([
                xCn
            ])),
            A2(sCn, "MasterQualifyItem", C([
                A2(Sjn, uCn(3), uCn(5)),
                UCn(Uun)
            ])),
            A2(sCn, "MasterQualifyEdit", g),
            A2(sCn, "MasterQualifyForm", C([
                Pjn(zun),
                xCn,
                cjn(uCn(4)),
                mCn(C([
                    A2(vCn, "label", C([
                        A2(Sjn, uCn(0), uCn(4)),
                        _jn(uCn(28)),
                        xCn
                    ]))
                ]))
            ])),
            A2(sCn, "ReversedLayout", C([
                xCn,
                mjn.jF,
                A2(Sjn, ljn, uCn(8)),
                BCn(uCn(48)),
                Pjn(Mun.nn),
                UCn(Nun),
                Njn(uCn(4)),
                mCn(C([
                    A2(vCn, ".ButtonLabel", C([
                        Pjn(Kun)
                    ])),
                    A2(vCn, ".LayoutHeaderTitle", C([
                        Djn
                    ]))
                ]))
            ]))
        ])
    ])), VAn = C([
        A2(sCn, "PlayerFold", C([
            A2(HCn, 3, Oun),
            cjn(uCn(3)),
            QCn,
            rwn(uCn(190))
        ])),
        A2(sCn, "PlayerFoldInfos", C([
            QCn,
            Djn,
            cjn(uCn(6)),
            Yjn(uCn(3)),
            Pjn(zun)
        ])),
        A2(sCn, "PlayerFoldInfo", C([
            xCn,
            A2(kjn, 1, Nun)
        ])),
        A2(sCn, "PlayerFoldInfosTitle", C([
            UCn(Uun),
            Ojn.r5,
            njn.jj,
            cjn(uCn(6))
        ])),
        A2(sCn, "PlayerFoldInfoLabel", C([
            UCn(xun),
            A2(Sjn, uCn(3), uCn(6)),
            fjn(uCn(100))
        ])),
        A2(sCn, "PlayerFoldInfoValues", C([
            QCn,
            Djn
        ])),
        A2(sCn, "PlayerFoldInfoValue", C([
            UCn(Uun),
            Djn,
            A2(Sjn, uCn(3), uCn(6))
        ])),
        A2(sCn, "PlayerFoldPreview", C([
            xCn,
            Jjn.oV,
            mjn.jF,
            pjn("radial-gradient(ellipse at center, rgba(24,31,41,.6) 0%,rgba(24,31,41,1) 100%), " + hwn),
            ywn(Nun),
            qCn,
            BCn(uCn(90)),
            Ejn(C([
                pjn("radial-gradient(ellipse at center, rgba(24,31,41,0) 0%,rgba(24,31,41,1) 100%), " + hwn)
            ]))
        ])),
        A2(sCn, "PlayerFoldPlay", C([
            fjn(uCn(60)),
            BCn(uCn(60)),
            Pjn(Mun.jR),
            A2(HCn, 3, Nun),
            rjn(Ijn),
            mCn(C([
                A2(vCn, "svg", C([
                    fjn(uCn(60)),
                    BCn(uCn(60))
                ]))
            ]))
        ])),
        A2(sCn, "PlayerFoldProxy", C([
            BCn(uCn(60)),
            Pjn(zun),
            cjn(uCn(20)),
            A2(HCn, 3, Nun),
            A2(dwn, 0, Nun),
            njn.jj,
            UCn(Ijn)
        ])),
        A2(sCn, "PlayerFoldSpinner", C([
            Qjn.jF,
            Djn,
            rjn(Kun)
        ])),
        A2(sCn, "PlayerUnfold", C([
            rwn(uCn(190))
        ]))
    ]), UAn = C([
        A2(sCn, "Settings", C([
            QCn,
            Djn
        ])),
        A2(sCn, "AdminOps", C([
            mCn(C([
                A2(sCn, "LayoutHeader", C([
                    Pjn(Bwn.nn)
                ]))
            ]))
        ])),
        A2(jCn, C([
            "(min-width: 1000px)"
        ]), C([
            A2(sCn, "Settings", C([
                Rjn.l3,
                xjn.ja
            ]))
        ]))
    ]), JAn = KCn("empty"), ZAn = tCn(C([
        Cjn(uCn(16)),
        njn.jj
    ])), KAn = function(n) {
        return ZCn(function(n) {
            return {
                $: 3,
                a: n
            };
        }(n));
    }, _An = C([
        A2($Cn, C([
            sCn("MasterWrapper"),
            sCn("MasterShadow")
        ]), C([
            qCn,
            QCn
        ])),
        A2(sCn, "MasterWrapper", C([
            ojn(100),
            A3(XCn, 0, 0, 0),
            mCn(C([
                A2($Cn, C([
                    sCn("ShowMain")
                ]), C([
                    fjn(WCn(100))
                ]))
            ]))
        ])),
        A2(sCn, "MasterShadow", C([
            ojn(0),
            A3(XCn, 100, 0, 0)
        ])),
        A2(sCn, "ShowWrapper", C([
            xCn,
            Djn
        ])),
        A2(sCn, "ShowMain", C([
            Djn,
            QCn,
            DCn("translate(0,0)")
        ])),
        A2(sCn, "ShowHomeWrapper", C([
            QCn,
            ACn.ja,
            Djn
        ])),
        A2(sCn, "ShowAside", C([
            fjn(uCn(404)),
            QCn
        ])),
        A2(sCn, "ShowDesc", C([
            Pjn(Nun),
            qCn,
            QCn,
            Djn
        ])),
        A2(sCn, "ShowSelectBroadcastable", C([
            Njn(uCn(4)),
            cjn(uCn(1)),
            A2(HCn, 3, Oun)
        ])),
        A2(sCn, "ShowTodos", C([
            A2(HCn, 3, "#5E2F83"),
            QCn,
            cjn(uCn(3)),
            A2(ECn, "gap", "3px"),
            Njn(uCn(4)),
            JAn(C([
                lCn.n9
            ]))
        ])),
        A2(sCn, "DeliveryForm", C([
            A2(HCn, 6, Oun),
            cjn(uCn(1))
        ])),
        A2(sCn, "DeliveryFormBanners", C([
            A2(HCn, 3, Nun),
            QCn,
            A2(ECn, "gap", "3px")
        ])),
        A2(sCn, "ShowDeliveries", C([
            ijn(uCn(4))
        ])),
        A2(sCn, "ShowDeliveriesTitle", C([
            Pjn(Mun.eP),
            UCn(Mun.m6),
            njn.jj,
            Cjn(uCn(16)),
            cjn(uCn(6)),
            Njn(uCn(3))
        ])),
        A2(sCn, "ShowDeliveryNew", C([
            Pjn(Mun.eP),
            UCn(Uun),
            njn.jj,
            Cjn(uCn(16)),
            cjn(uCn(6)),
            Njn(uCn(3))
        ])),
        A2(sCn, "ShowDeliveriesItem", C([
            A2(HCn, 3, Mun.nn),
            Njn(uCn(3)),
            Pjn(Mun.nn),
            UCn(Mun.ma),
            QCn,
            A2(KAn, "open", C([
                mCn(C([
                    A2(sCn, "IconFolded", C([
                        DCn("rotate(90deg)")
                    ]))
                ]))
            ]))
        ])),
        A2(sCn, "IconFolded", C([
            rjn(Mun.eQ)
        ])),
        A2(sCn, "ShowDeliveriesItemTitle", C([
            xCn,
            mjn.jF,
            UCn(Ijn),
            cjn(uCn(6))
        ])),
        A2(sCn, "ShowDeliveriesItemTitleLink", C([
            UCn("inherit"),
            Djn,
            Ejn(C([
                Mwn.rV
            ]))
        ])),
        A2(sCn, "ShowDeliveriesItemStatus", C([
            Pjn(Ijn),
            A2(HCn, 3, Nun),
            UCn(xun),
            cjn(uCn(6))
        ])),
        A2(sCn, "ShowDeliveriesSuccess", C([
            rjn(Run.jR)
        ])),
        A2(sCn, "ShowDeliverySegmentsTabs", C([
            xCn,
            ijn(uCn(3))
        ])),
        A2(sCn, "ShowDeliverySegmentsContent", C([
            Pjn(Oun),
            cjn(uCn(4))
        ])),
        A2(vCn, ".ShowDeliverySegmentsContent .InputText", C([
            UCn(Uun)
        ])),
        A2(sCn, "ShowDeliverySegmentsTab", C([
            A2(Sjn, uCn(4), uCn(8)),
            UCn(Uun)
        ])),
        A2(sCn, "ShowDeliverySegmentsTabActive", C([
            Pjn(Oun),
            UCn(Ijn)
        ])),
        A2($Cn, C([
            sCn("ShowMaterial"),
            sCn("ShowPlayer")
        ]), C([
            Pjn(Nun),
            Bjn(8888),
            QCn
        ])),
        A2(sCn, "ShowInfos", C([
            QCn
        ])),
        A2(sCn, "ShowComments", C([
            Pjn(Nun),
            qCn,
            QCn,
            Bjn(9999)
        ])),
        A2(sCn, "ShowHeader", C([
            BCn(uCn(80)),
            cjn(uCn(10)),
            Pjn(xun),
            Njn(uCn(4)),
            QCn
        ])),
        A2(sCn, "ShowActions", C([
            BCn(uCn(28)),
            xCn,
            xwn.jF
        ])),
        A2(sCn, "ShowHeaderTitle", C([
            jjn,
            UCn(Nun)
        ])),
        A2(sCn, "ShowHeaderId", C([
            UCn(zun),
            BCn(uCn(14))
        ])),
        A2(sCn, "ShowHeaderSubTitle", C([
            UCn(zun),
            ZAn
        ])),
        A2(sCn, "ShowActivity", g),
        A2(sCn, "ShowActivityList", g),
        A2(sCn, "ShowActivityItem", C([
            ajn(uCn(4)),
            UCn(Hun),
            Fjn(uCn(20)),
            eCn.du,
            mCn(C([
                A2(vCn, "svg", C([
                    A2(CAn, 2, 2)
                ]))
            ]))
        ])),
        A2(sCn, "ShowActivityDate", C([
            Yjn(uCn(10)),
            UCn(Zun),
            eAn.od
        ])),
        A2(sCn, "ShowAccepted", C([
            mCn(C([
                A2($Cn, C([
                    sCn("LayoutAppBar"),
                    sCn("AsideTabs")
                ]), C([
                    Pjn(Run.jR)
                ]))
            ]))
        ])),
        A2(sCn, "ShowError", C([
            QCn,
            Djn
        ])),
        A2(jCn, C([
            "(min-width: 1000px)"
        ]), g),
        A2(jCn, C([
            "(max-width: 650px)"
        ]), g),
        A2(vCn, "#player", C([
            mCn(C([
                A2(sCn, "LoadingSpinner", C([
                    ajn(NCn)
                ]))
            ]))
        ]))
    ]), GAn = function(n) {
        return tCn(C([
            mCn(C([
                A2(sCn, "Button", C([
                    pjn(n.nl),
                    UCn(n.m7),
                    Ejn(C([
                        pjn(n.jR),
                        UCn(Ijn)
                    ]))
                ]))
            ]))
        ]));
    }, YAn = C([
        A2(sCn, "Acceptation", C([
            Pjn(Mun.nn)
        ])),
        A2(sCn, "AcceptationAccepted", C([
            Pjn(Run.nn),
            mCn(C([
                A2(sCn, "AcceptationContent", C([
                    ywn(Run.nn)
                ]))
            ]))
        ])),
        A2(sCn, "AcceptationRefused", C([
            Pjn(Gun.nl),
            mCn(C([
                A2(sCn, "AcceptationContent", C([
                    ywn(Gun.nl)
                ]))
            ]))
        ])),
        A2(sCn, "AcceptationHeader", C([
            xCn,
            UCn(Nun),
            A2(Sjn, ljn, uCn(7)),
            BCn(uCn(48)),
            mjn.jF
        ])),
        A2(sCn, "AcceptationHeaderTitle", C([
            Djn,
            eAn.od,
            ACn.l3,
            tAn.k5,
            njn.jj,
            Cjn(uCn(14)),
            Fjn(uCn(8))
        ])),
        A2(sCn, "AcceptationHeaderActions", C([
            Pjn(Nun),
            UCn(Ijn),
            cjn(uCn(3)),
            xCn
        ])),
        A2(sCn, "AcceptationHeaderActionsWrapper", C([
            Jjn.oV,
            Ejn(C([
                mCn(C([
                    A2(sCn, "AcceptationHeaderActionsAction", C([
                        Pjn(Mun.jR),
                        rjn(Mun.m6)
                    ]))
                ]))
            ]))
        ])),
        A2(sCn, "AcceptationHeaderActionsAction", C([
            qjn(uCn(26)),
            BCn(uCn(26)),
            A2(Sjn, uCn(0), uCn(5)),
            Pjn(zun),
            xCn,
            mjn.jF,
            A2(sjn, "AcceptationHeaderActionsOk", C([
                rjn(Run.jR)
            ])),
            A2(sjn, "AcceptationHeaderActionsKo", C([
                rjn(Gun.jR)
            ]))
        ])),
        A2(sCn, "AcceptationHeaderActionsIcon", C([
            ijn(uCn(4))
        ])),
        A2(sCn, "AcceptationHeaderActionsLabel", C([
            A2(Sjn, ljn, uCn(3))
        ])),
        A2(sCn, "AcceptationContent", C([
            QCn,
            Pjn(Nun),
            A2(HCn, 6, Mun.nn),
            A2(kjn, 0, ""),
            cjn(uCn(3)),
            mCn(C([
                A2(sCn, "InputTextarea", C([
                    A2(HCn, 3, Nun),
                    A2(ECn, "width", "100% !important"),
                    ajn(ljn),
                    Pjn(zun),
                    Djn
                ])),
                A2(sCn, "InputWrapper", C([
                    QCn,
                    Djn
                ])),
                A2(sCn, "AcceptationButton", C([
                    UCn(Ijn),
                    ijn(uCn(3))
                ])),
                A2(sCn, "ButtonDisabled", C([
                    Pjn(Oun),
                    UCn(Zun),
                    Ejn(C([
                        Pjn(Oun),
                        UCn(Zun)
                    ]))
                ]))
            ]))
        ])),
        A2(sCn, "AcceptationChoices", C([
            QCn,
            Ujn(C([
                mwn(C([
                    Pjn(zun),
                    QCn,
                    ijn(uCn(3)),
                    GCn(C([
                        ijn(uCn(0))
                    ]))
                ]))
            ]))
        ])),
        A2(sCn, "AcceptationOk", C([
            Pjn(Run.jR),
            cjn(uCn(3)),
            QCn,
            Djn,
            GAn(Run)
        ])),
        A2(sCn, "AcceptationNormal", C([
            Pjn(Mun.nl),
            cjn(uCn(3)),
            QCn,
            Djn
        ])),
        A2(sCn, "AcceptationKo", C([
            A2(HCn, 3, Gun.jR),
            Pjn(Nun),
            cjn(uCn(3)),
            QCn,
            Djn,
            GAn(Gun)
        ])),
        A2(sCn, "AcceptationText", C([
            A3($wn, uCn(3), uCn(6), uCn(6)),
            Pjn(Mun.eQ),
            A2(HCn, 3, Nun),
            UCn(Mun.l8),
            Djn,
            Qjn.jF
        ])),
        A2(sCn, "AcceptationTextOk", C([
            A3($wn, uCn(3), uCn(6), uCn(6)),
            Pjn(Run.eQ),
            A2(HCn, 3, Nun),
            UCn(Run.l8),
            Djn,
            Qjn.jF
        ])),
        A2(sCn, "AcceptationRejectionText", C([
            A3($wn, uCn(3), uCn(6), uCn(6)),
            Pjn(Gun.eQ),
            UCn(Gun.l8),
            Djn,
            Qjn.jF
        ])),
        A2($Cn, C([
            sCn("AcceptationVoteTitleAccepted"),
            sCn("AcceptationVoteTitleRejected")
        ]), C([
            Qjn.jF,
            cjn(uCn(6))
        ])),
        A2(sCn, "AcceptationVoteTitleRejected", C([
            UCn(Gun.jR)
        ])),
        A2(sCn, "AcceptationVote", C([
            UCn(Uun),
            A2(kjn, 2, Nun)
        ])),
        A2(sCn, "AcceptationVoteUser", C([
            xCn,
            mjn.jF,
            cjn(uCn(3)),
            mCn(C([
                A2(sCn, "Avatar", C([
                    nwn(uCn(10))
                ]))
            ]))
        ])),
        A2(sCn, "AcceptationVoteUserName", C([
            Kjn(1),
            ICn(1),
            ACn.l3,
            tAn.k5,
            eAn.od
        ])),
        A2(sCn, "AcceptationVoteReason", C([
            A2(Sjn, uCn(5), uCn(10))
        ])),
        A2(sCn, "AcceptationVoteAccepted", C([
            xCn,
            Pjn(Run.jR),
            UCn(Ijn)
        ])),
        A2(sCn, "AcceptationVoteWaiting", C([
            xCn,
            Pjn(zun)
        ])),
        A2(sCn, "AcceptationVoteRejected", C([
            QCn,
            Pjn(Gun.jR),
            UCn(Ijn)
        ])),
        A2(sCn, "AcceptationRejection", C([
            cjn(uCn(10)),
            Pjn(Gun.nl),
            UCn(Ijn)
        ])),
        A2(sCn, "AcceptationWarning", C([
            xCn,
            mjn.jF,
            Ujn(C([
                A2(vCn, "svg", C([
                    pjn(Bwn.nn),
                    mCn(C([
                        A2(sCn, "Fg", C([
                            JCn(Bwn.ks)
                        ]))
                    ]))
                ]))
            ]))
        ])),
        A2(sCn, "AcceptationBorderWrapper", C([
            A2(HCn, 6, Mun.nn),
            cjn(uCn(3))
        ]))
    ]), nLn = {
        ja: A2(Gkn, "flex", "auto"),
        lK: function(n) {
            return A2(Gkn, "flex", "flex-basis(" + Bt(n) + ")");
        },
        lL: function(n) {
            return A2(Gkn, "flex", "flex-grow(" + Bt(n) + ")");
        },
        lM: function(n) {
            return A2(Gkn, "flex", "flex-shrink(" + Bt(n) + ")");
        },
        n9: A2(Gkn, "flex", "none")
    }, rLn = A2(mu, Gkn("font-weight"), Bt), tLn = C([
        A2(sCn, "Activity", C([
            QCn,
            Djn
        ])),
        A2(sCn, "ActivityTitle", C([
            cjn(uCn(6)),
            Pjn(Mun.eP),
            UCn(Ijn),
            njn.jj,
            xCn,
            Njn(uCn(2))
        ])),
        A2(sCn, "ActivityHeader", C([
            BCn(uCn(48)),
            Pjn(Mun.nn),
            A2(Sjn, ljn, uCn(10)),
            xCn,
            Njn(uCn(4)),
            mjn.jF,
            Ujn(C([
                A2(sCn, "Select", C([
                    A2(bwn, 0, ""),
                    Ujn(C([
                        A2(sCn, "SelectButton", C([
                            A2(bwn, 3, Nun)
                        ]))
                    ])),
                    A2(Ajn, uCn(0), uCn(5))
                ]))
            ]))
        ])),
        A2(sCn, "ActivityHeaderLink", C([
            UCn(Ijn),
            A2(Sjn, ljn, uCn(10))
        ])),
        A2(sCn, "ActivityContent", C([
            QCn,
            Djn
        ])),
        A2(sCn, "ActivityItem", C([
            Pjn(zun),
            cjn(uCn(3)),
            Njn(uCn(2)),
            Ujn(C([
                A2(sCn, "IconBullet", C([
                    A2(jAn, 0, 4)
                ]))
            ]))
        ])),
        A2(sCn, "ActivityEvent", C([
            eCn.du,
            Fjn(uCn(34)),
            Ujn(C([
                A2(sCn, "IconBullet", C([
                    A2(CAn, 1, 8)
                ]))
            ]))
        ])),
        A2(jCn, C([
            "(min-width: 1000px)"
        ]), C([
            A2(sCn, "Activity", C([
                QCn,
                Djn
            ])),
            A2(sCn, "ActivityContent", C([
                Djn,
                Njn(uCn(2))
            ]))
        ])),
        A2(sCn, "ActivityOnlyEvents", C([
            mCn(C([
                A2(sCn, "ActivityComment", C([
                    lCn.n9
                ]))
            ]))
        ])),
        A2(sCn, "ActivityOnlyComments", C([
            mCn(C([
                A2(sCn, "ActivityEvent", C([
                    lCn.n9
                ]))
            ]))
        ])),
        A2(sCn, "CommentButton", C([
            nwn(uCn(4))
        ])),
        A2(sCn, "ActivityCommentForm", C([
            UCn(Vun),
            Pjn(Nun),
            cjn(uCn(3)),
            Njn(uCn(4)),
            A2(HCn, 8, Mun.nn)
        ])),
        A2(sCn, "ActivityAnswerForm", C([
            xCn,
            Pjn(Nun),
            UCn(Vun),
            Ujn(C([
                A2(sCn, "Avatar", C([
                    ajn(uCn(2))
                ]))
            ]))
        ])),
        A2(sCn, "ActivityCommentFormMessage", C([
            Pjn(zun)
        ])),
        A2(sCn, "ActivityCommentFormSubmit", C([
            xCn,
            wjn.bV,
            ijn(uCn(2)),
            Pjn(zun)
        ])),
        A2(sCn, "ActivityCommentHideSubmit", C([
            lCn.n9
        ])),
        A2(sCn, "ActivityComment", C([
            Pjn(zun),
            cjn(uCn(4)),
            Njn(uCn(2)),
            xCn
        ])),
        A2(sCn, "ActivityCommentHeader", C([
            xCn
        ])),
        A2(sCn, "ActivityCommentActions", C([
            xCn
        ])),
        A2(sCn, "ActivityCommentDelete", C([
            xCn,
            Ejn(C([
                rjn(Ijn),
                mCn(C([
                    A2(sCn, "ButtonMiniIcon", C([
                        Pjn(Gun.jR)
                    ]))
                ]))
            ]))
        ])),
        A2(sCn, "ActivityCommentAuthor", C([
            UCn(Hun),
            rLn(500)
        ])),
        A2(sCn, "ActivityCommentContent", C([
            A2(Sjn, uCn(4), uCn(6)),
            Djn,
            QCn
        ])),
        A2(sCn, "ActivityCommentDate", g),
        A2(sCn, "ActivityCommentWrap", C([
            QCn,
            A2(Ajn, uCn(2), uCn(0))
        ])),
        A2(sCn, "ActivityCommentMessage", C([
            A2(Sjn, uCn(8), uCn(0)),
            UCn(Uun),
            eAn.o_
        ])),
        A2(sCn, "ActivityCommentTimecode", C([
            xCn,
            Djn,
            mCn(C([
                A2(sCn, "InputWrapper", C([
                    nLn.n9,
                    fjn(uCn(30)),
                    Xwn
                ])),
                A2(sCn, "InputCheckbox", C([
                    cjn(ljn),
                    ajn(ljn)
                ]))
            ]))
        ])),
        A3(PCn, "ActivityCommentContent", "ActivityCommentTimecode", C([
            A2(Ajn, uCn(8), uCn(0))
        ])),
        A2(sCn, "ActivityCommentTimecodeLabel", C([
            awn.mP,
            UCn(xun),
            cjn(uCn(2))
        ])),
        A2(sCn, "ActivityAnswerMessage", C([
            A2(Sjn, uCn(2), uCn(0)),
            UCn(Uun)
        ])),
        A2(sCn, "ActivityAnswers", g),
        A2(sCn, "ActivityAnswer", g),
        A2(sCn, "ActivityAnswerHeader", C([
            xCn
        ])),
        A2(sCn, "ActivityAnswer", C([
            cjn(uCn(4)),
            Pjn(Nun),
            xCn,
            Njn(uCn(2))
        ])),
        A2(sCn, "ActivityCommentVerif", C([
            ijn(uCn(2))
        ])),
        A2(sCn, "ActivityCommentVerifTc", C([
            xCn,
            Njn(uCn(2))
        ])),
        A2(sCn, "ActivityCommentVerifLabel", C([
            xCn,
            Djn,
            A2(Sjn, uCn(3), uCn(6)),
            Pjn(zun)
        ])),
        A2(sCn, "ActivityCommentVerifHeader", C([
            xCn,
            mCn(C([
                A2(sCn, "InputTextarea", C([
                    Cjn(uCn(16)),
                    A2(Sjn, uCn(3), uCn(6)),
                    A4(Gjn, uCn(0), uCn(3), uCn(0), uCn(0))
                ]))
            ]))
        ])),
        A2(ujn, "VerificationMotifInput", C([
            Cjn(uCn(16)),
            A2(Sjn, uCn(3), uCn(6))
        ])),
        A2(sCn, "RedFlag", C([
            mCn(C([
                A2(sCn, "InputTextarea", C([
                    ywn(Gun.jR)
                ]))
            ]))
        ])),
        A2(sCn, "OrangeFlag", C([
            mCn(C([
                A2(sCn, "InputTextarea", C([
                    ywn(Bwn.jR)
                ]))
            ]))
        ])),
        A2(sCn, "GreenFlag", C([
            mCn(C([
                A2(sCn, "InputTextarea", C([
                    ywn(Run.jR)
                ]))
            ]))
        ])),
        A2(sCn, "BlueFlag", C([
            mCn(C([
                A2(sCn, "InputTextarea", C([
                    ywn(Mun.jR)
                ]))
            ]))
        ])),
        A2(sCn, "ActivityVerificationBloc", C([
            Pjn(Nun),
            cjn(uCn(2))
        ])),
        A2(sCn, "ActivityVerificationMessage", C([
            Cjn(uCn(16)),
            A2(Sjn, uCn(3), uCn(6)),
            A2(HCn, 3, Mun.jR),
            UCn(Ijn),
            A2(sjn, "RedFlag", C([
                ywn(Gun.jR)
            ])),
            A2(sjn, "OrangeFlag", C([
                ywn(Bwn.jR)
            ])),
            A2(sjn, "GreenFlag", C([
                ywn(Run.jR)
            ]))
        ])),
        A2(sCn, "ActivityVerificationFlag", C([
            cjn(uCn(5)),
            Yjn(uCn(1)),
            Pjn(zun)
        ])),
        A2(sCn, "RegularOperations", C([
            QCn,
            A2(HCn, 4, Mun.jR),
            cjn(uCn(3)),
            ijn(uCn(3)),
            Njn(uCn(3))
        ])),
        A2(sCn, "RegularOperationsHeader", C([
            cjn(uCn(10)),
            Pjn(Mun.nn),
            UCn(Mun.ks),
            njn.jk,
            Cjn(uCn(15))
        ])),
        A2(sCn, "Operations", C([
            QCn,
            A2(HCn, 4, Bwn.jR),
            cjn(uCn(3))
        ])),
        A2(sCn, "OperationsHeader", C([
            cjn(uCn(10)),
            Pjn(Bwn.nn),
            UCn(Bwn.ks),
            njn.jk,
            Cjn(uCn(15))
        ])),
        A2(sCn, "OperationContent", C([
            QCn,
            Kjn(1),
            ICn(1),
            cjn(uCn(10)),
            Pjn(zun),
            UCn(Ijn),
            A2(dwn, 3, Nun),
            mCn(C([
                A2(sCn, "InputWrapper", C([
                    Njn(uCn(5))
                ]))
            ]))
        ])),
        A2(sCn, "OperationStatusNone", C([
            Pjn(Zun)
        ])),
        A2(sCn, "OperationStatusRunning", C([
            Pjn(Mun.jR)
        ])),
        A2(sCn, "OperationStatusSuccess", C([
            Pjn(Run.jR)
        ])),
        A2(sCn, "OperationStatusFailure", C([
            Pjn(Gun.jR)
        ])),
        A2(sCn, "VerifContent", C([
            QCn,
            Kjn(1),
            ICn(1),
            cjn(uCn(10)),
            Pjn(zun),
            UCn(Ijn),
            mCn(C([
                A2(sCn, "InputWrapper", C([
                    Njn(uCn(5))
                ]))
            ]))
        ])),
        A2(sCn, "ActivityVerificationFlagSelect", C([
            xCn,
            mCn(C([
                A2(sCn, "OrangeFlag", C([
                    rjn(Bwn.jR),
                    A2(sjn, "ActivityVerificationFlagSelected", C([
                        Pjn(Bwn.jR),
                        rjn(Ijn)
                    ])),
                    Ejn(C([
                        Pjn(Bwn.jR),
                        rjn(Ijn)
                    ]))
                ])),
                A2(sCn, "RedFlag", C([
                    rjn(Gun.jR),
                    A2(sjn, "ActivityVerificationFlagSelected", C([
                        Pjn(Gun.jR),
                        rjn(Ijn)
                    ])),
                    Ejn(C([
                        Pjn(Gun.jR),
                        rjn(Ijn)
                    ]))
                ])),
                A2(sCn, "BlueFlag", C([
                    rjn(Mun.jR),
                    A2(sjn, "ActivityVerificationFlagSelected", C([
                        Pjn(Mun.jR),
                        rjn(Ijn)
                    ])),
                    Ejn(C([
                        Pjn(Mun.jR),
                        rjn(Ijn)
                    ]))
                ]))
            ]))
        ])),
        A2(sCn, "ActivityCommentSpacer", C([
            Djn
        ])),
        A2(vCn, ".Activity > .ActivityContent", C([
            A2(kjn, 4, Mun.nn)
        ])),
        A2(sCn, "VerifOperationContent", C([
            mjn.bV
        ])),
        A2(vCn, ".VerifOperationContent .Select", C([
            Njn(uCn(10)),
            qjn(uCn(135))
        ]))
    ]), eLn = C([
        A2(sCn, "ShowArchives", C([
            QCn
        ])),
        A2(sCn, "ShowArchivesHeader", C([
            cjn(uCn(10)),
            Pjn(Kun),
            UCn(Nun),
            njn.jk,
            Cjn(uCn(15))
        ])),
        A2(sCn, "ShowArchive", C([
            xCn,
            A2(kjn, 3, Nun)
        ])),
        A2(sCn, "ShowArchiveActions", C([
            cjn(uCn(6)),
            Pjn(zun),
            wjn.bV,
            xCn
        ])),
        A2(sCn, "ShowArchivesLock", C([
            rjn(Mun.ks),
            Xwn,
            xCn
        ])),
        A2(sCn, "ShowArchiveStatus", C([
            fjn(uCn(10))
        ])),
        A2(sCn, "ShowArchiveContent", C([
            QCn,
            Kjn(1),
            ICn(1),
            cjn(uCn(10)),
            Pjn(zun),
            UCn(Ijn),
            A2(dwn, 3, Nun),
            mCn(C([
                A2(sCn, "ShowInputWrapper", C([
                    Njn(uCn(5))
                ]))
            ]))
        ]))
    ]), uLn = KCn("disabled"), aLn = C([
        A2(sCn, "DownloadWrapper", C([
            Pjn(Mun.nn),
            ijn(uCn(4))
        ])),
        A2(sCn, "DownloadBloc", C([
            cjn(uCn(4)),
            pjn(zun),
            ijn(uCn(3))
        ])),
        A2(sCn, "DownloadBlocTitle", C([
            UCn(xun),
            njn.jj,
            Cjn(uCn(15)),
            A3($wn, uCn(4), uCn(6), uCn(4))
        ])),
        A2(sCn, "DownloadSection", g),
        A2(sCn, "DownloadSectionTitle", C([
            UCn(Ijn),
            A3($wn, uCn(8), uCn(6), uCn(4)),
            lCn.jh
        ])),
        A2(sCn, "DownloadSectionChoices", C([
            cjn(uCn(1)),
            pjn(Nun)
        ])),
        A2(sCn, "DownloadSectionChoice", C([
            xCn,
            ajn(uCn(2)),
            UCn(Nun),
            njn.jj,
            Ejn(C([
                mCn(C([
                    A2(sCn, "DownloadSectionLabel", C([
                        pjn(Mun.jR),
                        UCn(Ijn)
                    ]))
                ]))
            ]))
        ])),
        A2(sCn, "DownloadSectionInput", C([
            cjn(uCn(8)),
            lCn.bU,
            pjn(zun)
        ])),
        A2(sCn, "DownloadSectionLabel", C([
            cjn(uCn(6)),
            pjn(xun),
            Djn,
            Yjn(uCn(2))
        ])),
        A2(sCn, "DownloadSubmit", C([
            xCn,
            ijn(uCn(4)),
            cjn(uCn(1)),
            pjn(Nun)
        ])),
        A2(sCn, "DownloadSubmitSpacer", C([
            Djn,
            ajn(uCn(2)),
            pjn(zun)
        ])),
        A2(sCn, "DownloadSubmitButton", C([
            UCn(Ijn),
            ajn(uCn(2)),
            A2(Sjn, uCn(4), uCn(6)),
            Cjn(uCn(16)),
            pjn(Mun.nl),
            Ejn(C([
                pjn(Mun.jR)
            ])),
            uLn(C([
                pjn(Zun),
                UCn(Nun)
            ]))
        ])),
        A2(sCn, "DownloadSimpleButton", C([
            UCn(Nun),
            ajn(uCn(2)),
            A2(Sjn, uCn(4), uCn(6)),
            pjn(Zun),
            Ejn(C([
                pjn(xun)
            ]))
        ])),
        A2(sCn, "DownloadFile", C([
            xCn,
            ijn(uCn(3)),
            pjn(Nun)
        ])),
        A2(sCn, "DownloadFileIcon", C([
            QCn,
            cjn(uCn(6)),
            pjn(Mun.nn),
            rjn(Ijn)
        ])),
        A2(sCn, "DownloadFileBody", C([
            xCn,
            Djn,
            Yjn(uCn(2))
        ])),
        A2(sCn, "DownloadFileName", C([
            Djn,
            cjn(uCn(6)),
            pjn(Mun.nn),
            UCn(Ijn)
        ])),
        A2(sCn, "DownloadFileAction", C([
            cjn(uCn(6)),
            pjn(Mun.nn),
            UCn(Mun.m6),
            mCn(C([
                A2(vCn, "p", C([
                    ajn(uCn(0)),
                    nAn(uCn(4))
                ]))
            ]))
        ])),
        A2(sCn, "DownloadFileButton", C([
            cjn(uCn(6)),
            pjn(Mun.nl),
            ijn(uCn(1)),
            A2(HCn, 3, Nun),
            rjn(Ijn),
            UCn(Mun.m7),
            xCn,
            Djn,
            mCn(C([
                A2(vCn, "svg", C([
                    ajn(uCn(2))
                ]))
            ])),
            Ejn(C([
                pjn(Mun.jR),
                UCn(Ijn)
            ]))
        ])),
        A2(sCn, "Downloaded", C([
            mCn(C([
                A2(sCn, "DownloadFileIcon", C([
                    pjn(Run.nn)
                ])),
                A2(sCn, "DownloadFileName", C([
                    pjn(Run.nn)
                ])),
                A2(sCn, "DownloadFileAction", C([
                    pjn(Run.nn),
                    UCn(Run.m6)
                ])),
                A2(sCn, "DownloadFileButton", C([
                    pjn(Run.nl),
                    UCn(Run.m7)
                ]))
            ]))
        ])),
        A2(sCn, "DownloadDisabled", C([
            mCn(C([
                A2(sCn, "DownloadFileIcon", C([
                    pjn(zun),
                    rjn(Kun)
                ])),
                A2(sCn, "DownloadFileName", C([
                    pjn(Oun),
                    UCn(xun)
                ])),
                A2(sCn, "DownloadFileAction", C([
                    pjn(Oun),
                    UCn(xun)
                ])),
                A2(sCn, "DownloadFileButton", C([
                    pjn(zun),
                    UCn(xun),
                    rjn(xun)
                ]))
            ]))
        ])),
        A2(sCn, "HowToOpenIntercom", C([
            cjn(uCn(20)),
            Cjn(uCn(14)),
            UCn(Jun),
            lCn.jh
        ])),
        A2(sCn, "DownloadOptionsWrapper", C([
            Pjn(zun),
            cjn(uCn(3)),
            A2(HCn, 3, Nun),
            JAn(C([
                lCn.n9
            ]))
        ])),
        A2(sCn, "DownloadOptionsBloc", C([
            eCn.du,
            pjn(zun),
            Bjn(9),
            cjn(uCn(6)),
            QCn
        ])),
        A2(sCn, "DownloadOptionsBack", g),
        A2(sCn, "DownloadOptionsClose", C([
            A2(swn, 12, 12)
        ])),
        A2(sCn, "DownloadRowBloc", C([
            xCn
        ])),
        A2(sCn, "DownloadOptionsCredentials", C([
            pjn(zun),
            cjn(uCn(6))
        ])),
        A2(sCn, "DownloadOptionsText", C([
            Djn,
            ijn(uCn(3)),
            cjn(uCn(6))
        ])),
        A2(sCn, "DownloadOptionsButtons", C([
            pjn(zun),
            xCn,
            cjn(uCn(6)),
            wjn.bV
        ])),
        A2(sCn, "DownloadRowButtons", C([
            Pjn("#5E2F83"),
            cjn(uCn(6))
        ])),
        A2(sCn, "DownloadSftpLink", C([
            cjn(uCn(6)),
            Djn,
            xCn,
            mjn.jF
        ])),
        A2(sCn, "DownloadSftpUrl", C([
            Pjn(Kun),
            UCn(Mun.jR),
            xCn,
            Djn,
            Cjn(Wwn(1.2)),
            Yjn(uCn(10))
        ])),
        A2(sCn, "DownloadsLinks", C([
            QCn,
            A2(ECn, "gap", "3px")
        ])),
        A2(sCn, "DownloadsLinksItem", C([
            xCn,
            cjn(uCn(3)),
            Pjn(Oun),
            UCn(Vun),
            Ejn(C([
                Pjn(Mun.nl),
                UCn(Ijn)
            ]))
        ])),
        A2(sCn, "DownloadsLinksItemIcon", C([
            cjn(uCn(6)),
            Pjn(Nun),
            Xwn,
            fjn(uCn(40))
        ])),
        A2(sCn, "DownloadsLinksItemWrapper", C([
            QCn,
            Djn,
            cjn(uCn(6))
        ])),
        A2(sCn, "DownloadsLinksItemName", C([
            njn.jj,
            Cjn(Wwn(1.1)),
            zAn.jn
        ])),
        A2(sCn, "DownloadsLinksItemDetails", C([
            Cjn(Wwn(.95)),
            ojn(70)
        ]))
    ]), iLn = C([
        A2(sCn, "EditWrapper", C([
            QCn,
            Njn(uCn(4))
        ])),
        A2(jCn, C([
            "(min-width: 1000px)"
        ]), g),
        A2(sCn, "EditForm", C([
            QCn
        ])),
        A2(sCn, "EditHeaderIcon", C([
            fjn(uCn(50)),
            Pjn(Mun.nn)
        ])),
        A2(sCn, "EditHeaderLabel", C([
            Kjn(1),
            ICn(1),
            eAn.od,
            ACn.l3,
            tAn.k5,
            cjn(uCn(10)),
            UCn(Oun)
        ])),
        A2(sCn, "EditHeaderActions", C([
            xCn
        ])),
        A2(sCn, "EditFooter", C([
            xCn,
            Pjn(Nun),
            cjn(uCn(3)),
            wjn.bV
        ])),
        A2(sCn, "EditContent", C([
            QCn,
            Pjn(zun),
            UCn(Vun),
            cjn(uCn(3))
        ])),
        A2(sCn, "EditEditing", C([
            mCn(C([
                A2(sCn, "EditContent", C([
                    Pjn(zun)
                ])),
                A2(sCn, "EditRowContent", C([
                    Pjn(Nun),
                    ACn.sl
                ]))
            ]))
        ])),
        A2(sCn, "EditRow", C([
            xCn,
            Njn(uCn(3)),
            uwn.sp
        ])),
        A2(sCn, "EditRowContent", C([
            Kjn(1),
            ICn(1),
            eAn.od,
            ACn.l3,
            tAn.k5,
            UCn(Ijn),
            Pjn(zun),
            cjn(uCn(6)),
            mCn(C([
                A2(vCn, "input", C([
                    ajn(ljn),
                    cjn(ljn),
                    A2(HCn, 0, "")
                ]))
            ]))
        ])),
        A2(sCn, "EditRowLabel", C([
            UCn(xun),
            cjn(uCn(6)),
            fjn(WCn(40)),
            awn.mP
        ]))
    ]), oLn = function(n) {
        return tCn(C([
            Cjn(uCn(n)),
            njn.jj
        ]));
    }, cLn = F2(function(n, r) {
        return C([
            eC(A3(tC, A3(ta, A2(pa, n, g), g, Ct), g, r))
        ]);
    }), fLn = cLn("svg"), sLn = C([
        A2(sCn, "FilesWrapper", C([
            QCn,
            UCn(Uun)
        ])),
        A2(sCn, "FilesHeader", C([
            xCn,
            Pjn(Kun),
            A2(Sjn, uCn(0), uCn(10)),
            BCn(uCn(48)),
            mjn.jF
        ])),
        A2(sCn, "FilesTitle", C([
            oLn(16),
            UCn(Nun),
            _jn(uCn(28)),
            Djn
        ])),
        A2(sCn, "FilesItem", C([
            xCn
        ])),
        A2(sCn, "FilesItemIcon", C([
            eCn.du,
            xCn
        ])),
        A2(sCn, "FilesItemIconStamps", C([
            eCn.ij,
            QCn,
            aCn(uCn(43)),
            nCn(uCn(30)),
            DCn("translate(-50%,-50%)")
        ])),
        A2(sCn, "FilesItemIconStamp", C([
            xCn,
            qjn(uCn(20)),
            BCn(uCn(17)),
            _jn(uCn(17)),
            ajn(uCn(2)),
            A2(Sjn, uCn(0), uCn(5)),
            Own(uCn(10)),
            oLn(12),
            UCn(Ijn),
            wjn.jF,
            mCn(C([
                A2(sCn, "Fg", C([
                    JCn(Ijn)
                ]))
            ]))
        ])),
        A2(sCn, "FilesItemSuccess", C([
            mCn(C([
                A2(sCn, "FilesItemIconStamp", C([
                    Pjn(Run.jR)
                ])),
                A2(sCn, "Bg", C([
                    JCn(Run.jR)
                ]))
            ]))
        ])),
        A2(sCn, "FilesItemFailure", C([
            mCn(C([
                A2(sCn, "FilesItemIconStamp", C([
                    Pjn(Gun.jR)
                ])),
                A2(sCn, "Bg", C([
                    JCn(Gun.jR)
                ]))
            ]))
        ])),
        A2(sCn, "FilesItemWarning", C([
            mCn(C([
                A2(sCn, "FilesItemIconStamp", C([
                    Pjn(Run.jR)
                ])),
                A2(sCn, "FilesItemWarning", C([
                    pjn(Bwn.jR)
                ])),
                A2(sCn, "Bg", C([
                    JCn(Run.jR)
                ]))
            ]))
        ])),
        A2($Cn, C([
            sCn("FilesItemAwait"),
            sCn("FilesMaterial")
        ]), C([
            mCn(C([
                A2(sCn, "Fg", C([
                    JCn(Vun)
                ])),
                A2(sCn, "Bg", C([
                    JCn(Vun)
                ]))
            ]))
        ])),
        A2(sCn, "FilesBroadcast", C([
            QCn,
            cjn(uCn(10)),
            Pjn(Jun),
            Njn(uCn(4)),
            Ejn(C([
                pjn(Ijn)
            ]))
        ])),
        A2(sCn, "FilesMaterial", C([
            QCn,
            cjn(uCn(10)),
            Pjn(Jun),
            Njn(uCn(4)),
            Ejn(C([
                pjn(Ijn)
            ]))
        ])),
        A2(sCn, "FilesGroupTitle", C([
            oLn(16),
            Pjn(Oun),
            UCn(Uun),
            A2(Sjn, uCn(10), uCn(10))
        ])),
        A2(sCn, "FilesItemContent", C([
            A2(Sjn, uCn(5), uCn(10))
        ])),
        A2(sCn, "FilesItemTitle", C([
            oLn(14),
            QCn,
            A2(Sjn, uCn(5), uCn(10))
        ])),
        A2(sCn, "FilesItemTitle2", C([
            Cjn(uCn(12)),
            njn.jk,
            A2(Sjn, uCn(5), uCn(0)),
            Ojn.r5,
            UCn(Zun)
        ])),
        A2(sCn, "FilesItemNextStep", C([
            A2(Sjn, uCn(5), uCn(10)),
            pjn("rgba(0,0,0,.1)"),
            UCn("rgba(255,255,255,.8)"),
            ajn(uCn(2)),
            xCn
        ])),
        A2($Cn, C([
            sCn("FilesAccepted"),
            sCn("FilesAwaitingUpload"),
            sCn("FilesUploading"),
            sCn("FilesRunningTasks")
        ]), C([
            Pjn(Mun.jR),
            UCn(Ijn),
            QCn
        ])),
        A2(sCn, "FilesAwaitingUpload", g),
        A2(sCn, "FilesUploading", g),
        A2(sCn, "FilesRunningTasks", C([
            cjn(uCn(2))
        ])),
        A2(sCn, "FilesFileOk", g),
        A2(sCn, "FilesFileKo", g),
        A2(sCn, "FilesAccepted", C([
            Pjn(Run.jR)
        ])),
        A2(sCn, "ManagerActionsWrapper", C([
            Xjn,
            Djn,
            cjn(uCn(3))
        ])),
        A2(sCn, "FileItem", C([
            xCn,
            Njn(uCn(4))
        ])),
        A2(sCn, "FileStatus", C([
            fjn(uCn(15)),
            A2(bwn, 2, Oun)
        ])),
        A2(sCn, "FileStatusOperation", C([
            Pjn(Mun.jR)
        ])),
        A2(sCn, "FileStatusFailure", C([
            Pjn(Gun.jR)
        ])),
        A2(sCn, "FileStatusWarning", C([
            Pjn(Bwn.jR)
        ])),
        A2(sCn, "FileStatusSuccess", C([
            Pjn(Run.jR)
        ])),
        A2(sCn, "FileContent", C([
            QCn,
            Djn,
            Pjn(Jun),
            UCn(zun),
            cjn(uCn(2))
        ])),
        A2(sCn, "FileDescription", C([
            cjn(uCn(5))
        ])),
        A2(sCn, "FilesWrapperSectionTitle", C([
            pjn(Kun),
            UCn(Jun),
            njn.jk,
            A2(Sjn, uCn(5), uCn(10)),
            xCn,
            Njn(uCn(4))
        ])),
        A2(sCn, "FileDescriptionTitle", C([
            njn.jk,
            xCn,
            rjn(xun)
        ])),
        A2(sCn, "FileDescriptionTitleName", C([
            Djn,
            yjn(WCn(95)),
            zAn.jn
        ])),
        A2(sCn, "FileDescriptionDetails", C([
            UCn(Zun)
        ])),
        A2(sCn, "FileOperation", C([
            ijn(uCn(2))
        ])),
        A2(sCn, "FileOperationSummary", C([
            xCn,
            cjn(uCn(3)),
            mjn.jF,
            Pjn(Uun)
        ])),
        A2(sCn, "FileOperationLabel", C([
            Kjn(1),
            ICn(1),
            qjn(uCn(250)),
            eAn.od,
            ACn.l3,
            tAn.k5,
            rjn(xun),
            Ujn(C([
                fLn(C([
                    A2(jAn, 0, 4)
                ]))
            ]))
        ])),
        A2(sCn, "FileOperationLabelTitle", C([
            njn.jk,
            UCn(Nun)
        ])),
        A2(sCn, "FileOperationLabelProgress", C([
            UCn(Zun)
        ])),
        A2(sCn, "FileOperationProgress", C([
            fjn(WCn(50)),
            ICn(1),
            yjn(uCn(250))
        ])),
        A2(sCn, "FileOperationDetails", C([
            xCn,
            Pjn(Hun),
            UCn(zun),
            cjn(uCn(5))
        ])),
        A2(sCn, "FileOperationDetailsLabel", C([
            Kjn(1),
            ICn(1),
            eAn.od,
            ACn.l3,
            tAn.k5
        ])),
        A2(sCn, "FileOperationDetailsActions", g),
        A2(sCn, "FileOperationWarning", C([
            QCn,
            lCn.jh,
            ACn.ja,
            Pjn(zun),
            UCn(Hun),
            cjn(uCn(5)),
            mCn(C([
                A2(vCn, "tr:nth-child(odd)", C([
                    Pjn("#555d68")
                ])),
                A2(vCn, "th", C([
                    eAn.od
                ]))
            ]))
        ])),
        A2(sCn, "TranscodeWarning", C([
            Kjn(1),
            eAn.od,
            ACn.l3,
            tAn.k5
        ])),
        A2(sCn, "TranscodeWarningField", C([
            Djn
        ])),
        A2(sCn, "FileOperationIcon", C([
            BCn(uCn(20)),
            fjn(uCn(20)),
            Xwn,
            rjn(xun)
        ])),
        A2(sCn, "FileTitle", C([
            Kjn(1),
            ICn(1),
            xCn
        ]))
    ]), lLn = function(n) {
        return A2(Gkn, "border-spacing", _kn(n));
    }, dLn = Pi({
        bQ: "Download",
        bX: "Download"
    }), bLn = {
        ja: A2(Gkn, "table-layout", "auto"),
        lH: A2(Gkn, "table-layout", "fixed")
    }, mLn = {
        cE: A2(Gkn, "transform-origin", "center bottom"),
        cF: A2(Gkn, "transform-origin", "left bottom"),
        cG: A2(Gkn, "transform-origin", "right bottom"),
        jF: A2(Gkn, "transform-origin", "center"),
        cH: A2(Gkn, "transform-origin", "left center"),
        cI: A2(Gkn, "transform-origin", "right center"),
        cN: Gkn("transform-origin"),
        dP: A2(Gkn, "transform-origin", "center top"),
        bs: A2(Gkn, "transform-origin", "left top"),
        dQ: A2(Gkn, "transform-origin", "right top")
    }, pLn = Pi({
        bQ: "View",
        bX: "Visionnage"
    }), vLn = C([
        A2(sCn, "InvitationsWrapper", C([
            QCn,
            Pjn("#181e28"),
            mCn(C([
                A2(vCn, ".InvitationsForm .InputLabelText", C([
                    A2(ECn, "align-items", "center"),
                    pjn("#232d39"),
                    Fjn(uCn(8))
                ])),
                A2(vCn, ".InvitationsForm .InputLabel", C([
                    Yjn(uCn(0)),
                    nwn(uCn(0)),
                    Njn(uCn(0)),
                    ijn(uCn(3))
                ]))
            ]))
        ])),
        A2(sCn, "InvitationsTable", C([
            mCn(C([
                A2(vCn, "td:not(.InvitationEmail)", C([
                    cjn(uCn(3))
                ]))
            ]))
        ])),
        A2(sCn, "InvitationsHeader", C([
            xCn,
            cjn(uCn(10)),
            Pjn(Kun),
            UCn(Nun),
            Njn(uCn(4)),
            mCn(C([
                A2(sCn, "ButtonLabel", C([
                    Pjn(Kun)
                ]))
            ]))
        ])),
        A2(sCn, "Header", C([
            mCn(C([
                A2(vCn, "td:not(:last-child)", C([
                    DCn("rotate(-45deg) translate(20px, -15px)"),
                    mLn.bs
                ]))
            ]))
        ])),
        A2(sCn, "InvitationsTable", C([
            nAn(uCn(70)),
            bLn.lH,
            fjn(WCn(100)),
            Pjn("#232D3A"),
            lLn(uCn(0)),
            Njn(uCn(3)),
            mCn(C([
                A2(vCn, ".InputCheckboxLine .InputWrapper", C([
                    ajn(NCn)
                ])),
                A2(vCn, "tr", C([
                    Pjn("#555D68c2"),
                    BCn(uCn(30))
                ])),
                A2(vCn, "tr:nth-child(odd)", C([
                    Pjn("#555d68")
                ])),
                A2(vCn, "td", C([
                    eCn.du,
                    fjn(uCn(30)),
                    A2(ECn, "border", "1px solid #181f29")
                ])),
                A2(vCn, "tr:first-child td:first-child:before", C([
                    A2(ECn, "content", "'" + pLn + "'"),
                    DCn("rotate(-45deg) translate(16px, -20px)"),
                    lCn.mm,
                    eCn.ij,
                    mLn.bs,
                    nCn(WCn(30))
                ])),
                A2(vCn, "tr:first-child td:nth-child(2):before", C([
                    A2(ECn, "content", "'Upload'"),
                    DCn("rotate(-45deg) translate(16px, -20px)"),
                    lCn.mm,
                    eCn.ij,
                    mLn.bs,
                    nCn(WCn(30))
                ])),
                A2(vCn, "tr:first-child td:nth-child(3):before", C([
                    A2(ECn, "content", "'" + dLn + "'"),
                    DCn("rotate(-45deg) translate(16px, -20px)"),
                    lCn.mm,
                    eCn.ij,
                    mLn.bs,
                    nCn(WCn(30))
                ])),
                A2(vCn, "tr:first-child td:nth-child(4):before", C([
                    A2(ECn, "content", "'Transcode'"),
                    DCn("rotate(-45deg) translate(16px, -20px)"),
                    lCn.mm,
                    eCn.ij,
                    mLn.bs,
                    nCn(WCn(30))
                ])),
                A2(sCn, "InvitationEmail", C([
                    fjn(WCn(60))
                ])),
                A2(sCn, "InvitationDelete", C([
                    Qjn.jF,
                    Jjn.oV
                ])),
                A2(sCn, "InvitationSourceKind", C([
                    Qjn.jF
                ]))
            ]))
        ])),
        A2(sCn, "InvitationEmail", C([
            yjn(uCn(100)),
            ACn.l3,
            tAn.k5,
            eAn.od,
            Fjn(uCn(5)),
            UCn("#ffffff")
        ])),
        A2(sCn, "InvitationEdit", C([
            mCn(C([
                A2(vCn, "svg", C([
                    DCn("scale(2)")
                ]))
            ]))
        ])),
        A2(sCn, "FullCube", C([
            fjn(uCn(17)),
            BCn(uCn(17)),
            Pjn("#3BAAFF"),
            A2(ECn, "margin", "auto"),
            A2(ECn, "border", "2px solid #181f29")
        ])),
        A2(sCn, "EmptyCube", C([
            fjn(uCn(17)),
            BCn(uCn(17)),
            Pjn(""),
            A2(ECn, "margin", "auto"),
            A2(ECn, "border", "2px solid #181f29")
        ])),
        A2(sCn, "InvitationsForm", C([
            QCn,
            cjn(uCn(4)),
            Njn(uCn(4)),
            ijn(uCn(-4)),
            Pjn(Nun),
            A2(HCn, 8, Mun.nn),
            A2(kjn, 0, Mun.nn),
            mCn(C([
                A2(sCn, "InputLabel", C([
                    Djn,
                    ajn(uCn(6)),
                    cjn(ljn)
                ])),
                A2(sCn, "InputLabelText", C([
                    cjn(ljn),
                    Djn,
                    xCn
                ])),
                A2(sCn, "InputText", C([
                    A2(HCn, 0, Nun),
                    ajn(ljn),
                    UCn(Uun),
                    cjn(uCn(6)),
                    pjn(zun)
                ]))
            ]))
        ])),
        A2(sCn, "ShowTranscode", C([
            lCn.rl
        ])),
        A2(sCn, "HideTranscode", C([
            lCn.n9
        ]))
    ]), $Ln = C([
        A2(sCn, "JobsWrapper", C([
            QCn
        ])),
        A2(jCn, C([
            "(min-width: 1000px)"
        ]), g),
        A2(sCn, "JobsContent", C([
            QCn,
            Pjn(zun),
            UCn(Vun),
            A2(hjn, 3, Nun),
            cjn(uCn(3))
        ])),
        A2(sCn, "JobsRow", C([
            xCn,
            Njn(uCn(3)),
            uwn.sp
        ])),
        A2(sCn, "JobsRowContent", C([
            Kjn(1),
            ICn(1),
            eAn.od,
            ACn.l3,
            tAn.k5,
            UCn(Ijn),
            Pjn(zun),
            cjn(uCn(6)),
            mCn(C([
                A2(vCn, "input", C([
                    ajn(ljn),
                    cjn(ljn),
                    A2(HCn, 0, "")
                ]))
            ]))
        ])),
        A2(sCn, "JobsRowLabel", C([
            UCn(xun),
            cjn(uCn(6)),
            fjn(WCn(40)),
            awn.mP
        ]))
    ]), gLn = C([
        A2(sCn, "Operations", C([
            QCn,
            A2(HCn, 4, Bwn.jR),
            cjn(uCn(3))
        ])),
        A2(sCn, "OperationsHeader", C([
            cjn(uCn(10)),
            Pjn(Bwn.nn),
            UCn(Bwn.ks),
            njn.jk,
            Cjn(uCn(15))
        ])),
        A2(sCn, "Operation", C([
            xCn,
            A2(kjn, 3, Nun)
        ])),
        A2(sCn, "OperationStatus", C([
            fjn(uCn(10))
        ])),
        A2(sCn, "OperationStatusNone", C([
            Pjn(Zun)
        ])),
        A2(sCn, "OperationStatusRunning", C([
            Pjn(Mun.jR)
        ])),
        A2(sCn, "OperationStatusSuccess", C([
            Pjn(Run.jR)
        ])),
        A2(sCn, "OperationStatusFailure", C([
            Pjn(Gun.jR)
        ])),
        A2(sCn, "OperationContent", C([
            QCn,
            Kjn(1),
            ICn(1),
            cjn(uCn(10)),
            Pjn(zun),
            UCn(Ijn),
            A2(dwn, 3, Nun),
            mCn(C([
                A2(sCn, "InputWrapper", C([
                    Njn(uCn(5))
                ])),
                A2(sCn, "ShowHideTable", C([
                    xwn.lN,
                    eCn.du,
                    aCn(uCn(-22))
                ]))
            ]))
        ])),
        A2(sCn, "PlayerSettings", C([
            xCn,
            mCn(C([
                A2(vCn, "div", C([
                    Kjn(1)
                ]))
            ]))
        ])),
        A2(vCn, ".ButtonMini", C([
            Jjn.oV
        ])),
        A2(sCn, "DeepProbeTable", C([
            nAn(uCn(10)),
            bLn.lH,
            fjn(WCn(100)),
            Pjn("#232D3A"),
            lLn(uCn(0)),
            lCn.jh,
            mCn(C([
                A2(vCn, ".InputCheckboxLine .InputWrapper", C([
                    ajn(NCn)
                ])),
                A2(vCn, "tr", C([
                    Pjn("#555D68c2"),
                    BCn(uCn(30))
                ])),
                A2(vCn, "tr:nth-child(odd)", C([
                    Pjn("#555d68")
                ])),
                A2(vCn, "td", C([
                    eCn.du,
                    fjn(WCn(40)),
                    A2(ECn, "border", "1px solid #181f29"),
                    A2(Sjn, uCn(0), uCn(5))
                ])),
                A2(vCn, "td:first-child", C([
                    eCn.du,
                    fjn(WCn(3)),
                    A2(ECn, "border", "none"),
                    Pjn("#232D3A")
                ])),
                A2(sCn, "ProbeItem", C([
                    Jjn.oV
                ])),
                A2(vCn, "tr:first-child", C([
                    Pjn("#232D3A"),
                    mCn(C([
                        A2(vCn, "td", C([
                            eCn.du,
                            fjn(WCn(3)),
                            A2(ECn, "border", "0px")
                        ]))
                    ]))
                ])),
                A2(vCn, "table", C([
                    fjn(WCn(95)),
                    A4(Gjn, WCn(0), WCn(0), WCn(0), WCn(6)),
                    Pjn("#181f29"),
                    mCn(C([
                        A2(vCn, "tr", C([
                            Pjn("transparent")
                        ])),
                        A2(vCn, "tr:nth-child(odd)", C([
                            Pjn("transparent")
                        ])),
                        A2(vCn, "tr", C([
                            A2(ECn, "border", "none")
                        ])),
                        A2(vCn, "td:first-child", C([
                            Pjn("#181f29")
                        ]))
                    ]))
                ]))
            ]))
        ])),
        A2(sCn, "ProbeLog", C([
            mCn(C([
                A2(vCn, ".Button", C([
                    lCn.ml,
                    nwn(uCn(10))
                ]))
            ]))
        ]))
    ]), hLn = {
        jF: A2(Gkn, "align-content", "center"),
        bV: A2(Gkn, "align-content", "flex-end"),
        lN: A2(Gkn, "align-content", "flex-start"),
        hl: A2(Gkn, "align-content", "space-around"),
        qF: A2(Gkn, "align-content", "space-between"),
        qY: A2(Gkn, "align-content", "stretch")
    }, kLn = C([
        A2(sCn, "ReportWrapper", C([
            Pjn(zun),
            cjn(uCn(10)),
            ACn.ja,
            xCn,
            lCn.jh
        ])),
        A2(sCn, "ReportSection", C([
            lCn.ri,
            VCn.jl,
            fjn(WCn(100))
        ])),
        A2(sCn, "ReportLinks", C([
            QCn,
            uwn.sp,
            hLn.qY
        ])),
        A2(sCn, "ReportLinksIcon", C([
            fjn(uCn(22)),
            BCn(uCn(22)),
            Xwn,
            Pjn(Nun)
        ])),
        A2(sCn, "ReportLinksLabel", C([
            A2(Sjn, uCn(2), uCn(5)),
            Djn
        ])),
        A2(sCn, "ReportLinksButton", C([
            xCn,
            Njn(uCn(3)),
            mjn.jF,
            Pjn(Mun.eP),
            cjn(uCn(2)),
            Ejn(C([
                UCn(Mun.m7),
                Pjn(Mun.nl)
            ]))
        ]))
    ]), CLn = A2(mu, Gkn("order"), Bt), jLn = C([
        A2(sCn, "Tracks", C([
            QCn,
            Njn(uCn(4))
        ])),
        A2(sCn, "TracksTitle", C([
            Pjn(Oun),
            UCn(Hun),
            A2(Sjn, uCn(2), uCn(6)),
            ijn(uCn(3)),
            Ojn.r5,
            njn.jj
        ])),
        A2(sCn, "TracksTrack", C([
            xCn,
            A2(HCn, 3, Oun),
            cjn(uCn(3)),
            A2(kjn, 0, Oun)
        ])),
        A2(sCn, "TracksTrackIcon", C([
            Pjn(Oun),
            nwn(uCn(3)),
            rjn(xun),
            cjn(uCn(6))
        ])),
        A2(sCn, "TracksTrackSelect", C([
            QCn,
            Djn,
            ijn(uCn(-3)),
            mCn(C([
                A2(sCn, "BannerEmptyness", C([
                    A3(Ljn, uCn(3), uCn(0), uCn(0))
                ])),
                A2(sCn, "BannerTodo", C([
                    A3(Ljn, uCn(3), uCn(0), uCn(0))
                ]))
            ]))
        ])),
        A2(sCn, "TracksTrackSelectItem", C([
            xCn,
            mjn.jF,
            Jjn.oV,
            A2(HCn, 3, Oun),
            Pjn(zun),
            cjn(uCn(3)),
            Ejn(C([
                UCn(Ijn)
            ])),
            EAn(C([
                ijn(uCn(3))
            ]))
        ])),
        A2(sCn, "TracksTrackSelectItemTitle", C([
            Cjn(uCn(15)),
            cjn(uCn(3)),
            FCn(WCn(50))
        ])),
        A2(sCn, "TracksTrackSelectItemProp", C([
            cjn(uCn(3)),
            Djn,
            FCn(WCn(20))
        ])),
        A2(sCn, "TracksTrackSelectItemIndex", C([
            cjn(uCn(3)),
            FCn(uCn(40))
        ])),
        A2(vCn, ".TracksTrackSelectItemProp:last-child", C([
            Qjn.pz
        ])),
        A2(sCn, "TracksTrackToggleMore", C([
            lCn.n9
        ])),
        A2(vCn, ".TracksTrackSelectGroup.TracksTrackSelectFolded .TracksTrackSelectLabel:nth-child(n+5)", C([
            lCn.n9
        ])),
        A2(sCn, "TracksTrackSelectMore", C([
            Qjn.jF,
            Pjn(zun),
            Cjn(uCn(15)),
            A2(Sjn, uCn(4), uCn(6)),
            ijn(uCn(3)),
            CLn(99),
            UCn(Ijn),
            Ejn(C([
                Pjn(Oun)
            ]))
        ])),
        A2(sCn, "TracksTrackSelectGroup", C([
            QCn
        ])),
        A2(sCn, "TracksTrackSelectLabel", C([
            mCn(C([
                A2(vCn, "input", C([
                    lCn.n9
                ])),
                A2(vCn, "input:checked", C([
                    oAn(C([
                        A2(sCn, "TracksTrackSelectItem", C([
                            ywn(Mun.jR),
                            UCn(Ijn)
                        ]))
                    ]))
                ]))
            ]))
        ]))
    ]), wLn = _u(C([
        tLn,
        YAn,
        eLn,
        sLn,
        kLn,
        iLn,
        $Ln,
        gLn,
        vLn,
        aLn,
        _An,
        XAn,
        HAn,
        VAn,
        jLn,
        RAn,
        UAn
    ])), ALn = C([
        A2(sCn, "TimelineWrapper", C([
            Djn,
            qCn,
            QCn,
            ACn.ja
        ])),
        A2(sCn, "TimelineList", C([
            QCn,
            mCn(C([
                A2(vCn, "a:hover", C([
                    Mwn.rV
                ]))
            ]))
        ])),
        A2(sCn, "TimelineDate", C([
            A2(Sjn, uCn(4), uCn(10)),
            lCn.jh,
            Qjn.jF,
            Pjn(Oun),
            UCn(Hun),
            Njn(uCn(4))
        ])),
        A2(sCn, "TimelineEvent", C([
            Pjn(zun),
            UCn(xun),
            _jn(uCn(25)),
            A2(Sjn, uCn(10), uCn(10)),
            Njn(uCn(4)),
            QCn
        ])),
        A2(sCn, "TimelineGroup", C([
            A2(Sjn, uCn(4), uCn(6))
        ])),
        A2(sCn, "TimelineGroupEvent", C([
            xCn,
            mjn.jF,
            ijn(uCn(2))
        ])),
        A2(sCn, "TimelineSingleEvent", C([
            xCn,
            mjn.jF,
            ijn(uCn(2))
        ])),
        A2(sCn, "TimelineEventMessage", C([
            A2(Sjn, uCn(0), uCn(8)),
            Djn,
            mCn(C([
                A2(vCn, "span", C([
                    UCn(Zun)
                ]))
            ]))
        ])),
        A2(sCn, "TimelineEventTitle", C([
            eCn.du,
            mCn(C([
                A2(vCn, "a", C([
                    lCn.ml
                ])),
                A2(vCn, "p", C([
                    lCn.ml
                ])),
                A2(vCn, "svg", C([
                    Yjn(uCn(5)),
                    nwn(uCn(5))
                ])),
                A2(vCn, "div", C([
                    eCn.du,
                    aCn(uCn(5)),
                    lCn.ml,
                    Jjn.oV,
                    ajn(uCn(0))
                ])),
                A2(sCn, "TimelineEventTitleMessage", C([
                    eCn.qS,
                    Jjn.ja,
                    Yjn(uCn(10))
                ])),
                A2(sCn, "TimelineEventResumeSingle", C([
                    Jjn.ja
                ]))
            ]))
        ])),
        A2(sCn, "TimelineEventResume", C([
            lCn.ml,
            Yjn(uCn(15)),
            eCn.du,
            aCn(uCn(5)),
            Jjn.oV
        ])),
        A2(sCn, "TimelineEventLabel", C([
            YCn.pz
        ])),
        A2(sCn, "TimelineEventLabelPin", C([
            fjn(uCn(10)),
            BCn(uCn(10)),
            Own(uCn(10)),
            lCn.mm,
            Yjn(uCn(6))
        ]))
    ]), LLn = C([
        A2(sCn, "PadokUploadWrapper", C([
            QCn
        ])),
        A2(sCn, "PadokUploadTitle", C([
            Pjn(Mun.nn),
            cjn(uCn(10)),
            Cjn(uCn(15)),
            njn.jk,
            UCn(Ijn),
            Njn(uCn(4))
        ])),
        A2(sCn, "PadokUpload", C([
            QCn,
            Pjn(Mun.eP),
            Njn(uCn(4)),
            UCn(Mun.ma)
        ])),
        A2(sCn, "PadokUploadInfo", C([
            cjn(uCn(10)),
            lCn.ml
        ])),
        A2(sCn, "PadokUploadKo", C([
            Pjn(Bwn.eP),
            UCn(Bwn.ma)
        ])),
        A2(sCn, "PadokUploadTitleKo", C([
            Pjn(Bwn.nn)
        ])),
        A2(sCn, "PadokUploadInvitation", C([
            Pjn(Oun),
            cjn(uCn(10)),
            rLn(600),
            Njn(uCn(4))
        ]))
    ]), yLn = C([
        A2(jCn, C([
            "(max-width: 1000px)"
        ]), C([
            A2(sCn, "ShowsWrapper", C([
                A4(cCn, 0, 0, 0, 94),
                ACn.l3,
                QCn
            ])),
            A2(sCn, "SettingsWrapper", C([
                A4(cCn, 0, 0, 0, 94),
                ACn.ja,
                QCn
            ])),
            A2(sCn, "MenuSettings", C([
                fjn(NCn)
            ])),
            A2(sCn, "BrowserWrapper", C([
                fjn(NCn)
            ])),
            A2($Cn, C([
                sCn("BrowserWrapper"),
                sCn("TimelineWrapper"),
                sCn("ShowWrapper"),
                sCn("MasterWrapper")
            ]), C([
                ICn(0),
                DCn("translate3d(0,0,0)"),
                A2(dwn, 0, "transparent"),
                nwn(uCn(2)),
                Njn(uCn(2)),
                A4(cCn, 0, 0, 0, 0),
                qCn
            ])),
            A2($Cn, C([
                sCn("ShowMain"),
                sCn("ShowAside")
            ]), C([
                A4(cCn, 0, 0, 0, 0),
                qCn
            ])),
            A2(sCn, "ShowAside", C([
                fjn(NCn)
            ])),
            A2($Cn, C([
                sCn("ShowWrapper"),
                sCn("ShowAside"),
                sCn("TimelineWrapper")
            ]), C([
                DCn("translate3d(101%,0,0)")
            ])),
            A3(PCn, "ActiveShow", "ShowWrapper", C([
                DCn("translate3d(0,0,0)")
            ])),
            A3(PCn, "ActiveShow", "BrowserWrapper", C([
                DCn("translate3d(-100%,0,0)")
            ])),
            A3(PCn, "AsideOpened", "ShowAside", C([
                DCn("translate3d(0,0,0)")
            ])),
            A3(PCn, "AsideOpened", "ShowMain", C([
                DCn("translate3d(-101%,0,0)")
            ])),
            A2(sCn, "LayoutFwdButton", C([
                fjn(uCn(80))
            ])),
            A2(sCn, "LayoutBackButton", C([
                lCn.n9
            ])),
            A2(sCn, "AsideOpened", C([
                mCn(C([
                    A2(sCn, "LayoutBackButton", C([
                        lCn.n9
                    ])),
                    A2(sCn, "LayoutHomeButton", C([
                        lCn.bU
                    ]))
                ]))
            ]))
        ]))
    ]), SLn = cLn("input"), FLn = awn.mP, TLn = $jn("placeholder"), QLn = cLn("textarea"), ILn = (KH = C([
        TLn(C([
            ojn(80),
            UCn(xun),
            FLn
        ]))
    ]), C([
        SLn(KH),
        QLn(KH)
    ])), BLn = _u(C([
        OCn,
        DAn,
        Vjn,
        fwn,
        wLn,
        LLn,
        ALn,
        LCn,
        RCn,
        yLn,
        bjn,
        SCn,
        ILn,
        Lwn,
        djn
    ])), WLn = mC, PLn = lu({
        m: function(n) {
            var r = cH(n.r6), t = d(di({
                lI: n,
                oI: r.b,
                r6: r.a
            }), p$), e = n.r8;
            if (e.$) return t;
            var u = A2(ji, i$, e.a);
            return u.$ ? t : A2(HN, n, u.a);
        },
        q1: function(n) {
            return 1 === n.$ ? A2(lH, Si, function(n) {
                var r, t, e;
                return gH(C([
                    dH(vH),
                    kH(pH),
                    (r = bH, t = void 0 !== nr.hidden ? {
                        l3: "hidden",
                        jG: "visibilitychange"
                    } : void 0 !== nr.mozHidden ? {
                        l3: "mozHidden",
                        jG: "mozvisibilitychange"
                    } : void 0 !== nr.msHidden ? {
                        l3: "msHidden",
                        jG: "msvisibilitychange"
                    } : void 0 !== nr.webkitHidden ? {
                        l3: "webkitHidden",
                        jG: "webkitvisibilitychange"
                    } : {
                        l3: "hidden",
                        jG: "visibilitychange"
                    }, A3(WH, 0, t.jG, A2(Fe, PH(r), A2(du, "target", A2(du, t.l3, Ae))))),
                    A2(lH, mH, (e = sU, gH(C([
                        A2(lH, iV, xV),
                        e(oV)
                    ])))),
                    A2(lH, $H, JV(n.r$)),
                    function() {
                        var r = n.al.r6;
                        n: for(;;)switch(r.$){
                            case 1:
                                return A2(lH, Pv(n.g9.mj), A2(fU, n.g9, n.al));
                            case 4:
                                if (4 === r.a.$) {
                                    var t = n.iz.oJ.dT;
                                    if (t.$) return hH;
                                    var e = t.a;
                                    return A2(lH, A2(mu, A2(mu, wi, Be), bE), aV(e));
                                }
                                break n;
                            case 2:
                                return A2(lH, Wv, ZV());
                            default:
                                break n;
                        }
                        return hH;
                    }()
                ]));
            }(n.a)) : A2(lH, sH, dH(fH));
        },
        r: a7,
        s: function(n) {
            var r;
            return WLn(A2(Se, g, C([
                Kkn(n),
                (r = BLn, li(A3(oi, "style", g, za(fi(ii(za(ci(r))))))))
            ])));
        }
    });
    _H = {
        Private: {
            init: PLn(A2(we, function(n) {
                return A2(we, function(r) {
                    return A2(we, function(t) {
                        return A2(we, function(e) {
                            return A2(we, function(u) {
                                return A2(we, function(a) {
                                    return A2(we, function(i) {
                                        return A2(we, function(o) {
                                            return Qe({
                                                bN: o,
                                                ft: i,
                                                mF: a,
                                                oc: u,
                                                r6: e,
                                                r8: t,
                                                sd: r,
                                                ih: n
                                            });
                                        }, A2(du, "defaults", A2(we, function(n) {
                                            return A2(we, function(r) {
                                                return A2(we, function(t) {
                                                    return Qe({
                                                        js: t,
                                                        jt: r,
                                                        qj: n
                                                    });
                                                }, A2(du, "browserAccept", Bi));
                                            }, A2(du, "browserArchive", Bi));
                                        }, A2(du, "showAside", Bi))));
                                    }, A2(du, "height", dl));
                                }, A2(du, "isAdvertiser", Ae));
                            }, A2(du, "now", dl));
                        }, A2(du, "url", Bi));
                    }, A2(du, "user", $b(C([
                        yN(Ct),
                        A2(Fe, kt, Qi)
                    ]))));
                }, A2(du, "version", Bi));
            }, A2(du, "width", dl)))(0)
        }
    }, n.Elm ? function n(r, t) {
        for(var e in t)e in r ? "init" == e ? a(6) : n(r[e], t[e]) : r[e] = t[e];
    }(n.Elm, _H) : n.Elm = _H;
}($cc2b0350e0cbd02a$exports);


var $08e5db9bd951c9f9$require$Elm = $cc2b0350e0cbd02a$exports.Elm;
// Expose the config for everyboAdaY
window.nomalab = {
    user: null,
    isAdvertiser: false,
    aws: null,
    // nomalabEnv is exposed by config.js ()
    // See helpers/thirdParty
    sentry: null,
    intercom: null,
    raw_frame_url: null
};















window.addEventListener('load', async function() {
    const response = await fetch('/v4/config/front');
    if (response.ok) {
        const config = await response.json();
        window.nomalab.sentry = config.sentry;
        window.nomalab.intercom = config.intercom;
        window.nomalab.raw_frame_url = config.raw_frame?.url;
    }
    // Fetch user infos
    fetch('/v3/users/me').then(function(response) {
        if (response.status === 200) return response.json();
        else throw 'not logged';
    }).then(function(me) {
        // Setup the user
        window.nomalab.user = me;
        return Promise.all([
            // fetch isAdvertiser status
            me.organization ? fetch(`/v4/organizations/${me.organization}/isAdvertiser`).then(function(response) {
                return response.json();
            }).then(function(data) {
                window.nomalab.isAdvertiser = data.isAdvertiser;
            }) : Promise.resolve(null),
            // fetch aws config
            fetch('/v3/aws/config').then(function(response) {
                return response.json();
            }).then(function(awsConfig) {
                // See helpers/upload
                window.nomalab.aws = awsConfig;
            })
        ]);
    }).catch(function(err) {
        // Not logged
        if (location.pathname === "/account/settings" || !location.pathname.startsWith("/account")) {
            const from = "?from=" + location.pathname;
            window.history.replaceState(null, "", "/account/login" + from);
        }
    }).finally(function() {
        // RUN THE APP
        var app = $08e5db9bd951c9f9$require$Elm.Private.init({
            node: document.getElementById('page'),
            flags: {
                user: window.nomalab.user,
                url: window.location.pathname + window.location.search,
                lang: window.navigator.userLanguage || window.navigator.language,
                width: window.innerWidth,
                height: window.innerHeight,
                now: new Date().getTime(),
                defaults: $53dd92cf139b6a84$exports.defaults(),
                version: 'dev',
                isAdvertiser: window.nomalab.isAdvertiser ?? false
            }
        });
        (parcelRequire("8TgEi"))(app);
        (parcelRequire("bvPu1"))(app);
        (parcelRequire("hjsOJ"))(app);
        (parcelRequire("iHeIR"))(app, 'redirect');
        // do not bother to load when not logged
        if (window.nomalab.user) {
            (parcelRequire("8oUNT"));
            (parcelRequire("3mVol"));
            (parcelRequire("4ARPW"));
            (parcelRequire("5JGum"));
            (parcelRequire("3Ii3I"))(app);
            (parcelRequire("4lCIN"))(app);
            (parcelRequire("56a0I"))(app);
            (parcelRequire("j63Xd"));
            (parcelRequire("fFcjN")).default(app);
            (parcelRequire("5pxJW"))(app);
            (parcelRequire("kRPup"))(app);
            $53dd92cf139b6a84$exports.subscribe(app);
        }
    });
});


//# sourceMappingURL=apps.3a48c442.js.map
